
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired386"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired386"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ee1if", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $a5b360542ba5d519$export$ffb0004e005737fa, (v) => $a5b360542ba5d519$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $a5b360542ba5d519$export$34b9dba7ce09269b, (v) => $a5b360542ba5d519$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $a5b360542ba5d519$export$25062201e9e25d76, (v) => $a5b360542ba5d519$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a5b360542ba5d519$export$ffb0004e005737fa;
var $a5b360542ba5d519$export$34b9dba7ce09269b;
var $a5b360542ba5d519$export$25062201e9e25d76;
"use strict";
var $a5b360542ba5d519$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a5b360542ba5d519$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $a5b360542ba5d519$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $a5b360542ba5d519$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$a5b360542ba5d519$export$ffb0004e005737fa = $a5b360542ba5d519$var$REACT_FRAGMENT_TYPE;
$a5b360542ba5d519$export$34b9dba7ce09269b = $a5b360542ba5d519$var$jsxProd;
$a5b360542ba5d519$export$25062201e9e25d76 = $a5b360542ba5d519$var$jsxProd;

});

parcelRegister("2QzWK", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $212c52566c7736a1$export$9c16c1426311996d, (v) => $212c52566c7736a1$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $212c52566c7736a1$export$dca3b0875bd9a954, (v) => $212c52566c7736a1$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $212c52566c7736a1$export$16fa2f45be04daa8, (v) => $212c52566c7736a1$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $212c52566c7736a1$export$ffb0004e005737fa, (v) => $212c52566c7736a1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $212c52566c7736a1$export$e2c29f18771995cb, (v) => $212c52566c7736a1$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $212c52566c7736a1$export$221d75b3f55bb0bd, (v) => $212c52566c7736a1$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $212c52566c7736a1$export$5f8d39834fd61797, (v) => $212c52566c7736a1$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $212c52566c7736a1$export$74bf444e3cd11ea5, (v) => $212c52566c7736a1$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $212c52566c7736a1$export$1ced07cd6b1985ce, (v) => $212c52566c7736a1$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $212c52566c7736a1$export$abd8e32b826d7ea7, (v) => $212c52566c7736a1$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $212c52566c7736a1$export$69a3209f1a06c04d, (v) => $212c52566c7736a1$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $212c52566c7736a1$export$8c538325882c7eec, (v) => $212c52566c7736a1$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $212c52566c7736a1$export$e530037191fcd5d7, (v) => $212c52566c7736a1$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $212c52566c7736a1$export$fd42f52fd3ae1109, (v) => $212c52566c7736a1$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $212c52566c7736a1$export$c8a8987d4410bf2d, (v) => $212c52566c7736a1$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $212c52566c7736a1$export$7d1e3a5e95ceca43, (v) => $212c52566c7736a1$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $212c52566c7736a1$export$257a8862b851cb5b, (v) => $212c52566c7736a1$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $212c52566c7736a1$export$a8257692ac88316c, (v) => $212c52566c7736a1$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $212c52566c7736a1$export$488013bae63b21da, (v) => $212c52566c7736a1$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $212c52566c7736a1$export$7c73462e0d25e514, (v) => $212c52566c7736a1$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $212c52566c7736a1$export$7568632d0d33d16d, (v) => $212c52566c7736a1$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $212c52566c7736a1$export$f93f40ac0ca7e3a8, (v) => $212c52566c7736a1$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $212c52566c7736a1$export$1f96ae73734a86cc, (v) => $212c52566c7736a1$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $212c52566c7736a1$export$9a47ced3238df325, (v) => $212c52566c7736a1$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $212c52566c7736a1$export$35808ee640e87ca7, (v) => $212c52566c7736a1$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $212c52566c7736a1$export$fae74005e78b1a27, (v) => $212c52566c7736a1$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $212c52566c7736a1$export$dc8fbce3eb94dc1e, (v) => $212c52566c7736a1$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $212c52566c7736a1$export$6a7bc4e911dc01cf, (v) => $212c52566c7736a1$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $212c52566c7736a1$export$6d9c69b0de29b591, (v) => $212c52566c7736a1$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $212c52566c7736a1$export$7f54fc3180508a52, (v) => $212c52566c7736a1$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $212c52566c7736a1$export$f680877a34711e37, (v) => $212c52566c7736a1$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $212c52566c7736a1$export$d5a552a76deda3c2, (v) => $212c52566c7736a1$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $212c52566c7736a1$export$aaabe4eda9ed9969, (v) => $212c52566c7736a1$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $212c52566c7736a1$export$e5c5a5f917a5871c, (v) => $212c52566c7736a1$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $212c52566c7736a1$export$1538c33de8887b59, (v) => $212c52566c7736a1$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $212c52566c7736a1$export$fca7f784ae7a249a, (v) => $212c52566c7736a1$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $212c52566c7736a1$export$13e3392192263954, (v) => $212c52566c7736a1$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $212c52566c7736a1$export$b8f5890fc79d6aca, (v) => $212c52566c7736a1$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $212c52566c7736a1$export$60241385465d0a34, (v) => $212c52566c7736a1$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $212c52566c7736a1$export$306c0aa65ff9ec16, (v) => $212c52566c7736a1$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $212c52566c7736a1$export$7b286972b8d8ccbf, (v) => $212c52566c7736a1$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $212c52566c7736a1$export$83d89fbfd8236492, (v) => $212c52566c7736a1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $212c52566c7736a1$export$9c16c1426311996d;
var $212c52566c7736a1$export$dca3b0875bd9a954;
var $212c52566c7736a1$export$16fa2f45be04daa8;
var $212c52566c7736a1$export$ffb0004e005737fa;
var $212c52566c7736a1$export$e2c29f18771995cb;
var $212c52566c7736a1$export$221d75b3f55bb0bd;
var $212c52566c7736a1$export$5f8d39834fd61797;
var $212c52566c7736a1$export$74bf444e3cd11ea5;
var $212c52566c7736a1$export$1ced07cd6b1985ce;
var $212c52566c7736a1$export$abd8e32b826d7ea7;
var $212c52566c7736a1$export$69a3209f1a06c04d;
var $212c52566c7736a1$export$8c538325882c7eec;
var $212c52566c7736a1$export$e530037191fcd5d7;
var $212c52566c7736a1$export$fd42f52fd3ae1109;
var $212c52566c7736a1$export$c8a8987d4410bf2d;
var $212c52566c7736a1$export$7d1e3a5e95ceca43;
var $212c52566c7736a1$export$257a8862b851cb5b;
var $212c52566c7736a1$export$a8257692ac88316c;
var $212c52566c7736a1$export$488013bae63b21da;
var $212c52566c7736a1$export$7c73462e0d25e514;
var $212c52566c7736a1$export$7568632d0d33d16d;
var $212c52566c7736a1$export$f93f40ac0ca7e3a8;
var $212c52566c7736a1$export$1f96ae73734a86cc;
var $212c52566c7736a1$export$9a47ced3238df325;
var $212c52566c7736a1$export$35808ee640e87ca7;
var $212c52566c7736a1$export$fae74005e78b1a27;
var $212c52566c7736a1$export$dc8fbce3eb94dc1e;
var $212c52566c7736a1$export$6a7bc4e911dc01cf;
var $212c52566c7736a1$export$6d9c69b0de29b591;
var $212c52566c7736a1$export$7f54fc3180508a52;
var $212c52566c7736a1$export$f680877a34711e37;
var $212c52566c7736a1$export$d5a552a76deda3c2;
var $212c52566c7736a1$export$aaabe4eda9ed9969;
var $212c52566c7736a1$export$e5c5a5f917a5871c;
var $212c52566c7736a1$export$1538c33de8887b59;
var $212c52566c7736a1$export$fca7f784ae7a249a;
var $212c52566c7736a1$export$13e3392192263954;
var $212c52566c7736a1$export$b8f5890fc79d6aca;
var $212c52566c7736a1$export$60241385465d0a34;
var $212c52566c7736a1$export$306c0aa65ff9ec16;
var $212c52566c7736a1$export$7b286972b8d8ccbf;
var $212c52566c7736a1$export$83d89fbfd8236492;
"use strict";
var $212c52566c7736a1$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $212c52566c7736a1$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $212c52566c7736a1$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $212c52566c7736a1$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $212c52566c7736a1$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $212c52566c7736a1$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $212c52566c7736a1$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $212c52566c7736a1$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $212c52566c7736a1$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $212c52566c7736a1$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $212c52566c7736a1$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $212c52566c7736a1$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $212c52566c7736a1$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $212c52566c7736a1$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $212c52566c7736a1$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$212c52566c7736a1$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $212c52566c7736a1$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $212c52566c7736a1$var$assign = Object.assign, $212c52566c7736a1$var$emptyObject = {};
function $212c52566c7736a1$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $212c52566c7736a1$var$emptyObject;
    this.updater = updater || $212c52566c7736a1$var$ReactNoopUpdateQueue;
}
$212c52566c7736a1$var$Component.prototype.isReactComponent = {};
$212c52566c7736a1$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$212c52566c7736a1$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $212c52566c7736a1$var$ComponentDummy() {}
$212c52566c7736a1$var$ComponentDummy.prototype = $212c52566c7736a1$var$Component.prototype;
function $212c52566c7736a1$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $212c52566c7736a1$var$emptyObject;
    this.updater = updater || $212c52566c7736a1$var$ReactNoopUpdateQueue;
}
var $212c52566c7736a1$var$pureComponentPrototype = $212c52566c7736a1$var$PureComponent.prototype = new $212c52566c7736a1$var$ComponentDummy();
$212c52566c7736a1$var$pureComponentPrototype.constructor = $212c52566c7736a1$var$PureComponent;
$212c52566c7736a1$var$assign($212c52566c7736a1$var$pureComponentPrototype, $212c52566c7736a1$var$Component.prototype);
$212c52566c7736a1$var$pureComponentPrototype.isPureReactComponent = !0;
var $212c52566c7736a1$var$isArrayImpl = Array.isArray;
function $212c52566c7736a1$var$noop() {}
var $212c52566c7736a1$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $212c52566c7736a1$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $212c52566c7736a1$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $212c52566c7736a1$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $212c52566c7736a1$var$cloneAndReplaceKey(oldElement, newKey) {
    return $212c52566c7736a1$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $212c52566c7736a1$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $212c52566c7736a1$var$REACT_ELEMENT_TYPE;
}
function $212c52566c7736a1$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $212c52566c7736a1$var$userProvidedKeyEscapeRegex = /\/+/g;
function $212c52566c7736a1$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $212c52566c7736a1$var$escape("" + element.key) : index.toString(36);
}
function $212c52566c7736a1$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($212c52566c7736a1$var$noop, $212c52566c7736a1$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $212c52566c7736a1$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $212c52566c7736a1$var$REACT_ELEMENT_TYPE:
                case $212c52566c7736a1$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $212c52566c7736a1$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $212c52566c7736a1$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $212c52566c7736a1$var$getElementKey(children, 0) : nameSoFar, $212c52566c7736a1$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($212c52566c7736a1$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $212c52566c7736a1$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($212c52566c7736a1$var$isValidElement(callback) && (callback = $212c52566c7736a1$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($212c52566c7736a1$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($212c52566c7736a1$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $212c52566c7736a1$var$getElementKey(nameSoFar, i), invokeCallback += $212c52566c7736a1$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $212c52566c7736a1$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $212c52566c7736a1$var$getElementKey(nameSoFar, i++), invokeCallback += $212c52566c7736a1$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $212c52566c7736a1$var$mapIntoArray($212c52566c7736a1$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $212c52566c7736a1$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $212c52566c7736a1$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $212c52566c7736a1$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $212c52566c7736a1$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $212c52566c7736a1$var$Children = {
    map: $212c52566c7736a1$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $212c52566c7736a1$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $212c52566c7736a1$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $212c52566c7736a1$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$212c52566c7736a1$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$212c52566c7736a1$export$9c16c1426311996d = $212c52566c7736a1$var$REACT_ACTIVITY_TYPE;
$212c52566c7736a1$export$dca3b0875bd9a954 = $212c52566c7736a1$var$Children;
$212c52566c7736a1$export$16fa2f45be04daa8 = $212c52566c7736a1$var$Component;
$212c52566c7736a1$export$ffb0004e005737fa = $212c52566c7736a1$var$REACT_FRAGMENT_TYPE;
$212c52566c7736a1$export$e2c29f18771995cb = $212c52566c7736a1$var$REACT_PROFILER_TYPE;
$212c52566c7736a1$export$221d75b3f55bb0bd = $212c52566c7736a1$var$PureComponent;
$212c52566c7736a1$export$5f8d39834fd61797 = $212c52566c7736a1$var$REACT_STRICT_MODE_TYPE;
$212c52566c7736a1$export$74bf444e3cd11ea5 = $212c52566c7736a1$var$REACT_SUSPENSE_TYPE;
$212c52566c7736a1$export$1ced07cd6b1985ce = $212c52566c7736a1$var$ReactSharedInternals;
$212c52566c7736a1$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $212c52566c7736a1$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$212c52566c7736a1$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$212c52566c7736a1$export$8c538325882c7eec = function() {
    return null;
};
$212c52566c7736a1$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $212c52566c7736a1$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$212c52566c7736a1$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $212c52566c7736a1$var$ReactElement(element.type, key, props);
};
$212c52566c7736a1$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $212c52566c7736a1$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $212c52566c7736a1$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$212c52566c7736a1$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$212c52566c7736a1$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $212c52566c7736a1$var$ReactElement(type, key, props);
};
$212c52566c7736a1$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$212c52566c7736a1$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $212c52566c7736a1$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$212c52566c7736a1$export$a8257692ac88316c = $212c52566c7736a1$var$isValidElement;
$212c52566c7736a1$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $212c52566c7736a1$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $212c52566c7736a1$var$lazyInitializer
    };
};
$212c52566c7736a1$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $212c52566c7736a1$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$212c52566c7736a1$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $212c52566c7736a1$var$ReactSharedInternals.T, currentTransition = {};
    $212c52566c7736a1$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $212c52566c7736a1$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($212c52566c7736a1$var$noop, $212c52566c7736a1$var$reportGlobalError);
    } catch (error) {
        $212c52566c7736a1$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $212c52566c7736a1$var$ReactSharedInternals.T = prevTransition;
    }
};
$212c52566c7736a1$export$f93f40ac0ca7e3a8 = function() {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useCacheRefresh();
};
$212c52566c7736a1$export$1f96ae73734a86cc = function(usable) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.use(usable);
};
$212c52566c7736a1$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$212c52566c7736a1$export$35808ee640e87ca7 = function(callback, deps) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$212c52566c7736a1$export$fae74005e78b1a27 = function(Context) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useContext(Context);
};
$212c52566c7736a1$export$dc8fbce3eb94dc1e = function() {};
$212c52566c7736a1$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$212c52566c7736a1$export$6d9c69b0de29b591 = function(create, deps) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useEffect(create, deps);
};
$212c52566c7736a1$export$7f54fc3180508a52 = function(callback) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$212c52566c7736a1$export$f680877a34711e37 = function() {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useId();
};
$212c52566c7736a1$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$212c52566c7736a1$export$aaabe4eda9ed9969 = function(create, deps) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$212c52566c7736a1$export$e5c5a5f917a5871c = function(create, deps) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$212c52566c7736a1$export$1538c33de8887b59 = function(create, deps) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useMemo(create, deps);
};
$212c52566c7736a1$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$212c52566c7736a1$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$212c52566c7736a1$export$b8f5890fc79d6aca = function(initialValue) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useRef(initialValue);
};
$212c52566c7736a1$export$60241385465d0a34 = function(initialState) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useState(initialState);
};
$212c52566c7736a1$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$212c52566c7736a1$export$7b286972b8d8ccbf = function() {
    return $212c52566c7736a1$var$ReactSharedInternals.H.useTransition();
};
$212c52566c7736a1$export$83d89fbfd8236492 = "19.2.4";

});

parcelRegister("kF4cy", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $f0aae54e49e47103$export$882461b6382ed46c, (v) => $f0aae54e49e47103$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $f0aae54e49e47103$export$757ceba2d55c277e, (v) => $f0aae54e49e47103$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $f0aae54e49e47103$export$83d89fbfd8236492, (v) => $f0aae54e49e47103$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $f0aae54e49e47103$export$882461b6382ed46c;
var $f0aae54e49e47103$export$757ceba2d55c277e;
var $f0aae54e49e47103$export$83d89fbfd8236492;
"use strict";

var $hDqGr = parcelRequire("hDqGr");

var $kYL7Z = parcelRequire("kYL7Z");

var $cRanb = parcelRequire("cRanb");
function $f0aae54e49e47103$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $f0aae54e49e47103$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $f0aae54e49e47103$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $f0aae54e49e47103$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $f0aae54e49e47103$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $f0aae54e49e47103$var$assertIsMounted(fiber) {
    if ($f0aae54e49e47103$var$getNearestMountedFiber(fiber) !== fiber) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(188));
}
function $f0aae54e49e47103$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $f0aae54e49e47103$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $f0aae54e49e47103$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $f0aae54e49e47103$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $f0aae54e49e47103$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $f0aae54e49e47103$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $f0aae54e49e47103$var$assign = Object.assign, $f0aae54e49e47103$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $f0aae54e49e47103$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $f0aae54e49e47103$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $f0aae54e49e47103$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $f0aae54e49e47103$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $f0aae54e49e47103$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $f0aae54e49e47103$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $f0aae54e49e47103$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $f0aae54e49e47103$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $f0aae54e49e47103$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $f0aae54e49e47103$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $f0aae54e49e47103$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $f0aae54e49e47103$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $f0aae54e49e47103$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $f0aae54e49e47103$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $f0aae54e49e47103$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $f0aae54e49e47103$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $f0aae54e49e47103$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$f0aae54e49e47103$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $f0aae54e49e47103$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $f0aae54e49e47103$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $f0aae54e49e47103$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $f0aae54e49e47103$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $f0aae54e49e47103$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $f0aae54e49e47103$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $f0aae54e49e47103$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $f0aae54e49e47103$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $f0aae54e49e47103$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $f0aae54e49e47103$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $f0aae54e49e47103$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $f0aae54e49e47103$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $f0aae54e49e47103$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $f0aae54e49e47103$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $f0aae54e49e47103$var$getComponentNameFromType(type.type) || "Memo";
        case $f0aae54e49e47103$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $f0aae54e49e47103$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $f0aae54e49e47103$var$isArrayImpl = Array.isArray, $f0aae54e49e47103$var$ReactSharedInternals = $kYL7Z.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f0aae54e49e47103$var$ReactDOMSharedInternals = $cRanb.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $f0aae54e49e47103$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $f0aae54e49e47103$var$valueStack = [], $f0aae54e49e47103$var$index = -1;
function $f0aae54e49e47103$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $f0aae54e49e47103$var$pop(cursor) {
    0 > $f0aae54e49e47103$var$index || (cursor.current = $f0aae54e49e47103$var$valueStack[$f0aae54e49e47103$var$index], $f0aae54e49e47103$var$valueStack[$f0aae54e49e47103$var$index] = null, $f0aae54e49e47103$var$index--);
}
function $f0aae54e49e47103$var$push(cursor, value) {
    $f0aae54e49e47103$var$index++;
    $f0aae54e49e47103$var$valueStack[$f0aae54e49e47103$var$index] = cursor.current;
    cursor.current = value;
}
var $f0aae54e49e47103$var$contextStackCursor = $f0aae54e49e47103$var$createCursor(null), $f0aae54e49e47103$var$contextFiberStackCursor = $f0aae54e49e47103$var$createCursor(null), $f0aae54e49e47103$var$rootInstanceStackCursor = $f0aae54e49e47103$var$createCursor(null), $f0aae54e49e47103$var$hostTransitionProviderCursor = $f0aae54e49e47103$var$createCursor(null);
function $f0aae54e49e47103$var$pushHostContainer(fiber, nextRootInstance) {
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$rootInstanceStackCursor, nextRootInstance);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$contextFiberStackCursor, fiber);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $f0aae54e49e47103$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $f0aae54e49e47103$var$getOwnHostContext(nextRootInstance), fiber = $f0aae54e49e47103$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$contextStackCursor);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$contextStackCursor, fiber);
}
function $f0aae54e49e47103$var$popHostContainer() {
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$contextStackCursor);
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$contextFiberStackCursor);
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$rootInstanceStackCursor);
}
function $f0aae54e49e47103$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $f0aae54e49e47103$var$push($f0aae54e49e47103$var$hostTransitionProviderCursor, fiber);
    var context = $f0aae54e49e47103$var$contextStackCursor.current;
    var JSCompiler_inline_result = $f0aae54e49e47103$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($f0aae54e49e47103$var$push($f0aae54e49e47103$var$contextFiberStackCursor, fiber), $f0aae54e49e47103$var$push($f0aae54e49e47103$var$contextStackCursor, JSCompiler_inline_result));
}
function $f0aae54e49e47103$var$popHostContext(fiber) {
    $f0aae54e49e47103$var$contextFiberStackCursor.current === fiber && ($f0aae54e49e47103$var$pop($f0aae54e49e47103$var$contextStackCursor), $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$contextFiberStackCursor));
    $f0aae54e49e47103$var$hostTransitionProviderCursor.current === fiber && ($f0aae54e49e47103$var$pop($f0aae54e49e47103$var$hostTransitionProviderCursor), $f0aae54e49e47103$var$HostTransitionContext._currentValue = $f0aae54e49e47103$var$sharedNotPendingObject);
}
var $f0aae54e49e47103$var$prefix, $f0aae54e49e47103$var$suffix;
function $f0aae54e49e47103$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $f0aae54e49e47103$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $f0aae54e49e47103$var$prefix = match && match[1] || "";
        $f0aae54e49e47103$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $f0aae54e49e47103$var$prefix + name + $f0aae54e49e47103$var$suffix;
}
var $f0aae54e49e47103$var$reentry = !1;
function $f0aae54e49e47103$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $f0aae54e49e47103$var$reentry) return "";
    $f0aae54e49e47103$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $f0aae54e49e47103$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $f0aae54e49e47103$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $f0aae54e49e47103$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $f0aae54e49e47103$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $f0aae54e49e47103$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $f0aae54e49e47103$var$describeBuiltInComponentFrame("Suspense Fallback") : $f0aae54e49e47103$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $f0aae54e49e47103$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $f0aae54e49e47103$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $f0aae54e49e47103$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $f0aae54e49e47103$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $f0aae54e49e47103$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $f0aae54e49e47103$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $f0aae54e49e47103$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $f0aae54e49e47103$var$hasOwnProperty = Object.prototype.hasOwnProperty, $f0aae54e49e47103$var$scheduleCallback$3 = $hDqGr.unstable_scheduleCallback, $f0aae54e49e47103$var$cancelCallback$1 = $hDqGr.unstable_cancelCallback, $f0aae54e49e47103$var$shouldYield = $hDqGr.unstable_shouldYield, $f0aae54e49e47103$var$requestPaint = $hDqGr.unstable_requestPaint, $f0aae54e49e47103$var$now = $hDqGr.unstable_now, $f0aae54e49e47103$var$getCurrentPriorityLevel = $hDqGr.unstable_getCurrentPriorityLevel, $f0aae54e49e47103$var$ImmediatePriority = $hDqGr.unstable_ImmediatePriority, $f0aae54e49e47103$var$UserBlockingPriority = $hDqGr.unstable_UserBlockingPriority, $f0aae54e49e47103$var$NormalPriority$1 = $hDqGr.unstable_NormalPriority, $f0aae54e49e47103$var$LowPriority = $hDqGr.unstable_LowPriority, $f0aae54e49e47103$var$IdlePriority = $hDqGr.unstable_IdlePriority, $f0aae54e49e47103$var$log$1 = $hDqGr.log, $f0aae54e49e47103$var$unstable_setDisableYieldValue = $hDqGr.unstable_setDisableYieldValue, $f0aae54e49e47103$var$rendererID = null, $f0aae54e49e47103$var$injectedHook = null;
function $f0aae54e49e47103$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $f0aae54e49e47103$var$log$1 && $f0aae54e49e47103$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($f0aae54e49e47103$var$injectedHook && "function" === typeof $f0aae54e49e47103$var$injectedHook.setStrictMode) try {
        $f0aae54e49e47103$var$injectedHook.setStrictMode($f0aae54e49e47103$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $f0aae54e49e47103$var$clz32 = Math.clz32 ? Math.clz32 : $f0aae54e49e47103$var$clz32Fallback, $f0aae54e49e47103$var$log = Math.log, $f0aae54e49e47103$var$LN2 = Math.LN2;
function $f0aae54e49e47103$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($f0aae54e49e47103$var$log(x) / $f0aae54e49e47103$var$LN2 | 0) | 0;
}
var $f0aae54e49e47103$var$nextTransitionUpdateLane = 256, $f0aae54e49e47103$var$nextTransitionDeferredLane = 262144, $f0aae54e49e47103$var$nextRetryLane = 4194304;
function $f0aae54e49e47103$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $f0aae54e49e47103$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $f0aae54e49e47103$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $f0aae54e49e47103$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f0aae54e49e47103$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $f0aae54e49e47103$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $f0aae54e49e47103$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $f0aae54e49e47103$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $f0aae54e49e47103$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $f0aae54e49e47103$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $f0aae54e49e47103$var$claimNextRetryLane() {
    var lane = $f0aae54e49e47103$var$nextRetryLane;
    $f0aae54e49e47103$var$nextRetryLane <<= 1;
    0 === ($f0aae54e49e47103$var$nextRetryLane & 62914560) && ($f0aae54e49e47103$var$nextRetryLane = 4194304);
    return lane;
}
function $f0aae54e49e47103$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $f0aae54e49e47103$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $f0aae54e49e47103$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $f0aae54e49e47103$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $f0aae54e49e47103$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $f0aae54e49e47103$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $f0aae54e49e47103$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $f0aae54e49e47103$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $f0aae54e49e47103$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $f0aae54e49e47103$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $f0aae54e49e47103$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $f0aae54e49e47103$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $f0aae54e49e47103$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $f0aae54e49e47103$var$resolveUpdatePriority() {
    var updatePriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $f0aae54e49e47103$var$getEventPriority(updatePriority.type);
}
function $f0aae54e49e47103$var$runWithPriority(priority, fn) {
    var previousPriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
    try {
        return $f0aae54e49e47103$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $f0aae54e49e47103$var$randomKey = Math.random().toString(36).slice(2), $f0aae54e49e47103$var$internalInstanceKey = "__reactFiber$" + $f0aae54e49e47103$var$randomKey, $f0aae54e49e47103$var$internalPropsKey = "__reactProps$" + $f0aae54e49e47103$var$randomKey, $f0aae54e49e47103$var$internalContainerInstanceKey = "__reactContainer$" + $f0aae54e49e47103$var$randomKey, $f0aae54e49e47103$var$internalEventHandlersKey = "__reactEvents$" + $f0aae54e49e47103$var$randomKey, $f0aae54e49e47103$var$internalEventHandlerListenersKey = "__reactListeners$" + $f0aae54e49e47103$var$randomKey, $f0aae54e49e47103$var$internalEventHandlesSetKey = "__reactHandles$" + $f0aae54e49e47103$var$randomKey, $f0aae54e49e47103$var$internalRootNodeResourcesKey = "__reactResources$" + $f0aae54e49e47103$var$randomKey, $f0aae54e49e47103$var$internalHoistableMarker = "__reactMarker$" + $f0aae54e49e47103$var$randomKey;
function $f0aae54e49e47103$var$detachDeletedInstance(node) {
    delete node[$f0aae54e49e47103$var$internalInstanceKey];
    delete node[$f0aae54e49e47103$var$internalPropsKey];
    delete node[$f0aae54e49e47103$var$internalEventHandlersKey];
    delete node[$f0aae54e49e47103$var$internalEventHandlerListenersKey];
    delete node[$f0aae54e49e47103$var$internalEventHandlesSetKey];
}
function $f0aae54e49e47103$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$f0aae54e49e47103$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$f0aae54e49e47103$var$internalContainerInstanceKey] || parentNode[$f0aae54e49e47103$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $f0aae54e49e47103$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$f0aae54e49e47103$var$internalInstanceKey]) return parentNode;
                targetNode = $f0aae54e49e47103$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $f0aae54e49e47103$var$getInstanceFromNode(node) {
    if (node = node[$f0aae54e49e47103$var$internalInstanceKey] || node[$f0aae54e49e47103$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $f0aae54e49e47103$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(33));
}
function $f0aae54e49e47103$var$getResourcesFromRoot(root) {
    var resources = root[$f0aae54e49e47103$var$internalRootNodeResourcesKey];
    resources || (resources = root[$f0aae54e49e47103$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $f0aae54e49e47103$var$markNodeAsHoistable(node) {
    node[$f0aae54e49e47103$var$internalHoistableMarker] = !0;
}
var $f0aae54e49e47103$var$allNativeEvents = new Set(), $f0aae54e49e47103$var$registrationNameDependencies = {};
function $f0aae54e49e47103$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $f0aae54e49e47103$var$registerDirectEvent(registrationName, dependencies);
    $f0aae54e49e47103$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $f0aae54e49e47103$var$registerDirectEvent(registrationName, dependencies) {
    $f0aae54e49e47103$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$f0aae54e49e47103$var$allNativeEvents.add(dependencies[registrationName]);
}
var $f0aae54e49e47103$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $f0aae54e49e47103$var$illegalAttributeNameCache = {}, $f0aae54e49e47103$var$validatedAttributeNameCache = {};
function $f0aae54e49e47103$var$isAttributeNameSafe(attributeName) {
    if ($f0aae54e49e47103$var$hasOwnProperty.call($f0aae54e49e47103$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($f0aae54e49e47103$var$hasOwnProperty.call($f0aae54e49e47103$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($f0aae54e49e47103$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $f0aae54e49e47103$var$validatedAttributeNameCache[attributeName] = !0;
    $f0aae54e49e47103$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $f0aae54e49e47103$var$setValueForAttribute(node, name, value) {
    if ($f0aae54e49e47103$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $f0aae54e49e47103$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $f0aae54e49e47103$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $f0aae54e49e47103$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $f0aae54e49e47103$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $f0aae54e49e47103$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $f0aae54e49e47103$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $f0aae54e49e47103$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $f0aae54e49e47103$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $f0aae54e49e47103$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $f0aae54e49e47103$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $f0aae54e49e47103$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $f0aae54e49e47103$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $f0aae54e49e47103$var$getToStringValue(value);
        } else element.value !== "" + $f0aae54e49e47103$var$getToStringValue(value) && (element.value = "" + $f0aae54e49e47103$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $f0aae54e49e47103$var$setDefaultValue(element, type, $f0aae54e49e47103$var$getToStringValue(value)) : null != defaultValue ? $f0aae54e49e47103$var$setDefaultValue(element, type, $f0aae54e49e47103$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $f0aae54e49e47103$var$getToStringValue(name) : element.removeAttribute("name");
}
function $f0aae54e49e47103$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $f0aae54e49e47103$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $f0aae54e49e47103$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $f0aae54e49e47103$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $f0aae54e49e47103$var$track(element);
}
function $f0aae54e49e47103$var$setDefaultValue(node, type, value) {
    "number" === type && $f0aae54e49e47103$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $f0aae54e49e47103$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $f0aae54e49e47103$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $f0aae54e49e47103$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $f0aae54e49e47103$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $f0aae54e49e47103$var$getToStringValue(defaultValue) : "";
}
function $f0aae54e49e47103$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(92));
            if ($f0aae54e49e47103$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $f0aae54e49e47103$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $f0aae54e49e47103$var$track(element);
}
function $f0aae54e49e47103$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $f0aae54e49e47103$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $f0aae54e49e47103$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $f0aae54e49e47103$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $f0aae54e49e47103$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $f0aae54e49e47103$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $f0aae54e49e47103$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $f0aae54e49e47103$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $f0aae54e49e47103$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $f0aae54e49e47103$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $f0aae54e49e47103$var$sanitizeURL(url) {
    return $f0aae54e49e47103$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $f0aae54e49e47103$var$noop$1() {}
var $f0aae54e49e47103$var$currentReplayingEvent = null;
function $f0aae54e49e47103$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $f0aae54e49e47103$var$restoreTarget = null, $f0aae54e49e47103$var$restoreQueue = null;
function $f0aae54e49e47103$var$restoreStateOfTarget(target) {
    var internalInstance = $f0aae54e49e47103$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$f0aae54e49e47103$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $f0aae54e49e47103$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$f0aae54e49e47103$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(90));
                            $f0aae54e49e47103$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $f0aae54e49e47103$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $f0aae54e49e47103$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $f0aae54e49e47103$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $f0aae54e49e47103$var$isInsideEventHandler = !1;
function $f0aae54e49e47103$var$batchedUpdates$1(fn, a, b) {
    if ($f0aae54e49e47103$var$isInsideEventHandler) return fn(a, b);
    $f0aae54e49e47103$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($f0aae54e49e47103$var$isInsideEventHandler = !1, null !== $f0aae54e49e47103$var$restoreTarget || null !== $f0aae54e49e47103$var$restoreQueue) {
            if ($f0aae54e49e47103$var$flushSyncWork$1(), $f0aae54e49e47103$var$restoreTarget && (a = $f0aae54e49e47103$var$restoreTarget, fn = $f0aae54e49e47103$var$restoreQueue, $f0aae54e49e47103$var$restoreQueue = $f0aae54e49e47103$var$restoreTarget = null, $f0aae54e49e47103$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$f0aae54e49e47103$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $f0aae54e49e47103$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$f0aae54e49e47103$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $f0aae54e49e47103$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $f0aae54e49e47103$var$passiveBrowserEventsSupported = !1;
if ($f0aae54e49e47103$var$canUseDOM) try {
    var $f0aae54e49e47103$var$options = {};
    Object.defineProperty($f0aae54e49e47103$var$options, "passive", {
        get: function() {
            $f0aae54e49e47103$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $f0aae54e49e47103$var$options, $f0aae54e49e47103$var$options);
    window.removeEventListener("test", $f0aae54e49e47103$var$options, $f0aae54e49e47103$var$options);
} catch (e) {
    $f0aae54e49e47103$var$passiveBrowserEventsSupported = !1;
}
var $f0aae54e49e47103$var$root = null, $f0aae54e49e47103$var$startText = null, $f0aae54e49e47103$var$fallbackText = null;
function $f0aae54e49e47103$var$getData() {
    if ($f0aae54e49e47103$var$fallbackText) return $f0aae54e49e47103$var$fallbackText;
    var start, startValue = $f0aae54e49e47103$var$startText, startLength = startValue.length, end, endValue = "value" in $f0aae54e49e47103$var$root ? $f0aae54e49e47103$var$root.value : $f0aae54e49e47103$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $f0aae54e49e47103$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $f0aae54e49e47103$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $f0aae54e49e47103$var$functionThatReturnsTrue() {
    return !0;
}
function $f0aae54e49e47103$var$functionThatReturnsFalse() {
    return !1;
}
function $f0aae54e49e47103$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $f0aae54e49e47103$var$functionThatReturnsTrue : $f0aae54e49e47103$var$functionThatReturnsFalse;
        this.isPropagationStopped = $f0aae54e49e47103$var$functionThatReturnsFalse;
        return this;
    }
    $f0aae54e49e47103$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $f0aae54e49e47103$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $f0aae54e49e47103$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $f0aae54e49e47103$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $f0aae54e49e47103$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $f0aae54e49e47103$var$SyntheticEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$EventInterface), $f0aae54e49e47103$var$UIEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$EventInterface, {
    view: 0,
    detail: 0
}), $f0aae54e49e47103$var$SyntheticUIEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$UIEventInterface), $f0aae54e49e47103$var$lastMovementX, $f0aae54e49e47103$var$lastMovementY, $f0aae54e49e47103$var$lastMouseEvent, $f0aae54e49e47103$var$MouseEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $f0aae54e49e47103$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $f0aae54e49e47103$var$lastMouseEvent && ($f0aae54e49e47103$var$lastMouseEvent && "mousemove" === event.type ? ($f0aae54e49e47103$var$lastMovementX = event.screenX - $f0aae54e49e47103$var$lastMouseEvent.screenX, $f0aae54e49e47103$var$lastMovementY = event.screenY - $f0aae54e49e47103$var$lastMouseEvent.screenY) : $f0aae54e49e47103$var$lastMovementY = $f0aae54e49e47103$var$lastMovementX = 0, $f0aae54e49e47103$var$lastMouseEvent = event);
        return $f0aae54e49e47103$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $f0aae54e49e47103$var$lastMovementY;
    }
}), $f0aae54e49e47103$var$SyntheticMouseEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$MouseEventInterface), $f0aae54e49e47103$var$DragEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$MouseEventInterface, {
    dataTransfer: 0
}), $f0aae54e49e47103$var$SyntheticDragEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$DragEventInterface), $f0aae54e49e47103$var$FocusEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$UIEventInterface, {
    relatedTarget: 0
}), $f0aae54e49e47103$var$SyntheticFocusEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$FocusEventInterface), $f0aae54e49e47103$var$AnimationEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f0aae54e49e47103$var$SyntheticAnimationEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$AnimationEventInterface), $f0aae54e49e47103$var$ClipboardEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $f0aae54e49e47103$var$SyntheticClipboardEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$ClipboardEventInterface), $f0aae54e49e47103$var$CompositionEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$EventInterface, {
    data: 0
}), $f0aae54e49e47103$var$SyntheticCompositionEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$CompositionEventInterface), $f0aae54e49e47103$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $f0aae54e49e47103$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $f0aae54e49e47103$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $f0aae54e49e47103$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $f0aae54e49e47103$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $f0aae54e49e47103$var$getEventModifierState() {
    return $f0aae54e49e47103$var$modifierStateGetter;
}
var $f0aae54e49e47103$var$KeyboardEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $f0aae54e49e47103$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $f0aae54e49e47103$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $f0aae54e49e47103$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $f0aae54e49e47103$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $f0aae54e49e47103$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $f0aae54e49e47103$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $f0aae54e49e47103$var$SyntheticKeyboardEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$KeyboardEventInterface), $f0aae54e49e47103$var$PointerEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $f0aae54e49e47103$var$SyntheticPointerEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$PointerEventInterface), $f0aae54e49e47103$var$TouchEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $f0aae54e49e47103$var$getEventModifierState
}), $f0aae54e49e47103$var$SyntheticTouchEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$TouchEventInterface), $f0aae54e49e47103$var$TransitionEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $f0aae54e49e47103$var$SyntheticTransitionEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$TransitionEventInterface), $f0aae54e49e47103$var$WheelEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $f0aae54e49e47103$var$SyntheticWheelEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$WheelEventInterface), $f0aae54e49e47103$var$ToggleEventInterface = $f0aae54e49e47103$var$assign({}, $f0aae54e49e47103$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $f0aae54e49e47103$var$SyntheticToggleEvent = $f0aae54e49e47103$var$createSyntheticEvent($f0aae54e49e47103$var$ToggleEventInterface), $f0aae54e49e47103$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $f0aae54e49e47103$var$canUseCompositionEvent = $f0aae54e49e47103$var$canUseDOM && "CompositionEvent" in window, $f0aae54e49e47103$var$documentMode = null;
$f0aae54e49e47103$var$canUseDOM && "documentMode" in document && ($f0aae54e49e47103$var$documentMode = document.documentMode);
var $f0aae54e49e47103$var$canUseTextInputEvent = $f0aae54e49e47103$var$canUseDOM && "TextEvent" in window && !$f0aae54e49e47103$var$documentMode, $f0aae54e49e47103$var$useFallbackCompositionData = $f0aae54e49e47103$var$canUseDOM && (!$f0aae54e49e47103$var$canUseCompositionEvent || $f0aae54e49e47103$var$documentMode && 8 < $f0aae54e49e47103$var$documentMode && 11 >= $f0aae54e49e47103$var$documentMode), $f0aae54e49e47103$var$SPACEBAR_CHAR = String.fromCharCode(32), $f0aae54e49e47103$var$hasSpaceKeypress = !1;
function $f0aae54e49e47103$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $f0aae54e49e47103$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $f0aae54e49e47103$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $f0aae54e49e47103$var$isComposing = !1;
function $f0aae54e49e47103$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $f0aae54e49e47103$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $f0aae54e49e47103$var$hasSpaceKeypress = !0;
            return $f0aae54e49e47103$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $f0aae54e49e47103$var$SPACEBAR_CHAR && $f0aae54e49e47103$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $f0aae54e49e47103$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($f0aae54e49e47103$var$isComposing) return "compositionend" === domEventName || !$f0aae54e49e47103$var$canUseCompositionEvent && $f0aae54e49e47103$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $f0aae54e49e47103$var$getData(), $f0aae54e49e47103$var$fallbackText = $f0aae54e49e47103$var$startText = $f0aae54e49e47103$var$root = null, $f0aae54e49e47103$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $f0aae54e49e47103$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $f0aae54e49e47103$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $f0aae54e49e47103$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$f0aae54e49e47103$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $f0aae54e49e47103$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $f0aae54e49e47103$var$restoreTarget ? $f0aae54e49e47103$var$restoreQueue ? $f0aae54e49e47103$var$restoreQueue.push(target) : $f0aae54e49e47103$var$restoreQueue = [
        target
    ] : $f0aae54e49e47103$var$restoreTarget = target;
    inst = $f0aae54e49e47103$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $f0aae54e49e47103$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $f0aae54e49e47103$var$activeElement$1 = null, $f0aae54e49e47103$var$activeElementInst$1 = null;
function $f0aae54e49e47103$var$runEventInBatch(dispatchQueue) {
    $f0aae54e49e47103$var$processDispatchQueue(dispatchQueue, 0);
}
function $f0aae54e49e47103$var$getInstIfValueChanged(targetInst) {
    var targetNode = $f0aae54e49e47103$var$getNodeFromInstance(targetInst);
    if ($f0aae54e49e47103$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $f0aae54e49e47103$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $f0aae54e49e47103$var$isInputEventSupported = !1;
if ($f0aae54e49e47103$var$canUseDOM) {
    var $f0aae54e49e47103$var$JSCompiler_inline_result$jscomp$286;
    if ($f0aae54e49e47103$var$canUseDOM) {
        var $f0aae54e49e47103$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$f0aae54e49e47103$var$isSupported$jscomp$inline_427) {
            var $f0aae54e49e47103$var$element$jscomp$inline_428 = document.createElement("div");
            $f0aae54e49e47103$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $f0aae54e49e47103$var$isSupported$jscomp$inline_427 = "function" === typeof $f0aae54e49e47103$var$element$jscomp$inline_428.oninput;
        }
        $f0aae54e49e47103$var$JSCompiler_inline_result$jscomp$286 = $f0aae54e49e47103$var$isSupported$jscomp$inline_427;
    } else $f0aae54e49e47103$var$JSCompiler_inline_result$jscomp$286 = !1;
    $f0aae54e49e47103$var$isInputEventSupported = $f0aae54e49e47103$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $f0aae54e49e47103$var$stopWatchingForValueChange() {
    $f0aae54e49e47103$var$activeElement$1 && ($f0aae54e49e47103$var$activeElement$1.detachEvent("onpropertychange", $f0aae54e49e47103$var$handlePropertyChange), $f0aae54e49e47103$var$activeElementInst$1 = $f0aae54e49e47103$var$activeElement$1 = null);
}
function $f0aae54e49e47103$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $f0aae54e49e47103$var$getInstIfValueChanged($f0aae54e49e47103$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $f0aae54e49e47103$var$createAndAccumulateChangeEvent(dispatchQueue, $f0aae54e49e47103$var$activeElementInst$1, nativeEvent, $f0aae54e49e47103$var$getEventTarget(nativeEvent));
        $f0aae54e49e47103$var$batchedUpdates$1($f0aae54e49e47103$var$runEventInBatch, dispatchQueue);
    }
}
function $f0aae54e49e47103$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($f0aae54e49e47103$var$stopWatchingForValueChange(), $f0aae54e49e47103$var$activeElement$1 = target, $f0aae54e49e47103$var$activeElementInst$1 = targetInst, $f0aae54e49e47103$var$activeElement$1.attachEvent("onpropertychange", $f0aae54e49e47103$var$handlePropertyChange)) : "focusout" === domEventName && $f0aae54e49e47103$var$stopWatchingForValueChange();
}
function $f0aae54e49e47103$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $f0aae54e49e47103$var$getInstIfValueChanged($f0aae54e49e47103$var$activeElementInst$1);
}
function $f0aae54e49e47103$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $f0aae54e49e47103$var$getInstIfValueChanged(targetInst);
}
function $f0aae54e49e47103$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $f0aae54e49e47103$var$getInstIfValueChanged(targetInst);
}
function $f0aae54e49e47103$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $f0aae54e49e47103$var$objectIs = "function" === typeof Object.is ? Object.is : $f0aae54e49e47103$var$is;
function $f0aae54e49e47103$var$shallowEqual(objA, objB) {
    if ($f0aae54e49e47103$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$f0aae54e49e47103$var$hasOwnProperty.call(objB, currentKey) || !$f0aae54e49e47103$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $f0aae54e49e47103$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $f0aae54e49e47103$var$getNodeForCharacterOffset(root, offset) {
    var node = $f0aae54e49e47103$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $f0aae54e49e47103$var$getLeafNode(node);
    }
}
function $f0aae54e49e47103$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $f0aae54e49e47103$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $f0aae54e49e47103$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $f0aae54e49e47103$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $f0aae54e49e47103$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $f0aae54e49e47103$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $f0aae54e49e47103$var$skipSelectionChangeEvent = $f0aae54e49e47103$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $f0aae54e49e47103$var$activeElement = null, $f0aae54e49e47103$var$activeElementInst = null, $f0aae54e49e47103$var$lastSelection = null, $f0aae54e49e47103$var$mouseDown = !1;
function $f0aae54e49e47103$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $f0aae54e49e47103$var$mouseDown || null == $f0aae54e49e47103$var$activeElement || $f0aae54e49e47103$var$activeElement !== $f0aae54e49e47103$var$getActiveElement(doc) || (doc = $f0aae54e49e47103$var$activeElement, "selectionStart" in doc && $f0aae54e49e47103$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $f0aae54e49e47103$var$lastSelection && $f0aae54e49e47103$var$shallowEqual($f0aae54e49e47103$var$lastSelection, doc) || ($f0aae54e49e47103$var$lastSelection = doc, doc = $f0aae54e49e47103$var$accumulateTwoPhaseListeners($f0aae54e49e47103$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $f0aae54e49e47103$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $f0aae54e49e47103$var$activeElement)));
}
function $f0aae54e49e47103$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $f0aae54e49e47103$var$vendorPrefixes = {
    animationend: $f0aae54e49e47103$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $f0aae54e49e47103$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $f0aae54e49e47103$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $f0aae54e49e47103$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $f0aae54e49e47103$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $f0aae54e49e47103$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $f0aae54e49e47103$var$makePrefixMap("Transition", "TransitionEnd")
}, $f0aae54e49e47103$var$prefixedEventNames = {}, $f0aae54e49e47103$var$style = {};
$f0aae54e49e47103$var$canUseDOM && ($f0aae54e49e47103$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $f0aae54e49e47103$var$vendorPrefixes.animationend.animation, delete $f0aae54e49e47103$var$vendorPrefixes.animationiteration.animation, delete $f0aae54e49e47103$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $f0aae54e49e47103$var$vendorPrefixes.transitionend.transition);
function $f0aae54e49e47103$var$getVendorPrefixedEventName(eventName) {
    if ($f0aae54e49e47103$var$prefixedEventNames[eventName]) return $f0aae54e49e47103$var$prefixedEventNames[eventName];
    if (!$f0aae54e49e47103$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $f0aae54e49e47103$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $f0aae54e49e47103$var$style) return $f0aae54e49e47103$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $f0aae54e49e47103$var$ANIMATION_END = $f0aae54e49e47103$var$getVendorPrefixedEventName("animationend"), $f0aae54e49e47103$var$ANIMATION_ITERATION = $f0aae54e49e47103$var$getVendorPrefixedEventName("animationiteration"), $f0aae54e49e47103$var$ANIMATION_START = $f0aae54e49e47103$var$getVendorPrefixedEventName("animationstart"), $f0aae54e49e47103$var$TRANSITION_RUN = $f0aae54e49e47103$var$getVendorPrefixedEventName("transitionrun"), $f0aae54e49e47103$var$TRANSITION_START = $f0aae54e49e47103$var$getVendorPrefixedEventName("transitionstart"), $f0aae54e49e47103$var$TRANSITION_CANCEL = $f0aae54e49e47103$var$getVendorPrefixedEventName("transitioncancel"), $f0aae54e49e47103$var$TRANSITION_END = $f0aae54e49e47103$var$getVendorPrefixedEventName("transitionend"), $f0aae54e49e47103$var$topLevelEventsToReactNames = new Map(), $f0aae54e49e47103$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$f0aae54e49e47103$var$simpleEventPluginEvents.push("scrollEnd");
function $f0aae54e49e47103$var$registerSimpleEvent(domEventName, reactName) {
    $f0aae54e49e47103$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $f0aae54e49e47103$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $f0aae54e49e47103$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $f0aae54e49e47103$var$concurrentQueues = [], $f0aae54e49e47103$var$concurrentQueuesIndex = 0, $f0aae54e49e47103$var$concurrentlyUpdatedLanes = 0;
function $f0aae54e49e47103$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $f0aae54e49e47103$var$concurrentQueuesIndex, i = $f0aae54e49e47103$var$concurrentlyUpdatedLanes = $f0aae54e49e47103$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $f0aae54e49e47103$var$concurrentQueues[i];
        $f0aae54e49e47103$var$concurrentQueues[i++] = null;
        var queue = $f0aae54e49e47103$var$concurrentQueues[i];
        $f0aae54e49e47103$var$concurrentQueues[i++] = null;
        var update = $f0aae54e49e47103$var$concurrentQueues[i];
        $f0aae54e49e47103$var$concurrentQueues[i++] = null;
        var lane = $f0aae54e49e47103$var$concurrentQueues[i];
        $f0aae54e49e47103$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $f0aae54e49e47103$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $f0aae54e49e47103$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $f0aae54e49e47103$var$concurrentQueues[$f0aae54e49e47103$var$concurrentQueuesIndex++] = fiber;
    $f0aae54e49e47103$var$concurrentQueues[$f0aae54e49e47103$var$concurrentQueuesIndex++] = queue;
    $f0aae54e49e47103$var$concurrentQueues[$f0aae54e49e47103$var$concurrentQueuesIndex++] = update;
    $f0aae54e49e47103$var$concurrentQueues[$f0aae54e49e47103$var$concurrentQueuesIndex++] = lane;
    $f0aae54e49e47103$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $f0aae54e49e47103$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $f0aae54e49e47103$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $f0aae54e49e47103$var$getRootForUpdatedFiber(fiber);
}
function $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $f0aae54e49e47103$var$enqueueUpdate$1(fiber, null, null, lane);
    return $f0aae54e49e47103$var$getRootForUpdatedFiber(fiber);
}
function $f0aae54e49e47103$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $f0aae54e49e47103$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $f0aae54e49e47103$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $f0aae54e49e47103$var$nestedUpdateCount) throw $f0aae54e49e47103$var$nestedUpdateCount = 0, $f0aae54e49e47103$var$rootWithNestedUpdates = null, Error($f0aae54e49e47103$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $f0aae54e49e47103$var$emptyContextObject = {};
function $f0aae54e49e47103$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $f0aae54e49e47103$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $f0aae54e49e47103$var$FiberNode(tag, pendingProps, key, mode);
}
function $f0aae54e49e47103$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $f0aae54e49e47103$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $f0aae54e49e47103$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $f0aae54e49e47103$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $f0aae54e49e47103$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $f0aae54e49e47103$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $f0aae54e49e47103$var$isHostHoistableType(type, pendingProps, $f0aae54e49e47103$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $f0aae54e49e47103$var$REACT_ACTIVITY_TYPE:
            return type = $f0aae54e49e47103$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $f0aae54e49e47103$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $f0aae54e49e47103$var$REACT_FRAGMENT_TYPE:
            return $f0aae54e49e47103$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $f0aae54e49e47103$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $f0aae54e49e47103$var$REACT_PROFILER_TYPE:
            return type = $f0aae54e49e47103$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $f0aae54e49e47103$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $f0aae54e49e47103$var$REACT_SUSPENSE_TYPE:
            return type = $f0aae54e49e47103$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $f0aae54e49e47103$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $f0aae54e49e47103$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $f0aae54e49e47103$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $f0aae54e49e47103$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $f0aae54e49e47103$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $f0aae54e49e47103$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $f0aae54e49e47103$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $f0aae54e49e47103$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $f0aae54e49e47103$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($f0aae54e49e47103$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $f0aae54e49e47103$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $f0aae54e49e47103$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $f0aae54e49e47103$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $f0aae54e49e47103$var$createFiberFromText(content, mode, lanes) {
    content = $f0aae54e49e47103$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $f0aae54e49e47103$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $f0aae54e49e47103$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $f0aae54e49e47103$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $f0aae54e49e47103$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $f0aae54e49e47103$var$CapturedStacks = new WeakMap();
function $f0aae54e49e47103$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $f0aae54e49e47103$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $f0aae54e49e47103$var$getStackByFiberInDevAndProd(source)
        };
        $f0aae54e49e47103$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $f0aae54e49e47103$var$getStackByFiberInDevAndProd(source)
    };
}
var $f0aae54e49e47103$var$forkStack = [], $f0aae54e49e47103$var$forkStackIndex = 0, $f0aae54e49e47103$var$treeForkProvider = null, $f0aae54e49e47103$var$treeForkCount = 0, $f0aae54e49e47103$var$idStack = [], $f0aae54e49e47103$var$idStackIndex = 0, $f0aae54e49e47103$var$treeContextProvider = null, $f0aae54e49e47103$var$treeContextId = 1, $f0aae54e49e47103$var$treeContextOverflow = "";
function $f0aae54e49e47103$var$pushTreeFork(workInProgress, totalChildren) {
    $f0aae54e49e47103$var$forkStack[$f0aae54e49e47103$var$forkStackIndex++] = $f0aae54e49e47103$var$treeForkCount;
    $f0aae54e49e47103$var$forkStack[$f0aae54e49e47103$var$forkStackIndex++] = $f0aae54e49e47103$var$treeForkProvider;
    $f0aae54e49e47103$var$treeForkProvider = workInProgress;
    $f0aae54e49e47103$var$treeForkCount = totalChildren;
}
function $f0aae54e49e47103$var$pushTreeId(workInProgress, totalChildren, index) {
    $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex++] = $f0aae54e49e47103$var$treeContextId;
    $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex++] = $f0aae54e49e47103$var$treeContextOverflow;
    $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex++] = $f0aae54e49e47103$var$treeContextProvider;
    $f0aae54e49e47103$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $f0aae54e49e47103$var$treeContextId;
    workInProgress = $f0aae54e49e47103$var$treeContextOverflow;
    var baseLength = 32 - $f0aae54e49e47103$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $f0aae54e49e47103$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $f0aae54e49e47103$var$treeContextId = 1 << 32 - $f0aae54e49e47103$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $f0aae54e49e47103$var$treeContextOverflow = length + workInProgress;
    } else $f0aae54e49e47103$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $f0aae54e49e47103$var$treeContextOverflow = workInProgress;
}
function $f0aae54e49e47103$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($f0aae54e49e47103$var$pushTreeFork(workInProgress, 1), $f0aae54e49e47103$var$pushTreeId(workInProgress, 1, 0));
}
function $f0aae54e49e47103$var$popTreeContext(workInProgress) {
    for(; workInProgress === $f0aae54e49e47103$var$treeForkProvider;)$f0aae54e49e47103$var$treeForkProvider = $f0aae54e49e47103$var$forkStack[--$f0aae54e49e47103$var$forkStackIndex], $f0aae54e49e47103$var$forkStack[$f0aae54e49e47103$var$forkStackIndex] = null, $f0aae54e49e47103$var$treeForkCount = $f0aae54e49e47103$var$forkStack[--$f0aae54e49e47103$var$forkStackIndex], $f0aae54e49e47103$var$forkStack[$f0aae54e49e47103$var$forkStackIndex] = null;
    for(; workInProgress === $f0aae54e49e47103$var$treeContextProvider;)$f0aae54e49e47103$var$treeContextProvider = $f0aae54e49e47103$var$idStack[--$f0aae54e49e47103$var$idStackIndex], $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex] = null, $f0aae54e49e47103$var$treeContextOverflow = $f0aae54e49e47103$var$idStack[--$f0aae54e49e47103$var$idStackIndex], $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex] = null, $f0aae54e49e47103$var$treeContextId = $f0aae54e49e47103$var$idStack[--$f0aae54e49e47103$var$idStackIndex], $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex] = null;
}
function $f0aae54e49e47103$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex++] = $f0aae54e49e47103$var$treeContextId;
    $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex++] = $f0aae54e49e47103$var$treeContextOverflow;
    $f0aae54e49e47103$var$idStack[$f0aae54e49e47103$var$idStackIndex++] = $f0aae54e49e47103$var$treeContextProvider;
    $f0aae54e49e47103$var$treeContextId = suspendedContext.id;
    $f0aae54e49e47103$var$treeContextOverflow = suspendedContext.overflow;
    $f0aae54e49e47103$var$treeContextProvider = workInProgress;
}
var $f0aae54e49e47103$var$hydrationParentFiber = null, $f0aae54e49e47103$var$nextHydratableInstance = null, $f0aae54e49e47103$var$isHydrating = !1, $f0aae54e49e47103$var$hydrationErrors = null, $f0aae54e49e47103$var$rootOrSingletonContext = !1, $f0aae54e49e47103$var$HydrationMismatchException = Error($f0aae54e49e47103$var$formatProdErrorMessage(519));
function $f0aae54e49e47103$var$throwOnHydrationMismatch(fiber) {
    var error = Error($f0aae54e49e47103$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $f0aae54e49e47103$var$queueHydrationError($f0aae54e49e47103$var$createCapturedValueAtFiber(error, fiber));
    throw $f0aae54e49e47103$var$HydrationMismatchException;
}
function $f0aae54e49e47103$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$f0aae54e49e47103$var$internalInstanceKey] = fiber;
    instance[$f0aae54e49e47103$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("cancel", instance);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $f0aae54e49e47103$var$mediaEventTypes.length; type++)$f0aae54e49e47103$var$listenToNonDelegatedEvent($f0aae54e49e47103$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("error", instance);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("invalid", instance);
            $f0aae54e49e47103$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("invalid", instance), $f0aae54e49e47103$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $f0aae54e49e47103$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($f0aae54e49e47103$var$listenToNonDelegatedEvent("beforetoggle", instance), $f0aae54e49e47103$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $f0aae54e49e47103$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $f0aae54e49e47103$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $f0aae54e49e47103$var$noop$1), instance = !0) : instance = !1;
    instance || $f0aae54e49e47103$var$throwOnHydrationMismatch(fiber, !0);
}
function $f0aae54e49e47103$var$popToNextHostParent(fiber) {
    for($f0aae54e49e47103$var$hydrationParentFiber = fiber.return; $f0aae54e49e47103$var$hydrationParentFiber;)switch($f0aae54e49e47103$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $f0aae54e49e47103$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $f0aae54e49e47103$var$rootOrSingletonContext = !0;
            return;
        default:
            $f0aae54e49e47103$var$hydrationParentFiber = $f0aae54e49e47103$var$hydrationParentFiber.return;
    }
}
function $f0aae54e49e47103$var$popHydrationState(fiber) {
    if (fiber !== $f0aae54e49e47103$var$hydrationParentFiber) return !1;
    if (!$f0aae54e49e47103$var$isHydrating) return $f0aae54e49e47103$var$popToNextHostParent(fiber), $f0aae54e49e47103$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $f0aae54e49e47103$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $f0aae54e49e47103$var$nextHydratableInstance && $f0aae54e49e47103$var$throwOnHydrationMismatch(fiber);
    $f0aae54e49e47103$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(317));
        $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(317));
        $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $f0aae54e49e47103$var$nextHydratableInstance, $f0aae54e49e47103$var$isSingletonScope(fiber.type) ? (fiber = $f0aae54e49e47103$var$previousHydratableOnEnteringScopedSingleton, $f0aae54e49e47103$var$previousHydratableOnEnteringScopedSingleton = null, $f0aae54e49e47103$var$nextHydratableInstance = fiber) : $f0aae54e49e47103$var$nextHydratableInstance = tag) : $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$hydrationParentFiber ? $f0aae54e49e47103$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $f0aae54e49e47103$var$resetHydrationState() {
    $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$hydrationParentFiber = null;
    $f0aae54e49e47103$var$isHydrating = !1;
}
function $f0aae54e49e47103$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $f0aae54e49e47103$var$hydrationErrors;
    null !== queuedErrors && (null === $f0aae54e49e47103$var$workInProgressRootRecoverableErrors ? $f0aae54e49e47103$var$workInProgressRootRecoverableErrors = queuedErrors : $f0aae54e49e47103$var$workInProgressRootRecoverableErrors.push.apply($f0aae54e49e47103$var$workInProgressRootRecoverableErrors, queuedErrors), $f0aae54e49e47103$var$hydrationErrors = null);
    return queuedErrors;
}
function $f0aae54e49e47103$var$queueHydrationError(error) {
    null === $f0aae54e49e47103$var$hydrationErrors ? $f0aae54e49e47103$var$hydrationErrors = [
        error
    ] : $f0aae54e49e47103$var$hydrationErrors.push(error);
}
var $f0aae54e49e47103$var$valueCursor = $f0aae54e49e47103$var$createCursor(null), $f0aae54e49e47103$var$currentlyRenderingFiber$1 = null, $f0aae54e49e47103$var$lastContextDependency = null;
function $f0aae54e49e47103$var$pushProvider(providerFiber, context, nextValue) {
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $f0aae54e49e47103$var$popProvider(context) {
    context._currentValue = $f0aae54e49e47103$var$valueCursor.current;
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$valueCursor);
}
function $f0aae54e49e47103$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $f0aae54e49e47103$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $f0aae54e49e47103$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $f0aae54e49e47103$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $f0aae54e49e47103$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $f0aae54e49e47103$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $f0aae54e49e47103$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($f0aae54e49e47103$var$HostTransitionContext) : current = [
                $f0aae54e49e47103$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $f0aae54e49e47103$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $f0aae54e49e47103$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$f0aae54e49e47103$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $f0aae54e49e47103$var$prepareToReadContext(workInProgress) {
    $f0aae54e49e47103$var$currentlyRenderingFiber$1 = workInProgress;
    $f0aae54e49e47103$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $f0aae54e49e47103$var$readContext(context) {
    return $f0aae54e49e47103$var$readContextForConsumer($f0aae54e49e47103$var$currentlyRenderingFiber$1, context);
}
function $f0aae54e49e47103$var$readContextDuringReconciliation(consumer, context) {
    null === $f0aae54e49e47103$var$currentlyRenderingFiber$1 && $f0aae54e49e47103$var$prepareToReadContext(consumer);
    return $f0aae54e49e47103$var$readContextForConsumer(consumer, context);
}
function $f0aae54e49e47103$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $f0aae54e49e47103$var$lastContextDependency) {
        if (null === consumer) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(308));
        $f0aae54e49e47103$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $f0aae54e49e47103$var$lastContextDependency = $f0aae54e49e47103$var$lastContextDependency.next = context;
    return value;
}
var $f0aae54e49e47103$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $f0aae54e49e47103$var$scheduleCallback$2 = $hDqGr.unstable_scheduleCallback, $f0aae54e49e47103$var$NormalPriority = $hDqGr.unstable_NormalPriority, $f0aae54e49e47103$var$CacheContext = {
    $$typeof: $f0aae54e49e47103$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $f0aae54e49e47103$var$createCache() {
    return {
        controller: new $f0aae54e49e47103$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $f0aae54e49e47103$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $f0aae54e49e47103$var$scheduleCallback$2($f0aae54e49e47103$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $f0aae54e49e47103$var$currentEntangledListeners = null, $f0aae54e49e47103$var$currentEntangledPendingCount = 0, $f0aae54e49e47103$var$currentEntangledLane = 0, $f0aae54e49e47103$var$currentEntangledActionThenable = null;
function $f0aae54e49e47103$var$entangleAsyncAction(transition, thenable) {
    if (null === $f0aae54e49e47103$var$currentEntangledListeners) {
        var entangledListeners = $f0aae54e49e47103$var$currentEntangledListeners = [];
        $f0aae54e49e47103$var$currentEntangledPendingCount = 0;
        $f0aae54e49e47103$var$currentEntangledLane = $f0aae54e49e47103$var$requestTransitionLane();
        $f0aae54e49e47103$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $f0aae54e49e47103$var$currentEntangledPendingCount++;
    thenable.then($f0aae54e49e47103$var$pingEngtangledActionScope, $f0aae54e49e47103$var$pingEngtangledActionScope);
    return thenable;
}
function $f0aae54e49e47103$var$pingEngtangledActionScope() {
    if (0 === --$f0aae54e49e47103$var$currentEntangledPendingCount && null !== $f0aae54e49e47103$var$currentEntangledListeners) {
        null !== $f0aae54e49e47103$var$currentEntangledActionThenable && ($f0aae54e49e47103$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $f0aae54e49e47103$var$currentEntangledListeners;
        $f0aae54e49e47103$var$currentEntangledListeners = null;
        $f0aae54e49e47103$var$currentEntangledLane = 0;
        $f0aae54e49e47103$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $f0aae54e49e47103$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $f0aae54e49e47103$var$prevOnStartTransitionFinish = $f0aae54e49e47103$var$ReactSharedInternals.S;
$f0aae54e49e47103$var$ReactSharedInternals.S = function(transition, returnValue) {
    $f0aae54e49e47103$var$globalMostRecentTransitionTime = $f0aae54e49e47103$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $f0aae54e49e47103$var$entangleAsyncAction(transition, returnValue);
    null !== $f0aae54e49e47103$var$prevOnStartTransitionFinish && $f0aae54e49e47103$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $f0aae54e49e47103$var$resumedCache = $f0aae54e49e47103$var$createCursor(null);
function $f0aae54e49e47103$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $f0aae54e49e47103$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $f0aae54e49e47103$var$workInProgressRoot.pooledCache;
}
function $f0aae54e49e47103$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $f0aae54e49e47103$var$push($f0aae54e49e47103$var$resumedCache, $f0aae54e49e47103$var$resumedCache.current) : $f0aae54e49e47103$var$push($f0aae54e49e47103$var$resumedCache, prevCachePool.pool);
}
function $f0aae54e49e47103$var$getSuspendedCache() {
    var cacheFromPool = $f0aae54e49e47103$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $f0aae54e49e47103$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $f0aae54e49e47103$var$SuspenseException = Error($f0aae54e49e47103$var$formatProdErrorMessage(460)), $f0aae54e49e47103$var$SuspenseyCommitException = Error($f0aae54e49e47103$var$formatProdErrorMessage(474)), $f0aae54e49e47103$var$SuspenseActionException = Error($f0aae54e49e47103$var$formatProdErrorMessage(542)), $f0aae54e49e47103$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $f0aae54e49e47103$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $f0aae54e49e47103$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($f0aae54e49e47103$var$noop$1, $f0aae54e49e47103$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $f0aae54e49e47103$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($f0aae54e49e47103$var$noop$1, $f0aae54e49e47103$var$noop$1);
            else {
                thenableState = $f0aae54e49e47103$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $f0aae54e49e47103$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $f0aae54e49e47103$var$suspendedThenable = thenable;
            throw $f0aae54e49e47103$var$SuspenseException;
    }
}
function $f0aae54e49e47103$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $f0aae54e49e47103$var$suspendedThenable = x, $f0aae54e49e47103$var$SuspenseException;
        throw x;
    }
}
var $f0aae54e49e47103$var$suspendedThenable = null;
function $f0aae54e49e47103$var$getSuspendedThenable() {
    if (null === $f0aae54e49e47103$var$suspendedThenable) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(459));
    var thenable = $f0aae54e49e47103$var$suspendedThenable;
    $f0aae54e49e47103$var$suspendedThenable = null;
    return thenable;
}
function $f0aae54e49e47103$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $f0aae54e49e47103$var$SuspenseException || rejectedReason === $f0aae54e49e47103$var$SuspenseActionException) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(483));
}
var $f0aae54e49e47103$var$thenableState$1 = null, $f0aae54e49e47103$var$thenableIndexCounter$1 = 0;
function $f0aae54e49e47103$var$unwrapThenable(thenable) {
    var index = $f0aae54e49e47103$var$thenableIndexCounter$1;
    $f0aae54e49e47103$var$thenableIndexCounter$1 += 1;
    null === $f0aae54e49e47103$var$thenableState$1 && ($f0aae54e49e47103$var$thenableState$1 = []);
    return $f0aae54e49e47103$var$trackUsedThenable($f0aae54e49e47103$var$thenableState$1, thenable, index);
}
function $f0aae54e49e47103$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $f0aae54e49e47103$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $f0aae54e49e47103$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $f0aae54e49e47103$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $f0aae54e49e47103$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $f0aae54e49e47103$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $f0aae54e49e47103$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $f0aae54e49e47103$var$REACT_LAZY_TYPE && $f0aae54e49e47103$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $f0aae54e49e47103$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $f0aae54e49e47103$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $f0aae54e49e47103$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $f0aae54e49e47103$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $f0aae54e49e47103$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $f0aae54e49e47103$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f0aae54e49e47103$var$REACT_ELEMENT_TYPE:
                    return lanes = $f0aae54e49e47103$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f0aae54e49e47103$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $f0aae54e49e47103$var$REACT_PORTAL_TYPE:
                    return newChild = $f0aae54e49e47103$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $f0aae54e49e47103$var$REACT_LAZY_TYPE:
                    return newChild = $f0aae54e49e47103$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($f0aae54e49e47103$var$isArrayImpl(newChild) || $f0aae54e49e47103$var$getIteratorFn(newChild)) return newChild = $f0aae54e49e47103$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $f0aae54e49e47103$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f0aae54e49e47103$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $f0aae54e49e47103$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f0aae54e49e47103$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f0aae54e49e47103$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $f0aae54e49e47103$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $f0aae54e49e47103$var$REACT_LAZY_TYPE:
                    return newChild = $f0aae54e49e47103$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($f0aae54e49e47103$var$isArrayImpl(newChild) || $f0aae54e49e47103$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $f0aae54e49e47103$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f0aae54e49e47103$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $f0aae54e49e47103$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f0aae54e49e47103$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f0aae54e49e47103$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $f0aae54e49e47103$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $f0aae54e49e47103$var$REACT_LAZY_TYPE:
                    return newChild = $f0aae54e49e47103$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($f0aae54e49e47103$var$isArrayImpl(newChild) || $f0aae54e49e47103$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $f0aae54e49e47103$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f0aae54e49e47103$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $f0aae54e49e47103$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f0aae54e49e47103$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $f0aae54e49e47103$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $f0aae54e49e47103$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $f0aae54e49e47103$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $f0aae54e49e47103$var$REACT_LAZY_TYPE && $f0aae54e49e47103$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $f0aae54e49e47103$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $f0aae54e49e47103$var$REACT_FRAGMENT_TYPE ? (lanes = $f0aae54e49e47103$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $f0aae54e49e47103$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $f0aae54e49e47103$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $f0aae54e49e47103$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $f0aae54e49e47103$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $f0aae54e49e47103$var$REACT_LAZY_TYPE:
                    return newChild = $f0aae54e49e47103$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($f0aae54e49e47103$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($f0aae54e49e47103$var$getIteratorFn(newChild)) {
                key = $f0aae54e49e47103$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f0aae54e49e47103$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $f0aae54e49e47103$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $f0aae54e49e47103$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $f0aae54e49e47103$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $f0aae54e49e47103$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $f0aae54e49e47103$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $f0aae54e49e47103$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $f0aae54e49e47103$var$SuspenseException || x === $f0aae54e49e47103$var$SuspenseActionException) throw x;
            var fiber = $f0aae54e49e47103$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $f0aae54e49e47103$var$reconcileChildFibers = $f0aae54e49e47103$var$createChildReconciler(!0), $f0aae54e49e47103$var$mountChildFibers = $f0aae54e49e47103$var$createChildReconciler(!1), $f0aae54e49e47103$var$hasForceUpdate = !1;
function $f0aae54e49e47103$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $f0aae54e49e47103$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $f0aae54e49e47103$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $f0aae54e49e47103$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($f0aae54e49e47103$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $f0aae54e49e47103$var$getRootForUpdatedFiber(fiber);
        $f0aae54e49e47103$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $f0aae54e49e47103$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $f0aae54e49e47103$var$getRootForUpdatedFiber(fiber);
}
function $f0aae54e49e47103$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $f0aae54e49e47103$var$markRootEntangled(root, lane);
    }
}
function $f0aae54e49e47103$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $f0aae54e49e47103$var$didReadFromEntangledAsyncAction = !1;
function $f0aae54e49e47103$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($f0aae54e49e47103$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $f0aae54e49e47103$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $f0aae54e49e47103$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $f0aae54e49e47103$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $f0aae54e49e47103$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($f0aae54e49e47103$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $f0aae54e49e47103$var$currentEntangledLane && ($f0aae54e49e47103$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $f0aae54e49e47103$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $f0aae54e49e47103$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $f0aae54e49e47103$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $f0aae54e49e47103$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $f0aae54e49e47103$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$f0aae54e49e47103$var$callCallback(callbacks[updateQueue], context);
}
var $f0aae54e49e47103$var$currentTreeHiddenStackCursor = $f0aae54e49e47103$var$createCursor(null), $f0aae54e49e47103$var$prevEntangledRenderLanesCursor = $f0aae54e49e47103$var$createCursor(0);
function $f0aae54e49e47103$var$pushHiddenContext(fiber, context) {
    fiber = $f0aae54e49e47103$var$entangledRenderLanes;
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$prevEntangledRenderLanesCursor, fiber);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$currentTreeHiddenStackCursor, context);
    $f0aae54e49e47103$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $f0aae54e49e47103$var$reuseHiddenContextOnStack() {
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$prevEntangledRenderLanesCursor, $f0aae54e49e47103$var$entangledRenderLanes);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$currentTreeHiddenStackCursor, $f0aae54e49e47103$var$currentTreeHiddenStackCursor.current);
}
function $f0aae54e49e47103$var$popHiddenContext() {
    $f0aae54e49e47103$var$entangledRenderLanes = $f0aae54e49e47103$var$prevEntangledRenderLanesCursor.current;
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$currentTreeHiddenStackCursor);
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$prevEntangledRenderLanesCursor);
}
var $f0aae54e49e47103$var$suspenseHandlerStackCursor = $f0aae54e49e47103$var$createCursor(null), $f0aae54e49e47103$var$shellBoundary = null;
function $f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, $f0aae54e49e47103$var$suspenseStackCursor.current & 1);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseHandlerStackCursor, handler);
    null === $f0aae54e49e47103$var$shellBoundary && (null === current || null !== $f0aae54e49e47103$var$currentTreeHiddenStackCursor.current ? $f0aae54e49e47103$var$shellBoundary = handler : null !== current.memoizedState && ($f0aae54e49e47103$var$shellBoundary = handler));
}
function $f0aae54e49e47103$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, $f0aae54e49e47103$var$suspenseStackCursor.current);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseHandlerStackCursor, fiber);
    null === $f0aae54e49e47103$var$shellBoundary && ($f0aae54e49e47103$var$shellBoundary = fiber);
}
function $f0aae54e49e47103$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, $f0aae54e49e47103$var$suspenseStackCursor.current), $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseHandlerStackCursor, fiber), null === $f0aae54e49e47103$var$shellBoundary && ($f0aae54e49e47103$var$shellBoundary = fiber)) : $f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(fiber);
}
function $f0aae54e49e47103$var$reuseSuspenseHandlerOnStack() {
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, $f0aae54e49e47103$var$suspenseStackCursor.current);
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseHandlerStackCursor, $f0aae54e49e47103$var$suspenseHandlerStackCursor.current);
}
function $f0aae54e49e47103$var$popSuspenseHandler(fiber) {
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$suspenseHandlerStackCursor);
    $f0aae54e49e47103$var$shellBoundary === fiber && ($f0aae54e49e47103$var$shellBoundary = null);
    $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$suspenseStackCursor);
}
var $f0aae54e49e47103$var$suspenseStackCursor = $f0aae54e49e47103$var$createCursor(0);
function $f0aae54e49e47103$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $f0aae54e49e47103$var$isSuspenseInstancePending(state) || $f0aae54e49e47103$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $f0aae54e49e47103$var$renderLanes = 0, $f0aae54e49e47103$var$currentlyRenderingFiber = null, $f0aae54e49e47103$var$currentHook = null, $f0aae54e49e47103$var$workInProgressHook = null, $f0aae54e49e47103$var$didScheduleRenderPhaseUpdate = !1, $f0aae54e49e47103$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $f0aae54e49e47103$var$localIdCounter = 0, $f0aae54e49e47103$var$thenableIndexCounter = 0, $f0aae54e49e47103$var$thenableState = null, $f0aae54e49e47103$var$globalClientIdCounter = 0;
function $f0aae54e49e47103$var$throwInvalidHookError() {
    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(321));
}
function $f0aae54e49e47103$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$f0aae54e49e47103$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $f0aae54e49e47103$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $f0aae54e49e47103$var$renderLanes = nextRenderLanes;
    $f0aae54e49e47103$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $f0aae54e49e47103$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $f0aae54e49e47103$var$HooksDispatcherOnMount : $f0aae54e49e47103$var$HooksDispatcherOnUpdate;
    $f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $f0aae54e49e47103$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $f0aae54e49e47103$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $f0aae54e49e47103$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $f0aae54e49e47103$var$finishRenderingHooks(current) {
    $f0aae54e49e47103$var$ReactSharedInternals.H = $f0aae54e49e47103$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $f0aae54e49e47103$var$currentHook && null !== $f0aae54e49e47103$var$currentHook.next;
    $f0aae54e49e47103$var$renderLanes = 0;
    $f0aae54e49e47103$var$workInProgressHook = $f0aae54e49e47103$var$currentHook = $f0aae54e49e47103$var$currentlyRenderingFiber = null;
    $f0aae54e49e47103$var$didScheduleRenderPhaseUpdate = !1;
    $f0aae54e49e47103$var$thenableIndexCounter = 0;
    $f0aae54e49e47103$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(300));
    null === current || $f0aae54e49e47103$var$didReceiveUpdate || (current = current.dependencies, null !== current && $f0aae54e49e47103$var$checkIfContextChanged(current) && ($f0aae54e49e47103$var$didReceiveUpdate = !0));
}
function $f0aae54e49e47103$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $f0aae54e49e47103$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $f0aae54e49e47103$var$didScheduleRenderPhaseUpdateDuringThisPass && ($f0aae54e49e47103$var$thenableState = null);
        $f0aae54e49e47103$var$thenableIndexCounter = 0;
        $f0aae54e49e47103$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $f0aae54e49e47103$var$workInProgressHook = $f0aae54e49e47103$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $f0aae54e49e47103$var$ReactSharedInternals.H = $f0aae54e49e47103$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($f0aae54e49e47103$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $f0aae54e49e47103$var$TransitionAwareHostComponent() {
    var dispatcher = $f0aae54e49e47103$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $f0aae54e49e47103$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $f0aae54e49e47103$var$currentHook ? $f0aae54e49e47103$var$currentHook.memoizedState : null) !== dispatcher && ($f0aae54e49e47103$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $f0aae54e49e47103$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $f0aae54e49e47103$var$localIdCounter;
    $f0aae54e49e47103$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $f0aae54e49e47103$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $f0aae54e49e47103$var$resetHooksOnUnwind(workInProgress) {
    if ($f0aae54e49e47103$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $f0aae54e49e47103$var$didScheduleRenderPhaseUpdate = !1;
    }
    $f0aae54e49e47103$var$renderLanes = 0;
    $f0aae54e49e47103$var$workInProgressHook = $f0aae54e49e47103$var$currentHook = $f0aae54e49e47103$var$currentlyRenderingFiber = null;
    $f0aae54e49e47103$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $f0aae54e49e47103$var$thenableIndexCounter = $f0aae54e49e47103$var$localIdCounter = 0;
    $f0aae54e49e47103$var$thenableState = null;
}
function $f0aae54e49e47103$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $f0aae54e49e47103$var$workInProgressHook ? $f0aae54e49e47103$var$currentlyRenderingFiber.memoizedState = $f0aae54e49e47103$var$workInProgressHook = hook : $f0aae54e49e47103$var$workInProgressHook = $f0aae54e49e47103$var$workInProgressHook.next = hook;
    return $f0aae54e49e47103$var$workInProgressHook;
}
function $f0aae54e49e47103$var$updateWorkInProgressHook() {
    if (null === $f0aae54e49e47103$var$currentHook) {
        var nextCurrentHook = $f0aae54e49e47103$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $f0aae54e49e47103$var$currentHook.next;
    var nextWorkInProgressHook = null === $f0aae54e49e47103$var$workInProgressHook ? $f0aae54e49e47103$var$currentlyRenderingFiber.memoizedState : $f0aae54e49e47103$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $f0aae54e49e47103$var$workInProgressHook = nextWorkInProgressHook, $f0aae54e49e47103$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $f0aae54e49e47103$var$currentlyRenderingFiber.alternate) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(467));
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(310));
        }
        $f0aae54e49e47103$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $f0aae54e49e47103$var$currentHook.memoizedState,
            baseState: $f0aae54e49e47103$var$currentHook.baseState,
            baseQueue: $f0aae54e49e47103$var$currentHook.baseQueue,
            queue: $f0aae54e49e47103$var$currentHook.queue,
            next: null
        };
        null === $f0aae54e49e47103$var$workInProgressHook ? $f0aae54e49e47103$var$currentlyRenderingFiber.memoizedState = $f0aae54e49e47103$var$workInProgressHook = nextCurrentHook : $f0aae54e49e47103$var$workInProgressHook = $f0aae54e49e47103$var$workInProgressHook.next = nextCurrentHook;
    }
    return $f0aae54e49e47103$var$workInProgressHook;
}
function $f0aae54e49e47103$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $f0aae54e49e47103$var$useThenable(thenable) {
    var index = $f0aae54e49e47103$var$thenableIndexCounter;
    $f0aae54e49e47103$var$thenableIndexCounter += 1;
    null === $f0aae54e49e47103$var$thenableState && ($f0aae54e49e47103$var$thenableState = []);
    thenable = $f0aae54e49e47103$var$trackUsedThenable($f0aae54e49e47103$var$thenableState, thenable, index);
    index = $f0aae54e49e47103$var$currentlyRenderingFiber;
    null === (null === $f0aae54e49e47103$var$workInProgressHook ? index.memoizedState : $f0aae54e49e47103$var$workInProgressHook.next) && (index = index.alternate, $f0aae54e49e47103$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $f0aae54e49e47103$var$HooksDispatcherOnMount : $f0aae54e49e47103$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $f0aae54e49e47103$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $f0aae54e49e47103$var$useThenable(usable);
        if (usable.$$typeof === $f0aae54e49e47103$var$REACT_CONTEXT_TYPE) return $f0aae54e49e47103$var$readContext(usable);
    }
    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(438, String(usable)));
}
function $f0aae54e49e47103$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $f0aae54e49e47103$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $f0aae54e49e47103$var$createFunctionComponentUpdateQueue(), $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $f0aae54e49e47103$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $f0aae54e49e47103$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $f0aae54e49e47103$var$updateReducer(reducer) {
    var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
    return $f0aae54e49e47103$var$updateReducerImpl(hook, $f0aae54e49e47103$var$currentHook, reducer);
}
function $f0aae54e49e47103$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($f0aae54e49e47103$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($f0aae54e49e47103$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $f0aae54e49e47103$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($f0aae54e49e47103$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $f0aae54e49e47103$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $f0aae54e49e47103$var$currentlyRenderingFiber.lanes |= revertLane, $f0aae54e49e47103$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $f0aae54e49e47103$var$currentlyRenderingFiber.lanes |= updateLane, $f0aae54e49e47103$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$f0aae54e49e47103$var$objectIs(pendingQueue, hook.memoizedState) && ($f0aae54e49e47103$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $f0aae54e49e47103$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $f0aae54e49e47103$var$rerenderReducer(reducer) {
    var hook = $f0aae54e49e47103$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $f0aae54e49e47103$var$objectIs(newState, hook.memoizedState) || ($f0aae54e49e47103$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $f0aae54e49e47103$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $f0aae54e49e47103$var$currentlyRenderingFiber, hook = $f0aae54e49e47103$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $f0aae54e49e47103$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$f0aae54e49e47103$var$objectIs(($f0aae54e49e47103$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $f0aae54e49e47103$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $f0aae54e49e47103$var$updateEffect($f0aae54e49e47103$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $f0aae54e49e47103$var$workInProgressHook && $f0aae54e49e47103$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $f0aae54e49e47103$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f0aae54e49e47103$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $f0aae54e49e47103$var$workInProgressRoot) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($f0aae54e49e47103$var$renderLanes & 127) || $f0aae54e49e47103$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $f0aae54e49e47103$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $f0aae54e49e47103$var$createFunctionComponentUpdateQueue(), $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $f0aae54e49e47103$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $f0aae54e49e47103$var$checkIfSnapshotChanged(inst) && $f0aae54e49e47103$var$forceStoreRerender(fiber);
}
function $f0aae54e49e47103$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $f0aae54e49e47103$var$checkIfSnapshotChanged(inst) && $f0aae54e49e47103$var$forceStoreRerender(fiber);
    });
}
function $f0aae54e49e47103$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$f0aae54e49e47103$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $f0aae54e49e47103$var$forceStoreRerender(fiber) {
    var root = $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $f0aae54e49e47103$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $f0aae54e49e47103$var$mountStateImpl(initialState) {
    var hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f0aae54e49e47103$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $f0aae54e49e47103$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f0aae54e49e47103$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $f0aae54e49e47103$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $f0aae54e49e47103$var$updateReducerImpl(hook, $f0aae54e49e47103$var$currentHook, "function" === typeof reducer ? reducer : $f0aae54e49e47103$var$basicStateReducer);
}
function $f0aae54e49e47103$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($f0aae54e49e47103$var$isRenderPhaseUpdate(fiber)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $f0aae54e49e47103$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $f0aae54e49e47103$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $f0aae54e49e47103$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $f0aae54e49e47103$var$ReactSharedInternals.T, currentTransition = {};
        $f0aae54e49e47103$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $f0aae54e49e47103$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $f0aae54e49e47103$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $f0aae54e49e47103$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f0aae54e49e47103$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $f0aae54e49e47103$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $f0aae54e49e47103$var$onActionError(actionQueue, node, error$66);
    }
}
function $f0aae54e49e47103$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $f0aae54e49e47103$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $f0aae54e49e47103$var$onActionError(actionQueue, node, error);
    }) : $f0aae54e49e47103$var$onActionSuccess(actionQueue, node, returnValue);
}
function $f0aae54e49e47103$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $f0aae54e49e47103$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $f0aae54e49e47103$var$runActionStateAction(actionQueue, nextState)));
}
function $f0aae54e49e47103$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $f0aae54e49e47103$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $f0aae54e49e47103$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $f0aae54e49e47103$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $f0aae54e49e47103$var$mountActionState(action, initialStateProp) {
    if ($f0aae54e49e47103$var$isHydrating) {
        var ssrFormState = $f0aae54e49e47103$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $f0aae54e49e47103$var$currentlyRenderingFiber;
                if ($f0aae54e49e47103$var$isHydrating) {
                    if ($f0aae54e49e47103$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $f0aae54e49e47103$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $f0aae54e49e47103$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $f0aae54e49e47103$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $f0aae54e49e47103$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $f0aae54e49e47103$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $f0aae54e49e47103$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $f0aae54e49e47103$var$dispatchSetState.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $f0aae54e49e47103$var$mountStateImpl(!1);
    inRootOrSingleton = $f0aae54e49e47103$var$dispatchOptimisticSetState.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $f0aae54e49e47103$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $f0aae54e49e47103$var$dispatchActionState.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $f0aae54e49e47103$var$updateActionState(action) {
    var stateHook = $f0aae54e49e47103$var$updateWorkInProgressHook();
    return $f0aae54e49e47103$var$updateActionStateImpl(stateHook, $f0aae54e49e47103$var$currentHook, action);
}
function $f0aae54e49e47103$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $f0aae54e49e47103$var$updateReducerImpl(stateHook, currentStateHook, $f0aae54e49e47103$var$actionStateReducer)[0];
    stateHook = $f0aae54e49e47103$var$updateReducer($f0aae54e49e47103$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $f0aae54e49e47103$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $f0aae54e49e47103$var$SuspenseException) throw $f0aae54e49e47103$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $f0aae54e49e47103$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($f0aae54e49e47103$var$currentlyRenderingFiber.flags |= 2048, $f0aae54e49e47103$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $f0aae54e49e47103$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $f0aae54e49e47103$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $f0aae54e49e47103$var$rerenderActionState(action) {
    var stateHook = $f0aae54e49e47103$var$updateWorkInProgressHook(), currentStateHook = $f0aae54e49e47103$var$currentHook;
    if (null !== currentStateHook) return $f0aae54e49e47103$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $f0aae54e49e47103$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $f0aae54e49e47103$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $f0aae54e49e47103$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $f0aae54e49e47103$var$createFunctionComponentUpdateQueue(), $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $f0aae54e49e47103$var$updateRef() {
    return $f0aae54e49e47103$var$updateWorkInProgressHook().memoizedState;
}
function $f0aae54e49e47103$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
    $f0aae54e49e47103$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $f0aae54e49e47103$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $f0aae54e49e47103$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $f0aae54e49e47103$var$currentHook && null !== deps && $f0aae54e49e47103$var$areHookInputsEqual(deps, $f0aae54e49e47103$var$currentHook.memoizedState.deps) ? hook.memoizedState = $f0aae54e49e47103$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($f0aae54e49e47103$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $f0aae54e49e47103$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $f0aae54e49e47103$var$mountEffect(create, deps) {
    $f0aae54e49e47103$var$mountEffectImpl(8390656, 8, create, deps);
}
function $f0aae54e49e47103$var$updateEffect(create, deps) {
    $f0aae54e49e47103$var$updateEffectImpl(2048, 8, create, deps);
}
function $f0aae54e49e47103$var$useEffectEventImpl(payload) {
    $f0aae54e49e47103$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $f0aae54e49e47103$var$createFunctionComponentUpdateQueue(), $f0aae54e49e47103$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $f0aae54e49e47103$var$updateEvent(callback) {
    var ref = $f0aae54e49e47103$var$updateWorkInProgressHook().memoizedState;
    $f0aae54e49e47103$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($f0aae54e49e47103$var$executionContext & 2)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $f0aae54e49e47103$var$updateInsertionEffect(create, deps) {
    return $f0aae54e49e47103$var$updateEffectImpl(4, 2, create, deps);
}
function $f0aae54e49e47103$var$updateLayoutEffect(create, deps) {
    return $f0aae54e49e47103$var$updateEffectImpl(4, 4, create, deps);
}
function $f0aae54e49e47103$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $f0aae54e49e47103$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $f0aae54e49e47103$var$updateEffectImpl(4, 4, $f0aae54e49e47103$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $f0aae54e49e47103$var$mountDebugValue() {}
function $f0aae54e49e47103$var$updateCallback(callback, deps) {
    var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f0aae54e49e47103$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $f0aae54e49e47103$var$updateMemo(nextCreate, deps) {
    var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $f0aae54e49e47103$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $f0aae54e49e47103$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $f0aae54e49e47103$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $f0aae54e49e47103$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($f0aae54e49e47103$var$renderLanes & 1073741824) && 0 === ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $f0aae54e49e47103$var$requestDeferredLane();
    $f0aae54e49e47103$var$currentlyRenderingFiber.lanes |= hook;
    $f0aae54e49e47103$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $f0aae54e49e47103$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($f0aae54e49e47103$var$objectIs(value, prevValue)) return value;
    if (null !== $f0aae54e49e47103$var$currentTreeHiddenStackCursor.current) return hook = $f0aae54e49e47103$var$mountDeferredValueImpl(hook, value, initialValue), $f0aae54e49e47103$var$objectIs(hook, prevValue) || ($f0aae54e49e47103$var$didReceiveUpdate = !0), hook;
    if (0 === ($f0aae54e49e47103$var$renderLanes & 42) || 0 !== ($f0aae54e49e47103$var$renderLanes & 1073741824) && 0 === ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 261930)) return $f0aae54e49e47103$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $f0aae54e49e47103$var$requestDeferredLane();
    $f0aae54e49e47103$var$currentlyRenderingFiber.lanes |= hook;
    $f0aae54e49e47103$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $f0aae54e49e47103$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
    $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $f0aae54e49e47103$var$ReactSharedInternals.T, currentTransition = {};
    $f0aae54e49e47103$var$ReactSharedInternals.T = currentTransition;
    $f0aae54e49e47103$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $f0aae54e49e47103$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $f0aae54e49e47103$var$chainThenableValue(returnValue, finishedState);
            $f0aae54e49e47103$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $f0aae54e49e47103$var$requestUpdateLane(fiber));
        } else $f0aae54e49e47103$var$dispatchSetStateInternal(fiber, queue, finishedState, $f0aae54e49e47103$var$requestUpdateLane(fiber));
    } catch (error) {
        $f0aae54e49e47103$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $f0aae54e49e47103$var$requestUpdateLane());
    } finally{
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $f0aae54e49e47103$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f0aae54e49e47103$var$noop() {}
function $f0aae54e49e47103$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(476));
    var queue = $f0aae54e49e47103$var$ensureFormComponentIsStateful(formFiber).queue;
    $f0aae54e49e47103$var$startTransition(formFiber, queue, pendingState, $f0aae54e49e47103$var$sharedNotPendingObject, null === action ? $f0aae54e49e47103$var$noop : function() {
        $f0aae54e49e47103$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $f0aae54e49e47103$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $f0aae54e49e47103$var$sharedNotPendingObject,
        baseState: $f0aae54e49e47103$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f0aae54e49e47103$var$basicStateReducer,
            lastRenderedState: $f0aae54e49e47103$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $f0aae54e49e47103$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $f0aae54e49e47103$var$requestFormReset$1(formFiber) {
    var stateHook = $f0aae54e49e47103$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $f0aae54e49e47103$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $f0aae54e49e47103$var$requestUpdateLane());
}
function $f0aae54e49e47103$var$useHostTransitionStatus() {
    return $f0aae54e49e47103$var$readContext($f0aae54e49e47103$var$HostTransitionContext);
}
function $f0aae54e49e47103$var$updateId() {
    return $f0aae54e49e47103$var$updateWorkInProgressHook().memoizedState;
}
function $f0aae54e49e47103$var$updateRefresh() {
    return $f0aae54e49e47103$var$updateWorkInProgressHook().memoizedState;
}
function $f0aae54e49e47103$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $f0aae54e49e47103$var$requestUpdateLane();
                fiber = $f0aae54e49e47103$var$createUpdate(lane);
                var root$69 = $f0aae54e49e47103$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($f0aae54e49e47103$var$scheduleUpdateOnFiber(root$69, provider, lane), $f0aae54e49e47103$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $f0aae54e49e47103$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $f0aae54e49e47103$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $f0aae54e49e47103$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $f0aae54e49e47103$var$isRenderPhaseUpdate(fiber) ? $f0aae54e49e47103$var$enqueueRenderPhaseUpdate(queue, action) : (action = $f0aae54e49e47103$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($f0aae54e49e47103$var$scheduleUpdateOnFiber(action, fiber, lane), $f0aae54e49e47103$var$entangleTransitionUpdate(action, queue, lane)));
}
function $f0aae54e49e47103$var$dispatchSetState(fiber, queue, action) {
    var lane = $f0aae54e49e47103$var$requestUpdateLane();
    $f0aae54e49e47103$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $f0aae54e49e47103$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f0aae54e49e47103$var$isRenderPhaseUpdate(fiber)) $f0aae54e49e47103$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($f0aae54e49e47103$var$objectIs(eagerState, currentState)) return $f0aae54e49e47103$var$enqueueUpdate$1(fiber, queue, update, 0), null === $f0aae54e49e47103$var$workInProgressRoot && $f0aae54e49e47103$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $f0aae54e49e47103$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $f0aae54e49e47103$var$scheduleUpdateOnFiber(action, fiber, lane), $f0aae54e49e47103$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $f0aae54e49e47103$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $f0aae54e49e47103$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($f0aae54e49e47103$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $f0aae54e49e47103$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $f0aae54e49e47103$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $f0aae54e49e47103$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $f0aae54e49e47103$var$currentlyRenderingFiber || null !== alternate && alternate === $f0aae54e49e47103$var$currentlyRenderingFiber;
}
function $f0aae54e49e47103$var$enqueueRenderPhaseUpdate(queue, update) {
    $f0aae54e49e47103$var$didScheduleRenderPhaseUpdateDuringThisPass = $f0aae54e49e47103$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $f0aae54e49e47103$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $f0aae54e49e47103$var$markRootEntangled(root, lane);
    }
}
var $f0aae54e49e47103$var$ContextOnlyDispatcher = {
    readContext: $f0aae54e49e47103$var$readContext,
    use: $f0aae54e49e47103$var$use,
    useCallback: $f0aae54e49e47103$var$throwInvalidHookError,
    useContext: $f0aae54e49e47103$var$throwInvalidHookError,
    useEffect: $f0aae54e49e47103$var$throwInvalidHookError,
    useImperativeHandle: $f0aae54e49e47103$var$throwInvalidHookError,
    useLayoutEffect: $f0aae54e49e47103$var$throwInvalidHookError,
    useInsertionEffect: $f0aae54e49e47103$var$throwInvalidHookError,
    useMemo: $f0aae54e49e47103$var$throwInvalidHookError,
    useReducer: $f0aae54e49e47103$var$throwInvalidHookError,
    useRef: $f0aae54e49e47103$var$throwInvalidHookError,
    useState: $f0aae54e49e47103$var$throwInvalidHookError,
    useDebugValue: $f0aae54e49e47103$var$throwInvalidHookError,
    useDeferredValue: $f0aae54e49e47103$var$throwInvalidHookError,
    useTransition: $f0aae54e49e47103$var$throwInvalidHookError,
    useSyncExternalStore: $f0aae54e49e47103$var$throwInvalidHookError,
    useId: $f0aae54e49e47103$var$throwInvalidHookError,
    useHostTransitionStatus: $f0aae54e49e47103$var$throwInvalidHookError,
    useFormState: $f0aae54e49e47103$var$throwInvalidHookError,
    useActionState: $f0aae54e49e47103$var$throwInvalidHookError,
    useOptimistic: $f0aae54e49e47103$var$throwInvalidHookError,
    useMemoCache: $f0aae54e49e47103$var$throwInvalidHookError,
    useCacheRefresh: $f0aae54e49e47103$var$throwInvalidHookError
};
$f0aae54e49e47103$var$ContextOnlyDispatcher.useEffectEvent = $f0aae54e49e47103$var$throwInvalidHookError;
var $f0aae54e49e47103$var$HooksDispatcherOnMount = {
    readContext: $f0aae54e49e47103$var$readContext,
    use: $f0aae54e49e47103$var$use,
    useCallback: function(callback, deps) {
        $f0aae54e49e47103$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $f0aae54e49e47103$var$readContext,
    useEffect: $f0aae54e49e47103$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $f0aae54e49e47103$var$mountEffectImpl(4194308, 4, $f0aae54e49e47103$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $f0aae54e49e47103$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $f0aae54e49e47103$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $f0aae54e49e47103$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $f0aae54e49e47103$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($f0aae54e49e47103$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $f0aae54e49e47103$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $f0aae54e49e47103$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $f0aae54e49e47103$var$dispatchReducerAction.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $f0aae54e49e47103$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $f0aae54e49e47103$var$dispatchSetState.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $f0aae54e49e47103$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
        return $f0aae54e49e47103$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $f0aae54e49e47103$var$mountStateImpl(!1);
        stateHook = $f0aae54e49e47103$var$startTransition.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $f0aae54e49e47103$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $f0aae54e49e47103$var$currentlyRenderingFiber, hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
        if ($f0aae54e49e47103$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $f0aae54e49e47103$var$workInProgressRoot) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(349));
            0 !== ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 127) || $f0aae54e49e47103$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $f0aae54e49e47103$var$mountEffect($f0aae54e49e47103$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $f0aae54e49e47103$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $f0aae54e49e47103$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $f0aae54e49e47103$var$mountWorkInProgressHook(), identifierPrefix = $f0aae54e49e47103$var$workInProgressRoot.identifierPrefix;
        if ($f0aae54e49e47103$var$isHydrating) {
            var JSCompiler_inline_result = $f0aae54e49e47103$var$treeContextOverflow;
            var idWithLeadingBit = $f0aae54e49e47103$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $f0aae54e49e47103$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $f0aae54e49e47103$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $f0aae54e49e47103$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $f0aae54e49e47103$var$useHostTransitionStatus,
    useFormState: $f0aae54e49e47103$var$mountActionState,
    useActionState: $f0aae54e49e47103$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $f0aae54e49e47103$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $f0aae54e49e47103$var$dispatchOptimisticSetState.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $f0aae54e49e47103$var$useMemoCache,
    useCacheRefresh: function() {
        return $f0aae54e49e47103$var$mountWorkInProgressHook().memoizedState = $f0aae54e49e47103$var$refreshCache.bind(null, $f0aae54e49e47103$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $f0aae54e49e47103$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($f0aae54e49e47103$var$executionContext & 2)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $f0aae54e49e47103$var$HooksDispatcherOnUpdate = {
    readContext: $f0aae54e49e47103$var$readContext,
    use: $f0aae54e49e47103$var$use,
    useCallback: $f0aae54e49e47103$var$updateCallback,
    useContext: $f0aae54e49e47103$var$readContext,
    useEffect: $f0aae54e49e47103$var$updateEffect,
    useImperativeHandle: $f0aae54e49e47103$var$updateImperativeHandle,
    useInsertionEffect: $f0aae54e49e47103$var$updateInsertionEffect,
    useLayoutEffect: $f0aae54e49e47103$var$updateLayoutEffect,
    useMemo: $f0aae54e49e47103$var$updateMemo,
    useReducer: $f0aae54e49e47103$var$updateReducer,
    useRef: $f0aae54e49e47103$var$updateRef,
    useState: function() {
        return $f0aae54e49e47103$var$updateReducer($f0aae54e49e47103$var$basicStateReducer);
    },
    useDebugValue: $f0aae54e49e47103$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
        return $f0aae54e49e47103$var$updateDeferredValueImpl(hook, $f0aae54e49e47103$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f0aae54e49e47103$var$updateReducer($f0aae54e49e47103$var$basicStateReducer)[0], start = $f0aae54e49e47103$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f0aae54e49e47103$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f0aae54e49e47103$var$updateSyncExternalStore,
    useId: $f0aae54e49e47103$var$updateId,
    useHostTransitionStatus: $f0aae54e49e47103$var$useHostTransitionStatus,
    useFormState: $f0aae54e49e47103$var$updateActionState,
    useActionState: $f0aae54e49e47103$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
        return $f0aae54e49e47103$var$updateOptimisticImpl(hook, $f0aae54e49e47103$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $f0aae54e49e47103$var$useMemoCache,
    useCacheRefresh: $f0aae54e49e47103$var$updateRefresh
};
$f0aae54e49e47103$var$HooksDispatcherOnUpdate.useEffectEvent = $f0aae54e49e47103$var$updateEvent;
var $f0aae54e49e47103$var$HooksDispatcherOnRerender = {
    readContext: $f0aae54e49e47103$var$readContext,
    use: $f0aae54e49e47103$var$use,
    useCallback: $f0aae54e49e47103$var$updateCallback,
    useContext: $f0aae54e49e47103$var$readContext,
    useEffect: $f0aae54e49e47103$var$updateEffect,
    useImperativeHandle: $f0aae54e49e47103$var$updateImperativeHandle,
    useInsertionEffect: $f0aae54e49e47103$var$updateInsertionEffect,
    useLayoutEffect: $f0aae54e49e47103$var$updateLayoutEffect,
    useMemo: $f0aae54e49e47103$var$updateMemo,
    useReducer: $f0aae54e49e47103$var$rerenderReducer,
    useRef: $f0aae54e49e47103$var$updateRef,
    useState: function() {
        return $f0aae54e49e47103$var$rerenderReducer($f0aae54e49e47103$var$basicStateReducer);
    },
    useDebugValue: $f0aae54e49e47103$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
        return null === $f0aae54e49e47103$var$currentHook ? $f0aae54e49e47103$var$mountDeferredValueImpl(hook, value, initialValue) : $f0aae54e49e47103$var$updateDeferredValueImpl(hook, $f0aae54e49e47103$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $f0aae54e49e47103$var$rerenderReducer($f0aae54e49e47103$var$basicStateReducer)[0], start = $f0aae54e49e47103$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $f0aae54e49e47103$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $f0aae54e49e47103$var$updateSyncExternalStore,
    useId: $f0aae54e49e47103$var$updateId,
    useHostTransitionStatus: $f0aae54e49e47103$var$useHostTransitionStatus,
    useFormState: $f0aae54e49e47103$var$rerenderActionState,
    useActionState: $f0aae54e49e47103$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $f0aae54e49e47103$var$updateWorkInProgressHook();
        if (null !== $f0aae54e49e47103$var$currentHook) return $f0aae54e49e47103$var$updateOptimisticImpl(hook, $f0aae54e49e47103$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $f0aae54e49e47103$var$useMemoCache,
    useCacheRefresh: $f0aae54e49e47103$var$updateRefresh
};
$f0aae54e49e47103$var$HooksDispatcherOnRerender.useEffectEvent = $f0aae54e49e47103$var$updateEvent;
function $f0aae54e49e47103$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $f0aae54e49e47103$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $f0aae54e49e47103$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f0aae54e49e47103$var$requestUpdateLane(), update = $f0aae54e49e47103$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f0aae54e49e47103$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f0aae54e49e47103$var$scheduleUpdateOnFiber(payload, inst, lane), $f0aae54e49e47103$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $f0aae54e49e47103$var$requestUpdateLane(), update = $f0aae54e49e47103$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $f0aae54e49e47103$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($f0aae54e49e47103$var$scheduleUpdateOnFiber(payload, inst, lane), $f0aae54e49e47103$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $f0aae54e49e47103$var$requestUpdateLane(), update = $f0aae54e49e47103$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $f0aae54e49e47103$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($f0aae54e49e47103$var$scheduleUpdateOnFiber(callback, inst, lane), $f0aae54e49e47103$var$entangleTransitions(callback, inst, lane));
    }
};
function $f0aae54e49e47103$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$f0aae54e49e47103$var$shallowEqual(oldProps, newProps) || !$f0aae54e49e47103$var$shallowEqual(oldState, newState) : !0;
}
function $f0aae54e49e47103$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $f0aae54e49e47103$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $f0aae54e49e47103$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $f0aae54e49e47103$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $f0aae54e49e47103$var$defaultOnUncaughtError(error) {
    $f0aae54e49e47103$var$reportGlobalError(error);
}
function $f0aae54e49e47103$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $f0aae54e49e47103$var$defaultOnRecoverableError(error) {
    $f0aae54e49e47103$var$reportGlobalError(error);
}
function $f0aae54e49e47103$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $f0aae54e49e47103$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $f0aae54e49e47103$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $f0aae54e49e47103$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $f0aae54e49e47103$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $f0aae54e49e47103$var$createClassErrorUpdate(lane) {
    lane = $f0aae54e49e47103$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $f0aae54e49e47103$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $f0aae54e49e47103$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $f0aae54e49e47103$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed ? $f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $f0aae54e49e47103$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $f0aae54e49e47103$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $f0aae54e49e47103$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $f0aae54e49e47103$var$shellBoundary ? $f0aae54e49e47103$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $f0aae54e49e47103$var$workInProgressRootExitStatus && ($f0aae54e49e47103$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $f0aae54e49e47103$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $f0aae54e49e47103$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $f0aae54e49e47103$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $f0aae54e49e47103$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $f0aae54e49e47103$var$attachPingListener(root, value, rootRenderLanes);
        $f0aae54e49e47103$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($f0aae54e49e47103$var$isHydrating) return returnFiber = $f0aae54e49e47103$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $f0aae54e49e47103$var$HydrationMismatchException && (root = Error($f0aae54e49e47103$var$formatProdErrorMessage(422), {
        cause: value
    }), $f0aae54e49e47103$var$queueHydrationError($f0aae54e49e47103$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $f0aae54e49e47103$var$HydrationMismatchException && (returnFiber = Error($f0aae54e49e47103$var$formatProdErrorMessage(423), {
        cause: value
    }), $f0aae54e49e47103$var$queueHydrationError($f0aae54e49e47103$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $f0aae54e49e47103$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $f0aae54e49e47103$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $f0aae54e49e47103$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $f0aae54e49e47103$var$workInProgressRootExitStatus && ($f0aae54e49e47103$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($f0aae54e49e47103$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $f0aae54e49e47103$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $f0aae54e49e47103$var$workInProgressRootConcurrentErrors ? $f0aae54e49e47103$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $f0aae54e49e47103$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $f0aae54e49e47103$var$workInProgressRootExitStatus && ($f0aae54e49e47103$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $f0aae54e49e47103$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $f0aae54e49e47103$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $f0aae54e49e47103$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed || !$f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $f0aae54e49e47103$var$createClassErrorUpdate(rootRenderLanes), $f0aae54e49e47103$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $f0aae54e49e47103$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $f0aae54e49e47103$var$SelectiveHydrationException = Error($f0aae54e49e47103$var$formatProdErrorMessage(461)), $f0aae54e49e47103$var$didReceiveUpdate = !1;
function $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $f0aae54e49e47103$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $f0aae54e49e47103$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $f0aae54e49e47103$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $f0aae54e49e47103$var$prepareToReadContext(workInProgress);
    nextProps = $f0aae54e49e47103$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $f0aae54e49e47103$var$checkDidRenderIdHook();
    if (null !== current && !$f0aae54e49e47103$var$didReceiveUpdate) return $f0aae54e49e47103$var$bailoutHooks(current, workInProgress, renderLanes), $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f0aae54e49e47103$var$isHydrating && key && $f0aae54e49e47103$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f0aae54e49e47103$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$f0aae54e49e47103$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $f0aae54e49e47103$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $f0aae54e49e47103$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$f0aae54e49e47103$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $f0aae54e49e47103$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $f0aae54e49e47103$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $f0aae54e49e47103$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($f0aae54e49e47103$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($f0aae54e49e47103$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $f0aae54e49e47103$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($f0aae54e49e47103$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $f0aae54e49e47103$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $f0aae54e49e47103$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $f0aae54e49e47103$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $f0aae54e49e47103$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $f0aae54e49e47103$var$pushHiddenContext(workInProgress, prevState) : $f0aae54e49e47103$var$reuseHiddenContextOnStack(), $f0aae54e49e47103$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $f0aae54e49e47103$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($f0aae54e49e47103$var$pushTransition(workInProgress, prevState.cachePool), $f0aae54e49e47103$var$pushHiddenContext(workInProgress, prevState), $f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $f0aae54e49e47103$var$pushTransition(workInProgress, null), $f0aae54e49e47103$var$reuseHiddenContextOnStack(), $f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(workInProgress));
    $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $f0aae54e49e47103$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $f0aae54e49e47103$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $f0aae54e49e47103$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $f0aae54e49e47103$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $f0aae54e49e47103$var$pushTransition(workInProgress, null);
    $f0aae54e49e47103$var$reuseHiddenContextOnStack();
    $f0aae54e49e47103$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $f0aae54e49e47103$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $f0aae54e49e47103$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $f0aae54e49e47103$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $f0aae54e49e47103$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f0aae54e49e47103$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f0aae54e49e47103$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $f0aae54e49e47103$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $f0aae54e49e47103$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($f0aae54e49e47103$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $f0aae54e49e47103$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $f0aae54e49e47103$var$bailoutOffscreenComponent(null, current);
            $f0aae54e49e47103$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $f0aae54e49e47103$var$nextHydratableInstance) ? (current = $f0aae54e49e47103$var$canHydrateHydrationBoundary(current, $f0aae54e49e47103$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f0aae54e49e47103$var$treeContextProvider ? {
                    id: $f0aae54e49e47103$var$treeContextId,
                    overflow: $f0aae54e49e47103$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f0aae54e49e47103$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f0aae54e49e47103$var$hydrationParentFiber = workInProgress, $f0aae54e49e47103$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f0aae54e49e47103$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $f0aae54e49e47103$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $f0aae54e49e47103$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $f0aae54e49e47103$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($f0aae54e49e47103$var$formatProdErrorMessage(558));
        } else if ($f0aae54e49e47103$var$didReceiveUpdate || $f0aae54e49e47103$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $f0aae54e49e47103$var$didReceiveUpdate || didSuspend) {
            nextProps = $f0aae54e49e47103$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $f0aae54e49e47103$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(current, dehydrated), $f0aae54e49e47103$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $f0aae54e49e47103$var$SelectiveHydrationException;
            $f0aae54e49e47103$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f0aae54e49e47103$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratable(dehydrated.nextSibling), $f0aae54e49e47103$var$hydrationParentFiber = workInProgress, $f0aae54e49e47103$var$isHydrating = !0, $f0aae54e49e47103$var$hydrationErrors = null, $f0aae54e49e47103$var$rootOrSingletonContext = !1, null !== current && $f0aae54e49e47103$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f0aae54e49e47103$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $f0aae54e49e47103$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $f0aae54e49e47103$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $f0aae54e49e47103$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f0aae54e49e47103$var$prepareToReadContext(workInProgress);
    Component = $f0aae54e49e47103$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $f0aae54e49e47103$var$checkDidRenderIdHook();
    if (null !== current && !$f0aae54e49e47103$var$didReceiveUpdate) return $f0aae54e49e47103$var$bailoutHooks(current, workInProgress, renderLanes), $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f0aae54e49e47103$var$isHydrating && nextProps && $f0aae54e49e47103$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $f0aae54e49e47103$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $f0aae54e49e47103$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $f0aae54e49e47103$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $f0aae54e49e47103$var$finishRenderingHooks(current);
    Component = $f0aae54e49e47103$var$checkDidRenderIdHook();
    if (null !== current && !$f0aae54e49e47103$var$didReceiveUpdate) return $f0aae54e49e47103$var$bailoutHooks(current, workInProgress, renderLanes), $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $f0aae54e49e47103$var$isHydrating && Component && $f0aae54e49e47103$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $f0aae54e49e47103$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $f0aae54e49e47103$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $f0aae54e49e47103$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $f0aae54e49e47103$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $f0aae54e49e47103$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $f0aae54e49e47103$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $f0aae54e49e47103$var$readContext(contextType) : $f0aae54e49e47103$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($f0aae54e49e47103$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $f0aae54e49e47103$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $f0aae54e49e47103$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $f0aae54e49e47103$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $f0aae54e49e47103$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $f0aae54e49e47103$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $f0aae54e49e47103$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $f0aae54e49e47103$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $f0aae54e49e47103$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f0aae54e49e47103$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f0aae54e49e47103$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $f0aae54e49e47103$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($f0aae54e49e47103$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $f0aae54e49e47103$var$hasForceUpdate || $f0aae54e49e47103$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $f0aae54e49e47103$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $f0aae54e49e47103$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $f0aae54e49e47103$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $f0aae54e49e47103$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $f0aae54e49e47103$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $f0aae54e49e47103$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $f0aae54e49e47103$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $f0aae54e49e47103$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $f0aae54e49e47103$var$hasForceUpdate || null !== current && null !== current.dependencies && $f0aae54e49e47103$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($f0aae54e49e47103$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $f0aae54e49e47103$var$hasForceUpdate || $f0aae54e49e47103$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $f0aae54e49e47103$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $f0aae54e49e47103$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $f0aae54e49e47103$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $f0aae54e49e47103$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $f0aae54e49e47103$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $f0aae54e49e47103$var$resetHydrationState();
    workInProgress.flags |= 256;
    $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $f0aae54e49e47103$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $f0aae54e49e47103$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $f0aae54e49e47103$var$getSuspendedCache()
    };
}
function $f0aae54e49e47103$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $f0aae54e49e47103$var$workInProgressDeferredLane);
    return current;
}
function $f0aae54e49e47103$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($f0aae54e49e47103$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($f0aae54e49e47103$var$isHydrating) {
            showFallback ? $f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $f0aae54e49e47103$var$nextHydratableInstance) ? (current = $f0aae54e49e47103$var$canHydrateHydrationBoundary(current, $f0aae54e49e47103$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $f0aae54e49e47103$var$treeContextProvider ? {
                    id: $f0aae54e49e47103$var$treeContextId,
                    overflow: $f0aae54e49e47103$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $f0aae54e49e47103$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $f0aae54e49e47103$var$hydrationParentFiber = workInProgress, $f0aae54e49e47103$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $f0aae54e49e47103$var$throwOnHydrationMismatch(workInProgress);
            $f0aae54e49e47103$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $f0aae54e49e47103$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $f0aae54e49e47103$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $f0aae54e49e47103$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f0aae54e49e47103$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f0aae54e49e47103$var$SUSPENDED_MARKER, $f0aae54e49e47103$var$bailoutOffscreenComponent(null, nextProps);
        $f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $f0aae54e49e47103$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $f0aae54e49e47103$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $f0aae54e49e47103$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $f0aae54e49e47103$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f0aae54e49e47103$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $f0aae54e49e47103$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $f0aae54e49e47103$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f0aae54e49e47103$var$SUSPENDED_MARKER, workInProgress = $f0aae54e49e47103$var$bailoutOffscreenComponent(null, nextProps));
        else if ($f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress), $f0aae54e49e47103$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($f0aae54e49e47103$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $f0aae54e49e47103$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $f0aae54e49e47103$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($f0aae54e49e47103$var$didReceiveUpdate || $f0aae54e49e47103$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $f0aae54e49e47103$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $f0aae54e49e47103$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $f0aae54e49e47103$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(current, nextProps), $f0aae54e49e47103$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $f0aae54e49e47103$var$SelectiveHydrationException;
            $f0aae54e49e47103$var$isSuspenseInstancePending(nextPrimaryChildren) || $f0aae54e49e47103$var$renderDidSuspendDelayIfPossible();
            workInProgress = $f0aae54e49e47103$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $f0aae54e49e47103$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratable(nextPrimaryChildren.nextSibling), $f0aae54e49e47103$var$hydrationParentFiber = workInProgress, $f0aae54e49e47103$var$isHydrating = !0, $f0aae54e49e47103$var$hydrationErrors = null, $f0aae54e49e47103$var$rootOrSingletonContext = !1, null !== current && $f0aae54e49e47103$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $f0aae54e49e47103$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $f0aae54e49e47103$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $f0aae54e49e47103$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $f0aae54e49e47103$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $f0aae54e49e47103$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $f0aae54e49e47103$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $f0aae54e49e47103$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $f0aae54e49e47103$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $f0aae54e49e47103$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $f0aae54e49e47103$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $f0aae54e49e47103$var$SUSPENDED_MARKER, $f0aae54e49e47103$var$bailoutOffscreenComponent(current.child, nextProps);
    $f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $f0aae54e49e47103$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $f0aae54e49e47103$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $f0aae54e49e47103$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $f0aae54e49e47103$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $f0aae54e49e47103$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $f0aae54e49e47103$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $f0aae54e49e47103$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $f0aae54e49e47103$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $f0aae54e49e47103$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $f0aae54e49e47103$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $f0aae54e49e47103$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $f0aae54e49e47103$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $f0aae54e49e47103$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, suspenseContext);
    $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $f0aae54e49e47103$var$isHydrating ? $f0aae54e49e47103$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $f0aae54e49e47103$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $f0aae54e49e47103$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $f0aae54e49e47103$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $f0aae54e49e47103$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $f0aae54e49e47103$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $f0aae54e49e47103$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $f0aae54e49e47103$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $f0aae54e49e47103$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($f0aae54e49e47103$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $f0aae54e49e47103$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $f0aae54e49e47103$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $f0aae54e49e47103$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $f0aae54e49e47103$var$checkIfContextChanged(current) ? !0 : !1;
}
function $f0aae54e49e47103$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $f0aae54e49e47103$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $f0aae54e49e47103$var$pushProvider(workInProgress, $f0aae54e49e47103$var$CacheContext, current.memoizedState.cache);
            $f0aae54e49e47103$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $f0aae54e49e47103$var$pushHostContext(workInProgress);
            break;
        case 4:
            $f0aae54e49e47103$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $f0aae54e49e47103$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $f0aae54e49e47103$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $f0aae54e49e47103$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $f0aae54e49e47103$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($f0aae54e49e47103$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $f0aae54e49e47103$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, $f0aae54e49e47103$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $f0aae54e49e47103$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $f0aae54e49e47103$var$pushProvider(workInProgress, $f0aae54e49e47103$var$CacheContext, current.memoizedState.cache);
    }
    return $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $f0aae54e49e47103$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $f0aae54e49e47103$var$didReceiveUpdate = !0;
        else {
            if (!$f0aae54e49e47103$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $f0aae54e49e47103$var$didReceiveUpdate = !1, $f0aae54e49e47103$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $f0aae54e49e47103$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $f0aae54e49e47103$var$didReceiveUpdate = !1, $f0aae54e49e47103$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $f0aae54e49e47103$var$pushTreeId(workInProgress, $f0aae54e49e47103$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $f0aae54e49e47103$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $f0aae54e49e47103$var$shouldConstruct(current) ? (props = $f0aae54e49e47103$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $f0aae54e49e47103$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $f0aae54e49e47103$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $f0aae54e49e47103$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $f0aae54e49e47103$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $f0aae54e49e47103$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $f0aae54e49e47103$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $f0aae54e49e47103$var$getComponentNameFromType(current) || current;
                    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $f0aae54e49e47103$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $f0aae54e49e47103$var$resolveClassComponentProps(props, workInProgress.pendingProps), $f0aae54e49e47103$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $f0aae54e49e47103$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $f0aae54e49e47103$var$cloneUpdateQueue(current, workInProgress);
                $f0aae54e49e47103$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $f0aae54e49e47103$var$pushProvider(workInProgress, $f0aae54e49e47103$var$CacheContext, props);
                props !== prevState.cache && $f0aae54e49e47103$var$propagateContextChanges(workInProgress, [
                    $f0aae54e49e47103$var$CacheContext
                ], renderLanes, !0);
                $f0aae54e49e47103$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $f0aae54e49e47103$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $f0aae54e49e47103$var$createCapturedValueAtFiber(Error($f0aae54e49e47103$var$formatProdErrorMessage(424)), workInProgress);
                        $f0aae54e49e47103$var$queueHydrationError($$typeof);
                        workInProgress = $f0aae54e49e47103$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratable(current.firstChild);
                        $f0aae54e49e47103$var$hydrationParentFiber = workInProgress;
                        $f0aae54e49e47103$var$isHydrating = !0;
                        $f0aae54e49e47103$var$hydrationErrors = null;
                        $f0aae54e49e47103$var$rootOrSingletonContext = !0;
                        renderLanes = $f0aae54e49e47103$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $f0aae54e49e47103$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $f0aae54e49e47103$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $f0aae54e49e47103$var$markRef(current, workInProgress), null === current ? (renderLanes = $f0aae54e49e47103$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $f0aae54e49e47103$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $f0aae54e49e47103$var$getOwnerDocumentFromRootContainer($f0aae54e49e47103$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$f0aae54e49e47103$var$internalInstanceKey] = workInProgress, props[$f0aae54e49e47103$var$internalPropsKey] = current, $f0aae54e49e47103$var$setInitialProperties(props, renderLanes, current), $f0aae54e49e47103$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $f0aae54e49e47103$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $f0aae54e49e47103$var$pushHostContext(workInProgress), null === current && $f0aae54e49e47103$var$isHydrating && (props = workInProgress.stateNode = $f0aae54e49e47103$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $f0aae54e49e47103$var$rootInstanceStackCursor.current), $f0aae54e49e47103$var$hydrationParentFiber = workInProgress, $f0aae54e49e47103$var$rootOrSingletonContext = !0, $$typeof = $f0aae54e49e47103$var$nextHydratableInstance, $f0aae54e49e47103$var$isSingletonScope(workInProgress.type) ? ($f0aae54e49e47103$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratable(props.firstChild)) : $f0aae54e49e47103$var$nextHydratableInstance = $$typeof), $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $f0aae54e49e47103$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $f0aae54e49e47103$var$isHydrating) {
                if ($$typeof = props = $f0aae54e49e47103$var$nextHydratableInstance) props = $f0aae54e49e47103$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $f0aae54e49e47103$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $f0aae54e49e47103$var$hydrationParentFiber = workInProgress, $f0aae54e49e47103$var$nextHydratableInstance = $f0aae54e49e47103$var$getNextHydratable(props.firstChild), $f0aae54e49e47103$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $f0aae54e49e47103$var$throwOnHydrationMismatch(workInProgress);
            }
            $f0aae54e49e47103$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $f0aae54e49e47103$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $f0aae54e49e47103$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $f0aae54e49e47103$var$renderWithHooks(current, workInProgress, $f0aae54e49e47103$var$TransitionAwareHostComponent, null, null, renderLanes), $f0aae54e49e47103$var$HostTransitionContext._currentValue = $$typeof);
            $f0aae54e49e47103$var$markRef(current, workInProgress);
            $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $f0aae54e49e47103$var$isHydrating) {
                if (current = renderLanes = $f0aae54e49e47103$var$nextHydratableInstance) renderLanes = $f0aae54e49e47103$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $f0aae54e49e47103$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $f0aae54e49e47103$var$hydrationParentFiber = workInProgress, $f0aae54e49e47103$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $f0aae54e49e47103$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $f0aae54e49e47103$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $f0aae54e49e47103$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $f0aae54e49e47103$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $f0aae54e49e47103$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $f0aae54e49e47103$var$pushProvider(workInProgress, workInProgress.type, props.value), $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $f0aae54e49e47103$var$prepareToReadContext(workInProgress), $$typeof = $f0aae54e49e47103$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $f0aae54e49e47103$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $f0aae54e49e47103$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $f0aae54e49e47103$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $f0aae54e49e47103$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $f0aae54e49e47103$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $f0aae54e49e47103$var$prepareToReadContext(workInProgress), props = $f0aae54e49e47103$var$readContext($f0aae54e49e47103$var$CacheContext), null === current ? ($$typeof = $f0aae54e49e47103$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $f0aae54e49e47103$var$workInProgressRoot, prevState = $f0aae54e49e47103$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $f0aae54e49e47103$var$initializeUpdateQueue(workInProgress), $f0aae54e49e47103$var$pushProvider(workInProgress, $f0aae54e49e47103$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($f0aae54e49e47103$var$cloneUpdateQueue(current, workInProgress), $f0aae54e49e47103$var$processUpdateQueue(workInProgress, null, null, renderLanes), $f0aae54e49e47103$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $f0aae54e49e47103$var$pushProvider(workInProgress, $f0aae54e49e47103$var$CacheContext, props)) : (props = prevState.cache, $f0aae54e49e47103$var$pushProvider(workInProgress, $f0aae54e49e47103$var$CacheContext, props), props !== $$typeof.cache && $f0aae54e49e47103$var$propagateContextChanges(workInProgress, [
                $f0aae54e49e47103$var$CacheContext
            ], renderLanes, !0))), $f0aae54e49e47103$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f0aae54e49e47103$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $f0aae54e49e47103$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($f0aae54e49e47103$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $f0aae54e49e47103$var$suspendedThenable = $f0aae54e49e47103$var$noopSuspenseyCommitThenable, $f0aae54e49e47103$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $f0aae54e49e47103$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$f0aae54e49e47103$var$preloadResource(resource)) {
        if ($f0aae54e49e47103$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $f0aae54e49e47103$var$suspendedThenable = $f0aae54e49e47103$var$noopSuspenseyCommitThenable, $f0aae54e49e47103$var$SuspenseyCommitException;
    }
}
function $f0aae54e49e47103$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $f0aae54e49e47103$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $f0aae54e49e47103$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $f0aae54e49e47103$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$f0aae54e49e47103$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $f0aae54e49e47103$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $f0aae54e49e47103$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $f0aae54e49e47103$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $f0aae54e49e47103$var$bubbleProperties(workInProgress), null;
        case 1:
            return $f0aae54e49e47103$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $f0aae54e49e47103$var$popProvider($f0aae54e49e47103$var$CacheContext);
            $f0aae54e49e47103$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $f0aae54e49e47103$var$popHydrationState(workInProgress) ? $f0aae54e49e47103$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $f0aae54e49e47103$var$upgradeHydrationErrorsToRecoverable());
            $f0aae54e49e47103$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($f0aae54e49e47103$var$markUpdate(workInProgress), null !== nextResource ? ($f0aae54e49e47103$var$bubbleProperties(workInProgress), $f0aae54e49e47103$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f0aae54e49e47103$var$bubbleProperties(workInProgress), $f0aae54e49e47103$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($f0aae54e49e47103$var$markUpdate(workInProgress), $f0aae54e49e47103$var$bubbleProperties(workInProgress), $f0aae54e49e47103$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($f0aae54e49e47103$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $f0aae54e49e47103$var$markUpdate(workInProgress), $f0aae54e49e47103$var$bubbleProperties(workInProgress), $f0aae54e49e47103$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $f0aae54e49e47103$var$popHostContext(workInProgress);
            renderLanes = $f0aae54e49e47103$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f0aae54e49e47103$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(166));
                    $f0aae54e49e47103$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $f0aae54e49e47103$var$contextStackCursor.current;
                $f0aae54e49e47103$var$popHydrationState(workInProgress) ? $f0aae54e49e47103$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $f0aae54e49e47103$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $f0aae54e49e47103$var$markUpdate(workInProgress));
            }
            $f0aae54e49e47103$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $f0aae54e49e47103$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f0aae54e49e47103$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(166));
                    $f0aae54e49e47103$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $f0aae54e49e47103$var$contextStackCursor.current;
                if ($f0aae54e49e47103$var$popHydrationState(workInProgress)) $f0aae54e49e47103$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $f0aae54e49e47103$var$getOwnerDocumentFromRootContainer($f0aae54e49e47103$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$f0aae54e49e47103$var$internalInstanceKey] = workInProgress;
                    nextResource[$f0aae54e49e47103$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($f0aae54e49e47103$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $f0aae54e49e47103$var$markUpdate(workInProgress);
                }
            }
            $f0aae54e49e47103$var$bubbleProperties(workInProgress);
            $f0aae54e49e47103$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $f0aae54e49e47103$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(166));
                current = $f0aae54e49e47103$var$rootInstanceStackCursor.current;
                if ($f0aae54e49e47103$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $f0aae54e49e47103$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$f0aae54e49e47103$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $f0aae54e49e47103$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $f0aae54e49e47103$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $f0aae54e49e47103$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$f0aae54e49e47103$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $f0aae54e49e47103$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $f0aae54e49e47103$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(557));
                        current[$f0aae54e49e47103$var$internalInstanceKey] = workInProgress;
                    } else $f0aae54e49e47103$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f0aae54e49e47103$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $f0aae54e49e47103$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $f0aae54e49e47103$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f0aae54e49e47103$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(558));
            }
            $f0aae54e49e47103$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $f0aae54e49e47103$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(317));
                        type[$f0aae54e49e47103$var$internalInstanceKey] = workInProgress;
                    } else $f0aae54e49e47103$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $f0aae54e49e47103$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $f0aae54e49e47103$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $f0aae54e49e47103$var$popSuspenseHandler(workInProgress), workInProgress;
                    $f0aae54e49e47103$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $f0aae54e49e47103$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $f0aae54e49e47103$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $f0aae54e49e47103$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $f0aae54e49e47103$var$popHostContainer(), null === current && $f0aae54e49e47103$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $f0aae54e49e47103$var$bubbleProperties(workInProgress), null;
        case 10:
            return $f0aae54e49e47103$var$popProvider(workInProgress.type), $f0aae54e49e47103$var$bubbleProperties(workInProgress), null;
        case 19:
            $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $f0aae54e49e47103$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $f0aae54e49e47103$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $f0aae54e49e47103$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $f0aae54e49e47103$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $f0aae54e49e47103$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $f0aae54e49e47103$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$f0aae54e49e47103$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, $f0aae54e49e47103$var$suspenseStackCursor.current & 1 | 2);
                            $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $f0aae54e49e47103$var$now() > $f0aae54e49e47103$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $f0aae54e49e47103$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $f0aae54e49e47103$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $f0aae54e49e47103$var$scheduleRetryEffect(workInProgress, current), $f0aae54e49e47103$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$f0aae54e49e47103$var$isHydrating) return $f0aae54e49e47103$var$bubbleProperties(workInProgress), null;
                    } else 2 * $f0aae54e49e47103$var$now() - newProps.renderingStartTime > $f0aae54e49e47103$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $f0aae54e49e47103$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $f0aae54e49e47103$var$now(), current.sibling = null, renderLanes = $f0aae54e49e47103$var$suspenseStackCursor.current, $f0aae54e49e47103$var$push($f0aae54e49e47103$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $f0aae54e49e47103$var$isHydrating && $f0aae54e49e47103$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $f0aae54e49e47103$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $f0aae54e49e47103$var$popSuspenseHandler(workInProgress), $f0aae54e49e47103$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($f0aae54e49e47103$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $f0aae54e49e47103$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $f0aae54e49e47103$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $f0aae54e49e47103$var$popProvider($f0aae54e49e47103$var$CacheContext), $f0aae54e49e47103$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $f0aae54e49e47103$var$unwindWork(current, workInProgress) {
    $f0aae54e49e47103$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $f0aae54e49e47103$var$popProvider($f0aae54e49e47103$var$CacheContext), $f0aae54e49e47103$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $f0aae54e49e47103$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $f0aae54e49e47103$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(340));
                $f0aae54e49e47103$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $f0aae54e49e47103$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(340));
                $f0aae54e49e47103$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$suspenseStackCursor), null;
        case 4:
            return $f0aae54e49e47103$var$popHostContainer(), null;
        case 10:
            return $f0aae54e49e47103$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $f0aae54e49e47103$var$popSuspenseHandler(workInProgress), $f0aae54e49e47103$var$popHiddenContext(), null !== current && $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $f0aae54e49e47103$var$popProvider($f0aae54e49e47103$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $f0aae54e49e47103$var$unwindInterruptedWork(current, interruptedWork) {
    $f0aae54e49e47103$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $f0aae54e49e47103$var$popProvider($f0aae54e49e47103$var$CacheContext);
            $f0aae54e49e47103$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $f0aae54e49e47103$var$popHostContext(interruptedWork);
            break;
        case 4:
            $f0aae54e49e47103$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $f0aae54e49e47103$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $f0aae54e49e47103$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$suspenseStackCursor);
            break;
        case 10:
            $f0aae54e49e47103$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $f0aae54e49e47103$var$popSuspenseHandler(interruptedWork);
            $f0aae54e49e47103$var$popHiddenContext();
            null !== current && $f0aae54e49e47103$var$pop($f0aae54e49e47103$var$resumedCache);
            break;
        case 24:
            $f0aae54e49e47103$var$popProvider($f0aae54e49e47103$var$CacheContext);
    }
}
function $f0aae54e49e47103$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f0aae54e49e47103$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $f0aae54e49e47103$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f0aae54e49e47103$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $f0aae54e49e47103$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f0aae54e49e47103$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $f0aae54e49e47103$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f0aae54e49e47103$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $f0aae54e49e47103$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $f0aae54e49e47103$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $f0aae54e49e47103$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $f0aae54e49e47103$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f0aae54e49e47103$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $f0aae54e49e47103$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$f0aae54e49e47103$var$internalPropsKey] = newProps;
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f0aae54e49e47103$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $f0aae54e49e47103$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $f0aae54e49e47103$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $f0aae54e49e47103$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $f0aae54e49e47103$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $f0aae54e49e47103$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $f0aae54e49e47103$var$noop$1));
    else if (4 !== tag && (27 === tag && $f0aae54e49e47103$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($f0aae54e49e47103$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$f0aae54e49e47103$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $f0aae54e49e47103$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $f0aae54e49e47103$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($f0aae54e49e47103$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$f0aae54e49e47103$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $f0aae54e49e47103$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $f0aae54e49e47103$var$setInitialProperties(singleton, type, props);
        singleton[$f0aae54e49e47103$var$internalInstanceKey] = finishedWork;
        singleton[$f0aae54e49e47103$var$internalPropsKey] = props;
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $f0aae54e49e47103$var$offscreenSubtreeIsHidden = !1, $f0aae54e49e47103$var$offscreenSubtreeWasHidden = !1, $f0aae54e49e47103$var$needsFormReset = !1, $f0aae54e49e47103$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $f0aae54e49e47103$var$nextEffect = null;
function $f0aae54e49e47103$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $f0aae54e49e47103$var$eventsEnabled = $f0aae54e49e47103$var$_enabled;
    root = $f0aae54e49e47103$var$getActiveElementDeep(root);
    if ($f0aae54e49e47103$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $f0aae54e49e47103$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $f0aae54e49e47103$var$_enabled = !1;
    for($f0aae54e49e47103$var$nextEffect = firstChild; null !== $f0aae54e49e47103$var$nextEffect;)if (firstChild = $f0aae54e49e47103$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $f0aae54e49e47103$var$nextEffect = root;
    else for(; null !== $f0aae54e49e47103$var$nextEffect;){
        firstChild = $f0aae54e49e47103$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $f0aae54e49e47103$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $f0aae54e49e47103$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $f0aae54e49e47103$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $f0aae54e49e47103$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $f0aae54e49e47103$var$nextEffect = root;
            break;
        }
        $f0aae54e49e47103$var$nextEffect = firstChild.return;
    }
}
function $f0aae54e49e47103$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f0aae54e49e47103$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $f0aae54e49e47103$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $f0aae54e49e47103$var$commitClassCallbacks(finishedWork);
            flags & 512 && $f0aae54e49e47103$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $f0aae54e49e47103$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $f0aae54e49e47103$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $f0aae54e49e47103$var$commitHostMount(finishedWork);
            flags & 512 && $f0aae54e49e47103$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f0aae54e49e47103$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $f0aae54e49e47103$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $f0aae54e49e47103$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $f0aae54e49e47103$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $f0aae54e49e47103$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $f0aae54e49e47103$var$offscreenSubtreeWasHidden;
                prevProps = $f0aae54e49e47103$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $f0aae54e49e47103$var$offscreenSubtreeWasHidden;
                $f0aae54e49e47103$var$offscreenSubtreeIsHidden = flags;
                ($f0aae54e49e47103$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $f0aae54e49e47103$var$offscreenSubtreeIsHidden = prevProps;
                $f0aae54e49e47103$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $f0aae54e49e47103$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $f0aae54e49e47103$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $f0aae54e49e47103$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $f0aae54e49e47103$var$hostParent = null, $f0aae54e49e47103$var$hostParentIsContainer = !1;
function $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$f0aae54e49e47103$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $f0aae54e49e47103$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($f0aae54e49e47103$var$injectedHook && "function" === typeof $f0aae54e49e47103$var$injectedHook.onCommitFiberUnmount) try {
        $f0aae54e49e47103$var$injectedHook.onCommitFiberUnmount($f0aae54e49e47103$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden || $f0aae54e49e47103$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden || $f0aae54e49e47103$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $f0aae54e49e47103$var$hostParent, prevHostParentIsContainer = $f0aae54e49e47103$var$hostParentIsContainer;
            $f0aae54e49e47103$var$isSingletonScope(deletedFiber.type) && ($f0aae54e49e47103$var$hostParent = deletedFiber.stateNode, $f0aae54e49e47103$var$hostParentIsContainer = !1);
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f0aae54e49e47103$var$releaseSingletonInstance(deletedFiber.stateNode);
            $f0aae54e49e47103$var$hostParent = prevHostParent;
            $f0aae54e49e47103$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden || $f0aae54e49e47103$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $f0aae54e49e47103$var$hostParent;
            prevHostParentIsContainer = $f0aae54e49e47103$var$hostParentIsContainer;
            $f0aae54e49e47103$var$hostParent = null;
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f0aae54e49e47103$var$hostParent = prevHostParent;
            $f0aae54e49e47103$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $f0aae54e49e47103$var$hostParent) {
                if ($f0aae54e49e47103$var$hostParentIsContainer) try {
                    (9 === $f0aae54e49e47103$var$hostParent.nodeType ? $f0aae54e49e47103$var$hostParent.body : "HTML" === $f0aae54e49e47103$var$hostParent.nodeName ? $f0aae54e49e47103$var$hostParent.ownerDocument.body : $f0aae54e49e47103$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $f0aae54e49e47103$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $f0aae54e49e47103$var$hostParent && ($f0aae54e49e47103$var$hostParentIsContainer ? (finishedRoot = $f0aae54e49e47103$var$hostParent, $f0aae54e49e47103$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $f0aae54e49e47103$var$retryIfBlockedOn(finishedRoot)) : $f0aae54e49e47103$var$clearHydrationBoundary($f0aae54e49e47103$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $f0aae54e49e47103$var$hostParent;
            prevHostParentIsContainer = $f0aae54e49e47103$var$hostParentIsContainer;
            $f0aae54e49e47103$var$hostParent = deletedFiber.stateNode.containerInfo;
            $f0aae54e49e47103$var$hostParentIsContainer = !0;
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f0aae54e49e47103$var$hostParent = prevHostParent;
            $f0aae54e49e47103$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $f0aae54e49e47103$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden || $f0aae54e49e47103$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden || ($f0aae54e49e47103$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $f0aae54e49e47103$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden = (prevHostParent = $f0aae54e49e47103$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $f0aae54e49e47103$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $f0aae54e49e47103$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $f0aae54e49e47103$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $f0aae54e49e47103$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $f0aae54e49e47103$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $f0aae54e49e47103$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $f0aae54e49e47103$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $f0aae54e49e47103$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $f0aae54e49e47103$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $f0aae54e49e47103$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $f0aae54e49e47103$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($f0aae54e49e47103$var$isSingletonScope(parent.type)) {
                        $f0aae54e49e47103$var$hostParent = parent.stateNode;
                        $f0aae54e49e47103$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $f0aae54e49e47103$var$hostParent = parent.stateNode;
                    $f0aae54e49e47103$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $f0aae54e49e47103$var$hostParent = parent.stateNode.containerInfo;
                    $f0aae54e49e47103$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $f0aae54e49e47103$var$hostParent) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(160));
        $f0aae54e49e47103$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $f0aae54e49e47103$var$hostParent = null;
        $f0aae54e49e47103$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$f0aae54e49e47103$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $f0aae54e49e47103$var$currentHoistableRoot = null;
function $f0aae54e49e47103$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($f0aae54e49e47103$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $f0aae54e49e47103$var$commitHookEffectListMount(3, finishedWork), $f0aae54e49e47103$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f0aae54e49e47103$var$offscreenSubtreeWasHidden || null === current || $f0aae54e49e47103$var$safelyDetachRef(current, current.return));
            flags & 64 && $f0aae54e49e47103$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $f0aae54e49e47103$var$currentHoistableRoot;
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f0aae54e49e47103$var$offscreenSubtreeWasHidden || null === current || $f0aae54e49e47103$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$f0aae54e49e47103$var$internalHoistableMarker] || currentResource[$f0aae54e49e47103$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $f0aae54e49e47103$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$f0aae54e49e47103$var$internalInstanceKey] = finishedWork;
                                        $f0aae54e49e47103$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $f0aae54e49e47103$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f0aae54e49e47103$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $f0aae54e49e47103$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $f0aae54e49e47103$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($f0aae54e49e47103$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$f0aae54e49e47103$var$internalInstanceKey] = finishedWork;
                                $f0aae54e49e47103$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $f0aae54e49e47103$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $f0aae54e49e47103$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $f0aae54e49e47103$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $f0aae54e49e47103$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $f0aae54e49e47103$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f0aae54e49e47103$var$offscreenSubtreeWasHidden || null === current || $f0aae54e49e47103$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $f0aae54e49e47103$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($f0aae54e49e47103$var$offscreenSubtreeWasHidden || null === current || $f0aae54e49e47103$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $f0aae54e49e47103$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $f0aae54e49e47103$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($f0aae54e49e47103$var$needsFormReset = !0);
            break;
        case 6:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $f0aae54e49e47103$var$tagCaches = null;
            hoistableRoot = $f0aae54e49e47103$var$currentHoistableRoot;
            $f0aae54e49e47103$var$currentHoistableRoot = $f0aae54e49e47103$var$getHoistableRoot(root.containerInfo);
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$currentHoistableRoot = hoistableRoot;
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $f0aae54e49e47103$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $f0aae54e49e47103$var$needsFormReset && ($f0aae54e49e47103$var$needsFormReset = !1, $f0aae54e49e47103$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $f0aae54e49e47103$var$currentHoistableRoot;
            $f0aae54e49e47103$var$currentHoistableRoot = $f0aae54e49e47103$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            $f0aae54e49e47103$var$currentHoistableRoot = flags;
            break;
        case 12:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f0aae54e49e47103$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($f0aae54e49e47103$var$globalMostRecentFallbackTime = $f0aae54e49e47103$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f0aae54e49e47103$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $f0aae54e49e47103$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $f0aae54e49e47103$var$offscreenSubtreeWasHidden;
            $f0aae54e49e47103$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $f0aae54e49e47103$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $f0aae54e49e47103$var$offscreenSubtreeIsHidden || $f0aae54e49e47103$var$offscreenSubtreeWasHidden || $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $f0aae54e49e47103$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $f0aae54e49e47103$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $f0aae54e49e47103$var$hideOrUnhideDehydratedBoundary(instance, !0) : $f0aae54e49e47103$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $f0aae54e49e47103$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $f0aae54e49e47103$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $f0aae54e49e47103$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $f0aae54e49e47103$var$recursivelyTraverseMutationEffects(root, finishedWork), $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork);
    }
}
function $f0aae54e49e47103$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($f0aae54e49e47103$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $f0aae54e49e47103$var$getHostSibling(finishedWork);
                    $f0aae54e49e47103$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($f0aae54e49e47103$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $f0aae54e49e47103$var$getHostSibling(finishedWork);
                    $f0aae54e49e47103$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $f0aae54e49e47103$var$getHostSibling(finishedWork);
                    $f0aae54e49e47103$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $f0aae54e49e47103$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $f0aae54e49e47103$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $f0aae54e49e47103$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$f0aae54e49e47103$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $f0aae54e49e47103$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $f0aae54e49e47103$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $f0aae54e49e47103$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $f0aae54e49e47103$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $f0aae54e49e47103$var$safelyDetachRef(finishedWork, finishedWork.return);
                $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $f0aae54e49e47103$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f0aae54e49e47103$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$f0aae54e49e47103$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $f0aae54e49e47103$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $f0aae54e49e47103$var$commitClassCallbacks(finishedWork);
                $f0aae54e49e47103$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $f0aae54e49e47103$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $f0aae54e49e47103$var$commitHostMount(finishedWork);
                $f0aae54e49e47103$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f0aae54e49e47103$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $f0aae54e49e47103$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $f0aae54e49e47103$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $f0aae54e49e47103$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f0aae54e49e47103$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $f0aae54e49e47103$var$releaseCache(previousCache));
}
function $f0aae54e49e47103$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $f0aae54e49e47103$var$releaseCache(current));
}
function $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f0aae54e49e47103$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $f0aae54e49e47103$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f0aae54e49e47103$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $f0aae54e49e47103$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $f0aae54e49e47103$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $f0aae54e49e47103$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $f0aae54e49e47103$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $f0aae54e49e47103$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $f0aae54e49e47103$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $f0aae54e49e47103$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $f0aae54e49e47103$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $f0aae54e49e47103$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $f0aae54e49e47103$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $f0aae54e49e47103$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $f0aae54e49e47103$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $f0aae54e49e47103$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $f0aae54e49e47103$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f0aae54e49e47103$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $f0aae54e49e47103$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f0aae54e49e47103$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f0aae54e49e47103$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $f0aae54e49e47103$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f0aae54e49e47103$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $f0aae54e49e47103$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $f0aae54e49e47103$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $f0aae54e49e47103$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $f0aae54e49e47103$var$suspenseyCommitFlag = 8192;
function $f0aae54e49e47103$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $f0aae54e49e47103$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$f0aae54e49e47103$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $f0aae54e49e47103$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $f0aae54e49e47103$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $f0aae54e49e47103$var$suspenseyCommitFlag && null !== fiber.memoizedState && $f0aae54e49e47103$var$suspendResource(suspendedState, $f0aae54e49e47103$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $f0aae54e49e47103$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $f0aae54e49e47103$var$currentHoistableRoot;
            $f0aae54e49e47103$var$currentHoistableRoot = $f0aae54e49e47103$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $f0aae54e49e47103$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $f0aae54e49e47103$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $f0aae54e49e47103$var$suspenseyCommitFlag, $f0aae54e49e47103$var$suspenseyCommitFlag = 16777216, $f0aae54e49e47103$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $f0aae54e49e47103$var$suspenseyCommitFlag = previousHoistableRoot) : $f0aae54e49e47103$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $f0aae54e49e47103$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $f0aae54e49e47103$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $f0aae54e49e47103$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f0aae54e49e47103$var$nextEffect = childToDelete;
            $f0aae54e49e47103$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f0aae54e49e47103$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$f0aae54e49e47103$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $f0aae54e49e47103$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $f0aae54e49e47103$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $f0aae54e49e47103$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $f0aae54e49e47103$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $f0aae54e49e47103$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $f0aae54e49e47103$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $f0aae54e49e47103$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $f0aae54e49e47103$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $f0aae54e49e47103$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $f0aae54e49e47103$var$nextEffect = childToDelete;
            $f0aae54e49e47103$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $f0aae54e49e47103$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $f0aae54e49e47103$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $f0aae54e49e47103$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $f0aae54e49e47103$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $f0aae54e49e47103$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $f0aae54e49e47103$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $f0aae54e49e47103$var$nextEffect;){
        var fiber = $f0aae54e49e47103$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $f0aae54e49e47103$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $f0aae54e49e47103$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $f0aae54e49e47103$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $f0aae54e49e47103$var$nextEffect;){
            cache = $f0aae54e49e47103$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $f0aae54e49e47103$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $f0aae54e49e47103$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $f0aae54e49e47103$var$nextEffect = sibling;
                break a;
            }
            $f0aae54e49e47103$var$nextEffect = returnFiber;
        }
    }
}
var $f0aae54e49e47103$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $f0aae54e49e47103$var$readContext($f0aae54e49e47103$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $f0aae54e49e47103$var$readContext($f0aae54e49e47103$var$CacheContext).controller.signal;
    }
}, $f0aae54e49e47103$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $f0aae54e49e47103$var$executionContext = 0, $f0aae54e49e47103$var$workInProgressRoot = null, $f0aae54e49e47103$var$workInProgress = null, $f0aae54e49e47103$var$workInProgressRootRenderLanes = 0, $f0aae54e49e47103$var$workInProgressSuspendedReason = 0, $f0aae54e49e47103$var$workInProgressThrownValue = null, $f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings = !1, $f0aae54e49e47103$var$workInProgressRootIsPrerendering = !1, $f0aae54e49e47103$var$workInProgressRootDidAttachPingListener = !1, $f0aae54e49e47103$var$entangledRenderLanes = 0, $f0aae54e49e47103$var$workInProgressRootExitStatus = 0, $f0aae54e49e47103$var$workInProgressRootSkippedLanes = 0, $f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes = 0, $f0aae54e49e47103$var$workInProgressRootPingedLanes = 0, $f0aae54e49e47103$var$workInProgressDeferredLane = 0, $f0aae54e49e47103$var$workInProgressSuspendedRetryLanes = 0, $f0aae54e49e47103$var$workInProgressRootConcurrentErrors = null, $f0aae54e49e47103$var$workInProgressRootRecoverableErrors = null, $f0aae54e49e47103$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $f0aae54e49e47103$var$globalMostRecentFallbackTime = 0, $f0aae54e49e47103$var$globalMostRecentTransitionTime = 0, $f0aae54e49e47103$var$workInProgressRootRenderTargetTime = Infinity, $f0aae54e49e47103$var$workInProgressTransitions = null, $f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed = null, $f0aae54e49e47103$var$pendingEffectsStatus = 0, $f0aae54e49e47103$var$pendingEffectsRoot = null, $f0aae54e49e47103$var$pendingFinishedWork = null, $f0aae54e49e47103$var$pendingEffectsLanes = 0, $f0aae54e49e47103$var$pendingEffectsRemainingLanes = 0, $f0aae54e49e47103$var$pendingPassiveTransitions = null, $f0aae54e49e47103$var$pendingRecoverableErrors = null, $f0aae54e49e47103$var$nestedUpdateCount = 0, $f0aae54e49e47103$var$rootWithNestedUpdates = null;
function $f0aae54e49e47103$var$requestUpdateLane() {
    return 0 !== ($f0aae54e49e47103$var$executionContext & 2) && 0 !== $f0aae54e49e47103$var$workInProgressRootRenderLanes ? $f0aae54e49e47103$var$workInProgressRootRenderLanes & -$f0aae54e49e47103$var$workInProgressRootRenderLanes : null !== $f0aae54e49e47103$var$ReactSharedInternals.T ? $f0aae54e49e47103$var$requestTransitionLane() : $f0aae54e49e47103$var$resolveUpdatePriority();
}
function $f0aae54e49e47103$var$requestDeferredLane() {
    if (0 === $f0aae54e49e47103$var$workInProgressDeferredLane) {
        if (0 === ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 536870912) || $f0aae54e49e47103$var$isHydrating) {
            var lane = $f0aae54e49e47103$var$nextTransitionDeferredLane;
            $f0aae54e49e47103$var$nextTransitionDeferredLane <<= 1;
            0 === ($f0aae54e49e47103$var$nextTransitionDeferredLane & 3932160) && ($f0aae54e49e47103$var$nextTransitionDeferredLane = 262144);
            $f0aae54e49e47103$var$workInProgressDeferredLane = lane;
        } else $f0aae54e49e47103$var$workInProgressDeferredLane = 536870912;
    }
    lane = $f0aae54e49e47103$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $f0aae54e49e47103$var$workInProgressDeferredLane;
}
function $f0aae54e49e47103$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $f0aae54e49e47103$var$workInProgressRoot && (2 === $f0aae54e49e47103$var$workInProgressSuspendedReason || 9 === $f0aae54e49e47103$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $f0aae54e49e47103$var$prepareFreshStack(root, 0), $f0aae54e49e47103$var$markRootSuspended(root, $f0aae54e49e47103$var$workInProgressRootRenderLanes, $f0aae54e49e47103$var$workInProgressDeferredLane, !1);
    $f0aae54e49e47103$var$markRootUpdated$1(root, lane);
    if (0 === ($f0aae54e49e47103$var$executionContext & 2) || root !== $f0aae54e49e47103$var$workInProgressRoot) root === $f0aae54e49e47103$var$workInProgressRoot && (0 === ($f0aae54e49e47103$var$executionContext & 2) && ($f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $f0aae54e49e47103$var$workInProgressRootExitStatus && $f0aae54e49e47103$var$markRootSuspended(root, $f0aae54e49e47103$var$workInProgressRootRenderLanes, $f0aae54e49e47103$var$workInProgressDeferredLane, !1)), $f0aae54e49e47103$var$ensureRootIsScheduled(root);
}
function $f0aae54e49e47103$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($f0aae54e49e47103$var$executionContext & 6)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $f0aae54e49e47103$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $f0aae54e49e47103$var$renderRootConcurrent(root$jscomp$0, lanes) : $f0aae54e49e47103$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $f0aae54e49e47103$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $f0aae54e49e47103$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$f0aae54e49e47103$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $f0aae54e49e47103$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $f0aae54e49e47103$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($f0aae54e49e47103$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $f0aae54e49e47103$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($f0aae54e49e47103$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $f0aae54e49e47103$var$workInProgressRootRecoverableErrors;
                            $f0aae54e49e47103$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $f0aae54e49e47103$var$workInProgressRootRecoverableErrors ? $f0aae54e49e47103$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $f0aae54e49e47103$var$workInProgressRootRecoverableErrors.push.apply($f0aae54e49e47103$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $f0aae54e49e47103$var$prepareFreshStack(root$jscomp$0, 0);
                $f0aae54e49e47103$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($f0aae54e49e47103$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $f0aae54e49e47103$var$markRootSuspended(shouldTimeSlice, lanes, $f0aae54e49e47103$var$workInProgressDeferredLane, !$f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $f0aae54e49e47103$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($f0aae54e49e47103$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $f0aae54e49e47103$var$globalMostRecentFallbackTime + 300 - $f0aae54e49e47103$var$now(), 10 < exitStatus)) {
                    $f0aae54e49e47103$var$markRootSuspended(shouldTimeSlice, lanes, $f0aae54e49e47103$var$workInProgressDeferredLane, !$f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $f0aae54e49e47103$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $f0aae54e49e47103$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $f0aae54e49e47103$var$scheduleTimeout($f0aae54e49e47103$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $f0aae54e49e47103$var$workInProgressRootRecoverableErrors, $f0aae54e49e47103$var$workInProgressTransitions, $f0aae54e49e47103$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f0aae54e49e47103$var$workInProgressDeferredLane, $f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes, $f0aae54e49e47103$var$workInProgressSuspendedRetryLanes, $f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $f0aae54e49e47103$var$commitRootWhenReady(shouldTimeSlice, forceSync, $f0aae54e49e47103$var$workInProgressRootRecoverableErrors, $f0aae54e49e47103$var$workInProgressTransitions, $f0aae54e49e47103$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $f0aae54e49e47103$var$workInProgressDeferredLane, $f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes, $f0aae54e49e47103$var$workInProgressSuspendedRetryLanes, $f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $f0aae54e49e47103$var$ensureRootIsScheduled(root$jscomp$0);
}
function $f0aae54e49e47103$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $f0aae54e49e47103$var$noop$1
        };
        $f0aae54e49e47103$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $f0aae54e49e47103$var$globalMostRecentFallbackTime - $f0aae54e49e47103$var$now() : (lanes & 4194048) === lanes ? $f0aae54e49e47103$var$globalMostRecentTransitionTime - $f0aae54e49e47103$var$now() : 0;
        timeoutOffset = $f0aae54e49e47103$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $f0aae54e49e47103$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($f0aae54e49e47103$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $f0aae54e49e47103$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $f0aae54e49e47103$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $f0aae54e49e47103$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$f0aae54e49e47103$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $f0aae54e49e47103$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$f0aae54e49e47103$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $f0aae54e49e47103$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $f0aae54e49e47103$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $f0aae54e49e47103$var$flushSyncWork$1() {
    return 0 === ($f0aae54e49e47103$var$executionContext & 6) ? ($f0aae54e49e47103$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $f0aae54e49e47103$var$resetWorkInProgressStack() {
    if (null !== $f0aae54e49e47103$var$workInProgress) {
        if (0 === $f0aae54e49e47103$var$workInProgressSuspendedReason) var interruptedWork = $f0aae54e49e47103$var$workInProgress.return;
        else interruptedWork = $f0aae54e49e47103$var$workInProgress, $f0aae54e49e47103$var$lastContextDependency = $f0aae54e49e47103$var$currentlyRenderingFiber$1 = null, $f0aae54e49e47103$var$resetHooksOnUnwind(interruptedWork), $f0aae54e49e47103$var$thenableState$1 = null, $f0aae54e49e47103$var$thenableIndexCounter$1 = 0, interruptedWork = $f0aae54e49e47103$var$workInProgress;
        for(; null !== interruptedWork;)$f0aae54e49e47103$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $f0aae54e49e47103$var$workInProgress = null;
    }
}
function $f0aae54e49e47103$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $f0aae54e49e47103$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $f0aae54e49e47103$var$pendingEffectsLanes = 0;
    $f0aae54e49e47103$var$resetWorkInProgressStack();
    $f0aae54e49e47103$var$workInProgressRoot = root;
    $f0aae54e49e47103$var$workInProgress = timeoutHandle = $f0aae54e49e47103$var$createWorkInProgress(root.current, null);
    $f0aae54e49e47103$var$workInProgressRootRenderLanes = lanes;
    $f0aae54e49e47103$var$workInProgressSuspendedReason = 0;
    $f0aae54e49e47103$var$workInProgressThrownValue = null;
    $f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $f0aae54e49e47103$var$workInProgressRootIsPrerendering = $f0aae54e49e47103$var$checkIfRootIsPrerendering(root, lanes);
    $f0aae54e49e47103$var$workInProgressRootDidAttachPingListener = !1;
    $f0aae54e49e47103$var$workInProgressSuspendedRetryLanes = $f0aae54e49e47103$var$workInProgressDeferredLane = $f0aae54e49e47103$var$workInProgressRootPingedLanes = $f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes = $f0aae54e49e47103$var$workInProgressRootSkippedLanes = $f0aae54e49e47103$var$workInProgressRootExitStatus = 0;
    $f0aae54e49e47103$var$workInProgressRootRecoverableErrors = $f0aae54e49e47103$var$workInProgressRootConcurrentErrors = null;
    $f0aae54e49e47103$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $f0aae54e49e47103$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $f0aae54e49e47103$var$entangledRenderLanes = lanes;
    $f0aae54e49e47103$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $f0aae54e49e47103$var$handleThrow(root, thrownValue) {
    $f0aae54e49e47103$var$currentlyRenderingFiber = null;
    $f0aae54e49e47103$var$ReactSharedInternals.H = $f0aae54e49e47103$var$ContextOnlyDispatcher;
    thrownValue === $f0aae54e49e47103$var$SuspenseException || thrownValue === $f0aae54e49e47103$var$SuspenseActionException ? (thrownValue = $f0aae54e49e47103$var$getSuspendedThenable(), $f0aae54e49e47103$var$workInProgressSuspendedReason = 3) : thrownValue === $f0aae54e49e47103$var$SuspenseyCommitException ? (thrownValue = $f0aae54e49e47103$var$getSuspendedThenable(), $f0aae54e49e47103$var$workInProgressSuspendedReason = 4) : $f0aae54e49e47103$var$workInProgressSuspendedReason = thrownValue === $f0aae54e49e47103$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $f0aae54e49e47103$var$workInProgressThrownValue = thrownValue;
    null === $f0aae54e49e47103$var$workInProgress && ($f0aae54e49e47103$var$workInProgressRootExitStatus = 1, $f0aae54e49e47103$var$logUncaughtError(root, $f0aae54e49e47103$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $f0aae54e49e47103$var$shouldRemainOnPreviousScreen() {
    var handler = $f0aae54e49e47103$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 4194048) === $f0aae54e49e47103$var$workInProgressRootRenderLanes ? null === $f0aae54e49e47103$var$shellBoundary ? !0 : !1 : ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 62914560) === $f0aae54e49e47103$var$workInProgressRootRenderLanes || 0 !== ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 536870912) ? handler === $f0aae54e49e47103$var$shellBoundary : !1;
}
function $f0aae54e49e47103$var$pushDispatcher() {
    var prevDispatcher = $f0aae54e49e47103$var$ReactSharedInternals.H;
    $f0aae54e49e47103$var$ReactSharedInternals.H = $f0aae54e49e47103$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $f0aae54e49e47103$var$ContextOnlyDispatcher : prevDispatcher;
}
function $f0aae54e49e47103$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $f0aae54e49e47103$var$ReactSharedInternals.A;
    $f0aae54e49e47103$var$ReactSharedInternals.A = $f0aae54e49e47103$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $f0aae54e49e47103$var$renderDidSuspendDelayIfPossible() {
    $f0aae54e49e47103$var$workInProgressRootExitStatus = 4;
    $f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings || ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 4194048) !== $f0aae54e49e47103$var$workInProgressRootRenderLanes && null !== $f0aae54e49e47103$var$suspenseHandlerStackCursor.current || ($f0aae54e49e47103$var$workInProgressRootIsPrerendering = !0);
    0 === ($f0aae54e49e47103$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($f0aae54e49e47103$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $f0aae54e49e47103$var$workInProgressRoot || $f0aae54e49e47103$var$markRootSuspended($f0aae54e49e47103$var$workInProgressRoot, $f0aae54e49e47103$var$workInProgressRootRenderLanes, $f0aae54e49e47103$var$workInProgressDeferredLane, !1);
}
function $f0aae54e49e47103$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $f0aae54e49e47103$var$executionContext;
    $f0aae54e49e47103$var$executionContext |= 2;
    var prevDispatcher = $f0aae54e49e47103$var$pushDispatcher(), prevAsyncDispatcher = $f0aae54e49e47103$var$pushAsyncDispatcher();
    if ($f0aae54e49e47103$var$workInProgressRoot !== root || $f0aae54e49e47103$var$workInProgressRootRenderLanes !== lanes) $f0aae54e49e47103$var$workInProgressTransitions = null, $f0aae54e49e47103$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $f0aae54e49e47103$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $f0aae54e49e47103$var$workInProgressSuspendedReason && null !== $f0aae54e49e47103$var$workInProgress) {
            var unitOfWork = $f0aae54e49e47103$var$workInProgress, thrownValue = $f0aae54e49e47103$var$workInProgressThrownValue;
            switch($f0aae54e49e47103$var$workInProgressSuspendedReason){
                case 8:
                    $f0aae54e49e47103$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $f0aae54e49e47103$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $f0aae54e49e47103$var$workInProgressSuspendedReason;
                    $f0aae54e49e47103$var$workInProgressSuspendedReason = 0;
                    $f0aae54e49e47103$var$workInProgressThrownValue = null;
                    $f0aae54e49e47103$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $f0aae54e49e47103$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $f0aae54e49e47103$var$workInProgressSuspendedReason, $f0aae54e49e47103$var$workInProgressSuspendedReason = 0, $f0aae54e49e47103$var$workInProgressThrownValue = null, $f0aae54e49e47103$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $f0aae54e49e47103$var$workLoopSync();
        exitStatus = $f0aae54e49e47103$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $f0aae54e49e47103$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $f0aae54e49e47103$var$lastContextDependency = $f0aae54e49e47103$var$currentlyRenderingFiber$1 = null;
    $f0aae54e49e47103$var$executionContext = prevExecutionContext;
    $f0aae54e49e47103$var$ReactSharedInternals.H = prevDispatcher;
    $f0aae54e49e47103$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $f0aae54e49e47103$var$workInProgress && ($f0aae54e49e47103$var$workInProgressRoot = null, $f0aae54e49e47103$var$workInProgressRootRenderLanes = 0, $f0aae54e49e47103$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $f0aae54e49e47103$var$workLoopSync() {
    for(; null !== $f0aae54e49e47103$var$workInProgress;)$f0aae54e49e47103$var$performUnitOfWork($f0aae54e49e47103$var$workInProgress);
}
function $f0aae54e49e47103$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $f0aae54e49e47103$var$executionContext;
    $f0aae54e49e47103$var$executionContext |= 2;
    var prevDispatcher = $f0aae54e49e47103$var$pushDispatcher(), prevAsyncDispatcher = $f0aae54e49e47103$var$pushAsyncDispatcher();
    $f0aae54e49e47103$var$workInProgressRoot !== root || $f0aae54e49e47103$var$workInProgressRootRenderLanes !== lanes ? ($f0aae54e49e47103$var$workInProgressTransitions = null, $f0aae54e49e47103$var$workInProgressRootRenderTargetTime = $f0aae54e49e47103$var$now() + 500, $f0aae54e49e47103$var$prepareFreshStack(root, lanes)) : $f0aae54e49e47103$var$workInProgressRootIsPrerendering = $f0aae54e49e47103$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $f0aae54e49e47103$var$workInProgressSuspendedReason && null !== $f0aae54e49e47103$var$workInProgress) {
            lanes = $f0aae54e49e47103$var$workInProgress;
            var thrownValue = $f0aae54e49e47103$var$workInProgressThrownValue;
            b: switch($f0aae54e49e47103$var$workInProgressSuspendedReason){
                case 1:
                    $f0aae54e49e47103$var$workInProgressSuspendedReason = 0;
                    $f0aae54e49e47103$var$workInProgressThrownValue = null;
                    $f0aae54e49e47103$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($f0aae54e49e47103$var$isThenableResolved(thrownValue)) {
                        $f0aae54e49e47103$var$workInProgressSuspendedReason = 0;
                        $f0aae54e49e47103$var$workInProgressThrownValue = null;
                        $f0aae54e49e47103$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $f0aae54e49e47103$var$workInProgressSuspendedReason && 9 !== $f0aae54e49e47103$var$workInProgressSuspendedReason || $f0aae54e49e47103$var$workInProgressRoot !== root || ($f0aae54e49e47103$var$workInProgressSuspendedReason = 7);
                        $f0aae54e49e47103$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $f0aae54e49e47103$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $f0aae54e49e47103$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $f0aae54e49e47103$var$isThenableResolved(thrownValue) ? ($f0aae54e49e47103$var$workInProgressSuspendedReason = 0, $f0aae54e49e47103$var$workInProgressThrownValue = null, $f0aae54e49e47103$var$replaySuspendedUnitOfWork(lanes)) : ($f0aae54e49e47103$var$workInProgressSuspendedReason = 0, $f0aae54e49e47103$var$workInProgressThrownValue = null, $f0aae54e49e47103$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($f0aae54e49e47103$var$workInProgress.tag){
                        case 26:
                            resource = $f0aae54e49e47103$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $f0aae54e49e47103$var$workInProgress;
                            if (resource ? $f0aae54e49e47103$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $f0aae54e49e47103$var$workInProgressSuspendedReason = 0;
                                $f0aae54e49e47103$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $f0aae54e49e47103$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($f0aae54e49e47103$var$workInProgress = returnFiber, $f0aae54e49e47103$var$completeUnitOfWork(returnFiber)) : $f0aae54e49e47103$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $f0aae54e49e47103$var$workInProgressSuspendedReason = 0;
                    $f0aae54e49e47103$var$workInProgressThrownValue = null;
                    $f0aae54e49e47103$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $f0aae54e49e47103$var$workInProgressSuspendedReason = 0;
                    $f0aae54e49e47103$var$workInProgressThrownValue = null;
                    $f0aae54e49e47103$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $f0aae54e49e47103$var$resetWorkInProgressStack();
                    $f0aae54e49e47103$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(462));
            }
        }
        $f0aae54e49e47103$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $f0aae54e49e47103$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $f0aae54e49e47103$var$lastContextDependency = $f0aae54e49e47103$var$currentlyRenderingFiber$1 = null;
    $f0aae54e49e47103$var$ReactSharedInternals.H = prevDispatcher;
    $f0aae54e49e47103$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $f0aae54e49e47103$var$executionContext = prevExecutionContext;
    if (null !== $f0aae54e49e47103$var$workInProgress) return 0;
    $f0aae54e49e47103$var$workInProgressRoot = null;
    $f0aae54e49e47103$var$workInProgressRootRenderLanes = 0;
    $f0aae54e49e47103$var$finishQueueingConcurrentUpdates();
    return $f0aae54e49e47103$var$workInProgressRootExitStatus;
}
function $f0aae54e49e47103$var$workLoopConcurrentByScheduler() {
    for(; null !== $f0aae54e49e47103$var$workInProgress && !$f0aae54e49e47103$var$shouldYield();)$f0aae54e49e47103$var$performUnitOfWork($f0aae54e49e47103$var$workInProgress);
}
function $f0aae54e49e47103$var$performUnitOfWork(unitOfWork) {
    var next = $f0aae54e49e47103$var$beginWork(unitOfWork.alternate, unitOfWork, $f0aae54e49e47103$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f0aae54e49e47103$var$completeUnitOfWork(unitOfWork) : $f0aae54e49e47103$var$workInProgress = next;
}
function $f0aae54e49e47103$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $f0aae54e49e47103$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $f0aae54e49e47103$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $f0aae54e49e47103$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $f0aae54e49e47103$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $f0aae54e49e47103$var$resetHooksOnUnwind(next);
        default:
            $f0aae54e49e47103$var$unwindInterruptedWork(current, next), next = $f0aae54e49e47103$var$workInProgress = $f0aae54e49e47103$var$resetWorkInProgress(next, $f0aae54e49e47103$var$entangledRenderLanes), next = $f0aae54e49e47103$var$beginWork(current, next, $f0aae54e49e47103$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $f0aae54e49e47103$var$completeUnitOfWork(unitOfWork) : $f0aae54e49e47103$var$workInProgress = next;
}
function $f0aae54e49e47103$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $f0aae54e49e47103$var$lastContextDependency = $f0aae54e49e47103$var$currentlyRenderingFiber$1 = null;
    $f0aae54e49e47103$var$resetHooksOnUnwind(unitOfWork);
    $f0aae54e49e47103$var$thenableState$1 = null;
    $f0aae54e49e47103$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($f0aae54e49e47103$var$throwException(root, returnFiber, unitOfWork, thrownValue, $f0aae54e49e47103$var$workInProgressRootRenderLanes)) {
            $f0aae54e49e47103$var$workInProgressRootExitStatus = 1;
            $f0aae54e49e47103$var$logUncaughtError(root, $f0aae54e49e47103$var$createCapturedValueAtFiber(thrownValue, root.current));
            $f0aae54e49e47103$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $f0aae54e49e47103$var$workInProgress = returnFiber, error;
        $f0aae54e49e47103$var$workInProgressRootExitStatus = 1;
        $f0aae54e49e47103$var$logUncaughtError(root, $f0aae54e49e47103$var$createCapturedValueAtFiber(thrownValue, root.current));
        $f0aae54e49e47103$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($f0aae54e49e47103$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($f0aae54e49e47103$var$workInProgressRootIsPrerendering || 0 !== ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $f0aae54e49e47103$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $f0aae54e49e47103$var$unwindUnitOfWork(unitOfWork, root);
    } else $f0aae54e49e47103$var$completeUnitOfWork(unitOfWork);
}
function $f0aae54e49e47103$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $f0aae54e49e47103$var$unwindUnitOfWork(completedWork, $f0aae54e49e47103$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $f0aae54e49e47103$var$completeWork(completedWork.alternate, completedWork, $f0aae54e49e47103$var$entangledRenderLanes);
        if (null !== next) {
            $f0aae54e49e47103$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $f0aae54e49e47103$var$workInProgress = completedWork;
            return;
        }
        $f0aae54e49e47103$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $f0aae54e49e47103$var$workInProgressRootExitStatus && ($f0aae54e49e47103$var$workInProgressRootExitStatus = 5);
}
function $f0aae54e49e47103$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $f0aae54e49e47103$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $f0aae54e49e47103$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $f0aae54e49e47103$var$workInProgress = unitOfWork;
            return;
        }
        $f0aae54e49e47103$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $f0aae54e49e47103$var$workInProgressRootExitStatus = 6;
    $f0aae54e49e47103$var$workInProgress = null;
}
function $f0aae54e49e47103$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $f0aae54e49e47103$var$flushPendingEffects();
    while (0 !== $f0aae54e49e47103$var$pendingEffectsStatus);
    if (0 !== ($f0aae54e49e47103$var$executionContext & 6)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $f0aae54e49e47103$var$concurrentlyUpdatedLanes;
        $f0aae54e49e47103$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $f0aae54e49e47103$var$workInProgressRoot && ($f0aae54e49e47103$var$workInProgress = $f0aae54e49e47103$var$workInProgressRoot = null, $f0aae54e49e47103$var$workInProgressRootRenderLanes = 0);
        $f0aae54e49e47103$var$pendingFinishedWork = finishedWork;
        $f0aae54e49e47103$var$pendingEffectsRoot = root;
        $f0aae54e49e47103$var$pendingEffectsLanes = lanes;
        $f0aae54e49e47103$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $f0aae54e49e47103$var$pendingPassiveTransitions = transitions;
        $f0aae54e49e47103$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $f0aae54e49e47103$var$scheduleCallback$1($f0aae54e49e47103$var$NormalPriority$1, function() {
            $f0aae54e49e47103$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $f0aae54e49e47103$var$ReactSharedInternals.T;
            $f0aae54e49e47103$var$ReactSharedInternals.T = null;
            transitions = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
            $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $f0aae54e49e47103$var$executionContext;
            $f0aae54e49e47103$var$executionContext |= 4;
            try {
                $f0aae54e49e47103$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $f0aae54e49e47103$var$executionContext = spawnedLane, $f0aae54e49e47103$var$ReactDOMSharedInternals.p = transitions, $f0aae54e49e47103$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $f0aae54e49e47103$var$pendingEffectsStatus = 1;
        $f0aae54e49e47103$var$flushMutationEffects();
        $f0aae54e49e47103$var$flushLayoutEffects();
        $f0aae54e49e47103$var$flushSpawnedWork();
    }
}
function $f0aae54e49e47103$var$flushMutationEffects() {
    if (1 === $f0aae54e49e47103$var$pendingEffectsStatus) {
        $f0aae54e49e47103$var$pendingEffectsStatus = 0;
        var root = $f0aae54e49e47103$var$pendingEffectsRoot, finishedWork = $f0aae54e49e47103$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $f0aae54e49e47103$var$ReactSharedInternals.T;
            $f0aae54e49e47103$var$ReactSharedInternals.T = null;
            var previousPriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
            $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f0aae54e49e47103$var$executionContext;
            $f0aae54e49e47103$var$executionContext |= 4;
            try {
                $f0aae54e49e47103$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $f0aae54e49e47103$var$selectionInformation, curFocusedElem = $f0aae54e49e47103$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $f0aae54e49e47103$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $f0aae54e49e47103$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $f0aae54e49e47103$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $f0aae54e49e47103$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $f0aae54e49e47103$var$_enabled = !!$f0aae54e49e47103$var$eventsEnabled;
                $f0aae54e49e47103$var$selectionInformation = $f0aae54e49e47103$var$eventsEnabled = null;
            } finally{
                $f0aae54e49e47103$var$executionContext = prevExecutionContext, $f0aae54e49e47103$var$ReactDOMSharedInternals.p = previousPriority, $f0aae54e49e47103$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $f0aae54e49e47103$var$pendingEffectsStatus = 2;
    }
}
function $f0aae54e49e47103$var$flushLayoutEffects() {
    if (2 === $f0aae54e49e47103$var$pendingEffectsStatus) {
        $f0aae54e49e47103$var$pendingEffectsStatus = 0;
        var root = $f0aae54e49e47103$var$pendingEffectsRoot, finishedWork = $f0aae54e49e47103$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $f0aae54e49e47103$var$ReactSharedInternals.T;
            $f0aae54e49e47103$var$ReactSharedInternals.T = null;
            var previousPriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
            $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $f0aae54e49e47103$var$executionContext;
            $f0aae54e49e47103$var$executionContext |= 4;
            try {
                $f0aae54e49e47103$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $f0aae54e49e47103$var$executionContext = prevExecutionContext, $f0aae54e49e47103$var$ReactDOMSharedInternals.p = previousPriority, $f0aae54e49e47103$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $f0aae54e49e47103$var$pendingEffectsStatus = 3;
    }
}
function $f0aae54e49e47103$var$flushSpawnedWork() {
    if (4 === $f0aae54e49e47103$var$pendingEffectsStatus || 3 === $f0aae54e49e47103$var$pendingEffectsStatus) {
        $f0aae54e49e47103$var$pendingEffectsStatus = 0;
        $f0aae54e49e47103$var$requestPaint();
        var root = $f0aae54e49e47103$var$pendingEffectsRoot, finishedWork = $f0aae54e49e47103$var$pendingFinishedWork, lanes = $f0aae54e49e47103$var$pendingEffectsLanes, recoverableErrors = $f0aae54e49e47103$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $f0aae54e49e47103$var$pendingEffectsStatus = 5 : ($f0aae54e49e47103$var$pendingEffectsStatus = 0, $f0aae54e49e47103$var$pendingFinishedWork = $f0aae54e49e47103$var$pendingEffectsRoot = null, $f0aae54e49e47103$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $f0aae54e49e47103$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($f0aae54e49e47103$var$injectedHook && "function" === typeof $f0aae54e49e47103$var$injectedHook.onCommitFiberRoot) try {
            $f0aae54e49e47103$var$injectedHook.onCommitFiberRoot($f0aae54e49e47103$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $f0aae54e49e47103$var$ReactSharedInternals.T;
            remainingLanes = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
            $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 2;
            $f0aae54e49e47103$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $f0aae54e49e47103$var$ReactSharedInternals.T = finishedWork, $f0aae54e49e47103$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($f0aae54e49e47103$var$pendingEffectsLanes & 3) && $f0aae54e49e47103$var$flushPendingEffects();
        $f0aae54e49e47103$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $f0aae54e49e47103$var$rootWithNestedUpdates ? $f0aae54e49e47103$var$nestedUpdateCount++ : ($f0aae54e49e47103$var$nestedUpdateCount = 0, $f0aae54e49e47103$var$rootWithNestedUpdates = root) : $f0aae54e49e47103$var$nestedUpdateCount = 0;
        $f0aae54e49e47103$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $f0aae54e49e47103$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $f0aae54e49e47103$var$releaseCache(remainingLanes)));
}
function $f0aae54e49e47103$var$flushPendingEffects() {
    $f0aae54e49e47103$var$flushMutationEffects();
    $f0aae54e49e47103$var$flushLayoutEffects();
    $f0aae54e49e47103$var$flushSpawnedWork();
    return $f0aae54e49e47103$var$flushPassiveEffects();
}
function $f0aae54e49e47103$var$flushPassiveEffects() {
    if (5 !== $f0aae54e49e47103$var$pendingEffectsStatus) return !1;
    var root = $f0aae54e49e47103$var$pendingEffectsRoot, remainingLanes = $f0aae54e49e47103$var$pendingEffectsRemainingLanes;
    $f0aae54e49e47103$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $f0aae54e49e47103$var$lanesToEventPriority($f0aae54e49e47103$var$pendingEffectsLanes), prevTransition = $f0aae54e49e47103$var$ReactSharedInternals.T, previousPriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
    try {
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $f0aae54e49e47103$var$ReactSharedInternals.T = null;
        renderPriority = $f0aae54e49e47103$var$pendingPassiveTransitions;
        $f0aae54e49e47103$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $f0aae54e49e47103$var$pendingEffectsRoot, lanes = $f0aae54e49e47103$var$pendingEffectsLanes;
        $f0aae54e49e47103$var$pendingEffectsStatus = 0;
        $f0aae54e49e47103$var$pendingFinishedWork = $f0aae54e49e47103$var$pendingEffectsRoot = null;
        $f0aae54e49e47103$var$pendingEffectsLanes = 0;
        if (0 !== ($f0aae54e49e47103$var$executionContext & 6)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(331));
        var prevExecutionContext = $f0aae54e49e47103$var$executionContext;
        $f0aae54e49e47103$var$executionContext |= 4;
        $f0aae54e49e47103$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $f0aae54e49e47103$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $f0aae54e49e47103$var$executionContext = prevExecutionContext;
        $f0aae54e49e47103$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($f0aae54e49e47103$var$injectedHook && "function" === typeof $f0aae54e49e47103$var$injectedHook.onPostCommitFiberRoot) try {
            $f0aae54e49e47103$var$injectedHook.onPostCommitFiberRoot($f0aae54e49e47103$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = previousPriority, $f0aae54e49e47103$var$ReactSharedInternals.T = prevTransition, $f0aae54e49e47103$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $f0aae54e49e47103$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $f0aae54e49e47103$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $f0aae54e49e47103$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $f0aae54e49e47103$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($f0aae54e49e47103$var$markRootUpdated$1(rootFiber, 2), $f0aae54e49e47103$var$ensureRootIsScheduled(rootFiber));
}
function $f0aae54e49e47103$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $f0aae54e49e47103$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $f0aae54e49e47103$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed || !$f0aae54e49e47103$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $f0aae54e49e47103$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $f0aae54e49e47103$var$createClassErrorUpdate(2);
                instance = $f0aae54e49e47103$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($f0aae54e49e47103$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $f0aae54e49e47103$var$markRootUpdated$1(instance, 2), $f0aae54e49e47103$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $f0aae54e49e47103$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $f0aae54e49e47103$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($f0aae54e49e47103$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $f0aae54e49e47103$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $f0aae54e49e47103$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $f0aae54e49e47103$var$workInProgressRoot === root && ($f0aae54e49e47103$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $f0aae54e49e47103$var$workInProgressRootExitStatus || 3 === $f0aae54e49e47103$var$workInProgressRootExitStatus && ($f0aae54e49e47103$var$workInProgressRootRenderLanes & 62914560) === $f0aae54e49e47103$var$workInProgressRootRenderLanes && 300 > $f0aae54e49e47103$var$now() - $f0aae54e49e47103$var$globalMostRecentFallbackTime ? 0 === ($f0aae54e49e47103$var$executionContext & 2) && $f0aae54e49e47103$var$prepareFreshStack(root, 0) : $f0aae54e49e47103$var$workInProgressRootPingedLanes |= pingedLanes, $f0aae54e49e47103$var$workInProgressSuspendedRetryLanes === $f0aae54e49e47103$var$workInProgressRootRenderLanes && ($f0aae54e49e47103$var$workInProgressSuspendedRetryLanes = 0));
    $f0aae54e49e47103$var$ensureRootIsScheduled(root);
}
function $f0aae54e49e47103$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $f0aae54e49e47103$var$claimNextRetryLane());
    boundaryFiber = $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($f0aae54e49e47103$var$markRootUpdated$1(boundaryFiber, retryLane), $f0aae54e49e47103$var$ensureRootIsScheduled(boundaryFiber));
}
function $f0aae54e49e47103$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $f0aae54e49e47103$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f0aae54e49e47103$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $f0aae54e49e47103$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $f0aae54e49e47103$var$scheduleCallback$1(priorityLevel, callback) {
    return $f0aae54e49e47103$var$scheduleCallback$3(priorityLevel, callback);
}
var $f0aae54e49e47103$var$firstScheduledRoot = null, $f0aae54e49e47103$var$lastScheduledRoot = null, $f0aae54e49e47103$var$didScheduleMicrotask = !1, $f0aae54e49e47103$var$mightHavePendingSyncWork = !1, $f0aae54e49e47103$var$isFlushingWork = !1, $f0aae54e49e47103$var$currentEventTransitionLane = 0;
function $f0aae54e49e47103$var$ensureRootIsScheduled(root) {
    root !== $f0aae54e49e47103$var$lastScheduledRoot && null === root.next && (null === $f0aae54e49e47103$var$lastScheduledRoot ? $f0aae54e49e47103$var$firstScheduledRoot = $f0aae54e49e47103$var$lastScheduledRoot = root : $f0aae54e49e47103$var$lastScheduledRoot = $f0aae54e49e47103$var$lastScheduledRoot.next = root);
    $f0aae54e49e47103$var$mightHavePendingSyncWork = !0;
    $f0aae54e49e47103$var$didScheduleMicrotask || ($f0aae54e49e47103$var$didScheduleMicrotask = !0, $f0aae54e49e47103$var$scheduleImmediateRootScheduleTask());
}
function $f0aae54e49e47103$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$f0aae54e49e47103$var$isFlushingWork && $f0aae54e49e47103$var$mightHavePendingSyncWork) {
        $f0aae54e49e47103$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $f0aae54e49e47103$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $f0aae54e49e47103$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $f0aae54e49e47103$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $f0aae54e49e47103$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $f0aae54e49e47103$var$getNextLanes(root$170, root$170 === $f0aae54e49e47103$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $f0aae54e49e47103$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $f0aae54e49e47103$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $f0aae54e49e47103$var$isFlushingWork = !1;
    }
}
function $f0aae54e49e47103$var$processRootScheduleInImmediateTask() {
    $f0aae54e49e47103$var$processRootScheduleInMicrotask();
}
function $f0aae54e49e47103$var$processRootScheduleInMicrotask() {
    $f0aae54e49e47103$var$mightHavePendingSyncWork = $f0aae54e49e47103$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $f0aae54e49e47103$var$currentEventTransitionLane && $f0aae54e49e47103$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $f0aae54e49e47103$var$currentEventTransitionLane);
    for(var currentTime = $f0aae54e49e47103$var$now(), prev = null, root = $f0aae54e49e47103$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $f0aae54e49e47103$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $f0aae54e49e47103$var$firstScheduledRoot = next : prev.next = next, null === next && ($f0aae54e49e47103$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $f0aae54e49e47103$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $f0aae54e49e47103$var$pendingEffectsStatus && 5 !== $f0aae54e49e47103$var$pendingEffectsStatus || $f0aae54e49e47103$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $f0aae54e49e47103$var$currentEventTransitionLane && ($f0aae54e49e47103$var$currentEventTransitionLane = 0);
}
function $f0aae54e49e47103$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $f0aae54e49e47103$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $f0aae54e49e47103$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $f0aae54e49e47103$var$workInProgressRoot;
    suspendedLanes = $f0aae54e49e47103$var$workInProgressRootRenderLanes;
    suspendedLanes = $f0aae54e49e47103$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $f0aae54e49e47103$var$workInProgressSuspendedReason || 9 === $f0aae54e49e47103$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $f0aae54e49e47103$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $f0aae54e49e47103$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $f0aae54e49e47103$var$cancelCallback$1(pingedLanes);
        switch($f0aae54e49e47103$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $f0aae54e49e47103$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $f0aae54e49e47103$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $f0aae54e49e47103$var$IdlePriority;
                break;
            default:
                suspendedLanes = $f0aae54e49e47103$var$NormalPriority$1;
        }
        pingedLanes = $f0aae54e49e47103$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $f0aae54e49e47103$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $f0aae54e49e47103$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $f0aae54e49e47103$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $f0aae54e49e47103$var$pendingEffectsStatus && 5 !== $f0aae54e49e47103$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($f0aae54e49e47103$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $f0aae54e49e47103$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $f0aae54e49e47103$var$getNextLanes(root, root === $f0aae54e49e47103$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $f0aae54e49e47103$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $f0aae54e49e47103$var$scheduleTaskForRootDuringMicrotask(root, $f0aae54e49e47103$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $f0aae54e49e47103$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $f0aae54e49e47103$var$performSyncWorkOnRoot(root, lanes) {
    if ($f0aae54e49e47103$var$flushPendingEffects()) return null;
    $f0aae54e49e47103$var$performWorkOnRoot(root, lanes, !0);
}
function $f0aae54e49e47103$var$scheduleImmediateRootScheduleTask() {
    $f0aae54e49e47103$var$scheduleMicrotask(function() {
        0 !== ($f0aae54e49e47103$var$executionContext & 6) ? $f0aae54e49e47103$var$scheduleCallback$3($f0aae54e49e47103$var$ImmediatePriority, $f0aae54e49e47103$var$processRootScheduleInImmediateTask) : $f0aae54e49e47103$var$processRootScheduleInMicrotask();
    });
}
function $f0aae54e49e47103$var$requestTransitionLane() {
    if (0 === $f0aae54e49e47103$var$currentEventTransitionLane) {
        var actionScopeLane = $f0aae54e49e47103$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $f0aae54e49e47103$var$nextTransitionUpdateLane, $f0aae54e49e47103$var$nextTransitionUpdateLane <<= 1, 0 === ($f0aae54e49e47103$var$nextTransitionUpdateLane & 261888) && ($f0aae54e49e47103$var$nextTransitionUpdateLane = 256));
        $f0aae54e49e47103$var$currentEventTransitionLane = actionScopeLane;
    }
    return $f0aae54e49e47103$var$currentEventTransitionLane;
}
function $f0aae54e49e47103$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $f0aae54e49e47103$var$sanitizeURL("" + actionProp);
}
function $f0aae54e49e47103$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $f0aae54e49e47103$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $f0aae54e49e47103$var$coerceFormActionProp((nativeEventTarget[$f0aae54e49e47103$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$f0aae54e49e47103$var$internalPropsKey] || null) ? $f0aae54e49e47103$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $f0aae54e49e47103$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $f0aae54e49e47103$var$currentEventTransitionLane) {
                                var formData = submitter ? $f0aae54e49e47103$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $f0aae54e49e47103$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $f0aae54e49e47103$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $f0aae54e49e47103$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $f0aae54e49e47103$var$i$jscomp$inline_1577 = 0; $f0aae54e49e47103$var$i$jscomp$inline_1577 < $f0aae54e49e47103$var$simpleEventPluginEvents.length; $f0aae54e49e47103$var$i$jscomp$inline_1577++){
    var $f0aae54e49e47103$var$eventName$jscomp$inline_1578 = $f0aae54e49e47103$var$simpleEventPluginEvents[$f0aae54e49e47103$var$i$jscomp$inline_1577], $f0aae54e49e47103$var$domEventName$jscomp$inline_1579 = $f0aae54e49e47103$var$eventName$jscomp$inline_1578.toLowerCase(), $f0aae54e49e47103$var$capitalizedEvent$jscomp$inline_1580 = $f0aae54e49e47103$var$eventName$jscomp$inline_1578[0].toUpperCase() + $f0aae54e49e47103$var$eventName$jscomp$inline_1578.slice(1);
    $f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$domEventName$jscomp$inline_1579, "on" + $f0aae54e49e47103$var$capitalizedEvent$jscomp$inline_1580);
}
$f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$ANIMATION_END, "onAnimationEnd");
$f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$ANIMATION_ITERATION, "onAnimationIteration");
$f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$ANIMATION_START, "onAnimationStart");
$f0aae54e49e47103$var$registerSimpleEvent("dblclick", "onDoubleClick");
$f0aae54e49e47103$var$registerSimpleEvent("focusin", "onFocus");
$f0aae54e49e47103$var$registerSimpleEvent("focusout", "onBlur");
$f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$TRANSITION_RUN, "onTransitionRun");
$f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$TRANSITION_START, "onTransitionStart");
$f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$TRANSITION_CANCEL, "onTransitionCancel");
$f0aae54e49e47103$var$registerSimpleEvent($f0aae54e49e47103$var$TRANSITION_END, "onTransitionEnd");
$f0aae54e49e47103$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$f0aae54e49e47103$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$f0aae54e49e47103$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$f0aae54e49e47103$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$f0aae54e49e47103$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$f0aae54e49e47103$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$f0aae54e49e47103$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$f0aae54e49e47103$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$f0aae54e49e47103$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$f0aae54e49e47103$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $f0aae54e49e47103$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $f0aae54e49e47103$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($f0aae54e49e47103$var$mediaEventTypes));
function $f0aae54e49e47103$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f0aae54e49e47103$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $f0aae54e49e47103$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $f0aae54e49e47103$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$f0aae54e49e47103$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$f0aae54e49e47103$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($f0aae54e49e47103$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $f0aae54e49e47103$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $f0aae54e49e47103$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $f0aae54e49e47103$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $f0aae54e49e47103$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$f0aae54e49e47103$var$listeningMarker]) {
        rootContainerElement[$f0aae54e49e47103$var$listeningMarker] = !0;
        $f0aae54e49e47103$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($f0aae54e49e47103$var$nonDelegatedEvents.has(domEventName) || $f0aae54e49e47103$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $f0aae54e49e47103$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$f0aae54e49e47103$var$listeningMarker] || (ownerDocument[$f0aae54e49e47103$var$listeningMarker] = !0, $f0aae54e49e47103$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $f0aae54e49e47103$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($f0aae54e49e47103$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $f0aae54e49e47103$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $f0aae54e49e47103$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $f0aae54e49e47103$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$f0aae54e49e47103$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $f0aae54e49e47103$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $f0aae54e49e47103$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $f0aae54e49e47103$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $f0aae54e49e47103$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $f0aae54e49e47103$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $f0aae54e49e47103$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticTouchEvent;
                        break;
                    case $f0aae54e49e47103$var$ANIMATION_END:
                    case $f0aae54e49e47103$var$ANIMATION_ITERATION:
                    case $f0aae54e49e47103$var$ANIMATION_START:
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticAnimationEvent;
                        break;
                    case $f0aae54e49e47103$var$TRANSITION_END:
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $f0aae54e49e47103$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $f0aae54e49e47103$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($f0aae54e49e47103$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $f0aae54e49e47103$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($f0aae54e49e47103$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$f0aae54e49e47103$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $f0aae54e49e47103$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $f0aae54e49e47103$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $f0aae54e49e47103$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $f0aae54e49e47103$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $f0aae54e49e47103$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $f0aae54e49e47103$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $f0aae54e49e47103$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $f0aae54e49e47103$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $f0aae54e49e47103$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $f0aae54e49e47103$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $f0aae54e49e47103$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $f0aae54e49e47103$var$getTargetInstForChangeEvent;
                else if ($f0aae54e49e47103$var$isTextInputElement(reactName)) {
                    if ($f0aae54e49e47103$var$isInputEventSupported) getTargetInstFunc = $f0aae54e49e47103$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $f0aae54e49e47103$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $f0aae54e49e47103$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $f0aae54e49e47103$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $f0aae54e49e47103$var$getTargetInstForChangeEvent) : getTargetInstFunc = $f0aae54e49e47103$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $f0aae54e49e47103$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $f0aae54e49e47103$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $f0aae54e49e47103$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($f0aae54e49e47103$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $f0aae54e49e47103$var$activeElement = handleEventFunc, $f0aae54e49e47103$var$activeElementInst = targetInst, $f0aae54e49e47103$var$lastSelection = null;
                    break;
                case "focusout":
                    $f0aae54e49e47103$var$lastSelection = $f0aae54e49e47103$var$activeElementInst = $f0aae54e49e47103$var$activeElement = null;
                    break;
                case "mousedown":
                    $f0aae54e49e47103$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $f0aae54e49e47103$var$mouseDown = !1;
                    $f0aae54e49e47103$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($f0aae54e49e47103$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $f0aae54e49e47103$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($f0aae54e49e47103$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $f0aae54e49e47103$var$isComposing ? $f0aae54e49e47103$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($f0aae54e49e47103$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($f0aae54e49e47103$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $f0aae54e49e47103$var$isComposing && (fallbackData = $f0aae54e49e47103$var$getData()) : ($f0aae54e49e47103$var$root = nativeEventTarget, $f0aae54e49e47103$var$startText = "value" in $f0aae54e49e47103$var$root ? $f0aae54e49e47103$var$root.value : $f0aae54e49e47103$var$root.textContent, $f0aae54e49e47103$var$isComposing = !0)), handleEventFunc = $f0aae54e49e47103$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $f0aae54e49e47103$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $f0aae54e49e47103$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $f0aae54e49e47103$var$canUseTextInputEvent ? $f0aae54e49e47103$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $f0aae54e49e47103$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $f0aae54e49e47103$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $f0aae54e49e47103$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $f0aae54e49e47103$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $f0aae54e49e47103$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $f0aae54e49e47103$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $f0aae54e49e47103$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $f0aae54e49e47103$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($f0aae54e49e47103$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $f0aae54e49e47103$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($f0aae54e49e47103$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $f0aae54e49e47103$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $f0aae54e49e47103$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $f0aae54e49e47103$var$getListener(target, registrationName), null != stateNode && listeners.unshift($f0aae54e49e47103$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $f0aae54e49e47103$var$getListener(target, registrationName), null != stateNode && listeners.push($f0aae54e49e47103$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $f0aae54e49e47103$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $f0aae54e49e47103$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $f0aae54e49e47103$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($f0aae54e49e47103$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($f0aae54e49e47103$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $f0aae54e49e47103$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $f0aae54e49e47103$var$normalizeMarkupForTextOrAttribute(clientText);
    return $f0aae54e49e47103$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $f0aae54e49e47103$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $f0aae54e49e47103$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $f0aae54e49e47103$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $f0aae54e49e47103$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $f0aae54e49e47103$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $f0aae54e49e47103$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $f0aae54e49e47103$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $f0aae54e49e47103$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f0aae54e49e47103$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $f0aae54e49e47103$var$setProp(domElement, tag, "name", props.name, props, null), $f0aae54e49e47103$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $f0aae54e49e47103$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $f0aae54e49e47103$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($f0aae54e49e47103$var$setProp(domElement, tag, "encType", props.encType, props, null), $f0aae54e49e47103$var$setProp(domElement, tag, "method", props.method, props, null), $f0aae54e49e47103$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $f0aae54e49e47103$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f0aae54e49e47103$var$noop$1);
            break;
        case "onScroll":
            null != value && $f0aae54e49e47103$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f0aae54e49e47103$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $f0aae54e49e47103$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("toggle", domElement);
            $f0aae54e49e47103$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $f0aae54e49e47103$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $f0aae54e49e47103$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $f0aae54e49e47103$var$aliases.get(key) || key, $f0aae54e49e47103$var$setValueForAttribute(domElement, key, value);
    }
}
function $f0aae54e49e47103$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $f0aae54e49e47103$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $f0aae54e49e47103$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $f0aae54e49e47103$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $f0aae54e49e47103$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $f0aae54e49e47103$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $f0aae54e49e47103$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$f0aae54e49e47103$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$f0aae54e49e47103$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $f0aae54e49e47103$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $f0aae54e49e47103$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("error", domElement);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($f0aae54e49e47103$var$formatProdErrorMessage(137, tag));
                    default:
                        $f0aae54e49e47103$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $f0aae54e49e47103$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $f0aae54e49e47103$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $f0aae54e49e47103$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $f0aae54e49e47103$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $f0aae54e49e47103$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $f0aae54e49e47103$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(91));
                    break;
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $f0aae54e49e47103$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("toggle", domElement);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("cancel", domElement);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $f0aae54e49e47103$var$mediaEventTypes.length; hasSrc++)$f0aae54e49e47103$var$listenToNonDelegatedEvent($f0aae54e49e47103$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("error", domElement);
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $f0aae54e49e47103$var$listenToNonDelegatedEvent("error", domElement), $f0aae54e49e47103$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($f0aae54e49e47103$var$formatProdErrorMessage(137, tag));
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($f0aae54e49e47103$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $f0aae54e49e47103$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $f0aae54e49e47103$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $f0aae54e49e47103$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $f0aae54e49e47103$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $f0aae54e49e47103$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $f0aae54e49e47103$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $f0aae54e49e47103$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $f0aae54e49e47103$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $f0aae54e49e47103$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $f0aae54e49e47103$var$updateOptions(domElement, !!lastProps, tag, !0) : $f0aae54e49e47103$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $f0aae54e49e47103$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $f0aae54e49e47103$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $f0aae54e49e47103$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $f0aae54e49e47103$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($f0aae54e49e47103$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $f0aae54e49e47103$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $f0aae54e49e47103$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $f0aae54e49e47103$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $f0aae54e49e47103$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $f0aae54e49e47103$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $f0aae54e49e47103$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $f0aae54e49e47103$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $f0aae54e49e47103$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $f0aae54e49e47103$var$eventsEnabled = null, $f0aae54e49e47103$var$selectionInformation = null;
function $f0aae54e49e47103$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $f0aae54e49e47103$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $f0aae54e49e47103$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $f0aae54e49e47103$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $f0aae54e49e47103$var$currentPopstateTransitionEvent = null;
function $f0aae54e49e47103$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $f0aae54e49e47103$var$currentPopstateTransitionEvent) return !1;
        $f0aae54e49e47103$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $f0aae54e49e47103$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $f0aae54e49e47103$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $f0aae54e49e47103$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $f0aae54e49e47103$var$localPromise = "function" === typeof Promise ? Promise : void 0, $f0aae54e49e47103$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $f0aae54e49e47103$var$localPromise ? function(callback) {
    return $f0aae54e49e47103$var$localPromise.resolve(null).then(callback).catch($f0aae54e49e47103$var$handleErrorInNextTick);
} : $f0aae54e49e47103$var$scheduleTimeout;
function $f0aae54e49e47103$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $f0aae54e49e47103$var$isSingletonScope(type) {
    return "head" === type;
}
function $f0aae54e49e47103$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $f0aae54e49e47103$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $f0aae54e49e47103$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $f0aae54e49e47103$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$f0aae54e49e47103$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $f0aae54e49e47103$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $f0aae54e49e47103$var$retryIfBlockedOn(hydrationInstance);
}
function $f0aae54e49e47103$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $f0aae54e49e47103$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $f0aae54e49e47103$var$clearContainerSparingly(node);
                $f0aae54e49e47103$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $f0aae54e49e47103$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$f0aae54e49e47103$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $f0aae54e49e47103$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $f0aae54e49e47103$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f0aae54e49e47103$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f0aae54e49e47103$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $f0aae54e49e47103$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $f0aae54e49e47103$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $f0aae54e49e47103$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $f0aae54e49e47103$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $f0aae54e49e47103$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $f0aae54e49e47103$var$previousHydratableOnEnteringScopedSingleton = null;
function $f0aae54e49e47103$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $f0aae54e49e47103$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $f0aae54e49e47103$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $f0aae54e49e47103$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $f0aae54e49e47103$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(451));
    }
}
function $f0aae54e49e47103$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $f0aae54e49e47103$var$detachDeletedInstance(instance);
}
var $f0aae54e49e47103$var$preloadPropsMap = new Map(), $f0aae54e49e47103$var$preconnectsSet = new Set();
function $f0aae54e49e47103$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $f0aae54e49e47103$var$previousDispatcher = $f0aae54e49e47103$var$ReactDOMSharedInternals.d;
$f0aae54e49e47103$var$ReactDOMSharedInternals.d = {
    f: $f0aae54e49e47103$var$flushSyncWork,
    r: $f0aae54e49e47103$var$requestFormReset,
    D: $f0aae54e49e47103$var$prefetchDNS,
    C: $f0aae54e49e47103$var$preconnect,
    L: $f0aae54e49e47103$var$preload,
    m: $f0aae54e49e47103$var$preloadModule,
    X: $f0aae54e49e47103$var$preinitScript,
    S: $f0aae54e49e47103$var$preinitStyle,
    M: $f0aae54e49e47103$var$preinitModuleScript
};
function $f0aae54e49e47103$var$flushSyncWork() {
    var previousWasRendering = $f0aae54e49e47103$var$previousDispatcher.f(), wasRendering = $f0aae54e49e47103$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $f0aae54e49e47103$var$requestFormReset(form) {
    var formInst = $f0aae54e49e47103$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $f0aae54e49e47103$var$requestFormReset$1(formInst) : $f0aae54e49e47103$var$previousDispatcher.r(form);
}
var $f0aae54e49e47103$var$globalDocument = "undefined" === typeof document ? null : document;
function $f0aae54e49e47103$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $f0aae54e49e47103$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $f0aae54e49e47103$var$preconnectsSet.has(limitedEscapedHref) || ($f0aae54e49e47103$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $f0aae54e49e47103$var$setInitialProperties(href, "link", rel), $f0aae54e49e47103$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $f0aae54e49e47103$var$prefetchDNS(href) {
    $f0aae54e49e47103$var$previousDispatcher.D(href);
    $f0aae54e49e47103$var$preconnectAs("dns-prefetch", href, null);
}
function $f0aae54e49e47103$var$preconnect(href, crossOrigin) {
    $f0aae54e49e47103$var$previousDispatcher.C(href, crossOrigin);
    $f0aae54e49e47103$var$preconnectAs("preconnect", href, crossOrigin);
}
function $f0aae54e49e47103$var$preload(href, as, options) {
    $f0aae54e49e47103$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $f0aae54e49e47103$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $f0aae54e49e47103$var$getStyleKey(href);
                break;
            case "script":
                key = $f0aae54e49e47103$var$getScriptKey(href);
        }
        $f0aae54e49e47103$var$preloadPropsMap.has(key) || (href = $f0aae54e49e47103$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $f0aae54e49e47103$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($f0aae54e49e47103$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($f0aae54e49e47103$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $f0aae54e49e47103$var$setInitialProperties(as, "link", href), $f0aae54e49e47103$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $f0aae54e49e47103$var$preloadModule(href, options) {
    $f0aae54e49e47103$var$previousDispatcher.m(href, options);
    var ownerDocument = $f0aae54e49e47103$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $f0aae54e49e47103$var$getScriptKey(href);
        }
        if (!$f0aae54e49e47103$var$preloadPropsMap.has(key) && (href = $f0aae54e49e47103$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $f0aae54e49e47103$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($f0aae54e49e47103$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $f0aae54e49e47103$var$setInitialProperties(as, "link", href);
            $f0aae54e49e47103$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $f0aae54e49e47103$var$preinitStyle(href, precedence, options) {
    $f0aae54e49e47103$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $f0aae54e49e47103$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $f0aae54e49e47103$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $f0aae54e49e47103$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($f0aae54e49e47103$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $f0aae54e49e47103$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $f0aae54e49e47103$var$preloadPropsMap.get(key)) && $f0aae54e49e47103$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $f0aae54e49e47103$var$markNodeAsHoistable(link);
                $f0aae54e49e47103$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $f0aae54e49e47103$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $f0aae54e49e47103$var$preinitScript(src, options) {
    $f0aae54e49e47103$var$previousDispatcher.X(src, options);
    var ownerDocument = $f0aae54e49e47103$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f0aae54e49e47103$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f0aae54e49e47103$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f0aae54e49e47103$var$getScriptSelectorFromKey(key)), resource || (src = $f0aae54e49e47103$var$assign({
            src: src,
            async: !0
        }, options), (options = $f0aae54e49e47103$var$preloadPropsMap.get(key)) && $f0aae54e49e47103$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f0aae54e49e47103$var$markNodeAsHoistable(resource), $f0aae54e49e47103$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f0aae54e49e47103$var$preinitModuleScript(src, options) {
    $f0aae54e49e47103$var$previousDispatcher.M(src, options);
    var ownerDocument = $f0aae54e49e47103$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $f0aae54e49e47103$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $f0aae54e49e47103$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($f0aae54e49e47103$var$getScriptSelectorFromKey(key)), resource || (src = $f0aae54e49e47103$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $f0aae54e49e47103$var$preloadPropsMap.get(key)) && $f0aae54e49e47103$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $f0aae54e49e47103$var$markNodeAsHoistable(resource), $f0aae54e49e47103$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $f0aae54e49e47103$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $f0aae54e49e47103$var$rootInstanceStackCursor.current) ? $f0aae54e49e47103$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $f0aae54e49e47103$var$getStyleKey(pendingProps.href), pendingProps = $f0aae54e49e47103$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $f0aae54e49e47103$var$getStyleKey(pendingProps.href);
                var styles$243 = $f0aae54e49e47103$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($f0aae54e49e47103$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $f0aae54e49e47103$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $f0aae54e49e47103$var$preloadPropsMap.set(type, pendingProps), styles$243 || $f0aae54e49e47103$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $f0aae54e49e47103$var$getScriptKey(pendingProps), pendingProps = $f0aae54e49e47103$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(444, type));
    }
}
function $f0aae54e49e47103$var$getStyleKey(href) {
    return 'href="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $f0aae54e49e47103$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $f0aae54e49e47103$var$stylesheetPropsFromRawProps(rawProps) {
    return $f0aae54e49e47103$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $f0aae54e49e47103$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $f0aae54e49e47103$var$setInitialProperties(key, "link", preloadProps), $f0aae54e49e47103$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $f0aae54e49e47103$var$getScriptKey(src) {
    return '[src="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $f0aae54e49e47103$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $f0aae54e49e47103$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $f0aae54e49e47103$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $f0aae54e49e47103$var$markNodeAsHoistable(instance), instance;
            var styleProps = $f0aae54e49e47103$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $f0aae54e49e47103$var$markNodeAsHoistable(instance);
            $f0aae54e49e47103$var$setInitialProperties(instance, "style", styleProps);
            $f0aae54e49e47103$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $f0aae54e49e47103$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($f0aae54e49e47103$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $f0aae54e49e47103$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $f0aae54e49e47103$var$stylesheetPropsFromRawProps(props);
            (styleProps = $f0aae54e49e47103$var$preloadPropsMap.get(styleProps)) && $f0aae54e49e47103$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $f0aae54e49e47103$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f0aae54e49e47103$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $f0aae54e49e47103$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $f0aae54e49e47103$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($f0aae54e49e47103$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $f0aae54e49e47103$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $f0aae54e49e47103$var$preloadPropsMap.get(instance$249)) instance = $f0aae54e49e47103$var$assign({}, props), $f0aae54e49e47103$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $f0aae54e49e47103$var$markNodeAsHoistable(styleProps);
            $f0aae54e49e47103$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($f0aae54e49e47103$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $f0aae54e49e47103$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $f0aae54e49e47103$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $f0aae54e49e47103$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $f0aae54e49e47103$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $f0aae54e49e47103$var$tagCaches = null;
function $f0aae54e49e47103$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $f0aae54e49e47103$var$tagCaches) {
        var cache = new Map();
        var caches = $f0aae54e49e47103$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $f0aae54e49e47103$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$f0aae54e49e47103$var$internalHoistableMarker] || node[$f0aae54e49e47103$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $f0aae54e49e47103$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $f0aae54e49e47103$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $f0aae54e49e47103$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $f0aae54e49e47103$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $f0aae54e49e47103$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($f0aae54e49e47103$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $f0aae54e49e47103$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $f0aae54e49e47103$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $f0aae54e49e47103$var$stylesheetPropsFromRawProps(props);
            (key = $f0aae54e49e47103$var$preloadPropsMap.get(key)) && $f0aae54e49e47103$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $f0aae54e49e47103$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $f0aae54e49e47103$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $f0aae54e49e47103$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $f0aae54e49e47103$var$estimatedBytesWithinLimit = 0;
function $f0aae54e49e47103$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $f0aae54e49e47103$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $f0aae54e49e47103$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $f0aae54e49e47103$var$estimatedBytesWithinLimit && ($f0aae54e49e47103$var$estimatedBytesWithinLimit = 62500 * $f0aae54e49e47103$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $f0aae54e49e47103$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $f0aae54e49e47103$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $f0aae54e49e47103$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $f0aae54e49e47103$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $f0aae54e49e47103$var$precedencesByRoot = null;
function $f0aae54e49e47103$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $f0aae54e49e47103$var$precedencesByRoot = new Map(), resources.forEach($f0aae54e49e47103$var$insertStylesheetIntoRoot, state), $f0aae54e49e47103$var$precedencesByRoot = null, $f0aae54e49e47103$var$onUnsuspend.call(state));
}
function $f0aae54e49e47103$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $f0aae54e49e47103$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $f0aae54e49e47103$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $f0aae54e49e47103$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $f0aae54e49e47103$var$HostTransitionContext = {
    $$typeof: $f0aae54e49e47103$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $f0aae54e49e47103$var$sharedNotPendingObject,
    _currentValue2: $f0aae54e49e47103$var$sharedNotPendingObject,
    _threadCount: 0
};
function $f0aae54e49e47103$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $f0aae54e49e47103$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $f0aae54e49e47103$var$createLaneMap(0);
    this.hiddenUpdates = $f0aae54e49e47103$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $f0aae54e49e47103$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $f0aae54e49e47103$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $f0aae54e49e47103$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $f0aae54e49e47103$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $f0aae54e49e47103$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $f0aae54e49e47103$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $f0aae54e49e47103$var$emptyContextObject;
    parentComponent = $f0aae54e49e47103$var$emptyContextObject;
    return parentComponent;
}
function $f0aae54e49e47103$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $f0aae54e49e47103$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $f0aae54e49e47103$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $f0aae54e49e47103$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($f0aae54e49e47103$var$scheduleUpdateOnFiber(element, rootFiber, lane), $f0aae54e49e47103$var$entangleTransitions(element, rootFiber, lane));
}
function $f0aae54e49e47103$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $f0aae54e49e47103$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $f0aae54e49e47103$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $f0aae54e49e47103$var$markRetryLaneImpl(fiber, retryLane);
}
function $f0aae54e49e47103$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $f0aae54e49e47103$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $f0aae54e49e47103$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $f0aae54e49e47103$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $f0aae54e49e47103$var$requestUpdateLane();
        lane = $f0aae54e49e47103$var$getBumpedLaneForHydrationByLane(lane);
        var root = $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $f0aae54e49e47103$var$scheduleUpdateOnFiber(root, fiber, lane);
        $f0aae54e49e47103$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $f0aae54e49e47103$var$_enabled = !0;
function $f0aae54e49e47103$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f0aae54e49e47103$var$ReactSharedInternals.T;
    $f0aae54e49e47103$var$ReactSharedInternals.T = null;
    var previousPriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
    try {
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 2, $f0aae54e49e47103$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = previousPriority, $f0aae54e49e47103$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f0aae54e49e47103$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $f0aae54e49e47103$var$ReactSharedInternals.T;
    $f0aae54e49e47103$var$ReactSharedInternals.T = null;
    var previousPriority = $f0aae54e49e47103$var$ReactDOMSharedInternals.p;
    try {
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = 8, $f0aae54e49e47103$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $f0aae54e49e47103$var$ReactDOMSharedInternals.p = previousPriority, $f0aae54e49e47103$var$ReactSharedInternals.T = prevTransition;
    }
}
function $f0aae54e49e47103$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($f0aae54e49e47103$var$_enabled) {
        var blockedOn = $f0aae54e49e47103$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $f0aae54e49e47103$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f0aae54e49e47103$var$return_targetInst, targetContainer), $f0aae54e49e47103$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($f0aae54e49e47103$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($f0aae54e49e47103$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $f0aae54e49e47103$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $f0aae54e49e47103$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $f0aae54e49e47103$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $f0aae54e49e47103$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $f0aae54e49e47103$var$ensureRootIsScheduled(fiber);
                                0 === ($f0aae54e49e47103$var$executionContext & 6) && ($f0aae54e49e47103$var$workInProgressRootRenderTargetTime = $f0aae54e49e47103$var$now() + 500, $f0aae54e49e47103$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $f0aae54e49e47103$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $f0aae54e49e47103$var$scheduleUpdateOnFiber(root, fiber, 2), $f0aae54e49e47103$var$flushSyncWork$1(), $f0aae54e49e47103$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $f0aae54e49e47103$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $f0aae54e49e47103$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $f0aae54e49e47103$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $f0aae54e49e47103$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $f0aae54e49e47103$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $f0aae54e49e47103$var$getEventTarget(nativeEvent);
    return $f0aae54e49e47103$var$findInstanceBlockingTarget(nativeEvent);
}
var $f0aae54e49e47103$var$return_targetInst = null;
function $f0aae54e49e47103$var$findInstanceBlockingTarget(targetNode) {
    $f0aae54e49e47103$var$return_targetInst = null;
    targetNode = $f0aae54e49e47103$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $f0aae54e49e47103$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $f0aae54e49e47103$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $f0aae54e49e47103$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $f0aae54e49e47103$var$return_targetInst = targetNode;
    return null;
}
function $f0aae54e49e47103$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($f0aae54e49e47103$var$getCurrentPriorityLevel()){
                case $f0aae54e49e47103$var$ImmediatePriority:
                    return 2;
                case $f0aae54e49e47103$var$UserBlockingPriority:
                    return 8;
                case $f0aae54e49e47103$var$NormalPriority$1:
                case $f0aae54e49e47103$var$LowPriority:
                    return 32;
                case $f0aae54e49e47103$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $f0aae54e49e47103$var$hasScheduledReplayAttempt = !1, $f0aae54e49e47103$var$queuedFocus = null, $f0aae54e49e47103$var$queuedDrag = null, $f0aae54e49e47103$var$queuedMouse = null, $f0aae54e49e47103$var$queuedPointers = new Map(), $f0aae54e49e47103$var$queuedPointerCaptures = new Map(), $f0aae54e49e47103$var$queuedExplicitHydrationTargets = [], $f0aae54e49e47103$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $f0aae54e49e47103$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $f0aae54e49e47103$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $f0aae54e49e47103$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $f0aae54e49e47103$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $f0aae54e49e47103$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $f0aae54e49e47103$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $f0aae54e49e47103$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $f0aae54e49e47103$var$getInstanceFromNode(blockedOn), null !== blockedOn && $f0aae54e49e47103$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $f0aae54e49e47103$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $f0aae54e49e47103$var$queuedFocus = $f0aae54e49e47103$var$accumulateOrCreateContinuousQueuedReplayableEvent($f0aae54e49e47103$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $f0aae54e49e47103$var$queuedDrag = $f0aae54e49e47103$var$accumulateOrCreateContinuousQueuedReplayableEvent($f0aae54e49e47103$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $f0aae54e49e47103$var$queuedMouse = $f0aae54e49e47103$var$accumulateOrCreateContinuousQueuedReplayableEvent($f0aae54e49e47103$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $f0aae54e49e47103$var$queuedPointers.set(pointerId, $f0aae54e49e47103$var$accumulateOrCreateContinuousQueuedReplayableEvent($f0aae54e49e47103$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $f0aae54e49e47103$var$queuedPointerCaptures.set(pointerId, $f0aae54e49e47103$var$accumulateOrCreateContinuousQueuedReplayableEvent($f0aae54e49e47103$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $f0aae54e49e47103$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $f0aae54e49e47103$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $f0aae54e49e47103$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $f0aae54e49e47103$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f0aae54e49e47103$var$runWithPriority(queuedTarget.priority, function() {
                        $f0aae54e49e47103$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $f0aae54e49e47103$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $f0aae54e49e47103$var$runWithPriority(queuedTarget.priority, function() {
                        $f0aae54e49e47103$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $f0aae54e49e47103$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $f0aae54e49e47103$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $f0aae54e49e47103$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $f0aae54e49e47103$var$currentReplayingEvent = null;
        } else return targetContainers = $f0aae54e49e47103$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $f0aae54e49e47103$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $f0aae54e49e47103$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $f0aae54e49e47103$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $f0aae54e49e47103$var$replayUnblockedEvents() {
    $f0aae54e49e47103$var$hasScheduledReplayAttempt = !1;
    null !== $f0aae54e49e47103$var$queuedFocus && $f0aae54e49e47103$var$attemptReplayContinuousQueuedEvent($f0aae54e49e47103$var$queuedFocus) && ($f0aae54e49e47103$var$queuedFocus = null);
    null !== $f0aae54e49e47103$var$queuedDrag && $f0aae54e49e47103$var$attemptReplayContinuousQueuedEvent($f0aae54e49e47103$var$queuedDrag) && ($f0aae54e49e47103$var$queuedDrag = null);
    null !== $f0aae54e49e47103$var$queuedMouse && $f0aae54e49e47103$var$attemptReplayContinuousQueuedEvent($f0aae54e49e47103$var$queuedMouse) && ($f0aae54e49e47103$var$queuedMouse = null);
    $f0aae54e49e47103$var$queuedPointers.forEach($f0aae54e49e47103$var$attemptReplayContinuousQueuedEventInMap);
    $f0aae54e49e47103$var$queuedPointerCaptures.forEach($f0aae54e49e47103$var$attemptReplayContinuousQueuedEventInMap);
}
function $f0aae54e49e47103$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $f0aae54e49e47103$var$hasScheduledReplayAttempt || ($f0aae54e49e47103$var$hasScheduledReplayAttempt = !0, $hDqGr.unstable_scheduleCallback($hDqGr.unstable_NormalPriority, $f0aae54e49e47103$var$replayUnblockedEvents)));
}
var $f0aae54e49e47103$var$lastScheduledReplayQueue = null;
function $f0aae54e49e47103$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $f0aae54e49e47103$var$lastScheduledReplayQueue !== formReplayingQueue && ($f0aae54e49e47103$var$lastScheduledReplayQueue = formReplayingQueue, $hDqGr.unstable_scheduleCallback($hDqGr.unstable_NormalPriority, function() {
        $f0aae54e49e47103$var$lastScheduledReplayQueue === formReplayingQueue && ($f0aae54e49e47103$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $f0aae54e49e47103$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $f0aae54e49e47103$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $f0aae54e49e47103$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $f0aae54e49e47103$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $f0aae54e49e47103$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $f0aae54e49e47103$var$queuedFocus && $f0aae54e49e47103$var$scheduleCallbackIfUnblocked($f0aae54e49e47103$var$queuedFocus, unblocked);
    null !== $f0aae54e49e47103$var$queuedDrag && $f0aae54e49e47103$var$scheduleCallbackIfUnblocked($f0aae54e49e47103$var$queuedDrag, unblocked);
    null !== $f0aae54e49e47103$var$queuedMouse && $f0aae54e49e47103$var$scheduleCallbackIfUnblocked($f0aae54e49e47103$var$queuedMouse, unblocked);
    $f0aae54e49e47103$var$queuedPointers.forEach(unblock);
    $f0aae54e49e47103$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $f0aae54e49e47103$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $f0aae54e49e47103$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $f0aae54e49e47103$var$queuedExplicitHydrationTargets.length && (i = $f0aae54e49e47103$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$f0aae54e49e47103$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $f0aae54e49e47103$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$f0aae54e49e47103$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $f0aae54e49e47103$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$f0aae54e49e47103$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $f0aae54e49e47103$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $f0aae54e49e47103$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $f0aae54e49e47103$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $f0aae54e49e47103$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f0aae54e49e47103$var$ReactDOMHydrationRoot.prototype.render = $f0aae54e49e47103$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(409));
    var current = root.current, lane = $f0aae54e49e47103$var$requestUpdateLane();
    $f0aae54e49e47103$var$updateContainerImpl(current, lane, children, root, null, null);
};
$f0aae54e49e47103$var$ReactDOMHydrationRoot.prototype.unmount = $f0aae54e49e47103$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $f0aae54e49e47103$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $f0aae54e49e47103$var$flushSyncWork$1();
        container[$f0aae54e49e47103$var$internalContainerInstanceKey] = null;
    }
};
function $f0aae54e49e47103$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$f0aae54e49e47103$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $f0aae54e49e47103$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $f0aae54e49e47103$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $f0aae54e49e47103$var$queuedExplicitHydrationTargets[i].priority; i++);
        $f0aae54e49e47103$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $f0aae54e49e47103$var$attemptExplicitHydrationTarget(target);
    }
};
var $f0aae54e49e47103$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $kYL7Z.version;
if ("19.2.4" !== $f0aae54e49e47103$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(527, $f0aae54e49e47103$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.4"));
$f0aae54e49e47103$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($f0aae54e49e47103$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $f0aae54e49e47103$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $f0aae54e49e47103$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $f0aae54e49e47103$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.4",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $f0aae54e49e47103$var$ReactSharedInternals,
    reconcilerVersion: "19.2.4"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $f0aae54e49e47103$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$f0aae54e49e47103$var$hook$jscomp$inline_2348.isDisabled && $f0aae54e49e47103$var$hook$jscomp$inline_2348.supportsFiber) try {
        $f0aae54e49e47103$var$rendererID = $f0aae54e49e47103$var$hook$jscomp$inline_2348.inject($f0aae54e49e47103$var$internals$jscomp$inline_2347), $f0aae54e49e47103$var$injectedHook = $f0aae54e49e47103$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$f0aae54e49e47103$export$882461b6382ed46c = function(container, options) {
    if (!$f0aae54e49e47103$var$isValidContainer(container)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f0aae54e49e47103$var$defaultOnUncaughtError, onCaughtError = $f0aae54e49e47103$var$defaultOnCaughtError, onRecoverableError = $f0aae54e49e47103$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $f0aae54e49e47103$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $f0aae54e49e47103$var$defaultOnDefaultTransitionIndicator);
    container[$f0aae54e49e47103$var$internalContainerInstanceKey] = options.current;
    $f0aae54e49e47103$var$listenToAllSupportedEvents(container);
    return new $f0aae54e49e47103$var$ReactDOMRoot(options);
};
$f0aae54e49e47103$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$f0aae54e49e47103$var$isValidContainer(container)) throw Error($f0aae54e49e47103$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $f0aae54e49e47103$var$defaultOnUncaughtError, onCaughtError = $f0aae54e49e47103$var$defaultOnCaughtError, onRecoverableError = $f0aae54e49e47103$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $f0aae54e49e47103$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $f0aae54e49e47103$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $f0aae54e49e47103$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $f0aae54e49e47103$var$requestUpdateLane();
    isStrictMode = $f0aae54e49e47103$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $f0aae54e49e47103$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $f0aae54e49e47103$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $f0aae54e49e47103$var$markRootUpdated$1(initialChildren, options);
    $f0aae54e49e47103$var$ensureRootIsScheduled(initialChildren);
    container[$f0aae54e49e47103$var$internalContainerInstanceKey] = initialChildren.current;
    $f0aae54e49e47103$var$listenToAllSupportedEvents(container);
    return new $f0aae54e49e47103$var$ReactDOMHydrationRoot(initialChildren);
};
$f0aae54e49e47103$export$83d89fbfd8236492 = "19.2.4";

});
parcelRegister("hDqGr", function(module, exports) {
'use strict';

module.exports = (parcelRequire("ieElr"));

});
parcelRegister("ieElr", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $d468d46ecb545e2a$export$c4744153514ff05d, (v) => $d468d46ecb545e2a$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $d468d46ecb545e2a$export$3e506c1ccc9cc1a7, (v) => $d468d46ecb545e2a$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $d468d46ecb545e2a$export$e26fe2ed2fa76875, (v) => $d468d46ecb545e2a$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $d468d46ecb545e2a$export$502329bbf4b505b1, (v) => $d468d46ecb545e2a$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $d468d46ecb545e2a$export$6e3807111c4874c4, (v) => $d468d46ecb545e2a$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $d468d46ecb545e2a$export$c27134553091fb3a, (v) => $d468d46ecb545e2a$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $d468d46ecb545e2a$export$33ee1acdc04fd2a2, (v) => $d468d46ecb545e2a$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $d468d46ecb545e2a$export$b00a404bbd5edef2, (v) => $d468d46ecb545e2a$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $d468d46ecb545e2a$export$d66a1c1c77bd778b, (v) => $d468d46ecb545e2a$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $d468d46ecb545e2a$export$d3dfb8e4810cb555, (v) => $d468d46ecb545e2a$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $d468d46ecb545e2a$export$72fdf0e06517287b, (v) => $d468d46ecb545e2a$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $d468d46ecb545e2a$export$816d2913ae6b83b1, (v) => $d468d46ecb545e2a$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $d468d46ecb545e2a$export$61bcfe829111a1d0, (v) => $d468d46ecb545e2a$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $d468d46ecb545e2a$export$7ee8c9beb337bc3f, (v) => $d468d46ecb545e2a$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $d468d46ecb545e2a$export$b5836b71941fa3ed, (v) => $d468d46ecb545e2a$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $d468d46ecb545e2a$export$cf845f2c119da08a, (v) => $d468d46ecb545e2a$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d468d46ecb545e2a$export$c4744153514ff05d;
var $d468d46ecb545e2a$export$3e506c1ccc9cc1a7;
var $d468d46ecb545e2a$export$e26fe2ed2fa76875;
var $d468d46ecb545e2a$export$502329bbf4b505b1;
var $d468d46ecb545e2a$export$6e3807111c4874c4;
var $d468d46ecb545e2a$export$c27134553091fb3a;
var $d468d46ecb545e2a$export$33ee1acdc04fd2a2;
var $d468d46ecb545e2a$export$b00a404bbd5edef2;
var $d468d46ecb545e2a$export$d66a1c1c77bd778b;
var $d468d46ecb545e2a$export$d3dfb8e4810cb555;
var $d468d46ecb545e2a$export$72fdf0e06517287b;
var $d468d46ecb545e2a$export$816d2913ae6b83b1;
var $d468d46ecb545e2a$export$61bcfe829111a1d0;
var $d468d46ecb545e2a$export$7ee8c9beb337bc3f;
var $d468d46ecb545e2a$export$b5836b71941fa3ed;
var $d468d46ecb545e2a$export$cf845f2c119da08a;
"use strict";
function $d468d46ecb545e2a$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $d468d46ecb545e2a$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $d468d46ecb545e2a$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $d468d46ecb545e2a$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $d468d46ecb545e2a$var$compare(left, last)) rightIndex < length && 0 > $d468d46ecb545e2a$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $d468d46ecb545e2a$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $d468d46ecb545e2a$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$d468d46ecb545e2a$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $d468d46ecb545e2a$var$localPerformance = performance;
    $d468d46ecb545e2a$export$c4744153514ff05d = function() {
        return $d468d46ecb545e2a$var$localPerformance.now();
    };
} else {
    var $d468d46ecb545e2a$var$localDate = Date, $d468d46ecb545e2a$var$initialTime = $d468d46ecb545e2a$var$localDate.now();
    $d468d46ecb545e2a$export$c4744153514ff05d = function() {
        return $d468d46ecb545e2a$var$localDate.now() - $d468d46ecb545e2a$var$initialTime;
    };
}
var $d468d46ecb545e2a$var$taskQueue = [], $d468d46ecb545e2a$var$timerQueue = [], $d468d46ecb545e2a$var$taskIdCounter = 1, $d468d46ecb545e2a$var$currentTask = null, $d468d46ecb545e2a$var$currentPriorityLevel = 3, $d468d46ecb545e2a$var$isPerformingWork = !1, $d468d46ecb545e2a$var$isHostCallbackScheduled = !1, $d468d46ecb545e2a$var$isHostTimeoutScheduled = !1, $d468d46ecb545e2a$var$needsPaint = !1, $d468d46ecb545e2a$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $d468d46ecb545e2a$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $d468d46ecb545e2a$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $d468d46ecb545e2a$var$advanceTimers(currentTime) {
    for(var timer = $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$timerQueue); null !== timer;){
        if (null === timer.callback) $d468d46ecb545e2a$var$pop($d468d46ecb545e2a$var$timerQueue);
        else if (timer.startTime <= currentTime) $d468d46ecb545e2a$var$pop($d468d46ecb545e2a$var$timerQueue), timer.sortIndex = timer.expirationTime, $d468d46ecb545e2a$var$push($d468d46ecb545e2a$var$taskQueue, timer);
        else break;
        timer = $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$timerQueue);
    }
}
function $d468d46ecb545e2a$var$handleTimeout(currentTime) {
    $d468d46ecb545e2a$var$isHostTimeoutScheduled = !1;
    $d468d46ecb545e2a$var$advanceTimers(currentTime);
    if (!$d468d46ecb545e2a$var$isHostCallbackScheduled) {
        if (null !== $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$taskQueue)) $d468d46ecb545e2a$var$isHostCallbackScheduled = !0, $d468d46ecb545e2a$var$isMessageLoopRunning || ($d468d46ecb545e2a$var$isMessageLoopRunning = !0, $d468d46ecb545e2a$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$timerQueue);
            null !== firstTimer && $d468d46ecb545e2a$var$requestHostTimeout($d468d46ecb545e2a$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $d468d46ecb545e2a$var$isMessageLoopRunning = !1, $d468d46ecb545e2a$var$taskTimeoutID = -1, $d468d46ecb545e2a$var$frameInterval = 5, $d468d46ecb545e2a$var$startTime = -1;
function $d468d46ecb545e2a$var$shouldYieldToHost() {
    return $d468d46ecb545e2a$var$needsPaint ? !0 : $d468d46ecb545e2a$export$c4744153514ff05d() - $d468d46ecb545e2a$var$startTime < $d468d46ecb545e2a$var$frameInterval ? !1 : !0;
}
function $d468d46ecb545e2a$var$performWorkUntilDeadline() {
    $d468d46ecb545e2a$var$needsPaint = !1;
    if ($d468d46ecb545e2a$var$isMessageLoopRunning) {
        var currentTime = $d468d46ecb545e2a$export$c4744153514ff05d();
        $d468d46ecb545e2a$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $d468d46ecb545e2a$var$isHostCallbackScheduled = !1;
                $d468d46ecb545e2a$var$isHostTimeoutScheduled && ($d468d46ecb545e2a$var$isHostTimeoutScheduled = !1, $d468d46ecb545e2a$var$localClearTimeout($d468d46ecb545e2a$var$taskTimeoutID), $d468d46ecb545e2a$var$taskTimeoutID = -1);
                $d468d46ecb545e2a$var$isPerformingWork = !0;
                var previousPriorityLevel = $d468d46ecb545e2a$var$currentPriorityLevel;
                try {
                    b: {
                        $d468d46ecb545e2a$var$advanceTimers(currentTime);
                        for($d468d46ecb545e2a$var$currentTask = $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$taskQueue); null !== $d468d46ecb545e2a$var$currentTask && !($d468d46ecb545e2a$var$currentTask.expirationTime > currentTime && $d468d46ecb545e2a$var$shouldYieldToHost());){
                            var callback = $d468d46ecb545e2a$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $d468d46ecb545e2a$var$currentTask.callback = null;
                                $d468d46ecb545e2a$var$currentPriorityLevel = $d468d46ecb545e2a$var$currentTask.priorityLevel;
                                var continuationCallback = callback($d468d46ecb545e2a$var$currentTask.expirationTime <= currentTime);
                                currentTime = $d468d46ecb545e2a$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $d468d46ecb545e2a$var$currentTask.callback = continuationCallback;
                                    $d468d46ecb545e2a$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $d468d46ecb545e2a$var$currentTask === $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$taskQueue) && $d468d46ecb545e2a$var$pop($d468d46ecb545e2a$var$taskQueue);
                                $d468d46ecb545e2a$var$advanceTimers(currentTime);
                            } else $d468d46ecb545e2a$var$pop($d468d46ecb545e2a$var$taskQueue);
                            $d468d46ecb545e2a$var$currentTask = $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$taskQueue);
                        }
                        if (null !== $d468d46ecb545e2a$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$timerQueue);
                            null !== firstTimer && $d468d46ecb545e2a$var$requestHostTimeout($d468d46ecb545e2a$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $d468d46ecb545e2a$var$currentTask = null, $d468d46ecb545e2a$var$currentPriorityLevel = previousPriorityLevel, $d468d46ecb545e2a$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $d468d46ecb545e2a$var$schedulePerformWorkUntilDeadline() : $d468d46ecb545e2a$var$isMessageLoopRunning = !1;
        }
    }
}
var $d468d46ecb545e2a$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $d468d46ecb545e2a$var$localSetImmediate) $d468d46ecb545e2a$var$schedulePerformWorkUntilDeadline = function() {
    $d468d46ecb545e2a$var$localSetImmediate($d468d46ecb545e2a$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $d468d46ecb545e2a$var$channel = new MessageChannel(), $d468d46ecb545e2a$var$port = $d468d46ecb545e2a$var$channel.port2;
    $d468d46ecb545e2a$var$channel.port1.onmessage = $d468d46ecb545e2a$var$performWorkUntilDeadline;
    $d468d46ecb545e2a$var$schedulePerformWorkUntilDeadline = function() {
        $d468d46ecb545e2a$var$port.postMessage(null);
    };
} else $d468d46ecb545e2a$var$schedulePerformWorkUntilDeadline = function() {
    $d468d46ecb545e2a$var$localSetTimeout($d468d46ecb545e2a$var$performWorkUntilDeadline, 0);
};
function $d468d46ecb545e2a$var$requestHostTimeout(callback, ms) {
    $d468d46ecb545e2a$var$taskTimeoutID = $d468d46ecb545e2a$var$localSetTimeout(function() {
        callback($d468d46ecb545e2a$export$c4744153514ff05d());
    }, ms);
}
$d468d46ecb545e2a$export$3e506c1ccc9cc1a7 = 5;
$d468d46ecb545e2a$export$e26fe2ed2fa76875 = 1;
$d468d46ecb545e2a$export$502329bbf4b505b1 = 4;
$d468d46ecb545e2a$export$6e3807111c4874c4 = 3;
$d468d46ecb545e2a$export$c27134553091fb3a = null;
$d468d46ecb545e2a$export$33ee1acdc04fd2a2 = 2;
$d468d46ecb545e2a$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$d468d46ecb545e2a$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $d468d46ecb545e2a$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$d468d46ecb545e2a$export$d3dfb8e4810cb555 = function() {
    return $d468d46ecb545e2a$var$currentPriorityLevel;
};
$d468d46ecb545e2a$export$72fdf0e06517287b = function(eventHandler) {
    switch($d468d46ecb545e2a$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $d468d46ecb545e2a$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $d468d46ecb545e2a$var$currentPriorityLevel;
    $d468d46ecb545e2a$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d468d46ecb545e2a$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d468d46ecb545e2a$export$816d2913ae6b83b1 = function() {
    $d468d46ecb545e2a$var$needsPaint = !0;
};
$d468d46ecb545e2a$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $d468d46ecb545e2a$var$currentPriorityLevel;
    $d468d46ecb545e2a$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $d468d46ecb545e2a$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$d468d46ecb545e2a$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $d468d46ecb545e2a$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $d468d46ecb545e2a$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $d468d46ecb545e2a$var$push($d468d46ecb545e2a$var$timerQueue, priorityLevel), null === $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$taskQueue) && priorityLevel === $d468d46ecb545e2a$var$peek($d468d46ecb545e2a$var$timerQueue) && ($d468d46ecb545e2a$var$isHostTimeoutScheduled ? ($d468d46ecb545e2a$var$localClearTimeout($d468d46ecb545e2a$var$taskTimeoutID), $d468d46ecb545e2a$var$taskTimeoutID = -1) : $d468d46ecb545e2a$var$isHostTimeoutScheduled = !0, $d468d46ecb545e2a$var$requestHostTimeout($d468d46ecb545e2a$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $d468d46ecb545e2a$var$push($d468d46ecb545e2a$var$taskQueue, priorityLevel), $d468d46ecb545e2a$var$isHostCallbackScheduled || $d468d46ecb545e2a$var$isPerformingWork || ($d468d46ecb545e2a$var$isHostCallbackScheduled = !0, $d468d46ecb545e2a$var$isMessageLoopRunning || ($d468d46ecb545e2a$var$isMessageLoopRunning = !0, $d468d46ecb545e2a$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$d468d46ecb545e2a$export$b5836b71941fa3ed = $d468d46ecb545e2a$var$shouldYieldToHost;
$d468d46ecb545e2a$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $d468d46ecb545e2a$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $d468d46ecb545e2a$var$currentPriorityLevel;
        $d468d46ecb545e2a$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $d468d46ecb545e2a$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("kYL7Z", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2QzWK"));

});

parcelRegister("cRanb", function(module, exports) {
'use strict';
function $95c27b211a4743d5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($95c27b211a4743d5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$95c27b211a4743d5$var$checkDCE();

module.exports = (parcelRequire("1MKqd"));

});
parcelRegister("1MKqd", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $14ce4889f9f9f6b2$export$69ce8ef3fe5cead0, (v) => $14ce4889f9f9f6b2$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $14ce4889f9f9f6b2$export$d39a5bbd09211389, (v) => $14ce4889f9f9f6b2$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $14ce4889f9f9f6b2$export$cd75ccfd720a3cd4, (v) => $14ce4889f9f9f6b2$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $14ce4889f9f9f6b2$export$a0816fa17a9e79be, (v) => $14ce4889f9f9f6b2$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $14ce4889f9f9f6b2$export$7292efcadded39f3, (v) => $14ce4889f9f9f6b2$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $14ce4889f9f9f6b2$export$da407abadb9b8f86, (v) => $14ce4889f9f9f6b2$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $14ce4889f9f9f6b2$export$314cfea32580671c, (v) => $14ce4889f9f9f6b2$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $14ce4889f9f9f6b2$export$513ccb98c53b8039, (v) => $14ce4889f9f9f6b2$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $14ce4889f9f9f6b2$export$dbca993bc2d264a, (v) => $14ce4889f9f9f6b2$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $14ce4889f9f9f6b2$export$4797a8006f0655d0, (v) => $14ce4889f9f9f6b2$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $14ce4889f9f9f6b2$export$c78a37762a8d58e1, (v) => $14ce4889f9f9f6b2$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $14ce4889f9f9f6b2$export$606f11b2eb45ecc6, (v) => $14ce4889f9f9f6b2$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $14ce4889f9f9f6b2$export$f7e8a0bf92324b1e, (v) => $14ce4889f9f9f6b2$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $14ce4889f9f9f6b2$export$83d89fbfd8236492, (v) => $14ce4889f9f9f6b2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $14ce4889f9f9f6b2$export$69ce8ef3fe5cead0;
var $14ce4889f9f9f6b2$export$d39a5bbd09211389;
var $14ce4889f9f9f6b2$export$cd75ccfd720a3cd4;
var $14ce4889f9f9f6b2$export$a0816fa17a9e79be;
var $14ce4889f9f9f6b2$export$7292efcadded39f3;
var $14ce4889f9f9f6b2$export$da407abadb9b8f86;
var $14ce4889f9f9f6b2$export$314cfea32580671c;
var $14ce4889f9f9f6b2$export$513ccb98c53b8039;
var $14ce4889f9f9f6b2$export$dbca993bc2d264a;
var $14ce4889f9f9f6b2$export$4797a8006f0655d0;
var $14ce4889f9f9f6b2$export$c78a37762a8d58e1;
var $14ce4889f9f9f6b2$export$606f11b2eb45ecc6;
var $14ce4889f9f9f6b2$export$f7e8a0bf92324b1e;
var $14ce4889f9f9f6b2$export$83d89fbfd8236492;
"use strict";

var $kYL7Z = parcelRequire("kYL7Z");
function $14ce4889f9f9f6b2$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $14ce4889f9f9f6b2$var$noop() {}
var $14ce4889f9f9f6b2$var$Internals = {
    d: {
        f: $14ce4889f9f9f6b2$var$noop,
        r: function() {
            throw Error($14ce4889f9f9f6b2$var$formatProdErrorMessage(522));
        },
        D: $14ce4889f9f9f6b2$var$noop,
        C: $14ce4889f9f9f6b2$var$noop,
        L: $14ce4889f9f9f6b2$var$noop,
        m: $14ce4889f9f9f6b2$var$noop,
        X: $14ce4889f9f9f6b2$var$noop,
        S: $14ce4889f9f9f6b2$var$noop,
        M: $14ce4889f9f9f6b2$var$noop
    },
    p: 0,
    findDOMNode: null
}, $14ce4889f9f9f6b2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $14ce4889f9f9f6b2$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $14ce4889f9f9f6b2$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $14ce4889f9f9f6b2$var$ReactSharedInternals = $kYL7Z.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $14ce4889f9f9f6b2$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$14ce4889f9f9f6b2$export$69ce8ef3fe5cead0 = $14ce4889f9f9f6b2$var$Internals;
$14ce4889f9f9f6b2$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($14ce4889f9f9f6b2$var$formatProdErrorMessage(299));
    return $14ce4889f9f9f6b2$var$createPortal$1(children, container, null, key);
};
$14ce4889f9f9f6b2$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $14ce4889f9f9f6b2$var$ReactSharedInternals.T, previousUpdatePriority = $14ce4889f9f9f6b2$var$Internals.p;
    try {
        if ($14ce4889f9f9f6b2$var$ReactSharedInternals.T = null, $14ce4889f9f9f6b2$var$Internals.p = 2, fn) return fn();
    } finally{
        $14ce4889f9f9f6b2$var$ReactSharedInternals.T = previousTransition, $14ce4889f9f9f6b2$var$Internals.p = previousUpdatePriority, $14ce4889f9f9f6b2$var$Internals.d.f();
    }
};
$14ce4889f9f9f6b2$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $14ce4889f9f9f6b2$var$Internals.d.C(href, options));
};
$14ce4889f9f9f6b2$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $14ce4889f9f9f6b2$var$Internals.d.D(href);
};
$14ce4889f9f9f6b2$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $14ce4889f9f9f6b2$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $14ce4889f9f9f6b2$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $14ce4889f9f9f6b2$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$14ce4889f9f9f6b2$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $14ce4889f9f9f6b2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $14ce4889f9f9f6b2$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $14ce4889f9f9f6b2$var$Internals.d.M(href);
    }
};
$14ce4889f9f9f6b2$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $14ce4889f9f9f6b2$var$getCrossOriginStringAs(as, options.crossOrigin);
        $14ce4889f9f9f6b2$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$14ce4889f9f9f6b2$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $14ce4889f9f9f6b2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $14ce4889f9f9f6b2$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $14ce4889f9f9f6b2$var$Internals.d.m(href);
    }
};
$14ce4889f9f9f6b2$export$4797a8006f0655d0 = function(form) {
    $14ce4889f9f9f6b2$var$Internals.d.r(form);
};
$14ce4889f9f9f6b2$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$14ce4889f9f9f6b2$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $14ce4889f9f9f6b2$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$14ce4889f9f9f6b2$export$f7e8a0bf92324b1e = function() {
    return $14ce4889f9f9f6b2$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$14ce4889f9f9f6b2$export$83d89fbfd8236492 = "19.2.4";

});



parcelRegister("euNJf", function(module, exports) {

$parcel$export(module.exports, "pascalCase", () => $a8da711ef74b1a6a$export$26c6f48841fe1a8a);

var $er4Gf = parcelRequire("er4Gf");

var $75JmI = parcelRequire("75JmI");
function $a8da711ef74b1a6a$export$66a4dfea2695736(input, index) {
    var firstChar = input.charAt(0);
    var lowerChars = input.substr(1).toLowerCase();
    if (index > 0 && firstChar >= "0" && firstChar <= "9") return "_" + firstChar + lowerChars;
    return "" + firstChar.toUpperCase() + lowerChars;
}
function $a8da711ef74b1a6a$export$c27cf446dc44c0b9(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
}
function $a8da711ef74b1a6a$export$26c6f48841fe1a8a(input, options) {
    if (options === void 0) options = {};
    return (0, $75JmI.noCase)(input, (0, $er4Gf.__assign)({
        delimiter: "",
        transform: $a8da711ef74b1a6a$export$66a4dfea2695736
    }, options));
}

});
parcelRegister("er4Gf", function(module, exports) {

$parcel$export(module.exports, "__assign", () => $a82737b887d3ebb4$export$18ce0697a983be9b);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $a82737b887d3ebb4$var$extendStatics = function(d, b) {
    $a82737b887d3ebb4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a82737b887d3ebb4$var$extendStatics(d, b);
};
function $a82737b887d3ebb4$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a82737b887d3ebb4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a82737b887d3ebb4$export$18ce0697a983be9b = function() {
    $a82737b887d3ebb4$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a82737b887d3ebb4$export$18ce0697a983be9b.apply(this, arguments);
};
function $a82737b887d3ebb4$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a82737b887d3ebb4$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a82737b887d3ebb4$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a82737b887d3ebb4$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a82737b887d3ebb4$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a82737b887d3ebb4$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $a82737b887d3ebb4$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a82737b887d3ebb4$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a82737b887d3ebb4$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a82737b887d3ebb4$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a82737b887d3ebb4$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a82737b887d3ebb4$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a82737b887d3ebb4$export$45d3717a4c69092e(o, m, p);
}
function $a82737b887d3ebb4$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a82737b887d3ebb4$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a82737b887d3ebb4$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a82737b887d3ebb4$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a82737b887d3ebb4$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a82737b887d3ebb4$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a82737b887d3ebb4$export$10c90e4f7922046c(v) {
    return this instanceof $a82737b887d3ebb4$export$10c90e4f7922046c ? (this.v = v, this) : new $a82737b887d3ebb4$export$10c90e4f7922046c(v);
}
function $a82737b887d3ebb4$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a82737b887d3ebb4$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a82737b887d3ebb4$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a82737b887d3ebb4$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a82737b887d3ebb4$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a82737b887d3ebb4$export$19a8beecd37a4c45 === "function" ? $a82737b887d3ebb4$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a82737b887d3ebb4$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a82737b887d3ebb4$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a82737b887d3ebb4$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a82737b887d3ebb4$export$45d3717a4c69092e(result, mod, k);
    }
    $a82737b887d3ebb4$var$__setModuleDefault(result, mod);
    return result;
}
function $a82737b887d3ebb4$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a82737b887d3ebb4$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a82737b887d3ebb4$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a82737b887d3ebb4$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a82737b887d3ebb4$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a82737b887d3ebb4$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a82737b887d3ebb4$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a82737b887d3ebb4$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $a82737b887d3ebb4$export$2e2bcd8739ae039 = {
    __extends: $a82737b887d3ebb4$export$a8ba968b8961cb8a,
    __assign: $a82737b887d3ebb4$export$18ce0697a983be9b,
    __rest: $a82737b887d3ebb4$export$3c9a16f847548506,
    __decorate: $a82737b887d3ebb4$export$29e00dfd3077644b,
    __param: $a82737b887d3ebb4$export$d5ad3fd78186038f,
    __metadata: $a82737b887d3ebb4$export$f1db080c865becb9,
    __awaiter: $a82737b887d3ebb4$export$1050f835b63b671e,
    __generator: $a82737b887d3ebb4$export$67ebef60e6f28a6,
    __createBinding: $a82737b887d3ebb4$export$45d3717a4c69092e,
    __exportStar: $a82737b887d3ebb4$export$f33643c0debef087,
    __values: $a82737b887d3ebb4$export$19a8beecd37a4c45,
    __read: $a82737b887d3ebb4$export$8d051b38c9118094,
    __spread: $a82737b887d3ebb4$export$afc72e2116322959,
    __spreadArrays: $a82737b887d3ebb4$export$6388937ca91ccae8,
    __spreadArray: $a82737b887d3ebb4$export$1216008129fb82ed,
    __await: $a82737b887d3ebb4$export$10c90e4f7922046c,
    __asyncGenerator: $a82737b887d3ebb4$export$e427f37a30a4de9b,
    __asyncDelegator: $a82737b887d3ebb4$export$bbd80228419bb833,
    __asyncValues: $a82737b887d3ebb4$export$e3b29a3d6162315f,
    __makeTemplateObject: $a82737b887d3ebb4$export$4fb47efe1390b86f,
    __importStar: $a82737b887d3ebb4$export$c21735bcef00d192,
    __importDefault: $a82737b887d3ebb4$export$da59b14a69baef04,
    __classPrivateFieldGet: $a82737b887d3ebb4$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a82737b887d3ebb4$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a82737b887d3ebb4$export$81fdc39f203e4e04,
    __addDisposableResource: $a82737b887d3ebb4$export$88ac25d8e944e405,
    __disposeResources: $a82737b887d3ebb4$export$8f076105dc360e92
};

});

parcelRegister("75JmI", function(module, exports) {

$parcel$export(module.exports, "noCase", () => $529c30ab9278b4b3$export$a596972587f860c8);

var $7vCOO = parcelRequire("7vCOO");
// Support camel case ("camelCase" -> "camel Case" and "CAMELCase" -> "CAMEL Case").
var $529c30ab9278b4b3$var$DEFAULT_SPLIT_REGEXP = [
    /([a-z0-9])([A-Z])/g,
    /([A-Z])([A-Z][a-z])/g
];
// Remove all non-word characters.
var $529c30ab9278b4b3$var$DEFAULT_STRIP_REGEXP = /[^A-Z0-9]+/gi;
function $529c30ab9278b4b3$export$a596972587f860c8(input, options) {
    if (options === void 0) options = {};
    var _a = options.splitRegexp, splitRegexp = _a === void 0 ? $529c30ab9278b4b3$var$DEFAULT_SPLIT_REGEXP : _a, _b = options.stripRegexp, stripRegexp = _b === void 0 ? $529c30ab9278b4b3$var$DEFAULT_STRIP_REGEXP : _b, _c = options.transform, transform = _c === void 0 ? (0, $7vCOO.lowerCase) : _c, _d = options.delimiter, delimiter = _d === void 0 ? " " : _d;
    var result = $529c30ab9278b4b3$var$replace($529c30ab9278b4b3$var$replace(input, splitRegexp, "$1\0$2"), stripRegexp, "\0");
    var start = 0;
    var end = result.length;
    // Trim the delimiter from around the output string.
    while(result.charAt(start) === "\0")start++;
    while(result.charAt(end - 1) === "\0")end--;
    // Transform each token independently.
    return result.slice(start, end).split("\0").map(transform).join(delimiter);
}
/**
 * Replace `re` in the input string with the replacement value.
 */ function $529c30ab9278b4b3$var$replace(input, re, value) {
    if (re instanceof RegExp) return input.replace(re, value);
    return re.reduce(function(input, re) {
        return input.replace(re, value);
    }, input);
}

});
parcelRegister("7vCOO", function(module, exports) {

$parcel$export(module.exports, "lowerCase", () => $57798a3a90bc0827$export$61d6efbc6547e8eb);
/**
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 */ var $57798a3a90bc0827$var$SUPPORTED_LOCALE = {
    tr: {
        regexp: /\u0130|\u0049|\u0049\u0307/g,
        map: {
            \u0130: "\u0069",
            I: "\u0131",
            I\u0307: "\u0069"
        }
    },
    az: {
        regexp: /\u0130/g,
        map: {
            \u0130: "\u0069",
            I: "\u0131",
            I\u0307: "\u0069"
        }
    },
    lt: {
        regexp: /\u0049|\u004A|\u012E|\u00CC|\u00CD|\u0128/g,
        map: {
            I: "\u0069\u0307",
            J: "\u006A\u0307",
            \u012E: "\u012F\u0307",
            "\xcc": "\u0069\u0307\u0300",
            "\xcd": "\u0069\u0307\u0301",
            \u0128: "\u0069\u0307\u0303"
        }
    }
};
function $57798a3a90bc0827$export$206cd6ecad4fcdde(str, locale) {
    var lang = $57798a3a90bc0827$var$SUPPORTED_LOCALE[locale.toLowerCase()];
    if (lang) return $57798a3a90bc0827$export$61d6efbc6547e8eb(str.replace(lang.regexp, function(m) {
        return lang.map[m];
    }));
    return $57798a3a90bc0827$export$61d6efbc6547e8eb(str);
}
function $57798a3a90bc0827$export$61d6efbc6547e8eb(str) {
    return str.toLowerCase();
}

});



parcelRegister("6Y6tm", function(module, exports) {

$parcel$export(module.exports, "IconSize", () => $512d5df7fb2c1a6f$export$ff775019b5b6e7df);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $512d5df7fb2c1a6f$export$ff775019b5b6e7df;
(function(IconSize) {
    IconSize[IconSize["STANDARD"] = 16] = "STANDARD";
    IconSize[IconSize["LARGE"] = 20] = "LARGE";
})($512d5df7fb2c1a6f$export$ff775019b5b6e7df || ($512d5df7fb2c1a6f$export$ff775019b5b6e7df = {}));

});

parcelRegister("cWXea", function(module, exports) {
module.exports = import("7tOQn").then(()=>parcelRequire('4vRDv'));

});

parcelRegister("6Lw1c", function(module, exports) {
module.exports = import("4DbFx").then(()=>parcelRequire('iCZGs'));

});

parcelRegister("aURB2", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $fVmQV = parcelRequire("fVmQV");
function $7f28b57c5d1dd0f3$var$emptyFunction() {}
function $7f28b57c5d1dd0f3$var$emptyFunctionWithReset() {}
$7f28b57c5d1dd0f3$var$emptyFunctionWithReset.resetWarningCache = $7f28b57c5d1dd0f3$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $fVmQV) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $7f28b57c5d1dd0f3$var$emptyFunctionWithReset,
        resetWarningCache: $7f28b57c5d1dd0f3$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("fVmQV", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $b97de7f0d35befdf$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $b97de7f0d35befdf$var$ReactPropTypesSecret;

});


parcelRegister("6t2bg", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $4b57248e5933d7c9$export$306c0aa65ff9ec16, (v) => $4b57248e5933d7c9$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4b57248e5933d7c9$export$306c0aa65ff9ec16;
"use strict";

var $kYL7Z = parcelRequire("kYL7Z");
function $4b57248e5933d7c9$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $4b57248e5933d7c9$var$objectIs = "function" === typeof Object.is ? Object.is : $4b57248e5933d7c9$var$is, $4b57248e5933d7c9$var$useState = $kYL7Z.useState, $4b57248e5933d7c9$var$useEffect = $kYL7Z.useEffect, $4b57248e5933d7c9$var$useLayoutEffect = $kYL7Z.useLayoutEffect, $4b57248e5933d7c9$var$useDebugValue = $kYL7Z.useDebugValue;
function $4b57248e5933d7c9$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $4b57248e5933d7c9$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $4b57248e5933d7c9$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $4b57248e5933d7c9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $4b57248e5933d7c9$var$useEffect(function() {
        $4b57248e5933d7c9$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $4b57248e5933d7c9$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $4b57248e5933d7c9$var$useDebugValue(value);
    return value;
}
function $4b57248e5933d7c9$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$4b57248e5933d7c9$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $4b57248e5933d7c9$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $4b57248e5933d7c9$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $4b57248e5933d7c9$var$useSyncExternalStore$1 : $4b57248e5933d7c9$var$useSyncExternalStore$2;
$4b57248e5933d7c9$export$306c0aa65ff9ec16 = void 0 !== $kYL7Z.useSyncExternalStore ? $kYL7Z.useSyncExternalStore : $4b57248e5933d7c9$var$shim;

});

parcelRegister("24GUP", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv2020 = void 0;

var $9JDAR = parcelRequire("9JDAR");

var $cgRhl = parcelRequire("cgRhl");

var $ldhBP = parcelRequire("ldhBP");

var $3oNYk = parcelRequire("3oNYk");
const META_SCHEMA_ID = "https://json-schema.org/draft/2020-12/schema";
class Ajv2020 extends $9JDAR.default {
    constructor(opts = {}){
        super({
            ...opts,
            dynamicRef: true,
            next: true,
            unevaluated: true
        });
    }
    _addVocabularies() {
        super._addVocabularies();
        $cgRhl.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($ldhBP.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        const { $data, meta } = this.opts;
        if (!meta) return;
        $3oNYk.default.call(this, $data);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv2020 = Ajv2020;
module.exports = exports = Ajv2020;
module.exports.Ajv2020 = Ajv2020;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv2020;

var $4Gzns = parcelRequire("4Gzns");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $4Gzns.KeywordCxt;
    }
});

var $8vps4 = parcelRequire("8vps4");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $8vps4._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $8vps4.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $8vps4.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $8vps4.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $8vps4.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $8vps4.CodeGen;
    }
});

var $cMAcV = parcelRequire("cMAcV");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $cMAcV.default;
    }
});

var $8u76A = parcelRequire("8u76A");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $8u76A.default;
    }
});

});
parcelRegister("9JDAR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $4Gzns = parcelRequire("4Gzns");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $4Gzns.KeywordCxt;
    }
});

var $8vps4 = parcelRequire("8vps4");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $8vps4._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $8vps4.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $8vps4.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $8vps4.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $8vps4.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $8vps4.CodeGen;
    }
});

var $cMAcV = parcelRequire("cMAcV");

var $8u76A = parcelRequire("8u76A");

var $2Y0Hl = parcelRequire("2Y0Hl");

var $bRq00 = parcelRequire("bRq00");

var $8vps4 = parcelRequire("8vps4");

var $3aYST = parcelRequire("3aYST");

var $riMdG = parcelRequire("riMdG");

var $4wi01 = parcelRequire("4wi01");

var $binfM = parcelRequire("binfM");

var $7U7v8 = parcelRequire("7U7v8");
const $71670778ccd8d148$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$71670778ccd8d148$var$defaultRegExp.code = "new RegExp";
const $71670778ccd8d148$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $71670778ccd8d148$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $71670778ccd8d148$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $71670778ccd8d148$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $71670778ccd8d148$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $71670778ccd8d148$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $71670778ccd8d148$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $7U7v8.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $71670778ccd8d148$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $71670778ccd8d148$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $71670778ccd8d148$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = {};
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$71670778ccd8d148$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $8vps4.ValueScope({
            scope: {},
            prefixes: $71670778ccd8d148$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $71670778ccd8d148$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $2Y0Hl.getRules)();
        $71670778ccd8d148$var$checkOptions.call(this, $71670778ccd8d148$var$removedOptions, opts, "NOT SUPPORTED");
        $71670778ccd8d148$var$checkOptions.call(this, $71670778ccd8d148$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $71670778ccd8d148$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $71670778ccd8d148$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $71670778ccd8d148$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $71670778ccd8d148$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $binfM;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$binfM
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $8u76A.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $3aYST.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $71670778ccd8d148$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $bRq00.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $bRq00.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $71670778ccd8d148$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $3aYST.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $71670778ccd8d148$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $4wi01.eachItem)(keyword, (kwd)=>$71670778ccd8d148$var$addRule.call(this, kwd));
            return this;
        }
        $71670778ccd8d148$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $riMdG.getJSONTypes)(def.type),
            schemaType: (0, $riMdG.getJSONTypes)(def.schemaType)
        };
        (0, $4wi01.eachItem)(keyword, definition.type.length === 0 ? (k)=>$71670778ccd8d148$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$71670778ccd8d148$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $71670778ccd8d148$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $3aYST.normalizeId)(id || baseId);
        const localRefs = $3aYST.getSchemaRefs.call(this, schema, baseId);
        sch = new $bRq00.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $bRq00.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $bRq00.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
$71670778ccd8d148$var$Ajv.ValidationError = $cMAcV.default;
$71670778ccd8d148$var$Ajv.MissingRefError = $8u76A.default;
module.exports.default = $71670778ccd8d148$var$Ajv;
function $71670778ccd8d148$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $71670778ccd8d148$var$getSchEnv(keyRef) {
    keyRef = (0, $3aYST.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $71670778ccd8d148$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $71670778ccd8d148$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $71670778ccd8d148$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $71670778ccd8d148$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $71670778ccd8d148$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $71670778ccd8d148$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $71670778ccd8d148$var$getLogger(logger) {
    if (logger === false) return $71670778ccd8d148$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $71670778ccd8d148$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $71670778ccd8d148$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $4wi01.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$71670778ccd8d148$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $71670778ccd8d148$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $riMdG.getJSONTypes)(definition.type),
            schemaType: (0, $riMdG.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $71670778ccd8d148$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $71670778ccd8d148$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $71670778ccd8d148$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $71670778ccd8d148$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $71670778ccd8d148$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $71670778ccd8d148$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $71670778ccd8d148$var$$dataRef
        ]
    };
}

});
parcelRegister("4Gzns", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $lrggG = parcelRequire("lrggG");

var $riMdG = parcelRequire("riMdG");

var $2rT8q = parcelRequire("2rT8q");

var $riMdG = parcelRequire("riMdG");

var $d8h1X = parcelRequire("d8h1X");

var $fY8yN = parcelRequire("fY8yN");

var $3HMak = parcelRequire("3HMak");

var $8vps4 = parcelRequire("8vps4");

var $4tUVW = parcelRequire("4tUVW");

var $3aYST = parcelRequire("3aYST");

var $4wi01 = parcelRequire("4wi01");

var $1Jv02 = parcelRequire("1Jv02");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $369686d8bdd32a29$var$validateFunctionCode(it) {
    if ($369686d8bdd32a29$var$isSchemaObj(it)) {
        $369686d8bdd32a29$var$checkKeywords(it);
        if ($369686d8bdd32a29$var$schemaCxtHasRules(it)) {
            $369686d8bdd32a29$var$topSchemaObjCode(it);
            return;
        }
    }
    $369686d8bdd32a29$var$validateFunction(it, ()=>(0, $lrggG.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $369686d8bdd32a29$var$validateFunctionCode;
function $369686d8bdd32a29$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $8vps4._)`${$4tUVW.default.data}, ${$4tUVW.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $8vps4._)`"use strict"; ${$369686d8bdd32a29$var$funcSourceUrl(schema, opts)}`);
        $369686d8bdd32a29$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $8vps4._)`${$4tUVW.default.data}, ${$369686d8bdd32a29$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($369686d8bdd32a29$var$funcSourceUrl(schema, opts)).code(body));
}
function $369686d8bdd32a29$var$destructureValCxt(opts) {
    return (0, $8vps4._)`{${$4tUVW.default.instancePath}="", ${$4tUVW.default.parentData}, ${$4tUVW.default.parentDataProperty}, ${$4tUVW.default.rootData}=${$4tUVW.default.data}${opts.dynamicRef ? (0, $8vps4._)`, ${$4tUVW.default.dynamicAnchors}={}` : $8vps4.nil}}={}`;
}
function $369686d8bdd32a29$var$destructureValCxtES5(gen, opts) {
    gen.if($4tUVW.default.valCxt, ()=>{
        gen.var($4tUVW.default.instancePath, (0, $8vps4._)`${$4tUVW.default.valCxt}.${$4tUVW.default.instancePath}`);
        gen.var($4tUVW.default.parentData, (0, $8vps4._)`${$4tUVW.default.valCxt}.${$4tUVW.default.parentData}`);
        gen.var($4tUVW.default.parentDataProperty, (0, $8vps4._)`${$4tUVW.default.valCxt}.${$4tUVW.default.parentDataProperty}`);
        gen.var($4tUVW.default.rootData, (0, $8vps4._)`${$4tUVW.default.valCxt}.${$4tUVW.default.rootData}`);
        if (opts.dynamicRef) gen.var($4tUVW.default.dynamicAnchors, (0, $8vps4._)`${$4tUVW.default.valCxt}.${$4tUVW.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($4tUVW.default.instancePath, (0, $8vps4._)`""`);
        gen.var($4tUVW.default.parentData, (0, $8vps4._)`undefined`);
        gen.var($4tUVW.default.parentDataProperty, (0, $8vps4._)`undefined`);
        gen.var($4tUVW.default.rootData, $4tUVW.default.data);
        if (opts.dynamicRef) gen.var($4tUVW.default.dynamicAnchors, (0, $8vps4._)`{}`);
    });
}
function $369686d8bdd32a29$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $369686d8bdd32a29$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $369686d8bdd32a29$var$commentKeyword(it);
        $369686d8bdd32a29$var$checkNoDefault(it);
        gen.let($4tUVW.default.vErrors, null);
        gen.let($4tUVW.default.errors, 0);
        if (opts.unevaluated) $369686d8bdd32a29$var$resetEvaluated(it);
        $369686d8bdd32a29$var$typeAndKeywords(it);
        $369686d8bdd32a29$var$returnResults(it);
    });
    return;
}
function $369686d8bdd32a29$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $8vps4._)`${validateName}.evaluated`);
    gen.if((0, $8vps4._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $8vps4._)`${it.evaluated}.props`, (0, $8vps4._)`undefined`));
    gen.if((0, $8vps4._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $8vps4._)`${it.evaluated}.items`, (0, $8vps4._)`undefined`));
}
function $369686d8bdd32a29$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $8vps4._)`/*# sourceURL=${schId} */` : $8vps4.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $369686d8bdd32a29$var$subschemaCode(it, valid) {
    if ($369686d8bdd32a29$var$isSchemaObj(it)) {
        $369686d8bdd32a29$var$checkKeywords(it);
        if ($369686d8bdd32a29$var$schemaCxtHasRules(it)) {
            $369686d8bdd32a29$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $lrggG.boolOrEmptySchema)(it, valid);
}
function $369686d8bdd32a29$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $369686d8bdd32a29$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $369686d8bdd32a29$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $369686d8bdd32a29$var$commentKeyword(it);
    $369686d8bdd32a29$var$updateContext(it);
    $369686d8bdd32a29$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $4tUVW.default.errors);
    $369686d8bdd32a29$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $8vps4._)`${errsCount} === ${$4tUVW.default.errors}`);
}
function $369686d8bdd32a29$var$checkKeywords(it) {
    (0, $4wi01.checkUnknownRules)(it);
    $369686d8bdd32a29$var$checkRefsAndKeywords(it);
}
function $369686d8bdd32a29$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $369686d8bdd32a29$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $riMdG.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $riMdG.coerceAndCheckDataType)(it, types);
    $369686d8bdd32a29$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $369686d8bdd32a29$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $4wi01.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $369686d8bdd32a29$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $4wi01.checkStrictMode)(it, "default is ignored in the schema root");
}
function $369686d8bdd32a29$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $3aYST.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $369686d8bdd32a29$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $369686d8bdd32a29$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $8vps4._)`${$4tUVW.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $8vps4.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $8vps4._)`${$4tUVW.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $369686d8bdd32a29$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $8vps4._)`${$4tUVW.default.errors} === 0`, ()=>gen.return($4tUVW.default.data), ()=>gen.throw((0, $8vps4._)`new ${ValidationError}(${$4tUVW.default.vErrors})`));
    else {
        gen.assign((0, $8vps4._)`${validateName}.errors`, $4tUVW.default.vErrors);
        if (opts.unevaluated) $369686d8bdd32a29$var$assignEvaluated(it);
        gen.return((0, $8vps4._)`${$4tUVW.default.errors} === 0`);
    }
}
function $369686d8bdd32a29$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $8vps4.Name) gen.assign((0, $8vps4._)`${evaluated}.props`, props);
    if (items instanceof $8vps4.Name) gen.assign((0, $8vps4._)`${evaluated}.items`, items);
}
function $369686d8bdd32a29$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $4wi01.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$369686d8bdd32a29$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $369686d8bdd32a29$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $2rT8q.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $riMdG.checkDataType)(group.type, data, opts.strictNumbers));
            $369686d8bdd32a29$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $riMdG.reportTypeError)(it);
            }
            gen.endIf();
        } else $369686d8bdd32a29$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $8vps4._)`${$4tUVW.default.errors} === ${errsCount || 0}`);
    }
}
function $369686d8bdd32a29$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $d8h1X.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $2rT8q.shouldUseRule)(schema, rule)) $369686d8bdd32a29$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $369686d8bdd32a29$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $369686d8bdd32a29$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $369686d8bdd32a29$var$checkMultipleTypes(it, types);
    $369686d8bdd32a29$var$checkKeywordTypes(it, it.dataTypes);
}
function $369686d8bdd32a29$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$369686d8bdd32a29$var$includesType(it.dataTypes, t)) $369686d8bdd32a29$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    $369686d8bdd32a29$var$narrowSchemaTypes(it, types);
}
function $369686d8bdd32a29$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $369686d8bdd32a29$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $369686d8bdd32a29$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $2rT8q.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$369686d8bdd32a29$var$hasApplicableType(ts, t))) $369686d8bdd32a29$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $369686d8bdd32a29$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $369686d8bdd32a29$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $369686d8bdd32a29$var$narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if ($369686d8bdd32a29$var$includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function $369686d8bdd32a29$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $4wi01.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $369686d8bdd32a29$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $fY8yN.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $4wi01.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $369686d8bdd32a29$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $fY8yN.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $4tUVW.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $8vps4.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $8vps4.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $8vps4._)`${schemaCode} !== undefined && (${(0, $8vps4.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $1Jv02.reportExtraError : $1Jv02.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $1Jv02.reportError)(this, this.def.$dataError || $1Jv02.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $1Jv02.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $8vps4.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $8vps4.nil, $dataValid = $8vps4.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $8vps4.or)((0, $8vps4._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $8vps4.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $8vps4.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $8vps4.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $8vps4.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $8vps4._)`${(0, $riMdG.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $riMdG.DataType.Wrong)}`;
            }
            return $8vps4.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $8vps4._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $8vps4.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $3HMak.getSubschema)(this.it, appl);
        (0, $3HMak.extendSubschemaData)(subschema, this.it, appl);
        (0, $3HMak.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $369686d8bdd32a29$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $4wi01.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $4wi01.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $8vps4.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $369686d8bdd32a29$var$KeywordCxt;
function $369686d8bdd32a29$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $369686d8bdd32a29$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $fY8yN.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $fY8yN.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $fY8yN.funcKeywordCode)(cxt, def);
}
const $369686d8bdd32a29$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $369686d8bdd32a29$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $369686d8bdd32a29$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $4tUVW.default.rootData;
    if ($data[0] === "/") {
        if (!$369686d8bdd32a29$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $4tUVW.default.rootData;
    } else {
        const matches = $369686d8bdd32a29$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $8vps4._)`${data}${(0, $8vps4.getProperty)((0, $4wi01.unescapeJsonPointer)(segment))}`;
        expr = (0, $8vps4._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $369686d8bdd32a29$var$getData;

});
parcelRegister("lrggG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $1Jv02 = parcelRequire("1Jv02");

var $8vps4 = parcelRequire("8vps4");

var $4tUVW = parcelRequire("4tUVW");
const $f9b8bd178cb7bcf9$var$boolError = {
    message: "boolean schema is false"
};
function $f9b8bd178cb7bcf9$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $f9b8bd178cb7bcf9$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($4tUVW.default.data);
    else {
        gen.assign((0, $8vps4._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $f9b8bd178cb7bcf9$var$topBoolOrEmptySchema;
function $f9b8bd178cb7bcf9$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $f9b8bd178cb7bcf9$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $f9b8bd178cb7bcf9$var$boolOrEmptySchema;
function $f9b8bd178cb7bcf9$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $1Jv02.reportError)(cxt, $f9b8bd178cb7bcf9$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("1Jv02", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $4tUVW = parcelRequire("4tUVW");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $8vps4.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $8vps4.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $8vps4.str)`"${keyword}" keyword is invalid ($data)`
};
function $14320a4c71b0eed9$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $14320a4c71b0eed9$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $14320a4c71b0eed9$var$addError(gen, errObj);
    else $14320a4c71b0eed9$var$returnErrors(it, (0, $8vps4._)`[${errObj}]`);
}
module.exports.reportError = $14320a4c71b0eed9$var$reportError;
function $14320a4c71b0eed9$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $14320a4c71b0eed9$var$errorObjectCode(cxt, error, errorPaths);
    $14320a4c71b0eed9$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $14320a4c71b0eed9$var$returnErrors(it, $4tUVW.default.vErrors);
}
module.exports.reportExtraError = $14320a4c71b0eed9$var$reportExtraError;
function $14320a4c71b0eed9$var$resetErrorsCount(gen, errsCount) {
    gen.assign($4tUVW.default.errors, errsCount);
    gen.if((0, $8vps4._)`${$4tUVW.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $8vps4._)`${$4tUVW.default.vErrors}.length`, errsCount), ()=>gen.assign($4tUVW.default.vErrors, null)));
}
module.exports.resetErrorsCount = $14320a4c71b0eed9$var$resetErrorsCount;
function $14320a4c71b0eed9$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $4tUVW.default.errors, (i)=>{
        gen.const(err, (0, $8vps4._)`${$4tUVW.default.vErrors}[${i}]`);
        gen.if((0, $8vps4._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $8vps4._)`${err}.instancePath`, (0, $8vps4.strConcat)($4tUVW.default.instancePath, it.errorPath)));
        gen.assign((0, $8vps4._)`${err}.schemaPath`, (0, $8vps4.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $8vps4._)`${err}.schema`, schemaValue);
            gen.assign((0, $8vps4._)`${err}.data`, data);
        }
    });
}
module.exports.extendErrors = $14320a4c71b0eed9$var$extendErrors;
function $14320a4c71b0eed9$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $8vps4._)`${$4tUVW.default.vErrors} === null`, ()=>gen.assign($4tUVW.default.vErrors, (0, $8vps4._)`[${err}]`), (0, $8vps4._)`${$4tUVW.default.vErrors}.push(${err})`);
    gen.code((0, $8vps4._)`${$4tUVW.default.errors}++`);
}
function $14320a4c71b0eed9$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $8vps4._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $8vps4._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $14320a4c71b0eed9$var$E = {
    keyword: new $8vps4.Name("keyword"),
    schemaPath: new $8vps4.Name("schemaPath"),
    params: new $8vps4.Name("params"),
    propertyName: new $8vps4.Name("propertyName"),
    message: new $8vps4.Name("message"),
    schema: new $8vps4.Name("schema"),
    parentSchema: new $8vps4.Name("parentSchema")
};
function $14320a4c71b0eed9$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $8vps4._)`{}`;
    return $14320a4c71b0eed9$var$errorObject(cxt, error, errorPaths);
}
function $14320a4c71b0eed9$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $14320a4c71b0eed9$var$errorInstancePath(it, errorPaths),
        $14320a4c71b0eed9$var$errorSchemaPath(cxt, errorPaths)
    ];
    $14320a4c71b0eed9$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $14320a4c71b0eed9$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $8vps4.str)`${errorPath}${(0, $4wi01.getErrorPath)(instancePath, $4wi01.Type.Str)}` : errorPath;
    return [
        $4tUVW.default.instancePath,
        (0, $8vps4.strConcat)($4tUVW.default.instancePath, instPath)
    ];
}
function $14320a4c71b0eed9$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $8vps4.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $8vps4.str)`${schPath}${(0, $4wi01.getErrorPath)(schemaPath, $4wi01.Type.Str)}`;
    return [
        $14320a4c71b0eed9$var$E.schemaPath,
        schPath
    ];
}
function $14320a4c71b0eed9$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $14320a4c71b0eed9$var$E.keyword,
        keyword
    ], [
        $14320a4c71b0eed9$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $8vps4._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $14320a4c71b0eed9$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $14320a4c71b0eed9$var$E.schema,
        schemaValue
    ], [
        $14320a4c71b0eed9$var$E.parentSchema,
        (0, $8vps4._)`${topSchemaRef}${schemaPath}`
    ], [
        $4tUVW.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $14320a4c71b0eed9$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("8vps4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $iCENS = parcelRequire("iCENS");

var $5rYlJ = parcelRequire("5rYlJ");

var $iCENS = parcelRequire("iCENS");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $iCENS._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $iCENS.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $iCENS.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $iCENS.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $iCENS.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $iCENS.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $iCENS.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $iCENS.Name;
    }
});

var $5rYlJ = parcelRequire("5rYlJ");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $5rYlJ.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $5rYlJ.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $5rYlJ.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $5rYlJ.varKinds;
    }
});
module.exports.operators = {
    GT: new $iCENS._Code(">"),
    GTE: new $iCENS._Code(">="),
    LT: new $iCENS._Code("<"),
    LTE: new $iCENS._Code("<="),
    EQ: new $iCENS._Code("==="),
    NEQ: new $iCENS._Code("!=="),
    NOT: new $iCENS._Code("!"),
    OR: new $iCENS._Code("||"),
    AND: new $iCENS._Code("&&"),
    ADD: new $iCENS._Code("+")
};
class $6314f62f59ce0edd$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $6314f62f59ce0edd$var$Def extends $6314f62f59ce0edd$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $5rYlJ.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $6314f62f59ce0edd$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $iCENS._CodeOrName ? this.rhs.names : {};
    }
}
class $6314f62f59ce0edd$var$Assign extends $6314f62f59ce0edd$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $iCENS.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $6314f62f59ce0edd$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $iCENS.Name ? {} : {
            ...this.lhs.names
        };
        return $6314f62f59ce0edd$var$addExprNames(names, this.rhs);
    }
}
class $6314f62f59ce0edd$var$AssignOp extends $6314f62f59ce0edd$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $6314f62f59ce0edd$var$Label extends $6314f62f59ce0edd$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $6314f62f59ce0edd$var$Break extends $6314f62f59ce0edd$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $6314f62f59ce0edd$var$Throw extends $6314f62f59ce0edd$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $6314f62f59ce0edd$var$AnyCode extends $6314f62f59ce0edd$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $6314f62f59ce0edd$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $iCENS._CodeOrName ? this.code.names : {};
    }
}
class $6314f62f59ce0edd$var$ParentNode extends $6314f62f59ce0edd$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $6314f62f59ce0edd$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$6314f62f59ce0edd$var$addNames(names, n.names), {});
    }
}
class $6314f62f59ce0edd$var$BlockNode extends $6314f62f59ce0edd$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $6314f62f59ce0edd$var$Root extends $6314f62f59ce0edd$var$ParentNode {
}
class $6314f62f59ce0edd$var$Else extends $6314f62f59ce0edd$var$BlockNode {
}
$6314f62f59ce0edd$var$Else.kind = "else";
class $6314f62f59ce0edd$var$If extends $6314f62f59ce0edd$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $6314f62f59ce0edd$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $6314f62f59ce0edd$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $6314f62f59ce0edd$var$If($6314f62f59ce0edd$var$not(cond), e instanceof $6314f62f59ce0edd$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $6314f62f59ce0edd$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $6314f62f59ce0edd$var$addExprNames(names, this.condition);
        if (this.else) $6314f62f59ce0edd$var$addNames(names, this.else.names);
        return names;
    }
}
$6314f62f59ce0edd$var$If.kind = "if";
class $6314f62f59ce0edd$var$For extends $6314f62f59ce0edd$var$BlockNode {
}
$6314f62f59ce0edd$var$For.kind = "for";
class $6314f62f59ce0edd$var$ForLoop extends $6314f62f59ce0edd$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $6314f62f59ce0edd$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $6314f62f59ce0edd$var$addNames(super.names, this.iteration.names);
    }
}
class $6314f62f59ce0edd$var$ForRange extends $6314f62f59ce0edd$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $5rYlJ.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $6314f62f59ce0edd$var$addExprNames(super.names, this.from);
        return $6314f62f59ce0edd$var$addExprNames(names, this.to);
    }
}
class $6314f62f59ce0edd$var$ForIter extends $6314f62f59ce0edd$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $6314f62f59ce0edd$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $6314f62f59ce0edd$var$addNames(super.names, this.iterable.names);
    }
}
class $6314f62f59ce0edd$var$Func extends $6314f62f59ce0edd$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$6314f62f59ce0edd$var$Func.kind = "func";
class $6314f62f59ce0edd$var$Return extends $6314f62f59ce0edd$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$6314f62f59ce0edd$var$Return.kind = "return";
class $6314f62f59ce0edd$var$Try extends $6314f62f59ce0edd$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $6314f62f59ce0edd$var$addNames(names, this.catch.names);
        if (this.finally) $6314f62f59ce0edd$var$addNames(names, this.finally.names);
        return names;
    }
}
class $6314f62f59ce0edd$var$Catch extends $6314f62f59ce0edd$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$6314f62f59ce0edd$var$Catch.kind = "catch";
class $6314f62f59ce0edd$var$Finally extends $6314f62f59ce0edd$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$6314f62f59ce0edd$var$Finally.kind = "finally";
class $6314f62f59ce0edd$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $5rYlJ.Scope({
            parent: extScope
        });
        this._nodes = [
            new $6314f62f59ce0edd$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $6314f62f59ce0edd$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($5rYlJ.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($5rYlJ.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($5rYlJ.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $6314f62f59ce0edd$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $6314f62f59ce0edd$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $iCENS.nil) this._leafNode(new $6314f62f59ce0edd$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $iCENS.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $iCENS._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $6314f62f59ce0edd$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $6314f62f59ce0edd$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $6314f62f59ce0edd$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($6314f62f59ce0edd$var$If, $6314f62f59ce0edd$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $6314f62f59ce0edd$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $5rYlJ.varKinds.var : $5rYlJ.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $6314f62f59ce0edd$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $5rYlJ.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $iCENS.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $iCENS._)`${arr}.length`, (i)=>{
                this.var(name, (0, $iCENS._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $6314f62f59ce0edd$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $5rYlJ.varKinds.var : $5rYlJ.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $iCENS._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $6314f62f59ce0edd$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($6314f62f59ce0edd$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $6314f62f59ce0edd$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $6314f62f59ce0edd$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $6314f62f59ce0edd$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($6314f62f59ce0edd$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $6314f62f59ce0edd$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $6314f62f59ce0edd$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $6314f62f59ce0edd$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($6314f62f59ce0edd$var$Catch, $6314f62f59ce0edd$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $6314f62f59ce0edd$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $iCENS.nil, async, funcBody) {
        this._blockNode(new $6314f62f59ce0edd$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($6314f62f59ce0edd$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $6314f62f59ce0edd$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $6314f62f59ce0edd$var$CodeGen;
function $6314f62f59ce0edd$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $6314f62f59ce0edd$var$addExprNames(names, from) {
    return from instanceof $iCENS._CodeOrName ? $6314f62f59ce0edd$var$addNames(names, from.names) : names;
}
function $6314f62f59ce0edd$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $iCENS.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $iCENS._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $iCENS.Name) c = replaceName(c);
        if (c instanceof $iCENS._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $iCENS._Code && e._items.some((c)=>c instanceof $iCENS.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $6314f62f59ce0edd$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $6314f62f59ce0edd$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $iCENS._)`!${$6314f62f59ce0edd$var$par(x)}`;
}
module.exports.not = $6314f62f59ce0edd$var$not;
const $6314f62f59ce0edd$var$andCode = $6314f62f59ce0edd$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $6314f62f59ce0edd$var$and(...args) {
    return args.reduce($6314f62f59ce0edd$var$andCode);
}
module.exports.and = $6314f62f59ce0edd$var$and;
const $6314f62f59ce0edd$var$orCode = $6314f62f59ce0edd$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $6314f62f59ce0edd$var$or(...args) {
    return args.reduce($6314f62f59ce0edd$var$orCode);
}
module.exports.or = $6314f62f59ce0edd$var$or;
function $6314f62f59ce0edd$var$mappend(op) {
    return (x, y)=>x === $iCENS.nil ? y : y === $iCENS.nil ? x : (0, $iCENS._)`${$6314f62f59ce0edd$var$par(x)} ${op} ${$6314f62f59ce0edd$var$par(y)}`;
}
function $6314f62f59ce0edd$var$par(x) {
    return x instanceof $iCENS.Name ? x : (0, $iCENS._)`(${x})`;
}

});
parcelRegister("iCENS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class $d8eb6d4c68db413e$var$_CodeOrName {
}
module.exports._CodeOrName = $d8eb6d4c68db413e$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $d8eb6d4c68db413e$var$Name extends $d8eb6d4c68db413e$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $d8eb6d4c68db413e$var$Name;
class $d8eb6d4c68db413e$var$_Code extends $d8eb6d4c68db413e$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $d8eb6d4c68db413e$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $d8eb6d4c68db413e$var$_Code;
module.exports.nil = new $d8eb6d4c68db413e$var$_Code("");
function $d8eb6d4c68db413e$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $d8eb6d4c68db413e$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $d8eb6d4c68db413e$var$_Code(code);
}
module.exports._ = $d8eb6d4c68db413e$var$_;
const $d8eb6d4c68db413e$var$plus = new $d8eb6d4c68db413e$var$_Code("+");
function $d8eb6d4c68db413e$var$str(strs, ...args) {
    const expr = [
        $d8eb6d4c68db413e$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($d8eb6d4c68db413e$var$plus);
        $d8eb6d4c68db413e$var$addCodeArg(expr, args[i]);
        expr.push($d8eb6d4c68db413e$var$plus, $d8eb6d4c68db413e$var$safeStringify(strs[++i]));
    }
    $d8eb6d4c68db413e$var$optimize(expr);
    return new $d8eb6d4c68db413e$var$_Code(expr);
}
module.exports.str = $d8eb6d4c68db413e$var$str;
function $d8eb6d4c68db413e$var$addCodeArg(code, arg) {
    if (arg instanceof $d8eb6d4c68db413e$var$_Code) code.push(...arg._items);
    else if (arg instanceof $d8eb6d4c68db413e$var$Name) code.push(arg);
    else code.push($d8eb6d4c68db413e$var$interpolate(arg));
}
module.exports.addCodeArg = $d8eb6d4c68db413e$var$addCodeArg;
function $d8eb6d4c68db413e$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $d8eb6d4c68db413e$var$plus) {
            const res = $d8eb6d4c68db413e$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $d8eb6d4c68db413e$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $d8eb6d4c68db413e$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $d8eb6d4c68db413e$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $d8eb6d4c68db413e$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $d8eb6d4c68db413e$var$str`${c1}${c2}`;
}
module.exports.strConcat = $d8eb6d4c68db413e$var$strConcat;
// TODO do not allow arrays here
function $d8eb6d4c68db413e$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $d8eb6d4c68db413e$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $d8eb6d4c68db413e$var$stringify(x) {
    return new $d8eb6d4c68db413e$var$_Code($d8eb6d4c68db413e$var$safeStringify(x));
}
module.exports.stringify = $d8eb6d4c68db413e$var$stringify;
function $d8eb6d4c68db413e$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $d8eb6d4c68db413e$var$safeStringify;
function $d8eb6d4c68db413e$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $d8eb6d4c68db413e$var$_Code(`.${key}`) : $d8eb6d4c68db413e$var$_`[${key}]`;
}
module.exports.getProperty = $d8eb6d4c68db413e$var$getProperty;
//Does best effort to format the name properly
function $d8eb6d4c68db413e$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $d8eb6d4c68db413e$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $d8eb6d4c68db413e$var$getEsmExportName;
function $d8eb6d4c68db413e$var$regexpCode(rx) {
    return new $d8eb6d4c68db413e$var$_Code(rx.toString());
}
module.exports.regexpCode = $d8eb6d4c68db413e$var$regexpCode;

});

parcelRegister("5rYlJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $iCENS = parcelRequire("iCENS");
class $3f7e49816c1a83f4$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $3f7e49816c1a83f4$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($3f7e49816c1a83f4$var$UsedValueState || (module.exports.UsedValueState = $3f7e49816c1a83f4$var$UsedValueState = {}));
module.exports.varKinds = {
    const: new $iCENS.Name("const"),
    let: new $iCENS.Name("let"),
    var: new $iCENS.Name("var")
};
class $3f7e49816c1a83f4$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $iCENS.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $iCENS.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $3f7e49816c1a83f4$var$Scope;
class $3f7e49816c1a83f4$var$ValueScopeName extends $iCENS.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $iCENS._)`.${new $iCENS.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $3f7e49816c1a83f4$var$ValueScopeName;
const $3f7e49816c1a83f4$var$line = (0, $iCENS._)`\n`;
class $3f7e49816c1a83f4$var$ValueScope extends $3f7e49816c1a83f4$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $3f7e49816c1a83f4$var$line : $iCENS.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $3f7e49816c1a83f4$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $iCENS._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $iCENS.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $3f7e49816c1a83f4$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $iCENS._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $iCENS._)`${code}${c}${this.opts._n}`;
                else throw new $3f7e49816c1a83f4$var$ValueError(name);
                nameSet.set(name, $3f7e49816c1a83f4$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $3f7e49816c1a83f4$var$ValueScope;

});


parcelRegister("4wi01", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $8vps4 = parcelRequire("8vps4");

var $iCENS = parcelRequire("iCENS");
// TODO refactor to use Set
function $34a81ce1544e5daf$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $34a81ce1544e5daf$var$toHash;
function $34a81ce1544e5daf$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $34a81ce1544e5daf$var$checkUnknownRules(it, schema);
    return !$34a81ce1544e5daf$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $34a81ce1544e5daf$var$alwaysValidSchema;
function $34a81ce1544e5daf$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $34a81ce1544e5daf$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $34a81ce1544e5daf$var$checkUnknownRules;
function $34a81ce1544e5daf$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $34a81ce1544e5daf$var$schemaHasRules;
function $34a81ce1544e5daf$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $34a81ce1544e5daf$var$schemaHasRulesButRef;
function $34a81ce1544e5daf$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $8vps4._)`${schema}`;
    }
    return (0, $8vps4._)`${topSchemaRef}${schemaPath}${(0, $8vps4.getProperty)(keyword)}`;
}
module.exports.schemaRefOrVal = $34a81ce1544e5daf$var$schemaRefOrVal;
function $34a81ce1544e5daf$var$unescapeFragment(str) {
    return $34a81ce1544e5daf$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $34a81ce1544e5daf$var$unescapeFragment;
function $34a81ce1544e5daf$var$escapeFragment(str) {
    return encodeURIComponent($34a81ce1544e5daf$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $34a81ce1544e5daf$var$escapeFragment;
function $34a81ce1544e5daf$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $34a81ce1544e5daf$var$escapeJsonPointer;
function $34a81ce1544e5daf$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $34a81ce1544e5daf$var$unescapeJsonPointer;
function $34a81ce1544e5daf$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $34a81ce1544e5daf$var$eachItem;
function $34a81ce1544e5daf$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $8vps4.Name ? (from instanceof $8vps4.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $8vps4.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $8vps4.Name && !(res instanceof $8vps4.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $34a81ce1544e5daf$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $8vps4._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $8vps4._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $8vps4._)`${to} || {}`).code((0, $8vps4._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $8vps4._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $8vps4._)`${to} || {}`);
                    $34a81ce1544e5daf$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $34a81ce1544e5daf$var$evaluatedPropsToName
    }),
    items: $34a81ce1544e5daf$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $8vps4._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $8vps4._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $8vps4._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $8vps4._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $34a81ce1544e5daf$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $8vps4._)`{}`);
    if (ps !== undefined) $34a81ce1544e5daf$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $34a81ce1544e5daf$var$evaluatedPropsToName;
function $34a81ce1544e5daf$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $8vps4._)`${props}${(0, $8vps4.getProperty)(p)}`, true));
}
module.exports.setEvaluated = $34a81ce1544e5daf$var$setEvaluated;
const $34a81ce1544e5daf$var$snippets = {};
function $34a81ce1544e5daf$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $34a81ce1544e5daf$var$snippets[f.code] || ($34a81ce1544e5daf$var$snippets[f.code] = new $iCENS._Code(f.code))
    });
}
module.exports.useFunc = $34a81ce1544e5daf$var$useFunc;
var $34a81ce1544e5daf$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($34a81ce1544e5daf$var$Type || (module.exports.Type = $34a81ce1544e5daf$var$Type = {}));
function $34a81ce1544e5daf$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $8vps4.Name) {
        const isNumber = dataPropType === $34a81ce1544e5daf$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $8vps4._)`"[" + ${dataProp} + "]"` : (0, $8vps4._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $8vps4._)`"/" + ${dataProp}` : (0, $8vps4._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $8vps4.getProperty)(dataProp).toString() : "/" + $34a81ce1544e5daf$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $34a81ce1544e5daf$var$getErrorPath;
function $34a81ce1544e5daf$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $34a81ce1544e5daf$var$checkStrictMode;

});

parcelRegister("4tUVW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");
const $343608acb407c143$var$names = {
    // validation function arguments
    data: new $8vps4.Name("data"),
    // args passed from referencing schema
    valCxt: new $8vps4.Name("valCxt"),
    instancePath: new $8vps4.Name("instancePath"),
    parentData: new $8vps4.Name("parentData"),
    parentDataProperty: new $8vps4.Name("parentDataProperty"),
    rootData: new $8vps4.Name("rootData"),
    dynamicAnchors: new $8vps4.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $8vps4.Name("vErrors"),
    errors: new $8vps4.Name("errors"),
    this: new $8vps4.Name("this"),
    // "globals"
    self: new $8vps4.Name("self"),
    scope: new $8vps4.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $8vps4.Name("json"),
    jsonPos: new $8vps4.Name("jsonPos"),
    jsonLen: new $8vps4.Name("jsonLen"),
    jsonPart: new $8vps4.Name("jsonPart")
};
module.exports.default = $343608acb407c143$var$names;

});



parcelRegister("riMdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $2Y0Hl = parcelRequire("2Y0Hl");

var $2rT8q = parcelRequire("2rT8q");

var $1Jv02 = parcelRequire("1Jv02");

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
var $0521166653711c1c$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($0521166653711c1c$var$DataType || (module.exports.DataType = $0521166653711c1c$var$DataType = {}));
function $0521166653711c1c$var$getSchemaTypes(schema) {
    const types = $0521166653711c1c$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $0521166653711c1c$var$getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function $0521166653711c1c$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($2Y0Hl.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $0521166653711c1c$var$getJSONTypes;
function $0521166653711c1c$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $0521166653711c1c$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $2rT8q.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $0521166653711c1c$var$checkDataTypes(types, data, opts.strictNumbers, $0521166653711c1c$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $0521166653711c1c$var$coerceData(it, types, coerceTo);
            else $0521166653711c1c$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $0521166653711c1c$var$coerceAndCheckDataType;
const $0521166653711c1c$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $0521166653711c1c$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$0521166653711c1c$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $0521166653711c1c$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $8vps4._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $8vps4._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $8vps4._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $8vps4._)`${data}[0]`).assign(dataType, (0, $8vps4._)`typeof ${data}`).if($0521166653711c1c$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $8vps4._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($0521166653711c1c$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $0521166653711c1c$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $8vps4._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $0521166653711c1c$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $8vps4._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $8vps4._)`"" + ${data}`).elseIf((0, $8vps4._)`${data} === null`).assign(coerced, (0, $8vps4._)`""`);
                return;
            case "number":
                gen.elseIf((0, $8vps4._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $8vps4._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $8vps4._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $8vps4._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $8vps4._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $8vps4._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $8vps4._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $8vps4._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $8vps4._)`[${data}]`);
        }
    }
}
function $0521166653711c1c$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $8vps4._)`${parentData} !== undefined`, ()=>gen.assign((0, $8vps4._)`${parentData}[${parentDataProperty}]`, expr));
}
function $0521166653711c1c$var$checkDataType(dataType, data, strictNums, correct = $0521166653711c1c$var$DataType.Correct) {
    const EQ = correct === $0521166653711c1c$var$DataType.Correct ? $8vps4.operators.EQ : $8vps4.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $8vps4._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $8vps4._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $8vps4._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $8vps4._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $8vps4._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $0521166653711c1c$var$DataType.Correct ? cond : (0, $8vps4.not)(cond);
    function numCond(_cond = $8vps4.nil) {
        return (0, $8vps4.and)((0, $8vps4._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $8vps4._)`isFinite(${data})` : $8vps4.nil);
    }
}
module.exports.checkDataType = $0521166653711c1c$var$checkDataType;
function $0521166653711c1c$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $0521166653711c1c$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $4wi01.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $8vps4._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $8vps4._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $8vps4.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $8vps4.and)(cond, $0521166653711c1c$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $0521166653711c1c$var$checkDataTypes;
const $0521166653711c1c$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $8vps4._)`{type: ${schema}}` : (0, $8vps4._)`{type: ${schemaValue}}`
};
function $0521166653711c1c$var$reportTypeError(it) {
    const cxt = $0521166653711c1c$var$getTypeErrorContext(it);
    (0, $1Jv02.reportError)(cxt, $0521166653711c1c$var$typeError);
}
module.exports.reportTypeError = $0521166653711c1c$var$reportTypeError;
function $0521166653711c1c$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $4wi01.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("2Y0Hl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $2291b9fc9fb51905$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $2291b9fc9fb51905$var$jsonTypes = new Set($2291b9fc9fb51905$var$_jsonTypes);
function $2291b9fc9fb51905$var$isJSONType(x) {
    return typeof x == "string" && $2291b9fc9fb51905$var$jsonTypes.has(x);
}
module.exports.isJSONType = $2291b9fc9fb51905$var$isJSONType;
function $2291b9fc9fb51905$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $2291b9fc9fb51905$var$getRules;

});

parcelRegister("2rT8q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $1c88df0279d2bd29$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $1c88df0279d2bd29$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $1c88df0279d2bd29$var$schemaHasRulesForType;
function $1c88df0279d2bd29$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$1c88df0279d2bd29$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $1c88df0279d2bd29$var$shouldUseGroup;
function $1c88df0279d2bd29$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $1c88df0279d2bd29$var$shouldUseRule;

});


parcelRegister("d8h1X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
function $98f93ba29d074111$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$98f93ba29d074111$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$98f93ba29d074111$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $98f93ba29d074111$var$assignDefaults;
function $98f93ba29d074111$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $8vps4._)`${data}${(0, $8vps4.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $4wi01.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $8vps4._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $8vps4._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $8vps4._)`${childData} = ${(0, $8vps4.stringify)(defaultValue)}`);
}

});

parcelRegister("fY8yN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4tUVW = parcelRequire("4tUVW");

var $dlwLI = parcelRequire("dlwLI");

var $1Jv02 = parcelRequire("1Jv02");
function $ba03197e4f4de505$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $ba03197e4f4de505$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $8vps4.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $ba03197e4f4de505$var$macroKeywordCode;
function $ba03197e4f4de505$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $ba03197e4f4de505$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $ba03197e4f4de505$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $ba03197e4f4de505$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $ba03197e4f4de505$var$modifyData(cxt);
            reportErrs(()=>$ba03197e4f4de505$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $8vps4._)`await `), (e)=>gen.assign(valid, false).if((0, $8vps4._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $8vps4._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $8vps4._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($8vps4.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $8vps4._)`await ` : $8vps4.nil) {
        const passCxt = it.opts.passContext ? $4tUVW.default.this : $4tUVW.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $8vps4._)`${_await}${(0, $dlwLI.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $8vps4.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $ba03197e4f4de505$var$funcKeywordCode;
function $ba03197e4f4de505$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $8vps4._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $ba03197e4f4de505$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $8vps4._)`Array.isArray(${errs})`, ()=>{
        gen.assign($4tUVW.default.vErrors, (0, $8vps4._)`${$4tUVW.default.vErrors} === null ? ${errs} : ${$4tUVW.default.vErrors}.concat(${errs})`).assign($4tUVW.default.errors, (0, $8vps4._)`${$4tUVW.default.vErrors}.length`);
        (0, $1Jv02.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $ba03197e4f4de505$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $ba03197e4f4de505$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $8vps4.stringify)(result)
    });
}
function $ba03197e4f4de505$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $ba03197e4f4de505$var$validSchemaType;
function $ba03197e4f4de505$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $ba03197e4f4de505$var$validateKeywordUsage;

});
parcelRegister("dlwLI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $4tUVW = parcelRequire("4tUVW");

var $4wi01 = parcelRequire("4wi01");
function $9b76a7afffcc400e$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($9b76a7afffcc400e$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $8vps4._)`${prop}`
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $9b76a7afffcc400e$var$checkReportMissingProp;
function $9b76a7afffcc400e$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $8vps4.or)(...properties.map((prop)=>(0, $8vps4.and)($9b76a7afffcc400e$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $8vps4._)`${missing} = ${prop}`)));
}
module.exports.checkMissingProp = $9b76a7afffcc400e$var$checkMissingProp;
function $9b76a7afffcc400e$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $9b76a7afffcc400e$var$reportMissingProp;
function $9b76a7afffcc400e$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $8vps4._)`Object.prototype.hasOwnProperty`
    });
}
module.exports.hasPropFunc = $9b76a7afffcc400e$var$hasPropFunc;
function $9b76a7afffcc400e$var$isOwnProperty(gen, data, property) {
    return (0, $8vps4._)`${$9b76a7afffcc400e$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
module.exports.isOwnProperty = $9b76a7afffcc400e$var$isOwnProperty;
function $9b76a7afffcc400e$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $8vps4._)`${data}${(0, $8vps4.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $8vps4._)`${cond} && ${$9b76a7afffcc400e$var$isOwnProperty(gen, data, property)}` : cond;
}
module.exports.propertyInData = $9b76a7afffcc400e$var$propertyInData;
function $9b76a7afffcc400e$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $8vps4._)`${data}${(0, $8vps4.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $8vps4.or)(cond, (0, $8vps4.not)($9b76a7afffcc400e$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $9b76a7afffcc400e$var$noPropertyInData;
function $9b76a7afffcc400e$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $9b76a7afffcc400e$var$allSchemaProperties;
function $9b76a7afffcc400e$var$schemaProperties(it, schemaMap) {
    return $9b76a7afffcc400e$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $4wi01.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $9b76a7afffcc400e$var$schemaProperties;
function $9b76a7afffcc400e$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $8vps4._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $4tUVW.default.instancePath,
            (0, $8vps4.strConcat)($4tUVW.default.instancePath, errorPath)
        ],
        [
            $4tUVW.default.parentData,
            it.parentData
        ],
        [
            $4tUVW.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $4tUVW.default.rootData,
            $4tUVW.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $4tUVW.default.dynamicAnchors,
        $4tUVW.default.dynamicAnchors
    ]);
    const args = (0, $8vps4._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $8vps4.nil ? (0, $8vps4._)`${func}.call(${context}, ${args})` : (0, $8vps4._)`${func}(${args})`;
}
module.exports.callValidateCode = $9b76a7afffcc400e$var$callValidateCode;
const $9b76a7afffcc400e$var$newRegExp = (0, $8vps4._)`new RegExp`;
function $9b76a7afffcc400e$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $8vps4._)`${regExp.code === "new RegExp" ? $9b76a7afffcc400e$var$newRegExp : (0, $4wi01.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
module.exports.usePattern = $9b76a7afffcc400e$var$usePattern;
function $9b76a7afffcc400e$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $8vps4._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $4wi01.Type.Num
            }, valid);
            gen.if((0, $8vps4.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $9b76a7afffcc400e$var$validateArray;
function $9b76a7afffcc400e$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $4wi01.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $8vps4._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $8vps4.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $9b76a7afffcc400e$var$validateUnion;

});


parcelRegister("3HMak", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
function $2b2abfed4e72e78c$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $8vps4._)`${it.schemaPath}${(0, $8vps4.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $8vps4._)`${it.schemaPath}${(0, $8vps4.getProperty)(keyword)}${(0, $8vps4.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $4wi01.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $2b2abfed4e72e78c$var$getSubschema;
function $2b2abfed4e72e78c$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $8vps4._)`${it.data}${(0, $8vps4.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $8vps4.str)`${errorPath}${(0, $4wi01.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $8vps4._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $8vps4.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $2b2abfed4e72e78c$var$extendSubschemaData;
function $2b2abfed4e72e78c$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $2b2abfed4e72e78c$var$extendSubschemaMode;

});

parcelRegister("3aYST", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $4wi01 = parcelRequire("4wi01");

var $erj4U = parcelRequire("erj4U");

var $5KXa7 = parcelRequire("5KXa7");
// TODO refactor to use keyword definitions
const $250188a1c9c24711$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $250188a1c9c24711$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$250188a1c9c24711$var$hasRef(schema);
    if (!limit) return false;
    return $250188a1c9c24711$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $250188a1c9c24711$var$inlineRef;
const $250188a1c9c24711$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $250188a1c9c24711$var$hasRef(schema) {
    for(const key in schema){
        if ($250188a1c9c24711$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($250188a1c9c24711$var$hasRef)) return true;
        if (typeof sch == "object" && $250188a1c9c24711$var$hasRef(sch)) return true;
    }
    return false;
}
function $250188a1c9c24711$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($250188a1c9c24711$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $4wi01.eachItem)(schema[key], (sch)=>count += $250188a1c9c24711$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $250188a1c9c24711$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $250188a1c9c24711$var$normalizeId(id);
    const p = resolver.parse(id);
    return $250188a1c9c24711$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $250188a1c9c24711$var$getFullPath;
function $250188a1c9c24711$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $250188a1c9c24711$var$_getFullPath;
const $250188a1c9c24711$var$TRAILING_SLASH_HASH = /#\/?$/;
function $250188a1c9c24711$var$normalizeId(id) {
    return id ? id.replace($250188a1c9c24711$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $250188a1c9c24711$var$normalizeId;
function $250188a1c9c24711$var$resolveUrl(resolver, baseId, id) {
    id = $250188a1c9c24711$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $250188a1c9c24711$var$resolveUrl;
const $250188a1c9c24711$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $250188a1c9c24711$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $250188a1c9c24711$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $250188a1c9c24711$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $5KXa7(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $250188a1c9c24711$var$normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $250188a1c9c24711$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$250188a1c9c24711$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$erj4U(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $250188a1c9c24711$var$getSchemaRefs;

});
parcelRegister("erj4U", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("5KXa7", function(module, exports) {
'use strict';
var $430f240765886d3f$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $430f240765886d3f$var$_traverse(opts, pre, post, schema, '', schema);
};
$430f240765886d3f$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$430f240765886d3f$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$430f240765886d3f$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$430f240765886d3f$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $430f240765886d3f$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $430f240765886d3f$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$430f240765886d3f$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $430f240765886d3f$var$traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)$430f240765886d3f$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $430f240765886d3f$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $430f240765886d3f$var$traverse.keywords || opts.allKeys && !(key in $430f240765886d3f$var$traverse.skipKeywords)) $430f240765886d3f$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $430f240765886d3f$var$escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

});



parcelRegister("cMAcV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $94e60dc1f646591b$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $94e60dc1f646591b$var$ValidationError;

});

parcelRegister("8u76A", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3aYST = parcelRequire("3aYST");
class $62d6a30c6111d4d2$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $3aYST.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $3aYST.normalizeId)((0, $3aYST.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $62d6a30c6111d4d2$var$MissingRefError;

});

parcelRegister("bRq00", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $8vps4 = parcelRequire("8vps4");

var $cMAcV = parcelRequire("cMAcV");

var $4tUVW = parcelRequire("4tUVW");

var $3aYST = parcelRequire("3aYST");

var $4wi01 = parcelRequire("4wi01");

var $4Gzns = parcelRequire("4Gzns");
class $8a28cfd024ae1d06$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $3aYST.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $8a28cfd024ae1d06$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $8a28cfd024ae1d06$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $8a28cfd024ae1d06$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $3aYST.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $8vps4.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $cMAcV.default,
        code: (0, $8vps4._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $4tUVW.default.data,
        parentData: $4tUVW.default.parentData,
        parentDataProperty: $4tUVW.default.parentDataProperty,
        dataNames: [
            $4tUVW.default.data
        ],
        dataPathArr: [
            $8vps4.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $8vps4.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $8vps4.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $8vps4._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $4Gzns.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($4tUVW.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$4tUVW.default.self}`, `${$4tUVW.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $8vps4.Name ? undefined : props,
                items: items instanceof $8vps4.Name ? undefined : items,
                dynamicProps: props instanceof $8vps4.Name,
                dynamicItems: items instanceof $8vps4.Name
            };
            if (validate.source) validate.source.evaluated = (0, $8vps4.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $8a28cfd024ae1d06$var$compileSchema;
function $8a28cfd024ae1d06$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $3aYST.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $8a28cfd024ae1d06$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $8a28cfd024ae1d06$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $8a28cfd024ae1d06$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $8a28cfd024ae1d06$var$resolveRef;
function $8a28cfd024ae1d06$var$inlineOrCompile(sch) {
    if ((0, $3aYST.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $8a28cfd024ae1d06$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $8a28cfd024ae1d06$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($8a28cfd024ae1d06$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $8a28cfd024ae1d06$var$getCompilingSchema;
function $8a28cfd024ae1d06$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $8a28cfd024ae1d06$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $8a28cfd024ae1d06$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $8a28cfd024ae1d06$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $3aYST._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $3aYST.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $8a28cfd024ae1d06$var$getJsonPointer.call(this, p, root);
    const id = (0, $3aYST.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $8a28cfd024ae1d06$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $8a28cfd024ae1d06$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $8a28cfd024ae1d06$var$compileSchema.call(this, schOrRef);
    if (id === (0, $3aYST.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $3aYST.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $8a28cfd024ae1d06$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $8a28cfd024ae1d06$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $8a28cfd024ae1d06$var$resolveSchema;
const $8a28cfd024ae1d06$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $8a28cfd024ae1d06$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $4wi01.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$8a28cfd024ae1d06$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $3aYST.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $4wi01.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $3aYST.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $8a28cfd024ae1d06$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $8a28cfd024ae1d06$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("binfM", function(module, exports) {
module.exports = JSON.parse("{\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON AnySchema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

});

parcelRegister("7U7v8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kmiPP = parcelRequire("kmiPP");
$kmiPP.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $kmiPP;

});
parcelRegister("kmiPP", function(module, exports) {
'use strict';

var $4IgSx = parcelRequire("4IgSx");
var $ed2478ed63eb006a$require$normalizeIPv6 = $4IgSx.normalizeIPv6;
var $ed2478ed63eb006a$require$removeDotSegments = $4IgSx.removeDotSegments;
var $ed2478ed63eb006a$require$recomposeAuthority = $4IgSx.recomposeAuthority;
var $ed2478ed63eb006a$require$normalizeComponentEncoding = $4IgSx.normalizeComponentEncoding;
var $ed2478ed63eb006a$require$isIPv4 = $4IgSx.isIPv4;
var $ed2478ed63eb006a$require$nonSimpleDomain = $4IgSx.nonSimpleDomain;

var $fU27W = parcelRequire("fU27W");
var $ed2478ed63eb006a$require$SCHEMES = $fU27W.SCHEMES;
var $ed2478ed63eb006a$require$getSchemeHandler = $fU27W.getSchemeHandler;
/**
 * @template {import('./types/index').URIComponent|string} T
 * @param {T} uri
 * @param {import('./types/index').Options} [options]
 * @returns {T}
 */ function $ed2478ed63eb006a$var$normalize(uri, options) {
    if (typeof uri === 'string') uri = /** @type {T} */ $ed2478ed63eb006a$var$serialize($ed2478ed63eb006a$var$parse(uri, options), options);
    else if (typeof uri === 'object') uri = /** @type {T} */ $ed2478ed63eb006a$var$parse($ed2478ed63eb006a$var$serialize(uri, options), options);
    return uri;
}
/**
 * @param {string} baseURI
 * @param {string} relativeURI
 * @param {import('./types/index').Options} [options]
 * @returns {string}
 */ function $ed2478ed63eb006a$var$resolve(baseURI, relativeURI, options) {
    const schemelessOptions = options ? Object.assign({
        scheme: 'null'
    }, options) : {
        scheme: 'null'
    };
    const resolved = $ed2478ed63eb006a$var$resolveComponent($ed2478ed63eb006a$var$parse(baseURI, schemelessOptions), $ed2478ed63eb006a$var$parse(relativeURI, schemelessOptions), schemelessOptions, true);
    schemelessOptions.skipEscape = true;
    return $ed2478ed63eb006a$var$serialize(resolved, schemelessOptions);
}
/**
 * @param {import ('./types/index').URIComponent} base
 * @param {import ('./types/index').URIComponent} relative
 * @param {import('./types/index').Options} [options]
 * @param {boolean} [skipNormalization=false]
 * @returns {import ('./types/index').URIComponent}
 */ function $ed2478ed63eb006a$var$resolveComponent(base, relative, options, skipNormalization) {
    /** @type {import('./types/index').URIComponent} */ const target = {};
    if (!skipNormalization) {
        base = $ed2478ed63eb006a$var$parse($ed2478ed63eb006a$var$serialize(base, options), options) // normalize base component
        ;
        relative = $ed2478ed63eb006a$var$parse($ed2478ed63eb006a$var$serialize(relative, options), options) // normalize relative component
        ;
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        // target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = $ed2478ed63eb006a$require$removeDotSegments(relative.path || '');
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            // target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = $ed2478ed63eb006a$require$removeDotSegments(relative.path || '');
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) target.query = relative.query;
                else target.query = base.query;
            } else {
                if (relative.path[0] === '/') target.path = $ed2478ed63eb006a$require$removeDotSegments(relative.path);
                else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = '/' + relative.path;
                    else if (!base.path) target.path = relative.path;
                    else target.path = base.path.slice(0, base.path.lastIndexOf('/') + 1) + relative.path;
                    target.path = $ed2478ed63eb006a$require$removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            // target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}
/**
 * @param {import ('./types/index').URIComponent|string} uriA
 * @param {import ('./types/index').URIComponent|string} uriB
 * @param {import ('./types/index').Options} options
 * @returns {boolean}
 */ function $ed2478ed63eb006a$var$equal(uriA, uriB, options) {
    if (typeof uriA === 'string') {
        uriA = unescape(uriA);
        uriA = $ed2478ed63eb006a$var$serialize($ed2478ed63eb006a$require$normalizeComponentEncoding($ed2478ed63eb006a$var$parse(uriA, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriA === 'object') uriA = $ed2478ed63eb006a$var$serialize($ed2478ed63eb006a$require$normalizeComponentEncoding(uriA, true), {
        ...options,
        skipEscape: true
    });
    if (typeof uriB === 'string') {
        uriB = unescape(uriB);
        uriB = $ed2478ed63eb006a$var$serialize($ed2478ed63eb006a$require$normalizeComponentEncoding($ed2478ed63eb006a$var$parse(uriB, options), true), {
            ...options,
            skipEscape: true
        });
    } else if (typeof uriB === 'object') uriB = $ed2478ed63eb006a$var$serialize($ed2478ed63eb006a$require$normalizeComponentEncoding(uriB, true), {
        ...options,
        skipEscape: true
    });
    return uriA.toLowerCase() === uriB.toLowerCase();
}
/**
 * @param {Readonly<import('./types/index').URIComponent>} cmpts
 * @param {import('./types/index').Options} [opts]
 * @returns {string}
 */ function $ed2478ed63eb006a$var$serialize(cmpts, opts) {
    const component = {
        host: cmpts.host,
        scheme: cmpts.scheme,
        userinfo: cmpts.userinfo,
        port: cmpts.port,
        path: cmpts.path,
        query: cmpts.query,
        nid: cmpts.nid,
        nss: cmpts.nss,
        uuid: cmpts.uuid,
        fragment: cmpts.fragment,
        reference: cmpts.reference,
        resourceName: cmpts.resourceName,
        secure: cmpts.secure,
        error: ''
    };
    const options = Object.assign({}, opts);
    const uriTokens = [];
    // find scheme handler
    const schemeHandler = $ed2478ed63eb006a$require$getSchemeHandler(options.scheme || component.scheme);
    // perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(component, options);
    if (component.path !== undefined) {
        if (!options.skipEscape) {
            component.path = escape(component.path);
            if (component.scheme !== undefined) component.path = component.path.split('%3A').join(':');
        } else component.path = unescape(component.path);
    }
    if (options.reference !== 'suffix' && component.scheme) uriTokens.push(component.scheme, ':');
    const authority = $ed2478ed63eb006a$require$recomposeAuthority(component);
    if (authority !== undefined) {
        if (options.reference !== 'suffix') uriTokens.push('//');
        uriTokens.push(authority);
        if (component.path && component.path[0] !== '/') uriTokens.push('/');
    }
    if (component.path !== undefined) {
        let s = component.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = $ed2478ed63eb006a$require$removeDotSegments(s);
        if (authority === undefined && s[0] === '/' && s[1] === '/') // don't allow the path to start with "//"
        s = '/%2F' + s.slice(2);
        uriTokens.push(s);
    }
    if (component.query !== undefined) uriTokens.push('?', component.query);
    if (component.fragment !== undefined) uriTokens.push('#', component.fragment);
    return uriTokens.join('');
}
const $ed2478ed63eb006a$var$URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns
 */ function $ed2478ed63eb006a$var$parse(uri, opts) {
    const options = Object.assign({}, opts);
    /** @type {import('./types/index').URIComponent} */ const parsed = {
        scheme: undefined,
        userinfo: undefined,
        host: '',
        port: undefined,
        path: '',
        query: undefined,
        fragment: undefined
    };
    let isIP = false;
    if (options.reference === 'suffix') {
        if (options.scheme) uri = options.scheme + ':' + uri;
        else uri = '//' + uri;
    }
    const matches = uri.match($ed2478ed63eb006a$var$URI_PARSE);
    if (matches) {
        // store each component
        parsed.scheme = matches[1];
        parsed.userinfo = matches[3];
        parsed.host = matches[4];
        parsed.port = parseInt(matches[5], 10);
        parsed.path = matches[6] || '';
        parsed.query = matches[7];
        parsed.fragment = matches[8];
        // fix port number
        if (isNaN(parsed.port)) parsed.port = matches[5];
        if (parsed.host) {
            const ipv4result = $ed2478ed63eb006a$require$isIPv4(parsed.host);
            if (ipv4result === false) {
                const ipv6result = $ed2478ed63eb006a$require$normalizeIPv6(parsed.host);
                parsed.host = ipv6result.host.toLowerCase();
                isIP = ipv6result.isIPV6;
            } else isIP = true;
        }
        if (parsed.scheme === undefined && parsed.userinfo === undefined && parsed.host === undefined && parsed.port === undefined && parsed.query === undefined && !parsed.path) parsed.reference = 'same-document';
        else if (parsed.scheme === undefined) parsed.reference = 'relative';
        else if (parsed.fragment === undefined) parsed.reference = 'absolute';
        else parsed.reference = 'uri';
        // check for reference errors
        if (options.reference && options.reference !== 'suffix' && options.reference !== parsed.reference) parsed.error = parsed.error || 'URI is not a ' + options.reference + ' reference.';
        // find scheme handler
        const schemeHandler = $ed2478ed63eb006a$require$getSchemeHandler(options.scheme || parsed.scheme);
        // check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            // if host component is a domain name
            if (parsed.host && (options.domainHost || schemeHandler && schemeHandler.domainHost) && isIP === false && $ed2478ed63eb006a$require$nonSimpleDomain(parsed.host)) // convert Unicode IDN -> ASCII IDN
            try {
                parsed.host = URL.domainToASCII(parsed.host.toLowerCase());
            } catch (e) {
                parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e;
            }
        // convert IRI -> URI
        }
        if (!schemeHandler || schemeHandler && !schemeHandler.skipNormalize) {
            if (uri.indexOf('%') !== -1) {
                if (parsed.scheme !== undefined) parsed.scheme = unescape(parsed.scheme);
                if (parsed.host !== undefined) parsed.host = unescape(parsed.host);
            }
            if (parsed.path) parsed.path = escape(unescape(parsed.path));
            if (parsed.fragment) parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
        }
        // perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) schemeHandler.parse(parsed, options);
    } else parsed.error = parsed.error || 'URI can not be parsed.';
    return parsed;
}
const $ed2478ed63eb006a$var$fastUri = {
    SCHEMES: $ed2478ed63eb006a$require$SCHEMES,
    normalize: $ed2478ed63eb006a$var$normalize,
    resolve: $ed2478ed63eb006a$var$resolve,
    resolveComponent: $ed2478ed63eb006a$var$resolveComponent,
    equal: $ed2478ed63eb006a$var$equal,
    serialize: $ed2478ed63eb006a$var$serialize,
    parse: $ed2478ed63eb006a$var$parse
};
module.exports = $ed2478ed63eb006a$var$fastUri;
module.exports.default = $ed2478ed63eb006a$var$fastUri;
module.exports.fastUri = $ed2478ed63eb006a$var$fastUri;

});
parcelRegister("4IgSx", function(module, exports) {
'use strict';
/** @type {(value: string) => boolean} */ const $36e85d393cf88e0d$var$isUUID = RegExp.prototype.test.bind(/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/iu);
/** @type {(value: string) => boolean} */ const $36e85d393cf88e0d$var$isIPv4 = RegExp.prototype.test.bind(/^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)$/u);
/**
 * @param {Array<string>} input
 * @returns {string}
 */ function $36e85d393cf88e0d$var$stringArrayToHexStripped(input) {
    let acc = '';
    let code = 0;
    let i = 0;
    for(i = 0; i < input.length; i++){
        code = input[i].charCodeAt(0);
        if (code === 48) continue;
        if (!(code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102)) return '';
        acc += input[i];
        break;
    }
    for(i += 1; i < input.length; i++){
        code = input[i].charCodeAt(0);
        if (!(code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102)) return '';
        acc += input[i];
    }
    return acc;
}
/**
 * @typedef {Object} GetIPV6Result
 * @property {boolean} error - Indicates if there was an error parsing the IPv6 address.
 * @property {string} address - The parsed IPv6 address.
 * @property {string} [zone] - The zone identifier, if present.
 */ /**
 * @param {string} value
 * @returns {boolean}
 */ const $36e85d393cf88e0d$var$nonSimpleDomain = RegExp.prototype.test.bind(/[^!"$&'()*+,\-.;=_`a-z{}~]/u);
/**
 * @param {Array<string>} buffer
 * @returns {boolean}
 */ function $36e85d393cf88e0d$var$consumeIsZone(buffer) {
    buffer.length = 0;
    return true;
}
/**
 * @param {Array<string>} buffer
 * @param {Array<string>} address
 * @param {GetIPV6Result} output
 * @returns {boolean}
 */ function $36e85d393cf88e0d$var$consumeHextets(buffer, address, output) {
    if (buffer.length) {
        const hex = $36e85d393cf88e0d$var$stringArrayToHexStripped(buffer);
        if (hex !== '') address.push(hex);
        else {
            output.error = true;
            return false;
        }
        buffer.length = 0;
    }
    return true;
}
/**
 * @param {string} input
 * @returns {GetIPV6Result}
 */ function $36e85d393cf88e0d$var$getIPV6(input) {
    let tokenCount = 0;
    const output = {
        error: false,
        address: '',
        zone: ''
    };
    /** @type {Array<string>} */ const address = [];
    /** @type {Array<string>} */ const buffer = [];
    let endipv6Encountered = false;
    let endIpv6 = false;
    let consume = $36e85d393cf88e0d$var$consumeHextets;
    for(let i = 0; i < input.length; i++){
        const cursor = input[i];
        if (cursor === '[' || cursor === ']') continue;
        if (cursor === ':') {
            if (endipv6Encountered === true) endIpv6 = true;
            if (!consume(buffer, address, output)) break;
            if (++tokenCount > 7) {
                // not valid
                output.error = true;
                break;
            }
            if (i > 0 && input[i - 1] === ':') endipv6Encountered = true;
            address.push(':');
            continue;
        } else if (cursor === '%') {
            if (!consume(buffer, address, output)) break;
            // switch to zone detection
            consume = $36e85d393cf88e0d$var$consumeIsZone;
        } else {
            buffer.push(cursor);
            continue;
        }
    }
    if (buffer.length) {
        if (consume === $36e85d393cf88e0d$var$consumeIsZone) output.zone = buffer.join('');
        else if (endIpv6) address.push(buffer.join(''));
        else address.push($36e85d393cf88e0d$var$stringArrayToHexStripped(buffer));
    }
    output.address = address.join('');
    return output;
}
/**
 * @typedef {Object} NormalizeIPv6Result
 * @property {string} host - The normalized host.
 * @property {string} [escapedHost] - The escaped host.
 * @property {boolean} isIPV6 - Indicates if the host is an IPv6 address.
 */ /**
 * @param {string} host
 * @returns {NormalizeIPv6Result}
 */ function $36e85d393cf88e0d$var$normalizeIPv6(host) {
    if ($36e85d393cf88e0d$var$findToken(host, ':') < 2) return {
        host: host,
        isIPV6: false
    };
    const ipv6 = $36e85d393cf88e0d$var$getIPV6(host);
    if (!ipv6.error) {
        let newHost = ipv6.address;
        let escapedHost = ipv6.address;
        if (ipv6.zone) {
            newHost += '%' + ipv6.zone;
            escapedHost += '%25' + ipv6.zone;
        }
        return {
            host: newHost,
            isIPV6: true,
            escapedHost: escapedHost
        };
    } else return {
        host: host,
        isIPV6: false
    };
}
/**
 * @param {string} str
 * @param {string} token
 * @returns {number}
 */ function $36e85d393cf88e0d$var$findToken(str, token) {
    let ind = 0;
    for(let i = 0; i < str.length; i++)if (str[i] === token) ind++;
    return ind;
}
/**
 * @param {string} path
 * @returns {string}
 *
 * @see https://datatracker.ietf.org/doc/html/rfc3986#section-5.2.4
 */ function $36e85d393cf88e0d$var$removeDotSegments(path) {
    let input = path;
    const output = [];
    let nextSlash = -1;
    let len = 0;
    // eslint-disable-next-line no-cond-assign
    while(len = input.length){
        if (len === 1) {
            if (input === '.') break;
            else if (input === '/') {
                output.push('/');
                break;
            } else {
                output.push(input);
                break;
            }
        } else if (len === 2) {
            if (input[0] === '.') {
                if (input[1] === '.') break;
                else if (input[1] === '/') {
                    input = input.slice(2);
                    continue;
                }
            } else if (input[0] === '/') {
                if (input[1] === '.' || input[1] === '/') {
                    output.push('/');
                    break;
                }
            }
        } else if (len === 3) {
            if (input === '/..') {
                if (output.length !== 0) output.pop();
                output.push('/');
                break;
            }
        }
        if (input[0] === '.') {
            if (input[1] === '.') {
                if (input[2] === '/') {
                    input = input.slice(3);
                    continue;
                }
            } else if (input[1] === '/') {
                input = input.slice(2);
                continue;
            }
        } else if (input[0] === '/') {
            if (input[1] === '.') {
                if (input[2] === '/') {
                    input = input.slice(2);
                    continue;
                } else if (input[2] === '.') {
                    if (input[3] === '/') {
                        input = input.slice(3);
                        if (output.length !== 0) output.pop();
                        continue;
                    }
                }
            }
        }
        // Rule 2E: Move normal path segment to output
        if ((nextSlash = input.indexOf('/', 1)) === -1) {
            output.push(input);
            break;
        } else {
            output.push(input.slice(0, nextSlash));
            input = input.slice(nextSlash);
        }
    }
    return output.join('');
}
/**
 * @param {import('../types/index').URIComponent} component
 * @param {boolean} esc
 * @returns {import('../types/index').URIComponent}
 */ function $36e85d393cf88e0d$var$normalizeComponentEncoding(component, esc) {
    const func = esc !== true ? escape : unescape;
    if (component.scheme !== undefined) component.scheme = func(component.scheme);
    if (component.userinfo !== undefined) component.userinfo = func(component.userinfo);
    if (component.host !== undefined) component.host = func(component.host);
    if (component.path !== undefined) component.path = func(component.path);
    if (component.query !== undefined) component.query = func(component.query);
    if (component.fragment !== undefined) component.fragment = func(component.fragment);
    return component;
}
/**
 * @param {import('../types/index').URIComponent} component
 * @returns {string|undefined}
 */ function $36e85d393cf88e0d$var$recomposeAuthority(component) {
    const uriTokens = [];
    if (component.userinfo !== undefined) {
        uriTokens.push(component.userinfo);
        uriTokens.push('@');
    }
    if (component.host !== undefined) {
        let host = unescape(component.host);
        if (!$36e85d393cf88e0d$var$isIPv4(host)) {
            const ipV6res = $36e85d393cf88e0d$var$normalizeIPv6(host);
            if (ipV6res.isIPV6 === true) host = `[${ipV6res.escapedHost}]`;
            else host = component.host;
        }
        uriTokens.push(host);
    }
    if (typeof component.port === 'number' || typeof component.port === 'string') {
        uriTokens.push(':');
        uriTokens.push(String(component.port));
    }
    return uriTokens.length ? uriTokens.join('') : undefined;
}
module.exports = {
    nonSimpleDomain: $36e85d393cf88e0d$var$nonSimpleDomain,
    recomposeAuthority: $36e85d393cf88e0d$var$recomposeAuthority,
    normalizeComponentEncoding: $36e85d393cf88e0d$var$normalizeComponentEncoding,
    removeDotSegments: $36e85d393cf88e0d$var$removeDotSegments,
    isIPv4: $36e85d393cf88e0d$var$isIPv4,
    isUUID: $36e85d393cf88e0d$var$isUUID,
    normalizeIPv6: $36e85d393cf88e0d$var$normalizeIPv6,
    stringArrayToHexStripped: $36e85d393cf88e0d$var$stringArrayToHexStripped
};

});

parcelRegister("fU27W", function(module, exports) {
'use strict';

var $4IgSx = parcelRequire("4IgSx");
var $b93dbc61af4fc593$require$isUUID = $4IgSx.isUUID;
const $b93dbc61af4fc593$var$URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
const $b93dbc61af4fc593$var$supportedSchemeNames = /** @type {const} */ [
    'http',
    'https',
    'ws',
    'wss',
    'urn',
    'urn:uuid'
];
/** @typedef {supportedSchemeNames[number]} SchemeName */ /**
 * @param {string} name
 * @returns {name is SchemeName}
 */ function $b93dbc61af4fc593$var$isValidSchemeName(name) {
    return $b93dbc61af4fc593$var$supportedSchemeNames.indexOf(/** @type {*} */ name) !== -1;
}
/**
 * @callback SchemeFn
 * @param {import('../types/index').URIComponent} component
 * @param {import('../types/index').Options} options
 * @returns {import('../types/index').URIComponent}
 */ /**
 * @typedef {Object} SchemeHandler
 * @property {SchemeName} scheme - The scheme name.
 * @property {boolean} [domainHost] - Indicates if the scheme supports domain hosts.
 * @property {SchemeFn} parse - Function to parse the URI component for this scheme.
 * @property {SchemeFn} serialize - Function to serialize the URI component for this scheme.
 * @property {boolean} [skipNormalize] - Indicates if normalization should be skipped for this scheme.
 * @property {boolean} [absolutePath] - Indicates if the scheme uses absolute paths.
 * @property {boolean} [unicodeSupport] - Indicates if the scheme supports Unicode.
 */ /**
 * @param {import('../types/index').URIComponent} wsComponent
 * @returns {boolean}
 */ function $b93dbc61af4fc593$var$wsIsSecure(wsComponent) {
    if (wsComponent.secure === true) return true;
    else if (wsComponent.secure === false) return false;
    else if (wsComponent.scheme) return wsComponent.scheme.length === 3 && (wsComponent.scheme[0] === 'w' || wsComponent.scheme[0] === 'W') && (wsComponent.scheme[1] === 's' || wsComponent.scheme[1] === 'S') && (wsComponent.scheme[2] === 's' || wsComponent.scheme[2] === 'S');
    else return false;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$httpParse(component) {
    if (!component.host) component.error = component.error || 'HTTP URIs must have a host.';
    return component;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$httpSerialize(component) {
    const secure = String(component.scheme).toLowerCase() === 'https';
    // normalize the default port
    if (component.port === (secure ? 443 : 80) || component.port === '') component.port = undefined;
    // normalize the empty path
    if (!component.path) component.path = '/';
    // NOTE: We do not parse query strings for HTTP URIs
    // as WWW Form Url Encoded query strings are part of the HTML4+ spec,
    // and not the HTTP spec.
    return component;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$wsParse(wsComponent) {
    // indicate if the secure flag is set
    wsComponent.secure = $b93dbc61af4fc593$var$wsIsSecure(wsComponent);
    // construct resouce name
    wsComponent.resourceName = (wsComponent.path || '/') + (wsComponent.query ? '?' + wsComponent.query : '');
    wsComponent.path = undefined;
    wsComponent.query = undefined;
    return wsComponent;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$wsSerialize(wsComponent) {
    // normalize the default port
    if (wsComponent.port === ($b93dbc61af4fc593$var$wsIsSecure(wsComponent) ? 443 : 80) || wsComponent.port === '') wsComponent.port = undefined;
    // ensure scheme matches secure flag
    if (typeof wsComponent.secure === 'boolean') {
        wsComponent.scheme = wsComponent.secure ? 'wss' : 'ws';
        wsComponent.secure = undefined;
    }
    // reconstruct path from resource name
    if (wsComponent.resourceName) {
        const [path, query] = wsComponent.resourceName.split('?');
        wsComponent.path = path && path !== '/' ? path : undefined;
        wsComponent.query = query;
        wsComponent.resourceName = undefined;
    }
    // forbid fragment component
    wsComponent.fragment = undefined;
    return wsComponent;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$urnParse(urnComponent, options) {
    if (!urnComponent.path) {
        urnComponent.error = 'URN can not be parsed';
        return urnComponent;
    }
    const matches = urnComponent.path.match($b93dbc61af4fc593$var$URN_REG);
    if (matches) {
        const scheme = options.scheme || urnComponent.scheme || 'urn';
        urnComponent.nid = matches[1].toLowerCase();
        urnComponent.nss = matches[2];
        const urnScheme = `${scheme}:${options.nid || urnComponent.nid}`;
        const schemeHandler = $b93dbc61af4fc593$var$getSchemeHandler(urnScheme);
        urnComponent.path = undefined;
        if (schemeHandler) urnComponent = schemeHandler.parse(urnComponent, options);
    } else urnComponent.error = urnComponent.error || 'URN can not be parsed.';
    return urnComponent;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$urnSerialize(urnComponent, options) {
    if (urnComponent.nid === undefined) throw new Error('URN without nid cannot be serialized');
    const scheme = options.scheme || urnComponent.scheme || 'urn';
    const nid = urnComponent.nid.toLowerCase();
    const urnScheme = `${scheme}:${options.nid || nid}`;
    const schemeHandler = $b93dbc61af4fc593$var$getSchemeHandler(urnScheme);
    if (schemeHandler) urnComponent = schemeHandler.serialize(urnComponent, options);
    const uriComponent = urnComponent;
    const nss = urnComponent.nss;
    uriComponent.path = `${nid || options.nid}:${nss}`;
    options.skipEscape = true;
    return uriComponent;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$urnuuidParse(urnComponent, options) {
    const uuidComponent = urnComponent;
    uuidComponent.uuid = uuidComponent.nss;
    uuidComponent.nss = undefined;
    if (!options.tolerant && (!uuidComponent.uuid || !$b93dbc61af4fc593$require$isUUID(uuidComponent.uuid))) uuidComponent.error = uuidComponent.error || 'UUID is not valid.';
    return uuidComponent;
}
/** @type {SchemeFn} */ function $b93dbc61af4fc593$var$urnuuidSerialize(uuidComponent) {
    const urnComponent = uuidComponent;
    // normalize UUID
    urnComponent.nss = (uuidComponent.uuid || '').toLowerCase();
    return urnComponent;
}
const $b93dbc61af4fc593$var$http = /** @type {SchemeHandler} */ {
    scheme: 'http',
    domainHost: true,
    parse: $b93dbc61af4fc593$var$httpParse,
    serialize: $b93dbc61af4fc593$var$httpSerialize
};
const $b93dbc61af4fc593$var$https = /** @type {SchemeHandler} */ {
    scheme: 'https',
    domainHost: $b93dbc61af4fc593$var$http.domainHost,
    parse: $b93dbc61af4fc593$var$httpParse,
    serialize: $b93dbc61af4fc593$var$httpSerialize
};
const $b93dbc61af4fc593$var$ws = /** @type {SchemeHandler} */ {
    scheme: 'ws',
    domainHost: true,
    parse: $b93dbc61af4fc593$var$wsParse,
    serialize: $b93dbc61af4fc593$var$wsSerialize
};
const $b93dbc61af4fc593$var$wss = /** @type {SchemeHandler} */ {
    scheme: 'wss',
    domainHost: $b93dbc61af4fc593$var$ws.domainHost,
    parse: $b93dbc61af4fc593$var$ws.parse,
    serialize: $b93dbc61af4fc593$var$ws.serialize
};
const $b93dbc61af4fc593$var$urn = /** @type {SchemeHandler} */ {
    scheme: 'urn',
    parse: $b93dbc61af4fc593$var$urnParse,
    serialize: $b93dbc61af4fc593$var$urnSerialize,
    skipNormalize: true
};
const $b93dbc61af4fc593$var$urnuuid = /** @type {SchemeHandler} */ {
    scheme: 'urn:uuid',
    parse: $b93dbc61af4fc593$var$urnuuidParse,
    serialize: $b93dbc61af4fc593$var$urnuuidSerialize,
    skipNormalize: true
};
const $b93dbc61af4fc593$var$SCHEMES = /** @type {Record<SchemeName, SchemeHandler>} */ {
    http: $b93dbc61af4fc593$var$http,
    https: $b93dbc61af4fc593$var$https,
    ws: $b93dbc61af4fc593$var$ws,
    wss: $b93dbc61af4fc593$var$wss,
    urn: $b93dbc61af4fc593$var$urn,
    'urn:uuid': $b93dbc61af4fc593$var$urnuuid
};
Object.setPrototypeOf($b93dbc61af4fc593$var$SCHEMES, null);
/**
 * @param {string|undefined} scheme
 * @returns {SchemeHandler|undefined}
 */ function $b93dbc61af4fc593$var$getSchemeHandler(scheme) {
    return scheme && ($b93dbc61af4fc593$var$SCHEMES[/** @type {SchemeName} */ scheme] || $b93dbc61af4fc593$var$SCHEMES[/** @type {SchemeName} */ scheme.toLowerCase()]) || undefined;
}
module.exports = {
    wsIsSecure: $b93dbc61af4fc593$var$wsIsSecure,
    SCHEMES: $b93dbc61af4fc593$var$SCHEMES,
    isValidSchemeName: $b93dbc61af4fc593$var$isValidSchemeName,
    getSchemeHandler: $b93dbc61af4fc593$var$getSchemeHandler
};

});




parcelRegister("cgRhl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c57c9 = parcelRequire("c57c9");

var $iNdz2 = parcelRequire("iNdz2");

var $3NrUa = parcelRequire("3NrUa");

var $7z6fO = parcelRequire("7z6fO");

var $2H73j = parcelRequire("2H73j");

var $hY9IU = parcelRequire("hY9IU");

var $alCI0 = parcelRequire("alCI0");

var $ap2Xe = parcelRequire("ap2Xe");
const $8ef04eb62dcf4a61$var$draft2020Vocabularies = [
    $7z6fO.default,
    $c57c9.default,
    $iNdz2.default,
    (0, $3NrUa.default)(true),
    $alCI0.default,
    $ap2Xe.metadataVocabulary,
    $ap2Xe.contentVocabulary,
    $2H73j.default,
    $hY9IU.default
];
module.exports.default = $8ef04eb62dcf4a61$var$draft2020Vocabularies;

});
parcelRegister("c57c9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $feijQ = parcelRequire("feijQ");

var $3qfhS = parcelRequire("3qfhS");
const $8cbb886e20a3d343$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $feijQ.default,
    $3qfhS.default
];
module.exports.default = $8cbb886e20a3d343$var$core;

});
parcelRegister("feijQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $b1665f9731ddf293$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $b1665f9731ddf293$var$def;

});

parcelRegister("3qfhS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $8u76A = parcelRequire("8u76A");

var $dlwLI = parcelRequire("dlwLI");

var $8vps4 = parcelRequire("8vps4");

var $4tUVW = parcelRequire("4tUVW");

var $bRq00 = parcelRequire("bRq00");

var $4wi01 = parcelRequire("4wi01");
const $27dfa88cd01de697$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $bRq00.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $8u76A.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $bRq00.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $27dfa88cd01de697$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $27dfa88cd01de697$var$callRef(cxt, (0, $8vps4._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $27dfa88cd01de697$var$getValidate(cxt, sch);
            $27dfa88cd01de697$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $8vps4.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $8vps4.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $27dfa88cd01de697$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $8vps4._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
module.exports.getValidate = $27dfa88cd01de697$var$getValidate;
function $27dfa88cd01de697$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $4tUVW.default.this : $8vps4.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $8vps4._)`await ${(0, $dlwLI.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $8vps4._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $dlwLI.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $8vps4._)`${source}.errors`;
        gen.assign($4tUVW.default.vErrors, (0, $8vps4._)`${$4tUVW.default.vErrors} === null ? ${errs} : ${$4tUVW.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($4tUVW.default.errors, (0, $8vps4._)`${$4tUVW.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $4wi01.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $8vps4._)`${source}.evaluated.props`);
                it.props = $4wi01.mergeEvaluated.props(gen, props, it.props, $8vps4.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $4wi01.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $8vps4._)`${source}.evaluated.items`);
                it.items = $4wi01.mergeEvaluated.items(gen, items, it.items, $8vps4.Name);
            }
        }
    }
}
module.exports.callRef = $27dfa88cd01de697$var$callRef;
module.exports.default = $27dfa88cd01de697$var$def;

});


parcelRegister("iNdz2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9Y3xP = parcelRequire("9Y3xP");

var $8aiwy = parcelRequire("8aiwy");

var $fDrxX = parcelRequire("fDrxX");

var $iACr3 = parcelRequire("iACr3");

var $3dh2K = parcelRequire("3dh2K");

var $hHznA = parcelRequire("hHznA");

var $1cuBe = parcelRequire("1cuBe");

var $g2S11 = parcelRequire("g2S11");

var $52mq6 = parcelRequire("52mq6");

var $RpnZL = parcelRequire("RpnZL");
const $dae753265d64b12b$var$validation = [
    // number
    $9Y3xP.default,
    $8aiwy.default,
    // string
    $fDrxX.default,
    $iACr3.default,
    // object
    $3dh2K.default,
    $hHznA.default,
    // array
    $1cuBe.default,
    $g2S11.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $52mq6.default,
    $RpnZL.default
];
module.exports.default = $dae753265d64b12b$var$validation;

});
parcelRegister("9Y3xP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");
const $741c778b8152afdc$var$ops = $8vps4.operators;
const $741c778b8152afdc$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $741c778b8152afdc$var$ops.LTE,
        fail: $741c778b8152afdc$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $741c778b8152afdc$var$ops.GTE,
        fail: $741c778b8152afdc$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $741c778b8152afdc$var$ops.LT,
        fail: $741c778b8152afdc$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $741c778b8152afdc$var$ops.GT,
        fail: $741c778b8152afdc$var$ops.LTE
    }
};
const $741c778b8152afdc$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $8vps4.str)`must be ${$741c778b8152afdc$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $8vps4._)`{comparison: ${$741c778b8152afdc$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const $741c778b8152afdc$var$def = {
    keyword: Object.keys($741c778b8152afdc$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $741c778b8152afdc$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $8vps4._)`${data} ${$741c778b8152afdc$var$KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
module.exports.default = $741c778b8152afdc$var$def;

});

parcelRegister("8aiwy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");
const $5f1da06542376c6b$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $8vps4.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{multipleOf: ${schemaCode}}`
};
const $5f1da06542376c6b$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $5f1da06542376c6b$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $8vps4._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, $8vps4._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, $8vps4._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
module.exports.default = $5f1da06542376c6b$var$def;

});

parcelRegister("fDrxX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $kTcY2 = parcelRequire("kTcY2");
const $b61fddbe967e39f2$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $8vps4.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{limit: ${schemaCode}}`
};
const $b61fddbe967e39f2$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $b61fddbe967e39f2$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $8vps4.operators.GT : $8vps4.operators.LT;
        const len = it.opts.unicode === false ? (0, $8vps4._)`${data}.length` : (0, $8vps4._)`${(0, $4wi01.useFunc)(cxt.gen, $kTcY2.default)}(${data})`;
        cxt.fail$data((0, $8vps4._)`${len} ${op} ${schemaCode}`);
    }
};
module.exports.default = $b61fddbe967e39f2$var$def;

});
parcelRegister("kTcY2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $f35300ba40593774$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $f35300ba40593774$var$ucs2length;
$f35300ba40593774$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRegister("iACr3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dlwLI = parcelRequire("dlwLI");

var $4wi01 = parcelRequire("4wi01");

var $8vps4 = parcelRequire("8vps4");
const $d8896740528ee542$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $8vps4.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{pattern: ${schemaCode}}`
};
const $d8896740528ee542$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $d8896740528ee542$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const u = it.opts.unicodeRegExp ? "u" : "";
        if ($data) {
            const { regExp: regExp } = it.opts.code;
            const regExpCode = regExp.code === "new RegExp" ? (0, $8vps4._)`new RegExp` : (0, $4wi01.useFunc)(gen, regExp);
            const valid = gen.let("valid");
            gen.try(()=>gen.assign(valid, (0, $8vps4._)`${regExpCode}(${schemaCode}, ${u}).test(${data})`), ()=>gen.assign(valid, false));
            cxt.fail$data((0, $8vps4._)`!${valid}`);
        } else {
            const regExp = (0, $dlwLI.usePattern)(cxt, schema);
            cxt.fail$data((0, $8vps4._)`!${regExp}.test(${data})`);
        }
    }
};
module.exports.default = $d8896740528ee542$var$def;

});

parcelRegister("3dh2K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");
const $256fce6e35b464a9$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $8vps4.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{limit: ${schemaCode}}`
};
const $256fce6e35b464a9$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $256fce6e35b464a9$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $8vps4.operators.GT : $8vps4.operators.LT;
        cxt.fail$data((0, $8vps4._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
module.exports.default = $256fce6e35b464a9$var$def;

});

parcelRegister("hHznA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dlwLI = parcelRequire("dlwLI");

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
const $ce31e573fa308daa$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $8vps4.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty: missingProperty } })=>(0, $8vps4._)`{missingProperty: ${missingProperty}}`
};
const $ce31e573fa308daa$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $ce31e573fa308daa$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $4wi01.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($8vps4.nil, loopAllRequired);
            else for (const prop of schema)(0, $dlwLI.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $dlwLI.checkMissingProp)(cxt, schema, missing));
                (0, $dlwLI.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $dlwLI.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $dlwLI.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $8vps4.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $8vps4.nil);
        }
    }
};
module.exports.default = $ce31e573fa308daa$var$def;

});

parcelRegister("1cuBe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");
const $0dfea5e224508617$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $8vps4.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{limit: ${schemaCode}}`
};
const $0dfea5e224508617$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $0dfea5e224508617$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $8vps4.operators.GT : $8vps4.operators.LT;
        cxt.fail$data((0, $8vps4._)`${data}.length ${op} ${schemaCode}`);
    }
};
module.exports.default = $0dfea5e224508617$var$def;

});

parcelRegister("g2S11", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $riMdG = parcelRequire("riMdG");

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $8HgX0 = parcelRequire("8HgX0");
const $bae6bb967e90066b$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $8vps4.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i: i, j: j } })=>(0, $8vps4._)`{i: ${i}, j: ${j}}`
};
const $bae6bb967e90066b$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $bae6bb967e90066b$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $riMdG.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $8vps4._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $8vps4._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $8vps4._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $riMdG.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $riMdG.DataType.Wrong);
            const indices = gen.const("indices", (0, $8vps4._)`{}`);
            gen.for((0, $8vps4._)`;${i}--;`, ()=>{
                gen.let(item, (0, $8vps4._)`${data}[${i}]`);
                gen.if(wrongType, (0, $8vps4._)`continue`);
                if (itemTypes.length > 1) gen.if((0, $8vps4._)`typeof ${item} == "string"`, (0, $8vps4._)`${item} += "_"`);
                gen.if((0, $8vps4._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, $8vps4._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $8vps4._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, $4wi01.useFunc)(gen, $8HgX0.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $8vps4._)`;${i}--;`, ()=>gen.for((0, $8vps4._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, $8vps4._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $bae6bb967e90066b$var$def;

});
parcelRegister("8HgX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $erj4U = parcelRequire("erj4U");
$erj4U.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $erj4U;

});


parcelRegister("52mq6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $8HgX0 = parcelRequire("8HgX0");
const $3aae87c78cf6cce0$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{allowedValue: ${schemaCode}}`
};
const $3aae87c78cf6cce0$var$def = {
    keyword: "const",
    $data: true,
    error: $3aae87c78cf6cce0$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $8vps4._)`!${(0, $4wi01.useFunc)(gen, $8HgX0.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, $8vps4._)`${schema} !== ${data}`);
    }
};
module.exports.default = $3aae87c78cf6cce0$var$def;

});

parcelRegister("RpnZL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $8HgX0 = parcelRequire("8HgX0");
const $0a08a47c89f1fd3c$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{allowedValues: ${schemaCode}}`
};
const $0a08a47c89f1fd3c$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $0a08a47c89f1fd3c$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $4wi01.useFunc)(gen, $8HgX0.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $8vps4.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $8vps4._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $8vps4._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, $8vps4._)`${data} === ${sch}`;
        }
    }
};
module.exports.default = $0a08a47c89f1fd3c$var$def;

});


parcelRegister("3NrUa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $exKqV = parcelRequire("exKqV");

var $j18NW = parcelRequire("j18NW");

var $7H2uL = parcelRequire("7H2uL");

var $didN1 = parcelRequire("didN1");

var $k26am = parcelRequire("k26am");

var $8e3vv = parcelRequire("8e3vv");

var $gyH3t = parcelRequire("gyH3t");

var $7CM7I = parcelRequire("7CM7I");

var $hLjNC = parcelRequire("hLjNC");

var $i6tKq = parcelRequire("i6tKq");

var $kDHbB = parcelRequire("kDHbB");

var $aCidA = parcelRequire("aCidA");

var $knT4w = parcelRequire("knT4w");

var $5EE6J = parcelRequire("5EE6J");

var $kes7g = parcelRequire("kes7g");

var $lWMA2 = parcelRequire("lWMA2");
function $2c3b980d23933fbd$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $kDHbB.default,
        $aCidA.default,
        $knT4w.default,
        $5EE6J.default,
        $kes7g.default,
        $lWMA2.default,
        // object
        $gyH3t.default,
        $7CM7I.default,
        $8e3vv.default,
        $hLjNC.default,
        $i6tKq.default
    ];
    // array
    if (draft2020) applicator.push($j18NW.default, $didN1.default);
    else applicator.push($exKqV.default, $7H2uL.default);
    applicator.push($k26am.default);
    return applicator;
}
module.exports.default = $2c3b980d23933fbd$var$getApplicator;

});
parcelRegister("exKqV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
const $02bb7c8e3f6bbe77$var$error = {
    message: ({ params: { len: len } })=>(0, $8vps4.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $8vps4._)`{limit: ${len}}`
};
const $02bb7c8e3f6bbe77$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $02bb7c8e3f6bbe77$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $4wi01.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $02bb7c8e3f6bbe77$var$validateAdditionalItems(cxt, items);
    }
};
function $02bb7c8e3f6bbe77$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $8vps4._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $8vps4._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, $4wi01.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $8vps4._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, $8vps4.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $4wi01.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $8vps4.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.validateAdditionalItems = $02bb7c8e3f6bbe77$var$validateAdditionalItems;
module.exports.default = $02bb7c8e3f6bbe77$var$def;

});

parcelRegister("j18NW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7H2uL = parcelRequire("7H2uL");
const $dd84f0b02d001295$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $7H2uL.validateTuple)(cxt, "items")
};
module.exports.default = $dd84f0b02d001295$var$def;

});
parcelRegister("7H2uL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $dlwLI = parcelRequire("dlwLI");
const $599e7c0c85762e69$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $599e7c0c85762e69$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $4wi01.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $dlwLI.validateArray)(cxt));
    }
};
function $599e7c0c85762e69$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $4wi01.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $8vps4._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, $4wi01.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $8vps4._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $4wi01.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.validateTuple = $599e7c0c85762e69$var$validateTuple;
module.exports.default = $599e7c0c85762e69$var$def;

});


parcelRegister("didN1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $dlwLI = parcelRequire("dlwLI");

var $exKqV = parcelRequire("exKqV");
const $027f5967c6abe267$var$error = {
    message: ({ params: { len: len } })=>(0, $8vps4.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $8vps4._)`{limit: ${len}}`
};
const $027f5967c6abe267$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $027f5967c6abe267$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $4wi01.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $exKqV.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $dlwLI.validateArray)(cxt));
    }
};
module.exports.default = $027f5967c6abe267$var$def;

});

parcelRegister("k26am", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
const $e958c7009ad11125$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $8vps4.str)`must contain at least ${min} valid item(s)` : (0, $8vps4.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $8vps4._)`{minContains: ${min}}` : (0, $8vps4._)`{minContains: ${min}, maxContains: ${max}}`
};
const $e958c7009ad11125$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $e958c7009ad11125$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $8vps4._)`${data}.length`);
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $4wi01.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $4wi01.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $4wi01.alwaysValidSchema)(it, schema)) {
            let cond = (0, $8vps4._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, $8vps4._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $8vps4._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $4wi01.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $8vps4._)`${count}++`);
            if (max === undefined) gen.if((0, $8vps4._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $8vps4._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $8vps4._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $e958c7009ad11125$var$def;

});

parcelRegister("8e3vv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $dlwLI = parcelRequire("dlwLI");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $8vps4.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $8vps4._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const $5fd259fa4cb96dda$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $5fd259fa4cb96dda$var$splitDependencies(cxt);
        $5fd259fa4cb96dda$var$validatePropertyDeps(cxt, propDeps);
        $5fd259fa4cb96dda$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $5fd259fa4cb96dda$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $5fd259fa4cb96dda$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $dlwLI.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $dlwLI.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $8vps4._)`${hasProperty} && (${(0, $dlwLI.checkMissingProp)(cxt, deps, missing)})`);
            (0, $dlwLI.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
module.exports.validatePropertyDeps = $5fd259fa4cb96dda$var$validatePropertyDeps;
function $5fd259fa4cb96dda$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $4wi01.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $dlwLI.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.validateSchemaDeps = $5fd259fa4cb96dda$var$validateSchemaDeps;
module.exports.default = $5fd259fa4cb96dda$var$def;

});

parcelRegister("gyH3t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
const $c0e1382a87d4f976$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $8vps4._)`{propertyName: ${params.propertyName}}`
};
const $c0e1382a87d4f976$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $c0e1382a87d4f976$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $4wi01.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $8vps4.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $c0e1382a87d4f976$var$def;

});

parcelRegister("7CM7I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dlwLI = parcelRequire("dlwLI");

var $8vps4 = parcelRequire("8vps4");

var $4tUVW = parcelRequire("4tUVW");

var $4wi01 = parcelRequire("4wi01");
const $58d1695879501595$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $8vps4._)`{additionalProperty: ${params.additionalProperty}}`
};
const $58d1695879501595$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $58d1695879501595$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $4wi01.alwaysValidSchema)(it, schema)) return;
        const props = (0, $dlwLI.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $dlwLI.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $8vps4._)`${errsCount} === ${$4tUVW.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $4wi01.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $dlwLI.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $8vps4.or)(...props.map((p)=>(0, $8vps4._)`${key} === ${p}`));
            else definedProp = $8vps4.nil;
            if (patProps.length) definedProp = (0, $8vps4.or)(definedProp, ...patProps.map((p)=>(0, $8vps4._)`${(0, $dlwLI.usePattern)(cxt, p)}.test(${key})`));
            return (0, $8vps4.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $8vps4._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $4wi01.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $8vps4.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $8vps4.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $4wi01.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $58d1695879501595$var$def;

});

parcelRegister("hLjNC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4Gzns = parcelRequire("4Gzns");

var $dlwLI = parcelRequire("dlwLI");

var $4wi01 = parcelRequire("4wi01");

var $7CM7I = parcelRequire("7CM7I");
const $cee62f3489ed7e7f$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $7CM7I.default.code(new $4Gzns.KeywordCxt(it, $7CM7I.default, "additionalProperties"));
        const allProps = (0, $dlwLI.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $4wi01.mergeEvaluated.props(gen, (0, $4wi01.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $4wi01.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $dlwLI.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $cee62f3489ed7e7f$var$def;

});

parcelRegister("i6tKq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dlwLI = parcelRequire("dlwLI");

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $4wi01 = parcelRequire("4wi01");
const $d2dfdcd5b88e2af2$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $dlwLI.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $4wi01.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $8vps4.Name)) it.props = (0, $4wi01.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $4wi01.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $8vps4._)`${(0, $dlwLI.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $4wi01.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $8vps4._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $8vps4.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $d2dfdcd5b88e2af2$var$def;

});

parcelRegister("kDHbB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4wi01 = parcelRequire("4wi01");
const $f068f30b4391ddc6$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $4wi01.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $f068f30b4391ddc6$var$def;

});

parcelRegister("aCidA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $dlwLI = parcelRequire("dlwLI");
const $7bab95bb594a8b05$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $dlwLI.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $7bab95bb594a8b05$var$def;

});

parcelRegister("knT4w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
const $ed70acbe88d8b4ea$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $8vps4._)`{passingSchemas: ${params.passing}}`
};
const $ed70acbe88d8b4ea$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $ed70acbe88d8b4ea$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $4wi01.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $8vps4._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, $8vps4._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $8vps4.Name);
                });
            });
        }
    }
};
module.exports.default = $ed70acbe88d8b4ea$var$def;

});

parcelRegister("5EE6J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4wi01 = parcelRequire("4wi01");
const $41dfccb0cdf80619$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $4wi01.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $41dfccb0cdf80619$var$def;

});

parcelRegister("kes7g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
const $ebaaecb63da0289d$var$error = {
    message: ({ params: params })=>(0, $8vps4.str)`must match "${params.ifClause}" schema`,
    params: ({ params: params })=>(0, $8vps4._)`{failingKeyword: ${params.ifClause}}`
};
const $ebaaecb63da0289d$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $ebaaecb63da0289d$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $4wi01.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $ebaaecb63da0289d$var$hasSchema(it, "then");
        const hasElse = $ebaaecb63da0289d$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $8vps4.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $8vps4._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $ebaaecb63da0289d$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $4wi01.alwaysValidSchema)(it, schema);
}
module.exports.default = $ebaaecb63da0289d$var$def;

});

parcelRegister("lWMA2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4wi01 = parcelRequire("4wi01");
const $ffa4b2cd9440d7f3$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $4wi01.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $ffa4b2cd9440d7f3$var$def;

});


parcelRegister("7z6fO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d6AfP = parcelRequire("d6AfP");

var $c4qwN = parcelRequire("c4qwN");

var $kE8dE = parcelRequire("kE8dE");

var $hiPln = parcelRequire("hiPln");
const $5820a72fe3132fa2$var$dynamic = [
    $d6AfP.default,
    $c4qwN.default,
    $kE8dE.default,
    $hiPln.default
];
module.exports.default = $5820a72fe3132fa2$var$dynamic;

});
parcelRegister("d6AfP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dynamicAnchor = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4tUVW = parcelRequire("4tUVW");

var $bRq00 = parcelRequire("bRq00");

var $3qfhS = parcelRequire("3qfhS");
const $98a7f541288ffe71$var$def = {
    keyword: "$dynamicAnchor",
    schemaType: "string",
    code: (cxt)=>$98a7f541288ffe71$var$dynamicAnchor(cxt, cxt.schema)
};
function $98a7f541288ffe71$var$dynamicAnchor(cxt, anchor) {
    const { gen: gen, it: it } = cxt;
    it.schemaEnv.root.dynamicAnchors[anchor] = true;
    const v = (0, $8vps4._)`${$4tUVW.default.dynamicAnchors}${(0, $8vps4.getProperty)(anchor)}`;
    const validate = it.errSchemaPath === "#" ? it.validateName : $98a7f541288ffe71$var$_getValidate(cxt);
    gen.if((0, $8vps4._)`!${v}`, ()=>gen.assign(v, validate));
}
module.exports.dynamicAnchor = $98a7f541288ffe71$var$dynamicAnchor;
function $98a7f541288ffe71$var$_getValidate(cxt) {
    const { schemaEnv: schemaEnv, schema: schema, self: self } = cxt.it;
    const { root: root, baseId: baseId, localRefs: localRefs, meta: meta } = schemaEnv.root;
    const { schemaId: schemaId } = self.opts;
    const sch = new $bRq00.SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId,
        localRefs: localRefs,
        meta: meta
    });
    $bRq00.compileSchema.call(self, sch);
    return (0, $3qfhS.getValidate)(cxt, sch);
}
module.exports.default = $98a7f541288ffe71$var$def;

});

parcelRegister("c4qwN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dynamicRef = void 0;

var $8vps4 = parcelRequire("8vps4");

var $4tUVW = parcelRequire("4tUVW");

var $3qfhS = parcelRequire("3qfhS");
const $8c9a6fa9ca3e7791$var$def = {
    keyword: "$dynamicRef",
    schemaType: "string",
    code: (cxt)=>$8c9a6fa9ca3e7791$var$dynamicRef(cxt, cxt.schema)
};
function $8c9a6fa9ca3e7791$var$dynamicRef(cxt, ref) {
    const { gen: gen, keyword: keyword, it: it } = cxt;
    if (ref[0] !== "#") throw new Error(`"${keyword}" only supports hash fragment reference`);
    const anchor = ref.slice(1);
    if (it.allErrors) _dynamicRef();
    else {
        const valid = gen.let("valid", false);
        _dynamicRef(valid);
        cxt.ok(valid);
    }
    function _dynamicRef(valid) {
        // TODO the assumption here is that `recursiveRef: #` always points to the root
        // of the schema object, which is not correct, because there may be $id that
        // makes # point to it, and the target schema may not contain dynamic/recursiveAnchor.
        // Because of that 2 tests in recursiveRef.json fail.
        // This is a similar problem to #815 (`$id` doesn't alter resolution scope for `{ "$ref": "#" }`).
        // (This problem is not tested in JSON-Schema-Test-Suite)
        if (it.schemaEnv.root.dynamicAnchors[anchor]) {
            const v = gen.let("_v", (0, $8vps4._)`${$4tUVW.default.dynamicAnchors}${(0, $8vps4.getProperty)(anchor)}`);
            gen.if(v, _callRef(v, valid), _callRef(it.validateName, valid));
        } else _callRef(it.validateName, valid)();
    }
    function _callRef(validate, valid) {
        return valid ? ()=>gen.block(()=>{
                (0, $3qfhS.callRef)(cxt, validate);
                gen.let(valid, true);
            }) : ()=>(0, $3qfhS.callRef)(cxt, validate);
    }
}
module.exports.dynamicRef = $8c9a6fa9ca3e7791$var$dynamicRef;
module.exports.default = $8c9a6fa9ca3e7791$var$def;

});

parcelRegister("kE8dE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d6AfP = parcelRequire("d6AfP");

var $4wi01 = parcelRequire("4wi01");
const $03e0ffaa32ae2431$var$def = {
    keyword: "$recursiveAnchor",
    schemaType: "boolean",
    code (cxt) {
        if (cxt.schema) (0, $d6AfP.dynamicAnchor)(cxt, "");
        else (0, $4wi01.checkStrictMode)(cxt.it, "$recursiveAnchor: false is ignored");
    }
};
module.exports.default = $03e0ffaa32ae2431$var$def;

});

parcelRegister("hiPln", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c4qwN = parcelRequire("c4qwN");
const $c98bf1ed9a5949f6$var$def = {
    keyword: "$recursiveRef",
    schemaType: "string",
    code: (cxt)=>(0, $c4qwN.dynamicRef)(cxt, cxt.schema)
};
module.exports.default = $c98bf1ed9a5949f6$var$def;

});


parcelRegister("2H73j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cNOmB = parcelRequire("cNOmB");

var $dUHmE = parcelRequire("dUHmE");

var $1FInt = parcelRequire("1FInt");
const $1f6511624f3d8849$var$next = [
    $cNOmB.default,
    $dUHmE.default,
    $1FInt.default
];
module.exports.default = $1f6511624f3d8849$var$next;

});
parcelRegister("cNOmB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8e3vv = parcelRequire("8e3vv");
const $952120c5471df942$var$def = {
    keyword: "dependentRequired",
    type: "object",
    schemaType: "object",
    error: $8e3vv.error,
    code: (cxt)=>(0, $8e3vv.validatePropertyDeps)(cxt)
};
module.exports.default = $952120c5471df942$var$def;

});

parcelRegister("dUHmE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8e3vv = parcelRequire("8e3vv");
const $a21224956d0e87d8$var$def = {
    keyword: "dependentSchemas",
    type: "object",
    schemaType: "object",
    code: (cxt)=>(0, $8e3vv.validateSchemaDeps)(cxt)
};
module.exports.default = $a21224956d0e87d8$var$def;

});

parcelRegister("1FInt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $4wi01 = parcelRequire("4wi01");
const $137c0b3a0fccaede$var$def = {
    keyword: [
        "maxContains",
        "minContains"
    ],
    type: "array",
    schemaType: "number",
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.contains === undefined) (0, $4wi01.checkStrictMode)(it, `"${keyword}" without "contains" is ignored`);
    }
};
module.exports.default = $137c0b3a0fccaede$var$def;

});


parcelRegister("hY9IU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hmHr9 = parcelRequire("hmHr9");

var $1yeSd = parcelRequire("1yeSd");
const $d14f951fda918d78$var$unevaluated = [
    $hmHr9.default,
    $1yeSd.default
];
module.exports.default = $d14f951fda918d78$var$unevaluated;

});
parcelRegister("hmHr9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");

var $4tUVW = parcelRequire("4tUVW");
const $ca462f6d5bed313b$var$error = {
    message: "must NOT have unevaluated properties",
    params: ({ params: params })=>(0, $8vps4._)`{unevaluatedProperty: ${params.unevaluatedProperty}}`
};
const $ca462f6d5bed313b$var$def = {
    keyword: "unevaluatedProperties",
    type: "object",
    schemaType: [
        "boolean",
        "object"
    ],
    trackErrors: true,
    error: $ca462f6d5bed313b$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, props: props } = it;
        if (props instanceof $8vps4.Name) gen.if((0, $8vps4._)`${props} !== true`, ()=>gen.forIn("key", data, (key)=>gen.if(unevaluatedDynamic(props, key), ()=>unevaluatedPropCode(key))));
        else if (props !== true) gen.forIn("key", data, (key)=>props === undefined ? unevaluatedPropCode(key) : gen.if(unevaluatedStatic(props, key), ()=>unevaluatedPropCode(key)));
        it.props = true;
        cxt.ok((0, $8vps4._)`${errsCount} === ${$4tUVW.default.errors}`);
        function unevaluatedPropCode(key) {
            if (schema === false) {
                cxt.setParams({
                    unevaluatedProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (!(0, $4wi01.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                cxt.subschema({
                    keyword: "unevaluatedProperties",
                    dataProp: key,
                    dataPropType: $4wi01.Type.Str
                }, valid);
                if (!allErrors) gen.if((0, $8vps4.not)(valid), ()=>gen.break());
            }
        }
        function unevaluatedDynamic(evaluatedProps, key) {
            return (0, $8vps4._)`!${evaluatedProps} || !${evaluatedProps}[${key}]`;
        }
        function unevaluatedStatic(evaluatedProps, key) {
            const ps = [];
            for(const p in evaluatedProps)if (evaluatedProps[p] === true) ps.push((0, $8vps4._)`${key} !== ${p}`);
            return (0, $8vps4.and)(...ps);
        }
    }
};
module.exports.default = $ca462f6d5bed313b$var$def;

});

parcelRegister("1yeSd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $4wi01 = parcelRequire("4wi01");
const $121480f711f8156c$var$error = {
    message: ({ params: { len: len } })=>(0, $8vps4.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $8vps4._)`{limit: ${len}}`
};
const $121480f711f8156c$var$def = {
    keyword: "unevaluatedItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    error: $121480f711f8156c$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        const items = it.items || 0;
        if (items === true) return;
        const len = gen.const("len", (0, $8vps4._)`${data}.length`);
        if (schema === false) {
            cxt.setParams({
                len: items
            });
            cxt.fail((0, $8vps4._)`${len} > ${items}`);
        } else if (typeof schema == "object" && !(0, $4wi01.alwaysValidSchema)(it, schema)) {
            const valid = gen.var("valid", (0, $8vps4._)`${len} <= ${items}`);
            gen.if((0, $8vps4.not)(valid), ()=>validateItems(valid, items));
            cxt.ok(valid);
        }
        it.items = true;
        function validateItems(valid, from) {
            gen.forRange("i", from, len, (i)=>{
                cxt.subschema({
                    keyword: "unevaluatedItems",
                    dataProp: i,
                    dataPropType: $4wi01.Type.Num
                }, valid);
                if (!it.allErrors) gen.if((0, $8vps4.not)(valid), ()=>gen.break());
            });
        }
    }
};
module.exports.default = $121480f711f8156c$var$def;

});


parcelRegister("alCI0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3TUej = parcelRequire("3TUej");
const $7889e44f2507faaa$var$format = [
    $3TUej.default
];
module.exports.default = $7889e44f2507faaa$var$format;

});
parcelRegister("3TUej", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");
const $2d72203d06c4df3b$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $8vps4.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $8vps4._)`{format: ${schemaCode}}`
};
const $2d72203d06c4df3b$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $2d72203d06c4df3b$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $8vps4._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $8vps4._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, $8vps4._)`${fDef}.type || "string"`).assign(format, (0, $8vps4._)`${fDef}.validate`), ()=>gen.assign(fType, (0, $8vps4._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, $8vps4.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $8vps4.nil;
                return (0, $8vps4._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $8vps4._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, $8vps4._)`${format}(${data})`;
                const validData = (0, $8vps4._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, $8vps4._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $8vps4.regexpCode)(fmtDef) : opts.code.formats ? (0, $8vps4._)`${opts.code.formats}${(0, $8vps4.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $8vps4._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $8vps4._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, $8vps4._)`${fmtRef}(${data})` : (0, $8vps4._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
module.exports.default = $2d72203d06c4df3b$var$def;

});


parcelRegister("ap2Xe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRegister("ldhBP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8vps4 = parcelRequire("8vps4");

var $2AiLq = parcelRequire("2AiLq");

var $bRq00 = parcelRequire("bRq00");

var $8u76A = parcelRequire("8u76A");

var $4wi01 = parcelRequire("4wi01");
const $f71878b22abf3226$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $2AiLq.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $8vps4._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const $f71878b22abf3226$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $f71878b22abf3226$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { oneOf: oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $8vps4._)`${data}${(0, $8vps4.getProperty)(tagName)}`);
        gen.if((0, $8vps4._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $2AiLq.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $8vps4._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $2AiLq.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $8vps4.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $4wi01.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    const ref = sch.$ref;
                    sch = $bRq00.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                    if (sch instanceof $bRq00.SchemaEnv) sch = sch.schema;
                    if (sch === undefined) throw new $8u76A.default(it.opts.uriResolver, it.baseId, ref);
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $f71878b22abf3226$var$def;

});
parcelRegister("2AiLq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $1e1d7fb1d348431a$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($1e1d7fb1d348431a$var$DiscrError || (module.exports.DiscrError = $1e1d7fb1d348431a$var$DiscrError = {}));

});


parcelRegister("3oNYk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eyQq6 = parcelRequire("eyQq6");

var $gJiSu = parcelRequire("gJiSu");

var $lUcbW = parcelRequire("lUcbW");

var $f532j = parcelRequire("f532j");

var $7eY70 = parcelRequire("7eY70");

var $bEJrb = parcelRequire("bEJrb");

var $kwgb8 = parcelRequire("kwgb8");

var $d5CYX = parcelRequire("d5CYX");
const $279a6069a3755318$var$META_SUPPORT_DATA = [
    "/properties"
];
function $279a6069a3755318$var$addMetaSchema2020($data) {
    [
        $eyQq6,
        $gJiSu,
        $lUcbW,
        $f532j,
        $7eY70,
        with$data(this, $bEJrb),
        $kwgb8,
        with$data(this, $d5CYX)
    ].forEach((sch)=>this.addMetaSchema(sch, undefined, false));
    return this;
    function with$data(ajv, sch) {
        return $data ? ajv.$dataMetaSchema(sch, $279a6069a3755318$var$META_SUPPORT_DATA) : sch;
    }
}
module.exports.default = $279a6069a3755318$var$addMetaSchema2020;

});
parcelRegister("eyQq6", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/schema\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/core\":true,\"https://json-schema.org/draft/2020-12/vocab/applicator\":true,\"https://json-schema.org/draft/2020-12/vocab/unevaluated\":true,\"https://json-schema.org/draft/2020-12/vocab/validation\":true,\"https://json-schema.org/draft/2020-12/vocab/meta-data\":true,\"https://json-schema.org/draft/2020-12/vocab/format-annotation\":true,\"https://json-schema.org/draft/2020-12/vocab/content\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Core and Validation specifications meta-schema\",\"allOf\":[{\"$ref\":\"meta/core\"},{\"$ref\":\"meta/applicator\"},{\"$ref\":\"meta/unevaluated\"},{\"$ref\":\"meta/validation\"},{\"$ref\":\"meta/meta-data\"},{\"$ref\":\"meta/format-annotation\"},{\"$ref\":\"meta/content\"}],\"type\":[\"object\",\"boolean\"],\"$comment\":\"This meta-schema also defines keywords that have appeared in previous drafts in order to prevent incompatible extensions as they remain in common use.\",\"properties\":{\"definitions\":{\"$comment\":\"\\\"definitions\\\" has been replaced by \\\"$defs\\\".\",\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"deprecated\":true,\"default\":{}},\"dependencies\":{\"$comment\":\"\\\"dependencies\\\" has been split and replaced by \\\"dependentSchemas\\\" and \\\"dependentRequired\\\" in order to serve their differing semantics.\",\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$dynamicRef\":\"#meta\"},{\"$ref\":\"meta/validation#/$defs/stringArray\"}]},\"deprecated\":true,\"default\":{}},\"$recursiveAnchor\":{\"$comment\":\"\\\"$recursiveAnchor\\\" has been replaced by \\\"$dynamicAnchor\\\".\",\"$ref\":\"meta/core#/$defs/anchorString\",\"deprecated\":true},\"$recursiveRef\":{\"$comment\":\"\\\"$recursiveRef\\\" has been replaced by \\\"$dynamicRef\\\".\",\"$ref\":\"meta/core#/$defs/uriReferenceString\",\"deprecated\":true}}}");

});

parcelRegister("gJiSu", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/applicator\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/applicator\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Applicator vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"prefixItems\":{\"$ref\":\"#/$defs/schemaArray\"},\"items\":{\"$dynamicRef\":\"#meta\"},\"contains\":{\"$dynamicRef\":\"#meta\"},\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependentSchemas\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"},\"default\":{}},\"propertyNames\":{\"$dynamicRef\":\"#meta\"},\"if\":{\"$dynamicRef\":\"#meta\"},\"then\":{\"$dynamicRef\":\"#meta\"},\"else\":{\"$dynamicRef\":\"#meta\"},\"allOf\":{\"$ref\":\"#/$defs/schemaArray\"},\"anyOf\":{\"$ref\":\"#/$defs/schemaArray\"},\"oneOf\":{\"$ref\":\"#/$defs/schemaArray\"},\"not\":{\"$dynamicRef\":\"#meta\"}},\"$defs\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$dynamicRef\":\"#meta\"}}}}");

});

parcelRegister("lUcbW", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/unevaluated\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/unevaluated\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Unevaluated applicator vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"unevaluatedItems\":{\"$dynamicRef\":\"#meta\"},\"unevaluatedProperties\":{\"$dynamicRef\":\"#meta\"}}}");

});

parcelRegister("f532j", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/content\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/content\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Content vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"contentEncoding\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentSchema\":{\"$dynamicRef\":\"#meta\"}}}");

});

parcelRegister("7eY70", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/core\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/core\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Core vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"$ref\":\"#/$defs/uriReferenceString\",\"$comment\":\"Non-empty fragments not allowed.\",\"pattern\":\"^[^#]*#?$\"},\"$schema\":{\"$ref\":\"#/$defs/uriString\"},\"$ref\":{\"$ref\":\"#/$defs/uriReferenceString\"},\"$anchor\":{\"$ref\":\"#/$defs/anchorString\"},\"$dynamicRef\":{\"$ref\":\"#/$defs/uriReferenceString\"},\"$dynamicAnchor\":{\"$ref\":\"#/$defs/anchorString\"},\"$vocabulary\":{\"type\":\"object\",\"propertyNames\":{\"$ref\":\"#/$defs/uriString\"},\"additionalProperties\":{\"type\":\"boolean\"}},\"$comment\":{\"type\":\"string\"},\"$defs\":{\"type\":\"object\",\"additionalProperties\":{\"$dynamicRef\":\"#meta\"}}},\"$defs\":{\"anchorString\":{\"type\":\"string\",\"pattern\":\"^[A-Za-z_][-A-Za-z0-9._]*$\"},\"uriString\":{\"type\":\"string\",\"format\":\"uri\"},\"uriReferenceString\":{\"type\":\"string\",\"format\":\"uri-reference\"}}}");

});

parcelRegister("bEJrb", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/format-annotation\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/format-annotation\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Format vocabulary meta-schema for annotation results\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"format\":{\"type\":\"string\"}}}");

});

parcelRegister("kwgb8", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/meta-data\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/meta-data\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Meta-data vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"deprecated\":{\"type\":\"boolean\",\"default\":false},\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"writeOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true}}}");

});

parcelRegister("d5CYX", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"https://json-schema.org/draft/2020-12/schema\",\"$id\":\"https://json-schema.org/draft/2020-12/meta/validation\",\"$vocabulary\":{\"https://json-schema.org/draft/2020-12/vocab/validation\":true},\"$dynamicAnchor\":\"meta\",\"title\":\"Validation vocabulary meta-schema\",\"type\":[\"object\",\"boolean\"],\"properties\":{\"type\":{\"anyOf\":[{\"$ref\":\"#/$defs/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/$defs/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"maxItems\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/$defs/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"maxContains\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minContains\":{\"$ref\":\"#/$defs/nonNegativeInteger\",\"default\":1},\"maxProperties\":{\"$ref\":\"#/$defs/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/$defs/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/$defs/stringArray\"},\"dependentRequired\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/stringArray\"}}},\"$defs\":{\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"$ref\":\"#/$defs/nonNegativeInteger\",\"default\":0},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}}}");

});



parcelRegister("bYj7Y", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});

var $5ikfu = parcelRequire("5ikfu");

var $awvWu = parcelRequire("awvWu");

var $8vps4 = parcelRequire("8vps4");
const fullName = new $8vps4.Name("fullFormats");
const fastName = new $8vps4.Name("fastFormats");
const formatsPlugin = (ajv, opts = {
    keywords: true
})=>{
    if (Array.isArray(opts)) {
        addFormats(ajv, opts, $5ikfu.fullFormats, fullName);
        return ajv;
    }
    const [formats, exportName] = opts.mode === "fast" ? [
        $5ikfu.fastFormats,
        fastName
    ] : [
        $5ikfu.fullFormats,
        fullName
    ];
    const list = opts.formats || $5ikfu.formatNames;
    addFormats(ajv, list, formats, exportName);
    if (opts.keywords) (0, $awvWu.default)(ajv);
    return ajv;
};
formatsPlugin.get = (name, mode = "full")=>{
    const formats = mode === "fast" ? $5ikfu.fastFormats : $5ikfu.fullFormats;
    const f = formats[name];
    if (!f) throw new Error(`Unknown format "${name}"`);
    return f;
};
function addFormats(ajv, list, fs, exportName) {
    var _a;
    var _b;
    (_a = (_b = ajv.opts.code).formats) !== null && _a !== void 0 ? _a : _b.formats = (0, $8vps4._)`require("ajv-formats/dist/formats").${exportName}`;
    for (const f of list)ajv.addFormat(f, fs[f]);
}
module.exports = exports = formatsPlugin;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatsPlugin;

});
parcelRegister("5ikfu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatNames = module.exports.fastFormats = module.exports.fullFormats = void 0;
function $3dae572ab86572df$var$fmtDef(validate, compare) {
    return {
        validate: validate,
        compare: compare
    };
}
module.exports.fullFormats = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: $3dae572ab86572df$var$fmtDef($3dae572ab86572df$var$date, $3dae572ab86572df$var$compareDate),
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: $3dae572ab86572df$var$fmtDef($3dae572ab86572df$var$getTime(true), $3dae572ab86572df$var$compareTime),
    "date-time": $3dae572ab86572df$var$fmtDef($3dae572ab86572df$var$getDateTime(true), $3dae572ab86572df$var$compareDateTime),
    "iso-time": $3dae572ab86572df$var$fmtDef($3dae572ab86572df$var$getTime(), $3dae572ab86572df$var$compareIsoTime),
    "iso-date-time": $3dae572ab86572df$var$fmtDef($3dae572ab86572df$var$getDateTime(), $3dae572ab86572df$var$compareIsoDateTime),
    // duration: https://tools.ietf.org/html/rfc3339#appendix-A
    duration: /^P(?!$)((\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+S)?)?|(\d+W)?)$/,
    uri: $3dae572ab86572df$var$uri,
    "uri-reference": /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i,
    // uri-template: https://tools.ietf.org/html/rfc6570
    "uri-template": /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i,
    // For the source: https://gist.github.com/dperini/729294
    // For test cases: https://mathiasbynens.be/demo/url-regex
    url: /^(?:https?|ftp):\/\/(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)(?:\.(?:[a-z0-9\u{00a1}-\u{ffff}]+-)*[a-z0-9\u{00a1}-\u{ffff}]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/,
    ipv6: /^((([0-9a-f]{1,4}:){7}([0-9a-f]{1,4}|:))|(([0-9a-f]{1,4}:){6}(:[0-9a-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){5}(((:[0-9a-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9a-f]{1,4}:){4}(((:[0-9a-f]{1,4}){1,3})|((:[0-9a-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){3}(((:[0-9a-f]{1,4}){1,4})|((:[0-9a-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){2}(((:[0-9a-f]{1,4}){1,5})|((:[0-9a-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9a-f]{1,4}:){1}(((:[0-9a-f]{1,4}){1,6})|((:[0-9a-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9a-f]{1,4}){1,7})|((:[0-9a-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/i,
    regex: $3dae572ab86572df$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": /^(?:\/(?:[^~/]|~0|~1)*)*$/,
    "json-pointer-uri-fragment": /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/,
    byte: // the following formats are used by the openapi specification: https://spec.openapis.org/oas/v3.0.0#data-types
    // byte: https://github.com/miguelmota/is-base64
    $3dae572ab86572df$var$byte,
    // signed 32 bit integer
    int32: {
        type: "number",
        validate: $3dae572ab86572df$var$validateInt32
    },
    // signed 64 bit integer
    int64: {
        type: "number",
        validate: $3dae572ab86572df$var$validateInt64
    },
    // C-type float
    float: {
        type: "number",
        validate: $3dae572ab86572df$var$validateNumber
    },
    // C-type double
    double: {
        type: "number",
        validate: $3dae572ab86572df$var$validateNumber
    },
    // hint to the UI to hide input strings
    password: true,
    // unchecked string payload
    binary: true
};
module.exports.fastFormats = {
    ...module.exports.fullFormats,
    date: $3dae572ab86572df$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d$/, $3dae572ab86572df$var$compareDate),
    time: $3dae572ab86572df$var$fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, $3dae572ab86572df$var$compareTime),
    "date-time": $3dae572ab86572df$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\dt(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i, $3dae572ab86572df$var$compareDateTime),
    "iso-time": $3dae572ab86572df$var$fmtDef(/^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, $3dae572ab86572df$var$compareIsoTime),
    "iso-date-time": $3dae572ab86572df$var$fmtDef(/^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i, $3dae572ab86572df$var$compareIsoDateTime),
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'wilful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i
};
module.exports.formatNames = Object.keys(module.exports.fullFormats);
function $3dae572ab86572df$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
const $3dae572ab86572df$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
const $3dae572ab86572df$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $3dae572ab86572df$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    const matches = $3dae572ab86572df$var$DATE.exec(str);
    if (!matches) return false;
    const year = +matches[1];
    const month = +matches[2];
    const day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month === 2 && $3dae572ab86572df$var$isLeapYear(year) ? 29 : $3dae572ab86572df$var$DAYS[month]);
}
function $3dae572ab86572df$var$compareDate(d1, d2) {
    if (!(d1 && d2)) return undefined;
    if (d1 > d2) return 1;
    if (d1 < d2) return -1;
    return 0;
}
const $3dae572ab86572df$var$TIME = /^(\d\d):(\d\d):(\d\d(?:\.\d+)?)(z|([+-])(\d\d)(?::?(\d\d))?)?$/i;
function $3dae572ab86572df$var$getTime(strictTimeZone) {
    return function time(str) {
        const matches = $3dae572ab86572df$var$TIME.exec(str);
        if (!matches) return false;
        const hr = +matches[1];
        const min = +matches[2];
        const sec = +matches[3];
        const tz = matches[4];
        const tzSign = matches[5] === "-" ? -1 : 1;
        const tzH = +(matches[6] || 0);
        const tzM = +(matches[7] || 0);
        if (tzH > 23 || tzM > 59 || strictTimeZone && !tz) return false;
        if (hr <= 23 && min <= 59 && sec < 60) return true;
        // leap second
        const utcMin = min - tzM * tzSign;
        const utcHr = hr - tzH * tzSign - (utcMin < 0 ? 1 : 0);
        return (utcHr === 23 || utcHr === -1) && (utcMin === 59 || utcMin === -1) && sec < 61;
    };
}
function $3dae572ab86572df$var$compareTime(s1, s2) {
    if (!(s1 && s2)) return undefined;
    const t1 = new Date("2020-01-01T" + s1).valueOf();
    const t2 = new Date("2020-01-01T" + s2).valueOf();
    if (!(t1 && t2)) return undefined;
    return t1 - t2;
}
function $3dae572ab86572df$var$compareIsoTime(t1, t2) {
    if (!(t1 && t2)) return undefined;
    const a1 = $3dae572ab86572df$var$TIME.exec(t1);
    const a2 = $3dae572ab86572df$var$TIME.exec(t2);
    if (!(a1 && a2)) return undefined;
    t1 = a1[1] + a1[2] + a1[3];
    t2 = a2[1] + a2[2] + a2[3];
    if (t1 > t2) return 1;
    if (t1 < t2) return -1;
    return 0;
}
const $3dae572ab86572df$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $3dae572ab86572df$var$getDateTime(strictTimeZone) {
    const time = $3dae572ab86572df$var$getTime(strictTimeZone);
    return function date_time(str) {
        // http://tools.ietf.org/html/rfc3339#section-5.6
        const dateTime = str.split($3dae572ab86572df$var$DATE_TIME_SEPARATOR);
        return dateTime.length === 2 && $3dae572ab86572df$var$date(dateTime[0]) && time(dateTime[1]);
    };
}
function $3dae572ab86572df$var$compareDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const d1 = new Date(dt1).valueOf();
    const d2 = new Date(dt2).valueOf();
    if (!(d1 && d2)) return undefined;
    return d1 - d2;
}
function $3dae572ab86572df$var$compareIsoDateTime(dt1, dt2) {
    if (!(dt1 && dt2)) return undefined;
    const [d1, t1] = dt1.split($3dae572ab86572df$var$DATE_TIME_SEPARATOR);
    const [d2, t2] = dt2.split($3dae572ab86572df$var$DATE_TIME_SEPARATOR);
    const res = $3dae572ab86572df$var$compareDate(d1, d2);
    if (res === undefined) return undefined;
    return res || $3dae572ab86572df$var$compareTime(t1, t2);
}
const $3dae572ab86572df$var$NOT_URI_FRAGMENT = /\/|:/;
const $3dae572ab86572df$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
function $3dae572ab86572df$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $3dae572ab86572df$var$NOT_URI_FRAGMENT.test(str) && $3dae572ab86572df$var$URI.test(str);
}
const $3dae572ab86572df$var$BYTE = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/gm;
function $3dae572ab86572df$var$byte(str) {
    $3dae572ab86572df$var$BYTE.lastIndex = 0;
    return $3dae572ab86572df$var$BYTE.test(str);
}
const $3dae572ab86572df$var$MIN_INT32 = -(2 ** 31);
const $3dae572ab86572df$var$MAX_INT32 = 2 ** 31 - 1;
function $3dae572ab86572df$var$validateInt32(value) {
    return Number.isInteger(value) && value <= $3dae572ab86572df$var$MAX_INT32 && value >= $3dae572ab86572df$var$MIN_INT32;
}
function $3dae572ab86572df$var$validateInt64(value) {
    // JSON and javascript max Int is 2**53, so any int that passes isInteger is valid for Int64
    return Number.isInteger(value);
}
function $3dae572ab86572df$var$validateNumber() {
    return true;
}
const $3dae572ab86572df$var$Z_ANCHOR = /[^\\]\\Z/;
function $3dae572ab86572df$var$regex(str) {
    if ($3dae572ab86572df$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("awvWu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.formatLimitDefinition = void 0;

var $dhwai = parcelRequire("dhwai");

var $8vps4 = parcelRequire("8vps4");
const $7a95ab9f1322a86e$var$ops = $8vps4.operators;
const $7a95ab9f1322a86e$var$KWDs = {
    formatMaximum: {
        okStr: "<=",
        ok: $7a95ab9f1322a86e$var$ops.LTE,
        fail: $7a95ab9f1322a86e$var$ops.GT
    },
    formatMinimum: {
        okStr: ">=",
        ok: $7a95ab9f1322a86e$var$ops.GTE,
        fail: $7a95ab9f1322a86e$var$ops.LT
    },
    formatExclusiveMaximum: {
        okStr: "<",
        ok: $7a95ab9f1322a86e$var$ops.LT,
        fail: $7a95ab9f1322a86e$var$ops.GTE
    },
    formatExclusiveMinimum: {
        okStr: ">",
        ok: $7a95ab9f1322a86e$var$ops.GT,
        fail: $7a95ab9f1322a86e$var$ops.LTE
    }
};
const $7a95ab9f1322a86e$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $8vps4.str)`should be ${$7a95ab9f1322a86e$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $8vps4._)`{comparison: ${$7a95ab9f1322a86e$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
module.exports.formatLimitDefinition = {
    keyword: Object.keys($7a95ab9f1322a86e$var$KWDs),
    type: "string",
    schemaType: "string",
    $data: true,
    error: $7a95ab9f1322a86e$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, keyword: keyword, it: it } = cxt;
        const { opts: opts, self: self } = it;
        if (!opts.validateFormats) return;
        const fCxt = new $dhwai.KeywordCxt(it, self.RULES.all.format.definition, "format");
        if (fCxt.$data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fmt = gen.const("fmt", (0, $8vps4._)`${fmts}[${fCxt.schemaCode}]`);
            cxt.fail$data((0, $8vps4.or)((0, $8vps4._)`typeof ${fmt} != "object"`, (0, $8vps4._)`${fmt} instanceof RegExp`, (0, $8vps4._)`typeof ${fmt}.compare != "function"`, compareCode(fmt)));
        }
        function validateFormat() {
            const format = fCxt.schema;
            const fmtDef = self.formats[format];
            if (!fmtDef || fmtDef === true) return;
            if (typeof fmtDef != "object" || fmtDef instanceof RegExp || typeof fmtDef.compare != "function") throw new Error(`"${keyword}": format "${format}" does not define "compare" function`);
            const fmt = gen.scopeValue("formats", {
                key: format,
                ref: fmtDef,
                code: opts.code.formats ? (0, $8vps4._)`${opts.code.formats}${(0, $8vps4.getProperty)(format)}` : undefined
            });
            cxt.fail$data(compareCode(fmt));
        }
        function compareCode(fmt) {
            return (0, $8vps4._)`${fmt}.compare(${data}, ${schemaCode}) ${$7a95ab9f1322a86e$var$KWDs[keyword].fail} 0`;
        }
    },
    dependencies: [
        "format"
    ]
};
const $7a95ab9f1322a86e$var$formatLimitPlugin = (ajv)=>{
    ajv.addKeyword(module.exports.formatLimitDefinition);
    return ajv;
};
module.exports.default = $7a95ab9f1322a86e$var$formatLimitPlugin;

});
parcelRegister("dhwai", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;

var $9JDAR = parcelRequire("9JDAR");

var $c9znl = parcelRequire("c9znl");

var $ldhBP = parcelRequire("ldhBP");

var $dcdcv = parcelRequire("dcdcv");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends $9JDAR.default {
    _addVocabularies() {
        super._addVocabularies();
        $c9znl.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($ldhBP.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema($dcdcv, META_SUPPORT_DATA) : $dcdcv;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $4Gzns = parcelRequire("4Gzns");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $4Gzns.KeywordCxt;
    }
});

var $8vps4 = parcelRequire("8vps4");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $8vps4._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $8vps4.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $8vps4.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $8vps4.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $8vps4.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $8vps4.CodeGen;
    }
});

var $cMAcV = parcelRequire("cMAcV");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $cMAcV.default;
    }
});

var $8u76A = parcelRequire("8u76A");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $8u76A.default;
    }
});

});
parcelRegister("c9znl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $c57c9 = parcelRequire("c57c9");

var $iNdz2 = parcelRequire("iNdz2");

var $3NrUa = parcelRequire("3NrUa");

var $alCI0 = parcelRequire("alCI0");

var $ap2Xe = parcelRequire("ap2Xe");
const $8d91c41fc04dfd22$var$draft7Vocabularies = [
    $c57c9.default,
    $iNdz2.default,
    (0, $3NrUa.default)(),
    $alCI0.default,
    $ap2Xe.metadataVocabulary,
    $ap2Xe.contentVocabulary
];
module.exports.default = $8d91c41fc04dfd22$var$draft7Vocabularies;

});

parcelRegister("dcdcv", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");

});




parcelRegister("dEbHu", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $9ef8164759892955$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ef8164759892955$var$isValid;

var $9ef8164759892955$var$_index = $9ef8164759892955$require$_interopRequireDefault((parcelRequire("4BUEa")));

var $9ef8164759892955$var$_index2 = $9ef8164759892955$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $9ef8164759892955$var$_index3 = $9ef8164759892955$require$_interopRequireDefault((parcelRequire("lAH9J")));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ function $9ef8164759892955$var$isValid(dirtyDate) {
    (0, $9ef8164759892955$var$_index3.default)(1, arguments);
    if (!(0, $9ef8164759892955$var$_index.default)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $9ef8164759892955$var$_index2.default)(dirtyDate);
    return !isNaN(Number(date));
}
module.exports = module.exports.default;

});
parcelRegister("9ucar", function(module, exports) {
function $6e805a9d1192bb27$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $6e805a9d1192bb27$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("4BUEa", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $35b68f07eee122c7$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35b68f07eee122c7$var$isDate;

var $35b68f07eee122c7$var$_typeof2 = $35b68f07eee122c7$require$_interopRequireDefault((parcelRequire("a23Td")));

var $35b68f07eee122c7$var$_index = $35b68f07eee122c7$require$_interopRequireDefault((parcelRequire("lAH9J")));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $35b68f07eee122c7$var$isDate(value) {
    (0, $35b68f07eee122c7$var$_index.default)(1, arguments);
    return value instanceof Date || (0, $35b68f07eee122c7$var$_typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = module.exports.default;

});
parcelRegister("a23Td", function(module, exports) {
function $74dd1baf3979962e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $74dd1baf3979962e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $74dd1baf3979962e$var$_typeof(o);
}
module.exports = $74dd1baf3979962e$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lAH9J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fb7e6fa1a0b140d1$var$requiredArgs;
function $fb7e6fa1a0b140d1$var$requiredArgs(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}
module.exports = module.exports.default;

});


parcelRegister("2EcQ8", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $1ed946ee1fa9148b$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ed946ee1fa9148b$var$toDate;

var $1ed946ee1fa9148b$var$_typeof2 = $1ed946ee1fa9148b$require$_interopRequireDefault((parcelRequire("a23Td")));

var $1ed946ee1fa9148b$var$_index = $1ed946ee1fa9148b$require$_interopRequireDefault((parcelRequire("lAH9J")));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ function $1ed946ee1fa9148b$var$toDate(argument) {
    (0, $1ed946ee1fa9148b$var$_index.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $1ed946ee1fa9148b$var$_typeof2.default)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}
module.exports = module.exports.default;

});


parcelRegister("beNeX", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $82e73297eef32841$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $82e73297eef32841$var$subMilliseconds;

var $82e73297eef32841$var$_index = $82e73297eef32841$require$_interopRequireDefault((parcelRequire("9JEzi")));

var $82e73297eef32841$var$_index2 = $82e73297eef32841$require$_interopRequireDefault((parcelRequire("lAH9J")));

var $82e73297eef32841$var$_index3 = $82e73297eef32841$require$_interopRequireDefault((parcelRequire("3iCLV")));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */ function $82e73297eef32841$var$subMilliseconds(dirtyDate, dirtyAmount) {
    (0, $82e73297eef32841$var$_index2.default)(2, arguments);
    var amount = (0, $82e73297eef32841$var$_index3.default)(dirtyAmount);
    return (0, $82e73297eef32841$var$_index.default)(dirtyDate, -amount);
}
module.exports = module.exports.default;

});
parcelRegister("9JEzi", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $7167c90768fa3d01$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7167c90768fa3d01$var$addMilliseconds;

var $7167c90768fa3d01$var$_index = $7167c90768fa3d01$require$_interopRequireDefault((parcelRequire("3iCLV")));

var $7167c90768fa3d01$var$_index2 = $7167c90768fa3d01$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $7167c90768fa3d01$var$_index3 = $7167c90768fa3d01$require$_interopRequireDefault((parcelRequire("lAH9J")));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */ function $7167c90768fa3d01$var$addMilliseconds(dirtyDate, dirtyAmount) {
    (0, $7167c90768fa3d01$var$_index3.default)(2, arguments);
    var timestamp = (0, $7167c90768fa3d01$var$_index2.default)(dirtyDate).getTime();
    var amount = (0, $7167c90768fa3d01$var$_index.default)(dirtyAmount);
    return new Date(timestamp + amount);
}
module.exports = module.exports.default;

});
parcelRegister("3iCLV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $267120d4a5534de1$var$toInteger;
function $267120d4a5534de1$var$toInteger(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = module.exports.default;

});



parcelRegister("l578r", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $f58f99794634e763$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f58f99794634e763$var$_index = $f58f99794634e763$require$_interopRequireDefault((parcelRequire("fpsai")));

var $f58f99794634e763$var$_index2 = $f58f99794634e763$require$_interopRequireDefault((parcelRequire("2z36j")));

var $f58f99794634e763$var$_index3 = $f58f99794634e763$require$_interopRequireDefault((parcelRequire("aVYsV")));

var $f58f99794634e763$var$_index4 = $f58f99794634e763$require$_interopRequireDefault((parcelRequire("3FWiw")));

var $f58f99794634e763$var$_index5 = $f58f99794634e763$require$_interopRequireDefault((parcelRequire("kWPOO")));

var $f58f99794634e763$var$_index6 = $f58f99794634e763$require$_interopRequireDefault((parcelRequire("7v6bA")));

var $f58f99794634e763$var$_index7 = $f58f99794634e763$require$_interopRequireDefault((parcelRequire("9zm7f")));
var $f58f99794634e763$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $f58f99794634e763$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return $f58f99794634e763$var$_index7.default.y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $f58f99794634e763$var$_index5.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $f58f99794634e763$var$_index6.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $f58f99794634e763$var$_index6.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $f58f99794634e763$var$_index3.default)(date);
        // Padding
        return (0, $f58f99794634e763$var$_index6.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $f58f99794634e763$var$_index6.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $f58f99794634e763$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $f58f99794634e763$var$_index6.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return $f58f99794634e763$var$_index7.default.M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $f58f99794634e763$var$_index6.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $f58f99794634e763$var$_index4.default)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $f58f99794634e763$var$_index6.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $f58f99794634e763$var$_index2.default)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $f58f99794634e763$var$_index6.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return $f58f99794634e763$var$_index7.default.d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $f58f99794634e763$var$_index.default)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $f58f99794634e763$var$_index6.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $f58f99794634e763$var$_index6.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $f58f99794634e763$var$_index6.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $f58f99794634e763$var$_index6.default)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $f58f99794634e763$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $f58f99794634e763$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $f58f99794634e763$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $f58f99794634e763$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $f58f99794634e763$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $f58f99794634e763$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return $f58f99794634e763$var$_index7.default.h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return $f58f99794634e763$var$_index7.default.H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f58f99794634e763$var$_index6.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $f58f99794634e763$var$_index6.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return $f58f99794634e763$var$_index7.default.m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return $f58f99794634e763$var$_index7.default.s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return $f58f99794634e763$var$_index7.default.S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $f58f99794634e763$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $f58f99794634e763$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $f58f99794634e763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $f58f99794634e763$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $f58f99794634e763$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $f58f99794634e763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $f58f99794634e763$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $f58f99794634e763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $f58f99794634e763$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $f58f99794634e763$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $f58f99794634e763$var$_index6.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $f58f99794634e763$var$_index6.default)(timestamp, token.length);
    }
};
function $f58f99794634e763$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $f58f99794634e763$var$_index6.default)(minutes, 2);
}
function $f58f99794634e763$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $f58f99794634e763$var$_index6.default)(Math.abs(offset) / 60, 2);
    }
    return $f58f99794634e763$var$formatTimezone(offset, dirtyDelimiter);
}
function $f58f99794634e763$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $f58f99794634e763$var$_index6.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $f58f99794634e763$var$_index6.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $f58f99794634e763$var$_default = $f58f99794634e763$var$formatters;
module.exports.default = $f58f99794634e763$var$_default;
module.exports = module.exports.default;

});
parcelRegister("fpsai", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $b37f09cf04f7e22c$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b37f09cf04f7e22c$var$getUTCDayOfYear;

var $b37f09cf04f7e22c$var$_index = $b37f09cf04f7e22c$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $b37f09cf04f7e22c$var$_index2 = $b37f09cf04f7e22c$require$_interopRequireDefault((parcelRequire("lAH9J")));
var $b37f09cf04f7e22c$var$MILLISECONDS_IN_DAY = 86400000;
function $b37f09cf04f7e22c$var$getUTCDayOfYear(dirtyDate) {
    (0, $b37f09cf04f7e22c$var$_index2.default)(1, arguments);
    var date = (0, $b37f09cf04f7e22c$var$_index.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $b37f09cf04f7e22c$var$MILLISECONDS_IN_DAY) + 1;
}
module.exports = module.exports.default;

});

parcelRegister("2z36j", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $1de14165ed705397$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1de14165ed705397$var$getUTCISOWeek;

var $1de14165ed705397$var$_index = $1de14165ed705397$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $1de14165ed705397$var$_index2 = $1de14165ed705397$require$_interopRequireDefault((parcelRequire("cKDOV")));

var $1de14165ed705397$var$_index3 = $1de14165ed705397$require$_interopRequireDefault((parcelRequire("cVR3T")));

var $1de14165ed705397$var$_index4 = $1de14165ed705397$require$_interopRequireDefault((parcelRequire("lAH9J")));
var $1de14165ed705397$var$MILLISECONDS_IN_WEEK = 604800000;
function $1de14165ed705397$var$getUTCISOWeek(dirtyDate) {
    (0, $1de14165ed705397$var$_index4.default)(1, arguments);
    var date = (0, $1de14165ed705397$var$_index.default)(dirtyDate);
    var diff = (0, $1de14165ed705397$var$_index2.default)(date).getTime() - (0, $1de14165ed705397$var$_index3.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $1de14165ed705397$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("cKDOV", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $9488ab6bd7a44d56$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9488ab6bd7a44d56$var$startOfUTCISOWeek;

var $9488ab6bd7a44d56$var$_index = $9488ab6bd7a44d56$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $9488ab6bd7a44d56$var$_index2 = $9488ab6bd7a44d56$require$_interopRequireDefault((parcelRequire("lAH9J")));
function $9488ab6bd7a44d56$var$startOfUTCISOWeek(dirtyDate) {
    (0, $9488ab6bd7a44d56$var$_index2.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $9488ab6bd7a44d56$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});

parcelRegister("cVR3T", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $96a3f7db84b87680$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $96a3f7db84b87680$var$startOfUTCISOWeekYear;

var $96a3f7db84b87680$var$_index = $96a3f7db84b87680$require$_interopRequireDefault((parcelRequire("aVYsV")));

var $96a3f7db84b87680$var$_index2 = $96a3f7db84b87680$require$_interopRequireDefault((parcelRequire("cKDOV")));

var $96a3f7db84b87680$var$_index3 = $96a3f7db84b87680$require$_interopRequireDefault((parcelRequire("lAH9J")));
function $96a3f7db84b87680$var$startOfUTCISOWeekYear(dirtyDate) {
    (0, $96a3f7db84b87680$var$_index3.default)(1, arguments);
    var year = (0, $96a3f7db84b87680$var$_index.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $96a3f7db84b87680$var$_index2.default)(fourthOfJanuary);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("aVYsV", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $7f5e217524d432ae$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7f5e217524d432ae$var$getUTCISOWeekYear;

var $7f5e217524d432ae$var$_index = $7f5e217524d432ae$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $7f5e217524d432ae$var$_index2 = $7f5e217524d432ae$require$_interopRequireDefault((parcelRequire("lAH9J")));

var $7f5e217524d432ae$var$_index3 = $7f5e217524d432ae$require$_interopRequireDefault((parcelRequire("cKDOV")));
function $7f5e217524d432ae$var$getUTCISOWeekYear(dirtyDate) {
    (0, $7f5e217524d432ae$var$_index2.default)(1, arguments);
    var date = (0, $7f5e217524d432ae$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $7f5e217524d432ae$var$_index3.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $7f5e217524d432ae$var$_index3.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("3FWiw", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $2ad26c25a0ee671c$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ad26c25a0ee671c$var$getUTCWeek;

var $2ad26c25a0ee671c$var$_index = $2ad26c25a0ee671c$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $2ad26c25a0ee671c$var$_index2 = $2ad26c25a0ee671c$require$_interopRequireDefault((parcelRequire("9RdF8")));

var $2ad26c25a0ee671c$var$_index3 = $2ad26c25a0ee671c$require$_interopRequireDefault((parcelRequire("kYV09")));

var $2ad26c25a0ee671c$var$_index4 = $2ad26c25a0ee671c$require$_interopRequireDefault((parcelRequire("lAH9J")));
var $2ad26c25a0ee671c$var$MILLISECONDS_IN_WEEK = 604800000;
function $2ad26c25a0ee671c$var$getUTCWeek(dirtyDate, options) {
    (0, $2ad26c25a0ee671c$var$_index4.default)(1, arguments);
    var date = (0, $2ad26c25a0ee671c$var$_index.default)(dirtyDate);
    var diff = (0, $2ad26c25a0ee671c$var$_index2.default)(date, options).getTime() - (0, $2ad26c25a0ee671c$var$_index3.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $2ad26c25a0ee671c$var$MILLISECONDS_IN_WEEK) + 1;
}
module.exports = module.exports.default;

});
parcelRegister("9RdF8", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $72d3a95b03dfe11f$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $72d3a95b03dfe11f$var$startOfUTCWeek;

var $72d3a95b03dfe11f$var$_index = $72d3a95b03dfe11f$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $72d3a95b03dfe11f$var$_index2 = $72d3a95b03dfe11f$require$_interopRequireDefault((parcelRequire("lAH9J")));

var $72d3a95b03dfe11f$var$_index3 = $72d3a95b03dfe11f$require$_interopRequireDefault((parcelRequire("3iCLV")));

var $4fo5Z = parcelRequire("4fo5Z");
function $72d3a95b03dfe11f$var$startOfUTCWeek(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $72d3a95b03dfe11f$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $4fo5Z.getDefaultOptions)();
    var weekStartsOn = (0, $72d3a95b03dfe11f$var$_index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $72d3a95b03dfe11f$var$_index.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("4fo5Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getDefaultOptions = $317b4101eab5e174$var$getDefaultOptions;
module.exports.setDefaultOptions = $317b4101eab5e174$var$setDefaultOptions;
var $317b4101eab5e174$var$defaultOptions = {};
function $317b4101eab5e174$var$getDefaultOptions() {
    return $317b4101eab5e174$var$defaultOptions;
}
function $317b4101eab5e174$var$setDefaultOptions(newOptions) {
    $317b4101eab5e174$var$defaultOptions = newOptions;
}

});


parcelRegister("kYV09", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $f465a08e98bec301$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f465a08e98bec301$var$startOfUTCWeekYear;

var $f465a08e98bec301$var$_index = $f465a08e98bec301$require$_interopRequireDefault((parcelRequire("kWPOO")));

var $f465a08e98bec301$var$_index2 = $f465a08e98bec301$require$_interopRequireDefault((parcelRequire("lAH9J")));

var $f465a08e98bec301$var$_index3 = $f465a08e98bec301$require$_interopRequireDefault((parcelRequire("9RdF8")));

var $f465a08e98bec301$var$_index4 = $f465a08e98bec301$require$_interopRequireDefault((parcelRequire("3iCLV")));

var $4fo5Z = parcelRequire("4fo5Z");
function $f465a08e98bec301$var$startOfUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f465a08e98bec301$var$_index2.default)(1, arguments);
    var defaultOptions = (0, $4fo5Z.getDefaultOptions)();
    var firstWeekContainsDate = (0, $f465a08e98bec301$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $f465a08e98bec301$var$_index.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $f465a08e98bec301$var$_index3.default)(firstWeek, options);
    return date;
}
module.exports = module.exports.default;

});
parcelRegister("kWPOO", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $f4016b87c0393e1d$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f4016b87c0393e1d$var$getUTCWeekYear;

var $f4016b87c0393e1d$var$_index = $f4016b87c0393e1d$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $f4016b87c0393e1d$var$_index2 = $f4016b87c0393e1d$require$_interopRequireDefault((parcelRequire("lAH9J")));

var $f4016b87c0393e1d$var$_index3 = $f4016b87c0393e1d$require$_interopRequireDefault((parcelRequire("9RdF8")));

var $f4016b87c0393e1d$var$_index4 = $f4016b87c0393e1d$require$_interopRequireDefault((parcelRequire("3iCLV")));

var $4fo5Z = parcelRequire("4fo5Z");
function $f4016b87c0393e1d$var$getUTCWeekYear(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f4016b87c0393e1d$var$_index2.default)(1, arguments);
    var date = (0, $f4016b87c0393e1d$var$_index.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $4fo5Z.getDefaultOptions)();
    var firstWeekContainsDate = (0, $f4016b87c0393e1d$var$_index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f4016b87c0393e1d$var$_index3.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f4016b87c0393e1d$var$_index3.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
module.exports = module.exports.default;

});



parcelRegister("7v6bA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57603a03e2f458bc$var$addLeadingZeros;
function $57603a03e2f458bc$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
module.exports = module.exports.default;

});

parcelRegister("9zm7f", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $6f7889ade6e661a8$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f7889ade6e661a8$var$_index = $6f7889ade6e661a8$require$_interopRequireDefault((parcelRequire("7v6bA")));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $6f7889ade6e661a8$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $6f7889ade6e661a8$var$_index.default)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $6f7889ade6e661a8$var$_index.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $6f7889ade6e661a8$var$_index.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $6f7889ade6e661a8$var$_index.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $6f7889ade6e661a8$var$_index.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $6f7889ade6e661a8$var$_index.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $6f7889ade6e661a8$var$_index.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $6f7889ade6e661a8$var$_index.default)(fractionalSeconds, token.length);
    }
};
var $6f7889ade6e661a8$var$_default = $6f7889ade6e661a8$var$formatters;
module.exports.default = $6f7889ade6e661a8$var$_default;
module.exports = module.exports.default;

});


parcelRegister("2rlkx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $1c6ea6263ea59a13$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $1c6ea6263ea59a13$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $1c6ea6263ea59a13$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $1c6ea6263ea59a13$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $1c6ea6263ea59a13$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $1c6ea6263ea59a13$var$timeLongFormatter(timePattern, formatLong));
};
var $1c6ea6263ea59a13$var$longFormatters = {
    p: $1c6ea6263ea59a13$var$timeLongFormatter,
    P: $1c6ea6263ea59a13$var$dateTimeLongFormatter
};
var $1c6ea6263ea59a13$var$_default = $1c6ea6263ea59a13$var$longFormatters;
module.exports.default = $1c6ea6263ea59a13$var$_default;
module.exports = module.exports.default;

});

parcelRegister("fSvzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b8f46500206d24cd$var$getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $b8f46500206d24cd$var$getTimezoneOffsetInMilliseconds(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}
module.exports = module.exports.default;

});

parcelRegister("eRjSO", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $02caab19ebebb004$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02caab19ebebb004$var$_index = $02caab19ebebb004$require$_interopRequireDefault((parcelRequire("dUqN7")));
var $02caab19ebebb004$var$_default = $02caab19ebebb004$var$_index.default;
module.exports.default = $02caab19ebebb004$var$_default;
module.exports = module.exports.default;

});
parcelRegister("dUqN7", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $a205498337dc091a$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a205498337dc091a$var$_index = $a205498337dc091a$require$_interopRequireDefault((parcelRequire("l1aJX")));

var $a205498337dc091a$var$_index2 = $a205498337dc091a$require$_interopRequireDefault((parcelRequire("2Amli")));

var $a205498337dc091a$var$_index3 = $a205498337dc091a$require$_interopRequireDefault((parcelRequire("aSmoJ")));

var $a205498337dc091a$var$_index4 = $a205498337dc091a$require$_interopRequireDefault((parcelRequire("fM1tj")));

var $a205498337dc091a$var$_index5 = $a205498337dc091a$require$_interopRequireDefault((parcelRequire("fNPg5")));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $a205498337dc091a$var$locale = {
    code: 'en-US',
    formatDistance: $a205498337dc091a$var$_index.default,
    formatLong: $a205498337dc091a$var$_index2.default,
    formatRelative: $a205498337dc091a$var$_index3.default,
    localize: $a205498337dc091a$var$_index4.default,
    match: $a205498337dc091a$var$_index5.default,
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $a205498337dc091a$var$_default = $a205498337dc091a$var$locale;
module.exports.default = $a205498337dc091a$var$_default;
module.exports = module.exports.default;

});
parcelRegister("l1aJX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f4d205c1ea65bfaa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $f4d205c1ea65bfaa$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f4d205c1ea65bfaa$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $f4d205c1ea65bfaa$var$_default = $f4d205c1ea65bfaa$var$formatDistance;
module.exports.default = $f4d205c1ea65bfaa$var$_default;
module.exports = module.exports.default;

});

parcelRegister("2Amli", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $1e20464bd5659509$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1e20464bd5659509$var$_index = $1e20464bd5659509$require$_interopRequireDefault((parcelRequire("f7ffK")));
var $1e20464bd5659509$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $1e20464bd5659509$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $1e20464bd5659509$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $1e20464bd5659509$var$formatLong = {
    date: (0, $1e20464bd5659509$var$_index.default)({
        formats: $1e20464bd5659509$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $1e20464bd5659509$var$_index.default)({
        formats: $1e20464bd5659509$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $1e20464bd5659509$var$_index.default)({
        formats: $1e20464bd5659509$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $1e20464bd5659509$var$_default = $1e20464bd5659509$var$formatLong;
module.exports.default = $1e20464bd5659509$var$_default;
module.exports = module.exports.default;

});
parcelRegister("f7ffK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b013576951be0db1$var$buildFormatLongFn;
function $b013576951be0db1$var$buildFormatLongFn(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}
module.exports = module.exports.default;

});


parcelRegister("aSmoJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $7eb05242973e1791$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $7eb05242973e1791$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7eb05242973e1791$var$formatRelativeLocale[token];
};
var $7eb05242973e1791$var$_default = $7eb05242973e1791$var$formatRelative;
module.exports.default = $7eb05242973e1791$var$_default;
module.exports = module.exports.default;

});

parcelRegister("fM1tj", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $b7bc7af487d40a52$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b7bc7af487d40a52$var$_index = $b7bc7af487d40a52$require$_interopRequireDefault((parcelRequire("7OGhr")));
var $b7bc7af487d40a52$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $b7bc7af487d40a52$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $b7bc7af487d40a52$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $b7bc7af487d40a52$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $b7bc7af487d40a52$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $b7bc7af487d40a52$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $b7bc7af487d40a52$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $b7bc7af487d40a52$var$localize = {
    ordinalNumber: $b7bc7af487d40a52$var$ordinalNumber,
    era: (0, $b7bc7af487d40a52$var$_index.default)({
        values: $b7bc7af487d40a52$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $b7bc7af487d40a52$var$_index.default)({
        values: $b7bc7af487d40a52$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $b7bc7af487d40a52$var$_index.default)({
        values: $b7bc7af487d40a52$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $b7bc7af487d40a52$var$_index.default)({
        values: $b7bc7af487d40a52$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $b7bc7af487d40a52$var$_index.default)({
        values: $b7bc7af487d40a52$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b7bc7af487d40a52$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b7bc7af487d40a52$var$_default = $b7bc7af487d40a52$var$localize;
module.exports.default = $b7bc7af487d40a52$var$_default;
module.exports = module.exports.default;

});
parcelRegister("7OGhr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $5b0dffe9467760ca$var$buildLocalizeFn;
function $5b0dffe9467760ca$var$buildLocalizeFn(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}
module.exports = module.exports.default;

});


parcelRegister("fNPg5", function(module, exports) {
"use strict";

var $9ucar = parcelRequire("9ucar");
var $b813317d32222ac6$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b813317d32222ac6$var$_index = $b813317d32222ac6$require$_interopRequireDefault((parcelRequire("f2Bzn")));

var $b813317d32222ac6$var$_index2 = $b813317d32222ac6$require$_interopRequireDefault((parcelRequire("e1GmR")));
var $b813317d32222ac6$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $b813317d32222ac6$var$parseOrdinalNumberPattern = /\d+/i;
var $b813317d32222ac6$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $b813317d32222ac6$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $b813317d32222ac6$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $b813317d32222ac6$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b813317d32222ac6$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $b813317d32222ac6$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b813317d32222ac6$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $b813317d32222ac6$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $b813317d32222ac6$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $b813317d32222ac6$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $b813317d32222ac6$var$match = {
    ordinalNumber: (0, $b813317d32222ac6$var$_index2.default)({
        matchPattern: $b813317d32222ac6$var$matchOrdinalNumberPattern,
        parsePattern: $b813317d32222ac6$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $b813317d32222ac6$var$_index.default)({
        matchPatterns: $b813317d32222ac6$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b813317d32222ac6$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $b813317d32222ac6$var$_index.default)({
        matchPatterns: $b813317d32222ac6$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b813317d32222ac6$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $b813317d32222ac6$var$_index.default)({
        matchPatterns: $b813317d32222ac6$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b813317d32222ac6$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $b813317d32222ac6$var$_index.default)({
        matchPatterns: $b813317d32222ac6$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b813317d32222ac6$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $b813317d32222ac6$var$_index.default)({
        matchPatterns: $b813317d32222ac6$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b813317d32222ac6$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b813317d32222ac6$var$_default = $b813317d32222ac6$var$match;
module.exports.default = $b813317d32222ac6$var$_default;
module.exports = module.exports.default;

});
parcelRegister("f2Bzn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $af342f74b2c82de5$var$buildMatchFn;
function $af342f74b2c82de5$var$buildMatchFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $af342f74b2c82de5$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $af342f74b2c82de5$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $af342f74b2c82de5$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $af342f74b2c82de5$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}
module.exports = module.exports.default;

});

parcelRegister("e1GmR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a362060da9bc3ee0$var$buildMatchPatternFn;
function $a362060da9bc3ee0$var$buildMatchPatternFn(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
module.exports = module.exports.default;

});




parcelRegister("bnqyM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $848671f69e41d9d1$var$assign;
function $848671f69e41d9d1$var$assign(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}
module.exports = module.exports.default;

});

parcelRegister("i5w0I", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.17.23';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution, see: https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            var index = -1, length = path.length;
            if (!length) return true;
            var isRootPrimitive = object == null || typeof object !== 'object' && typeof object !== 'function';
            while(++index < length){
                var key = path[index];
                // skip non-string keys (e.g., Symbols, numbers)
                if (typeof key !== 'string') continue;
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block "constructor.prototype" chains
                if (key === 'constructor' && index + 1 < length && typeof path[index + 1] === 'string' && path[index + 1] === 'prototype') {
                    // Allow ONLY when the path starts at a primitive root, e.g., _.unset(0, 'constructor.prototype.a')
                    if (isRootPrimitive && index === 0) continue;
                    return false;
                }
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                result[pair[0]] = pair[1];
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignInWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("kij1l", function(module, exports) {

//! moment-timezone.js
//! version : 0.5.48
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone
(function(root, factory) {
    "use strict";
    /*global define*/ if (module.exports) module.exports = factory((parcelRequire("aXpL2"))); // Node
    else if (typeof define === 'function' && define.amd) define([
        'moment'
    ], factory); // AMD
    else factory(root.moment); // Browser
})(module.exports, function(moment) {
    "use strict";
    // Resolves es6 module loading issue
    if (moment.version === undefined && moment.default) moment = moment.default;
    // Do not load moment-timezone a second time.
    // if (moment.tz !== undefined) {
    // 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
    // 	return moment;
    // }
    var VERSION = "0.5.48", zones = {}, links = {}, countries = {}, names = {}, guesses = {}, cachedGuess;
    if (!moment || typeof moment.version !== 'string') logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
    var momentVersion = moment.version.split('.'), major = +momentVersion[0], minor = +momentVersion[1];
    // Moment.js version check
    if (major < 2 || major === 2 && minor < 6) logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
    /************************************
		Unpacking
	************************************/ function charCodeToInt(charCode) {
        if (charCode > 96) return charCode - 87;
        else if (charCode > 64) return charCode - 29;
        return charCode - 48;
    }
    function unpackBase60(string) {
        var i = 0, parts = string.split('.'), whole = parts[0], fractional = parts[1] || '', multiplier = 1, num, out = 0, sign = 1;
        // handle negative numbers
        if (string.charCodeAt(0) === 45) {
            i = 1;
            sign = -1;
        }
        // handle digits before the decimal
        for(i; i < whole.length; i++){
            num = charCodeToInt(whole.charCodeAt(i));
            out = 60 * out + num;
        }
        // handle digits after the decimal
        for(i = 0; i < fractional.length; i++){
            multiplier = multiplier / 60;
            num = charCodeToInt(fractional.charCodeAt(i));
            out += num * multiplier;
        }
        return out * sign;
    }
    function arrayToInt(array) {
        for(var i = 0; i < array.length; i++)array[i] = unpackBase60(array[i]);
    }
    function intToUntil(array, length) {
        for(var i = 0; i < length; i++)array[i] = Math.round((array[i - 1] || 0) + array[i] * 60000); // minutes to milliseconds
        array[length - 1] = Infinity;
    }
    function mapIndices(source, indices) {
        var out = [], i;
        for(i = 0; i < indices.length; i++)out[i] = source[indices[i]];
        return out;
    }
    function unpack(string) {
        var data = string.split('|'), offsets = data[2].split(' '), indices = data[3].split(''), untils = data[4].split(' ');
        arrayToInt(offsets);
        arrayToInt(indices);
        arrayToInt(untils);
        intToUntil(untils, indices.length);
        return {
            name: data[0],
            abbrs: mapIndices(data[1].split(' '), indices),
            offsets: mapIndices(offsets, indices),
            untils: untils,
            population: data[5] | 0
        };
    }
    /************************************
		Zone object
	************************************/ function Zone(packedString) {
        if (packedString) this._set(unpack(packedString));
    }
    function closest(num, arr) {
        var len = arr.length;
        if (num < arr[0]) return 0;
        else if (len > 1 && arr[len - 1] === Infinity && num >= arr[len - 2]) return len - 1;
        else if (num >= arr[len - 1]) return -1;
        var mid;
        var lo = 0;
        var hi = len - 1;
        while(hi - lo > 1){
            mid = Math.floor((lo + hi) / 2);
            if (arr[mid] <= num) lo = mid;
            else hi = mid;
        }
        return hi;
    }
    Zone.prototype = {
        _set: function(unpacked) {
            this.name = unpacked.name;
            this.abbrs = unpacked.abbrs;
            this.untils = unpacked.untils;
            this.offsets = unpacked.offsets;
            this.population = unpacked.population;
        },
        _index: function(timestamp) {
            var target = +timestamp, untils = this.untils, i;
            i = closest(target, untils);
            if (i >= 0) return i;
        },
        countries: function() {
            var zone_name = this.name;
            return Object.keys(countries).filter(function(country_code) {
                return countries[country_code].zones.indexOf(zone_name) !== -1;
            });
        },
        parse: function(timestamp) {
            var target = +timestamp, offsets = this.offsets, untils = this.untils, max = untils.length - 1, offset, offsetNext, offsetPrev, i;
            for(i = 0; i < max; i++){
                offset = offsets[i];
                offsetNext = offsets[i + 1];
                offsetPrev = offsets[i ? i - 1 : i];
                if (offset < offsetNext && tz.moveAmbiguousForward) offset = offsetNext;
                else if (offset > offsetPrev && tz.moveInvalidForward) offset = offsetPrev;
                if (target < untils[i] - offset * 60000) return offsets[i];
            }
            return offsets[max];
        },
        abbr: function(mom) {
            return this.abbrs[this._index(mom)];
        },
        offset: function(mom) {
            logError("zone.offset has been deprecated in favor of zone.utcOffset");
            return this.offsets[this._index(mom)];
        },
        utcOffset: function(mom) {
            return this.offsets[this._index(mom)];
        }
    };
    /************************************
		Country object
	************************************/ function Country(country_name, zone_names) {
        this.name = country_name;
        this.zones = zone_names;
    }
    /************************************
		Current Timezone
	************************************/ function OffsetAt(at) {
        var timeString = at.toTimeString();
        var abbr = timeString.match(/\([a-z ]+\)/i);
        if (abbr && abbr[0]) {
            // 17:56:31 GMT-0600 (CST)
            // 17:56:31 GMT-0600 (Central Standard Time)
            abbr = abbr[0].match(/[A-Z]/g);
            abbr = abbr ? abbr.join('') : undefined;
        } else {
            // 17:56:31 CST
            // 17:56:31 GMT+0800 (台北標準時間)
            abbr = timeString.match(/[A-Z]{3,5}/g);
            abbr = abbr ? abbr[0] : undefined;
        }
        if (abbr === 'GMT') abbr = undefined;
        this.at = +at;
        this.abbr = abbr;
        this.offset = at.getTimezoneOffset();
    }
    function ZoneScore(zone) {
        this.zone = zone;
        this.offsetScore = 0;
        this.abbrScore = 0;
    }
    ZoneScore.prototype.scoreOffsetAt = function(offsetAt) {
        this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
        if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) this.abbrScore++;
    };
    function findChange(low, high) {
        var mid, diff;
        while(diff = ((high.at - low.at) / 12e4 | 0) * 6e4){
            mid = new OffsetAt(new Date(low.at + diff));
            if (mid.offset === low.offset) low = mid;
            else high = mid;
        }
        return low;
    }
    function userOffsets() {
        var startYear = new Date().getFullYear() - 2, last = new OffsetAt(new Date(startYear, 0, 1)), lastOffset = last.offset, offsets = [
            last
        ], change, next, nextOffset, i;
        for(i = 1; i < 48; i++){
            nextOffset = new Date(startYear, i, 1).getTimezoneOffset();
            if (nextOffset !== lastOffset) {
                // Create OffsetAt here to avoid unnecessary abbr parsing before checking offsets
                next = new OffsetAt(new Date(startYear, i, 1));
                change = findChange(last, next);
                offsets.push(change);
                offsets.push(new OffsetAt(new Date(change.at + 6e4)));
                last = next;
                lastOffset = nextOffset;
            }
        }
        for(i = 0; i < 4; i++){
            offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
            offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
        }
        return offsets;
    }
    function sortZoneScores(a, b) {
        if (a.offsetScore !== b.offsetScore) return a.offsetScore - b.offsetScore;
        if (a.abbrScore !== b.abbrScore) return a.abbrScore - b.abbrScore;
        if (a.zone.population !== b.zone.population) return b.zone.population - a.zone.population;
        return b.zone.name.localeCompare(a.zone.name);
    }
    function addToGuesses(name, offsets) {
        var i, offset;
        arrayToInt(offsets);
        for(i = 0; i < offsets.length; i++){
            offset = offsets[i];
            guesses[offset] = guesses[offset] || {};
            guesses[offset][name] = true;
        }
    }
    function guessesForUserOffsets(offsets) {
        var offsetsLength = offsets.length, filteredGuesses = {}, out = [], checkedOffsets = {}, i, j, offset, guessesOffset;
        for(i = 0; i < offsetsLength; i++){
            offset = offsets[i].offset;
            if (checkedOffsets.hasOwnProperty(offset)) continue;
            guessesOffset = guesses[offset] || {};
            for(j in guessesOffset)if (guessesOffset.hasOwnProperty(j)) filteredGuesses[j] = true;
            checkedOffsets[offset] = true;
        }
        for(i in filteredGuesses)if (filteredGuesses.hasOwnProperty(i)) out.push(names[i]);
        return out;
    }
    function rebuildGuess() {
        // use Intl API when available and returning valid time zone
        try {
            var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (intlName && intlName.length > 3) {
                var name = names[normalizeName(intlName)];
                if (name) return name;
                logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
            }
        } catch (e) {
        // Intl unavailable, fall back to manual guessing.
        }
        var offsets = userOffsets(), offsetsLength = offsets.length, guesses = guessesForUserOffsets(offsets), zoneScores = [], zoneScore, i, j;
        for(i = 0; i < guesses.length; i++){
            zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
            for(j = 0; j < offsetsLength; j++)zoneScore.scoreOffsetAt(offsets[j]);
            zoneScores.push(zoneScore);
        }
        zoneScores.sort(sortZoneScores);
        return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
    }
    function guess(ignoreCache) {
        if (!cachedGuess || ignoreCache) cachedGuess = rebuildGuess();
        return cachedGuess;
    }
    /************************************
		Global Methods
	************************************/ function normalizeName(name) {
        return (name || '').toLowerCase().replace(/\//g, '_');
    }
    function addZone(packed) {
        var i, name, split, normalized;
        if (typeof packed === "string") packed = [
            packed
        ];
        for(i = 0; i < packed.length; i++){
            split = packed[i].split('|');
            name = split[0];
            normalized = normalizeName(name);
            zones[normalized] = packed[i];
            names[normalized] = name;
            addToGuesses(normalized, split[2].split(' '));
        }
    }
    function getZone(name, caller) {
        name = normalizeName(name);
        var zone = zones[name];
        var link;
        if (zone instanceof Zone) return zone;
        if (typeof zone === 'string') {
            zone = new Zone(zone);
            zones[name] = zone;
            return zone;
        }
        // Pass getZone to prevent recursion more than 1 level deep
        if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
            zone = zones[name] = new Zone();
            zone._set(link);
            zone.name = names[name];
            return zone;
        }
        return null;
    }
    function getNames() {
        var i, out = [];
        for(i in names)if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) out.push(names[i]);
        return out.sort();
    }
    function getCountryNames() {
        return Object.keys(countries);
    }
    function addLink(aliases) {
        var i, alias, normal0, normal1;
        if (typeof aliases === "string") aliases = [
            aliases
        ];
        for(i = 0; i < aliases.length; i++){
            alias = aliases[i].split('|');
            normal0 = normalizeName(alias[0]);
            normal1 = normalizeName(alias[1]);
            links[normal0] = normal1;
            names[normal0] = alias[0];
            links[normal1] = normal0;
            names[normal1] = alias[1];
        }
    }
    function addCountries(data) {
        var i, country_code, country_zones, split;
        if (!data || !data.length) return;
        for(i = 0; i < data.length; i++){
            split = data[i].split('|');
            country_code = split[0].toUpperCase();
            country_zones = split[1].split(' ');
            countries[country_code] = new Country(country_code, country_zones);
        }
    }
    function getCountry(name) {
        name = name.toUpperCase();
        return countries[name] || null;
    }
    function zonesForCountry(country, with_offset) {
        country = getCountry(country);
        if (!country) return null;
        var zones = country.zones.sort();
        if (with_offset) return zones.map(function(zone_name) {
            var zone = getZone(zone_name);
            return {
                name: zone_name,
                offset: zone.utcOffset(new Date())
            };
        });
        return zones;
    }
    function loadData(data) {
        addZone(data.zones);
        addLink(data.links);
        addCountries(data.countries);
        tz.dataVersion = data.version;
    }
    function zoneExists(name) {
        if (!zoneExists.didShowError) {
            zoneExists.didShowError = true;
            logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
        }
        return !!getZone(name);
    }
    function needsOffset(m) {
        var isUnixTimestamp = m._f === 'X' || m._f === 'x';
        return !!(m._a && m._tzm === undefined && !isUnixTimestamp);
    }
    function logError(message) {
        if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    }
    /************************************
		moment.tz namespace
	************************************/ function tz(input) {
        var args = Array.prototype.slice.call(arguments, 0, -1), name = arguments[arguments.length - 1], out = moment.utc.apply(null, args), zone;
        if (!moment.isMoment(input) && needsOffset(out) && (zone = getZone(name))) out.add(zone.parse(out), 'minutes');
        out.tz(name);
        return out;
    }
    tz.version = VERSION;
    tz.dataVersion = '';
    tz._zones = zones;
    tz._links = links;
    tz._names = names;
    tz._countries = countries;
    tz.add = addZone;
    tz.link = addLink;
    tz.load = loadData;
    tz.zone = getZone;
    tz.zoneExists = zoneExists; // deprecated in 0.1.0
    tz.guess = guess;
    tz.names = getNames;
    tz.Zone = Zone;
    tz.unpack = unpack;
    tz.unpackBase60 = unpackBase60;
    tz.needsOffset = needsOffset;
    tz.moveInvalidForward = true;
    tz.moveAmbiguousForward = false;
    tz.countries = getCountryNames;
    tz.zonesForCountry = zonesForCountry;
    /************************************
		Interface with Moment.js
	************************************/ var fn = moment.fn;
    moment.tz = tz;
    moment.defaultZone = null;
    moment.updateOffset = function(mom, keepTime) {
        var zone = moment.defaultZone, offset;
        if (mom._z === undefined) {
            if (zone && needsOffset(mom) && !mom._isUTC && mom.isValid()) {
                mom._d = moment.utc(mom._a)._d;
                mom.utc().add(zone.parse(mom), 'minutes');
            }
            mom._z = zone;
        }
        if (mom._z) {
            offset = mom._z.utcOffset(mom);
            if (Math.abs(offset) < 16) offset = offset / 60;
            if (mom.utcOffset !== undefined) {
                var z = mom._z;
                mom.utcOffset(-offset, keepTime);
                mom._z = z;
            } else mom.zone(offset, keepTime);
        }
    };
    fn.tz = function(name, keepTime) {
        if (name) {
            if (typeof name !== 'string') throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
            this._z = getZone(name);
            if (this._z) moment.updateOffset(this, keepTime);
            else logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
            return this;
        }
        if (this._z) return this._z.name;
    };
    function abbrWrap(old) {
        return function() {
            if (this._z) return this._z.abbr(this);
            return old.call(this);
        };
    }
    function resetZoneWrap(old) {
        return function() {
            this._z = null;
            return old.apply(this, arguments);
        };
    }
    function resetZoneWrap2(old) {
        return function() {
            if (arguments.length > 0) this._z = null;
            return old.apply(this, arguments);
        };
    }
    fn.zoneName = abbrWrap(fn.zoneName);
    fn.zoneAbbr = abbrWrap(fn.zoneAbbr);
    fn.utc = resetZoneWrap(fn.utc);
    fn.local = resetZoneWrap(fn.local);
    fn.utcOffset = resetZoneWrap2(fn.utcOffset);
    moment.tz.setDefault = function(name) {
        if (major < 2 || major === 2 && minor < 9) logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
        moment.defaultZone = name ? getZone(name) : null;
        return moment;
    };
    // Cloning a moment should include the _z property.
    var momentProperties = moment.momentProperties;
    if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
        // moment 2.8.1+
        momentProperties.push('_z');
        momentProperties.push('_a');
    } else if (momentProperties) // moment 2.7.0
    momentProperties._z = null;
    // INJECT DATA
    return moment;
});

});
parcelRegister("aXpL2", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.30.1';
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});


parcelRegister("dXDHh", function(module, exports) {
module.exports = JSON.parse("{\"version\":\"2025b\",\"zones\":[\"Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5\",\"Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5\",\"Africa/Algiers|LMT PMT WET WEST CET CEST|-c.c -9.l 0 -10 -10 -20|01232323232323232454542423234542324|-3bQ0c.c MDA2.P cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5\",\"Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6\",\"Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4\",\"Africa/Maputo|LMT CAT|-2a.i -20|01|-2sw2a.i|26e5\",\"Africa/Cairo|LMT EET EEST|-25.9 -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBC5.9 1AQM5.9 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0 kSp0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0|15e6\",\"Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|32e5\",\"Africa/Ceuta|LMT WET WEST CET CEST|l.g 0 -10 -10 -20|0121212121212121212121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2M0M0 GdX0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|85e3\",\"Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0|20e4\",\"Africa/Johannesburg|LMT SAST SAST SAST|-1Q -1u -20 -30|0123232|-39EpQ qTcm 1Ajdu 1cL0 1cN0 1cL0|84e5\",\"Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|\",\"Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5\",\"Africa/Monrovia|LMT MMT MMT GMT|H.8 H.8 I.u 0|0123|-3ygng.Q 1usM0 28G01.m|11e5\",\"Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5\",\"Africa/Sao_Tome|LMT LMT GMT WAT|-q.U A.J 0 -10|01232|-3tooq.U 18aoq.U 4i6N0 2q00|\",\"Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5\",\"Africa/Tunis|LMT PMT CET CEST|-E.I -9.l -10 -20|01232323232323232323232323232323232|-3zO0E.I 1cBAv.n 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5\",\"Africa/Windhoek|LMT +0130 SAST SAST CAT WAT|-18.o -1u -20 -30 -20 -10|012324545454545454545454545454545454545454545454545454|-39Ep8.o qTbC.o 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4\",\"America/Adak|LMT LMT NST NWT NPT BST BDT AHST HST HDT|-cd.m bK.C b0 a0 a0 b0 a0 a0 a0 90|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVzf.p 1EX1d.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326\",\"America/Anchorage|LMT LMT AST AWT APT AHST AHDT YST AKST AKDT|-e0.o 9X.A a0 90 90 a0 90 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVxs.n 1EX20.o 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4\",\"America/Puerto_Rico|LMT AST AWT APT|4o.p 40 30 30|01231|-2Qi7z.z 1IUbz.z 7XT0 iu0|24e5\",\"America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4\",\"America/Argentina/Buenos_Aires|LMT CMT -04 -03 -02|3R.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343434343|-331U6.c 125cn pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Catamarca|LMT CMT -04 -03 -02|4n.8 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243432343|-331TA.Q 125bR.E pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Cordoba|LMT CMT -04 -03 -02|4g.M 4g.M 40 30 20|012323232323232323232323232323232323232323234343434243434343|-331TH.c 125c0 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|\",\"America/Argentina/Jujuy|LMT CMT -04 -03 -02|4l.c 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232434343|-331TC.M 125bT.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/La_Rioja|LMT CMT -04 -03 -02|4r.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tw.A 125bN.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Mendoza|LMT CMT -04 -03 -02|4z.g 4g.M 40 30 20|012323232323232323232323232323232323232323234343423232432343|-331To.I 125bF.w pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|\",\"America/Argentina/Rio_Gallegos|LMT CMT -04 -03 -02|4A.Q 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tn.8 125bD.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|\",\"America/Argentina/Salta|LMT CMT -04 -03 -02|4l.E 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342434343|-331TC.k 125bT.8 pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|\",\"America/Argentina/San_Juan|LMT CMT -04 -03 -02|4y.4 4g.M 40 30 20|0123232323232323232323232323232323232323232343434342343432343|-331Tp.U 125bG.I pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|\",\"America/Argentina/San_Luis|LMT CMT -04 -03 -02|4p.o 4g.M 40 30 20|0123232323232323232323232323232323232323232343434232323432323|-331Ty.A 125bP.o pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|\",\"America/Argentina/Tucuman|LMT CMT -04 -03 -02|4k.Q 4g.M 40 30 20|01232323232323232323232323232323232323232323434343424343234343|-331TD.8 125bT.U pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|\",\"America/Argentina/Ushuaia|LMT CMT -04 -03 -02|4x.c 4g.M 40 30 20|012323232323232323232323232323232323232323234343434343432343|-331Tq.M 125bH.A pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|\",\"America/Asuncion|LMT AMT -04 -03|3O.E 3O.E 40 30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-3eLw9.k 1FGo0 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5\",\"America/Panama|LMT CMT EST|5i.8 5j.A 50|012|-3eLuF.Q Iy01.s|15e5\",\"America/Bahia_Banderas|LMT MST CST MDT CDT|71 70 60 60 50|01213121313131313131313131313131313142424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|84e3\",\"America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5\",\"America/Barbados|LMT AST ADT -0330|3W.t 40 30 3u|0121213121212121|-2m4k1.v 1eAN1.v RB0 1Bz0 Op0 1rb0 11d0 1jJc0 IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4\",\"America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5\",\"America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3\",\"America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2\",\"America/Bogota|LMT BMT -05 -04|4U.g 4U.g 50 40|01232|-3sTv3.I 1eIo0 38yo3.I 1PX0|90e5\",\"America/Boise|LMT PST PDT MST MWT MPT MDT|7I.N 80 70 70 60 60 60|01212134536363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-3tFE0 1nEe0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4\",\"America/Cambridge_Bay|-00 MST MWT MPT MDT CST CDT EST|0 70 60 60 60 60 50 50|012314141414141414141414141414141414141414141414141414141414567541414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-21Jc0 RO90 8x20 ix0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2\",\"America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4\",\"America/Cancun|LMT CST EST CDT EDT|5L.4 60 50 50 40|01213132431313131313131313131313131313131312|-1UQG0 2q3C0 2tx0 wgP0 1lb0 14p0 1lb0 14o0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4\",\"America/Caracas|LMT CMT -0430 -04|4r.I 4r.E 4u 40|012323|-3eLvw.g ROnX.U 28KM2.k 1IwOu kqo0|29e5\",\"America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3\",\"America/Chicago|LMT CST CDT EST CWT CPT|5O.A 60 50 50 50 50|012121212121212121212121212121212121213121212121214512121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5\",\"America/Chihuahua|LMT MST CST MDT CDT|74.k 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|81e4\",\"America/Ciudad_Juarez|LMT MST CST MDT CDT|75.U 70 60 60 50|01213124242313131313131313131313131313131313131313131313131321313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Costa_Rica|LMT SJMT CST CDT|5A.d 5A.d 60 50|01232323232|-3eLun.L 1fyo0 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5\",\"America/Coyhaique|LMT SMT -05 -04 -03|4M.g 4G.J 50 40 30|012131323232323232323434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvb.I MJbS.t fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|\",\"America/Phoenix|LMT MST MDT MWT|7s.i 70 60 60|012121313121|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5\",\"America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4\",\"America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8\",\"America/Dawson_Creek|LMT PST PDT PWT PPT MST|80.U 80 70 70 70 70|01213412121212121212121212121212121212121212121212121212125|-3tofX.4 1nspX.4 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3\",\"America/Dawson|LMT YST YDT YWT YPT YDDT PST PDT MST|9h.E 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeG.k GWpG.k 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2\",\"America/Denver|LMT MST MDT MWT MPT|6X.U 70 60 60 60|012121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFF0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5\",\"America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5\",\"America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5\",\"America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3\",\"America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5\",\"America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 4Q00 8mp0 8lz0 SN0 1cL0 pHB0 83r0 AU0 5MN0 1Rz0 38N0 Wn0 1qP0 11z0 1o10 11z0 3NA0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5\",\"America/Fort_Nelson|LMT PST PDT PWT PPT MST|8a.L 80 70 70 70 70|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121215|-3tofN.d 1nspN.d 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2\",\"America/Fort_Wayne|LMT CST CDT CWT CPT EST EDT|5I.C 60 50 50 50 50 40|0121212134121212121212121212151565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5\",\"America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3\",\"America/Godthab|LMT -03 -02 -01|3q.U 30 20 10|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e3\",\"America/Goose_Bay|LMT NST NDT NST NDT NWT NPT AST ADT ADDT|41.E 3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|0121343434343434356343434343434343434343434343434343434343437878787878787878787878787878787878787878787879787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-3tojW.k 1nspt.c 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2\",\"America/Grand_Turk|LMT KMT EST EDT AST|4I.w 57.a 50 40 40|01232323232323232323232323232323232323232323232323232323232323232323232323243232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLvf.s RK0m.C 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2\",\"America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5\",\"America/Guayaquil|LMT QMT -05 -04|5j.k 5e 50 40|01232|-3eLuE.E 1DNzS.E 2uILK rz0|27e5\",\"America/Guyana|LMT -04 -0345 -03|3Q.D 40 3J 30|01231|-2mf87.l 8Hc7.l 2r7bJ Ey0f|80e4\",\"America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4\",\"America/Havana|LMT HMT CST CDT|5t.s 5t.A 50 40|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLuu.w 1qx00.8 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5\",\"America/Hermosillo|LMT MST CST MDT|7n.Q 70 60 60|01213121313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0|64e4\",\"America/Indiana/Knox|LMT CST CDT CWT CPT EST|5K.u 60 50 50 50 50|01212134121212121212121212121212121212151212121212121212121212121212121212121212121212121252121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Marengo|LMT CST CDT CWT CPT EST EDT|5J.n 60 50 50 50 50 40|01212134121212121212121215656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Petersburg|LMT CST CDT CWT CPT EST EDT|5N.7 60 50 50 50 50 40|012121341212121212121212121215121212121212121212121252125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Tell_City|LMT CST CDT CWT CPT EST EDT|5L.3 60 50 50 50 50 40|012121341212121212121212121512165652121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vevay|LMT CST CDT CWT CPT EST EDT|5E.g 60 50 50 50 50 40|0121213415656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Vincennes|LMT CST CDT CWT CPT EST EDT|5O.7 60 50 50 50 50 40|012121341212121212121212121212121565652125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Indiana/Winamac|LMT CST CDT CWT CPT EST EDT|5K.p 60 50 50 50 50 40|012121341212121212121212121212121212121565652165656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Inuvik|-00 PST PDT MDT MST|0 80 70 60 70|01212121212121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-FnA0 L3K0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2\",\"America/Iqaluit|-00 EWT EPT EST EDT CST CDT|0 40 40 50 40 60 50|0123434343434343434343434343434343434343434343434343434343456343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-16K00 7nX0 iv0 14HB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2\",\"America/Jamaica|LMT KMT EST EDT|57.a 57.a 50 40|01232323232323232323232|-3eLuQ.O RK00 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4\",\"America/Juneau|LMT LMT PST PWT PPT PDT YDT YST AKST AKDT|-f2.j 8V.F 80 70 70 70 80 90 90 80|0123425252525252525252525252625252578989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVwq.s 1EX12.j 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3\",\"America/Kentucky/Louisville|LMT CST CDT CWT CPT EST EDT|5H.2 60 50 50 50 50 40|01212121213412121212121212121212121212565656565656525656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Kentucky/Monticello|LMT CST CDT CWT CPT EST EDT|5D.o 60 50 50 50 50 40|01212134121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFG0 1nEe0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/La_Paz|LMT CMT BST -04|4w.A 4w.A 3w.A 40|0123|-3eLvr.o 1FIo0 13b0|19e5\",\"America/Lima|LMT LMT -05 -04|58.c 58.A 50 40|01232323232323232|-3eLuP.M JcM0.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6\",\"America/Los_Angeles|LMT PST PDT PWT PPT|7Q.W 80 70 70 70|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFE0 1nEe0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6\",\"America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4\",\"America/Managua|LMT MMT CST EST CDT|5J.8 5J.c 60 50 50|01232424232324242|-3eLue.Q 1Mhc0.4 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5\",\"America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5\",\"America/Martinique|LMT FFMT AST ADT|44.k 44.k 40 30|01232|-3eLvT.E PTA0 2LPbT.E 19X0|39e4\",\"America/Matamoros|LMT CST CDT|6u 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4\",\"America/Mazatlan|LMT MST CST MDT|75.E 70 60 60|01213121313131313131313131313131313131313131313131313131313131|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 otX0 2bmP0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|44e4\",\"America/Menominee|LMT CST CDT CWT CPT EST|5O.r 60 50 50 50 50|012121341212152121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3pdG9.x 1jce9.x 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2\",\"America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131|-1UQG0 2q3C0 24n0 wG10 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|11e5\",\"America/Metlakatla|LMT LMT PST PWT PPT PDT AKST AKDT|-fd.G 8K.i 80 70 70 70 90 80|0123425252525252525252525252525252526767672676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwf.5 1EX1d.G 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2\",\"America/Mexico_City|LMT MST CST MDT CDT CWT|6A.A 70 60 60 50 50|012131242425242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|20e6\",\"America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mxUf.k 2LHcf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2\",\"America/Moncton|LMT EST AST ADT AWT APT|4j.8 50 40 30 30 30|0123232323232323232323245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3txvE.Q J4ME.Q CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3\",\"America/Monterrey|LMT MST CST MDT CDT|6F.g 70 60 60 50|012131242424242424242424242424242424242424242424242424242424242|-1UQG0 dep0 8lz0 16p0 11z0 1dd0 2gmp0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0|41e5\",\"America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5\",\"America/Toronto|LMT EST EDT EWT EPT|5h.w 50 40 40 40|012121212121212121212121212121212121212121212123412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-32B6G.s UFdG.s 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1qL0 11B0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5\",\"America/New_York|LMT EST EDT EWT EPT|4U.2 50 40 40 40|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tFH0 1nEe0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6\",\"America/Nome|LMT LMT NST NWT NPT BST BDT YST AKST AKDT|-cW.m b1.C b0 a0 a0 b0 a0 90 90 80|01234256565656565656565656565656565678989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898989898|-48Pzs.L 1jVyu.p 1EX1W.m 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2\",\"America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2\",\"America/North_Dakota/Beulah|LMT MST MDT MWT MPT CST CDT|6L.7 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/North_Dakota/Center|LMT MST MDT MWT MPT CST CDT|6J.c 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212125656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/North_Dakota/New_Salem|LMT MST MDT MWT MPT CST CDT|6J.D 70 60 60 60 60 50|0121213412121212121212121212121212121212121212121212121212121212121212121212121212565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tFF0 1nEe0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|\",\"America/Ojinaga|LMT MST CST MDT CDT|6V.E 70 60 60 50|0121312424231313131313131313131313131313131313131313131313132424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-1UQF0 deo0 8lz0 16p0 11z0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3\",\"America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4\",\"America/Port-au-Prince|LMT PPMT EST EDT|4N.k 4N 50 40|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3eLva.E 15RLX.E 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4\",\"America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4\",\"America/Punta_Arenas|LMT SMT -05 -04 -03|4H.E 4G.J 50 40 30|01213132323232323232343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvg.k MJbX.5 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|\",\"America/Winnipeg|LMT CST CDT CWT CPT|6s.A 60 50 50 50|0121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3kLtv.o 1a3bv.o WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4\",\"America/Rankin_Inlet|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-vDc0 Bjk0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2\",\"America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5\",\"America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4\",\"America/Resolute|-00 CST CDT EST|0 60 50 50|01212121212121212121212121212121212121212121212121212121212321212121212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-SnA0 103I0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229\",\"America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4\",\"America/Santiago|LMT SMT -05 -04 -03|4G.J 4G.J 50 40 30|0121313232323232323432343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLvh.f MJc0 fJAh.f 5knG.J 1Vzh.f jRAG.J 1pbh.f 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 hX0 1q10 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|62e5\",\"America/Santo_Domingo|LMT SDMT EST EDT -0430 AST|4D.A 4E 50 40 4u 40|012324242424242525|-3eLvk.o 1Jic0.o 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5\",\"America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6\",\"America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|012132323232323232323232323232323232323232323232323232323232323232323232323232323232323232121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|452\",\"America/Sitka|LMT LMT PST PWT PPT PDT YST AKST AKDT|-eW.L 91.d 80 70 70 70 90 90 80|0123425252525252525252525252525252567878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787878787|-48Pzs.L 1jVwu 1EX0W.L 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2\",\"America/St_Johns|LMT NST NDT NST NDT NWT NPT NDDT|3u.Q 3u.Q 2u.Q 3u 2u 2u 2u 1u|012121212121212121212121212121212121213434343434343435634343434343434343434343434343434343434343434343434343434343434343434343434343434343437343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tokt.8 1l020 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4\",\"America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3\",\"America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5\",\"America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656\",\"America/Vancouver|LMT PST PDT PWT PPT|8c.s 80 70 70 70|01213412121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3tofL.w 1nspL.w 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5\",\"America/Whitehorse|LMT YST YDT YWT YPT YDDT PST PDT MST|90.c 90 80 80 80 70 80 70 70|0121213415167676767676767676767676767676767676767676767676767676767676767676767676767676767678|-2MSeX.M GWpX.M 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 LA0 ytd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3\",\"America/Yakutat|LMT LMT YST YWT YPT YDT AKST AKDT|-eF.5 9i.T 90 80 80 80 90 80|0123425252525252525252525252525252526767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-48Pzs.L 1jVwL.G 1EX1F.5 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642\",\"Antarctica/Casey|-00 +08 +11|0 -80 -b0|012121212121212121|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01 14kX 1lf1 14kX 1lf1 13bX|10\",\"Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70\",\"Pacific/Port_Moresby|LMT PMMT +10|-9M.E -9M.w -a0|012|-3D8VM.E AvA0.8|25e4\",\"Antarctica/Macquarie|-00 AEST AEDT|0 -a0 -b0|0121012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2OPc0 Fb40 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|1\",\"Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60\",\"Pacific/Auckland|LMT NZMT NZST NZST NZDT|-bD.4 -bu -cu -c0 -d0|012131313131313131313131313134343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-46jLD.4 2nEO9.4 Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|14e5\",\"Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40\",\"Antarctica/Rothera|-00 -03|0 30|01|gOo0|130\",\"Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5\",\"Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|40\",\"Antarctica/Vostok|-00 +07 +05|0 -70 -50|01012|-tjA0 1rWh0 1Nj0 1aTv0|25\",\"Europe/Berlin|LMT CET CEST CEMT|-R.s -10 -20 -30|012121212121212321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36RcR.s UbWR.s 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e5\",\"Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|0123232323232323232323212323232323232323232323232321|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 L4m0|15e5\",\"Asia/Amman|LMT EET EEST +03|-2n.I -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 LA0 1C00|25e5\",\"Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3\",\"Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4\",\"Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4\",\"Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4\",\"Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|\",\"Asia/Baghdad|LMT BMT +03 +04|-2V.E -2V.A -30 -40|0123232323232323232323232323232323232323232323232323232|-3eLCV.E 18ao0.4 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5\",\"Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4\",\"Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Asia/Bangkok|LMT BMT +07|-6G.4 -6G.4 -70|012|-3D8SG.4 1C000|15e6\",\"Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|\",\"Asia/Beirut|LMT EET EEST|-2m -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3D8Om 1BWom 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|22e5\",\"Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4\",\"Asia/Brunei|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|42e4\",\"Asia/Kolkata|LMT HMT MMT IST +0630|-5R.s -5R.k -5l.a -5u -6u|01234343|-4Fg5R.s BKo0.8 1rDcw.a 1r2LP.a 1un0 HB0 7zX0|15e6\",\"Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4\",\"Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5\",\"Asia/Shanghai|LMT CST CDT|-85.H -80 -90|012121212121212121212121212121|-2M0U5.H Iuo5.H 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6\",\"Asia/Colombo|LMT MMT +0530 +06 +0630|-5j.o -5j.w -5u -60 -6u|012342432|-3D8Rj.o 13inX.Q 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5\",\"Asia/Dhaka|LMT HMT +0630 +0530 +06 +07|-61.E -5R.k -6u -5u -60 -70|01232454|-3eLG1.E 26008.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6\",\"Asia/Damascus|LMT EET EEST +03|-2p.c -20 -30 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212123|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0|26e5\",\"Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le80 1dnX0 1nfA0 Xld0|19e4\",\"Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5\",\"Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4\",\"Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|\",\"Asia/Gaza|LMT EET EEST IST IDT|-2h.Q -20 -30 -20 -30|0121212121212121212121212121212121234343434343434343434343434343431212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCh.Q 1Azeh.Q MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|18e5\",\"Asia/Hebron|LMT EET EEST IST IDT|-2k.n -20 -30 -20 -30|012121212121212121212121212121212123434343434343434343434343434343121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2MBCk.n 1Azek.n MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1lb0 14p0 1in0 17d0 1cL0 1cN0 19X0 1fB0 14n0 jB0 2L0 11B0 WL0 gN0 8n0 11B0 TX0 gN0 bb0 11B0 On0 jB0 dX0 11B0 Lz0 gN0 mn0 WN0 IL0 gN0 pb0 WN0 Db0 jB0 rX0 11B0 xz0 gN0 xz0 11B0 rX0 jB0 An0 11B0 pb0 gN0 IL0 WN0 mn0 gN0 Lz0 WN0 gL0 jB0 On0 11B0 bb0 gN0 TX0 11B0 5z0 jB0 WL0 11B0 2L0 jB0 11z0 1ip0 19X0 1cN0 1cL0 17d0 1in0 14p0 1lb0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1nX0 14p0 1in0 17d0 1fz0 1a10 19X0 1fB0 17b0 gN0 2L0 WN0 14n0 gN0 5z0 WN0 WL0 jB0 8n0 11B0 Rb0 gN0 dX0 11B0 Lz0 jB0 gL0 11B0 IL0 jB0 mn0 WN0 FX0 gN0 rX0 WN0 An0 jB0 uL0 11B0 uL0 gN0 An0 11B0 rX0 gN0 Db0 11B0 mn0 jB0 FX0 11B0 jz0 gN0 On0 WN0 dX0 jB0 Rb0 WN0 bb0 jB0 TX0 11B0 5z0 gN0 11z0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0|25e4\",\"Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.u -76.u -70 -80 -90|0123423232|-2yC76.u bK00 1h7b6.u 5lz0 18o0 3Oq0 k5c0 aVX0 BAM0|90e5\",\"Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5\",\"Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3\",\"Asia/Irkutsk|LMT IMT +07 +08 +09|-6V.5 -6V.5 -70 -80 -90|012343434343434343434343234343434343434343434343434343434343434343|-3D8SV.5 1Bxc0 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Europe/Istanbul|LMT IMT EET EEST +03 +04|-1T.Q -1U.U -20 -30 -30 -40|01232323232323232323232323232323232323232323232345423232323232323232323232323232323232323232323232323232323232323234|-3D8NT.Q 1ePXW.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6\",\"Asia/Jakarta|LMT BMT +0720 +0730 +09 +08 WIB|-77.c -77.c -7k -7u -90 -80 -70|012343536|-49jH7.c 2hiLL.c luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6\",\"Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4\",\"Asia/Jerusalem|LMT JMT IST IDT IDDT|-2k.S -2k.E -20 -30 -40|012323232323232432323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8Ok.S 1wvA0.e SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0|81e4\",\"Asia/Kabul|LMT +04 +0430|-4A.M -40 -4u|012|-3eLEA.M 2dTcA.M|46e5\",\"Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4\",\"Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6\",\"Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5\",\"Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5\",\"Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2\",\"Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5\",\"Asia/Kuala_Lumpur|LMT SMT +07 +0720 +0730 +09 +08|-6T.p -6T.p -70 -7k -7u -90 -80|01234546|-2M0ST.p aIM0 17anT.p l5XE 17bO 8Fyu 1so10|71e5\",\"Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4\",\"Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3\",\"Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5\",\"Asia/Manila|LMT LMT PST PDT JST|fU.8 -83.Q -80 -90 -90|012323432323232|-54m83.Q 2d8A3.Q 1urM0 un0 bW10 nb0 7qo0 1MM0 klB0 lz0 TwN0 1bb0 uNB0 rz0|24e6\",\"Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|32e4\",\"Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4\",\"Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5\",\"Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5\",\"Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4\",\"Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4\",\"Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5\",\"Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 Mv90|\",\"Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4\",\"Asia/Rangoon|LMT RMT +0630 +09|-6o.L -6o.L -6u -90|01232|-3D8So.L 1BnA0 SmnS.L 7j9u|48e5\",\"Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4\",\"Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4\",\"Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6\",\"Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2\",\"Asia/Taipei|LMT CST JST CDT|-86 -80 -90 -90|012131313131313131313131313131313131313131|-30bk6 1FDc6 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5\",\"Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5\",\"Asia/Tbilisi|LMT TBMT +03 +04 +05|-2X.b -2X.b -30 -40 -50|01234343434343434343434323232343434343434343434323|-3D8OX.b 1LUM0 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5\",\"Asia/Tehran|LMT TMT +0330 +0430 +04 +05|-3p.I -3p.I -3u -4u -40 -50|012345423232323232323232323232323232323232323232323232323232323232323232|-2btDp.I Llc0 1FHaT.I 1pc0 120u Rc0 Dc0 1iMu JX0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0|14e6\",\"Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3\",\"Asia/Tokyo|LMT JST JDT|-9i.X -90 -a0|0121212121|-3jE90 2qSo0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6\",\"Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5\",\"Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2\",\"Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4\",\"Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4\",\"Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5\",\"Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5\",\"Atlantic/Azores|LMT HMT -02 -01 +00 WET WEST|1G.E 1S.w 20 10 0 0 -10|012323232323232323232323232323232323232323232343234323432343232323232323232323232323232323232323232323434343434343434343434356434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3tomh.k 18aoh.k aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 CT90 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 Ap0 An0 wo0 Eo0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|25e4\",\"Atlantic/Bermuda|LMT BMT BST AST ADT|4j.i 4j.i 3j.i 40 30|0121213434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3eLvE.G 16mo0 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3\",\"Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4\",\"Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|49e3\",\"Atlantic/Madeira|LMT FMT -01 +00 +01 WET WEST|17.A 17.A 10 0 -10 0 -10|01232323232323232323232323232323232323232323234323432343234323232323232323232323232323232323232323232356565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-3tomQ.o 18anQ.o aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 BJ90 1a00 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e4\",\"Atlantic/South_Georgia|LMT -02|2q.8 20|01|-3eLxx.Q|30\",\"Atlantic/Stanley|LMT SMT -04 -03 -02|3P.o 3P.o 40 30 20|0123232323232323434323232323232323232323232323232323232323232323232323|-3eLw8.A S200 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2\",\"Australia/Sydney|LMT AEST AEDT|-a4.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oW4.Q RlC4.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|40e5\",\"Australia/Adelaide|LMT ACST ACST ACDT|-9e.k -90 -9u -au|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-32oVe.k ak0e.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|11e5\",\"Australia/Brisbane|LMT AEST AEDT|-ac.8 -a0 -b0|012121212121212121|-32Bmc.8 Ry2c.8 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5\",\"Australia/Broken_Hill|LMT AEST ACST ACST ACDT|-9p.M -a0 -90 -9u -au|0123434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-32oVp.M 3Lzp.M 6wp0 H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|18e3\",\"Australia/Hobart|LMT AEST AEDT|-9N.g -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-3109N.g Pk1N.g 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|21e4\",\"Australia/Darwin|LMT ACST ACST ACDT|-8H.k -90 -9u -au|01232323232|-32oUH.k ajXH.k H1Bu xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4\",\"Australia/Eucla|LMT +0845 +0945|-8z.s -8J -9J|01212121212121212121|-30nIz.s PkpO.s xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368\",\"Australia/Lord_Howe|LMT AEST +1030 +1130 +11|-aA.k -a0 -au -bu -b0|01232323232424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424|-32oWA.k 3tzAA.k 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu|347\",\"Australia/Lindeman|LMT AEST AEDT|-9T.U -a0 -b0|0121212121212121212121|-32BlT.U Ry1T.U xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10\",\"Australia/Melbourne|LMT AEST AEDT|-9D.Q -a0 -b0|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-32oVD.Q RlBD.Q xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|39e5\",\"Australia/Perth|LMT AWST AWDT|-7H.o -80 -90|01212121212121212121|-30nHH.o PkpH.o xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5\",\"Europe/Brussels|LMT BMT WET CET CEST WEST|-h.u -h.u 0 -10 -20 -10|012343434325252525252525252525252525252525252525252525434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8Mh.u u1Ah.u SO00 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|21e5\",\"Pacific/Easter|LMT EMT -07 -06 -05|7h.s 7h.s 70 60 50|0123232323232323232323232323234343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-3eLsG.w 1HRc0 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0|30e2\",\"Europe/Athens|LMT AMT EET EEST CEST CET|-1y.Q -1y.Q -20 -30 -20 -10|0123234545232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-30SNy.Q OMM1 CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|35e5\",\"Europe/Dublin|LMT DMT IST GMT BST IST|p.l p.l -y.D 0 -10 -10|012343434343435353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353535353|-3BHby.D 1ra20 Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Etc/GMT-0|GMT|0|0||\",\"Etc/GMT-1|+01|-10|0||\",\"Etc/GMT-10|+10|-a0|0||\",\"Etc/GMT-11|+11|-b0|0||\",\"Etc/GMT-12|+12|-c0|0||\",\"Etc/GMT-13|+13|-d0|0||\",\"Etc/GMT-14|+14|-e0|0||\",\"Etc/GMT-2|+02|-20|0||\",\"Etc/GMT-3|+03|-30|0||\",\"Etc/GMT-4|+04|-40|0||\",\"Etc/GMT-5|+05|-50|0||\",\"Etc/GMT-6|+06|-60|0||\",\"Etc/GMT-7|+07|-70|0||\",\"Etc/GMT-8|+08|-80|0||\",\"Etc/GMT-9|+09|-90|0||\",\"Etc/GMT+1|-01|10|0||\",\"Etc/GMT+10|-10|a0|0||\",\"Etc/GMT+11|-11|b0|0||\",\"Etc/GMT+12|-12|c0|0||\",\"Etc/GMT+2|-02|20|0||\",\"Etc/GMT+3|-03|30|0||\",\"Etc/GMT+4|-04|40|0||\",\"Etc/GMT+5|-05|50|0||\",\"Etc/GMT+6|-06|60|0||\",\"Etc/GMT+7|-07|70|0||\",\"Etc/GMT+8|-08|80|0||\",\"Etc/GMT+9|-09|90|0||\",\"Etc/UTC|UTC|0|0||\",\"Europe/Andorra|LMT WET CET CEST|-6.4 0 -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2M0M6.4 1Pnc6.4 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|79e3\",\"Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5\",\"Europe/London|LMT GMT BST BDST|1.f 0 -10 -20|01212121212121212121212121212121212121212121212121232323232321212321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-4VgnW.J 2KHdW.J Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|10e6\",\"Europe/Belgrade|LMT CET CEST|-1m -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3topm 2juLm 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Prague|LMT PMT CET CEST GMT|-V.I -V.I -10 -20 0|0123232323232323232423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4QbAV.I 1FDc0 XPaV.I 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|13e5\",\"Europe/Bucharest|LMT BMT EET EEST|-1I.o -1I.o -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3awpI.o 1AU00 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|19e5\",\"Europe/Budapest|LMT CET CEST|-1g.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-3cK1g.k 124Lg.k 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"Europe/Zurich|LMT BMT CET CEST|-y.8 -t.K -10 -20|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4HyMy.8 1Dw04.m 1SfAt.K 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|38e4\",\"Europe/Chisinau|LMT CMT BMT EET EEST CEST CET MSK MSD|-1T.k -1T -1I.o -20 -30 -20 -10 -30 -40|0123434343434343434345656578787878787878787878434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-3D8NT.k 1wNA0.k wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|67e4\",\"Europe/Gibraltar|LMT GMT BST BDST CET CEST|l.o 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123232323232121232121212121212121212145454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-3BHbC.A 1ra1C.A Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|30e3\",\"Europe/Helsinki|LMT HMT EET EEST|-1D.N -1D.N -20 -30|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3H0ND.N 1Iu00 OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Kaliningrad|LMT CET CEST EET EEST MSK MSD +03|-1m -10 -20 -20 -30 -30 -40 -30|012121212121212343565656565656565654343434343434343434343434343434343434343434373|-36Rdm UbXm 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4\",\"Europe/Kiev|LMT KMT EET MSK CEST CET MSD EEST|-22.4 -22.4 -20 -30 -20 -10 -40 -30|01234545363636363636363636367272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-3D8O2.4 1LUM0 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o10 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|34e5\",\"Europe/Kirov|LMT +03 +04 +05 MSD MSK MSK|-3i.M -30 -40 -50 -40 -30 -40|0123232323232323232454524545454545454545454545454545454545454565|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4\",\"Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121212124121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 M00 1vb0 SN0 1vb0 SN0 1vb0 Td0 1vb0 SN0 1vb0 6600 18o0 3I00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1uo0 1c00 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 oiK0 1cM0 1cM0 1fB0 1cM0 1cM0 1cM0 1fA0 1a00 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5\",\"Europe/Madrid|LMT WET WEST WEMT CET CEST|e.I 0 -10 -20 -10 -20|0121212121212121212321454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2M0M0 G5z0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|62e5\",\"Europe/Malta|LMT CET CEST|-W.4 -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-35rcW.4 SXzW.4 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Minsk|LMT MMT EET MSK CEST CET MSD EEST +03|-1O.g -1O -20 -30 -20 -10 -40 -30 -30|012345454363636363636363636372727272727272727272727272727272727272728|-3D8NO.g 1LUM0.g eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5\",\"Europe/Paris|LMT PMT WET WEST CEST CET WEMT|-9.l -9.l 0 -10 -20 -10 -20|01232323232323232323232323232323232323232323232323234545463654545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-3bQ09.l MDA0 cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|11e6\",\"Europe/Moscow|LMT MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|01232434565756865656565656565656565698656565656565656565656565656565656565656a6|-3D8Ou.h 1sQM0 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6\",\"Europe/Riga|LMT RMT LST EET MSK CEST CET MSD EEST|-1A.y -1A.y -2A.y -20 -30 -20 -10 -40 -30|0121213456565647474747474747474838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383838383|-3D8NA.y 1xde0 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|64e4\",\"Europe/Rome|LMT RMT CET CEST|-N.U -N.U -10 -20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-4aU0N.U 15snN.U T000 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|39e5\",\"Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5\",\"Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|\",\"Europe/Simferopol|LMT SMT EET MSK CEST CET MSD EEST MSK|-2g.o -2g -20 -30 -20 -10 -40 -30 -40|0123454543636363636363636363272727636363727272727272727272727272727272727283|-3D8Og.o 1LUM0.o eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eN0 1cM0 1cM0 1cM0 1cM0 dV0 WO0 1cM0 1cM0 1fy0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4\",\"Europe/Sofia|LMT IMT EET CET CEST EEST|-1x.g -1U.U -20 -10 -20 -30|0123434325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-3D8Nx.g AiLA.k 1UFeU.U WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|12e5\",\"Europe/Tallinn|LMT TMT CET CEST EET MSK MSD EEST|-1D -1D -10 -20 -20 -30 -40 -30|0123214532323565656565656565657474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474747474|-3D8ND 1wI00 teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|41e4\",\"Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|42e4\",\"Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5\",\"Europe/Vienna|LMT CET CEST|-15.l -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-36Rd5.l UbX5.l 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|18e5\",\"Europe/Vilnius|LMT WMT KMT CET EET MSK CEST MSD EEST|-1F.g -1o -1z.A -10 -20 -30 -20 -40 -30|0123435636365757575757575757584848484848484848463648484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484848484|-3D8NF.g 1u5Ah.g 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|54e4\",\"Europe/Volgograd|LMT +03 +04 +05 MSD MSK MSK|-2V.E -30 -40 -50 -40 -30 -40|012323232323232324545452454545454545454545454545454545454545456525|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1fA0 1cM0 2pz0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5\",\"Europe/Warsaw|LMT WMT CET CEST EET EEST|-1o -1o -10 -20 -20 -30|0123232345423232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-3D8No 1qDA0 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|17e5\",\"Pacific/Honolulu|LMT HST HDT HWT HPT HST|av.q au 9u 9u 9u a0|01213415|-3061s.y 1uMdW.y 8x0 lef0 8wWu iAu 46p0|37e4\",\"Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2\",\"Indian/Maldives|LMT MMT +05|-4S -4S -50|012|-3D8QS 3eLA0|35e4\",\"Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4\",\"Pacific/Kwajalein|LMT +11 +10 +09 -12 +12|-b9.k -b0 -a0 -90 c0 -c0|0123145|-2M0X9.k 1rDA9.k akp0 6Up0 12ry0 Wan0|14e3\",\"Pacific/Chatham|LMT +1215 +1245 +1345|-cd.M -cf -cJ -dJ|0123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-46jMd.M 37RbW.M 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00|600\",\"Pacific/Apia|LMT LMT -1130 -11 -10 +14 +13|-cx.4 bq.U bu b0 a0 -e0 -d0|012343456565656565656565656|-38Fox.4 J1A0 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0|37e3\",\"Pacific/Bougainville|LMT PMMT +10 +09 +11|-am.g -9M.w -a0 -90 -b0|012324|-3D8Wm.g AvAx.I 1TCLM.w 7CN0 2MQp0|18e4\",\"Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3\",\"Pacific/Enderbury|-00 -12 -11 +13|0 c0 b0 -d0|0123|-1iIo0 1GsA0 B7X0|1\",\"Pacific/Fakaofo|LMT -11 +13|bo.U b0 -d0|012|-2M0Az.4 4ufXz.4|483\",\"Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|012121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0|88e4\",\"Pacific/Tarawa|LMT +12|-bw.4 -c0|01|-2M0Xw.4|29e3\",\"Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3\",\"Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125\",\"Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4\",\"Pacific/Guam|LMT LMT GST +09 GDT ChST|el -9D -a0 -90 -b0 -a0|0123242424242424242425|-54m9D 2glc0 1DFbD 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4\",\"Pacific/Kiritimati|LMT -1040 -10 +14|at.k aE a0 -e0|0123|-2M0Bu.E 3bIMa.E B7Xk|51e2\",\"Pacific/Kosrae|LMT LMT +11 +09 +10 +12|d8.4 -aP.U -b0 -90 -a0 -c0|0123243252|-54maP.U 2glc0 xsnP.U axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2\",\"Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2\",\"Pacific/Pago_Pago|LMT LMT SST|-cB.c bm.M b0|012|-38FoB.c J1A0|37e2\",\"Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3\",\"Pacific/Niue|LMT -1120 -11|bj.E bk b0|012|-FScE.k suo0.k|12e2\",\"Pacific/Norfolk|LMT +1112 +1130 +1230 +11 +12|-bb.Q -bc -bu -cu -b0 -c0|0123245454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2M0Xb.Q 21ILX.Q W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0|25e4\",\"Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3\",\"Pacific/Palau|LMT LMT +09|f2.4 -8V.U -90|012|-54m8V.U 2glc0|21e3\",\"Pacific/Pitcairn|LMT -0830 -08|8E.k 8u 80|012|-2M0Dj.E 3UVXN.E|56\",\"Pacific/Rarotonga|LMT LMT -1030 -0930 -10|-dk.U aD.4 au 9u a0|01234343434343434343434343434|-2Otpk.U 28zc0 13tbO.U IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3\",\"Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4\",\"Pacific/Tongatapu|LMT +1220 +13 +14|-cj.c -ck -d0 -e0|01232323232|-XbMj.c BgLX.c 1yndk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3\"],\"links\":[\"Africa/Abidjan|Africa/Accra\",\"Africa/Abidjan|Africa/Bamako\",\"Africa/Abidjan|Africa/Banjul\",\"Africa/Abidjan|Africa/Conakry\",\"Africa/Abidjan|Africa/Dakar\",\"Africa/Abidjan|Africa/Freetown\",\"Africa/Abidjan|Africa/Lome\",\"Africa/Abidjan|Africa/Nouakchott\",\"Africa/Abidjan|Africa/Ouagadougou\",\"Africa/Abidjan|Africa/Timbuktu\",\"Africa/Abidjan|Atlantic/Reykjavik\",\"Africa/Abidjan|Atlantic/St_Helena\",\"Africa/Abidjan|Iceland\",\"Africa/Cairo|Egypt\",\"Africa/Johannesburg|Africa/Maseru\",\"Africa/Johannesburg|Africa/Mbabane\",\"Africa/Lagos|Africa/Bangui\",\"Africa/Lagos|Africa/Brazzaville\",\"Africa/Lagos|Africa/Douala\",\"Africa/Lagos|Africa/Kinshasa\",\"Africa/Lagos|Africa/Libreville\",\"Africa/Lagos|Africa/Luanda\",\"Africa/Lagos|Africa/Malabo\",\"Africa/Lagos|Africa/Niamey\",\"Africa/Lagos|Africa/Porto-Novo\",\"Africa/Maputo|Africa/Blantyre\",\"Africa/Maputo|Africa/Bujumbura\",\"Africa/Maputo|Africa/Gaborone\",\"Africa/Maputo|Africa/Harare\",\"Africa/Maputo|Africa/Kigali\",\"Africa/Maputo|Africa/Lubumbashi\",\"Africa/Maputo|Africa/Lusaka\",\"Africa/Nairobi|Africa/Addis_Ababa\",\"Africa/Nairobi|Africa/Asmara\",\"Africa/Nairobi|Africa/Asmera\",\"Africa/Nairobi|Africa/Dar_es_Salaam\",\"Africa/Nairobi|Africa/Djibouti\",\"Africa/Nairobi|Africa/Kampala\",\"Africa/Nairobi|Africa/Mogadishu\",\"Africa/Nairobi|Indian/Antananarivo\",\"Africa/Nairobi|Indian/Comoro\",\"Africa/Nairobi|Indian/Mayotte\",\"Africa/Tripoli|Libya\",\"America/Adak|America/Atka\",\"America/Adak|US/Aleutian\",\"America/Anchorage|US/Alaska\",\"America/Argentina/Buenos_Aires|America/Buenos_Aires\",\"America/Argentina/Catamarca|America/Argentina/ComodRivadavia\",\"America/Argentina/Catamarca|America/Catamarca\",\"America/Argentina/Cordoba|America/Cordoba\",\"America/Argentina/Cordoba|America/Rosario\",\"America/Argentina/Jujuy|America/Jujuy\",\"America/Argentina/Mendoza|America/Mendoza\",\"America/Chicago|CST6CDT\",\"America/Chicago|US/Central\",\"America/Denver|America/Shiprock\",\"America/Denver|MST7MDT\",\"America/Denver|Navajo\",\"America/Denver|US/Mountain\",\"America/Detroit|US/Michigan\",\"America/Edmonton|America/Yellowknife\",\"America/Edmonton|Canada/Mountain\",\"America/Fort_Wayne|America/Indiana/Indianapolis\",\"America/Fort_Wayne|America/Indianapolis\",\"America/Fort_Wayne|US/East-Indiana\",\"America/Godthab|America/Nuuk\",\"America/Halifax|Canada/Atlantic\",\"America/Havana|Cuba\",\"America/Indiana/Knox|America/Knox_IN\",\"America/Indiana/Knox|US/Indiana-Starke\",\"America/Iqaluit|America/Pangnirtung\",\"America/Jamaica|Jamaica\",\"America/Kentucky/Louisville|America/Louisville\",\"America/Los_Angeles|PST8PDT\",\"America/Los_Angeles|US/Pacific\",\"America/Manaus|Brazil/West\",\"America/Mazatlan|Mexico/BajaSur\",\"America/Mexico_City|Mexico/General\",\"America/New_York|EST5EDT\",\"America/New_York|US/Eastern\",\"America/Noronha|Brazil/DeNoronha\",\"America/Panama|America/Atikokan\",\"America/Panama|America/Cayman\",\"America/Panama|America/Coral_Harbour\",\"America/Panama|EST\",\"America/Phoenix|America/Creston\",\"America/Phoenix|MST\",\"America/Phoenix|US/Arizona\",\"America/Puerto_Rico|America/Anguilla\",\"America/Puerto_Rico|America/Antigua\",\"America/Puerto_Rico|America/Aruba\",\"America/Puerto_Rico|America/Blanc-Sablon\",\"America/Puerto_Rico|America/Curacao\",\"America/Puerto_Rico|America/Dominica\",\"America/Puerto_Rico|America/Grenada\",\"America/Puerto_Rico|America/Guadeloupe\",\"America/Puerto_Rico|America/Kralendijk\",\"America/Puerto_Rico|America/Lower_Princes\",\"America/Puerto_Rico|America/Marigot\",\"America/Puerto_Rico|America/Montserrat\",\"America/Puerto_Rico|America/Port_of_Spain\",\"America/Puerto_Rico|America/St_Barthelemy\",\"America/Puerto_Rico|America/St_Kitts\",\"America/Puerto_Rico|America/St_Lucia\",\"America/Puerto_Rico|America/St_Thomas\",\"America/Puerto_Rico|America/St_Vincent\",\"America/Puerto_Rico|America/Tortola\",\"America/Puerto_Rico|America/Virgin\",\"America/Regina|Canada/Saskatchewan\",\"America/Rio_Branco|America/Porto_Acre\",\"America/Rio_Branco|Brazil/Acre\",\"America/Santiago|Chile/Continental\",\"America/Sao_Paulo|Brazil/East\",\"America/St_Johns|Canada/Newfoundland\",\"America/Tijuana|America/Ensenada\",\"America/Tijuana|America/Santa_Isabel\",\"America/Tijuana|Mexico/BajaNorte\",\"America/Toronto|America/Montreal\",\"America/Toronto|America/Nassau\",\"America/Toronto|America/Nipigon\",\"America/Toronto|America/Thunder_Bay\",\"America/Toronto|Canada/Eastern\",\"America/Vancouver|Canada/Pacific\",\"America/Whitehorse|Canada/Yukon\",\"America/Winnipeg|America/Rainy_River\",\"America/Winnipeg|Canada/Central\",\"Asia/Ashgabat|Asia/Ashkhabad\",\"Asia/Bangkok|Asia/Phnom_Penh\",\"Asia/Bangkok|Asia/Vientiane\",\"Asia/Bangkok|Indian/Christmas\",\"Asia/Brunei|Asia/Kuching\",\"Asia/Dhaka|Asia/Dacca\",\"Asia/Dubai|Asia/Muscat\",\"Asia/Dubai|Indian/Mahe\",\"Asia/Dubai|Indian/Reunion\",\"Asia/Ho_Chi_Minh|Asia/Saigon\",\"Asia/Hong_Kong|Hongkong\",\"Asia/Jerusalem|Asia/Tel_Aviv\",\"Asia/Jerusalem|Israel\",\"Asia/Kathmandu|Asia/Katmandu\",\"Asia/Kolkata|Asia/Calcutta\",\"Asia/Kuala_Lumpur|Asia/Singapore\",\"Asia/Kuala_Lumpur|Singapore\",\"Asia/Macau|Asia/Macao\",\"Asia/Makassar|Asia/Ujung_Pandang\",\"Asia/Nicosia|Europe/Nicosia\",\"Asia/Qatar|Asia/Bahrain\",\"Asia/Rangoon|Asia/Yangon\",\"Asia/Rangoon|Indian/Cocos\",\"Asia/Riyadh|Antarctica/Syowa\",\"Asia/Riyadh|Asia/Aden\",\"Asia/Riyadh|Asia/Kuwait\",\"Asia/Seoul|ROK\",\"Asia/Shanghai|Asia/Chongqing\",\"Asia/Shanghai|Asia/Chungking\",\"Asia/Shanghai|Asia/Harbin\",\"Asia/Shanghai|PRC\",\"Asia/Taipei|ROC\",\"Asia/Tehran|Iran\",\"Asia/Thimphu|Asia/Thimbu\",\"Asia/Tokyo|Japan\",\"Asia/Ulaanbaatar|Asia/Choibalsan\",\"Asia/Ulaanbaatar|Asia/Ulan_Bator\",\"Asia/Urumqi|Asia/Kashgar\",\"Atlantic/Faroe|Atlantic/Faeroe\",\"Australia/Adelaide|Australia/South\",\"Australia/Brisbane|Australia/Queensland\",\"Australia/Broken_Hill|Australia/Yancowinna\",\"Australia/Darwin|Australia/North\",\"Australia/Hobart|Australia/Currie\",\"Australia/Hobart|Australia/Tasmania\",\"Australia/Lord_Howe|Australia/LHI\",\"Australia/Melbourne|Australia/Victoria\",\"Australia/Perth|Australia/West\",\"Australia/Sydney|Australia/ACT\",\"Australia/Sydney|Australia/Canberra\",\"Australia/Sydney|Australia/NSW\",\"Etc/GMT-0|Etc/GMT\",\"Etc/GMT-0|Etc/GMT+0\",\"Etc/GMT-0|Etc/GMT0\",\"Etc/GMT-0|Etc/Greenwich\",\"Etc/GMT-0|GMT\",\"Etc/GMT-0|GMT+0\",\"Etc/GMT-0|GMT-0\",\"Etc/GMT-0|GMT0\",\"Etc/GMT-0|Greenwich\",\"Etc/UTC|Etc/UCT\",\"Etc/UTC|Etc/Universal\",\"Etc/UTC|Etc/Zulu\",\"Etc/UTC|UCT\",\"Etc/UTC|UTC\",\"Etc/UTC|Universal\",\"Etc/UTC|Zulu\",\"Europe/Athens|EET\",\"Europe/Belgrade|Europe/Ljubljana\",\"Europe/Belgrade|Europe/Podgorica\",\"Europe/Belgrade|Europe/Sarajevo\",\"Europe/Belgrade|Europe/Skopje\",\"Europe/Belgrade|Europe/Zagreb\",\"Europe/Berlin|Arctic/Longyearbyen\",\"Europe/Berlin|Atlantic/Jan_Mayen\",\"Europe/Berlin|Europe/Copenhagen\",\"Europe/Berlin|Europe/Oslo\",\"Europe/Berlin|Europe/Stockholm\",\"Europe/Brussels|CET\",\"Europe/Brussels|Europe/Amsterdam\",\"Europe/Brussels|Europe/Luxembourg\",\"Europe/Brussels|MET\",\"Europe/Chisinau|Europe/Tiraspol\",\"Europe/Dublin|Eire\",\"Europe/Helsinki|Europe/Mariehamn\",\"Europe/Istanbul|Asia/Istanbul\",\"Europe/Istanbul|Turkey\",\"Europe/Kiev|Europe/Kyiv\",\"Europe/Kiev|Europe/Uzhgorod\",\"Europe/Kiev|Europe/Zaporozhye\",\"Europe/Lisbon|Portugal\",\"Europe/Lisbon|WET\",\"Europe/London|Europe/Belfast\",\"Europe/London|Europe/Guernsey\",\"Europe/London|Europe/Isle_of_Man\",\"Europe/London|Europe/Jersey\",\"Europe/London|GB\",\"Europe/London|GB-Eire\",\"Europe/Moscow|W-SU\",\"Europe/Paris|Europe/Monaco\",\"Europe/Prague|Europe/Bratislava\",\"Europe/Rome|Europe/San_Marino\",\"Europe/Rome|Europe/Vatican\",\"Europe/Warsaw|Poland\",\"Europe/Zurich|Europe/Busingen\",\"Europe/Zurich|Europe/Vaduz\",\"Indian/Maldives|Indian/Kerguelen\",\"Pacific/Auckland|Antarctica/McMurdo\",\"Pacific/Auckland|Antarctica/South_Pole\",\"Pacific/Auckland|NZ\",\"Pacific/Chatham|NZ-CHAT\",\"Pacific/Easter|Chile/EasterIsland\",\"Pacific/Enderbury|Pacific/Kanton\",\"Pacific/Guadalcanal|Pacific/Pohnpei\",\"Pacific/Guadalcanal|Pacific/Ponape\",\"Pacific/Guam|Pacific/Saipan\",\"Pacific/Honolulu|HST\",\"Pacific/Honolulu|Pacific/Johnston\",\"Pacific/Honolulu|US/Hawaii\",\"Pacific/Kwajalein|Kwajalein\",\"Pacific/Pago_Pago|Pacific/Midway\",\"Pacific/Pago_Pago|Pacific/Samoa\",\"Pacific/Pago_Pago|US/Samoa\",\"Pacific/Port_Moresby|Antarctica/DumontDUrville\",\"Pacific/Port_Moresby|Pacific/Chuuk\",\"Pacific/Port_Moresby|Pacific/Truk\",\"Pacific/Port_Moresby|Pacific/Yap\",\"Pacific/Tarawa|Pacific/Funafuti\",\"Pacific/Tarawa|Pacific/Majuro\",\"Pacific/Tarawa|Pacific/Wake\",\"Pacific/Tarawa|Pacific/Wallis\"],\"countries\":[\"AD|Europe/Andorra\",\"AE|Asia/Dubai\",\"AF|Asia/Kabul\",\"AG|America/Puerto_Rico America/Antigua\",\"AI|America/Puerto_Rico America/Anguilla\",\"AL|Europe/Tirane\",\"AM|Asia/Yerevan\",\"AO|Africa/Lagos Africa/Luanda\",\"AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa\",\"AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia\",\"AS|Pacific/Pago_Pago\",\"AT|Europe/Vienna\",\"AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo\",\"AW|America/Puerto_Rico America/Aruba\",\"AX|Europe/Helsinki Europe/Mariehamn\",\"AZ|Asia/Baku\",\"BA|Europe/Belgrade Europe/Sarajevo\",\"BB|America/Barbados\",\"BD|Asia/Dhaka\",\"BE|Europe/Brussels\",\"BF|Africa/Abidjan Africa/Ouagadougou\",\"BG|Europe/Sofia\",\"BH|Asia/Qatar Asia/Bahrain\",\"BI|Africa/Maputo Africa/Bujumbura\",\"BJ|Africa/Lagos Africa/Porto-Novo\",\"BL|America/Puerto_Rico America/St_Barthelemy\",\"BM|Atlantic/Bermuda\",\"BN|Asia/Kuching Asia/Brunei\",\"BO|America/La_Paz\",\"BQ|America/Puerto_Rico America/Kralendijk\",\"BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco\",\"BS|America/Toronto America/Nassau\",\"BT|Asia/Thimphu\",\"BW|Africa/Maputo Africa/Gaborone\",\"BY|Europe/Minsk\",\"BZ|America/Belize\",\"CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston\",\"CC|Asia/Yangon Indian/Cocos\",\"CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi\",\"CF|Africa/Lagos Africa/Bangui\",\"CG|Africa/Lagos Africa/Brazzaville\",\"CH|Europe/Zurich\",\"CI|Africa/Abidjan\",\"CK|Pacific/Rarotonga\",\"CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter\",\"CM|Africa/Lagos Africa/Douala\",\"CN|Asia/Shanghai Asia/Urumqi\",\"CO|America/Bogota\",\"CR|America/Costa_Rica\",\"CU|America/Havana\",\"CV|Atlantic/Cape_Verde\",\"CW|America/Puerto_Rico America/Curacao\",\"CX|Asia/Bangkok Indian/Christmas\",\"CY|Asia/Nicosia Asia/Famagusta\",\"CZ|Europe/Prague\",\"DE|Europe/Zurich Europe/Berlin Europe/Busingen\",\"DJ|Africa/Nairobi Africa/Djibouti\",\"DK|Europe/Berlin Europe/Copenhagen\",\"DM|America/Puerto_Rico America/Dominica\",\"DO|America/Santo_Domingo\",\"DZ|Africa/Algiers\",\"EC|America/Guayaquil Pacific/Galapagos\",\"EE|Europe/Tallinn\",\"EG|Africa/Cairo\",\"EH|Africa/El_Aaiun\",\"ER|Africa/Nairobi Africa/Asmara\",\"ES|Europe/Madrid Africa/Ceuta Atlantic/Canary\",\"ET|Africa/Nairobi Africa/Addis_Ababa\",\"FI|Europe/Helsinki\",\"FJ|Pacific/Fiji\",\"FK|Atlantic/Stanley\",\"FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei\",\"FO|Atlantic/Faroe\",\"FR|Europe/Paris\",\"GA|Africa/Lagos Africa/Libreville\",\"GB|Europe/London\",\"GD|America/Puerto_Rico America/Grenada\",\"GE|Asia/Tbilisi\",\"GF|America/Cayenne\",\"GG|Europe/London Europe/Guernsey\",\"GH|Africa/Abidjan Africa/Accra\",\"GI|Europe/Gibraltar\",\"GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule\",\"GM|Africa/Abidjan Africa/Banjul\",\"GN|Africa/Abidjan Africa/Conakry\",\"GP|America/Puerto_Rico America/Guadeloupe\",\"GQ|Africa/Lagos Africa/Malabo\",\"GR|Europe/Athens\",\"GS|Atlantic/South_Georgia\",\"GT|America/Guatemala\",\"GU|Pacific/Guam\",\"GW|Africa/Bissau\",\"GY|America/Guyana\",\"HK|Asia/Hong_Kong\",\"HN|America/Tegucigalpa\",\"HR|Europe/Belgrade Europe/Zagreb\",\"HT|America/Port-au-Prince\",\"HU|Europe/Budapest\",\"ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura\",\"IE|Europe/Dublin\",\"IL|Asia/Jerusalem\",\"IM|Europe/London Europe/Isle_of_Man\",\"IN|Asia/Kolkata\",\"IO|Indian/Chagos\",\"IQ|Asia/Baghdad\",\"IR|Asia/Tehran\",\"IS|Africa/Abidjan Atlantic/Reykjavik\",\"IT|Europe/Rome\",\"JE|Europe/London Europe/Jersey\",\"JM|America/Jamaica\",\"JO|Asia/Amman\",\"JP|Asia/Tokyo\",\"KE|Africa/Nairobi\",\"KG|Asia/Bishkek\",\"KH|Asia/Bangkok Asia/Phnom_Penh\",\"KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati\",\"KM|Africa/Nairobi Indian/Comoro\",\"KN|America/Puerto_Rico America/St_Kitts\",\"KP|Asia/Pyongyang\",\"KR|Asia/Seoul\",\"KW|Asia/Riyadh Asia/Kuwait\",\"KY|America/Panama America/Cayman\",\"KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral\",\"LA|Asia/Bangkok Asia/Vientiane\",\"LB|Asia/Beirut\",\"LC|America/Puerto_Rico America/St_Lucia\",\"LI|Europe/Zurich Europe/Vaduz\",\"LK|Asia/Colombo\",\"LR|Africa/Monrovia\",\"LS|Africa/Johannesburg Africa/Maseru\",\"LT|Europe/Vilnius\",\"LU|Europe/Brussels Europe/Luxembourg\",\"LV|Europe/Riga\",\"LY|Africa/Tripoli\",\"MA|Africa/Casablanca\",\"MC|Europe/Paris Europe/Monaco\",\"MD|Europe/Chisinau\",\"ME|Europe/Belgrade Europe/Podgorica\",\"MF|America/Puerto_Rico America/Marigot\",\"MG|Africa/Nairobi Indian/Antananarivo\",\"MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro\",\"MK|Europe/Belgrade Europe/Skopje\",\"ML|Africa/Abidjan Africa/Bamako\",\"MM|Asia/Yangon\",\"MN|Asia/Ulaanbaatar Asia/Hovd\",\"MO|Asia/Macau\",\"MP|Pacific/Guam Pacific/Saipan\",\"MQ|America/Martinique\",\"MR|Africa/Abidjan Africa/Nouakchott\",\"MS|America/Puerto_Rico America/Montserrat\",\"MT|Europe/Malta\",\"MU|Indian/Mauritius\",\"MV|Indian/Maldives\",\"MW|Africa/Maputo Africa/Blantyre\",\"MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana\",\"MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur\",\"MZ|Africa/Maputo\",\"NA|Africa/Windhoek\",\"NC|Pacific/Noumea\",\"NE|Africa/Lagos Africa/Niamey\",\"NF|Pacific/Norfolk\",\"NG|Africa/Lagos\",\"NI|America/Managua\",\"NL|Europe/Brussels Europe/Amsterdam\",\"NO|Europe/Berlin Europe/Oslo\",\"NP|Asia/Kathmandu\",\"NR|Pacific/Nauru\",\"NU|Pacific/Niue\",\"NZ|Pacific/Auckland Pacific/Chatham\",\"OM|Asia/Dubai Asia/Muscat\",\"PA|America/Panama\",\"PE|America/Lima\",\"PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier\",\"PG|Pacific/Port_Moresby Pacific/Bougainville\",\"PH|Asia/Manila\",\"PK|Asia/Karachi\",\"PL|Europe/Warsaw\",\"PM|America/Miquelon\",\"PN|Pacific/Pitcairn\",\"PR|America/Puerto_Rico\",\"PS|Asia/Gaza Asia/Hebron\",\"PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores\",\"PW|Pacific/Palau\",\"PY|America/Asuncion\",\"QA|Asia/Qatar\",\"RE|Asia/Dubai Indian/Reunion\",\"RO|Europe/Bucharest\",\"RS|Europe/Belgrade\",\"RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr\",\"RW|Africa/Maputo Africa/Kigali\",\"SA|Asia/Riyadh\",\"SB|Pacific/Guadalcanal\",\"SC|Asia/Dubai Indian/Mahe\",\"SD|Africa/Khartoum\",\"SE|Europe/Berlin Europe/Stockholm\",\"SG|Asia/Singapore\",\"SH|Africa/Abidjan Atlantic/St_Helena\",\"SI|Europe/Belgrade Europe/Ljubljana\",\"SJ|Europe/Berlin Arctic/Longyearbyen\",\"SK|Europe/Prague Europe/Bratislava\",\"SL|Africa/Abidjan Africa/Freetown\",\"SM|Europe/Rome Europe/San_Marino\",\"SN|Africa/Abidjan Africa/Dakar\",\"SO|Africa/Nairobi Africa/Mogadishu\",\"SR|America/Paramaribo\",\"SS|Africa/Juba\",\"ST|Africa/Sao_Tome\",\"SV|America/El_Salvador\",\"SX|America/Puerto_Rico America/Lower_Princes\",\"SY|Asia/Damascus\",\"SZ|Africa/Johannesburg Africa/Mbabane\",\"TC|America/Grand_Turk\",\"TD|Africa/Ndjamena\",\"TF|Asia/Dubai Indian/Maldives Indian/Kerguelen\",\"TG|Africa/Abidjan Africa/Lome\",\"TH|Asia/Bangkok\",\"TJ|Asia/Dushanbe\",\"TK|Pacific/Fakaofo\",\"TL|Asia/Dili\",\"TM|Asia/Ashgabat\",\"TN|Africa/Tunis\",\"TO|Pacific/Tongatapu\",\"TR|Europe/Istanbul\",\"TT|America/Puerto_Rico America/Port_of_Spain\",\"TV|Pacific/Tarawa Pacific/Funafuti\",\"TW|Asia/Taipei\",\"TZ|Africa/Nairobi Africa/Dar_es_Salaam\",\"UA|Europe/Simferopol Europe/Kyiv\",\"UG|Africa/Nairobi Africa/Kampala\",\"UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake\",\"US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu\",\"UY|America/Montevideo\",\"UZ|Asia/Samarkand Asia/Tashkent\",\"VA|Europe/Rome Europe/Vatican\",\"VC|America/Puerto_Rico America/St_Vincent\",\"VE|America/Caracas\",\"VG|America/Puerto_Rico America/Tortola\",\"VI|America/Puerto_Rico America/St_Thomas\",\"VN|Asia/Bangkok Asia/Ho_Chi_Minh\",\"VU|Pacific/Efate\",\"WF|Pacific/Tarawa Pacific/Wallis\",\"WS|Pacific/Apia\",\"YE|Asia/Riyadh Asia/Aden\",\"YT|Africa/Nairobi Indian/Mayotte\",\"ZA|Africa/Johannesburg\",\"ZM|Africa/Maputo Africa/Lusaka\",\"ZW|Africa/Maputo Africa/Harare\"]}");

});

parcelRegister("lS2PV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Groups an array by a specified key.
 * @param array - The array to group.
 * @param key - The key to group the array by.
 * @returns An object where each key is a unique value from the array, and each value is an array of items from the original array that match the key.
 */ function $fec0d7616ff081ba$var$groupBy(array, key) {
    return array.reduce((result, item)=>{
        const groupKey = String(item[key]);
        if (!result[groupKey]) result[groupKey] = [];
        result[groupKey].push(item);
        return result;
    }, {});
}
module.exports.default = $fec0d7616ff081ba$var$groupBy;

});

parcelRegister("eUVR3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
/**
 * Replaces placeholders in a string with values from an object.
 * @param template - The string containing placeholders.
 * @param data - The object containing key-value pairs for replacement.
 * @returns The string with placeholders replaced by values.
 */ function $adc32c625180774e$var$supplant(template, data) {
    return template.replace(/{([^{}]*)}/g, (match, key)=>{
        const value = data[key];
        return typeof value === "string" || typeof value === "number" ? value.toString() : match;
    });
}
module.exports.default = $adc32c625180774e$var$supplant;

});

parcelRegister("eOcqU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $ac7f6122ba3ba1ce$var$countriesData = [
    {
        countryNameEn: "Andorra",
        countryNameLocal: "Andorra",
        countryCode: "AD",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ca",
        officialLanguageNameEn: "Catalan, Valencian",
        officialLanguageNameLocal: "Catal\xe0, Valenci\xe0",
        countryCallingCode: "376",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDE9"
    },
    {
        countryNameEn: "Afghanistan",
        countryNameLocal: "\u062F \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646 \u0627\u0633\u0644\u0627\u0645\u064A \u062F\u0648\u0644\u062A\u062F\u0648\u0644\u062A \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646, \u062C\u0645\u0647\u0648\u0631\u06CC \u0627\u0633\u0644\u0627\u0645\u06CC \u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646",
        countryCode: "AF",
        currencyCode: "AFN",
        currencyNameEn: "Afghan afghani",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fa",
        officialLanguageNameEn: "Persian",
        officialLanguageNameLocal: "\u0641\u0627\u0631\u0633\u06CC",
        countryCallingCode: "93",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDEB"
    },
    {
        countryNameEn: "Antigua and Barbuda",
        countryNameLocal: "Antigua and Barbuda",
        countryCode: "AG",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1268",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDEC"
    },
    {
        countryNameEn: "Anguilla",
        countryNameLocal: "Anguilla",
        countryCode: "AI",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1264",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDEE"
    },
    {
        countryNameEn: "Albania",
        countryNameLocal: "Shqip\xebria",
        countryCode: "AL",
        currencyCode: "ALL",
        currencyNameEn: "Albanian lek",
        tinType: "NIPT",
        tinName: "Numri i Identifikimit p\xebr Personin e Tatuesh\xebm",
        officialLanguageCode: "sq",
        officialLanguageNameEn: "Albanian",
        officialLanguageNameLocal: "Shqip",
        countryCallingCode: "355",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDF1"
    },
    {
        countryNameEn: "Armenia",
        countryNameLocal: "\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576",
        countryCode: "AM",
        currencyCode: "AMD",
        currencyNameEn: "Armenian dram",
        tinType: "",
        tinName: "",
        officialLanguageCode: "hy",
        officialLanguageNameEn: "Armenian",
        officialLanguageNameLocal: "\u0540\u0561\u0575\u0565\u0580\u0565\u0576",
        countryCallingCode: "374",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDF2"
    },
    {
        countryNameEn: "Angola",
        countryNameLocal: "Angola",
        countryCode: "AO",
        currencyCode: "AOA",
        currencyNameEn: "Angolan kwanza",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "244",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE6\uD83C\uDDF4"
    },
    {
        countryNameEn: "Antarctica",
        countryNameLocal: "Antarctica, Ant\xe1rtico, Antarctique, \u0410\u043D\u0442\u0430\u0440\u043A\u0442\u0438\u043A\u0435",
        countryCode: "AQ",
        currencyCode: "",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDF6"
    },
    {
        countryNameEn: "Argentina",
        countryNameLocal: "Argentina",
        countryCode: "AR",
        currencyCode: "ARS",
        currencyNameEn: "Argentine peso",
        tinType: "CUIT",
        tinName: "C\xf3digo \xdanico de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "54",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDF7"
    },
    {
        countryNameEn: "American Samoa",
        countryNameLocal: "American Samoa",
        countryCode: "AS",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1684",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDF8"
    },
    {
        countryNameEn: "Austria",
        countryNameLocal: "\xd6sterreich",
        countryCode: "AT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "UID",
        tinName: "Umsatzsteuer-Identifikationsnummer",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "43",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDF9"
    },
    {
        countryNameEn: "Australia",
        countryNameLocal: "Australia",
        countryCode: "AU",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "ABN",
        tinName: "Australian Business Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "61",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDFA"
    },
    {
        countryNameEn: "Aruba",
        countryNameLocal: "Aruba",
        countryCode: "AW",
        currencyCode: "AWG",
        currencyNameEn: "Aruban florin",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "297",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE6\uD83C\uDDFC"
    },
    {
        countryNameEn: "\xc5land Islands",
        countryNameLocal: "\xc5land",
        countryCode: "AX",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sv",
        officialLanguageNameEn: "Swedish",
        officialLanguageNameLocal: "Svenska",
        countryCallingCode: "358",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE6\uD83C\uDDFD"
    },
    {
        countryNameEn: "Azerbaijan",
        countryNameLocal: "Az\u0259rbaycan",
        countryCode: "AZ",
        currencyCode: "AZN",
        currencyNameEn: "Azerbaijani manat",
        tinType: "",
        tinName: "",
        officialLanguageCode: "az",
        officialLanguageNameEn: "Azerbaijani",
        officialLanguageNameLocal: "az\u0259rbaycan dili",
        countryCallingCode: "994",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE6\uD83C\uDDFF"
    },
    {
        countryNameEn: "Bosnia and Herzegovina",
        countryNameLocal: "Bosna i Hercegovina",
        countryCode: "BA",
        currencyCode: "BAM",
        currencyNameEn: "Bosnia and Herzegovina convertible mark",
        tinType: "",
        tinName: "",
        officialLanguageCode: "bs",
        officialLanguageNameEn: "Bosnian",
        officialLanguageNameLocal: "bosanski jezik",
        countryCallingCode: "387",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDE6"
    },
    {
        countryNameEn: "Barbados",
        countryNameLocal: "Barbados",
        countryCode: "BB",
        currencyCode: "BBD",
        currencyNameEn: "Barbados dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1246",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDE7"
    },
    {
        countryNameEn: "Bangladesh",
        countryNameLocal: "\u0997\u09A3\u09AA\u09CD\u09B0\u099C\u09BE\u09A4\u09A8\u09CD\u09A4\u09CD\u09B0\u09C0 \u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6",
        countryCode: "BD",
        currencyCode: "BDT",
        currencyNameEn: "Bangladeshi taka",
        tinType: "",
        tinName: "",
        officialLanguageCode: "bn",
        officialLanguageNameEn: "Bengali",
        officialLanguageNameLocal: "\u09AC\u09BE\u0982\u09B2\u09BE",
        countryCallingCode: "880",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE7\uD83C\uDDE9"
    },
    {
        countryNameEn: "Belgium",
        countryNameLocal: "Belgi\xeb, Belgique, Belgien",
        countryCode: "BE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "n\xb0 TVABTW-nr Mwst-nr",
        tinName: "BTW identificatienummer / Num\xe9ro de TVA",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "32",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDEA"
    },
    {
        countryNameEn: "Burkina Faso",
        countryNameLocal: "Burkina Faso",
        countryCode: "BF",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "226",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDEB"
    },
    {
        countryNameEn: "Bulgaria",
        countryNameLocal: "\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F",
        countryCode: "BG",
        currencyCode: "BGN",
        currencyNameEn: "Bulgarian lev",
        tinType: "\u0414\u0414\u0421 \u043D\u043E\u043C\u0435\u0440",
        tinName: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440 \u043F\u043E \u0414\u0414\u0421",
        officialLanguageCode: "bg",
        officialLanguageNameEn: "Bulgarian",
        officialLanguageNameLocal: "\u0431\u044A\u043B\u0433\u0430\u0440\u0441\u043A\u0438 \u0435\u0437\u0438\u043A",
        countryCallingCode: "359",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDEC"
    },
    {
        countryNameEn: "Bahrain",
        countryNameLocal: "\u0627\u0644\u0628\u062D\u0631\u064A\u0646",
        countryCode: "BH",
        currencyCode: "BHD",
        currencyNameEn: "Bahraini dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "973",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE7\uD83C\uDDED"
    },
    {
        countryNameEn: "Burundi",
        countryNameLocal: "Burundi",
        countryCode: "BI",
        currencyCode: "BIF",
        currencyNameEn: "Burundian franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "257",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDEE"
    },
    {
        countryNameEn: "Benin",
        countryNameLocal: "B\xe9nin",
        countryCode: "BJ",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "229",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDEF"
    },
    {
        countryNameEn: "Saint Barth\xe9lemy",
        countryNameLocal: "Saint-Barth\xe9lemy",
        countryCode: "BL",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "590",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDF1"
    },
    {
        countryNameEn: "Bermuda",
        countryNameLocal: "Bermuda",
        countryCode: "BM",
        currencyCode: "BMD",
        currencyNameEn: "Bermudian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1441",
        areaCodes: [],
        region: "North America",
        flag: "\uD83C\uDDE7\uD83C\uDDF2"
    },
    {
        countryNameEn: "Brunei Darussalam",
        countryNameLocal: "Brunei Darussalam",
        countryCode: "BN",
        currencyCode: "BND",
        currencyNameEn: "Brunei dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ms",
        officialLanguageNameEn: "Malay",
        officialLanguageNameLocal: "Bahasa Melayu, \u0628\u0647\u0627\u0633 \u0645\u0644\u0627\u064A\u0648\u200E",
        countryCallingCode: "673",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE7\uD83C\uDDF3"
    },
    {
        countryNameEn: "Bolivia (Plurinational State of)",
        countryNameLocal: "Bolivia, Bulibiya, Vol\xedvia, Wuliwya",
        countryCode: "BO",
        currencyCode: "BOP",
        currencyNameEn: "",
        tinType: "NIT",
        tinName: "N\xfamero de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "591",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDF4"
    },
    {
        countryNameEn: "Bonaire, Sint Eustatius and Saba",
        countryNameLocal: "Caribisch Nederland",
        countryCode: "BQ",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "5997",
        areaCodes: [],
        region: "Unknown",
        flag: "\uD83C\uDDE7\uD83C\uDDF6"
    },
    {
        countryNameEn: "Brazil",
        countryNameLocal: "Brasil",
        countryCode: "BR",
        currencyCode: "BRL",
        currencyNameEn: "Brazilian real",
        tinType: "CNPJ",
        tinName: "Cadastro Nacional de Pessoa Jur\xeddica",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "55",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDF7"
    },
    {
        countryNameEn: "Bhutan",
        countryNameLocal: "\u0F60\u0F56\u0FB2\u0F74\u0F42\u0F0B\u0F61\u0F74\u0F63",
        countryCode: "BT",
        currencyCode: "BTN",
        currencyNameEn: "Bhutanese ngultrum",
        tinType: "",
        tinName: "",
        officialLanguageCode: "dz",
        officialLanguageNameEn: "Dzongkha",
        officialLanguageNameLocal: "\u0F62\u0FAB\u0F7C\u0F44\u0F0B\u0F41",
        countryCallingCode: "975",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE7\uD83C\uDDF9"
    },
    {
        countryNameEn: "Bouvet Island",
        countryNameLocal: "Bouvet\xf8ya",
        countryCode: "BV",
        currencyCode: "NOK",
        currencyNameEn: "Norwegian krone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "no",
        officialLanguageNameEn: "Norwegian",
        officialLanguageNameLocal: "Norsk",
        countryCallingCode: "47",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDFB"
    },
    {
        countryNameEn: "Botswana",
        countryNameLocal: "Botswana",
        countryCode: "BW",
        currencyCode: "BWP",
        currencyNameEn: "Botswana pula",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "267",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE7\uD83C\uDDFC"
    },
    {
        countryNameEn: "Belarus",
        countryNameLocal: "\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C",
        countryCode: "BY",
        currencyCode: "BYR",
        currencyNameEn: "",
        tinType: "\u0423\u041D\u041F (UNP)",
        tinName: "\u0423\u0447\u0435\u0442\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0430",
        officialLanguageCode: "be",
        officialLanguageNameEn: "Belarusian",
        officialLanguageNameLocal: "\u0431\u0435\u043B\u0430\u0440\u0443\u0441\u043A\u0430\u044F \u043C\u043E\u0432\u0430",
        countryCallingCode: "375",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDFE"
    },
    {
        countryNameEn: "Belize",
        countryNameLocal: "Belize",
        countryCode: "BZ",
        currencyCode: "BZD",
        currencyNameEn: "Belize dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "501",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE7\uD83C\uDDFF"
    },
    {
        countryNameEn: "Canada",
        countryNameLocal: "Canada",
        countryCode: "CA",
        currencyCode: "CAD",
        currencyNameEn: "Canadian dollar",
        tinType: "BN / NE",
        tinName: "Business Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [
            "403",
            "587",
            "780",
            "825",
            "236",
            "250",
            "604",
            "672",
            "778",
            "204",
            "431",
            "506",
            "709",
            "782",
            "902",
            "226",
            "249",
            "289",
            "343",
            "365",
            "416",
            "437",
            "519",
            "548",
            "613",
            "647",
            "705",
            "807",
            "905",
            "367",
            "418",
            "438",
            "450",
            "514",
            "579",
            "581",
            "819",
            "873",
            "306",
            "639",
            "867"
        ],
        region: "North America",
        flag: "\uD83C\uDDE8\uD83C\uDDE6"
    },
    {
        countryNameEn: "Switzerland",
        countryNameLocal: "Schweiz, Suisse, Svizzera, Svizra",
        countryCode: "CH",
        currencyCode: "CHF",
        currencyNameEn: "Swiss franc",
        tinType: "MWST/TVA/IVA",
        tinName: "Mehrwertsteuernummer",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "41",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE8\uD83C\uDDED"
    },
    {
        countryNameEn: "C\xf4te d'Ivoire",
        countryNameLocal: "C\xf4te d'Ivoire",
        countryCode: "CI",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "225",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDEE"
    },
    {
        countryNameEn: "Chile",
        countryNameLocal: "Chile",
        countryCode: "CL",
        currencyCode: "CLP",
        currencyNameEn: "Chilean peso",
        tinType: "RUT",
        tinName: "Rol \xdanico Tributario",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "56",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDF1"
    },
    {
        countryNameEn: "Cameroon",
        countryNameLocal: "Cameroun, Cameroon",
        countryCode: "CM",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "237",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDF2"
    },
    {
        countryNameEn: "China",
        countryNameLocal: "\u4E2D\u56FD",
        countryCode: "CN",
        currencyCode: "CNY",
        currencyNameEn: "Renminbi (Chinese) yuan",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hans",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "86",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE8\uD83C\uDDF3"
    },
    {
        countryNameEn: "Colombia",
        countryNameLocal: "Colombia",
        countryCode: "CO",
        currencyCode: "COP",
        currencyNameEn: "Colombian peso",
        tinType: "NIT",
        tinName: "N\xfamero De Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "57",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDF4"
    },
    {
        countryNameEn: "Costa Rica",
        countryNameLocal: "Costa Rica",
        countryCode: "CR",
        currencyCode: "CRC",
        currencyNameEn: "Costa Rican colon",
        tinType: "",
        tinName: "C\xe9dula Jur\xeddica",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "506",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDF7"
    },
    {
        countryNameEn: "Cuba",
        countryNameLocal: "Cuba",
        countryCode: "CU",
        currencyCode: "CUC",
        currencyNameEn: "Cuban convertible peso",
        tinType: "",
        tinName: "",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "53",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE8\uD83C\uDDFA"
    },
    {
        countryNameEn: "Cabo Verde",
        countryNameLocal: "Cabo Verde",
        countryCode: "CV",
        currencyCode: "CVE",
        currencyNameEn: "Cape Verdean escudo",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "238",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDFB"
    },
    {
        countryNameEn: "Cura\xe7ao",
        countryNameLocal: "Cura\xe7ao",
        countryCode: "CW",
        currencyCode: "ANG",
        currencyNameEn: "Netherlands Antillean guilder",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "599",
        areaCodes: [],
        region: "Unknown",
        flag: "\uD83C\uDDE8\uD83C\uDDFC"
    },
    {
        countryNameEn: "Christmas Island",
        countryNameLocal: "Christmas Island",
        countryCode: "CX",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "61",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDE8\uD83C\uDDFD"
    },
    {
        countryNameEn: "Cyprus",
        countryNameLocal: "\u039A\u03CD\u03C0\u03C1\u03BF\u03C2, Kibris",
        countryCode: "CY",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "\u03A6\u03A0\u0391",
        tinName: "\u0391\u03C1\u03B9\u03B8\u03BC\u03CC\u03C2 \u0395\u03B3\u03B3\u03C1\u03B1\u03C6\u03AE\u03C2 \u03A6.\u03A0.\u0391.",
        officialLanguageCode: "el",
        officialLanguageNameEn: "Greek, Modern (1453-)",
        officialLanguageNameLocal: "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
        countryCallingCode: "357",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE8\uD83C\uDDFE"
    },
    {
        countryNameEn: "Germany",
        countryNameLocal: "Deutschland",
        countryCode: "DE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "USt-IdNr.",
        tinName: "Umsatzsteuer-Identifikationsnummer",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "49",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE9\uD83C\uDDEA"
    },
    {
        countryNameEn: "Djibouti",
        countryNameLocal: "Djibouti, \u062C\u064A\u0628\u0648\u062A\u064A, Jabuuti, Gabuutih",
        countryCode: "DJ",
        currencyCode: "DJF",
        currencyNameEn: "Djiboutian franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "253",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE9\uD83C\uDDEF"
    },
    {
        countryNameEn: "Denmark",
        countryNameLocal: "Danmark",
        countryCode: "DK",
        currencyCode: "DKK",
        currencyNameEn: "Danish krone",
        tinType: "CVR",
        tinName: "Momsregistreringsnummer",
        officialLanguageCode: "da",
        officialLanguageNameEn: "Danish",
        officialLanguageNameLocal: "dansk",
        countryCallingCode: "45",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE9\uD83C\uDDF0"
    },
    {
        countryNameEn: "Dominica",
        countryNameLocal: "Dominica",
        countryCode: "DM",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "767",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE9\uD83C\uDDF2"
    },
    {
        countryNameEn: "Algeria",
        countryNameLocal: "\u0627\u0644\u062C\u0632\u0627\u0626\u0631",
        countryCode: "DZ",
        currencyCode: "DZD",
        currencyNameEn: "Algerian dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "213",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE9\uD83C\uDDFF"
    },
    {
        countryNameEn: "Ecuador",
        countryNameLocal: "Ecuador",
        countryCode: "EC",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "RUC",
        tinName: "N\xfamero de Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "593",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEA\uD83C\uDDE8"
    },
    {
        countryNameEn: "Estonia",
        countryNameLocal: "Eesti",
        countryCode: "EE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "KMKR",
        tinName: "K\xe4ibemaksukohustuslase number",
        officialLanguageCode: "et",
        officialLanguageNameEn: "Estonian",
        officialLanguageNameLocal: "eesti, eesti keel",
        countryCallingCode: "372",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEA\uD83C\uDDEA"
    },
    {
        countryNameEn: "Egypt",
        countryNameLocal: "\u0645\u0635\u0631",
        countryCode: "EG",
        currencyCode: "EGP",
        currencyNameEn: "Egyptian pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "20",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDEA\uD83C\uDDEC"
    },
    {
        countryNameEn: "Western Sahara",
        countryNameLocal: "Sahara Occidental",
        countryCode: "EH",
        currencyCode: "MAD",
        currencyNameEn: "Moroccan dirham",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "212",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEA\uD83C\uDDED"
    },
    {
        countryNameEn: "Eritrea",
        countryNameLocal: "\u12A4\u122D\u1275\u122B, \u0625\u0631\u062A\u0631\u064A\u0627, Eritrea",
        countryCode: "ER",
        currencyCode: "ERN",
        currencyNameEn: "Eritrean nakfa",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ti",
        officialLanguageNameEn: "Tigrinya",
        officialLanguageNameLocal: "\u1275\u130D\u122D\u129B",
        countryCallingCode: "291",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEA\uD83C\uDDF7"
    },
    {
        countryNameEn: "Spain",
        countryNameLocal: "Espa\xf1a",
        countryCode: "ES",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "NIF (CIF)",
        tinName: "N\xfamero de Identificaci\xf3n Fiscal (formerly named C\xf3digo de Identificaci\xf3n Fiscal)",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "34",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEA\uD83C\uDDF8"
    },
    {
        countryNameEn: "Ethiopia",
        countryNameLocal: "\u12A2\u1275\u12EE\u1335\u12EB, Itoophiyaa",
        countryCode: "ET",
        currencyCode: "ETB",
        currencyNameEn: "Ethiopian birr",
        tinType: "",
        tinName: "",
        officialLanguageCode: "am",
        officialLanguageNameEn: "Amharic",
        officialLanguageNameLocal: "\u12A0\u121B\u122D\u129B",
        countryCallingCode: "251",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEA\uD83C\uDDF9"
    },
    {
        countryNameEn: "Finland",
        countryNameLocal: "Suomi",
        countryCode: "FI",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "ALV nro",
        tinName: "Arvonlis\xe4veronumero",
        officialLanguageCode: "fi",
        officialLanguageNameEn: "Finnish",
        officialLanguageNameLocal: "suomi, suomen kieli",
        countryCallingCode: "358",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEB\uD83C\uDDEE"
    },
    {
        countryNameEn: "Fiji",
        countryNameLocal: "Fiji",
        countryCode: "FJ",
        currencyCode: "FJD",
        currencyNameEn: "Fiji dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "679",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEB\uD83C\uDDEF"
    },
    {
        countryNameEn: "Micronesia (Federated States of)",
        countryNameLocal: "Micronesia",
        countryCode: "FM",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "691",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEB\uD83C\uDDF2"
    },
    {
        countryNameEn: "France",
        countryNameLocal: "France",
        countryCode: "FR",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "n\xb0 TVA",
        tinName: "Num\xe9ro d'identification \xe0 la taxe sur la valeur ajout\xe9e / Num\xe9ro de TVA intracommunautaire",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "33",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    {
        countryNameEn: "Gabon",
        countryNameLocal: "Gabon",
        countryCode: "GA",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "241",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDE6"
    },
    {
        countryNameEn: "Grenada",
        countryNameLocal: "Grenada",
        countryCode: "GD",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1473",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDE9"
    },
    {
        countryNameEn: "Georgia",
        countryNameLocal: "\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD",
        countryCode: "GE",
        currencyCode: "GEL",
        currencyNameEn: "Georgian lari",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ka",
        officialLanguageNameEn: "Georgian",
        officialLanguageNameLocal: "\u10E5\u10D0\u10E0\u10D7\u10E3\u10DA\u10D8",
        countryCallingCode: "995",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDEA"
    },
    {
        countryNameEn: "French Guiana",
        countryNameLocal: "Guyane fran\xe7aise",
        countryCode: "GF",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "594",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDEB"
    },
    {
        countryNameEn: "Guernsey",
        countryNameLocal: "Guernsey",
        countryCode: "GG",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDEC"
    },
    {
        countryNameEn: "Ghana",
        countryNameLocal: "Ghana",
        countryCode: "GH",
        currencyCode: "GHS",
        currencyNameEn: "Ghanaian cedi",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "233",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDED"
    },
    {
        countryNameEn: "Gibraltar",
        countryNameLocal: "Gibraltar",
        countryCode: "GI",
        currencyCode: "GIP",
        currencyNameEn: "Gibraltar pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "350",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDEE"
    },
    {
        countryNameEn: "Greenland",
        countryNameLocal: "Kalaallit Nunaat, Gr\xf8nland",
        countryCode: "GL",
        currencyCode: "DKK",
        currencyNameEn: "Danish krone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "kl",
        officialLanguageNameEn: "Kalaallisut, Greenlandic",
        officialLanguageNameLocal: "kalaallisut, kalaallit oqaasii",
        countryCallingCode: "299",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDF1"
    },
    {
        countryNameEn: "Guinea",
        countryNameLocal: "Guin\xe9e",
        countryCode: "GN",
        currencyCode: "GNF",
        currencyNameEn: "Guinean franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "224",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDF3"
    },
    {
        countryNameEn: "Guadeloupe",
        countryNameLocal: "Guadeloupe",
        countryCode: "GP",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "590",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDF5"
    },
    {
        countryNameEn: "Equatorial Guinea",
        countryNameLocal: "Guiena ecuatorial, Guin\xe9e \xe9quatoriale, Guin\xe9 Equatorial",
        countryCode: "GQ",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "240",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDF6"
    },
    {
        countryNameEn: "Greece",
        countryNameLocal: "\u0395\u03BB\u03BB\u03AC\u03B4\u03B1",
        countryCode: "GR",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "el",
        officialLanguageNameEn: "Greek, Modern (1453-)",
        officialLanguageNameLocal: "\u03B5\u03BB\u03BB\u03B7\u03BD\u03B9\u03BA\u03AC",
        countryCallingCode: "30",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDF7"
    },
    {
        countryNameEn: "South Georgia and the South Sandwich Islands",
        countryNameLocal: "South Georgia and the South Sandwich Islands",
        countryCode: "GS",
        currencyCode: "",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "500",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDF8"
    },
    {
        countryNameEn: "Guatemala",
        countryNameLocal: "Guatemala",
        countryCode: "GT",
        currencyCode: "GTQ",
        currencyNameEn: "Guatemalan quetzal",
        tinType: "NIT",
        tinName: "N\xfamero de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "502",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDF9"
    },
    {
        countryNameEn: "Guam",
        countryNameLocal: "Guam, Gu\xe5h\xe5n",
        countryCode: "GU",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEC\uD83C\uDDFA"
    },
    {
        countryNameEn: "Guinea-Bissau",
        countryNameLocal: "Guin\xe9-Bissau",
        countryCode: "GW",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "245",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDFC"
    },
    {
        countryNameEn: "Guyana",
        countryNameLocal: "Guyana",
        countryCode: "GY",
        currencyCode: "GYD",
        currencyNameEn: "Guyanese dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "592",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEC\uD83C\uDDFE"
    },
    {
        countryNameEn: "Hong Kong",
        countryNameLocal: "\u9999\u6E2F, Hong Kong",
        countryCode: "HK",
        currencyCode: "HKD",
        currencyNameEn: "Hong Kong dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hant",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "852",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDED\uD83C\uDDF0"
    },
    {
        countryNameEn: "Honduras",
        countryNameLocal: "Honduras",
        countryCode: "HN",
        currencyCode: "HNL",
        currencyNameEn: "Honduran lempira",
        tinType: "RTN",
        tinName: "Registro Tributario Nacional",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "504",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDED\uD83C\uDDF3"
    },
    {
        countryNameEn: "Croatia",
        countryNameLocal: "Hrvatska",
        countryCode: "HR",
        currencyCode: "HRK",
        currencyNameEn: "Croatian kuna",
        tinType: "PDV-ID; OIB",
        tinName: "PDV Id. Broj OIB",
        officialLanguageCode: "hr",
        officialLanguageNameEn: "Croatian",
        officialLanguageNameLocal: "hrvatski jezik",
        countryCallingCode: "385",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDED\uD83C\uDDF7"
    },
    {
        countryNameEn: "Haiti",
        countryNameLocal: "Ha\xefti, Ayiti",
        countryCode: "HT",
        currencyCode: "HTG",
        currencyNameEn: "Haitian gourde",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "509",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDED\uD83C\uDDF9"
    },
    {
        countryNameEn: "Hungary",
        countryNameLocal: "Magyarorsz\xe1g",
        countryCode: "HU",
        currencyCode: "HUF",
        currencyNameEn: "Hungarian forint",
        tinType: "ANUM",
        tinName: "K\xf6z\xf6ss\xe9gi ad\xf3sz\xe1m",
        officialLanguageCode: "hu",
        officialLanguageNameEn: "Hungarian",
        officialLanguageNameLocal: "magyar",
        countryCallingCode: "36",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDED\uD83C\uDDFA"
    },
    {
        countryNameEn: "Indonesia",
        countryNameLocal: "Indonesia",
        countryCode: "ID",
        currencyCode: "IDR",
        currencyNameEn: "Indonesian rupiah",
        tinType: "NPWP",
        tinName: "Nomor Pokok Wajib Pajak",
        officialLanguageCode: "id",
        officialLanguageNameEn: "Indonesian",
        officialLanguageNameLocal: "Bahasa Indonesia",
        countryCallingCode: "62",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEE\uD83C\uDDE9"
    },
    {
        countryNameEn: "Ireland",
        countryNameLocal: "Ireland, \xc9ire",
        countryCode: "IE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "VAT or CBL",
        tinName: "Value added tax identification no.",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "353",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDEA"
    },
    {
        countryNameEn: "Israel",
        countryNameLocal: "\u05D9\u05E9\u05E8\u05D0\u05DC",
        countryCode: "IL",
        currencyCode: "ILS",
        currencyNameEn: "Israeli new shekel",
        tinType: "",
        tinName: "\u05DE\u05E1' \u05E2\u05D5\u05E1\u05E7 \u05DE\u05D5\u05E8\u05E9\u05D4 / \u05D7\"\u05E4",
        officialLanguageCode: "he",
        officialLanguageNameEn: "Hebrew",
        officialLanguageNameLocal: "\u05E2\u05D1\u05E8\u05D9\u05EA",
        countryCallingCode: "972",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF1"
    },
    {
        countryNameEn: "Isle of Man",
        countryNameLocal: "Isle of Man",
        countryCode: "IM",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF2"
    },
    {
        countryNameEn: "India",
        countryNameLocal: "\u092D\u093E\u0930\u0924, India",
        countryCode: "IN",
        currencyCode: "INR",
        currencyNameEn: "Indian rupee",
        tinType: "VAT TIN / CST TIN",
        tinName: "Value Added Tax - Taxpayer Identification Number / Central Sales Tax - Taxpayer Identification Number (In most states)Not applicable",
        officialLanguageCode: "hi",
        officialLanguageNameEn: "Hindi",
        officialLanguageNameLocal: "\u0939\u093F\u0928\u094D\u0926\u0940, \u0939\u093F\u0902\u0926\u0940",
        countryCallingCode: "91",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEE\uD83C\uDDF3"
    },
    {
        countryNameEn: "British Indian Ocean Territories",
        countryNameLocal: "British Indian Ocean Territories",
        countryCode: "IO",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "246",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDEE\uD83C\uDDF4"
    },
    {
        countryNameEn: "Iraq",
        countryNameLocal: "\u0627\u0644\u0639\u0631\u0627\u0642, Iraq",
        countryCode: "IQ",
        currencyCode: "IQD",
        currencyNameEn: "Iraqi dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "964",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDEE\uD83C\uDDF6"
    },
    {
        countryNameEn: "Iran (Islamic Republic of)",
        countryNameLocal: "\u0627\u06CC\u0631\u0627\u0646",
        countryCode: "IR",
        currencyCode: "IRR",
        currencyNameEn: "Iranian rial",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fa",
        officialLanguageNameEn: "Persian",
        officialLanguageNameLocal: "\u0641\u0627\u0631\u0633\u06CC",
        countryCallingCode: "98",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEE\uD83C\uDDF7"
    },
    {
        countryNameEn: "Iceland",
        countryNameLocal: "\xcdsland",
        countryCode: "IS",
        currencyCode: "ISK",
        currencyNameEn: "Icelandic kr\xf3na",
        tinType: "VSK / VASK",
        tinName: "Vir\xf0isaukaskattsn\xfamer",
        officialLanguageCode: "is",
        officialLanguageNameEn: "Icelandic",
        officialLanguageNameLocal: "\xcdslenska",
        countryCallingCode: "354",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF8"
    },
    {
        countryNameEn: "Italy",
        countryNameLocal: "Italia",
        countryCode: "IT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "P.IVA",
        tinName: "Partita IVA(IVA = Imposta sul Valore Aggiunto)",
        officialLanguageCode: "it",
        officialLanguageNameEn: "Italian",
        officialLanguageNameLocal: "Italiano",
        countryCallingCode: "39",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEE\uD83C\uDDF9"
    },
    {
        countryNameEn: "Jersey",
        countryNameLocal: "Jersey",
        countryCode: "JE",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEF\uD83C\uDDEA"
    },
    {
        countryNameEn: "Jamaica",
        countryNameLocal: "Jamaica",
        countryCode: "JM",
        currencyCode: "JMD",
        currencyNameEn: "Jamaican dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "876",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDEF\uD83C\uDDF2"
    },
    {
        countryNameEn: "Jordan",
        countryNameLocal: "\u0627\u0644\u0623\u064F\u0631\u0652\u062F\u064F\u0646",
        countryCode: "JO",
        currencyCode: "JOD",
        currencyNameEn: "Jordanian dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "962",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDEF\uD83C\uDDF4"
    },
    {
        countryNameEn: "Japan",
        countryNameLocal: "\u65E5\u672C",
        countryCode: "JP",
        currencyCode: "JPY",
        currencyNameEn: "Japanese yen",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ja",
        officialLanguageNameEn: "Japanese",
        officialLanguageNameLocal: "\u65E5\u672C\u8A9E (\u306B\u307B\u3093\u3054)",
        countryCallingCode: "81",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDEF\uD83C\uDDF5"
    },
    {
        countryNameEn: "Kenya",
        countryNameLocal: "Kenya",
        countryCode: "KE",
        currencyCode: "KES",
        currencyNameEn: "Kenyan shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sw",
        officialLanguageNameEn: "Swahili",
        officialLanguageNameLocal: "Kiswahili",
        countryCallingCode: "254",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF0\uD83C\uDDEA"
    },
    {
        countryNameEn: "Kyrgyzstan",
        countryNameLocal: "\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D, \u041A\u0438\u0440\u0433\u0438\u0437\u0438\u044F",
        countryCode: "KG",
        currencyCode: "KGS",
        currencyNameEn: "Kyrgyzstani som",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ky",
        officialLanguageNameEn: "Kirghiz, Kyrgyz",
        officialLanguageNameLocal: "\u041A\u044B\u0440\u0433\u044B\u0437\u0447\u0430, \u041A\u044B\u0440\u0433\u044B\u0437 \u0442\u0438\u043B\u0438",
        countryCallingCode: "996",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDEC"
    },
    {
        countryNameEn: "Cambodia",
        countryNameLocal: "\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6",
        countryCode: "KH",
        currencyCode: "KHR",
        currencyNameEn: "Cambodian riel",
        tinType: "",
        tinName: "",
        officialLanguageCode: "km",
        officialLanguageNameEn: "Central Khmer",
        officialLanguageNameLocal: "\u1781\u17D2\u1798\u17C2\u179A, \u1781\u17C1\u1798\u179A\u1797\u17B6\u179F\u17B6, \u1797\u17B6\u179F\u17B6\u1781\u17D2\u1798\u17C2\u179A",
        countryCallingCode: "855",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDED"
    },
    {
        countryNameEn: "North Korea",
        countryNameLocal: "\uC870\uC120\uBBFC\uC8FC\uC8FC\uC758\uC778\uBBFC\uACF5\uD654\uAD6D",
        countryCode: "KP",
        currencyCode: "KPW",
        currencyNameEn: "North Korean won",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ko",
        officialLanguageNameEn: "Korean",
        officialLanguageNameLocal: "\uC870\uC120\uC5B4",
        countryCallingCode: "850",
        areaCodes: [],
        region: "Asia",
        flag: "\uD83C\uDDF0\uD83C\uDDF5"
    },
    {
        countryNameEn: "South Korea",
        countryNameLocal: "\uB300\uD55C\uBBFC\uAD6D",
        countryCode: "KR",
        currencyCode: "KRW",
        currencyNameEn: "South Korean won",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ko",
        officialLanguageNameEn: "Korean",
        officialLanguageNameLocal: "\uD55C\uAD6D\uC5B4",
        countryCallingCode: "82",
        areaCodes: [],
        region: "Asia",
        flag: "\uD83C\uDDF0\uD83C\uDDF7"
    },
    {
        countryNameEn: "Kiribati",
        countryNameLocal: "Kiribati",
        countryCode: "KI",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "686",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDEE"
    },
    {
        countryNameEn: "Saint Kitts and Nevis",
        countryNameLocal: "Saint Kitts and Nevis",
        countryCode: "KN",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1869",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF0\uD83C\uDDF3"
    },
    {
        countryNameEn: "Kuwait",
        countryNameLocal: "\u0627\u0644\u0643\u0648\u064A\u062A",
        countryCode: "KW",
        currencyCode: "KWD",
        currencyNameEn: "Kuwaiti dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "965",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF0\uD83C\uDDFC"
    },
    {
        countryNameEn: "Kazakhstan",
        countryNameLocal: "\u049A\u0430\u0437\u0430\u049B\u0441\u0442\u0430\u043D, \u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D",
        countryCode: "KZ",
        currencyCode: "KZT",
        currencyNameEn: "Kazakhstani tenge",
        tinType: "",
        tinName: "",
        officialLanguageCode: "kk",
        officialLanguageNameEn: "Kazakh",
        officialLanguageNameLocal: "\u049B\u0430\u0437\u0430\u049B \u0442\u0456\u043B\u0456",
        countryCallingCode: "7",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF0\uD83C\uDDFF"
    },
    {
        countryNameEn: "Lebanon",
        countryNameLocal: "\u0644\u0628\u0646\u0627\u0646, Liban",
        countryCode: "LB",
        currencyCode: "LBP",
        currencyNameEn: "Lebanese pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "961",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF1\uD83C\uDDE7"
    },
    {
        countryNameEn: "Saint Lucia",
        countryNameLocal: "Saint Lucia",
        countryCode: "LC",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1758",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF1\uD83C\uDDE8"
    },
    {
        countryNameEn: "Liechtenstein",
        countryNameLocal: "Liechtenstein",
        countryCode: "LI",
        currencyCode: "CHF",
        currencyNameEn: "Swiss franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "de",
        officialLanguageNameEn: "German",
        officialLanguageNameLocal: "Deutsch",
        countryCallingCode: "423",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDEE"
    },
    {
        countryNameEn: "Sri Lanka",
        countryNameLocal: "\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF, \u0B87\u0BB2\u0B99\u0BCD\u0B95\u0BC8",
        countryCode: "LK",
        currencyCode: "LKR",
        currencyNameEn: "Sri Lankan rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "si",
        officialLanguageNameEn: "Sinhala, Sinhalese",
        officialLanguageNameLocal: "\u0DC3\u0DD2\u0D82\u0DC4\u0DBD",
        countryCallingCode: "94",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF1\uD83C\uDDF0"
    },
    {
        countryNameEn: "Liberia",
        countryNameLocal: "Liberia",
        countryCode: "LR",
        currencyCode: "LRD",
        currencyNameEn: "Liberian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "231",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF1\uD83C\uDDF7"
    },
    {
        countryNameEn: "Lesotho",
        countryNameLocal: "Lesotho",
        countryCode: "LS",
        currencyCode: "LSL",
        currencyNameEn: "Lesotho loti",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "266",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF1\uD83C\uDDF8"
    },
    {
        countryNameEn: "Lithuania",
        countryNameLocal: "Lietuva",
        countryCode: "LT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "PVM kodas",
        tinName: "PVM (abbrev. Prid\u0117tin\u0117s vert\u0117s mokestis) mok\u0117tojo kodas",
        officialLanguageCode: "lt",
        officialLanguageNameEn: "Lithuanian",
        officialLanguageNameLocal: "lietuvi\u0173 kalba",
        countryCallingCode: "370",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDF9"
    },
    {
        countryNameEn: "Luxembourg",
        countryNameLocal: "L\xebtzebuerg, Luxembourg, Luxemburg",
        countryCode: "LU",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "No. TVA",
        tinName: "Num\xe9ro d'identification \xe0 la taxe sur la valeur ajout\xe9e",
        officialLanguageCode: "lb",
        officialLanguageNameEn: "Luxembourgish, Letzeburgesch",
        officialLanguageNameLocal: "L\xebtzebuergesch",
        countryCallingCode: "352",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDFA"
    },
    {
        countryNameEn: "Latvia",
        countryNameLocal: "Latvija",
        countryCode: "LV",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "PVN",
        tinName: "Pievienot\u0101s v\u0113rt\u012Bbas nodok\u013Ca (PVN) re\u0123istr\u0101cijas numurs",
        officialLanguageCode: "lv",
        officialLanguageNameEn: "Latvian",
        officialLanguageNameLocal: "latvie\u0161u valoda",
        countryCallingCode: "371",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF1\uD83C\uDDFB"
    },
    {
        countryNameEn: "Libya",
        countryNameLocal: "\u0644\u064A\u0628\u064A\u0627",
        countryCode: "LY",
        currencyCode: "LYD",
        currencyNameEn: "Libyan dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "218",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF1\uD83C\uDDFE"
    },
    {
        countryNameEn: "Morocco",
        countryNameLocal: "Maroc, \u2D4D\u2D4E\u2D56\u2D54\u2D49\u2D31, \u0627\u0644\u0645\u063A\u0631\u0628",
        countryCode: "MA",
        currencyCode: "MAD",
        currencyNameEn: "Moroccan dirham",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "212",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF2\uD83C\uDDE6"
    },
    {
        countryNameEn: "Monaco",
        countryNameLocal: "Monaco",
        countryCode: "MC",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "377",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDE8"
    },
    {
        countryNameEn: "Montenegro",
        countryNameLocal: "Crna Gora, \u0426\u0440\u043D\u0430 \u0413\u043E\u0440\u0430",
        countryCode: "ME",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "srp",
        officialLanguageNameEn: "\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A",
        officialLanguageNameLocal: "",
        countryCallingCode: "382",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDEA"
    },
    {
        countryNameEn: "Saint Martin (French part)",
        countryNameLocal: "Saint-Martin",
        countryCode: "MF",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "590",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDEB"
    },
    {
        countryNameEn: "Madagascar",
        countryNameLocal: "Madagasikara, Madagascar",
        countryCode: "MG",
        currencyCode: "MGA",
        currencyNameEn: "Malagasy ariary",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mg",
        officialLanguageNameEn: "Malagasy",
        officialLanguageNameLocal: "fiteny malagasy",
        countryCallingCode: "261",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDEC"
    },
    {
        countryNameEn: "Mali",
        countryNameLocal: "Mali",
        countryCode: "ML",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "223",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDF1"
    },
    {
        countryNameEn: "Myanmar",
        countryNameLocal: "\u1019\u103C\u1014\u103A\u1019\u102C",
        countryCode: "MM",
        currencyCode: "MMK",
        currencyNameEn: "Myanmar kyat",
        tinType: "",
        tinName: "",
        officialLanguageCode: "my",
        officialLanguageNameEn: "Burmese",
        officialLanguageNameLocal: "\u1017\u1019\u102C\u1005\u102C",
        countryCallingCode: "95",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDF2"
    },
    {
        countryNameEn: "Mongolia",
        countryNameLocal: "\u041C\u043E\u043D\u0433\u043E\u043B \u0423\u043B\u0441",
        countryCode: "MN",
        currencyCode: "MNT",
        currencyNameEn: "Mongolian t\xf6gr\xf6g",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mn",
        officialLanguageNameEn: "Mongolian",
        officialLanguageNameLocal: "\u041C\u043E\u043D\u0433\u043E\u043B \u0445\u044D\u043B",
        countryCallingCode: "976",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDF3"
    },
    {
        countryNameEn: "Macao",
        countryNameLocal: "\u6FB3\u9580, Macau",
        countryCode: "MO",
        currencyCode: "MOP",
        currencyNameEn: "Macanese pataca",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hant",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "853",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDF4"
    },
    {
        countryNameEn: "Martinique",
        countryNameLocal: "Martinique",
        countryCode: "MQ",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "596",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDF6"
    },
    {
        countryNameEn: "Mauritania",
        countryNameLocal: "\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627, Mauritanie",
        countryCode: "MR",
        currencyCode: "MRU",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "222",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF2\uD83C\uDDF7"
    },
    {
        countryNameEn: "Montserrat",
        countryNameLocal: "Montserrat",
        countryCode: "MS",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1664",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDF8"
    },
    {
        countryNameEn: "Malta",
        countryNameLocal: "Malta",
        countryCode: "MT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "Vat No.",
        tinName: "Vat reg. no.",
        officialLanguageCode: "mt",
        officialLanguageNameEn: "Maltese",
        officialLanguageNameLocal: "Malti",
        countryCallingCode: "356",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDF9"
    },
    {
        countryNameEn: "Mauritius",
        countryNameLocal: "Maurice, Mauritius",
        countryCode: "MU",
        currencyCode: "MUR",
        currencyNameEn: "Mauritian rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mfe",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "230",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDFA"
    },
    {
        countryNameEn: "Maldives",
        countryNameLocal: "",
        countryCode: "MV",
        currencyCode: "MVR",
        currencyNameEn: "Maldivian rufiyaa",
        tinType: "",
        tinName: "",
        officialLanguageCode: "dv",
        officialLanguageNameEn: "Divehi, Dhivehi, Maldivian",
        officialLanguageNameLocal: "\u078B\u07A8\u0788\u07AC\u0780\u07A8",
        countryCallingCode: "960",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDFB"
    },
    {
        countryNameEn: "Malawi",
        countryNameLocal: "Malawi",
        countryCode: "MW",
        currencyCode: "MWK",
        currencyNameEn: "Malawian kwacha",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "265",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDFC"
    },
    {
        countryNameEn: "Mexico",
        countryNameLocal: "M\xe9xico",
        countryCode: "MX",
        currencyCode: "MXN",
        currencyNameEn: "Mexican peso",
        tinType: "RFC",
        tinName: "Registro Federal de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "52",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF2\uD83C\uDDFD"
    },
    {
        countryNameEn: "Malaysia",
        countryNameLocal: "",
        countryCode: "MY",
        currencyCode: "MYR",
        currencyNameEn: "Malaysian ringgit",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ms",
        officialLanguageNameEn: "Malay",
        officialLanguageNameLocal: "Bahasa Melayu, \u0628\u0647\u0627\u0633 \u0645\u0644\u0627\u064A\u0648\u200E",
        countryCallingCode: "60",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF2\uD83C\uDDFE"
    },
    {
        countryNameEn: "Mozambique",
        countryNameLocal: "Mozambique",
        countryCode: "MZ",
        currencyCode: "MZN",
        currencyNameEn: "Mozambican metical",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "258",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF2\uD83C\uDDFF"
    },
    {
        countryNameEn: "Namibia",
        countryNameLocal: "Namibia",
        countryCode: "NA",
        currencyCode: "NAD",
        currencyNameEn: "Namibian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "264",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF3\uD83C\uDDE6"
    },
    {
        countryNameEn: "New Caledonia",
        countryNameLocal: "Nouvelle-Cal\xe9donie",
        countryCode: "NC",
        currencyCode: "XPF",
        currencyNameEn: "CFP franc (franc Pacifique)",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "687",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDE8"
    },
    {
        countryNameEn: "Norfolk Island",
        countryNameLocal: "Norfolk Island",
        countryCode: "NF",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDEB"
    },
    {
        countryNameEn: "Nigeria",
        countryNameLocal: "Nigeria",
        countryCode: "NG",
        currencyCode: "NGN",
        currencyNameEn: "Nigerian naira",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "234",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF3\uD83C\uDDEC"
    },
    {
        countryNameEn: "Nicaragua",
        countryNameLocal: "Nicaragua",
        countryCode: "NI",
        currencyCode: "NIO",
        currencyNameEn: "Nicaraguan c\xf3rdoba",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "505",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF3\uD83C\uDDEE"
    },
    {
        countryNameEn: "Norway",
        countryNameLocal: "Norge, Noreg",
        countryCode: "NO",
        currencyCode: "NOK",
        currencyNameEn: "Norwegian krone",
        tinType: "Orgnr",
        tinName: "Organisasjonsnummer",
        officialLanguageCode: "nb",
        officialLanguageNameEn: "Norwegian Bokm\xe5l",
        officialLanguageNameLocal: "Norsk Bokm\xe5l",
        countryCallingCode: "47",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF3\uD83C\uDDF4"
    },
    {
        countryNameEn: "Nepal",
        countryNameLocal: "",
        countryCode: "NP",
        currencyCode: "NPR",
        currencyNameEn: "Nepalese rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ne",
        officialLanguageNameEn: "Nepali",
        officialLanguageNameLocal: "\u0928\u0947\u092A\u093E\u0932\u0940",
        countryCallingCode: "977",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDF5"
    },
    {
        countryNameEn: "Nauru",
        countryNameLocal: "Nauru",
        countryCode: "NR",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "na",
        officialLanguageNameEn: "Nauru",
        officialLanguageNameLocal: "Dorerin Naoero",
        countryCallingCode: "674",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDF7"
    },
    {
        countryNameEn: "Niue",
        countryNameLocal: "Niue",
        countryCode: "NU",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "niu",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "683",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDFA"
    },
    {
        countryNameEn: "New Zealand",
        countryNameLocal: "New Zealand",
        countryCode: "NZ",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "NZBN",
        tinName: "NZ Business Number",
        officialLanguageCode: "mi",
        officialLanguageNameEn: "Maori",
        officialLanguageNameLocal: "te reo M\u0101ori",
        countryCallingCode: "64",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF3\uD83C\uDDFF"
    },
    {
        countryNameEn: "Oman",
        countryNameLocal: "\u0633\u0644\u0637\u0646\u0629 \u0639\u064F\u0645\u0627\u0646",
        countryCode: "OM",
        currencyCode: "OMR",
        currencyNameEn: "Omani rial",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "968",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF4\uD83C\uDDF2"
    },
    {
        countryNameEn: "Panama",
        countryNameLocal: "Panama",
        countryCode: "PA",
        currencyCode: "PAB",
        currencyNameEn: "Panamanian balboa",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "507",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDE6"
    },
    {
        countryNameEn: "Peru",
        countryNameLocal: "Per\xfa",
        countryCode: "PE",
        currencyCode: "PEN",
        currencyNameEn: "Peruvian sol",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "51",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDEA"
    },
    {
        countryNameEn: "French Polynesia",
        countryNameLocal: "Polyn\xe9sie fran\xe7aise",
        countryCode: "PF",
        currencyCode: "XPF",
        currencyNameEn: "CFP franc (franc Pacifique)",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "689",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDEB"
    },
    {
        countryNameEn: "Papua New Guinea",
        countryNameLocal: "Papua New Guinea",
        countryCode: "PG",
        currencyCode: "PGK",
        currencyNameEn: "Papua New Guinean kina",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "675",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDEC"
    },
    {
        countryNameEn: "Pakistan",
        countryNameLocal: "\u067E\u0627\u06A9\u0633\u062A\u0627\u0646",
        countryCode: "PK",
        currencyCode: "PKR",
        currencyNameEn: "Pakistani rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "92",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDF0"
    },
    {
        countryNameEn: "Poland",
        countryNameLocal: "Polska",
        countryCode: "PL",
        currencyCode: "PLN",
        currencyNameEn: "Polish z\u0142oty",
        tinType: "NIP",
        tinName: "numer identyfikacji podatkowej",
        officialLanguageCode: "pl",
        officialLanguageNameEn: "Polish",
        officialLanguageNameLocal: "j\u0119zyk polski, polszczyzna",
        countryCallingCode: "48",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF5\uD83C\uDDF1"
    },
    {
        countryNameEn: "Saint Pierre and Miquelon",
        countryNameLocal: "Saint-Pierre-et-Miquelon",
        countryCode: "PM",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "508",
        areaCodes: [],
        region: "North America",
        flag: "\uD83C\uDDF5\uD83C\uDDF2"
    },
    {
        countryNameEn: "Pitcairn",
        countryNameLocal: "Pitcairn",
        countryCode: "PN",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "64",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDF3"
    },
    {
        countryNameEn: "Puerto Rico",
        countryNameLocal: "Puerto Rico",
        countryCode: "PR",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "1",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDF7"
    },
    {
        countryNameEn: "Palestine, State of",
        countryNameLocal: "Palestinian Territory",
        countryCode: "PS",
        currencyCode: "",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "970",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF5\uD83C\uDDF8"
    },
    {
        countryNameEn: "Portugal",
        countryNameLocal: "Portugal",
        countryCode: "PT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "NIPC",
        tinName: "N\xfamero de Identifica\xe7\xe3o de Pessoa Coletiva (NIPC)",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "351",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF5\uD83C\uDDF9"
    },
    {
        countryNameEn: "Palau",
        countryNameLocal: "Palau",
        countryCode: "PW",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "680",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDFC"
    },
    {
        countryNameEn: "Paraguay",
        countryNameLocal: "Paraguay",
        countryCode: "PY",
        currencyCode: "PYG",
        currencyNameEn: "Paraguayan guaran\xed",
        tinType: "RUC",
        tinName: "Registro Unico de Contribuyentes",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "595",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF5\uD83C\uDDFE"
    },
    {
        countryNameEn: "Qatar",
        countryNameLocal: "\u0642\u0637\u0631",
        countryCode: "QA",
        currencyCode: "QAR",
        currencyNameEn: "Qatari riyal",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "974",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF6\uD83C\uDDE6"
    },
    {
        countryNameEn: "R\xe9union",
        countryNameLocal: "La R\xe9union",
        countryCode: "RE",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "262",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF7\uD83C\uDDEA"
    },
    {
        countryNameEn: "Romania",
        countryNameLocal: "Rom\xe2nia",
        countryCode: "RO",
        currencyCode: "RON",
        currencyNameEn: "Romanian leu",
        tinType: "CIF",
        tinName: "Codul de identificare fiscal\u0103",
        officialLanguageCode: "ro",
        officialLanguageNameEn: "Romanian, Moldavian, Moldovan",
        officialLanguageNameLocal: "Rom\xe2n\u0103",
        countryCallingCode: "40",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF7\uD83C\uDDF4"
    },
    {
        countryNameEn: "Serbia",
        countryNameLocal: "\u0421\u0440\u0431\u0438\u0458\u0430",
        countryCode: "RS",
        currencyCode: "RSD",
        currencyNameEn: "Serbian dinar",
        tinType: "PIB",
        tinName: "Poreski identifikacioni broj",
        officialLanguageCode: "sr",
        officialLanguageNameEn: "Serbian",
        officialLanguageNameLocal: "\u0441\u0440\u043F\u0441\u043A\u0438 \u0458\u0435\u0437\u0438\u043A",
        countryCallingCode: "381",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF7\uD83C\uDDF8"
    },
    {
        countryNameEn: "Russia",
        countryNameLocal: "\u0420\u043E\u0441\u0441\u0438\u044F",
        countryCode: "RU",
        currencyCode: "RUB",
        currencyNameEn: "Russian ruble",
        tinType: "\u0418\u041D\u041D",
        tinName: "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u043D\u043E\u043C\u0435\u0440 \u043D\u0430\u043B\u043E\u0433\u043E\u043F\u043B\u0430\u0442\u0435\u043B\u044C\u0449\u0438\u043A\u0430",
        officialLanguageCode: "ru",
        officialLanguageNameEn: "Russian",
        officialLanguageNameLocal: "\u0440\u0443\u0441\u0441\u043A\u0438\u0439",
        countryCallingCode: "7",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF7\uD83C\uDDFA"
    },
    {
        countryNameEn: "Rwanda",
        countryNameLocal: "Rwanda",
        countryCode: "RW",
        currencyCode: "RWF",
        currencyNameEn: "Rwandan franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "rw",
        officialLanguageNameEn: "Kinyarwanda",
        officialLanguageNameLocal: "Ikinyarwanda",
        countryCallingCode: "250",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF7\uD83C\uDDFC"
    },
    {
        countryNameEn: "Saudi Arabia",
        countryNameLocal: "\u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629",
        countryCode: "SA",
        currencyCode: "SAR",
        currencyNameEn: "Saudi riyal",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "966",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF8\uD83C\uDDE6"
    },
    {
        countryNameEn: "Solomon Islands",
        countryNameLocal: "Solomon Islands",
        countryCode: "SB",
        currencyCode: "SBD",
        currencyNameEn: "Solomon Islands dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "677",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF8\uD83C\uDDE7"
    },
    {
        countryNameEn: "Seychelles",
        countryNameLocal: "Seychelles",
        countryCode: "SC",
        currencyCode: "SCR",
        currencyNameEn: "Seychelles rupee",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "248",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDE8"
    },
    {
        countryNameEn: "Sweden",
        countryNameLocal: "Sverige",
        countryCode: "SE",
        currencyCode: "SEK",
        currencyNameEn: "Swedish krona/kronor",
        tinType: "Momsnr.",
        tinName: "VAT-nummer",
        officialLanguageCode: "sv",
        officialLanguageNameEn: "Swedish",
        officialLanguageNameLocal: "Svenska",
        countryCallingCode: "46",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDEA"
    },
    {
        countryNameEn: "Singapore",
        countryNameLocal: "Singapore",
        countryCode: "SG",
        currencyCode: "SGD",
        currencyNameEn: "Singapore dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hans",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "65",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF8\uD83C\uDDEC"
    },
    {
        countryNameEn: "Saint Helena, Ascension and Tristan da Cunha",
        countryNameLocal: "Saint Helena",
        countryCode: "SH",
        currencyCode: "SHP",
        currencyNameEn: "Saint Helena pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "290",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDED"
    },
    {
        countryNameEn: "Slovenia",
        countryNameLocal: "Slovenija",
        countryCode: "SI",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "ID za DDV",
        tinName: "Dav\u010Dna \u0161tevilka",
        officialLanguageCode: "sl",
        officialLanguageNameEn: "Slovenian",
        officialLanguageNameLocal: "Slovenski Jezik, Sloven\u0161\u010Dina",
        countryCallingCode: "386",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDEE"
    },
    {
        countryNameEn: "Svalbard and Jan Mayen",
        countryNameLocal: "Svalbard and Jan Mayen",
        countryCode: "SJ",
        currencyCode: "NOK",
        currencyNameEn: "Norwegian krone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "no",
        officialLanguageNameEn: "Norwegian",
        officialLanguageNameLocal: "Norsk",
        countryCallingCode: "4779",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDEF"
    },
    {
        countryNameEn: "Slovakia",
        countryNameLocal: "Slovensko",
        countryCode: "SK",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "I\u010C DPH",
        tinName: "Identifika\u010Dn\xe9 \u010D\xedslo pre da\u0148 z pridanej hodnoty",
        officialLanguageCode: "sk",
        officialLanguageNameEn: "Slovak",
        officialLanguageNameLocal: "Sloven\u010Dina, Slovensk\xfd Jazyk",
        countryCallingCode: "421",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDF0"
    },
    {
        countryNameEn: "Sierra Leone",
        countryNameLocal: "Sierra Leone",
        countryCode: "SL",
        currencyCode: "SLL",
        currencyNameEn: "Sierra Leonean leone",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "232",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF1"
    },
    {
        countryNameEn: "Republic of San Marino",
        countryNameLocal: "Repubblica di San Marino",
        countryCode: "SM",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "C.O.E.",
        tinName: "Codice operatore economico",
        officialLanguageCode: "it",
        officialLanguageNameEn: "Italian",
        officialLanguageNameLocal: "Italiano",
        countryCallingCode: "378",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF8\uD83C\uDDF2"
    },
    {
        countryNameEn: "Senegal",
        countryNameLocal: "S\xe9n\xe9gal",
        countryCode: "SN",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "221",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF3"
    },
    {
        countryNameEn: "Somalia",
        countryNameLocal: "Somalia, \u0627\u0644\u0635\u0648\u0645\u0627\u0644",
        countryCode: "SO",
        currencyCode: "SOS",
        currencyNameEn: "Somali shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "so",
        officialLanguageNameEn: "Somali",
        officialLanguageNameLocal: "Soomaaliga, af Soomaali",
        countryCallingCode: "252",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF8\uD83C\uDDF4"
    },
    {
        countryNameEn: "Suriname",
        countryNameLocal: "Suriname",
        countryCode: "SR",
        currencyCode: "SRD",
        currencyNameEn: "Surinamese dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "597",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF8\uD83C\uDDF7"
    },
    {
        countryNameEn: "South Sudan",
        countryNameLocal: "South Sudan",
        countryCode: "SS",
        currencyCode: "SSP",
        currencyNameEn: "South Sudanese pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "211",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF8"
    },
    {
        countryNameEn: "Sao Tome and Principe",
        countryNameLocal: "S\xe3o Tom\xe9 e Pr\xedncipe",
        countryCode: "ST",
        currencyCode: "STN",
        currencyNameEn: "",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "239",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDF9"
    },
    {
        countryNameEn: "El Salvador",
        countryNameLocal: "El Salvador",
        countryCode: "SV",
        currencyCode: "SVC",
        currencyNameEn: "Salvadoran col\xf3n",
        tinType: "NIT",
        tinName: "N\xfamero de Identificaci\xf3n Tributaria",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "503",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF8\uD83C\uDDFB"
    },
    {
        countryNameEn: "Sint Maarten (Dutch part)",
        countryNameLocal: "Sint Maarten",
        countryCode: "SX",
        currencyCode: "ANG",
        currencyNameEn: "Netherlands Antillean guilder",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "1721",
        areaCodes: [],
        region: "Unknown",
        flag: "\uD83C\uDDF8\uD83C\uDDFD"
    },
    {
        countryNameEn: "Syrian Arab Republic",
        countryNameLocal: "\u0633\u0648\u0631\u064A\u0627, S\u016Briyya",
        countryCode: "SY",
        currencyCode: "SYP",
        currencyNameEn: "Syrian pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "963",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF8\uD83C\uDDFE"
    },
    {
        countryNameEn: "Chad",
        countryNameLocal: "Tchad, \u062A\u0634\u0627\u062F",
        countryCode: "TD",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "235",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF9\uD83C\uDDE9"
    },
    {
        countryNameEn: "Togo",
        countryNameLocal: "Togo",
        countryCode: "TG",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "228",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF9\uD83C\uDDEC"
    },
    {
        countryNameEn: "Thailand",
        countryNameLocal: "\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22",
        countryCode: "TH",
        currencyCode: "THB",
        currencyNameEn: "Thai baht",
        tinType: "",
        tinName: "",
        officialLanguageCode: "th",
        officialLanguageNameEn: "Thai",
        officialLanguageNameLocal: "\u0E44\u0E17\u0E22",
        countryCallingCode: "66",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDED"
    },
    {
        countryNameEn: "Tajikistan",
        countryNameLocal: ",",
        countryCode: "TJ",
        currencyCode: "TJS",
        currencyNameEn: "Tajikistani somoni",
        tinType: "",
        tinName: "",
        officialLanguageCode: "tg",
        officialLanguageNameEn: "Tajik",
        officialLanguageNameLocal: "\u0442\u043E\u04B7\u0438\u043A\u04E3, to\xe7ik\u012B, \u062A\u0627\u062C\u06CC\u06A9\u06CC\u200E",
        countryCallingCode: "992",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDEF"
    },
    {
        countryNameEn: "Tokelau",
        countryNameLocal: "Tokelau",
        countryCode: "TK",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "tkl",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "690",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF0"
    },
    {
        countryNameEn: "Timor-Leste",
        countryNameLocal: "Timor-Leste, Timor Lorosa'e",
        countryCode: "TL",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "pt",
        officialLanguageNameEn: "Portuguese",
        officialLanguageNameLocal: "Portugu\xeas",
        countryCallingCode: "670",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF1"
    },
    {
        countryNameEn: "Turkmenistan",
        countryNameLocal: "T\xfcrkmenistan",
        countryCode: "TM",
        currencyCode: "TMT",
        currencyNameEn: "Turkmenistan manat",
        tinType: "",
        tinName: "",
        officialLanguageCode: "tk",
        officialLanguageNameEn: "Turkmen",
        officialLanguageNameLocal: "T\xfcrkmen, \u0422\u04AF\u0440\u043A\u043C\u0435\u043D",
        countryCallingCode: "993",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF2"
    },
    {
        countryNameEn: "Tunisia",
        countryNameLocal: "\u062A\u0648\u0646\u0633, Tunisie",
        countryCode: "TN",
        currencyCode: "TND",
        currencyNameEn: "Tunisian dinar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "216",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF9\uD83C\uDDF3"
    },
    {
        countryNameEn: "Tonga",
        countryNameLocal: "Tonga",
        countryCode: "TO",
        currencyCode: "TOP",
        currencyNameEn: "Tongan pa\u02BBanga",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "676",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDF4"
    },
    {
        countryNameEn: "Turkey",
        countryNameLocal: "T\xfcrkiye",
        countryCode: "TR",
        currencyCode: "TRY",
        currencyNameEn: "Turkish lira",
        tinType: "KDV",
        tinName: "Vergi Kimlik Numaras\u0131",
        officialLanguageCode: "tr",
        officialLanguageNameEn: "Turkish",
        officialLanguageNameLocal: "T\xfcrk\xe7e",
        countryCallingCode: "90",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF9\uD83C\uDDF7"
    },
    {
        countryNameEn: "Trinidad and Tobago",
        countryNameLocal: "Trinidad and Tobago",
        countryCode: "TT",
        currencyCode: "TTD",
        currencyNameEn: "Trinidad and Tobago dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "868",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDF9\uD83C\uDDF9"
    },
    {
        countryNameEn: "Tuvalu",
        countryNameLocal: "Tuvalu",
        countryCode: "TV",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "688",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDFB"
    },
    {
        countryNameEn: "United Republic of Tanzania",
        countryNameLocal: "Tanzania",
        countryCode: "TZ",
        currencyCode: "TZS",
        currencyNameEn: "Tanzanian shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sw",
        officialLanguageNameEn: "Swahili",
        officialLanguageNameLocal: "Kiswahili",
        countryCallingCode: "255",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF9\uD83C\uDDFF"
    },
    {
        countryNameEn: "Ukraine",
        countryNameLocal: "\u0423\u043A\u0440\u0430\u0457\u043D\u0430",
        countryCode: "UA",
        currencyCode: "UAH",
        currencyNameEn: "Ukrainian hryvnia",
        tinType: "\u0406\u041D\u041F\u041F",
        tinName: "\u0406\u0434\u0435\u043D\u0442\u0438\u0444\u0456\u043A\u0430\u0446\u0456\u0439\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u043D\u0438\u043A\u0430 \u043F\u043E\u0434\u0430\u0442\u043A\u0456\u0432",
        officialLanguageCode: "uk",
        officialLanguageNameEn: "Ukrainian",
        officialLanguageNameLocal: "\u0423\u043A\u0440\u0430\u0457\u043D\u0441\u044C\u043A\u0430",
        countryCallingCode: "380",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDFA\uD83C\uDDE6"
    },
    {
        countryNameEn: "Uganda",
        countryNameLocal: "Uganda",
        countryCode: "UG",
        currencyCode: "UGX",
        currencyNameEn: "Ugandan shilling",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "256",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFA\uD83C\uDDEC"
    },
    {
        countryNameEn: "United States of America",
        countryNameLocal: "United States of America",
        countryCode: "US",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "EIN",
        tinName: "Tax Identification Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [],
        region: "North America",
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    {
        countryNameEn: "Uruguay",
        countryNameLocal: "Uruguay",
        countryCode: "UY",
        currencyCode: "UYU",
        currencyNameEn: "Uruguayan peso",
        tinType: "RUT",
        tinName: "Registro \xdanico Tributario",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "598",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFA\uD83C\uDDFE"
    },
    {
        countryNameEn: "Uzbekistan",
        countryNameLocal: "",
        countryCode: "UZ",
        currencyCode: "UZS",
        currencyNameEn: "Uzbekistan som",
        tinType: "\u0421\u0422\u0418\u0420",
        tinName: "\u0421\u043E\u043B\u0438\u049B \u0442\u045E\u043B\u043E\u0432\u0447\u0438\u043B\u0430\u0440\u043D\u0438\u043D\u0433 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044F \u0440\u0430\u049B\u0430\u043C\u0438",
        officialLanguageCode: "uz",
        officialLanguageNameEn: "Uzbek",
        officialLanguageNameLocal: "O\u02BBzbek, \u040E\u0437\u0431\u0435\u043A, \u0623\u06C7\u0632\u0628\u06D0\u0643\u200E",
        countryCallingCode: "998",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFA\uD83C\uDDFF"
    },
    {
        countryNameEn: "Saint Vincent and the Grenadines",
        countryNameLocal: "Saint Vincent and the Grenadines",
        countryCode: "VC",
        currencyCode: "XCD",
        currencyNameEn: "East Caribbean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1784",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDE8"
    },
    {
        countryNameEn: "Venezuela (Bolivarian Republic of)",
        countryNameLocal: "Venezuela",
        countryCode: "VE",
        currencyCode: "VES",
        currencyNameEn: "",
        tinType: "RIF",
        tinName: "Registro de Informacion Fiscal",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "58",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDEA"
    },
    {
        countryNameEn: "Virgin Islands (British)",
        countryNameLocal: "British Virgin Islands",
        countryCode: "VG",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1284",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDEC"
    },
    {
        countryNameEn: "Virgin Islands (U.S.)",
        countryNameLocal: "United States Virgin Islands",
        countryCode: "VI",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1340",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDFB\uD83C\uDDEE"
    },
    {
        countryNameEn: "Vietnam",
        countryNameLocal: "Vi\u1EC7t Nam",
        countryCode: "VN",
        currencyCode: "VND",
        currencyNameEn: "Vietnamese \u0111\u1ED3ng",
        tinType: "",
        tinName: "",
        officialLanguageCode: "vi",
        officialLanguageNameEn: "Vietnamese",
        officialLanguageNameLocal: "Ti\u1EBFng Vi\u1EC7t",
        countryCallingCode: "84",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFB\uD83C\uDDF3"
    },
    {
        countryNameEn: "Vanuatu",
        countryNameLocal: "Vanuatu",
        countryCode: "VU",
        currencyCode: "VUV",
        currencyNameEn: "Vanuatu vatu",
        tinType: "",
        tinName: "",
        officialLanguageCode: "bi",
        officialLanguageNameEn: "Bislama",
        officialLanguageNameLocal: "Bislama",
        countryCallingCode: "678",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFB\uD83C\uDDFA"
    },
    {
        countryNameEn: "Wallis and Futuna",
        countryNameLocal: "Wallis-et-Futuna",
        countryCode: "WF",
        currencyCode: "XPF",
        currencyNameEn: "CFP franc (franc Pacifique)",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "681",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFC\uD83C\uDDEB"
    },
    {
        countryNameEn: "Samoa",
        countryNameLocal: "Samoa",
        countryCode: "WS",
        currencyCode: "WST",
        currencyNameEn: "Samoan tala",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sm",
        officialLanguageNameEn: "Samoan",
        officialLanguageNameLocal: "gagana fa'a Samoa",
        countryCallingCode: "685",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDFC\uD83C\uDDF8"
    },
    {
        countryNameEn: "Yemen",
        countryNameLocal: "\u0627\u0644\u064A\u064E\u0645\u064E\u0646",
        countryCode: "YE",
        currencyCode: "YER",
        currencyNameEn: "Yemeni rial",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "967",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDFE\uD83C\uDDEA"
    },
    {
        countryNameEn: "Mayotte",
        countryNameLocal: "Mayotte",
        countryCode: "YT",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "262",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFE\uD83C\uDDF9"
    },
    {
        countryNameEn: "South Africa",
        countryNameLocal: "South Africa",
        countryCode: "ZA",
        currencyCode: "ZAR",
        currencyNameEn: "South African rand",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "27",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFF\uD83C\uDDE6"
    },
    {
        countryNameEn: "Zambia",
        countryNameLocal: "Zambia",
        countryCode: "ZM",
        currencyCode: "ZMW",
        currencyNameEn: "Zambian kwacha",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "260",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFF\uD83C\uDDF2"
    },
    {
        countryNameEn: "Zimbabwe",
        countryNameLocal: "Zimbabwe",
        countryCode: "ZW",
        currencyCode: "ZWL",
        currencyNameEn: "Zimbabwean dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "263",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDFF\uD83C\uDDFC"
    },
    {
        countryNameEn: "Eswatini",
        countryNameLocal: "Swaziland",
        countryCode: "SZ",
        currencyCode: "SZL",
        currencyNameEn: "Swazi lilangeni",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "268",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF8\uD83C\uDDFF"
    },
    {
        countryNameEn: "North Macedonia",
        countryNameLocal: "\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430",
        countryCode: "MK",
        currencyCode: "MKD",
        currencyNameEn: "Macedonian denar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "mk",
        officialLanguageNameEn: "Macedonian",
        officialLanguageNameLocal: "\u043C\u0430\u043A\u0435\u0434\u043E\u043D\u0441\u043A\u0438 \u0458\u0430\u0437\u0438\u043A",
        countryCallingCode: "389",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDF0"
    },
    {
        countryNameEn: "Philippines",
        countryNameLocal: "Philippines",
        countryCode: "PH",
        currencyCode: "PHP",
        currencyNameEn: "Philippine peso",
        tinType: "TIN",
        tinName: "Tax Identification Number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "63",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF5\uD83C\uDDED"
    },
    {
        countryNameEn: "Netherlands",
        countryNameLocal: "Nederland",
        countryCode: "NL",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "Btw-nr.",
        tinName: "Btw-nummer",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "31",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF3\uD83C\uDDF1"
    },
    {
        countryNameEn: "United Arab Emirates",
        countryNameLocal: "\u062F\u0648\u0644\u0629 \u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0651\u0629 \u0627\u0644\u0645\u062A\u0651\u062D\u062F\u0629",
        countryCode: "AE",
        currencyCode: "AED",
        currencyNameEn: "United Arab Emirates dirham",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "971",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDE6\uD83C\uDDEA"
    },
    {
        countryNameEn: "Republic of Moldova",
        countryNameLocal: "Moldova, \u041C\u043E\u043B\u0434\u0430\u0432\u0438\u044F",
        countryCode: "MD",
        currencyCode: "MDL",
        currencyNameEn: "Moldovan leu",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ro",
        officialLanguageNameEn: "Romanian, Moldavian, Moldovan",
        officialLanguageNameLocal: "Rom\xe2n\u0103",
        countryCallingCode: "373",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDF2\uD83C\uDDE9"
    },
    {
        countryNameEn: "Gambia",
        countryNameLocal: "The Gambia",
        countryCode: "GM",
        currencyCode: "GMD",
        currencyNameEn: "Gambian dalasi",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "220",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDEC\uD83C\uDDF2"
    },
    {
        countryNameEn: "Dominican Republic",
        countryNameLocal: "Rep\xfablica Dominicana",
        countryCode: "DO",
        currencyCode: "DOP",
        currencyNameEn: "Dominican peso",
        tinType: "RNC",
        tinName: "Registro Nacional del Contribuyente",
        officialLanguageCode: "es",
        officialLanguageNameEn: "Spanish, Castilian",
        officialLanguageNameLocal: "Espa\xf1ol",
        countryCallingCode: "1",
        areaCodes: [],
        region: "South/Latin America",
        flag: "\uD83C\uDDE9\uD83C\uDDF4"
    },
    {
        countryNameEn: "Sudan",
        countryNameLocal: "\u0627\u0644\u0633\u0648\u062F\u0627\u0646",
        countryCode: "SD",
        currencyCode: "SDG",
        currencyNameEn: "Sudanese pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "ar",
        officialLanguageNameEn: "Arabic",
        officialLanguageNameLocal: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        countryCallingCode: "249",
        areaCodes: [],
        region: "Arab States",
        flag: "\uD83C\uDDF8\uD83C\uDDE9"
    },
    {
        countryNameEn: "Lao People's Democratic Republic",
        countryNameLocal: "\u0E9B\u0EB0\u0E8A\u0EB2\u0E8A\u0EBB\u0E99\u0EA5\u0EB2\u0EA7",
        countryCode: "LA",
        currencyCode: "LAK",
        currencyNameEn: "Lao kip",
        tinType: "",
        tinName: "",
        officialLanguageCode: "lo",
        officialLanguageNameEn: "Lao",
        officialLanguageNameLocal: "\u0E9E\u0EB2\u0EAA\u0EB2\u0EA5\u0EB2\u0EA7",
        countryCallingCode: "856",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF1\uD83C\uDDE6"
    },
    {
        countryNameEn: "Taiwan, Province of China",
        countryNameLocal: "Taiwan",
        countryCode: "TW",
        currencyCode: "TWD",
        currencyNameEn: "New Taiwan dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "zh-hant",
        officialLanguageNameEn: "",
        officialLanguageNameLocal: "",
        countryCallingCode: "886",
        areaCodes: [],
        region: "Asia & Pacific",
        flag: "\uD83C\uDDF9\uD83C\uDDFC"
    },
    {
        countryNameEn: "Republic of the Congo",
        countryNameLocal: "R\xe9publique du Congo",
        countryCode: "CG",
        currencyCode: "XAF",
        currencyNameEn: "CFA franc BEAC",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "242",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDEC"
    },
    {
        countryNameEn: "Czechia",
        countryNameLocal: "\u010Cesk\xe1 republika",
        countryCode: "CZ",
        currencyCode: "CZK",
        currencyNameEn: "Czech koruna",
        tinType: "DI\u010C",
        tinName: "Da\u0148ov\xe9 identifika\u010Dn\xed \u010D\xedslo",
        officialLanguageCode: "cs",
        officialLanguageNameEn: "Czech",
        officialLanguageNameLocal: "\u010Ce\u0161tina",
        countryCallingCode: "420",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDE8\uD83C\uDDFF"
    },
    {
        countryNameEn: "United Kingdom",
        countryNameLocal: "Great Britain",
        countryCode: "GB",
        currencyCode: "GBP",
        currencyNameEn: "Pound sterling",
        tinType: "VAT Reg No",
        tinName: "Value added tax registration number",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "44",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEC\uD83C\uDDE7"
    },
    {
        countryNameEn: "Niger",
        countryNameLocal: "Niger",
        countryCode: "NE",
        currencyCode: "XOF",
        currencyNameEn: "CFA franc BCEAO",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "227",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDF3\uD83C\uDDEA"
    },
    {
        countryNameEn: "Democratic Republic of the Congo",
        countryNameLocal: "Democratic Republic of the Congo",
        countryCode: "CD",
        currencyCode: "CDF",
        currencyNameEn: "Congolese franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "243",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDE9"
    },
    {
        countryNameEn: "Commonwealth of The Bahamas",
        countryNameLocal: "Commonwealth of The Bahamas",
        countryCode: "BS",
        currencyCode: "BSD",
        currencyNameEn: "Bahamian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 242",
        areaCodes: [],
        region: "Caribbean",
        flag: "\uD83C\uDDE7\uD83C\uDDF8"
    },
    {
        countryNameEn: "Cocos (Keeling) Islands",
        countryNameLocal: "Pulu Kokos (Keeling)",
        countryCode: "CC",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "61 891",
        areaCodes: [],
        region: "Australia",
        flag: "\uD83C\uDDE8\uD83C\uDDE8"
    },
    {
        countryNameEn: "Central African Republic",
        countryNameLocal: "R\xe9publique centrafricaine",
        countryCode: "CF",
        currencyCode: "XAF",
        currencyNameEn: "Central African CFA",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "236",
        areaCodes: [],
        region: "Africa",
        flag: "\uD83C\uDDE8\uD83C\uDDEB"
    },
    {
        countryNameEn: "Cook Islands",
        countryNameLocal: "K\u016Bki '\u0100irani",
        countryCode: "CK",
        currencyCode: "NZD",
        currencyNameEn: "New Zealand dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "682",
        areaCodes: [],
        region: "South Pacific Ocean",
        flag: "\uD83C\uDDE8\uD83C\uDDF0"
    },
    {
        countryNameEn: "Falkland Islands",
        countryNameLocal: "Falkland Islands",
        countryCode: "FK",
        currencyCode: "FKP",
        currencyNameEn: "Falklands pound",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "500",
        areaCodes: [],
        region: "South Atlantic Ocean",
        flag: "\uD83C\uDDEB\uD83C\uDDF0"
    },
    {
        countryNameEn: "Faroe Islands",
        countryNameLocal: "F\xe6r\xf8erne",
        countryCode: "FO",
        currencyCode: "DKK",
        currencyNameEn: "Faroese kr\xf3na",
        tinType: "",
        tinName: "",
        officialLanguageCode: "da",
        officialLanguageNameEn: "Danish",
        officialLanguageNameLocal: "dansk",
        countryCallingCode: "298",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDEB\uD83C\uDDF4"
    },
    {
        countryNameEn: "Territory of Heard Island and McDonald Islands",
        countryNameLocal: "Territory of Heard Island and McDonald Islands",
        countryCode: "HM",
        currencyCode: "AUD",
        currencyNameEn: "Australian dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDED\uD83C\uDDF2"
    },
    {
        countryNameEn: "British Indian Ocean Territory",
        countryNameLocal: "British Indian Ocean Territory",
        countryCode: "IO",
        currencyCode: "USD",
        currencyNameEn: "United States Dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "246",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDEE\uD83C\uDDF4"
    },
    {
        countryNameEn: "Comoros",
        countryNameLocal: "Umoja wa Komori",
        countryCode: "KM",
        currencyCode: "KMF",
        currencyNameEn: "Comorian franc",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "269",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDF0\uD83C\uDDF2"
    },
    {
        countryNameEn: "Cayman Islands",
        countryNameLocal: "Cayman Islands",
        countryCode: "KY",
        currencyCode: "KYD",
        currencyNameEn: "Cayman Islands dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 345",
        areaCodes: [],
        region: "Caribbean Sea",
        flag: "\uD83C\uDDF0\uD83C\uDDFE"
    },
    {
        countryNameEn: "Republic of the Marshall Islands",
        countryNameLocal: "Aolep\u0101n Aor\u014Dkin \u1E42aje\u1E37",
        countryCode: "MH",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "692",
        areaCodes: [],
        region: "Pacific Ocean",
        flag: "\uD83C\uDDF2\uD83C\uDDED"
    },
    {
        countryNameEn: "Commonwealth of the Northern Mariana Islands",
        countryNameLocal: "Sankattan Siha Na Islas Mari\xe5nas",
        countryCode: "MP",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 670",
        areaCodes: [],
        region: "Pacific Ocean",
        flag: "\uD83C\uDDF2\uD83C\uDDF5"
    },
    {
        countryNameEn: "Turks and Caicos Islands",
        countryNameLocal: "Turks and Caicos Islands",
        countryCode: "TC",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1 649",
        areaCodes: [],
        region: "Atlantic Ocean",
        flag: "\uD83C\uDDF9\uD83C\uDDE8"
    },
    {
        countryNameEn: "French Southern and Antarctic Lands",
        countryNameLocal: "Terres australes et antarctiques fran\xe7aises",
        countryCode: "TF",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "fr",
        officialLanguageNameEn: "French",
        officialLanguageNameLocal: "Fran\xe7ais",
        countryCallingCode: "672",
        areaCodes: [],
        region: "Indian Ocean",
        flag: "\uD83C\uDDF9\uD83C\uDDEB"
    },
    {
        countryNameEn: "United States Minor Outlying Islands",
        countryNameLocal: "United States Minor Outlying Islands",
        countryCode: "UM",
        currencyCode: "USD",
        currencyNameEn: "United States dollar",
        tinType: "",
        tinName: "",
        officialLanguageCode: "en",
        officialLanguageNameEn: "English",
        officialLanguageNameLocal: "English",
        countryCallingCode: "1",
        areaCodes: [],
        region: "Pacific Ocean",
        flag: "\uD83C\uDDFA\uD83C\uDDF2"
    },
    {
        countryNameEn: "Holy See",
        countryNameLocal: "Sancta Sedes",
        countryCode: "VA",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "la",
        officialLanguageNameEn: "Latin",
        officialLanguageNameLocal: "lingua lat\u012Bna",
        countryCallingCode: "39",
        areaCodes: [],
        region: "Europe",
        flag: "\uD83C\uDDFB\uD83C\uDDE6"
    },
    {
        countryNameEn: "Republic of Kosovo",
        countryNameLocal: "Republika e Kosov\xebs",
        countryCode: "XK",
        currencyCode: "EUR",
        currencyNameEn: "Euro",
        tinType: "",
        tinName: "",
        officialLanguageCode: "sq",
        officialLanguageNameEn: "Albanian",
        officialLanguageNameLocal: "Shqip",
        countryCallingCode: "383",
        region: "Europe",
        flag: "\uD83C\uDDFD\uD83C\uDDF0"
    },
    {
        countryNameEn: "Netherlands Antilles",
        countryNameLocal: "Nederlandse Antillen",
        countryCode: "AN",
        currencyCode: "ANG",
        currencyNameEn: "Netherlands Antillean guilder",
        tinType: "",
        tinName: "",
        officialLanguageCode: "nl",
        officialLanguageNameEn: "Dutch, Flemish",
        officialLanguageNameLocal: "Nederlands, Vlaams",
        countryCallingCode: "599",
        region: "Europe",
        flag: "\uD83C\uDDE7\uD83C\uDDF6"
    }
];
module.exports.default = $ac7f6122ba3ba1ce$var$countriesData;

});

parcelRegister("dFjst", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', promiseTag = '[object Promise]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */ function addMapEntry(map, pair) {
    // Don't return `map.set` because it's not chainable in IE 11.
    map.set(pair[0], pair[1]);
    return map;
}
/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */ function addSetEntry(set, value) {
    // Don't return `set.add` because it's not chainable in IE 11.
    set.add(value);
    return set;
}
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView'), Map = getNative(root, 'Map'), Promise = getNative(root, 'Promise'), Set = getNative(root, 'Set'), WeakMap = getNative(root, 'WeakMap'), nativeCreate = getNative(Object, 'create');
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__['delete'](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function assignValue(object, key, value) {
    var objValue = object[key];
    if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) object[key] = value;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function baseAssign(object, source) {
    return object && copyObject(source, keys(source), object);
}
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
    var result;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!isObject(value)) return value;
    var isArr = isArray(value);
    if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) return copyArray(value, result);
    } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) return cloneBuffer(value, isDeep);
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
            if (isHostObject(value)) return object ? value : {};
            result = initCloneObject(isFunc ? {} : value);
            if (!isDeep) return copySymbols(value, baseAssign(result, value));
        } else {
            if (!cloneableTags[tag]) return object ? value : {};
            result = initCloneByTag(value, tag, baseClone, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new Stack);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if (!isArr) var props = isFull ? getAllKeys(value) : keys(value);
    arrayEach(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
    });
    return result;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var result = new buffer.constructor(buffer.length);
    buffer.copy(result);
    return result;
}
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */ function cloneMap(map, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
    return arrayReduce(array, addMapEntry, new map.constructor);
}
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */ function cloneSet(set, isDeep, cloneFunc) {
    var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
    return arrayReduce(array, addSetEntry, new set.constructor);
}
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function cloneSymbol(symbol) {
    return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function copyObject(source, props, object, customizer) {
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        assignValue(object, key, newValue === undefined ? source[key] : newValue);
    }
    return object;
}
/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function copySymbols(source, object) {
    return copyObject(source, getSymbols(source), object);
}
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function initCloneArray(array) {
    var length = array.length, result = array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneObject(object) {
    return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
}
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function initCloneByTag(object, tag, cloneFunc, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case arrayBufferTag:
            return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
            return new Ctor(+object);
        case dataViewTag:
            return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
            return cloneTypedArray(object, isDeep);
        case mapTag:
            return cloneMap(object, isDeep, cloneFunc);
        case numberTag:
        case stringTag:
            return new Ctor(object);
        case regexpTag:
            return cloneRegExp(object);
        case setTag:
            return cloneSet(object, isDeep, cloneFunc);
        case symbolTag:
            return cloneSymbol(object);
    }
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function cloneDeep(value) {
    return baseClone(value, true, true);
}
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : '';
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = cloneDeep;

});

parcelRegister("4kgx4", function(module, exports) {

var $fuOhN = parcelRequire("fuOhN");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $fuOhN.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === 'string') try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === 'object') payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRegister("fuOhN", function(module, exports) {

$parcel$export(module.exports, "sign", () => $b480aa1805af3b4f$export$c5552dfdbc7cec71, (v) => $b480aa1805af3b4f$export$c5552dfdbc7cec71 = v);
$parcel$export(module.exports, "verify", () => $b480aa1805af3b4f$export$532244b5b8b0b4b6, (v) => $b480aa1805af3b4f$export$532244b5b8b0b4b6 = v);
$parcel$export(module.exports, "decode", () => $b480aa1805af3b4f$export$2f872c0f2117be69, (v) => $b480aa1805af3b4f$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "createSign", () => $b480aa1805af3b4f$export$45df7cae684751af, (v) => $b480aa1805af3b4f$export$45df7cae684751af = v);
/*global exports*/ var $b480aa1805af3b4f$export$6f6fa4628974a579;
var $b480aa1805af3b4f$export$c5552dfdbc7cec71;
var $b480aa1805af3b4f$export$532244b5b8b0b4b6;
var $b480aa1805af3b4f$export$2f872c0f2117be69;
var $b480aa1805af3b4f$export$1ea939691cdc45b8;
var $b480aa1805af3b4f$export$45df7cae684751af;
var $b480aa1805af3b4f$export$6f65485f87568e37;

var $4XRSe = parcelRequire("4XRSe");

var $c5wBR = parcelRequire("c5wBR");
var $b480aa1805af3b4f$var$ALGORITHMS = [
    'HS256',
    'HS384',
    'HS512',
    'RS256',
    'RS384',
    'RS512',
    'PS256',
    'PS384',
    'PS512',
    'ES256',
    'ES384',
    'ES512'
];
$b480aa1805af3b4f$export$6f6fa4628974a579 = $b480aa1805af3b4f$var$ALGORITHMS;
$b480aa1805af3b4f$export$c5552dfdbc7cec71 = $4XRSe.sign;
$b480aa1805af3b4f$export$532244b5b8b0b4b6 = $c5wBR.verify;
$b480aa1805af3b4f$export$2f872c0f2117be69 = $c5wBR.decode;
$b480aa1805af3b4f$export$1ea939691cdc45b8 = $c5wBR.isValid;
$b480aa1805af3b4f$export$45df7cae684751af = function createSign(opts) {
    return new $4XRSe(opts);
};
$b480aa1805af3b4f$export$6f65485f87568e37 = function createVerify(opts) {
    return new $c5wBR(opts);
};

});
parcelRegister("4XRSe", function(module, exports) {
/*global module*/ 
var $4OiF0 = parcelRequire("4OiF0");
var $39d6764fdf33983c$require$Buffer = $4OiF0.Buffer;

var $2r4Mc = parcelRequire("2r4Mc");

var $9xnLy = parcelRequire("9xnLy");

var $9nTep = parcelRequire("9nTep");

var $i16Zl = parcelRequire("i16Zl");

var $5DFzG = parcelRequire("5DFzG");
function $39d6764fdf33983c$var$base64url(string, encoding) {
    return $39d6764fdf33983c$require$Buffer.from(string, encoding).toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $39d6764fdf33983c$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || 'utf8';
    var encodedHeader = $39d6764fdf33983c$var$base64url($i16Zl(header), 'binary');
    var encodedPayload = $39d6764fdf33983c$var$base64url($i16Zl(payload), encoding);
    return $5DFzG.format('%s.%s', encodedHeader, encodedPayload);
}
function $39d6764fdf33983c$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $9xnLy(header.alg);
    var securedInput = $39d6764fdf33983c$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $5DFzG.format('%s.%s', securedInput, signature);
}
function $39d6764fdf33983c$var$SignStream(opts) {
    var secret = opts.secret;
    secret = secret == null ? opts.privateKey : secret;
    secret = secret == null ? opts.key : secret;
    if (/^hs/i.test(opts.header.alg) === true && secret == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $2r4Mc(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $2r4Mc(opts.payload);
    this.secret.once('close', (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once('close', (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$5DFzG.inherits($39d6764fdf33983c$var$SignStream, $9nTep);
$39d6764fdf33983c$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $39d6764fdf33983c$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit('done', signature);
        this.emit('data', signature);
        this.emit('end');
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$39d6764fdf33983c$var$SignStream.sign = $39d6764fdf33983c$var$jwsSign;
module.exports = $39d6764fdf33983c$var$SignStream;

});
parcelRegister("4OiF0", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $8UsMN = parcelRequire("8UsMN");
var $380a4e85b8a3823e$var$Buffer = $8UsMN.Buffer;
// alternative to using Object.keys for old browsers
function $380a4e85b8a3823e$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($380a4e85b8a3823e$var$Buffer.from && $380a4e85b8a3823e$var$Buffer.alloc && $380a4e85b8a3823e$var$Buffer.allocUnsafe && $380a4e85b8a3823e$var$Buffer.allocUnsafeSlow) module.exports = $8UsMN;
else {
    // Copy properties from require('buffer')
    $380a4e85b8a3823e$var$copyProps($8UsMN, module.exports);
    module.exports.Buffer = $380a4e85b8a3823e$var$SafeBuffer;
}
function $380a4e85b8a3823e$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $380a4e85b8a3823e$var$Buffer(arg, encodingOrOffset, length);
}
$380a4e85b8a3823e$var$SafeBuffer.prototype = Object.create($380a4e85b8a3823e$var$Buffer.prototype);
// Copy static methods from Buffer
$380a4e85b8a3823e$var$copyProps($380a4e85b8a3823e$var$Buffer, $380a4e85b8a3823e$var$SafeBuffer);
$380a4e85b8a3823e$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $380a4e85b8a3823e$var$Buffer(arg, encodingOrOffset, length);
};
$380a4e85b8a3823e$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $380a4e85b8a3823e$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$380a4e85b8a3823e$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $380a4e85b8a3823e$var$Buffer(size);
};
$380a4e85b8a3823e$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $8UsMN.SlowBuffer(size);
};

});
parcelRegister("8UsMN", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $67c9e20098a0f7e5$export$a143d493d941bafc, (v) => $67c9e20098a0f7e5$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $67c9e20098a0f7e5$export$e4cf37d7f6fb9e0a, (v) => $67c9e20098a0f7e5$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $67c9e20098a0f7e5$export$f99ded8fe4b79145, (v) => $67c9e20098a0f7e5$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $67c9e20098a0f7e5$export$599f31c3813fae4d, (v) => $67c9e20098a0f7e5$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $67c9e20098a0f7e5$export$a143d493d941bafc;
var $67c9e20098a0f7e5$export$e4cf37d7f6fb9e0a;
var $67c9e20098a0f7e5$export$f99ded8fe4b79145;
var $67c9e20098a0f7e5$export$599f31c3813fae4d;
'use strict';

var $7E04z = parcelRequire("7E04z");

var $7YtfP = parcelRequire("7YtfP");
const $67c9e20098a0f7e5$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$67c9e20098a0f7e5$export$a143d493d941bafc = $67c9e20098a0f7e5$var$Buffer;
$67c9e20098a0f7e5$export$e4cf37d7f6fb9e0a = $67c9e20098a0f7e5$var$SlowBuffer;
$67c9e20098a0f7e5$export$f99ded8fe4b79145 = 50;
const $67c9e20098a0f7e5$var$K_MAX_LENGTH = 0x7fffffff;
$67c9e20098a0f7e5$export$599f31c3813fae4d = $67c9e20098a0f7e5$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $67c9e20098a0f7e5$var$Buffer.TYPED_ARRAY_SUPPORT = $67c9e20098a0f7e5$var$typedArraySupport();
if (!$67c9e20098a0f7e5$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $67c9e20098a0f7e5$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($67c9e20098a0f7e5$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($67c9e20098a0f7e5$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $67c9e20098a0f7e5$var$createBuffer(length) {
    if (length > $67c9e20098a0f7e5$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $67c9e20098a0f7e5$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $67c9e20098a0f7e5$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $67c9e20098a0f7e5$var$allocUnsafe(arg);
    }
    return $67c9e20098a0f7e5$var$from(arg, encodingOrOffset, length);
}
$67c9e20098a0f7e5$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $67c9e20098a0f7e5$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $67c9e20098a0f7e5$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $67c9e20098a0f7e5$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($67c9e20098a0f7e5$var$isInstance(value, ArrayBuffer) || value && $67c9e20098a0f7e5$var$isInstance(value.buffer, ArrayBuffer)) return $67c9e20098a0f7e5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($67c9e20098a0f7e5$var$isInstance(value, SharedArrayBuffer) || value && $67c9e20098a0f7e5$var$isInstance(value.buffer, SharedArrayBuffer))) return $67c9e20098a0f7e5$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $67c9e20098a0f7e5$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $67c9e20098a0f7e5$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $67c9e20098a0f7e5$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $67c9e20098a0f7e5$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $67c9e20098a0f7e5$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($67c9e20098a0f7e5$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($67c9e20098a0f7e5$var$Buffer, Uint8Array);
function $67c9e20098a0f7e5$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $67c9e20098a0f7e5$var$alloc(size, fill, encoding) {
    $67c9e20098a0f7e5$var$assertSize(size);
    if (size <= 0) return $67c9e20098a0f7e5$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $67c9e20098a0f7e5$var$createBuffer(size).fill(fill, encoding) : $67c9e20098a0f7e5$var$createBuffer(size).fill(fill);
    return $67c9e20098a0f7e5$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $67c9e20098a0f7e5$var$Buffer.alloc = function(size, fill, encoding) {
    return $67c9e20098a0f7e5$var$alloc(size, fill, encoding);
};
function $67c9e20098a0f7e5$var$allocUnsafe(size) {
    $67c9e20098a0f7e5$var$assertSize(size);
    return $67c9e20098a0f7e5$var$createBuffer(size < 0 ? 0 : $67c9e20098a0f7e5$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $67c9e20098a0f7e5$var$Buffer.allocUnsafe = function(size) {
    return $67c9e20098a0f7e5$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $67c9e20098a0f7e5$var$Buffer.allocUnsafeSlow = function(size) {
    return $67c9e20098a0f7e5$var$allocUnsafe(size);
};
function $67c9e20098a0f7e5$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$67c9e20098a0f7e5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $67c9e20098a0f7e5$var$byteLength(string, encoding) | 0;
    let buf = $67c9e20098a0f7e5$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $67c9e20098a0f7e5$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $67c9e20098a0f7e5$var$checked(array.length) | 0;
    const buf = $67c9e20098a0f7e5$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $67c9e20098a0f7e5$var$fromArrayView(arrayView) {
    if ($67c9e20098a0f7e5$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $67c9e20098a0f7e5$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $67c9e20098a0f7e5$var$fromArrayLike(arrayView);
}
function $67c9e20098a0f7e5$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $67c9e20098a0f7e5$var$Buffer.prototype);
    return buf;
}
function $67c9e20098a0f7e5$var$fromObject(obj) {
    if ($67c9e20098a0f7e5$var$Buffer.isBuffer(obj)) {
        const len = $67c9e20098a0f7e5$var$checked(obj.length) | 0;
        const buf = $67c9e20098a0f7e5$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $67c9e20098a0f7e5$var$numberIsNaN(obj.length)) return $67c9e20098a0f7e5$var$createBuffer(0);
        return $67c9e20098a0f7e5$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $67c9e20098a0f7e5$var$fromArrayLike(obj.data);
}
function $67c9e20098a0f7e5$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $67c9e20098a0f7e5$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $67c9e20098a0f7e5$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $67c9e20098a0f7e5$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $67c9e20098a0f7e5$var$Buffer.alloc(+length);
}
$67c9e20098a0f7e5$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $67c9e20098a0f7e5$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$67c9e20098a0f7e5$var$Buffer.compare = function compare(a, b) {
    if ($67c9e20098a0f7e5$var$isInstance(a, Uint8Array)) a = $67c9e20098a0f7e5$var$Buffer.from(a, a.offset, a.byteLength);
    if ($67c9e20098a0f7e5$var$isInstance(b, Uint8Array)) b = $67c9e20098a0f7e5$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(a) || !$67c9e20098a0f7e5$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$67c9e20098a0f7e5$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$67c9e20098a0f7e5$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $67c9e20098a0f7e5$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $67c9e20098a0f7e5$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($67c9e20098a0f7e5$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(buf)) buf = $67c9e20098a0f7e5$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $67c9e20098a0f7e5$var$byteLength(string, encoding) {
    if ($67c9e20098a0f7e5$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $67c9e20098a0f7e5$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $67c9e20098a0f7e5$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $67c9e20098a0f7e5$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $67c9e20098a0f7e5$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$67c9e20098a0f7e5$var$Buffer.byteLength = $67c9e20098a0f7e5$var$byteLength;
function $67c9e20098a0f7e5$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $67c9e20098a0f7e5$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $67c9e20098a0f7e5$var$utf8Slice(this, start, end);
        case 'ascii':
            return $67c9e20098a0f7e5$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $67c9e20098a0f7e5$var$latin1Slice(this, start, end);
        case 'base64':
            return $67c9e20098a0f7e5$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $67c9e20098a0f7e5$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$67c9e20098a0f7e5$var$Buffer.prototype._isBuffer = true;
function $67c9e20098a0f7e5$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$67c9e20098a0f7e5$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$67c9e20098a0f7e5$var$swap(this, i, i + 1);
    return this;
};
$67c9e20098a0f7e5$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $67c9e20098a0f7e5$var$swap(this, i, i + 3);
        $67c9e20098a0f7e5$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$67c9e20098a0f7e5$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $67c9e20098a0f7e5$var$swap(this, i, i + 7);
        $67c9e20098a0f7e5$var$swap(this, i + 1, i + 6);
        $67c9e20098a0f7e5$var$swap(this, i + 2, i + 5);
        $67c9e20098a0f7e5$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$67c9e20098a0f7e5$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $67c9e20098a0f7e5$var$utf8Slice(this, 0, length);
    return $67c9e20098a0f7e5$var$slowToString.apply(this, arguments);
};
$67c9e20098a0f7e5$var$Buffer.prototype.toLocaleString = $67c9e20098a0f7e5$var$Buffer.prototype.toString;
$67c9e20098a0f7e5$var$Buffer.prototype.equals = function equals(b) {
    if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $67c9e20098a0f7e5$var$Buffer.compare(this, b) === 0;
};
$67c9e20098a0f7e5$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $67c9e20098a0f7e5$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($67c9e20098a0f7e5$var$customInspectSymbol) $67c9e20098a0f7e5$var$Buffer.prototype[$67c9e20098a0f7e5$var$customInspectSymbol] = $67c9e20098a0f7e5$var$Buffer.prototype.inspect;
$67c9e20098a0f7e5$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($67c9e20098a0f7e5$var$isInstance(target, Uint8Array)) target = $67c9e20098a0f7e5$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $67c9e20098a0f7e5$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($67c9e20098a0f7e5$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $67c9e20098a0f7e5$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($67c9e20098a0f7e5$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $67c9e20098a0f7e5$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $67c9e20098a0f7e5$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $67c9e20098a0f7e5$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$67c9e20098a0f7e5$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$67c9e20098a0f7e5$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $67c9e20098a0f7e5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$67c9e20098a0f7e5$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $67c9e20098a0f7e5$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $67c9e20098a0f7e5$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($67c9e20098a0f7e5$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $67c9e20098a0f7e5$var$utf8Write(buf, string, offset, length) {
    return $67c9e20098a0f7e5$var$blitBuffer($67c9e20098a0f7e5$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $67c9e20098a0f7e5$var$asciiWrite(buf, string, offset, length) {
    return $67c9e20098a0f7e5$var$blitBuffer($67c9e20098a0f7e5$var$asciiToBytes(string), buf, offset, length);
}
function $67c9e20098a0f7e5$var$base64Write(buf, string, offset, length) {
    return $67c9e20098a0f7e5$var$blitBuffer($67c9e20098a0f7e5$var$base64ToBytes(string), buf, offset, length);
}
function $67c9e20098a0f7e5$var$ucs2Write(buf, string, offset, length) {
    return $67c9e20098a0f7e5$var$blitBuffer($67c9e20098a0f7e5$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$67c9e20098a0f7e5$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $67c9e20098a0f7e5$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $67c9e20098a0f7e5$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $67c9e20098a0f7e5$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $67c9e20098a0f7e5$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $67c9e20098a0f7e5$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$67c9e20098a0f7e5$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $67c9e20098a0f7e5$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7E04z.fromByteArray(buf);
    else return $7E04z.fromByteArray(buf.slice(start, end));
}
function $67c9e20098a0f7e5$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $67c9e20098a0f7e5$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $67c9e20098a0f7e5$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $67c9e20098a0f7e5$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $67c9e20098a0f7e5$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $67c9e20098a0f7e5$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $67c9e20098a0f7e5$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $67c9e20098a0f7e5$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $67c9e20098a0f7e5$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $67c9e20098a0f7e5$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $67c9e20098a0f7e5$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$67c9e20098a0f7e5$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $67c9e20098a0f7e5$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $67c9e20098a0f7e5$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$67c9e20098a0f7e5$var$Buffer.prototype.readUintLE = $67c9e20098a0f7e5$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readUintBE = $67c9e20098a0f7e5$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readUint8 = $67c9e20098a0f7e5$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$67c9e20098a0f7e5$var$Buffer.prototype.readUint16LE = $67c9e20098a0f7e5$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readUint16BE = $67c9e20098a0f7e5$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$67c9e20098a0f7e5$var$Buffer.prototype.readUint32LE = $67c9e20098a0f7e5$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readUint32BE = $67c9e20098a0f7e5$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$67c9e20098a0f7e5$var$Buffer.prototype.readBigUInt64LE = $67c9e20098a0f7e5$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $67c9e20098a0f7e5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $67c9e20098a0f7e5$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$67c9e20098a0f7e5$var$Buffer.prototype.readBigUInt64BE = $67c9e20098a0f7e5$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $67c9e20098a0f7e5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $67c9e20098a0f7e5$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$67c9e20098a0f7e5$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$67c9e20098a0f7e5$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$67c9e20098a0f7e5$var$Buffer.prototype.readBigInt64LE = $67c9e20098a0f7e5$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $67c9e20098a0f7e5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $67c9e20098a0f7e5$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$67c9e20098a0f7e5$var$Buffer.prototype.readBigInt64BE = $67c9e20098a0f7e5$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $67c9e20098a0f7e5$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $67c9e20098a0f7e5$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$67c9e20098a0f7e5$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 4, this.length);
    return $7YtfP.read(this, offset, true, 23, 4);
};
$67c9e20098a0f7e5$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 4, this.length);
    return $7YtfP.read(this, offset, false, 23, 4);
};
$67c9e20098a0f7e5$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 8, this.length);
    return $7YtfP.read(this, offset, true, 52, 8);
};
$67c9e20098a0f7e5$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkOffset(offset, 8, this.length);
    return $7YtfP.read(this, offset, false, 52, 8);
};
function $67c9e20098a0f7e5$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$67c9e20098a0f7e5$var$Buffer.prototype.writeUintLE = $67c9e20098a0f7e5$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $67c9e20098a0f7e5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeUintBE = $67c9e20098a0f7e5$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $67c9e20098a0f7e5$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeUint8 = $67c9e20098a0f7e5$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeUint16LE = $67c9e20098a0f7e5$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeUint16BE = $67c9e20098a0f7e5$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeUint32LE = $67c9e20098a0f7e5$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeUint32BE = $67c9e20098a0f7e5$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $67c9e20098a0f7e5$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $67c9e20098a0f7e5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $67c9e20098a0f7e5$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $67c9e20098a0f7e5$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$67c9e20098a0f7e5$var$Buffer.prototype.writeBigUInt64LE = $67c9e20098a0f7e5$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $67c9e20098a0f7e5$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$67c9e20098a0f7e5$var$Buffer.prototype.writeBigUInt64BE = $67c9e20098a0f7e5$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $67c9e20098a0f7e5$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$67c9e20098a0f7e5$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $67c9e20098a0f7e5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $67c9e20098a0f7e5$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeBigInt64LE = $67c9e20098a0f7e5$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $67c9e20098a0f7e5$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$67c9e20098a0f7e5$var$Buffer.prototype.writeBigInt64BE = $67c9e20098a0f7e5$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $67c9e20098a0f7e5$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $67c9e20098a0f7e5$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $67c9e20098a0f7e5$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7YtfP.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$67c9e20098a0f7e5$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $67c9e20098a0f7e5$var$writeFloat(this, value, offset, true, noAssert);
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $67c9e20098a0f7e5$var$writeFloat(this, value, offset, false, noAssert);
};
function $67c9e20098a0f7e5$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $67c9e20098a0f7e5$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7YtfP.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$67c9e20098a0f7e5$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $67c9e20098a0f7e5$var$writeDouble(this, value, offset, true, noAssert);
};
$67c9e20098a0f7e5$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $67c9e20098a0f7e5$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$67c9e20098a0f7e5$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$67c9e20098a0f7e5$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$67c9e20098a0f7e5$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$67c9e20098a0f7e5$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $67c9e20098a0f7e5$var$Buffer.isBuffer(val) ? val : $67c9e20098a0f7e5$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $67c9e20098a0f7e5$var$errors = {};
function $67c9e20098a0f7e5$var$E(sym, getMessage, Base) {
    $67c9e20098a0f7e5$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$67c9e20098a0f7e5$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$67c9e20098a0f7e5$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$67c9e20098a0f7e5$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $67c9e20098a0f7e5$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $67c9e20098a0f7e5$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $67c9e20098a0f7e5$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $67c9e20098a0f7e5$var$checkBounds(buf, offset, byteLength) {
    $67c9e20098a0f7e5$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $67c9e20098a0f7e5$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $67c9e20098a0f7e5$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $67c9e20098a0f7e5$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $67c9e20098a0f7e5$var$checkBounds(buf, offset, byteLength);
}
function $67c9e20098a0f7e5$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $67c9e20098a0f7e5$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $67c9e20098a0f7e5$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $67c9e20098a0f7e5$var$validateNumber(value, type);
        throw new $67c9e20098a0f7e5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $67c9e20098a0f7e5$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $67c9e20098a0f7e5$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $67c9e20098a0f7e5$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $67c9e20098a0f7e5$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($67c9e20098a0f7e5$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $67c9e20098a0f7e5$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $67c9e20098a0f7e5$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $67c9e20098a0f7e5$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $67c9e20098a0f7e5$var$base64ToBytes(str) {
    return $7E04z.toByteArray($67c9e20098a0f7e5$var$base64clean(str));
}
function $67c9e20098a0f7e5$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $67c9e20098a0f7e5$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $67c9e20098a0f7e5$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $67c9e20098a0f7e5$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $67c9e20098a0f7e5$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $67c9e20098a0f7e5$var$BufferBigIntNotDefined : fn;
}
function $67c9e20098a0f7e5$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("7E04z", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $590c5348fc5a211a$export$d622b2ad8d90c771, (v) => $590c5348fc5a211a$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $590c5348fc5a211a$export$6100ba28696e12de, (v) => $590c5348fc5a211a$export$6100ba28696e12de = v);
var $590c5348fc5a211a$export$a48f0734ac7c2329;
var $590c5348fc5a211a$export$d622b2ad8d90c771;
var $590c5348fc5a211a$export$6100ba28696e12de;
'use strict';
$590c5348fc5a211a$export$a48f0734ac7c2329 = $590c5348fc5a211a$var$byteLength;
$590c5348fc5a211a$export$d622b2ad8d90c771 = $590c5348fc5a211a$var$toByteArray;
$590c5348fc5a211a$export$6100ba28696e12de = $590c5348fc5a211a$var$fromByteArray;
var $590c5348fc5a211a$var$lookup = [];
var $590c5348fc5a211a$var$revLookup = [];
var $590c5348fc5a211a$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $590c5348fc5a211a$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $590c5348fc5a211a$var$i = 0, $590c5348fc5a211a$var$len = $590c5348fc5a211a$var$code.length; $590c5348fc5a211a$var$i < $590c5348fc5a211a$var$len; ++$590c5348fc5a211a$var$i){
    $590c5348fc5a211a$var$lookup[$590c5348fc5a211a$var$i] = $590c5348fc5a211a$var$code[$590c5348fc5a211a$var$i];
    $590c5348fc5a211a$var$revLookup[$590c5348fc5a211a$var$code.charCodeAt($590c5348fc5a211a$var$i)] = $590c5348fc5a211a$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$590c5348fc5a211a$var$revLookup['-'.charCodeAt(0)] = 62;
$590c5348fc5a211a$var$revLookup['_'.charCodeAt(0)] = 63;
function $590c5348fc5a211a$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $590c5348fc5a211a$var$byteLength(b64) {
    var lens = $590c5348fc5a211a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $590c5348fc5a211a$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $590c5348fc5a211a$var$toByteArray(b64) {
    var tmp;
    var lens = $590c5348fc5a211a$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $590c5348fc5a211a$var$Arr($590c5348fc5a211a$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i)] << 18 | $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i)] << 2 | $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i)] << 10 | $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $590c5348fc5a211a$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $590c5348fc5a211a$var$tripletToBase64(num) {
    return $590c5348fc5a211a$var$lookup[num >> 18 & 0x3F] + $590c5348fc5a211a$var$lookup[num >> 12 & 0x3F] + $590c5348fc5a211a$var$lookup[num >> 6 & 0x3F] + $590c5348fc5a211a$var$lookup[num & 0x3F];
}
function $590c5348fc5a211a$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($590c5348fc5a211a$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $590c5348fc5a211a$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($590c5348fc5a211a$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($590c5348fc5a211a$var$lookup[tmp >> 2] + $590c5348fc5a211a$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($590c5348fc5a211a$var$lookup[tmp >> 10] + $590c5348fc5a211a$var$lookup[tmp >> 4 & 0x3F] + $590c5348fc5a211a$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("7YtfP", function(module, exports) {

$parcel$export(module.exports, "read", () => $5ce4d44f35dbee3f$export$aafa59e2e03f2942, (v) => $5ce4d44f35dbee3f$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $5ce4d44f35dbee3f$export$68d8715fc104d294, (v) => $5ce4d44f35dbee3f$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $5ce4d44f35dbee3f$export$aafa59e2e03f2942;
var $5ce4d44f35dbee3f$export$68d8715fc104d294;
$5ce4d44f35dbee3f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$5ce4d44f35dbee3f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("2r4Mc", function(module, exports) {
/*global module, process*/ 
var $ajwPf = parcelRequire("ajwPf");

var $4OiF0 = parcelRequire("4OiF0");
var $1c61cedfaea6ca0f$require$Buffer = $4OiF0.Buffer;

var $9nTep = parcelRequire("9nTep");

var $5DFzG = parcelRequire("5DFzG");
function $1c61cedfaea6ca0f$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $1c61cedfaea6ca0f$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === 'function') {
        this.buffer = $1c61cedfaea6ca0f$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === 'object') {
        this.buffer = data;
        this.writable = false;
        $ajwPf.nextTick((function() {
            this.emit('end', data);
            this.readable = false;
            this.emit('close');
        }).bind(this));
        return this;
    }
    throw new TypeError('Unexpected data type (' + typeof data + ')');
}
$5DFzG.inherits($1c61cedfaea6ca0f$var$DataStream, $9nTep);
$1c61cedfaea6ca0f$var$DataStream.prototype.write = function write(data) {
    this.buffer = $1c61cedfaea6ca0f$require$Buffer.concat([
        this.buffer,
        $1c61cedfaea6ca0f$require$Buffer.from(data)
    ]);
    this.emit('data', data);
};
$1c61cedfaea6ca0f$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit('end', data);
    this.emit('close');
    this.writable = false;
    this.readable = false;
};
module.exports = $1c61cedfaea6ca0f$var$DataStream;

});
parcelRegister("ajwPf", function(module, exports) {
// shim for using process in browser
var $78252438d374e671$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $78252438d374e671$var$cachedSetTimeout;
var $78252438d374e671$var$cachedClearTimeout;
function $78252438d374e671$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $78252438d374e671$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $78252438d374e671$var$cachedSetTimeout = setTimeout;
        else $78252438d374e671$var$cachedSetTimeout = $78252438d374e671$var$defaultSetTimout;
    } catch (e) {
        $78252438d374e671$var$cachedSetTimeout = $78252438d374e671$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $78252438d374e671$var$cachedClearTimeout = clearTimeout;
        else $78252438d374e671$var$cachedClearTimeout = $78252438d374e671$var$defaultClearTimeout;
    } catch (e) {
        $78252438d374e671$var$cachedClearTimeout = $78252438d374e671$var$defaultClearTimeout;
    }
})();
function $78252438d374e671$var$runTimeout(fun) {
    if ($78252438d374e671$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($78252438d374e671$var$cachedSetTimeout === $78252438d374e671$var$defaultSetTimout || !$78252438d374e671$var$cachedSetTimeout) && setTimeout) {
        $78252438d374e671$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $78252438d374e671$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $78252438d374e671$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $78252438d374e671$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $78252438d374e671$var$runClearTimeout(marker) {
    if ($78252438d374e671$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($78252438d374e671$var$cachedClearTimeout === $78252438d374e671$var$defaultClearTimeout || !$78252438d374e671$var$cachedClearTimeout) && clearTimeout) {
        $78252438d374e671$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $78252438d374e671$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $78252438d374e671$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $78252438d374e671$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $78252438d374e671$var$queue = [];
var $78252438d374e671$var$draining = false;
var $78252438d374e671$var$currentQueue;
var $78252438d374e671$var$queueIndex = -1;
function $78252438d374e671$var$cleanUpNextTick() {
    if (!$78252438d374e671$var$draining || !$78252438d374e671$var$currentQueue) return;
    $78252438d374e671$var$draining = false;
    if ($78252438d374e671$var$currentQueue.length) $78252438d374e671$var$queue = $78252438d374e671$var$currentQueue.concat($78252438d374e671$var$queue);
    else $78252438d374e671$var$queueIndex = -1;
    if ($78252438d374e671$var$queue.length) $78252438d374e671$var$drainQueue();
}
function $78252438d374e671$var$drainQueue() {
    if ($78252438d374e671$var$draining) return;
    var timeout = $78252438d374e671$var$runTimeout($78252438d374e671$var$cleanUpNextTick);
    $78252438d374e671$var$draining = true;
    var len = $78252438d374e671$var$queue.length;
    while(len){
        $78252438d374e671$var$currentQueue = $78252438d374e671$var$queue;
        $78252438d374e671$var$queue = [];
        while(++$78252438d374e671$var$queueIndex < len)if ($78252438d374e671$var$currentQueue) $78252438d374e671$var$currentQueue[$78252438d374e671$var$queueIndex].run();
        $78252438d374e671$var$queueIndex = -1;
        len = $78252438d374e671$var$queue.length;
    }
    $78252438d374e671$var$currentQueue = null;
    $78252438d374e671$var$draining = false;
    $78252438d374e671$var$runClearTimeout(timeout);
}
$78252438d374e671$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $78252438d374e671$var$queue.push(new $78252438d374e671$var$Item(fun, args));
    if ($78252438d374e671$var$queue.length === 1 && !$78252438d374e671$var$draining) $78252438d374e671$var$runTimeout($78252438d374e671$var$drainQueue);
};
// v8 likes predictible objects
function $78252438d374e671$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$78252438d374e671$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$78252438d374e671$var$process.title = 'browser';
$78252438d374e671$var$process.browser = true;
$78252438d374e671$var$process.env = {};
$78252438d374e671$var$process.argv = [];
$78252438d374e671$var$process.version = ''; // empty string to avoid regexp issues
$78252438d374e671$var$process.versions = {};
function $78252438d374e671$var$noop() {}
$78252438d374e671$var$process.on = $78252438d374e671$var$noop;
$78252438d374e671$var$process.addListener = $78252438d374e671$var$noop;
$78252438d374e671$var$process.once = $78252438d374e671$var$noop;
$78252438d374e671$var$process.off = $78252438d374e671$var$noop;
$78252438d374e671$var$process.removeListener = $78252438d374e671$var$noop;
$78252438d374e671$var$process.removeAllListeners = $78252438d374e671$var$noop;
$78252438d374e671$var$process.emit = $78252438d374e671$var$noop;
$78252438d374e671$var$process.prependListener = $78252438d374e671$var$noop;
$78252438d374e671$var$process.prependOnceListener = $78252438d374e671$var$noop;
$78252438d374e671$var$process.listeners = function(name) {
    return [];
};
$78252438d374e671$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$78252438d374e671$var$process.cwd = function() {
    return '/';
};
$78252438d374e671$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$78252438d374e671$var$process.umask = function() {
    return 0;
};

});

parcelRegister("9nTep", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $6d511adee8537fdd$var$Stream;

var $fPnTa = parcelRequire("fPnTa");
var $6d511adee8537fdd$require$EE = $fPnTa.EventEmitter;

var $bniia = parcelRequire("bniia");
$bniia($6d511adee8537fdd$var$Stream, $6d511adee8537fdd$require$EE);

$6d511adee8537fdd$var$Stream.Readable = (parcelRequire("57INz"));

$6d511adee8537fdd$var$Stream.Writable = (parcelRequire("1svhU"));

$6d511adee8537fdd$var$Stream.Duplex = (parcelRequire("5OPQQ"));

$6d511adee8537fdd$var$Stream.Transform = (parcelRequire("5XJRJ"));

$6d511adee8537fdd$var$Stream.PassThrough = (parcelRequire("fxcM6"));

$6d511adee8537fdd$var$Stream.finished = (parcelRequire("5DTHA"));

$6d511adee8537fdd$var$Stream.pipeline = (parcelRequire("9kIr2"));
// Backwards-compat with node 0.4.x
$6d511adee8537fdd$var$Stream.Stream = $6d511adee8537fdd$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $6d511adee8537fdd$var$Stream() {
    $6d511adee8537fdd$require$EE.call(this);
}
$6d511adee8537fdd$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($6d511adee8537fdd$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("fPnTa", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $b85e263ca6947d0f$var$R = typeof Reflect === 'object' ? Reflect : null;
var $b85e263ca6947d0f$var$ReflectApply = $b85e263ca6947d0f$var$R && typeof $b85e263ca6947d0f$var$R.apply === 'function' ? $b85e263ca6947d0f$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b85e263ca6947d0f$var$ReflectOwnKeys;
if ($b85e263ca6947d0f$var$R && typeof $b85e263ca6947d0f$var$R.ownKeys === 'function') $b85e263ca6947d0f$var$ReflectOwnKeys = $b85e263ca6947d0f$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b85e263ca6947d0f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b85e263ca6947d0f$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b85e263ca6947d0f$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b85e263ca6947d0f$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b85e263ca6947d0f$var$EventEmitter() {
    $b85e263ca6947d0f$var$EventEmitter.init.call(this);
}
module.exports = $b85e263ca6947d0f$var$EventEmitter;
module.exports.once = $b85e263ca6947d0f$var$once;
// Backwards-compat with node 0.10.x
$b85e263ca6947d0f$var$EventEmitter.EventEmitter = $b85e263ca6947d0f$var$EventEmitter;
$b85e263ca6947d0f$var$EventEmitter.prototype._events = undefined;
$b85e263ca6947d0f$var$EventEmitter.prototype._eventsCount = 0;
$b85e263ca6947d0f$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b85e263ca6947d0f$var$defaultMaxListeners = 10;
function $b85e263ca6947d0f$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b85e263ca6947d0f$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $b85e263ca6947d0f$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $b85e263ca6947d0f$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $b85e263ca6947d0f$var$defaultMaxListeners = arg;
    }
});
$b85e263ca6947d0f$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b85e263ca6947d0f$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $b85e263ca6947d0f$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $b85e263ca6947d0f$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b85e263ca6947d0f$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b85e263ca6947d0f$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b85e263ca6947d0f$var$_getMaxListeners(this);
};
$b85e263ca6947d0f$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $b85e263ca6947d0f$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b85e263ca6947d0f$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b85e263ca6947d0f$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b85e263ca6947d0f$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b85e263ca6947d0f$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b85e263ca6947d0f$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b85e263ca6947d0f$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b85e263ca6947d0f$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b85e263ca6947d0f$var$_addListener(this, type, listener, false);
};
$b85e263ca6947d0f$var$EventEmitter.prototype.on = $b85e263ca6947d0f$var$EventEmitter.prototype.addListener;
$b85e263ca6947d0f$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b85e263ca6947d0f$var$_addListener(this, type, listener, true);
};
function $b85e263ca6947d0f$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b85e263ca6947d0f$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b85e263ca6947d0f$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b85e263ca6947d0f$var$EventEmitter.prototype.once = function once(type, listener) {
    $b85e263ca6947d0f$var$checkListener(listener);
    this.on(type, $b85e263ca6947d0f$var$_onceWrap(this, type, listener));
    return this;
};
$b85e263ca6947d0f$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b85e263ca6947d0f$var$checkListener(listener);
    this.prependListener(type, $b85e263ca6947d0f$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b85e263ca6947d0f$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b85e263ca6947d0f$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b85e263ca6947d0f$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$b85e263ca6947d0f$var$EventEmitter.prototype.off = $b85e263ca6947d0f$var$EventEmitter.prototype.removeListener;
$b85e263ca6947d0f$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b85e263ca6947d0f$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b85e263ca6947d0f$var$unwrapListeners(evlistener) : $b85e263ca6947d0f$var$arrayClone(evlistener, evlistener.length);
}
$b85e263ca6947d0f$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b85e263ca6947d0f$var$_listeners(this, type, true);
};
$b85e263ca6947d0f$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b85e263ca6947d0f$var$_listeners(this, type, false);
};
$b85e263ca6947d0f$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $b85e263ca6947d0f$var$listenerCount.call(emitter, type);
};
$b85e263ca6947d0f$var$EventEmitter.prototype.listenerCount = $b85e263ca6947d0f$var$listenerCount;
function $b85e263ca6947d0f$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b85e263ca6947d0f$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b85e263ca6947d0f$var$ReflectOwnKeys(this._events) : [];
};
function $b85e263ca6947d0f$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b85e263ca6947d0f$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b85e263ca6947d0f$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b85e263ca6947d0f$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $b85e263ca6947d0f$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $b85e263ca6947d0f$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b85e263ca6947d0f$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $b85e263ca6947d0f$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $b85e263ca6947d0f$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("bniia", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("57INz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $ajwPf = parcelRequire("ajwPf");
'use strict';
module.exports = $3bb05b40ab8db4cc$var$Readable;
/*<replacement>*/ var $3bb05b40ab8db4cc$var$Duplex;
/*</replacement>*/ $3bb05b40ab8db4cc$var$Readable.ReadableState = $3bb05b40ab8db4cc$var$ReadableState;

var $fPnTa = parcelRequire("fPnTa");
var $3bb05b40ab8db4cc$require$EE = $fPnTa.EventEmitter;
var $3bb05b40ab8db4cc$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $3RpQ9 = parcelRequire("3RpQ9");

var $8UsMN = parcelRequire("8UsMN");
var $3bb05b40ab8db4cc$require$Buffer = $8UsMN.Buffer;
var $3bb05b40ab8db4cc$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $3bb05b40ab8db4cc$var$_uint8ArrayToBuffer(chunk) {
    return $3bb05b40ab8db4cc$require$Buffer.from(chunk);
}
function $3bb05b40ab8db4cc$var$_isUint8Array(obj) {
    return $3bb05b40ab8db4cc$require$Buffer.isBuffer(obj) || obj instanceof $3bb05b40ab8db4cc$var$OurUint8Array;
}

var $66yC2 = parcelRequire("66yC2");
var $3bb05b40ab8db4cc$var$debug;
if ($66yC2 && $66yC2.debuglog) $3bb05b40ab8db4cc$var$debug = $66yC2.debuglog('stream');
else $3bb05b40ab8db4cc$var$debug = function debug() {};

var $jQzBV = parcelRequire("jQzBV");

var $7HooQ = parcelRequire("7HooQ");

var $aLyJl = parcelRequire("aLyJl");
var $3bb05b40ab8db4cc$var$getHighWaterMark = $aLyJl.getHighWaterMark;

var $kWZ9n = parcelRequire("kWZ9n");
var $3bb05b40ab8db4cc$require$_require$codes = $kWZ9n.codes;
var $3bb05b40ab8db4cc$var$ERR_INVALID_ARG_TYPE = $3bb05b40ab8db4cc$require$_require$codes.ERR_INVALID_ARG_TYPE, $3bb05b40ab8db4cc$var$ERR_STREAM_PUSH_AFTER_EOF = $3bb05b40ab8db4cc$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $3bb05b40ab8db4cc$var$ERR_METHOD_NOT_IMPLEMENTED = $3bb05b40ab8db4cc$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $3bb05b40ab8db4cc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $3bb05b40ab8db4cc$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $3bb05b40ab8db4cc$var$StringDecoder;
var $3bb05b40ab8db4cc$var$createReadableStreamAsyncIterator;
var $3bb05b40ab8db4cc$var$from;

(parcelRequire("bniia"))($3bb05b40ab8db4cc$var$Readable, $3RpQ9);
var $3bb05b40ab8db4cc$var$errorOrDestroy = $7HooQ.errorOrDestroy;
var $3bb05b40ab8db4cc$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $3bb05b40ab8db4cc$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $3bb05b40ab8db4cc$var$ReadableState(options, stream, isDuplex) {
    $3bb05b40ab8db4cc$var$Duplex = $3bb05b40ab8db4cc$var$Duplex || (parcelRequire("5OPQQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $3bb05b40ab8db4cc$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $3bb05b40ab8db4cc$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $jQzBV();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$3bb05b40ab8db4cc$var$StringDecoder) $3bb05b40ab8db4cc$var$StringDecoder = (parcelRequire("eJDLo")).StringDecoder;
        this.decoder = new $3bb05b40ab8db4cc$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $3bb05b40ab8db4cc$var$Readable(options) {
    $3bb05b40ab8db4cc$var$Duplex = $3bb05b40ab8db4cc$var$Duplex || (parcelRequire("5OPQQ"));
    if (!(this instanceof $3bb05b40ab8db4cc$var$Readable)) return new $3bb05b40ab8db4cc$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $3bb05b40ab8db4cc$var$Duplex;
    this._readableState = new $3bb05b40ab8db4cc$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $3RpQ9.call(this);
}
Object.defineProperty($3bb05b40ab8db4cc$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$3bb05b40ab8db4cc$var$Readable.prototype.destroy = $7HooQ.destroy;
$3bb05b40ab8db4cc$var$Readable.prototype._undestroy = $7HooQ.undestroy;
$3bb05b40ab8db4cc$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3bb05b40ab8db4cc$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $3bb05b40ab8db4cc$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $3bb05b40ab8db4cc$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$3bb05b40ab8db4cc$var$Readable.prototype.unshift = function(chunk) {
    return $3bb05b40ab8db4cc$var$readableAddChunk(this, chunk, null, true, false);
};
function $3bb05b40ab8db4cc$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $3bb05b40ab8db4cc$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $3bb05b40ab8db4cc$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $3bb05b40ab8db4cc$var$chunkInvalid(state, chunk);
        if (er) $3bb05b40ab8db4cc$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $3bb05b40ab8db4cc$require$Buffer.prototype) chunk = $3bb05b40ab8db4cc$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $3bb05b40ab8db4cc$var$errorOrDestroy(stream, new $3bb05b40ab8db4cc$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $3bb05b40ab8db4cc$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $3bb05b40ab8db4cc$var$errorOrDestroy(stream, new $3bb05b40ab8db4cc$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $3bb05b40ab8db4cc$var$addChunk(stream, state, chunk, false);
                    else $3bb05b40ab8db4cc$var$maybeReadMore(stream, state);
                } else $3bb05b40ab8db4cc$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $3bb05b40ab8db4cc$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $3bb05b40ab8db4cc$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $3bb05b40ab8db4cc$var$emitReadable(stream);
    }
    $3bb05b40ab8db4cc$var$maybeReadMore(stream, state);
}
function $3bb05b40ab8db4cc$var$chunkInvalid(state, chunk) {
    var er;
    if (!$3bb05b40ab8db4cc$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $3bb05b40ab8db4cc$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$3bb05b40ab8db4cc$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$3bb05b40ab8db4cc$var$Readable.prototype.setEncoding = function(enc) {
    if (!$3bb05b40ab8db4cc$var$StringDecoder) $3bb05b40ab8db4cc$var$StringDecoder = (parcelRequire("eJDLo")).StringDecoder;
    var decoder = new $3bb05b40ab8db4cc$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $3bb05b40ab8db4cc$var$MAX_HWM = 0x40000000;
function $3bb05b40ab8db4cc$var$computeNewHighWaterMark(n) {
    if (n >= $3bb05b40ab8db4cc$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $3bb05b40ab8db4cc$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3bb05b40ab8db4cc$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3bb05b40ab8db4cc$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$3bb05b40ab8db4cc$var$Readable.prototype.read = function(n) {
    $3bb05b40ab8db4cc$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $3bb05b40ab8db4cc$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3bb05b40ab8db4cc$var$endReadable(this);
        else $3bb05b40ab8db4cc$var$emitReadable(this);
        return null;
    }
    n = $3bb05b40ab8db4cc$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3bb05b40ab8db4cc$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $3bb05b40ab8db4cc$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3bb05b40ab8db4cc$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $3bb05b40ab8db4cc$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $3bb05b40ab8db4cc$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3bb05b40ab8db4cc$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $3bb05b40ab8db4cc$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3bb05b40ab8db4cc$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $3bb05b40ab8db4cc$var$onEofChunk(stream, state) {
    $3bb05b40ab8db4cc$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $3bb05b40ab8db4cc$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $3bb05b40ab8db4cc$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3bb05b40ab8db4cc$var$emitReadable(stream) {
    var state = stream._readableState;
    $3bb05b40ab8db4cc$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3bb05b40ab8db4cc$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $ajwPf.nextTick($3bb05b40ab8db4cc$var$emitReadable_, stream);
    }
}
function $3bb05b40ab8db4cc$var$emitReadable_(stream) {
    var state = stream._readableState;
    $3bb05b40ab8db4cc$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $3bb05b40ab8db4cc$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3bb05b40ab8db4cc$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $ajwPf.nextTick($3bb05b40ab8db4cc$var$maybeReadMore_, stream, state);
    }
}
function $3bb05b40ab8db4cc$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $3bb05b40ab8db4cc$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3bb05b40ab8db4cc$var$Readable.prototype._read = function(n) {
    $3bb05b40ab8db4cc$var$errorOrDestroy(this, new $3bb05b40ab8db4cc$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$3bb05b40ab8db4cc$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $3bb05b40ab8db4cc$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $ajwPf.stdout && dest !== $ajwPf.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $ajwPf.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $3bb05b40ab8db4cc$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $3bb05b40ab8db4cc$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $3bb05b40ab8db4cc$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $3bb05b40ab8db4cc$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $3bb05b40ab8db4cc$var$debug('ondata');
        var ret = dest.write(chunk);
        $3bb05b40ab8db4cc$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $3bb05b40ab8db4cc$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $3bb05b40ab8db4cc$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3bb05b40ab8db4cc$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($3bb05b40ab8db4cc$var$EElistenerCount(dest, 'error') === 0) $3bb05b40ab8db4cc$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $3bb05b40ab8db4cc$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3bb05b40ab8db4cc$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3bb05b40ab8db4cc$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $3bb05b40ab8db4cc$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3bb05b40ab8db4cc$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $3bb05b40ab8db4cc$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $3bb05b40ab8db4cc$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $3bb05b40ab8db4cc$var$flow(src);
        }
    };
}
$3bb05b40ab8db4cc$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $3bb05b40ab8db4cc$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$3bb05b40ab8db4cc$var$Readable.prototype.on = function(ev, fn) {
    var res = $3RpQ9.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $3bb05b40ab8db4cc$var$debug('on readable', state.length, state.reading);
            if (state.length) $3bb05b40ab8db4cc$var$emitReadable(this);
            else if (!state.reading) $ajwPf.nextTick($3bb05b40ab8db4cc$var$nReadingNextTick, this);
        }
    }
    return res;
};
$3bb05b40ab8db4cc$var$Readable.prototype.addListener = $3bb05b40ab8db4cc$var$Readable.prototype.on;
$3bb05b40ab8db4cc$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $3RpQ9.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $ajwPf.nextTick($3bb05b40ab8db4cc$var$updateReadableListening, this);
    return res;
};
$3bb05b40ab8db4cc$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $3RpQ9.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $ajwPf.nextTick($3bb05b40ab8db4cc$var$updateReadableListening, this);
    return res;
};
function $3bb05b40ab8db4cc$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $3bb05b40ab8db4cc$var$nReadingNextTick(self1) {
    $3bb05b40ab8db4cc$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3bb05b40ab8db4cc$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $3bb05b40ab8db4cc$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $3bb05b40ab8db4cc$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $3bb05b40ab8db4cc$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $ajwPf.nextTick($3bb05b40ab8db4cc$var$resume_, stream, state);
    }
}
function $3bb05b40ab8db4cc$var$resume_(stream, state) {
    $3bb05b40ab8db4cc$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $3bb05b40ab8db4cc$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3bb05b40ab8db4cc$var$Readable.prototype.pause = function() {
    $3bb05b40ab8db4cc$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $3bb05b40ab8db4cc$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $3bb05b40ab8db4cc$var$flow(stream) {
    var state = stream._readableState;
    $3bb05b40ab8db4cc$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3bb05b40ab8db4cc$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $3bb05b40ab8db4cc$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $3bb05b40ab8db4cc$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $3bb05b40ab8db4cc$var$kProxyEvents.length; n++)stream.on($3bb05b40ab8db4cc$var$kProxyEvents[n], this.emit.bind(this, $3bb05b40ab8db4cc$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $3bb05b40ab8db4cc$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $3bb05b40ab8db4cc$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($3bb05b40ab8db4cc$var$createReadableStreamAsyncIterator === undefined) $3bb05b40ab8db4cc$var$createReadableStreamAsyncIterator = (parcelRequire("eZzXz"));
    return $3bb05b40ab8db4cc$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($3bb05b40ab8db4cc$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($3bb05b40ab8db4cc$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($3bb05b40ab8db4cc$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$3bb05b40ab8db4cc$var$Readable._fromList = $3bb05b40ab8db4cc$var$fromList;
Object.defineProperty($3bb05b40ab8db4cc$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3bb05b40ab8db4cc$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $3bb05b40ab8db4cc$var$endReadable(stream) {
    var state = stream._readableState;
    $3bb05b40ab8db4cc$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $ajwPf.nextTick($3bb05b40ab8db4cc$var$endReadableNT, state, stream);
    }
}
function $3bb05b40ab8db4cc$var$endReadableNT(state, stream) {
    $3bb05b40ab8db4cc$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $3bb05b40ab8db4cc$var$Readable.from = function(iterable, opts) {
    if ($3bb05b40ab8db4cc$var$from === undefined) $3bb05b40ab8db4cc$var$from = (parcelRequire("gTQvb"));
    return $3bb05b40ab8db4cc$var$from($3bb05b40ab8db4cc$var$Readable, iterable, opts);
};
function $3bb05b40ab8db4cc$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("3RpQ9", function(module, exports) {

module.exports = (parcelRequire("fPnTa")).EventEmitter;

});

parcelRegister("66yC2", function(module, exports) {
"use strict";

});

parcelRegister("jQzBV", function(module, exports) {
'use strict';
function $e72e7f3025ab50ce$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e72e7f3025ab50ce$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e72e7f3025ab50ce$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e72e7f3025ab50ce$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e72e7f3025ab50ce$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e72e7f3025ab50ce$var$_defineProperty(obj, key, value) {
    key = $e72e7f3025ab50ce$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e72e7f3025ab50ce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e72e7f3025ab50ce$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e72e7f3025ab50ce$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e72e7f3025ab50ce$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e72e7f3025ab50ce$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e72e7f3025ab50ce$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e72e7f3025ab50ce$var$_toPropertyKey(arg) {
    var key = $e72e7f3025ab50ce$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $e72e7f3025ab50ce$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $8UsMN = parcelRequire("8UsMN");
var $e72e7f3025ab50ce$var$Buffer = $8UsMN.Buffer;

var $66yC2 = parcelRequire("66yC2");
var $e72e7f3025ab50ce$var$inspect = $66yC2.inspect;
var $e72e7f3025ab50ce$var$custom = $e72e7f3025ab50ce$var$inspect && $e72e7f3025ab50ce$var$inspect.custom || 'inspect';
function $e72e7f3025ab50ce$var$copyBuffer(src, target, offset) {
    $e72e7f3025ab50ce$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $e72e7f3025ab50ce$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $e72e7f3025ab50ce$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $e72e7f3025ab50ce$var$Buffer.alloc(0);
                var ret = $e72e7f3025ab50ce$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $e72e7f3025ab50ce$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $e72e7f3025ab50ce$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $e72e7f3025ab50ce$var$custom,
            value: function value(_, options) {
                return $e72e7f3025ab50ce$var$inspect(this, $e72e7f3025ab50ce$var$_objectSpread($e72e7f3025ab50ce$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("7HooQ", function(module, exports) {

var $ajwPf = parcelRequire("ajwPf");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $59af79ce84ac113a$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $ajwPf.nextTick($59af79ce84ac113a$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $ajwPf.nextTick($59af79ce84ac113a$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $ajwPf.nextTick($59af79ce84ac113a$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $ajwPf.nextTick($59af79ce84ac113a$var$emitErrorAndCloseNT, _this, err);
            } else $ajwPf.nextTick($59af79ce84ac113a$var$emitCloseNT, _this);
        } else if (cb) {
            $ajwPf.nextTick($59af79ce84ac113a$var$emitCloseNT, _this);
            cb(err);
        } else $ajwPf.nextTick($59af79ce84ac113a$var$emitCloseNT, _this);
    });
    return this;
}
function $59af79ce84ac113a$var$emitErrorAndCloseNT(self, err) {
    $59af79ce84ac113a$var$emitErrorNT(self, err);
    $59af79ce84ac113a$var$emitCloseNT(self);
}
function $59af79ce84ac113a$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $59af79ce84ac113a$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $59af79ce84ac113a$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $59af79ce84ac113a$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $59af79ce84ac113a$var$destroy,
    undestroy: $59af79ce84ac113a$var$undestroy,
    errorOrDestroy: $59af79ce84ac113a$var$errorOrDestroy
};

});

parcelRegister("aLyJl", function(module, exports) {
'use strict';

var $7d693be9117b5058$var$ERR_INVALID_OPT_VALUE = (parcelRequire("kWZ9n")).codes.ERR_INVALID_OPT_VALUE;
function $7d693be9117b5058$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $7d693be9117b5058$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $7d693be9117b5058$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $7d693be9117b5058$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $7d693be9117b5058$var$getHighWaterMark
};

});
parcelRegister("kWZ9n", function(module, exports) {

$parcel$export(module.exports, "codes", () => $f408a898c2e0b045$export$e45cb6485273080e, (v) => $f408a898c2e0b045$export$e45cb6485273080e = v);
var $f408a898c2e0b045$export$e45cb6485273080e;
'use strict';
function $f408a898c2e0b045$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $f408a898c2e0b045$var$codes = {};
function $f408a898c2e0b045$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $f408a898c2e0b045$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $f408a898c2e0b045$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $f408a898c2e0b045$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $f408a898c2e0b045$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $f408a898c2e0b045$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $f408a898c2e0b045$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$f408a898c2e0b045$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$f408a898c2e0b045$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $f408a898c2e0b045$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($f408a898c2e0b045$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($f408a898c2e0b045$var$oneOf(expected, 'type'));
    else {
        var type = $f408a898c2e0b045$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($f408a898c2e0b045$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$f408a898c2e0b045$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$f408a898c2e0b045$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$f408a898c2e0b045$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$f408a898c2e0b045$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$f408a898c2e0b045$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$f408a898c2e0b045$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$f408a898c2e0b045$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$f408a898c2e0b045$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$f408a898c2e0b045$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$f408a898c2e0b045$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$f408a898c2e0b045$export$e45cb6485273080e = $f408a898c2e0b045$var$codes;

});


parcelRegister("5OPQQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $ajwPf = parcelRequire("ajwPf");
'use strict';
/*<replacement>*/ var $43c9d7dd80c2a50d$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $43c9d7dd80c2a50d$var$Duplex;

var $57INz = parcelRequire("57INz");

var $1svhU = parcelRequire("1svhU");

(parcelRequire("bniia"))($43c9d7dd80c2a50d$var$Duplex, $57INz);
// Allow the keys array to be GC'ed.
var $43c9d7dd80c2a50d$var$keys = $43c9d7dd80c2a50d$var$objectKeys($1svhU.prototype);
for(var $43c9d7dd80c2a50d$var$v = 0; $43c9d7dd80c2a50d$var$v < $43c9d7dd80c2a50d$var$keys.length; $43c9d7dd80c2a50d$var$v++){
    var $43c9d7dd80c2a50d$var$method = $43c9d7dd80c2a50d$var$keys[$43c9d7dd80c2a50d$var$v];
    if (!$43c9d7dd80c2a50d$var$Duplex.prototype[$43c9d7dd80c2a50d$var$method]) $43c9d7dd80c2a50d$var$Duplex.prototype[$43c9d7dd80c2a50d$var$method] = $1svhU.prototype[$43c9d7dd80c2a50d$var$method];
}
function $43c9d7dd80c2a50d$var$Duplex(options) {
    if (!(this instanceof $43c9d7dd80c2a50d$var$Duplex)) return new $43c9d7dd80c2a50d$var$Duplex(options);
    $57INz.call(this, options);
    $1svhU.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $43c9d7dd80c2a50d$var$onend);
        }
    }
}
Object.defineProperty($43c9d7dd80c2a50d$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($43c9d7dd80c2a50d$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($43c9d7dd80c2a50d$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $43c9d7dd80c2a50d$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $ajwPf.nextTick($43c9d7dd80c2a50d$var$onEndNT, this);
}
function $43c9d7dd80c2a50d$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($43c9d7dd80c2a50d$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("1svhU", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $ajwPf = parcelRequire("ajwPf");
'use strict';
module.exports = $1100ad171f7ca79d$var$Writable;
/* <replacement> */ function $1100ad171f7ca79d$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $1100ad171f7ca79d$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $1100ad171f7ca79d$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $1100ad171f7ca79d$var$Duplex;
/*</replacement>*/ $1100ad171f7ca79d$var$Writable.WritableState = $1100ad171f7ca79d$var$WritableState;

/*<replacement>*/ var $1100ad171f7ca79d$var$internalUtil = {
    deprecate: (parcelRequire("f2W2v"))
};

var $3RpQ9 = parcelRequire("3RpQ9");

var $8UsMN = parcelRequire("8UsMN");
var $1100ad171f7ca79d$require$Buffer = $8UsMN.Buffer;
var $1100ad171f7ca79d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $1100ad171f7ca79d$var$_uint8ArrayToBuffer(chunk) {
    return $1100ad171f7ca79d$require$Buffer.from(chunk);
}
function $1100ad171f7ca79d$var$_isUint8Array(obj) {
    return $1100ad171f7ca79d$require$Buffer.isBuffer(obj) || obj instanceof $1100ad171f7ca79d$var$OurUint8Array;
}

var $7HooQ = parcelRequire("7HooQ");

var $aLyJl = parcelRequire("aLyJl");
var $1100ad171f7ca79d$var$getHighWaterMark = $aLyJl.getHighWaterMark;

var $kWZ9n = parcelRequire("kWZ9n");
var $1100ad171f7ca79d$require$_require$codes = $kWZ9n.codes;
var $1100ad171f7ca79d$var$ERR_INVALID_ARG_TYPE = $1100ad171f7ca79d$require$_require$codes.ERR_INVALID_ARG_TYPE, $1100ad171f7ca79d$var$ERR_METHOD_NOT_IMPLEMENTED = $1100ad171f7ca79d$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $1100ad171f7ca79d$var$ERR_MULTIPLE_CALLBACK = $1100ad171f7ca79d$require$_require$codes.ERR_MULTIPLE_CALLBACK, $1100ad171f7ca79d$var$ERR_STREAM_CANNOT_PIPE = $1100ad171f7ca79d$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $1100ad171f7ca79d$var$ERR_STREAM_DESTROYED = $1100ad171f7ca79d$require$_require$codes.ERR_STREAM_DESTROYED, $1100ad171f7ca79d$var$ERR_STREAM_NULL_VALUES = $1100ad171f7ca79d$require$_require$codes.ERR_STREAM_NULL_VALUES, $1100ad171f7ca79d$var$ERR_STREAM_WRITE_AFTER_END = $1100ad171f7ca79d$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $1100ad171f7ca79d$var$ERR_UNKNOWN_ENCODING = $1100ad171f7ca79d$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $1100ad171f7ca79d$var$errorOrDestroy = $7HooQ.errorOrDestroy;

(parcelRequire("bniia"))($1100ad171f7ca79d$var$Writable, $3RpQ9);
function $1100ad171f7ca79d$var$nop() {}

function $1100ad171f7ca79d$var$WritableState(options, stream, isDuplex) {
    $1100ad171f7ca79d$var$Duplex = $1100ad171f7ca79d$var$Duplex || (parcelRequire("5OPQQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $1100ad171f7ca79d$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $1100ad171f7ca79d$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $1100ad171f7ca79d$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $1100ad171f7ca79d$var$CorkedRequest(this);
}
$1100ad171f7ca79d$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($1100ad171f7ca79d$var$WritableState.prototype, 'buffer', {
            get: $1100ad171f7ca79d$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $1100ad171f7ca79d$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $1100ad171f7ca79d$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($1100ad171f7ca79d$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($1100ad171f7ca79d$var$realHasInstance.call(this, object)) return true;
            if (this !== $1100ad171f7ca79d$var$Writable) return false;
            return object && object._writableState instanceof $1100ad171f7ca79d$var$WritableState;
        }
    });
} else $1100ad171f7ca79d$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $1100ad171f7ca79d$var$Writable(options) {
    $1100ad171f7ca79d$var$Duplex = $1100ad171f7ca79d$var$Duplex || (parcelRequire("5OPQQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $1100ad171f7ca79d$var$Duplex;
    if (!isDuplex && !$1100ad171f7ca79d$var$realHasInstance.call($1100ad171f7ca79d$var$Writable, this)) return new $1100ad171f7ca79d$var$Writable(options);
    this._writableState = new $1100ad171f7ca79d$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $3RpQ9.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$1100ad171f7ca79d$var$Writable.prototype.pipe = function() {
    $1100ad171f7ca79d$var$errorOrDestroy(this, new $1100ad171f7ca79d$var$ERR_STREAM_CANNOT_PIPE());
};
function $1100ad171f7ca79d$var$writeAfterEnd(stream, cb) {
    var er = new $1100ad171f7ca79d$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $1100ad171f7ca79d$var$errorOrDestroy(stream, er);
    $ajwPf.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $1100ad171f7ca79d$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $1100ad171f7ca79d$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $1100ad171f7ca79d$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $1100ad171f7ca79d$var$errorOrDestroy(stream, er);
        $ajwPf.nextTick(cb, er);
        return false;
    }
    return true;
}
$1100ad171f7ca79d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $1100ad171f7ca79d$var$_isUint8Array(chunk);
    if (isBuf && !$1100ad171f7ca79d$require$Buffer.isBuffer(chunk)) chunk = $1100ad171f7ca79d$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $1100ad171f7ca79d$var$nop;
    if (state.ending) $1100ad171f7ca79d$var$writeAfterEnd(this, cb);
    else if (isBuf || $1100ad171f7ca79d$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $1100ad171f7ca79d$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$1100ad171f7ca79d$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1100ad171f7ca79d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1100ad171f7ca79d$var$clearBuffer(this, state);
    }
};
$1100ad171f7ca79d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $1100ad171f7ca79d$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($1100ad171f7ca79d$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $1100ad171f7ca79d$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $1100ad171f7ca79d$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($1100ad171f7ca79d$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1100ad171f7ca79d$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $1100ad171f7ca79d$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $1100ad171f7ca79d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $1100ad171f7ca79d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1100ad171f7ca79d$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1100ad171f7ca79d$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $ajwPf.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $ajwPf.nextTick($1100ad171f7ca79d$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $1100ad171f7ca79d$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $1100ad171f7ca79d$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $1100ad171f7ca79d$var$finishMaybe(stream, state);
    }
}
function $1100ad171f7ca79d$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $1100ad171f7ca79d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $1100ad171f7ca79d$var$ERR_MULTIPLE_CALLBACK();
    $1100ad171f7ca79d$var$onwriteStateUpdate(state);
    if (er) $1100ad171f7ca79d$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $1100ad171f7ca79d$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1100ad171f7ca79d$var$clearBuffer(stream, state);
        if (sync) $ajwPf.nextTick($1100ad171f7ca79d$var$afterWrite, stream, state, finished, cb);
        else $1100ad171f7ca79d$var$afterWrite(stream, state, finished, cb);
    }
}
function $1100ad171f7ca79d$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $1100ad171f7ca79d$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $1100ad171f7ca79d$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $1100ad171f7ca79d$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $1100ad171f7ca79d$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $1100ad171f7ca79d$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $1100ad171f7ca79d$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $1100ad171f7ca79d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$1100ad171f7ca79d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $1100ad171f7ca79d$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$1100ad171f7ca79d$var$Writable.prototype._writev = null;
$1100ad171f7ca79d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $1100ad171f7ca79d$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($1100ad171f7ca79d$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $1100ad171f7ca79d$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $1100ad171f7ca79d$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $1100ad171f7ca79d$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $1100ad171f7ca79d$var$finishMaybe(stream, state);
    });
}
function $1100ad171f7ca79d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $ajwPf.nextTick($1100ad171f7ca79d$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1100ad171f7ca79d$var$finishMaybe(stream, state) {
    var need = $1100ad171f7ca79d$var$needFinish(state);
    if (need) {
        $1100ad171f7ca79d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $1100ad171f7ca79d$var$endWritable(stream, state, cb) {
    state.ending = true;
    $1100ad171f7ca79d$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $ajwPf.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $1100ad171f7ca79d$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($1100ad171f7ca79d$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$1100ad171f7ca79d$var$Writable.prototype.destroy = $7HooQ.destroy;
$1100ad171f7ca79d$var$Writable.prototype._undestroy = $7HooQ.undestroy;
$1100ad171f7ca79d$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("f2W2v", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $af4410580a1c0ae1$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $af4410580a1c0ae1$var$deprecate(fn, msg) {
    if ($af4410580a1c0ae1$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($af4410580a1c0ae1$var$config('throwDeprecation')) throw new Error(msg);
            else if ($af4410580a1c0ae1$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $af4410580a1c0ae1$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("eJDLo", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $aba41cda4ab2fab9$export$63a7aa211a91ed69, (v) => $aba41cda4ab2fab9$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $aba41cda4ab2fab9$export$63a7aa211a91ed69;
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $aba41cda4ab2fab9$require$Buffer = $4OiF0.Buffer;
/*</replacement>*/ var $aba41cda4ab2fab9$var$isEncoding = $aba41cda4ab2fab9$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $aba41cda4ab2fab9$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $aba41cda4ab2fab9$var$normalizeEncoding(enc) {
    var nenc = $aba41cda4ab2fab9$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($aba41cda4ab2fab9$require$Buffer.isEncoding === $aba41cda4ab2fab9$var$isEncoding || !$aba41cda4ab2fab9$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$aba41cda4ab2fab9$export$63a7aa211a91ed69 = $aba41cda4ab2fab9$var$StringDecoder;
function $aba41cda4ab2fab9$var$StringDecoder(encoding) {
    this.encoding = $aba41cda4ab2fab9$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $aba41cda4ab2fab9$var$utf16Text;
            this.end = $aba41cda4ab2fab9$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $aba41cda4ab2fab9$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $aba41cda4ab2fab9$var$base64Text;
            this.end = $aba41cda4ab2fab9$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $aba41cda4ab2fab9$var$simpleWrite;
            this.end = $aba41cda4ab2fab9$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $aba41cda4ab2fab9$require$Buffer.allocUnsafe(nb);
}
$aba41cda4ab2fab9$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$aba41cda4ab2fab9$var$StringDecoder.prototype.end = $aba41cda4ab2fab9$var$utf8End;
// Returns only complete characters in a Buffer
$aba41cda4ab2fab9$var$StringDecoder.prototype.text = $aba41cda4ab2fab9$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$aba41cda4ab2fab9$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $aba41cda4ab2fab9$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $aba41cda4ab2fab9$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $aba41cda4ab2fab9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $aba41cda4ab2fab9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $aba41cda4ab2fab9$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $aba41cda4ab2fab9$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $aba41cda4ab2fab9$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $aba41cda4ab2fab9$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $aba41cda4ab2fab9$var$utf8Text(buf, i) {
    var total = $aba41cda4ab2fab9$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $aba41cda4ab2fab9$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $aba41cda4ab2fab9$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $aba41cda4ab2fab9$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $aba41cda4ab2fab9$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $aba41cda4ab2fab9$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $aba41cda4ab2fab9$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $aba41cda4ab2fab9$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("eZzXz", function(module, exports) {

var $ajwPf = parcelRequire("ajwPf");
'use strict';
var $aea2a80fac6302a0$var$_Object$setPrototypeO;
function $aea2a80fac6302a0$var$_defineProperty(obj, key, value) {
    key = $aea2a80fac6302a0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aea2a80fac6302a0$var$_toPropertyKey(arg) {
    var key = $aea2a80fac6302a0$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $aea2a80fac6302a0$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $5DTHA = parcelRequire("5DTHA");
var $aea2a80fac6302a0$var$kLastResolve = Symbol('lastResolve');
var $aea2a80fac6302a0$var$kLastReject = Symbol('lastReject');
var $aea2a80fac6302a0$var$kError = Symbol('error');
var $aea2a80fac6302a0$var$kEnded = Symbol('ended');
var $aea2a80fac6302a0$var$kLastPromise = Symbol('lastPromise');
var $aea2a80fac6302a0$var$kHandlePromise = Symbol('handlePromise');
var $aea2a80fac6302a0$var$kStream = Symbol('stream');
function $aea2a80fac6302a0$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $aea2a80fac6302a0$var$readAndResolve(iter) {
    var resolve = iter[$aea2a80fac6302a0$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$aea2a80fac6302a0$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$aea2a80fac6302a0$var$kLastPromise] = null;
            iter[$aea2a80fac6302a0$var$kLastResolve] = null;
            iter[$aea2a80fac6302a0$var$kLastReject] = null;
            resolve($aea2a80fac6302a0$var$createIterResult(data, false));
        }
    }
}
function $aea2a80fac6302a0$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $ajwPf.nextTick($aea2a80fac6302a0$var$readAndResolve, iter);
}
function $aea2a80fac6302a0$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$aea2a80fac6302a0$var$kEnded]) {
                resolve($aea2a80fac6302a0$var$createIterResult(undefined, true));
                return;
            }
            iter[$aea2a80fac6302a0$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $aea2a80fac6302a0$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $aea2a80fac6302a0$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($aea2a80fac6302a0$var$_Object$setPrototypeO = {
    get stream () {
        return this[$aea2a80fac6302a0$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$aea2a80fac6302a0$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$aea2a80fac6302a0$var$kEnded]) return Promise.resolve($aea2a80fac6302a0$var$createIterResult(undefined, true));
        if (this[$aea2a80fac6302a0$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $ajwPf.nextTick(function() {
                if (_this[$aea2a80fac6302a0$var$kError]) reject(_this[$aea2a80fac6302a0$var$kError]);
                else resolve($aea2a80fac6302a0$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$aea2a80fac6302a0$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($aea2a80fac6302a0$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$aea2a80fac6302a0$var$kStream].read();
            if (data !== null) return Promise.resolve($aea2a80fac6302a0$var$createIterResult(data, false));
            promise = new Promise(this[$aea2a80fac6302a0$var$kHandlePromise]);
        }
        this[$aea2a80fac6302a0$var$kLastPromise] = promise;
        return promise;
    }
}, $aea2a80fac6302a0$var$_defineProperty($aea2a80fac6302a0$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $aea2a80fac6302a0$var$_defineProperty($aea2a80fac6302a0$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$aea2a80fac6302a0$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($aea2a80fac6302a0$var$createIterResult(undefined, true));
        });
    });
}), $aea2a80fac6302a0$var$_Object$setPrototypeO), $aea2a80fac6302a0$var$AsyncIteratorPrototype);
var $aea2a80fac6302a0$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($aea2a80fac6302a0$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $aea2a80fac6302a0$var$_defineProperty(_Object$create, $aea2a80fac6302a0$var$kStream, {
        value: stream,
        writable: true
    }), $aea2a80fac6302a0$var$_defineProperty(_Object$create, $aea2a80fac6302a0$var$kLastResolve, {
        value: null,
        writable: true
    }), $aea2a80fac6302a0$var$_defineProperty(_Object$create, $aea2a80fac6302a0$var$kLastReject, {
        value: null,
        writable: true
    }), $aea2a80fac6302a0$var$_defineProperty(_Object$create, $aea2a80fac6302a0$var$kError, {
        value: null,
        writable: true
    }), $aea2a80fac6302a0$var$_defineProperty(_Object$create, $aea2a80fac6302a0$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $aea2a80fac6302a0$var$_defineProperty(_Object$create, $aea2a80fac6302a0$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$aea2a80fac6302a0$var$kStream].read();
            if (data) {
                iterator[$aea2a80fac6302a0$var$kLastPromise] = null;
                iterator[$aea2a80fac6302a0$var$kLastResolve] = null;
                iterator[$aea2a80fac6302a0$var$kLastReject] = null;
                resolve($aea2a80fac6302a0$var$createIterResult(data, false));
            } else {
                iterator[$aea2a80fac6302a0$var$kLastResolve] = resolve;
                iterator[$aea2a80fac6302a0$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$aea2a80fac6302a0$var$kLastPromise] = null;
    $5DTHA(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$aea2a80fac6302a0$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$aea2a80fac6302a0$var$kLastPromise] = null;
                iterator[$aea2a80fac6302a0$var$kLastResolve] = null;
                iterator[$aea2a80fac6302a0$var$kLastReject] = null;
                reject(err);
            }
            iterator[$aea2a80fac6302a0$var$kError] = err;
            return;
        }
        var resolve = iterator[$aea2a80fac6302a0$var$kLastResolve];
        if (resolve !== null) {
            iterator[$aea2a80fac6302a0$var$kLastPromise] = null;
            iterator[$aea2a80fac6302a0$var$kLastResolve] = null;
            iterator[$aea2a80fac6302a0$var$kLastReject] = null;
            resolve($aea2a80fac6302a0$var$createIterResult(undefined, true));
        }
        iterator[$aea2a80fac6302a0$var$kEnded] = true;
    });
    stream.on('readable', $aea2a80fac6302a0$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $aea2a80fac6302a0$var$createReadableStreamAsyncIterator;

});
parcelRegister("5DTHA", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $41bbcd8799a74f7c$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("kWZ9n")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $41bbcd8799a74f7c$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $41bbcd8799a74f7c$var$noop() {}
function $41bbcd8799a74f7c$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $41bbcd8799a74f7c$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $41bbcd8799a74f7c$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $41bbcd8799a74f7c$var$once(callback || $41bbcd8799a74f7c$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $41bbcd8799a74f7c$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $41bbcd8799a74f7c$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($41bbcd8799a74f7c$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $41bbcd8799a74f7c$var$eos;

});


parcelRegister("gTQvb", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("5XJRJ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $45760a65f870e778$var$Transform;

var $kWZ9n = parcelRequire("kWZ9n");
var $45760a65f870e778$require$_require$codes = $kWZ9n.codes;
var $45760a65f870e778$var$ERR_METHOD_NOT_IMPLEMENTED = $45760a65f870e778$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $45760a65f870e778$var$ERR_MULTIPLE_CALLBACK = $45760a65f870e778$require$_require$codes.ERR_MULTIPLE_CALLBACK, $45760a65f870e778$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $45760a65f870e778$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $45760a65f870e778$var$ERR_TRANSFORM_WITH_LENGTH_0 = $45760a65f870e778$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $5OPQQ = parcelRequire("5OPQQ");

(parcelRequire("bniia"))($45760a65f870e778$var$Transform, $5OPQQ);
function $45760a65f870e778$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $45760a65f870e778$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $45760a65f870e778$var$Transform(options) {
    if (!(this instanceof $45760a65f870e778$var$Transform)) return new $45760a65f870e778$var$Transform(options);
    $5OPQQ.call(this, options);
    this._transformState = {
        afterTransform: $45760a65f870e778$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $45760a65f870e778$var$prefinish);
}
function $45760a65f870e778$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $45760a65f870e778$var$done(_this, er, data);
    });
    else $45760a65f870e778$var$done(this, null, null);
}
$45760a65f870e778$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $5OPQQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$45760a65f870e778$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $45760a65f870e778$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$45760a65f870e778$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$45760a65f870e778$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$45760a65f870e778$var$Transform.prototype._destroy = function(err, cb) {
    $5OPQQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $45760a65f870e778$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $45760a65f870e778$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $45760a65f870e778$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("fxcM6", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $b4f3d8eb33848b60$var$PassThrough;

var $5XJRJ = parcelRequire("5XJRJ");

(parcelRequire("bniia"))($b4f3d8eb33848b60$var$PassThrough, $5XJRJ);
function $b4f3d8eb33848b60$var$PassThrough(options) {
    if (!(this instanceof $b4f3d8eb33848b60$var$PassThrough)) return new $b4f3d8eb33848b60$var$PassThrough(options);
    $5XJRJ.call(this, options);
}
$b4f3d8eb33848b60$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("9kIr2", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $6cb8732f82d3b8f9$var$eos;
function $6cb8732f82d3b8f9$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $kWZ9n = parcelRequire("kWZ9n");
var $6cb8732f82d3b8f9$require$_require$codes = $kWZ9n.codes;
var $6cb8732f82d3b8f9$var$ERR_MISSING_ARGS = $6cb8732f82d3b8f9$require$_require$codes.ERR_MISSING_ARGS, $6cb8732f82d3b8f9$var$ERR_STREAM_DESTROYED = $6cb8732f82d3b8f9$require$_require$codes.ERR_STREAM_DESTROYED;
function $6cb8732f82d3b8f9$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $6cb8732f82d3b8f9$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $6cb8732f82d3b8f9$var$destroyer(stream, reading, writing, callback) {
    callback = $6cb8732f82d3b8f9$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($6cb8732f82d3b8f9$var$eos === undefined) $6cb8732f82d3b8f9$var$eos = (parcelRequire("5DTHA"));
    $6cb8732f82d3b8f9$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($6cb8732f82d3b8f9$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $6cb8732f82d3b8f9$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $6cb8732f82d3b8f9$var$call(fn) {
    fn();
}
function $6cb8732f82d3b8f9$var$pipe(from, to) {
    return from.pipe(to);
}
function $6cb8732f82d3b8f9$var$popCallback(streams) {
    if (!streams.length) return $6cb8732f82d3b8f9$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $6cb8732f82d3b8f9$var$noop;
    return streams.pop();
}
function $6cb8732f82d3b8f9$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $6cb8732f82d3b8f9$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $6cb8732f82d3b8f9$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $6cb8732f82d3b8f9$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($6cb8732f82d3b8f9$var$call);
            if (reading) return;
            destroys.forEach($6cb8732f82d3b8f9$var$call);
            callback(error);
        });
    });
    return streams.reduce($6cb8732f82d3b8f9$var$pipe);
}
module.exports = $6cb8732f82d3b8f9$var$pipeline;

});


parcelRegister("5DFzG", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $ajwPf = parcelRequire("ajwPf");
var $41b0d81643f8a8d4$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $41b0d81643f8a8d4$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$41b0d81643f8a8d4$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($41b0d81643f8a8d4$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($41b0d81643f8a8d4$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($41b0d81643f8a8d4$var$isNull(x) || !$41b0d81643f8a8d4$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $41b0d81643f8a8d4$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($ajwPf.throwDeprecation) throw new Error(msg);
            else if ($ajwPf.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $41b0d81643f8a8d4$var$debugs = {};
var $41b0d81643f8a8d4$var$debugEnvRegex = /^$/;
var $41b0d81643f8a8d4$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$41b0d81643f8a8d4$var$debugs[set]) {
        if ($41b0d81643f8a8d4$var$debugEnvRegex.test(set)) {
            var pid = $ajwPf.pid;
            $41b0d81643f8a8d4$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $41b0d81643f8a8d4$var$debugs[set] = function() {};
    }
    return $41b0d81643f8a8d4$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $41b0d81643f8a8d4$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $41b0d81643f8a8d4$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($41b0d81643f8a8d4$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($41b0d81643f8a8d4$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($41b0d81643f8a8d4$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($41b0d81643f8a8d4$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($41b0d81643f8a8d4$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $41b0d81643f8a8d4$var$stylizeWithColor;
    return $41b0d81643f8a8d4$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $41b0d81643f8a8d4$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$41b0d81643f8a8d4$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$41b0d81643f8a8d4$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $41b0d81643f8a8d4$var$stylizeWithColor(str, styleType) {
    var style = $41b0d81643f8a8d4$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $41b0d81643f8a8d4$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $41b0d81643f8a8d4$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $41b0d81643f8a8d4$var$stylizeNoColor(str, styleType) {
    return str;
}
function $41b0d81643f8a8d4$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $41b0d81643f8a8d4$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $41b0d81643f8a8d4$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$41b0d81643f8a8d4$var$isString(ret)) ret = $41b0d81643f8a8d4$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $41b0d81643f8a8d4$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $41b0d81643f8a8d4$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($41b0d81643f8a8d4$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $41b0d81643f8a8d4$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($41b0d81643f8a8d4$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($41b0d81643f8a8d4$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($41b0d81643f8a8d4$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($41b0d81643f8a8d4$var$isError(value)) return $41b0d81643f8a8d4$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($41b0d81643f8a8d4$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($41b0d81643f8a8d4$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($41b0d81643f8a8d4$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($41b0d81643f8a8d4$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($41b0d81643f8a8d4$var$isError(value)) base = ' ' + $41b0d81643f8a8d4$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($41b0d81643f8a8d4$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $41b0d81643f8a8d4$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $41b0d81643f8a8d4$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $41b0d81643f8a8d4$var$reduceToSingleString(output, base, braces);
}
function $41b0d81643f8a8d4$var$formatPrimitive(ctx, value) {
    if ($41b0d81643f8a8d4$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($41b0d81643f8a8d4$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($41b0d81643f8a8d4$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($41b0d81643f8a8d4$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($41b0d81643f8a8d4$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $41b0d81643f8a8d4$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $41b0d81643f8a8d4$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($41b0d81643f8a8d4$var$hasOwnProperty(value, String(i))) output.push($41b0d81643f8a8d4$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($41b0d81643f8a8d4$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $41b0d81643f8a8d4$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$41b0d81643f8a8d4$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($41b0d81643f8a8d4$var$isNull(recurseTimes)) str = $41b0d81643f8a8d4$var$formatValue(ctx, desc.value, null);
            else str = $41b0d81643f8a8d4$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($41b0d81643f8a8d4$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $41b0d81643f8a8d4$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("aW3OO"));
function $41b0d81643f8a8d4$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $41b0d81643f8a8d4$var$isArray;
function $41b0d81643f8a8d4$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $41b0d81643f8a8d4$var$isBoolean;
function $41b0d81643f8a8d4$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $41b0d81643f8a8d4$var$isNull;
function $41b0d81643f8a8d4$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $41b0d81643f8a8d4$var$isNullOrUndefined;
function $41b0d81643f8a8d4$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $41b0d81643f8a8d4$var$isNumber;
function $41b0d81643f8a8d4$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $41b0d81643f8a8d4$var$isString;
function $41b0d81643f8a8d4$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $41b0d81643f8a8d4$var$isSymbol;
function $41b0d81643f8a8d4$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $41b0d81643f8a8d4$var$isUndefined;
function $41b0d81643f8a8d4$var$isRegExp(re) {
    return $41b0d81643f8a8d4$var$isObject(re) && $41b0d81643f8a8d4$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $41b0d81643f8a8d4$var$isRegExp;
module.exports.types.isRegExp = $41b0d81643f8a8d4$var$isRegExp;
function $41b0d81643f8a8d4$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $41b0d81643f8a8d4$var$isObject;
function $41b0d81643f8a8d4$var$isDate(d) {
    return $41b0d81643f8a8d4$var$isObject(d) && $41b0d81643f8a8d4$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $41b0d81643f8a8d4$var$isDate;
module.exports.types.isDate = $41b0d81643f8a8d4$var$isDate;
function $41b0d81643f8a8d4$var$isError(e) {
    return $41b0d81643f8a8d4$var$isObject(e) && ($41b0d81643f8a8d4$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $41b0d81643f8a8d4$var$isError;
module.exports.types.isNativeError = $41b0d81643f8a8d4$var$isError;
function $41b0d81643f8a8d4$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $41b0d81643f8a8d4$var$isFunction;
function $41b0d81643f8a8d4$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $41b0d81643f8a8d4$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("6aIxO"));
function $41b0d81643f8a8d4$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $41b0d81643f8a8d4$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $41b0d81643f8a8d4$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $41b0d81643f8a8d4$var$timestamp() {
    var d = new Date();
    var time = [
        $41b0d81643f8a8d4$var$pad(d.getHours()),
        $41b0d81643f8a8d4$var$pad(d.getMinutes()),
        $41b0d81643f8a8d4$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $41b0d81643f8a8d4$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $41b0d81643f8a8d4$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("bniia"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$41b0d81643f8a8d4$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $41b0d81643f8a8d4$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $41b0d81643f8a8d4$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($41b0d81643f8a8d4$var$kCustomPromisifiedSymbol && original[$41b0d81643f8a8d4$var$kCustomPromisifiedSymbol]) {
        var fn = original[$41b0d81643f8a8d4$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $41b0d81643f8a8d4$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($41b0d81643f8a8d4$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $41b0d81643f8a8d4$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $41b0d81643f8a8d4$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $41b0d81643f8a8d4$var$kCustomPromisifiedSymbol;
function $41b0d81643f8a8d4$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $41b0d81643f8a8d4$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $ajwPf.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $ajwPf.nextTick($41b0d81643f8a8d4$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $41b0d81643f8a8d4$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $41b0d81643f8a8d4$var$callbackify;

});
parcelRegister("aW3OO", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $dicXN = parcelRequire("dicXN");

var $j29Ee = parcelRequire("j29Ee");

var $kduBn = parcelRequire("kduBn");

var $9J0fH = parcelRequire("9J0fH");
function $7f624874644a1c41$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $7f624874644a1c41$var$BigIntSupported = typeof BigInt !== 'undefined';
var $7f624874644a1c41$var$SymbolSupported = typeof Symbol !== 'undefined';
var $7f624874644a1c41$var$ObjectToString = $7f624874644a1c41$var$uncurryThis(Object.prototype.toString);
var $7f624874644a1c41$var$numberValue = $7f624874644a1c41$var$uncurryThis(Number.prototype.valueOf);
var $7f624874644a1c41$var$stringValue = $7f624874644a1c41$var$uncurryThis(String.prototype.valueOf);
var $7f624874644a1c41$var$booleanValue = $7f624874644a1c41$var$uncurryThis(Boolean.prototype.valueOf);
if ($7f624874644a1c41$var$BigIntSupported) var $7f624874644a1c41$var$bigIntValue = $7f624874644a1c41$var$uncurryThis(BigInt.prototype.valueOf);
if ($7f624874644a1c41$var$SymbolSupported) var $7f624874644a1c41$var$symbolValue = $7f624874644a1c41$var$uncurryThis(Symbol.prototype.valueOf);
function $7f624874644a1c41$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $dicXN;
module.exports.isGeneratorFunction = $j29Ee;
module.exports.isTypedArray = $9J0fH;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $7f624874644a1c41$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $7f624874644a1c41$var$isPromise;
function $7f624874644a1c41$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $9J0fH(value) || $7f624874644a1c41$var$isDataView(value);
}
module.exports.isArrayBufferView = $7f624874644a1c41$var$isArrayBufferView;
function $7f624874644a1c41$var$isUint8Array(value) {
    return $kduBn(value) === 'Uint8Array';
}
module.exports.isUint8Array = $7f624874644a1c41$var$isUint8Array;
function $7f624874644a1c41$var$isUint8ClampedArray(value) {
    return $kduBn(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $7f624874644a1c41$var$isUint8ClampedArray;
function $7f624874644a1c41$var$isUint16Array(value) {
    return $kduBn(value) === 'Uint16Array';
}
module.exports.isUint16Array = $7f624874644a1c41$var$isUint16Array;
function $7f624874644a1c41$var$isUint32Array(value) {
    return $kduBn(value) === 'Uint32Array';
}
module.exports.isUint32Array = $7f624874644a1c41$var$isUint32Array;
function $7f624874644a1c41$var$isInt8Array(value) {
    return $kduBn(value) === 'Int8Array';
}
module.exports.isInt8Array = $7f624874644a1c41$var$isInt8Array;
function $7f624874644a1c41$var$isInt16Array(value) {
    return $kduBn(value) === 'Int16Array';
}
module.exports.isInt16Array = $7f624874644a1c41$var$isInt16Array;
function $7f624874644a1c41$var$isInt32Array(value) {
    return $kduBn(value) === 'Int32Array';
}
module.exports.isInt32Array = $7f624874644a1c41$var$isInt32Array;
function $7f624874644a1c41$var$isFloat32Array(value) {
    return $kduBn(value) === 'Float32Array';
}
module.exports.isFloat32Array = $7f624874644a1c41$var$isFloat32Array;
function $7f624874644a1c41$var$isFloat64Array(value) {
    return $kduBn(value) === 'Float64Array';
}
module.exports.isFloat64Array = $7f624874644a1c41$var$isFloat64Array;
function $7f624874644a1c41$var$isBigInt64Array(value) {
    return $kduBn(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $7f624874644a1c41$var$isBigInt64Array;
function $7f624874644a1c41$var$isBigUint64Array(value) {
    return $kduBn(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $7f624874644a1c41$var$isBigUint64Array;
function $7f624874644a1c41$var$isMapToString(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object Map]';
}
$7f624874644a1c41$var$isMapToString.working = typeof Map !== 'undefined' && $7f624874644a1c41$var$isMapToString(new Map());
function $7f624874644a1c41$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $7f624874644a1c41$var$isMapToString.working ? $7f624874644a1c41$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $7f624874644a1c41$var$isMap;
function $7f624874644a1c41$var$isSetToString(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object Set]';
}
$7f624874644a1c41$var$isSetToString.working = typeof Set !== 'undefined' && $7f624874644a1c41$var$isSetToString(new Set());
function $7f624874644a1c41$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $7f624874644a1c41$var$isSetToString.working ? $7f624874644a1c41$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $7f624874644a1c41$var$isSet;
function $7f624874644a1c41$var$isWeakMapToString(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object WeakMap]';
}
$7f624874644a1c41$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $7f624874644a1c41$var$isWeakMapToString(new WeakMap());
function $7f624874644a1c41$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $7f624874644a1c41$var$isWeakMapToString.working ? $7f624874644a1c41$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $7f624874644a1c41$var$isWeakMap;
function $7f624874644a1c41$var$isWeakSetToString(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object WeakSet]';
}
$7f624874644a1c41$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $7f624874644a1c41$var$isWeakSetToString(new WeakSet());
function $7f624874644a1c41$var$isWeakSet(value) {
    return $7f624874644a1c41$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $7f624874644a1c41$var$isWeakSet;
function $7f624874644a1c41$var$isArrayBufferToString(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$7f624874644a1c41$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $7f624874644a1c41$var$isArrayBufferToString(new ArrayBuffer());
function $7f624874644a1c41$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $7f624874644a1c41$var$isArrayBufferToString.working ? $7f624874644a1c41$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $7f624874644a1c41$var$isArrayBuffer;
function $7f624874644a1c41$var$isDataViewToString(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object DataView]';
}
$7f624874644a1c41$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $7f624874644a1c41$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $7f624874644a1c41$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $7f624874644a1c41$var$isDataViewToString.working ? $7f624874644a1c41$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $7f624874644a1c41$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $7f624874644a1c41$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $7f624874644a1c41$var$isSharedArrayBufferToString(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $7f624874644a1c41$var$isSharedArrayBuffer(value) {
    if (typeof $7f624874644a1c41$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $7f624874644a1c41$var$isSharedArrayBufferToString.working === 'undefined') $7f624874644a1c41$var$isSharedArrayBufferToString.working = $7f624874644a1c41$var$isSharedArrayBufferToString(new $7f624874644a1c41$var$SharedArrayBufferCopy());
    return $7f624874644a1c41$var$isSharedArrayBufferToString.working ? $7f624874644a1c41$var$isSharedArrayBufferToString(value) : value instanceof $7f624874644a1c41$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $7f624874644a1c41$var$isSharedArrayBuffer;
function $7f624874644a1c41$var$isAsyncFunction(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $7f624874644a1c41$var$isAsyncFunction;
function $7f624874644a1c41$var$isMapIterator(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $7f624874644a1c41$var$isMapIterator;
function $7f624874644a1c41$var$isSetIterator(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $7f624874644a1c41$var$isSetIterator;
function $7f624874644a1c41$var$isGeneratorObject(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $7f624874644a1c41$var$isGeneratorObject;
function $7f624874644a1c41$var$isWebAssemblyCompiledModule(value) {
    return $7f624874644a1c41$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $7f624874644a1c41$var$isWebAssemblyCompiledModule;
function $7f624874644a1c41$var$isNumberObject(value) {
    return $7f624874644a1c41$var$checkBoxedPrimitive(value, $7f624874644a1c41$var$numberValue);
}
module.exports.isNumberObject = $7f624874644a1c41$var$isNumberObject;
function $7f624874644a1c41$var$isStringObject(value) {
    return $7f624874644a1c41$var$checkBoxedPrimitive(value, $7f624874644a1c41$var$stringValue);
}
module.exports.isStringObject = $7f624874644a1c41$var$isStringObject;
function $7f624874644a1c41$var$isBooleanObject(value) {
    return $7f624874644a1c41$var$checkBoxedPrimitive(value, $7f624874644a1c41$var$booleanValue);
}
module.exports.isBooleanObject = $7f624874644a1c41$var$isBooleanObject;
function $7f624874644a1c41$var$isBigIntObject(value) {
    return $7f624874644a1c41$var$BigIntSupported && $7f624874644a1c41$var$checkBoxedPrimitive(value, $7f624874644a1c41$var$bigIntValue);
}
module.exports.isBigIntObject = $7f624874644a1c41$var$isBigIntObject;
function $7f624874644a1c41$var$isSymbolObject(value) {
    return $7f624874644a1c41$var$SymbolSupported && $7f624874644a1c41$var$checkBoxedPrimitive(value, $7f624874644a1c41$var$symbolValue);
}
module.exports.isSymbolObject = $7f624874644a1c41$var$isSymbolObject;
function $7f624874644a1c41$var$isBoxedPrimitive(value) {
    return $7f624874644a1c41$var$isNumberObject(value) || $7f624874644a1c41$var$isStringObject(value) || $7f624874644a1c41$var$isBooleanObject(value) || $7f624874644a1c41$var$isBigIntObject(value) || $7f624874644a1c41$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $7f624874644a1c41$var$isBoxedPrimitive;
function $7f624874644a1c41$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($7f624874644a1c41$var$isArrayBuffer(value) || $7f624874644a1c41$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $7f624874644a1c41$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("dicXN", function(module, exports) {
'use strict';

var $9ad7030f1033f3c7$var$hasToStringTag = (parcelRequire("5FDXm"))();

var $g81mU = parcelRequire("g81mU");
var $9ad7030f1033f3c7$var$$toString = $g81mU('Object.prototype.toString');
/** @type {import('.')} */ var $9ad7030f1033f3c7$var$isStandardArguments = function isArguments(value) {
    if ($9ad7030f1033f3c7$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $9ad7030f1033f3c7$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $9ad7030f1033f3c7$var$isLegacyArguments = function isArguments(value) {
    if ($9ad7030f1033f3c7$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $9ad7030f1033f3c7$var$$toString(value) !== '[object Array]' && 'callee' in value && $9ad7030f1033f3c7$var$$toString(value.callee) === '[object Function]';
};
var $9ad7030f1033f3c7$var$supportsStandardArguments = function() {
    return $9ad7030f1033f3c7$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$9ad7030f1033f3c7$var$isStandardArguments.isLegacyArguments = $9ad7030f1033f3c7$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $9ad7030f1033f3c7$var$supportsStandardArguments ? $9ad7030f1033f3c7$var$isStandardArguments : $9ad7030f1033f3c7$var$isLegacyArguments;

});
parcelRegister("5FDXm", function(module, exports) {
'use strict';

var $4hDYj = parcelRequire("4hDYj");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $4hDYj() && !!Symbol.toStringTag;
};

});
parcelRegister("4hDYj", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("g81mU", function(module, exports) {
'use strict';

var $jjVv5 = parcelRequire("jjVv5");

var $jsGtG = parcelRequire("jsGtG");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $bbde747453370be2$var$$indexOf = $jsGtG([
    $jjVv5('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $jjVv5(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $bbde747453370be2$var$$indexOf(name, '.prototype.') > -1) return $jsGtG(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("jjVv5", function(module, exports) {
'use strict';
var $e10c651283a25cd0$var$undefined1;

var $gX4Xa = parcelRequire("gX4Xa");

var $aCHxl = parcelRequire("aCHxl");

var $b4TuV = parcelRequire("b4TuV");

var $b2bra = parcelRequire("b2bra");

var $2SThx = parcelRequire("2SThx");

var $fWR09 = parcelRequire("fWR09");

var $bd4Go = parcelRequire("bd4Go");

var $e9xD9 = parcelRequire("e9xD9");

var $e3oFb = parcelRequire("e3oFb");

var $iU9Km = parcelRequire("iU9Km");

var $k7RyD = parcelRequire("k7RyD");

var $6OYL9 = parcelRequire("6OYL9");

var $3ylY6 = parcelRequire("3ylY6");

var $2UT2R = parcelRequire("2UT2R");

var $aO3or = parcelRequire("aO3or");
var $e10c651283a25cd0$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $e10c651283a25cd0$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $e10c651283a25cd0$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $9y1lh = parcelRequire("9y1lh");

var $lU6yz = parcelRequire("lU6yz");
var $e10c651283a25cd0$var$throwTypeError = function() {
    throw new $bd4Go();
};
var $e10c651283a25cd0$var$ThrowTypeError = $9y1lh ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $e10c651283a25cd0$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $9y1lh(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $e10c651283a25cd0$var$throwTypeError;
        }
    }
}() : $e10c651283a25cd0$var$throwTypeError;

var $e10c651283a25cd0$var$hasSymbols = (parcelRequire("8wwIK"))();

var $jjOI9 = parcelRequire("jjOI9");

var $1FGUy = parcelRequire("1FGUy");

var $2t47g = parcelRequire("2t47g");

var $fBhij = parcelRequire("fBhij");

var $vpcDR = parcelRequire("vpcDR");
var $e10c651283a25cd0$var$needsEval = {};
var $e10c651283a25cd0$var$TypedArray = typeof Uint8Array === 'undefined' || !$jjOI9 ? undefined : $jjOI9(Uint8Array);
var $e10c651283a25cd0$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $e10c651283a25cd0$var$hasSymbols && $jjOI9 ? $jjOI9([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $e10c651283a25cd0$var$needsEval,
    '%AsyncGenerator%': $e10c651283a25cd0$var$needsEval,
    '%AsyncGeneratorFunction%': $e10c651283a25cd0$var$needsEval,
    '%AsyncIteratorPrototype%': $e10c651283a25cd0$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $aCHxl,
    '%eval%': eval,
    '%EvalError%': $b4TuV,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $e10c651283a25cd0$var$$Function,
    '%GeneratorFunction%': $e10c651283a25cd0$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $e10c651283a25cd0$var$hasSymbols && $jjOI9 ? $jjOI9($jjOI9([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$e10c651283a25cd0$var$hasSymbols || !$jjOI9 ? undefined : $jjOI9(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $gX4Xa,
    '%Object.getOwnPropertyDescriptor%': $9y1lh,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $b2bra,
    '%ReferenceError%': $2SThx,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$e10c651283a25cd0$var$hasSymbols || !$jjOI9 ? undefined : $jjOI9(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $e10c651283a25cd0$var$hasSymbols && $jjOI9 ? $jjOI9(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $e10c651283a25cd0$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $fWR09,
    '%ThrowTypeError%': $e10c651283a25cd0$var$ThrowTypeError,
    '%TypedArray%': $e10c651283a25cd0$var$TypedArray,
    '%TypeError%': $bd4Go,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $e9xD9,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $vpcDR,
    '%Function.prototype.apply%': $fBhij,
    '%Object.defineProperty%': $lU6yz,
    '%Object.getPrototypeOf%': $1FGUy,
    '%Math.abs%': $e3oFb,
    '%Math.floor%': $iU9Km,
    '%Math.max%': $k7RyD,
    '%Math.min%': $6OYL9,
    '%Math.pow%': $3ylY6,
    '%Math.round%': $2UT2R,
    '%Math.sign%': $aO3or,
    '%Reflect.getPrototypeOf%': $2t47g
};
if ($jjOI9) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $e10c651283a25cd0$var$errorProto = $jjOI9($jjOI9(e));
    $e10c651283a25cd0$var$INTRINSICS['%Error.prototype%'] = $e10c651283a25cd0$var$errorProto;
}
var $e10c651283a25cd0$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $e10c651283a25cd0$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $e10c651283a25cd0$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $e10c651283a25cd0$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $jjOI9) value = $jjOI9(gen.prototype);
    }
    $e10c651283a25cd0$var$INTRINSICS[name] = value;
    return value;
};
var $e10c651283a25cd0$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $fWTH1 = parcelRequire("fWTH1");

var $hTKbj = parcelRequire("hTKbj");
var $e10c651283a25cd0$var$$concat = $fWTH1.call($vpcDR, Array.prototype.concat);
var $e10c651283a25cd0$var$$spliceApply = $fWTH1.call($fBhij, Array.prototype.splice);
var $e10c651283a25cd0$var$$replace = $fWTH1.call($vpcDR, String.prototype.replace);
var $e10c651283a25cd0$var$$strSlice = $fWTH1.call($vpcDR, String.prototype.slice);
var $e10c651283a25cd0$var$$exec = $fWTH1.call($vpcDR, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $e10c651283a25cd0$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $e10c651283a25cd0$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $e10c651283a25cd0$var$stringToPath = function stringToPath(string) {
    var first = $e10c651283a25cd0$var$$strSlice(string, 0, 1);
    var last = $e10c651283a25cd0$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $fWR09('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $fWR09('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $e10c651283a25cd0$var$$replace(string, $e10c651283a25cd0$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $e10c651283a25cd0$var$$replace(subString, $e10c651283a25cd0$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $e10c651283a25cd0$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($hTKbj($e10c651283a25cd0$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $e10c651283a25cd0$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($hTKbj($e10c651283a25cd0$var$INTRINSICS, intrinsicName)) {
        var value = $e10c651283a25cd0$var$INTRINSICS[intrinsicName];
        if (value === $e10c651283a25cd0$var$needsEval) value = $e10c651283a25cd0$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $bd4Go('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $fWR09('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $bd4Go('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $bd4Go('"allowMissing" argument must be a boolean');
    if ($e10c651283a25cd0$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $fWR09('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $e10c651283a25cd0$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $e10c651283a25cd0$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $e10c651283a25cd0$var$$spliceApply(parts, $e10c651283a25cd0$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $e10c651283a25cd0$var$$strSlice(part, 0, 1);
        var last = $e10c651283a25cd0$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $fWR09('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($hTKbj($e10c651283a25cd0$var$INTRINSICS, intrinsicRealName)) value = $e10c651283a25cd0$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $bd4Go('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($9y1lh && i + 1 >= parts.length) {
                var desc = $9y1lh(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $hTKbj(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $e10c651283a25cd0$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("gX4Xa", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("aCHxl", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("b4TuV", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("b2bra", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2SThx", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("fWR09", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("bd4Go", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("e9xD9", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("e3oFb", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("iU9Km", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("k7RyD", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("6OYL9", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("3ylY6", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("2UT2R", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("aO3or", function(module, exports) {
'use strict';

var $l3V9k = parcelRequire("l3V9k");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($l3V9k(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("l3V9k", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("9y1lh", function(module, exports) {
'use strict';

var $83hfv = parcelRequire("83hfv");
var $6f38548b89c61288$require$$gOPD = $83hfv;
if ($6f38548b89c61288$require$$gOPD) try {
    $6f38548b89c61288$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $6f38548b89c61288$require$$gOPD = null;
}
module.exports = $6f38548b89c61288$require$$gOPD;

});
parcelRegister("83hfv", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("lU6yz", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $ff23e9eb1b4886a7$var$$defineProperty = Object.defineProperty || false;
if ($ff23e9eb1b4886a7$var$$defineProperty) try {
    $ff23e9eb1b4886a7$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $ff23e9eb1b4886a7$var$$defineProperty = false;
}
module.exports = $ff23e9eb1b4886a7$var$$defineProperty;

});

parcelRegister("8wwIK", function(module, exports) {
'use strict';
var $634ab18eab4916a6$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $4hDYj = parcelRequire("4hDYj");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $634ab18eab4916a6$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $634ab18eab4916a6$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $4hDYj();
};

});

parcelRegister("jjOI9", function(module, exports) {
'use strict';

var $2t47g = parcelRequire("2t47g");

var $1FGUy = parcelRequire("1FGUy");

var $3o8XN = parcelRequire("3o8XN");
/** @type {import('.')} */ module.exports = $2t47g ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $2t47g(O);
} : $1FGUy ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1FGUy(O);
} : $3o8XN ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $3o8XN(O);
} : null;

});
parcelRegister("2t47g", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("1FGUy", function(module, exports) {
'use strict';

var $gX4Xa = parcelRequire("gX4Xa");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $gX4Xa.getPrototypeOf || null;

});

parcelRegister("3o8XN", function(module, exports) {
'use strict';

var $jsGtG = parcelRequire("jsGtG");

var $9y1lh = parcelRequire("9y1lh");
var $277a90f5f9223e2f$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $277a90f5f9223e2f$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $277a90f5f9223e2f$var$desc = !!$277a90f5f9223e2f$var$hasProtoAccessor && $9y1lh && $9y1lh(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $277a90f5f9223e2f$var$$Object = Object;
var $277a90f5f9223e2f$var$$getPrototypeOf = $277a90f5f9223e2f$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $277a90f5f9223e2f$var$desc && typeof $277a90f5f9223e2f$var$desc.get === 'function' ? $jsGtG([
    $277a90f5f9223e2f$var$desc.get
]) : typeof $277a90f5f9223e2f$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $277a90f5f9223e2f$var$$getPrototypeOf(value == null ? value : $277a90f5f9223e2f$var$$Object(value));
} : false;

});
parcelRegister("jsGtG", function(module, exports) {
'use strict';

var $fWTH1 = parcelRequire("fWTH1");

var $bd4Go = parcelRequire("bd4Go");

var $vpcDR = parcelRequire("vpcDR");

var $fHBhu = parcelRequire("fHBhu");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $bd4Go('a function is required');
    return $fHBhu($fWTH1, $vpcDR, args);
};

});
parcelRegister("fWTH1", function(module, exports) {
'use strict';

var $j532l = parcelRequire("j532l");
module.exports = Function.prototype.bind || $j532l;

});
parcelRegister("j532l", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $de40d6ffd4cf5938$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $de40d6ffd4cf5938$var$toStr = Object.prototype.toString;
var $de40d6ffd4cf5938$var$max = Math.max;
var $de40d6ffd4cf5938$var$funcType = '[object Function]';
var $de40d6ffd4cf5938$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $de40d6ffd4cf5938$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $de40d6ffd4cf5938$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $de40d6ffd4cf5938$var$toStr.apply(target) !== $de40d6ffd4cf5938$var$funcType) throw new TypeError($de40d6ffd4cf5938$var$ERROR_MESSAGE + target);
    var args = $de40d6ffd4cf5938$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $de40d6ffd4cf5938$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $de40d6ffd4cf5938$var$concatty(args, arguments));
    };
    var boundLength = $de40d6ffd4cf5938$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $de40d6ffd4cf5938$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("vpcDR", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("fHBhu", function(module, exports) {
'use strict';

var $fWTH1 = parcelRequire("fWTH1");

var $fBhij = parcelRequire("fBhij");

var $vpcDR = parcelRequire("vpcDR");

var $hq1Vc = parcelRequire("hq1Vc");
/** @type {import('./actualApply')} */ module.exports = $hq1Vc || $fWTH1.call($vpcDR, $fBhij);

});
parcelRegister("fBhij", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("hq1Vc", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("hTKbj", function(module, exports) {
'use strict';
var $d07b656abef7c31f$var$call = Function.prototype.call;
var $d07b656abef7c31f$var$$hasOwn = Object.prototype.hasOwnProperty;

var $fWTH1 = parcelRequire("fWTH1");
/** @type {import('.')} */ module.exports = $fWTH1.call($d07b656abef7c31f$var$call, $d07b656abef7c31f$var$$hasOwn);

});




parcelRegister("j29Ee", function(module, exports) {
'use strict';

var $g81mU = parcelRequire("g81mU");

var $eP6Nz = parcelRequire("eP6Nz");
var $ddb5b014c5b0581d$var$isFnRegex = $eP6Nz(/^\s*(?:function)?\*/);

var $ddb5b014c5b0581d$var$hasToStringTag = (parcelRequire("5FDXm"))();

var $jjOI9 = parcelRequire("jjOI9");
var $ddb5b014c5b0581d$var$toStr = $g81mU('Object.prototype.toString');
var $ddb5b014c5b0581d$var$fnToStr = $g81mU('Function.prototype.toString');

var $8Z0rE = parcelRequire("8Z0rE");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($ddb5b014c5b0581d$var$isFnRegex($ddb5b014c5b0581d$var$fnToStr(fn))) return true;
    if (!$ddb5b014c5b0581d$var$hasToStringTag) {
        var str = $ddb5b014c5b0581d$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$jjOI9) return false;
    var GeneratorFunction = $8Z0rE();
    return GeneratorFunction && $jjOI9(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("eP6Nz", function(module, exports) {
'use strict';

var $g81mU = parcelRequire("g81mU");

var $46ZIB = parcelRequire("46ZIB");
var $acab1a22f3900001$var$$exec = $g81mU('RegExp.prototype.exec');

var $bd4Go = parcelRequire("bd4Go");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$46ZIB(regex)) throw new $bd4Go('`regex` must be a RegExp');
    return function test(s) {
        return $acab1a22f3900001$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("46ZIB", function(module, exports) {
'use strict';

var $g81mU = parcelRequire("g81mU");

var $2fe798f5af44c689$var$hasToStringTag = (parcelRequire("5FDXm"))();

var $hTKbj = parcelRequire("hTKbj");

var $9y1lh = parcelRequire("9y1lh");
/** @type {import('.')} */ var $2fe798f5af44c689$var$fn;
if ($2fe798f5af44c689$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $2fe798f5af44c689$var$$exec = $g81mU('RegExp.prototype.exec');
    /** @type {object} */ var $2fe798f5af44c689$var$isRegexMarker = {};
    var $2fe798f5af44c689$var$throwRegexMarker = function() {
        throw $2fe798f5af44c689$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $2fe798f5af44c689$var$badStringifier = {
        toString: $2fe798f5af44c689$var$throwRegexMarker,
        valueOf: $2fe798f5af44c689$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $2fe798f5af44c689$var$badStringifier[Symbol.toPrimitive] = $2fe798f5af44c689$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $2fe798f5af44c689$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $9y1lh(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $hTKbj(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $2fe798f5af44c689$var$$exec(value, /** @type {unknown} */ $2fe798f5af44c689$var$badStringifier);
        } catch (e) {
            return e === $2fe798f5af44c689$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $2fe798f5af44c689$var$$toString = $g81mU('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $2fe798f5af44c689$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $2fe798f5af44c689$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $2fe798f5af44c689$var$$toString(value) === $2fe798f5af44c689$var$regexClass;
    };
}
module.exports = $2fe798f5af44c689$var$fn;

});


parcelRegister("8Z0rE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6907b41390e1eb7b$export$2e2bcd8739ae039);

var $dL9Ax = parcelRequire("dL9Ax");
var /** @type {import('./index.d.mts').default} */ $6907b41390e1eb7b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($dL9Ax)));

});
parcelRegister("dL9Ax", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $a0471a2ad3c2a4be$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$a0471a2ad3c2a4be$var$cached;

});



parcelRegister("kduBn", function(module, exports) {
'use strict';

var $gVIf7 = parcelRequire("gVIf7");

var $dlTe4 = parcelRequire("dlTe4");

var $eYtAb = parcelRequire("eYtAb");

var $g81mU = parcelRequire("g81mU");

var $9y1lh = parcelRequire("9y1lh");

var $jjOI9 = parcelRequire("jjOI9");
var $eb7cc26c4b374ecd$var$$toString = $g81mU('Object.prototype.toString');

var $eb7cc26c4b374ecd$var$hasToStringTag = (parcelRequire("5FDXm"))();
var $eb7cc26c4b374ecd$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $eb7cc26c4b374ecd$var$typedArrays = $dlTe4();
var $eb7cc26c4b374ecd$var$$slice = $g81mU('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $eb7cc26c4b374ecd$var$$indexOf = $g81mU('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $eb7cc26c4b374ecd$var$cache = {
    __proto__: null
};
if ($eb7cc26c4b374ecd$var$hasToStringTag && $9y1lh && $jjOI9) $gVIf7($eb7cc26c4b374ecd$var$typedArrays, function(typedArray) {
    var arr = new $eb7cc26c4b374ecd$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $jjOI9) {
        var proto = $jjOI9(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $9y1lh(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $jjOI9(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $9y1lh(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $eYtAb(descriptor.get);
            $eb7cc26c4b374ecd$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $gVIf7($eb7cc26c4b374ecd$var$typedArrays, function(typedArray) {
    var arr = new $eb7cc26c4b374ecd$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $eYtAb(fn);
        $eb7cc26c4b374ecd$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $eb7cc26c4b374ecd$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $gVIf7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $eb7cc26c4b374ecd$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $eb7cc26c4b374ecd$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $eb7cc26c4b374ecd$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $gVIf7(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $eb7cc26c4b374ecd$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $eb7cc26c4b374ecd$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$eb7cc26c4b374ecd$var$hasToStringTag) {
        /** @type {string} */ var tag = $eb7cc26c4b374ecd$var$$slice($eb7cc26c4b374ecd$var$$toString(value), 8, -1);
        if ($eb7cc26c4b374ecd$var$$indexOf($eb7cc26c4b374ecd$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $eb7cc26c4b374ecd$var$trySlices(value);
    }
    if (!$9y1lh) return null;
     // unknown engine
    return $eb7cc26c4b374ecd$var$tryTypedArrays(value);
};

});
parcelRegister("gVIf7", function(module, exports) {
'use strict';

var $h1xpa = parcelRequire("h1xpa");
var $c53449e8d6c953b7$var$toStr = Object.prototype.toString;
var $c53449e8d6c953b7$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c53449e8d6c953b7$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c53449e8d6c953b7$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c53449e8d6c953b7$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c53449e8d6c953b7$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c53449e8d6c953b7$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c53449e8d6c953b7$var$isArray(x) {
    return $c53449e8d6c953b7$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$h1xpa(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c53449e8d6c953b7$var$isArray(list)) $c53449e8d6c953b7$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c53449e8d6c953b7$var$forEachString(list, iterator, receiver);
    else $c53449e8d6c953b7$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("h1xpa", function(module, exports) {
'use strict';
var $c64c713294da406b$var$fnToStr = Function.prototype.toString;
var $c64c713294da406b$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $c64c713294da406b$var$badArrayLike;
var $c64c713294da406b$var$isCallableMarker;
if (typeof $c64c713294da406b$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $c64c713294da406b$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $c64c713294da406b$var$isCallableMarker;
        }
    });
    $c64c713294da406b$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $c64c713294da406b$var$reflectApply(function() {
        throw 42;
    }, null, $c64c713294da406b$var$badArrayLike);
} catch (_) {
    if (_ !== $c64c713294da406b$var$isCallableMarker) $c64c713294da406b$var$reflectApply = null;
}
else $c64c713294da406b$var$reflectApply = null;
var $c64c713294da406b$var$constructorRegex = /^\s*class\b/;
var $c64c713294da406b$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $c64c713294da406b$var$fnToStr.call(value);
        return $c64c713294da406b$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $c64c713294da406b$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($c64c713294da406b$var$isES6ClassFn(value)) return false;
        $c64c713294da406b$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $c64c713294da406b$var$toStr = Object.prototype.toString;
var $c64c713294da406b$var$objectClass = '[object Object]';
var $c64c713294da406b$var$fnClass = '[object Function]';
var $c64c713294da406b$var$genClass = '[object GeneratorFunction]';
var $c64c713294da406b$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $c64c713294da406b$var$ddaClass2 = '[object HTML document.all class]';
var $c64c713294da406b$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $c64c713294da406b$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $c64c713294da406b$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $c64c713294da406b$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $c64c713294da406b$var$all = document.all;
    if ($c64c713294da406b$var$toStr.call($c64c713294da406b$var$all) === $c64c713294da406b$var$toStr.call(document.all)) $c64c713294da406b$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($c64c713294da406b$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $c64c713294da406b$var$toStr.call(value);
            return (str === $c64c713294da406b$var$ddaClass || str === $c64c713294da406b$var$ddaClass2 || str === $c64c713294da406b$var$ddaClass3 // opera 12.16
             || str === $c64c713294da406b$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $c64c713294da406b$var$reflectApply ? function isCallable(value) {
    if ($c64c713294da406b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $c64c713294da406b$var$reflectApply(value, null, $c64c713294da406b$var$badArrayLike);
    } catch (e) {
        if (e !== $c64c713294da406b$var$isCallableMarker) return false;
    }
    return !$c64c713294da406b$var$isES6ClassFn(value) && $c64c713294da406b$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($c64c713294da406b$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($c64c713294da406b$var$hasToStringTag) return $c64c713294da406b$var$tryFunctionObject(value);
    if ($c64c713294da406b$var$isES6ClassFn(value)) return false;
    var strClass = $c64c713294da406b$var$toStr.call(value);
    if (strClass !== $c64c713294da406b$var$fnClass && strClass !== $c64c713294da406b$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $c64c713294da406b$var$tryFunctionObject(value);
};

});


parcelRegister("dlTe4", function(module, exports) {
'use strict';

var $6Qn4D = parcelRequire("6Qn4D");
var $9b88133ca6b59456$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $6Qn4D.length; i++)if (typeof $9b88133ca6b59456$var$g[$6Qn4D[i]] === 'function') // @ts-expect-error
    out[out.length] = $6Qn4D[i];
    return out;
};

});
parcelRegister("6Qn4D", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("eYtAb", function(module, exports) {
'use strict';

var $5lzVy = parcelRequire("5lzVy");

var $lU6yz = parcelRequire("lU6yz");

var $jsGtG = parcelRequire("jsGtG");

var $05a5c = parcelRequire("05a5c");
module.exports = function callBind(originalFunction) {
    var func = $jsGtG(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $5lzVy(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($lU6yz) $lU6yz(module.exports, 'apply', {
    value: $05a5c
});
else module.exports.apply = $05a5c;

});
parcelRegister("5lzVy", function(module, exports) {
'use strict';

var $jjVv5 = parcelRequire("jjVv5");

var $1XlSv = parcelRequire("1XlSv");

var $3e4ac84e112280da$var$hasDescriptors = (parcelRequire("iXROs"))();

var $9y1lh = parcelRequire("9y1lh");

var $bd4Go = parcelRequire("bd4Go");
var $3e4ac84e112280da$var$$floor = $jjVv5('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $bd4Go('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $3e4ac84e112280da$var$$floor(length) !== length) throw new $bd4Go('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $9y1lh) {
        var desc = $9y1lh(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($3e4ac84e112280da$var$hasDescriptors) $1XlSv(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $1XlSv(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("1XlSv", function(module, exports) {
'use strict';

var $lU6yz = parcelRequire("lU6yz");

var $fWR09 = parcelRequire("fWR09");

var $bd4Go = parcelRequire("bd4Go");

var $9y1lh = parcelRequire("9y1lh");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $bd4Go('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $bd4Go('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $bd4Go('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $bd4Go('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $bd4Go('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $bd4Go('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$9y1lh && $9y1lh(obj, property);
    if ($lU6yz) $lU6yz(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $fWR09('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("iXROs", function(module, exports) {
'use strict';

var $lU6yz = parcelRequire("lU6yz");
var $dce77acc411f2a86$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$lU6yz;
};
$dce77acc411f2a86$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$lU6yz) return null;
    try {
        return $lU6yz([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $dce77acc411f2a86$var$hasPropertyDescriptors;

});


parcelRegister("05a5c", function(module, exports) {
'use strict';

var $fWTH1 = parcelRequire("fWTH1");

var $fBhij = parcelRequire("fBhij");

var $fHBhu = parcelRequire("fHBhu");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $fHBhu($fWTH1, $fBhij, arguments);
};

});



parcelRegister("9J0fH", function(module, exports) {
'use strict';

var $kduBn = parcelRequire("kduBn");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$kduBn(value);
};

});


parcelRegister("6aIxO", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("9xnLy", function(module, exports) {

var $4OiF0 = parcelRequire("4OiF0");
var $6f19a18f168f3e52$require$Buffer = $4OiF0.Buffer;

var $7GYkA = parcelRequire("7GYkA");

var $crX4E = parcelRequire("crX4E");

var $5DFzG = parcelRequire("5DFzG");
var $6f19a18f168f3e52$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $6f19a18f168f3e52$var$MSG_INVALID_SECRET = 'secret must be a string or buffer';
var $6f19a18f168f3e52$var$MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var $6f19a18f168f3e52$var$MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
var $6f19a18f168f3e52$var$supportsKeyObjects = typeof $7GYkA.createPublicKey === 'function';
if ($6f19a18f168f3e52$var$supportsKeyObjects) {
    $6f19a18f168f3e52$var$MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
    $6f19a18f168f3e52$var$MSG_INVALID_SECRET += 'or a KeyObject';
}
function $6f19a18f168f3e52$var$checkIsPublicKey(key) {
    if ($6f19a18f168f3e52$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (!$6f19a18f168f3e52$var$supportsKeyObjects) throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== 'object') throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== 'string') throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== 'string') throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== 'function') throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_VERIFIER_KEY);
}
function $6f19a18f168f3e52$var$checkIsPrivateKey(key) {
    if ($6f19a18f168f3e52$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (typeof key === 'object') return;
    throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_SIGNER_KEY);
}
function $6f19a18f168f3e52$var$checkIsSecretKey(key) {
    if ($6f19a18f168f3e52$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return key;
    if (!$6f19a18f168f3e52$var$supportsKeyObjects) throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_SECRET);
    if (typeof key !== 'object') throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_SECRET);
    if (key.type !== 'secret') throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_SECRET);
    if (typeof key.export !== 'function') throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_SECRET);
}
function $6f19a18f168f3e52$var$fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $6f19a18f168f3e52$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += '=';
    return base64url.replace(/\-/g, '+').replace(/_/g, '/');
}
function $6f19a18f168f3e52$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $5DFzG.format.bind($5DFzG, template).apply(null, args);
    return new TypeError(errMsg);
}
function $6f19a18f168f3e52$var$bufferOrString(obj) {
    return $6f19a18f168f3e52$require$Buffer.isBuffer(obj) || typeof obj === 'string';
}
function $6f19a18f168f3e52$var$normalizeInput(thing) {
    if (!$6f19a18f168f3e52$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $6f19a18f168f3e52$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $6f19a18f168f3e52$var$checkIsSecretKey(secret);
        thing = $6f19a18f168f3e52$var$normalizeInput(thing);
        var hmac = $7GYkA.createHmac('sha' + bits, secret);
        var sig = (hmac.update(thing), hmac.digest('base64'));
        return $6f19a18f168f3e52$var$fromBase64(sig);
    };
}
var $6f19a18f168f3e52$var$bufferEqual;

var $6f19a18f168f3e52$var$timingSafeEqual = 'timingSafeEqual' in $7GYkA ? function timingSafeEqual(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $7GYkA.timingSafeEqual(a, b);
} : function timingSafeEqual(a, b) {
    if (!$6f19a18f168f3e52$var$bufferEqual) $6f19a18f168f3e52$var$bufferEqual = (parcelRequire("74JZ3"));
    return $6f19a18f168f3e52$var$bufferEqual(a, b);
};
function $6f19a18f168f3e52$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $6f19a18f168f3e52$var$createHmacSigner(bits)(thing, secret);
        return $6f19a18f168f3e52$var$timingSafeEqual($6f19a18f168f3e52$require$Buffer.from(signature), $6f19a18f168f3e52$require$Buffer.from(computedSig));
    };
}
function $6f19a18f168f3e52$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $6f19a18f168f3e52$var$checkIsPrivateKey(privateKey);
        thing = $6f19a18f168f3e52$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $7GYkA.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
        return $6f19a18f168f3e52$var$fromBase64(sig);
    };
}
function $6f19a18f168f3e52$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $6f19a18f168f3e52$var$checkIsPublicKey(publicKey);
        thing = $6f19a18f168f3e52$var$normalizeInput(thing);
        signature = $6f19a18f168f3e52$var$toBase64(signature);
        var verifier = $7GYkA.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, 'base64');
    };
}
function $6f19a18f168f3e52$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $6f19a18f168f3e52$var$checkIsPrivateKey(privateKey);
        thing = $6f19a18f168f3e52$var$normalizeInput(thing);
        var signer = $7GYkA.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $7GYkA.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $7GYkA.constants.RSA_PSS_SALTLEN_DIGEST
        }, 'base64'));
        return $6f19a18f168f3e52$var$fromBase64(sig);
    };
}
function $6f19a18f168f3e52$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $6f19a18f168f3e52$var$checkIsPublicKey(publicKey);
        thing = $6f19a18f168f3e52$var$normalizeInput(thing);
        signature = $6f19a18f168f3e52$var$toBase64(signature);
        var verifier = $7GYkA.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $7GYkA.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $7GYkA.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, 'base64');
    };
}
function $6f19a18f168f3e52$var$createECDSASigner(bits) {
    var inner = $6f19a18f168f3e52$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $crX4E.derToJose(signature, 'ES' + bits);
        return signature;
    };
}
function $6f19a18f168f3e52$var$createECDSAVerifer(bits) {
    var inner = $6f19a18f168f3e52$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $crX4E.joseToDer(signature, 'ES' + bits).toString('base64');
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $6f19a18f168f3e52$var$createNoneSigner() {
    return function sign() {
        return '';
    };
}
function $6f19a18f168f3e52$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === '';
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $6f19a18f168f3e52$var$createHmacSigner,
        rs: $6f19a18f168f3e52$var$createKeySigner,
        ps: $6f19a18f168f3e52$var$createPSSKeySigner,
        es: $6f19a18f168f3e52$var$createECDSASigner,
        none: $6f19a18f168f3e52$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $6f19a18f168f3e52$var$createHmacVerifier,
        rs: $6f19a18f168f3e52$var$createKeyVerifier,
        ps: $6f19a18f168f3e52$var$createPSSKeyVerifier,
        es: $6f19a18f168f3e52$var$createECDSAVerifer,
        none: $6f19a18f168f3e52$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
    if (!match) throw $6f19a18f168f3e52$var$typeError($6f19a18f168f3e52$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRegister("7GYkA", function(module, exports) {

$parcel$export(module.exports, "randomBytes", () => $599b4122280d86d6$export$5f828d93ff035aa8, (v) => $599b4122280d86d6$export$5f828d93ff035aa8 = v);
$parcel$export(module.exports, "rng", () => $599b4122280d86d6$export$cd94982b18c6332c, (v) => $599b4122280d86d6$export$cd94982b18c6332c = v);
$parcel$export(module.exports, "pseudoRandomBytes", () => $599b4122280d86d6$export$1d518568e4f529b0, (v) => $599b4122280d86d6$export$1d518568e4f529b0 = v);
$parcel$export(module.exports, "prng", () => $599b4122280d86d6$export$5285b6d41c912b41, (v) => $599b4122280d86d6$export$5285b6d41c912b41 = v);
$parcel$export(module.exports, "createHash", () => $599b4122280d86d6$export$2fb37efbf6ae0c0e, (v) => $599b4122280d86d6$export$2fb37efbf6ae0c0e = v);
$parcel$export(module.exports, "Hash", () => $599b4122280d86d6$export$ab85ecd77ce6a5cd, (v) => $599b4122280d86d6$export$ab85ecd77ce6a5cd = v);
$parcel$export(module.exports, "createHmac", () => $599b4122280d86d6$export$da39cf97e1eb7c91, (v) => $599b4122280d86d6$export$da39cf97e1eb7c91 = v);
$parcel$export(module.exports, "Hmac", () => $599b4122280d86d6$export$52a9039d7177394f, (v) => $599b4122280d86d6$export$52a9039d7177394f = v);
$parcel$export(module.exports, "getHashes", () => $599b4122280d86d6$export$f7201db400317331, (v) => $599b4122280d86d6$export$f7201db400317331 = v);
$parcel$export(module.exports, "pbkdf2", () => $599b4122280d86d6$export$448fa22aedc9dbca, (v) => $599b4122280d86d6$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $599b4122280d86d6$export$b80c7ba289c8fa56, (v) => $599b4122280d86d6$export$b80c7ba289c8fa56 = v);
$parcel$export(module.exports, "Cipher", () => $599b4122280d86d6$export$26e5786e8ac8e530, (v) => $599b4122280d86d6$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipher", () => $599b4122280d86d6$export$bdd223f16383713e, (v) => $599b4122280d86d6$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipheriv", () => $599b4122280d86d6$export$20533d26f07f1ee0, (v) => $599b4122280d86d6$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createCipheriv", () => $599b4122280d86d6$export$2f64596b8cbf08b4, (v) => $599b4122280d86d6$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Decipher", () => $599b4122280d86d6$export$2ce6d8d0e8b04e1a, (v) => $599b4122280d86d6$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipher", () => $599b4122280d86d6$export$12ada9414fbc594c, (v) => $599b4122280d86d6$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipheriv", () => $599b4122280d86d6$export$f5e7e39d57cd9700, (v) => $599b4122280d86d6$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "createDecipheriv", () => $599b4122280d86d6$export$36b6d6ef312eab39, (v) => $599b4122280d86d6$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $599b4122280d86d6$export$58a258485f1e49f6, (v) => $599b4122280d86d6$export$58a258485f1e49f6 = v);
$parcel$export(module.exports, "listCiphers", () => $599b4122280d86d6$export$dedd8dc3dc62b370, (v) => $599b4122280d86d6$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "DiffieHellmanGroup", () => $599b4122280d86d6$export$971862a2fcb1bb40, (v) => $599b4122280d86d6$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $599b4122280d86d6$export$c6ff6a88acbeaf40, (v) => $599b4122280d86d6$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $599b4122280d86d6$export$fdc27893e98845cc, (v) => $599b4122280d86d6$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $599b4122280d86d6$export$6671fb9a1323bed, (v) => $599b4122280d86d6$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $599b4122280d86d6$export$d74daf141a551db, (v) => $599b4122280d86d6$export$d74daf141a551db = v);
$parcel$export(module.exports, "createSign", () => $599b4122280d86d6$export$45df7cae684751af, (v) => $599b4122280d86d6$export$45df7cae684751af = v);
$parcel$export(module.exports, "Sign", () => $599b4122280d86d6$export$1db683ad541682f6, (v) => $599b4122280d86d6$export$1db683ad541682f6 = v);
$parcel$export(module.exports, "createVerify", () => $599b4122280d86d6$export$6f65485f87568e37, (v) => $599b4122280d86d6$export$6f65485f87568e37 = v);
$parcel$export(module.exports, "Verify", () => $599b4122280d86d6$export$91a8e56769aeb334, (v) => $599b4122280d86d6$export$91a8e56769aeb334 = v);
$parcel$export(module.exports, "createECDH", () => $599b4122280d86d6$export$2d4117e99c2179e4, (v) => $599b4122280d86d6$export$2d4117e99c2179e4 = v);
$parcel$export(module.exports, "publicEncrypt", () => $599b4122280d86d6$export$512823e338ddb1b7, (v) => $599b4122280d86d6$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateEncrypt", () => $599b4122280d86d6$export$9d0e0c0c4a8d30f3, (v) => $599b4122280d86d6$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $599b4122280d86d6$export$b9d55ff329113abd, (v) => $599b4122280d86d6$export$b9d55ff329113abd = v);
$parcel$export(module.exports, "privateDecrypt", () => $599b4122280d86d6$export$7efb24e2fddf99b9, (v) => $599b4122280d86d6$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "randomFill", () => $599b4122280d86d6$export$bb1abf2ce84fc7e8, (v) => $599b4122280d86d6$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $599b4122280d86d6$export$2f7171e78e524d5e, (v) => $599b4122280d86d6$export$2f7171e78e524d5e = v);
$parcel$export(module.exports, "createCredentials", () => $599b4122280d86d6$export$e1d879b482f37d98, (v) => $599b4122280d86d6$export$e1d879b482f37d98 = v);
$parcel$export(module.exports, "constants", () => $599b4122280d86d6$export$1a988e7317c65621, (v) => $599b4122280d86d6$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $599b4122280d86d6$export$5f828d93ff035aa8;
var $599b4122280d86d6$export$cd94982b18c6332c;
var $599b4122280d86d6$export$1d518568e4f529b0;
var $599b4122280d86d6$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $599b4122280d86d6$export$2fb37efbf6ae0c0e;
var $599b4122280d86d6$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $599b4122280d86d6$export$da39cf97e1eb7c91;
var $599b4122280d86d6$export$52a9039d7177394f;
var $599b4122280d86d6$export$f7201db400317331;
var $599b4122280d86d6$export$448fa22aedc9dbca;
var $599b4122280d86d6$export$b80c7ba289c8fa56;
var $599b4122280d86d6$export$26e5786e8ac8e530;
var $599b4122280d86d6$export$bdd223f16383713e;
var $599b4122280d86d6$export$20533d26f07f1ee0;
var $599b4122280d86d6$export$2f64596b8cbf08b4;
var $599b4122280d86d6$export$2ce6d8d0e8b04e1a;
var $599b4122280d86d6$export$12ada9414fbc594c;
var $599b4122280d86d6$export$f5e7e39d57cd9700;
var $599b4122280d86d6$export$36b6d6ef312eab39;
var $599b4122280d86d6$export$58a258485f1e49f6;
var $599b4122280d86d6$export$dedd8dc3dc62b370;
var $599b4122280d86d6$export$971862a2fcb1bb40;
var $599b4122280d86d6$export$c6ff6a88acbeaf40;
var $599b4122280d86d6$export$fdc27893e98845cc;
var $599b4122280d86d6$export$6671fb9a1323bed;
var $599b4122280d86d6$export$d74daf141a551db;
var $599b4122280d86d6$export$45df7cae684751af;
var $599b4122280d86d6$export$1db683ad541682f6;
var $599b4122280d86d6$export$6f65485f87568e37;
var $599b4122280d86d6$export$91a8e56769aeb334;
var $599b4122280d86d6$export$2d4117e99c2179e4;
var $599b4122280d86d6$export$512823e338ddb1b7;
var $599b4122280d86d6$export$9d0e0c0c4a8d30f3;
var $599b4122280d86d6$export$b9d55ff329113abd;
var $599b4122280d86d6$export$7efb24e2fddf99b9;
var $599b4122280d86d6$export$bb1abf2ce84fc7e8;
var $599b4122280d86d6$export$2f7171e78e524d5e;
var $599b4122280d86d6$export$e1d879b482f37d98;
var $599b4122280d86d6$export$1a988e7317c65621;
'use strict';

$599b4122280d86d6$export$5f828d93ff035aa8 = $599b4122280d86d6$export$cd94982b18c6332c = $599b4122280d86d6$export$1d518568e4f529b0 = $599b4122280d86d6$export$5285b6d41c912b41 = (parcelRequire("bUSoq"));

$599b4122280d86d6$export$2fb37efbf6ae0c0e = $599b4122280d86d6$export$ab85ecd77ce6a5cd = (parcelRequire("dHvdJ"));

$599b4122280d86d6$export$da39cf97e1eb7c91 = $599b4122280d86d6$export$52a9039d7177394f = (parcelRequire("arZPn"));

var $luisd = parcelRequire("luisd");
var $599b4122280d86d6$var$algoKeys = Object.keys($luisd);
var $599b4122280d86d6$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($599b4122280d86d6$var$algoKeys);
$599b4122280d86d6$export$f7201db400317331 = function() {
    return $599b4122280d86d6$var$hashes;
};

var $ellmV = parcelRequire("ellmV");
$599b4122280d86d6$export$448fa22aedc9dbca = $ellmV.pbkdf2;
$599b4122280d86d6$export$b80c7ba289c8fa56 = $ellmV.pbkdf2Sync;

var $gfQS5 = parcelRequire("gfQS5");
$599b4122280d86d6$export$26e5786e8ac8e530 = $gfQS5.Cipher;
$599b4122280d86d6$export$bdd223f16383713e = $gfQS5.createCipher;
$599b4122280d86d6$export$20533d26f07f1ee0 = $gfQS5.Cipheriv;
$599b4122280d86d6$export$2f64596b8cbf08b4 = $gfQS5.createCipheriv;
$599b4122280d86d6$export$2ce6d8d0e8b04e1a = $gfQS5.Decipher;
$599b4122280d86d6$export$12ada9414fbc594c = $gfQS5.createDecipher;
$599b4122280d86d6$export$f5e7e39d57cd9700 = $gfQS5.Decipheriv;
$599b4122280d86d6$export$36b6d6ef312eab39 = $gfQS5.createDecipheriv;
$599b4122280d86d6$export$58a258485f1e49f6 = $gfQS5.getCiphers;
$599b4122280d86d6$export$dedd8dc3dc62b370 = $gfQS5.listCiphers;

var $9PCF9 = parcelRequire("9PCF9");
$599b4122280d86d6$export$971862a2fcb1bb40 = $9PCF9.DiffieHellmanGroup;
$599b4122280d86d6$export$c6ff6a88acbeaf40 = $9PCF9.createDiffieHellmanGroup;
$599b4122280d86d6$export$fdc27893e98845cc = $9PCF9.getDiffieHellman;
$599b4122280d86d6$export$6671fb9a1323bed = $9PCF9.createDiffieHellman;
$599b4122280d86d6$export$d74daf141a551db = $9PCF9.DiffieHellman;

var $2qrhF = parcelRequire("2qrhF");
$599b4122280d86d6$export$45df7cae684751af = $2qrhF.createSign;
$599b4122280d86d6$export$1db683ad541682f6 = $2qrhF.Sign;
$599b4122280d86d6$export$6f65485f87568e37 = $2qrhF.createVerify;
$599b4122280d86d6$export$91a8e56769aeb334 = $2qrhF.Verify;

$599b4122280d86d6$export$2d4117e99c2179e4 = (parcelRequire("3ZddE"));

var $e76V8 = parcelRequire("e76V8");
$599b4122280d86d6$export$512823e338ddb1b7 = $e76V8.publicEncrypt;
$599b4122280d86d6$export$9d0e0c0c4a8d30f3 = $e76V8.privateEncrypt;
$599b4122280d86d6$export$b9d55ff329113abd = $e76V8.publicDecrypt;
$599b4122280d86d6$export$7efb24e2fddf99b9 = $e76V8.privateDecrypt;

var $30hQH = parcelRequire("30hQH");
$599b4122280d86d6$export$bb1abf2ce84fc7e8 = $30hQH.randomFill;
$599b4122280d86d6$export$2f7171e78e524d5e = $30hQH.randomFillSync;
$599b4122280d86d6$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$599b4122280d86d6$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("bUSoq", function(module, exports) {

var $ajwPf = parcelRequire("ajwPf");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $8acf1e00313c2f61$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $8acf1e00313c2f61$var$MAX_UINT32 = 4294967295;
function $8acf1e00313c2f61$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $4OiF0 = parcelRequire("4OiF0");
var $8acf1e00313c2f61$require$Buffer = $4OiF0.Buffer;
var $8acf1e00313c2f61$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($8acf1e00313c2f61$var$crypto && $8acf1e00313c2f61$var$crypto.getRandomValues) module.exports = $8acf1e00313c2f61$var$randomBytes;
else module.exports = $8acf1e00313c2f61$var$oldBrowser;
function $8acf1e00313c2f61$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $8acf1e00313c2f61$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $8acf1e00313c2f61$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $8acf1e00313c2f61$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $8acf1e00313c2f61$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $8acf1e00313c2f61$var$crypto.getRandomValues(bytes.slice(generated, generated + $8acf1e00313c2f61$var$MAX_BYTES));
        else $8acf1e00313c2f61$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $ajwPf.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("dHvdJ", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $eXAjQ = parcelRequire("eXAjQ");

var $1JYNO = parcelRequire("1JYNO");

var $1eplY = parcelRequire("1eplY");

var $7fR9R = parcelRequire("7fR9R");
function $9f97823a23f5ef70$var$Hash(hash) {
    $7fR9R.call(this, 'digest');
    this._hash = hash;
}
$bniia($9f97823a23f5ef70$var$Hash, $7fR9R);
$9f97823a23f5ef70$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$9f97823a23f5ef70$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $eXAjQ();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $1JYNO();
    return new $9f97823a23f5ef70$var$Hash($1eplY(alg));
};

});
parcelRegister("eXAjQ", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $dGPsD = parcelRequire("dGPsD");

var $4OiF0 = parcelRequire("4OiF0");
var $ae42bf90c776e123$require$Buffer = $4OiF0.Buffer;
var $ae42bf90c776e123$var$ARRAY16 = new Array(16);
function $ae42bf90c776e123$var$MD5() {
    $dGPsD.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$bniia($ae42bf90c776e123$var$MD5, $dGPsD);
$ae42bf90c776e123$var$MD5.prototype._update = function() {
    var M = $ae42bf90c776e123$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $ae42bf90c776e123$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $ae42bf90c776e123$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $ae42bf90c776e123$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $ae42bf90c776e123$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $ae42bf90c776e123$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $ae42bf90c776e123$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $ae42bf90c776e123$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $ae42bf90c776e123$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $ae42bf90c776e123$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $ae42bf90c776e123$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $ae42bf90c776e123$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $ae42bf90c776e123$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $ae42bf90c776e123$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $ae42bf90c776e123$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $ae42bf90c776e123$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $ae42bf90c776e123$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $ae42bf90c776e123$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $ae42bf90c776e123$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $ae42bf90c776e123$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $ae42bf90c776e123$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $ae42bf90c776e123$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $ae42bf90c776e123$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $ae42bf90c776e123$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $ae42bf90c776e123$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $ae42bf90c776e123$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $ae42bf90c776e123$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $ae42bf90c776e123$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $ae42bf90c776e123$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $ae42bf90c776e123$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $ae42bf90c776e123$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $ae42bf90c776e123$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $ae42bf90c776e123$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $ae42bf90c776e123$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $ae42bf90c776e123$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $ae42bf90c776e123$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $ae42bf90c776e123$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $ae42bf90c776e123$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $ae42bf90c776e123$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $ae42bf90c776e123$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $ae42bf90c776e123$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $ae42bf90c776e123$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $ae42bf90c776e123$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $ae42bf90c776e123$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $ae42bf90c776e123$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $ae42bf90c776e123$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $ae42bf90c776e123$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $ae42bf90c776e123$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $ae42bf90c776e123$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $ae42bf90c776e123$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $ae42bf90c776e123$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $ae42bf90c776e123$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $ae42bf90c776e123$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $ae42bf90c776e123$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $ae42bf90c776e123$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $ae42bf90c776e123$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $ae42bf90c776e123$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $ae42bf90c776e123$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $ae42bf90c776e123$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $ae42bf90c776e123$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $ae42bf90c776e123$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $ae42bf90c776e123$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $ae42bf90c776e123$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $ae42bf90c776e123$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $ae42bf90c776e123$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$ae42bf90c776e123$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $ae42bf90c776e123$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $ae42bf90c776e123$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $ae42bf90c776e123$var$fnF(a, b, c, d, m, k, s) {
    return $ae42bf90c776e123$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $ae42bf90c776e123$var$fnG(a, b, c, d, m, k, s) {
    return $ae42bf90c776e123$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $ae42bf90c776e123$var$fnH(a, b, c, d, m, k, s) {
    return $ae42bf90c776e123$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $ae42bf90c776e123$var$fnI(a, b, c, d, m, k, s) {
    return $ae42bf90c776e123$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $ae42bf90c776e123$var$MD5;

});
parcelRegister("dGPsD", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $9f771da68903a577$require$Buffer = $4OiF0.Buffer;

var $9nTep = parcelRequire("9nTep");
var $9f771da68903a577$require$Transform = $9nTep.Transform;

var $bniia = parcelRequire("bniia");
function $9f771da68903a577$var$HashBase(blockSize) {
    $9f771da68903a577$require$Transform.call(this);
    this._block = $9f771da68903a577$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$bniia($9f771da68903a577$var$HashBase, $9f771da68903a577$require$Transform);
$9f771da68903a577$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$9f771da68903a577$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $9f771da68903a577$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $9f771da68903a577$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($9f771da68903a577$require$Buffer.prototype instanceof Uint8Array || $9f771da68903a577$require$Buffer.TYPED_ARRAY_SUPPORT);
function $9f771da68903a577$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $9f771da68903a577$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $9f771da68903a577$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($9f771da68903a577$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $9f771da68903a577$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $9f771da68903a577$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($9f771da68903a577$var$useUint8Array && data instanceof Uint8Array) return $9f771da68903a577$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($9f771da68903a577$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $9f771da68903a577$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$9f771da68903a577$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $9f771da68903a577$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$9f771da68903a577$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$9f771da68903a577$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$9f771da68903a577$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $9f771da68903a577$var$HashBase;

});


parcelRegister("1JYNO", function(module, exports) {
'use strict';

var $8UsMN = parcelRequire("8UsMN");
var $144928824ab3c44a$require$Buffer = $8UsMN.Buffer;

var $bniia = parcelRequire("bniia");

var $km1qv = parcelRequire("km1qv");
var $144928824ab3c44a$var$ARRAY16 = new Array(16);
var $144928824ab3c44a$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $144928824ab3c44a$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $144928824ab3c44a$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $144928824ab3c44a$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $144928824ab3c44a$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $144928824ab3c44a$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $144928824ab3c44a$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $144928824ab3c44a$var$fn1(a, b, c, d, e, m, k, s) {
    return $144928824ab3c44a$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $144928824ab3c44a$var$fn2(a, b, c, d, e, m, k, s) {
    return $144928824ab3c44a$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $144928824ab3c44a$var$fn3(a, b, c, d, e, m, k, s) {
    return $144928824ab3c44a$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $144928824ab3c44a$var$fn4(a, b, c, d, e, m, k, s) {
    return $144928824ab3c44a$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $144928824ab3c44a$var$fn5(a, b, c, d, e, m, k, s) {
    return $144928824ab3c44a$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $144928824ab3c44a$var$RIPEMD160() {
    $km1qv.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$bniia($144928824ab3c44a$var$RIPEMD160, $km1qv);
$144928824ab3c44a$var$RIPEMD160.prototype._update = function() {
    var words = $144928824ab3c44a$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $144928824ab3c44a$var$fn1(al, bl, cl, dl, el, words[$144928824ab3c44a$var$zl[i]], $144928824ab3c44a$var$hl[0], $144928824ab3c44a$var$sl[i]);
            tr = $144928824ab3c44a$var$fn5(ar, br, cr, dr, er, words[$144928824ab3c44a$var$zr[i]], $144928824ab3c44a$var$hr[0], $144928824ab3c44a$var$sr[i]);
        } else if (i < 32) {
            tl = $144928824ab3c44a$var$fn2(al, bl, cl, dl, el, words[$144928824ab3c44a$var$zl[i]], $144928824ab3c44a$var$hl[1], $144928824ab3c44a$var$sl[i]);
            tr = $144928824ab3c44a$var$fn4(ar, br, cr, dr, er, words[$144928824ab3c44a$var$zr[i]], $144928824ab3c44a$var$hr[1], $144928824ab3c44a$var$sr[i]);
        } else if (i < 48) {
            tl = $144928824ab3c44a$var$fn3(al, bl, cl, dl, el, words[$144928824ab3c44a$var$zl[i]], $144928824ab3c44a$var$hl[2], $144928824ab3c44a$var$sl[i]);
            tr = $144928824ab3c44a$var$fn3(ar, br, cr, dr, er, words[$144928824ab3c44a$var$zr[i]], $144928824ab3c44a$var$hr[2], $144928824ab3c44a$var$sr[i]);
        } else if (i < 64) {
            tl = $144928824ab3c44a$var$fn4(al, bl, cl, dl, el, words[$144928824ab3c44a$var$zl[i]], $144928824ab3c44a$var$hl[3], $144928824ab3c44a$var$sl[i]);
            tr = $144928824ab3c44a$var$fn2(ar, br, cr, dr, er, words[$144928824ab3c44a$var$zr[i]], $144928824ab3c44a$var$hr[3], $144928824ab3c44a$var$sr[i]);
        } else {
            tl = $144928824ab3c44a$var$fn5(al, bl, cl, dl, el, words[$144928824ab3c44a$var$zl[i]], $144928824ab3c44a$var$hl[4], $144928824ab3c44a$var$sl[i]);
            tr = $144928824ab3c44a$var$fn1(ar, br, cr, dr, er, words[$144928824ab3c44a$var$zr[i]], $144928824ab3c44a$var$hr[4], $144928824ab3c44a$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $144928824ab3c44a$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $144928824ab3c44a$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$144928824ab3c44a$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $144928824ab3c44a$require$Buffer.alloc ? $144928824ab3c44a$require$Buffer.alloc(20) : new $144928824ab3c44a$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $144928824ab3c44a$var$RIPEMD160;

});
parcelRegister("km1qv", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $ed16f7fa46884697$require$Buffer = $4OiF0.Buffer;

var $fmceT = parcelRequire("fmceT");

var $95soA = parcelRequire("95soA");
var $ed16f7fa46884697$require$Transform = $95soA.Transform;

var $bniia = parcelRequire("bniia");
function $ed16f7fa46884697$var$HashBase(blockSize) {
    $ed16f7fa46884697$require$Transform.call(this);
    this._block = $ed16f7fa46884697$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$bniia($ed16f7fa46884697$var$HashBase, $ed16f7fa46884697$require$Transform);
$ed16f7fa46884697$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ed16f7fa46884697$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ed16f7fa46884697$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $fmceT(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$ed16f7fa46884697$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$ed16f7fa46884697$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$ed16f7fa46884697$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $ed16f7fa46884697$var$HashBase;

});
parcelRegister("fmceT", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $b2e2678af36415e9$require$Buffer = $4OiF0.Buffer;

var $3xZbU = parcelRequire("3xZbU");
var $b2e2678af36415e9$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $b2e2678af36415e9$var$useArrayBuffer = $b2e2678af36415e9$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $b2e2678af36415e9$var$isView = $b2e2678af36415e9$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $b2e2678af36415e9$require$Buffer.isBuffer(thing) || $b2e2678af36415e9$var$useUint8Array && thing instanceof Uint8Array || $b2e2678af36415e9$var$isView && $b2e2678af36415e9$var$isView(thing)) return $3xZbU(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("3xZbU", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $2953eb768fccbf5c$require$Buffer = $4OiF0.Buffer;

var $8IJyL = parcelRequire("8IJyL");

var $63Eo9 = parcelRequire("63Eo9");
var $2953eb768fccbf5c$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $63Eo9(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $2953eb768fccbf5c$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $2953eb768fccbf5c$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $2953eb768fccbf5c$var$useFromArrayBuffer = $2953eb768fccbf5c$var$useArrayBuffer && ($2953eb768fccbf5c$require$Buffer.prototype instanceof Uint8Array || $2953eb768fccbf5c$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($2953eb768fccbf5c$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $2953eb768fccbf5c$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $2953eb768fccbf5c$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($2953eb768fccbf5c$var$useArrayBuffer && $2953eb768fccbf5c$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $2953eb768fccbf5c$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($2953eb768fccbf5c$var$useFromArrayBuffer) {
            var res = $2953eb768fccbf5c$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $2953eb768fccbf5c$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($2953eb768fccbf5c$var$useUint8Array && data instanceof Uint8Array) return $2953eb768fccbf5c$require$Buffer.from(data);
    var isArr = $8IJyL(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $2953eb768fccbf5c$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $2953eb768fccbf5c$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("8IJyL", function(module, exports) {
var $6595c6022a944f07$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $6595c6022a944f07$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("63Eo9", function(module, exports) {
'use strict';

var $bd4Go = parcelRequire("bd4Go");

var $g81mU = parcelRequire("g81mU");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $46925a348c314edc$var$$typedArrayBuffer = $g81mU('TypedArray.prototype.buffer', true);

var $9J0fH = parcelRequire("9J0fH");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $46925a348c314edc$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$9J0fH(x)) throw new $bd4Go('Not a Typed Array');
    return x.buffer;
};

});



parcelRegister("95soA", function(module, exports) {

exports = module.exports = (parcelRequire("kNz6F"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("2Fm12"));

exports.Duplex = (parcelRequire("j8rHA"));

exports.Transform = (parcelRequire("8ICBy"));

exports.PassThrough = (parcelRequire("JwlC1"));

});
parcelRegister("kNz6F", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $ajwPf = parcelRequire("ajwPf");
'use strict';

var $8sl5C = parcelRequire("8sl5C");
/*</replacement>*/ module.exports = $f2439daf1c93bcf3$var$Readable;

var $bEGgk = parcelRequire("bEGgk");
/*</replacement>*/ /*<replacement>*/ var $f2439daf1c93bcf3$var$Duplex;
/*</replacement>*/ $f2439daf1c93bcf3$var$Readable.ReadableState = $f2439daf1c93bcf3$var$ReadableState;

var $fPnTa = parcelRequire("fPnTa");
var $f2439daf1c93bcf3$require$EE = $fPnTa.EventEmitter;
var $f2439daf1c93bcf3$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $9WBzb = parcelRequire("9WBzb");

var $7YBGB = parcelRequire("7YBGB");
var $f2439daf1c93bcf3$require$Buffer = $7YBGB.Buffer;
var $f2439daf1c93bcf3$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $f2439daf1c93bcf3$var$_uint8ArrayToBuffer(chunk) {
    return $f2439daf1c93bcf3$require$Buffer.from(chunk);
}
function $f2439daf1c93bcf3$var$_isUint8Array(obj) {
    return $f2439daf1c93bcf3$require$Buffer.isBuffer(obj) || obj instanceof $f2439daf1c93bcf3$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $f2439daf1c93bcf3$var$util = Object.create((parcelRequire("7fIzB")));

$f2439daf1c93bcf3$var$util.inherits = (parcelRequire("bniia"));

var $66yC2 = parcelRequire("66yC2");
var $f2439daf1c93bcf3$var$debug = void 0;
if ($66yC2 && $66yC2.debuglog) $f2439daf1c93bcf3$var$debug = $66yC2.debuglog('stream');
else $f2439daf1c93bcf3$var$debug = function() {};

var $2BYFf = parcelRequire("2BYFf");

var $gaKSA = parcelRequire("gaKSA");
var $f2439daf1c93bcf3$var$StringDecoder;
$f2439daf1c93bcf3$var$util.inherits($f2439daf1c93bcf3$var$Readable, $9WBzb);
var $f2439daf1c93bcf3$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $f2439daf1c93bcf3$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($bEGgk(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $f2439daf1c93bcf3$var$ReadableState(options, stream) {
    $f2439daf1c93bcf3$var$Duplex = $f2439daf1c93bcf3$var$Duplex || (parcelRequire("j8rHA"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $f2439daf1c93bcf3$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $2BYFf();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$f2439daf1c93bcf3$var$StringDecoder) $f2439daf1c93bcf3$var$StringDecoder = (parcelRequire("6wL34")).StringDecoder;
        this.decoder = new $f2439daf1c93bcf3$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $f2439daf1c93bcf3$var$Readable(options) {
    $f2439daf1c93bcf3$var$Duplex = $f2439daf1c93bcf3$var$Duplex || (parcelRequire("j8rHA"));
    if (!(this instanceof $f2439daf1c93bcf3$var$Readable)) return new $f2439daf1c93bcf3$var$Readable(options);
    this._readableState = new $f2439daf1c93bcf3$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $9WBzb.call(this);
}
Object.defineProperty($f2439daf1c93bcf3$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$f2439daf1c93bcf3$var$Readable.prototype.destroy = $gaKSA.destroy;
$f2439daf1c93bcf3$var$Readable.prototype._undestroy = $gaKSA.undestroy;
$f2439daf1c93bcf3$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$f2439daf1c93bcf3$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $f2439daf1c93bcf3$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $f2439daf1c93bcf3$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$f2439daf1c93bcf3$var$Readable.prototype.unshift = function(chunk) {
    return $f2439daf1c93bcf3$var$readableAddChunk(this, chunk, null, true, false);
};
function $f2439daf1c93bcf3$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $f2439daf1c93bcf3$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $f2439daf1c93bcf3$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $f2439daf1c93bcf3$require$Buffer.prototype) chunk = $f2439daf1c93bcf3$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $f2439daf1c93bcf3$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $f2439daf1c93bcf3$var$addChunk(stream, state, chunk, false);
                    else $f2439daf1c93bcf3$var$maybeReadMore(stream, state);
                } else $f2439daf1c93bcf3$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $f2439daf1c93bcf3$var$needMoreData(state);
}
function $f2439daf1c93bcf3$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $f2439daf1c93bcf3$var$emitReadable(stream);
    }
    $f2439daf1c93bcf3$var$maybeReadMore(stream, state);
}
function $f2439daf1c93bcf3$var$chunkInvalid(state, chunk) {
    var er;
    if (!$f2439daf1c93bcf3$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $f2439daf1c93bcf3$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$f2439daf1c93bcf3$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$f2439daf1c93bcf3$var$Readable.prototype.setEncoding = function(enc) {
    if (!$f2439daf1c93bcf3$var$StringDecoder) $f2439daf1c93bcf3$var$StringDecoder = (parcelRequire("6wL34")).StringDecoder;
    this._readableState.decoder = new $f2439daf1c93bcf3$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $f2439daf1c93bcf3$var$MAX_HWM = 0x800000;
function $f2439daf1c93bcf3$var$computeNewHighWaterMark(n) {
    if (n >= $f2439daf1c93bcf3$var$MAX_HWM) n = $f2439daf1c93bcf3$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f2439daf1c93bcf3$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $f2439daf1c93bcf3$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$f2439daf1c93bcf3$var$Readable.prototype.read = function(n) {
    $f2439daf1c93bcf3$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $f2439daf1c93bcf3$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $f2439daf1c93bcf3$var$endReadable(this);
        else $f2439daf1c93bcf3$var$emitReadable(this);
        return null;
    }
    n = $f2439daf1c93bcf3$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $f2439daf1c93bcf3$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $f2439daf1c93bcf3$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $f2439daf1c93bcf3$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $f2439daf1c93bcf3$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $f2439daf1c93bcf3$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $f2439daf1c93bcf3$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $f2439daf1c93bcf3$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $f2439daf1c93bcf3$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $f2439daf1c93bcf3$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $f2439daf1c93bcf3$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $f2439daf1c93bcf3$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $f2439daf1c93bcf3$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $8sl5C.nextTick($f2439daf1c93bcf3$var$emitReadable_, stream);
        else $f2439daf1c93bcf3$var$emitReadable_(stream);
    }
}
function $f2439daf1c93bcf3$var$emitReadable_(stream) {
    $f2439daf1c93bcf3$var$debug('emit readable');
    stream.emit('readable');
    $f2439daf1c93bcf3$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $f2439daf1c93bcf3$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $8sl5C.nextTick($f2439daf1c93bcf3$var$maybeReadMore_, stream, state);
    }
}
function $f2439daf1c93bcf3$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $f2439daf1c93bcf3$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$f2439daf1c93bcf3$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$f2439daf1c93bcf3$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $f2439daf1c93bcf3$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $ajwPf.stdout && dest !== $ajwPf.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $8sl5C.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $f2439daf1c93bcf3$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $f2439daf1c93bcf3$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $f2439daf1c93bcf3$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $f2439daf1c93bcf3$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $f2439daf1c93bcf3$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $f2439daf1c93bcf3$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $f2439daf1c93bcf3$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $f2439daf1c93bcf3$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($f2439daf1c93bcf3$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $f2439daf1c93bcf3$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $f2439daf1c93bcf3$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $f2439daf1c93bcf3$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $f2439daf1c93bcf3$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $f2439daf1c93bcf3$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $f2439daf1c93bcf3$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $f2439daf1c93bcf3$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $f2439daf1c93bcf3$var$flow(src);
        }
    };
}
$f2439daf1c93bcf3$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $f2439daf1c93bcf3$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$f2439daf1c93bcf3$var$Readable.prototype.on = function(ev, fn) {
    var res = $9WBzb.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $8sl5C.nextTick($f2439daf1c93bcf3$var$nReadingNextTick, this);
            else if (state.length) $f2439daf1c93bcf3$var$emitReadable(this);
        }
    }
    return res;
};
$f2439daf1c93bcf3$var$Readable.prototype.addListener = $f2439daf1c93bcf3$var$Readable.prototype.on;
function $f2439daf1c93bcf3$var$nReadingNextTick(self1) {
    $f2439daf1c93bcf3$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$f2439daf1c93bcf3$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $f2439daf1c93bcf3$var$debug('resume');
        state.flowing = true;
        $f2439daf1c93bcf3$var$resume(this, state);
    }
    return this;
};
function $f2439daf1c93bcf3$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $8sl5C.nextTick($f2439daf1c93bcf3$var$resume_, stream, state);
    }
}
function $f2439daf1c93bcf3$var$resume_(stream, state) {
    if (!state.reading) {
        $f2439daf1c93bcf3$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $f2439daf1c93bcf3$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$f2439daf1c93bcf3$var$Readable.prototype.pause = function() {
    $f2439daf1c93bcf3$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $f2439daf1c93bcf3$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $f2439daf1c93bcf3$var$flow(stream) {
    var state = stream._readableState;
    $f2439daf1c93bcf3$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$f2439daf1c93bcf3$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $f2439daf1c93bcf3$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $f2439daf1c93bcf3$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $f2439daf1c93bcf3$var$kProxyEvents.length; n++)stream.on($f2439daf1c93bcf3$var$kProxyEvents[n], this.emit.bind(this, $f2439daf1c93bcf3$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $f2439daf1c93bcf3$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($f2439daf1c93bcf3$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$f2439daf1c93bcf3$var$Readable._fromList = $f2439daf1c93bcf3$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f2439daf1c93bcf3$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $f2439daf1c93bcf3$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f2439daf1c93bcf3$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $f2439daf1c93bcf3$var$copyFromBufferString(n, list) : $f2439daf1c93bcf3$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f2439daf1c93bcf3$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $f2439daf1c93bcf3$var$copyFromBuffer(n, list) {
    var ret = $f2439daf1c93bcf3$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $f2439daf1c93bcf3$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $8sl5C.nextTick($f2439daf1c93bcf3$var$endReadableNT, state, stream);
    }
}
function $f2439daf1c93bcf3$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $f2439daf1c93bcf3$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("8sl5C", function(module, exports) {

var $ajwPf = parcelRequire("ajwPf");
'use strict';
module.exports = {
    nextTick: $62814c3c3d5fe42c$var$nextTick
};
function $62814c3c3d5fe42c$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $ajwPf.nextTick(fn);
        case 2:
            return $ajwPf.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $ajwPf.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $ajwPf.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $ajwPf.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("bEGgk", function(module, exports) {
var $87c4368eb5367bbf$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $87c4368eb5367bbf$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("9WBzb", function(module, exports) {

module.exports = (parcelRequire("fPnTa")).EventEmitter;

});

parcelRegister("7YBGB", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $8UsMN = parcelRequire("8UsMN");
var $5ceb5eb2b1a390ea$var$Buffer = $8UsMN.Buffer;
// alternative to using Object.keys for old browsers
function $5ceb5eb2b1a390ea$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($5ceb5eb2b1a390ea$var$Buffer.from && $5ceb5eb2b1a390ea$var$Buffer.alloc && $5ceb5eb2b1a390ea$var$Buffer.allocUnsafe && $5ceb5eb2b1a390ea$var$Buffer.allocUnsafeSlow) module.exports = $8UsMN;
else {
    // Copy properties from require('buffer')
    $5ceb5eb2b1a390ea$var$copyProps($8UsMN, module.exports);
    module.exports.Buffer = $5ceb5eb2b1a390ea$var$SafeBuffer;
}
function $5ceb5eb2b1a390ea$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $5ceb5eb2b1a390ea$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$5ceb5eb2b1a390ea$var$copyProps($5ceb5eb2b1a390ea$var$Buffer, $5ceb5eb2b1a390ea$var$SafeBuffer);
$5ceb5eb2b1a390ea$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $5ceb5eb2b1a390ea$var$Buffer(arg, encodingOrOffset, length);
};
$5ceb5eb2b1a390ea$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $5ceb5eb2b1a390ea$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$5ceb5eb2b1a390ea$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5ceb5eb2b1a390ea$var$Buffer(size);
};
$5ceb5eb2b1a390ea$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $8UsMN.SlowBuffer(size);
};

});

parcelRegister("7fIzB", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $547c826f9b92c565$export$43bee75e5e14138e, (v) => $547c826f9b92c565$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $547c826f9b92c565$export$f9ce7b637dfbe238, (v) => $547c826f9b92c565$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $547c826f9b92c565$export$630801d484da15df, (v) => $547c826f9b92c565$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $547c826f9b92c565$export$bedb7023a7733221, (v) => $547c826f9b92c565$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $547c826f9b92c565$export$7e4aa119212bc614, (v) => $547c826f9b92c565$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $547c826f9b92c565$export$844ec244b1367d54, (v) => $547c826f9b92c565$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $547c826f9b92c565$export$a244864fd9645c7f, (v) => $547c826f9b92c565$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $547c826f9b92c565$export$fce6876652108ab, (v) => $547c826f9b92c565$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $547c826f9b92c565$export$49841c62b9eff15, (v) => $547c826f9b92c565$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $547c826f9b92c565$export$a6cdc56e425d0d0a, (v) => $547c826f9b92c565$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $547c826f9b92c565$export$871608497c498473, (v) => $547c826f9b92c565$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $547c826f9b92c565$export$e6127cc7fe7395c3, (v) => $547c826f9b92c565$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $547c826f9b92c565$export$f6e2535fb5126e54, (v) => $547c826f9b92c565$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $547c826f9b92c565$export$c3825b437cbdea5c, (v) => $547c826f9b92c565$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $547c826f9b92c565$export$a7884ebc965f8f54, (v) => $547c826f9b92c565$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $547c826f9b92c565$export$43bee75e5e14138e;
var $547c826f9b92c565$export$f9ce7b637dfbe238;
var $547c826f9b92c565$export$630801d484da15df;
var $547c826f9b92c565$export$bedb7023a7733221;
var $547c826f9b92c565$export$7e4aa119212bc614;
var $547c826f9b92c565$export$844ec244b1367d54;
var $547c826f9b92c565$export$a244864fd9645c7f;
var $547c826f9b92c565$export$fce6876652108ab;
var $547c826f9b92c565$export$49841c62b9eff15;
var $547c826f9b92c565$export$a6cdc56e425d0d0a;
var $547c826f9b92c565$export$871608497c498473;
var $547c826f9b92c565$export$e6127cc7fe7395c3;
var $547c826f9b92c565$export$f6e2535fb5126e54;
var $547c826f9b92c565$export$c3825b437cbdea5c;
var $547c826f9b92c565$export$a7884ebc965f8f54;
function $547c826f9b92c565$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $547c826f9b92c565$var$objectToString(arg) === '[object Array]';
}
$547c826f9b92c565$export$43bee75e5e14138e = $547c826f9b92c565$var$isArray;
function $547c826f9b92c565$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$547c826f9b92c565$export$f9ce7b637dfbe238 = $547c826f9b92c565$var$isBoolean;
function $547c826f9b92c565$var$isNull(arg) {
    return arg === null;
}
$547c826f9b92c565$export$630801d484da15df = $547c826f9b92c565$var$isNull;
function $547c826f9b92c565$var$isNullOrUndefined(arg) {
    return arg == null;
}
$547c826f9b92c565$export$bedb7023a7733221 = $547c826f9b92c565$var$isNullOrUndefined;
function $547c826f9b92c565$var$isNumber(arg) {
    return typeof arg === 'number';
}
$547c826f9b92c565$export$7e4aa119212bc614 = $547c826f9b92c565$var$isNumber;
function $547c826f9b92c565$var$isString(arg) {
    return typeof arg === 'string';
}
$547c826f9b92c565$export$844ec244b1367d54 = $547c826f9b92c565$var$isString;
function $547c826f9b92c565$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$547c826f9b92c565$export$a244864fd9645c7f = $547c826f9b92c565$var$isSymbol;
function $547c826f9b92c565$var$isUndefined(arg) {
    return arg === void 0;
}
$547c826f9b92c565$export$fce6876652108ab = $547c826f9b92c565$var$isUndefined;
function $547c826f9b92c565$var$isRegExp(re) {
    return $547c826f9b92c565$var$objectToString(re) === '[object RegExp]';
}
$547c826f9b92c565$export$49841c62b9eff15 = $547c826f9b92c565$var$isRegExp;
function $547c826f9b92c565$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$547c826f9b92c565$export$a6cdc56e425d0d0a = $547c826f9b92c565$var$isObject;
function $547c826f9b92c565$var$isDate(d) {
    return $547c826f9b92c565$var$objectToString(d) === '[object Date]';
}
$547c826f9b92c565$export$871608497c498473 = $547c826f9b92c565$var$isDate;
function $547c826f9b92c565$var$isError(e) {
    return $547c826f9b92c565$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$547c826f9b92c565$export$e6127cc7fe7395c3 = $547c826f9b92c565$var$isError;
function $547c826f9b92c565$var$isFunction(arg) {
    return typeof arg === 'function';
}
$547c826f9b92c565$export$f6e2535fb5126e54 = $547c826f9b92c565$var$isFunction;
function $547c826f9b92c565$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$547c826f9b92c565$export$c3825b437cbdea5c = $547c826f9b92c565$var$isPrimitive;

$547c826f9b92c565$export$a7884ebc965f8f54 = (parcelRequire("8UsMN")).Buffer.isBuffer;
function $547c826f9b92c565$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("2BYFf", function(module, exports) {
'use strict';
function $1e6e182221942bf9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $7YBGB = parcelRequire("7YBGB");
var $1e6e182221942bf9$require$Buffer = $7YBGB.Buffer;

var $66yC2 = parcelRequire("66yC2");
function $1e6e182221942bf9$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $1e6e182221942bf9$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $1e6e182221942bf9$require$Buffer.alloc(0);
        var ret = $1e6e182221942bf9$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $1e6e182221942bf9$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($66yC2 && $66yC2.inspect && $66yC2.inspect.custom) module.exports.prototype[$66yC2.inspect.custom] = function() {
    var obj = $66yC2.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("gaKSA", function(module, exports) {
'use strict';

var $8sl5C = parcelRequire("8sl5C");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $bc61f1cbb22c5cbb$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $8sl5C.nextTick($bc61f1cbb22c5cbb$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $8sl5C.nextTick($bc61f1cbb22c5cbb$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $8sl5C.nextTick($bc61f1cbb22c5cbb$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $8sl5C.nextTick($bc61f1cbb22c5cbb$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $bc61f1cbb22c5cbb$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $bc61f1cbb22c5cbb$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $bc61f1cbb22c5cbb$var$destroy,
    undestroy: $bc61f1cbb22c5cbb$var$undestroy
};

});

parcelRegister("j8rHA", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $8sl5C = parcelRequire("8sl5C");
/*</replacement>*/ /*<replacement>*/ var $dee440bb4c2eca4a$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $dee440bb4c2eca4a$var$Duplex;

/*<replacement>*/ var $dee440bb4c2eca4a$var$util = Object.create((parcelRequire("7fIzB")));

$dee440bb4c2eca4a$var$util.inherits = (parcelRequire("bniia"));

var $kNz6F = parcelRequire("kNz6F");

var $2Fm12 = parcelRequire("2Fm12");
$dee440bb4c2eca4a$var$util.inherits($dee440bb4c2eca4a$var$Duplex, $kNz6F);
// avoid scope creep, the keys array can then be collected
var $dee440bb4c2eca4a$var$keys = $dee440bb4c2eca4a$var$objectKeys($2Fm12.prototype);
for(var $dee440bb4c2eca4a$var$v = 0; $dee440bb4c2eca4a$var$v < $dee440bb4c2eca4a$var$keys.length; $dee440bb4c2eca4a$var$v++){
    var $dee440bb4c2eca4a$var$method = $dee440bb4c2eca4a$var$keys[$dee440bb4c2eca4a$var$v];
    if (!$dee440bb4c2eca4a$var$Duplex.prototype[$dee440bb4c2eca4a$var$method]) $dee440bb4c2eca4a$var$Duplex.prototype[$dee440bb4c2eca4a$var$method] = $2Fm12.prototype[$dee440bb4c2eca4a$var$method];
}
function $dee440bb4c2eca4a$var$Duplex(options) {
    if (!(this instanceof $dee440bb4c2eca4a$var$Duplex)) return new $dee440bb4c2eca4a$var$Duplex(options);
    $kNz6F.call(this, options);
    $2Fm12.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $dee440bb4c2eca4a$var$onend);
}
Object.defineProperty($dee440bb4c2eca4a$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $dee440bb4c2eca4a$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $8sl5C.nextTick($dee440bb4c2eca4a$var$onEndNT, this);
}
function $dee440bb4c2eca4a$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($dee440bb4c2eca4a$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$dee440bb4c2eca4a$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $8sl5C.nextTick(cb, err);
};

});
parcelRegister("2Fm12", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $8sl5C = parcelRequire("8sl5C");
/*</replacement>*/ module.exports = $1f107cfaa32108de$var$Writable;
/* <replacement> */ function $1f107cfaa32108de$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $1f107cfaa32108de$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $1f107cfaa32108de$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $1f107cfaa32108de$var$asyncWrite = (0, $8sl5C.nextTick);
/*</replacement>*/ /*<replacement>*/ var $1f107cfaa32108de$var$Duplex;
/*</replacement>*/ $1f107cfaa32108de$var$Writable.WritableState = $1f107cfaa32108de$var$WritableState;

/*<replacement>*/ var $1f107cfaa32108de$var$util = Object.create((parcelRequire("7fIzB")));

$1f107cfaa32108de$var$util.inherits = (parcelRequire("bniia"));

/*</replacement>*/ /*<replacement>*/ var $1f107cfaa32108de$var$internalUtil = {
    deprecate: (parcelRequire("f2W2v"))
};

var $9WBzb = parcelRequire("9WBzb");

var $7YBGB = parcelRequire("7YBGB");
var $1f107cfaa32108de$require$Buffer = $7YBGB.Buffer;
var $1f107cfaa32108de$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $1f107cfaa32108de$var$_uint8ArrayToBuffer(chunk) {
    return $1f107cfaa32108de$require$Buffer.from(chunk);
}
function $1f107cfaa32108de$var$_isUint8Array(obj) {
    return $1f107cfaa32108de$require$Buffer.isBuffer(obj) || obj instanceof $1f107cfaa32108de$var$OurUint8Array;
}

var $gaKSA = parcelRequire("gaKSA");
$1f107cfaa32108de$var$util.inherits($1f107cfaa32108de$var$Writable, $9WBzb);
function $1f107cfaa32108de$var$nop() {}

function $1f107cfaa32108de$var$WritableState(options, stream) {
    $1f107cfaa32108de$var$Duplex = $1f107cfaa32108de$var$Duplex || (parcelRequire("j8rHA"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $1f107cfaa32108de$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $1f107cfaa32108de$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $1f107cfaa32108de$var$CorkedRequest(this);
}
$1f107cfaa32108de$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($1f107cfaa32108de$var$WritableState.prototype, 'buffer', {
            get: $1f107cfaa32108de$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $1f107cfaa32108de$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $1f107cfaa32108de$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($1f107cfaa32108de$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($1f107cfaa32108de$var$realHasInstance.call(this, object)) return true;
            if (this !== $1f107cfaa32108de$var$Writable) return false;
            return object && object._writableState instanceof $1f107cfaa32108de$var$WritableState;
        }
    });
} else $1f107cfaa32108de$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $1f107cfaa32108de$var$Writable(options) {
    $1f107cfaa32108de$var$Duplex = $1f107cfaa32108de$var$Duplex || (parcelRequire("j8rHA"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$1f107cfaa32108de$var$realHasInstance.call($1f107cfaa32108de$var$Writable, this) && !(this instanceof $1f107cfaa32108de$var$Duplex)) return new $1f107cfaa32108de$var$Writable(options);
    this._writableState = new $1f107cfaa32108de$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $9WBzb.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$1f107cfaa32108de$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $1f107cfaa32108de$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $8sl5C.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $1f107cfaa32108de$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $8sl5C.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$1f107cfaa32108de$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $1f107cfaa32108de$var$_isUint8Array(chunk);
    if (isBuf && !$1f107cfaa32108de$require$Buffer.isBuffer(chunk)) chunk = $1f107cfaa32108de$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $1f107cfaa32108de$var$nop;
    if (state.ended) $1f107cfaa32108de$var$writeAfterEnd(this, cb);
    else if (isBuf || $1f107cfaa32108de$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $1f107cfaa32108de$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$1f107cfaa32108de$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$1f107cfaa32108de$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1f107cfaa32108de$var$clearBuffer(this, state);
    }
};
$1f107cfaa32108de$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $1f107cfaa32108de$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $1f107cfaa32108de$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($1f107cfaa32108de$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1f107cfaa32108de$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $1f107cfaa32108de$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $1f107cfaa32108de$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $1f107cfaa32108de$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1f107cfaa32108de$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $8sl5C.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $8sl5C.nextTick($1f107cfaa32108de$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $1f107cfaa32108de$var$finishMaybe(stream, state);
    }
}
function $1f107cfaa32108de$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $1f107cfaa32108de$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $1f107cfaa32108de$var$onwriteStateUpdate(state);
    if (er) $1f107cfaa32108de$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $1f107cfaa32108de$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1f107cfaa32108de$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $1f107cfaa32108de$var$asyncWrite($1f107cfaa32108de$var$afterWrite, stream, state, finished, cb);
        else $1f107cfaa32108de$var$afterWrite(stream, state, finished, cb);
    }
}
function $1f107cfaa32108de$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $1f107cfaa32108de$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $1f107cfaa32108de$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $1f107cfaa32108de$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $1f107cfaa32108de$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $1f107cfaa32108de$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $1f107cfaa32108de$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $1f107cfaa32108de$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$1f107cfaa32108de$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$1f107cfaa32108de$var$Writable.prototype._writev = null;
$1f107cfaa32108de$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $1f107cfaa32108de$var$endWritable(this, state, cb);
};
function $1f107cfaa32108de$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $1f107cfaa32108de$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $1f107cfaa32108de$var$finishMaybe(stream, state);
    });
}
function $1f107cfaa32108de$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $8sl5C.nextTick($1f107cfaa32108de$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1f107cfaa32108de$var$finishMaybe(stream, state) {
    var need = $1f107cfaa32108de$var$needFinish(state);
    if (need) {
        $1f107cfaa32108de$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $1f107cfaa32108de$var$endWritable(stream, state, cb) {
    state.ending = true;
    $1f107cfaa32108de$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $8sl5C.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $1f107cfaa32108de$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($1f107cfaa32108de$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$1f107cfaa32108de$var$Writable.prototype.destroy = $gaKSA.destroy;
$1f107cfaa32108de$var$Writable.prototype._undestroy = $gaKSA.undestroy;
$1f107cfaa32108de$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("6wL34", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $4c0a3a1b5b92c467$export$63a7aa211a91ed69, (v) => $4c0a3a1b5b92c467$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $4c0a3a1b5b92c467$export$63a7aa211a91ed69;
'use strict';

var $7YBGB = parcelRequire("7YBGB");
var $4c0a3a1b5b92c467$require$Buffer = $7YBGB.Buffer;
/*</replacement>*/ var $4c0a3a1b5b92c467$var$isEncoding = $4c0a3a1b5b92c467$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $4c0a3a1b5b92c467$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $4c0a3a1b5b92c467$var$normalizeEncoding(enc) {
    var nenc = $4c0a3a1b5b92c467$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($4c0a3a1b5b92c467$require$Buffer.isEncoding === $4c0a3a1b5b92c467$var$isEncoding || !$4c0a3a1b5b92c467$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$4c0a3a1b5b92c467$export$63a7aa211a91ed69 = $4c0a3a1b5b92c467$var$StringDecoder;
function $4c0a3a1b5b92c467$var$StringDecoder(encoding) {
    this.encoding = $4c0a3a1b5b92c467$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $4c0a3a1b5b92c467$var$utf16Text;
            this.end = $4c0a3a1b5b92c467$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $4c0a3a1b5b92c467$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $4c0a3a1b5b92c467$var$base64Text;
            this.end = $4c0a3a1b5b92c467$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $4c0a3a1b5b92c467$var$simpleWrite;
            this.end = $4c0a3a1b5b92c467$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $4c0a3a1b5b92c467$require$Buffer.allocUnsafe(nb);
}
$4c0a3a1b5b92c467$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$4c0a3a1b5b92c467$var$StringDecoder.prototype.end = $4c0a3a1b5b92c467$var$utf8End;
// Returns only complete characters in a Buffer
$4c0a3a1b5b92c467$var$StringDecoder.prototype.text = $4c0a3a1b5b92c467$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$4c0a3a1b5b92c467$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $4c0a3a1b5b92c467$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $4c0a3a1b5b92c467$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $4c0a3a1b5b92c467$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $4c0a3a1b5b92c467$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $4c0a3a1b5b92c467$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $4c0a3a1b5b92c467$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $4c0a3a1b5b92c467$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $4c0a3a1b5b92c467$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $4c0a3a1b5b92c467$var$utf8Text(buf, i) {
    var total = $4c0a3a1b5b92c467$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $4c0a3a1b5b92c467$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $4c0a3a1b5b92c467$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $4c0a3a1b5b92c467$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $4c0a3a1b5b92c467$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $4c0a3a1b5b92c467$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $4c0a3a1b5b92c467$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $4c0a3a1b5b92c467$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("8ICBy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $659060e259ba68c2$var$Transform;

var $j8rHA = parcelRequire("j8rHA");

/*<replacement>*/ var $659060e259ba68c2$var$util = Object.create((parcelRequire("7fIzB")));

$659060e259ba68c2$var$util.inherits = (parcelRequire("bniia"));
/*</replacement>*/ $659060e259ba68c2$var$util.inherits($659060e259ba68c2$var$Transform, $j8rHA);
function $659060e259ba68c2$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $659060e259ba68c2$var$Transform(options) {
    if (!(this instanceof $659060e259ba68c2$var$Transform)) return new $659060e259ba68c2$var$Transform(options);
    $j8rHA.call(this, options);
    this._transformState = {
        afterTransform: $659060e259ba68c2$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $659060e259ba68c2$var$prefinish);
}
function $659060e259ba68c2$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $659060e259ba68c2$var$done(_this, er, data);
    });
    else $659060e259ba68c2$var$done(this, null, null);
}
$659060e259ba68c2$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $j8rHA.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$659060e259ba68c2$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$659060e259ba68c2$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$659060e259ba68c2$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$659060e259ba68c2$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $j8rHA.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $659060e259ba68c2$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("JwlC1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $088d4ba3e188b551$var$PassThrough;

var $8ICBy = parcelRequire("8ICBy");

/*<replacement>*/ var $088d4ba3e188b551$var$util = Object.create((parcelRequire("7fIzB")));

$088d4ba3e188b551$var$util.inherits = (parcelRequire("bniia"));
/*</replacement>*/ $088d4ba3e188b551$var$util.inherits($088d4ba3e188b551$var$PassThrough, $8ICBy);
function $088d4ba3e188b551$var$PassThrough(options) {
    if (!(this instanceof $088d4ba3e188b551$var$PassThrough)) return new $088d4ba3e188b551$var$PassThrough(options);
    $8ICBy.call(this, options);
}
$088d4ba3e188b551$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("1eplY", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("fLSEz"));

module.exports.sha1 = (parcelRequire("clQEv"));

module.exports.sha224 = (parcelRequire("61gwW"));

module.exports.sha256 = (parcelRequire("e1mvm"));

module.exports.sha384 = (parcelRequire("fg4RU"));

module.exports.sha512 = (parcelRequire("g9xkA"));

});
parcelRegister("fLSEz", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $d9hQa = parcelRequire("d9hQa");

var $4OiF0 = parcelRequire("4OiF0");
var $b7b5a3cfb2063a60$require$Buffer = $4OiF0.Buffer;
var $b7b5a3cfb2063a60$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $b7b5a3cfb2063a60$var$W = new Array(80);
function $b7b5a3cfb2063a60$var$Sha() {
    this.init();
    this._w = $b7b5a3cfb2063a60$var$W;
    $d9hQa.call(this, 64, 56);
}
$bniia($b7b5a3cfb2063a60$var$Sha, $d9hQa);
$b7b5a3cfb2063a60$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $b7b5a3cfb2063a60$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $b7b5a3cfb2063a60$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $b7b5a3cfb2063a60$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$b7b5a3cfb2063a60$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $b7b5a3cfb2063a60$var$rotl5(a) + $b7b5a3cfb2063a60$var$ft(s, b, c, d) + e + w[j] + $b7b5a3cfb2063a60$var$K[s] | 0;
        e = d;
        d = c;
        c = $b7b5a3cfb2063a60$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$b7b5a3cfb2063a60$var$Sha.prototype._hash = function() {
    var H = $b7b5a3cfb2063a60$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $b7b5a3cfb2063a60$var$Sha;

});
parcelRegister("d9hQa", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $9929f45da2ace5b8$require$Buffer = $4OiF0.Buffer;

var $3xZbU = parcelRequire("3xZbU");
// prototype class for hash functions
function $9929f45da2ace5b8$var$Hash(blockSize, finalSize) {
    this._block = $9929f45da2ace5b8$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$9929f45da2ace5b8$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $3xZbU(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$9929f45da2ace5b8$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$9929f45da2ace5b8$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $9929f45da2ace5b8$var$Hash;

});


parcelRegister("clQEv", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $d9hQa = parcelRequire("d9hQa");

var $4OiF0 = parcelRequire("4OiF0");
var $8fe049d6d1f42de8$require$Buffer = $4OiF0.Buffer;
var $8fe049d6d1f42de8$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $8fe049d6d1f42de8$var$W = new Array(80);
function $8fe049d6d1f42de8$var$Sha1() {
    this.init();
    this._w = $8fe049d6d1f42de8$var$W;
    $d9hQa.call(this, 64, 56);
}
$bniia($8fe049d6d1f42de8$var$Sha1, $d9hQa);
$8fe049d6d1f42de8$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $8fe049d6d1f42de8$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $8fe049d6d1f42de8$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $8fe049d6d1f42de8$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $8fe049d6d1f42de8$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$8fe049d6d1f42de8$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $8fe049d6d1f42de8$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $8fe049d6d1f42de8$var$rotl5(a) + $8fe049d6d1f42de8$var$ft(s, b, c, d) + e + w[j] + $8fe049d6d1f42de8$var$K[s] | 0;
        e = d;
        d = c;
        c = $8fe049d6d1f42de8$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$8fe049d6d1f42de8$var$Sha1.prototype._hash = function() {
    var H = $8fe049d6d1f42de8$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $8fe049d6d1f42de8$var$Sha1;

});

parcelRegister("61gwW", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $e1mvm = parcelRequire("e1mvm");

var $d9hQa = parcelRequire("d9hQa");

var $4OiF0 = parcelRequire("4OiF0");
var $461fa8abc8273a9f$require$Buffer = $4OiF0.Buffer;
var $461fa8abc8273a9f$var$W = new Array(64);
function $461fa8abc8273a9f$var$Sha224() {
    this.init();
    this._w = $461fa8abc8273a9f$var$W; // new Array(64)
    $d9hQa.call(this, 64, 56);
}
$bniia($461fa8abc8273a9f$var$Sha224, $e1mvm);
$461fa8abc8273a9f$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$461fa8abc8273a9f$var$Sha224.prototype._hash = function() {
    var H = $461fa8abc8273a9f$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $461fa8abc8273a9f$var$Sha224;

});
parcelRegister("e1mvm", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $d9hQa = parcelRequire("d9hQa");

var $4OiF0 = parcelRequire("4OiF0");
var $a3529daac5299a75$require$Buffer = $4OiF0.Buffer;
var $a3529daac5299a75$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $a3529daac5299a75$var$W = new Array(64);
function $a3529daac5299a75$var$Sha256() {
    this.init();
    this._w = $a3529daac5299a75$var$W; // new Array(64)
    $d9hQa.call(this, 64, 56);
}
$bniia($a3529daac5299a75$var$Sha256, $d9hQa);
$a3529daac5299a75$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $a3529daac5299a75$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $a3529daac5299a75$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $a3529daac5299a75$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $a3529daac5299a75$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $a3529daac5299a75$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $a3529daac5299a75$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$a3529daac5299a75$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $a3529daac5299a75$var$gamma1(w[i - 2]) + w[i - 7] + $a3529daac5299a75$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $a3529daac5299a75$var$sigma1(e) + $a3529daac5299a75$var$ch(e, f, g) + $a3529daac5299a75$var$K[j] + w[j] | 0;
        var T2 = $a3529daac5299a75$var$sigma0(a) + $a3529daac5299a75$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$a3529daac5299a75$var$Sha256.prototype._hash = function() {
    var H = $a3529daac5299a75$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $a3529daac5299a75$var$Sha256;

});


parcelRegister("fg4RU", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $g9xkA = parcelRequire("g9xkA");

var $d9hQa = parcelRequire("d9hQa");

var $4OiF0 = parcelRequire("4OiF0");
var $b1bc20670ebee3a8$require$Buffer = $4OiF0.Buffer;
var $b1bc20670ebee3a8$var$W = new Array(160);
function $b1bc20670ebee3a8$var$Sha384() {
    this.init();
    this._w = $b1bc20670ebee3a8$var$W;
    $d9hQa.call(this, 128, 112);
}
$bniia($b1bc20670ebee3a8$var$Sha384, $g9xkA);
$b1bc20670ebee3a8$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$b1bc20670ebee3a8$var$Sha384.prototype._hash = function() {
    var H = $b1bc20670ebee3a8$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $b1bc20670ebee3a8$var$Sha384;

});
parcelRegister("g9xkA", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $d9hQa = parcelRequire("d9hQa");

var $4OiF0 = parcelRequire("4OiF0");
var $bc27577884415b4a$require$Buffer = $4OiF0.Buffer;
var $bc27577884415b4a$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $bc27577884415b4a$var$W = new Array(160);
function $bc27577884415b4a$var$Sha512() {
    this.init();
    this._w = $bc27577884415b4a$var$W;
    $d9hQa.call(this, 128, 112);
}
$bniia($bc27577884415b4a$var$Sha512, $d9hQa);
$bc27577884415b4a$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $bc27577884415b4a$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $bc27577884415b4a$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $bc27577884415b4a$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $bc27577884415b4a$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $bc27577884415b4a$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $bc27577884415b4a$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $bc27577884415b4a$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $bc27577884415b4a$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $bc27577884415b4a$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$bc27577884415b4a$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $bc27577884415b4a$var$Gamma0(xh, xl);
        var gamma0l = $bc27577884415b4a$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $bc27577884415b4a$var$Gamma1(xh, xl);
        var gamma1l = $bc27577884415b4a$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $bc27577884415b4a$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $bc27577884415b4a$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $bc27577884415b4a$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $bc27577884415b4a$var$maj(ah, bh, ch);
        var majl = $bc27577884415b4a$var$maj(al, bl, cl);
        var sigma0h = $bc27577884415b4a$var$sigma0(ah, al);
        var sigma0l = $bc27577884415b4a$var$sigma0(al, ah);
        var sigma1h = $bc27577884415b4a$var$sigma1(eh, el);
        var sigma1l = $bc27577884415b4a$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $bc27577884415b4a$var$K[j];
        var Kil = $bc27577884415b4a$var$K[j + 1];
        var chh = $bc27577884415b4a$var$Ch(eh, fh, gh);
        var chl = $bc27577884415b4a$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $bc27577884415b4a$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $bc27577884415b4a$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $bc27577884415b4a$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $bc27577884415b4a$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $bc27577884415b4a$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $bc27577884415b4a$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $bc27577884415b4a$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $bc27577884415b4a$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $bc27577884415b4a$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $bc27577884415b4a$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $bc27577884415b4a$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $bc27577884415b4a$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $bc27577884415b4a$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $bc27577884415b4a$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $bc27577884415b4a$var$getCarry(this._hl, hl) | 0;
};
$bc27577884415b4a$var$Sha512.prototype._hash = function() {
    var H = $bc27577884415b4a$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $bc27577884415b4a$var$Sha512;

});



parcelRegister("7fR9R", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $54832b380df1b10e$require$Buffer = $4OiF0.Buffer;

var $9nTep = parcelRequire("9nTep");
var $54832b380df1b10e$require$Transform = $9nTep.Transform;

var $eJDLo = parcelRequire("eJDLo");
var $54832b380df1b10e$require$StringDecoder = $eJDLo.StringDecoder;

var $bniia = parcelRequire("bniia");

var $3xZbU = parcelRequire("3xZbU");
function $54832b380df1b10e$var$CipherBase(hashMode) {
    $54832b380df1b10e$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$bniia($54832b380df1b10e$var$CipherBase, $54832b380df1b10e$require$Transform);
$54832b380df1b10e$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $3xZbU(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$54832b380df1b10e$var$CipherBase.prototype.setAutoPadding = function() {};
$54832b380df1b10e$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$54832b380df1b10e$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$54832b380df1b10e$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$54832b380df1b10e$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$54832b380df1b10e$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$54832b380df1b10e$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $54832b380df1b10e$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$54832b380df1b10e$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $54832b380df1b10e$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $54832b380df1b10e$var$CipherBase;

});


parcelRegister("arZPn", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $A050z = parcelRequire("A050z");

var $7fR9R = parcelRequire("7fR9R");

var $4OiF0 = parcelRequire("4OiF0");
var $79bc62acc8fba62a$require$Buffer = $4OiF0.Buffer;

var $1SGN9 = parcelRequire("1SGN9");

var $1JYNO = parcelRequire("1JYNO");

var $1eplY = parcelRequire("1eplY");
var $79bc62acc8fba62a$var$ZEROS = $79bc62acc8fba62a$require$Buffer.alloc(128);
function $79bc62acc8fba62a$var$Hmac(alg, key) {
    $7fR9R.call(this, 'digest');
    if (typeof key === 'string') key = $79bc62acc8fba62a$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $1JYNO() : $1eplY(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $79bc62acc8fba62a$require$Buffer.concat([
        key,
        $79bc62acc8fba62a$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $79bc62acc8fba62a$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $79bc62acc8fba62a$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $1JYNO() : $1eplY(alg);
    this._hash.update(ipad);
}
$bniia($79bc62acc8fba62a$var$Hmac, $7fR9R);
$79bc62acc8fba62a$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$79bc62acc8fba62a$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $1JYNO() : $1eplY(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $79bc62acc8fba62a$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $A050z($1SGN9, key);
    return new $79bc62acc8fba62a$var$Hmac(alg, key);
};

});
parcelRegister("A050z", function(module, exports) {
'use strict';

var $bniia = parcelRequire("bniia");

var $4OiF0 = parcelRequire("4OiF0");
var $06c36cbfe146790c$require$Buffer = $4OiF0.Buffer;

var $7fR9R = parcelRequire("7fR9R");
var $06c36cbfe146790c$var$ZEROS = $06c36cbfe146790c$require$Buffer.alloc(128);
var $06c36cbfe146790c$var$blocksize = 64;
function $06c36cbfe146790c$var$Hmac(alg, key) {
    $7fR9R.call(this, 'digest');
    if (typeof key === 'string') key = $06c36cbfe146790c$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $06c36cbfe146790c$var$blocksize) key = alg(key);
    else if (key.length < $06c36cbfe146790c$var$blocksize) key = $06c36cbfe146790c$require$Buffer.concat([
        key,
        $06c36cbfe146790c$var$ZEROS
    ], $06c36cbfe146790c$var$blocksize);
    var ipad = this._ipad = $06c36cbfe146790c$require$Buffer.allocUnsafe($06c36cbfe146790c$var$blocksize);
    var opad = this._opad = $06c36cbfe146790c$require$Buffer.allocUnsafe($06c36cbfe146790c$var$blocksize);
    for(var i = 0; i < $06c36cbfe146790c$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$bniia($06c36cbfe146790c$var$Hmac, $7fR9R);
$06c36cbfe146790c$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$06c36cbfe146790c$var$Hmac.prototype._final = function() {
    var h = this._alg($06c36cbfe146790c$require$Buffer.concat(this._hash));
    return this._alg($06c36cbfe146790c$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $06c36cbfe146790c$var$Hmac;

});

parcelRegister("1SGN9", function(module, exports) {

var $eXAjQ = parcelRequire("eXAjQ");
module.exports = function(buffer) {
    return new $eXAjQ().update(buffer).digest();
};

});


parcelRegister("luisd", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6rTx5"));

});
parcelRegister("6rTx5", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("ellmV", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $a7139a420a4bebd3$export$448fa22aedc9dbca, (v) => $a7139a420a4bebd3$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $a7139a420a4bebd3$export$b80c7ba289c8fa56, (v) => $a7139a420a4bebd3$export$b80c7ba289c8fa56 = v);
var $a7139a420a4bebd3$export$448fa22aedc9dbca;
var $a7139a420a4bebd3$export$b80c7ba289c8fa56;
'use strict';

$a7139a420a4bebd3$export$448fa22aedc9dbca = (parcelRequire("eRp7M"));

$a7139a420a4bebd3$export$b80c7ba289c8fa56 = (parcelRequire("51RDi"));

});
parcelRegister("eRp7M", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $ad19811d6738152f$require$Buffer = $4OiF0.Buffer;

var $hKPt4 = parcelRequire("hKPt4");

var $2Vyyl = parcelRequire("2Vyyl");

var $51RDi = parcelRequire("51RDi");

var $f41UR = parcelRequire("f41UR");
var $ad19811d6738152f$var$ZERO_BUF;
var $ad19811d6738152f$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $ad19811d6738152f$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $ad19811d6738152f$var$checks = [];
var $ad19811d6738152f$var$nextTick;
function $ad19811d6738152f$var$getNextTick() {
    if ($ad19811d6738152f$var$nextTick) return $ad19811d6738152f$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $ad19811d6738152f$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $ad19811d6738152f$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $ad19811d6738152f$var$nextTick = $parcel$global.setImmediate;
    else $ad19811d6738152f$var$nextTick = $parcel$global.setTimeout;
    return $ad19811d6738152f$var$nextTick;
}
function $ad19811d6738152f$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $ad19811d6738152f$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $ad19811d6738152f$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $ad19811d6738152f$require$Buffer.from(res);
    });
}
function $ad19811d6738152f$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$ad19811d6738152f$var$subtle || !$ad19811d6738152f$var$subtle.importKey || !$ad19811d6738152f$var$subtle.deriveBits) return Promise.resolve(false);
    if ($ad19811d6738152f$var$checks[algo] !== undefined) return $ad19811d6738152f$var$checks[algo];
    $ad19811d6738152f$var$ZERO_BUF = $ad19811d6738152f$var$ZERO_BUF || $ad19811d6738152f$require$Buffer.alloc(8);
    var prom = $ad19811d6738152f$var$browserPbkdf2($ad19811d6738152f$var$ZERO_BUF, $ad19811d6738152f$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $ad19811d6738152f$var$checks[algo] = prom;
    return prom;
}
function $ad19811d6738152f$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $ad19811d6738152f$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $ad19811d6738152f$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $hKPt4(iterations, keylen);
    password = $f41UR(password, $2Vyyl, 'Password');
    salt = $f41UR(salt, $2Vyyl, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $ad19811d6738152f$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $ad19811d6738152f$var$getNextTick()(function() {
            var out;
            try {
                out = $51RDi(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $ad19811d6738152f$var$resolvePromise($ad19811d6738152f$var$checkNative(algo).then(function(resp) {
        if (resp) return $ad19811d6738152f$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $51RDi(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("hKPt4", function(module, exports) {
'use strict';
var $cecea80317af31a1$var$$isFinite = isFinite;
var $cecea80317af31a1$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$cecea80317af31a1$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $cecea80317af31a1$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("2Vyyl", function(module, exports) {

var $ajwPf = parcelRequire("ajwPf");
'use strict';
var $221bb51f50381d26$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $221bb51f50381d26$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $221bb51f50381d26$var$pVersionMajor = parseInt($ajwPf.version.split('.')[0].slice(1), 10);
    $221bb51f50381d26$var$defaultEncoding = $221bb51f50381d26$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $221bb51f50381d26$var$defaultEncoding = 'utf-8';
module.exports = $221bb51f50381d26$var$defaultEncoding;

});

parcelRegister("51RDi", function(module, exports) {
'use strict';

var $1SGN9 = parcelRequire("1SGN9");

var $1JYNO = parcelRequire("1JYNO");

var $1eplY = parcelRequire("1eplY");

var $4OiF0 = parcelRequire("4OiF0");
var $3a96a616d76bcb8d$require$Buffer = $4OiF0.Buffer;

var $hKPt4 = parcelRequire("hKPt4");

var $2Vyyl = parcelRequire("2Vyyl");

var $f41UR = parcelRequire("f41UR");
var $3a96a616d76bcb8d$var$ZEROS = $3a96a616d76bcb8d$require$Buffer.alloc(128);
var $3a96a616d76bcb8d$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $3a96a616d76bcb8d$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $3a96a616d76bcb8d$var$rmd160Func(data) {
    return new $1JYNO().update(data).digest();
}
function $3a96a616d76bcb8d$var$getDigest(alg) {
    function shaFunc(data) {
        return $1eplY(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $3a96a616d76bcb8d$var$rmd160Func;
    if (alg === 'md5') return $1SGN9;
    return shaFunc;
}
function $3a96a616d76bcb8d$var$Hmac(alg, key, saltLen) {
    var hash = $3a96a616d76bcb8d$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $3a96a616d76bcb8d$require$Buffer.concat([
        key,
        $3a96a616d76bcb8d$var$ZEROS
    ], blocksize);
    var ipad = $3a96a616d76bcb8d$require$Buffer.allocUnsafe(blocksize + $3a96a616d76bcb8d$var$sizes[alg]);
    var opad = $3a96a616d76bcb8d$require$Buffer.allocUnsafe(blocksize + $3a96a616d76bcb8d$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $3a96a616d76bcb8d$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $3a96a616d76bcb8d$var$sizes[alg];
}
$3a96a616d76bcb8d$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $3a96a616d76bcb8d$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $hKPt4(iterations, keylen);
    password = $f41UR(password, $2Vyyl, 'Password');
    salt = $f41UR(salt, $2Vyyl, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $3a96a616d76bcb8d$var$mapping[lowerDigest] || lowerDigest;
    var size = $3a96a616d76bcb8d$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $3a96a616d76bcb8d$var$Hmac(mappedDigest, password, salt.length);
    var DK = $3a96a616d76bcb8d$require$Buffer.allocUnsafe(keylen);
    var block1 = $3a96a616d76bcb8d$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $3a96a616d76bcb8d$var$pbkdf2;

});
parcelRegister("f41UR", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $af78b7373175d524$require$Buffer = $4OiF0.Buffer;

var $3xZbU = parcelRequire("3xZbU");
var $af78b7373175d524$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $af78b7373175d524$var$useArrayBuffer = $af78b7373175d524$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $af78b7373175d524$var$isView = $af78b7373175d524$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $af78b7373175d524$require$Buffer.isBuffer(thing) || $af78b7373175d524$var$useUint8Array && thing instanceof Uint8Array || $af78b7373175d524$var$isView && $af78b7373175d524$var$isView(thing)) return $3xZbU(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("gfQS5", function(module, exports) {

$parcel$export(module.exports, "createCipher", () => $bd570f32d1ad8ab8$export$bdd223f16383713e, (v) => $bd570f32d1ad8ab8$export$bdd223f16383713e = v);
$parcel$export(module.exports, "Cipher", () => $bd570f32d1ad8ab8$export$26e5786e8ac8e530, (v) => $bd570f32d1ad8ab8$export$26e5786e8ac8e530 = v);
$parcel$export(module.exports, "createCipheriv", () => $bd570f32d1ad8ab8$export$2f64596b8cbf08b4, (v) => $bd570f32d1ad8ab8$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "Cipheriv", () => $bd570f32d1ad8ab8$export$20533d26f07f1ee0, (v) => $bd570f32d1ad8ab8$export$20533d26f07f1ee0 = v);
$parcel$export(module.exports, "createDecipher", () => $bd570f32d1ad8ab8$export$12ada9414fbc594c, (v) => $bd570f32d1ad8ab8$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "Decipher", () => $bd570f32d1ad8ab8$export$2ce6d8d0e8b04e1a, (v) => $bd570f32d1ad8ab8$export$2ce6d8d0e8b04e1a = v);
$parcel$export(module.exports, "createDecipheriv", () => $bd570f32d1ad8ab8$export$36b6d6ef312eab39, (v) => $bd570f32d1ad8ab8$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "Decipheriv", () => $bd570f32d1ad8ab8$export$f5e7e39d57cd9700, (v) => $bd570f32d1ad8ab8$export$f5e7e39d57cd9700 = v);
$parcel$export(module.exports, "listCiphers", () => $bd570f32d1ad8ab8$export$dedd8dc3dc62b370, (v) => $bd570f32d1ad8ab8$export$dedd8dc3dc62b370 = v);
$parcel$export(module.exports, "getCiphers", () => $bd570f32d1ad8ab8$export$58a258485f1e49f6, (v) => $bd570f32d1ad8ab8$export$58a258485f1e49f6 = v);
var $bd570f32d1ad8ab8$export$bdd223f16383713e;
var $bd570f32d1ad8ab8$export$26e5786e8ac8e530;
var $bd570f32d1ad8ab8$export$2f64596b8cbf08b4;
var $bd570f32d1ad8ab8$export$20533d26f07f1ee0;
var $bd570f32d1ad8ab8$export$12ada9414fbc594c;
var $bd570f32d1ad8ab8$export$2ce6d8d0e8b04e1a;
var $bd570f32d1ad8ab8$export$36b6d6ef312eab39;
var $bd570f32d1ad8ab8$export$f5e7e39d57cd9700;
var $bd570f32d1ad8ab8$export$dedd8dc3dc62b370;
var $bd570f32d1ad8ab8$export$58a258485f1e49f6;

var $aGKUV = parcelRequire("aGKUV");

var $2JnZq = parcelRequire("2JnZq");

var $hATs4 = parcelRequire("hATs4");

var $lGzCO = parcelRequire("lGzCO");

var $cthQ7 = parcelRequire("cthQ7");
function $bd570f32d1ad8ab8$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($hATs4[suite]) {
        keyLen = $hATs4[suite].key;
        ivLen = $hATs4[suite].iv;
    } else if ($lGzCO[suite]) {
        keyLen = $lGzCO[suite].key * 8;
        ivLen = $lGzCO[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $cthQ7(password, false, keyLen, ivLen);
    return $bd570f32d1ad8ab8$var$createCipheriv(suite, keys.key, keys.iv);
}
function $bd570f32d1ad8ab8$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($hATs4[suite]) {
        keyLen = $hATs4[suite].key;
        ivLen = $hATs4[suite].iv;
    } else if ($lGzCO[suite]) {
        keyLen = $lGzCO[suite].key * 8;
        ivLen = $lGzCO[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $cthQ7(password, false, keyLen, ivLen);
    return $bd570f32d1ad8ab8$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $bd570f32d1ad8ab8$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($hATs4[suite]) return $2JnZq.createCipheriv(suite, key, iv);
    if ($lGzCO[suite]) return new $aGKUV({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $bd570f32d1ad8ab8$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($hATs4[suite]) return $2JnZq.createDecipheriv(suite, key, iv);
    if ($lGzCO[suite]) return new $aGKUV({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $bd570f32d1ad8ab8$var$getCiphers() {
    return Object.keys($lGzCO).concat($2JnZq.getCiphers());
}
$bd570f32d1ad8ab8$export$bdd223f16383713e = $bd570f32d1ad8ab8$export$26e5786e8ac8e530 = $bd570f32d1ad8ab8$var$createCipher;
$bd570f32d1ad8ab8$export$2f64596b8cbf08b4 = $bd570f32d1ad8ab8$export$20533d26f07f1ee0 = $bd570f32d1ad8ab8$var$createCipheriv;
$bd570f32d1ad8ab8$export$12ada9414fbc594c = $bd570f32d1ad8ab8$export$2ce6d8d0e8b04e1a = $bd570f32d1ad8ab8$var$createDecipher;
$bd570f32d1ad8ab8$export$36b6d6ef312eab39 = $bd570f32d1ad8ab8$export$f5e7e39d57cd9700 = $bd570f32d1ad8ab8$var$createDecipheriv;
$bd570f32d1ad8ab8$export$dedd8dc3dc62b370 = $bd570f32d1ad8ab8$export$58a258485f1e49f6 = $bd570f32d1ad8ab8$var$getCiphers;

});
parcelRegister("aGKUV", function(module, exports) {

var $7fR9R = parcelRequire("7fR9R");

var $3lt2x = parcelRequire("3lt2x");

var $bniia = parcelRequire("bniia");

var $4OiF0 = parcelRequire("4OiF0");
var $7c82386baaf7dac0$require$Buffer = $4OiF0.Buffer;
var $7c82386baaf7dac0$var$modes = {
    'des-ede3-cbc': $3lt2x.CBC.instantiate($3lt2x.EDE),
    'des-ede3': $3lt2x.EDE,
    'des-ede-cbc': $3lt2x.CBC.instantiate($3lt2x.EDE),
    'des-ede': $3lt2x.EDE,
    'des-cbc': $3lt2x.CBC.instantiate($3lt2x.DES),
    'des-ecb': $3lt2x.DES
};
$7c82386baaf7dac0$var$modes.des = $7c82386baaf7dac0$var$modes['des-cbc'];
$7c82386baaf7dac0$var$modes.des3 = $7c82386baaf7dac0$var$modes['des-ede3-cbc'];
module.exports = $7c82386baaf7dac0$var$DES;
$bniia($7c82386baaf7dac0$var$DES, $7fR9R);
function $7c82386baaf7dac0$var$DES(opts) {
    $7fR9R.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $7c82386baaf7dac0$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$7c82386baaf7dac0$require$Buffer.isBuffer(key)) key = $7c82386baaf7dac0$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $7c82386baaf7dac0$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$7c82386baaf7dac0$require$Buffer.isBuffer(iv)) iv = $7c82386baaf7dac0$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$7c82386baaf7dac0$var$DES.prototype._update = function(data) {
    return $7c82386baaf7dac0$require$Buffer.from(this._des.update(data));
};
$7c82386baaf7dac0$var$DES.prototype._final = function() {
    return $7c82386baaf7dac0$require$Buffer.from(this._des.final());
};

});
parcelRegister("3lt2x", function(module, exports) {

$parcel$export(module.exports, "DES", () => $26f9dbfe77309d6f$export$cc8859615686b300, (v) => $26f9dbfe77309d6f$export$cc8859615686b300 = v);
$parcel$export(module.exports, "CBC", () => $26f9dbfe77309d6f$export$8ad3f227af08fcc5, (v) => $26f9dbfe77309d6f$export$8ad3f227af08fcc5 = v);
$parcel$export(module.exports, "EDE", () => $26f9dbfe77309d6f$export$947646e34766044f, (v) => $26f9dbfe77309d6f$export$947646e34766044f = v);
var $26f9dbfe77309d6f$export$eab97d15b1788b8d;
var $26f9dbfe77309d6f$export$26e5786e8ac8e530;
var $26f9dbfe77309d6f$export$cc8859615686b300;
var $26f9dbfe77309d6f$export$8ad3f227af08fcc5;
var $26f9dbfe77309d6f$export$947646e34766044f;
'use strict';

$26f9dbfe77309d6f$export$eab97d15b1788b8d = (parcelRequire("iFbrB"));

$26f9dbfe77309d6f$export$26e5786e8ac8e530 = (parcelRequire("jzGYd"));

$26f9dbfe77309d6f$export$cc8859615686b300 = (parcelRequire("gXbM9"));

$26f9dbfe77309d6f$export$8ad3f227af08fcc5 = (parcelRequire("6Pi5A"));

$26f9dbfe77309d6f$export$947646e34766044f = (parcelRequire("aUE1e"));

});
parcelRegister("iFbrB", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $d964eee456090fce$export$cfaef8ed399428b0, (v) => $d964eee456090fce$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $d964eee456090fce$export$a80c7deaea7cbd80, (v) => $d964eee456090fce$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $d964eee456090fce$export$ed7577ae6e1cd0ef, (v) => $d964eee456090fce$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $d964eee456090fce$export$5dcbef3aa594f567, (v) => $d964eee456090fce$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $d964eee456090fce$export$5bc8001ca71ed9c5, (v) => $d964eee456090fce$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $d964eee456090fce$export$3e714e2c5d5d8cb2, (v) => $d964eee456090fce$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $d964eee456090fce$export$94c3e544fd062b7f, (v) => $d964eee456090fce$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $d964eee456090fce$export$9f77e0932fb78f72, (v) => $d964eee456090fce$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $d964eee456090fce$export$d865ce2836f5927f, (v) => $d964eee456090fce$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $d964eee456090fce$export$95e62ad65da8b7d2, (v) => $d964eee456090fce$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $d964eee456090fce$export$209139ff098c441a, (v) => $d964eee456090fce$export$209139ff098c441a = v);
var $d964eee456090fce$export$cfaef8ed399428b0;
var $d964eee456090fce$export$a80c7deaea7cbd80;
var $d964eee456090fce$export$ed7577ae6e1cd0ef;
var $d964eee456090fce$export$5dcbef3aa594f567;
var $d964eee456090fce$export$5bc8001ca71ed9c5;
var $d964eee456090fce$export$3e714e2c5d5d8cb2;
var $d964eee456090fce$export$94c3e544fd062b7f;
var $d964eee456090fce$export$9f77e0932fb78f72;
var $d964eee456090fce$export$d865ce2836f5927f;
var $d964eee456090fce$export$95e62ad65da8b7d2;
var $d964eee456090fce$export$209139ff098c441a;
'use strict';
$d964eee456090fce$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$d964eee456090fce$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$d964eee456090fce$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$d964eee456090fce$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$d964eee456090fce$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$d964eee456090fce$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $d964eee456090fce$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$d964eee456090fce$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $d964eee456090fce$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $d964eee456090fce$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $d964eee456090fce$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $d964eee456090fce$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$d964eee456090fce$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $d964eee456090fce$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$d964eee456090fce$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $d964eee456090fce$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $d964eee456090fce$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $d964eee456090fce$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$d964eee456090fce$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $d964eee456090fce$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $d964eee456090fce$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$d964eee456090fce$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("jzGYd", function(module, exports) {
'use strict';

var $bNW2d = parcelRequire("bNW2d");
function $e4029e33618e3e39$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $e4029e33618e3e39$var$Cipher;
$e4029e33618e3e39$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$e4029e33618e3e39$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$e4029e33618e3e39$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$e4029e33618e3e39$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$e4029e33618e3e39$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$e4029e33618e3e39$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$e4029e33618e3e39$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$e4029e33618e3e39$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$e4029e33618e3e39$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$e4029e33618e3e39$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$e4029e33618e3e39$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $bNW2d.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("bNW2d", function(module, exports) {
module.exports = $898149ce3890f9ea$var$assert;
function $898149ce3890f9ea$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$898149ce3890f9ea$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("gXbM9", function(module, exports) {
'use strict';

var $bNW2d = parcelRequire("bNW2d");

var $bniia = parcelRequire("bniia");

var $iFbrB = parcelRequire("iFbrB");

var $jzGYd = parcelRequire("jzGYd");
function $c57b4a6fbff7edf3$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $c57b4a6fbff7edf3$var$DES(options) {
    $jzGYd.call(this, options);
    var state = new $c57b4a6fbff7edf3$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$bniia($c57b4a6fbff7edf3$var$DES, $jzGYd);
module.exports = $c57b4a6fbff7edf3$var$DES;
$c57b4a6fbff7edf3$var$DES.create = function create(options) {
    return new $c57b4a6fbff7edf3$var$DES(options);
};
var $c57b4a6fbff7edf3$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$c57b4a6fbff7edf3$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $bNW2d.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $iFbrB.readUInt32BE(key, 0);
    var kR = $iFbrB.readUInt32BE(key, 4);
    $iFbrB.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $c57b4a6fbff7edf3$var$shiftTable[i >>> 1];
        kL = $iFbrB.r28shl(kL, shift);
        kR = $iFbrB.r28shl(kR, shift);
        $iFbrB.pc2(kL, kR, state.keys, i);
    }
};
$c57b4a6fbff7edf3$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $iFbrB.readUInt32BE(inp, inOff);
    var r = $iFbrB.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $iFbrB.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $iFbrB.writeUInt32BE(out, l, outOff);
    $iFbrB.writeUInt32BE(out, r, outOff + 4);
};
$c57b4a6fbff7edf3$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$c57b4a6fbff7edf3$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$bNW2d.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$c57b4a6fbff7edf3$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $iFbrB.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $iFbrB.substitute(keyL, keyR);
        var f = $iFbrB.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $iFbrB.rip(r, l, out, off);
};
$c57b4a6fbff7edf3$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $iFbrB.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $iFbrB.substitute(keyL, keyR);
        var f = $iFbrB.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $iFbrB.rip(l, r, out, off);
};

});

parcelRegister("6Pi5A", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $4f8589993858d9df$export$f9bb8d20ccc7477a, (v) => $4f8589993858d9df$export$f9bb8d20ccc7477a = v);
var $4f8589993858d9df$export$f9bb8d20ccc7477a;
'use strict';

var $bNW2d = parcelRequire("bNW2d");

var $bniia = parcelRequire("bniia");
var $4f8589993858d9df$var$proto = {};
function $4f8589993858d9df$var$CBCState(iv) {
    $bNW2d.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $4f8589993858d9df$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $bniia(CBC, Base);
    var keys = Object.keys($4f8589993858d9df$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $4f8589993858d9df$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$4f8589993858d9df$export$f9bb8d20ccc7477a = $4f8589993858d9df$var$instantiate;
$4f8589993858d9df$var$proto._cbcInit = function _cbcInit() {
    var state = new $4f8589993858d9df$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$4f8589993858d9df$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("aUE1e", function(module, exports) {
'use strict';

var $bNW2d = parcelRequire("bNW2d");

var $bniia = parcelRequire("bniia");

var $jzGYd = parcelRequire("jzGYd");

var $gXbM9 = parcelRequire("gXbM9");
function $7f1e2d455a929e25$var$EDEState(type, key) {
    $bNW2d.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $gXbM9.create({
            type: 'encrypt',
            key: k1
        }),
        $gXbM9.create({
            type: 'decrypt',
            key: k2
        }),
        $gXbM9.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $gXbM9.create({
            type: 'decrypt',
            key: k3
        }),
        $gXbM9.create({
            type: 'encrypt',
            key: k2
        }),
        $gXbM9.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $7f1e2d455a929e25$var$EDE(options) {
    $jzGYd.call(this, options);
    var state = new $7f1e2d455a929e25$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$bniia($7f1e2d455a929e25$var$EDE, $jzGYd);
module.exports = $7f1e2d455a929e25$var$EDE;
$7f1e2d455a929e25$var$EDE.create = function create(options) {
    return new $7f1e2d455a929e25$var$EDE(options);
};
$7f1e2d455a929e25$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$7f1e2d455a929e25$var$EDE.prototype._pad = $gXbM9.prototype._pad;
$7f1e2d455a929e25$var$EDE.prototype._unpad = $gXbM9.prototype._unpad;

});



parcelRegister("2JnZq", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $1fd2649f2d7f999c$export$2f64596b8cbf08b4, (v) => $1fd2649f2d7f999c$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $1fd2649f2d7f999c$export$36b6d6ef312eab39, (v) => $1fd2649f2d7f999c$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $1fd2649f2d7f999c$export$58a258485f1e49f6, (v) => $1fd2649f2d7f999c$export$58a258485f1e49f6 = v);
var $1fd2649f2d7f999c$export$bdd223f16383713e;
var $1fd2649f2d7f999c$export$26e5786e8ac8e530;
var $1fd2649f2d7f999c$export$2f64596b8cbf08b4;
var $1fd2649f2d7f999c$export$20533d26f07f1ee0;
var $1fd2649f2d7f999c$export$12ada9414fbc594c;
var $1fd2649f2d7f999c$export$2ce6d8d0e8b04e1a;
var $1fd2649f2d7f999c$export$36b6d6ef312eab39;
var $1fd2649f2d7f999c$export$f5e7e39d57cd9700;
var $1fd2649f2d7f999c$export$dedd8dc3dc62b370;
var $1fd2649f2d7f999c$export$58a258485f1e49f6;

var $6ILRy = parcelRequire("6ILRy");

var $iccu4 = parcelRequire("iccu4");

var $l3VQd = parcelRequire("l3VQd");
function $1fd2649f2d7f999c$var$getCiphers() {
    return Object.keys($l3VQd);
}
$1fd2649f2d7f999c$export$bdd223f16383713e = $1fd2649f2d7f999c$export$26e5786e8ac8e530 = $6ILRy.createCipher;
$1fd2649f2d7f999c$export$2f64596b8cbf08b4 = $1fd2649f2d7f999c$export$20533d26f07f1ee0 = $6ILRy.createCipheriv;
$1fd2649f2d7f999c$export$12ada9414fbc594c = $1fd2649f2d7f999c$export$2ce6d8d0e8b04e1a = $iccu4.createDecipher;
$1fd2649f2d7f999c$export$36b6d6ef312eab39 = $1fd2649f2d7f999c$export$f5e7e39d57cd9700 = $iccu4.createDecipheriv;
$1fd2649f2d7f999c$export$dedd8dc3dc62b370 = $1fd2649f2d7f999c$export$58a258485f1e49f6 = $1fd2649f2d7f999c$var$getCiphers;

});
parcelRegister("6ILRy", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $4e4bfab2c825cb8e$export$2f64596b8cbf08b4, (v) => $4e4bfab2c825cb8e$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $4e4bfab2c825cb8e$export$bdd223f16383713e, (v) => $4e4bfab2c825cb8e$export$bdd223f16383713e = v);
var $4e4bfab2c825cb8e$export$2f64596b8cbf08b4;
var $4e4bfab2c825cb8e$export$bdd223f16383713e;

var $hATs4 = parcelRequire("hATs4");

var $1wbtR = parcelRequire("1wbtR");

var $4OiF0 = parcelRequire("4OiF0");
var $4e4bfab2c825cb8e$require$Buffer = $4OiF0.Buffer;

var $jwQyu = parcelRequire("jwQyu");

var $7fR9R = parcelRequire("7fR9R");

var $1eFE8 = parcelRequire("1eFE8");

var $cthQ7 = parcelRequire("cthQ7");

var $bniia = parcelRequire("bniia");
function $4e4bfab2c825cb8e$var$Cipher(mode, key, iv) {
    $7fR9R.call(this);
    this._cache = new $4e4bfab2c825cb8e$var$Splitter();
    this._cipher = new $1eFE8.AES(key);
    this._prev = $4e4bfab2c825cb8e$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$bniia($4e4bfab2c825cb8e$var$Cipher, $7fR9R);
$4e4bfab2c825cb8e$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $4e4bfab2c825cb8e$require$Buffer.concat(out);
};
var $4e4bfab2c825cb8e$var$PADDING = $4e4bfab2c825cb8e$require$Buffer.alloc(16, 0x10);
$4e4bfab2c825cb8e$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($4e4bfab2c825cb8e$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$4e4bfab2c825cb8e$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $4e4bfab2c825cb8e$var$Splitter() {
    this.cache = $4e4bfab2c825cb8e$require$Buffer.allocUnsafe(0);
}
$4e4bfab2c825cb8e$var$Splitter.prototype.add = function(data) {
    this.cache = $4e4bfab2c825cb8e$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$4e4bfab2c825cb8e$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$4e4bfab2c825cb8e$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $4e4bfab2c825cb8e$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $4e4bfab2c825cb8e$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $4e4bfab2c825cb8e$var$createCipheriv(suite, password, iv) {
    var config = $hATs4[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $4e4bfab2c825cb8e$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $4e4bfab2c825cb8e$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $jwQyu(config.module, password, iv);
    else if (config.type === 'auth') return new $1wbtR(config.module, password, iv);
    return new $4e4bfab2c825cb8e$var$Cipher(config.module, password, iv);
}
function $4e4bfab2c825cb8e$var$createCipher(suite, password) {
    var config = $hATs4[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $cthQ7(password, false, config.key, config.iv);
    return $4e4bfab2c825cb8e$var$createCipheriv(suite, keys.key, keys.iv);
}
$4e4bfab2c825cb8e$export$2f64596b8cbf08b4 = $4e4bfab2c825cb8e$var$createCipheriv;
$4e4bfab2c825cb8e$export$bdd223f16383713e = $4e4bfab2c825cb8e$var$createCipher;

});
parcelRegister("hATs4", function(module, exports) {








var $ccf0d0074022769e$var$modeModules = {
    ECB: (parcelRequire("6SVHN")),
    CBC: (parcelRequire("6Fpa7")),
    CFB: (parcelRequire("57fNo")),
    CFB8: (parcelRequire("1CnKI")),
    CFB1: (parcelRequire("bGJLd")),
    OFB: (parcelRequire("49PGC")),
    CTR: (parcelRequire("aTFc5")),
    GCM: (parcelRequire("aTFc5"))
};

var $l3VQd = parcelRequire("l3VQd");
for(var $ccf0d0074022769e$var$key in $l3VQd)$l3VQd[$ccf0d0074022769e$var$key].module = $ccf0d0074022769e$var$modeModules[$l3VQd[$ccf0d0074022769e$var$key].mode];
module.exports = $l3VQd;

});
parcelRegister("6SVHN", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $50348c52563d51e4$export$5b0f6292f11d1d18, (v) => $50348c52563d51e4$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $50348c52563d51e4$export$e85a0c9a1067c5d3, (v) => $50348c52563d51e4$export$e85a0c9a1067c5d3 = v);
var $50348c52563d51e4$export$5b0f6292f11d1d18;
var $50348c52563d51e4$export$e85a0c9a1067c5d3;
$50348c52563d51e4$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$50348c52563d51e4$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("6Fpa7", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $4daa172072cd3e53$export$5b0f6292f11d1d18, (v) => $4daa172072cd3e53$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $4daa172072cd3e53$export$e85a0c9a1067c5d3, (v) => $4daa172072cd3e53$export$e85a0c9a1067c5d3 = v);
var $4daa172072cd3e53$export$5b0f6292f11d1d18;
var $4daa172072cd3e53$export$e85a0c9a1067c5d3;

var $1rhhe = parcelRequire("1rhhe");
$4daa172072cd3e53$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $1rhhe(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$4daa172072cd3e53$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $1rhhe(out, pad);
};

});
parcelRegister("1rhhe", function(module, exports) {

var $8UsMN = parcelRequire("8UsMN");
var $10c5b6e7e9afde79$require$Buffer = $8UsMN.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $10c5b6e7e9afde79$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("57fNo", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $3b99dbe4bdb79814$export$5b0f6292f11d1d18, (v) => $3b99dbe4bdb79814$export$5b0f6292f11d1d18 = v);
var $3b99dbe4bdb79814$export$5b0f6292f11d1d18;

var $4OiF0 = parcelRequire("4OiF0");
var $3b99dbe4bdb79814$require$Buffer = $4OiF0.Buffer;

var $1rhhe = parcelRequire("1rhhe");
function $3b99dbe4bdb79814$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $1rhhe(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $3b99dbe4bdb79814$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$3b99dbe4bdb79814$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $3b99dbe4bdb79814$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $3b99dbe4bdb79814$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $3b99dbe4bdb79814$require$Buffer.concat([
                out,
                $3b99dbe4bdb79814$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $3b99dbe4bdb79814$require$Buffer.concat([
                out,
                $3b99dbe4bdb79814$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("1CnKI", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $12dbc3c9e74144c6$export$5b0f6292f11d1d18, (v) => $12dbc3c9e74144c6$export$5b0f6292f11d1d18 = v);
var $12dbc3c9e74144c6$export$5b0f6292f11d1d18;

var $4OiF0 = parcelRequire("4OiF0");
var $12dbc3c9e74144c6$require$Buffer = $4OiF0.Buffer;
function $12dbc3c9e74144c6$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $12dbc3c9e74144c6$require$Buffer.concat([
        self._prev.slice(1),
        $12dbc3c9e74144c6$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$12dbc3c9e74144c6$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $12dbc3c9e74144c6$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $12dbc3c9e74144c6$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("bGJLd", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $88271d0affca1c96$export$5b0f6292f11d1d18, (v) => $88271d0affca1c96$export$5b0f6292f11d1d18 = v);
var $88271d0affca1c96$export$5b0f6292f11d1d18;

var $4OiF0 = parcelRequire("4OiF0");
var $88271d0affca1c96$require$Buffer = $4OiF0.Buffer;
function $88271d0affca1c96$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $88271d0affca1c96$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $88271d0affca1c96$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $88271d0affca1c96$require$Buffer.allocUnsafe(buffer.length);
    buffer = $88271d0affca1c96$require$Buffer.concat([
        buffer,
        $88271d0affca1c96$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$88271d0affca1c96$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $88271d0affca1c96$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $88271d0affca1c96$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("49PGC", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $30701883398d7d88$export$5b0f6292f11d1d18, (v) => $30701883398d7d88$export$5b0f6292f11d1d18 = v);
var $30701883398d7d88$export$5b0f6292f11d1d18;

var $8UsMN = parcelRequire("8UsMN");
var $30701883398d7d88$require$Buffer = $8UsMN.Buffer;

var $1rhhe = parcelRequire("1rhhe");
function $30701883398d7d88$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$30701883398d7d88$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $30701883398d7d88$require$Buffer.concat([
        self._cache,
        $30701883398d7d88$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $1rhhe(chunk, pad);
};

});

parcelRegister("aTFc5", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $7eeefeb1e4c7dbcf$export$5b0f6292f11d1d18, (v) => $7eeefeb1e4c7dbcf$export$5b0f6292f11d1d18 = v);
var $7eeefeb1e4c7dbcf$export$5b0f6292f11d1d18;

var $1rhhe = parcelRequire("1rhhe");

var $4OiF0 = parcelRequire("4OiF0");
var $7eeefeb1e4c7dbcf$require$Buffer = $4OiF0.Buffer;

var $1Uyl8 = parcelRequire("1Uyl8");
function $7eeefeb1e4c7dbcf$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $1Uyl8(self._prev);
    return out;
}
var $7eeefeb1e4c7dbcf$var$blockSize = 16;
$7eeefeb1e4c7dbcf$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $7eeefeb1e4c7dbcf$var$blockSize);
    var start = self._cache.length;
    self._cache = $7eeefeb1e4c7dbcf$require$Buffer.concat([
        self._cache,
        $7eeefeb1e4c7dbcf$require$Buffer.allocUnsafe(chunkNum * $7eeefeb1e4c7dbcf$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $7eeefeb1e4c7dbcf$var$getBlock(self);
        var offset = start + i * $7eeefeb1e4c7dbcf$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $1rhhe(chunk, pad);
};

});
parcelRegister("1Uyl8", function(module, exports) {
function $1645a89ad58da289$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $1645a89ad58da289$var$incr32;

});


parcelRegister("l3VQd", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("1wbtR", function(module, exports) {

var $1eFE8 = parcelRequire("1eFE8");

var $4OiF0 = parcelRequire("4OiF0");
var $11b1af712a3f5e54$require$Buffer = $4OiF0.Buffer;

var $7fR9R = parcelRequire("7fR9R");

var $bniia = parcelRequire("bniia");

var $jNvWi = parcelRequire("jNvWi");

var $1rhhe = parcelRequire("1rhhe");

var $1Uyl8 = parcelRequire("1Uyl8");
function $11b1af712a3f5e54$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $11b1af712a3f5e54$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $11b1af712a3f5e54$require$Buffer.concat([
            iv,
            $11b1af712a3f5e54$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $11b1af712a3f5e54$require$Buffer.concat([
            iv,
            $11b1af712a3f5e54$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $jNvWi(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($11b1af712a3f5e54$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($11b1af712a3f5e54$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $11b1af712a3f5e54$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $11b1af712a3f5e54$require$Buffer.from(self._finID);
    $1Uyl8(out);
    return out;
}
function $11b1af712a3f5e54$var$StreamCipher(mode, key, iv, decrypt) {
    $7fR9R.call(this);
    var h = $11b1af712a3f5e54$require$Buffer.alloc(4, 0);
    this._cipher = new $1eFE8.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $jNvWi(ck);
    iv = $11b1af712a3f5e54$var$calcIv(this, iv, ck);
    this._prev = $11b1af712a3f5e54$require$Buffer.from(iv);
    this._cache = $11b1af712a3f5e54$require$Buffer.allocUnsafe(0);
    this._secCache = $11b1af712a3f5e54$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$bniia($11b1af712a3f5e54$var$StreamCipher, $7fR9R);
$11b1af712a3f5e54$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $11b1af712a3f5e54$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$11b1af712a3f5e54$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $1rhhe(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $11b1af712a3f5e54$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$11b1af712a3f5e54$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$11b1af712a3f5e54$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$11b1af712a3f5e54$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$11b1af712a3f5e54$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $11b1af712a3f5e54$var$StreamCipher;

});
parcelRegister("1eFE8", function(module, exports) {

$parcel$export(module.exports, "AES", () => $0e67675cfcaf4f4a$export$b80fbe1c3a2b92b5, (v) => $0e67675cfcaf4f4a$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $0e67675cfcaf4f4a$export$b80fbe1c3a2b92b5;

var $4OiF0 = parcelRequire("4OiF0");
var $0e67675cfcaf4f4a$require$Buffer = $4OiF0.Buffer;
function $0e67675cfcaf4f4a$var$asUInt32Array(buf) {
    if (!$0e67675cfcaf4f4a$require$Buffer.isBuffer(buf)) buf = $0e67675cfcaf4f4a$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $0e67675cfcaf4f4a$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $0e67675cfcaf4f4a$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $0e67675cfcaf4f4a$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $0e67675cfcaf4f4a$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $0e67675cfcaf4f4a$var$AES(key) {
    this._key = $0e67675cfcaf4f4a$var$asUInt32Array(key);
    this._reset();
}
$0e67675cfcaf4f4a$var$AES.blockSize = 16;
$0e67675cfcaf4f4a$var$AES.keySize = 32;
$0e67675cfcaf4f4a$var$AES.prototype.blockSize = $0e67675cfcaf4f4a$var$AES.blockSize;
$0e67675cfcaf4f4a$var$AES.prototype.keySize = $0e67675cfcaf4f4a$var$AES.keySize;
$0e67675cfcaf4f4a$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $0e67675cfcaf4f4a$var$G.SBOX[t >>> 24] << 24 | $0e67675cfcaf4f4a$var$G.SBOX[t >>> 16 & 0xff] << 16 | $0e67675cfcaf4f4a$var$G.SBOX[t >>> 8 & 0xff] << 8 | $0e67675cfcaf4f4a$var$G.SBOX[t & 0xff];
            t ^= $0e67675cfcaf4f4a$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $0e67675cfcaf4f4a$var$G.SBOX[t >>> 24] << 24 | $0e67675cfcaf4f4a$var$G.SBOX[t >>> 16 & 0xff] << 16 | $0e67675cfcaf4f4a$var$G.SBOX[t >>> 8 & 0xff] << 8 | $0e67675cfcaf4f4a$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $0e67675cfcaf4f4a$var$G.INV_SUB_MIX[0][$0e67675cfcaf4f4a$var$G.SBOX[tt >>> 24]] ^ $0e67675cfcaf4f4a$var$G.INV_SUB_MIX[1][$0e67675cfcaf4f4a$var$G.SBOX[tt >>> 16 & 0xff]] ^ $0e67675cfcaf4f4a$var$G.INV_SUB_MIX[2][$0e67675cfcaf4f4a$var$G.SBOX[tt >>> 8 & 0xff]] ^ $0e67675cfcaf4f4a$var$G.INV_SUB_MIX[3][$0e67675cfcaf4f4a$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$0e67675cfcaf4f4a$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $0e67675cfcaf4f4a$var$asUInt32Array(M);
    return $0e67675cfcaf4f4a$var$cryptBlock(M, this._keySchedule, $0e67675cfcaf4f4a$var$G.SUB_MIX, $0e67675cfcaf4f4a$var$G.SBOX, this._nRounds);
};
$0e67675cfcaf4f4a$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $0e67675cfcaf4f4a$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$0e67675cfcaf4f4a$var$AES.prototype.decryptBlock = function(M) {
    M = $0e67675cfcaf4f4a$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $0e67675cfcaf4f4a$var$cryptBlock(M, this._invKeySchedule, $0e67675cfcaf4f4a$var$G.INV_SUB_MIX, $0e67675cfcaf4f4a$var$G.INV_SBOX, this._nRounds);
    var buf = $0e67675cfcaf4f4a$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$0e67675cfcaf4f4a$var$AES.prototype.scrub = function() {
    $0e67675cfcaf4f4a$var$scrubVec(this._keySchedule);
    $0e67675cfcaf4f4a$var$scrubVec(this._invKeySchedule);
    $0e67675cfcaf4f4a$var$scrubVec(this._key);
};
$0e67675cfcaf4f4a$export$b80fbe1c3a2b92b5 = $0e67675cfcaf4f4a$var$AES;

});

parcelRegister("jNvWi", function(module, exports) {

var $4OiF0 = parcelRequire("4OiF0");
var $e69b5e65e6c3acec$require$Buffer = $4OiF0.Buffer;
var $e69b5e65e6c3acec$var$ZEROES = $e69b5e65e6c3acec$require$Buffer.alloc(16, 0);
function $e69b5e65e6c3acec$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $e69b5e65e6c3acec$var$fromArray(out) {
    var buf = $e69b5e65e6c3acec$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $e69b5e65e6c3acec$var$GHASH(key) {
    this.h = key;
    this.state = $e69b5e65e6c3acec$require$Buffer.alloc(16, 0);
    this.cache = $e69b5e65e6c3acec$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$e69b5e65e6c3acec$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$e69b5e65e6c3acec$var$GHASH.prototype._multiply = function() {
    var Vi = $e69b5e65e6c3acec$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $e69b5e65e6c3acec$var$fromArray(Zi);
};
$e69b5e65e6c3acec$var$GHASH.prototype.update = function(buf) {
    this.cache = $e69b5e65e6c3acec$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$e69b5e65e6c3acec$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($e69b5e65e6c3acec$require$Buffer.concat([
        this.cache,
        $e69b5e65e6c3acec$var$ZEROES
    ], 16));
    this.ghash($e69b5e65e6c3acec$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $e69b5e65e6c3acec$var$GHASH;

});


parcelRegister("jwQyu", function(module, exports) {

var $1eFE8 = parcelRequire("1eFE8");

var $4OiF0 = parcelRequire("4OiF0");
var $e379c5dfc31f4a80$require$Buffer = $4OiF0.Buffer;

var $7fR9R = parcelRequire("7fR9R");

var $bniia = parcelRequire("bniia");
function $e379c5dfc31f4a80$var$StreamCipher(mode, key, iv, decrypt) {
    $7fR9R.call(this);
    this._cipher = new $1eFE8.AES(key);
    this._prev = $e379c5dfc31f4a80$require$Buffer.from(iv);
    this._cache = $e379c5dfc31f4a80$require$Buffer.allocUnsafe(0);
    this._secCache = $e379c5dfc31f4a80$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$bniia($e379c5dfc31f4a80$var$StreamCipher, $7fR9R);
$e379c5dfc31f4a80$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$e379c5dfc31f4a80$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $e379c5dfc31f4a80$var$StreamCipher;

});

parcelRegister("cthQ7", function(module, exports) {

var $4OiF0 = parcelRequire("4OiF0");
var $9146080923923f80$require$Buffer = $4OiF0.Buffer;

var $eXAjQ = parcelRequire("eXAjQ");
/* eslint-disable camelcase */ function $9146080923923f80$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$9146080923923f80$require$Buffer.isBuffer(password)) password = $9146080923923f80$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$9146080923923f80$require$Buffer.isBuffer(salt)) salt = $9146080923923f80$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $9146080923923f80$require$Buffer.alloc(keyLen);
    var iv = $9146080923923f80$require$Buffer.alloc(ivLen || 0);
    var tmp = $9146080923923f80$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $eXAjQ();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $9146080923923f80$var$EVP_BytesToKey;

});


parcelRegister("iccu4", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $d3f30809b7d49f03$export$12ada9414fbc594c, (v) => $d3f30809b7d49f03$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $d3f30809b7d49f03$export$36b6d6ef312eab39, (v) => $d3f30809b7d49f03$export$36b6d6ef312eab39 = v);
var $d3f30809b7d49f03$export$12ada9414fbc594c;
var $d3f30809b7d49f03$export$36b6d6ef312eab39;

var $1wbtR = parcelRequire("1wbtR");

var $4OiF0 = parcelRequire("4OiF0");
var $d3f30809b7d49f03$require$Buffer = $4OiF0.Buffer;

var $hATs4 = parcelRequire("hATs4");

var $jwQyu = parcelRequire("jwQyu");

var $7fR9R = parcelRequire("7fR9R");

var $1eFE8 = parcelRequire("1eFE8");

var $cthQ7 = parcelRequire("cthQ7");

var $bniia = parcelRequire("bniia");
function $d3f30809b7d49f03$var$Decipher(mode, key, iv) {
    $7fR9R.call(this);
    this._cache = new $d3f30809b7d49f03$var$Splitter();
    this._last = void 0;
    this._cipher = new $1eFE8.AES(key);
    this._prev = $d3f30809b7d49f03$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$bniia($d3f30809b7d49f03$var$Decipher, $7fR9R);
$d3f30809b7d49f03$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $d3f30809b7d49f03$require$Buffer.concat(out);
};
$d3f30809b7d49f03$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $d3f30809b7d49f03$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$d3f30809b7d49f03$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $d3f30809b7d49f03$var$Splitter() {
    this.cache = $d3f30809b7d49f03$require$Buffer.allocUnsafe(0);
}
$d3f30809b7d49f03$var$Splitter.prototype.add = function(data) {
    this.cache = $d3f30809b7d49f03$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$d3f30809b7d49f03$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$d3f30809b7d49f03$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $d3f30809b7d49f03$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $d3f30809b7d49f03$var$createDecipheriv(suite, password, iv) {
    var config = $hATs4[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $d3f30809b7d49f03$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $d3f30809b7d49f03$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $jwQyu(config.module, password, iv, true);
    else if (config.type === 'auth') return new $1wbtR(config.module, password, iv, true);
    return new $d3f30809b7d49f03$var$Decipher(config.module, password, iv);
}
function $d3f30809b7d49f03$var$createDecipher(suite, password) {
    var config = $hATs4[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $cthQ7(password, false, config.key, config.iv);
    return $d3f30809b7d49f03$var$createDecipheriv(suite, keys.key, keys.iv);
}
$d3f30809b7d49f03$export$12ada9414fbc594c = $d3f30809b7d49f03$var$createDecipher;
$d3f30809b7d49f03$export$36b6d6ef312eab39 = $d3f30809b7d49f03$var$createDecipheriv;

});


parcelRegister("lGzCO", function(module, exports) {

$parcel$export(module.exports, "des-ecb", () => $fc9927969185e023$export$116f8a5cee447347, (v) => $fc9927969185e023$export$116f8a5cee447347 = v);
$parcel$export(module.exports, "des-cbc", () => $fc9927969185e023$export$7483c4066bfb7ae9, (v) => $fc9927969185e023$export$7483c4066bfb7ae9 = v);
$parcel$export(module.exports, "des", () => $fc9927969185e023$export$e7a565d2e588bb06, (v) => $fc9927969185e023$export$e7a565d2e588bb06 = v);
$parcel$export(module.exports, "des-ede3-cbc", () => $fc9927969185e023$export$aaa2f54a426f3eb8, (v) => $fc9927969185e023$export$aaa2f54a426f3eb8 = v);
$parcel$export(module.exports, "des3", () => $fc9927969185e023$export$eba20568dde4ada, (v) => $fc9927969185e023$export$eba20568dde4ada = v);
$parcel$export(module.exports, "des-ede3", () => $fc9927969185e023$export$d3b5e5996938f5ae, (v) => $fc9927969185e023$export$d3b5e5996938f5ae = v);
$parcel$export(module.exports, "des-ede-cbc", () => $fc9927969185e023$export$57c08356130bc99b, (v) => $fc9927969185e023$export$57c08356130bc99b = v);
$parcel$export(module.exports, "des-ede", () => $fc9927969185e023$export$c7169791d5c1e65d, (v) => $fc9927969185e023$export$c7169791d5c1e65d = v);
var $fc9927969185e023$export$116f8a5cee447347;
var $fc9927969185e023$export$7483c4066bfb7ae9;
var $fc9927969185e023$export$e7a565d2e588bb06;
var $fc9927969185e023$export$aaa2f54a426f3eb8;
var $fc9927969185e023$export$eba20568dde4ada;
var $fc9927969185e023$export$d3b5e5996938f5ae;
var $fc9927969185e023$export$57c08356130bc99b;
var $fc9927969185e023$export$c7169791d5c1e65d;
$fc9927969185e023$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$fc9927969185e023$export$7483c4066bfb7ae9 = $fc9927969185e023$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$fc9927969185e023$export$aaa2f54a426f3eb8 = $fc9927969185e023$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$fc9927969185e023$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$fc9927969185e023$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$fc9927969185e023$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("9PCF9", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", () => $7286de1bbcec2423$export$971862a2fcb1bb40, (v) => $7286de1bbcec2423$export$971862a2fcb1bb40 = v);
$parcel$export(module.exports, "createDiffieHellmanGroup", () => $7286de1bbcec2423$export$c6ff6a88acbeaf40, (v) => $7286de1bbcec2423$export$c6ff6a88acbeaf40 = v);
$parcel$export(module.exports, "getDiffieHellman", () => $7286de1bbcec2423$export$fdc27893e98845cc, (v) => $7286de1bbcec2423$export$fdc27893e98845cc = v);
$parcel$export(module.exports, "createDiffieHellman", () => $7286de1bbcec2423$export$6671fb9a1323bed, (v) => $7286de1bbcec2423$export$6671fb9a1323bed = v);
$parcel$export(module.exports, "DiffieHellman", () => $7286de1bbcec2423$export$d74daf141a551db, (v) => $7286de1bbcec2423$export$d74daf141a551db = v);
var $7286de1bbcec2423$export$971862a2fcb1bb40;
var $7286de1bbcec2423$export$c6ff6a88acbeaf40;
var $7286de1bbcec2423$export$fdc27893e98845cc;
var $7286de1bbcec2423$export$6671fb9a1323bed;
var $7286de1bbcec2423$export$d74daf141a551db;

var $8UsMN = parcelRequire("8UsMN");
var $7286de1bbcec2423$require$Buffer = $8UsMN.Buffer;

var $fzqD1 = parcelRequire("fzqD1");

var $jBhBo = parcelRequire("jBhBo");

var $8oJEU = parcelRequire("8oJEU");
function $7286de1bbcec2423$var$getDiffieHellman(mod) {
    var prime = new $7286de1bbcec2423$require$Buffer($jBhBo[mod].prime, 'hex');
    var gen = new $7286de1bbcec2423$require$Buffer($jBhBo[mod].gen, 'hex');
    return new $8oJEU(prime, gen);
}
var $7286de1bbcec2423$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $7286de1bbcec2423$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($7286de1bbcec2423$require$Buffer.isBuffer(enc) || $7286de1bbcec2423$var$ENCODINGS[enc] === undefined) return $7286de1bbcec2423$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $7286de1bbcec2423$require$Buffer([
        2
    ]);
    if (!$7286de1bbcec2423$require$Buffer.isBuffer(generator)) generator = new $7286de1bbcec2423$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $8oJEU($fzqD1(prime, generator), generator, true);
    if (!$7286de1bbcec2423$require$Buffer.isBuffer(prime)) prime = new $7286de1bbcec2423$require$Buffer(prime, enc);
    return new $8oJEU(prime, generator, true);
}
$7286de1bbcec2423$export$971862a2fcb1bb40 = $7286de1bbcec2423$export$c6ff6a88acbeaf40 = $7286de1bbcec2423$export$fdc27893e98845cc = $7286de1bbcec2423$var$getDiffieHellman;
$7286de1bbcec2423$export$6671fb9a1323bed = $7286de1bbcec2423$export$d74daf141a551db = $7286de1bbcec2423$var$createDiffieHellman;

});
parcelRegister("fzqD1", function(module, exports) {

var $bUSoq = parcelRequire("bUSoq");
module.exports = $b55ec7c08a8064ca$var$findPrime;
$b55ec7c08a8064ca$var$findPrime.simpleSieve = $b55ec7c08a8064ca$var$simpleSieve;
$b55ec7c08a8064ca$var$findPrime.fermatTest = $b55ec7c08a8064ca$var$fermatTest;

var $edZn3 = parcelRequire("edZn3");
var $b55ec7c08a8064ca$var$TWENTYFOUR = new $edZn3(24);

var $TFXOD = parcelRequire("TFXOD");
var $b55ec7c08a8064ca$var$millerRabin = new $TFXOD();
var $b55ec7c08a8064ca$var$ONE = new $edZn3(1);
var $b55ec7c08a8064ca$var$TWO = new $edZn3(2);
var $b55ec7c08a8064ca$var$FIVE = new $edZn3(5);
var $b55ec7c08a8064ca$var$SIXTEEN = new $edZn3(16);
var $b55ec7c08a8064ca$var$EIGHT = new $edZn3(8);
var $b55ec7c08a8064ca$var$TEN = new $edZn3(10);
var $b55ec7c08a8064ca$var$THREE = new $edZn3(3);
var $b55ec7c08a8064ca$var$SEVEN = new $edZn3(7);
var $b55ec7c08a8064ca$var$ELEVEN = new $edZn3(11);
var $b55ec7c08a8064ca$var$FOUR = new $edZn3(4);
var $b55ec7c08a8064ca$var$TWELVE = new $edZn3(12);
var $b55ec7c08a8064ca$var$primes = null;
function $b55ec7c08a8064ca$var$_getPrimes() {
    if ($b55ec7c08a8064ca$var$primes !== null) return $b55ec7c08a8064ca$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $b55ec7c08a8064ca$var$primes = res;
    return res;
}
function $b55ec7c08a8064ca$var$simpleSieve(p) {
    var primes = $b55ec7c08a8064ca$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $b55ec7c08a8064ca$var$fermatTest(p) {
    var red = $edZn3.mont(p);
    return $b55ec7c08a8064ca$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $b55ec7c08a8064ca$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $edZn3([
            0x8c,
            0x7b
        ]);
        else return new $edZn3([
            0x8c,
            0x27
        ]);
    }
    gen = new $edZn3(gen);
    var num, n2;
    while(true){
        num = new $edZn3($bUSoq(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($b55ec7c08a8064ca$var$ONE);
        if (!num.testn(1)) num.iadd($b55ec7c08a8064ca$var$TWO);
        if (!gen.cmp($b55ec7c08a8064ca$var$TWO)) while(num.mod($b55ec7c08a8064ca$var$TWENTYFOUR).cmp($b55ec7c08a8064ca$var$ELEVEN))num.iadd($b55ec7c08a8064ca$var$FOUR);
        else if (!gen.cmp($b55ec7c08a8064ca$var$FIVE)) while(num.mod($b55ec7c08a8064ca$var$TEN).cmp($b55ec7c08a8064ca$var$THREE))num.iadd($b55ec7c08a8064ca$var$FOUR);
        n2 = num.shrn(1);
        if ($b55ec7c08a8064ca$var$simpleSieve(n2) && $b55ec7c08a8064ca$var$simpleSieve(num) && $b55ec7c08a8064ca$var$fermatTest(n2) && $b55ec7c08a8064ca$var$fermatTest(num) && $b55ec7c08a8064ca$var$millerRabin.test(n2) && $b55ec7c08a8064ca$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("edZn3", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("66yC2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("TFXOD", function(module, exports) {

var $2IoDw = parcelRequire("2IoDw");

var $9m54X = parcelRequire("9m54X");
function $0a75b04ca74e1302$var$MillerRabin(rand) {
    this.rand = rand || new $9m54X.Rand();
}
module.exports = $0a75b04ca74e1302$var$MillerRabin;
$0a75b04ca74e1302$var$MillerRabin.create = function create(rand) {
    return new $0a75b04ca74e1302$var$MillerRabin(rand);
};
$0a75b04ca74e1302$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $2IoDw(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$0a75b04ca74e1302$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$0a75b04ca74e1302$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $2IoDw.mont(n);
    var rone = new $2IoDw(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $2IoDw(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$0a75b04ca74e1302$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $2IoDw.mont(n);
    var rone = new $2IoDw(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $2IoDw(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("2IoDw", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("66yC2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9m54X", function(module, exports) {
var $6cfa1bb523150d5d$var$r;
module.exports = function rand(len) {
    if (!$6cfa1bb523150d5d$var$r) $6cfa1bb523150d5d$var$r = new $6cfa1bb523150d5d$var$Rand(null);
    return $6cfa1bb523150d5d$var$r.generate(len);
};
function $6cfa1bb523150d5d$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $6cfa1bb523150d5d$var$Rand;
$6cfa1bb523150d5d$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$6cfa1bb523150d5d$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $6cfa1bb523150d5d$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $6cfa1bb523150d5d$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $6cfa1bb523150d5d$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $6cfa1bb523150d5d$var$crypto = (parcelRequire("66yC2"));
    if (typeof $6cfa1bb523150d5d$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $6cfa1bb523150d5d$var$Rand.prototype._rand = function _rand(n) {
        return $6cfa1bb523150d5d$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("jBhBo", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("8oJEU", function(module, exports) {

var $8UsMN = parcelRequire("8UsMN");
var $61d3fb85c1a4b899$require$Buffer = $8UsMN.Buffer;

var $edZn3 = parcelRequire("edZn3");

var $TFXOD = parcelRequire("TFXOD");
var $61d3fb85c1a4b899$var$millerRabin = new $TFXOD();
var $61d3fb85c1a4b899$var$TWENTYFOUR = new $edZn3(24);
var $61d3fb85c1a4b899$var$ELEVEN = new $edZn3(11);
var $61d3fb85c1a4b899$var$TEN = new $edZn3(10);
var $61d3fb85c1a4b899$var$THREE = new $edZn3(3);
var $61d3fb85c1a4b899$var$SEVEN = new $edZn3(7);

var $fzqD1 = parcelRequire("fzqD1");

var $bUSoq = parcelRequire("bUSoq");
module.exports = $61d3fb85c1a4b899$var$DH;
function $61d3fb85c1a4b899$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$61d3fb85c1a4b899$require$Buffer.isBuffer(pub)) pub = new $61d3fb85c1a4b899$require$Buffer(pub, enc);
    this._pub = new $edZn3(pub);
    return this;
}
function $61d3fb85c1a4b899$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$61d3fb85c1a4b899$require$Buffer.isBuffer(priv)) priv = new $61d3fb85c1a4b899$require$Buffer(priv, enc);
    this._priv = new $edZn3(priv);
    return this;
}
var $61d3fb85c1a4b899$var$primeCache = {};
function $61d3fb85c1a4b899$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $61d3fb85c1a4b899$var$primeCache) return $61d3fb85c1a4b899$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$fzqD1.simpleSieve || !$fzqD1.fermatTest(prime) || !$61d3fb85c1a4b899$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $61d3fb85c1a4b899$var$primeCache[hex] = error;
        return error;
    }
    if (!$61d3fb85c1a4b899$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($61d3fb85c1a4b899$var$TWENTYFOUR).cmp($61d3fb85c1a4b899$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($61d3fb85c1a4b899$var$TEN);
            if (rem.cmp($61d3fb85c1a4b899$var$THREE) && rem.cmp($61d3fb85c1a4b899$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $61d3fb85c1a4b899$var$primeCache[hex] = error;
    return error;
}
function $61d3fb85c1a4b899$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $edZn3(prime);
    this._prime = $edZn3.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $61d3fb85c1a4b899$var$setPublicKey;
        this.setPrivateKey = $61d3fb85c1a4b899$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($61d3fb85c1a4b899$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $61d3fb85c1a4b899$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$61d3fb85c1a4b899$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $edZn3($bUSoq(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$61d3fb85c1a4b899$var$DH.prototype.computeSecret = function(other) {
    other = new $edZn3(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $61d3fb85c1a4b899$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $61d3fb85c1a4b899$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $61d3fb85c1a4b899$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$61d3fb85c1a4b899$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $61d3fb85c1a4b899$var$formatReturnValue(this._pub, enc);
};
$61d3fb85c1a4b899$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $61d3fb85c1a4b899$var$formatReturnValue(this._priv, enc);
};
$61d3fb85c1a4b899$var$DH.prototype.getPrime = function(enc) {
    return $61d3fb85c1a4b899$var$formatReturnValue(this.__prime, enc);
};
$61d3fb85c1a4b899$var$DH.prototype.getGenerator = function(enc) {
    return $61d3fb85c1a4b899$var$formatReturnValue(this._gen, enc);
};
$61d3fb85c1a4b899$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$61d3fb85c1a4b899$require$Buffer.isBuffer(gen)) gen = new $61d3fb85c1a4b899$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $edZn3(gen);
    return this;
};
function $61d3fb85c1a4b899$var$formatReturnValue(bn, enc) {
    var buf = new $61d3fb85c1a4b899$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("2qrhF", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $1c432c82e81c9204$require$Buffer = $4OiF0.Buffer;

var $dHvdJ = parcelRequire("dHvdJ");

var $95soA = parcelRequire("95soA");

var $bniia = parcelRequire("bniia");

var $5lPkG = parcelRequire("5lPkG");

var $9J4Jv = parcelRequire("9J4Jv");

var $6rTx5 = parcelRequire("6rTx5");
Object.keys($6rTx5).forEach(function(key) {
    $6rTx5[key].id = $1c432c82e81c9204$require$Buffer.from($6rTx5[key].id, 'hex');
    $6rTx5[key.toLowerCase()] = $6rTx5[key];
});
function $1c432c82e81c9204$var$Sign(algorithm) {
    $95soA.Writable.call(this);
    var data = $6rTx5[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $dHvdJ(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$bniia($1c432c82e81c9204$var$Sign, $95soA.Writable);
$1c432c82e81c9204$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$1c432c82e81c9204$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $1c432c82e81c9204$require$Buffer.from(data, enc) : data);
    return this;
};
$1c432c82e81c9204$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $5lPkG(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $1c432c82e81c9204$var$Verify(algorithm) {
    $95soA.Writable.call(this);
    var data = $6rTx5[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $dHvdJ(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$bniia($1c432c82e81c9204$var$Verify, $95soA.Writable);
$1c432c82e81c9204$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$1c432c82e81c9204$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $1c432c82e81c9204$require$Buffer.from(data, enc) : data);
    return this;
};
$1c432c82e81c9204$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $1c432c82e81c9204$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $9J4Jv(sigBuffer, hash, key, this._signType, this._tag);
};
function $1c432c82e81c9204$var$createSign(algorithm) {
    return new $1c432c82e81c9204$var$Sign(algorithm);
}
function $1c432c82e81c9204$var$createVerify(algorithm) {
    return new $1c432c82e81c9204$var$Verify(algorithm);
}
module.exports = {
    Sign: $1c432c82e81c9204$var$createSign,
    Verify: $1c432c82e81c9204$var$createVerify,
    createSign: $1c432c82e81c9204$var$createSign,
    createVerify: $1c432c82e81c9204$var$createVerify
};

});
parcelRegister("5lPkG", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $3e56bb800abcdecf$require$Buffer = $4OiF0.Buffer;

var $arZPn = parcelRequire("arZPn");

var $aHKJP = parcelRequire("aHKJP");

var $ikIB9 = parcelRequire("ikIB9");
var $3e56bb800abcdecf$require$EC = $ikIB9.ec;

var $7ww61 = parcelRequire("7ww61");

var $eOlL6 = parcelRequire("eOlL6");

var $6YO51 = parcelRequire("6YO51");
var $3e56bb800abcdecf$var$RSA_PKCS1_PADDING = 1;
function $3e56bb800abcdecf$var$sign(hash, key, hashType, signType, tag) {
    var priv = $eOlL6(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $3e56bb800abcdecf$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $3e56bb800abcdecf$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $3e56bb800abcdecf$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $3e56bb800abcdecf$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $aHKJP(pad, priv);
    return out;
}
function $3e56bb800abcdecf$var$ecSign(hash, priv) {
    var curveId = $6YO51[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $3e56bb800abcdecf$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $3e56bb800abcdecf$require$Buffer.from(out.toDER());
}
function $3e56bb800abcdecf$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $7ww61(0);
    var k;
    var H = $3e56bb800abcdecf$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $3e56bb800abcdecf$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $3e56bb800abcdecf$var$makeKey(q, kv, algo);
        r = $3e56bb800abcdecf$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $7ww61(0);
        }
    }
    return $3e56bb800abcdecf$var$toDER(r, s);
}
function $3e56bb800abcdecf$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $3e56bb800abcdecf$require$Buffer.from(res);
}
function $3e56bb800abcdecf$var$getKey(x, q, hash, algo) {
    x = $3e56bb800abcdecf$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $3e56bb800abcdecf$require$Buffer.alloc(q.byteLength() - x.length);
        x = $3e56bb800abcdecf$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $3e56bb800abcdecf$var$bits2octets(hash, q);
    var v = $3e56bb800abcdecf$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $3e56bb800abcdecf$require$Buffer.alloc(hlen);
    k = $arZPn(algo, k).update(v).update($3e56bb800abcdecf$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $arZPn(algo, k).update(v).digest();
    k = $arZPn(algo, k).update(v).update($3e56bb800abcdecf$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $arZPn(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $3e56bb800abcdecf$var$bits2int(obits, q) {
    var bits = new $7ww61(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $3e56bb800abcdecf$var$bits2octets(bits, q) {
    bits = $3e56bb800abcdecf$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $3e56bb800abcdecf$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $3e56bb800abcdecf$require$Buffer.alloc(q.byteLength() - out.length);
        out = $3e56bb800abcdecf$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $3e56bb800abcdecf$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $3e56bb800abcdecf$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $arZPn(algo, kv.k).update(kv.v).digest();
            t = $3e56bb800abcdecf$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $3e56bb800abcdecf$var$bits2int(t, q);
        kv.k = $arZPn(algo, kv.k).update(kv.v).update($3e56bb800abcdecf$require$Buffer.from([
            0
        ])).digest();
        kv.v = $arZPn(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $3e56bb800abcdecf$var$makeR(g, k, p, q) {
    return g.toRed($7ww61.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $3e56bb800abcdecf$var$sign;
module.exports.getKey = $3e56bb800abcdecf$var$getKey;
module.exports.makeKey = $3e56bb800abcdecf$var$makeKey;

});
parcelRegister("aHKJP", function(module, exports) {
'use strict';

var $7ww61 = parcelRequire("7ww61");

var $bUSoq = parcelRequire("bUSoq");

var $4OiF0 = parcelRequire("4OiF0");
var $7cb22cc547a9a105$require$Buffer = $4OiF0.Buffer;
function $7cb22cc547a9a105$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $7ww61($bUSoq(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $7cb22cc547a9a105$var$blind(priv) {
    var r = $7cb22cc547a9a105$var$getr(priv);
    var blinder = r.toRed($7ww61.mont(priv.modulus)).redPow(new $7ww61(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $7cb22cc547a9a105$var$crt(msg, priv) {
    var blinds = $7cb22cc547a9a105$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $7ww61(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($7ww61.mont(priv.prime1));
    var c2 = blinded.toRed($7ww61.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($7cb22cc547a9a105$require$Buffer, 'be', len);
}
$7cb22cc547a9a105$var$crt.getr = $7cb22cc547a9a105$var$getr;
module.exports = $7cb22cc547a9a105$var$crt;

});
parcelRegister("7ww61", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("66yC2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("ikIB9", function(module, exports) {
'use strict';
var $d58cb088a719219c$var$elliptic = module.exports;

$d58cb088a719219c$var$elliptic.version = (parcelRequire("5JwsX")).version;

$d58cb088a719219c$var$elliptic.utils = (parcelRequire("fpVz9"));

$d58cb088a719219c$var$elliptic.rand = (parcelRequire("9m54X"));

$d58cb088a719219c$var$elliptic.curve = (parcelRequire("9N9oN"));

$d58cb088a719219c$var$elliptic.curves = (parcelRequire("ch9s3"));

// Protocols
$d58cb088a719219c$var$elliptic.ec = (parcelRequire("2XALJ"));

$d58cb088a719219c$var$elliptic.eddsa = (parcelRequire("aNhbj"));

});
parcelRegister("5JwsX", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("fpVz9", function(module, exports) {
'use strict';
var $b395d83880f8fd8e$var$utils = module.exports;

var $7ceHy = parcelRequire("7ceHy");

var $bNW2d = parcelRequire("bNW2d");

var $am8t0 = parcelRequire("am8t0");
$b395d83880f8fd8e$var$utils.assert = $bNW2d;
$b395d83880f8fd8e$var$utils.toArray = $am8t0.toArray;
$b395d83880f8fd8e$var$utils.zero2 = $am8t0.zero2;
$b395d83880f8fd8e$var$utils.toHex = $am8t0.toHex;
$b395d83880f8fd8e$var$utils.encode = $am8t0.encode;
// Represent num in a w-NAF form
function $b395d83880f8fd8e$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$b395d83880f8fd8e$var$utils.getNAF = $b395d83880f8fd8e$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $b395d83880f8fd8e$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$b395d83880f8fd8e$var$utils.getJSF = $b395d83880f8fd8e$var$getJSF;
function $b395d83880f8fd8e$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$b395d83880f8fd8e$var$utils.cachedProperty = $b395d83880f8fd8e$var$cachedProperty;
function $b395d83880f8fd8e$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $b395d83880f8fd8e$var$utils.toArray(bytes, 'hex') : bytes;
}
$b395d83880f8fd8e$var$utils.parseBytes = $b395d83880f8fd8e$var$parseBytes;
function $b395d83880f8fd8e$var$intFromLE(bytes) {
    return new $7ceHy(bytes, 'hex', 'le');
}
$b395d83880f8fd8e$var$utils.intFromLE = $b395d83880f8fd8e$var$intFromLE;

});
parcelRegister("7ceHy", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("66yC2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("am8t0", function(module, exports) {
'use strict';
var $78a286c5c0af1869$var$utils = module.exports;
function $78a286c5c0af1869$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$78a286c5c0af1869$var$utils.toArray = $78a286c5c0af1869$var$toArray;
function $78a286c5c0af1869$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$78a286c5c0af1869$var$utils.zero2 = $78a286c5c0af1869$var$zero2;
function $78a286c5c0af1869$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $78a286c5c0af1869$var$zero2(msg[i].toString(16));
    return res;
}
$78a286c5c0af1869$var$utils.toHex = $78a286c5c0af1869$var$toHex;
$78a286c5c0af1869$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $78a286c5c0af1869$var$toHex(arr);
    else return arr;
};

});


parcelRegister("9N9oN", function(module, exports) {
'use strict';
var $720ffb1d5b6a5141$var$curve = module.exports;

$720ffb1d5b6a5141$var$curve.base = (parcelRequire("5O5VQ"));

$720ffb1d5b6a5141$var$curve.short = (parcelRequire("9ZaPg"));

$720ffb1d5b6a5141$var$curve.mont = (parcelRequire("a8wOD"));

$720ffb1d5b6a5141$var$curve.edwards = (parcelRequire("8OnvZ"));

});
parcelRegister("5O5VQ", function(module, exports) {
'use strict';

var $7ceHy = parcelRequire("7ceHy");

var $fpVz9 = parcelRequire("fpVz9");
var $43a6393f963dadca$var$getNAF = $fpVz9.getNAF;
var $43a6393f963dadca$var$getJSF = $fpVz9.getJSF;
var $43a6393f963dadca$var$assert = $fpVz9.assert;
function $43a6393f963dadca$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7ceHy(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7ceHy.red(conf.prime) : $7ceHy.mont(this.p);
    // Useful for many curves
    this.zero = new $7ceHy(0).toRed(this.red);
    this.one = new $7ceHy(1).toRed(this.red);
    this.two = new $7ceHy(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7ceHy(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $43a6393f963dadca$var$BaseCurve;
$43a6393f963dadca$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$43a6393f963dadca$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$43a6393f963dadca$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $43a6393f963dadca$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $43a6393f963dadca$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$43a6393f963dadca$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $43a6393f963dadca$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $43a6393f963dadca$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$43a6393f963dadca$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $43a6393f963dadca$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $43a6393f963dadca$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $43a6393f963dadca$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $43a6393f963dadca$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$43a6393f963dadca$var$BaseCurve.BasePoint = $43a6393f963dadca$var$BasePoint;
$43a6393f963dadca$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$43a6393f963dadca$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$43a6393f963dadca$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $fpVz9.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $43a6393f963dadca$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $43a6393f963dadca$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$43a6393f963dadca$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$43a6393f963dadca$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$43a6393f963dadca$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $fpVz9.encode(this._encode(compact), enc);
};
$43a6393f963dadca$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$43a6393f963dadca$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$43a6393f963dadca$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$43a6393f963dadca$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$43a6393f963dadca$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$43a6393f963dadca$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("9ZaPg", function(module, exports) {
'use strict';

var $fpVz9 = parcelRequire("fpVz9");

var $7ceHy = parcelRequire("7ceHy");

var $bniia = parcelRequire("bniia");

var $5O5VQ = parcelRequire("5O5VQ");
var $74523554e19eddbe$var$assert = $fpVz9.assert;
function $74523554e19eddbe$var$ShortCurve(conf) {
    $5O5VQ.call(this, 'short', conf);
    this.a = new $7ceHy(conf.a, 16).toRed(this.red);
    this.b = new $7ceHy(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$bniia($74523554e19eddbe$var$ShortCurve, $5O5VQ);
module.exports = $74523554e19eddbe$var$ShortCurve;
$74523554e19eddbe$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7ceHy(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7ceHy(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $74523554e19eddbe$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7ceHy(vec.a, 16),
            b: new $7ceHy(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$74523554e19eddbe$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7ceHy.mont(num);
    var tinv = new $7ceHy(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7ceHy(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$74523554e19eddbe$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7ceHy(1);
    var y1 = new $7ceHy(0);
    var x2 = new $7ceHy(0);
    var y2 = new $7ceHy(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$74523554e19eddbe$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$74523554e19eddbe$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7ceHy(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$74523554e19eddbe$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$74523554e19eddbe$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $74523554e19eddbe$var$Point(curve, x, y, isRed) {
    $5O5VQ.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7ceHy(x, 16);
        this.y = new $7ceHy(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$bniia($74523554e19eddbe$var$Point, $5O5VQ.BasePoint);
$74523554e19eddbe$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $74523554e19eddbe$var$Point(this, x, y, isRed);
};
$74523554e19eddbe$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $74523554e19eddbe$var$Point.fromJSON(this, obj, red);
};
$74523554e19eddbe$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$74523554e19eddbe$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$74523554e19eddbe$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$74523554e19eddbe$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$74523554e19eddbe$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$74523554e19eddbe$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$74523554e19eddbe$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$74523554e19eddbe$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$74523554e19eddbe$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$74523554e19eddbe$var$Point.prototype.mul = function mul(k) {
    k = new $7ceHy(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$74523554e19eddbe$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$74523554e19eddbe$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$74523554e19eddbe$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$74523554e19eddbe$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$74523554e19eddbe$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $74523554e19eddbe$var$JPoint(curve, x, y, z) {
    $5O5VQ.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7ceHy(0);
    } else {
        this.x = new $7ceHy(x, 16);
        this.y = new $7ceHy(y, 16);
        this.z = new $7ceHy(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$bniia($74523554e19eddbe$var$JPoint, $5O5VQ.BasePoint);
$74523554e19eddbe$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $74523554e19eddbe$var$JPoint(this, x, y, z);
};
$74523554e19eddbe$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$74523554e19eddbe$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$74523554e19eddbe$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$74523554e19eddbe$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$74523554e19eddbe$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$74523554e19eddbe$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$74523554e19eddbe$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$74523554e19eddbe$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$74523554e19eddbe$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$74523554e19eddbe$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$74523554e19eddbe$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7ceHy(k, kbase);
    return this.curve._wnafMul(this, k);
};
$74523554e19eddbe$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$74523554e19eddbe$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$74523554e19eddbe$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$74523554e19eddbe$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("a8wOD", function(module, exports) {
'use strict';

var $7ceHy = parcelRequire("7ceHy");

var $bniia = parcelRequire("bniia");

var $5O5VQ = parcelRequire("5O5VQ");

var $fpVz9 = parcelRequire("fpVz9");
function $76141b402d6093ab$var$MontCurve(conf) {
    $5O5VQ.call(this, 'mont', conf);
    this.a = new $7ceHy(conf.a, 16).toRed(this.red);
    this.b = new $7ceHy(conf.b, 16).toRed(this.red);
    this.i4 = new $7ceHy(4).toRed(this.red).redInvm();
    this.two = new $7ceHy(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$bniia($76141b402d6093ab$var$MontCurve, $5O5VQ);
module.exports = $76141b402d6093ab$var$MontCurve;
$76141b402d6093ab$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $76141b402d6093ab$var$Point(curve, x, z) {
    $5O5VQ.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7ceHy(x, 16);
        this.z = new $7ceHy(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$bniia($76141b402d6093ab$var$Point, $5O5VQ.BasePoint);
$76141b402d6093ab$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($fpVz9.toArray(bytes, enc), 1);
};
$76141b402d6093ab$var$MontCurve.prototype.point = function point(x, z) {
    return new $76141b402d6093ab$var$Point(this, x, z);
};
$76141b402d6093ab$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $76141b402d6093ab$var$Point.fromJSON(this, obj);
};
$76141b402d6093ab$var$Point.prototype.precompute = function precompute() {
// No-op
};
$76141b402d6093ab$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$76141b402d6093ab$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $76141b402d6093ab$var$Point(curve, obj[0], obj[1] || curve.one);
};
$76141b402d6093ab$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$76141b402d6093ab$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$76141b402d6093ab$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$76141b402d6093ab$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$76141b402d6093ab$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$76141b402d6093ab$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$76141b402d6093ab$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$76141b402d6093ab$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$76141b402d6093ab$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$76141b402d6093ab$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$76141b402d6093ab$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("8OnvZ", function(module, exports) {
'use strict';

var $fpVz9 = parcelRequire("fpVz9");

var $7ceHy = parcelRequire("7ceHy");

var $bniia = parcelRequire("bniia");

var $5O5VQ = parcelRequire("5O5VQ");
var $66a53bd35555c492$var$assert = $fpVz9.assert;
function $66a53bd35555c492$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $5O5VQ.call(this, 'edwards', conf);
    this.a = new $7ceHy(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7ceHy(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7ceHy(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $66a53bd35555c492$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$bniia($66a53bd35555c492$var$EdwardsCurve, $5O5VQ);
module.exports = $66a53bd35555c492$var$EdwardsCurve;
$66a53bd35555c492$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$66a53bd35555c492$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$66a53bd35555c492$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$66a53bd35555c492$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7ceHy(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$66a53bd35555c492$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7ceHy(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$66a53bd35555c492$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $66a53bd35555c492$var$Point(curve, x, y, z, t) {
    $5O5VQ.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7ceHy(x, 16);
        this.y = new $7ceHy(y, 16);
        this.z = z ? new $7ceHy(z, 16) : this.curve.one;
        this.t = t && new $7ceHy(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$bniia($66a53bd35555c492$var$Point, $5O5VQ.BasePoint);
$66a53bd35555c492$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $66a53bd35555c492$var$Point.fromJSON(this, obj);
};
$66a53bd35555c492$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $66a53bd35555c492$var$Point(this, x, y, z, t);
};
$66a53bd35555c492$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $66a53bd35555c492$var$Point(curve, obj[0], obj[1], obj[2]);
};
$66a53bd35555c492$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$66a53bd35555c492$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$66a53bd35555c492$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$66a53bd35555c492$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$66a53bd35555c492$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$66a53bd35555c492$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$66a53bd35555c492$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$66a53bd35555c492$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$66a53bd35555c492$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$66a53bd35555c492$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$66a53bd35555c492$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$66a53bd35555c492$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$66a53bd35555c492$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$66a53bd35555c492$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$66a53bd35555c492$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$66a53bd35555c492$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$66a53bd35555c492$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$66a53bd35555c492$var$Point.prototype.toP = $66a53bd35555c492$var$Point.prototype.normalize;
$66a53bd35555c492$var$Point.prototype.mixedAdd = $66a53bd35555c492$var$Point.prototype.add;

});


parcelRegister("ch9s3", function(module, exports) {
'use strict';
var $8efe676f0c98e244$var$curves = module.exports;

var $d8iRl = parcelRequire("d8iRl");

var $9N9oN = parcelRequire("9N9oN");

var $fpVz9 = parcelRequire("fpVz9");
var $8efe676f0c98e244$var$assert = $fpVz9.assert;
function $8efe676f0c98e244$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $9N9oN.short(options);
    else if (options.type === 'edwards') this.curve = new $9N9oN.edwards(options);
    else this.curve = new $9N9oN.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $8efe676f0c98e244$var$assert(this.g.validate(), 'Invalid curve');
    $8efe676f0c98e244$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$8efe676f0c98e244$var$curves.PresetCurve = $8efe676f0c98e244$var$PresetCurve;
function $8efe676f0c98e244$var$defineCurve(name, options) {
    Object.defineProperty($8efe676f0c98e244$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $8efe676f0c98e244$var$PresetCurve(options);
            Object.defineProperty($8efe676f0c98e244$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$8efe676f0c98e244$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $d8iRl.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$8efe676f0c98e244$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $d8iRl.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$8efe676f0c98e244$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $d8iRl.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$8efe676f0c98e244$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $d8iRl.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$8efe676f0c98e244$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $d8iRl.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$8efe676f0c98e244$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $d8iRl.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$8efe676f0c98e244$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $d8iRl.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $8efe676f0c98e244$var$pre;

try {
    $8efe676f0c98e244$var$pre = (parcelRequire("eh5tQ"));
} catch (e) {
    $8efe676f0c98e244$var$pre = undefined;
}
$8efe676f0c98e244$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $d8iRl.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $8efe676f0c98e244$var$pre
    ]
});

});
parcelRegister("d8iRl", function(module, exports) {
var $98faa6c93590bcaa$var$hash = module.exports;

$98faa6c93590bcaa$var$hash.utils = (parcelRequire("5h91W"));

$98faa6c93590bcaa$var$hash.common = (parcelRequire("2uLAh"));

$98faa6c93590bcaa$var$hash.sha = (parcelRequire("e6NW8"));

$98faa6c93590bcaa$var$hash.ripemd = (parcelRequire("4vjbU"));

$98faa6c93590bcaa$var$hash.hmac = (parcelRequire("bzM2M"));
// Proxy hash functions to the main object
$98faa6c93590bcaa$var$hash.sha1 = $98faa6c93590bcaa$var$hash.sha.sha1;
$98faa6c93590bcaa$var$hash.sha256 = $98faa6c93590bcaa$var$hash.sha.sha256;
$98faa6c93590bcaa$var$hash.sha224 = $98faa6c93590bcaa$var$hash.sha.sha224;
$98faa6c93590bcaa$var$hash.sha384 = $98faa6c93590bcaa$var$hash.sha.sha384;
$98faa6c93590bcaa$var$hash.sha512 = $98faa6c93590bcaa$var$hash.sha.sha512;
$98faa6c93590bcaa$var$hash.ripemd160 = $98faa6c93590bcaa$var$hash.ripemd.ripemd160;

});
parcelRegister("5h91W", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $3d758b8404927caf$export$69f1b2dcda23c5f8, (v) => $3d758b8404927caf$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $3d758b8404927caf$export$45b10814cc054894, (v) => $3d758b8404927caf$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $3d758b8404927caf$export$7ea66e3774a60b67, (v) => $3d758b8404927caf$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $3d758b8404927caf$export$34a52f00f601f6f1, (v) => $3d758b8404927caf$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $3d758b8404927caf$export$812b0cbd5e8a72ab, (v) => $3d758b8404927caf$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $3d758b8404927caf$export$f24f9e11d63bb314, (v) => $3d758b8404927caf$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $3d758b8404927caf$export$b71357c7e07ca1f1, (v) => $3d758b8404927caf$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $3d758b8404927caf$export$2e58a4b541fdcbe8, (v) => $3d758b8404927caf$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $3d758b8404927caf$export$183b950bde9faab8, (v) => $3d758b8404927caf$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $3d758b8404927caf$export$4785c77169fea59e, (v) => $3d758b8404927caf$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $3d758b8404927caf$export$242a185dfcffac5b, (v) => $3d758b8404927caf$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $3d758b8404927caf$export$58c04ae0ae31877d, (v) => $3d758b8404927caf$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $3d758b8404927caf$export$d058ca695f8c6f11, (v) => $3d758b8404927caf$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $3d758b8404927caf$export$a1efd7fc3e986367, (v) => $3d758b8404927caf$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $3d758b8404927caf$export$bbfea4a2b5abaab4, (v) => $3d758b8404927caf$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $3d758b8404927caf$export$97ad4afc7de86152, (v) => $3d758b8404927caf$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $3d758b8404927caf$export$ce4673d9a79f6a4b, (v) => $3d758b8404927caf$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $3d758b8404927caf$export$786cc99fc6eedc0b, (v) => $3d758b8404927caf$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $3d758b8404927caf$export$45c59b9a1848dd0, (v) => $3d758b8404927caf$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $3d758b8404927caf$export$50d8f613e76d3034, (v) => $3d758b8404927caf$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $3d758b8404927caf$export$b8e83683c60ee162, (v) => $3d758b8404927caf$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $3d758b8404927caf$export$aeeb51790d1bcc4a, (v) => $3d758b8404927caf$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $3d758b8404927caf$export$bb7c616f719ad9c, (v) => $3d758b8404927caf$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $3d758b8404927caf$export$4d63290824f9d7df, (v) => $3d758b8404927caf$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $3d758b8404927caf$export$2f64ceb90ef28ea1, (v) => $3d758b8404927caf$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $3d758b8404927caf$export$8d2089d465f6d10d, (v) => $3d758b8404927caf$export$8d2089d465f6d10d = v);
var $3d758b8404927caf$export$69f1b2dcda23c5f8;
var $3d758b8404927caf$export$45b10814cc054894;
var $3d758b8404927caf$export$7ea66e3774a60b67;
var $3d758b8404927caf$export$34a52f00f601f6f1;
var $3d758b8404927caf$export$812b0cbd5e8a72ab;
var $3d758b8404927caf$export$f24f9e11d63bb314;
var $3d758b8404927caf$export$b71357c7e07ca1f1;
var $3d758b8404927caf$export$2e58a4b541fdcbe8;
var $3d758b8404927caf$export$183b950bde9faab8;
var $3d758b8404927caf$export$4785c77169fea59e;
var $3d758b8404927caf$export$242a185dfcffac5b;
var $3d758b8404927caf$export$58c04ae0ae31877d;
var $3d758b8404927caf$export$d058ca695f8c6f11;
var $3d758b8404927caf$export$a1efd7fc3e986367;
var $3d758b8404927caf$export$bbfea4a2b5abaab4;
var $3d758b8404927caf$export$97ad4afc7de86152;
var $3d758b8404927caf$export$ce4673d9a79f6a4b;
var $3d758b8404927caf$export$786cc99fc6eedc0b;
var $3d758b8404927caf$export$45c59b9a1848dd0;
var $3d758b8404927caf$export$50d8f613e76d3034;
var $3d758b8404927caf$export$b8e83683c60ee162;
var $3d758b8404927caf$export$aeeb51790d1bcc4a;
var $3d758b8404927caf$export$bb7c616f719ad9c;
var $3d758b8404927caf$export$4d63290824f9d7df;
var $3d758b8404927caf$export$2f64ceb90ef28ea1;
var $3d758b8404927caf$export$8d2089d465f6d10d;
'use strict';

var $bNW2d = parcelRequire("bNW2d");

var $bniia = parcelRequire("bniia");
$3d758b8404927caf$export$69f1b2dcda23c5f8 = $bniia;
function $3d758b8404927caf$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $3d758b8404927caf$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($3d758b8404927caf$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$3d758b8404927caf$export$45b10814cc054894 = $3d758b8404927caf$var$toArray;
function $3d758b8404927caf$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $3d758b8404927caf$var$zero2(msg[i].toString(16));
    return res;
}
$3d758b8404927caf$export$7ea66e3774a60b67 = $3d758b8404927caf$var$toHex;
function $3d758b8404927caf$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$3d758b8404927caf$export$34a52f00f601f6f1 = $3d758b8404927caf$var$htonl;
function $3d758b8404927caf$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $3d758b8404927caf$var$htonl(w);
        res += $3d758b8404927caf$var$zero8(w.toString(16));
    }
    return res;
}
$3d758b8404927caf$export$812b0cbd5e8a72ab = $3d758b8404927caf$var$toHex32;
function $3d758b8404927caf$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$3d758b8404927caf$export$f24f9e11d63bb314 = $3d758b8404927caf$var$zero2;
function $3d758b8404927caf$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$3d758b8404927caf$export$b71357c7e07ca1f1 = $3d758b8404927caf$var$zero8;
function $3d758b8404927caf$var$join32(msg, start, end, endian) {
    var len = end - start;
    $bNW2d(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$3d758b8404927caf$export$2e58a4b541fdcbe8 = $3d758b8404927caf$var$join32;
function $3d758b8404927caf$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$3d758b8404927caf$export$183b950bde9faab8 = $3d758b8404927caf$var$split32;
function $3d758b8404927caf$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$3d758b8404927caf$export$4785c77169fea59e = $3d758b8404927caf$var$rotr32;
function $3d758b8404927caf$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$3d758b8404927caf$export$242a185dfcffac5b = $3d758b8404927caf$var$rotl32;
function $3d758b8404927caf$var$sum32(a, b) {
    return a + b >>> 0;
}
$3d758b8404927caf$export$58c04ae0ae31877d = $3d758b8404927caf$var$sum32;
function $3d758b8404927caf$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$3d758b8404927caf$export$d058ca695f8c6f11 = $3d758b8404927caf$var$sum32_3;
function $3d758b8404927caf$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$3d758b8404927caf$export$a1efd7fc3e986367 = $3d758b8404927caf$var$sum32_4;
function $3d758b8404927caf$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$3d758b8404927caf$export$bbfea4a2b5abaab4 = $3d758b8404927caf$var$sum32_5;
function $3d758b8404927caf$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$3d758b8404927caf$export$97ad4afc7de86152 = $3d758b8404927caf$var$sum64;
function $3d758b8404927caf$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$3d758b8404927caf$export$ce4673d9a79f6a4b = $3d758b8404927caf$var$sum64_hi;
function $3d758b8404927caf$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$3d758b8404927caf$export$786cc99fc6eedc0b = $3d758b8404927caf$var$sum64_lo;
function $3d758b8404927caf$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$3d758b8404927caf$export$45c59b9a1848dd0 = $3d758b8404927caf$var$sum64_4_hi;
function $3d758b8404927caf$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$3d758b8404927caf$export$50d8f613e76d3034 = $3d758b8404927caf$var$sum64_4_lo;
function $3d758b8404927caf$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$3d758b8404927caf$export$b8e83683c60ee162 = $3d758b8404927caf$var$sum64_5_hi;
function $3d758b8404927caf$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$3d758b8404927caf$export$aeeb51790d1bcc4a = $3d758b8404927caf$var$sum64_5_lo;
function $3d758b8404927caf$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$3d758b8404927caf$export$bb7c616f719ad9c = $3d758b8404927caf$var$rotr64_hi;
function $3d758b8404927caf$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3d758b8404927caf$export$4d63290824f9d7df = $3d758b8404927caf$var$rotr64_lo;
function $3d758b8404927caf$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$3d758b8404927caf$export$2f64ceb90ef28ea1 = $3d758b8404927caf$var$shr64_hi;
function $3d758b8404927caf$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$3d758b8404927caf$export$8d2089d465f6d10d = $3d758b8404927caf$var$shr64_lo;

});

parcelRegister("2uLAh", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $1d134b5c7ce49ebf$export$8687658379b577e6, (v) => $1d134b5c7ce49ebf$export$8687658379b577e6 = v);
var $1d134b5c7ce49ebf$export$8687658379b577e6;
'use strict';

var $5h91W = parcelRequire("5h91W");

var $bNW2d = parcelRequire("bNW2d");
function $1d134b5c7ce49ebf$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$1d134b5c7ce49ebf$export$8687658379b577e6 = $1d134b5c7ce49ebf$var$BlockHash;
$1d134b5c7ce49ebf$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $5h91W.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $5h91W.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$1d134b5c7ce49ebf$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $bNW2d(this.pending === null);
    return this._digest(enc);
};
$1d134b5c7ce49ebf$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("e6NW8", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $a4585c9907e68763$export$5091bdda49ba90f5, (v) => $a4585c9907e68763$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $a4585c9907e68763$export$97b70509d4e397ea, (v) => $a4585c9907e68763$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $a4585c9907e68763$export$bced8d2aada2d1c9, (v) => $a4585c9907e68763$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $a4585c9907e68763$export$612d47d55dedde45, (v) => $a4585c9907e68763$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $a4585c9907e68763$export$a888d2532e6dc7bb, (v) => $a4585c9907e68763$export$a888d2532e6dc7bb = v);
var $a4585c9907e68763$export$5091bdda49ba90f5;
var $a4585c9907e68763$export$97b70509d4e397ea;
var $a4585c9907e68763$export$bced8d2aada2d1c9;
var $a4585c9907e68763$export$612d47d55dedde45;
var $a4585c9907e68763$export$a888d2532e6dc7bb;
'use strict';

$a4585c9907e68763$export$5091bdda49ba90f5 = (parcelRequire("8pXku"));

$a4585c9907e68763$export$97b70509d4e397ea = (parcelRequire("9B7hK"));

$a4585c9907e68763$export$bced8d2aada2d1c9 = (parcelRequire("4yK5H"));

$a4585c9907e68763$export$612d47d55dedde45 = (parcelRequire("2xlNG"));

$a4585c9907e68763$export$a888d2532e6dc7bb = (parcelRequire("eQOPn"));

});
parcelRegister("8pXku", function(module, exports) {
'use strict';

var $5h91W = parcelRequire("5h91W");

var $2uLAh = parcelRequire("2uLAh");

var $br9Yg = parcelRequire("br9Yg");
var $620eae2260f4e035$var$rotl32 = $5h91W.rotl32;
var $620eae2260f4e035$var$sum32 = $5h91W.sum32;
var $620eae2260f4e035$var$sum32_5 = $5h91W.sum32_5;
var $620eae2260f4e035$var$ft_1 = $br9Yg.ft_1;
var $620eae2260f4e035$var$BlockHash = $2uLAh.BlockHash;
var $620eae2260f4e035$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $620eae2260f4e035$var$SHA1() {
    if (!(this instanceof $620eae2260f4e035$var$SHA1)) return new $620eae2260f4e035$var$SHA1();
    $620eae2260f4e035$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$5h91W.inherits($620eae2260f4e035$var$SHA1, $620eae2260f4e035$var$BlockHash);
module.exports = $620eae2260f4e035$var$SHA1;
$620eae2260f4e035$var$SHA1.blockSize = 512;
$620eae2260f4e035$var$SHA1.outSize = 160;
$620eae2260f4e035$var$SHA1.hmacStrength = 80;
$620eae2260f4e035$var$SHA1.padLength = 64;
$620eae2260f4e035$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $620eae2260f4e035$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $620eae2260f4e035$var$sum32_5($620eae2260f4e035$var$rotl32(a, 5), $620eae2260f4e035$var$ft_1(s, b, c, d), e, W[i], $620eae2260f4e035$var$sha1_K[s]);
        e = d;
        d = c;
        c = $620eae2260f4e035$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $620eae2260f4e035$var$sum32(this.h[0], a);
    this.h[1] = $620eae2260f4e035$var$sum32(this.h[1], b);
    this.h[2] = $620eae2260f4e035$var$sum32(this.h[2], c);
    this.h[3] = $620eae2260f4e035$var$sum32(this.h[3], d);
    this.h[4] = $620eae2260f4e035$var$sum32(this.h[4], e);
};
$620eae2260f4e035$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5h91W.toHex32(this.h, 'big');
    else return $5h91W.split32(this.h, 'big');
};

});
parcelRegister("br9Yg", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $8539f35a7ad6aa6c$export$5a92649d7ddb9f63, (v) => $8539f35a7ad6aa6c$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $8539f35a7ad6aa6c$export$c6d0d020c3a6269, (v) => $8539f35a7ad6aa6c$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $8539f35a7ad6aa6c$export$eb90c27fca05f956, (v) => $8539f35a7ad6aa6c$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $8539f35a7ad6aa6c$export$14a4a98e063b1999, (v) => $8539f35a7ad6aa6c$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $8539f35a7ad6aa6c$export$d20cecfa1564c686, (v) => $8539f35a7ad6aa6c$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $8539f35a7ad6aa6c$export$44fd472a12fc6db, (v) => $8539f35a7ad6aa6c$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $8539f35a7ad6aa6c$export$1ed238bb6ea1dd47, (v) => $8539f35a7ad6aa6c$export$1ed238bb6ea1dd47 = v);
var $8539f35a7ad6aa6c$export$5a92649d7ddb9f63;
var $8539f35a7ad6aa6c$export$c6d0d020c3a6269;
var $8539f35a7ad6aa6c$export$eb90c27fca05f956;
var $8539f35a7ad6aa6c$export$cc992891a14496a1;
var $8539f35a7ad6aa6c$export$14a4a98e063b1999;
var $8539f35a7ad6aa6c$export$d20cecfa1564c686;
var $8539f35a7ad6aa6c$export$44fd472a12fc6db;
var $8539f35a7ad6aa6c$export$1ed238bb6ea1dd47;
'use strict';

var $5h91W = parcelRequire("5h91W");
var $8539f35a7ad6aa6c$var$rotr32 = $5h91W.rotr32;
function $8539f35a7ad6aa6c$var$ft_1(s, x, y, z) {
    if (s === 0) return $8539f35a7ad6aa6c$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $8539f35a7ad6aa6c$var$p32(x, y, z);
    if (s === 2) return $8539f35a7ad6aa6c$var$maj32(x, y, z);
}
$8539f35a7ad6aa6c$export$5a92649d7ddb9f63 = $8539f35a7ad6aa6c$var$ft_1;
function $8539f35a7ad6aa6c$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$8539f35a7ad6aa6c$export$c6d0d020c3a6269 = $8539f35a7ad6aa6c$var$ch32;
function $8539f35a7ad6aa6c$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$8539f35a7ad6aa6c$export$eb90c27fca05f956 = $8539f35a7ad6aa6c$var$maj32;
function $8539f35a7ad6aa6c$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$8539f35a7ad6aa6c$export$cc992891a14496a1 = $8539f35a7ad6aa6c$var$p32;
function $8539f35a7ad6aa6c$var$s0_256(x) {
    return $8539f35a7ad6aa6c$var$rotr32(x, 2) ^ $8539f35a7ad6aa6c$var$rotr32(x, 13) ^ $8539f35a7ad6aa6c$var$rotr32(x, 22);
}
$8539f35a7ad6aa6c$export$14a4a98e063b1999 = $8539f35a7ad6aa6c$var$s0_256;
function $8539f35a7ad6aa6c$var$s1_256(x) {
    return $8539f35a7ad6aa6c$var$rotr32(x, 6) ^ $8539f35a7ad6aa6c$var$rotr32(x, 11) ^ $8539f35a7ad6aa6c$var$rotr32(x, 25);
}
$8539f35a7ad6aa6c$export$d20cecfa1564c686 = $8539f35a7ad6aa6c$var$s1_256;
function $8539f35a7ad6aa6c$var$g0_256(x) {
    return $8539f35a7ad6aa6c$var$rotr32(x, 7) ^ $8539f35a7ad6aa6c$var$rotr32(x, 18) ^ x >>> 3;
}
$8539f35a7ad6aa6c$export$44fd472a12fc6db = $8539f35a7ad6aa6c$var$g0_256;
function $8539f35a7ad6aa6c$var$g1_256(x) {
    return $8539f35a7ad6aa6c$var$rotr32(x, 17) ^ $8539f35a7ad6aa6c$var$rotr32(x, 19) ^ x >>> 10;
}
$8539f35a7ad6aa6c$export$1ed238bb6ea1dd47 = $8539f35a7ad6aa6c$var$g1_256;

});


parcelRegister("9B7hK", function(module, exports) {
'use strict';

var $5h91W = parcelRequire("5h91W");

var $4yK5H = parcelRequire("4yK5H");
function $6fcd3873c21bc73e$var$SHA224() {
    if (!(this instanceof $6fcd3873c21bc73e$var$SHA224)) return new $6fcd3873c21bc73e$var$SHA224();
    $4yK5H.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$5h91W.inherits($6fcd3873c21bc73e$var$SHA224, $4yK5H);
module.exports = $6fcd3873c21bc73e$var$SHA224;
$6fcd3873c21bc73e$var$SHA224.blockSize = 512;
$6fcd3873c21bc73e$var$SHA224.outSize = 224;
$6fcd3873c21bc73e$var$SHA224.hmacStrength = 192;
$6fcd3873c21bc73e$var$SHA224.padLength = 64;
$6fcd3873c21bc73e$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $5h91W.toHex32(this.h.slice(0, 7), 'big');
    else return $5h91W.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("4yK5H", function(module, exports) {
'use strict';

var $5h91W = parcelRequire("5h91W");

var $2uLAh = parcelRequire("2uLAh");

var $br9Yg = parcelRequire("br9Yg");

var $bNW2d = parcelRequire("bNW2d");
var $351e1716450ee50c$var$sum32 = $5h91W.sum32;
var $351e1716450ee50c$var$sum32_4 = $5h91W.sum32_4;
var $351e1716450ee50c$var$sum32_5 = $5h91W.sum32_5;
var $351e1716450ee50c$var$ch32 = $br9Yg.ch32;
var $351e1716450ee50c$var$maj32 = $br9Yg.maj32;
var $351e1716450ee50c$var$s0_256 = $br9Yg.s0_256;
var $351e1716450ee50c$var$s1_256 = $br9Yg.s1_256;
var $351e1716450ee50c$var$g0_256 = $br9Yg.g0_256;
var $351e1716450ee50c$var$g1_256 = $br9Yg.g1_256;
var $351e1716450ee50c$var$BlockHash = $2uLAh.BlockHash;
var $351e1716450ee50c$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $351e1716450ee50c$var$SHA256() {
    if (!(this instanceof $351e1716450ee50c$var$SHA256)) return new $351e1716450ee50c$var$SHA256();
    $351e1716450ee50c$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $351e1716450ee50c$var$sha256_K;
    this.W = new Array(64);
}
$5h91W.inherits($351e1716450ee50c$var$SHA256, $351e1716450ee50c$var$BlockHash);
module.exports = $351e1716450ee50c$var$SHA256;
$351e1716450ee50c$var$SHA256.blockSize = 512;
$351e1716450ee50c$var$SHA256.outSize = 256;
$351e1716450ee50c$var$SHA256.hmacStrength = 192;
$351e1716450ee50c$var$SHA256.padLength = 64;
$351e1716450ee50c$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $351e1716450ee50c$var$sum32_4($351e1716450ee50c$var$g1_256(W[i - 2]), W[i - 7], $351e1716450ee50c$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $bNW2d(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $351e1716450ee50c$var$sum32_5(h, $351e1716450ee50c$var$s1_256(e), $351e1716450ee50c$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $351e1716450ee50c$var$sum32($351e1716450ee50c$var$s0_256(a), $351e1716450ee50c$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $351e1716450ee50c$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $351e1716450ee50c$var$sum32(T1, T2);
    }
    this.h[0] = $351e1716450ee50c$var$sum32(this.h[0], a);
    this.h[1] = $351e1716450ee50c$var$sum32(this.h[1], b);
    this.h[2] = $351e1716450ee50c$var$sum32(this.h[2], c);
    this.h[3] = $351e1716450ee50c$var$sum32(this.h[3], d);
    this.h[4] = $351e1716450ee50c$var$sum32(this.h[4], e);
    this.h[5] = $351e1716450ee50c$var$sum32(this.h[5], f);
    this.h[6] = $351e1716450ee50c$var$sum32(this.h[6], g);
    this.h[7] = $351e1716450ee50c$var$sum32(this.h[7], h);
};
$351e1716450ee50c$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5h91W.toHex32(this.h, 'big');
    else return $5h91W.split32(this.h, 'big');
};

});


parcelRegister("2xlNG", function(module, exports) {
'use strict';

var $5h91W = parcelRequire("5h91W");

var $eQOPn = parcelRequire("eQOPn");
function $1d8f92ea3901cfd0$var$SHA384() {
    if (!(this instanceof $1d8f92ea3901cfd0$var$SHA384)) return new $1d8f92ea3901cfd0$var$SHA384();
    $eQOPn.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$5h91W.inherits($1d8f92ea3901cfd0$var$SHA384, $eQOPn);
module.exports = $1d8f92ea3901cfd0$var$SHA384;
$1d8f92ea3901cfd0$var$SHA384.blockSize = 1024;
$1d8f92ea3901cfd0$var$SHA384.outSize = 384;
$1d8f92ea3901cfd0$var$SHA384.hmacStrength = 192;
$1d8f92ea3901cfd0$var$SHA384.padLength = 128;
$1d8f92ea3901cfd0$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5h91W.toHex32(this.h.slice(0, 12), 'big');
    else return $5h91W.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("eQOPn", function(module, exports) {
'use strict';

var $5h91W = parcelRequire("5h91W");

var $2uLAh = parcelRequire("2uLAh");

var $bNW2d = parcelRequire("bNW2d");
var $acfd59595aef30e5$var$rotr64_hi = $5h91W.rotr64_hi;
var $acfd59595aef30e5$var$rotr64_lo = $5h91W.rotr64_lo;
var $acfd59595aef30e5$var$shr64_hi = $5h91W.shr64_hi;
var $acfd59595aef30e5$var$shr64_lo = $5h91W.shr64_lo;
var $acfd59595aef30e5$var$sum64 = $5h91W.sum64;
var $acfd59595aef30e5$var$sum64_hi = $5h91W.sum64_hi;
var $acfd59595aef30e5$var$sum64_lo = $5h91W.sum64_lo;
var $acfd59595aef30e5$var$sum64_4_hi = $5h91W.sum64_4_hi;
var $acfd59595aef30e5$var$sum64_4_lo = $5h91W.sum64_4_lo;
var $acfd59595aef30e5$var$sum64_5_hi = $5h91W.sum64_5_hi;
var $acfd59595aef30e5$var$sum64_5_lo = $5h91W.sum64_5_lo;
var $acfd59595aef30e5$var$BlockHash = $2uLAh.BlockHash;
var $acfd59595aef30e5$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $acfd59595aef30e5$var$SHA512() {
    if (!(this instanceof $acfd59595aef30e5$var$SHA512)) return new $acfd59595aef30e5$var$SHA512();
    $acfd59595aef30e5$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $acfd59595aef30e5$var$sha512_K;
    this.W = new Array(160);
}
$5h91W.inherits($acfd59595aef30e5$var$SHA512, $acfd59595aef30e5$var$BlockHash);
module.exports = $acfd59595aef30e5$var$SHA512;
$acfd59595aef30e5$var$SHA512.blockSize = 1024;
$acfd59595aef30e5$var$SHA512.outSize = 512;
$acfd59595aef30e5$var$SHA512.hmacStrength = 192;
$acfd59595aef30e5$var$SHA512.padLength = 128;
$acfd59595aef30e5$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $acfd59595aef30e5$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $acfd59595aef30e5$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $acfd59595aef30e5$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $acfd59595aef30e5$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $acfd59595aef30e5$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $acfd59595aef30e5$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$acfd59595aef30e5$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $bNW2d(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $acfd59595aef30e5$var$s1_512_hi(eh, el);
        var c1_lo = $acfd59595aef30e5$var$s1_512_lo(eh, el);
        var c2_hi = $acfd59595aef30e5$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $acfd59595aef30e5$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $acfd59595aef30e5$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $acfd59595aef30e5$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $acfd59595aef30e5$var$s0_512_hi(ah, al);
        c0_lo = $acfd59595aef30e5$var$s0_512_lo(ah, al);
        c1_hi = $acfd59595aef30e5$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $acfd59595aef30e5$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $acfd59595aef30e5$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $acfd59595aef30e5$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $acfd59595aef30e5$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $acfd59595aef30e5$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $acfd59595aef30e5$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $acfd59595aef30e5$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $acfd59595aef30e5$var$sum64(this.h, 0, ah, al);
    $acfd59595aef30e5$var$sum64(this.h, 2, bh, bl);
    $acfd59595aef30e5$var$sum64(this.h, 4, ch, cl);
    $acfd59595aef30e5$var$sum64(this.h, 6, dh, dl);
    $acfd59595aef30e5$var$sum64(this.h, 8, eh, el);
    $acfd59595aef30e5$var$sum64(this.h, 10, fh, fl);
    $acfd59595aef30e5$var$sum64(this.h, 12, gh, gl);
    $acfd59595aef30e5$var$sum64(this.h, 14, hh, hl);
};
$acfd59595aef30e5$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5h91W.toHex32(this.h, 'big');
    else return $5h91W.split32(this.h, 'big');
};
function $acfd59595aef30e5$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$s0_512_hi(xh, xl) {
    var c0_hi = $acfd59595aef30e5$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $acfd59595aef30e5$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $acfd59595aef30e5$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$s0_512_lo(xh, xl) {
    var c0_lo = $acfd59595aef30e5$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $acfd59595aef30e5$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $acfd59595aef30e5$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$s1_512_hi(xh, xl) {
    var c0_hi = $acfd59595aef30e5$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $acfd59595aef30e5$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $acfd59595aef30e5$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$s1_512_lo(xh, xl) {
    var c0_lo = $acfd59595aef30e5$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $acfd59595aef30e5$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $acfd59595aef30e5$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$g0_512_hi(xh, xl) {
    var c0_hi = $acfd59595aef30e5$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $acfd59595aef30e5$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $acfd59595aef30e5$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$g0_512_lo(xh, xl) {
    var c0_lo = $acfd59595aef30e5$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $acfd59595aef30e5$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $acfd59595aef30e5$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$g1_512_hi(xh, xl) {
    var c0_hi = $acfd59595aef30e5$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $acfd59595aef30e5$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $acfd59595aef30e5$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $acfd59595aef30e5$var$g1_512_lo(xh, xl) {
    var c0_lo = $acfd59595aef30e5$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $acfd59595aef30e5$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $acfd59595aef30e5$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("4vjbU", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $3478f1a068efe73f$export$d1cea0ee4e3f0d3e, (v) => $3478f1a068efe73f$export$d1cea0ee4e3f0d3e = v);
var $3478f1a068efe73f$export$d1cea0ee4e3f0d3e;
'use strict';

var $5h91W = parcelRequire("5h91W");

var $2uLAh = parcelRequire("2uLAh");
var $3478f1a068efe73f$var$rotl32 = $5h91W.rotl32;
var $3478f1a068efe73f$var$sum32 = $5h91W.sum32;
var $3478f1a068efe73f$var$sum32_3 = $5h91W.sum32_3;
var $3478f1a068efe73f$var$sum32_4 = $5h91W.sum32_4;
var $3478f1a068efe73f$var$BlockHash = $2uLAh.BlockHash;
function $3478f1a068efe73f$var$RIPEMD160() {
    if (!(this instanceof $3478f1a068efe73f$var$RIPEMD160)) return new $3478f1a068efe73f$var$RIPEMD160();
    $3478f1a068efe73f$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$5h91W.inherits($3478f1a068efe73f$var$RIPEMD160, $3478f1a068efe73f$var$BlockHash);
$3478f1a068efe73f$export$d1cea0ee4e3f0d3e = $3478f1a068efe73f$var$RIPEMD160;
$3478f1a068efe73f$var$RIPEMD160.blockSize = 512;
$3478f1a068efe73f$var$RIPEMD160.outSize = 160;
$3478f1a068efe73f$var$RIPEMD160.hmacStrength = 192;
$3478f1a068efe73f$var$RIPEMD160.padLength = 64;
$3478f1a068efe73f$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $3478f1a068efe73f$var$sum32($3478f1a068efe73f$var$rotl32($3478f1a068efe73f$var$sum32_4(A, $3478f1a068efe73f$var$f(j, B, C, D), msg[$3478f1a068efe73f$var$r[j] + start], $3478f1a068efe73f$var$K(j)), $3478f1a068efe73f$var$s[j]), E);
        A = E;
        E = D;
        D = $3478f1a068efe73f$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $3478f1a068efe73f$var$sum32($3478f1a068efe73f$var$rotl32($3478f1a068efe73f$var$sum32_4(Ah, $3478f1a068efe73f$var$f(79 - j, Bh, Ch, Dh), msg[$3478f1a068efe73f$var$rh[j] + start], $3478f1a068efe73f$var$Kh(j)), $3478f1a068efe73f$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $3478f1a068efe73f$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $3478f1a068efe73f$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $3478f1a068efe73f$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $3478f1a068efe73f$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $3478f1a068efe73f$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $3478f1a068efe73f$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$3478f1a068efe73f$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $5h91W.toHex32(this.h, 'little');
    else return $5h91W.split32(this.h, 'little');
};
function $3478f1a068efe73f$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $3478f1a068efe73f$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $3478f1a068efe73f$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $3478f1a068efe73f$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $3478f1a068efe73f$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $3478f1a068efe73f$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $3478f1a068efe73f$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("bzM2M", function(module, exports) {
'use strict';

var $5h91W = parcelRequire("5h91W");

var $bNW2d = parcelRequire("bNW2d");
function $86d83b1ef1e8734d$var$Hmac(hash, key, enc) {
    if (!(this instanceof $86d83b1ef1e8734d$var$Hmac)) return new $86d83b1ef1e8734d$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($5h91W.toArray(key, enc));
}
module.exports = $86d83b1ef1e8734d$var$Hmac;
$86d83b1ef1e8734d$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $bNW2d(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$86d83b1ef1e8734d$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$86d83b1ef1e8734d$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("eh5tQ", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("2XALJ", function(module, exports) {
'use strict';

var $7ceHy = parcelRequire("7ceHy");

var $ftqWI = parcelRequire("ftqWI");

var $fpVz9 = parcelRequire("fpVz9");

var $ch9s3 = parcelRequire("ch9s3");

var $9m54X = parcelRequire("9m54X");
var $227d9cfd9405da50$var$assert = $fpVz9.assert;

var $jHJd0 = parcelRequire("jHJd0");

var $3Mc9q = parcelRequire("3Mc9q");
function $227d9cfd9405da50$var$EC(options) {
    if (!(this instanceof $227d9cfd9405da50$var$EC)) return new $227d9cfd9405da50$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $227d9cfd9405da50$var$assert(Object.prototype.hasOwnProperty.call($ch9s3, options), 'Unknown curve ' + options);
        options = $ch9s3[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $ch9s3.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $227d9cfd9405da50$var$EC;
$227d9cfd9405da50$var$EC.prototype.keyPair = function keyPair(options) {
    return new $jHJd0(this, options);
};
$227d9cfd9405da50$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $jHJd0.fromPrivate(this, priv, enc);
};
$227d9cfd9405da50$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $jHJd0.fromPublic(this, pub, enc);
};
$227d9cfd9405da50$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $ftqWI({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $9m54X(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7ceHy(2));
    for(;;){
        var priv = new $7ceHy(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$227d9cfd9405da50$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($7ceHy.isBN(msg) || typeof msg === 'number') {
        msg = new $7ceHy(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $7ceHy(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $7ceHy(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$227d9cfd9405da50$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$7ceHy.isBN(msg)) {
        $227d9cfd9405da50$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $227d9cfd9405da50$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$227d9cfd9405da50$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $227d9cfd9405da50$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $227d9cfd9405da50$var$assert(new $7ceHy(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $ftqWI({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7ceHy(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7ceHy(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3Mc9q({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$227d9cfd9405da50$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $3Mc9q(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$227d9cfd9405da50$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $227d9cfd9405da50$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $3Mc9q(signature, enc);
    var n = this.n;
    var e = new $7ceHy(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$227d9cfd9405da50$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3Mc9q(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("ftqWI", function(module, exports) {
'use strict';

var $d8iRl = parcelRequire("d8iRl");

var $am8t0 = parcelRequire("am8t0");

var $bNW2d = parcelRequire("bNW2d");
function $b43e776378e98b75$var$HmacDRBG(options) {
    if (!(this instanceof $b43e776378e98b75$var$HmacDRBG)) return new $b43e776378e98b75$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $am8t0.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $am8t0.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $am8t0.toArray(options.pers, options.persEnc || 'hex');
    $bNW2d(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $b43e776378e98b75$var$HmacDRBG;
$b43e776378e98b75$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$b43e776378e98b75$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $d8iRl.hmac(this.hash, this.K);
};
$b43e776378e98b75$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$b43e776378e98b75$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $am8t0.toArray(entropy, entropyEnc);
    add = $am8t0.toArray(add, addEnc);
    $bNW2d(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$b43e776378e98b75$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $am8t0.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $am8t0.encode(res, enc);
};

});

parcelRegister("jHJd0", function(module, exports) {
'use strict';

var $7ceHy = parcelRequire("7ceHy");

var $fpVz9 = parcelRequire("fpVz9");
var $e5851a018387567c$var$assert = $fpVz9.assert;
function $e5851a018387567c$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $e5851a018387567c$var$KeyPair;
$e5851a018387567c$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $e5851a018387567c$var$KeyPair) return pub;
    return new $e5851a018387567c$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$e5851a018387567c$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $e5851a018387567c$var$KeyPair) return priv;
    return new $e5851a018387567c$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$e5851a018387567c$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$e5851a018387567c$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$e5851a018387567c$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$e5851a018387567c$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7ceHy(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$e5851a018387567c$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $e5851a018387567c$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $e5851a018387567c$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$e5851a018387567c$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $e5851a018387567c$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$e5851a018387567c$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$e5851a018387567c$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$e5851a018387567c$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("3Mc9q", function(module, exports) {
'use strict';

var $7ceHy = parcelRequire("7ceHy");

var $fpVz9 = parcelRequire("fpVz9");
var $2bff47b83f68368a$var$assert = $fpVz9.assert;
function $2bff47b83f68368a$var$Signature(options, enc) {
    if (options instanceof $2bff47b83f68368a$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2bff47b83f68368a$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $7ceHy(options.r, 16);
    this.s = new $7ceHy(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2bff47b83f68368a$var$Signature;
function $2bff47b83f68368a$var$Position() {
    this.place = 0;
}
function $2bff47b83f68368a$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2bff47b83f68368a$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2bff47b83f68368a$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $fpVz9.toArray(data, enc);
    var p = new $2bff47b83f68368a$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2bff47b83f68368a$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2bff47b83f68368a$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2bff47b83f68368a$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7ceHy(r);
    this.s = new $7ceHy(s);
    this.recoveryParam = null;
    return true;
};
function $2bff47b83f68368a$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2bff47b83f68368a$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2bff47b83f68368a$var$rmPadding(r);
    s = $2bff47b83f68368a$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2bff47b83f68368a$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2bff47b83f68368a$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2bff47b83f68368a$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $fpVz9.encode(res, enc);
};

});


parcelRegister("aNhbj", function(module, exports) {
'use strict';

var $d8iRl = parcelRequire("d8iRl");

var $ch9s3 = parcelRequire("ch9s3");

var $fpVz9 = parcelRequire("fpVz9");
var $7dbbcee1ea10bb0d$var$assert = $fpVz9.assert;
var $7dbbcee1ea10bb0d$var$parseBytes = $fpVz9.parseBytes;

var $kQKNv = parcelRequire("kQKNv");

var $ioc6i = parcelRequire("ioc6i");
function $7dbbcee1ea10bb0d$var$EDDSA(curve) {
    $7dbbcee1ea10bb0d$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $7dbbcee1ea10bb0d$var$EDDSA)) return new $7dbbcee1ea10bb0d$var$EDDSA(curve);
    curve = $ch9s3[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $d8iRl.sha512;
}
module.exports = $7dbbcee1ea10bb0d$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $7dbbcee1ea10bb0d$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $7dbbcee1ea10bb0d$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $7dbbcee1ea10bb0d$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $7dbbcee1ea10bb0d$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $fpVz9.intFromLE(hash.digest()).umod(this.curve.n);
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $kQKNv.fromPublic(this, pub);
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $kQKNv.fromSecret(this, secret);
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $ioc6i) return sig;
    return new $ioc6i(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $7dbbcee1ea10bb0d$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $fpVz9.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $fpVz9.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $fpVz9.intFromLE(bytes);
};
$7dbbcee1ea10bb0d$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("kQKNv", function(module, exports) {
'use strict';

var $fpVz9 = parcelRequire("fpVz9");
var $f2dcf6fc69c81076$var$assert = $fpVz9.assert;
var $f2dcf6fc69c81076$var$parseBytes = $fpVz9.parseBytes;
var $f2dcf6fc69c81076$var$cachedProperty = $fpVz9.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $f2dcf6fc69c81076$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $f2dcf6fc69c81076$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $f2dcf6fc69c81076$var$parseBytes(params.pub);
}
$f2dcf6fc69c81076$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $f2dcf6fc69c81076$var$KeyPair) return pub;
    return new $f2dcf6fc69c81076$var$KeyPair(eddsa, {
        pub: pub
    });
};
$f2dcf6fc69c81076$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $f2dcf6fc69c81076$var$KeyPair) return secret;
    return new $f2dcf6fc69c81076$var$KeyPair(eddsa, {
        secret: secret
    });
};
$f2dcf6fc69c81076$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$f2dcf6fc69c81076$var$cachedProperty($f2dcf6fc69c81076$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$f2dcf6fc69c81076$var$cachedProperty($f2dcf6fc69c81076$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$f2dcf6fc69c81076$var$cachedProperty($f2dcf6fc69c81076$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$f2dcf6fc69c81076$var$cachedProperty($f2dcf6fc69c81076$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$f2dcf6fc69c81076$var$cachedProperty($f2dcf6fc69c81076$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$f2dcf6fc69c81076$var$cachedProperty($f2dcf6fc69c81076$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$f2dcf6fc69c81076$var$KeyPair.prototype.sign = function sign(message) {
    $f2dcf6fc69c81076$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$f2dcf6fc69c81076$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$f2dcf6fc69c81076$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $f2dcf6fc69c81076$var$assert(this._secret, 'KeyPair is public only');
    return $fpVz9.encode(this.secret(), enc);
};
$f2dcf6fc69c81076$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $fpVz9.encode(this.pubBytes(), enc);
};
module.exports = $f2dcf6fc69c81076$var$KeyPair;

});

parcelRegister("ioc6i", function(module, exports) {
'use strict';

var $7ceHy = parcelRequire("7ceHy");

var $fpVz9 = parcelRequire("fpVz9");
var $d633dad346666a2a$var$assert = $fpVz9.assert;
var $d633dad346666a2a$var$cachedProperty = $fpVz9.cachedProperty;
var $d633dad346666a2a$var$parseBytes = $fpVz9.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $d633dad346666a2a$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $d633dad346666a2a$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $d633dad346666a2a$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $d633dad346666a2a$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7ceHy) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$d633dad346666a2a$var$cachedProperty($d633dad346666a2a$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$d633dad346666a2a$var$cachedProperty($d633dad346666a2a$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$d633dad346666a2a$var$cachedProperty($d633dad346666a2a$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$d633dad346666a2a$var$cachedProperty($d633dad346666a2a$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$d633dad346666a2a$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$d633dad346666a2a$var$Signature.prototype.toHex = function toHex() {
    return $fpVz9.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $d633dad346666a2a$var$Signature;

});



parcelRegister("eOlL6", function(module, exports) {
'use strict';

var $g78em = parcelRequire("g78em");

var $4IRG5 = parcelRequire("4IRG5");

var $hg5oe = parcelRequire("hg5oe");

var $2JnZq = parcelRequire("2JnZq");

var $ellmV = parcelRequire("ellmV");
var $ac869d0300f1f362$require$pbkdf2Sync = $ellmV.pbkdf2Sync;

var $4OiF0 = parcelRequire("4OiF0");
var $ac869d0300f1f362$require$Buffer = $4OiF0.Buffer;
function $ac869d0300f1f362$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $4IRG5[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $ac869d0300f1f362$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $2JnZq.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $ac869d0300f1f362$require$Buffer.concat(out);
}
function $ac869d0300f1f362$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$ac869d0300f1f362$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $ac869d0300f1f362$require$Buffer.from(buffer);
    var stripped = $hg5oe(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $g78em.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $g78em.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $g78em.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $g78em.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $g78em.EncryptedPrivateKey.decode(data, 'der');
            data = $ac869d0300f1f362$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $g78em.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $g78em.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $g78em.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $g78em.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $g78em.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $g78em.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $g78em.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $g78em.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$ac869d0300f1f362$var$parseKeys.signature = $g78em.signature;
module.exports = $ac869d0300f1f362$var$parseKeys;

});
parcelRegister("g78em", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $bbb3af3a3b28ae2b$export$c98397a6eb8d0678, (v) => $bbb3af3a3b28ae2b$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $bbb3af3a3b28ae2b$export$f4aab6816f64fa6b, (v) => $bbb3af3a3b28ae2b$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $bbb3af3a3b28ae2b$export$4471f5c65d097c11, (v) => $bbb3af3a3b28ae2b$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $bbb3af3a3b28ae2b$export$ca8b6604d6ce14de, (v) => $bbb3af3a3b28ae2b$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $bbb3af3a3b28ae2b$export$8f54525b330fd87b, (v) => $bbb3af3a3b28ae2b$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $bbb3af3a3b28ae2b$export$23cd2842b44ca3e7, (v) => $bbb3af3a3b28ae2b$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $bbb3af3a3b28ae2b$export$245c9aaa9f5ce4ce, (v) => $bbb3af3a3b28ae2b$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $bbb3af3a3b28ae2b$export$8ad762e3e6399afe, (v) => $bbb3af3a3b28ae2b$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $bbb3af3a3b28ae2b$export$32ef6f92e22c6ab0, (v) => $bbb3af3a3b28ae2b$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $bbb3af3a3b28ae2b$export$c9cd164b539ebb63, (v) => $bbb3af3a3b28ae2b$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $bbb3af3a3b28ae2b$export$c98397a6eb8d0678;
var $bbb3af3a3b28ae2b$export$f4aab6816f64fa6b;
var $bbb3af3a3b28ae2b$export$4471f5c65d097c11;
var $bbb3af3a3b28ae2b$export$ca8b6604d6ce14de;
var $bbb3af3a3b28ae2b$export$8f54525b330fd87b;
var $bbb3af3a3b28ae2b$export$23cd2842b44ca3e7;
var $bbb3af3a3b28ae2b$export$245c9aaa9f5ce4ce;
var $bbb3af3a3b28ae2b$export$8ad762e3e6399afe;
var $bbb3af3a3b28ae2b$export$32ef6f92e22c6ab0;
var $bbb3af3a3b28ae2b$export$c9cd164b539ebb63;
'use strict';

var $1auoC = parcelRequire("1auoC");

$bbb3af3a3b28ae2b$export$c98397a6eb8d0678 = (parcelRequire("ged9F"));
var $bbb3af3a3b28ae2b$var$RSAPrivateKey = $1auoC.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$bbb3af3a3b28ae2b$export$f4aab6816f64fa6b = $bbb3af3a3b28ae2b$var$RSAPrivateKey;
var $bbb3af3a3b28ae2b$var$RSAPublicKey = $1auoC.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$bbb3af3a3b28ae2b$export$4471f5c65d097c11 = $bbb3af3a3b28ae2b$var$RSAPublicKey;
var $bbb3af3a3b28ae2b$var$AlgorithmIdentifier = $1auoC.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $bbb3af3a3b28ae2b$var$PublicKey = $1auoC.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($bbb3af3a3b28ae2b$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$bbb3af3a3b28ae2b$export$ca8b6604d6ce14de = $bbb3af3a3b28ae2b$var$PublicKey;
var $bbb3af3a3b28ae2b$var$PrivateKeyInfo = $1auoC.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($bbb3af3a3b28ae2b$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$bbb3af3a3b28ae2b$export$8f54525b330fd87b = $bbb3af3a3b28ae2b$var$PrivateKeyInfo;
var $bbb3af3a3b28ae2b$var$EncryptedPrivateKeyInfo = $1auoC.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$bbb3af3a3b28ae2b$export$23cd2842b44ca3e7 = $bbb3af3a3b28ae2b$var$EncryptedPrivateKeyInfo;
var $bbb3af3a3b28ae2b$var$DSAPrivateKey = $1auoC.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$bbb3af3a3b28ae2b$export$245c9aaa9f5ce4ce = $bbb3af3a3b28ae2b$var$DSAPrivateKey;
$bbb3af3a3b28ae2b$export$8ad762e3e6399afe = $1auoC.define('DSAparam', function() {
    this['int']();
});
var $bbb3af3a3b28ae2b$var$ECParameters = $1auoC.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $bbb3af3a3b28ae2b$var$ECPrivateKey = $1auoC.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($bbb3af3a3b28ae2b$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$bbb3af3a3b28ae2b$export$32ef6f92e22c6ab0 = $bbb3af3a3b28ae2b$var$ECPrivateKey;
$bbb3af3a3b28ae2b$export$c9cd164b539ebb63 = $1auoC.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("1auoC", function(module, exports) {
var $0d9e4da3b33d7c7b$var$asn1 = module.exports;

$0d9e4da3b33d7c7b$var$asn1.bignum = (parcelRequire("jwZLX"));

$0d9e4da3b33d7c7b$var$asn1.define = (parcelRequire("aslIH")).define;

$0d9e4da3b33d7c7b$var$asn1.base = (parcelRequire("gi7zr"));

$0d9e4da3b33d7c7b$var$asn1.constants = (parcelRequire("4Sey6"));

$0d9e4da3b33d7c7b$var$asn1.decoders = (parcelRequire("8KdoP"));

$0d9e4da3b33d7c7b$var$asn1.encoders = (parcelRequire("aaDqI"));

});
parcelRegister("jwZLX", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("66yC2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("aslIH", function(module, exports) {

var $1auoC = parcelRequire("1auoC");

var $bniia = parcelRequire("bniia");
var $79cd5e0e4c09e157$var$api = module.exports;
$79cd5e0e4c09e157$var$api.define = function define(name, body) {
    return new $79cd5e0e4c09e157$var$Entity(name, body);
};
function $79cd5e0e4c09e157$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$79cd5e0e4c09e157$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("2gshA")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $bniia(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$79cd5e0e4c09e157$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($1auoC.decoders[enc]);
    return this.decoders[enc];
};
$79cd5e0e4c09e157$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$79cd5e0e4c09e157$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($1auoC.encoders[enc]);
    return this.encoders[enc];
};
$79cd5e0e4c09e157$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("2gshA", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("gi7zr", function(module, exports) {
var $bdc433263ddfd403$var$base = module.exports;

$bdc433263ddfd403$var$base.Reporter = (parcelRequire("kiLMG")).Reporter;

$bdc433263ddfd403$var$base.DecoderBuffer = (parcelRequire("6LLAC")).DecoderBuffer;

$bdc433263ddfd403$var$base.EncoderBuffer = (parcelRequire("6LLAC")).EncoderBuffer;

$bdc433263ddfd403$var$base.Node = (parcelRequire("f4zDQ"));

});
parcelRegister("kiLMG", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $ec7a8e0971c45be5$export$957313a2f485e5ed, (v) => $ec7a8e0971c45be5$export$957313a2f485e5ed = v);
var $ec7a8e0971c45be5$export$957313a2f485e5ed;

var $bniia = parcelRequire("bniia");
function $ec7a8e0971c45be5$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$ec7a8e0971c45be5$export$957313a2f485e5ed = $ec7a8e0971c45be5$var$Reporter;
$ec7a8e0971c45be5$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $ec7a8e0971c45be5$var$ReporterError;
};
$ec7a8e0971c45be5$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$ec7a8e0971c45be5$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$ec7a8e0971c45be5$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$ec7a8e0971c45be5$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$ec7a8e0971c45be5$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$ec7a8e0971c45be5$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$ec7a8e0971c45be5$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$ec7a8e0971c45be5$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$ec7a8e0971c45be5$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $ec7a8e0971c45be5$var$ReporterError;
    if (inherited) err = msg;
    else err = new $ec7a8e0971c45be5$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$ec7a8e0971c45be5$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $ec7a8e0971c45be5$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$bniia($ec7a8e0971c45be5$var$ReporterError, Error);
$ec7a8e0971c45be5$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $ec7a8e0971c45be5$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("6LLAC", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $4edc0c2618622315$export$bf9f79cdc4a49163, (v) => $4edc0c2618622315$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $4edc0c2618622315$export$8ff24f7760c7a78e, (v) => $4edc0c2618622315$export$8ff24f7760c7a78e = v);
var $4edc0c2618622315$export$bf9f79cdc4a49163;
var $4edc0c2618622315$export$8ff24f7760c7a78e;

var $bniia = parcelRequire("bniia");

var $gi7zr = parcelRequire("gi7zr");
var $4edc0c2618622315$require$Reporter = $gi7zr.Reporter;

var $8UsMN = parcelRequire("8UsMN");
var $4edc0c2618622315$require$Buffer = $8UsMN.Buffer;
function $4edc0c2618622315$var$DecoderBuffer(base, options) {
    $4edc0c2618622315$require$Reporter.call(this, options);
    if (!$4edc0c2618622315$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$bniia($4edc0c2618622315$var$DecoderBuffer, $4edc0c2618622315$require$Reporter);
$4edc0c2618622315$export$bf9f79cdc4a49163 = $4edc0c2618622315$var$DecoderBuffer;
$4edc0c2618622315$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $4edc0c2618622315$require$Reporter.prototype.save.call(this)
    };
};
$4edc0c2618622315$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $4edc0c2618622315$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $4edc0c2618622315$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$4edc0c2618622315$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$4edc0c2618622315$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$4edc0c2618622315$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $4edc0c2618622315$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$4edc0c2618622315$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $4edc0c2618622315$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $4edc0c2618622315$var$EncoderBuffer)) item = new $4edc0c2618622315$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $4edc0c2618622315$require$Buffer.byteLength(value);
    } else if ($4edc0c2618622315$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$4edc0c2618622315$export$8ff24f7760c7a78e = $4edc0c2618622315$var$EncoderBuffer;
$4edc0c2618622315$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $4edc0c2618622315$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($4edc0c2618622315$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("f4zDQ", function(module, exports) {

var $gi7zr = parcelRequire("gi7zr");
var $af92e06bbd2c2b81$require$Reporter = $gi7zr.Reporter;

var $gi7zr = parcelRequire("gi7zr");
var $af92e06bbd2c2b81$require$EncoderBuffer = $gi7zr.EncoderBuffer;

var $gi7zr = parcelRequire("gi7zr");
var $af92e06bbd2c2b81$require$DecoderBuffer = $gi7zr.DecoderBuffer;

var $bNW2d = parcelRequire("bNW2d");
// Supported tags
var $af92e06bbd2c2b81$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $af92e06bbd2c2b81$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($af92e06bbd2c2b81$var$tags);
// Overrided methods list
var $af92e06bbd2c2b81$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $af92e06bbd2c2b81$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $af92e06bbd2c2b81$var$Node;
var $af92e06bbd2c2b81$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$af92e06bbd2c2b81$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $af92e06bbd2c2b81$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$af92e06bbd2c2b81$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $af92e06bbd2c2b81$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$af92e06bbd2c2b81$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $bNW2d(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $bNW2d.equal(state.children.length, 1, 'Root node can have only one child');
};
$af92e06bbd2c2b81$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $bNW2d(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $bNW2d(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$af92e06bbd2c2b81$var$overrided.forEach(function(method) {
    $af92e06bbd2c2b81$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$af92e06bbd2c2b81$var$tags.forEach(function(tag) {
    $af92e06bbd2c2b81$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $bNW2d(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$af92e06bbd2c2b81$var$Node.prototype.use = function use(item) {
    $bNW2d(item);
    var state = this._baseState;
    $bNW2d(state.use === null);
    state.use = item;
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $bNW2d(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $bNW2d(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $bNW2d(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $bNW2d(state.key === null);
    state.key = newKey;
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $bNW2d(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$af92e06bbd2c2b81$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $bNW2d(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$af92e06bbd2c2b81$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $af92e06bbd2c2b81$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$af92e06bbd2c2b81$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$af92e06bbd2c2b81$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $bNW2d(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$af92e06bbd2c2b81$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$af92e06bbd2c2b81$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $af92e06bbd2c2b81$require$EncoderBuffer(data, this.reporter);
};
$af92e06bbd2c2b81$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$af92e06bbd2c2b81$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $af92e06bbd2c2b81$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$af92e06bbd2c2b81$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $bNW2d(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$af92e06bbd2c2b81$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$af92e06bbd2c2b81$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$af92e06bbd2c2b81$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("4Sey6", function(module, exports) {
var $38c77db1983955eb$var$constants = module.exports;
// Helper
$38c77db1983955eb$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$38c77db1983955eb$var$constants.der = (parcelRequire("4Urgx"));

});
parcelRegister("4Urgx", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $39318aca916bc80c$export$3584c46ed60baee8, (v) => $39318aca916bc80c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $39318aca916bc80c$export$f18596ef8d632e49, (v) => $39318aca916bc80c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $39318aca916bc80c$export$2b067c6666111485, (v) => $39318aca916bc80c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $39318aca916bc80c$export$f17df38a421ab9e3, (v) => $39318aca916bc80c$export$f17df38a421ab9e3 = v);
var $39318aca916bc80c$export$3584c46ed60baee8;
var $39318aca916bc80c$export$f18596ef8d632e49;
var $39318aca916bc80c$export$2b067c6666111485;
var $39318aca916bc80c$export$f17df38a421ab9e3;

var $4Sey6 = parcelRequire("4Sey6");
$39318aca916bc80c$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$39318aca916bc80c$export$f18596ef8d632e49 = $4Sey6._reverse($39318aca916bc80c$export$3584c46ed60baee8);
$39318aca916bc80c$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$39318aca916bc80c$export$f17df38a421ab9e3 = $4Sey6._reverse($39318aca916bc80c$export$2b067c6666111485);

});


parcelRegister("8KdoP", function(module, exports) {
var $65dd0373f5fb53cf$var$decoders = module.exports;

$65dd0373f5fb53cf$var$decoders.der = (parcelRequire("9Qw3K"));

$65dd0373f5fb53cf$var$decoders.pem = (parcelRequire("lgkmB"));

});
parcelRegister("9Qw3K", function(module, exports) {

var $bniia = parcelRequire("bniia");

var $1auoC = parcelRequire("1auoC");
var $72b1d6bfd0392eb9$var$base = $1auoC.base;
var $72b1d6bfd0392eb9$var$bignum = $1auoC.bignum;
// Import DER constants
var $72b1d6bfd0392eb9$var$der = $1auoC.constants.der;
function $72b1d6bfd0392eb9$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $72b1d6bfd0392eb9$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $72b1d6bfd0392eb9$var$DERDecoder;
$72b1d6bfd0392eb9$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $72b1d6bfd0392eb9$var$base.DecoderBuffer)) data = new $72b1d6bfd0392eb9$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $72b1d6bfd0392eb9$var$DERNode(parent) {
    $72b1d6bfd0392eb9$var$base.Node.call(this, 'der', parent);
}
$bniia($72b1d6bfd0392eb9$var$DERNode, $72b1d6bfd0392eb9$var$base.Node);
$72b1d6bfd0392eb9$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $72b1d6bfd0392eb9$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $72b1d6bfd0392eb9$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $72b1d6bfd0392eb9$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$72b1d6bfd0392eb9$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $72b1d6bfd0392eb9$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $72b1d6bfd0392eb9$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$72b1d6bfd0392eb9$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $72b1d6bfd0392eb9$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$72b1d6bfd0392eb9$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $72b1d6bfd0392eb9$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $72b1d6bfd0392eb9$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $72b1d6bfd0392eb9$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $72b1d6bfd0392eb9$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("lgkmB", function(module, exports) {

var $bniia = parcelRequire("bniia");

var $8UsMN = parcelRequire("8UsMN");
var $f7aae363000a87cb$require$Buffer = $8UsMN.Buffer;

var $9Qw3K = parcelRequire("9Qw3K");
function $f7aae363000a87cb$var$PEMDecoder(entity) {
    $9Qw3K.call(this, entity);
    this.enc = 'pem';
}
$bniia($f7aae363000a87cb$var$PEMDecoder, $9Qw3K);
module.exports = $f7aae363000a87cb$var$PEMDecoder;
$f7aae363000a87cb$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $f7aae363000a87cb$require$Buffer(base64, 'base64');
    return $9Qw3K.prototype.decode.call(this, input, options);
};

});


parcelRegister("aaDqI", function(module, exports) {
var $76796c857c98b413$var$encoders = module.exports;

$76796c857c98b413$var$encoders.der = (parcelRequire("73ynf"));

$76796c857c98b413$var$encoders.pem = (parcelRequire("4nYMz"));

});
parcelRegister("73ynf", function(module, exports) {

var $bniia = parcelRequire("bniia");

var $8UsMN = parcelRequire("8UsMN");
var $52337a29460d16d0$require$Buffer = $8UsMN.Buffer;

var $1auoC = parcelRequire("1auoC");
var $52337a29460d16d0$var$base = $1auoC.base;
// Import DER constants
var $52337a29460d16d0$var$der = $1auoC.constants.der;
function $52337a29460d16d0$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $52337a29460d16d0$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $52337a29460d16d0$var$DEREncoder;
$52337a29460d16d0$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $52337a29460d16d0$var$DERNode(parent) {
    $52337a29460d16d0$var$base.Node.call(this, 'der', parent);
}
$bniia($52337a29460d16d0$var$DERNode, $52337a29460d16d0$var$base.Node);
$52337a29460d16d0$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $52337a29460d16d0$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $52337a29460d16d0$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $52337a29460d16d0$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$52337a29460d16d0$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $52337a29460d16d0$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$52337a29460d16d0$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $52337a29460d16d0$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $52337a29460d16d0$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$52337a29460d16d0$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $52337a29460d16d0$var$two(date.getFullYear()),
        $52337a29460d16d0$var$two(date.getUTCMonth() + 1),
        $52337a29460d16d0$var$two(date.getUTCDate()),
        $52337a29460d16d0$var$two(date.getUTCHours()),
        $52337a29460d16d0$var$two(date.getUTCMinutes()),
        $52337a29460d16d0$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $52337a29460d16d0$var$two(date.getFullYear() % 100),
        $52337a29460d16d0$var$two(date.getUTCMonth() + 1),
        $52337a29460d16d0$var$two(date.getUTCDate()),
        $52337a29460d16d0$var$two(date.getUTCHours()),
        $52337a29460d16d0$var$two(date.getUTCMinutes()),
        $52337a29460d16d0$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$52337a29460d16d0$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$52337a29460d16d0$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$52337a29460d16d0$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $52337a29460d16d0$require$Buffer(numArray);
    }
    if ($52337a29460d16d0$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $52337a29460d16d0$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $52337a29460d16d0$require$Buffer(out));
};
$52337a29460d16d0$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$52337a29460d16d0$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$52337a29460d16d0$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $52337a29460d16d0$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($52337a29460d16d0$var$der.tagByName.hasOwnProperty(tag)) res = $52337a29460d16d0$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $52337a29460d16d0$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("4nYMz", function(module, exports) {

var $bniia = parcelRequire("bniia");

var $73ynf = parcelRequire("73ynf");
function $33187589f91d0b99$var$PEMEncoder(entity) {
    $73ynf.call(this, entity);
    this.enc = 'pem';
}
$bniia($33187589f91d0b99$var$PEMEncoder, $73ynf);
module.exports = $33187589f91d0b99$var$PEMEncoder;
$33187589f91d0b99$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $73ynf.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("ged9F", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $1auoC = parcelRequire("1auoC");
var $bd0828768e92e003$var$Time = $1auoC.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $bd0828768e92e003$var$AttributeTypeValue = $1auoC.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $bd0828768e92e003$var$AlgorithmIdentifier = $1auoC.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $bd0828768e92e003$var$SubjectPublicKeyInfo = $1auoC.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($bd0828768e92e003$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $bd0828768e92e003$var$RelativeDistinguishedName = $1auoC.define('RelativeDistinguishedName', function() {
    this.setof($bd0828768e92e003$var$AttributeTypeValue);
});
var $bd0828768e92e003$var$RDNSequence = $1auoC.define('RDNSequence', function() {
    this.seqof($bd0828768e92e003$var$RelativeDistinguishedName);
});
var $bd0828768e92e003$var$Name = $1auoC.define('Name', function() {
    this.choice({
        rdnSequence: this.use($bd0828768e92e003$var$RDNSequence)
    });
});
var $bd0828768e92e003$var$Validity = $1auoC.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($bd0828768e92e003$var$Time), this.key('notAfter').use($bd0828768e92e003$var$Time));
});
var $bd0828768e92e003$var$Extension = $1auoC.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $bd0828768e92e003$var$TBSCertificate = $1auoC.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($bd0828768e92e003$var$AlgorithmIdentifier), this.key('issuer').use($bd0828768e92e003$var$Name), this.key('validity').use($bd0828768e92e003$var$Validity), this.key('subject').use($bd0828768e92e003$var$Name), this.key('subjectPublicKeyInfo').use($bd0828768e92e003$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($bd0828768e92e003$var$Extension).optional());
});
var $bd0828768e92e003$var$X509Certificate = $1auoC.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($bd0828768e92e003$var$TBSCertificate), this.key('signatureAlgorithm').use($bd0828768e92e003$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $bd0828768e92e003$var$X509Certificate;

});


parcelRegister("4IRG5", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("hg5oe", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $c9081c95530708e4$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $c9081c95530708e4$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $c9081c95530708e4$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $cthQ7 = parcelRequire("cthQ7");

var $2JnZq = parcelRequire("2JnZq");

var $4OiF0 = parcelRequire("4OiF0");
var $c9081c95530708e4$require$Buffer = $4OiF0.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($c9081c95530708e4$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($c9081c95530708e4$var$fullRegex);
        decrypted = $c9081c95530708e4$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $c9081c95530708e4$require$Buffer.from(match[2], 'hex');
        var cipherText = $c9081c95530708e4$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $cthQ7(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $2JnZq.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $c9081c95530708e4$require$Buffer.concat(out);
    }
    var tag = key.match($c9081c95530708e4$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("6YO51", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("9J4Jv", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $714bfcdf9383a1fd$require$Buffer = $4OiF0.Buffer;

var $7ww61 = parcelRequire("7ww61");

var $ikIB9 = parcelRequire("ikIB9");
var $714bfcdf9383a1fd$require$EC = $ikIB9.ec;

var $eOlL6 = parcelRequire("eOlL6");

var $6YO51 = parcelRequire("6YO51");
function $714bfcdf9383a1fd$var$verify(sig, hash, key, signType, tag) {
    var pub = $eOlL6(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $714bfcdf9383a1fd$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $714bfcdf9383a1fd$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $714bfcdf9383a1fd$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $714bfcdf9383a1fd$require$Buffer.from(pad);
    var red = $7ww61.mont(pub.modulus);
    sig = new $7ww61(sig).toRed(red);
    sig = sig.redPow(new $7ww61(pub.publicExponent));
    sig = $714bfcdf9383a1fd$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $714bfcdf9383a1fd$var$ecVerify(sig, hash, pub) {
    var curveId = $6YO51[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $714bfcdf9383a1fd$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $714bfcdf9383a1fd$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $eOlL6.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $714bfcdf9383a1fd$var$checkValue(s, q);
    $714bfcdf9383a1fd$var$checkValue(r, q);
    var montp = $7ww61.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $7ww61(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $714bfcdf9383a1fd$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $714bfcdf9383a1fd$var$verify;

});


parcelRegister("3ZddE", function(module, exports) {

var $8UsMN = parcelRequire("8UsMN");
var $2e7152ac6797a74f$require$Buffer = $8UsMN.Buffer;

var $ikIB9 = parcelRequire("ikIB9");

var $2DN2x = parcelRequire("2DN2x");
module.exports = function createECDH(curve) {
    return new $2e7152ac6797a74f$var$ECDH(curve);
};
var $2e7152ac6797a74f$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$2e7152ac6797a74f$var$aliases.p224 = $2e7152ac6797a74f$var$aliases.secp224r1;
$2e7152ac6797a74f$var$aliases.p256 = $2e7152ac6797a74f$var$aliases.secp256r1 = $2e7152ac6797a74f$var$aliases.prime256v1;
$2e7152ac6797a74f$var$aliases.p192 = $2e7152ac6797a74f$var$aliases.secp192r1 = $2e7152ac6797a74f$var$aliases.prime192v1;
$2e7152ac6797a74f$var$aliases.p384 = $2e7152ac6797a74f$var$aliases.secp384r1;
$2e7152ac6797a74f$var$aliases.p521 = $2e7152ac6797a74f$var$aliases.secp521r1;
function $2e7152ac6797a74f$var$ECDH(curve) {
    this.curveType = $2e7152ac6797a74f$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $ikIB9.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$2e7152ac6797a74f$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$2e7152ac6797a74f$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$2e7152ac6797a74f$require$Buffer.isBuffer(other)) other = new $2e7152ac6797a74f$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $2e7152ac6797a74f$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$2e7152ac6797a74f$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $2e7152ac6797a74f$var$formatReturnValue(key, enc);
};
$2e7152ac6797a74f$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $2e7152ac6797a74f$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$2e7152ac6797a74f$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$2e7152ac6797a74f$require$Buffer.isBuffer(pub)) pub = new $2e7152ac6797a74f$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$2e7152ac6797a74f$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$2e7152ac6797a74f$require$Buffer.isBuffer(priv)) priv = new $2e7152ac6797a74f$require$Buffer(priv, enc);
    var _priv = new $2DN2x(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $2e7152ac6797a74f$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $2e7152ac6797a74f$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $2e7152ac6797a74f$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $2e7152ac6797a74f$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("2DN2x", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("66yC2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("e76V8", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", () => $a467166dad050f69$export$512823e338ddb1b7, (v) => $a467166dad050f69$export$512823e338ddb1b7 = v);
$parcel$export(module.exports, "privateDecrypt", () => $a467166dad050f69$export$7efb24e2fddf99b9, (v) => $a467166dad050f69$export$7efb24e2fddf99b9 = v);
$parcel$export(module.exports, "privateEncrypt", () => $a467166dad050f69$export$9d0e0c0c4a8d30f3, (v) => $a467166dad050f69$export$9d0e0c0c4a8d30f3 = v);
$parcel$export(module.exports, "publicDecrypt", () => $a467166dad050f69$export$b9d55ff329113abd, (v) => $a467166dad050f69$export$b9d55ff329113abd = v);
var $a467166dad050f69$export$512823e338ddb1b7;
var $a467166dad050f69$export$7efb24e2fddf99b9;
var $a467166dad050f69$export$9d0e0c0c4a8d30f3;
var $a467166dad050f69$export$b9d55ff329113abd;

$a467166dad050f69$export$512823e338ddb1b7 = (parcelRequire("95P7C"));

$a467166dad050f69$export$7efb24e2fddf99b9 = (parcelRequire("1LJuO"));
$a467166dad050f69$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a467166dad050f69$export$512823e338ddb1b7(key, buf, true);
};
$a467166dad050f69$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a467166dad050f69$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("95P7C", function(module, exports) {

var $eOlL6 = parcelRequire("eOlL6");

var $bUSoq = parcelRequire("bUSoq");

var $dHvdJ = parcelRequire("dHvdJ");

var $4UAri = parcelRequire("4UAri");

var $9nhUm = parcelRequire("9nhUm");

var $hADws = parcelRequire("hADws");

var $4w14y = parcelRequire("4w14y");

var $aHKJP = parcelRequire("aHKJP");

var $4OiF0 = parcelRequire("4OiF0");
var $69ec3c714ec96de6$require$Buffer = $4OiF0.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $eOlL6(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $69ec3c714ec96de6$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $69ec3c714ec96de6$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $hADws(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $aHKJP(paddedMsg, key);
    else return $4w14y(paddedMsg, key);
};
function $69ec3c714ec96de6$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $dHvdJ('sha1').update($69ec3c714ec96de6$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $69ec3c714ec96de6$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $bUSoq(hLen);
    var maskedDb = $9nhUm($69ec3c714ec96de6$require$Buffer.concat([
        iHash,
        ps,
        $69ec3c714ec96de6$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $4UAri(seed, dblen));
    var maskedSeed = $9nhUm(seed, $4UAri(maskedDb, hLen));
    return new $hADws($69ec3c714ec96de6$require$Buffer.concat([
        $69ec3c714ec96de6$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $69ec3c714ec96de6$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $69ec3c714ec96de6$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $69ec3c714ec96de6$var$nonZero(k - mLen - 3);
    return new $hADws($69ec3c714ec96de6$require$Buffer.concat([
        $69ec3c714ec96de6$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $69ec3c714ec96de6$require$Buffer.alloc(1),
        msg
    ], k));
}
function $69ec3c714ec96de6$var$nonZero(len) {
    var out = $69ec3c714ec96de6$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $bUSoq(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $bUSoq(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("4UAri", function(module, exports) {

var $dHvdJ = parcelRequire("dHvdJ");

var $4OiF0 = parcelRequire("4OiF0");
var $3938a872f580cf6b$require$Buffer = $4OiF0.Buffer;
module.exports = function(seed, len) {
    var t = $3938a872f580cf6b$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $3938a872f580cf6b$var$i2ops(i++);
        t = $3938a872f580cf6b$require$Buffer.concat([
            t,
            $dHvdJ('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $3938a872f580cf6b$var$i2ops(c) {
    var out = $3938a872f580cf6b$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("9nhUm", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("hADws", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("66yC2")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4w14y", function(module, exports) {

var $hADws = parcelRequire("hADws");

var $4OiF0 = parcelRequire("4OiF0");
var $349afb896da6ffe6$require$Buffer = $4OiF0.Buffer;
function $349afb896da6ffe6$var$withPublic(paddedMsg, key) {
    return $349afb896da6ffe6$require$Buffer.from(paddedMsg.toRed($hADws.mont(key.modulus)).redPow(new $hADws(key.publicExponent)).fromRed().toArray());
}
module.exports = $349afb896da6ffe6$var$withPublic;

});


parcelRegister("1LJuO", function(module, exports) {

var $eOlL6 = parcelRequire("eOlL6");

var $4UAri = parcelRequire("4UAri");

var $9nhUm = parcelRequire("9nhUm");

var $hADws = parcelRequire("hADws");

var $aHKJP = parcelRequire("aHKJP");

var $dHvdJ = parcelRequire("dHvdJ");

var $4w14y = parcelRequire("4w14y");

var $4OiF0 = parcelRequire("4OiF0");
var $149d78cb0a43d8dd$require$Buffer = $4OiF0.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $eOlL6(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $hADws(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $4w14y(new $hADws(enc), key);
    else msg = $aHKJP(enc, key);
    var zBuffer = $149d78cb0a43d8dd$require$Buffer.alloc(k - msg.length);
    msg = $149d78cb0a43d8dd$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $149d78cb0a43d8dd$var$oaep(key, msg);
    else if (padding === 1) return $149d78cb0a43d8dd$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $149d78cb0a43d8dd$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $dHvdJ('sha1').update($149d78cb0a43d8dd$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $9nhUm(maskedSeed, $4UAri(maskedDb, hLen));
    var db = $9nhUm(maskedDb, $4UAri(seed, k - hLen - 1));
    if ($149d78cb0a43d8dd$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $149d78cb0a43d8dd$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $149d78cb0a43d8dd$var$compare(a, b) {
    a = $149d78cb0a43d8dd$require$Buffer.from(a);
    b = $149d78cb0a43d8dd$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("30hQH", function(module, exports) {

$parcel$export(module.exports, "randomFill", () => $22ff379ee4e98c66$export$bb1abf2ce84fc7e8, (v) => $22ff379ee4e98c66$export$bb1abf2ce84fc7e8 = v);
$parcel$export(module.exports, "randomFillSync", () => $22ff379ee4e98c66$export$2f7171e78e524d5e, (v) => $22ff379ee4e98c66$export$2f7171e78e524d5e = v);
var $22ff379ee4e98c66$export$bb1abf2ce84fc7e8;
var $22ff379ee4e98c66$export$2f7171e78e524d5e;

var $ajwPf = parcelRequire("ajwPf");
'use strict';
function $22ff379ee4e98c66$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $4OiF0 = parcelRequire("4OiF0");

var $bUSoq = parcelRequire("bUSoq");
var $22ff379ee4e98c66$var$Buffer = $4OiF0.Buffer;
var $22ff379ee4e98c66$var$kBufferMaxLength = $4OiF0.kMaxLength;
var $22ff379ee4e98c66$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $22ff379ee4e98c66$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $22ff379ee4e98c66$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $22ff379ee4e98c66$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $22ff379ee4e98c66$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $22ff379ee4e98c66$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $22ff379ee4e98c66$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $22ff379ee4e98c66$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($22ff379ee4e98c66$var$crypto && $22ff379ee4e98c66$var$crypto.getRandomValues || false) {
    $22ff379ee4e98c66$export$bb1abf2ce84fc7e8 = $22ff379ee4e98c66$var$randomFill;
    $22ff379ee4e98c66$export$2f7171e78e524d5e = $22ff379ee4e98c66$var$randomFillSync;
} else {
    $22ff379ee4e98c66$export$bb1abf2ce84fc7e8 = $22ff379ee4e98c66$var$oldBrowser;
    $22ff379ee4e98c66$export$2f7171e78e524d5e = $22ff379ee4e98c66$var$oldBrowser;
}
function $22ff379ee4e98c66$var$randomFill(buf, offset, size, cb) {
    if (!$22ff379ee4e98c66$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $22ff379ee4e98c66$var$assertOffset(offset, buf.length);
    $22ff379ee4e98c66$var$assertSize(size, offset, buf.length);
    return $22ff379ee4e98c66$var$actualFill(buf, offset, size, cb);
}
function $22ff379ee4e98c66$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $22ff379ee4e98c66$var$crypto.getRandomValues(uint);
    if (cb) {
        $ajwPf.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $bUSoq(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $bUSoq(size);
    bytes.copy(buf, offset);
    return buf;
}
function $22ff379ee4e98c66$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$22ff379ee4e98c66$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $22ff379ee4e98c66$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $22ff379ee4e98c66$var$assertSize(size, offset, buf.length);
    return $22ff379ee4e98c66$var$actualFill(buf, offset, size);
}

});


parcelRegister("crX4E", function(module, exports) {
'use strict';

var $4OiF0 = parcelRequire("4OiF0");
var $9105d48aeb87caaf$require$Buffer = $4OiF0.Buffer;

var $eqRv3 = parcelRequire("eqRv3");
var $9105d48aeb87caaf$var$MAX_OCTET = 0x80, $9105d48aeb87caaf$var$CLASS_UNIVERSAL = 0, $9105d48aeb87caaf$var$PRIMITIVE_BIT = 0x20, $9105d48aeb87caaf$var$TAG_SEQ = 0x10, $9105d48aeb87caaf$var$TAG_INT = 0x02, $9105d48aeb87caaf$var$ENCODED_TAG_SEQ = $9105d48aeb87caaf$var$TAG_SEQ | $9105d48aeb87caaf$var$PRIMITIVE_BIT | $9105d48aeb87caaf$var$CLASS_UNIVERSAL << 6, $9105d48aeb87caaf$var$ENCODED_TAG_INT = $9105d48aeb87caaf$var$TAG_INT | $9105d48aeb87caaf$var$CLASS_UNIVERSAL << 6;
function $9105d48aeb87caaf$var$base64Url(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $9105d48aeb87caaf$var$signatureAsBuffer(signature) {
    if ($9105d48aeb87caaf$require$Buffer.isBuffer(signature)) return signature;
    else if ('string' === typeof signature) return $9105d48aeb87caaf$require$Buffer.from(signature, 'base64');
    throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}
function $9105d48aeb87caaf$var$derToJose(signature, alg) {
    signature = $9105d48aeb87caaf$var$signatureAsBuffer(signature);
    var paramBytes = $eqRv3(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $9105d48aeb87caaf$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($9105d48aeb87caaf$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $9105d48aeb87caaf$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $9105d48aeb87caaf$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $9105d48aeb87caaf$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString('base64');
    dst = $9105d48aeb87caaf$var$base64Url(dst);
    return dst;
}
function $9105d48aeb87caaf$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $9105d48aeb87caaf$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $9105d48aeb87caaf$var$joseToDer(signature, alg) {
    signature = $9105d48aeb87caaf$var$signatureAsBuffer(signature);
    var paramBytes = $eqRv3(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $9105d48aeb87caaf$var$countPadding(signature, 0, paramBytes);
    var sPadding = $9105d48aeb87caaf$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $9105d48aeb87caaf$var$MAX_OCTET;
    var dst = $9105d48aeb87caaf$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $9105d48aeb87caaf$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $9105d48aeb87caaf$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $9105d48aeb87caaf$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $9105d48aeb87caaf$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $9105d48aeb87caaf$var$derToJose,
    joseToDer: $9105d48aeb87caaf$var$joseToDer
};

});
parcelRegister("eqRv3", function(module, exports) {
'use strict';
function $a81cfe58cbdcb31e$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $a81cfe58cbdcb31e$var$paramBytesForAlg = {
    ES256: $a81cfe58cbdcb31e$var$getParamSize(256),
    ES384: $a81cfe58cbdcb31e$var$getParamSize(384),
    ES512: $a81cfe58cbdcb31e$var$getParamSize(521)
};
function $a81cfe58cbdcb31e$var$getParamBytesForAlg(alg) {
    var paramBytes = $a81cfe58cbdcb31e$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $a81cfe58cbdcb31e$var$getParamBytesForAlg;

});


parcelRegister("74JZ3", function(module, exports) {
/*jshint node:true */ 'use strict';

var $8UsMN = parcelRequire("8UsMN");
var $526c9388d9e5ea93$require$Buffer = $8UsMN.Buffer;

var $8UsMN = parcelRequire("8UsMN");
var $526c9388d9e5ea93$require$SlowBuffer = $8UsMN.SlowBuffer;
module.exports = $526c9388d9e5ea93$var$bufferEq;
function $526c9388d9e5ea93$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$526c9388d9e5ea93$require$Buffer.isBuffer(a) || !$526c9388d9e5ea93$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$526c9388d9e5ea93$var$bufferEq.install = function() {
    $526c9388d9e5ea93$require$Buffer.prototype.equal = $526c9388d9e5ea93$require$SlowBuffer.prototype.equal = function equal(that) {
        return $526c9388d9e5ea93$var$bufferEq(this, that);
    };
};
var $526c9388d9e5ea93$var$origBufEqual = $526c9388d9e5ea93$require$Buffer.prototype.equal;
var $526c9388d9e5ea93$var$origSlowBufEqual = $526c9388d9e5ea93$require$SlowBuffer.prototype.equal;
$526c9388d9e5ea93$var$bufferEq.restore = function() {
    $526c9388d9e5ea93$require$Buffer.prototype.equal = $526c9388d9e5ea93$var$origBufEqual;
    $526c9388d9e5ea93$require$SlowBuffer.prototype.equal = $526c9388d9e5ea93$var$origSlowBufEqual;
};

});


parcelRegister("i16Zl", function(module, exports) {
/*global module*/ 
var $8UsMN = parcelRequire("8UsMN");
var $d1ddbdc390996be8$require$Buffer = $8UsMN.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number' || $d1ddbdc390996be8$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRegister("c5wBR", function(module, exports) {
/*global module*/ 
var $4OiF0 = parcelRequire("4OiF0");
var $8ccf3f45bbc5f184$require$Buffer = $4OiF0.Buffer;

var $2r4Mc = parcelRequire("2r4Mc");

var $9xnLy = parcelRequire("9xnLy");

var $9nTep = parcelRequire("9nTep");

var $i16Zl = parcelRequire("i16Zl");

var $5DFzG = parcelRequire("5DFzG");
var $8ccf3f45bbc5f184$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $8ccf3f45bbc5f184$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === '[object Object]';
}
function $8ccf3f45bbc5f184$var$safeJsonParse(thing) {
    if ($8ccf3f45bbc5f184$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $8ccf3f45bbc5f184$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split('.', 1)[0];
    return $8ccf3f45bbc5f184$var$safeJsonParse($8ccf3f45bbc5f184$require$Buffer.from(encodedHeader, 'base64').toString('binary'));
}
function $8ccf3f45bbc5f184$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split('.', 2).join('.');
}
function $8ccf3f45bbc5f184$var$signatureFromJWS(jwsSig) {
    return jwsSig.split('.')[2];
}
function $8ccf3f45bbc5f184$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || 'utf8';
    var payload = jwsSig.split('.')[1];
    return $8ccf3f45bbc5f184$require$Buffer.from(payload, 'base64').toString(encoding);
}
function $8ccf3f45bbc5f184$var$isValidJws(string) {
    return $8ccf3f45bbc5f184$var$JWS_REGEX.test(string) && !!$8ccf3f45bbc5f184$var$headerFromJWS(string);
}
function $8ccf3f45bbc5f184$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $i16Zl(jwsSig);
    var signature = $8ccf3f45bbc5f184$var$signatureFromJWS(jwsSig);
    var securedInput = $8ccf3f45bbc5f184$var$securedInputFromJWS(jwsSig);
    var algo = $9xnLy(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $8ccf3f45bbc5f184$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $i16Zl(jwsSig);
    if (!$8ccf3f45bbc5f184$var$isValidJws(jwsSig)) return null;
    var header = $8ccf3f45bbc5f184$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $8ccf3f45bbc5f184$var$payloadFromJWS(jwsSig);
    if (header.typ === 'JWT' || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $8ccf3f45bbc5f184$var$signatureFromJWS(jwsSig)
    };
}
function $8ccf3f45bbc5f184$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret;
    secretOrKey = secretOrKey == null ? opts.publicKey : secretOrKey;
    secretOrKey = secretOrKey == null ? opts.key : secretOrKey;
    if (/^hs/i.test(opts.algorithm) === true && secretOrKey == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $2r4Mc(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $2r4Mc(opts.signature);
    this.secret.once('close', (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once('close', (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$5DFzG.inherits($8ccf3f45bbc5f184$var$VerifyStream, $9nTep);
$8ccf3f45bbc5f184$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $8ccf3f45bbc5f184$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $8ccf3f45bbc5f184$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit('done', valid, obj);
        this.emit('data', valid);
        this.emit('end');
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$8ccf3f45bbc5f184$var$VerifyStream.decode = $8ccf3f45bbc5f184$var$jwsDecode;
$8ccf3f45bbc5f184$var$VerifyStream.isValid = $8ccf3f45bbc5f184$var$isValidJws;
$8ccf3f45bbc5f184$var$VerifyStream.verify = $8ccf3f45bbc5f184$var$jwsVerify;
module.exports = $8ccf3f45bbc5f184$var$VerifyStream;

});



parcelRegister("HjT2s", function(module, exports) {

var $iegT3 = parcelRequire("iegT3");

var $6Ogh4 = parcelRequire("6Ogh4");

var $j0d2F = parcelRequire("j0d2F");

var $4kgx4 = parcelRequire("4kgx4");

var $dK2v1 = parcelRequire("dK2v1");

var $uu4nw = parcelRequire("uu4nw");

var $fuOhN = parcelRequire("fuOhN");
var $0823715b0a1c6796$var$PUB_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512'
];
var $0823715b0a1c6796$var$RSA_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
var $0823715b0a1c6796$var$HS_ALGS = [
    'HS256',
    'HS384',
    'HS512'
];
if ($uu4nw) {
    $0823715b0a1c6796$var$PUB_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
    $0823715b0a1c6796$var$RSA_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === 'function' && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    var done;
    if (callback) done = callback;
    else done = function(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') return done(new $iegT3('clockTimestamp must be a number'));
    if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) return done(new $iegT3('nonce must be a non-empty string'));
    var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $iegT3('jwt must be provided'));
    if (typeof jwtString !== 'string') return done(new $iegT3('jwt must be a string'));
    var parts = jwtString.split('.');
    if (parts.length !== 3) return done(new $iegT3('jwt malformed'));
    var decodedToken;
    try {
        decodedToken = $4kgx4(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $iegT3('invalid token'));
    var header = decodedToken.header;
    var getSecret;
    if (typeof secretOrPublicKey === 'function') {
        if (!callback) return done(new $iegT3('verify must be called asynchronous if secret or public key is provided as a callback'));
        getSecret = secretOrPublicKey;
    } else getSecret = function(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $iegT3('error in secret or public key callback: ' + err.message));
        var hasSignature = parts[2].trim() !== '';
        if (!hasSignature && secretOrPublicKey) return done(new $iegT3('jwt signature is required'));
        if (hasSignature && !secretOrPublicKey) return done(new $iegT3('secret or public key must be provided'));
        if (!hasSignature && !options.algorithms) options.algorithms = [
            'none'
        ];
        if (!options.algorithms) options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') || ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ? $0823715b0a1c6796$var$PUB_KEY_ALGS : ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ? $0823715b0a1c6796$var$RSA_KEY_ALGS : $0823715b0a1c6796$var$HS_ALGS;
        if (!~options.algorithms.indexOf(decodedToken.header.alg)) return done(new $iegT3('invalid algorithm'));
        var valid;
        try {
            valid = $fuOhN.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $iegT3('invalid signature'));
        var payload = decodedToken.payload;
        if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== 'number') return done(new $iegT3('invalid nbf value'));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $6Ogh4('jwt not active', new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
            if (typeof payload.exp !== 'number') return done(new $iegT3('invalid exp value'));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $j0d2F('jwt expired', new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            var audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            var target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            var match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $iegT3('jwt audience invalid. expected: ' + audiences.join(' or ')));
        }
        if (options.issuer) {
            var invalid_issuer = typeof options.issuer === 'string' && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $iegT3('jwt issuer invalid. expected: ' + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $iegT3('jwt subject invalid. expected: ' + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $iegT3('jwt jwtid invalid. expected: ' + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $iegT3('jwt nonce invalid. expected: ' + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== 'number') return done(new $iegT3('iat required when maxAge is specified'));
            var maxAgeTimestamp = $dK2v1(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === 'undefined') return done(new $iegT3('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $j0d2F('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            var signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRegister("iegT3", function(module, exports) {
var $d456a234801a5f2a$var$JsonWebTokenError = function(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = 'JsonWebTokenError';
    this.message = message;
    if (error) this.inner = error;
};
$d456a234801a5f2a$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$d456a234801a5f2a$var$JsonWebTokenError.prototype.constructor = $d456a234801a5f2a$var$JsonWebTokenError;
module.exports = $d456a234801a5f2a$var$JsonWebTokenError;

});

parcelRegister("6Ogh4", function(module, exports) {

var $iegT3 = parcelRequire("iegT3");
var $4f540953b399d857$var$NotBeforeError = function(message, date) {
    $iegT3.call(this, message);
    this.name = 'NotBeforeError';
    this.date = date;
};
$4f540953b399d857$var$NotBeforeError.prototype = Object.create($iegT3.prototype);
$4f540953b399d857$var$NotBeforeError.prototype.constructor = $4f540953b399d857$var$NotBeforeError;
module.exports = $4f540953b399d857$var$NotBeforeError;

});

parcelRegister("j0d2F", function(module, exports) {

var $iegT3 = parcelRequire("iegT3");
var $dd58224331d447de$var$TokenExpiredError = function(message, expiredAt) {
    $iegT3.call(this, message);
    this.name = 'TokenExpiredError';
    this.expiredAt = expiredAt;
};
$dd58224331d447de$var$TokenExpiredError.prototype = Object.create($iegT3.prototype);
$dd58224331d447de$var$TokenExpiredError.prototype.constructor = $dd58224331d447de$var$TokenExpiredError;
module.exports = $dd58224331d447de$var$TokenExpiredError;

});

parcelRegister("dK2v1", function(module, exports) {

var $l9wOm = parcelRequire("l9wOm");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === 'string') {
        var milliseconds = $l9wOm(time);
        if (typeof milliseconds === 'undefined') return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === 'number') return timestamp + time;
    else return;
};

});
parcelRegister("l9wOm", function(module, exports) {
/**
 * Helpers.
 */ var $f663e3df24e639d1$var$s = 1000;
var $f663e3df24e639d1$var$m = $f663e3df24e639d1$var$s * 60;
var $f663e3df24e639d1$var$h = $f663e3df24e639d1$var$m * 60;
var $f663e3df24e639d1$var$d = $f663e3df24e639d1$var$h * 24;
var $f663e3df24e639d1$var$w = $f663e3df24e639d1$var$d * 7;
var $f663e3df24e639d1$var$y = $f663e3df24e639d1$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $f663e3df24e639d1$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $f663e3df24e639d1$var$fmtLong(val) : $f663e3df24e639d1$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $f663e3df24e639d1$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $f663e3df24e639d1$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $f663e3df24e639d1$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $f663e3df24e639d1$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $f663e3df24e639d1$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $f663e3df24e639d1$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $f663e3df24e639d1$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f663e3df24e639d1$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $f663e3df24e639d1$var$d) return Math.round(ms / $f663e3df24e639d1$var$d) + 'd';
    if (msAbs >= $f663e3df24e639d1$var$h) return Math.round(ms / $f663e3df24e639d1$var$h) + 'h';
    if (msAbs >= $f663e3df24e639d1$var$m) return Math.round(ms / $f663e3df24e639d1$var$m) + 'm';
    if (msAbs >= $f663e3df24e639d1$var$s) return Math.round(ms / $f663e3df24e639d1$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $f663e3df24e639d1$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $f663e3df24e639d1$var$d) return $f663e3df24e639d1$var$plural(ms, msAbs, $f663e3df24e639d1$var$d, 'day');
    if (msAbs >= $f663e3df24e639d1$var$h) return $f663e3df24e639d1$var$plural(ms, msAbs, $f663e3df24e639d1$var$h, 'hour');
    if (msAbs >= $f663e3df24e639d1$var$m) return $f663e3df24e639d1$var$plural(ms, msAbs, $f663e3df24e639d1$var$m, 'minute');
    if (msAbs >= $f663e3df24e639d1$var$s) return $f663e3df24e639d1$var$plural(ms, msAbs, $f663e3df24e639d1$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $f663e3df24e639d1$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});


parcelRegister("uu4nw", function(module, exports) {

var $ajwPf = parcelRequire("ajwPf");

var $6Afct = parcelRequire("6Afct");
module.exports = $6Afct.satisfies($ajwPf.version, '^6.12.0 || >=8.0.0');

});
parcelRegister("6Afct", function(module, exports) {
exports = module.exports = SemVer;
var debug;
debug = function() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
// The actual regexps go on exports.re
var re = exports.re = [];
var safeRe = exports.safeRe = [];
var src = exports.src = [];
var R = 0;
var LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
var safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
function makeSafeRe(value) {
    for(var i = 0; i < safeRegexReplacements.length; i++){
        var token = safeRegexReplacements[i][0];
        var max = safeRegexReplacements[i][1];
        value = value.split(token + '*').join(token + '{0,' + max + '}').split(token + '+').join(token + '{1,' + max + '}');
    }
    return value;
}
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '\\d+';
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-]' + LETTERDASHNUMBER + '*';
// ## Main Version
// Three dot-separated numeric identifiers.
var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' + '(' + src[NUMERICIDENTIFIER] + ')\\.' + '(' + src[NUMERICIDENTIFIER] + ')';
var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' + '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' + '(' + src[NUMERICIDENTIFIERLOOSE] + ')';
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] + '|' + src[NONNUMERICIDENTIFIER] + ')';
var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] + '|' + src[NONNUMERICIDENTIFIER] + ')';
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] + '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';
var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] + '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = LETTERDASHNUMBER + '+';
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] + '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] + src[PRERELEASE] + '?' + src[BUILD] + '?';
src[FULL] = '^' + FULLPLAIN + '$';
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] + src[PRERELEASELOOSE] + '?' + src[BUILD] + '?';
var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';
var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';
var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' + '(?:' + src[PRERELEASE] + ')?' + src[BUILD] + '?' + ')?)?';
var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:' + src[PRERELEASELOOSE] + ')?' + src[BUILD] + '?' + ')?)?';
var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = "(?:^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + '})' + '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' + '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' + '(?:$|[^\\d])';
// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';
var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
safeRe[TILDETRIM] = new RegExp(makeSafeRe(src[TILDETRIM]), 'g');
var tildeTrimReplace = '$1~';
var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';
// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';
var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
safeRe[CARETTRIM] = new RegExp(makeSafeRe(src[CARETTRIM]), 'g');
var caretTrimReplace = '$1^';
var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';
// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] + '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';
// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
safeRe[COMPARATORTRIM] = new RegExp(makeSafeRe(src[COMPARATORTRIM]), 'g');
var comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' + '\\s+-\\s+' + '(' + src[XRANGEPLAIN] + ')' + '\\s*$';
var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' + '\\s+-\\s+' + '(' + src[XRANGEPLAINLOOSE] + ')' + '\\s*$';
// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) {
        re[i] = new RegExp(src[i]);
        // Replace all greedy whitespace to prevent regex dos issues. These regex are
        // used internally via the safeRe object since all inputs in this library get
        // normalized first to trim and collapse all extra whitespace. The original
        // regexes are exported for userland consumption and lower level usage. A
        // future breaking change could export the safer regex only with a note that
        // all input should have extra whitespace removed.
        safeRe[i] = new RegExp(makeSafeRe(src[i]));
    }
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== 'string') return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? safeRe[LOOSE] : safeRe[FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== 'string') throw new TypeError('Invalid Version: ' + version);
    if (version.length > MAX_LENGTH) throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters');
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug('SemVer', version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? safeRe[LOOSE] : safeRe[FULL]);
    if (!m) throw new TypeError('Invalid Version: ' + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split('.').map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split('.') : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + '.' + this.minor + '.' + this.patch;
    if (this.prerelease.length) this.version += '-' + this.prerelease.join('.');
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug('SemVer.compare', this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug('prerelease compare', i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case 'premajor':
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc('pre', identifier);
            break;
        case 'preminor':
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc('pre', identifier);
            break;
        case 'prepatch':
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc('patch', identifier);
            this.inc('pre', identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case 'prerelease':
            if (this.prerelease.length === 0) this.inc('patch', identifier);
            this.inc('pre', identifier);
            break;
        case 'major':
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case 'minor':
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case 'patch':
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case 'pre':
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error('invalid increment argument: ' + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === 'string') {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = '';
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = 'pre';
            var defaultResult = 'prerelease';
        }
        for(var key in v1)if (key === 'major' || key === 'minor' || key === 'patch') {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compare(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.rcompare(a, b, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return eq(a, b, loose);
        case '!=':
            return neq(a, b, loose);
        case '>':
            return gt(a, b, loose);
        case '>=':
            return gte(a, b, loose);
        case '<':
            return lt(a, b, loose);
        case '<=':
            return lte(a, b, loose);
        default:
            throw new TypeError('Invalid operator: ' + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    comp = comp.trim().split(/\s+/).join(' ');
    debug('comparator', comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = '';
    else this.value = this.operator + this.semver.version;
    debug('comp', this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError('Invalid comparator: ' + comp);
    this.operator = m[1];
    if (this.operator === '=') this.operator = '';
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug('Comparator.test', version, this.options.loose);
    if (this.semver === ANY) return true;
    if (typeof version === 'string') version = new SemVer(version, this.options);
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === '') {
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === '') {
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === '>=' || this.operator === '>') && (comp.operator === '>=' || comp.operator === '>');
    var sameDirectionDecreasing = (this.operator === '<=' || this.operator === '<') && (comp.operator === '<=' || comp.operator === '<');
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === '>=' || this.operator === '<=') && (comp.operator === '>=' || comp.operator === '<=');
    var oppositeDirectionsLessThan = cmp(this.semver, '<', comp.semver, options) && (this.operator === '>=' || this.operator === '>') && (comp.operator === '<=' || comp.operator === '<');
    var oppositeDirectionsGreaterThan = cmp(this.semver, '>', comp.semver, options) && (this.operator === '<=' || this.operator === '<') && (comp.operator === '>=' || comp.operator === '>');
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First reduce all whitespace as much as possible so we do not have to rely
    // on potentially slow regexes like \s*. This is then stored and used for
    // future error messages as well.
    this.raw = range.trim().split(/\s+/).join(' ');
    // First, split based on boolean or ||
    this.set = this.raw.split('||').map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError('Invalid SemVer Range: ' + this.raw);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(' ').trim();
    }).join('||').trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? safeRe[HYPHENRANGELOOSE] : safeRe[HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug('hyphen replace', range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(safeRe[COMPARATORTRIM], comparatorTrimReplace);
    debug('comparator trim', range, safeRe[COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(safeRe[TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(safeRe[CARETTRIM], caretTrimReplace);
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var set = range.split(' ').map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(' ').split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError('a Range is required');
    return this.set.some(function(thisComparators) {
        return thisComparators.every(function(thisComparator) {
            return range.set.some(function(rangeComparators) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(' ').trim().split(' ');
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug('comp', comp, options);
    comp = replaceCarets(comp, options);
    debug('caret', comp);
    comp = replaceTildes(comp, options);
    debug('tildes', comp);
    comp = replaceXRanges(comp, options);
    debug('xrange', comp);
    comp = replaceStars(comp, options);
    debug('stars', comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === 'x' || id === '*';
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(' ');
}
function replaceTilde(comp, options) {
    var r = options.loose ? safeRe[TILDELOOSE] : safeRe[TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug('tilde', comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
        else if (pr) {
            debug('replaceTilde pr', pr);
            ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + (+m + 1) + '.0';
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + (+m + 1) + '.0';
        debug('tilde return', ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(' ');
}
function replaceCaret(comp, options) {
    debug('caret', comp, options);
    var r = options.loose ? safeRe[CARETLOOSE] : safeRe[CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug('caret', comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (isX(p)) {
            if (M === '0') ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
            else ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
        } else if (pr) {
            debug('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + m + '.' + (+p + 1);
                else ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + (+m + 1) + '.0';
            } else ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + (+M + 1) + '.0.0';
        } else {
            debug('no pr');
            if (M === '0') {
                if (m === '0') ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + m + '.' + (+p + 1);
                else ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + (+m + 1) + '.0';
            } else ret = '>=' + M + '.' + m + '.' + p + ' <' + (+M + 1) + '.0.0';
        }
        debug('caret return', ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug('replaceXRanges', comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(' ');
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? safeRe[XRANGELOOSE] : safeRe[XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug('xRange', comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + '.' + m + '.' + p;
        } else if (xm) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (xp) ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
        debug('xRange return', ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(safeRe[STAR], '');
}
// This function is passed to string.replace(safeRe[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = '';
    else if (isX(fm)) from = '>=' + fM + '.0.0';
    else if (isX(fp)) from = '>=' + fM + '.' + fm + '.0';
    else from = '>=' + from;
    if (isX(tM)) to = '';
    else if (isX(tm)) to = '<' + (+tM + 1) + '.0.0';
    else if (isX(tp)) to = '<' + tM + '.' + (+tm + 1) + '.0';
    else if (tpr) to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
    else to = '<=' + to;
    return (from + ' ' + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === 'string') version = new SemVer(version, this.options);
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer('0.0.0');
    if (range.test(minver)) return minver;
    minver = new SemVer('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error('Unexpected operation: ' + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || '*';
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, '<', options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, '>', options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version) {
    if (version instanceof SemVer) return version;
    if (typeof version !== 'string') return null;
    var match = version.match(safeRe[COERCE]);
    if (match == null) return null;
    return parse(match[1] + '.' + (match[2] || '0') + '.' + (match[3] || '0'));
}

});



parcelRegister("bHGuR", function(module, exports) {

var $8UsMN = parcelRequire("8UsMN");
var $8854acd075952190$require$Buffer = $8UsMN.Buffer;

var $dK2v1 = parcelRequire("dK2v1");

var $uu4nw = parcelRequire("uu4nw");

var $fuOhN = parcelRequire("fuOhN");

var $kgX4w = parcelRequire("kgX4w");

var $gAKel = parcelRequire("gAKel");

var $bg7sw = parcelRequire("bg7sw");

var $kiYAc = parcelRequire("kiYAc");

var $dEIfR = parcelRequire("dEIfR");

var $jPi6q = parcelRequire("jPi6q");

var $apJvU = parcelRequire("apJvU");
var $8854acd075952190$var$SUPPORTED_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512',
    'HS256',
    'HS384',
    'HS512',
    'none'
];
if ($uu4nw) $8854acd075952190$var$SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
var $8854acd075952190$var$sign_options_schema = {
    expiresIn: {
        isValid: function(value) {
            return $bg7sw(value) || $jPi6q(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function(value) {
            return $bg7sw(value) || $jPi6q(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function(value) {
            return $jPi6q(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $kgX4w.bind(null, $8854acd075952190$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $dEIfR,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $jPi6q,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $jPi6q,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $jPi6q,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $jPi6q,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $gAKel,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $jPi6q,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $gAKel,
        message: '"mutatePayload" must be a boolean'
    }
};
var $8854acd075952190$var$registered_claims_schema = {
    iat: {
        isValid: $kiYAc,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $kiYAc,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $kiYAc,
        message: '"nbf" should be a number of seconds'
    }
};
function $8854acd075952190$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$dEIfR(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        var validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $8854acd075952190$var$validateOptions(options) {
    return $8854acd075952190$var$validate($8854acd075952190$var$sign_options_schema, false, options, 'options');
}
function $8854acd075952190$var$validatePayload(payload) {
    return $8854acd075952190$var$validate($8854acd075952190$var$registered_claims_schema, true, payload, 'payload');
}
var $8854acd075952190$var$options_to_payload = {
    'audience': 'aud',
    'issuer': 'iss',
    'subject': 'sub',
    'jwtid': 'jti'
};
var $8854acd075952190$var$options_for_objects = [
    'expiresIn',
    'notBefore',
    'noTimestamp',
    'audience',
    'issuer',
    'subject',
    'jwtid'
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    } else options = options || {};
    var isObjectPayload = typeof payload === 'object' && !$8854acd075952190$require$Buffer.isBuffer(payload);
    var header = Object.assign({
        alg: options.algorithm || 'HS256',
        typ: isObjectPayload ? 'JWT' : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== 'none') return failure(new Error('secretOrPrivateKey must have a value'));
    if (typeof payload === 'undefined') return failure(new Error('payload is required'));
    else if (isObjectPayload) {
        try {
            $8854acd075952190$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        var invalid_options = $8854acd075952190$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== 'undefined';
        });
        if (invalid_options.length > 0) return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + typeof payload + ' payload'));
    }
    if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $8854acd075952190$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    var timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== 'undefined') {
        try {
            payload.nbf = $dK2v1(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === 'undefined') return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
        try {
            payload.exp = $dK2v1(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === 'undefined') return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($8854acd075952190$var$options_to_payload).forEach(function(key) {
        var claim = $8854acd075952190$var$options_to_payload[key];
        if (typeof options[key] !== 'undefined') {
            if (typeof payload[claim] !== 'undefined') return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    var encoding = options.encoding || 'utf8';
    if (typeof callback === 'function') {
        callback = callback && $apJvU(callback);
        $fuOhN.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once('error', callback).once('done', function(signature) {
            callback(null, signature);
        });
    } else return $fuOhN.sign({
        header: header,
        payload: payload,
        secret: secretOrPrivateKey,
        encoding: encoding
    });
};

});
parcelRegister("kgX4w", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $ec231fbd9f471a46$var$INFINITY = 1 / 0, $ec231fbd9f471a46$var$MAX_SAFE_INTEGER = 9007199254740991, $ec231fbd9f471a46$var$MAX_INTEGER = 1.7976931348623157e+308, $ec231fbd9f471a46$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ec231fbd9f471a46$var$argsTag = '[object Arguments]', $ec231fbd9f471a46$var$funcTag = '[object Function]', $ec231fbd9f471a46$var$genTag = '[object GeneratorFunction]', $ec231fbd9f471a46$var$stringTag = '[object String]', $ec231fbd9f471a46$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $ec231fbd9f471a46$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ec231fbd9f471a46$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ec231fbd9f471a46$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ec231fbd9f471a46$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $ec231fbd9f471a46$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $ec231fbd9f471a46$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $ec231fbd9f471a46$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ec231fbd9f471a46$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ec231fbd9f471a46$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $ec231fbd9f471a46$var$baseFindIndex(array, $ec231fbd9f471a46$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $ec231fbd9f471a46$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $ec231fbd9f471a46$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $ec231fbd9f471a46$var$baseValues(object, props) {
    return $ec231fbd9f471a46$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ec231fbd9f471a46$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $ec231fbd9f471a46$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ec231fbd9f471a46$var$hasOwnProperty = $ec231fbd9f471a46$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ec231fbd9f471a46$var$objectToString = $ec231fbd9f471a46$var$objectProto.toString;
/** Built-in value references. */ var $ec231fbd9f471a46$var$propertyIsEnumerable = $ec231fbd9f471a46$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ec231fbd9f471a46$var$nativeKeys = $ec231fbd9f471a46$var$overArg(Object.keys, Object), $ec231fbd9f471a46$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $ec231fbd9f471a46$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $ec231fbd9f471a46$var$isArray(value) || $ec231fbd9f471a46$var$isArguments(value) ? $ec231fbd9f471a46$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $ec231fbd9f471a46$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $ec231fbd9f471a46$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ec231fbd9f471a46$var$baseKeys(object) {
    if (!$ec231fbd9f471a46$var$isPrototype(object)) return $ec231fbd9f471a46$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($ec231fbd9f471a46$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $ec231fbd9f471a46$var$isIndex(value, length) {
    length = length == null ? $ec231fbd9f471a46$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $ec231fbd9f471a46$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $ec231fbd9f471a46$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $ec231fbd9f471a46$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $ec231fbd9f471a46$var$includes(collection, value, fromIndex, guard) {
    collection = $ec231fbd9f471a46$var$isArrayLike(collection) ? collection : $ec231fbd9f471a46$var$values(collection);
    fromIndex = fromIndex && !guard ? $ec231fbd9f471a46$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $ec231fbd9f471a46$var$nativeMax(length + fromIndex, 0);
    return $ec231fbd9f471a46$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $ec231fbd9f471a46$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $ec231fbd9f471a46$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $ec231fbd9f471a46$var$isArrayLikeObject(value) && $ec231fbd9f471a46$var$hasOwnProperty.call(value, 'callee') && (!$ec231fbd9f471a46$var$propertyIsEnumerable.call(value, 'callee') || $ec231fbd9f471a46$var$objectToString.call(value) == $ec231fbd9f471a46$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $ec231fbd9f471a46$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ec231fbd9f471a46$var$isArrayLike(value) {
    return value != null && $ec231fbd9f471a46$var$isLength(value.length) && !$ec231fbd9f471a46$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $ec231fbd9f471a46$var$isArrayLikeObject(value) {
    return $ec231fbd9f471a46$var$isObjectLike(value) && $ec231fbd9f471a46$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $ec231fbd9f471a46$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $ec231fbd9f471a46$var$isObject(value) ? $ec231fbd9f471a46$var$objectToString.call(value) : '';
    return tag == $ec231fbd9f471a46$var$funcTag || tag == $ec231fbd9f471a46$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ec231fbd9f471a46$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $ec231fbd9f471a46$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ec231fbd9f471a46$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ec231fbd9f471a46$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $ec231fbd9f471a46$var$isString(value) {
    return typeof value == 'string' || !$ec231fbd9f471a46$var$isArray(value) && $ec231fbd9f471a46$var$isObjectLike(value) && $ec231fbd9f471a46$var$objectToString.call(value) == $ec231fbd9f471a46$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ec231fbd9f471a46$var$isSymbol(value) {
    return typeof value == 'symbol' || $ec231fbd9f471a46$var$isObjectLike(value) && $ec231fbd9f471a46$var$objectToString.call(value) == $ec231fbd9f471a46$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $ec231fbd9f471a46$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $ec231fbd9f471a46$var$toNumber(value);
    if (value === $ec231fbd9f471a46$var$INFINITY || value === -$ec231fbd9f471a46$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $ec231fbd9f471a46$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $ec231fbd9f471a46$var$toInteger(value) {
    var result = $ec231fbd9f471a46$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ec231fbd9f471a46$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($ec231fbd9f471a46$var$isSymbol(value)) return $ec231fbd9f471a46$var$NAN;
    if ($ec231fbd9f471a46$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $ec231fbd9f471a46$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($ec231fbd9f471a46$var$reTrim, '');
    var isBinary = $ec231fbd9f471a46$var$reIsBinary.test(value);
    return isBinary || $ec231fbd9f471a46$var$reIsOctal.test(value) ? $ec231fbd9f471a46$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ec231fbd9f471a46$var$reIsBadHex.test(value) ? $ec231fbd9f471a46$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $ec231fbd9f471a46$var$keys(object) {
    return $ec231fbd9f471a46$var$isArrayLike(object) ? $ec231fbd9f471a46$var$arrayLikeKeys(object) : $ec231fbd9f471a46$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $ec231fbd9f471a46$var$values(object) {
    return object ? $ec231fbd9f471a46$var$baseValues(object, $ec231fbd9f471a46$var$keys(object)) : [];
}
module.exports = $ec231fbd9f471a46$var$includes;

});

parcelRegister("gAKel", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $c143de83e142402e$var$boolTag = '[object Boolean]';
/** Used for built-in method references. */ var $c143de83e142402e$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c143de83e142402e$var$objectToString = $c143de83e142402e$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $c143de83e142402e$var$isBoolean(value) {
    return value === true || value === false || $c143de83e142402e$var$isObjectLike(value) && $c143de83e142402e$var$objectToString.call(value) == $c143de83e142402e$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c143de83e142402e$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = $c143de83e142402e$var$isBoolean;

});

parcelRegister("bg7sw", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $8326f98db34b7279$var$INFINITY = 1 / 0, $8326f98db34b7279$var$MAX_INTEGER = 1.7976931348623157e+308, $8326f98db34b7279$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $8326f98db34b7279$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $8326f98db34b7279$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $8326f98db34b7279$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8326f98db34b7279$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8326f98db34b7279$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8326f98db34b7279$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $8326f98db34b7279$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8326f98db34b7279$var$objectToString = $8326f98db34b7279$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $8326f98db34b7279$var$isInteger(value) {
    return typeof value == 'number' && value == $8326f98db34b7279$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $8326f98db34b7279$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8326f98db34b7279$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8326f98db34b7279$var$isSymbol(value) {
    return typeof value == 'symbol' || $8326f98db34b7279$var$isObjectLike(value) && $8326f98db34b7279$var$objectToString.call(value) == $8326f98db34b7279$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $8326f98db34b7279$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $8326f98db34b7279$var$toNumber(value);
    if (value === $8326f98db34b7279$var$INFINITY || value === -$8326f98db34b7279$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $8326f98db34b7279$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $8326f98db34b7279$var$toInteger(value) {
    var result = $8326f98db34b7279$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8326f98db34b7279$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($8326f98db34b7279$var$isSymbol(value)) return $8326f98db34b7279$var$NAN;
    if ($8326f98db34b7279$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $8326f98db34b7279$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($8326f98db34b7279$var$reTrim, '');
    var isBinary = $8326f98db34b7279$var$reIsBinary.test(value);
    return isBinary || $8326f98db34b7279$var$reIsOctal.test(value) ? $8326f98db34b7279$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8326f98db34b7279$var$reIsBadHex.test(value) ? $8326f98db34b7279$var$NAN : +value;
}
module.exports = $8326f98db34b7279$var$isInteger;

});

parcelRegister("kiYAc", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $ec847b92d5ba703c$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $ec847b92d5ba703c$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ec847b92d5ba703c$var$objectToString = $ec847b92d5ba703c$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ec847b92d5ba703c$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $ec847b92d5ba703c$var$isNumber(value) {
    return typeof value == 'number' || $ec847b92d5ba703c$var$isObjectLike(value) && $ec847b92d5ba703c$var$objectToString.call(value) == $ec847b92d5ba703c$var$numberTag;
}
module.exports = $ec847b92d5ba703c$var$isNumber;

});

parcelRegister("dEIfR", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $9f1156e261c35ef1$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $9f1156e261c35ef1$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $9f1156e261c35ef1$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $9f1156e261c35ef1$var$funcProto = Function.prototype, $9f1156e261c35ef1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $9f1156e261c35ef1$var$funcToString = $9f1156e261c35ef1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $9f1156e261c35ef1$var$hasOwnProperty = $9f1156e261c35ef1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $9f1156e261c35ef1$var$objectCtorString = $9f1156e261c35ef1$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9f1156e261c35ef1$var$objectToString = $9f1156e261c35ef1$var$objectProto.toString;
/** Built-in value references. */ var $9f1156e261c35ef1$var$getPrototype = $9f1156e261c35ef1$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $9f1156e261c35ef1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $9f1156e261c35ef1$var$isPlainObject(value) {
    if (!$9f1156e261c35ef1$var$isObjectLike(value) || $9f1156e261c35ef1$var$objectToString.call(value) != $9f1156e261c35ef1$var$objectTag || $9f1156e261c35ef1$var$isHostObject(value)) return false;
    var proto = $9f1156e261c35ef1$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $9f1156e261c35ef1$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $9f1156e261c35ef1$var$funcToString.call(Ctor) == $9f1156e261c35ef1$var$objectCtorString;
}
module.exports = $9f1156e261c35ef1$var$isPlainObject;

});

parcelRegister("jPi6q", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $e6f0d28cd65dc3ba$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $e6f0d28cd65dc3ba$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e6f0d28cd65dc3ba$var$objectToString = $e6f0d28cd65dc3ba$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $e6f0d28cd65dc3ba$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $e6f0d28cd65dc3ba$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $e6f0d28cd65dc3ba$var$isString(value) {
    return typeof value == 'string' || !$e6f0d28cd65dc3ba$var$isArray(value) && $e6f0d28cd65dc3ba$var$isObjectLike(value) && $e6f0d28cd65dc3ba$var$objectToString.call(value) == $e6f0d28cd65dc3ba$var$stringTag;
}
module.exports = $e6f0d28cd65dc3ba$var$isString;

});

parcelRegister("apJvU", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $794f8b3e28fd5e63$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $794f8b3e28fd5e63$var$INFINITY = 1 / 0, $794f8b3e28fd5e63$var$MAX_INTEGER = 1.7976931348623157e+308, $794f8b3e28fd5e63$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $794f8b3e28fd5e63$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $794f8b3e28fd5e63$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $794f8b3e28fd5e63$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $794f8b3e28fd5e63$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $794f8b3e28fd5e63$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $794f8b3e28fd5e63$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $794f8b3e28fd5e63$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $794f8b3e28fd5e63$var$objectToString = $794f8b3e28fd5e63$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $794f8b3e28fd5e63$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($794f8b3e28fd5e63$var$FUNC_ERROR_TEXT);
    n = $794f8b3e28fd5e63$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $794f8b3e28fd5e63$var$once(func) {
    return $794f8b3e28fd5e63$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $794f8b3e28fd5e63$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $794f8b3e28fd5e63$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $794f8b3e28fd5e63$var$isSymbol(value) {
    return typeof value == 'symbol' || $794f8b3e28fd5e63$var$isObjectLike(value) && $794f8b3e28fd5e63$var$objectToString.call(value) == $794f8b3e28fd5e63$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $794f8b3e28fd5e63$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $794f8b3e28fd5e63$var$toNumber(value);
    if (value === $794f8b3e28fd5e63$var$INFINITY || value === -$794f8b3e28fd5e63$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $794f8b3e28fd5e63$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $794f8b3e28fd5e63$var$toInteger(value) {
    var result = $794f8b3e28fd5e63$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $794f8b3e28fd5e63$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($794f8b3e28fd5e63$var$isSymbol(value)) return $794f8b3e28fd5e63$var$NAN;
    if ($794f8b3e28fd5e63$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $794f8b3e28fd5e63$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($794f8b3e28fd5e63$var$reTrim, '');
    var isBinary = $794f8b3e28fd5e63$var$reIsBinary.test(value);
    return isBinary || $794f8b3e28fd5e63$var$reIsOctal.test(value) ? $794f8b3e28fd5e63$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $794f8b3e28fd5e63$var$reIsBadHex.test(value) ? $794f8b3e28fd5e63$var$NAN : +value;
}
module.exports = $794f8b3e28fd5e63$var$once;

});


parcelRegister("gpBw0", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");

var $jZTcE = parcelRequire("jZTcE");

var $dSbzl = parcelRequire("dSbzl");

var $9aq3h = parcelRequire("9aq3h");

var $jMlqx = parcelRequire("jMlqx");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $bf2c14e5848a70c6$var$createInstance(defaultConfig) {
    var context = new $dSbzl(defaultConfig);
    var instance = $jZTcE($dSbzl.prototype.request, context);
    // Copy axios.prototype to instance
    $lj5dW.extend(instance, $dSbzl.prototype, context);
    // Copy context to instance
    $lj5dW.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $bf2c14e5848a70c6$var$createInstance($9aq3h(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $bf2c14e5848a70c6$var$axios = $bf2c14e5848a70c6$var$createInstance($jMlqx);
// Expose Axios class to allow class inheritance
$bf2c14e5848a70c6$var$axios.Axios = $dSbzl;

// Expose Cancel & CancelToken
$bf2c14e5848a70c6$var$axios.Cancel = (parcelRequire("6DSPz"));

$bf2c14e5848a70c6$var$axios.CancelToken = (parcelRequire("1Nz00"));

$bf2c14e5848a70c6$var$axios.isCancel = (parcelRequire("kNZMC"));

$bf2c14e5848a70c6$var$axios.VERSION = (parcelRequire("9ISWg")).version;
// Expose all/spread
$bf2c14e5848a70c6$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$bf2c14e5848a70c6$var$axios.spread = (parcelRequire("cUOV7"));

// Expose isAxiosError
$bf2c14e5848a70c6$var$axios.isAxiosError = (parcelRequire("b5ubl"));
module.exports = $bf2c14e5848a70c6$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $bf2c14e5848a70c6$var$axios;

});
parcelRegister("lj5dW", function(module, exports) {
'use strict';

var $jZTcE = parcelRequire("jZTcE");
// utils is a library of generic helper functions non-specific to axios
var $f82f6cac3f4f8894$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $f82f6cac3f4f8894$var$isArray(val) {
    return Array.isArray(val);
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $f82f6cac3f4f8894$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $f82f6cac3f4f8894$var$isBuffer(val) {
    return val !== null && !$f82f6cac3f4f8894$var$isUndefined(val) && val.constructor !== null && !$f82f6cac3f4f8894$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $f82f6cac3f4f8894$var$isArrayBuffer(val) {
    return $f82f6cac3f4f8894$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $f82f6cac3f4f8894$var$isFormData(val) {
    return $f82f6cac3f4f8894$var$toString.call(val) === '[object FormData]';
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $f82f6cac3f4f8894$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $f82f6cac3f4f8894$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $f82f6cac3f4f8894$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $f82f6cac3f4f8894$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $f82f6cac3f4f8894$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $f82f6cac3f4f8894$var$isPlainObject(val) {
    if ($f82f6cac3f4f8894$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $f82f6cac3f4f8894$var$isDate(val) {
    return $f82f6cac3f4f8894$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $f82f6cac3f4f8894$var$isFile(val) {
    return $f82f6cac3f4f8894$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $f82f6cac3f4f8894$var$isBlob(val) {
    return $f82f6cac3f4f8894$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $f82f6cac3f4f8894$var$isFunction(val) {
    return $f82f6cac3f4f8894$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $f82f6cac3f4f8894$var$isStream(val) {
    return $f82f6cac3f4f8894$var$isObject(val) && $f82f6cac3f4f8894$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $f82f6cac3f4f8894$var$isURLSearchParams(val) {
    return $f82f6cac3f4f8894$var$toString.call(val) === '[object URLSearchParams]';
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $f82f6cac3f4f8894$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $f82f6cac3f4f8894$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $f82f6cac3f4f8894$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($f82f6cac3f4f8894$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $f82f6cac3f4f8894$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($f82f6cac3f4f8894$var$isPlainObject(result[key]) && $f82f6cac3f4f8894$var$isPlainObject(val)) result[key] = $f82f6cac3f4f8894$var$merge(result[key], val);
        else if ($f82f6cac3f4f8894$var$isPlainObject(val)) result[key] = $f82f6cac3f4f8894$var$merge({}, val);
        else if ($f82f6cac3f4f8894$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$f82f6cac3f4f8894$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $f82f6cac3f4f8894$var$extend(a, b, thisArg) {
    $f82f6cac3f4f8894$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $jZTcE(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $f82f6cac3f4f8894$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $f82f6cac3f4f8894$var$isArray,
    isArrayBuffer: $f82f6cac3f4f8894$var$isArrayBuffer,
    isBuffer: $f82f6cac3f4f8894$var$isBuffer,
    isFormData: $f82f6cac3f4f8894$var$isFormData,
    isArrayBufferView: $f82f6cac3f4f8894$var$isArrayBufferView,
    isString: $f82f6cac3f4f8894$var$isString,
    isNumber: $f82f6cac3f4f8894$var$isNumber,
    isObject: $f82f6cac3f4f8894$var$isObject,
    isPlainObject: $f82f6cac3f4f8894$var$isPlainObject,
    isUndefined: $f82f6cac3f4f8894$var$isUndefined,
    isDate: $f82f6cac3f4f8894$var$isDate,
    isFile: $f82f6cac3f4f8894$var$isFile,
    isBlob: $f82f6cac3f4f8894$var$isBlob,
    isFunction: $f82f6cac3f4f8894$var$isFunction,
    isStream: $f82f6cac3f4f8894$var$isStream,
    isURLSearchParams: $f82f6cac3f4f8894$var$isURLSearchParams,
    isStandardBrowserEnv: $f82f6cac3f4f8894$var$isStandardBrowserEnv,
    forEach: $f82f6cac3f4f8894$var$forEach,
    merge: $f82f6cac3f4f8894$var$merge,
    extend: $f82f6cac3f4f8894$var$extend,
    trim: $f82f6cac3f4f8894$var$trim,
    stripBOM: $f82f6cac3f4f8894$var$stripBOM
};

});
parcelRegister("jZTcE", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("dSbzl", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");

var $jyXmo = parcelRequire("jyXmo");

var $3e1mo = parcelRequire("3e1mo");

var $8HjTW = parcelRequire("8HjTW");

var $9aq3h = parcelRequire("9aq3h");

var $2Di3s = parcelRequire("2Di3s");
var $a1994add25e3a6a7$var$validators = $2Di3s.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $a1994add25e3a6a7$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $3e1mo(),
        response: new $3e1mo()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $a1994add25e3a6a7$var$Axios.prototype.request = function request(configOrUrl, config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof configOrUrl === 'string') {
        config = config || {};
        config.url = configOrUrl;
    } else config = configOrUrl || {};
    config = $9aq3h(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $2Di3s.assertOptions(transitional, {
        silentJSONParsing: $a1994add25e3a6a7$var$validators.transitional($a1994add25e3a6a7$var$validators.boolean),
        forcedJSONParsing: $a1994add25e3a6a7$var$validators.transitional($a1994add25e3a6a7$var$validators.boolean),
        clarifyTimeoutError: $a1994add25e3a6a7$var$validators.transitional($a1994add25e3a6a7$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $8HjTW,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $8HjTW(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$a1994add25e3a6a7$var$Axios.prototype.getUri = function getUri(config) {
    config = $9aq3h(this.defaults, config);
    return $jyXmo(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$lj5dW.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a1994add25e3a6a7$var$Axios.prototype[method] = function(url, config) {
        return this.request($9aq3h(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$lj5dW.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $a1994add25e3a6a7$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($9aq3h(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $a1994add25e3a6a7$var$Axios;

});
parcelRegister("jyXmo", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
function $e3df3d0125e474be$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($lj5dW.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $lj5dW.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($lj5dW.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $lj5dW.forEach(val, function parseValue(v) {
                if ($lj5dW.isDate(v)) v = v.toISOString();
                else if ($lj5dW.isObject(v)) v = JSON.stringify(v);
                parts.push($e3df3d0125e474be$var$encode(key) + '=' + $e3df3d0125e474be$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("3e1mo", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
function $2593bc06bc41f8c0$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $2593bc06bc41f8c0$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $2593bc06bc41f8c0$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $2593bc06bc41f8c0$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $lj5dW.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $2593bc06bc41f8c0$var$InterceptorManager;

});

parcelRegister("8HjTW", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");

var $7fuN5 = parcelRequire("7fuN5");

var $kNZMC = parcelRequire("kNZMC");

var $jMlqx = parcelRequire("jMlqx");

var $6DSPz = parcelRequire("6DSPz");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $6551c6dfb68eeae4$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $6DSPz('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $6551c6dfb68eeae4$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $7fuN5.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $lj5dW.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $lj5dW.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $jMlqx.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $6551c6dfb68eeae4$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $7fuN5.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$kNZMC(reason)) {
            $6551c6dfb68eeae4$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $7fuN5.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("7fuN5", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");

var $jMlqx = parcelRequire("jMlqx");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $jMlqx;
    /*eslint no-param-reassign:0*/ $lj5dW.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("jMlqx", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");

var $jUqWy = parcelRequire("jUqWy");

var $8Po8x = parcelRequire("8Po8x");

var $1jZh3 = parcelRequire("1jZh3");
var $e6631efcd7b3c13f$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $e6631efcd7b3c13f$var$setContentTypeIfUnset(headers, value) {
    if (!$lj5dW.isUndefined(headers) && $lj5dW.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $e6631efcd7b3c13f$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("8rSqM"));
    return adapter;
}
function $e6631efcd7b3c13f$var$stringifySafely(rawValue, parser, encoder) {
    if ($lj5dW.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $lj5dW.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $e6631efcd7b3c13f$var$defaults = {
    transitional: $1jZh3,
    adapter: $e6631efcd7b3c13f$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $jUqWy(headers, 'Accept');
            $jUqWy(headers, 'Content-Type');
            if ($lj5dW.isFormData(data) || $lj5dW.isArrayBuffer(data) || $lj5dW.isBuffer(data) || $lj5dW.isStream(data) || $lj5dW.isFile(data) || $lj5dW.isBlob(data)) return data;
            if ($lj5dW.isArrayBufferView(data)) return data.buffer;
            if ($lj5dW.isURLSearchParams(data)) {
                $e6631efcd7b3c13f$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($lj5dW.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $e6631efcd7b3c13f$var$setContentTypeIfUnset(headers, 'application/json');
                return $e6631efcd7b3c13f$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $e6631efcd7b3c13f$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $lj5dW.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $8Po8x(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$lj5dW.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $e6631efcd7b3c13f$var$defaults.headers[method] = {};
});
$lj5dW.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $e6631efcd7b3c13f$var$defaults.headers[method] = $lj5dW.merge($e6631efcd7b3c13f$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $e6631efcd7b3c13f$var$defaults;

});
parcelRegister("jUqWy", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $lj5dW.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("8Po8x", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("1jZh3", function(module, exports) {
'use strict';
module.exports = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

});

parcelRegister("8rSqM", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");

var $3ctvK = parcelRequire("3ctvK");

var $3Aers = parcelRequire("3Aers");

var $jyXmo = parcelRequire("jyXmo");

var $lm4f5 = parcelRequire("lm4f5");

var $9DUXE = parcelRequire("9DUXE");

var $hpPN4 = parcelRequire("hpPN4");

var $funDE = parcelRequire("funDE");

var $1jZh3 = parcelRequire("1jZh3");

var $6DSPz = parcelRequire("6DSPz");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($lj5dW.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $lm4f5(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $jyXmo(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $9DUXE(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3ctvK(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($funDE('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($funDE('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $1jZh3;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($funDE(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($lj5dW.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $hpPN4(fullPath)) && config.xsrfCookieName ? $3Aers.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $lj5dW.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$lj5dW.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $6DSPz('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3ctvK", function(module, exports) {
'use strict';

var $funDE = parcelRequire("funDE");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($funDE('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("funDE", function(module, exports) {
'use strict';

var $8Po8x = parcelRequire("8Po8x");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $8Po8x(error, config, code, request, response);
};

});


parcelRegister("3Aers", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
module.exports = $lj5dW.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($lj5dW.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($lj5dW.isString(path)) cookie.push('path=' + path);
            if ($lj5dW.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("lm4f5", function(module, exports) {
'use strict';

var $eeL33 = parcelRequire("eeL33");

var $dHFtb = parcelRequire("dHFtb");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$eeL33(requestedURL)) return $dHFtb(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("eeL33", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

});

parcelRegister("dHFtb", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("9DUXE", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $7053f0e33ad7fc7e$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $lj5dW.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $lj5dW.trim(line.substr(0, i)).toLowerCase();
        val = $lj5dW.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $7053f0e33ad7fc7e$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("hpPN4", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
module.exports = $lj5dW.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $lj5dW.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("6DSPz", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $4d60eadc21357d88$var$Cancel(message) {
    this.message = message;
}
$4d60eadc21357d88$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$4d60eadc21357d88$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $4d60eadc21357d88$var$Cancel;

});




parcelRegister("kNZMC", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("9aq3h", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($lj5dW.isPlainObject(target) && $lj5dW.isPlainObject(source)) return $lj5dW.merge(target, source);
        else if ($lj5dW.isPlainObject(source)) return $lj5dW.merge({}, source);
        else if ($lj5dW.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$lj5dW.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$lj5dW.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$lj5dW.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$lj5dW.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$lj5dW.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $lj5dW.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $lj5dW.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("2Di3s", function(module, exports) {
'use strict';

var $9ISWg = parcelRequire("9ISWg");
var $1ead3a9666a439de$require$VERSION = $9ISWg.version;
var $1ead3a9666a439de$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $1ead3a9666a439de$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $1ead3a9666a439de$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $1ead3a9666a439de$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $1ead3a9666a439de$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$1ead3a9666a439de$var$deprecatedWarnings[opt]) {
            $1ead3a9666a439de$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $1ead3a9666a439de$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $1ead3a9666a439de$var$assertOptions,
    validators: $1ead3a9666a439de$var$validators
};

});
parcelRegister("9ISWg", function(module, exports) {
module.exports = {
    "version": "0.26.1"
};

});



parcelRegister("1Nz00", function(module, exports) {
'use strict';

var $6DSPz = parcelRequire("6DSPz");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $14f584296a05c157$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $6DSPz(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $14f584296a05c157$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $14f584296a05c157$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $14f584296a05c157$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $14f584296a05c157$var$CancelToken.source = function source() {
    var cancel;
    var token = new $14f584296a05c157$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $14f584296a05c157$var$CancelToken;

});

parcelRegister("cUOV7", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("b5ubl", function(module, exports) {
'use strict';

var $lj5dW = parcelRequire("lj5dW");
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return $lj5dW.isObject(payload) && payload.isAxiosError === true;
};

});


parcelRegister("6yTTp", function(module, exports) {
(function() {
    var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', crypt = {
        // Bit-wise rotation left
        rotl: function(n, b) {
            return n << b | n >>> 32 - b;
        },
        // Bit-wise rotation right
        rotr: function(n, b) {
            return n << 32 - b | n >>> b;
        },
        // Swap big-endian to little-endian and vice versa
        endian: function(n) {
            // If number given, swap endian
            if (n.constructor == Number) return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
            // Else, assume array and swap all items
            for(var i = 0; i < n.length; i++)n[i] = crypt.endian(n[i]);
            return n;
        },
        // Generate an array of any length of random bytes
        randomBytes: function(n) {
            for(var bytes = []; n > 0; n--)bytes.push(Math.floor(Math.random() * 256));
            return bytes;
        },
        // Convert a byte array to big-endian 32-bit words
        bytesToWords: function(bytes) {
            for(var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8)words[b >>> 5] |= bytes[i] << 24 - b % 32;
            return words;
        },
        // Convert big-endian 32-bit words to a byte array
        wordsToBytes: function(words) {
            for(var bytes = [], b = 0; b < words.length * 32; b += 8)bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
            return bytes;
        },
        // Convert a byte array to a hex string
        bytesToHex: function(bytes) {
            for(var hex = [], i = 0; i < bytes.length; i++){
                hex.push((bytes[i] >>> 4).toString(16));
                hex.push((bytes[i] & 0xF).toString(16));
            }
            return hex.join('');
        },
        // Convert a hex string to a byte array
        hexToBytes: function(hex) {
            for(var bytes = [], c = 0; c < hex.length; c += 2)bytes.push(parseInt(hex.substr(c, 2), 16));
            return bytes;
        },
        // Convert a byte array to a base-64 string
        bytesToBase64: function(bytes) {
            for(var base64 = [], i = 0; i < bytes.length; i += 3){
                var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
                for(var j = 0; j < 4; j++)if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));
                else base64.push('=');
            }
            return base64.join('');
        },
        // Convert a base-64 string to a byte array
        base64ToBytes: function(base64) {
            // Remove non-base-64 characters
            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
            for(var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4){
                if (imod4 == 0) continue;
                bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
            }
            return bytes;
        }
    };
    module.exports = crypt;
})();

});

parcelRegister("6qat2", function(module, exports) {
var $4acd4a658c43cdad$var$charenc = {
    // UTF-8 encoding
    utf8: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            return $4acd4a658c43cdad$var$charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            return decodeURIComponent(escape($4acd4a658c43cdad$var$charenc.bin.bytesToString(bytes)));
        }
    },
    // Binary encoding
    bin: {
        // Convert a string to a byte array
        stringToBytes: function(str) {
            for(var bytes = [], i = 0; i < str.length; i++)bytes.push(str.charCodeAt(i) & 0xFF);
            return bytes;
        },
        // Convert a byte array to a string
        bytesToString: function(bytes) {
            for(var str = [], i = 0; i < bytes.length; i++)str.push(String.fromCharCode(bytes[i]));
            return str.join('');
        }
    }
};
module.exports = $4acd4a658c43cdad$var$charenc;

});

parcelRegister("cPjZS", function(module, exports) {
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ // The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function(obj) {
    return obj != null && ($9569c2711f0f579f$var$isBuffer(obj) || $9569c2711f0f579f$var$isSlowBuffer(obj) || !!obj._isBuffer);
};
function $9569c2711f0f579f$var$isBuffer(obj) {
    return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}
// For Node v0.10 support. Remove this eventually.
function $9569c2711f0f579f$var$isSlowBuffer(obj) {
    return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && $9569c2711f0f579f$var$isBuffer(obj.slice(0, 0));
}

});

var $fc31e5e9fc16a880$exports = {};
'use strict';

$fc31e5e9fc16a880$exports = (parcelRequire("ee1if"));


parcelRequire("kYL7Z");
var $2fc1460ebb889ad8$exports = {};
'use strict';
function $2fc1460ebb889ad8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($2fc1460ebb889ad8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$2fc1460ebb889ad8$var$checkDCE();

$2fc1460ebb889ad8$exports = (parcelRequire("kF4cy"));


/**
 * react-router v7.13.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $kYL7Z = parcelRequire("kYL7Z");
var $3c99a37f3fed1403$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-JZWAC4HX.mjs"
});
var $3c99a37f3fed1403$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $3c99a37f3fed1403$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $3c99a37f3fed1403$var$__typeError("Cannot " + msg);
var $3c99a37f3fed1403$var$__privateGet = (obj, member, getter)=>($3c99a37f3fed1403$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $3c99a37f3fed1403$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $3c99a37f3fed1403$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $3c99a37f3fed1403$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($3c99a37f3fed1403$export$e19cd5f9376f8cee || {});
var $3c99a37f3fed1403$var$PopStateEventType = "popstate";
function $3c99a37f3fed1403$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $3c99a37f3fed1403$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $3c99a37f3fed1403$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $3c99a37f3fed1403$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $3c99a37f3fed1403$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $3c99a37f3fed1403$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $3c99a37f3fed1403$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $3c99a37f3fed1403$export$fe53371bee54353d(to);
    }
    return $3c99a37f3fed1403$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $3c99a37f3fed1403$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $3c99a37f3fed1403$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $3c99a37f3fed1403$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $3c99a37f3fed1403$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $3c99a37f3fed1403$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $3c99a37f3fed1403$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $3c99a37f3fed1403$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $3c99a37f3fed1403$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $3c99a37f3fed1403$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $3c99a37f3fed1403$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $3c99a37f3fed1403$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $3c99a37f3fed1403$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $3c99a37f3fed1403$var$createKey()
    };
    return location;
}
function $3c99a37f3fed1403$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $3c99a37f3fed1403$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $3c99a37f3fed1403$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $3c99a37f3fed1403$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $3c99a37f3fed1403$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $3c99a37f3fed1403$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $3c99a37f3fed1403$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $3c99a37f3fed1403$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($3c99a37f3fed1403$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($3c99a37f3fed1403$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $3c99a37f3fed1403$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $3c99a37f3fed1403$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $3c99a37f3fed1403$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $3c99a37f3fed1403$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $3c99a37f3fed1403$var$_map;
var $3c99a37f3fed1403$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $3c99a37f3fed1403$var$__privateAdd(this, $3c99a37f3fed1403$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($3c99a37f3fed1403$var$__privateGet(this, $3c99a37f3fed1403$var$_map).has(context)) return $3c99a37f3fed1403$var$__privateGet(this, $3c99a37f3fed1403$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $3c99a37f3fed1403$var$__privateGet(this, $3c99a37f3fed1403$var$_map).set(context, value);
    }
};
$3c99a37f3fed1403$var$_map = new WeakMap();
var $3c99a37f3fed1403$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $3c99a37f3fed1403$var$isUnsupportedLazyRouteObjectKey(key) {
    return $3c99a37f3fed1403$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $3c99a37f3fed1403$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $3c99a37f3fed1403$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $3c99a37f3fed1403$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $3c99a37f3fed1403$var$isIndexRoute(route) {
    return route.index === true;
}
function $3c99a37f3fed1403$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $3c99a37f3fed1403$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $3c99a37f3fed1403$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($3c99a37f3fed1403$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $3c99a37f3fed1403$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $3c99a37f3fed1403$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $3c99a37f3fed1403$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $3c99a37f3fed1403$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $3c99a37f3fed1403$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $3c99a37f3fed1403$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $3c99a37f3fed1403$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $3c99a37f3fed1403$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $3c99a37f3fed1403$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $3c99a37f3fed1403$var$flattenRoutes(routes);
    $3c99a37f3fed1403$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $3c99a37f3fed1403$var$decodePath(pathname);
        matches = $3c99a37f3fed1403$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $3c99a37f3fed1403$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $3c99a37f3fed1403$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $3c99a37f3fed1403$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $3c99a37f3fed1403$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $3c99a37f3fed1403$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $3c99a37f3fed1403$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $3c99a37f3fed1403$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $3c99a37f3fed1403$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $3c99a37f3fed1403$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $3c99a37f3fed1403$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $3c99a37f3fed1403$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $3c99a37f3fed1403$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $3c99a37f3fed1403$var$paramRe = /^:[\w-]+$/;
var $3c99a37f3fed1403$var$dynamicSegmentValue = 3;
var $3c99a37f3fed1403$var$indexRouteValue = 2;
var $3c99a37f3fed1403$var$emptySegmentValue = 1;
var $3c99a37f3fed1403$var$staticSegmentValue = 10;
var $3c99a37f3fed1403$var$splatPenalty = -2;
var $3c99a37f3fed1403$var$isSplat = (s)=>s === "*";
function $3c99a37f3fed1403$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($3c99a37f3fed1403$var$isSplat)) initialScore += $3c99a37f3fed1403$var$splatPenalty;
    if (index) initialScore += $3c99a37f3fed1403$var$indexRouteValue;
    return segments.filter((s)=>!$3c99a37f3fed1403$var$isSplat(s)).reduce((score, segment)=>score + ($3c99a37f3fed1403$var$paramRe.test(segment) ? $3c99a37f3fed1403$var$dynamicSegmentValue : segment === "" ? $3c99a37f3fed1403$var$emptySegmentValue : $3c99a37f3fed1403$var$staticSegmentValue), initialScore);
}
function $3c99a37f3fed1403$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $3c99a37f3fed1403$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $3c99a37f3fed1403$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $3c99a37f3fed1403$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $3c99a37f3fed1403$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $3c99a37f3fed1403$var$normalizePathname($3c99a37f3fed1403$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $3c99a37f3fed1403$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $3c99a37f3fed1403$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $3c99a37f3fed1403$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $3c99a37f3fed1403$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $3c99a37f3fed1403$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $3c99a37f3fed1403$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $3c99a37f3fed1403$var$compilePath(path, caseSensitive = false, end = true) {
    $3c99a37f3fed1403$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $3c99a37f3fed1403$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $3c99a37f3fed1403$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $3c99a37f3fed1403$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $3c99a37f3fed1403$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $3c99a37f3fed1403$var$joinPaths([
        basename,
        pathname
    ]);
}
var $3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $3c99a37f3fed1403$var$isAbsoluteUrl = (url)=>$3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX.test(url);
function $3c99a37f3fed1403$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $3c99a37f3fed1403$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = toPathname.replace(/\/\/+/g, "/");
        if (toPathname.startsWith("/")) pathname = $3c99a37f3fed1403$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $3c99a37f3fed1403$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $3c99a37f3fed1403$var$normalizeSearch(search),
        hash: $3c99a37f3fed1403$var$normalizeHash(hash)
    };
}
function $3c99a37f3fed1403$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $3c99a37f3fed1403$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $3c99a37f3fed1403$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $3c99a37f3fed1403$var$getResolveToMatches(matches) {
    let pathMatches = $3c99a37f3fed1403$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $3c99a37f3fed1403$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $3c99a37f3fed1403$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $3c99a37f3fed1403$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $3c99a37f3fed1403$var$getInvalidPathError("?", "pathname", "search", to));
        $3c99a37f3fed1403$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $3c99a37f3fed1403$var$getInvalidPathError("#", "pathname", "hash", to));
        $3c99a37f3fed1403$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $3c99a37f3fed1403$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $3c99a37f3fed1403$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $3c99a37f3fed1403$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $3c99a37f3fed1403$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $3c99a37f3fed1403$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $3c99a37f3fed1403$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $3c99a37f3fed1403$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $3c99a37f3fed1403$export$4051a07651545597(data2, init) {
    return new $3c99a37f3fed1403$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $3c99a37f3fed1403$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $3c99a37f3fed1403$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $3c99a37f3fed1403$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $3c99a37f3fed1403$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $3c99a37f3fed1403$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $3c99a37f3fed1403$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $3c99a37f3fed1403$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $3c99a37f3fed1403$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
var $3c99a37f3fed1403$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $3c99a37f3fed1403$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($3c99a37f3fed1403$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $3c99a37f3fed1403$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $3c99a37f3fed1403$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $3c99a37f3fed1403$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $3c99a37f3fed1403$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $3c99a37f3fed1403$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $3c99a37f3fed1403$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$3c99a37f3fed1403$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $3c99a37f3fed1403$var$wrapImpl(aggregated[key], original, (...args)=>$3c99a37f3fed1403$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$3c99a37f3fed1403$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$3c99a37f3fed1403$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $3c99a37f3fed1403$var$wrapImpl(aggregated.middleware, original, (...args)=>$3c99a37f3fed1403$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$3c99a37f3fed1403$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $3c99a37f3fed1403$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$3c99a37f3fed1403$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $3c99a37f3fed1403$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $3c99a37f3fed1403$export$fe53371bee54353d(to) : ".",
                ...$3c99a37f3fed1403$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$3c99a37f3fed1403$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$3c99a37f3fed1403$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $3c99a37f3fed1403$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$3c99a37f3fed1403$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$3c99a37f3fed1403$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $3c99a37f3fed1403$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $3c99a37f3fed1403$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $3c99a37f3fed1403$var$getReadonlyRequest(request),
            context: context != null ? $3c99a37f3fed1403$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $3c99a37f3fed1403$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $3c99a37f3fed1403$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $3c99a37f3fed1403$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $3c99a37f3fed1403$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $3c99a37f3fed1403$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $3c99a37f3fed1403$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $3c99a37f3fed1403$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $3c99a37f3fed1403$var$getReadonlyContext(context)
    };
}
function $3c99a37f3fed1403$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $3c99a37f3fed1403$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $3c99a37f3fed1403$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $3c99a37f3fed1403$var$getReadonlyContext(context) {
    if ($3c99a37f3fed1403$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $3c99a37f3fed1403$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $3c99a37f3fed1403$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $3c99a37f3fed1403$var$objectProtoNames;
}
// lib/router/router.ts
var $3c99a37f3fed1403$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $3c99a37f3fed1403$var$validMutationMethods = new Set($3c99a37f3fed1403$var$validMutationMethodsArr);
var $3c99a37f3fed1403$var$validRequestMethodsArr = [
    "GET",
    ...$3c99a37f3fed1403$var$validMutationMethodsArr
];
var $3c99a37f3fed1403$var$validRequestMethods = new Set($3c99a37f3fed1403$var$validRequestMethodsArr);
var $3c99a37f3fed1403$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $3c99a37f3fed1403$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $3c99a37f3fed1403$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $3c99a37f3fed1403$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $3c99a37f3fed1403$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $3c99a37f3fed1403$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $3c99a37f3fed1403$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $3c99a37f3fed1403$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $3c99a37f3fed1403$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $3c99a37f3fed1403$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $3c99a37f3fed1403$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$3c99a37f3fed1403$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $3c99a37f3fed1403$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $3c99a37f3fed1403$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $3c99a37f3fed1403$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $3c99a37f3fed1403$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $3c99a37f3fed1403$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$3c99a37f3fed1403$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$3c99a37f3fed1403$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$3c99a37f3fed1403$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $3c99a37f3fed1403$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $3c99a37f3fed1403$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $3c99a37f3fed1403$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $3c99a37f3fed1403$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$3c99a37f3fed1403$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $3c99a37f3fed1403$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $3c99a37f3fed1403$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $3c99a37f3fed1403$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $3c99a37f3fed1403$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $3c99a37f3fed1403$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $3c99a37f3fed1403$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $3c99a37f3fed1403$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $3c99a37f3fed1403$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $3c99a37f3fed1403$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $3c99a37f3fed1403$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $3c99a37f3fed1403$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $3c99a37f3fed1403$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $3c99a37f3fed1403$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $3c99a37f3fed1403$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $3c99a37f3fed1403$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $3c99a37f3fed1403$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $3c99a37f3fed1403$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $3c99a37f3fed1403$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $3c99a37f3fed1403$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($3c99a37f3fed1403$var$isErrorResult(result) && $3c99a37f3fed1403$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $3c99a37f3fed1403$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $3c99a37f3fed1403$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$3c99a37f3fed1403$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $3c99a37f3fed1403$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $3c99a37f3fed1403$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $3c99a37f3fed1403$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $3c99a37f3fed1403$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $3c99a37f3fed1403$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($3c99a37f3fed1403$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $3c99a37f3fed1403$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($3c99a37f3fed1403$var$isErrorResult(result)) {
            let boundaryMatch = $3c99a37f3fed1403$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $3c99a37f3fed1403$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $3c99a37f3fed1403$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $3c99a37f3fed1403$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $3c99a37f3fed1403$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $3c99a37f3fed1403$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$3c99a37f3fed1403$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $3c99a37f3fed1403$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $3c99a37f3fed1403$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $3c99a37f3fed1403$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $3c99a37f3fed1403$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $3c99a37f3fed1403$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $3c99a37f3fed1403$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $3c99a37f3fed1403$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $3c99a37f3fed1403$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $3c99a37f3fed1403$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $3c99a37f3fed1403$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $3c99a37f3fed1403$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $3c99a37f3fed1403$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $3c99a37f3fed1403$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $3c99a37f3fed1403$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $3c99a37f3fed1403$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($3c99a37f3fed1403$var$isRedirectResult(actionResult) || $3c99a37f3fed1403$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $3c99a37f3fed1403$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($3c99a37f3fed1403$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $3c99a37f3fed1403$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $3c99a37f3fed1403$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($3c99a37f3fed1403$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $3c99a37f3fed1403$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $3c99a37f3fed1403$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $3c99a37f3fed1403$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $3c99a37f3fed1403$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $3c99a37f3fed1403$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $3c99a37f3fed1403$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $3c99a37f3fed1403$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $3c99a37f3fed1403$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $3c99a37f3fed1403$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $3c99a37f3fed1403$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $3c99a37f3fed1403$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $3c99a37f3fed1403$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $3c99a37f3fed1403$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $3c99a37f3fed1403$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $3c99a37f3fed1403$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $3c99a37f3fed1403$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $3c99a37f3fed1403$var$getDoneFetcher(void 0));
            return;
        }
        if ($3c99a37f3fed1403$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $3c99a37f3fed1403$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($3c99a37f3fed1403$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $3c99a37f3fed1403$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $3c99a37f3fed1403$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $3c99a37f3fed1403$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $3c99a37f3fed1403$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($3c99a37f3fed1403$var$isAbsoluteUrl(location)) {
                const url = $3c99a37f3fed1403$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $3c99a37f3fed1403$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $3c99a37f3fed1403$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($3c99a37f3fed1403$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $3c99a37f3fed1403$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $3c99a37f3fed1403$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $3c99a37f3fed1403$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$3c99a37f3fed1403$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($3c99a37f3fed1403$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $3c99a37f3fed1403$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $3c99a37f3fed1403$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $3c99a37f3fed1403$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $3c99a37f3fed1403$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $3c99a37f3fed1403$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $3c99a37f3fed1403$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $3c99a37f3fed1403$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $3c99a37f3fed1403$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $3c99a37f3fed1403$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $3c99a37f3fed1403$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $3c99a37f3fed1403$export$386d57f03f0b2883;
        $3c99a37f3fed1403$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $3c99a37f3fed1403$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $3c99a37f3fed1403$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $3c99a37f3fed1403$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $3c99a37f3fed1403$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$3c99a37f3fed1403$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $3c99a37f3fed1403$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $3c99a37f3fed1403$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $3c99a37f3fed1403$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $3c99a37f3fed1403$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $3c99a37f3fed1403$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $3c99a37f3fed1403$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $3c99a37f3fed1403$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $3c99a37f3fed1403$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $3c99a37f3fed1403$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $3c99a37f3fed1403$export$3336b097a6fbc59a(routes, opts) {
    $3c99a37f3fed1403$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $3c99a37f3fed1403$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$3c99a37f3fed1403$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $3c99a37f3fed1403$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $3c99a37f3fed1403$var$createLocation("", $3c99a37f3fed1403$export$fe53371bee54353d(url), null, "default");
        let matches = $3c99a37f3fed1403$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $3c99a37f3fed1403$export$b8d3e69d4b3eff04();
        if (!$3c99a37f3fed1403$var$isValidMethod(method) && method !== "HEAD") {
            let error = $3c99a37f3fed1403$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $3c99a37f3fed1403$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $3c99a37f3fed1403$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $3c99a37f3fed1403$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $3c99a37f3fed1403$export$f5708dca728d7177(requestContext instanceof $3c99a37f3fed1403$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $3c99a37f3fed1403$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $3c99a37f3fed1403$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $3c99a37f3fed1403$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($3c99a37f3fed1403$export$6e80290866a84dd4(error)) return error;
                    if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $3c99a37f3fed1403$export$f2680fa305b734ca(error.status, error.statusText, await $3c99a37f3fed1403$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($3c99a37f3fed1403$export$e0163cfdf7bc9cfa(error)) error = $3c99a37f3fed1403$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $3c99a37f3fed1403$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $3c99a37f3fed1403$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $3c99a37f3fed1403$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $3c99a37f3fed1403$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $3c99a37f3fed1403$export$f5708dca728d7177($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $3c99a37f3fed1403$var$createLocation("", $3c99a37f3fed1403$export$fe53371bee54353d(url), null, "default");
        let matches = $3c99a37f3fed1403$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $3c99a37f3fed1403$export$b8d3e69d4b3eff04();
        if (!$3c99a37f3fed1403$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $3c99a37f3fed1403$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $3c99a37f3fed1403$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $3c99a37f3fed1403$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $3c99a37f3fed1403$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $3c99a37f3fed1403$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $3c99a37f3fed1403$export$f5708dca728d7177(requestContext instanceof $3c99a37f3fed1403$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $3c99a37f3fed1403$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $3c99a37f3fed1403$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $3c99a37f3fed1403$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $3c99a37f3fed1403$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($3c99a37f3fed1403$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($3c99a37f3fed1403$var$dataWithResponseInitToResponse(error));
                if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $3c99a37f3fed1403$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($3c99a37f3fed1403$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $3c99a37f3fed1403$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($3c99a37f3fed1403$var$isDataStrategyResult(e) && $3c99a37f3fed1403$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($3c99a37f3fed1403$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $3c99a37f3fed1403$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $3c99a37f3fed1403$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($3c99a37f3fed1403$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($3c99a37f3fed1403$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($3c99a37f3fed1403$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $3c99a37f3fed1403$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $3c99a37f3fed1403$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($3c99a37f3fed1403$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $3c99a37f3fed1403$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $3c99a37f3fed1403$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $3c99a37f3fed1403$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $3c99a37f3fed1403$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $3c99a37f3fed1403$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $3c99a37f3fed1403$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $3c99a37f3fed1403$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $3c99a37f3fed1403$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $3c99a37f3fed1403$var$callDataStrategyImpl(dataStrategy || $3c99a37f3fed1403$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($3c99a37f3fed1403$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $3c99a37f3fed1403$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($3c99a37f3fed1403$export$e0163cfdf7bc9cfa(result.result)) throw $3c99a37f3fed1403$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $3c99a37f3fed1403$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $3c99a37f3fed1403$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $3c99a37f3fed1403$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $3c99a37f3fed1403$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $3c99a37f3fed1403$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $3c99a37f3fed1403$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $3c99a37f3fed1403$var$resolveTo(to ? to : ".", $3c99a37f3fed1403$var$getResolveToMatches(contextualMatches), $3c99a37f3fed1403$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $3c99a37f3fed1403$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $3c99a37f3fed1403$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $3c99a37f3fed1403$export$fe53371bee54353d(path);
}
function $3c99a37f3fed1403$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$3c99a37f3fed1403$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$3c99a37f3fed1403$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $3c99a37f3fed1403$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $3c99a37f3fed1403$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $3c99a37f3fed1403$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$3c99a37f3fed1403$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$3c99a37f3fed1403$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $3c99a37f3fed1403$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $3c99a37f3fed1403$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $3c99a37f3fed1403$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $3c99a37f3fed1403$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $3c99a37f3fed1403$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($3c99a37f3fed1403$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $3c99a37f3fed1403$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $3c99a37f3fed1403$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $3c99a37f3fed1403$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $3c99a37f3fed1403$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $3c99a37f3fed1403$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$3c99a37f3fed1403$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $3c99a37f3fed1403$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($3c99a37f3fed1403$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $3c99a37f3fed1403$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($3c99a37f3fed1403$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $3c99a37f3fed1403$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $3c99a37f3fed1403$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $3c99a37f3fed1403$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $3c99a37f3fed1403$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $3c99a37f3fed1403$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($3c99a37f3fed1403$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $3c99a37f3fed1403$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $3c99a37f3fed1403$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$3c99a37f3fed1403$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $3c99a37f3fed1403$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $3c99a37f3fed1403$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $3c99a37f3fed1403$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $3c99a37f3fed1403$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $3c99a37f3fed1403$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$3c99a37f3fed1403$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $3c99a37f3fed1403$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $3c99a37f3fed1403$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $3c99a37f3fed1403$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$3c99a37f3fed1403$var$isSameRoute(aChild, bChild)));
}
var $3c99a37f3fed1403$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $3c99a37f3fed1403$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $3c99a37f3fed1403$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $3c99a37f3fed1403$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $3c99a37f3fed1403$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $3c99a37f3fed1403$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $3c99a37f3fed1403$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $3c99a37f3fed1403$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $3c99a37f3fed1403$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $3c99a37f3fed1403$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $3c99a37f3fed1403$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $3c99a37f3fed1403$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $3c99a37f3fed1403$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $3c99a37f3fed1403$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $3c99a37f3fed1403$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $3c99a37f3fed1403$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $3c99a37f3fed1403$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $3c99a37f3fed1403$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $3c99a37f3fed1403$var$isNonNullable(value) {
    return value !== void 0;
}
function $3c99a37f3fed1403$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $3c99a37f3fed1403$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($3c99a37f3fed1403$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $3c99a37f3fed1403$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $3c99a37f3fed1403$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $3c99a37f3fed1403$var$defaultDataStrategy(args);
    return $3c99a37f3fed1403$var$runClientMiddlewarePipeline(args, ()=>$3c99a37f3fed1403$var$defaultDataStrategy(args));
}
function $3c99a37f3fed1403$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $3c99a37f3fed1403$var$runMiddlewarePipeline(args, handler, processResult, $3c99a37f3fed1403$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $3c99a37f3fed1403$export$e0163cfdf7bc9cfa(result) ? $3c99a37f3fed1403$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $3c99a37f3fed1403$var$runClientMiddlewarePipeline(args, handler) {
    return $3c99a37f3fed1403$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($3c99a37f3fed1403$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $3c99a37f3fed1403$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $3c99a37f3fed1403$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $3c99a37f3fed1403$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $3c99a37f3fed1403$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $3c99a37f3fed1403$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $3c99a37f3fed1403$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $3c99a37f3fed1403$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $3c99a37f3fed1403$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $3c99a37f3fed1403$var$loadLazyRoute(match.route, $3c99a37f3fed1403$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $3c99a37f3fed1403$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $3c99a37f3fed1403$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $3c99a37f3fed1403$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $3c99a37f3fed1403$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $3c99a37f3fed1403$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$3c99a37f3fed1403$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($3c99a37f3fed1403$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $3c99a37f3fed1403$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $3c99a37f3fed1403$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $3c99a37f3fed1403$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $3c99a37f3fed1403$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $3c99a37f3fed1403$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $3c99a37f3fed1403$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $3c99a37f3fed1403$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $3c99a37f3fed1403$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $3c99a37f3fed1403$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $3c99a37f3fed1403$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $3c99a37f3fed1403$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $3c99a37f3fed1403$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $3c99a37f3fed1403$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $3c99a37f3fed1403$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $3c99a37f3fed1403$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $3c99a37f3fed1403$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($3c99a37f3fed1403$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $3c99a37f3fed1403$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $3c99a37f3fed1403$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $3c99a37f3fed1403$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($3c99a37f3fed1403$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $3c99a37f3fed1403$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $3c99a37f3fed1403$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$3c99a37f3fed1403$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $3c99a37f3fed1403$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $3c99a37f3fed1403$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($3c99a37f3fed1403$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $3c99a37f3fed1403$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $3c99a37f3fed1403$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($3c99a37f3fed1403$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $3c99a37f3fed1403$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $3c99a37f3fed1403$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $3c99a37f3fed1403$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $3c99a37f3fed1403$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $3c99a37f3fed1403$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $3c99a37f3fed1403$export$f5708dca728d7177(!$3c99a37f3fed1403$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($3c99a37f3fed1403$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $3c99a37f3fed1403$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $3c99a37f3fed1403$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $3c99a37f3fed1403$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $3c99a37f3fed1403$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $3c99a37f3fed1403$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $3c99a37f3fed1403$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($3c99a37f3fed1403$var$isErrorResult(result)) {
            let boundaryMatch = $3c99a37f3fed1403$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($3c99a37f3fed1403$var$isRedirectResult(result)) $3c99a37f3fed1403$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $3c99a37f3fed1403$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $3c99a37f3fed1403$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $3c99a37f3fed1403$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $3c99a37f3fed1403$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $3c99a37f3fed1403$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $3c99a37f3fed1403$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $3c99a37f3fed1403$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $3c99a37f3fed1403$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $3c99a37f3fed1403$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $3c99a37f3fed1403$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($3c99a37f3fed1403$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $3c99a37f3fed1403$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $3c99a37f3fed1403$export$8ccf933b0513f8d0(path) : path;
    return $3c99a37f3fed1403$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $3c99a37f3fed1403$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $3c99a37f3fed1403$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $3c99a37f3fed1403$var$dataWithResponseInitToErrorResponse(data2) {
    return new $3c99a37f3fed1403$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $3c99a37f3fed1403$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $3c99a37f3fed1403$var$isDataStrategyResult(value));
}
function $3c99a37f3fed1403$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $3c99a37f3fed1403$var$isRedirectDataStrategyResult(result) {
    return $3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result.result) && $3c99a37f3fed1403$var$redirectStatusCodes.has(result.result.status);
}
function $3c99a37f3fed1403$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $3c99a37f3fed1403$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $3c99a37f3fed1403$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $3c99a37f3fed1403$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $3c99a37f3fed1403$export$794b2760043cf8cd(statusCode) {
    return $3c99a37f3fed1403$var$redirectStatusCodes.has(statusCode);
}
function $3c99a37f3fed1403$export$6e80290866a84dd4(result) {
    return $3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result) && $3c99a37f3fed1403$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $3c99a37f3fed1403$var$isValidMethod(method) {
    return $3c99a37f3fed1403$var$validRequestMethods.has(method.toUpperCase());
}
function $3c99a37f3fed1403$export$cbae47800eb95bc3(method) {
    return $3c99a37f3fed1403$var$validMutationMethods.has(method.toUpperCase());
}
function $3c99a37f3fed1403$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $3c99a37f3fed1403$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $3c99a37f3fed1403$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $3c99a37f3fed1403$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $3c99a37f3fed1403$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $3c99a37f3fed1403$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $3c99a37f3fed1403$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $3c99a37f3fed1403$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $3c99a37f3fed1403$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $3c99a37f3fed1403$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $3c99a37f3fed1403$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $3c99a37f3fed1403$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($3c99a37f3fed1403$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $3c99a37f3fed1403$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($3c99a37f3fed1403$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $3c99a37f3fed1403$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $3c99a37f3fed1403$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $3c99a37f3fed1403$export$2eeee58951ff3c1c = $kYL7Z.createContext(null);
$3c99a37f3fed1403$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $3c99a37f3fed1403$export$315e3ffb01f217 = $kYL7Z.createContext(null);
$3c99a37f3fed1403$export$315e3ffb01f217.displayName = "DataRouterState";
var $3c99a37f3fed1403$export$717f757c655223f1 = $kYL7Z.createContext(false);
function $3c99a37f3fed1403$var$useIsRSCRouterContext() {
    return $kYL7Z.useContext($3c99a37f3fed1403$export$717f757c655223f1);
}
var $3c99a37f3fed1403$export$3681f408decb40d1 = $kYL7Z.createContext({
    isTransitioning: false
});
$3c99a37f3fed1403$export$3681f408decb40d1.displayName = "ViewTransition";
var $3c99a37f3fed1403$export$cb3f1df1bef00a39 = $kYL7Z.createContext(/* @__PURE__ */ new Map());
$3c99a37f3fed1403$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $3c99a37f3fed1403$var$AwaitContext = $kYL7Z.createContext(null);
$3c99a37f3fed1403$var$AwaitContext.displayName = "Await";
var $3c99a37f3fed1403$export$2666c20e15407622 = (props)=>$kYL7Z.createElement($3c99a37f3fed1403$var$AwaitContext.Provider, props);
var $3c99a37f3fed1403$export$3044ab7fdabeaee6 = $kYL7Z.createContext(null);
$3c99a37f3fed1403$export$3044ab7fdabeaee6.displayName = "Navigation";
var $3c99a37f3fed1403$export$e6a44b110a0c44d3 = $kYL7Z.createContext(null);
$3c99a37f3fed1403$export$e6a44b110a0c44d3.displayName = "Location";
var $3c99a37f3fed1403$export$aac280ed165a4397 = $kYL7Z.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$3c99a37f3fed1403$export$aac280ed165a4397.displayName = "Route";
var $3c99a37f3fed1403$var$RouteErrorContext = $kYL7Z.createContext(null);
$3c99a37f3fed1403$var$RouteErrorContext.displayName = "RouteError";
var $3c99a37f3fed1403$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $3c99a37f3fed1403$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $3c99a37f3fed1403$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $3c99a37f3fed1403$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $3c99a37f3fed1403$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$3c99a37f3fed1403$var$ERROR_DIGEST_BASE}:${$3c99a37f3fed1403$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $3c99a37f3fed1403$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$3c99a37f3fed1403$var$ERROR_DIGEST_BASE}:${$3c99a37f3fed1403$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $3c99a37f3fed1403$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $3c99a37f3fed1403$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $3c99a37f3fed1403$export$f5708dca728d7177($3c99a37f3fed1403$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $3c99a37f3fed1403$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $3c99a37f3fed1403$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $3c99a37f3fed1403$export$9c954a9d03d32f4a() {
    return $kYL7Z.useContext($3c99a37f3fed1403$export$e6a44b110a0c44d3) != null;
}
function $3c99a37f3fed1403$export$45d76561a5302f2b() {
    $3c99a37f3fed1403$export$f5708dca728d7177($3c99a37f3fed1403$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $kYL7Z.useContext($3c99a37f3fed1403$export$e6a44b110a0c44d3).location;
}
function $3c99a37f3fed1403$export$1b3f31771c5d07c() {
    return $kYL7Z.useContext($3c99a37f3fed1403$export$e6a44b110a0c44d3).navigationType;
}
function $3c99a37f3fed1403$export$6c330e8992e8a295(pattern) {
    $3c99a37f3fed1403$export$f5708dca728d7177($3c99a37f3fed1403$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $3c99a37f3fed1403$export$45d76561a5302f2b();
    return $kYL7Z.useMemo(()=>$3c99a37f3fed1403$export$81336c211d5ff295(pattern, $3c99a37f3fed1403$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $3c99a37f3fed1403$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $3c99a37f3fed1403$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6).static;
    if (!isStatic) $kYL7Z.useLayoutEffect(cb);
}
function $3c99a37f3fed1403$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    return isDataRoute ? $3c99a37f3fed1403$var$useNavigateStable() : $3c99a37f3fed1403$var$useNavigateUnstable();
}
function $3c99a37f3fed1403$var$useNavigateUnstable() {
    $3c99a37f3fed1403$export$f5708dca728d7177($3c99a37f3fed1403$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $kYL7Z.useContext($3c99a37f3fed1403$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let { matches: matches } = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($3c99a37f3fed1403$var$getResolveToMatches(matches));
    let activeRef = $kYL7Z.useRef(false);
    $3c99a37f3fed1403$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $kYL7Z.useCallback((to, options = {})=>{
        $3c99a37f3fed1403$var$warning(activeRef.current, $3c99a37f3fed1403$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $3c99a37f3fed1403$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $3c99a37f3fed1403$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $3c99a37f3fed1403$var$OutletContext = $kYL7Z.createContext(null);
function $3c99a37f3fed1403$export$4138103a3ae699cc() {
    return $kYL7Z.useContext($3c99a37f3fed1403$var$OutletContext);
}
function $3c99a37f3fed1403$export$a3be3530d8e40d0b(context) {
    let outlet = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397).outlet;
    return $kYL7Z.useMemo(()=>outlet && /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $3c99a37f3fed1403$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $3c99a37f3fed1403$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($3c99a37f3fed1403$var$getResolveToMatches(matches));
    return $kYL7Z.useMemo(()=>$3c99a37f3fed1403$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $3c99a37f3fed1403$export$5d3fca4a98652595(routes, locationArg) {
    return $3c99a37f3fed1403$var$useRoutesImpl(routes, locationArg);
}
function $3c99a37f3fed1403$var$useRoutesImpl(routes, locationArg, dataRouterState, onError, future) {
    $3c99a37f3fed1403$export$f5708dca728d7177($3c99a37f3fed1403$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($3c99a37f3fed1403$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $3c99a37f3fed1403$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $3c99a37f3fed1403$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $3c99a37f3fed1403$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $3c99a37f3fed1403$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($3c99a37f3fed1403$export$945fecf35a8ef089) {
        $3c99a37f3fed1403$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $3c99a37f3fed1403$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $3c99a37f3fed1403$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $3c99a37f3fed1403$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $3c99a37f3fed1403$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $3c99a37f3fed1403$var$DefaultErrorComponent() {
    let error = $3c99a37f3fed1403$export$ed527bf60f6e05f2();
    let message = $3c99a37f3fed1403$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($3c99a37f3fed1403$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, /* @__PURE__ */ $kYL7Z.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $kYL7Z.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $kYL7Z.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $kYL7Z.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, /* @__PURE__ */ $kYL7Z.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $kYL7Z.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $kYL7Z.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $3c99a37f3fed1403$var$defaultErrorElement = /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$DefaultErrorComponent, null);
var $3c99a37f3fed1403$var$RenderErrorBoundary = class extends $kYL7Z.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $3c99a37f3fed1403$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$3c99a37f3fed1403$var$RenderErrorBoundary.contextType = $3c99a37f3fed1403$export$717f757c655223f1;
var $3c99a37f3fed1403$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $3c99a37f3fed1403$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $3c99a37f3fed1403$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $3c99a37f3fed1403$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $3c99a37f3fed1403$var$parseToInfo(redirect2.location, basename);
            if ($3c99a37f3fed1403$var$isBrowser && !$3c99a37f3fed1403$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $3c99a37f3fed1403$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $kYL7Z.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $3c99a37f3fed1403$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $kYL7Z.useContext($3c99a37f3fed1403$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $3c99a37f3fed1403$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, onErrorHandler = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $3c99a37f3fed1403$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $3c99a37f3fed1403$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $3c99a37f3fed1403$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $3c99a37f3fed1403$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $kYL7Z.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $3c99a37f3fed1403$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $3c99a37f3fed1403$var$useDataRouterContext(hookName) {
    let ctx = $kYL7Z.useContext($3c99a37f3fed1403$export$2eeee58951ff3c1c);
    $3c99a37f3fed1403$export$f5708dca728d7177(ctx, $3c99a37f3fed1403$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $3c99a37f3fed1403$var$useDataRouterState(hookName) {
    let state = $kYL7Z.useContext($3c99a37f3fed1403$export$315e3ffb01f217);
    $3c99a37f3fed1403$export$f5708dca728d7177(state, $3c99a37f3fed1403$var$getDataRouterConsoleError(hookName));
    return state;
}
function $3c99a37f3fed1403$var$useRouteContext(hookName) {
    let route = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    $3c99a37f3fed1403$export$f5708dca728d7177(route, $3c99a37f3fed1403$var$getDataRouterConsoleError(hookName));
    return route;
}
function $3c99a37f3fed1403$var$useCurrentRouteId(hookName) {
    let route = $3c99a37f3fed1403$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $3c99a37f3fed1403$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $3c99a37f3fed1403$var$useRouteId() {
    return $3c99a37f3fed1403$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $3c99a37f3fed1403$export$d0fd4b7106de2769() {
    let state = $3c99a37f3fed1403$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $3c99a37f3fed1403$export$600dc272ed516c15() {
    let dataRouterContext = $3c99a37f3fed1403$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $3c99a37f3fed1403$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $kYL7Z.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $kYL7Z.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $3c99a37f3fed1403$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $3c99a37f3fed1403$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $kYL7Z.useMemo(()=>matches.map((m)=>$3c99a37f3fed1403$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $3c99a37f3fed1403$export$1448a5050d252c4d() {
    let state = $3c99a37f3fed1403$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $3c99a37f3fed1403$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $3c99a37f3fed1403$export$fd5d37484eab868d(routeId) {
    let state = $3c99a37f3fed1403$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $3c99a37f3fed1403$export$fdc00f3f26066d5e() {
    let state = $3c99a37f3fed1403$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $3c99a37f3fed1403$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $3c99a37f3fed1403$export$ed527bf60f6e05f2() {
    let error = $kYL7Z.useContext($3c99a37f3fed1403$var$RouteErrorContext);
    let state = $3c99a37f3fed1403$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $3c99a37f3fed1403$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $3c99a37f3fed1403$export$78a72ddb39bdd145() {
    let value = $kYL7Z.useContext($3c99a37f3fed1403$var$AwaitContext);
    return value?._data;
}
function $3c99a37f3fed1403$export$17f53340677d5831() {
    let value = $kYL7Z.useContext($3c99a37f3fed1403$var$AwaitContext);
    return value?._error;
}
var $3c99a37f3fed1403$var$blockerId = 0;
function $3c99a37f3fed1403$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $3c99a37f3fed1403$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $3c99a37f3fed1403$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $kYL7Z.useState("");
    let blockerFunction = $kYL7Z.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $3c99a37f3fed1403$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $3c99a37f3fed1403$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $kYL7Z.useEffect(()=>{
        let key = String(++$3c99a37f3fed1403$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $kYL7Z.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $3c99a37f3fed1403$export$386d57f03f0b2883;
}
function $3c99a37f3fed1403$var$useNavigateStable() {
    let { router: router } = $3c99a37f3fed1403$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $3c99a37f3fed1403$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $kYL7Z.useRef(false);
    $3c99a37f3fed1403$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $kYL7Z.useCallback(async (to, options = {})=>{
        $3c99a37f3fed1403$var$warning(activeRef.current, $3c99a37f3fed1403$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $3c99a37f3fed1403$var$alreadyWarned = {};
function $3c99a37f3fed1403$var$warningOnce(key, cond, message) {
    if (!cond && !$3c99a37f3fed1403$var$alreadyWarned[key]) {
        $3c99a37f3fed1403$var$alreadyWarned[key] = true;
        $3c99a37f3fed1403$var$warning(false, message);
    }
}
function $3c99a37f3fed1403$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $3c99a37f3fed1403$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $3c99a37f3fed1403$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $3c99a37f3fed1403$var$alreadyWarned2 = {};
function $3c99a37f3fed1403$export$5b28268982f175ba(condition, message) {
    if (!condition && !$3c99a37f3fed1403$var$alreadyWarned2[message]) {
        $3c99a37f3fed1403$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $3c99a37f3fed1403$var$USE_OPTIMISTIC = "useOptimistic";
var $3c99a37f3fed1403$var$useOptimisticImpl = $kYL7Z[$3c99a37f3fed1403$var$USE_OPTIMISTIC];
var $3c99a37f3fed1403$var$stableUseOptimisticSetter = ()=>void 0;
function $3c99a37f3fed1403$var$useOptimisticSafe(val) {
    if ($3c99a37f3fed1403$var$useOptimisticImpl) return $3c99a37f3fed1403$var$useOptimisticImpl(val);
    else return [
        val,
        $3c99a37f3fed1403$var$stableUseOptimisticSetter
    ];
}
function $3c99a37f3fed1403$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($3c99a37f3fed1403$export$945fecf35a8ef089) {
            if (route.element) $3c99a37f3fed1403$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $kYL7Z.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($3c99a37f3fed1403$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $3c99a37f3fed1403$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $kYL7Z.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($3c99a37f3fed1403$export$945fecf35a8ef089) {
            if (route.errorElement) $3c99a37f3fed1403$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $kYL7Z.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $3c99a37f3fed1403$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $3c99a37f3fed1403$export$f30f7e456d254e83(routes, opts) {
    return $3c99a37f3fed1403$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3c99a37f3fed1403$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $3c99a37f3fed1403$export$e2fd2c03906469db,
        mapRouteProperties: $3c99a37f3fed1403$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $3c99a37f3fed1403$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $3c99a37f3fed1403$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $3c99a37f3fed1403$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $kYL7Z.useState(router.state);
    let [state, setOptimisticState] = $3c99a37f3fed1403$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $kYL7Z.useState();
    let [vtContext, setVtContext] = $kYL7Z.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $kYL7Z.useState();
    let [transition, setTransition] = $kYL7Z.useState();
    let [interruption, setInterruption] = $kYL7Z.useState();
    let fetcherData = $kYL7Z.useRef(/* @__PURE__ */ new Map());
    let setState = $kYL7Z.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $3c99a37f3fed1403$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $3c99a37f3fed1403$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $3c99a37f3fed1403$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $kYL7Z.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$3c99a37f3fed1403$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $kYL7Z.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $kYL7Z.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $3c99a37f3fed1403$var$Deferred());
    }, [
        vtContext
    ]);
    $kYL7Z.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $kYL7Z.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$3c99a37f3fed1403$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $kYL7Z.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $kYL7Z.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $kYL7Z.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $kYL7Z.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        onError: onError
    })))))), null);
}
function $3c99a37f3fed1403$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $3c99a37f3fed1403$var$MemoizedDataRoutes = $kYL7Z.memo($3c99a37f3fed1403$var$DataRoutes);
function $3c99a37f3fed1403$var$DataRoutes({ routes: routes, future: future, state: state, onError: onError }) {
    return $3c99a37f3fed1403$var$useRoutesImpl(routes, void 0, state, onError, future);
}
function $3c99a37f3fed1403$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $kYL7Z.useRef();
    if (historyRef.current == null) historyRef.current = $3c99a37f3fed1403$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kYL7Z.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYL7Z.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $kYL7Z.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $kYL7Z.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $3c99a37f3fed1403$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $3c99a37f3fed1403$export$f5708dca728d7177($3c99a37f3fed1403$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    $3c99a37f3fed1403$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    let { pathname: locationPathname } = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let navigate = $3c99a37f3fed1403$export$9770f232ac06a008();
    let path = $3c99a37f3fed1403$var$resolveTo(to, $3c99a37f3fed1403$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $kYL7Z.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $3c99a37f3fed1403$export$910ae8079b2c2852(props) {
    return $3c99a37f3fed1403$export$a3be3530d8e40d0b(props.context);
}
function $3c99a37f3fed1403$export$e7b0ac011bb776c6(props) {
    $3c99a37f3fed1403$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $3c99a37f3fed1403$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $3c99a37f3fed1403$export$f5708dca728d7177(!$3c99a37f3fed1403$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $kYL7Z.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $3c99a37f3fed1403$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $kYL7Z.useMemo(()=>{
        let trailingPathname = $3c99a37f3fed1403$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $3c99a37f3fed1403$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $3c99a37f3fed1403$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $3c99a37f3fed1403$export$5d3fca4a98652595($3c99a37f3fed1403$export$16da398f5434bdec(children), location);
}
function $3c99a37f3fed1403$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $kYL7Z.useContext($3c99a37f3fed1403$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $kYL7Z.useContext($3c99a37f3fed1403$export$315e3ffb01f217);
    let onError = $kYL7Z.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $3c99a37f3fed1403$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$ResolveAwait, null, children));
}
var $3c99a37f3fed1403$var$AwaitErrorBoundary = class extends $kYL7Z.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $3c99a37f3fed1403$var$ResolveAwait({ children: children }) {
    let data2 = $3c99a37f3fed1403$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, toRender);
}
function $3c99a37f3fed1403$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $kYL7Z.Children.forEach(children, (element, index)=>{
        if (!$kYL7Z.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $kYL7Z.Fragment) {
            routes.push.apply(routes, $3c99a37f3fed1403$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $3c99a37f3fed1403$export$f5708dca728d7177(element.type === $3c99a37f3fed1403$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $3c99a37f3fed1403$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $3c99a37f3fed1403$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $3c99a37f3fed1403$export$9b5b6d122dea0c88 = $3c99a37f3fed1403$export$16da398f5434bdec;
function $3c99a37f3fed1403$export$daf73786167a7f72(matches) {
    return $3c99a37f3fed1403$var$_renderMatches(matches);
}
function $3c99a37f3fed1403$var$useRouteComponentProps() {
    return {
        params: $3c99a37f3fed1403$export$99eaa27ddbbb95ef(),
        loaderData: $3c99a37f3fed1403$export$1448a5050d252c4d(),
        actionData: $3c99a37f3fed1403$export$fdc00f3f26066d5e(),
        matches: $3c99a37f3fed1403$export$2378eb7f5ff86053()
    };
}
function $3c99a37f3fed1403$export$6c4f3826290c37af({ children: children }) {
    const props = $3c99a37f3fed1403$var$useRouteComponentProps();
    return $kYL7Z.cloneElement(children, props);
}
function $3c99a37f3fed1403$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $3c99a37f3fed1403$var$useRouteComponentProps();
        return $kYL7Z.createElement(Component4, props);
    };
}
function $3c99a37f3fed1403$var$useHydrateFallbackProps() {
    return {
        params: $3c99a37f3fed1403$export$99eaa27ddbbb95ef(),
        loaderData: $3c99a37f3fed1403$export$1448a5050d252c4d(),
        actionData: $3c99a37f3fed1403$export$fdc00f3f26066d5e()
    };
}
function $3c99a37f3fed1403$export$f8cff34f39c1932a({ children: children }) {
    const props = $3c99a37f3fed1403$var$useHydrateFallbackProps();
    return $kYL7Z.cloneElement(children, props);
}
function $3c99a37f3fed1403$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $3c99a37f3fed1403$var$useHydrateFallbackProps();
        return $kYL7Z.createElement(HydrateFallback, props);
    };
}
function $3c99a37f3fed1403$var$useErrorBoundaryProps() {
    return {
        params: $3c99a37f3fed1403$export$99eaa27ddbbb95ef(),
        loaderData: $3c99a37f3fed1403$export$1448a5050d252c4d(),
        actionData: $3c99a37f3fed1403$export$fdc00f3f26066d5e(),
        error: $3c99a37f3fed1403$export$ed527bf60f6e05f2()
    };
}
function $3c99a37f3fed1403$export$e5afde5c4b6d747b({ children: children }) {
    const props = $3c99a37f3fed1403$var$useErrorBoundaryProps();
    return $kYL7Z.cloneElement(children, props);
}
function $3c99a37f3fed1403$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $3c99a37f3fed1403$var$useErrorBoundaryProps();
        return $kYL7Z.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $3c99a37f3fed1403$var$defaultMethod = "get";
var $3c99a37f3fed1403$var$defaultEncType = "application/x-www-form-urlencoded";
function $3c99a37f3fed1403$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $3c99a37f3fed1403$var$isButtonElement(object) {
    return $3c99a37f3fed1403$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $3c99a37f3fed1403$var$isFormElement(object) {
    return $3c99a37f3fed1403$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $3c99a37f3fed1403$var$isInputElement(object) {
    return $3c99a37f3fed1403$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $3c99a37f3fed1403$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $3c99a37f3fed1403$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$3c99a37f3fed1403$var$isModifiedEvent(event);
}
function $3c99a37f3fed1403$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $3c99a37f3fed1403$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $3c99a37f3fed1403$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $3c99a37f3fed1403$var$_formDataSupportsSubmitter = null;
function $3c99a37f3fed1403$var$isFormDataSubmitterSupported() {
    if ($3c99a37f3fed1403$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $3c99a37f3fed1403$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $3c99a37f3fed1403$var$_formDataSupportsSubmitter = true;
    }
    return $3c99a37f3fed1403$var$_formDataSupportsSubmitter;
}
var $3c99a37f3fed1403$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $3c99a37f3fed1403$var$getFormEncType(encType) {
    if (encType != null && !$3c99a37f3fed1403$var$supportedFormEncTypes.has(encType)) {
        $3c99a37f3fed1403$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$3c99a37f3fed1403$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $3c99a37f3fed1403$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($3c99a37f3fed1403$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $3c99a37f3fed1403$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $3c99a37f3fed1403$var$defaultMethod;
        encType = $3c99a37f3fed1403$var$getFormEncType(target.getAttribute("enctype")) || $3c99a37f3fed1403$var$defaultEncType;
        formData = new FormData(target);
    } else if ($3c99a37f3fed1403$var$isButtonElement(target) || $3c99a37f3fed1403$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $3c99a37f3fed1403$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $3c99a37f3fed1403$var$defaultMethod;
        encType = $3c99a37f3fed1403$var$getFormEncType(target.getAttribute("formenctype")) || $3c99a37f3fed1403$var$getFormEncType(form.getAttribute("enctype")) || $3c99a37f3fed1403$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$3c99a37f3fed1403$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($3c99a37f3fed1403$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $3c99a37f3fed1403$var$defaultMethod;
        action = null;
        encType = $3c99a37f3fed1403$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $3c99a37f3fed1403$var$HOLE = -1;
var $3c99a37f3fed1403$var$NAN = -2;
var $3c99a37f3fed1403$var$NEGATIVE_INFINITY = -3;
var $3c99a37f3fed1403$var$NEGATIVE_ZERO = -4;
var $3c99a37f3fed1403$var$NULL = -5;
var $3c99a37f3fed1403$var$POSITIVE_INFINITY = -6;
var $3c99a37f3fed1403$var$UNDEFINED = -7;
var $3c99a37f3fed1403$var$TYPE_BIGINT = "B";
var $3c99a37f3fed1403$var$TYPE_DATE = "D";
var $3c99a37f3fed1403$var$TYPE_ERROR = "E";
var $3c99a37f3fed1403$var$TYPE_MAP = "M";
var $3c99a37f3fed1403$var$TYPE_NULL_OBJECT = "N";
var $3c99a37f3fed1403$var$TYPE_PROMISE = "P";
var $3c99a37f3fed1403$var$TYPE_REGEXP = "R";
var $3c99a37f3fed1403$var$TYPE_SET = "S";
var $3c99a37f3fed1403$var$TYPE_SYMBOL = "Y";
var $3c99a37f3fed1403$var$TYPE_URL = "U";
var $3c99a37f3fed1403$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $3c99a37f3fed1403$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $3c99a37f3fed1403$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $3c99a37f3fed1403$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $3c99a37f3fed1403$var$UNDEFINED;
    if (input === null) return $3c99a37f3fed1403$var$NULL;
    if (Number.isNaN(input)) return $3c99a37f3fed1403$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $3c99a37f3fed1403$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $3c99a37f3fed1403$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $3c99a37f3fed1403$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $3c99a37f3fed1403$var$stringify.call(this, input, index);
    return index;
}
function $3c99a37f3fed1403$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$3c99a37f3fed1403$var$flatten.call(this, k)}":${$3c99a37f3fed1403$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$3c99a37f3fed1403$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$3c99a37f3fed1403$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$3c99a37f3fed1403$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$3c99a37f3fed1403$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $3c99a37f3fed1403$var$flatten.call(this, input2[i]) : $3c99a37f3fed1403$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$3c99a37f3fed1403$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$3c99a37f3fed1403$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$3c99a37f3fed1403$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$3c99a37f3fed1403$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$3c99a37f3fed1403$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$3c99a37f3fed1403$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$3c99a37f3fed1403$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $3c99a37f3fed1403$var$flatten.call(this, k),
                                    $3c99a37f3fed1403$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$3c99a37f3fed1403$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$3c99a37f3fed1403$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$3c99a37f3fed1403$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$3c99a37f3fed1403$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($3c99a37f3fed1403$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$3c99a37f3fed1403$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$3c99a37f3fed1403$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $3c99a37f3fed1403$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $3c99a37f3fed1403$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $3c99a37f3fed1403$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $3c99a37f3fed1403$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $3c99a37f3fed1403$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $3c99a37f3fed1403$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $3c99a37f3fed1403$var$hydrate.call(this, startIndex);
}
function $3c99a37f3fed1403$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $3c99a37f3fed1403$var$UNDEFINED:
                set(void 0);
                continue;
            case $3c99a37f3fed1403$var$NULL:
                set(null);
                continue;
            case $3c99a37f3fed1403$var$NAN:
                set(NaN);
                continue;
            case $3c99a37f3fed1403$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $3c99a37f3fed1403$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $3c99a37f3fed1403$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $3c99a37f3fed1403$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $3c99a37f3fed1403$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $3c99a37f3fed1403$var$globalObj && $3c99a37f3fed1403$var$globalObj[errorType] ? new $3c99a37f3fed1403$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $3c99a37f3fed1403$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $3c99a37f3fed1403$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $3c99a37f3fed1403$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $3c99a37f3fed1403$var$Deferred2();
    const reader = readable.pipeThrough($3c99a37f3fed1403$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $3c99a37f3fed1403$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $3c99a37f3fed1403$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $3c99a37f3fed1403$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $3c99a37f3fed1403$var$unflatten.call(this, line)
    };
}
async function $3c99a37f3fed1403$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $3c99a37f3fed1403$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $3c99a37f3fed1403$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $3c99a37f3fed1403$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $3c99a37f3fed1403$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $3c99a37f3fed1403$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $3c99a37f3fed1403$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $3c99a37f3fed1403$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$3c99a37f3fed1403$var$TYPE_PROMISE}${deferredId}:[["${$3c99a37f3fed1403$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$3c99a37f3fed1403$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$3c99a37f3fed1403$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $3c99a37f3fed1403$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$3c99a37f3fed1403$var$TYPE_ERROR}${deferredId}:[["${$3c99a37f3fed1403$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$3c99a37f3fed1403$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$3c99a37f3fed1403$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $3c99a37f3fed1403$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $3c99a37f3fed1403$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $3c99a37f3fed1403$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $3c99a37f3fed1403$export$4cf11838cdc2a8a8(html) {
    return html.replace($3c99a37f3fed1403$var$ESCAPE_REGEX, (match)=>$3c99a37f3fed1403$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $3c99a37f3fed1403$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $3c99a37f3fed1403$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $3c99a37f3fed1403$var$SingleFetchNoResultError = class extends Error {
};
var $3c99a37f3fed1403$export$ae9272e641ead836 = 202;
var $3c99a37f3fed1403$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $3c99a37f3fed1403$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $kYL7Z.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$3c99a37f3fed1403$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, scriptTag, /* @__PURE__ */ $kYL7Z.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, scriptTag, /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Suspense, null, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $3c99a37f3fed1403$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $3c99a37f3fed1403$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $3c99a37f3fed1403$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $3c99a37f3fed1403$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $3c99a37f3fed1403$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $3c99a37f3fed1403$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $3c99a37f3fed1403$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $3c99a37f3fed1403$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $3c99a37f3fed1403$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $3c99a37f3fed1403$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $3c99a37f3fed1403$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $3c99a37f3fed1403$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($3c99a37f3fed1403$export$3f1eb41d9a6a6a27(result.result) || $3c99a37f3fed1403$export$972111febbeef05b(result.result) || $3c99a37f3fed1403$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $3c99a37f3fed1403$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $3c99a37f3fed1403$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $3c99a37f3fed1403$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $3c99a37f3fed1403$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$3c99a37f3fed1403$var$createDeferred2());
    let singleFetchDfd = $3c99a37f3fed1403$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $3c99a37f3fed1403$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $3c99a37f3fed1403$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $3c99a37f3fed1403$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $3c99a37f3fed1403$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $3c99a37f3fed1403$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $3c99a37f3fed1403$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $3c99a37f3fed1403$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $3c99a37f3fed1403$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $3c99a37f3fed1403$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $3c99a37f3fed1403$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $3c99a37f3fed1403$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
        else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    }
    return url;
}
async function $3c99a37f3fed1403$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $3c99a37f3fed1403$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $3c99a37f3fed1403$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $3c99a37f3fed1403$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $3c99a37f3fed1403$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $3c99a37f3fed1403$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($3c99a37f3fed1403$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $3c99a37f3fed1403$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $3c99a37f3fed1403$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($3c99a37f3fed1403$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$3c99a37f3fed1403$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $3c99a37f3fed1403$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $3c99a37f3fed1403$export$4023ad4ecd4126a2(body, global) {
    return $3c99a37f3fed1403$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $3c99a37f3fed1403$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$3c99a37f3fed1403$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $3c99a37f3fed1403$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $3c99a37f3fed1403$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $3c99a37f3fed1403$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $3c99a37f3fed1403$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $3c99a37f3fed1403$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $3c99a37f3fed1403$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $3c99a37f3fed1403$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $3c99a37f3fed1403$var$getModuleLinkHrefs(matches, manifest);
    return $3c99a37f3fed1403$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $3c99a37f3fed1403$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $3c99a37f3fed1403$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $3c99a37f3fed1403$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($3c99a37f3fed1403$var$prefetchStyleLink));
}
async function $3c99a37f3fed1403$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$3c99a37f3fed1403$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$3c99a37f3fed1403$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$3c99a37f3fed1403$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($3c99a37f3fed1403$var$prefetchStyleLink));
}
async function $3c99a37f3fed1403$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $3c99a37f3fed1403$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $3c99a37f3fed1403$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $3c99a37f3fed1403$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $3c99a37f3fed1403$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $3c99a37f3fed1403$var$dedupeLinkDescriptors(links.flat(1).filter($3c99a37f3fed1403$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $3c99a37f3fed1403$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $3c99a37f3fed1403$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $3c99a37f3fed1403$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $3c99a37f3fed1403$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $3c99a37f3fed1403$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $3c99a37f3fed1403$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$3c99a37f3fed1403$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($3c99a37f3fed1403$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $3c99a37f3fed1403$var$_isPreloadSupported;
function $3c99a37f3fed1403$var$isPreloadSupported() {
    if ($3c99a37f3fed1403$var$_isPreloadSupported !== void 0) return $3c99a37f3fed1403$var$_isPreloadSupported;
    let el = document.createElement("link");
    $3c99a37f3fed1403$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $3c99a37f3fed1403$var$_isPreloadSupported;
}
function $3c99a37f3fed1403$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $3c99a37f3fed1403$export$945fecf35a8ef089 ? /* @__PURE__ */ $kYL7Z.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $3c99a37f3fed1403$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $3c99a37f3fed1403$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $3c99a37f3fed1403$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $3c99a37f3fed1403$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$RemixRootDefaultErrorBoundary, {
            error: $3c99a37f3fed1403$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $kYL7Z.createElement(routeModule.Layout, null, /* @__PURE__ */ $kYL7Z.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $kYL7Z.createElement(routeModule.Layout, null, /* @__PURE__ */ $kYL7Z.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $kYL7Z.createElement(routeModule.Layout, null, /* @__PURE__ */ $kYL7Z.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $3c99a37f3fed1403$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $3c99a37f3fed1403$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $3c99a37f3fed1403$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$3c99a37f3fed1403$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $3c99a37f3fed1403$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $3c99a37f3fed1403$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $3c99a37f3fed1403$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $3c99a37f3fed1403$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $3c99a37f3fed1403$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $3c99a37f3fed1403$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $3c99a37f3fed1403$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $3c99a37f3fed1403$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $3c99a37f3fed1403$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $3c99a37f3fed1403$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $3c99a37f3fed1403$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $3c99a37f3fed1403$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $3c99a37f3fed1403$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$3c99a37f3fed1403$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $3c99a37f3fed1403$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $3c99a37f3fed1403$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $3c99a37f3fed1403$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $3c99a37f3fed1403$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $3c99a37f3fed1403$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $3c99a37f3fed1403$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $3c99a37f3fed1403$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $3c99a37f3fed1403$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $3c99a37f3fed1403$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $3c99a37f3fed1403$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $3c99a37f3fed1403$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $3c99a37f3fed1403$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $3c99a37f3fed1403$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $3c99a37f3fed1403$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $3c99a37f3fed1403$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $3c99a37f3fed1403$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $3c99a37f3fed1403$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $3c99a37f3fed1403$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $3c99a37f3fed1403$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $3c99a37f3fed1403$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $3c99a37f3fed1403$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $3c99a37f3fed1403$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $3c99a37f3fed1403$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $3c99a37f3fed1403$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $3c99a37f3fed1403$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $3c99a37f3fed1403$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $3c99a37f3fed1403$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $3c99a37f3fed1403$var$nextPaths = /* @__PURE__ */ new Set();
var $3c99a37f3fed1403$var$discoveredPathsMaxSize = 1e3;
var $3c99a37f3fed1403$var$discoveredPaths = /* @__PURE__ */ new Set();
var $3c99a37f3fed1403$var$URL_LIMIT = 7680;
function $3c99a37f3fed1403$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $3c99a37f3fed1403$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $3c99a37f3fed1403$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $3c99a37f3fed1403$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$3c99a37f3fed1403$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($3c99a37f3fed1403$var$discoveredPaths.has(path)) return;
        await $3c99a37f3fed1403$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $3c99a37f3fed1403$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $kYL7Z.useEffect(()=>{
        if (!$3c99a37f3fed1403$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$3c99a37f3fed1403$var$discoveredPaths.has(pathname)) $3c99a37f3fed1403$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($3c99a37f3fed1403$var$nextPaths.keys()).filter((path)=>{
                if ($3c99a37f3fed1403$var$discoveredPaths.has(path)) {
                    $3c99a37f3fed1403$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $3c99a37f3fed1403$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $3c99a37f3fed1403$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $3c99a37f3fed1403$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $3c99a37f3fed1403$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $3c99a37f3fed1403$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($3c99a37f3fed1403$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $3c99a37f3fed1403$var$URL_LIMIT) {
        $3c99a37f3fed1403$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($3c99a37f3fed1403$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($3c99a37f3fed1403$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($3c99a37f3fed1403$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$3c99a37f3fed1403$var$addToFifoQueue(p, $3c99a37f3fed1403$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $3c99a37f3fed1403$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $3c99a37f3fed1403$var$addToFifoQueue(path, queue) {
    if (queue.size >= $3c99a37f3fed1403$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $3c99a37f3fed1403$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $3c99a37f3fed1403$var$useDataRouterContext2() {
    let context = $kYL7Z.useContext($3c99a37f3fed1403$export$2eeee58951ff3c1c);
    $3c99a37f3fed1403$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $3c99a37f3fed1403$var$useDataRouterStateContext() {
    let context = $kYL7Z.useContext($3c99a37f3fed1403$export$315e3ffb01f217);
    $3c99a37f3fed1403$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $3c99a37f3fed1403$export$208d6a3bc3aa62bd = $kYL7Z.createContext(void 0);
$3c99a37f3fed1403$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $3c99a37f3fed1403$var$useFrameworkContext() {
    let context = $kYL7Z.useContext($3c99a37f3fed1403$export$208d6a3bc3aa62bd);
    $3c99a37f3fed1403$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $3c99a37f3fed1403$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $kYL7Z.useContext($3c99a37f3fed1403$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $kYL7Z.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $kYL7Z.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $kYL7Z.useRef(null);
    $kYL7Z.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $kYL7Z.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $3c99a37f3fed1403$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $3c99a37f3fed1403$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $3c99a37f3fed1403$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $3c99a37f3fed1403$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $3c99a37f3fed1403$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $3c99a37f3fed1403$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $3c99a37f3fed1403$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$3c99a37f3fed1403$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $3c99a37f3fed1403$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $3c99a37f3fed1403$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $3c99a37f3fed1403$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $3c99a37f3fed1403$var$useDataRouterStateContext();
    let matches = $3c99a37f3fed1403$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $kYL7Z.useMemo(()=>$3c99a37f3fed1403$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $kYL7Z.createElement("style", {
        [$3c99a37f3fed1403$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $kYL7Z.createElement("link", {
        [$3c99a37f3fed1403$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>$3c99a37f3fed1403$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $kYL7Z.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
function $3c99a37f3fed1403$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $3c99a37f3fed1403$var$useDataRouterContext2();
    let matches = $kYL7Z.useMemo(()=>$3c99a37f3fed1403$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $3c99a37f3fed1403$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $3c99a37f3fed1403$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $kYL7Z.useState([]);
    $kYL7Z.useEffect(()=>{
        let interrupted = false;
        $3c99a37f3fed1403$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $3c99a37f3fed1403$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $3c99a37f3fed1403$var$useFrameworkContext();
    let { basename: basename } = $3c99a37f3fed1403$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $3c99a37f3fed1403$var$useDataRouterStateContext();
    let newMatchesForData = $kYL7Z.useMemo(()=>$3c99a37f3fed1403$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $kYL7Z.useMemo(()=>$3c99a37f3fed1403$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $kYL7Z.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $3c99a37f3fed1403$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $kYL7Z.useMemo(()=>$3c99a37f3fed1403$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $3c99a37f3fed1403$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $kYL7Z.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $kYL7Z.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $kYL7Z.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
function $3c99a37f3fed1403$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $3c99a37f3fed1403$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $3c99a37f3fed1403$var$useDataRouterStateContext();
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let _matches = $3c99a37f3fed1403$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$3c99a37f3fed1403$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $kYL7Z.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $kYL7Z.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $kYL7Z.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $kYL7Z.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $3c99a37f3fed1403$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $kYL7Z.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $3c99a37f3fed1403$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $3c99a37f3fed1403$var$isHydrated = false;
function $3c99a37f3fed1403$export$3be068dde909e563() {
    $3c99a37f3fed1403$var$isHydrated = true;
}
function $3c99a37f3fed1403$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $3c99a37f3fed1403$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $3c99a37f3fed1403$var$useDataRouterContext2();
    let { matches: routerMatches } = $3c99a37f3fed1403$var$useDataRouterStateContext();
    let isRSCRouterContext = $3c99a37f3fed1403$var$useIsRSCRouterContext();
    let enableFogOfWar = $3c99a37f3fed1403$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $3c99a37f3fed1403$var$getActiveMatches(routerMatches, null, isSpaMode);
    $kYL7Z.useEffect(()=>{
        $3c99a37f3fed1403$export$3be068dde909e563();
    }, []);
    let initialScripts = $kYL7Z.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $3c99a37f3fed1403$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($3c99a37f3fed1403$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, /* @__PURE__ */ $kYL7Z.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $kYL7Z.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $3c99a37f3fed1403$var$isHydrated || isRSCRouterContext ? [] : $3c99a37f3fed1403$var$dedupe(manifest.entry.imports.concat($3c99a37f3fed1403$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $3c99a37f3fed1403$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $3c99a37f3fed1403$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $kYL7Z.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $kYL7Z.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $kYL7Z.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $kYL7Z.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $3c99a37f3fed1403$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $3c99a37f3fed1403$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $3c99a37f3fed1403$export$32e57f52df4b6e34 = class extends $kYL7Z.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $3c99a37f3fed1403$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $kYL7Z.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($3c99a37f3fed1403$export$972111febbeef05b(error)) return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $kYL7Z.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $3c99a37f3fed1403$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $kYL7Z.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $kYL7Z.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $3c99a37f3fed1403$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $3c99a37f3fed1403$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $kYL7Z.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $kYL7Z.createElement("head", null, /* @__PURE__ */ $kYL7Z.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $kYL7Z.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $kYL7Z.createElement("title", null, title)), /* @__PURE__ */ $kYL7Z.createElement("body", null, /* @__PURE__ */ $kYL7Z.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$ff0bf87698939488, null) : null)));
}
var $3c99a37f3fed1403$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($3c99a37f3fed1403$var$isBrowser2) window.__reactRouterVersion = "7.13.0";
} catch (e) {}
function $3c99a37f3fed1403$export$1f3f55432a00e06d(routes, opts) {
    return $3c99a37f3fed1403$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3c99a37f3fed1403$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $3c99a37f3fed1403$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $3c99a37f3fed1403$export$9269a41d8c4635e,
        hydrationRouteProperties: $3c99a37f3fed1403$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $3c99a37f3fed1403$export$1ba7ed8a3a7b3765(routes, opts) {
    return $3c99a37f3fed1403$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $3c99a37f3fed1403$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $3c99a37f3fed1403$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $3c99a37f3fed1403$export$9269a41d8c4635e,
        hydrationRouteProperties: $3c99a37f3fed1403$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $3c99a37f3fed1403$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $3c99a37f3fed1403$var$deserializeErrors(state.errors)
    };
    return state;
}
function $3c99a37f3fed1403$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $3c99a37f3fed1403$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $3c99a37f3fed1403$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $kYL7Z.useRef();
    if (historyRef.current == null) historyRef.current = $3c99a37f3fed1403$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kYL7Z.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYL7Z.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $kYL7Z.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $kYL7Z.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $3c99a37f3fed1403$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $kYL7Z.useRef();
    if (historyRef.current == null) historyRef.current = $3c99a37f3fed1403$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $kYL7Z.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYL7Z.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $kYL7Z.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $kYL7Z.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $3c99a37f3fed1403$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $kYL7Z.useState({
        action: history.action,
        location: history.location
    });
    let setState = $kYL7Z.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $kYL7Z.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $kYL7Z.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$3c99a37f3fed1403$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $3c99a37f3fed1403$export$a6c7ac8248d6e38a = $kYL7Z.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, unstable_useTransitions: unstable_useTransitions } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $3c99a37f3fed1403$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $3c99a37f3fed1403$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $3c99a37f3fed1403$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $3c99a37f3fed1403$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $kYL7Z.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: parsed.absoluteURL || href,
        onClick: parsed.isExternal || reloadDocument ? onClick : handleClick,
        ref: $3c99a37f3fed1403$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, link, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$3c99a37f3fed1403$export$a6c7ac8248d6e38a.displayName = "Link";
var $3c99a37f3fed1403$export$b0d92dbee9b5b60d = $kYL7Z.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $3c99a37f3fed1403$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let routerState = $kYL7Z.useContext($3c99a37f3fed1403$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $3c99a37f3fed1403$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $3c99a37f3fed1403$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$3c99a37f3fed1403$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $3c99a37f3fed1403$export$a7fed597f4b8afd8 = $kYL7Z.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $3c99a37f3fed1403$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let submit = $3c99a37f3fed1403$export$47c85c6e3a081d3();
    let formAction = $3c99a37f3fed1403$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $kYL7Z.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $kYL7Z.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$3c99a37f3fed1403$export$a7fed597f4b8afd8.displayName = "Form";
function $3c99a37f3fed1403$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $kYL7Z.useContext($3c99a37f3fed1403$export$208d6a3bc3aa62bd);
    let { basename: basename } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let matches = $3c99a37f3fed1403$export$2378eb7f5ff86053();
    $3c99a37f3fed1403$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $kYL7Z.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $3c99a37f3fed1403$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $kYL7Z.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$3c99a37f3fed1403$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $3c99a37f3fed1403$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$3c99a37f3fed1403$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$3c99a37f3fed1403$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $3c99a37f3fed1403$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $3c99a37f3fed1403$var$useDataRouterContext3(hookName) {
    let ctx = $kYL7Z.useContext($3c99a37f3fed1403$export$2eeee58951ff3c1c);
    $3c99a37f3fed1403$export$f5708dca728d7177(ctx, $3c99a37f3fed1403$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $3c99a37f3fed1403$var$useDataRouterState2(hookName) {
    let state = $kYL7Z.useContext($3c99a37f3fed1403$export$315e3ffb01f217);
    $3c99a37f3fed1403$export$f5708dca728d7177(state, $3c99a37f3fed1403$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $3c99a37f3fed1403$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $3c99a37f3fed1403$export$9770f232ac06a008();
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let path = $3c99a37f3fed1403$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $kYL7Z.useCallback((event)=>{
        if ($3c99a37f3fed1403$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $3c99a37f3fed1403$export$fe53371bee54353d(location) === $3c99a37f3fed1403$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $kYL7Z.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $3c99a37f3fed1403$export$f1a78c17382fe22a(defaultInit) {
    $3c99a37f3fed1403$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $kYL7Z.useRef($3c99a37f3fed1403$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $kYL7Z.useRef(false);
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let searchParams = $kYL7Z.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $3c99a37f3fed1403$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $3c99a37f3fed1403$export$9770f232ac06a008();
    let setSearchParams = $kYL7Z.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $3c99a37f3fed1403$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $3c99a37f3fed1403$var$fetcherId = 0;
var $3c99a37f3fed1403$var$getUniqueFetcherId = ()=>`__${String(++$3c99a37f3fed1403$var$fetcherId)}__`;
function $3c99a37f3fed1403$export$47c85c6e3a081d3() {
    let { router: router } = $3c99a37f3fed1403$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let currentRouteId = $3c99a37f3fed1403$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $kYL7Z.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $3c99a37f3fed1403$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $3c99a37f3fed1403$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $3c99a37f3fed1403$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let routeContext = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    $3c99a37f3fed1403$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$3c99a37f3fed1403$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $3c99a37f3fed1403$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $3c99a37f3fed1403$export$fe53371bee54353d(path);
}
function $3c99a37f3fed1403$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $3c99a37f3fed1403$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $3c99a37f3fed1403$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $kYL7Z.useContext($3c99a37f3fed1403$export$cb3f1df1bef00a39);
    let route = $kYL7Z.useContext($3c99a37f3fed1403$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $3c99a37f3fed1403$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $3c99a37f3fed1403$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $3c99a37f3fed1403$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $kYL7Z.useId();
    let [fetcherKey, setFetcherKey] = $kYL7Z.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $kYL7Z.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $kYL7Z.useCallback(async (href, opts)=>{
        $3c99a37f3fed1403$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $3c99a37f3fed1403$export$47c85c6e3a081d3();
    let submit = $kYL7Z.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $kYL7Z.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $kYL7Z.useMemo(()=>{
        let FetcherForm2 = $kYL7Z.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $3c99a37f3fed1403$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $kYL7Z.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $3c99a37f3fed1403$export$fa996778a3a31087() {
    let state = $3c99a37f3fed1403$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $3c99a37f3fed1403$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $3c99a37f3fed1403$var$savedScrollPositions = {};
function $3c99a37f3fed1403$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $3c99a37f3fed1403$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $3c99a37f3fed1403$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $3c99a37f3fed1403$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $3c99a37f3fed1403$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $kYL7Z.useContext($3c99a37f3fed1403$export$3044ab7fdabeaee6);
    let location = $3c99a37f3fed1403$export$45d76561a5302f2b();
    let matches = $3c99a37f3fed1403$export$2378eb7f5ff86053();
    let navigation = $3c99a37f3fed1403$export$d0fd4b7106de2769();
    $kYL7Z.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $3c99a37f3fed1403$var$usePageHide($kYL7Z.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $3c99a37f3fed1403$var$getScrollRestorationKey(location, matches, basename, getKey);
            $3c99a37f3fed1403$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $3c99a37f3fed1403$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($3c99a37f3fed1403$var$savedScrollPositions));
        } catch (error) {
            $3c99a37f3fed1403$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $kYL7Z.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $3c99a37f3fed1403$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $3c99a37f3fed1403$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $kYL7Z.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($3c99a37f3fed1403$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$3c99a37f3fed1403$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $kYL7Z.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $3c99a37f3fed1403$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $3c99a37f3fed1403$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $kYL7Z.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $3c99a37f3fed1403$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $kYL7Z.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $3c99a37f3fed1403$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $3c99a37f3fed1403$export$b273b3273281a049(when);
    $kYL7Z.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $kYL7Z.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $3c99a37f3fed1403$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $kYL7Z.useContext($3c99a37f3fed1403$export$3681f408decb40d1);
    $3c99a37f3fed1403$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $3c99a37f3fed1403$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $3c99a37f3fed1403$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $3c99a37f3fed1403$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $3c99a37f3fed1403$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $3c99a37f3fed1403$export$81336c211d5ff295(path.pathname, nextPath) != null || $3c99a37f3fed1403$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $3c99a37f3fed1403$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $3c99a37f3fed1403$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $3c99a37f3fed1403$var$getStatelessNavigator();
    return /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $3c99a37f3fed1403$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $3c99a37f3fed1403$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $3c99a37f3fed1403$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $3c99a37f3fed1403$var$serializeErrors(context.errors)
        };
        let json = $3c99a37f3fed1403$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $kYL7Z.createElement($kYL7Z.Fragment, null, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $kYL7Z.createElement($3c99a37f3fed1403$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $kYL7Z.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $3c99a37f3fed1403$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $3c99a37f3fed1403$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $3c99a37f3fed1403$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($3c99a37f3fed1403$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $3c99a37f3fed1403$var$getStatelessNavigator() {
    return {
        createHref: $3c99a37f3fed1403$var$createHref,
        encodeLocation: $3c99a37f3fed1403$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $3c99a37f3fed1403$export$69163f0b72ec60d9(routes, opts) {
    return $3c99a37f3fed1403$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $3c99a37f3fed1403$export$9269a41d8c4635e
    });
}
function $3c99a37f3fed1403$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $3c99a37f3fed1403$export$87cb1a9238dc3fba(routes, $3c99a37f3fed1403$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $3c99a37f3fed1403$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $3c99a37f3fed1403$var$createHref,
        encodeLocation: $3c99a37f3fed1403$var$encodeLocation,
        getFetcher () {
            return $3c99a37f3fed1403$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $3c99a37f3fed1403$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $3c99a37f3fed1403$var$createHref(to) {
    return typeof to === "string" ? to : $3c99a37f3fed1403$export$fe53371bee54353d(to);
}
function $3c99a37f3fed1403$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $3c99a37f3fed1403$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $3c99a37f3fed1403$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;


// This is a magic string replaced by rollup
const $5480def7277060d8$export$31499a9cd224b78c = "10.38.0";


/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $e2edf35eced5b7b2$export$f1a6cdb1459e81d1 = globalThis;


/**
 * An object that contains globally accessible properties and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $b51d9d034721a478$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $b51d9d034721a478$export$c8bfa33e4e8ae492((0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1));
    return 0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $b51d9d034721a478$export$c8bfa33e4e8ae492(carrier) {
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    // For now: First SDK that sets the .version property wins
    __SENTRY__.version = __SENTRY__.version || (0, $5480def7277060d8$export$31499a9cd224b78c);
    // Intentionally populating and returning the version of "this" SDK instance
    // rather than what's set in .version so that "this" SDK always gets its carrier
    return __SENTRY__[0, $5480def7277060d8$export$31499a9cd224b78c] = __SENTRY__[0, $5480def7277060d8$export$31499a9cd224b78c] || {};
}
/**
 * Returns a global singleton contained in the global `__SENTRY__[]` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $b51d9d034721a478$export$7e223ec222791509(name, creator, obj = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1)) {
    const __SENTRY__ = obj.__SENTRY__ = obj.__SENTRY__ || {};
    const carrier = __SENTRY__[0, $5480def7277060d8$export$31499a9cd224b78c] = __SENTRY__[0, $5480def7277060d8$export$31499a9cd224b78c] || {};
    // Note: We do not want to set `carrier.version` here, as this may be called before any `init` is called, e.g. for the default scopes
    return carrier[name] || (carrier[name] = creator());
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $e74753b69eef4000$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



// eslint-disable-next-line @typescript-eslint/unbound-method
const $057f17bbb7048b01$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$e6127cc7fe7395c3(wat) {
    switch($057f17bbb7048b01$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
        case '[object WebAssembly.Exception]':
            return true;
        default:
            return $057f17bbb7048b01$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$var$isBuiltin(wat, className) {
    return $057f17bbb7048b01$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$9f9636d330b71954(wat) {
    return $057f17bbb7048b01$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$ef9e2056653f0c8e(wat) {
    return $057f17bbb7048b01$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$12e869b2a583f783(wat) {
    return $057f17bbb7048b01$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$844ec244b1367d54(wat) {
    return $057f17bbb7048b01$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$c3825b437cbdea5c(wat) {
    return wat === null || $057f17bbb7048b01$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$53b83ca8eaab0383(wat) {
    return $057f17bbb7048b01$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $057f17bbb7048b01$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $057f17bbb7048b01$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$49841c62b9eff15(wat) {
    return $057f17bbb7048b01$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $057f17bbb7048b01$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat?.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$bc2894c7158efbac(wat) {
    return $057f17bbb7048b01$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ // TODO: fix in v11, convert any to unknown
// export function isInstanceOf<T>(wat: unknown, base: { new (...args: any[]): T }): wat is T {
function $057f17bbb7048b01$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch  {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel or a VNode.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $057f17bbb7048b01$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    // We also need to check for __v_isVNode because Vue 3 component render instances have an internal __v_isVNode property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue || wat.__v_isVNode));
}
/**
 * Checks whether the given parameter is a Standard Web API Request instance.
 *
 * Returns false if Request is not available in the current runtime.
 */ function $057f17bbb7048b01$export$6d3d1f317d7cda57(request) {
    return typeof Request !== 'undefined' && $057f17bbb7048b01$export$49034edbe6b62415(request, Request);
}



const $8fe80379f466e1f6$var$WINDOW = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);
const $8fe80379f466e1f6$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8fe80379f466e1f6$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8fe80379f466e1f6$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8fe80379f466e1f6$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch  {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8fe80379f466e1f6$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    if (!elem?.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($8fe80379f466e1f6$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs?.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs?.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        const className = elem.className;
        if (className && (0, $057f17bbb7048b01$export$844ec244b1367d54)(className)) {
            const classes = className.split(/\s+/);
            for (const c of classes)out.push(`.${c}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for (const k of allowedAttrs){
        const attr = elem.getAttribute(k);
        if (attr) out.push(`[${k}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $8fe80379f466e1f6$export$1cfafeee2987818b() {
    try {
        return $8fe80379f466e1f6$var$WINDOW.document.location.href;
    } catch  {
        return '';
    }
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precedence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $8fe80379f466e1f6$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$8fe80379f466e1f6$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}





const $ff784a3dc7695b3c$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** Prefix for logging strings */ const $ff784a3dc7695b3c$var$PREFIX = 'Sentry Logger ';
/** This may be mutated by the console instrumentation. */ const $ff784a3dc7695b3c$export$77c4ce905194557b = {};
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $ff784a3dc7695b3c$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($ff784a3dc7695b3c$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $ff784a3dc7695b3c$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $ff784a3dc7695b3c$var$enable() {
    $ff784a3dc7695b3c$var$_getLoggerSettings().enabled = true;
}
function $ff784a3dc7695b3c$var$disable() {
    $ff784a3dc7695b3c$var$_getLoggerSettings().enabled = false;
}
function $ff784a3dc7695b3c$var$isEnabled() {
    return $ff784a3dc7695b3c$var$_getLoggerSettings().enabled;
}
function $ff784a3dc7695b3c$var$log(...args) {
    $ff784a3dc7695b3c$var$_maybeLog('log', ...args);
}
function $ff784a3dc7695b3c$var$warn(...args) {
    $ff784a3dc7695b3c$var$_maybeLog('warn', ...args);
}
function $ff784a3dc7695b3c$var$error(...args) {
    $ff784a3dc7695b3c$var$_maybeLog('error', ...args);
}
function $ff784a3dc7695b3c$var$_maybeLog(level, ...args) {
    if (!(0, $e74753b69eef4000$export$16a28057038b10ef)) return;
    if ($ff784a3dc7695b3c$var$isEnabled()) $ff784a3dc7695b3c$export$cda52e2a8927a2ca(()=>{
        (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).console[level](`${$ff784a3dc7695b3c$var$PREFIX}[${level}]:`, ...args);
    });
}
function $ff784a3dc7695b3c$var$_getLoggerSettings() {
    if (!(0, $e74753b69eef4000$export$16a28057038b10ef)) return {
        enabled: false
    };
    return (0, $b51d9d034721a478$export$7e223ec222791509)('loggerSettings', ()=>({
            enabled: false
        }));
}
/**
 * This is a logger singleton which either logs things or no-ops if logging is not enabled.
 */ const $ff784a3dc7695b3c$export$1c9f709888824e05 = {
    enable: /** Enable logging. */ $ff784a3dc7695b3c$var$enable,
    disable: /** Disable logging. */ $ff784a3dc7695b3c$var$disable,
    isEnabled: /** Check if logging is enabled. */ $ff784a3dc7695b3c$var$isEnabled,
    log: /** Log a message. */ $ff784a3dc7695b3c$var$log,
    warn: /** Log a warning. */ $ff784a3dc7695b3c$var$warn,
    error: /** Log an error. */ $ff784a3dc7695b3c$var$error
};



/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Replace a method in an object with a wrapped version of itself.
 *
 * If the method on the passed object is not a function, the wrapper will not be applied.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $085a6ebfb8b9293d$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    // explicitly casting to unknown because we don't know the type of the method initially at all
    const original = source[name];
    if (typeof original !== 'function') return;
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $085a6ebfb8b9293d$export$5c1499e2e5d010ae(wrapped, original);
    try {
        source[name] = wrapped;
    } catch  {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Failed to replace method "${name}" in object`, source);
    }
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $085a6ebfb8b9293d$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch  {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $085a6ebfb8b9293d$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $085a6ebfb8b9293d$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch  {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $085a6ebfb8b9293d$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argument itself, when value is neither an Event nor
 *  an Error.
 */ function $085a6ebfb8b9293d$export$62ff257738bf57f5(value) {
    if ((0, $057f17bbb7048b01$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$085a6ebfb8b9293d$var$getOwnProperties(value)
    };
    else if ((0, $057f17bbb7048b01$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $085a6ebfb8b9293d$var$serializeEventTarget(value.target),
            currentTarget: $085a6ebfb8b9293d$var$serializeEventTarget(value.currentTarget),
            ...$085a6ebfb8b9293d$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $057f17bbb7048b01$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $085a6ebfb8b9293d$var$serializeEventTarget(target) {
    try {
        return (0, $057f17bbb7048b01$export$45a5e7f76e0caa8d)(target) ? (0, $8fe80379f466e1f6$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch  {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $085a6ebfb8b9293d$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $085a6ebfb8b9293d$export$b0244d5063c0b61b(exception) {
    const keys = Object.keys($085a6ebfb8b9293d$export$62ff257738bf57f5(exception));
    keys.sort();
    return !keys[0] ? '[object has no keys]' : keys.join(', ');
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 *
 * @deprecated This function is no longer used by the SDK and will be removed in a future major version.
 */ function $085a6ebfb8b9293d$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $085a6ebfb8b9293d$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $085a6ebfb8b9293d$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    // Early return for primitive values
    if (inputValue === null || typeof inputValue !== 'object') return inputValue;
    // Check memo map first for all object types
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) return memoVal;
    // handle arrays
    if (Array.isArray(inputValue)) {
        const returnValue = [];
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((value)=>{
            returnValue.push($085a6ebfb8b9293d$var$_dropUndefinedKeys(value, memoizationMap));
        });
        return returnValue;
    }
    if ($085a6ebfb8b9293d$var$isPojo(inputValue)) {
        const returnValue = {};
        // Store mapping to handle circular references
        memoizationMap.set(inputValue, returnValue);
        const keys = Object.keys(inputValue);
        keys.forEach((key)=>{
            const val = inputValue[key];
            if (val !== undefined) returnValue[key] = $085a6ebfb8b9293d$var$_dropUndefinedKeys(val, memoizationMap);
        });
        return returnValue;
    }
    // For other object types, return as is
    return inputValue;
}
function $085a6ebfb8b9293d$var$isPojo(input) {
    // Plain objects have Object as constructor or no constructor
    const constructor = input.constructor;
    return constructor === Object || constructor === undefined;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $085a6ebfb8b9293d$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        // this will catch both undefined and null
        case wat == undefined:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $057f17bbb7048b01$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}



// undefined = not yet resolved, null = no runner found, function = runner found
let $3ce37121dbb69e34$var$RESOLVED_RUNNER;
/**
 * Simple wrapper that allows SDKs to *secretly* set context wrapper to generate safe random IDs in cache components contexts
 */ function $3ce37121dbb69e34$export$ff239213cb80e2da(cb) {
    // Skips future symbol lookups if we've already resolved (or attempted to resolve) the runner once
    if ($3ce37121dbb69e34$var$RESOLVED_RUNNER !== undefined) return $3ce37121dbb69e34$var$RESOLVED_RUNNER ? $3ce37121dbb69e34$var$RESOLVED_RUNNER(cb) : cb();
    const sym = Symbol.for('__SENTRY_SAFE_RANDOM_ID_WRAPPER__');
    const globalWithSymbol = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);
    if (sym in globalWithSymbol && typeof globalWithSymbol[sym] === 'function') {
        $3ce37121dbb69e34$var$RESOLVED_RUNNER = globalWithSymbol[sym];
        return $3ce37121dbb69e34$var$RESOLVED_RUNNER(cb);
    }
    $3ce37121dbb69e34$var$RESOLVED_RUNNER = null;
    return cb();
}
/**
 * Identical to Math.random() but wrapped in withRandomSafeContext
 * to ensure safe random number generation in certain contexts (e.g., Next.js Cache Components).
 */ function $3ce37121dbb69e34$export$9869d72de32a3917() {
    return $3ce37121dbb69e34$export$ff239213cb80e2da(()=>Math.random());
}
/**
 * Identical to Date.now() but wrapped in withRandomSafeContext
 * to ensure safe time value generation in certain contexts (e.g., Next.js Cache Components).
 */ function $3ce37121dbb69e34$export$65b1bada40c91b34() {
    return $3ce37121dbb69e34$export$ff239213cb80e2da(()=>Date.now());
}



const $7a317b2b764bd658$var$STACKTRACE_FRAME_LIMIT = 50;
const $7a317b2b764bd658$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $7a317b2b764bd658$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $7a317b2b764bd658$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $7a317b2b764bd658$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            let line = lines[i];
            // Truncate lines over 1kb because many of the regular expressions use
            // backtracking which results in run time that increases exponentially
            // with input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) line = line.slice(0, 1024);
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $7a317b2b764bd658$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($7a317b2b764bd658$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $7a317b2b764bd658$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $7a317b2b764bd658$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $7a317b2b764bd658$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $7a317b2b764bd658$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $7a317b2b764bd658$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test($7a317b2b764bd658$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($7a317b2b764bd658$var$STRIP_FRAME_REGEXP.test($7a317b2b764bd658$var$getLastStackFrame(localStack).function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the scope itself, making it:
        //
        //   Sentry.captureException()
        //   scope.captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($7a317b2b764bd658$var$STRIP_FRAME_REGEXP.test($7a317b2b764bd658$var$getLastStackFrame(localStack).function || '')) localStack.pop();
    }
    return localStack.slice(0, $7a317b2b764bd658$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || $7a317b2b764bd658$var$getLastStackFrame(localStack).filename,
            function: frame.function || $7a317b2b764bd658$export$27c7e15d453fc0ac
        }));
}
function $7a317b2b764bd658$var$getLastStackFrame(arr) {
    return arr[arr.length - 1] || {};
}
const $7a317b2b764bd658$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $7a317b2b764bd658$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $7a317b2b764bd658$var$defaultFunctionName;
        return fn.name || $7a317b2b764bd658$var$defaultFunctionName;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $7a317b2b764bd658$var$defaultFunctionName;
    }
}
/**
 * Get's stack frames from an event without needing to check for undefined properties.
 */ function $7a317b2b764bd658$export$91d8ca51bd9f6a47(event) {
    const exception = event.exception;
    if (exception) {
        const frames = [];
        try {
            // @ts-expect-error Object could be undefined
            exception.values.forEach((value)=>{
                // @ts-expect-error Value could be undefined
                if (value.stacktrace.frames) // @ts-expect-error Value could be undefined
                frames.push(...value.stacktrace.frames);
            });
            return frames;
        } catch  {
            return undefined;
        }
    }
    return undefined;
}
/**
 * Get the internal name of an internal Vue value, to represent it in a stacktrace.
 *
 * @param value The value to get the internal name of.
 */ function $7a317b2b764bd658$export$b6d9c5eb2330759f(value) {
    // Check if it's a VNode (has __v_isVNode) or a component instance (has _isVue/__isVue)
    const isVNode = '__v_isVNode' in value && value.__v_isVNode;
    return isVNode ? '[VueVNode]' : '[VueViewModel]';
}
/**
 * Normalizes stack line paths by removing file:// prefix and leading slashes for Windows paths
 */ function $7a317b2b764bd658$export$60c0d6c8e038267a(path) {
    let filename = path?.startsWith('file://') ? path.slice(7) : path;
    // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
    if (filename?.match(/\/[A-Z]:/)) filename = filename.slice(1);
    return filename;
}


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $ff73814e958d28bd$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $ff73814e958d28bd$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ function $ff73814e958d28bd$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $057f17bbb7048b01$export$7916fad0ebc23f48)(value)) output.push((0, $7a317b2b764bd658$export$b6d9c5eb2330759f)(value));
            else output.push(String(value));
        } catch  {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $ff73814e958d28bd$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $057f17bbb7048b01$export$844ec244b1367d54)(value)) return false;
    if ((0, $057f17bbb7048b01$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $057f17bbb7048b01$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $ff73814e958d28bd$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$ff73814e958d28bd$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}



function $4da1f60d556678ad$var$getCrypto() {
    const gbl = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);
    return gbl.crypto || gbl.msCrypto;
}
let $4da1f60d556678ad$var$emptyUuid;
function $4da1f60d556678ad$var$getRandomByte() {
    return (0, $3ce37121dbb69e34$export$9869d72de32a3917)() * 16;
}
/**
 * UUID4 generator
 * @param crypto Object that provides the crypto API.
 * @returns string Generated UUID4.
 */ function $4da1f60d556678ad$export$19f53698e68b2496(crypto = $4da1f60d556678ad$var$getCrypto()) {
    try {
        if (crypto?.randomUUID) // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $3ce37121dbb69e34$export$ff239213cb80e2da)(()=>crypto.randomUUID()).replace(/-/g, '');
    } catch  {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    if (!$4da1f60d556678ad$var$emptyUuid) // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    $4da1f60d556678ad$var$emptyUuid = "10000000100040008000100000000000";
    return $4da1f60d556678ad$var$emptyUuid.replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ ($4da1f60d556678ad$var$getRandomByte() & 15) >> c / 4).toString(16));
}
function $4da1f60d556678ad$var$getFirstException(event) {
    return event.exception?.values?.[0];
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $4da1f60d556678ad$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $4da1f60d556678ad$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $4da1f60d556678ad$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $4da1f60d556678ad$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $4da1f60d556678ad$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism?.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $4da1f60d556678ad$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ function $4da1f60d556678ad$var$_parseInt(input) {
    return parseInt(input || '', 10);
}
/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $4da1f60d556678ad$export$d364f2020ab30578(input) {
    const match = input.match($4da1f60d556678ad$var$SEMVER_REGEXP) || [];
    const major = $4da1f60d556678ad$var$_parseInt(match[1]);
    const minor = $4da1f60d556678ad$var$_parseInt(match[2]);
    const patch = $4da1f60d556678ad$var$_parseInt(match[3]);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $4da1f60d556678ad$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $ff73814e958d28bd$export$4215662d762d6f9d)(line, 0));
    // We guard here to ensure this is not larger than the existing number of lines
    const lineIndex = Math.min(maxLines - 1, sourceLine);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    frame.context_line = (0, $ff73814e958d28bd$export$4215662d762d6f9d)(lines[lineIndex], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $ff73814e958d28bd$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $4da1f60d556678ad$export$6de4ffac6a2f1098(exception) {
    if ($4da1f60d556678ad$var$isAlreadyCaptured(exception)) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch  {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
function $4da1f60d556678ad$var$isAlreadyCaptured(exception) {
    try {
        return exception.__sentry_captured__;
    } catch  {} // eslint-disable-line no-empty
}




const $906abfdc43292150$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ function $906abfdc43292150$export$7740643b9eeaf0c4() {
    return (0, $3ce37121dbb69e34$export$65b1bada40c91b34)() / $906abfdc43292150$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $906abfdc43292150$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);
    // Some browser and environments don't have a performance or timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    if (!performance?.now || !performance.timeOrigin) return $906abfdc43292150$export$7740643b9eeaf0c4;
    const timeOrigin = performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + (0, $3ce37121dbb69e34$export$ff239213cb80e2da)(()=>performance.now())) / $906abfdc43292150$var$ONE_SECOND_IN_MS;
    };
}
let $906abfdc43292150$var$_cachedTimestampInSeconds;
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ function $906abfdc43292150$export$ee52dced521e3e18() {
    // We store this in a closure so that we don't have to create a new function every time this is called.
    const func = $906abfdc43292150$var$_cachedTimestampInSeconds ?? ($906abfdc43292150$var$_cachedTimestampInSeconds = $906abfdc43292150$var$createUnixTimestampInSecondsFunc());
    return func();
}
/**
 * Cached result of getBrowserTimeOrigin.
 */ let $906abfdc43292150$var$cachedTimeOrigin = null;
/**
 * Gets the time origin and the mode used to determine it.
 *
 * Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
 * performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
 * data as reliable if they are within a reasonable threshold of the current time.
 *
 * TODO: move to `@sentry/browser-utils` package.
 */ function $906abfdc43292150$var$getBrowserTimeOrigin() {
    const { performance: performance } = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);
    if (!performance?.now) return undefined;
    const threshold = 300000; // 5 minutes in milliseconds
    const performanceNow = (0, $3ce37121dbb69e34$export$ff239213cb80e2da)(()=>performance.now());
    const dateNow = (0, $3ce37121dbb69e34$export$65b1bada40c91b34)();
    const timeOrigin = performance.timeOrigin;
    if (typeof timeOrigin === 'number') {
        const timeOriginDelta = Math.abs(timeOrigin + performanceNow - dateNow);
        if (timeOriginDelta < threshold) return timeOrigin;
    }
    // TODO: Remove all code related to `performance.timing.navigationStart` once we drop support for Safari 14.
    // `performance.timeSince` is available in Safari 15.
    // see: https://caniuse.com/mdn-api_performance_timeorigin
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing?.navigationStart;
    if (typeof navigationStart === 'number') {
        const navigationStartDelta = Math.abs(navigationStart + performanceNow - dateNow);
        if (navigationStartDelta < threshold) return navigationStart;
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to subtracting
    // `performance.now()` from `Date.now()`.
    return dateNow - performanceNow;
}
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ function $906abfdc43292150$export$baf075a948ffc0bf() {
    if ($906abfdc43292150$var$cachedTimeOrigin === null) $906abfdc43292150$var$cachedTimeOrigin = $906abfdc43292150$var$getBrowserTimeOrigin();
    return $906abfdc43292150$var$cachedTimeOrigin;
}


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $c02b5704ee22c2a7$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $906abfdc43292150$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $4da1f60d556678ad$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$c02b5704ee22c2a7$var$sessionToJSON(session)
    };
    if (context) $c02b5704ee22c2a7$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see Client.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $c02b5704ee22c2a7$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $906abfdc43292150$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $4da1f60d556678ad$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $c02b5704ee22c2a7$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $c02b5704ee22c2a7$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $c02b5704ee22c2a7$var$sessionToJSON(session) {
    return {
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    };
}




/**
 * Shallow merge two objects.
 * Does not mutate the passed in objects.
 * Undefined/empty values in the merge object will overwrite existing values.
 *
 * By default, this merges 2 levels deep.
 */ function $9392a3c1760ef37e$export$4950aa0f605343fb(initialObj, mergeObj, levels = 2) {
    // If the merge value is not an object, or we have no merge levels left,
    // we just set the value to the merge value
    if (!mergeObj || typeof mergeObj !== 'object' || levels <= 0) return mergeObj;
    // If the merge object is an empty object, and the initial object is not undefined, we return the initial object
    if (initialObj && Object.keys(mergeObj).length === 0) return initialObj;
    // Clone object
    const output = {
        ...initialObj
    };
    // Merge values into output, resursively
    for(const key in mergeObj)if (Object.prototype.hasOwnProperty.call(mergeObj, key)) output[key] = $9392a3c1760ef37e$export$4950aa0f605343fb(output[key], mergeObj[key], levels - 1);
    return output;
}




/**
 * Generate a random, valid trace ID.
 */ function $089e6aeb4531f5e4$export$dc6d7ea554bcce10() {
    return (0, $4da1f60d556678ad$export$19f53698e68b2496)();
}
/**
 * Generate a random, valid span ID.
 */ function $089e6aeb4531f5e4$export$295213bc4d0c54ad() {
    return (0, $4da1f60d556678ad$export$19f53698e68b2496)().substring(16);
}




const $e57da10b3d1051db$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $e57da10b3d1051db$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(scope, $e57da10b3d1051db$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$e57da10b3d1051db$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $e57da10b3d1051db$export$91f063ebb8eff307(scope) {
    return scope[$e57da10b3d1051db$var$SCOPE_SPAN_FIELD];
}




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $3503af534c878a78$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * A context to be used for capturing an event.
 * This can either be a Scope, or a partial ScopeContext,
 * or a callback that receives the current scope and returns a new scope to use.
 */ /**
 * Holds additional event information.
 */ class $3503af534c878a78$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Attributes */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ /** Conversation ID */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = {
            traceId: (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $3ce37121dbb69e34$export$9869d72de32a3917)()
        };
    }
    /**
   * Clone all data from this scope into a new scope.
   */ clone() {
        const newScope = new $3503af534c878a78$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._attributes = {
            ...this._attributes
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        if (this._contexts.flags) // We need to copy the `values` array so insertions on a cloned scope
        // won't affect the original array.
        newScope._contexts.flags = {
            values: [
                ...this._contexts.flags.values
            ]
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        newScope._conversationId = this._conversationId;
        (0, $e57da10b3d1051db$export$3f25fa50c18e20ca)(newScope, (0, $e57da10b3d1051db$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * Update the client assigned to this scope.
   * Note that not every scope will have a client assigned - isolation scopes & the global scope will generally not have a client,
   * as well as manually created scopes.
   */ setClient(client) {
        this._client = client;
    }
    /**
   * Set the ID of the last captured error event.
   * This is generally only captured on the isolation scope.
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * Get the client assigned to this scope.
   */ getClient() {
        return this._client;
    }
    /**
   * Get the ID of the last captured error event.
   * This is generally only available on the isolation scope.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * Add an event processor that will be called before an event is sent.
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * Set the user for this scope.
   * Set to `null` to unset the user.
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $c02b5704ee22c2a7$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the user from this scope.
   */ getUser() {
        return this._user;
    }
    /**
   * Set the conversation ID for this scope.
   * Set to `null` to unset the conversation ID.
   */ setConversationId(conversationId) {
        this._conversationId = conversationId || undefined;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set an object that will be merged into existing tags on the scope,
   * and will be sent as tags data with the event.
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single tag that will be sent as tags data with the event.
   */ setTag(key, value) {
        return this.setTags({
            [key]: value
        });
    }
    /**
   * Sets attributes onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param newAttributes - The attributes to set on the scope. You can either pass in key-value pairs, or
   * an object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttributes({
   *   is_admin: true,
   *   payment_selection: 'credit_card',
   *   render_duration: { value: 'render_duration', unit: 'ms' },
   * });
   * ```
   */ setAttributes(newAttributes) {
        this._attributes = {
            ...this._attributes,
            ...newAttributes
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets an attribute onto the scope.
   *
   * These attributes are currently applied to logs and metrics.
   * In the future, they will also be applied to spans.
   *
   * Important: For now, only strings, numbers and boolean attributes are supported, despite types allowing for
   * more complex attribute types. We'll add this support in the future but already specify the wider type to
   * avoid a breaking change in the future.
   *
   * @param key - The attribute key.
   * @param value - the attribute value. You can either pass in a raw value, or an attribute
   * object with a `value` and an optional `unit` (if applicable to your attribute).
   *
   * @example
   * ```typescript
   * scope.setAttribute('is_admin', true);
   * scope.setAttribute('render_duration', { value: 'render_duration', unit: 'ms' });
   * ```
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setAttribute(key, value) {
        return this.setAttributes({
            [key]: value
        });
    }
    /**
   * Removes the attribute with the given key from the scope.
   *
   * @param key - The attribute key.
   *
   * @example
   * ```typescript
   * scope.removeAttribute('is_admin');
   * ```
   */ removeAttribute(key) {
        if (key in this._attributes) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._attributes[key];
            this._notifyScopeListeners();
        }
        return this;
    }
    /**
   * Set an object that will be merged into existing extra on the scope,
   * and will be sent as extra data with the event.
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set a single key:value extra entry that will be sent as extra data with the event.
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the fingerprint on the scope to send with the events.
   * @param {string[]} fingerprint Fingerprint to group events in Sentry.
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the level on the scope for future events.
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope so that the name of e.g. taken server route or
   * the page location is attached to future events.
   *
   * IMPORTANT: Calling this function does NOT change the name of the currently active
   * root span. If you want to change the name of the active root span, use
   * `Sentry.updateSpanName(rootSpan, 'new name')` instead.
   *
   * By default, the SDK updates the scope's transaction name automatically on sensible
   * occasions, such as a page navigation or when handling a new request on the server.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets context data with the given name.
   * Data passed as context will be normalized. You can also pass `null` to unset the context.
   * Note that context data will not be merged - calling `setContext` will overwrite an existing context with the same key.
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Set the session for the scope.
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the session from the scope.
   */ getSession() {
        return this._session;
    }
    /**
   * Updates the scope with provided data. Can work in three variations:
   * - plain object containing updatable attributes
   * - Scope instance that'll extract the attributes from
   * - callback function that'll receive the current scope as an argument and allow for modifications
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const scopeInstance = scopeToMerge instanceof $3503af534c878a78$export$775b6bb06e53a214 ? scopeToMerge.getScopeData() : (0, $057f17bbb7048b01$export$53b83ca8eaab0383)(scopeToMerge) ? captureContext : undefined;
        const { tags: tags, attributes: attributes, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext, conversationId: conversationId } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._attributes = {
            ...this._attributes,
            ...attributes
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (conversationId) this._conversationId = conversationId;
        return this;
    }
    /**
   * Clears the current scope and resets its properties.
   * Note: The client will not be cleared.
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._attributes = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._session = undefined;
        this._conversationId = undefined;
        (0, $e57da10b3d1051db$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this.setPropagationContext({
            traceId: (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $3ce37121dbb69e34$export$9869d72de32a3917)()
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Adds a breadcrumb to the scope.
   * By default, the last 100 breadcrumbs are kept.
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $3503af534c878a78$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $906abfdc43292150$export$7740643b9eeaf0c4)(),
            ...breadcrumb,
            // Breadcrumb messages can theoretically be infinitely large and they're held in memory so we truncate them not to leak (too much) memory
            message: breadcrumb.message ? (0, $ff73814e958d28bd$export$6a506b36fdea397d)(breadcrumb.message, 2048) : breadcrumb.message
        };
        this._breadcrumbs.push(mergedBreadcrumb);
        if (this._breadcrumbs.length > maxCrumbs) {
            this._breadcrumbs = this._breadcrumbs.slice(-maxCrumbs);
            this._client?.recordDroppedEvent('buffer_overflow', 'log_item');
        }
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Get the last breadcrumb of the scope.
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * Clear all breadcrumbs from the scope.
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Add an attachment to the scope.
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * Clear all attachments from the scope.
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Get the data of this scope, which should be applied to an event during processing.
   */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            attributes: this._attributes,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $e57da10b3d1051db$export$91f063ebb8eff307)(this),
            conversationId: this._conversationId
        };
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry.
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = (0, $9392a3c1760ef37e$export$4950aa0f605343fb)(this._sdkProcessingMetadata, newData, 2);
        return this;
    }
    /**
   * Add propagation context to the scope, used for distributed tracing
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * Get propagation context from the scope, used for distributed tracing
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @returns {string} The id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint?.event_id || (0, $4da1f60d556678ad$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @returns {string} The id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint?.event_id || (0, $4da1f60d556678ad$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = hint?.syntheticException ?? new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a Sentry event for this scope.
   *
   * @returns {string} The id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint?.event_id || (0, $4da1f60d556678ad$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}


/** Get the default current scope. */ function $3dcc3f674ff459f2$export$6f1b9191db9c4d5() {
    return (0, $b51d9d034721a478$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $3503af534c878a78$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $3dcc3f674ff459f2$export$de9862929b76bf57() {
    return (0, $b51d9d034721a478$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $3503af534c878a78$export$775b6bb06e53a214)());
}





/**
 * This is an object that holds a stack of scopes.
 */ class $4e32494c1451b2a9$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $3503af534c878a78$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $3503af534c878a78$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        // scope stack for domains or the process
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $057f17bbb7048b01$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this._stack.push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this._stack.length <= 1) return false;
        return !!this._stack.pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $4e32494c1451b2a9$var$getAsyncContextStack() {
    const registry = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const sentry = (0, $b51d9d034721a478$export$c8bfa33e4e8ae492)(registry);
    return sentry.stack = sentry.stack || new $4e32494c1451b2a9$export$d36ec451f120cfba((0, $3dcc3f674ff459f2$export$6f1b9191db9c4d5)(), (0, $3dcc3f674ff459f2$export$de9862929b76bf57)());
}
function $4e32494c1451b2a9$var$withScope(callback) {
    return $4e32494c1451b2a9$var$getAsyncContextStack().withScope(callback);
}
function $4e32494c1451b2a9$var$withSetScope(scope, callback) {
    const stack = $4e32494c1451b2a9$var$getAsyncContextStack();
    return stack.withScope(()=>{
        stack.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $4e32494c1451b2a9$var$withIsolationScope(callback) {
    return $4e32494c1451b2a9$var$getAsyncContextStack().withScope(()=>{
        return callback($4e32494c1451b2a9$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $4e32494c1451b2a9$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $4e32494c1451b2a9$var$withIsolationScope,
        withScope: $4e32494c1451b2a9$var$withScope,
        withSetScope: $4e32494c1451b2a9$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $4e32494c1451b2a9$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$4e32494c1451b2a9$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$4e32494c1451b2a9$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $3e49a8fa7c1f2ba6$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const sentry = (0, $b51d9d034721a478$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $3e49a8fa7c1f2ba6$export$f639b0c2752203be(carrier) {
    const sentry = (0, $b51d9d034721a478$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $4e32494c1451b2a9$export$329d4d4d54e42710)();
}





/**
 * Get the currently active scope.
 */ function $64ff6138fe06e713$export$c7be4b0125a10cba() {
    const carrier = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const acs = (0, $3e49a8fa7c1f2ba6$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current execution context.
 */ function $64ff6138fe06e713$export$68f3af03034c9e90() {
    const carrier = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const acs = (0, $3e49a8fa7c1f2ba6$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $64ff6138fe06e713$export$aa55d5ab8e05984f() {
    return (0, $b51d9d034721a478$export$7e223ec222791509)('globalScope', ()=>new (0, $3503af534c878a78$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $64ff6138fe06e713$export$ec58d9285c204497(...rest) {
    const carrier = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const acs = (0, $3e49a8fa7c1f2ba6$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $64ff6138fe06e713$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const acs = (0, $3e49a8fa7c1f2ba6$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $64ff6138fe06e713$export$6bb76d6eba7e258c() {
    return $64ff6138fe06e713$export$c7be4b0125a10cba().getClient();
}
/**
 * Get a trace context for the given scope.
 */ function $64ff6138fe06e713$export$1e83db7ee4876dc4(scope) {
    const propagationContext = scope.getPropagationContext();
    const { traceId: traceId, parentSpanId: parentSpanId, propagationSpanId: propagationSpanId } = propagationContext;
    const traceContext = {
        trace_id: traceId,
        span_id: propagationSpanId || (0, $089e6aeb4531f5e4$export$295213bc4d0c54ad)()
    };
    if (parentSpanId) traceContext.parent_span_id = parentSpanId;
    return traceContext;
}





const $00abeec2398bba5c$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preserve the order of integrations in the array.
 *
 * @private
 */ function $00abeec2398bba5c$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.values(integrationsByName);
}
/** Gets integrations to install */ function $00abeec2398bba5c$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') {
        const resolvedUserIntegrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(resolvedUserIntegrations) ? resolvedUserIntegrations : [
            resolvedUserIntegrations
        ];
    } else integrations = defaultIntegrations;
    return $00abeec2398bba5c$var$filterDuplicates(integrations);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $00abeec2398bba5c$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $00abeec2398bba5c$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $00abeec2398bba5c$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration?.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $00abeec2398bba5c$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if (!$00abeec2398bba5c$export$b14a8888f80a0b3e.includes(integration.name) && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $00abeec2398bba5c$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current scope's client. */ function $00abeec2398bba5c$export$2d8f5188773bcddd(integration) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $00abeec2398bba5c$export$2323046b9414659f(fn) {
    return fn;
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $d06802d0f59b2c9f$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Attributes that holds the sample rate that was locally applied to a span.
 * If this attribute is not defined, it means that the span inherited a sampling decision.
 *
 * NOTE: Is only defined on root spans.
 */ const $d06802d0f59b2c9f$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Attribute holding the sample rate of the previous trace.
 * This is used to sample consistently across subsequent traces in the browser SDK.
 *
 * Note: Only defined on root spans, if opted into consistent sampling
 */ const $d06802d0f59b2c9f$export$889fb736668e1ecc = 'sentry.previous_trace_sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $d06802d0f59b2c9f$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $d06802d0f59b2c9f$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $d06802d0f59b2c9f$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $d06802d0f59b2c9f$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $d06802d0f59b2c9f$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * A custom span name set by users guaranteed to be taken over any automatically
 * inferred name. This attribute is removed before the span is sent.
 *
 * @internal only meant for internal SDK usage
 * @hidden
 */ const $d06802d0f59b2c9f$export$165ce9a229f6f050 = 'sentry.custom_span_name';
/**
 * The id of the profile that this span occurred in.
 */ const $d06802d0f59b2c9f$export$1efec95406bbe327 = 'sentry.profile_id';
const $d06802d0f59b2c9f$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $d06802d0f59b2c9f$export$b016f89ac1066ec = 'cache.hit';
const $d06802d0f59b2c9f$export$3110e4c3f4386399 = 'cache.key';
const $d06802d0f59b2c9f$export$86be76deee227ff2 = 'cache.item_size';
/** TODO: Remove these once we update to latest semantic conventions */ const $d06802d0f59b2c9f$export$be7a251980e7e946 = 'http.request.method';
const $d06802d0f59b2c9f$export$25dfd73e0e32c6e1 = 'url.full';
/**
 * A span link attribute to mark the link as a special span link.
 *
 * Known values:
 * - `previous_trace`: The span links to the frontend root span of the previous trace.
 * - `next_trace`: The span links to the frontend root span of the next trace. (Not set by the SDK)
 *
 * Other values may be set as appropriate.
 * @see https://develop.sentry.dev/sdk/telemetry/traces/span-links/#link-types
 */ const $d06802d0f59b2c9f$export$ff77b5fd5b2d627b = 'sentry.link.type';
/**
 * =============================================================================
 * GEN AI ATTRIBUTES
 * Based on OpenTelemetry Semantic Conventions for Generative AI
 * @see https://opentelemetry.io/docs/specs/semconv/gen-ai/
 * =============================================================================
 */ /**
 * The conversation ID for linking messages across API calls.
 * For OpenAI Assistants API: thread_id
 * For LangGraph: configurable.thread_id
 */ const $d06802d0f59b2c9f$export$71a4a707257f2774 = 'gen_ai.conversation.id';


const $07bde267a5e3f791$var$INTEGRATION_NAME = 'ConversationId';
const $07bde267a5e3f791$var$_conversationIdIntegration = ()=>{
    return {
        name: $07bde267a5e3f791$var$INTEGRATION_NAME,
        setup (client) {
            client.on('spanStart', (span)=>{
                const scopeData = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)().getScopeData();
                const isolationScopeData = (0, $64ff6138fe06e713$export$68f3af03034c9e90)().getScopeData();
                const conversationId = scopeData.conversationId || isolationScopeData.conversationId;
                if (conversationId) span.setAttribute((0, $d06802d0f59b2c9f$export$71a4a707257f2774), conversationId);
            });
        }
    };
};
/**
 * Automatically applies conversation ID from scope to spans.
 *
 * This integration reads the conversation ID from the current or isolation scope
 * and applies it to spans when they start. This ensures the conversation ID is
 * available for all AI-related operations.
 */ const $07bde267a5e3f791$export$97457a453081a5b3 = (0, $00abeec2398bba5c$export$2323046b9414659f)($07bde267a5e3f791$var$_conversationIdIntegration);





const $4d4fa9e396da88ac$var$INTEGRATION_NAME = 'Dedupe';
const $4d4fa9e396da88ac$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $4d4fa9e396da88ac$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($4d4fa9e396da88ac$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch  {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $4d4fa9e396da88ac$export$6d39aa44cd0c7567 = (0, $00abeec2398bba5c$export$2323046b9414659f)($4d4fa9e396da88ac$var$_dedupeIntegration);
/** only exported for tests. */ function $4d4fa9e396da88ac$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($4d4fa9e396da88ac$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($4d4fa9e396da88ac$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $4d4fa9e396da88ac$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$4d4fa9e396da88ac$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$4d4fa9e396da88ac$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $4d4fa9e396da88ac$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $4d4fa9e396da88ac$var$_getExceptionFromEvent(previousEvent);
    const currentException = $4d4fa9e396da88ac$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$4d4fa9e396da88ac$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$4d4fa9e396da88ac$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $4d4fa9e396da88ac$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = (0, $7a317b2b764bd658$export$91d8ca51bd9f6a47)(currentEvent);
    let previousFrames = (0, $7a317b2b764bd658$export$91d8ca51bd9f6a47)(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameA = previousFrames[i];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $4d4fa9e396da88ac$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch  {
        return false;
    }
}
function $4d4fa9e396da88ac$var$_getExceptionFromEvent(event) {
    return event.exception?.values?.[0];
}




let $7b15a7ab0b9e593d$var$originalFunctionToString;
const $7b15a7ab0b9e593d$var$INTEGRATION_NAME = 'FunctionToString';
const $7b15a7ab0b9e593d$var$SETUP_CLIENTS = new WeakMap();
const $7b15a7ab0b9e593d$var$_functionToStringIntegration = ()=>{
    return {
        name: $7b15a7ab0b9e593d$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $7b15a7ab0b9e593d$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $085a6ebfb8b9293d$export$e6cc1e135e2092e5)(this);
                    const context = $7b15a7ab0b9e593d$var$SETUP_CLIENTS.has((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $7b15a7ab0b9e593d$var$originalFunctionToString.apply(context, args);
                };
            } catch  {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $7b15a7ab0b9e593d$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $7b15a7ab0b9e593d$export$7918117e9202e4fb = (0, $00abeec2398bba5c$export$2323046b9414659f)($7b15a7ab0b9e593d$var$_functionToStringIntegration);




/**
 * Get a list of possible event messages from a Sentry event.
 */ function $c63d95a8106631de$export$d55a97c329cacfcc(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    try {
        // @ts-expect-error Try catching to save bundle size
        const lastException = event.exception.values[event.exception.values.length - 1];
        if (lastException?.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    } catch  {
    // ignore errors here
    }
    return possibleMessages;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $d2a49612e9ecceb5$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/,
    /^Can't find variable: gmo$/,
    /^undefined is not an object \(evaluating 'a\.[A-Z]'\)$/,
    'can\'t redefine non-configurable property "solana"',
    "vv().getRestrictions is not a function. (In 'vv().getRestrictions(1,a)', 'vv().getRestrictions' is undefined)",
    "Can't find variable: _AutofillCallbackHandler",
    /^Non-Error promise rejection captured with value: Object Not Found Matching Id:\d+, MethodName:simulateEvent, ParamCount:\d+$/,
    /^Java exception was raised during method invocation$/
];
/** Options for the EventFilters integration */ const $d2a49612e9ecceb5$var$INTEGRATION_NAME = 'EventFilters';
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 */ const $d2a49612e9ecceb5$export$9a84f518c163c552 = (0, $00abeec2398bba5c$export$2323046b9414659f)((options = {})=>{
    let mergedOptions;
    return {
        name: $d2a49612e9ecceb5$var$INTEGRATION_NAME,
        setup (client) {
            const clientOptions = client.getOptions();
            mergedOptions = $d2a49612e9ecceb5$var$_mergeOptions(options, clientOptions);
        },
        processEvent (event, _hint, client) {
            if (!mergedOptions) {
                const clientOptions = client.getOptions();
                mergedOptions = $d2a49612e9ecceb5$var$_mergeOptions(options, clientOptions);
            }
            return $d2a49612e9ecceb5$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
});
/**
 * An integration that filters out events (errors and transactions) based on:
 *
 * - (Errors) A curated list of known low-value or irrelevant errors (see {@link DEFAULT_IGNORE_ERRORS})
 * - (Errors) A list of error messages or urls/filenames passed in via
 *   - Top level Sentry.init options (`ignoreErrors`, `denyUrls`, `allowUrls`)
 *   - The same options passed to the integration directly via @param options
 * - (Transactions/Spans) A list of root span (transaction) names passed in via
 *   - Top level Sentry.init option (`ignoreTransactions`)
 *   - The same option passed to the integration directly via @param options
 *
 * Events filtered by this integration will not be sent to Sentry.
 *
 * @deprecated this integration was renamed and will be removed in a future major version.
 * Use `eventFiltersIntegration` instead.
 */ const $d2a49612e9ecceb5$export$cb3c5c2ceb9818ba = (0, $00abeec2398bba5c$export$2323046b9414659f)((options = {})=>{
    return {
        ...$d2a49612e9ecceb5$export$9a84f518c163c552(options),
        name: 'InboundFilters'
    };
});
function $d2a49612e9ecceb5$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $d2a49612e9ecceb5$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ]
    };
}
function $d2a49612e9ecceb5$var$_shouldDropEvent(event, options) {
    if (!event.type) {
        // Filter errors
        if ($d2a49612e9ecceb5$var$_isIgnoredError(event, options.ignoreErrors)) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $4da1f60d556678ad$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($d2a49612e9ecceb5$var$_isUselessError(event)) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Event dropped due to not having an error message, error type or stacktrace.\nEvent: ${(0, $4da1f60d556678ad$export$4157119e2b157127)(event)}`);
            return true;
        }
        if ($d2a49612e9ecceb5$var$_isDeniedUrl(event, options.denyUrls)) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $4da1f60d556678ad$export$4157119e2b157127)(event)}.\nUrl: ${$d2a49612e9ecceb5$var$_getEventFilterUrl(event)}`);
            return true;
        }
        if (!$d2a49612e9ecceb5$var$_isAllowedUrl(event, options.allowUrls)) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $4da1f60d556678ad$export$4157119e2b157127)(event)}.\nUrl: ${$d2a49612e9ecceb5$var$_getEventFilterUrl(event)}`);
            return true;
        }
    } else if (event.type === 'transaction') // Filter transactions
    {
        if ($d2a49612e9ecceb5$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $4da1f60d556678ad$export$4157119e2b157127)(event)}`);
            return true;
        }
    }
    return false;
}
function $d2a49612e9ecceb5$var$_isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors?.length) return false;
    return (0, $c63d95a8106631de$export$d55a97c329cacfcc)(event).some((message)=>(0, $ff73814e958d28bd$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $d2a49612e9ecceb5$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (!ignoreTransactions?.length) return false;
    const name = event.transaction;
    return name ? (0, $ff73814e958d28bd$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $d2a49612e9ecceb5$var$_isDeniedUrl(event, denyUrls) {
    if (!denyUrls?.length) return false;
    const url = $d2a49612e9ecceb5$var$_getEventFilterUrl(event);
    return !url ? false : (0, $ff73814e958d28bd$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $d2a49612e9ecceb5$var$_isAllowedUrl(event, allowUrls) {
    if (!allowUrls?.length) return true;
    const url = $d2a49612e9ecceb5$var$_getEventFilterUrl(event);
    return !url ? true : (0, $ff73814e958d28bd$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $d2a49612e9ecceb5$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $d2a49612e9ecceb5$var$_getEventFilterUrl(event) {
    try {
        // If there are linked exceptions or exception aggregates we only want to match against the top frame of the "root" (the main exception)
        // The root always comes last in linked exceptions
        const rootException = [
            ...event.exception?.values ?? []
        ].reverse().find((value)=>value.mechanism?.parent_id === undefined && value.stacktrace?.frames?.length);
        const frames = rootException?.stacktrace?.frames;
        return frames ? $d2a49612e9ecceb5$var$_getLastValidUrl(frames) : null;
    } catch  {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error(`Cannot extract url for event ${(0, $4da1f60d556678ad$export$4157119e2b157127)(event)}`);
        return null;
    }
}
function $d2a49612e9ecceb5$var$_isUselessError(event) {
    // We only want to consider events for dropping that actually have recorded exception values.
    if (!event.exception?.values?.length) return false;
    return(// No top-level message
    !event.message && // There are no exception values that have a stacktrace, a non-generic-Error type or value
    !event.exception.values.some((value)=>value.stacktrace || value.type && value.type !== 'Error' || value.value));
}




/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $a74e51de1476d220$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $e74753b69eef4000$export$16a28057038b10ef) (0, $ff784a3dc7695b3c$export$1c9f709888824e05).enable();
        else // use `console.warn` rather than `debug.warn` since by non-debug bundles have all `debug.x` statements stripped
        (0, $ff784a3dc7695b3c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $a74e51de1476d220$export$ecb76f41d43c0e43(client);
    client.init();
    return client;
}
/**
 * Make the given client the current client.
 */ function $a74e51de1476d220$export$ecb76f41d43c0e43(client) {
    (0, $64ff6138fe06e713$export$c7be4b0125a10cba)().setClient(client);
}


/**
 * Type-guard: The attribute object has the shape the official attribute object (value, type, unit).
 * https://develop.sentry.dev/sdk/telemetry/scopes/#setting-attributes
 */ function $1f7a8041c0ae48d4$export$f5706f332d297c38(maybeObj) {
    return typeof maybeObj === 'object' && maybeObj != null && !Array.isArray(maybeObj) && Object.keys(maybeObj).includes('value');
}
/**
 * Converts an attribute value to a typed attribute value.
 *
 * For now, we intentionally only support primitive values and attribute objects with primitive values.
 * If @param useFallback is true, we stringify non-primitive values to a string attribute value. Otherwise
 * we return `undefined` for unsupported values.
 *
 * @param value - The value of the passed attribute.
 * @param useFallback - If true, unsupported values will be stringified to a string attribute value.
 *                      Defaults to false. In this case, `undefined` is returned for unsupported values.
 * @returns The typed attribute.
 */ function $1f7a8041c0ae48d4$export$f18f8779fed6dfa(rawValue, useFallback) {
    const { value: value, unit: unit } = $1f7a8041c0ae48d4$export$f5706f332d297c38(rawValue) ? rawValue : {
        value: rawValue,
        unit: undefined
    };
    const attributeValue = $1f7a8041c0ae48d4$var$getTypedAttributeValue(value);
    const checkedUnit = unit && typeof unit === 'string' ? {
        unit: unit
    } : {};
    if (attributeValue) return {
        ...attributeValue,
        ...checkedUnit
    };
    if (!useFallback || useFallback === 'skip-undefined' && value === undefined) return;
    // Fallback: stringify the value
    // TODO(v11): be smarter here and use String constructor if stringify fails
    // (this is a breaking change for already existing attribute values)
    let stringValue = '';
    try {
        stringValue = JSON.stringify(value) ?? '';
    } catch  {
    // Do nothing
    }
    return {
        value: stringValue,
        type: 'string',
        ...checkedUnit
    };
}
/**
 * Serializes raw attributes to typed attributes as expected in our envelopes.
 *
 * @param attributes The raw attributes to serialize.
 * @param fallback   If true, unsupported values will be stringified to a string attribute value.
 *                   Defaults to false. In this case, `undefined` is returned for unsupported values.
 *
 * @returns The serialized attributes.
 */ function $1f7a8041c0ae48d4$export$4954cae66e755861(attributes, fallback = false) {
    const serializedAttributes = {};
    for (const [key, value] of Object.entries(attributes ?? {})){
        const typedValue = $1f7a8041c0ae48d4$export$f18f8779fed6dfa(value, fallback);
        if (typedValue) serializedAttributes[key] = typedValue;
    }
    return serializedAttributes;
}
/**
 * NOTE: We intentionally do not return anything for non-primitive values:
 *  - array support will come in the future but if we stringify arrays now,
 *    sending arrays (unstringified) later will be a subtle breaking change.
 *  - Objects are not supported yet and product support is still TBD.
 *  - We still keep the type signature for TypedAttributeValue wider to avoid a
 *    breaking change once we add support for non-primitive values.
 *  - Once we go back to supporting arrays and stringifying all other values,
 *    we already implemented the serialization logic here:
 *    https://github.com/getsentry/sentry-javascript/pull/18165
 */ function $1f7a8041c0ae48d4$var$getTypedAttributeValue(value) {
    const primitiveType = typeof value === 'string' ? 'string' : typeof value === 'boolean' ? 'boolean' : typeof value === 'number' && !Number.isNaN(value) ? Number.isInteger(value) ? 'integer' : 'double' : null;
    if (primitiveType) // @ts-expect-error - TS complains because {@link TypedAttributeValue} is strictly typed to
    // avoid setting the wrong `type` on the attribute value.
    // In this case, getPrimitiveType already does the check but TS doesn't know that.
    // The "clean" alternative is to return an object per `typeof value` case
    // but that would require more bundle size
    // Therefore, we ignore it.
    return {
        value: value,
        type: primitiveType
    };
}








const $2a9a4c4c0dffc99b$export$849dbeeeda01ae98 = 'production';
const $2a9a4c4c0dffc99b$export$6829f580e78306fa = 'development';







const $231c50e128fa7b11$export$6e69537d67fa20f = 'sentry-';
const $231c50e128fa7b11$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $231c50e128fa7b11$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $231c50e128fa7b11$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $231c50e128fa7b11$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($231c50e128fa7b11$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($231c50e128fa7b11$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $231c50e128fa7b11$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$231c50e128fa7b11$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $231c50e128fa7b11$export$12a7349a29a6e3c2(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $231c50e128fa7b11$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $057f17bbb7048b01$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $231c50e128fa7b11$var$baggageHeaderToObject(curr);
        Object.entries(currBaggageObject).forEach(([key, value])=>{
            acc[key] = value;
        });
        return acc;
    }, {});
    return $231c50e128fa7b11$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $231c50e128fa7b11$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>{
        const eqIdx = baggageEntry.indexOf('=');
        if (eqIdx === -1) // Likely an invalid entry
        return [];
        const key = baggageEntry.slice(0, eqIdx);
        const value = baggageEntry.slice(eqIdx + 1);
        return [
            key,
            value
        ].map((keyOrValue)=>{
            try {
                return decodeURIComponent(keyOrValue.trim());
            } catch  {
                // We ignore errors here, e.g. if the value cannot be URL decoded.
                // This will then be skipped in the next step
                return;
            }
        });
    }).reduce((acc, [key, value])=>{
        if (key && value) acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $231c50e128fa7b11$export$12a7349a29a6e3c2(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $231c50e128fa7b11$export$bdd844ddb2def819) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}




/** Regular expression used to extract org ID from a DSN host. */ const $8ef4a8c4a6476e0c$var$ORG_ID_REGEX = /^o(\d+)\./;
/** Regular expression used to parse a Dsn. */ const $8ef4a8c4a6476e0c$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)((?:\[[:.%\w]+\]|[\w.-]+))(?::(\d+))?\/(.+)/;
function $8ef4a8c4a6476e0c$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $8ef4a8c4a6476e0c$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $8ef4a8c4a6476e0c$export$b892860177f70a30(str) {
    const match = $8ef4a8c4a6476e0c$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $ff784a3dc7695b3c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host = '', port = '', lastPath = ''] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $8ef4a8c4a6476e0c$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $8ef4a8c4a6476e0c$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $8ef4a8c4a6476e0c$var$validateDsn(dsn) {
    if (!(0, $e74753b69eef4000$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$8ef4a8c4a6476e0c$var$isValidProtocol(protocol)) {
        (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Extract the org ID from a DSN host.
 *
 * @param host The host from a DSN
 * @returns The org ID if found, undefined otherwise
 */ function $8ef4a8c4a6476e0c$export$5914f4e7748c29c9(host) {
    const match = host.match($8ef4a8c4a6476e0c$var$ORG_ID_REGEX);
    return match?.[1];
}
/**
 *  Returns the organization ID of the client.
 *
 *  The organization ID is extracted from the DSN. If the client options include a `orgId`, this will always take precedence.
 */ function $8ef4a8c4a6476e0c$export$b7ac9b8efa4bb595(client) {
    const options = client.getOptions();
    const { host: host } = client.getDsn() || {};
    let org_id;
    if (options.orgId) org_id = String(options.orgId);
    else if (host) org_id = $8ef4a8c4a6476e0c$export$5914f4e7748c29c9(host);
    return org_id;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $8ef4a8c4a6476e0c$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $8ef4a8c4a6476e0c$export$b892860177f70a30(from) : $8ef4a8c4a6476e0c$var$dsnFromComponents(from);
    if (!components || !$8ef4a8c4a6476e0c$var$validateDsn(components)) return undefined;
    return components;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if span recording is currently enabled.
 *
 * Spans are recorded when at least one of `tracesSampleRate` and `tracesSampler`
 * is defined in the SDK config. This function does not make any assumption about
 * sampling decisions, it only checks if the SDK is configured to record spans.
 *
 * Important: This function only determines if span recording is enabled. Trace
 * continuation and propagation is separately controlled and not covered by this function.
 * If this function returns `false`, traces can still be propagated (which is what
 * we refer to by "Tracing without Performance")
 * @see https://develop.sentry.dev/sdk/telemetry/traces/tracing-without-performance/
 *
 * @param maybeOptions An SDK options object to be passed to this function.
 * If this option is not provided, the function will use the current client's options.
 */ function $22da8de313ab467e$export$1f70765132c3c225(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)()?.getOptions();
    return !!options && // Note: This check is `!= null`, meaning "nullish". `0` is not "nullish", `undefined` and `null` are. (This comment was brought to you by 15 minutes of questioning life)
    (options.tracesSampleRate != null || !!options.tracesSampler);
}







const $d4120bb7aba6235c$export$136e25984ba4a383 = 0;
const $d4120bb7aba6235c$export$58f7963109c806fc = 1;
const $d4120bb7aba6235c$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or internal_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $d4120bb7aba6235c$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $d4120bb7aba6235c$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $d4120bb7aba6235c$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $d4120bb7aba6235c$export$f966a0446ece71e,
        message: 'internal_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $d4120bb7aba6235c$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $d4120bb7aba6235c$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}




const $ecf2a0f66df9dd54$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $ecf2a0f66df9dd54$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Wrap a scope with a WeakRef if available, falling back to a direct scope. */ function $ecf2a0f66df9dd54$var$wrapScopeWithWeakRef(scope) {
    try {
        // @ts-expect-error - WeakRef is not available in all environments
        const WeakRefClass = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).WeakRef;
        if (typeof WeakRefClass === 'function') return new WeakRefClass(scope);
    } catch  {
    // WeakRef not available or failed to create
    // We'll fall back to a direct scope
    }
    return scope;
}
/** Try to unwrap a scope from a potential WeakRef wrapper. */ function $ecf2a0f66df9dd54$var$unwrapScopeFromWeakRef(scopeRef) {
    if (!scopeRef) return undefined;
    if (typeof scopeRef === 'object' && 'deref' in scopeRef && typeof scopeRef.deref === 'function') try {
        return scopeRef.deref();
    } catch  {
        return undefined;
    }
    // Fallback to a direct scope
    return scopeRef;
}
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $ecf2a0f66df9dd54$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(span, $ecf2a0f66df9dd54$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, $ecf2a0f66df9dd54$var$wrapScopeWithWeakRef(isolationScope));
        // We don't wrap the scope with a WeakRef here because webkit aggressively garbage collects
        // and scopes are not held in memory for long periods of time.
        (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(span, $ecf2a0f66df9dd54$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 * If WeakRef was used and scopes have been garbage collected, returns undefined for those scopes.
 */ function $ecf2a0f66df9dd54$export$c08fbc656a245d03(span) {
    const spanWithScopes = span;
    return {
        scope: spanWithScopes[$ecf2a0f66df9dd54$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: $ecf2a0f66df9dd54$var$unwrapScopeFromWeakRef(spanWithScopes[$ecf2a0f66df9dd54$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD])
    };
}








/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $f99dcce240975486$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) return undefined;
    return rate;
}




// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $80a392b08eb130e9$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * This is terrible naming but the function has nothing to do with the W3C traceparent header.
 * It can only parse the `sentry-trace` header and extract the "trace parent" data.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $80a392b08eb130e9$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($80a392b08eb130e9$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $80a392b08eb130e9$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $80a392b08eb130e9$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $231c50e128fa7b11$export$5b96ee2c8421f107)(baggage);
    if (!traceparentData?.traceId) return {
        traceId: (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)(),
        sampleRand: (0, $3ce37121dbb69e34$export$9869d72de32a3917)()
    };
    const sampleRand = $80a392b08eb130e9$var$getSampleRandFromTraceparentAndDsc(traceparentData, dynamicSamplingContext);
    // The sample_rand on the DSC needs to be generated based on traceparent + baggage.
    if (dynamicSamplingContext) dynamicSamplingContext.sample_rand = sampleRand.toString();
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData;
    return {
        traceId: traceId,
        parentSpanId: parentSpanId,
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {},
        sampleRand: sampleRand
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $80a392b08eb130e9$export$f35d907436da45cf(traceId = (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)(), spanId = (0, $089e6aeb4531f5e4$export$295213bc4d0c54ad)(), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}
/**
 * Creates a W3C traceparent header from the given trace and span ids.
 */ function $80a392b08eb130e9$export$1aff3752542747dd(traceId = (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)(), spanId = (0, $089e6aeb4531f5e4$export$295213bc4d0c54ad)(), sampled) {
    return `00-${traceId}-${spanId}-${sampled ? '01' : '00'}`;
}
/**
 * Given any combination of an incoming trace, generate a sample rand based on its defined semantics.
 *
 * Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
 */ function $80a392b08eb130e9$var$getSampleRandFromTraceparentAndDsc(traceparentData, dsc) {
    // When there is an incoming sample rand use it.
    const parsedSampleRand = (0, $f99dcce240975486$export$a5bd2d81656d9546)(dsc?.sample_rand);
    if (parsedSampleRand !== undefined) return parsedSampleRand;
    // Otherwise, if there is an incoming sampling decision + sample rate, generate a sample rand that would lead to the same sampling decision.
    const parsedSampleRate = (0, $f99dcce240975486$export$a5bd2d81656d9546)(dsc?.sample_rate);
    if (parsedSampleRate && traceparentData?.parentSampled !== undefined) return traceparentData.parentSampled ? (0, $3ce37121dbb69e34$export$9869d72de32a3917)() * parsedSampleRate : parsedSampleRate + (0, $3ce37121dbb69e34$export$9869d72de32a3917)() * (1 - parsedSampleRate);
    else // If nothing applies, return a random sample rand.
    return (0, $3ce37121dbb69e34$export$9869d72de32a3917)();
}
/**
 * Determines whether a new trace should be continued based on the provided baggage org ID and the client's `strictTraceContinuation` option.
 * If the trace should not be continued, a new trace will be started.
 *
 * The result is dependent on the `strictTraceContinuation` option in the client.
 * See https://develop.sentry.dev/sdk/telemetry/traces/#stricttracecontinuation
 */ function $80a392b08eb130e9$export$18811bc99eefceaa(client, baggageOrgId) {
    const clientOrgId = (0, $8ef4a8c4a6476e0c$export$b7ac9b8efa4bb595)(client);
    // Case: baggage orgID and Client orgID don't match - always start new trace
    if (baggageOrgId && clientOrgId && baggageOrgId !== clientOrgId) {
        (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Won't continue trace because org IDs don't match (incoming baggage: ${baggageOrgId}, SDK options: ${clientOrgId})`);
        return false;
    }
    const strictTraceContinuation = client.getOptions().strictTraceContinuation || false; // default for `strictTraceContinuation` is `false`
    if (strictTraceContinuation) // With strict continuation enabled, don't continue trace if:
    // - Baggage has orgID, but Client doesn't have one
    // - Client has orgID, but baggage doesn't have one
    {
        if (baggageOrgId && !clientOrgId || !baggageOrgId && clientOrgId) {
            (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Starting a new trace because strict trace continuation is enabled but one org ID is missing (incoming baggage: ${baggageOrgId}, Sentry client: ${clientOrgId})`);
            return false;
        }
    }
    return true;
}




// These are aligned with OpenTelemetry trace flags
const $122b7a6129e42fb6$export$208d5b368507fb8b = 0x0;
const $122b7a6129e42fb6$export$eb571cd9b5d98de8 = 0x1;
let $122b7a6129e42fb6$var$hasShownSpanDropWarning = false;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $122b7a6129e42fb6$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin, links: links } = $122b7a6129e42fb6$export$92d8c23565496537(span);
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin,
        links: links
    };
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $122b7a6129e42fb6$export$46c6fbd1d265ebf0(span) {
    const { spanId: spanId, traceId: trace_id, isRemote: isRemote } = span.spanContext();
    // If the span is remote, we use a random/virtual span as span_id to the trace context,
    // and the remote span as parent_span_id
    const parent_span_id = isRemote ? spanId : $122b7a6129e42fb6$export$92d8c23565496537(span).parent_span_id;
    const scope = (0, $ecf2a0f66df9dd54$export$c08fbc656a245d03)(span).scope;
    const span_id = isRemote ? scope?.getPropagationContext().propagationSpanId || (0, $089e6aeb4531f5e4$export$295213bc4d0c54ad)() : spanId;
    return {
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    };
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $122b7a6129e42fb6$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $122b7a6129e42fb6$export$5caecac1caaf3a71(span);
    return (0, $80a392b08eb130e9$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a Span to a W3C traceparent header.
 */ function $122b7a6129e42fb6$export$cda58d87bc594e9f(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $122b7a6129e42fb6$export$5caecac1caaf3a71(span);
    return (0, $80a392b08eb130e9$export$1aff3752542747dd)(traceId, spanId, sampled);
}
/**
 *  Converts the span links array to a flattened version to be sent within an envelope.
 *
 *  If the links array is empty, it returns `undefined` so the empty value can be dropped before it's sent.
 */ function $122b7a6129e42fb6$export$cb3e3a12e0eec16c(links) {
    if (links && links.length > 0) return links.map(({ context: { spanId: spanId, traceId: traceId, traceFlags: traceFlags, ...restContext }, attributes: attributes })=>({
            span_id: spanId,
            trace_id: traceId,
            sampled: traceFlags === $122b7a6129e42fb6$export$eb571cd9b5d98de8,
            attributes: attributes,
            ...restContext
        }));
    else return undefined;
}
/**
 * Convert a span time input into a timestamp in seconds.
 */ function $122b7a6129e42fb6$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $122b7a6129e42fb6$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $122b7a6129e42fb6$var$ensureTimestampInSeconds(input.getTime());
    return (0, $906abfdc43292150$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $122b7a6129e42fb6$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $122b7a6129e42fb6$export$92d8c23565496537(span) {
    if ($122b7a6129e42fb6$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
    if ($122b7a6129e42fb6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
        const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, status: status, links: links } = span;
        // In preparation for the next major of OpenTelemetry, we want to support
        // looking up the parent span id according to the new API
        // In OTel v1, the parent span id is accessed as `parentSpanId`
        // In OTel v2, the parent span id is accessed as `spanId` on the `parentSpanContext`
        const parentSpanId = 'parentSpanId' in span ? span.parentSpanId : 'parentSpanContext' in span ? span.parentSpanContext?.spanId : undefined;
        return {
            span_id: span_id,
            trace_id: trace_id,
            data: attributes,
            description: name,
            parent_span_id: parentSpanId,
            start_timestamp: $122b7a6129e42fb6$export$3f7581298f56c6d7(startTime),
            // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
            timestamp: $122b7a6129e42fb6$export$3f7581298f56c6d7(endTime) || undefined,
            status: $122b7a6129e42fb6$export$e238a77ea3a8cd66(status),
            op: attributes[0, $d06802d0f59b2c9f$export$1a413bd9a88fdb09],
            origin: attributes[0, $d06802d0f59b2c9f$export$cca8dd30f57f805e],
            links: $122b7a6129e42fb6$export$cb3e3a12e0eec16c(links)
        };
    }
    // Finally, at least we have `spanContext()`....
    // This should not actually happen in reality, but we need to handle it for type safety.
    return {
        span_id: span_id,
        trace_id: trace_id,
        start_timestamp: 0,
        data: {}
    };
}
function $122b7a6129e42fb6$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $122b7a6129e42fb6$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $122b7a6129e42fb6$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $122b7a6129e42fb6$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $122b7a6129e42fb6$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $d4120bb7aba6235c$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $d4120bb7aba6235c$export$58f7963109c806fc)) return 'ok';
    return status.message || 'internal_error';
}
const $122b7a6129e42fb6$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $122b7a6129e42fb6$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $122b7a6129e42fb6$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$122b7a6129e42fb6$var$ROOT_SPAN_FIELD] || span;
    (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(childSpan, $122b7a6129e42fb6$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$122b7a6129e42fb6$var$CHILD_SPANS_FIELD]) span[$122b7a6129e42fb6$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(span, $122b7a6129e42fb6$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $122b7a6129e42fb6$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$122b7a6129e42fb6$var$CHILD_SPANS_FIELD]) span[$122b7a6129e42fb6$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $122b7a6129e42fb6$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($122b7a6129e42fb6$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$122b7a6129e42fb6$var$CHILD_SPANS_FIELD] ? Array.from(span[$122b7a6129e42fb6$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $122b7a6129e42fb6$export$c4c6a79b1260ca1b(span) {
    return span[$122b7a6129e42fb6$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $122b7a6129e42fb6$export$1be426a8e585c83e() {
    const carrier = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const acs = (0, $3e49a8fa7c1f2ba6$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $e57da10b3d1051db$export$91f063ebb8eff307)((0, $64ff6138fe06e713$export$c7be4b0125a10cba)());
}
/**
 * Logs a warning once if `beforeSendSpan` is used to drop spans.
 */ function $122b7a6129e42fb6$export$d11691ff45a3e535() {
    if (!$122b7a6129e42fb6$var$hasShownSpanDropWarning) {
        (0, $ff784a3dc7695b3c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Returning null from `beforeSendSpan` is disallowed. To drop certain spans, configure the respective integrations directly or use `ignoreSpans`.');
        });
        $122b7a6129e42fb6$var$hasShownSpanDropWarning = true;
    }
}
/**
 * Updates the name of the given span and ensures that the span name is not
 * overwritten by the Sentry SDK.
 *
 * Use this function instead of `span.updateName()` if you want to make sure that
 * your name is kept. For some spans, for example root `http.server` spans the
 * Sentry SDK would otherwise overwrite the span name with a high-quality name
 * it infers when the span ends.
 *
 * Use this function in server code or when your span is started on the server
 * and on the client (browser). If you only update a span name on the client,
 * you can also use `span.updateName()` the SDK does not overwrite the name.
 *
 * @param span - The span to update the name of.
 * @param name - The name to set on the span.
 */ function $122b7a6129e42fb6$export$5b72d3169c1be715(span, name) {
    span.updateName(name);
    span.setAttributes({
        [(0, $d06802d0f59b2c9f$export$d7a7d984b0791405)]: 'custom',
        [(0, $d06802d0f59b2c9f$export$165ce9a229f6f050)]: name
    });
}



/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $175980fe5a84e4c5$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $175980fe5a84e4c5$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(spanWithMaybeDsc, $175980fe5a84e4c5$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $175980fe5a84e4c5$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // Instead of conditionally adding non-undefined values, we add them and then remove them if needed
    // otherwise, the order of baggage entries changes, which "breaks" a bunch of tests etc.
    const dsc = {
        environment: options.environment || (0, $2a9a4c4c0dffc99b$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id,
        org_id: (0, $8ef4a8c4a6476e0c$export$b7ac9b8efa4bb595)(client)
    };
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Get the dynamic sampling context for the currently active scopes.
 */ function $175980fe5a84e4c5$export$89ef1736f08c6b2b(client, scope) {
    const propagationContext = scope.getPropagationContext();
    return propagationContext.dsc || $175980fe5a84e4c5$export$366bad00d6815eed(propagationContext.traceId, client);
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $175980fe5a84e4c5$export$a117f995597e25df(span) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const rootSpan = (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(span);
    const rootSpanJson = (0, $122b7a6129e42fb6$export$92d8c23565496537)(rootSpan);
    const rootSpanAttributes = rootSpanJson.data;
    const traceState = rootSpan.spanContext().traceState;
    // The span sample rate that was locally applied to the root span should also always be applied to the DSC, even if the DSC is frozen.
    // This is so that the downstream traces/services can use parentSampleRate in their `tracesSampler` to make consistent sampling decisions across the entire trace.
    const rootSpanSampleRate = traceState?.get('sentry.sample_rate') ?? rootSpanAttributes[0, $d06802d0f59b2c9f$export$ccfe0a40627cc34b] ?? rootSpanAttributes[0, $d06802d0f59b2c9f$export$889fb736668e1ecc];
    function applyLocalSampleRateToDsc(dsc) {
        if (typeof rootSpanSampleRate === 'number' || typeof rootSpanSampleRate === 'string') dsc.sample_rate = `${rootSpanSampleRate}`;
        return dsc;
    }
    // For core implementation, we freeze the DSC onto the span as a non-enumerable property
    const frozenDsc = rootSpan[$175980fe5a84e4c5$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return applyLocalSampleRateToDsc(frozenDsc);
    // For OpenTelemetry, we freeze the DSC on the trace state
    const traceStateDsc = traceState?.get('sentry.dsc');
    // If the span has a DSC, we want it to take precedence
    const dscOnTraceState = traceStateDsc && (0, $231c50e128fa7b11$export$5b96ee2c8421f107)(traceStateDsc);
    if (dscOnTraceState) return applyLocalSampleRateToDsc(dscOnTraceState);
    // Else, we generate it from the span
    const dsc = $175980fe5a84e4c5$export$366bad00d6815eed(span.spanContext().traceId, client);
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = rootSpanAttributes[0, $d06802d0f59b2c9f$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    const name = rootSpanJson.description;
    if (source !== 'url' && name) dsc.transaction = name;
    // How can we even land here with hasSpansEnabled() returning false?
    // Otel creates a Non-recording span in Tracing Without Performance mode when handling incoming requests
    // So we end up with an active span that is not sampled (neither positively nor negatively)
    if ((0, $22da8de313ab467e$export$1f70765132c3c225)()) {
        dsc.sampled = String((0, $122b7a6129e42fb6$export$5caecac1caaf3a71)(rootSpan));
        dsc.sample_rand = // In OTEL we store the sample rand on the trace state because we cannot access scopes for NonRecordingSpans
        // The Sentry OTEL SpanSampler takes care of writing the sample rand on the root span
        traceState?.get('sentry.sample_rand') ?? // On all other platforms we can actually get the scopes from a root span (we use this as a fallback)
        (0, $ecf2a0f66df9dd54$export$c08fbc656a245d03)(rootSpan).scope?.getPropagationContext().sampleRand.toString();
    }
    applyLocalSampleRateToDsc(dsc);
    client.emit('createDsc', dsc, rootSpan);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $175980fe5a84e4c5$export$95cf936fdacaff7b(span) {
    const dsc = $175980fe5a84e4c5$export$a117f995597e25df(span);
    return (0, $231c50e128fa7b11$export$56766feef403f365)(dsc);
}




/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $caa3e3e5ebbbdd71$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $caa3e3e5ebbbdd71$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $caa3e3e5ebbbdd71$var$applySpanToEvent(event, span);
    $caa3e3e5ebbbdd71$var$applyFingerprintToEvent(event, fingerprint);
    $caa3e3e5ebbbdd71$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $caa3e3e5ebbbdd71$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $caa3e3e5ebbbdd71$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, attributes: attributes, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $caa3e3e5ebbbdd71$export$b1a120a2871faa46(data, 'extra', extra);
    $caa3e3e5ebbbdd71$export$b1a120a2871faa46(data, 'tags', tags);
    $caa3e3e5ebbbdd71$export$b1a120a2871faa46(data, 'attributes', attributes);
    $caa3e3e5ebbbdd71$export$b1a120a2871faa46(data, 'user', user);
    $caa3e3e5ebbbdd71$export$b1a120a2871faa46(data, 'contexts', contexts);
    data.sdkProcessingMetadata = (0, $9392a3c1760ef37e$export$4950aa0f605343fb)(data.sdkProcessingMetadata, sdkProcessingMetadata, 2);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $caa3e3e5ebbbdd71$export$b1a120a2871faa46(data, prop, mergeVal) {
    data[prop] = (0, $9392a3c1760ef37e$export$4950aa0f605343fb)(data[prop], mergeVal, 1);
}
/**
 * Get the scope data for the current scope after merging with the
 * global scope and isolation scope.
 *
 * @param currentScope - The current scope.
 * @returns The scope data.
 */ function $caa3e3e5ebbbdd71$export$cc422922fcbb91c6(isolationScope, currentScope) {
    const scopeData = (0, $64ff6138fe06e713$export$aa55d5ab8e05984f)().getScopeData();
    isolationScope && $caa3e3e5ebbbdd71$export$25ac7e259a513db4(scopeData, isolationScope.getScopeData());
    currentScope && $caa3e3e5ebbbdd71$export$25ac7e259a513db4(scopeData, currentScope.getScopeData());
    return scopeData;
}
function $caa3e3e5ebbbdd71$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    if (Object.keys(extra).length) event.extra = {
        ...extra,
        ...event.extra
    };
    if (Object.keys(tags).length) event.tags = {
        ...tags,
        ...event.tags
    };
    if (Object.keys(user).length) event.user = {
        ...user,
        ...event.user
    };
    if (Object.keys(contexts).length) event.contexts = {
        ...contexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $caa3e3e5ebbbdd71$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $caa3e3e5ebbbdd71$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $caa3e3e5ebbbdd71$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $122b7a6129e42fb6$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $175980fe5a84e4c5$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $122b7a6129e42fb6$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $caa3e3e5ebbbdd71$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
        event.fingerprint
    ] : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (!event.fingerprint.length) delete event.fingerprint;
}







/** Extract trace information from scope */ function $586b0e9dcee0909f$export$fb7d833b3fdedf5f(client, scope) {
    if (!scope) return [
        undefined,
        undefined
    ];
    return (0, $64ff6138fe06e713$export$ec58d9285c204497)(scope, ()=>{
        const span = (0, $122b7a6129e42fb6$export$1be426a8e585c83e)();
        const traceContext = span ? (0, $122b7a6129e42fb6$export$46c6fbd1d265ebf0)(span) : (0, $64ff6138fe06e713$export$1e83db7ee4876dc4)(scope);
        const dynamicSamplingContext = span ? (0, $175980fe5a84e4c5$export$a117f995597e25df)(span) : (0, $175980fe5a84e4c5$export$89ef1736f08c6b2b)(client, scope);
        return [
            dynamicSamplingContext,
            traceContext
        ];
    });
}


/**
 * Maps a log severity level to a log severity number.
 *
 * @see LogSeverityLevel
 */ const $68ab26dab632c4f9$export$4fb50c0840d636d1 = {
    trace: 1,
    debug: 5,
    info: 9,
    warn: 13,
    error: 17,
    fatal: 21
};








/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normalized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8f8ce6efe9d68113$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $8f8ce6efe9d68113$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $8f8ce6efe9d68113$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $8f8ce6efe9d68113$export$a3295358bff77e(object, depth);
    if ($8f8ce6efe9d68113$var$jsonSize(normalized) > maxSize) return $8f8ce6efe9d68113$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $8f8ce6efe9d68113$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = $8f8ce6efe9d68113$var$memoBuilder()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'boolean',
        'string'
    ].includes(typeof value) || typeof value === 'number' && Number.isFinite(value)) return value;
    const stringified = $8f8ce6efe9d68113$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $8f8ce6efe9d68113$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch  {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $085a6ebfb8b9293d$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $8f8ce6efe9d68113$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $8f8ce6efe9d68113$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $057f17bbb7048b01$export$7916fad0ebc23f48)(value)) return (0, $7a317b2b764bd658$export$b6d9c5eb2330759f)(value);
        // React's SyntheticEvent thingy
        if ((0, $057f17bbb7048b01$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && !Number.isFinite(value)) return `[${value}]`;
        if (typeof value === 'function') return `[Function: ${(0, $7a317b2b764bd658$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $8f8ce6efe9d68113$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $8f8ce6efe9d68113$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype?.constructor ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $8f8ce6efe9d68113$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8f8ce6efe9d68113$var$jsonSize(value) {
    return $8f8ce6efe9d68113$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $8f8ce6efe9d68113$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch  {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}
/**
 * Helper to decycle json objects
 */ function $8f8ce6efe9d68113$var$memoBuilder() {
    const inner = new WeakSet();
    function memoize(obj) {
        if (inner.has(obj)) return true;
        inner.add(obj);
        return false;
    }
    function unmemoize(obj) {
        inner.delete(obj);
    }
    return [
        memoize,
        unmemoize
    ];
}



/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $6eda0c2a5c5e65e3$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $6eda0c2a5c5e65e3$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $6eda0c2a5c5e65e3$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $6eda0c2a5c5e65e3$export$604a45d95a155e2b(envelope, types) {
    return $6eda0c2a5c5e65e3$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $6eda0c2a5c5e65e3$var$encodeUTF8(input) {
    const carrier = (0, $b51d9d034721a478$export$c8bfa33e4e8ae492)((0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1));
    return carrier.encodePolyfill ? carrier.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $6eda0c2a5c5e65e3$var$decodeUTF8(input) {
    const carrier = (0, $b51d9d034721a478$export$c8bfa33e4e8ae492)((0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1));
    return carrier.decodePolyfill ? carrier.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $6eda0c2a5c5e65e3$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $6eda0c2a5c5e65e3$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $6eda0c2a5c5e65e3$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch  {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.stringify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $8f8ce6efe9d68113$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $6eda0c2a5c5e65e3$var$concatBuffers(parts);
}
function $6eda0c2a5c5e65e3$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $6eda0c2a5c5e65e3$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $6eda0c2a5c5e65e3$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($6eda0c2a5c5e65e3$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $6eda0c2a5c5e65e3$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $6eda0c2a5c5e65e3$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $6eda0c2a5c5e65e3$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        {
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        },
        buffer
    ];
}
const $6eda0c2a5c5e65e3$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    profile_chunk: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    raw_security: 'security',
    log: 'log_item',
    metric: 'metric',
    trace_metric: 'metric'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $6eda0c2a5c5e65e3$export$b11169581eeaf237(type) {
    return $6eda0c2a5c5e65e3$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $6eda0c2a5c5e65e3$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent?.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $6eda0c2a5c5e65e3$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata?.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8ef4a8c4a6476e0c$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: dynamicSamplingContext
        }
    };
}


/**
 * Creates a log container envelope item for a list of logs.
 *
 * @param items - The logs to include in the envelope.
 * @returns The created log container envelope item.
 */ function $b64be2b0f8017ee0$export$efdf3b13edb1118e(items) {
    return [
        {
            type: 'log',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.log+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of logs.
 *
 * Logs from multiple traces can be included in the same envelope.
 *
 * @param logs - The logs to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $b64be2b0f8017ee0$export$cdcd668e6516443f(logs, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $8ef4a8c4a6476e0c$export$44d472fbb931a776)(dsn);
    return (0, $6eda0c2a5c5e65e3$export$f93f7f385160c44e)(headers, [
        $b64be2b0f8017ee0$export$efdf3b13edb1118e(logs)
    ]);
}


const $0a259c8ca224b0c2$var$MAX_LOG_BUFFER_SIZE = 100;
/**
 * Sets a log attribute if the value exists and the attribute key is not already present.
 *
 * @param logAttributes - The log attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $0a259c8ca224b0c2$var$setLogAttribute(logAttributes, key, value, setEvenIfPresent = true) {
    if (value && (!logAttributes[key] || setEvenIfPresent)) logAttributes[key] = value;
}
/**
 * Captures a serialized log event and adds it to the log buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedLog - The serialized log event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $0a259c8ca224b0c2$export$743ba6f7ec19225f(client, serializedLog) {
    const bufferMap = $0a259c8ca224b0c2$var$_getBufferMap();
    const logBuffer = $0a259c8ca224b0c2$export$5365c9902fb9e770(client);
    if (logBuffer === undefined) bufferMap.set(client, [
        serializedLog
    ]);
    else if (logBuffer.length >= $0a259c8ca224b0c2$var$MAX_LOG_BUFFER_SIZE) {
        $0a259c8ca224b0c2$export$f8ed83d3b6a0b504(client, logBuffer);
        bufferMap.set(client, [
            serializedLog
        ]);
    } else bufferMap.set(client, [
        ...logBuffer,
        serializedLog
    ]);
}
/**
 * Captures a log event and sends it to Sentry.
 *
 * @param log - The log event to capture.
 * @param scope - A scope. Uses the current scope if not provided.
 * @param client - A client. Uses the current client if not provided.
 * @param captureSerializedLog - A function to capture the serialized log.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $0a259c8ca224b0c2$export$3ab3d16b9eebd986(beforeLog, currentScope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)(), captureSerializedLog = $0a259c8ca224b0c2$export$743ba6f7ec19225f) {
    const client = currentScope?.getClient() ?? (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('No client available to capture log.');
        return;
    }
    const { release: release, environment: environment, enableLogs: enableLogs = false, beforeSendLog: beforeSendLog } = client.getOptions();
    if (!enableLogs) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('logging option not enabled, log will not be captured.');
        return;
    }
    const [, traceContext] = (0, $586b0e9dcee0909f$export$fb7d833b3fdedf5f)(client, currentScope);
    const processedLogAttributes = {
        ...beforeLog.attributes
    };
    const { user: { id: id, email: email, username: username }, attributes: scopeAttributes = {} } = (0, $caa3e3e5ebbbdd71$export$cc422922fcbb91c6)((0, $64ff6138fe06e713$export$68f3af03034c9e90)(), currentScope);
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'user.id', id, false);
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'user.email', email, false);
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'user.name', username, false);
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'sentry.release', release);
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'sentry.environment', environment);
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.name', name);
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'sentry.sdk.version', version);
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') // We send this so we can identify cases where the replayId is attached but the replay itself might not have been sent to Sentry
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'sentry._internal.replay_is_buffering', true);
    const beforeLogMessage = beforeLog.message;
    if ((0, $057f17bbb7048b01$export$dbcbffa59149b824)(beforeLogMessage)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ = [] } = beforeLogMessage;
        if (__sentry_template_values__?.length) processedLogAttributes['sentry.message.template'] = __sentry_template_string__;
        __sentry_template_values__.forEach((param, index)=>{
            processedLogAttributes[`sentry.message.parameter.${index}`] = param;
        });
    }
    const span = (0, $e57da10b3d1051db$export$91f063ebb8eff307)(currentScope);
    // Add the parent span ID to the log attributes for trace context
    $0a259c8ca224b0c2$var$setLogAttribute(processedLogAttributes, 'sentry.trace.parent_span_id', span?.spanContext().spanId);
    const processedLog = {
        ...beforeLog,
        attributes: processedLogAttributes
    };
    client.emit('beforeCaptureLog', processedLog);
    // We need to wrap this in `consoleSandbox` to avoid recursive calls to `beforeSendLog`
    const log = beforeSendLog ? (0, $ff784a3dc7695b3c$export$cda52e2a8927a2ca)(()=>beforeSendLog(processedLog)) : processedLog;
    if (!log) {
        client.recordDroppedEvent('before_send', 'log_item', 1);
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('beforeSendLog returned null, log will not be captured.');
        return;
    }
    const { level: level, message: message, attributes: logAttributes = {}, severityNumber: severityNumber } = log;
    const serializedLog = {
        timestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)(),
        level: level,
        body: message,
        trace_id: traceContext?.trace_id,
        severity_number: severityNumber ?? (0, $68ab26dab632c4f9$export$4fb50c0840d636d1)[level],
        attributes: {
            ...(0, $1f7a8041c0ae48d4$export$4954cae66e755861)(scopeAttributes),
            ...(0, $1f7a8041c0ae48d4$export$4954cae66e755861)(logAttributes, true)
        }
    };
    captureSerializedLog(client, serializedLog);
    client.emit('afterCaptureLog', log);
}
/**
 * Flushes the logs buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeLogBuffer - A log buffer. Uses the log buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $0a259c8ca224b0c2$export$f8ed83d3b6a0b504(client, maybeLogBuffer) {
    const logBuffer = maybeLogBuffer ?? $0a259c8ca224b0c2$export$5365c9902fb9e770(client) ?? [];
    if (logBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $b64be2b0f8017ee0$export$cdcd668e6516443f)(logBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the log buffer after envelopes have been constructed.
    $0a259c8ca224b0c2$var$_getBufferMap().set(client, []);
    client.emit('flushLogs');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the log buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the log buffer for.
 * @returns The log buffer for the given client.
 */ function $0a259c8ca224b0c2$export$5365c9902fb9e770(client) {
    return $0a259c8ca224b0c2$var$_getBufferMap().get(client);
}
function $0a259c8ca224b0c2$var$_getBufferMap() {
    // The reference to the Client <> LogBuffer map is stored on the carrier to ensure it's always the same
    return (0, $b51d9d034721a478$export$7e223ec222791509)('clientToLogBufferMap', ()=>new WeakMap());
}












/**
 * Creates a metric container envelope item for a list of metrics.
 *
 * @param items - The metrics to include in the envelope.
 * @returns The created metric container envelope item.
 */ function $e5f22c42b804a7d7$export$58e45eb52ad1077d(items) {
    return [
        {
            type: 'trace_metric',
            item_count: items.length,
            content_type: 'application/vnd.sentry.items.trace-metric+json'
        },
        {
            items: items
        }
    ];
}
/**
 * Creates an envelope for a list of metrics.
 *
 * Metrics from multiple traces can be included in the same envelope.
 *
 * @param metrics - The metrics to include in the envelope.
 * @param metadata - The metadata to include in the envelope.
 * @param tunnel - The tunnel to include in the envelope.
 * @param dsn - The DSN to include in the envelope.
 * @returns The created envelope.
 */ function $e5f22c42b804a7d7$export$f23eb96e33154901(metrics, metadata, tunnel, dsn) {
    const headers = {};
    if (metadata?.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && !!dsn) headers.dsn = (0, $8ef4a8c4a6476e0c$export$44d472fbb931a776)(dsn);
    return (0, $6eda0c2a5c5e65e3$export$f93f7f385160c44e)(headers, [
        $e5f22c42b804a7d7$export$58e45eb52ad1077d(metrics)
    ]);
}


const $c775830d1e8c2972$var$MAX_METRIC_BUFFER_SIZE = 1000;
/**
 * Sets a metric attribute if the value exists and the attribute key is not already present.
 *
 * @param metricAttributes - The metric attributes object to modify.
 * @param key - The attribute key to set.
 * @param value - The value to set (only sets if truthy and key not present).
 * @param setEvenIfPresent - Whether to set the attribute if it is present. Defaults to true.
 */ function $c775830d1e8c2972$var$setMetricAttribute(metricAttributes, key, value, setEvenIfPresent = true) {
    if (value && (setEvenIfPresent || !(key in metricAttributes))) metricAttributes[key] = value;
}
/**
 * Captures a serialized metric event and adds it to the metric buffer for the given client.
 *
 * @param client - A client. Uses the current client if not provided.
 * @param serializedMetric - The serialized metric event to capture.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $c775830d1e8c2972$export$84661fd26e6cac96(client, serializedMetric) {
    const bufferMap = $c775830d1e8c2972$var$_getBufferMap();
    const metricBuffer = $c775830d1e8c2972$export$49385134251b08ff(client);
    if (metricBuffer === undefined) bufferMap.set(client, [
        serializedMetric
    ]);
    else if (metricBuffer.length >= $c775830d1e8c2972$var$MAX_METRIC_BUFFER_SIZE) {
        $c775830d1e8c2972$export$91c9ef254b7d0f67(client, metricBuffer);
        bufferMap.set(client, [
            serializedMetric
        ]);
    } else bufferMap.set(client, [
        ...metricBuffer,
        serializedMetric
    ]);
}
/**
 * Options for capturing a metric internally.
 */ /**
 * Enriches metric with all contextual attributes (user, SDK metadata, replay, etc.)
 */ function $c775830d1e8c2972$var$_enrichMetricAttributes(beforeMetric, client, user) {
    const { release: release, environment: environment } = client.getOptions();
    const processedMetricAttributes = {
        ...beforeMetric.attributes
    };
    // Add user attributes
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'user.id', user.id, false);
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'user.email', user.email, false);
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'user.name', user.username, false);
    // Add Sentry metadata
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'sentry.release', release);
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'sentry.environment', environment);
    // Add SDK metadata
    const { name: name, version: version } = client.getSdkMetadata()?.sdk ?? {};
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.name', name);
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'sentry.sdk.version', version);
    // Add replay metadata
    const replay = client.getIntegrationByName('Replay');
    const replayId = replay?.getReplayId(true);
    $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'sentry.replay_id', replayId);
    if (replayId && replay?.getRecordingMode() === 'buffer') $c775830d1e8c2972$var$setMetricAttribute(processedMetricAttributes, 'sentry._internal.replay_is_buffering', true);
    return {
        ...beforeMetric,
        attributes: processedMetricAttributes
    };
}
/**
 * Creates a serialized metric ready to be sent to Sentry.
 */ function $c775830d1e8c2972$var$_buildSerializedMetric(metric, client, currentScope, scopeAttributes) {
    // Get trace context
    const [, traceContext] = (0, $586b0e9dcee0909f$export$fb7d833b3fdedf5f)(client, currentScope);
    const span = (0, $e57da10b3d1051db$export$91f063ebb8eff307)(currentScope);
    const traceId = span ? span.spanContext().traceId : traceContext?.trace_id;
    const spanId = span ? span.spanContext().spanId : undefined;
    return {
        timestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)(),
        trace_id: traceId ?? '',
        span_id: spanId,
        name: metric.name,
        type: metric.type,
        unit: metric.unit,
        value: metric.value,
        attributes: {
            ...(0, $1f7a8041c0ae48d4$export$4954cae66e755861)(scopeAttributes),
            ...(0, $1f7a8041c0ae48d4$export$4954cae66e755861)(metric.attributes, 'skip-undefined')
        }
    };
}
/**
 * Captures a metric event and sends it to Sentry.
 *
 * @param metric - The metric event to capture.
 * @param options - Options for capturing the metric.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $c775830d1e8c2972$export$288d896e6652e0c4(beforeMetric, options) {
    const currentScope = options?.scope ?? (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
    const captureSerializedMetric = options?.captureSerializedMetric ?? $c775830d1e8c2972$export$84661fd26e6cac96;
    const client = currentScope?.getClient() ?? (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('No client available to capture metric.');
        return;
    }
    const { _experiments: _experiments, enableMetrics: enableMetrics, beforeSendMetric: beforeSendMetric } = client.getOptions();
    // todo(v11): Remove the experimental flag
    // eslint-disable-next-line deprecation/deprecation
    const metricsEnabled = enableMetrics ?? _experiments?.enableMetrics ?? true;
    if (!metricsEnabled) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('metrics option not enabled, metric will not be captured.');
        return;
    }
    // Enrich metric with contextual attributes
    const { user: user, attributes: scopeAttributes } = (0, $caa3e3e5ebbbdd71$export$cc422922fcbb91c6)((0, $64ff6138fe06e713$export$68f3af03034c9e90)(), currentScope);
    const enrichedMetric = $c775830d1e8c2972$var$_enrichMetricAttributes(beforeMetric, client, user);
    client.emit('processMetric', enrichedMetric);
    // todo(v11): Remove the experimental `beforeSendMetric`
    // eslint-disable-next-line deprecation/deprecation
    const beforeSendCallback = beforeSendMetric || _experiments?.beforeSendMetric;
    const processedMetric = beforeSendCallback ? beforeSendCallback(enrichedMetric) : enrichedMetric;
    if (!processedMetric) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('`beforeSendMetric` returned `null`, will not send metric.');
        return;
    }
    const serializedMetric = $c775830d1e8c2972$var$_buildSerializedMetric(processedMetric, client, currentScope, scopeAttributes);
    (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('[Metric]', serializedMetric);
    captureSerializedMetric(client, serializedMetric);
    client.emit('afterCaptureMetric', processedMetric);
}
/**
 * Flushes the metrics buffer to Sentry.
 *
 * @param client - A client.
 * @param maybeMetricBuffer - A metric buffer. Uses the metric buffer for the given client if not provided.
 *
 * @experimental This method will experience breaking changes. This is not yet part of
 * the stable Sentry SDK API and can be changed or removed without warning.
 */ function $c775830d1e8c2972$export$91c9ef254b7d0f67(client, maybeMetricBuffer) {
    const metricBuffer = maybeMetricBuffer ?? $c775830d1e8c2972$export$49385134251b08ff(client) ?? [];
    if (metricBuffer.length === 0) return;
    const clientOptions = client.getOptions();
    const envelope = (0, $e5f22c42b804a7d7$export$f23eb96e33154901)(metricBuffer, clientOptions._metadata, clientOptions.tunnel, client.getDsn());
    // Clear the metric buffer after envelopes have been constructed.
    $c775830d1e8c2972$var$_getBufferMap().set(client, []);
    client.emit('flushMetrics');
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}
/**
 * Returns the metric buffer for a given client.
 *
 * Exported for testing purposes.
 *
 * @param client - The client to get the metric buffer for.
 * @returns The metric buffer for the given client.
 */ function $c775830d1e8c2972$export$49385134251b08ff(client) {
    return $c775830d1e8c2972$var$_getBufferMap().get(client);
}
function $c775830d1e8c2972$var$_getBufferMap() {
    // The reference to the Client <> MetricBuffer map is stored on the carrier to ensure it's always the same
    return (0, $b51d9d034721a478$export$7e223ec222791509)('clientToMetricBufferMap', ()=>new WeakMap());
}

// By default, we want to infer the IP address, unless this is explicitly set to `null`
// We do this after all other processing is done
// If `ip_address` is explicitly set to `null` or a value, we leave it as is
/**
 * @internal
 * @deprecated -- set ip inferral via via SDK metadata options on client instead.
 */ function $349a19aada264b44$export$3e12ad68afa434ac(objWithMaybeUser) {
    if (objWithMaybeUser.user?.ip_address === undefined) objWithMaybeUser.user = {
        ...objWithMaybeUser.user,
        ip_address: '{{auto}}'
    };
}
/**
 * @internal
 */ function $349a19aada264b44$export$e8e2d07ba63e2b6c(session) {
    if ('aggregates' in session) {
        if (session.attrs?.['ip_address'] === undefined) session.attrs = {
            ...session.attrs,
            ip_address: '{{auto}}'
        };
    } else if (session.ipAddress === undefined) session.ipAddress = '{{auto}}';
}


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $db3439a3565fcfe3$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $5480def7277060d8$export$31499a9cd224b78c)
            })),
        version: (0, $5480def7277060d8$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}


const $313c552b52876041$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $313c552b52876041$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $313c552b52876041$var$_getIngestEndpoint(dsn) {
    return `${$313c552b52876041$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $313c552b52876041$var$_encodedAuth(dsn, sdkInfo) {
    const params = {
        sentry_version: $313c552b52876041$var$SENTRY_API_VERSION
    };
    if (dsn.publicKey) // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    params.sentry_key = dsn.publicKey;
    if (sdkInfo) params.sentry_client = `${sdkInfo.name}/${sdkInfo.version}`;
    return new URLSearchParams(params).toString();
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $313c552b52876041$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$313c552b52876041$var$_getIngestEndpoint(dsn)}?${$313c552b52876041$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $313c552b52876041$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $8ef4a8c4a6476e0c$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$313c552b52876041$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $8ef4a8c4a6476e0c$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}











function $c71ed437cb7ccf8a$var$logIgnoredSpan(droppedSpan) {
    (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Ignoring span ${droppedSpan.op} - ${droppedSpan.description} because it matches \`ignoreSpans\`.`);
}
/**
 * Check if a span should be ignored based on the ignoreSpans configuration.
 */ function $c71ed437cb7ccf8a$export$5d569ac97c389400(span, ignoreSpans) {
    if (!ignoreSpans?.length || !span.description) return false;
    for (const pattern of ignoreSpans){
        if ($c71ed437cb7ccf8a$var$isStringOrRegExp(pattern)) {
            if ((0, $ff73814e958d28bd$export$cdded5b28a5f8c6d)(span.description, pattern)) {
                (0, $e74753b69eef4000$export$16a28057038b10ef) && $c71ed437cb7ccf8a$var$logIgnoredSpan(span);
                return true;
            }
            continue;
        }
        if (!pattern.name && !pattern.op) continue;
        const nameMatches = pattern.name ? (0, $ff73814e958d28bd$export$cdded5b28a5f8c6d)(span.description, pattern.name) : true;
        const opMatches = pattern.op ? span.op && (0, $ff73814e958d28bd$export$cdded5b28a5f8c6d)(span.op, pattern.op) : true;
        // This check here is only correct because we can guarantee that we ran `isMatchingPattern`
        // for at least one of `nameMatches` and `opMatches`. So in contrary to how this looks,
        // not both op and name actually have to match. This is the most efficient way to check
        // for all combinations of name and op patterns.
        if (nameMatches && opMatches) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && $c71ed437cb7ccf8a$var$logIgnoredSpan(span);
            return true;
        }
    }
    return false;
}
/**
 * Takes a list of spans, and a span that was dropped, and re-parents the child spans of the dropped span to the parent of the dropped span, if possible.
 * This mutates the spans array in place!
 */ function $c71ed437cb7ccf8a$export$ddf57376e818b444(spans, dropSpan) {
    const droppedSpanParentId = dropSpan.parent_span_id;
    const droppedSpanId = dropSpan.span_id;
    // This should generally not happen, as we do not apply this on root spans
    // but to be safe, we just bail in this case
    if (!droppedSpanParentId) return;
    for (const span of spans)if (span.parent_span_id === droppedSpanId) span.parent_span_id = droppedSpanParentId;
}
function $c71ed437cb7ccf8a$var$isStringOrRegExp(value) {
    return typeof value === 'string' || value instanceof RegExp;
}



/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 *
 * @internal, exported only for testing
 **/ function $d77a84de84103d0a$export$8a6cdb6116a9fd2b(event, newSdkInfo) {
    if (!newSdkInfo) return event;
    const eventSdkInfo = event.sdk || {};
    event.sdk = {
        ...eventSdkInfo,
        name: eventSdkInfo.name || newSdkInfo.name,
        version: eventSdkInfo.version || newSdkInfo.version,
        integrations: [
            ...event.sdk?.integrations || [],
            ...newSdkInfo.integrations || []
        ],
        packages: [
            ...event.sdk?.packages || [],
            ...newSdkInfo.packages || []
        ],
        settings: event.sdk?.settings || newSdkInfo.settings ? {
            ...event.sdk?.settings,
            ...newSdkInfo.settings
        } : undefined
    };
    return event;
}
/** Creates an envelope from a Session */ function $d77a84de84103d0a$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6eda0c2a5c5e65e3$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8ef4a8c4a6476e0c$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $6eda0c2a5c5e65e3$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $d77a84de84103d0a$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $6eda0c2a5c5e65e3$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjust a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $d77a84de84103d0a$export$8a6cdb6116a9fd2b(event, metadata?.sdk);
    const envelopeHeaders = (0, $6eda0c2a5c5e65e3$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $6eda0c2a5c5e65e3$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $d77a84de84103d0a$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $175980fe5a84e4c5$export$a117f995597e25df)(spans[0]);
    const dsn = client?.getDsn();
    const tunnel = client?.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $8ef4a8c4a6476e0c$export$44d472fbb931a776)(dsn)
        }
    };
    const { beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = client?.getOptions() || {};
    const filteredSpans = ignoreSpans?.length ? spans.filter((span)=>!(0, $c71ed437cb7ccf8a$export$5d569ac97c389400)((0, $122b7a6129e42fb6$export$92d8c23565496537)(span), ignoreSpans)) : spans;
    const droppedSpans = spans.length - filteredSpans.length;
    if (droppedSpans) client?.recordDroppedEvent('before_send', 'span', droppedSpans);
    const convertToSpanJSON = beforeSendSpan ? (span)=>{
        const spanJson = (0, $122b7a6129e42fb6$export$92d8c23565496537)(span);
        const processedSpan = beforeSendSpan(spanJson);
        if (!processedSpan) {
            (0, $122b7a6129e42fb6$export$d11691ff45a3e535)();
            return spanJson;
        }
        return processedSpan;
    } : (0, $122b7a6129e42fb6$export$92d8c23565496537);
    const items = [];
    for (const span of filteredSpans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $6eda0c2a5c5e65e3$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $6eda0c2a5c5e65e3$export$f93f7f385160c44e)(headers, items);
}











/* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ const $91d0d788d64d0c3d$var$STATE_PENDING = 0;
const $91d0d788d64d0c3d$var$STATE_RESOLVED = 1;
const $91d0d788d64d0c3d$var$STATE_REJECTED = 2;
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $91d0d788d64d0c3d$export$1fda8aa4d135f8aa(value) {
    return new $91d0d788d64d0c3d$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $91d0d788d64d0c3d$export$78e43115b553f358(reason) {
    return new $91d0d788d64d0c3d$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $91d0d788d64d0c3d$export$6f292d4960313241 {
    constructor(executor){
        this._state = $91d0d788d64d0c3d$var$STATE_PENDING;
        this._handlers = [];
        this._runExecutor(executor);
    }
    /** @inheritdoc */ then(onfulfilled, onrejected) {
        return new $91d0d788d64d0c3d$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** @inheritdoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** @inheritdoc */ finally(onfinally) {
        return new $91d0d788d64d0c3d$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** Excute the resolve/reject handlers. */ _executeHandlers() {
        if (this._state === $91d0d788d64d0c3d$var$STATE_PENDING) return;
        const cachedHandlers = this._handlers.slice();
        this._handlers = [];
        cachedHandlers.forEach((handler)=>{
            if (handler[0]) return;
            if (this._state === $91d0d788d64d0c3d$var$STATE_RESOLVED) handler[1](this._value);
            if (this._state === $91d0d788d64d0c3d$var$STATE_REJECTED) handler[2](this._value);
            handler[0] = true;
        });
    }
    /** Run the executor for the SyncPromise. */ _runExecutor(executor) {
        const setResult = (state, value)=>{
            if (this._state !== $91d0d788d64d0c3d$var$STATE_PENDING) return;
            if ((0, $057f17bbb7048b01$export$f5b060c2914b97c8)(value)) {
                value.then(resolve, reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
        const resolve = (value)=>{
            setResult($91d0d788d64d0c3d$var$STATE_RESOLVED, value);
        };
        const reject = (reason)=>{
            setResult($91d0d788d64d0c3d$var$STATE_REJECTED, reason);
        };
        try {
            executor(resolve, reject);
        } catch (e) {
            reject(e);
        }
    }
}


const $da9c6caf9b214510$export$c8667f1887a128dc = Symbol.for('SentryBufferFullError');
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $da9c6caf9b214510$export$85a4f67f852183e6(limit = 100) {
    const buffer = new Set();
    function isReady() {
        return buffer.size < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        buffer.delete(task);
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $91d0d788d64d0c3d$export$78e43115b553f358)($da9c6caf9b214510$export$c8667f1887a128dc);
        // start the task and add its promise to the queue
        const task = taskProducer();
        buffer.add(task);
        task.then(()=>remove(task), ()=>remove(task));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        if (!buffer.size) return (0, $91d0d788d64d0c3d$export$1fda8aa4d135f8aa)(true);
        // We want to resolve even if one of the promises rejects
        const drainPromise = Promise.allSettled(Array.from(buffer)).then(()=>true);
        if (!timeout) return drainPromise;
        const promises = [
            drainPromise,
            new Promise((resolve)=>setTimeout(()=>resolve(false), timeout))
        ];
        // Promise.race will resolve to the first promise that resolves or rejects
        // So if the drainPromise resolves, the timeout promise will be ignored
        return Promise.race(promises);
    }
    return {
        get $ () {
            return Array.from(buffer);
        },
        add: add,
        drain: drain
    };
}



// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $732464aedd6fa599$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $732464aedd6fa599$export$615352e17ed7741(header, now = (0, $3ce37121dbb69e34$export$65b1bada40c91b34)()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $732464aedd6fa599$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $732464aedd6fa599$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $732464aedd6fa599$export$6c91fec22056810a(limits, dataCategory, now = (0, $3ce37121dbb69e34$export$65b1bada40c91b34)()) {
    return $732464aedd6fa599$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $732464aedd6fa599$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = (0, $3ce37121dbb69e34$export$65b1bada40c91b34)()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers?.['x-sentry-rate-limits'];
    const retryAfterHeader = headers?.['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $732464aedd6fa599$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}


const $9c0afdbdc0ce2604$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $9c0afdbdc0ce2604$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $da9c6caf9b214510$export$85a4f67f852183e6)(options.bufferSize || $9c0afdbdc0ce2604$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $6eda0c2a5c5e65e3$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $6eda0c2a5c5e65e3$export$b11169581eeaf237)(type);
            if ((0, $732464aedd6fa599$export$6c91fec22056810a)(rateLimits, dataCategory)) options.recordDroppedEvent('ratelimit_backoff', dataCategory);
            else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return Promise.resolve({});
        const filteredEnvelope = (0, $6eda0c2a5c5e65e3$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            // Don't record outcomes for client reports - we don't want to create a feedback loop if client reports themselves fail to send
            if ((0, $6eda0c2a5c5e65e3$export$604a45d95a155e2b)(filteredEnvelope, [
                'client_report'
            ])) {
                (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Dropping client report. Will not send outcomes (reason: ${reason}).`);
                return;
            }
            (0, $6eda0c2a5c5e65e3$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                options.recordDroppedEvent(reason, (0, $6eda0c2a5c5e65e3$export$b11169581eeaf237)(type));
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $6eda0c2a5c5e65e3$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $732464aedd6fa599$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error('Encountered error running transport request:', error);
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error === (0, $da9c6caf9b214510$export$c8667f1887a128dc)) {
                (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return Promise.resolve({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $02f4489ee3ea240a$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $906abfdc43292150$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $6eda0c2a5c5e65e3$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}















/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $f82f813dd4c18ebe$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    try {
        const result = $f82f813dd4c18ebe$var$_notifyEventProcessors(event, hint, processors, index);
        return (0, $057f17bbb7048b01$export$f5b060c2914b97c8)(result) ? result : (0, $91d0d788d64d0c3d$export$1fda8aa4d135f8aa)(result);
    } catch (error) {
        return (0, $91d0d788d64d0c3d$export$78e43115b553f358)(error);
    }
}
function $f82f813dd4c18ebe$var$_notifyEventProcessors(event, hint, processors, index) {
    const processor = processors[index];
    if (!event || !processor) return event;
    const result = processor({
        ...event
    }, hint);
    (0, $e74753b69eef4000$export$16a28057038b10ef) && result === null && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Event processor "${processor.id || '?'}" dropped event`);
    if ((0, $057f17bbb7048b01$export$f5b060c2914b97c8)(result)) return result.then((final)=>$f82f813dd4c18ebe$var$_notifyEventProcessors(final, hint, processors, index + 1));
    return $f82f813dd4c18ebe$var$_notifyEventProcessors(result, hint, processors, index + 1);
}





let $e8dc112258264c69$var$parsedStackResults;
let $e8dc112258264c69$var$lastSentryKeysCount;
let $e8dc112258264c69$var$lastNativeKeysCount;
let $e8dc112258264c69$var$cachedFilenameDebugIds;
/**
 * Returns a map of filenames to debug identifiers.
 * Supports both proprietary _sentryDebugIds and native _debugIds (e.g., from Vercel) formats.
 */ function $e8dc112258264c69$export$e069fee9c632ed00(stackParser) {
    const sentryDebugIdMap = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1)._sentryDebugIds;
    const nativeDebugIdMap = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1)._debugIds;
    if (!sentryDebugIdMap && !nativeDebugIdMap) return {};
    const sentryDebugIdKeys = sentryDebugIdMap ? Object.keys(sentryDebugIdMap) : [];
    const nativeDebugIdKeys = nativeDebugIdMap ? Object.keys(nativeDebugIdMap) : [];
    // If the count of registered globals hasn't changed since the last call, we
    // can just return the cached result.
    if ($e8dc112258264c69$var$cachedFilenameDebugIds && sentryDebugIdKeys.length === $e8dc112258264c69$var$lastSentryKeysCount && nativeDebugIdKeys.length === $e8dc112258264c69$var$lastNativeKeysCount) return $e8dc112258264c69$var$cachedFilenameDebugIds;
    $e8dc112258264c69$var$lastSentryKeysCount = sentryDebugIdKeys.length;
    $e8dc112258264c69$var$lastNativeKeysCount = nativeDebugIdKeys.length;
    // Build a map of filename -> debug_id from both sources
    $e8dc112258264c69$var$cachedFilenameDebugIds = {};
    if (!$e8dc112258264c69$var$parsedStackResults) $e8dc112258264c69$var$parsedStackResults = {};
    const processDebugIds = (debugIdKeys, debugIdMap)=>{
        for (const key of debugIdKeys){
            const debugId = debugIdMap[key];
            const result = $e8dc112258264c69$var$parsedStackResults?.[key];
            if (result && $e8dc112258264c69$var$cachedFilenameDebugIds && debugId) {
                // Use cached filename but update with current debug ID
                $e8dc112258264c69$var$cachedFilenameDebugIds[result[0]] = debugId;
                // Update cached result with new debug ID
                if ($e8dc112258264c69$var$parsedStackResults) $e8dc112258264c69$var$parsedStackResults[key] = [
                    result[0],
                    debugId
                ];
            } else if (debugId) {
                const parsedStack = stackParser(key);
                for(let i = parsedStack.length - 1; i >= 0; i--){
                    const stackFrame = parsedStack[i];
                    const filename = stackFrame?.filename;
                    if (filename && $e8dc112258264c69$var$cachedFilenameDebugIds && $e8dc112258264c69$var$parsedStackResults) {
                        $e8dc112258264c69$var$cachedFilenameDebugIds[filename] = debugId;
                        $e8dc112258264c69$var$parsedStackResults[key] = [
                            filename,
                            debugId
                        ];
                        break;
                    }
                }
            }
        }
    };
    if (sentryDebugIdMap) processDebugIds(sentryDebugIdKeys, sentryDebugIdMap);
    // Native _debugIds will override _sentryDebugIds if same file
    if (nativeDebugIdMap) processDebugIds(nativeDebugIdKeys, nativeDebugIdMap);
    return $e8dc112258264c69$var$cachedFilenameDebugIds;
}
/**
 * Returns a list of debug images for the given resources.
 */ function $e8dc112258264c69$export$5a7368330d9ee6e3(stackParser, resource_paths) {
    const filenameDebugIdMap = $e8dc112258264c69$export$e069fee9c632ed00(stackParser);
    if (!filenameDebugIdMap) return [];
    const images = [];
    for (const path of resource_paths){
        const normalizedPath = (0, $7a317b2b764bd658$export$60c0d6c8e038267a)(path);
        if (normalizedPath && filenameDebugIdMap[normalizedPath]) images.push({
            type: 'sourcemap',
            code_file: path,
            debug_id: filenameDebugIdMap[normalizedPath]
        });
    }
    return images;
}







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $a58af1770cf64326$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $4da1f60d556678ad$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $906abfdc43292150$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $a58af1770cf64326$export$d7e04067a6fbc882(prepared, options);
    $a58af1770cf64326$var$applyIntegrationsMetadata(prepared, integrations);
    if (client) client.emit('applyFrameMetadata', event);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $a58af1770cf64326$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $a58af1770cf64326$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Scope.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $caa3e3e5ebbbdd71$export$cc422922fcbb91c6)(isolationScope, finalScope);
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $caa3e3e5ebbbdd71$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $f82f813dd4c18ebe$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $a58af1770cf64326$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $a58af1770cf64326$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 * Enhances event using the client configuration.
 * It takes care of all "static" values like environment, release and `dist`,
 * as well as truncating overly long values.
 *
 * Only exported for tests.
 *
 * @param event event instance to be enhanced
 */ function $a58af1770cf64326$export$d7e04067a6fbc882(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength } = options;
    // empty strings do not make sense for environment, release, and dist
    // so we handle them the same as if they were not provided
    event.environment = event.environment || environment || (0, $2a9a4c4c0dffc99b$export$849dbeeeda01ae98);
    if (!event.release && release) event.release = release;
    if (!event.dist && dist) event.dist = dist;
    const request = event.request;
    if (request?.url && maxValueLength) request.url = (0, $ff73814e958d28bd$export$6a506b36fdea397d)(request.url, maxValueLength);
    if (maxValueLength) event.exception?.values?.forEach((exception)=>{
        if (exception.value) // Truncates error messages
        exception.value = (0, $ff73814e958d28bd$export$6a506b36fdea397d)(exception.value, maxValueLength);
    });
}
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $a58af1770cf64326$export$63042efc86f043e7(event, stackParser) {
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = (0, $e8dc112258264c69$export$e069fee9c632ed00)(stackParser);
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
        });
    });
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $a58af1770cf64326$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    event.exception?.values?.forEach((exception)=>{
        exception.stacktrace?.frames?.forEach((frame)=>{
            if (frame.debug_id) {
                if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                delete frame.debug_id;
            }
        });
    });
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.entries(filenameDebugIdMap).forEach(([filename, debug_id])=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: debug_id
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $a58af1770cf64326$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $a58af1770cf64326$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $8f8ce6efe9d68113$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $8f8ce6efe9d68113$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $8f8ce6efe9d68113$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $8f8ce6efe9d68113$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts?.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $8f8ce6efe9d68113$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $8f8ce6efe9d68113$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    // event.contexts.flags (FeatureFlagContext) stores context for our feature
    // flag integrations. It has a greater nesting depth than our other typed
    // Contexts, so we re-normalize with a fixed depth of 3 here. We do not want
    // to skip this in case of conflicting, user-provided context.
    if (event.contexts?.flags && normalized.contexts) normalized.contexts.flags = (0, $8f8ce6efe9d68113$export$a3295358bff77e)(event.contexts.flags, 3, maxBreadth);
    return normalized;
}
function $a58af1770cf64326$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $3503af534c878a78$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $a58af1770cf64326$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($a58af1770cf64326$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($a58af1770cf64326$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $a58af1770cf64326$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $3503af534c878a78$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $a58af1770cf64326$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'propagationContext'
];
function $a58af1770cf64326$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$a58af1770cf64326$var$captureContextKeys.includes(key));
}








/**
 * Converts a transaction event to a span JSON object.
 */ function $29dc9bdb9dd8c6ad$export$d9c6b2464b0a687e(event) {
    const { trace_id: trace_id, parent_span_id: parent_span_id, span_id: span_id, status: status, origin: origin, data: data, op: op } = event.contexts?.trace ?? {};
    return {
        data: data ?? {},
        description: event.transaction,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id ?? '',
        start_timestamp: event.start_timestamp ?? 0,
        status: status,
        timestamp: event.timestamp,
        trace_id: trace_id ?? '',
        origin: origin,
        profile_id: data?.[0, $d06802d0f59b2c9f$export$1efec95406bbe327],
        exclusive_time: data?.[0, $d06802d0f59b2c9f$export$fea48ba9f4550879],
        measurements: event.measurements,
        is_segment: true
    };
}
/**
 * Converts a span JSON object to a transaction event.
 */ function $29dc9bdb9dd8c6ad$export$f2d8fce5ae150e92(span) {
    return {
        type: 'transaction',
        timestamp: span.timestamp,
        start_timestamp: span.start_timestamp,
        transaction: span.description,
        contexts: {
            trace: {
                trace_id: span.trace_id,
                span_id: span.span_id,
                parent_span_id: span.parent_span_id,
                op: span.op,
                status: span.status,
                origin: span.origin,
                data: {
                    ...span.data,
                    ...span.profile_id && {
                        [(0, $d06802d0f59b2c9f$export$1efec95406bbe327)]: span.profile_id
                    },
                    ...span.exclusive_time && {
                        [(0, $d06802d0f59b2c9f$export$fea48ba9f4550879)]: span.exclusive_time
                    }
                }
            }
        },
        measurements: span.measurements
    };
}


/* eslint-disable max-lines */ const $404620d4746f08bf$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
const $404620d4746f08bf$var$MISSING_RELEASE_FOR_SESSION_ERROR = 'Discarded session because of missing or non-string release';
const $404620d4746f08bf$var$INTERNAL_ERROR_SYMBOL = Symbol.for('SentryInternalError');
const $404620d4746f08bf$var$DO_NOT_SEND_EVENT_SYMBOL = Symbol.for('SentryDoNotSendEventError');
// Default interval for flushing logs and metrics (5 seconds)
const $404620d4746f08bf$var$DEFAULT_FLUSH_INTERVAL = 5000;
function $404620d4746f08bf$var$_makeInternalError(message) {
    return {
        message: message,
        [$404620d4746f08bf$var$INTERNAL_ERROR_SYMBOL]: true
    };
}
function $404620d4746f08bf$var$_makeDoNotSendEventError(message) {
    return {
        message: message,
        [$404620d4746f08bf$var$DO_NOT_SEND_EVENT_SYMBOL]: true
    };
}
function $404620d4746f08bf$var$_isInternalError(error) {
    return !!error && typeof error === 'object' && $404620d4746f08bf$var$INTERNAL_ERROR_SYMBOL in error;
}
function $404620d4746f08bf$var$_isDoNotSendEventError(error) {
    return !!error && typeof error === 'object' && $404620d4746f08bf$var$DO_NOT_SEND_EVENT_SYMBOL in error;
}
/**
 * Sets up weight-based flushing for logs or metrics.
 * This helper function encapsulates the common pattern of:
 * 1. Tracking accumulated weight of items
 * 2. Flushing when weight exceeds threshold (800KB)
 * 3. Flushing after timeout period from the first item
 *
 * Uses closure variables to track weight and timeout state.
 */ function $404620d4746f08bf$var$setupWeightBasedFlushing(client, afterCaptureHook, flushHook, estimateSizeFn, flushFn) {
    // Track weight and timeout in closure variables
    let weight = 0;
    let flushTimeout;
    let isTimerActive = false;
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(flushHook, ()=>{
        weight = 0;
        clearTimeout(flushTimeout);
        isTimerActive = false;
    });
    // @ts-expect-error - TypeScript can't narrow generic hook types to match specific overloads, but we know this is type-safe
    client.on(afterCaptureHook, (item)=>{
        weight += estimateSizeFn(item);
        // We flush the buffer if it exceeds 0.8 MB
        // The weight is a rough estimate, so we flush way before the payload gets too big.
        if (weight >= 800000) flushFn(client);
        else if (!isTimerActive) {
            // Only start timer if one isn't already running.
            // This prevents flushing being delayed by items that arrive close to the timeout limit
            // and thus resetting the flushing timeout and delaying items being flushed.
            isTimerActive = true;
            flushTimeout = setTimeout(()=>{
                flushFn(client);
            // Note: isTimerActive is reset by the flushHook handler above, not here,
            // to avoid race conditions when new items arrive during the flush.
            }, $404620d4746f08bf$var$DEFAULT_FLUSH_INTERVAL);
        }
    });
    client.on('flush', ()=>{
        flushFn(client);
    });
}
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link Client._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends Client<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $404620d4746f08bf$export$1f2bb630327ac4b6 {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        this._promiseBuffer = (0, $da9c6caf9b214510$export$85a4f67f852183e6)(options.transportOptions?.bufferSize ?? (0, $9c0afdbdc0ce2604$export$e515cf6dfd2f98b8));
        if (options.dsn) this._dsn = (0, $8ef4a8c4a6476e0c$export$128827c3562ec0cb)(options.dsn);
        else (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $313c552b52876041$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
        // Backfill enableLogs option from _experiments.enableLogs
        // TODO(v11): Remove or change default value
        // eslint-disable-next-line deprecation/deprecation
        this._options.enableLogs = this._options.enableLogs ?? this._options._experiments?.enableLogs;
        // Setup log flushing with weight and timeout tracking
        if (this._options.enableLogs) $404620d4746f08bf$var$setupWeightBasedFlushing(this, 'afterCaptureLog', 'flushLogs', $404620d4746f08bf$var$estimateLogSizeInBytes, (0, $0a259c8ca224b0c2$export$f8ed83d3b6a0b504));
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = this._options.enableMetrics ?? this._options._experiments?.enableMetrics ?? true;
        // Setup metric flushing with weight and timeout tracking
        if (enableMetrics) $404620d4746f08bf$var$setupWeightBasedFlushing(this, 'afterCaptureMetric', 'flushMetrics', $404620d4746f08bf$var$estimateMetricSizeInBytes, (0, $c775830d1e8c2972$export$91c9ef254b7d0f67));
    }
    /**
   * Captures an exception event and sends it to Sentry.
   *
   * Unlike `captureException` exported from every SDK, this method requires that you pass it the current scope.
   */ captureException(exception, hint, scope) {
        const eventId = (0, $4da1f60d556678ad$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $4da1f60d556678ad$export$6de4ffac6a2f1098)(exception)) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log($404620d4746f08bf$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(()=>this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)).then((res)=>res), 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a message event and sends it to Sentry.
   *
   * Unlike `captureMessage` exported from every SDK, this method requires that you pass it the current scope.
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $4da1f60d556678ad$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $057f17bbb7048b01$export$dbcbffa59149b824)(message) ? message : String(message);
        const isMessage = (0, $057f17bbb7048b01$export$c3825b437cbdea5c)(message);
        const promisedEvent = isMessage ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(()=>promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)), isMessage ? 'unknown' : 'error');
        return hintWithEventId.event_id;
    }
    /**
   * Captures a manually created event and sends it to Sentry.
   *
   * Unlike `captureEvent` exported from every SDK, this method requires that you pass it the current scope.
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $4da1f60d556678ad$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint?.originalException && (0, $4da1f60d556678ad$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log($404620d4746f08bf$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        const dataCategory = $404620d4746f08bf$var$getDataCategoryByType(event.type);
        this._process(()=>this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope, capturedSpanIsolationScope), dataCategory);
        return hintWithEventId.event_id;
    }
    /**
   * Captures a session.
   */ captureSession(session) {
        this.sendSession(session);
        // After sending, we set init false to indicate it's not the first occurrence
        (0, $c02b5704ee22c2a7$export$531818e825e774db)(session, {
            init: false
        });
    }
    /**
   * Create a cron monitor check in and send it to Sentry. This method is not available on all clients.
   *
   * @param checkIn An object that describes a check in.
   * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
   * to create a monitor automatically when sending a check in.
   * @param scope An optional scope containing event metadata.
   * @returns A string representing the id of the check in.
   */ /**
   * Get the current Dsn.
   */ getDsn() {
        return this._dsn;
    }
    /**
   * Get the current options.
   */ getOptions() {
        return this._options;
    }
    /**
   * Get the SDK metadata.
   * @see SdkMetadata
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * Returns the transport that is used by the client.
   * Please note that the transport gets lazy initialized so it will only be there once the first event has been sent.
   */ getTransport() {
        return this._transport;
    }
    /**
   * Wait for all events to be sent or the timeout to expire, whichever comes first.
   *
   * @param timeout Maximum time in ms the client should wait for events to be flushed. Omitting this parameter will
   *   cause the client to wait until all events are sent before resolving the promise.
   * @returns A promise that will resolve with `true` if all events are sent before the timeout, or `false` if there are
   * still events in the queue when the timeout is reached.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async flush(timeout) {
        const transport = this._transport;
        if (!transport) return true;
        this.emit('flush');
        const clientFinished = await this._isClientDoneProcessing(timeout);
        const transportFlushed = await transport.flush(timeout);
        return clientFinished && transportFlushed;
    }
    /**
   * Flush the event queue and set the client to `enabled = false`. See {@link Client.flush}.
   *
   * @param {number} timeout Maximum time in ms the client should wait before shutting down. Omitting this parameter will cause
   *   the client to wait until all events are sent before disabling itself.
   * @returns {Promise<boolean>} A promise which resolves to `true` if the flush completes successfully before the timeout, or `false` if
   * it doesn't.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async close(timeout) {
        const result = await this.flush(timeout);
        this.getOptions().enabled = false;
        this.emit('close');
        return result;
    }
    /**
   * Get all installed event processors.
   */ getEventProcessors() {
        return this._eventProcessors;
    }
    /**
   * Adds an event processor that applies to any event processed by this client.
   */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * Initialize this client.
   * Call this after the client was set on a scope.
   */ init() {
        if (this._isEnabled() || // Force integrations to be setup even if no DSN was set when we have
        // Spotlight enabled. This is particularly important for browser as we
        // don't support the `spotlight` option there and rely on the users
        // adding the `spotlightBrowserIntegration()` to their integrations which
        // wouldn't get initialized with the check below when there's no DSN set.
        this._options.integrations.some(({ name: name })=>name.startsWith('Spotlight'))) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns {Integration|undefined} The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Add an integration to the client.
   * This can be used to e.g. lazy load integrations.
   * In most cases, this should not be necessary,
   * and you're better off just passing the integrations via `integrations: []` at initialization time.
   * However, if you find the need to conditionally load & add an integration, you can use `addIntegration` to do so.
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $00abeec2398bba5c$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $00abeec2398bba5c$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * Send a fully prepared event to Sentry.
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $d77a84de84103d0a$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $6eda0c2a5c5e65e3$export$d650323442802f6f)(env, (0, $6eda0c2a5c5e65e3$export$d8fc80952cc31fa4)(attachment));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env).then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse));
    }
    /**
   * Send a session or session aggregrates to Sentry.
   */ sendSession(session) {
        // Backfill release and environment on session
        const { release: clientReleaseOption, environment: clientEnvironmentOption = (0, $2a9a4c4c0dffc99b$export$849dbeeeda01ae98) } = this._options;
        if ('aggregates' in session) {
            const sessionAttrs = session.attrs || {};
            if (!sessionAttrs.release && !clientReleaseOption) {
                (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn($404620d4746f08bf$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            sessionAttrs.release = sessionAttrs.release || clientReleaseOption;
            sessionAttrs.environment = sessionAttrs.environment || clientEnvironmentOption;
            session.attrs = sessionAttrs;
        } else {
            if (!session.release && !clientReleaseOption) {
                (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn($404620d4746f08bf$var$MISSING_RELEASE_FOR_SESSION_ERROR);
                return;
            }
            session.release = session.release || clientReleaseOption;
            session.environment = session.environment || clientEnvironmentOption;
        }
        this.emit('beforeSendSession', session);
        const env = (0, $d77a84de84103d0a$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * Record on the client that an event got dropped (ie, an event that will not be sent to Sentry).
   */ recordDroppedEvent(reason, category, count = 1) {
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /* eslint-disable @typescript-eslint/unified-signatures */ /**
   * Register a callback for whenever a span is started.
   * Receives the span as argument.
   * @returns {() => void} A function that, when executed, removes the registered callback.
   */ /**
   * Register a hook on this client.
   */ on(hook, callback) {
        const hookCallbacks = this._hooks[hook] = this._hooks[hook] || new Set();
        // Wrap the callback in a function so that registering the same callback instance multiple
        // times results in the callback being called multiple times.
        // @ts-expect-error - The `callback` type is correct and must be a function due to the
        // individual, specific overloads of this function.
        // eslint-disable-next-line @typescript-eslint/ban-types
        const uniqueCallback = (...args)=>callback(...args);
        hookCallbacks.add(uniqueCallback);
        // This function returns a callback execution handler that, when invoked,
        // deregisters a callback. This is crucial for managing instances where callbacks
        // need to be unregistered to prevent self-referencing in callback closures,
        // ensuring proper garbage collection.
        return ()=>{
            hookCallbacks.delete(uniqueCallback);
        };
    }
    /** Fire a hook whenever a span starts. */ /**
   * Emit a hook that was previously registered via `on()`.
   */ emit(hook, ...rest) {
        const callbacks = this._hooks[hook];
        if (callbacks) callbacks.forEach((callback)=>callback(...rest));
    }
    /**
   * Send an envelope to Sentry.
   */ // @ts-expect-error - PromiseLike is a subset of Promise
    async sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) try {
            return await this._transport.send(envelope);
        } catch (reason) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error('Error while sending envelope:', reason);
            return {};
        }
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error('Transport disabled');
        return {};
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $00abeec2398bba5c$export$51abed9797baa598)(this, integrations);
        (0, $00abeec2398bba5c$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        // initially, set `crashed` based on the event level and update from exceptions if there are any later on
        let crashed = event.level === 'fatal';
        let errored = false;
        const exceptions = event.exception?.values;
        if (exceptions) {
            errored = true;
            // reset crashed to false if there are exceptions, to ensure `mechanism.handled` is respected.
            crashed = false;
            for (const ex of exceptions)if (ex.mechanism?.handled === false) {
                crashed = true;
                break;
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $c02b5704ee22c2a7$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ async _isClientDoneProcessing(timeout) {
        let ticked = 0;
        // if no timeout is provided, we wait "forever" until everything is processed
        while(!timeout || ticked < timeout){
            await new Promise((resolve)=>setTimeout(resolve, 1));
            if (!this._numProcessing) return true;
            ticked++;
        }
        return false;
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations?.length) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $a58af1770cf64326$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            this.emit('postprocessEvent', evt, hint);
            evt.contexts = {
                trace: (0, $64ff6138fe06e713$export$1e83db7ee4876dc4)(currentScope),
                ...evt.contexts
            };
            const dynamicSamplingContext = (0, $175980fe5a84e4c5$export$89ef1736f08c6b2b)(this, currentScope);
            evt.sdkProcessingMetadata = {
                dynamicSamplingContext: dynamicSamplingContext,
                ...evt.sdkProcessingMetadata
            };
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, currentScope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)(), isolationScope = (0, $64ff6138fe06e713$export$68f3af03034c9e90)()) {
        if ((0, $e74753b69eef4000$export$16a28057038b10ef) && $404620d4746f08bf$var$isErrorEvent(event)) (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Captured error event \`${(0, $c63d95a8106631de$export$d55a97c329cacfcc)(event)[0] || '<unknown>'}\``);
        return this._processEvent(event, hint, currentScope, isolationScope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $e74753b69eef4000$export$16a28057038b10ef) {
                if ($404620d4746f08bf$var$_isDoNotSendEventError(reason)) (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(reason.message);
                else if ($404620d4746f08bf$var$_isInternalError(reason)) (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(reason.message);
                else (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(reason);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope, isolationScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $404620d4746f08bf$var$isTransactionEvent(event);
        const isError = $404620d4746f08bf$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $f99dcce240975486$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && (0, $3ce37121dbb69e34$export$9869d72de32a3917)() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error');
            return (0, $91d0d788d64d0c3d$export$78e43115b553f358)($404620d4746f08bf$var$_makeDoNotSendEventError(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`));
        }
        const dataCategory = $404620d4746f08bf$var$getDataCategoryByType(event.type);
        return this._prepareEvent(event, hint, currentScope, isolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory);
                throw $404620d4746f08bf$var$_makeDoNotSendEventError('An event processor returned `null`, will not send event.');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $404620d4746f08bf$var$processBeforeSend(this, options, prepared, hint);
            return $404620d4746f08bf$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw $404620d4746f08bf$var$_makeDoNotSendEventError(`${beforeSendLabel} returned \`null\`, will not send event.`);
            }
            const session = currentScope.getSession() || isolationScope.getSession();
            if (isError && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata?.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if ($404620d4746f08bf$var$_isDoNotSendEventError(reason) || $404620d4746f08bf$var$_isInternalError(reason)) throw reason;
            this.captureException(reason, {
                mechanism: {
                    handled: false,
                    type: 'internal'
                },
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw $404620d4746f08bf$var$_makeInternalError(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(taskProducer, dataCategory) {
        this._numProcessing++;
        this._promiseBuffer.add(taskProducer).then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            if (reason === (0, $da9c6caf9b214510$export$c8667f1887a128dc)) this.recordDroppedEvent('queue_overflow', dataCategory);
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.entries(outcomes).map(([key, quantity])=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: quantity
            };
        });
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('Flushing outcomes...');
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('Sending outcomes:', outcomes);
        const envelope = (0, $02f4489ee3ea240a$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $8ef4a8c4a6476e0c$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}
function $404620d4746f08bf$var$getDataCategoryByType(type) {
    return type === 'replay_event' ? 'replay' : type || 'error';
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $404620d4746f08bf$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $057f17bbb7048b01$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $057f17bbb7048b01$export$53b83ca8eaab0383)(event) && event !== null) throw $404620d4746f08bf$var$_makeInternalError(invalidValueError);
        return event;
    }, (e)=>{
        throw $404620d4746f08bf$var$_makeInternalError(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $057f17bbb7048b01$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw $404620d4746f08bf$var$_makeInternalError(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $404620d4746f08bf$var$processBeforeSend(client, options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan, ignoreSpans: ignoreSpans } = options;
    let processedEvent = event;
    if ($404620d4746f08bf$var$isErrorEvent(processedEvent) && beforeSend) return beforeSend(processedEvent, hint);
    if ($404620d4746f08bf$var$isTransactionEvent(processedEvent)) {
        // Avoid processing if we don't have to
        if (beforeSendSpan || ignoreSpans) {
            // 1. Process root span
            const rootSpanJson = (0, $29dc9bdb9dd8c6ad$export$d9c6b2464b0a687e)(processedEvent);
            // 1.1 If the root span should be ignored, drop the whole transaction
            if (ignoreSpans?.length && (0, $c71ed437cb7ccf8a$export$5d569ac97c389400)(rootSpanJson, ignoreSpans)) // dropping the whole transaction!
            return null;
            // 1.2 If a `beforeSendSpan` callback is defined, process the root span
            if (beforeSendSpan) {
                const processedRootSpanJson = beforeSendSpan(rootSpanJson);
                if (!processedRootSpanJson) (0, $122b7a6129e42fb6$export$d11691ff45a3e535)();
                else // update event with processed root span values
                processedEvent = (0, $9392a3c1760ef37e$export$4950aa0f605343fb)(event, (0, $29dc9bdb9dd8c6ad$export$f2d8fce5ae150e92)(processedRootSpanJson));
            }
            // 2. Process child spans
            if (processedEvent.spans) {
                const processedSpans = [];
                const initialSpans = processedEvent.spans;
                for (const span of initialSpans){
                    // 2.a If the child span should be ignored, reparent it to the root span
                    if (ignoreSpans?.length && (0, $c71ed437cb7ccf8a$export$5d569ac97c389400)(span, ignoreSpans)) {
                        (0, $c71ed437cb7ccf8a$export$ddf57376e818b444)(initialSpans, span);
                        continue;
                    }
                    // 2.b If a `beforeSendSpan` callback is defined, process the child span
                    if (beforeSendSpan) {
                        const processedSpan = beforeSendSpan(span);
                        if (!processedSpan) {
                            (0, $122b7a6129e42fb6$export$d11691ff45a3e535)();
                            processedSpans.push(span);
                        } else processedSpans.push(processedSpan);
                    } else processedSpans.push(span);
                }
                const droppedSpans = processedEvent.spans.length - processedSpans.length;
                if (droppedSpans) client.recordDroppedEvent('before_send', 'span', droppedSpans);
                processedEvent.spans = processedSpans;
            }
        }
        if (beforeSendTransaction) {
            if (processedEvent.spans) {
                // We store the # of spans before processing in SDK metadata,
                // so we can compare it afterwards to determine how many spans were dropped
                const spanCountBefore = processedEvent.spans.length;
                processedEvent.sdkProcessingMetadata = {
                    ...event.sdkProcessingMetadata,
                    spanCountBeforeProcessing: spanCountBefore
                };
            }
            return beforeSendTransaction(processedEvent, hint);
        }
    }
    return processedEvent;
}
function $404620d4746f08bf$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $404620d4746f08bf$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Estimate the size of a metric in bytes.
 *
 * @param metric - The metric to estimate the size of.
 * @returns The estimated size of the metric in bytes.
 */ function $404620d4746f08bf$var$estimateMetricSizeInBytes(metric) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (metric.name) weight += metric.name.length * 2;
    // Add weight for number
    weight += 8;
    return weight + $404620d4746f08bf$var$estimateAttributesSizeInBytes(metric.attributes);
}
/**
 * Estimate the size of a log in bytes.
 *
 * @param log - The log to estimate the size of.
 * @returns The estimated size of the log in bytes.
 */ function $404620d4746f08bf$var$estimateLogSizeInBytes(log) {
    let weight = 0;
    // Estimate byte size of 2 bytes per character. This is a rough estimate JS strings are stored as UTF-16.
    if (log.message) weight += log.message.length * 2;
    return weight + $404620d4746f08bf$var$estimateAttributesSizeInBytes(log.attributes);
}
/**
 * Estimate the size of attributes in bytes.
 *
 * @param attributes - The attributes object to estimate the size of.
 * @returns The estimated size of the attributes in bytes.
 */ function $404620d4746f08bf$var$estimateAttributesSizeInBytes(attributes) {
    if (!attributes) return 0;
    let weight = 0;
    Object.values(attributes).forEach((value)=>{
        if (Array.isArray(value)) weight += value.length * $404620d4746f08bf$var$estimatePrimitiveSizeInBytes(value[0]);
        else if ((0, $057f17bbb7048b01$export$c3825b437cbdea5c)(value)) weight += $404620d4746f08bf$var$estimatePrimitiveSizeInBytes(value);
        else // For objects values, we estimate the size of the object as 100 bytes
        weight += 100;
    });
    return weight;
}
function $404620d4746f08bf$var$estimatePrimitiveSizeInBytes(value) {
    if (typeof value === 'string') return value.length * 2;
    else if (typeof value === 'number') return 8;
    else if (typeof value === 'boolean') return 4;
    return 0;
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `debug` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $aeff4153c130a48e$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $aeff4153c130a48e$export$8ad33f488b1ab046() {
    // This comment is used to identify this line in the CDN bundle build step and replace this with "return 'cdn';"
    /* __SENTRY_SDK_SOURCE__ */ return 'npm';
}






/**
 * Extracts stack frames from the error.stack string
 */ function $4908e2bf1e7559ed$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
function $4908e2bf1e7559ed$var$hasSentryFetchUrlHost(error) {
    return (0, $057f17bbb7048b01$export$e6127cc7fe7395c3)(error) && '__sentry_fetch_url_host__' in error && typeof error.__sentry_fetch_url_host__ === 'string';
}
/**
 * Enhances the error message with the hostname for better Sentry error reporting.
 * This allows third-party packages to still match on the original error message,
 * while Sentry gets the enhanced version with context.
 *
 * Only used internally
 * @hidden
 */ function $4908e2bf1e7559ed$export$35a730c8874c1024(error) {
    // If the error has a __sentry_fetch_url_host__ property (added by fetch instrumentation),
    // enhance the error message with the hostname.
    if ($4908e2bf1e7559ed$var$hasSentryFetchUrlHost(error)) return `${error.message} (${error.__sentry_fetch_url_host__})`;
    return error.message;
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $4908e2bf1e7559ed$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: $4908e2bf1e7559ed$export$35a730c8874c1024(error)
    };
    const frames = $4908e2bf1e7559ed$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
/** If a plain object has a property that is an `Error`, return this error. */ function $4908e2bf1e7559ed$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}
function $4908e2bf1e7559ed$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    const keys = (0, $085a6ebfb8b9293d$export$b0244d5063c0b61b)(exception);
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $057f17bbb7048b01$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as exception with message \`${exception.message}\``;
    const className = $4908e2bf1e7559ed$var$getObjectClassName(exception);
    return `${className && className !== 'Object' ? `'${className}'` : 'Object'} captured as exception with keys: ${keys}`;
}
function $4908e2bf1e7559ed$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
function $4908e2bf1e7559ed$var$getException(client, mechanism, exception, hint) {
    if ((0, $057f17bbb7048b01$export$e6127cc7fe7395c3)(exception)) return [
        exception,
        undefined
    ];
    // Mutate this!
    mechanism.synthetic = true;
    if ((0, $057f17bbb7048b01$export$53b83ca8eaab0383)(exception)) {
        const normalizeDepth = client?.getOptions().normalizeDepth;
        const extras = {
            ['__serialized__']: (0, $8f8ce6efe9d68113$export$23fbbb20bed71033)(exception, normalizeDepth)
        };
        const errorFromProp = $4908e2bf1e7559ed$var$getErrorPropertyFromObject(exception);
        if (errorFromProp) return [
            errorFromProp,
            extras
        ];
        const message = $4908e2bf1e7559ed$var$getMessageForObject(exception);
        const ex = hint?.syntheticException || new Error(message);
        ex.message = message;
        return [
            ex,
            extras
        ];
    }
    // This handles when someone does: `throw "something awesome";`
    // We use synthesized Error here so we can extract a (rough) stack trace.
    const ex = hint?.syntheticException || new Error(exception);
    ex.message = `${exception}`;
    return [
        ex,
        undefined
    ];
}
/**
 * Builds and Event from a Exception
 * @hidden
 */ function $4908e2bf1e7559ed$export$9dd56ed1ef0c3420(client, stackParser, exception, hint) {
    const providedMechanism = hint?.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    const [ex, extras] = $4908e2bf1e7559ed$var$getException(client, mechanism, exception, hint);
    const event = {
        exception: {
            values: [
                $4908e2bf1e7559ed$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $4da1f60d556678ad$export$f26508487bf83ee7)(event, undefined, undefined);
    (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(event, mechanism);
    return {
        ...event,
        event_id: hint?.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $4908e2bf1e7559ed$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint?.event_id,
        level: level
    };
    if (attachStacktrace && hint?.syntheticException) {
        const frames = $4908e2bf1e7559ed$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) {
            event.exception = {
                values: [
                    {
                        value: message,
                        stacktrace: {
                            frames: frames
                        }
                    }
                ]
            };
            (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(event, {
                synthetic: true
            });
        }
    }
    if ((0, $057f17bbb7048b01$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}


/**
 * This function creates an exception from a JavaScript Error
 */ function $d85fd2ab7f9a30e0$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $d85fd2ab7f9a30e0$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: $d85fd2ab7f9a30e0$export$2e9ae379995d99e3(ex),
        value: $d85fd2ab7f9a30e0$export$86005d1b62804363(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $d85fd2ab7f9a30e0$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    const normalizeDepth = client?.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $d85fd2ab7f9a30e0$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $8f8ce6efe9d68113$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $d85fd2ab7f9a30e0$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $057f17bbb7048b01$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $d85fd2ab7f9a30e0$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $d85fd2ab7f9a30e0$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $d85fd2ab7f9a30e0$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $d85fd2ab7f9a30e0$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $d85fd2ab7f9a30e0$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $d85fd2ab7f9a30e0$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $d85fd2ab7f9a30e0$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch  {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $d85fd2ab7f9a30e0$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $d85fd2ab7f9a30e0$var$getSkipFirstStackStringLines(ex) {
    if (ex && $d85fd2ab7f9a30e0$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $d85fd2ab7f9a30e0$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
// https://developer.mozilla.org/en-US/docs/WebAssembly/JavaScript_interface/Exception
// @ts-expect-error - WebAssembly.Exception is a valid class
function $d85fd2ab7f9a30e0$var$isWebAssemblyException(exception) {
    // Check for support
    // @ts-expect-error - WebAssembly.Exception is a valid class
    if (typeof WebAssembly !== 'undefined' && typeof WebAssembly.Exception !== 'undefined') // @ts-expect-error - WebAssembly.Exception is a valid class
    return exception instanceof WebAssembly.Exception;
    else return false;
}
/**
 * Extracts from errors what we use as the exception `type` in error events.
 *
 * Usually, this is the `name` property on Error objects but WASM errors need to be treated differently.
 */ function $d85fd2ab7f9a30e0$export$2e9ae379995d99e3(ex) {
    const name = ex?.name;
    // The name for WebAssembly.Exception Errors needs to be extracted differently.
    // Context: https://github.com/getsentry/sentry-javascript/issues/13787
    if (!name && $d85fd2ab7f9a30e0$var$isWebAssemblyException(ex)) {
        // Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        const hasTypeInMessage = ex.message && Array.isArray(ex.message) && ex.message.length == 2;
        return hasTypeInMessage ? ex.message[0] : 'WebAssembly.Exception';
    }
    return name;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $d85fd2ab7f9a30e0$export$86005d1b62804363(ex) {
    const message = ex?.message;
    if ($d85fd2ab7f9a30e0$var$isWebAssemblyException(ex)) {
        // For Node 18, Emscripten sets array[type, message] to the "message" property on the WebAssembly.Exception object
        if (Array.isArray(ex.message) && ex.message.length == 2) return ex.message[1];
        return 'wasm exception';
    }
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return (0, $4908e2bf1e7559ed$export$35a730c8874c1024)(message.error);
    return (0, $4908e2bf1e7559ed$export$35a730c8874c1024)(ex);
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $d85fd2ab7f9a30e0$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $d85fd2ab7f9a30e0$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $91d0d788d64d0c3d$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $d85fd2ab7f9a30e0$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint?.syntheticException || undefined;
    const event = $d85fd2ab7f9a30e0$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint?.event_id) event.event_id = hint.event_id;
    return (0, $91d0d788d64d0c3d$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $d85fd2ab7f9a30e0$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $057f17bbb7048b01$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $d85fd2ab7f9a30e0$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $057f17bbb7048b01$export$ef9e2056653f0c8e)(exception) || (0, $057f17bbb7048b01$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $d85fd2ab7f9a30e0$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $057f17bbb7048b01$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $d85fd2ab7f9a30e0$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $4da1f60d556678ad$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $057f17bbb7048b01$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $d85fd2ab7f9a30e0$var$eventFromError(stackParser, exception);
    if ((0, $057f17bbb7048b01$export$53b83ca8eaab0383)(exception) || (0, $057f17bbb7048b01$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $d85fd2ab7f9a30e0$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $d85fd2ab7f9a30e0$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $4da1f60d556678ad$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $d85fd2ab7f9a30e0$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $d85fd2ab7f9a30e0$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
        (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
    }
    if ((0, $057f17bbb7048b01$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $d85fd2ab7f9a30e0$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $085a6ebfb8b9293d$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $057f17bbb7048b01$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $057f17bbb7048b01$export$9671ea99bd126ace)(exception)) {
        const className = $d85fd2ab7f9a30e0$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $d85fd2ab7f9a30e0$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch  {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $d85fd2ab7f9a30e0$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}













/* eslint-disable */ // Vendor "Awaited" in to be TS 3.8 compatible
/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $85962ff85718ae24$export$18ce21a8b7efd7e9(fn, onError, onFinally = ()=>{}, onSuccess = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $85962ff85718ae24$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally, onSuccess);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $85962ff85718ae24$var$maybeHandlePromiseRejection(value, onError, onFinally, onSuccess) {
    if ((0, $057f17bbb7048b01$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        onSuccess(res);
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    onSuccess(value);
    return value;
}













/**
 * Print a log message for a started span.
 */ function $e3c61abcd119b779$export$2f3d84e767c9592b(span) {
    if (!(0, $e74753b69eef4000$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $122b7a6129e42fb6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $122b7a6129e42fb6$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $122b7a6129e42fb6$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $e3c61abcd119b779$export$b77c830667a4d630(span) {
    if (!(0, $e74753b69eef4000$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $122b7a6129e42fb6$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(msg);
}






/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $184a030670a52cb1$export$5f833db634b217bb(options, samplingContext, sampleRand) {
    // nothing to do if span recording is not enabled
    if (!(0, $22da8de313ab467e$export$1f70765132c3c225)(options)) return [
        false
    ];
    let localSampleRateWasApplied = undefined;
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler({
            ...samplingContext,
            inheritOrSampleWith: (fallbackSampleRate)=>{
                // If we have an incoming parent sample rate, we'll just use that one.
                // The sampling decision will be inherited because of the sample_rand that was generated when the trace reached the incoming boundaries of the SDK.
                if (typeof samplingContext.parentSampleRate === 'number') return samplingContext.parentSampleRate;
                // Fallback if parent sample rate is not on the incoming trace (e.g. if there is no baggage)
                // This is to provide backwards compatibility if there are incoming traces from older SDKs that don't send a parent sample rate or a sample rand. In these cases we just want to force either a sampling decision on the downstream traces via the sample rate.
                if (typeof samplingContext.parentSampled === 'boolean') return Number(samplingContext.parentSampled);
                return fallbackSampleRate;
            }
        });
        localSampleRateWasApplied = true;
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        localSampleRateWasApplied = true;
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $f99dcce240975486$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`[Tracing] Discarding root span because of invalid sample rate. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate,
            localSampleRateWasApplied
        ];
    }
    // We always compare the sample rand for the current execution context against the chosen sample rate.
    // Read more: https://develop.sentry.dev/sdk/telemetry/traces/#propagated-random-value
    const shouldSample = sampleRand < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
    return [
        shouldSample,
        parsedSampleRate,
        localSampleRateWasApplied
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $8cd83374eb82db90$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $089e6aeb4531f5e4$export$295213bc4d0c54ad)();
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $122b7a6129e42fb6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
    /** @inheritDoc */ addLink(_link) {
        return this;
    }
    /** @inheritDoc */ addLinks(_links) {
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
}
















/**
 * Adds a measurement to the active transaction on the current global scope. You can optionally pass in a different span
 * as the 4th parameter.
 */ function $43046124904738ea$export$7cc31b475d33a706(name, value, unit, activeSpan = (0, $122b7a6129e42fb6$export$1be426a8e585c83e)()) {
    const rootSpan = activeSpan && (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`[Measurement] Setting measurement on root span: ${name} = ${value} ${unit}`);
        rootSpan.addEvent(name, {
            [(0, $d06802d0f59b2c9f$export$69cd5c610c7bb96a)]: value,
            [(0, $d06802d0f59b2c9f$export$f5f95cff026507b5)]: unit
        });
    }
}
/**
 * Convert timed events to measurements.
 */ function $43046124904738ea$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $d06802d0f59b2c9f$export$f5f95cff026507b5];
        const value = attributes[0, $d06802d0f59b2c9f$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}



const $5136924baff39ecb$var$MAX_SPAN_COUNT = 1000;
/**
 * Span contains all data about a span
 */ class $5136924baff39ecb$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)();
        this._spanId = spanContext.spanId || (0, $089e6aeb4531f5e4$export$295213bc4d0c54ad)();
        this._startTime = spanContext.startTimestamp || (0, $906abfdc43292150$export$ee52dced521e3e18)();
        this._links = spanContext.links;
        this._attributes = {};
        this.setAttributes({
            [(0, $d06802d0f59b2c9f$export$cca8dd30f57f805e)]: 'manual',
            [(0, $d06802d0f59b2c9f$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritDoc */ addLink(link) {
        if (this._links) this._links.push(link);
        else this._links = [
            link
        ];
        return this;
    }
    /** @inheritDoc */ addLinks(links) {
        if (this._links) this._links.push(...links);
        else this._links = links;
        return this;
    }
    /**
   * This should generally not be used,
   * but it is needed for being compliant with the OTEL Span interface.
   *
   * @hidden
   * @internal
   */ recordException(_exception, _time) {
    // noop
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $122b7a6129e42fb6$export$eb571cd9b5d98de8) : (0, $122b7a6129e42fb6$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
        return this;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
        return this;
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $122b7a6129e42fb6$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        this.setAttribute((0, $d06802d0f59b2c9f$export$d7a7d984b0791405), 'custom');
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $122b7a6129e42fb6$export$3f7581298f56c6d7)(endTimestamp);
        (0, $e3c61abcd119b779$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return {
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $d06802d0f59b2c9f$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $122b7a6129e42fb6$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $d06802d0f59b2c9f$export$cca8dd30f57f805e],
            profile_id: this._attributes[0, $d06802d0f59b2c9f$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $d06802d0f59b2c9f$export$fea48ba9f4550879],
            measurements: (0, $43046124904738ea$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined,
            links: (0, $122b7a6129e42fb6$export$cb3e3a12e0eec16c)(this._links)
        };
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('[Tracing] Adding an event to span:', name);
        const time = $5136924baff39ecb$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $906abfdc43292150$export$ee52dced521e3e18)();
        const attributes = $5136924baff39ecb$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $122b7a6129e42fb6$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            if (this._sampled) $5136924baff39ecb$var$sendSpanEnvelope((0, $d77a84de84103d0a$export$19a0081d4b39d77)([
                this
            ], client));
            else {
                (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('[Tracing] Discarding standalone span because its trace was not chosen to be sampled.');
                if (client) client.recordDroppedEvent('sample_rate', 'span');
            }
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $ecf2a0f66df9dd54$export$c08fbc656a245d03)(this).scope || (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$5136924baff39ecb$var$isFullFinishedSpan((0, $122b7a6129e42fb6$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $ecf2a0f66df9dd54$export$c08fbc656a245d03)(this);
        const normalizedRequest = capturedSpanScope?.getScopeData().sdkProcessingMetadata?.normalizedRequest;
        if (this._sampled !== true) return undefined;
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $122b7a6129e42fb6$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$5136924baff39ecb$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $122b7a6129e42fb6$export$92d8c23565496537)(span)).filter($5136924baff39ecb$var$isFullFinishedSpan);
        const source = this._attributes[0, $d06802d0f59b2c9f$export$d7a7d984b0791405];
        // remove internal root span attributes we don't need to send.
        /* eslint-disable @typescript-eslint/no-dynamic-delete */ delete this._attributes[0, $d06802d0f59b2c9f$export$165ce9a229f6f050];
        spans.forEach((span)=>{
            delete span.data[0, $d06802d0f59b2c9f$export$165ce9a229f6f050];
        });
        // eslint-enabled-next-line @typescript-eslint/no-dynamic-delete
        const transaction = {
            contexts: {
                trace: (0, $122b7a6129e42fb6$export$4c3967a8a2f6bbd6)(this)
            },
            spans: // spans.sort() mutates the array, but `spans` is already a copy so we can safely do this here
            // we do not use spans anymore after this point
            spans.length > $5136924baff39ecb$var$MAX_SPAN_COUNT ? spans.sort((a, b)=>a.start_timestamp - b.start_timestamp).slice(0, $5136924baff39ecb$var$MAX_SPAN_COUNT) : spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                dynamicSamplingContext: (0, $175980fe5a84e4c5$export$a117f995597e25df)(this)
            },
            request: normalizedRequest,
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $43046124904738ea$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('[Measurements] Adding measurements to transaction event', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $5136924baff39ecb$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $5136924baff39ecb$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $5136924baff39ecb$var$isStandaloneSpan(span) {
    return span instanceof $5136924baff39ecb$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $5136924baff39ecb$var$sendSpanEnvelope(envelope) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    // sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    client.sendEnvelope(envelope);
}




/* eslint-disable max-lines */ const $f9a78683e1667a75$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $f9a78683e1667a75$export$a1bd95187356f372(options, callback) {
    const acs = $f9a78683e1667a75$var$getAcs();
    if (acs.startSpan) return acs.startSpan(options, callback);
    const spanArguments = $f9a78683e1667a75$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    // We still need to fork a potentially passed scope, as we set the active span on it
    // and we need to ensure that it is cleaned up properly once the span ends.
    const customForkedScope = customScope?.clone();
    return (0, $64ff6138fe06e713$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $f9a78683e1667a75$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
            const parentSpan = $f9a78683e1667a75$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $8cd83374eb82db90$export$d6636b700b76c516)() : $f9a78683e1667a75$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $e57da10b3d1051db$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $85962ff85718ae24$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $122b7a6129e42fb6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $d4120bb7aba6235c$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            }, ()=>{
                activeSpan.end();
            });
        });
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. Use `span.end()` to end the span.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $f9a78683e1667a75$export$c10292ad04b92aea(options, callback) {
    const acs = $f9a78683e1667a75$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(options, callback);
    const spanArguments = $f9a78683e1667a75$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan, scope: customScope } = options;
    const customForkedScope = customScope?.clone();
    return (0, $64ff6138fe06e713$export$ec58d9285c204497)(customForkedScope, ()=>{
        // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
        const wrapper = $f9a78683e1667a75$var$getActiveSpanWrapper(customParentSpan);
        return wrapper(()=>{
            const scope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
            const parentSpan = $f9a78683e1667a75$var$getParentSpan(scope, customParentSpan);
            const shouldSkipSpan = options.onlyIfParent && !parentSpan;
            const activeSpan = shouldSkipSpan ? new (0, $8cd83374eb82db90$export$d6636b700b76c516)() : $f9a78683e1667a75$var$createChildOrRootSpan({
                parentSpan: parentSpan,
                spanArguments: spanArguments,
                forceTransaction: forceTransaction,
                scope: scope
            });
            (0, $e57da10b3d1051db$export$3f25fa50c18e20ca)(scope, activeSpan);
            return (0, $85962ff85718ae24$export$18ce21a8b7efd7e9)(// We pass the `finish` function to the callback, so the user can finish the span manually
            // this is mainly here for historic purposes because previously, we instructed users to call
            // `finish` instead of `span.end()` to also clean up the scope. Nowadays, calling `span.end()`
            // or `finish` has the same effect and we simply leave it here to avoid breaking user code.
            ()=>callback(activeSpan, ()=>activeSpan.end()), ()=>{
                // Only update the span status if it hasn't been changed yet, and the span is not yet finished
                const { status: status } = (0, $122b7a6129e42fb6$export$92d8c23565496537)(activeSpan);
                if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                    code: (0, $d4120bb7aba6235c$export$f966a0446ece71e),
                    message: 'internal_error'
                });
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $f9a78683e1667a75$export$63dbba021a6b4047(options) {
    const acs = $f9a78683e1667a75$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(options);
    const spanArguments = $f9a78683e1667a75$var$parseSentrySpanArguments(options);
    const { forceTransaction: forceTransaction, parentSpan: customParentSpan } = options;
    // If `options.scope` is defined, we use this as as a wrapper,
    // If `options.parentSpan` is defined, we want to wrap the callback in `withActiveSpan`
    const wrapper = options.scope ? (callback)=>(0, $64ff6138fe06e713$export$ec58d9285c204497)(options.scope, callback) : customParentSpan !== undefined ? (callback)=>$f9a78683e1667a75$export$e57ac09b143d92a2(customParentSpan, callback) : (callback)=>callback();
    return wrapper(()=>{
        const scope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
        const parentSpan = $f9a78683e1667a75$var$getParentSpan(scope, customParentSpan);
        const shouldSkipSpan = options.onlyIfParent && !parentSpan;
        if (shouldSkipSpan) return new (0, $8cd83374eb82db90$export$d6636b700b76c516)();
        return $f9a78683e1667a75$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanArguments: spanArguments,
            forceTransaction: forceTransaction,
            scope: scope
        });
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $f9a78683e1667a75$export$d2ee9b39b25437b3 = (options, callback)=>{
    const carrier = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    const acs = (0, $3e49a8fa7c1f2ba6$export$f639b0c2752203be)(carrier);
    if (acs.continueTrace) return acs.continueTrace(options, callback);
    const { sentryTrace: sentryTrace, baggage: baggage } = options;
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    const incomingDsc = (0, $231c50e128fa7b11$export$5b96ee2c8421f107)(baggage);
    if (client && !(0, $80a392b08eb130e9$export$18811bc99eefceaa)(client, incomingDsc?.org_id)) return $f9a78683e1667a75$export$f90b03291402f553(callback);
    return (0, $64ff6138fe06e713$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $80a392b08eb130e9$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        (0, $e57da10b3d1051db$export$3f25fa50c18e20ca)(scope, undefined);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $f9a78683e1667a75$export$e57ac09b143d92a2(span, callback) {
    const acs = $f9a78683e1667a75$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $64ff6138fe06e713$export$ec58d9285c204497)((scope)=>{
        (0, $e57da10b3d1051db$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $f9a78683e1667a75$export$869298f9835abc68(callback) {
    const acs = $f9a78683e1667a75$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $64ff6138fe06e713$export$ec58d9285c204497)((scope)=>{
        // Note: We do not wait for the callback to finish before we reset the metadata
        // the reason for this is that otherwise, in the browser this can lead to very weird behavior
        // as there is only a single top scope, if the callback takes longer to finish,
        // other, unrelated spans may also be suppressed, which we do not want
        // so instead, we only suppress tracing synchronoysly in the browser
        scope.setSDKProcessingMetadata({
            [$f9a78683e1667a75$var$SUPPRESS_TRACING_KEY]: true
        });
        const res = callback();
        scope.setSDKProcessingMetadata({
            [$f9a78683e1667a75$var$SUPPRESS_TRACING_KEY]: undefined
        });
        return res;
    });
}
/**
 * Starts a new trace for the duration of the provided callback. Spans started within the
 * callback will be part of the new trace instead of a potentially previously started trace.
 *
 * Important: Only use this function if you want to override the default trace lifetime and
 * propagation mechanism of the SDK for the duration and scope of the provided callback.
 * The newly created trace will also be the root of a new distributed trace, for example if
 * you make http requests within the callback.
 * This function might be useful if the operation you want to instrument should not be part
 * of a potentially ongoing trace.
 *
 * Default behavior:
 * - Server-side: A new trace is started for each incoming request.
 * - Browser: A new trace is started for each page our route. Navigating to a new route
 *            or page will automatically create a new trace.
 */ function $f9a78683e1667a75$export$f90b03291402f553(callback) {
    return (0, $64ff6138fe06e713$export$ec58d9285c204497)((scope)=>{
        scope.setPropagationContext({
            traceId: (0, $089e6aeb4531f5e4$export$dc6d7ea554bcce10)(),
            sampleRand: (0, $3ce37121dbb69e34$export$9869d72de32a3917)()
        });
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Starting a new trace with id ${scope.getPropagationContext().traceId}`);
        return $f9a78683e1667a75$export$e57ac09b143d92a2(null, callback);
    });
}
function $f9a78683e1667a75$var$createChildOrRootSpan({ parentSpan: parentSpan, spanArguments: spanArguments, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $22da8de313ab467e$export$1f70765132c3c225)()) {
        const span = new (0, $8cd83374eb82db90$export$d6636b700b76c516)();
        // If this is a root span, we ensure to freeze a DSC
        // So we can have at least partial data here
        if (forceTransaction || !parentSpan) {
            const dsc = {
                sampled: 'false',
                sample_rate: '0',
                transaction: spanArguments.name,
                ...(0, $175980fe5a84e4c5$export$a117f995597e25df)(span)
            };
            (0, $175980fe5a84e4c5$export$7398c93e763ca9fd)(span, dsc);
        }
        return span;
    }
    const isolationScope = (0, $64ff6138fe06e713$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $f9a78683e1667a75$var$_startChildSpan(parentSpan, scope, spanArguments);
        (0, $122b7a6129e42fb6$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $175980fe5a84e4c5$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $122b7a6129e42fb6$export$5caecac1caaf3a71)(parentSpan);
        span = $f9a78683e1667a75$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        (0, $175980fe5a84e4c5$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $f9a78683e1667a75$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanArguments
        }, scope, parentSampled);
        if (dsc) (0, $175980fe5a84e4c5$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $e3c61abcd119b779$export$2f3d84e767c9592b)(span);
    (0, $ecf2a0f66df9dd54$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 */ function $f9a78683e1667a75$var$parseSentrySpanArguments(options) {
    const exp = options.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...options
    };
    if (options.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $122b7a6129e42fb6$export$3f7581298f56c6d7)(options.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $f9a78683e1667a75$var$getAcs() {
    const carrier = (0, $b51d9d034721a478$export$19eade501500c6c1)();
    return (0, $3e49a8fa7c1f2ba6$export$f639b0c2752203be)(carrier);
}
function $f9a78683e1667a75$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {};
    const { name: name = '' } = spanArguments;
    const mutableSpanSamplingData = {
        spanAttributes: {
            ...spanArguments.attributes
        },
        spanName: name,
        parentSampled: parentSampled
    };
    // we don't care about the decision for the moment; this is just a placeholder
    client?.emit('beforeSampling', mutableSpanSamplingData, {
        decision: false
    });
    // If hook consumers override the parentSampled flag, we will use that value instead of the actual one
    const finalParentSampled = mutableSpanSamplingData.parentSampled ?? parentSampled;
    const finalAttributes = mutableSpanSamplingData.spanAttributes;
    const currentPropagationContext = scope.getPropagationContext();
    const [sampled, sampleRate, localSampleRateWasApplied] = scope.getScopeData().sdkProcessingMetadata[$f9a78683e1667a75$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $184a030670a52cb1$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: finalParentSampled,
        attributes: finalAttributes,
        parentSampleRate: (0, $f99dcce240975486$export$a5bd2d81656d9546)(currentPropagationContext.dsc?.sample_rate)
    }, currentPropagationContext.sampleRand);
    const rootSpan = new (0, $5136924baff39ecb$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $d06802d0f59b2c9f$export$d7a7d984b0791405)]: 'custom',
            [(0, $d06802d0f59b2c9f$export$ccfe0a40627cc34b)]: sampleRate !== undefined && localSampleRateWasApplied ? sampleRate : undefined,
            ...finalAttributes
        },
        sampled: sampled
    });
    if (!sampled && client) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log('[Tracing] Discarding root span because its trace was not chosen to be sampled.');
        client.recordDroppedEvent('sample_rate', 'transaction');
    }
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $f9a78683e1667a75$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$f9a78683e1667a75$var$SUPPRESS_TRACING_KEY] ? false : (0, $122b7a6129e42fb6$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $5136924baff39ecb$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $8cd83374eb82db90$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $122b7a6129e42fb6$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $f9a78683e1667a75$var$getParentSpan(scope, customParentSpan) {
    // always use the passed in span directly
    if (customParentSpan) return customParentSpan;
    // This is different from `undefined` as it means the user explicitly wants no parent span
    if (customParentSpan === null) return undefined;
    const span = (0, $e57da10b3d1051db$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $122b7a6129e42fb6$export$c4c6a79b1260ca1b)(span);
    return span;
}
function $f9a78683e1667a75$var$getActiveSpanWrapper(parentSpan) {
    return parentSpan !== undefined ? (callback)=>{
        return $f9a78683e1667a75$export$e57ac09b143d92a2(parentSpan, callback);
    } : (callback)=>callback();
}








/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fbf735d82d5bf8ab$export$f5282963edea4a68(exception, hint) {
    return (0, $64ff6138fe06e713$export$c7be4b0125a10cba)().captureException(exception, (0, $a58af1770cf64326$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $fbf735d82d5bf8ab$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const hint = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $64ff6138fe06e713$export$c7be4b0125a10cba)().captureMessage(message, level, hint);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $fbf735d82d5bf8ab$export$1462b974fdcf6ba2(event, hint) {
    return (0, $64ff6138fe06e713$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ function $fbf735d82d5bf8ab$export$2f04de43fe27971a(name, context) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $fbf735d82d5bf8ab$export$bb4922da0dd51b92(extras) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $fbf735d82d5bf8ab$export$8e8e7789d42ed61d(key, extra) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $fbf735d82d5bf8ab$export$74a8fb34822092e6(tags) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $fbf735d82d5bf8ab$export$a37d07ee78eb4569(key, value) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $fbf735d82d5bf8ab$export$8b6bb3dd62a01be2(user) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().setUser(user);
}
/**
 * Sets the conversation ID for the current isolation scope.
 *
 * @param conversationId The conversation ID to set. Pass `null` or `undefined` to unset the conversation ID.
 */ function $fbf735d82d5bf8ab$export$58213391a19e392(conversationId) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().setConversationId(conversationId);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $fbf735d82d5bf8ab$export$5d4e9fd7fac8e617() {
    return (0, $64ff6138fe06e713$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fbf735d82d5bf8ab$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (!client) (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $4da1f60d556678ad$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param callback Callback to be monitored
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fbf735d82d5bf8ab$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    function runCallback() {
        const checkInId = $fbf735d82d5bf8ab$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: 'in_progress'
        }, upsertMonitorConfig);
        const now = (0, $906abfdc43292150$export$ee52dced521e3e18)();
        function finishCheckIn(status) {
            $fbf735d82d5bf8ab$export$413528111fbc67c({
                monitorSlug: monitorSlug,
                status: status,
                checkInId: checkInId,
                duration: (0, $906abfdc43292150$export$ee52dced521e3e18)() - now
            });
        }
        // Default behavior without isolateTrace
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $057f17bbb7048b01$export$f5b060c2914b97c8)(maybePromiseResult)) return maybePromiseResult.then((r)=>{
            finishCheckIn('ok');
            return r;
        }, (e)=>{
            finishCheckIn('error');
            throw e;
        });
        finishCheckIn('ok');
        return maybePromiseResult;
    }
    return (0, $64ff6138fe06e713$export$9a4fed82c350c2bd)(()=>upsertMonitorConfig?.isolateTrace ? (0, $f9a78683e1667a75$export$f90b03291402f553)(runCallback) : runCallback());
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fbf735d82d5bf8ab$export$4909b86c8034bf73(timeout) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fbf735d82d5bf8ab$export$8360e631d277ea4d(timeout) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $fbf735d82d5bf8ab$export$3f95c6f800b78024() {
    return !!(0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $fbf735d82d5bf8ab$export$3b029eb57ac4d562() {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    return client?.getOptions().enabled !== false && !!client?.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $fbf735d82d5bf8ab$export$9aac0b9f77928fbf(callback) {
    (0, $64ff6138fe06e713$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $fbf735d82d5bf8ab$export$c0d84948cecf78d8(context) {
    const isolationScope = (0, $64ff6138fe06e713$export$68f3af03034c9e90)();
    const currentScope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $c02b5704ee22c2a7$export$14a186326edbb264)({
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession?.status === 'ok') (0, $c02b5704ee22c2a7$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $fbf735d82d5bf8ab$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $fbf735d82d5bf8ab$export$17a5be43989a0bc1() {
    const isolationScope = (0, $64ff6138fe06e713$export$68f3af03034c9e90)();
    const currentScope = (0, $64ff6138fe06e713$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $c02b5704ee22c2a7$export$56521d9ba90f62ee)(session);
    $fbf735d82d5bf8ab$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $fbf735d82d5bf8ab$var$_sendSessionUpdate() {
    const isolationScope = (0, $64ff6138fe06e713$export$68f3af03034c9e90)();
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    const session = isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $fbf735d82d5bf8ab$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $fbf735d82d5bf8ab$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $fbf735d82d5bf8ab$var$_sendSessionUpdate();
}


const $d8b5c5326f8895cd$export$56d8a8a25bd48b81 = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);
let $d8b5c5326f8895cd$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $d8b5c5326f8895cd$export$b79738ab10c590b2() {
    return $d8b5c5326f8895cd$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $d8b5c5326f8895cd$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $d8b5c5326f8895cd$var$ignoreOnError++;
    setTimeout(()=>{
        $d8b5c5326f8895cd$var$ignoreOnError--;
    });
}
// eslint-disable-next-line @typescript-eslint/ban-types
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $d8b5c5326f8895cd$export$4997ffc0176396a6(fn, options = {}) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    function isFunction(fn) {
        return typeof fn === 'function';
    }
    if (!isFunction(fn)) return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            if (typeof wrapper === 'function') return wrapper;
            else // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
            // that something messed with it. In that case we want to return the originally passed function.
            return fn;
        }
        // We don't wanna wrap it twice
        if ((0, $085a6ebfb8b9293d$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch  {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    // Wrap the function itself
    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function(...args) {
        try {
            // Also wrap arguments that are themselves functions
            const wrappedArguments = args.map((arg)=>$d8b5c5326f8895cd$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $d8b5c5326f8895cd$export$1265a142ff5ba165();
            (0, $64ff6138fe06e713$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $4da1f60d556678ad$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $4da1f60d556678ad$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                // no need to add a mechanism here, we already add it via an event processor above
                (0, $fbf735d82d5bf8ab$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    // Wrap the wrapped function in a proxy, to ensure any other properties of the original function remain available
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch  {
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    }
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $085a6ebfb8b9293d$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    } catch  {
    // This may throw if e.g. the descriptor does not exist, or a browser does not allow redefining `name`.
    // to save some bytes we simply try-catch this
    }
    return sentryWrapped;
}
/**
 * Get HTTP request data from the current page.
 */ function $d8b5c5326f8895cd$export$a3c4a8453e8936f0() {
    // grab as much info as exists and add it to the event
    const url = (0, $8fe80379f466e1f6$export$1cfafeee2987818b)();
    const { referrer: referrer } = $d8b5c5326f8895cd$export$56d8a8a25bd48b81.document || {};
    const { userAgent: userAgent } = $d8b5c5326f8895cd$export$56d8a8a25bd48b81.navigator || {};
    const headers = {
        ...referrer && {
            Referer: referrer
        },
        ...userAgent && {
            'User-Agent': userAgent
        }
    };
    const request = {
        url: url,
        headers: headers
    };
    return request;
}


/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $b79a341f278bd18d$export$1df9218a526d318d extends (0, $404620d4746f08bf$export$1f2bb630327ac4b6) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = $b79a341f278bd18d$export$4e107b20a7f977(options);
        const sdkSource = (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $aeff4153c130a48e$export$8ad33f488b1ab046)();
        (0, $db3439a3565fcfe3$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        // Only allow IP inferral by Relay if sendDefaultPii is true
        if (opts._metadata?.sdk) opts._metadata.sdk.settings = {
            infer_ip: opts.sendDefaultPii ? 'auto' : 'never',
            // purposefully allowing already passed settings to override the default
            ...opts._metadata.sdk.settings
        };
        super(opts);
        const { sendDefaultPii: sendDefaultPii, sendClientReports: sendClientReports, enableLogs: enableLogs, _experiments: _experiments, enableMetrics: enableMetricsOption } = this._options;
        // todo(v11): Remove the experimental flag
        // eslint-disable-next-line deprecation/deprecation
        const enableMetrics = enableMetricsOption ?? _experiments?.enableMetrics ?? true;
        // Flush logs and metrics when page becomes hidden (e.g., tab switch, navigation)
        // todo(v11): Remove the experimental flag
        if ((0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).document && (sendClientReports || enableLogs || enableMetrics)) (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') {
                if (sendClientReports) this._flushOutcomes();
                if (enableLogs) (0, $0a259c8ca224b0c2$export$f8ed83d3b6a0b504)(this);
                if (enableMetrics) (0, $c775830d1e8c2972$export$91c9ef254b7d0f67)(this);
            }
        });
        if (sendDefaultPii) this.on('beforeSendSession', (0, $349a19aada264b44$export$e8e2d07ba63e2b6c));
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $d85fd2ab7f9a30e0$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $d85fd2ab7f9a30e0$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, currentScope, isolationScope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, currentScope, isolationScope);
    }
}
/** Exported only for tests. */ function $b79a341f278bd18d$export$4e107b20a7f977(optionsArg) {
    return {
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).SENTRY_RELEASE?.id,
        sendClientReports: true,
        // We default this to true, as it is the safer scenario
        parentSpanIsAlwaysRootSpan: true,
        ...optionsArg
    };
}





/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $0cbb72b772e1532d$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $0cbb72b772e1532d$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $64ff6138fe06e713$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $0cbb72b772e1532d$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $906abfdc43292150$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $ff784a3dc7695b3c$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}







// We keep the handlers globally
const $1cff7e9ef0554a43$var$handlers = {};
const $1cff7e9ef0554a43$var$instrumented = {};
/** Add a handler function. */ function $1cff7e9ef0554a43$export$a4e09611e30da72e(type, handler) {
    $1cff7e9ef0554a43$var$handlers[type] = $1cff7e9ef0554a43$var$handlers[type] || [];
    $1cff7e9ef0554a43$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $1cff7e9ef0554a43$export$b17eab759a1cb5fe() {
    Object.keys($1cff7e9ef0554a43$var$handlers).forEach((key)=>{
        $1cff7e9ef0554a43$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $1cff7e9ef0554a43$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$1cff7e9ef0554a43$var$instrumented[type]) {
        $1cff7e9ef0554a43$var$instrumented[type] = true;
        try {
            instrumentFn();
        } catch (e) {
            (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error(`Error while instrumenting ${type}`, e);
        }
    }
}
/** Trigger handlers for a given instrumentation type. */ function $1cff7e9ef0554a43$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $1cff7e9ef0554a43$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $7a317b2b764bd658$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}


/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c14e953190a678dd$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, $c14e953190a678dd$var$instrumentConsole);
}
function $c14e953190a678dd$var$instrumentConsole() {
    if (!('console' in (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1))) return;
    (0, $ff784a3dc7695b3c$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).console)) return;
        (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)((0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $ff784a3dc7695b3c$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $ff784a3dc7695b3c$export$77c4ce905194557b)[level];
                log?.apply((0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}







const $63d2c47996651f52$var$WINDOW = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $63d2c47996651f52$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $63d2c47996651f52$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $63d2c47996651f52$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch  {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $63d2c47996651f52$export$67fc34576016d6ec() {
    return 'history' in $63d2c47996651f52$var$WINDOW && !!$63d2c47996651f52$var$WINDOW.history;
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ const $63d2c47996651f52$export$edf3cb81fd7d2a3e = $63d2c47996651f52$var$_isFetchSupported;
function $63d2c47996651f52$var$_isFetchSupported() {
    if (!('fetch' in $63d2c47996651f52$var$WINDOW)) return false;
    try {
        new Headers();
        // Deno requires a valid URL so '' cannot be used as an argument
        new Request('data:,');
        new Response();
        return true;
    } catch  {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $63d2c47996651f52$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $63d2c47996651f52$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$63d2c47996651f52$var$_isFetchSupported()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($63d2c47996651f52$export$d5f608b368e73f38($63d2c47996651f52$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $63d2c47996651f52$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow?.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $63d2c47996651f52$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $e74753b69eef4000$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $63d2c47996651f52$export$531055a6c684a70a() {
    return 'ReportingObserver' in $63d2c47996651f52$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 * @deprecated This is no longer used and will be removed in a future major version.
 */ function $63d2c47996651f52$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$63d2c47996651f52$var$_isFetchSupported()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch  {
        return false;
    }
}





/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c4077f93c172a7d5$export$f75d3c772c923df0(handler, skipNativeFetchCheck) {
    const type = 'fetch';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, ()=>$c4077f93c172a7d5$var$instrumentFetch(undefined, skipNativeFetchCheck));
}
/**
 * Add an instrumentation handler for long-lived fetch requests, like consuming server-sent events (SSE) via fetch.
 * The handler will resolve the request body and emit the actual `endTimestamp`, so that the
 * span can be updated accordingly.
 *
 * Only used internally
 * @hidden
 */ function $c4077f93c172a7d5$export$1a79663eb318fe6a(handler) {
    const type = 'fetch-body-resolved';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, ()=>$c4077f93c172a7d5$var$instrumentFetch($c4077f93c172a7d5$var$streamHandler));
}
function $c4077f93c172a7d5$var$instrumentFetch(onFetchResolved, skipNativeFetchCheck = false) {
    if (skipNativeFetchCheck && !(0, $63d2c47996651f52$export$c82d238e23c40b21)()) return;
    (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)((0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            // We capture the error right here and not in the Promise error callback because Safari (and probably other
            // browsers too) will wipe the stack trace up to this point, only leaving us with this file which is useless.
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your fetch call did not
            //       have a stack trace, so the SDK backfilled the stack trace so
            //       you can see which fetch call failed.
            const virtualError = new Error();
            const { method: method, url: url } = $c4077f93c172a7d5$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)() * 1000,
                virtualError: // // Adding the error to be able to fingerprint the failed fetch event in HttpClient instrumentation
                virtualError,
                headers: $c4077f93c172a7d5$var$getHeadersFromFetchArgs(args)
            };
            // if there is no callback, fetch is instrumented directly
            if (!onFetchResolved) (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1), args).then(async (response)=>{
                if (onFetchResolved) onFetchResolved(response);
                else (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)() * 1000,
                    response: response
                });
                return response;
            }, (error)=>{
                (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('fetch', {
                    ...handlerData,
                    endTimestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)() * 1000,
                    error: error
                });
                if ((0, $057f17bbb7048b01$export$e6127cc7fe7395c3)(error) && error.stack === undefined) {
                    // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                    //       it means the error, that was caused by your fetch call did not
                    //       have a stack trace, so the SDK backfilled the stack trace so
                    //       you can see which fetch call failed.
                    error.stack = virtualError.stack;
                    (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(error, 'framesToPop', 1);
                }
                // We enhance fetch error messages with hostname information based on the configuration.
                // Possible messages we handle here:
                // * "Failed to fetch" (chromium)
                // * "Load failed" (webkit)
                // * "NetworkError when attempting to fetch resource." (firefox)
                const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
                const enhanceOption = client?.getOptions().enhanceFetchErrorMessages ?? 'always';
                const shouldEnhance = enhanceOption !== false;
                if (shouldEnhance && error instanceof TypeError && (error.message === 'Failed to fetch' || error.message === 'Load failed' || error.message === 'NetworkError when attempting to fetch resource.')) try {
                    const url = new URL(handlerData.fetchData.url);
                    const hostname = url.host;
                    if (enhanceOption === 'always') // Modify the error message directly
                    error.message = `${error.message} (${hostname})`;
                    else // Store hostname as non-enumerable property for Sentry-only enhancement
                    // This preserves the original error message for third-party packages
                    (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(error, '__sentry_fetch_url_host__', hostname);
                } catch  {
                // ignore it if errors happen here
                }
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
async function $c4077f93c172a7d5$var$resolveResponse(res, onFinishedResolving) {
    if (res?.body) {
        const body = res.body;
        const responseReader = body.getReader();
        // Define a maximum duration after which we just cancel
        const maxFetchDurationTimeout = setTimeout(()=>{
            body.cancel().then(null, ()=>{
            // noop
            });
        }, 90000);
        let readingActive = true;
        while(readingActive){
            let chunkTimeout;
            try {
                // abort reading if read op takes more than 5s
                chunkTimeout = setTimeout(()=>{
                    body.cancel().then(null, ()=>{
                    // noop on error
                    });
                }, 5000);
                // This .read() call will reject/throw when we abort due to timeouts through `body.cancel()`
                const { done: done } = await responseReader.read();
                clearTimeout(chunkTimeout);
                if (done) {
                    onFinishedResolving();
                    readingActive = false;
                }
            } catch  {
                readingActive = false;
            } finally{
                clearTimeout(chunkTimeout);
            }
        }
        clearTimeout(maxFetchDurationTimeout);
        responseReader.releaseLock();
        body.cancel().then(null, ()=>{
        // noop on error
        });
    }
}
function $c4077f93c172a7d5$var$streamHandler(response) {
    // clone response for awaiting stream
    let clonedResponseForResolving;
    try {
        clonedResponseForResolving = response.clone();
    } catch  {
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $c4077f93c172a7d5$var$resolveResponse(clonedResponseForResolving, ()=>{
        (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('fetch-body-resolved', {
            endTimestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)() * 1000,
            response: response
        });
    });
}
function $c4077f93c172a7d5$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $c4077f93c172a7d5$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($c4077f93c172a7d5$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $c4077f93c172a7d5$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [resource, options] = fetchArgs;
        return {
            url: $c4077f93c172a7d5$var$getUrlFromResource(resource),
            method: $c4077f93c172a7d5$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : (0, $057f17bbb7048b01$export$6d3d1f317d7cda57)(resource) && $c4077f93c172a7d5$var$hasProp(resource, 'method') ? String(resource.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $c4077f93c172a7d5$var$getUrlFromResource(arg),
        method: $c4077f93c172a7d5$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
function $c4077f93c172a7d5$var$getHeadersFromFetchArgs(fetchArgs) {
    const [requestArgument, optionsArgument] = fetchArgs;
    try {
        if (typeof optionsArgument === 'object' && optionsArgument !== null && 'headers' in optionsArgument && optionsArgument.headers) return new Headers(optionsArgument.headers);
        if ((0, $057f17bbb7048b01$export$6d3d1f317d7cda57)(requestArgument)) return new Headers(requestArgument.headers);
    } catch  {
    // noop
    }
    return;
}

/**
 * Determine a breadcrumb's log level (only `warning` or `error`) based on an HTTP status code.
 */ function $90245338ea306540$export$b8cfcc4175694bcc(statusCode) {
    // NOTE: undefined defaults to 'info' in Sentry
    if (statusCode === undefined) return undefined;
    else if (statusCode >= 400 && statusCode < 500) return 'warning';
    else if (statusCode >= 500) return 'error';
    else return undefined;
}


// Curious about `thismessage:/`? See: https://www.rfc-editor.org/rfc/rfc2557.html
//  > When the methods above do not yield an absolute URI, a base URL
//  > of "thismessage:/" MUST be employed. This base URL has been
//  > defined for the sole purpose of resolving relative references
//  > within a multipart/related structure when no other base URI is
//  > specified.
//
// We need to provide a base URL to `parseStringToURLObject` because the fetch API gives us a
// relative URL sometimes.
//
// This is the only case where we need to provide a base URL to `parseStringToURLObject`
// because the relative URL is not valid on its own.
const $af62e93da5e15d3a$var$DEFAULT_BASE_URL = 'thismessage:/';
/**
 * Checks if the URL object is relative
 *
 * @param url - The URL object to check
 * @returns True if the URL object is relative, false otherwise
 */ function $af62e93da5e15d3a$export$e258e13805402ba7(url) {
    return 'isRelative' in url;
}
/**
 * Parses string to a URL object
 *
 * @param url - The URL to parse
 * @returns The parsed URL object or undefined if the URL is invalid
 */ function $af62e93da5e15d3a$export$2004d912a9ead694(url, urlBase) {
    const isRelative = url.indexOf('://') <= 0 && url.indexOf('//') !== 0;
    const base = urlBase ?? (isRelative ? $af62e93da5e15d3a$var$DEFAULT_BASE_URL : undefined);
    try {
        // Use `canParse` to short-circuit the URL constructor if it's not a valid URL
        // This is faster than trying to construct the URL and catching the error
        // Node 20+, Chrome 120+, Firefox 115+, Safari 17+
        if ('canParse' in URL && !URL.canParse(url, base)) return undefined;
        const fullUrlObject = new URL(url, base);
        if (isRelative) // Because we used a fake base URL, we need to return a relative URL object.
        // We cannot return anything about the origin, host, etc. because it will refer to the fake base URL.
        return {
            isRelative: isRelative,
            pathname: fullUrlObject.pathname,
            search: fullUrlObject.search,
            hash: fullUrlObject.hash
        };
        return fullUrlObject;
    } catch  {
    // empty body
    }
    return undefined;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $af62e93da5e15d3a$export$5339fcdc8e2a427c(url) {
    if ($af62e93da5e15d3a$export$e258e13805402ba7(url)) return url.pathname;
    const newUrl = new URL(url);
    newUrl.search = '';
    newUrl.hash = '';
    if ([
        '80',
        '443'
    ].includes(newUrl.port)) newUrl.port = '';
    if (newUrl.password) newUrl.password = '%filtered%';
    if (newUrl.username) newUrl.username = '%filtered%';
    return newUrl.toString();
}
function $af62e93da5e15d3a$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName) {
    const method = request?.method?.toUpperCase() ?? 'GET';
    const route = routeName ? routeName : urlObject ? kind === 'client' ? $af62e93da5e15d3a$export$5339fcdc8e2a427c(urlObject) : urlObject.pathname : '/';
    return `${method} ${route}`;
}
/**
 * Takes a parsed URL object and returns a set of attributes for the span
 * that represents the HTTP request for that url. This is used for both server
 * and client http spans.
 *
 * Follows https://opentelemetry.io/docs/specs/semconv/http/.
 *
 * @param urlObject - see {@link parseStringToURLObject}
 * @param kind - The type of HTTP operation (server or client)
 * @param spanOrigin - The origin of the span
 * @param request - The request object, see {@link PartialRequest}
 * @param routeName - The name of the route, must be low cardinality
 * @returns The span name and attributes for the HTTP operation
 */ function $af62e93da5e15d3a$export$c37a41544f3c180c(urlObject, kind, spanOrigin, request, routeName) {
    const attributes = {
        [(0, $d06802d0f59b2c9f$export$cca8dd30f57f805e)]: spanOrigin,
        [(0, $d06802d0f59b2c9f$export$d7a7d984b0791405)]: 'url'
    };
    if (routeName) {
        // This is based on https://opentelemetry.io/docs/specs/semconv/http/http-spans/#name
        attributes[kind === 'server' ? 'http.route' : 'url.template'] = routeName;
        attributes[0, $d06802d0f59b2c9f$export$d7a7d984b0791405] = 'route';
    }
    if (request?.method) attributes[0, $d06802d0f59b2c9f$export$be7a251980e7e946] = request.method.toUpperCase();
    if (urlObject) {
        if (urlObject.search) attributes['url.query'] = urlObject.search;
        if (urlObject.hash) attributes['url.fragment'] = urlObject.hash;
        if (urlObject.pathname) {
            attributes['url.path'] = urlObject.pathname;
            if (urlObject.pathname === '/') attributes[0, $d06802d0f59b2c9f$export$d7a7d984b0791405] = 'route';
        }
        if (!$af62e93da5e15d3a$export$e258e13805402ba7(urlObject)) {
            attributes[0, $d06802d0f59b2c9f$export$25dfd73e0e32c6e1] = urlObject.href;
            if (urlObject.port) attributes['url.port'] = urlObject.port;
            if (urlObject.protocol) attributes['url.scheme'] = urlObject.protocol;
            if (urlObject.hostname) attributes[kind === 'server' ? 'server.address' : 'url.domain'] = urlObject.hostname;
        }
    }
    return [
        $af62e93da5e15d3a$var$getHttpSpanNameFromUrlObject(urlObject, kind, request, routeName),
        attributes
    ];
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $af62e93da5e15d3a$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $af62e93da5e15d3a$export$ce084c78234bd35(urlPath) {
    return urlPath.split(/[?#]/, 1)[0];
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $af62e93da5e15d3a$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host?.replace(/^.*@/, '[filtered]:[filtered]@').replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}
/**
 * Strips the content from a data URL, returning a placeholder with the MIME type.
 *
 * Data URLs can be very long (e.g. base64 encoded scripts for Web Workers),
 * with little valuable information, often leading to envelopes getting dropped due
 * to size limit violations. Therefore, we strip data URLs and replace them with a
 * placeholder.
 *
 * @param url - The URL to process
 * @param includeDataPrefix - If true, includes the first 10 characters of the data stream
 *                            for debugging (e.g., to identify magic bytes like WASM's AGFzbQ).
 *                            Defaults to true.
 * @returns For data URLs, returns a short format like `data:text/javascript;base64,SGVsbG8gV2... [truncated]`.
 *          For non-data URLs, returns the original URL unchanged.
 */ function $af62e93da5e15d3a$export$8abd806fcaf234fa(url, includeDataPrefix = true) {
    if (url.startsWith('data:')) {
        // Match the MIME type (everything after 'data:' until the first ';' or ',')
        const match = url.match(/^data:([^;,]+)/);
        const mimeType = match ? match[1] : 'text/plain';
        const isBase64 = url.includes(';base64,');
        // Find where the actual data starts (after the comma)
        const dataStart = url.indexOf(',');
        let dataPrefix = '';
        if (includeDataPrefix && dataStart !== -1) {
            const data = url.slice(dataStart + 1);
            // Include first 10 chars of data to help identify content (e.g., magic bytes)
            dataPrefix = data.length > 10 ? `${data.slice(0, 10)}... [truncated]` : data;
        }
        return `data:${mimeType}${isBase64 ? ',base64' : ''}${dataPrefix ? `,${dataPrefix}` : ''}`;
    }
    return url;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $a78ea827ecab359d$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : [
        'fatal',
        'error',
        'warning',
        'log',
        'info',
        'debug'
    ].includes(level) ? level : 'log';
}




const $68290708259de2d6$export$56d8a8a25bd48b81 = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1);


const $1bdd33f0582a39bc$var$DEBOUNCE_DURATION = 1000;
let $1bdd33f0582a39bc$var$debounceTimerID;
let $1bdd33f0582a39bc$var$lastCapturedEventType;
let $1bdd33f0582a39bc$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $1bdd33f0582a39bc$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, $1bdd33f0582a39bc$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $1bdd33f0582a39bc$export$3014bbf0af0e1d4a() {
    if (!(0, $68290708259de2d6$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $1cff7e9ef0554a43$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $1bdd33f0582a39bc$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $68290708259de2d6$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $68290708259de2d6$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        const globalObject = (0, $68290708259de2d6$export$56d8a8a25bd48b81);
        const proto = globalObject[target]?.prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto?.hasOwnProperty?.('addEventListener')) return;
        (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $1bdd33f0582a39bc$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const handlers = this.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete this.__sentry_instrumentation_handlers__;
                    }
                } catch  {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListeners` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $1bdd33f0582a39bc$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $1bdd33f0582a39bc$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $1bdd33f0582a39bc$var$lastCapturedEventTargetId) return false;
    } catch  {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $1bdd33f0582a39bc$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target?.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $1bdd33f0582a39bc$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $1bdd33f0582a39bc$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($1bdd33f0582a39bc$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $085a6ebfb8b9293d$export$e73679ffaf56810e)(target, '_sentryId', (0, $4da1f60d556678ad$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$1bdd33f0582a39bc$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $1bdd33f0582a39bc$var$lastCapturedEventType = event.type;
            $1bdd33f0582a39bc$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($1bdd33f0582a39bc$var$debounceTimerID);
        $1bdd33f0582a39bc$var$debounceTimerID = (0, $68290708259de2d6$export$56d8a8a25bd48b81).setTimeout(()=>{
            $1bdd33f0582a39bc$var$lastCapturedEventTargetId = undefined;
            $1bdd33f0582a39bc$var$lastCapturedEventType = undefined;
        }, $1bdd33f0582a39bc$var$DEBOUNCE_DURATION);
    };
}
function $1bdd33f0582a39bc$var$getEventTarget(event) {
    try {
        return event.target;
    } catch  {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}



let $c912d52d18f1e436$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c912d52d18f1e436$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, $c912d52d18f1e436$export$d9b613a6254a184e);
}
/**
 * Exported just for testing
 */ function $c912d52d18f1e436$export$d9b613a6254a184e() {
    // The `popstate` event may also be triggered on `pushState`, but it may not always reliably be emitted by the browser
    // Which is why we also monkey-patch methods below, in addition to this
    (0, $68290708259de2d6$export$56d8a8a25bd48b81).addEventListener('popstate', ()=>{
        const to = (0, $68290708259de2d6$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $c912d52d18f1e436$var$lastHref;
        $c912d52d18f1e436$var$lastHref = to;
        if (from === to) return;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('history', handlerData);
    });
    // Just guard against this not being available, in weird environments
    if (!(0, $63d2c47996651f52$export$67fc34576016d6ec)()) return;
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                const from = $c912d52d18f1e436$var$lastHref;
                // Ensure the URL is absolute
                // this can be either a path, then it is relative to the current origin
                // or a full URL of the current origin - other origins are not allowed
                // See: https://developer.mozilla.org/en-US/docs/Web/API/History/pushState#url
                // coerce to string (this is what pushState does)
                const to = $c912d52d18f1e436$var$getAbsoluteUrl(String(url));
                // keep track of the current URL state, as we always receive only the updated state
                $c912d52d18f1e436$var$lastHref = to;
                if (from === to) return originalHistoryFunction.apply(this, args);
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)((0, $68290708259de2d6$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)((0, $68290708259de2d6$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}
function $c912d52d18f1e436$var$getAbsoluteUrl(urlOrPath) {
    try {
        const url = new URL(urlOrPath, (0, $68290708259de2d6$export$56d8a8a25bd48b81).location.origin);
        return url.toString();
    } catch  {
        // fallback, just do nothing
        return urlOrPath;
    }
}



const $0e23099f873fc3f2$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0e23099f873fc3f2$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, $0e23099f873fc3f2$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0e23099f873fc3f2$export$c67d533bf77cbf54() {
    if (!(0, $68290708259de2d6$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.open = new Proxy(xhrproto.open, {
        apply (originalOpen, xhrOpenThisArg, xhrOpenArgArray) {
            // NOTE: If you are a Sentry user, and you are seeing this stack frame,
            //       it means the error, that was caused by your XHR call did not
            //       have a stack trace. If you are using HttpClient integration,
            //       this is the expected behavior, as we are using this virtual error to capture
            //       the location of your XHR call, and group your HttpClient events accordingly.
            const virtualError = new Error();
            const startTimestamp = (0, $906abfdc43292150$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $057f17bbb7048b01$export$844ec244b1367d54)(xhrOpenArgArray[0]) ? xhrOpenArgArray[0].toUpperCase() : undefined;
            const url = $0e23099f873fc3f2$var$parseXhrUrlArg(xhrOpenArgArray[1]);
            if (!method || !url) return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
            xhrOpenThisArg[$0e23099f873fc3f2$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) xhrOpenThisArg.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = xhrOpenThisArg[$0e23099f873fc3f2$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (xhrOpenThisArg.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhrOpenThisArg.status;
                    } catch  {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: xhrOpenThisArg,
                        virtualError: virtualError
                    };
                    (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in xhrOpenThisArg && typeof xhrOpenThisArg.onreadystatechange === 'function') xhrOpenThisArg.onreadystatechange = new Proxy(xhrOpenThisArg.onreadystatechange, {
                apply (originalOnreadystatechange, onreadystatechangeThisArg, onreadystatechangeArgArray) {
                    onreadystatechangeHandler();
                    return originalOnreadystatechange.apply(onreadystatechangeThisArg, onreadystatechangeArgArray);
                }
            });
            else xhrOpenThisArg.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            xhrOpenThisArg.setRequestHeader = new Proxy(xhrOpenThisArg.setRequestHeader, {
                apply (originalSetRequestHeader, setRequestHeaderThisArg, setRequestHeaderArgArray) {
                    const [header, value] = setRequestHeaderArgArray;
                    const xhrInfo = setRequestHeaderThisArg[$0e23099f873fc3f2$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $057f17bbb7048b01$export$844ec244b1367d54)(header) && (0, $057f17bbb7048b01$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return originalSetRequestHeader.apply(setRequestHeaderThisArg, setRequestHeaderArgArray);
                }
            });
            return originalOpen.apply(xhrOpenThisArg, xhrOpenArgArray);
        }
    });
    // eslint-disable-next-line @typescript-eslint/unbound-method
    xhrproto.send = new Proxy(xhrproto.send, {
        apply (originalSend, sendThisArg, sendArgArray) {
            const sentryXhrData = sendThisArg[$0e23099f873fc3f2$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(sendThisArg, sendArgArray);
            if (sendArgArray[0] !== undefined) sentryXhrData.body = sendArgArray[0];
            const handlerData = {
                startTimestamp: (0, $906abfdc43292150$export$ee52dced521e3e18)() * 1000,
                xhr: sendThisArg
            };
            (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(sendThisArg, sendArgArray);
        }
    });
}
/**
 * Parses the URL argument of a XHR method to a string.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/open#url
 * url: A string or any other object with a stringifier — including a URL object — that provides the URL of the resource to send the request to.
 *
 * @param url - The URL argument of an XHR method
 * @returns The parsed URL string or undefined if the URL is invalid
 */ function $0e23099f873fc3f2$var$parseXhrUrlArg(url) {
    if ((0, $057f17bbb7048b01$export$844ec244b1367d54)(url)) return url;
    try {
        // If the passed in argument is not a string, it should have a `toString` method as a stringifier.
        // If that fails, we just return undefined (like in IE11 where URL is not available)
        return url.toString();
    } catch  {} // eslint-disable-line no-empty
    return undefined;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1a670c87e40f63e7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $ac5ebea0403f6f58$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $ac5ebea0403f6f58$var$INTEGRATION_NAME = 'Breadcrumbs';
const $ac5ebea0403f6f58$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $ac5ebea0403f6f58$var$INTEGRATION_NAME,
        setup (client) {
            // TODO(v11): Remove this functionality and use `consoleIntegration` from @sentry/core instead.
            if (_options.console) (0, $c14e953190a678dd$export$1d6e0d073f9e6723)($ac5ebea0403f6f58$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $1bdd33f0582a39bc$export$5aeffd3db2cf9df7)($ac5ebea0403f6f58$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $0e23099f873fc3f2$export$26ace48dd54c9aea)($ac5ebea0403f6f58$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $c4077f93c172a7d5$export$f75d3c772c923df0)($ac5ebea0403f6f58$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $c912d52d18f1e436$export$3f18c56c58114e75)($ac5ebea0403f6f58$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $ac5ebea0403f6f58$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $ac5ebea0403f6f58$export$c079d904b326663a = (0, $00abeec2398bba5c$export$2323046b9414659f)($ac5ebea0403f6f58$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $ac5ebea0403f6f58$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client) return;
        (0, $0cbb72b772e1532d$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $4da1f60d556678ad$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creates a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $ac5ebea0403f6f58$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $ac5ebea0403f6f58$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $1a670c87e40f63e7$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`\`dom.maxStringLength\` cannot exceed ${$ac5ebea0403f6f58$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$ac5ebea0403f6f58$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $ac5ebea0403f6f58$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $ac5ebea0403f6f58$var$_isEvent(event) ? event.target : event;
            target = (0, $8fe80379f466e1f6$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $8fe80379f466e1f6$export$26727cfcc4d7e0fc)(element);
        } catch  {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $0cbb72b772e1532d$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $ac5ebea0403f6f58$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $a78ea827ecab359d$export$d771ef054122c30a)(handlerData.level),
            message: (0, $ff73814e958d28bd$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $ff73814e958d28bd$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $0cbb72b772e1532d$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $ac5ebea0403f6f58$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $0e23099f873fc3f2$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        const breadcrumb = {
            category: 'xhr',
            data: data,
            type: 'http',
            level: (0, $90245338ea306540$export$b8cfcc4175694bcc)(status_code)
        };
        client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
        (0, $0cbb72b772e1532d$export$efda9a273d7a036d)(breadcrumb, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $ac5ebea0403f6f58$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        handlerData.fetchData.method, handlerData.fetchData.url;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $0cbb72b772e1532d$export$efda9a273d7a036d)(breadcrumb, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response?.status
            };
            handlerData.fetchData.request_body_size;
            handlerData.fetchData.response_body_size;
            response?.status;
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            const breadcrumb = {
                category: 'fetch',
                data: data,
                type: 'http',
                level: (0, $90245338ea306540$export$b8cfcc4175694bcc)(data.status_code)
            };
            client.emit('beforeOutgoingRequestBreadcrumb', breadcrumb, hint);
            (0, $0cbb72b772e1532d$export$efda9a273d7a036d)(breadcrumb, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $ac5ebea0403f6f58$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $af62e93da5e15d3a$export$7a5253c0f62e0150)((0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $af62e93da5e15d3a$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $af62e93da5e15d3a$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom?.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $0cbb72b772e1532d$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $ac5ebea0403f6f58$var$_isEvent(event) {
    return !!event && !!event.target;
}




const $763fce48c7fe1090$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $763fce48c7fe1090$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $763fce48c7fe1090$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        unregisterOriginalCallbacks: false,
        ...options
    };
    return {
        name: $763fce48c7fe1090$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)((0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81), 'setTimeout', $763fce48c7fe1090$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)((0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81), 'setInterval', $763fce48c7fe1090$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)((0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81), 'requestAnimationFrame', $763fce48c7fe1090$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81)) (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $763fce48c7fe1090$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $763fce48c7fe1090$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach((target)=>$763fce48c7fe1090$var$_wrapEventTarget(target, _options));
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $763fce48c7fe1090$export$59bfe9f1c76150e = (0, $00abeec2398bba5c$export$2323046b9414659f)($763fce48c7fe1090$var$_browserApiErrorsIntegration);
function $763fce48c7fe1090$var$_wrapTimeFunction(original) {
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $d8b5c5326f8895cd$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                handled: false,
                type: `auto.browser.browserapierrors.${(0, $7a317b2b764bd658$export$aad197c7121a6651)(original)}`
            }
        });
        return original.apply(this, args);
    };
}
function $763fce48c7fe1090$var$_wrapRAF(original) {
    return function(callback) {
        return original.apply(this, [
            (0, $d8b5c5326f8895cd$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        handler: (0, $7a317b2b764bd658$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'auto.browser.browserapierrors.requestAnimationFrame'
                }
            })
        ]);
    };
}
function $763fce48c7fe1090$var$_wrapXHR(originalSend) {
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            handler: (0, $7a317b2b764bd658$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: `auto.browser.browserapierrors.xhr.${prop}`
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $085a6ebfb8b9293d$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $7a317b2b764bd658$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $d8b5c5326f8895cd$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $763fce48c7fe1090$var$_wrapEventTarget(target, integrationOptions) {
    const globalObject = (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81);
    const proto = globalObject[target]?.prototype;
    // eslint-disable-next-line no-prototype-builtins
    if (!proto?.hasOwnProperty?.('addEventListener')) return;
    (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(eventName, fn, options) {
            try {
                if ($763fce48c7fe1090$var$isEventListenerObject(fn)) // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $d8b5c5326f8895cd$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            handler: (0, $7a317b2b764bd658$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.handleEvent'
                    }
                });
            } catch  {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            if (integrationOptions.unregisterOriginalCallbacks) $763fce48c7fe1090$var$unregisterOriginalCallback(this, eventName, fn);
            return original.apply(this, [
                eventName,
                (0, $d8b5c5326f8895cd$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            handler: (0, $7a317b2b764bd658$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'auto.browser.browserapierrors.addEventListener'
                    }
                }),
                options
            ]);
        };
    });
    (0, $085a6ebfb8b9293d$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(eventName, fn, options) {
            /**
       * There are 2 possible scenarios here:
       *
       * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
       * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
       * as a pass-through, and call original `removeEventListener` with it.
       *
       * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
       * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
       * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
       * in order for us to make a distinction between wrapped/non-wrapped functions possible.
       * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
       *
       * When someone adds a handler prior to initialization, and then do it again, but after,
       * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
       * to get rid of the initial handler and it'd stick there forever.
       */ try {
                const originalEventHandler = fn.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch  {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, fn, options);
        };
    });
}
function $763fce48c7fe1090$var$isEventListenerObject(obj) {
    return typeof obj.handleEvent === 'function';
}
function $763fce48c7fe1090$var$unregisterOriginalCallback(target, eventName, fn) {
    if (target && typeof target === 'object' && 'removeEventListener' in target && typeof target.removeEventListener === 'function') target.removeEventListener(eventName, fn);
}






/**
 * When added, automatically creates sessions which allow you to track adoption and crashes (crash free rate) in your Releases in Sentry.
 * More information: https://docs.sentry.io/product/releases/health/
 *
 * Note: In order for session tracking to work, you need to set up Releases: https://docs.sentry.io/product/releases/
 */ const $5c6bdac4a35adc93$export$1baa7880e357371c = (0, $00abeec2398bba5c$export$2323046b9414659f)(()=>{
    return {
        name: 'BrowserSession',
        setupOnce () {
            if (typeof (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).document === 'undefined') {
                (0, $1a670c87e40f63e7$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn('Using the `browserSessionIntegration` in non-browser environments is not supported.');
                return;
            }
            // The session duration for browser sessions does not track a meaningful
            // concept that can be used as a metric.
            // Automatically captured sessions are akin to page views, and thus we
            // discard their duration.
            (0, $fbf735d82d5bf8ab$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $fbf735d82d5bf8ab$export$667e7b4d445d566b)();
            // We want to create a session for every navigation as well
            (0, $c912d52d18f1e436$export$3f18c56c58114e75)(({ from: from, to: to })=>{
                // Don't create an additional session for the initial route or if the location did not change
                if (from !== undefined && from !== to) {
                    (0, $fbf735d82d5bf8ab$export$c0d84948cecf78d8)({
                        ignoreDuration: true
                    });
                    (0, $fbf735d82d5bf8ab$export$667e7b4d445d566b)();
                }
            });
        }
    };
});




let $7d5c8cdfe8ab126c$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7d5c8cdfe8ab126c$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, $7d5c8cdfe8ab126c$var$instrumentError);
}
function $7d5c8cdfe8ab126c$var$instrumentError() {
    $7d5c8cdfe8ab126c$var$_oldOnErrorHandler = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).onerror;
    // Note: The reason we are doing window.onerror instead of window.addEventListener('error')
    // is that we are using this handler in the Loader Script, to handle buffered errors consistently
    (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('error', handlerData);
        if ($7d5c8cdfe8ab126c$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $7d5c8cdfe8ab126c$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $e503e4dcb3c348c7$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $e503e4dcb3c348c7$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $1cff7e9ef0554a43$export$a4e09611e30da72e)(type, handler);
    (0, $1cff7e9ef0554a43$export$e18d6c5462c01368)(type, $e503e4dcb3c348c7$var$instrumentUnhandledRejection);
}
function $e503e4dcb3c348c7$var$instrumentUnhandledRejection() {
    $e503e4dcb3c348c7$var$_oldOnUnhandledRejectionHandler = (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).onunhandledrejection;
    // Note: The reason we are doing window.onunhandledrejection instead of window.addEventListener('unhandledrejection')
    // is that we are using this handler in the Loader Script, to handle buffered rejections consistently
    (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $1cff7e9ef0554a43$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($e503e4dcb3c348c7$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $e503e4dcb3c348c7$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $e2edf35eced5b7b2$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





const $602bbd5215211361$var$INTEGRATION_NAME = 'GlobalHandlers';
const $602bbd5215211361$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $602bbd5215211361$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $602bbd5215211361$var$_installGlobalOnErrorHandler(client);
                $602bbd5215211361$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $602bbd5215211361$var$_installGlobalOnUnhandledRejectionHandler(client);
                $602bbd5215211361$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $602bbd5215211361$export$66acc70e8cf2b71a = (0, $00abeec2398bba5c$export$2323046b9414659f)($602bbd5215211361$var$_globalHandlersIntegration);
function $602bbd5215211361$var$_installGlobalOnErrorHandler(client) {
    (0, $7d5c8cdfe8ab126c$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $602bbd5215211361$var$getOptions();
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client || (0, $d8b5c5326f8895cd$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $602bbd5215211361$var$_enhanceEventWithInitialFrame((0, $d85fd2ab7f9a30e0$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $fbf735d82d5bf8ab$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onerror'
            }
        });
    });
}
function $602bbd5215211361$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $e503e4dcb3c348c7$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $602bbd5215211361$var$getOptions();
        if ((0, $64ff6138fe06e713$export$6bb76d6eba7e258c)() !== client || (0, $d8b5c5326f8895cd$export$b79738ab10c590b2)()) return;
        const error = $602bbd5215211361$export$b2cc40fa8241780(e);
        const event = (0, $057f17bbb7048b01$export$c3825b437cbdea5c)(error) ? $602bbd5215211361$export$1353b5b36844a9ed(error) : (0, $d85fd2ab7f9a30e0$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $fbf735d82d5bf8ab$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'auto.browser.global_handlers.onunhandledrejection'
            }
        });
    });
}
/**
 *
 */ function $602bbd5215211361$export$b2cc40fa8241780(error) {
    if ((0, $057f17bbb7048b01$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch  {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $602bbd5215211361$export$1353b5b36844a9ed(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
function $602bbd5215211361$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = column;
    const lineno = line;
    const filename = $602bbd5215211361$var$getFilenameFromUrl(url) ?? (0, $8fe80379f466e1f6$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $7a317b2b764bd658$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $602bbd5215211361$var$globalHandlerLog(type) {
    (0, $1a670c87e40f63e7$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).log(`Global Handler attached: ${type}`);
}
function $602bbd5215211361$var$getOptions() {
    const client = (0, $64ff6138fe06e713$export$6bb76d6eba7e258c)();
    const options = client?.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}
function $602bbd5215211361$var$getFilenameFromUrl(url) {
    if (!(0, $057f17bbb7048b01$export$844ec244b1367d54)(url) || url.length === 0) return undefined;
    // Strip data URL content to avoid long base64 strings in stack frames
    // (e.g. when initializing a Worker with a base64 encoded script)
    // Don't include data prefix for filenames as it's not useful for stack traces
    // Wrap with < > to indicate it's a placeholder
    if (url.startsWith('data:')) return `<${(0, $af62e93da5e15d3a$export$8abd806fcaf234fa)(url, false)}>`;
    return url;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $9a7197251549155c$export$1378794447170364 = (0, $00abeec2398bba5c$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).navigator && !(0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).location && !(0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).document) return;
            const reqData = (0, $d8b5c5326f8895cd$export$a3c4a8453e8936f0)();
            const headers = {
                ...reqData.headers,
                ...event.request?.headers
            };
            event.request = {
                ...reqData,
                ...event.request,
                headers: headers
            };
        }
    };
});



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $9672f505e1e0e518$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, key, limit, event, hint) {
    if (!event.exception?.values || !hint || !(0, $057f17bbb7048b01$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $9672f505e1e0e518$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0);
}
function $9672f505e1e0e518$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $057f17bbb7048b01$export$49034edbe6b62415)(error[key], Error)) {
        $9672f505e1e0e518$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $9672f505e1e0e518$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $9672f505e1e0e518$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if ($9672f505e1e0e518$var$isExceptionGroup(error)) error.errors.forEach((childError, i)=>{
        if ((0, $057f17bbb7048b01$export$49034edbe6b62415)(childError, Error)) {
            $9672f505e1e0e518$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $9672f505e1e0e518$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $9672f505e1e0e518$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $9672f505e1e0e518$var$isExceptionGroup(error) {
    return Array.isArray(error.errors);
}
function $9672f505e1e0e518$var$applyExceptionGroupFieldsForParentException(exception, exceptionId, error) {
    exception.mechanism = {
        handled: true,
        type: 'auto.core.linked_errors',
        ...$9672f505e1e0e518$var$isExceptionGroup(error) && {
            is_exception_group: true
        },
        ...exception.mechanism,
        exception_id: exceptionId
    };
}
function $9672f505e1e0e518$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    exception.mechanism = {
        handled: true,
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}



const $22f11cd6f04a4c55$var$DEFAULT_KEY = 'cause';
const $22f11cd6f04a4c55$var$DEFAULT_LIMIT = 5;
const $22f11cd6f04a4c55$var$INTEGRATION_NAME = 'LinkedErrors';
const $22f11cd6f04a4c55$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $22f11cd6f04a4c55$var$DEFAULT_LIMIT;
    const key = options.key || $22f11cd6f04a4c55$var$DEFAULT_KEY;
    return {
        name: $22f11cd6f04a4c55$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $9672f505e1e0e518$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $d85fd2ab7f9a30e0$export$a6c2d27607295951), options.stackParser, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $22f11cd6f04a4c55$export$ebabb00eb7f3a395 = (0, $00abeec2398bba5c$export$2323046b9414659f)($22f11cd6f04a4c55$var$_linkedErrorsIntegration);




const $c1b301744660c7fc$var$OPERA10_PRIORITY = 10;
const $c1b301744660c7fc$var$OPERA11_PRIORITY = 20;
const $c1b301744660c7fc$var$CHROME_PRIORITY = 30;
const $c1b301744660c7fc$var$WINJS_PRIORITY = 40;
const $c1b301744660c7fc$var$GECKO_PRIORITY = 50;
function $c1b301744660c7fc$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $7a317b2b764bd658$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// This regex matches frames that have no function name (ie. are at the top level of a module).
// For example "at http://localhost:5000//script.js:1:126"
// Frames _with_ function names usually look as follows: "at commitLayoutEffects (react-dom.development.js:23426:1)"
const $c1b301744660c7fc$var$chromeRegexNoFnName = /^\s*at (\S+?)(?::(\d+))(?::(\d+))\s*$/i;
// This regex matches all the frames that have a function name.
const $c1b301744660c7fc$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $c1b301744660c7fc$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Matches stack frames with data URIs instead of filename so we can still get the function name
// Example: "at dynamicFn (data:application/javascript,export function dynamicFn() {..."
const $c1b301744660c7fc$var$chromeDataUriRegex = /at (.+?) ?\(data:(.+?),/;
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $c1b301744660c7fc$var$chromeStackParserFn = (line)=>{
    const dataUriMatch = line.match($c1b301744660c7fc$var$chromeDataUriRegex);
    if (dataUriMatch) return {
        filename: `<data:${dataUriMatch[2]}>`,
        function: dataUriMatch[1]
    };
    // If the stack line has no function name, we need to parse it differently
    const noFnParts = $c1b301744660c7fc$var$chromeRegexNoFnName.exec(line);
    if (noFnParts) {
        const [, filename, line, col] = noFnParts;
        return $c1b301744660c7fc$var$createFrame(filename, (0, $7a317b2b764bd658$export$27c7e15d453fc0ac), +line, +col);
    }
    const parts = $c1b301744660c7fc$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $c1b301744660c7fc$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $c1b301744660c7fc$var$extractSafariExtensionDetails(parts[1] || (0, $7a317b2b764bd658$export$27c7e15d453fc0ac), parts[2]);
        return $c1b301744660c7fc$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $c1b301744660c7fc$export$263a749fff749872 = [
    $c1b301744660c7fc$var$CHROME_PRIORITY,
    $c1b301744660c7fc$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $c1b301744660c7fc$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $c1b301744660c7fc$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $c1b301744660c7fc$var$gecko = (line)=>{
    const parts = $c1b301744660c7fc$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $c1b301744660c7fc$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $7a317b2b764bd658$export$27c7e15d453fc0ac);
        [func, filename] = $c1b301744660c7fc$var$extractSafariExtensionDetails(func, filename);
        return $c1b301744660c7fc$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $c1b301744660c7fc$export$cdba47a5dd2804d = [
    $c1b301744660c7fc$var$GECKO_PRIORITY,
    $c1b301744660c7fc$var$gecko
];
const $c1b301744660c7fc$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $c1b301744660c7fc$var$winjs = (line)=>{
    const parts = $c1b301744660c7fc$var$winjsRegex.exec(line);
    return parts ? $c1b301744660c7fc$var$createFrame(parts[2], parts[1] || (0, $7a317b2b764bd658$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $c1b301744660c7fc$export$179460296da408e8 = [
    $c1b301744660c7fc$var$WINJS_PRIORITY,
    $c1b301744660c7fc$var$winjs
];
const $c1b301744660c7fc$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $c1b301744660c7fc$var$opera10 = (line)=>{
    const parts = $c1b301744660c7fc$var$opera10Regex.exec(line);
    return parts ? $c1b301744660c7fc$var$createFrame(parts[2], parts[3] || (0, $7a317b2b764bd658$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $c1b301744660c7fc$export$f892b52c880ffc7a = [
    $c1b301744660c7fc$var$OPERA10_PRIORITY,
    $c1b301744660c7fc$var$opera10
];
const $c1b301744660c7fc$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $c1b301744660c7fc$var$opera11 = (line)=>{
    const parts = $c1b301744660c7fc$var$opera11Regex.exec(line);
    return parts ? $c1b301744660c7fc$var$createFrame(parts[5], parts[3] || parts[4] || (0, $7a317b2b764bd658$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $c1b301744660c7fc$export$af11af13f09fb0dc = [
    $c1b301744660c7fc$var$OPERA11_PRIORITY,
    $c1b301744660c7fc$var$opera11
];
const $c1b301744660c7fc$export$7197c0fe6554c079 = [
    $c1b301744660c7fc$export$263a749fff749872,
    $c1b301744660c7fc$export$cdba47a5dd2804d
];
const $c1b301744660c7fc$export$2b2b997d81bf3907 = (0, $7a317b2b764bd658$export$a5739666fb2d03d4)(...$c1b301744660c7fc$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $c1b301744660c7fc$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $7a317b2b764bd658$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};




/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2bc3ab9159c9e46f$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $e6c93398c9e1faaa$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $e6c93398c9e1faaa$export$e464f4a514ac28a8(name) {
    const cached = $e6c93398c9e1faaa$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $68290708259de2d6$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $63d2c47996651f52$export$d5f608b368e73f38)(impl)) return $e6c93398c9e1faaa$var$cachedImplementations[name] = impl.bind((0, $68290708259de2d6$export$56d8a8a25bd48b81));
    const document = (0, $68290708259de2d6$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow?.[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $2bc3ab9159c9e46f$export$16a28057038b10ef) && (0, $ff784a3dc7695b3c$export$1c9f709888824e05).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $e6c93398c9e1faaa$var$cachedImplementations[name] = impl.bind((0, $68290708259de2d6$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $e6c93398c9e1faaa$export$8aa36702e8c8978(name) {
    $e6c93398c9e1faaa$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $e6c93398c9e1faaa$export$e7aa7bc5c1b3cfb3(...rest) {
    return $e6c93398c9e1faaa$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $e6c93398c9e1faaa$export$831dc9f2ab0a617b(...rest) {
    return $e6c93398c9e1faaa$export$e464f4a514ac28a8('setTimeout')(...rest);
}


const $9a6372f0f9a691c3$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE = 40;
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9a6372f0f9a691c3$export$b2311068c46d7cc8(options, nativeFetch = (0, $e6c93398c9e1faaa$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    async function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'strict-origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. when finishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            // Note: We do not need to suppress tracing here, because we are using the native fetch, instead of our wrapped one.
            const response = await nativeFetch(options.url, requestOptions);
            return {
                statusCode: response.status,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After')
                }
            };
        } catch (e) {
            (0, $e6c93398c9e1faaa$export$8aa36702e8c8978)('fetch');
            throw e;
        } finally{
            pendingBodySize -= requestSize;
            pendingCount--;
        }
    }
    return (0, $9c0afdbdc0ce2604$export$d09f50d9ab7f7b69)(options, makeRequest, (0, $da9c6caf9b214510$export$85a4f67f852183e6)(options.bufferSize || $9a6372f0f9a691c3$var$DEFAULT_BROWSER_TRANSPORT_BUFFER_SIZE));
}





/**
 * Returns true if the SDK is running in an embedded browser extension.
 * Stand-alone browser extensions (which do not share the same data as the main browser page) are fine.
 */ function $987e4b3da4bfdfb9$export$dc236a86065879fc() {
    if ($987e4b3da4bfdfb9$var$_isEmbeddedBrowserExtension()) {
        if (0, $1a670c87e40f63e7$export$16a28057038b10ef) (0, $ff784a3dc7695b3c$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot use Sentry.init() in a browser extension, see: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return true;
    }
    return false;
}
function $987e4b3da4bfdfb9$var$_isEmbeddedBrowserExtension() {
    if (typeof (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).window === 'undefined') // No need to show the error if we're not in a browser window environment (e.g. service workers)
    return false;
    const _window = (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81);
    // Running the SDK in NW.js, which appears like a browser extension but isn't, is also fine
    // see: https://github.com/getsentry/sentry-javascript/issues/12668
    if (_window.nw) return false;
    const extensionObject = _window['chrome'] || _window['browser'];
    if (!extensionObject?.runtime?.id) return false;
    const href = (0, $8fe80379f466e1f6$export$1cfafeee2987818b)();
    const extensionProtocols = [
        'chrome-extension',
        'moz-extension',
        'ms-browser-extension',
        'safari-web-extension'
    ];
    // Running the SDK in a dedicated extension page and calling Sentry.init is fine; no risk of data leakage
    const isDedicatedExtensionPage = (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81) === (0, $d8b5c5326f8895cd$export$56d8a8a25bd48b81).top && extensionProtocols.some((protocol)=>href.startsWith(`${protocol}://`));
    return !isDedicatedExtensionPage;
}


/** Get the default integrations for the browser SDK. */ function $eb20a7636aae2fe3$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        // TODO(v11): Replace with `eventFiltersIntegration` once we remove the deprecated `inboundFiltersIntegration`
        // eslint-disable-next-line deprecation/deprecation
        (0, $d2a49612e9ecceb5$export$cb3c5c2ceb9818ba)(),
        (0, $7b15a7ab0b9e593d$export$7918117e9202e4fb)(),
        (0, $07bde267a5e3f791$export$97457a453081a5b3)(),
        (0, $763fce48c7fe1090$export$59bfe9f1c76150e)(),
        (0, $ac5ebea0403f6f58$export$c079d904b326663a)(),
        (0, $602bbd5215211361$export$66acc70e8cf2b71a)(),
        (0, $22f11cd6f04a4c55$export$ebabb00eb7f3a395)(),
        (0, $4d4fa9e396da88ac$export$6d39aa44cd0c7567)(),
        (0, $9a7197251549155c$export$1378794447170364)(),
        (0, $5c6bdac4a35adc93$export$1baa7880e357371c)()
    ];
}
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $eb20a7636aae2fe3$export$2cd8252107eb640b(options = {}) {
    const shouldDisableBecauseIsBrowserExtenstion = !options.skipBrowserExtensionCheck && (0, $987e4b3da4bfdfb9$export$dc236a86065879fc)();
    let defaultIntegrations = options.defaultIntegrations == null ? $eb20a7636aae2fe3$export$5783b2920b1d62b9() : options.defaultIntegrations;
    const clientOptions = {
        ...options,
        enabled: shouldDisableBecauseIsBrowserExtenstion ? false : options.enabled,
        stackParser: (0, $7a317b2b764bd658$export$1d5cf88b347146d4)(options.stackParser || (0, $c1b301744660c7fc$export$2b2b997d81bf3907)),
        integrations: (0, $00abeec2398bba5c$export$68bc4c01ab8ae766)({
            integrations: options.integrations,
            defaultIntegrations: defaultIntegrations
        }),
        transport: options.transport || (0, $9a6372f0f9a691c3$export$b2311068c46d7cc8)
    };
    return (0, $a74e51de1476d220$export$5333c3f1c58d9bc1)((0, $b79a341f278bd18d$export$1df9218a526d318d), clientOptions);
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $eb20a7636aae2fe3$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $eb20a7636aae2fe3$export$4e4d8b287d028b6b(callback) {
    callback();
}




var $kYL7Z = parcelRequire("kYL7Z");
/**
 * Inits the React SDK
 */ function $c932a85603fa1501$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $db3439a3565fcfe3$export$b9f95b027256052c)(opts, 'react');
    (0, $fbf735d82d5bf8ab$export$2f04de43fe27971a)('react', {
        version: $kYL7Z.version
    });
    return (0, $eb20a7636aae2fe3$export$2cd8252107eb640b)(opts);
}



const $a13d063d3fb3aa31$export$d43f2f435f160490 = "https://api.auravisionlabs.com";
const $a13d063d3fb3aa31$export$28f31de52ea27c12 = "https://users.auravision.ai";
const $a13d063d3fb3aa31$export$839cb5e51805b1a5 = "https://iot-command.auravision.ai";
const $a13d063d3fb3aa31$export$e33ab6722891f216 = "https://thumbnailer.auravisionlabs.com";
const $a13d063d3fb3aa31$export$fa3559c82ed925a = "https://app.auravisionlabs.com";
const $a13d063d3fb3aa31$export$1bc62597831f80f3 = "https://dash.auravision.ai";
const $a13d063d3fb3aa31$export$6ed6116aaa4a07d6 = "id.auravision.ai";
const $a13d063d3fb3aa31$export$458778b94eb61719 = "70bWvERe4iy6qGTEBAHnf7aJSB7M8QM6";
const $a13d063d3fb3aa31$export$b6344303c18d5a5e = true;
const $a13d063d3fb3aa31$export$d4214b4977c811ed = "AIzaSyCKiK1gArJ9AFw01clncIWxA5OqATD95jA";
const $a13d063d3fb3aa31$export$2510a7994c247cf7 = "AIzaSyAvGLAGFk3pB1fqK7WEGSy-RVL2RZ-E0kw";
const $a13d063d3fb3aa31$export$4625fcba3fc11d47 = "prod";




var $kYL7Z = parcelRequire("kYL7Z");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $ebba836a6d35485c$var$extendStatics = function(d, b) {
    $ebba836a6d35485c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $ebba836a6d35485c$var$extendStatics(d, b);
};
function $ebba836a6d35485c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $ebba836a6d35485c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $ebba836a6d35485c$export$18ce0697a983be9b = function() {
    $ebba836a6d35485c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ebba836a6d35485c$export$18ce0697a983be9b.apply(this, arguments);
};
function $ebba836a6d35485c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $ebba836a6d35485c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $ebba836a6d35485c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $ebba836a6d35485c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $ebba836a6d35485c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $ebba836a6d35485c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $ebba836a6d35485c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $ebba836a6d35485c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $ebba836a6d35485c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $ebba836a6d35485c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $ebba836a6d35485c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $ebba836a6d35485c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $ebba836a6d35485c$export$45d3717a4c69092e(o, m, p);
}
function $ebba836a6d35485c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $ebba836a6d35485c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $ebba836a6d35485c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($ebba836a6d35485c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $ebba836a6d35485c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $ebba836a6d35485c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $ebba836a6d35485c$export$10c90e4f7922046c(v) {
    return this instanceof $ebba836a6d35485c$export$10c90e4f7922046c ? (this.v = v, this) : new $ebba836a6d35485c$export$10c90e4f7922046c(v);
}
function $ebba836a6d35485c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $ebba836a6d35485c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $ebba836a6d35485c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $ebba836a6d35485c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $ebba836a6d35485c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $ebba836a6d35485c$export$19a8beecd37a4c45 === "function" ? $ebba836a6d35485c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $ebba836a6d35485c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $ebba836a6d35485c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $ebba836a6d35485c$var$ownKeys = function(o) {
    $ebba836a6d35485c$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $ebba836a6d35485c$var$ownKeys(o);
};
function $ebba836a6d35485c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $ebba836a6d35485c$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $ebba836a6d35485c$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $ebba836a6d35485c$var$__setModuleDefault(result, mod);
    return result;
}
function $ebba836a6d35485c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $ebba836a6d35485c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $ebba836a6d35485c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $ebba836a6d35485c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $ebba836a6d35485c$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $ebba836a6d35485c$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $ebba836a6d35485c$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $ebba836a6d35485c$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $ebba836a6d35485c$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $ebba836a6d35485c$export$2e2bcd8739ae039 = {
    __extends: $ebba836a6d35485c$export$a8ba968b8961cb8a,
    __assign: $ebba836a6d35485c$export$18ce0697a983be9b,
    __rest: $ebba836a6d35485c$export$3c9a16f847548506,
    __decorate: $ebba836a6d35485c$export$29e00dfd3077644b,
    __param: $ebba836a6d35485c$export$d5ad3fd78186038f,
    __esDecorate: $ebba836a6d35485c$export$3a84e1ae4e97e9b0,
    __runInitializers: $ebba836a6d35485c$export$d831c04e792af3d,
    __propKey: $ebba836a6d35485c$export$6a2a36740a146cb8,
    __setFunctionName: $ebba836a6d35485c$export$d1a06452d3489bc7,
    __metadata: $ebba836a6d35485c$export$f1db080c865becb9,
    __awaiter: $ebba836a6d35485c$export$1050f835b63b671e,
    __generator: $ebba836a6d35485c$export$67ebef60e6f28a6,
    __createBinding: $ebba836a6d35485c$export$45d3717a4c69092e,
    __exportStar: $ebba836a6d35485c$export$f33643c0debef087,
    __values: $ebba836a6d35485c$export$19a8beecd37a4c45,
    __read: $ebba836a6d35485c$export$8d051b38c9118094,
    __spread: $ebba836a6d35485c$export$afc72e2116322959,
    __spreadArrays: $ebba836a6d35485c$export$6388937ca91ccae8,
    __spreadArray: $ebba836a6d35485c$export$1216008129fb82ed,
    __await: $ebba836a6d35485c$export$10c90e4f7922046c,
    __asyncGenerator: $ebba836a6d35485c$export$e427f37a30a4de9b,
    __asyncDelegator: $ebba836a6d35485c$export$bbd80228419bb833,
    __asyncValues: $ebba836a6d35485c$export$e3b29a3d6162315f,
    __makeTemplateObject: $ebba836a6d35485c$export$4fb47efe1390b86f,
    __importStar: $ebba836a6d35485c$export$c21735bcef00d192,
    __importDefault: $ebba836a6d35485c$export$da59b14a69baef04,
    __classPrivateFieldGet: $ebba836a6d35485c$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $ebba836a6d35485c$export$d40a35129aaff81f,
    __classPrivateFieldIn: $ebba836a6d35485c$export$81fdc39f203e4e04,
    __addDisposableResource: $ebba836a6d35485c$export$88ac25d8e944e405,
    __disposeResources: $ebba836a6d35485c$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $ebba836a6d35485c$export$889dfb5d17574b0b
};


function $78c62715703babd4$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


// eslint-disable-next-line no-undef
var $8ece34f03d6420fa$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $8ece34f03d6420fa$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $78c62715703babd4$export$2e2bcd8739ae039)(function(prop) {
    return $8ece34f03d6420fa$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $kYL7Z = parcelRequire("kYL7Z");
var $51b2b888e4316b33$export$71ad59f2e432cfe8 = "-ms-";
var $51b2b888e4316b33$export$2c0f367103c8d01c = "-moz-";
var $51b2b888e4316b33$export$39dfd62a25e0fe93 = "-webkit-";
var $51b2b888e4316b33$export$a29989082612d0d9 = "comm";
var $51b2b888e4316b33$export$aa3a2e812ca8570d = "rule";
var $51b2b888e4316b33$export$527d108ccf083c2b = "decl";
var $51b2b888e4316b33$export$d3d35020fa5b54f0 = "@page";
var $51b2b888e4316b33$export$500415a86c544f73 = "@media";
var $51b2b888e4316b33$export$a763edbf796b780a = "@import";
var $51b2b888e4316b33$export$2790aeb8b4e5c826 = "@charset";
var $51b2b888e4316b33$export$1cc683e23b84b133 = "@viewport";
var $51b2b888e4316b33$export$9447a5efea57e862 = "@supports";
var $51b2b888e4316b33$export$ef011b4e114b1fba = "@document";
var $51b2b888e4316b33$export$6aad947bda0f3f46 = "@namespace";
var $51b2b888e4316b33$export$b44a8529a35fcb60 = "@keyframes";
var $51b2b888e4316b33$export$2c16de31893252e6 = "@font-face";
var $51b2b888e4316b33$export$3d846dd52e150c6f = "@counter-style";
var $51b2b888e4316b33$export$22314bfbb57653fe = "@font-feature-values";
var $51b2b888e4316b33$export$d773506282b3cfe6 = "@layer";
var $51b2b888e4316b33$export$1c5a554c78c0cd12 = "@scope";
var $51b2b888e4316b33$export$2335f513bbd82c6d = Math.abs;
var $51b2b888e4316b33$export$6788812c4e6611e6 = String.fromCharCode;
var $51b2b888e4316b33$export$e6e34fd1f2686227 = Object.assign;
function $51b2b888e4316b33$export$d6af199866bfb566(e, r) {
    return $51b2b888e4316b33$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $51b2b888e4316b33$export$a9db5e087081082d(e, 0)) << 2 ^ $51b2b888e4316b33$export$a9db5e087081082d(e, 1)) << 2 ^ $51b2b888e4316b33$export$a9db5e087081082d(e, 2)) << 2 ^ $51b2b888e4316b33$export$a9db5e087081082d(e, 3) : 0;
}
function $51b2b888e4316b33$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $51b2b888e4316b33$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $51b2b888e4316b33$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $51b2b888e4316b33$export$f8e21b1e77979a08(e, r, a) {
    return e.indexOf(r, a);
}
function $51b2b888e4316b33$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $51b2b888e4316b33$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $51b2b888e4316b33$export$36776f635604f274(e) {
    return e.length;
}
function $51b2b888e4316b33$export$f9084667e487ed46(e) {
    return e.length;
}
function $51b2b888e4316b33$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $51b2b888e4316b33$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
function $51b2b888e4316b33$export$3dea766d36a8935f(e, r) {
    return e.filter(function(e) {
        return !$51b2b888e4316b33$export$4659b591c19bdf3d(e, r);
    });
}
var $51b2b888e4316b33$export$53f1d5ea8de3d7c = 1;
var $51b2b888e4316b33$export$4e0c71f277ca26b3 = 1;
var $51b2b888e4316b33$export$f24224f1c91d8156 = 0;
var $51b2b888e4316b33$export$5880b8b5730aff45 = 0;
var $51b2b888e4316b33$export$c0306caf338ac095 = 0;
var $51b2b888e4316b33$export$30a86d91af8ff6e6 = "";
function $51b2b888e4316b33$export$35059013cd4a06db(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: $51b2b888e4316b33$export$53f1d5ea8de3d7c,
        column: $51b2b888e4316b33$export$4e0c71f277ca26b3,
        length: t,
        return: "",
        siblings: u
    };
}
function $51b2b888e4316b33$export$784d13d8ee351f07(e, r) {
    return $51b2b888e4316b33$export$e6e34fd1f2686227($51b2b888e4316b33$export$35059013cd4a06db("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function $51b2b888e4316b33$export$590e8b2c435046d9(e) {
    while(e.root)e = $51b2b888e4316b33$export$784d13d8ee351f07(e.root, {
        children: [
            e
        ]
    });
    $51b2b888e4316b33$export$10d8903dec122b9d(e, e.siblings);
}
function $51b2b888e4316b33$export$eba6f6f03b0a92e7() {
    return $51b2b888e4316b33$export$c0306caf338ac095;
}
function $51b2b888e4316b33$export$232faf9add678146() {
    $51b2b888e4316b33$export$c0306caf338ac095 = $51b2b888e4316b33$export$5880b8b5730aff45 > 0 ? $51b2b888e4316b33$export$a9db5e087081082d($51b2b888e4316b33$export$30a86d91af8ff6e6, --$51b2b888e4316b33$export$5880b8b5730aff45) : 0;
    if ($51b2b888e4316b33$export$4e0c71f277ca26b3--, $51b2b888e4316b33$export$c0306caf338ac095 === 10) $51b2b888e4316b33$export$4e0c71f277ca26b3 = 1, $51b2b888e4316b33$export$53f1d5ea8de3d7c--;
    return $51b2b888e4316b33$export$c0306caf338ac095;
}
function $51b2b888e4316b33$export$48cfd1e771a65c4f() {
    $51b2b888e4316b33$export$c0306caf338ac095 = $51b2b888e4316b33$export$5880b8b5730aff45 < $51b2b888e4316b33$export$f24224f1c91d8156 ? $51b2b888e4316b33$export$a9db5e087081082d($51b2b888e4316b33$export$30a86d91af8ff6e6, $51b2b888e4316b33$export$5880b8b5730aff45++) : 0;
    if ($51b2b888e4316b33$export$4e0c71f277ca26b3++, $51b2b888e4316b33$export$c0306caf338ac095 === 10) $51b2b888e4316b33$export$4e0c71f277ca26b3 = 1, $51b2b888e4316b33$export$53f1d5ea8de3d7c++;
    return $51b2b888e4316b33$export$c0306caf338ac095;
}
function $51b2b888e4316b33$export$4d3fb11e950abb9e() {
    return $51b2b888e4316b33$export$a9db5e087081082d($51b2b888e4316b33$export$30a86d91af8ff6e6, $51b2b888e4316b33$export$5880b8b5730aff45);
}
function $51b2b888e4316b33$export$e88cb2efb12ae807() {
    return $51b2b888e4316b33$export$5880b8b5730aff45;
}
function $51b2b888e4316b33$export$58adb3bec8346d0f(e, r) {
    return $51b2b888e4316b33$export$2f35ab04d2335697($51b2b888e4316b33$export$30a86d91af8ff6e6, e, r);
}
function $51b2b888e4316b33$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $51b2b888e4316b33$export$2de70f21292aac9e(e) {
    return $51b2b888e4316b33$export$53f1d5ea8de3d7c = $51b2b888e4316b33$export$4e0c71f277ca26b3 = 1, $51b2b888e4316b33$export$f24224f1c91d8156 = $51b2b888e4316b33$export$36776f635604f274($51b2b888e4316b33$export$30a86d91af8ff6e6 = e), $51b2b888e4316b33$export$5880b8b5730aff45 = 0, [];
}
function $51b2b888e4316b33$export$45918ac1574455b1(e) {
    return $51b2b888e4316b33$export$30a86d91af8ff6e6 = "", e;
}
function $51b2b888e4316b33$export$410ac95b9ec204b8(e) {
    return $51b2b888e4316b33$export$87c2784dc9fc4ab($51b2b888e4316b33$export$58adb3bec8346d0f($51b2b888e4316b33$export$5880b8b5730aff45 - 1, $51b2b888e4316b33$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $51b2b888e4316b33$export$660b2ee2d4fb4eff(e) {
    return $51b2b888e4316b33$export$45918ac1574455b1($51b2b888e4316b33$export$5f8c09e3ae6f64e1($51b2b888e4316b33$export$2de70f21292aac9e(e)));
}
function $51b2b888e4316b33$export$7af1228ff777d175(e) {
    while($51b2b888e4316b33$export$c0306caf338ac095 = $51b2b888e4316b33$export$4d3fb11e950abb9e())if ($51b2b888e4316b33$export$c0306caf338ac095 < 33) $51b2b888e4316b33$export$48cfd1e771a65c4f();
    else break;
    return $51b2b888e4316b33$export$9e1725a4cfeada27(e) > 2 || $51b2b888e4316b33$export$9e1725a4cfeada27($51b2b888e4316b33$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $51b2b888e4316b33$export$5f8c09e3ae6f64e1(e) {
    while($51b2b888e4316b33$export$48cfd1e771a65c4f())switch($51b2b888e4316b33$export$9e1725a4cfeada27($51b2b888e4316b33$export$c0306caf338ac095)){
        case 0:
            $51b2b888e4316b33$export$10d8903dec122b9d($51b2b888e4316b33$export$c2ab62c7bf24634($51b2b888e4316b33$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $51b2b888e4316b33$export$10d8903dec122b9d($51b2b888e4316b33$export$410ac95b9ec204b8($51b2b888e4316b33$export$c0306caf338ac095), e);
            break;
        default:
            $51b2b888e4316b33$export$10d8903dec122b9d($51b2b888e4316b33$export$6788812c4e6611e6($51b2b888e4316b33$export$c0306caf338ac095), e);
    }
    return e;
}
function $51b2b888e4316b33$export$955ba06d119e085e(e, r) {
    while(--r && $51b2b888e4316b33$export$48cfd1e771a65c4f())if ($51b2b888e4316b33$export$c0306caf338ac095 < 48 || $51b2b888e4316b33$export$c0306caf338ac095 > 102 || $51b2b888e4316b33$export$c0306caf338ac095 > 57 && $51b2b888e4316b33$export$c0306caf338ac095 < 65 || $51b2b888e4316b33$export$c0306caf338ac095 > 70 && $51b2b888e4316b33$export$c0306caf338ac095 < 97) break;
    return $51b2b888e4316b33$export$58adb3bec8346d0f(e, $51b2b888e4316b33$export$e88cb2efb12ae807() + (r < 6 && $51b2b888e4316b33$export$4d3fb11e950abb9e() == 32 && $51b2b888e4316b33$export$48cfd1e771a65c4f() == 32));
}
function $51b2b888e4316b33$export$c889f2fcc19dbf12(e) {
    while($51b2b888e4316b33$export$48cfd1e771a65c4f())switch($51b2b888e4316b33$export$c0306caf338ac095){
        case e:
            return $51b2b888e4316b33$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $51b2b888e4316b33$export$c889f2fcc19dbf12($51b2b888e4316b33$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $51b2b888e4316b33$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $51b2b888e4316b33$export$48cfd1e771a65c4f();
            break;
    }
    return $51b2b888e4316b33$export$5880b8b5730aff45;
}
function $51b2b888e4316b33$export$4254d4e2b3745c4c(e, r) {
    while($51b2b888e4316b33$export$48cfd1e771a65c4f())if (e + $51b2b888e4316b33$export$c0306caf338ac095 === 57) break;
    else if (e + $51b2b888e4316b33$export$c0306caf338ac095 === 84 && $51b2b888e4316b33$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $51b2b888e4316b33$export$58adb3bec8346d0f(r, $51b2b888e4316b33$export$5880b8b5730aff45 - 1) + "*" + $51b2b888e4316b33$export$6788812c4e6611e6(e === 47 ? e : $51b2b888e4316b33$export$48cfd1e771a65c4f());
}
function $51b2b888e4316b33$export$c2ab62c7bf24634(e) {
    while(!$51b2b888e4316b33$export$9e1725a4cfeada27($51b2b888e4316b33$export$4d3fb11e950abb9e()))$51b2b888e4316b33$export$48cfd1e771a65c4f();
    return $51b2b888e4316b33$export$58adb3bec8346d0f(e, $51b2b888e4316b33$export$5880b8b5730aff45);
}
function $51b2b888e4316b33$export$ef7acd7185315e22(e) {
    return $51b2b888e4316b33$export$45918ac1574455b1($51b2b888e4316b33$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $51b2b888e4316b33$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $51b2b888e4316b33$export$98e6a39c04603d36(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = $51b2b888e4316b33$export$48cfd1e771a65c4f()){
        case 40:
            if (b != 108 && $51b2b888e4316b33$export$a9db5e087081082d(z, l - 1) == 58) {
                if ($51b2b888e4316b33$export$f8e21b1e77979a08(z += $51b2b888e4316b33$export$77ad94ebf1c2b9ed($51b2b888e4316b33$export$410ac95b9ec204b8(g), "&", "&\f"), "&\f", $51b2b888e4316b33$export$2335f513bbd82c6d(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += $51b2b888e4316b33$export$410ac95b9ec204b8(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += $51b2b888e4316b33$export$7af1228ff777d175(b);
            break;
        case 92:
            z += $51b2b888e4316b33$export$955ba06d119e085e($51b2b888e4316b33$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($51b2b888e4316b33$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $51b2b888e4316b33$export$10d8903dec122b9d($51b2b888e4316b33$export$4a34f930e789283c($51b2b888e4316b33$export$4254d4e2b3745c4c($51b2b888e4316b33$export$48cfd1e771a65c4f(), $51b2b888e4316b33$export$e88cb2efb12ae807()), r, a, i), i);
                    if (($51b2b888e4316b33$export$9e1725a4cfeada27(b || 1) == 5 || $51b2b888e4316b33$export$9e1725a4cfeada27($51b2b888e4316b33$export$4d3fb11e950abb9e() || 1) == 5) && $51b2b888e4316b33$export$36776f635604f274(z) && $51b2b888e4316b33$export$2f35ab04d2335697(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = $51b2b888e4316b33$export$36776f635604f274(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = $51b2b888e4316b33$export$77ad94ebf1c2b9ed(z, /\f/g, "");
                    if (v > 0 && ($51b2b888e4316b33$export$36776f635604f274(z) - l || h === 0 && b === 47)) $51b2b888e4316b33$export$10d8903dec122b9d(v > 32 ? $51b2b888e4316b33$export$f8483753829ec8f3(z + ";", c, a, l - 1, i) : $51b2b888e4316b33$export$f8483753829ec8f3($51b2b888e4316b33$export$77ad94ebf1c2b9ed(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    $51b2b888e4316b33$export$10d8903dec122b9d(j = $51b2b888e4316b33$export$3307ffa7023ede1e(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) $51b2b888e4316b33$export$98e6a39c04603d36(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if ($51b2b888e4316b33$export$a9db5e087081082d(z, 3) === 110) break;
                                case 108:
                                    if ($51b2b888e4316b33$export$a9db5e087081082d(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) $51b2b888e4316b33$export$98e6a39c04603d36(e, j, j, c && $51b2b888e4316b33$export$10d8903dec122b9d($51b2b888e4316b33$export$3307ffa7023ede1e(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else $51b2b888e4316b33$export$98e6a39c04603d36(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + $51b2b888e4316b33$export$36776f635604f274(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && $51b2b888e4316b33$export$232faf9add678146() == 125) continue;
            }
            switch(z += $51b2b888e4316b33$export$6788812c4e6611e6(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($51b2b888e4316b33$export$36776f635604f274(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($51b2b888e4316b33$export$4d3fb11e950abb9e() === 45) z += $51b2b888e4316b33$export$410ac95b9ec204b8($51b2b888e4316b33$export$48cfd1e771a65c4f());
                    p = $51b2b888e4316b33$export$4d3fb11e950abb9e(), o = l = $51b2b888e4316b33$export$36776f635604f274(k = z += $51b2b888e4316b33$export$c2ab62c7bf24634($51b2b888e4316b33$export$e88cb2efb12ae807())), g++;
                    break;
                case 45:
                    if (b === 45 && $51b2b888e4316b33$export$36776f635604f274(z) == 2) h = 0;
            }
    }
    return s;
}
function $51b2b888e4316b33$export$3307ffa7023ede1e(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = $51b2b888e4316b33$export$f9084667e487ed46(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = $51b2b888e4316b33$export$2f35ab04d2335697(e, v + 1, v = $51b2b888e4316b33$export$2335f513bbd82c6d(d = u[w])), x = e; k < h; ++k)if (x = $51b2b888e4316b33$export$87c2784dc9fc4ab(d > 0 ? b[k] + " " + m : $51b2b888e4316b33$export$77ad94ebf1c2b9ed(m, /&\f/g, b[k]))) f[g++] = x;
    return $51b2b888e4316b33$export$35059013cd4a06db(e, r, a, s === 0 ? $51b2b888e4316b33$export$aa3a2e812ca8570d : i, f, o, l, p);
}
function $51b2b888e4316b33$export$4a34f930e789283c(e, r, a, n) {
    return $51b2b888e4316b33$export$35059013cd4a06db(e, r, a, $51b2b888e4316b33$export$a29989082612d0d9, $51b2b888e4316b33$export$6788812c4e6611e6($51b2b888e4316b33$export$eba6f6f03b0a92e7()), $51b2b888e4316b33$export$2f35ab04d2335697(e, 2, -2), 0, n);
}
function $51b2b888e4316b33$export$f8483753829ec8f3(e, r, a, c, n) {
    return $51b2b888e4316b33$export$35059013cd4a06db(e, r, a, $51b2b888e4316b33$export$527d108ccf083c2b, $51b2b888e4316b33$export$2f35ab04d2335697(e, 0, c), $51b2b888e4316b33$export$2f35ab04d2335697(e, c + 1, -1), c, n);
}
function $51b2b888e4316b33$export$82e9f45cca5ba907(c, n, s) {
    switch($51b2b888e4316b33$export$d6af199866bfb566(c, n)){
        case 5103:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + c;
        case 4855:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return $51b2b888e4316b33$export$2c0f367103c8d01c + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$2c0f367103c8d01c + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + c + c;
        case 5936:
            switch($51b2b888e4316b33$export$a9db5e087081082d(c, n + 11)){
                case 114:
                    return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + c + c;
        case 6165:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + "flex-" + c + c;
        case 5187:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(\w+).+(:[^]+)/, $51b2b888e4316b33$export$39dfd62a25e0fe93 + "box-$1$2" + $51b2b888e4316b33$export$71ad59f2e432cfe8 + "flex-$1$2") + c;
        case 5443:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + "flex-item-" + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") + (!$51b2b888e4316b33$export$4659b591c19bdf3d(c, /flex-|baseline/) ? $51b2b888e4316b33$export$71ad59f2e432cfe8 + "grid-row-" + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + "flex-line-pack" + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "shrink", "negative") + c;
        case 5292:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "basis", "preferred-size") + c;
        case 6060:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + "box-" + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "-grow", "") + $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "grow", "positive") + c;
        case 4554:
            return $51b2b888e4316b33$export$39dfd62a25e0fe93 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /([^-])(transform)/g, "$1" + $51b2b888e4316b33$export$39dfd62a25e0fe93 + "$2") + c;
        case 6187:
            return $51b2b888e4316b33$export$77ad94ebf1c2b9ed($51b2b888e4316b33$export$77ad94ebf1c2b9ed($51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(zoom-|grab)/, $51b2b888e4316b33$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $51b2b888e4316b33$export$39dfd62a25e0fe93 + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(image-set\([^]*)/, $51b2b888e4316b33$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $51b2b888e4316b33$export$77ad94ebf1c2b9ed($51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(.+:)(flex-)?(.*)/, $51b2b888e4316b33$export$39dfd62a25e0fe93 + "box-pack:$3" + $51b2b888e4316b33$export$71ad59f2e432cfe8 + "flex-pack:$3"), /space-between/, "justify") + $51b2b888e4316b33$export$39dfd62a25e0fe93 + c + c;
        case 4200:
            if (!$51b2b888e4316b33$export$4659b591c19bdf3d(c, /flex-|baseline/)) return $51b2b888e4316b33$export$71ad59f2e432cfe8 + "grid-column-align" + $51b2b888e4316b33$export$2f35ab04d2335697(c, n) + c;
            break;
        case 2592:
        case 3360:
            return $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, $51b2b888e4316b33$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$51b2b888e4316b33$export$f8e21b1e77979a08(c + (s = s[n].value), "span", 0) ? c : $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "-start", "") + c + $51b2b888e4316b33$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$51b2b888e4316b33$export$f8e21b1e77979a08(s, "span", 0) ? $51b2b888e4316b33$export$4659b591c19bdf3d(s, /\d+/) : +$51b2b888e4316b33$export$4659b591c19bdf3d(s, /\d+/) - +$51b2b888e4316b33$export$4659b591c19bdf3d(c, /\d+/)) + ";";
            return $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $51b2b888e4316b33$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? c : $51b2b888e4316b33$export$71ad59f2e432cfe8 + $51b2b888e4316b33$export$77ad94ebf1c2b9ed($51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(.+)-inline(.+)/, $51b2b888e4316b33$export$39dfd62a25e0fe93 + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($51b2b888e4316b33$export$36776f635604f274(c) - 1 - n > 6) switch($51b2b888e4316b33$export$a9db5e087081082d(c, n + 1)){
                case 109:
                    if ($51b2b888e4316b33$export$a9db5e087081082d(c, n + 4) !== 45) break;
                case 102:
                    return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(.+:)(.+)-([^]+)/, "$1" + $51b2b888e4316b33$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $51b2b888e4316b33$export$2c0f367103c8d01c + ($51b2b888e4316b33$export$a9db5e087081082d(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~$51b2b888e4316b33$export$f8e21b1e77979a08(c, "stretch", 0) ? $51b2b888e4316b33$export$82e9f45cca5ba907($51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return $51b2b888e4316b33$export$71ad59f2e432cfe8 + a + ":" + n + i + (s ? $51b2b888e4316b33$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if ($51b2b888e4316b33$export$a9db5e087081082d(c, n + 6) === 121) return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, ":", ":" + $51b2b888e4316b33$export$39dfd62a25e0fe93) + c;
            break;
        case 6444:
            switch($51b2b888e4316b33$export$a9db5e087081082d(c, $51b2b888e4316b33$export$a9db5e087081082d(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $51b2b888e4316b33$export$39dfd62a25e0fe93 + ($51b2b888e4316b33$export$a9db5e087081082d(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $51b2b888e4316b33$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $51b2b888e4316b33$export$71ad59f2e432cfe8 + "$2box$3") + c;
                case 100:
                    return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, ":", ":" + $51b2b888e4316b33$export$71ad59f2e432cfe8) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function $51b2b888e4316b33$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $51b2b888e4316b33$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $51b2b888e4316b33$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $51b2b888e4316b33$export$a763edbf796b780a:
        case $51b2b888e4316b33$export$6aad947bda0f3f46:
        case $51b2b888e4316b33$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $51b2b888e4316b33$export$a29989082612d0d9:
            return "";
        case $51b2b888e4316b33$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $51b2b888e4316b33$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $51b2b888e4316b33$export$aa3a2e812ca8570d:
            if (!$51b2b888e4316b33$export$36776f635604f274(e.value = e.props.join(","))) return "";
    }
    return $51b2b888e4316b33$export$36776f635604f274(a = $51b2b888e4316b33$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $51b2b888e4316b33$export$5a7767152ae0305f(e) {
    var r = $51b2b888e4316b33$export$f9084667e487ed46(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function $51b2b888e4316b33$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $51b2b888e4316b33$export$e08c7d021b829b7a(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case $51b2b888e4316b33$export$527d108ccf083c2b:
                c.return = $51b2b888e4316b33$export$82e9f45cca5ba907(c.value, c.length, u);
                return;
            case $51b2b888e4316b33$export$b44a8529a35fcb60:
                return $51b2b888e4316b33$export$dfdc1655ccc5b9cb([
                    $51b2b888e4316b33$export$784d13d8ee351f07(c, {
                        value: $51b2b888e4316b33$export$77ad94ebf1c2b9ed(c.value, "@", "@" + $51b2b888e4316b33$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $51b2b888e4316b33$export$aa3a2e812ca8570d:
                if (c.length) return $51b2b888e4316b33$export$1be1fc439b849fdf(u = c.props, function(n) {
                    switch($51b2b888e4316b33$export$4659b591c19bdf3d(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            $51b2b888e4316b33$export$590e8b2c435046d9($51b2b888e4316b33$export$784d13d8ee351f07(c, {
                                props: [
                                    $51b2b888e4316b33$export$77ad94ebf1c2b9ed(n, /:(read-\w+)/, ":" + $51b2b888e4316b33$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $51b2b888e4316b33$export$590e8b2c435046d9($51b2b888e4316b33$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $51b2b888e4316b33$export$e6e34fd1f2686227(c, {
                                props: $51b2b888e4316b33$export$3dea766d36a8935f(u, i)
                            });
                            break;
                        case "::placeholder":
                            $51b2b888e4316b33$export$590e8b2c435046d9($51b2b888e4316b33$export$784d13d8ee351f07(c, {
                                props: [
                                    $51b2b888e4316b33$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $51b2b888e4316b33$export$39dfd62a25e0fe93 + "input-$1")
                                ]
                            }));
                            $51b2b888e4316b33$export$590e8b2c435046d9($51b2b888e4316b33$export$784d13d8ee351f07(c, {
                                props: [
                                    $51b2b888e4316b33$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, ":" + $51b2b888e4316b33$export$2c0f367103c8d01c + "$1")
                                ]
                            }));
                            $51b2b888e4316b33$export$590e8b2c435046d9($51b2b888e4316b33$export$784d13d8ee351f07(c, {
                                props: [
                                    $51b2b888e4316b33$export$77ad94ebf1c2b9ed(n, /:(plac\w+)/, $51b2b888e4316b33$export$71ad59f2e432cfe8 + "input-$1")
                                ]
                            }));
                            $51b2b888e4316b33$export$590e8b2c435046d9($51b2b888e4316b33$export$784d13d8ee351f07(c, {
                                props: [
                                    n
                                ]
                            }));
                            $51b2b888e4316b33$export$e6e34fd1f2686227(c, {
                                props: $51b2b888e4316b33$export$3dea766d36a8935f(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function $51b2b888e4316b33$export$76a88f7de6507443(e) {
    switch(e.type){
        case $51b2b888e4316b33$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $51b2b888e4316b33$export$1be1fc439b849fdf($51b2b888e4316b33$export$660b2ee2d4fb4eff(r), function(r, a, c) {
                    switch($51b2b888e4316b33$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $51b2b888e4316b33$export$2f35ab04d2335697(r, 1, $51b2b888e4316b33$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + $51b2b888e4316b33$export$2f35ab04d2335697(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $51b2b888e4316b33$export$f9084667e487ed46(c) > 1 ? "" : r;
                                case a = $51b2b888e4316b33$export$f9084667e487ed46(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $f35d4e7f999e2519$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};


var $564f85e69a9a6189$var$a = "data-styled", $564f85e69a9a6189$var$c = "active", $564f85e69a9a6189$var$u = "data-styled-version", $564f85e69a9a6189$export$83d89fbfd8236492 = "6.3.9", $564f85e69a9a6189$var$d = "/*!sc*/\n", $564f85e69a9a6189$var$h = "undefined" != typeof window && "undefined" != typeof document, $564f85e69a9a6189$var$p = void 0 === (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext, $564f85e69a9a6189$var$f = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : false), $564f85e69a9a6189$var$m = {}, $564f85e69a9a6189$var$y = /invalid hook call/i, $564f85e69a9a6189$var$v = new Set, $564f85e69a9a6189$var$g = function(t, n) {
    var o, s, i, a, e;
}, $564f85e69a9a6189$var$S = Object.freeze([]), $564f85e69a9a6189$var$w = Object.freeze({});
function $564f85e69a9a6189$var$b(e, t, n) {
    return void 0 === n && (n = $564f85e69a9a6189$var$w), e.theme !== n.theme && e.theme || t || n.theme;
}
var $564f85e69a9a6189$var$N = new Set([
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "button",
    "br",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "main",
    "map",
    "mark",
    "menu",
    "meter",
    "nav",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "search",
    "section",
    "select",
    "slot",
    "small",
    "span",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "tspan",
    "use"
]), $564f85e69a9a6189$var$E = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $564f85e69a9a6189$var$C = /(^-|-$)/g;
function $564f85e69a9a6189$var$A(e) {
    return e.replace($564f85e69a9a6189$var$E, "-").replace($564f85e69a9a6189$var$C, "");
}
var $564f85e69a9a6189$var$_ = /(a)(d)/gi, $564f85e69a9a6189$var$P = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $564f85e69a9a6189$var$I(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $564f85e69a9a6189$var$P(t % 52) + n;
    return ($564f85e69a9a6189$var$P(t % 52) + n).replace($564f85e69a9a6189$var$_, "$1-$2");
}
var $564f85e69a9a6189$var$O, $564f85e69a9a6189$var$D = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $564f85e69a9a6189$var$R = function(e) {
    return $564f85e69a9a6189$var$D(5381, e);
};
function $564f85e69a9a6189$var$T(e) {
    return $564f85e69a9a6189$var$I($564f85e69a9a6189$var$R(e) >>> 0);
}
function $564f85e69a9a6189$var$x(e) {
    return e.displayName || e.name || "Component";
}
function $564f85e69a9a6189$var$j(e) {
    return "string" == typeof e && true;
}
var $564f85e69a9a6189$var$k = "function" == typeof Symbol && Symbol.for, $564f85e69a9a6189$var$M = $564f85e69a9a6189$var$k ? Symbol.for("react.memo") : 60115, $564f85e69a9a6189$var$V = $564f85e69a9a6189$var$k ? Symbol.for("react.forward_ref") : 60112, $564f85e69a9a6189$var$F = {
    childContextTypes: !0,
    contextType: !0,
    contextTypes: !0,
    defaultProps: !0,
    displayName: !0,
    getDefaultProps: !0,
    getDerivedStateFromError: !0,
    getDerivedStateFromProps: !0,
    mixins: !0,
    propTypes: !0,
    type: !0
}, $564f85e69a9a6189$var$G = {
    name: !0,
    length: !0,
    prototype: !0,
    caller: !0,
    callee: !0,
    arguments: !0,
    arity: !0
}, $564f85e69a9a6189$var$L = {
    $$typeof: !0,
    compare: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0,
    type: !0
}, $564f85e69a9a6189$var$B = (($564f85e69a9a6189$var$O = {})[$564f85e69a9a6189$var$V] = {
    $$typeof: !0,
    render: !0,
    defaultProps: !0,
    displayName: !0,
    propTypes: !0
}, $564f85e69a9a6189$var$O[$564f85e69a9a6189$var$M] = $564f85e69a9a6189$var$L, $564f85e69a9a6189$var$O);
function $564f85e69a9a6189$var$z(e) {
    var t;
    return ("type" in (t = e) && t.type.$$typeof) === $564f85e69a9a6189$var$M ? $564f85e69a9a6189$var$L : "$$typeof" in e ? $564f85e69a9a6189$var$B[e.$$typeof] : $564f85e69a9a6189$var$F;
}
var $564f85e69a9a6189$var$$ = Object.defineProperty, $564f85e69a9a6189$var$Y = Object.getOwnPropertyNames, $564f85e69a9a6189$var$W = Object.getOwnPropertySymbols, $564f85e69a9a6189$var$q = Object.getOwnPropertyDescriptor, $564f85e69a9a6189$var$H = Object.getPrototypeOf, $564f85e69a9a6189$var$U = Object.prototype;
function $564f85e69a9a6189$var$J(e, t, n) {
    if ("string" != typeof t) {
        if ($564f85e69a9a6189$var$U) {
            var r = $564f85e69a9a6189$var$H(t);
            r && r !== $564f85e69a9a6189$var$U && $564f85e69a9a6189$var$J(e, r, n);
        }
        var o = $564f85e69a9a6189$var$Y(t);
        $564f85e69a9a6189$var$W && (o = o.concat($564f85e69a9a6189$var$W(t)));
        for(var s = $564f85e69a9a6189$var$z(e), i = $564f85e69a9a6189$var$z(t), a = 0; a < o.length; ++a){
            var c = o[a];
            if (!(c in $564f85e69a9a6189$var$G || n && n[c] || i && c in i || s && c in s)) {
                var u = $564f85e69a9a6189$var$q(t, c);
                try {
                    $564f85e69a9a6189$var$$(e, c, u);
                } catch (e) {}
            }
        }
    }
    return e;
}
function $564f85e69a9a6189$var$X(e) {
    return "function" == typeof e;
}
function $564f85e69a9a6189$export$7ba318d8d2f06c76(e) {
    return "object" == typeof e && "styledComponentId" in e;
}
function $564f85e69a9a6189$var$K(e, t) {
    return e && t ? "".concat(e, " ").concat(t) : e || t || "";
}
function $564f85e69a9a6189$var$Q(e, t) {
    return e.join(t || "");
}
function $564f85e69a9a6189$var$ee(e) {
    return null !== e && "object" == typeof e && e.constructor.name === Object.name && !("props" in e && e.$$typeof);
}
function $564f85e69a9a6189$var$te(e, t, n) {
    if (void 0 === n && (n = !1), !n && !$564f85e69a9a6189$var$ee(e) && !Array.isArray(e)) return t;
    if (Array.isArray(t)) for(var r = 0; r < t.length; r++)e[r] = $564f85e69a9a6189$var$te(e[r], t[r]);
    else if ($564f85e69a9a6189$var$ee(t)) for(var r in t)e[r] = $564f85e69a9a6189$var$te(e[r], t[r]);
    return e;
}
function $564f85e69a9a6189$var$ne(e, t) {
    Object.defineProperty(e, "toString", {
        value: t
    });
}
var $564f85e69a9a6189$var$re = {};
function $564f85e69a9a6189$var$oe() {
    for(var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t];
    for(var n = e[0], r = [], o = 1, s = e.length; o < s; o += 1)r.push(e[o]);
    return r.forEach(function(e) {
        n = n.replace(/%[a-z]/, e);
    }), n;
}
function $564f85e69a9a6189$var$se(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    return new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#".concat(t, " for more information.").concat(n.length > 0 ? " Args: ".concat(n.join(", ")) : ""));
}
var $564f85e69a9a6189$var$ie = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e, this._cGroup = 0, this._cIndex = 0;
    }
    return e.prototype.indexOfGroup = function(e) {
        if (e === this._cGroup) return this._cIndex;
        var t = this._cIndex;
        if (e > this._cGroup) for(var n = this._cGroup; n < e; n++)t += this.groupSizes[n];
        else for(n = this._cGroup - 1; n >= e; n--)t -= this.groupSizes[n];
        return this._cGroup = e, this._cIndex = t, t;
    }, e.prototype.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)if ((o <<= 1) < 0) throw $564f85e69a9a6189$var$se(16, "".concat(e));
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = (s = 0, t.length); s < c; s++)this.tag.insertRule(i, t[s]) && (this.groupSizes[e]++, i++, a++);
        a > 0 && this._cGroup > e && (this._cIndex += a);
    }, e.prototype.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
            t > 0 && this._cGroup > e && (this._cIndex -= t);
        }
    }, e.prototype.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + $564f85e69a9a6189$var$d;
        return t;
    }, e;
}(), $564f85e69a9a6189$var$ae = 1073741824, $564f85e69a9a6189$var$ce = new Map, $564f85e69a9a6189$var$ue = new Map, $564f85e69a9a6189$var$le = 1, $564f85e69a9a6189$var$de = function(e) {
    if ($564f85e69a9a6189$var$ce.has(e)) return $564f85e69a9a6189$var$ce.get(e);
    for(; $564f85e69a9a6189$var$ue.has($564f85e69a9a6189$var$le);)$564f85e69a9a6189$var$le++;
    var t = $564f85e69a9a6189$var$le++;
    return $564f85e69a9a6189$var$ce.set(e, t), $564f85e69a9a6189$var$ue.set(t, e), t;
}, $564f85e69a9a6189$var$he = function(e, t) {
    $564f85e69a9a6189$var$le = t + 1, $564f85e69a9a6189$var$ce.set(e, t), $564f85e69a9a6189$var$ue.set(t, e);
}, $564f85e69a9a6189$var$pe = "style[".concat($564f85e69a9a6189$var$a, "][").concat($564f85e69a9a6189$var$u, '="').concat($564f85e69a9a6189$export$83d89fbfd8236492, '"]'), $564f85e69a9a6189$var$fe = new RegExp("^".concat($564f85e69a9a6189$var$a, '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)')), $564f85e69a9a6189$var$me = function(e) {
    return "undefined" != typeof ShadowRoot && e instanceof ShadowRoot || "host" in e && 11 === e.nodeType;
}, $564f85e69a9a6189$var$ye = function(e) {
    if (!e) return document;
    if ($564f85e69a9a6189$var$me(e)) return e;
    if ("getRootNode" in e) {
        var t = e.getRootNode();
        if ($564f85e69a9a6189$var$me(t)) return t;
    }
    return document;
}, $564f85e69a9a6189$var$ve = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $564f85e69a9a6189$var$ge = function(e, t) {
    for(var n, r = (null !== (n = t.textContent) && void 0 !== n ? n : "").split($564f85e69a9a6189$var$d), o = [], s = 0, i = r.length; s < i; s++){
        var a = r[s].trim();
        if (a) {
            var c = a.match($564f85e69a9a6189$var$fe);
            if (c) {
                var u = 0 | parseInt(c[1], 10), l = c[2];
                0 !== u && ($564f85e69a9a6189$var$he(l, u), $564f85e69a9a6189$var$ve(e, l, c[3]), e.getTag().insertRules(u, o)), o.length = 0;
            } else o.push(a);
        }
    }
}, $564f85e69a9a6189$var$Se = function(e) {
    for(var t = $564f85e69a9a6189$var$ye(e.options.target).querySelectorAll($564f85e69a9a6189$var$pe), n = 0, r = t.length; n < r; n++){
        var o = t[n];
        o && o.getAttribute($564f85e69a9a6189$var$a) !== $564f85e69a9a6189$var$c && ($564f85e69a9a6189$var$ge(e, o), o.parentNode && o.parentNode.removeChild(o));
    }
};
function $564f85e69a9a6189$var$we() {
    return "undefined" != typeof __webpack_nonce__ ? __webpack_nonce__ : null;
}
var $564f85e69a9a6189$var$be = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        var t = Array.from(e.querySelectorAll("style[".concat($564f85e69a9a6189$var$a, "]")));
        return t[t.length - 1];
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($564f85e69a9a6189$var$a, $564f85e69a9a6189$var$c), r.setAttribute($564f85e69a9a6189$var$u, $564f85e69a9a6189$export$83d89fbfd8236492);
    var i = $564f85e69a9a6189$var$we();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $564f85e69a9a6189$var$Ne = function() {
    function e(e) {
        this.element = $564f85e69a9a6189$var$be(e), this.element.appendChild(document.createTextNode("")), this.sheet = function(e) {
            var t;
            if (e.sheet) return e.sheet;
            for(var n = null !== (t = e.getRootNode().styleSheets) && void 0 !== t ? t : document.styleSheets, r = 0, o = n.length; r < o; r++){
                var s = n[r];
                if (s.ownerNode === e) return s;
            }
            throw $564f85e69a9a6189$var$se(17);
        }(this.element), this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, e.prototype.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, e.prototype.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return t && t.cssText ? t.cssText : "";
    }, e;
}(), $564f85e69a9a6189$var$Ee = function() {
    function e(e) {
        this.element = $564f85e69a9a6189$var$be(e), this.nodes = this.element.childNodes, this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t);
            return this.element.insertBefore(n, this.nodes[e] || null), this.length++, !0;
        }
        return !1;
    }, e.prototype.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $564f85e69a9a6189$var$Ce = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    return e.prototype.insertRule = function(e, t) {
        return e <= this.length && (e === this.length ? this.rules.push(t) : this.rules.splice(e, 0, t), this.length++, !0);
    }, e.prototype.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, e.prototype.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $564f85e69a9a6189$var$Ae = $564f85e69a9a6189$var$h, $564f85e69a9a6189$var$_e = {
    isServer: !$564f85e69a9a6189$var$h,
    useCSSOMInjection: !$564f85e69a9a6189$var$f
}, $564f85e69a9a6189$var$Pe = function() {
    function e(e, n, r) {
        void 0 === e && (e = $564f85e69a9a6189$var$w), void 0 === n && (n = {});
        var o = this;
        this.options = (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, $564f85e69a9a6189$var$_e), e), this.gs = n, this.names = new Map(r), this.server = !!e.isServer, !this.server && $564f85e69a9a6189$var$h && $564f85e69a9a6189$var$Ae && ($564f85e69a9a6189$var$Ae = !1, $564f85e69a9a6189$var$Se(this)), $564f85e69a9a6189$var$ne(this, function() {
            return function(e) {
                for(var t = e.getTag(), n = t.length, r = "", o = function(n) {
                    var o = function(e) {
                        return $564f85e69a9a6189$var$ue.get(e);
                    }(n);
                    if (void 0 === o) return "continue";
                    var s = e.names.get(o);
                    if (void 0 === s || !s.size) return "continue";
                    var i = t.getGroup(n);
                    if (0 === i.length) return "continue";
                    var c = $564f85e69a9a6189$var$a + ".g" + n + '[id="' + o + '"]', u = "";
                    s.forEach(function(e) {
                        e.length > 0 && (u += e + ",");
                    }), r += i + c + '{content:"' + u + '"}' + $564f85e69a9a6189$var$d;
                }, s = 0; s < n; s++)o(s);
                return r;
            }(o);
        });
    }
    return e.registerId = function(e) {
        return $564f85e69a9a6189$var$de(e);
    }, e.prototype.rehydrate = function() {
        !this.server && $564f85e69a9a6189$var$h && $564f85e69a9a6189$var$Se(this);
    }, e.prototype.reconstructWithOptions = function(n, r) {
        void 0 === r && (r = !0);
        var o = new e((0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, this.options), n), this.gs, r && this.names || void 0);
        return !this.server && $564f85e69a9a6189$var$h && n.target !== this.options.target && $564f85e69a9a6189$var$ye(this.options.target) !== $564f85e69a9a6189$var$ye(n.target) && $564f85e69a9a6189$var$Se(o), o;
    }, e.prototype.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, e.prototype.getTag = function() {
        var e;
        return this.tag || (this.tag = (e = function(e) {
            var t = e.useCSSOMInjection, n = e.target;
            return e.isServer ? new $564f85e69a9a6189$var$Ce(n) : t ? new $564f85e69a9a6189$var$Ne(n) : new $564f85e69a9a6189$var$Ee(n);
        }(this.options), new $564f85e69a9a6189$var$ie(e)));
    }, e.prototype.hasNameForId = function(e, t) {
        var n, r;
        return null !== (r = null === (n = this.names.get(e)) || void 0 === n ? void 0 : n.has(t)) && void 0 !== r && r;
    }, e.prototype.registerName = function(e, t) {
        $564f85e69a9a6189$var$de(e);
        var n = this.names.get(e);
        n ? n.add(t) : this.names.set(e, new Set([
            t
        ]));
    }, e.prototype.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($564f85e69a9a6189$var$de(e), n);
    }, e.prototype.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, e.prototype.clearRules = function(e) {
        this.getTag().clearGroup($564f85e69a9a6189$var$de(e)), this.clearNames(e);
    }, e.prototype.clearTag = function() {
        this.tag = void 0;
    }, e;
}(), $564f85e69a9a6189$var$Ie = /&/g, $564f85e69a9a6189$var$Oe = 47, $564f85e69a9a6189$var$De = 42;
function $564f85e69a9a6189$var$Re(e) {
    if (-1 === e.indexOf("}")) return !1;
    for(var t = e.length, n = 0, r = 0, o = !1, s = 0; s < t; s++){
        var i = e.charCodeAt(s);
        if (0 !== r || o || i !== $564f85e69a9a6189$var$Oe || e.charCodeAt(s + 1) !== $564f85e69a9a6189$var$De) {
            if (o) i === $564f85e69a9a6189$var$De && e.charCodeAt(s + 1) === $564f85e69a9a6189$var$Oe && (o = !1, s++);
            else if (34 !== i && 39 !== i || 0 !== s && 92 === e.charCodeAt(s - 1)) {
                if (0 === r) {
                    if (123 === i) n++;
                    else if (125 === i && --n < 0) return !0;
                }
            } else 0 === r ? r = i : r === i && (r = 0);
        } else o = !0, s++;
    }
    return 0 !== n || 0 !== r;
}
function $564f85e69a9a6189$var$Te(e, t) {
    return e.map(function(e) {
        return "rule" === e.type && (e.value = "".concat(t, " ").concat(e.value), e.value = e.value.replaceAll(",", ",".concat(t, " ")), e.props = e.props.map(function(e) {
            return "".concat(t, " ").concat(e);
        })), Array.isArray(e.children) && "@keyframes" !== e.type && (e.children = $564f85e69a9a6189$var$Te(e.children, t)), e;
    });
}
function $564f85e69a9a6189$var$xe(e) {
    var t, n, r, o = void 0 === e ? $564f85e69a9a6189$var$w : e, i = o.options, a = void 0 === i ? $564f85e69a9a6189$var$w : i, c = o.plugins, u = void 0 === c ? $564f85e69a9a6189$var$S : c, l = function(e, r, o) {
        return o.startsWith(n) && o.endsWith(n) && o.replaceAll(n, "").length > 0 ? ".".concat(t) : e;
    }, d = u.slice();
    d.push(function(e) {
        e.type === $51b2b888e4316b33$export$aa3a2e812ca8570d && e.value.includes("&") && (r || (r = new RegExp("\\".concat(n, "\\b"), "g")), e.props[0] = e.props[0].replace($564f85e69a9a6189$var$Ie, n).replace(r, l));
    }), a.prefix && d.push($51b2b888e4316b33$export$e08c7d021b829b7a), d.push($51b2b888e4316b33$export$fac44ee5b035f737);
    var h = [], p = $51b2b888e4316b33$export$5a7767152ae0305f(d.concat($51b2b888e4316b33$export$38bcb760f1d4871c(function(e) {
        return h.push(e);
    }))), f = function(e, o, i, c) {
        void 0 === o && (o = ""), void 0 === i && (i = ""), void 0 === c && (c = "&"), t = c, n = o, r = void 0;
        var u = function(e) {
            if (!$564f85e69a9a6189$var$Re(e)) return e;
            for(var t = e.length, n = "", r = 0, o = 0, s = 0, i = !1, a = 0; a < t; a++){
                var c = e.charCodeAt(a);
                if (0 !== s || i || c !== $564f85e69a9a6189$var$Oe || e.charCodeAt(a + 1) !== $564f85e69a9a6189$var$De) {
                    if (i) c === $564f85e69a9a6189$var$De && e.charCodeAt(a + 1) === $564f85e69a9a6189$var$Oe && (i = !1, a++);
                    else if (34 !== c && 39 !== c || 0 !== a && 92 === e.charCodeAt(a - 1)) {
                        if (0 === s) {
                            if (123 === c) o++;
                            else if (125 === c) {
                                if (--o < 0) {
                                    for(var u = a + 1; u < t;){
                                        var l = e.charCodeAt(u);
                                        if (59 === l || 10 === l) break;
                                        u++;
                                    }
                                    u < t && 59 === e.charCodeAt(u) && u++, o = 0, a = u - 1, r = u;
                                    continue;
                                }
                                0 === o && (n += e.substring(r, a + 1), r = a + 1);
                            } else 59 === c && 0 === o && (n += e.substring(r, a + 1), r = a + 1);
                        }
                    } else 0 === s ? s = c : s === c && (s = 0);
                } else i = !0, a++;
            }
            if (r < t) {
                var d = e.substring(r);
                $564f85e69a9a6189$var$Re(d) || (n += d);
            }
            return n;
        }(function(e) {
            if (-1 === e.indexOf("//")) return e;
            for(var t = e.length, n = [], r = 0, o = 0, s = 0, i = 0; o < t;){
                var a = e.charCodeAt(o);
                if (34 !== a && 39 !== a || 0 !== o && 92 === e.charCodeAt(o - 1)) {
                    if (0 === s) {
                        if (a === $564f85e69a9a6189$var$Oe && o + 1 < t && e.charCodeAt(o + 1) === $564f85e69a9a6189$var$De) {
                            for(o += 2; o + 1 < t && (e.charCodeAt(o) !== $564f85e69a9a6189$var$De || e.charCodeAt(o + 1) !== $564f85e69a9a6189$var$Oe);)o++;
                            o += 2;
                        } else if (40 === a && o >= 3 && 108 == (32 | e.charCodeAt(o - 1)) && 114 == (32 | e.charCodeAt(o - 2)) && 117 == (32 | e.charCodeAt(o - 3))) i = 1, o++;
                        else if (i > 0) 41 === a ? i-- : 40 === a && i++, o++;
                        else if (a === $564f85e69a9a6189$var$De && o + 1 < t && e.charCodeAt(o + 1) === $564f85e69a9a6189$var$Oe) o > r && n.push(e.substring(r, o)), r = o += 2;
                        else if (a === $564f85e69a9a6189$var$Oe && o + 1 < t && e.charCodeAt(o + 1) === $564f85e69a9a6189$var$Oe) {
                            for(o > r && n.push(e.substring(r, o)); o < t && 10 !== e.charCodeAt(o);)o++;
                            r = o;
                        } else o++;
                    } else o++;
                } else 0 === s ? s = a : s === a && (s = 0), o++;
            }
            return 0 === r ? e : (r < t && n.push(e.substring(r)), n.join(""));
        }(e)), l = $51b2b888e4316b33$export$ef7acd7185315e22(i || o ? "".concat(i, " ").concat(o, " { ").concat(u, " }") : u);
        return a.namespace && (l = $564f85e69a9a6189$var$Te(l, a.namespace)), h = [], $51b2b888e4316b33$export$dfdc1655ccc5b9cb(l, p), h;
    };
    return f.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $564f85e69a9a6189$var$se(15), $564f85e69a9a6189$var$D(e, t.name);
    }, 5381).toString() : "", f;
}
var $564f85e69a9a6189$var$je = new $564f85e69a9a6189$var$Pe, $564f85e69a9a6189$var$ke = $564f85e69a9a6189$var$xe(), $564f85e69a9a6189$var$Me = {
    shouldForwardProp: void 0,
    styleSheet: $564f85e69a9a6189$var$je,
    stylis: $564f85e69a9a6189$var$ke
}, $564f85e69a9a6189$export$8c190ef828af4c86 = $564f85e69a9a6189$var$p ? {
    Provider: function(e) {
        return e.children;
    },
    Consumer: function(e) {
        return (0, e.children)($564f85e69a9a6189$var$Me);
    }
} : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext($564f85e69a9a6189$var$Me), $564f85e69a9a6189$export$91317688fc694efa = $564f85e69a9a6189$export$8c190ef828af4c86.Consumer, $564f85e69a9a6189$var$Ge = $564f85e69a9a6189$var$p ? {
    Provider: function(e) {
        return e.children;
    },
    Consumer: function(e) {
        return (0, e.children)(void 0);
    }
} : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext(void 0);
function $564f85e69a9a6189$var$Le() {
    return $564f85e69a9a6189$var$p ? $564f85e69a9a6189$var$Me : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useContext($564f85e69a9a6189$export$8c190ef828af4c86);
}
function $564f85e69a9a6189$export$a473771da2f0ff7c(e) {
    if ($564f85e69a9a6189$var$p || !(0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useMemo) return e.children;
    var t = $564f85e69a9a6189$var$Le().styleSheet, n = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useMemo(function() {
        var n = t;
        return e.sheet ? n = e.sheet : e.target && (n = n.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (n = n.reconstructWithOptions({
            useCSSOMInjection: !1
        })), n;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target,
        t
    ]), o = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useMemo(function() {
        return $564f85e69a9a6189$var$xe({
            options: {
                namespace: e.namespace,
                prefix: e.enableVendorPrefixes
            },
            plugins: e.stylisPlugins
        });
    }, [
        e.enableVendorPrefixes,
        e.namespace,
        e.stylisPlugins
    ]), s = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useMemo(function() {
        return {
            shouldForwardProp: e.shouldForwardProp,
            styleSheet: n,
            stylis: o
        };
    }, [
        e.shouldForwardProp,
        n,
        o
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($564f85e69a9a6189$export$8c190ef828af4c86.Provider, {
        value: s
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($564f85e69a9a6189$var$Ge.Provider, {
        value: o
    }, e.children));
}
var $564f85e69a9a6189$var$ze = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $564f85e69a9a6189$var$ke);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.name = e, this.id = "sc-keyframes-".concat(e), this.rules = t, $564f85e69a9a6189$var$ne(this, function() {
            throw $564f85e69a9a6189$var$se(12, String(n.name));
        });
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $564f85e69a9a6189$var$ke), this.name + e.hash;
    }, e;
}();
function $564f85e69a9a6189$var$$e(e, t) {
    return null == t || "boolean" == typeof t || "" === t ? "" : "number" != typeof t || 0 === t || e in (0, $f35d4e7f999e2519$export$2e2bcd8739ae039) || e.startsWith("--") ? String(t).trim() : "".concat(t, "px");
}
var $564f85e69a9a6189$var$Ye = function(e) {
    return e >= "A" && e <= "Z";
};
function $564f85e69a9a6189$var$We(e) {
    for(var t = "", n = 0; n < e.length; n++){
        var r = e[n];
        if (1 === n && "-" === r && "-" === e[0]) return e;
        $564f85e69a9a6189$var$Ye(r) ? t += "-" + r.toLowerCase() : t += r;
    }
    return t.startsWith("ms-") ? "-" + t : t;
}
var $564f85e69a9a6189$var$qe = function(e) {
    return null == e || !1 === e || "" === e;
}, $564f85e69a9a6189$var$He = function(t) {
    var n = [];
    for(var r in t){
        var o = t[r];
        t.hasOwnProperty(r) && !$564f85e69a9a6189$var$qe(o) && (Array.isArray(o) && o.isCss || $564f85e69a9a6189$var$X(o) ? n.push("".concat($564f85e69a9a6189$var$We(r), ":"), o, ";") : $564f85e69a9a6189$var$ee(o) ? n.push.apply(n, (0, $ebba836a6d35485c$export$1216008129fb82ed)((0, $ebba836a6d35485c$export$1216008129fb82ed)([
            "".concat(r, " {")
        ], $564f85e69a9a6189$var$He(o), !1), [
            "}"
        ], !1)) : n.push("".concat($564f85e69a9a6189$var$We(r), ": ").concat($564f85e69a9a6189$var$$e(r, o), ";")));
    }
    return n;
};
function $564f85e69a9a6189$var$Ue(e, t, n, r, o) {
    if (void 0 === o && (o = []), "string" == typeof e) return e && o.push(e), o;
    if ($564f85e69a9a6189$var$qe(e)) return o;
    if ($564f85e69a9a6189$export$7ba318d8d2f06c76(e)) return o.push(".".concat(e.styledComponentId)), o;
    if ($564f85e69a9a6189$var$X(e)) {
        if (!$564f85e69a9a6189$var$X(i = e) || i.prototype && i.prototype.isReactComponent || !t) return o.push(e), o;
        var s = e(t);
        return $564f85e69a9a6189$var$Ue(s, t, n, r, o);
    }
    var i;
    if (e instanceof $564f85e69a9a6189$var$ze) return n ? (e.inject(n, r), o.push(e.getName(r))) : o.push(e), o;
    if ($564f85e69a9a6189$var$ee(e)) {
        for(var a = $564f85e69a9a6189$var$He(e), c = 0; c < a.length; c++)o.push(a[c]);
        return o;
    }
    if (!Array.isArray(e)) return o.push(e.toString()), o;
    for(c = 0; c < e.length; c++)$564f85e69a9a6189$var$Ue(e[c], t, n, r, o);
    return o;
}
function $564f85e69a9a6189$var$Je(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($564f85e69a9a6189$var$X(n) && !$564f85e69a9a6189$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $564f85e69a9a6189$var$Xe = $564f85e69a9a6189$var$R($564f85e69a9a6189$export$83d89fbfd8236492), $564f85e69a9a6189$var$Ze = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $564f85e69a9a6189$var$Je(e), this.componentId = t, this.baseHash = $564f85e69a9a6189$var$D($564f85e69a9a6189$var$Xe, t), this.baseStyle = n, $564f85e69a9a6189$var$Pe.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.baseStyle ? this.baseStyle.generateAndInjectStyles(e, t, n).className : "";
        if (this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(this.componentId, this.staticRulesId)) r = $564f85e69a9a6189$var$K(r, this.staticRulesId);
            else {
                var o = $564f85e69a9a6189$var$Q($564f85e69a9a6189$var$Ue(this.rules, e, t, n)), s = $564f85e69a9a6189$var$I($564f85e69a9a6189$var$D(this.baseHash, o) >>> 0);
                if (!t.hasNameForId(this.componentId, s)) {
                    var i = n(o, ".".concat(s), void 0, this.componentId);
                    t.insertRules(this.componentId, s, i);
                }
                r = $564f85e69a9a6189$var$K(r, s), this.staticRulesId = s;
            }
        } else {
            for(var a = $564f85e69a9a6189$var$D(this.baseHash, n.hash), c = "", u = 0; u < this.rules.length; u++){
                var l = this.rules[u];
                if ("string" == typeof l) c += l;
                else if (l) {
                    var d = $564f85e69a9a6189$var$Q($564f85e69a9a6189$var$Ue(l, e, t, n));
                    a = $564f85e69a9a6189$var$D($564f85e69a9a6189$var$D(a, String(u)), d), c += d;
                }
            }
            if (c) {
                var h = $564f85e69a9a6189$var$I(a >>> 0);
                if (!t.hasNameForId(this.componentId, h)) {
                    var p = n(c, ".".concat(h), void 0, this.componentId);
                    t.insertRules(this.componentId, h, p);
                }
                r = $564f85e69a9a6189$var$K(r, h);
            }
        }
        return {
            className: r,
            css: "undefined" == typeof window ? t.getTag().getGroup($564f85e69a9a6189$var$de(this.componentId)) : ""
        };
    }, e;
}(), $564f85e69a9a6189$export$2c657da244d00bd6 = $564f85e69a9a6189$var$p ? {
    Provider: function(e) {
        return e.children;
    },
    Consumer: function(e) {
        return (0, e.children)(void 0);
    }
} : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext(void 0), $564f85e69a9a6189$export$b631efc24e9d5e2f = $564f85e69a9a6189$export$2c657da244d00bd6.Consumer;
function $564f85e69a9a6189$export$93d4e7f90805808f() {
    var e = $564f85e69a9a6189$var$p ? void 0 : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useContext($564f85e69a9a6189$export$2c657da244d00bd6);
    if (!e) throw $564f85e69a9a6189$var$se(18);
    return e;
}
function $564f85e69a9a6189$export$d8964aec282183a3(e) {
    if ($564f85e69a9a6189$var$p) return e.children;
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useContext($564f85e69a9a6189$export$2c657da244d00bd6), o = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useMemo(function() {
        return function(e, n) {
            if (!e) throw $564f85e69a9a6189$var$se(14);
            if ($564f85e69a9a6189$var$X(e)) {
                var r = e(n);
                return r;
            }
            if (Array.isArray(e) || "object" != typeof e) throw $564f85e69a9a6189$var$se(8);
            return n ? (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, n), e) : e;
        }(e.theme, n);
    }, [
        e.theme,
        n
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($564f85e69a9a6189$export$2c657da244d00bd6.Provider, {
        value: o
    }, e.children) : null;
}
var $564f85e69a9a6189$var$nt = {}, $564f85e69a9a6189$var$rt = new Set;
function $564f85e69a9a6189$var$ot(e, s, i) {
    var a = $564f85e69a9a6189$export$7ba318d8d2f06c76(e), c = e, u = !$564f85e69a9a6189$var$j(e), d = s.attrs, h = void 0 === d ? $564f85e69a9a6189$var$S : d, f = s.componentId, m = void 0 === f ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $564f85e69a9a6189$var$A(e);
        $564f85e69a9a6189$var$nt[n] = ($564f85e69a9a6189$var$nt[n] || 0) + 1;
        var r = "".concat(n, "-").concat($564f85e69a9a6189$var$T($564f85e69a9a6189$export$83d89fbfd8236492 + n + $564f85e69a9a6189$var$nt[n]));
        return t ? "".concat(t, "-").concat(r) : r;
    }(s.displayName, s.parentComponentId) : f, y = s.displayName, v = void 0 === y ? function(e) {
        return $564f85e69a9a6189$var$j(e) ? "styled.".concat(e) : "Styled(".concat($564f85e69a9a6189$var$x(e), ")");
    }(e) : y, E = s.displayName && s.componentId ? "".concat($564f85e69a9a6189$var$A(s.displayName), "-").concat(s.componentId) : s.componentId || m, C = a && c.attrs ? c.attrs.concat(h).filter(Boolean) : h, _ = s.shouldForwardProp;
    if (a && c.shouldForwardProp) {
        var P = c.shouldForwardProp;
        if (s.shouldForwardProp) {
            var I = s.shouldForwardProp;
            _ = function(e, t) {
                return P(e, t) && I(e, t);
            };
        } else _ = P;
    }
    var O = new $564f85e69a9a6189$var$Ze(i, E, a ? c.componentStyle : void 0);
    function D(e, s) {
        return function(e, s, i) {
            var a = e.attrs, c = e.componentStyle, u = e.defaultProps, l = e.foldedComponentIds, d = e.styledComponentId, h = e.target, f = $564f85e69a9a6189$var$p ? void 0 : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useContext($564f85e69a9a6189$export$2c657da244d00bd6), m = $564f85e69a9a6189$var$Le(), y = e.shouldForwardProp || m.shouldForwardProp;
            var v = $564f85e69a9a6189$var$b(s, f, u) || ($564f85e69a9a6189$var$p ? void 0 : $564f85e69a9a6189$var$w), g = function(e, n, r) {
                for(var o, s = (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, n), {
                    className: void 0,
                    theme: r
                }), i = 0; i < e.length; i += 1){
                    var a = $564f85e69a9a6189$var$X(o = e[i]) ? o(s) : o;
                    for(var c in a)"className" === c ? s.className = $564f85e69a9a6189$var$K(s.className, a[c]) : "style" === c ? s.style = (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, s.style), a[c]) : s[c] = a[c];
                }
                return "className" in n && "string" == typeof n.className && (s.className = $564f85e69a9a6189$var$K(s.className, n.className)), s;
            }(a, s, v), S = g.as || h, E = {};
            for(var C in g)void 0 === g[C] || "$" === C[0] || "as" === C || "theme" === C && g.theme === v || ("forwardedAs" === C ? E.as = g.forwardedAs : y && !y(C, S) || (E[C] = g[C], y));
            var A = function(e, t) {
                var n = $564f85e69a9a6189$var$Le(), o = e.generateAndInjectStyles(t, n.styleSheet, n.stylis);
                return o;
            }(c, g), _ = A.className, P = A.css;
            var I = $564f85e69a9a6189$var$K(l, d);
            _ && (I += " " + _), g.className && (I += " " + g.className), E[$564f85e69a9a6189$var$j(S) && !$564f85e69a9a6189$var$N.has(S) ? "class" : "className"] = I, i && (E.ref = i);
            var O = (0, $kYL7Z.createElement)(S, E);
            return $564f85e69a9a6189$var$p && P ? (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("style", {
                precedence: "styled-components",
                href: "sc-".concat(d, "-").concat(_),
                children: P
            }), O) : O;
        }(R, e, s);
    }
    D.displayName = v;
    var R = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).forwardRef(D);
    return R.attrs = C, R.componentStyle = O, R.displayName = v, R.shouldForwardProp = _, R.foldedComponentIds = a ? $564f85e69a9a6189$var$K(c.foldedComponentIds, c.styledComponentId) : "", R.styledComponentId = E, R.target = a ? c.target : e, Object.defineProperty(R, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(e) {
            this._foldedDefaultProps = a ? function(e) {
                for(var t = [], n = 1; n < arguments.length; n++)t[n - 1] = arguments[n];
                for(var r = 0, o = t; r < o.length; r++)$564f85e69a9a6189$var$te(e, o[r], !0);
                return e;
            }({}, c.defaultProps, e) : e;
        }
    }), $564f85e69a9a6189$var$ne(R, function() {
        return ".".concat(R.styledComponentId);
    }), u && $564f85e69a9a6189$var$J(R, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0
    }), R;
}
function $564f85e69a9a6189$var$st(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}
var $564f85e69a9a6189$var$it = function(e) {
    return Object.assign(e, {
        isCss: !0
    });
};
function $564f85e69a9a6189$export$dbf350e5966cf602(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    if ($564f85e69a9a6189$var$X(t) || $564f85e69a9a6189$var$ee(t)) return $564f85e69a9a6189$var$it($564f85e69a9a6189$var$Ue($564f85e69a9a6189$var$st($564f85e69a9a6189$var$S, (0, $ebba836a6d35485c$export$1216008129fb82ed)([
        t
    ], n, !0))));
    var o = t;
    return 0 === n.length && 1 === o.length && "string" == typeof o[0] ? $564f85e69a9a6189$var$Ue(o) : $564f85e69a9a6189$var$it($564f85e69a9a6189$var$Ue($564f85e69a9a6189$var$st(o, n)));
}
function $564f85e69a9a6189$var$ct(n, r, o) {
    if (void 0 === o && (o = $564f85e69a9a6189$var$w), !r) throw $564f85e69a9a6189$var$se(1, r);
    var s = function(t) {
        for(var s = [], i = 1; i < arguments.length; i++)s[i - 1] = arguments[i];
        return n(r, o, $564f85e69a9a6189$export$dbf350e5966cf602.apply(void 0, (0, $ebba836a6d35485c$export$1216008129fb82ed)([
            t
        ], s, !1)));
    };
    return s.attrs = function(e) {
        return $564f85e69a9a6189$var$ct(n, r, (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, o), {
            attrs: Array.prototype.concat(o.attrs, e).filter(Boolean)
        }));
    }, s.withConfig = function(e) {
        return $564f85e69a9a6189$var$ct(n, r, (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, o), e));
    }, s;
}
var $564f85e69a9a6189$var$ut = function(e) {
    return $564f85e69a9a6189$var$ct($564f85e69a9a6189$var$ot, e);
}, $564f85e69a9a6189$export$2e2bcd8739ae039 = $564f85e69a9a6189$var$ut;
$564f85e69a9a6189$var$N.forEach(function(e) {
    $564f85e69a9a6189$export$2e2bcd8739ae039[e] = $564f85e69a9a6189$var$ut(e);
});
var $564f85e69a9a6189$var$dt = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $564f85e69a9a6189$var$Je(e), $564f85e69a9a6189$var$Pe.registerId(this.componentId + 1);
    }
    return e.prototype.createStyles = function(e, t, n, r) {
        var o = r($564f85e69a9a6189$var$Q($564f85e69a9a6189$var$Ue(this.rules, t, n, r)), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, e.prototype.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, e.prototype.renderStyles = function(e, t, n, r) {
        e > 2 && $564f85e69a9a6189$var$Pe.registerId(this.componentId + e);
        var o = this.componentId + e;
        this.isStatic ? n.hasNameForId(o, o) || this.createStyles(e, t, n, r) : (this.removeStyles(e, n), this.createStyles(e, t, n, r));
    }, e;
}();
function $564f85e69a9a6189$export$f0f03736edb61697(n) {
    for(var o = [], s = 1; s < arguments.length; s++)o[s - 1] = arguments[s];
    var i = $564f85e69a9a6189$export$dbf350e5966cf602.apply(void 0, (0, $ebba836a6d35485c$export$1216008129fb82ed)([
        n
    ], o, !1)), a = "sc-global-".concat($564f85e69a9a6189$var$T(JSON.stringify(i))), c = new $564f85e69a9a6189$var$dt(i, a);
    var u = new WeakMap, l = function(e) {
        var t = $564f85e69a9a6189$var$Le(), n = $564f85e69a9a6189$var$p ? void 0 : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useContext($564f85e69a9a6189$export$2c657da244d00bd6), o = u.get(t.styleSheet);
        if (void 0 === o && (o = t.styleSheet.allocateGSInstance(a), u.set(t.styleSheet, o)), ("undefined" == typeof window || !t.styleSheet.server) && d(o, e, t.styleSheet, n, t.stylis), $564f85e69a9a6189$var$p || (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useLayoutEffect(function() {
            return t.styleSheet.server || d(o, e, t.styleSheet, n, t.stylis), function() {
                var e;
                c.removeStyles(o, t.styleSheet), e = t.styleSheet.options.target, "undefined" != typeof document && (null != e ? e : document).querySelectorAll('style[data-styled-global="'.concat(a, '"]')).forEach(function(e) {
                    return e.remove();
                });
            };
        }, [
            o,
            e,
            t.styleSheet,
            n,
            t.stylis
        ]), $564f85e69a9a6189$var$p) {
            var s = a + o, l = "undefined" == typeof window ? t.styleSheet.getTag().getGroup($564f85e69a9a6189$var$de(s)) : "";
            if (l) return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("style", {
                key: "".concat(a, "-").concat(o),
                "data-styled-global": a,
                children: l
            });
        }
        return null;
    };
    function d(e, n, r, o, s) {
        if (c.isStatic) c.renderStyles(e, $564f85e69a9a6189$var$m, r, s);
        else {
            var i = (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, n), {
                theme: $564f85e69a9a6189$var$b(n, o, l.defaultProps)
            });
            c.renderStyles(e, i, r, s);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).memo(l);
}
function $564f85e69a9a6189$export$d25ddfdf17c3ad3e(t) {
    for(var n = [], r = 1; r < arguments.length; r++)n[r - 1] = arguments[r];
    var o = $564f85e69a9a6189$var$Q($564f85e69a9a6189$export$dbf350e5966cf602.apply(void 0, (0, $ebba836a6d35485c$export$1216008129fb82ed)([
        t
    ], n, !1))), s = $564f85e69a9a6189$var$T(o);
    return new $564f85e69a9a6189$var$ze(s, o);
}
function $564f85e69a9a6189$export$e8748c6a27b910dc(e) {
    var n = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).forwardRef(function(n, o) {
        var s = $564f85e69a9a6189$var$b(n, $564f85e69a9a6189$var$p ? void 0 : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useContext($564f85e69a9a6189$export$2c657da244d00bd6), e.defaultProps);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement(e, (0, $ebba836a6d35485c$export$18ce0697a983be9b)((0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, n), {
            theme: s,
            ref: o
        }));
    });
    return n.displayName = "WithTheme(".concat($564f85e69a9a6189$var$x(e), ")"), $564f85e69a9a6189$var$J(n, e);
}
var $564f85e69a9a6189$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $564f85e69a9a6189$var$we(), r = $564f85e69a9a6189$var$Q([
                n && 'nonce="'.concat(n, '"'),
                "".concat($564f85e69a9a6189$var$a, '="true"'),
                "".concat($564f85e69a9a6189$var$u, '="').concat($564f85e69a9a6189$export$83d89fbfd8236492, '"')
            ].filter(Boolean), " ");
            return "<style ".concat(r, ">").concat(t, "</style>");
        }, this.getStyleTags = function() {
            if (e.sealed) throw $564f85e69a9a6189$var$se(2);
            return e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var n;
            if (e.sealed) throw $564f85e69a9a6189$var$se(2);
            var o = e.instance.toString();
            if (!o) return [];
            var s = ((n = {})[$564f85e69a9a6189$var$a] = "", n[$564f85e69a9a6189$var$u] = $564f85e69a9a6189$export$83d89fbfd8236492, n.dangerouslySetInnerHTML = {
                __html: o
            }, n), i = $564f85e69a9a6189$var$we();
            return i && (s.nonce = i), [
                (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("style", (0, $ebba836a6d35485c$export$18ce0697a983be9b)({}, s, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $564f85e69a9a6189$var$Pe({
            isServer: !0
        }), this.sealed = !1;
    }
    return e.prototype.collectStyles = function(e) {
        if (this.sealed) throw $564f85e69a9a6189$var$se(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($564f85e69a9a6189$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, e.prototype.interleaveWithNodeStream = function(e) {
        throw $564f85e69a9a6189$var$se(3);
    }, e;
}(), $564f85e69a9a6189$export$5c87cfe6c475f500 = {
    StyleSheet: $564f85e69a9a6189$var$Pe,
    mainSheet: $564f85e69a9a6189$var$je
};
var $564f85e69a9a6189$var$vt = "__sc-".concat($564f85e69a9a6189$var$a, "__");


var $2cfd35af7ec11fdd$exports = {};

$parcel$export($2cfd35af7ec11fdd$exports, "ACTIVE", () => $2cfd35af7ec11fdd$export$2b35adb71b3f6143);
$parcel$export($2cfd35af7ec11fdd$exports, "ALIGN_LEFT", () => $2cfd35af7ec11fdd$export$7895aadd1956b1c7);
$parcel$export($2cfd35af7ec11fdd$exports, "ALIGN_RIGHT", () => $2cfd35af7ec11fdd$export$f1299af03a3c605a);
$parcel$export($2cfd35af7ec11fdd$exports, "COMPACT", () => $2cfd35af7ec11fdd$export$db1cdb8627b81f84);
$parcel$export($2cfd35af7ec11fdd$exports, "DARK", () => $2cfd35af7ec11fdd$export$b9b16d1820185434);
$parcel$export($2cfd35af7ec11fdd$exports, "DISABLED", () => $2cfd35af7ec11fdd$export$8cd212c10b4124d2);
$parcel$export($2cfd35af7ec11fdd$exports, "FILL", () => $2cfd35af7ec11fdd$export$5672a3e1deb5b505);
$parcel$export($2cfd35af7ec11fdd$exports, "FIXED", () => $2cfd35af7ec11fdd$export$91f67f1eeaea8c1e);
$parcel$export($2cfd35af7ec11fdd$exports, "FIXED_TOP", () => $2cfd35af7ec11fdd$export$3df9f2c23b50ca42);
$parcel$export($2cfd35af7ec11fdd$exports, "INLINE", () => $2cfd35af7ec11fdd$export$1ff9623b26415f8);
$parcel$export($2cfd35af7ec11fdd$exports, "INTERACTIVE", () => $2cfd35af7ec11fdd$export$ceebd5febfdef8a3);
$parcel$export($2cfd35af7ec11fdd$exports, "LARGE", () => $2cfd35af7ec11fdd$export$7b93a10c0fefe3e3);
$parcel$export($2cfd35af7ec11fdd$exports, "LOADING", () => $2cfd35af7ec11fdd$export$26d55645375ca9a);
$parcel$export($2cfd35af7ec11fdd$exports, "MINIMAL", () => $2cfd35af7ec11fdd$export$a61ada011bb84f5);
$parcel$export($2cfd35af7ec11fdd$exports, "OUTLINED", () => $2cfd35af7ec11fdd$export$d31ef73d8bd6b2be);
$parcel$export($2cfd35af7ec11fdd$exports, "PADDED", () => $2cfd35af7ec11fdd$export$1f3db38142bdf083);
$parcel$export($2cfd35af7ec11fdd$exports, "MULTILINE", () => $2cfd35af7ec11fdd$export$49f467056ef3fc6c);
$parcel$export($2cfd35af7ec11fdd$exports, "READ_ONLY", () => $2cfd35af7ec11fdd$export$a45819e0f9bcfea2);
$parcel$export($2cfd35af7ec11fdd$exports, "ROUND", () => $2cfd35af7ec11fdd$export$58785fc667c0c50b);
$parcel$export($2cfd35af7ec11fdd$exports, "SELECTED", () => $2cfd35af7ec11fdd$export$657f886463d93938);
$parcel$export($2cfd35af7ec11fdd$exports, "SMALL", () => $2cfd35af7ec11fdd$export$71dd4c8ecd45e95f);
$parcel$export($2cfd35af7ec11fdd$exports, "VERTICAL", () => $2cfd35af7ec11fdd$export$9f2fe7df0ae9fdea);
$parcel$export($2cfd35af7ec11fdd$exports, "POSITION_TOP", () => $2cfd35af7ec11fdd$export$4fb34bdcd97adf85);
$parcel$export($2cfd35af7ec11fdd$exports, "positionClass", () => $2cfd35af7ec11fdd$export$4f8aee4b943e40e);
$parcel$export($2cfd35af7ec11fdd$exports, "POSITION_BOTTOM", () => $2cfd35af7ec11fdd$export$cec9b06edc71d96c);
$parcel$export($2cfd35af7ec11fdd$exports, "POSITION_LEFT", () => $2cfd35af7ec11fdd$export$b0758137ee643e7);
$parcel$export($2cfd35af7ec11fdd$exports, "POSITION_RIGHT", () => $2cfd35af7ec11fdd$export$4ed9c122bcc20157);
$parcel$export($2cfd35af7ec11fdd$exports, "ELEVATION_0", () => $2cfd35af7ec11fdd$export$c8efb467fc55a6a1);
$parcel$export($2cfd35af7ec11fdd$exports, "elevationClass", () => $2cfd35af7ec11fdd$export$b7727d57dec24270);
$parcel$export($2cfd35af7ec11fdd$exports, "ELEVATION_1", () => $2cfd35af7ec11fdd$export$7b5afc1ddf65f8b7);
$parcel$export($2cfd35af7ec11fdd$exports, "ELEVATION_2", () => $2cfd35af7ec11fdd$export$86dd92dfea4f39dd);
$parcel$export($2cfd35af7ec11fdd$exports, "ELEVATION_3", () => $2cfd35af7ec11fdd$export$ef7592bd90f2537f);
$parcel$export($2cfd35af7ec11fdd$exports, "ELEVATION_4", () => $2cfd35af7ec11fdd$export$1d67a24a95ef24c2);
$parcel$export($2cfd35af7ec11fdd$exports, "INTENT_PRIMARY", () => $2cfd35af7ec11fdd$export$37c8deab6e9ff120);
$parcel$export($2cfd35af7ec11fdd$exports, "intentClass", () => $2cfd35af7ec11fdd$export$6771d82d925c8189);
$parcel$export($2cfd35af7ec11fdd$exports, "INTENT_SUCCESS", () => $2cfd35af7ec11fdd$export$fd8d2f5f74a29424);
$parcel$export($2cfd35af7ec11fdd$exports, "INTENT_WARNING", () => $2cfd35af7ec11fdd$export$355c57fd095a7f5a);
$parcel$export($2cfd35af7ec11fdd$exports, "INTENT_DANGER", () => $2cfd35af7ec11fdd$export$373495f4c0568b73);
$parcel$export($2cfd35af7ec11fdd$exports, "FOCUS_DISABLED", () => $2cfd35af7ec11fdd$export$aeda8252e54b50f7);
$parcel$export($2cfd35af7ec11fdd$exports, "FOCUS_STYLE_MANAGER_IGNORE", () => $2cfd35af7ec11fdd$export$bedc1b77a139edca);
$parcel$export($2cfd35af7ec11fdd$exports, "UI_TEXT", () => $2cfd35af7ec11fdd$export$88620a540780da7c);
$parcel$export($2cfd35af7ec11fdd$exports, "RUNNING_TEXT", () => $2cfd35af7ec11fdd$export$d0190f823696a5cc);
$parcel$export($2cfd35af7ec11fdd$exports, "MONOSPACE_TEXT", () => $2cfd35af7ec11fdd$export$558d226ddadcf457);
$parcel$export($2cfd35af7ec11fdd$exports, "TEXT_LARGE", () => $2cfd35af7ec11fdd$export$50e449675bbd8ae2);
$parcel$export($2cfd35af7ec11fdd$exports, "TEXT_SMALL", () => $2cfd35af7ec11fdd$export$504f956f6b2a8e65);
$parcel$export($2cfd35af7ec11fdd$exports, "TEXT_MUTED", () => $2cfd35af7ec11fdd$export$31a5874ec7f49f29);
$parcel$export($2cfd35af7ec11fdd$exports, "TEXT_DISABLED", () => $2cfd35af7ec11fdd$export$4aa79107ea222f04);
$parcel$export($2cfd35af7ec11fdd$exports, "TEXT_OVERFLOW_ELLIPSIS", () => $2cfd35af7ec11fdd$export$cd50c877adf39dd7);
$parcel$export($2cfd35af7ec11fdd$exports, "BLOCKQUOTE", () => $2cfd35af7ec11fdd$export$afa7aa09bb57d54f);
$parcel$export($2cfd35af7ec11fdd$exports, "CODE", () => $2cfd35af7ec11fdd$export$ec5856072852bd7f);
$parcel$export($2cfd35af7ec11fdd$exports, "CODE_BLOCK", () => $2cfd35af7ec11fdd$export$cf55d1bff75690da);
$parcel$export($2cfd35af7ec11fdd$exports, "HEADING", () => $2cfd35af7ec11fdd$export$eef1738e402a65e6);
$parcel$export($2cfd35af7ec11fdd$exports, "LIST", () => $2cfd35af7ec11fdd$export$84cc8e12a434d4e);
$parcel$export($2cfd35af7ec11fdd$exports, "LIST_UNSTYLED", () => $2cfd35af7ec11fdd$export$e52b656749d9474c);
$parcel$export($2cfd35af7ec11fdd$exports, "RTL", () => $2cfd35af7ec11fdd$export$850f7749a2909601);
$parcel$export($2cfd35af7ec11fdd$exports, "ALERT", () => $2cfd35af7ec11fdd$export$8dfce1a3f4c39a);
$parcel$export($2cfd35af7ec11fdd$exports, "ALERT_BODY", () => $2cfd35af7ec11fdd$export$5d3ddfb12869545d);
$parcel$export($2cfd35af7ec11fdd$exports, "ALERT_CONTENTS", () => $2cfd35af7ec11fdd$export$1dba7da5e8205b5f);
$parcel$export($2cfd35af7ec11fdd$exports, "ALERT_FOOTER", () => $2cfd35af7ec11fdd$export$a928c8e2db526b6c);
$parcel$export($2cfd35af7ec11fdd$exports, "BREADCRUMB", () => $2cfd35af7ec11fdd$export$474829b260ce19ab);
$parcel$export($2cfd35af7ec11fdd$exports, "BREADCRUMB_CURRENT", () => $2cfd35af7ec11fdd$export$d25ee28b316abe2a);
$parcel$export($2cfd35af7ec11fdd$exports, "BREADCRUMBS", () => $2cfd35af7ec11fdd$export$c3619772211b515b);
$parcel$export($2cfd35af7ec11fdd$exports, "BREADCRUMBS_COLLAPSED", () => $2cfd35af7ec11fdd$export$6c5df38f864cf0e3);
$parcel$export($2cfd35af7ec11fdd$exports, "BUTTON", () => $2cfd35af7ec11fdd$export$b887e88d8d0739f6);
$parcel$export($2cfd35af7ec11fdd$exports, "BUTTON_GROUP", () => $2cfd35af7ec11fdd$export$cbb1216936bf389c);
$parcel$export($2cfd35af7ec11fdd$exports, "BUTTON_SPINNER", () => $2cfd35af7ec11fdd$export$3fd25a11349a7fac);
$parcel$export($2cfd35af7ec11fdd$exports, "BUTTON_TEXT", () => $2cfd35af7ec11fdd$export$22617f068a979d82);
$parcel$export($2cfd35af7ec11fdd$exports, "CALLOUT", () => $2cfd35af7ec11fdd$export$ae3fb0b35b6ca2a9);
$parcel$export($2cfd35af7ec11fdd$exports, "CALLOUT_HAS_BODY_CONTENT", () => $2cfd35af7ec11fdd$export$c801bbbb1e2ccb0b);
$parcel$export($2cfd35af7ec11fdd$exports, "CALLOUT_ICON", () => $2cfd35af7ec11fdd$export$c4700bfd78cb069a);
$parcel$export($2cfd35af7ec11fdd$exports, "CARD", () => $2cfd35af7ec11fdd$export$95783a805443ad7d);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTROL_CARD", () => $2cfd35af7ec11fdd$export$6769bd973fd6af36);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTROL_CARD_LABEL", () => $2cfd35af7ec11fdd$export$d60e975594bbe489);
$parcel$export($2cfd35af7ec11fdd$exports, "SWITCH_CONTROL_CARD", () => $2cfd35af7ec11fdd$export$9cedcb03c3922bb7);
$parcel$export($2cfd35af7ec11fdd$exports, "CHECKBOX_CONTROL_CARD", () => $2cfd35af7ec11fdd$export$3412f17fbe03c097);
$parcel$export($2cfd35af7ec11fdd$exports, "RADIO_CONTROL_CARD", () => $2cfd35af7ec11fdd$export$4de35bcdbf177a1f);
$parcel$export($2cfd35af7ec11fdd$exports, "CARD_LIST", () => $2cfd35af7ec11fdd$export$ad39b86c40d3c47c);
$parcel$export($2cfd35af7ec11fdd$exports, "CARD_LIST_BORDERED", () => $2cfd35af7ec11fdd$export$5adfba49857b538f);
$parcel$export($2cfd35af7ec11fdd$exports, "COLLAPSE", () => $2cfd35af7ec11fdd$export$a1b955d4799a6f74);
$parcel$export($2cfd35af7ec11fdd$exports, "COLLAPSE_BODY", () => $2cfd35af7ec11fdd$export$e4d292b696959393);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTEXT_MENU", () => $2cfd35af7ec11fdd$export$6a0da22e72d4f0eb);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTEXT_MENU_VIRTUAL_TARGET", () => $2cfd35af7ec11fdd$export$b9534b88b3cef166);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTEXT_MENU_POPOVER", () => $2cfd35af7ec11fdd$export$7ee0ba3b9fa0a5ea);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTEXT_MENU_BACKDROP", () => $2cfd35af7ec11fdd$export$418ef826d3ba978d);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTROL_GROUP", () => $2cfd35af7ec11fdd$export$1c86bb6d85c165);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG", () => $2cfd35af7ec11fdd$export$f99739dbfcd2e015);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_CONTAINER", () => $2cfd35af7ec11fdd$export$d84b649f32bf6ead);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_HEADER", () => $2cfd35af7ec11fdd$export$c09efbe888b20fd);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_BODY", () => $2cfd35af7ec11fdd$export$12096ec1410ccb2);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_BODY_SCROLL_CONTAINER", () => $2cfd35af7ec11fdd$export$dd51a6f3fef5a9d4);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_CLOSE_BUTTON", () => $2cfd35af7ec11fdd$export$9588cbdf14f4605f);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_FOOTER", () => $2cfd35af7ec11fdd$export$6ea271a01e7dc590);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_FOOTER_FIXED", () => $2cfd35af7ec11fdd$export$b60b0eff9b84a85c);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_FOOTER_MAIN_SECTION", () => $2cfd35af7ec11fdd$export$a01581f2cb63a5c5);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_FOOTER_ACTIONS", () => $2cfd35af7ec11fdd$export$6ab793fb94a2b7f8);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_STEP", () => $2cfd35af7ec11fdd$export$ff97c652790bdec);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_STEP_CONTAINER", () => $2cfd35af7ec11fdd$export$15158775e667dbe6);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_STEP_TITLE", () => $2cfd35af7ec11fdd$export$e6263bc32f85a4a4);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_STEP_ICON", () => $2cfd35af7ec11fdd$export$e7c377477d704043);
$parcel$export($2cfd35af7ec11fdd$exports, "DIALOG_STEP_VIEWED", () => $2cfd35af7ec11fdd$export$97e1fe7e02b9bd0);
$parcel$export($2cfd35af7ec11fdd$exports, "DIVIDER", () => $2cfd35af7ec11fdd$export$59669b530bfa91b6);
$parcel$export($2cfd35af7ec11fdd$exports, "DRAWER", () => $2cfd35af7ec11fdd$export$9d2de6eebf7462b5);
$parcel$export($2cfd35af7ec11fdd$exports, "DRAWER_BODY", () => $2cfd35af7ec11fdd$export$a772fb749abfcf1d);
$parcel$export($2cfd35af7ec11fdd$exports, "DRAWER_FOOTER", () => $2cfd35af7ec11fdd$export$b9287ddc8f6e3044);
$parcel$export($2cfd35af7ec11fdd$exports, "DRAWER_HEADER", () => $2cfd35af7ec11fdd$export$4cd03a6721b31533);
$parcel$export($2cfd35af7ec11fdd$exports, "EDITABLE_TEXT", () => $2cfd35af7ec11fdd$export$8cffb49e9dd41ae);
$parcel$export($2cfd35af7ec11fdd$exports, "EDITABLE_TEXT_CONTENT", () => $2cfd35af7ec11fdd$export$78b1aa7020d6af37);
$parcel$export($2cfd35af7ec11fdd$exports, "EDITABLE_TEXT_EDITING", () => $2cfd35af7ec11fdd$export$2d16d4c1c295606c);
$parcel$export($2cfd35af7ec11fdd$exports, "EDITABLE_TEXT_INPUT", () => $2cfd35af7ec11fdd$export$4d6e427d15d16553);
$parcel$export($2cfd35af7ec11fdd$exports, "EDITABLE_TEXT_PLACEHOLDER", () => $2cfd35af7ec11fdd$export$90d364a014ea6f0a);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE", () => $2cfd35af7ec11fdd$export$659c2dc95c10337e);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_ELLIPSIZE", () => $2cfd35af7ec11fdd$export$c92e868735e7ed90);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_HAS_SUBTITLE", () => $2cfd35af7ec11fdd$export$32306a4d67fbbec);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_ICON_CONTAINER", () => $2cfd35af7ec11fdd$export$4a30999b77042528);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_SUBTITLE", () => $2cfd35af7ec11fdd$export$6d113d689052ca80);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_TAGS_CONTAINER", () => $2cfd35af7ec11fdd$export$2b6f21fa0a5321de);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_TEXT", () => $2cfd35af7ec11fdd$export$dfa64ede72bd0307);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_TITLE", () => $2cfd35af7ec11fdd$export$e57a71e20aa8627);
$parcel$export($2cfd35af7ec11fdd$exports, "ENTITY_TITLE_TITLE_AND_TAGS", () => $2cfd35af7ec11fdd$export$85f27204a6624107);
$parcel$export($2cfd35af7ec11fdd$exports, "FLEX_EXPANDER", () => $2cfd35af7ec11fdd$export$bab85e3adc70edd1);
$parcel$export($2cfd35af7ec11fdd$exports, "HTML_SELECT", () => $2cfd35af7ec11fdd$export$c50fbf6be7ac3331);
$parcel$export($2cfd35af7ec11fdd$exports, "HTML_TABLE", () => $2cfd35af7ec11fdd$export$76a315d343674c9b);
$parcel$export($2cfd35af7ec11fdd$exports, "HTML_TABLE_BORDERED", () => $2cfd35af7ec11fdd$export$13618d7eda5fcc77);
$parcel$export($2cfd35af7ec11fdd$exports, "HTML_TABLE_STRIPED", () => $2cfd35af7ec11fdd$export$a2a4accb8fbddd4a);
$parcel$export($2cfd35af7ec11fdd$exports, "INPUT", () => $2cfd35af7ec11fdd$export$9ea760072c364d49);
$parcel$export($2cfd35af7ec11fdd$exports, "INPUT_GHOST", () => $2cfd35af7ec11fdd$export$e8d5c1be80b7588b);
$parcel$export($2cfd35af7ec11fdd$exports, "INPUT_GROUP", () => $2cfd35af7ec11fdd$export$87f36efdfb463a6f);
$parcel$export($2cfd35af7ec11fdd$exports, "INPUT_LEFT_CONTAINER", () => $2cfd35af7ec11fdd$export$9705bb16375b49e5);
$parcel$export($2cfd35af7ec11fdd$exports, "INPUT_ACTION", () => $2cfd35af7ec11fdd$export$217bb10d53bd2e48);
$parcel$export($2cfd35af7ec11fdd$exports, "RESIZABLE_INPUT_SPAN", () => $2cfd35af7ec11fdd$export$f038e7a42893c7e5);
$parcel$export($2cfd35af7ec11fdd$exports, "TEXT_AREA", () => $2cfd35af7ec11fdd$export$794d3720201fcdd9);
$parcel$export($2cfd35af7ec11fdd$exports, "TEXT_AREA_AUTO_RESIZE", () => $2cfd35af7ec11fdd$export$9c466612a9056aac);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTROL", () => $2cfd35af7ec11fdd$export$43f367b3e957f219);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTROL_INPUT", () => $2cfd35af7ec11fdd$export$bab5e6ae1dd9e6dc);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTROL_INDICATOR", () => $2cfd35af7ec11fdd$export$947bb9f998f185cb);
$parcel$export($2cfd35af7ec11fdd$exports, "CONTROL_INDICATOR_CHILD", () => $2cfd35af7ec11fdd$export$f717c522dcd748f);
$parcel$export($2cfd35af7ec11fdd$exports, "CHECKBOX", () => $2cfd35af7ec11fdd$export$6b636bdca7063f33);
$parcel$export($2cfd35af7ec11fdd$exports, "RADIO", () => $2cfd35af7ec11fdd$export$f0fd3c01e562401e);
$parcel$export($2cfd35af7ec11fdd$exports, "RADIO_GROUP", () => $2cfd35af7ec11fdd$export$fd120c956045e61b);
$parcel$export($2cfd35af7ec11fdd$exports, "SWITCH", () => $2cfd35af7ec11fdd$export$d19595eff304150b);
$parcel$export($2cfd35af7ec11fdd$exports, "SWITCH_INNER_TEXT", () => $2cfd35af7ec11fdd$export$33abfe9257d195b1);
$parcel$export($2cfd35af7ec11fdd$exports, "FILE_INPUT", () => $2cfd35af7ec11fdd$export$57b7f518a2a69b0e);
$parcel$export($2cfd35af7ec11fdd$exports, "FILE_INPUT_HAS_SELECTION", () => $2cfd35af7ec11fdd$export$3359eeec929a0672);
$parcel$export($2cfd35af7ec11fdd$exports, "FILE_UPLOAD_INPUT", () => $2cfd35af7ec11fdd$export$c7e0715fb31daeab);
$parcel$export($2cfd35af7ec11fdd$exports, "FILE_UPLOAD_INPUT_CUSTOM_TEXT", () => $2cfd35af7ec11fdd$export$59e222d99c2278dc);
$parcel$export($2cfd35af7ec11fdd$exports, "KEY", () => $2cfd35af7ec11fdd$export$7167c830cefcb6b5);
$parcel$export($2cfd35af7ec11fdd$exports, "KEY_COMBO", () => $2cfd35af7ec11fdd$export$3fe55454f8e5fecc);
$parcel$export($2cfd35af7ec11fdd$exports, "MODIFIER_KEY", () => $2cfd35af7ec11fdd$export$c0bfb400388c9a25);
$parcel$export($2cfd35af7ec11fdd$exports, "HOTKEY", () => $2cfd35af7ec11fdd$export$524232ca2c12639f);
$parcel$export($2cfd35af7ec11fdd$exports, "HOTKEY_LABEL", () => $2cfd35af7ec11fdd$export$df79a4ea2a4b4f00);
$parcel$export($2cfd35af7ec11fdd$exports, "HOTKEY_COLUMN", () => $2cfd35af7ec11fdd$export$9781926db144baeb);
$parcel$export($2cfd35af7ec11fdd$exports, "HOTKEY_DIALOG", () => $2cfd35af7ec11fdd$export$66e6d5f9c266313f);
$parcel$export($2cfd35af7ec11fdd$exports, "LABEL", () => $2cfd35af7ec11fdd$export$37aee82a3cb1e8f7);
$parcel$export($2cfd35af7ec11fdd$exports, "FORM_GROUP", () => $2cfd35af7ec11fdd$export$eb9b2b8480b01f1a);
$parcel$export($2cfd35af7ec11fdd$exports, "FORM_CONTENT", () => $2cfd35af7ec11fdd$export$1247dfb8c6ce45b3);
$parcel$export($2cfd35af7ec11fdd$exports, "FORM_HELPER_TEXT", () => $2cfd35af7ec11fdd$export$7b266b21b246878c);
$parcel$export($2cfd35af7ec11fdd$exports, "FORM_GROUP_SUB_LABEL", () => $2cfd35af7ec11fdd$export$650c7aa14bc99906);
$parcel$export($2cfd35af7ec11fdd$exports, "LINK", () => $2cfd35af7ec11fdd$export$b395009ca7f092c7);
$parcel$export($2cfd35af7ec11fdd$exports, "LINK_UNDERLINE_ALWAYS", () => $2cfd35af7ec11fdd$export$3382ce39fbe36d96);
$parcel$export($2cfd35af7ec11fdd$exports, "LINK_UNDERLINE_HOVER", () => $2cfd35af7ec11fdd$export$8bb2272d3902d2df);
$parcel$export($2cfd35af7ec11fdd$exports, "LINK_UNDERLINE_NONE", () => $2cfd35af7ec11fdd$export$7a60a55c76739a19);
$parcel$export($2cfd35af7ec11fdd$exports, "LINK_COLOR_INHERIT", () => $2cfd35af7ec11fdd$export$35216eaf487338ff);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU", () => $2cfd35af7ec11fdd$export$4f072ecaef317163);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_ITEM", () => $2cfd35af7ec11fdd$export$fec55ff920461811);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_ITEM_IS_SELECTABLE", () => $2cfd35af7ec11fdd$export$1607fdc199b2002d);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_ITEM_SELECTED_ICON", () => $2cfd35af7ec11fdd$export$57ecfc48b890391e);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_ITEM_ICON", () => $2cfd35af7ec11fdd$export$83ad8bedeaf892db);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_ITEM_LABEL", () => $2cfd35af7ec11fdd$export$127f1aff25359810);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_SUBMENU", () => $2cfd35af7ec11fdd$export$cb67094da280ec15);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_SUBMENU_ICON", () => $2cfd35af7ec11fdd$export$c803f550eda0736b);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_DIVIDER", () => $2cfd35af7ec11fdd$export$3d44661fef1f8fab);
$parcel$export($2cfd35af7ec11fdd$exports, "MENU_HEADER", () => $2cfd35af7ec11fdd$export$935edc360fae2305);
$parcel$export($2cfd35af7ec11fdd$exports, "MULTISTEP_DIALOG", () => $2cfd35af7ec11fdd$export$e4907b506e27c727);
$parcel$export($2cfd35af7ec11fdd$exports, "MULTISTEP_DIALOG_PANELS", () => $2cfd35af7ec11fdd$export$165374e683bfc3d1);
$parcel$export($2cfd35af7ec11fdd$exports, "MULTISTEP_DIALOG_LEFT_PANEL", () => $2cfd35af7ec11fdd$export$90dcb6be9a743a48);
$parcel$export($2cfd35af7ec11fdd$exports, "MULTISTEP_DIALOG_RIGHT_PANEL", () => $2cfd35af7ec11fdd$export$e9411f2a7cfd9180);
$parcel$export($2cfd35af7ec11fdd$exports, "MULTISTEP_DIALOG_NAV_TOP", () => $2cfd35af7ec11fdd$export$d124f327de7e3466);
$parcel$export($2cfd35af7ec11fdd$exports, "MULTISTEP_DIALOG_NAV_RIGHT", () => $2cfd35af7ec11fdd$export$ea2fba933a716cc1);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION", () => $2cfd35af7ec11fdd$export$524548702ba0011d);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_COLLAPSED", () => $2cfd35af7ec11fdd$export$9ba725bcf1af0077);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER", () => $2cfd35af7ec11fdd$export$63456c6676f3202e);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER_LEFT", () => $2cfd35af7ec11fdd$export$9b06418cb438289c);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER_TITLE", () => $2cfd35af7ec11fdd$export$74c36f1cd002a019);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER_SUB_TITLE", () => $2cfd35af7ec11fdd$export$8ed21854aa0cfd29);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER_DIVIDER", () => $2cfd35af7ec11fdd$export$de57f6a3819660b5);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER_TABS", () => $2cfd35af7ec11fdd$export$7694981ef852b7da);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER_RIGHT", () => $2cfd35af7ec11fdd$export$62cb9e4fef796ae4);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_HEADER_COLLAPSE_CARET", () => $2cfd35af7ec11fdd$export$a36a79bf809cf779);
$parcel$export($2cfd35af7ec11fdd$exports, "SECTION_CARD", () => $2cfd35af7ec11fdd$export$4164b234af6a614a);
$parcel$export($2cfd35af7ec11fdd$exports, "NAVBAR", () => $2cfd35af7ec11fdd$export$f326e925396cee25);
$parcel$export($2cfd35af7ec11fdd$exports, "NAVBAR_GROUP", () => $2cfd35af7ec11fdd$export$1deea56284aa1171);
$parcel$export($2cfd35af7ec11fdd$exports, "NAVBAR_HEADING", () => $2cfd35af7ec11fdd$export$cad935353152fe7);
$parcel$export($2cfd35af7ec11fdd$exports, "NAVBAR_DIVIDER", () => $2cfd35af7ec11fdd$export$b91d5a600cda5fbf);
$parcel$export($2cfd35af7ec11fdd$exports, "NON_IDEAL_STATE", () => $2cfd35af7ec11fdd$export$c5a432c36e3e4b78);
$parcel$export($2cfd35af7ec11fdd$exports, "NON_IDEAL_STATE_VISUAL", () => $2cfd35af7ec11fdd$export$da806f614bdc1508);
$parcel$export($2cfd35af7ec11fdd$exports, "NON_IDEAL_STATE_TEXT", () => $2cfd35af7ec11fdd$export$d60a07aa759048a);
$parcel$export($2cfd35af7ec11fdd$exports, "NUMERIC_INPUT", () => $2cfd35af7ec11fdd$export$80e675620d8e3b55);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERFLOW_LIST", () => $2cfd35af7ec11fdd$export$b73498d5fb011014);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERFLOW_LIST_SPACER", () => $2cfd35af7ec11fdd$export$22f5645f551377bf);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY", () => $2cfd35af7ec11fdd$export$abec5a3e0b81aaba);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_BACKDROP", () => $2cfd35af7ec11fdd$export$5b24c9aa87f5d19);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_CONTAINER", () => $2cfd35af7ec11fdd$export$5c46fa2471ac640f);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_CONTENT", () => $2cfd35af7ec11fdd$export$649e0e2ba5bce2b2);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_INLINE", () => $2cfd35af7ec11fdd$export$d070066894e6449f);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_OPEN", () => $2cfd35af7ec11fdd$export$15df4039dd977837);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_SCROLL_CONTAINER", () => $2cfd35af7ec11fdd$export$164be6ff0724d89e);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_START_FOCUS_TRAP", () => $2cfd35af7ec11fdd$export$b05704f848ce027);
$parcel$export($2cfd35af7ec11fdd$exports, "OVERLAY_END_FOCUS_TRAP", () => $2cfd35af7ec11fdd$export$72317839a64c29d3);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK", () => $2cfd35af7ec11fdd$export$977c8163a074ab4c);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK_HEADER", () => $2cfd35af7ec11fdd$export$86f0fc908ef772ca);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK_HEADER_BACK", () => $2cfd35af7ec11fdd$export$dba4a9d0529c5123);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK_VIEW", () => $2cfd35af7ec11fdd$export$9ba9ddd2abc1a482);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK2", () => $2cfd35af7ec11fdd$export$8b7fecf2fba0abf9);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK2_HEADER", () => $2cfd35af7ec11fdd$export$f9f46f21fbe4920c);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK2_HEADER_BACK", () => $2cfd35af7ec11fdd$export$bea2f695ce1f90b1);
$parcel$export($2cfd35af7ec11fdd$exports, "PANEL_STACK2_VIEW", () => $2cfd35af7ec11fdd$export$e6cf7858677f7d09);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER", () => $2cfd35af7ec11fdd$export$dbe3482d899925c4);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_ARROW", () => $2cfd35af7ec11fdd$export$8eaa9259ba89a7e8);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_BACKDROP", () => $2cfd35af7ec11fdd$export$cd1026626bfe5c07);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_CAPTURING_DISMISS", () => $2cfd35af7ec11fdd$export$2cfbe2eb60c57d5b);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_CONTENT", () => $2cfd35af7ec11fdd$export$1e96671e28a297dd);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_CONTENT_PLACEMENT", () => $2cfd35af7ec11fdd$export$345b7893b44144f1);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_CONTENT_SIZING", () => $2cfd35af7ec11fdd$export$5b0bac172c0cf3a);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_DISMISS", () => $2cfd35af7ec11fdd$export$7d23743fb33d0182);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_DISMISS_OVERRIDE", () => $2cfd35af7ec11fdd$export$1f4f24a25ef790c0);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_MATCH_TARGET_WIDTH", () => $2cfd35af7ec11fdd$export$4e93ab2f5f3e0b11);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_OPEN", () => $2cfd35af7ec11fdd$export$e864f5b391d71738);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_POPPER_ESCAPED", () => $2cfd35af7ec11fdd$export$28f35cf1b92fac04);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_REFERENCE_HIDDEN", () => $2cfd35af7ec11fdd$export$4b518c2bca894b80);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_TARGET", () => $2cfd35af7ec11fdd$export$534b03eda12f917);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_TRANSITION_CONTAINER", () => $2cfd35af7ec11fdd$export$620767fe6c31e984);
$parcel$export($2cfd35af7ec11fdd$exports, "POPOVER_WRAPPER", () => $2cfd35af7ec11fdd$export$9361cd420f832cf2);
$parcel$export($2cfd35af7ec11fdd$exports, "PROGRESS_BAR", () => $2cfd35af7ec11fdd$export$40c78f7c1065c43c);
$parcel$export($2cfd35af7ec11fdd$exports, "PROGRESS_METER", () => $2cfd35af7ec11fdd$export$19dacc38bfe958b2);
$parcel$export($2cfd35af7ec11fdd$exports, "PROGRESS_NO_STRIPES", () => $2cfd35af7ec11fdd$export$52fec100aaa98b55);
$parcel$export($2cfd35af7ec11fdd$exports, "PROGRESS_NO_ANIMATION", () => $2cfd35af7ec11fdd$export$890ea6f485d6060f);
$parcel$export($2cfd35af7ec11fdd$exports, "PORTAL", () => $2cfd35af7ec11fdd$export$ac4d91f5203d82ae);
$parcel$export($2cfd35af7ec11fdd$exports, "SKELETON", () => $2cfd35af7ec11fdd$export$169e587b68892b4e);
$parcel$export($2cfd35af7ec11fdd$exports, "SLIDER", () => $2cfd35af7ec11fdd$export$992366d871da5550);
$parcel$export($2cfd35af7ec11fdd$exports, "SLIDER_AXIS", () => $2cfd35af7ec11fdd$export$229cabfdbcbdfc2d);
$parcel$export($2cfd35af7ec11fdd$exports, "SLIDER_HANDLE", () => $2cfd35af7ec11fdd$export$d5ec8f6bd4e7f30c);
$parcel$export($2cfd35af7ec11fdd$exports, "SLIDER_LABEL", () => $2cfd35af7ec11fdd$export$c7563cb73c31904);
$parcel$export($2cfd35af7ec11fdd$exports, "SLIDER_TRACK", () => $2cfd35af7ec11fdd$export$c17129aaccf9f04f);
$parcel$export($2cfd35af7ec11fdd$exports, "SLIDER_PROGRESS", () => $2cfd35af7ec11fdd$export$cb8b3334a21a52ed);
$parcel$export($2cfd35af7ec11fdd$exports, "START", () => $2cfd35af7ec11fdd$export$21c466265830bc3a);
$parcel$export($2cfd35af7ec11fdd$exports, "END", () => $2cfd35af7ec11fdd$export$32239d68d9c6cb49);
$parcel$export($2cfd35af7ec11fdd$exports, "SPINNER", () => $2cfd35af7ec11fdd$export$6bf3d9c372a8b76a);
$parcel$export($2cfd35af7ec11fdd$exports, "SPINNER_ANIMATION", () => $2cfd35af7ec11fdd$export$c422a257b54d6303);
$parcel$export($2cfd35af7ec11fdd$exports, "SPINNER_HEAD", () => $2cfd35af7ec11fdd$export$67c4dde5cd44a3bf);
$parcel$export($2cfd35af7ec11fdd$exports, "SPINNER_NO_SPIN", () => $2cfd35af7ec11fdd$export$35495e002696aec2);
$parcel$export($2cfd35af7ec11fdd$exports, "SPINNER_TRACK", () => $2cfd35af7ec11fdd$export$cf9c7c98d20f3675);
$parcel$export($2cfd35af7ec11fdd$exports, "SEGMENTED_CONTROL", () => $2cfd35af7ec11fdd$export$a9da50bcccdc2ea1);
$parcel$export($2cfd35af7ec11fdd$exports, "TAB", () => $2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e);
$parcel$export($2cfd35af7ec11fdd$exports, "TAB_ICON", () => $2cfd35af7ec11fdd$export$761ffa813d3bcf7b);
$parcel$export($2cfd35af7ec11fdd$exports, "TAB_TAG", () => $2cfd35af7ec11fdd$export$21993928ad2e2f77);
$parcel$export($2cfd35af7ec11fdd$exports, "TAB_INDICATOR", () => $2cfd35af7ec11fdd$export$32364f631fea0fb);
$parcel$export($2cfd35af7ec11fdd$exports, "TAB_INDICATOR_WRAPPER", () => $2cfd35af7ec11fdd$export$8da12ef58da8ed12);
$parcel$export($2cfd35af7ec11fdd$exports, "TAB_LIST", () => $2cfd35af7ec11fdd$export$29216fa86fc3af12);
$parcel$export($2cfd35af7ec11fdd$exports, "TAB_PANEL", () => $2cfd35af7ec11fdd$export$1bc1faf0ee61fa47);
$parcel$export($2cfd35af7ec11fdd$exports, "TABS", () => $2cfd35af7ec11fdd$export$73b877b58963a4f);
$parcel$export($2cfd35af7ec11fdd$exports, "TAG", () => $2cfd35af7ec11fdd$export$2680f340d0781853);
$parcel$export($2cfd35af7ec11fdd$exports, "TAG_REMOVE", () => $2cfd35af7ec11fdd$export$1dace92eb43d2917);
$parcel$export($2cfd35af7ec11fdd$exports, "COMPOUND_TAG", () => $2cfd35af7ec11fdd$export$fe7a531a68939d45);
$parcel$export($2cfd35af7ec11fdd$exports, "COMPOUND_TAG_LEFT", () => $2cfd35af7ec11fdd$export$936a90ee17829787);
$parcel$export($2cfd35af7ec11fdd$exports, "COMPOUND_TAG_LEFT_CONTENT", () => $2cfd35af7ec11fdd$export$23fcc0f95d746a8);
$parcel$export($2cfd35af7ec11fdd$exports, "COMPOUND_TAG_RIGHT", () => $2cfd35af7ec11fdd$export$8b9fa1756fbe1a2c);
$parcel$export($2cfd35af7ec11fdd$exports, "COMPOUND_TAG_RIGHT_CONTENT", () => $2cfd35af7ec11fdd$export$eb7199f9fc66b8f3);
$parcel$export($2cfd35af7ec11fdd$exports, "TAG_INPUT", () => $2cfd35af7ec11fdd$export$ffaf3bbf154e07cf);
$parcel$export($2cfd35af7ec11fdd$exports, "TAG_INPUT_ICON", () => $2cfd35af7ec11fdd$export$999c53f91b6a7a4a);
$parcel$export($2cfd35af7ec11fdd$exports, "TAG_INPUT_VALUES", () => $2cfd35af7ec11fdd$export$1711f8b4411c6f5f);
$parcel$export($2cfd35af7ec11fdd$exports, "TOAST", () => $2cfd35af7ec11fdd$export$6d378d1ab7ed5175);
$parcel$export($2cfd35af7ec11fdd$exports, "TOAST_CONTAINER", () => $2cfd35af7ec11fdd$export$bda400aeced77722);
$parcel$export($2cfd35af7ec11fdd$exports, "TOAST_MESSAGE", () => $2cfd35af7ec11fdd$export$ce2171b20910fc4b);
$parcel$export($2cfd35af7ec11fdd$exports, "TOOLTIP", () => $2cfd35af7ec11fdd$export$1517edb21b105800);
$parcel$export($2cfd35af7ec11fdd$exports, "TOOLTIP_INDICATOR", () => $2cfd35af7ec11fdd$export$db434af9cd0173fa);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE", () => $2cfd35af7ec11fdd$export$33ecaa422889cd80);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE", () => $2cfd35af7ec11fdd$export$497d287dd067ff98);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_CARET", () => $2cfd35af7ec11fdd$export$bcef107a0b76070f);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_CARET_CLOSED", () => $2cfd35af7ec11fdd$export$ea4d3d46c22ddfed);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_CARET_NONE", () => $2cfd35af7ec11fdd$export$94af84e54168f6de);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_CARET_OPEN", () => $2cfd35af7ec11fdd$export$e023ef8de1b4549b);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_CONTENT", () => $2cfd35af7ec11fdd$export$2f310b4a8c8311c8);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_EXPANDED", () => $2cfd35af7ec11fdd$export$22ed5f498d01ae6c);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_ICON", () => $2cfd35af7ec11fdd$export$50f70f673012be50);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_LABEL", () => $2cfd35af7ec11fdd$export$9e24c367c0ac6f88);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_LIST", () => $2cfd35af7ec11fdd$export$eb052bba2c207529);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_SECONDARY_LABEL", () => $2cfd35af7ec11fdd$export$15c472de16dfeefd);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_NODE_SELECTED", () => $2cfd35af7ec11fdd$export$4a8bcbdf26c6e4af);
$parcel$export($2cfd35af7ec11fdd$exports, "TREE_ROOT", () => $2cfd35af7ec11fdd$export$b397da2e1679ac19);
$parcel$export($2cfd35af7ec11fdd$exports, "ICON", () => $2cfd35af7ec11fdd$export$d2b60e6b56e900e8);
$parcel$export($2cfd35af7ec11fdd$exports, "ICON_STANDARD", () => $2cfd35af7ec11fdd$export$9e817070703bebe0);
$parcel$export($2cfd35af7ec11fdd$exports, "ICON_LARGE", () => $2cfd35af7ec11fdd$export$ef62356806fa9c5a);
$parcel$export($2cfd35af7ec11fdd$exports, "ICON_MUTED", () => $2cfd35af7ec11fdd$export$42eab3af8b7fb664);
$parcel$export($2cfd35af7ec11fdd$exports, "getClassNamespace", () => $2cfd35af7ec11fdd$export$e018c2ab23bd5a2c);
$parcel$export($2cfd35af7ec11fdd$exports, "alignmentClass", () => $2cfd35af7ec11fdd$export$4677781bb583a8b4);
$parcel$export($2cfd35af7ec11fdd$exports, "iconClass", () => $2cfd35af7ec11fdd$export$9a22524e6364be6);
$parcel$export($2cfd35af7ec11fdd$exports, "sizeClass", () => $2cfd35af7ec11fdd$export$d3aeaee5bf9ec3ef);
$parcel$export($2cfd35af7ec11fdd$exports, "variantClass", () => $2cfd35af7ec11fdd$export$ca9b25d6cdb1dab3);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Alignment along the horizontal axis. */ const $ff848d68cab849d9$export$9d7927214ed7d2cf = {
    CENTER: "center",
    END: "end",
    /**
     * @deprecated use `Alignment.START` instead.
     */ LEFT: "left",
    /**
     * @deprecated use `Alignment.END` instead.
     */ RIGHT: "right",
    START: "start"
};
const $ff848d68cab849d9$export$84b2d1b68830363f = {
    CENTER: "center",
    END: "end",
    START: "start"
};


/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable sort-keys */ const $214039abae8daf12$export$58bfb4f6ec5aa58d = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4
};


/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable sort-keys */ /**
 * The four basic intents.
 */ const $9489302fa7beb346$export$dc3e8878c31a5f1c = {
    NONE: "none",
    PRIMARY: "primary",
    SUCCESS: "success",
    WARNING: "warning",
    DANGER: "danger"
};


/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $066a1d9f6e8ad6f2$export$13807d9ee5a34a42 = {
    BOTTOM: "bottom",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    LEFT: "left",
    LEFT_BOTTOM: "left-bottom",
    LEFT_TOP: "left-top",
    RIGHT: "right",
    RIGHT_BOTTOM: "right-bottom",
    RIGHT_TOP: "right-top",
    TOP: "top",
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right"
};
function $066a1d9f6e8ad6f2$export$b0b056baf6a0eb37(position) {
    /* istanbul ignore next */ return position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.TOP || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.TOP_LEFT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.TOP_RIGHT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.BOTTOM || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.BOTTOM_LEFT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.BOTTOM_RIGHT;
}
function $066a1d9f6e8ad6f2$export$5df8e457999da1ae(position) {
    /* istanbul ignore next */ return position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.LEFT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.LEFT_TOP || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.LEFT_BOTTOM || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.RIGHT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.RIGHT_TOP || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.RIGHT_BOTTOM;
}
function $066a1d9f6e8ad6f2$export$a531f93822c3a253(position) {
    if (position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.TOP || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.TOP_LEFT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.TOP_RIGHT) return $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.TOP;
    else if (position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.BOTTOM || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.BOTTOM_LEFT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.BOTTOM_RIGHT) return $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.BOTTOM;
    else if (position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.LEFT || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.LEFT_TOP || position === $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.LEFT_BOTTOM) return $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.LEFT;
    else return $066a1d9f6e8ad6f2$export$13807d9ee5a34a42.RIGHT;
}


let $2cfd35af7ec11fdd$var$NS = "bp6";
if (typeof BLUEPRINT_NAMESPACE !== "undefined") $2cfd35af7ec11fdd$var$NS = BLUEPRINT_NAMESPACE;
else if (typeof REACT_APP_BLUEPRINT_NAMESPACE !== "undefined") $2cfd35af7ec11fdd$var$NS = REACT_APP_BLUEPRINT_NAMESPACE;
const $2cfd35af7ec11fdd$export$2b35adb71b3f6143 = `${$2cfd35af7ec11fdd$var$NS}-active`;
const $2cfd35af7ec11fdd$export$7895aadd1956b1c7 = `${$2cfd35af7ec11fdd$var$NS}-align-left`;
const $2cfd35af7ec11fdd$export$f1299af03a3c605a = `${$2cfd35af7ec11fdd$var$NS}-align-right`;
const $2cfd35af7ec11fdd$export$db1cdb8627b81f84 = `${$2cfd35af7ec11fdd$var$NS}-compact`;
const $2cfd35af7ec11fdd$export$b9b16d1820185434 = `${$2cfd35af7ec11fdd$var$NS}-dark`;
const $2cfd35af7ec11fdd$export$8cd212c10b4124d2 = `${$2cfd35af7ec11fdd$var$NS}-disabled`;
const $2cfd35af7ec11fdd$export$5672a3e1deb5b505 = `${$2cfd35af7ec11fdd$var$NS}-fill`;
const $2cfd35af7ec11fdd$export$91f67f1eeaea8c1e = `${$2cfd35af7ec11fdd$var$NS}-fixed`;
const $2cfd35af7ec11fdd$export$3df9f2c23b50ca42 = `${$2cfd35af7ec11fdd$var$NS}-fixed-top`;
const $2cfd35af7ec11fdd$export$1ff9623b26415f8 = `${$2cfd35af7ec11fdd$var$NS}-inline`;
const $2cfd35af7ec11fdd$export$ceebd5febfdef8a3 = `${$2cfd35af7ec11fdd$var$NS}-interactive`;
const $2cfd35af7ec11fdd$export$7b93a10c0fefe3e3 = `${$2cfd35af7ec11fdd$var$NS}-large`;
const $2cfd35af7ec11fdd$export$26d55645375ca9a = `${$2cfd35af7ec11fdd$var$NS}-loading`;
const $2cfd35af7ec11fdd$export$a61ada011bb84f5 = `${$2cfd35af7ec11fdd$var$NS}-minimal`;
const $2cfd35af7ec11fdd$export$d31ef73d8bd6b2be = `${$2cfd35af7ec11fdd$var$NS}-outlined`;
const $2cfd35af7ec11fdd$export$1f3db38142bdf083 = `${$2cfd35af7ec11fdd$var$NS}-padded`;
const $2cfd35af7ec11fdd$export$49f467056ef3fc6c = `${$2cfd35af7ec11fdd$var$NS}-multiline`;
const $2cfd35af7ec11fdd$export$a45819e0f9bcfea2 = `${$2cfd35af7ec11fdd$var$NS}-read-only`;
const $2cfd35af7ec11fdd$export$58785fc667c0c50b = `${$2cfd35af7ec11fdd$var$NS}-round`;
const $2cfd35af7ec11fdd$export$657f886463d93938 = `${$2cfd35af7ec11fdd$var$NS}-selected`;
const $2cfd35af7ec11fdd$export$71dd4c8ecd45e95f = `${$2cfd35af7ec11fdd$var$NS}-small`;
const $2cfd35af7ec11fdd$export$9f2fe7df0ae9fdea = `${$2cfd35af7ec11fdd$var$NS}-vertical`;
const $2cfd35af7ec11fdd$export$4fb34bdcd97adf85 = $2cfd35af7ec11fdd$export$4f8aee4b943e40e((0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42).TOP);
const $2cfd35af7ec11fdd$export$cec9b06edc71d96c = $2cfd35af7ec11fdd$export$4f8aee4b943e40e((0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42).BOTTOM);
const $2cfd35af7ec11fdd$export$b0758137ee643e7 = $2cfd35af7ec11fdd$export$4f8aee4b943e40e((0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42).LEFT);
const $2cfd35af7ec11fdd$export$4ed9c122bcc20157 = $2cfd35af7ec11fdd$export$4f8aee4b943e40e((0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42).RIGHT);
const $2cfd35af7ec11fdd$export$c8efb467fc55a6a1 = $2cfd35af7ec11fdd$export$b7727d57dec24270((0, $214039abae8daf12$export$58bfb4f6ec5aa58d).ZERO);
const $2cfd35af7ec11fdd$export$7b5afc1ddf65f8b7 = $2cfd35af7ec11fdd$export$b7727d57dec24270((0, $214039abae8daf12$export$58bfb4f6ec5aa58d).ONE);
const $2cfd35af7ec11fdd$export$86dd92dfea4f39dd = $2cfd35af7ec11fdd$export$b7727d57dec24270((0, $214039abae8daf12$export$58bfb4f6ec5aa58d).TWO);
const $2cfd35af7ec11fdd$export$ef7592bd90f2537f = $2cfd35af7ec11fdd$export$b7727d57dec24270((0, $214039abae8daf12$export$58bfb4f6ec5aa58d).THREE);
const $2cfd35af7ec11fdd$export$1d67a24a95ef24c2 = $2cfd35af7ec11fdd$export$b7727d57dec24270((0, $214039abae8daf12$export$58bfb4f6ec5aa58d).FOUR);
const $2cfd35af7ec11fdd$export$37c8deab6e9ff120 = $2cfd35af7ec11fdd$export$6771d82d925c8189((0, $9489302fa7beb346$export$dc3e8878c31a5f1c).PRIMARY);
const $2cfd35af7ec11fdd$export$fd8d2f5f74a29424 = $2cfd35af7ec11fdd$export$6771d82d925c8189((0, $9489302fa7beb346$export$dc3e8878c31a5f1c).SUCCESS);
const $2cfd35af7ec11fdd$export$355c57fd095a7f5a = $2cfd35af7ec11fdd$export$6771d82d925c8189((0, $9489302fa7beb346$export$dc3e8878c31a5f1c).WARNING);
const $2cfd35af7ec11fdd$export$373495f4c0568b73 = $2cfd35af7ec11fdd$export$6771d82d925c8189((0, $9489302fa7beb346$export$dc3e8878c31a5f1c).DANGER);
const $2cfd35af7ec11fdd$export$aeda8252e54b50f7 = `${$2cfd35af7ec11fdd$var$NS}-focus-disabled`;
const $2cfd35af7ec11fdd$export$bedc1b77a139edca = `${$2cfd35af7ec11fdd$var$NS}-focus-style-manager-ignore`;
const $2cfd35af7ec11fdd$export$88620a540780da7c = `${$2cfd35af7ec11fdd$var$NS}-ui-text`;
const $2cfd35af7ec11fdd$export$d0190f823696a5cc = `${$2cfd35af7ec11fdd$var$NS}-running-text`;
const $2cfd35af7ec11fdd$export$558d226ddadcf457 = `${$2cfd35af7ec11fdd$var$NS}-monospace-text`;
const $2cfd35af7ec11fdd$export$50e449675bbd8ae2 = `${$2cfd35af7ec11fdd$var$NS}-text-large`;
const $2cfd35af7ec11fdd$export$504f956f6b2a8e65 = `${$2cfd35af7ec11fdd$var$NS}-text-small`;
const $2cfd35af7ec11fdd$export$31a5874ec7f49f29 = `${$2cfd35af7ec11fdd$var$NS}-text-muted`;
const $2cfd35af7ec11fdd$export$4aa79107ea222f04 = `${$2cfd35af7ec11fdd$var$NS}-text-disabled`;
const $2cfd35af7ec11fdd$export$cd50c877adf39dd7 = `${$2cfd35af7ec11fdd$var$NS}-text-overflow-ellipsis`;
const $2cfd35af7ec11fdd$export$afa7aa09bb57d54f = `${$2cfd35af7ec11fdd$var$NS}-blockquote`;
const $2cfd35af7ec11fdd$export$ec5856072852bd7f = `${$2cfd35af7ec11fdd$var$NS}-code`;
const $2cfd35af7ec11fdd$export$cf55d1bff75690da = `${$2cfd35af7ec11fdd$var$NS}-code-block`;
const $2cfd35af7ec11fdd$export$eef1738e402a65e6 = `${$2cfd35af7ec11fdd$var$NS}-heading`;
const $2cfd35af7ec11fdd$export$84cc8e12a434d4e = `${$2cfd35af7ec11fdd$var$NS}-list`;
const $2cfd35af7ec11fdd$export$e52b656749d9474c = `${$2cfd35af7ec11fdd$var$NS}-list-unstyled`;
const $2cfd35af7ec11fdd$export$850f7749a2909601 = `${$2cfd35af7ec11fdd$var$NS}-rtl`;
const $2cfd35af7ec11fdd$export$8dfce1a3f4c39a = `${$2cfd35af7ec11fdd$var$NS}-alert`;
const $2cfd35af7ec11fdd$export$5d3ddfb12869545d = `${$2cfd35af7ec11fdd$export$8dfce1a3f4c39a}-body`;
const $2cfd35af7ec11fdd$export$1dba7da5e8205b5f = `${$2cfd35af7ec11fdd$export$8dfce1a3f4c39a}-contents`;
const $2cfd35af7ec11fdd$export$a928c8e2db526b6c = `${$2cfd35af7ec11fdd$export$8dfce1a3f4c39a}-footer`;
const $2cfd35af7ec11fdd$export$474829b260ce19ab = `${$2cfd35af7ec11fdd$var$NS}-breadcrumb`;
const $2cfd35af7ec11fdd$export$d25ee28b316abe2a = `${$2cfd35af7ec11fdd$export$474829b260ce19ab}-current`;
const $2cfd35af7ec11fdd$export$c3619772211b515b = `${$2cfd35af7ec11fdd$export$474829b260ce19ab}s`;
const $2cfd35af7ec11fdd$export$6c5df38f864cf0e3 = `${$2cfd35af7ec11fdd$export$474829b260ce19ab}s-collapsed`;
const $2cfd35af7ec11fdd$export$b887e88d8d0739f6 = `${$2cfd35af7ec11fdd$var$NS}-button`;
const $2cfd35af7ec11fdd$export$cbb1216936bf389c = `${$2cfd35af7ec11fdd$export$b887e88d8d0739f6}-group`;
const $2cfd35af7ec11fdd$export$3fd25a11349a7fac = `${$2cfd35af7ec11fdd$export$b887e88d8d0739f6}-spinner`;
const $2cfd35af7ec11fdd$export$22617f068a979d82 = `${$2cfd35af7ec11fdd$export$b887e88d8d0739f6}-text`;
const $2cfd35af7ec11fdd$export$ae3fb0b35b6ca2a9 = `${$2cfd35af7ec11fdd$var$NS}-callout`;
const $2cfd35af7ec11fdd$export$c801bbbb1e2ccb0b = `${$2cfd35af7ec11fdd$export$ae3fb0b35b6ca2a9}-has-body-content`;
const $2cfd35af7ec11fdd$export$c4700bfd78cb069a = `${$2cfd35af7ec11fdd$export$ae3fb0b35b6ca2a9}-icon`;
const $2cfd35af7ec11fdd$export$95783a805443ad7d = `${$2cfd35af7ec11fdd$var$NS}-card`;
const $2cfd35af7ec11fdd$export$6769bd973fd6af36 = `${$2cfd35af7ec11fdd$var$NS}-control-card`;
const $2cfd35af7ec11fdd$export$d60e975594bbe489 = `${$2cfd35af7ec11fdd$export$6769bd973fd6af36}-label`;
const $2cfd35af7ec11fdd$export$9cedcb03c3922bb7 = `${$2cfd35af7ec11fdd$var$NS}-switch-control-card`;
const $2cfd35af7ec11fdd$export$3412f17fbe03c097 = `${$2cfd35af7ec11fdd$var$NS}-checkbox-control-card`;
const $2cfd35af7ec11fdd$export$4de35bcdbf177a1f = `${$2cfd35af7ec11fdd$var$NS}-radio-control-card`;
const $2cfd35af7ec11fdd$export$ad39b86c40d3c47c = `${$2cfd35af7ec11fdd$var$NS}-card-list`;
const $2cfd35af7ec11fdd$export$5adfba49857b538f = `${$2cfd35af7ec11fdd$export$ad39b86c40d3c47c}-bordered`;
const $2cfd35af7ec11fdd$export$a1b955d4799a6f74 = `${$2cfd35af7ec11fdd$var$NS}-collapse`;
const $2cfd35af7ec11fdd$export$e4d292b696959393 = `${$2cfd35af7ec11fdd$export$a1b955d4799a6f74}-body`;
const $2cfd35af7ec11fdd$export$6a0da22e72d4f0eb = `${$2cfd35af7ec11fdd$var$NS}-context-menu`;
const $2cfd35af7ec11fdd$export$b9534b88b3cef166 = `${$2cfd35af7ec11fdd$export$6a0da22e72d4f0eb}-virtual-target`;
const $2cfd35af7ec11fdd$export$7ee0ba3b9fa0a5ea = `${$2cfd35af7ec11fdd$export$6a0da22e72d4f0eb}-popover`;
const $2cfd35af7ec11fdd$export$418ef826d3ba978d = `${$2cfd35af7ec11fdd$export$6a0da22e72d4f0eb}-backdrop`;
const $2cfd35af7ec11fdd$export$1c86bb6d85c165 = `${$2cfd35af7ec11fdd$var$NS}-control-group`;
const $2cfd35af7ec11fdd$export$f99739dbfcd2e015 = `${$2cfd35af7ec11fdd$var$NS}-dialog`;
const $2cfd35af7ec11fdd$export$d84b649f32bf6ead = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-container`;
const $2cfd35af7ec11fdd$export$c09efbe888b20fd = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-header`;
const $2cfd35af7ec11fdd$export$12096ec1410ccb2 = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-body`;
const $2cfd35af7ec11fdd$export$dd51a6f3fef5a9d4 = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-body-scroll-container`;
const $2cfd35af7ec11fdd$export$9588cbdf14f4605f = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-close-button`;
const $2cfd35af7ec11fdd$export$6ea271a01e7dc590 = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-footer`;
const $2cfd35af7ec11fdd$export$b60b0eff9b84a85c = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-footer-fixed`;
const $2cfd35af7ec11fdd$export$a01581f2cb63a5c5 = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-footer-main-section`;
const $2cfd35af7ec11fdd$export$6ab793fb94a2b7f8 = `${$2cfd35af7ec11fdd$export$f99739dbfcd2e015}-footer-actions`;
const $2cfd35af7ec11fdd$export$ff97c652790bdec = `${$2cfd35af7ec11fdd$var$NS}-dialog-step`;
const $2cfd35af7ec11fdd$export$15158775e667dbe6 = `${$2cfd35af7ec11fdd$export$ff97c652790bdec}-container`;
const $2cfd35af7ec11fdd$export$e6263bc32f85a4a4 = `${$2cfd35af7ec11fdd$export$ff97c652790bdec}-title`;
const $2cfd35af7ec11fdd$export$e7c377477d704043 = `${$2cfd35af7ec11fdd$export$ff97c652790bdec}-icon`;
const $2cfd35af7ec11fdd$export$97e1fe7e02b9bd0 = `${$2cfd35af7ec11fdd$export$ff97c652790bdec}-viewed`;
const $2cfd35af7ec11fdd$export$59669b530bfa91b6 = `${$2cfd35af7ec11fdd$var$NS}-divider`;
const $2cfd35af7ec11fdd$export$9d2de6eebf7462b5 = `${$2cfd35af7ec11fdd$var$NS}-drawer`;
const $2cfd35af7ec11fdd$export$a772fb749abfcf1d = `${$2cfd35af7ec11fdd$export$9d2de6eebf7462b5}-body`;
const $2cfd35af7ec11fdd$export$b9287ddc8f6e3044 = `${$2cfd35af7ec11fdd$export$9d2de6eebf7462b5}-footer`;
const $2cfd35af7ec11fdd$export$4cd03a6721b31533 = `${$2cfd35af7ec11fdd$export$9d2de6eebf7462b5}-header`;
const $2cfd35af7ec11fdd$export$8cffb49e9dd41ae = `${$2cfd35af7ec11fdd$var$NS}-editable-text`;
const $2cfd35af7ec11fdd$export$78b1aa7020d6af37 = `${$2cfd35af7ec11fdd$export$8cffb49e9dd41ae}-content`;
const $2cfd35af7ec11fdd$export$2d16d4c1c295606c = `${$2cfd35af7ec11fdd$export$8cffb49e9dd41ae}-editing`;
const $2cfd35af7ec11fdd$export$4d6e427d15d16553 = `${$2cfd35af7ec11fdd$export$8cffb49e9dd41ae}-input`;
const $2cfd35af7ec11fdd$export$90d364a014ea6f0a = `${$2cfd35af7ec11fdd$export$8cffb49e9dd41ae}-placeholder`;
const $2cfd35af7ec11fdd$export$659c2dc95c10337e = `${$2cfd35af7ec11fdd$var$NS}-entity-title`;
const $2cfd35af7ec11fdd$export$c92e868735e7ed90 = `${$2cfd35af7ec11fdd$var$NS}-entity-title-ellipsize`;
const $2cfd35af7ec11fdd$export$32306a4d67fbbec = `${$2cfd35af7ec11fdd$export$659c2dc95c10337e}-has-subtitle`;
const $2cfd35af7ec11fdd$export$4a30999b77042528 = `${$2cfd35af7ec11fdd$export$659c2dc95c10337e}-icon-container`;
const $2cfd35af7ec11fdd$export$6d113d689052ca80 = `${$2cfd35af7ec11fdd$export$659c2dc95c10337e}-subtitle`;
const $2cfd35af7ec11fdd$export$2b6f21fa0a5321de = `${$2cfd35af7ec11fdd$export$659c2dc95c10337e}-tags-container`;
const $2cfd35af7ec11fdd$export$dfa64ede72bd0307 = `${$2cfd35af7ec11fdd$export$659c2dc95c10337e}-text`;
const $2cfd35af7ec11fdd$export$e57a71e20aa8627 = `${$2cfd35af7ec11fdd$export$659c2dc95c10337e}-title`;
const $2cfd35af7ec11fdd$export$85f27204a6624107 = `${$2cfd35af7ec11fdd$export$659c2dc95c10337e}-title-and-tags`;
const $2cfd35af7ec11fdd$export$bab85e3adc70edd1 = `${$2cfd35af7ec11fdd$var$NS}-flex-expander`;
const $2cfd35af7ec11fdd$export$c50fbf6be7ac3331 = `${$2cfd35af7ec11fdd$var$NS}-html-select`;
const $2cfd35af7ec11fdd$export$76a315d343674c9b = `${$2cfd35af7ec11fdd$var$NS}-html-table`;
const $2cfd35af7ec11fdd$export$13618d7eda5fcc77 = `${$2cfd35af7ec11fdd$export$76a315d343674c9b}-bordered`;
const $2cfd35af7ec11fdd$export$a2a4accb8fbddd4a = `${$2cfd35af7ec11fdd$export$76a315d343674c9b}-striped`;
const $2cfd35af7ec11fdd$export$9ea760072c364d49 = `${$2cfd35af7ec11fdd$var$NS}-input`;
const $2cfd35af7ec11fdd$export$e8d5c1be80b7588b = `${$2cfd35af7ec11fdd$export$9ea760072c364d49}-ghost`;
const $2cfd35af7ec11fdd$export$87f36efdfb463a6f = `${$2cfd35af7ec11fdd$export$9ea760072c364d49}-group`;
const $2cfd35af7ec11fdd$export$9705bb16375b49e5 = `${$2cfd35af7ec11fdd$export$9ea760072c364d49}-left-container`;
const $2cfd35af7ec11fdd$export$217bb10d53bd2e48 = `${$2cfd35af7ec11fdd$export$9ea760072c364d49}-action`;
const $2cfd35af7ec11fdd$export$f038e7a42893c7e5 = `${$2cfd35af7ec11fdd$var$NS}-resizable-input-span`;
const $2cfd35af7ec11fdd$export$794d3720201fcdd9 = `${$2cfd35af7ec11fdd$var$NS}-text-area`;
const $2cfd35af7ec11fdd$export$9c466612a9056aac = `${$2cfd35af7ec11fdd$export$794d3720201fcdd9}-auto-resize`;
const $2cfd35af7ec11fdd$export$43f367b3e957f219 = `${$2cfd35af7ec11fdd$var$NS}-control`;
const $2cfd35af7ec11fdd$export$bab5e6ae1dd9e6dc = `${$2cfd35af7ec11fdd$export$43f367b3e957f219}-input`;
const $2cfd35af7ec11fdd$export$947bb9f998f185cb = `${$2cfd35af7ec11fdd$export$43f367b3e957f219}-indicator`;
const $2cfd35af7ec11fdd$export$f717c522dcd748f = `${$2cfd35af7ec11fdd$export$947bb9f998f185cb}-child`;
const $2cfd35af7ec11fdd$export$6b636bdca7063f33 = `${$2cfd35af7ec11fdd$var$NS}-checkbox`;
const $2cfd35af7ec11fdd$export$f0fd3c01e562401e = `${$2cfd35af7ec11fdd$var$NS}-radio`;
const $2cfd35af7ec11fdd$export$fd120c956045e61b = `${$2cfd35af7ec11fdd$var$NS}-radio-group`;
const $2cfd35af7ec11fdd$export$d19595eff304150b = `${$2cfd35af7ec11fdd$var$NS}-switch`;
const $2cfd35af7ec11fdd$export$33abfe9257d195b1 = `${$2cfd35af7ec11fdd$export$d19595eff304150b}-inner-text`;
const $2cfd35af7ec11fdd$export$57b7f518a2a69b0e = `${$2cfd35af7ec11fdd$var$NS}-file-input`;
const $2cfd35af7ec11fdd$export$3359eeec929a0672 = `${$2cfd35af7ec11fdd$var$NS}-file-input-has-selection`;
const $2cfd35af7ec11fdd$export$c7e0715fb31daeab = `${$2cfd35af7ec11fdd$var$NS}-file-upload-input`;
const $2cfd35af7ec11fdd$export$59e222d99c2278dc = `${$2cfd35af7ec11fdd$var$NS}-file-upload-input-custom-text`;
const $2cfd35af7ec11fdd$export$7167c830cefcb6b5 = `${$2cfd35af7ec11fdd$var$NS}-key`;
const $2cfd35af7ec11fdd$export$3fe55454f8e5fecc = `${$2cfd35af7ec11fdd$export$7167c830cefcb6b5}-combo`;
const $2cfd35af7ec11fdd$export$c0bfb400388c9a25 = `${$2cfd35af7ec11fdd$var$NS}-modifier-key`;
const $2cfd35af7ec11fdd$export$524232ca2c12639f = `${$2cfd35af7ec11fdd$var$NS}-hotkey`;
const $2cfd35af7ec11fdd$export$df79a4ea2a4b4f00 = `${$2cfd35af7ec11fdd$export$524232ca2c12639f}-label`;
const $2cfd35af7ec11fdd$export$9781926db144baeb = `${$2cfd35af7ec11fdd$export$524232ca2c12639f}-column`;
const $2cfd35af7ec11fdd$export$66e6d5f9c266313f = `${$2cfd35af7ec11fdd$export$524232ca2c12639f}-dialog`;
const $2cfd35af7ec11fdd$export$37aee82a3cb1e8f7 = `${$2cfd35af7ec11fdd$var$NS}-label`;
const $2cfd35af7ec11fdd$export$eb9b2b8480b01f1a = `${$2cfd35af7ec11fdd$var$NS}-form-group`;
const $2cfd35af7ec11fdd$export$1247dfb8c6ce45b3 = `${$2cfd35af7ec11fdd$var$NS}-form-content`;
const $2cfd35af7ec11fdd$export$7b266b21b246878c = `${$2cfd35af7ec11fdd$var$NS}-form-helper-text`;
const $2cfd35af7ec11fdd$export$650c7aa14bc99906 = `${$2cfd35af7ec11fdd$var$NS}-form-group-sub-label`;
const $2cfd35af7ec11fdd$export$b395009ca7f092c7 = `${$2cfd35af7ec11fdd$var$NS}-link`;
const $2cfd35af7ec11fdd$export$3382ce39fbe36d96 = `${$2cfd35af7ec11fdd$export$b395009ca7f092c7}-underline-always`;
const $2cfd35af7ec11fdd$export$8bb2272d3902d2df = `${$2cfd35af7ec11fdd$export$b395009ca7f092c7}-underline-hover`;
const $2cfd35af7ec11fdd$export$7a60a55c76739a19 = `${$2cfd35af7ec11fdd$export$b395009ca7f092c7}-underline-none`;
const $2cfd35af7ec11fdd$export$35216eaf487338ff = `${$2cfd35af7ec11fdd$export$b395009ca7f092c7}-color-inherit`;
const $2cfd35af7ec11fdd$export$4f072ecaef317163 = `${$2cfd35af7ec11fdd$var$NS}-menu`;
const $2cfd35af7ec11fdd$export$fec55ff920461811 = `${$2cfd35af7ec11fdd$export$4f072ecaef317163}-item`;
const $2cfd35af7ec11fdd$export$1607fdc199b2002d = `${$2cfd35af7ec11fdd$export$fec55ff920461811}-is-selectable`;
const $2cfd35af7ec11fdd$export$57ecfc48b890391e = `${$2cfd35af7ec11fdd$export$fec55ff920461811}-selected-icon`;
const $2cfd35af7ec11fdd$export$83ad8bedeaf892db = `${$2cfd35af7ec11fdd$export$fec55ff920461811}-icon`;
const $2cfd35af7ec11fdd$export$127f1aff25359810 = `${$2cfd35af7ec11fdd$export$fec55ff920461811}-label`;
const $2cfd35af7ec11fdd$export$cb67094da280ec15 = `${$2cfd35af7ec11fdd$var$NS}-submenu`;
const $2cfd35af7ec11fdd$export$c803f550eda0736b = `${$2cfd35af7ec11fdd$export$cb67094da280ec15}-icon`;
const $2cfd35af7ec11fdd$export$3d44661fef1f8fab = `${$2cfd35af7ec11fdd$export$4f072ecaef317163}-divider`;
const $2cfd35af7ec11fdd$export$935edc360fae2305 = `${$2cfd35af7ec11fdd$export$4f072ecaef317163}-header`;
const $2cfd35af7ec11fdd$export$e4907b506e27c727 = `${$2cfd35af7ec11fdd$var$NS}-multistep-dialog`;
const $2cfd35af7ec11fdd$export$165374e683bfc3d1 = `${$2cfd35af7ec11fdd$export$e4907b506e27c727}-panels`;
const $2cfd35af7ec11fdd$export$90dcb6be9a743a48 = `${$2cfd35af7ec11fdd$export$e4907b506e27c727}-left-panel`;
const $2cfd35af7ec11fdd$export$e9411f2a7cfd9180 = `${$2cfd35af7ec11fdd$export$e4907b506e27c727}-right-panel`;
const $2cfd35af7ec11fdd$export$d124f327de7e3466 = `${$2cfd35af7ec11fdd$export$e4907b506e27c727}-nav-top`;
const $2cfd35af7ec11fdd$export$ea2fba933a716cc1 = `${$2cfd35af7ec11fdd$export$e4907b506e27c727}-nav-right`;
const $2cfd35af7ec11fdd$export$524548702ba0011d = `${$2cfd35af7ec11fdd$var$NS}-section`;
const $2cfd35af7ec11fdd$export$9ba725bcf1af0077 = `${$2cfd35af7ec11fdd$export$524548702ba0011d}-collapsed`;
const $2cfd35af7ec11fdd$export$63456c6676f3202e = `${$2cfd35af7ec11fdd$export$524548702ba0011d}-header`;
const $2cfd35af7ec11fdd$export$9b06418cb438289c = `${$2cfd35af7ec11fdd$export$63456c6676f3202e}-left`;
const $2cfd35af7ec11fdd$export$74c36f1cd002a019 = `${$2cfd35af7ec11fdd$export$63456c6676f3202e}-title`;
const $2cfd35af7ec11fdd$export$8ed21854aa0cfd29 = `${$2cfd35af7ec11fdd$export$63456c6676f3202e}-sub-title`;
const $2cfd35af7ec11fdd$export$de57f6a3819660b5 = `${$2cfd35af7ec11fdd$export$63456c6676f3202e}-divider`;
const $2cfd35af7ec11fdd$export$7694981ef852b7da = `${$2cfd35af7ec11fdd$export$63456c6676f3202e}-tabs`;
const $2cfd35af7ec11fdd$export$62cb9e4fef796ae4 = `${$2cfd35af7ec11fdd$export$63456c6676f3202e}-right`;
const $2cfd35af7ec11fdd$export$a36a79bf809cf779 = `${$2cfd35af7ec11fdd$export$63456c6676f3202e}-collapse-caret`;
const $2cfd35af7ec11fdd$export$4164b234af6a614a = `${$2cfd35af7ec11fdd$export$524548702ba0011d}-card`;
const $2cfd35af7ec11fdd$export$f326e925396cee25 = `${$2cfd35af7ec11fdd$var$NS}-navbar`;
const $2cfd35af7ec11fdd$export$1deea56284aa1171 = `${$2cfd35af7ec11fdd$export$f326e925396cee25}-group`;
const $2cfd35af7ec11fdd$export$cad935353152fe7 = `${$2cfd35af7ec11fdd$export$f326e925396cee25}-heading`;
const $2cfd35af7ec11fdd$export$b91d5a600cda5fbf = `${$2cfd35af7ec11fdd$export$f326e925396cee25}-divider`;
const $2cfd35af7ec11fdd$export$c5a432c36e3e4b78 = `${$2cfd35af7ec11fdd$var$NS}-non-ideal-state`;
const $2cfd35af7ec11fdd$export$da806f614bdc1508 = `${$2cfd35af7ec11fdd$export$c5a432c36e3e4b78}-visual`;
const $2cfd35af7ec11fdd$export$d60a07aa759048a = `${$2cfd35af7ec11fdd$export$c5a432c36e3e4b78}-text`;
const $2cfd35af7ec11fdd$export$80e675620d8e3b55 = `${$2cfd35af7ec11fdd$var$NS}-numeric-input`;
const $2cfd35af7ec11fdd$export$b73498d5fb011014 = `${$2cfd35af7ec11fdd$var$NS}-overflow-list`;
const $2cfd35af7ec11fdd$export$22f5645f551377bf = `${$2cfd35af7ec11fdd$export$b73498d5fb011014}-spacer`;
const $2cfd35af7ec11fdd$export$abec5a3e0b81aaba = `${$2cfd35af7ec11fdd$var$NS}-overlay`;
const $2cfd35af7ec11fdd$export$5b24c9aa87f5d19 = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-backdrop`;
const $2cfd35af7ec11fdd$export$5c46fa2471ac640f = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-container`;
const $2cfd35af7ec11fdd$export$649e0e2ba5bce2b2 = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-content`;
const $2cfd35af7ec11fdd$export$d070066894e6449f = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-inline`;
const $2cfd35af7ec11fdd$export$15df4039dd977837 = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-open`;
const $2cfd35af7ec11fdd$export$164be6ff0724d89e = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-scroll-container`;
const $2cfd35af7ec11fdd$export$b05704f848ce027 = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-start-focus-trap`;
const $2cfd35af7ec11fdd$export$72317839a64c29d3 = `${$2cfd35af7ec11fdd$export$abec5a3e0b81aaba}-end-focus-trap`;
const $2cfd35af7ec11fdd$export$977c8163a074ab4c = `${$2cfd35af7ec11fdd$var$NS}-panel-stack2`;
const $2cfd35af7ec11fdd$export$86f0fc908ef772ca = `${$2cfd35af7ec11fdd$export$977c8163a074ab4c}-header`;
const $2cfd35af7ec11fdd$export$dba4a9d0529c5123 = `${$2cfd35af7ec11fdd$export$977c8163a074ab4c}-header-back`;
const $2cfd35af7ec11fdd$export$9ba9ddd2abc1a482 = `${$2cfd35af7ec11fdd$export$977c8163a074ab4c}-view`;
const $2cfd35af7ec11fdd$export$8b7fecf2fba0abf9 = $2cfd35af7ec11fdd$export$977c8163a074ab4c;
const $2cfd35af7ec11fdd$export$f9f46f21fbe4920c = $2cfd35af7ec11fdd$export$86f0fc908ef772ca;
const $2cfd35af7ec11fdd$export$bea2f695ce1f90b1 = $2cfd35af7ec11fdd$export$dba4a9d0529c5123;
const $2cfd35af7ec11fdd$export$e6cf7858677f7d09 = $2cfd35af7ec11fdd$export$9ba9ddd2abc1a482;
const $2cfd35af7ec11fdd$export$dbe3482d899925c4 = `${$2cfd35af7ec11fdd$var$NS}-popover`;
const $2cfd35af7ec11fdd$export$8eaa9259ba89a7e8 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-arrow`;
const $2cfd35af7ec11fdd$export$cd1026626bfe5c07 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-backdrop`;
const $2cfd35af7ec11fdd$export$2cfbe2eb60c57d5b = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-capturing-dismiss`;
const $2cfd35af7ec11fdd$export$1e96671e28a297dd = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-content`;
const $2cfd35af7ec11fdd$export$345b7893b44144f1 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-placement`;
const $2cfd35af7ec11fdd$export$5b0bac172c0cf3a = `${$2cfd35af7ec11fdd$export$1e96671e28a297dd}-sizing`;
const $2cfd35af7ec11fdd$export$7d23743fb33d0182 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-dismiss`;
const $2cfd35af7ec11fdd$export$1f4f24a25ef790c0 = `${$2cfd35af7ec11fdd$export$7d23743fb33d0182}-override`;
const $2cfd35af7ec11fdd$export$4e93ab2f5f3e0b11 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-match-target-width`;
const $2cfd35af7ec11fdd$export$e864f5b391d71738 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-open`;
const $2cfd35af7ec11fdd$export$28f35cf1b92fac04 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-popper-escaped`;
const $2cfd35af7ec11fdd$export$4b518c2bca894b80 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-reference-hidden`;
const $2cfd35af7ec11fdd$export$534b03eda12f917 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-target`;
const $2cfd35af7ec11fdd$export$620767fe6c31e984 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-transition-container`;
const $2cfd35af7ec11fdd$export$9361cd420f832cf2 = `${$2cfd35af7ec11fdd$export$dbe3482d899925c4}-wrapper`;
const $2cfd35af7ec11fdd$export$40c78f7c1065c43c = `${$2cfd35af7ec11fdd$var$NS}-progress-bar`;
const $2cfd35af7ec11fdd$export$19dacc38bfe958b2 = `${$2cfd35af7ec11fdd$var$NS}-progress-meter`;
const $2cfd35af7ec11fdd$export$52fec100aaa98b55 = `${$2cfd35af7ec11fdd$var$NS}-no-stripes`;
const $2cfd35af7ec11fdd$export$890ea6f485d6060f = `${$2cfd35af7ec11fdd$var$NS}-no-animation`;
const $2cfd35af7ec11fdd$export$ac4d91f5203d82ae = `${$2cfd35af7ec11fdd$var$NS}-portal`;
const $2cfd35af7ec11fdd$export$169e587b68892b4e = `${$2cfd35af7ec11fdd$var$NS}-skeleton`;
const $2cfd35af7ec11fdd$export$992366d871da5550 = `${$2cfd35af7ec11fdd$var$NS}-slider`;
const $2cfd35af7ec11fdd$export$229cabfdbcbdfc2d = `${$2cfd35af7ec11fdd$export$992366d871da5550}-axis`;
const $2cfd35af7ec11fdd$export$d5ec8f6bd4e7f30c = `${$2cfd35af7ec11fdd$export$992366d871da5550}-handle`;
const $2cfd35af7ec11fdd$export$c7563cb73c31904 = `${$2cfd35af7ec11fdd$export$992366d871da5550}-label`;
const $2cfd35af7ec11fdd$export$c17129aaccf9f04f = `${$2cfd35af7ec11fdd$export$992366d871da5550}-track`;
const $2cfd35af7ec11fdd$export$cb8b3334a21a52ed = `${$2cfd35af7ec11fdd$export$992366d871da5550}-progress`;
const $2cfd35af7ec11fdd$export$21c466265830bc3a = `${$2cfd35af7ec11fdd$var$NS}-start`;
const $2cfd35af7ec11fdd$export$32239d68d9c6cb49 = `${$2cfd35af7ec11fdd$var$NS}-end`;
const $2cfd35af7ec11fdd$export$6bf3d9c372a8b76a = `${$2cfd35af7ec11fdd$var$NS}-spinner`;
const $2cfd35af7ec11fdd$export$c422a257b54d6303 = `${$2cfd35af7ec11fdd$export$6bf3d9c372a8b76a}-animation`;
const $2cfd35af7ec11fdd$export$67c4dde5cd44a3bf = `${$2cfd35af7ec11fdd$export$6bf3d9c372a8b76a}-head`;
const $2cfd35af7ec11fdd$export$35495e002696aec2 = `${$2cfd35af7ec11fdd$var$NS}-no-spin`;
const $2cfd35af7ec11fdd$export$cf9c7c98d20f3675 = `${$2cfd35af7ec11fdd$export$6bf3d9c372a8b76a}-track`;
const $2cfd35af7ec11fdd$export$a9da50bcccdc2ea1 = `${$2cfd35af7ec11fdd$var$NS}-segmented-control`;
const $2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e = `${$2cfd35af7ec11fdd$var$NS}-tab`;
const $2cfd35af7ec11fdd$export$761ffa813d3bcf7b = `${$2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e}-icon`;
const $2cfd35af7ec11fdd$export$21993928ad2e2f77 = `${$2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e}-tag`;
const $2cfd35af7ec11fdd$export$32364f631fea0fb = `${$2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e}-indicator`;
const $2cfd35af7ec11fdd$export$8da12ef58da8ed12 = `${$2cfd35af7ec11fdd$export$32364f631fea0fb}-wrapper`;
const $2cfd35af7ec11fdd$export$29216fa86fc3af12 = `${$2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e}-list`;
const $2cfd35af7ec11fdd$export$1bc1faf0ee61fa47 = `${$2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e}-panel`;
const $2cfd35af7ec11fdd$export$73b877b58963a4f = `${$2cfd35af7ec11fdd$export$f1c9dd0f5207dd5e}s`;
const $2cfd35af7ec11fdd$export$2680f340d0781853 = `${$2cfd35af7ec11fdd$var$NS}-tag`;
const $2cfd35af7ec11fdd$export$1dace92eb43d2917 = `${$2cfd35af7ec11fdd$export$2680f340d0781853}-remove`;
const $2cfd35af7ec11fdd$export$fe7a531a68939d45 = `${$2cfd35af7ec11fdd$var$NS}-compound-tag`;
const $2cfd35af7ec11fdd$export$936a90ee17829787 = `${$2cfd35af7ec11fdd$export$fe7a531a68939d45}-left`;
const $2cfd35af7ec11fdd$export$23fcc0f95d746a8 = `${$2cfd35af7ec11fdd$export$fe7a531a68939d45}-left-content`;
const $2cfd35af7ec11fdd$export$8b9fa1756fbe1a2c = `${$2cfd35af7ec11fdd$export$fe7a531a68939d45}-right`;
const $2cfd35af7ec11fdd$export$eb7199f9fc66b8f3 = `${$2cfd35af7ec11fdd$export$fe7a531a68939d45}-right-content`;
const $2cfd35af7ec11fdd$export$ffaf3bbf154e07cf = `${$2cfd35af7ec11fdd$var$NS}-tag-input`;
const $2cfd35af7ec11fdd$export$999c53f91b6a7a4a = `${$2cfd35af7ec11fdd$export$ffaf3bbf154e07cf}-icon`;
const $2cfd35af7ec11fdd$export$1711f8b4411c6f5f = `${$2cfd35af7ec11fdd$export$ffaf3bbf154e07cf}-values`;
const $2cfd35af7ec11fdd$export$6d378d1ab7ed5175 = `${$2cfd35af7ec11fdd$var$NS}-toast`;
const $2cfd35af7ec11fdd$export$bda400aeced77722 = `${$2cfd35af7ec11fdd$export$6d378d1ab7ed5175}-container`;
const $2cfd35af7ec11fdd$export$ce2171b20910fc4b = `${$2cfd35af7ec11fdd$export$6d378d1ab7ed5175}-message`;
const $2cfd35af7ec11fdd$export$1517edb21b105800 = `${$2cfd35af7ec11fdd$var$NS}-tooltip`;
const $2cfd35af7ec11fdd$export$db434af9cd0173fa = `${$2cfd35af7ec11fdd$export$1517edb21b105800}-indicator`;
const $2cfd35af7ec11fdd$export$33ecaa422889cd80 = `${$2cfd35af7ec11fdd$var$NS}-tree`;
const $2cfd35af7ec11fdd$export$497d287dd067ff98 = `${$2cfd35af7ec11fdd$var$NS}-tree-node`;
const $2cfd35af7ec11fdd$export$bcef107a0b76070f = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-caret`;
const $2cfd35af7ec11fdd$export$ea4d3d46c22ddfed = `${$2cfd35af7ec11fdd$export$bcef107a0b76070f}-closed`;
const $2cfd35af7ec11fdd$export$94af84e54168f6de = `${$2cfd35af7ec11fdd$export$bcef107a0b76070f}-none`;
const $2cfd35af7ec11fdd$export$e023ef8de1b4549b = `${$2cfd35af7ec11fdd$export$bcef107a0b76070f}-open`;
const $2cfd35af7ec11fdd$export$2f310b4a8c8311c8 = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-content`;
const $2cfd35af7ec11fdd$export$22ed5f498d01ae6c = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-expanded`;
const $2cfd35af7ec11fdd$export$50f70f673012be50 = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-icon`;
const $2cfd35af7ec11fdd$export$9e24c367c0ac6f88 = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-label`;
const $2cfd35af7ec11fdd$export$eb052bba2c207529 = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-list`;
const $2cfd35af7ec11fdd$export$15c472de16dfeefd = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-secondary-label`;
const $2cfd35af7ec11fdd$export$4a8bcbdf26c6e4af = `${$2cfd35af7ec11fdd$export$497d287dd067ff98}-selected`;
const $2cfd35af7ec11fdd$export$b397da2e1679ac19 = `${$2cfd35af7ec11fdd$var$NS}-tree-root`;
const $2cfd35af7ec11fdd$export$d2b60e6b56e900e8 = `${$2cfd35af7ec11fdd$var$NS}-icon`;
const $2cfd35af7ec11fdd$export$9e817070703bebe0 = `${$2cfd35af7ec11fdd$export$d2b60e6b56e900e8}-standard`;
const $2cfd35af7ec11fdd$export$ef62356806fa9c5a = `${$2cfd35af7ec11fdd$export$d2b60e6b56e900e8}-large`;
const $2cfd35af7ec11fdd$export$42eab3af8b7fb664 = `${$2cfd35af7ec11fdd$export$d2b60e6b56e900e8}-muted`;
function $2cfd35af7ec11fdd$export$e018c2ab23bd5a2c() {
    return $2cfd35af7ec11fdd$var$NS;
}
function $2cfd35af7ec11fdd$export$4677781bb583a8b4(alignment) {
    switch(alignment){
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        case (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).LEFT:
        case (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).START:
            return $2cfd35af7ec11fdd$export$7895aadd1956b1c7;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        case (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).RIGHT:
        case (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).END:
            return $2cfd35af7ec11fdd$export$f1299af03a3c605a;
        default:
            return undefined;
    }
}
function $2cfd35af7ec11fdd$export$b7727d57dec24270(elevation) {
    if (elevation === undefined) return undefined;
    return `${$2cfd35af7ec11fdd$var$NS}-elevation-${elevation}`;
}
function $2cfd35af7ec11fdd$export$9a22524e6364be6(iconName) {
    if (iconName == null) return undefined;
    return iconName.indexOf(`${$2cfd35af7ec11fdd$var$NS}-icon-`) === 0 ? iconName : `${$2cfd35af7ec11fdd$var$NS}-icon-${iconName}`;
}
function $2cfd35af7ec11fdd$export$6771d82d925c8189(intent) {
    if (intent == null || intent === (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).NONE) return undefined;
    return `${$2cfd35af7ec11fdd$var$NS}-intent-${intent.toLowerCase()}`;
}
function $2cfd35af7ec11fdd$export$4f8aee4b943e40e(position) {
    if (position === undefined) return undefined;
    return `${$2cfd35af7ec11fdd$var$NS}-position-${position}`;
}
function $2cfd35af7ec11fdd$export$d3aeaee5bf9ec3ef(size, legacyProps) {
    if (size === "small") return $2cfd35af7ec11fdd$export$71dd4c8ecd45e95f;
    if (size === "large") return $2cfd35af7ec11fdd$export$7b93a10c0fefe3e3;
    const { large: large = false, small: small = false } = legacyProps;
    return {
        [$2cfd35af7ec11fdd$export$7b93a10c0fefe3e3]: large,
        [$2cfd35af7ec11fdd$export$71dd4c8ecd45e95f]: small
    };
}
function $2cfd35af7ec11fdd$export$ca9b25d6cdb1dab3(variant, legacyProps) {
    // variant takes precedence over minimal and outlined
    if (variant === "outlined") return $2cfd35af7ec11fdd$export$d31ef73d8bd6b2be;
    if (variant === "minimal") return $2cfd35af7ec11fdd$export$a61ada011bb84f5;
    const { minimal: minimal = false, outlined: outlined = false } = legacyProps;
    return {
        [$2cfd35af7ec11fdd$export$a61ada011bb84f5]: minimal,
        [$2cfd35af7ec11fdd$export$d31ef73d8bd6b2be]: outlined
    };
}


var $ef515bba949c7615$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($ef515bba949c7615$exports) {
        classNames.default = classNames;
        $ef515bba949c7615$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $kYL7Z = parcelRequire("kYL7Z");

/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $5bed6f2a5e88b283$var$ns = "[Blueprint]";
const $5bed6f2a5e88b283$export$4fcb16c0555f6e60 = $5bed6f2a5e88b283$var$ns + ` clamp: max cannot be less than min`;
const $5bed6f2a5e88b283$export$5b85f29a2be29baf = $5bed6f2a5e88b283$var$ns + ` <Alert> cancelButtonText and onCancel should be set together.`;
const $5bed6f2a5e88b283$export$f6e5524776d50d97 = $5bed6f2a5e88b283$var$ns + ` <Alert> canEscapeKeyCancel enabled without onCancel or onClose handler.`;
const $5bed6f2a5e88b283$export$b72cc84fa7249bbc = $5bed6f2a5e88b283$var$ns + ` <Alert> canOutsideClickCancel enabled without onCancel or onClose handler.`;
const $5bed6f2a5e88b283$export$8199ee9314ddbcae = $5bed6f2a5e88b283$var$ns + ` alignIndicator="left" is deprecated. Please use alignIndicator="start" instead.`;
const $5bed6f2a5e88b283$export$eccf1a4fa99b7000 = $5bed6f2a5e88b283$var$ns + ` alignIndicator="right" is deprecated. Please use alignIndicator="end" instead.`;
const $5bed6f2a5e88b283$export$8f999a9838a08e45 = $5bed6f2a5e88b283$var$ns + `alignIndicator="center" is not supported on control components and will be ignored.`;
const $5bed6f2a5e88b283$export$f0828ffa8b68f1a3 = $5bed6f2a5e88b283$var$ns + ` alignText="left" is deprecated. Please use alignText="start" instead.`;
const $5bed6f2a5e88b283$export$3ce66916c24b80d9 = $5bed6f2a5e88b283$var$ns + ` alignText="right" is deprecated. Please use alignText="end" instead.`;
const $5bed6f2a5e88b283$export$f884ac63592942b4 = $5bed6f2a5e88b283$var$ns + ` <Button> minimal is deprecated. Please use variant="minimal".`;
const $5bed6f2a5e88b283$export$73ca735f50558bbc = $5bed6f2a5e88b283$var$ns + ` <ButtonGroup> minimal is deprecated. Please use variant="minimal".`;
const $5bed6f2a5e88b283$export$fddcf522a4ed2084 = $5bed6f2a5e88b283$var$ns + ` <Button> outlined is deprecated. Please use variant="outlined".`;
const $5bed6f2a5e88b283$export$d8a6e1fa5571596 = $5bed6f2a5e88b283$var$ns + ` <ButtonGroup> outlined is deprecated. Please use variant="outlined".`;
const $5bed6f2a5e88b283$export$a966041437837cbb = $5bed6f2a5e88b283$var$ns + ` <Hotkeys> only accepts <Hotkey> children.`;
const $5bed6f2a5e88b283$export$670242ac4c5d7db8 = $5bed6f2a5e88b283$var$ns + ` useHotkeys() was used outside of a <HotkeysProvider> context. These hotkeys will not be shown in the hotkeys help dialog.`;
const $5bed6f2a5e88b283$export$9dbacdb91396601 = $5bed6f2a5e88b283$var$ns + ` <HotkeysTarget> was configured with local hotkeys, but you did not use the generated event handlers to bind their event handlers. Try using a render function as the child of this component.`;
const $5bed6f2a5e88b283$export$7dcc26c4d745a6de = $5bed6f2a5e88b283$var$ns + ` <InputGroup> leftElement and leftIcon prop are mutually exclusive, with leftElement taking priority.`;
const $5bed6f2a5e88b283$export$c616346f9f6261 = $5bed6f2a5e88b283$var$ns + ` <NavbarGroup> does not support align="center". Only "left" or "right" alignment is allowed, and align="center" will be ignored.`;
const $5bed6f2a5e88b283$export$5813ec87ec3acb90 = $5bed6f2a5e88b283$var$ns + ` <NumericInput> requires min to be no greater than max if both are defined.`;
const $5bed6f2a5e88b283$export$560b8988862ea429 = $5bed6f2a5e88b283$var$ns + ` <NumericInput> requires minorStepSize to be no greater than stepSize.`;
const $5bed6f2a5e88b283$export$6e5c02badc46235e = $5bed6f2a5e88b283$var$ns + ` <NumericInput> requires stepSize to be no greater than majorStepSize.`;
const $5bed6f2a5e88b283$export$bfff41693cbc35d4 = $5bed6f2a5e88b283$var$ns + ` <NumericInput> requires minorStepSize to be strictly greater than zero.`;
const $5bed6f2a5e88b283$export$659f97d5057a476 = $5bed6f2a5e88b283$var$ns + ` <NumericInput> requires majorStepSize to be strictly greater than zero.`;
const $5bed6f2a5e88b283$export$cf406687fba595e5 = $5bed6f2a5e88b283$var$ns + ` <NumericInput> requires stepSize to be strictly greater than zero.`;
const $5bed6f2a5e88b283$export$b9f78c93f51845b9 = $5bed6f2a5e88b283$var$ns + ` <NumericInput> controlled value prop does not adhere to stepSize, min, and/or max constraints.`;
const $5bed6f2a5e88b283$export$19bc0ed8b2e0d575 = $5bed6f2a5e88b283$var$ns + ` <OverflowList> does not support changing observeParents after mounting.`;
const $5bed6f2a5e88b283$export$3cf04cff067b1497 = `${$5bed6f2a5e88b283$var$ns} <Popover> requires renderTarget prop or a child element.`;
const $5bed6f2a5e88b283$export$deb4db7b191454de = `${$5bed6f2a5e88b283$var$ns} <Popover hasBackdrop={true}> requires interactionKind="click".`;
const $5bed6f2a5e88b283$export$d26b2b7b10deb660 = `${$5bed6f2a5e88b283$var$ns} <Popover> supports only one child which is rendered as its target; additional children are ignored.`;
const $5bed6f2a5e88b283$export$92bbc536d12dd3d6 = $5bed6f2a5e88b283$var$ns + ` <Popover> with children ignores renderTarget prop; use either prop or children.`;
const $5bed6f2a5e88b283$export$fb9dc24caac9c30e = $5bed6f2a5e88b283$var$ns + ` Disabling <Popover> with empty/whitespace content...`;
const $5bed6f2a5e88b283$export$d2c026502cfc32e6 = $5bed6f2a5e88b283$var$ns + ` <Popover usePortal={false}> ignores hasBackdrop`;
const $5bed6f2a5e88b283$export$bd8a2148d985bb65 = $5bed6f2a5e88b283$var$ns + ` <Popover> supports either placement or position prop, not both.`;
const $5bed6f2a5e88b283$export$cdb7203a6f2d3ac9 = $5bed6f2a5e88b283$var$ns + ` <Popover> onInteraction is ignored when uncontrolled.`;
const $5bed6f2a5e88b283$export$958f5bcc111a3890 = $5bed6f2a5e88b283$var$ns + ` <Popover> targetProps value is ignored when renderTarget API is used.`;
const $5bed6f2a5e88b283$export$85aa0d720577b224 = $5bed6f2a5e88b283$var$ns + ` <RadioGroup> children and options prop are mutually exclusive, with options taking priority.`;
const $5bed6f2a5e88b283$export$3f628d74aa22ee14 = $5bed6f2a5e88b283$var$ns + ` <Slider> stepSize must be greater than zero.`;
const $5bed6f2a5e88b283$export$e1e1f71b44b50957 = $5bed6f2a5e88b283$var$ns + ` <Slider> labelStepSize must be greater than zero.`;
const $5bed6f2a5e88b283$export$bd089811e8f6237d = $5bed6f2a5e88b283$var$ns + ` <Slider> min prop must be a finite number.`;
const $5bed6f2a5e88b283$export$34f34bdfff94a103 = $5bed6f2a5e88b283$var$ns + ` <Slider> max prop must be a finite number.`;
const $5bed6f2a5e88b283$export$8cdad9f5b77513a2 = $5bed6f2a5e88b283$var$ns + ` <RangeSlider> value prop must be an array of two non-null numbers.`;
const $5bed6f2a5e88b283$export$5c23f31d1ea14389 = $5bed6f2a5e88b283$var$ns + ` <MultiSlider> children must be <SliderHandle>s or <SliderTrackStop>s`;
const $5bed6f2a5e88b283$export$be7e9beb3b581c37 = $5bed6f2a5e88b283$var$ns + ` <MultiSlider> labelStepSize and labelValues prop are mutually exclusive, with labelStepSize taking priority.`;
const $5bed6f2a5e88b283$export$612c20961251008f = $5bed6f2a5e88b283$var$ns + ` <Spinner> Classes.SMALL/LARGE are ignored if size prop is set.`;
const $5bed6f2a5e88b283$export$fdceab30a81a80e3 = $5bed6f2a5e88b283$var$ns + ` OverlayToaster.create() is not supported inside React lifecycle methods in React 16.` + ` See usage example on the docs site. https://blueprintjs.com/docs/#core/components/toast.example`;
const $5bed6f2a5e88b283$export$2451692ca60e5d58 = $5bed6f2a5e88b283$var$ns + ` <OverlayToaster> maxToasts is set to an invalid number, must be greater than 0`;
const $5bed6f2a5e88b283$export$18ab8fe30147e847 = $5bed6f2a5e88b283$var$ns + ` OverlayToaster.create() ignores inline prop as it always creates a new element.`;
const $5bed6f2a5e88b283$export$2c7c4d8c17b24fc3 = $5bed6f2a5e88b283$var$ns + ` <Dialog> iconName is ignored if title is omitted.`;
const $5bed6f2a5e88b283$export$b1ffdd5a20552cca = $5bed6f2a5e88b283$var$ns + ` <Dialog> isCloseButtonShown prop is ignored if title is omitted.`;
const $5bed6f2a5e88b283$export$ee41c46c4147fad0 = $5bed6f2a5e88b283$var$ns + ` <Drawer> all angle positions are casted into pure position (TOP, BOTTOM, LEFT or RIGHT)`;
const $5bed6f2a5e88b283$export$ec9bf1f3f03eed46 = $5bed6f2a5e88b283$var$ns + ` <Overlay2> was used outside of a <OverlaysProvider> context. This will no longer be supported in ` + `Blueprint v6. See https://github.com/palantir/blueprint/wiki/Overlay2-migration`;
const $5bed6f2a5e88b283$export$9a7688a076ebfc22 = $5bed6f2a5e88b283$var$ns + ` <Overlay2> cannot use childRef and childRefs props simultaneously`;
const $5bed6f2a5e88b283$export$d1780dd5da45c8d8 = $5bed6f2a5e88b283$var$ns + ` <Overlay2> requires childRefs prop when rendering multiple child elements`;
const $5bed6f2a5e88b283$export$5c53f620d79bf998 = $5bed6f2a5e88b283$var$ns + ` <Overlay2> requires each child element to have a unique key prop when childRefs is used`;
function $5bed6f2a5e88b283$export$55997053782da70a(component, props) {
    const { large: large, small: small } = props;
    if (large && small) console.warn($5bed6f2a5e88b283$var$ns + ` <${component}> large and small props are mutually exclusive. Please use size="large" or size="small" instead.`);
    else if (large) console.warn($5bed6f2a5e88b283$var$ns + ` <${component}> large is deprecated. Please use size="large" instead.`);
    else if (small) console.warn($5bed6f2a5e88b283$var$ns + ` <${component}> small is deprecated. Please use size="small" instead.`);
}


/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b898cefa02f59fb9$export$64b684a1d3f6f6a6 = "Blueprint6";
/** A collection of curated prop keys used across our Components which are not valid HTMLElement props. */ const $b898cefa02f59fb9$var$INVALID_PROPS = [
    "active",
    "alignText",
    "asyncControl",
    "containerRef",
    "current",
    "elementRef",
    "ellipsizeText",
    "endIcon",
    "fill",
    "icon",
    "iconSize",
    "inputClassName",
    "inputRef",
    "intent",
    "inline",
    "large",
    "loading",
    "leftElement",
    "leftIcon",
    "minimal",
    "onRemove",
    "outlined",
    "panel",
    "panelClassName",
    "popoverProps",
    "rightElement",
    "rightIcon",
    "round",
    "selectedValue",
    "size",
    "small",
    "tagName",
    "text",
    "textClassName",
    "variant"
];
function $b898cefa02f59fb9$export$962dd23b3e663274(props, invalidProps = $b898cefa02f59fb9$var$INVALID_PROPS, shouldMerge = false) {
    if (shouldMerge) invalidProps = invalidProps.concat($b898cefa02f59fb9$var$INVALID_PROPS);
    return invalidProps.reduce((prev, curr)=>{
        // Props with hyphens (e.g. data-*) are always considered html props
        if (curr.indexOf("-") !== -1) return prev;
        if (prev.hasOwnProperty(curr)) delete prev[curr];
        return prev;
    }, {
        ...props
    });
}


var $f141b3b4d406798c$exports = {};

$parcel$export($f141b3b4d406798c$exports, "isNodeEnv", () => $f141b3b4d406798c$export$ba99498080d0627b);
$parcel$export($f141b3b4d406798c$exports, "arrayLengthCompare", () => $f141b3b4d406798c$export$a508c2eeffcdc594);
$parcel$export($f141b3b4d406798c$exports, "approxEqual", () => $f141b3b4d406798c$export$8a4f1dcc58a69dbd);
$parcel$export($f141b3b4d406798c$exports, "clamp", () => $f141b3b4d406798c$export$7d15b64cf5a3a4c4);
$parcel$export($f141b3b4d406798c$exports, "countDecimalPlaces", () => $f141b3b4d406798c$export$a42544f265f8403);
$parcel$export($f141b3b4d406798c$exports, "uniqueId", () => $f141b3b4d406798c$export$8b15d37bc3f197d4);
$parcel$export($f141b3b4d406798c$exports, "isEmptyString", () => $f141b3b4d406798c$export$78d1711480f95c3e);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $f141b3b4d406798c$export$ba99498080d0627b(env) {
    return typeof NODE_ENV !== "undefined" && NODE_ENV === env;
}
function $f141b3b4d406798c$export$a508c2eeffcdc594(a = [], b = []) {
    return a.length - b.length;
}
function $f141b3b4d406798c$export$8a4f1dcc58a69dbd(a, b, tolerance = 0.00001) {
    return Math.abs(a - b) <= tolerance;
}
function $f141b3b4d406798c$export$7d15b64cf5a3a4c4(val, min, max) {
    if (val == null) return val;
    if (max < min) throw new Error((0, $5bed6f2a5e88b283$export$4fcb16c0555f6e60));
    return Math.min(Math.max(val, min), max);
}
function $f141b3b4d406798c$export$a42544f265f8403(num) {
    if (!isFinite(num)) return 0;
    let e = 1;
    let p = 0;
    while(Math.round(num * e) / e !== num){
        e *= 10;
        p++;
    }
    return p;
}
const $f141b3b4d406798c$var$uniqueCountForNamespace = new Map();
function $f141b3b4d406798c$export$8b15d37bc3f197d4(namespace) {
    const curCount = $f141b3b4d406798c$var$uniqueCountForNamespace.get(namespace) ?? 0;
    $f141b3b4d406798c$var$uniqueCountForNamespace.set(namespace, curCount + 1);
    return `${namespace}-${curCount}`;
}
function $f141b3b4d406798c$export$78d1711480f95c3e(val) {
    return typeof val === "string" && val.trim().length === 0;
}


/* !
 * (c) Copyright 2025 Palantir Technologies Inc. All rights reserved.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

function $782dccc2198ae4be$export$fa00fc37980674c4(validator, dependencies = []) {
    (0, $kYL7Z.useEffect)(()=>{
        if (!(0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) validator();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencies);
}


var $425946125bdc4b8f$export$11e6017846e949;
(function(SpinnerSize) {
    SpinnerSize[SpinnerSize["SMALL"] = 20] = "SMALL";
    SpinnerSize[SpinnerSize["STANDARD"] = 50] = "STANDARD";
    SpinnerSize[SpinnerSize["LARGE"] = 100] = "LARGE";
})($425946125bdc4b8f$export$11e6017846e949 || ($425946125bdc4b8f$export$11e6017846e949 = {}));
// see http://stackoverflow.com/a/18473154/3124288 for calculating arc path
const $425946125bdc4b8f$var$R = 45;
const $425946125bdc4b8f$var$SPINNER_TRACK = `M 50,50 m 0,-${$425946125bdc4b8f$var$R} a ${$425946125bdc4b8f$var$R},${$425946125bdc4b8f$var$R} 0 1 1 0,${$425946125bdc4b8f$var$R * 2} a ${$425946125bdc4b8f$var$R},${$425946125bdc4b8f$var$R} 0 1 1 0,-${$425946125bdc4b8f$var$R * 2}`;
// unitless total length of SVG path, to which stroke-dash* properties are relative.
// https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/pathLength
// this value is the result of `<path d={SPINNER_TRACK} />.getTotalLength()` and works in all browsers:
const $425946125bdc4b8f$var$PATH_LENGTH = 280;
const $425946125bdc4b8f$var$MIN_SIZE = 10;
const $425946125bdc4b8f$var$STROKE_WIDTH = 4;
const $425946125bdc4b8f$var$MIN_STROKE_WIDTH = 16;
const $425946125bdc4b8f$export$7f7cbe89f1eacd2 = (props)=>{
    const { className: className = "", intent: intent, value: value, tagName: tagName = "div", size: size, ...htmlProps } = props;
    (0, $782dccc2198ae4be$export$fa00fc37980674c4)(()=>{
        const isSizePropSet = size != null;
        const isSizeClassSet = className.indexOf((0, $2cfd35af7ec11fdd$exports).SMALL) >= 0 || className.indexOf((0, $2cfd35af7ec11fdd$exports).LARGE) >= 0;
        if (isSizePropSet && isSizeClassSet) console.warn((0, $5bed6f2a5e88b283$export$612c20961251008f));
    }, [
        className,
        size
    ]);
    const sizePx = $425946125bdc4b8f$var$getSize(size, className);
    // keep spinner track width consistent at all sizes (down to about 10px).
    const strokeWidth = Math.min($425946125bdc4b8f$var$MIN_STROKE_WIDTH, $425946125bdc4b8f$var$STROKE_WIDTH * $425946125bdc4b8f$export$11e6017846e949.LARGE / sizePx);
    const strokeOffset = $425946125bdc4b8f$var$PATH_LENGTH - $425946125bdc4b8f$var$PATH_LENGTH * (value == null ? 0.25 : (0, $f141b3b4d406798c$export$7d15b64cf5a3a4c4)(value, 0, 1));
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).SPINNER, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), {
        [(0, $2cfd35af7ec11fdd$exports).SPINNER_NO_SPIN]: value != null
    }, className);
    // multiple DOM elements around SVG are necessary to properly isolate animation:
    // - SVG elements in IE do not support anim/trans so they must be set on a parent HTML element.
    // - SPINNER_ANIMATION isolates svg from parent display and is always centered inside root element.
    return (0, $kYL7Z.createElement)(tagName, {
        "aria-label": "loading",
        "aria-valuemax": 100,
        "aria-valuemin": 0,
        "aria-valuenow": value === undefined ? undefined : value * 100,
        className: classes,
        role: "progressbar",
        ...htmlProps
    }, (0, $kYL7Z.createElement)(tagName, {
        className: (0, $2cfd35af7ec11fdd$exports).SPINNER_ANIMATION
    }, (0, $fc31e5e9fc16a880$exports.jsxs)("svg", {
        width: sizePx,
        height: sizePx,
        strokeWidth: strokeWidth.toFixed(2),
        viewBox: $425946125bdc4b8f$var$getViewBox(strokeWidth),
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)("path", {
                className: (0, $2cfd35af7ec11fdd$exports).SPINNER_TRACK,
                d: $425946125bdc4b8f$var$SPINNER_TRACK
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)("path", {
                className: (0, $2cfd35af7ec11fdd$exports).SPINNER_HEAD,
                d: $425946125bdc4b8f$var$SPINNER_TRACK,
                pathLength: $425946125bdc4b8f$var$PATH_LENGTH,
                strokeDasharray: `${$425946125bdc4b8f$var$PATH_LENGTH} ${$425946125bdc4b8f$var$PATH_LENGTH}`,
                strokeDashoffset: strokeOffset
            })
        ]
    })));
};
$425946125bdc4b8f$export$7f7cbe89f1eacd2.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Spinner`;
/**
 * Resolve size to a pixel value.
 * Size can be set by className, props, default, or minimum constant.
 */ const $425946125bdc4b8f$var$getSize = (size, className)=>{
    if (size == null) {
        if (className.indexOf((0, $2cfd35af7ec11fdd$exports).SMALL) >= 0) return $425946125bdc4b8f$export$11e6017846e949.SMALL;
        else if (className.indexOf((0, $2cfd35af7ec11fdd$exports).LARGE) >= 0) return $425946125bdc4b8f$export$11e6017846e949.LARGE;
        return $425946125bdc4b8f$export$11e6017846e949.STANDARD;
    }
    return Math.max($425946125bdc4b8f$var$MIN_SIZE, size);
};
/** Compute viewbox such that stroked track sits exactly at edge of image frame. */ const $425946125bdc4b8f$var$getViewBox = (strokeWidth)=>{
    const radius = $425946125bdc4b8f$var$R + strokeWidth / 2;
    const viewBoxX = (50 - radius).toFixed(2);
    const viewBoxWidth = (radius * 2).toFixed(2);
    return `${viewBoxX} ${viewBoxX} ${viewBoxWidth} ${viewBoxWidth}`;
};


//Colors
const $2df8c38f80e77278$export$f1fbbe1776f7d7f = '#eff3f6';
const $2df8c38f80e77278$export$6472a8108632870e = '#CFD5D9';
const $2df8c38f80e77278$export$87c69c0dc894f992 = '#C31919';
const $2df8c38f80e77278$export$7a91b0fde7ec420f = 'rgb(0,0,0)';
const $2df8c38f80e77278$export$29814851e0aa981f = 'rgb(255,255,255)';
const $2df8c38f80e77278$export$aa201224bb439d47 = 'rgb(255,0,0)';
const $2df8c38f80e77278$export$738c3b9a44c87ecc = 'rgb(0,0,255)';
const $2df8c38f80e77278$export$48d4b2cd5bc0e88b = 'rgb(0,255,0)';
const $2df8c38f80e77278$export$aab610c505c06a8f = 'rgb(255,255,0)';
const $2df8c38f80e77278$export$c7e0129e68c19529 = 'rgba(255,0,0,0.1)';
const $2df8c38f80e77278$export$13891f961d0b567c = 'rgba(0,0,255,0.1)';
const $2df8c38f80e77278$export$c6a5ece72fb4d6b3 = 'rgba(0,255,0,0.1)';
const $2df8c38f80e77278$export$620f6a9fc4bba701 = 'rgba(255,255,0,0.1)';


function $414e231c569bbbbf$var$e(e, t) {
    var n = {};
    for(var o in e)Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (n[o] = e[o]);
    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
        var r = 0;
        for(o = Object.getOwnPropertySymbols(e); r < o.length; r++)t.indexOf(o[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[r]) && (n[o[r]] = e[o[r]]);
    }
    return n;
}
"function" == typeof SuppressedError && SuppressedError;
var $414e231c569bbbbf$var$t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : {}, $414e231c569bbbbf$var$n = {}, $414e231c569bbbbf$var$o = {};
Object.defineProperty($414e231c569bbbbf$var$o, "__esModule", {
    value: !0
});
var $414e231c569bbbbf$var$r = function() {
    function e() {
        var e = this;
        this.locked = new Map, this.addToLocked = function(t, n) {
            var o = e.locked.get(t);
            void 0 === o ? void 0 === n ? e.locked.set(t, []) : e.locked.set(t, [
                n
            ]) : void 0 !== n && (o.unshift(n), e.locked.set(t, o));
        }, this.isLocked = function(t) {
            return e.locked.has(t);
        }, this.lock = function(t) {
            return new Promise(function(n, o) {
                e.isLocked(t) ? e.addToLocked(t, n) : (e.addToLocked(t), n());
            });
        }, this.unlock = function(t) {
            var n = e.locked.get(t);
            if (void 0 !== n && 0 !== n.length) {
                var o = n.pop();
                e.locked.set(t, n), void 0 !== o && setTimeout(o, 0);
            } else e.locked.delete(t);
        };
    }
    return e.getInstance = function() {
        return void 0 === e.instance && (e.instance = new e), e.instance;
    }, e;
}();
$414e231c569bbbbf$var$o.default = function() {
    return $414e231c569bbbbf$var$r.getInstance();
};
var $414e231c569bbbbf$var$i = $414e231c569bbbbf$var$t && $414e231c569bbbbf$var$t.__awaiter || function(e, t, n, o) {
    return new (n || (n = Promise))(function(r, i) {
        function a(e) {
            try {
                c(o.next(e));
            } catch (e) {
                i(e);
            }
        }
        function s(e) {
            try {
                c(o.throw(e));
            } catch (e) {
                i(e);
            }
        }
        function c(e) {
            e.done ? r(e.value) : new n(function(t) {
                t(e.value);
            }).then(a, s);
        }
        c((o = o.apply(e, t || [])).next());
    });
}, $414e231c569bbbbf$var$a = $414e231c569bbbbf$var$t && $414e231c569bbbbf$var$t.__generator || function(e, t) {
    var n, o, r, i, a = {
        label: 0,
        sent: function() {
            if (1 & r[0]) throw r[1];
            return r[1];
        },
        trys: [],
        ops: []
    };
    return i = {
        next: s(0),
        throw: s(1),
        return: s(2)
    }, "function" == typeof Symbol && (i[Symbol.iterator] = function() {
        return this;
    }), i;
    function s(i) {
        return function(s) {
            return function(i) {
                if (n) throw new TypeError("Generator is already executing.");
                for(; a;)try {
                    if (n = 1, o && (r = 2 & i[0] ? o.return : i[0] ? o.throw || ((r = o.return) && r.call(o), 0) : o.next) && !(r = r.call(o, i[1])).done) return r;
                    switch(o = 0, r && (i = [
                        2 & i[0],
                        r.value
                    ]), i[0]){
                        case 0:
                        case 1:
                            r = i;
                            break;
                        case 4:
                            return a.label++, {
                                value: i[1],
                                done: !1
                            };
                        case 5:
                            a.label++, o = i[1], i = [
                                0
                            ];
                            continue;
                        case 7:
                            i = a.ops.pop(), a.trys.pop();
                            continue;
                        default:
                            if (!(r = a.trys, (r = r.length > 0 && r[r.length - 1]) || 6 !== i[0] && 2 !== i[0])) {
                                a = 0;
                                continue;
                            }
                            if (3 === i[0] && (!r || i[1] > r[0] && i[1] < r[3])) {
                                a.label = i[1];
                                break;
                            }
                            if (6 === i[0] && a.label < r[1]) {
                                a.label = r[1], r = i;
                                break;
                            }
                            if (r && a.label < r[2]) {
                                a.label = r[2], a.ops.push(i);
                                break;
                            }
                            r[2] && a.ops.pop(), a.trys.pop();
                            continue;
                    }
                    i = t.call(e, a);
                } catch (e) {
                    i = [
                        6,
                        e
                    ], o = 0;
                } finally{
                    n = r = 0;
                }
                if (5 & i[0]) throw i[1];
                return {
                    value: i[0] ? i[1] : void 0,
                    done: !0
                };
            }([
                i,
                s
            ]);
        };
    }
}, $414e231c569bbbbf$var$s = $414e231c569bbbbf$var$t;
Object.defineProperty($414e231c569bbbbf$var$n, "__esModule", {
    value: !0
});
var $414e231c569bbbbf$var$c = $414e231c569bbbbf$var$o, $414e231c569bbbbf$var$u = {
    key: function(e) {
        return $414e231c569bbbbf$var$i($414e231c569bbbbf$var$s, void 0, void 0, function() {
            return $414e231c569bbbbf$var$a(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    getItem: function(e) {
        return $414e231c569bbbbf$var$i($414e231c569bbbbf$var$s, void 0, void 0, function() {
            return $414e231c569bbbbf$var$a(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    clear: function() {
        return $414e231c569bbbbf$var$i($414e231c569bbbbf$var$s, void 0, void 0, function() {
            return $414e231c569bbbbf$var$a(this, function(e) {
                return [
                    2,
                    window.localStorage.clear()
                ];
            });
        });
    },
    removeItem: function(e) {
        return $414e231c569bbbbf$var$i($414e231c569bbbbf$var$s, void 0, void 0, function() {
            return $414e231c569bbbbf$var$a(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    setItem: function(e, t) {
        return $414e231c569bbbbf$var$i($414e231c569bbbbf$var$s, void 0, void 0, function() {
            return $414e231c569bbbbf$var$a(this, function(e) {
                throw new Error("Unsupported");
            });
        });
    },
    keySync: function(e) {
        return window.localStorage.key(e);
    },
    getItemSync: function(e) {
        return window.localStorage.getItem(e);
    },
    clearSync: function() {
        return window.localStorage.clear();
    },
    removeItemSync: function(e) {
        return window.localStorage.removeItem(e);
    },
    setItemSync: function(e, t) {
        return window.localStorage.setItem(e, t);
    }
};
function $414e231c569bbbbf$var$l(e) {
    return new Promise(function(t) {
        return setTimeout(t, e);
    });
}
function $414e231c569bbbbf$var$d(e) {
    for(var t = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", n = "", o = 0; o < e; o++)n += t[Math.floor(Math.random() * t.length)];
    return n;
}
var $414e231c569bbbbf$var$h = function() {
    function e(t) {
        this.acquiredIatSet = new Set, this.storageHandler = void 0, this.id = Date.now().toString() + $414e231c569bbbbf$var$d(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), this.storageHandler = t, void 0 === e.waiters && (e.waiters = []);
    }
    return e.prototype.acquireLock = function(t, n) {
        return void 0 === n && (n = 5e3), $414e231c569bbbbf$var$i(this, void 0, void 0, function() {
            var o, r, i, s, c, h, p;
            return $414e231c569bbbbf$var$a(this, function(a) {
                switch(a.label){
                    case 0:
                        o = Date.now() + $414e231c569bbbbf$var$d(4), r = Date.now() + n, i = "browser-tabs-lock-key-" + t, s = void 0 === this.storageHandler ? $414e231c569bbbbf$var$u : this.storageHandler, a.label = 1;
                    case 1:
                        return Date.now() < r ? [
                            4,
                            $414e231c569bbbbf$var$l(30)
                        ] : [
                            3,
                            8
                        ];
                    case 2:
                        return a.sent(), null !== s.getItemSync(i) ? [
                            3,
                            5
                        ] : (c = this.id + "-" + t + "-" + o, [
                            4,
                            $414e231c569bbbbf$var$l(Math.floor(25 * Math.random()))
                        ]);
                    case 3:
                        return a.sent(), s.setItemSync(i, JSON.stringify({
                            id: this.id,
                            iat: o,
                            timeoutKey: c,
                            timeAcquired: Date.now(),
                            timeRefreshed: Date.now()
                        })), [
                            4,
                            $414e231c569bbbbf$var$l(30)
                        ];
                    case 4:
                        return a.sent(), null !== (h = s.getItemSync(i)) && (p = JSON.parse(h)).id === this.id && p.iat === o ? (this.acquiredIatSet.add(o), this.refreshLockWhileAcquired(i, o), [
                            2,
                            !0
                        ]) : [
                            3,
                            7
                        ];
                    case 5:
                        return e.lockCorrector(void 0 === this.storageHandler ? $414e231c569bbbbf$var$u : this.storageHandler), [
                            4,
                            this.waitForSomethingToChange(r)
                        ];
                    case 6:
                        a.sent(), a.label = 7;
                    case 7:
                        return o = Date.now() + $414e231c569bbbbf$var$d(4), [
                            3,
                            1
                        ];
                    case 8:
                        return [
                            2,
                            !1
                        ];
                }
            });
        });
    }, e.prototype.refreshLockWhileAcquired = function(e, t) {
        return $414e231c569bbbbf$var$i(this, void 0, void 0, function() {
            var n = this;
            return $414e231c569bbbbf$var$a(this, function(o) {
                return setTimeout(function() {
                    return $414e231c569bbbbf$var$i(n, void 0, void 0, function() {
                        var n, o, r;
                        return $414e231c569bbbbf$var$a(this, function(i) {
                            switch(i.label){
                                case 0:
                                    return [
                                        4,
                                        $414e231c569bbbbf$var$c.default().lock(t)
                                    ];
                                case 1:
                                    return i.sent(), this.acquiredIatSet.has(t) ? (n = void 0 === this.storageHandler ? $414e231c569bbbbf$var$u : this.storageHandler, null === (o = n.getItemSync(e)) ? ($414e231c569bbbbf$var$c.default().unlock(t), [
                                        2
                                    ]) : ((r = JSON.parse(o)).timeRefreshed = Date.now(), n.setItemSync(e, JSON.stringify(r)), $414e231c569bbbbf$var$c.default().unlock(t), this.refreshLockWhileAcquired(e, t), [
                                        2
                                    ])) : ($414e231c569bbbbf$var$c.default().unlock(t), [
                                        2
                                    ]);
                            }
                        });
                    });
                }, 1e3), [
                    2
                ];
            });
        });
    }, e.prototype.waitForSomethingToChange = function(t) {
        return $414e231c569bbbbf$var$i(this, void 0, void 0, function() {
            return $414e231c569bbbbf$var$a(this, function(n) {
                switch(n.label){
                    case 0:
                        return [
                            4,
                            new Promise(function(n) {
                                var o = !1, r = Date.now(), i = !1;
                                function a() {
                                    if (i || (window.removeEventListener("storage", a), e.removeFromWaiting(a), clearTimeout(s), i = !0), !o) {
                                        o = !0;
                                        var t = 50 - (Date.now() - r);
                                        t > 0 ? setTimeout(n, t) : n(null);
                                    }
                                }
                                window.addEventListener("storage", a), e.addToWaiting(a);
                                var s = setTimeout(a, Math.max(0, t - Date.now()));
                            })
                        ];
                    case 1:
                        return n.sent(), [
                            2
                        ];
                }
            });
        });
    }, e.addToWaiting = function(t) {
        this.removeFromWaiting(t), void 0 !== e.waiters && e.waiters.push(t);
    }, e.removeFromWaiting = function(t) {
        void 0 !== e.waiters && (e.waiters = e.waiters.filter(function(e) {
            return e !== t;
        }));
    }, e.notifyWaiters = function() {
        void 0 !== e.waiters && e.waiters.slice().forEach(function(e) {
            return e();
        });
    }, e.prototype.releaseLock = function(e) {
        return $414e231c569bbbbf$var$i(this, void 0, void 0, function() {
            return $414e231c569bbbbf$var$a(this, function(t) {
                switch(t.label){
                    case 0:
                        return [
                            4,
                            this.releaseLock__private__(e)
                        ];
                    case 1:
                        return [
                            2,
                            t.sent()
                        ];
                }
            });
        });
    }, e.prototype.releaseLock__private__ = function(t) {
        return $414e231c569bbbbf$var$i(this, void 0, void 0, function() {
            var n, o, r, i;
            return $414e231c569bbbbf$var$a(this, function(a) {
                switch(a.label){
                    case 0:
                        return n = void 0 === this.storageHandler ? $414e231c569bbbbf$var$u : this.storageHandler, o = "browser-tabs-lock-key-" + t, null === (r = n.getItemSync(o)) ? [
                            2
                        ] : (i = JSON.parse(r)).id !== this.id ? [
                            3,
                            2
                        ] : [
                            4,
                            $414e231c569bbbbf$var$c.default().lock(i.iat)
                        ];
                    case 1:
                        a.sent(), this.acquiredIatSet.delete(i.iat), n.removeItemSync(o), $414e231c569bbbbf$var$c.default().unlock(i.iat), e.notifyWaiters(), a.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
    }, e.lockCorrector = function(t) {
        for(var n = Date.now() - 5e3, o = t, r = [], i = 0;;){
            var a = o.keySync(i);
            if (null === a) break;
            r.push(a), i++;
        }
        for(var s = !1, c = 0; c < r.length; c++){
            var u = r[c];
            if (u.includes("browser-tabs-lock-key")) {
                var l = o.getItemSync(u);
                if (null !== l) {
                    var d = JSON.parse(l);
                    (void 0 === d.timeRefreshed && d.timeAcquired < n || void 0 !== d.timeRefreshed && d.timeRefreshed < n) && (o.removeItemSync(u), s = !0);
                }
            }
        }
        s && e.notifyWaiters();
    }, e.waiters = void 0, e;
}(), $414e231c569bbbbf$var$p = $414e231c569bbbbf$var$n.default = $414e231c569bbbbf$var$h;
const $414e231c569bbbbf$var$f = {
    timeoutInSeconds: 60
}, $414e231c569bbbbf$var$m = {
    name: "auth0-spa-js",
    version: "2.14.0"
}, $414e231c569bbbbf$var$y = ()=>Date.now();
class $414e231c569bbbbf$export$7d465be8efa67280 extends Error {
    constructor(e, t){
        super(t), this.error = e, this.error_description = t, Object.setPrototypeOf(this, $414e231c569bbbbf$export$7d465be8efa67280.prototype);
    }
    static fromPayload(e) {
        let { error: t, error_description: n } = e;
        return new $414e231c569bbbbf$export$7d465be8efa67280(t, n);
    }
}
class $414e231c569bbbbf$export$cf0c46b07324e9c5 extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e, t, n){
        let o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
        super(e, t), this.state = n, this.appState = o, Object.setPrototypeOf(this, $414e231c569bbbbf$export$cf0c46b07324e9c5.prototype);
    }
}
class $414e231c569bbbbf$export$aaa3fc6bdea78d4d extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e, t, n, o){
        let r = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
        super(e, t), this.connection = n, this.state = o, this.appState = r, Object.setPrototypeOf(this, $414e231c569bbbbf$export$aaa3fc6bdea78d4d.prototype);
    }
}
class $414e231c569bbbbf$export$66d311bf29d5c89c extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(){
        super("timeout", "Timeout"), Object.setPrototypeOf(this, $414e231c569bbbbf$export$66d311bf29d5c89c.prototype);
    }
}
class $414e231c569bbbbf$export$ebbb83fe03f719a4 extends $414e231c569bbbbf$export$66d311bf29d5c89c {
    constructor(e){
        super(), this.popup = e, Object.setPrototypeOf(this, $414e231c569bbbbf$export$ebbb83fe03f719a4.prototype);
    }
}
class $414e231c569bbbbf$export$f1f681f0fb26bb55 extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e){
        super("cancelled", "Popup closed"), this.popup = e, Object.setPrototypeOf(this, $414e231c569bbbbf$export$f1f681f0fb26bb55.prototype);
    }
}
class $414e231c569bbbbf$export$d52312082b7f6392 extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(){
        super("popup_open", "Unable to open a popup for loginWithPopup - window.open returned `null`"), Object.setPrototypeOf(this, $414e231c569bbbbf$export$d52312082b7f6392.prototype);
    }
}
class $414e231c569bbbbf$export$c59494f4dae44ada extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e, t, n, o){
        super(e, t), this.mfa_token = n, this.mfa_requirements = o, Object.setPrototypeOf(this, $414e231c569bbbbf$export$c59494f4dae44ada.prototype);
    }
}
class $414e231c569bbbbf$export$ac1d2a00f8e0a046 extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_refresh_token", "Missing Refresh Token (audience: '".concat($414e231c569bbbbf$var$R(e, [
            "default"
        ]), "', scope: '").concat($414e231c569bbbbf$var$R(t), "')")), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $414e231c569bbbbf$export$ac1d2a00f8e0a046.prototype);
    }
}
class $414e231c569bbbbf$var$T extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e, t){
        super("missing_scopes", "Missing requested scopes after refresh (audience: '".concat($414e231c569bbbbf$var$R(e, [
            "default"
        ]), "', missing scope: '").concat($414e231c569bbbbf$var$R(t), "')")), this.audience = e, this.scope = t, Object.setPrototypeOf(this, $414e231c569bbbbf$var$T.prototype);
    }
}
class $414e231c569bbbbf$export$ffb710231177fce3 extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e){
        super("use_dpop_nonce", "Server rejected DPoP proof: wrong nonce"), this.newDpopNonce = e, Object.setPrototypeOf(this, $414e231c569bbbbf$export$ffb710231177fce3.prototype);
    }
}
function $414e231c569bbbbf$var$R(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
    return e && !t.includes(e) ? e : "";
}
const $414e231c569bbbbf$var$I = ()=>window.crypto, $414e231c569bbbbf$var$O = ()=>{
    const e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_~.";
    let t = "";
    return Array.from($414e231c569bbbbf$var$I().getRandomValues(new Uint8Array(43))).forEach((n)=>t += e[n % e.length]), t;
}, $414e231c569bbbbf$var$x = (e)=>btoa(e), $414e231c569bbbbf$var$C = [
    {
        key: "name",
        type: [
            "string"
        ]
    },
    {
        key: "version",
        type: [
            "string",
            "number"
        ]
    },
    {
        key: "env",
        type: [
            "object"
        ]
    }
], $414e231c569bbbbf$var$j = function(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
    return Object.keys(e).reduce((n, o)=>{
        if (t && "env" === o) return n;
        const r = $414e231c569bbbbf$var$C.find((e)=>e.key === o);
        return r && r.type.includes(typeof e[o]) && (n[o] = e[o]), n;
    }, {});
}, $414e231c569bbbbf$var$D = (t)=>{
    var { clientId: n } = t, o = $414e231c569bbbbf$var$e(t, [
        "clientId"
    ]);
    return new URLSearchParams(((e)=>Object.keys(e).filter((t)=>void 0 !== e[t]).reduce((t, n)=>Object.assign(Object.assign({}, t), {
                [n]: e[n]
            }), {}))(Object.assign({
        client_id: n
    }, o))).toString();
}, $414e231c569bbbbf$var$K = async (e)=>{
    const t = $414e231c569bbbbf$var$I().subtle.digest({
        name: "SHA-256"
    }, (new TextEncoder).encode(e));
    return await t;
}, $414e231c569bbbbf$var$L = (e)=>((e)=>decodeURIComponent(atob(e).split("").map((e)=>"%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2)).join("")))(e.replace(/_/g, "/").replace(/-/g, "+")), $414e231c569bbbbf$var$U = (e)=>{
    const t = new Uint8Array(e);
    return ((e)=>{
        const t = {
            "+": "-",
            "/": "_",
            "=": ""
        };
        return e.replace(/[+/=]/g, (e)=>t[e]);
    })(window.btoa(String.fromCharCode(...Array.from(t))));
}, $414e231c569bbbbf$var$N = new TextEncoder, $414e231c569bbbbf$var$W = new TextDecoder;
function $414e231c569bbbbf$var$z(e) {
    return "string" == typeof e ? $414e231c569bbbbf$var$N.encode(e) : $414e231c569bbbbf$var$W.decode(e);
}
function $414e231c569bbbbf$var$H(e) {
    if ("number" != typeof e.modulusLength || e.modulusLength < 2048) throw new $414e231c569bbbbf$var$G(`${e.name} modulusLength must be at least 2048 bits`);
}
async function $414e231c569bbbbf$var$M(e, t, n) {
    if (!1 === n.usages.includes("sign")) throw new TypeError('private CryptoKey instances used for signing assertions must include "sign" in their "usages"');
    const o = `${$414e231c569bbbbf$var$V($414e231c569bbbbf$var$z(JSON.stringify(e)))}.${$414e231c569bbbbf$var$V($414e231c569bbbbf$var$z(JSON.stringify(t)))}`;
    return `${o}.${$414e231c569bbbbf$var$V(await crypto.subtle.sign(function(e) {
        switch(e.algorithm.name){
            case "ECDSA":
                return {
                    name: e.algorithm.name,
                    hash: "SHA-256"
                };
            case "RSA-PSS":
                return $414e231c569bbbbf$var$H(e.algorithm), {
                    name: e.algorithm.name,
                    saltLength: 32
                };
            case "RSASSA-PKCS1-v1_5":
                return $414e231c569bbbbf$var$H(e.algorithm), {
                    name: e.algorithm.name
                };
            case "Ed25519":
                return {
                    name: e.algorithm.name
                };
        }
        throw new $414e231c569bbbbf$var$F;
    }(n), n, $414e231c569bbbbf$var$z(o)))}`;
}
let $414e231c569bbbbf$var$J;
if (Uint8Array.prototype.toBase64) $414e231c569bbbbf$var$J = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    $414e231c569bbbbf$var$J = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const n = [];
        for(let o = 0; o < t.byteLength; o += e)n.push(String.fromCharCode.apply(null, t.subarray(o, o + e)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $414e231c569bbbbf$var$V(e) {
    return $414e231c569bbbbf$var$J(e);
}
class $414e231c569bbbbf$var$F extends Error {
    constructor(e){
        var t;
        super(null != e ? e : "operation not supported"), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
class $414e231c569bbbbf$var$G extends Error {
    constructor(e){
        var t;
        super(e), this.name = this.constructor.name, null === (t = Error.captureStackTrace) || void 0 === t || t.call(Error, this, this.constructor);
    }
}
function $414e231c569bbbbf$var$Z(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "PS256";
                throw new $414e231c569bbbbf$var$F("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                if ("SHA-256" === e.algorithm.hash.name) return "RS256";
                throw new $414e231c569bbbbf$var$F("unsupported RsaHashedKeyAlgorithm hash name");
            }(e);
        case "ECDSA":
            return function(e) {
                if ("P-256" === e.algorithm.namedCurve) return "ES256";
                throw new $414e231c569bbbbf$var$F("unsupported EcKeyAlgorithm namedCurve");
            }(e);
        case "Ed25519":
            return "Ed25519";
        default:
            throw new $414e231c569bbbbf$var$F("unsupported CryptoKey algorithm name");
    }
}
function $414e231c569bbbbf$var$q(e) {
    return e instanceof CryptoKey;
}
function $414e231c569bbbbf$var$B(e) {
    return $414e231c569bbbbf$var$q(e) && "public" === e.type;
}
async function $414e231c569bbbbf$var$X(e, t, n, o, r, i) {
    const a = null == e ? void 0 : e.privateKey, s = null == e ? void 0 : e.publicKey;
    if (!$414e231c569bbbbf$var$q(c = a) || "private" !== c.type) throw new TypeError('"keypair.privateKey" must be a private CryptoKey');
    var c;
    if (!$414e231c569bbbbf$var$B(s)) throw new TypeError('"keypair.publicKey" must be a public CryptoKey');
    if (!0 !== s.extractable) throw new TypeError('"keypair.publicKey.extractable" must be true');
    if ("string" != typeof t) throw new TypeError('"htu" must be a string');
    if ("string" != typeof n) throw new TypeError('"htm" must be a string');
    if (void 0 !== o && "string" != typeof o) throw new TypeError('"nonce" must be a string or undefined');
    if (void 0 !== r && "string" != typeof r) throw new TypeError('"accessToken" must be a string or undefined');
    if (void 0 !== i && ("object" != typeof i || null === i || Array.isArray(i))) throw new TypeError('"additional" must be an object');
    return $414e231c569bbbbf$var$M({
        alg: $414e231c569bbbbf$var$Z(a),
        typ: "dpop+jwt",
        jwk: await $414e231c569bbbbf$var$Y(s)
    }, Object.assign(Object.assign({}, i), {
        iat: Math.floor(Date.now() / 1e3),
        jti: crypto.randomUUID(),
        htm: n,
        nonce: o,
        htu: t,
        ath: r ? $414e231c569bbbbf$var$V(await crypto.subtle.digest("SHA-256", $414e231c569bbbbf$var$z(r))) : void 0
    }), a);
}
async function $414e231c569bbbbf$var$Y(e) {
    const { kty: t, e: n, n: o, x: r, y: i, crv: a } = await crypto.subtle.exportKey("jwk", e);
    return {
        kty: t,
        crv: a,
        e: n,
        n: o,
        x: r,
        y: i
    };
}
const $414e231c569bbbbf$var$Q = [
    "authorization_code",
    "refresh_token",
    "urn:ietf:params:oauth:grant-type:token-exchange",
    "http://auth0.com/oauth/grant-type/mfa-oob",
    "http://auth0.com/oauth/grant-type/mfa-otp",
    "http://auth0.com/oauth/grant-type/mfa-recovery-code"
];
function $414e231c569bbbbf$var$$() {
    return async function(e, t) {
        var n;
        let o;
        if ("string" != typeof e || 0 === e.length) throw new TypeError('"alg" must be a non-empty string');
        switch(e){
            case "PS256":
                o = {
                    name: "RSA-PSS",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "RS256":
                o = {
                    name: "RSASSA-PKCS1-v1_5",
                    hash: "SHA-256",
                    modulusLength: 2048,
                    publicExponent: new Uint8Array([
                        1,
                        0,
                        1
                    ])
                };
                break;
            case "ES256":
                o = {
                    name: "ECDSA",
                    namedCurve: "P-256"
                };
                break;
            case "Ed25519":
                o = {
                    name: "Ed25519"
                };
                break;
            default:
                throw new $414e231c569bbbbf$var$F;
        }
        return crypto.subtle.generateKey(o, null !== (n = null == t ? void 0 : t.extractable) && void 0 !== n && n, [
            "sign",
            "verify"
        ]);
    }("ES256", {
        extractable: !1
    });
}
function $414e231c569bbbbf$var$ee(e) {
    return async function(e) {
        if (!$414e231c569bbbbf$var$B(e)) throw new TypeError('"publicKey" must be a public CryptoKey');
        if (!0 !== e.extractable) throw new TypeError('"publicKey.extractable" must be true');
        const t = await $414e231c569bbbbf$var$Y(e);
        let n;
        switch(t.kty){
            case "EC":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x,
                    y: t.y
                };
                break;
            case "OKP":
                n = {
                    crv: t.crv,
                    kty: t.kty,
                    x: t.x
                };
                break;
            case "RSA":
                n = {
                    e: t.e,
                    kty: t.kty,
                    n: t.n
                };
                break;
            default:
                throw new $414e231c569bbbbf$var$F("unsupported JWK kty");
        }
        return $414e231c569bbbbf$var$V(await crypto.subtle.digest({
            name: "SHA-256"
        }, $414e231c569bbbbf$var$z(JSON.stringify(n))));
    }(e.publicKey);
}
function $414e231c569bbbbf$var$te(e) {
    let { keyPair: t, url: n, method: o, nonce: r, accessToken: i } = e;
    const a = function(e) {
        const t = new URL(e);
        return t.search = "", t.hash = "", t.href;
    }(n);
    return $414e231c569bbbbf$var$X(t, a, o, r, i);
}
const $414e231c569bbbbf$var$ne = async (e, t)=>{
    const n = await fetch(e, t);
    var o;
    return {
        ok: n.ok,
        json: await n.json(),
        headers: (o = n.headers, [
            ...o
        ].reduce((e, t)=>{
            let [n, o] = t;
            return e[n] = o, e;
        }, {}))
    };
}, $414e231c569bbbbf$var$oe = async (e, t, n)=>{
    const o = new AbortController;
    let r;
    return t.signal = o.signal, Promise.race([
        $414e231c569bbbbf$var$ne(e, t),
        new Promise((e, t)=>{
            r = setTimeout(()=>{
                o.abort(), t(new Error("Timeout when executing 'fetch'"));
            }, n);
        })
    ]).finally(()=>{
        clearTimeout(r);
    });
}, $414e231c569bbbbf$var$re = async (e, t, n, o, r, i, a, s)=>((e, t)=>new Promise(function(n, o) {
            const r = new MessageChannel;
            r.port1.onmessage = function(e) {
                e.data.error ? o(new Error(e.data.error)) : n(e.data), r.port1.close();
            }, t.postMessage(e, [
                r.port2
            ]);
        }))({
        auth: {
            audience: t,
            scope: n
        },
        timeout: r,
        fetchUrl: e,
        fetchOptions: o,
        useFormData: a,
        useMrrt: s
    }, i), $414e231c569bbbbf$var$ie = async function(e, t, n, o, r, i) {
    let a = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1e4, s = arguments.length > 7 ? arguments[7] : void 0;
    return r ? $414e231c569bbbbf$var$re(e, t, n, o, a, r, i, s) : $414e231c569bbbbf$var$oe(e, o, a);
};
async function $414e231c569bbbbf$var$ae(t, n, o, r, i, a, s, c, u, l) {
    if (u) {
        const e = await u.generateProof({
            url: t,
            method: i.method || "GET",
            nonce: await u.getNonce()
        });
        i.headers = Object.assign(Object.assign({}, i.headers), {
            dpop: e
        });
    }
    let d, h = null;
    for(let e = 0; e < 3; e++)try {
        d = await $414e231c569bbbbf$var$ie(t, o, r, i, a, s, n, c), h = null;
        break;
    } catch (e) {
        h = e;
    }
    if (h) throw h;
    const p = d.json, { error: f, error_description: m } = p, y = $414e231c569bbbbf$var$e(p, [
        "error",
        "error_description"
    ]), { headers: g, ok: v } = d;
    let b;
    if (u && (b = g["dpop-nonce"], b && await u.setNonce(b)), !v) {
        const e = m || "HTTP error. Unable to fetch ".concat(t);
        if ("mfa_required" === f) throw new $414e231c569bbbbf$export$c59494f4dae44ada(f, e, y.mfa_token, y.mfa_requirements);
        if ("missing_refresh_token" === f) throw new $414e231c569bbbbf$export$ac1d2a00f8e0a046(o, r);
        if ("use_dpop_nonce" === f) {
            if (!u || !b || l) throw new $414e231c569bbbbf$export$ffb710231177fce3(b);
            return $414e231c569bbbbf$var$ae(t, n, o, r, i, a, s, c, u, !0);
        }
        throw new $414e231c569bbbbf$export$7d465be8efa67280(f || "request_error", e);
    }
    return y;
}
async function $414e231c569bbbbf$var$se(t, n) {
    var { baseUrl: o, timeout: r, audience: i, scope: a, auth0Client: s, useFormData: c, useMrrt: u, dpop: l } = t, d = $414e231c569bbbbf$var$e(t, [
        "baseUrl",
        "timeout",
        "audience",
        "scope",
        "auth0Client",
        "useFormData",
        "useMrrt",
        "dpop"
    ]);
    const h = "urn:ietf:params:oauth:grant-type:token-exchange" === d.grant_type, p = "refresh_token" === d.grant_type && u, f = Object.assign(Object.assign(Object.assign(Object.assign({}, d), h && i && {
        audience: i
    }), h && a && {
        scope: a
    }), p && {
        audience: i,
        scope: a
    }), y = c ? $414e231c569bbbbf$var$D(f) : JSON.stringify(f), w = (g = d.grant_type, $414e231c569bbbbf$var$Q.includes(g));
    var g;
    return await $414e231c569bbbbf$var$ae("".concat(o, "/oauth/token"), r, i || "default", a, {
        method: "POST",
        body: y,
        headers: {
            "Content-Type": c ? "application/x-www-form-urlencoded" : "application/json",
            "Auth0-Client": btoa(JSON.stringify($414e231c569bbbbf$var$j(s || $414e231c569bbbbf$var$m)))
        }
    }, n, c, u, w ? l : void 0);
}
const $414e231c569bbbbf$var$ce = (e)=>Array.from(new Set(e)), $414e231c569bbbbf$var$ue = function() {
    for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
    return $414e231c569bbbbf$var$ce(t.filter(Boolean).join(" ").trim().split(/\s+/)).join(" ");
}, $414e231c569bbbbf$var$le = (e, t, n)=>{
    let o;
    return n && (o = e[n]), o || (o = e.default), $414e231c569bbbbf$var$ue(o, t);
};
class $414e231c569bbbbf$export$2cb47d384c8dd787 {
    constructor(e){
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "@@auth0spajs@@", n = arguments.length > 2 ? arguments[2] : void 0;
        this.prefix = t, this.suffix = n, this.clientId = e.clientId, this.scope = e.scope, this.audience = e.audience;
    }
    toKey() {
        return [
            this.prefix,
            this.clientId,
            this.audience,
            this.scope,
            this.suffix
        ].filter(Boolean).join("::");
    }
    static fromKey(e) {
        const [t, n, o, r] = e.split("::");
        return new $414e231c569bbbbf$export$2cb47d384c8dd787({
            clientId: n,
            scope: r,
            audience: o
        }, t);
    }
    static fromCacheEntry(e) {
        const { scope: t, audience: n, client_id: o } = e;
        return new $414e231c569bbbbf$export$2cb47d384c8dd787({
            scope: t,
            audience: n,
            clientId: o
        });
    }
}
class $414e231c569bbbbf$export$40ef2cb682e70737 {
    set(e, t) {
        localStorage.setItem(e, JSON.stringify(t));
    }
    get(e) {
        const t = window.localStorage.getItem(e);
        if (t) try {
            return JSON.parse(t);
        } catch (e) {
            return;
        }
    }
    remove(e) {
        localStorage.removeItem(e);
    }
    allKeys() {
        return Object.keys(window.localStorage).filter((e)=>e.startsWith("@@auth0spajs@@"));
    }
}
class $414e231c569bbbbf$export$467265324939f47f {
    constructor(){
        this.enclosedCache = function() {
            let e = {};
            return {
                set (t, n) {
                    e[t] = n;
                },
                get (t) {
                    const n = e[t];
                    if (n) return n;
                },
                remove (t) {
                    delete e[t];
                },
                allKeys: ()=>Object.keys(e)
            };
        }();
    }
}
class $414e231c569bbbbf$var$fe {
    constructor(e, t, n){
        this.cache = e, this.keyManifest = t, this.nowProvider = n || $414e231c569bbbbf$var$y;
    }
    async setIdToken(e, t, n) {
        var o;
        const r = this.getIdTokenCacheKey(e);
        await this.cache.set(r, {
            id_token: t,
            decodedToken: n
        }), await (null === (o = this.keyManifest) || void 0 === o ? void 0 : o.add(r));
    }
    async getIdToken(e) {
        const t = await this.cache.get(this.getIdTokenCacheKey(e.clientId));
        if (!t && e.scope && e.audience) {
            const t = await this.get(e);
            if (!t) return;
            if (!t.id_token || !t.decodedToken) return;
            return {
                id_token: t.id_token,
                decodedToken: t.decodedToken
            };
        }
        if (t) return {
            id_token: t.id_token,
            decodedToken: t.decodedToken
        };
    }
    async get(e) {
        let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], o = arguments.length > 3 ? arguments[3] : void 0;
        var r;
        let i = await this.cache.get(e.toKey());
        if (!i) {
            const t = await this.getCacheKeys();
            if (!t) return;
            const r = this.matchExistingCacheKey(e, t);
            if (r && (i = await this.cache.get(r)), !i && n && "cache-only" !== o) return this.getEntryWithRefreshToken(e, t);
        }
        if (!i) return;
        const a = await this.nowProvider(), s = Math.floor(a / 1e3);
        return i.expiresAt - t < s ? i.body.refresh_token ? this.modifiedCachedEntry(i, e) : (await this.cache.remove(e.toKey()), void await (null === (r = this.keyManifest) || void 0 === r ? void 0 : r.remove(e.toKey()))) : i.body;
    }
    async modifiedCachedEntry(e, t) {
        return e.body = {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        }, await this.cache.set(t.toKey(), e), {
            refresh_token: e.body.refresh_token,
            audience: e.body.audience,
            scope: e.body.scope
        };
    }
    async set(e) {
        var t;
        const n = new $414e231c569bbbbf$export$2cb47d384c8dd787({
            clientId: e.client_id,
            scope: e.scope,
            audience: e.audience
        }), o = await this.wrapCacheEntry(e);
        await this.cache.set(n.toKey(), o), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.add(n.toKey()));
    }
    async remove(e, t, n) {
        const o = new $414e231c569bbbbf$export$2cb47d384c8dd787({
            clientId: e,
            scope: n,
            audience: t
        });
        await this.cache.remove(o.toKey());
    }
    async clear(e) {
        var t;
        const n = await this.getCacheKeys();
        n && (await n.filter((t)=>!e || t.includes(e)).reduce(async (e, t)=>{
            await e, await this.cache.remove(t);
        }, Promise.resolve()), await (null === (t = this.keyManifest) || void 0 === t ? void 0 : t.clear()));
    }
    async wrapCacheEntry(e) {
        const t = await this.nowProvider();
        return {
            body: e,
            expiresAt: Math.floor(t / 1e3) + e.expires_in
        };
    }
    async getCacheKeys() {
        var e;
        return this.keyManifest ? null === (e = await this.keyManifest.get()) || void 0 === e ? void 0 : e.keys : this.cache.allKeys ? this.cache.allKeys() : void 0;
    }
    getIdTokenCacheKey(e) {
        return new $414e231c569bbbbf$export$2cb47d384c8dd787({
            clientId: e
        }, "@@auth0spajs@@", "@@user@@").toKey();
    }
    matchExistingCacheKey(e, t) {
        return t.filter((t)=>{
            var n;
            const o = $414e231c569bbbbf$export$2cb47d384c8dd787.fromKey(t), r = new Set(o.scope && o.scope.split(" ")), i = (null === (n = e.scope) || void 0 === n ? void 0 : n.split(" ")) || [], a = o.scope && i.reduce((e, t)=>e && r.has(t), !0);
            return "@@auth0spajs@@" === o.prefix && o.clientId === e.clientId && o.audience === e.audience && a;
        })[0];
    }
    async getEntryWithRefreshToken(e, t) {
        var n;
        for (const o of t){
            const t = $414e231c569bbbbf$export$2cb47d384c8dd787.fromKey(o);
            if ("@@auth0spajs@@" === t.prefix && t.clientId === e.clientId) {
                const t = await this.cache.get(o);
                if (null === (n = null == t ? void 0 : t.body) || void 0 === n ? void 0 : n.refresh_token) return this.modifiedCachedEntry(t, e);
            }
        }
    }
    async updateEntry(e, t) {
        var n;
        const o = await this.getCacheKeys();
        if (o) for (const r of o){
            const o = await this.cache.get(r);
            if ((null === (n = null == o ? void 0 : o.body) || void 0 === n ? void 0 : n.refresh_token) === e) {
                const e = Object.assign(Object.assign({}, o.body), {
                    refresh_token: t
                });
                await this.set(e);
            }
        }
    }
}
class $414e231c569bbbbf$var$me {
    constructor(e, t, n){
        this.storage = e, this.clientId = t, this.cookieDomain = n, this.storageKey = "".concat("a0.spajs.txs", ".").concat(this.clientId);
    }
    create(e) {
        this.storage.save(this.storageKey, e, {
            daysUntilExpire: 1,
            cookieDomain: this.cookieDomain
        });
    }
    get() {
        return this.storage.get(this.storageKey);
    }
    remove() {
        this.storage.remove(this.storageKey, {
            cookieDomain: this.cookieDomain
        });
    }
}
const $414e231c569bbbbf$var$ye = (e)=>"number" == typeof e, $414e231c569bbbbf$var$we = [
    "iss",
    "aud",
    "exp",
    "nbf",
    "iat",
    "jti",
    "azp",
    "nonce",
    "auth_time",
    "at_hash",
    "c_hash",
    "acr",
    "amr",
    "sub_jwk",
    "cnf",
    "sip_from_tag",
    "sip_date",
    "sip_callid",
    "sip_cseq_num",
    "sip_via_branch",
    "orig",
    "dest",
    "mky",
    "events",
    "toe",
    "txn",
    "rph",
    "sid",
    "vot",
    "vtm"
], $414e231c569bbbbf$var$ge = (e)=>{
    if (!e.id_token) throw new Error("ID token is required but missing");
    const t = ((e)=>{
        const t = e.split("."), [n, o, r] = t;
        if (3 !== t.length || !n || !o || !r) throw new Error("ID token could not be decoded");
        const i = JSON.parse($414e231c569bbbbf$var$L(o)), a = {
            __raw: e
        }, s = {};
        return Object.keys(i).forEach((e)=>{
            a[e] = i[e], $414e231c569bbbbf$var$we.includes(e) || (s[e] = i[e]);
        }), {
            encoded: {
                header: n,
                payload: o,
                signature: r
            },
            header: JSON.parse($414e231c569bbbbf$var$L(n)),
            claims: a,
            user: s
        };
    })(e.id_token);
    if (!t.claims.iss) throw new Error("Issuer (iss) claim must be a string present in the ID token");
    if (t.claims.iss !== e.iss) throw new Error('Issuer (iss) claim mismatch in the ID token; expected "'.concat(e.iss, '", found "').concat(t.claims.iss, '"'));
    if (!t.user.sub) throw new Error("Subject (sub) claim must be a string present in the ID token");
    if ("RS256" !== t.header.alg) throw new Error('Signature algorithm of "'.concat(t.header.alg, '" is not supported. Expected the ID token to be signed with "RS256".'));
    if (!t.claims.aud || "string" != typeof t.claims.aud && !Array.isArray(t.claims.aud)) throw new Error("Audience (aud) claim must be a string or array of strings present in the ID token");
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e.aud)) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but was not one of "').concat(t.claims.aud.join(", "), '"'));
        if (t.claims.aud.length > 1) {
            if (!t.claims.azp) throw new Error("Authorized Party (azp) claim must be a string present in the ID token when Audience (aud) claim has multiple values");
            if (t.claims.azp !== e.aud) throw new Error('Authorized Party (azp) claim mismatch in the ID token; expected "'.concat(e.aud, '", found "').concat(t.claims.azp, '"'));
        }
    } else if (t.claims.aud !== e.aud) throw new Error('Audience (aud) claim mismatch in the ID token; expected "'.concat(e.aud, '" but found "').concat(t.claims.aud, '"'));
    if (e.nonce) {
        if (!t.claims.nonce) throw new Error("Nonce (nonce) claim must be a string present in the ID token");
        if (t.claims.nonce !== e.nonce) throw new Error('Nonce (nonce) claim mismatch in the ID token; expected "'.concat(e.nonce, '", found "').concat(t.claims.nonce, '"'));
    }
    if (e.max_age && !$414e231c569bbbbf$var$ye(t.claims.auth_time)) throw new Error("Authentication Time (auth_time) claim must be a number present in the ID token when Max Age (max_age) is specified");
    if (null == t.claims.exp || !$414e231c569bbbbf$var$ye(t.claims.exp)) throw new Error("Expiration Time (exp) claim must be a number present in the ID token");
    if (!$414e231c569bbbbf$var$ye(t.claims.iat)) throw new Error("Issued At (iat) claim must be a number present in the ID token");
    const n = e.leeway || 60, o = new Date(e.now || Date.now()), r = new Date(0);
    if (r.setUTCSeconds(t.claims.exp + n), o > r) throw new Error("Expiration Time (exp) claim error in the ID token; current time (".concat(o, ") is after expiration time (").concat(r, ")"));
    if (null != t.claims.nbf && $414e231c569bbbbf$var$ye(t.claims.nbf)) {
        const e = new Date(0);
        if (e.setUTCSeconds(t.claims.nbf - n), o < e) throw new Error("Not Before time (nbf) claim in the ID token indicates that this token can't be used just yet. Current time (".concat(o, ") is before ").concat(e));
    }
    if (null != t.claims.auth_time && $414e231c569bbbbf$var$ye(t.claims.auth_time)) {
        const r = new Date(0);
        if (r.setUTCSeconds(parseInt(t.claims.auth_time) + e.max_age + n), o > r) throw new Error("Authentication Time (auth_time) claim in the ID token indicates that too much time has passed since the last end-user authentication. Current time (".concat(o, ") is after last auth at ").concat(r));
    }
    if (e.organization) {
        const n = e.organization.trim();
        if (n.startsWith("org_")) {
            const e = n;
            if (!t.claims.org_id) throw new Error("Organization ID (org_id) claim must be a string present in the ID token");
            if (e !== t.claims.org_id) throw new Error('Organization ID (org_id) claim mismatch in the ID token; expected "'.concat(e, '", found "').concat(t.claims.org_id, '"'));
        } else {
            const e = n.toLowerCase();
            if (!t.claims.org_name) throw new Error("Organization Name (org_name) claim must be a string present in the ID token");
            if (e !== t.claims.org_name) throw new Error('Organization Name (org_name) claim mismatch in the ID token; expected "'.concat(e, '", found "').concat(t.claims.org_name, '"'));
        }
    }
    return t;
};
var $414e231c569bbbbf$var$ve = $414e231c569bbbbf$var$t && $414e231c569bbbbf$var$t.__assign || function() {
    return $414e231c569bbbbf$var$ve = Object.assign || function(e) {
        for(var t, n = 1, o = arguments.length; n < o; n++)for(var r in t = arguments[n])Object.prototype.hasOwnProperty.call(t, r) && (e[r] = t[r]);
        return e;
    }, $414e231c569bbbbf$var$ve.apply(this, arguments);
};
function $414e231c569bbbbf$var$be(e, t) {
    if (!t) return "";
    var n = "; " + e;
    return !0 === t ? n : n + "=" + t;
}
function $414e231c569bbbbf$var$_e(e, t, n) {
    return encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/\(/g, "%28").replace(/\)/g, "%29") + "=" + encodeURIComponent(t).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent) + function(e) {
        if ("number" == typeof e.expires) {
            var t = new Date;
            t.setMilliseconds(t.getMilliseconds() + 864e5 * e.expires), e.expires = t;
        }
        return $414e231c569bbbbf$var$be("Expires", e.expires ? e.expires.toUTCString() : "") + $414e231c569bbbbf$var$be("Domain", e.domain) + $414e231c569bbbbf$var$be("Path", e.path) + $414e231c569bbbbf$var$be("Secure", e.secure) + $414e231c569bbbbf$var$be("SameSite", e.sameSite);
    }(n);
}
function $414e231c569bbbbf$var$ke() {
    return function(e) {
        for(var t = {}, n = e ? e.split("; ") : [], o = /(%[\dA-F]{2})+/gi, r = 0; r < n.length; r++){
            var i = n[r].split("="), a = i.slice(1).join("=");
            '"' === a.charAt(0) && (a = a.slice(1, -1));
            try {
                t[i[0].replace(o, decodeURIComponent)] = a.replace(o, decodeURIComponent);
            } catch (e) {}
        }
        return t;
    }(document.cookie);
}
var $414e231c569bbbbf$var$Se = function(e) {
    return $414e231c569bbbbf$var$ke()[e];
};
function $414e231c569bbbbf$var$Ee(e, t, n) {
    document.cookie = $414e231c569bbbbf$var$_e(e, t, $414e231c569bbbbf$var$ve({
        path: "/"
    }, n));
}
var $414e231c569bbbbf$var$Ae = $414e231c569bbbbf$var$Ee;
var $414e231c569bbbbf$var$Te = function(e, t) {
    $414e231c569bbbbf$var$Ee(e, "", $414e231c569bbbbf$var$ve($414e231c569bbbbf$var$ve({}, t), {
        expires: -1
    }));
};
const $414e231c569bbbbf$var$Pe = {
    get (e) {
        const t = $414e231c569bbbbf$var$Se(e);
        if (void 0 !== t) return JSON.parse(t);
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0,
            sameSite: "none"
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $414e231c569bbbbf$var$Ae(e, JSON.stringify(t), o);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $414e231c569bbbbf$var$Te(e, n);
    }
}, $414e231c569bbbbf$var$Re = {
    get (e) {
        const t = $414e231c569bbbbf$var$Pe.get(e);
        return t || $414e231c569bbbbf$var$Pe.get("".concat("_legacy_").concat(e));
    },
    save (e, t, n) {
        let o = {};
        "https:" === window.location.protocol && (o = {
            secure: !0
        }), (null == n ? void 0 : n.daysUntilExpire) && (o.expires = n.daysUntilExpire), (null == n ? void 0 : n.cookieDomain) && (o.domain = n.cookieDomain), $414e231c569bbbbf$var$Ae("".concat("_legacy_").concat(e), JSON.stringify(t), o), $414e231c569bbbbf$var$Pe.save(e, t, n);
    },
    remove (e, t) {
        let n = {};
        (null == t ? void 0 : t.cookieDomain) && (n.domain = t.cookieDomain), $414e231c569bbbbf$var$Te(e, n), $414e231c569bbbbf$var$Pe.remove(e, t), $414e231c569bbbbf$var$Pe.remove("".concat("_legacy_").concat(e), t);
    }
}, $414e231c569bbbbf$var$Ie = {
    get (e) {
        if ("undefined" == typeof sessionStorage) return;
        const t = sessionStorage.getItem(e);
        return null != t ? JSON.parse(t) : void 0;
    },
    save (e, t) {
        sessionStorage.setItem(e, JSON.stringify(t));
    },
    remove (e) {
        sessionStorage.removeItem(e);
    }
};
var $414e231c569bbbbf$export$7390b1e457b4cb6f;
!function(e) {
    e.Code = "code", e.ConnectCode = "connect_code";
}($414e231c569bbbbf$export$7390b1e457b4cb6f || ($414e231c569bbbbf$export$7390b1e457b4cb6f = {}));
class $414e231c569bbbbf$export$1f44aaf2ec115b54 {
}
function $414e231c569bbbbf$var$Ce(e, t, n) {
    var o = void 0 === t ? null : t, r = function(e, t) {
        var n = atob(e);
        if (t) {
            for(var o = new Uint8Array(n.length), r = 0, i = n.length; r < i; ++r)o[r] = n.charCodeAt(r);
            return String.fromCharCode.apply(null, new Uint16Array(o.buffer));
        }
        return n;
    }(e, void 0 !== n && n), i = r.indexOf("\n", 10) + 1, a = r.substring(i) + (o ? "//# sourceMappingURL=" + o : ""), s = new Blob([
        a
    ], {
        type: "application/javascript"
    });
    return URL.createObjectURL(s);
}
var $414e231c569bbbbf$var$je, $414e231c569bbbbf$var$De, $414e231c569bbbbf$var$Ke, $414e231c569bbbbf$var$Le, $414e231c569bbbbf$var$Ue = ($414e231c569bbbbf$var$je = "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", $414e231c569bbbbf$var$De = null, $414e231c569bbbbf$var$Ke = !1, function(e) {
    return $414e231c569bbbbf$var$Le = $414e231c569bbbbf$var$Le || $414e231c569bbbbf$var$Ce($414e231c569bbbbf$var$je, $414e231c569bbbbf$var$De, $414e231c569bbbbf$var$Ke), new Worker($414e231c569bbbbf$var$Le, e);
});
const $414e231c569bbbbf$var$Ne = {}, $414e231c569bbbbf$var$We = async function(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 3;
    for(let n = 0; n < t; n++)if (await e()) return !0;
    return !1;
};
class $414e231c569bbbbf$var$ze {
    constructor(e, t){
        this.cache = e, this.clientId = t, this.manifestKey = this.createManifestKeyFrom(this.clientId);
    }
    async add(e) {
        var t;
        const n = new Set((null === (t = await this.cache.get(this.manifestKey)) || void 0 === t ? void 0 : t.keys) || []);
        n.add(e), await this.cache.set(this.manifestKey, {
            keys: [
                ...n
            ]
        });
    }
    async remove(e) {
        const t = await this.cache.get(this.manifestKey);
        if (t) {
            const n = new Set(t.keys);
            return n.delete(e), n.size > 0 ? await this.cache.set(this.manifestKey, {
                keys: [
                    ...n
                ]
            }) : await this.cache.remove(this.manifestKey);
        }
    }
    get() {
        return this.cache.get(this.manifestKey);
    }
    clear() {
        return this.cache.remove(this.manifestKey);
    }
    createManifestKeyFrom(e) {
        return "".concat("@@auth0spajs@@", "::").concat(e);
    }
}
const $414e231c569bbbbf$var$He = {
    memory: ()=>(new $414e231c569bbbbf$export$467265324939f47f).enclosedCache,
    localstorage: ()=>new $414e231c569bbbbf$export$40ef2cb682e70737
}, $414e231c569bbbbf$var$Me = (e)=>$414e231c569bbbbf$var$He[e], $414e231c569bbbbf$var$Je = (t)=>{
    const { openUrl: n, onRedirect: o } = t, r = $414e231c569bbbbf$var$e(t, [
        "openUrl",
        "onRedirect"
    ]);
    return Object.assign(Object.assign({}, r), {
        openUrl: !1 === n || n ? n : o
    });
}, $414e231c569bbbbf$var$Ve = (e, t)=>{
    const n = (null == t ? void 0 : t.split(" ")) || [];
    return ((null == e ? void 0 : e.split(" ")) || []).every((e)=>n.includes(e));
}, $414e231c569bbbbf$var$Fe = {
    NONCE: "nonce",
    KEYPAIR: "keypair"
};
class $414e231c569bbbbf$var$Ge {
    constructor(e){
        this.clientId = e;
    }
    getVersion() {
        return 1;
    }
    createDbHandle() {
        const e = window.indexedDB.open("auth0-spa-js", this.getVersion());
        return new Promise((t, n)=>{
            e.onupgradeneeded = ()=>Object.values($414e231c569bbbbf$var$Fe).forEach((t)=>e.result.createObjectStore(t)), e.onerror = ()=>n(e.error), e.onsuccess = ()=>t(e.result);
        });
    }
    async getDbHandle() {
        return this.dbHandle || (this.dbHandle = await this.createDbHandle()), this.dbHandle;
    }
    async executeDbRequest(e, t, n) {
        const o = n((await this.getDbHandle()).transaction(e, t).objectStore(e));
        return new Promise((e, t)=>{
            o.onsuccess = ()=>e(o.result), o.onerror = ()=>t(o.error);
        });
    }
    buildKey(e) {
        const t = e ? "_".concat(e) : "auth0";
        return "".concat(this.clientId, "::").concat(t);
    }
    setNonce(e, t) {
        return this.save($414e231c569bbbbf$var$Fe.NONCE, this.buildKey(t), e);
    }
    setKeyPair(e) {
        return this.save($414e231c569bbbbf$var$Fe.KEYPAIR, this.buildKey(), e);
    }
    async save(e, t, n) {
        await this.executeDbRequest(e, "readwrite", (e)=>e.put(n, t));
    }
    findNonce(e) {
        return this.find($414e231c569bbbbf$var$Fe.NONCE, this.buildKey(e));
    }
    findKeyPair() {
        return this.find($414e231c569bbbbf$var$Fe.KEYPAIR, this.buildKey());
    }
    find(e, t) {
        return this.executeDbRequest(e, "readonly", (e)=>e.get(t));
    }
    async deleteBy(e, t) {
        const n = await this.executeDbRequest(e, "readonly", (e)=>e.getAllKeys());
        null == n || n.filter(t).map((t)=>this.executeDbRequest(e, "readwrite", (e)=>e.delete(t)));
    }
    deleteByClientId(e, t) {
        return this.deleteBy(e, (e)=>"string" == typeof e && e.startsWith("".concat(t, "::")));
    }
    clearNonces() {
        return this.deleteByClientId($414e231c569bbbbf$var$Fe.NONCE, this.clientId);
    }
    clearKeyPairs() {
        return this.deleteByClientId($414e231c569bbbbf$var$Fe.KEYPAIR, this.clientId);
    }
}
class $414e231c569bbbbf$var$Ze {
    constructor(e){
        this.storage = new $414e231c569bbbbf$var$Ge(e);
    }
    getNonce(e) {
        return this.storage.findNonce(e);
    }
    setNonce(e, t) {
        return this.storage.setNonce(e, t);
    }
    async getOrGenerateKeyPair() {
        let e = await this.storage.findKeyPair();
        return e || (e = await $414e231c569bbbbf$var$$(), await this.storage.setKeyPair(e)), e;
    }
    async generateProof(e) {
        const t = await this.getOrGenerateKeyPair();
        return $414e231c569bbbbf$var$te(Object.assign({
            keyPair: t
        }, e));
    }
    async calculateThumbprint() {
        return $414e231c569bbbbf$var$ee(await this.getOrGenerateKeyPair());
    }
    async clear() {
        await Promise.all([
            this.storage.clearNonces(),
            this.storage.clearKeyPairs()
        ]);
    }
}
var $414e231c569bbbbf$var$qe;
!function(e) {
    e.Bearer = "Bearer", e.DPoP = "DPoP";
}($414e231c569bbbbf$var$qe || ($414e231c569bbbbf$var$qe = {}));
class $414e231c569bbbbf$var$Be {
    constructor(e, t){
        this.hooks = t, this.config = Object.assign(Object.assign({}, e), {
            fetch: e.fetch || ("undefined" == typeof window ? fetch : window.fetch.bind(window))
        });
    }
    isAbsoluteUrl(e) {
        return /^(https?:)?\/\//i.test(e);
    }
    buildUrl(e, t) {
        if (t) {
            if (this.isAbsoluteUrl(t)) return t;
            if (e) return "".concat(e.replace(/\/?\/$/, ""), "/").concat(t.replace(/^\/+/, ""));
        }
        throw new TypeError("`url` must be absolute or `baseUrl` non-empty.");
    }
    getAccessToken(e) {
        return this.config.getAccessToken ? this.config.getAccessToken(e) : this.hooks.getAccessToken(e);
    }
    extractUrl(e) {
        return "string" == typeof e ? e : e instanceof URL ? e.href : e.url;
    }
    buildBaseRequest(e, t) {
        if (!this.config.baseUrl) return new Request(e, t);
        const n = this.buildUrl(this.config.baseUrl, this.extractUrl(e)), o = e instanceof Request ? new Request(n, e) : n;
        return new Request(o, t);
    }
    setAuthorizationHeader(e, t) {
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : $414e231c569bbbbf$var$qe.Bearer;
        e.headers.set("authorization", "".concat(n, " ").concat(t));
    }
    async setDpopProofHeader(e, t) {
        if (!this.config.dpopNonceId) return;
        const n = await this.hooks.getDpopNonce(), o = await this.hooks.generateDpopProof({
            accessToken: t,
            method: e.method,
            nonce: n,
            url: e.url
        });
        e.headers.set("dpop", o);
    }
    async prepareRequest(e, t) {
        const n = await this.getAccessToken(t);
        let o, r;
        "string" == typeof n ? (o = this.config.dpopNonceId ? $414e231c569bbbbf$var$qe.DPoP : $414e231c569bbbbf$var$qe.Bearer, r = n) : (o = n.token_type, r = n.access_token), this.setAuthorizationHeader(e, r, o), o === $414e231c569bbbbf$var$qe.DPoP && await this.setDpopProofHeader(e, r);
    }
    getHeader(e, t) {
        return Array.isArray(e) ? new Headers(e).get(t) || "" : "function" == typeof e.get ? e.get(t) || "" : e[t] || "";
    }
    hasUseDpopNonceError(e) {
        if (401 !== e.status) return !1;
        const t = this.getHeader(e.headers, "www-authenticate");
        return t.includes("invalid_dpop_nonce") || t.includes("use_dpop_nonce");
    }
    async handleResponse(e, t) {
        const n = this.getHeader(e.headers, "dpop-nonce");
        if (n && await this.hooks.setDpopNonce(n), !this.hasUseDpopNonceError(e)) return e;
        if (!n || !t.onUseDpopNonceError) throw new $414e231c569bbbbf$export$ffb710231177fce3(n);
        return t.onUseDpopNonceError();
    }
    async internalFetchWithAuth(e, t, n, o) {
        const r = this.buildBaseRequest(e, t);
        await this.prepareRequest(r, o);
        const i = await this.config.fetch(r);
        return this.handleResponse(i, n);
    }
    fetchWithAuth(e, t, n) {
        const o = {
            onUseDpopNonceError: ()=>this.internalFetchWithAuth(e, t, Object.assign(Object.assign({}, o), {
                    onUseDpopNonceError: void 0
                }), n)
        };
        return this.internalFetchWithAuth(e, t, o, n);
    }
}
class $414e231c569bbbbf$var$Xe {
    constructor(e, t){
        this.myAccountFetcher = e, this.apiBase = t;
    }
    async connectAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/connect"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        });
        return this._handleResponse(t);
    }
    async completeAccount(e) {
        const t = await this.myAccountFetcher.fetchWithAuth("".concat(this.apiBase, "v1/connected-accounts/complete"), {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(e)
        });
        return this._handleResponse(t);
    }
    async _handleResponse(e) {
        let t;
        try {
            t = await e.text(), t = JSON.parse(t);
        } catch (n) {
            throw new $414e231c569bbbbf$export$2c8acf1355a80350({
                type: "invalid_json",
                status: e.status,
                title: "Invalid JSON response",
                detail: t || String(n)
            });
        }
        if (e.ok) return t;
        throw new $414e231c569bbbbf$export$2c8acf1355a80350(t);
    }
}
class $414e231c569bbbbf$export$2c8acf1355a80350 extends Error {
    constructor(e){
        let { type: t, status: n, title: o, detail: r, validation_errors: i } = e;
        super(r), this.name = "MyAccountApiError", this.type = t, this.status = n, this.title = o, this.detail = r, this.validation_errors = i, Object.setPrototypeOf(this, $414e231c569bbbbf$export$2c8acf1355a80350.prototype);
    }
}
const $414e231c569bbbbf$var$Qe = {
    otp: {
        authenticatorTypes: [
            "otp"
        ]
    },
    sms: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "sms"
        ]
    },
    email: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "email"
        ]
    },
    push: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "auth0"
        ]
    },
    voice: {
        authenticatorTypes: [
            "oob"
        ],
        oobChannels: [
            "voice"
        ]
    }
}, $414e231c569bbbbf$var$$e = "http://auth0.com/oauth/grant-type/mfa-otp", $414e231c569bbbbf$var$et = "http://auth0.com/oauth/grant-type/mfa-oob", $414e231c569bbbbf$var$tt = "http://auth0.com/oauth/grant-type/mfa-recovery-code";
function $414e231c569bbbbf$var$nt(e, t) {
    this.v = e, this.k = t;
}
function $414e231c569bbbbf$var$ot(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
function $414e231c569bbbbf$var$rt(e) {
    return new $414e231c569bbbbf$var$nt(e, 0);
}
function $414e231c569bbbbf$var$it(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $414e231c569bbbbf$var$at(e, t) {
    return e.get($414e231c569bbbbf$var$ot(e, t));
}
function $414e231c569bbbbf$var$st(e, t, n) {
    $414e231c569bbbbf$var$it(e, t), t.set(e, n);
}
function $414e231c569bbbbf$var$ct(e, t, n) {
    return e.set($414e231c569bbbbf$var$ot(e, t), n), n;
}
function $414e231c569bbbbf$var$ut(e, t, n) {
    return (t = function(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var o = n.call(e, t || "default");
                if ("object" != typeof o) return o;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $414e231c569bbbbf$var$lt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t && (o = o.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, o);
    }
    return n;
}
function $414e231c569bbbbf$var$dt(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $414e231c569bbbbf$var$lt(Object(n), !0).forEach(function(t) {
            $414e231c569bbbbf$var$ut(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $414e231c569bbbbf$var$lt(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
function $414e231c569bbbbf$var$ht(e, t) {
    if (null == e) return {};
    var n, o, r = function(e, t) {
        if (null == e) return {};
        var n = {};
        for(var o in e)if (({}).hasOwnProperty.call(e, o)) {
            if (-1 !== t.indexOf(o)) continue;
            n[o] = e[o];
        }
        return n;
    }(e, t);
    if (Object.getOwnPropertySymbols) {
        var i = Object.getOwnPropertySymbols(e);
        for(o = 0; o < i.length; o++)n = i[o], -1 === t.indexOf(n) && ({}).propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
}
function $414e231c569bbbbf$var$pt(e) {
    return function() {
        return new $414e231c569bbbbf$var$ft(e.apply(this, arguments));
    };
}
function $414e231c569bbbbf$var$ft(e) {
    var t, n;
    function o(t, n) {
        try {
            var i = e[t](n), a = i.value, s = a instanceof $414e231c569bbbbf$var$nt;
            Promise.resolve(s ? a.v : a).then(function(n) {
                if (s) {
                    var c = "return" === t ? "return" : "next";
                    if (!a.k || n.done) return o(c, n);
                    n = e[c](n).value;
                }
                r(i.done ? "return" : "normal", n);
            }, function(e) {
                o("throw", e);
            });
        } catch (e) {
            r("throw", e);
        }
    }
    function r(e, r) {
        switch(e){
            case "return":
                t.resolve({
                    value: r,
                    done: !0
                });
                break;
            case "throw":
                t.reject(r);
                break;
            default:
                t.resolve({
                    value: r,
                    done: !1
                });
        }
        (t = t.next) ? o(t.key, t.arg) : n = null;
    }
    this._invoke = function(e, r) {
        return new Promise(function(i, a) {
            var s = {
                key: e,
                arg: r,
                resolve: i,
                reject: a,
                next: null
            };
            n ? n = n.next = s : (t = n = s, o(e, r));
        });
    }, "function" != typeof e.return && (this.return = void 0);
}
var $414e231c569bbbbf$var$mt, $414e231c569bbbbf$var$yt;
let $414e231c569bbbbf$var$wt;
if ($414e231c569bbbbf$var$ft.prototype["function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator"] = function() {
    return this;
}, $414e231c569bbbbf$var$ft.prototype.next = function(e) {
    return this._invoke("next", e);
}, $414e231c569bbbbf$var$ft.prototype.throw = function(e) {
    return this._invoke("throw", e);
}, $414e231c569bbbbf$var$ft.prototype.return = function(e) {
    return this._invoke("return", e);
}, "undefined" == typeof navigator || null === ($414e231c569bbbbf$var$mt = navigator.userAgent) || void 0 === $414e231c569bbbbf$var$mt || null === ($414e231c569bbbbf$var$yt = $414e231c569bbbbf$var$mt.startsWith) || void 0 === $414e231c569bbbbf$var$yt || !$414e231c569bbbbf$var$yt.call($414e231c569bbbbf$var$mt, "Mozilla/5.0 ")) {
    const e = "v3.8.3";
    $414e231c569bbbbf$var$wt = "".concat("oauth4webapi", "/").concat(e);
}
function $414e231c569bbbbf$var$gt(e, t) {
    if (null == e) return !1;
    try {
        return e instanceof t || Object.getPrototypeOf(e)[Symbol.toStringTag] === t.prototype[Symbol.toStringTag];
    } catch (e) {
        return !1;
    }
}
function $414e231c569bbbbf$var$vt(e, t, n) {
    const o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
const $414e231c569bbbbf$var$bt = Symbol(), $414e231c569bbbbf$var$_t = Symbol(), $414e231c569bbbbf$var$kt = Symbol(), $414e231c569bbbbf$var$St = Symbol(), $414e231c569bbbbf$var$Et = Symbol(), $414e231c569bbbbf$var$At = Symbol(), $414e231c569bbbbf$var$Tt = new TextEncoder, $414e231c569bbbbf$var$Pt = new TextDecoder;
function $414e231c569bbbbf$var$Rt(e) {
    return "string" == typeof e ? $414e231c569bbbbf$var$Tt.encode(e) : $414e231c569bbbbf$var$Pt.decode(e);
}
let $414e231c569bbbbf$var$It, $414e231c569bbbbf$var$Ot;
if (Uint8Array.prototype.toBase64) $414e231c569bbbbf$var$It = (e)=>(e instanceof ArrayBuffer && (e = new Uint8Array(e)), e.toBase64({
        alphabet: "base64url",
        omitPadding: !0
    }));
else {
    const e = 32768;
    $414e231c569bbbbf$var$It = (t)=>{
        t instanceof ArrayBuffer && (t = new Uint8Array(t));
        const n = [];
        for(let o = 0; o < t.byteLength; o += e)n.push(String.fromCharCode.apply(null, t.subarray(o, o + e)));
        return btoa(n.join("")).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    };
}
function $414e231c569bbbbf$var$xt(e) {
    return "string" == typeof e ? $414e231c569bbbbf$var$Ot(e) : $414e231c569bbbbf$var$It(e);
}
$414e231c569bbbbf$var$Ot = Uint8Array.fromBase64 ? (e)=>{
    try {
        return Uint8Array.fromBase64(e, {
            alphabet: "base64url"
        });
    } catch (e) {
        throw $414e231c569bbbbf$var$vt("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", e);
    }
} : (e)=>{
    try {
        const t = atob(e.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "")), n = new Uint8Array(t.length);
        for(let e = 0; e < t.length; e++)n[e] = t.charCodeAt(e);
        return n;
    } catch (e) {
        throw $414e231c569bbbbf$var$vt("The input to be decoded is not correctly encoded.", "ERR_INVALID_ARG_VALUE", e);
    }
};
class $414e231c569bbbbf$var$Ct extends Error {
    constructor(e, t){
        var n;
        super(e, t), $414e231c569bbbbf$var$ut(this, "code", void 0), this.name = this.constructor.name, this.code = $414e231c569bbbbf$var$Cn, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
class $414e231c569bbbbf$var$jt extends Error {
    constructor(e, t){
        var n;
        super(e, t), $414e231c569bbbbf$var$ut(this, "code", void 0), this.name = this.constructor.name, null != t && t.code && (this.code = null == t ? void 0 : t.code), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
function $414e231c569bbbbf$var$Dt(e, t, n) {
    return new $414e231c569bbbbf$var$jt(e, {
        code: t,
        cause: n
    });
}
function $414e231c569bbbbf$var$Kt(e, t) {
    if (function(e, t) {
        if (!(e instanceof CryptoKey)) throw $414e231c569bbbbf$var$vt("".concat(t, " must be a CryptoKey"), "ERR_INVALID_ARG_TYPE");
    }(e, t), "private" !== e.type) throw $414e231c569bbbbf$var$vt("".concat(t, " must be a private CryptoKey"), "ERR_INVALID_ARG_VALUE");
}
function $414e231c569bbbbf$var$Lt(e) {
    return null !== e && "object" == typeof e && !Array.isArray(e);
}
function $414e231c569bbbbf$var$Ut(e) {
    $414e231c569bbbbf$var$gt(e, Headers) && (e = Object.fromEntries(e.entries()));
    const t = new Headers(null != e ? e : {});
    if ($414e231c569bbbbf$var$wt && !t.has("user-agent") && t.set("user-agent", $414e231c569bbbbf$var$wt), t.has("authorization")) throw $414e231c569bbbbf$var$vt('"options.headers" must not include the "authorization" header name', "ERR_INVALID_ARG_VALUE");
    return t;
}
function $414e231c569bbbbf$var$Nt(e, t) {
    if (void 0 !== t) {
        if ("function" == typeof t && (t = t(e.href)), !(t instanceof AbortSignal)) throw $414e231c569bbbbf$var$vt('"options.signal" must return or be an instance of AbortSignal', "ERR_INVALID_ARG_TYPE");
        return t;
    }
}
function $414e231c569bbbbf$var$Wt(e) {
    return e.includes("//") ? e.replace("//", "/") : e;
}
async function $414e231c569bbbbf$var$zt(e, t) {
    return async function(e, t, n, o) {
        if (!(e instanceof URL)) throw $414e231c569bbbbf$var$vt('"'.concat(t, '" must be an instance of URL'), "ERR_INVALID_ARG_TYPE");
        $414e231c569bbbbf$var$en(e, !0 !== (null == o ? void 0 : o[$414e231c569bbbbf$var$bt]));
        const r = n(new URL(e.href)), i = $414e231c569bbbbf$var$Ut(null == o ? void 0 : o.headers);
        return i.set("accept", "application/json"), ((null == o ? void 0 : o[$414e231c569bbbbf$var$St]) || fetch)(r.href, {
            body: void 0,
            headers: Object.fromEntries(i.entries()),
            method: "GET",
            redirect: "manual",
            signal: $414e231c569bbbbf$var$Nt(r, null == o ? void 0 : o.signal)
        });
    }(e, "issuerIdentifier", (e)=>{
        switch(null == t ? void 0 : t.algorithm){
            case void 0:
            case "oidc":
                !function(e, t) {
                    e.pathname = $414e231c569bbbbf$var$Wt("".concat(e.pathname, "/").concat(t));
                }(e, ".well-known/openid-configuration");
                break;
            case "oauth2":
                !function(e, t) {
                    let n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    "/" === e.pathname ? e.pathname = t : e.pathname = $414e231c569bbbbf$var$Wt("".concat(t, "/").concat(n ? e.pathname : e.pathname.replace(/(\/)$/, "")));
                }(e, ".well-known/oauth-authorization-server");
                break;
            default:
                throw $414e231c569bbbbf$var$vt('"options.algorithm" must be "oidc" (default), or "oauth2"', "ERR_INVALID_ARG_VALUE");
        }
        return e;
    }, t);
}
function $414e231c569bbbbf$var$Ht(e, t, n, o, r) {
    try {
        if ("number" != typeof e || !Number.isFinite(e)) throw $414e231c569bbbbf$var$vt("".concat(n, " must be a number"), "ERR_INVALID_ARG_TYPE", r);
        if (e > 0) return;
        if (t) {
            if (0 !== e) throw $414e231c569bbbbf$var$vt("".concat(n, " must be a non-negative number"), "ERR_INVALID_ARG_VALUE", r);
            return;
        }
        throw $414e231c569bbbbf$var$vt("".concat(n, " must be a positive number"), "ERR_INVALID_ARG_VALUE", r);
    } catch (e) {
        if (o) throw $414e231c569bbbbf$var$Dt(e.message, o, r);
        throw e;
    }
}
function $414e231c569bbbbf$var$Mt(e, t, n, o) {
    try {
        if ("string" != typeof e) throw $414e231c569bbbbf$var$vt("".concat(t, " must be a string"), "ERR_INVALID_ARG_TYPE", o);
        if (0 === e.length) throw $414e231c569bbbbf$var$vt("".concat(t, " must not be empty"), "ERR_INVALID_ARG_VALUE", o);
    } catch (e) {
        if (n) throw $414e231c569bbbbf$var$Dt(e.message, n, o);
        throw e;
    }
}
function $414e231c569bbbbf$var$Jt(e) {
    !function(e, t) {
        if ($414e231c569bbbbf$var$fn(e) !== t) throw function(e) {
            let t = '"response" content-type must be ';
            for(var n = arguments.length, o = new Array(n > 1 ? n - 1 : 0), r = 1; r < n; r++)o[r - 1] = arguments[r];
            if (o.length > 2) {
                const e = o.pop();
                t += "".concat(o.join(", "), ", or ").concat(e);
            } else 2 === o.length ? t += "".concat(o[0], " or ").concat(o[1]) : t += o[0];
            return $414e231c569bbbbf$var$Dt(t, $414e231c569bbbbf$var$Ln, e);
        }(e, t);
    }(e, "application/json");
}
function $414e231c569bbbbf$var$Vt() {
    return $414e231c569bbbbf$var$xt(crypto.getRandomValues(new Uint8Array(32)));
}
function $414e231c569bbbbf$var$Ft(e) {
    switch(e.algorithm.name){
        case "RSA-PSS":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "PS256";
                    case "SHA-384":
                        return "PS384";
                    case "SHA-512":
                        return "PS512";
                    default:
                        throw new $414e231c569bbbbf$var$Ct("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "RSASSA-PKCS1-v1_5":
            return function(e) {
                switch(e.algorithm.hash.name){
                    case "SHA-256":
                        return "RS256";
                    case "SHA-384":
                        return "RS384";
                    case "SHA-512":
                        return "RS512";
                    default:
                        throw new $414e231c569bbbbf$var$Ct("unsupported RsaHashedKeyAlgorithm hash name", {
                            cause: e
                        });
                }
            }(e);
        case "ECDSA":
            return function(e) {
                switch(e.algorithm.namedCurve){
                    case "P-256":
                        return "ES256";
                    case "P-384":
                        return "ES384";
                    case "P-521":
                        return "ES512";
                    default:
                        throw new $414e231c569bbbbf$var$Ct("unsupported EcKeyAlgorithm namedCurve", {
                            cause: e
                        });
                }
            }(e);
        case "Ed25519":
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            return e.algorithm.name;
        case "EdDSA":
            return "Ed25519";
        default:
            throw new $414e231c569bbbbf$var$Ct("unsupported CryptoKey algorithm name", {
                cause: e
            });
    }
}
function $414e231c569bbbbf$var$Gt(e) {
    const t = null == e ? void 0 : e[$414e231c569bbbbf$var$_t];
    return "number" == typeof t && Number.isFinite(t) ? t : 0;
}
function $414e231c569bbbbf$var$Zt(e) {
    const t = null == e ? void 0 : e[$414e231c569bbbbf$var$kt];
    return "number" == typeof t && Number.isFinite(t) && -1 !== Math.sign(t) ? t : 30;
}
function $414e231c569bbbbf$var$qt() {
    return Math.floor(Date.now() / 1e3);
}
function $414e231c569bbbbf$var$Bt(e) {
    if ("object" != typeof e || null === e) throw $414e231c569bbbbf$var$vt('"as" must be an object', "ERR_INVALID_ARG_TYPE");
    $414e231c569bbbbf$var$Mt(e.issuer, '"as.issuer"');
}
function $414e231c569bbbbf$var$Xt(e) {
    if ("object" != typeof e || null === e) throw $414e231c569bbbbf$var$vt('"client" must be an object', "ERR_INVALID_ARG_TYPE");
    $414e231c569bbbbf$var$Mt(e.client_id, '"client.client_id"');
}
function $414e231c569bbbbf$var$Yt(e) {
    return $414e231c569bbbbf$var$Mt(e, '"clientSecret"'), (t, n, o, r)=>{
        o.set("client_id", n.client_id), o.set("client_secret", e);
    };
}
function $414e231c569bbbbf$var$Qt(e, t) {
    const { key: n, kid: o } = (r = e) instanceof CryptoKey ? {
        key: r
    } : (null == r ? void 0 : r.key) instanceof CryptoKey ? (void 0 !== r.kid && $414e231c569bbbbf$var$Mt(r.kid, '"kid"'), {
        key: r.key,
        kid: r.kid
    }) : {};
    var r;
    return $414e231c569bbbbf$var$Kt(n, '"clientPrivateKey.key"'), async (e, r, i, a)=>{
        var s;
        const c = {
            alg: $414e231c569bbbbf$var$Ft(n),
            kid: o
        }, u = function(e, t) {
            const n = $414e231c569bbbbf$var$qt() + $414e231c569bbbbf$var$Gt(t);
            return {
                jti: $414e231c569bbbbf$var$Vt(),
                aud: e.issuer,
                exp: n + 60,
                iat: n,
                nbf: n,
                iss: t.client_id,
                sub: t.client_id
            };
        }(e, r);
        null == t || null === (s = t[$414e231c569bbbbf$var$Et]) || void 0 === s || s.call(t, c, u), i.set("client_id", r.client_id), i.set("client_assertion_type", "urn:ietf:params:oauth:client-assertion-type:jwt-bearer"), i.set("client_assertion", await async function(e, t, n) {
            if (!n.usages.includes("sign")) throw $414e231c569bbbbf$var$vt('CryptoKey instances used for signing assertions must include "sign" in their "usages"', "ERR_INVALID_ARG_VALUE");
            const o = "".concat($414e231c569bbbbf$var$xt($414e231c569bbbbf$var$Rt(JSON.stringify(e))), ".").concat($414e231c569bbbbf$var$xt($414e231c569bbbbf$var$Rt(JSON.stringify(t)))), r = $414e231c569bbbbf$var$xt(await crypto.subtle.sign(function(e) {
                switch(e.algorithm.name){
                    case "ECDSA":
                        return {
                            name: e.algorithm.name,
                            hash: $414e231c569bbbbf$var$Zn(e)
                        };
                    case "RSA-PSS":
                        switch($414e231c569bbbbf$var$Gn(e), e.algorithm.hash.name){
                            case "SHA-256":
                            case "SHA-384":
                            case "SHA-512":
                                return {
                                    name: e.algorithm.name,
                                    saltLength: parseInt(e.algorithm.hash.name.slice(-3), 10) >> 3
                                };
                            default:
                                throw new $414e231c569bbbbf$var$Ct("unsupported RSA-PSS hash name", {
                                    cause: e
                                });
                        }
                    case "RSASSA-PKCS1-v1_5":
                        return $414e231c569bbbbf$var$Gn(e), e.algorithm.name;
                    case "ML-DSA-44":
                    case "ML-DSA-65":
                    case "ML-DSA-87":
                    case "Ed25519":
                        return e.algorithm.name;
                }
                throw new $414e231c569bbbbf$var$Ct("unsupported CryptoKey algorithm name", {
                    cause: e
                });
            }(n), n, $414e231c569bbbbf$var$Rt(o)));
            return "".concat(o, ".").concat(r);
        }(c, u, n));
    };
}
const $414e231c569bbbbf$var$$t = URL.parse ? (e, t)=>URL.parse(e, t) : (e, t)=>{
    try {
        return new URL(e, t);
    } catch (e) {
        return null;
    }
};
function $414e231c569bbbbf$var$en(e, t) {
    if (t && "https:" !== e.protocol) throw $414e231c569bbbbf$var$Dt("only requests to HTTPS are allowed", $414e231c569bbbbf$var$Nn, e);
    if ("https:" !== e.protocol && "http:" !== e.protocol) throw $414e231c569bbbbf$var$Dt("only HTTP and HTTPS requests are allowed", $414e231c569bbbbf$var$Wn, e);
}
function $414e231c569bbbbf$var$tn(e, t, n, o) {
    let r;
    if ("string" != typeof e || !(r = $414e231c569bbbbf$var$$t(e))) throw $414e231c569bbbbf$var$Dt("authorization server metadata does not contain a valid ".concat(n ? '"as.mtls_endpoint_aliases.'.concat(t, '"') : '"as.'.concat(t, '"')), void 0 === e ? $414e231c569bbbbf$var$Jn : $414e231c569bbbbf$var$Vn, {
        attribute: n ? "mtls_endpoint_aliases.".concat(t) : t
    });
    return $414e231c569bbbbf$var$en(r, o), r;
}
function $414e231c569bbbbf$var$nn(e, t, n, o) {
    return n && e.mtls_endpoint_aliases && t in e.mtls_endpoint_aliases ? $414e231c569bbbbf$var$tn(e.mtls_endpoint_aliases[t], t, n, o) : $414e231c569bbbbf$var$tn(e[t], t, n, o);
}
class $414e231c569bbbbf$var$on extends Error {
    constructor(e, t){
        var n;
        super(e, t), $414e231c569bbbbf$var$ut(this, "cause", void 0), $414e231c569bbbbf$var$ut(this, "code", void 0), $414e231c569bbbbf$var$ut(this, "error", void 0), $414e231c569bbbbf$var$ut(this, "status", void 0), $414e231c569bbbbf$var$ut(this, "error_description", void 0), $414e231c569bbbbf$var$ut(this, "response", void 0), this.name = this.constructor.name, this.code = $414e231c569bbbbf$var$xn, this.cause = t.cause, this.error = t.cause.error, this.status = t.response.status, this.error_description = t.cause.error_description, Object.defineProperty(this, "response", {
            enumerable: !1,
            value: t.response
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
class $414e231c569bbbbf$var$rn extends Error {
    constructor(e, t){
        var n, o;
        super(e, t), $414e231c569bbbbf$var$ut(this, "cause", void 0), $414e231c569bbbbf$var$ut(this, "code", void 0), $414e231c569bbbbf$var$ut(this, "error", void 0), $414e231c569bbbbf$var$ut(this, "error_description", void 0), this.name = this.constructor.name, this.code = $414e231c569bbbbf$var$jn, this.cause = t.cause, this.error = t.cause.get("error"), this.error_description = null !== (n = t.cause.get("error_description")) && void 0 !== n ? n : void 0, null === (o = Error.captureStackTrace) || void 0 === o || o.call(Error, this, this.constructor);
    }
}
class $414e231c569bbbbf$var$an extends Error {
    constructor(e, t){
        var n;
        super(e, t), $414e231c569bbbbf$var$ut(this, "cause", void 0), $414e231c569bbbbf$var$ut(this, "code", void 0), $414e231c569bbbbf$var$ut(this, "response", void 0), $414e231c569bbbbf$var$ut(this, "status", void 0), this.name = this.constructor.name, this.code = $414e231c569bbbbf$var$On, this.cause = t.cause, this.status = t.response.status, this.response = t.response, Object.defineProperty(this, "response", {
            enumerable: !1
        }), null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
const $414e231c569bbbbf$var$sn = "[a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+", $414e231c569bbbbf$var$cn = new RegExp("^[,\\s]*(" + $414e231c569bbbbf$var$sn + ")"), $414e231c569bbbbf$var$un = new RegExp('^[,\\s]*([a-zA-Z0-9!#$%&\\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*"((?:[^"\\\\]|\\\\[\\s\\S])*)"[,\\s]*(.*)'), $414e231c569bbbbf$var$ln = new RegExp("^[,\\s]*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)\\s*=\\s*([a-zA-Z0-9!#$%&\\'\\*\\+\\-\\.\\^_`\\|~]+)[,\\s]*(.*)"), $414e231c569bbbbf$var$dn = new RegExp("^([a-zA-Z0-9\\-\\._\\~\\+\\/]+={0,2})(?:$|[,\\s])(.*)");
async function $414e231c569bbbbf$var$hn(e, t, n) {
    if (e.status !== t) {
        let t;
        var o;
        if (function(e) {
            let t;
            if (t = function(e) {
                if (!$414e231c569bbbbf$var$gt(e, Response)) throw $414e231c569bbbbf$var$vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
                const t = e.headers.get("www-authenticate");
                if (null === t) return;
                const n = [];
                let o = t;
                for(; o;){
                    var r;
                    let e = o.match($414e231c569bbbbf$var$cn);
                    const t = null === (r = e) || void 0 === r ? void 0 : r[1].toLowerCase();
                    if (!t) return;
                    const i = o.substring(e[0].length);
                    if (i && !i.match(/^[\s,]/)) return;
                    const a = i.match(/^\s+(.*)$/), s = !!a;
                    o = a ? a[1] : void 0;
                    const c = {};
                    let u;
                    if (s) for(; o;){
                        let t, n;
                        if (e = o.match($414e231c569bbbbf$var$un)) {
                            if ([, t, n, o] = e, n.includes("\\")) try {
                                n = JSON.parse('"'.concat(n, '"'));
                            } catch (e) {}
                            c[t.toLowerCase()] = n;
                        } else {
                            if (!(e = o.match($414e231c569bbbbf$var$ln))) {
                                if (e = o.match($414e231c569bbbbf$var$dn)) {
                                    if (Object.keys(c).length) break;
                                    [, u, o] = e;
                                    break;
                                }
                                return;
                            }
                            [, t, n, o] = e, c[t.toLowerCase()] = n;
                        }
                    }
                    else o = i || void 0;
                    const l = {
                        scheme: t,
                        parameters: c
                    };
                    u && (l.token68 = u), n.push(l);
                }
                return n.length ? n : void 0;
            }(e)) throw new $414e231c569bbbbf$var$an("server responded with a challenge in the WWW-Authenticate HTTP Header", {
                cause: t,
                response: e
            });
        }(e), t = await async function(e) {
            if (e.status > 399 && e.status < 500) {
                $414e231c569bbbbf$var$Fn(e), $414e231c569bbbbf$var$Jt(e);
                try {
                    const t = await e.clone().json();
                    if ($414e231c569bbbbf$var$Lt(t) && "string" == typeof t.error && t.error.length) return t;
                } catch (e) {}
            }
        }(e)) throw await (null === (o = e.body) || void 0 === o ? void 0 : o.cancel()), new $414e231c569bbbbf$var$on("server responded with an error in the response body", {
            cause: t,
            response: e
        });
        throw $414e231c569bbbbf$var$Dt('"response" is not a conform '.concat(n, " response (unexpected HTTP status code)"), $414e231c569bbbbf$var$Un, e);
    }
}
function $414e231c569bbbbf$var$pn(e) {
    if (!$414e231c569bbbbf$var$Sn.has(e)) throw $414e231c569bbbbf$var$vt('"options.DPoP" is not a valid DPoPHandle', "ERR_INVALID_ARG_VALUE");
}
function $414e231c569bbbbf$var$fn(e) {
    var t;
    return null === (t = e.headers.get("content-type")) || void 0 === t ? void 0 : t.split(";")[0];
}
async function $414e231c569bbbbf$var$mn(e, t, n, o, r, i, a) {
    return await n(e, t, r, i), i.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"), ((null == a ? void 0 : a[$414e231c569bbbbf$var$St]) || fetch)(o.href, {
        body: r,
        headers: Object.fromEntries(i.entries()),
        method: "POST",
        redirect: "manual",
        signal: $414e231c569bbbbf$var$Nt(o, null == a ? void 0 : a.signal)
    });
}
async function $414e231c569bbbbf$var$yn(e, t, n, o, r, i) {
    var a;
    const s = $414e231c569bbbbf$var$nn(e, "token_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == i ? void 0 : i[$414e231c569bbbbf$var$bt]));
    r.set("grant_type", o);
    const c = $414e231c569bbbbf$var$Ut(null == i ? void 0 : i.headers);
    c.set("accept", "application/json"), void 0 !== (null == i ? void 0 : i.DPoP) && ($414e231c569bbbbf$var$pn(i.DPoP), await i.DPoP.addProof(s, c, "POST"));
    const u = await $414e231c569bbbbf$var$mn(e, t, n, s, r, c, i);
    return null == i || null === (a = i.DPoP) || void 0 === a || a.cacheNonce(u, s), u;
}
const $414e231c569bbbbf$var$wn = new WeakMap, $414e231c569bbbbf$var$gn = new WeakMap;
function $414e231c569bbbbf$var$vn(e) {
    if (!e.id_token) return;
    const t = $414e231c569bbbbf$var$wn.get(e);
    if (!t) throw $414e231c569bbbbf$var$vt('"ref" was already garbage collected or did not resolve from the proper sources', "ERR_INVALID_ARG_VALUE");
    return t;
}
async function $414e231c569bbbbf$var$bn(e, t, n, o, r, i) {
    if ($414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), !$414e231c569bbbbf$var$gt(n, Response)) throw $414e231c569bbbbf$var$vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
    await $414e231c569bbbbf$var$hn(n, 200, "Token Endpoint"), $414e231c569bbbbf$var$Fn(n);
    const a = await $414e231c569bbbbf$var$eo(n);
    if ($414e231c569bbbbf$var$Mt(a.access_token, '"response" body "access_token" property', $414e231c569bbbbf$var$Kn, {
        body: a
    }), $414e231c569bbbbf$var$Mt(a.token_type, '"response" body "token_type" property', $414e231c569bbbbf$var$Kn, {
        body: a
    }), a.token_type = a.token_type.toLowerCase(), void 0 !== a.expires_in) {
        let e = "number" != typeof a.expires_in ? parseFloat(a.expires_in) : a.expires_in;
        $414e231c569bbbbf$var$Ht(e, !0, '"response" body "expires_in" property', $414e231c569bbbbf$var$Kn, {
            body: a
        }), a.expires_in = e;
    }
    if (void 0 !== a.refresh_token && $414e231c569bbbbf$var$Mt(a.refresh_token, '"response" body "refresh_token" property', $414e231c569bbbbf$var$Kn, {
        body: a
    }), void 0 !== a.scope && "string" != typeof a.scope) throw $414e231c569bbbbf$var$Dt('"response" body "scope" property must be a string', $414e231c569bbbbf$var$Kn, {
        body: a
    });
    if (void 0 !== a.id_token) {
        $414e231c569bbbbf$var$Mt(a.id_token, '"response" body "id_token" property', $414e231c569bbbbf$var$Kn, {
            body: a
        });
        const i = [
            "aud",
            "exp",
            "iat",
            "iss",
            "sub"
        ];
        !0 === t.require_auth_time && i.push("auth_time"), void 0 !== t.default_max_age && ($414e231c569bbbbf$var$Ht(t.default_max_age, !0, '"client.default_max_age"'), i.push("auth_time")), null != o && o.length && i.push(...o);
        const { claims: s, jwt: c } = await (async function(e, t, n, o, r) {
            let i, a, { 0: s, 1: c, length: u } = e.split(".");
            if (5 === u) {
                if (void 0 === r) throw new $414e231c569bbbbf$var$Ct("JWE decryption is not configured", {
                    cause: e
                });
                e = await r(e), { 0: s, 1: c, length: u } = e.split(".");
            }
            if (3 !== u) throw $414e231c569bbbbf$var$Dt("Invalid JWT", $414e231c569bbbbf$var$Kn, e);
            try {
                i = JSON.parse($414e231c569bbbbf$var$Rt($414e231c569bbbbf$var$xt(s)));
            } catch (e) {
                throw $414e231c569bbbbf$var$Dt("failed to parse JWT Header body as base64url encoded JSON", $414e231c569bbbbf$var$Dn, e);
            }
            if (!$414e231c569bbbbf$var$Lt(i)) throw $414e231c569bbbbf$var$Dt("JWT Header must be a top level object", $414e231c569bbbbf$var$Kn, e);
            if (t(i), void 0 !== i.crit) throw new $414e231c569bbbbf$var$Ct('no JWT "crit" header parameter extensions are supported', {
                cause: {
                    header: i
                }
            });
            try {
                a = JSON.parse($414e231c569bbbbf$var$Rt($414e231c569bbbbf$var$xt(c)));
            } catch (e) {
                throw $414e231c569bbbbf$var$Dt("failed to parse JWT Payload body as base64url encoded JSON", $414e231c569bbbbf$var$Dn, e);
            }
            if (!$414e231c569bbbbf$var$Lt(a)) throw $414e231c569bbbbf$var$Dt("JWT Payload must be a top level object", $414e231c569bbbbf$var$Kn, e);
            const l = $414e231c569bbbbf$var$qt() + n;
            if (void 0 !== a.exp) {
                if ("number" != typeof a.exp) throw $414e231c569bbbbf$var$Dt('unexpected JWT "exp" (expiration time) claim type', $414e231c569bbbbf$var$Kn, {
                    claims: a
                });
                if (a.exp <= l - o) throw $414e231c569bbbbf$var$Dt('unexpected JWT "exp" (expiration time) claim value, expiration is past current timestamp', $414e231c569bbbbf$var$zn, {
                    claims: a,
                    now: l,
                    tolerance: o,
                    claim: "exp"
                });
            }
            if (void 0 !== a.iat && "number" != typeof a.iat) throw $414e231c569bbbbf$var$Dt('unexpected JWT "iat" (issued at) claim type', $414e231c569bbbbf$var$Kn, {
                claims: a
            });
            if (void 0 !== a.iss && "string" != typeof a.iss) throw $414e231c569bbbbf$var$Dt('unexpected JWT "iss" (issuer) claim type', $414e231c569bbbbf$var$Kn, {
                claims: a
            });
            if (void 0 !== a.nbf) {
                if ("number" != typeof a.nbf) throw $414e231c569bbbbf$var$Dt('unexpected JWT "nbf" (not before) claim type', $414e231c569bbbbf$var$Kn, {
                    claims: a
                });
                if (a.nbf > l + o) throw $414e231c569bbbbf$var$Dt('unexpected JWT "nbf" (not before) claim value', $414e231c569bbbbf$var$zn, {
                    claims: a,
                    now: l,
                    tolerance: o,
                    claim: "nbf"
                });
            }
            if (void 0 !== a.aud && "string" != typeof a.aud && !Array.isArray(a.aud)) throw $414e231c569bbbbf$var$Dt('unexpected JWT "aud" (audience) claim type', $414e231c569bbbbf$var$Kn, {
                claims: a
            });
            return {
                header: i,
                claims: a,
                jwt: e
            };
        })(a.id_token, $414e231c569bbbbf$var$Bn.bind(void 0, t.id_token_signed_response_alg, e.id_token_signing_alg_values_supported, "RS256"), $414e231c569bbbbf$var$Gt(t), $414e231c569bbbbf$var$Zt(t), r).then($414e231c569bbbbf$var$Tn.bind(void 0, i)).then($414e231c569bbbbf$var$kn.bind(void 0, e)).then($414e231c569bbbbf$var$_n.bind(void 0, t.client_id));
        if (Array.isArray(s.aud) && 1 !== s.aud.length) {
            if (void 0 === s.azp) throw $414e231c569bbbbf$var$Dt('ID Token "aud" (audience) claim includes additional untrusted audiences', $414e231c569bbbbf$var$Hn, {
                claims: s,
                claim: "aud"
            });
            if (s.azp !== t.client_id) throw $414e231c569bbbbf$var$Dt('unexpected ID Token "azp" (authorized party) claim value', $414e231c569bbbbf$var$Hn, {
                expected: t.client_id,
                claims: s,
                claim: "azp"
            });
        }
        void 0 !== s.auth_time && $414e231c569bbbbf$var$Ht(s.auth_time, !0, 'ID Token "auth_time" (authentication time)', $414e231c569bbbbf$var$Kn, {
            claims: s
        }), $414e231c569bbbbf$var$gn.set(n, c), $414e231c569bbbbf$var$wn.set(a, s);
    }
    if (void 0 !== (null == i ? void 0 : i[a.token_type])) i[a.token_type](n, a);
    else if ("dpop" !== a.token_type && "bearer" !== a.token_type) throw new $414e231c569bbbbf$var$Ct("unsupported `token_type` value", {
        cause: {
            body: a
        }
    });
    return a;
}
function $414e231c569bbbbf$var$_n(e, t) {
    if (Array.isArray(t.claims.aud)) {
        if (!t.claims.aud.includes(e)) throw $414e231c569bbbbf$var$Dt('unexpected JWT "aud" (audience) claim value', $414e231c569bbbbf$var$Hn, {
            expected: e,
            claims: t.claims,
            claim: "aud"
        });
    } else if (t.claims.aud !== e) throw $414e231c569bbbbf$var$Dt('unexpected JWT "aud" (audience) claim value', $414e231c569bbbbf$var$Hn, {
        expected: e,
        claims: t.claims,
        claim: "aud"
    });
    return t;
}
function $414e231c569bbbbf$var$kn(e, t) {
    var n, o;
    const r = null !== (n = null === (o = e[$414e231c569bbbbf$var$no]) || void 0 === o ? void 0 : o.call(e, t)) && void 0 !== n ? n : e.issuer;
    if (t.claims.iss !== r) throw $414e231c569bbbbf$var$Dt('unexpected JWT "iss" (issuer) claim value', $414e231c569bbbbf$var$Hn, {
        expected: r,
        claims: t.claims,
        claim: "iss"
    });
    return t;
}
const $414e231c569bbbbf$var$Sn = new WeakSet;
const $414e231c569bbbbf$var$En = Symbol();
const $414e231c569bbbbf$var$An = {
    aud: "audience",
    c_hash: "code hash",
    client_id: "client id",
    exp: "expiration time",
    iat: "issued at",
    iss: "issuer",
    jti: "jwt id",
    nonce: "nonce",
    s_hash: "state hash",
    sub: "subject",
    ath: "access token hash",
    htm: "http method",
    htu: "http uri",
    cnf: "confirmation",
    auth_time: "authentication time"
};
function $414e231c569bbbbf$var$Tn(e, t) {
    for (const n of e)if (void 0 === t.claims[n]) throw $414e231c569bbbbf$var$Dt('JWT "'.concat(n, '" (').concat($414e231c569bbbbf$var$An[n], ") claim missing"), $414e231c569bbbbf$var$Kn, {
        claims: t.claims
    });
    return t;
}
const $414e231c569bbbbf$var$Pn = Symbol(), $414e231c569bbbbf$var$Rn = Symbol();
async function $414e231c569bbbbf$var$In(e, t, n, o) {
    return "string" == typeof (null == o ? void 0 : o.expectedNonce) || "number" == typeof (null == o ? void 0 : o.maxAge) || null != o && o.requireIdToken ? async function(e, t, n, o, r, i, a) {
        const s = [];
        switch(o){
            case void 0:
                o = $414e231c569bbbbf$var$Pn;
                break;
            case $414e231c569bbbbf$var$Pn:
                break;
            default:
                $414e231c569bbbbf$var$Mt(o, '"expectedNonce" argument'), s.push("nonce");
        }
        switch(null != r || (r = t.default_max_age), r){
            case void 0:
                r = $414e231c569bbbbf$var$Rn;
                break;
            case $414e231c569bbbbf$var$Rn:
                break;
            default:
                $414e231c569bbbbf$var$Ht(r, !0, '"maxAge" argument'), s.push("auth_time");
        }
        const c = await $414e231c569bbbbf$var$bn(e, t, n, s, i, a);
        $414e231c569bbbbf$var$Mt(c.id_token, '"response" body "id_token" property', $414e231c569bbbbf$var$Kn, {
            body: c
        });
        const u = $414e231c569bbbbf$var$vn(c);
        if (r !== $414e231c569bbbbf$var$Rn) {
            const e = $414e231c569bbbbf$var$qt() + $414e231c569bbbbf$var$Gt(t), n = $414e231c569bbbbf$var$Zt(t);
            if (u.auth_time + r < e - n) throw $414e231c569bbbbf$var$Dt("too much time has elapsed since the last End-User authentication", $414e231c569bbbbf$var$zn, {
                claims: u,
                now: e,
                tolerance: n,
                claim: "auth_time"
            });
        }
        if (o === $414e231c569bbbbf$var$Pn) {
            if (void 0 !== u.nonce) throw $414e231c569bbbbf$var$Dt('unexpected ID Token "nonce" claim value', $414e231c569bbbbf$var$Hn, {
                expected: void 0,
                claims: u,
                claim: "nonce"
            });
        } else if (u.nonce !== o) throw $414e231c569bbbbf$var$Dt('unexpected ID Token "nonce" claim value', $414e231c569bbbbf$var$Hn, {
            expected: o,
            claims: u,
            claim: "nonce"
        });
        return c;
    }(e, t, n, o.expectedNonce, o.maxAge, o[$414e231c569bbbbf$var$At], o.recognizedTokenTypes) : async function(e, t, n, o, r) {
        const i = await $414e231c569bbbbf$var$bn(e, t, n, void 0, o, r), a = $414e231c569bbbbf$var$vn(i);
        if (a) {
            if (void 0 !== t.default_max_age) {
                $414e231c569bbbbf$var$Ht(t.default_max_age, !0, '"client.default_max_age"');
                const e = $414e231c569bbbbf$var$qt() + $414e231c569bbbbf$var$Gt(t), n = $414e231c569bbbbf$var$Zt(t);
                if (a.auth_time + t.default_max_age < e - n) throw $414e231c569bbbbf$var$Dt("too much time has elapsed since the last End-User authentication", $414e231c569bbbbf$var$zn, {
                    claims: a,
                    now: e,
                    tolerance: n,
                    claim: "auth_time"
                });
            }
            if (void 0 !== a.nonce) throw $414e231c569bbbbf$var$Dt('unexpected ID Token "nonce" claim value', $414e231c569bbbbf$var$Hn, {
                expected: void 0,
                claims: a,
                claim: "nonce"
            });
        }
        return i;
    }(e, t, n, null == o ? void 0 : o[$414e231c569bbbbf$var$At], null == o ? void 0 : o.recognizedTokenTypes);
}
const $414e231c569bbbbf$var$On = "OAUTH_WWW_AUTHENTICATE_CHALLENGE", $414e231c569bbbbf$var$xn = "OAUTH_RESPONSE_BODY_ERROR", $414e231c569bbbbf$var$Cn = "OAUTH_UNSUPPORTED_OPERATION", $414e231c569bbbbf$var$jn = "OAUTH_AUTHORIZATION_RESPONSE_ERROR", $414e231c569bbbbf$var$Dn = "OAUTH_PARSE_ERROR", $414e231c569bbbbf$var$Kn = "OAUTH_INVALID_RESPONSE", $414e231c569bbbbf$var$Ln = "OAUTH_RESPONSE_IS_NOT_JSON", $414e231c569bbbbf$var$Un = "OAUTH_RESPONSE_IS_NOT_CONFORM", $414e231c569bbbbf$var$Nn = "OAUTH_HTTP_REQUEST_FORBIDDEN", $414e231c569bbbbf$var$Wn = "OAUTH_REQUEST_PROTOCOL_FORBIDDEN", $414e231c569bbbbf$var$zn = "OAUTH_JWT_TIMESTAMP_CHECK_FAILED", $414e231c569bbbbf$var$Hn = "OAUTH_JWT_CLAIM_COMPARISON_FAILED", $414e231c569bbbbf$var$Mn = "OAUTH_JSON_ATTRIBUTE_COMPARISON_FAILED", $414e231c569bbbbf$var$Jn = "OAUTH_MISSING_SERVER_METADATA", $414e231c569bbbbf$var$Vn = "OAUTH_INVALID_SERVER_METADATA";
function $414e231c569bbbbf$var$Fn(e) {
    if (e.bodyUsed) throw $414e231c569bbbbf$var$vt('"response" body has been used already', "ERR_INVALID_ARG_VALUE");
}
function $414e231c569bbbbf$var$Gn(e) {
    const { algorithm: t } = e;
    if ("number" != typeof t.modulusLength || t.modulusLength < 2048) throw new $414e231c569bbbbf$var$Ct("unsupported ".concat(t.name, " modulusLength"), {
        cause: e
    });
}
function $414e231c569bbbbf$var$Zn(e) {
    const { algorithm: t } = e;
    switch(t.namedCurve){
        case "P-256":
            return "SHA-256";
        case "P-384":
            return "SHA-384";
        case "P-521":
            return "SHA-512";
        default:
            throw new $414e231c569bbbbf$var$Ct("unsupported ECDSA namedCurve", {
                cause: e
            });
    }
}
async function $414e231c569bbbbf$var$qn(e) {
    if ("POST" !== e.method) throw $414e231c569bbbbf$var$vt("form_post responses are expected to use the POST method", "ERR_INVALID_ARG_VALUE", {
        cause: e
    });
    if ("application/x-www-form-urlencoded" !== $414e231c569bbbbf$var$fn(e)) throw $414e231c569bbbbf$var$vt("form_post responses are expected to use the application/x-www-form-urlencoded content-type", "ERR_INVALID_ARG_VALUE", {
        cause: e
    });
    return async function(e) {
        if (e.bodyUsed) throw $414e231c569bbbbf$var$vt("form_post Request instances must contain a readable body", "ERR_INVALID_ARG_VALUE", {
            cause: e
        });
        return e.text();
    }(e);
}
function $414e231c569bbbbf$var$Bn(e, t, n, o) {
    if (void 0 === e) {
        if (Array.isArray(t)) {
            if (!t.includes(o.alg)) throw $414e231c569bbbbf$var$Dt('unexpected JWT "alg" header parameter', $414e231c569bbbbf$var$Kn, {
                header: o,
                expected: t,
                reason: "authorization server metadata"
            });
        } else {
            if (void 0 === n) throw $414e231c569bbbbf$var$Dt('missing client or server configuration to verify used JWT "alg" header parameter', void 0, {
                client: e,
                issuer: t,
                fallback: n
            });
            if ("string" == typeof n ? o.alg !== n : "function" == typeof n ? !n(o.alg) : !n.includes(o.alg)) throw $414e231c569bbbbf$var$Dt('unexpected JWT "alg" header parameter', $414e231c569bbbbf$var$Kn, {
                header: o,
                expected: n,
                reason: "default value"
            });
        }
    } else if ("string" == typeof e ? o.alg !== e : !e.includes(o.alg)) throw $414e231c569bbbbf$var$Dt('unexpected JWT "alg" header parameter', $414e231c569bbbbf$var$Kn, {
        header: o,
        expected: e,
        reason: "client configuration"
    });
}
function $414e231c569bbbbf$var$Xn(e, t) {
    const { 0: n, length: o } = e.getAll(t);
    if (o > 1) throw $414e231c569bbbbf$var$Dt('"'.concat(t, '" parameter must be provided only once'), $414e231c569bbbbf$var$Kn);
    return n;
}
const $414e231c569bbbbf$var$Yn = Symbol(), $414e231c569bbbbf$var$Qn = Symbol();
function $414e231c569bbbbf$var$$n(e, t, n, o) {
    if ($414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), n instanceof URL && (n = n.searchParams), !(n instanceof URLSearchParams)) throw $414e231c569bbbbf$var$vt('"parameters" must be an instance of URLSearchParams, or URL', "ERR_INVALID_ARG_TYPE");
    if ($414e231c569bbbbf$var$Xn(n, "response")) throw $414e231c569bbbbf$var$Dt('"parameters" contains a JARM response, use validateJwtAuthResponse() instead of validateAuthResponse()', $414e231c569bbbbf$var$Kn, {
        parameters: n
    });
    const r = $414e231c569bbbbf$var$Xn(n, "iss"), i = $414e231c569bbbbf$var$Xn(n, "state");
    if (!r && e.authorization_response_iss_parameter_supported) throw $414e231c569bbbbf$var$Dt('response parameter "iss" (issuer) missing', $414e231c569bbbbf$var$Kn, {
        parameters: n
    });
    if (r && r !== e.issuer) throw $414e231c569bbbbf$var$Dt('unexpected "iss" (issuer) response parameter value', $414e231c569bbbbf$var$Kn, {
        expected: e.issuer,
        parameters: n
    });
    switch(o){
        case void 0:
        case $414e231c569bbbbf$var$Qn:
            if (void 0 !== i) throw $414e231c569bbbbf$var$Dt('unexpected "state" response parameter encountered', $414e231c569bbbbf$var$Kn, {
                expected: void 0,
                parameters: n
            });
            break;
        case $414e231c569bbbbf$var$Yn:
            break;
        default:
            if ($414e231c569bbbbf$var$Mt(o, '"expectedState" argument'), i !== o) throw $414e231c569bbbbf$var$Dt(void 0 === i ? 'response parameter "state" missing' : 'unexpected "state" response parameter value', $414e231c569bbbbf$var$Kn, {
                expected: o,
                parameters: n
            });
    }
    if ($414e231c569bbbbf$var$Xn(n, "error")) throw new $414e231c569bbbbf$var$rn("authorization response from the server is an error", {
        cause: n
    });
    const a = $414e231c569bbbbf$var$Xn(n, "id_token"), s = $414e231c569bbbbf$var$Xn(n, "token");
    if (void 0 !== a || void 0 !== s) throw new $414e231c569bbbbf$var$Ct("implicit and hybrid flows are not supported");
    var c;
    return c = new URLSearchParams(n), $414e231c569bbbbf$var$Sn.add(c), c;
}
async function $414e231c569bbbbf$var$eo(e) {
    let t, n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : $414e231c569bbbbf$var$Jt;
    try {
        t = await e.json();
    } catch (t) {
        throw n(e), $414e231c569bbbbf$var$Dt('failed to parse "response" body as JSON', $414e231c569bbbbf$var$Dn, t);
    }
    if (!$414e231c569bbbbf$var$Lt(t)) throw $414e231c569bbbbf$var$Dt('"response" body must be a top level object', $414e231c569bbbbf$var$Kn, {
        body: t
    });
    return t;
}
const $414e231c569bbbbf$var$to = Symbol(), $414e231c569bbbbf$var$no = Symbol(), $414e231c569bbbbf$var$oo = new TextEncoder, $414e231c569bbbbf$var$ro = new TextDecoder;
function $414e231c569bbbbf$var$io(e) {
    const t = new Uint8Array(e.length);
    for(let n = 0; n < e.length; n++){
        const o = e.charCodeAt(n);
        if (o > 127) throw new TypeError("non-ASCII string encountered in encode()");
        t[n] = o;
    }
    return t;
}
function $414e231c569bbbbf$var$ao(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64(e);
    const t = atob(e), n = new Uint8Array(t.length);
    for(let e = 0; e < t.length; e++)n[e] = t.charCodeAt(e);
    return n;
}
function $414e231c569bbbbf$var$so(e) {
    if (Uint8Array.fromBase64) return Uint8Array.fromBase64("string" == typeof e ? e : $414e231c569bbbbf$var$ro.decode(e), {
        alphabet: "base64url"
    });
    let t = e;
    t instanceof Uint8Array && (t = $414e231c569bbbbf$var$ro.decode(t)), t = t.replace(/-/g, "+").replace(/_/g, "/");
    try {
        return $414e231c569bbbbf$var$ao(t);
    } catch (e) {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
}
class $414e231c569bbbbf$var$co extends Error {
    constructor(e, t){
        var n;
        super(e, t), $414e231c569bbbbf$var$ut(this, "code", "ERR_JOSE_GENERIC"), this.name = this.constructor.name, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$co, "code", "ERR_JOSE_GENERIC");
class $414e231c569bbbbf$var$uo extends $414e231c569bbbbf$var$co {
    constructor(e, t){
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        super(e, {
            cause: {
                claim: n,
                reason: o,
                payload: t
            }
        }), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED"), $414e231c569bbbbf$var$ut(this, "claim", void 0), $414e231c569bbbbf$var$ut(this, "reason", void 0), $414e231c569bbbbf$var$ut(this, "payload", void 0), this.claim = n, this.reason = o, this.payload = t;
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$uo, "code", "ERR_JWT_CLAIM_VALIDATION_FAILED");
class $414e231c569bbbbf$var$lo extends $414e231c569bbbbf$var$co {
    constructor(e, t){
        let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "unspecified", o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "unspecified";
        super(e, {
            cause: {
                claim: n,
                reason: o,
                payload: t
            }
        }), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWT_EXPIRED"), $414e231c569bbbbf$var$ut(this, "claim", void 0), $414e231c569bbbbf$var$ut(this, "reason", void 0), $414e231c569bbbbf$var$ut(this, "payload", void 0), this.claim = n, this.reason = o, this.payload = t;
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$lo, "code", "ERR_JWT_EXPIRED");
class $414e231c569bbbbf$var$ho extends $414e231c569bbbbf$var$co {
    constructor(){
        super(...arguments), $414e231c569bbbbf$var$ut(this, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$ho, "code", "ERR_JOSE_ALG_NOT_ALLOWED");
class $414e231c569bbbbf$var$po extends $414e231c569bbbbf$var$co {
    constructor(){
        super(...arguments), $414e231c569bbbbf$var$ut(this, "code", "ERR_JOSE_NOT_SUPPORTED");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$po, "code", "ERR_JOSE_NOT_SUPPORTED");
$414e231c569bbbbf$var$ut(class extends $414e231c569bbbbf$var$co {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "decryption operation failed", arguments.length > 1 ? arguments[1] : void 0), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWE_DECRYPTION_FAILED");
    }
}, "code", "ERR_JWE_DECRYPTION_FAILED");
$414e231c569bbbbf$var$ut(class extends $414e231c569bbbbf$var$co {
    constructor(){
        super(...arguments), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWE_INVALID");
    }
}, "code", "ERR_JWE_INVALID");
class $414e231c569bbbbf$var$fo extends $414e231c569bbbbf$var$co {
    constructor(){
        super(...arguments), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWS_INVALID");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$fo, "code", "ERR_JWS_INVALID");
class $414e231c569bbbbf$var$mo extends $414e231c569bbbbf$var$co {
    constructor(){
        super(...arguments), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWT_INVALID");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$mo, "code", "ERR_JWT_INVALID");
$414e231c569bbbbf$var$ut(class extends $414e231c569bbbbf$var$co {
    constructor(){
        super(...arguments), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWK_INVALID");
    }
}, "code", "ERR_JWK_INVALID");
class $414e231c569bbbbf$var$yo extends $414e231c569bbbbf$var$co {
    constructor(){
        super(...arguments), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWKS_INVALID");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$yo, "code", "ERR_JWKS_INVALID");
class $414e231c569bbbbf$var$wo extends $414e231c569bbbbf$var$co {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "no applicable key found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWKS_NO_MATCHING_KEY");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$wo, "code", "ERR_JWKS_NO_MATCHING_KEY");
class $414e231c569bbbbf$var$go extends $414e231c569bbbbf$var$co {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "multiple matching keys found in the JSON Web Key Set", arguments.length > 1 ? arguments[1] : void 0), $414e231c569bbbbf$var$ut(this, Symbol.asyncIterator, void 0), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$go, "code", "ERR_JWKS_MULTIPLE_MATCHING_KEYS");
class $414e231c569bbbbf$var$vo extends $414e231c569bbbbf$var$co {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "request timed out", arguments.length > 1 ? arguments[1] : void 0), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWKS_TIMEOUT");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$vo, "code", "ERR_JWKS_TIMEOUT");
class $414e231c569bbbbf$var$bo extends $414e231c569bbbbf$var$co {
    constructor(){
        super(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "signature verification failed", arguments.length > 1 ? arguments[1] : void 0), $414e231c569bbbbf$var$ut(this, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
    }
}
$414e231c569bbbbf$var$ut($414e231c569bbbbf$var$bo, "code", "ERR_JWS_SIGNATURE_VERIFICATION_FAILED");
const $414e231c569bbbbf$var$_o = function(e) {
    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "algorithm.name";
    return new TypeError("CryptoKey does not support this operation, its ".concat(t, " must be ").concat(e));
}, $414e231c569bbbbf$var$ko = (e, t)=>e.name === t;
function $414e231c569bbbbf$var$So(e) {
    return parseInt(e.name.slice(4), 10);
}
function $414e231c569bbbbf$var$Eo(e, t, n) {
    switch(t){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$414e231c569bbbbf$var$ko(e.algorithm, "HMAC")) throw $414e231c569bbbbf$var$_o("HMAC");
                const n = parseInt(t.slice(2), 10);
                if ($414e231c569bbbbf$var$So(e.algorithm.hash) !== n) throw $414e231c569bbbbf$var$_o("SHA-".concat(n), "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$414e231c569bbbbf$var$ko(e.algorithm, "RSASSA-PKCS1-v1_5")) throw $414e231c569bbbbf$var$_o("RSASSA-PKCS1-v1_5");
                const n = parseInt(t.slice(2), 10);
                if ($414e231c569bbbbf$var$So(e.algorithm.hash) !== n) throw $414e231c569bbbbf$var$_o("SHA-".concat(n), "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$414e231c569bbbbf$var$ko(e.algorithm, "RSA-PSS")) throw $414e231c569bbbbf$var$_o("RSA-PSS");
                const n = parseInt(t.slice(2), 10);
                if ($414e231c569bbbbf$var$So(e.algorithm.hash) !== n) throw $414e231c569bbbbf$var$_o("SHA-".concat(n), "algorithm.hash");
                break;
            }
        case "Ed25519":
        case "EdDSA":
            if (!$414e231c569bbbbf$var$ko(e.algorithm, "Ed25519")) throw $414e231c569bbbbf$var$_o("Ed25519");
            break;
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            if (!$414e231c569bbbbf$var$ko(e.algorithm, t)) throw $414e231c569bbbbf$var$_o(t);
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$414e231c569bbbbf$var$ko(e.algorithm, "ECDSA")) throw $414e231c569bbbbf$var$_o("ECDSA");
                const n = function(e) {
                    switch(e){
                        case "ES256":
                            return "P-256";
                        case "ES384":
                            return "P-384";
                        case "ES512":
                            return "P-521";
                        default:
                            throw new Error("unreachable");
                    }
                }(t);
                if (e.algorithm.namedCurve !== n) throw $414e231c569bbbbf$var$_o(n, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    !function(e, t) {
        if (t && !e.usages.includes(t)) throw new TypeError("CryptoKey does not support this operation, its usages must include ".concat(t, "."));
    }(e, n);
}
function $414e231c569bbbbf$var$Ao(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)o[r - 2] = arguments[r];
    if ((o = o.filter(Boolean)).length > 2) {
        const t = o.pop();
        e += "one of type ".concat(o.join(", "), ", or ").concat(t, ".");
    } else 2 === o.length ? e += "one of type ".concat(o[0], " or ").concat(o[1], ".") : e += "of type ".concat(o[0], ".");
    if (null == t) e += " Received ".concat(t);
    else if ("function" == typeof t && t.name) e += " Received function ".concat(t.name);
    else if ("object" == typeof t && null != t) {
        var i;
        null !== (i = t.constructor) && void 0 !== i && i.name && (e += " Received an instance of ".concat(t.constructor.name));
    }
    return e;
}
const $414e231c569bbbbf$var$To = function(e, t) {
    for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)o[r - 2] = arguments[r];
    return $414e231c569bbbbf$var$Ao("Key for the ".concat(e, " algorithm must be "), t, ...o);
}, $414e231c569bbbbf$var$Po = (e)=>{
    if ("CryptoKey" === (null == e ? void 0 : e[Symbol.toStringTag])) return !0;
    try {
        return e instanceof CryptoKey;
    } catch (e) {
        return !1;
    }
}, $414e231c569bbbbf$var$Ro = (e)=>"KeyObject" === (null == e ? void 0 : e[Symbol.toStringTag]), $414e231c569bbbbf$var$Io = (e)=>$414e231c569bbbbf$var$Po(e) || $414e231c569bbbbf$var$Ro(e);
function $414e231c569bbbbf$var$Oo(e) {
    if ("object" != typeof (t = e) || null === t || "[object Object]" !== Object.prototype.toString.call(e)) return !1;
    var t;
    if (null === Object.getPrototypeOf(e)) return !0;
    let n = e;
    for(; null !== Object.getPrototypeOf(n);)n = Object.getPrototypeOf(n);
    return Object.getPrototypeOf(e) === n;
}
const $414e231c569bbbbf$var$xo = (e, t)=>{
    if (e.byteLength !== t.length) return !1;
    for(let n = 0; n < e.byteLength; n++)if (e[n] !== t[n]) return !1;
    return !0;
}, $414e231c569bbbbf$var$Co = (e)=>{
    const t = e.data[e.pos++];
    if (128 & t) {
        const n = 127 & t;
        let o = 0;
        for(let t = 0; t < n; t++)o = o << 8 | e.data[e.pos++];
        return o;
    }
    return t;
}, $414e231c569bbbbf$var$jo = (e, t, n)=>{
    if (e.data[e.pos++] !== t) throw new Error(n);
}, $414e231c569bbbbf$var$Do = (e, t)=>{
    const n = e.data.subarray(e.pos, e.pos + t);
    return e.pos += t, n;
};
const $414e231c569bbbbf$var$Ko = (e)=>{
    const t = ((e)=>{
        $414e231c569bbbbf$var$jo(e, 6, "Expected algorithm OID");
        const t = $414e231c569bbbbf$var$Co(e);
        return $414e231c569bbbbf$var$Do(e, t);
    })(e);
    if ($414e231c569bbbbf$var$xo(t, [
        43,
        101,
        110
    ])) return "X25519";
    if (!$414e231c569bbbbf$var$xo(t, [
        42,
        134,
        72,
        206,
        61,
        2,
        1
    ])) throw new Error("Unsupported key algorithm");
    $414e231c569bbbbf$var$jo(e, 6, "Expected curve OID");
    const n = $414e231c569bbbbf$var$Co(e), o = $414e231c569bbbbf$var$Do(e, n);
    for (const { name: e, oid: t } of [
        {
            name: "P-256",
            oid: [
                42,
                134,
                72,
                206,
                61,
                3,
                1,
                7
            ]
        },
        {
            name: "P-384",
            oid: [
                43,
                129,
                4,
                0,
                34
            ]
        },
        {
            name: "P-521",
            oid: [
                43,
                129,
                4,
                0,
                35
            ]
        }
    ])if ($414e231c569bbbbf$var$xo(o, t)) return e;
    throw new Error("Unsupported named curve");
}, $414e231c569bbbbf$var$Lo = async (e, t, n, o)=>{
    var r;
    let i, a;
    const s = "spki" === e, c = ()=>s ? [
            "verify"
        ] : [
            "sign"
        ];
    switch(n){
        case "PS256":
        case "PS384":
        case "PS512":
            i = {
                name: "RSA-PSS",
                hash: "SHA-".concat(n.slice(-3))
            }, a = c();
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            i = {
                name: "RSASSA-PKCS1-v1_5",
                hash: "SHA-".concat(n.slice(-3))
            }, a = c();
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            i = {
                name: "RSA-OAEP",
                hash: "SHA-".concat(parseInt(n.slice(-3), 10) || 1)
            }, a = s ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            i = {
                name: "ECDSA",
                namedCurve: ({
                    ES256: "P-256",
                    ES384: "P-384",
                    ES512: "P-521"
                })[n]
            }, a = c();
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            try {
                const e = o.getNamedCurve(t);
                i = "X25519" === e ? {
                    name: "X25519"
                } : {
                    name: "ECDH",
                    namedCurve: e
                };
            } catch (e) {
                throw new $414e231c569bbbbf$var$po("Invalid or unsupported key format");
            }
            a = s ? [] : [
                "deriveBits"
            ];
            break;
        case "Ed25519":
        case "EdDSA":
            i = {
                name: "Ed25519"
            }, a = c();
            break;
        case "ML-DSA-44":
        case "ML-DSA-65":
        case "ML-DSA-87":
            i = {
                name: n
            }, a = c();
            break;
        default:
            throw new $414e231c569bbbbf$var$po('Invalid or unsupported "alg" (Algorithm) value');
    }
    return crypto.subtle.importKey(e, t, i, null !== (r = null == o ? void 0 : o.extractable) && void 0 !== r ? r : !!s, a);
}, $414e231c569bbbbf$var$Uo = (e, t, n)=>{
    var o;
    const r = ((e, t)=>$414e231c569bbbbf$var$ao(e.replace(t, "")))(e, /(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g);
    let i = n;
    return null != t && null !== (o = t.startsWith) && void 0 !== o && o.call(t, "ECDH-ES") && (i || (i = {}), i.getNamedCurve = (e)=>{
        const t = {
            data: e,
            pos: 0
        };
        return function(e) {
            $414e231c569bbbbf$var$jo(e, 48, "Invalid PKCS#8 structure"), $414e231c569bbbbf$var$Co(e), $414e231c569bbbbf$var$jo(e, 2, "Expected version field");
            const t = $414e231c569bbbbf$var$Co(e);
            e.pos += t, $414e231c569bbbbf$var$jo(e, 48, "Expected algorithm identifier");
            const n = $414e231c569bbbbf$var$Co(e);
            e.pos;
        }(t), $414e231c569bbbbf$var$Ko(t);
    }), $414e231c569bbbbf$var$Lo("pkcs8", r, t, i);
};
async function $414e231c569bbbbf$var$No(e) {
    var t, n;
    if (!e.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: o, keyUsages: r } = function(e) {
        let t, n;
        switch(e.kty){
            case "AKP":
                switch(e.alg){
                    case "ML-DSA-44":
                    case "ML-DSA-65":
                    case "ML-DSA-87":
                        t = {
                            name: e.alg
                        }, n = e.priv ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    default:
                        throw new $414e231c569bbbbf$var$po('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            case "RSA":
                switch(e.alg){
                    case "PS256":
                    case "PS384":
                    case "PS512":
                        t = {
                            name: "RSA-PSS",
                            hash: "SHA-".concat(e.alg.slice(-3))
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "RS256":
                    case "RS384":
                    case "RS512":
                        t = {
                            name: "RSASSA-PKCS1-v1_5",
                            hash: "SHA-".concat(e.alg.slice(-3))
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "RSA-OAEP":
                    case "RSA-OAEP-256":
                    case "RSA-OAEP-384":
                    case "RSA-OAEP-512":
                        t = {
                            name: "RSA-OAEP",
                            hash: "SHA-".concat(parseInt(e.alg.slice(-3), 10) || 1)
                        }, n = e.d ? [
                            "decrypt",
                            "unwrapKey"
                        ] : [
                            "encrypt",
                            "wrapKey"
                        ];
                        break;
                    default:
                        throw new $414e231c569bbbbf$var$po('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            case "EC":
                switch(e.alg){
                    case "ES256":
                        t = {
                            name: "ECDSA",
                            namedCurve: "P-256"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ES384":
                        t = {
                            name: "ECDSA",
                            namedCurve: "P-384"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ES512":
                        t = {
                            name: "ECDSA",
                            namedCurve: "P-521"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ECDH-ES":
                    case "ECDH-ES+A128KW":
                    case "ECDH-ES+A192KW":
                    case "ECDH-ES+A256KW":
                        t = {
                            name: "ECDH",
                            namedCurve: e.crv
                        }, n = e.d ? [
                            "deriveBits"
                        ] : [];
                        break;
                    default:
                        throw new $414e231c569bbbbf$var$po('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            case "OKP":
                switch(e.alg){
                    case "Ed25519":
                    case "EdDSA":
                        t = {
                            name: "Ed25519"
                        }, n = e.d ? [
                            "sign"
                        ] : [
                            "verify"
                        ];
                        break;
                    case "ECDH-ES":
                    case "ECDH-ES+A128KW":
                    case "ECDH-ES+A192KW":
                    case "ECDH-ES+A256KW":
                        t = {
                            name: e.crv
                        }, n = e.d ? [
                            "deriveBits"
                        ] : [];
                        break;
                    default:
                        throw new $414e231c569bbbbf$var$po('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
                }
                break;
            default:
                throw new $414e231c569bbbbf$var$po('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
        }
        return {
            algorithm: t,
            keyUsages: n
        };
    }(e), i = $414e231c569bbbbf$var$dt({}, e);
    return "AKP" !== i.kty && delete i.alg, delete i.use, crypto.subtle.importKey("jwk", i, o, null !== (t = e.ext) && void 0 !== t ? t : !e.d && !e.priv, null !== (n = e.key_ops) && void 0 !== n ? n : r);
}
const $414e231c569bbbbf$var$Wo = (e)=>$414e231c569bbbbf$var$Oo(e) && "string" == typeof e.kty;
let $414e231c569bbbbf$var$zo;
const $414e231c569bbbbf$var$Ho = async function(e, t, n) {
    let o = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    $414e231c569bbbbf$var$zo || ($414e231c569bbbbf$var$zo = new WeakMap);
    let r = $414e231c569bbbbf$var$zo.get(e);
    if (null != r && r[n]) return r[n];
    const i = await $414e231c569bbbbf$var$No($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, t), {}, {
        alg: n
    }));
    return o && Object.freeze(e), r ? r[n] = i : $414e231c569bbbbf$var$zo.set(e, {
        [n]: i
    }), i;
};
async function $414e231c569bbbbf$var$Mo(e, t) {
    if (e instanceof Uint8Array) return e;
    if ($414e231c569bbbbf$var$Po(e)) return e;
    if ($414e231c569bbbbf$var$Ro(e)) {
        if ("secret" === e.type) return e.export();
        if ("toCryptoKey" in e && "function" == typeof e.toCryptoKey) try {
            return ((e, t)=>{
                $414e231c569bbbbf$var$zo || ($414e231c569bbbbf$var$zo = new WeakMap);
                let n = $414e231c569bbbbf$var$zo.get(e);
                if (null != n && n[t]) return n[t];
                const o = "public" === e.type, r = !!o;
                let i;
                if ("x25519" === e.asymmetricKeyType) {
                    switch(t){
                        case "ECDH-ES":
                        case "ECDH-ES+A128KW":
                        case "ECDH-ES+A192KW":
                        case "ECDH-ES+A256KW":
                            break;
                        default:
                            throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    }
                    i = e.toCryptoKey(e.asymmetricKeyType, r, o ? [] : [
                        "deriveBits"
                    ]);
                }
                if ("ed25519" === e.asymmetricKeyType) {
                    if ("EdDSA" !== t && "Ed25519" !== t) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    i = e.toCryptoKey(e.asymmetricKeyType, r, [
                        o ? "verify" : "sign"
                    ]);
                }
                switch(e.asymmetricKeyType){
                    case "ml-dsa-44":
                    case "ml-dsa-65":
                    case "ml-dsa-87":
                        if (t !== e.asymmetricKeyType.toUpperCase()) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                        i = e.toCryptoKey(e.asymmetricKeyType, r, [
                            o ? "verify" : "sign"
                        ]);
                }
                if ("rsa" === e.asymmetricKeyType) {
                    let n;
                    switch(t){
                        case "RSA-OAEP":
                            n = "SHA-1";
                            break;
                        case "RS256":
                        case "PS256":
                        case "RSA-OAEP-256":
                            n = "SHA-256";
                            break;
                        case "RS384":
                        case "PS384":
                        case "RSA-OAEP-384":
                            n = "SHA-384";
                            break;
                        case "RS512":
                        case "PS512":
                        case "RSA-OAEP-512":
                            n = "SHA-512";
                            break;
                        default:
                            throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    }
                    if (t.startsWith("RSA-OAEP")) return e.toCryptoKey({
                        name: "RSA-OAEP",
                        hash: n
                    }, r, o ? [
                        "encrypt"
                    ] : [
                        "decrypt"
                    ]);
                    i = e.toCryptoKey({
                        name: t.startsWith("PS") ? "RSA-PSS" : "RSASSA-PKCS1-v1_5",
                        hash: n
                    }, r, [
                        o ? "verify" : "sign"
                    ]);
                }
                if ("ec" === e.asymmetricKeyType) {
                    var a;
                    const n = new Map([
                        [
                            "prime256v1",
                            "P-256"
                        ],
                        [
                            "secp384r1",
                            "P-384"
                        ],
                        [
                            "secp521r1",
                            "P-521"
                        ]
                    ]).get(null === (a = e.asymmetricKeyDetails) || void 0 === a ? void 0 : a.namedCurve);
                    if (!n) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                    "ES256" === t && "P-256" === n && (i = e.toCryptoKey({
                        name: "ECDSA",
                        namedCurve: n
                    }, r, [
                        o ? "verify" : "sign"
                    ])), "ES384" === t && "P-384" === n && (i = e.toCryptoKey({
                        name: "ECDSA",
                        namedCurve: n
                    }, r, [
                        o ? "verify" : "sign"
                    ])), "ES512" === t && "P-521" === n && (i = e.toCryptoKey({
                        name: "ECDSA",
                        namedCurve: n
                    }, r, [
                        o ? "verify" : "sign"
                    ])), t.startsWith("ECDH-ES") && (i = e.toCryptoKey({
                        name: "ECDH",
                        namedCurve: n
                    }, r, o ? [] : [
                        "deriveBits"
                    ]));
                }
                if (!i) throw new TypeError("given KeyObject instance cannot be used for this algorithm");
                return n ? n[t] = i : $414e231c569bbbbf$var$zo.set(e, {
                    [t]: i
                }), i;
            })(e, t);
        } catch (e) {
            if (e instanceof TypeError) throw e;
        }
        let n = e.export({
            format: "jwk"
        });
        return $414e231c569bbbbf$var$Ho(e, n, t);
    }
    if ($414e231c569bbbbf$var$Wo(e)) return e.k ? $414e231c569bbbbf$var$so(e.k) : $414e231c569bbbbf$var$Ho(e, e, t, !0);
    throw new Error("unreachable");
}
const $414e231c569bbbbf$var$Jo = (e)=>null == e ? void 0 : e[Symbol.toStringTag], $414e231c569bbbbf$var$Vo = (e, t, n)=>{
    if (void 0 !== t.use) {
        let e;
        switch(n){
            case "sign":
            case "verify":
                e = "sig";
                break;
            case "encrypt":
            case "decrypt":
                e = "enc";
        }
        if (t.use !== e) throw new TypeError('Invalid key for this operation, its "use" must be "'.concat(e, '" when present'));
    }
    if (void 0 !== t.alg && t.alg !== e) throw new TypeError('Invalid key for this operation, its "alg" must be "'.concat(e, '" when present'));
    if (Array.isArray(t.key_ops)) {
        var o, r;
        let i;
        switch(!0){
            case "sign" === n || "verify" === n:
            case "dir" === e:
            case e.includes("CBC-HS"):
                i = n;
                break;
            case e.startsWith("PBES2"):
                i = "deriveBits";
                break;
            case /^A\d{3}(?:GCM)?(?:KW)?$/.test(e):
                i = !e.includes("GCM") && e.endsWith("KW") ? "encrypt" === n ? "wrapKey" : "unwrapKey" : n;
                break;
            case "encrypt" === n && e.startsWith("RSA"):
                i = "wrapKey";
                break;
            case "decrypt" === n:
                i = e.startsWith("RSA") ? "unwrapKey" : "deriveBits";
        }
        if (i && !1 === (null === (o = t.key_ops) || void 0 === o || null === (r = o.includes) || void 0 === r ? void 0 : r.call(o, i))) throw new TypeError('Invalid key for this operation, its "key_ops" must include "'.concat(i, '" when present'));
    }
    return !0;
};
function $414e231c569bbbbf$var$Fo(e, t, n) {
    switch(e.substring(0, 2)){
        case "A1":
        case "A2":
        case "di":
        case "HS":
        case "PB":
            ((e, t, n)=>{
                if (!(t instanceof Uint8Array)) {
                    if ($414e231c569bbbbf$var$Wo(t)) {
                        if (((e)=>"oct" === e.kty && "string" == typeof e.k)(t) && $414e231c569bbbbf$var$Vo(e, t, n)) return;
                        throw new TypeError('JSON Web Key for symmetric algorithms must have JWK "kty" (Key Type) equal to "oct" and the JWK "k" (Key Value) present');
                    }
                    if (!$414e231c569bbbbf$var$Io(t)) throw new TypeError($414e231c569bbbbf$var$To(e, t, "CryptoKey", "KeyObject", "JSON Web Key", "Uint8Array"));
                    if ("secret" !== t.type) throw new TypeError("".concat($414e231c569bbbbf$var$Jo(t), ' instances for symmetric algorithms must be of type "secret"'));
                }
            })(e, t, n);
            break;
        default:
            ((e, t, n)=>{
                if ($414e231c569bbbbf$var$Wo(t)) switch(n){
                    case "decrypt":
                    case "sign":
                        if (((e)=>"oct" !== e.kty && ("AKP" === e.kty && "string" == typeof e.priv || "string" == typeof e.d))(t) && $414e231c569bbbbf$var$Vo(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a private JWK");
                    case "encrypt":
                    case "verify":
                        if (((e)=>"oct" !== e.kty && void 0 === e.d && void 0 === e.priv)(t) && $414e231c569bbbbf$var$Vo(e, t, n)) return;
                        throw new TypeError("JSON Web Key for this operation must be a public JWK");
                }
                if (!$414e231c569bbbbf$var$Io(t)) throw new TypeError($414e231c569bbbbf$var$To(e, t, "CryptoKey", "KeyObject", "JSON Web Key"));
                if ("secret" === t.type) throw new TypeError("".concat($414e231c569bbbbf$var$Jo(t), ' instances for asymmetric algorithms must not be of type "secret"'));
                if ("public" === t.type) switch(n){
                    case "sign":
                        throw new TypeError("".concat($414e231c569bbbbf$var$Jo(t), ' instances for asymmetric algorithm signing must be of type "private"'));
                    case "decrypt":
                        throw new TypeError("".concat($414e231c569bbbbf$var$Jo(t), ' instances for asymmetric algorithm decryption must be of type "private"'));
                }
                if ("private" === t.type) switch(n){
                    case "verify":
                        throw new TypeError("".concat($414e231c569bbbbf$var$Jo(t), ' instances for asymmetric algorithm verifying must be of type "public"'));
                    case "encrypt":
                        throw new TypeError("".concat($414e231c569bbbbf$var$Jo(t), ' instances for asymmetric algorithm encryption must be of type "public"'));
                }
            })(e, t, n);
    }
}
var $414e231c569bbbbf$var$Go, $414e231c569bbbbf$var$Zo;
let $414e231c569bbbbf$var$qo, $414e231c569bbbbf$var$Bo;
if ("undefined" == typeof navigator || null === ($414e231c569bbbbf$var$Go = navigator.userAgent) || void 0 === $414e231c569bbbbf$var$Go || null === ($414e231c569bbbbf$var$Zo = $414e231c569bbbbf$var$Go.startsWith) || void 0 === $414e231c569bbbbf$var$Zo || !$414e231c569bbbbf$var$Zo.call($414e231c569bbbbf$var$Go, "Mozilla/5.0 ")) {
    const e = "v6.8.1";
    $414e231c569bbbbf$var$Bo = "".concat("openid-client", "/").concat(e), $414e231c569bbbbf$var$qo = {
        "user-agent": $414e231c569bbbbf$var$Bo
    };
}
const $414e231c569bbbbf$var$Xo = (e)=>$414e231c569bbbbf$var$Yo.get(e);
let $414e231c569bbbbf$var$Yo, $414e231c569bbbbf$var$Qo;
function $414e231c569bbbbf$var$$o(e) {
    return void 0 !== e ? $414e231c569bbbbf$var$Yt(e) : ($414e231c569bbbbf$var$Qo || ($414e231c569bbbbf$var$Qo = new WeakMap), (e, t, n, o)=>{
        let r;
        return (r = $414e231c569bbbbf$var$Qo.get(t)) || (!function(e, t) {
            if ("string" != typeof e) throw $414e231c569bbbbf$var$or("".concat(t, " must be a string"), $414e231c569bbbbf$var$nr);
            if (0 === e.length) throw $414e231c569bbbbf$var$or("".concat(t, " must not be empty"), $414e231c569bbbbf$var$tr);
        }(t.client_secret, '"metadata.client_secret"'), r = $414e231c569bbbbf$var$Yt(t.client_secret), $414e231c569bbbbf$var$Qo.set(t, r)), r(e, t, n, o);
    });
}
const $414e231c569bbbbf$var$er = $414e231c569bbbbf$var$St, $414e231c569bbbbf$var$tr = "ERR_INVALID_ARG_VALUE", $414e231c569bbbbf$var$nr = "ERR_INVALID_ARG_TYPE";
function $414e231c569bbbbf$var$or(e, t, n) {
    const o = new TypeError(e, {
        cause: n
    });
    return Object.assign(o, {
        code: t
    }), o;
}
function $414e231c569bbbbf$var$rr(e) {
    return async function(e) {
        return $414e231c569bbbbf$var$Mt(e, "codeVerifier"), $414e231c569bbbbf$var$xt(await crypto.subtle.digest("SHA-256", $414e231c569bbbbf$var$Rt(e)));
    }(e);
}
function $414e231c569bbbbf$var$ir() {
    return $414e231c569bbbbf$var$Vt();
}
class $414e231c569bbbbf$var$ar extends Error {
    constructor(e, t){
        var n;
        super(e, t), $414e231c569bbbbf$var$ut(this, "code", void 0), this.name = this.constructor.name, this.code = null == t ? void 0 : t.code, null === (n = Error.captureStackTrace) || void 0 === n || n.call(Error, this, this.constructor);
    }
}
function $414e231c569bbbbf$var$sr(e, t, n) {
    return new $414e231c569bbbbf$var$ar(e, {
        cause: t,
        code: n
    });
}
function $414e231c569bbbbf$var$cr(e) {
    if (e instanceof TypeError || e instanceof $414e231c569bbbbf$var$ar || e instanceof $414e231c569bbbbf$var$on || e instanceof $414e231c569bbbbf$var$rn || e instanceof $414e231c569bbbbf$var$an) throw e;
    if (e instanceof $414e231c569bbbbf$var$jt) switch(e.code){
        case $414e231c569bbbbf$var$Nn:
            throw $414e231c569bbbbf$var$sr("only requests to HTTPS are allowed", e, e.code);
        case $414e231c569bbbbf$var$Wn:
            throw $414e231c569bbbbf$var$sr("only requests to HTTP or HTTPS are allowed", e, e.code);
        case $414e231c569bbbbf$var$Un:
            throw $414e231c569bbbbf$var$sr("unexpected HTTP response status code", e.cause, e.code);
        case $414e231c569bbbbf$var$Ln:
            throw $414e231c569bbbbf$var$sr("unexpected response content-type", e.cause, e.code);
        case $414e231c569bbbbf$var$Dn:
            throw $414e231c569bbbbf$var$sr("parsing error occured", e, e.code);
        case $414e231c569bbbbf$var$Kn:
            throw $414e231c569bbbbf$var$sr("invalid response encountered", e, e.code);
        case $414e231c569bbbbf$var$Hn:
            throw $414e231c569bbbbf$var$sr("unexpected JWT claim value encountered", e, e.code);
        case $414e231c569bbbbf$var$Mn:
            throw $414e231c569bbbbf$var$sr("unexpected JSON attribute value encountered", e, e.code);
        case $414e231c569bbbbf$var$zn:
            throw $414e231c569bbbbf$var$sr("JWT timestamp claim value failed validation", e, e.code);
        default:
            throw $414e231c569bbbbf$var$sr(e.message, e, e.code);
    }
    if (e instanceof $414e231c569bbbbf$var$Ct) throw $414e231c569bbbbf$var$sr("unsupported operation", e, e.code);
    if (e instanceof DOMException) switch(e.name){
        case "OperationError":
            throw $414e231c569bbbbf$var$sr("runtime operation error", e, $414e231c569bbbbf$var$Cn);
        case "NotSupportedError":
            throw $414e231c569bbbbf$var$sr("runtime unsupported operation", e, $414e231c569bbbbf$var$Cn);
        case "TimeoutError":
            throw $414e231c569bbbbf$var$sr("operation timed out", e, "OAUTH_TIMEOUT");
        case "AbortError":
            throw $414e231c569bbbbf$var$sr("operation aborted", e, "OAUTH_ABORT");
    }
    throw new $414e231c569bbbbf$var$ar("something went wrong", {
        cause: e
    });
}
async function $414e231c569bbbbf$var$ur(e, t, n, o, r) {
    const i = await async function(e, t) {
        var n, o;
        if (!(e instanceof URL)) throw $414e231c569bbbbf$var$or('"server" must be an instance of URL', $414e231c569bbbbf$var$nr);
        const r = !e.href.includes("/.well-known/"), i = null !== (n = null == t ? void 0 : t.timeout) && void 0 !== n ? n : 30, a = AbortSignal.timeout(1e3 * i), s = await (r ? $414e231c569bbbbf$var$zt(e, {
            algorithm: null == t ? void 0 : t.algorithm,
            [$414e231c569bbbbf$var$St]: null == t ? void 0 : t[$414e231c569bbbbf$var$er],
            [$414e231c569bbbbf$var$bt]: null == t || null === (o = t.execute) || void 0 === o ? void 0 : o.includes($414e231c569bbbbf$var$wr),
            signal: a,
            headers: new Headers($414e231c569bbbbf$var$qo)
        }) : ((null == t ? void 0 : t[$414e231c569bbbbf$var$er]) || fetch)(($414e231c569bbbbf$var$en(e, null == t || null === (c = t.execute) || void 0 === c || !c.includes($414e231c569bbbbf$var$wr)), e.href), {
            headers: Object.fromEntries(new Headers($414e231c569bbbbf$var$dt({
                accept: "application/json"
            }, $414e231c569bbbbf$var$qo)).entries()),
            body: void 0,
            method: "GET",
            redirect: "manual",
            signal: a
        })).then((e)=>(async function(e, t) {
                const n = e;
                if (!(n instanceof URL) && n !== $414e231c569bbbbf$var$to) throw $414e231c569bbbbf$var$vt('"expectedIssuerIdentifier" must be an instance of URL', "ERR_INVALID_ARG_TYPE");
                if (!$414e231c569bbbbf$var$gt(t, Response)) throw $414e231c569bbbbf$var$vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
                if (200 !== t.status) throw $414e231c569bbbbf$var$Dt('"response" is not a conform Authorization Server Metadata response (unexpected HTTP status code)', $414e231c569bbbbf$var$Un, t);
                $414e231c569bbbbf$var$Fn(t);
                const o = await $414e231c569bbbbf$var$eo(t);
                if ($414e231c569bbbbf$var$Mt(o.issuer, '"response" body "issuer" property', $414e231c569bbbbf$var$Kn, {
                    body: o
                }), n !== $414e231c569bbbbf$var$to && new URL(o.issuer).href !== n.href) throw $414e231c569bbbbf$var$Dt('"response" body "issuer" property does not match the expected value', $414e231c569bbbbf$var$Mn, {
                    expected: n.href,
                    body: o,
                    attribute: "issuer"
                });
                return o;
            })($414e231c569bbbbf$var$to, e)).catch($414e231c569bbbbf$var$cr);
        var c;
        r && new URL(s.issuer).href !== e.href && (function(e, t, n) {
            return !("https://login.microsoftonline.com" !== e.origin || null != n && n.algorithm && "oidc" !== n.algorithm || (t[$414e231c569bbbbf$var$lr] = !0, 0));
        }(e, s, t) || function(e, t) {
            return !(!e.hostname.endsWith(".b2clogin.com") || null != t && t.algorithm && "oidc" !== t.algorithm);
        }(e, t) || (()=>{
            throw new $414e231c569bbbbf$var$ar("discovered metadata issuer does not match the expected issuer", {
                code: $414e231c569bbbbf$var$Mn,
                cause: {
                    expected: e.href,
                    body: s,
                    attribute: "issuer"
                }
            });
        })());
        return s;
    }(e, r), a = new $414e231c569bbbbf$var$dr(i, t, n, o);
    let s = $414e231c569bbbbf$var$Xo(a);
    if (null != r && r[$414e231c569bbbbf$var$er] && (s.fetch = r[$414e231c569bbbbf$var$er]), null != r && r.timeout && (s.timeout = r.timeout), null != r && r.execute) for (const e of r.execute)e(a);
    return a;
}
new TextDecoder;
const $414e231c569bbbbf$var$lr = Symbol();
class $414e231c569bbbbf$var$dr {
    constructor(e, t, n, o){
        var r, i, a, s, c;
        if ("string" != typeof t || !t.length) throw $414e231c569bbbbf$var$or('"clientId" must be a non-empty string', $414e231c569bbbbf$var$nr);
        if ("string" == typeof n && (n = {
            client_secret: n
        }), void 0 !== (null === (r = n) || void 0 === r ? void 0 : r.client_id) && t !== n.client_id) throw $414e231c569bbbbf$var$or('"clientId" and "metadata.client_id" must be the same', $414e231c569bbbbf$var$tr);
        const u = $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, structuredClone(n)), {}, {
            client_id: t
        });
        let l;
        u[$414e231c569bbbbf$var$_t] = null !== (i = null === (a = n) || void 0 === a ? void 0 : a[$414e231c569bbbbf$var$_t]) && void 0 !== i ? i : 0, u[$414e231c569bbbbf$var$kt] = null !== (s = null === (c = n) || void 0 === c ? void 0 : c[$414e231c569bbbbf$var$kt]) && void 0 !== s ? s : 30, l = o || ("string" == typeof u.client_secret && u.client_secret.length ? $414e231c569bbbbf$var$$o(u.client_secret) : (e, t, n, o)=>{
            n.set("client_id", t.client_id);
        });
        let d = Object.freeze(u);
        const h = structuredClone(e);
        $414e231c569bbbbf$var$lr in e && (h[$414e231c569bbbbf$var$no] = (t)=>{
            let { claims: { tid: n } } = t;
            return e.issuer.replace("{tenantid}", n);
        });
        let p = Object.freeze(h);
        $414e231c569bbbbf$var$Yo || ($414e231c569bbbbf$var$Yo = new WeakMap), $414e231c569bbbbf$var$Yo.set(this, {
            __proto__: null,
            as: p,
            c: d,
            auth: l,
            tlsOnly: !0,
            jwksCache: {}
        });
    }
    serverMetadata() {
        const e = structuredClone($414e231c569bbbbf$var$Xo(this).as);
        return function(e) {
            Object.defineProperties(e, function(e) {
                return {
                    supportsPKCE: {
                        __proto__: null,
                        value () {
                            var t;
                            let n = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "S256";
                            return !0 === (null === (t = e.code_challenge_methods_supported) || void 0 === t ? void 0 : t.includes(n));
                        }
                    }
                };
            }(e));
        }(e), e;
    }
    clientMetadata() {
        return structuredClone($414e231c569bbbbf$var$Xo(this).c);
    }
    get timeout() {
        return $414e231c569bbbbf$var$Xo(this).timeout;
    }
    set timeout(e) {
        $414e231c569bbbbf$var$Xo(this).timeout = e;
    }
    get [$414e231c569bbbbf$var$er]() {
        return $414e231c569bbbbf$var$Xo(this).fetch;
    }
    set [$414e231c569bbbbf$var$er](e) {
        $414e231c569bbbbf$var$Xo(this).fetch = e;
    }
}
function $414e231c569bbbbf$var$hr(e) {
    Object.defineProperties(e, function(e) {
        let t;
        if (void 0 !== e.expires_in) {
            const n = new Date;
            n.setSeconds(n.getSeconds() + e.expires_in), t = n.getTime();
        }
        return {
            expiresIn: {
                __proto__: null,
                value () {
                    if (t) {
                        const e = Date.now();
                        return t > e ? Math.floor((t - e) / 1e3) : 0;
                    }
                }
            },
            claims: {
                __proto__: null,
                value () {
                    try {
                        return $414e231c569bbbbf$var$vn(this);
                    } catch (e) {
                        return;
                    }
                }
            }
        };
    }(e));
}
async function $414e231c569bbbbf$var$pr(e, t, n) {
    var o;
    let r = arguments.length > 3 && void 0 !== arguments[3] && arguments[3];
    const i = null === (o = e.headers.get("retry-after")) || void 0 === o ? void 0 : o.trim();
    if (void 0 === i) return;
    let a;
    if (/^\d+$/.test(i)) a = parseInt(i, 10);
    else {
        const e = new Date(i);
        if (Number.isFinite(e.getTime())) {
            const t = new Date, n = e.getTime() - t.getTime();
            n > 0 && (a = Math.ceil(n / 1e3));
        }
    }
    if (r && !Number.isFinite(a)) throw new $414e231c569bbbbf$var$jt("invalid Retry-After header value", {
        cause: e
    });
    a > t && await $414e231c569bbbbf$var$fr(a - t, n);
}
function $414e231c569bbbbf$var$fr(e, t) {
    return new Promise((n, o)=>{
        const r = (e)=>{
            try {
                t.throwIfAborted();
            } catch (e) {
                return void o(e);
            }
            if (e <= 0) return void n();
            const i = Math.min(e, 5);
            setTimeout(()=>r(e - i), 1e3 * i);
        };
        r(e);
    });
}
async function $414e231c569bbbbf$var$mr(e, t) {
    $414e231c569bbbbf$var$Sr(e);
    const { as: n, c: o, auth: r, fetch: i, tlsOnly: a, timeout: s } = $414e231c569bbbbf$var$Xo(e);
    return (async function(e, t, n, o, r) {
        $414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t);
        const i = $414e231c569bbbbf$var$nn(e, "backchannel_authentication_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == r ? void 0 : r[$414e231c569bbbbf$var$bt])), a = new URLSearchParams(o);
        a.set("client_id", t.client_id);
        const s = $414e231c569bbbbf$var$Ut(null == r ? void 0 : r.headers);
        return s.set("accept", "application/json"), $414e231c569bbbbf$var$mn(e, t, n, i, a, s, r);
    })(n, o, r, t, {
        [$414e231c569bbbbf$var$St]: i,
        [$414e231c569bbbbf$var$bt]: !a,
        headers: new Headers($414e231c569bbbbf$var$qo),
        signal: $414e231c569bbbbf$var$Er(s)
    }).then((e)=>(async function(e, t, n) {
            if ($414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), !$414e231c569bbbbf$var$gt(n, Response)) throw $414e231c569bbbbf$var$vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
            await $414e231c569bbbbf$var$hn(n, 200, "Backchannel Authentication Endpoint"), $414e231c569bbbbf$var$Fn(n);
            const o = await $414e231c569bbbbf$var$eo(n);
            $414e231c569bbbbf$var$Mt(o.auth_req_id, '"response" body "auth_req_id" property', $414e231c569bbbbf$var$Kn, {
                body: o
            });
            let r = "number" != typeof o.expires_in ? parseFloat(o.expires_in) : o.expires_in;
            return $414e231c569bbbbf$var$Ht(r, !0, '"response" body "expires_in" property', $414e231c569bbbbf$var$Kn, {
                body: o
            }), o.expires_in = r, void 0 !== o.interval && $414e231c569bbbbf$var$Ht(o.interval, !1, '"response" body "interval" property', $414e231c569bbbbf$var$Kn, {
                body: o
            }), o;
        })(n, o, e)).catch($414e231c569bbbbf$var$cr);
}
async function $414e231c569bbbbf$var$yr(e, t, n, o) {
    var r, i;
    $414e231c569bbbbf$var$Sr(e), n = new URLSearchParams(n);
    let a = null !== (r = t.interval) && void 0 !== r ? r : 5;
    const s = null !== (i = null == o ? void 0 : o.signal) && void 0 !== i ? i : AbortSignal.timeout(1e3 * t.expires_in);
    try {
        await $414e231c569bbbbf$var$fr(a, s);
    } catch (e) {
        $414e231c569bbbbf$var$cr(e);
    }
    const { as: c, c: u, auth: l, fetch: d, tlsOnly: h, nonRepudiation: p, timeout: f, decrypt: m } = $414e231c569bbbbf$var$Xo(e), y = (r, i)=>$414e231c569bbbbf$var$yr(e, $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, t), {}, {
            interval: r
        }), n, $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, o), {}, {
            signal: s,
            flag: i
        })), w = await (async function(e, t, n, o, r) {
        $414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), $414e231c569bbbbf$var$Mt(o, '"authReqId"');
        const i = new URLSearchParams(null == r ? void 0 : r.additionalParameters);
        return i.set("auth_req_id", o), $414e231c569bbbbf$var$yn(e, t, n, "urn:openid:params:grant-type:ciba", i, r);
    })(c, u, l, t.auth_req_id, {
        [$414e231c569bbbbf$var$St]: d,
        [$414e231c569bbbbf$var$bt]: !h,
        additionalParameters: n,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($414e231c569bbbbf$var$qo),
        signal: s.aborted ? s : $414e231c569bbbbf$var$Er(f)
    }).catch($414e231c569bbbbf$var$cr);
    var g;
    if (503 === w.status && w.headers.has("retry-after")) return await $414e231c569bbbbf$var$pr(w, a, s, !0), await (null === (g = w.body) || void 0 === g ? void 0 : g.cancel()), y(a);
    const v = async function(e, t, n, o) {
        return $414e231c569bbbbf$var$bn(e, t, n, void 0, null == o ? void 0 : o[$414e231c569bbbbf$var$At], null == o ? void 0 : o.recognizedTokenTypes);
    }(c, u, w, {
        [$414e231c569bbbbf$var$At]: m
    });
    let b;
    try {
        b = await v;
    } catch (e) {
        if ($414e231c569bbbbf$var$Ar(e, o)) return y(a, $414e231c569bbbbf$var$Tr);
        if (e instanceof $414e231c569bbbbf$var$on) switch(e.error){
            case "slow_down":
                a += 5;
            case "authorization_pending":
                return await $414e231c569bbbbf$var$pr(e.response, a, s), y(a);
        }
        $414e231c569bbbbf$var$cr(e);
    }
    return b.id_token && await (null == p ? void 0 : p(w)), $414e231c569bbbbf$var$hr(b), b;
}
function $414e231c569bbbbf$var$wr(e) {
    $414e231c569bbbbf$var$Xo(e).tlsOnly = !1;
}
async function $414e231c569bbbbf$var$gr(e, t, n, o, r) {
    if ($414e231c569bbbbf$var$Sr(e), !((null == r ? void 0 : r.flag) === $414e231c569bbbbf$var$Tr || t instanceof URL || function(e, t) {
        try {
            return Object.getPrototypeOf(e)[Symbol.toStringTag] === t;
        } catch (e) {
            return !1;
        }
    }(t, "Request"))) throw $414e231c569bbbbf$var$or('"currentUrl" must be an instance of URL, or Request', $414e231c569bbbbf$var$nr);
    let i, a;
    const { as: s, c: c, auth: u, fetch: l, tlsOnly: d, jarm: h, hybrid: p, nonRepudiation: f, timeout: m, decrypt: y, implicit: w } = $414e231c569bbbbf$var$Xo(e);
    if ((null == r ? void 0 : r.flag) === $414e231c569bbbbf$var$Tr) i = r.authResponse, a = r.redirectUri;
    else {
        if (!(t instanceof URL)) {
            const e = t;
            switch(t = new URL(t.url), e.method){
                case "GET":
                    break;
                case "POST":
                    const n = new URLSearchParams(await $414e231c569bbbbf$var$qn(e));
                    if (p) t.hash = n.toString();
                    else for (const [e, o] of n.entries())t.searchParams.append(e, o);
                    break;
                default:
                    throw $414e231c569bbbbf$var$or("unexpected Request HTTP method", $414e231c569bbbbf$var$tr);
            }
        }
        switch(a = function(e) {
            return (e = new URL(e)).search = "", e.hash = "", e.href;
        }(t), !0){
            case !!h:
                i = await h(t, null == n ? void 0 : n.expectedState);
                break;
            case !!p:
                i = await p(t, null == n ? void 0 : n.expectedNonce, null == n ? void 0 : n.expectedState, null == n ? void 0 : n.maxAge);
                break;
            case !!w:
                throw new TypeError("authorizationCodeGrant() cannot be used by response_type=id_token clients");
            default:
                try {
                    i = $414e231c569bbbbf$var$$n(s, c, t.searchParams, null == n ? void 0 : n.expectedState);
                } catch (e) {
                    $414e231c569bbbbf$var$cr(e);
                }
        }
    }
    const g = await (async function(e, t, n, o, r, i, a) {
        if ($414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), !$414e231c569bbbbf$var$Sn.has(o)) throw $414e231c569bbbbf$var$vt('"callbackParameters" must be an instance of URLSearchParams obtained from "validateAuthResponse()", or "validateJwtAuthResponse()', "ERR_INVALID_ARG_VALUE");
        $414e231c569bbbbf$var$Mt(r, '"redirectUri"');
        const s = $414e231c569bbbbf$var$Xn(o, "code");
        if (!s) throw $414e231c569bbbbf$var$Dt('no authorization code in "callbackParameters"', $414e231c569bbbbf$var$Kn);
        const c = new URLSearchParams(null == a ? void 0 : a.additionalParameters);
        return c.set("redirect_uri", r), c.set("code", s), i !== $414e231c569bbbbf$var$En && ($414e231c569bbbbf$var$Mt(i, '"codeVerifier"'), c.set("code_verifier", i)), $414e231c569bbbbf$var$yn(e, t, n, "authorization_code", c, a);
    })(s, c, u, i, a, (null == n ? void 0 : n.pkceCodeVerifier) || $414e231c569bbbbf$var$En, {
        additionalParameters: o,
        [$414e231c569bbbbf$var$St]: l,
        [$414e231c569bbbbf$var$bt]: !d,
        DPoP: null == r ? void 0 : r.DPoP,
        headers: new Headers($414e231c569bbbbf$var$qo),
        signal: $414e231c569bbbbf$var$Er(m)
    }).catch($414e231c569bbbbf$var$cr);
    "string" != typeof (null == n ? void 0 : n.expectedNonce) && "number" != typeof (null == n ? void 0 : n.maxAge) || (n.idTokenExpected = !0);
    const v = $414e231c569bbbbf$var$In(s, c, g, {
        expectedNonce: null == n ? void 0 : n.expectedNonce,
        maxAge: null == n ? void 0 : n.maxAge,
        requireIdToken: null == n ? void 0 : n.idTokenExpected,
        [$414e231c569bbbbf$var$At]: y
    });
    let b;
    try {
        b = await v;
    } catch (t) {
        if ($414e231c569bbbbf$var$Ar(t, r)) return $414e231c569bbbbf$var$gr(e, void 0, n, o, $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, r), {}, {
            flag: $414e231c569bbbbf$var$Tr,
            authResponse: i,
            redirectUri: a
        }));
        $414e231c569bbbbf$var$cr(t);
    }
    return b.id_token && await (null == f ? void 0 : f(g)), $414e231c569bbbbf$var$hr(b), b;
}
async function $414e231c569bbbbf$var$vr(e, t, n, o) {
    $414e231c569bbbbf$var$Sr(e), n = new URLSearchParams(n);
    const { as: r, c: i, auth: a, fetch: s, tlsOnly: c, nonRepudiation: u, timeout: l, decrypt: d } = $414e231c569bbbbf$var$Xo(e), h = await (async function(e, t, n, o, r) {
        $414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), $414e231c569bbbbf$var$Mt(o, '"refreshToken"');
        const i = new URLSearchParams(null == r ? void 0 : r.additionalParameters);
        return i.set("refresh_token", o), $414e231c569bbbbf$var$yn(e, t, n, "refresh_token", i, r);
    })(r, i, a, t, {
        [$414e231c569bbbbf$var$St]: s,
        [$414e231c569bbbbf$var$bt]: !c,
        additionalParameters: n,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($414e231c569bbbbf$var$qo),
        signal: $414e231c569bbbbf$var$Er(l)
    }).catch($414e231c569bbbbf$var$cr), p = async function(e, t, n, o) {
        return $414e231c569bbbbf$var$bn(e, t, n, void 0, null == o ? void 0 : o[$414e231c569bbbbf$var$At], null == o ? void 0 : o.recognizedTokenTypes);
    }(r, i, h, {
        [$414e231c569bbbbf$var$At]: d
    });
    let f;
    try {
        f = await p;
    } catch (r) {
        if ($414e231c569bbbbf$var$Ar(r, o)) return $414e231c569bbbbf$var$vr(e, t, n, $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, o), {}, {
            flag: $414e231c569bbbbf$var$Tr
        }));
        $414e231c569bbbbf$var$cr(r);
    }
    return f.id_token && await (null == u ? void 0 : u(h)), $414e231c569bbbbf$var$hr(f), f;
}
async function $414e231c569bbbbf$var$br(e, t, n) {
    $414e231c569bbbbf$var$Sr(e), t = new URLSearchParams(t);
    const { as: o, c: r, auth: i, fetch: a, tlsOnly: s, timeout: c } = $414e231c569bbbbf$var$Xo(e), u = await (async function(e, t, n, o, r) {
        return $414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), $414e231c569bbbbf$var$yn(e, t, n, "client_credentials", new URLSearchParams(o), r);
    })(o, r, i, t, {
        [$414e231c569bbbbf$var$St]: a,
        [$414e231c569bbbbf$var$bt]: !s,
        DPoP: null == n ? void 0 : n.DPoP,
        headers: new Headers($414e231c569bbbbf$var$qo),
        signal: $414e231c569bbbbf$var$Er(c)
    }).catch($414e231c569bbbbf$var$cr), l = async function(e, t, n, o) {
        return $414e231c569bbbbf$var$bn(e, t, n, void 0, null == o ? void 0 : o[$414e231c569bbbbf$var$At], null == o ? void 0 : o.recognizedTokenTypes);
    }(o, r, u);
    let d;
    try {
        d = await l;
    } catch (o) {
        if ($414e231c569bbbbf$var$Ar(o, n)) return $414e231c569bbbbf$var$br(e, t, $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, n), {}, {
            flag: $414e231c569bbbbf$var$Tr
        }));
        $414e231c569bbbbf$var$cr(o);
    }
    return $414e231c569bbbbf$var$hr(d), d;
}
function $414e231c569bbbbf$var$_r(e, t) {
    $414e231c569bbbbf$var$Sr(e);
    const { as: n, c: o, tlsOnly: r, hybrid: i, jarm: a, implicit: s } = $414e231c569bbbbf$var$Xo(e), c = $414e231c569bbbbf$var$nn(n, "authorization_endpoint", !1, r);
    if ((t = new URLSearchParams(t)).has("client_id") || t.set("client_id", o.client_id), !t.has("request_uri") && !t.has("request")) {
        if (t.has("response_type") || t.set("response_type", i ? "code id_token" : s ? "id_token" : "code"), s && !t.has("nonce")) throw $414e231c569bbbbf$var$or("response_type=id_token clients must provide a nonce parameter in their authorization request parameters", $414e231c569bbbbf$var$tr);
        a && t.set("response_mode", "jwt");
    }
    for (const [e, n] of t.entries())c.searchParams.append(e, n);
    return c;
}
async function $414e231c569bbbbf$var$kr(e, t, n) {
    $414e231c569bbbbf$var$Sr(e);
    const o = $414e231c569bbbbf$var$_r(e, t), { as: r, c: i, auth: a, fetch: s, tlsOnly: c, timeout: u } = $414e231c569bbbbf$var$Xo(e), l = await (async function(e, t, n, o, r) {
        var i;
        $414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t);
        const a = $414e231c569bbbbf$var$nn(e, "pushed_authorization_request_endpoint", t.use_mtls_endpoint_aliases, !0 !== (null == r ? void 0 : r[$414e231c569bbbbf$var$bt])), s = new URLSearchParams(o);
        s.set("client_id", t.client_id);
        const c = $414e231c569bbbbf$var$Ut(null == r ? void 0 : r.headers);
        c.set("accept", "application/json"), void 0 !== (null == r ? void 0 : r.DPoP) && ($414e231c569bbbbf$var$pn(r.DPoP), await r.DPoP.addProof(a, c, "POST"));
        const u = await $414e231c569bbbbf$var$mn(e, t, n, a, s, c, r);
        return null == r || null === (i = r.DPoP) || void 0 === i || i.cacheNonce(u, a), u;
    })(r, i, a, o.searchParams, {
        [$414e231c569bbbbf$var$St]: s,
        [$414e231c569bbbbf$var$bt]: !c,
        DPoP: null == n ? void 0 : n.DPoP,
        headers: new Headers($414e231c569bbbbf$var$qo),
        signal: $414e231c569bbbbf$var$Er(u)
    }).catch($414e231c569bbbbf$var$cr), d = async function(e, t, n) {
        if ($414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), !$414e231c569bbbbf$var$gt(n, Response)) throw $414e231c569bbbbf$var$vt('"response" must be an instance of Response', "ERR_INVALID_ARG_TYPE");
        await $414e231c569bbbbf$var$hn(n, 201, "Pushed Authorization Request Endpoint"), $414e231c569bbbbf$var$Fn(n);
        const o = await $414e231c569bbbbf$var$eo(n);
        $414e231c569bbbbf$var$Mt(o.request_uri, '"response" body "request_uri" property', $414e231c569bbbbf$var$Kn, {
            body: o
        });
        let r = "number" != typeof o.expires_in ? parseFloat(o.expires_in) : o.expires_in;
        return $414e231c569bbbbf$var$Ht(r, !0, '"response" body "expires_in" property', $414e231c569bbbbf$var$Kn, {
            body: o
        }), o.expires_in = r, o;
    }(r, i, l);
    let h;
    try {
        h = await d;
    } catch (o) {
        if ($414e231c569bbbbf$var$Ar(o, n)) return $414e231c569bbbbf$var$kr(e, t, $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, n), {}, {
            flag: $414e231c569bbbbf$var$Tr
        }));
        $414e231c569bbbbf$var$cr(o);
    }
    return $414e231c569bbbbf$var$_r(e, {
        request_uri: h.request_uri
    });
}
function $414e231c569bbbbf$var$Sr(e) {
    if (!(e instanceof $414e231c569bbbbf$var$dr)) throw $414e231c569bbbbf$var$or('"config" must be an instance of Configuration', $414e231c569bbbbf$var$nr);
    if (Object.getPrototypeOf(e) !== $414e231c569bbbbf$var$dr.prototype) throw $414e231c569bbbbf$var$or("subclassing Configuration is not allowed", $414e231c569bbbbf$var$tr);
}
function $414e231c569bbbbf$var$Er(e) {
    return e ? AbortSignal.timeout(1e3 * e) : void 0;
}
function $414e231c569bbbbf$var$Ar(e, t) {
    return !(null == t || !t.DPoP || t.flag === $414e231c569bbbbf$var$Tr) && function(e) {
        if (e instanceof $414e231c569bbbbf$var$an) {
            const { 0: t, length: n } = e.cause;
            return 1 === n && "dpop" === t.scheme && "use_dpop_nonce" === t.parameters.error;
        }
        return e instanceof $414e231c569bbbbf$var$on && "use_dpop_nonce" === e.error;
    }(e);
}
Object.freeze($414e231c569bbbbf$var$dr.prototype);
const $414e231c569bbbbf$var$Tr = Symbol();
async function $414e231c569bbbbf$var$Pr(e, t, n, o) {
    $414e231c569bbbbf$var$Sr(e);
    const { as: r, c: i, auth: a, fetch: s, tlsOnly: c, timeout: u, decrypt: l } = $414e231c569bbbbf$var$Xo(e), d = await (async function(e, t, n, o, r, i) {
        return $414e231c569bbbbf$var$Bt(e), $414e231c569bbbbf$var$Xt(t), $414e231c569bbbbf$var$Mt(o, '"grantType"'), $414e231c569bbbbf$var$yn(e, t, n, o, new URLSearchParams(r), i);
    })(r, i, a, t, new URLSearchParams(n), {
        [$414e231c569bbbbf$var$St]: s,
        [$414e231c569bbbbf$var$bt]: !c,
        DPoP: null == o ? void 0 : o.DPoP,
        headers: new Headers($414e231c569bbbbf$var$qo),
        signal: $414e231c569bbbbf$var$Er(u)
    }).then((e)=>{
        let n;
        return "urn:ietf:params:oauth:grant-type:token-exchange" === t && (n = {
            n_a: ()=>{}
        }), async function(e, t, n, o) {
            return $414e231c569bbbbf$var$bn(e, t, n, void 0, null == o ? void 0 : o[$414e231c569bbbbf$var$At], null == o ? void 0 : o.recognizedTokenTypes);
        }(r, i, e, {
            [$414e231c569bbbbf$var$At]: l,
            recognizedTokenTypes: n
        });
    }).catch($414e231c569bbbbf$var$cr);
    return $414e231c569bbbbf$var$hr(d), d;
}
async function $414e231c569bbbbf$var$Rr(e, t, n) {
    if (t instanceof Uint8Array) {
        if (!e.startsWith("HS")) throw new TypeError(function(e) {
            for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
            return $414e231c569bbbbf$var$Ao("Key must be ", e, ...n);
        }(t, "CryptoKey", "KeyObject", "JSON Web Key"));
        return crypto.subtle.importKey("raw", t, {
            hash: "SHA-".concat(e.slice(-3)),
            name: "HMAC"
        }, !1, [
            n
        ]);
    }
    return $414e231c569bbbbf$var$Eo(t, e, n), t;
}
async function $414e231c569bbbbf$var$Ir(e, t, n, o) {
    const r = await $414e231c569bbbbf$var$Rr(e, t, "verify");
    !function(e, t) {
        if (e.startsWith("RS") || e.startsWith("PS")) {
            const { modulusLength: n } = t.algorithm;
            if ("number" != typeof n || n < 2048) throw new TypeError("".concat(e, " requires key modulusLength to be 2048 bits or larger"));
        }
    }(e, r);
    const i = function(e, t) {
        const n = "SHA-".concat(e.slice(-3));
        switch(e){
            case "HS256":
            case "HS384":
            case "HS512":
                return {
                    hash: n,
                    name: "HMAC"
                };
            case "PS256":
            case "PS384":
            case "PS512":
                return {
                    hash: n,
                    name: "RSA-PSS",
                    saltLength: parseInt(e.slice(-3), 10) >> 3
                };
            case "RS256":
            case "RS384":
            case "RS512":
                return {
                    hash: n,
                    name: "RSASSA-PKCS1-v1_5"
                };
            case "ES256":
            case "ES384":
            case "ES512":
                return {
                    hash: n,
                    name: "ECDSA",
                    namedCurve: t.namedCurve
                };
            case "Ed25519":
            case "EdDSA":
                return {
                    name: "Ed25519"
                };
            case "ML-DSA-44":
            case "ML-DSA-65":
            case "ML-DSA-87":
                return {
                    name: e
                };
            default:
                throw new $414e231c569bbbbf$var$po("alg ".concat(e, " is not supported either by JOSE or your javascript runtime"));
        }
    }(e, r.algorithm);
    try {
        return await crypto.subtle.verify(i, r, n, o);
    } catch (e) {
        return !1;
    }
}
async function $414e231c569bbbbf$var$Or(e, t, n) {
    if (!$414e231c569bbbbf$var$Oo(e)) throw new $414e231c569bbbbf$var$fo("Flattened JWS must be an object");
    if (void 0 === e.protected && void 0 === e.header) throw new $414e231c569bbbbf$var$fo('Flattened JWS must have either of the "protected" or "header" members');
    if (void 0 !== e.protected && "string" != typeof e.protected) throw new $414e231c569bbbbf$var$fo("JWS Protected Header incorrect type");
    if (void 0 === e.payload) throw new $414e231c569bbbbf$var$fo("JWS Payload missing");
    if ("string" != typeof e.signature) throw new $414e231c569bbbbf$var$fo("JWS Signature missing or incorrect type");
    if (void 0 !== e.header && !$414e231c569bbbbf$var$Oo(e.header)) throw new $414e231c569bbbbf$var$fo("JWS Unprotected Header incorrect type");
    let o = {};
    if (e.protected) try {
        const t = $414e231c569bbbbf$var$so(e.protected);
        o = JSON.parse($414e231c569bbbbf$var$ro.decode(t));
    } catch (e) {
        throw new $414e231c569bbbbf$var$fo("JWS Protected Header is invalid");
    }
    if (!function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        const o = t.filter(Boolean);
        if (0 === o.length || 1 === o.length) return !0;
        let r;
        for (const e of o){
            const t = Object.keys(e);
            if (r && 0 !== r.size) for (const e of t){
                if (r.has(e)) return !1;
                r.add(e);
            }
            else r = new Set(t);
        }
        return !0;
    }(o, e.header)) throw new $414e231c569bbbbf$var$fo("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const r = $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, o), e.header), i = function(e, t, n, o, r) {
        if (void 0 !== r.crit && void 0 === (null == o ? void 0 : o.crit)) throw new e('"crit" (Critical) Header Parameter MUST be integrity protected');
        if (!o || void 0 === o.crit) return new Set;
        if (!Array.isArray(o.crit) || 0 === o.crit.length || o.crit.some((e)=>"string" != typeof e || 0 === e.length)) throw new e('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
        let i;
        i = void 0 !== n ? new Map([
            ...Object.entries(n),
            ...t.entries()
        ]) : t;
        for (const t of o.crit){
            if (!i.has(t)) throw new $414e231c569bbbbf$var$po('Extension Header Parameter "'.concat(t, '" is not recognized'));
            if (void 0 === r[t]) throw new e('Extension Header Parameter "'.concat(t, '" is missing'));
            if (i.get(t) && void 0 === o[t]) throw new e('Extension Header Parameter "'.concat(t, '" MUST be integrity protected'));
        }
        return new Set(o.crit);
    }($414e231c569bbbbf$var$fo, new Map([
        [
            "b64",
            !0
        ]
    ]), null == n ? void 0 : n.crit, o, r);
    let a = !0;
    if (i.has("b64") && (a = o.b64, "boolean" != typeof a)) throw new $414e231c569bbbbf$var$fo('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    const { alg: s } = r;
    if ("string" != typeof s || !s) throw new $414e231c569bbbbf$var$fo('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const c = n && function(e, t) {
        if (void 0 !== t && (!Array.isArray(t) || t.some((e)=>"string" != typeof e))) throw new TypeError('"'.concat(e, '" option must be an array of strings'));
        if (t) return new Set(t);
    }("algorithms", n.algorithms);
    if (c && !c.has(s)) throw new $414e231c569bbbbf$var$ho('"alg" (Algorithm) Header Parameter value not allowed');
    if (a) {
        if ("string" != typeof e.payload) throw new $414e231c569bbbbf$var$fo("JWS Payload must be a string");
    } else if ("string" != typeof e.payload && !(e.payload instanceof Uint8Array)) throw new $414e231c569bbbbf$var$fo("JWS Payload must be a string or an Uint8Array instance");
    let u = !1;
    "function" == typeof t && (t = await t(o, e), u = !0), $414e231c569bbbbf$var$Fo(s, t, "verify");
    const l = function() {
        for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
        const o = t.reduce((e, t)=>{
            let { length: n } = t;
            return e + n;
        }, 0), r = new Uint8Array(o);
        let i = 0;
        for (const e of t)r.set(e, i), i += e.length;
        return r;
    }(void 0 !== e.protected ? $414e231c569bbbbf$var$io(e.protected) : new Uint8Array, $414e231c569bbbbf$var$io("."), "string" == typeof e.payload ? a ? $414e231c569bbbbf$var$io(e.payload) : $414e231c569bbbbf$var$oo.encode(e.payload) : e.payload);
    let d;
    try {
        d = $414e231c569bbbbf$var$so(e.signature);
    } catch (e) {
        throw new $414e231c569bbbbf$var$fo("Failed to base64url decode the signature");
    }
    const h = await $414e231c569bbbbf$var$Mo(t, s);
    if (!await $414e231c569bbbbf$var$Ir(s, h, d, l)) throw new $414e231c569bbbbf$var$bo;
    let p;
    if (a) try {
        p = $414e231c569bbbbf$var$so(e.payload);
    } catch (e) {
        throw new $414e231c569bbbbf$var$fo("Failed to base64url decode the payload");
    }
    else p = "string" == typeof e.payload ? $414e231c569bbbbf$var$oo.encode(e.payload) : e.payload;
    const f = {
        payload: p
    };
    return void 0 !== e.protected && (f.protectedHeader = o), void 0 !== e.header && (f.unprotectedHeader = e.header), u ? $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, f), {}, {
        key: h
    }) : f;
}
const $414e231c569bbbbf$var$xr = (e)=>Math.floor(e.getTime() / 1e3), $414e231c569bbbbf$var$Cr = /^(\+|\-)? ?(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)(?: (ago|from now))?$/i;
function $414e231c569bbbbf$var$jr(e) {
    const t = $414e231c569bbbbf$var$Cr.exec(e);
    if (!t || t[4] && t[1]) throw new TypeError("Invalid time period format");
    const n = parseFloat(t[2]);
    let o;
    switch(t[3].toLowerCase()){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            o = Math.round(n);
            break;
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            o = Math.round(60 * n);
            break;
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            o = Math.round(3600 * n);
            break;
        case "day":
        case "days":
        case "d":
            o = Math.round(86400 * n);
            break;
        case "week":
        case "weeks":
        case "w":
            o = Math.round(604800 * n);
            break;
        default:
            o = Math.round(31557600 * n);
    }
    return "-" === t[1] || "ago" === t[4] ? -o : o;
}
const $414e231c569bbbbf$var$Dr = (e)=>e.includes("/") ? e.toLowerCase() : "application/".concat(e.toLowerCase()), $414e231c569bbbbf$var$Kr = (e, t)=>"string" == typeof e ? t.includes(e) : !!Array.isArray(e) && t.some(Set.prototype.has.bind(new Set(e)));
async function $414e231c569bbbbf$var$Lr(e, t, n) {
    var o;
    const r = await async function(e, t, n) {
        if (e instanceof Uint8Array && (e = $414e231c569bbbbf$var$ro.decode(e)), "string" != typeof e) throw new $414e231c569bbbbf$var$fo("Compact JWS must be a string or Uint8Array");
        const { 0: o, 1: r, 2: i, length: a } = e.split(".");
        if (3 !== a) throw new $414e231c569bbbbf$var$fo("Invalid Compact JWS");
        const s = await $414e231c569bbbbf$var$Or({
            payload: r,
            protected: o,
            signature: i
        }, t, n), c = {
            payload: s.payload,
            protectedHeader: s.protectedHeader
        };
        return "function" == typeof t ? $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, c), {}, {
            key: s.key
        }) : c;
    }(e, t, n);
    if (null !== (o = r.protectedHeader.crit) && void 0 !== o && o.includes("b64") && !1 === r.protectedHeader.b64) throw new $414e231c569bbbbf$var$mo("JWTs MUST NOT use unencoded payload");
    const i = function(e, t) {
        let n, o = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        try {
            n = JSON.parse($414e231c569bbbbf$var$ro.decode(t));
        } catch (e) {}
        if (!$414e231c569bbbbf$var$Oo(n)) throw new $414e231c569bbbbf$var$mo("JWT Claims Set must be a top-level JSON object");
        const { typ: r } = o;
        if (r && ("string" != typeof e.typ || $414e231c569bbbbf$var$Dr(e.typ) !== $414e231c569bbbbf$var$Dr(r))) throw new $414e231c569bbbbf$var$uo('unexpected "typ" JWT header value', n, "typ", "check_failed");
        const { requiredClaims: i = [], issuer: a, subject: s, audience: c, maxTokenAge: u } = o, l = [
            ...i
        ];
        void 0 !== u && l.push("iat"), void 0 !== c && l.push("aud"), void 0 !== s && l.push("sub"), void 0 !== a && l.push("iss");
        for (const e of new Set(l.reverse()))if (!(e in n)) throw new $414e231c569bbbbf$var$uo('missing required "'.concat(e, '" claim'), n, e, "missing");
        if (a && !(Array.isArray(a) ? a : [
            a
        ]).includes(n.iss)) throw new $414e231c569bbbbf$var$uo('unexpected "iss" claim value', n, "iss", "check_failed");
        if (s && n.sub !== s) throw new $414e231c569bbbbf$var$uo('unexpected "sub" claim value', n, "sub", "check_failed");
        if (c && !$414e231c569bbbbf$var$Kr(n.aud, "string" == typeof c ? [
            c
        ] : c)) throw new $414e231c569bbbbf$var$uo('unexpected "aud" claim value', n, "aud", "check_failed");
        let d;
        switch(typeof o.clockTolerance){
            case "string":
                d = $414e231c569bbbbf$var$jr(o.clockTolerance);
                break;
            case "number":
                d = o.clockTolerance;
                break;
            case "undefined":
                d = 0;
                break;
            default:
                throw new TypeError("Invalid clockTolerance option type");
        }
        const { currentDate: h } = o, p = $414e231c569bbbbf$var$xr(h || new Date);
        if ((void 0 !== n.iat || u) && "number" != typeof n.iat) throw new $414e231c569bbbbf$var$uo('"iat" claim must be a number', n, "iat", "invalid");
        if (void 0 !== n.nbf) {
            if ("number" != typeof n.nbf) throw new $414e231c569bbbbf$var$uo('"nbf" claim must be a number', n, "nbf", "invalid");
            if (n.nbf > p + d) throw new $414e231c569bbbbf$var$uo('"nbf" claim timestamp check failed', n, "nbf", "check_failed");
        }
        if (void 0 !== n.exp) {
            if ("number" != typeof n.exp) throw new $414e231c569bbbbf$var$uo('"exp" claim must be a number', n, "exp", "invalid");
            if (n.exp <= p - d) throw new $414e231c569bbbbf$var$lo('"exp" claim timestamp check failed', n, "exp", "check_failed");
        }
        if (u) {
            const e = p - n.iat;
            if (e - d > ("number" == typeof u ? u : $414e231c569bbbbf$var$jr(u))) throw new $414e231c569bbbbf$var$lo('"iat" claim timestamp check failed (too far in the past)', n, "iat", "check_failed");
            if (e < 0 - d) throw new $414e231c569bbbbf$var$uo('"iat" claim timestamp check failed (it should be in the past)', n, "iat", "check_failed");
        }
        return n;
    }(r.protectedHeader, r.payload, n), a = {
        payload: i,
        protectedHeader: r.protectedHeader
    };
    return "function" == typeof t ? $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, a), {}, {
        key: r.key
    }) : a;
}
function $414e231c569bbbbf$var$Ur(e) {
    return $414e231c569bbbbf$var$Oo(e);
}
var $414e231c569bbbbf$var$Nr, $414e231c569bbbbf$var$Wr, $414e231c569bbbbf$var$zr = new WeakMap, $414e231c569bbbbf$var$Hr = new WeakMap;
class $414e231c569bbbbf$var$Mr {
    constructor(e){
        if ($414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$zr, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$Hr, new WeakMap), !function(e) {
            return e && "object" == typeof e && Array.isArray(e.keys) && e.keys.every($414e231c569bbbbf$var$Ur);
        }(e)) throw new $414e231c569bbbbf$var$yo("JSON Web Key Set malformed");
        $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$zr, this, structuredClone(e));
    }
    jwks() {
        return $414e231c569bbbbf$var$at($414e231c569bbbbf$var$zr, this);
    }
    async getKey(e, t) {
        const { alg: n, kid: o } = $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, e), null == t ? void 0 : t.header), r = function(e) {
            switch("string" == typeof e && e.slice(0, 2)){
                case "RS":
                case "PS":
                    return "RSA";
                case "ES":
                    return "EC";
                case "Ed":
                    return "OKP";
                case "ML":
                    return "AKP";
                default:
                    throw new $414e231c569bbbbf$var$po('Unsupported "alg" value for a JSON Web Key Set');
            }
        }(n), i = $414e231c569bbbbf$var$at($414e231c569bbbbf$var$zr, this).keys.filter((e)=>{
            let t = r === e.kty;
            if (t && "string" == typeof o && (t = o === e.kid), !t || "string" != typeof e.alg && "AKP" !== r || (t = n === e.alg), t && "string" == typeof e.use && (t = "sig" === e.use), t && Array.isArray(e.key_ops) && (t = e.key_ops.includes("verify")), t) switch(n){
                case "ES256":
                    t = "P-256" === e.crv;
                    break;
                case "ES384":
                    t = "P-384" === e.crv;
                    break;
                case "ES512":
                    t = "P-521" === e.crv;
                    break;
                case "Ed25519":
                case "EdDSA":
                    t = "Ed25519" === e.crv;
            }
            return t;
        }), { 0: a, length: s } = i;
        if (0 === s) throw new $414e231c569bbbbf$var$wo;
        if (1 !== s) {
            const e = new $414e231c569bbbbf$var$go, t = $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Hr, this);
            throw e[Symbol.asyncIterator] = $414e231c569bbbbf$var$pt(function*() {
                for (const e of i)try {
                    yield yield $414e231c569bbbbf$var$rt($414e231c569bbbbf$var$Jr(t, e, n));
                } catch (e) {}
            }), e;
        }
        return $414e231c569bbbbf$var$Jr($414e231c569bbbbf$var$at($414e231c569bbbbf$var$Hr, this), a, n);
    }
}
async function $414e231c569bbbbf$var$Jr(e, t, n) {
    const o = e.get(t) || e.set(t, {}).get(t);
    if (void 0 === o[n]) {
        const e = await async function(e, t, n) {
            var o;
            if (!$414e231c569bbbbf$var$Oo(e)) throw new TypeError("JWK must be an object");
            let r;
            switch(null != t || (t = e.alg), null != r || (r = null !== (o = null == n ? void 0 : n.extractable) && void 0 !== o ? o : e.ext), e.kty){
                case "oct":
                    if ("string" != typeof e.k || !e.k) throw new TypeError('missing "k" (Key Value) Parameter value');
                    return $414e231c569bbbbf$var$so(e.k);
                case "RSA":
                    if ("oth" in e && void 0 !== e.oth) throw new $414e231c569bbbbf$var$po('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
                    return $414e231c569bbbbf$var$No($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, e), {}, {
                        alg: t,
                        ext: r
                    }));
                case "AKP":
                    if ("string" != typeof e.alg || !e.alg) throw new TypeError('missing "alg" (Algorithm) Parameter value');
                    if (void 0 !== t && t !== e.alg) throw new TypeError("JWK alg and alg option value mismatch");
                    return $414e231c569bbbbf$var$No($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, e), {}, {
                        ext: r
                    }));
                case "EC":
                case "OKP":
                    return $414e231c569bbbbf$var$No($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, e), {}, {
                        alg: t,
                        ext: r
                    }));
                default:
                    throw new $414e231c569bbbbf$var$po('Unsupported "kty" (Key Type) Parameter value');
            }
        }($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, t), {}, {
            ext: !0
        }), n);
        if (e instanceof Uint8Array || "public" !== e.type) throw new $414e231c569bbbbf$var$yo("JSON Web Key Set members must be public keys");
        o[n] = e;
    }
    return o[n];
}
function $414e231c569bbbbf$var$Vr(e) {
    const t = new $414e231c569bbbbf$var$Mr(e), n = async (e, n)=>t.getKey(e, n);
    return Object.defineProperties(n, {
        jwks: {
            value: ()=>structuredClone(t.jwks()),
            enumerable: !1,
            configurable: !1,
            writable: !1
        }
    }), n;
}
let $414e231c569bbbbf$var$Fr;
if ("undefined" == typeof navigator || null === ($414e231c569bbbbf$var$Nr = navigator.userAgent) || void 0 === $414e231c569bbbbf$var$Nr || null === ($414e231c569bbbbf$var$Wr = $414e231c569bbbbf$var$Nr.startsWith) || void 0 === $414e231c569bbbbf$var$Wr || !$414e231c569bbbbf$var$Wr.call($414e231c569bbbbf$var$Nr, "Mozilla/5.0 ")) {
    const e = "v6.1.3";
    $414e231c569bbbbf$var$Fr = "".concat("jose", "/").concat(e);
}
const $414e231c569bbbbf$var$Gr = Symbol();
const $414e231c569bbbbf$var$Zr = Symbol();
var $414e231c569bbbbf$var$qr = new WeakMap, $414e231c569bbbbf$var$Br = new WeakMap, $414e231c569bbbbf$var$Xr = new WeakMap, $414e231c569bbbbf$var$Yr = new WeakMap, $414e231c569bbbbf$var$Qr = new WeakMap, $414e231c569bbbbf$var$$r = new WeakMap, $414e231c569bbbbf$var$ei = new WeakMap, $414e231c569bbbbf$var$ti = new WeakMap, $414e231c569bbbbf$var$ni = new WeakMap, $414e231c569bbbbf$var$oi = new WeakMap;
class $414e231c569bbbbf$var$ri {
    constructor(e, t){
        if ($414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$qr, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$Br, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$Xr, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$Yr, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$Qr, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$$r, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$ei, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$ti, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$ni, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$oi, void 0), !(e instanceof URL)) throw new TypeError("url must be an instance of URL");
        var n, o;
        $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$qr, this, new URL(e.href)), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$Br, this, "number" == typeof (null == t ? void 0 : t.timeoutDuration) ? null == t ? void 0 : t.timeoutDuration : 5e3), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$Xr, this, "number" == typeof (null == t ? void 0 : t.cooldownDuration) ? null == t ? void 0 : t.cooldownDuration : 3e4), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$Yr, this, "number" == typeof (null == t ? void 0 : t.cacheMaxAge) ? null == t ? void 0 : t.cacheMaxAge : 6e5), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$ei, this, new Headers(null == t ? void 0 : t.headers)), $414e231c569bbbbf$var$Fr && !$414e231c569bbbbf$var$at($414e231c569bbbbf$var$ei, this).has("User-Agent") && $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ei, this).set("User-Agent", $414e231c569bbbbf$var$Fr), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ei, this).has("accept") || ($414e231c569bbbbf$var$at($414e231c569bbbbf$var$ei, this).set("accept", "application/json"), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ei, this).append("accept", "application/jwk-set+json")), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$ti, this, null == t ? void 0 : t[$414e231c569bbbbf$var$Gr]), void 0 !== (null == t ? void 0 : t[$414e231c569bbbbf$var$Zr]) && ($414e231c569bbbbf$var$ct($414e231c569bbbbf$var$oi, this, null == t ? void 0 : t[$414e231c569bbbbf$var$Zr]), n = null == t ? void 0 : t[$414e231c569bbbbf$var$Zr], o = $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Yr, this), "object" == typeof n && null !== n && "uat" in n && "number" == typeof n.uat && !(Date.now() - n.uat >= o) && "jwks" in n && $414e231c569bbbbf$var$Oo(n.jwks) && Array.isArray(n.jwks.keys) && Array.prototype.every.call(n.jwks.keys, $414e231c569bbbbf$var$Oo) && ($414e231c569bbbbf$var$ct($414e231c569bbbbf$var$Qr, this, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$oi, this).uat), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$ni, this, $414e231c569bbbbf$var$Vr($414e231c569bbbbf$var$at($414e231c569bbbbf$var$oi, this).jwks))));
    }
    pendingFetch() {
        return !!$414e231c569bbbbf$var$at($414e231c569bbbbf$var$$r, this);
    }
    coolingDown() {
        return "number" == typeof $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Qr, this) && Date.now() < $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Qr, this) + $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Xr, this);
    }
    fresh() {
        return "number" == typeof $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Qr, this) && Date.now() < $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Qr, this) + $414e231c569bbbbf$var$at($414e231c569bbbbf$var$Yr, this);
    }
    jwks() {
        var e;
        return null === (e = $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ni, this)) || void 0 === e ? void 0 : e.jwks();
    }
    async getKey(e, t) {
        $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ni, this) && this.fresh() || await this.reload();
        try {
            return await $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ni, this).call(this, e, t);
        } catch (n) {
            if (n instanceof $414e231c569bbbbf$var$wo && !1 === this.coolingDown()) return await this.reload(), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ni, this).call(this, e, t);
            throw n;
        }
    }
    async reload() {
        $414e231c569bbbbf$var$at($414e231c569bbbbf$var$$r, this) && ("undefined" != typeof WebSocketPair || "undefined" != typeof navigator && "Cloudflare-Workers" === navigator.userAgent || "undefined" != typeof EdgeRuntime && "vercel" === EdgeRuntime) && $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$$r, this, void 0), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$$r, this) || $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$$r, this, (async function(e, t, n) {
            let o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : fetch;
            const r = await o(e, {
                method: "GET",
                signal: n,
                redirect: "manual",
                headers: t
            }).catch((e)=>{
                if ("TimeoutError" === e.name) throw new $414e231c569bbbbf$var$vo;
                throw e;
            });
            if (200 !== r.status) throw new $414e231c569bbbbf$var$co("Expected 200 OK from the JSON Web Key Set HTTP response");
            try {
                return await r.json();
            } catch (e) {
                throw new $414e231c569bbbbf$var$co("Failed to parse the JSON Web Key Set HTTP response as JSON");
            }
        })($414e231c569bbbbf$var$at($414e231c569bbbbf$var$qr, this).href, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ei, this), AbortSignal.timeout($414e231c569bbbbf$var$at($414e231c569bbbbf$var$Br, this)), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ti, this)).then((e)=>{
            $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$ni, this, $414e231c569bbbbf$var$Vr(e)), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$oi, this) && ($414e231c569bbbbf$var$at($414e231c569bbbbf$var$oi, this).uat = Date.now(), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$oi, this).jwks = e), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$Qr, this, Date.now()), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$$r, this, void 0);
        }).catch((e)=>{
            throw $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$$r, this, void 0), e;
        })), await $414e231c569bbbbf$var$at($414e231c569bbbbf$var$$r, this);
    }
}
const $414e231c569bbbbf$var$ii = [
    "mfaToken"
], $414e231c569bbbbf$var$ai = [
    "mfaToken"
];
var $414e231c569bbbbf$var$si, $414e231c569bbbbf$var$ci, $414e231c569bbbbf$var$ui, $414e231c569bbbbf$var$li, $414e231c569bbbbf$var$di, $414e231c569bbbbf$var$hi, $414e231c569bbbbf$var$pi, $414e231c569bbbbf$var$fi, $414e231c569bbbbf$var$mi = class extends Error {
    constructor(e, t){
        super(t), $414e231c569bbbbf$var$ut(this, "code", void 0), this.name = "NotSupportedError", this.code = e;
    }
}, $414e231c569bbbbf$var$yi = class extends Error {
    constructor(e, t, n){
        super(t), $414e231c569bbbbf$var$ut(this, "cause", void 0), $414e231c569bbbbf$var$ut(this, "code", void 0), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
    }
}, $414e231c569bbbbf$var$wi = class extends $414e231c569bbbbf$var$yi {
    constructor(e, t){
        super("token_by_code_error", e, t), this.name = "TokenByCodeError";
    }
}, $414e231c569bbbbf$var$gi = class extends $414e231c569bbbbf$var$yi {
    constructor(e, t){
        super("token_by_client_credentials_error", e, t), this.name = "TokenByClientCredentialsError";
    }
}, $414e231c569bbbbf$var$vi = class extends $414e231c569bbbbf$var$yi {
    constructor(e, t){
        super("token_by_refresh_token_error", e, t), this.name = "TokenByRefreshTokenError";
    }
}, $414e231c569bbbbf$var$bi = class extends $414e231c569bbbbf$var$yi {
    constructor(e, t){
        super("token_for_connection_error", e, t), this.name = "TokenForConnectionErrorCode";
    }
}, $414e231c569bbbbf$var$_i = class extends $414e231c569bbbbf$var$yi {
    constructor(e, t){
        super("token_exchange_error", e, t), this.name = "TokenExchangeError";
    }
}, $414e231c569bbbbf$var$ki = class extends Error {
    constructor(e){
        super(e), $414e231c569bbbbf$var$ut(this, "code", "verify_logout_token_error"), this.name = "VerifyLogoutTokenError";
    }
}, $414e231c569bbbbf$var$Si = class extends $414e231c569bbbbf$var$yi {
    constructor(e){
        super("backchannel_authentication_error", "There was an error when trying to use Client-Initiated Backchannel Authentication.", e), $414e231c569bbbbf$var$ut(this, "code", "backchannel_authentication_error"), this.name = "BackchannelAuthenticationError";
    }
}, $414e231c569bbbbf$var$Ei = class extends $414e231c569bbbbf$var$yi {
    constructor(e){
        super("build_authorization_url_error", "There was an error when trying to build the authorization URL.", e), this.name = "BuildAuthorizationUrlError";
    }
}, $414e231c569bbbbf$var$Ai = class extends $414e231c569bbbbf$var$yi {
    constructor(e){
        super("build_link_user_url_error", "There was an error when trying to build the Link User URL.", e), this.name = "BuildLinkUserUrlError";
    }
}, $414e231c569bbbbf$var$Ti = class extends $414e231c569bbbbf$var$yi {
    constructor(e){
        super("build_unlink_user_url_error", "There was an error when trying to build the Unlink User URL.", e), this.name = "BuildUnlinkUserUrlError";
    }
}, $414e231c569bbbbf$var$Pi = class extends Error {
    constructor(){
        super("The client secret or client assertion signing key must be provided."), $414e231c569bbbbf$var$ut(this, "code", "missing_client_auth_error"), this.name = "MissingClientAuthError";
    }
};
function $414e231c569bbbbf$var$Ri(e) {
    return Object.entries(e).filter((e)=>{
        let [, t] = e;
        return void 0 !== t;
    }).reduce((e, t)=>$414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, e), {}, {
            [t[0]]: t[1]
        }), {});
}
var $414e231c569bbbbf$var$Ii = class extends Error {
    constructor(e, t, n){
        super(t), $414e231c569bbbbf$var$ut(this, "cause", void 0), $414e231c569bbbbf$var$ut(this, "code", void 0), this.code = e, this.cause = n && {
            error: n.error,
            error_description: n.error_description,
            message: n.message
        };
    }
}, $414e231c569bbbbf$var$Oi = class extends $414e231c569bbbbf$var$Ii {
    constructor(e, t){
        super("mfa_list_authenticators_error", e, t), this.name = "MfaListAuthenticatorsError";
    }
}, $414e231c569bbbbf$var$xi = class extends $414e231c569bbbbf$var$Ii {
    constructor(e, t){
        super("mfa_enrollment_error", e, t), this.name = "MfaEnrollmentError";
    }
}, $414e231c569bbbbf$var$Ci = class extends $414e231c569bbbbf$var$Ii {
    constructor(e, t){
        super("mfa_delete_authenticator_error", e, t), this.name = "MfaDeleteAuthenticatorError";
    }
}, $414e231c569bbbbf$var$ji = class extends $414e231c569bbbbf$var$Ii {
    constructor(e, t){
        super("mfa_challenge_error", e, t), this.name = "MfaChallengeError";
    }
};
function $414e231c569bbbbf$var$Di(e) {
    return {
        id: e.id,
        authenticatorType: e.authenticator_type,
        active: e.active,
        name: e.name,
        oobChannels: e.oob_channels,
        type: e.type
    };
}
var $414e231c569bbbbf$var$Ki = ($414e231c569bbbbf$var$si = new WeakMap, $414e231c569bbbbf$var$ci = new WeakMap, $414e231c569bbbbf$var$ui = new WeakMap, class {
    constructor(e){
        var t;
        $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$si, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$ci, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$ui, void 0), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$si, this, "https://".concat(e.domain)), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$ci, this, e.clientId), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$ui, this, null !== (t = e.customFetch) && void 0 !== t ? t : function() {
            return fetch(...arguments);
        });
    }
    async listAuthenticators(e) {
        const t = "".concat($414e231c569bbbbf$var$at($414e231c569bbbbf$var$si, this), "/mfa/authenticators"), { mfaToken: n } = e, o = await $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ui, this).call(this, t, {
            method: "GET",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            }
        });
        if (!o.ok) {
            const e = await o.json();
            throw new $414e231c569bbbbf$var$Oi(e.error_description || "Failed to list authenticators", e);
        }
        return (await o.json()).map($414e231c569bbbbf$var$Di);
    }
    async enrollAuthenticator(e) {
        const t = "".concat($414e231c569bbbbf$var$at($414e231c569bbbbf$var$si, this), "/mfa/associate"), { mfaToken: n } = e, o = $414e231c569bbbbf$var$ht(e, $414e231c569bbbbf$var$ii), r = {
            authenticator_types: o.authenticatorTypes
        };
        "oobChannels" in o && (r.oob_channels = o.oobChannels), "phoneNumber" in o && o.phoneNumber && (r.phone_number = o.phoneNumber), "email" in o && o.email && (r.email = o.email);
        const i = await $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ui, this).call(this, t, {
            method: "POST",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            },
            body: JSON.stringify(r)
        });
        if (!i.ok) {
            const e = await i.json();
            throw new $414e231c569bbbbf$var$xi(e.error_description || "Failed to enroll authenticator", e);
        }
        return function(e) {
            if ("otp" === e.authenticator_type) return {
                authenticatorType: "otp",
                secret: e.secret,
                barcodeUri: e.barcode_uri,
                recoveryCodes: e.recovery_codes,
                id: e.id
            };
            if ("oob" === e.authenticator_type) return {
                authenticatorType: "oob",
                oobChannel: e.oob_channel,
                oobCode: e.oob_code,
                bindingMethod: e.binding_method,
                id: e.id
            };
            throw new Error("Unexpected authenticator type: ".concat(e.authenticator_type));
        }(await i.json());
    }
    async deleteAuthenticator(e) {
        const { authenticatorId: t, mfaToken: n } = e, o = "".concat($414e231c569bbbbf$var$at($414e231c569bbbbf$var$si, this), "/mfa/authenticators/").concat(encodeURIComponent(t)), r = await $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ui, this).call(this, o, {
            method: "DELETE",
            headers: {
                Authorization: "Bearer ".concat(n),
                "Content-Type": "application/json"
            }
        });
        if (!r.ok) {
            const e = await r.json();
            throw new $414e231c569bbbbf$var$Ci(e.error_description || "Failed to delete authenticator", e);
        }
    }
    async challengeAuthenticator(e) {
        const t = "".concat($414e231c569bbbbf$var$at($414e231c569bbbbf$var$si, this), "/mfa/challenge"), { mfaToken: n } = e, o = $414e231c569bbbbf$var$ht(e, $414e231c569bbbbf$var$ai), r = {
            mfa_token: n,
            client_id: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ci, this),
            challenge_type: o.challengeType
        };
        o.authenticatorId && (r.authenticator_id = o.authenticatorId);
        const i = await $414e231c569bbbbf$var$at($414e231c569bbbbf$var$ui, this).call(this, t, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(r)
        });
        if (!i.ok) {
            const e = await i.json();
            throw new $414e231c569bbbbf$var$ji(e.error_description || "Failed to challenge authenticator", e);
        }
        return function(e) {
            const t = {
                challengeType: e.challenge_type
            };
            return void 0 !== e.oob_code && (t.oobCode = e.oob_code), void 0 !== e.binding_method && (t.bindingMethod = e.binding_method), t;
        }(await i.json());
    }
}), $414e231c569bbbbf$var$Li = class e {
    constructor(e, t, n, o, r, i, a){
        $414e231c569bbbbf$var$ut(this, "accessToken", void 0), $414e231c569bbbbf$var$ut(this, "idToken", void 0), $414e231c569bbbbf$var$ut(this, "refreshToken", void 0), $414e231c569bbbbf$var$ut(this, "expiresAt", void 0), $414e231c569bbbbf$var$ut(this, "scope", void 0), $414e231c569bbbbf$var$ut(this, "claims", void 0), $414e231c569bbbbf$var$ut(this, "authorizationDetails", void 0), $414e231c569bbbbf$var$ut(this, "tokenType", void 0), $414e231c569bbbbf$var$ut(this, "issuedTokenType", void 0), this.accessToken = e, this.idToken = n, this.refreshToken = o, this.expiresAt = t, this.scope = r, this.claims = i, this.authorizationDetails = a;
    }
    static fromTokenEndpointResponse(t) {
        const n = t.id_token ? t.claims() : void 0, o = new e(t.access_token, Math.floor(Date.now() / 1e3) + Number(t.expires_in), t.id_token, t.refresh_token, t.scope, n, t.authorization_details);
        return o.tokenType = t.token_type, o.issuedTokenType = t.issued_token_type, o;
    }
}, $414e231c569bbbbf$var$Ui = "openid profile email offline_access", $414e231c569bbbbf$var$Ni = Object.freeze(new Set([
    "grant_type",
    "client_id",
    "client_secret",
    "client_assertion",
    "client_assertion_type",
    "subject_token",
    "subject_token_type",
    "requested_token_type",
    "actor_token",
    "actor_token_type",
    "audience",
    "aud",
    "resource",
    "resources",
    "resource_indicator",
    "scope",
    "connection",
    "login_hint",
    "organization",
    "assertion"
]));
function $414e231c569bbbbf$var$Wi(e) {
    if (null == e) throw new $414e231c569bbbbf$var$_i("subject_token is required");
    if ("string" != typeof e) throw new $414e231c569bbbbf$var$_i("subject_token must be a string");
    if (0 === e.trim().length) throw new $414e231c569bbbbf$var$_i("subject_token cannot be blank or whitespace");
    if (e !== e.trim()) throw new $414e231c569bbbbf$var$_i("subject_token must not include leading or trailing whitespace");
    if (/^bearer\s+/i.test(e)) throw new $414e231c569bbbbf$var$_i("subject_token must not include the 'Bearer ' prefix");
}
function $414e231c569bbbbf$var$zi(e, t) {
    if (t) {
        for (const [n, o] of Object.entries(t))if (!$414e231c569bbbbf$var$Ni.has(n)) {
            if (Array.isArray(o)) {
                if (o.length > 20) throw new $414e231c569bbbbf$var$_i("Parameter '".concat(n, "' exceeds maximum array size of ").concat(20));
                o.forEach((t)=>{
                    e.append(n, t);
                });
            } else e.append(n, o);
        }
    }
}
var $414e231c569bbbbf$var$Hi = ($414e231c569bbbbf$var$li = new WeakMap, $414e231c569bbbbf$var$di = new WeakMap, $414e231c569bbbbf$var$hi = new WeakMap, $414e231c569bbbbf$var$pi = new WeakMap, $414e231c569bbbbf$var$fi = new WeakSet, class {
    constructor(e){
        if (function(e, t) {
            $414e231c569bbbbf$var$it(e, t), t.add(e);
        }(this, $414e231c569bbbbf$var$fi), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$li, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$di, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$hi, void 0), $414e231c569bbbbf$var$st(this, $414e231c569bbbbf$var$pi, void 0), $414e231c569bbbbf$var$ut(this, "mfa", void 0), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$hi, this, e), e.useMtls && !e.customFetch) throw new $414e231c569bbbbf$var$mi("mtls_without_custom_fetch_not_supported", "Using mTLS without a custom fetch implementation is not supported");
        this.mfa = new $414e231c569bbbbf$var$Ki({
            domain: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).domain,
            clientId: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientId,
            customFetch: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).customFetch
        });
    }
    async buildAuthorizationUrl(e) {
        const { serverMetadata: t } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
        if (null != e && e.pushedAuthorizationRequests && !t.pushed_authorization_request_endpoint) throw new $414e231c569bbbbf$var$mi("par_not_supported_error", "The Auth0 tenant does not have pushed authorization requests enabled. Learn how to enable it here: https://auth0.com/docs/get-started/applications/configure-par");
        try {
            return await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Gi).call(this, e);
        } catch (e) {
            throw new $414e231c569bbbbf$var$Ei(e);
        }
    }
    async buildLinkUserUrl(e) {
        try {
            const t = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Gi).call(this, {
                authorizationParams: $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, e.authorizationParams), {}, {
                    requested_connection: e.connection,
                    requested_connection_scope: e.connectionScope,
                    scope: "openid link_account offline_access",
                    id_token_hint: e.idToken
                })
            });
            return {
                linkUserUrl: t.authorizationUrl,
                codeVerifier: t.codeVerifier
            };
        } catch (e) {
            throw new $414e231c569bbbbf$var$Ai(e);
        }
    }
    async buildUnlinkUserUrl(e) {
        try {
            const t = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Gi).call(this, {
                authorizationParams: $414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, e.authorizationParams), {}, {
                    requested_connection: e.connection,
                    scope: "openid unlink_account",
                    id_token_hint: e.idToken
                })
            });
            return {
                unlinkUserUrl: t.authorizationUrl,
                codeVerifier: t.codeVerifier
            };
        } catch (e) {
            throw new $414e231c569bbbbf$var$Ti(e);
        }
    }
    async backchannelAuthentication(e) {
        const { configuration: t, serverMetadata: n } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this), o = $414e231c569bbbbf$var$Ri($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), r = new URLSearchParams($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({
            scope: $414e231c569bbbbf$var$Ui
        }, o), {}, {
            client_id: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientId,
            binding_message: e.bindingMessage,
            login_hint: JSON.stringify({
                format: "iss_sub",
                iss: n.issuer,
                sub: e.loginHint.sub
            })
        }));
        e.requestedExpiry && r.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && r.append("authorization_details", JSON.stringify(e.authorizationDetails));
        try {
            const e = await $414e231c569bbbbf$var$mr(t, r), n = await $414e231c569bbbbf$var$yr(t, e);
            return $414e231c569bbbbf$var$Li.fromTokenEndpointResponse(n);
        } catch (e) {
            throw new $414e231c569bbbbf$var$Si(e);
        }
    }
    async initiateBackchannelAuthentication(e) {
        const { configuration: t, serverMetadata: n } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this), o = $414e231c569bbbbf$var$Ri($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), r = new URLSearchParams($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({
            scope: $414e231c569bbbbf$var$Ui
        }, o), {}, {
            client_id: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientId,
            binding_message: e.bindingMessage,
            login_hint: JSON.stringify({
                format: "iss_sub",
                iss: n.issuer,
                sub: e.loginHint.sub
            })
        }));
        e.requestedExpiry && r.append("requested_expiry", e.requestedExpiry.toString()), e.authorizationDetails && r.append("authorization_details", JSON.stringify(e.authorizationDetails));
        try {
            const e = await $414e231c569bbbbf$var$mr(t, r);
            return {
                authReqId: e.auth_req_id,
                expiresIn: e.expires_in,
                interval: e.interval
            };
        } catch (e) {
            throw new $414e231c569bbbbf$var$Si(e);
        }
    }
    async backchannelAuthenticationGrant(e) {
        let { authReqId: t } = e;
        const { configuration: n } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this), o = new URLSearchParams({
            auth_req_id: t
        });
        try {
            const e = await $414e231c569bbbbf$var$Pr(n, "urn:openid:params:grant-type:ciba", o);
            return $414e231c569bbbbf$var$Li.fromTokenEndpointResponse(e);
        } catch (e) {
            throw new $414e231c569bbbbf$var$Si(e);
        }
    }
    async getTokenForConnection(e) {
        var t;
        if (e.refreshToken && e.accessToken) throw new $414e231c569bbbbf$var$bi("Either a refresh or access token should be specified, but not both.");
        const n = null !== (t = e.accessToken) && void 0 !== t ? t : e.refreshToken;
        if (!n) throw new $414e231c569bbbbf$var$bi("Either a refresh or access token must be specified.");
        try {
            return await this.exchangeToken({
                connection: e.connection,
                subjectToken: n,
                subjectTokenType: e.accessToken ? "urn:ietf:params:oauth:token-type:access_token" : "urn:ietf:params:oauth:token-type:refresh_token",
                loginHint: e.loginHint
            });
        } catch (e) {
            if (e instanceof $414e231c569bbbbf$var$_i) throw new $414e231c569bbbbf$var$bi(e.message, e.cause);
            throw e;
        }
    }
    async exchangeToken(e) {
        return "connection" in e ? $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Ji).call(this, e) : $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Vi).call(this, e);
    }
    async getTokenByCode(e, t) {
        const { configuration: n } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
        try {
            const o = await $414e231c569bbbbf$var$gr(n, e, {
                pkceCodeVerifier: t.codeVerifier
            });
            return $414e231c569bbbbf$var$Li.fromTokenEndpointResponse(o);
        } catch (e) {
            throw new $414e231c569bbbbf$var$wi("There was an error while trying to request a token.", e);
        }
    }
    async getTokenByRefreshToken(e) {
        const { configuration: t } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
        try {
            const n = await $414e231c569bbbbf$var$vr(t, e.refreshToken);
            return $414e231c569bbbbf$var$Li.fromTokenEndpointResponse(n);
        } catch (e) {
            throw new $414e231c569bbbbf$var$vi("The access token has expired and there was an error while trying to refresh it.", e);
        }
    }
    async getTokenByClientCredentials(e) {
        const { configuration: t } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
        try {
            const n = new URLSearchParams({
                audience: e.audience
            });
            e.organization && n.append("organization", e.organization);
            const o = await $414e231c569bbbbf$var$br(t, n);
            return $414e231c569bbbbf$var$Li.fromTokenEndpointResponse(o);
        } catch (e) {
            throw new $414e231c569bbbbf$var$gi("There was an error while trying to request a token.", e);
        }
    }
    async buildLogoutUrl(e) {
        const { configuration: t, serverMetadata: n } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
        if (!n.end_session_endpoint) {
            const t = new URL("https://".concat($414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).domain, "/v2/logout"));
            return t.searchParams.set("returnTo", e.returnTo), t.searchParams.set("client_id", $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientId), t;
        }
        return function(e, t) {
            $414e231c569bbbbf$var$Sr(e);
            const { as: n, c: o, tlsOnly: r } = $414e231c569bbbbf$var$Xo(e), i = $414e231c569bbbbf$var$nn(n, "end_session_endpoint", !1, r);
            (t = new URLSearchParams(t)).has("client_id") || t.set("client_id", o.client_id);
            for (const [e, n] of t.entries())i.searchParams.append(e, n);
            return i;
        }(t, {
            post_logout_redirect_uri: e.returnTo
        });
    }
    async verifyLogoutToken(e) {
        const { serverMetadata: t } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
        $414e231c569bbbbf$var$at($414e231c569bbbbf$var$pi, this) || $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$pi, this, function(e, t) {
            const n = new $414e231c569bbbbf$var$ri(e, t), o = async (e, t)=>n.getKey(e, t);
            return Object.defineProperties(o, {
                coolingDown: {
                    get: ()=>n.coolingDown(),
                    enumerable: !0,
                    configurable: !1
                },
                fresh: {
                    get: ()=>n.fresh(),
                    enumerable: !0,
                    configurable: !1
                },
                reload: {
                    value: ()=>n.reload(),
                    enumerable: !0,
                    configurable: !1,
                    writable: !1
                },
                reloading: {
                    get: ()=>n.pendingFetch(),
                    enumerable: !0,
                    configurable: !1
                },
                jwks: {
                    value: ()=>n.jwks(),
                    enumerable: !0,
                    configurable: !1,
                    writable: !1
                }
            }), o;
        }(new URL(t.jwks_uri), {
            [$414e231c569bbbbf$var$Gr]: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).customFetch
        }));
        const { payload: n } = await $414e231c569bbbbf$var$Lr(e.logoutToken, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$pi, this), {
            issuer: t.issuer,
            audience: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientId,
            algorithms: [
                "RS256"
            ],
            requiredClaims: [
                "iat"
            ]
        });
        if (!("sid" in n) && !("sub" in n)) throw new $414e231c569bbbbf$var$ki('either "sid" or "sub" (or both) claims must be present');
        if ("sid" in n && "string" != typeof n.sid) throw new $414e231c569bbbbf$var$ki('"sid" claim must be a string');
        if ("sub" in n && "string" != typeof n.sub) throw new $414e231c569bbbbf$var$ki('"sub" claim must be a string');
        if ("nonce" in n) throw new $414e231c569bbbbf$var$ki('"nonce" claim is prohibited');
        if (!("events" in n)) throw new $414e231c569bbbbf$var$ki('"events" claim is missing');
        if ("object" != typeof n.events || null === n.events) throw new $414e231c569bbbbf$var$ki('"events" claim must be an object');
        if (!("http://schemas.openid.net/event/backchannel-logout" in n.events)) throw new $414e231c569bbbbf$var$ki('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim');
        if ("object" != typeof n.events["http://schemas.openid.net/event/backchannel-logout"]) throw new $414e231c569bbbbf$var$ki('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object');
        return {
            sid: n.sid,
            sub: n.sub
        };
    }
});
async function $414e231c569bbbbf$var$Mi() {
    if ($414e231c569bbbbf$var$at($414e231c569bbbbf$var$li, this) && $414e231c569bbbbf$var$at($414e231c569bbbbf$var$di, this)) return {
        configuration: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$li, this),
        serverMetadata: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$di, this)
    };
    const e = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Fi).call(this);
    return $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$li, this, await $414e231c569bbbbf$var$ur(new URL("https://".concat($414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).domain)), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientId, {
        use_mtls_endpoint_aliases: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).useMtls
    }, e, {
        [$414e231c569bbbbf$var$er]: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).customFetch
    })), $414e231c569bbbbf$var$ct($414e231c569bbbbf$var$di, this, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$li, this).serverMetadata()), $414e231c569bbbbf$var$at($414e231c569bbbbf$var$li, this)[$414e231c569bbbbf$var$er] = $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).customFetch || fetch, {
        configuration: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$li, this),
        serverMetadata: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$di, this)
    };
}
async function $414e231c569bbbbf$var$Ji(e) {
    var t, n;
    const { configuration: o } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
    if ("audience" in e || "resource" in e) throw new $414e231c569bbbbf$var$_i("audience and resource parameters are not supported for Token Vault exchanges");
    $414e231c569bbbbf$var$Wi(e.subjectToken);
    const r = new URLSearchParams({
        connection: e.connection,
        subject_token: e.subjectToken,
        subject_token_type: null !== (t = e.subjectTokenType) && void 0 !== t ? t : "urn:ietf:params:oauth:token-type:access_token",
        requested_token_type: null !== (n = e.requestedTokenType) && void 0 !== n ? n : "http://auth0.com/oauth/token-type/federated-connection-access-token"
    });
    e.loginHint && r.append("login_hint", e.loginHint), e.scope && r.append("scope", e.scope), $414e231c569bbbbf$var$zi(r, e.extra);
    try {
        const e = await $414e231c569bbbbf$var$Pr(o, "urn:auth0:params:oauth:grant-type:token-exchange:federated-connection-access-token", r);
        return $414e231c569bbbbf$var$Li.fromTokenEndpointResponse(e);
    } catch (t) {
        throw new $414e231c569bbbbf$var$_i("Failed to exchange token for connection '".concat(e.connection, "'."), t);
    }
}
async function $414e231c569bbbbf$var$Vi(e) {
    const { configuration: t } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this);
    $414e231c569bbbbf$var$Wi(e.subjectToken);
    const n = new URLSearchParams({
        subject_token_type: e.subjectTokenType,
        subject_token: e.subjectToken
    });
    e.audience && n.append("audience", e.audience), e.scope && n.append("scope", e.scope), e.requestedTokenType && n.append("requested_token_type", e.requestedTokenType), e.organization && n.append("organization", e.organization), $414e231c569bbbbf$var$zi(n, e.extra);
    try {
        const e = await $414e231c569bbbbf$var$Pr(t, "urn:ietf:params:oauth:grant-type:token-exchange", n);
        return $414e231c569bbbbf$var$Li.fromTokenEndpointResponse(e);
    } catch (t) {
        throw new $414e231c569bbbbf$var$_i("Failed to exchange token of type '".concat(e.subjectTokenType, "'").concat(e.audience ? " for audience '".concat(e.audience, "'") : "", "."), t);
    }
}
async function $414e231c569bbbbf$var$Fi() {
    if (!$414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientSecret && !$414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientAssertionSigningKey && !$414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).useMtls) throw new $414e231c569bbbbf$var$Pi;
    if ($414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).useMtls) return (e, t, n, o)=>{
        n.set("client_id", t.client_id);
    };
    let e = $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientAssertionSigningKey;
    return !e || e instanceof CryptoKey || (e = await async function(e, t, n) {
        if ("string" != typeof e || 0 !== e.indexOf("-----BEGIN PRIVATE KEY-----")) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
        return $414e231c569bbbbf$var$Uo(e, t, n);
    }(e, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientAssertionSigningAlg || "RS256")), e ? function(e, t) {
        return $414e231c569bbbbf$var$Qt(e, t);
    }(e) : $414e231c569bbbbf$var$$o($414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientSecret);
}
async function $414e231c569bbbbf$var$Gi(e) {
    const { configuration: t } = await $414e231c569bbbbf$var$ot($414e231c569bbbbf$var$fi, this, $414e231c569bbbbf$var$Mi).call(this), n = $414e231c569bbbbf$var$ir(), o = await $414e231c569bbbbf$var$rr(n), r = $414e231c569bbbbf$var$Ri($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({}, $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).authorizationParams), null == e ? void 0 : e.authorizationParams)), i = new URLSearchParams($414e231c569bbbbf$var$dt($414e231c569bbbbf$var$dt({
        scope: $414e231c569bbbbf$var$Ui
    }, r), {}, {
        client_id: $414e231c569bbbbf$var$at($414e231c569bbbbf$var$hi, this).clientId,
        code_challenge: o,
        code_challenge_method: "S256"
    }));
    return {
        authorizationUrl: null != e && e.pushedAuthorizationRequests ? await $414e231c569bbbbf$var$kr(t, i) : await $414e231c569bbbbf$var$_r(t, i),
        codeVerifier: n
    };
}
class $414e231c569bbbbf$export$fd2d7253282cd781 extends $414e231c569bbbbf$export$7d465be8efa67280 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $414e231c569bbbbf$export$fd2d7253282cd781.prototype);
    }
    static fromPayload(e) {
        let { error: t, error_description: n } = e;
        return new $414e231c569bbbbf$export$fd2d7253282cd781(t, n);
    }
}
class $414e231c569bbbbf$export$940c42743f432969 extends $414e231c569bbbbf$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $414e231c569bbbbf$export$940c42743f432969.prototype);
    }
}
class $414e231c569bbbbf$export$870742f9876ce7c1 extends $414e231c569bbbbf$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $414e231c569bbbbf$export$870742f9876ce7c1.prototype);
    }
}
class $414e231c569bbbbf$export$5a994d9ede115726 extends $414e231c569bbbbf$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $414e231c569bbbbf$export$5a994d9ede115726.prototype);
    }
}
class $414e231c569bbbbf$export$ed4d3fbc582ebfd8 extends $414e231c569bbbbf$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $414e231c569bbbbf$export$ed4d3fbc582ebfd8.prototype);
    }
}
class $414e231c569bbbbf$export$702aa0eb54b4ab0a extends $414e231c569bbbbf$export$fd2d7253282cd781 {
    constructor(e, t){
        super(e, t), Object.setPrototypeOf(this, $414e231c569bbbbf$export$702aa0eb54b4ab0a.prototype);
    }
}
class $414e231c569bbbbf$var$$i {
    constructor(){
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 6e5;
        this.contexts = new Map, this.ttlMs = e;
    }
    set(e, t) {
        this.cleanup(), this.contexts.set(e, Object.assign(Object.assign({}, t), {
            createdAt: Date.now()
        }));
    }
    get(e) {
        const t = this.contexts.get(e);
        if (t) {
            if (!(Date.now() - t.createdAt > this.ttlMs)) return t;
            this.contexts.delete(e);
        }
    }
    remove(e) {
        this.contexts.delete(e);
    }
    cleanup() {
        const e = Date.now();
        for (const [t, n] of this.contexts)e - n.createdAt > this.ttlMs && this.contexts.delete(t);
    }
    get size() {
        return this.contexts.size;
    }
}
class $414e231c569bbbbf$export$c23d31083644c64d {
    constructor(e, t){
        this.authJsMfaClient = e, this.auth0Client = t, this.contextManager = new $414e231c569bbbbf$var$$i;
    }
    setMFAAuthDetails(e, t, n, o) {
        this.contextManager.set(e, {
            scope: t,
            audience: n,
            mfaRequirements: o
        });
    }
    async getAuthenticators(e) {
        var t, n;
        const o = this.contextManager.get(e);
        if (!(null === (t = null == o ? void 0 : o.mfaRequirements) || void 0 === t ? void 0 : t.challenge) || 0 === o.mfaRequirements.challenge.length) throw new $414e231c569bbbbf$export$940c42743f432969("invalid_request", "challengeType is required and must contain at least one challenge type, please check mfa_required error payload");
        const r = o.mfaRequirements.challenge.map((e)=>e.type);
        try {
            return (await this.authJsMfaClient.listAuthenticators({
                mfaToken: e
            })).filter((e)=>!!e.type && r.includes(e.type));
        } catch (e) {
            if (e instanceof $414e231c569bbbbf$var$Oi) throw new $414e231c569bbbbf$export$940c42743f432969(null === (n = e.cause) || void 0 === n ? void 0 : n.error, e.message);
            throw e;
        }
    }
    async enroll(e) {
        var t;
        const n = function(e) {
            const t = $414e231c569bbbbf$var$Qe[e.factorType];
            return Object.assign(Object.assign(Object.assign({
                mfaToken: e.mfaToken,
                authenticatorTypes: t.authenticatorTypes
            }, t.oobChannels && {
                oobChannels: t.oobChannels
            }), "phoneNumber" in e && {
                phoneNumber: e.phoneNumber
            }), "email" in e && {
                email: e.email
            });
        }(e);
        try {
            return await this.authJsMfaClient.enrollAuthenticator(n);
        } catch (e) {
            if (e instanceof $414e231c569bbbbf$var$xi) throw new $414e231c569bbbbf$export$870742f9876ce7c1(null === (t = e.cause) || void 0 === t ? void 0 : t.error, e.message);
            throw e;
        }
    }
    async challenge(e) {
        var t;
        try {
            const t = {
                challengeType: e.challengeType,
                mfaToken: e.mfaToken
            };
            return e.authenticatorId && (t.authenticatorId = e.authenticatorId), await this.authJsMfaClient.challengeAuthenticator(t);
        } catch (e) {
            if (e instanceof $414e231c569bbbbf$var$ji) throw new $414e231c569bbbbf$export$5a994d9ede115726(null === (t = e.cause) || void 0 === t ? void 0 : t.error, e.message);
            throw e;
        }
    }
    async getEnrollmentFactors(e) {
        const t = this.contextManager.get(e);
        if (!t || !t.mfaRequirements) throw new $414e231c569bbbbf$export$702aa0eb54b4ab0a("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
        return t.mfaRequirements.enroll && 0 !== t.mfaRequirements.enroll.length ? t.mfaRequirements.enroll : [];
    }
    async verify(e) {
        const t = this.contextManager.get(e.mfaToken);
        if (!t) throw new $414e231c569bbbbf$export$ed4d3fbc582ebfd8("mfa_context_not_found", "MFA context not found for this MFA token. Please retry the original request to get a new MFA token.");
        const n = function(e) {
            return "otp" in e && e.otp ? $414e231c569bbbbf$var$$e : "oobCode" in e && e.oobCode ? $414e231c569bbbbf$var$et : "recoveryCode" in e && e.recoveryCode ? $414e231c569bbbbf$var$tt : void 0;
        }(e);
        if (!n) throw new $414e231c569bbbbf$export$ed4d3fbc582ebfd8("invalid_request", "Unable to determine grant type. Provide one of: otp, oobCode, or recoveryCode.");
        const o = t.scope, r = t.audience;
        try {
            const t = await this.auth0Client._requestTokenForMfa({
                grant_type: n,
                mfaToken: e.mfaToken,
                scope: o,
                audience: r,
                otp: e.otp,
                oob_code: e.oobCode,
                binding_code: e.bindingCode,
                recovery_code: e.recoveryCode
            });
            return this.contextManager.remove(e.mfaToken), t;
        } catch (e) {
            if (e instanceof $414e231c569bbbbf$export$c59494f4dae44ada) this.setMFAAuthDetails(e.mfa_token, o, r, e.mfa_requirements);
            else if (e instanceof $414e231c569bbbbf$export$ed4d3fbc582ebfd8) throw new $414e231c569bbbbf$export$ed4d3fbc582ebfd8(e.error, e.error_description);
            throw e;
        }
    }
}
const $414e231c569bbbbf$var$ta = new $414e231c569bbbbf$var$p;
class $414e231c569bbbbf$export$b50978e389d6e1d5 {
    constructor(e){
        let t, n;
        if (this.userCache = (new $414e231c569bbbbf$export$467265324939f47f).enclosedCache, this.activeLockKeys = new Set, this.defaultOptions = {
            authorizationParams: {
                scope: "openid profile email"
            },
            useRefreshTokensFallback: !1,
            useFormData: !0
        }, this._releaseLockOnPageHide = async ()=>{
            const e = Array.from(this.activeLockKeys);
            for (const t of e)await $414e231c569bbbbf$var$ta.releaseLock(t);
            this.activeLockKeys.clear(), window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }, this.options = Object.assign(Object.assign(Object.assign({}, this.defaultOptions), e), {
            authorizationParams: Object.assign(Object.assign({}, this.defaultOptions.authorizationParams), e.authorizationParams)
        }), "undefined" != typeof window && (()=>{
            if (!$414e231c569bbbbf$var$I()) throw new Error("For security reasons, `window.crypto` is required to run `auth0-spa-js`.");
            if (void 0 === $414e231c569bbbbf$var$I().subtle) throw new Error("\n      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.\n    ");
        })(), e.cache && e.cacheLocation && console.warn("Both `cache` and `cacheLocation` options have been specified in the Auth0Client configuration; ignoring `cacheLocation` and using `cache`."), e.cache) n = e.cache;
        else {
            if (t = e.cacheLocation || "memory", !$414e231c569bbbbf$var$Me(t)) throw new Error('Invalid cache location "'.concat(t, '"'));
            n = $414e231c569bbbbf$var$Me(t)();
        }
        var o;
        this.httpTimeoutMs = e.httpTimeoutInSeconds ? 1e3 * e.httpTimeoutInSeconds : 1e4, this.cookieStorage = !1 === e.legacySameSiteCookie ? $414e231c569bbbbf$var$Pe : $414e231c569bbbbf$var$Re, this.orgHintCookieName = (o = this.options.clientId, "auth0.".concat(o, ".organization_hint")), this.isAuthenticatedCookieName = ((e)=>"auth0.".concat(e, ".is.authenticated"))(this.options.clientId), this.sessionCheckExpiryDays = e.sessionCheckExpiryDays || 1;
        const r = e.useCookiesForTransactions ? this.cookieStorage : $414e231c569bbbbf$var$Ie;
        var i;
        this.scope = function(e, t) {
            for(var n = arguments.length, o = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)o[r - 2] = arguments[r];
            if ("object" != typeof e) return {
                default: $414e231c569bbbbf$var$ue(t, e, ...o)
            };
            let i = {
                default: $414e231c569bbbbf$var$ue(t, ...o)
            };
            return Object.keys(e).forEach((n)=>{
                const r = e[n];
                i[n] = $414e231c569bbbbf$var$ue(t, r, ...o);
            }), i;
        }(this.options.authorizationParams.scope, "openid", this.options.useRefreshTokens ? "offline_access" : ""), this.transactionManager = new $414e231c569bbbbf$var$me(r, this.options.clientId, this.options.cookieDomain), this.nowProvider = this.options.nowProvider || $414e231c569bbbbf$var$y, this.cacheManager = new $414e231c569bbbbf$var$fe(n, n.allKeys ? void 0 : new $414e231c569bbbbf$var$ze(n, this.options.clientId), this.nowProvider), this.dpop = this.options.useDpop ? new $414e231c569bbbbf$var$Ze(this.options.clientId) : void 0, this.domainUrl = (i = this.options.domain, /^https?:\/\//.test(i) ? i : "https://".concat(i)), this.tokenIssuer = ((e, t)=>e ? e.startsWith("https://") ? e : "https://".concat(e, "/") : "".concat(t, "/"))(this.options.issuer, this.domainUrl);
        const a = "".concat(this.domainUrl, "/me/"), s = this.createFetcher(Object.assign(Object.assign({}, this.options.useDpop && {
            dpopNonceId: "__auth0_my_account_api__"
        }), {
            getAccessToken: ()=>this.getTokenSilently({
                    authorizationParams: {
                        scope: "create:me:connected_accounts",
                        audience: a
                    },
                    detailedResponse: !0
                })
        }));
        this.myAccountApi = new $414e231c569bbbbf$var$Xe(s, a), this.authJsClient = new $414e231c569bbbbf$var$Hi({
            domain: this.options.domain,
            clientId: this.options.clientId
        }), this.mfa = new $414e231c569bbbbf$export$c23d31083644c64d(this.authJsClient.mfa, this), "undefined" != typeof window && window.Worker && this.options.useRefreshTokens && "memory" === t && (this.options.workerUrl ? this.worker = new Worker(this.options.workerUrl) : this.worker = new $414e231c569bbbbf$var$Ue);
    }
    getConfiguration() {
        return Object.freeze({
            domain: this.options.domain,
            clientId: this.options.clientId
        });
    }
    _url(e) {
        const t = this.options.auth0Client || $414e231c569bbbbf$var$m, n = $414e231c569bbbbf$var$j(t, !0), o = encodeURIComponent(btoa(JSON.stringify(n)));
        return "".concat(this.domainUrl).concat(e, "&auth0Client=").concat(o);
    }
    _authorizeUrl(e) {
        return this._url("/authorize?".concat($414e231c569bbbbf$var$D(e)));
    }
    async _verifyIdToken(e, t, n) {
        const o = await this.nowProvider();
        var r;
        return $414e231c569bbbbf$var$ge({
            iss: this.tokenIssuer,
            aud: this.options.clientId,
            id_token: e,
            nonce: t,
            organization: n,
            leeway: this.options.leeway,
            max_age: (r = this.options.authorizationParams.max_age, "string" != typeof r ? r : parseInt(r, 10) || void 0),
            now: o
        });
    }
    _processOrgHint(e) {
        e ? this.cookieStorage.save(this.orgHintCookieName, e, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }) : this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        });
    }
    async _prepareAuthorizeUrl(e, t, n) {
        var o;
        const r = $414e231c569bbbbf$var$x($414e231c569bbbbf$var$O()), i = $414e231c569bbbbf$var$x($414e231c569bbbbf$var$O()), a = $414e231c569bbbbf$var$O(), s = await $414e231c569bbbbf$var$K(a), c = $414e231c569bbbbf$var$U(s), u = await (null === (o = this.dpop) || void 0 === o ? void 0 : o.calculateThumbprint()), l = ((e, t, n, o, r, i, a, s, c)=>Object.assign(Object.assign(Object.assign({
                client_id: e.clientId
            }, e.authorizationParams), n), {
                scope: $414e231c569bbbbf$var$le(t, n.scope, n.audience),
                response_type: "code",
                response_mode: s || "query",
                state: o,
                nonce: r,
                redirect_uri: a || e.authorizationParams.redirect_uri,
                code_challenge: i,
                code_challenge_method: "S256",
                dpop_jkt: c
            }))(this.options, this.scope, e, r, i, c, e.redirect_uri || this.options.authorizationParams.redirect_uri || n, null == t ? void 0 : t.response_mode, u), d = this._authorizeUrl(l);
        return {
            nonce: i,
            code_verifier: a,
            scope: l.scope,
            audience: l.audience || "default",
            redirect_uri: l.redirect_uri,
            state: r,
            url: d
        };
    }
    async loginWithPopup(e, t) {
        var n;
        if (e = e || {}, !(t = t || {}).popup && (t.popup = ((e)=>{
            const t = window.screenX + (window.innerWidth - 400) / 2, n = window.screenY + (window.innerHeight - 600) / 2;
            return window.open(e, "auth0:authorize:popup", "left=".concat(t, ",top=").concat(n, ",width=").concat(400, ",height=").concat(600, ",resizable,scrollbars=yes,status=1"));
        })(""), !t.popup)) throw new $414e231c569bbbbf$export$d52312082b7f6392;
        const o = await this._prepareAuthorizeUrl(e.authorizationParams || {}, {
            response_mode: "web_message"
        }, window.location.origin);
        t.popup.location.href = o.url;
        const r = await ((e)=>new Promise((t, n)=>{
                let o;
                const r = setInterval(()=>{
                    e.popup && e.popup.closed && (clearInterval(r), clearTimeout(i), window.removeEventListener("message", o, !1), n(new $414e231c569bbbbf$export$f1f681f0fb26bb55(e.popup)));
                }, 1e3), i = setTimeout(()=>{
                    clearInterval(r), n(new $414e231c569bbbbf$export$ebbb83fe03f719a4(e.popup)), window.removeEventListener("message", o, !1);
                }, 1e3 * (e.timeoutInSeconds || 60));
                o = function(a) {
                    if (a.data && "authorization_response" === a.data.type) {
                        if (clearTimeout(i), clearInterval(r), window.removeEventListener("message", o, !1), !1 !== e.closePopup && e.popup.close(), a.data.response.error) return n($414e231c569bbbbf$export$7d465be8efa67280.fromPayload(a.data.response));
                        t(a.data.response);
                    }
                }, window.addEventListener("message", o);
            }))(Object.assign(Object.assign({}, t), {
            timeoutInSeconds: t.timeoutInSeconds || this.options.authorizeTimeoutInSeconds || 60
        }));
        if (o.state !== r.state) throw new $414e231c569bbbbf$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const i = (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.organization) || this.options.authorizationParams.organization;
        await this._requestToken({
            audience: o.audience,
            scope: o.scope,
            code_verifier: o.code_verifier,
            grant_type: "authorization_code",
            code: r.code,
            redirect_uri: o.redirect_uri
        }, {
            nonceIn: o.nonce,
            organization: i
        });
    }
    async getUser() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.user;
    }
    async getIdTokenClaims() {
        var e;
        const t = await this._getIdTokenFromCache();
        return null === (e = null == t ? void 0 : t.decodedToken) || void 0 === e ? void 0 : e.claims;
    }
    async loginWithRedirect() {
        var t;
        const n = $414e231c569bbbbf$var$Je(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}), { openUrl: o, fragment: r, appState: i } = n, a = $414e231c569bbbbf$var$e(n, [
            "openUrl",
            "fragment",
            "appState"
        ]), s = (null === (t = a.authorizationParams) || void 0 === t ? void 0 : t.organization) || this.options.authorizationParams.organization, c = await this._prepareAuthorizeUrl(a.authorizationParams || {}), { url: u } = c, l = $414e231c569bbbbf$var$e(c, [
            "url"
        ]);
        this.transactionManager.create(Object.assign(Object.assign(Object.assign({}, l), {
            appState: i,
            response_type: $414e231c569bbbbf$export$7390b1e457b4cb6f.Code
        }), s && {
            organization: s
        }));
        const d = r ? "".concat(u, "#").concat(r) : u;
        o ? await o(d) : window.location.assign(d);
    }
    async handleRedirectCallback() {
        const e = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.href).split("?").slice(1);
        if (0 === e.length) throw new Error("There are no query params available for parsing.");
        const t = this.transactionManager.get();
        if (!t) throw new $414e231c569bbbbf$export$7d465be8efa67280("missing_transaction", "Invalid state");
        this.transactionManager.remove();
        const n = ((e)=>{
            e.indexOf("#") > -1 && (e = e.substring(0, e.indexOf("#")));
            const t = new URLSearchParams(e);
            return {
                state: t.get("state"),
                code: t.get("code") || void 0,
                connect_code: t.get("connect_code") || void 0,
                error: t.get("error") || void 0,
                error_description: t.get("error_description") || void 0
            };
        })(e.join(""));
        return t.response_type === $414e231c569bbbbf$export$7390b1e457b4cb6f.ConnectCode ? this._handleConnectAccountRedirectCallback(n, t) : this._handleLoginRedirectCallback(n, t);
    }
    async _handleLoginRedirectCallback(e, t) {
        const { code: n, state: o, error: r, error_description: i } = e;
        if (r) throw new $414e231c569bbbbf$export$cf0c46b07324e9c5(r, i || r, o, t.appState);
        if (!t.code_verifier || t.state && t.state !== o) throw new $414e231c569bbbbf$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = t.organization, s = t.nonce, c = t.redirect_uri;
        return await this._requestToken(Object.assign({
            audience: t.audience,
            scope: t.scope,
            code_verifier: t.code_verifier,
            grant_type: "authorization_code",
            code: n
        }, c ? {
            redirect_uri: c
        } : {}), {
            nonceIn: s,
            organization: a
        }), {
            appState: t.appState,
            response_type: $414e231c569bbbbf$export$7390b1e457b4cb6f.Code
        };
    }
    async _handleConnectAccountRedirectCallback(e, t) {
        const { connect_code: n, state: o, error: r, error_description: i } = e;
        if (r) throw new $414e231c569bbbbf$export$aaa3fc6bdea78d4d(r, i || r, t.connection, o, t.appState);
        if (!n) throw new $414e231c569bbbbf$export$7d465be8efa67280("missing_connect_code", "Missing connect code");
        if (!(t.code_verifier && t.state && t.auth_session && t.redirect_uri && t.state === o)) throw new $414e231c569bbbbf$export$7d465be8efa67280("state_mismatch", "Invalid state");
        const a = await this.myAccountApi.completeAccount({
            auth_session: t.auth_session,
            connect_code: n,
            redirect_uri: t.redirect_uri,
            code_verifier: t.code_verifier
        });
        return Object.assign(Object.assign({}, a), {
            appState: t.appState,
            response_type: $414e231c569bbbbf$export$7390b1e457b4cb6f.ConnectCode
        });
    }
    async checkSession(e) {
        if (!this.cookieStorage.get(this.isAuthenticatedCookieName)) {
            if (!this.cookieStorage.get("auth0.is.authenticated")) return;
            this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
                daysUntilExpire: this.sessionCheckExpiryDays,
                cookieDomain: this.options.cookieDomain
            }), this.cookieStorage.remove("auth0.is.authenticated");
        }
        try {
            await this.getTokenSilently(e);
        } catch (e) {}
    }
    async getTokenSilently() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        var t, n;
        const o = Object.assign(Object.assign({
            cacheMode: "on"
        }, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $414e231c569bbbbf$var$le(this.scope, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope, (null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.audience) || this.options.authorizationParams.audience)
            })
        }), r = await ((e, t)=>{
            let n = $414e231c569bbbbf$var$Ne[t];
            return n || (n = e().finally(()=>{
                delete $414e231c569bbbbf$var$Ne[t], n = null;
            }), $414e231c569bbbbf$var$Ne[t] = n), n;
        })(()=>this._getTokenSilently(o), "".concat(this.options.clientId, "::").concat(o.authorizationParams.audience, "::").concat(o.authorizationParams.scope));
        return e.detailedResponse ? r : null == r ? void 0 : r.access_token;
    }
    async _getTokenSilently(t) {
        const { cacheMode: n } = t, o = $414e231c569bbbbf$var$e(t, [
            "cacheMode"
        ]);
        if ("off" !== n) {
            const e = await this._getEntryFromCache({
                scope: o.authorizationParams.scope,
                audience: o.authorizationParams.audience || "default",
                clientId: this.options.clientId,
                cacheMode: n
            });
            if (e) return e;
        }
        if ("cache-only" === n) return;
        const r = (i = this.options.clientId, a = o.authorizationParams.audience || "default", "".concat("auth0.lock.getTokenSilently", ".").concat(i, ".").concat(a));
        var i, a;
        if (!await $414e231c569bbbbf$var$We(()=>$414e231c569bbbbf$var$ta.acquireLock(r, 5e3), 10)) throw new $414e231c569bbbbf$export$66d311bf29d5c89c;
        this.activeLockKeys.add(r), 1 === this.activeLockKeys.size && window.addEventListener("pagehide", this._releaseLockOnPageHide);
        try {
            if ("off" !== n) {
                const e = await this._getEntryFromCache({
                    scope: o.authorizationParams.scope,
                    audience: o.authorizationParams.audience || "default",
                    clientId: this.options.clientId
                });
                if (e) return e;
            }
            const e = this.options.useRefreshTokens ? await this._getTokenUsingRefreshToken(o) : await this._getTokenFromIFrame(o), { id_token: t, token_type: i, access_token: a, oauthTokenScope: s, expires_in: c } = e;
            return Object.assign(Object.assign({
                id_token: t,
                token_type: i,
                access_token: a
            }, s ? {
                scope: s
            } : null), {
                expires_in: c
            });
        } finally{
            await $414e231c569bbbbf$var$ta.releaseLock(r), this.activeLockKeys.delete(r), 0 === this.activeLockKeys.size && window.removeEventListener("pagehide", this._releaseLockOnPageHide);
        }
    }
    async getTokenWithPopup() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
        var n, o;
        const r = Object.assign(Object.assign({}, e), {
            authorizationParams: Object.assign(Object.assign(Object.assign({}, this.options.authorizationParams), e.authorizationParams), {
                scope: $414e231c569bbbbf$var$le(this.scope, null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.scope, (null === (o = e.authorizationParams) || void 0 === o ? void 0 : o.audience) || this.options.authorizationParams.audience)
            })
        });
        t = Object.assign(Object.assign({}, $414e231c569bbbbf$var$f), t), await this.loginWithPopup(r, t);
        return (await this.cacheManager.get(new $414e231c569bbbbf$export$2cb47d384c8dd787({
            scope: r.authorizationParams.scope,
            audience: r.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt)).access_token;
    }
    async isAuthenticated() {
        return !!await this.getUser();
    }
    _buildLogoutUrl(t) {
        null !== t.clientId ? t.clientId = t.clientId || this.options.clientId : delete t.clientId;
        const n = t.logoutParams || {}, { federated: o } = n, r = $414e231c569bbbbf$var$e(n, [
            "federated"
        ]), i = o ? "&federated" : "";
        return this._url("/v2/logout?".concat($414e231c569bbbbf$var$D(Object.assign({
            clientId: t.clientId
        }, r)))) + i;
    }
    async logout() {
        let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        var n;
        const o = $414e231c569bbbbf$var$Je(t), { openUrl: r } = o, i = $414e231c569bbbbf$var$e(o, [
            "openUrl"
        ]);
        null === t.clientId ? await this.cacheManager.clear() : await this.cacheManager.clear(t.clientId || this.options.clientId), this.cookieStorage.remove(this.orgHintCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.cookieStorage.remove(this.isAuthenticatedCookieName, {
            cookieDomain: this.options.cookieDomain
        }), this.userCache.remove("@@user@@"), await (null === (n = this.dpop) || void 0 === n ? void 0 : n.clear());
        const a = this._buildLogoutUrl(i);
        r ? await r(a) : !1 !== r && window.location.assign(a);
    }
    async _getTokenFromIFrame(e) {
        const t = (n = this.options.clientId, "".concat("auth0.lock.getTokenFromIFrame", ".").concat(n));
        var n;
        if (!await $414e231c569bbbbf$var$We(()=>$414e231c569bbbbf$var$ta.acquireLock(t, 5e3), 10)) throw new $414e231c569bbbbf$export$66d311bf29d5c89c;
        try {
            const n = Object.assign(Object.assign({}, e.authorizationParams), {
                prompt: "none"
            }), o = this.cookieStorage.get(this.orgHintCookieName);
            o && !n.organization && (n.organization = o);
            const { url: r, state: i, nonce: a, code_verifier: s, redirect_uri: c, scope: u, audience: l } = await this._prepareAuthorizeUrl(n, {
                response_mode: "web_message"
            }, window.location.origin);
            if (window.crossOriginIsolated) throw new $414e231c569bbbbf$export$7d465be8efa67280("login_required", "The application is running in a Cross-Origin Isolated context, silently retrieving a token without refresh token is not possible.");
            const d = e.timeoutInSeconds || this.options.authorizeTimeoutInSeconds;
            let h;
            try {
                h = new URL(this.domainUrl).origin;
            } catch (e) {
                h = this.domainUrl;
            }
            const p = await function(e, t) {
                let n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 60;
                return new Promise((o, r)=>{
                    const i = window.document.createElement("iframe");
                    i.setAttribute("width", "0"), i.setAttribute("height", "0"), i.style.display = "none";
                    const a = ()=>{
                        window.document.body.contains(i) && (window.document.body.removeChild(i), window.removeEventListener("message", s, !1));
                    };
                    let s;
                    const c = setTimeout(()=>{
                        r(new $414e231c569bbbbf$export$66d311bf29d5c89c), a();
                    }, 1e3 * n);
                    s = function(e) {
                        if (e.origin != t) return;
                        if (!e.data || "authorization_response" !== e.data.type) return;
                        const n = e.source;
                        n && n.close(), e.data.response.error ? r($414e231c569bbbbf$export$7d465be8efa67280.fromPayload(e.data.response)) : o(e.data.response), clearTimeout(c), window.removeEventListener("message", s, !1), setTimeout(a, 2e3);
                    }, window.addEventListener("message", s, !1), window.document.body.appendChild(i), i.setAttribute("src", e);
                });
            }(r, h, d);
            if (i !== p.state) throw new $414e231c569bbbbf$export$7d465be8efa67280("state_mismatch", "Invalid state");
            const f = await this._requestToken(Object.assign(Object.assign({}, e.authorizationParams), {
                code_verifier: s,
                code: p.code,
                grant_type: "authorization_code",
                redirect_uri: c,
                timeout: e.authorizationParams.timeout || this.httpTimeoutMs
            }), {
                nonceIn: a,
                organization: n.organization
            });
            return Object.assign(Object.assign({}, f), {
                scope: u,
                oauthTokenScope: f.scope,
                audience: l
            });
        } catch (e) {
            throw "login_required" === e.error && this.logout({
                openUrl: !1
            }), e;
        } finally{
            await $414e231c569bbbbf$var$ta.releaseLock(t);
        }
    }
    async _getTokenUsingRefreshToken(e) {
        var t, n;
        const o = await this.cacheManager.get(new $414e231c569bbbbf$export$2cb47d384c8dd787({
            scope: e.authorizationParams.scope,
            audience: e.authorizationParams.audience || "default",
            clientId: this.options.clientId
        }), void 0, this.options.useMrrt);
        if (!(o && o.refresh_token || this.worker)) {
            if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            throw new $414e231c569bbbbf$export$ac1d2a00f8e0a046(e.authorizationParams.audience || "default", e.authorizationParams.scope);
        }
        const r = e.authorizationParams.redirect_uri || this.options.authorizationParams.redirect_uri || window.location.origin, i = "number" == typeof e.timeoutInSeconds ? 1e3 * e.timeoutInSeconds : null, a = ((e, t, n, o)=>{
            var r;
            if (e && n && o) {
                if (t.audience !== n) return t.scope;
                const e = o.split(" "), i = (null === (r = t.scope) || void 0 === r ? void 0 : r.split(" ")) || [], a = i.every((t)=>e.includes(t));
                return e.length >= i.length && a ? o : t.scope;
            }
            return t.scope;
        })(this.options.useMrrt, e.authorizationParams, null == o ? void 0 : o.audience, null == o ? void 0 : o.scope);
        try {
            const t = await this._requestToken(Object.assign(Object.assign(Object.assign({}, e.authorizationParams), {
                grant_type: "refresh_token",
                refresh_token: o && o.refresh_token,
                redirect_uri: r
            }), i && {
                timeout: i
            }), {
                scopesToRequest: a
            });
            if (t.refresh_token && (null == o ? void 0 : o.refresh_token) && await this.cacheManager.updateEntry(o.refresh_token, t.refresh_token), this.options.useMrrt) {
                if (s = null == o ? void 0 : o.audience, c = null == o ? void 0 : o.scope, u = e.authorizationParams.audience, l = e.authorizationParams.scope, s !== u || !$414e231c569bbbbf$var$Ve(l, c)) {
                    if (!$414e231c569bbbbf$var$Ve(a, t.scope)) {
                        if (this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
                        await this.cacheManager.remove(this.options.clientId, e.authorizationParams.audience, e.authorizationParams.scope);
                        const n = ((e, t)=>{
                            const n = (null == e ? void 0 : e.split(" ")) || [], o = (null == t ? void 0 : t.split(" ")) || [];
                            return n.filter((e)=>-1 == o.indexOf(e)).join(",");
                        })(a, t.scope);
                        throw new $414e231c569bbbbf$var$T(e.authorizationParams.audience || "default", n);
                    }
                }
            }
            return Object.assign(Object.assign({}, t), {
                scope: e.authorizationParams.scope,
                oauthTokenScope: t.scope,
                audience: e.authorizationParams.audience || "default"
            });
        } catch (o) {
            if (o.message) {
                if (o.message.includes("user is blocked")) throw await this.logout({
                    openUrl: !1
                }), o;
                if ((o.message.includes("Missing Refresh Token") || o.message.includes("invalid refresh token")) && this.options.useRefreshTokensFallback) return await this._getTokenFromIFrame(e);
            }
            throw o instanceof $414e231c569bbbbf$export$c59494f4dae44ada && this.mfa.setMFAAuthDetails(o.mfa_token, null === (t = e.authorizationParams) || void 0 === t ? void 0 : t.scope, null === (n = e.authorizationParams) || void 0 === n ? void 0 : n.audience, o.mfa_requirements), o;
        }
        var s, c, u, l;
    }
    async _saveEntryInCache(t) {
        const { id_token: n, decodedToken: o } = t, r = $414e231c569bbbbf$var$e(t, [
            "id_token",
            "decodedToken"
        ]);
        this.userCache.set("@@user@@", {
            id_token: n,
            decodedToken: o
        }), await this.cacheManager.setIdToken(this.options.clientId, t.id_token, t.decodedToken), await this.cacheManager.set(r);
    }
    async _getIdTokenFromCache() {
        const e = this.options.authorizationParams.audience || "default", t = this.scope[e], n = await this.cacheManager.getIdToken(new $414e231c569bbbbf$export$2cb47d384c8dd787({
            clientId: this.options.clientId,
            audience: e,
            scope: t
        })), o = this.userCache.get("@@user@@");
        return n && n.id_token === (null == o ? void 0 : o.id_token) ? o : (this.userCache.set("@@user@@", n), n);
    }
    async _getEntryFromCache(e) {
        let { scope: t, audience: n, clientId: o, cacheMode: r } = e;
        const i = await this.cacheManager.get(new $414e231c569bbbbf$export$2cb47d384c8dd787({
            scope: t,
            audience: n,
            clientId: o
        }), 60, this.options.useMrrt, r);
        if (i && i.access_token) {
            const { token_type: e, access_token: t, oauthTokenScope: n, expires_in: o } = i, r = await this._getIdTokenFromCache();
            return r && Object.assign(Object.assign({
                id_token: r.id_token,
                token_type: e || "Bearer",
                access_token: t
            }, n ? {
                scope: n
            } : null), {
                expires_in: o
            });
        }
    }
    async _requestToken(e, t) {
        var n, o;
        const { nonceIn: r, organization: i, scopesToRequest: a } = t || {}, s = await $414e231c569bbbbf$var$se(Object.assign(Object.assign({
            baseUrl: this.domainUrl,
            client_id: this.options.clientId,
            auth0Client: this.options.auth0Client,
            useFormData: this.options.useFormData,
            timeout: this.httpTimeoutMs,
            useMrrt: this.options.useMrrt,
            dpop: this.dpop
        }, e), {
            scope: a || e.scope
        }), this.worker), c = await this._verifyIdToken(s.id_token, r, i);
        if ("authorization_code" === e.grant_type) {
            const e = await this._getIdTokenFromCache();
            (null === (o = null === (n = null == e ? void 0 : e.decodedToken) || void 0 === n ? void 0 : n.claims) || void 0 === o ? void 0 : o.sub) && e.decodedToken.claims.sub !== c.claims.sub && (await this.cacheManager.clear(this.options.clientId), this.userCache.remove("@@user@@"));
        }
        return await this._saveEntryInCache(Object.assign(Object.assign(Object.assign(Object.assign({}, s), {
            decodedToken: c,
            scope: e.scope,
            audience: e.audience || "default"
        }), s.scope ? {
            oauthTokenScope: s.scope
        } : null), {
            client_id: this.options.clientId
        })), this.cookieStorage.save(this.isAuthenticatedCookieName, !0, {
            daysUntilExpire: this.sessionCheckExpiryDays,
            cookieDomain: this.options.cookieDomain
        }), this._processOrgHint(i || c.claims.org_id), Object.assign(Object.assign({}, s), {
            decodedToken: c
        });
    }
    async loginWithCustomTokenExchange(e) {
        return this._requestToken(Object.assign(Object.assign({}, e), {
            grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
            subject_token: e.subject_token,
            subject_token_type: e.subject_token_type,
            scope: $414e231c569bbbbf$var$le(this.scope, e.scope, e.audience || this.options.authorizationParams.audience),
            audience: e.audience || this.options.authorizationParams.audience,
            organization: e.organization || this.options.authorizationParams.organization
        }));
    }
    async exchangeToken(e) {
        return this.loginWithCustomTokenExchange(e);
    }
    _assertDpop(e) {
        if (!e) throw new Error("`useDpop` option must be enabled before using DPoP.");
    }
    getDpopNonce(e) {
        return this._assertDpop(this.dpop), this.dpop.getNonce(e);
    }
    setDpopNonce(e, t) {
        return this._assertDpop(this.dpop), this.dpop.setNonce(e, t);
    }
    generateDpopProof(e) {
        return this._assertDpop(this.dpop), this.dpop.generateProof(e);
    }
    createFetcher() {
        let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
        return new $414e231c569bbbbf$var$Be(e, {
            isDpopEnabled: ()=>!!this.options.useDpop,
            getAccessToken: (e)=>{
                var t;
                return this.getTokenSilently({
                    authorizationParams: {
                        scope: null === (t = null == e ? void 0 : e.scope) || void 0 === t ? void 0 : t.join(" "),
                        audience: null == e ? void 0 : e.audience
                    },
                    detailedResponse: !0
                });
            },
            getDpopNonce: ()=>this.getDpopNonce(e.dpopNonceId),
            setDpopNonce: (t)=>this.setDpopNonce(t, e.dpopNonceId),
            generateDpopProof: (e)=>this.generateDpopProof(e)
        });
    }
    async connectAccountWithRedirect(e) {
        const { openUrl: t, appState: n, connection: o, scopes: r, authorization_params: i, redirectUri: a = this.options.authorizationParams.redirect_uri || window.location.origin } = e;
        if (!o) throw new Error("connection is required");
        const s = $414e231c569bbbbf$var$x($414e231c569bbbbf$var$O()), c = $414e231c569bbbbf$var$O(), u = await $414e231c569bbbbf$var$K(c), l = $414e231c569bbbbf$var$U(u), { connect_uri: d, connect_params: h, auth_session: p } = await this.myAccountApi.connectAccount({
            connection: o,
            scopes: r,
            redirect_uri: a,
            state: s,
            code_challenge: l,
            code_challenge_method: "S256",
            authorization_params: i
        });
        this.transactionManager.create({
            state: s,
            code_verifier: c,
            auth_session: p,
            redirect_uri: a,
            appState: n,
            connection: o,
            response_type: $414e231c569bbbbf$export$7390b1e457b4cb6f.ConnectCode
        });
        const f = new URL(d);
        f.searchParams.set("ticket", h.ticket), t ? await t(f.toString()) : window.location.assign(f);
    }
    async _requestTokenForMfa(t, n) {
        const { mfaToken: o } = t, r = $414e231c569bbbbf$var$e(t, [
            "mfaToken"
        ]);
        return this._requestToken(Object.assign(Object.assign({}, r), {
            mfa_token: o
        }), n);
    }
}
async function $414e231c569bbbbf$export$9fa2cfec0168886e(e) {
    const t = new $414e231c569bbbbf$export$b50978e389d6e1d5(e);
    return await t.checkSession(), t;
}



let $128dd395bc2881df$var$auth0Client;
const $128dd395bc2881df$export$6ec1c89625bf577a = async ()=>{
    $128dd395bc2881df$var$auth0Client = new (0, $414e231c569bbbbf$export$b50978e389d6e1d5)({
        domain: (0, $a13d063d3fb3aa31$export$6ed6116aaa4a07d6),
        clientId: (0, $a13d063d3fb3aa31$export$458778b94eb61719),
        authorizationParams: {
            audience: 'https://api-core.auravision.ai'
        }
    });
    await $128dd395bc2881df$var$auth0Client.checkSession();
    return $128dd395bc2881df$var$auth0Client;
};
const $128dd395bc2881df$export$d320cf6efb0385ef = async ()=>{
    return $128dd395bc2881df$var$auth0Client ? await $128dd395bc2881df$var$auth0Client.isAuthenticated() : false;
};
const $128dd395bc2881df$export$caa56256f2cca349 = ()=>$128dd395bc2881df$var$auth0Client;


// ---------------------- Authenticated Routes
const $711b21ca0f0dd1b5$var$Wrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
  padding: 2em;
  background: ${(0, $2df8c38f80e77278$export$f1fbbe1776f7d7f)};
  width: 100%;
  text-align: center;
  height: 100vh;
`;
const $711b21ca0f0dd1b5$export$e94eec0db1e8c995 = ()=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($711b21ca0f0dd1b5$var$Wrapper, {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
            className: (0, $2cfd35af7ec11fdd$exports).SMALL
        })
    });
// ---------------------- Auth0Wrapper
const $711b21ca0f0dd1b5$export$9b8f089fab3cf7ba = ({ children: children })=>{
    const [ready, setReady] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        (0, $128dd395bc2881df$export$6ec1c89625bf577a)().then((auth0Client)=>{
            const { search: search } = window.location;
            if (search.includes('code=') && search.includes('state=')) auth0Client.handleRedirectCallback().then(()=>{
                window.history.replaceState(null, '', window.location.pathname);
            }).catch(()=>{
                window.history.replaceState(null, '', window.location.pathname);
            }).finally(()=>{
                setReady(true);
            });
            else setReady(true);
        });
    }, []);
    return ready ? children : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($711b21ca0f0dd1b5$export$e94eec0db1e8c995, {});
};
// ---------------------- Authenticated Layout Route
const $711b21ca0f0dd1b5$export$f0f76eeab536c10d = ({ login: login })=>{
    const [authCheckComplete, setAuthCheckComplete] = (0, $kYL7Z.useState)(false);
    const [isAuthenticated, setIsAuthenticated] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        (0, $128dd395bc2881df$export$d320cf6efb0385ef)().then((result)=>{
            setAuthCheckComplete(true);
            setIsAuthenticated(result);
        });
    }, []);
    if (!authCheckComplete) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($711b21ca0f0dd1b5$export$e94eec0db1e8c995, {});
    if (!isAuthenticated) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$444b3ab0cb9aec40), {
        to: login
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$910ae8079b2c2852), {});
};



parcelRequire("kYL7Z");





var $kYL7Z = parcelRequire("kYL7Z");
/* !
 * (c) Copyright 2024 Palantir Technologies Inc. All rights reserved.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function $7544862da546e887$export$dedd81df7bc1307(value) {
    return value != null && typeof value !== "function";
}
function $7544862da546e887$export$76025ed275866d92(value) {
    return typeof value === "function";
}
function $7544862da546e887$export$4bb192c7cacf928f(refTarget, ref) {
    if ($7544862da546e887$export$dedd81df7bc1307(refTarget)) // HACKHACK: .current property is readonly
    refTarget.current = ref;
    else if ($7544862da546e887$export$76025ed275866d92(refTarget)) refTarget(ref);
}
function $7544862da546e887$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            $7544862da546e887$export$4bb192c7cacf928f(ref, value);
        });
    };
}
function $7544862da546e887$export$f0c653cfd7dea798(ref) {
    if (ref === null) return null;
    if (typeof ref.current === "undefined") return ref;
    return ref.current;
}
function $7544862da546e887$export$e9e0d2af9a57b401(refTargetParent, refTargetKey, refProp) {
    return (ref)=>{
        refTargetParent[refTargetKey] = ref;
        $7544862da546e887$export$4bb192c7cacf928f(refProp, ref);
    };
}

var $5f04c694ca05154e$exports = {};

$parcel$export($5f04c694ca05154e$exports, "clickElementOnKeyPress", () => $5f6dd9e57dfd2e30$export$d429894ed4cff305);
$parcel$export($5f04c694ca05154e$exports, "elementIsOrContains", () => $5f6dd9e57dfd2e30$export$3c0fcc112e8e7788);
$parcel$export($5f04c694ca05154e$exports, "elementIsTextInput", () => $5f6dd9e57dfd2e30$export$dea6a6e5494f51e0);
$parcel$export($5f04c694ca05154e$exports, "getActiveElement", () => $5f6dd9e57dfd2e30$export$cd4e5573fbe2b576);
$parcel$export($5f04c694ca05154e$exports, "getFocusableElements", () => $5f6dd9e57dfd2e30$export$433aaa1f216cf32d);
$parcel$export($5f04c694ca05154e$exports, "throttle", () => $5f6dd9e57dfd2e30$export$de363e709c412c8a);
$parcel$export($5f04c694ca05154e$exports, "throttleEvent", () => $5f6dd9e57dfd2e30$export$4897e46a283195b6);
$parcel$export($5f04c694ca05154e$exports, "throttleReactEventCallback", () => $5f6dd9e57dfd2e30$export$deef02b46be8a843);
$parcel$export($5f04c694ca05154e$exports, "isFunction", () => $4fe78071c01b0041$export$f6e2535fb5126e54);
$parcel$export($5f04c694ca05154e$exports, "isDarkTheme", () => $af71190e8aacd531$export$5a63ccfbe4d87ef0);
$parcel$export($5f04c694ca05154e$exports, "setRef", () => $7544862da546e887$export$4bb192c7cacf928f);
$parcel$export($5f04c694ca05154e$exports, "getRef", () => $7544862da546e887$export$f0c653cfd7dea798);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b34da589af313d88$exports = {};

$parcel$export($b34da589af313d88$exports, "arraysEqual", () => $b34da589af313d88$export$234180f8206db11b);
$parcel$export($b34da589af313d88$exports, "shallowCompareKeys", () => $b34da589af313d88$export$d9dfaae715e1ab60);
$parcel$export($b34da589af313d88$exports, "deepCompareKeys", () => $b34da589af313d88$export$64d4bb231c0f132b);
$parcel$export($b34da589af313d88$exports, "getDeepUnequalKeyValues", () => $b34da589af313d88$export$685403fd77bd7c39);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns true if the arrays are equal. Elements will be shallowly compared by
 * default, or they will be compared using the custom `compare` function if one
 * is provided.
 */ function $b34da589af313d88$export$234180f8206db11b(arrA, arrB, compare = (a, b)=>a === b) {
    // treat `null` and `undefined` as the same
    if (arrA == null && arrB == null) return true;
    else if (arrA == null || arrB == null || arrA.length !== arrB.length) return false;
    else return arrA.every((a, i)=>compare(a, arrB[i]));
}
function $b34da589af313d88$export$d9dfaae715e1ab60(objA, objB, keys) {
    // treat `null` and `undefined` as the same
    if (objA == null && objB == null) return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return false;
    else if (keys != null) return $b34da589af313d88$var$shallowCompareKeysImpl(objA, objB, keys);
    else {
        // shallowly compare all keys from both objects
        const keysA = Object.keys(objA);
        const keysB = Object.keys(objB);
        return $b34da589af313d88$var$shallowCompareKeysImpl(objA, objB, {
            include: keysA
        }) && $b34da589af313d88$var$shallowCompareKeysImpl(objA, objB, {
            include: keysB
        });
    }
}
function $b34da589af313d88$export$64d4bb231c0f132b(objA, objB, keys) {
    if (objA === objB) return true;
    else if (objA == null && objB == null) // treat `null` and `undefined` as the same
    return true;
    else if (objA == null || objB == null) return false;
    else if (Array.isArray(objA) || Array.isArray(objB)) return $b34da589af313d88$export$234180f8206db11b(objA, objB, $b34da589af313d88$export$64d4bb231c0f132b);
    else if ($b34da589af313d88$var$isSimplePrimitiveType(objA) || $b34da589af313d88$var$isSimplePrimitiveType(objB)) return objA === objB;
    else if (keys != null) return $b34da589af313d88$var$deepCompareKeysImpl(objA, objB, keys);
    else if (objA.constructor !== objB.constructor) return false;
    else {
        const keysA = Object.keys(objA);
        const keysB = Object.keys(objB);
        if (keysA == null || keysB == null) return false;
        if (keysA.length === 0 && keysB.length === 0) return true;
        return $b34da589af313d88$export$234180f8206db11b(keysA, keysB) && $b34da589af313d88$var$deepCompareKeysImpl(objA, objB, keysA);
    }
}
function $b34da589af313d88$export$685403fd77bd7c39(objA = {}, objB = {}, keys) {
    const filteredKeys = keys == null ? $b34da589af313d88$var$unionKeys(objA, objB) : keys;
    return $b34da589af313d88$var$getUnequalKeyValues(objA, objB, filteredKeys, (a, b, key)=>{
        return $b34da589af313d88$export$64d4bb231c0f132b(a, b, [
            key
        ]);
    });
}
// Private helpers
// ===============
/**
 * Partial shallow comparison between objects using the given list of keys.
 */ function $b34da589af313d88$var$shallowCompareKeysImpl(objA, objB, keys) {
    return $b34da589af313d88$var$filterKeys(objA, objB, keys).every((key)=>{
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && objA[key] === objB[key];
    });
}
/**
 * Partial deep comparison between objects using the given list of keys.
 */ function $b34da589af313d88$var$deepCompareKeysImpl(objA, objB, keys) {
    return keys.every((key)=>{
        return objA.hasOwnProperty(key) === objB.hasOwnProperty(key) && $b34da589af313d88$export$64d4bb231c0f132b(objA[key], objB[key]);
    });
}
function $b34da589af313d88$var$isSimplePrimitiveType(value) {
    return typeof value === "number" || typeof value === "string" || typeof value === "boolean";
}
function $b34da589af313d88$var$filterKeys(objA, objB, keys) {
    if ($b34da589af313d88$var$isAllowlist(keys)) return keys.include;
    else if ($b34da589af313d88$var$isDenylist(keys)) {
        const keysA = Object.keys(objA);
        const keysB = Object.keys(objB);
        // merge keys from both objects into a big set for quick access
        const keySet = $b34da589af313d88$var$arrayToObject(keysA.concat(keysB));
        // delete denied keys from the key set
        keys.exclude.forEach((key)=>delete keySet[key]);
        // return the remaining keys as an array
        return Object.keys(keySet);
    }
    return [];
}
function $b34da589af313d88$var$isAllowlist(keys) {
    return keys != null && keys.include != null;
}
function $b34da589af313d88$var$isDenylist(keys) {
    return keys != null && keys.exclude != null;
}
function $b34da589af313d88$var$arrayToObject(arr) {
    return arr.reduce((obj, element)=>{
        obj[element] = true;
        return obj;
    }, {});
}
function $b34da589af313d88$var$getUnequalKeyValues(objA, objB, keys, compareFn) {
    const unequalKeys = keys.filter((key)=>!compareFn(objA, objB, key));
    const unequalKeyValues = unequalKeys.map((key)=>({
            key: key,
            valueA: objA[key],
            valueB: objB[key]
        }));
    return unequalKeyValues;
}
function $b34da589af313d88$var$unionKeys(objA, objB) {
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    const concatKeys = keysA.concat(keysB);
    const keySet = $b34da589af313d88$var$arrayToObject(concatKeys);
    return Object.keys(keySet);
}


/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** @returns true if React is running in a client environment, and false if it's in a server */ function $5f6dd9e57dfd2e30$export$974c8c6d1fbc6154() {
    return typeof window !== "undefined" && window.document != null;
}
function $5f6dd9e57dfd2e30$export$3c0fcc112e8e7788(element, testElement) {
    return element === testElement || element.contains(testElement);
}
function $5f6dd9e57dfd2e30$export$dea6a6e5494f51e0(elem) {
    // we check these cases for unit testing, but this should not happen
    // during normal operation
    if (elem == null || elem.closest == null) return false;
    const editable = elem.closest("input, textarea, [contenteditable=true]");
    if (editable == null) return false;
    // don't let checkboxes, switches, and radio buttons prevent hotkey behavior
    if (editable.tagName.toLowerCase() === "input") {
        const inputType = editable.type;
        if (inputType === "checkbox" || inputType === "radio") return false;
    }
    // don't let read-only fields prevent hotkey behavior
    if (editable.readOnly) return false;
    return true;
}
function $5f6dd9e57dfd2e30$export$cd4e5573fbe2b576(element, options) {
    const rootNode = element?.getRootNode(options) ?? document;
    const activeElement = rootNode.activeElement;
    return activeElement instanceof HTMLElement ? activeElement : null;
}
function $5f6dd9e57dfd2e30$export$4897e46a283195b6(target, eventName, newEventName) {
    const throttledFunc = $5f6dd9e57dfd2e30$var$throttleImpl((event)=>{
        target.dispatchEvent(new CustomEvent(newEventName, event));
    });
    target.addEventListener(eventName, throttledFunc);
    return throttledFunc;
}
function $5f6dd9e57dfd2e30$export$deef02b46be8a843(callback, options = {}) {
    const throttledFunc = $5f6dd9e57dfd2e30$var$throttleImpl(callback, (event2)=>{
        if (options.preventDefault) event2.preventDefault();
    }, // prevent React from reclaiming the event object before we reference it
    (event2)=>event2.persist());
    return throttledFunc;
}
function $5f6dd9e57dfd2e30$export$de363e709c412c8a(method) {
    return $5f6dd9e57dfd2e30$var$throttleImpl(method);
}
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $5f6dd9e57dfd2e30$var$throttleImpl(onAnimationFrameRequested, onBeforeIsRunningCheck, onAfterIsRunningCheck) {
    let isRunning = false;
    const func = (...args)=>{
        onBeforeIsRunningCheck?.(...args);
        if (isRunning) return;
        isRunning = true;
        onAfterIsRunningCheck?.(...args);
        requestAnimationFrame(()=>{
            onAnimationFrameRequested(...args);
            isRunning = false;
        });
    };
    return func;
}
function $5f6dd9e57dfd2e30$export$d429894ed4cff305(keys) {
    return (e)=>{
        if (keys.some((key)=>e.key === key)) {
            // Prevent spacebar from scrolling the page unless we're in a text field
            if (!$5f6dd9e57dfd2e30$export$dea6a6e5494f51e0(e.target)) e.preventDefault();
            e.target.dispatchEvent(new MouseEvent("click", {
                ...e,
                view: undefined
            }));
        }
    };
}
/**
 * Selector for all possible focusable items.
 *
 * Derived from this SO question: {@link https://stackoverflow.com/questions/1599660/which-html-elements-can-receive-focus}
 *
 * Note: Order may not be correct if children elements use tabindex values > 0.
 */ const $5f6dd9e57dfd2e30$var$SELECTOR_FOCUSABLE = [
    'a[href]:not([tabindex="-1"])',
    'button:not([disabled]):not([tabindex="-1"])',
    'details:not([tabindex="-1"])',
    'input:not([disabled]):not([tabindex="-1"])',
    'select:not([disabled]):not([tabindex="-1"])',
    'textarea:not([disabled]):not([tabindex="-1"])',
    '[tabindex]:not([tabindex="-1"])'
].join(",");
function $5f6dd9e57dfd2e30$export$433aaa1f216cf32d(element) {
    return Array.from(element.querySelectorAll($5f6dd9e57dfd2e30$var$SELECTOR_FOCUSABLE));
}


/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns whether the value is a function. Acts as a type guard. */ /* istanbul ignore next */ // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $4fe78071c01b0041$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}



var $dd6a2a6ae729b1ca$exports = {};

$parcel$export($dd6a2a6ae729b1ca$exports, "isReactNodeEmpty", () => $dd6a2a6ae729b1ca$export$5a81b62107752acd);
$parcel$export($dd6a2a6ae729b1ca$exports, "isReactChildrenElementOrElements", () => $dd6a2a6ae729b1ca$export$1a5f9f98c90cf6a1);
$parcel$export($dd6a2a6ae729b1ca$exports, "ensureElement", () => $dd6a2a6ae729b1ca$export$7210cc31459d553a);
$parcel$export($dd6a2a6ae729b1ca$exports, "isReactElement", () => $dd6a2a6ae729b1ca$export$564ec7e3bcdb7847);
$parcel$export($dd6a2a6ae729b1ca$exports, "isElementOfType", () => $dd6a2a6ae729b1ca$export$8bb8d43ade7732d8);
/*
 * Copyright 2020 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

function $dd6a2a6ae729b1ca$export$5a81b62107752acd(node, skipArray = false) {
    return node == null || node === "" || node === false || !skipArray && Array.isArray(node) && // only recurse one level through arrays, for performance
    (node.length === 0 || node.every((n)=>$dd6a2a6ae729b1ca$export$5a81b62107752acd(n, true)));
}
function $dd6a2a6ae729b1ca$export$1a5f9f98c90cf6a1(children) {
    return !$dd6a2a6ae729b1ca$export$5a81b62107752acd(children, true) && children !== true;
}
function $dd6a2a6ae729b1ca$export$7210cc31459d553a(child, tagName = "span", props = {}) {
    if (child == null || typeof child === "boolean" || (0, $f141b3b4d406798c$export$78d1711480f95c3e)(child)) return undefined;
    else if (typeof child === "string" || typeof child === "number" || $dd6a2a6ae729b1ca$var$isReactFragment(child) || $dd6a2a6ae729b1ca$var$isReactNodeArray(child)) // wrap the child element
    return (0, $kYL7Z.createElement)(tagName, props, child);
    else if ($dd6a2a6ae729b1ca$export$564ec7e3bcdb7847(child)) {
        if (Object.keys(props).length > 0) // clone the element and merge props
        return (0, $kYL7Z.cloneElement)(child, props);
        else // nothing to do, it's a valid ReactElement
        return child;
    } else // child is inferred as {}
    return undefined;
}
function $dd6a2a6ae729b1ca$export$564ec7e3bcdb7847(child) {
    return typeof child === "object" && typeof child.type !== "undefined" && typeof child.props !== "undefined";
}
function $dd6a2a6ae729b1ca$var$isReactFragment(child) {
    // bit hacky, but generally works
    return typeof child.type === "symbol";
}
function $dd6a2a6ae729b1ca$var$isReactNodeArray(child) {
    return Array.isArray(child);
}
function $dd6a2a6ae729b1ca$export$8bb8d43ade7732d8(element, ComponentType) {
    return element != null && element.type != null && element.type.displayName != null && element.type.displayName === ComponentType.displayName;
}


var $71cd9eef18a80484$exports = {};

$parcel$export($71cd9eef18a80484$exports, "isKeyboardClick", () => $71cd9eef18a80484$export$746ace428e2a5877);
$parcel$export($71cd9eef18a80484$exports, "isArrowKey", () => $71cd9eef18a80484$export$a0d3f776048184d0);
$parcel$export($71cd9eef18a80484$exports, "getArrowKeyDirection", () => $71cd9eef18a80484$export$dbbacc1a71add06d);
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns whether the keyboard event was triggered by Enter or Space, the two keys that are expected to trigger
 * interactive elements like buttons.
 */ function $71cd9eef18a80484$export$746ace428e2a5877(event) {
    return event.key === "Enter" || event.key === " ";
}
const $71cd9eef18a80484$var$ARROW_KEYS = [
    "ArrowUp",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight"
];
function $71cd9eef18a80484$export$a0d3f776048184d0(event) {
    return $71cd9eef18a80484$var$ARROW_KEYS.includes(event.key);
}
function $71cd9eef18a80484$export$dbbacc1a71add06d(event, /** Keys that result in a return of -1 */ negativeKeys, /** Keys that result in a return of 1 */ positiveKeys) {
    if (negativeKeys.includes(event.key)) return -1;
    else if (positiveKeys.includes(event.key)) return 1;
    return undefined;
}


/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $af71190e8aacd531$export$5a63ccfbe4d87ef0(element) {
    return element != null && element instanceof Element && element.closest(`.${$2cfd35af7ec11fdd$export$b9b16d1820185434}`) != null;
}



$parcel$exportWildcard($5f04c694ca05154e$exports, $b34da589af313d88$exports);
$parcel$exportWildcard($5f04c694ca05154e$exports, $f141b3b4d406798c$exports);
$parcel$exportWildcard($5f04c694ca05154e$exports, $dd6a2a6ae729b1ca$exports);
$parcel$exportWildcard($5f04c694ca05154e$exports, $71cd9eef18a80484$exports);


const $31e2d7b239eaf344$var$DEFAULT_OPTIONS = {
    defaultTabIndex: undefined,
    disabledTabIndex: -1
};
function $31e2d7b239eaf344$export$7c46b9e4cdce0dd5(interactive, props, ref, options = $31e2d7b239eaf344$var$DEFAULT_OPTIONS) {
    const { defaultTabIndex: defaultTabIndex, disabledTabIndex: disabledTabIndex } = options;
    const { active: active, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onBlur: onBlur, tabIndex: tabIndex = defaultTabIndex } = props;
    // the current key being pressed
    const [currentKeyPressed, setCurrentKeyPressed] = (0, $kYL7Z.useState)();
    // whether the button is in "active" state
    const [isActive, setIsActive] = (0, $kYL7Z.useState)(false);
    // our local ref for the interactive element, merged with the consumer's own ref in this hook's return value
    const elementRef = (0, $kYL7Z.useRef)(null);
    const handleBlur = (0, $kYL7Z.useCallback)((e)=>{
        if (isActive) setIsActive(false);
        onBlur?.(e);
    }, [
        isActive,
        onBlur
    ]);
    const handleKeyDown = (0, $kYL7Z.useCallback)((e)=>{
        if ((0, $5f04c694ca05154e$exports).isKeyboardClick(e)) {
            e.preventDefault();
            if (e.key !== currentKeyPressed) setIsActive(true);
        }
        setCurrentKeyPressed(e.key);
        onKeyDown?.(e);
    }, [
        currentKeyPressed,
        onKeyDown
    ]);
    const handleKeyUp = (0, $kYL7Z.useCallback)((e)=>{
        if ((0, $5f04c694ca05154e$exports).isKeyboardClick(e)) {
            setIsActive(false);
            elementRef.current?.click();
        }
        setCurrentKeyPressed(undefined);
        onKeyUp?.(e);
    }, [
        onKeyUp,
        elementRef
    ]);
    const resolvedActive = interactive && (active || isActive);
    return [
        resolvedActive,
        {
            onBlur: handleBlur,
            onClick: interactive ? onClick : undefined,
            onFocus: interactive ? onFocus : undefined,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            ref: (0, $7544862da546e887$export$c9058316764c140e)(elementRef, ref),
            tabIndex: interactive ? tabIndex : disabledTabIndex
        }
    ];
}







var $kYL7Z = parcelRequire("kYL7Z");
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable camelcase */ 
var $euNJf = parcelRequire("euNJf");
var $er4Gf = parcelRequire("er4Gf");

var $er4Gf = parcelRequire("er4Gf");

var $75JmI = parcelRequire("75JmI");
function $3448c1c81f2493a9$export$e1b697368b9a68f5(input, options) {
    if (options === void 0) options = {};
    return (0, $75JmI.noCase)(input, (0, $er4Gf.__assign)({
        delimiter: "."
    }, options));
}


function $143d36162381d76e$export$feae9a740c003485(input, options) {
    if (options === void 0) options = {};
    return (0, $3448c1c81f2493a9$export$e1b697368b9a68f5)(input, (0, $er4Gf.__assign)({
        delimiter: "_"
    }, options));
}


var $2a9b5b4ccace6af5$export$f9661b8856577c15;
(function(BlueprintIcons_16) {
    BlueprintIcons_16["AddChild"] = "add-child";
    BlueprintIcons_16["AddClip"] = "add-clip";
    BlueprintIcons_16["AddColumnLeft"] = "add-column-left";
    BlueprintIcons_16["AddColumnRight"] = "add-column-right";
    BlueprintIcons_16["AddLocation"] = "add-location";
    BlueprintIcons_16["AddParent"] = "add-parent";
    BlueprintIcons_16["AddRowBottom"] = "add-row-bottom";
    BlueprintIcons_16["AddRowTop"] = "add-row-top";
    BlueprintIcons_16["AddToArtifact"] = "add-to-artifact";
    BlueprintIcons_16["AddToFolder"] = "add-to-folder";
    BlueprintIcons_16["Add"] = "add";
    BlueprintIcons_16["AimpointsTarget"] = "aimpoints-target";
    BlueprintIcons_16["Airplane"] = "airplane";
    BlueprintIcons_16["AlignCenter"] = "align-center";
    BlueprintIcons_16["AlignJustify"] = "align-justify";
    BlueprintIcons_16["AlignLeft"] = "align-left";
    BlueprintIcons_16["AlignRight"] = "align-right";
    BlueprintIcons_16["AlignmentBottom"] = "alignment-bottom";
    BlueprintIcons_16["AlignmentHorizontalCenter"] = "alignment-horizontal-center";
    BlueprintIcons_16["AlignmentLeft"] = "alignment-left";
    BlueprintIcons_16["AlignmentRight"] = "alignment-right";
    BlueprintIcons_16["AlignmentTop"] = "alignment-top";
    BlueprintIcons_16["AlignmentVerticalCenter"] = "alignment-vertical-center";
    BlueprintIcons_16["Ammunition"] = "ammunition";
    BlueprintIcons_16["Anchor"] = "anchor";
    BlueprintIcons_16["Annotation"] = "annotation";
    BlueprintIcons_16["Announcement"] = "announcement";
    BlueprintIcons_16["Antenna"] = "antenna";
    BlueprintIcons_16["AppHeader"] = "app-header";
    BlueprintIcons_16["Application"] = "application";
    BlueprintIcons_16["Applications"] = "applications";
    BlueprintIcons_16["Archive"] = "archive";
    BlueprintIcons_16["AreaOfInterest"] = "area-of-interest";
    BlueprintIcons_16["ArrayBoolean"] = "array-boolean";
    BlueprintIcons_16["ArrayDate"] = "array-date";
    BlueprintIcons_16["ArrayFloatingPoint"] = "array-floating-point";
    BlueprintIcons_16["ArrayNumeric"] = "array-numeric";
    BlueprintIcons_16["ArrayObject"] = "array-object";
    BlueprintIcons_16["ArrayString"] = "array-string";
    BlueprintIcons_16["ArrayTimestamp"] = "array-timestamp";
    BlueprintIcons_16["Array"] = "array";
    BlueprintIcons_16["ArrowBottomLeft"] = "arrow-bottom-left";
    BlueprintIcons_16["ArrowBottomRight"] = "arrow-bottom-right";
    BlueprintIcons_16["ArrowDown"] = "arrow-down";
    BlueprintIcons_16["ArrowLeft"] = "arrow-left";
    BlueprintIcons_16["ArrowRight"] = "arrow-right";
    BlueprintIcons_16["ArrowTopLeft"] = "arrow-top-left";
    BlueprintIcons_16["ArrowTopRight"] = "arrow-top-right";
    BlueprintIcons_16["ArrowUp"] = "arrow-up";
    BlueprintIcons_16["ArrowsArc"] = "arrows-arc";
    BlueprintIcons_16["ArrowsHorizontal"] = "arrows-horizontal";
    BlueprintIcons_16["ArrowsVertical"] = "arrows-vertical";
    BlueprintIcons_16["Asterisk"] = "asterisk";
    BlueprintIcons_16["At"] = "at";
    BlueprintIcons_16["AutomaticUpdates"] = "automatic-updates";
    BlueprintIcons_16["Axle"] = "axle";
    BlueprintIcons_16["Backlink"] = "backlink";
    BlueprintIcons_16["BackwardTen"] = "backward-ten";
    BlueprintIcons_16["Badge"] = "badge";
    BlueprintIcons_16["BanCircle"] = "ban-circle";
    BlueprintIcons_16["BankAccount"] = "bank-account";
    BlueprintIcons_16["Barcode"] = "barcode";
    BlueprintIcons_16["BinaryNumber"] = "binary-number";
    BlueprintIcons_16["Blank"] = "blank";
    BlueprintIcons_16["BlockPromote"] = "block-promote";
    BlueprintIcons_16["BlockedPerson"] = "blocked-person";
    BlueprintIcons_16["Bold"] = "bold";
    BlueprintIcons_16["Book"] = "book";
    BlueprintIcons_16["Bookmark"] = "bookmark";
    BlueprintIcons_16["Box"] = "box";
    BlueprintIcons_16["BranchLocked"] = "branch-locked";
    BlueprintIcons_16["BranchUnlocked"] = "branch-unlocked";
    BlueprintIcons_16["Briefcase"] = "briefcase";
    BlueprintIcons_16["BringData"] = "bring-data";
    BlueprintIcons_16["BringForward"] = "bring-forward";
    BlueprintIcons_16["BritishPound"] = "british-pound";
    BlueprintIcons_16["Bug"] = "bug";
    BlueprintIcons_16["Buggy"] = "buggy";
    BlueprintIcons_16["Build"] = "build";
    BlueprintIcons_16["Bullseye"] = "bullseye";
    BlueprintIcons_16["Calculator"] = "calculator";
    BlueprintIcons_16["Calendar"] = "calendar";
    BlueprintIcons_16["Camera"] = "camera";
    BlueprintIcons_16["CaretDown"] = "caret-down";
    BlueprintIcons_16["CaretLeft"] = "caret-left";
    BlueprintIcons_16["CaretRight"] = "caret-right";
    BlueprintIcons_16["CaretUp"] = "caret-up";
    BlueprintIcons_16["CargoShip"] = "cargo-ship";
    BlueprintIcons_16["CellTower"] = "cell-tower";
    BlueprintIcons_16["Changes"] = "changes";
    BlueprintIcons_16["Chart"] = "chart";
    BlueprintIcons_16["Chat"] = "chat";
    BlueprintIcons_16["ChevronBackward"] = "chevron-backward";
    BlueprintIcons_16["ChevronDown"] = "chevron-down";
    BlueprintIcons_16["ChevronForward"] = "chevron-forward";
    BlueprintIcons_16["ChevronLeft"] = "chevron-left";
    BlueprintIcons_16["ChevronRight"] = "chevron-right";
    BlueprintIcons_16["ChevronUp"] = "chevron-up";
    BlueprintIcons_16["CircleArrowDown"] = "circle-arrow-down";
    BlueprintIcons_16["CircleArrowLeft"] = "circle-arrow-left";
    BlueprintIcons_16["CircleArrowRight"] = "circle-arrow-right";
    BlueprintIcons_16["CircleArrowUp"] = "circle-arrow-up";
    BlueprintIcons_16["Circle"] = "circle";
    BlueprintIcons_16["Citation"] = "citation";
    BlueprintIcons_16["Clean"] = "clean";
    BlueprintIcons_16["Clip"] = "clip";
    BlueprintIcons_16["ClipboardFile"] = "clipboard-file";
    BlueprintIcons_16["Clipboard"] = "clipboard";
    BlueprintIcons_16["CloudDownload"] = "cloud-download";
    BlueprintIcons_16["CloudServer"] = "cloud-server";
    BlueprintIcons_16["CloudTick"] = "cloud-tick";
    BlueprintIcons_16["CloudUpload"] = "cloud-upload";
    BlueprintIcons_16["Cloud"] = "cloud";
    BlueprintIcons_16["CodeBlock"] = "code-block";
    BlueprintIcons_16["Code"] = "code";
    BlueprintIcons_16["Cog"] = "cog";
    BlueprintIcons_16["CollapseAll"] = "collapse-all";
    BlueprintIcons_16["ColorFill"] = "color-fill";
    BlueprintIcons_16["ColumnLayout"] = "column-layout";
    BlueprintIcons_16["Comment"] = "comment";
    BlueprintIcons_16["Comparison"] = "comparison";
    BlueprintIcons_16["Compass"] = "compass";
    BlueprintIcons_16["Compressed"] = "compressed";
    BlueprintIcons_16["Confirm"] = "confirm";
    BlueprintIcons_16["ConsoleAlert"] = "console-alert";
    BlueprintIcons_16["Console"] = "console";
    BlueprintIcons_16["Construction"] = "construction";
    BlueprintIcons_16["Contrast"] = "contrast";
    BlueprintIcons_16["Control"] = "control";
    BlueprintIcons_16["CreditCard"] = "credit-card";
    BlueprintIcons_16["Crop"] = "crop";
    BlueprintIcons_16["CrossCircle"] = "cross-circle";
    BlueprintIcons_16["Cross"] = "cross";
    BlueprintIcons_16["Crown"] = "crown";
    BlueprintIcons_16["CssStyle"] = "css-style";
    BlueprintIcons_16["CubeAdd"] = "cube-add";
    BlueprintIcons_16["CubeCutout"] = "cube-cutout";
    BlueprintIcons_16["CubeCutouts"] = "cube-cutouts";
    BlueprintIcons_16["CubeEdit"] = "cube-edit";
    BlueprintIcons_16["CubeRemove"] = "cube-remove";
    BlueprintIcons_16["Cube"] = "cube";
    BlueprintIcons_16["Cubes"] = "cubes";
    BlueprintIcons_16["CurlyBraces"] = "curly-braces";
    BlueprintIcons_16["CurvedRangeChart"] = "curved-range-chart";
    BlueprintIcons_16["Cut"] = "cut";
    BlueprintIcons_16["Cycle"] = "cycle";
    BlueprintIcons_16["Dashboard"] = "dashboard";
    BlueprintIcons_16["DataCloud"] = "data-cloud";
    BlueprintIcons_16["DataConnection"] = "data-connection";
    BlueprintIcons_16["DataLineage"] = "data-lineage";
    BlueprintIcons_16["DataSearch"] = "data-search";
    BlueprintIcons_16["DataSync"] = "data-sync";
    BlueprintIcons_16["Database"] = "database";
    BlueprintIcons_16["DeleteClip"] = "delete-clip";
    BlueprintIcons_16["Delete"] = "delete";
    BlueprintIcons_16["Delta"] = "delta";
    BlueprintIcons_16["DeriveColumn"] = "derive-column";
    BlueprintIcons_16["Desktop"] = "desktop";
    BlueprintIcons_16["Detection"] = "detection";
    BlueprintIcons_16["Diagnosis"] = "diagnosis";
    BlueprintIcons_16["DiagramTree"] = "diagram-tree";
    BlueprintIcons_16["DirectionLeft"] = "direction-left";
    BlueprintIcons_16["DirectionRight"] = "direction-right";
    BlueprintIcons_16["Disable"] = "disable";
    BlueprintIcons_16["Divide"] = "divide";
    BlueprintIcons_16["DocumentCode"] = "document-code";
    BlueprintIcons_16["DocumentLocked"] = "document-locked";
    BlueprintIcons_16["DocumentOpen"] = "document-open";
    BlueprintIcons_16["DocumentShare"] = "document-share";
    BlueprintIcons_16["Document"] = "document";
    BlueprintIcons_16["Dollar"] = "dollar";
    BlueprintIcons_16["Dot"] = "dot";
    BlueprintIcons_16["DoubleCaretHorizontal"] = "double-caret-horizontal";
    BlueprintIcons_16["DoubleCaretVertical"] = "double-caret-vertical";
    BlueprintIcons_16["DoubleChevronDown"] = "double-chevron-down";
    BlueprintIcons_16["DoubleChevronLeft"] = "double-chevron-left";
    BlueprintIcons_16["DoubleChevronRight"] = "double-chevron-right";
    BlueprintIcons_16["DoubleChevronUp"] = "double-chevron-up";
    BlueprintIcons_16["DoughnutChart"] = "doughnut-chart";
    BlueprintIcons_16["Download"] = "download";
    BlueprintIcons_16["DragHandleHorizontal"] = "drag-handle-horizontal";
    BlueprintIcons_16["DragHandleVertical"] = "drag-handle-vertical";
    BlueprintIcons_16["Draw"] = "draw";
    BlueprintIcons_16["DrawerLeftFilled"] = "drawer-left-filled";
    BlueprintIcons_16["DrawerLeft"] = "drawer-left";
    BlueprintIcons_16["DrawerRightFilled"] = "drawer-right-filled";
    BlueprintIcons_16["DrawerRight"] = "drawer-right";
    BlueprintIcons_16["DriveTime"] = "drive-time";
    BlueprintIcons_16["DroneUav"] = "drone-uav";
    BlueprintIcons_16["Drone"] = "drone";
    BlueprintIcons_16["Duplicate"] = "duplicate";
    BlueprintIcons_16["Edit"] = "edit";
    BlueprintIcons_16["Eject"] = "eject";
    BlueprintIcons_16["Emoji"] = "emoji";
    BlueprintIcons_16["Endnote"] = "endnote";
    BlueprintIcons_16["Endorsed"] = "endorsed";
    BlueprintIcons_16["Envelope"] = "envelope";
    BlueprintIcons_16["Equals"] = "equals";
    BlueprintIcons_16["Eraser"] = "eraser";
    BlueprintIcons_16["Error"] = "error";
    BlueprintIcons_16["Euro"] = "euro";
    BlueprintIcons_16["Excavator"] = "excavator";
    BlueprintIcons_16["Exchange"] = "exchange";
    BlueprintIcons_16["ExcludeRow"] = "exclude-row";
    BlueprintIcons_16["ExpandAll"] = "expand-all";
    BlueprintIcons_16["Explain"] = "explain";
    BlueprintIcons_16["Export"] = "export";
    BlueprintIcons_16["EyeOff"] = "eye-off";
    BlueprintIcons_16["EyeOn"] = "eye-on";
    BlueprintIcons_16["EyeOpen"] = "eye-open";
    BlueprintIcons_16["FastBackward"] = "fast-backward";
    BlueprintIcons_16["FastForward"] = "fast-forward";
    BlueprintIcons_16["FeedSubscribed"] = "feed-subscribed";
    BlueprintIcons_16["Feed"] = "feed";
    BlueprintIcons_16["FighterJet"] = "fighter-jet";
    BlueprintIcons_16["Film"] = "film";
    BlueprintIcons_16["FilterKeep"] = "filter-keep";
    BlueprintIcons_16["FilterList"] = "filter-list";
    BlueprintIcons_16["FilterOpen"] = "filter-open";
    BlueprintIcons_16["FilterRemove"] = "filter-remove";
    BlueprintIcons_16["FilterSortAsc"] = "filter-sort-asc";
    BlueprintIcons_16["FilterSortDesc"] = "filter-sort-desc";
    BlueprintIcons_16["Filter"] = "filter";
    BlueprintIcons_16["Flag"] = "flag";
    BlueprintIcons_16["Flame"] = "flame";
    BlueprintIcons_16["Flash"] = "flash";
    BlueprintIcons_16["FloatingPoint"] = "floating-point";
    BlueprintIcons_16["FloppyDisk"] = "floppy-disk";
    BlueprintIcons_16["FlowBranch"] = "flow-branch";
    BlueprintIcons_16["FlowEnd"] = "flow-end";
    BlueprintIcons_16["FlowLinear"] = "flow-linear";
    BlueprintIcons_16["FlowReviewBranch"] = "flow-review-branch";
    BlueprintIcons_16["FlowReview"] = "flow-review";
    BlueprintIcons_16["Flows"] = "flows";
    BlueprintIcons_16["FolderClose"] = "folder-close";
    BlueprintIcons_16["FolderNew"] = "folder-new";
    BlueprintIcons_16["FolderOpen"] = "folder-open";
    BlueprintIcons_16["FolderSharedOpen"] = "folder-shared-open";
    BlueprintIcons_16["FolderShared"] = "folder-shared";
    BlueprintIcons_16["Follower"] = "follower";
    BlueprintIcons_16["Following"] = "following";
    BlueprintIcons_16["Font"] = "font";
    BlueprintIcons_16["ForkEnd"] = "fork-end";
    BlueprintIcons_16["Fork"] = "fork";
    BlueprintIcons_16["Form"] = "form";
    BlueprintIcons_16["ForwardTen"] = "forward-ten";
    BlueprintIcons_16["Fuel"] = "fuel";
    BlueprintIcons_16["FullCircle"] = "full-circle";
    BlueprintIcons_16["FullStackedChart"] = "full-stacked-chart";
    BlueprintIcons_16["Fullscreen"] = "fullscreen";
    BlueprintIcons_16["FunctionMinimal"] = "function-minimal";
    BlueprintIcons_16["Function"] = "function";
    BlueprintIcons_16["GanttChart"] = "gantt-chart";
    BlueprintIcons_16["Generate"] = "generate";
    BlueprintIcons_16["Geofence"] = "geofence";
    BlueprintIcons_16["Geolocation"] = "geolocation";
    BlueprintIcons_16["Geosearch"] = "geosearch";
    BlueprintIcons_16["Geotime"] = "geotime";
    BlueprintIcons_16["GiftBox"] = "gift-box";
    BlueprintIcons_16["GitBranch"] = "git-branch";
    BlueprintIcons_16["GitCommit"] = "git-commit";
    BlueprintIcons_16["GitMerge"] = "git-merge";
    BlueprintIcons_16["GitNewBranch"] = "git-new-branch";
    BlueprintIcons_16["GitPull"] = "git-pull";
    BlueprintIcons_16["GitPush"] = "git-push";
    BlueprintIcons_16["GitRebase"] = "git-rebase";
    BlueprintIcons_16["GitRepo"] = "git-repo";
    BlueprintIcons_16["Glass"] = "glass";
    BlueprintIcons_16["GlobeNetworkAdd"] = "globe-network-add";
    BlueprintIcons_16["GlobeNetwork"] = "globe-network";
    BlueprintIcons_16["Globe"] = "globe";
    BlueprintIcons_16["GraphRemove"] = "graph-remove";
    BlueprintIcons_16["Graph"] = "graph";
    BlueprintIcons_16["GreaterThanOrEqualTo"] = "greater-than-or-equal-to";
    BlueprintIcons_16["GreaterThan"] = "greater-than";
    BlueprintIcons_16["GridView"] = "grid-view";
    BlueprintIcons_16["Grid"] = "grid";
    BlueprintIcons_16["GroupItem"] = "group-item";
    BlueprintIcons_16["GroupObjects"] = "group-objects";
    BlueprintIcons_16["GroupedBarChart"] = "grouped-bar-chart";
    BlueprintIcons_16["HandDown"] = "hand-down";
    BlueprintIcons_16["HandLeft"] = "hand-left";
    BlueprintIcons_16["HandRight"] = "hand-right";
    BlueprintIcons_16["HandUp"] = "hand-up";
    BlueprintIcons_16["Hand"] = "hand";
    BlueprintIcons_16["Hat"] = "hat";
    BlueprintIcons_16["HeaderOne"] = "header-one";
    BlueprintIcons_16["HeaderThree"] = "header-three";
    BlueprintIcons_16["HeaderTwo"] = "header-two";
    BlueprintIcons_16["Header"] = "header";
    BlueprintIcons_16["Headset"] = "headset";
    BlueprintIcons_16["HeartBroken"] = "heart-broken";
    BlueprintIcons_16["Heart"] = "heart";
    BlueprintIcons_16["HeatGrid"] = "heat-grid";
    BlueprintIcons_16["Heatmap"] = "heatmap";
    BlueprintIcons_16["Helicopter"] = "helicopter";
    BlueprintIcons_16["Help"] = "help";
    BlueprintIcons_16["HelperManagement"] = "helper-management";
    BlueprintIcons_16["Hexagon"] = "hexagon";
    BlueprintIcons_16["HighPriority"] = "high-priority";
    BlueprintIcons_16["HighVoltagePole"] = "high-voltage-pole";
    BlueprintIcons_16["Highlight"] = "highlight";
    BlueprintIcons_16["History"] = "history";
    BlueprintIcons_16["Home"] = "home";
    BlueprintIcons_16["HorizontalBarChartAsc"] = "horizontal-bar-chart-asc";
    BlueprintIcons_16["HorizontalBarChartDesc"] = "horizontal-bar-chart-desc";
    BlueprintIcons_16["HorizontalBarChart"] = "horizontal-bar-chart";
    BlueprintIcons_16["HorizontalDistribution"] = "horizontal-distribution";
    BlueprintIcons_16["HorizontalInbetween"] = "horizontal-inbetween";
    BlueprintIcons_16["Hurricane"] = "hurricane";
    BlueprintIcons_16["IdNumber"] = "id-number";
    BlueprintIcons_16["ImageRotateLeft"] = "image-rotate-left";
    BlueprintIcons_16["ImageRotateRight"] = "image-rotate-right";
    BlueprintIcons_16["Import"] = "import";
    BlueprintIcons_16["InboxFiltered"] = "inbox-filtered";
    BlueprintIcons_16["InboxGeo"] = "inbox-geo";
    BlueprintIcons_16["InboxSearch"] = "inbox-search";
    BlueprintIcons_16["InboxUpdate"] = "inbox-update";
    BlueprintIcons_16["Inbox"] = "inbox";
    BlueprintIcons_16["InfoSign"] = "info-sign";
    BlueprintIcons_16["Inheritance"] = "inheritance";
    BlueprintIcons_16["InheritedGroup"] = "inherited-group";
    BlueprintIcons_16["InnerJoin"] = "inner-join";
    BlueprintIcons_16["Input"] = "input";
    BlueprintIcons_16["Insert"] = "insert";
    BlueprintIcons_16["Intelligence"] = "intelligence";
    BlueprintIcons_16["Intersection"] = "intersection";
    BlueprintIcons_16["IpAddress"] = "ip-address";
    BlueprintIcons_16["IssueClosed"] = "issue-closed";
    BlueprintIcons_16["IssueNew"] = "issue-new";
    BlueprintIcons_16["Issue"] = "issue";
    BlueprintIcons_16["Italic"] = "italic";
    BlueprintIcons_16["JoinTable"] = "join-table";
    BlueprintIcons_16["KeyBackspace"] = "key-backspace";
    BlueprintIcons_16["KeyCommand"] = "key-command";
    BlueprintIcons_16["KeyControl"] = "key-control";
    BlueprintIcons_16["KeyDelete"] = "key-delete";
    BlueprintIcons_16["KeyEnter"] = "key-enter";
    BlueprintIcons_16["KeyEscape"] = "key-escape";
    BlueprintIcons_16["KeyOption"] = "key-option";
    BlueprintIcons_16["KeyShift"] = "key-shift";
    BlueprintIcons_16["KeyTab"] = "key-tab";
    BlueprintIcons_16["Key"] = "key";
    BlueprintIcons_16["KnownVehicle"] = "known-vehicle";
    BlueprintIcons_16["LabTest"] = "lab-test";
    BlueprintIcons_16["Label"] = "label";
    BlueprintIcons_16["LayerOutline"] = "layer-outline";
    BlueprintIcons_16["Layer"] = "layer";
    BlueprintIcons_16["Layers"] = "layers";
    BlueprintIcons_16["LayoutAuto"] = "layout-auto";
    BlueprintIcons_16["LayoutBalloon"] = "layout-balloon";
    BlueprintIcons_16["LayoutBottomRowThreeTiles"] = "layout-bottom-row-three-tiles";
    BlueprintIcons_16["LayoutBottomRowTwoTiles"] = "layout-bottom-row-two-tiles";
    BlueprintIcons_16["LayoutCircle"] = "layout-circle";
    BlueprintIcons_16["LayoutGrid"] = "layout-grid";
    BlueprintIcons_16["LayoutGroupBy"] = "layout-group-by";
    BlueprintIcons_16["LayoutHierarchy"] = "layout-hierarchy";
    BlueprintIcons_16["LayoutLeftColumnThreeTiles"] = "layout-left-column-three-tiles";
    BlueprintIcons_16["LayoutLeftColumnTwoTiles"] = "layout-left-column-two-tiles";
    BlueprintIcons_16["LayoutLinear"] = "layout-linear";
    BlueprintIcons_16["LayoutRightColumnThreeTiles"] = "layout-right-column-three-tiles";
    BlueprintIcons_16["LayoutRightColumnTwoTiles"] = "layout-right-column-two-tiles";
    BlueprintIcons_16["LayoutSkewGrid"] = "layout-skew-grid";
    BlueprintIcons_16["LayoutSortedClusters"] = "layout-sorted-clusters";
    BlueprintIcons_16["LayoutThreeColumns"] = "layout-three-columns";
    BlueprintIcons_16["LayoutThreeRows"] = "layout-three-rows";
    BlueprintIcons_16["LayoutTopRowThreeTiles"] = "layout-top-row-three-tiles";
    BlueprintIcons_16["LayoutTopRowTwoTiles"] = "layout-top-row-two-tiles";
    BlueprintIcons_16["LayoutTwoColumns"] = "layout-two-columns";
    BlueprintIcons_16["LayoutTwoRows"] = "layout-two-rows";
    BlueprintIcons_16["Layout"] = "layout";
    BlueprintIcons_16["Learning"] = "learning";
    BlueprintIcons_16["LeftJoin"] = "left-join";
    BlueprintIcons_16["LengthenText"] = "lengthen-text";
    BlueprintIcons_16["LessThanOrEqualTo"] = "less-than-or-equal-to";
    BlueprintIcons_16["LessThan"] = "less-than";
    BlueprintIcons_16["Lifesaver"] = "lifesaver";
    BlueprintIcons_16["Lightbulb"] = "lightbulb";
    BlueprintIcons_16["Lightning"] = "lightning";
    BlueprintIcons_16["Link"] = "link";
    BlueprintIcons_16["LinkedSquares"] = "linked-squares";
    BlueprintIcons_16["ListColumns"] = "list-columns";
    BlueprintIcons_16["ListDetailView"] = "list-detail-view";
    BlueprintIcons_16["List"] = "list";
    BlueprintIcons_16["Locate"] = "locate";
    BlueprintIcons_16["Lock"] = "lock";
    BlueprintIcons_16["Locomotive"] = "locomotive";
    BlueprintIcons_16["LogIn"] = "log-in";
    BlueprintIcons_16["LogOut"] = "log-out";
    BlueprintIcons_16["LowVoltagePole"] = "low-voltage-pole";
    BlueprintIcons_16["Manual"] = "manual";
    BlueprintIcons_16["ManuallyEnteredData"] = "manually-entered-data";
    BlueprintIcons_16["ManyToMany"] = "many-to-many";
    BlueprintIcons_16["ManyToOne"] = "many-to-one";
    BlueprintIcons_16["MapCreate"] = "map-create";
    BlueprintIcons_16["MapMarker"] = "map-marker";
    BlueprintIcons_16["Map"] = "map";
    BlueprintIcons_16["Markdown"] = "markdown";
    BlueprintIcons_16["Maximize"] = "maximize";
    BlueprintIcons_16["Media"] = "media";
    BlueprintIcons_16["MenuClosed"] = "menu-closed";
    BlueprintIcons_16["MenuOpen"] = "menu-open";
    BlueprintIcons_16["Menu"] = "menu";
    BlueprintIcons_16["MergeColumns"] = "merge-columns";
    BlueprintIcons_16["MergeLinks"] = "merge-links";
    BlueprintIcons_16["Microphone"] = "microphone";
    BlueprintIcons_16["Minimize"] = "minimize";
    BlueprintIcons_16["Minus"] = "minus";
    BlueprintIcons_16["MobilePhone"] = "mobile-phone";
    BlueprintIcons_16["MobileVideo"] = "mobile-video";
    BlueprintIcons_16["ModalFilled"] = "modal-filled";
    BlueprintIcons_16["Modal"] = "modal";
    BlueprintIcons_16["Model"] = "model";
    BlueprintIcons_16["Moon"] = "moon";
    BlueprintIcons_16["More"] = "more";
    BlueprintIcons_16["Mountain"] = "mountain";
    BlueprintIcons_16["Move"] = "move";
    BlueprintIcons_16["Mugshot"] = "mugshot";
    BlueprintIcons_16["MultiSelect"] = "multi-select";
    BlueprintIcons_16["Music"] = "music";
    BlueprintIcons_16["Nest"] = "nest";
    BlueprintIcons_16["NewDrawing"] = "new-drawing";
    BlueprintIcons_16["NewGridItem"] = "new-grid-item";
    BlueprintIcons_16["NewLayer"] = "new-layer";
    BlueprintIcons_16["NewLayers"] = "new-layers";
    BlueprintIcons_16["NewLink"] = "new-link";
    BlueprintIcons_16["NewObject"] = "new-object";
    BlueprintIcons_16["NewPerson"] = "new-person";
    BlueprintIcons_16["NewPrescription"] = "new-prescription";
    BlueprintIcons_16["NewShield"] = "new-shield";
    BlueprintIcons_16["NewTextBox"] = "new-text-box";
    BlueprintIcons_16["Ninja"] = "ninja";
    BlueprintIcons_16["NotEqualTo"] = "not-equal-to";
    BlueprintIcons_16["NotificationsAdd"] = "notifications-add";
    BlueprintIcons_16["NotificationsSnooze"] = "notifications-snooze";
    BlueprintIcons_16["NotificationsUpdated"] = "notifications-updated";
    BlueprintIcons_16["Notifications"] = "notifications";
    BlueprintIcons_16["NumberedList"] = "numbered-list";
    BlueprintIcons_16["Numerical"] = "numerical";
    BlueprintIcons_16["ObjectView"] = "object-view";
    BlueprintIcons_16["Office"] = "office";
    BlueprintIcons_16["Offline"] = "offline";
    BlueprintIcons_16["OilField"] = "oil-field";
    BlueprintIcons_16["OneColumn"] = "one-column";
    BlueprintIcons_16["OneToMany"] = "one-to-many";
    BlueprintIcons_16["OneToOne"] = "one-to-one";
    BlueprintIcons_16["OpenApplication"] = "open-application";
    BlueprintIcons_16["Outdated"] = "outdated";
    BlueprintIcons_16["Output"] = "output";
    BlueprintIcons_16["Package"] = "package";
    BlueprintIcons_16["PageBreak"] = "page-break";
    BlueprintIcons_16["PageLayout"] = "page-layout";
    BlueprintIcons_16["PanelStats"] = "panel-stats";
    BlueprintIcons_16["PanelTable"] = "panel-table";
    BlueprintIcons_16["Panel"] = "panel";
    BlueprintIcons_16["Paperclip"] = "paperclip";
    BlueprintIcons_16["Paragraph"] = "paragraph";
    BlueprintIcons_16["PasteVariable"] = "paste-variable";
    BlueprintIcons_16["PathSearch"] = "path-search";
    BlueprintIcons_16["Path"] = "path";
    BlueprintIcons_16["Pause"] = "pause";
    BlueprintIcons_16["People"] = "people";
    BlueprintIcons_16["Percentage"] = "percentage";
    BlueprintIcons_16["Person"] = "person";
    BlueprintIcons_16["PhoneCall"] = "phone-call";
    BlueprintIcons_16["PhoneForward"] = "phone-forward";
    BlueprintIcons_16["PhoneSearch"] = "phone-search";
    BlueprintIcons_16["Phone"] = "phone";
    BlueprintIcons_16["PieChart"] = "pie-chart";
    BlueprintIcons_16["Pill"] = "pill";
    BlueprintIcons_16["Pin"] = "pin";
    BlueprintIcons_16["Pistol"] = "pistol";
    BlueprintIcons_16["PivotTable"] = "pivot-table";
    BlueprintIcons_16["Pivot"] = "pivot";
    BlueprintIcons_16["Play"] = "play";
    BlueprintIcons_16["Playbook"] = "playbook";
    BlueprintIcons_16["Plus"] = "plus";
    BlueprintIcons_16["PolygonFilter"] = "polygon-filter";
    BlueprintIcons_16["Power"] = "power";
    BlueprintIcons_16["PredictiveAnalysis"] = "predictive-analysis";
    BlueprintIcons_16["Prescription"] = "prescription";
    BlueprintIcons_16["Presentation"] = "presentation";
    BlueprintIcons_16["Print"] = "print";
    BlueprintIcons_16["Projects"] = "projects";
    BlueprintIcons_16["Properties"] = "properties";
    BlueprintIcons_16["Property"] = "property";
    BlueprintIcons_16["PublishFunction"] = "publish-function";
    BlueprintIcons_16["Pulse"] = "pulse";
    BlueprintIcons_16["Rain"] = "rain";
    BlueprintIcons_16["Random"] = "random";
    BlueprintIcons_16["RangeRing"] = "range-ring";
    BlueprintIcons_16["Record"] = "record";
    BlueprintIcons_16["RectHeight"] = "rect-height";
    BlueprintIcons_16["RectWidth"] = "rect-width";
    BlueprintIcons_16["Rectangle"] = "rectangle";
    BlueprintIcons_16["Redo"] = "redo";
    BlueprintIcons_16["RefreshOff"] = "refresh-off";
    BlueprintIcons_16["Refresh"] = "refresh";
    BlueprintIcons_16["Regex"] = "regex";
    BlueprintIcons_16["RegressionChart"] = "regression-chart";
    BlueprintIcons_16["RemoveColumnLeft"] = "remove-column-left";
    BlueprintIcons_16["RemoveColumnRight"] = "remove-column-right";
    BlueprintIcons_16["RemoveColumn"] = "remove-column";
    BlueprintIcons_16["RemoveRowBottom"] = "remove-row-bottom";
    BlueprintIcons_16["RemoveRowTop"] = "remove-row-top";
    BlueprintIcons_16["Remove"] = "remove";
    BlueprintIcons_16["Repeat"] = "repeat";
    BlueprintIcons_16["Reset"] = "reset";
    BlueprintIcons_16["Resolve"] = "resolve";
    BlueprintIcons_16["Rig"] = "rig";
    BlueprintIcons_16["RightJoin"] = "right-join";
    BlueprintIcons_16["Ring"] = "ring";
    BlueprintIcons_16["RocketSlant"] = "rocket-slant";
    BlueprintIcons_16["Rocket"] = "rocket";
    BlueprintIcons_16["RootFolder"] = "root-folder";
    BlueprintIcons_16["RotateCcw"] = "rotate-ccw";
    BlueprintIcons_16["RotateCw"] = "rotate-cw";
    BlueprintIcons_16["RotateDocument"] = "rotate-document";
    BlueprintIcons_16["RotatePage"] = "rotate-page";
    BlueprintIcons_16["Route"] = "route";
    BlueprintIcons_16["RunHistory"] = "run-history";
    BlueprintIcons_16["Satellite"] = "satellite";
    BlueprintIcons_16["Saved"] = "saved";
    BlueprintIcons_16["ScatterPlot"] = "scatter-plot";
    BlueprintIcons_16["SearchAround"] = "search-around";
    BlueprintIcons_16["SearchTemplate"] = "search-template";
    BlueprintIcons_16["SearchText"] = "search-text";
    BlueprintIcons_16["Search"] = "search";
    BlueprintIcons_16["SegmentedControl"] = "segmented-control";
    BlueprintIcons_16["Select"] = "select";
    BlueprintIcons_16["SelectionBoxAdd"] = "selection-box-add";
    BlueprintIcons_16["SelectionBoxEdit"] = "selection-box-edit";
    BlueprintIcons_16["SelectionBoxRemove"] = "selection-box-remove";
    BlueprintIcons_16["SelectionBox"] = "selection-box";
    BlueprintIcons_16["Selection"] = "selection";
    BlueprintIcons_16["SendBackward"] = "send-backward";
    BlueprintIcons_16["SendMessage"] = "send-message";
    BlueprintIcons_16["SendToGraph"] = "send-to-graph";
    BlueprintIcons_16["SendToMap"] = "send-to-map";
    BlueprintIcons_16["SendTo"] = "send-to";
    BlueprintIcons_16["Sensor"] = "sensor";
    BlueprintIcons_16["SeriesAdd"] = "series-add";
    BlueprintIcons_16["SeriesConfiguration"] = "series-configuration";
    BlueprintIcons_16["SeriesDerived"] = "series-derived";
    BlueprintIcons_16["SeriesFiltered"] = "series-filtered";
    BlueprintIcons_16["SeriesSearch"] = "series-search";
    BlueprintIcons_16["ServerInstall"] = "server-install";
    BlueprintIcons_16["Server"] = "server";
    BlueprintIcons_16["Settings"] = "settings";
    BlueprintIcons_16["Shapes"] = "shapes";
    BlueprintIcons_16["Share"] = "share";
    BlueprintIcons_16["SharedFilter"] = "shared-filter";
    BlueprintIcons_16["Shield"] = "shield";
    BlueprintIcons_16["Ship"] = "ship";
    BlueprintIcons_16["Shop"] = "shop";
    BlueprintIcons_16["ShoppingCart"] = "shopping-cart";
    BlueprintIcons_16["ShortenText"] = "shorten-text";
    BlueprintIcons_16["SignalSearch"] = "signal-search";
    BlueprintIcons_16["SimCard"] = "sim-card";
    BlueprintIcons_16["Slash"] = "slash";
    BlueprintIcons_16["SmallCross"] = "small-cross";
    BlueprintIcons_16["SmallInfoSign"] = "small-info-sign";
    BlueprintIcons_16["SmallMinus"] = "small-minus";
    BlueprintIcons_16["SmallPlus"] = "small-plus";
    BlueprintIcons_16["SmallSquare"] = "small-square";
    BlueprintIcons_16["SmallTick"] = "small-tick";
    BlueprintIcons_16["Snowflake"] = "snowflake";
    BlueprintIcons_16["SoccerBall"] = "soccer-ball";
    BlueprintIcons_16["SocialMedia"] = "social-media";
    BlueprintIcons_16["SortAlphabeticalDesc"] = "sort-alphabetical-desc";
    BlueprintIcons_16["SortAlphabetical"] = "sort-alphabetical";
    BlueprintIcons_16["SortAsc"] = "sort-asc";
    BlueprintIcons_16["SortDesc"] = "sort-desc";
    BlueprintIcons_16["SortNumericalDesc"] = "sort-numerical-desc";
    BlueprintIcons_16["SortNumerical"] = "sort-numerical";
    BlueprintIcons_16["Sort"] = "sort";
    BlueprintIcons_16["SpellCheck"] = "spell-check";
    BlueprintIcons_16["Spin"] = "spin";
    BlueprintIcons_16["SplitColumns"] = "split-columns";
    BlueprintIcons_16["SportsStadium"] = "sports-stadium";
    BlueprintIcons_16["Square"] = "square";
    BlueprintIcons_16["StackedChart"] = "stacked-chart";
    BlueprintIcons_16["StadiumGeometry"] = "stadium-geometry";
    BlueprintIcons_16["StarEmpty"] = "star-empty";
    BlueprintIcons_16["Star"] = "star";
    BlueprintIcons_16["StepBackward"] = "step-backward";
    BlueprintIcons_16["StepChart"] = "step-chart";
    BlueprintIcons_16["StepForward"] = "step-forward";
    BlueprintIcons_16["Stop"] = "stop";
    BlueprintIcons_16["Stopwatch"] = "stopwatch";
    BlueprintIcons_16["Strikethrough"] = "strikethrough";
    BlueprintIcons_16["Style"] = "style";
    BlueprintIcons_16["Subscript"] = "subscript";
    BlueprintIcons_16["SubtractRightJoin"] = "subtract-right-join";
    BlueprintIcons_16["Superscript"] = "superscript";
    BlueprintIcons_16["SwapHorizontal"] = "swap-horizontal";
    BlueprintIcons_16["SwapVertical"] = "swap-vertical";
    BlueprintIcons_16["Sweep"] = "sweep";
    BlueprintIcons_16["Switch"] = "switch";
    BlueprintIcons_16["SymbolCircle"] = "symbol-circle";
    BlueprintIcons_16["SymbolCross"] = "symbol-cross";
    BlueprintIcons_16["SymbolDiamond"] = "symbol-diamond";
    BlueprintIcons_16["SymbolRectangle"] = "symbol-rectangle";
    BlueprintIcons_16["SymbolSquare"] = "symbol-square";
    BlueprintIcons_16["SymbolTriangleDown"] = "symbol-triangle-down";
    BlueprintIcons_16["SymbolTriangleUp"] = "symbol-triangle-up";
    BlueprintIcons_16["Syringe"] = "syringe";
    BlueprintIcons_16["TableSync"] = "table-sync";
    BlueprintIcons_16["TagAdd"] = "tag-add";
    BlueprintIcons_16["TagPromote"] = "tag-promote";
    BlueprintIcons_16["TagRefresh"] = "tag-refresh";
    BlueprintIcons_16["TagUndo"] = "tag-undo";
    BlueprintIcons_16["Tag"] = "tag";
    BlueprintIcons_16["Tags"] = "tags";
    BlueprintIcons_16["TakeAction"] = "take-action";
    BlueprintIcons_16["Tank"] = "tank";
    BlueprintIcons_16["Target"] = "target";
    BlueprintIcons_16["Taxi"] = "taxi";
    BlueprintIcons_16["Team"] = "team";
    BlueprintIcons_16["Temperature"] = "temperature";
    BlueprintIcons_16["TextHighlight"] = "text-highlight";
    BlueprintIcons_16["ThAdd"] = "th-add";
    BlueprintIcons_16["ThDerived"] = "th-derived";
    BlueprintIcons_16["ThDisconnect"] = "th-disconnect";
    BlueprintIcons_16["ThFiltered"] = "th-filtered";
    BlueprintIcons_16["ThListAdd"] = "th-list-add";
    BlueprintIcons_16["ThList"] = "th-list";
    BlueprintIcons_16["ThVirtualAdd"] = "th-virtual-add";
    BlueprintIcons_16["ThVirtual"] = "th-virtual";
    BlueprintIcons_16["Th"] = "th";
    BlueprintIcons_16["ThirdParty"] = "third-party";
    BlueprintIcons_16["ThumbsDown"] = "thumbs-down";
    BlueprintIcons_16["ThumbsUp"] = "thumbs-up";
    BlueprintIcons_16["TickCircle"] = "tick-circle";
    BlueprintIcons_16["Tick"] = "tick";
    BlueprintIcons_16["Time"] = "time";
    BlueprintIcons_16["TimelineAreaChart"] = "timeline-area-chart";
    BlueprintIcons_16["TimelineBarChart"] = "timeline-bar-chart";
    BlueprintIcons_16["TimelineEvents"] = "timeline-events";
    BlueprintIcons_16["TimelineLineChart"] = "timeline-line-chart";
    BlueprintIcons_16["Tint"] = "tint";
    BlueprintIcons_16["Torch"] = "torch";
    BlueprintIcons_16["Tractor"] = "tractor";
    BlueprintIcons_16["Train"] = "train";
    BlueprintIcons_16["Translate"] = "translate";
    BlueprintIcons_16["Trash"] = "trash";
    BlueprintIcons_16["Tree"] = "tree";
    BlueprintIcons_16["TrendingDown"] = "trending-down";
    BlueprintIcons_16["TrendingUp"] = "trending-up";
    BlueprintIcons_16["Trophy"] = "trophy";
    BlueprintIcons_16["Truck"] = "truck";
    BlueprintIcons_16["TwoColumns"] = "two-columns";
    BlueprintIcons_16["Unarchive"] = "unarchive";
    BlueprintIcons_16["Underline"] = "underline";
    BlueprintIcons_16["Undo"] = "undo";
    BlueprintIcons_16["UngroupObjects"] = "ungroup-objects";
    BlueprintIcons_16["UnknownVehicle"] = "unknown-vehicle";
    BlueprintIcons_16["Unlink"] = "unlink";
    BlueprintIcons_16["Unlock"] = "unlock";
    BlueprintIcons_16["Unpin"] = "unpin";
    BlueprintIcons_16["Unresolve"] = "unresolve";
    BlueprintIcons_16["Updated"] = "updated";
    BlueprintIcons_16["Upload"] = "upload";
    BlueprintIcons_16["User"] = "user";
    BlueprintIcons_16["VariableLayer"] = "variable-layer";
    BlueprintIcons_16["Variable"] = "variable";
    BlueprintIcons_16["Vector"] = "vector";
    BlueprintIcons_16["VerticalBarChartAsc"] = "vertical-bar-chart-asc";
    BlueprintIcons_16["VerticalBarChartDesc"] = "vertical-bar-chart-desc";
    BlueprintIcons_16["VerticalDistribution"] = "vertical-distribution";
    BlueprintIcons_16["VerticalInbetween"] = "vertical-inbetween";
    BlueprintIcons_16["Video"] = "video";
    BlueprintIcons_16["Virus"] = "virus";
    BlueprintIcons_16["VolumeDown"] = "volume-down";
    BlueprintIcons_16["VolumeOff"] = "volume-off";
    BlueprintIcons_16["VolumeUp"] = "volume-up";
    BlueprintIcons_16["Walk"] = "walk";
    BlueprintIcons_16["WarningSign"] = "warning-sign";
    BlueprintIcons_16["WaterfallChart"] = "waterfall-chart";
    BlueprintIcons_16["Waves"] = "waves";
    BlueprintIcons_16["WidgetButton"] = "widget-button";
    BlueprintIcons_16["WidgetFooter"] = "widget-footer";
    BlueprintIcons_16["WidgetHeader"] = "widget-header";
    BlueprintIcons_16["Widget"] = "widget";
    BlueprintIcons_16["Wind"] = "wind";
    BlueprintIcons_16["Won"] = "won";
    BlueprintIcons_16["WrapLines"] = "wrap-lines";
    BlueprintIcons_16["WrenchRedo"] = "wrench-redo";
    BlueprintIcons_16["WrenchSnooze"] = "wrench-snooze";
    BlueprintIcons_16["WrenchTime"] = "wrench-time";
    BlueprintIcons_16["Wrench"] = "wrench";
    BlueprintIcons_16["Yen"] = "yen";
    BlueprintIcons_16["ZoomIn"] = "zoom-in";
    BlueprintIcons_16["ZoomOut"] = "zoom-out";
    BlueprintIcons_16["ZoomToFit"] = "zoom-to-fit";
})($2a9b5b4ccace6af5$export$f9661b8856577c15 || ($2a9b5b4ccace6af5$export$f9661b8856577c15 = {}));
const $2a9b5b4ccace6af5$export$579a898a65651aa0 = {
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddChild]: "62365",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddClip]: "61697",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddColumnLeft]: "61698",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddColumnRight]: "61699",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddLocation]: "61700",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddParent]: "62366",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddRowBottom]: "61701",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddRowTop]: "61702",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddToArtifact]: "61703",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AddToFolder]: "61704",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Add]: "61705",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AimpointsTarget]: "62261",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Airplane]: "61706",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignCenter]: "61707",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignJustify]: "61708",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignLeft]: "61709",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignRight]: "61710",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignmentBottom]: "61711",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignmentHorizontalCenter]: "61712",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignmentLeft]: "61713",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignmentRight]: "61714",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignmentTop]: "61715",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AlignmentVerticalCenter]: "61716",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Ammunition]: "62274",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Anchor]: "62256",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Annotation]: "61717",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Announcement]: "62358",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Antenna]: "61718",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AppHeader]: "61719",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Application]: "61720",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Applications]: "61721",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Archive]: "61722",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AreaOfInterest]: "61723",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrayBoolean]: "61724",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrayDate]: "61725",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrayFloatingPoint]: "62253",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrayNumeric]: "61726",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrayObject]: "62356",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrayString]: "61727",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrayTimestamp]: "61728",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Array]: "61729",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowBottomLeft]: "61730",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowBottomRight]: "61731",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowDown]: "61732",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowLeft]: "61733",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowRight]: "61734",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowTopLeft]: "61735",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowTopRight]: "61736",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowUp]: "61737",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowsArc]: "62343",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowsHorizontal]: "61738",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ArrowsVertical]: "61739",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Asterisk]: "61740",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.At]: "62257",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.AutomaticUpdates]: "61741",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Axle]: "62264",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Backlink]: "61742",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BackwardTen]: "62300",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Badge]: "61743",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BanCircle]: "61744",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BankAccount]: "61745",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Barcode]: "61746",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BinaryNumber]: "62295",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Blank]: "61747",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BlockPromote]: "62322",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BlockedPerson]: "61748",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Bold]: "61749",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Book]: "61750",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Bookmark]: "61751",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Box]: "61752",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BranchLocked]: "62374",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BranchUnlocked]: "62375",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Briefcase]: "61753",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BringData]: "61754",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BringForward]: "62292",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.BritishPound]: "62342",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Bug]: "62254",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Buggy]: "61755",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Build]: "61756",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Bullseye]: "62297",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Calculator]: "61757",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Calendar]: "61758",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Camera]: "61759",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CaretDown]: "61760",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CaretLeft]: "61761",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CaretRight]: "61762",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CaretUp]: "61763",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CargoShip]: "61764",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CellTower]: "61765",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Changes]: "61766",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Chart]: "61767",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Chat]: "61768",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ChevronBackward]: "61769",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ChevronDown]: "61770",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ChevronForward]: "61771",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ChevronLeft]: "61772",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ChevronRight]: "61773",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ChevronUp]: "61774",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CircleArrowDown]: "61775",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CircleArrowLeft]: "61776",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CircleArrowRight]: "61777",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CircleArrowUp]: "61778",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Circle]: "61779",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Citation]: "61780",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Clean]: "61781",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Clip]: "61782",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ClipboardFile]: "62299",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Clipboard]: "61783",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CloudDownload]: "61784",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CloudServer]: "62298",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CloudTick]: "62286",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CloudUpload]: "61785",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Cloud]: "61786",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CodeBlock]: "61787",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Code]: "61788",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Cog]: "61789",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CollapseAll]: "61790",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ColorFill]: "62248",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ColumnLayout]: "61791",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Comment]: "61792",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Comparison]: "61793",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Compass]: "61794",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Compressed]: "61795",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Confirm]: "61796",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ConsoleAlert]: "62381",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Console]: "61797",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Construction]: "62357",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Contrast]: "61798",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Control]: "61799",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CreditCard]: "61800",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Crop]: "62291",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CrossCircle]: "62262",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Cross]: "61801",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Crown]: "61802",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CssStyle]: "62315",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CubeAdd]: "61803",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CubeCutout]: "62389",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CubeCutouts]: "62390",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CubeEdit]: "62339",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CubeRemove]: "61804",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Cube]: "61805",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Cubes]: "62323",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CurlyBraces]: "62296",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.CurvedRangeChart]: "61806",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Cut]: "61807",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Cycle]: "61808",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Dashboard]: "61809",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DataCloud]: "62353",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DataConnection]: "61810",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DataLineage]: "61811",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DataSearch]: "62319",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DataSync]: "62316",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Database]: "61812",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DeleteClip]: "62371",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Delete]: "61813",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Delta]: "61814",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DeriveColumn]: "61815",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Desktop]: "61816",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Detection]: "62273",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Diagnosis]: "61817",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DiagramTree]: "61818",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DirectionLeft]: "61819",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DirectionRight]: "61820",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Disable]: "61821",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Divide]: "62247",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DocumentCode]: "62368",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DocumentLocked]: "62369",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DocumentOpen]: "61822",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DocumentShare]: "61823",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Document]: "61824",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Dollar]: "61825",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Dot]: "61826",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DoubleCaretHorizontal]: "61827",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DoubleCaretVertical]: "61828",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DoubleChevronDown]: "61829",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DoubleChevronLeft]: "61830",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DoubleChevronRight]: "61831",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DoubleChevronUp]: "61832",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DoughnutChart]: "61833",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Download]: "61834",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DragHandleHorizontal]: "61835",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DragHandleVertical]: "61836",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Draw]: "61837",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DrawerLeftFilled]: "61838",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DrawerLeft]: "61839",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DrawerRightFilled]: "61840",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DrawerRight]: "61841",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DriveTime]: "61842",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.DroneUav]: "62386",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Drone]: "62385",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Duplicate]: "61843",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Edit]: "61844",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Eject]: "61845",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Emoji]: "61846",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Endnote]: "62294",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Endorsed]: "61847",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Envelope]: "61848",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Equals]: "61849",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Eraser]: "61850",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Error]: "61851",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Euro]: "61852",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Excavator]: "62317",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Exchange]: "61853",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ExcludeRow]: "61854",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ExpandAll]: "61855",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Explain]: "62285",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Export]: "61856",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.EyeOff]: "61857",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.EyeOn]: "61858",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.EyeOpen]: "61859",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FastBackward]: "61860",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FastForward]: "61861",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FeedSubscribed]: "61862",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Feed]: "61863",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FighterJet]: "62340",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Film]: "61864",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FilterKeep]: "61865",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FilterList]: "61866",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FilterOpen]: "61867",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FilterRemove]: "61868",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FilterSortAsc]: "62350",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FilterSortDesc]: "62351",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Filter]: "61869",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Flag]: "61870",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Flame]: "61871",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Flash]: "61872",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FloatingPoint]: "62252",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FloppyDisk]: "61873",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FlowBranch]: "61874",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FlowEnd]: "61875",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FlowLinear]: "61876",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FlowReviewBranch]: "61877",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FlowReview]: "61878",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Flows]: "61879",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FolderClose]: "61880",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FolderNew]: "61881",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FolderOpen]: "61882",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FolderSharedOpen]: "61883",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FolderShared]: "61884",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Follower]: "61885",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Following]: "61886",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Font]: "61887",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ForkEnd]: "62391",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Fork]: "61888",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Form]: "61889",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ForwardTen]: "62301",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Fuel]: "62243",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FullCircle]: "61890",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FullStackedChart]: "61891",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Fullscreen]: "61892",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.FunctionMinimal]: "62388",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Function]: "61893",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GanttChart]: "61894",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Generate]: "62284",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Geofence]: "61895",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Geolocation]: "61896",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Geosearch]: "61897",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Geotime]: "62276",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GiftBox]: "62370",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitBranch]: "61898",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitCommit]: "61899",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitMerge]: "61900",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitNewBranch]: "61901",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitPull]: "61902",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitPush]: "61903",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitRebase]: "62380",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GitRepo]: "61904",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Glass]: "61905",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GlobeNetworkAdd]: "62338",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GlobeNetwork]: "61906",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Globe]: "61907",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GraphRemove]: "61908",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Graph]: "61909",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GreaterThanOrEqualTo]: "61910",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GreaterThan]: "61911",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GridView]: "61912",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Grid]: "61913",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GroupItem]: "62282",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GroupObjects]: "61914",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.GroupedBarChart]: "61915",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HandDown]: "61916",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HandLeft]: "61917",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HandRight]: "61918",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HandUp]: "61919",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Hand]: "61920",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Hat]: "61921",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HeaderOne]: "61922",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HeaderThree]: "61923",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HeaderTwo]: "61924",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Header]: "61925",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Headset]: "61926",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HeartBroken]: "61927",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Heart]: "61928",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HeatGrid]: "61929",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Heatmap]: "61930",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Helicopter]: "61931",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Help]: "61932",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HelperManagement]: "61933",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Hexagon]: "62324",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HighPriority]: "61934",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HighVoltagePole]: "62259",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Highlight]: "61935",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.History]: "61936",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Home]: "61937",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HorizontalBarChartAsc]: "61938",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HorizontalBarChartDesc]: "61939",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HorizontalBarChart]: "61940",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HorizontalDistribution]: "61941",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.HorizontalInbetween]: "62249",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Hurricane]: "61942",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.IdNumber]: "61943",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ImageRotateLeft]: "61944",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ImageRotateRight]: "61945",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Import]: "61946",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.InboxFiltered]: "61947",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.InboxGeo]: "61948",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.InboxSearch]: "61949",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.InboxUpdate]: "61950",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Inbox]: "61951",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.InfoSign]: "61952",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Inheritance]: "61953",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.InheritedGroup]: "61954",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.InnerJoin]: "61955",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Input]: "62283",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Insert]: "61956",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Intelligence]: "62263",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Intersection]: "61957",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.IpAddress]: "61958",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.IssueClosed]: "61959",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.IssueNew]: "61960",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Issue]: "61961",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Italic]: "61962",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.JoinTable]: "61963",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyBackspace]: "61964",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyCommand]: "61965",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyControl]: "61966",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyDelete]: "61967",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyEnter]: "61968",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyEscape]: "61969",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyOption]: "61970",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyShift]: "61971",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KeyTab]: "61972",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Key]: "61973",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.KnownVehicle]: "61974",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LabTest]: "61975",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Label]: "61976",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayerOutline]: "61977",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Layer]: "61978",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Layers]: "61979",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutAuto]: "61980",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutBalloon]: "61981",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutBottomRowThreeTiles]: "62308",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutBottomRowTwoTiles]: "62307",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutCircle]: "61982",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutGrid]: "61983",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutGroupBy]: "61984",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutHierarchy]: "61985",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutLeftColumnThreeTiles]: "62310",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutLeftColumnTwoTiles]: "62309",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutLinear]: "61986",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutRightColumnThreeTiles]: "62312",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutRightColumnTwoTiles]: "62311",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutSkewGrid]: "61987",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutSortedClusters]: "61988",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutThreeColumns]: "62305",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutThreeRows]: "62306",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutTopRowThreeTiles]: "62314",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutTopRowTwoTiles]: "62313",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutTwoColumns]: "62303",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LayoutTwoRows]: "62304",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Layout]: "61989",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Learning]: "61990",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LeftJoin]: "61991",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LengthenText]: "62270",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LessThanOrEqualTo]: "61992",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LessThan]: "61993",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Lifesaver]: "61994",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Lightbulb]: "61995",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Lightning]: "61996",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Link]: "61997",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LinkedSquares]: "62341",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ListColumns]: "61998",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ListDetailView]: "61999",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.List]: "62000",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Locate]: "62001",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Lock]: "62002",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Locomotive]: "62267",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LogIn]: "62003",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LogOut]: "62004",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.LowVoltagePole]: "62258",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Manual]: "62005",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ManuallyEnteredData]: "62006",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ManyToMany]: "62007",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ManyToOne]: "62008",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MapCreate]: "62009",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MapMarker]: "62010",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Map]: "62011",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Markdown]: "62377",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Maximize]: "62012",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Media]: "62013",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MenuClosed]: "62014",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MenuOpen]: "62015",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Menu]: "62016",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MergeColumns]: "62017",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MergeLinks]: "62018",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Microphone]: "62275",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Minimize]: "62019",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Minus]: "62020",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MobilePhone]: "62021",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MobileVideo]: "62022",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ModalFilled]: "62023",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Modal]: "62024",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Model]: "62269",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Moon]: "62025",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.More]: "62026",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Mountain]: "62027",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Move]: "62028",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Mugshot]: "62029",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.MultiSelect]: "62030",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Music]: "62031",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Nest]: "62032",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewDrawing]: "62033",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewGridItem]: "62034",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewLayer]: "62035",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewLayers]: "62036",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewLink]: "62037",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewObject]: "62038",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewPerson]: "62039",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewPrescription]: "62040",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewShield]: "62281",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NewTextBox]: "62041",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Ninja]: "62042",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NotEqualTo]: "62043",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NotificationsAdd]: "62360",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NotificationsSnooze]: "62044",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NotificationsUpdated]: "62045",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Notifications]: "62046",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.NumberedList]: "62047",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Numerical]: "62048",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ObjectView]: "62352",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Office]: "62049",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Offline]: "62050",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.OilField]: "62051",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.OneColumn]: "62052",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.OneToMany]: "62053",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.OneToOne]: "62054",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.OpenApplication]: "62251",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Outdated]: "62055",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Output]: "62320",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Package]: "62325",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PageBreak]: "62373",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PageLayout]: "62056",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PanelStats]: "62057",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PanelTable]: "62058",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Panel]: "62337",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Paperclip]: "62059",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Paragraph]: "62060",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PasteVariable]: "62278",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PathSearch]: "62061",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Path]: "62062",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Pause]: "62063",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.People]: "62064",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Percentage]: "62065",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Person]: "62066",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PhoneCall]: "62279",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PhoneForward]: "62280",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PhoneSearch]: "62359",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Phone]: "62067",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PieChart]: "62068",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Pill]: "62326",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Pin]: "62069",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Pistol]: "62364",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PivotTable]: "62070",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Pivot]: "62071",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Play]: "62072",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Playbook]: "62244",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Plus]: "62073",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PolygonFilter]: "62074",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Power]: "62075",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PredictiveAnalysis]: "62076",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Prescription]: "62077",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Presentation]: "62078",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Print]: "62079",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Projects]: "62080",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Properties]: "62081",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Property]: "62082",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.PublishFunction]: "62083",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Pulse]: "62084",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Rain]: "62085",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Random]: "62086",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RangeRing]: "62321",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Record]: "62087",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RectHeight]: "62245",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RectWidth]: "62246",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Rectangle]: "62241",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Redo]: "62088",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RefreshOff]: "62378",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Refresh]: "62089",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Regex]: "62255",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RegressionChart]: "62090",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RemoveColumnLeft]: "62091",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RemoveColumnRight]: "62092",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RemoveColumn]: "62093",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RemoveRowBottom]: "62094",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RemoveRowTop]: "62095",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Remove]: "62096",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Repeat]: "62097",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Reset]: "62098",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Resolve]: "62099",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Rig]: "62100",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RightJoin]: "62101",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Ring]: "62102",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RocketSlant]: "62103",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Rocket]: "62104",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RootFolder]: "62367",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RotateCcw]: "62345",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RotateCw]: "62344",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RotateDocument]: "62105",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RotatePage]: "62106",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Route]: "62107",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.RunHistory]: "62355",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Satellite]: "62108",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Saved]: "62109",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ScatterPlot]: "62110",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SearchAround]: "62111",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SearchTemplate]: "62112",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SearchText]: "62113",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Search]: "62114",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SegmentedControl]: "62115",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Select]: "62116",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SelectionBoxAdd]: "62362",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SelectionBoxEdit]: "62363",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SelectionBoxRemove]: "62376",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SelectionBox]: "62361",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Selection]: "62117",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SendBackward]: "62293",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SendMessage]: "62118",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SendToGraph]: "62119",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SendToMap]: "62120",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SendTo]: "62121",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Sensor]: "62268",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SeriesAdd]: "62122",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SeriesConfiguration]: "62123",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SeriesDerived]: "62124",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SeriesFiltered]: "62125",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SeriesSearch]: "62126",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ServerInstall]: "62327",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Server]: "62328",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Settings]: "62127",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Shapes]: "62128",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Share]: "62129",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SharedFilter]: "62130",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Shield]: "62131",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Ship]: "62132",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Shop]: "62133",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ShoppingCart]: "62134",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ShortenText]: "62271",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SignalSearch]: "62135",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SimCard]: "62136",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Slash]: "62137",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SmallCross]: "62138",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SmallInfoSign]: "62260",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SmallMinus]: "62139",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SmallPlus]: "62140",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SmallSquare]: "62141",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SmallTick]: "62142",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Snowflake]: "62143",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SoccerBall]: "62288",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SocialMedia]: "62144",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SortAlphabeticalDesc]: "62145",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SortAlphabetical]: "62146",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SortAsc]: "62147",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SortDesc]: "62148",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SortNumericalDesc]: "62149",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SortNumerical]: "62150",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Sort]: "62151",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SpellCheck]: "62272",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Spin]: "62387",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SplitColumns]: "62152",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SportsStadium]: "62289",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Square]: "62153",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.StackedChart]: "62154",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.StadiumGeometry]: "62155",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.StarEmpty]: "62156",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Star]: "62157",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.StepBackward]: "62158",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.StepChart]: "62159",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.StepForward]: "62160",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Stop]: "62161",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Stopwatch]: "62162",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Strikethrough]: "62163",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Style]: "62164",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Subscript]: "62265",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SubtractRightJoin]: "62354",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Superscript]: "62266",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SwapHorizontal]: "62165",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SwapVertical]: "62166",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Sweep]: "62372",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Switch]: "62167",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SymbolCircle]: "62168",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SymbolCross]: "62169",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SymbolDiamond]: "62170",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SymbolRectangle]: "62242",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SymbolSquare]: "62171",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SymbolTriangleDown]: "62172",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.SymbolTriangleUp]: "62173",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Syringe]: "62174",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TableSync]: "62318",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TagAdd]: "62329",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TagPromote]: "62330",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TagRefresh]: "62331",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TagUndo]: "62332",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Tag]: "62175",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Tags]: "62333",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TakeAction]: "62176",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Tank]: "62177",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Target]: "62178",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Taxi]: "62179",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Team]: "62290",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Temperature]: "62180",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TextHighlight]: "62181",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThAdd]: "62346",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThDerived]: "62182",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThDisconnect]: "62183",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThFiltered]: "62184",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThListAdd]: "62347",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThList]: "62185",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThVirtualAdd]: "62349",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThVirtual]: "62348",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Th]: "62186",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThirdParty]: "62187",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThumbsDown]: "62188",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ThumbsUp]: "62189",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TickCircle]: "62190",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Tick]: "62191",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Time]: "62192",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TimelineAreaChart]: "62193",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TimelineBarChart]: "62194",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TimelineEvents]: "62195",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TimelineLineChart]: "62196",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Tint]: "62197",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Torch]: "62198",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Tractor]: "62199",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Train]: "62200",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Translate]: "62201",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Trash]: "62202",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Tree]: "62203",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TrendingDown]: "62204",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TrendingUp]: "62205",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Trophy]: "62287",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Truck]: "62206",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.TwoColumns]: "62207",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Unarchive]: "62208",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Underline]: "62209",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Undo]: "62210",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.UngroupObjects]: "62211",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.UnknownVehicle]: "62212",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Unlink]: "62277",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Unlock]: "62213",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Unpin]: "62214",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Unresolve]: "62215",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Updated]: "62216",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Upload]: "62217",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.User]: "62218",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VariableLayer]: "62379",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Variable]: "62219",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Vector]: "62302",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VerticalBarChartAsc]: "62220",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VerticalBarChartDesc]: "62221",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VerticalDistribution]: "62222",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VerticalInbetween]: "62250",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Video]: "62223",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Virus]: "62224",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VolumeDown]: "62225",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VolumeOff]: "62226",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.VolumeUp]: "62227",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Walk]: "62228",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WarningSign]: "62229",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WaterfallChart]: "62230",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Waves]: "62231",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WidgetButton]: "62232",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WidgetFooter]: "62233",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WidgetHeader]: "62234",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Widget]: "62235",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Wind]: "62236",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Won]: "62383",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WrapLines]: "62382",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WrenchRedo]: "62334",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WrenchSnooze]: "62335",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.WrenchTime]: "62336",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Wrench]: "62237",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.Yen]: "62384",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ZoomIn]: "62238",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ZoomOut]: "62239",
    [$2a9b5b4ccace6af5$export$f9661b8856577c15.ZoomToFit]: "62240"
};


const $9e62bb97e4398bc6$var$IconNamesNew = {};
const $9e62bb97e4398bc6$var$IconNamesLegacy = {};
for (const name of Object.values((0, $2a9b5b4ccace6af5$export$f9661b8856577c15))){
    $9e62bb97e4398bc6$var$IconNamesNew[(0, $euNJf.pascalCase)(name)] = name;
    $9e62bb97e4398bc6$var$IconNamesLegacy[(0, $143d36162381d76e$export$feae9a740c003485)(name).toUpperCase()] = name;
}
const $9e62bb97e4398bc6$export$897be40ab5372714 = {
    ...$9e62bb97e4398bc6$var$IconNamesNew,
    ...$9e62bb97e4398bc6$var$IconNamesLegacy
};
const $9e62bb97e4398bc6$export$9c3c8ad8ae0fef6c = new Set(Object.values($9e62bb97e4398bc6$export$897be40ab5372714));



var $6Y6tm = parcelRequire("6Y6tm");
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns whether bundler-injected variable `NODE_ENV` equals `env`. */ function $220359515d8f4d61$var$isNodeEnv(env) {
    return typeof NODE_ENV !== "undefined" && NODE_ENV === env;
}
async function $220359515d8f4d61$export$af723ac7cb96136b(taskDescription, task) {
    const shouldMeasure = $220359515d8f4d61$var$isNodeEnv("development") && typeof performance !== "undefined";
    let start;
    if (shouldMeasure) {
        start = performance.now();
        console.info(`Started '${taskDescription}'...`);
    }
    await task();
    if (shouldMeasure) {
        const time = Math.round(performance.now() - start);
        console.info(`Finished '${taskDescription}' in ${time}ms`);
    }
    return;
}




async function $59c158682bdabfb0$var$getLoaderFn(options) {
    const { loader: loader = $59c158682bdabfb0$var$singleton.defaultLoader } = options;
    if (typeof loader === "function") return loader;
    else if (loader === "all") return (await (parcelRequire("cWXea"))).allPathsLoader;
    else return (await (parcelRequire("6Lw1c"))).splitPathsBySizeLoader;
}
class $59c158682bdabfb0$export$4f13f83fd8bb1dac {
    /** @internal */ defaultLoader = "split-by-size";
    /** @internal */ loadedIconPaths16 = new Map();
    /** @internal */ loadedIconPaths20 = new Map();
    /**
     * Set global icon loading options for all subsequent `Icons.load()` calls.
     */ static setLoaderOptions(options) {
        if (options.loader !== undefined) $59c158682bdabfb0$var$singleton.defaultLoader = options.loader;
    }
    static async load(icons, size, options) {
        if (!Array.isArray(icons)) icons = [
            icons
        ];
        await Promise.all(icons.map((icon)=>this.loadImpl(icon, size, options)));
        return;
    }
    /**
     * Load all available icons for use in Blueprint components.
     */ static async loadAll(options) {
        const allIcons = Object.values((0, $9e62bb97e4398bc6$export$897be40ab5372714));
        (0, $220359515d8f4d61$export$af723ac7cb96136b)(`[Blueprint] loading all icons`, async ()=>{
            await Promise.all([
                this.load(allIcons, (0, $6Y6tm.IconSize).STANDARD, options),
                this.load(allIcons, (0, $6Y6tm.IconSize).LARGE, options)
            ]);
        });
    }
    /**
     * Get the icon SVG paths. Returns `undefined` if the icon has not been loaded yet.
     */ static getPaths(icon, size) {
        if (!this.isValidIconName(icon)) // don't warn, since this.load() will have warned already
        return undefined;
        const loadedIcons = size < (0, $6Y6tm.IconSize).LARGE ? $59c158682bdabfb0$var$singleton.loadedIconPaths16 : $59c158682bdabfb0$var$singleton.loadedIconPaths20;
        return loadedIcons.get(icon);
    }
    static async loadImpl(icon, size, options = {}) {
        if (!this.isValidIconName(icon)) {
            console.error(`[Blueprint] Unknown icon '${icon}'`);
            return;
        }
        const loadedIcons = size < (0, $6Y6tm.IconSize).LARGE ? $59c158682bdabfb0$var$singleton.loadedIconPaths16 : $59c158682bdabfb0$var$singleton.loadedIconPaths20;
        if (loadedIcons.has(icon)) // already loaded, no-op
        return;
        const loaderFn = await $59c158682bdabfb0$var$getLoaderFn(options);
        try {
            const supportedSize = size < (0, $6Y6tm.IconSize).LARGE ? (0, $6Y6tm.IconSize).STANDARD : (0, $6Y6tm.IconSize).LARGE;
            const paths = await loaderFn(icon, supportedSize);
            loadedIcons.set(icon, paths);
        } catch (e) {
            console.error(`[Blueprint] Unable to load ${size}px icon '${icon}'`, e);
        }
    }
    /**
     * @returns true if the given string is a valid {@link IconName}
     */ static isValidIconName(iconName) {
        return (0, $9e62bb97e4398bc6$export$9c3c8ad8ae0fef6c).has(iconName);
    }
}
const $59c158682bdabfb0$var$singleton = new $59c158682bdabfb0$export$4f13f83fd8bb1dac();


var $6Y6tm = parcelRequire("6Y6tm");


var $kYL7Z = parcelRequire("kYL7Z");
/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $2302955f16230d86$var$NS = "bp6";
const $2302955f16230d86$export$d2b60e6b56e900e8 = `${$2302955f16230d86$var$NS}-icon`;



var $6Y6tm = parcelRequire("6Y6tm");
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e0c88d175a31dec4$var$uniqueCountForNamespace = new Map();
function $e0c88d175a31dec4$export$8b15d37bc3f197d4(namespace) {
    const curCount = $e0c88d175a31dec4$var$uniqueCountForNamespace.get(namespace) ?? 0;
    $e0c88d175a31dec4$var$uniqueCountForNamespace.set(namespace, curCount + 1);
    return `${namespace}-${curCount}`;
}


const $8f558ced286a8918$export$5529589efc4d4370 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { children: children, className: className, color: color, htmlTitle: htmlTitle, iconName: iconName, size: size = (0, $6Y6tm.IconSize).STANDARD, svgProps: svgProps, tagName: tagName = "span", title: title, ...htmlProps } = props;
    const isLarge = size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const viewBox = `0 0 ${pixelGridSize} ${pixelGridSize}`;
    const titleId = (0, $e0c88d175a31dec4$export$8b15d37bc3f197d4)("iconTitle");
    const sharedSvgProps = {
        fill: color,
        height: size,
        role: "img",
        viewBox: viewBox,
        width: size,
        ...svgProps
    };
    if (tagName === null) return (0, $fc31e5e9fc16a880$exports.jsxs)("svg", {
        "aria-labelledby": title ? titleId : undefined,
        "data-icon": iconName,
        ref: ref,
        ...sharedSvgProps,
        ...htmlProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(className, svgProps?.className),
        children: [
            title && (0, $fc31e5e9fc16a880$exports.jsx)("title", {
                id: titleId,
                children: title
            }),
            children
        ]
    });
    else // N.B. styles for `Classes.ICON` are defined in @blueprintjs/core in `_icon.scss`
    return (0, $kYL7Z.createElement)(tagName, {
        "aria-hidden": title ? undefined : true,
        ...htmlProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))($2302955f16230d86$export$d2b60e6b56e900e8, `${$2302955f16230d86$export$d2b60e6b56e900e8}-${iconName}`, className),
        ref: ref,
        title: htmlTitle
    }, (0, $fc31e5e9fc16a880$exports.jsxs)("svg", {
        "data-icon": iconName,
        ...sharedSvgProps,
        className: svgProps?.className,
        children: [
            title && (0, $fc31e5e9fc16a880$exports.jsx)("title", {
                children: title
            }),
            children
        ]
    }));
});
$8f558ced286a8918$export$5529589efc4d4370.displayName = "Blueprint6.SVGIconContainer";



const $b90a50544ad30fb8$export$f04a61298a47a40f = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { autoLoad: autoLoad = true, className: className, color: color, icon: icon, intent: intent, tagName: tagName = "span", svgProps: svgProps, title: title, htmlTitle: htmlTitle, ...htmlProps } = props;
    const size = props.size ?? (0, $6Y6tm.IconSize).STANDARD;
    const [iconPaths, setIconPaths] = (0, $kYL7Z.useState)(()=>typeof icon === "string" ? (0, $59c158682bdabfb0$export$4f13f83fd8bb1dac).getPaths(icon, size) : undefined);
    (0, $kYL7Z.useEffect)(()=>{
        let shouldCancelIconLoading = false;
        if (typeof icon === "string") {
            // The icon may have been loaded already, in which case we can simply grab it.
            // N.B. when `autoLoad={true}`, we can't rely on simply calling Icons.load() here to re-load an icon module
            // which has already been loaded & cached, since it may have been loaded with special loading options which
            // this component knows nothing about.
            const loadedIconPaths = (0, $59c158682bdabfb0$export$4f13f83fd8bb1dac).getPaths(icon, size);
            if (loadedIconPaths !== undefined) setIconPaths(loadedIconPaths);
            else if (autoLoad) (0, $59c158682bdabfb0$export$4f13f83fd8bb1dac).load(icon, size).then(()=>{
                // if this effect expired by the time icon loaded, then don't set state
                if (!shouldCancelIconLoading) setIconPaths((0, $59c158682bdabfb0$export$4f13f83fd8bb1dac).getPaths(icon, size));
            }).catch((reason)=>{
                console.error(`[Blueprint] Icon '${icon}' (${size}px) could not be loaded.`, reason);
            });
            else console.error(`[Blueprint] Icon '${icon}' (${size}px) is not loaded yet and autoLoad={false}, did you call Icons.load('${icon}', ${size})?`);
        }
        return ()=>{
            shouldCancelIconLoading = true;
        };
    }, [
        autoLoad,
        icon,
        size
    ]);
    if (icon == null || typeof icon === "boolean") return null;
    else if (typeof icon !== "string") return icon;
    if (iconPaths == null) {
        // fall back to icon font if unloaded or unable to load SVG implementation
        const sizeClass = size === (0, $6Y6tm.IconSize).STANDARD ? (0, $2cfd35af7ec11fdd$exports).ICON_STANDARD : size === (0, $6Y6tm.IconSize).LARGE ? (0, $2cfd35af7ec11fdd$exports).ICON_LARGE : undefined;
        return (0, $kYL7Z.createElement)(tagName || "span", {
            "aria-hidden": title ? undefined : true,
            ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(htmlProps),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).ICON, sizeClass, (0, $2cfd35af7ec11fdd$exports).iconClass(icon), (0, $2cfd35af7ec11fdd$exports).intentClass(intent), className),
            "data-icon": icon,
            ref: ref,
            title: htmlTitle
        });
    } else {
        const pathElements = iconPaths.map((d, i)=>(0, $fc31e5e9fc16a880$exports.jsx)("path", {
                d: d,
                fillRule: "evenodd"
            }, i));
        // HACKHACK: there is no good way to narrow the type of SVGIconContainerProps here because of the use
        // of a conditional type within the type union that defines that interface. So we cast to <any>.
        // see https://github.com/microsoft/TypeScript/issues/24929, https://github.com/microsoft/TypeScript/issues/33014
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
            children: pathElements,
            // don't forward `Classes.ICON` or `Classes.iconClass(icon)` here, since the container will render those classes
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).intentClass(intent), className),
            color: color,
            htmlTitle: htmlTitle,
            iconName: icon,
            ref: ref,
            size: size,
            svgProps: svgProps,
            tagName: tagName,
            title: title,
            ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(htmlProps)
        });
    }
});
$b90a50544ad30fb8$export$f04a61298a47a40f.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Icon`;



/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $kYL7Z = parcelRequire("kYL7Z");


/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

const $c7a0a0a998d4e92a$export$700979bc83e7db82 = (0, $5f6dd9e57dfd2e30$export$974c8c6d1fbc6154)() ? (0, $kYL7Z.useLayoutEffect) : (0, $kYL7Z.useEffect);


const $51dde1f29cbe0fd9$export$5f1af8db9871e1d6 = (0, $kYL7Z.forwardRef)(({ children: children, tagName: tagName = "div", title: title, className: className, ellipsize: ellipsize = false, ...htmlProps }, forwardedRef)=>{
    const contentMeasuringRef = (0, $kYL7Z.useRef)();
    const textRef = (0, $kYL7Z.useMemo)(()=>(0, $7544862da546e887$export$c9058316764c140e)(contentMeasuringRef, forwardedRef), [
        forwardedRef
    ]);
    const [textContent, setTextContent] = (0, $kYL7Z.useState)("");
    const [isContentOverflowing, setIsContentOverflowing] = (0, $kYL7Z.useState)();
    // try to be conservative about running this effect, since querying scrollWidth causes the browser to reflow / recalculate styles,
    // which can be very expensive for long lists (for example, in long Menus)
    (0, $c7a0a0a998d4e92a$export$700979bc83e7db82)(()=>{
        if (contentMeasuringRef.current?.textContent != null) {
            setIsContentOverflowing(ellipsize && contentMeasuringRef.current.scrollWidth > contentMeasuringRef.current.clientWidth);
            setTextContent(contentMeasuringRef.current.textContent);
        }
    }, [
        contentMeasuringRef,
        children,
        ellipsize
    ]);
    return (0, $kYL7Z.createElement)(tagName, {
        ...htmlProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))({
            [(0, $2cfd35af7ec11fdd$exports).TEXT_OVERFLOW_ELLIPSIS]: ellipsize
        }, className),
        ref: textRef,
        title: title ?? (isContentOverflowing ? textContent : undefined)
    }, children);
});
$51dde1f29cbe0fd9$export$5f1af8db9871e1d6.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Text`;


const $aa0ed25827418946$export$353f5b6fc5456de1 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const commonAttributes = $aa0ed25827418946$var$useSharedButtonAttributes(props, ref);
    return (0, $fc31e5e9fc16a880$exports.jsx)("button", {
        type: "button",
        ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(props),
        ...commonAttributes,
        children: $aa0ed25827418946$var$renderButtonContents(props)
    });
});
$aa0ed25827418946$export$353f5b6fc5456de1.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Button`;
const $aa0ed25827418946$export$59a34841c163ed64 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { href: href } = props;
    const commonProps = $aa0ed25827418946$var$useSharedButtonAttributes(props, ref, {
        defaultTabIndex: 0,
        disabledTabIndex: -1
    });
    return (0, $fc31e5e9fc16a880$exports.jsx)("a", {
        role: "button",
        ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(props),
        ...commonProps,
        "aria-disabled": commonProps.disabled,
        href: commonProps.disabled ? undefined : href,
        children: $aa0ed25827418946$var$renderButtonContents(props)
    });
});
$aa0ed25827418946$export$59a34841c163ed64.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.AnchorButton`;
/**
 * Most of the button logic lives in this shared hook.
 */ function $aa0ed25827418946$var$useSharedButtonAttributes(props, ref, options) {
    const { alignText: alignText, fill: fill, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
    large, loading: loading = false, minimal: // eslint-disable-next-line @typescript-eslint/no-deprecated
    minimal, outlined: // eslint-disable-next-line @typescript-eslint/no-deprecated
    outlined, size: size = "medium", small: // eslint-disable-next-line @typescript-eslint/no-deprecated
    small, variant: variant = "solid" } = props;
    const disabled = props.disabled || loading;
    const [active, interactiveProps] = (0, $31e2d7b239eaf344$export$7c46b9e4cdce0dd5)(!disabled, props, ref, options);
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).BUTTON, {
        [(0, $2cfd35af7ec11fdd$exports).ACTIVE]: active,
        [(0, $2cfd35af7ec11fdd$exports).DISABLED]: disabled,
        [(0, $2cfd35af7ec11fdd$exports).FILL]: fill,
        [(0, $2cfd35af7ec11fdd$exports).LOADING]: loading
    }, (0, $2cfd35af7ec11fdd$exports).alignmentClass(alignText), (0, $2cfd35af7ec11fdd$exports).intentClass(props.intent), (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
        large: large,
        small: small
    }), (0, $2cfd35af7ec11fdd$exports).variantClass(variant, {
        minimal: minimal,
        outlined: outlined
    }), props.className);
    return {
        ...interactiveProps,
        className: className,
        disabled: disabled
    };
}
/**
 * Shared rendering code for button contents.
 */ function $aa0ed25827418946$var$renderButtonContents(props) {
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const { children: children, ellipsizeText: ellipsizeText, endIcon: endIcon, icon: icon, loading: loading, rightIcon: rightIcon, text: text, textClassName: textClassName } = props;
    const hasTextContent = !(0, $5f04c694ca05154e$exports).isReactNodeEmpty(text) || !(0, $5f04c694ca05154e$exports).isReactNodeEmpty(children);
    return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            loading && (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                className: (0, $2cfd35af7ec11fdd$exports).BUTTON_SPINNER,
                size: (0, $425946125bdc4b8f$export$11e6017846e949).SMALL
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: icon
            }),
            hasTextContent && (0, $fc31e5e9fc16a880$exports.jsxs)((0, $51dde1f29cbe0fd9$export$5f1af8db9871e1d6), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).BUTTON_TEXT, textClassName),
                ellipsize: ellipsizeText,
                tagName: "span",
                children: [
                    text,
                    children
                ]
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: endIcon ?? rightIcon
            })
        ]
    });
}



const $92e6067166fae914$var$Title = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).h3`
  margin-top: 1em;
`;
const $92e6067166fae914$var$Wrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
  padding: 2em;
  background: ${(0, $2df8c38f80e77278$export$f1fbbe1776f7d7f)};
  width: 100%;
  text-align: center;
  height: 100vh;
`;
const $92e6067166fae914$export$3cb69218ff952ef8 = ()=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($92e6067166fae914$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: "warning-sign"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($92e6067166fae914$var$Title, {
                children: "Page not found"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/',
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    intent: (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).PRIMARY,
                    children: "Home"
                })
            })
        ]
    });




var $kYL7Z = parcelRequire("kYL7Z");



const $db43518de4d3e4ff$export$f14c0e3f98d164c0 = ()=>{
    const [redirectToHome, setRedirectToHome] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        (async ()=>{
            const auth0 = (0, $128dd395bc2881df$export$caa56256f2cca349)();
            const isAuthenticated = await auth0.isAuthenticated();
            if (isAuthenticated) setRedirectToHome(true);
            else await auth0.loginWithRedirect({
                authorizationParams: {
                    redirect_uri: window.location.origin
                }
            });
        })();
    }, []);
    if (redirectToHome) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$444b3ab0cb9aec40), {
        to: "/",
        replace: true
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $711b21ca0f0dd1b5$export$e94eec0db1e8c995), {});
};
const $db43518de4d3e4ff$export$ae5920452e7cb547 = ()=>{
    const auth0Client = (0, $128dd395bc2881df$export$caa56256f2cca349)();
    auth0Client.logout({
        logoutParams: {
            returnTo: window.location.origin
        }
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $711b21ca0f0dd1b5$export$e94eec0db1e8c995), {});
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");

parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");







var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $99be9a3184d0ed36$export$81585da998e09b11 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "small-cross",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M228.2 200L294 265.8C297.8 269.4 300 274.4 300 280C300 291 291 300 280 300C274.4000000000001 300 269.4000000000001 297.8 265.8 294.2L200 228.2L134.2 294.2C130.6 297.8 125.6 300 120 300C109 300 100 291 100 280C100 274.4 102.2 269.4 105.8 265.8L171.8 200L106 134.2000000000001C102.2 130.6 100 125.6 100 120C100 109 109 100 120 100C125.6 100 130.6 102.2 134.2 105.8L200 171.8L265.8 106C269.4000000000001 102.2 274.4000000000001 100 280 100C291 100 300 109 300 120C300 125.6 297.8 130.6 294.2000000000001 134.2000000000001L228.2 200z" : "M188.2 160L234 205.8C237.8 209.4 240 214.4 240 220C240 231 231 240 220 240C214.4 240 209.4 237.8 205.8 234.2L160 188.2L114.2 234.2C110.6 237.8 105.6 240 100 240C89 240 80 231 80 220C80 214.4 82.2 209.4 85.8 205.8L131.8 160L86 114.2C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L160 131.8L205.8 86C209.4 82.2 214.4 80 220 80C231 80 240 89 240 100C240 105.6 237.8 110.6 234.2 114.2L188.2 160z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$99be9a3184d0ed36$export$81585da998e09b11.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$99be9a3184d0ed36$export$81585da998e09b11.displayName = `Blueprint6.Icon.SmallCross`;
var $99be9a3184d0ed36$export$2e2bcd8739ae039 = $99be9a3184d0ed36$export$81585da998e09b11;



const $2bef731a9a97e30f$export$eb6c87c0f34cc108 = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const { className: className, large: large, onRemove: onRemove, size: size, tabIndex: tabIndex } = props;
    const isLarge = large || size === "large" || className?.includes((0, $2cfd35af7ec11fdd$exports).LARGE);
    const handleRemoveClick = (0, $kYL7Z.useCallback)((e)=>{
        onRemove?.(e, props);
    }, [
        onRemove,
        props
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)("button", {
        "aria-label": "Remove tag",
        type: "button",
        className: (0, $2cfd35af7ec11fdd$exports).TAG_REMOVE,
        onClick: handleRemoveClick,
        tabIndex: tabIndex,
        children: (0, $fc31e5e9fc16a880$exports.jsx)((0, $99be9a3184d0ed36$export$81585da998e09b11), {
            size: isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD
        })
    });
};
$2bef731a9a97e30f$export$eb6c87c0f34cc108.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.TagRemoveButton`;


const $0975f43a8b42d010$export$3288d34c523a1192 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { children: children, className: className, endIcon: endIcon, fill: fill = false, icon: icon, intent: intent, interactive: interactive, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
    large = false, minimal: minimal = false, multiline: multiline, onRemove: onRemove, rightIcon: // eslint-disable-next-line @typescript-eslint/no-deprecated
    rightIcon, round: round = false, size: size = "medium", tabIndex: tabIndex = 0, htmlTitle: htmlTitle, ...htmlProps } = props;
    const isRemovable = (0, $5f04c694ca05154e$exports).isFunction(onRemove);
    const isInteractive = interactive ?? htmlProps.onClick != null;
    const [active, interactiveProps] = (0, $31e2d7b239eaf344$export$7c46b9e4cdce0dd5)(isInteractive, props, ref, {
        defaultTabIndex: 0,
        disabledTabIndex: undefined
    });
    const tagClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TAG, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
        large: large
    }), {
        [(0, $2cfd35af7ec11fdd$exports).ACTIVE]: active,
        [(0, $2cfd35af7ec11fdd$exports).FILL]: fill,
        [(0, $2cfd35af7ec11fdd$exports).INTERACTIVE]: isInteractive,
        [(0, $2cfd35af7ec11fdd$exports).MINIMAL]: minimal,
        [(0, $2cfd35af7ec11fdd$exports).ROUND]: round
    }, className);
    return (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
        ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(htmlProps),
        ...interactiveProps,
        className: tagClasses,
        role: isInteractive ? "button" : undefined,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: icon
            }),
            !(0, $dd6a2a6ae729b1ca$export$5a81b62107752acd)(children) && (0, $fc31e5e9fc16a880$exports.jsx)((0, $51dde1f29cbe0fd9$export$5f1af8db9871e1d6), {
                className: (0, $2cfd35af7ec11fdd$exports).FILL,
                ellipsize: !multiline,
                tagName: "span",
                title: htmlTitle,
                children: children
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: endIcon ?? rightIcon
            }),
            isRemovable && (0, $fc31e5e9fc16a880$exports.jsx)((0, $2bef731a9a97e30f$export$eb6c87c0f34cc108), {
                ...props
            })
        ]
    });
});
$0975f43a8b42d010$export$3288d34c523a1192.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Tag`;



var $508d3b93c20f9d5b$exports = {};
$508d3b93c20f9d5b$exports = import.meta.resolve("44bCj");


const $c7a73239b47a74cf$export$44c6a27b41bcee9f = {
    desktopNavbarWidth: '18em',
    columnsNumberNeededBeforeHavingFixWitdh: 5
};
const $c7a73239b47a74cf$export$da34334718e35096 = (theme)=>{
    if (theme) return {
        all: theme.chartColors[8],
        filtered: theme.chartColors[8],
        other: theme.chartColors[9],
        gender_male: theme.properties['--gender-male'],
        gender_female: theme.properties['--gender-female'],
        gender_undefined: theme.properties['--gender-undefined'],
        age_0_15: theme.chartColors[0],
        age_16_24: theme.chartColors[1],
        age_25_34: theme.chartColors[2],
        age_35_44: theme.chartColors[3],
        age_45_54: theme.chartColors[4],
        age_55_64: theme.chartColors[5],
        age_65_100: theme.chartColors[6],
        age_undefined: theme.grayUndefined,
        role_staff: theme.chartColors[3],
        role_customer: theme.chartColors[4],
        role_undefined: theme.properties['--gray-undefined']
    };
};
const $c7a73239b47a74cf$export$17e4c67b460a8fbc = (key, theme)=>{
    if (theme) {
        if (key.includes('female')) return theme.properties['--gender-female'];
        if (key.includes('male')) return theme.properties['--gender-male'];
    }
};
const $c7a73239b47a74cf$export$d07517a676ce386f = {
    PHONE_SIZE: '480px',
    PHONE_SIZE_PLUS_1: '481px',
    TABLET_SIZE: '820px',
    TABLET_SIZE_PLUS_1: '821px',
    SMALL_PC_SIZE: '1000px',
    SMALL_PC_SIZE_PLUS_1: '1001px',
    MED_PC_SIZE: '1300px',
    MED_PC_SIZE_PLUS_1: '1301px'
};
const $c7a73239b47a74cf$export$f72d8951b36b047e = ()=>{
    const width = window.innerWidth;
    if (width <= 820) return $c7a73239b47a74cf$export$d07517a676ce386f.PHONE_SIZE;
    else if (820 < width && width <= 1000) return $c7a73239b47a74cf$export$d07517a676ce386f.TABLET_SIZE;
    else if (1000 < width && width <= 1300) return $c7a73239b47a74cf$export$d07517a676ce386f.SMALL_PC_SIZE;
    else return $c7a73239b47a74cf$export$d07517a676ce386f.MED_PC_SIZE;
};
const $c7a73239b47a74cf$export$cbcfe4007f417765 = (theme)=>{
    if (theme) return {
        defaultFont: theme.properties['--fonts-default'],
        headingFont: theme.properties['--fonts-heading'],
        widgetFont: theme.properties['--fonts-widget-body']
    };
};


var $7f3412929cea4d45$exports = {};
'use strict';
Object.defineProperty($7f3412929cea4d45$exports, "__esModule", {
    value: true
});
$7f3412929cea4d45$exports.Scrollbars = undefined;
var $69ff16989ae8a20b$exports = {};
'use strict';
Object.defineProperty($69ff16989ae8a20b$exports, "__esModule", {
    value: true
});
var $69ff16989ae8a20b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $69ff16989ae8a20b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $8ca860769b6e01bc$exports = {};
var $3e96ce0a2e51bbb0$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $3e96ce0a2e51bbb0$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $3e96ce0a2e51bbb0$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $3e96ce0a2e51bbb0$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($3e96ce0a2e51bbb0$exports);


var $8ca860769b6e01bc$var$root = typeof window === 'undefined' ? $parcel$global : window, $8ca860769b6e01bc$var$vendors = [
    'moz',
    'webkit'
], $8ca860769b6e01bc$var$suffix = 'AnimationFrame', $8ca860769b6e01bc$var$raf = $8ca860769b6e01bc$var$root['request' + $8ca860769b6e01bc$var$suffix], $8ca860769b6e01bc$var$caf = $8ca860769b6e01bc$var$root['cancel' + $8ca860769b6e01bc$var$suffix] || $8ca860769b6e01bc$var$root['cancelRequest' + $8ca860769b6e01bc$var$suffix];
for(var $8ca860769b6e01bc$var$i = 0; !$8ca860769b6e01bc$var$raf && $8ca860769b6e01bc$var$i < $8ca860769b6e01bc$var$vendors.length; $8ca860769b6e01bc$var$i++){
    $8ca860769b6e01bc$var$raf = $8ca860769b6e01bc$var$root[$8ca860769b6e01bc$var$vendors[$8ca860769b6e01bc$var$i] + 'Request' + $8ca860769b6e01bc$var$suffix];
    $8ca860769b6e01bc$var$caf = $8ca860769b6e01bc$var$root[$8ca860769b6e01bc$var$vendors[$8ca860769b6e01bc$var$i] + 'Cancel' + $8ca860769b6e01bc$var$suffix] || $8ca860769b6e01bc$var$root[$8ca860769b6e01bc$var$vendors[$8ca860769b6e01bc$var$i] + 'CancelRequest' + $8ca860769b6e01bc$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$8ca860769b6e01bc$var$raf || !$8ca860769b6e01bc$var$caf) {
    var $8ca860769b6e01bc$var$last = 0, $8ca860769b6e01bc$var$id = 0, $8ca860769b6e01bc$var$queue = [], $8ca860769b6e01bc$var$frameDuration = 1000 / 60;
    $8ca860769b6e01bc$var$raf = function(callback) {
        if ($8ca860769b6e01bc$var$queue.length === 0) {
            var _now = $3e96ce0a2e51bbb0$exports(), next = Math.max(0, $8ca860769b6e01bc$var$frameDuration - (_now - $8ca860769b6e01bc$var$last));
            $8ca860769b6e01bc$var$last = next + _now;
            setTimeout(function() {
                var cp = $8ca860769b6e01bc$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $8ca860769b6e01bc$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($8ca860769b6e01bc$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $8ca860769b6e01bc$var$queue.push({
            handle: ++$8ca860769b6e01bc$var$id,
            callback: callback,
            cancelled: false
        });
        return $8ca860769b6e01bc$var$id;
    };
    $8ca860769b6e01bc$var$caf = function(handle) {
        for(var i = 0; i < $8ca860769b6e01bc$var$queue.length; i++)if ($8ca860769b6e01bc$var$queue[i].handle === handle) $8ca860769b6e01bc$var$queue[i].cancelled = true;
    };
}
$8ca860769b6e01bc$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $8ca860769b6e01bc$var$raf.call($8ca860769b6e01bc$var$root, fn);
};
$8ca860769b6e01bc$exports.cancel = function() {
    $8ca860769b6e01bc$var$caf.apply($8ca860769b6e01bc$var$root, arguments);
};
$8ca860769b6e01bc$exports.polyfill = function(object) {
    if (!object) object = $8ca860769b6e01bc$var$root;
    object.requestAnimationFrame = $8ca860769b6e01bc$var$raf;
    object.cancelAnimationFrame = $8ca860769b6e01bc$var$caf;
};


var $69ff16989ae8a20b$var$_raf3 = $69ff16989ae8a20b$var$_interopRequireDefault($8ca860769b6e01bc$exports);
var $9b3a03e45a00dc99$exports = {};
var $7fdbb56531331cea$exports = {};
var $7fdbb56531331cea$var$div = null;
var $7fdbb56531331cea$var$prefixes = [
    'Webkit',
    'Moz',
    'O',
    'ms'
];
$7fdbb56531331cea$exports = function prefixStyle(prop) {
    // re-use a dummy div
    if (!$7fdbb56531331cea$var$div) $7fdbb56531331cea$var$div = document.createElement('div');
    var style = $7fdbb56531331cea$var$div.style;
    // prop exists without prefix
    if (prop in style) return prop;
    // borderRadius -> BorderRadius
    var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);
    // find the vendor-prefixed prop
    for(var i = $7fdbb56531331cea$var$prefixes.length; i >= 0; i--){
        var name = $7fdbb56531331cea$var$prefixes[i] + titleCase;
        // e.g. WebkitBorderRadius or webkitBorderRadius
        if (name in style) return name;
    }
    return false;
};


var $417c86e211805aa2$exports = {};
var $05574f14f76354c6$exports = {};
var $c21197d21182d333$exports = {};
/**
 * Export.
 */ $c21197d21182d333$exports = $c21197d21182d333$var$toNoCase;
/**
 * Test whether a string is camel-case.
 */ var $c21197d21182d333$var$hasSpace = /\s/;
var $c21197d21182d333$var$hasSeparator = /(_|-|\.|:)/;
var $c21197d21182d333$var$hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;
/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */ function $c21197d21182d333$var$toNoCase(string) {
    if ($c21197d21182d333$var$hasSpace.test(string)) return string.toLowerCase();
    if ($c21197d21182d333$var$hasSeparator.test(string)) return ($c21197d21182d333$var$unseparate(string) || string).toLowerCase();
    if ($c21197d21182d333$var$hasCamel.test(string)) return $c21197d21182d333$var$uncamelize(string).toLowerCase();
    return string.toLowerCase();
}
/**
 * Separator splitter.
 */ var $c21197d21182d333$var$separatorSplitter = /[\W_]+(.|$)/g;
/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $c21197d21182d333$var$unseparate(string) {
    return string.replace($c21197d21182d333$var$separatorSplitter, function(m, next) {
        return next ? ' ' + next : '';
    });
}
/**
 * Camelcase splitter.
 */ var $c21197d21182d333$var$camelSplitter = /(.)([A-Z]+)/g;
/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */ function $c21197d21182d333$var$uncamelize(string) {
    return string.replace($c21197d21182d333$var$camelSplitter, function(m, previous, uppers) {
        return previous + ' ' + uppers.toLowerCase().split('').join(' ');
    });
}


/**
 * Export.
 */ $05574f14f76354c6$exports = $05574f14f76354c6$var$toSpaceCase;
/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */ function $05574f14f76354c6$var$toSpaceCase(string) {
    return $c21197d21182d333$exports(string).replace(/[\W_]+(.|$)/g, function(matches, match) {
        return match ? ' ' + match : '';
    }).trim();
}


/**
 * Export.
 */ $417c86e211805aa2$exports = $417c86e211805aa2$var$toCamelCase;
/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */ function $417c86e211805aa2$var$toCamelCase(string) {
    return $05574f14f76354c6$exports(string).replace(/\s(\w)/g, function(matches, letter) {
        return letter.toUpperCase();
    });
}


var $9b3a03e45a00dc99$var$cache = {
    'float': 'cssFloat'
};
var $e76e494b870032f8$exports = {};
/* The following list is defined in React's core */ var $e76e494b870032f8$var$IS_UNITLESS = {
    animationIterationCount: true,
    boxFlex: true,
    boxFlexGroup: true,
    boxOrdinalGroup: true,
    columnCount: true,
    flex: true,
    flexGrow: true,
    flexPositive: true,
    flexShrink: true,
    flexNegative: true,
    flexOrder: true,
    gridRow: true,
    gridColumn: true,
    fontWeight: true,
    lineClamp: true,
    lineHeight: true,
    opacity: true,
    order: true,
    orphans: true,
    tabSize: true,
    widows: true,
    zIndex: true,
    zoom: true,
    // SVG-related properties
    fillOpacity: true,
    stopOpacity: true,
    strokeDashoffset: true,
    strokeOpacity: true,
    strokeWidth: true
};
$e76e494b870032f8$exports = function(name, value) {
    if (typeof value === 'number' && !$e76e494b870032f8$var$IS_UNITLESS[name]) return value + 'px';
    else return value;
};


function $9b3a03e45a00dc99$var$style(element, property, value) {
    var camel = $9b3a03e45a00dc99$var$cache[property];
    if (typeof camel === 'undefined') camel = $9b3a03e45a00dc99$var$detect(property);
    // may be false if CSS prop is unsupported
    if (camel) {
        if (value === undefined) return element.style[camel];
        element.style[camel] = $e76e494b870032f8$exports(camel, value);
    }
}
function $9b3a03e45a00dc99$var$each(element, properties) {
    for(var k in properties)if (properties.hasOwnProperty(k)) $9b3a03e45a00dc99$var$style(element, k, properties[k]);
}
function $9b3a03e45a00dc99$var$detect(cssProp) {
    var camel = $417c86e211805aa2$exports(cssProp);
    var result = $7fdbb56531331cea$exports(camel);
    $9b3a03e45a00dc99$var$cache[camel] = $9b3a03e45a00dc99$var$cache[cssProp] = $9b3a03e45a00dc99$var$cache[result] = result;
    return result;
}
function $9b3a03e45a00dc99$var$set() {
    if (arguments.length === 2) {
        if (typeof arguments[1] === 'string') arguments[0].style.cssText = arguments[1];
        else $9b3a03e45a00dc99$var$each(arguments[0], arguments[1]);
    } else $9b3a03e45a00dc99$var$style(arguments[0], arguments[1], arguments[2]);
}
$9b3a03e45a00dc99$exports = $9b3a03e45a00dc99$var$set;
$9b3a03e45a00dc99$exports.set = $9b3a03e45a00dc99$var$set;
$9b3a03e45a00dc99$exports.get = function(element, properties) {
    if (Array.isArray(properties)) return properties.reduce(function(obj, prop) {
        obj[prop] = $9b3a03e45a00dc99$var$style(element, prop || '');
        return obj;
    }, {});
    else return $9b3a03e45a00dc99$var$style(element, properties || '');
};


var $69ff16989ae8a20b$var$_domCss2 = $69ff16989ae8a20b$var$_interopRequireDefault($9b3a03e45a00dc99$exports);

var $kYL7Z = parcelRequire("kYL7Z");
var $393ebd45498ca0b8$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $393ebd45498ca0b8$var$ReactIs, $393ebd45498ca0b8$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$393ebd45498ca0b8$exports = (parcelRequire("aURB2"))();


var $69ff16989ae8a20b$var$_propTypes2 = $69ff16989ae8a20b$var$_interopRequireDefault($393ebd45498ca0b8$exports);
var $86f727d3bd34ab1b$exports = {};
'use strict';
Object.defineProperty($86f727d3bd34ab1b$exports, "__esModule", {
    value: true
});
$86f727d3bd34ab1b$exports["default"] = $86f727d3bd34ab1b$var$isString;
function $86f727d3bd34ab1b$var$isString(maybe) {
    return typeof maybe === 'string';
}


var $69ff16989ae8a20b$var$_isString2 = $69ff16989ae8a20b$var$_interopRequireDefault($86f727d3bd34ab1b$exports);
var $b20328f3f5edd5a4$exports = {};
'use strict';
Object.defineProperty($b20328f3f5edd5a4$exports, "__esModule", {
    value: true
});
$b20328f3f5edd5a4$exports["default"] = $b20328f3f5edd5a4$var$getScrollbarWidth;

var $b20328f3f5edd5a4$var$_domCss2 = $b20328f3f5edd5a4$var$_interopRequireDefault($9b3a03e45a00dc99$exports);
function $b20328f3f5edd5a4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
var $b20328f3f5edd5a4$var$scrollbarWidth = false;
function $b20328f3f5edd5a4$var$getScrollbarWidth() {
    var cacheEnabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    if (cacheEnabled && $b20328f3f5edd5a4$var$scrollbarWidth !== false) return $b20328f3f5edd5a4$var$scrollbarWidth;
    /* istanbul ignore else */ if (typeof document !== 'undefined') {
        var div = document.createElement('div');
        (0, $b20328f3f5edd5a4$var$_domCss2["default"])(div, {
            width: 100,
            height: 100,
            position: 'absolute',
            top: -9999,
            overflow: 'scroll',
            MsOverflowStyle: 'scrollbar'
        });
        document.body.appendChild(div);
        $b20328f3f5edd5a4$var$scrollbarWidth = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    } else $b20328f3f5edd5a4$var$scrollbarWidth = 0;
    return $b20328f3f5edd5a4$var$scrollbarWidth || 0;
}


var $69ff16989ae8a20b$var$_getScrollbarWidth2 = $69ff16989ae8a20b$var$_interopRequireDefault($b20328f3f5edd5a4$exports);
var $6d0759b47a7d60c6$exports = {};
"use strict";
Object.defineProperty($6d0759b47a7d60c6$exports, "__esModule", {
    value: true
});
$6d0759b47a7d60c6$exports["default"] = $6d0759b47a7d60c6$var$returnFalse;
function $6d0759b47a7d60c6$var$returnFalse() {
    return false;
}


var $69ff16989ae8a20b$var$_returnFalse2 = $69ff16989ae8a20b$var$_interopRequireDefault($6d0759b47a7d60c6$exports);
var $94fc878b61afbdb0$exports = {};
"use strict";
Object.defineProperty($94fc878b61afbdb0$exports, "__esModule", {
    value: true
});
$94fc878b61afbdb0$exports["default"] = $94fc878b61afbdb0$var$getInnerWidth;
function $94fc878b61afbdb0$var$getInnerWidth(el) {
    var clientWidth = el.clientWidth;
    var _getComputedStyle = getComputedStyle(el), paddingLeft = _getComputedStyle.paddingLeft, paddingRight = _getComputedStyle.paddingRight;
    return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}


var $69ff16989ae8a20b$var$_getInnerWidth2 = $69ff16989ae8a20b$var$_interopRequireDefault($94fc878b61afbdb0$exports);
var $e743822ca4207c04$exports = {};
"use strict";
Object.defineProperty($e743822ca4207c04$exports, "__esModule", {
    value: true
});
$e743822ca4207c04$exports["default"] = $e743822ca4207c04$var$getInnerHeight;
function $e743822ca4207c04$var$getInnerHeight(el) {
    var clientHeight = el.clientHeight;
    var _getComputedStyle = getComputedStyle(el), paddingTop = _getComputedStyle.paddingTop, paddingBottom = _getComputedStyle.paddingBottom;
    return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}


var $69ff16989ae8a20b$var$_getInnerHeight2 = $69ff16989ae8a20b$var$_interopRequireDefault($e743822ca4207c04$exports);
var $43ff43b77ad19ce1$exports = {};
'use strict';
Object.defineProperty($43ff43b77ad19ce1$exports, "__esModule", {
    value: true
});
var $43ff43b77ad19ce1$var$containerStyleDefault = $43ff43b77ad19ce1$exports.containerStyleDefault = {
    position: 'relative',
    overflow: 'hidden',
    width: '100%',
    height: '100%'
};
// Overrides containerStyleDefault properties
var $43ff43b77ad19ce1$var$containerStyleAutoHeight = $43ff43b77ad19ce1$exports.containerStyleAutoHeight = {
    height: 'auto'
};
var $43ff43b77ad19ce1$var$viewStyleDefault = $43ff43b77ad19ce1$exports.viewStyleDefault = {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'scroll',
    WebkitOverflowScrolling: 'touch'
};
// Overrides viewStyleDefault properties
var $43ff43b77ad19ce1$var$viewStyleAutoHeight = $43ff43b77ad19ce1$exports.viewStyleAutoHeight = {
    position: 'relative',
    top: undefined,
    left: undefined,
    right: undefined,
    bottom: undefined
};
var $43ff43b77ad19ce1$var$viewStyleUniversalInitial = $43ff43b77ad19ce1$exports.viewStyleUniversalInitial = {
    overflow: 'hidden',
    marginRight: 0,
    marginBottom: 0
};
var $43ff43b77ad19ce1$var$trackHorizontalStyleDefault = $43ff43b77ad19ce1$exports.trackHorizontalStyleDefault = {
    position: 'absolute',
    height: 6
};
var $43ff43b77ad19ce1$var$trackVerticalStyleDefault = $43ff43b77ad19ce1$exports.trackVerticalStyleDefault = {
    position: 'absolute',
    width: 6
};
var $43ff43b77ad19ce1$var$thumbHorizontalStyleDefault = $43ff43b77ad19ce1$exports.thumbHorizontalStyleDefault = {
    position: 'relative',
    display: 'block',
    height: '100%'
};
var $43ff43b77ad19ce1$var$thumbVerticalStyleDefault = $43ff43b77ad19ce1$exports.thumbVerticalStyleDefault = {
    position: 'relative',
    display: 'block',
    width: '100%'
};
var $43ff43b77ad19ce1$var$disableSelectStyle = $43ff43b77ad19ce1$exports.disableSelectStyle = {
    userSelect: 'none'
};
var $43ff43b77ad19ce1$var$disableSelectStyleReset = $43ff43b77ad19ce1$exports.disableSelectStyleReset = {
    userSelect: ''
};


var $9ad75478585d779c$exports = {};
'use strict';
Object.defineProperty($9ad75478585d779c$exports, "__esModule", {
    value: true
});
var $9ad75478585d779c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
$9ad75478585d779c$exports.renderViewDefault = $9ad75478585d779c$var$renderViewDefault;
$9ad75478585d779c$exports.renderTrackHorizontalDefault = $9ad75478585d779c$var$renderTrackHorizontalDefault;
$9ad75478585d779c$exports.renderTrackVerticalDefault = $9ad75478585d779c$var$renderTrackVerticalDefault;
$9ad75478585d779c$exports.renderThumbHorizontalDefault = $9ad75478585d779c$var$renderThumbHorizontalDefault;
$9ad75478585d779c$exports.renderThumbVerticalDefault = $9ad75478585d779c$var$renderThumbVerticalDefault;

var $kYL7Z = parcelRequire("kYL7Z");
var $9ad75478585d779c$var$_react2 = $9ad75478585d779c$var$_interopRequireDefault($kYL7Z);
function $9ad75478585d779c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $9ad75478585d779c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
/* eslint-disable react/prop-types */ function $9ad75478585d779c$var$renderViewDefault(props) {
    return $9ad75478585d779c$var$_react2["default"].createElement('div', props);
}
function $9ad75478585d779c$var$renderTrackHorizontalDefault(_ref) {
    var style = _ref.style, props = $9ad75478585d779c$var$_objectWithoutProperties(_ref, [
        'style'
    ]);
    var finalStyle = $9ad75478585d779c$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        left: 2,
        borderRadius: 3
    });
    return $9ad75478585d779c$var$_react2["default"].createElement('div', $9ad75478585d779c$var$_extends({
        style: finalStyle
    }, props));
}
function $9ad75478585d779c$var$renderTrackVerticalDefault(_ref2) {
    var style = _ref2.style, props = $9ad75478585d779c$var$_objectWithoutProperties(_ref2, [
        'style'
    ]);
    var finalStyle = $9ad75478585d779c$var$_extends({}, style, {
        right: 2,
        bottom: 2,
        top: 2,
        borderRadius: 3
    });
    return $9ad75478585d779c$var$_react2["default"].createElement('div', $9ad75478585d779c$var$_extends({
        style: finalStyle
    }, props));
}
function $9ad75478585d779c$var$renderThumbHorizontalDefault(_ref3) {
    var style = _ref3.style, props = $9ad75478585d779c$var$_objectWithoutProperties(_ref3, [
        'style'
    ]);
    var finalStyle = $9ad75478585d779c$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $9ad75478585d779c$var$_react2["default"].createElement('div', $9ad75478585d779c$var$_extends({
        style: finalStyle
    }, props));
}
function $9ad75478585d779c$var$renderThumbVerticalDefault(_ref4) {
    var style = _ref4.style, props = $9ad75478585d779c$var$_objectWithoutProperties(_ref4, [
        'style'
    ]);
    var finalStyle = $9ad75478585d779c$var$_extends({}, style, {
        cursor: 'pointer',
        borderRadius: 'inherit',
        backgroundColor: 'rgba(0,0,0,.2)'
    });
    return $9ad75478585d779c$var$_react2["default"].createElement('div', $9ad75478585d779c$var$_extends({
        style: finalStyle
    }, props));
}


function $69ff16989ae8a20b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $69ff16989ae8a20b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $69ff16989ae8a20b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $69ff16989ae8a20b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $69ff16989ae8a20b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $69ff16989ae8a20b$var$Scrollbars = function(_Component) {
    $69ff16989ae8a20b$var$_inherits(Scrollbars, _Component);
    function Scrollbars(props) {
        var _ref;
        $69ff16989ae8a20b$var$_classCallCheck(this, Scrollbars);
        for(var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
        var _this = $69ff16989ae8a20b$var$_possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [
            this,
            props
        ].concat(rest)));
        _this.getScrollLeft = _this.getScrollLeft.bind(_this);
        _this.getScrollTop = _this.getScrollTop.bind(_this);
        _this.getScrollWidth = _this.getScrollWidth.bind(_this);
        _this.getScrollHeight = _this.getScrollHeight.bind(_this);
        _this.getClientWidth = _this.getClientWidth.bind(_this);
        _this.getClientHeight = _this.getClientHeight.bind(_this);
        _this.getValues = _this.getValues.bind(_this);
        _this.getThumbHorizontalWidth = _this.getThumbHorizontalWidth.bind(_this);
        _this.getThumbVerticalHeight = _this.getThumbVerticalHeight.bind(_this);
        _this.getScrollLeftForOffset = _this.getScrollLeftForOffset.bind(_this);
        _this.getScrollTopForOffset = _this.getScrollTopForOffset.bind(_this);
        _this.scrollLeft = _this.scrollLeft.bind(_this);
        _this.scrollTop = _this.scrollTop.bind(_this);
        _this.scrollToLeft = _this.scrollToLeft.bind(_this);
        _this.scrollToTop = _this.scrollToTop.bind(_this);
        _this.scrollToRight = _this.scrollToRight.bind(_this);
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.handleTrackMouseEnter = _this.handleTrackMouseEnter.bind(_this);
        _this.handleTrackMouseLeave = _this.handleTrackMouseLeave.bind(_this);
        _this.handleHorizontalTrackMouseDown = _this.handleHorizontalTrackMouseDown.bind(_this);
        _this.handleVerticalTrackMouseDown = _this.handleVerticalTrackMouseDown.bind(_this);
        _this.handleHorizontalThumbMouseDown = _this.handleHorizontalThumbMouseDown.bind(_this);
        _this.handleVerticalThumbMouseDown = _this.handleVerticalThumbMouseDown.bind(_this);
        _this.handleWindowResize = _this.handleWindowResize.bind(_this);
        _this.handleScroll = _this.handleScroll.bind(_this);
        _this.handleDrag = _this.handleDrag.bind(_this);
        _this.handleDragEnd = _this.handleDragEnd.bind(_this);
        _this.state = {
            didMountUniversal: false
        };
        return _this;
    }
    $69ff16989ae8a20b$var$_createClass(Scrollbars, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                this.addListeners();
                this.update();
                this.componentDidMountUniversal();
            }
        },
        {
            key: 'componentDidMountUniversal',
            value: function componentDidMountUniversal() {
                // eslint-disable-line react/sort-comp
                var universal = this.props.universal;
                if (!universal) return;
                this.setState({
                    didMountUniversal: true
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                this.update();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.removeListeners();
                (0, $8ca860769b6e01bc$exports.cancel)(this.requestFrame);
                clearTimeout(this.hideTracksTimeout);
                clearInterval(this.detectScrollingInterval);
            }
        },
        {
            key: 'getScrollLeft',
            value: function getScrollLeft() {
                if (!this.view) return 0;
                return this.view.scrollLeft;
            }
        },
        {
            key: 'getScrollTop',
            value: function getScrollTop() {
                if (!this.view) return 0;
                return this.view.scrollTop;
            }
        },
        {
            key: 'getScrollWidth',
            value: function getScrollWidth() {
                if (!this.view) return 0;
                return this.view.scrollWidth;
            }
        },
        {
            key: 'getScrollHeight',
            value: function getScrollHeight() {
                if (!this.view) return 0;
                return this.view.scrollHeight;
            }
        },
        {
            key: 'getClientWidth',
            value: function getClientWidth() {
                if (!this.view) return 0;
                return this.view.clientWidth;
            }
        },
        {
            key: 'getClientHeight',
            value: function getClientHeight() {
                if (!this.view) return 0;
                return this.view.clientHeight;
            }
        },
        {
            key: 'getValues',
            value: function getValues() {
                var _ref2 = this.view || {}, _ref2$scrollLeft = _ref2.scrollLeft, scrollLeft = _ref2$scrollLeft === undefined ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2.scrollTop, scrollTop = _ref2$scrollTop === undefined ? 0 : _ref2$scrollTop, _ref2$scrollWidth = _ref2.scrollWidth, scrollWidth = _ref2$scrollWidth === undefined ? 0 : _ref2$scrollWidth, _ref2$scrollHeight = _ref2.scrollHeight, scrollHeight = _ref2$scrollHeight === undefined ? 0 : _ref2$scrollHeight, _ref2$clientWidth = _ref2.clientWidth, clientWidth = _ref2$clientWidth === undefined ? 0 : _ref2$clientWidth, _ref2$clientHeight = _ref2.clientHeight, clientHeight = _ref2$clientHeight === undefined ? 0 : _ref2$clientHeight;
                return {
                    left: scrollLeft / (scrollWidth - clientWidth) || 0,
                    top: scrollTop / (scrollHeight - clientHeight) || 0,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollWidth: scrollWidth,
                    scrollHeight: scrollHeight,
                    clientWidth: clientWidth,
                    clientHeight: clientHeight
                };
            }
        },
        {
            key: 'getThumbHorizontalWidth',
            value: function getThumbHorizontalWidth() {
                var _props = this.props, thumbSize = _props.thumbSize, thumbMinSize = _props.thumbMinSize;
                var _view = this.view, scrollWidth = _view.scrollWidth, clientWidth = _view.clientWidth;
                var trackWidth = (0, $69ff16989ae8a20b$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
                if (trackWidth <= width) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(width, thumbMinSize);
            }
        },
        {
            key: 'getThumbVerticalHeight',
            value: function getThumbVerticalHeight() {
                var _props2 = this.props, thumbSize = _props2.thumbSize, thumbMinSize = _props2.thumbMinSize;
                var _view2 = this.view, scrollHeight = _view2.scrollHeight, clientHeight = _view2.clientHeight;
                var trackHeight = (0, $69ff16989ae8a20b$var$_getInnerHeight2["default"])(this.trackVertical);
                var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
                if (trackHeight <= height) return 0;
                if (thumbSize) return thumbSize;
                return Math.max(height, thumbMinSize);
            }
        },
        {
            key: 'getScrollLeftForOffset',
            value: function getScrollLeftForOffset(offset) {
                var _view3 = this.view, scrollWidth = _view3.scrollWidth, clientWidth = _view3.clientWidth;
                var trackWidth = (0, $69ff16989ae8a20b$var$_getInnerWidth2["default"])(this.trackHorizontal);
                var thumbWidth = this.getThumbHorizontalWidth();
                return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
            }
        },
        {
            key: 'getScrollTopForOffset',
            value: function getScrollTopForOffset(offset) {
                var _view4 = this.view, scrollHeight = _view4.scrollHeight, clientHeight = _view4.clientHeight;
                var trackHeight = (0, $69ff16989ae8a20b$var$_getInnerHeight2["default"])(this.trackVertical);
                var thumbHeight = this.getThumbVerticalHeight();
                return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
            }
        },
        {
            key: 'scrollLeft',
            value: function scrollLeft() {
                var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollLeft = left;
            }
        },
        {
            key: 'scrollTop',
            value: function scrollTop() {
                var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (!this.view) return;
                this.view.scrollTop = top;
            }
        },
        {
            key: 'scrollToLeft',
            value: function scrollToLeft() {
                if (!this.view) return;
                this.view.scrollLeft = 0;
            }
        },
        {
            key: 'scrollToTop',
            value: function scrollToTop() {
                if (!this.view) return;
                this.view.scrollTop = 0;
            }
        },
        {
            key: 'scrollToRight',
            value: function scrollToRight() {
                if (!this.view) return;
                this.view.scrollLeft = this.view.scrollWidth;
            }
        },
        {
            key: 'scrollToBottom',
            value: function scrollToBottom() {
                if (!this.view) return;
                this.view.scrollTop = this.view.scrollHeight;
            }
        },
        {
            key: 'addListeners',
            value: function addListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.addEventListener('scroll', this.handleScroll);
                if (!(0, $69ff16989ae8a20b$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.addEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.addEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.addEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.addEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.addEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.addEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.addEventListener('resize', this.handleWindowResize);
            }
        },
        {
            key: 'removeListeners',
            value: function removeListeners() {
                /* istanbul ignore if */ if (typeof document === 'undefined' || !this.view) return;
                var view = this.view, trackHorizontal = this.trackHorizontal, trackVertical = this.trackVertical, thumbHorizontal = this.thumbHorizontal, thumbVertical = this.thumbVertical;
                view.removeEventListener('scroll', this.handleScroll);
                if (!(0, $69ff16989ae8a20b$var$_getScrollbarWidth2["default"])()) return;
                trackHorizontal.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackHorizontal.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackHorizontal.removeEventListener('mousedown', this.handleHorizontalTrackMouseDown);
                trackVertical.removeEventListener('mouseenter', this.handleTrackMouseEnter);
                trackVertical.removeEventListener('mouseleave', this.handleTrackMouseLeave);
                trackVertical.removeEventListener('mousedown', this.handleVerticalTrackMouseDown);
                thumbHorizontal.removeEventListener('mousedown', this.handleHorizontalThumbMouseDown);
                thumbVertical.removeEventListener('mousedown', this.handleVerticalThumbMouseDown);
                window.removeEventListener('resize', this.handleWindowResize);
                // Possibly setup by `handleDragStart`
                this.teardownDragging();
            }
        },
        {
            key: 'handleScroll',
            value: function handleScroll(event) {
                var _this2 = this;
                var _props3 = this.props, onScroll = _props3.onScroll, onScrollFrame = _props3.onScrollFrame;
                if (onScroll) onScroll(event);
                this.update(function(values) {
                    var scrollLeft = values.scrollLeft, scrollTop = values.scrollTop;
                    _this2.viewScrollLeft = scrollLeft;
                    _this2.viewScrollTop = scrollTop;
                    if (onScrollFrame) onScrollFrame(values);
                });
                this.detectScrolling();
            }
        },
        {
            key: 'handleScrollStart',
            value: function handleScrollStart() {
                var onScrollStart = this.props.onScrollStart;
                if (onScrollStart) onScrollStart();
                this.handleScrollStartAutoHide();
            }
        },
        {
            key: 'handleScrollStartAutoHide',
            value: function handleScrollStartAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleScrollStop',
            value: function handleScrollStop() {
                var onScrollStop = this.props.onScrollStop;
                if (onScrollStop) onScrollStop();
                this.handleScrollStopAutoHide();
            }
        },
        {
            key: 'handleScrollStopAutoHide',
            value: function handleScrollStopAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleWindowResize',
            value: function handleWindowResize() {
                (0, $69ff16989ae8a20b$var$_getScrollbarWidth2["default"])(false);
                this.forceUpdate();
            }
        },
        {
            key: 'handleHorizontalTrackMouseDown',
            value: function handleHorizontalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientX = event.clientX;
                var _target$getBoundingCl = target.getBoundingClientRect(), targetLeft = _target$getBoundingCl.left;
                var thumbWidth = this.getThumbHorizontalWidth();
                var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
                this.view.scrollLeft = this.getScrollLeftForOffset(offset);
            }
        },
        {
            key: 'handleVerticalTrackMouseDown',
            value: function handleVerticalTrackMouseDown(event) {
                event.preventDefault();
                var target = event.target, clientY = event.clientY;
                var _target$getBoundingCl2 = target.getBoundingClientRect(), targetTop = _target$getBoundingCl2.top;
                var thumbHeight = this.getThumbVerticalHeight();
                var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
                this.view.scrollTop = this.getScrollTopForOffset(offset);
            }
        },
        {
            key: 'handleHorizontalThumbMouseDown',
            value: function handleHorizontalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientX = event.clientX;
                var offsetWidth = target.offsetWidth;
                var _target$getBoundingCl3 = target.getBoundingClientRect(), left = _target$getBoundingCl3.left;
                this.prevPageX = offsetWidth - (clientX - left);
            }
        },
        {
            key: 'handleVerticalThumbMouseDown',
            value: function handleVerticalThumbMouseDown(event) {
                event.preventDefault();
                this.handleDragStart(event);
                var target = event.target, clientY = event.clientY;
                var offsetHeight = target.offsetHeight;
                var _target$getBoundingCl4 = target.getBoundingClientRect(), top = _target$getBoundingCl4.top;
                this.prevPageY = offsetHeight - (clientY - top);
            }
        },
        {
            key: 'setupDragging',
            value: function setupDragging() {
                (0, $69ff16989ae8a20b$var$_domCss2["default"])(document.body, $43ff43b77ad19ce1$exports.disableSelectStyle);
                document.addEventListener('mousemove', this.handleDrag);
                document.addEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = $69ff16989ae8a20b$var$_returnFalse2["default"];
            }
        },
        {
            key: 'teardownDragging',
            value: function teardownDragging() {
                (0, $69ff16989ae8a20b$var$_domCss2["default"])(document.body, $43ff43b77ad19ce1$exports.disableSelectStyleReset);
                document.removeEventListener('mousemove', this.handleDrag);
                document.removeEventListener('mouseup', this.handleDragEnd);
                document.onselectstart = undefined;
            }
        },
        {
            key: 'handleDragStart',
            value: function handleDragStart(event) {
                this.dragging = true;
                event.stopImmediatePropagation();
                this.setupDragging();
            }
        },
        {
            key: 'handleDrag',
            value: function handleDrag(event) {
                if (this.prevPageX) {
                    var clientX = event.clientX;
                    var _trackHorizontal$getB = this.trackHorizontal.getBoundingClientRect(), trackLeft = _trackHorizontal$getB.left;
                    var thumbWidth = this.getThumbHorizontalWidth();
                    var clickPosition = thumbWidth - this.prevPageX;
                    var offset = -trackLeft + clientX - clickPosition;
                    this.view.scrollLeft = this.getScrollLeftForOffset(offset);
                }
                if (this.prevPageY) {
                    var clientY = event.clientY;
                    var _trackVertical$getBou = this.trackVertical.getBoundingClientRect(), trackTop = _trackVertical$getBou.top;
                    var thumbHeight = this.getThumbVerticalHeight();
                    var _clickPosition = thumbHeight - this.prevPageY;
                    var _offset = -trackTop + clientY - _clickPosition;
                    this.view.scrollTop = this.getScrollTopForOffset(_offset);
                }
                return false;
            }
        },
        {
            key: 'handleDragEnd',
            value: function handleDragEnd() {
                this.dragging = false;
                this.prevPageX = this.prevPageY = 0;
                this.teardownDragging();
                this.handleDragEndAutoHide();
            }
        },
        {
            key: 'handleDragEndAutoHide',
            value: function handleDragEndAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'handleTrackMouseEnter',
            value: function handleTrackMouseEnter() {
                this.trackMouseOver = true;
                this.handleTrackMouseEnterAutoHide();
            }
        },
        {
            key: 'handleTrackMouseEnterAutoHide',
            value: function handleTrackMouseEnterAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.showTracks();
            }
        },
        {
            key: 'handleTrackMouseLeave',
            value: function handleTrackMouseLeave() {
                this.trackMouseOver = false;
                this.handleTrackMouseLeaveAutoHide();
            }
        },
        {
            key: 'handleTrackMouseLeaveAutoHide',
            value: function handleTrackMouseLeaveAutoHide() {
                var autoHide = this.props.autoHide;
                if (!autoHide) return;
                this.hideTracks();
            }
        },
        {
            key: 'showTracks',
            value: function showTracks() {
                clearTimeout(this.hideTracksTimeout);
                (0, $69ff16989ae8a20b$var$_domCss2["default"])(this.trackHorizontal, {
                    opacity: 1
                });
                (0, $69ff16989ae8a20b$var$_domCss2["default"])(this.trackVertical, {
                    opacity: 1
                });
            }
        },
        {
            key: 'hideTracks',
            value: function hideTracks() {
                var _this3 = this;
                if (this.dragging) return;
                if (this.scrolling) return;
                if (this.trackMouseOver) return;
                var autoHideTimeout = this.props.autoHideTimeout;
                clearTimeout(this.hideTracksTimeout);
                this.hideTracksTimeout = setTimeout(function() {
                    (0, $69ff16989ae8a20b$var$_domCss2["default"])(_this3.trackHorizontal, {
                        opacity: 0
                    });
                    (0, $69ff16989ae8a20b$var$_domCss2["default"])(_this3.trackVertical, {
                        opacity: 0
                    });
                }, autoHideTimeout);
            }
        },
        {
            key: 'detectScrolling',
            value: function detectScrolling() {
                var _this4 = this;
                if (this.scrolling) return;
                this.scrolling = true;
                this.handleScrollStart();
                this.detectScrollingInterval = setInterval(function() {
                    if (_this4.lastViewScrollLeft === _this4.viewScrollLeft && _this4.lastViewScrollTop === _this4.viewScrollTop) {
                        clearInterval(_this4.detectScrollingInterval);
                        _this4.scrolling = false;
                        _this4.handleScrollStop();
                    }
                    _this4.lastViewScrollLeft = _this4.viewScrollLeft;
                    _this4.lastViewScrollTop = _this4.viewScrollTop;
                }, 100);
            }
        },
        {
            key: 'raf',
            value: function raf(callback) {
                var _this5 = this;
                if (this.requestFrame) $69ff16989ae8a20b$var$_raf3["default"].cancel(this.requestFrame);
                this.requestFrame = (0, $69ff16989ae8a20b$var$_raf3["default"])(function() {
                    _this5.requestFrame = undefined;
                    callback();
                });
            }
        },
        {
            key: 'update',
            value: function update(callback) {
                var _this6 = this;
                this.raf(function() {
                    return _this6._update(callback);
                });
            }
        },
        {
            key: '_update',
            value: function _update(callback) {
                var _props4 = this.props, onUpdate = _props4.onUpdate, hideTracksWhenNotNeeded = _props4.hideTracksWhenNotNeeded;
                var values = this.getValues();
                if ((0, $69ff16989ae8a20b$var$_getScrollbarWidth2["default"])()) {
                    var scrollLeft = values.scrollLeft, clientWidth = values.clientWidth, scrollWidth = values.scrollWidth;
                    var trackHorizontalWidth = (0, $69ff16989ae8a20b$var$_getInnerWidth2["default"])(this.trackHorizontal);
                    var thumbHorizontalWidth = this.getThumbHorizontalWidth();
                    var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
                    var thumbHorizontalStyle = {
                        width: thumbHorizontalWidth,
                        transform: 'translateX(' + thumbHorizontalX + 'px)'
                    };
                    var scrollTop = values.scrollTop, clientHeight = values.clientHeight, scrollHeight = values.scrollHeight;
                    var trackVerticalHeight = (0, $69ff16989ae8a20b$var$_getInnerHeight2["default"])(this.trackVertical);
                    var thumbVerticalHeight = this.getThumbVerticalHeight();
                    var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
                    var thumbVerticalStyle = {
                        height: thumbVerticalHeight,
                        transform: 'translateY(' + thumbVerticalY + 'px)'
                    };
                    if (hideTracksWhenNotNeeded) {
                        var trackHorizontalStyle = {
                            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
                        };
                        var trackVerticalStyle = {
                            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
                        };
                        (0, $69ff16989ae8a20b$var$_domCss2["default"])(this.trackHorizontal, trackHorizontalStyle);
                        (0, $69ff16989ae8a20b$var$_domCss2["default"])(this.trackVertical, trackVerticalStyle);
                    }
                    (0, $69ff16989ae8a20b$var$_domCss2["default"])(this.thumbHorizontal, thumbHorizontalStyle);
                    (0, $69ff16989ae8a20b$var$_domCss2["default"])(this.thumbVertical, thumbVerticalStyle);
                }
                if (onUpdate) onUpdate(values);
                if (typeof callback !== 'function') return;
                callback(values);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this7 = this;
                var scrollbarWidth = (0, $69ff16989ae8a20b$var$_getScrollbarWidth2["default"])();
                /* eslint-disable no-unused-vars */ var _props5 = this.props, onScroll = _props5.onScroll, onScrollFrame = _props5.onScrollFrame, onScrollStart = _props5.onScrollStart, onScrollStop = _props5.onScrollStop, onUpdate = _props5.onUpdate, renderView = _props5.renderView, renderTrackHorizontal = _props5.renderTrackHorizontal, renderTrackVertical = _props5.renderTrackVertical, renderThumbHorizontal = _props5.renderThumbHorizontal, renderThumbVertical = _props5.renderThumbVertical, tagName = _props5.tagName, hideTracksWhenNotNeeded = _props5.hideTracksWhenNotNeeded, autoHide = _props5.autoHide, autoHideTimeout = _props5.autoHideTimeout, autoHideDuration = _props5.autoHideDuration, thumbSize = _props5.thumbSize, thumbMinSize = _props5.thumbMinSize, universal = _props5.universal, autoHeight = _props5.autoHeight, autoHeightMin = _props5.autoHeightMin, autoHeightMax = _props5.autoHeightMax, style = _props5.style, children = _props5.children, props = $69ff16989ae8a20b$var$_objectWithoutProperties(_props5, [
                    'onScroll',
                    'onScrollFrame',
                    'onScrollStart',
                    'onScrollStop',
                    'onUpdate',
                    'renderView',
                    'renderTrackHorizontal',
                    'renderTrackVertical',
                    'renderThumbHorizontal',
                    'renderThumbVertical',
                    'tagName',
                    'hideTracksWhenNotNeeded',
                    'autoHide',
                    'autoHideTimeout',
                    'autoHideDuration',
                    'thumbSize',
                    'thumbMinSize',
                    'universal',
                    'autoHeight',
                    'autoHeightMin',
                    'autoHeightMax',
                    'style',
                    'children'
                ]);
                /* eslint-enable no-unused-vars */ var didMountUniversal = this.state.didMountUniversal;
                var containerStyle = $69ff16989ae8a20b$var$_extends({}, $43ff43b77ad19ce1$exports.containerStyleDefault, autoHeight && $69ff16989ae8a20b$var$_extends({}, $43ff43b77ad19ce1$exports.containerStyleAutoHeight, {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }), style);
                var viewStyle = $69ff16989ae8a20b$var$_extends({}, $43ff43b77ad19ce1$exports.viewStyleDefault, {
                    // Hide scrollbars by setting a negative margin
                    marginRight: scrollbarWidth ? -scrollbarWidth : 0,
                    marginBottom: scrollbarWidth ? -scrollbarWidth : 0
                }, autoHeight && $69ff16989ae8a20b$var$_extends({}, $43ff43b77ad19ce1$exports.viewStyleAutoHeight, {
                    // Add scrollbarWidth to autoHeight in order to compensate negative margins
                    minHeight: (0, $69ff16989ae8a20b$var$_isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
                    maxHeight: (0, $69ff16989ae8a20b$var$_isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
                }), autoHeight && universal && !didMountUniversal && {
                    minHeight: autoHeightMin,
                    maxHeight: autoHeightMax
                }, universal && !didMountUniversal && $43ff43b77ad19ce1$exports.viewStyleUniversalInitial);
                var trackAutoHeightStyle = {
                    transition: 'opacity ' + autoHideDuration + 'ms',
                    opacity: 0
                };
                var trackHorizontalStyle = $69ff16989ae8a20b$var$_extends({}, $43ff43b77ad19ce1$exports.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                var trackVerticalStyle = $69ff16989ae8a20b$var$_extends({}, $43ff43b77ad19ce1$exports.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
                    display: 'none'
                });
                return (0, $kYL7Z.createElement)(tagName, $69ff16989ae8a20b$var$_extends({}, props, {
                    style: containerStyle,
                    ref: function ref(_ref3) {
                        _this7.container = _ref3;
                    }
                }), [
                    (0, $kYL7Z.cloneElement)(renderView({
                        style: viewStyle
                    }), {
                        key: 'view',
                        ref: function ref(_ref4) {
                            _this7.view = _ref4;
                        }
                    }, children),
                    (0, $kYL7Z.cloneElement)(renderTrackHorizontal({
                        style: trackHorizontalStyle
                    }), {
                        key: 'trackHorizontal',
                        ref: function ref(_ref5) {
                            _this7.trackHorizontal = _ref5;
                        }
                    }, (0, $kYL7Z.cloneElement)(renderThumbHorizontal({
                        style: $43ff43b77ad19ce1$exports.thumbHorizontalStyleDefault
                    }), {
                        ref: function ref(_ref6) {
                            _this7.thumbHorizontal = _ref6;
                        }
                    })),
                    (0, $kYL7Z.cloneElement)(renderTrackVertical({
                        style: trackVerticalStyle
                    }), {
                        key: 'trackVertical',
                        ref: function ref(_ref7) {
                            _this7.trackVertical = _ref7;
                        }
                    }, (0, $kYL7Z.cloneElement)(renderThumbVertical({
                        style: $43ff43b77ad19ce1$exports.thumbVerticalStyleDefault
                    }), {
                        ref: function ref(_ref8) {
                            _this7.thumbVertical = _ref8;
                        }
                    }))
                ]);
            }
        }
    ]);
    return Scrollbars;
}($kYL7Z.Component);
$69ff16989ae8a20b$exports["default"] = $69ff16989ae8a20b$var$Scrollbars;
$69ff16989ae8a20b$var$Scrollbars.propTypes = {
    onScroll: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    onScrollFrame: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    onScrollStart: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    onScrollStop: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    onUpdate: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    renderView: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    renderTrackHorizontal: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    renderTrackVertical: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    renderThumbHorizontal: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    renderThumbVertical: $69ff16989ae8a20b$var$_propTypes2["default"].func,
    tagName: $69ff16989ae8a20b$var$_propTypes2["default"].string,
    thumbSize: $69ff16989ae8a20b$var$_propTypes2["default"].number,
    thumbMinSize: $69ff16989ae8a20b$var$_propTypes2["default"].number,
    hideTracksWhenNotNeeded: $69ff16989ae8a20b$var$_propTypes2["default"].bool,
    autoHide: $69ff16989ae8a20b$var$_propTypes2["default"].bool,
    autoHideTimeout: $69ff16989ae8a20b$var$_propTypes2["default"].number,
    autoHideDuration: $69ff16989ae8a20b$var$_propTypes2["default"].number,
    autoHeight: $69ff16989ae8a20b$var$_propTypes2["default"].bool,
    autoHeightMin: $69ff16989ae8a20b$var$_propTypes2["default"].oneOfType([
        $69ff16989ae8a20b$var$_propTypes2["default"].number,
        $69ff16989ae8a20b$var$_propTypes2["default"].string
    ]),
    autoHeightMax: $69ff16989ae8a20b$var$_propTypes2["default"].oneOfType([
        $69ff16989ae8a20b$var$_propTypes2["default"].number,
        $69ff16989ae8a20b$var$_propTypes2["default"].string
    ]),
    universal: $69ff16989ae8a20b$var$_propTypes2["default"].bool,
    style: $69ff16989ae8a20b$var$_propTypes2["default"].object,
    children: $69ff16989ae8a20b$var$_propTypes2["default"].node
};
$69ff16989ae8a20b$var$Scrollbars.defaultProps = {
    renderView: $9ad75478585d779c$exports.renderViewDefault,
    renderTrackHorizontal: $9ad75478585d779c$exports.renderTrackHorizontalDefault,
    renderTrackVertical: $9ad75478585d779c$exports.renderTrackVerticalDefault,
    renderThumbHorizontal: $9ad75478585d779c$exports.renderThumbHorizontalDefault,
    renderThumbVertical: $9ad75478585d779c$exports.renderThumbVerticalDefault,
    tagName: 'div',
    thumbMinSize: 30,
    hideTracksWhenNotNeeded: false,
    autoHide: false,
    autoHideTimeout: 1000,
    autoHideDuration: 200,
    autoHeight: false,
    autoHeightMin: 0,
    autoHeightMax: 200,
    universal: false
};


var $7f3412929cea4d45$var$_Scrollbars2 = $7f3412929cea4d45$var$_interopRequireDefault($69ff16989ae8a20b$exports);
function $7f3412929cea4d45$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
$7f3412929cea4d45$exports["default"] = $7f3412929cea4d45$var$_Scrollbars2["default"];
$7f3412929cea4d45$exports.Scrollbars = $7f3412929cea4d45$var$_Scrollbars2["default"];


var $cd397b46bbd25e75$exports = {};
$cd397b46bbd25e75$exports = JSON.parse("{\"name\":\"aura-statelemscreator\",\"version\":\"2.0.1\",\"private\":true,\"dependencies\":{\"@auravisionlabs/aura-pkg-auth-service\":\"1.5.8\",\"@auravisionlabs/aura-pkg-ui-formatter\":\"1.4.1\",\"@auravisionlabs/aura-react\":\"^0.1.5\",\"@auth0/auth0-spa-js\":\"^2.14.0\",\"@blueprintjs/core\":\"^6.7.0\",\"@blueprintjs/datetime\":\"^6.0.14\",\"@blueprintjs/select\":\"^6.0.14\",\"@dnd-kit/core\":\"^6.3.1\",\"@dnd-kit/modifiers\":\"^9.0.0\",\"@dnd-kit/sortable\":\"^10.0.0\",\"@dnd-kit/utilities\":\"^3.2.2\",\"@sentry/react\":\"^10.38.0\",\"@vis.gl/react-google-maps\":\"^1.9.0\",\"@wojtekmaj/react-timerange-picker\":\"^6.0.0\",\"ajv\":\"^8.18.0\",\"ajv-errors\":\"^3.0.0\",\"ajv-formats\":\"^3.0.1\",\"awaity\":\"^1.0.0\",\"country-codes-list\":\"^2.0.0\",\"currency-codes\":\"^2.2.0\",\"dexie\":\"^4.0.11\",\"hls.js\":\"^1.6.15\",\"immutable\":\"^5.0.0-beta.5\",\"lodash\":\"^4.17.15\",\"moment\":\"^2.27.0\",\"moment-timezone\":\"^0.5.47\",\"parcel\":\"^2.16.4\",\"react\":\"^19.1.0\",\"react-custom-scrollbars-2\":\"^4.4.0\",\"react-data-grid\":\"^7.0.0-beta.57\",\"react-dom\":\"^19.1.0\",\"react-router\":\"^7.13.0\",\"styled-components\":\"^6.1.0\",\"uuid\":\"^3.4.0\"},\"scripts\":{\"start\":\"parcel src/index.html --port 3300\",\"build\":\"parcel build src/index.html --dist-dir build --no-cache\",\"prebuild\":\"rm -rf dist\",\"test\":\"jest\",\"test:watch\":\"jest --watch\"},\"eslintConfig\":{\"extends\":\"react-app\"},\"alias\":{\"react\":\"./node_modules/react\",\"@blueprintjs/core\":\"./node_modules/@blueprintjs/core\"},\"browserslist\":[\"last 5 chrome versions\"],\"devDependencies\":{\"@babel/core\":\"^7.24.4\",\"@babel/preset-env\":\"^7.29.0\",\"@babel/preset-react\":\"^7.28.5\",\"@testing-library/dom\":\"^10.4.2\",\"@testing-library/jest-dom\":\"^6.9.1\",\"@testing-library/react\":\"^16.3.2\",\"babel-jest\":\"^30.2.0\",\"buffer\":\"^6.0.3\",\"crypto-browserify\":\"^3.12.0\",\"events\":\"^3.3.0\",\"https-browserify\":\"^1.0.0\",\"jest\":\"^30.2.0\",\"jest-environment-jsdom\":\"^30.2.0\",\"process\":\"^0.11.10\",\"stream-browserify\":\"^3.0.0\",\"stream-http\":\"^3.2.0\",\"string_decoder\":\"^1.3.0\",\"url\":\"^0.11.4\",\"util\":\"^0.12.5\",\"vm-browserify\":\"^1.1.2\"}}");




parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");


var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $7879b1e0779e0db7$export$98ac0f496a0846de = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "caret-right",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M280 200C280 206.2 277 211.4 272.6 215.2L272.8 215.4L152.8 315.4L152.6 315.2C149.2 318 144.8 320 140 320C129 320 120 311 120 300V100C120 89 129 80 140 80C144.8 80 149.2 82 152.6 84.8L152.8 84.6L272.8 184.6L272.6 184.8C277 188.6 280 193.8 280 200z" : "M220 160C220 163 218.6 165.6 216.6 167.4L216.6 167.4L136.6 237.4L136.6 237.4C134.8 239 132.6 240 130 240C124.4 240 120 235.6 120 230V90C120 84.4 124.4 80 130 80C132.6 80 134.8 81 136.6 82.6C136.6 82.6 136.6 82.6 136.6 82.6L216.6 152.6L216.6 152.6C218.6 154.4 220 157 220 160z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$7879b1e0779e0db7$export$98ac0f496a0846de.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$7879b1e0779e0db7$export$98ac0f496a0846de.displayName = `Blueprint6.Icon.CaretRight`;
var $7879b1e0779e0db7$export$2e2bcd8739ae039 = $7879b1e0779e0db7$export$98ac0f496a0846de;



var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $154f92b720f0daf8$export$4f10daf60b914288 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "small-tick",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M300 300C294.4000000000001 300 289.4000000000001 297.8 285.8 294.2L160 168.2L114.2 214.2C110.6 217.8 105.6 220 100 220C89 220 80 211 80 200C80 194.4 82.2 189.4 85.8 185.8L145.8 125.8C149.4 122.2 154.4 120 160 120S170.6 122.2 174.2 125.8L314.2000000000001 265.8C317.8 269.4 320 274.4 320 280C320 291 311 300 300 300z" : "M240 220C234.4 220 229.4 217.8 225.8 214.2L140 128.2L94.2 174.2C90.6 177.8 85.6 180 80 180C69 180 60 171 60 160C60 154.4 62.2 149.4 65.8 145.8L125.8 85.8C129.4 82.2 134.4 80 140 80S150.6 82.2 154.2 85.8L254.2 185.8C257.8 189.4 260 194.4 260 200C260 211 251 220 240 220z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$154f92b720f0daf8$export$4f10daf60b914288.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$154f92b720f0daf8$export$4f10daf60b914288.displayName = `Blueprint6.Icon.SmallTick`;
var $154f92b720f0daf8$export$2e2bcd8739ae039 = $154f92b720f0daf8$export$4f10daf60b914288;









var $kYL7Z = parcelRequire("kYL7Z");

var $kYL7Z = parcelRequire("kYL7Z");
var $4f95ec2fc0204d79$export$3dbd3405086fec7b = $kYL7Z.createContext();
var $4f95ec2fc0204d79$export$cbabb21c2529b130 = $kYL7Z.createContext();
function $4f95ec2fc0204d79$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $kYL7Z.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $kYL7Z.useRef(false);
    $kYL7Z.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $kYL7Z.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $kYL7Z.createElement($4f95ec2fc0204d79$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $kYL7Z.createElement($4f95ec2fc0204d79$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}


var $kYL7Z = parcelRequire("kYL7Z");


var $kYL7Z = parcelRequire("kYL7Z");
var $1ae8714d1bf90594$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $1ae8714d1bf90594$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $1ae8714d1bf90594$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $1ae8714d1bf90594$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $1ae8714d1bf90594$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $1ae8714d1bf90594$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $kYL7Z.useLayoutEffect : $kYL7Z.useEffect;



var $kYL7Z = parcelRequire("kYL7Z");

var $cRanb = parcelRequire("cRanb");
function $d1de2f9a4417b0ef$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $c7b85e1213901cd1$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $c7b85e1213901cd1$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $c7b85e1213901cd1$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $4b60c4571c4ba25a$export$8960430cfd85939f = Math.max;
var $4b60c4571c4ba25a$export$96ec731ed4dcb222 = Math.min;
var $4b60c4571c4ba25a$export$2077e0241d6afd3c = Math.round;



function $c089b41bea9fb355$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $797cda8a926c609f$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $c089b41bea9fb355$export$2e2bcd8739ae039)());
}


function $f7960d6350cb8776$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4b60c4571c4ba25a$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4b60c4571c4ba25a$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $c7b85e1213901cd1$export$45a5e7f76e0caa8d)(element) ? (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $797cda8a926c609f$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $b1d0adcd9f6fb472$export$2e2bcd8739ae039(node) {
    var win = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $02ccd6342692fb4f$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $5d98961894493176$export$2e2bcd8739ae039(node) {
    if (node === (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(node) || !(0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(node)) return (0, $b1d0adcd9f6fb472$export$2e2bcd8739ae039)(node);
    else return (0, $02ccd6342692fb4f$export$2e2bcd8739ae039)(node);
}


function $c375d5958a2eefbf$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $cbb8c2e57503b5d4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $c7b85e1213901cd1$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $a65d7e4cc16cf82f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $f7960d6350cb8776$export$2e2bcd8739ae039)((0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(element)).left + (0, $b1d0adcd9f6fb472$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $f3d7afa89abb14a4$export$2e2bcd8739ae039(element) {
    return (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $cde1ab4ae625e734$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $1e4181c84c40afbf$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4b60c4571c4ba25a$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4b60c4571c4ba25a$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $1e4181c84c40afbf$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(offsetParent) && $1e4181c84c40afbf$var$isElementScaled(offsetParent);
    var documentElement = (0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $f7960d6350cb8776$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $cde1ab4ae625e734$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $5d98961894493176$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $f7960d6350cb8776$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $a65d7e4cc16cf82f$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $b5dfdbffe4ebdc80$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $f7960d6350cb8776$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $2ca4e4edf417097d$export$2e2bcd8739ae039(element) {
    if ((0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $c7b85e1213901cd1$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $301eeb0581aae054$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(node) && (0, $cde1ab4ae625e734$export$2e2bcd8739ae039)(node)) return node;
    return $301eeb0581aae054$export$2e2bcd8739ae039((0, $2ca4e4edf417097d$export$2e2bcd8739ae039)(node));
}





function $2be326e2ba6ca617$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $301eeb0581aae054$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $cde1ab4ae625e734$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2be326e2ba6ca617$export$2e2bcd8739ae039((0, $2ca4e4edf417097d$export$2e2bcd8739ae039)(target)));
}







function $3307ddc3423ff6ca$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(element)) >= 0;
}




function $a4d661e74a73949f$var$getTrueOffsetParent(element) {
    if (!(0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $a4d661e74a73949f$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $c089b41bea9fb355$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $c089b41bea9fb355$export$2e2bcd8739ae039)());
    if (isIE && (0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $2ca4e4edf417097d$export$2e2bcd8739ae039)(element);
    if ((0, $c7b85e1213901cd1$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $a4d661e74a73949f$export$2e2bcd8739ae039(element) {
    var window = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(element);
    var offsetParent = $a4d661e74a73949f$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $3307ddc3423ff6ca$export$2e2bcd8739ae039)(offsetParent) && (0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $a4d661e74a73949f$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $a4d661e74a73949f$var$getContainingBlock(element) || window;
}


var $96141c701351b0a1$export$1e95b668f3b82d = 'top';
var $96141c701351b0a1$export$40e543e69a8b3fbb = 'bottom';
var $96141c701351b0a1$export$79ffe56a765070d2 = 'right';
var $96141c701351b0a1$export$eabcd2c8791e7bf4 = 'left';
var $96141c701351b0a1$export$dfb5619354ba860 = 'auto';
var $96141c701351b0a1$export$aec2ce47c367b8c3 = [
    $96141c701351b0a1$export$1e95b668f3b82d,
    $96141c701351b0a1$export$40e543e69a8b3fbb,
    $96141c701351b0a1$export$79ffe56a765070d2,
    $96141c701351b0a1$export$eabcd2c8791e7bf4
];
var $96141c701351b0a1$export$b3571188c770cc5a = 'start';
var $96141c701351b0a1$export$bd5df0f255a350f8 = 'end';
var $96141c701351b0a1$export$390fd549c5303b4d = 'clippingParents';
var $96141c701351b0a1$export$d7b7311ec04a3e8f = 'viewport';
var $96141c701351b0a1$export$ae5ab1c730825774 = 'popper';
var $96141c701351b0a1$export$ca50aac9f3ba507f = 'reference';
var $96141c701351b0a1$export$368f9a87e87fa4e1 = /*#__PURE__*/ $96141c701351b0a1$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $96141c701351b0a1$export$b3571188c770cc5a,
        placement + "-" + $96141c701351b0a1$export$bd5df0f255a350f8
    ]);
}, []);
var $96141c701351b0a1$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($96141c701351b0a1$export$aec2ce47c367b8c3, [
    $96141c701351b0a1$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $96141c701351b0a1$export$b3571188c770cc5a,
        placement + "-" + $96141c701351b0a1$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $96141c701351b0a1$export$421679a7c3d56e = 'beforeRead';
var $96141c701351b0a1$export$aafa59e2e03f2942 = 'read';
var $96141c701351b0a1$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $96141c701351b0a1$export$c65e99957a05207c = 'beforeMain';
var $96141c701351b0a1$export$f22da7240b7add18 = 'main';
var $96141c701351b0a1$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $96141c701351b0a1$export$8d4d2d70e7d46032 = 'beforeWrite';
var $96141c701351b0a1$export$68d8715fc104d294 = 'write';
var $96141c701351b0a1$export$70a6e5159acce2e6 = 'afterWrite';
var $96141c701351b0a1$export$d087d3878fdf71d5 = [
    $96141c701351b0a1$export$421679a7c3d56e,
    $96141c701351b0a1$export$aafa59e2e03f2942,
    $96141c701351b0a1$export$6964f6c886723980,
    $96141c701351b0a1$export$c65e99957a05207c,
    $96141c701351b0a1$export$f22da7240b7add18,
    $96141c701351b0a1$export$bab79516f2d662fe,
    $96141c701351b0a1$export$8d4d2d70e7d46032,
    $96141c701351b0a1$export$68d8715fc104d294,
    $96141c701351b0a1$export$70a6e5159acce2e6
];


function $33e47531d8fe4772$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $33e47531d8fe4772$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $33e47531d8fe4772$var$order(modifiers); // order based on phase
    return (0, $96141c701351b0a1$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $0488dafd274334bb$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $4f6ede4c31ca7316$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $2a64651498df3370$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $2a64651498df3370$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $2a64651498df3370$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $2a64651498df3370$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $2a64651498df3370$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $c7b85e1213901cd1$export$45a5e7f76e0caa8d)(reference) ? (0, $2be326e2ba6ca617$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $2be326e2ba6ca617$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $2be326e2ba6ca617$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $33e47531d8fe4772$export$2e2bcd8739ae039)((0, $4f6ede4c31ca7316$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$2a64651498df3370$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $1e4181c84c40afbf$export$2e2bcd8739ae039)(reference, (0, $a4d661e74a73949f$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $b5dfdbffe4ebdc80$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $0488dafd274334bb$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$2a64651498df3370$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $2a64651498df3370$export$8f7491d57c8f97a9 = /*#__PURE__*/ $2a64651498df3370$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $9b2ac561d0691c5f$var$passive = {
    passive: true
};
function $9b2ac561d0691c5f$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $9b2ac561d0691c5f$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $9b2ac561d0691c5f$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $9b2ac561d0691c5f$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $9b2ac561d0691c5f$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $9b2ac561d0691c5f$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $9b2ac561d0691c5f$var$effect,
    data: {}
};



function $82f3b9661652fc50$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $e19af7e228b8c42c$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $11f0bc5528e5f95c$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $41dc8d65083e34e1$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $82f3b9661652fc50$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $e19af7e228b8c42c$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $96141c701351b0a1$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $96141c701351b0a1$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $96141c701351b0a1$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $96141c701351b0a1$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $11f0bc5528e5f95c$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $96141c701351b0a1$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $96141c701351b0a1$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $b914e45af6296b2c$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $41dc8d65083e34e1$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $b914e45af6296b2c$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $b914e45af6296b2c$var$popperOffsets,
    data: {}
};










var $b5267b4fb9e6c5b0$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $b5267b4fb9e6c5b0$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4b60c4571c4ba25a$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $4b60c4571c4ba25a$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $b5267b4fb9e6c5b0$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $96141c701351b0a1$export$eabcd2c8791e7bf4);
    var sideY = (0, $96141c701351b0a1$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $a4d661e74a73949f$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(popper);
            if ((0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $96141c701351b0a1$export$1e95b668f3b82d) || (placement === (0, $96141c701351b0a1$export$eabcd2c8791e7bf4) || placement === (0, $96141c701351b0a1$export$79ffe56a765070d2)) && variation === (0, $96141c701351b0a1$export$bd5df0f255a350f8)) {
            sideY = (0, $96141c701351b0a1$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $96141c701351b0a1$export$eabcd2c8791e7bf4) || (placement === (0, $96141c701351b0a1$export$1e95b668f3b82d) || placement === (0, $96141c701351b0a1$export$40e543e69a8b3fbb)) && variation === (0, $96141c701351b0a1$export$bd5df0f255a350f8)) {
            sideX = (0, $96141c701351b0a1$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $b5267b4fb9e6c5b0$var$unsetSides);
    var _ref4 = roundOffsets === true ? $b5267b4fb9e6c5b0$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $b5267b4fb9e6c5b0$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $82f3b9661652fc50$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $e19af7e228b8c42c$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $b5267b4fb9e6c5b0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $b5267b4fb9e6c5b0$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $b5267b4fb9e6c5b0$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $b5267b4fb9e6c5b0$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $d1b8959de199a5ac$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(element) || !(0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $d1b8959de199a5ac$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(element) || !(0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $d1b8959de199a5ac$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $d1b8959de199a5ac$var$applyStyles,
    effect: $d1b8959de199a5ac$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $1669b32eb081c51b$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $82f3b9661652fc50$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $96141c701351b0a1$export$eabcd2c8791e7bf4),
        (0, $96141c701351b0a1$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $96141c701351b0a1$export$eabcd2c8791e7bf4),
        (0, $96141c701351b0a1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $1669b32eb081c51b$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $96141c701351b0a1$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $1669b32eb081c51b$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $1669b32eb081c51b$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $1669b32eb081c51b$var$offset
};


var $7f78d2ea84847cb6$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $7f78d2ea84847cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $7f78d2ea84847cb6$var$hash[matched];
    });
}



var $f80ae95309f3f0ed$var$hash = {
    start: 'end',
    end: 'start'
};
function $f80ae95309f3f0ed$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $f80ae95309f3f0ed$var$hash[matched];
    });
}







function $027ac180ea964328$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $d1de2f9a4417b0ef$export$2e2bcd8739ae039)(element);
    var html = (0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $797cda8a926c609f$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $a65d7e4cc16cf82f$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $438f85db3e901ddd$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $b1d0adcd9f6fb472$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4b60c4571c4ba25a$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4b60c4571c4ba25a$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $a65d7e4cc16cf82f$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $4b60c4571c4ba25a$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $23d332cd89351857$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $c7b85e1213901cd1$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $fc23c4ed54b3c627$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $fa9f10b88bf1e7db$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $f7960d6350cb8776$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $fa9f10b88bf1e7db$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $96141c701351b0a1$export$d7b7311ec04a3e8f) ? (0, $fc23c4ed54b3c627$export$2e2bcd8739ae039)((0, $027ac180ea964328$export$2e2bcd8739ae039)(element, strategy)) : (0, $c7b85e1213901cd1$export$45a5e7f76e0caa8d)(clippingParent) ? $fa9f10b88bf1e7db$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $fc23c4ed54b3c627$export$2e2bcd8739ae039)((0, $438f85db3e901ddd$export$2e2bcd8739ae039)((0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $fa9f10b88bf1e7db$var$getClippingParents(element) {
    var clippingParents = (0, $2be326e2ba6ca617$export$2e2bcd8739ae039)((0, $2ca4e4edf417097d$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $f3d7afa89abb14a4$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $c7b85e1213901cd1$export$1b3bfaa9684536aa)(element) ? (0, $a4d661e74a73949f$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $c7b85e1213901cd1$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $c7b85e1213901cd1$export$45a5e7f76e0caa8d)(clippingParent) && (0, $23d332cd89351857$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $c375d5958a2eefbf$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $fa9f10b88bf1e7db$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $fa9f10b88bf1e7db$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $fa9f10b88bf1e7db$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4b60c4571c4ba25a$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $4b60c4571c4ba25a$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $4b60c4571c4ba25a$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4b60c4571c4ba25a$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $fa9f10b88bf1e7db$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $2b0c78fbf2fe9b3b$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2eeaffc6da69830f$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $2b0c78fbf2fe9b3b$export$2e2bcd8739ae039)(), paddingObject);
}


function $acb113186b8decec$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $b12e487d70f5d23f$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $96141c701351b0a1$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $96141c701351b0a1$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $96141c701351b0a1$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2eeaffc6da69830f$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $acb113186b8decec$export$2e2bcd8739ae039)(padding, (0, $96141c701351b0a1$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $96141c701351b0a1$export$ae5ab1c730825774) ? (0, $96141c701351b0a1$export$ca50aac9f3ba507f) : (0, $96141c701351b0a1$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $fa9f10b88bf1e7db$export$2e2bcd8739ae039)((0, $c7b85e1213901cd1$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $cbb8c2e57503b5d4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $f7960d6350cb8776$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $41dc8d65083e34e1$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $fc23c4ed54b3c627$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $96141c701351b0a1$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $96141c701351b0a1$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $96141c701351b0a1$export$79ffe56a765070d2),
                (0, $96141c701351b0a1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $96141c701351b0a1$export$1e95b668f3b82d),
                (0, $96141c701351b0a1$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $fb827c6c74524675$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $96141c701351b0a1$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $e19af7e228b8c42c$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $96141c701351b0a1$export$368f9a87e87fa4e1) : (0, $96141c701351b0a1$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $e19af7e228b8c42c$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $96141c701351b0a1$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $b12e487d70f5d23f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $82f3b9661652fc50$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $26d80f7355afb191$var$getExpandedFallbackPlacements(placement) {
    if ((0, $82f3b9661652fc50$export$2e2bcd8739ae039)(placement) === (0, $96141c701351b0a1$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $7f78d2ea84847cb6$export$2e2bcd8739ae039)(placement);
    return [
        (0, $f80ae95309f3f0ed$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $f80ae95309f3f0ed$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $26d80f7355afb191$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $82f3b9661652fc50$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $7f78d2ea84847cb6$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $26d80f7355afb191$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $82f3b9661652fc50$export$2e2bcd8739ae039)(placement) === (0, $96141c701351b0a1$export$dfb5619354ba860) ? (0, $fb827c6c74524675$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $82f3b9661652fc50$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $e19af7e228b8c42c$export$2e2bcd8739ae039)(placement) === (0, $96141c701351b0a1$export$b3571188c770cc5a);
        var isVertical = [
            (0, $96141c701351b0a1$export$1e95b668f3b82d),
            (0, $96141c701351b0a1$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $b12e487d70f5d23f$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $96141c701351b0a1$export$79ffe56a765070d2) : (0, $96141c701351b0a1$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $96141c701351b0a1$export$40e543e69a8b3fbb) : (0, $96141c701351b0a1$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $7f78d2ea84847cb6$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $7f78d2ea84847cb6$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $26d80f7355afb191$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $26d80f7355afb191$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $fab2597319d0b9d4$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $d859f1625bdabb28$export$f28d906d67a997f3(min, value, max) {
    return (0, $4b60c4571c4ba25a$export$8960430cfd85939f)(min, (0, $4b60c4571c4ba25a$export$96ec731ed4dcb222)(value, max));
}
function $d859f1625bdabb28$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $d859f1625bdabb28$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $254fde1e8972bca7$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $b12e487d70f5d23f$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $82f3b9661652fc50$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $e19af7e228b8c42c$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $11f0bc5528e5f95c$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $fab2597319d0b9d4$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $96141c701351b0a1$export$1e95b668f3b82d) : (0, $96141c701351b0a1$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $96141c701351b0a1$export$40e543e69a8b3fbb) : (0, $96141c701351b0a1$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $96141c701351b0a1$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $96141c701351b0a1$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $b5dfdbffe4ebdc80$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $2b0c78fbf2fe9b3b$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $d859f1625bdabb28$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $a4d661e74a73949f$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $d859f1625bdabb28$export$f28d906d67a997f3)(tether ? (0, $4b60c4571c4ba25a$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $4b60c4571c4ba25a$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $96141c701351b0a1$export$1e95b668f3b82d) : (0, $96141c701351b0a1$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $96141c701351b0a1$export$40e543e69a8b3fbb) : (0, $96141c701351b0a1$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $96141c701351b0a1$export$1e95b668f3b82d),
            (0, $96141c701351b0a1$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $d859f1625bdabb28$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $d859f1625bdabb28$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $254fde1e8972bca7$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $254fde1e8972bca7$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $3a4a7841a13554f1$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2eeaffc6da69830f$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $acb113186b8decec$export$2e2bcd8739ae039)(padding, (0, $96141c701351b0a1$export$aec2ce47c367b8c3)));
};
function $3a4a7841a13554f1$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $82f3b9661652fc50$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $11f0bc5528e5f95c$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $96141c701351b0a1$export$eabcd2c8791e7bf4),
        (0, $96141c701351b0a1$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $3a4a7841a13554f1$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $b5dfdbffe4ebdc80$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $96141c701351b0a1$export$1e95b668f3b82d) : (0, $96141c701351b0a1$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $96141c701351b0a1$export$40e543e69a8b3fbb) : (0, $96141c701351b0a1$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $a4d661e74a73949f$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $d859f1625bdabb28$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $3a4a7841a13554f1$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $23d332cd89351857$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $3a4a7841a13554f1$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $3a4a7841a13554f1$var$arrow,
    effect: $3a4a7841a13554f1$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $c57599756e81470a$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $c57599756e81470a$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $96141c701351b0a1$export$1e95b668f3b82d),
        (0, $96141c701351b0a1$export$79ffe56a765070d2),
        (0, $96141c701351b0a1$export$40e543e69a8b3fbb),
        (0, $96141c701351b0a1$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $c57599756e81470a$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $b12e487d70f5d23f$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $b12e487d70f5d23f$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $c57599756e81470a$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $c57599756e81470a$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $c57599756e81470a$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $c57599756e81470a$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $c57599756e81470a$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $c57599756e81470a$var$hide
};




var $4aab8f070417bc2e$export$d34966752335dd47 = [
    (0, $9b2ac561d0691c5f$export$2e2bcd8739ae039),
    (0, $b914e45af6296b2c$export$2e2bcd8739ae039),
    (0, $b5267b4fb9e6c5b0$export$2e2bcd8739ae039),
    (0, $d1b8959de199a5ac$export$2e2bcd8739ae039),
    (0, $1669b32eb081c51b$export$2e2bcd8739ae039),
    (0, $26d80f7355afb191$export$2e2bcd8739ae039),
    (0, $254fde1e8972bca7$export$2e2bcd8739ae039),
    (0, $3a4a7841a13554f1$export$2e2bcd8739ae039),
    (0, $c57599756e81470a$export$2e2bcd8739ae039)
];
var $4aab8f070417bc2e$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $2a64651498df3370$export$ed5e13716264f202)({
    defaultModifiers: $4aab8f070417bc2e$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $4c59b452e1b93204$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $4c59b452e1b93204$var$hasElementType = typeof Element !== 'undefined';
var $4c59b452e1b93204$var$hasMap = typeof Map === 'function';
var $4c59b452e1b93204$var$hasSet = typeof Set === 'function';
var $4c59b452e1b93204$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $4c59b452e1b93204$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$4c59b452e1b93204$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($4c59b452e1b93204$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$4c59b452e1b93204$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($4c59b452e1b93204$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($4c59b452e1b93204$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($4c59b452e1b93204$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$4c59b452e1b93204$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$4c59b452e1b93204$exports = function isEqual(a, b) {
    try {
        return $4c59b452e1b93204$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $4a0b81621030a237$var$EMPTY_MODIFIERS = [];
var $4a0b81621030a237$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $kYL7Z.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $4a0b81621030a237$var$EMPTY_MODIFIERS
    };
    var _React$useState = $kYL7Z.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $kYL7Z.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $cRanb.flushSync(function() {
                    setState({
                        styles: (0, $1ae8714d1bf90594$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $1ae8714d1bf90594$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $kYL7Z.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($4c59b452e1b93204$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $kYL7Z.useRef();
    (0, $1ae8714d1bf90594$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $1ae8714d1bf90594$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $4aab8f070417bc2e$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $088df94f93f6879b$var$NOOP = function NOOP() {
    return void 0;
};
var $088df94f93f6879b$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $088df94f93f6879b$var$EMPTY_MODIFIERS = [];
function $088df94f93f6879b$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $088df94f93f6879b$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $kYL7Z.useContext((0, $4f95ec2fc0204d79$export$3dbd3405086fec7b));
    var _React$useState = $kYL7Z.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $kYL7Z.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $kYL7Z.useEffect(function() {
        (0, $1ae8714d1bf90594$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $kYL7Z.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $4a0b81621030a237$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $kYL7Z.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $088df94f93f6879b$var$NOOP,
            update: update || $088df94f93f6879b$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $1ae8714d1bf90594$export$f52c55943429c8b6)(children)(childrenProps);
}


var $kYL7Z = parcelRequire("kYL7Z");
var $a38764b27d7ac7f8$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $a38764b27d7ac7f8$var$__DEV__ = false;
var $a38764b27d7ac7f8$var$warning = function() {};
if ($a38764b27d7ac7f8$var$__DEV__) {
    var $a38764b27d7ac7f8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $a38764b27d7ac7f8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $a38764b27d7ac7f8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$a38764b27d7ac7f8$exports = $a38764b27d7ac7f8$var$warning;




function $d76c79860bf927b7$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $kYL7Z.useContext((0, $4f95ec2fc0204d79$export$cbabb21c2529b130));
    var refHandler = $kYL7Z.useCallback(function(node) {
        (0, $1ae8714d1bf90594$export$4bb192c7cacf928f)(innerRef, node);
        (0, $1ae8714d1bf90594$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $kYL7Z.useEffect(function() {
        return function() {
            return (0, $1ae8714d1bf90594$export$4bb192c7cacf928f)(innerRef, null);
        };
    }, []);
    $kYL7Z.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($a38764b27d7ac7f8$exports)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $1ae8714d1bf90594$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}


/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

class $ceff0151c81d8a08$export$844dfdc3b38c9679 extends (0, $kYL7Z.PureComponent) {
    // unsafe lifecycle method
    componentWillUpdate;
    componentWillReceiveProps;
    componentWillMount;
    // this should be static, not an instance method
    getDerivedStateFromProps;
    /** Component displayName should be `public static`. This property exists to prevent incorrect usage. */ displayName;
    // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
    timeoutIds = [];
    requestIds = [];
    constructor(props){
        super(props);
        if (!(0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) this.validateProps(this.props);
    }
    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        if (!(0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) this.validateProps(this.props);
    }
    componentWillUnmount() {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    }
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */ requestAnimationFrame(callback) {
        const handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return ()=>window.cancelAnimationFrame(handle);
    }
    /**
     * Set a timeout and remember its ID.
     * All pending timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */ setTimeout(callback, timeout) {
        const handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return ()=>window.clearTimeout(handle);
    }
    /**
     * Clear all known timeouts.
     */ clearTimeouts = ()=>{
        if (this.timeoutIds.length > 0) {
            for (const timeoutId of this.timeoutIds)window.clearTimeout(timeoutId);
            this.timeoutIds = [];
        }
    };
    /**
     * Clear all known animation frame requests.
     */ cancelAnimationFrames = ()=>{
        if (this.requestIds.length > 0) {
            for (const requestId of this.requestIds)window.cancelAnimationFrame(requestId);
            this.requestIds = [];
        }
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */ validateProps(_props) {
    // implement in subclass
    }
}






var $kYL7Z = parcelRequire("kYL7Z");
function $5e98e3bb7d6e1885$export$2e2bcd8739ae039() {
    return $5e98e3bb7d6e1885$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $5e98e3bb7d6e1885$export$2e2bcd8739ae039.apply(null, arguments);
}


function $d35c9002bc58893a$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $4df27d4f64ae9d51$export$2e2bcd8739ae039(t, e) {
    return $4df27d4f64ae9d51$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $4df27d4f64ae9d51$export$2e2bcd8739ae039(t, e);
}


function $9355aef5cf50b323$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $4df27d4f64ae9d51$export$2e2bcd8739ae039)(t, o);
}



/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $54569ea5e7905195$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $b205bb81558558ab$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $54569ea5e7905195$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $e353747d1fd7715f$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $e353747d1fd7715f$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $e353747d1fd7715f$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $e353747d1fd7715f$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");

var $cRanb = parcelRequire("cRanb");
var $cdaf183d0291fd07$export$2e2bcd8739ae039 = {
    disabled: false
};




var $kYL7Z = parcelRequire("kYL7Z");
var $81b16df68436b72c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext(null);


var $3947b2d6e87dd482$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $cdf05ace2d8b6790$export$bb38bb9a1161268 = 'unmounted';
var $cdf05ace2d8b6790$export$84cbff306f539230 = 'exited';
var $cdf05ace2d8b6790$export$df38205c966be359 = 'entering';
var $cdf05ace2d8b6790$export$78e9e6e3e014d60a = 'entered';
var $cdf05ace2d8b6790$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $cdf05ace2d8b6790$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $9355aef5cf50b323$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $cdf05ace2d8b6790$export$84cbff306f539230;
                _this.appearStatus = $cdf05ace2d8b6790$export$df38205c966be359;
            } else initialStatus = $cdf05ace2d8b6790$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $cdf05ace2d8b6790$export$bb38bb9a1161268;
        else initialStatus = $cdf05ace2d8b6790$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $cdf05ace2d8b6790$export$bb38bb9a1161268) return {
            status: $cdf05ace2d8b6790$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $cdf05ace2d8b6790$export$df38205c966be359 && status !== $cdf05ace2d8b6790$export$78e9e6e3e014d60a) nextStatus = $cdf05ace2d8b6790$export$df38205c966be359;
            } else if (status === $cdf05ace2d8b6790$export$df38205c966be359 || status === $cdf05ace2d8b6790$export$78e9e6e3e014d60a) nextStatus = $cdf05ace2d8b6790$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $cdf05ace2d8b6790$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($cRanb))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $3947b2d6e87dd482$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $cdf05ace2d8b6790$export$84cbff306f539230) this.setState({
            status: $cdf05ace2d8b6790$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($cRanb))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $cdaf183d0291fd07$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $cdf05ace2d8b6790$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $cdf05ace2d8b6790$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $cdf05ace2d8b6790$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($cRanb))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $cdaf183d0291fd07$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $cdf05ace2d8b6790$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $cdf05ace2d8b6790$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $cdf05ace2d8b6790$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($cRanb))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $cdf05ace2d8b6790$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $d35c9002bc58893a$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $81b16df68436b72c$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Component);
$cdf05ace2d8b6790$var$Transition.contextType = (0, $81b16df68436b72c$export$2e2bcd8739ae039);
$cdf05ace2d8b6790$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $cdf05ace2d8b6790$var$noop() {}
$cdf05ace2d8b6790$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $cdf05ace2d8b6790$var$noop,
    onEntering: $cdf05ace2d8b6790$var$noop,
    onEntered: $cdf05ace2d8b6790$var$noop,
    onExit: $cdf05ace2d8b6790$var$noop,
    onExiting: $cdf05ace2d8b6790$var$noop,
    onExited: $cdf05ace2d8b6790$var$noop
};
$cdf05ace2d8b6790$var$Transition.UNMOUNTED = $cdf05ace2d8b6790$export$bb38bb9a1161268;
$cdf05ace2d8b6790$var$Transition.EXITED = $cdf05ace2d8b6790$export$84cbff306f539230;
$cdf05ace2d8b6790$var$Transition.ENTERING = $cdf05ace2d8b6790$export$df38205c966be359;
$cdf05ace2d8b6790$var$Transition.ENTERED = $cdf05ace2d8b6790$export$78e9e6e3e014d60a;
$cdf05ace2d8b6790$var$Transition.EXITING = $cdf05ace2d8b6790$export$4aacc83d4d59139f;
var $cdf05ace2d8b6790$export$2e2bcd8739ae039 = $cdf05ace2d8b6790$var$Transition;




var $a55240fa3c35e720$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $b205bb81558558ab$export$2e2bcd8739ae039)(node, c);
    });
};
var $a55240fa3c35e720$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $e353747d1fd7715f$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $a55240fa3c35e720$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $9355aef5cf50b323$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $3947b2d6e87dd482$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $a55240fa3c35e720$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $a55240fa3c35e720$var$removeClass(node, baseClassName);
        if (activeClassName) $a55240fa3c35e720$var$removeClass(node, activeClassName);
        if (doneClassName) $a55240fa3c35e720$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $d35c9002bc58893a$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $cdf05ace2d8b6790$export$2e2bcd8739ae039), (0, $5e98e3bb7d6e1885$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Component);
$a55240fa3c35e720$var$CSSTransition.defaultProps = {
    classNames: ''
};
$a55240fa3c35e720$var$CSSTransition.propTypes = {};
var $a55240fa3c35e720$export$2e2bcd8739ae039 = $a55240fa3c35e720$var$CSSTransition;



function $a7d528e2b909fae0$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $kYL7Z = parcelRequire("kYL7Z");


var $kYL7Z = parcelRequire("kYL7Z");
function $5332c0fe8316e0d9$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $kYL7Z.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $kYL7Z.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $5332c0fe8316e0d9$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $5332c0fe8316e0d9$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $5332c0fe8316e0d9$export$fa71e2345c31d7a2(props, onExited) {
    return $5332c0fe8316e0d9$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $kYL7Z.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $5332c0fe8316e0d9$var$getProp(child, 'appear', props),
            enter: $5332c0fe8316e0d9$var$getProp(child, 'enter', props),
            exit: $5332c0fe8316e0d9$var$getProp(child, 'exit', props)
        });
    });
}
function $5332c0fe8316e0d9$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $5332c0fe8316e0d9$export$bbc8a025727ea824(nextProps.children);
    var children = $5332c0fe8316e0d9$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $kYL7Z.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $kYL7Z.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $kYL7Z.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $5332c0fe8316e0d9$var$getProp(child, 'exit', nextProps),
            enter: $5332c0fe8316e0d9$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $kYL7Z.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $kYL7Z.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $kYL7Z.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $5332c0fe8316e0d9$var$getProp(child, 'exit', nextProps),
            enter: $5332c0fe8316e0d9$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $a423602b7c98e212$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $a423602b7c98e212$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $a423602b7c98e212$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $9355aef5cf50b323$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $5332c0fe8316e0d9$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $5332c0fe8316e0d9$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $5332c0fe8316e0d9$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $5e98e3bb7d6e1885$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $d35c9002bc58893a$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $a423602b7c98e212$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $81b16df68436b72c$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $81b16df68436b72c$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Component);
$a423602b7c98e212$var$TransitionGroup.propTypes = {};
$a423602b7c98e212$var$TransitionGroup.defaultProps = $a423602b7c98e212$var$defaultProps;
var $a423602b7c98e212$export$2e2bcd8739ae039 = $a423602b7c98e212$var$TransitionGroup;







/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");





var $kYL7Z = parcelRequire("kYL7Z");
const $da52efb365364a8e$export$ffbb3c21604c2bde = (0, $kYL7Z.createContext)({
    hasProvider: false,
    stack: {
        current: []
    }
});
const $da52efb365364a8e$export$2e609a126d315e1b = ({ children: children })=>{
    const stack = (0, $kYL7Z.useRef)([]);
    const contextValue = (0, $kYL7Z.useMemo)(()=>({
            hasProvider: true,
            stack: stack
        }), [
        stack
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)($da52efb365364a8e$export$ffbb3c21604c2bde.Provider, {
        value: contextValue,
        children: children
    });
};


/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");
var $d0d78daa30293833$exports = {};
'use strict';

$d0d78daa30293833$exports = (parcelRequire("6t2bg"));



const $121325984289ba73$var$globalStack = [];
const $121325984289ba73$var$globalStackListeners = [];
const $121325984289ba73$export$c93586c81c6b24b8 = (fn)=>{
    fn($121325984289ba73$var$globalStack);
    $121325984289ba73$var$globalStackListeners.forEach((listener)=>listener());
};
const $121325984289ba73$var$legacyGlobalOverlayStackStore = {
    getSnapshot: ()=>$121325984289ba73$var$globalStack,
    subscribe: (listener)=>{
        $121325984289ba73$var$globalStackListeners.push(listener);
        return ()=>{
            const index = $121325984289ba73$var$globalStackListeners.indexOf(listener);
            $121325984289ba73$var$globalStackListeners.splice(index, 1);
        };
    }
};
function $121325984289ba73$export$501bbf48543ad65d() {
    const stack = (0, $d0d78daa30293833$exports.useSyncExternalStore)($121325984289ba73$var$legacyGlobalOverlayStackStore.subscribe, $121325984289ba73$var$legacyGlobalOverlayStackStore.getSnapshot, // server snapshot is the same as client snapshot
    $121325984289ba73$var$legacyGlobalOverlayStackStore.getSnapshot);
    const getLastOpened = (0, $kYL7Z.useCallback)(()=>stack[stack.length - 1], [
        stack
    ]);
    const getThisOverlayAndDescendants = (0, $kYL7Z.useCallback)((id)=>{
        const stackIndex = stack.findIndex((o)=>o.id === id);
        return stack.slice(stackIndex);
    }, [
        stack
    ]);
    const resetStack = (0, $kYL7Z.useCallback)(()=>{
        $121325984289ba73$export$c93586c81c6b24b8((s)=>s.splice(0, s.length));
    }, []);
    const openOverlay = (0, $kYL7Z.useCallback)((overlay)=>{
        $121325984289ba73$var$globalStack.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, $2cfd35af7ec11fdd$exports).OVERLAY_OPEN);
    }, []);
    const closeOverlay = (0, $kYL7Z.useCallback)((id)=>{
        const otherOverlaysWithBackdrop = stack.filter((o)=>o.props.usePortal && o.props.hasBackdrop && o.id !== id);
        const index = $121325984289ba73$var$globalStack.findIndex((o)=>o.id === id);
        if (index > -1) $121325984289ba73$var$globalStack.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, $2cfd35af7ec11fdd$exports).OVERLAY_OPEN);
    }, [
        stack
    ]);
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}


function $f03f4e3b2979f7ee$export$b9eca684780184d5() {
    // get the overlay stack from application-wide React context
    const { stack: stack, hasProvider: hasProvider } = (0, $kYL7Z.useContext)((0, $da52efb365364a8e$export$ffbb3c21604c2bde));
    const legacyOverlayStack = (0, $121325984289ba73$export$501bbf48543ad65d)();
    const getLastOpened = (0, $kYL7Z.useCallback)(()=>{
        return stack.current[stack.current.length - 1];
    }, [
        stack
    ]);
    const getThisOverlayAndDescendants = (0, $kYL7Z.useCallback)((id)=>{
        const index = stack.current.findIndex((o)=>o.id === id);
        if (index === -1) return [];
        return stack.current.slice(index);
    }, [
        stack
    ]);
    const resetStack = (0, $kYL7Z.useCallback)(()=>{
        stack.current = [];
    }, [
        stack
    ]);
    const openOverlay = (0, $kYL7Z.useCallback)((overlay)=>{
        stack.current.push(overlay);
        if (overlay.props.usePortal && overlay.props.hasBackdrop) // add a class to the body to prevent scrolling of content below the overlay
        document.body.classList.add((0, $2cfd35af7ec11fdd$exports).OVERLAY_OPEN);
    }, [
        stack
    ]);
    const closeOverlay = (0, $kYL7Z.useCallback)((id)=>{
        const otherOverlaysWithBackdrop = stack.current.filter((o)=>o.props.usePortal && o.props.hasBackdrop && o.id !== id);
        const index = stack.current.findIndex((o)=>o.id === id);
        if (index > -1) stack.current.splice(index, 1);
        if (otherOverlaysWithBackdrop.length === 0) // remove body class which prevents scrolling of content below overlay
        document.body.classList.remove((0, $2cfd35af7ec11fdd$exports).OVERLAY_OPEN);
    }, [
        stack
    ]);
    if (!hasProvider) {
        if ((0, $f141b3b4d406798c$export$ba99498080d0627b)("development")) console.error((0, $5bed6f2a5e88b283$export$ec9bf1f3f03eed46));
        return legacyOverlayStack;
    }
    return {
        closeOverlay: closeOverlay,
        getLastOpened: getLastOpened,
        getThisOverlayAndDescendants: getThisOverlayAndDescendants,
        openOverlay: openOverlay,
        resetStack: resetStack
    };
}


/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");
function $611231c730532d04$export$5cae361ad82dce8b(value) {
    // create a new reference
    const ref = (0, $kYL7Z.useRef)();
    // store current value in ref
    (0, $kYL7Z.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    // return previous value (happens before update in useEffect above)
    return ref.current;
}


/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 


function $08868bf7d7c70f8c$export$d68aba5567a52975(container) {
    const containerElement = (0, $7544862da546e887$export$f0c653cfd7dea798)(container);
    const focusableElements = containerElement != null ? (0, $5f6dd9e57dfd2e30$export$433aaa1f216cf32d)(containerElement) : [];
    return focusableElements.filter((el)=>!el.classList.contains((0, $2cfd35af7ec11fdd$export$b05704f848ce027)) && !el.classList.contains((0, $2cfd35af7ec11fdd$export$72317839a64c29d3)));
}


/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

var $cRanb = parcelRequire("cRanb");



var $kYL7Z = parcelRequire("kYL7Z");
const $3607191252287766$export$60d741e20e0aa309 = (0, $kYL7Z.createContext)({});
const $3607191252287766$export$6df4068a17305b10 = ({ children: children, portalClassName: portalClassName, portalContainer: portalContainer })=>{
    const contextOptions = (0, $kYL7Z.useMemo)(()=>({
            portalClassName: portalClassName,
            portalContainer: portalContainer
        }), [
        portalClassName,
        portalContainer
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)($3607191252287766$export$60d741e20e0aa309.Provider, {
        value: contextOptions,
        children: children
    });
};


function $559b5482c85e619c$export$602eac185826482c(// eslint-disable-next-line @typescript-eslint/no-deprecated
{ className: className, stopPropagationEvents: stopPropagationEvents, container: container, onChildrenMount: onChildrenMount, children: children }) {
    const context = (0, $kYL7Z.useContext)((0, $3607191252287766$export$60d741e20e0aa309));
    const portalContainer = container ?? context.portalContainer ?? (typeof document !== "undefined" ? document.body : undefined);
    const [portalElement, setPortalElement] = (0, $kYL7Z.useState)();
    const createPortalElement = (0, $kYL7Z.useCallback)(()=>{
        const newPortalElement = document.createElement("div");
        newPortalElement.classList.add((0, $2cfd35af7ec11fdd$exports).PORTAL);
        $559b5482c85e619c$var$maybeAddClass(newPortalElement.classList, className); // directly added to this portal element
        $559b5482c85e619c$var$maybeAddClass(newPortalElement.classList, context.portalClassName); // added via PortalProvider context
        $559b5482c85e619c$var$addStopPropagationListeners(newPortalElement, stopPropagationEvents);
        return newPortalElement;
    }, [
        className,
        context.portalClassName,
        stopPropagationEvents
    ]);
    // create the container element & attach it to the DOM
    (0, $kYL7Z.useEffect)(()=>{
        if (portalContainer == null) return;
        const newPortalElement = createPortalElement();
        portalContainer.appendChild(newPortalElement);
        setPortalElement(newPortalElement);
        return ()=>{
            $559b5482c85e619c$var$removeStopPropagationListeners(newPortalElement, stopPropagationEvents);
            newPortalElement.remove();
            setPortalElement(undefined);
        };
    }, [
        portalContainer,
        createPortalElement,
        stopPropagationEvents
    ]);
    // wait until next successful render to invoke onChildrenMount callback
    (0, $kYL7Z.useEffect)(()=>{
        if (portalElement != null) onChildrenMount?.();
    }, [
        portalElement,
        onChildrenMount
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (portalElement != null) {
            $559b5482c85e619c$var$maybeAddClass(portalElement.classList, className);
            return ()=>$559b5482c85e619c$var$maybeRemoveClass(portalElement.classList, className);
        }
        return undefined;
    }, [
        className,
        portalElement
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (portalElement != null) {
            $559b5482c85e619c$var$addStopPropagationListeners(portalElement, stopPropagationEvents);
            return ()=>$559b5482c85e619c$var$removeStopPropagationListeners(portalElement, stopPropagationEvents);
        }
        return undefined;
    }, [
        portalElement,
        stopPropagationEvents
    ]);
    // Only render `children` once this component has mounted in a browser environment, so they are
    // immediately attached to the DOM tree and can do DOM things like measuring or `autoFocus`.
    // See long comment on componentDidMount in https://reactjs.org/docs/portals.html#event-bubbling-through-portals
    if (typeof document === "undefined" || portalElement == null) return null;
    else return (0, $cRanb.createPortal)(children, portalElement);
}
$559b5482c85e619c$export$602eac185826482c.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Portal`;
function $559b5482c85e619c$var$maybeRemoveClass(classList, className) {
    if (className != null && className !== "") classList.remove(...className.split(" "));
}
function $559b5482c85e619c$var$maybeAddClass(classList, className) {
    if (className != null && className !== "") classList.add(...className.split(" "));
}
function $559b5482c85e619c$var$addStopPropagationListeners(portalElement, eventNames) {
    eventNames?.forEach((event)=>portalElement.addEventListener(event, $559b5482c85e619c$var$handleStopProgation));
}
function $559b5482c85e619c$var$removeStopPropagationListeners(portalElement, events) {
    events?.forEach((event)=>portalElement.removeEventListener(event, $559b5482c85e619c$var$handleStopProgation));
}
function $559b5482c85e619c$var$handleStopProgation(e) {
    e.stopPropagation();
}


const $aef6e7264f0251d6$export$2e8e2c61dfd53893 = (0, $kYL7Z.forwardRef)((props, forwardedRef)=>{
    const { autoFocus: autoFocus = true, backdropClassName: backdropClassName, backdropProps: backdropProps = {}, canEscapeKeyClose: canEscapeKeyClose = true, canOutsideClickClose: canOutsideClickClose = true, childRef: childRef, childRefs: childRefs, children: children, className: className, enforceFocus: enforceFocus = true, hasBackdrop: hasBackdrop = true, isOpen: isOpen = false, lazy: lazy = (0, $5f6dd9e57dfd2e30$export$974c8c6d1fbc6154)(), onClose: onClose, onClosed: onClosed, onClosing: onClosing, onOpened: onOpened, onOpening: onOpening, portalClassName: portalClassName, portalContainer: portalContainer, shouldReturnFocusOnClose: shouldReturnFocusOnClose = true, transitionDuration: transitionDuration = 300, transitionName: transitionName = (0, $2cfd35af7ec11fdd$exports).OVERLAY, usePortal: usePortal = true } = props;
    $aef6e7264f0251d6$var$useOverlay2Validation(props);
    const { closeOverlay: closeOverlay, getLastOpened: getLastOpened, getThisOverlayAndDescendants: getThisOverlayAndDescendants, openOverlay: openOverlay } = (0, $f03f4e3b2979f7ee$export$b9eca684780184d5)();
    const [isAutoFocusing, setIsAutoFocusing] = (0, $kYL7Z.useState)(false);
    const [hasEverOpened, setHasEverOpened] = (0, $kYL7Z.useState)(false);
    const [shouldFocusOnContainerMount, setShouldFocusOnContainerMount] = (0, $kYL7Z.useState)(false);
    const lastActiveElementBeforeOpened = (0, $kYL7Z.useRef)(null);
    /** Ref for container element, containing all children and the backdrop */ const containerElement = (0, $kYL7Z.useRef)(null);
    /** Ref for backdrop element */ const backdropElement = (0, $kYL7Z.useRef)(null);
    /* An empty, keyboard-focusable div at the beginning of the Overlay content */ const startFocusTrapElement = (0, $kYL7Z.useRef)(null);
    /* An empty, keyboard-focusable div at the end of the Overlay content */ const endFocusTrapElement = (0, $kYL7Z.useRef)(null);
    /**
     * Locally-generated DOM ref for a singleton child element.
     * This is only used iff the user does not specify the `childRef` or `childRefs` props.
     */ const localChildRef = (0, $kYL7Z.useRef)(null);
    const bringFocusInsideOverlay = (0, $kYL7Z.useCallback)((containerOverride)=>{
        // always delay focus manipulation to just before repaint to prevent scroll jumping
        return requestAnimationFrame(()=>{
            // container element may be undefined between component mounting and Portal rendering
            // activeElement may be undefined in some rare cases in IE
            const container = containerOverride ?? (0, $7544862da546e887$export$f0c653cfd7dea798)(containerElement);
            const activeElement = (0, $5f6dd9e57dfd2e30$export$cd4e5573fbe2b576)(container);
            if (container == null || activeElement == null) return;
            // Overlay2 is guaranteed to be mounted here
            const isFocusOutsideModal = !container.contains(activeElement);
            if (isFocusOutsideModal) {
                (0, $7544862da546e887$export$f0c653cfd7dea798)(startFocusTrapElement)?.focus({
                    preventScroll: true
                });
                setIsAutoFocusing(false);
            }
        });
    }, []);
    /**
     * Callback for when the container element is mounted in the DOM.
     * This handles a race condition where autoFocus is requested before Portal renders a container.
     */ const handleContainerMount = (0, $kYL7Z.useCallback)((node)=>{
        // If we have a pending focus request and the container is now available, apply focus
        if (node != null && shouldFocusOnContainerMount) {
            setShouldFocusOnContainerMount(false);
            setIsAutoFocusing(true);
            bringFocusInsideOverlay(node);
        }
    }, [
        bringFocusInsideOverlay,
        shouldFocusOnContainerMount
    ]);
    /**
     * Combined ref that both stores the container element and triggers mount logic
     */ const mergedContainerRef = (0, $kYL7Z.useMemo)(()=>(0, $7544862da546e887$export$c9058316764c140e)(containerElement, handleContainerMount), [
        handleContainerMount
    ]);
    /** Unique ID for this overlay in the global stack */ const id = $aef6e7264f0251d6$var$useOverlay2ID();
    // N.B. use `null` here and not simply `undefined` because `useImperativeHandle` will set `null` on unmount,
    // and we need the following code to be resilient to that value.
    const instance = (0, $kYL7Z.useRef)(null);
    /**
     * When multiple `enforceFocus` Overlays are open, this event handler is only active for the most
     * recently opened one to avoid Overlays competing with each other for focus.
     */ const handleDocumentFocus = (0, $kYL7Z.useCallback)((e)=>{
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        const eventTarget = e.composed ? e.composedPath()[0] : e.target;
        const container = (0, $7544862da546e887$export$f0c653cfd7dea798)(containerElement);
        if (container != null && eventTarget instanceof Node && !container.contains(eventTarget)) {
            // prevent default focus behavior (sometimes auto-scrolls the page)
            e.preventDefault();
            e.stopImmediatePropagation();
            bringFocusInsideOverlay();
        }
    }, [
        bringFocusInsideOverlay
    ]);
    // N.B. this listener is only kept attached when `isOpen={true}` and `canOutsideClickClose={true}`
    const handleDocumentMousedown = (0, $kYL7Z.useCallback)((e)=>{
        // get the actual target even in the Shadow DOM
        // see https://github.com/palantir/blueprint/issues/4220
        const eventTarget = e.composed ? e.composedPath()[0] : e.target;
        const thisOverlayAndDescendants = getThisOverlayAndDescendants(id);
        const isClickInThisOverlayOrDescendant = thisOverlayAndDescendants.some(({ containerElement: containerRef })=>{
            // `elem` is the container of backdrop & content, so clicking directly on that container
            // should not count as being "inside" the overlay.
            const elem = (0, $7544862da546e887$export$f0c653cfd7dea798)(containerRef);
            return elem?.contains(eventTarget) && !elem.isSameNode(eventTarget);
        });
        if (!isClickInThisOverlayOrDescendant) // casting to any because this is a native event
        onClose?.(e);
    }, [
        getThisOverlayAndDescendants,
        id,
        onClose
    ]);
    // N.B. this listener allows Escape key to close overlays that don't have focus (e.g., hover-triggered tooltips)
    // It's only attached when `autoFocus={false}` (indicating a hover interaction) and `canEscapeKeyClose={true}`
    const handleDocumentKeyDown = (0, $kYL7Z.useCallback)((e)=>{
        if (e.key === "Escape" && canEscapeKeyClose) {
            // Only close if this is the topmost overlay to avoid closing multiple overlays at once
            const lastOpened = getLastOpened();
            if (lastOpened?.id === id) {
                onClose?.(e);
                e.stopPropagation();
                e.preventDefault();
            }
        }
    }, [
        canEscapeKeyClose,
        getLastOpened,
        id,
        onClose
    ]);
    // send this instance's imperative handle to the the forwarded ref as well as our local ref
    const ref = (0, $kYL7Z.useMemo)(()=>(0, $7544862da546e887$export$c9058316764c140e)(forwardedRef, instance), [
        forwardedRef
    ]);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>({
            bringFocusInsideOverlay: bringFocusInsideOverlay,
            containerElement: containerElement,
            handleDocumentFocus: handleDocumentFocus,
            handleDocumentMousedown: handleDocumentMousedown,
            id: id,
            props: {
                autoFocus: autoFocus,
                enforceFocus: enforceFocus,
                hasBackdrop: hasBackdrop,
                usePortal: usePortal
            }
        }), [
        autoFocus,
        bringFocusInsideOverlay,
        enforceFocus,
        handleDocumentFocus,
        handleDocumentMousedown,
        hasBackdrop,
        id,
        usePortal
    ]);
    const handleContainerKeyDown = (0, $kYL7Z.useCallback)((e)=>{
        if (e.key === "Escape" && canEscapeKeyClose) {
            onClose?.(e);
            // prevent other overlays from closing
            e.stopPropagation();
            // prevent browser-specific escape key behavior (Safari exits fullscreen)
            e.preventDefault();
        }
    }, [
        canEscapeKeyClose,
        onClose
    ]);
    const overlayWillOpen = (0, $kYL7Z.useCallback)(()=>{
        if (instance.current == null) return;
        const lastOpenedOverlay = getLastOpened();
        if (lastOpenedOverlay?.handleDocumentFocus !== undefined) document.removeEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
        openOverlay(instance.current);
        if (autoFocus) {
            const container = (0, $7544862da546e887$export$f0c653cfd7dea798)(containerElement);
            if (container != null) {
                setIsAutoFocusing(true);
                bringFocusInsideOverlay();
            } else setShouldFocusOnContainerMount(true);
        }
        (0, $7544862da546e887$export$4bb192c7cacf928f)(lastActiveElementBeforeOpened, (0, $5f6dd9e57dfd2e30$export$cd4e5573fbe2b576)((0, $7544862da546e887$export$f0c653cfd7dea798)(containerElement)));
    }, [
        autoFocus,
        bringFocusInsideOverlay,
        getLastOpened,
        openOverlay
    ]);
    const overlayWillClose = (0, $kYL7Z.useCallback)(()=>{
        document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        document.removeEventListener("mousedown", handleDocumentMousedown);
        // N.B. `instance.current` may be null at this point if we are cleaning up an open overlay during the unmount phase
        // (this is common, for example, with context menu's singleton `showContextMenu` / `hideContextMenu` imperative APIs).
        closeOverlay(id);
        const lastOpenedOverlay = getLastOpened();
        if (lastOpenedOverlay !== undefined) // Only bring focus back to last overlay if it had autoFocus _and_ enforceFocus enabled.
        // If `autoFocus={false}`, it's likely that the overlay never received focus in the first place,
        // so it would be surprising for us to send it there. See https://github.com/palantir/blueprint/issues/4921
        {
            if (lastOpenedOverlay.props.autoFocus && lastOpenedOverlay.props.enforceFocus) {
                lastOpenedOverlay.bringFocusInsideOverlay?.();
                if (lastOpenedOverlay.handleDocumentFocus !== undefined) document.addEventListener("focus", lastOpenedOverlay.handleDocumentFocus, /* useCapture */ true);
            }
        }
    }, [
        closeOverlay,
        getLastOpened,
        handleDocumentFocus,
        handleDocumentMousedown,
        id
    ]);
    const prevIsOpen = (0, $611231c730532d04$export$5cae361ad82dce8b)(isOpen) ?? false;
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen) setHasEverOpened(true);
        if (!prevIsOpen && isOpen) // just opened
        overlayWillOpen();
        if (prevIsOpen && !isOpen) // just closed
        overlayWillClose();
    }, [
        isOpen,
        overlayWillOpen,
        overlayWillClose,
        prevIsOpen
    ]);
    // Important: clean up old document-level event listeners if their memoized values change (this is rare, but
    // may happen, for example, if a user forgets to use `useCallback` in the `props.onClose` value).
    // Otherwise, we will lose the reference to those values and create a memory leak since we won't be able
    // to successfully detach them inside overlayWillClose.
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen || !(canOutsideClickClose && !hasBackdrop)) return;
        document.addEventListener("mousedown", handleDocumentMousedown);
        return ()=>{
            document.removeEventListener("mousedown", handleDocumentMousedown);
        };
    }, [
        handleDocumentMousedown,
        isOpen,
        canOutsideClickClose,
        hasBackdrop
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        // Attach document-level keydown listener for overlays that don't receive focus (like hover tooltips)
        // This enables Escape key dismissal without stealing focus on hover
        if (!isOpen || autoFocus !== false || !canEscapeKeyClose) return;
        document.addEventListener("keydown", handleDocumentKeyDown);
        return ()=>{
            document.removeEventListener("keydown", handleDocumentKeyDown);
        };
    }, [
        handleDocumentKeyDown,
        isOpen,
        autoFocus,
        canEscapeKeyClose
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen || !enforceFocus) return;
        // Only add listener if this overlay is the most recent one
        const lastOpened = getLastOpened();
        const isTopOverlay = lastOpened?.id === id;
        if (!isTopOverlay) return;
        // Focus events do not bubble, but setting useCapture allows us to listen in and execute
        // our handler before all others
        document.addEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        return ()=>{
            document.removeEventListener("focus", handleDocumentFocus, /* useCapture */ true);
        };
    }, [
        handleDocumentFocus,
        enforceFocus,
        isOpen,
        getLastOpened,
        id
    ]);
    const overlayWillCloseRef = (0, $kYL7Z.useRef)(overlayWillClose);
    overlayWillCloseRef.current = overlayWillClose;
    (0, $kYL7Z.useEffect)(()=>{
        // run cleanup code once on unmount, ensuring we call the most recent overlayWillClose callback
        // by storing in a ref and keeping up to date
        return ()=>{
            overlayWillCloseRef.current();
        };
    }, []);
    const handleTransitionExited = (0, $kYL7Z.useCallback)((node)=>{
        const lastActiveElement = (0, $7544862da546e887$export$f0c653cfd7dea798)(lastActiveElementBeforeOpened);
        if (shouldReturnFocusOnClose && lastActiveElement instanceof HTMLElement) lastActiveElement.focus();
        onClosed?.(node);
    }, [
        onClosed,
        shouldReturnFocusOnClose
    ]);
    // N.B. CSSTransition requires this callback to be defined, even if it's unused.
    const handleTransitionAddEnd = (0, $kYL7Z.useCallback)(()=>{
    // no-op
    }, []);
    /**
     * Gets the relevant DOM ref for a child element using the `childRef` or `childRefs` props (if possible).
     * This ref is necessary for `CSSTransition` to work in React 18 without relying on `ReactDOM.findDOMNode`.
     *
     * Returns `undefined` if the user did not specify either of those props. In those cases, we use the ref we
     * have locally generated and expect that the user _did not_ specify their own `ref` on the child element
     * (it will get clobbered / overriden).
     *
     * @see https://reactcommunity.org/react-transition-group/css-transition
     */ const getUserChildRef = (0, $kYL7Z.useCallback)((child)=>{
        if (childRef != null) return childRef;
        else if (childRefs != null) {
            const key = child.key;
            if (key == null) {
                if (!(0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) console.error((0, $5bed6f2a5e88b283$export$5c53f620d79bf998));
                return undefined;
            }
            return childRefs[key];
        }
        return undefined;
    }, [
        childRef,
        childRefs
    ]);
    const maybeRenderChild = (0, $kYL7Z.useCallback)((child)=>{
        if (child == null || (0, $f141b3b4d406798c$export$78d1711480f95c3e)(child)) return null;
        // decorate the child with a few injected props
        const userChildRef = getUserChildRef(child);
        const childProps = (0, $dd6a2a6ae729b1ca$export$564ec7e3bcdb7847)(child) ? child.props : {};
        // if the child is a string, number, or fragment, it will be wrapped in a <span> element
        const decoratedChild = (0, $dd6a2a6ae729b1ca$export$7210cc31459d553a)(child, "span", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(childProps.className, (0, $2cfd35af7ec11fdd$exports).OVERLAY_CONTENT),
            // IMPORTANT: only inject our ref if the user didn't specify childRef or childRefs already. Otherwise,
            // we risk clobbering the user's ref (which we cannot inspect here while cloning/decorating the child).
            ref: userChildRef === undefined ? localChildRef : undefined,
            tabIndex: enforceFocus || autoFocus ? 0 : undefined
        });
        const resolvedChildRef = userChildRef ?? localChildRef;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $a55240fa3c35e720$export$2e2bcd8739ae039), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            // HACKHACK: CSSTransition types are slightly incompatible with React types here.
            // React prefers `| null` but not `| undefined` for the ref value, while
            // CSSTransition _demands_ that `| undefined` be part of the element type.
            nodeRef: resolvedChildRef,
            onEntered: $aef6e7264f0251d6$var$getLifecycleCallbackWithChildRef(onOpened, resolvedChildRef),
            onEntering: $aef6e7264f0251d6$var$getLifecycleCallbackWithChildRef(onOpening, resolvedChildRef),
            onExited: $aef6e7264f0251d6$var$getLifecycleCallbackWithChildRef(handleTransitionExited, resolvedChildRef),
            onExiting: $aef6e7264f0251d6$var$getLifecycleCallbackWithChildRef(onClosing, resolvedChildRef),
            timeout: transitionDuration,
            children: decoratedChild
        });
    }, [
        autoFocus,
        enforceFocus,
        getUserChildRef,
        handleTransitionAddEnd,
        handleTransitionExited,
        onClosing,
        onOpened,
        onOpening,
        transitionDuration,
        transitionName
    ]);
    const handleBackdropMouseDown = (0, $kYL7Z.useCallback)((e)=>{
        if (canOutsideClickClose) onClose?.(e);
        if (enforceFocus) bringFocusInsideOverlay();
        backdropProps?.onMouseDown?.(e);
    }, [
        backdropProps,
        bringFocusInsideOverlay,
        canOutsideClickClose,
        enforceFocus,
        onClose
    ]);
    const renderDummyElement = (0, $kYL7Z.useCallback)((key, dummyElementProps)=>(0, $fc31e5e9fc16a880$exports.jsx)((0, $a55240fa3c35e720$export$2e2bcd8739ae039), {
            addEndListener: handleTransitionAddEnd,
            classNames: transitionName,
            nodeRef: dummyElementProps.ref,
            timeout: transitionDuration,
            unmountOnExit: true,
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                tabIndex: 0,
                ...dummyElementProps
            })
        }, key), [
        handleTransitionAddEnd,
        transitionDuration,
        transitionName
    ]);
    /**
     * Ensures repeatedly pressing shift+tab keeps focus inside the Overlay. Moves focus to
     * the `endFocusTrapElement` or the first keyboard-focusable element in the Overlay (excluding
     * the `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ const handleStartFocusTrapElementFocus = (0, $kYL7Z.useCallback)((e)=>{
        if (!enforceFocus || isAutoFocusing) return;
        // e.relatedTarget will not be defined if this was a programmatic focus event, as is the
        // case when we call this.bringFocusInsideOverlay() after a user clicked on the backdrop.
        // Otherwise, we're handling a user interaction, and we should wrap around to the last
        // element in this transition group.
        const container = (0, $7544862da546e887$export$f0c653cfd7dea798)(containerElement);
        const endFocusTrap = (0, $7544862da546e887$export$f0c653cfd7dea798)(endFocusTrapElement);
        if (e.relatedTarget != null && container?.contains(e.relatedTarget) && e.relatedTarget !== endFocusTrap) endFocusTrap?.focus({
            preventScroll: true
        });
    }, [
        enforceFocus,
        isAutoFocusing
    ]);
    /**
     * Wrap around to the end of the dialog if `enforceFocus` is enabled.
     */ const handleStartFocusTrapElementKeyDown = (0, $kYL7Z.useCallback)((e)=>{
        if (!enforceFocus) return;
        if (e.shiftKey && e.key === "Tab") {
            const lastFocusableElement = (0, $08868bf7d7c70f8c$export$d68aba5567a52975)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else (0, $7544862da546e887$export$f0c653cfd7dea798)(endFocusTrapElement)?.focus({
                preventScroll: true
            });
        }
    }, [
        enforceFocus
    ]);
    /**
     * Ensures repeatedly pressing tab keeps focus inside the Overlay. Moves focus to the
     * `startFocusTrapElement` or the last keyboard-focusable element in the Overlay (excluding the
     * `startFocusTrapElement`), depending on whether the element losing focus is inside the
     * Overlay.
     */ const handleEndFocusTrapElementFocus = (0, $kYL7Z.useCallback)((e)=>{
        // No need for this.props.enforceFocus check here because this element is only rendered
        // when that prop is true.
        // During user interactions, e.relatedTarget will be defined, and we should wrap around to the
        // "start focus trap" element.
        // Otherwise, we're handling a programmatic focus event, which can only happen after a user
        // presses shift+tab from the first focusable element in the overlay.
        const startFocusTrap = (0, $7544862da546e887$export$f0c653cfd7dea798)(startFocusTrapElement);
        if (e.relatedTarget != null && (0, $7544862da546e887$export$f0c653cfd7dea798)(containerElement)?.contains(e.relatedTarget) && e.relatedTarget !== startFocusTrap) {
            const firstFocusableElement = (0, $08868bf7d7c70f8c$export$d68aba5567a52975)(containerElement).shift();
            // ensure we don't re-focus an already active element by comparing against e.relatedTarget
            if (!isAutoFocusing && firstFocusableElement != null && firstFocusableElement !== e.relatedTarget) firstFocusableElement.focus();
            else startFocusTrap?.focus({
                preventScroll: true
            });
        } else {
            const lastFocusableElement = (0, $08868bf7d7c70f8c$export$d68aba5567a52975)(containerElement).pop();
            if (lastFocusableElement != null) lastFocusableElement.focus();
            else // Keeps focus within Overlay even if there are no keyboard-focusable children
            startFocusTrap?.focus({
                preventScroll: true
            });
        }
    }, [
        isAutoFocusing
    ]);
    const maybeBackdrop = (0, $kYL7Z.useMemo)(()=>hasBackdrop && isOpen ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $a55240fa3c35e720$export$2e2bcd8739ae039), {
            classNames: transitionName,
            nodeRef: backdropElement,
            timeout: transitionDuration,
            addEndListener: handleTransitionAddEnd,
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                ...backdropProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).OVERLAY_BACKDROP, backdropClassName, backdropProps?.className),
                onMouseDown: handleBackdropMouseDown,
                ref: backdropElement
            })
        }, "__backdrop") : null, [
        backdropClassName,
        backdropProps,
        handleBackdropMouseDown,
        handleTransitionAddEnd,
        hasBackdrop,
        isOpen,
        transitionDuration,
        transitionName
    ]);
    // no reason to render anything at all if we're being truly lazy
    if (lazy && !hasEverOpened) return null;
    // TransitionGroup types require single array of children; does not support nested arrays.
    // So we must collapse backdrop and children into one array, and every item must be wrapped in a
    // Transition element (no ReactText allowed).
    const childrenWithTransitions = isOpen ? (0, $kYL7Z.Children).map(children, maybeRenderChild) ?? [] : [];
    // const maybeBackdrop = maybeRenderBackdrop();
    if (maybeBackdrop !== null) childrenWithTransitions.unshift(maybeBackdrop);
    if (isOpen && (autoFocus || enforceFocus) && childrenWithTransitions.length > 0) {
        childrenWithTransitions.unshift(renderDummyElement("__start", {
            className: (0, $2cfd35af7ec11fdd$exports).OVERLAY_START_FOCUS_TRAP,
            onFocus: handleStartFocusTrapElementFocus,
            onKeyDown: handleStartFocusTrapElementKeyDown,
            ref: startFocusTrapElement
        }));
        if (enforceFocus) childrenWithTransitions.push(renderDummyElement("__end", {
            className: (0, $2cfd35af7ec11fdd$exports).OVERLAY_END_FOCUS_TRAP,
            onFocus: handleEndFocusTrapElementFocus,
            ref: endFocusTrapElement
        }));
    }
    const transitionGroup = // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        "aria-live": "polite",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).OVERLAY, {
            [(0, $2cfd35af7ec11fdd$exports).OVERLAY_OPEN]: isOpen,
            [(0, $2cfd35af7ec11fdd$exports).OVERLAY_INLINE]: !usePortal
        }, className),
        onKeyDown: handleContainerKeyDown,
        ref: mergedContainerRef,
        children: (0, $fc31e5e9fc16a880$exports.jsx)((0, $a423602b7c98e212$export$2e2bcd8739ae039), {
            appear: true,
            component: null,
            children: childrenWithTransitions
        })
    });
    if (usePortal) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $559b5482c85e619c$export$602eac185826482c), {
        className: portalClassName,
        container: portalContainer,
        children: transitionGroup
    });
    else return transitionGroup;
});
$aef6e7264f0251d6$export$2e8e2c61dfd53893.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Overlay2`;
function $aef6e7264f0251d6$var$useOverlay2Validation({ childRef: childRef, childRefs: childRefs, children: children }) {
    const numChildren = (0, $kYL7Z.Children).count(children);
    (0, $kYL7Z.useEffect)(()=>{
        if ((0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) return;
        if (childRef != null && childRefs != null) console.error((0, $5bed6f2a5e88b283$export$9a7688a076ebfc22));
        if (numChildren > 1 && childRefs == null) console.error((0, $5bed6f2a5e88b283$export$d1780dd5da45c8d8));
    }, [
        childRef,
        childRefs,
        numChildren
    ]);
}
/**
 * Generates a unique ID for a given Overlay which persists across the component's lifecycle.
 */ function $aef6e7264f0251d6$var$useOverlay2ID() {
    const id = (0, $kYL7Z.useId)();
    return `${$aef6e7264f0251d6$export$2e8e2c61dfd53893.displayName}-${id}`;
}
// N.B. the `onExiting` callback is not provided with the `node` argument as suggested in CSSTransition types since
// we are using the `nodeRef` prop, so we must inject it dynamically.
function $aef6e7264f0251d6$var$getLifecycleCallbackWithChildRef(callback, childRef) {
    return ()=>{
        if (childRef?.current != null) callback?.(childRef.current);
    };
}


/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

class $2d61fae3cd19394f$export$99e7f5e92b1f0cf9 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.ResizeSensor`;
    targetRef = this.props.targetRef ?? (0, $kYL7Z.createRef)();
    prevElement = undefined;
    observer;
    render() {
        const onlyChild = (0, $kYL7Z.Children).only(this.props.children);
        // If we're provided a mutable ref to the child element already, we must re-use that one. This is necessary
        // in cases where the child node is not a native DOM element and does not use `forwardRef`, since
        // there's no way for us to know how to attach to the underlying DOM node.
        if (this.props.targetRef !== undefined) return onlyChild;
        return (0, $kYL7Z.cloneElement)(onlyChild, {
            ref: this.targetRef
        });
    }
    componentDidMount() {
        // ResizeObserver is available in all modern browsers supported by Blueprint but not in server-side rendering
        // and some test environments like jsdom, so we to do a feature check here.
        this.observer = globalThis.ResizeObserver != null ? new ResizeObserver((entries)=>this.props.onResize?.(entries)) : undefined;
        this.observeElement();
    }
    componentDidUpdate(prevProps) {
        this.observeElement(this.props.observeParents !== prevProps.observeParents);
    }
    componentWillUnmount() {
        this.observer?.disconnect();
        this.prevElement = undefined;
    }
    /**
     * Observe the DOM element, if defined and different from the currently
     * observed element. Pass `force` argument to skip element checks and always
     * re-observe.
     */ observeElement(force = false) {
        if (this.observer === undefined) return;
        if (!(this.targetRef.current instanceof Element)) {
            // stop everything if not defined
            this.observer.disconnect();
            return;
        }
        if (this.targetRef.current === this.prevElement && !force) // quit if given same element -- nothing to update (unless forced)
        return;
        else {
            // clear observer list if new element
            this.observer.disconnect();
            // remember element reference for next time
            this.prevElement = this.targetRef.current;
        }
        // observer callback is invoked immediately when observing new elements
        this.observer.observe(this.targetRef.current);
        if (this.props.observeParents) {
            let parent = this.targetRef.current.parentElement;
            while(parent != null){
                this.observer.observe(parent);
                parent = parent.parentElement;
            }
        }
    }
}


/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable sort-keys */ // adapted from https://popper.js.org/docs/v2/modifiers/community-modifiers/
const $628f0a659c521e95$export$a8e9b369768a413a = {
    enabled: true,
    name: "matchReferenceWidth",
    phase: "beforeWrite",
    requires: [
        "computeStyles"
    ],
    fn: ({ state: state })=>{
        state.styles.popper.width = `${state.rects.reference.width}px`;
    },
    effect: ({ state: state })=>{
        const referenceWidth = state.elements.reference.getBoundingClientRect().width;
        state.elements.popper.style.width = `${referenceWidth}px`;
    }
};




/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $17185a9159326d30$export$1f716c21fc884054(placement) {
    return placement.split("-")[0];
}
function $17185a9159326d30$export$14f7b3a1379533e9(side) {
    return [
        "left",
        "right"
    ].indexOf(side) !== -1;
}
function $17185a9159326d30$export$9c5e28bad23365fa(side) {
    switch(side){
        case "top":
            return "bottom";
        case "left":
            return "right";
        case "bottom":
            return "top";
        default:
            return "left";
    }
}
function $17185a9159326d30$export$f0989780f32bfcda(placement) {
    const align = placement.split("-")[1];
    switch(align){
        case "start":
            return "left";
        case "end":
            return "right";
        default:
            return "center";
    }
}
function $17185a9159326d30$export$ac94fefc82bff952(placement, arrowStyles) {
    const basePlacement = $17185a9159326d30$export$1f716c21fc884054(placement);
    if (arrowStyles === undefined) return $17185a9159326d30$export$14f7b3a1379533e9(basePlacement) ? `${$17185a9159326d30$export$9c5e28bad23365fa(basePlacement)} ${$17185a9159326d30$export$f0989780f32bfcda(basePlacement)}` : `${$17185a9159326d30$export$f0989780f32bfcda(basePlacement)} ${$17185a9159326d30$export$9c5e28bad23365fa(basePlacement)}`;
    else {
        // const arrowSizeShift = state.elements.arrow.clientHeight / 2;
        const arrowSizeShift = 15;
        // can use keyword for dimension without the arrow, to ease computation burden.
        // move origin by half arrow's height to keep it centered.
        return $17185a9159326d30$export$14f7b3a1379533e9(basePlacement) ? `${$17185a9159326d30$export$9c5e28bad23365fa(basePlacement)} ${parseInt(arrowStyles.top, 10) + arrowSizeShift}px` : `${parseInt(arrowStyles.left, 10) + arrowSizeShift}px ${$17185a9159326d30$export$9c5e28bad23365fa(basePlacement)}`;
    }
}


// these paths come from the Core Kit Sketch file
// https://github.com/palantir/blueprint/blob/50a71c9/resources/sketch/blueprint-core-kit.sketch
const $c91d97645d05d63d$var$SVG_SHADOW_PATH = "M8.11 6.302c1.015-.936 1.887-2.922 1.887-4.297v26c0-1.378-.868-3.357-1.888-4.297L.925 17.09c-1.237-1.14-1.233-3.034 0-4.17L8.11 6.302z";
const $c91d97645d05d63d$var$SVG_ARROW_PATH = "M8.787 7.036c1.22-1.125 2.21-3.376 2.21-5.03V0v30-2.005c0-1.654-.983-3.9-2.21-5.03l-7.183-6.616c-.81-.746-.802-1.96 0-2.7l7.183-6.614z";
// additional space between arrow and edge of target
const $c91d97645d05d63d$var$ARROW_SPACING = 4;
const $c91d97645d05d63d$export$4c969461ca74ea0d = 30;
const $c91d97645d05d63d$export$26419ed1e4945e0 = 22;
/* istanbul ignore next */ /** Modifier helper function to compute arrow rotate() transform */ function $c91d97645d05d63d$var$getArrowAngle(placement) {
    if (placement == null) return 0;
    // can only be top/left/bottom/right - auto is resolved internally
    switch((0, $17185a9159326d30$export$1f716c21fc884054)(placement)){
        case "top":
            return -90;
        case "left":
            return 180;
        case "bottom":
            return 90;
        default:
            return 0;
    }
}
/* istanbul ignore next */ /**
 * Popper's builtin "arrow" modifier options.padding doesn't seem to work for us, so we
 * need to compute our own offset in the direction of the popover relative to the reference.
 */ function $c91d97645d05d63d$var$getArrowReferenceOffsetStyle(placement) {
    const offset = $c91d97645d05d63d$export$4c969461ca74ea0d / 2 - $c91d97645d05d63d$var$ARROW_SPACING;
    switch((0, $17185a9159326d30$export$1f716c21fc884054)(placement)){
        case "top":
            return {
                bottom: -offset
            };
        case "left":
            return {
                right: -offset
            };
        case "bottom":
            return {
                top: -offset
            };
        default:
            return {
                left: -offset
            };
    }
}
const $c91d97645d05d63d$export$3152841115e061b2 = ({ arrowProps: { ref: ref, style: style }, placement: placement })=>// data attribute allows popper.js to position the arrow
    (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        "aria-hidden": true,
        className: (0, $2cfd35af7ec11fdd$exports).POPOVER_ARROW,
        "data-popper-arrow": true,
        ref: ref,
        style: {
            ...style,
            ...$c91d97645d05d63d$var$getArrowReferenceOffsetStyle(placement)
        },
        children: (0, $fc31e5e9fc16a880$exports.jsxs)("svg", {
            viewBox: `0 0 ${$c91d97645d05d63d$export$4c969461ca74ea0d} ${$c91d97645d05d63d$export$4c969461ca74ea0d}`,
            style: {
                transform: `rotate(${$c91d97645d05d63d$var$getArrowAngle(placement)}deg)`
            },
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)("path", {
                    className: (0, $2cfd35af7ec11fdd$exports).POPOVER_ARROW + "-border",
                    d: $c91d97645d05d63d$var$SVG_SHADOW_PATH
                }),
                (0, $fc31e5e9fc16a880$exports.jsx)("path", {
                    className: (0, $2cfd35af7ec11fdd$exports).POPOVER_ARROW + "-fill",
                    d: $c91d97645d05d63d$var$SVG_ARROW_PATH
                })
            ]
        })
    });
$c91d97645d05d63d$export$3152841115e061b2.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.PopoverArrow`;


/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $ce578faf011ad99f$export$2fdab12f67185662 = {
    ...(0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42),
    AUTO: "auto",
    AUTO_END: "auto-end",
    AUTO_START: "auto-start"
};


function $67456ae6d694b225$export$d7fe7517a77957bc(position) {
    /* istanbul ignore next */ switch(position){
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).TOP_LEFT:
            return "top-start";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).TOP:
            return "top";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).TOP_RIGHT:
            return "top-end";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).RIGHT_TOP:
            return "right-start";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).RIGHT:
            return "right";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).RIGHT_BOTTOM:
            return "right-end";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).BOTTOM_RIGHT:
            return "bottom-end";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).BOTTOM:
            return "bottom";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).BOTTOM_LEFT:
            return "bottom-start";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).LEFT_BOTTOM:
            return "left-end";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).LEFT:
            return "left";
        case (0, $ce578faf011ad99f$export$2fdab12f67185662).LEFT_TOP:
            return "left-start";
        case "auto":
        case "auto-start":
        case "auto-end":
            // Return the string unchanged.
            return position;
        default:
            return $67456ae6d694b225$var$assertNever(position);
    }
}
/* istanbul ignore next */ function $67456ae6d694b225$var$assertNever(x) {
    throw new Error("Unexpected position: " + x);
}


/* !
 * (c) Copyright 2025 Palantir Technologies Inc. All rights reserved.
 */ const $0656ff6cfe9f702c$export$6c571fbf65f9c7a6 = {
    CLICK: "click",
    CLICK_TARGET_ONLY: "click-target",
    HOVER: "hover",
    HOVER_TARGET_ONLY: "hover-target"
};



class $5ebb8a1948a3d723$export$5b6b19405a83ff9d extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Popover`;
    static defaultProps = {
        boundary: "clippingParents",
        captureDismiss: false,
        defaultIsOpen: false,
        disabled: false,
        fill: false,
        hasBackdrop: false,
        hoverCloseDelay: 300,
        hoverOpenDelay: 150,
        inheritDarkTheme: true,
        interactionKind: (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).CLICK,
        matchTargetWidth: false,
        minimal: false,
        openOnTargetFocus: true,
        // N.B. we don't set a default for `placement` or `position` here because that would trigger
        // a warning in validateProps if the other prop is specified by a user of this component
        positioningStrategy: "absolute",
        renderTarget: undefined,
        shouldReturnFocusOnClose: false,
        targetTagName: "span",
        transitionDuration: 300,
        usePortal: true
    };
    state = {
        hasDarkParent: false,
        isClosingViaEscapeKeypress: false,
        isOpen: this.getIsOpen(this.props)
    };
    /**
     * DOM element that contains the popover.
     * When `usePortal={true}`, this element will be portaled outside the usual DOM flow,
     * so this reference can be very useful for testing.
     *
     * @public for testing
     */ popoverElement = null;
    /** Popover ref handler */ popoverRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "popoverElement", this.props.popoverRef);
    /**
     * Target DOM element ref.
     *
     * N.B. this must be a ref object since we pass it to `<ResizeSensor>`, which needs to know about the target
     * DOM element in order to observe its dimensions.
     *
     * @public for testing
     */ targetRef = (0, $kYL7Z.createRef)();
    /**
     * Overlay2 transition container element ref.
     */ transitionContainerElement = (0, $kYL7Z.createRef)();
    cancelOpenTimeout;
    // a flag that lets us detect mouse movement between the target and popover,
    // now that mouseleave is triggered when you cross the gap between the two.
    isMouseInTargetOrPopover = false;
    // a flag that indicates whether the target previously lost focus to another
    // element on the same page.
    lostFocusOnSamePage = true;
    // Reference to the Poppper.scheduleUpdate() function, this changes every time the popper is mounted
    popperScheduleUpdate;
    isControlled = ()=>this.props.isOpen !== undefined;
    // arrow is disabled if minimal, or if the arrow modifier was explicitly disabled
    isArrowEnabled = ()=>!this.props.minimal && this.props.modifiers?.arrow?.enabled !== false;
    isHoverInteractionKind = ()=>{
        return this.props.interactionKind === (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).HOVER || this.props.interactionKind === (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).HOVER_TARGET_ONLY;
    };
    // popper innerRef gives us a handle on the transition container, since that's what we render as the overlay child,
    // so if we want to look at our actual popover element, we need to reach inside a bit
    getPopoverElement() {
        return this.popoverElement?.querySelector(`.${(0, $2cfd35af7ec11fdd$exports).POPOVER}`);
    }
    getIsOpen(props) {
        // disabled popovers should never be allowed to open.
        if (props.disabled) return false;
        else return props.isOpen ?? props.defaultIsOpen;
    }
    render() {
        const { disabled: disabled, placement: placement, position: position = "auto", positioningStrategy: positioningStrategy } = this.props;
        const { isOpen: isOpen } = this.state;
        if (this.getIsContentEmpty()) {
            // need to do this check in render(), because `isOpen` is derived from
            // state, and state can't necessarily be accessed in validateProps.
            if (!disabled && isOpen !== false && !(0, $5f04c694ca05154e$exports).isNodeEnv("production")) console.warn($5bed6f2a5e88b283$export$fb9dc24caac9c30e);
            // just render the target without a content overlay if there is no content to display
            return this.renderTarget({
                ref: $5ebb8a1948a3d723$var$noop
            });
        }
        // Important: do not use <Reference innerRef> since it has a bug when used in React 18 strict mode
        // see https://github.com/floating-ui/react-popper/pull/459
        return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $4f95ec2fc0204d79$export$d0d38e7dec7a1a61), {
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $d76c79860bf927b7$export$e0be378c32fb70a7), {
                    children: this.renderTarget
                }),
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $088df94f93f6879b$export$badac9ada3a0bdf9), {
                    innerRef: this.popoverRef,
                    placement: placement ?? (0, $67456ae6d694b225$export$d7fe7517a77957bc)(position),
                    strategy: positioningStrategy,
                    modifiers: this.getPopperModifiers(),
                    children: this.renderPopover
                })
            ]
        });
    }
    componentDidMount() {
        this.updateDarkParent();
    }
    componentDidUpdate(props, state) {
        super.componentDidUpdate(props, state);
        this.updateDarkParent();
        const nextIsOpen = this.getIsOpen(this.props);
        if (this.props.isOpen != null && nextIsOpen !== this.state.isOpen) {
            this.setOpenState(nextIsOpen);
            // tricky: setOpenState calls setState only if this.props.isOpen is
            // not controlled, so we need to invoke setState manually here.
            this.setState({
                isOpen: nextIsOpen
            });
        } else if (this.props.disabled && this.state.isOpen && this.props.isOpen == null) // special case: close an uncontrolled popover when disabled is set to true
        this.setOpenState(false);
    }
    validateProps(props) {
        if (props.isOpen == null && props.onInteraction != null) console.warn($5bed6f2a5e88b283$export$cdb7203a6f2d3ac9);
        if (props.hasBackdrop && !props.usePortal) console.warn($5bed6f2a5e88b283$export$d2c026502cfc32e6);
        if (props.hasBackdrop && props.interactionKind !== (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).CLICK) console.warn($5bed6f2a5e88b283$export$deb4db7b191454de);
        if (props.placement !== undefined && props.position !== undefined) console.warn($5bed6f2a5e88b283$export$bd8a2148d985bb65);
        const childrenCount = (0, $kYL7Z.Children).count(props.children);
        const hasRenderTargetProp = props.renderTarget !== undefined;
        const hasTargetPropsProp = props.targetProps !== undefined;
        if (childrenCount === 0 && !hasRenderTargetProp) console.warn($5bed6f2a5e88b283$export$3cf04cff067b1497);
        if (childrenCount > 1) console.warn($5bed6f2a5e88b283$export$d26b2b7b10deb660);
        if (childrenCount > 0 && hasRenderTargetProp) console.warn($5bed6f2a5e88b283$export$92bbc536d12dd3d6);
        if (hasRenderTargetProp && hasTargetPropsProp) console.warn($5bed6f2a5e88b283$export$958f5bcc111a3890);
    }
    /**
     * Instance method to instruct the `Popover` to recompute its position.
     *
     * This method should only be used if you are updating the target in a way
     * that does not cause it to re-render, such as changing its _position_
     * without changing its _size_ (since `Popover` already repositions when it
     * detects a resize).
     */ reposition = ()=>this.popperScheduleUpdate?.();
    renderTarget = ({ ref: popperChildRef })=>{
        const { children: children, className: className, disabled: disabled, fill: fill, openOnTargetFocus: openOnTargetFocus, renderTarget: renderTarget } = this.props;
        const { isOpen: isOpen } = this.state;
        const isControlled = this.isControlled();
        const isHoverInteractionKind = this.isHoverInteractionKind();
        let { targetTagName: targetTagName } = this.props;
        if (fill) targetTagName = "div";
        // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
        // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Reference.js#L17
        const ref = (0, $7544862da546e887$export$c9058316764c140e)(popperChildRef, this.targetRef);
        const targetEventHandlers = isHoverInteractionKind ? {
            // HOVER handlers
            onBlur: this.handleTargetBlur,
            onContextMenu: this.handleTargetContextMenu,
            onFocus: this.handleTargetFocus,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave
        } : {
            // CLICK needs only one handler
            onClick: this.handleTargetClick,
            // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
            onKeyDown: this.handleKeyDown
        };
        // Ensure target is focusable if relevant prop enabled
        const targetTabIndex = !this.getIsContentEmpty() && !disabled && openOnTargetFocus && isHoverInteractionKind ? 0 : undefined;
        const ownTargetProps = {
            // N.B. this.props.className is passed along to renderTarget even though the user would have access to it.
            // If, instead, renderTarget is undefined and the target is provided as a child, this.props.className is
            // applied to the generated target wrapper element.
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(className, (0, $2cfd35af7ec11fdd$exports).POPOVER_TARGET, {
                [(0, $2cfd35af7ec11fdd$exports).POPOVER_OPEN]: isOpen,
                // this class is mainly useful for button targets
                [(0, $2cfd35af7ec11fdd$exports).ACTIVE]: isOpen && !isControlled && !isHoverInteractionKind,
                [(0, $2cfd35af7ec11fdd$exports).FILL]: fill
            }),
            ref: ref,
            ...targetEventHandlers
        };
        const childTargetProps = {
            "aria-expanded": isHoverInteractionKind ? undefined : isOpen,
            "aria-haspopup": this.props.interactionKind === (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).HOVER_TARGET_ONLY ? undefined : this.props.popupKind ?? "menu"
        };
        const targetModifierClasses = {
            // this class is mainly useful for Blueprint <Button> targets; we should only apply it for
            // uncontrolled popovers when they are opened by a user interaction
            [(0, $2cfd35af7ec11fdd$exports).ACTIVE]: isOpen && !isControlled && !isHoverInteractionKind,
            // similarly, this class is mainly useful for targets like <Button>, <InputGroup>, etc.
            [(0, $2cfd35af7ec11fdd$exports).FILL]: fill
        };
        let target;
        if (renderTarget !== undefined) target = renderTarget({
            ...ownTargetProps,
            ...childTargetProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(ownTargetProps.className, targetModifierClasses),
            isOpen: // if the consumer renders a tooltip target, it's their responsibility to disable that tooltip
            // when *this* popover is open
            isOpen,
            tabIndex: targetTabIndex
        });
        else {
            const childTarget = (0, $5f04c694ca05154e$exports).ensureElement((0, $kYL7Z.Children).toArray(children)[0]);
            if (childTarget === undefined) return null;
            const clonedTarget = (0, $kYL7Z.cloneElement)(childTarget, {
                ...childTargetProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(childTarget.props.className, targetModifierClasses),
                // force disable single Tooltip child when popover is open
                disabled: isOpen && $5ebb8a1948a3d723$var$isElementTooltip(childTarget) ? true : childTarget.props.disabled,
                tabIndex: childTarget.props.tabIndex ?? targetTabIndex
            });
            const wrappedTarget = (0, $kYL7Z.createElement)(targetTagName, {
                ...ownTargetProps,
                ...this.props.targetProps
            }, clonedTarget);
            target = wrappedTarget;
        }
        // No need to use the merged `ref` here, that only needs to be forwarded to the child node so that React can
        // notify both popper.js and our components about the mounted DOM element.
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $2d61fae3cd19394f$export$99e7f5e92b1f0cf9), {
            targetRef: this.targetRef,
            onResize: this.reposition,
            children: target
        });
    };
    renderPopover = (popperProps)=>{
        const { autoFocus: autoFocus, enforceFocus: enforceFocus, backdropProps: backdropProps, canEscapeKeyClose: canEscapeKeyClose, hasBackdrop: hasBackdrop, interactionKind: interactionKind, usePortal: usePortal } = this.props;
        const { isClosingViaEscapeKeypress: isClosingViaEscapeKeypress, isOpen: isOpen } = this.state;
        // compute an appropriate transform origin so the scale animation points towards target
        const transformOrigin = (0, $17185a9159326d30$export$ac94fefc82bff952)(popperProps.placement, this.isArrowEnabled() ? popperProps.arrowProps.style : undefined);
        // need to update our reference to this function on every render as it will change.
        this.popperScheduleUpdate = popperProps.update;
        const popoverHandlers = {
            // always check popover clicks for dismiss class
            onClick: this.handlePopoverClick,
            // treat ENTER/SPACE keys the same as a click for accessibility
            onKeyDown: (event)=>(0, $5f04c694ca05154e$exports).isKeyboardClick(event) && this.handlePopoverClick(event)
        };
        if (interactionKind === (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).HOVER || !usePortal && interactionKind === (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).HOVER_TARGET_ONLY) {
            popoverHandlers.onMouseEnter = this.handleMouseEnter;
            popoverHandlers.onMouseLeave = this.handleMouseLeave;
        }
        const basePlacement = (0, $17185a9159326d30$export$1f716c21fc884054)(popperProps.placement);
        const popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).POPOVER, {
            [(0, $2cfd35af7ec11fdd$exports).DARK]: this.props.inheritDarkTheme && this.state.hasDarkParent,
            [(0, $2cfd35af7ec11fdd$exports).MINIMAL]: this.props.minimal,
            [(0, $2cfd35af7ec11fdd$exports).POPOVER_CAPTURING_DISMISS]: this.props.captureDismiss,
            [(0, $2cfd35af7ec11fdd$exports).POPOVER_MATCH_TARGET_WIDTH]: this.props.matchTargetWidth,
            [(0, $2cfd35af7ec11fdd$exports).POPOVER_REFERENCE_HIDDEN]: popperProps.isReferenceHidden === true,
            [(0, $2cfd35af7ec11fdd$exports).POPOVER_POPPER_ESCAPED]: popperProps.hasPopperEscaped === true
        }, `${(0, $2cfd35af7ec11fdd$exports).POPOVER_CONTENT_PLACEMENT}-${basePlacement}`, this.props.popoverClassName);
        const defaultAutoFocus = this.isHoverInteractionKind() ? false : undefined;
        // if hover interaction, it doesn't make sense to take over focus control
        const shouldReturnFocusOnClose = this.isHoverInteractionKind() ? false : isClosingViaEscapeKeypress ? true : this.props.shouldReturnFocusOnClose;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $aef6e7264f0251d6$export$2e8e2c61dfd53893), {
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: autoFocus ?? defaultAutoFocus,
            backdropClassName: (0, $2cfd35af7ec11fdd$exports).POPOVER_BACKDROP,
            backdropProps: backdropProps,
            canEscapeKeyClose: canEscapeKeyClose,
            canOutsideClickClose: interactionKind === (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).CLICK,
            childRef: this.transitionContainerElement,
            enforceFocus: enforceFocus,
            hasBackdrop: hasBackdrop,
            isOpen: isOpen,
            lazy: this.props.lazy,
            onClose: this.handleOverlayClose,
            onClosed: this.props.onClosed,
            onClosing: this.props.onClosing,
            onOpened: this.props.onOpened,
            onOpening: this.props.onOpening,
            transitionDuration: this.props.transitionDuration,
            transitionName: (0, $2cfd35af7ec11fdd$exports).POPOVER,
            usePortal: usePortal,
            portalClassName: this.props.portalClassName,
            portalContainer: this.props.portalContainer,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            portalStopPropagationEvents: this.props.portalStopPropagationEvents,
            shouldReturnFocusOnClose: shouldReturnFocusOnClose,
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).POPOVER_TRANSITION_CONTAINER,
                // We need to attach a ref that notifies both react-popper and our Popover component about the DOM
                // element inside the Overlay2. We cannot re-use `PopperChildrenProps.ref` because Overlay2 only
                // accepts a ref object (not a callback) due to a CSSTransition API limitation.
                // N.B. react-popper has a wide type for this ref, but we can narrow it based on the source,
                // see https://github.com/floating-ui/react-popper/blob/beac280d61082852c4efc302be902911ce2d424c/src/Popper.js#L94
                ref: (0, $7544862da546e887$export$c9058316764c140e)(popperProps.ref, this.transitionContainerElement),
                style: popperProps.style,
                children: (0, $fc31e5e9fc16a880$exports.jsx)((0, $2d61fae3cd19394f$export$99e7f5e92b1f0cf9), {
                    onResize: this.reposition,
                    children: (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                        className: popoverClasses,
                        style: {
                            transformOrigin: transformOrigin
                        },
                        ref: this.popoverRef,
                        ...popoverHandlers,
                        children: [
                            this.isArrowEnabled() && (0, $fc31e5e9fc16a880$exports.jsx)((0, $c91d97645d05d63d$export$3152841115e061b2), {
                                arrowProps: popperProps.arrowProps,
                                placement: popperProps.placement
                            }),
                            (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                className: (0, $2cfd35af7ec11fdd$exports).POPOVER_CONTENT,
                                children: this.props.content
                            })
                        ]
                    })
                })
            })
        });
    };
    getPopperModifiers() {
        const { matchTargetWidth: matchTargetWidth, modifiers: modifiers, modifiersCustom: modifiersCustom } = this.props;
        const popperModifiers = [
            {
                enabled: this.isArrowEnabled(),
                name: "arrow",
                ...modifiers?.arrow
            },
            {
                name: "computeStyles",
                ...modifiers?.computeStyles,
                options: {
                    adaptive: true,
                    // We disable the built-in gpuAcceleration so that
                    // Popper.js will return us easy to interpolate values
                    // (top, left instead of transform: translate3d)
                    // We'll then use these values to generate the needed
                    // css transform values blended with the react-spring values
                    gpuAcceleration: false,
                    ...modifiers?.computeStyles?.options
                }
            },
            {
                enabled: this.isArrowEnabled(),
                name: "offset",
                ...modifiers?.offset,
                options: {
                    offset: [
                        0,
                        (0, $c91d97645d05d63d$export$4c969461ca74ea0d) / 2
                    ],
                    ...modifiers?.offset?.options
                }
            },
            {
                name: "flip",
                ...modifiers?.flip,
                options: {
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary,
                    ...modifiers?.flip?.options
                }
            },
            {
                name: "preventOverflow",
                ...modifiers?.preventOverflow,
                options: {
                    boundary: this.props.boundary,
                    rootBoundary: this.props.rootBoundary,
                    ...modifiers?.preventOverflow?.options
                }
            }
        ];
        if (matchTargetWidth) popperModifiers.push((0, $628f0a659c521e95$export$a8e9b369768a413a));
        if (modifiersCustom !== undefined) popperModifiers.push(...modifiersCustom);
        return popperModifiers;
    }
    handleTargetFocus = (e)=>{
        if (this.props.openOnTargetFocus && this.isHoverInteractionKind()) {
            if (e.relatedTarget == null && !this.lostFocusOnSamePage) // ignore this focus event -- the target was already focused but the page itself
            // lost focus (e.g. due to switching tabs).
            return;
            this.handleMouseEnter(e);
        }
    };
    handleTargetBlur = (e)=>{
        if (this.props.openOnTargetFocus && this.isHoverInteractionKind()) {
            if (e.relatedTarget != null) // if the next element to receive focus is within the popover, we'll want to leave the
            // popover open.
            {
                if (e.relatedTarget !== this.popoverElement && !this.isElementInPopover(e.relatedTarget)) this.handleMouseLeave(e);
            } else this.handleMouseLeave(e);
        }
        this.lostFocusOnSamePage = e.relatedTarget != null;
    };
    handleTargetContextMenu = (e)=>{
        // we assume that when someone prevents the default interaction on this event (a browser native context menu),
        // they are showing a custom context menu (as ContextMenu2 does); in this case, we should close this popover/tooltip
        if (e.defaultPrevented) this.setOpenState(false, e);
    };
    handleMouseEnter = (e)=>{
        this.isMouseInTargetOrPopover = true;
        // if we're entering the popover, and the mode is set to be HOVER_TARGET_ONLY, we want to manually
        // trigger the mouse leave event, as hovering over the popover shouldn't count.
        if (!this.props.usePortal && this.isElementInPopover(e.target) && this.props.interactionKind === (0, $0656ff6cfe9f702c$export$6c571fbf65f9c7a6).HOVER_TARGET_ONLY && !this.props.openOnTargetFocus) this.handleMouseLeave(e);
        else if (!this.props.disabled) // only begin opening popover when it is enabled
        this.setOpenState(true, e, this.props.hoverOpenDelay);
    };
    handleMouseLeave = (e)=>{
        this.isMouseInTargetOrPopover = false;
        // Wait until the event queue is flushed, because we want to leave the
        // popover open if the mouse entered the popover immediately after
        // leaving the target (or vice versa). Make sure to persist the event since
        // we need to access `nativeEvent` in `this.setOpenState()`.
        e.persist();
        this.setTimeout(()=>{
            if (this.isMouseInTargetOrPopover) return;
            // user-configurable closing delay is helpful when moving mouse from target to popover
            this.setOpenState(false, e, this.props.hoverCloseDelay);
        });
    };
    handlePopoverClick = (e)=>{
        const eventTarget = e.target;
        const eventPopover = eventTarget.closest(`.${(0, $2cfd35af7ec11fdd$exports).POPOVER}`);
        const eventPopoverV1 = eventTarget.closest(`.${(0, $2cfd35af7ec11fdd$exports).POPOVER}`);
        const isEventFromSelf = (eventPopover ?? eventPopoverV1) === this.getPopoverElement();
        const isEventPopoverCapturing = eventPopover?.classList.contains((0, $2cfd35af7ec11fdd$exports).POPOVER_CAPTURING_DISMISS) ?? eventPopoverV1?.classList.contains((0, $2cfd35af7ec11fdd$exports).POPOVER_CAPTURING_DISMISS) ?? false;
        // an OVERRIDE inside a DISMISS does not dismiss, and a DISMISS inside an OVERRIDE will dismiss.
        const dismissElement = eventTarget.closest(`.${(0, $2cfd35af7ec11fdd$exports).POPOVER_DISMISS}, .${(0, $2cfd35af7ec11fdd$exports).POPOVER_DISMISS_OVERRIDE}`);
        const shouldDismiss = dismissElement?.classList.contains((0, $2cfd35af7ec11fdd$exports).POPOVER_DISMISS) ?? false;
        const isDisabled = eventTarget.closest(`:disabled, .${(0, $2cfd35af7ec11fdd$exports).DISABLED}`) != null;
        if (shouldDismiss && !isDisabled && (!isEventPopoverCapturing || isEventFromSelf)) this.setOpenState(false, e);
    };
    handleOverlayClose = (e)=>{
        if (this.targetRef.current == null || e === undefined) return;
        const event = e.nativeEvent ?? e;
        const eventTarget = event.composed ? event.composedPath()[0] : event.target;
        // if click was in target, target event listener will handle things, so don't close
        const isKeyboardEvent = e.nativeEvent instanceof KeyboardEvent || e instanceof KeyboardEvent;
        if (!(0, $5f04c694ca05154e$exports).elementIsOrContains(this.targetRef.current, eventTarget) || isKeyboardEvent) this.setOpenState(false, e);
    };
    handleKeyDown = (e)=>{
        const isKeyboardClick = (0, $5f04c694ca05154e$exports).isKeyboardClick(e);
        // For keyboard accessibility, trigger the same behavior as a click event upon pressing ENTER/SPACE
        if (isKeyboardClick) this.handleTargetClick(e);
    };
    handleTargetClick = (e)=>{
        // Target element(s) may fire simulated click event upon pressing ENTER/SPACE, which we should ignore
        // see: https://github.com/palantir/blueprint/issues/5775
        const shouldIgnoreClick = this.state.isOpen && this.isSimulatedButtonClick(e);
        if (!shouldIgnoreClick) // ensure click did not originate from within inline popover before closing
        {
            if (!this.props.disabled && !this.isElementInPopover(e.target)) {
                if (this.props.isOpen == null) this.setState((prevState)=>({
                        isOpen: !prevState.isOpen
                    }));
                else this.setOpenState(!this.props.isOpen, e);
            }
        }
    };
    isSimulatedButtonClick = (e)=>{
        return !e.isTrusted && e.target.matches(`.${(0, $2cfd35af7ec11fdd$exports).BUTTON}`);
    };
    // a wrapper around setState({ isOpen }) that will call props.onInteraction instead when in controlled mode.
    // starts a timeout to delay changing the state if a non-zero duration is provided.
    setOpenState(isOpen, e, timeout) {
        // cancel any existing timeout because we have new state
        this.cancelOpenTimeout?.();
        if (timeout !== undefined && timeout > 0) {
            // Persist the react event since it will be used in a later macrotask.
            e?.persist();
            this.cancelOpenTimeout = this.setTimeout(()=>{
                this.setOpenState(isOpen, e);
            }, timeout);
        } else {
            if (this.props.isOpen == null) this.setState({
                isOpen: isOpen
            });
            else this.props.onInteraction?.(isOpen, e);
            if (!isOpen) {
                // non-null assertion because the only time `e` is undefined is when in controlled mode
                // or the rare special case in uncontrolled mode when the `disabled` flag is toggled true
                this.props.onClose?.(e);
                this.setState({
                    isClosingViaEscapeKeypress: $5ebb8a1948a3d723$var$isEscapeKeypressEvent(e?.nativeEvent)
                });
            }
        }
    }
    updateDarkParent() {
        if (this.props.usePortal && this.state.isOpen) {
            const hasDarkParent = this.targetRef.current?.closest(`.${(0, $2cfd35af7ec11fdd$exports).DARK}`) != null;
            this.setState({
                hasDarkParent: hasDarkParent
            });
        }
    }
    isElementInPopover(element) {
        return this.getPopoverElement()?.contains(element) ?? false;
    }
    getIsContentEmpty() {
        const { content: content } = this.props;
        return content == null || (0, $5f04c694ca05154e$exports).isEmptyString(content);
    }
}
function $5ebb8a1948a3d723$var$isElementTooltip(element) {
    return element?.type?.displayName === `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Tooltip`;
}
function $5ebb8a1948a3d723$var$isEscapeKeypressEvent(e) {
    return e instanceof KeyboardEvent && e.key === "Escape";
}
function $5ebb8a1948a3d723$var$noop() {
// no-op
}







const $1d0e64f739af1a0c$export$d9b273488cd8ce6f = (props)=>{
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    const { className: className, children: children, large: large, size: size = "medium", small: small, ulRef: ulRef, ...htmlProps } = props;
    return (0, $fc31e5e9fc16a880$exports.jsx)("ul", {
        role: "menu",
        ...htmlProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(className, (0, $2cfd35af7ec11fdd$exports).MENU, (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
            large: large,
            small: small
        })),
        ref: ulRef,
        children: children
    });
};
$1d0e64f739af1a0c$export$d9b273488cd8ce6f.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Menu`;


const $d3dc9af3e7961651$export$2ce376c2cc3355c8 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { active: active = false, className: className, children: children, disabled: disabled = false, icon: icon, intent: intent, labelClassName: labelClassName, labelElement: labelElement, multiline: multiline = false, popoverProps: popoverProps = {}, roleStructure: roleStructure = "menuitem", selected: selected, shouldDismissPopover: shouldDismissPopover = true, submenuProps: submenuProps, text: text = "", textClassName: textClassName, tagName: tagName = "a", htmlTitle: htmlTitle, ...htmlProps } = props;
    const [liRole, targetRole, ariaSelected] = roleStructure === "listoption" // "listoption": parent has listbox role, or is a <select>
     ? [
        "option",
        undefined,
        Boolean(selected)
    ] : roleStructure === "menuitem" // "menuitem": parent has menu role
     ? [
        "none",
        "menuitem",
        undefined
    ] : roleStructure === "none" // "none": allows wrapping MenuItem in custom <li>
     ? [
        "none",
        undefined,
        undefined
    ] : [
        undefined,
        undefined,
        undefined
    ];
    const isSelectable = roleStructure === "listoption";
    const isSelected = isSelectable && selected;
    const hasIcon = icon != null;
    const hasSubmenu = children != null;
    const intentClass = (0, $2cfd35af7ec11fdd$exports).intentClass(intent);
    const anchorClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).MENU_ITEM, intentClass, {
        [(0, $2cfd35af7ec11fdd$exports).ACTIVE]: active,
        [(0, $2cfd35af7ec11fdd$exports).DISABLED]: disabled,
        // prevent popover from closing when clicking on submenu trigger or disabled item
        [(0, $2cfd35af7ec11fdd$exports).POPOVER_DISMISS]: shouldDismissPopover && !disabled && !hasSubmenu,
        [(0, $2cfd35af7ec11fdd$exports).MENU_ITEM_IS_SELECTABLE]: isSelectable,
        [(0, $2cfd35af7ec11fdd$exports).SELECTED]: isSelected
    }, className);
    const maybeLabel = props.label == null && labelElement == null ? null : (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).MENU_ITEM_LABEL, labelClassName),
        children: [
            props.label,
            labelElement
        ]
    });
    const htmlPropsOnly = (0, $b898cefa02f59fb9$export$962dd23b3e663274)(htmlProps);
    const target = (0, $kYL7Z.createElement)(tagName, {
        // for menuitems, onClick when enter key pressed doesn't take effect like it does for a button-- fix this
        onKeyDown: (0, $5f6dd9e57dfd2e30$export$d429894ed4cff305)([
            "Enter",
            " "
        ]),
        // if hasSubmenu, must apply correct role and tabIndex to the outer popover target <span> instead of this target element
        role: hasSubmenu ? "none" : targetRole,
        ...htmlPropsOnly,
        tabIndex: hasSubmenu ? -1 : htmlPropsOnly.tabIndex != null ? htmlPropsOnly.tabIndex : 0,
        ...disabled ? $d3dc9af3e7961651$var$DISABLED_PROPS : {},
        className: anchorClasses
    }, isSelected ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $154f92b720f0daf8$export$4f10daf60b914288), {
        className: (0, $2cfd35af7ec11fdd$exports).MENU_ITEM_SELECTED_ICON
    }) : undefined, hasIcon ? // wrap icon in a <span> in case `icon` is a custom element rather than a built-in icon identifier,
    // so that we always render this class and hide it from a screen reader
    (0, $fc31e5e9fc16a880$exports.jsx)("span", {
        className: (0, $2cfd35af7ec11fdd$exports).MENU_ITEM_ICON,
        "aria-hidden": true,
        children: (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
            icon: icon,
            tabIndex: -1
        })
    }) : undefined, (0, $fc31e5e9fc16a880$exports.jsx)((0, $51dde1f29cbe0fd9$export$5f1af8db9871e1d6), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).FILL, textClassName),
        ellipsize: !multiline,
        title: htmlTitle,
        children: text
    }), maybeLabel, hasSubmenu ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $7879b1e0779e0db7$export$98ac0f496a0846de), {
        className: (0, $2cfd35af7ec11fdd$exports).MENU_SUBMENU_ICON,
        title: "Open sub menu"
    }) : undefined);
    const liClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))({
        [(0, $2cfd35af7ec11fdd$exports).MENU_SUBMENU]: hasSubmenu
    });
    return (0, $fc31e5e9fc16a880$exports.jsx)("li", {
        className: liClasses,
        ref: ref,
        role: liRole,
        "aria-selected": ariaSelected,
        children: children == null ? target : (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            // eslint-disable-next-line jsx-a11y/no-autofocus -- intentionally disabled
            autoFocus: false,
            captureDismiss: false,
            disabled: disabled,
            enforceFocus: false,
            hoverCloseDelay: 0,
            interactionKind: "hover",
            modifiers: $d3dc9af3e7961651$var$SUBMENU_POPOVER_MODIFIERS,
            targetProps: {
                role: targetRole,
                tabIndex: 0
            },
            placement: "right-start",
            usePortal: false,
            ...popoverProps,
            content: (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                ...submenuProps,
                children: children
            }),
            minimal: true,
            popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).MENU_SUBMENU, popoverProps?.popoverClassName),
            children: target
        })
    });
});
$d3dc9af3e7961651$export$2ce376c2cc3355c8.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.MenuItem`;
const $d3dc9af3e7961651$var$SUBMENU_POPOVER_MODIFIERS = {
    // 20px padding - scrollbar width + a bit
    flip: {
        enabled: true,
        options: {
            padding: 20,
            rootBoundary: "viewport"
        }
    },
    // shift popover up 5px so MenuItems align
    offset: {
        enabled: true,
        options: {
            offset: [
                -5,
                0
            ]
        }
    },
    preventOverflow: {
        enabled: true,
        options: {
            padding: 20,
            rootBoundary: "viewport"
        }
    }
};
// props to ignore when disabled
const $d3dc9af3e7961651$var$DISABLED_PROPS = {
    "aria-disabled": true,
    href: undefined,
    onClick: undefined,
    onMouseDown: undefined,
    onMouseEnter: undefined,
    onMouseLeave: undefined,
    tabIndex: -1
};





var $kYL7Z = parcelRequire("kYL7Z");



var $kYL7Z = parcelRequire("kYL7Z");






class $dfdeb9f3093918f4$export$bc10c55cb47bf894 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.AsyncControllableInput`;
    /**
     * The amount of time (in milliseconds) which the input will wait after a compositionEnd event before
     * unlocking its state value for external updates via props. See `handleCompositionEnd` for more details.
     */ static COMPOSITION_END_DELAY = 10;
    state = {
        hasPendingUpdate: false,
        isComposing: false,
        nextValue: this.props.value,
        value: this.props.value
    };
    cancelPendingCompositionEnd = null;
    static getDerivedStateFromProps(nextProps, nextState) {
        if (nextState.isComposing || nextProps.value === undefined) // don't derive anything from props if:
        // - in uncontrolled mode, OR
        // - currently composing, since we'll do that after composition ends
        return null;
        const userTriggeredUpdate = nextState.nextValue !== nextState.value;
        if (userTriggeredUpdate) {
            if (nextProps.value === nextState.nextValue) {
                // parent has processed and accepted our update
                if (nextState.hasPendingUpdate) return {
                    hasPendingUpdate: false,
                    value: nextProps.value
                };
                else return {
                    value: nextState.nextValue
                };
            } else {
                if (nextProps.value === nextState.value) // we have sent the update to our parent, but it has not been processed yet. just wait.
                // DO NOT set nextValue here, since that will temporarily render a potentially stale controlled value,
                // causing the cursor to jump once the new value is accepted
                return {
                    hasPendingUpdate: true
                };
                // accept controlled update overriding user action
                return {
                    hasPendingUpdate: false,
                    nextValue: nextProps.value,
                    value: nextProps.value
                };
            }
        } else // accept controlled update, could be confirming or denying user action
        return {
            hasPendingUpdate: false,
            nextValue: nextProps.value,
            value: nextProps.value
        };
    }
    render() {
        const { isComposing: isComposing, hasPendingUpdate: hasPendingUpdate, value: value, nextValue: nextValue } = this.state;
        const { inputRef: inputRef, ...restProps } = this.props;
        return (0, $fc31e5e9fc16a880$exports.jsx)("input", {
            ...restProps,
            ref: inputRef,
            // render the pending value even if it is not confirmed by a parent's async controlled update
            // so that the cursor does not jump to the end of input as reported in
            // https://github.com/palantir/blueprint/issues/4298
            value: isComposing || hasPendingUpdate ? nextValue : value,
            onCompositionStart: this.handleCompositionStart,
            onCompositionEnd: this.handleCompositionEnd,
            onChange: this.handleChange
        });
    }
    handleCompositionStart = (e)=>{
        this.cancelPendingCompositionEnd?.();
        this.setState({
            isComposing: true
        });
        this.props.onCompositionStart?.(e);
    };
    handleCompositionEnd = (e)=>{
        // In some non-latin languages, a keystroke can end a composition event and immediately afterwards start another.
        // This can lead to unexpected characters showing up in the text input. In order to circumvent this problem, we
        // use a timeout which creates a delay which merges the two composition events, creating a more natural and predictable UX.
        // `this.state.nextValue` will become "locked" (it cannot be overwritten by the `value` prop) until a delay (10ms) has
        // passed without a new composition event starting.
        this.cancelPendingCompositionEnd = this.setTimeout(()=>this.setState({
                isComposing: false
            }), $dfdeb9f3093918f4$export$bc10c55cb47bf894.COMPOSITION_END_DELAY);
        this.props.onCompositionEnd?.(e);
    };
    handleChange = (e)=>{
        const { value: value } = e.target;
        this.setState({
            nextValue: value
        });
        this.props.onChange?.(e);
    };
}


const $35acf471a14b7dad$var$NON_HTML_PROPS = [
    "inputSize",
    "onValueChange"
];
class $35acf471a14b7dad$export$6e5a9cd40e0c9b97 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.InputGroup`;
    state = {};
    leftElement = null;
    rightElement = null;
    refHandlers = {
        leftElement: (ref)=>this.leftElement = ref,
        rightElement: (ref)=>this.rightElement = ref
    };
    render() {
        const { asyncControl: asyncControl = false, className: className, disabled: disabled, fill: fill, inputClassName: inputClassName, inputRef: inputRef, inputSize: inputSize, intent: intent, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
        large, readOnly: readOnly, round: round, size: size = "medium", small: // eslint-disable-next-line @typescript-eslint/no-deprecated
        small, tagName: tagName = "div" } = this.props;
        const inputGroupClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).INPUT_GROUP, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), {
            [(0, $2cfd35af7ec11fdd$exports).DISABLED]: disabled,
            [(0, $2cfd35af7ec11fdd$exports).READ_ONLY]: readOnly,
            [(0, $2cfd35af7ec11fdd$exports).FILL]: fill,
            [(0, $2cfd35af7ec11fdd$exports).ROUND]: round
        }, (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
            large: large,
            small: small
        }), className);
        const style = {
            ...this.props.style,
            paddingLeft: this.state.leftElementWidth,
            paddingRight: this.state.rightElementWidth
        };
        const inputProps = {
            type: "text",
            ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(this.props, $35acf471a14b7dad$var$NON_HTML_PROPS, true),
            "aria-disabled": disabled,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).INPUT, inputClassName),
            onChange: this.handleInputChange,
            size: inputSize,
            style: style
        };
        const inputElement = asyncControl ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $dfdeb9f3093918f4$export$bc10c55cb47bf894), {
            ...inputProps,
            inputRef: inputRef
        }) : (0, $fc31e5e9fc16a880$exports.jsx)("input", {
            ...inputProps,
            ref: inputRef
        });
        return (0, $kYL7Z.createElement)(tagName, {
            className: inputGroupClasses
        }, this.maybeRenderLeftElement(), inputElement, this.maybeRenderRightElement());
    }
    componentDidMount() {
        this.updateInputWidth();
    }
    componentDidUpdate(prevProps) {
        const { leftElement: leftElement, rightElement: rightElement } = this.props;
        if (prevProps.leftElement !== leftElement || prevProps.rightElement !== rightElement) this.updateInputWidth();
    }
    validateProps(props) {
        if (props.leftElement != null && props.leftIcon != null) console.warn((0, $5bed6f2a5e88b283$export$7dcc26c4d745a6de));
    }
    handleInputChange = (event)=>{
        const value = event.target.value;
        this.props.onChange?.(event);
        this.props.onValueChange?.(value, event.target);
    };
    maybeRenderLeftElement() {
        const { leftElement: leftElement, leftIcon: leftIcon } = this.props;
        if (leftElement != null) return (0, $fc31e5e9fc16a880$exports.jsx)("span", {
            className: (0, $2cfd35af7ec11fdd$exports).INPUT_LEFT_CONTAINER,
            ref: this.refHandlers.leftElement,
            children: leftElement
        });
        else if (leftIcon != null) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
            icon: leftIcon,
            "aria-hidden": true,
            tabIndex: -1
        });
        return undefined;
    }
    maybeRenderRightElement() {
        const { rightElement: rightElement } = this.props;
        if (rightElement == null) return undefined;
        return (0, $fc31e5e9fc16a880$exports.jsx)("span", {
            className: (0, $2cfd35af7ec11fdd$exports).INPUT_ACTION,
            ref: this.refHandlers.rightElement,
            children: rightElement
        });
    }
    updateInputWidth() {
        const { leftElementWidth: leftElementWidth, rightElementWidth: rightElementWidth } = this.state;
        if (this.leftElement != null) {
            const { clientWidth: clientWidth } = this.leftElement;
            // small threshold to prevent infinite loops
            if (leftElementWidth === undefined || Math.abs(clientWidth - leftElementWidth) > 2) this.setState({
                leftElementWidth: clientWidth
            });
        } else this.setState({
            leftElementWidth: undefined
        });
        if (this.rightElement != null) {
            const { clientWidth: clientWidth } = this.rightElement;
            // small threshold to prevent infinite loops
            if (rightElementWidth === undefined || Math.abs(clientWidth - rightElementWidth) > 2) this.setState({
                rightElementWidth: clientWidth
            });
        } else this.setState({
            rightElementWidth: undefined
        });
    }
}

/*
 * Copyright 2021 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Specifies the popup kind for [aria-haspopup](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-haspopup).
 */ var $da7063ee0db80208$export$4d5c295289e9b3bf;
(function(PopupKind) {
    /** The popup is a menu. */ PopupKind["MENU"] = "menu";
    /** The popup is a listbox. */ PopupKind["LISTBOX"] = "listbox";
    /** The popup is a tree. */ PopupKind["TREE"] = "tree";
    /** The popup is a grid. */ PopupKind["GRID"] = "grid";
    /** The popup is a dialog. */ PopupKind["DIALOG"] = "dialog";
})($da7063ee0db80208$export$4d5c295289e9b3bf || ($da7063ee0db80208$export$4d5c295289e9b3bf = {}));




var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $d5a01f31f7e06d3b$export$3c877bb842c36952 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "cross",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M228.2 200L314 285.8C317.8 289.4 320 294.4 320 300C320 311 311 320 300 320C294.4000000000001 320 289.4000000000001 317.8 285.8 314.2L200 228.2L114.2 314.2C110.6 317.8 105.6 320 100 320C89 320 80 311 80 300C80 294.4 82.2 289.4 85.8 285.8L171.8 200L86 114.2000000000001C82.2 110.6 80 105.6 80 100C80 89 89 80 100 80C105.6 80 110.6 82.2 114.2 85.8L200 171.8L285.8 86C289.4000000000001 82.2 294.4000000000001 80 300 80C311 80 320 89 320 100C320 105.6 317.8 110.6 314.2000000000001 114.2000000000001L228.2 200z" : "M188.2 160L254 225.8C257.8 229.4 260 234.4 260 240C260 251 251 260 240 260C234.4 260 229.4 257.8 225.8 254.2L160 188.2L94.2 254.2C90.6 257.8 85.6 260 80 260C69 260 60 251 60 240C60 234.4 62.2 229.4 65.8 225.8L131.8 160L66 94.2C62.2 90.6 60 85.6 60 80C60 69 69 60 80 60C85.6 60 90.6 62.2 94.2 65.8L160 131.8L225.8 66C229.4 62.2 234.4 60 240 60C251 60 260 69 260 80C260 85.6 257.8 90.6 254.2 94.2L188.2 160z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$d5a01f31f7e06d3b$export$3c877bb842c36952.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$d5a01f31f7e06d3b$export$3c877bb842c36952.displayName = `Blueprint6.Icon.Cross`;
var $d5a01f31f7e06d3b$export$2e2bcd8739ae039 = $d5a01f31f7e06d3b$export$3c877bb842c36952;



var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $86c7da1d2a30830f$export$4b85d3515bd863a5 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "search",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M391.2 51.2L292.4 150C309.8 175.8 320 206.6 320 240C320 328.4 248.4 400 160 400S0 328.4 0 240S71.6 80 160 80C193.4 80 224.2 90.2 250 107.6L348.8 8.8C354.2000000000001 3.4 361.8 0 370 0C386.6 0 400 13.4 400 30C400 38.2 396.6 45.8 391.2 51.2zM160 120C93.8 120 40 173.8 40 240S93.8 360 160 360S280 306.2000000000001 280 240S226.2 120 160 120z" : "M311 51.4L257.6 105C271.6 126.8 279.8 152.6 279.8 180.2C279.8 257.6 217.2 320.2 139.8 320.2S-0.2 257.6 -0.2 180.2S62.4 40.2 139.8 40.2C167.6 40.2 193.4 48.6 215 62.4L268.6 9C274 3.6 281.6 0.2 289.8 0.2C306.4 0.2 319.8 13.6 319.8 30.2C319.8 38.4 316.4 46 311 51.4zM139.8 80.2C84.6 80.2 39.8 125 39.8 180.2S84.6 280.2 139.8 280.2S239.8 235.4 239.8 180.2S195 80.2 139.8 80.2z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$86c7da1d2a30830f$export$4b85d3515bd863a5.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$86c7da1d2a30830f$export$4b85d3515bd863a5.displayName = `Blueprint6.Icon.Search`;
var $86c7da1d2a30830f$export$2e2bcd8739ae039 = $86c7da1d2a30830f$export$4b85d3515bd863a5;


var $27a0f3536dedad79$exports = {};

$parcel$export($27a0f3536dedad79$exports, "MULTISELECT", () => $27a0f3536dedad79$export$bba0e784b747d8d7);
$parcel$export($27a0f3536dedad79$exports, "MULTISELECT_POPOVER", () => $27a0f3536dedad79$export$fbebd36a6deaeedb);
$parcel$export($27a0f3536dedad79$exports, "MULTISELECT_POPOVER_DEFAULT_WIDTH", () => $27a0f3536dedad79$export$3be7a20687e6432a);
$parcel$export($27a0f3536dedad79$exports, "MULTISELECT_POPOVER_TAG_INPUT_MARGIN", () => $27a0f3536dedad79$export$a713dbd098a9a82f);
$parcel$export($27a0f3536dedad79$exports, "MULTISELECT_TAG_INPUT_INPUT", () => $27a0f3536dedad79$export$473396dff47d182f);
$parcel$export($27a0f3536dedad79$exports, "OMNIBAR", () => $27a0f3536dedad79$export$4df213ae3a2d0138);
$parcel$export($27a0f3536dedad79$exports, "OMNIBAR_OVERLAY", () => $27a0f3536dedad79$export$13ef787e18d22080);
$parcel$export($27a0f3536dedad79$exports, "SELECT_POPOVER", () => $27a0f3536dedad79$export$77109d4160ed3ec7);
$parcel$export($27a0f3536dedad79$exports, "SUGGEST_POPOVER", () => $27a0f3536dedad79$export$afb47d2c172a4cf);
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
const $27a0f3536dedad79$var$NS = (0, $2cfd35af7ec11fdd$exports).getClassNamespace();
const $27a0f3536dedad79$export$bba0e784b747d8d7 = `${$27a0f3536dedad79$var$NS}-multi-select`;
const $27a0f3536dedad79$export$fbebd36a6deaeedb = `${$27a0f3536dedad79$export$bba0e784b747d8d7}-popover`;
const $27a0f3536dedad79$export$3be7a20687e6432a = `${$27a0f3536dedad79$export$bba0e784b747d8d7}-popover-default-width`;
const $27a0f3536dedad79$export$a713dbd098a9a82f = `${$27a0f3536dedad79$export$bba0e784b747d8d7}-popover-tag-input-margin`;
const $27a0f3536dedad79$export$473396dff47d182f = `${$27a0f3536dedad79$export$bba0e784b747d8d7}-tag-input-input`;
const $27a0f3536dedad79$export$4df213ae3a2d0138 = `${$27a0f3536dedad79$var$NS}-omnibar`;
const $27a0f3536dedad79$export$13ef787e18d22080 = `${$27a0f3536dedad79$export$4df213ae3a2d0138}-overlay`;
const $27a0f3536dedad79$export$77109d4160ed3ec7 = `${$27a0f3536dedad79$var$NS}-select-popover`;
const $27a0f3536dedad79$export$afb47d2c172a4cf = `${$27a0f3536dedad79$var$NS}-suggest-popover`;



/*
 * Copyright 2019 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

class $59a32f4549faf3b7$export$ca6a3753167de7aa extends (0, $kYL7Z.Component) {
    // unsafe lifecycle methods
    componentWillUpdate;
    componentWillReceiveProps;
    componentWillMount;
    // this should be static, not an instance method
    getDerivedStateFromProps;
    /** Component displayName should be `public static`. This property exists to prevent incorrect usage. */ displayName;
    // Not bothering to remove entries when their timeouts finish because clearing invalid ID is a no-op
    timeoutIds = [];
    requestIds = [];
    constructor(props){
        super(props);
        if (!(0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) this.validateProps(this.props);
    }
    componentDidUpdate(_prevProps, _prevState, _snapshot) {
        if (!(0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) this.validateProps(this.props);
    }
    componentWillUnmount() {
        this.clearTimeouts();
        this.cancelAnimationFrames();
    }
    /**
     * Request an animation frame and remember its ID.
     * All pending requests will be canceled when component unmounts.
     *
     * @returns a "cancel" function that will cancel the request when invoked.
     */ requestAnimationFrame(callback) {
        const handle = window.requestAnimationFrame(callback);
        this.requestIds.push(handle);
        return ()=>window.cancelAnimationFrame(handle);
    }
    /**
     * Set a timeout and remember its ID.
     * All stored timeouts will be cleared when component unmounts.
     *
     * @returns a "cancel" function that will clear timeout when invoked.
     */ setTimeout(callback, timeout) {
        const handle = window.setTimeout(callback, timeout);
        this.timeoutIds.push(handle);
        return ()=>window.clearTimeout(handle);
    }
    /**
     * Clear all known timeouts.
     */ clearTimeouts = ()=>{
        if (this.timeoutIds.length > 0) {
            for (const timeoutId of this.timeoutIds)window.clearTimeout(timeoutId);
            this.timeoutIds = [];
        }
    };
    /**
     * Clear all known animation frame requests.
     */ cancelAnimationFrames = ()=>{
        if (this.requestIds.length > 0) {
            for (const requestId of this.requestIds)window.cancelAnimationFrame(requestId);
            this.requestIds = [];
        }
    };
    /**
     * Ensures that the props specified for a component are valid.
     * Implementations should check that props are valid and usually throw an Error if they are not.
     * Implementations should not duplicate checks that the type system already guarantees.
     *
     * This method should be used instead of React's
     * [propTypes](https://facebook.github.io/react/docs/reusable-components.html#prop-validation) feature.
     * Like propTypes, these runtime checks run only in development mode.
     */ validateProps(_props) {
    // implement in subclass
    }
}


/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $daced99e67c1a25d$export$4dd70a7c4549164b(itemsEqualProp, itemA, itemB) {
    // Use strict equality if:
    // A) Default equality check is necessary because itemsEqualProp is undefined.
    // OR
    // B) Either item is null/undefined. Note that null represents "no item", while
    //    undefined represents an uncontrolled prop. This strict equality check ensures
    //    nothing will ever be considered equivalent to an uncontrolled prop.
    if (itemsEqualProp === undefined || itemA == null || itemB == null) return itemA === itemB;
    if ((0, $5f04c694ca05154e$exports).isFunction(itemsEqualProp)) // itemsEqualProp is an equality comparator function, so use it
    return itemsEqualProp(itemA, itemB);
    else // itemsEqualProp is a property name, so strictly compare the values of the property.
    return itemA[itemsEqualProp] === itemB[itemsEqualProp];
}

/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns an instance of a "Create Item" object. */ function $f77e07cd2c03b3cc$export$3af999347d244081() {
    return {
        __blueprintCreateNewItemBrand: "blueprint-create-new-item"
    };
}
function $f77e07cd2c03b3cc$export$34f76065d3c0d679(item) {
    if (item == null) return false;
    // see if the provided item exactly matches the `CreateNewItem` object,
    // with no superfluous keys.
    const keys = Object.keys(item);
    if (keys.length !== 1 || keys[0] !== "__blueprintCreateNewItemBrand") return false;
    return item.__blueprintCreateNewItemBrand === "blueprint-create-new-item";
}
function $f77e07cd2c03b3cc$export$f0f14253205ef68f(activeItem) {
    return activeItem == null || $f77e07cd2c03b3cc$export$34f76065d3c0d679(activeItem) ? null : activeItem;
}

/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ItemListRenderer` helper method for rendering each item in `filteredItems`,
 * with optional support for `noResults` (when filtered items is empty)
 * and `initialContent` (when query is empty).
 */ function $377e6a29abf27839$export$f58d484c96d9e9e6(props, noResults, initialContent) {
    if (props.query.length === 0 && initialContent !== undefined) return initialContent;
    const items = props.filteredItems.map(props.renderItem).filter((item)=>item != null);
    return items.length > 0 ? items : noResults;
}


class $bd0ad1ca6092f56b$export$53fc189dda010966 extends (0, $59a32f4549faf3b7$export$ca6a3753167de7aa) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.QueryList`;
    static defaultProps = {
        disabled: false,
        resetOnQuery: true
    };
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ static ofType() {
        return $bd0ad1ca6092f56b$export$53fc189dda010966;
    }
    itemsParentRef;
    itemRefs = new Map();
    listId;
    refHandlers = {
        itemsParent: (ref)=>this.itemsParentRef = ref
    };
    /**
     * Flag indicating that we should check whether selected item is in viewport
     * after rendering, typically because of keyboard change. Set to `true` when
     * manipulating state in a way that may cause active item to scroll away.
     */ shouldCheckActiveItemInViewport = false;
    /**
     * The item that we expect to be the next selected active item (based on click
     * or key interactions). When scrollToActiveItem = false, used to detect if
     * an unexpected external change to the active item has been made.
     */ expectedNextActiveItem = null;
    /**
     * Flag which is set to true while in between an ENTER "keydown" event and its
     * corresponding "keyup" event.
     *
     * When entering text via an IME (https://en.wikipedia.org/wiki/Input_method),
     * the ENTER key is pressed to confirm the character(s) to be input from a list
     * of options. The operating system intercepts the ENTER "keydown" event and
     * prevents it from propagating to the application, but "keyup" is still
     * fired, triggering a spurious event which this component does not expect.
     *
     * To work around this quirk, we keep track of "real" key presses by setting
     * this flag in handleKeyDown.
     */ isEnterKeyPressed = false;
    constructor(props){
        super(props);
        // Generate unique ID for accessibility
        this.listId = props.listId ?? (0, $5f04c694ca05154e$exports).uniqueId("bp-query-list");
        const { query: query = "" } = props;
        const createNewItem = props.createNewItemFromQuery?.(query);
        const filteredItems = $bd0ad1ca6092f56b$var$getFilteredItems(query, props);
        this.state = {
            activeItem: props.activeItem !== undefined ? props.activeItem : props.initialActiveItem ?? $bd0ad1ca6092f56b$export$db4cfd88d8087392(filteredItems, props.itemDisabled),
            createNewItem: createNewItem,
            filteredItems: filteredItems,
            query: query
        };
    }
    render() {
        const { className: className, items: items, renderer: renderer, itemListRenderer: itemListRenderer = this.renderItemList, menuProps: menuProps } = this.props;
        const { createNewItem: createNewItem, ...spreadableState } = this.state;
        // Generate ID for active item
        const activeItemId = this.getActiveItemId();
        return renderer({
            ...spreadableState,
            activeItemId: activeItemId,
            className: className,
            handleItemSelect: this.handleItemSelect,
            handleKeyDown: this.handleKeyDown,
            handleKeyUp: this.handleKeyUp,
            handlePaste: this.handlePaste,
            handleQueryChange: this.handleInputQueryChange,
            itemList: itemListRenderer({
                ...spreadableState,
                items: items,
                itemsParentRef: this.refHandlers.itemsParent,
                menuProps: {
                    ...menuProps,
                    id: this.listId
                },
                renderCreateItem: this.renderCreateItemMenuItem,
                renderItem: this.renderItem
            }),
            listId: this.listId
        });
    }
    componentDidUpdate(prevProps) {
        if (this.props.activeItem !== undefined && this.props.activeItem !== this.state.activeItem) {
            this.shouldCheckActiveItemInViewport = true;
            this.setState({
                activeItem: this.props.activeItem
            });
        }
        if (this.props.query != null && this.props.query !== prevProps.query) // new query
        this.setQuery(this.props.query, this.props.resetOnQuery, this.props);
        else if (// same query (or uncontrolled query), but items in the list changed
        !(0, $5f04c694ca05154e$exports).shallowCompareKeys(this.props, prevProps, {
            include: [
                "items",
                "itemListPredicate",
                "itemPredicate"
            ]
        })) this.setQuery(this.state.query);
        if (this.shouldCheckActiveItemInViewport) {
            // update scroll position immediately before repaint so DOM is accurate
            // (latest filteredItems) and to avoid flicker.
            this.requestAnimationFrame(()=>this.scrollActiveItemIntoView());
            // reset the flag
            this.shouldCheckActiveItemInViewport = false;
        }
    }
    scrollActiveItemIntoView() {
        const scrollToActiveItem = this.props.scrollToActiveItem !== false;
        const externalChangeToActiveItem = !(0, $daced99e67c1a25d$export$4dd70a7c4549164b)(this.props.itemsEqual, (0, $f77e07cd2c03b3cc$export$f0f14253205ef68f)(this.expectedNextActiveItem), (0, $f77e07cd2c03b3cc$export$f0f14253205ef68f)(this.props.activeItem));
        this.expectedNextActiveItem = null;
        if (!scrollToActiveItem && externalChangeToActiveItem) return;
        const activeElement = this.getActiveElement();
        if (this.itemsParentRef != null && activeElement != null) {
            const { offsetTop: activeTop, offsetHeight: activeHeight } = activeElement;
            const { offsetTop: parentOffsetTop, scrollTop: parentScrollTop, clientHeight: parentHeight } = this.itemsParentRef;
            // compute padding on parent element to ensure we always leave space
            const { paddingTop: paddingTop, paddingBottom: paddingBottom } = this.getItemsParentPadding();
            // compute the two edges of the active item for comparison, including parent padding
            const activeBottomEdge = activeTop + activeHeight + paddingBottom - parentOffsetTop;
            const activeTopEdge = activeTop - paddingTop - parentOffsetTop;
            if (activeBottomEdge >= parentScrollTop + parentHeight) // offscreen bottom: align bottom of item with bottom of viewport
            this.itemsParentRef.scrollTop = activeBottomEdge + activeHeight - parentHeight;
            else if (activeTopEdge <= parentScrollTop) // offscreen top: align top of item with top of viewport
            this.itemsParentRef.scrollTop = activeTopEdge - activeHeight;
        }
    }
    setQuery(query, resetActiveItem = this.props.resetOnQuery, props = this.props) {
        const { createNewItemFromQuery: createNewItemFromQuery } = props;
        this.shouldCheckActiveItemInViewport = true;
        const hasQueryChanged = query !== this.state.query;
        if (hasQueryChanged) props.onQueryChange?.(query);
        // Leading and trailing whitespace can be confusing to display, so we remove it when passing it
        // to functions dealing with data, like createNewItemFromQuery. But we need the unaltered user-typed
        // query to remain in state to be able to render controlled text inputs properly.
        const trimmedQuery = query.trim();
        const filteredItems = $bd0ad1ca6092f56b$var$getFilteredItems(trimmedQuery, props);
        const createNewItem = createNewItemFromQuery != null && trimmedQuery !== "" ? createNewItemFromQuery(trimmedQuery) : undefined;
        this.setState({
            createNewItem: createNewItem,
            filteredItems: filteredItems,
            query: query
        });
        // always reset active item if it's now filtered or disabled
        const activeIndex = this.getActiveIndex(filteredItems);
        const shouldUpdateActiveItem = resetActiveItem || activeIndex < 0 || $bd0ad1ca6092f56b$var$isItemDisabled((0, $f77e07cd2c03b3cc$export$f0f14253205ef68f)(this.state.activeItem), activeIndex, props.itemDisabled);
        if (shouldUpdateActiveItem) {
            // if the `createNewItem` is first, that should be the first active item.
            if (this.isCreateItemRendered(createNewItem) && this.isCreateItemFirst()) this.setActiveItem((0, $f77e07cd2c03b3cc$export$3af999347d244081)());
            else this.setActiveItem($bd0ad1ca6092f56b$export$db4cfd88d8087392(filteredItems, props.itemDisabled));
        }
    }
    setActiveItem(activeItem) {
        this.expectedNextActiveItem = activeItem;
        if (this.props.activeItem === undefined) {
            // indicate that the active item may need to be scrolled into view after update.
            this.shouldCheckActiveItemInViewport = true;
            this.setState({
                activeItem: activeItem
            });
        }
        if ((0, $f77e07cd2c03b3cc$export$34f76065d3c0d679)(activeItem)) this.props.onActiveItemChange?.(null, true);
        else this.props.onActiveItemChange?.(activeItem, false);
    }
    /** default `itemListRenderer` implementation */ renderItemList = (listProps)=>{
        const { initialContent: initialContent, noResults: noResults } = this.props;
        // omit noResults if createNewItemFromQuery and createNewItemRenderer are both supplied, and query is not empty
        const createItemView = listProps.renderCreateItem();
        const maybeNoResults = createItemView != null ? null : noResults;
        const menuContent = (0, $377e6a29abf27839$export$f58d484c96d9e9e6)(listProps, maybeNoResults, initialContent);
        if (menuContent == null && createItemView == null) return null;
        const createFirst = this.isCreateItemFirst();
        return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
            role: "listbox",
            ...listProps.menuProps,
            ulRef: listProps.itemsParentRef,
            children: [
                createFirst && createItemView,
                menuContent,
                !createFirst && createItemView
            ]
        });
    };
    /** wrapper around `itemRenderer` to inject props */ renderItem = (item, index)=>{
        if (this.props.disabled !== true) {
            const { activeItem: activeItem, query: query, filteredItems: filteredItems } = this.state;
            const modifiers = {
                active: (0, $daced99e67c1a25d$export$4dd70a7c4549164b)(this.props.itemsEqual, (0, $f77e07cd2c03b3cc$export$f0f14253205ef68f)(activeItem), item),
                disabled: $bd0ad1ca6092f56b$var$isItemDisabled(item, index, this.props.itemDisabled),
                matchesPredicate: filteredItems.indexOf(item) >= 0
            };
            // Generate accessibility attributes
            const itemId = `${this.listId}-item-${index}`;
            return this.props.itemRenderer(item, {
                handleClick: (e)=>this.handleItemSelect(item, e),
                handleFocus: ()=>this.setActiveItem(item),
                id: itemId,
                index: index,
                modifiers: modifiers,
                query: query,
                ref: (node)=>{
                    if (node) this.itemRefs.set(index, node);
                    else this.itemRefs.delete(index);
                }
            });
        }
        return null;
    };
    renderCreateItemMenuItem = ()=>{
        if (this.isCreateItemRendered(this.state.createNewItem)) {
            const { activeItem: activeItem, query: query } = this.state;
            const trimmedQuery = query.trim();
            const handleClick = (evt)=>{
                this.handleItemCreate(trimmedQuery, evt);
            };
            const isActive = (0, $f77e07cd2c03b3cc$export$34f76065d3c0d679)(activeItem);
            return this.props.createNewItemRenderer(trimmedQuery, isActive, handleClick);
        }
        return null;
    };
    getActiveElement() {
        const { activeItem: activeItem } = this.state;
        if (this.itemsParentRef != null) {
            if ((0, $f77e07cd2c03b3cc$export$34f76065d3c0d679)(activeItem)) {
                const index = this.isCreateItemFirst() ? 0 : this.state.filteredItems.length;
                return this.itemsParentRef.children.item(index);
            } else {
                const activeIndex = this.getActiveIndex();
                return this.itemRefs.get(activeIndex) ?? this.itemsParentRef.children.item(activeIndex);
            }
        }
        return undefined;
    }
    getActiveIndex(items = this.state.filteredItems) {
        const { activeItem: activeItem } = this.state;
        if (activeItem == null || (0, $f77e07cd2c03b3cc$export$34f76065d3c0d679)(activeItem)) return -1;
        // NOTE: this operation is O(n) so it should be avoided in render(). safe for events though.
        for(let i = 0; i < items.length; ++i){
            if ((0, $daced99e67c1a25d$export$4dd70a7c4549164b)(this.props.itemsEqual, items[i], activeItem)) return i;
        }
        return -1;
    }
    getItemsParentPadding() {
        // assert ref exists because it was checked before calling
        const { paddingTop: paddingTop, paddingBottom: paddingBottom } = getComputedStyle(this.itemsParentRef);
        return {
            paddingBottom: $bd0ad1ca6092f56b$var$pxToNumber(paddingBottom),
            paddingTop: $bd0ad1ca6092f56b$var$pxToNumber(paddingTop)
        };
    }
    handleItemCreate = (query, evt)=>{
        // we keep a cached createNewItem in state, but might as well recompute
        // the result just to be sure it's perfectly in sync with the query.
        const value = this.props.createNewItemFromQuery?.(query);
        if (value != null) {
            const newItems = Array.isArray(value) ? value : [
                value
            ];
            for (const item of newItems)this.props.onItemSelect?.(item, evt);
            this.maybeResetQuery();
        }
    };
    handleItemSelect = (item, event)=>{
        this.setActiveItem(item);
        this.props.onItemSelect?.(item, event);
        this.maybeResetQuery();
    };
    handlePaste = (queries)=>{
        const { createNewItemFromQuery: createNewItemFromQuery, onItemsPaste: onItemsPaste } = this.props;
        let nextActiveItem;
        const nextQueries = [];
        // Find an exising item that exactly matches each pasted value, or
        // create a new item if possible. Ignore unmatched values if creating
        // items is disabled.
        const pastedItemsToEmit = [];
        for (const query of queries){
            const equalItem = $bd0ad1ca6092f56b$var$getMatchingItem(query, this.props);
            if (equalItem !== undefined) {
                nextActiveItem = equalItem;
                pastedItemsToEmit.push(equalItem);
            } else if (this.canCreateItems()) {
                const value = createNewItemFromQuery?.(query);
                if (value !== undefined) {
                    const newItems = Array.isArray(value) ? value : [
                        value
                    ];
                    pastedItemsToEmit.push(...newItems);
                }
            } else nextQueries.push(query);
        }
        // UX nicety: combine all unmatched queries into a single
        // comma-separated query in the input, so we don't lose any information.
        // And don't reset the active item; we'll do that ourselves below.
        this.setQuery(nextQueries.join(", "), false);
        // UX nicety: update the active item if we matched with at least one
        // existing item.
        if (nextActiveItem !== undefined) this.setActiveItem(nextActiveItem);
        onItemsPaste?.(pastedItemsToEmit);
    };
    handleKeyDown = (event)=>{
        if (!event.nativeEvent.isComposing) {
            const { key: key } = event;
            const direction = (0, $5f04c694ca05154e$exports).getArrowKeyDirection(event, [
                "ArrowUp"
            ], [
                "ArrowDown"
            ]);
            if (direction !== undefined) {
                event.preventDefault();
                const nextActiveItem = this.getNextActiveItem(direction);
                if (nextActiveItem != null) this.setActiveItem(nextActiveItem);
            } else if (key === "Enter") this.isEnterKeyPressed = true;
        }
        this.props.onKeyDown?.(event);
    };
    handleKeyUp = (event)=>{
        const { onKeyUp: onKeyUp } = this.props;
        const { activeItem: activeItem } = this.state;
        if (event.key === "Enter" && this.isEnterKeyPressed) {
            // We handle ENTER in keyup here to play nice with the Button component's keyboard
            // clicking. Button is commonly used as the only child of Select. If we were to
            // instead process ENTER on keydown, then Button would click itself on keyup and
            // the Select popover would re-open.
            event.preventDefault();
            if (activeItem == null || (0, $f77e07cd2c03b3cc$export$34f76065d3c0d679)(activeItem)) this.handleItemCreate(this.state.query, event);
            else this.handleItemSelect(activeItem, event);
            this.isEnterKeyPressed = false;
        }
        onKeyUp?.(event);
    };
    handleInputQueryChange = (event)=>{
        const query = event == null ? "" : event.target.value;
        this.setQuery(query);
        this.props.onQueryChange?.(query, event);
    };
    /**
     * Get the next enabled item, moving in the given direction from the start
     * index. A `null` return value means no suitable item was found.
     *
     * @param direction amount to move in each iteration, typically +/-1
     * @param startIndex item to start iteration
     */ getNextActiveItem(direction, startIndex = this.getActiveIndex()) {
        if (this.isCreateItemRendered(this.state.createNewItem)) {
            const reachedCreate = startIndex === 0 && direction === -1 || startIndex === this.state.filteredItems.length - 1 && direction === 1;
            if (reachedCreate) return (0, $f77e07cd2c03b3cc$export$3af999347d244081)();
        }
        return $bd0ad1ca6092f56b$export$db4cfd88d8087392(this.state.filteredItems, this.props.itemDisabled, direction, startIndex);
    }
    /**
     * @param createNewItem Checks if this item would match the current query. Cannot check this.state.createNewItem
     *  every time since state may not have been updated yet.
     */ isCreateItemRendered(createNewItem) {
        return this.canCreateItems() && this.state.query !== "" && // this check is unfortunately O(N) on the number of items, but
        // alas, hiding the "Create Item" option when it exactly matches an
        // existing item is much clearer.
        !this.wouldCreatedItemMatchSomeExistingItem(createNewItem);
    }
    isCreateItemFirst() {
        return this.props.createNewItemPosition === "first";
    }
    canCreateItems() {
        return this.props.createNewItemFromQuery != null && this.props.createNewItemRenderer != null;
    }
    wouldCreatedItemMatchSomeExistingItem(createNewItem) {
        // search only the filtered items, not the full items list, because we
        // only need to check items that match the current query.
        return this.state.filteredItems.some((item)=>{
            const newItems = Array.isArray(createNewItem) ? createNewItem : [
                createNewItem
            ];
            return newItems.some((newItem)=>(0, $daced99e67c1a25d$export$4dd70a7c4549164b)(this.props.itemsEqual, item, newItem));
        });
    }
    maybeResetQuery() {
        if (this.props.resetOnSelect) this.setQuery("", true);
    }
    /** Generate unique ID for the currently active item */ getActiveItemId() {
        const { activeItem: activeItem } = this.state;
        if (activeItem == null) return undefined;
        if ((0, $f77e07cd2c03b3cc$export$34f76065d3c0d679)(activeItem)) return `${this.listId}-create-item`;
        const activeIndex = this.getActiveIndex();
        return activeIndex >= 0 ? `${this.listId}-item-${activeIndex}` : undefined;
    }
}
function $bd0ad1ca6092f56b$var$pxToNumber(value) {
    return value == null ? 0 : parseInt(value.slice(0, -2), 10);
}
function $bd0ad1ca6092f56b$var$getMatchingItem(query, { items: items, itemPredicate: itemPredicate }) {
    if ((0, $5f04c694ca05154e$exports).isFunction(itemPredicate)) // .find() doesn't exist in ES5. Alternative: use a for loop instead of
    // .filter() so that we can return as soon as we find the first match.
    for(let i = 0; i < items.length; i++){
        const item = items[i];
        if (itemPredicate(query, item, i, true)) return item;
    }
    return undefined;
}
function $bd0ad1ca6092f56b$var$getFilteredItems(query, { items: items, itemPredicate: itemPredicate, itemListPredicate: itemListPredicate }) {
    if ((0, $5f04c694ca05154e$exports).isFunction(itemListPredicate)) // note that implementations can reorder the items here
    return itemListPredicate(query, items);
    else if ((0, $5f04c694ca05154e$exports).isFunction(itemPredicate)) return items.filter((item, index)=>itemPredicate(query, item, index));
    return items;
}
/** Wrap number around min/max values: if it exceeds one bound, return the other. */ function $bd0ad1ca6092f56b$var$wrapNumber(value, min, max) {
    if (value < min) return max;
    else if (value > max) return min;
    return value;
}
function $bd0ad1ca6092f56b$var$isItemDisabled(item, index, itemDisabled) {
    if (itemDisabled == null || item == null) return false;
    else if ((0, $5f04c694ca05154e$exports).isFunction(itemDisabled)) return itemDisabled(item, index);
    return !!item[itemDisabled];
}
function $bd0ad1ca6092f56b$export$db4cfd88d8087392(items, itemDisabled, direction = 1, startIndex = items.length - 1) {
    if (items.length === 0) return null;
    // remember where we started to prevent an infinite loop
    let index = startIndex;
    const maxIndex = items.length - 1;
    do {
        // find first non-disabled item
        index = $bd0ad1ca6092f56b$var$wrapNumber(index + direction, 0, maxIndex);
        if (!$bd0ad1ca6092f56b$var$isItemDisabled(items[index], index, itemDisabled)) return items[index];
    }while (index !== startIndex && startIndex !== -1);
    return null;
}


class $db379be4b874c425$export$ef9b1a59e592288f extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Select`;
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ static ofType() {
        return $db379be4b874c425$export$ef9b1a59e592288f;
    }
    state = {
        isOpen: false
    };
    inputElement = null;
    queryList = null;
    previousFocusedElement;
    handleInputRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "inputElement", this.props.inputProps?.inputRef);
    handleQueryListRef = (ref)=>this.queryList = ref;
    listboxId = (0, $5f04c694ca05154e$exports).uniqueId("listbox");
    render() {
        // omit props specific to this component, spread the rest.
        const { filterable: filterable, inputProps: inputProps, menuProps: menuProps, popoverProps: popoverProps, ...restProps } = this.props;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $bd0ad1ca6092f56b$export$53fc189dda010966), {
            ...restProps,
            listId: this.listboxId,
            menuProps: {
                "aria-label": "selectable options",
                ...menuProps
            },
            onItemSelect: this.handleItemSelect,
            ref: this.handleQueryListRef,
            renderer: this.renderQueryList
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.inputProps?.inputRef !== this.props.inputProps?.inputRef) {
            (0, $7544862da546e887$export$4bb192c7cacf928f)(prevProps.inputProps?.inputRef, null);
            this.handleInputRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "inputElement", this.props.inputProps?.inputRef);
            (0, $7544862da546e887$export$4bb192c7cacf928f)(this.props.inputProps?.inputRef, this.inputElement);
        }
        if (this.state.isOpen && !prevState.isOpen && this.queryList != null) this.queryList.scrollActiveItemIntoView();
    }
    renderQueryList = (listProps)=>{
        // not using defaultProps cuz they're hard to type with generics (can't use <T> on static members)
        const { filterable: filterable = true, disabled: disabled = false, inputProps: inputProps = {}, placeholder: placeholder = "Filter...", popoverContentProps: popoverContentProps = {}, popoverProps: popoverProps = {}, popoverRef: popoverRef } = this.props;
        const input = (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
            "aria-activedescendant": listProps.activeItemId,
            "aria-autocomplete": "list",
            "aria-expanded": this.state.isOpen,
            leftIcon: (0, $fc31e5e9fc16a880$exports.jsx)((0, $86c7da1d2a30830f$export$4b85d3515bd863a5), {}),
            placeholder: placeholder,
            rightElement: this.maybeRenderClearButton(listProps.query),
            role: "combobox",
            ...inputProps,
            inputRef: this.handleInputRef,
            onChange: listProps.handleQueryChange,
            value: listProps.query
        });
        const { handleKeyDown: handleKeyDown, handleKeyUp: handleKeyUp } = listProps;
        // N.B. no need to set `fill` since that is unused with the `renderTarget` API
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            autoFocus: false,
            enforceFocus: false,
            isOpen: this.state.isOpen,
            disabled: disabled,
            placement: popoverProps.position || popoverProps.placement ? undefined : "bottom-start",
            ...popoverProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(listProps.className, popoverProps.className),
            content: (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                ...popoverContentProps,
                onKeyDown: handleKeyDown,
                onKeyUp: handleKeyUp,
                children: [
                    filterable ? input : undefined,
                    listProps.itemList
                ]
            }),
            onClosing: this.handlePopoverClosing,
            onInteraction: this.handlePopoverInteraction,
            onOpened: this.handlePopoverOpened,
            onOpening: this.handlePopoverOpening,
            popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $27a0f3536dedad79$exports).SELECT_POPOVER, popoverProps.popoverClassName),
            popupKind: (0, $da7063ee0db80208$export$4d5c295289e9b3bf).LISTBOX,
            ref: popoverRef,
            renderTarget: this.getPopoverTargetRenderer(listProps, this.state.isOpen)
        });
    };
    // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like
    // the "fill" prop. Note that we must take `isOpen` as an argument to force this render function to be called
    // again after that state changes.
    getPopoverTargetRenderer = (listProps, isOpen)=>// N.B. pull out `isOpen` so that it's not forwarded to the DOM, but remember not to use it directly
        // since it may be stale (`renderTarget` is not re-invoked on this.state changes).
        // eslint-disable-next-line react/display-name
        ({ isOpen: _isOpen, ref: ref, ...targetProps })=>{
            const { disabled: disabled, filterable: filterable = true, popoverProps: popoverProps = {}, popoverTargetProps: popoverTargetProps } = this.props;
            const { handleKeyDown: handleKeyDown, handleKeyUp: handleKeyUp } = listProps;
            const { targetTagName: targetTagName = "div" } = popoverProps;
            return (0, $kYL7Z.createElement)(targetTagName, {
                "aria-controls": this.listboxId,
                ...popoverTargetProps,
                ...targetProps,
                "aria-disabled": disabled,
                "aria-expanded": isOpen,
                // When filterable, the InputGroup inside is the combobox; this trigger is just a button
                // When not filterable, this trigger is the combobox
                ...filterable ? {
                    "aria-haspopup": "listbox"
                } : {},
                // Note that we must set FILL here in addition to children to get the wrapper element to full width
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(targetProps.className, popoverTargetProps?.className, {
                    [(0, $2cfd35af7ec11fdd$exports).FILL]: this.props.fill
                }),
                // Normally, Popover would also need to attach its own `onKeyDown` handler via `targetProps`,
                // but in our case we fully manage that interaction and listen for key events to open/close
                // the popover, so we elide it from the DOM.
                onKeyDown: this.withPopoverTargetPropsHandler("keydown", isOpen ? handleKeyDown : this.handleTargetKeyDown),
                onKeyUp: this.withPopoverTargetPropsHandler("keyup", isOpen ? handleKeyUp : undefined),
                ref: ref,
                role: filterable ? undefined : "combobox"
            }, this.props.children);
        };
    maybeRenderClearButton(query) {
        return query.length > 0 ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
            "aria-label": "Clear filter query",
            icon: (0, $fc31e5e9fc16a880$exports.jsx)((0, $d5a01f31f7e06d3b$export$3c877bb842c36952), {}),
            onClick: this.resetQuery,
            title: "Clear filter query",
            variant: "minimal"
        }) : undefined;
    }
    withPopoverTargetPropsHandler = (eventType, handler)=>{
        switch(eventType){
            case "keydown":
                return (event)=>{
                    handler?.(event);
                    this.props.popoverTargetProps?.onKeyDown?.(event);
                };
            case "keyup":
                return (event)=>{
                    handler?.(event);
                    this.props.popoverTargetProps?.onKeyUp?.(event);
                };
        }
    };
    /**
     * Target wrapper element "keydown" handler while the popover is closed.
     */ handleTargetKeyDown = (event)=>{
        // open popover when arrow key pressed on target while closed
        if (event.key === "ArrowUp" || event.key === "ArrowDown") {
            event.preventDefault();
            this.setState({
                isOpen: true
            });
        } else if ((0, $5f04c694ca05154e$exports).isKeyboardClick(event)) this.setState({
            isOpen: true
        });
    };
    handleItemSelect = (item, event)=>{
        const target = event?.target;
        const menuItem = target?.closest(`.${(0, $2cfd35af7ec11fdd$exports).MENU_ITEM}`);
        const menuItemDismiss = menuItem?.matches(`.${(0, $2cfd35af7ec11fdd$exports).POPOVER_DISMISS}`);
        const shouldDismiss = menuItemDismiss ?? true;
        this.setState({
            isOpen: !shouldDismiss
        });
        this.props.onItemSelect?.(item, event);
    };
    handlePopoverInteraction = (isOpen, event)=>{
        this.setState({
            isOpen: isOpen
        });
        this.props.popoverProps?.onInteraction?.(isOpen, event);
    };
    handlePopoverOpening = (node)=>{
        // save currently focused element before popover steals focus, so we can restore it when closing.
        this.previousFocusedElement = (0, $5f04c694ca05154e$exports).getActiveElement(this.inputElement) ?? undefined;
        if (this.props.resetOnClose) this.resetQuery();
        this.props.popoverProps?.onOpening?.(node);
    };
    handlePopoverOpened = (node)=>{
        // scroll active item into view after popover transition completes and all dimensions are stable.
        if (this.queryList != null) this.queryList.scrollActiveItemIntoView();
        this.requestAnimationFrame(()=>{
            const { inputProps: inputProps = {} } = this.props;
            // autofocus is enabled by default
            if (inputProps.autoFocus !== false) this.inputElement?.focus();
        });
        this.props.popoverProps?.onOpened?.(node);
    };
    handlePopoverClosing = (node)=>{
        // restore focus to saved element.
        // timeout allows popover to begin closing and remove focus handlers beforehand.
        /* istanbul ignore next */ this.requestAnimationFrame(()=>{
            if (this.previousFocusedElement !== undefined) {
                this.previousFocusedElement.focus();
                this.previousFocusedElement = undefined;
            }
        });
        this.props.popoverProps?.onClosing?.(node);
    };
    resetQuery = ()=>this.queryList && this.queryList.setQuery("", true);
}


var $aa27e6f0058e6325$exports = {};

$parcel$export($aa27e6f0058e6325$exports, "users", () => $aa27e6f0058e6325$export$7652f722913b5d7);
$parcel$export($aa27e6f0058e6325$exports, "roles", () => $aa27e6f0058e6325$export$8e77a375f9a5908e);
$parcel$export($aa27e6f0058e6325$exports, "adminRoles", () => $aa27e6f0058e6325$export$981db36c5c688393);
$parcel$export($aa27e6f0058e6325$exports, "invite", () => $aa27e6f0058e6325$export$dd37b42f82fee9c3);
$parcel$export($aa27e6f0058e6325$exports, "roles_users", () => $aa27e6f0058e6325$export$4bd7e1475dbdd75f);
$parcel$export($aa27e6f0058e6325$exports, "adminRoles_users", () => $aa27e6f0058e6325$export$880d08909c9f5387);
$parcel$export($aa27e6f0058e6325$exports, "adminRoles_capabilities", () => $aa27e6f0058e6325$export$5d38d8531ecf1ed4);
$parcel$export($aa27e6f0058e6325$exports, "capabilities", () => $aa27e6f0058e6325$export$8e76ac9f37578d1b);




var $kYL7Z = parcelRequire("kYL7Z");









var $kYL7Z = parcelRequire("kYL7Z");



/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

function $d762dfe30d03b4c6$export$d8e6abf214c9ec0f(callback, delay) {
    const savedCallback = (0, $kYL7Z.useRef)(callback);
    // remember the latest callback if it changes
    (0, $c7a0a0a998d4e92a$export$700979bc83e7db82)(()=>{
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // set up the timeout
    (0, $kYL7Z.useEffect)(()=>{
        // Don't schedule if no delay is specified.
        // Note: 0 is a valid value for delay.
        if (!delay && delay !== 0) return;
        const id = setTimeout(()=>savedCallback.current(), delay);
        return ()=>clearTimeout(id);
    }, [
        delay
    ]);
}





var $kYL7Z = parcelRequire("kYL7Z");


const $9aea662359a2cfdc$export$69b1032f2ecdf404 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { alignText: alignText, className: className, fill: fill, minimal: // eslint-disable-next-line @typescript-eslint/no-deprecated
    minimal, outlined: // eslint-disable-next-line @typescript-eslint/no-deprecated
    outlined, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
    large, size: size = "medium", variant: variant = "solid", vertical: vertical, ...htmlProps } = props;
    const buttonGroupClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).BUTTON_GROUP, {
        [(0, $2cfd35af7ec11fdd$exports).FILL]: fill,
        [(0, $2cfd35af7ec11fdd$exports).VERTICAL]: vertical
    }, (0, $2cfd35af7ec11fdd$exports).alignmentClass(alignText), (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
        large: large
    }), (0, $2cfd35af7ec11fdd$exports).variantClass(variant, {
        minimal: minimal,
        outlined: outlined
    }), className);
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        ...htmlProps,
        ref: ref,
        className: buttonGroupClasses,
        children: props.children
    });
});
$9aea662359a2cfdc$export$69b1032f2ecdf404.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.ButtonGroup`;




const $4b7786f0d6c5dd26$export$8d8dc7d5f743331b = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { action: action, className: className, icon: icon, intent: intent, isCloseButtonShown: isCloseButtonShown = true, message: message, onDismiss: onDismiss, timeout: timeout = 5000 } = props;
    const [isTimeoutStarted, setIsTimeoutStarted] = (0, $kYL7Z.useState)(false);
    const startTimeout = (0, $kYL7Z.useCallback)(()=>setIsTimeoutStarted(true), []);
    const clearTimeout = (0, $kYL7Z.useCallback)(()=>setIsTimeoutStarted(false), []);
    // Per docs: "Providing a value less than or equal to 0 will disable the timeout (this is discouraged)."
    const isTimeoutEnabled = timeout != null && timeout > 0;
    // timeout is triggered & cancelled by updating `isTimeoutStarted` state
    (0, $d762dfe30d03b4c6$export$d8e6abf214c9ec0f)(()=>{
        triggerDismiss(true);
    }, isTimeoutStarted && isTimeoutEnabled ? timeout : null);
    // start timeout on mount or change, cancel on unmount
    (0, $kYL7Z.useEffect)(()=>{
        if (isTimeoutEnabled) startTimeout();
        else clearTimeout();
        return clearTimeout;
    }, [
        clearTimeout,
        startTimeout,
        isTimeoutEnabled,
        timeout
    ]);
    const triggerDismiss = (0, $kYL7Z.useCallback)((didTimeoutExpire)=>{
        clearTimeout();
        onDismiss?.(didTimeoutExpire);
    }, [
        clearTimeout,
        onDismiss
    ]);
    const handleCloseClick = (0, $kYL7Z.useCallback)(()=>triggerDismiss(false), [
        triggerDismiss
    ]);
    const handleActionClick = (0, $kYL7Z.useCallback)((e)=>{
        action?.onClick?.(e);
        triggerDismiss(false);
    }, [
        action,
        triggerDismiss
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TOAST, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), className),
        // Pause timeouts if users are hovering over or click on the toast. The toast may have
        // actions the user wants to click. It'd be a poor experience to "pull the toast" out
        // from under them.
        onBlur: startTimeout,
        onFocus: clearTimeout,
        onMouseEnter: clearTimeout,
        onMouseLeave: startTimeout,
        ref: ref,
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: 0,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: icon
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                className: (0, $2cfd35af7ec11fdd$exports).TOAST_MESSAGE,
                role: "alert",
                children: message
            }),
            (0, $fc31e5e9fc16a880$exports.jsxs)((0, $9aea662359a2cfdc$export$69b1032f2ecdf404), {
                variant: "minimal",
                children: [
                    action && (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$59a34841c163ed64), {
                        ...action,
                        intent: undefined,
                        onClick: handleActionClick
                    }),
                    isCloseButtonShown && (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        "aria-label": "Close",
                        icon: (0, $fc31e5e9fc16a880$exports.jsx)((0, $d5a01f31f7e06d3b$export$3c877bb842c36952), {}),
                        onClick: handleCloseClick
                    })
                ]
            })
        ]
    });
});
$4b7786f0d6c5dd26$export$8d8dc7d5f743331b.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Toast`;
const $4b7786f0d6c5dd26$export$ee0bd2a518c4fe8a = $4b7786f0d6c5dd26$export$8d8dc7d5f743331b;


const $311fa04eaa4042ef$var$defaultDomRenderer = (element, container)=>{
    (0, $2fc1460ebb889ad8$exports.createRoot)(container).render(element);
};
const $311fa04eaa4042ef$export$7c765baa85a505b5 = 50;
class $311fa04eaa4042ef$export$b0708472ff39d83b extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.OverlayToaster`;
    static defaultProps = {
        autoFocus: false,
        canEscapeKeyClear: true,
        position: (0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42).TOP,
        usePortal: true
    };
    /**
     * Create a new `Toaster` instance that can be shared around your application.
     * The `Toaster` will be rendered into a new element appended to the given container.
     */ static create(props, options = {}) {
        if (props != null && props.usePortal != null && !(0, $f141b3b4d406798c$export$ba99498080d0627b)("production")) console.warn((0, $5bed6f2a5e88b283$export$18ab8fe30147e847));
        const { container: container = document.body, domRenderer: domRenderer = $311fa04eaa4042ef$var$defaultDomRenderer } = options;
        const toasterComponentRoot = document.createElement("div");
        container.appendChild(toasterComponentRoot);
        return new Promise((resolve, reject)=>{
            try {
                domRenderer((0, $fc31e5e9fc16a880$exports.jsx)($311fa04eaa4042ef$export$b0708472ff39d83b, {
                    ...props,
                    ref: handleRef,
                    usePortal: false
                }), toasterComponentRoot);
            } catch (error) {
                // Note that we're catching errors from the domRenderer function
                // call, but not errors when rendering <OverlayToaster>, which
                // happens in a separate scheduled tick. Wrapping the
                // OverlayToaster in an error boundary would be necessary to
                // capture rendering errors, but that's still a bit unreliable
                // and would only catch errors rendering the initial mount.
                reject(error);
            }
            // We can get a rough guarantee that the OverlayToaster has been
            // mounted to the DOM by waiting until the ref callback here has
            // been fired.
            //
            // This is the approach suggested under "What about the render
            // callback?" at https://github.com/reactwg/react-18/discussions/5.
            function handleRef(ref) {
                if (ref == null) {
                    reject(new Error((0, $5bed6f2a5e88b283$export$fdceab30a81a80e3)));
                    return;
                }
                resolve(ref);
            }
        });
    }
    /**
     * This is an alias for `OverlayToaster.create`, exposed for backwards compatibility with the 5.x API.
     *
     * @deprecated Use `OverlayToaster.create` instead.
     */ static createAsync(props, options) {
        return $311fa04eaa4042ef$export$b0708472ff39d83b.create(props, options);
    }
    state = {
        toastRefs: {},
        toasts: []
    };
    // Queue of toasts to be displayed. If toasts are shown too quickly back to back, it can result in cut off toasts.
    // The queue ensures that toasts are only displayed in QUEUE_TIMEOUT_MS increments.
    queue = {
        cancel: undefined,
        isRunning: false,
        toasts: []
    };
    // auto-incrementing identifier for un-keyed toasts
    toastId = 0;
    toastRefs = {};
    /** Compute a new collection of toast refs (usually after updating toasts) */ getToastRefs = (toasts)=>{
        return toasts.reduce((refs, toast)=>{
            refs[toast.key] = (0, $kYL7Z.createRef)();
            return refs;
        }, {});
    };
    show(props, key) {
        const options = this.createToastOptions(props, key);
        const wasExistingToastUpdated = this.maybeUpdateExistingToast(options, key);
        if (wasExistingToastUpdated) return options.key;
        if (this.queue.isRunning) // If a toast has been shown recently, push to the queued toasts to prevent toasts from being shown too
        // quickly for the animations to keep up
        this.queue.toasts.push(options);
        else {
            // If we have not recently shown a toast, we can immediately show the given toast
            this.immediatelyShowToast(options);
            this.startQueueTimeout();
        }
        return options.key;
    }
    maybeUpdateExistingToast(options, key) {
        if (key == null) return false;
        const isExistingQueuedToast = this.queue.toasts.some((toast)=>toast.key === key);
        if (isExistingQueuedToast) {
            this.queue.toasts = this.queue.toasts.map((t)=>t.key === key ? options : t);
            return true;
        }
        const isExistingShownToast = this.state.toasts.some((toast)=>toast.key === key);
        if (isExistingShownToast) {
            this.updateToastsInState((toasts)=>toasts.map((t)=>t.key === key ? options : t));
            return true;
        }
        return false;
    }
    immediatelyShowToast(options) {
        if (this.props.maxToasts) // check if active number of toasts are at the maxToasts limit
        this.dismissIfAtLimit();
        this.updateToastsInState((toasts)=>[
                options,
                ...toasts
            ]);
    }
    startQueueTimeout() {
        this.queue.isRunning = true;
        this.queue.cancel = this.setTimeout(this.handleQueueTimeout, $311fa04eaa4042ef$export$7c765baa85a505b5);
    }
    handleQueueTimeout = ()=>{
        const nextToast = this.queue.toasts.shift();
        if (nextToast != null) {
            this.immediatelyShowToast(nextToast);
            this.startQueueTimeout();
        } else this.queue.isRunning = false;
    };
    updateToastsInState(getNewToasts) {
        this.setState((prevState)=>{
            const toasts = getNewToasts(prevState.toasts);
            return {
                toastRefs: this.getToastRefs(toasts),
                toasts: toasts
            };
        });
    }
    dismiss(key, timeoutExpired = false) {
        this.setState((prevState)=>{
            const toasts = prevState.toasts.filter((t)=>{
                const matchesKey = t.key === key;
                if (matchesKey) t.onDismiss?.(timeoutExpired);
                return !matchesKey;
            });
            return {
                toastRefs: this.getToastRefs(toasts),
                toasts: toasts
            };
        });
    }
    clear() {
        this.queue.cancel?.();
        this.queue = {
            cancel: undefined,
            isRunning: false,
            toasts: []
        };
        this.state.toasts.forEach((t)=>t.onDismiss?.(false));
        this.setState({
            toastRefs: {},
            toasts: []
        });
    }
    getToasts() {
        return this.state.toasts;
    }
    render() {
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TOAST_CONTAINER, this.getPositionClasses(), this.props.className);
        return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $aef6e7264f0251d6$export$2e8e2c61dfd53893), {
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: this.props.autoFocus,
            canEscapeKeyClose: this.props.canEscapeKeyClear,
            canOutsideClickClose: false,
            className: classes,
            childRefs: this.toastRefs,
            enforceFocus: false,
            hasBackdrop: false,
            isOpen: this.state.toasts.length > 0 || this.props.children != null,
            onClose: this.handleClose,
            shouldReturnFocusOnClose: false,
            // $pt-transition-duration * 3 + $pt-transition-duration / 2
            transitionDuration: 350,
            transitionName: (0, $2cfd35af7ec11fdd$exports).TOAST,
            usePortal: this.props.usePortal,
            children: [
                this.state.toasts.map(this.renderToast, this),
                this.props.children
            ]
        });
    }
    validateProps({ maxToasts: maxToasts }) {
        // maximum number of toasts should not be a number less than 1
        if (maxToasts !== undefined && maxToasts < 1) throw new Error((0, $5bed6f2a5e88b283$export$2451692ca60e5d58));
    }
    dismissIfAtLimit() {
        if (this.state.toasts.length === this.props.maxToasts) // dismiss the oldest toast to stay within the maxToasts limit
        this.dismiss(this.state.toasts[this.state.toasts.length - 1].key);
    }
    renderToast = (toast)=>{
        const { key: key, ...toastProps } = toast;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $4b7786f0d6c5dd26$export$8d8dc7d5f743331b), {
            ...toastProps,
            onDismiss: this.getDismissHandler(toast)
        }, key);
    };
    createToastOptions(props, key = `toast-${this.toastId++}`) {
        // clone the object before adding the key prop to avoid leaking the mutation
        return {
            ...props,
            key: key
        };
    }
    getPositionClasses() {
        const positions = this.props.position.split("-");
        // NOTE that there is no -center class because that's the default style
        return [
            ...positions.map((p)=>`${(0, $2cfd35af7ec11fdd$exports).TOAST_CONTAINER}-${p.toLowerCase()}`),
            `${(0, $2cfd35af7ec11fdd$exports).TOAST_CONTAINER}-${this.props.usePortal ? "in-portal" : "inline"}`
        ];
    }
    getDismissHandler = (toast)=>(timeoutExpired)=>{
            this.dismiss(toast.key, timeoutExpired);
        };
    handleClose = (e)=>{
        // NOTE that `e` isn't always a KeyboardEvent but that's the only type we care about
        if (e.key === "Escape") this.clear();
    };
}


let $cc4fa4b6613dc4ad$var$toaster;
(0, $311fa04eaa4042ef$export$b0708472ff39d83b).createAsync().then((t)=>{
    $cc4fa4b6613dc4ad$var$toaster = t;
});
const $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0 = (args)=>$cc4fa4b6613dc4ad$var$toaster?.show({
        intent: (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).WARNING,
        ...args
    });
const $cc4fa4b6613dc4ad$export$73e19c0339806233 = (args)=>$cc4fa4b6613dc4ad$var$toaster?.show({
        intent: (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).SUCCESS,
        ...args
    });
const $cc4fa4b6613dc4ad$export$4cc0fb945c4ba96e = (args)=>$cc4fa4b6613dc4ad$var$toaster?.show({
        intent: (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).PRIMARY,
        ...args
    });



const $4dffb8c44373925a$export$848feb93d8f32b9b = async ({ path: path, fetchOptions: fetchOptions, otherOptions: otherOptions = {}, responseExpected: responseExpected = true, responseMethod: responseMethod = 'json' })=>{
    const fetchOpts = {
        ...fetchOptions,
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: undefined
        }
    };
    const auth0Client = (0, $128dd395bc2881df$export$caa56256f2cca349)();
    const token = await auth0Client.getTokenSilently();
    if (token) fetchOpts.headers.Authorization = `Bearer ${token}`;
    const res = await fetch(path, fetchOpts);
    if (res.ok && responseExpected) return await res[responseMethod]();
    else if (res.ok && !responseExpected) return true;
    // if response is 401 show a toast prompting the user to log back in
    if (res.status === 401 && !otherOptions.disable401Toast) {
        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
            message: 'Got a 401 from API'
        });
        return false;
    }
    let errorBody = null;
    try {
        errorBody = await res.json();
    } catch (_) {}
    console.warn('Error response', res);
    if (errorBody) console.warn('Error response body', errorBody);
    if (!otherOptions.disableErrorToasts) {
        const detail = errorBody?.message || errorBody?.error || res.statusText;
        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
            message: `${res.status}: ${detail}`
        });
    }
    throw new Error(res.status);
};


const $aa27e6f0058e6325$export$7652f722913b5d7 = {
    list: (orgId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/users?query[ownerOrgId]=${orgId}&pageSize=500`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    listAdopted: (orgId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/adopted-users?query[ownerOrgId]=${orgId}&pageSize=500`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    delete: (userId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/users/${userId}`,
            fetchOptions: {
                method: 'DELETE'
            },
            responseExpected: false
        });
    },
    update: (userId, userObject)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/users/${userId}`,
            fetchOptions: {
                method: 'PUT',
                body: JSON.stringify(userObject)
            }
        });
    },
    organisationsForUser: (userId, silent = false)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/users/${userId}/organisations`,
            fetchOptions: {
                method: 'GET'
            },
            otherOptions: {
                disableErrorToasts: silent,
                disable401Toast: silent
            }
        });
    },
    rolesForUser: (userId, orgId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/users/${userId}/roles?query[orgId]=${orgId}`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    addRole: (userId, orgId, roleId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/users/${userId}/roles`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify({
                    orgId: orgId,
                    roleId: Number(roleId)
                })
            }
        });
    },
    removeRole: (userId, orgId, roleId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/users/${userId}/roles/${roleId}?query[orgId]=${orgId}`,
            fetchOptions: {
                method: 'DELETE'
            },
            responseExpected: false
        });
    }
};
const $aa27e6f0058e6325$export$8e77a375f9a5908e = {
    list: ()=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/roles?pageSize=100&orderBy=id`,
            fetchOptions: {
                method: 'GET'
            }
        });
    }
};
const $aa27e6f0058e6325$export$981db36c5c688393 = {
    list: (silent = false)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/admin-roles?pageSize=100&orderBy=id`,
            fetchOptions: {
                method: 'GET'
            },
            otherOptions: {
                disableErrorToasts: silent,
                disable401Toast: silent
            }
        });
    }
};
const $aa27e6f0058e6325$export$dd37b42f82fee9c3 = {
    // targetApp is optional. When it is undefined the key is omitted and the
    // auth service applies its default (webclient).
    send: (email, roleIds, org, targetApp)=>{
        const body = JSON.stringify({
            email: email,
            roles: roleIds,
            invitingOrgName: org.name,
            orgToInviteTo: org.id,
            ...targetApp ? {
                targetApp: targetApp
            } : {}
        });
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/invite-user`,
            fetchOptions: {
                method: 'POST',
                body: body
            },
            responseExpected: false
        });
    }
};
const $aa27e6f0058e6325$var$generateAllOrgsQuery = (allOrgs)=>{
    return allOrgs.reduce((acc, org, index)=>`${acc}${index === 0 ? '' : '&'}query[orgId]=${org.id}`, '');
};
const $aa27e6f0058e6325$export$4bd7e1475dbdd75f = {
    list: (roleId, allOrgs)=>{
        const allOrgsQs = $aa27e6f0058e6325$var$generateAllOrgsQuery(allOrgs);
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/roles/${roleId}/users?pageSize=500&${allOrgsQs}&orderBy=id`,
            fetchOptions: {
                method: 'GET'
            }
        });
    }
};
const $aa27e6f0058e6325$export$880d08909c9f5387 = {
    list: (roleId, allOrgs)=>{
        const allOrgsQs = $aa27e6f0058e6325$var$generateAllOrgsQuery(allOrgs);
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/admin-roles/${roleId}/users?pageSize=500&${allOrgsQs}&orderBy=id`,
            fetchOptions: {
                method: 'GET'
            }
        });
    }
};
const $aa27e6f0058e6325$export$5d38d8531ecf1ed4 = {
    list: (roleId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/admin-roles/${roleId}/capabilities?pageSize=500&&orderBy=id`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    create: (roleId, capabilityId)=>{
        const body = JSON.stringify({
            capabilityId: Number(capabilityId)
        });
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/admin-roles/${roleId}/capabilities`,
            fetchOptions: {
                method: 'POST',
                body: body
            }
        });
    }
};
const $aa27e6f0058e6325$export$8e76ac9f37578d1b = {
    list: (silent = false)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/capabilities?pageSize=500&&orderBy=id`,
            fetchOptions: {
                method: 'GET'
            },
            otherOptions: {
                disableErrorToasts: silent,
                disable401Toast: silent
            }
        });
    },
    create: (capability)=>{
        const body = JSON.stringify(capability);
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$28f31de52ea27c12)}/api/v1/capabilities`,
            fetchOptions: {
                method: 'POST',
                body: body
            }
        });
    }
};



const $d580a4558a21e5b2$var$MobileButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
  margin-top: 1em;
  background: transparent !important;
  border: 1px solid;

  & .bp6-button-text {
      color: rgba(0, 0, 0, 0.8) !important;
  }
`;
const $d580a4558a21e5b2$var$DesktopButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
  margin-top: 1em;
  background: transparent !important;
  border: 1px solid;

  & .bp6-button-text {
      color: rgba(255, 255, 255, 0.8) !important;
  }
`;
const $d580a4558a21e5b2$var$OrganisationSwitcher = ({ user: user, availableOrganisations: availableOrganisations, isMobile: isMobile = false })=>{
    const currentOrgId = user.organisation?._id;
    const getItem = ({ name: name, id: id })=>{
        const getLabel = (orgId)=>orgId === currentOrgId ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                minimal: true,
                intent: "primary",
                children: "Current"
            }) : undefined;
        const setPrimaryOrg = async (newOrgId)=>{
            try {
                if (newOrgId !== currentOrgId) {
                    await $aa27e6f0058e6325$export$7652f722913b5d7.update(user.id, {
                        email: user.email,
                        fullName: user.name,
                        status: 'active',
                        primaryOrgId: newOrgId
                    });
                    window.location.replace('/'); // go home
                }
            } catch (e) {
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Could not switch organisations. Please contact support.'
                });
                console.error(e);
            }
        };
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
            onClick: ()=>setPrimaryOrg(id),
            label: getLabel(id),
            text: name
        }, id);
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
        itemRenderer: getItem,
        items: availableOrganisations,
        minimal: true,
        filterable: false,
        children: isMobile ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($d580a4558a21e5b2$var$MobileButton, {
            minimal: true,
            rightIcon: "caret-down",
            text: user.organisation?.name || "Organisation"
        }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($d580a4558a21e5b2$var$DesktopButton, {
            minimal: true,
            rightIcon: "caret-down",
            text: "Switch organisation"
        })
    });
};
var $d580a4558a21e5b2$export$2e2bcd8739ae039 = $d580a4558a21e5b2$var$OrganisationSwitcher;




var $kYL7Z = parcelRequire("kYL7Z");



const $b097a5f0891e1c14$var$Item = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).h3`
  color: ${({ $selected: $selected, $depth: $depth })=>$selected && $depth === 0 ? '#fff' : 'rgba(255, 255, 255, 0.8)'};
  font-size: 0.9rem;
  background: ${({ $selected: $selected, $depth: $depth })=>$selected && $depth === 0 ? '#333D4D' : null};
  font-weight: ${({ $selected: $selected })=>$selected ? 'bold' : 'normal'};
  padding: 0.5rem 1.25rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 0;
  padding-left: ${({ $depth: $depth })=>$depth > 0 ? `calc(calc(16px * ${$depth}) + 2.25rem)` : null};
  margin: 0;

  &:hover {
    color: ${({ $selected: $selected, $depth: $depth })=>$selected && $depth === 0 ? '#fff' : '#fff'};
  }
`;
const $b097a5f0891e1c14$var$ItemIcon = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $b90a50544ad30fb8$export$f04a61298a47a40f))`
  margin-right: 1rem;
`;
const $b097a5f0891e1c14$var$MenuItem = ({ item: item, depth: depth = 0, location: location })=>{
    const navigate = (0, $3c99a37f3fed1403$export$9770f232ac06a008)();
    const routerLocation = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    const getSelected = (route, depth)=>{
        let selected = false;
        if (route.includes('?')) route = route.split('?')[0];
        if (route === window.location.pathname) selected = true;
        if (!selected) {
            if (depth === 0 && typeof window === 'object') {
                // find the first part of the route that is not blank
                const routeFirstPart = route.split('/').find((str)=>!!str);
                // find the first part of the window.location.pathname that is not blank
                const currentPathFirstPart = window.location.pathname.split('/').find((str)=>!!str);
                selected = routeFirstPart === currentPathFirstPart;
            }
        }
        return selected;
    };
    const [selected, setSelected] = (0, $kYL7Z.useState)(getSelected(item.path, depth));
    (0, $kYL7Z.useEffect)(()=>{
        setSelected(getSelected(item.path, depth));
    }, [
        routerLocation.pathname,
        depth,
        item.path
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($b097a5f0891e1c14$var$Item, {
                onClick: ()=>navigate(item.path),
                $selected: selected,
                $depth: depth || 0,
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b097a5f0891e1c14$var$ItemIcon, {
                        icon: item.icon
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                        children: item.label
                    })
                ]
            }, item.label),
            (selected || item.alwaysExpanded) && item.children && item.children.map((child)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b097a5f0891e1c14$var$MenuItem, {
                    item: child,
                    depth: depth + 1,
                    location: location
                }, child.label))
        ]
    });
};
var $b097a5f0891e1c14$export$2e2bcd8739ae039 = $b097a5f0891e1c14$var$MenuItem;


const $01469ba6f99a702c$var$Wrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
    width: ${(0, $c7a73239b47a74cf$export$44c6a27b41bcee9f).desktopNavbarWidth};
    background: #19212F;
    flex: 0;
    order: -1;
    height: 100vh;
    overflow-y: auto;
    filter: ${(props)=>props.$blur ? `blur(${props.$blur})` : ''};
`;
const $01469ba6f99a702c$var$FlexScrollbars = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $7f3412929cea4d45$exports.Scrollbars))`
    & > div {
        display: flex;
        flex-direction: column;
    }
`;
const $01469ba6f99a702c$var$Menu = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin-top: 1em;
`;
const $01469ba6f99a702c$var$MenuDivider = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin: 1em 1.5em;
    border-bottom: 1px solid #2c3545;
`;
const $01469ba6f99a702c$var$UserSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
    margin: 0.5em;
    margin-top: 2.5em;
    padding: 1.5em 1em;
    color: rgba(255, 255, 255, 0.8);
    border-top: 1px solid #2c3545;
    display: flex;
    background: #19212F;
    position: relative;
`;
const $01469ba6f99a702c$var$VersionSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    opacity: 0.5;
    width: 100%;
    margin: auto 0 0.5rem;
`;
const $01469ba6f99a702c$var$UserTextSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    flex: 1;
    margin-left: 1em;
`;
const $01469ba6f99a702c$var$UserName = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).p`
    font-size: 0.9em;
    margin-bottom: 0.3em;
`;
const $01469ba6f99a702c$var$OrgName = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).p`
    font-size: 0.85em;
`;
const $01469ba6f99a702c$var$LogoutButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    color: rgba(255, 255, 255, 0.8) !important;
    background: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.8);

    & .bp6-button-text {
        color: rgba(255, 255, 255, 0.8) !important;
    }
`;
const $01469ba6f99a702c$var$Logo = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).img`
    width: 100%;
`;
const $01469ba6f99a702c$var$PoweredLogo = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: block;
    margin: 1rem auto 2rem;
    width: 124px;
    aspect-ratio: 123 / 22;
`;
const $01469ba6f99a702c$var$DesktopSidebar = ({ user: user = {}, availableOrganisations: availableOrganisations = [], blur: blur, logout: logout, menuItems: menuItems, location: location })=>{
    const navigate = (0, $3c99a37f3fed1403$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($01469ba6f99a702c$var$Wrapper, {
        $blur: blur,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($01469ba6f99a702c$var$FlexScrollbars, {
            renderThumbVertical: ({ style: style, props: props })=>{
                const customStyle = {
                    backgroundColor: 'rgb(255, 255, 255, 0.2)',
                    borderRadius: '3px'
                };
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    ...props,
                    style: {
                        ...style,
                        ...customStyle
                    }
                });
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($01469ba6f99a702c$var$Logo, {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($508d3b93c20f9d5b$exports))),
                    alt: "Aura Vision Labs logo"
                }),
                (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) !== "prod" && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    large: true,
                    intent: (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) === "uat" ? "warning" : "danger",
                    style: {
                        textAlign: "center"
                    },
                    children: (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) === "uat" ? "UAT" : "RISK UNKNOWN ENVIRONMENT"
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($01469ba6f99a702c$var$Menu, {
                    children: menuItems.map((item, index)=>{
                        if (item.type === 'divider') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($01469ba6f99a702c$var$MenuDivider, {}, `divider-${index}`);
                        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b097a5f0891e1c14$export$2e2bcd8739ae039), {
                            item: item,
                            location: location
                        }, item.label);
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($01469ba6f99a702c$var$UserSection, {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "user"
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($01469ba6f99a702c$var$UserTextSection, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($01469ba6f99a702c$var$UserName, {
                                    children: user.email
                                }),
                                user.organisation?.name && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($01469ba6f99a702c$var$OrgName, {
                                    children: user.organisation.name
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($01469ba6f99a702c$var$LogoutButton, {
                                    minimal: true,
                                    onClick: ()=>navigate(logout),
                                    children: "Logout"
                                }),
                                availableOrganisations.length > 1 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d580a4558a21e5b2$export$2e2bcd8739ae039), {
                                    user: user,
                                    availableOrganisations: availableOrganisations
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($01469ba6f99a702c$var$VersionSection, {
                    children: [
                        (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) === "uat" ? "uat-" : "",
                        "v",
                        (0, $cd397b46bbd25e75$exports.version)
                    ]
                })
            ]
        })
    });
};
var $01469ba6f99a702c$export$2e2bcd8739ae039 = $01469ba6f99a702c$var$DesktopSidebar;




var $kYL7Z = parcelRequire("kYL7Z");




/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $kYL7Z = parcelRequire("kYL7Z");

function $64289e527bcd600c$var$htmlElement(tagName, tagClassName) {
    /* eslint-disable-next-line react/display-name */ return (0, $kYL7Z.forwardRef)((props, ref)=>{
        const { className: className, children: children, ...htmlProps } = props;
        return (0, $kYL7Z.createElement)(tagName, {
            ...htmlProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(tagClassName, className),
            ref: ref
        }, children);
    });
}
const $64289e527bcd600c$export$5523b16adee8048 = $64289e527bcd600c$var$htmlElement("h1", (0, $2cfd35af7ec11fdd$export$eef1738e402a65e6));
const $64289e527bcd600c$export$cb94397127ac9363 = $64289e527bcd600c$var$htmlElement("h2", (0, $2cfd35af7ec11fdd$export$eef1738e402a65e6));
const $64289e527bcd600c$export$746be9e3a3dfff1f = $64289e527bcd600c$var$htmlElement("h3", (0, $2cfd35af7ec11fdd$export$eef1738e402a65e6));
const $64289e527bcd600c$export$cc5e069d64fda823 = $64289e527bcd600c$var$htmlElement("h4", (0, $2cfd35af7ec11fdd$export$eef1738e402a65e6));
const $64289e527bcd600c$export$88ef9fdaf11f7a1f = $64289e527bcd600c$var$htmlElement("h5", (0, $2cfd35af7ec11fdd$export$eef1738e402a65e6));
const $64289e527bcd600c$export$a559fb8039b06400 = $64289e527bcd600c$var$htmlElement("h6", (0, $2cfd35af7ec11fdd$export$eef1738e402a65e6));
const $64289e527bcd600c$export$29a7a275fe11687 = $64289e527bcd600c$var$htmlElement("blockquote", (0, $2cfd35af7ec11fdd$export$afa7aa09bb57d54f));
const $64289e527bcd600c$export$52f0f02147b12c03 = $64289e527bcd600c$var$htmlElement("code", (0, $2cfd35af7ec11fdd$export$ec5856072852bd7f));
const $64289e527bcd600c$export$bba54bd7e8a0d398 = $64289e527bcd600c$var$htmlElement("pre", (0, $2cfd35af7ec11fdd$export$cf55d1bff75690da));
const $64289e527bcd600c$export$b04be29aa201d4f5 = $64289e527bcd600c$var$htmlElement("label", (0, $2cfd35af7ec11fdd$export$37aee82a3cb1e8f7));
const $64289e527bcd600c$export$cf840b004443bad7 = $64289e527bcd600c$var$htmlElement("ol", (0, $2cfd35af7ec11fdd$export$84cc8e12a434d4e));
const $64289e527bcd600c$export$f3ebe09c29d85c53 = $64289e527bcd600c$var$htmlElement("ul", (0, $2cfd35af7ec11fdd$export$84cc8e12a434d4e));


const $0b22b1cd0550bc0f$export$acb07b4664ac227c = ({ className: className, title: title, titleId: titleId })=>{
    const dividerClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(title ? (0, $2cfd35af7ec11fdd$exports).MENU_HEADER : (0, $2cfd35af7ec11fdd$exports).MENU_DIVIDER, className);
    return (0, $fc31e5e9fc16a880$exports.jsx)("li", {
        className: dividerClasses,
        role: "separator",
        children: title && (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$a559fb8039b06400), {
            id: titleId,
            children: title
        })
    });
};
$0b22b1cd0550bc0f$export$acb07b4664ac227c.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.MenuDivider`;



var $4df8d6dd78b7faef$exports = {};
$4df8d6dd78b7faef$exports = import.meta.resolve("cUcho");




const $2a5e5a371e3cdc0c$var$Wrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
    width: 100%;
    background: #19212F;
    color: rgba(255, 255, 255, 0.8);
    flex: 1;
    order: -1;
    padding: 1em;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;
const $2a5e5a371e3cdc0c$var$LogoImg = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).img`
    max-width: 180px;
    max-height: 30px;
`;
const $2a5e5a371e3cdc0c$var$BoldMenuItem = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8))`
    font-weight: 600;

    & div {
        color: rgb(24, 32, 38);
    }
`;
const $2a5e5a371e3cdc0c$var$MobileSidebar = ({ user: user = {}, availableOrganisations: availableOrganisations = [], logout: logout, menuItems: menuItems, location: location })=>{
    const theme = (0, $kYL7Z.useContext)((0, $564f85e69a9a6189$export$2c657da244d00bd6));
    const navigate = (0, $3c99a37f3fed1403$export$9770f232ac06a008)();
    const logo = theme && theme.logo && theme.logo.mobile ? `../assets/logos/${theme.logo.mobile}` : (0, (/*@__PURE__*/$parcel$interopDefault($4df8d6dd78b7faef$exports)));
    const activeItem = menuItems.find((item)=>(typeof window === 'object' && item.path) === window.location.pathname);
    const productMenu = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($2a5e5a371e3cdc0c$var$BoldMenuItem, {
                icon: "user",
                disabled: true,
                text: user.email
            }),
            availableOrganisations.length > 1 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d580a4558a21e5b2$export$2e2bcd8739ae039), {
                user: user,
                availableOrganisations: availableOrganisations,
                isMobile: true
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0b22b1cd0550bc0f$export$acb07b4664ac227c), {}),
            menuItems.map((item, index)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                    icon: item.icon,
                    text: item.label,
                    location: location,
                    onClick: (e)=>{
                        if (item.path.includes('https://')) window.location = item.path;
                        else navigate(item.path);
                    },
                    disabled: (typeof window === 'object' && item.path) === window.location.pathname
                }, item.label || index)),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                icon: "log-out",
                text: "Logout",
                onClick: ()=>navigate(logout)
            })
        ]
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($2a5e5a371e3cdc0c$var$Wrapper, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($2a5e5a371e3cdc0c$var$LogoImg, {
                src: logo,
                alt: "Aura Vision Labs logo"
            }),
            (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) !== "prod" && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                large: true,
                intent: (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) === "uat" ? "warning" : "danger",
                style: {
                    textAlign: "center"
                },
                children: (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) === "uat" ? "UAT" : "RISK UNKNOWN ENVIRONMENT"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                children: activeItem && activeItem.label
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                content: productMenu,
                position: (0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42).BOTTOM_LEFT,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    icon: "menu",
                    className: (0, $2cfd35af7ec11fdd$exports).MINIMAL
                })
            })
        ]
    });
};
var $2a5e5a371e3cdc0c$export$2e2bcd8739ae039 = $2a5e5a371e3cdc0c$var$MobileSidebar;



var $kYL7Z = parcelRequire("kYL7Z");


const $8e425011355aeb30$export$4d8a2dd92b1567c6 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
  @media (min-width: ${(0, $c7a73239b47a74cf$export$d07517a676ce386f).TABLET_SIZE_PLUS_1}) {
    display: none;
  }
`;
const $8e425011355aeb30$export$2919e78c90114331 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
  @media (max-width: ${(0, $c7a73239b47a74cf$export$d07517a676ce386f).TABLET_SIZE}) or (min-width: ${(0, $c7a73239b47a74cf$export$d07517a676ce386f).SMALL_PC_SIZE_PLUS_1}) {
      display: none;
  }
`;
const $8e425011355aeb30$export$eb8deef317734844 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
  @media (max-width: ${(0, $c7a73239b47a74cf$export$d07517a676ce386f).SMALL_PC_SIZE}) {
      display: none;
  }
`;
const $8e425011355aeb30$export$f47430f7ffdcc134 = ()=>{
    const [layout, setLayout] = (0, $kYL7Z.useState)('Desktop');
    const handleResize = ()=>{
        let newLayout = 'Desktop';
        switch((0, $c7a73239b47a74cf$export$f72d8951b36b047e)()){
            case (0, $c7a73239b47a74cf$export$d07517a676ce386f).MED_PC_SIZE:
            case (0, $c7a73239b47a74cf$export$d07517a676ce386f).SMALL_PC_SIZE:
                newLayout = 'Desktop';
                break;
            case (0, $c7a73239b47a74cf$export$d07517a676ce386f).TABLET_SIZE:
                newLayout = 'Tablet';
                break;
            case (0, $c7a73239b47a74cf$export$d07517a676ce386f).PHONE_SIZE:
                newLayout = 'Mobile';
        }
        setLayout(newLayout);
    };
    (0, $kYL7Z.useEffect)(()=>{
        window.addEventListener('resize', handleResize);
        handleResize();
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    return layout;
};


// type Props = {
//   user: UserModel.t,
//   showLivePage: boolean,
//   showDemoLivePage: boolean,
//   showHeadcountPlanner: Boolean,
//   logout: (options: Object) => void | Promise<Object>,
//   reports?: ReportModel.t[],
//   location: Object,
// };
// type MenuItemT = {
//   label: string,
//   icon?: string,
//   path: string,
//   children?: MenuItemT[],
// };
const $98c32c04c140ecbc$export$1ba59dacbcbf90fe = (props)=>{
    const menuItems = [
        {
            label: 'Clients',
            icon: 'office',
            path: '/orgs'
        },
        {
            label: 'Locations',
            icon: 'area-of-interest',
            path: '/locs'
        },
        {
            label: 'Devices',
            icon: 'desktop',
            path: '/devs'
        },
        {
            label: 'Cameras',
            icon: 'camera',
            path: '/recs'
        }
    ];
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $8e425011355aeb30$export$4d8a2dd92b1567c6), {
                className: 'sidebar',
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $2a5e5a371e3cdc0c$export$2e2bcd8739ae039), {
                    ...props,
                    logout: '/logout',
                    menuItems: menuItems
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $8e425011355aeb30$export$2919e78c90114331), {
                className: 'sidebar',
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $01469ba6f99a702c$export$2e2bcd8739ae039), {
                    ...props,
                    logout: '/logout',
                    menuItems: menuItems
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $8e425011355aeb30$export$eb8deef317734844), {
                className: 'sidebar',
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $01469ba6f99a702c$export$2e2bcd8739ae039), {
                    ...props,
                    logout: '/logout',
                    menuItems: menuItems
                })
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");









const $884219a1a53516ac$export$d2b2717c8fde48ba = ({ className: className, ...htmlProps })=>{
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).NAVBAR_DIVIDER, className),
        ...htmlProps
    });
};
$884219a1a53516ac$export$d2b2717c8fde48ba.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.NavbarDivider`;








const $9e862aa978dbafac$export$90df0bffe1bcd17c = ({ align: align = (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).START, children: children, className: className, ...htmlProps })=>{
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).NAVBAR_GROUP, (0, $2cfd35af7ec11fdd$exports).alignmentClass(align), className);
    (0, $782dccc2198ae4be$export$fa00fc37980674c4)(()=>{
        if (align === (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).CENTER) console.warn((0, $5bed6f2a5e88b283$export$c616346f9f6261));
    }, [
        align
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: classes,
        ...htmlProps,
        children: children
    });
};
$9e862aa978dbafac$export$90df0bffe1bcd17c.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.NavbarGroup`;






const $f54419ee27121e6c$export$d37a5b1da727490b = ({ children: children, className: className, ...htmlProps })=>{
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).NAVBAR_HEADING, className),
        ...htmlProps,
        children: children
    });
};
$f54419ee27121e6c$export$d37a5b1da727490b.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.NavbarHeading`;


const $be1267437d12fa3a$export$42cfbb80f7861e77 = (props)=>{
    const { children: children, className: className, fixedToTop: fixedToTop, ...htmlProps } = props;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).NAVBAR, {
        [(0, $2cfd35af7ec11fdd$exports).FIXED_TOP]: fixedToTop
    }, className);
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: classes,
        ...htmlProps,
        children: children
    });
};
$be1267437d12fa3a$export$42cfbb80f7861e77.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Navbar`;
// compound components of Navbar
/** @deprecated Use `NavbarDivider` instead */ $be1267437d12fa3a$export$42cfbb80f7861e77.Divider = (0, $884219a1a53516ac$export$d2b2717c8fde48ba);
/** @deprecated Use `NavbarGroup` instead */ $be1267437d12fa3a$export$42cfbb80f7861e77.Group = (0, $9e862aa978dbafac$export$90df0bffe1bcd17c);
/** @deprecated Use `NavbarHeading` instead */ $be1267437d12fa3a$export$42cfbb80f7861e77.Heading = (0, $f54419ee27121e6c$export$d37a5b1da727490b);




var $kYL7Z = parcelRequire("kYL7Z");






var $kYL7Z = parcelRequire("kYL7Z");
const $88fc97e447cf01bc$var$noOpDispatch = ()=>null;
const $88fc97e447cf01bc$export$39ae08fa83328b12 = (0, $kYL7Z.createContext)([
    {},
    $88fc97e447cf01bc$var$noOpDispatch
]);
const $88fc97e447cf01bc$var$tooltipContextReducer = (state, action)=>{
    switch(action.type){
        case "FORCE_DISABLED_STATE":
            return {
                forceDisabled: true
            };
        case "RESET_DISABLED_STATE":
            return {};
        default:
            return state;
    }
};
const $88fc97e447cf01bc$export$f78649fb9ca566b8 = ({ children: children, forceDisable: forceDisable })=>{
    const [state, dispatch] = (0, $kYL7Z.useReducer)($88fc97e447cf01bc$var$tooltipContextReducer, {});
    const contextValue = (0, $kYL7Z.useMemo)(()=>[
            state,
            dispatch
        ], [
        state,
        dispatch
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (forceDisable) dispatch({
            type: "FORCE_DISABLED_STATE"
        });
        else dispatch({
            type: "RESET_DISABLED_STATE"
        });
    }, [
        forceDisable
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)($88fc97e447cf01bc$export$39ae08fa83328b12.Provider, {
        value: contextValue,
        children: typeof children === "function" ? children(state) : children
    });
};


class $19351b9bacb9d9ea$export$28c660c63b792dea extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Tooltip`;
    static defaultProps = {
        compact: false,
        hoverCloseDelay: 0,
        hoverOpenDelay: 100,
        interactionKind: "hover-target",
        minimal: false,
        transitionDuration: 100
    };
    popoverRef = (0, $kYL7Z.createRef)();
    render() {
        // if we have an ancestor TooltipContext, we should take its state into account in this render path,
        // it was likely created by a parent ContextMenu
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $88fc97e447cf01bc$export$39ae08fa83328b12).Consumer, {
            children: ([state])=>(0, $fc31e5e9fc16a880$exports.jsx)((0, $88fc97e447cf01bc$export$f78649fb9ca566b8), {
                    ...state,
                    children: this.renderPopover
                })
        });
    }
    reposition() {
        this.popoverRef.current?.reposition();
    }
    // any descendant ContextMenus may update this ctxState
    renderPopover = (ctxState)=>{
        const { children: children, compact: compact, disabled: disabled, intent: intent, popoverClassName: popoverClassName, ...restProps } = this.props;
        const popoverClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))($2cfd35af7ec11fdd$export$1517edb21b105800, $2cfd35af7ec11fdd$export$6771d82d925c8189(intent), popoverClassName, {
            [$2cfd35af7ec11fdd$export$db1cdb8627b81f84]: compact
        });
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            modifiers: {
                arrow: {
                    enabled: !this.props.minimal
                },
                offset: {
                    options: {
                        offset: [
                            0,
                            (0, $c91d97645d05d63d$export$26419ed1e4945e0) / 2
                        ]
                    }
                }
            },
            ...restProps,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: false,
            disabled: ctxState.forceDisabled ?? disabled,
            enforceFocus: false,
            lazy: true,
            popoverClassName: popoverClasses,
            portalContainer: this.props.portalContainer,
            ref: this.popoverRef,
            children: children
        });
    };
}




const $6fe65c5850c045b1$var$_Navbar = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $be1267437d12fa3a$export$42cfbb80f7861e77))`
    margin-bottom: 1em;
`;
const $6fe65c5850c045b1$var$_PopoverContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 1em;
    text-align: center;
`;
const $6fe65c5850c045b1$var$LinkTag = ({ icon: icon, name: name, path: path, subpaths: subpaths = [] })=>{
    const layout = (0, $8e425011355aeb30$export$f47430f7ffdcc134)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
        interactionKind: "hover",
        hoverOpenDelay: 100,
        hoverCloseDelay: 100,
        disabled: !subpaths.length,
        placement: "bottom",
        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($6fe65c5850c045b1$var$_PopoverContent, {
            children: subpaths.map(({ path: path, name: subname, icon: icon }, index)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("p", {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                        to: path,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                            round: true,
                            large: true,
                            icon: icon,
                            interactive: true,
                            children: `${name} ${subname}`
                        })
                    })
                }, index))
        }),
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
            to: path,
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                title: name,
                round: true,
                large: true,
                interactive: true,
                icon: icon,
                children: layout === 'Desktop' ? name : ""
            })
        })
    });
};
const $6fe65c5850c045b1$var$ConfirmingTag = ({ icon: icon, name: name, onClick: onClick, confirm: confirm = false })=>{
    const [confirmOpen, setConfirmOpen] = (0, $kYL7Z.useState)(false);
    const layout = (0, $8e425011355aeb30$export$f47430f7ffdcc134)();
    return confirm ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
        isOpen: confirmOpen,
        onClose: ()=>setConfirmOpen(false),
        position: "bottom-left",
        shouldReturnFocusOnClose: true,
        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($6fe65c5850c045b1$var$_PopoverContent, {
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$88ef9fdaf11f7a1f), {
                    children: "Sure?"
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    text: "Yes",
                    intent: "success",
                    onClick: onClick
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
            content: name,
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                round: true,
                large: true,
                interactive: true,
                icon: icon,
                onClick: ()=>setConfirmOpen(!confirmOpen),
                children: layout === 'Desktop' ? name : ""
            })
        })
    }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
        content: name,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            round: true,
            large: true,
            interactive: true,
            icon: icon,
            onClick: onClick,
            children: layout === 'Desktop' ? name : ""
        })
    });
};
const $6fe65c5850c045b1$export$fb18b6d37b1923ee = ({ left: left, right: right })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($6fe65c5850c045b1$var$_Navbar, {
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $be1267437d12fa3a$export$42cfbb80f7861e77).Group, {
                    align: (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).LEFT,
                    children: left ? left.map((item)=>{
                        const Component = item.path ? $6fe65c5850c045b1$var$LinkTag : $6fe65c5850c045b1$var$ConfirmingTag;
                        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)(Component, {
                            icon: item.icon,
                            name: item.name,
                            path: item.path,
                            subpaths: item.subpaths,
                            onClick: item.onClick,
                            confirm: item.confirm
                        }, item.name);
                    }) : null
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $be1267437d12fa3a$export$42cfbb80f7861e77).Group, {
                    align: (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).RIGHT,
                    children: right ? right.map((item)=>{
                        const Component = item.path ? $6fe65c5850c045b1$var$LinkTag : $6fe65c5850c045b1$var$ConfirmingTag;
                        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)(Component, {
                            icon: item.icon,
                            name: item.name,
                            path: item.path,
                            subpaths: item.subpaths,
                            onClick: item.onClick,
                            confirm: item.confirm
                        }, item.name);
                    }) : null
                })
            ]
        })
    });







const $5a9cade4af2d6a52$var$formatAreaContextBody = (areaContext, recordingId)=>{
    return JSON.stringify({
        type: areaContext.type,
        areaId: areaContext.areaId,
        taxonomy: areaContext.taxonomy,
        recording: recordingId
    });
};
const $5a9cade4af2d6a52$var$formatLineContextBody = (lineContext, recordingId)=>{
    return JSON.stringify({
        type: lineContext.type,
        actions: lineContext.actions,
        withinLocationMovementKey: lineContext.withinLocationMovementKey,
        recording: recordingId,
        metadata: lineContext.metadata
    });
};
const $5a9cade4af2d6a52$export$a8c677e3fb6cda8a = {
    create: (newAreaContext, recordingId)=>{
        const body = $5a9cade4af2d6a52$var$formatAreaContextBody(newAreaContext, recordingId);
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/areaContext/create`,
            fetchOptions: {
                method: 'POST',
                body: body
            }
        });
    },
    update: (updatedAreaContext, recordingId)=>{
        const body = $5a9cade4af2d6a52$var$formatAreaContextBody(updatedAreaContext, recordingId);
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/areaContext/${updatedAreaContext.id}/update`,
            fetchOptions: {
                method: 'POST',
                body: body
            }
        });
    },
    delete: (deletedAreaContextId)=>(0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/areaContext/${deletedAreaContextId}/delete`,
            fetchOptions: {
                method: 'DELETE'
            },
            responseExpected: false
        })
};
const $5a9cade4af2d6a52$export$4ea2e4f1695ba788 = {
    create: (newLineContext, recordingId)=>{
        const body = $5a9cade4af2d6a52$var$formatLineContextBody(newLineContext, recordingId);
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/lineContext/create`,
            fetchOptions: {
                method: 'POST',
                body: body
            }
        });
    },
    update: (updatedLineContext, recordingId)=>{
        const body = $5a9cade4af2d6a52$var$formatLineContextBody(updatedLineContext, recordingId);
        if (!updatedLineContext.id) return null;
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/lineContext/${updatedLineContext.id}/update`,
            fetchOptions: {
                method: 'POST',
                body: body
            }
        });
    },
    delete: (deletedAreaContextId)=>(0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/lineContext/${deletedAreaContextId}/delete`,
            fetchOptions: {
                method: 'DELETE'
            },
            responseExpected: false
        })
};
const $5a9cade4af2d6a52$export$93b258f6fd606e97 = {
    get: (recId, options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/recording/${recId}?` + (options ? new URLSearchParams(options).toString() : ""),
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    list: (options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/recording/list`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(options || {})
            }
        });
    },
    create: (options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/recording`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(options)
            }
        });
    },
    update: (recId, options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/recording/${recId}`,
            fetchOptions: {
                method: 'PATCH',
                body: JSON.stringify(options || {})
            }
        });
    },
    thumbnail: {
        patch: (recId, options)=>{
            return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
                path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/recording/${recId}/thumbnail`,
                fetchOptions: {
                    method: 'PATCH',
                    body: JSON.stringify(options || {})
                }
            });
        }
    }
};
const $5a9cade4af2d6a52$export$a78349cff2b2c2a0 = {
    get: (recId)=>(0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/recording/${recId}/processingConfig`,
            fetchOptions: {
                method: 'GET'
            }
        }),
    create: (recording, config)=>(0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/processingConfig/create`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify({
                    recording: recording,
                    config: config
                })
            }
        }),
    update: (recording, config)=>(0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/processingConfig/create`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify({
                    recording: recording,
                    config: config
                })
            }
        })
};
const $5a9cade4af2d6a52$export$e67dc8ea625cc8ef = {
    list: (options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/cameraServer/list`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(options || {})
            }
        });
    },
    get: (deviceId, options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/cameraServer/${deviceId}?` + (options ? new URLSearchParams(options).toString() : ""),
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    update: (deviceId, options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/cameraServer/${deviceId}/update`,
            fetchOptions: {
                method: 'PATCH',
                body: JSON.stringify(options || {})
            }
        });
    }
};
const $5a9cade4af2d6a52$export$d030b7498dcede47 = {
    list: ()=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/organisation`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    create: (options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/organisation`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(options || {})
            }
        });
    },
    get: (organisationId)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/organisation/${organisationId}`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    update: (organisationId, options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/organisation/${organisationId}`,
            fetchOptions: {
                method: 'PATCH',
                body: JSON.stringify(options || {})
            }
        });
    },
    userHasMembership: ()=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/organisation/userHasMembership`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    availableMetrics: {
        get: (organisationId)=>{
            return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
                path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/organisation/${organisationId}/availableMetrics`,
                fetchOptions: {
                    method: 'GET'
                }
            });
        },
        update: (organisationId, config)=>{
            return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
                path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/organisation/${organisationId}/availableMetrics`,
                fetchOptions: {
                    method: 'PUT',
                    body: JSON.stringify({
                        config: config
                    })
                }
            });
        }
    }
};
const $5a9cade4af2d6a52$export$c2de8e0aab246379 = {
    list: (options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/location/list`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(options || {})
            }
        });
    },
    get: (locationId, options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/location/${locationId}?` + (options ? new URLSearchParams(options).toString() : ""),
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    create: (options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/location`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(options || {})
            }
        });
    },
    update: (locationId, options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/location/${locationId}`,
            fetchOptions: {
                method: 'PATCH',
                body: JSON.stringify(options || {})
            }
        });
    },
    assignTag: (locationId, tagId, otherOptions)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/location/${locationId}/tag/${tagId}`,
            fetchOptions: {
                method: 'PUT'
            },
            otherOptions: otherOptions
        });
    },
    unassignTag: (locationId, tagId, otherOptions)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/location/${locationId}/tag/${tagId}`,
            fetchOptions: {
                method: 'DELETE'
            },
            otherOptions: otherOptions
        });
    }
};
const $5a9cade4af2d6a52$export$45b22599efdf0a89 = {
    list: (options)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/tags?` + (options ? new URLSearchParams(options).toString() : ""),
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    create: (options, otherOptions)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/tags`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(options || {})
            },
            otherOptions: otherOptions
        });
    }
};
const $5a9cade4af2d6a52$export$557cacc73549007c = {
    create: (recording, config)=>(0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/statElems/create`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify({
                    recording: recording,
                    config: config
                })
            }
        })
};
const $5a9cade4af2d6a52$export$c0572ad6b22dbd1a = {
    list: ()=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/dashboard-report/list`,
            fetchOptions: {
                method: 'GET'
            }
        });
    }
};
const $5a9cade4af2d6a52$export$8fe3681f0fd2c0ee = {
    list: ()=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/scheduled-report-job/list`,
            fetchOptions: {
                method: 'GET'
            }
        });
    },
    create: (payload)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/scheduled-report-job`,
            fetchOptions: {
                method: 'POST',
                body: JSON.stringify(payload)
            }
        });
    },
    update: (id, payload)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/scheduled-report-job/${id}`,
            fetchOptions: {
                method: 'PUT',
                body: JSON.stringify(payload)
            }
        });
    },
    remove: (id)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/scheduled-report-job/${id}`,
            fetchOptions: {
                method: 'DELETE'
            },
            responseExpected: false
        });
    }
};
const $5a9cade4af2d6a52$export$7652f722913b5d7 = {
    profile: ()=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$d43f2f435f160490)}/v1/users/profile`,
            fetchOptions: {
                method: 'GET'
            }
        });
    }
};




var $kYL7Z = parcelRequire("kYL7Z");





var $kYL7Z = parcelRequire("kYL7Z");
const $fb92a67b3e898f78$export$3c1acde371c1f2a2 = /*#__PURE__*/ (0, $kYL7Z.createContext)({});


const $9b223f1af136d4fb$var$HeaderMain = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $be1267437d12fa3a$export$42cfbb80f7861e77))`
  width: 100%;
  margin-bottom: 1em;
  background-color: #19212F;
  color: rgba(255, 255, 255, 0.8);
`;
const $9b223f1af136d4fb$var$OverlayContentStyle = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: block;
    width: 100%;
    height: 100%;
    margin: auto;
    align-content: center;
    //textAlign: center;
`;
const $9b223f1af136d4fb$export$d891e68672c8a87f = ({ children: children })=>{
    const location = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    const [nav, setNav] = (0, $kYL7Z.useState)({});
    const [controls, setControls] = (0, $kYL7Z.useState)([]);
    const [navGroup, _setNavGroup] = (0, $kYL7Z.useState)([]);
    const [loading, _setLoading] = (0, $kYL7Z.useState)({
        status: false,
        location: "?"
    });
    const [count, setCount] = (0, $kYL7Z.useState)(null);
    const [prevPath, setPrevPath] = (0, $kYL7Z.useState)(location.pathname);
    // Reset all nav state when route changes — setState during render
    // runs BEFORE children mount/effects, so children's setNav/setControls
    // won't be wiped (unlike useEffect which fires parent AFTER children)
    if (prevPath !== location.pathname) {
        setPrevPath(location.pathname);
        setNav({});
        setControls([]);
        _setNavGroup([]);
        setCount(null);
    }
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Setting navigation context", loading);
    }, [
        loading
    ]);
    const setNavGroup = (0, $kYL7Z.useCallback)((newNavGroup)=>{
        _setNavGroup(newNavGroup);
        return newNavGroup;
    }, []);
    const setLoading = (0, $kYL7Z.useCallback)((newLoading)=>{
        const ret = {
            status: newLoading.status ?? loading.status,
            location: newLoading.location ?? loading.location
        };
        _setLoading(ret);
        return ret;
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2).Provider, {
        value: {
            nav: nav,
            setNav: setNav,
            controls: controls,
            setControls: setControls,
            navGroup: navGroup,
            setNavGroup: setNavGroup,
            loading: loading,
            setLoading: setLoading,
            setCount: setCount
        },
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aef6e7264f0251d6$export$2e8e2c61dfd53893), {
                    isOpen: loading.status,
                    canOutsideClickClose: false,
                    canEscapeKeyClose: false,
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($9b223f1af136d4fb$var$OverlayContentStyle, {
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                            intent: "primary",
                            size: 100
                        })
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($9b223f1af136d4fb$var$HeaderMain, {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $be1267437d12fa3a$export$42cfbb80f7861e77).Group, {
                        align: "left",
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $be1267437d12fa3a$export$42cfbb80f7861e77).Heading, {
                            children: [
                                count ? `(${count.filtered !== count.total ? `${count.filtered}/${count.total}` : count.total}) - ` : '',
                                loading.location
                            ]
                        })
                    })
                }),
                nav.right?.length || nav.left?.length ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6fe65c5850c045b1$export$fb18b6d37b1923ee), {
                    left: nav.left?.length ? [
                        ...nav.left
                    ] : [],
                    right: nav.right?.length ? [
                        ...nav.right,
                        ...navGroup,
                        ...controls
                    ] : [
                        ...navGroup,
                        ...controls
                    ]
                }) : null,
                children
            ]
        })
    });
};


// ------------------------------
// ------------------------ styles
const $af6fbd639611b05f$var$Wrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
  display: flex;
  height: 100vh;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  background-attachment: fixed;

  @media (max-width: ${(0, $c7a73239b47a74cf$export$d07517a676ce386f).TABLET_SIZE}) {
    flex-direction: column;
    max-width: 100vw;
  }
`;
const $af6fbd639611b05f$var$Content = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).section`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;

  @media (min-width: ${(0, $c7a73239b47a74cf$export$d07517a676ce386f).TABLET_SIZE_PLUS_1}) {
    width: 0;
  }
`;
const $af6fbd639611b05f$var$PageContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin: 1rem;
    max-width: calc(100% - 2rem);
    overflow-x: auto;
`;
// ------------------------------
// ------------------------- page
const $af6fbd639611b05f$export$19246bc72d40c4bc = ()=>{
    const [user, setUser] = (0, $kYL7Z.useState)();
    const [availableOrganisations, setAvailableOrganisations] = (0, $kYL7Z.useState)();
    // on componentDidMount
    (0, $kYL7Z.useEffect)(()=>{
        (0, $5a9cade4af2d6a52$export$7652f722913b5d7).profile().then((_user)=>{
            setUser(_user);
            return (0, $5a9cade4af2d6a52$export$d030b7498dcede47).userHasMembership();
        }).then((_availableOrganisations)=>{
            setAvailableOrganisations(_availableOrganisations);
        });
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($af6fbd639611b05f$var$Wrapper, {
        className: "logged-in",
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $98c32c04c140ecbc$export$1ba59dacbcbf90fe), {
                blur: 0,
                user: user,
                availableOrganisations: availableOrganisations
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($af6fbd639611b05f$var$Content, {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9b223f1af136d4fb$export$d891e68672c8a87f), {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($af6fbd639611b05f$var$PageContainer, {
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$910ae8079b2c2852), {})
                    })
                })
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");


/**
 * Renders common control elements, with additional props to customize appearance.
 * This component is not exported and is only used within this module for `Checkbox`, `Radio`, and `Switch` below.
 */ const $4e9bf29f7973618d$var$ControlInternal = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { alignIndicator: alignIndicator, children: children, className: className, indicatorChildren: indicatorChildren, inline: inline, inputRef: inputRef, label: label, labelElement: labelElement, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
    large, size: size = "medium", style: style, type: type, typeClassName: typeClassName, tagName: tagName = "label", ...htmlProps } = props;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).CONTROL, typeClassName, {
        [(0, $2cfd35af7ec11fdd$exports).DISABLED]: htmlProps.disabled,
        [(0, $2cfd35af7ec11fdd$exports).INLINE]: inline
    }, (0, $2cfd35af7ec11fdd$exports).alignmentClass(alignIndicator), (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
        large: large
    }), className);
    return (0, $kYL7Z.createElement)(tagName, {
        className: classes,
        ref: ref,
        style: style
    }, (0, $fc31e5e9fc16a880$exports.jsx)("input", {
        className: (0, $2cfd35af7ec11fdd$exports).CONTROL_INPUT,
        ...htmlProps,
        ref: inputRef,
        type: type
    }), (0, $fc31e5e9fc16a880$exports.jsx)("span", {
        className: (0, $2cfd35af7ec11fdd$exports).CONTROL_INDICATOR,
        children: indicatorChildren
    }), label, labelElement, children);
});
$4e9bf29f7973618d$var$ControlInternal.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Control`;
const $4e9bf29f7973618d$export$b5d5cf8927ab7262 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { innerLabelChecked: innerLabelChecked, innerLabel: innerLabel, ...controlProps } = props;
    const switchLabels = innerLabel || innerLabelChecked ? [
        (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: (0, $2cfd35af7ec11fdd$exports).CONTROL_INDICATOR_CHILD,
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).SWITCH_INNER_TEXT,
                children: innerLabelChecked ? innerLabelChecked : innerLabel
            })
        }, "checked"),
        (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: (0, $2cfd35af7ec11fdd$exports).CONTROL_INDICATOR_CHILD,
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).SWITCH_INNER_TEXT,
                children: innerLabel
            })
        }, "unchecked")
    ] : null;
    return (0, $fc31e5e9fc16a880$exports.jsx)($4e9bf29f7973618d$var$ControlInternal, {
        ...controlProps,
        indicatorChildren: switchLabels,
        ref: ref,
        type: "checkbox",
        typeClassName: (0, $2cfd35af7ec11fdd$exports).SWITCH
    });
});
$4e9bf29f7973618d$export$b5d5cf8927ab7262.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Switch`;
const $4e9bf29f7973618d$export$d7b12c4107be0d61 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    return (0, $fc31e5e9fc16a880$exports.jsx)($4e9bf29f7973618d$var$ControlInternal, {
        ...props,
        ref: ref,
        type: "radio",
        typeClassName: (0, $2cfd35af7ec11fdd$exports).RADIO
    });
});
$4e9bf29f7973618d$export$d7b12c4107be0d61.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Radio`;
const $4e9bf29f7973618d$export$48513f6b9f8ce62d = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { defaultIndeterminate: defaultIndeterminate, indeterminate: indeterminate, onChange: onChange, ...controlProps } = props;
    const [isIndeterminate, setIsIndeterminate] = (0, $kYL7Z.useState)(indeterminate || defaultIndeterminate || false);
    const localInputRef = (0, $kYL7Z.useRef)(null);
    const inputRef = (0, $7544862da546e887$export$c9058316764c140e)(props.inputRef, localInputRef);
    const handleChange = (0, $kYL7Z.useCallback)((evt)=>{
        // update state immediately only if uncontrolled
        if (indeterminate === undefined) setIsIndeterminate(evt.target.indeterminate);
        // otherwise wait for props change. always invoke handler.
        onChange?.(evt);
    }, [
        indeterminate,
        onChange
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (indeterminate !== undefined) setIsIndeterminate(indeterminate);
    }, [
        indeterminate
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (localInputRef.current != null) localInputRef.current.indeterminate = isIndeterminate;
    }, [
        localInputRef,
        isIndeterminate
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)($4e9bf29f7973618d$var$ControlInternal, {
        ...controlProps,
        inputRef: inputRef,
        onChange: handleChange,
        ref: ref,
        type: "checkbox",
        typeClassName: (0, $2cfd35af7ec11fdd$exports).CHECKBOX
    });
});
$4e9bf29f7973618d$export$48513f6b9f8ce62d.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Checkbox`;




var $kYL7Z = parcelRequire("kYL7Z");



var $6Y6tm = parcelRequire("6Y6tm");








var $6540feeb2a2776f0$export$3351d7ed1d78edaf;
(function(DrawerSize) {
    DrawerSize["SMALL"] = "360px";
    DrawerSize["STANDARD"] = "50%";
    DrawerSize["LARGE"] = "90%";
})($6540feeb2a2776f0$export$3351d7ed1d78edaf || ($6540feeb2a2776f0$export$3351d7ed1d78edaf = {}));
class $6540feeb2a2776f0$export$4071300121a182f5 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Drawer`;
    static defaultProps = {
        canOutsideClickClose: true,
        isOpen: false,
        position: "right",
        style: {}
    };
    render() {
        const { hasBackdrop: hasBackdrop, size: size, style: style, position: position } = this.props;
        const { className: className, children: children, ...overlayProps } = this.props;
        const realPosition = (0, $066a1d9f6e8ad6f2$export$a531f93822c3a253)(position);
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).DRAWER, {
            [(0, $2cfd35af7ec11fdd$exports).positionClass(realPosition) ?? ""]: true
        }, className);
        const styleProp = size == null ? style : {
            ...style,
            [(0, $066a1d9f6e8ad6f2$export$b0b056baf6a0eb37)(realPosition) ? "height" : "width"]: size
        };
        return(// N.B. the `OVERLAY_CONTAINER` class is a bit of a misnomer since it is only being used by the Drawer
        // component, but we keep it for backwards compatibility.
        (0, $fc31e5e9fc16a880$exports.jsx)((0, $aef6e7264f0251d6$export$2e8e2c61dfd53893), {
            ...overlayProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))({
                [(0, $2cfd35af7ec11fdd$exports).OVERLAY_CONTAINER]: hasBackdrop
            }),
            children: (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                className: classes,
                style: styleProp,
                children: [
                    this.maybeRenderHeader(),
                    children
                ]
            })
        }));
    }
    validateProps(props) {
        if (props.title == null) {
            if (props.icon != null) console.warn($5bed6f2a5e88b283$export$2c7c4d8c17b24fc3);
            if (props.isCloseButtonShown != null) console.warn($5bed6f2a5e88b283$export$b1ffdd5a20552cca);
        }
        if (props.position != null) {
            if (props.position !== (0, $066a1d9f6e8ad6f2$export$a531f93822c3a253)(props.position)) console.warn($5bed6f2a5e88b283$export$ee41c46c4147fad0);
        }
    }
    maybeRenderCloseButton() {
        // `isCloseButtonShown` can't be defaulted through default props because of props validation
        // so this check actually defaults it to true (fails only if directly set to false)
        if (this.props.isCloseButtonShown !== false) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
            "aria-label": "Close",
            className: (0, $2cfd35af7ec11fdd$exports).DIALOG_CLOSE_BUTTON,
            icon: (0, $fc31e5e9fc16a880$exports.jsx)((0, $99be9a3184d0ed36$export$81585da998e09b11), {
                size: (0, $6Y6tm.IconSize).LARGE
            }),
            onClick: this.props.onClose,
            variant: "minimal"
        });
        else return null;
    }
    maybeRenderHeader() {
        const { icon: icon, title: title } = this.props;
        if (title == null) return null;
        return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: (0, $2cfd35af7ec11fdd$exports).DRAWER_HEADER,
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                    icon: icon,
                    size: (0, $6Y6tm.IconSize).LARGE
                }),
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$cc5e069d64fda823), {
                    children: title
                }),
                this.maybeRenderCloseButton()
            ]
        });
    }
}





var $kYL7Z = parcelRequire("kYL7Z");



var $kYL7Z = parcelRequire("kYL7Z");


const $0199c8413a0068dd$export$60332b2344f7fe41 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { className: className, elevation: elevation = (0, $214039abae8daf12$export$58bfb4f6ec5aa58d).ZERO, interactive: interactive = false, selected: selected, compact: compact, ...htmlProps } = props;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(className, (0, $2cfd35af7ec11fdd$exports).CARD, (0, $2cfd35af7ec11fdd$exports).elevationClass(elevation), {
        [(0, $2cfd35af7ec11fdd$exports).INTERACTIVE]: interactive,
        [(0, $2cfd35af7ec11fdd$exports).COMPACT]: compact,
        [(0, $2cfd35af7ec11fdd$exports).SELECTED]: selected
    });
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: classes,
        ref: ref,
        ...htmlProps
    });
});
$0199c8413a0068dd$export$60332b2344f7fe41.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Card`;




var $kYL7Z = parcelRequire("kYL7Z");


var $e4a7ce8c396337d4$export$e4d9e886ffb2233;
(function(AnimationStates) {
    /**
     * The body is re-rendered, height is set to the measured body height and
     * the body Y is set to 0.
     */ AnimationStates[AnimationStates["OPEN_START"] = 0] = "OPEN_START";
    /**
     * Animation begins, height is set to auto. This is all animated, and on
     * complete, the state changes to OPEN.
     */ AnimationStates[AnimationStates["OPENING"] = 1] = "OPENING";
    /**
     * The collapse height is set to auto, and the body Y is set to 0 (so the
     * element can be seen as normal).
     */ AnimationStates[AnimationStates["OPEN"] = 2] = "OPEN";
    /**
     * Height has been changed from auto to the measured height of the body to
     * prepare for the closing animation in CLOSING.
     */ AnimationStates[AnimationStates["CLOSING_START"] = 3] = "CLOSING_START";
    /**
     * Height is set to 0 and the body Y is at -height. Both of these properties
     * are transformed, and then after the animation is complete, the state
     * changes to CLOSED.
     */ AnimationStates[AnimationStates["CLOSING"] = 4] = "CLOSING";
    /**
     * The contents of the collapse is not rendered, the collapse height is 0,
     * and the body Y is at -height (so that the bottom of the body is at Y=0).
     */ AnimationStates[AnimationStates["CLOSED"] = 5] = "CLOSED";
})($e4a7ce8c396337d4$export$e4d9e886ffb2233 || ($e4a7ce8c396337d4$export$e4d9e886ffb2233 = {}));
class $e4a7ce8c396337d4$export$78768a9af065a7b extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Collapse`;
    static defaultProps = {
        component: "div",
        isOpen: false,
        keepChildrenMounted: false,
        transitionDuration: 200
    };
    static getDerivedStateFromProps(props, state) {
        const { isOpen: isOpen } = props;
        const { animationState: animationState } = state;
        if (isOpen) switch(animationState){
            case $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPEN:
                break;
            case $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPENING:
                break;
            default:
                return {
                    animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPEN_START
                };
        }
        else switch(animationState){
            case $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSED:
                break;
            case $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSING:
                break;
            default:
                // need to set an explicit height so that transition can work
                return {
                    animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSING_START,
                    height: `${state.heightWhenOpen}px`
                };
        }
        return null;
    }
    state = {
        animationState: this.props.isOpen ? $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPEN : $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSED,
        height: undefined,
        heightWhenOpen: undefined
    };
    // The element containing the contents of the collapse.
    contents = null;
    render() {
        const isContentVisible = this.state.animationState !== $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSED;
        const shouldRenderChildren = isContentVisible || this.props.keepChildrenMounted;
        const displayWithTransform = isContentVisible && this.state.animationState !== $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSING;
        const isAutoHeight = this.state.height === "auto";
        const containerStyle = {
            height: isContentVisible ? this.state.height : undefined,
            overflowY: isAutoHeight ? "visible" : undefined,
            // transitions don't work with height: auto
            transition: isAutoHeight ? "none" : undefined
        };
        const contentsStyle = {
            // only use heightWhenOpen while closing
            transform: displayWithTransform ? "translateY(0)" : `translateY(-${this.state.heightWhenOpen}px)`,
            // transitions don't work with height: auto
            transition: isAutoHeight ? "none" : undefined
        };
        return (0, $kYL7Z.createElement)(this.props.component, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).COLLAPSE, this.props.className),
            style: containerStyle
        }, (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: (0, $2cfd35af7ec11fdd$exports).COLLAPSE_BODY,
            ref: this.contentsRefHandler,
            style: contentsStyle,
            "aria-hidden": !isContentVisible,
            children: shouldRenderChildren ? this.props.children : null
        }));
    }
    componentDidMount() {
        this.forceUpdate();
        // HACKHACK: this should probably be done in getSnapshotBeforeUpdate
        if (this.props.isOpen) this.setState({
            animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPEN,
            height: "auto"
        });
        else this.setState({
            animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSED,
            height: "0px"
        });
    }
    componentDidUpdate() {
        if (this.contents == null) return;
        const { transitionDuration: transitionDuration } = this.props;
        const { animationState: animationState } = this.state;
        if (animationState === $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPEN_START) {
            const { clientHeight: clientHeight } = this.contents;
            this.setState({
                animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPENING,
                height: `${clientHeight}px`,
                heightWhenOpen: clientHeight
            });
            this.setTimeout(()=>this.onDelayedStateChange(), transitionDuration);
        } else if (animationState === $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSING_START) {
            const { clientHeight: clientHeight } = this.contents;
            this.setTimeout(()=>this.setState({
                    animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSING,
                    height: "0px",
                    heightWhenOpen: clientHeight
                }));
            this.setTimeout(()=>this.onDelayedStateChange(), transitionDuration);
        }
    }
    contentsRefHandler = (el)=>{
        this.contents = el;
        if (this.contents != null) {
            const height = this.contents.clientHeight;
            this.setState({
                animationState: this.props.isOpen ? $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPEN : $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSED,
                height: height === 0 ? undefined : `${height}px`,
                heightWhenOpen: height === 0 ? undefined : height
            });
        }
    };
    onDelayedStateChange() {
        switch(this.state.animationState){
            case $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPENING:
                this.setState({
                    animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.OPEN,
                    height: "auto"
                });
                break;
            case $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSING:
                this.setState({
                    animationState: $e4a7ce8c396337d4$export$e4d9e886ffb2233.CLOSED
                });
                break;
            default:
                break;
        }
    }
}




var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");







class $1f28229800ba03f9$export$3ddf2d174ce01153 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static defaultProps = {
        canOutsideClickClose: true,
        isOpen: false,
        titleTagName: (0, $64289e527bcd600c$export$cb94397127ac9363)
    };
    childRef = (0, $kYL7Z.createRef)();
    titleId;
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Dialog`;
    constructor(props){
        super(props);
        const id = (0, $f141b3b4d406798c$export$8b15d37bc3f197d4)("bp-dialog");
        this.titleId = `title-${id}`;
    }
    render() {
        const { className: className, children: children, containerRef: containerRef, style: style, title: title, role: role = "dialog", ...overlayProps } = this.props;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $aef6e7264f0251d6$export$2e8e2c61dfd53893), {
            ...overlayProps,
            className: (0, $2cfd35af7ec11fdd$exports).OVERLAY_SCROLL_CONTAINER,
            childRef: this.childRef,
            hasBackdrop: true,
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).DIALOG_CONTAINER,
                ref: (0, $7544862da546e887$export$c9058316764c140e)(containerRef, this.childRef),
                children: (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).DIALOG, className),
                    role: role,
                    "aria-modal": overlayProps.enforceFocus ?? true,
                    "aria-labelledby": this.props["aria-labelledby"] || (title ? this.titleId : undefined),
                    "aria-describedby": this.props["aria-describedby"],
                    style: style,
                    children: [
                        this.maybeRenderHeader(),
                        children
                    ]
                })
            })
        });
    }
    validateProps(props) {
        if (props.title == null) {
            if (props.icon != null) console.warn($5bed6f2a5e88b283$export$2c7c4d8c17b24fc3);
            if (props.isCloseButtonShown != null) console.warn($5bed6f2a5e88b283$export$b1ffdd5a20552cca);
        }
    }
    maybeRenderCloseButton() {
        // show close button if prop is undefined or null
        // this gives us a behavior as if the default value were `true`
        if (this.props.isCloseButtonShown !== false) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
            "aria-label": "Close",
            className: (0, $2cfd35af7ec11fdd$exports).DIALOG_CLOSE_BUTTON,
            icon: (0, $fc31e5e9fc16a880$exports.jsx)((0, $99be9a3184d0ed36$export$81585da998e09b11), {
                size: (0, $6Y6tm.IconSize).STANDARD
            }),
            onClick: this.props.onClose,
            variant: "minimal"
        });
        else return undefined;
    }
    maybeRenderHeader() {
        const { icon: icon, title: title, titleTagName: TitleTagName = (0, $64289e527bcd600c$export$cb94397127ac9363) } = this.props;
        if (title == null) return undefined;
        return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: (0, $2cfd35af7ec11fdd$exports).DIALOG_HEADER,
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                    icon: icon,
                    size: (0, $6Y6tm.IconSize).STANDARD,
                    "aria-hidden": true,
                    tabIndex: -1
                }),
                (0, $fc31e5e9fc16a880$exports.jsx)(TitleTagName, {
                    id: this.titleId,
                    children: title
                }),
                this.maybeRenderCloseButton()
            ]
        });
    }
}




var $kYL7Z = parcelRequire("kYL7Z");

const $4c25c4a737f23a8e$export$5d20f2c38fcde41f = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { children: children, className: className, useOverflowScrollContainer: useOverflowScrollContainer = true, ...htmlProps } = props;
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        ...htmlProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).DIALOG_BODY, className, {
            [(0, $2cfd35af7ec11fdd$exports).DIALOG_BODY_SCROLL_CONTAINER]: useOverflowScrollContainer
        }),
        ref: ref,
        children: children
    });
});
$4c25c4a737f23a8e$export$5d20f2c38fcde41f.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.DialogBody`;



/**
 * JSON Schema validation using ajv.
 * Returns errors as [{instancePath, message, keyword}].
 */ 
var $24GUP = parcelRequire("24GUP");

var $bYj7Y = parcelRequire("bYj7Y");
var $21b8c9a84345aa8f$exports = {};
"use strict";
Object.defineProperty($21b8c9a84345aa8f$exports, "__esModule", {
    value: true
});

var $dhwai = parcelRequire("dhwai");

var $8vps4 = parcelRequire("8vps4");

var $iCENS = parcelRequire("iCENS");

var $4Gzns = parcelRequire("4Gzns");

var $1Jv02 = parcelRequire("1Jv02");

var $4tUVW = parcelRequire("4tUVW");
const $21b8c9a84345aa8f$var$keyword = "errorMessage";
const $21b8c9a84345aa8f$var$used = new $dhwai.Name("emUsed");
const $21b8c9a84345aa8f$var$KEYWORD_PROPERTY_PARAMS = {
    required: "missingProperty",
    dependencies: "property",
    dependentRequired: "property"
};
const $21b8c9a84345aa8f$var$INTERPOLATION = /\$\{[^}]+\}/;
const $21b8c9a84345aa8f$var$INTERPOLATION_REPLACE = /\$\{([^}]+)\}/g;
const $21b8c9a84345aa8f$var$EMPTY_STR = /^""\s*\+\s*|\s*\+\s*""$/g;
function $21b8c9a84345aa8f$var$errorMessage(options) {
    return {
        keyword: $21b8c9a84345aa8f$var$keyword,
        schemaType: [
            "string",
            "object"
        ],
        post: true,
        code (cxt) {
            const { gen: gen, data: data, schema: schema, schemaValue: schemaValue, it: it } = cxt;
            if (it.createErrors === false) return;
            const sch = schema;
            const instancePath = $8vps4.strConcat($4tUVW.default.instancePath, it.errorPath);
            gen.if($dhwai._`${$4tUVW.default.errors} > 0`, ()=>{
                if (typeof sch == "object") {
                    const [kwdPropErrors, kwdErrors] = keywordErrorsConfig(sch);
                    if (kwdErrors) processKeywordErrors(kwdErrors);
                    if (kwdPropErrors) processKeywordPropErrors(kwdPropErrors);
                    processChildErrors(childErrorsConfig(sch));
                }
                const schMessage = typeof sch == "string" ? sch : sch._;
                if (schMessage) processAllErrors(schMessage);
                if (!options.keepErrors) removeUsedErrors();
            });
            function childErrorsConfig({ properties: properties, items: items }) {
                const errors = {};
                if (properties) {
                    errors.props = {};
                    for(const p in properties)errors.props[p] = [];
                }
                if (items) {
                    errors.items = {};
                    for(let i = 0; i < items.length; i++)errors.items[i] = [];
                }
                return errors;
            }
            function keywordErrorsConfig(emSchema) {
                let propErrors;
                let errors;
                for(const k in emSchema){
                    if (k === "properties" || k === "items") continue;
                    const kwdSch = emSchema[k];
                    if (typeof kwdSch == "object") {
                        propErrors || (propErrors = {});
                        const errMap = propErrors[k] = {};
                        for(const p in kwdSch)errMap[p] = [];
                    } else {
                        errors || (errors = {});
                        errors[k] = [];
                    }
                }
                return [
                    propErrors,
                    errors
                ];
            }
            function processKeywordErrors(kwdErrors) {
                const kwdErrs = gen.const("emErrors", $dhwai.stringify(kwdErrors));
                const templates = gen.const("templates", getTemplatesCode(kwdErrors, schema));
                gen.forOf("err", $4tUVW.default.vErrors, (err)=>gen.if(matchKeywordError(err, kwdErrs), ()=>gen.code($dhwai._`${kwdErrs}[${err}.keyword].push(${err})`).assign($dhwai._`${err}.${$21b8c9a84345aa8f$var$used}`, true)));
                const { singleError: singleError } = options;
                if (singleError) {
                    const message = gen.let("message", $dhwai._`""`);
                    const paramsErrors = gen.let("paramsErrors", $dhwai._`[]`);
                    loopErrors((key)=>{
                        gen.if(message, ()=>gen.code($dhwai._`${message} += ${typeof singleError == "string" ? singleError : ";"}`));
                        gen.code($dhwai._`${message} += ${errMessage(key)}`);
                        gen.assign(paramsErrors, $dhwai._`${paramsErrors}.concat(${kwdErrs}[${key}])`);
                    });
                    $1Jv02.reportError(cxt, {
                        message: message,
                        params: $dhwai._`{errors: ${paramsErrors}}`
                    });
                } else loopErrors((key)=>$1Jv02.reportError(cxt, {
                        message: errMessage(key),
                        params: $dhwai._`{errors: ${kwdErrs}[${key}]}`
                    }));
                function loopErrors(body) {
                    gen.forIn("key", kwdErrs, (key)=>gen.if($dhwai._`${kwdErrs}[${key}].length`, ()=>body(key)));
                }
                function errMessage(key) {
                    return $dhwai._`${key} in ${templates} ? ${templates}[${key}]() : ${schemaValue}[${key}]`;
                }
            }
            function processKeywordPropErrors(kwdPropErrors) {
                const kwdErrs = gen.const("emErrors", $dhwai.stringify(kwdPropErrors));
                const templatesCode = [];
                for(const k in kwdPropErrors)templatesCode.push([
                    k,
                    getTemplatesCode(kwdPropErrors[k], schema[k])
                ]);
                const templates = gen.const("templates", gen.object(...templatesCode));
                const kwdPropParams = gen.scopeValue("obj", {
                    ref: $21b8c9a84345aa8f$var$KEYWORD_PROPERTY_PARAMS,
                    code: $dhwai.stringify($21b8c9a84345aa8f$var$KEYWORD_PROPERTY_PARAMS)
                });
                const propParam = gen.let("emPropParams");
                const paramsErrors = gen.let("emParamsErrors");
                gen.forOf("err", $4tUVW.default.vErrors, (err)=>gen.if(matchKeywordError(err, kwdErrs), ()=>{
                        gen.assign(propParam, $dhwai._`${kwdPropParams}[${err}.keyword]`);
                        gen.assign(paramsErrors, $dhwai._`${kwdErrs}[${err}.keyword][${err}.params[${propParam}]]`);
                        gen.if(paramsErrors, ()=>gen.code($dhwai._`${paramsErrors}.push(${err})`).assign($dhwai._`${err}.${$21b8c9a84345aa8f$var$used}`, true));
                    }));
                gen.forIn("key", kwdErrs, (key)=>gen.forIn("keyProp", $dhwai._`${kwdErrs}[${key}]`, (keyProp)=>{
                        gen.assign(paramsErrors, $dhwai._`${kwdErrs}[${key}][${keyProp}]`);
                        gen.if($dhwai._`${paramsErrors}.length`, ()=>{
                            const tmpl = gen.const("tmpl", $dhwai._`${templates}[${key}] && ${templates}[${key}][${keyProp}]`);
                            $1Jv02.reportError(cxt, {
                                message: $dhwai._`${tmpl} ? ${tmpl}() : ${schemaValue}[${key}][${keyProp}]`,
                                params: $dhwai._`{errors: ${paramsErrors}}`
                            });
                        });
                    }));
            }
            function processChildErrors(childErrors) {
                const { props: props, items: items } = childErrors;
                if (!props && !items) return;
                const isObj = $dhwai._`typeof ${data} == "object"`;
                const isArr = $dhwai._`Array.isArray(${data})`;
                const childErrs = gen.let("emErrors");
                let childKwd;
                let childProp;
                const templates = gen.let("templates");
                if (props && items) {
                    childKwd = gen.let("emChildKwd");
                    gen.if(isObj);
                    gen.if(isArr, ()=>{
                        init(items, schema.items);
                        gen.assign(childKwd, $dhwai.str`items`);
                    }, ()=>{
                        init(props, schema.properties);
                        gen.assign(childKwd, $dhwai.str`properties`);
                    });
                    childProp = $dhwai._`[${childKwd}]`;
                } else if (items) {
                    gen.if(isArr);
                    init(items, schema.items);
                    childProp = $dhwai._`.items`;
                } else if (props) {
                    gen.if($8vps4.and(isObj, $8vps4.not(isArr)));
                    init(props, schema.properties);
                    childProp = $dhwai._`.properties`;
                }
                gen.forOf("err", $4tUVW.default.vErrors, (err)=>ifMatchesChildError(err, childErrs, (child)=>gen.code($dhwai._`${childErrs}[${child}].push(${err})`).assign($dhwai._`${err}.${$21b8c9a84345aa8f$var$used}`, true)));
                gen.forIn("key", childErrs, (key)=>gen.if($dhwai._`${childErrs}[${key}].length`, ()=>{
                        $1Jv02.reportError(cxt, {
                            message: $dhwai._`${key} in ${templates} ? ${templates}[${key}]() : ${schemaValue}${childProp}[${key}]`,
                            params: $dhwai._`{errors: ${childErrs}[${key}]}`
                        });
                        gen.assign($dhwai._`${$4tUVW.default.vErrors}[${$4tUVW.default.errors}-1].instancePath`, $dhwai._`${instancePath} + "/" + ${key}.replace(/~/g, "~0").replace(/\\//g, "~1")`);
                    }));
                gen.endIf();
                function init(children, msgs) {
                    gen.assign(childErrs, $dhwai.stringify(children));
                    gen.assign(templates, getTemplatesCode(children, msgs));
                }
            }
            function processAllErrors(schMessage) {
                const errs = gen.const("emErrs", $dhwai._`[]`);
                gen.forOf("err", $4tUVW.default.vErrors, (err)=>gen.if(matchAnyError(err), ()=>gen.code($dhwai._`${errs}.push(${err})`).assign($dhwai._`${err}.${$21b8c9a84345aa8f$var$used}`, true)));
                gen.if($dhwai._`${errs}.length`, ()=>$1Jv02.reportError(cxt, {
                        message: templateExpr(schMessage),
                        params: $dhwai._`{errors: ${errs}}`
                    }));
            }
            function removeUsedErrors() {
                const errs = gen.const("emErrs", $dhwai._`[]`);
                gen.forOf("err", $4tUVW.default.vErrors, (err)=>gen.if($dhwai._`!${err}.${$21b8c9a84345aa8f$var$used}`, ()=>gen.code($dhwai._`${errs}.push(${err})`)));
                gen.assign($4tUVW.default.vErrors, errs).assign($4tUVW.default.errors, $dhwai._`${errs}.length`);
            }
            function matchKeywordError(err, kwdErrs) {
                return $8vps4.and($dhwai._`${err}.keyword !== ${$21b8c9a84345aa8f$var$keyword}`, $dhwai._`!${err}.${$21b8c9a84345aa8f$var$used}`, $dhwai._`${err}.instancePath === ${instancePath}`, $dhwai._`${err}.keyword in ${kwdErrs}`, // TODO match the end of the string?
                $dhwai._`${err}.schemaPath.indexOf(${it.errSchemaPath}) === 0`, $dhwai._`/^\\/[^\\/]*$/.test(${err}.schemaPath.slice(${it.errSchemaPath.length}))`);
            }
            function ifMatchesChildError(err, childErrs, thenBody) {
                gen.if($8vps4.and($dhwai._`${err}.keyword !== ${$21b8c9a84345aa8f$var$keyword}`, $dhwai._`!${err}.${$21b8c9a84345aa8f$var$used}`, $dhwai._`${err}.instancePath.indexOf(${instancePath}) === 0`), ()=>{
                    const childRegex = gen.scopeValue("pattern", {
                        ref: /^\/([^/]*)(?:\/|$)/,
                        code: $dhwai._`new RegExp("^\\\/([^/]*)(?:\\\/|$)")`
                    });
                    const matches = gen.const("emMatches", $dhwai._`${childRegex}.exec(${err}.instancePath.slice(${instancePath}.length))`);
                    const child = gen.const("emChild", $dhwai._`${matches} && ${matches}[1].replace(/~1/g, "/").replace(/~0/g, "~")`);
                    gen.if($dhwai._`${child} !== undefined && ${child} in ${childErrs}`, ()=>thenBody(child));
                });
            }
            function matchAnyError(err) {
                return $8vps4.and($dhwai._`${err}.keyword !== ${$21b8c9a84345aa8f$var$keyword}`, $dhwai._`!${err}.${$21b8c9a84345aa8f$var$used}`, $8vps4.or($dhwai._`${err}.instancePath === ${instancePath}`, $8vps4.and($dhwai._`${err}.instancePath.indexOf(${instancePath}) === 0`, $dhwai._`${err}.instancePath[${instancePath}.length] === "/"`)), $dhwai._`${err}.schemaPath.indexOf(${it.errSchemaPath}) === 0`, $dhwai._`${err}.schemaPath[${it.errSchemaPath}.length] === "/"`);
            }
            function getTemplatesCode(keys, msgs) {
                const templatesCode = [];
                for(const k in keys){
                    const msg = msgs[k];
                    if ($21b8c9a84345aa8f$var$INTERPOLATION.test(msg)) templatesCode.push([
                        k,
                        templateFunc(msg)
                    ]);
                }
                return gen.object(...templatesCode);
            }
            function templateExpr(msg) {
                if (!$21b8c9a84345aa8f$var$INTERPOLATION.test(msg)) return $dhwai.stringify(msg);
                return new $iCENS._Code($iCENS.safeStringify(msg).replace($21b8c9a84345aa8f$var$INTERPOLATION_REPLACE, (_s, ptr)=>`" + JSON.stringify(${$4Gzns.getData(ptr, it)}) + "`).replace($21b8c9a84345aa8f$var$EMPTY_STR, ""));
            }
            function templateFunc(msg) {
                return $dhwai._`function(){return ${templateExpr(msg)}}`;
            }
        },
        metaSchema: {
            anyOf: [
                {
                    type: "string"
                },
                {
                    type: "object",
                    properties: {
                        properties: {
                            $ref: "#/$defs/stringMap"
                        },
                        items: {
                            $ref: "#/$defs/stringList"
                        },
                        required: {
                            $ref: "#/$defs/stringOrMap"
                        },
                        dependencies: {
                            $ref: "#/$defs/stringOrMap"
                        }
                    },
                    additionalProperties: {
                        type: "string"
                    }
                }
            ],
            $defs: {
                stringMap: {
                    type: "object",
                    additionalProperties: {
                        type: "string"
                    }
                },
                stringOrMap: {
                    anyOf: [
                        {
                            type: "string"
                        },
                        {
                            $ref: "#/$defs/stringMap"
                        }
                    ]
                },
                stringList: {
                    type: "array",
                    items: {
                        type: "string"
                    }
                }
            }
        }
    };
}
const $21b8c9a84345aa8f$var$ajvErrors = (ajv, options = {})=>{
    if (!ajv.opts.allErrors) throw new Error("ajv-errors: Ajv option allErrors must be true");
    if (ajv.opts.jsPropertySyntax) throw new Error("ajv-errors: ajv option jsPropertySyntax is not supported");
    return ajv.addKeyword($21b8c9a84345aa8f$var$errorMessage(options));
};
$21b8c9a84345aa8f$exports.default = $21b8c9a84345aa8f$var$ajvErrors;
$21b8c9a84345aa8f$exports = $21b8c9a84345aa8f$var$ajvErrors;
$21b8c9a84345aa8f$exports.default = $21b8c9a84345aa8f$var$ajvErrors;


const $adeac7fc1fb1e32e$var$ajv = new (0, (/*@__PURE__*/$parcel$interopDefault($24GUP)))({
    allErrors: true,
    strictTypes: false
});
(0, (/*@__PURE__*/$parcel$interopDefault($bYj7Y)))($adeac7fc1fb1e32e$var$ajv);
(0, (/*@__PURE__*/$parcel$interopDefault($21b8c9a84345aa8f$exports)))($adeac7fc1fb1e32e$var$ajv);
const $adeac7fc1fb1e32e$var$cache = new WeakMap();
const $adeac7fc1fb1e32e$var$getValidator = (schema)=>{
    if ($adeac7fc1fb1e32e$var$cache.has(schema)) return $adeac7fc1fb1e32e$var$cache.get(schema);
    const compiled = $adeac7fc1fb1e32e$var$ajv.compile(schema);
    $adeac7fc1fb1e32e$var$cache.set(schema, compiled);
    return compiled;
};
const $adeac7fc1fb1e32e$export$44b5bed83342a92f = (obj, path)=>{
    let current = obj;
    for (const key of path){
        if (current == null) return undefined;
        current = current[key];
    }
    return current;
};
const $adeac7fc1fb1e32e$export$106587181eda0dce = (base, overlay)=>{
    if (overlay == null) return base;
    if (base == null) return overlay;
    if (typeof base !== 'object' || typeof overlay !== 'object') return overlay;
    if (Array.isArray(overlay)) return overlay;
    const result = {
        ...base
    };
    for (const [key, val] of Object.entries(overlay))result[key] = $adeac7fc1fb1e32e$export$106587181eda0dce(result[key], val);
    return result;
};
const $adeac7fc1fb1e32e$export$d463cb62e398d222 = (schema, path, data)=>{
    let current = schema;
    let currentData = data;
    for (const key of path){
        if (!current) return undefined;
        // Apply triggered dependentSchemas at this level
        if (currentData && typeof currentData === 'object' && !Array.isArray(currentData) && current.dependentSchemas) {
            for (const [depKey, depSchema] of Object.entries(current.dependentSchemas))if (depKey in currentData) current = $adeac7fc1fb1e32e$export$106587181eda0dce(current, depSchema);
        }
        current = current.properties?.[key];
        currentData = currentData?.[key];
    }
    return current;
};
const $adeac7fc1fb1e32e$export$a22775fa5e2eebd9 = (schema, data)=>{
    if (!schema || !data) return [];
    const compiled = $adeac7fc1fb1e32e$var$getValidator(schema);
    compiled(data);
    const errors = [];
    const seen = new Set();
    // Map ajv errors — remap required errors from parent to child path
    for (const err of compiled.errors || []){
        let instancePath = err.instancePath;
        let message = err.message;
        let keyword = err.keyword;
        if (err.keyword === 'required') {
            instancePath = (err.instancePath || '') + '/' + err.params.missingProperty;
            message = 'is a required property';
        } else if (err.keyword === 'errorMessage' && err.params?.errors?.[0]?.keyword === 'required') {
            const inner = err.params.errors[0];
            instancePath = (err.instancePath || '') + '/' + inner.params.missingProperty;
        }
        if (!seen.has(instancePath)) {
            seen.add(instancePath);
            errors.push({
                instancePath: instancePath,
                message: message,
                keyword: keyword
            });
        }
    }
    // UI-specific: treat empty strings and empty arrays as missing for required fields
    // (JSON Schema required only checks property existence, not emptiness)
    const checkEmpty = (propSchema, obj, pathPrefix)=>{
        const reqFields = propSchema?.required || [];
        for (const [key, fieldSchema] of Object.entries(propSchema?.properties || {})){
            const instancePath = pathPrefix + '/' + key;
            const value = obj?.[key];
            if (fieldSchema.type === 'object' && fieldSchema.properties) checkEmpty(fieldSchema, value, instancePath);
            else if (fieldSchema.type === 'array' && fieldSchema.items?.type === 'object' && fieldSchema.items?.properties && Array.isArray(value)) value.forEach((item, index)=>{
                checkEmpty(fieldSchema.items, item, instancePath + '/' + index);
            });
            else if (reqFields.includes(key) && !seen.has(instancePath)) {
                const empty = value === '' || Array.isArray(value) && value.length === 0;
                if (empty) {
                    seen.add(instancePath);
                    errors.push({
                        instancePath: instancePath,
                        message: 'is a required property',
                        keyword: 'required'
                    });
                }
            }
        }
        // Recurse into additionalProperties entries
        const addlSchema = propSchema.additionalProperties;
        if (addlSchema && typeof addlSchema === 'object' && addlSchema.properties && obj && typeof obj === 'object') {
            for (const [key, value] of Object.entries(obj))if (!propSchema.properties?.[key]) checkEmpty(addlSchema, value, pathPrefix + '/' + key);
        }
    };
    checkEmpty(schema, data, '');
    return errors;
};



parcelRequire("kYL7Z");



var $kYL7Z = parcelRequire("kYL7Z");




const $15cb308855229ba4$export$2d00230e1e6f7fbc = (props)=>{
    const { children: children, className: className, contentClassName: contentClassName, disabled: disabled, fill: fill, helperText: helperText, inline: inline, intent: intent, label: label, labelFor: labelFor, labelInfo: labelInfo, style: style, subLabel: subLabel, ...htmlProps } = props;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).FORM_GROUP, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), {
        [(0, $2cfd35af7ec11fdd$exports).DISABLED]: disabled,
        [(0, $2cfd35af7ec11fdd$exports).FILL]: fill,
        [(0, $2cfd35af7ec11fdd$exports).INLINE]: inline
    }, className);
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: classes,
        style: style,
        ...htmlProps,
        children: [
            label && (0, $fc31e5e9fc16a880$exports.jsxs)("label", {
                className: (0, $2cfd35af7ec11fdd$exports).LABEL,
                htmlFor: labelFor,
                children: [
                    label,
                    " ",
                    (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                        className: (0, $2cfd35af7ec11fdd$exports).TEXT_MUTED,
                        children: labelInfo
                    })
                ]
            }),
            subLabel && (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).FORM_GROUP_SUB_LABEL,
                children: subLabel
            }),
            (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).FORM_CONTENT, contentClassName),
                children: [
                    children,
                    helperText && (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                        className: (0, $2cfd35af7ec11fdd$exports).FORM_HELPER_TEXT,
                        children: helperText
                    })
                ]
            })
        ]
    });
};
$15cb308855229ba4$export$2d00230e1e6f7fbc.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.FormGroup`;



const $4a49823ead28a6dc$export$d2615da4cc5487a7 = /*#__PURE__*/ (0, $kYL7Z.createContext)(null);
const $4a49823ead28a6dc$export$53146c55f8a78b = /*#__PURE__*/ (0, $kYL7Z.createContext)(null);
const $4a49823ead28a6dc$export$9cda184b27147279 = (0, $564f85e69a9a6189$export$dbf350e5966cf602)`
    --sf-vertical-gap: 0.25em;
    --sf-horizontal-gap: 0.5em;
    --sf-group-padding: 12px;
    --sf-group-margin: 0.75em;
    --sf-group-label-color: inherit;
    --sf-group-label-size: inherit;
    --sf-label-color: inherit;
    --sf-label-size: inherit;
    --sf-label-weight: 600;
    --sf-border-radius: 20px;
    --sf-group-background: white;
    --sf-group-shadow: 0 0 0 1px rgba(17, 20, 24, 0.15), 0 0 0 rgba(17, 20, 24, 0), 0 1px 1px rgba(17, 20, 24, 0.2);
    --sf-text-align: left;
`;
const $4a49823ead28a6dc$export$cacf2b92a5669314 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc))`
    label[class*="bp"][class*="-label"] {
        color: var(--sf-label-color);
        font-size: var(--sf-label-size);
        font-weight: var(--sf-label-weight);
    }
`;
const $4a49823ead28a6dc$export$5f513dadd988fceb = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    & [class*="bp"][class*="-input-group"],
    & [class*="bp"][class*="-input-group"] > [class*="bp"][class*="-input"],
    & textarea[class*="bp"][class*="-input"] {
        border-radius: var(--sf-border-radius) !important;
    }
    & [class*="bp"][class*="-input"],
    & textarea[class*="bp"][class*="-input"] {
        text-align: var(--sf-text-align);
    }
`;
const $4a49823ead28a6dc$var$errorMessage = (e)=>{
    if (e.keyword === 'errorMessage') return e.message;
    const prop = e.instancePath ? e.instancePath.split('/').pop() : null;
    if (prop && e.keyword === 'required') return `"${prop}" is required`;
    if (prop) return `"${prop}" ${e.message}`;
    return e.message;
};
const $4a49823ead28a6dc$export$270fdfb6d7e81102 = ({ errors: errors, onClick: onClick })=>{
    if (!errors || !errors.length) return null;
    const count = errors.length;
    if (count === 1) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        intent: "danger",
        minimal: true,
        round: true,
        interactive: !!onClick,
        onClick: onClick,
        children: $4a49823ead28a6dc$var$errorMessage(errors[0])
    });
    const tip = errors.slice(0, 3).map((e)=>$4a49823ead28a6dc$var$errorMessage(e)).join('\n') + (count > 3 ? `\n... and ${count - 3} more` : '');
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
            style: {
                whiteSpace: 'pre-line'
            },
            children: tip
        }),
        placement: "top",
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            intent: "danger",
            minimal: true,
            round: true,
            interactive: true,
            onClick: onClick,
            children: [
                count,
                " errors"
            ]
        })
    });
};


const $ae01e54584616062$export$2c73285ae9390cec = ({ label: label, value: value, disabled: disabled, error: error, nullable: nullable, optional: optional, icon: icon, onChange: onChange })=>{
    const intent = error ? 'danger' : 'none';
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        helperText: error?.message,
        intent: intent,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$5f513dadd988fceb), {
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                fill: true,
                value: value ?? '',
                disabled: disabled,
                intent: intent,
                leftIcon: icon,
                placeholder: optional ? '(optional)' : undefined,
                onChange: (e)=>{
                    const v = e.target.value;
                    onChange(nullable && v === '' ? null : v);
                }
            })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




const $ff643fbd30c6097b$var$SelectButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    &[class*="bp"][class*="-button"] {
        border-radius: var(--sf-border-radius) !important;
        width: ${(p)=>p.fill ? '100%' : 'fit-content'};
        justify-content: space-between;
        background: transparent !important;
        box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2) !important;
    }
`;
const $ff643fbd30c6097b$var$IS_TOUCH = typeof window !== 'undefined' && ('ontouchstart' in window || navigator.maxTouchPoints > 0);
const $ff643fbd30c6097b$var$EMPTY_ITEM = {
    label: '\u2014 Empty \u2014',
    value: ''
};
const $ff643fbd30c6097b$var$filterItem = (query, item)=>{
    if (!query) return true;
    return item.label.toLowerCase().includes(query.toLowerCase());
};
const $ff643fbd30c6097b$export$d55b50a564d0b931 = ({ label: label, value: value, options: initialOptions, disabled: disabled, error: error, icon: icon, required: required, allowCreate: allowCreate, fill: fill, matchTargetWidth: matchTargetWidth, onChange: onChange })=>{
    const intent = error ? 'danger' : 'none';
    const options = (0, $kYL7Z.useMemo)(()=>{
        const sorted = [
            ...initialOptions
        ].sort((a, b)=>a.label.localeCompare(b.label));
        if (allowCreate && value && !sorted.find((o)=>o.value === value)) return [
            ...sorted,
            {
                label: String(value),
                value: value
            }
        ];
        return sorted;
    }, [
        initialOptions,
        value,
        allowCreate
    ]);
    const allItems = required ? options : [
        $ff643fbd30c6097b$var$EMPTY_ITEM,
        ...options
    ];
    const selected = options.find((o)=>o.value === value);
    const displayText = selected?.label ?? (required ? 'Not selected' : $ff643fbd30c6097b$var$EMPTY_ITEM.label);
    const handleCreateItem = (0, $kYL7Z.useCallback)((query)=>({
            label: query,
            value: query
        }), []);
    const renderCreateItem = (0, $kYL7Z.useCallback)((query, active, handleClick)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
            icon: "add",
            text: `Use "${query}"`,
            active: active,
            onClick: handleClick
        }, "__create__"), []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        helperText: error?.message,
        intent: intent,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
            items: allItems,
            itemRenderer: (item, { handleClick: handleClick, modifiers: modifiers, index: index })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                    text: item.label,
                    active: modifiers.active,
                    selected: item.value === value,
                    disabled: modifiers.disabled,
                    onClick: handleClick
                }, `${item.value}-${index}`),
            itemPredicate: $ff643fbd30c6097b$var$filterItem,
            onItemSelect: (item)=>onChange(item.value || undefined),
            disabled: disabled,
            resetOnClose: true,
            popoverProps: {
                minimal: true,
                matchTargetWidth: matchTargetWidth ?? !!fill,
                popoverClassName: 'sf-select-popover'
            },
            popoverContentProps: {
                style: {
                    maxHeight: 450,
                    overflowY: 'auto'
                }
            },
            filterable: true,
            inputProps: $ff643fbd30c6097b$var$IS_TOUCH ? {
                autoFocus: false
            } : undefined,
            createNewItemFromQuery: allowCreate ? handleCreateItem : undefined,
            createNewItemRenderer: allowCreate ? renderCreateItem : undefined,
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($ff643fbd30c6097b$var$SelectButton, {
                text: displayText,
                rightIcon: "chevron-down",
                icon: icon,
                disabled: disabled,
                fill: fill
            })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");



var $6Y6tm = parcelRequire("6Y6tm");







var $kYL7Z = parcelRequire("kYL7Z");

const $7b699d8fd359edb7$export$d635389915ad9268 = (0, $kYL7Z.forwardRef)(function ResizableInput(props, ref) {
    const [content, setContent] = (0, $kYL7Z.useState)("");
    const [width, setWidth] = (0, $kYL7Z.useState)(0);
    const span = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useEffect)(()=>{
        if (span.current != null) setWidth(span.current.offsetWidth);
    }, [
        content
    ]);
    const { onChange: onChange, style: style, ...otherProps } = props;
    const handleInputChange = (evt)=>{
        onChange?.(evt);
        setContent(evt?.target?.value ?? "");
    };
    return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                ref: span,
                className: (0, $2cfd35af7ec11fdd$exports).RESIZABLE_INPUT_SPAN,
                "aria-hidden": true,
                children: content.replace(/ /g, "\u00a0")
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)("input", {
                ...otherProps,
                type: "text",
                style: {
                    ...style,
                    width: width
                },
                onChange: handleInputChange,
                ref: ref
            })
        ]
    });
});
$7b699d8fd359edb7$export$d635389915ad9268.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.ResizableInput`;


/** special value for absence of active tag */ const $207f15f337a35162$var$NONE = -1;
class $207f15f337a35162$export$39299b56cfd4e361 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.TagInput`;
    static defaultProps = {
        addOnBlur: false,
        addOnPaste: true,
        autoResize: false,
        inputProps: {},
        separator: /[,\n\r]/,
        tagProps: {}
    };
    static getDerivedStateFromProps(props, state) {
        if (props.inputValue !== state.prevInputValueProp) return {
            inputValue: props.inputValue,
            prevInputValueProp: props.inputValue
        };
        return null;
    }
    state = {
        activeIndex: $207f15f337a35162$var$NONE,
        inputValue: this.props.inputValue || "",
        isInputFocused: false
    };
    inputElement = null;
    handleRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "inputElement", this.props.inputRef);
    render() {
        const { autoResize: autoResize, className: className, disabled: disabled, fill: fill, inputProps: inputProps, intent: intent, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
        large, leftIcon: leftIcon, placeholder: placeholder, size: size = "medium", values: values } = this.props;
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).INPUT, (0, $2cfd35af7ec11fdd$exports).TAG_INPUT, {
            [(0, $2cfd35af7ec11fdd$exports).ACTIVE]: this.state.isInputFocused,
            [(0, $2cfd35af7ec11fdd$exports).DISABLED]: disabled,
            [(0, $2cfd35af7ec11fdd$exports).FILL]: fill
        }, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
            large: large
        }), className);
        const isLarge = classes.indexOf((0, $2cfd35af7ec11fdd$exports).LARGE) > $207f15f337a35162$var$NONE;
        // use placeholder prop only if it's defined and values list is empty or contains only falsy values
        const isSomeValueDefined = values.some((val)=>!!val);
        const resolvedPlaceholder = placeholder == null || isSomeValueDefined ? inputProps?.placeholder : placeholder;
        // final props that may be sent to <input> or <ResizableInput>
        const resolvedInputProps = {
            value: this.state.inputValue,
            ...inputProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).INPUT_GHOST, inputProps?.className),
            disabled: disabled,
            onChange: this.handleInputChange,
            onFocus: this.handleInputFocus,
            onKeyDown: this.handleInputKeyDown,
            onKeyUp: this.handleInputKeyUp,
            onPaste: this.handleInputPaste,
            placeholder: resolvedPlaceholder,
            ref: this.handleRef
        };
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- container delegates interaction to input element
        (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: classes,
            onBlur: this.handleContainerBlur,
            onClick: this.handleContainerClick,
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                    className: (0, $2cfd35af7ec11fdd$exports).TAG_INPUT_ICON,
                    icon: leftIcon,
                    size: isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD
                }),
                (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    className: (0, $2cfd35af7ec11fdd$exports).TAG_INPUT_VALUES,
                    children: [
                        values.map(this.maybeRenderTag),
                        this.props.children,
                        autoResize ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $7b699d8fd359edb7$export$d635389915ad9268), {
                            ...resolvedInputProps
                        }) : (0, $fc31e5e9fc16a880$exports.jsx)("input", {
                            ...resolvedInputProps
                        })
                    ]
                }),
                this.props.rightElement
            ]
        }));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.inputRef !== this.props.inputRef) {
            (0, $7544862da546e887$export$4bb192c7cacf928f)(prevProps.inputRef, null);
            this.handleRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "inputElement", this.props.inputRef);
            (0, $7544862da546e887$export$4bb192c7cacf928f)(this.props.inputRef, this.inputElement);
        }
    }
    addTags = (value, method = "default")=>{
        const { inputValue: inputValue, onAdd: onAdd, onChange: onChange, values: values } = this.props;
        const newValues = this.getValues(value);
        let shouldClearInput = onAdd?.(newValues, method) !== false && inputValue === undefined;
        // avoid a potentially expensive computation if this prop is omitted
        if ((0, $5f04c694ca05154e$exports).isFunction(onChange)) shouldClearInput = onChange([
            ...values,
            ...newValues
        ]) !== false && shouldClearInput;
        // only explicit return false cancels text clearing
        if (shouldClearInput) this.setState({
            inputValue: ""
        });
    };
    maybeRenderTag = (tag, index)=>{
        if (!tag) return null;
        // eslint-disable-next-line @typescript-eslint/no-deprecated
        const { large: large, size: size, tagProps: tagProps } = this.props;
        const props = (0, $5f04c694ca05154e$exports).isFunction(tagProps) ? tagProps(tag, index) : tagProps;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            active: index === this.state.activeIndex,
            "data-tag-index": index,
            // eslint-disable-next-line @typescript-eslint/no-deprecated
            large: large,
            onRemove: this.props.disabled ? undefined : this.handleRemoveTag,
            size: size,
            ...props,
            children: tag
        }, tag + "__" + index);
    };
    getNextActiveIndex(direction) {
        const { activeIndex: activeIndex } = this.state;
        if (activeIndex === $207f15f337a35162$var$NONE) // nothing active & moving left: select last defined value. otherwise select nothing.
        return direction < 0 ? this.findNextIndex(this.props.values.length, -1) : $207f15f337a35162$var$NONE;
        else // otherwise, move in direction and clamp to bounds.
        // note that upper bound allows going one beyond last item
        // so focus can move off the right end, into the text input.
        return this.findNextIndex(activeIndex, direction);
    }
    findNextIndex(startIndex, direction) {
        const { values: values } = this.props;
        let index = startIndex + direction;
        while(index > 0 && index < values.length && !values[index])index += direction;
        return (0, $5f04c694ca05154e$exports).clamp(index, 0, values.length);
    }
    /**
     * Splits inputValue on separator prop,
     * trims whitespace from each new value,
     * and ignores empty values.
     */ getValues(inputValue) {
        const { separator: separator } = this.props;
        // NOTE: split() typings define two overrides for string and RegExp.
        // this does not play well with our union prop type, so we'll just declare it as a valid type.
        return (separator === false ? [
            inputValue
        ] : inputValue.split(separator)).map((val)=>val.trim()).filter((val)=>val.length > 0);
    }
    handleContainerClick = ()=>{
        this.inputElement?.focus();
    };
    handleContainerBlur = ({ currentTarget: currentTarget })=>{
        this.requestAnimationFrame(()=>{
            // we only care if the blur event is leaving the container.
            // defer this check using rAF so activeElement will have updated.
            const isFocusInsideContainer = currentTarget.contains((0, $5f6dd9e57dfd2e30$export$cd4e5573fbe2b576)(this.inputElement));
            if (!isFocusInsideContainer) {
                if (this.props.addOnBlur && this.state.inputValue !== undefined && this.state.inputValue.length > 0) this.addTags(this.state.inputValue, "blur");
                this.setState({
                    activeIndex: $207f15f337a35162$var$NONE,
                    isInputFocused: false
                });
            }
        });
    };
    handleInputFocus = (event)=>{
        this.setState({
            isInputFocused: true
        });
        this.props.inputProps?.onFocus?.(event);
    };
    handleInputChange = (event)=>{
        this.setState({
            activeIndex: $207f15f337a35162$var$NONE,
            inputValue: event.currentTarget.value
        });
        this.props.onInputChange?.(event);
        this.props.inputProps?.onChange?.(event);
    };
    handleInputKeyDown = (event)=>{
        const { selectionEnd: selectionEnd, value: value } = event.currentTarget;
        const { activeIndex: activeIndex } = this.state;
        let activeIndexToEmit = activeIndex;
        // do not add a new tag if the user is composing (e.g. for Japanese or Chinese)
        if (event.key === "Enter" && !event.nativeEvent.isComposing && value.length > 0) this.addTags(value, "default");
        else if (selectionEnd === 0 && this.props.values.length > 0) {
            // cursor at beginning of input allows interaction with tags.
            // use selectionEnd to verify cursor position and no text selection.
            const direction = (0, $5f04c694ca05154e$exports).getArrowKeyDirection(event, [
                "ArrowLeft"
            ], [
                "ArrowRight"
            ]);
            if (direction !== undefined) {
                const nextActiveIndex = this.getNextActiveIndex(direction);
                if (nextActiveIndex !== activeIndex) {
                    event.stopPropagation();
                    activeIndexToEmit = nextActiveIndex;
                    this.setState({
                        activeIndex: nextActiveIndex
                    });
                }
            } else if (event.key === "Backspace") this.handleBackspaceToRemove(event);
            else if (event.key === "Delete") this.handleDeleteToRemove(event);
        }
        this.invokeKeyPressCallback("onKeyDown", event, activeIndexToEmit);
    };
    handleInputKeyUp = (event)=>{
        this.invokeKeyPressCallback("onKeyUp", event, this.state.activeIndex);
    };
    handleInputPaste = (event)=>{
        const { separator: separator } = this.props;
        const value = event.clipboardData.getData("text");
        if (!this.props.addOnPaste || value.length === 0) return;
        // special case as a UX nicety: if the user pasted only one value with no delimiters in it, leave that value in
        // the input field so that the user can refine it before converting it to a tag manually.
        if (separator === false || value.split(separator).length === 1) return;
        event.preventDefault();
        this.addTags(value, "paste");
    };
    handleRemoveTag = (event)=>{
        // using data attribute to simplify callback logic -- one handler for all children
        const index = +event.currentTarget.parentElement.getAttribute("data-tag-index");
        this.removeIndexFromValues(index);
    };
    handleBackspaceToRemove(event) {
        const previousActiveIndex = this.state.activeIndex;
        // always move leftward one item (this will focus last item if nothing is focused)
        this.setState({
            activeIndex: this.getNextActiveIndex(-1)
        });
        // delete item if there was a previous valid selection (ignore first backspace to focus last item)
        if (this.isValidIndex(previousActiveIndex)) {
            event.stopPropagation();
            this.removeIndexFromValues(previousActiveIndex);
        }
    }
    handleDeleteToRemove(event) {
        const { activeIndex: activeIndex } = this.state;
        if (this.isValidIndex(activeIndex)) {
            event.stopPropagation();
            this.removeIndexFromValues(activeIndex);
        }
    }
    /** Remove the item at the given index by invoking `onRemove` and `onChange` accordingly. */ removeIndexFromValues(index) {
        const { onChange: onChange, onRemove: onRemove, values: values } = this.props;
        onRemove?.(values[index], index);
        onChange?.(values.filter((_, i)=>i !== index));
    }
    invokeKeyPressCallback(propCallbackName, event, activeIndex) {
        this.props[propCallbackName]?.(event, activeIndex === $207f15f337a35162$var$NONE ? undefined : activeIndex);
        this.props.inputProps[propCallbackName]?.(event);
    }
    /** Returns whether the given index represents a valid item in `this.props.values`. */ isValidIndex(index) {
        return index !== $207f15f337a35162$var$NONE && index < this.props.values.length;
    }
}





class $c302f4df8217899c$export$1e7dfd31545b5809 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.MultiSelect`;
    listboxId = (0, $5f04c694ca05154e$exports).uniqueId("listbox");
    static defaultProps = {
        disabled: false,
        fill: false,
        placeholder: "Search..."
    };
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ static ofType() {
        return $c302f4df8217899c$export$1e7dfd31545b5809;
    }
    state = {
        isOpen: this.props.popoverProps && this.props.popoverProps.isOpen || false
    };
    input = null;
    queryList = null;
    refHandlers = {
        input: (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "input", this.props.tagInputProps?.inputRef),
        popover: (0, $kYL7Z.createRef)(),
        queryList: (ref)=>this.queryList = ref
    };
    componentDidUpdate(prevProps) {
        if (prevProps.tagInputProps?.inputRef !== this.props.tagInputProps?.inputRef) {
            (0, $7544862da546e887$export$4bb192c7cacf928f)(prevProps.tagInputProps?.inputRef, null);
            this.refHandlers.input = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "input", this.props.tagInputProps?.inputRef);
            (0, $7544862da546e887$export$4bb192c7cacf928f)(this.props.tagInputProps?.inputRef, this.input);
        }
        if (prevProps.onClear === undefined && this.props.onClear !== undefined || prevProps.onClear !== undefined && this.props.onClear === undefined) this.forceUpdate();
    }
    render() {
        // omit props specific to this component, spread the rest.
        const { menuProps: menuProps, openOnKeyDown: openOnKeyDown, popoverProps: popoverProps, tagInputProps: tagInputProps, customTarget: customTarget, ...restProps } = this.props;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $bd0ad1ca6092f56b$export$53fc189dda010966), {
            ...restProps,
            menuProps: {
                "aria-label": "selectable options",
                ...menuProps,
                "aria-multiselectable": true,
                id: this.listboxId
            },
            onItemSelect: this.handleItemSelect,
            onQueryChange: this.handleQueryChange,
            ref: this.refHandlers.queryList,
            renderer: this.renderQueryList
        });
    }
    renderQueryList = (listProps)=>{
        const { disabled: disabled, popoverContentProps: popoverContentProps = {}, popoverProps: popoverProps = {} } = this.props;
        const { handleKeyDown: handleKeyDown, handleKeyUp: handleKeyUp } = listProps;
        // N.B. no need to set `popoverProps.fill` since that is unused with the `renderTarget` API
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            autoFocus: false,
            canEscapeKeyClose: true,
            disabled: disabled,
            enforceFocus: false,
            isOpen: this.state.isOpen,
            placement: popoverProps.position || popoverProps.placement ? undefined : "bottom-start",
            ...popoverProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(listProps.className, popoverProps.className),
            content: (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                // In the case where customTarget is supplied and the TagInput is rendered within the Popover,
                // without matchTargetWidth there is no width defined in any of TagInput's
                // grandparents when it's rendered through usePortal, so it will never flex-wrap
                // and infinitely grow horizontally. To address this, if there is no width guidance
                // from matchTargetWidth, explicitly set a default width to so Tags will flex-wrap.
                className: this.props.customTarget != null && !this.props.popoverProps?.matchTargetWidth ? (0, $27a0f3536dedad79$exports).MULTISELECT_POPOVER_DEFAULT_WIDTH : undefined,
                ...popoverContentProps,
                onKeyDown: handleKeyDown,
                onKeyUp: handleKeyUp,
                children: [
                    this.props.customTarget != null && this.getTagInput(listProps, (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).FILL, (0, $27a0f3536dedad79$exports).MULTISELECT_POPOVER_TAG_INPUT_MARGIN)),
                    listProps.itemList
                ]
            }),
            interactionKind: "click",
            onInteraction: this.handlePopoverInteraction,
            onOpened: this.handlePopoverOpened,
            popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $27a0f3536dedad79$exports).MULTISELECT_POPOVER, popoverProps.popoverClassName),
            popupKind: (0, $da7063ee0db80208$export$4d5c295289e9b3bf).LISTBOX,
            ref: (0, $7544862da546e887$export$c9058316764c140e)(this.refHandlers.popover, this.props.popoverRef),
            renderTarget: this.getPopoverTargetRenderer(listProps, this.state.isOpen)
        });
    };
    // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like
    // the "fill" prop. Note that we must take `isOpen` as an argument to force this render function to be called
    // again after that state changes.
    getPopoverTargetRenderer = (listProps, isOpen)=>// N.B. pull out `isOpen` so that it's not forwarded to the DOM, but remember not to use it directly
        // since it may be stale (`renderTarget` is not re-invoked on this.state changes).
        // eslint-disable-next-line react/display-name
        ({ isOpen: _isOpen, ref: ref, ...targetProps })=>{
            const { disabled: disabled, fill: fill, selectedItems: selectedItems, popoverProps: popoverProps = {}, popoverTargetProps: popoverTargetProps = {} } = this.props;
            const { handleKeyDown: handleKeyDown, handleKeyUp: handleKeyUp } = listProps;
            const { targetTagName: targetTagName = "div" } = popoverProps;
            return (0, $kYL7Z.createElement)(targetTagName, {
                "aria-autocomplete": "list",
                "aria-controls": this.listboxId,
                ...popoverTargetProps,
                ...targetProps,
                "aria-disabled": disabled,
                "aria-expanded": isOpen,
                // Note that we must set FILL here in addition to TagInput to get the wrapper element to full width
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(targetProps.className, popoverTargetProps.className, {
                    [(0, $2cfd35af7ec11fdd$exports).FILL]: fill
                }),
                // Normally, Popover would also need to attach its own `onKeyDown` handler via `targetProps`,
                // but in our case we fully manage that interaction and listen for key events to open/close
                // the popover, so we elide it from the DOM.
                onKeyDown: this.getTagInputKeyDownHandler(handleKeyDown),
                onKeyUp: this.getTagInputKeyUpHandler(handleKeyUp),
                ref: ref,
                role: "combobox"
            }, this.props.customTarget != null ? this.props.customTarget(selectedItems, isOpen) : this.getTagInput(listProps));
        };
    getTagInput = (listProps, className)=>{
        const { disabled: disabled, fill: fill, onClear: onClear, placeholder: placeholder, selectedItems: selectedItems, tagInputProps: tagInputProps = {} } = this.props;
        const maybeClearButton = onClear !== undefined && selectedItems.length > 0 ? // use both aria-label and title a11y attributes here, for screen readers
        // and mouseover interactions respectively
        (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
            "aria-label": "Clear selected items",
            disabled: disabled,
            icon: (0, $fc31e5e9fc16a880$exports.jsx)((0, $d5a01f31f7e06d3b$export$3c877bb842c36952), {}),
            onClick: this.handleClearButtonClick,
            title: "Clear selected items",
            variant: "minimal"
        }) : undefined;
        // add our own inputProps.className so that we can reference it in event handlers
        const inputProps = {
            ...tagInputProps.inputProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(tagInputProps.inputProps?.className, (0, $27a0f3536dedad79$exports).MULTISELECT_TAG_INPUT_INPUT)
        };
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $207f15f337a35162$export$39299b56cfd4e361), {
            placeholder: placeholder,
            rightElement: maybeClearButton,
            ...tagInputProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(className, (0, $27a0f3536dedad79$exports).MULTISELECT, tagInputProps.className),
            disabled: disabled,
            fill: fill,
            inputRef: this.refHandlers.input,
            inputProps: inputProps,
            inputValue: listProps.query,
            onAdd: this.getTagInputAddHandler(listProps),
            onInputChange: listProps.handleQueryChange,
            onRemove: this.handleTagRemove,
            values: selectedItems.map(this.props.tagRenderer)
        });
    };
    handleItemSelect = (item, evt)=>{
        if (this.input != null) this.input.focus();
        this.props.onItemSelect?.(item, evt);
        this.refHandlers.popover.current?.reposition(); // reposition when size of input changes
    };
    handleQueryChange = (query, evt)=>{
        this.setState({
            isOpen: query.length > 0 || this.props.customTarget == null && !this.props.openOnKeyDown
        });
        this.props.onQueryChange?.(query, evt);
    };
    // Popover interaction kind is CLICK, so this only handles click events.
    // Note that we defer to the next animation frame in order to get the latest activeElement
    handlePopoverInteraction = (nextOpenState, evt)=>{
        if (this.props.customTarget != null) {
            this.setState({
                isOpen: nextOpenState
            });
            this.props.popoverProps?.onInteraction?.(nextOpenState, evt);
            return;
        }
        this.requestAnimationFrame(()=>{
            const isInputFocused = this.input === (0, $5f04c694ca05154e$exports).getActiveElement(this.input);
            if (this.input != null && !isInputFocused) // input is no longer focused, we should close the popover
            this.setState({
                isOpen: false
            });
            else if (!this.props.openOnKeyDown) // we should open immediately on click focus events
            this.setState({
                isOpen: true
            });
            this.props.popoverProps?.onInteraction?.(nextOpenState, evt);
        });
    };
    handlePopoverOpened = (node)=>{
        if (this.queryList != null) // scroll active item into view after popover transition completes and all dimensions are stable.
        this.queryList.scrollActiveItemIntoView();
        const hasCustomTarget = this.props.customTarget != null;
        if (hasCustomTarget && this.input != null) {
            const shouldAutofocus = this.props.tagInputProps?.inputProps?.autoFocus !== false;
            if (shouldAutofocus) this.input.focus();
        }
        this.props.popoverProps?.onOpened?.(node);
    };
    handleTagRemove = (tag, index)=>{
        const { selectedItems: selectedItems, onRemove: onRemove, tagInputProps: tagInputProps } = this.props;
        onRemove?.(selectedItems[index], index);
        tagInputProps?.onRemove?.(tag, index);
        this.refHandlers.popover.current?.reposition(); // reposition when size of input changes
    };
    getTagInputAddHandler = (listProps)=>(values, method)=>{
            if (method === "paste") listProps.handlePaste(values);
        };
    getTagInputKeyDownHandler = (handleQueryListKeyDown)=>{
        return (e)=>{
            if (e.key === "Escape" || e.key === "Tab") {
                // By default the escape key will not trigger a blur on the
                // input element. It must be done explicitly.
                if (e.key === "Escape") {
                    this.input?.blur();
                    // prevent other overlays from closing
                    e.stopPropagation();
                    // prevent browser-specific escape key behavior (Safari exits fullscreen)
                    e.preventDefault();
                }
                this.setState({
                    isOpen: false
                });
            } else if (!(e.key === "Backspace" || e.key === "ArrowLeft" || e.key === "ArrowRight")) {
                // Custom target might not be an input, so certain keystrokes might have other effects (space pushing the scrollview down)
                if (this.props.customTarget != null) {
                    if (e.key === " ") {
                        e.preventDefault();
                        this.setState({
                            isOpen: true
                        });
                    } else if (e.key === "Enter") this.setState({
                        isOpen: true
                    });
                } else this.setState({
                    isOpen: true
                });
            }
            const isTargetingTagRemoveButton = e.target.closest(`.${(0, $2cfd35af7ec11fdd$exports).TAG_REMOVE}`) != null;
            if (this.state.isOpen && !isTargetingTagRemoveButton) handleQueryListKeyDown?.(e);
            this.props.popoverTargetProps?.onKeyDown?.(e);
        };
    };
    getTagInputKeyUpHandler = (handleQueryListKeyUp)=>{
        return (e)=>{
            const isTargetingInput = e.target.classList.contains((0, $27a0f3536dedad79$exports).MULTISELECT_TAG_INPUT_INPUT);
            // only handle events when the focus is on the actual <input> inside the TagInput, as that's
            // what QueryList is designed to do
            if (this.state.isOpen && isTargetingInput) handleQueryListKeyUp?.(e);
            this.props.popoverTargetProps?.onKeyDown?.(e);
        };
    };
    handleClearButtonClick = ()=>{
        this.props.onClear?.();
        this.refHandlers.popover.current?.reposition(); // reposition when size of input changes
    };
}




const $5b1fe30c6fd5e00d$var$TargetButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    &[class*="bp"][class*="-button"] {
        border-radius: var(--sf-border-radius) !important;
        width: ${(p)=>p.fill ? '100%' : 'fit-content'};
        justify-content: space-between;
        background: transparent !important;
        box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2) !important;
        padding: 4px 8px;
        min-height: 30px;
        cursor: pointer;
        overflow: hidden;

        & > .bp6-button-text {
            display: flex;
            align-items: center;
            gap: 4px;
            overflow: hidden;
            flex: 1;
            min-width: 0;
        }
    }
`;
const $5b1fe30c6fd5e00d$var$ActionBar = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 4px;
    padding: 4px 5px;
    border-top: 1px solid rgba(17, 20, 24, 0.15);

    & > * { flex: 1; }
`;
const $5b1fe30c6fd5e00d$var$TagsDisplay = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    overflow: hidden;
    position: relative;
`;
const $5b1fe30c6fd5e00d$var$TagRemoveBtn = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    border-radius: 0 10px 10px 0;
    background: rgba(205, 66, 70, 0.75);
    color: white;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s;
`;
const $5b1fe30c6fd5e00d$var$HoverRemoveTag = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $0975f43a8b42d010$export$3288d34c523a1192))`
    position: relative;
    &:hover ${$5b1fe30c6fd5e00d$var$TagRemoveBtn} {
        opacity: 1;
    }
`;
const $5b1fe30c6fd5e00d$var$MeasureRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    position: absolute;
    visibility: hidden;
    pointer-events: none;
    white-space: nowrap;
`;
const $5b1fe30c6fd5e00d$var$HiddenTagsList = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px;
`;
const $5b1fe30c6fd5e00d$var$AutoFitTags = ({ selected: selected, options: options, disabled: disabled, onRemove: onRemove })=>{
    const measureRef = (0, $kYL7Z.useRef)(null);
    const targetRef = (0, $kYL7Z.useRef)(null);
    const fitRef = (0, $kYL7Z.useRef)(selected.length);
    const hiddenRef = (0, $kYL7Z.useRef)(0);
    const [, forceUpdate] = (0, $kYL7Z.useState)(0);
    const tags = (0, $kYL7Z.useMemo)(()=>selected.map((v)=>{
            const item = options.find((o)=>o.value === v);
            return {
                value: v,
                label: item?.label ?? v
            };
        }), [
        selected,
        options
    ]);
    const compute = (0, $kYL7Z.useCallback)(()=>{
        const measure = measureRef.current;
        const target = targetRef.current;
        if (!measure || !target || !tags.length) return;
        const available = target.clientWidth - 60;
        const children = measure.children;
        if (!children.length || available <= 0) return;
        const badgeWidth = children[children.length - 1].offsetWidth + 4;
        let used = 0;
        let fit = 0;
        for(let i = 0; i < tags.length; i++){
            const tagWidth = children[i].offsetWidth + (i > 0 ? 4 : 0);
            const isLast = i === tags.length - 1;
            const spaceNeeded = used + tagWidth + (isLast ? 0 : badgeWidth);
            if (spaceNeeded > available && fit > 0) break;
            used += tagWidth + (i > 0 ? 4 : 0);
            fit++;
        }
        const hidden = tags.length - fit;
        if (fit !== fitRef.current || hidden !== hiddenRef.current) {
            fitRef.current = fit;
            hiddenRef.current = hidden;
            forceUpdate((n)=>n + 1);
        }
    }, [
        tags
    ]);
    const refCallback = (0, $kYL7Z.useCallback)((node)=>{
        measureRef.current = node;
        if (node) {
            const formGroup = node.closest('[class*="bp"][class*="-form-group"]');
            targetRef.current = formGroup || node.parentElement;
        }
    }, []);
    (0, $kYL7Z.useLayoutEffect)(()=>{
        const target = targetRef.current;
        if (!target) return;
        compute();
        const ro = new ResizeObserver(compute);
        ro.observe(target);
        return ()=>ro.disconnect();
    }, [
        compute
    ]);
    if (!tags.length) return null;
    const visibleCount = fitRef.current;
    const remaining = selected.length - visibleCount;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($5b1fe30c6fd5e00d$var$TagsDisplay, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($5b1fe30c6fd5e00d$var$MeasureRow, {
                ref: refCallback,
                children: [
                    tags.map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                            minimal: true,
                            small: true,
                            round: true,
                            intent: "primary",
                            children: t.label
                        }, t.value)),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        small: true,
                        round: true,
                        children: [
                            "+",
                            selected.length
                        ]
                    })
                ]
            }),
            tags.slice(0, visibleCount).map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($5b1fe30c6fd5e00d$var$HoverRemoveTag, {
                    minimal: true,
                    small: true,
                    round: true,
                    intent: "primary",
                    children: [
                        t.label,
                        !disabled && onRemove && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($5b1fe30c6fd5e00d$var$TagRemoveBtn, {
                            onClick: (e)=>{
                                e.stopPropagation();
                                onRemove(t.value);
                            },
                            children: "\xd7"
                        })
                    ]
                }, t.value)),
            remaining > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                placement: "bottom",
                hoverOpenDelay: 200,
                content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($5b1fe30c6fd5e00d$var$HiddenTagsList, {
                    children: tags.map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                            small: true,
                            round: true,
                            children: t.label
                        }, t.value))
                }),
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    small: true,
                    round: true,
                    interactive: true,
                    children: [
                        "+",
                        remaining
                    ]
                })
            })
        ]
    });
};
const $5b1fe30c6fd5e00d$var$getDisplayText = (selectedItems, options, label)=>{
    if (selectedItems.length === 0) return `No ${label}`;
    if (selectedItems.length === 1) {
        const item = options.find((o)=>o.value === selectedItems[0]);
        return item?.label ?? selectedItems[0];
    }
    if (selectedItems.length === options.length) return `All ${label}`;
    return `${selectedItems.length} ${label}`;
};
const $5b1fe30c6fd5e00d$var$filterItem = (query, item)=>{
    if (!query) return true;
    return item.label.toLowerCase().includes(query.toLowerCase());
};
const $5b1fe30c6fd5e00d$export$4efd8d874a0cb609 = ({ label: label, rawLabel: rawLabel, value: value, options: initialOptions, disabled: disabled, error: error, icon: icon, placeholder: placeholder, allowCreate: allowCreate, nullable: nullable, fill: fill, matchTargetWidth: matchTargetWidth, showMax: showMax, onChange: onChange })=>{
    const intent = error ? 'danger' : 'none';
    const selected = value || [];
    const buttonLabel = rawLabel || label;
    const targetRef = (0, $kYL7Z.useRef)(null);
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    // Merge any created values (in selected but not in initialOptions) into the options list
    const options = (0, $kYL7Z.useMemo)(()=>{
        if (!allowCreate) return initialOptions;
        const known = new Set(initialOptions.map((o)=>o.value));
        const created = selected.filter((v)=>!known.has(v)).map((v)=>({
                label: String(v),
                value: v
            }));
        return [
            ...initialOptions,
            ...created
        ];
    }, [
        initialOptions,
        selected,
        allowCreate
    ]);
    // Sort: selected items first, then unselected; alphabetical within each group
    const sortedOptions = (0, $kYL7Z.useMemo)(()=>{
        const selectedSet = new Set(selected);
        return [
            ...options
        ].sort((a, b)=>{
            const aSelected = selectedSet.has(a.value) ? 0 : 1;
            const bSelected = selectedSet.has(b.value) ? 0 : 1;
            if (aSelected !== bSelected) return aSelected - bSelected;
            return a.label.localeCompare(b.label);
        });
    }, [
        options,
        selected
    ]);
    const handleItemSelect = (0, $kYL7Z.useCallback)((item)=>{
        if (selected.includes(item.value)) {
            const remaining = selected.filter((v)=>v !== item.value);
            onChange(nullable && remaining.length === 0 ? null : remaining);
        } else onChange([
            ...selected,
            item.value
        ]);
    }, [
        selected,
        nullable,
        onChange
    ]);
    const handleRemoveOne = (0, $kYL7Z.useCallback)((val)=>{
        const remaining = selected.filter((v)=>v !== val);
        onChange(nullable && remaining.length === 0 ? null : remaining);
    }, [
        selected,
        nullable,
        onChange
    ]);
    const handleSelectAll = (0, $kYL7Z.useCallback)(()=>{
        onChange(options.map((o)=>o.value));
    }, [
        options,
        onChange
    ]);
    const handleClear = (0, $kYL7Z.useCallback)(()=>{
        onChange(nullable ? null : []);
    }, [
        nullable,
        onChange
    ]);
    const handleCreateItem = (0, $kYL7Z.useCallback)((query)=>({
            label: query,
            value: query
        }), []);
    const renderCreateItem = (0, $kYL7Z.useCallback)((query, active, handleClick)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
            icon: "add",
            text: `Create "${query}"`,
            active: active,
            onClick: handleClick,
            shouldDismissPopover: false
        }, "__create__"), []);
    const displayText = $5b1fe30c6fd5e00d$var$getDisplayText(selected, options, buttonLabel);
    // showMax: undefined → auto-fit, 0 → text only, null → all tags, N → up to N tags
    const displayContent = (0, $kYL7Z.useMemo)(()=>{
        if (showMax === undefined) return null; // handled by AutoFitTags
        const max = showMax === null ? Infinity : showMax || 0;
        if (!max || selected.length === 0) return displayText;
        const visible = selected.slice(0, max);
        const remaining = selected.length - visible.length;
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($5b1fe30c6fd5e00d$var$TagsDisplay, {
            children: [
                visible.map((v)=>{
                    const item = options.find((o)=>o.value === v);
                    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($5b1fe30c6fd5e00d$var$HoverRemoveTag, {
                        minimal: true,
                        small: true,
                        round: true,
                        intent: "primary",
                        children: [
                            item?.label ?? v,
                            !disabled && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($5b1fe30c6fd5e00d$var$TagRemoveBtn, {
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleRemoveOne(v);
                                },
                                children: "\xd7"
                            })
                        ]
                    }, v);
                }),
                remaining > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                    placement: "bottom",
                    hoverOpenDelay: 200,
                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($5b1fe30c6fd5e00d$var$HiddenTagsList, {
                        children: selected.map((v)=>{
                            const item = options.find((o)=>o.value === v);
                            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                small: true,
                                round: true,
                                children: item?.label ?? v
                            }, v);
                        })
                    }),
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        small: true,
                        round: true,
                        interactive: true,
                        children: [
                            "+",
                            remaining
                        ]
                    })
                })
            ]
        });
    }, [
        selected,
        options,
        showMax,
        displayText,
        disabled,
        handleRemoveOne
    ]);
    const useAutoFit = showMax === undefined && selected.length > 0;
    const tagsContent = useAutoFit ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($5b1fe30c6fd5e00d$var$AutoFitTags, {
        selected: selected,
        options: options,
        disabled: disabled,
        onRemove: handleRemoveOne
    }) : displayContent ?? (selected.length === 0 ? null : displayText);
    // Selected items as item objects for Blueprint's MultiSelect
    const selectedItems = (0, $kYL7Z.useMemo)(()=>selected.map((v)=>options.find((o)=>o.value === v) || {
                label: String(v),
                value: v
            }), [
        selected,
        options
    ]);
    const customTarget = (0, $kYL7Z.useCallback)((items, open)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($5b1fe30c6fd5e00d$var$TargetButton, {
            ref: targetRef,
            fill: fill,
            disabled: disabled,
            endIcon: open ? 'chevron-up' : 'chevron-down',
            text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                children: [
                    icon && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: icon,
                        size: 14,
                        style: {
                            color: '#5c7080',
                            flexShrink: 0
                        }
                    }),
                    tagsContent || /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                        style: {
                            color: '#5c7080'
                        },
                        children: displayText
                    })
                ]
            })
        }), [
        fill,
        disabled,
        icon,
        tagsContent,
        displayText
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        helperText: error?.message,
        intent: intent,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c302f4df8217899c$export$1e7dfd31545b5809), {
            items: sortedOptions,
            selectedItems: selectedItems,
            onItemSelect: handleItemSelect,
            resetOnSelect: true,
            onRemove: (item)=>handleRemoveOne(item.value),
            itemPredicate: $5b1fe30c6fd5e00d$var$filterItem,
            itemRenderer: (item, { handleClick: handleClick, modifiers: modifiers, index: index })=>{
                if (!modifiers.matchesPredicate) return null;
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                    icon: selected.includes(item.value) ? 'tick' : 'blank',
                    text: item.label,
                    active: modifiers.active,
                    disabled: modifiers.disabled,
                    onClick: handleClick,
                    shouldDismissPopover: false
                }, `${item.value}-${index}`);
            },
            tagRenderer: (item)=>item.label,
            customTarget: customTarget,
            fill: fill,
            disabled: disabled,
            placeholder: placeholder || 'Search...',
            createNewItemFromQuery: allowCreate ? handleCreateItem : undefined,
            createNewItemRenderer: allowCreate ? renderCreateItem : undefined,
            popoverProps: {
                minimal: true,
                placement: 'bottom-start',
                matchTargetWidth: matchTargetWidth ?? !!fill,
                isOpen: isOpen,
                onInteraction: (nextOpen)=>setIsOpen(nextOpen)
            },
            menuProps: {
                style: {
                    maxHeight: 300,
                    overflowY: 'auto'
                }
            },
            tagInputProps: {
                tagProps: {
                    minimal: true,
                    small: true,
                    round: true,
                    intent: 'primary'
                },
                leftIcon: icon
            },
            itemListRenderer: ({ items: items, renderItem: renderItem, renderCreateItem: renderCreateItem, itemsParentRef: itemsParentRef })=>{
                const createItem = renderCreateItem();
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                            style: {
                                maxHeight: 300,
                                overflowY: 'auto'
                            },
                            ref: itemsParentRef,
                            children: [
                                items.length > 0 ? items.map(renderItem) : !createItem && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                    disabled: true,
                                    text: "No results."
                                }),
                                createItem
                            ]
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($5b1fe30c6fd5e00d$var$ActionBar, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    small: true,
                                    outlined: true,
                                    text: "Select all",
                                    onClick: handleSelectAll
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    small: true,
                                    outlined: true,
                                    text: "Clear",
                                    onClick: handleClear
                                })
                            ]
                        })
                    ]
                });
            }
        })
    });
};



parcelRequire("kYL7Z");



const $975d12346ccd0e6b$var$CompactFormGroup = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $4a49823ead28a6dc$export$cacf2b92a5669314))`
    &[class*="bp"][class*="-form-group"] {
        margin-bottom: 0;
    }
`;
const $975d12346ccd0e6b$export$208c2e617baf9fc3 = ({ label: label, value: value, disabled: disabled, error: error, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($975d12346ccd0e6b$var$CompactFormGroup, {
        helperText: error?.message,
        intent: error ? 'danger' : 'none',
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
            label: label,
            checked: !!value,
            disabled: disabled,
            onChange: (e)=>onChange(e.target.checked)
        })
    });
};



parcelRequire("kYL7Z");






var $kYL7Z = parcelRequire("kYL7Z");

/* !
 * (c) Copyright 2023 Palantir Technologies Inc. All rights reserved.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");
const $740824cda402a079$export$31cf727f386dbacb = 10;
function $740824cda402a079$export$88d015e1d288e379(props) {
    const { onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd, value: propValue, onChange: onChange } = props;
    // The source of truth for the input value. This is not updated during IME composition.
    // It may be updated by a parent component.
    const [value, setValue] = (0, $kYL7Z.useState)(propValue);
    // The latest input value, which updates during IME composition.
    const [nextValue, setNextValue] = (0, $kYL7Z.useState)(propValue);
    // Whether we are in the middle of a composition event.
    const [isComposing, setIsComposing] = (0, $kYL7Z.useState)(false);
    // Whether there is a pending update we are expecting from a parent component.
    const [hasPendingUpdate, setHasPendingUpdate] = (0, $kYL7Z.useState)(false);
    const cancelPendingCompositionEnd = (0, $kYL7Z.useRef)();
    const handleCompositionStart = (0, $kYL7Z.useCallback)((event)=>{
        cancelPendingCompositionEnd.current?.();
        setIsComposing(true);
        onCompositionStart?.(event);
    }, [
        onCompositionStart
    ]);
    // creates a timeout which will set `isComposing` to false after a delay
    // returns a function which will cancel the timeout if called before it fires
    const createOnCancelPendingCompositionEnd = (0, $kYL7Z.useCallback)(()=>{
        const timeoutId = window.setTimeout(()=>setIsComposing(false), $740824cda402a079$export$31cf727f386dbacb);
        return ()=>window.clearTimeout(timeoutId);
    }, []);
    const handleCompositionEnd = (0, $kYL7Z.useCallback)((event)=>{
        // In some non-latin languages, a keystroke can end a composition event and immediately afterwards start another.
        // This can lead to unexpected characters showing up in the text input. In order to circumvent this problem, we
        // use a timeout which creates a delay which merges the two composition events, creating a more natural and predictable UX.
        // `this.state.nextValue` will become "locked" (it cannot be overwritten by the `value` prop) until a delay (10ms) has
        // passed without a new composition event starting.
        cancelPendingCompositionEnd.current = createOnCancelPendingCompositionEnd();
        onCompositionEnd?.(event);
    }, [
        createOnCancelPendingCompositionEnd,
        onCompositionEnd
    ]);
    const handleChange = (0, $kYL7Z.useCallback)((event)=>{
        const { value: targetValue } = event.target;
        setNextValue(targetValue);
        onChange?.(event);
    }, [
        onChange
    ]);
    // don't derive anything from props if:
    // - in uncontrolled mode, OR
    // - currently composing, since we'll do that after composition ends
    const shouldDeriveFromProps = !(isComposing || propValue === undefined);
    if (shouldDeriveFromProps) {
        const userTriggeredUpdate = nextValue !== value;
        if (userTriggeredUpdate && propValue === nextValue) {
            // parent has processed and accepted our update
            setValue(propValue);
            setHasPendingUpdate(false);
        } else if (userTriggeredUpdate && propValue === value) // we have sent the update to our parent, but it has not been processed yet. just wait.
        // DO NOT set nextValue here, since that will temporarily render a potentially stale controlled value,
        // causing the cursor to jump once the new value is accepted
        {
            if (!hasPendingUpdate) // make sure to setState only when necessary to avoid infinite loops
            setHasPendingUpdate(true);
        } else if (userTriggeredUpdate && propValue !== value) {
            // accept controlled update overriding user action
            setValue(propValue);
            setNextValue(propValue);
            setHasPendingUpdate(false);
        } else if (!userTriggeredUpdate) // accept controlled update, could be confirming or denying user action
        {
            if (value !== propValue || hasPendingUpdate) {
                // make sure to setState only when necessary to avoid infinite loops
                setValue(propValue);
                setNextValue(propValue);
                setHasPendingUpdate(false);
            }
        }
    }
    return {
        onChange: handleChange,
        onCompositionEnd: handleCompositionEnd,
        onCompositionStart: handleCompositionStart,
        // render the pending value even if it is not confirmed by a parent's async controlled update
        // so that the cursor does not jump to the end of input as reported in
        // https://github.com/palantir/blueprint/issues/4298
        value: isComposing || hasPendingUpdate ? nextValue : value
    };
}


const $cc3a611cc2d5d14c$export$781616f40f5824c1 = (0, $kYL7Z.forwardRef)(function AsyncControllableTextArea(props, ref) {
    const { value: parentValue, onChange: parentOnChange, onCompositionStart: parentOnCompositionStart, onCompositionEnd: parentOnCompositionEnd, ...restProps } = props;
    const { value: value, onChange: onChange, onCompositionStart: onCompositionStart, onCompositionEnd: onCompositionEnd } = (0, $740824cda402a079$export$88d015e1d288e379)({
        onChange: parentOnChange,
        onCompositionEnd: parentOnCompositionEnd,
        onCompositionStart: parentOnCompositionStart,
        value: parentValue
    });
    return (0, $fc31e5e9fc16a880$exports.jsx)("textarea", {
        ...restProps,
        value: value,
        onChange: onChange,
        onCompositionStart: onCompositionStart,
        onCompositionEnd: onCompositionEnd,
        ref: ref
    });
});
$cc3a611cc2d5d14c$export$781616f40f5824c1.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.AsyncControllableTextArea`;


class $97da32377aa7cac2$export$f5c9f3c2c4054eec extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static defaultProps = {
        autoResize: false,
        fill: false,
        large: false,
        size: "medium",
        small: false
    };
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.TextArea`;
    state = {};
    // used to measure and set the height of the component on first mount
    textareaElement = null;
    handleRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "textareaElement", this.props.inputRef);
    maybeSyncHeightToScrollHeight = ()=>{
        const { autoResize: autoResize } = this.props;
        if (this.textareaElement != null) {
            const { scrollHeight: scrollHeight } = this.textareaElement;
            if (autoResize) {
                // set height to 0 to force scrollHeight to be the minimum height to fit
                // the content of the textarea
                this.textareaElement.style.height = "0px";
                this.textareaElement.style.height = scrollHeight.toString() + "px";
                this.setState({
                    height: scrollHeight
                });
            }
        }
        if (this.props.autoResize && this.textareaElement != null) {
            // set height to 0 to force scrollHeight to be the minimum height to fit
            // the content of the textarea
            this.textareaElement.style.height = "0px";
            const { scrollHeight: scrollHeight } = this.textareaElement;
            this.textareaElement.style.height = scrollHeight.toString() + "px";
            this.setState({
                height: scrollHeight
            });
        }
    };
    componentDidMount() {
        this.maybeSyncHeightToScrollHeight();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.inputRef !== this.props.inputRef) {
            (0, $7544862da546e887$export$4bb192c7cacf928f)(prevProps.inputRef, null);
            this.handleRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "textareaElement", this.props.inputRef);
            (0, $7544862da546e887$export$4bb192c7cacf928f)(this.props.inputRef, this.textareaElement);
        }
        if (prevProps.value !== this.props.value || prevProps.style !== this.props.style) this.maybeSyncHeightToScrollHeight();
    }
    render() {
        const { asyncControl: asyncControl, autoResize: autoResize, className: className, fill: fill, inputRef: inputRef, intent: intent, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
        large, size: size = "medium", small: // eslint-disable-next-line @typescript-eslint/no-deprecated
        small, ...htmlProps } = this.props;
        const rootClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).INPUT, (0, $2cfd35af7ec11fdd$exports).TEXT_AREA, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
            large: large,
            small: small
        }), {
            [(0, $2cfd35af7ec11fdd$exports).FILL]: fill,
            [(0, $2cfd35af7ec11fdd$exports).TEXT_AREA_AUTO_RESIZE]: autoResize
        }, className);
        // add explicit height style while preserving user-supplied styles if they exist
        let { style: style = {} } = htmlProps;
        if (autoResize && this.state.height != null) // this style object becomes non-extensible when mounted (at least in the enzyme renderer),
        // so we make a new one to add a property
        style = {
            ...style,
            height: `${this.state.height}px`
        };
        const TextAreaComponent = asyncControl ? (0, $cc3a611cc2d5d14c$export$781616f40f5824c1) : "textarea";
        return (0, $fc31e5e9fc16a880$exports.jsx)(TextAreaComponent, {
            ...htmlProps,
            className: rootClasses,
            onChange: this.handleChange,
            style: style,
            ref: this.handleRef
        });
    }
    handleChange = (e)=>{
        this.maybeSyncHeightToScrollHeight();
        this.props.onChange?.(e);
    };
}



const $4d2d3b6573676c4d$export$301bf6213f61d17f = ({ label: label, value: value, disabled: disabled, error: error, rows: rows = 10, onChange: onChange })=>{
    const intent = error ? 'danger' : 'none';
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        helperText: error?.message,
        intent: intent,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$5f513dadd988fceb), {
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $97da32377aa7cac2$export$f5c9f3c2c4054eec), {
                fill: true,
                rows: rows,
                value: value ?? '',
                disabled: disabled,
                intent: intent,
                onChange: (e)=>onChange(e.target.value),
                style: {
                    fontFamily: 'monospace',
                    resize: 'vertical'
                }
            })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");



const $7d01f98e6cb87248$var$parseJsonError = (text)=>{
    if (!text || text.trim() === '') return null;
    try {
        JSON.parse(text);
        return null;
    } catch (e) {
        const match = e.message.match(/position (\d+)/);
        if (match) {
            const pos = parseInt(match[1], 10);
            const before = text.slice(0, pos);
            const line = (before.match(/\n/g) || []).length + 1;
            const col = pos - before.lastIndexOf('\n');
            return {
                message: `Invalid JSON at line ${line}, col ${col}`
            };
        }
        return {
            message: e.message
        };
    }
};
const $7d01f98e6cb87248$var$serialize = (value)=>{
    if (value === undefined || value === null) return '';
    return JSON.stringify(value, null, 2);
};
const $7d01f98e6cb87248$export$a724837acbf4d78b = ({ label: label, value: value, disabled: disabled, error: error, rows: rows = 10, schema: schema, onChange: onChange })=>{
    const [text, setText] = (0, $kYL7Z.useState)(()=>$7d01f98e6cb87248$var$serialize(value));
    const [localError, setLocalError] = (0, $kYL7Z.useState)(null);
    const timerRef = (0, $kYL7Z.useRef)(null);
    const lastExternalRef = (0, $kYL7Z.useRef)(value);
    // Sync from external value changes (not from our own onChange)
    (0, $kYL7Z.useEffect)(()=>{
        if (value !== lastExternalRef.current) {
            lastExternalRef.current = value;
            setText($7d01f98e6cb87248$var$serialize(value));
            setLocalError(null);
        }
    }, [
        value
    ]);
    const handleChange = (0, $kYL7Z.useCallback)((e)=>{
        const newText = e.target.value;
        setText(newText);
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>{
            // Check JSON syntax
            const jsonErr = $7d01f98e6cb87248$var$parseJsonError(newText);
            if (jsonErr) {
                setLocalError(jsonErr);
                return;
            }
            // Empty text → undefined
            if (!newText || newText.trim() === '') {
                setLocalError(null);
                lastExternalRef.current = undefined;
                onChange(undefined);
                return;
            }
            // Parse succeeded — validate against schema if provided
            const parsed = JSON.parse(newText);
            let schemaErr = null;
            if (schema?.properties) {
                const schemaErrors = (0, $adeac7fc1fb1e32e$export$a22775fa5e2eebd9)(schema, parsed);
                if (schemaErrors.length > 0) schemaErr = {
                    message: schemaErrors.map((e)=>`${e.instancePath || '/'}: ${e.message}`).join('; ')
                };
            }
            setLocalError(schemaErr);
            lastExternalRef.current = parsed;
            onChange(parsed);
        }, 500);
    }, [
        schema,
        onChange
    ]);
    // Cleanup timer
    (0, $kYL7Z.useEffect)(()=>()=>clearTimeout(timerRef.current), []);
    const displayError = error || localError;
    const intent = displayError ? 'danger' : 'none';
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        helperText: displayError?.message,
        intent: intent,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$5f513dadd988fceb), {
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $97da32377aa7cac2$export$f5c9f3c2c4054eec), {
                fill: true,
                rows: rows,
                value: text,
                disabled: disabled,
                intent: intent,
                onChange: handleChange,
                style: {
                    fontFamily: 'monospace',
                    resize: 'vertical',
                    minHeight: `${rows * 1.4}em`
                }
            })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");



var $kYL7Z = parcelRequire("kYL7Z");

var $cRanb = parcelRequire("cRanb");

var $kYL7Z = parcelRequire("kYL7Z");
function $e8fe9e9079a95c7c$export$2f8294366bb2d67a() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, $kYL7Z.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const $e8fe9e9079a95c7c$export$71594e8a50f746f4 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function $e8fe9e9079a95c7c$export$5a096129d439f843(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function $e8fe9e9079a95c7c$export$8ee0fc9ee280b4ee(node) {
    return 'nodeType' in node;
}
function $e8fe9e9079a95c7c$export$38b2d434cce3ea22(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if ($e8fe9e9079a95c7c$export$5a096129d439f843(target)) return target;
    if (!$e8fe9e9079a95c7c$export$8ee0fc9ee280b4ee(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function $e8fe9e9079a95c7c$export$62858bae88b53fd0(node) {
    const { Document: Document } = $e8fe9e9079a95c7c$export$38b2d434cce3ea22(node);
    return node instanceof Document;
}
function $e8fe9e9079a95c7c$export$1b3bfaa9684536aa(node) {
    if ($e8fe9e9079a95c7c$export$5a096129d439f843(node)) return false;
    return node instanceof $e8fe9e9079a95c7c$export$38b2d434cce3ea22(node).HTMLElement;
}
function $e8fe9e9079a95c7c$export$17eda790a720ec57(node) {
    return node instanceof $e8fe9e9079a95c7c$export$38b2d434cce3ea22(node).SVGElement;
}
function $e8fe9e9079a95c7c$export$b204af158042fbac(target) {
    if (!target) return document;
    if ($e8fe9e9079a95c7c$export$5a096129d439f843(target)) return target.document;
    if (!$e8fe9e9079a95c7c$export$8ee0fc9ee280b4ee(target)) return document;
    if ($e8fe9e9079a95c7c$export$62858bae88b53fd0(target)) return target;
    if ($e8fe9e9079a95c7c$export$1b3bfaa9684536aa(target) || $e8fe9e9079a95c7c$export$17eda790a720ec57(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const $e8fe9e9079a95c7c$export$700979bc83e7db82 = $e8fe9e9079a95c7c$export$71594e8a50f746f4 ? (0, $kYL7Z.useLayoutEffect) : (0, $kYL7Z.useEffect);
function $e8fe9e9079a95c7c$export$90fc3a17d93f704c(handler) {
    const handlerRef = (0, $kYL7Z.useRef)(handler);
    $e8fe9e9079a95c7c$export$700979bc83e7db82(()=>{
        handlerRef.current = handler;
    });
    return (0, $kYL7Z.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function $e8fe9e9079a95c7c$export$f4b266cd2aae9cb1() {
    const intervalRef = (0, $kYL7Z.useRef)(null);
    const set = (0, $kYL7Z.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, $kYL7Z.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function $e8fe9e9079a95c7c$export$86c4283a11f23f95(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, $kYL7Z.useRef)(value);
    $e8fe9e9079a95c7c$export$700979bc83e7db82(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function $e8fe9e9079a95c7c$export$b0d7b7f1fcd613d1(callback, dependencies) {
    const valueRef = (0, $kYL7Z.useRef)();
    return (0, $kYL7Z.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function $e8fe9e9079a95c7c$export$bc23c270f170c912(onChange) {
    const onChangeHandler = $e8fe9e9079a95c7c$export$90fc3a17d93f704c(onChange);
    const node = (0, $kYL7Z.useRef)(null);
    const setNodeRef = (0, $kYL7Z.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function $e8fe9e9079a95c7c$export$5cae361ad82dce8b(value) {
    const ref = (0, $kYL7Z.useRef)();
    (0, $kYL7Z.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let $e8fe9e9079a95c7c$var$ids = {};
function $e8fe9e9079a95c7c$export$c485849f2e393253(prefix, value) {
    return (0, $kYL7Z.useMemo)(()=>{
        if (value) return value;
        const id = $e8fe9e9079a95c7c$var$ids[prefix] == null ? 0 : $e8fe9e9079a95c7c$var$ids[prefix] + 1;
        $e8fe9e9079a95c7c$var$ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function $e8fe9e9079a95c7c$var$createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const $e8fe9e9079a95c7c$export$e16d8520af44a096 = /*#__PURE__*/ $e8fe9e9079a95c7c$var$createAdjustmentFn(1);
const $e8fe9e9079a95c7c$export$4e2d2ead65e5f7e3 = /*#__PURE__*/ $e8fe9e9079a95c7c$var$createAdjustmentFn(-1);
function $e8fe9e9079a95c7c$export$d0e71af79cd586c6(event) {
    return 'clientX' in event && 'clientY' in event;
}
function $e8fe9e9079a95c7c$export$130b789831072f4c(event) {
    if (!event) return false;
    const { KeyboardEvent: KeyboardEvent } = $e8fe9e9079a95c7c$export$38b2d434cce3ea22(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function $e8fe9e9079a95c7c$export$c4dfce035d43d1e0(event) {
    if (!event) return false;
    const { TouchEvent: TouchEvent } = $e8fe9e9079a95c7c$export$38b2d434cce3ea22(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function $e8fe9e9079a95c7c$export$36195c8aa1517e04(event) {
    if ($e8fe9e9079a95c7c$export$c4dfce035d43d1e0(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x: x,
                y: y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x: x,
                y: y
            };
        }
    }
    if ($e8fe9e9079a95c7c$export$d0e71af79cd586c6(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const $e8fe9e9079a95c7c$export$c4ffa16951855e28 = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x: x, y: y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX: scaleX, scaleY: scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                $e8fe9e9079a95c7c$export$c4ffa16951855e28.Translate.toString(transform),
                $e8fe9e9079a95c7c$export$c4ffa16951855e28.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property: property, duration: duration, easing: easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const $e8fe9e9079a95c7c$var$SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function $e8fe9e9079a95c7c$export$44f71d798fd0a62b(element) {
    if (element.matches($e8fe9e9079a95c7c$var$SELECTOR)) return element;
    return element.querySelector($e8fe9e9079a95c7c$var$SELECTOR);
}



var $kYL7Z = parcelRequire("kYL7Z");
const $d7d72276af0af045$var$hiddenStyles = {
    display: 'none'
};
function $d7d72276af0af045$export$1496ac55023363a5(_ref) {
    let { id: id, value: value } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        id: id,
        style: $d7d72276af0af045$var$hiddenStyles
    }, value);
}
function $d7d72276af0af045$export$ae99b902be98b17(_ref) {
    let { id: id, announcement: announcement, ariaLiveType: ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function $d7d72276af0af045$export$97d78af8d95ca8bd() {
    const [announcement, setAnnouncement] = (0, $kYL7Z.useState)('');
    const announce = (0, $kYL7Z.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce: announce,
        announcement: announcement
    };
}


const $d59febdd5a89527d$var$DndMonitorContext = /*#__PURE__*/ (0, $kYL7Z.createContext)(null);
function $d59febdd5a89527d$export$1182af90218a7b81(listener) {
    const registerListener = (0, $kYL7Z.useContext)($d59febdd5a89527d$var$DndMonitorContext);
    (0, $kYL7Z.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function $d59febdd5a89527d$var$useDndMonitorProvider() {
    const [listeners] = (0, $kYL7Z.useState)(()=>new Set());
    const registerListener = (0, $kYL7Z.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, $kYL7Z.useCallback)((_ref)=>{
        let { type: type, event: event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const $d59febdd5a89527d$export$2547556495408594 = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const $d59febdd5a89527d$export$6acb64047911dd54 = {
    onDragStart (_ref) {
        let { active: active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active: active, over: over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active: active, over: over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active: active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function $d59febdd5a89527d$var$Accessibility(_ref) {
    let { announcements: announcements = $d59febdd5a89527d$export$6acb64047911dd54, container: container, hiddenTextDescribedById: hiddenTextDescribedById, screenReaderInstructions: screenReaderInstructions = $d59febdd5a89527d$export$2547556495408594 } = _ref;
    const { announce: announce, announcement: announcement } = (0, $d7d72276af0af045$export$97d78af8d95ca8bd)();
    const liveRegionId = (0, $e8fe9e9079a95c7c$export$c485849f2e393253)("DndLiveRegion");
    const [mounted, setMounted] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        setMounted(true);
    }, []);
    $d59febdd5a89527d$export$1182af90218a7b81((0, $kYL7Z.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active: active } = _ref2;
                announce(announcements.onDragStart({
                    active: active
                }));
            },
            onDragMove (_ref3) {
                let { active: active, over: over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active: active,
                    over: over
                }));
            },
            onDragOver (_ref4) {
                let { active: active, over: over } = _ref4;
                announce(announcements.onDragOver({
                    active: active,
                    over: over
                }));
            },
            onDragEnd (_ref5) {
                let { active: active, over: over } = _ref5;
                announce(announcements.onDragEnd({
                    active: active,
                    over: over
                }));
            },
            onDragCancel (_ref6) {
                let { active: active, over: over } = _ref6;
                announce(announcements.onDragCancel({
                    active: active,
                    over: over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $d7d72276af0af045$export$1496ac55023363a5), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $d7d72276af0af045$export$ae99b902be98b17), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, $cRanb.createPortal)(markup, container) : markup;
}
var $d59febdd5a89527d$var$Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})($d59febdd5a89527d$var$Action || ($d59febdd5a89527d$var$Action = {}));
function $d59febdd5a89527d$var$noop() {}
function $d59febdd5a89527d$export$cc72dd71f4ec69eb(sensor, options) {
    return (0, $kYL7Z.useMemo)(()=>({
            sensor: sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function $d59febdd5a89527d$export$19012f58216d597f() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, $kYL7Z.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const $d59febdd5a89527d$export$597cbd7bbd10deb4 = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function $d59febdd5a89527d$var$distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function $d59febdd5a89527d$var$getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, $e8fe9e9079a95c7c$export$36195c8aa1517e04)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function $d59febdd5a89527d$var$sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function $d59febdd5a89527d$var$sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function $d59febdd5a89527d$var$cornersOfRectangle(_ref5) {
    let { left: left, top: top, height: height, width: width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function $d59febdd5a89527d$export$ef1beab6d7287295(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function $d59febdd5a89527d$var$centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const $d59febdd5a89527d$export$c8e785ae6b74bab8 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const centerRect = $d59febdd5a89527d$var$centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = $d59febdd5a89527d$var$distanceBetween($d59febdd5a89527d$var$centerOfRectangle(rect), centerRect);
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort($d59febdd5a89527d$var$sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const $d59febdd5a89527d$export$c3a6c1c7122b31c9 = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const corners = $d59febdd5a89527d$var$cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = $d59febdd5a89527d$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + $d59febdd5a89527d$var$distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($d59febdd5a89527d$var$sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function $d59febdd5a89527d$var$getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const $d59febdd5a89527d$export$953346c40b5eb62a = (_ref)=>{
    let { collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = $d59febdd5a89527d$var$getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort($d59febdd5a89527d$var$sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function $d59febdd5a89527d$var$isPointWithinRect(point, rect) {
    const { top: top, left: left, bottom: bottom, right: right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const $d59febdd5a89527d$export$cd834c0ba378cb94 = (_ref)=>{
    let { droppableContainers: droppableContainers, droppableRects: droppableRects, pointerCoordinates: pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id: id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && $d59febdd5a89527d$var$isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = $d59febdd5a89527d$var$cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + $d59febdd5a89527d$var$distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id: id,
                data: {
                    droppableContainer: droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort($d59febdd5a89527d$var$sortCollisionsAsc);
};
function $d59febdd5a89527d$var$adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function $d59febdd5a89527d$var$getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : $d59febdd5a89527d$export$597cbd7bbd10deb4;
}
function $d59febdd5a89527d$var$createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const $d59febdd5a89527d$var$getAdjustedRect = /*#__PURE__*/ $d59febdd5a89527d$var$createRectAdjustmentFn(1);
function $d59febdd5a89527d$var$parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function $d59febdd5a89527d$var$inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = $d59febdd5a89527d$var$parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX: scaleX, scaleY: scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const $d59febdd5a89527d$var$defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function $d59febdd5a89527d$export$b6aa1f30c53d7454(element, options) {
    if (options === void 0) options = $d59febdd5a89527d$var$defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform: transform, transformOrigin: transformOrigin } = (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(element).getComputedStyle(element);
        if (transform) rect = $d59febdd5a89527d$var$inverseTransform(rect, transform, transformOrigin);
    }
    const { top: top, left: left, width: width, height: height, bottom: bottom, right: right } = rect;
    return {
        top: top,
        left: left,
        width: width,
        height: height,
        bottom: bottom,
        right: right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function $d59febdd5a89527d$var$getTransformAgnosticClientRect(element) {
    return $d59febdd5a89527d$export$b6aa1f30c53d7454(element, {
        ignoreTransform: true
    });
}
function $d59febdd5a89527d$var$getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width: width,
        height: height
    };
}
function $d59febdd5a89527d$var$isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function $d59febdd5a89527d$var$isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function $d59febdd5a89527d$export$e4864aa91b5ed091(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, $e8fe9e9079a95c7c$export$62858bae88b53fd0)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, $e8fe9e9079a95c7c$export$1b3bfaa9684536aa)(node) || (0, $e8fe9e9079a95c7c$export$17eda790a720ec57)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(element).getComputedStyle(node);
        if (node !== element) {
            if ($d59febdd5a89527d$var$isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if ($d59febdd5a89527d$var$isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function $d59febdd5a89527d$var$getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = $d59febdd5a89527d$export$e4864aa91b5ed091(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function $d59febdd5a89527d$var$getScrollableElement(element) {
    if (!(0, $e8fe9e9079a95c7c$export$71594e8a50f746f4) || !element) return null;
    if ((0, $e8fe9e9079a95c7c$export$5a096129d439f843)(element)) return element;
    if (!(0, $e8fe9e9079a95c7c$export$8ee0fc9ee280b4ee)(element)) return null;
    if ((0, $e8fe9e9079a95c7c$export$62858bae88b53fd0)(element) || element === (0, $e8fe9e9079a95c7c$export$b204af158042fbac)(element).scrollingElement) return window;
    if ((0, $e8fe9e9079a95c7c$export$1b3bfaa9684536aa)(element)) return element;
    return null;
}
function $d59febdd5a89527d$var$getScrollXCoordinate(element) {
    if ((0, $e8fe9e9079a95c7c$export$5a096129d439f843)(element)) return element.scrollX;
    return element.scrollLeft;
}
function $d59febdd5a89527d$var$getScrollYCoordinate(element) {
    if ((0, $e8fe9e9079a95c7c$export$5a096129d439f843)(element)) return element.scrollY;
    return element.scrollTop;
}
function $d59febdd5a89527d$var$getScrollCoordinates(element) {
    return {
        x: $d59febdd5a89527d$var$getScrollXCoordinate(element),
        y: $d59febdd5a89527d$var$getScrollYCoordinate(element)
    };
}
var $d59febdd5a89527d$var$Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})($d59febdd5a89527d$var$Direction || ($d59febdd5a89527d$var$Direction = {}));
function $d59febdd5a89527d$var$isDocumentScrollingElement(element) {
    if (!(0, $e8fe9e9079a95c7c$export$71594e8a50f746f4) || !element) return false;
    return element === document.scrollingElement;
}
function $d59febdd5a89527d$var$getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = $d59febdd5a89527d$var$isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop: isTop,
        isLeft: isLeft,
        isBottom: isBottom,
        isRight: isRight,
        maxScroll: maxScroll,
        minScroll: minScroll
    };
}
const $d59febdd5a89527d$var$defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function $d59febdd5a89527d$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top: top, left: left, right: right, bottom: bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = $d59febdd5a89527d$var$defaultThreshold;
    const { isTop: isTop, isBottom: isBottom, isLeft: isLeft, isRight: isRight } = $d59febdd5a89527d$var$getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = $d59febdd5a89527d$var$Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = $d59febdd5a89527d$var$Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = $d59febdd5a89527d$var$Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = $d59febdd5a89527d$var$Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction: direction,
        speed: speed
    };
}
function $d59febdd5a89527d$var$getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top: top, left: left, right: right, bottom: bottom } = element.getBoundingClientRect();
    return {
        top: top,
        left: left,
        right: right,
        bottom: bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function $d59febdd5a89527d$var$getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, $e8fe9e9079a95c7c$export$e16d8520af44a096)(acc, $d59febdd5a89527d$var$getScrollCoordinates(node));
    }, $d59febdd5a89527d$export$597cbd7bbd10deb4);
}
function $d59febdd5a89527d$var$getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $d59febdd5a89527d$var$getScrollXCoordinate(node);
    }, 0);
}
function $d59febdd5a89527d$var$getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + $d59febdd5a89527d$var$getScrollYCoordinate(node);
    }, 0);
}
function $d59febdd5a89527d$var$scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = $d59febdd5a89527d$export$b6aa1f30c53d7454;
    if (!element) return;
    const { top: top, left: left, bottom: bottom, right: right } = measure(element);
    const firstScrollableAncestor = $d59febdd5a89527d$var$getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const $d59febdd5a89527d$var$properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        $d59febdd5a89527d$var$getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        $d59febdd5a89527d$var$getScrollYOffset
    ]
];
class $d59febdd5a89527d$var$Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = $d59febdd5a89527d$export$e4864aa91b5ed091(element);
        const scrollOffsets = $d59febdd5a89527d$var$getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of $d59febdd5a89527d$var$properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class $d59febdd5a89527d$var$Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function $d59febdd5a89527d$var$getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget: EventTarget } = (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(target);
    return target instanceof EventTarget ? target : (0, $e8fe9e9079a95c7c$export$b204af158042fbac)(target);
}
function $d59febdd5a89527d$var$hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var $d59febdd5a89527d$var$EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})($d59febdd5a89527d$var$EventName || ($d59febdd5a89527d$var$EventName = {}));
function $d59febdd5a89527d$var$preventDefault(event) {
    event.preventDefault();
}
function $d59febdd5a89527d$var$stopPropagation(event) {
    event.stopPropagation();
}
var $d59febdd5a89527d$export$a8b1916dba3ae88b;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})($d59febdd5a89527d$export$a8b1916dba3ae88b || ($d59febdd5a89527d$export$a8b1916dba3ae88b = {}));
const $d59febdd5a89527d$var$defaultKeyboardCodes = {
    start: [
        $d59febdd5a89527d$export$a8b1916dba3ae88b.Space,
        $d59febdd5a89527d$export$a8b1916dba3ae88b.Enter
    ],
    cancel: [
        $d59febdd5a89527d$export$a8b1916dba3ae88b.Esc
    ],
    end: [
        $d59febdd5a89527d$export$a8b1916dba3ae88b.Space,
        $d59febdd5a89527d$export$a8b1916dba3ae88b.Enter,
        $d59febdd5a89527d$export$a8b1916dba3ae88b.Tab
    ]
};
const $d59febdd5a89527d$export$ae4c9a18005b0235 = (event, _ref)=>{
    let { currentCoordinates: currentCoordinates } = _ref;
    switch(event.code){
        case $d59febdd5a89527d$export$a8b1916dba3ae88b.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case $d59febdd5a89527d$export$a8b1916dba3ae88b.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case $d59febdd5a89527d$export$a8b1916dba3ae88b.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case $d59febdd5a89527d$export$a8b1916dba3ae88b.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class $d59febdd5a89527d$export$44d67f2a438aeba9 {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target: target } } = props;
        this.props = props;
        this.listeners = new $d59febdd5a89527d$var$Listeners((0, $e8fe9e9079a95c7c$export$b204af158042fbac)(target));
        this.windowListeners = new $d59febdd5a89527d$var$Listeners((0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add($d59febdd5a89527d$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($d59febdd5a89527d$var$EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add($d59febdd5a89527d$var$EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode: activeNode, onStart: onStart } = this.props;
        const node = activeNode.node.current;
        if (node) $d59febdd5a89527d$var$scrollIntoViewIfNeeded(node);
        onStart($d59febdd5a89527d$export$597cbd7bbd10deb4);
    }
    handleKeyDown(event) {
        if ((0, $e8fe9e9079a95c7c$export$130b789831072f4c)(event)) {
            const { active: active, context: context, options: options } = this.props;
            const { keyboardCodes: keyboardCodes = $d59febdd5a89527d$var$defaultKeyboardCodes, coordinateGetter: coordinateGetter = $d59febdd5a89527d$export$ae4c9a18005b0235, scrollBehavior: scrollBehavior = 'smooth' } = options;
            const { code: code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect: collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : $d59febdd5a89527d$export$597cbd7bbd10deb4;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active: active,
                context: context.current,
                currentCoordinates: currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, $e8fe9e9079a95c7c$export$4e2d2ead65e5f7e3)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors: scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop: isTop, isRight: isRight, isLeft: isLeft, isBottom: isBottom, maxScroll: maxScroll, minScroll: minScroll } = $d59febdd5a89527d$var$getScrollPosition(scrollContainer);
                    const scrollElementRect = $d59febdd5a89527d$var$getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Right && !isRight || direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Left && !isLeft;
                    const canScrollY = direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Down && !isBottom || direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Right && newScrollCoordinates <= maxScroll.x || direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Down && newScrollCoordinates <= maxScroll.y || direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === $d59febdd5a89527d$export$a8b1916dba3ae88b.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, $e8fe9e9079a95c7c$export$e16d8520af44a096)((0, $e8fe9e9079a95c7c$export$4e2d2ead65e5f7e3)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove: onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd: onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel: onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
$d59febdd5a89527d$export$44d67f2a438aeba9.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes: keyboardCodes = $d59febdd5a89527d$var$defaultKeyboardCodes, onActivation: onActivation } = _ref;
            let { active: active } = _ref2;
            const { code: code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function $d59febdd5a89527d$var$isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function $d59febdd5a89527d$var$isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class $d59febdd5a89527d$var$AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = $d59febdd5a89527d$var$getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event: event } = props;
        const { target: target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, $e8fe9e9079a95c7c$export$b204af158042fbac)(target);
        this.documentListeners = new $d59febdd5a89527d$var$Listeners(this.document);
        this.listeners = new $d59febdd5a89527d$var$Listeners(listenerTarget);
        this.windowListeners = new $d59febdd5a89527d$var$Listeners((0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, $e8fe9e9079a95c7c$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates : $d59febdd5a89527d$export$597cbd7bbd10deb4;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events: events, props: { options: { activationConstraint: activationConstraint, bypassActivationConstraint: bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add($d59febdd5a89527d$var$EventName.Resize, this.handleCancel);
        this.windowListeners.add($d59febdd5a89527d$var$EventName.DragStart, $d59febdd5a89527d$var$preventDefault);
        this.windowListeners.add($d59febdd5a89527d$var$EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add($d59febdd5a89527d$var$EventName.ContextMenu, $d59febdd5a89527d$var$preventDefault);
        this.documentListeners.add($d59febdd5a89527d$var$EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if ($d59febdd5a89527d$var$isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if ($d59febdd5a89527d$var$isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active: active, onPending: onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates: initialCoordinates } = this;
        const { onStart: onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add($d59febdd5a89527d$var$EventName.Click, $d59febdd5a89527d$var$stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add($d59febdd5a89527d$var$EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated: activated, initialCoordinates: initialCoordinates, props: props } = this;
        const { onMove: onMove, options: { activationConstraint: activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, $e8fe9e9079a95c7c$export$36195c8aa1517e04)(event)) != null ? _getEventCoordinates2 : $d59febdd5a89527d$export$597cbd7bbd10deb4;
        const delta = (0, $e8fe9e9079a95c7c$export$4e2d2ead65e5f7e3)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if ($d59febdd5a89527d$var$isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && $d59febdd5a89527d$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if ($d59febdd5a89527d$var$hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if ($d59febdd5a89527d$var$isDelayConstraint(activationConstraint)) {
                if ($d59febdd5a89527d$var$hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort: onAbort, onEnd: onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort: onAbort, onCancel: onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === $d59febdd5a89527d$export$a8b1916dba3ae88b.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const $d59febdd5a89527d$var$events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class $d59febdd5a89527d$export$b26af955418d6638 extends $d59febdd5a89527d$var$AbstractPointerSensor {
    constructor(props){
        const { event: event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, $e8fe9e9079a95c7c$export$b204af158042fbac)(event.target);
        super(props, $d59febdd5a89527d$var$events, listenerTarget);
    }
}
$d59febdd5a89527d$export$b26af955418d6638.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $d59febdd5a89527d$var$events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var $d59febdd5a89527d$var$MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})($d59febdd5a89527d$var$MouseButton || ($d59febdd5a89527d$var$MouseButton = {}));
class $d59febdd5a89527d$export$b28554b50bf7f273 extends $d59febdd5a89527d$var$AbstractPointerSensor {
    constructor(props){
        super(props, $d59febdd5a89527d$var$events$1, (0, $e8fe9e9079a95c7c$export$b204af158042fbac)(props.event.target));
    }
}
$d59febdd5a89527d$export$b28554b50bf7f273.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            if (event.button === $d59febdd5a89527d$var$MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
const $d59febdd5a89527d$var$events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class $d59febdd5a89527d$export$19b41baf2e1bcdc0 extends $d59febdd5a89527d$var$AbstractPointerSensor {
    constructor(props){
        super(props, $d59febdd5a89527d$var$events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener($d59febdd5a89527d$var$events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener($d59febdd5a89527d$var$events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
$d59febdd5a89527d$export$19b41baf2e1bcdc0.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation: onActivation } = _ref2;
            const { touches: touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event: event
            });
            return true;
        }
    }
];
var $d59febdd5a89527d$export$eefe60e26f04c318;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})($d59febdd5a89527d$export$eefe60e26f04c318 || ($d59febdd5a89527d$export$eefe60e26f04c318 = {}));
var $d59febdd5a89527d$export$f93aa492a37e1b0e;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})($d59febdd5a89527d$export$f93aa492a37e1b0e || ($d59febdd5a89527d$export$f93aa492a37e1b0e = {}));
function $d59febdd5a89527d$var$useAutoScroller(_ref) {
    let { acceleration: acceleration, activator: activator = $d59febdd5a89527d$export$eefe60e26f04c318.Pointer, canScroll: canScroll, draggingRect: draggingRect, enabled: enabled, interval: interval = 5, order: order = $d59febdd5a89527d$export$f93aa492a37e1b0e.TreeOrder, pointerCoordinates: pointerCoordinates, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, delta: delta, threshold: threshold } = _ref;
    const scrollIntent = $d59febdd5a89527d$var$useScrollIntent({
        delta: delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, $e8fe9e9079a95c7c$export$f4b266cd2aae9cb1)();
    const scrollSpeed = (0, $kYL7Z.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, $kYL7Z.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, $kYL7Z.useMemo)(()=>{
        switch(activator){
            case $d59febdd5a89527d$export$eefe60e26f04c318.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case $d59febdd5a89527d$export$eefe60e26f04c318.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, $kYL7Z.useRef)(null);
    const autoScroll = (0, $kYL7Z.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, $kYL7Z.useMemo)(()=>order === $d59febdd5a89527d$export$f93aa492a37e1b0e.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction: direction, speed: speed } = $d59febdd5a89527d$var$getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const $d59febdd5a89527d$var$defaultScrollIntent = {
    x: {
        [$d59febdd5a89527d$var$Direction.Backward]: false,
        [$d59febdd5a89527d$var$Direction.Forward]: false
    },
    y: {
        [$d59febdd5a89527d$var$Direction.Backward]: false,
        [$d59febdd5a89527d$var$Direction.Forward]: false
    }
};
function $d59febdd5a89527d$var$useScrollIntent(_ref2) {
    let { delta: delta, disabled: disabled } = _ref2;
    const previousDelta = (0, $e8fe9e9079a95c7c$export$5cae361ad82dce8b)(delta);
    return (0, $e8fe9e9079a95c7c$export$b0d7b7f1fcd613d1)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return $d59febdd5a89527d$var$defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [$d59febdd5a89527d$var$Direction.Backward]: previousIntent.x[$d59febdd5a89527d$var$Direction.Backward] || direction.x === -1,
                [$d59febdd5a89527d$var$Direction.Forward]: previousIntent.x[$d59febdd5a89527d$var$Direction.Forward] || direction.x === 1
            },
            y: {
                [$d59febdd5a89527d$var$Direction.Backward]: previousIntent.y[$d59febdd5a89527d$var$Direction.Backward] || direction.y === -1,
                [$d59febdd5a89527d$var$Direction.Forward]: previousIntent.y[$d59febdd5a89527d$var$Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function $d59febdd5a89527d$var$useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, $e8fe9e9079a95c7c$export$b0d7b7f1fcd613d1)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function $d59febdd5a89527d$var$useCombineActivators(sensors, getSyntheticHandler) {
    return (0, $kYL7Z.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var $d59febdd5a89527d$export$571c10ffffe014ab;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})($d59febdd5a89527d$export$571c10ffffe014ab || ($d59febdd5a89527d$export$571c10ffffe014ab = {}));
var $d59febdd5a89527d$export$8e062c3160beefd5;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})($d59febdd5a89527d$export$8e062c3160beefd5 || ($d59febdd5a89527d$export$8e062c3160beefd5 = {}));
const $d59febdd5a89527d$var$defaultValue = /*#__PURE__*/ new Map();
function $d59febdd5a89527d$var$useDroppableMeasuring(containers, _ref) {
    let { dragging: dragging, dependencies: dependencies, config: config } = _ref;
    const [queue, setQueue] = (0, $kYL7Z.useState)(null);
    const { frequency: frequency, measure: measure, strategy: strategy } = config;
    const containersRef = (0, $kYL7Z.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, $e8fe9e9079a95c7c$export$86c4283a11f23f95)(disabled);
    const measureDroppableContainers = (0, $kYL7Z.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, $kYL7Z.useRef)(null);
    const droppableRects = (0, $e8fe9e9079a95c7c$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (disabled && !dragging) return $d59febdd5a89527d$var$defaultValue;
        if (!previousValue || previousValue === $d59febdd5a89527d$var$defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new $d59febdd5a89527d$var$Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects: droppableRects,
        measureDroppableContainers: measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case $d59febdd5a89527d$export$571c10ffffe014ab.Always:
                return false;
            case $d59febdd5a89527d$export$571c10ffffe014ab.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function $d59febdd5a89527d$var$useInitialValue(value, computeFn) {
    return (0, $e8fe9e9079a95c7c$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function $d59febdd5a89527d$var$useInitialRect(node, measure) {
    return $d59febdd5a89527d$var$useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function $d59febdd5a89527d$var$useMutationObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleMutations = (0, $e8fe9e9079a95c7c$export$90fc3a17d93f704c)(callback);
    const mutationObserver = (0, $kYL7Z.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver: MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function $d59febdd5a89527d$var$useResizeObserver(_ref) {
    let { callback: callback, disabled: disabled } = _ref;
    const handleResize = (0, $e8fe9e9079a95c7c$export$90fc3a17d93f704c)(callback);
    const resizeObserver = (0, $kYL7Z.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver: ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function $d59febdd5a89527d$var$defaultMeasure(element) {
    return new $d59febdd5a89527d$var$Rect($d59febdd5a89527d$export$b6aa1f30c53d7454(element), element);
}
function $d59febdd5a89527d$var$useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = $d59febdd5a89527d$var$defaultMeasure;
    const [rect, setRect] = (0, $kYL7Z.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = $d59febdd5a89527d$var$useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type: type, target: target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = $d59febdd5a89527d$var$useResizeObserver({
        callback: measureRect
    });
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function $d59febdd5a89527d$var$useRectDelta(rect) {
    const initialRect = $d59febdd5a89527d$var$useInitialValue(rect);
    return $d59febdd5a89527d$var$getRectDelta(rect, initialRect);
}
const $d59febdd5a89527d$var$defaultValue$1 = [];
function $d59febdd5a89527d$var$useScrollableAncestors(node) {
    const previousNode = (0, $kYL7Z.useRef)(node);
    const ancestors = (0, $e8fe9e9079a95c7c$export$b0d7b7f1fcd613d1)((previousValue)=>{
        if (!node) return $d59febdd5a89527d$var$defaultValue$1;
        if (previousValue && previousValue !== $d59febdd5a89527d$var$defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return $d59febdd5a89527d$export$e4864aa91b5ed091(node);
    }, [
        node
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function $d59febdd5a89527d$var$useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, $kYL7Z.useState)(null);
    const prevElements = (0, $kYL7Z.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, $kYL7Z.useCallback)((event)=>{
        const scrollingElement = $d59febdd5a89527d$var$getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, $d59febdd5a89527d$var$getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, $kYL7Z.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = $d59febdd5a89527d$var$getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        $d59febdd5a89527d$var$getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = $d59febdd5a89527d$var$getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, $kYL7Z.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, $e8fe9e9079a95c7c$export$e16d8520af44a096)(acc, coordinates), $d59febdd5a89527d$export$597cbd7bbd10deb4) : $d59febdd5a89527d$var$getScrollOffsets(elements);
        return $d59febdd5a89527d$export$597cbd7bbd10deb4;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function $d59febdd5a89527d$var$useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, $kYL7Z.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== $d59febdd5a89527d$export$597cbd7bbd10deb4;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, $e8fe9e9079a95c7c$export$4e2d2ead65e5f7e3)(scrollOffsets, initialScrollOffsets.current) : $d59febdd5a89527d$export$597cbd7bbd10deb4;
}
function $d59febdd5a89527d$var$useSensorSetup(sensors) {
    (0, $kYL7Z.useEffect)(()=>{
        if (!(0, $e8fe9e9079a95c7c$export$71594e8a50f746f4)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor: sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor: sensor } = _ref2;
        return sensor;
    }));
}
function $d59febdd5a89527d$var$useSyntheticListeners(listeners, id) {
    return (0, $kYL7Z.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName: eventName, handler: handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function $d59febdd5a89527d$var$useWindowRect(element) {
    return (0, $kYL7Z.useMemo)(()=>element ? $d59febdd5a89527d$var$getWindowClientRect(element) : null, [
        element
    ]);
}
const $d59febdd5a89527d$var$defaultValue$2 = [];
function $d59febdd5a89527d$var$useRects(elements, measure) {
    if (measure === void 0) measure = $d59febdd5a89527d$export$b6aa1f30c53d7454;
    const [firstElement] = elements;
    const windowRect = $d59febdd5a89527d$var$useWindowRect(firstElement ? (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(firstElement) : null);
    const [rects, setRects] = (0, $kYL7Z.useState)($d59febdd5a89527d$var$defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return $d59febdd5a89527d$var$defaultValue$2;
            return elements.map((element)=>$d59febdd5a89527d$var$isDocumentScrollingElement(element) ? windowRect : new $d59febdd5a89527d$var$Rect(measure(element), element));
        });
    }
    const resizeObserver = $d59febdd5a89527d$var$useResizeObserver({
        callback: measureRects
    });
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function $d59febdd5a89527d$var$getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, $e8fe9e9079a95c7c$export$1b3bfaa9684536aa)(firstChild) ? firstChild : node;
}
function $d59febdd5a89527d$var$useDragOverlayMeasuring(_ref) {
    let { measure: measure } = _ref;
    const [rect, setRect] = (0, $kYL7Z.useState)(null);
    const handleResize = (0, $kYL7Z.useCallback)((entries)=>{
        for (const { target: target } of entries)if ((0, $e8fe9e9079a95c7c$export$1b3bfaa9684536aa)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = $d59febdd5a89527d$var$useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, $kYL7Z.useCallback)((element)=>{
        const node = $d59febdd5a89527d$var$getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, $e8fe9e9079a95c7c$export$bc23c270f170c912)(handleNodeChange);
    return (0, $kYL7Z.useMemo)(()=>({
            nodeRef: nodeRef,
            rect: rect,
            setRef: setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const $d59febdd5a89527d$var$defaultSensors = [
    {
        sensor: $d59febdd5a89527d$export$b26af955418d6638,
        options: {}
    },
    {
        sensor: $d59febdd5a89527d$export$44d67f2a438aeba9,
        options: {}
    }
];
const $d59febdd5a89527d$var$defaultData = {
    current: {}
};
const $d59febdd5a89527d$var$defaultMeasuringConfiguration = {
    draggable: {
        measure: $d59febdd5a89527d$var$getTransformAgnosticClientRect
    },
    droppable: {
        measure: $d59febdd5a89527d$var$getTransformAgnosticClientRect,
        strategy: $d59febdd5a89527d$export$571c10ffffe014ab.WhileDragging,
        frequency: $d59febdd5a89527d$export$8e062c3160beefd5.Optimized
    },
    dragOverlay: {
        measure: $d59febdd5a89527d$export$b6aa1f30c53d7454
    }
};
class $d59febdd5a89527d$var$DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled: disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const $d59febdd5a89527d$var$defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new $d59febdd5a89527d$var$DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: $d59febdd5a89527d$var$noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: $d59febdd5a89527d$var$defaultMeasuringConfiguration,
    measureDroppableContainers: $d59febdd5a89527d$var$noop,
    windowRect: null,
    measuringScheduled: false
};
const $d59febdd5a89527d$var$defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: $d59febdd5a89527d$var$noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: $d59febdd5a89527d$var$noop
};
const $d59febdd5a89527d$var$InternalContext = /*#__PURE__*/ (0, $kYL7Z.createContext)($d59febdd5a89527d$var$defaultInternalContext);
const $d59febdd5a89527d$var$PublicContext = /*#__PURE__*/ (0, $kYL7Z.createContext)($d59febdd5a89527d$var$defaultPublicContext);
function $d59febdd5a89527d$var$getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new $d59febdd5a89527d$var$DroppableContainersMap()
        }
    };
}
function $d59febdd5a89527d$var$reducer(state, action) {
    switch(action.type){
        case $d59febdd5a89527d$var$Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case $d59febdd5a89527d$var$Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case $d59febdd5a89527d$var$Action.DragEnd:
        case $d59febdd5a89527d$var$Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case $d59febdd5a89527d$var$Action.RegisterDroppable:
            {
                const { element: element } = action;
                const { id: id } = element;
                const containers = new $d59febdd5a89527d$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $d59febdd5a89527d$var$Action.SetDroppableDisabled:
            {
                const { id: id, key: key, disabled: disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $d59febdd5a89527d$var$DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled: disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        case $d59febdd5a89527d$var$Action.UnregisterDroppable:
            {
                const { id: id, key: key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new $d59febdd5a89527d$var$DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers: containers
                    }
                };
            }
        default:
            return state;
    }
}
function $d59febdd5a89527d$var$RestoreFocus(_ref) {
    let { disabled: disabled } = _ref;
    const { active: active, activatorEvent: activatorEvent, draggableNodes: draggableNodes } = (0, $kYL7Z.useContext)($d59febdd5a89527d$var$InternalContext);
    const previousActivatorEvent = (0, $e8fe9e9079a95c7c$export$5cae361ad82dce8b)(activatorEvent);
    const previousActiveId = (0, $e8fe9e9079a95c7c$export$5cae361ad82dce8b)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, $kYL7Z.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, $e8fe9e9079a95c7c$export$130b789831072f4c)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode: activatorNode, node: node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, $e8fe9e9079a95c7c$export$44f71d798fd0a62b)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function $d59febdd5a89527d$export$f1696300e8775372(modifiers, _ref) {
    let { transform: transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function $d59febdd5a89527d$var$useMeasuringConfiguration(config) {
    return (0, $kYL7Z.useMemo)(()=>({
            draggable: {
                ...$d59febdd5a89527d$var$defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...$d59febdd5a89527d$var$defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...$d59febdd5a89527d$var$defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function $d59febdd5a89527d$var$useLayoutShiftScrollCompensation(_ref) {
    let { activeNode: activeNode, measure: measure, initialRect: initialRect, config: config = true } = _ref;
    const initialized = (0, $kYL7Z.useRef)(false);
    const { x: x, y: y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = $d59febdd5a89527d$var$getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = $d59febdd5a89527d$var$getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const $d59febdd5a89527d$var$ActiveDraggableContext = /*#__PURE__*/ (0, $kYL7Z.createContext)({
    ...$d59febdd5a89527d$export$597cbd7bbd10deb4,
    scaleX: 1,
    scaleY: 1
});
var $d59febdd5a89527d$var$Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})($d59febdd5a89527d$var$Status || ($d59febdd5a89527d$var$Status = {}));
const $d59febdd5a89527d$export$2d5c5ceac203fc1e = /*#__PURE__*/ (0, $kYL7Z.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id: id, accessibility: accessibility, autoScroll: autoScroll = true, children: children, sensors: sensors = $d59febdd5a89527d$var$defaultSensors, collisionDetection: collisionDetection = $d59febdd5a89527d$export$953346c40b5eb62a, measuring: measuring, modifiers: modifiers, ...props } = _ref;
    const store = (0, $kYL7Z.useReducer)($d59febdd5a89527d$var$reducer, undefined, $d59febdd5a89527d$var$getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = $d59febdd5a89527d$var$useDndMonitorProvider();
    const [status, setStatus] = (0, $kYL7Z.useState)($d59febdd5a89527d$var$Status.Uninitialized);
    const isInitialized = status === $d59febdd5a89527d$var$Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate: translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, $kYL7Z.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, $kYL7Z.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : $d59febdd5a89527d$var$defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, $kYL7Z.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, $kYL7Z.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, $kYL7Z.useState)(null);
    const latestProps = (0, $e8fe9e9079a95c7c$export$86c4283a11f23f95)(props, Object.values(props));
    const draggableDescribedById = (0, $e8fe9e9079a95c7c$export$c485849f2e393253)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, $kYL7Z.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = $d59febdd5a89527d$var$useMeasuringConfiguration(measuring);
    const { droppableRects: droppableRects, measureDroppableContainers: measureDroppableContainers, measuringScheduled: measuringScheduled } = $d59febdd5a89527d$var$useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = $d59febdd5a89527d$var$useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, $kYL7Z.useMemo)(()=>activatorEvent ? (0, $e8fe9e9079a95c7c$export$36195c8aa1517e04)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = $d59febdd5a89527d$var$useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    $d59febdd5a89527d$var$useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = $d59febdd5a89527d$var$useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = $d59febdd5a89527d$var$useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, $kYL7Z.useRef)({
        activatorEvent: null,
        active: null,
        activeNode: activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects: droppableRects,
        draggableNodes: draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers: droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = $d59febdd5a89527d$var$useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = $d59febdd5a89527d$var$useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = $d59febdd5a89527d$var$useWindowRect(draggingNode ? (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = $d59febdd5a89527d$var$useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = $d59febdd5a89527d$var$useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = $d59febdd5a89527d$export$f1696300e8775372(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        windowRect: windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, $e8fe9e9079a95c7c$export$e16d8520af44a096)(activationCoordinates, translate) : null;
    const scrollOffsets = $d59febdd5a89527d$var$useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = $d59febdd5a89527d$var$useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = $d59febdd5a89527d$var$useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, $e8fe9e9079a95c7c$export$e16d8520af44a096)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? $d59febdd5a89527d$var$getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active: active,
        collisionRect: collisionRect,
        droppableRects: droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates: pointerCoordinates
    }) : null;
    const overId = $d59febdd5a89527d$export$ef1beab6d7287295(collisions, 'id');
    const [over, setOver] = (0, $kYL7Z.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, $e8fe9e9079a95c7c$export$e16d8520af44a096)(modifiedTranslate, activeNodeScrollDelta);
    const transform = $d59febdd5a89527d$var$adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, $kYL7Z.useRef)(null);
    const instantiateSensor = (0, $kYL7Z.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options: options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode: activeNode,
            event: activatorEvent,
            options: options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort: onDragAbort } = latestProps.current;
                const event = {
                    id: id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event: event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending: onDragPending } = latestProps.current;
                const event = {
                    id: id,
                    constraint: constraint,
                    initialCoordinates: initialCoordinates,
                    offset: offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event: event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart: onDragStart } = latestProps.current;
                const event = {
                    activatorEvent: activatorEvent,
                    active: {
                        id: id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, $cRanb.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus($d59febdd5a89527d$var$Status.Initializing);
                    dispatch({
                        type: $d59febdd5a89527d$var$Action.DragStart,
                        initialCoordinates: initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event: event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: $d59febdd5a89527d$var$Action.DragMove,
                    coordinates: coordinates
                });
            },
            onEnd: createHandler($d59febdd5a89527d$var$Action.DragEnd),
            onCancel: createHandler($d59febdd5a89527d$var$Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active: active, collisions: collisions, over: over, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop: cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent: activatorEvent,
                        active: active,
                        collisions: collisions,
                        delta: scrollAdjustedTranslate,
                        over: over
                    };
                    if (type === $d59febdd5a89527d$var$Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = $d59febdd5a89527d$var$Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, $cRanb.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type: type
                    });
                    setStatus($d59febdd5a89527d$var$Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === $d59febdd5a89527d$var$Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event: event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, $kYL7Z.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = $d59febdd5a89527d$var$useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    $d59febdd5a89527d$var$useSensorSetup(sensors);
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        if (activeNodeRect && status === $d59febdd5a89527d$var$Status.Initializing) setStatus($d59febdd5a89527d$var$Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        const { onDragMove: onDragMove } = latestProps.current;
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, over: over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $cRanb.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event: event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        const { active: active, activatorEvent: activatorEvent, collisions: collisions, droppableContainers: droppableContainers, scrollAdjustedTranslate: scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver: onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active: active,
            activatorEvent: activatorEvent,
            collisions: collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over: over
        };
        (0, $cRanb.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event: event
            });
        });
    }, [
        overId
    ]);
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        sensorContext.current = {
            activatorEvent: activatorEvent,
            active: active,
            activeNode: activeNode,
            collisionRect: collisionRect,
            collisions: collisions,
            droppableRects: droppableRects,
            draggableNodes: draggableNodes,
            draggingNode: draggingNode,
            draggingNodeRect: draggingNodeRect,
            droppableContainers: droppableContainers,
            over: over,
            scrollableAncestors: scrollableAncestors,
            scrollAdjustedTranslate: scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    $d59febdd5a89527d$var$useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates: pointerCoordinates,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects
    });
    const publicContext = (0, $kYL7Z.useMemo)(()=>{
        const context = {
            active: active,
            activeNode: activeNode,
            activeNodeRect: activeNodeRect,
            activatorEvent: activatorEvent,
            collisions: collisions,
            containerNodeRect: containerNodeRect,
            dragOverlay: dragOverlay,
            draggableNodes: draggableNodes,
            droppableContainers: droppableContainers,
            droppableRects: droppableRects,
            over: over,
            measureDroppableContainers: measureDroppableContainers,
            scrollableAncestors: scrollableAncestors,
            scrollableAncestorRects: scrollableAncestorRects,
            measuringConfiguration: measuringConfiguration,
            measuringScheduled: measuringScheduled,
            windowRect: windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, $kYL7Z.useMemo)(()=>{
        const context = {
            activatorEvent: activatorEvent,
            activators: activators,
            active: active,
            activeNodeRect: activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch: dispatch,
            draggableNodes: draggableNodes,
            over: over,
            measureDroppableContainers: measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$InternalContext.Provider, {
        value: internalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$PublicContext.Provider, {
        value: publicContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled: enabled
        };
        return {
            enabled: enabled
        };
    }
});
const $d59febdd5a89527d$var$NullContext = /*#__PURE__*/ (0, $kYL7Z.createContext)(null);
const $d59febdd5a89527d$var$defaultRole = 'button';
const $d59febdd5a89527d$var$ID_PREFIX = 'Draggable';
function $d59febdd5a89527d$export$df30c81f5aa01ff7(_ref) {
    let { id: id, data: data, disabled: disabled = false, attributes: attributes } = _ref;
    const key = (0, $e8fe9e9079a95c7c$export$c485849f2e393253)($d59febdd5a89527d$var$ID_PREFIX);
    const { activators: activators, activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, ariaDescribedById: ariaDescribedById, draggableNodes: draggableNodes, over: over } = (0, $kYL7Z.useContext)($d59febdd5a89527d$var$InternalContext);
    const { role: role = $d59febdd5a89527d$var$defaultRole, roleDescription: roleDescription = 'draggable', tabIndex: tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, $kYL7Z.useContext)(isDragging ? $d59febdd5a89527d$var$ActiveDraggableContext : $d59febdd5a89527d$var$NullContext);
    const [node, setNodeRef] = (0, $e8fe9e9079a95c7c$export$bc23c270f170c912)();
    const [activatorNode, setActivatorNodeRef] = (0, $e8fe9e9079a95c7c$export$bc23c270f170c912)();
    const listeners = $d59febdd5a89527d$var$useSyntheticListeners(activators, id);
    const dataRef = (0, $e8fe9e9079a95c7c$export$86c4283a11f23f95)(data);
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        draggableNodes.set(id, {
            id: id,
            key: key,
            node: node,
            activatorNode: activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, $kYL7Z.useMemo)(()=>({
            role: role,
            tabIndex: tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === $d59febdd5a89527d$var$defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active: active,
        activatorEvent: activatorEvent,
        activeNodeRect: activeNodeRect,
        attributes: memoizedAttributes,
        isDragging: isDragging,
        listeners: disabled ? undefined : listeners,
        node: node,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        transform: transform
    };
}
function $d59febdd5a89527d$export$4930f6bf413be70e() {
    return (0, $kYL7Z.useContext)($d59febdd5a89527d$var$PublicContext);
}
const $d59febdd5a89527d$var$ID_PREFIX$1 = 'Droppable';
const $d59febdd5a89527d$var$defaultResizeObserverConfig = {
    timeout: 25
};
function $d59febdd5a89527d$export$d74e5d67dc2b3176(_ref) {
    let { data: data, disabled: disabled = false, id: id, resizeObserverConfig: resizeObserverConfig } = _ref;
    const key = (0, $e8fe9e9079a95c7c$export$c485849f2e393253)($d59febdd5a89527d$var$ID_PREFIX$1);
    const { active: active, dispatch: dispatch, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $kYL7Z.useContext)($d59febdd5a89527d$var$InternalContext);
    const previous = (0, $kYL7Z.useRef)({
        disabled: disabled
    });
    const resizeObserverConnected = (0, $kYL7Z.useRef)(false);
    const rect = (0, $kYL7Z.useRef)(null);
    const callbackId = (0, $kYL7Z.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor: updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...$d59febdd5a89527d$var$defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, $e8fe9e9079a95c7c$export$86c4283a11f23f95)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, $kYL7Z.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = $d59febdd5a89527d$var$useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, $kYL7Z.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, $e8fe9e9079a95c7c$export$bc23c270f170c912)(handleNodeChange);
    const dataRef = (0, $e8fe9e9079a95c7c$export$86c4283a11f23f95)(data);
    (0, $kYL7Z.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        dispatch({
            type: $d59febdd5a89527d$var$Action.RegisterDroppable,
            element: {
                id: id,
                key: key,
                disabled: disabled,
                node: nodeRef,
                rect: rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: $d59febdd5a89527d$var$Action.UnregisterDroppable,
                key: key,
                id: id
            });
    }, [
        id
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: $d59febdd5a89527d$var$Action.SetDroppableDisabled,
                id: id,
                key: key,
                disabled: disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active: active,
        rect: rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over: over,
        setNodeRef: setNodeRef
    };
}
function $d59febdd5a89527d$var$AnimationManager(_ref) {
    let { animation: animation, children: children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, $kYL7Z.useState)(null);
    const [element, setElement] = (0, $kYL7Z.useState)(null);
    const previousChildren = (0, $e8fe9e9079a95c7c$export$5cae361ad82dce8b)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null, children, clonedChildren ? (0, $kYL7Z.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const $d59febdd5a89527d$var$defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function $d59febdd5a89527d$var$NullifiedContextProvider(_ref) {
    let { children: children } = _ref;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$InternalContext.Provider, {
        value: $d59febdd5a89527d$var$defaultInternalContext
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$ActiveDraggableContext.Provider, {
        value: $d59febdd5a89527d$var$defaultTransform
    }, children));
}
const $d59febdd5a89527d$var$baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const $d59febdd5a89527d$var$defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, $e8fe9e9079a95c7c$export$130b789831072f4c)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const $d59febdd5a89527d$var$PositionedOverlay = /*#__PURE__*/ (0, $kYL7Z.forwardRef)((_ref, ref)=>{
    let { as: as, activatorEvent: activatorEvent, adjustScale: adjustScale, children: children, className: className, rect: rect, style: style, transform: transform, transition: transition = $d59febdd5a89527d$var$defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...$d59febdd5a89527d$var$baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, $e8fe9e9079a95c7c$export$c4ffa16951855e28).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? $d59febdd5a89527d$var$getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement(as, {
        className: className,
        style: styles,
        ref: ref
    }, children);
});
const $d59febdd5a89527d$export$28c62adcaabe654c = (options)=>(_ref)=>{
        let { active: active, dragOverlay: dragOverlay } = _ref;
        const originalStyles = {};
        const { styles: styles, className: className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const $d59febdd5a89527d$var$defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial: initial, final: final } } = _ref2;
    return [
        {
            transform: (0, $e8fe9e9079a95c7c$export$c4ffa16951855e28).Transform.toString(initial)
        },
        {
            transform: (0, $e8fe9e9079a95c7c$export$c4ffa16951855e28).Transform.toString(final)
        }
    ];
};
const $d59febdd5a89527d$export$10f7ab1c653bb60e = {
    duration: 250,
    easing: 'ease',
    keyframes: $d59febdd5a89527d$var$defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ $d59febdd5a89527d$export$28c62adcaabe654c({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function $d59febdd5a89527d$var$useDropAnimation(_ref3) {
    let { config: config, draggableNodes: draggableNodes, droppableContainers: droppableContainers, measuringConfiguration: measuringConfiguration } = _ref3;
    return (0, $e8fe9e9079a95c7c$export$90fc3a17d93f704c)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = $d59febdd5a89527d$var$getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform: transform } = (0, $e8fe9e9079a95c7c$export$38b2d434cce3ea22)(node).getComputedStyle(node);
        const parsedTransform = $d59febdd5a89527d$var$parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : $d59febdd5a89527d$var$createDefaultDropAnimation(config);
        $d59febdd5a89527d$var$scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id: id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes: draggableNodes,
            dragOverlay: {
                node: node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers: droppableContainers,
            measuringConfiguration: measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function $d59febdd5a89527d$var$createDefaultDropAnimation(options) {
    const { duration: duration, easing: easing, sideEffects: sideEffects, keyframes: keyframes } = {
        ...$d59febdd5a89527d$export$10f7ab1c653bb60e,
        ...options
    };
    return (_ref4)=>{
        let { active: active, dragOverlay: dragOverlay, transform: transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active: active,
            dragOverlay: dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active: active,
            dragOverlay: dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration: duration,
            easing: easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let $d59febdd5a89527d$var$key = 0;
function $d59febdd5a89527d$var$useKey(id) {
    return (0, $kYL7Z.useMemo)(()=>{
        if (id == null) return;
        $d59febdd5a89527d$var$key++;
        return $d59febdd5a89527d$var$key;
    }, [
        id
    ]);
}
const $d59febdd5a89527d$export$aca73479aa40659d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).memo((_ref)=>{
    let { adjustScale: adjustScale = false, children: children, dropAnimation: dropAnimationConfig, style: style, transition: transition, modifiers: modifiers, wrapperElement: wrapperElement = 'div', className: className, zIndex: zIndex = 999 } = _ref;
    const { activatorEvent: activatorEvent, active: active, activeNodeRect: activeNodeRect, containerNodeRect: containerNodeRect, draggableNodes: draggableNodes, droppableContainers: droppableContainers, dragOverlay: dragOverlay, over: over, measuringConfiguration: measuringConfiguration, scrollableAncestors: scrollableAncestors, scrollableAncestorRects: scrollableAncestorRects, windowRect: windowRect } = $d59febdd5a89527d$export$4930f6bf413be70e();
    const transform = (0, $kYL7Z.useContext)($d59febdd5a89527d$var$ActiveDraggableContext);
    const key = $d59febdd5a89527d$var$useKey(active == null ? void 0 : active.id);
    const modifiedTransform = $d59febdd5a89527d$export$f1696300e8775372(modifiers, {
        activatorEvent: activatorEvent,
        active: active,
        activeNodeRect: activeNodeRect,
        containerNodeRect: containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over: over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors: scrollableAncestors,
        scrollableAncestorRects: scrollableAncestorRects,
        transform: transform,
        windowRect: windowRect
    });
    const initialRect = $d59febdd5a89527d$var$useInitialValue(activeNodeRect);
    const dropAnimation = $d59febdd5a89527d$var$useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes: draggableNodes,
        droppableContainers: droppableContainers,
        measuringConfiguration: measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$NullifiedContextProvider, null, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($d59febdd5a89527d$var$PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex: zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});



var $kYL7Z = parcelRequire("kYL7Z");


/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function $03fb2278f85c6d47$export$5d49d615ad5ea2b0(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function $03fb2278f85c6d47$export$5d3a3e794fd2dcef(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function $03fb2278f85c6d47$var$getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function $03fb2278f85c6d47$var$isValidIndex(index) {
    return index !== null && index >= 0;
}
function $03fb2278f85c6d47$var$itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function $03fb2278f85c6d47$var$normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const $03fb2278f85c6d47$var$defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const $03fb2278f85c6d47$export$7a687825fa98548a = (_ref)=>{
    var _rects$activeIndex;
    let { rects: rects, activeNodeRect: fallbackActiveRect, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = $03fb2278f85c6d47$var$getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...$03fb2278f85c6d47$var$defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...$03fb2278f85c6d47$var$defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...$03fb2278f85c6d47$var$defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...$03fb2278f85c6d47$var$defaultScale
    };
};
function $03fb2278f85c6d47$var$getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const $03fb2278f85c6d47$export$9377a9486e3fbbe1 = (_ref)=>{
    let { rects: rects, activeIndex: activeIndex, overIndex: overIndex, index: index } = _ref;
    const newRects = $03fb2278f85c6d47$export$5d49d615ad5ea2b0(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const $03fb2278f85c6d47$export$8b26fb37076c162 = (_ref)=>{
    let { activeIndex: activeIndex, index: index, rects: rects, overIndex: overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const $03fb2278f85c6d47$var$defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const $03fb2278f85c6d47$export$fe2be640df2ffb9e = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex: activeIndex, activeNodeRect: fallbackActiveRect, index: index, rects: rects, overIndex: overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...$03fb2278f85c6d47$var$defaultScale$1
        };
    }
    const itemGap = $03fb2278f85c6d47$var$getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...$03fb2278f85c6d47$var$defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...$03fb2278f85c6d47$var$defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...$03fb2278f85c6d47$var$defaultScale$1
    };
};
function $03fb2278f85c6d47$var$getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const $03fb2278f85c6d47$var$ID_PREFIX = 'Sortable';
const $03fb2278f85c6d47$var$Context = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext({
    activeIndex: -1,
    containerId: $03fb2278f85c6d47$var$ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: $03fb2278f85c6d47$export$9377a9486e3fbbe1,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function $03fb2278f85c6d47$export$86155fde54f06e6a(_ref) {
    let { children: children, id: id, items: userDefinedItems, strategy: strategy = $03fb2278f85c6d47$export$9377a9486e3fbbe1, disabled: disabledProp = false } = _ref;
    const { active: active, dragOverlay: dragOverlay, droppableRects: droppableRects, over: over, measureDroppableContainers: measureDroppableContainers } = (0, $d59febdd5a89527d$export$4930f6bf413be70e)();
    const containerId = (0, $e8fe9e9079a95c7c$export$c485849f2e393253)($03fb2278f85c6d47$var$ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, $kYL7Z.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, $kYL7Z.useRef)(items);
    const itemsHaveChanged = !$03fb2278f85c6d47$var$itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = $03fb2278f85c6d47$var$normalizeDisabled(disabledProp);
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, $kYL7Z.useMemo)(()=>({
            activeIndex: activeIndex,
            containerId: containerId,
            disabled: disabled,
            disableTransforms: disableTransforms,
            items: items,
            overIndex: overIndex,
            useDragOverlay: useDragOverlay,
            sortedRects: $03fb2278f85c6d47$var$getSortedRects(items, droppableRects),
            strategy: strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($03fb2278f85c6d47$var$Context.Provider, {
        value: contextValue
    }, children);
}
const $03fb2278f85c6d47$export$e1ca29a833a61b5e = (_ref)=>{
    let { id: id, items: items, activeIndex: activeIndex, overIndex: overIndex } = _ref;
    return $03fb2278f85c6d47$export$5d49d615ad5ea2b0(items, activeIndex, overIndex).indexOf(id);
};
const $03fb2278f85c6d47$export$633d85fd1dcf5e11 = (_ref2)=>{
    let { containerId: containerId, isSorting: isSorting, wasDragging: wasDragging, index: index, items: items, newIndex: newIndex, previousItems: previousItems, previousContainerId: previousContainerId, transition: transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const $03fb2278f85c6d47$var$defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const $03fb2278f85c6d47$var$transitionProperty = 'transform';
const $03fb2278f85c6d47$var$disabledTransition = /*#__PURE__*/ (0, $e8fe9e9079a95c7c$export$c4ffa16951855e28).Transition.toString({
    property: $03fb2278f85c6d47$var$transitionProperty,
    duration: 0,
    easing: 'linear'
});
const $03fb2278f85c6d47$var$defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function $03fb2278f85c6d47$var$useDerivedTransform(_ref) {
    let { disabled: disabled, index: index, node: node, rect: rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, $kYL7Z.useState)(null);
    const previousIndex = (0, $kYL7Z.useRef)(index);
    (0, $e8fe9e9079a95c7c$export$700979bc83e7db82)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, $d59febdd5a89527d$export$b6aa1f30c53d7454)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function $03fb2278f85c6d47$export$4ebcb6201122185a(_ref) {
    let { animateLayoutChanges: animateLayoutChanges = $03fb2278f85c6d47$export$633d85fd1dcf5e11, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex: getNewIndex = $03fb2278f85c6d47$export$e1ca29a833a61b5e, id: id, strategy: localStrategy, resizeObserverConfig: resizeObserverConfig, transition: transition = $03fb2278f85c6d47$var$defaultTransition } = _ref;
    const { items: items, containerId: containerId, activeIndex: activeIndex, disabled: globalDisabled, disableTransforms: disableTransforms, sortedRects: sortedRects, overIndex: overIndex, useDragOverlay: useDragOverlay, strategy: globalStrategy } = (0, $kYL7Z.useContext)($03fb2278f85c6d47$var$Context);
    const disabled = $03fb2278f85c6d47$var$normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, $kYL7Z.useMemo)(()=>({
            sortable: {
                containerId: containerId,
                index: index,
                items: items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, $kYL7Z.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect: rect, node: node, isOver: isOver, setNodeRef: setDroppableNodeRef } = (0, $d59febdd5a89527d$export$d74e5d67dc2b3176)({
        id: id,
        data: data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active: active, activatorEvent: activatorEvent, activeNodeRect: activeNodeRect, attributes: attributes, setNodeRef: setDraggableNodeRef, listeners: listeners, isDragging: isDragging, over: over, setActivatorNodeRef: setActivatorNodeRef, transform: transform } = (0, $d59febdd5a89527d$export$df30c81f5aa01ff7)({
        id: id,
        data: data,
        attributes: {
            ...$03fb2278f85c6d47$var$defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, $e8fe9e9079a95c7c$export$2f8294366bb2d67a)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && $03fb2278f85c6d47$var$isValidIndex(activeIndex) && $03fb2278f85c6d47$var$isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect: activeNodeRect,
        activeIndex: activeIndex,
        overIndex: overIndex,
        index: index
    }) : null;
    const newIndex = $03fb2278f85c6d47$var$isValidIndex(activeIndex) && $03fb2278f85c6d47$var$isValidIndex(overIndex) ? getNewIndex({
        id: id,
        items: items,
        activeIndex: activeIndex,
        overIndex: overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, $kYL7Z.useRef)({
        activeId: activeId,
        items: items,
        newIndex: newIndex,
        containerId: containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active: active,
        containerId: containerId,
        isDragging: isDragging,
        isSorting: isSorting,
        id: id,
        index: index,
        items: items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition: transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = $03fb2278f85c6d47$var$useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index: index,
        node: node,
        rect: rect
    });
    (0, $kYL7Z.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active: active,
        activeIndex: activeIndex,
        attributes: attributes,
        data: data,
        rect: rect,
        index: index,
        newIndex: newIndex,
        items: items,
        isOver: isOver,
        isSorting: isSorting,
        isDragging: isDragging,
        listeners: listeners,
        node: node,
        overIndex: overIndex,
        over: over,
        setNodeRef: setNodeRef,
        setActivatorNodeRef: setActivatorNodeRef,
        setDroppableNodeRef: setDroppableNodeRef,
        setDraggableNodeRef: setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return $03fb2278f85c6d47$var$disabledTransition;
        if (shouldDisplaceDragSource && !(0, $e8fe9e9079a95c7c$export$130b789831072f4c)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, $e8fe9e9079a95c7c$export$c4ffa16951855e28).Transition.toString({
            ...transition,
            property: $03fb2278f85c6d47$var$transitionProperty
        });
        return undefined;
    }
}
function $03fb2278f85c6d47$var$normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function $03fb2278f85c6d47$export$6424ec8a0d450b09(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const $03fb2278f85c6d47$var$directions = [
    (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Down,
    (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Right,
    (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Up,
    (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Left
];
const $03fb2278f85c6d47$export$a6f27ecf02eb3a67 = (event, _ref)=>{
    let { context: { active: active, collisionRect: collisionRect, droppableRects: droppableRects, droppableContainers: droppableContainers, over: over, scrollableAncestors: scrollableAncestors } } = _ref;
    if ($03fb2278f85c6d47$var$directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, $d59febdd5a89527d$export$a8b1916dba3ae88b).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, $d59febdd5a89527d$export$c3a6c1c7122b31c9)({
            active: active,
            collisionRect: collisionRect,
            droppableRects: droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, $d59febdd5a89527d$export$ef1beab6d7287295)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, $d59febdd5a89527d$export$e4864aa91b5ed091)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = $03fb2278f85c6d47$var$isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = $03fb2278f85c6d47$var$isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, $e8fe9e9079a95c7c$export$4e2d2ead65e5f7e3)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function $03fb2278f85c6d47$var$isSameContainer(a, b) {
    if (!$03fb2278f85c6d47$export$6424ec8a0d450b09(a) || !$03fb2278f85c6d47$export$6424ec8a0d450b09(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function $03fb2278f85c6d47$var$isAfter(a, b) {
    if (!$03fb2278f85c6d47$export$6424ec8a0d450b09(a) || !$03fb2278f85c6d47$export$6424ec8a0d450b09(b)) return false;
    if (!$03fb2278f85c6d47$var$isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}



function $65b1c87aa1a7f14a$export$7f11ea1f0ba255b5(gridSize) {
    return (_ref)=>{
        let { transform: transform } = _ref;
        return {
            ...transform,
            x: Math.ceil(transform.x / gridSize) * gridSize,
            y: Math.ceil(transform.y / gridSize) * gridSize
        };
    };
}
const $65b1c87aa1a7f14a$export$29320759dd5f3702 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        y: 0
    };
};
function $65b1c87aa1a7f14a$var$restrictToBoundingRect(transform, rect, boundingRect) {
    const value = {
        ...transform
    };
    if (rect.top + transform.y <= boundingRect.top) value.y = boundingRect.top - rect.top;
    else if (rect.bottom + transform.y >= boundingRect.top + boundingRect.height) value.y = boundingRect.top + boundingRect.height - rect.bottom;
    if (rect.left + transform.x <= boundingRect.left) value.x = boundingRect.left - rect.left;
    else if (rect.right + transform.x >= boundingRect.left + boundingRect.width) value.x = boundingRect.left + boundingRect.width - rect.right;
    return value;
}
const $65b1c87aa1a7f14a$export$c7685f801ed492b5 = (_ref)=>{
    let { containerNodeRect: containerNodeRect, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (!draggingNodeRect || !containerNodeRect) return transform;
    return $65b1c87aa1a7f14a$var$restrictToBoundingRect(transform, draggingNodeRect, containerNodeRect);
};
const $65b1c87aa1a7f14a$export$85bf625d52c1d097 = (_ref)=>{
    let { draggingNodeRect: draggingNodeRect, transform: transform, scrollableAncestorRects: scrollableAncestorRects } = _ref;
    const firstScrollableAncestorRect = scrollableAncestorRects[0];
    if (!draggingNodeRect || !firstScrollableAncestorRect) return transform;
    return $65b1c87aa1a7f14a$var$restrictToBoundingRect(transform, draggingNodeRect, firstScrollableAncestorRect);
};
const $65b1c87aa1a7f14a$export$1ed98a87b7c51b89 = (_ref)=>{
    let { transform: transform } = _ref;
    return {
        ...transform,
        x: 0
    };
};
const $65b1c87aa1a7f14a$export$57196ad89f591aab = (_ref)=>{
    let { transform: transform, draggingNodeRect: draggingNodeRect, windowRect: windowRect } = _ref;
    if (!draggingNodeRect || !windowRect) return transform;
    return $65b1c87aa1a7f14a$var$restrictToBoundingRect(transform, draggingNodeRect, windowRect);
};
const $65b1c87aa1a7f14a$export$70a75ea36ecd3098 = (_ref)=>{
    let { activatorEvent: activatorEvent, draggingNodeRect: draggingNodeRect, transform: transform } = _ref;
    if (draggingNodeRect && activatorEvent) {
        const activatorCoordinates = (0, $e8fe9e9079a95c7c$export$36195c8aa1517e04)(activatorEvent);
        if (!activatorCoordinates) return transform;
        const offsetX = activatorCoordinates.x - draggingNodeRect.left;
        const offsetY = activatorCoordinates.y - draggingNodeRect.top;
        return {
            ...transform,
            x: transform.x + offsetX - draggingNodeRect.width / 2,
            y: transform.y + offsetY - draggingNodeRect.height / 2
        };
    }
    return transform;
};




var $kYL7Z = parcelRequire("kYL7Z");





const $1b1f065dadce0c15$var$BUFFER_WIDTH_DEFAULT = 5;
class $1b1f065dadce0c15$export$a0dcf0ef8dc3ae26 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.EditableText`;
    static defaultProps = {
        alwaysRenderInput: false,
        confirmOnEnterKey: false,
        defaultValue: "",
        disabled: false,
        maxLines: Infinity,
        minLines: 1,
        minWidth: 80,
        multiline: false,
        placeholder: "Click to Edit",
        type: "text"
    };
    inputElement = null;
    valueElement = null;
    refHandlers = {
        content: (spanElement)=>{
            this.valueElement = spanElement;
        },
        input: (input)=>{
            if (input != null) {
                this.inputElement = input;
                // temporary fix for #3882
                if (!this.props.alwaysRenderInput) this.inputElement.focus();
                if (this.state != null && this.state.isEditing) {
                    const supportsSelection = $1b1f065dadce0c15$var$inputSupportsSelection(input);
                    if (supportsSelection) {
                        const { length: length } = input.value;
                        input.setSelectionRange(this.props.selectAllOnFocus ? 0 : length, length);
                    }
                    if (!supportsSelection || !this.props.selectAllOnFocus) input.scrollLeft = input.scrollWidth;
                }
            }
        }
    };
    constructor(props){
        super(props);
        const value = props.value == null ? props.defaultValue : props.value;
        this.state = {
            inputHeight: 0,
            inputWidth: 0,
            isEditing: props.isEditing === true && props.disabled === false,
            lastValue: value,
            value: value
        };
    }
    render() {
        const { alwaysRenderInput: alwaysRenderInput, disabled: disabled, elementRef: elementRef, multiline: multiline, contentId: contentId } = this.props;
        const value = this.props.value ?? this.state.value;
        const hasValue = value != null && value !== "";
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).EDITABLE_TEXT, (0, $2cfd35af7ec11fdd$exports).intentClass(this.props.intent), {
            [(0, $2cfd35af7ec11fdd$exports).DISABLED]: disabled,
            [(0, $2cfd35af7ec11fdd$exports).EDITABLE_TEXT_EDITING]: this.state.isEditing,
            [(0, $2cfd35af7ec11fdd$exports).EDITABLE_TEXT_PLACEHOLDER]: !hasValue,
            [(0, $2cfd35af7ec11fdd$exports).MULTILINE]: multiline
        }, this.props.className);
        let contentStyle;
        if (multiline) // set height only in multiline mode when not editing
        // otherwise we're measuring this element to determine appropriate height of text
        contentStyle = {
            height: !this.state.isEditing ? this.state.inputHeight : undefined
        };
        else // minWidth only applies in single line mode (multiline == width 100%)
        contentStyle = {
            height: this.state.inputHeight,
            lineHeight: this.state.inputHeight != null ? `${this.state.inputHeight}px` : undefined,
            minWidth: this.props.minWidth
        };
        // If we are always rendering an input, then NEVER make the container div focusable.
        // Otherwise, make container div focusable when not editing, so it can still be tabbed
        // to focus (when the input is rendered, it is itself focusable so container div doesn't need to be)
        const tabIndex = alwaysRenderInput || this.state.isEditing || disabled ? undefined : 0;
        // we need the contents to be rendered while editing so that we can measure their height
        // and size the container element responsively
        const shouldHideContents = alwaysRenderInput && !this.state.isEditing;
        const spanProps = contentId != null ? {
            id: contentId
        } : {};
        return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: classes,
            onFocus: this.handleFocus,
            tabIndex: tabIndex,
            ref: elementRef,
            children: [
                alwaysRenderInput || this.state.isEditing ? this.renderInput(value) : undefined,
                shouldHideContents ? undefined : (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                    ...spanProps,
                    className: (0, $2cfd35af7ec11fdd$exports).EDITABLE_TEXT_CONTENT,
                    ref: this.refHandlers.content,
                    style: contentStyle,
                    children: hasValue ? value : this.props.placeholder
                })
            ]
        });
    }
    componentDidMount() {
        this.updateInputDimensions();
    }
    componentDidUpdate(prevProps, prevState) {
        const newState = {};
        // allow setting the value to undefined/null in controlled mode
        if (this.props.value !== prevProps.value && (prevProps.value != null || this.props.value != null)) newState.value = this.props.value;
        if (this.props.isEditing != null && this.props.isEditing !== prevProps.isEditing) newState.isEditing = this.props.isEditing;
        if (this.props.disabled || this.props.disabled == null && prevProps.disabled) newState.isEditing = false;
        this.setState(newState);
        if (this.state.isEditing && !prevState.isEditing) this.props.onEdit?.(this.state.value);
        // updateInputDimensions is an expensive method. Call it only when the props
        // it depends on change
        if (this.state.value !== prevState.value || this.props.alwaysRenderInput !== prevProps.alwaysRenderInput || this.props.maxLines !== prevProps.maxLines || this.props.minLines !== prevProps.minLines || this.props.minWidth !== prevProps.minWidth || this.props.multiline !== prevProps.multiline || this.props.placeholder !== prevProps.placeholder) this.updateInputDimensions();
    }
    cancelEditing = ()=>{
        const { lastValue: lastValue, value: value } = this.state;
        this.setState({
            isEditing: false,
            value: lastValue
        });
        if (value !== lastValue) this.props.onChange?.(lastValue);
        this.props.onCancel?.(lastValue);
    };
    toggleEditing = ()=>{
        if (this.state.isEditing) {
            const { value: value } = this.state;
            this.setState({
                isEditing: false,
                lastValue: value
            });
            this.props.onConfirm?.(value);
        } else if (!this.props.disabled) this.setState({
            isEditing: true
        });
    };
    handleFocus = ()=>{
        const { alwaysRenderInput: alwaysRenderInput, disabled: disabled, selectAllOnFocus: selectAllOnFocus } = this.props;
        if (!disabled) this.setState({
            isEditing: true
        });
        if (alwaysRenderInput && selectAllOnFocus && this.inputElement != null) {
            const { length: length } = this.inputElement.value;
            this.inputElement.setSelectionRange(0, length);
        }
    };
    handleTextChange = (event)=>{
        const value = event.target.value;
        // state value should be updated only when uncontrolled
        if (this.props.value == null) this.setState({
            value: value
        });
        this.props.onChange?.(value);
    };
    handleKeyEvent = (event)=>{
        // During IME composition, Enter and Escape has special meanings that we will not override
        if (event.nativeEvent.isComposing) return;
        const { altKey: altKey, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = event;
        if (event.key === "Escape") {
            this.cancelEditing();
            return;
        }
        const hasModifierKey = altKey || ctrlKey || metaKey || shiftKey;
        if (event.key === "Enter") {
            // prevent browsers (Edge?) from full screening with alt + enter
            // shift + enter adds a newline by default
            if (altKey || shiftKey) event.preventDefault();
            if (this.props.confirmOnEnterKey && this.props.multiline) {
                if (event.target != null && hasModifierKey) {
                    $1b1f065dadce0c15$var$insertAtCaret(event.target, "\n");
                    this.handleTextChange(event);
                } else this.toggleEditing();
            } else if (!this.props.multiline || hasModifierKey) this.toggleEditing();
        }
    };
    renderInput(value) {
        const { disabled: disabled, maxLength: maxLength, multiline: multiline, type: type, placeholder: placeholder, customInputAttributes: customInputAttributes } = this.props;
        const props = {
            className: (0, $2cfd35af7ec11fdd$exports).EDITABLE_TEXT_INPUT,
            disabled: disabled,
            maxLength: maxLength,
            onBlur: this.toggleEditing,
            onChange: this.handleTextChange,
            onKeyDown: this.handleKeyEvent,
            placeholder: placeholder,
            value: value
        };
        const { inputHeight: inputHeight, inputWidth: inputWidth } = this.state;
        if (inputHeight !== 0 && inputWidth !== 0) props.style = {
            height: inputHeight,
            lineHeight: !multiline && inputHeight != null ? `${inputHeight}px` : undefined,
            width: multiline ? "100%" : inputWidth
        };
        return multiline ? (0, $fc31e5e9fc16a880$exports.jsx)("textarea", {
            ref: this.refHandlers.input,
            ...props,
            ...customInputAttributes
        }) : (0, $fc31e5e9fc16a880$exports.jsx)("input", {
            ref: this.refHandlers.input,
            type: type,
            ...props,
            ...customInputAttributes
        });
    }
    updateInputDimensions() {
        if (this.valueElement != null) {
            const { maxLines: maxLines, minLines: minLines, minWidth: minWidth, multiline: multiline } = this.props;
            const { parentElement: parentElement, textContent: textContent } = this.valueElement;
            let { scrollHeight: scrollHeight, scrollWidth: scrollWidth } = this.valueElement;
            const lineHeight = $1b1f065dadce0c15$var$getLineHeight(this.valueElement);
            // add one line to computed <span> height if text ends in newline
            // because <span> collapses that trailing whitespace but <textarea> shows it
            if (multiline && this.state.isEditing && /\n$/.test(textContent ?? "")) scrollHeight += lineHeight;
            if (lineHeight > 0) // line height could be 0 if the isNaN block from getLineHeight kicks in
            scrollHeight = (0, $f141b3b4d406798c$export$7d15b64cf5a3a4c4)(scrollHeight, minLines * lineHeight, maxLines * lineHeight);
            // Chrome's input caret height misaligns text so the line-height must be larger than font-size.
            // The computed scrollHeight must also account for a larger inherited line-height from the parent.
            scrollHeight = Math.max(scrollHeight, $1b1f065dadce0c15$var$getFontSize(this.valueElement) + 1, $1b1f065dadce0c15$var$getLineHeight(parentElement));
            // Need to add a small buffer so text does not shift prior to resizing, causing an infinite loop.
            scrollWidth += $1b1f065dadce0c15$var$BUFFER_WIDTH_DEFAULT;
            this.setState({
                inputHeight: scrollHeight,
                inputWidth: Math.max(scrollWidth, minWidth)
            });
            // synchronizes the ::before pseudo-element's height while editing for Chrome 53
            if (multiline && this.state.isEditing) this.setTimeout(()=>parentElement.style.height = `${scrollHeight}px`);
        }
    }
}
function $1b1f065dadce0c15$var$getFontSize(element) {
    const fontSize = getComputedStyle(element).fontSize;
    return fontSize === "" ? 0 : parseInt(fontSize.slice(0, -2), 10);
}
function $1b1f065dadce0c15$var$getLineHeight(element) {
    // getComputedStyle() => 18.0001px => 18
    let lineHeight = parseInt(getComputedStyle(element).lineHeight.slice(0, -2), 10);
    // this check will be true if line-height is a keyword like "normal"
    if (isNaN(lineHeight)) {
        // @see http://stackoverflow.com/a/18430767/6342931
        const line = document.createElement("span");
        line.innerHTML = "<br>";
        element.appendChild(line);
        const singleLineHeight = element.offsetHeight;
        line.innerHTML = "<br><br>";
        const doubleLineHeight = element.offsetHeight;
        element.removeChild(line);
        // this can return 0 in edge cases
        lineHeight = doubleLineHeight - singleLineHeight;
    }
    return lineHeight;
}
function $1b1f065dadce0c15$var$insertAtCaret(el, text) {
    const { selectionEnd: selectionEnd, selectionStart: selectionStart, value: value } = el;
    if (selectionStart >= 0) {
        const before = value.substring(0, selectionStart);
        const after = value.substring(selectionEnd, value.length);
        const len = text.length;
        el.value = `${before}${text}${after}`;
        el.selectionStart = selectionStart + len;
        el.selectionEnd = selectionStart + len;
    }
}
function $1b1f065dadce0c15$var$inputSupportsSelection(input) {
    switch(input.type){
        // HTMLTextAreaElement
        case "textarea":
            return true;
        // HTMLInputElement
        // see https://html.spec.whatwg.org/multipage/input.html#do-not-apply
        case "text":
        case "search":
        case "tel":
        case "url":
        case "password":
            return true;
        default:
            return false;
    }
}




const $cd7c29a731f3402d$export$d062678bd7e11674 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $0199c8413a0068dd$export$60332b2344f7fe41))`
    padding: 12px;
    margin: 0.25em 0;
    border-radius: var(--sf-border-radius);
    background: var(--sf-group-background) !important;

    &[class*="bp"][class*="-card"] {
        box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1),
                    0 1px 1px rgba(17, 20, 24, 0.1),
                    0 2px 6px rgba(17, 20, 24, 0.1);
    }

    &:hover ${()=>$cd7c29a731f3402d$export$4e9d5ce1e6c22a94} {
        visibility: visible;
    }
`;
const $cd7c29a731f3402d$export$d97ababab02f5739 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: ${(p)=>p.$collapsed ? '0' : '8px'};
    cursor: ${(p)=>p.$collapsible ? 'pointer' : 'default'};
    touch-action: manipulation;
    -webkit-tap-highlight-color: transparent;
    min-height: ${(p)=>p.$collapsible ? '44px' : 'auto'};
`;
const $cd7c29a731f3402d$export$67cd4f075b72ffc9 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $b90a50544ad30fb8$export$f04a61298a47a40f))`
    color: #5c7080;
    cursor: pointer;
    padding: 10px;
    margin: -10px;
`;
const $cd7c29a731f3402d$export$a0c24614540b0efb = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $b90a50544ad30fb8$export$f04a61298a47a40f))`
    color: #5c7080;
    cursor: grab;
    &:active { cursor: grabbing; }
`;
const $cd7c29a731f3402d$export$4e9d5ce1e6c22a94 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    visibility: hidden;
`;
// Heading sizes: H3=22, H4=18, H5=16, H6=14 — description is 85% of that, floored at 12px
const $cd7c29a731f3402d$var$HEADING_SIZES = [
    22,
    18,
    16,
    14
];
const $cd7c29a731f3402d$var$descSize = (depth)=>Math.max($cd7c29a731f3402d$var$HEADING_SIZES[Math.min(depth || 0, 3)] * 0.85, 12);
const $cd7c29a731f3402d$export$bf220ed4520663e8 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    color: #5f6b7c;
    font-size: ${(p)=>$cd7c29a731f3402d$var$descSize(p.$depth)}px;
    line-height: 1.3;
    margin-top: 2px;
    & [class*="bp"][class*="-editable-text-input"] {
        field-sizing: content;
        width: auto !important;
    }
`;
const $cd7c29a731f3402d$var$PANEL_WIDTH = 'min(1080px, 90vw)';
const $cd7c29a731f3402d$var$PopoverContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 12px;
    max-height: 400px;
    overflow: auto;
`;
const $cd7c29a731f3402d$var$PortalContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`${(0, $4a49823ead28a6dc$export$9cda184b27147279)}`;
const $cd7c29a731f3402d$var$CompactBody = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: var(--sf-horizontal-gap, 8px);
    flex: 1;
    min-width: 0;
`;
const $cd7c29a731f3402d$var$PANEL_MODES = {
    popover: true,
    overlay: true,
    drawer: true
};
const $cd7c29a731f3402d$export$78d37f9aaa77d8 = ({ editMode: editMode, readonly: readonly, collapsed: collapsed, onToggleCollapse: onToggleCollapse, errors: errors, title: title, titleText: titleText, description: description, depth: depth, panelWidth: panelWidth, actions: actions, dragListeners: dragListeners, children: children })=>{
    const [panelOpen, setPanelOpen] = (0, $kYL7Z.useState)(false);
    const contentHidden = editMode === 'collapsible' ? collapsed : !!$cd7c29a731f3402d$var$PANEL_MODES[editMode];
    const expandCard = contentHidden ? ()=>{
        if (editMode === 'collapsible') onToggleCollapse?.();
        else if ($cd7c29a731f3402d$var$PANEL_MODES[editMode]) setPanelOpen(true);
    } : undefined;
    const leftSlot = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            flex: 1,
            minWidth: 0
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                },
                children: [
                    dragListeners && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                        content: `Move ${titleText}`,
                        placement: "top",
                        hoverOpenDelay: 400,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$export$a0c24614540b0efb, {
                            icon: "drag-handle-vertical",
                            ...dragListeners
                        })
                    }),
                    editMode === 'collapsible' && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$export$67cd4f075b72ffc9, {
                        icon: collapsed ? 'caret-right' : 'caret-down',
                        onClick: (e)=>{
                            e.stopPropagation();
                            onToggleCollapse();
                        }
                    }),
                    editMode === 'popover' && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                        interactionKind: "hover",
                        placement: "right-start",
                        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$var$PortalContent, {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($cd7c29a731f3402d$var$PopoverContent, {
                                style: {
                                    width: panelWidth || $cd7c29a731f3402d$var$PANEL_WIDTH
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                        style: {
                                            marginBottom: 12
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px'
                                                },
                                                children: title
                                            }),
                                            description && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                                style: {
                                                    marginTop: 4
                                                },
                                                children: description
                                            })
                                        ]
                                    }),
                                    children
                                ]
                            })
                        }),
                        hoverOpenDelay: 200,
                        hoverCloseDelay: 100,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: readonly ? 'eye-open' : 'edit',
                            style: {
                                color: '#5c7080',
                                cursor: 'pointer'
                            }
                        })
                    }),
                    (editMode === 'overlay' || editMode === 'drawer') && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                        content: `${readonly ? 'View' : 'Edit'} ${titleText}`,
                        placement: "top",
                        hoverOpenDelay: 400,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: readonly ? 'eye-open' : 'edit',
                            style: {
                                color: '#5c7080',
                                cursor: 'pointer'
                            },
                            onClick: ()=>setPanelOpen(true)
                        })
                    }),
                    title,
                    contentHidden && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                        errors: errors,
                        onClick: expandCard
                    })
                ]
            }),
            description
        ]
    });
    const renderBody = ()=>{
        if (editMode === 'collapsible') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $e4a7ce8c396337d4$export$78768a9af065a7b), {
            isOpen: !collapsed,
            children: children
        });
        if (editMode === 'compact' || editMode === 'popover') return null;
        if (editMode === 'overlay') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
            isOpen: panelOpen,
            onClose: ()=>setPanelOpen(false),
            title: title || titleText,
            style: {
                width: panelWidth || $cd7c29a731f3402d$var$PANEL_WIDTH
            },
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($cd7c29a731f3402d$var$PortalContent, {
                    children: [
                        description && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                            style: {
                                marginBottom: 12
                            },
                            children: description
                        }),
                        children
                    ]
                })
            })
        });
        if (editMode === 'drawer') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
            isOpen: panelOpen,
            onClose: ()=>setPanelOpen(false),
            size: panelWidth || $cd7c29a731f3402d$var$PANEL_WIDTH,
            title: title || titleText,
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($cd7c29a731f3402d$var$PortalContent, {
                style: {
                    padding: 20
                },
                children: [
                    description && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                        style: {
                            marginBottom: 12
                        },
                        children: description
                    }),
                    children
                ]
            })
        });
        return children;
    };
    if (editMode === 'compact') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$export$d062678bd7e11674, {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($cd7c29a731f3402d$var$CompactBody, {
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                    },
                    children: [
                        dragListeners && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                            content: `Move ${titleText}`,
                            placement: "top",
                            hoverOpenDelay: 400,
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$export$a0c24614540b0efb, {
                                icon: "drag-handle-vertical",
                                ...dragListeners
                            })
                        }),
                        title,
                        description
                    ]
                }),
                children,
                actions
            ]
        })
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($cd7c29a731f3402d$export$d062678bd7e11674, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($cd7c29a731f3402d$export$d97ababab02f5739, {
                $collapsed: contentHidden,
                $collapsible: editMode === 'collapsible',
                children: [
                    leftSlot,
                    actions
                ]
            }),
            renderBody()
        ]
    });
};
// --- Shared editable title/description components ---
const $cd7c29a731f3402d$var$HEADINGS = [
    (0, $64289e527bcd600c$export$746be9e3a3dfff1f),
    (0, $64289e527bcd600c$export$cc5e069d64fda823),
    (0, $64289e527bcd600c$export$88ef9fdaf11f7a1f),
    (0, $64289e527bcd600c$export$a559fb8039b06400)
];
const $cd7c29a731f3402d$export$66422503964e48cd = (depth)=>$cd7c29a731f3402d$var$HEADINGS[Math.min(depth || 0, $cd7c29a731f3402d$var$HEADINGS.length - 1)];
const $cd7c29a731f3402d$export$cddb8b7ba9e8674e = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $64289e527bcd600c$export$88ef9fdaf11f7a1f))`
    margin: 0;
    color: var(--sf-group-label-color);
`;
const $cd7c29a731f3402d$export$9ae73c5a1c63f2d4 = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $64289e527bcd600c$export$88ef9fdaf11f7a1f))`
    margin: 0;
    color: var(--sf-group-label-color);
    & [class*="bp"][class*="-editable-text-input"] {
        field-sizing: content;
        width: auto !important;
    }
`;
const $cd7c29a731f3402d$var$TitleError = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    color: #cd4246;
    font-size: 12px;
    margin-top: 2px;
`;
const $cd7c29a731f3402d$export$fef41aee7d064ab9 = (val, type)=>{
    if (type === 'number' || type === 'integer') {
        const n = Number(val);
        return isNaN(n) ? val : n;
    }
    return val;
};
const $cd7c29a731f3402d$var$DEBOUNCE_MS = 500;
const $cd7c29a731f3402d$export$f9d7171ad5f156a8 = ({ value: value, disabled: disabled, error: error, type: type, depth: depth, placeholder: placeholder, onChange: onChange })=>{
    const [text, setText] = (0, $kYL7Z.useState)(String(value ?? ''));
    const timerRef = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useEffect)(()=>setText(String(value ?? '')), [
        value
    ]);
    (0, $kYL7Z.useEffect)(()=>()=>clearTimeout(timerRef.current), []);
    const handleChange = (0, $kYL7Z.useCallback)((val)=>{
        setText(val);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>onChange($cd7c29a731f3402d$export$fef41aee7d064ab9(val, type)), $cd7c29a731f3402d$var$DEBOUNCE_MS);
    }, [
        onChange,
        type
    ]);
    const handleConfirm = (0, $kYL7Z.useCallback)((val)=>{
        clearTimeout(timerRef.current);
        onChange($cd7c29a731f3402d$export$fef41aee7d064ab9(val, type));
    }, [
        onChange,
        type
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$export$9ae73c5a1c63f2d4, {
                as: $cd7c29a731f3402d$export$66422503964e48cd(depth),
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1b1f065dadce0c15$export$a0dcf0ef8dc3ae26), {
                    value: text,
                    onChange: handleChange,
                    onConfirm: handleConfirm,
                    disabled: disabled,
                    placeholder: placeholder,
                    selectAllOnFocus: true,
                    intent: error ? 'danger' : 'none'
                })
            }),
            error && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$var$TitleError, {
                children: error.message
            })
        ]
    });
};
const $cd7c29a731f3402d$var$DescriptionError = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    color: #cd4246;
    font-size: 11px;
    margin-top: 1px;
`;
const $cd7c29a731f3402d$export$1c673afd5aa0b669 = ({ value: value, disabled: disabled, error: error, type: type, depth: depth, placeholder: placeholder, onChange: onChange })=>{
    const [text, setText] = (0, $kYL7Z.useState)(String(value ?? ''));
    const timerRef = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useEffect)(()=>setText(String(value ?? '')), [
        value
    ]);
    (0, $kYL7Z.useEffect)(()=>()=>clearTimeout(timerRef.current), []);
    const handleChange = (0, $kYL7Z.useCallback)((val)=>{
        setText(val);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>onChange($cd7c29a731f3402d$export$fef41aee7d064ab9(val, type)), $cd7c29a731f3402d$var$DEBOUNCE_MS);
    }, [
        onChange,
        type
    ]);
    const handleConfirm = (0, $kYL7Z.useCallback)((val)=>{
        clearTimeout(timerRef.current);
        onChange($cd7c29a731f3402d$export$fef41aee7d064ab9(val, type));
    }, [
        onChange,
        type
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($cd7c29a731f3402d$export$bf220ed4520663e8, {
        $depth: depth,
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1b1f065dadce0c15$export$a0dcf0ef8dc3ae26), {
                value: text,
                onChange: handleChange,
                onConfirm: handleConfirm,
                disabled: disabled,
                placeholder: placeholder,
                selectAllOnFocus: true,
                intent: error ? 'danger' : 'none',
                maxLines: 1
            }),
            error && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($cd7c29a731f3402d$var$DescriptionError, {
                children: error.message
            })
        ]
    });
};



const $6594c3cd3a940aa3$var$SENSOR_OPTIONS = {
    activationConstraint: {
        distance: 5
    }
};
const $6594c3cd3a940aa3$var$V_MODIFIERS = [
    (0, $65b1c87aa1a7f14a$export$1ed98a87b7c51b89)
];
const $6594c3cd3a940aa3$var$H_MODIFIERS = [
    (0, $65b1c87aa1a7f14a$export$29320759dd5f3702)
];
const $6594c3cd3a940aa3$var$ArrayWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: var(--sf-vertical-gap);
`;
const $6594c3cd3a940aa3$var$HorizontalItems = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: var(--sf-horizontal-gap);
    & > * { min-width: 0;
`;
const $6594c3cd3a940aa3$var$ArrayError = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    color: #cd4246;
    font-size: 12px;
    margin-top: 4px;
`;
const $6594c3cd3a940aa3$var$noLayoutAnimation = ()=>false;
const $6594c3cd3a940aa3$var$SortableItem = ({ id: id, horizontal: horizontal, children: children })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $03fb2278f85c6d47$export$4ebcb6201122185a)({
        id: id,
        animateLayoutChanges: $6594c3cd3a940aa3$var$noLayoutAnimation
    });
    const style = {
        transform: transform ? horizontal ? `translate3d(${transform.x}px, 0, 0)` : `translate3d(0, ${transform.y}px, 0)` : undefined,
        transition: transition,
        opacity: isDragging ? 0.5 : 1
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        ref: setNodeRef,
        style: {
            ...style,
            outline: 'none'
        },
        ...attributes,
        children: children(listeners, isDragging)
    });
};
const $6594c3cd3a940aa3$export$42efeba470be9198 = ({ value: value, nullable: nullable, disabled: disabled, readonly: readonly, reorderable: reorderable = true, horizontal: horizontal, editMode: editModeProp, initialCollapsed: initialCollapsed, maxItems: maxItems, itemSchema: itemSchema, depth: depth, itemTitle: itemTitle, itemTitleReadOnly: itemTitleReadOnly, itemTitleType: itemTitleType, itemDescription: itemDescription, itemDescriptionReadOnly: itemDescriptionReadOnly, itemDescriptionType: itemDescriptionType, panelWidth: panelWidth, itemErrors: itemErrors, error: error, renderItem: renderItem, onChange: onChange })=>{
    const editMode = editModeProp || (initialCollapsed != null ? 'collapsible' : undefined) || (!itemTitle && !itemDescription ? 'compact' : undefined);
    const items = Array.isArray(value) ? value : [];
    const canDrag = reorderable && !disabled && !readonly;
    const isHorizontal = !!horizontal;
    // Stable IDs for sortable items — indices shift on reorder, so we need persistent IDs
    const counterRef = (0, $kYL7Z.useRef)(0);
    const idsRef = (0, $kYL7Z.useRef)([]);
    // Sync idsRef length with items, assigning new IDs for any new slots
    if (idsRef.current.length !== items.length) {
        const newIds = [];
        for(let i = 0; i < items.length; i++)newIds.push(idsRef.current[i] ?? `item-${counterRef.current++}`);
        idsRef.current = newIds;
    }
    const sensors = (0, $d59febdd5a89527d$export$19012f58216d597f)((0, $d59febdd5a89527d$export$cc72dd71f4ec69eb)((0, $d59febdd5a89527d$export$b28554b50bf7f273), $6594c3cd3a940aa3$var$SENSOR_OPTIONS), (0, $d59febdd5a89527d$export$cc72dd71f4ec69eb)((0, $d59febdd5a89527d$export$19b41baf2e1bcdc0), $6594c3cd3a940aa3$var$SENSOR_OPTIONS));
    // Collapse state lifted to survive canDrag branch changes (readonly toggle)
    const [collapsedMap, setCollapsedMap] = (0, $kYL7Z.useState)({});
    const isItemCollapsed = (id)=>id in collapsedMap ? collapsedMap[id] : !!initialCollapsed;
    const toggleItemCollapse = (0, $kYL7Z.useCallback)((id)=>{
        setCollapsedMap((prev)=>({
                ...prev,
                [id]: !(id in prev ? prev[id] : !!initialCollapsed)
            }));
    }, [
        initialCollapsed
    ]);
    const handleDragEnd = (0, $kYL7Z.useCallback)((event)=>{
        const { active: active, over: over } = event;
        if (!over || active.id === over.id) return;
        const oldIndex = idsRef.current.indexOf(active.id);
        const newIndex = idsRef.current.indexOf(over.id);
        if (oldIndex === -1 || newIndex === -1) return;
        idsRef.current = (0, $03fb2278f85c6d47$export$5d49d615ad5ea2b0)(idsRef.current, oldIndex, newIndex);
        const reordered = (0, $03fb2278f85c6d47$export$5d49d615ad5ea2b0)(items, oldIndex, newIndex);
        onChange(reordered);
    }, [
        items,
        onChange
    ]);
    const collectionCtx = (0, $kYL7Z.useContext)((0, $4a49823ead28a6dc$export$53146c55f8a78b));
    // Ref so the header's stale addTag closure always reads the latest value
    const valueRef = (0, $kYL7Z.useRef)(value);
    valueRef.current = value;
    const handleAdd = (0, $kYL7Z.useCallback)(()=>{
        const currentItems = Array.isArray(valueRef.current) ? valueRef.current : [];
        const defaults = {};
        if (itemSchema?.properties) {
            for (const [key, prop] of Object.entries(itemSchema.properties))if (prop.default !== undefined) defaults[key] = prop.default;
        }
        const newId = `item-${counterRef.current++}`;
        idsRef.current = [
            ...idsRef.current,
            newId
        ];
        if (editMode === 'collapsible') setCollapsedMap((prev)=>({
                ...prev,
                [newId]: false
            }));
        onChange([
            ...currentItems,
            defaults
        ]);
    }, [
        itemSchema,
        editMode,
        onChange
    ]);
    const handleRemove = (index)=>{
        idsRef.current = idsRef.current.filter((_, i)=>i !== index);
        const remaining = items.filter((_, i)=>i !== index);
        onChange(nullable && remaining.length === 0 ? null : remaining);
    };
    const handleItemChange = (index, newItem)=>{
        const updated = items.map((item, i)=>i === index ? newItem : item);
        onChange(updated);
    };
    const titleError = (index)=>{
        if (!itemTitle || !itemErrors) return undefined;
        const errs = itemErrors(index);
        return errs.find((e)=>e.instancePath === '/' + itemTitle);
    };
    const descriptionError = (index)=>{
        if (!itemDescription || !itemErrors) return undefined;
        const errs = itemErrors(index);
        return errs.find((e)=>e.instancePath === '/' + itemDescription);
    };
    const itemTitleText = (item, index)=>itemTitle && item?.[itemTitle] ? String(item[itemTitle]) : `Item ${index + 1}`;
    const renderItemCard = (item, index, dragListeners, isDragging)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$78d37f9aaa77d8), {
            editMode: editMode,
            readonly: readonly,
            collapsed: isItemCollapsed(idsRef.current[index]),
            onToggleCollapse: ()=>toggleItemCollapse(idsRef.current[index]),
            errors: itemErrors ? itemErrors(index) : [],
            panelWidth: panelWidth,
            dragListeners: dragListeners,
            description: itemDescription ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$1c673afd5aa0b669), {
                value: item[itemDescription],
                disabled: disabled || readonly || itemDescriptionReadOnly,
                error: descriptionError(index),
                type: itemDescriptionType,
                depth: depth,
                placeholder: `(Edit ${itemDescription})`,
                onChange: (newVal)=>handleItemChange(index, {
                        ...item,
                        [itemDescription]: newVal
                    })
            }) : undefined,
            depth: depth,
            titleText: itemTitleText(item, index),
            title: itemTitle ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$f9d7171ad5f156a8), {
                value: item[itemTitle],
                disabled: disabled || readonly || itemTitleReadOnly,
                error: titleError(index),
                type: itemTitleType,
                depth: depth,
                placeholder: `(Edit ${itemTitle})`,
                onChange: (newVal)=>handleItemChange(index, {
                        ...item,
                        [itemTitle]: newVal
                    })
            }) : editMode === 'drawer' || editMode === 'overlay' || editMode === 'popover' ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $cd7c29a731f3402d$export$cddb8b7ba9e8674e), {
                as: (0, $cd7c29a731f3402d$export$66422503964e48cd)(depth),
                children: [
                    "Item ",
                    index + 1
                ]
            }) : null,
            actions: !disabled && !readonly && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                content: `Remove ${itemTitleText(item, index)}`,
                placement: "top",
                hoverOpenDelay: 400,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$4e9d5ce1e6c22a94), {
                    icon: "cross",
                    minimal: true,
                    small: true,
                    onClick: ()=>handleRemove(index)
                })
            }),
            children: renderItem(item, index, (newItem)=>handleItemChange(index, newItem))
        });
    const canAdd = !disabled && !readonly && (!maxItems || items.length < maxItems);
    const addTag = canAdd ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        icon: "plus",
        round: true,
        minimal: true,
        interactive: true,
        intent: "primary",
        onClick: ()=>{
            collectionCtx?.expand();
            handleAdd();
        },
        children: "Add"
    }) : null;
    const countLabel = maxItems ? `${items.length}/${maxItems} items` : `${items.length} items`;
    const headerKey = `${!!error}|${items.length}|${disabled}|${readonly}|${maxItems}`;
    (0, $kYL7Z.useEffect)(()=>{
        if (collectionCtx) collectionCtx.setHeaderExtra(headerKey, /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
            children: [
                error && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($6594c3cd3a940aa3$var$ArrayError, {
                    children: error.message
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    round: true,
                    children: countLabel
                }),
                addTag
            ]
        }));
    }, [
        headerKey
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($6594c3cd3a940aa3$var$ArrayWrapper, {
        children: canDrag ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d59febdd5a89527d$export$2d5c5ceac203fc1e), {
            sensors: sensors,
            collisionDetection: (0, $d59febdd5a89527d$export$c8e785ae6b74bab8),
            modifiers: isHorizontal ? $6594c3cd3a940aa3$var$H_MODIFIERS : $6594c3cd3a940aa3$var$V_MODIFIERS,
            onDragEnd: handleDragEnd,
            children: isHorizontal ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($6594c3cd3a940aa3$var$HorizontalItems, {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $03fb2278f85c6d47$export$86155fde54f06e6a), {
                    items: idsRef.current,
                    strategy: (0, $03fb2278f85c6d47$export$7a687825fa98548a),
                    children: items.map((item, index)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($6594c3cd3a940aa3$var$SortableItem, {
                            id: idsRef.current[index],
                            horizontal: true,
                            children: (listeners, isDragging)=>renderItemCard(item, index, listeners, isDragging)
                        }, idsRef.current[index]))
                })
            }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $03fb2278f85c6d47$export$86155fde54f06e6a), {
                    items: idsRef.current,
                    strategy: (0, $03fb2278f85c6d47$export$fe2be640df2ffb9e),
                    children: items.map((item, index)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($6594c3cd3a940aa3$var$SortableItem, {
                            id: idsRef.current[index],
                            children: (listeners, isDragging)=>renderItemCard(item, index, listeners, isDragging)
                        }, idsRef.current[index]))
                })
            })
        }) : isHorizontal ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($6594c3cd3a940aa3$var$HorizontalItems, {
            children: items.map((item, index)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    children: renderItemCard(item, index, null)
                }, index))
        }) : items.map((item, index)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                children: renderItemCard(item, index, null)
            }, index))
    });
};




var $kYL7Z = parcelRequire("kYL7Z");



// --- Tree building from delimiter-separated flat strings ---
const $0007956562a61430$var$buildTree = (items, delimiter)=>{
    const nodeMap = new Map();
    const roots = [];
    const ensureNode = (value, segments)=>{
        if (nodeMap.has(value)) return nodeMap.get(value);
        const node = {
            value: value,
            label: segments[segments.length - 1],
            children: [],
            selectable: false
        };
        nodeMap.set(value, node);
        if (segments.length === 1) roots.push(node);
        else {
            const parentValue = segments.slice(0, -1).join(delimiter);
            const parent = ensureNode(parentValue, segments.slice(0, -1));
            parent.children.push(node);
        }
        return node;
    };
    const normalized = items.map((item)=>typeof item === 'string' ? {
            value: item,
            label: item
        } : item);
    for (const item of normalized){
        const segments = item.value.split(delimiter);
        const node = ensureNode(item.value, segments);
        node.selectable = true;
        if (item.label !== item.value) node.label = item.label;
    }
    return roots;
};
const $0007956562a61430$var$collectSelectableValues = (nodes)=>{
    const values = [];
    const walk = (ns)=>{
        for (const n of ns){
            if (n.selectable) values.push(n.value);
            if (n.children.length > 0) walk(n.children);
        }
    };
    walk(nodes);
    return values;
};
// --- Styled components ---
const $0007956562a61430$var$SelectButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    &[class*="bp"][class*="-button"] {
        border-radius: var(--sf-border-radius) !important;
        width: fit-content;
        justify-content: space-between;
        background: transparent !important;
        box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2) !important;
    }
`;
const $0007956562a61430$var$PanelContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
`;
const $0007956562a61430$var$Panel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    min-width: 150px;
    max-height: 320px;
    display: flex;
    flex-direction: column;

    &:not(:first-child) {
        border-left: 1px solid rgba(17, 20, 24, 0.15);
    }
`;
const $0007956562a61430$var$PanelHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 6px 10px;
    font-weight: 600;
    font-size: 11px;
    color: #5c7080;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(17, 20, 24, 0.15);
    white-space: nowrap;
`;
const $0007956562a61430$var$ActionBar = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 4px;
    padding: 4px 5px;
    border-bottom: 1px solid rgba(17, 20, 24, 0.15);
    & > * { flex: 1; }
`;
const $0007956562a61430$var$PanelBody = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    overflow-y: auto;
    flex: 1;
`;
const $0007956562a61430$var$ItemCheckbox = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d))`
    margin-bottom: 0;
    pointer-events: none;
`;
const $0007956562a61430$var$IndentedItem = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8))`
    &[class*="bp"][class*="-menu-item"] {
        padding-left: ${(p)=>7 + (p.$depth || 0) * 14}px !important;
    }
`;
const $0007956562a61430$var$GroupHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 6px 7px 2px ${(p)=>7 + (p.$depth || 0) * 14}px;
    font-weight: 600;
    font-size: 11px;
    color: #8a9ba8;
`;
// --- Recursive tree renderer ---
const $0007956562a61430$var$TreeNodes = ({ nodes: nodes, selected: selected, onItemClick: onItemClick, multi: multi, depth: depth })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: nodes.map((node)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, {
                children: [
                    node.selectable ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$IndentedItem, {
                        text: multi ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$ItemCheckbox, {
                            checked: selected.includes(node.value),
                            label: node.label
                        }) : node.label,
                        $depth: depth,
                        active: !multi && selected === node.value,
                        onClick: ()=>onItemClick(node.value),
                        shouldDismissPopover: false
                    }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$GroupHeader, {
                        $depth: depth,
                        children: node.label
                    }),
                    node.children.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$TreeNodes, {
                        nodes: node.children,
                        selected: selected,
                        onItemClick: onItemClick,
                        multi: multi,
                        depth: depth + 1
                    })
                ]
            }, node.value))
    });
// --- Flat item renderer ---
const $0007956562a61430$var$FlatItems = ({ items: items, selected: selected, onItemClick: onItemClick, multi: multi })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: items.map((item)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                text: multi ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$ItemCheckbox, {
                    checked: selected.includes(item.value),
                    label: item.label
                }) : item.label,
                active: !multi && selected === item.value,
                onClick: ()=>onItemClick(item.value),
                shouldDismissPopover: false
            }, item.value))
    });
// --- Helpers ---
const $0007956562a61430$var$normalizeItems = (items)=>items.map((item)=>typeof item === 'string' ? {
            value: item,
            label: item
        } : item);
/**
 * Resolve items for a level.
 *
 * Uses `activeMap` — a single "focused" value per ancestor level — to look up
 * `itemsFor` entries. When `dependsOn` is set, only that specific ancestor is
 * checked; otherwise ancestors are searched from immediate parent backwards.
 */ const $0007956562a61430$var$getLevelItems = (level, levelIndex, levels, activeMap)=>{
    if (level.items) return level.items;
    if (level.itemsFor) {
        if (level.dependsOn) {
            const val = activeMap[level.dependsOn];
            if (val && level.itemsFor[val]) return $0007956562a61430$var$normalizeItems(level.itemsFor[val]);
            return [];
        }
        for(let i = levelIndex - 1; i >= 0; i--){
            const val = activeMap[levels[i].key];
            if (val && level.itemsFor[val]) return $0007956562a61430$var$normalizeItems(level.itemsFor[val]);
        }
        return [];
    }
    return [];
};
const $0007956562a61430$var$getSingleDisplayText = (levels, value)=>{
    const parts = [];
    for (const level of levels){
        const val = value[level.key];
        if (val == null) break;
        if (level.items) {
            const item = level.items.find((i)=>i.value === val);
            parts.push(item?.label ?? val);
        } else if (level.delimiter) parts.push(...val.split(level.delimiter));
        else parts.push(val);
    }
    return parts.length > 0 ? parts.join(' \u203a ') : null;
};
const $0007956562a61430$var$getMultiDisplayText = (levels, value)=>{
    const parts = [];
    for (const level of levels){
        // Non-selectable levels store a string — show as prefix
        if (level.selectable === false) {
            const val = value[level.key];
            if (val) {
                const item = level.items?.find((i)=>i.value === val);
                parts.push(item?.label ?? val);
            }
            continue;
        }
        const selected = value[level.key] || [];
        if (selected.length === 0) continue;
        if (selected.length === 1) {
            const val = selected[0];
            if (level.items) {
                const item = level.items.find((i)=>i.value === val);
                parts.push(item?.label ?? val);
            } else if (level.delimiter) {
                const segments = val.split(level.delimiter);
                parts.push(segments[segments.length - 1]);
            } else parts.push(val);
        } else parts.push(`${selected.length} ${level.label}`);
    }
    return parts.length > 0 ? parts.join(' \u00b7 ') : null;
};
// --- Main component ---
const $0007956562a61430$export$78df0038885c98f9 = ({ label: label, value: value, disabled: disabled, error: error, levels: levels, multi: multi, onChange: onChange })=>{
    const currentValue = value || {};
    const intent = error ? 'danger' : 'none';
    // Internal "focused" item for multi-selectable levels — determines what
    // child panels show (separate from the checked values).
    const [focused, setFocused] = (0, $kYL7Z.useState)(()=>{
        const f = {};
        for (const level of levels)if (multi && level.selectable !== false) {
            const val = (value || {})[level.key];
            if (Array.isArray(val) && val.length > 0) f[level.key] = val[0];
        }
        return f;
    });
    // Active map: one focused value per level, used by getLevelItems.
    //   selectable:false  → value[key] (string stored in data)
    //   multi selectable  → focused[key] (internal state, last clicked)
    //   single selectable → value[key] (string stored in data)
    const activeMap = (0, $kYL7Z.useMemo)(()=>{
        const map = {};
        for (const level of levels){
            if (level.selectable === false) map[level.key] = currentValue[level.key];
            else if (multi) map[level.key] = focused[level.key];
            else map[level.key] = currentValue[level.key];
        }
        return map;
    }, [
        levels,
        currentValue,
        focused,
        multi
    ]);
    // Non-selectable: store string value (tab switch, no child clearing)
    const handleActivate = (0, $kYL7Z.useCallback)((levelKey, itemValue)=>{
        onChange({
            ...currentValue,
            [levelKey]: itemValue
        });
    }, [
        currentValue,
        onChange
    ]);
    // Single-select: replace value, clear children
    const handleSelect = (0, $kYL7Z.useCallback)((levelIndex, selectedValue)=>{
        const newValue = {};
        for(let i = 0; i < levels.length; i++){
            if (i < levelIndex) newValue[levels[i].key] = currentValue[levels[i].key];
            else if (i === levelIndex) newValue[levels[i].key] = selectedValue;
        }
        onChange(newValue);
    }, [
        levels,
        currentValue,
        onChange
    ]);
    // Multi-select: toggle item in/out of array + track focused
    const handleToggle = (0, $kYL7Z.useCallback)((levelKey, itemValue)=>{
        const current = currentValue[levelKey] || [];
        const updated = current.includes(itemValue) ? current.filter((v)=>v !== itemValue) : [
            ...current,
            itemValue
        ];
        onChange({
            ...currentValue,
            [levelKey]: updated
        });
        setFocused((prev)=>({
                ...prev,
                [levelKey]: itemValue
            }));
    }, [
        currentValue,
        onChange
    ]);
    const handleSelectAll = (0, $kYL7Z.useCallback)((levelKey, allValues)=>{
        onChange({
            ...currentValue,
            [levelKey]: allValues
        });
    }, [
        currentValue,
        onChange
    ]);
    const handleClear = (0, $kYL7Z.useCallback)((levelKey)=>{
        onChange({
            ...currentValue,
            [levelKey]: []
        });
    }, [
        currentValue,
        onChange
    ]);
    const displayText = (0, $kYL7Z.useMemo)(()=>multi ? $0007956562a61430$var$getMultiDisplayText(levels, currentValue) : $0007956562a61430$var$getSingleDisplayText(levels, currentValue), [
        levels,
        currentValue,
        multi
    ]);
    const panels = (0, $kYL7Z.useMemo)(()=>{
        return levels.map((level, i)=>{
            const items = $0007956562a61430$var$getLevelItems(level, i, levels, activeMap);
            if (items.length === 0 && i > 0) return null;
            const levelMulti = multi && level.selectable !== false;
            const tree = level.delimiter ? $0007956562a61430$var$buildTree(items, level.delimiter) : null;
            const selected = levelMulti ? currentValue[level.key] || [] : currentValue[level.key];
            const allValues = tree ? $0007956562a61430$var$collectSelectableValues(tree) : items.map((item)=>item.value);
            return {
                level: level,
                items: items,
                selected: selected,
                tree: tree,
                allValues: allValues,
                index: i,
                levelMulti: levelMulti
            };
        }).filter(Boolean);
    }, [
        levels,
        currentValue,
        activeMap,
        multi
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        helperText: error?.message,
        intent: intent,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            disabled: disabled,
            minimal: true,
            placement: "bottom-start",
            content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$PanelContainer, {
                children: panels.map(({ level: level, items: items, selected: selected, tree: tree, allValues: allValues, index: index, levelMulti: levelMulti })=>{
                    const onItemClick = levelMulti ? (val)=>handleToggle(level.key, val) : level.selectable === false ? (val)=>handleActivate(level.key, val) : (val)=>handleSelect(index, val);
                    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($0007956562a61430$var$Panel, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$PanelHeader, {
                                children: level.label
                            }),
                            levelMulti && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($0007956562a61430$var$ActionBar, {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                        small: true,
                                        outlined: true,
                                        text: "All",
                                        onClick: ()=>handleSelectAll(level.key, allValues)
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                        small: true,
                                        outlined: true,
                                        text: "Clear",
                                        onClick: ()=>handleClear(level.key)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$PanelBody, {
                                children: tree ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$TreeNodes, {
                                    nodes: tree,
                                    selected: selected,
                                    onItemClick: onItemClick,
                                    multi: levelMulti,
                                    depth: 0
                                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$FlatItems, {
                                    items: items,
                                    selected: selected,
                                    onItemClick: onItemClick,
                                    multi: levelMulti
                                })
                            })
                        ]
                    }, level.key);
                })
            }),
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0007956562a61430$var$SelectButton, {
                text: displayText || 'Select\u2026',
                rightIcon: "chevron-down",
                disabled: disabled
            })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");



function $e47888d12487ce32$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $e47888d12487ce32$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e47888d12487ce32$export$2e2bcd8739ae039(o);
}


function $f11f757927401511$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
}


function $aa14538e33156194$export$2e2bcd8739ae039(value) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || (0, $e47888d12487ce32$export$2e2bcd8739ae039)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}




function $c3d0f9877f46430d$export$2e2bcd8739ae039(argument) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $e47888d12487ce32$export$2e2bcd8739ae039)(argument) === 'object' && argStr === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || argStr === '[object Number]') return new Date(argument);
    else {
        if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $fd9aca475fd068a6$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $aa14538e33156194$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== 'number') return false;
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $67a1e72d685552e2$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $d070e8bf3706dc1d$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $40af3cc50c0a1704$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $d070e8bf3706dc1d$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $b08b8523dc55ecfa$var$MILLISECONDS_IN_DAY = 86400000;
function $b08b8523dc55ecfa$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $b08b8523dc55ecfa$var$MILLISECONDS_IN_DAY) + 1;
}





function $ddd2777e0c0574ba$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $7dc5ecc30ddcfe9b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $ddd2777e0c0574ba$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $ddd2777e0c0574ba$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $75c4f7d53fabb748$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $7dc5ecc30ddcfe9b$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $ddd2777e0c0574ba$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $0a530185a2c1d656$var$MILLISECONDS_IN_WEEK = 604800000;
function $0a530185a2c1d656$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $ddd2777e0c0574ba$export$2e2bcd8739ae039)(date).getTime() - (0, $75c4f7d53fabb748$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $0a530185a2c1d656$var$MILLISECONDS_IN_WEEK) + 1;
}







var $406c988538cdf14b$var$defaultOptions = {};
function $406c988538cdf14b$export$430a3269e24b912e() {
    return $406c988538cdf14b$var$defaultOptions;
}
function $406c988538cdf14b$export$95365be1b0704abc(newOptions) {
    $406c988538cdf14b$var$defaultOptions = newOptions;
}


function $8d486abfb72c5206$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $743e4ef5faf8e326$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $8d486abfb72c5206$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $8d486abfb72c5206$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $3d8e550dbd485af4$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $743e4ef5faf8e326$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $8d486abfb72c5206$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $04f89fbee0a7c75e$var$MILLISECONDS_IN_WEEK = 604800000;
function $04f89fbee0a7c75e$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $8d486abfb72c5206$export$2e2bcd8739ae039)(date, options).getTime() - (0, $3d8e550dbd485af4$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $04f89fbee0a7c75e$var$MILLISECONDS_IN_WEEK) + 1;
}



function $5d2a4c0e2c90b723$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $55536586c5cb0154$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(token === 'yy' ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === 'M' ? String(month + 1) : (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return dayPeriodEnumValue.toUpperCase();
            case 'aaa':
                return dayPeriodEnumValue;
            case 'aaaaa':
                return dayPeriodEnumValue[0];
            case 'aaaa':
            default:
                return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $55536586c5cb0154$export$2e2bcd8739ae039 = $55536586c5cb0154$var$formatters;


var $1fc17a286e10932b$var$dayPeriodEnum = {
    am: 'am',
    pm: 'pm',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $1fc17a286e10932b$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case 'G':
            case 'GG':
            case 'GGG':
                return localize.era(era, {
                    width: 'abbreviated'
                });
            // A, B
            case 'GGGGG':
                return localize.era(era, {
                    width: 'narrow'
                });
            // Anno Domini, Before Christ
            case 'GGGG':
            default:
                return localize.era(era, {
                    width: 'wide'
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === 'yo') {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: 'year'
            });
        }
        return (0, $55536586c5cb0154$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $743e4ef5faf8e326$export$2e2bcd8739ae039)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === 'YY') {
            var twoDigitYear = weekYear % 100;
            return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === 'Yo') return localize.ordinalNumber(weekYear, {
            unit: 'year'
        });
        // Padding
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $7dc5ecc30ddcfe9b$export$2e2bcd8739ae039)(date);
        // Padding
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'Q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'QQ':
                return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'Qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'QQQ':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'QQQQQ':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // 1st quarter, 2nd quarter, ...
            case 'QQQQ':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case 'q':
                return String(quarter);
            // 01, 02, 03, 04
            case 'qq':
                return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case 'qo':
                return localize.ordinalNumber(quarter, {
                    unit: 'quarter'
                });
            // Q1, Q2, Q3, Q4
            case 'qqq':
                return localize.quarter(quarter, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case 'qqqqq':
                return localize.quarter(quarter, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // 1st quarter, 2nd quarter, ...
            case 'qqqq':
            default:
                return localize.quarter(quarter, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case 'M':
            case 'MM':
                return (0, $55536586c5cb0154$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case 'Mo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'MMM':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // J, F, ..., D
            case 'MMMMM':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // January, February, ..., December
            case 'MMMM':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case 'L':
                return String(month + 1);
            // 01, 02, ..., 12
            case 'LL':
                return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case 'Lo':
                return localize.ordinalNumber(month + 1, {
                    unit: 'month'
                });
            // Jan, Feb, ..., Dec
            case 'LLL':
                return localize.month(month, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // J, F, ..., D
            case 'LLLLL':
                return localize.month(month, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // January, February, ..., December
            case 'LLLL':
            default:
                return localize.month(month, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $04f89fbee0a7c75e$export$2e2bcd8739ae039)(date, options);
        if (token === 'wo') return localize.ordinalNumber(week, {
            unit: 'week'
        });
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $0a530185a2c1d656$export$2e2bcd8739ae039)(date);
        if (token === 'Io') return localize.ordinalNumber(isoWeek, {
            unit: 'week'
        });
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === 'do') return localize.ordinalNumber(date.getUTCDate(), {
            unit: 'date'
        });
        return (0, $55536586c5cb0154$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $b08b8523dc55ecfa$export$2e2bcd8739ae039)(date);
        if (token === 'Do') return localize.ordinalNumber(dayOfYear, {
            unit: 'dayOfYear'
        });
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case 'E':
            case 'EE':
            case 'EEE':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'EEEEE':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'EEEEEE':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'EEEE':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case 'e':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'ee':
                return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case 'eo':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'eee':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'eeeee':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'eeeeee':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'eeee':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case 'c':
                return String(localDayOfWeek);
            // Padded numerical value
            case 'cc':
                return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case 'co':
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: 'day'
                });
            case 'ccc':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'standalone'
                });
            // T
            case 'ccccc':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'standalone'
                });
            // Tu
            case 'cccccc':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'standalone'
                });
            // Tuesday
            case 'cccc':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'standalone'
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case 'i':
                return String(isoDayOfWeek);
            // 02
            case 'ii':
                return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case 'io':
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: 'day'
                });
            // Tue
            case 'iii':
                return localize.day(dayOfWeek, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            // T
            case 'iiiii':
                return localize.day(dayOfWeek, {
                    width: 'narrow',
                    context: 'formatting'
                });
            // Tu
            case 'iiiiii':
                return localize.day(dayOfWeek, {
                    width: 'short',
                    context: 'formatting'
                });
            // Tuesday
            case 'iiii':
            default:
                return localize.day(dayOfWeek, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'a':
            case 'aa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'aaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'aaaaa':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'aaaa':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $1fc17a286e10932b$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $1fc17a286e10932b$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
        switch(token){
            case 'b':
            case 'bb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'bbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                }).toLowerCase();
            case 'bbbbb':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'bbbb':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $1fc17a286e10932b$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $1fc17a286e10932b$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $1fc17a286e10932b$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $1fc17a286e10932b$var$dayPeriodEnum.night;
        switch(token){
            case 'B':
            case 'BB':
            case 'BBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'abbreviated',
                    context: 'formatting'
                });
            case 'BBBBB':
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'narrow',
                    context: 'formatting'
                });
            case 'BBBB':
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: 'wide',
                    context: 'formatting'
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === 'ho') {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: 'hour'
            });
        }
        return (0, $55536586c5cb0154$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === 'Ho') return localize.ordinalNumber(date.getUTCHours(), {
            unit: 'hour'
        });
        return (0, $55536586c5cb0154$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === 'Ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === 'ko') return localize.ordinalNumber(hours, {
            unit: 'hour'
        });
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === 'mo') return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: 'minute'
        });
        return (0, $55536586c5cb0154$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === 'so') return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: 'second'
        });
        return (0, $55536586c5cb0154$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $55536586c5cb0154$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $1fc17a286e10932b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                // Hours and minutes without `:` delimiter
                return $1fc17a286e10932b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $1fc17a286e10932b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $1fc17a286e10932b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                // Hours and minutes without `:` delimiter
                return $1fc17a286e10932b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $1fc17a286e10932b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $1fc17a286e10932b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $1fc17a286e10932b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return 'GMT' + $1fc17a286e10932b$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'zzzz':
            default:
                return 'GMT' + $1fc17a286e10932b$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $1fc17a286e10932b$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(minutes, 2);
}
function $1fc17a286e10932b$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $1fc17a286e10932b$var$formatTimezone(offset, dirtyDelimiter);
}
function $1fc17a286e10932b$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $5d2a4c0e2c90b723$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $1fc17a286e10932b$export$2e2bcd8739ae039 = $1fc17a286e10932b$var$formatters;


var $950cbc186b4ec631$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'P':
            return formatLong.date({
                width: 'short'
            });
        case 'PP':
            return formatLong.date({
                width: 'medium'
            });
        case 'PPP':
            return formatLong.date({
                width: 'long'
            });
        case 'PPPP':
        default:
            return formatLong.date({
                width: 'full'
            });
    }
};
var $950cbc186b4ec631$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case 'p':
            return formatLong.time({
                width: 'short'
            });
        case 'pp':
            return formatLong.time({
                width: 'medium'
            });
        case 'ppp':
            return formatLong.time({
                width: 'long'
            });
        case 'pppp':
        default:
            return formatLong.time({
                width: 'full'
            });
    }
};
var $950cbc186b4ec631$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $950cbc186b4ec631$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case 'P':
            dateTimeFormat = formatLong.dateTime({
                width: 'short'
            });
            break;
        case 'PP':
            dateTimeFormat = formatLong.dateTime({
                width: 'medium'
            });
            break;
        case 'PPP':
            dateTimeFormat = formatLong.dateTime({
                width: 'long'
            });
            break;
        case 'PPPP':
        default:
            dateTimeFormat = formatLong.dateTime({
                width: 'full'
            });
            break;
    }
    return dateTimeFormat.replace('{{date}}', $950cbc186b4ec631$var$dateLongFormatter(datePattern, formatLong)).replace('{{time}}', $950cbc186b4ec631$var$timeLongFormatter(timePattern, formatLong));
};
var $950cbc186b4ec631$var$longFormatters = {
    p: $950cbc186b4ec631$var$timeLongFormatter,
    P: $950cbc186b4ec631$var$dateTimeLongFormatter
};
var $950cbc186b4ec631$export$2e2bcd8739ae039 = $950cbc186b4ec631$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $a3139271043a0e39$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $d463ee5f31bd0520$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $d463ee5f31bd0520$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $d463ee5f31bd0520$export$c6cc36aa33304772(token) {
    return $d463ee5f31bd0520$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $d463ee5f31bd0520$export$c6b49d6dceb604a1(token) {
    return $d463ee5f31bd0520$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $d463ee5f31bd0520$export$8073c1ae88f0e727(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $d25d639a82b19f61$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: 'less than a second',
        other: 'less than {{count}} seconds'
    },
    xSeconds: {
        one: '1 second',
        other: '{{count}} seconds'
    },
    halfAMinute: 'half a minute',
    lessThanXMinutes: {
        one: 'less than a minute',
        other: 'less than {{count}} minutes'
    },
    xMinutes: {
        one: '1 minute',
        other: '{{count}} minutes'
    },
    aboutXHours: {
        one: 'about 1 hour',
        other: 'about {{count}} hours'
    },
    xHours: {
        one: '1 hour',
        other: '{{count}} hours'
    },
    xDays: {
        one: '1 day',
        other: '{{count}} days'
    },
    aboutXWeeks: {
        one: 'about 1 week',
        other: 'about {{count}} weeks'
    },
    xWeeks: {
        one: '1 week',
        other: '{{count}} weeks'
    },
    aboutXMonths: {
        one: 'about 1 month',
        other: 'about {{count}} months'
    },
    xMonths: {
        one: '1 month',
        other: '{{count}} months'
    },
    aboutXYears: {
        one: 'about 1 year',
        other: 'about {{count}} years'
    },
    xYears: {
        one: '1 year',
        other: '{{count}} years'
    },
    overXYears: {
        one: 'over 1 year',
        other: 'over {{count}} years'
    },
    almostXYears: {
        one: 'almost 1 year',
        other: 'almost {{count}} years'
    }
};
var $d25d639a82b19f61$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d25d639a82b19f61$var$formatDistanceLocale[token];
    if (typeof tokenValue === 'string') result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace('{{count}}', count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return 'in ' + result;
        else return result + ' ago';
    }
    return result;
};
var $d25d639a82b19f61$export$2e2bcd8739ae039 = $d25d639a82b19f61$var$formatDistance;


function $0af2dee6bd4e1ff1$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $508fc0a54eba57fe$var$dateFormats = {
    full: 'EEEE, MMMM do, y',
    long: 'MMMM do, y',
    medium: 'MMM d, y',
    short: 'MM/dd/yyyy'
};
var $508fc0a54eba57fe$var$timeFormats = {
    full: 'h:mm:ss a zzzz',
    long: 'h:mm:ss a z',
    medium: 'h:mm:ss a',
    short: 'h:mm a'
};
var $508fc0a54eba57fe$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: '{{date}}, {{time}}',
    short: '{{date}}, {{time}}'
};
var $508fc0a54eba57fe$var$formatLong = {
    date: (0, $0af2dee6bd4e1ff1$export$2e2bcd8739ae039)({
        formats: $508fc0a54eba57fe$var$dateFormats,
        defaultWidth: 'full'
    }),
    time: (0, $0af2dee6bd4e1ff1$export$2e2bcd8739ae039)({
        formats: $508fc0a54eba57fe$var$timeFormats,
        defaultWidth: 'full'
    }),
    dateTime: (0, $0af2dee6bd4e1ff1$export$2e2bcd8739ae039)({
        formats: $508fc0a54eba57fe$var$dateTimeFormats,
        defaultWidth: 'full'
    })
};
var $508fc0a54eba57fe$export$2e2bcd8739ae039 = $508fc0a54eba57fe$var$formatLong;


var $c44af7bacf59530e$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: 'P'
};
var $c44af7bacf59530e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c44af7bacf59530e$var$formatRelativeLocale[token];
};
var $c44af7bacf59530e$export$2e2bcd8739ae039 = $c44af7bacf59530e$var$formatRelative;


function $b517b174b5742a05$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
        var valuesArray;
        if (context === 'formatting' && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $b4d8e849d92fa63a$var$eraValues = {
    narrow: [
        'B',
        'A'
    ],
    abbreviated: [
        'BC',
        'AD'
    ],
    wide: [
        'Before Christ',
        'Anno Domini'
    ]
};
var $b4d8e849d92fa63a$var$quarterValues = {
    narrow: [
        '1',
        '2',
        '3',
        '4'
    ],
    abbreviated: [
        'Q1',
        'Q2',
        'Q3',
        'Q4'
    ],
    wide: [
        '1st quarter',
        '2nd quarter',
        '3rd quarter',
        '4th quarter'
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $b4d8e849d92fa63a$var$monthValues = {
    narrow: [
        'J',
        'F',
        'M',
        'A',
        'M',
        'J',
        'J',
        'A',
        'S',
        'O',
        'N',
        'D'
    ],
    abbreviated: [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ],
    wide: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December'
    ]
};
var $b4d8e849d92fa63a$var$dayValues = {
    narrow: [
        'S',
        'M',
        'T',
        'W',
        'T',
        'F',
        'S'
    ],
    short: [
        'Su',
        'Mo',
        'Tu',
        'We',
        'Th',
        'Fr',
        'Sa'
    ],
    abbreviated: [
        'Sun',
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat'
    ],
    wide: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ]
};
var $b4d8e849d92fa63a$var$dayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'morning',
        afternoon: 'afternoon',
        evening: 'evening',
        night: 'night'
    }
};
var $b4d8e849d92fa63a$var$formattingDayPeriodValues = {
    narrow: {
        am: 'a',
        pm: 'p',
        midnight: 'mi',
        noon: 'n',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    abbreviated: {
        am: 'AM',
        pm: 'PM',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    },
    wide: {
        am: 'a.m.',
        pm: 'p.m.',
        midnight: 'midnight',
        noon: 'noon',
        morning: 'in the morning',
        afternoon: 'in the afternoon',
        evening: 'in the evening',
        night: 'at night'
    }
};
var $b4d8e849d92fa63a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + 'st';
        case 2:
            return number + 'nd';
        case 3:
            return number + 'rd';
    }
    return number + 'th';
};
var $b4d8e849d92fa63a$var$localize = {
    ordinalNumber: $b4d8e849d92fa63a$var$ordinalNumber,
    era: (0, $b517b174b5742a05$export$2e2bcd8739ae039)({
        values: $b4d8e849d92fa63a$var$eraValues,
        defaultWidth: 'wide'
    }),
    quarter: (0, $b517b174b5742a05$export$2e2bcd8739ae039)({
        values: $b4d8e849d92fa63a$var$quarterValues,
        defaultWidth: 'wide',
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $b517b174b5742a05$export$2e2bcd8739ae039)({
        values: $b4d8e849d92fa63a$var$monthValues,
        defaultWidth: 'wide'
    }),
    day: (0, $b517b174b5742a05$export$2e2bcd8739ae039)({
        values: $b4d8e849d92fa63a$var$dayValues,
        defaultWidth: 'wide'
    }),
    dayPeriod: (0, $b517b174b5742a05$export$2e2bcd8739ae039)({
        values: $b4d8e849d92fa63a$var$dayPeriodValues,
        defaultWidth: 'wide',
        formattingValues: $b4d8e849d92fa63a$var$formattingDayPeriodValues,
        defaultFormattingWidth: 'wide'
    })
};
var $b4d8e849d92fa63a$export$2e2bcd8739ae039 = $b4d8e849d92fa63a$var$localize;


function $707b6275cc8fd1f3$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $707b6275cc8fd1f3$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $707b6275cc8fd1f3$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $707b6275cc8fd1f3$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $707b6275cc8fd1f3$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $9a125b1eff948de0$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $b226adcde903b6bb$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $b226adcde903b6bb$var$parseOrdinalNumberPattern = /\d+/i;
var $b226adcde903b6bb$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $b226adcde903b6bb$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $b226adcde903b6bb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $b226adcde903b6bb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b226adcde903b6bb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $b226adcde903b6bb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $b226adcde903b6bb$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $b226adcde903b6bb$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $b226adcde903b6bb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $b226adcde903b6bb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $b226adcde903b6bb$var$match = {
    ordinalNumber: (0, $9a125b1eff948de0$export$2e2bcd8739ae039)({
        matchPattern: $b226adcde903b6bb$var$matchOrdinalNumberPattern,
        parsePattern: $b226adcde903b6bb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $707b6275cc8fd1f3$export$2e2bcd8739ae039)({
        matchPatterns: $b226adcde903b6bb$var$matchEraPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b226adcde903b6bb$var$parseEraPatterns,
        defaultParseWidth: 'any'
    }),
    quarter: (0, $707b6275cc8fd1f3$export$2e2bcd8739ae039)({
        matchPatterns: $b226adcde903b6bb$var$matchQuarterPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b226adcde903b6bb$var$parseQuarterPatterns,
        defaultParseWidth: 'any',
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $707b6275cc8fd1f3$export$2e2bcd8739ae039)({
        matchPatterns: $b226adcde903b6bb$var$matchMonthPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b226adcde903b6bb$var$parseMonthPatterns,
        defaultParseWidth: 'any'
    }),
    day: (0, $707b6275cc8fd1f3$export$2e2bcd8739ae039)({
        matchPatterns: $b226adcde903b6bb$var$matchDayPatterns,
        defaultMatchWidth: 'wide',
        parsePatterns: $b226adcde903b6bb$var$parseDayPatterns,
        defaultParseWidth: 'any'
    }),
    dayPeriod: (0, $707b6275cc8fd1f3$export$2e2bcd8739ae039)({
        matchPatterns: $b226adcde903b6bb$var$matchDayPeriodPatterns,
        defaultMatchWidth: 'any',
        parsePatterns: $b226adcde903b6bb$var$parseDayPeriodPatterns,
        defaultParseWidth: 'any'
    })
};
var $b226adcde903b6bb$export$2e2bcd8739ae039 = $b226adcde903b6bb$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $2f071ab2ce9db9ac$var$locale = {
    code: 'en-US',
    formatDistance: (0, $d25d639a82b19f61$export$2e2bcd8739ae039),
    formatLong: (0, $508fc0a54eba57fe$export$2e2bcd8739ae039),
    formatRelative: (0, $c44af7bacf59530e$export$2e2bcd8739ae039),
    localize: (0, $b4d8e849d92fa63a$export$2e2bcd8739ae039),
    match: (0, $b226adcde903b6bb$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2f071ab2ce9db9ac$export$2e2bcd8739ae039 = $2f071ab2ce9db9ac$var$locale;


var $aea6f79126d3f9ef$export$2e2bcd8739ae039 = (0, $2f071ab2ce9db9ac$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $2b4e856eb74a628a$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $2b4e856eb74a628a$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $2b4e856eb74a628a$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $2b4e856eb74a628a$var$doubleQuoteRegExp = /''/g;
var $2b4e856eb74a628a$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $2b4e856eb74a628a$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $aea6f79126d3f9ef$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $fd9aca475fd068a6$export$2e2bcd8739ae039)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $a3139271043a0e39$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $40af3cc50c0a1704$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($2b4e856eb74a628a$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = (0, $950cbc186b4ec631$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($2b4e856eb74a628a$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $2b4e856eb74a628a$var$cleanEscapedString(substring);
        var formatter = (0, $1fc17a286e10932b$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $d463ee5f31bd0520$export$c6b49d6dceb604a1)(substring)) (0, $d463ee5f31bd0520$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $d463ee5f31bd0520$export$c6cc36aa33304772)(substring)) (0, $d463ee5f31bd0520$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($2b4e856eb74a628a$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $2b4e856eb74a628a$var$cleanEscapedString(input) {
    var matched = input.match($2b4e856eb74a628a$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($2b4e856eb74a628a$var$doubleQuoteRegExp, "'");
}




var $kYL7Z = parcelRequire("kYL7Z");



function $62f69bb5773628be$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}




function $999339d7b1b67955$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var amount = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}




function $e9019aa720e4f7d1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyAmount);
    var days = amount * 7;
    return (0, $62f69bb5773628be$export$2e2bcd8739ae039)(dirtyDate, days);
}




function $46d461f3e28778dc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $999339d7b1b67955$export$2e2bcd8739ae039)(dirtyDate, amount * 12);
}




function $850a51168f487f37$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}



var $fa87d08b2e22bee7$var$MILLISECONDS_IN_DAY = 86400000;
function $fa87d08b2e22bee7$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var startOfDayLeft = (0, $850a51168f487f37$export$2e2bcd8739ae039)(dirtyDateLeft);
    var startOfDayRight = (0, $850a51168f487f37$export$2e2bcd8739ae039)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $a3139271043a0e39$export$2e2bcd8739ae039)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $a3139271043a0e39$export$2e2bcd8739ae039)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $fa87d08b2e22bee7$var$MILLISECONDS_IN_DAY);
}



function $7aa8daa05d53dbe4$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}





function $55faaefb20f1e937$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}



function $5228779d4f207934$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    return (0, $55faaefb20f1e937$export$2e2bcd8739ae039)(dirtyDate, {
        weekStartsOn: 1
    });
}



function $2047aa644d00beb8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}






function $30d2199abd040b9c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $f61d1f0ea5c727e5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    return (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(dirtyDate, {
        weekStartsOn: 1
    });
}





function $3b1b2c0feeaa3242$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $f61d1f0ea5c727e5$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $f61d1f0ea5c727e5$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $a686ab491b8e50af$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $3b1b2c0feeaa3242$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $f61d1f0ea5c727e5$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $ecdf5fd614e02e51$var$MILLISECONDS_IN_WEEK = 604800000;
function $ecdf5fd614e02e51$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $f61d1f0ea5c727e5$export$2e2bcd8739ae039)(date).getTime() - (0, $a686ab491b8e50af$export$2e2bcd8739ae039)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $ecdf5fd614e02e51$var$MILLISECONDS_IN_WEEK) + 1;
}



function $05f2725ceef790f2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}



function $db1f45d5f05fb8be$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    return Math.floor((0, $05f2725ceef790f2$export$2e2bcd8739ae039)(dirtyDate) / 1000);
}







function $2636dd837239a55e$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $d94d8b50a9363902$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $2636dd837239a55e$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    var date = (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}




var $34cd1079e5a47c05$var$MILLISECONDS_IN_WEEK = 604800000;
function $34cd1079e5a47c05$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(date, options).getTime() - (0, $d94d8b50a9363902$export$2e2bcd8739ae039)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $34cd1079e5a47c05$var$MILLISECONDS_IN_WEEK) + 1;
}




var $d39858047423db53$var$MILLISECONDS_IN_WEEK = 604800000;
function $d39858047423db53$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var startOfWeekLeft = (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $a3139271043a0e39$export$2e2bcd8739ae039)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $a3139271043a0e39$export$2e2bcd8739ae039)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $d39858047423db53$var$MILLISECONDS_IN_WEEK);
}




function $afa52b5589705347$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $31a0c8cc128a7cb2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}



function $aa7ec655448e331b$export$2e2bcd8739ae039(date, options) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    return (0, $d39858047423db53$export$2e2bcd8739ae039)((0, $afa52b5589705347$export$2e2bcd8739ae039)(date), (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(date), options) + 1;
}



function $3e00ad5e5752a430$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}



function $225ed1a47de95b15$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var dateToCompare = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}



function $01773c7f1dffd541$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var dateLeftStartOfDay = (0, $850a51168f487f37$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $850a51168f487f37$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}



function $748eba9a3bddca65$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}



function $6783555427d03e58$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var dateLeft = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateLeft);
    var dateRight = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}




function $cd00da459e6be22d$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, $e47888d12487ce32$export$2e2bcd8739ae039)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}




function $ccfd360e901c31d4$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') datesArray = dirtyDatesArray;
    else if ((0, $e47888d12487ce32$export$2e2bcd8739ae039)(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}


function $739d983d451ffdae$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $3b15ab4ed2361369$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $739d983d451ffdae$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $739d983d451ffdae$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $e54577a6a05a54f0$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $3b15ab4ed2361369$export$2e2bcd8739ae039)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}





function $2e951ae9a7338043$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError('assign requires that input parameter not be null or undefined');
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}









function $12e99504107770ec$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $4df27d4f64ae9d51$export$2e2bcd8739ae039)(t, e);
}


function $88338f8dce51697e$export$2e2bcd8739ae039(t) {
    return $88338f8dce51697e$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $88338f8dce51697e$export$2e2bcd8739ae039(t);
}


function $44243eb17a93533b$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($44243eb17a93533b$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}




function $5d1b9494a39362e7$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $e47888d12487ce32$export$2e2bcd8739ae039)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(t);
}


function $1ee6d8febd3e3e88$export$2e2bcd8739ae039(t) {
    var r = (0, $44243eb17a93533b$export$2e2bcd8739ae039)();
    return function() {
        var e, o = (0, $88338f8dce51697e$export$2e2bcd8739ae039)(t);
        if (r) {
            var s = (0, $88338f8dce51697e$export$2e2bcd8739ae039)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $5d1b9494a39362e7$export$2e2bcd8739ae039)(this, e);
    };
}


function $5cdf3f8435021086$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}




function $c76dfc5fc05e7d56$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $e47888d12487ce32$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $e47888d12487ce32$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $a082aa2878250d73$export$2e2bcd8739ae039(t) {
    var i = (0, $c76dfc5fc05e7d56$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $e47888d12487ce32$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f69f78b7edbce0d0$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $a082aa2878250d73$export$2e2bcd8739ae039)(o.key), o);
    }
}
function $f69f78b7edbce0d0$export$2e2bcd8739ae039(e, r, t) {
    return r && $f69f78b7edbce0d0$var$_defineProperties(e.prototype, r), t && $f69f78b7edbce0d0$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}



function $0295d13f8c0ec08d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $a082aa2878250d73$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


var $b76a40e3f9f8a11c$var$TIMEZONE_UNIT_PRIORITY = 10;
var $b76a40e3f9f8a11c$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, Setter);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)(this, "subPriority", 0);
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $b76a40e3f9f8a11c$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(ValueSetter, _Setter);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($b76a40e3f9f8a11c$export$81d53e3678089a6);
var $b76a40e3f9f8a11c$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this2), "priority", $b76a40e3f9f8a11c$var$TIMEZONE_UNIT_PRIORITY);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($b76a40e3f9f8a11c$export$81d53e3678089a6);












var $93ed575bcddca6a8$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, Parser);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)(this, "incompatibleTokens", void 0);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)(this, "priority", void 0);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)(this, "subPriority", void 0);
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $b76a40e3f9f8a11c$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();


var $001c24a37817615d$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(EraParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(EraParser);
    function EraParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 140);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'R',
            'u',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case 'G':
                    case 'GG':
                    case 'GGG':
                        return match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                    // A, B
                    case 'GGGGG':
                        return match.era(dateString, {
                            width: 'narrow'
                        });
                    // Anno Domini, Before Christ
                    case 'GGGG':
                    default:
                        return match.era(dateString, {
                            width: 'wide'
                        }) || match.era(dateString, {
                            width: 'abbreviated'
                        }) || match.era(dateString, {
                            width: 'narrow'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));









/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $995b5f114a9c3c13$export$dfd9b671c89acc8e = 7;
var $995b5f114a9c3c13$export$3913210603d8e9ae = 365.2425;
var $995b5f114a9c3c13$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $995b5f114a9c3c13$export$91246f0b9bd9beff = 60000;
var $995b5f114a9c3c13$export$7f72910d6dfd237a = 3600000;
var $995b5f114a9c3c13$export$397c2d5776aa9055 = 1000;
var $995b5f114a9c3c13$export$4dec998e48f9c246 = -$995b5f114a9c3c13$export$81caae6e1cc7a622;
var $995b5f114a9c3c13$export$f2f5ae5a8e2d8f9f = 60;
var $995b5f114a9c3c13$export$3c58128db900d44e = 3;
var $995b5f114a9c3c13$export$80d7e435f744f319 = 12;
var $995b5f114a9c3c13$export$4db7641526e3241f = 4;
var $995b5f114a9c3c13$export$698aec755e92c695 = 3600;
var $995b5f114a9c3c13$export$a77c1a7ebebe2a5a = 60;
var $995b5f114a9c3c13$export$815a9362476d2fe3 = $995b5f114a9c3c13$export$698aec755e92c695 * 24;
var $995b5f114a9c3c13$export$34804a017b31e2fe = $995b5f114a9c3c13$export$815a9362476d2fe3 * 7;
var $995b5f114a9c3c13$export$7271e9e3478110d1 = $995b5f114a9c3c13$export$815a9362476d2fe3 * $995b5f114a9c3c13$export$3913210603d8e9ae;
var $995b5f114a9c3c13$export$8e6600bbdee7dabb = $995b5f114a9c3c13$export$7271e9e3478110d1 / 12;
var $995b5f114a9c3c13$export$be1dccf2de902d31 = $995b5f114a9c3c13$export$8e6600bbdee7dabb * 3;


var $45b708cc5fd69e33$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $45b708cc5fd69e33$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $41158e0b84942e97$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $41158e0b84942e97$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $41158e0b84942e97$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === 'Z') return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === '+' ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $995b5f114a9c3c13$export$7f72910d6dfd237a) + minutes * (0, $995b5f114a9c3c13$export$91246f0b9bd9beff) + seconds * (0, $995b5f114a9c3c13$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $41158e0b84942e97$export$d931c43c4608a164(dateString) {
    return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $41158e0b84942e97$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388(new RegExp('^\\d{1,' + n + '}'), dateString);
    }
}
function $41158e0b84942e97$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388((0, $45b708cc5fd69e33$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $41158e0b84942e97$export$cc7cc9e2a3ff9388(new RegExp('^-?\\d{1,' + n + '}'), dateString);
    }
}
function $41158e0b84942e97$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case 'morning':
            return 4;
        case 'evening':
            return 17;
        case 'pm':
        case 'noon':
        case 'afternoon':
            return 12;
        case 'am':
        case 'midnight':
        case 'night':
        default:
            return 0;
    }
}
function $41158e0b84942e97$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $41158e0b84942e97$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


var $3d115760ee2b43fa$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(YearParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(YearParser);
    function YearParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'u',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'yy'
                    };
                };
                switch(token){
                    case 'y':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'yo':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $41158e0b84942e97$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));












var $26c6038d4847f7ed$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(LocalWeekYearParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === 'YY'
                    };
                };
                switch(token){
                    case 'Y':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(4, dateString), valueCallback);
                    case 'Yo':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'year'
                        }), valueCallback);
                    default:
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $743e4ef5faf8e326$export$2e2bcd8739ae039)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $41158e0b84942e97$export$29126f735cbf69f7)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $8d486abfb72c5206$export$2e2bcd8739ae039)(date, options);
                }
                var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $8d486abfb72c5206$export$2e2bcd8739ae039)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $02b0eca39baeb4dd$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(ISOWeekYearParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'u',
            'Q',
            'q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'R') return (0, $41158e0b84942e97$export$2c9307b2e29c533c)(4, dateString);
                return (0, $41158e0b84942e97$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $ddd2777e0c0574ba$export$2e2bcd8739ae039)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $e5496b646f06971f$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(ExtendedYearParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 130);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'G',
            'y',
            'Y',
            'R',
            'w',
            'I',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === 'u') return (0, $41158e0b84942e97$export$2c9307b2e29c533c)(4, dateString);
                return (0, $41158e0b84942e97$export$2c9307b2e29c533c)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $a1cb8139a29acb44$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(QuarterParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'Q':
                    case 'QQ':
                        // 01, 02, 03, 04
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'Qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'QQQ':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'QQQQQ':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'QQQQ':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $c2a918c6039d723c$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(StandAloneQuarterParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 120);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case 'q':
                    case 'qq':
                        // 01, 02, 03, 04
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case 'qo':
                        return match.ordinalNumber(dateString, {
                            unit: 'quarter'
                        });
                    // Q1, Q2, Q3, Q4
                    case 'qqq':
                        return match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case 'qqqqq':
                        return match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // 1st quarter, 2nd quarter, ...
                    case 'qqqq':
                    default:
                        return match.quarter(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.quarter(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $ecc9e5acee51afa6$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(MonthParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'L',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 110);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'M':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'MM':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Mo':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'MMM':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // J, F, ..., D
                    case 'MMMMM':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // January, February, ..., December
                    case 'MMMM':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $b58ab579a88939b0$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(StandAloneMonthParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 110);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case 'L':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case 'LL':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case 'Lo':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'month'
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case 'LLL':
                        return match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // J, F, ..., D
                    case 'LLLLL':
                        return match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // January, February, ..., December
                    case 'LLLL':
                    default:
                        return match.month(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.month(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));















function $2b971f4f532a867f$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var week = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyWeek);
    var diff = (0, $04f89fbee0a7c75e$export$2e2bcd8739ae039)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $1b1a74e2e424f296$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(LocalWeekParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'i',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'w':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).week, dateString);
                    case 'wo':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $8d486abfb72c5206$export$2e2bcd8739ae039)((0, $2b971f4f532a867f$export$2e2bcd8739ae039)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));















function $f5451465cd5c309c$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var isoWeek = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyISOWeek);
    var diff = (0, $0a530185a2c1d656$export$2e2bcd8739ae039)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}



var $8ac9dddda3fa0d50$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(ISOWeekParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 100);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'I':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).week, dateString);
                    case 'Io':
                        return match.ordinalNumber(dateString, {
                            unit: 'week'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $ddd2777e0c0574ba$export$2e2bcd8739ae039)((0, $f5451465cd5c309c$export$2e2bcd8739ae039)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $1e97e8961feeaae3$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1e97e8961feeaae3$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $1e97e8961feeaae3$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(DateParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(DateParser);
    function DateParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "subPriority", 1);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'w',
            'I',
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'd':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).date, dateString);
                    case 'do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $41158e0b84942e97$export$3d50627710b84d75)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $1e97e8961feeaae3$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $1e97e8961feeaae3$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $03def569ff6fccb1$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(DayOfYearParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "subpriority", 1);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'Y',
            'R',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'I',
            'd',
            'E',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'D':
                    case 'DD':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).dayOfYear, dateString);
                    case 'Do':
                        return match.ordinalNumber(dateString, {
                            unit: 'date'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $41158e0b84942e97$export$3d50627710b84d75)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));













function $99343cb254334292$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var weekStartsOn = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var day = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $7c40909befcfa76f$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(DayParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(DayParser);
    function DayParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'D',
            'i',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case 'E':
                    case 'EE':
                    case 'EEE':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'EEEEE':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'EEEEEE':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'EEEE':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $99343cb254334292$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $084d0714b68edc69$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(LocalDayParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'e':
                    case 'ee':
                        // 03
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'eo':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'eee':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // T
                    case 'eeeee':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tu
                    case 'eeeeee':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    // Tuesday
                    case 'eeee':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $99343cb254334292$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $96ad35d635a3ce5c$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'R',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'I',
            'd',
            'D',
            'E',
            'i',
            'e',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case 'c':
                    case 'cc':
                        // 03
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString), valueCallback);
                    // 3rd
                    case 'co':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                            unit: 'day'
                        }), valueCallback);
                    // Tue
                    case 'ccc':
                        return match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // T
                    case 'ccccc':
                        return match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tu
                    case 'cccccc':
                        return match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                    // Tuesday
                    case 'cccc':
                    default:
                        return match.day(dateString, {
                            width: 'wide',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'standalone'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'standalone'
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $99343cb254334292$export$2e2bcd8739ae039)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));













function $b964d04a1446dd0d$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var day = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}


var $36baeeb7e1e24f5e$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(ISODayParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 90);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'y',
            'Y',
            'u',
            'q',
            'Q',
            'M',
            'L',
            'w',
            'd',
            'D',
            'E',
            'e',
            'c',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case 'i':
                    case 'ii':
                        // 02
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                    // 2nd
                    case 'io':
                        return match.ordinalNumber(dateString, {
                            unit: 'day'
                        });
                    // Tue
                    case 'iii':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // T
                    case 'iiiii':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tu
                    case 'iiiiii':
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                    // Tuesday
                    case 'iiii':
                    default:
                        return (0, $41158e0b84942e97$export$4f84e3a82c7b538)(match.day(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'short',
                            context: 'formatting'
                        }) || match.day(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $b964d04a1446dd0d$export$2e2bcd8739ae039)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $7173946a47978ef8$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(AMPMParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'b',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'a':
                    case 'aa':
                    case 'aaa':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaaa':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'aaaa':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $41158e0b84942e97$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $67c54572946689c2$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(AMPMMidnightParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'B',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'b':
                    case 'bb':
                    case 'bbb':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbbb':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'bbbb':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $41158e0b84942e97$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $da7a1bcf7e4594cf$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(DayPeriodParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 80);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'B':
                    case 'BB':
                    case 'BBB':
                        return match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBBB':
                        return match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                    case 'BBBB':
                    default:
                        return match.dayPeriod(dateString, {
                            width: 'wide',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'abbreviated',
                            context: 'formatting'
                        }) || match.dayPeriod(dateString, {
                            width: 'narrow',
                            context: 'formatting'
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $41158e0b84942e97$export$fb506d2676e7f207)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $44ab085b3f7999e6$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(Hour1to12Parser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'H',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'h':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).hour12h, dateString);
                    case 'ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $2c0464bb55dd06e8$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(Hour0to23Parser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'K',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'H':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).hour23h, dateString);
                    case 'Ho':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $3b9b579c2fec2581$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(Hour0To11Parser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'h',
            'H',
            'k',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'K':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).hour11h, dateString);
                    case 'Ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $49daa262a4ef7751$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(Hour1To24Parser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 70);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            'a',
            'b',
            'h',
            'H',
            'K',
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'k':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).hour24h, dateString);
                    case 'ko':
                        return match.ordinalNumber(dateString, {
                            unit: 'hour'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $1155e57f9bee7c48$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(MinuteParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 60);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 'm':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).minute, dateString);
                    case 'mo':
                        return match.ordinalNumber(dateString, {
                            unit: 'minute'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $6ee699e77afcbac3$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(SecondParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 50);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case 's':
                        return (0, $41158e0b84942e97$export$cc7cc9e2a3ff9388)((0, $45b708cc5fd69e33$export$c123ee06d9da8480).second, dateString);
                    case 'so':
                        return match.ordinalNumber(dateString, {
                            unit: 'second'
                        });
                    default:
                        return (0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $c3aab8330c538b40$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(FractionOfSecondParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 30);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $41158e0b84942e97$export$4f84e3a82c7b538)((0, $41158e0b84942e97$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $8a28c993526b2e4e$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'x'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'X':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'XX':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).basic, dateString);
                    case 'XXXX':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'XXXXX':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'XXX':
                    default:
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));











var $3776ad4e985a0047$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(ISOTimezoneParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 10);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", [
            't',
            'T',
            'X'
        ]);
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case 'x':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
                    case 'xx':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).basic, dateString);
                    case 'xxxx':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
                    case 'xxxxx':
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
                    case 'xxx':
                    default:
                        return (0, $41158e0b84942e97$export$6497f4c0ecdfba8e)((0, $45b708cc5fd69e33$export$a7ee192b982af9c1).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $26d17fa6b36383d0$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(TimestampSecondsParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 40);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $41158e0b84942e97$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));










var $658c0cdd7cbe00a7$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $12e99504107770ec$export$2e2bcd8739ae039)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $1ee6d8febd3e3e88$export$2e2bcd8739ae039)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $5cdf3f8435021086$export$2e2bcd8739ae039)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "priority", 20);
        (0, $0295d13f8c0ec08d$export$2e2bcd8739ae039)((0, $a7d528e2b909fae0$export$2e2bcd8739ae039)(_this), "incompatibleTokens", '*');
        return _this;
    }
    (0, $f69f78b7edbce0d0$export$2e2bcd8739ae039)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $41158e0b84942e97$export$d931c43c4608a164)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $93ed575bcddca6a8$export$7acfa6ed01010e37));


var $e761c251bc316567$export$19131010e7fd8373 = {
    G: new (0, $001c24a37817615d$export$8e5a1d3f85a9688)(),
    y: new (0, $3d115760ee2b43fa$export$48d352de7cd4a988)(),
    Y: new (0, $26c6038d4847f7ed$export$b8ef38dfcf05d5db)(),
    R: new (0, $02b0eca39baeb4dd$export$951d1df011fde06f)(),
    u: new (0, $e5496b646f06971f$export$bad9d2ea38e8f1a)(),
    Q: new (0, $a1cb8139a29acb44$export$5cb0f701186dde1d)(),
    q: new (0, $c2a918c6039d723c$export$300c0c2990e20e6d)(),
    M: new (0, $ecc9e5acee51afa6$export$400dd8b40ef138a3)(),
    L: new (0, $b58ab579a88939b0$export$1d7eaa53eaa5deba)(),
    w: new (0, $1b1a74e2e424f296$export$c4005ffc174e07c0)(),
    I: new (0, $8ac9dddda3fa0d50$export$6fc8dbedd560a6af)(),
    d: new (0, $1e97e8961feeaae3$export$e8d4b28a20981dd2)(),
    D: new (0, $03def569ff6fccb1$export$6cfe0d613455f615)(),
    E: new (0, $7c40909befcfa76f$export$1b03c8b76262f7bd)(),
    e: new (0, $084d0714b68edc69$export$44d1c127ab42c480)(),
    c: new (0, $96ad35d635a3ce5c$export$e447a647caaaec1d)(),
    i: new (0, $36baeeb7e1e24f5e$export$693fb1e525095b2a)(),
    a: new (0, $7173946a47978ef8$export$8d1e08492351df91)(),
    b: new (0, $67c54572946689c2$export$73ca2bd0a17d273)(),
    B: new (0, $da7a1bcf7e4594cf$export$bb9212adf05373db)(),
    h: new (0, $44ab085b3f7999e6$export$8a04050a727a1756)(),
    H: new (0, $2c0464bb55dd06e8$export$e56f4dea2c3e56dd)(),
    K: new (0, $3b9b579c2fec2581$export$cbbe855312f87d77)(),
    k: new (0, $49daa262a4ef7751$export$6008046d2b34b6a5)(),
    m: new (0, $1155e57f9bee7c48$export$2b52670d9e2be53)(),
    s: new (0, $6ee699e77afcbac3$export$94d46d540cf1366a)(),
    S: new (0, $c3aab8330c538b40$export$b8e6f8b2d70893b1)(),
    X: new (0, $8a28c993526b2e4e$export$104d901d49fea29b)(),
    x: new (0, $3776ad4e985a0047$export$12910e5204b52b9)(),
    t: new (0, $26d17fa6b36383d0$export$2cd8bf877a05e96)(),
    T: new (0, $658c0cdd7cbe00a7$export$6d8f69c6906d6368)()
};



// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $0e24c03b34567a99$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $0e24c03b34567a99$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $0e24c03b34567a99$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $0e24c03b34567a99$var$doubleQuoteRegExp = /''/g;
var $0e24c03b34567a99$var$notWhitespaceRegExp = /\S/;
var $0e24c03b34567a99$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $0e24c03b34567a99$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $f11f757927401511$export$2e2bcd8739ae039)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $406c988538cdf14b$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $aea6f79126d3f9ef$export$2e2bcd8739ae039);
    if (!locale.match) throw new RangeError('locale must contain match property');
    var firstWeekContainsDate = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (formatString === '') {
        if (dateString === '') return (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $b76a40e3f9f8a11c$export$5aaf7ff7f09ea4ee)()
    ];
    var tokens = formatString.match($0e24c03b34567a99$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $950cbc186b4ec631$export$2e2bcd8739ae039)) {
            var longFormatter = (0, $950cbc186b4ec631$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($0e24c03b34567a99$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $e54577a6a05a54f0$export$2e2bcd8739ae039)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $d463ee5f31bd0520$export$c6b49d6dceb604a1)(token)) (0, $d463ee5f31bd0520$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $d463ee5f31bd0520$export$c6cc36aa33304772)(token)) (0, $d463ee5f31bd0520$export$8073c1ae88f0e727)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $e761c251bc316567$export$19131010e7fd8373)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($0e24c03b34567a99$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $0e24c03b34567a99$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $e47888d12487ce32$export$2e2bcd8739ae039)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $0e24c03b34567a99$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $40af3cc50c0a1704$export$2e2bcd8739ae039)(date, (0, $a3139271043a0e39$export$2e2bcd8739ae039)(date));
    var flags = {};
    var _iterator2 = (0, $e54577a6a05a54f0$export$2e2bcd8739ae039)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $2e951ae9a7338043$export$2e2bcd8739ae039)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $0e24c03b34567a99$var$cleanEscapedString(input) {
    return input.match($0e24c03b34567a99$var$escapedStringRegExp)[1].replace($0e24c03b34567a99$var$doubleQuoteRegExp, "'");
}





function $c8350ecb5bbedaf3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}



function $76953721381d18c1$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var month = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $c8350ecb5bbedaf3$export$2e2bcd8739ae039)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}




function $0b5a43424810ec34$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var date = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var year = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}



function $137f17d8df8283a3$export$2e2bcd8739ae039(dirtyDate) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(1, arguments);
    var cleanDate = (0, $c3d0f9877f46430d$export$2e2bcd8739ae039)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}




function $2b4ba0183d7cb9b1$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $f11f757927401511$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $67a1e72d685552e2$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $62f69bb5773628be$export$2e2bcd8739ae039)(dirtyDate, -amount);
}



/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $abf3b90c3ecb9f4f$var$__assign = function() {
    $abf3b90c3ecb9f4f$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $abf3b90c3ecb9f4f$var$__assign.apply(this, arguments);
};
function $abf3b90c3ecb9f4f$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $abf3b90c3ecb9f4f$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
/** Returns true when the props are of type {@link DayPickerMultipleProps}. */ function $abf3b90c3ecb9f4f$export$2d8c2b43ec0e528(props) {
    return props.mode === 'multiple';
}
/** Returns true when the props are of type {@link DayPickerRangeProps}. */ function $abf3b90c3ecb9f4f$export$f7b9f96866ec1964(props) {
    return props.mode === 'range';
}
/** Returns true when the props are of type {@link DayPickerSingleProps}. */ function $abf3b90c3ecb9f4f$export$e659ce9b264ea61(props) {
    return props.mode === 'single';
}
/**
 * The name of the default CSS classes.
 */ var $abf3b90c3ecb9f4f$var$defaultClassNames = {
    root: 'rdp',
    multiple_months: 'rdp-multiple_months',
    with_weeknumber: 'rdp-with_weeknumber',
    vhidden: 'rdp-vhidden',
    button_reset: 'rdp-button_reset',
    button: 'rdp-button',
    caption: 'rdp-caption',
    caption_start: 'rdp-caption_start',
    caption_end: 'rdp-caption_end',
    caption_between: 'rdp-caption_between',
    caption_label: 'rdp-caption_label',
    caption_dropdowns: 'rdp-caption_dropdowns',
    dropdown: 'rdp-dropdown',
    dropdown_month: 'rdp-dropdown_month',
    dropdown_year: 'rdp-dropdown_year',
    dropdown_icon: 'rdp-dropdown_icon',
    months: 'rdp-months',
    month: 'rdp-month',
    table: 'rdp-table',
    tbody: 'rdp-tbody',
    tfoot: 'rdp-tfoot',
    head: 'rdp-head',
    head_row: 'rdp-head_row',
    head_cell: 'rdp-head_cell',
    nav: 'rdp-nav',
    nav_button: 'rdp-nav_button',
    nav_button_previous: 'rdp-nav_button_previous',
    nav_button_next: 'rdp-nav_button_next',
    nav_icon: 'rdp-nav_icon',
    row: 'rdp-row',
    weeknumber: 'rdp-weeknumber',
    cell: 'rdp-cell',
    day: 'rdp-day',
    day_today: 'rdp-day_today',
    day_outside: 'rdp-day_outside',
    day_selected: 'rdp-day_selected',
    day_disabled: 'rdp-day_disabled',
    day_hidden: 'rdp-day_hidden',
    day_range_start: 'rdp-day_range_start',
    day_range_end: 'rdp-day_range_end',
    day_range_middle: 'rdp-day_range_middle'
};
/**
 * The default formatter for the caption.
 */ function $abf3b90c3ecb9f4f$var$formatCaption(month, options) {
    return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(month, 'LLLL y', options);
}
/**
 * The default formatter for the Day button.
 */ function $abf3b90c3ecb9f4f$var$formatDay(day, options) {
    return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(day, 'd', options);
}
/**
 * The default formatter for the Month caption.
 */ function $abf3b90c3ecb9f4f$var$formatMonthCaption(month, options) {
    return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(month, 'LLLL', options);
}
/**
 * The default formatter for the week number.
 */ function $abf3b90c3ecb9f4f$var$formatWeekNumber(weekNumber) {
    return "".concat(weekNumber);
}
/**
 * The default formatter for the name of the weekday.
 */ function $abf3b90c3ecb9f4f$var$formatWeekdayName(weekday, options) {
    return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(weekday, 'cccccc', options);
}
/**
 * The default formatter for the Year caption.
 */ function $abf3b90c3ecb9f4f$var$formatYearCaption(year, options) {
    return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(year, 'yyyy', options);
}
var $abf3b90c3ecb9f4f$var$formatters = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    formatCaption: $abf3b90c3ecb9f4f$var$formatCaption,
    formatDay: $abf3b90c3ecb9f4f$var$formatDay,
    formatMonthCaption: $abf3b90c3ecb9f4f$var$formatMonthCaption,
    formatWeekNumber: $abf3b90c3ecb9f4f$var$formatWeekNumber,
    formatWeekdayName: $abf3b90c3ecb9f4f$var$formatWeekdayName,
    formatYearCaption: $abf3b90c3ecb9f4f$var$formatYearCaption
});
/**
 * The default ARIA label for the day button.
 */ var $abf3b90c3ecb9f4f$var$labelDay = function(day, activeModifiers, options) {
    return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(day, 'do MMMM (EEEE)', options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $abf3b90c3ecb9f4f$var$labelMonthDropdown = function() {
    return 'Month: ';
};
/**
 * The default ARIA label for next month button in navigation
 */ var $abf3b90c3ecb9f4f$var$labelNext = function() {
    return 'Go to next month';
};
/**
 * The default ARIA label for previous month button in navigation
 */ var $abf3b90c3ecb9f4f$var$labelPrevious = function() {
    return 'Go to previous month';
};
/**
 * The default ARIA label for the Weekday element.
 */ var $abf3b90c3ecb9f4f$var$labelWeekday = function(day, options) {
    return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(day, 'cccc', options);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $abf3b90c3ecb9f4f$var$labelWeekNumber = function(n) {
    return "Week n. ".concat(n);
};
/**
 * The default ARIA label for the WeekNumber element.
 */ var $abf3b90c3ecb9f4f$var$labelYearDropdown = function() {
    return 'Year: ';
};
var $abf3b90c3ecb9f4f$var$labels = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    labelDay: $abf3b90c3ecb9f4f$var$labelDay,
    labelMonthDropdown: $abf3b90c3ecb9f4f$var$labelMonthDropdown,
    labelNext: $abf3b90c3ecb9f4f$var$labelNext,
    labelPrevious: $abf3b90c3ecb9f4f$var$labelPrevious,
    labelWeekNumber: $abf3b90c3ecb9f4f$var$labelWeekNumber,
    labelWeekday: $abf3b90c3ecb9f4f$var$labelWeekday,
    labelYearDropdown: $abf3b90c3ecb9f4f$var$labelYearDropdown
});
/**
 * Returns the default values to use in the DayPickerContext, in case they are
 * not passed down with the DayPicker initial props.
 */ function $abf3b90c3ecb9f4f$var$getDefaultContextValues() {
    var captionLayout = 'buttons';
    var classNames = $abf3b90c3ecb9f4f$var$defaultClassNames;
    var locale = (0, $2f071ab2ce9db9ac$export$2e2bcd8739ae039);
    var modifiersClassNames = {};
    var modifiers = {};
    var numberOfMonths = 1;
    var styles = {};
    var today = new Date();
    return {
        captionLayout: captionLayout,
        classNames: classNames,
        formatters: $abf3b90c3ecb9f4f$var$formatters,
        labels: $abf3b90c3ecb9f4f$var$labels,
        locale: locale,
        modifiersClassNames: modifiersClassNames,
        modifiers: modifiers,
        numberOfMonths: numberOfMonths,
        styles: styles,
        today: today,
        mode: 'default'
    };
}
/** Return the `fromDate` and `toDate` prop values values parsing the DayPicker props. */ function $abf3b90c3ecb9f4f$var$parseFromToProps(props) {
    var fromYear = props.fromYear, toYear = props.toYear, fromMonth = props.fromMonth, toMonth = props.toMonth;
    var fromDate = props.fromDate, toDate = props.toDate;
    if (fromMonth) fromDate = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(fromMonth);
    else if (fromYear) fromDate = new Date(fromYear, 0, 1);
    if (toMonth) toDate = (0, $2047aa644d00beb8$export$2e2bcd8739ae039)(toMonth);
    else if (toYear) toDate = new Date(toYear, 11, 31);
    return {
        fromDate: fromDate ? (0, $850a51168f487f37$export$2e2bcd8739ae039)(fromDate) : undefined,
        toDate: toDate ? (0, $850a51168f487f37$export$2e2bcd8739ae039)(toDate) : undefined
    };
}
/**
 * The DayPicker context shares the props passed to DayPicker within internal
 * and custom components. It is used to set the default values and perform
 * one-time calculations required to render the days.
 *
 * Access to this context from the {@link useDayPicker} hook.
 */ var $abf3b90c3ecb9f4f$export$5e463664ac32e9a9 = (0, $kYL7Z.createContext)(undefined);
/**
 * The provider for the {@link DayPickerContext}, assigning the defaults from the
 * initial DayPicker props.
 */ function $abf3b90c3ecb9f4f$export$a84f964d022d25c(props) {
    var _a;
    var initialProps = props.initialProps;
    var defaultContextValues = $abf3b90c3ecb9f4f$var$getDefaultContextValues();
    var _b = $abf3b90c3ecb9f4f$var$parseFromToProps(initialProps), fromDate = _b.fromDate, toDate = _b.toDate;
    var captionLayout = (_a = initialProps.captionLayout) !== null && _a !== void 0 ? _a : defaultContextValues.captionLayout;
    if (captionLayout !== 'buttons' && (!fromDate || !toDate)) // When no from/to dates are set, the caption is always buttons
    captionLayout = 'buttons';
    var onSelect;
    if ($abf3b90c3ecb9f4f$export$e659ce9b264ea61(initialProps) || $abf3b90c3ecb9f4f$export$2d8c2b43ec0e528(initialProps) || $abf3b90c3ecb9f4f$export$f7b9f96866ec1964(initialProps)) onSelect = initialProps.onSelect;
    var value = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, defaultContextValues), initialProps), {
        captionLayout: captionLayout,
        classNames: $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, defaultContextValues.classNames), initialProps.classNames),
        components: $abf3b90c3ecb9f4f$var$__assign({}, initialProps.components),
        formatters: $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, defaultContextValues.formatters), initialProps.formatters),
        fromDate: fromDate,
        labels: $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, defaultContextValues.labels), initialProps.labels),
        mode: initialProps.mode || defaultContextValues.mode,
        modifiers: $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, defaultContextValues.modifiers), initialProps.modifiers),
        modifiersClassNames: $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, defaultContextValues.modifiersClassNames), initialProps.modifiersClassNames),
        onSelect: onSelect,
        styles: $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, defaultContextValues.styles), initialProps.styles),
        toDate: toDate
    });
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$5e463664ac32e9a9.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link DayPickerContextValue}.
 *
 * Use the DayPicker context to access to the props passed to DayPicker inside
 * internal or custom components.
 */ function $abf3b90c3ecb9f4f$export$332e9e0d64b1f294() {
    var context = (0, $kYL7Z.useContext)($abf3b90c3ecb9f4f$export$5e463664ac32e9a9);
    if (!context) throw new Error("useDayPicker must be used within a DayPickerProvider.");
    return context;
}
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */ function $abf3b90c3ecb9f4f$export$5b9f95302ae85eba(props) {
    var _a = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), locale = _a.locale, classNames = _a.classNames, styles = _a.styles, formatCaption = _a.formatters.formatCaption;
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: classNames.caption_label,
        style: styles.caption_label,
        "aria-live": "polite",
        role: "presentation",
        id: props.id,
        children: formatCaption(props.displayMonth, {
            locale: locale
        })
    });
}
/**
 * Render the icon in the styled drop-down.
 */ function $abf3b90c3ecb9f4f$export$eaf28e65c2d9267c(props) {
    return (0, $fc31e5e9fc16a880$exports.jsx)("svg", $abf3b90c3ecb9f4f$var$__assign({
        width: "8px",
        height: "8px",
        viewBox: "0 0 120 120",
        "data-testid": "iconDropdown"
    }, props, {
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render a styled select component – displaying a caption and a custom
 * drop-down icon.
 */ function $abf3b90c3ecb9f4f$export$931cbfb6bfb85fc(props) {
    var _a, _b;
    var onChange = props.onChange, value = props.value, children = props.children, caption = props.caption, className = props.className, style = props.style;
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var IconDropdownComponent = (_b = (_a = dayPicker.components) === null || _a === void 0 ? void 0 : _a.IconDropdown) !== null && _b !== void 0 ? _b : $abf3b90c3ecb9f4f$export$eaf28e65c2d9267c;
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: className,
        style: style,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                className: dayPicker.classNames.vhidden,
                children: props['aria-label']
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)("select", {
                name: props.name,
                "aria-label": props['aria-label'],
                className: dayPicker.classNames.dropdown,
                style: dayPicker.styles.dropdown,
                value: value,
                onChange: onChange,
                children: children
            }),
            (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                className: dayPicker.classNames.caption_label,
                style: dayPicker.styles.caption_label,
                "aria-hidden": "true",
                children: [
                    caption,
                    (0, $fc31e5e9fc16a880$exports.jsx)(IconDropdownComponent, {
                        className: dayPicker.classNames.dropdown_icon,
                        style: dayPicker.styles.dropdown_icon
                    })
                ]
            })
        ]
    });
}
/** Render the dropdown to navigate between months. */ function $abf3b90c3ecb9f4f$var$MonthsDropdown(props) {
    var _a;
    var _b = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, styles = _b.styles, locale = _b.locale, formatMonthCaption = _b.formatters.formatMonthCaption, classNames = _b.classNames, components = _b.components, labelMonthDropdown = _b.labels.labelMonthDropdown;
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {});
    if (!toDate) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {});
    var dropdownMonths = [];
    if ((0, $6783555427d03e58$export$2e2bcd8739ae039)(fromDate, toDate)) {
        // only display the months included in the range
        var date = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(fromDate);
        for(var month = fromDate.getMonth(); month <= toDate.getMonth(); month++)dropdownMonths.push((0, $76953721381d18c1$export$2e2bcd8739ae039)(date, month));
    } else {
        // display all the 12 months
        var date = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(new Date()); // Any date should be OK, as we just need the year
        for(var month = 0; month <= 11; month++)dropdownMonths.push((0, $76953721381d18c1$export$2e2bcd8739ae039)(date, month));
    }
    var handleChange = function(e) {
        var selectedMonth = Number(e.target.value);
        var newMonth = (0, $76953721381d18c1$export$2e2bcd8739ae039)((0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(props.displayMonth), selectedMonth);
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$931cbfb6bfb85fc;
    return (0, $fc31e5e9fc16a880$exports.jsx)(DropdownComponent, {
        name: "months",
        "aria-label": labelMonthDropdown(),
        className: classNames.dropdown_month,
        style: styles.dropdown_month,
        onChange: handleChange,
        value: props.displayMonth.getMonth(),
        caption: formatMonthCaption(props.displayMonth, {
            locale: locale
        }),
        children: dropdownMonths.map(function(m) {
            return (0, $fc31e5e9fc16a880$exports.jsx)("option", {
                value: m.getMonth(),
                children: formatMonthCaption(m, {
                    locale: locale
                })
            }, m.getMonth());
        })
    });
}
/**
 * Render a dropdown to change the year. Take in account the `nav.fromDate` and
 * `toDate` from context.
 */ function $abf3b90c3ecb9f4f$var$YearsDropdown(props) {
    var _a;
    var displayMonth = props.displayMonth;
    var _b = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), fromDate = _b.fromDate, toDate = _b.toDate, locale = _b.locale, styles = _b.styles, classNames = _b.classNames, components = _b.components, formatYearCaption = _b.formatters.formatYearCaption, labelYearDropdown = _b.labels.labelYearDropdown;
    var years = [];
    // Dropdown should appear only when both from/toDate is set
    if (!fromDate) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {});
    if (!toDate) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {});
    var fromYear = fromDate.getFullYear();
    var toYear = toDate.getFullYear();
    for(var year = fromYear; year <= toYear; year++)years.push((0, $0b5a43424810ec34$export$2e2bcd8739ae039)((0, $137f17d8df8283a3$export$2e2bcd8739ae039)(new Date()), year));
    var handleChange = function(e) {
        var newMonth = (0, $0b5a43424810ec34$export$2e2bcd8739ae039)((0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(displayMonth), Number(e.target.value));
        props.onChange(newMonth);
    };
    var DropdownComponent = (_a = components === null || components === void 0 ? void 0 : components.Dropdown) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$931cbfb6bfb85fc;
    return (0, $fc31e5e9fc16a880$exports.jsx)(DropdownComponent, {
        name: "years",
        "aria-label": labelYearDropdown(),
        className: classNames.dropdown_year,
        style: styles.dropdown_year,
        onChange: handleChange,
        value: displayMonth.getFullYear(),
        caption: formatYearCaption(displayMonth, {
            locale: locale
        }),
        children: years.map(function(year) {
            return (0, $fc31e5e9fc16a880$exports.jsx)("option", {
                value: year.getFullYear(),
                children: formatYearCaption(year, {
                    locale: locale
                })
            }, year.getFullYear());
        })
    });
}
/**
 * Helper hook for using controlled/uncontrolled values from a component props.
 *
 * When the value is not controlled, pass `undefined` as `controlledValue` and
 * use the returned setter to update it.
 *
 * When the value is controlled, pass the controlled value as second
 * argument, which will be always returned as `value`.
 */ function $abf3b90c3ecb9f4f$var$useControlledValue(defaultValue, controlledValue) {
    var _a = (0, $kYL7Z.useState)(defaultValue), uncontrolledValue = _a[0], setValue = _a[1];
    var value = controlledValue === undefined ? uncontrolledValue : controlledValue;
    return [
        value,
        setValue
    ];
}
/** Return the initial month according to the given options. */ function $abf3b90c3ecb9f4f$var$getInitialMonth(context) {
    var month = context.month, defaultMonth = context.defaultMonth, today = context.today;
    var initialMonth = month || defaultMonth || today || new Date();
    var toDate = context.toDate, fromDate = context.fromDate, _a = context.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    // Fix the initialMonth if is after the to-date
    if (toDate && (0, $7aa8daa05d53dbe4$export$2e2bcd8739ae039)(toDate, initialMonth) < 0) {
        var offset = -1 * (numberOfMonths - 1);
        initialMonth = (0, $999339d7b1b67955$export$2e2bcd8739ae039)(toDate, offset);
    }
    // Fix the initialMonth if is before the from-date
    if (fromDate && (0, $7aa8daa05d53dbe4$export$2e2bcd8739ae039)(initialMonth, fromDate) < 0) initialMonth = fromDate;
    return (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(initialMonth);
}
/** Controls the navigation state. */ function $abf3b90c3ecb9f4f$var$useNavigationState() {
    var context = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var initialMonth = $abf3b90c3ecb9f4f$var$getInitialMonth(context);
    var _a = $abf3b90c3ecb9f4f$var$useControlledValue(initialMonth, context.month), month = _a[0], setMonth = _a[1];
    var goToMonth = function(date) {
        var _a;
        if (context.disableNavigation) return;
        var month = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(date);
        setMonth(month);
        (_a = context.onMonthChange) === null || _a === void 0 || _a.call(context, month);
    };
    return [
        month,
        goToMonth
    ];
}
/**
 * Return the months to display in the component according to the number of
 * months and the from/to date.
 */ function $abf3b90c3ecb9f4f$var$getDisplayMonths(month, _a) {
    var reverseMonths = _a.reverseMonths, numberOfMonths = _a.numberOfMonths;
    var start = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(month);
    var end = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)((0, $999339d7b1b67955$export$2e2bcd8739ae039)(start, numberOfMonths));
    var monthsDiff = (0, $7aa8daa05d53dbe4$export$2e2bcd8739ae039)(end, start);
    var months = [];
    for(var i = 0; i < monthsDiff; i++){
        var nextMonth = (0, $999339d7b1b67955$export$2e2bcd8739ae039)(start, i);
        months.push(nextMonth);
    }
    if (reverseMonths) months = months.reverse();
    return months;
}
/**
 * Returns the next month the user can navigate to according to the given
 * options.
 *
 * Please note that the next month is not always the next calendar month:
 *
 * - if after the `toDate` range, is undefined;
 * - if the navigation is paged, is the number of months displayed ahead.
 *
 */ function $abf3b90c3ecb9f4f$var$getNextMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var toDate = options.toDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(startingMonth);
    if (!toDate) return (0, $999339d7b1b67955$export$2e2bcd8739ae039)(month, offset);
    var monthsDiff = (0, $7aa8daa05d53dbe4$export$2e2bcd8739ae039)(toDate, startingMonth);
    if (monthsDiff < numberOfMonths) return undefined;
    // Jump forward as the number of months when paged navigation
    return (0, $999339d7b1b67955$export$2e2bcd8739ae039)(month, offset);
}
/**
 * Returns the next previous the user can navigate to, according to the given
 * options.
 *
 * Please note that the previous month is not always the previous calendar
 * month:
 *
 * - if before the `fromDate` date, is `undefined`;
 * - if the navigation is paged, is the number of months displayed before.
 *
 */ function $abf3b90c3ecb9f4f$var$getPreviousMonth(startingMonth, options) {
    if (options.disableNavigation) return undefined;
    var fromDate = options.fromDate, pagedNavigation = options.pagedNavigation, _a = options.numberOfMonths, numberOfMonths = _a === void 0 ? 1 : _a;
    var offset = pagedNavigation ? numberOfMonths : 1;
    var month = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(startingMonth);
    if (!fromDate) return (0, $999339d7b1b67955$export$2e2bcd8739ae039)(month, -offset);
    var monthsDiff = (0, $7aa8daa05d53dbe4$export$2e2bcd8739ae039)(month, fromDate);
    if (monthsDiff <= 0) return undefined;
    // Jump back as the number of months when paged navigation
    return (0, $999339d7b1b67955$export$2e2bcd8739ae039)(month, -offset);
}
/**
 * The Navigation context shares details and methods to navigate the months in DayPicker.
 * Access this context from the {@link useNavigation} hook.
 */ var $abf3b90c3ecb9f4f$export$3044ab7fdabeaee6 = (0, $kYL7Z.createContext)(undefined);
/** Provides the values for the {@link NavigationContext}. */ function $abf3b90c3ecb9f4f$export$d91daf425539f32f(props) {
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var _a = $abf3b90c3ecb9f4f$var$useNavigationState(), currentMonth = _a[0], goToMonth = _a[1];
    var displayMonths = $abf3b90c3ecb9f4f$var$getDisplayMonths(currentMonth, dayPicker);
    var nextMonth = $abf3b90c3ecb9f4f$var$getNextMonth(currentMonth, dayPicker);
    var previousMonth = $abf3b90c3ecb9f4f$var$getPreviousMonth(currentMonth, dayPicker);
    var isDateDisplayed = function(date) {
        return displayMonths.some(function(displayMonth) {
            return (0, $748eba9a3bddca65$export$2e2bcd8739ae039)(date, displayMonth);
        });
    };
    var goToDate = function(date, refDate) {
        if (isDateDisplayed(date)) return;
        if (refDate && (0, $225ed1a47de95b15$export$2e2bcd8739ae039)(date, refDate)) goToMonth((0, $999339d7b1b67955$export$2e2bcd8739ae039)(date, 1 + dayPicker.numberOfMonths * -1));
        else goToMonth(date);
    };
    var value = {
        currentMonth: currentMonth,
        displayMonths: displayMonths,
        goToMonth: goToMonth,
        goToDate: goToDate,
        previousMonth: previousMonth,
        nextMonth: nextMonth,
        isDateDisplayed: isDateDisplayed
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$3044ab7fdabeaee6.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link NavigationContextValue}. Use this hook to navigate
 * between months or years in DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $abf3b90c3ecb9f4f$export$d0fd4b7106de2769() {
    var context = (0, $kYL7Z.useContext)($abf3b90c3ecb9f4f$export$3044ab7fdabeaee6);
    if (!context) throw new Error('useNavigation must be used within a NavigationProvider');
    return context;
}
/**
 * Render a caption with the dropdowns to navigate between months and years.
 */ function $abf3b90c3ecb9f4f$export$6a3605aba74bcb3d(props) {
    var _a;
    var _b = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var goToMonth = $abf3b90c3ecb9f4f$export$d0fd4b7106de2769().goToMonth;
    var handleMonthChange = function(newMonth) {
        goToMonth((0, $999339d7b1b67955$export$2e2bcd8739ae039)(newMonth, props.displayIndex ? -props.displayIndex : 0));
    };
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$5b9f95302ae85eba;
    var captionLabel = (0, $fc31e5e9fc16a880$exports.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: classNames.caption_dropdowns,
        style: styles.caption_dropdowns,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: classNames.vhidden,
                children: captionLabel
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$MonthsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$YearsDropdown, {
                onChange: handleMonthChange,
                displayMonth: props.displayMonth
            })
        ]
    });
}
/**
 * Render the "previous month" button in the navigation.
 */ function $abf3b90c3ecb9f4f$export$fac286bb0d0d0385(props) {
    return (0, $fc31e5e9fc16a880$exports.jsx)("svg", $abf3b90c3ecb9f4f$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z",
            fill: "currentColor",
            fillRule: "nonzero"
        })
    }));
}
/**
 * Render the "next month" button in the navigation.
 */ function $abf3b90c3ecb9f4f$export$142e5a7835580ff5(props) {
    return (0, $fc31e5e9fc16a880$exports.jsx)("svg", $abf3b90c3ecb9f4f$var$__assign({
        width: "16px",
        height: "16px",
        viewBox: "0 0 120 120"
    }, props, {
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z",
            fill: "currentColor"
        })
    }));
}
/** Render a button HTML element applying the reset class name. */ var $abf3b90c3ecb9f4f$export$353f5b6fc5456de1 = (0, $kYL7Z.forwardRef)(function(props, ref) {
    var _a = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    var classNamesArr = [
        classNames.button_reset,
        classNames.button
    ];
    if (props.className) classNamesArr.push(props.className);
    var className = classNamesArr.join(' ');
    var style = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, styles.button_reset), styles.button);
    if (props.style) Object.assign(style, props.style);
    return (0, $fc31e5e9fc16a880$exports.jsx)("button", $abf3b90c3ecb9f4f$var$__assign({}, props, {
        ref: ref,
        type: "button",
        className: className,
        style: style
    }));
});
/** A component rendering the navigation buttons or the drop-downs. */ function $abf3b90c3ecb9f4f$var$Navigation(props) {
    var _a, _b;
    var _c = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), dir = _c.dir, locale = _c.locale, classNames = _c.classNames, styles = _c.styles, _d = _c.labels, labelPrevious = _d.labelPrevious, labelNext = _d.labelNext, components = _c.components;
    if (!props.nextMonth && !props.previousMonth) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {});
    var previousLabel = labelPrevious(props.previousMonth, {
        locale: locale
    });
    var previousClassName = [
        classNames.nav_button,
        classNames.nav_button_previous
    ].join(' ');
    var nextLabel = labelNext(props.nextMonth, {
        locale: locale
    });
    var nextClassName = [
        classNames.nav_button,
        classNames.nav_button_next
    ].join(' ');
    var IconRightComponent = (_a = components === null || components === void 0 ? void 0 : components.IconRight) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$142e5a7835580ff5;
    var IconLeftComponent = (_b = components === null || components === void 0 ? void 0 : components.IconLeft) !== null && _b !== void 0 ? _b : $abf3b90c3ecb9f4f$export$fac286bb0d0d0385;
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: classNames.nav,
        style: styles.nav,
        children: [
            !props.hidePrevious && (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$353f5b6fc5456de1, {
                name: "previous-month",
                "aria-label": previousLabel,
                className: previousClassName,
                style: styles.nav_button_previous,
                disabled: !props.previousMonth,
                onClick: props.onPreviousClick,
                children: dir === 'rtl' ? (0, $fc31e5e9fc16a880$exports.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $fc31e5e9fc16a880$exports.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            }),
            !props.hideNext && (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$353f5b6fc5456de1, {
                name: "next-month",
                "aria-label": nextLabel,
                className: nextClassName,
                style: styles.nav_button_next,
                disabled: !props.nextMonth,
                onClick: props.onNextClick,
                children: dir === 'rtl' ? (0, $fc31e5e9fc16a880$exports.jsx)(IconLeftComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                }) : (0, $fc31e5e9fc16a880$exports.jsx)(IconRightComponent, {
                    className: classNames.nav_icon,
                    style: styles.nav_icon
                })
            })
        ]
    });
}
/**
 * Render a caption with a button-based navigation.
 */ function $abf3b90c3ecb9f4f$export$f6e46da460a028c1(props) {
    var numberOfMonths = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294().numberOfMonths;
    var _a = $abf3b90c3ecb9f4f$export$d0fd4b7106de2769(), previousMonth = _a.previousMonth, nextMonth = _a.nextMonth, goToMonth = _a.goToMonth, displayMonths = _a.displayMonths;
    var displayIndex = displayMonths.findIndex(function(month) {
        return (0, $748eba9a3bddca65$export$2e2bcd8739ae039)(props.displayMonth, month);
    });
    var isFirst = displayIndex === 0;
    var isLast = displayIndex === displayMonths.length - 1;
    var hideNext = numberOfMonths > 1 && (isFirst || !isLast);
    var hidePrevious = numberOfMonths > 1 && (isLast || !isFirst);
    var handlePreviousClick = function() {
        if (!previousMonth) return;
        goToMonth(previousMonth);
    };
    var handleNextClick = function() {
        if (!nextMonth) return;
        goToMonth(nextMonth);
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$Navigation, {
        displayMonth: props.displayMonth,
        hideNext: hideNext,
        hidePrevious: hidePrevious,
        nextMonth: nextMonth,
        previousMonth: previousMonth,
        onPreviousClick: handlePreviousClick,
        onNextClick: handleNextClick
    });
}
/**
 * Render the caption of a month. The caption has a different layout when
 * setting the {@link DayPickerBase.captionLayout} prop.
 */ function $abf3b90c3ecb9f4f$export$32fbfacc5d962e0c(props) {
    var _a;
    var _b = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), classNames = _b.classNames, disableNavigation = _b.disableNavigation, styles = _b.styles, captionLayout = _b.captionLayout, components = _b.components;
    var CaptionLabelComponent = (_a = components === null || components === void 0 ? void 0 : components.CaptionLabel) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$5b9f95302ae85eba;
    var caption;
    if (disableNavigation) caption = (0, $fc31e5e9fc16a880$exports.jsx)(CaptionLabelComponent, {
        id: props.id,
        displayMonth: props.displayMonth
    });
    else if (captionLayout === 'dropdown') caption = (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$6a3605aba74bcb3d, {
        displayMonth: props.displayMonth,
        id: props.id
    });
    else if (captionLayout === 'dropdown-buttons') caption = (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$6a3605aba74bcb3d, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex,
                id: props.id
            })
        ]
    });
    else caption = (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)(CaptionLabelComponent, {
                id: props.id,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$f6e46da460a028c1, {
                displayMonth: props.displayMonth,
                id: props.id
            })
        ]
    });
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: classNames.caption,
        style: styles.caption,
        children: caption
    });
}
/** Render the Footer component (empty as default).*/ // eslint-disable-next-line @typescript-eslint/no-unused-vars
function $abf3b90c3ecb9f4f$export$a06f1c675e846f6f(props) {
    var _a = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), footer = _a.footer, styles = _a.styles, tfoot = _a.classNames.tfoot;
    if (!footer) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {});
    return (0, $fc31e5e9fc16a880$exports.jsx)("tfoot", {
        className: tfoot,
        style: styles.tfoot,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("tr", {
            children: (0, $fc31e5e9fc16a880$exports.jsx)("td", {
                colSpan: 8,
                children: footer
            })
        })
    });
}
/**
 * Generate a series of 7 days, starting from the week, to use for formatting
 * the weekday names (Monday, Tuesday, etc.).
 */ function $abf3b90c3ecb9f4f$var$getWeekdays(locale, /** The index of the first day of the week (0 - Sunday). */ weekStartsOn, /** Use ISOWeek instead of locale/ */ ISOWeek) {
    var start = ISOWeek ? (0, $f61d1f0ea5c727e5$export$2e2bcd8739ae039)(new Date()) : (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(new Date(), {
        locale: locale,
        weekStartsOn: weekStartsOn
    });
    var days = [];
    for(var i = 0; i < 7; i++){
        var day = (0, $62f69bb5773628be$export$2e2bcd8739ae039)(start, i);
        days.push(day);
    }
    return days;
}
/**
 * Render the HeadRow component - i.e. the table head row with the weekday names.
 */ function $abf3b90c3ecb9f4f$export$b008e842a2213343() {
    var _a = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles, showWeekNumber = _a.showWeekNumber, locale = _a.locale, weekStartsOn = _a.weekStartsOn, ISOWeek = _a.ISOWeek, formatWeekdayName = _a.formatters.formatWeekdayName, labelWeekday = _a.labels.labelWeekday;
    var weekdays = $abf3b90c3ecb9f4f$var$getWeekdays(locale, weekStartsOn, ISOWeek);
    return (0, $fc31e5e9fc16a880$exports.jsxs)("tr", {
        style: styles.head_row,
        className: classNames.head_row,
        children: [
            showWeekNumber && (0, $fc31e5e9fc16a880$exports.jsx)("td", {
                style: styles.head_cell,
                className: classNames.head_cell
            }),
            weekdays.map(function(weekday, i) {
                return (0, $fc31e5e9fc16a880$exports.jsx)("th", {
                    scope: "col",
                    className: classNames.head_cell,
                    style: styles.head_cell,
                    "aria-label": labelWeekday(weekday, {
                        locale: locale
                    }),
                    children: formatWeekdayName(weekday, {
                        locale: locale
                    })
                }, i);
            })
        ]
    });
}
/** Render the table head. */ function $abf3b90c3ecb9f4f$export$e93312b7773dfcac() {
    var _a;
    var _b = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), classNames = _b.classNames, styles = _b.styles, components = _b.components;
    var HeadRowComponent = (_a = components === null || components === void 0 ? void 0 : components.HeadRow) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$b008e842a2213343;
    return (0, $fc31e5e9fc16a880$exports.jsx)("thead", {
        style: styles.head,
        className: classNames.head,
        children: (0, $fc31e5e9fc16a880$exports.jsx)(HeadRowComponent, {})
    });
}
/** Render the content of the day cell. */ function $abf3b90c3ecb9f4f$export$16d0634337daf8ec(props) {
    var _a = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), locale = _a.locale, formatDay = _a.formatters.formatDay;
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: formatDay(props.date, {
            locale: locale
        })
    });
}
/**
 * The SelectMultiple context shares details about the selected days when in
 * multiple selection mode.
 *
 * Access this context from the {@link useSelectMultiple} hook.
 */ var $abf3b90c3ecb9f4f$export$26e3e4d6f601d4d6 = (0, $kYL7Z.createContext)(undefined);
/** Provides the values for the {@link SelectMultipleContext}. */ function $abf3b90c3ecb9f4f$export$913827019032c8d4(props) {
    if (!$abf3b90c3ecb9f4f$export$2d8c2b43ec0e528(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                disabled: []
            }
        };
        return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$26e3e4d6f601d4d6.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$91128e1c5ca64a0d, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $abf3b90c3ecb9f4f$export$91128e1c5ca64a0d(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected, min = initialProps.min, max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var isMinSelected = Boolean(activeModifiers.selected && min && (selected === null || selected === void 0 ? void 0 : selected.length) === min);
        if (isMinSelected) return;
        var isMaxSelected = Boolean(!activeModifiers.selected && max && (selected === null || selected === void 0 ? void 0 : selected.length) === max);
        if (isMaxSelected) return;
        var selectedDays = selected ? $abf3b90c3ecb9f4f$var$__spreadArray([], selected, true) : [];
        if (activeModifiers.selected) {
            var index = selectedDays.findIndex(function(selectedDay) {
                return (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(day, selectedDay);
            });
            selectedDays.splice(index, 1);
        } else selectedDays.push(day);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, selectedDays, day, activeModifiers, e);
    };
    var modifiers = {
        disabled: []
    };
    if (selected) modifiers.disabled.push(function(day) {
        var isMaxSelected = max && selected.length > max - 1;
        var isSelected = selected.some(function(selectedDay) {
            return (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(selectedDay, day);
        });
        return Boolean(isMaxSelected && !isSelected);
    });
    var contextValue = {
        selected: selected,
        onDayClick: onDayClick,
        modifiers: modifiers
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$26e3e4d6f601d4d6.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectMultipleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $abf3b90c3ecb9f4f$export$458361db477d8ed0() {
    var context = (0, $kYL7Z.useContext)($abf3b90c3ecb9f4f$export$26e3e4d6f601d4d6);
    if (!context) throw new Error('useSelectMultiple must be used within a SelectMultipleProvider');
    return context;
}
/**
 * Add a day to an existing range.
 *
 * The returned range takes in account the `undefined` values and if the added
 * day is already present in the range.
 */ function $abf3b90c3ecb9f4f$export$27ef550b4e6acc0c(day, range) {
    var _a = range || {}, from = _a.from, to = _a.to;
    if (from && to) {
        if ((0, $01773c7f1dffd541$export$2e2bcd8739ae039)(to, day) && (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(from, day)) return undefined;
        if ((0, $01773c7f1dffd541$export$2e2bcd8739ae039)(to, day)) return {
            from: to,
            to: undefined
        };
        if ((0, $01773c7f1dffd541$export$2e2bcd8739ae039)(from, day)) return undefined;
        if ((0, $3e00ad5e5752a430$export$2e2bcd8739ae039)(from, day)) return {
            from: day,
            to: to
        };
        return {
            from: from,
            to: day
        };
    }
    if (to) {
        if ((0, $3e00ad5e5752a430$export$2e2bcd8739ae039)(day, to)) return {
            from: to,
            to: day
        };
        return {
            from: day,
            to: to
        };
    }
    if (from) {
        if ((0, $225ed1a47de95b15$export$2e2bcd8739ae039)(day, from)) return {
            from: day,
            to: from
        };
        return {
            from: from,
            to: day
        };
    }
    return {
        from: day,
        to: undefined
    };
}
/**
 * The SelectRange context shares details about the selected days when in
 * range selection mode.
 *
 * Access this context from the {@link useSelectRange} hook.
 */ var $abf3b90c3ecb9f4f$export$49c734aed8c840bb = (0, $kYL7Z.createContext)(undefined);
/** Provides the values for the {@link SelectRangeProvider}. */ function $abf3b90c3ecb9f4f$export$deb49a47c7ee5fdf(props) {
    if (!$abf3b90c3ecb9f4f$export$f7b9f96866ec1964(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined,
            modifiers: {
                range_start: [],
                range_end: [],
                range_middle: [],
                disabled: []
            }
        };
        return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$49c734aed8c840bb.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$cca59e032fbbe71f, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $abf3b90c3ecb9f4f$export$cca59e032fbbe71f(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var selected = initialProps.selected;
    var _b = selected || {}, selectedFrom = _b.from, selectedTo = _b.to;
    var min = initialProps.min;
    var max = initialProps.max;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        var newRange = $abf3b90c3ecb9f4f$export$27ef550b4e6acc0c(day, selected);
        (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, newRange, day, activeModifiers, e);
    };
    var modifiers = {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
    };
    if (selectedFrom) {
        modifiers.range_start = [
            selectedFrom
        ];
        if (!selectedTo) modifiers.range_end = [
            selectedFrom
        ];
        else {
            modifiers.range_end = [
                selectedTo
            ];
            if (!(0, $01773c7f1dffd541$export$2e2bcd8739ae039)(selectedFrom, selectedTo)) modifiers.range_middle = [
                {
                    after: selectedFrom,
                    before: selectedTo
                }
            ];
        }
    } else if (selectedTo) {
        modifiers.range_start = [
            selectedTo
        ];
        modifiers.range_end = [
            selectedTo
        ];
    }
    if (min) {
        if (selectedFrom && !selectedTo) modifiers.disabled.push({
            after: (0, $2b4ba0183d7cb9b1$export$2e2bcd8739ae039)(selectedFrom, min - 1),
            before: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedFrom, min - 1)
        });
        if (selectedFrom && selectedTo) modifiers.disabled.push({
            after: selectedFrom,
            before: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedFrom, min - 1)
        });
        if (!selectedFrom && selectedTo) modifiers.disabled.push({
            after: (0, $2b4ba0183d7cb9b1$export$2e2bcd8739ae039)(selectedTo, min - 1),
            before: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedTo, min - 1)
        });
    }
    if (max) {
        if (selectedFrom && !selectedTo) {
            modifiers.disabled.push({
                before: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedFrom, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedFrom, max - 1)
            });
        }
        if (selectedFrom && selectedTo) {
            var selectedCount = (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(selectedTo, selectedFrom) + 1;
            var offset = max - selectedCount;
            modifiers.disabled.push({
                before: (0, $2b4ba0183d7cb9b1$export$2e2bcd8739ae039)(selectedFrom, offset)
            });
            modifiers.disabled.push({
                after: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedTo, offset)
            });
        }
        if (!selectedFrom && selectedTo) {
            modifiers.disabled.push({
                before: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedTo, -max + 1)
            });
            modifiers.disabled.push({
                after: (0, $62f69bb5773628be$export$2e2bcd8739ae039)(selectedTo, max - 1)
            });
        }
    }
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$49c734aed8c840bb.Provider, {
        value: {
            selected: selected,
            onDayClick: onDayClick,
            modifiers: modifiers
        },
        children: children
    });
}
/**
 * Hook to access the {@link SelectRangeContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $abf3b90c3ecb9f4f$export$ad0998138eb321e7() {
    var context = (0, $kYL7Z.useContext)($abf3b90c3ecb9f4f$export$49c734aed8c840bb);
    if (!context) throw new Error('useSelectRange must be used within a SelectRangeProvider');
    return context;
}
/** Normalize to array a matcher input. */ function $abf3b90c3ecb9f4f$var$matcherToArray(matcher) {
    if (Array.isArray(matcher)) return $abf3b90c3ecb9f4f$var$__spreadArray([], matcher, true);
    else if (matcher !== undefined) return [
        matcher
    ];
    else return [];
}
/** Create CustomModifiers from dayModifiers */ function $abf3b90c3ecb9f4f$var$getCustomModifiers(dayModifiers) {
    var customModifiers = {};
    Object.entries(dayModifiers).forEach(function(_a) {
        var modifier = _a[0], matcher = _a[1];
        customModifiers[modifier] = $abf3b90c3ecb9f4f$var$matcherToArray(matcher);
    });
    return customModifiers;
}
/** The name of the modifiers that are used internally by DayPicker. */ var $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5;
(function(InternalModifier) {
    InternalModifier["Outside"] = "outside";
    /** Name of the modifier applied to the disabled days, using the `disabled` prop. */ InternalModifier["Disabled"] = "disabled";
    /** Name of the modifier applied to the selected days using the `selected` prop). */ InternalModifier["Selected"] = "selected";
    /** Name of the modifier applied to the hidden days using the `hidden` prop). */ InternalModifier["Hidden"] = "hidden";
    /** Name of the modifier applied to the day specified using the `today` prop). */ InternalModifier["Today"] = "today";
    /** The modifier applied to the day starting a selected range, when in range selection mode.  */ InternalModifier["RangeStart"] = "range_start";
    /** The modifier applied to the day ending a selected range, when in range selection mode.  */ InternalModifier["RangeEnd"] = "range_end";
    /** The modifier applied to the days between the start and the end of a selected range, when in range selection mode.  */ InternalModifier["RangeMiddle"] = "range_middle";
})($abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5 || ($abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5 = {}));
var $abf3b90c3ecb9f4f$var$Selected = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.Selected, $abf3b90c3ecb9f4f$var$Disabled = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.Disabled, $abf3b90c3ecb9f4f$var$Hidden = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.Hidden, $abf3b90c3ecb9f4f$var$Today = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.Today, $abf3b90c3ecb9f4f$var$RangeEnd = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.RangeEnd, $abf3b90c3ecb9f4f$var$RangeMiddle = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.RangeMiddle, $abf3b90c3ecb9f4f$var$RangeStart = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.RangeStart, $abf3b90c3ecb9f4f$var$Outside = $abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5.Outside;
/** Return the {@link InternalModifiers} from the DayPicker and select contexts. */ function $abf3b90c3ecb9f4f$var$getInternalModifiers(dayPicker, selectMultiple, selectRange) {
    var _a;
    var internalModifiers = (_a = {}, _a[$abf3b90c3ecb9f4f$var$Selected] = $abf3b90c3ecb9f4f$var$matcherToArray(dayPicker.selected), _a[$abf3b90c3ecb9f4f$var$Disabled] = $abf3b90c3ecb9f4f$var$matcherToArray(dayPicker.disabled), _a[$abf3b90c3ecb9f4f$var$Hidden] = $abf3b90c3ecb9f4f$var$matcherToArray(dayPicker.hidden), _a[$abf3b90c3ecb9f4f$var$Today] = [
        dayPicker.today
    ], _a[$abf3b90c3ecb9f4f$var$RangeEnd] = [], _a[$abf3b90c3ecb9f4f$var$RangeMiddle] = [], _a[$abf3b90c3ecb9f4f$var$RangeStart] = [], _a[$abf3b90c3ecb9f4f$var$Outside] = [], _a);
    if (dayPicker.fromDate) internalModifiers[$abf3b90c3ecb9f4f$var$Disabled].push({
        before: dayPicker.fromDate
    });
    if (dayPicker.toDate) internalModifiers[$abf3b90c3ecb9f4f$var$Disabled].push({
        after: dayPicker.toDate
    });
    if ($abf3b90c3ecb9f4f$export$2d8c2b43ec0e528(dayPicker)) internalModifiers[$abf3b90c3ecb9f4f$var$Disabled] = internalModifiers[$abf3b90c3ecb9f4f$var$Disabled].concat(selectMultiple.modifiers[$abf3b90c3ecb9f4f$var$Disabled]);
    else if ($abf3b90c3ecb9f4f$export$f7b9f96866ec1964(dayPicker)) {
        internalModifiers[$abf3b90c3ecb9f4f$var$Disabled] = internalModifiers[$abf3b90c3ecb9f4f$var$Disabled].concat(selectRange.modifiers[$abf3b90c3ecb9f4f$var$Disabled]);
        internalModifiers[$abf3b90c3ecb9f4f$var$RangeStart] = selectRange.modifiers[$abf3b90c3ecb9f4f$var$RangeStart];
        internalModifiers[$abf3b90c3ecb9f4f$var$RangeMiddle] = selectRange.modifiers[$abf3b90c3ecb9f4f$var$RangeMiddle];
        internalModifiers[$abf3b90c3ecb9f4f$var$RangeEnd] = selectRange.modifiers[$abf3b90c3ecb9f4f$var$RangeEnd];
    }
    return internalModifiers;
}
/** The Modifiers context store the modifiers used in DayPicker. To access the value of this context, use {@link useModifiers}. */ var $abf3b90c3ecb9f4f$var$ModifiersContext = (0, $kYL7Z.createContext)(undefined);
/** Provide the value for the {@link ModifiersContext}. */ function $abf3b90c3ecb9f4f$var$ModifiersProvider(props) {
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var selectMultiple = $abf3b90c3ecb9f4f$export$458361db477d8ed0();
    var selectRange = $abf3b90c3ecb9f4f$export$ad0998138eb321e7();
    var internalModifiers = $abf3b90c3ecb9f4f$var$getInternalModifiers(dayPicker, selectMultiple, selectRange);
    var customModifiers = $abf3b90c3ecb9f4f$var$getCustomModifiers(dayPicker.modifiers);
    var modifiers = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, internalModifiers), customModifiers);
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$ModifiersContext.Provider, {
        value: modifiers,
        children: props.children
    });
}
/**
 * Return the modifiers used by DayPicker.
 *
 * This hook is meant to be used inside internal or custom components.
 * Requires to be wrapped into {@link ModifiersProvider}.
 *
 */ function $abf3b90c3ecb9f4f$var$useModifiers() {
    var context = (0, $kYL7Z.useContext)($abf3b90c3ecb9f4f$var$ModifiersContext);
    if (!context) throw new Error('useModifiers must be used within a ModifiersProvider');
    return context;
}
/** Returns true if `matcher` is of type {@link DateInterval}. */ function $abf3b90c3ecb9f4f$export$654311eaff47f3cd(matcher) {
    return Boolean(matcher && typeof matcher === 'object' && 'before' in matcher && 'after' in matcher);
}
/** Returns true if `value` is a {@link DateRange} type. */ function $abf3b90c3ecb9f4f$export$dd455b9c98fea187(value) {
    return Boolean(value && typeof value === 'object' && 'from' in value);
}
/** Returns true if `value` is of type {@link DateAfter}. */ function $abf3b90c3ecb9f4f$export$4760905e07020cd4(value) {
    return Boolean(value && typeof value === 'object' && 'after' in value);
}
/** Returns true if `value` is of type {@link DateBefore}. */ function $abf3b90c3ecb9f4f$export$a3bef2c4e855ef4e(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
/** Returns true if `value` is a {@link DayOfWeek} type. */ function $abf3b90c3ecb9f4f$export$483c833837970a3(value) {
    return Boolean(value && typeof value === 'object' && 'dayOfWeek' in value);
}
/** Return `true` whether `date` is inside `range`. */ function $abf3b90c3ecb9f4f$var$isDateInRange(date, range) {
    var _a;
    var from = range.from, to = range.to;
    if (from && to) {
        var isRangeInverted = (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(to, from) < 0;
        if (isRangeInverted) _a = [
            to,
            from
        ], from = _a[0], to = _a[1];
        var isInRange = (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(date, from) >= 0 && (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(to, date) >= 0;
        return isInRange;
    }
    if (to) return (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(to, date);
    if (from) return (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(from, date);
    return false;
}
/** Returns true if `value` is a Date type. */ function $abf3b90c3ecb9f4f$var$isDateType(value) {
    return (0, $aa14538e33156194$export$2e2bcd8739ae039)(value);
}
/** Returns true if `value` is an array of valid dates. */ function $abf3b90c3ecb9f4f$var$isArrayOfDates(value) {
    return Array.isArray(value) && value.every((0, $aa14538e33156194$export$2e2bcd8739ae039));
}
/**
 * Returns whether a day matches against at least one of the given Matchers.
 *
 * ```
 * const day = new Date(2022, 5, 19);
 * const matcher1: DateRange = {
 *    from: new Date(2021, 12, 21),
 *    to: new Date(2021, 12, 30)
 * }
 * const matcher2: DateRange = {
 *    from: new Date(2022, 5, 1),
 *    to: new Date(2022, 5, 23)
 * }
 *
 * const isMatch(day, [matcher1, matcher2]); // true, since day is in the matcher1 range.
 * ```
 * */ function $abf3b90c3ecb9f4f$export$b74c33566721f70f(day, matchers) {
    return matchers.some(function(matcher) {
        if (typeof matcher === 'boolean') return matcher;
        if ($abf3b90c3ecb9f4f$var$isDateType(matcher)) return (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(day, matcher);
        if ($abf3b90c3ecb9f4f$var$isArrayOfDates(matcher)) return matcher.includes(day);
        if ($abf3b90c3ecb9f4f$export$dd455b9c98fea187(matcher)) return $abf3b90c3ecb9f4f$var$isDateInRange(day, matcher);
        if ($abf3b90c3ecb9f4f$export$483c833837970a3(matcher)) return matcher.dayOfWeek.includes(day.getDay());
        if ($abf3b90c3ecb9f4f$export$654311eaff47f3cd(matcher)) {
            var diffBefore = (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(matcher.before, day);
            var diffAfter = (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(matcher.after, day);
            var isDayBefore = diffBefore > 0;
            var isDayAfter = diffAfter < 0;
            var isClosedInterval = (0, $3e00ad5e5752a430$export$2e2bcd8739ae039)(matcher.before, matcher.after);
            if (isClosedInterval) return isDayAfter && isDayBefore;
            else return isDayBefore || isDayAfter;
        }
        if ($abf3b90c3ecb9f4f$export$4760905e07020cd4(matcher)) return (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(day, matcher.after) > 0;
        if ($abf3b90c3ecb9f4f$export$a3bef2c4e855ef4e(matcher)) return (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(matcher.before, day) > 0;
        if (typeof matcher === 'function') return matcher(day);
        return false;
    });
}
/** Return the active modifiers for the given day. */ function $abf3b90c3ecb9f4f$var$getActiveModifiers(day, /** The modifiers to match for the given date. */ modifiers, /** The month where the day is displayed, to add the "outside" modifiers.  */ displayMonth) {
    var matchedModifiers = Object.keys(modifiers).reduce(function(result, key) {
        var modifier = modifiers[key];
        if ($abf3b90c3ecb9f4f$export$b74c33566721f70f(day, modifier)) result.push(key);
        return result;
    }, []);
    var activeModifiers = {};
    matchedModifiers.forEach(function(modifier) {
        return activeModifiers[modifier] = true;
    });
    if (displayMonth && !(0, $748eba9a3bddca65$export$2e2bcd8739ae039)(day, displayMonth)) activeModifiers.outside = true;
    return activeModifiers;
}
/**
 * Returns the day that should be the target of the focus when DayPicker is
 * rendered the first time.
 *
 * TODO: this function doesn't consider if the day is outside the month. We
 * implemented this check in `useDayRender` but it should probably go here. See
 * https://github.com/gpbl/react-day-picker/pull/1576
 */ function $abf3b90c3ecb9f4f$var$getInitialFocusTarget(displayMonths, modifiers) {
    var firstDayInMonth = (0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(displayMonths[0]);
    var lastDayInMonth = (0, $2047aa644d00beb8$export$2e2bcd8739ae039)(displayMonths[displayMonths.length - 1]);
    // TODO: cleanup code
    var firstFocusableDay;
    var today;
    var date = firstDayInMonth;
    while(date <= lastDayInMonth){
        var activeModifiers = $abf3b90c3ecb9f4f$var$getActiveModifiers(date, modifiers);
        var isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
        if (!isFocusable) {
            date = (0, $62f69bb5773628be$export$2e2bcd8739ae039)(date, 1);
            continue;
        }
        if (activeModifiers.selected) return date;
        if (activeModifiers.today && !today) today = date;
        if (!firstFocusableDay) firstFocusableDay = date;
        date = (0, $62f69bb5773628be$export$2e2bcd8739ae039)(date, 1);
    }
    if (today) return today;
    else return firstFocusableDay;
}
var $abf3b90c3ecb9f4f$var$MAX_RETRY = 365;
/** Return the next date to be focused. */ function $abf3b90c3ecb9f4f$var$getNextFocus(focusedDay, options) {
    var moveBy = options.moveBy, direction = options.direction, context = options.context, modifiers = options.modifiers, _a = options.retry, retry = _a === void 0 ? {
        count: 0,
        lastFocused: focusedDay
    } : _a;
    var weekStartsOn = context.weekStartsOn, fromDate = context.fromDate, toDate = context.toDate, locale = context.locale;
    var moveFns = {
        day: (0, $62f69bb5773628be$export$2e2bcd8739ae039),
        week: (0, $e9019aa720e4f7d1$export$2e2bcd8739ae039),
        month: (0, $999339d7b1b67955$export$2e2bcd8739ae039),
        year: (0, $46d461f3e28778dc$export$2e2bcd8739ae039),
        startOfWeek: function(date) {
            return context.ISOWeek ? (0, $f61d1f0ea5c727e5$export$2e2bcd8739ae039)(date) : (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        },
        endOfWeek: function(date) {
            return context.ISOWeek ? (0, $5228779d4f207934$export$2e2bcd8739ae039)(date) : (0, $55faaefb20f1e937$export$2e2bcd8739ae039)(date, {
                locale: locale,
                weekStartsOn: weekStartsOn
            });
        }
    };
    var newFocusedDay = moveFns[moveBy](focusedDay, direction === 'after' ? 1 : -1);
    if (direction === 'before' && fromDate) newFocusedDay = (0, $cd00da459e6be22d$export$2e2bcd8739ae039)([
        fromDate,
        newFocusedDay
    ]);
    else if (direction === 'after' && toDate) newFocusedDay = (0, $ccfd360e901c31d4$export$2e2bcd8739ae039)([
        toDate,
        newFocusedDay
    ]);
    var isFocusable = true;
    if (modifiers) {
        var activeModifiers = $abf3b90c3ecb9f4f$var$getActiveModifiers(newFocusedDay, modifiers);
        isFocusable = !activeModifiers.disabled && !activeModifiers.hidden;
    }
    if (isFocusable) return newFocusedDay;
    else {
        if (retry.count > $abf3b90c3ecb9f4f$var$MAX_RETRY) return retry.lastFocused;
        return $abf3b90c3ecb9f4f$var$getNextFocus(newFocusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers,
            retry: $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, retry), {
                count: retry.count + 1
            })
        });
    }
}
/**
 * The Focus context shares details about the focused day for the keyboard
 *
 * Access this context from the {@link useFocusContext} hook.
 */ var $abf3b90c3ecb9f4f$export$e1f21ba6aeca320f = (0, $kYL7Z.createContext)(undefined);
/** The provider for the {@link FocusContext}. */ function $abf3b90c3ecb9f4f$export$97cf4ab9b312b61a(props) {
    var navigation = $abf3b90c3ecb9f4f$export$d0fd4b7106de2769();
    var modifiers = $abf3b90c3ecb9f4f$var$useModifiers();
    var _a = (0, $kYL7Z.useState)(), focusedDay = _a[0], setFocusedDay = _a[1];
    var _b = (0, $kYL7Z.useState)(), lastFocused = _b[0], setLastFocused = _b[1];
    var initialFocusTarget = $abf3b90c3ecb9f4f$var$getInitialFocusTarget(navigation.displayMonths, modifiers);
    // TODO: cleanup and test obscure code below
    var focusTarget = (focusedDay !== null && focusedDay !== void 0 ? focusedDay : lastFocused && navigation.isDateDisplayed(lastFocused)) ? lastFocused : initialFocusTarget;
    var blur = function() {
        setLastFocused(focusedDay);
        setFocusedDay(undefined);
    };
    var focus = function(date) {
        setFocusedDay(date);
    };
    var context = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var moveFocus = function(moveBy, direction) {
        if (!focusedDay) return;
        var nextFocused = $abf3b90c3ecb9f4f$var$getNextFocus(focusedDay, {
            moveBy: moveBy,
            direction: direction,
            context: context,
            modifiers: modifiers
        });
        if ((0, $01773c7f1dffd541$export$2e2bcd8739ae039)(focusedDay, nextFocused)) return undefined;
        navigation.goToDate(nextFocused, focusedDay);
        focus(nextFocused);
    };
    var value = {
        focusedDay: focusedDay,
        focusTarget: focusTarget,
        blur: blur,
        focus: focus,
        focusDayAfter: function() {
            return moveFocus('day', 'after');
        },
        focusDayBefore: function() {
            return moveFocus('day', 'before');
        },
        focusWeekAfter: function() {
            return moveFocus('week', 'after');
        },
        focusWeekBefore: function() {
            return moveFocus('week', 'before');
        },
        focusMonthBefore: function() {
            return moveFocus('month', 'before');
        },
        focusMonthAfter: function() {
            return moveFocus('month', 'after');
        },
        focusYearBefore: function() {
            return moveFocus('year', 'before');
        },
        focusYearAfter: function() {
            return moveFocus('year', 'after');
        },
        focusStartOfWeek: function() {
            return moveFocus('startOfWeek', 'before');
        },
        focusEndOfWeek: function() {
            return moveFocus('endOfWeek', 'after');
        }
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$e1f21ba6aeca320f.Provider, {
        value: value,
        children: props.children
    });
}
/**
 * Hook to access the {@link FocusContextValue}. Use this hook to handle the
 * focus state of the elements.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $abf3b90c3ecb9f4f$export$69130071837c676e() {
    var context = (0, $kYL7Z.useContext)($abf3b90c3ecb9f4f$export$e1f21ba6aeca320f);
    if (!context) throw new Error('useFocusContext must be used within a FocusProvider');
    return context;
}
/**
 * Return the active modifiers for the specified day.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 * @param day
 * @param displayMonth
 */ function $abf3b90c3ecb9f4f$export$174df9b23ec1eb4b(day, /**
 * The month where the date is displayed. If not the same as `date`, the day
 * is an "outside day".
 */ displayMonth) {
    var modifiers = $abf3b90c3ecb9f4f$var$useModifiers();
    var activeModifiers = $abf3b90c3ecb9f4f$var$getActiveModifiers(day, modifiers, displayMonth);
    return activeModifiers;
}
/**
 * The SelectSingle context shares details about the selected days when in
 * single selection mode.
 *
 * Access this context from the {@link useSelectSingle} hook.
 */ var $abf3b90c3ecb9f4f$export$9632b0427d86eff3 = (0, $kYL7Z.createContext)(undefined);
/** Provides the values for the {@link SelectSingleProvider}. */ function $abf3b90c3ecb9f4f$export$d40a11a5bbe785ba(props) {
    if (!$abf3b90c3ecb9f4f$export$e659ce9b264ea61(props.initialProps)) {
        var emptyContextValue = {
            selected: undefined
        };
        return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$9632b0427d86eff3.Provider, {
            value: emptyContextValue,
            children: props.children
        });
    }
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$37bf09040cff7c3b, {
        initialProps: props.initialProps,
        children: props.children
    });
}
function $abf3b90c3ecb9f4f$export$37bf09040cff7c3b(_a) {
    var initialProps = _a.initialProps, children = _a.children;
    var onDayClick = function(day, activeModifiers, e) {
        var _a, _b, _c;
        (_a = initialProps.onDayClick) === null || _a === void 0 || _a.call(initialProps, day, activeModifiers, e);
        if (activeModifiers.selected && !initialProps.required) {
            (_b = initialProps.onSelect) === null || _b === void 0 || _b.call(initialProps, undefined, day, activeModifiers, e);
            return;
        }
        (_c = initialProps.onSelect) === null || _c === void 0 || _c.call(initialProps, day, day, activeModifiers, e);
    };
    var contextValue = {
        selected: initialProps.selected,
        onDayClick: onDayClick
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$9632b0427d86eff3.Provider, {
        value: contextValue,
        children: children
    });
}
/**
 * Hook to access the {@link SelectSingleContextValue}.
 *
 * This hook is meant to be used inside internal or custom components.
 */ function $abf3b90c3ecb9f4f$export$2d75d772c98e4b05() {
    var context = (0, $kYL7Z.useContext)($abf3b90c3ecb9f4f$export$9632b0427d86eff3);
    if (!context) throw new Error('useSelectSingle must be used within a SelectSingleProvider');
    return context;
}
/**
 * This hook returns details about the content to render in the day cell.
 *
 *
 * When a day cell is rendered in the table, DayPicker can either:
 *
 * - render nothing: when the day is outside the month or has matched the
 *   "hidden" modifier.
 * - render a button when `onDayClick` or a selection mode is set.
 * - render a non-interactive element: when no selection mode is set, the day
 *   cell shouldn’t respond to any interaction. DayPicker should render a `div`
 *   or a `span`.
 *
 * ### Usage
 *
 * Use this hook to customize the behavior of the {@link Day} component. Create a
 * new `Day` component using this hook and pass it to the `components` prop.
 * The source of {@link Day} can be a good starting point.
 *
 */ function $abf3b90c3ecb9f4f$var$useDayEventHandlers(date, activeModifiers) {
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var single = $abf3b90c3ecb9f4f$export$2d75d772c98e4b05();
    var multiple = $abf3b90c3ecb9f4f$export$458361db477d8ed0();
    var range = $abf3b90c3ecb9f4f$export$ad0998138eb321e7();
    var _a = $abf3b90c3ecb9f4f$export$69130071837c676e(), focusDayAfter = _a.focusDayAfter, focusDayBefore = _a.focusDayBefore, focusWeekAfter = _a.focusWeekAfter, focusWeekBefore = _a.focusWeekBefore, blur = _a.blur, focus = _a.focus, focusMonthBefore = _a.focusMonthBefore, focusMonthAfter = _a.focusMonthAfter, focusYearBefore = _a.focusYearBefore, focusYearAfter = _a.focusYearAfter, focusStartOfWeek = _a.focusStartOfWeek, focusEndOfWeek = _a.focusEndOfWeek;
    var onClick = function(e) {
        var _a, _b, _c, _d;
        if ($abf3b90c3ecb9f4f$export$e659ce9b264ea61(dayPicker)) (_a = single.onDayClick) === null || _a === void 0 || _a.call(single, date, activeModifiers, e);
        else if ($abf3b90c3ecb9f4f$export$2d8c2b43ec0e528(dayPicker)) (_b = multiple.onDayClick) === null || _b === void 0 || _b.call(multiple, date, activeModifiers, e);
        else if ($abf3b90c3ecb9f4f$export$f7b9f96866ec1964(dayPicker)) (_c = range.onDayClick) === null || _c === void 0 || _c.call(range, date, activeModifiers, e);
        else (_d = dayPicker.onDayClick) === null || _d === void 0 || _d.call(dayPicker, date, activeModifiers, e);
    };
    var onFocus = function(e) {
        var _a;
        focus(date);
        (_a = dayPicker.onDayFocus) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onBlur = function(e) {
        var _a;
        blur();
        (_a = dayPicker.onDayBlur) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onMouseLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayMouseLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerEnter = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerEnter) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onPointerLeave = function(e) {
        var _a;
        (_a = dayPicker.onDayPointerLeave) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchCancel = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchCancel) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchEnd = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchEnd) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchMove = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchMove) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onTouchStart = function(e) {
        var _a;
        (_a = dayPicker.onDayTouchStart) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyUp = function(e) {
        var _a;
        (_a = dayPicker.onDayKeyUp) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var onKeyDown = function(e) {
        var _a;
        switch(e.key){
            case 'ArrowLeft':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayAfter() : focusDayBefore();
                break;
            case 'ArrowRight':
                e.preventDefault();
                e.stopPropagation();
                dayPicker.dir === 'rtl' ? focusDayBefore() : focusDayAfter();
                break;
            case 'ArrowDown':
                e.preventDefault();
                e.stopPropagation();
                focusWeekAfter();
                break;
            case 'ArrowUp':
                e.preventDefault();
                e.stopPropagation();
                focusWeekBefore();
                break;
            case 'PageUp':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearBefore() : focusMonthBefore();
                break;
            case 'PageDown':
                e.preventDefault();
                e.stopPropagation();
                e.shiftKey ? focusYearAfter() : focusMonthAfter();
                break;
            case 'Home':
                e.preventDefault();
                e.stopPropagation();
                focusStartOfWeek();
                break;
            case 'End':
                e.preventDefault();
                e.stopPropagation();
                focusEndOfWeek();
                break;
        }
        (_a = dayPicker.onDayKeyDown) === null || _a === void 0 || _a.call(dayPicker, date, activeModifiers, e);
    };
    var eventHandlers = {
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onKeyUp: onKeyUp,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onPointerEnter: onPointerEnter,
        onPointerLeave: onPointerLeave,
        onTouchCancel: onTouchCancel,
        onTouchEnd: onTouchEnd,
        onTouchMove: onTouchMove,
        onTouchStart: onTouchStart
    };
    return eventHandlers;
}
/**
 * Return the current selected days when DayPicker is in selection mode. Days
 * selected by the custom selection mode are not returned.
 *
 * This hook is meant to be used inside internal or custom components.
 *
 */ function $abf3b90c3ecb9f4f$var$useSelectedDays() {
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var single = $abf3b90c3ecb9f4f$export$2d75d772c98e4b05();
    var multiple = $abf3b90c3ecb9f4f$export$458361db477d8ed0();
    var range = $abf3b90c3ecb9f4f$export$ad0998138eb321e7();
    var selectedDays = $abf3b90c3ecb9f4f$export$e659ce9b264ea61(dayPicker) ? single.selected : $abf3b90c3ecb9f4f$export$2d8c2b43ec0e528(dayPicker) ? multiple.selected : $abf3b90c3ecb9f4f$export$f7b9f96866ec1964(dayPicker) ? range.selected : undefined;
    return selectedDays;
}
function $abf3b90c3ecb9f4f$var$isInternalModifier(modifier) {
    return Object.values($abf3b90c3ecb9f4f$export$7652a4f8ecc53eb5).includes(modifier);
}
/**
 * Return the class names for the Day element, according to the given active
 * modifiers.
 *
 * Custom class names are set via `modifiersClassNames` or `classNames`,
 * where the first have the precedence.
 */ function $abf3b90c3ecb9f4f$var$getDayClassNames(dayPicker, activeModifiers) {
    var classNames = [
        dayPicker.classNames.day
    ];
    Object.keys(activeModifiers).forEach(function(modifier) {
        var customClassName = dayPicker.modifiersClassNames[modifier];
        if (customClassName) classNames.push(customClassName);
        else if ($abf3b90c3ecb9f4f$var$isInternalModifier(modifier)) {
            var internalClassName = dayPicker.classNames["day_".concat(modifier)];
            if (internalClassName) classNames.push(internalClassName);
        }
    });
    return classNames;
}
/** Return the style for the Day element, according to the given active modifiers. */ function $abf3b90c3ecb9f4f$var$getDayStyle(dayPicker, activeModifiers) {
    var style = $abf3b90c3ecb9f4f$var$__assign({}, dayPicker.styles.day);
    Object.keys(activeModifiers).forEach(function(modifier) {
        var _a;
        style = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, style), (_a = dayPicker.modifiersStyles) === null || _a === void 0 ? void 0 : _a[modifier]);
    });
    return style;
}
/**
 * Return props and data used to render the {@link Day} component.
 *
 * Use this hook when creating a component to replace the built-in `Day`
 * component.
 */ function $abf3b90c3ecb9f4f$export$634dab6d85b953fc(/** The date to render. */ day, /** The month where the date is displayed (if not the same as `date`, it means it is an "outside" day). */ displayMonth, /** A ref to the button element that will be target of focus when rendered (if required). */ buttonRef) {
    var _a;
    var _b, _c;
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var focusContext = $abf3b90c3ecb9f4f$export$69130071837c676e();
    var activeModifiers = $abf3b90c3ecb9f4f$export$174df9b23ec1eb4b(day, displayMonth);
    var eventHandlers = $abf3b90c3ecb9f4f$var$useDayEventHandlers(day, activeModifiers);
    var selectedDays = $abf3b90c3ecb9f4f$var$useSelectedDays();
    var isButton = Boolean(dayPicker.onDayClick || dayPicker.mode !== 'default');
    // Focus the button if the day is focused according to the focus context
    (0, $kYL7Z.useEffect)(function() {
        var _a;
        if (activeModifiers.outside) return;
        if (!focusContext.focusedDay) return;
        if (!isButton) return;
        if ((0, $01773c7f1dffd541$export$2e2bcd8739ae039)(focusContext.focusedDay, day)) (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        focusContext.focusedDay,
        day,
        buttonRef,
        isButton,
        activeModifiers.outside
    ]);
    var className = $abf3b90c3ecb9f4f$var$getDayClassNames(dayPicker, activeModifiers).join(' ');
    var style = $abf3b90c3ecb9f4f$var$getDayStyle(dayPicker, activeModifiers);
    var isHidden = Boolean(activeModifiers.outside && !dayPicker.showOutsideDays || activeModifiers.hidden);
    var DayContentComponent = (_c = (_b = dayPicker.components) === null || _b === void 0 ? void 0 : _b.DayContent) !== null && _c !== void 0 ? _c : $abf3b90c3ecb9f4f$export$16d0634337daf8ec;
    var children = (0, $fc31e5e9fc16a880$exports.jsx)(DayContentComponent, {
        date: day,
        displayMonth: displayMonth,
        activeModifiers: activeModifiers
    });
    var divProps = {
        style: style,
        className: className,
        children: children,
        role: 'gridcell'
    };
    var isFocusTarget = focusContext.focusTarget && (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(focusContext.focusTarget, day) && !activeModifiers.outside;
    var isFocused = focusContext.focusedDay && (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(focusContext.focusedDay, day);
    var buttonProps = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, divProps), (_a = {
        disabled: activeModifiers.disabled,
        role: 'gridcell'
    }, _a['aria-selected'] = activeModifiers.selected, _a.tabIndex = isFocused || isFocusTarget ? 0 : -1, _a)), eventHandlers);
    var dayRender = {
        isButton: isButton,
        isHidden: isHidden,
        activeModifiers: activeModifiers,
        selectedDays: selectedDays,
        buttonProps: buttonProps,
        divProps: divProps
    };
    return dayRender;
}
/**
 * The content of a day cell – as a button or span element according to its
 * modifiers.
 */ function $abf3b90c3ecb9f4f$export$7a9a31a911eb9a20(props) {
    var buttonRef = (0, $kYL7Z.useRef)(null);
    var dayRender = $abf3b90c3ecb9f4f$export$634dab6d85b953fc(props.date, props.displayMonth, buttonRef);
    if (dayRender.isHidden) return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "gridcell"
    });
    if (!dayRender.isButton) return (0, $fc31e5e9fc16a880$exports.jsx)("div", $abf3b90c3ecb9f4f$var$__assign({}, dayRender.divProps));
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$353f5b6fc5456de1, $abf3b90c3ecb9f4f$var$__assign({
        name: "day",
        ref: buttonRef
    }, dayRender.buttonProps));
}
/**
 * Render the week number element. If `onWeekNumberClick` is passed to DayPicker, it
 * renders a button, otherwise a span element.
 */ function $abf3b90c3ecb9f4f$export$f52f5e0fedb732da(props) {
    var weekNumber = props.number, dates = props.dates;
    var _a = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), onWeekNumberClick = _a.onWeekNumberClick, styles = _a.styles, classNames = _a.classNames, locale = _a.locale, labelWeekNumber = _a.labels.labelWeekNumber, formatWeekNumber = _a.formatters.formatWeekNumber;
    var content = formatWeekNumber(Number(weekNumber), {
        locale: locale
    });
    if (!onWeekNumberClick) return (0, $fc31e5e9fc16a880$exports.jsx)("span", {
        className: classNames.weeknumber,
        style: styles.weeknumber,
        children: content
    });
    var label = labelWeekNumber(Number(weekNumber), {
        locale: locale
    });
    var handleClick = function(e) {
        onWeekNumberClick(weekNumber, dates, e);
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$353f5b6fc5456de1, {
        name: "week-number",
        "aria-label": label,
        className: classNames.weeknumber,
        style: styles.weeknumber,
        onClick: handleClick,
        children: content
    });
}
/** Render a row in the calendar, with the days and the week number. */ function $abf3b90c3ecb9f4f$export$b59bdbef9ce70de2(props) {
    var _a, _b;
    var _c = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), styles = _c.styles, classNames = _c.classNames, showWeekNumber = _c.showWeekNumber, components = _c.components;
    var DayComponent = (_a = components === null || components === void 0 ? void 0 : components.Day) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$7a9a31a911eb9a20;
    var WeeknumberComponent = (_b = components === null || components === void 0 ? void 0 : components.WeekNumber) !== null && _b !== void 0 ? _b : $abf3b90c3ecb9f4f$export$f52f5e0fedb732da;
    var weekNumberCell;
    if (showWeekNumber) weekNumberCell = (0, $fc31e5e9fc16a880$exports.jsx)("td", {
        className: classNames.cell,
        style: styles.cell,
        children: (0, $fc31e5e9fc16a880$exports.jsx)(WeeknumberComponent, {
            number: props.weekNumber,
            dates: props.dates
        })
    });
    return (0, $fc31e5e9fc16a880$exports.jsxs)("tr", {
        className: classNames.row,
        style: styles.row,
        children: [
            weekNumberCell,
            props.dates.map(function(date) {
                return (0, $fc31e5e9fc16a880$exports.jsx)("td", {
                    className: classNames.cell,
                    style: styles.cell,
                    role: "presentation",
                    children: (0, $fc31e5e9fc16a880$exports.jsx)(DayComponent, {
                        displayMonth: props.displayMonth,
                        date: date
                    })
                }, (0, $db1f45d5f05fb8be$export$2e2bcd8739ae039)(date));
            })
        ]
    });
}
/** Return the weeks between two dates.  */ function $abf3b90c3ecb9f4f$var$daysToMonthWeeks(fromDate, toDate, options) {
    var toWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $5228779d4f207934$export$2e2bcd8739ae039)(toDate) : (0, $55faaefb20f1e937$export$2e2bcd8739ae039)(toDate, options);
    var fromWeek = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $f61d1f0ea5c727e5$export$2e2bcd8739ae039)(fromDate) : (0, $30d2199abd040b9c$export$2e2bcd8739ae039)(fromDate, options);
    var nOfDays = (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(toWeek, fromWeek);
    var days = [];
    for(var i = 0; i <= nOfDays; i++)days.push((0, $62f69bb5773628be$export$2e2bcd8739ae039)(fromWeek, i));
    var weeksInMonth = days.reduce(function(result, date) {
        var weekNumber = (options === null || options === void 0 ? void 0 : options.ISOWeek) ? (0, $ecdf5fd614e02e51$export$2e2bcd8739ae039)(date) : (0, $34cd1079e5a47c05$export$2e2bcd8739ae039)(date, options);
        var existingWeek = result.find(function(value) {
            return value.weekNumber === weekNumber;
        });
        if (existingWeek) {
            existingWeek.dates.push(date);
            return result;
        }
        result.push({
            weekNumber: weekNumber,
            dates: [
                date
            ]
        });
        return result;
    }, []);
    return weeksInMonth;
}
/**
 * Return the weeks belonging to the given month, adding the "outside days" to
 * the first and last week.
 */ function $abf3b90c3ecb9f4f$var$getMonthWeeks(month, options) {
    var weeksInMonth = $abf3b90c3ecb9f4f$var$daysToMonthWeeks((0, $31a0c8cc128a7cb2$export$2e2bcd8739ae039)(month), (0, $2047aa644d00beb8$export$2e2bcd8739ae039)(month), options);
    if (options === null || options === void 0 ? void 0 : options.useFixedWeeks) {
        // Add extra weeks to the month, up to 6 weeks
        var nrOfMonthWeeks = (0, $aa7ec655448e331b$export$2e2bcd8739ae039)(month, options);
        if (nrOfMonthWeeks < 6) {
            var lastWeek = weeksInMonth[weeksInMonth.length - 1];
            var lastDate = lastWeek.dates[lastWeek.dates.length - 1];
            var toDate = (0, $e9019aa720e4f7d1$export$2e2bcd8739ae039)(lastDate, 6 - nrOfMonthWeeks);
            var extraWeeks = $abf3b90c3ecb9f4f$var$daysToMonthWeeks((0, $e9019aa720e4f7d1$export$2e2bcd8739ae039)(lastDate, 1), toDate, options);
            weeksInMonth.push.apply(weeksInMonth, extraWeeks);
        }
    }
    return weeksInMonth;
}
/** Render the table with the calendar. */ function $abf3b90c3ecb9f4f$var$Table(props) {
    var _a, _b, _c;
    var _d = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), locale = _d.locale, classNames = _d.classNames, styles = _d.styles, hideHead = _d.hideHead, fixedWeeks = _d.fixedWeeks, components = _d.components, weekStartsOn = _d.weekStartsOn, firstWeekContainsDate = _d.firstWeekContainsDate, ISOWeek = _d.ISOWeek;
    var weeks = $abf3b90c3ecb9f4f$var$getMonthWeeks(props.displayMonth, {
        useFixedWeeks: Boolean(fixedWeeks),
        ISOWeek: ISOWeek,
        locale: locale,
        weekStartsOn: weekStartsOn,
        firstWeekContainsDate: firstWeekContainsDate
    });
    var HeadComponent = (_a = components === null || components === void 0 ? void 0 : components.Head) !== null && _a !== void 0 ? _a : $abf3b90c3ecb9f4f$export$e93312b7773dfcac;
    var RowComponent = (_b = components === null || components === void 0 ? void 0 : components.Row) !== null && _b !== void 0 ? _b : $abf3b90c3ecb9f4f$export$b59bdbef9ce70de2;
    var FooterComponent = (_c = components === null || components === void 0 ? void 0 : components.Footer) !== null && _c !== void 0 ? _c : $abf3b90c3ecb9f4f$export$a06f1c675e846f6f;
    return (0, $fc31e5e9fc16a880$exports.jsxs)("table", {
        id: props.id,
        className: classNames.table,
        style: styles.table,
        role: "grid",
        "aria-labelledby": props['aria-labelledby'],
        children: [
            !hideHead && (0, $fc31e5e9fc16a880$exports.jsx)(HeadComponent, {}),
            (0, $fc31e5e9fc16a880$exports.jsx)("tbody", {
                className: classNames.tbody,
                style: styles.tbody,
                children: weeks.map(function(week) {
                    return (0, $fc31e5e9fc16a880$exports.jsx)(RowComponent, {
                        displayMonth: props.displayMonth,
                        dates: week.dates,
                        weekNumber: week.weekNumber
                    }, week.weekNumber);
                })
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)(FooterComponent, {
                displayMonth: props.displayMonth
            })
        ]
    });
}
/*
The MIT License (MIT)

Copyright (c) 2018-present, React Training LLC

Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ /* eslint-disable prefer-const */ /* eslint-disable @typescript-eslint/ban-ts-comment */ /*
 * Welcome to @reach/auto-id!
 * Let's see if we can make sense of why this hook exists and its
 * implementation.
 *
 * Some background:
 *   1. Accessibility APIs rely heavily on element IDs
 *   2. Requiring developers to put IDs on every element in Reach UI is both
 *      cumbersome and error-prone
 *   3. With a component model, we can generate IDs for them!
 *
 * Solution 1: Generate random IDs.
 *
 * This works great as long as you don't server render your app. When React (in
 * the client) tries to reuse the markup from the server, the IDs won't match
 * and React will then recreate the entire DOM tree.
 *
 * Solution 2: Increment an integer
 *
 * This sounds great. Since we're rendering the exact same tree on the server
 * and client, we can increment a counter and get a deterministic result between
 * client and server. Also, JS integers can go up to nine-quadrillion. I'm
 * pretty sure the tab will be closed before an app never needs
 * 10 quadrillion IDs!
 *
 * Problem solved, right?
 *
 * Ah, but there's a catch! React's concurrent rendering makes this approach
 * non-deterministic. While the client and server will end up with the same
 * elements in the end, depending on suspense boundaries (and possibly some user
 * input during the initial render) the incrementing integers won't always match
 * up.
 *
 * Solution 3: Don't use IDs at all on the server; patch after first render.
 *
 * What we've done here is solution 2 with some tricks. With this approach, the
 * ID returned is an empty string on the first render. This way the server and
 * client have the same markup no matter how wild the concurrent rendering may
 * have gotten.
 *
 * After the render, we patch up the components with an incremented ID. This
 * causes a double render on any components with `useId`. Shouldn't be a problem
 * since the components using this hook should be small, and we're only updating
 * the ID attribute on the DOM, nothing big is happening.
 *
 * It doesn't have to be an incremented number, though--we could do generate
 * random strings instead, but incrementing a number is probably the cheapest
 * thing we can do.
 *
 * Additionally, we only do this patchup on the very first client render ever.
 * Any calls to `useId` that happen dynamically in the client will be
 * populated immediately with a value. So, we only get the double render after
 * server hydration and never again, SO BACK OFF ALRIGHT?
 */ function $abf3b90c3ecb9f4f$var$canUseDOM() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}
/**
 * React currently throws a warning when using useLayoutEffect on the server. To
 * get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect in the browser. We occasionally need useLayoutEffect to
 * ensure we don't get a render flash for certain operations, but we may also
 * need affected components to render on the server. One example is when setting
 * a component's descendants to retrieve their index values.
 *
 * Important to note that using this hook as an escape hatch will break the
 * eslint dependency warnings unless you rename the import to `useLayoutEffect`.
 * Use sparingly only when the effect won't effect the rendered HTML to avoid
 * any server/client mismatch.
 *
 * If a useLayoutEffect is needed and the result would create a mismatch, it's
 * likely that the component in question shouldn't be rendered on the server at
 * all, so a better approach would be to lazily render those in a parent
 * component after client-side hydration.
 *
 * https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * https://github.com/reduxjs/react-redux/blob/master/src/utils/useIsomorphicLayoutEffect.js
 *
 * @param effect
 * @param deps
 */ var $abf3b90c3ecb9f4f$var$useIsomorphicLayoutEffect = $abf3b90c3ecb9f4f$var$canUseDOM() ? (0, $kYL7Z.useLayoutEffect) : (0, $kYL7Z.useEffect);
var $abf3b90c3ecb9f4f$var$serverHandoffComplete = false;
var $abf3b90c3ecb9f4f$var$id = 0;
function $abf3b90c3ecb9f4f$var$genId() {
    return "react-day-picker-".concat(++$abf3b90c3ecb9f4f$var$id);
}
function $abf3b90c3ecb9f4f$var$useId(providedId) {
    // TODO: Remove error flag when updating internal deps to React 18. None of
    // our tricks will play well with concurrent rendering anyway.
    var _a;
    // If this instance isn't part of the initial render, we don't have to do the
    // double render/patch-up dance. We can just generate the ID and return it.
    var initialId = providedId !== null && providedId !== void 0 ? providedId : $abf3b90c3ecb9f4f$var$serverHandoffComplete ? $abf3b90c3ecb9f4f$var$genId() : null;
    var _b = (0, $kYL7Z.useState)(initialId), id = _b[0], setId = _b[1];
    $abf3b90c3ecb9f4f$var$useIsomorphicLayoutEffect(function() {
        if (id === null) // Patch the ID after render. We do this in `useLayoutEffect` to avoid any
        // rendering flicker, though it'll make the first render slower (unlikely
        // to matter, but you're welcome to measure your app and let us know if
        // it's a problem).
        setId($abf3b90c3ecb9f4f$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $kYL7Z.useEffect)(function() {
        if ($abf3b90c3ecb9f4f$var$serverHandoffComplete === false) // Flag all future uses of `useId` to skip the update dance. This is in
        // `useEffect` because it goes after `useLayoutEffect`, ensuring we don't
        // accidentally bail out of the patch-up dance prematurely.
        $abf3b90c3ecb9f4f$var$serverHandoffComplete = true;
    }, []);
    return (_a = providedId !== null && providedId !== void 0 ? providedId : id) !== null && _a !== void 0 ? _a : undefined;
}
/** Render a month. */ function $abf3b90c3ecb9f4f$var$Month(props) {
    var _a;
    var _b;
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var dir = dayPicker.dir, classNames = dayPicker.classNames, styles = dayPicker.styles, components = dayPicker.components;
    var displayMonths = $abf3b90c3ecb9f4f$export$d0fd4b7106de2769().displayMonths;
    var captionId = $abf3b90c3ecb9f4f$var$useId(dayPicker.id ? "".concat(dayPicker.id, "-").concat(props.displayIndex) : undefined);
    var tableId = dayPicker.id ? "".concat(dayPicker.id, "-grid-").concat(props.displayIndex) : undefined;
    var className = [
        classNames.month
    ];
    var style = styles.month;
    var isStart = props.displayIndex === 0;
    var isEnd = props.displayIndex === displayMonths.length - 1;
    var isCenter = !isStart && !isEnd;
    if (dir === 'rtl') _a = [
        isStart,
        isEnd
    ], isEnd = _a[0], isStart = _a[1];
    if (isStart) {
        className.push(classNames.caption_start);
        style = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, style), styles.caption_start);
    }
    if (isEnd) {
        className.push(classNames.caption_end);
        style = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, style), styles.caption_end);
    }
    if (isCenter) {
        className.push(classNames.caption_between);
        style = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, style), styles.caption_between);
    }
    var CaptionComponent = (_b = components === null || components === void 0 ? void 0 : components.Caption) !== null && _b !== void 0 ? _b : $abf3b90c3ecb9f4f$export$32fbfacc5d962e0c;
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: className.join(' '),
        style: style,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)(CaptionComponent, {
                id: captionId,
                displayMonth: props.displayMonth,
                displayIndex: props.displayIndex
            }),
            (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$Table, {
                id: tableId,
                "aria-labelledby": captionId,
                displayMonth: props.displayMonth
            })
        ]
    }, props.displayIndex);
}
/**
 * Render the wrapper for the month grids.
 */ function $abf3b90c3ecb9f4f$export$a0ec4efdb90fa181(props) {
    var _a = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294(), classNames = _a.classNames, styles = _a.styles;
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: classNames.months,
        style: styles.months,
        children: props.children
    });
}
/** Render the container with the months according to the number of months to display. */ function $abf3b90c3ecb9f4f$var$Root(_a) {
    var _b, _c;
    var initialProps = _a.initialProps;
    var dayPicker = $abf3b90c3ecb9f4f$export$332e9e0d64b1f294();
    var focusContext = $abf3b90c3ecb9f4f$export$69130071837c676e();
    var navigation = $abf3b90c3ecb9f4f$export$d0fd4b7106de2769();
    var _d = (0, $kYL7Z.useState)(false), hasInitialFocus = _d[0], setHasInitialFocus = _d[1];
    // Focus the focus target when initialFocus is passed in
    (0, $kYL7Z.useEffect)(function() {
        if (!dayPicker.initialFocus) return;
        if (!focusContext.focusTarget) return;
        if (hasInitialFocus) return;
        focusContext.focus(focusContext.focusTarget);
        setHasInitialFocus(true);
    }, [
        dayPicker.initialFocus,
        hasInitialFocus,
        focusContext.focus,
        focusContext.focusTarget,
        focusContext
    ]);
    // Apply classnames according to props
    var classNames = [
        dayPicker.classNames.root,
        dayPicker.className
    ];
    if (dayPicker.numberOfMonths > 1) classNames.push(dayPicker.classNames.multiple_months);
    if (dayPicker.showWeekNumber) classNames.push(dayPicker.classNames.with_weeknumber);
    var style = $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, dayPicker.styles.root), dayPicker.style);
    var dataAttributes = Object.keys(initialProps).filter(function(key) {
        return key.startsWith('data-');
    }).reduce(function(attrs, key) {
        var _a;
        return $abf3b90c3ecb9f4f$var$__assign($abf3b90c3ecb9f4f$var$__assign({}, attrs), (_a = {}, _a[key] = initialProps[key], _a));
    }, {});
    var MonthsComponent = (_c = (_b = initialProps.components) === null || _b === void 0 ? void 0 : _b.Months) !== null && _c !== void 0 ? _c : $abf3b90c3ecb9f4f$export$a0ec4efdb90fa181;
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", $abf3b90c3ecb9f4f$var$__assign({
        className: classNames.join(' '),
        style: style,
        dir: dayPicker.dir,
        id: dayPicker.id,
        nonce: initialProps.nonce,
        title: initialProps.title,
        lang: initialProps.lang
    }, dataAttributes, {
        children: (0, $fc31e5e9fc16a880$exports.jsx)(MonthsComponent, {
            children: navigation.displayMonths.map(function(month, i) {
                return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$Month, {
                    displayIndex: i,
                    displayMonth: month
                }, i);
            })
        })
    }));
}
/** Provide the value for all the context providers. */ function $abf3b90c3ecb9f4f$export$8f349d07558f59c4(props) {
    var children = props.children, initialProps = $abf3b90c3ecb9f4f$var$__rest(props, [
        "children"
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$a84f964d022d25c, {
        initialProps: initialProps,
        children: (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$d91daf425539f32f, {
            children: (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$d40a11a5bbe785ba, {
                initialProps: initialProps,
                children: (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$913827019032c8d4, {
                    initialProps: initialProps,
                    children: (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$deb49a47c7ee5fdf, {
                        initialProps: initialProps,
                        children: (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$ModifiersProvider, {
                            children: (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$97cf4ab9b312b61a, {
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
}
/**
 * DayPicker render a date picker component to let users pick dates from a
 * calendar. See http://react-day-picker.js.org for updated documentation and
 * examples.
 *
 * ### Customization
 *
 * DayPicker offers different customization props. For example,
 *
 * - show multiple months using `numberOfMonths`
 * - display a dropdown to navigate the months via `captionLayout`
 * - display the week numbers with `showWeekNumbers`
 * - disable or hide days with `disabled` or `hidden`
 *
 * ### Controlling the months
 *
 * Change the initially displayed month using the `defaultMonth` prop. The
 * displayed months are controlled by DayPicker and stored in its internal
 * state. To control the months yourself, use `month` instead of `defaultMonth`
 * and use the `onMonthChange` event to set it.
 *
 * To limit the months the user can navigate to, use
 * `fromDate`/`fromMonth`/`fromYear` or `toDate`/`toMonth`/`toYear`.
 *
 * ### Selection modes
 *
 * DayPicker supports different selection mode that can be toggled using the
 * `mode` prop:
 *
 * - `mode="single"`: only one day can be selected. Use `required` to make the
 *   selection required. Use the `onSelect` event handler to get the selected
 *   days.
 * - `mode="multiple"`: users can select one or more days. Limit the amount of
 *   days that can be selected with the `min` or the `max` props.
 * - `mode="range"`: users can select a range of days. Limit the amount of days
 *   in the range with the `min` or the `max` props.
 * - `mode="default"` (default): the built-in selections are disabled. Implement
 *   your own selection mode with `onDayClick`.
 *
 * The selection modes should cover the most common use cases. In case you
 * need a more refined way of selecting days, use `mode="default"`. Use the
 * `selected` props and add the day event handlers to add/remove days from the
 * selection.
 *
 * ### Modifiers
 *
 * A _modifier_ represents different styles or states for the days displayed in
 * the calendar (like "selected" or "disabled"). Define custom modifiers using
 * the `modifiers` prop.
 *
 * ### Formatters and custom component
 *
 * You can customize how the content is displayed in the date picker by using
 * either the formatters or replacing the internal components.
 *
 * For the most common cases you want to use the `formatters` prop to change how
 * the content is formatted in the calendar. Use the `components` prop to
 * replace the internal components, like the navigation icons.
 *
 * ### Styling
 *
 * DayPicker comes with a default, basic style in `react-day-picker/style` – use
 * it as template for your own style.
 *
 * If you are using CSS modules, pass the imported styles object the
 * `classNames` props.
 *
 * You can also style the elements via inline styles using the `styles` prop.
 *
 * ### Form fields
 *
 * If you need to bind the date picker to a form field, you can use the
 * `useInput` hooks for a basic behavior. See the `useInput` source as an
 * example to bind the date picker with form fields.
 *
 * ### Localization
 *
 * To localize DayPicker, import the locale from `date-fns` package and use the
 * `locale` prop.
 *
 * For example, to use Spanish locale:
 *
 * ```
 * import { es } from 'date-fns/locale';
 * <DayPicker locale={es} />
 * ```
 */ function $abf3b90c3ecb9f4f$export$97e6db89a86ff7ab(props) {
    return (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$export$8f349d07558f59c4, $abf3b90c3ecb9f4f$var$__assign({}, props, {
        children: (0, $fc31e5e9fc16a880$exports.jsx)($abf3b90c3ecb9f4f$var$Root, {
            initialProps: props
        })
    }));
}
/** @private */ function $abf3b90c3ecb9f4f$var$isValidDate(day) {
    return !isNaN(day.getTime());
}
/** Return props and setters for binding an input field to DayPicker. */ function $abf3b90c3ecb9f4f$export$1e36b9f257eee5fa(options) {
    if (options === void 0) options = {};
    var _a = options.locale, locale = _a === void 0 ? (0, $2f071ab2ce9db9ac$export$2e2bcd8739ae039) : _a, required = options.required, _b = options.format, format$1 = _b === void 0 ? 'PP' : _b, defaultSelected = options.defaultSelected, _c = options.today, today = _c === void 0 ? new Date() : _c;
    var _d = $abf3b90c3ecb9f4f$var$parseFromToProps(options), fromDate = _d.fromDate, toDate = _d.toDate;
    // Shortcut to the DateFns functions
    var parseValue = function(value) {
        return (0, $0e24c03b34567a99$export$2e2bcd8739ae039)(value, format$1, today, {
            locale: locale
        });
    };
    // Initialize states
    var _e = (0, $kYL7Z.useState)(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today), month = _e[0], setMonth = _e[1];
    var _f = (0, $kYL7Z.useState)(defaultSelected), selectedDay = _f[0], setSelectedDay = _f[1];
    var defaultInputValue = defaultSelected ? (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(defaultSelected, format$1, {
        locale: locale
    }) : '';
    var _g = (0, $kYL7Z.useState)(defaultInputValue), inputValue = _g[0], setInputValue = _g[1];
    var reset = function() {
        setSelectedDay(defaultSelected);
        setMonth(defaultSelected !== null && defaultSelected !== void 0 ? defaultSelected : today);
        setInputValue(defaultInputValue !== null && defaultInputValue !== void 0 ? defaultInputValue : '');
    };
    var setSelected = function(date) {
        setSelectedDay(date);
        setMonth(date !== null && date !== void 0 ? date : today);
        setInputValue(date ? (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(date, format$1, {
            locale: locale
        }) : '');
    };
    var handleDayClick = function(day, _a) {
        var selected = _a.selected;
        if (!required && selected) {
            setSelectedDay(undefined);
            setInputValue('');
            return;
        }
        setSelectedDay(day);
        setInputValue(day ? (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(day, format$1, {
            locale: locale
        }) : '');
    };
    var handleMonthChange = function(month) {
        setMonth(month);
    };
    // When changing the input field, save its value in state and check if the
    // string is a valid date. If it is a valid day, set it as selected and update
    // the calendar’s month.
    var handleChange = function(e) {
        setInputValue(e.target.value);
        var day = parseValue(e.target.value);
        var isBefore = fromDate && (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(fromDate, day) > 0;
        var isAfter = toDate && (0, $fa87d08b2e22bee7$export$2e2bcd8739ae039)(day, toDate) > 0;
        if (!$abf3b90c3ecb9f4f$var$isValidDate(day) || isBefore || isAfter) {
            setSelectedDay(undefined);
            return;
        }
        setSelectedDay(day);
        setMonth(day);
    };
    // Special case for _required_ fields: on blur, if the value of the input is not
    // a valid date, reset the calendar and the input value.
    var handleBlur = function(e) {
        var day = parseValue(e.target.value);
        if (!$abf3b90c3ecb9f4f$var$isValidDate(day)) reset();
    };
    // When focusing, make sure DayPicker visualizes the month of the date in the
    // input field.
    var handleFocus = function(e) {
        if (!e.target.value) {
            reset();
            return;
        }
        var day = parseValue(e.target.value);
        if ($abf3b90c3ecb9f4f$var$isValidDate(day)) setMonth(day);
    };
    var dayPickerProps = {
        month: month,
        onDayClick: handleDayClick,
        onMonthChange: handleMonthChange,
        selected: selectedDay,
        locale: locale,
        fromDate: fromDate,
        toDate: toDate,
        today: today
    };
    var inputProps = {
        onBlur: handleBlur,
        onChange: handleChange,
        onFocus: handleFocus,
        value: inputValue,
        placeholder: (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(new Date(), format$1, {
            locale: locale
        })
    };
    return {
        dayPickerProps: dayPickerProps,
        inputProps: inputProps,
        reset: reset,
        setSelected: setSelected
    };
}
/** Returns true when the props are of type {@link DayPickerDefaultProps}. */ function $abf3b90c3ecb9f4f$export$92cab9761365b1ec(props) {
    return props.mode === undefined || props.mode === 'default';
}


/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $kYL7Z = parcelRequire("kYL7Z");


const $49b7c0a83e560886$export$2e0a83ec2e27ecbb = ({ className: className, compact: compact = false, tagName: tagName = "div", ...htmlProps })=>{
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).DIVIDER, {
        [(0, $2cfd35af7ec11fdd$exports).COMPACT]: compact
    }, className);
    return (0, $kYL7Z.createElement)(tagName, {
        ...htmlProps,
        className: classes
    });
};
$49b7c0a83e560886$export$2e0a83ec2e27ecbb.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Divider`;


var $f55168e6b9fee700$exports = {};

$parcel$export($f55168e6b9fee700$exports, "DATE_INPUT", () => $f55168e6b9fee700$export$21b0c7010c56c398);
$parcel$export($f55168e6b9fee700$exports, "DATE_INPUT_POPOVER", () => $f55168e6b9fee700$export$aa60c2e89214d4ab);
$parcel$export($f55168e6b9fee700$exports, "DATE_INPUT_TIMEZONE_SELECT", () => $f55168e6b9fee700$export$968d469526591c5d);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER", () => $f55168e6b9fee700$export$87d3ef80c69e5cc1);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER_CAPTION", () => $f55168e6b9fee700$export$a31e1b9cd9836e09);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER_CAPTION_MEASURE", () => $f55168e6b9fee700$export$2855d3bf6e693aee);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER_CONTENT", () => $f55168e6b9fee700$export$a8b74a6b21fcf4d4);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER_FOOTER", () => $f55168e6b9fee700$export$62d89cd0d3534490);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER_MONTH_SELECT", () => $f55168e6b9fee700$export$ba2c22f23c17eff8);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER_YEAR_SELECT", () => $f55168e6b9fee700$export$2500a41a6538f0b5);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER_TIMEPICKER_WRAPPER", () => $f55168e6b9fee700$export$1251bafa1ac79378);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER", () => $f55168e6b9fee700$export$c877fc42929811b7);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER_CALENDARS", () => $f55168e6b9fee700$export$e4a9115e3603205f);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER_CONTIGUOUS", () => $f55168e6b9fee700$export$f69f2a52b7630e77);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER_SINGLE_MONTH", () => $f55168e6b9fee700$export$5a3f43666b69b910);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER_SHORTCUTS", () => $f55168e6b9fee700$export$d2b224016686a2d3);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER_TIMEPICKERS", () => $f55168e6b9fee700$export$22b199419fc8b6e6);
$parcel$export($f55168e6b9fee700$exports, "DATE_RANGE_INPUT", () => $f55168e6b9fee700$export$d08e353847bf42ad);
$parcel$export($f55168e6b9fee700$exports, "DATE_RANGE_INPUT_POPOVER", () => $f55168e6b9fee700$export$96b211ec6d337576);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER", () => $f55168e6b9fee700$export$5d6b097b9c0b7454);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_ARROW_BUTTON", () => $f55168e6b9fee700$export$8b0344624f037024);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_ARROW_ROW", () => $f55168e6b9fee700$export$b05bfbd539552506);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_DIVIDER_TEXT", () => $f55168e6b9fee700$export$63c653fccb9bdc32);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_HOUR", () => $f55168e6b9fee700$export$8d60bf31be10cc99);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_INPUT", () => $f55168e6b9fee700$export$1bab70e1f8c95b6e);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_INPUT_ROW", () => $f55168e6b9fee700$export$c64489aa92c606b5);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_MILLISECOND", () => $f55168e6b9fee700$export$aaa11131f806b417);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_MINUTE", () => $f55168e6b9fee700$export$6011200e3365c34f);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_SECOND", () => $f55168e6b9fee700$export$bdd59c72d2409e69);
$parcel$export($f55168e6b9fee700$exports, "TIMEPICKER_AMPM_SELECT", () => $f55168e6b9fee700$export$10d3db9716a1e954);
$parcel$export($f55168e6b9fee700$exports, "TIMEZONE_SELECT", () => $f55168e6b9fee700$export$546afb3dc983580);
$parcel$export($f55168e6b9fee700$exports, "TIMEZONE_SELECT_POPOVER", () => $f55168e6b9fee700$export$8ae0d29e76b74639);
$parcel$export($f55168e6b9fee700$exports, "ReactDayPickerClasses", () => $f55168e6b9fee700$export$47bccc4c1757d2fa);
$parcel$export($f55168e6b9fee700$exports, "DatePickerCaptionClasses", () => $f55168e6b9fee700$export$2c4312be9e49f0e2);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_CAPTION", () => $f55168e6b9fee700$export$971e0130537b59b0);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_DROPDOWN_MONTH", () => $f55168e6b9fee700$export$a86bda37afb382ec);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_DROPDOWN_YEAR", () => $f55168e6b9fee700$export$9c6e89aff341d865);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_NAV_BUTTON", () => $f55168e6b9fee700$export$ad2eb676a0a840e9);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_NAV_BUTTON_NEXT", () => $f55168e6b9fee700$export$b2437f4c814c7f0a);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_NAV_BUTTON_PREVIOUS", () => $f55168e6b9fee700$export$81d9a5d92ff6b2a2);
$parcel$export($f55168e6b9fee700$exports, "DatePickerClasses", () => $f55168e6b9fee700$export$831e2db37c13988c);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_DAY", () => $f55168e6b9fee700$export$d38ca72a8b2f3b6c);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_DAY_DISABLED", () => $f55168e6b9fee700$export$d9bf9da1cb8dc0b);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_DAY_IS_TODAY", () => $f55168e6b9fee700$export$f9f262b58d2d99b9);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_DAY_OUTSIDE", () => $f55168e6b9fee700$export$49c6d42d34143780);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_DAY_SELECTED", () => $f55168e6b9fee700$export$aafbc6e744935736);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_HIGHLIGHT_CURRENT_DAY", () => $f55168e6b9fee700$export$b240c65a283e391b);
$parcel$export($f55168e6b9fee700$exports, "DATEPICKER3_REVERSE_MONTH_AND_YEAR", () => $f55168e6b9fee700$export$ef6b3e78ea3c78ad);
$parcel$export($f55168e6b9fee700$exports, "DateRangePickerClasses", () => $f55168e6b9fee700$export$9c60e42f22c73af5);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_HOVERED_RANGE", () => $f55168e6b9fee700$export$e78dfc4f5afa3b70);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_HOVERED_RANGE_END", () => $f55168e6b9fee700$export$e83f86ee4df19bf0);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_HOVERED_RANGE_START", () => $f55168e6b9fee700$export$f9eba3aa2123aa83);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_REVERSE_MONTH_AND_YEAR", () => $f55168e6b9fee700$export$a7ec400eb8b87ade);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_SELECTED_RANGE_END", () => $f55168e6b9fee700$export$f78929e47ce9e933);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_SELECTED_RANGE_MIDDLE", () => $f55168e6b9fee700$export$6c2850d97c819b7a);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_SELECTED_RANGE_START", () => $f55168e6b9fee700$export$d43bb14c600f1be0);
$parcel$export($f55168e6b9fee700$exports, "DATERANGEPICKER3_TIMEPICKERS_STACKED", () => $f55168e6b9fee700$export$7aec51c0e563b50f);
$parcel$export($f55168e6b9fee700$exports, "dayPickerClassNameOverrides", () => $f55168e6b9fee700$export$6585c874fa3f2c68);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

const $f55168e6b9fee700$var$NS = (0, $2cfd35af7ec11fdd$exports).getClassNamespace();
const $f55168e6b9fee700$export$21b0c7010c56c398 = `${$f55168e6b9fee700$var$NS}-date-input`;
const $f55168e6b9fee700$export$aa60c2e89214d4ab = `${$f55168e6b9fee700$var$NS}-date-input-popover`;
const $f55168e6b9fee700$export$968d469526591c5d = `${$f55168e6b9fee700$var$NS}-date-input-timezone-select`;
const $f55168e6b9fee700$export$87d3ef80c69e5cc1 = `${$f55168e6b9fee700$var$NS}-datepicker`;
const $f55168e6b9fee700$export$a31e1b9cd9836e09 = `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-caption`;
const $f55168e6b9fee700$export$2855d3bf6e693aee = `${$f55168e6b9fee700$export$a31e1b9cd9836e09}-measure`;
const $f55168e6b9fee700$export$a8b74a6b21fcf4d4 = `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-content`;
const $f55168e6b9fee700$export$62d89cd0d3534490 = `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-footer`;
const $f55168e6b9fee700$export$ba2c22f23c17eff8 = `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-month-select`;
const $f55168e6b9fee700$export$2500a41a6538f0b5 = `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-year-select`;
const $f55168e6b9fee700$export$1251bafa1ac79378 = `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-timepicker-wrapper`;
const $f55168e6b9fee700$export$c877fc42929811b7 = `${$f55168e6b9fee700$var$NS}-daterangepicker`;
const $f55168e6b9fee700$export$e4a9115e3603205f = `${$f55168e6b9fee700$export$c877fc42929811b7}-calendars`;
const $f55168e6b9fee700$export$f69f2a52b7630e77 = `${$f55168e6b9fee700$export$c877fc42929811b7}-contiguous`;
const $f55168e6b9fee700$export$5a3f43666b69b910 = `${$f55168e6b9fee700$export$c877fc42929811b7}-single-month`;
const $f55168e6b9fee700$export$d2b224016686a2d3 = `${$f55168e6b9fee700$export$c877fc42929811b7}-shortcuts`;
const $f55168e6b9fee700$export$22b199419fc8b6e6 = `${$f55168e6b9fee700$export$c877fc42929811b7}-timepickers`;
const $f55168e6b9fee700$export$d08e353847bf42ad = `${$f55168e6b9fee700$var$NS}-date-range-input`;
const $f55168e6b9fee700$export$96b211ec6d337576 = `${$f55168e6b9fee700$var$NS}-date-range-input-popover`;
const $f55168e6b9fee700$export$5d6b097b9c0b7454 = `${$f55168e6b9fee700$var$NS}-timepicker`;
const $f55168e6b9fee700$export$8b0344624f037024 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-arrow-button`;
const $f55168e6b9fee700$export$b05bfbd539552506 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-arrow-row`;
const $f55168e6b9fee700$export$63c653fccb9bdc32 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-divider-text`;
const $f55168e6b9fee700$export$8d60bf31be10cc99 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-hour`;
const $f55168e6b9fee700$export$1bab70e1f8c95b6e = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-input`;
const $f55168e6b9fee700$export$c64489aa92c606b5 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-input-row`;
const $f55168e6b9fee700$export$aaa11131f806b417 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-millisecond`;
const $f55168e6b9fee700$export$6011200e3365c34f = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-minute`;
const $f55168e6b9fee700$export$bdd59c72d2409e69 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-second`;
const $f55168e6b9fee700$export$10d3db9716a1e954 = `${$f55168e6b9fee700$export$5d6b097b9c0b7454}-ampm-select`;
const $f55168e6b9fee700$export$546afb3dc983580 = `${$f55168e6b9fee700$var$NS}-timezone-select`;
const $f55168e6b9fee700$export$8ae0d29e76b74639 = `${$f55168e6b9fee700$export$546afb3dc983580}-popover`;
const $f55168e6b9fee700$var$RDP = "rdp";
const $f55168e6b9fee700$var$RDP_DAY = `${$f55168e6b9fee700$var$RDP}-day`;
const $f55168e6b9fee700$export$47bccc4c1757d2fa = {
    RDP: $f55168e6b9fee700$var$RDP,
    RDP_CAPTION: `${$f55168e6b9fee700$var$RDP}-caption`,
    RDP_CAPTION_DROPDOWNS: `${$f55168e6b9fee700$var$RDP}-caption_dropdowns`,
    RDP_CAPTION_LABEL: `${$f55168e6b9fee700$var$RDP}-caption_label`,
    RDP_DAY: $f55168e6b9fee700$var$RDP_DAY,
    RDP_DAY_DISABLED: `${$f55168e6b9fee700$var$RDP_DAY}_disabled`,
    RDP_DAY_HOVERED_RANGE: `${$f55168e6b9fee700$var$RDP_DAY}_hovered`,
    RDP_DAY_HOVERED_RANGE_END: `${$f55168e6b9fee700$var$RDP_DAY}_hovered_end`,
    RDP_DAY_HOVERED_RANGE_START: `${$f55168e6b9fee700$var$RDP_DAY}_hovered_start`,
    RDP_DAY_OUTSIDE: `${$f55168e6b9fee700$var$RDP_DAY}_outside`,
    RDP_DAY_RANGE_END: `${$f55168e6b9fee700$var$RDP_DAY}_range_end`,
    RDP_DAY_RANGE_MIDDLE: `${$f55168e6b9fee700$var$RDP_DAY}_range_middle`,
    RDP_DAY_RANGE_START: `${$f55168e6b9fee700$var$RDP_DAY}_range_start`,
    RDP_DAY_SELECTED: `${$f55168e6b9fee700$var$RDP_DAY}_selected`,
    RDP_DAY_TODAY: `${$f55168e6b9fee700$var$RDP_DAY}_today`,
    RDP_MONTH: `${$f55168e6b9fee700$var$RDP}-month`,
    RDP_NAV: `${$f55168e6b9fee700$var$RDP}-nav`,
    RDP_TABLE: `${$f55168e6b9fee700$var$RDP}-table`,
    RDP_VHIDDEN: `${$f55168e6b9fee700$var$RDP}-vhidden`
};
const $f55168e6b9fee700$export$2c4312be9e49f0e2 = {
    DATEPICKER3_CAPTION: $f55168e6b9fee700$export$a31e1b9cd9836e09,
    DATEPICKER3_DROPDOWN_MONTH: $f55168e6b9fee700$export$ba2c22f23c17eff8,
    DATEPICKER3_DROPDOWN_YEAR: $f55168e6b9fee700$export$2500a41a6538f0b5,
    DATEPICKER3_NAV_BUTTON: `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-nav-button`,
    DATEPICKER3_NAV_BUTTON_NEXT: `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-nav-button-next`,
    DATEPICKER3_NAV_BUTTON_PREVIOUS: `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-nav-button-previous`
};
const { DATEPICKER3_CAPTION: $f55168e6b9fee700$export$971e0130537b59b0, DATEPICKER3_DROPDOWN_MONTH: $f55168e6b9fee700$export$a86bda37afb382ec, DATEPICKER3_DROPDOWN_YEAR: $f55168e6b9fee700$export$9c6e89aff341d865, DATEPICKER3_NAV_BUTTON: $f55168e6b9fee700$export$ad2eb676a0a840e9, DATEPICKER3_NAV_BUTTON_NEXT: $f55168e6b9fee700$export$b2437f4c814c7f0a, DATEPICKER3_NAV_BUTTON_PREVIOUS: $f55168e6b9fee700$export$81d9a5d92ff6b2a2 } = $f55168e6b9fee700$export$2c4312be9e49f0e2;
const $f55168e6b9fee700$export$831e2db37c13988c = {
    DATEPICKER3_DAY: $f55168e6b9fee700$var$RDP_DAY,
    DATEPICKER3_DAY_DISABLED: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_DISABLED,
    DATEPICKER3_DAY_IS_TODAY: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_TODAY,
    DATEPICKER3_DAY_OUTSIDE: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_OUTSIDE,
    DATEPICKER3_DAY_SELECTED: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_SELECTED,
    DATEPICKER3_HIGHLIGHT_CURRENT_DAY: `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-highlight-current-day`,
    DATEPICKER3_REVERSE_MONTH_AND_YEAR: `${$f55168e6b9fee700$export$87d3ef80c69e5cc1}-reverse-month-and-year`
};
const { DATEPICKER3_DAY: $f55168e6b9fee700$export$d38ca72a8b2f3b6c, DATEPICKER3_DAY_DISABLED: $f55168e6b9fee700$export$d9bf9da1cb8dc0b, DATEPICKER3_DAY_IS_TODAY: $f55168e6b9fee700$export$f9f262b58d2d99b9, DATEPICKER3_DAY_OUTSIDE: $f55168e6b9fee700$export$49c6d42d34143780, DATEPICKER3_DAY_SELECTED: $f55168e6b9fee700$export$aafbc6e744935736, DATEPICKER3_HIGHLIGHT_CURRENT_DAY: $f55168e6b9fee700$export$b240c65a283e391b, DATEPICKER3_REVERSE_MONTH_AND_YEAR: $f55168e6b9fee700$export$ef6b3e78ea3c78ad } = $f55168e6b9fee700$export$831e2db37c13988c;
const $f55168e6b9fee700$export$9c60e42f22c73af5 = {
    DATERANGEPICKER3_HOVERED_RANGE: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_HOVERED_RANGE,
    DATERANGEPICKER3_HOVERED_RANGE_END: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_HOVERED_RANGE_END,
    DATERANGEPICKER3_HOVERED_RANGE_START: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_HOVERED_RANGE_START,
    DATERANGEPICKER3_REVERSE_MONTH_AND_YEAR: `${$f55168e6b9fee700$export$c877fc42929811b7}-reverse-month-and-year`,
    DATERANGEPICKER3_SELECTED_RANGE_END: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_RANGE_END,
    DATERANGEPICKER3_SELECTED_RANGE_MIDDLE: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_RANGE_MIDDLE,
    DATERANGEPICKER3_SELECTED_RANGE_START: $f55168e6b9fee700$export$47bccc4c1757d2fa.RDP_DAY_RANGE_START,
    DATERANGEPICKER3_TIMEPICKERS_STACKED: `${$f55168e6b9fee700$export$22b199419fc8b6e6}-stacked`
};
const { DATERANGEPICKER3_HOVERED_RANGE: $f55168e6b9fee700$export$e78dfc4f5afa3b70, DATERANGEPICKER3_HOVERED_RANGE_END: $f55168e6b9fee700$export$e83f86ee4df19bf0, DATERANGEPICKER3_HOVERED_RANGE_START: $f55168e6b9fee700$export$f9eba3aa2123aa83, DATERANGEPICKER3_REVERSE_MONTH_AND_YEAR: $f55168e6b9fee700$export$a7ec400eb8b87ade, DATERANGEPICKER3_SELECTED_RANGE_END: $f55168e6b9fee700$export$f78929e47ce9e933, DATERANGEPICKER3_SELECTED_RANGE_MIDDLE: $f55168e6b9fee700$export$6c2850d97c819b7a, DATERANGEPICKER3_SELECTED_RANGE_START: $f55168e6b9fee700$export$d43bb14c600f1be0, DATERANGEPICKER3_TIMEPICKERS_STACKED: $f55168e6b9fee700$export$7aec51c0e563b50f } = $f55168e6b9fee700$export$9c60e42f22c73af5;
const $f55168e6b9fee700$export$6585c874fa3f2c68 = {
    /* eslint-disable camelcase */ button: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).BUTTON, (0, $2cfd35af7ec11fdd$exports).MINIMAL),
    // no need for button "reset" styles since the core Button styles handle that for us
    button_reset: undefined,
    dropdown_month: $f55168e6b9fee700$export$2c4312be9e49f0e2.DATEPICKER3_DROPDOWN_MONTH,
    dropdown_year: $f55168e6b9fee700$export$2c4312be9e49f0e2.DATEPICKER3_DROPDOWN_YEAR,
    nav_button: $f55168e6b9fee700$export$2c4312be9e49f0e2.DATEPICKER3_NAV_BUTTON,
    nav_button_next: $f55168e6b9fee700$export$2c4312be9e49f0e2.DATEPICKER3_NAV_BUTTON_NEXT,
    nav_button_previous: $f55168e6b9fee700$export$2c4312be9e49f0e2.DATEPICKER3_NAV_BUTTON_PREVIOUS
};

var $09de41855074c4c6$exports = {};

$parcel$export($09de41855074c4c6$exports, "clone", () => $09de41855074c4c6$export$9cd59f9826255e47);
$parcel$export($09de41855074c4c6$exports, "isDateValid", () => $09de41855074c4c6$export$2de9850507a2d6ef);
$parcel$export($09de41855074c4c6$exports, "isEqual", () => $09de41855074c4c6$export$248d38f6296296c5);
$parcel$export($09de41855074c4c6$exports, "areRangesEqual", () => $09de41855074c4c6$export$acb5fb581109da36);
$parcel$export($09de41855074c4c6$exports, "isSameMonth", () => $09de41855074c4c6$export$a18c89cbd24170ff);
$parcel$export($09de41855074c4c6$exports, "isSameTime", () => $09de41855074c4c6$export$dd2b4b46b4a2f5c9);
$parcel$export($09de41855074c4c6$exports, "isDayInRange", () => $09de41855074c4c6$export$f2613bdb239ba952);
$parcel$export($09de41855074c4c6$exports, "isDayRangeInRange", () => $09de41855074c4c6$export$fcf491bb01a09ccc);
$parcel$export($09de41855074c4c6$exports, "isMonthInRange", () => $09de41855074c4c6$export$9ae2fcb84de26ead);
$parcel$export($09de41855074c4c6$exports, "isTimeEqualOrGreaterThan", () => $09de41855074c4c6$export$877826d063769583);
$parcel$export($09de41855074c4c6$exports, "isTimeEqualOrSmallerThan", () => $09de41855074c4c6$export$4215fe90b6a2b180);
$parcel$export($09de41855074c4c6$exports, "isTimeInRange", () => $09de41855074c4c6$export$8f2f015a4a2c7583);
$parcel$export($09de41855074c4c6$exports, "getDateOnlyWithTime", () => $09de41855074c4c6$export$31510e9f72d1c46a);
$parcel$export($09de41855074c4c6$exports, "getTimeInRange", () => $09de41855074c4c6$export$7b52d8cb0b510cd6);
$parcel$export($09de41855074c4c6$exports, "isTimeSameOrAfter", () => $09de41855074c4c6$export$39b4327191dc36dc);
$parcel$export($09de41855074c4c6$exports, "getDateBetween", () => $09de41855074c4c6$export$3badae9bb8275d53);
$parcel$export($09de41855074c4c6$exports, "getDateTime", () => $09de41855074c4c6$export$2364d538c15eb8db);
$parcel$export($09de41855074c4c6$exports, "getDatePreviousMonth", () => $09de41855074c4c6$export$51800a252b427908);
$parcel$export($09de41855074c4c6$exports, "getDateNextMonth", () => $09de41855074c4c6$export$5069800e6a742b20);
$parcel$export($09de41855074c4c6$exports, "convert24HourMeridiem", () => $09de41855074c4c6$export$2aab08b965e379d9);
$parcel$export($09de41855074c4c6$exports, "getIsPmFrom24Hour", () => $09de41855074c4c6$export$bcc178a0eb0686e9);
$parcel$export($09de41855074c4c6$exports, "get12HourFrom24Hour", () => $09de41855074c4c6$export$af42c864ff109f35);
$parcel$export($09de41855074c4c6$exports, "get24HourFrom12Hour", () => $09de41855074c4c6$export$eb06a9687b5a16f2);
$parcel$export($09de41855074c4c6$exports, "isToday", () => $09de41855074c4c6$export$629b0a497aa65267);
$parcel$export($09de41855074c4c6$exports, "hasMonthChanged", () => $09de41855074c4c6$export$a12b0a6d50bf6e83);
$parcel$export($09de41855074c4c6$exports, "hasTimeChanged", () => $09de41855074c4c6$export$ccbd2dc7e8e8f730);
$parcel$export($09de41855074c4c6$exports, "isSameDay", () => $01773c7f1dffd541$export$2e2bcd8739ae039);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* istanbul ignore next */ function $82dd99df002fae2e$export$ff981a274a6046d7(range) {
    return range[0] != null && range[1] != null;
}


/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Enumeration of calendar months.
 *
 * Note that the enum values are numbers (with January as `0`) so they can be
 * easily compared to `date.getMonth()`.
 */ var $5ba851d11a036547$export$a0ec4efdb90fa181;
(function(Months) {
    Months[Months["JANUARY"] = 0] = "JANUARY";
    Months[Months["FEBRUARY"] = 1] = "FEBRUARY";
    Months[Months["MARCH"] = 2] = "MARCH";
    Months[Months["APRIL"] = 3] = "APRIL";
    Months[Months["MAY"] = 4] = "MAY";
    Months[Months["JUNE"] = 5] = "JUNE";
    Months[Months["JULY"] = 6] = "JULY";
    Months[Months["AUGUST"] = 7] = "AUGUST";
    Months[Months["SEPTEMBER"] = 8] = "SEPTEMBER";
    Months[Months["OCTOBER"] = 9] = "OCTOBER";
    Months[Months["NOVEMBER"] = 10] = "NOVEMBER";
    Months[Months["DECEMBER"] = 11] = "DECEMBER";
})($5ba851d11a036547$export$a0ec4efdb90fa181 || ($5ba851d11a036547$export$a0ec4efdb90fa181 = {}));


function $09de41855074c4c6$export$9cd59f9826255e47(d) {
    return new Date(d.getTime());
}
function $09de41855074c4c6$export$2de9850507a2d6ef(date) {
    return date instanceof Date && !isNaN(date.valueOf());
}
function $09de41855074c4c6$export$248d38f6296296c5(date1, date2) {
    if (date1 == null && date2 == null) return true;
    else if (date1 == null || date2 == null) return false;
    else return date1.getTime() === date2.getTime();
}
function $09de41855074c4c6$export$acb5fb581109da36(dateRange1, dateRange2) {
    if (dateRange1 == null && dateRange2 == null) return true;
    else if (dateRange1 == null || dateRange2 == null) return false;
    else {
        const [start1, end1] = dateRange1;
        const [start2, end2] = dateRange2;
        const areStartsEqual = start1 == null && start2 == null || start1 != null && start2 != null && (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(start1, start2);
        const areEndsEqual = end1 == null && end2 == null || end1 != null && end2 != null && (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(end1, end2);
        return areStartsEqual && areEndsEqual;
    }
}
function $09de41855074c4c6$export$a18c89cbd24170ff(date1, date2) {
    return date1 != null && date2 != null && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear();
}
function $09de41855074c4c6$export$dd2b4b46b4a2f5c9(d1, d2) {
    // N.B. do not use date-fns helper fns here, since we don't want to return false when the month/day/year is different
    return d1 != null && d2 != null && d1.getHours() === d2.getHours() && d1.getMinutes() === d2.getMinutes() && d1.getSeconds() === d2.getSeconds() && d1.getMilliseconds() === d2.getMilliseconds();
}
function $09de41855074c4c6$export$f2613bdb239ba952(date, dateRange, exclusive = false) {
    if (date == null || !(0, $82dd99df002fae2e$export$ff981a274a6046d7)(dateRange)) return false;
    const day = $09de41855074c4c6$export$9cd59f9826255e47(date);
    const start = $09de41855074c4c6$export$9cd59f9826255e47(dateRange[0]);
    const end = $09de41855074c4c6$export$9cd59f9826255e47(dateRange[1]);
    day.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return start <= day && day <= end && (!exclusive || !(0, $01773c7f1dffd541$export$2e2bcd8739ae039)(start, day) && !(0, $01773c7f1dffd541$export$2e2bcd8739ae039)(day, end));
}
function $09de41855074c4c6$export$fcf491bb01a09ccc(innerRange, outerRange) {
    return (innerRange[0] == null || $09de41855074c4c6$export$f2613bdb239ba952(innerRange[0], outerRange)) && (innerRange[1] == null || $09de41855074c4c6$export$f2613bdb239ba952(innerRange[1], outerRange));
}
function $09de41855074c4c6$export$9ae2fcb84de26ead(date, dateRange) {
    if (date == null) return false;
    if (!(0, $82dd99df002fae2e$export$ff981a274a6046d7)(dateRange)) return false;
    const day = $09de41855074c4c6$export$9cd59f9826255e47(date);
    const start = $09de41855074c4c6$export$9cd59f9826255e47(dateRange[0]);
    const end = $09de41855074c4c6$export$9cd59f9826255e47(dateRange[1]);
    day.setDate(1);
    start.setDate(1);
    end.setDate(1);
    day.setHours(0, 0, 0, 0);
    start.setHours(0, 0, 0, 0);
    end.setHours(0, 0, 0, 0);
    return start <= day && day <= end;
}
const $09de41855074c4c6$export$877826d063769583 = (time, timeToCompare)=>time.getTime() >= timeToCompare.getTime();
const $09de41855074c4c6$export$4215fe90b6a2b180 = (time, timeToCompare)=>time.getTime() <= timeToCompare.getTime();
function $09de41855074c4c6$export$8f2f015a4a2c7583(date, minDate, maxDate) {
    const time = $09de41855074c4c6$export$31510e9f72d1c46a(date);
    const minTime = $09de41855074c4c6$export$31510e9f72d1c46a(minDate);
    const maxTime = $09de41855074c4c6$export$31510e9f72d1c46a(maxDate);
    const isTimeGreaterThanMinTime = $09de41855074c4c6$export$877826d063769583(time, minTime);
    const isTimeSmallerThanMaxTime = $09de41855074c4c6$export$4215fe90b6a2b180(time, maxTime);
    if ($09de41855074c4c6$export$4215fe90b6a2b180(maxTime, minTime)) return isTimeGreaterThanMinTime || isTimeSmallerThanMaxTime;
    return isTimeGreaterThanMinTime && isTimeSmallerThanMaxTime;
}
function $09de41855074c4c6$export$7b52d8cb0b510cd6(time, minTime, maxTime) {
    if ($09de41855074c4c6$export$dd2b4b46b4a2f5c9(minTime, maxTime)) return maxTime;
    else if ($09de41855074c4c6$export$8f2f015a4a2c7583(time, minTime, maxTime)) return time;
    else if ($09de41855074c4c6$export$39b4327191dc36dc(time, maxTime)) return maxTime;
    return minTime;
}
function $09de41855074c4c6$export$39b4327191dc36dc(date, dateToCompare) {
    const time = $09de41855074c4c6$export$31510e9f72d1c46a(date);
    const timeToCompare = $09de41855074c4c6$export$31510e9f72d1c46a(dateToCompare);
    return $09de41855074c4c6$export$877826d063769583(time, timeToCompare);
}
function $09de41855074c4c6$export$3badae9bb8275d53(dateRange) {
    const start = dateRange[0].getTime();
    const end = dateRange[1].getTime();
    const middle = start + (end - start) * 0.5;
    return new Date(middle);
}
function $09de41855074c4c6$export$2364d538c15eb8db(date, time) {
    if (date == null) return null;
    else if (time == null) // cannot use default argument because `null` is a common value in this package.
    return new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0);
    else return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
}
function $09de41855074c4c6$export$31510e9f72d1c46a(date) {
    return new Date(0, 0, 0, date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $09de41855074c4c6$export$51800a252b427908(date) {
    if (date.getMonth() === (0, $5ba851d11a036547$export$a0ec4efdb90fa181).JANUARY) return new Date(date.getFullYear() - 1, (0, $5ba851d11a036547$export$a0ec4efdb90fa181).DECEMBER);
    else return new Date(date.getFullYear(), date.getMonth() - 1);
}
function $09de41855074c4c6$export$5069800e6a742b20(date) {
    if (date.getMonth() === (0, $5ba851d11a036547$export$a0ec4efdb90fa181).DECEMBER) return new Date(date.getFullYear() + 1, (0, $5ba851d11a036547$export$a0ec4efdb90fa181).JANUARY);
    else return new Date(date.getFullYear(), date.getMonth() + 1);
}
function $09de41855074c4c6$export$2aab08b965e379d9(hour, toPm) {
    if (hour < 0 || hour > 23) throw new Error(`hour must be between [0,23] inclusive: got ${hour}`);
    return toPm ? hour % 12 + 12 : hour % 12;
}
function $09de41855074c4c6$export$bcc178a0eb0686e9(hour) {
    if (hour < 0 || hour > 23) throw new Error(`hour must be between [0,23] inclusive: got ${hour}`);
    return hour >= 12;
}
function $09de41855074c4c6$export$af42c864ff109f35(hour) {
    if (hour < 0 || hour > 23) throw new Error(`hour must be between [0,23] inclusive: got ${hour}`);
    const newHour = hour % 12;
    return newHour === 0 ? 12 : newHour;
}
function $09de41855074c4c6$export$eb06a9687b5a16f2(hour, isPm) {
    if (hour < 1 || hour > 12) throw new Error(`hour must be between [1,12] inclusive: got ${hour}`);
    const newHour = hour === 12 ? 0 : hour;
    return isPm ? newHour + 12 : newHour;
}
function $09de41855074c4c6$export$629b0a497aa65267(date) {
    return (0, $01773c7f1dffd541$export$2e2bcd8739ae039)(date, new Date());
}
function $09de41855074c4c6$export$a12b0a6d50bf6e83(prevDate, nextDate) {
    return prevDate == null !== (nextDate == null) || nextDate?.getMonth() !== prevDate?.getMonth();
}
function $09de41855074c4c6$export$ccbd2dc7e8e8f730(prevDate, nextDate) {
    return prevDate == null !== (nextDate == null) || nextDate?.getHours() !== prevDate?.getHours() || nextDate?.getMinutes() !== prevDate?.getMinutes() || nextDate?.getSeconds() !== prevDate?.getSeconds() || nextDate?.getMilliseconds() !== prevDate?.getMilliseconds();
}

var $b5140593a93ec51e$exports = {};

$parcel$export($b5140593a93ec51e$exports, "DATEPICKER_DEFAULT_VALUE_INVALID", () => $b5140593a93ec51e$export$55be56cf4513723a);
$parcel$export($b5140593a93ec51e$exports, "DATEPICKER_INITIAL_MONTH_INVALID", () => $b5140593a93ec51e$export$b5e6610e39bee791);
$parcel$export($b5140593a93ec51e$exports, "DATEPICKER_MAX_DATE_INVALID", () => $b5140593a93ec51e$export$e9e45e3634f5d7f7);
$parcel$export($b5140593a93ec51e$exports, "DATEPICKER_VALUE_INVALID", () => $b5140593a93ec51e$export$eafdbfad22ec0344);
$parcel$export($b5140593a93ec51e$exports, "DATERANGEPICKER_DEFAULT_VALUE_INVALID", () => $b5140593a93ec51e$export$4bc8a1f47b5c55e7);
$parcel$export($b5140593a93ec51e$exports, "DATERANGEPICKER_INITIAL_MONTH_INVALID", () => $b5140593a93ec51e$export$e1d5e8f8577b003d);
$parcel$export($b5140593a93ec51e$exports, "DATERANGEPICKER_MAX_DATE_INVALID", () => $b5140593a93ec51e$export$75f6efa4f49a2a0c);
$parcel$export($b5140593a93ec51e$exports, "DATERANGEPICKER_VALUE_INVALID", () => $b5140593a93ec51e$export$a592e42dc7320d64);
$parcel$export($b5140593a93ec51e$exports, "DATERANGEPICKER_PREFERRED_BOUNDARY_TO_MODIFY_INVALID", () => $b5140593a93ec51e$export$afa2875711ce35b6);
$parcel$export($b5140593a93ec51e$exports, "DATERANGEINPUT_NULL_VALUE", () => $b5140593a93ec51e$export$3dd6e8e65671180b);
$parcel$export($b5140593a93ec51e$exports, "DATEINPUT_INVALID_DEFAULT_TIMEZONE", () => $b5140593a93ec51e$export$3d337109aa65a3ec);
$parcel$export($b5140593a93ec51e$exports, "DATEINPUT_INVALID_TIMEZONE", () => $b5140593a93ec51e$export$aacf3e022d59f9ae);
/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b5140593a93ec51e$var$ns = "[Blueprint]";
const $b5140593a93ec51e$export$55be56cf4513723a = $b5140593a93ec51e$var$ns + ` <DatePicker> defaultValue must be within minDate and maxDate bounds.`;
const $b5140593a93ec51e$export$b5e6610e39bee791 = $b5140593a93ec51e$var$ns + ` <DatePicker> initialMonth must be within minDate and maxDate bounds.`;
const $b5140593a93ec51e$export$e9e45e3634f5d7f7 = $b5140593a93ec51e$var$ns + ` <DatePicker> maxDate must be later than minDate.`;
const $b5140593a93ec51e$export$eafdbfad22ec0344 = $b5140593a93ec51e$var$ns + ` <DatePicker> value prop must be within minDate and maxDate bounds.`;
const $b5140593a93ec51e$export$4bc8a1f47b5c55e7 = $b5140593a93ec51e$export$55be56cf4513723a.replace("DatePicker", "DateRangePicker");
const $b5140593a93ec51e$export$e1d5e8f8577b003d = $b5140593a93ec51e$export$b5e6610e39bee791.replace("DatePicker", "DateRangePicker");
const $b5140593a93ec51e$export$75f6efa4f49a2a0c = $b5140593a93ec51e$export$e9e45e3634f5d7f7.replace("DatePicker", "DateRangePicker");
const $b5140593a93ec51e$export$a592e42dc7320d64 = $b5140593a93ec51e$export$eafdbfad22ec0344.replace("DatePicker", "DateRangePicker");
const $b5140593a93ec51e$export$afa2875711ce35b6 = "<DateRangePicker> preferredBoundaryToModify must be a valid Boundary if defined.";
const $b5140593a93ec51e$export$3dd6e8e65671180b = $b5140593a93ec51e$var$ns + ` <DateRangeInput> value cannot be null. Pass undefined to clear the value and operate in` + " uncontrolled mode, or pass [null, null] to clear the value and continue operating in controlled mode.";
const $b5140593a93ec51e$export$3d337109aa65a3ec = `${$b5140593a93ec51e$var$ns} <DateInput> was provided an invalid defaultTimezone, defaulting to Etc/UTC instead`;
const $b5140593a93ec51e$export$aacf3e022d59f9ae = `${$b5140593a93ec51e$var$ns} <DateInput> was provided an invalid timezone, defaulting to Etc/UTC instead`;

var $aa39204287ac49ac$exports = {};

$parcel$export($aa39204287ac49ac$exports, "getIsoEquivalentWithUpdatedTimezone", () => $aa39204287ac49ac$export$c6048ee619dadafb);
$parcel$export($aa39204287ac49ac$exports, "convertDateToLocalEquivalentOfTimezoneTime", () => $aa39204287ac49ac$export$2e4d7e8be3da4693);
$parcel$export($aa39204287ac49ac$exports, "getDateObjectFromIsoString", () => $aa39204287ac49ac$export$2e533f99d90f945f);
$parcel$export($aa39204287ac49ac$exports, "convertLocalDateToTimezoneTime", () => $aa39204287ac49ac$export$77e1ef3b995f9757);
$parcel$export($aa39204287ac49ac$exports, "getCurrentTimezone", () => $48d99a353d924037$export$f99097fd719b301a);
$parcel$export($aa39204287ac49ac$exports, "UTC_TIME", () => $bed1268b872d85a4$export$d71d5a588caa0b2b);
/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.

var $8889cbf1b4d1e319$exports = {};
"use strict";

var $9ucar = parcelRequire("9ucar");
var $8889cbf1b4d1e319$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty($8889cbf1b4d1e319$exports, "__esModule", {
    value: true
});
$8889cbf1b4d1e319$exports.default = $8889cbf1b4d1e319$var$cloneObject;

var $8889cbf1b4d1e319$var$_index = $8889cbf1b4d1e319$require$_interopRequireDefault((parcelRequire("bnqyM")));
function $8889cbf1b4d1e319$var$cloneObject(object) {
    return (0, $8889cbf1b4d1e319$var$_index.default)({}, object);
}
$8889cbf1b4d1e319$exports = $8889cbf1b4d1e319$exports.default;


var $89b49e4682f797f3$exports = {};
"use strict";

var $9ucar = parcelRequire("9ucar");
var $89b49e4682f797f3$require$_interopRequireDefault = $9ucar.default;
Object.defineProperty($89b49e4682f797f3$exports, "__esModule", {
    value: true
});
$89b49e4682f797f3$exports.default = $89b49e4682f797f3$var$format;

var $89b49e4682f797f3$var$_index = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("dEbHu")));

var $89b49e4682f797f3$var$_index2 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("beNeX")));

var $89b49e4682f797f3$var$_index3 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("2EcQ8")));

var $89b49e4682f797f3$var$_index4 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("l578r")));

var $89b49e4682f797f3$var$_index5 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("2rlkx")));

var $89b49e4682f797f3$var$_index6 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("fSvzV")));
var $dcf5ff4e51787ce2$exports = {};
"use strict";
Object.defineProperty($dcf5ff4e51787ce2$exports, "__esModule", {
    value: true
});
$dcf5ff4e51787ce2$exports.isProtectedDayOfYearToken = $dcf5ff4e51787ce2$var$isProtectedDayOfYearToken;
$dcf5ff4e51787ce2$exports.isProtectedWeekYearToken = $dcf5ff4e51787ce2$var$isProtectedWeekYearToken;
$dcf5ff4e51787ce2$exports.throwProtectedError = $dcf5ff4e51787ce2$var$throwProtectedError;
var $dcf5ff4e51787ce2$var$protectedDayOfYearTokens = [
    'D',
    'DD'
];
var $dcf5ff4e51787ce2$var$protectedWeekYearTokens = [
    'YY',
    'YYYY'
];
function $dcf5ff4e51787ce2$var$isProtectedDayOfYearToken(token) {
    return $dcf5ff4e51787ce2$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $dcf5ff4e51787ce2$var$isProtectedWeekYearToken(token) {
    return $dcf5ff4e51787ce2$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $dcf5ff4e51787ce2$var$throwProtectedError(token, format, input) {
    if (token === 'YYYY') throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'YY') throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'D') throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === 'DD') throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}



var $89b49e4682f797f3$var$_index8 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("3iCLV")));

var $89b49e4682f797f3$var$_index9 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("lAH9J")));

var $4fo5Z = parcelRequire("4fo5Z");

var $89b49e4682f797f3$var$_index11 = $89b49e4682f797f3$require$_interopRequireDefault((parcelRequire("eRjSO")));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $89b49e4682f797f3$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $89b49e4682f797f3$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $89b49e4682f797f3$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $89b49e4682f797f3$var$doubleQuoteRegExp = /''/g;
var $89b49e4682f797f3$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ function $89b49e4682f797f3$var$format(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $89b49e4682f797f3$var$_index9.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $4fo5Z.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : $89b49e4682f797f3$var$_index11.default;
    var firstWeekContainsDate = (0, $89b49e4682f797f3$var$_index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
    var weekStartsOn = (0, $89b49e4682f797f3$var$_index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
    if (!locale.localize) throw new RangeError('locale must contain localize property');
    if (!locale.formatLong) throw new RangeError('locale must contain formatLong property');
    var originalDate = (0, $89b49e4682f797f3$var$_index3.default)(dirtyDate);
    if (!(0, $89b49e4682f797f3$var$_index.default)(originalDate)) throw new RangeError('Invalid time value');
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $89b49e4682f797f3$var$_index6.default)(originalDate);
    var utcDate = (0, $89b49e4682f797f3$var$_index2.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($89b49e4682f797f3$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === 'p' || firstCharacter === 'P') {
            var longFormatter = $89b49e4682f797f3$var$_index5.default[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join('').match($89b49e4682f797f3$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $89b49e4682f797f3$var$cleanEscapedString(substring);
        var formatter = $89b49e4682f797f3$var$_index4.default[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $dcf5ff4e51787ce2$exports.isProtectedWeekYearToken)(substring)) (0, $dcf5ff4e51787ce2$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $dcf5ff4e51787ce2$exports.isProtectedDayOfYearToken)(substring)) (0, $dcf5ff4e51787ce2$exports.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($89b49e4682f797f3$var$unescapedLatinCharacterRegExp)) throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        return substring;
    }).join('');
    return result;
}
function $89b49e4682f797f3$var$cleanEscapedString(input) {
    var matched = input.match($89b49e4682f797f3$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($89b49e4682f797f3$var$doubleQuoteRegExp, "'");
}
$89b49e4682f797f3$exports = $89b49e4682f797f3$exports.default;


/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ function $171af30422f45bf1$export$2e2bcd8739ae039(length, date, options) {
    var dtf = $171af30422f45bf1$var$getDTF(length, options.timeZone, options.locale);
    return dtf.formatToParts ? $171af30422f45bf1$var$partsTimeZone(dtf, date) : $171af30422f45bf1$var$hackyTimeZone(dtf, date);
}
function $171af30422f45bf1$var$partsTimeZone(dtf, date) {
    var formatted = dtf.formatToParts(date);
    for(var i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
}
function $171af30422f45bf1$var$hackyTimeZone(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, '');
    var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $171af30422f45bf1$var$getDTF(length, timeZone, locale) {
    if (locale && !locale.code) throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $b85f028ee1bee499$export$2e2bcd8739ae039(date, timeZone) {
    var dtf = $b85f028ee1bee499$var$getDateTimeFormat(timeZone);
    return dtf.formatToParts ? $b85f028ee1bee499$var$partsOffset(dtf, date) : $b85f028ee1bee499$var$hackyOffset(dtf, date);
}
var $b85f028ee1bee499$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $b85f028ee1bee499$var$partsOffset(dtf, date) {
    try {
        var formatted = dtf.formatToParts(date);
        var filled = [];
        for(var i = 0; i < formatted.length; i++){
            var pos = $b85f028ee1bee499$var$typeToPos[formatted[i].type];
            if (pos >= 0) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $b85f028ee1bee499$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date);
    var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parsed[3],
        parsed[1],
        parsed[2],
        parsed[4],
        parsed[5],
        parsed[6]
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
var $b85f028ee1bee499$var$dtfCache = {};
function $b85f028ee1bee499$var$getDateTimeFormat(timeZone) {
    if (!$b85f028ee1bee499$var$dtfCache[timeZone]) {
        // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
        var testDateFormatted = new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: 'America/New_York',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }).format(new Date('2014-06-25T04:00:00.123Z'));
        var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
        $b85f028ee1bee499$var$dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
            hourCycle: 'h23',
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        }) : new Intl.DateTimeFormat('en-US', {
            hour12: false,
            timeZone: timeZone,
            year: 'numeric',
            month: 'numeric',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });
    }
    return $b85f028ee1bee499$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $529fabdb087c4aeb$export$2e2bcd8739ae039(fullYear, month, day, hour, minute, second, millisecond) {
    var utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


var $7de9fb769263987a$var$MILLISECONDS_IN_HOUR = 3600000;
var $7de9fb769263987a$var$MILLISECONDS_IN_MINUTE = 60000;
var $7de9fb769263987a$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $7de9fb769263987a$export$2e2bcd8739ae039(timezoneString, date, isUtcDate) {
    var token;
    var absoluteOffset;
    // Empty string
    if (!timezoneString) return 0;
    // Z
    token = $7de9fb769263987a$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    var hours;
    // ±hh
    token = $7de9fb769263987a$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$7de9fb769263987a$var$validateTimezone(hours)) return NaN;
        return -(hours * $7de9fb769263987a$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $7de9fb769263987a$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        var minutes = parseInt(token[3], 10);
        if (!$7de9fb769263987a$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $7de9fb769263987a$var$MILLISECONDS_IN_HOUR + minutes * $7de9fb769263987a$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($7de9fb769263987a$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        var utcDate = isUtcDate ? date : $7de9fb769263987a$var$toUtcDate(date);
        var offset = $7de9fb769263987a$var$calcOffset(utcDate, timezoneString);
        var fixedOffset = isUtcDate ? offset : $7de9fb769263987a$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $7de9fb769263987a$var$toUtcDate(date) {
    return (0, $529fabdb087c4aeb$export$2e2bcd8739ae039)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $7de9fb769263987a$var$calcOffset(date, timezoneString) {
    var tokens = (0, $b85f028ee1bee499$export$2e2bcd8739ae039)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    var asUTC = (0, $529fabdb087c4aeb$export$2e2bcd8739ae039)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    var asTS = date.getTime();
    var over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $7de9fb769263987a$var$fixOffset(date, offset, timezoneString) {
    var localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    var o2 = $7de9fb769263987a$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    var o3 = $7de9fb769263987a$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $7de9fb769263987a$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
var $7de9fb769263987a$var$validIANATimezoneCache = {};
function $7de9fb769263987a$var$isValidTimezoneIANAString(timeZoneString) {
    if ($7de9fb769263987a$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $7de9fb769263987a$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


var $e52ebd9516fbcdfb$var$MILLISECONDS_IN_MINUTE = 60000;
var $e52ebd9516fbcdfb$var$formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, localize, options) {
        var timezoneOffset = $e52ebd9516fbcdfb$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $e52ebd9516fbcdfb$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $e52ebd9516fbcdfb$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $e52ebd9516fbcdfb$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, localize, options) {
        var timezoneOffset = $e52ebd9516fbcdfb$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $e52ebd9516fbcdfb$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $e52ebd9516fbcdfb$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $e52ebd9516fbcdfb$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, localize, options) {
        var timezoneOffset = $e52ebd9516fbcdfb$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $e52ebd9516fbcdfb$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $e52ebd9516fbcdfb$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, localize, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $171af30422f45bf1$export$2e2bcd8739ae039)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $171af30422f45bf1$export$2e2bcd8739ae039)('long', date, options);
        }
    }
};
function $e52ebd9516fbcdfb$var$getTimeZoneOffset(timeZone, originalDate) {
    var timeZoneOffset = timeZone ? (0, $7de9fb769263987a$export$2e2bcd8739ae039)(timeZone, originalDate, true) / $e52ebd9516fbcdfb$var$MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $e52ebd9516fbcdfb$var$addLeadingZeros(number, targetLength) {
    var sign = number < 0 ? '-' : '';
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $e52ebd9516fbcdfb$var$formatTimezone(offset, dirtyDelimeter) {
    var delimeter = dirtyDelimeter || '';
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = $e52ebd9516fbcdfb$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    var minutes = $e52ebd9516fbcdfb$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimeter + minutes;
}
function $e52ebd9516fbcdfb$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? '-' : '+';
        return sign + $e52ebd9516fbcdfb$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $e52ebd9516fbcdfb$var$formatTimezone(offset, dirtyDelimeter);
}
function $e52ebd9516fbcdfb$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? '-' : '+';
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || '';
    return sign + String(hours) + delimiter + $e52ebd9516fbcdfb$var$addLeadingZeros(minutes, 2);
}
var $e52ebd9516fbcdfb$export$2e2bcd8739ae039 = $e52ebd9516fbcdfb$var$formatters;



var $3iCLV = parcelRequire("3iCLV");

var $fSvzV = parcelRequire("fSvzV");

/** Regex to identify the presence of a time zone specifier in a date string */ var $5a0c685e75ce492b$var$tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var $5a0c685e75ce492b$export$2e2bcd8739ae039 = $5a0c685e75ce492b$var$tzPattern;


var $4be6c8832f1f8ec9$var$MILLISECONDS_IN_HOUR = 3600000;
var $4be6c8832f1f8ec9$var$MILLISECONDS_IN_MINUTE = 60000;
var $4be6c8832f1f8ec9$var$DEFAULT_ADDITIONAL_DIGITS = 2;
var $4be6c8832f1f8ec9$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $5a0c685e75ce492b$export$2e2bcd8739ae039)
};
function $4be6c8832f1f8ec9$export$2e2bcd8739ae039(argument, dirtyOptions) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    var options = dirtyOptions || {};
    var additionalDigits = options.additionalDigits == null ? $4be6c8832f1f8ec9$var$DEFAULT_ADDITIONAL_DIGITS : (0, (/*@__PURE__*/$parcel$interopDefault($3iCLV)))(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    var dateStrings = $4be6c8832f1f8ec9$var$splitDateString(argument);
    var parseYearResult = $4be6c8832f1f8ec9$var$parseYear(dateStrings.date, additionalDigits);
    var year = parseYearResult.year;
    var restDateString = parseYearResult.restDateString;
    var date = $4be6c8832f1f8ec9$var$parseDate(restDateString, year);
    if (isNaN(date)) return new Date(NaN);
    if (date) {
        var timestamp = date.getTime();
        var time = 0;
        var offset;
        if (dateStrings.time) {
            time = $4be6c8832f1f8ec9$var$parseTime(dateStrings.time);
            if (isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $7de9fb769263987a$export$2e2bcd8739ae039)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fSvzV)))(new Date(timestamp + time));
            offset = (0, (/*@__PURE__*/$parcel$interopDefault($fSvzV)))(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $4be6c8832f1f8ec9$var$splitDateString(dateString) {
    var dateStrings = {};
    var parts = $4be6c8832f1f8ec9$var$patterns.dateTimePattern.exec(dateString);
    var timeString;
    if (!parts) {
        parts = $4be6c8832f1f8ec9$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        var token = $4be6c8832f1f8ec9$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $4be6c8832f1f8ec9$var$parseYear(dateString, additionalDigits) {
    var patternYYY = $4be6c8832f1f8ec9$var$patterns.YYY[additionalDigits];
    var patternYYYYY = $4be6c8832f1f8ec9$var$patterns.YYYYY[additionalDigits];
    var token;
    // YYYY or ±YYYYY
    token = $4be6c8832f1f8ec9$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
    if (token) {
        var yearString = token[1];
        return {
            year: parseInt(yearString, 10),
            restDateString: dateString.slice(yearString.length)
        };
    }
    // YY or ±YYY
    token = $4be6c8832f1f8ec9$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
    if (token) {
        var centuryString = token[1];
        return {
            year: parseInt(centuryString, 10) * 100,
            restDateString: dateString.slice(centuryString.length)
        };
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $4be6c8832f1f8ec9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    var token;
    var date;
    var month;
    var week;
    // YYYY
    if (dateString.length === 0) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    token = $4be6c8832f1f8ec9$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$4be6c8832f1f8ec9$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $4be6c8832f1f8ec9$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        var dayOfYear = parseInt(token[1], 10);
        if (!$4be6c8832f1f8ec9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $4be6c8832f1f8ec9$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        var day = parseInt(token[2], 10);
        if (!$4be6c8832f1f8ec9$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $4be6c8832f1f8ec9$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$4be6c8832f1f8ec9$var$validateWeekDate(year, week)) return new Date(NaN);
        return $4be6c8832f1f8ec9$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $4be6c8832f1f8ec9$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        var dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$4be6c8832f1f8ec9$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $4be6c8832f1f8ec9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $4be6c8832f1f8ec9$var$parseTime(timeString) {
    var token;
    var hours;
    var minutes;
    // hh
    token = $4be6c8832f1f8ec9$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$4be6c8832f1f8ec9$var$validateTime(hours)) return NaN;
        return hours % 24 * $4be6c8832f1f8ec9$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $4be6c8832f1f8ec9$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$4be6c8832f1f8ec9$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $4be6c8832f1f8ec9$var$MILLISECONDS_IN_HOUR + minutes * $4be6c8832f1f8ec9$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $4be6c8832f1f8ec9$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        var seconds = parseFloat(token[3].replace(',', '.'));
        if (!$4be6c8832f1f8ec9$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $4be6c8832f1f8ec9$var$MILLISECONDS_IN_HOUR + minutes * $4be6c8832f1f8ec9$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $4be6c8832f1f8ec9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
var $4be6c8832f1f8ec9$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $4be6c8832f1f8ec9$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $4be6c8832f1f8ec9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $4be6c8832f1f8ec9$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        var isLeapYear = $4be6c8832f1f8ec9$var$isLeapYearIndex(year);
        if (isLeapYear && date > $4be6c8832f1f8ec9$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $4be6c8832f1f8ec9$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $4be6c8832f1f8ec9$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    var isLeapYear = $4be6c8832f1f8ec9$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $4be6c8832f1f8ec9$var$validateWeekDate(year, week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $4be6c8832f1f8ec9$var$validateTime(hours, minutes, seconds) {
    if (hours != null && (hours < 0 || hours >= 25)) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


var $19a4fa1d425a1232$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $19a4fa1d425a1232$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, dirtyOptions) {
    var formatStr = String(dirtyFormatStr);
    var options = dirtyOptions || {};
    var matches = formatStr.match($19a4fa1d425a1232$var$tzFormattingTokensRegExp);
    if (matches) {
        var date = (0, $4be6c8832f1f8ec9$export$2e2bcd8739ae039)(options.originalDate || dirtyDate, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result // This is a quoted portion, matched only to ensure we don't match inside it
            ;
            var pos = result.indexOf(token);
            var precededByQuotedSection = result[pos - 1] === "'";
            var replaced = result.replace(token, "'" + (0, $e52ebd9516fbcdfb$export$2e2bcd8739ae039)[token[0]](date, token, null, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($89b49e4682f797f3$exports)))(dirtyDate, formatStr, options);
}




function $f645f2040b6ffaca$export$2e2bcd8739ae039(dirtyDate, timeZone, options) {
    var date = (0, $4be6c8832f1f8ec9$export$2e2bcd8739ae039)(dirtyDate, options);
    var offsetMilliseconds = (0, $7de9fb769263987a$export$2e2bcd8739ae039)(timeZone, date, true);
    var d = new Date(date.getTime() - offsetMilliseconds);
    var resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}


function $c8f159e7bcf3dd48$export$2e2bcd8739ae039(date, timeZone, formatStr, options) {
    var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8889cbf1b4d1e319$exports)))(options);
    extendedOptions.timeZone = timeZone;
    extendedOptions.originalDate = date;
    return (0, $19a4fa1d425a1232$export$2e2bcd8739ae039)((0, $f645f2040b6ffaca$export$2e2bcd8739ae039)(date, timeZone), formatStr, extendedOptions);
}



function $bbeccef20910a3be$export$2e2bcd8739ae039(timeZone, date) {
    return -(0, $7de9fb769263987a$export$2e2bcd8739ae039)(timeZone, date);
}









function $90e7b6ac8e833daa$export$2e2bcd8739ae039(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $5a0c685e75ce492b$export$2e2bcd8739ae039))) {
        var extendedOptions = (0, (/*@__PURE__*/$parcel$interopDefault($8889cbf1b4d1e319$exports)))(options);
        extendedOptions.timeZone = timeZone;
        return (0, $4be6c8832f1f8ec9$export$2e2bcd8739ae039)(date, extendedOptions);
    }
    var d = (0, $4be6c8832f1f8ec9$export$2e2bcd8739ae039)(date, options);
    var utc = (0, $529fabdb087c4aeb$export$2e2bcd8739ae039)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
    var offsetMilliseconds = (0, $7de9fb769263987a$export$2e2bcd8739ae039)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}




/*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint-disable sort-keys */ /*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $fe40b9f585d451ef$export$454fcea1a4cf5346(tz, date) {
    const offsetInMs = (0, $bbeccef20910a3be$export$2e2bcd8739ae039)(tz.ianaCode, date);
    if (isNaN(offsetInMs)) throw new Error(`Unable to lookup offset for invalid timezone '${tz.ianaCode}'`);
    const isPositiveOffset = offsetInMs >= 0;
    const offsetInMinutes = Math.abs(offsetInMs) / 1000 / 60;
    const offsetHours = Math.trunc(offsetInMinutes / 60).toString().padStart(2, "0");
    const offsetMinutes = (offsetInMinutes % 60).toString().padEnd(2, "0");
    return {
        ...tz,
        offset: `${isPositiveOffset ? "+" : "-"}${offsetHours}:${offsetMinutes}`
    };
}


const $bed1268b872d85a4$var$utcWithoutOffset = {
    label: "UTC",
    ianaCode: "Etc/UTC"
};
const $bed1268b872d85a4$export$d71d5a588caa0b2b = (0, $fe40b9f585d451ef$export$454fcea1a4cf5346)($bed1268b872d85a4$var$utcWithoutOffset);
const $bed1268b872d85a4$var$timezonesWithoutOffset = [
    $bed1268b872d85a4$var$utcWithoutOffset,
    {
        label: "Niue",
        ianaCode: "Pacific/Niue"
    },
    {
        label: "Pago Pago",
        ianaCode: "Pacific/Pago_Pago"
    },
    {
        label: "Hawaii Time",
        ianaCode: "Pacific/Honolulu"
    },
    {
        label: "Rarotonga",
        ianaCode: "Pacific/Rarotonga"
    },
    {
        label: "Tahiti",
        ianaCode: "Pacific/Tahiti"
    },
    {
        label: "Marquesas",
        ianaCode: "Pacific/Marquesas"
    },
    {
        label: "Alaska",
        ianaCode: "America/Anchorage"
    },
    {
        label: "Gambier",
        ianaCode: "Pacific/Gambier"
    },
    {
        label: "Los Angeles",
        ianaCode: "America/Los_Angeles"
    },
    {
        label: "Tijuana",
        ianaCode: "America/Tijuana"
    },
    {
        label: "Vancouver",
        ianaCode: "America/Vancouver"
    },
    {
        label: "Whitehorse",
        ianaCode: "America/Whitehorse"
    },
    {
        label: "Pitcairn",
        ianaCode: "Pacific/Pitcairn"
    },
    {
        label: "Denver",
        ianaCode: "America/Denver"
    },
    {
        label: "Arizona",
        ianaCode: "America/Phoenix"
    },
    {
        label: "Chihuahua, Mazatlan",
        ianaCode: "America/Mazatlan"
    },
    {
        label: "Dawson Creek",
        ianaCode: "America/Dawson_Creek"
    },
    {
        label: "Edmonton",
        ianaCode: "America/Edmonton"
    },
    {
        label: "Hermosillo",
        ianaCode: "America/Hermosillo"
    },
    {
        label: "Yellowknife",
        ianaCode: "America/Yellowknife"
    },
    {
        label: "Belize",
        ianaCode: "America/Belize"
    },
    {
        label: "Chicago",
        ianaCode: "America/Chicago"
    },
    {
        label: "Mexico City",
        ianaCode: "America/Mexico_City"
    },
    {
        label: "Regina",
        ianaCode: "America/Regina"
    },
    {
        label: "Tegucigalpa",
        ianaCode: "America/Tegucigalpa"
    },
    {
        label: "Winnipeg",
        ianaCode: "America/Winnipeg"
    },
    {
        label: "Costa Rica",
        ianaCode: "America/Costa_Rica"
    },
    {
        label: "El Salvador",
        ianaCode: "America/El_Salvador"
    },
    {
        label: "Galapagos",
        ianaCode: "Pacific/Galapagos"
    },
    {
        label: "Guatemala",
        ianaCode: "America/Guatemala"
    },
    {
        label: "Managua",
        ianaCode: "America/Managua"
    },
    {
        label: "America Cancun",
        ianaCode: "America/Cancun"
    },
    {
        label: "Bogota",
        ianaCode: "America/Bogota"
    },
    {
        label: "Easter Island",
        ianaCode: "Pacific/Easter"
    },
    {
        label: "New York",
        ianaCode: "America/New_York"
    },
    {
        label: "Iqaluit",
        ianaCode: "America/Iqaluit"
    },
    {
        label: "Toronto",
        ianaCode: "America/Toronto"
    },
    {
        label: "Guayaquil",
        ianaCode: "America/Guayaquil"
    },
    {
        label: "Havana",
        ianaCode: "America/Havana"
    },
    {
        label: "Jamaica",
        ianaCode: "America/Jamaica"
    },
    {
        label: "Lima",
        ianaCode: "America/Lima"
    },
    {
        label: "Nassau",
        ianaCode: "America/Nassau"
    },
    {
        label: "Panama",
        ianaCode: "America/Panama"
    },
    {
        label: "Port-au-Prince",
        ianaCode: "America/Port-au-Prince"
    },
    {
        label: "Rio Branco",
        ianaCode: "America/Rio_Branco"
    },
    {
        label: "Halifax",
        ianaCode: "America/Halifax"
    },
    {
        label: "Barbados",
        ianaCode: "America/Barbados"
    },
    {
        label: "Bermuda",
        ianaCode: "Atlantic/Bermuda"
    },
    {
        label: "Boa Vista",
        ianaCode: "America/Boa_Vista"
    },
    {
        label: "Caracas",
        ianaCode: "America/Caracas"
    },
    {
        label: "Curacao",
        ianaCode: "America/Curacao"
    },
    {
        label: "Grand Turk",
        ianaCode: "America/Grand_Turk"
    },
    {
        label: "Guyana",
        ianaCode: "America/Guyana"
    },
    {
        label: "La Paz",
        ianaCode: "America/La_Paz"
    },
    {
        label: "Manaus",
        ianaCode: "America/Manaus"
    },
    {
        label: "Martinique",
        ianaCode: "America/Martinique"
    },
    {
        label: "Port of Spain",
        ianaCode: "America/Port_of_Spain"
    },
    {
        label: "Porto Velho",
        ianaCode: "America/Porto_Velho"
    },
    {
        label: "Puerto Rico",
        ianaCode: "America/Puerto_Rico"
    },
    {
        label: "Santo Domingo",
        ianaCode: "America/Santo_Domingo"
    },
    {
        label: "Thule",
        ianaCode: "America/Thule"
    },
    {
        label: "St. Johns",
        ianaCode: "America/St_Johns"
    },
    {
        label: "Araguaina",
        ianaCode: "America/Araguaina"
    },
    {
        label: "Asuncion",
        ianaCode: "America/Asuncion"
    },
    {
        label: "Belem",
        ianaCode: "America/Belem"
    },
    {
        label: "Buenos Aires",
        ianaCode: "America/Argentina/Buenos_Aires"
    },
    {
        label: "Campo Grande",
        ianaCode: "America/Campo_Grande"
    },
    {
        label: "Cayenne",
        ianaCode: "America/Cayenne"
    },
    {
        label: "Cuiaba",
        ianaCode: "America/Cuiaba"
    },
    {
        label: "Fortaleza",
        ianaCode: "America/Fortaleza"
    },
    {
        label: "Godthab",
        ianaCode: "America/Godthab"
    },
    {
        label: "Maceio",
        ianaCode: "America/Maceio"
    },
    {
        label: "Miquelon",
        ianaCode: "America/Miquelon"
    },
    {
        label: "Montevideo",
        ianaCode: "America/Montevideo"
    },
    {
        label: "Palmer",
        ianaCode: "Antarctica/Palmer"
    },
    {
        label: "Paramaribo",
        ianaCode: "America/Paramaribo"
    },
    {
        label: "Punta Arenas",
        ianaCode: "America/Punta_Arenas"
    },
    {
        label: "Recife",
        ianaCode: "America/Recife"
    },
    {
        label: "Rothera",
        ianaCode: "Antarctica/Rothera"
    },
    {
        label: "Salvador",
        ianaCode: "America/Bahia"
    },
    {
        label: "Santiago",
        ianaCode: "America/Santiago"
    },
    {
        label: "Stanley",
        ianaCode: "Atlantic/Stanley"
    },
    {
        label: "Noronha",
        ianaCode: "America/Noronha"
    },
    {
        label: "Sao Paulo",
        ianaCode: "America/Sao_Paulo"
    },
    {
        label: "South Georgia",
        ianaCode: "Atlantic/South_Georgia"
    },
    {
        label: "Azores",
        ianaCode: "Atlantic/Azores"
    },
    {
        label: "Cape Verde",
        ianaCode: "Atlantic/Cape_Verde"
    },
    {
        label: "Scoresbysund",
        ianaCode: "America/Scoresbysund"
    },
    {
        label: "Abidjan",
        ianaCode: "Africa/Abidjan"
    },
    {
        label: "Accra",
        ianaCode: "Africa/Accra"
    },
    {
        label: "Bissau",
        ianaCode: "Africa/Bissau"
    },
    {
        label: "Canary Islands",
        ianaCode: "Atlantic/Canary"
    },
    {
        label: "Casablanca",
        ianaCode: "Africa/Casablanca"
    },
    {
        label: "Danmarkshavn",
        ianaCode: "America/Danmarkshavn"
    },
    {
        label: "Dublin",
        ianaCode: "Europe/Dublin"
    },
    {
        label: "El Aaiun",
        ianaCode: "Africa/El_Aaiun"
    },
    {
        label: "Faeroe",
        ianaCode: "Atlantic/Faroe"
    },
    {
        label: "GMT (no daylight saving)",
        ianaCode: "Etc/GMT"
    },
    {
        label: "Lisbon",
        ianaCode: "Europe/Lisbon"
    },
    {
        label: "London",
        ianaCode: "Europe/London"
    },
    {
        label: "Monrovia",
        ianaCode: "Africa/Monrovia"
    },
    {
        label: "Reykjavik",
        ianaCode: "Atlantic/Reykjavik"
    },
    {
        label: "Algiers",
        ianaCode: "Africa/Algiers"
    },
    {
        label: "Amsterdam",
        ianaCode: "Europe/Amsterdam"
    },
    {
        label: "Andorra",
        ianaCode: "Europe/Andorra"
    },
    {
        label: "Berlin",
        ianaCode: "Europe/Berlin"
    },
    {
        label: "Brussels",
        ianaCode: "Europe/Brussels"
    },
    {
        label: "Budapest",
        ianaCode: "Europe/Budapest"
    },
    {
        label: "Belgrade",
        ianaCode: "Europe/Belgrade"
    },
    {
        label: "Prague",
        ianaCode: "Europe/Prague"
    },
    {
        label: "Ceuta",
        ianaCode: "Africa/Ceuta"
    },
    {
        label: "Copenhagen",
        ianaCode: "Europe/Copenhagen"
    },
    {
        label: "Gibraltar",
        ianaCode: "Europe/Gibraltar"
    },
    {
        label: "Lagos",
        ianaCode: "Africa/Lagos"
    },
    {
        label: "Luxembourg",
        ianaCode: "Europe/Luxembourg"
    },
    {
        label: "Madrid",
        ianaCode: "Europe/Madrid"
    },
    {
        label: "Malta",
        ianaCode: "Europe/Malta"
    },
    {
        label: "Monaco",
        ianaCode: "Europe/Monaco"
    },
    {
        label: "Ndjamena",
        ianaCode: "Africa/Ndjamena"
    },
    {
        label: "Oslo",
        ianaCode: "Europe/Oslo"
    },
    {
        label: "Paris",
        ianaCode: "Europe/Paris"
    },
    {
        label: "Rome",
        ianaCode: "Europe/Rome"
    },
    {
        label: "Stockholm",
        ianaCode: "Europe/Stockholm"
    },
    {
        label: "Tirane",
        ianaCode: "Europe/Tirane"
    },
    {
        label: "Tunis",
        ianaCode: "Africa/Tunis"
    },
    {
        label: "Vienna",
        ianaCode: "Europe/Vienna"
    },
    {
        label: "Warsaw",
        ianaCode: "Europe/Warsaw"
    },
    {
        label: "Zurich",
        ianaCode: "Europe/Zurich"
    },
    {
        label: "Amman",
        ianaCode: "Asia/Amman"
    },
    {
        label: "Athens",
        ianaCode: "Europe/Athens"
    },
    {
        label: "Beirut",
        ianaCode: "Asia/Beirut"
    },
    {
        label: "Bucharest",
        ianaCode: "Europe/Bucharest"
    },
    {
        label: "Cairo",
        ianaCode: "Africa/Cairo"
    },
    {
        label: "Chisinau",
        ianaCode: "Europe/Chisinau"
    },
    {
        label: "Damascus",
        ianaCode: "Asia/Damascus"
    },
    {
        label: "Gaza",
        ianaCode: "Asia/Gaza"
    },
    {
        label: "Helsinki",
        ianaCode: "Europe/Helsinki"
    },
    {
        label: "Jerusalem",
        ianaCode: "Asia/Jerusalem"
    },
    {
        label: "Johannesburg",
        ianaCode: "Africa/Johannesburg"
    },
    {
        label: "Khartoum",
        ianaCode: "Africa/Khartoum"
    },
    {
        label: "Kyiv",
        ianaCode: "Europe/Kiev"
    },
    {
        label: "Maputo",
        ianaCode: "Africa/Maputo"
    },
    {
        label: "Kaliningrad",
        ianaCode: "Europe/Kaliningrad"
    },
    {
        label: "Nicosia",
        ianaCode: "Asia/Nicosia"
    },
    {
        label: "Riga",
        ianaCode: "Europe/Riga"
    },
    {
        label: "Sofia",
        ianaCode: "Europe/Sofia"
    },
    {
        label: "Tallinn",
        ianaCode: "Europe/Tallinn"
    },
    {
        label: "Tripoli",
        ianaCode: "Africa/Tripoli"
    },
    {
        label: "Vilnius",
        ianaCode: "Europe/Vilnius"
    },
    {
        label: "Windhoek",
        ianaCode: "Africa/Windhoek"
    },
    {
        label: "Baghdad",
        ianaCode: "Asia/Baghdad"
    },
    {
        label: "Istanbul",
        ianaCode: "Europe/Istanbul"
    },
    {
        label: "Minsk",
        ianaCode: "Europe/Minsk"
    },
    {
        label: "Moscow",
        ianaCode: "Europe/Moscow"
    },
    {
        label: "Nairobi",
        ianaCode: "Africa/Nairobi"
    },
    {
        label: "Qatar",
        ianaCode: "Asia/Qatar"
    },
    {
        label: "Riyadh",
        ianaCode: "Asia/Riyadh"
    },
    {
        label: "Syowa",
        ianaCode: "Antarctica/Syowa"
    },
    {
        label: "Tehran",
        ianaCode: "Asia/Tehran"
    },
    {
        label: "Baku",
        ianaCode: "Asia/Baku"
    },
    {
        label: "Dubai",
        ianaCode: "Asia/Dubai"
    },
    {
        label: "Mahe",
        ianaCode: "Indian/Mahe"
    },
    {
        label: "Mauritius",
        ianaCode: "Indian/Mauritius"
    },
    {
        label: "Samara",
        ianaCode: "Europe/Samara"
    },
    {
        label: "Reunion",
        ianaCode: "Indian/Reunion"
    },
    {
        label: "Tbilisi",
        ianaCode: "Asia/Tbilisi"
    },
    {
        label: "Yerevan",
        ianaCode: "Asia/Yerevan"
    },
    {
        label: "Kabul",
        ianaCode: "Asia/Kabul"
    },
    {
        label: "Aqtau",
        ianaCode: "Asia/Aqtau"
    },
    {
        label: "Aqtobe",
        ianaCode: "Asia/Aqtobe"
    },
    {
        label: "Ashgabat",
        ianaCode: "Asia/Ashgabat"
    },
    {
        label: "Dushanbe",
        ianaCode: "Asia/Dushanbe"
    },
    {
        label: "Karachi",
        ianaCode: "Asia/Karachi"
    },
    {
        label: "Kerguelen",
        ianaCode: "Indian/Kerguelen"
    },
    {
        label: "Maldives",
        ianaCode: "Indian/Maldives"
    },
    {
        label: "Mawson",
        ianaCode: "Antarctica/Mawson"
    },
    {
        label: "Yekaterinburg",
        ianaCode: "Asia/Yekaterinburg"
    },
    {
        label: "Tashkent",
        ianaCode: "Asia/Tashkent"
    },
    {
        label: "Colombo",
        ianaCode: "Asia/Colombo"
    },
    {
        label: "India - Kolkata",
        ianaCode: "Asia/Kolkata"
    },
    {
        label: "Kathmandu",
        ianaCode: "Asia/Kathmandu"
    },
    {
        label: "Almaty",
        ianaCode: "Asia/Almaty"
    },
    {
        label: "Bishkek",
        ianaCode: "Asia/Bishkek"
    },
    {
        label: "Chagos",
        ianaCode: "Indian/Chagos"
    },
    {
        label: "Dhaka",
        ianaCode: "Asia/Dhaka"
    },
    {
        label: "Omsk",
        ianaCode: "Asia/Omsk"
    },
    {
        label: "Thimphu",
        ianaCode: "Asia/Thimphu"
    },
    {
        label: "Vostok",
        ianaCode: "Antarctica/Vostok"
    },
    {
        label: "Cocos",
        ianaCode: "Indian/Cocos"
    },
    {
        label: "Rangoon",
        ianaCode: "Asia/Yangon"
    },
    {
        label: "Bangkok",
        ianaCode: "Asia/Bangkok"
    },
    {
        label: "Christmas",
        ianaCode: "Indian/Christmas"
    },
    {
        label: "Davis",
        ianaCode: "Antarctica/Davis"
    },
    {
        label: "Hanoi",
        ianaCode: "Asia/Saigon"
    },
    {
        label: "Hovd",
        ianaCode: "Asia/Hovd"
    },
    {
        label: "Jakarta",
        ianaCode: "Asia/Jakarta"
    },
    {
        label: "Moscow+04 - Krasnoyarsk",
        ianaCode: "Asia/Krasnoyarsk"
    },
    {
        label: "Brunei",
        ianaCode: "Asia/Brunei"
    },
    {
        label: "China - Beijing",
        ianaCode: "Asia/Shanghai"
    },
    {
        label: "Choibalsan",
        ianaCode: "Asia/Choibalsan"
    },
    {
        label: "Hong Kong",
        ianaCode: "Asia/Hong_Kong"
    },
    {
        label: "Kuala Lumpur",
        ianaCode: "Asia/Kuala_Lumpur"
    },
    {
        label: "Macau",
        ianaCode: "Asia/Macau"
    },
    {
        label: "Makassar",
        ianaCode: "Asia/Makassar"
    },
    {
        label: "Manila",
        ianaCode: "Asia/Manila"
    },
    {
        label: "Moscow+05 - Irkutsk",
        ianaCode: "Asia/Irkutsk"
    },
    {
        label: "Singapore",
        ianaCode: "Asia/Singapore"
    },
    {
        label: "Taipei",
        ianaCode: "Asia/Taipei"
    },
    {
        label: "Ulaanbaatar",
        ianaCode: "Asia/Ulaanbaatar"
    },
    {
        label: "Perth",
        ianaCode: "Australia/Perth"
    },
    {
        label: "Pyongyang",
        ianaCode: "Asia/Pyongyang"
    },
    {
        label: "Dili",
        ianaCode: "Asia/Dili"
    },
    {
        label: "Jayapura",
        ianaCode: "Asia/Jayapura"
    },
    {
        label: "Moscow+06 - Yakutsk",
        ianaCode: "Asia/Yakutsk"
    },
    {
        label: "Palau",
        ianaCode: "Pacific/Palau"
    },
    {
        label: "Seoul",
        ianaCode: "Asia/Seoul"
    },
    {
        label: "Tokyo",
        ianaCode: "Asia/Tokyo"
    },
    {
        label: "Darwin",
        ianaCode: "Australia/Darwin"
    },
    {
        label: "Dumont D'Urville",
        ianaCode: "Antarctica/DumontDUrville"
    },
    {
        label: "Brisbane",
        ianaCode: "Australia/Brisbane"
    },
    {
        label: "Guam",
        ianaCode: "Pacific/Guam"
    },
    {
        label: "Moscow+07 - Vladivostok",
        ianaCode: "Asia/Vladivostok"
    },
    {
        label: "Port Moresby",
        ianaCode: "Pacific/Port_Moresby"
    },
    {
        label: "Truk",
        ianaCode: "Pacific/Chuuk"
    },
    {
        label: "Adelaide",
        ianaCode: "Australia/Adelaide"
    },
    {
        label: "Casey",
        ianaCode: "Antarctica/Casey"
    },
    {
        label: "Hobart",
        ianaCode: "Australia/Hobart"
    },
    {
        label: "Melbourne, Sydney",
        ianaCode: "Australia/Sydney"
    },
    {
        label: "Efate",
        ianaCode: "Pacific/Efate"
    },
    {
        label: "Guadalcanal",
        ianaCode: "Pacific/Guadalcanal"
    },
    {
        label: "Kosrae",
        ianaCode: "Pacific/Kosrae"
    },
    {
        label: "Moscow+08 - Magadan",
        ianaCode: "Asia/Magadan"
    },
    {
        label: "Norfolk",
        ianaCode: "Pacific/Norfolk"
    },
    {
        label: "Noumea",
        ianaCode: "Pacific/Noumea"
    },
    {
        label: "Ponape",
        ianaCode: "Pacific/Pohnpei"
    },
    {
        label: "Funafuti",
        ianaCode: "Pacific/Funafuti"
    },
    {
        label: "Kwajalein",
        ianaCode: "Pacific/Kwajalein"
    },
    {
        label: "Majuro",
        ianaCode: "Pacific/Majuro"
    },
    {
        label: "Moscow+09 - Petropavlovsk-Kamchatskiy",
        ianaCode: "Asia/Kamchatka"
    },
    {
        label: "Nauru",
        ianaCode: "Pacific/Nauru"
    },
    {
        label: "Tarawa",
        ianaCode: "Pacific/Tarawa"
    },
    {
        label: "Wake",
        ianaCode: "Pacific/Wake"
    },
    {
        label: "Wallis",
        ianaCode: "Pacific/Wallis"
    },
    {
        label: "Auckland",
        ianaCode: "Pacific/Auckland"
    },
    {
        label: "Enderbury",
        ianaCode: "Pacific/Enderbury"
    },
    {
        label: "Fakaofo",
        ianaCode: "Pacific/Fakaofo"
    },
    {
        label: "Fiji",
        ianaCode: "Pacific/Fiji"
    },
    {
        label: "Tongatapu",
        ianaCode: "Pacific/Tongatapu"
    },
    {
        label: "Apia",
        ianaCode: "Pacific/Apia"
    },
    {
        label: "Kiritimati",
        ianaCode: "Pacific/Kiritimati"
    }
];
const $bed1268b872d85a4$var$minimalTimezonesWithoutOffset = [
    $bed1268b872d85a4$var$utcWithoutOffset,
    {
        label: "Pago Pago",
        ianaCode: "Pacific/Pago_Pago"
    },
    {
        label: "Hawaii Time",
        ianaCode: "Pacific/Honolulu"
    },
    {
        label: "Marquesas",
        ianaCode: "Pacific/Marquesas"
    },
    {
        label: "Alaska",
        ianaCode: "America/Anchorage"
    },
    {
        label: "Los Angeles",
        ianaCode: "America/Los_Angeles"
    },
    {
        label: "Denver",
        ianaCode: "America/Denver"
    },
    {
        label: "Mexico City",
        ianaCode: "America/Mexico_City"
    },
    {
        label: "New York",
        ianaCode: "America/New_York"
    },
    {
        label: "Puerto Rico",
        ianaCode: "America/Puerto_Rico"
    },
    {
        label: "St. Johns",
        ianaCode: "America/St_Johns"
    },
    {
        label: "Buenos Aires",
        ianaCode: "America/Argentina/Buenos_Aires"
    },
    {
        label: "Sao Paulo",
        ianaCode: "America/Sao_Paulo"
    },
    {
        label: "Cape Verde",
        ianaCode: "Atlantic/Cape_Verde"
    },
    {
        label: "Paris",
        ianaCode: "Europe/Paris"
    },
    {
        label: "Cairo",
        ianaCode: "Africa/Cairo"
    },
    {
        label: "Moscow",
        ianaCode: "Europe/Moscow"
    },
    {
        label: "Tehran",
        ianaCode: "Asia/Tehran"
    },
    {
        label: "Dubai",
        ianaCode: "Asia/Dubai"
    },
    {
        label: "Karachi",
        ianaCode: "Asia/Karachi"
    },
    {
        label: "India - Kolkata",
        ianaCode: "Asia/Kolkata"
    },
    {
        label: "Kathmandu",
        ianaCode: "Asia/Kathmandu"
    },
    {
        label: "Dhaka",
        ianaCode: "Asia/Dhaka"
    },
    {
        label: "Rangoon",
        ianaCode: "Asia/Yangon"
    },
    {
        label: "Jakarta",
        ianaCode: "Asia/Jakarta"
    },
    {
        label: "Manila",
        ianaCode: "Asia/Manila"
    },
    {
        label: "Tokyo",
        ianaCode: "Asia/Tokyo"
    },
    {
        label: "Brisbane",
        ianaCode: "Australia/Brisbane"
    },
    {
        label: "Adelaide",
        ianaCode: "Australia/Adelaide"
    },
    {
        label: "Melbourne, Sydney",
        ianaCode: "Australia/Sydney"
    },
    {
        label: "Nauru",
        ianaCode: "Pacific/Nauru"
    },
    {
        label: "Auckland",
        ianaCode: "Pacific/Auckland"
    },
    {
        label: "Kiritimati",
        ianaCode: "Pacific/Kiritimati"
    }
];
const $bed1268b872d85a4$export$69a7ced738d49d78 = $bed1268b872d85a4$var$timezonesWithoutOffset.map((tz)=>(0, $fe40b9f585d451ef$export$454fcea1a4cf5346)(tz));
const $bed1268b872d85a4$export$4fe8453b006468dc = $bed1268b872d85a4$var$minimalTimezonesWithoutOffset.map((tz)=>(0, $fe40b9f585d451ef$export$454fcea1a4cf5346)(tz));


/**
 * Keep the returned timezone constant for a page load.
 */ let $48d99a353d924037$var$memoizedTimezone = null;
function $48d99a353d924037$export$f99097fd719b301a() {
    if ($48d99a353d924037$var$memoizedTimezone === null) // Unsupported in IE, which newer Blueprint components do not support.
    // In the unlikely case that the browser API returns undefined, we default to UTC.
    // @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/resolvedOptions
    $48d99a353d924037$var$memoizedTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone ?? (0, $bed1268b872d85a4$export$d71d5a588caa0b2b).ianaCode;
    return $48d99a353d924037$var$memoizedTimezone;
}


/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $9abbf4372f2fff3e$export$3a3ade082c590099 = {
    MILLISECOND: "millisecond",
    MINUTE: "minute",
    SECOND: "second"
};



const $aa39204287ac49ac$var$NO_TIME_PRECISION = "date";
const $aa39204287ac49ac$var$TIME_FORMAT_TO_ISO_FORMAT = {
    [(0, $9abbf4372f2fff3e$export$3a3ade082c590099).MILLISECOND]: "yyyy-MM-dd'T'HH:mm:ss.SSSxxx",
    [(0, $9abbf4372f2fff3e$export$3a3ade082c590099).SECOND]: "yyyy-MM-dd'T'HH:mm:ssxxx",
    [(0, $9abbf4372f2fff3e$export$3a3ade082c590099).MINUTE]: "yyyy-MM-dd'T'HH:mmxxx",
    [$aa39204287ac49ac$var$NO_TIME_PRECISION]: "yyyy-MM-dd"
};
/**
 * @see https://github.com/marnusw/date-fns-tz#formatintimezone
 * @returns a string of tokens which tell date-fns-tz's formatInTimeZone how to render a datetime
 */ function $aa39204287ac49ac$var$getFormatStr(timePrecision) {
    return $aa39204287ac49ac$var$TIME_FORMAT_TO_ISO_FORMAT[timePrecision ?? $aa39204287ac49ac$var$NO_TIME_PRECISION];
}
function $aa39204287ac49ac$export$c6048ee619dadafb(date, timezone, timePrecision) {
    const convertedDate = $aa39204287ac49ac$export$2e4d7e8be3da4693(date, timezone);
    return (0, $c8f159e7bcf3dd48$export$2e2bcd8739ae039)(convertedDate, timezone, $aa39204287ac49ac$var$getFormatStr(timePrecision));
}
function $aa39204287ac49ac$export$2e533f99d90f945f(value, timezone) {
    if (value === undefined) return undefined;
    // This function previously used lodash.isEmpty to check for empty values, which returns true for e.g. numbers and Dates.
    // Be extra defensive and avoid breakage in case a consumer is incorrectly passing in such a value.
    if (value === null || value === "" || typeof value !== "string") return null;
    const date = new Date(value);
    // If the value is just a date format then we convert it to midnight in local time to avoid weird things happening
    if (value.length === 10) // If it's just a date, we know it's interpreted as midnight UTC so we convert it to local time of that UTC time
    return $aa39204287ac49ac$export$77e1ef3b995f9757(date, (0, $bed1268b872d85a4$export$d71d5a588caa0b2b).ianaCode);
    return $aa39204287ac49ac$export$77e1ef3b995f9757(date, timezone);
}
function $aa39204287ac49ac$export$77e1ef3b995f9757(date, newTimezone) {
    const nowUtc = (0, $90e7b6ac8e833daa$export$2e2bcd8739ae039)(date, (0, $48d99a353d924037$export$f99097fd719b301a)());
    return (0, $f645f2040b6ffaca$export$2e2bcd8739ae039)(nowUtc, newTimezone);
}
function $aa39204287ac49ac$export$2e4d7e8be3da4693(date, newTimezone) {
    const nowUtc = (0, $90e7b6ac8e833daa$export$2e2bcd8739ae039)(date, newTimezone);
    return (0, $f645f2040b6ffaca$export$2e2bcd8739ae039)(nowUtc, (0, $48d99a353d924037$export$f99097fd719b301a)());
}



/* !
 * (c) Copyright 2025 Palantir Technologies Inc. All rights reserved.
 */ /*
 * Copyright 2022 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
function $75eed77eac003d2b$export$25fe81f0e0c5bc4(date, props, ignoreRange = false) {
    if (date == null) return "";
    else if (!(0, $09de41855074c4c6$export$2de9850507a2d6ef)(date)) return props.invalidDateMessage;
    else if (ignoreRange || (0, $09de41855074c4c6$export$f2613bdb239ba952)(date, [
        props.minDate ?? null,
        props.maxDate ?? null
    ])) return props.formatDate(date, props.locale);
    else return props.outOfRangeMessage;
}


/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Measure width in pixels of a string displayed with styles provided by `className`.
 * Should only be used if measuring can't be done with existing DOM elements.
 */ function $d70f3506246018c1$export$4ea92329b673abd1(text, className = "", containerElement = document.body) {
    if (containerElement == null) return 0;
    const span = document.createElement("span");
    span.classList.add(className);
    span.textContent = text;
    containerElement.appendChild(span);
    const spanWidth = span.offsetWidth;
    span.remove();
    return spanWidth;
}
function $d70f3506246018c1$export$4c4804864409f576(str, minLength) {
    if (str.length < minLength) return `${$d70f3506246018c1$var$stringRepeat("0", minLength - str.length)}${str}`;
    else return str;
}
function $d70f3506246018c1$var$stringRepeat(str, numTimes) {
    return new Array(numTimes + 1).join(str);
}


function $18b97d6d4bac5ed8$export$8c986457644bf63f() {
    const date = new Date();
    date.setMonth(date.getMonth() + 6);
    return date;
}
function $18b97d6d4bac5ed8$export$bc4dcd8499fa2367() {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 20);
    date.setMonth((0, $5ba851d11a036547$export$a0ec4efdb90fa181).JANUARY, 1);
    return date;
}
const $18b97d6d4bac5ed8$export$44a0e25ba7c59e2 = {
    getDefaultMaxDate: $18b97d6d4bac5ed8$export$8c986457644bf63f,
    getDefaultMinDate: $18b97d6d4bac5ed8$export$bc4dcd8499fa2367,
    getFormattedDateString: $75eed77eac003d2b$export$25fe81f0e0c5bc4,
    measureTextWidth: $d70f3506246018c1$export$4ea92329b673abd1
};


const $32774f42478d4346$export$9824d860d0b120d9 = "en-US";
const $32774f42478d4346$export$c4acb27cbfd4cf71 = (0, $18b97d6d4bac5ed8$export$44a0e25ba7c59e2).getDefaultMaxDate();
const $32774f42478d4346$export$c21855736e7fcd29 = (0, $18b97d6d4bac5ed8$export$44a0e25ba7c59e2).getDefaultMinDate();
const $32774f42478d4346$export$bebd990bff7e2517 = "Invalid date";
const $32774f42478d4346$export$f33c1daa2929f92c = "Out of range";
const $32774f42478d4346$export$a7d7c1462aaf87b8 = "Overlapping dates";
const $32774f42478d4346$export$3b8cfd9c1b194028 = new Date(undefined);


/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");

async function $153b220c70ded668$export$445abbc1431dafee(localeCode) {
    try {
        const localeModule = await import(/* webpackChunkName: "date-fns-locale-[request]" */ `date-fns/locale/${localeCode}/index.js`);
        return localeModule.default;
    } catch  {
        if (!(0, $5f04c694ca05154e$exports).isNodeEnv("production")) console.error(`[Blueprint] Could not load "${localeCode}" date-fns locale, please check that this locale code is supported: https://github.com/date-fns/date-fns/tree/main/src/locale`);
        return undefined;
    }
}
function $153b220c70ded668$export$9c9152b9a11226e8(localeOrCode, dateFnsLocaleLoader = $153b220c70ded668$export$445abbc1431dafee) {
    // make sure to set the locale correctly on first render if it is available
    const [locale, setLocale] = (0, $kYL7Z.useState)(typeof localeOrCode === "object" ? localeOrCode : undefined);
    (0, $kYL7Z.useEffect)(()=>{
        setLocale((prevLocale)=>{
            if (typeof localeOrCode === "string") {
                dateFnsLocaleLoader(localeOrCode).then(setLocale);
                // keep the current locale for now, it will be updated async
                return prevLocale;
            } else return localeOrCode;
        });
    }, [
        dateFnsLocaleLoader,
        localeOrCode
    ]);
    return locale;
}


class $dd417c1d28be0aaa$export$6a33e2aa49694e12 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    // Keeping track of `isMounted` state is generally considered an anti-pattern, but since there is no way to
    // cancel/abort dyanmic ES module `import()` calls to load the date-fns locale, this is the best way to avoid
    // setting state on an unmounted component, which creates noise in the console (especially while running tests).
    // N.B. this cannot be named `isMounted` because that conflicts with a React internal property.
    isComponentMounted = false;
    // HACKHACK: type fix for setState which does not accept partial state objects in our version of
    // @types/react (v16.14.x)
    setState(nextStateOrAction, callback) {
        if (typeof nextStateOrAction === "function") super.setState(nextStateOrAction, callback);
        else super.setState(nextStateOrAction);
    }
    async componentDidMount() {
        this.isComponentMounted = true;
        await this.loadLocale(this.props.locale);
    }
    async componentDidUpdate(prevProps) {
        if (this.props.locale !== prevProps.locale) await this.loadLocale(this.props.locale);
    }
    componentWillUnmount() {
        this.isComponentMounted = false;
    }
    async loadLocale(localeOrCode) {
        if (localeOrCode === undefined) return;
        else if (this.state.locale?.code === localeOrCode) return;
        if (typeof localeOrCode === "string") {
            const loader = this.props.dateFnsLocaleLoader ?? (0, $153b220c70ded668$export$445abbc1431dafee);
            const locale = await loader(localeOrCode);
            if (this.isComponentMounted) this.setState({
                locale: locale
            });
        } else this.setState({
            locale: localeOrCode
        });
    }
}




var $kYL7Z = parcelRequire("kYL7Z");

var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $4f8aaa167bbac046$export$14643e45770079c3 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "caret-down",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M320 260C320 271 311 280 300 280H100C89 280 80 271 80 260C80 255.2 82 250.8 84.8 247.4L84.6 247.2L184.6 127.2L184.8 127.4C188.6 123 193.8 120 200 120S211.4 123 215.2 127.4L215.4 127.2L315.4 247.2L315.2 247.4C318 250.8 320 255.2 320 260z" : "M240 190C240 195.6 235.6 200 230 200H90C84.4 200 80 195.6 80 190C80 187.4 81 185.2 82.6 183.4C82.6 183.4 82.6 183.4 82.6 183.4L152.6 103.4L152.6 103.4C154.4 101.4 157 100 160 100S165.6 101.4 167.4 103.4L167.4 103.4L237.4 183.4L237.4 183.4C239 185.2 240 187.4 240 190z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$4f8aaa167bbac046$export$14643e45770079c3.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$4f8aaa167bbac046$export$14643e45770079c3.displayName = `Blueprint6.Icon.CaretDown`;
var $4f8aaa167bbac046$export$2e2bcd8739ae039 = $4f8aaa167bbac046$export$14643e45770079c3;



var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $79a0ecdde38ec5f5$export$768716ad911f292f = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "double-caret-vertical",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M100 220H300C311 220 320 229 320 240C320 244.8 318 249.2 315.2 252.6L315.4 252.8L215.4 372.8L215.2 372.6C211.4 377 206.2 380 200 380S188.6 377 184.8 372.6L184.6 372.8L84.6 252.8L84.8 252.6C82 249.2 80 244.8 80 240C80 229 89 220 100 220zM300 180H100C89 180 80 171 80 160C80 155.2 82 150.8 84.8 147.4L84.6 147.2L184.6 27.2L184.8 27.4C188.6 23 193.8 20 200 20S211.4 23 215.2 27.4L215.4 27.2L315.4 147.2L315.2 147.4C318 150.8 320 155.2 320 160C320 171 311 180 300 180z" : "M100 180H220C231 180 240 189 240 200C240 205.6 237.8 210.6 234.2 214.2L174.2 274.2C170.6 277.8 165.6 280 160 280S149.4 277.8 145.8 274.2L85.8 214.2C82.2 210.6 80 205.6 80 200C80 189 89 180 100 180zM220 140H100C89 140 80 131 80 120C80 114.4 82.2 109.4 85.8 105.8L145.8 45.8C149.4 42.2 154.4 40 160 40S170.6 42.2 174.2 45.8L234.2 105.8C237.8 109.4 240 114.4 240 120C240 131 231 140 220 140z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$79a0ecdde38ec5f5$export$768716ad911f292f.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$79a0ecdde38ec5f5$export$768716ad911f292f.displayName = `Blueprint6.Icon.DoubleCaretVertical`;
var $79a0ecdde38ec5f5$export$2e2bcd8739ae039 = $79a0ecdde38ec5f5$export$768716ad911f292f;




const $9e675beb9e64c244$export$49d2a72fcffd1efe = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { className: className, children: children, disabled: disabled, fill: fill, iconName: iconName = "double-caret-vertical", iconProps: iconProps, large: large, minimal: minimal, options: options = [], value: value, ...htmlProps } = props;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$export$c50fbf6be7ac3331), {
        [(0, $2cfd35af7ec11fdd$export$8cd212c10b4124d2)]: disabled,
        [(0, $2cfd35af7ec11fdd$export$5672a3e1deb5b505)]: fill,
        [(0, $2cfd35af7ec11fdd$export$7b93a10c0fefe3e3)]: large,
        [(0, $2cfd35af7ec11fdd$export$a61ada011bb84f5)]: minimal
    }, className);
    const iconTitle = "Open dropdown";
    const endIcon = iconName === "double-caret-vertical" ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $79a0ecdde38ec5f5$export$768716ad911f292f), {
        title: iconTitle,
        ...iconProps
    }) : (0, $fc31e5e9fc16a880$exports.jsx)((0, $4f8aaa167bbac046$export$14643e45770079c3), {
        title: iconTitle,
        ...iconProps
    });
    const optionChildren = options.map((option)=>{
        const optionProps = typeof option === "object" ? option : {
            value: option
        };
        return (0, $kYL7Z.createElement)("option", {
            ...optionProps,
            key: optionProps.value,
            children: optionProps.label || optionProps.value
        });
    });
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: classes,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsxs)("select", {
                disabled: disabled,
                ref: ref,
                value: value,
                ...htmlProps,
                multiple: false,
                children: [
                    optionChildren,
                    children
                ]
            }),
            endIcon
        ]
    });
});
$9e675beb9e64c244$export$49d2a72fcffd1efe.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.HTMLSelect`;


/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");


var $6Y6tm = parcelRequire("6Y6tm");


function $14896419bf18de0f$export$58088a1aab19b337(monthSelectElement, containerElement, displayedMonthText) {
    const [monthRightOffset, setMonthRightOffset] = (0, $kYL7Z.useState)(0);
    (0, $c7a0a0a998d4e92a$export$700979bc83e7db82)(()=>{
        if (containerElement.current == null) return;
        // measure width of text as rendered inside our container element.
        const monthTextWidth = (0, $18b97d6d4bac5ed8$export$44a0e25ba7c59e2).measureTextWidth(displayedMonthText, (0, $f55168e6b9fee700$exports).DATEPICKER_CAPTION_MEASURE, containerElement.current);
        const monthSelectWidth = monthSelectElement.current?.clientWidth ?? 0;
        const rightOffset = Math.max(2, monthSelectWidth - monthTextWidth - (0, $6Y6tm.IconSize).STANDARD - 2);
        setMonthRightOffset(rightOffset);
    }, [
        containerElement,
        displayedMonthText,
        monthSelectElement
    ]);
    return monthRightOffset;
}


function $fd20de9e76929a21$export$71ca31c7c6df06c8({ caption: caption, children: children, ...props }) {
    const containerElement = (0, $kYL7Z.useRef)(null);
    const selectElement = (0, $kYL7Z.useRef)(null);
    // Use a custom hook to adjust the position of the position of the HTMLSelect icon to appear right next to
    // the month name. N.B. we expect props.caption to be a simple string representing the month name.
    const displayedMonthText = typeof caption === "string" ? caption : "";
    const monthSelectRightOffset = (0, $14896419bf18de0f$export$58088a1aab19b337)(selectElement, containerElement, displayedMonthText);
    const iconProps = (0, $kYL7Z.useMemo)(()=>props.name === "months" ? {
            style: {
                right: monthSelectRightOffset
            }
        } : {}, [
        props.name,
        monthSelectRightOffset
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        ref: containerElement,
        children: (0, $fc31e5e9fc16a880$exports.jsx)((0, $9e675beb9e64c244$export$49d2a72fcffd1efe), {
            iconProps: iconProps,
            minimal: true,
            ref: selectElement,
            ...props,
            children: children
        })
    });
}





var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $040ce4156a43f101$export$29ab0a58e0457c56 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "chevron-left",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M168.2 200L274 305.8C277.8 309.4 280 314.4 280 320C280 331 271 340 260 340C254.4 340 249.4 337.8 245.8 334.2L125.8 214.2C122.2 210.6 120 205.6 120 200C120 194.4 122.2 189.4 125.8 185.8L245.8 65.8C249.4 62.2 254.4 60 260 60C271 60 280 69 280 80C280 85.6 277.8 90.6 274.2000000000001 94.2000000000001L168.2 200z" : "M148.2 160L214 225.8C217.8 229.4 220 234.4 220 240C220 251 211 260 200 260C194.4 260 189.4 257.8 185.8 254.2L105.8 174.2C102.2 170.6 100 165.6 100 160C100 154.4 102.2 149.4 105.8 145.8L185.8 65.8C189.4 62.2 194.4 60 200 60C211 60 220 69 220 80C220 85.6 217.8 90.6 214.2 94.2L148.2 160z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$040ce4156a43f101$export$29ab0a58e0457c56.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$040ce4156a43f101$export$29ab0a58e0457c56.displayName = `Blueprint6.Icon.ChevronLeft`;
var $040ce4156a43f101$export$2e2bcd8739ae039 = $040ce4156a43f101$export$29ab0a58e0457c56;



var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $0e80a644be41bded$export$6172d85aadfc9b96 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "chevron-right",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M274.2000000000001 214.2L154.2 334.2000000000001C150.6 337.8 145.6 340 140 340C129 340 120 331 120 320C120 314.4 122.2 309.4 125.8 305.8L231.8 200L126 94.2000000000001C122.2 90.6 120 85.6 120 80C120 69 129 60 140 60C145.6 60 150.6 62.2 154.2 65.8L274.2000000000001 185.8C277.8 189.4 280 194.4 280 200C280 205.6 277.8 210.6 274.2000000000001 214.2z" : "M214.2 174.2L134.2 254.2C130.6 257.8 125.6 260 120 260C109 260 100 251 100 240C100 234.4 102.2 229.4 105.8 225.8L171.8 160L106 94.2C102.2 90.6 100 85.6 100 80C100 69 109 60 120 60C125.6 60 130.6 62.2 134.2 65.8L214.2 145.8C217.8 149.4 220 154.4 220 160C220 165.6 217.8 170.6 214.2 174.2z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$0e80a644be41bded$export$6172d85aadfc9b96.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$0e80a644be41bded$export$6172d85aadfc9b96.displayName = `Blueprint6.Icon.ChevronRight`;
var $0e80a644be41bded$export$2e2bcd8739ae039 = $0e80a644be41bded$export$6172d85aadfc9b96;


function $b224235f79acfce8$export$fac286bb0d0d0385({ children: children, ...props }) {
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $040ce4156a43f101$export$29ab0a58e0457c56), {
        ...props
    });
}
function $b224235f79acfce8$export$142e5a7835580ff5({ children: children, ...props }) {
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $0e80a644be41bded$export$6172d85aadfc9b96), {
        ...props
    });
}




var $kYL7Z = parcelRequire("kYL7Z");



const $ccc950d0df132737$export$b807bd574d08ebc1 = (props)=>{
    const { allowSingleDayRange: allowSingleDayRange = false, maxDate: maxDate, minDate: minDate, onShortcutClick: onShortcutClick, selectedShortcutIndex: selectedShortcutIndex = -1, timePrecision: timePrecision, useSingleDateShortcuts: useSingleDateShortcuts = false } = props;
    const shortcuts = props.shortcuts === true ? $ccc950d0df132737$var$createDefaultShortcuts(allowSingleDayRange, timePrecision != null, useSingleDateShortcuts) : props.shortcuts;
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
        "aria-label": "Date picker shortcuts",
        className: (0, $f55168e6b9fee700$exports).DATERANGEPICKER_SHORTCUTS,
        tabIndex: 0,
        children: shortcuts.map((shortcut, index)=>(0, $fc31e5e9fc16a880$exports.jsx)($ccc950d0df132737$var$ShortcutMenuItem, {
                active: selectedShortcutIndex === index,
                index: index,
                maxDate: maxDate,
                minDate: minDate,
                onShortcutClick: onShortcutClick,
                shortcut: shortcut
            }, index))
    });
};
const $ccc950d0df132737$var$ShortcutMenuItem = (props)=>{
    const { active: active, index: index, maxDate: maxDate, minDate: minDate, onShortcutClick: onShortcutClick, shortcut: shortcut } = props;
    const isShortcutInRange = (0, $09de41855074c4c6$export$fcf491bb01a09ccc)(shortcut.dateRange, [
        minDate,
        maxDate
    ]);
    const handleClick = (0, $kYL7Z.useCallback)(()=>onShortcutClick(shortcut, index), [
        index,
        onShortcutClick,
        shortcut
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
        active: active,
        disabled: !isShortcutInRange,
        onClick: handleClick,
        shouldDismissPopover: false,
        text: shortcut.label
    });
};
function $ccc950d0df132737$var$createShortcut(label, dateRange) {
    return {
        dateRange: dateRange,
        label: label
    };
}
function $ccc950d0df132737$var$createDefaultShortcuts(allowSingleDayRange, hasTimePrecision, useSingleDateShortcuts) {
    const today = new Date();
    const makeDate = (action)=>{
        const returnVal = (0, $09de41855074c4c6$export$9cd59f9826255e47)(today);
        action(returnVal);
        returnVal.setDate(returnVal.getDate() + 1);
        return returnVal;
    };
    const tomorrow = makeDate(()=>null);
    const yesterday = makeDate((d)=>d.setDate(d.getDate() - 2));
    const oneWeekAgo = makeDate((d)=>d.setDate(d.getDate() - 7));
    const oneMonthAgo = makeDate((d)=>d.setMonth(d.getMonth() - 1));
    const threeMonthsAgo = makeDate((d)=>d.setMonth(d.getMonth() - 3));
    const sixMonthsAgo = makeDate((d)=>d.setMonth(d.getMonth() - 6));
    const oneYearAgo = makeDate((d)=>d.setFullYear(d.getFullYear() - 1));
    const twoYearsAgo = makeDate((d)=>d.setFullYear(d.getFullYear() - 2));
    const singleDayShortcuts = allowSingleDayRange || useSingleDateShortcuts ? [
        $ccc950d0df132737$var$createShortcut("Today", [
            today,
            hasTimePrecision ? tomorrow : today
        ]),
        $ccc950d0df132737$var$createShortcut("Yesterday", [
            yesterday,
            hasTimePrecision ? today : yesterday
        ])
    ] : [];
    return [
        ...singleDayShortcuts,
        $ccc950d0df132737$var$createShortcut(useSingleDateShortcuts ? "1 week ago" : "Past week", [
            oneWeekAgo,
            today
        ]),
        $ccc950d0df132737$var$createShortcut(useSingleDateShortcuts ? "1 month ago" : "Past month", [
            oneMonthAgo,
            today
        ]),
        $ccc950d0df132737$var$createShortcut(useSingleDateShortcuts ? "3 months ago" : "Past 3 months", [
            threeMonthsAgo,
            today
        ]),
        // Don't include a couple of these for the single date shortcut
        ...useSingleDateShortcuts ? [] : [
            $ccc950d0df132737$var$createShortcut("Past 6 months", [
                sixMonthsAgo,
                today
            ])
        ],
        $ccc950d0df132737$var$createShortcut(useSingleDateShortcuts ? "1 year ago" : "Past year", [
            oneYearAgo,
            today
        ]),
        ...useSingleDateShortcuts ? [] : [
            $ccc950d0df132737$var$createShortcut("Past 2 years", [
                twoYearsAgo,
                today
            ])
        ]
    ];
}





var $kYL7Z = parcelRequire("kYL7Z");


/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $2ebc80f27b468054$export$d9e59215631231e3;
(function(TimeUnit) {
    // NOTE: string enum so we can use it in Record<> type at the end of this file, which requires string keys
    TimeUnit["HOUR_24"] = "hour24";
    TimeUnit["HOUR_12"] = "hour12";
    TimeUnit["MINUTE"] = "minute";
    TimeUnit["SECOND"] = "second";
    TimeUnit["MS"] = "ms";
})($2ebc80f27b468054$export$d9e59215631231e3 || ($2ebc80f27b468054$export$d9e59215631231e3 = {}));
function $2ebc80f27b468054$export$c175552e54e232(unit) {
    const timeUnitToPrintstr = {
        [$2ebc80f27b468054$export$d9e59215631231e3.HOUR_24]: "hours (24hr clock)",
        [$2ebc80f27b468054$export$d9e59215631231e3.HOUR_12]: "hours (12hr clock)",
        [$2ebc80f27b468054$export$d9e59215631231e3.MINUTE]: "minutes",
        [$2ebc80f27b468054$export$d9e59215631231e3.SECOND]: "seconds",
        [$2ebc80f27b468054$export$d9e59215631231e3.MS]: "milliseconds"
    };
    return timeUnitToPrintstr[unit];
}
function $2ebc80f27b468054$export$80af807a588288ab(unit, date) {
    switch(unit){
        case $2ebc80f27b468054$export$d9e59215631231e3.HOUR_24:
            return date.getHours();
        case $2ebc80f27b468054$export$d9e59215631231e3.HOUR_12:
            return (0, $09de41855074c4c6$export$af42c864ff109f35)(date.getHours());
        case $2ebc80f27b468054$export$d9e59215631231e3.MINUTE:
            return date.getMinutes();
        case $2ebc80f27b468054$export$d9e59215631231e3.SECOND:
            return date.getSeconds();
        case $2ebc80f27b468054$export$d9e59215631231e3.MS:
            return date.getMilliseconds();
        default:
            throw Error("Invalid TimeUnit");
    }
}
function $2ebc80f27b468054$export$10b31327beded5ec(unit, time, date, isPm = false) {
    switch(unit){
        case $2ebc80f27b468054$export$d9e59215631231e3.HOUR_24:
            date.setHours(time);
            break;
        case $2ebc80f27b468054$export$d9e59215631231e3.HOUR_12:
            date.setHours((0, $09de41855074c4c6$export$eb06a9687b5a16f2)(time, isPm));
            break;
        case $2ebc80f27b468054$export$d9e59215631231e3.MINUTE:
            date.setMinutes(time);
            break;
        case $2ebc80f27b468054$export$d9e59215631231e3.SECOND:
            date.setSeconds(time);
            break;
        case $2ebc80f27b468054$export$d9e59215631231e3.MS:
            date.setMilliseconds(time);
            break;
        default:
            throw Error("Invalid TimeUnit");
    }
    return date;
}
function $2ebc80f27b468054$export$48ca3c0262def7f9(unit, time) {
    return time != null && !isNaN(time) && $2ebc80f27b468054$export$deba58c3b1f946ac(unit) <= time && time <= $2ebc80f27b468054$export$c72b50f8a8feece(unit);
}
function $2ebc80f27b468054$export$9f49d31bd9f2c828(unit, time) {
    const max = $2ebc80f27b468054$export$c72b50f8a8feece(unit);
    const min = $2ebc80f27b468054$export$deba58c3b1f946ac(unit);
    if (time > max) return min;
    else if (time < min) return max;
    return time;
}
function $2ebc80f27b468054$export$1ccc1aaf243c41d3(unit) {
    return $2ebc80f27b468054$var$TimeUnitMetadataStore[unit].className;
}
function $2ebc80f27b468054$export$c72b50f8a8feece(unit) {
    return $2ebc80f27b468054$var$TimeUnitMetadataStore[unit].max;
}
function $2ebc80f27b468054$export$deba58c3b1f946ac(unit) {
    return $2ebc80f27b468054$var$TimeUnitMetadataStore[unit].min;
}
function $2ebc80f27b468054$export$5584d1599fea942e() {
    return new Date(0, 0, 0, $2ebc80f27b468054$var$DEFAULT_MIN_HOUR, $2ebc80f27b468054$var$DEFAULT_MIN_MINUTE, $2ebc80f27b468054$var$DEFAULT_MIN_SECOND, $2ebc80f27b468054$var$DEFAULT_MIN_MILLISECOND);
}
function $2ebc80f27b468054$export$41c08f29e8818967() {
    return new Date(0, 0, 0, $2ebc80f27b468054$var$DEFAULT_MAX_HOUR, $2ebc80f27b468054$var$DEFAULT_MAX_MINUTE, $2ebc80f27b468054$var$DEFAULT_MAX_SECOND, $2ebc80f27b468054$var$DEFAULT_MAX_MILLISECOND);
}
const $2ebc80f27b468054$var$DEFAULT_MIN_HOUR = 0;
const $2ebc80f27b468054$var$MERIDIEM_MIN_HOUR = 1;
const $2ebc80f27b468054$var$DEFAULT_MIN_MINUTE = 0;
const $2ebc80f27b468054$var$DEFAULT_MIN_SECOND = 0;
const $2ebc80f27b468054$var$DEFAULT_MIN_MILLISECOND = 0;
const $2ebc80f27b468054$var$DEFAULT_MAX_HOUR = 23;
const $2ebc80f27b468054$var$MERIDIEM_MAX_HOUR = 12;
const $2ebc80f27b468054$var$DEFAULT_MAX_MINUTE = 59;
const $2ebc80f27b468054$var$DEFAULT_MAX_SECOND = 59;
const $2ebc80f27b468054$var$DEFAULT_MAX_MILLISECOND = 999;
/**
 * A datastore (internal to this file) mapping TimeUnits to useful information about them.
 * Use the `get*` methods above to access these fields.
 */ const $2ebc80f27b468054$var$TimeUnitMetadataStore = {
    [$2ebc80f27b468054$export$d9e59215631231e3.HOUR_24]: {
        className: $f55168e6b9fee700$export$8d60bf31be10cc99,
        max: $2ebc80f27b468054$var$DEFAULT_MAX_HOUR,
        min: $2ebc80f27b468054$var$DEFAULT_MIN_HOUR
    },
    [$2ebc80f27b468054$export$d9e59215631231e3.HOUR_12]: {
        className: $f55168e6b9fee700$export$8d60bf31be10cc99,
        max: $2ebc80f27b468054$var$MERIDIEM_MAX_HOUR,
        min: $2ebc80f27b468054$var$MERIDIEM_MIN_HOUR
    },
    [$2ebc80f27b468054$export$d9e59215631231e3.MINUTE]: {
        className: $f55168e6b9fee700$export$6011200e3365c34f,
        max: $2ebc80f27b468054$var$DEFAULT_MAX_MINUTE,
        min: $2ebc80f27b468054$var$DEFAULT_MIN_MINUTE
    },
    [$2ebc80f27b468054$export$d9e59215631231e3.SECOND]: {
        className: $f55168e6b9fee700$export$bdd59c72d2409e69,
        max: $2ebc80f27b468054$var$DEFAULT_MAX_SECOND,
        min: $2ebc80f27b468054$var$DEFAULT_MIN_SECOND
    },
    [$2ebc80f27b468054$export$d9e59215631231e3.MS]: {
        className: $f55168e6b9fee700$export$aaa11131f806b417,
        max: $2ebc80f27b468054$var$DEFAULT_MAX_MILLISECOND,
        min: $2ebc80f27b468054$var$DEFAULT_MIN_MILLISECOND
    }
};



class $f80568c1718f0e62$export$5f876910ea565cd3 extends (0, $kYL7Z.Component) {
    static defaultProps = {
        autoFocus: false,
        disabled: false,
        maxTime: (0, $2ebc80f27b468054$export$41c08f29e8818967)(),
        minTime: (0, $2ebc80f27b468054$export$5584d1599fea942e)(),
        precision: (0, $9abbf4372f2fff3e$export$3a3ade082c590099).MINUTE,
        selectAllOnFocus: false,
        showArrowButtons: false,
        useAmPm: false
    };
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.TimePicker`;
    constructor(props){
        super(props);
        this.state = this.getFullStateFromValue(this.getInitialValue(), props.useAmPm);
    }
    timeInputIds = {
        [(0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24]: (0, $5f04c694ca05154e$exports).uniqueId((0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24 + "-input"),
        [(0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_12]: (0, $5f04c694ca05154e$exports).uniqueId((0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_12 + "-input"),
        [(0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE]: (0, $5f04c694ca05154e$exports).uniqueId((0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE + "-input"),
        [(0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND]: (0, $5f04c694ca05154e$exports).uniqueId((0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND + "-input"),
        [(0, $2ebc80f27b468054$export$d9e59215631231e3).MS]: (0, $5f04c694ca05154e$exports).uniqueId((0, $2ebc80f27b468054$export$d9e59215631231e3).MS + "-input")
    };
    render() {
        const shouldRenderMilliseconds = this.props.precision === (0, $9abbf4372f2fff3e$export$3a3ade082c590099).MILLISECOND;
        const shouldRenderSeconds = shouldRenderMilliseconds || this.props.precision === (0, $9abbf4372f2fff3e$export$3a3ade082c590099).SECOND;
        const hourUnit = this.props.useAmPm ? (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_12 : (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24;
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $f55168e6b9fee700$exports).TIMEPICKER, this.props.className, {
            [(0, $2cfd35af7ec11fdd$exports).DISABLED]: this.props.disabled
        });
        return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: classes,
            children: [
                (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    className: (0, $f55168e6b9fee700$exports).TIMEPICKER_ARROW_ROW,
                    children: [
                        this.maybeRenderArrowButton(true, hourUnit),
                        this.maybeRenderArrowButton(true, (0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE),
                        shouldRenderSeconds && this.maybeRenderArrowButton(true, (0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND),
                        shouldRenderMilliseconds && this.maybeRenderArrowButton(true, (0, $2ebc80f27b468054$export$d9e59215631231e3).MS)
                    ]
                }),
                (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    className: (0, $f55168e6b9fee700$exports).TIMEPICKER_INPUT_ROW,
                    children: [
                        this.renderInput((0, $f55168e6b9fee700$exports).TIMEPICKER_HOUR, hourUnit, this.state.hourText),
                        this.renderDivider(),
                        this.renderInput((0, $f55168e6b9fee700$exports).TIMEPICKER_MINUTE, (0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE, this.state.minuteText),
                        shouldRenderSeconds && this.renderDivider(),
                        shouldRenderSeconds && this.renderInput((0, $f55168e6b9fee700$exports).TIMEPICKER_SECOND, (0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND, this.state.secondText),
                        shouldRenderMilliseconds && this.renderDivider("."),
                        shouldRenderMilliseconds && this.renderInput((0, $f55168e6b9fee700$exports).TIMEPICKER_MILLISECOND, (0, $2ebc80f27b468054$export$d9e59215631231e3).MS, this.state.millisecondText)
                    ]
                }),
                this.maybeRenderAmPm(),
                (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    className: (0, $f55168e6b9fee700$exports).TIMEPICKER_ARROW_ROW,
                    children: [
                        this.maybeRenderArrowButton(false, hourUnit),
                        this.maybeRenderArrowButton(false, (0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE),
                        shouldRenderSeconds && this.maybeRenderArrowButton(false, (0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND),
                        shouldRenderMilliseconds && this.maybeRenderArrowButton(false, (0, $2ebc80f27b468054$export$d9e59215631231e3).MS)
                    ]
                })
            ]
        });
    }
    componentDidUpdate(prevProps) {
        const didMinTimeChange = prevProps.minTime !== this.props.minTime;
        const didMaxTimeChange = prevProps.maxTime !== this.props.maxTime;
        const didBoundsChange = didMinTimeChange || didMaxTimeChange;
        const didPropValueChange = prevProps.value !== this.props.value;
        const shouldStateUpdate = didBoundsChange || didPropValueChange;
        let value = this.state.value;
        if (this.props.value == null) value = this.getInitialValue();
        if (didBoundsChange) value = (0, $09de41855074c4c6$exports).getTimeInRange(this.state.value ?? this.getInitialValue(), this.props.minTime ?? (0, $2ebc80f27b468054$export$5584d1599fea942e)(), this.props.maxTime ?? (0, $2ebc80f27b468054$export$41c08f29e8818967)());
        if (this.props.value != null && !(0, $09de41855074c4c6$exports).isSameTime(this.props.value, prevProps.value ?? null)) value = this.props.value;
        if (shouldStateUpdate) this.setState(this.getFullStateFromValue(value, this.props.useAmPm));
    }
    // begin method definitions: rendering
    maybeRenderArrowButton(isDirectionUp, timeUnit) {
        if (!this.props.showArrowButtons) return null;
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $f55168e6b9fee700$exports).TIMEPICKER_ARROW_BUTTON, (0, $2ebc80f27b468054$export$1ccc1aaf243c41d3)(timeUnit));
        const onClick = ()=>(isDirectionUp ? this.incrementTime : this.decrementTime)(timeUnit);
        const label = `${isDirectionUp ? "Increase" : "Decrease"} ${(0, $2ebc80f27b468054$export$c175552e54e232)(timeUnit)}`;
        // set tabIndex=-1 to ensure a valid FocusEvent relatedTarget when focused
        return(// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        (0, $fc31e5e9fc16a880$exports.jsx)("span", {
            "aria-controls": this.timeInputIds[timeUnit],
            "aria-label": label,
            tabIndex: -1,
            className: classes,
            onClick: onClick,
            children: (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: isDirectionUp ? "chevron-up" : "chevron-down",
                title: label
            })
        }));
    }
    renderDivider(text = ":") {
        return (0, $fc31e5e9fc16a880$exports.jsx)("span", {
            className: (0, $f55168e6b9fee700$exports).TIMEPICKER_DIVIDER_TEXT,
            children: text
        });
    }
    renderInput(className, unit, value) {
        const isValid = value != null ? (0, $2ebc80f27b468054$export$48ca3c0262def7f9)(unit, parseInt(value, 10)) : false;
        const isHour = unit === (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_12 || unit === (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24;
        return (0, $fc31e5e9fc16a880$exports.jsx)("input", {
            "aria-label": (0, $2ebc80f27b468054$export$c175552e54e232)(unit),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $f55168e6b9fee700$exports).TIMEPICKER_INPUT, {
                [(0, $2cfd35af7ec11fdd$exports).intentClass((0, $9489302fa7beb346$export$dc3e8878c31a5f1c).DANGER)]: !isValid
            }, className),
            id: this.timeInputIds[unit],
            min: 0,
            max: (0, $2ebc80f27b468054$export$c72b50f8a8feece)(unit),
            onBlur: this.getInputBlurHandler(unit),
            onChange: this.getInputChangeHandler(unit),
            onFocus: this.getInputFocusHandler(unit),
            onKeyDown: this.getInputKeyDownHandler(unit),
            onKeyUp: this.getInputKeyUpHandler(unit),
            role: this.props.showArrowButtons ? "spinbutton" : undefined,
            type: "number",
            value: value,
            disabled: this.props.disabled,
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus: isHour && this.props.autoFocus
        });
    }
    maybeRenderAmPm() {
        if (!this.props.useAmPm) return null;
        return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $9e675beb9e64c244$export$49d2a72fcffd1efe), {
            className: (0, $f55168e6b9fee700$exports).TIMEPICKER_AMPM_SELECT,
            disabled: this.props.disabled,
            onChange: this.handleAmPmChange,
            value: this.state.isPm ? "pm" : "am",
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)("option", {
                    value: "am",
                    children: "AM"
                }),
                (0, $fc31e5e9fc16a880$exports.jsx)("option", {
                    value: "pm",
                    children: "PM"
                })
            ]
        });
    }
    // begin method definitions: event handlers
    getInputChangeHandler = (unit)=>(e)=>{
            const text = $f80568c1718f0e62$var$getStringValueFromInputEvent(e);
            switch(unit){
                case (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_12:
                case (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24:
                    this.setState({
                        hourText: text
                    });
                    break;
                case (0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE:
                    this.setState({
                        minuteText: text
                    });
                    break;
                case (0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND:
                    this.setState({
                        secondText: text
                    });
                    break;
                case (0, $2ebc80f27b468054$export$d9e59215631231e3).MS:
                    this.setState({
                        millisecondText: text
                    });
                    break;
            }
        };
    getInputBlurHandler = (unit)=>(e)=>{
            const text = $f80568c1718f0e62$var$getStringValueFromInputEvent(e);
            this.updateTime(parseInt(text, 10), unit);
            this.props.onBlur?.(e, unit);
        };
    getInputFocusHandler = (unit)=>(e)=>{
            if (this.props.selectAllOnFocus) e.currentTarget.select();
            this.props.onFocus?.(e, unit);
        };
    getInputKeyDownHandler = (unit)=>(e)=>{
            $f80568c1718f0e62$var$handleKeyEvent(e, {
                ArrowDown: ()=>this.decrementTime(unit),
                ArrowUp: ()=>this.incrementTime(unit),
                Enter: ()=>{
                    e.currentTarget.blur();
                }
            });
            this.props.onKeyDown?.(e, unit);
        };
    getInputKeyUpHandler = (unit)=>(e)=>{
            this.props.onKeyUp?.(e, unit);
        };
    handleAmPmChange = (e)=>{
        const isNextPm = e.currentTarget.value === "pm";
        if (isNextPm !== this.state.isPm) {
            const value = this.state.value ?? this.getInitialValue();
            const hour = (0, $09de41855074c4c6$exports).convert24HourMeridiem(value.getHours(), isNextPm);
            this.setState({
                isPm: isNextPm
            }, ()=>this.updateTime(hour, (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24));
        }
    };
    // begin method definitions: state modification
    /**
     * Generates a full TimePickerState object with all text fields set to formatted strings based on value
     */ getFullStateFromValue(value, useAmPm = false) {
        value = value ?? this.getInitialValue();
        const timeInRange = (0, $09de41855074c4c6$exports).getTimeInRange(value, this.props.minTime ?? (0, $2ebc80f27b468054$export$5584d1599fea942e)(), this.props.maxTime ?? (0, $2ebc80f27b468054$export$41c08f29e8818967)());
        const hourUnit = useAmPm ? (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_12 : (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24;
        /* eslint-disable sort-keys */ return {
            hourText: $f80568c1718f0e62$var$formatTime(timeInRange.getHours(), hourUnit),
            minuteText: $f80568c1718f0e62$var$formatTime(timeInRange.getMinutes(), (0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE),
            secondText: $f80568c1718f0e62$var$formatTime(timeInRange.getSeconds(), (0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND),
            millisecondText: $f80568c1718f0e62$var$formatTime(timeInRange.getMilliseconds(), (0, $2ebc80f27b468054$export$d9e59215631231e3).MS),
            value: timeInRange,
            isPm: (0, $09de41855074c4c6$exports).getIsPmFrom24Hour(timeInRange.getHours())
        };
    /* eslint-enable sort-keys */ }
    incrementTime = (unit)=>this.shiftTime(unit, 1);
    decrementTime = (unit)=>this.shiftTime(unit, -1);
    shiftTime(unit, amount) {
        if (this.props.disabled) return;
        const newTime = (0, $2ebc80f27b468054$export$80af807a588288ab)(unit, this.state.value ?? this.getInitialValue()) + amount;
        this.updateTime((0, $2ebc80f27b468054$export$9f49d31bd9f2c828)(unit, newTime), unit);
    }
    updateTime(time, unit) {
        const value = this.state.value ?? this.getInitialValue();
        const newValue = (0, $09de41855074c4c6$exports).clone(value);
        if ((0, $2ebc80f27b468054$export$48ca3c0262def7f9)(unit, time)) {
            (0, $2ebc80f27b468054$export$10b31327beded5ec)(unit, time, newValue, this.state.isPm);
            if ((0, $09de41855074c4c6$exports).isTimeInRange(newValue, this.props.minTime ?? (0, $2ebc80f27b468054$export$5584d1599fea942e)(), this.props.maxTime ?? (0, $2ebc80f27b468054$export$41c08f29e8818967)())) this.updateState({
                value: newValue
            });
            else this.updateState(this.getFullStateFromValue(value, this.props.useAmPm));
        } else this.updateState(this.getFullStateFromValue(value, this.props.useAmPm));
    }
    updateState(state) {
        let newState = state;
        const hasNewValue = newState.value != null && !(0, $09de41855074c4c6$exports).isSameTime(newState.value, this.state.value ?? null);
        if (this.props.value == null) {
            // component is uncontrolled
            if (hasNewValue) newState = this.getFullStateFromValue(newState.value, this.props.useAmPm);
            this.setState(newState);
        } else // component is controlled, and there's a new value
        // so set inputs' text based off of _old_ value and later fire onChange with new value
        if (hasNewValue) this.setState(this.getFullStateFromValue(this.state.value, this.props.useAmPm));
        else // no new value, this means only text has changed (from user typing)
        // we want inputs to change, so update state with new text for the inputs
        // but don't change actual value
        this.setState({
            ...newState,
            value: this.state.value != null ? (0, $09de41855074c4c6$exports).clone(this.state.value) : undefined
        });
        if (hasNewValue && newState.value != null) this.props.onChange?.(newState.value);
    }
    getInitialValue() {
        const minTime = this.props.minTime ?? (0, $2ebc80f27b468054$export$5584d1599fea942e)();
        let value = minTime;
        if (this.props.value != null) value = this.props.value;
        else if (this.props.defaultValue != null) value = this.props.defaultValue;
        return value;
    }
}
function $f80568c1718f0e62$var$formatTime(time, unit) {
    switch(unit){
        case (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_24:
            return time.toString();
        case (0, $2ebc80f27b468054$export$d9e59215631231e3).HOUR_12:
            return (0, $09de41855074c4c6$exports).get12HourFrom24Hour(time).toString();
        case (0, $2ebc80f27b468054$export$d9e59215631231e3).MINUTE:
        case (0, $2ebc80f27b468054$export$d9e59215631231e3).SECOND:
            return $d70f3506246018c1$export$4c4804864409f576(time.toString(), 2);
        case (0, $2ebc80f27b468054$export$d9e59215631231e3).MS:
            return $d70f3506246018c1$export$4c4804864409f576(time.toString(), 3);
        default:
            throw Error("Invalid TimeUnit");
    }
}
function $f80568c1718f0e62$var$getStringValueFromInputEvent(e) {
    return e.target.value;
}
function $f80568c1718f0e62$var$handleKeyEvent(e, actions, preventDefault = true) {
    for (const key of Object.keys(actions))if (e.key === key) {
        if (preventDefault) e.preventDefault();
        actions[key]();
    }
}




var $kYL7Z = parcelRequire("kYL7Z");
const $7d8cefd69d6cb95c$export$cf316c7f3b44c11e = (0, $kYL7Z.createContext)({
    locale: undefined
});
const $7d8cefd69d6cb95c$export$51f12e9a8a9bb794 = (props)=>{
    return (0, $fc31e5e9fc16a880$exports.jsx)($7d8cefd69d6cb95c$export$cf316c7f3b44c11e.Provider, {
        value: props,
        children: props.children
    });
};


class $9fdc068c47f68403$export$5109c6dd95d8fb00 extends (0, $dd417c1d28be0aaa$export$6a33e2aa49694e12) {
    static defaultProps = {
        canClearSelection: true,
        clearButtonText: "Clear",
        dayPickerProps: {},
        highlightCurrentDay: false,
        locale: (0, $32774f42478d4346$export$9824d860d0b120d9),
        maxDate: (0, $32774f42478d4346$export$c4acb27cbfd4cf71),
        minDate: (0, $32774f42478d4346$export$c21855736e7fcd29),
        reverseMonthAndYearMenus: false,
        shortcuts: false,
        showActionsBar: false,
        todayButtonText: "Today"
    };
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.DatePicker`;
    ignoreNextMonthChange = false;
    constructor(props){
        super(props);
        const value = $9fdc068c47f68403$var$getInitialValue(props);
        const initialMonth = $9fdc068c47f68403$var$getInitialMonth(props, value);
        this.state = {
            displayMonth: initialMonth.getMonth(),
            displayYear: initialMonth.getFullYear(),
            locale: undefined,
            selectedDay: value == null ? null : value.getDate(),
            selectedShortcutIndex: this.props.selectedShortcutIndex !== undefined ? this.props.selectedShortcutIndex : -1,
            value: value
        };
    }
    render() {
        const { className: className, dayPickerProps: dayPickerProps, footerElement: footerElement, maxDate: maxDate, minDate: minDate, showActionsBar: showActionsBar } = this.props;
        const { displayMonth: displayMonth, displayYear: displayYear, locale: locale } = this.state;
        return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $f55168e6b9fee700$exports).DATEPICKER, className, {
                [(0, $f55168e6b9fee700$exports).DATEPICKER3_HIGHLIGHT_CURRENT_DAY]: this.props.highlightCurrentDay,
                [(0, $f55168e6b9fee700$exports).DATEPICKER3_REVERSE_MONTH_AND_YEAR]: this.props.reverseMonthAndYearMenus
            }),
            children: [
                this.maybeRenderShortcuts(),
                (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    className: (0, $f55168e6b9fee700$exports).DATEPICKER_CONTENT,
                    children: (0, $fc31e5e9fc16a880$exports.jsxs)((0, $7d8cefd69d6cb95c$export$51f12e9a8a9bb794), {
                        ...this.props,
                        ...this.state,
                        children: [
                            (0, $fc31e5e9fc16a880$exports.jsx)((0, $abf3b90c3ecb9f4f$export$97e6db89a86ff7ab), {
                                locale: locale,
                                showOutsideDays: true,
                                ...dayPickerProps,
                                captionLayout: "dropdown-buttons",
                                classNames: {
                                    ...(0, $f55168e6b9fee700$export$6585c874fa3f2c68),
                                    ...dayPickerProps?.classNames
                                },
                                components: {
                                    Dropdown: (0, $fd20de9e76929a21$export$71ca31c7c6df06c8),
                                    IconLeft: $b224235f79acfce8$export$fac286bb0d0d0385,
                                    IconRight: $b224235f79acfce8$export$142e5a7835580ff5,
                                    ...dayPickerProps?.components
                                },
                                formatters: {
                                    formatWeekdayName: this.renderWeekdayName,
                                    ...dayPickerProps?.formatters
                                },
                                fromDate: minDate,
                                mode: "single",
                                month: new Date(displayYear, displayMonth),
                                onMonthChange: this.handleMonthChange,
                                onSelect: this.handleDaySelect,
                                required: !this.props.canClearSelection,
                                selected: this.state.value ?? undefined,
                                toDate: maxDate
                            }),
                            this.maybeRenderTimePicker(),
                            showActionsBar && this.renderOptionsBar(),
                            footerElement
                        ]
                    })
                })
            ]
        });
    }
    async componentDidMount() {
        await super.componentDidMount();
    }
    async componentDidUpdate(prevProps) {
        super.componentDidUpdate(prevProps);
        if (this.props.value !== prevProps.value) {
            if (this.props.value == null) // clear the value
            this.setState({
                value: null
            });
            else this.setState({
                displayMonth: this.props.value.getMonth(),
                displayYear: this.props.value.getFullYear(),
                selectedDay: this.props.value.getDate(),
                value: this.props.value
            });
        }
        if (this.props.selectedShortcutIndex !== prevProps.selectedShortcutIndex) this.setState({
            selectedShortcutIndex: this.props.selectedShortcutIndex
        });
    }
    validateProps(props) {
        const { defaultValue: defaultValue, initialMonth: initialMonth, maxDate: maxDate, minDate: minDate, value: value } = props;
        if (defaultValue != null && !(0, $09de41855074c4c6$exports).isDayInRange(defaultValue, [
            minDate,
            maxDate
        ])) console.error((0, $b5140593a93ec51e$exports).DATEPICKER_DEFAULT_VALUE_INVALID);
        if (initialMonth != null && !(0, $09de41855074c4c6$exports).isMonthInRange(initialMonth, [
            minDate,
            maxDate
        ])) console.error((0, $b5140593a93ec51e$exports).DATEPICKER_INITIAL_MONTH_INVALID);
        if (maxDate != null && minDate != null && maxDate < minDate && !(0, $09de41855074c4c6$exports).isSameDay(maxDate, minDate)) console.error((0, $b5140593a93ec51e$exports).DATEPICKER_MAX_DATE_INVALID);
        if (value != null && !(0, $09de41855074c4c6$exports).isDayInRange(value, [
            minDate,
            maxDate
        ])) console.error((0, $b5140593a93ec51e$exports).DATEPICKER_VALUE_INVALID);
    }
    /**
     * Custom formatter to render weekday names in the calendar header. The default formatter generally works fine,
     * but it was returning CAPITALIZED strings for some reason, while we prefer Title Case.
     */ renderWeekdayName = (date)=>{
        return (0, $2b4e856eb74a628a$export$2e2bcd8739ae039)(date, "EEEEEE", {
            locale: this.state.locale
        });
    };
    renderOptionsBar() {
        const { clearButtonText: clearButtonText, todayButtonText: todayButtonText, minDate: minDate, maxDate: maxDate, canClearSelection: canClearSelection } = this.props;
        const todayEnabled = $9fdc068c47f68403$var$isTodayEnabled(minDate, maxDate);
        return [
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $49b7c0a83e560886$export$2e0a83ec2e27ecbb), {}, "div"),
            (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                className: (0, $f55168e6b9fee700$exports).DATEPICKER_FOOTER,
                children: [
                    (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        disabled: !todayEnabled,
                        onClick: this.handleTodayClick,
                        text: todayButtonText,
                        variant: "minimal"
                    }),
                    (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        disabled: !canClearSelection,
                        onClick: this.handleClearClick,
                        text: clearButtonText,
                        variant: "minimal"
                    })
                ]
            }, "footer")
        ];
    }
    maybeRenderTimePicker() {
        const { timePrecision: timePrecision, timePickerProps: timePickerProps, minDate: minDate, maxDate: maxDate } = this.props;
        if (timePrecision == null && timePickerProps === undefined) return null;
        const applyMin = this.state.value != null && (0, $09de41855074c4c6$exports).isSameDay(this.state.value, minDate);
        const applyMax = this.state.value != null && (0, $09de41855074c4c6$exports).isSameDay(this.state.value, maxDate);
        return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: (0, $f55168e6b9fee700$exports).DATEPICKER_TIMEPICKER_WRAPPER,
            children: (0, $fc31e5e9fc16a880$exports.jsx)((0, $f80568c1718f0e62$export$5f876910ea565cd3), {
                precision: timePrecision,
                minTime: applyMin ? minDate : undefined,
                maxTime: applyMax ? maxDate : undefined,
                ...timePickerProps,
                onChange: this.handleTimeChange,
                value: this.state.value
            })
        });
    }
    maybeRenderShortcuts() {
        const { shortcuts: shortcuts } = this.props;
        if (shortcuts == null || shortcuts === false) return null;
        const { selectedShortcutIndex: selectedShortcutIndex } = this.state;
        const { maxDate: maxDate = (0, $32774f42478d4346$export$c4acb27cbfd4cf71), minDate: minDate = (0, $32774f42478d4346$export$c21855736e7fcd29), timePrecision: timePrecision } = this.props;
        // Reuse the existing date range shortcuts and only care about start date
        const dateRangeShortcuts = shortcuts === true ? true : shortcuts.map((shortcut)=>({
                ...shortcut,
                // TODO: Remove cast after setting "strictNullChecks: true"
                dateRange: [
                    shortcut.date,
                    null
                ]
            }));
        return [
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $ccc950d0df132737$export$b807bd574d08ebc1), {
                allowSingleDayRange: true,
                maxDate: maxDate,
                minDate: minDate,
                selectedShortcutIndex: selectedShortcutIndex,
                shortcuts: dateRangeShortcuts,
                timePrecision: timePrecision,
                onShortcutClick: this.handleShortcutClick,
                useSingleDateShortcuts: true
            }, "shortcuts"),
            (0, $fc31e5e9fc16a880$exports.jsx)((0, $49b7c0a83e560886$export$2e0a83ec2e27ecbb), {}, "div")
        ];
    }
    handleDaySelect = (day, selectedDay, activeModifiers, e)=>{
        if (activeModifiers.disabled) return;
        else if (day === undefined) {
            this.handleClearClick();
            return;
        }
        this.updateDay(day);
        this.props.dayPickerProps?.onSelect?.(day, selectedDay, activeModifiers, e);
        // allow toggling selected date by clicking it again (if prop enabled)
        const newValue = this.props.canClearSelection && activeModifiers.selected ? null : (0, $09de41855074c4c6$exports).getDateTime(day, this.state.value);
        this.updateValue(newValue, true);
    };
    handleShortcutClick = (shortcut, selectedShortcutIndex)=>{
        const { onShortcutChange: onShortcutChange, selectedShortcutIndex: currentShortcutIndex } = this.props;
        const { dateRange: dateRange, includeTime: includeTime } = shortcut;
        const newDate = dateRange[0];
        const newValue = includeTime ? newDate : (0, $09de41855074c4c6$exports).getDateTime(newDate, this.state.value);
        if (newDate == null) return;
        this.updateDay(newDate);
        this.updateValue(newValue, true);
        if (currentShortcutIndex === undefined) this.setState({
            selectedShortcutIndex: selectedShortcutIndex
        });
        const datePickerShortcut = {
            ...shortcut,
            date: newDate
        };
        onShortcutChange?.(datePickerShortcut, selectedShortcutIndex);
    };
    updateDay = (day)=>{
        if (this.props.value === undefined) // set now if uncontrolled, otherwise they'll be updated in `componentDidUpdate`
        this.setState({
            displayMonth: day.getMonth(),
            displayYear: day.getFullYear(),
            selectedDay: day.getDate()
        });
        if (this.state.value != null && this.state.value.getMonth() !== day.getMonth()) this.ignoreNextMonthChange = true;
    };
    computeValidDateInSpecifiedMonthYear(displayYear, displayMonth) {
        const { minDate: minDate, maxDate: maxDate } = this.props;
        const { selectedDay: selectedDay } = this.state;
        // month is 0-based, date is 1-based. date 0 is last day of previous month.
        const maxDaysInMonth = new Date(displayYear, displayMonth + 1, 0).getDate();
        const displayDate = selectedDay == null ? 1 : Math.min(selectedDay, maxDaysInMonth);
        // 12:00 matches the underlying react-day-picker timestamp behavior
        const value = (0, $09de41855074c4c6$exports).getDateTime(new Date(displayYear, displayMonth, displayDate, 12), this.state.value);
        // clamp between min and max dates
        if (value != null && value < minDate) return minDate;
        else if (value != null && value > maxDate) return maxDate;
        return value;
    }
    handleClearClick = ()=>this.updateValue(null, true);
    handleMonthChange = (newDate)=>{
        const date = this.computeValidDateInSpecifiedMonthYear(newDate.getFullYear(), newDate.getMonth());
        if (date != null) {
            this.setState({
                displayMonth: date.getMonth(),
                displayYear: date.getFullYear()
            });
            this.props.dayPickerProps?.onMonthChange?.(date);
        }
        if (this.state.value !== null) {
            // if handleDayClick just got run (so this flag is set), then the
            // user selected a date in a new month, so don't invoke onChange a
            // second time
            this.updateValue(date, false, this.ignoreNextMonthChange);
            this.ignoreNextMonthChange = false;
        }
    };
    handleTodayClick = ()=>{
        const { timezone: timezone } = this.props;
        const today = new Date();
        const value = timezone != null ? (0, $aa39204287ac49ac$exports).convertLocalDateToTimezoneTime(today, timezone) : today;
        const displayMonth = value.getMonth();
        const displayYear = value.getFullYear();
        const selectedDay = value.getDate();
        this.setState({
            displayMonth: displayMonth,
            displayYear: displayYear,
            selectedDay: selectedDay
        });
        this.updateValue(value, true);
    };
    handleTimeChange = (time)=>{
        this.props.timePickerProps?.onChange?.(time);
        const { value: value } = this.state;
        const newValue = (0, $09de41855074c4c6$exports).getDateTime(value != null ? value : new Date(), time);
        this.updateValue(newValue, true);
    };
    /**
     * Update `value` by invoking `onChange` (always) and setting state (if uncontrolled).
     */ updateValue(value, isUserChange, skipOnChange = false) {
        if (!skipOnChange) this.props.onChange?.(value, isUserChange);
        if (this.props.value === undefined) this.setState({
            value: value
        });
    }
}
function $9fdc068c47f68403$var$getInitialValue(props) {
    // !== because `null` is a valid value (no date)
    if (props.value !== undefined) return props.value;
    if (props.defaultValue !== undefined) return props.defaultValue;
    return null;
}
function $9fdc068c47f68403$var$getInitialMonth(props, value) {
    const rangeFromProps = [
        props.minDate ?? null,
        props.maxDate ?? null
    ];
    const today = new Date();
    // != because we must have a real `Date` to begin the calendar on.
    if (props.initialMonth != null) return props.initialMonth;
    else if (value != null) return value;
    else if ((0, $09de41855074c4c6$exports).isDayInRange(today, rangeFromProps)) return today;
    else return (0, $09de41855074c4c6$exports).getDateBetween(rangeFromProps);
}
function $9fdc068c47f68403$var$isTodayEnabled(minDate, maxDate) {
    const today = new Date();
    return (0, $09de41855074c4c6$exports).isDayInRange(today, [
        minDate,
        maxDate
    ]);
}





const $b8e847414b2fda26$var$MIN_DATE = new Date(2019, 0, 1);
const $b8e847414b2fda26$var$pad = (n, len = 2)=>String(n).padStart(len, '0');
const $b8e847414b2fda26$var$toZulu = (d)=>`${d.getUTCFullYear()}-${$b8e847414b2fda26$var$pad(d.getUTCMonth() + 1)}-${$b8e847414b2fda26$var$pad(d.getUTCDate())}T${$b8e847414b2fda26$var$pad(d.getUTCHours())}:${$b8e847414b2fda26$var$pad(d.getUTCMinutes())}:${$b8e847414b2fda26$var$pad(d.getUTCSeconds())}.${$b8e847414b2fda26$var$pad(d.getUTCMilliseconds(), 3)}Z`;
const $b8e847414b2fda26$var$toZuluDateOnly = (d)=>`${d.getFullYear()}-${$b8e847414b2fda26$var$pad(d.getMonth() + 1)}-${$b8e847414b2fda26$var$pad(d.getDate())}T00:00:00.000Z`;
const $b8e847414b2fda26$var$SelectButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    &[class*="bp"][class*="-button"] {
        border-radius: var(--sf-border-radius) !important;
        width: ${(p)=>p.fill ? '100%' : 'fit-content'};
        justify-content: space-between;
        background: transparent !important;
        box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2) !important;
    }
`;
const $b8e847414b2fda26$var$formatDisplay = (date, time)=>{
    if (!date) return null;
    const d = new Date(date);
    if (isNaN(d.getTime())) return date;
    const dateStr = d.toLocaleDateString('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
    });
    if (!time) return dateStr;
    const timeOpts = {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
    };
    if (time.precision === 'second' || time.precision === 'millisecond') timeOpts.second = '2-digit';
    return dateStr + ' ' + d.toLocaleTimeString('en-GB', timeOpts);
};
const $b8e847414b2fda26$export$34dc4cfa15ead1 = ({ label: label, value: value, disabled: disabled, error: error, time: time, fill: fill, onChange: onChange })=>{
    const intent = error ? 'danger' : 'none';
    const maxDate = (0, $kYL7Z.useMemo)(()=>{
        const d = new Date();
        d.setDate(d.getDate() + 7);
        return d;
    }, []);
    const timeEnabled = time?.enabled === true;
    const precision = timeEnabled ? time?.precision || 'minute' : undefined;
    const dateValue = (0, $kYL7Z.useMemo)(()=>{
        if (!value) return null;
        const d = new Date(value);
        return isNaN(d.getTime()) ? null : d;
    }, [
        value
    ]);
    const handleChange = (0, $kYL7Z.useCallback)((selectedDate)=>{
        if (!selectedDate) {
            onChange(undefined);
            return;
        }
        onChange(timeEnabled ? $b8e847414b2fda26$var$toZulu(selectedDate) : $b8e847414b2fda26$var$toZuluDateOnly(selectedDate));
    }, [
        onChange,
        timeEnabled
    ]);
    const displayText = $b8e847414b2fda26$var$formatDisplay(value, timeEnabled ? {
        precision: precision
    } : null) || 'Select\u2026';
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        helperText: error?.message,
        intent: intent,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            disabled: disabled,
            minimal: true,
            fill: !!fill,
            placement: "bottom-start",
            content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9fdc068c47f68403$export$5109c6dd95d8fb00), {
                locale: (0, $2f071ab2ce9db9ac$export$2e2bcd8739ae039),
                value: dateValue,
                onChange: handleChange,
                showActionsBar: true,
                highlightCurrentDay: true,
                reverseMonthAndYearMenus: true,
                minDate: $b8e847414b2fda26$var$MIN_DATE,
                maxDate: maxDate,
                timePrecision: precision
            }),
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b8e847414b2fda26$var$SelectButton, {
                text: displayText,
                rightIcon: "calendar",
                disabled: disabled,
                fill: fill
            })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");








const $c7955e0af01d9b79$var$SENSOR_OPTIONS = {
    activationConstraint: {
        distance: 5
    }
};
const $c7955e0af01d9b79$var$MODIFIERS = [
    (0, $65b1c87aa1a7f14a$export$1ed98a87b7c51b89)
];
const $c7955e0af01d9b79$var$Wrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: var(--sf-vertical-gap);
`;
const $c7955e0af01d9b79$var$DEBOUNCE_MS = 500;
const $c7955e0af01d9b79$var$EditableKey = ({ value: value, disabled: disabled, depth: depth, onConfirm: onConfirm })=>{
    const [text, setText] = (0, $kYL7Z.useState)(value);
    const timerRef = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useEffect)(()=>setText(value), [
        value
    ]);
    (0, $kYL7Z.useEffect)(()=>()=>clearTimeout(timerRef.current), []);
    const handleChange = (0, $kYL7Z.useCallback)((val)=>{
        setText(val);
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(()=>onConfirm(val), $c7955e0af01d9b79$var$DEBOUNCE_MS);
    }, [
        onConfirm
    ]);
    const handleConfirm = (0, $kYL7Z.useCallback)((val)=>{
        clearTimeout(timerRef.current);
        onConfirm(val);
    }, [
        onConfirm
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$9ae73c5a1c63f2d4), {
        as: (0, $cd7c29a731f3402d$export$66422503964e48cd)(depth),
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1b1f065dadce0c15$export$a0dcf0ef8dc3ae26), {
            value: text,
            onChange: handleChange,
            onConfirm: handleConfirm,
            disabled: disabled,
            selectAllOnFocus: true
        })
    });
};
const $c7955e0af01d9b79$var$ObjectError = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    color: #cd4246;
    font-size: 12px;
    margin-bottom: 4px;
`;
const $c7955e0af01d9b79$var$noLayoutAnimation = ()=>false;
const $c7955e0af01d9b79$var$SortableEntry = ({ id: id, children: children })=>{
    const { attributes: attributes, listeners: listeners, setNodeRef: setNodeRef, transform: transform, transition: transition, isDragging: isDragging } = (0, $03fb2278f85c6d47$export$4ebcb6201122185a)({
        id: id,
        animateLayoutChanges: $c7955e0af01d9b79$var$noLayoutAnimation
    });
    const style = {
        transform: transform ? `translate3d(0, ${transform.y}px, 0)` : undefined,
        transition: transition,
        opacity: isDragging ? 0.5 : 1
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        ref: setNodeRef,
        style: {
            ...style,
            outline: 'none'
        },
        ...attributes,
        children: children(listeners, isDragging)
    });
};
const $c7955e0af01d9b79$export$d142a6500a7b8fab = ({ value: value, disabled: disabled, readonly: readonly, reorderable: reorderable = true, editMode: editModeProp, initialCollapsed: initialCollapsed, entrySchema: entrySchema, allowRenaming: allowRenaming, propertyNames: propertyNames, fill: fill, depth: depth, itemTitle: itemTitle, itemTitleReadOnly: itemTitleReadOnly, itemTitleType: itemTitleType, itemDescription: itemDescription, itemDescriptionReadOnly: itemDescriptionReadOnly, itemDescriptionType: itemDescriptionType, panelWidth: panelWidth, entryErrors: entryErrors, error: error, renderEntry: renderEntry, onChange: onChange })=>{
    const editMode = editModeProp || (initialCollapsed != null ? 'collapsible' : undefined);
    const entries = (0, $kYL7Z.useMemo)(()=>value && typeof value === 'object' ? Object.entries(value) : [], [
        value
    ]);
    const canDrag = reorderable && !disabled && !readonly;
    const entryKeys = (0, $kYL7Z.useMemo)(()=>entries.map(([key])=>key), [
        entries
    ]);
    const sensors = (0, $d59febdd5a89527d$export$19012f58216d597f)((0, $d59febdd5a89527d$export$cc72dd71f4ec69eb)((0, $d59febdd5a89527d$export$b28554b50bf7f273), $c7955e0af01d9b79$var$SENSOR_OPTIONS), (0, $d59febdd5a89527d$export$cc72dd71f4ec69eb)((0, $d59febdd5a89527d$export$19b41baf2e1bcdc0), $c7955e0af01d9b79$var$SENSOR_OPTIONS));
    // Collapse state lifted to survive canDrag branch changes (readonly toggle)
    const [collapsedMap, setCollapsedMap] = (0, $kYL7Z.useState)({});
    const isCollapsed = (key)=>key in collapsedMap ? collapsedMap[key] : !!initialCollapsed;
    const toggleCollapse = (0, $kYL7Z.useCallback)((key)=>{
        setCollapsedMap((prev)=>({
                ...prev,
                [key]: !(key in prev ? prev[key] : !!initialCollapsed)
            }));
    }, [
        initialCollapsed
    ]);
    const handleDragEnd = (0, $kYL7Z.useCallback)((event)=>{
        const { active: active, over: over } = event;
        if (!over || active.id === over.id) return;
        const oldIndex = entryKeys.indexOf(String(active.id));
        const newIndex = entryKeys.indexOf(String(over.id));
        if (oldIndex === -1 || newIndex === -1) return;
        const reordered = (0, $03fb2278f85c6d47$export$5d49d615ad5ea2b0)(entries, oldIndex, newIndex);
        onChange(Object.fromEntries(reordered));
    }, [
        entries,
        entryKeys,
        onChange
    ]);
    const handleRename = (oldKey, newKey)=>{
        if (!newKey || newKey === oldKey) return;
        if (value[newKey] !== undefined) return;
        const result = {};
        for (const [k, v] of Object.entries(value))result[k === oldKey ? newKey : k] = v;
        onChange(result);
    };
    const handleEntryChange = (key, newValue)=>{
        onChange({
            ...value,
            [key]: newValue
        });
    };
    const buildDefaults = (0, $kYL7Z.useCallback)(()=>{
        const defaults = {};
        if (entrySchema?.properties) {
            for (const [key, prop] of Object.entries(entrySchema.properties))if (prop.default !== undefined) defaults[key] = prop.default;
        }
        return defaults;
    }, [
        entrySchema
    ]);
    const collectionCtx = (0, $kYL7Z.useContext)((0, $4a49823ead28a6dc$export$53146c55f8a78b));
    // Ref so the header's stale addTag closure always reads the latest value
    const valueRef = (0, $kYL7Z.useRef)(value);
    valueRef.current = value;
    const handleAddWithKey = (0, $kYL7Z.useCallback)((key)=>{
        if (editMode === 'collapsible') setCollapsedMap((prev)=>({
                ...prev,
                [key]: false
            }));
        onChange({
            ...valueRef.current || {},
            [key]: buildDefaults()
        });
    }, [
        editMode,
        onChange,
        buildDefaults
    ]);
    const availableKeys = propertyNames ? propertyNames.filter((k)=>!value || value[k] === undefined) : null;
    const [newKeyText, setNewKeyText] = (0, $kYL7Z.useState)('');
    const [addOpen, setAddOpen] = (0, $kYL7Z.useState)(false);
    const newKeyTrimmed = newKeyText.trim();
    const newKeyExists = newKeyTrimmed && value && value[newKeyTrimmed] !== undefined;
    const handleAddWithText = ()=>{
        if (!newKeyTrimmed || newKeyExists) return;
        handleAddWithKey(newKeyTrimmed);
        setNewKeyText('');
        setAddOpen(false);
    };
    const handleRemove = (key)=>{
        const { [key]: _, ...rest } = value;
        onChange(rest);
    };
    const titleError = (key)=>{
        if (!itemTitle || !entryErrors) return undefined;
        const errs = entryErrors(key);
        return errs.find((e)=>e.instancePath === '/' + itemTitle);
    };
    const descriptionError = (key)=>{
        if (!itemDescription || !entryErrors) return undefined;
        const errs = entryErrors(key);
        return errs.find((e)=>e.instancePath === '/' + itemDescription);
    };
    const renderTitle = (key, entryValue)=>{
        if (itemTitle && entryValue && typeof entryValue === 'object') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$f9d7171ad5f156a8), {
                    value: entryValue[itemTitle],
                    disabled: disabled || readonly || itemTitleReadOnly,
                    error: titleError(key),
                    type: itemTitleType,
                    depth: depth,
                    placeholder: `(Edit ${itemTitle})`,
                    onChange: (newVal)=>handleEntryChange(key, {
                            ...entryValue,
                            [itemTitle]: newVal
                        })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    round: true,
                    children: key
                })
            ]
        });
        if (allowRenaming && !disabled && !readonly) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c7955e0af01d9b79$var$EditableKey, {
            value: key,
            disabled: false,
            depth: depth,
            onConfirm: (newKey)=>handleRename(key, newKey)
        });
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$cddb8b7ba9e8674e), {
            as: (0, $cd7c29a731f3402d$export$66422503964e48cd)(depth),
            children: key
        });
    };
    const entryTitleText = (key, entryValue)=>itemTitle && entryValue?.[itemTitle] ? String(entryValue[itemTitle]) : key;
    const renderEntryCard = (key, entryValue, dragListeners, isDragging)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$78d37f9aaa77d8), {
            editMode: editMode,
            readonly: readonly,
            collapsed: isCollapsed(key),
            onToggleCollapse: ()=>toggleCollapse(key),
            errors: entryErrors ? entryErrors(key) : [],
            panelWidth: panelWidth,
            dragListeners: dragListeners,
            description: itemDescription && entryValue && typeof entryValue === 'object' ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$1c673afd5aa0b669), {
                value: entryValue[itemDescription],
                disabled: disabled || readonly || itemDescriptionReadOnly,
                error: descriptionError(key),
                type: itemDescriptionType,
                depth: depth,
                placeholder: `(Edit ${itemDescription})`,
                onChange: (newVal)=>handleEntryChange(key, {
                        ...entryValue,
                        [itemDescription]: newVal
                    })
            }) : undefined,
            depth: depth,
            titleText: entryTitleText(key, entryValue),
            title: renderTitle(key, entryValue),
            actions: !disabled && !readonly && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                content: `Remove ${entryTitleText(key, entryValue)}`,
                placement: "top",
                hoverOpenDelay: 400,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$4e9d5ce1e6c22a94), {
                    icon: "cross",
                    minimal: true,
                    small: true,
                    onClick: ()=>handleRemove(key)
                })
            }),
            children: renderEntry(entryValue, key, (newVal)=>handleEntryChange(key, newVal))
        });
    const addTag = entrySchema && !disabled && !readonly ? availableKeys && !availableKeys.length ? null : availableKeys ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
        items: availableKeys,
        itemRenderer: (item, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                text: item,
                active: modifiers.active,
                disabled: modifiers.disabled,
                onClick: handleClick
            }, item),
        itemPredicate: (query, item)=>!query || item.toLowerCase().includes(query.toLowerCase()),
        onItemSelect: handleAddWithKey,
        disabled: !availableKeys.length,
        resetOnClose: true,
        popoverProps: {
            minimal: true,
            placement: 'bottom',
            onOpening: ()=>collectionCtx?.expand()
        },
        filterable: true,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            icon: "plus",
            round: true,
            minimal: true,
            interactive: true,
            intent: "primary",
            children: "Add"
        })
    }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
        isOpen: addOpen,
        onClose: ()=>{
            setAddOpen(false);
            setNewKeyText('');
        },
        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            style: {
                padding: 8,
                display: 'flex',
                gap: 4,
                alignItems: 'center'
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$5f513dadd988fceb), {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                        value: newKeyText,
                        onChange: (e)=>setNewKeyText(e.target.value),
                        placeholder: "Property name",
                        small: true,
                        autoFocus: true,
                        intent: newKeyExists ? 'danger' : 'none',
                        onKeyDown: (e)=>e.key === 'Enter' && handleAddWithText()
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    icon: "tick",
                    small: true,
                    intent: "primary",
                    onClick: handleAddWithText,
                    disabled: !newKeyTrimmed || newKeyExists
                })
            ]
        }),
        placement: "bottom",
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            icon: "plus",
            round: true,
            minimal: true,
            interactive: true,
            intent: "primary",
            onClick: ()=>{
                collectionCtx?.expand();
                setAddOpen(true);
            },
            children: "Add"
        })
    }) : null;
    const headerKey = `${!!error}|${entries.length}|${disabled}|${readonly}|${availableKeys?.length}`;
    (0, $kYL7Z.useEffect)(()=>{
        if (collectionCtx) collectionCtx.setHeaderExtra(headerKey, /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
            children: [
                error && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c7955e0af01d9b79$var$ObjectError, {
                    children: error.message
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    round: true,
                    children: [
                        propertyNames ? `${entries.length}/${propertyNames.length}` : `${entries.length}`,
                        " items"
                    ]
                }),
                addTag
            ]
        }));
    }, [
        headerKey
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c7955e0af01d9b79$var$Wrapper, {
        children: canDrag ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d59febdd5a89527d$export$2d5c5ceac203fc1e), {
            sensors: sensors,
            collisionDetection: (0, $d59febdd5a89527d$export$c8e785ae6b74bab8),
            modifiers: $c7955e0af01d9b79$var$MODIFIERS,
            onDragEnd: handleDragEnd,
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $03fb2278f85c6d47$export$86155fde54f06e6a), {
                    items: entryKeys,
                    strategy: (0, $03fb2278f85c6d47$export$fe2be640df2ffb9e),
                    children: entries.map(([key, entryValue])=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c7955e0af01d9b79$var$SortableEntry, {
                            id: key,
                            children: (listeners, isDragging)=>renderEntryCard(key, entryValue, listeners, isDragging)
                        }, key))
                })
            })
        }) : entries.map(([key, entryValue])=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                children: renderEntryCard(key, entryValue, null)
            }, key))
    });
};







// --- Utilities ---
const $efb7d3097a0a7ab7$var$parseScopePath = (scope)=>{
    if (!scope || scope === '#') return [];
    return scope.replace('#/properties/', '').split('/properties/');
};
const $efb7d3097a0a7ab7$var$setByPath = (obj, path, value)=>{
    if (path.length === 0) return value;
    const result = Array.isArray(obj) ? [
        ...obj
    ] : {
        ...obj
    };
    const [head, ...rest] = path;
    result[head] = rest.length === 0 ? value : $efb7d3097a0a7ab7$var$setByPath(result[head] ?? {}, rest, value);
    return result;
};
const $efb7d3097a0a7ab7$var$labelFromKey = (key)=>key.replace(/([A-Z])/g, ' $1').replace(/^./, (s)=>s.toUpperCase()).trim();
// --- Theme root — CSS custom properties with defaults ---
const $efb7d3097a0a7ab7$var$FormRoot = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    ${(0, $4a49823ead28a6dc$export$9cda184b27147279)}
    --sf-max-width: none;
    --sf-width: 100%;
    width: var(--sf-width);
    max-width: var(--sf-max-width);
`;
// --- Styled layout wrappers ---
const $efb7d3097a0a7ab7$var$VerticalLayoutWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: var(--sf-vertical-gap);
`;
const $efb7d3097a0a7ab7$var$HorizontalLayoutWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: var(--sf-horizontal-gap);
    flex-wrap: ${(p)=>p.$wrap === false ? 'nowrap' : 'wrap'};
    & > * { flex: ${(p)=>p.$wrap === false ? '1' : '1 1 auto'}; }
`;
const $efb7d3097a0a7ab7$var$GroupCard = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $0199c8413a0068dd$export$60332b2344f7fe41))`
    margin: var(--sf-group-margin) 0;
    padding: var(--sf-group-padding);
    border-radius: var(--sf-border-radius);
    background: var(--sf-group-background) !important;

    &[class*="bp"][class*="-card"] {
        box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1),
                    0 1px 1px rgba(17, 20, 24, 0.1),
                    0 2px 6px rgba(17, 20, 24, 0.1);
    }
`;
const $efb7d3097a0a7ab7$var$GroupLabel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $64289e527bcd600c$export$88ef9fdaf11f7a1f))`
    color: var(--sf-group-label-color);
    font-size: var(--sf-group-label-size);
`;
const $efb7d3097a0a7ab7$var$HEADINGS = [
    (0, $64289e527bcd600c$export$746be9e3a3dfff1f),
    (0, $64289e527bcd600c$export$cc5e069d64fda823),
    (0, $64289e527bcd600c$export$88ef9fdaf11f7a1f),
    (0, $64289e527bcd600c$export$a559fb8039b06400)
];
const $efb7d3097a0a7ab7$var$headingFor = (depth)=>$efb7d3097a0a7ab7$var$HEADINGS[Math.min(depth || 0, $efb7d3097a0a7ab7$var$HEADINGS.length - 1)];
const $efb7d3097a0a7ab7$var$GroupHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;
`;
const $efb7d3097a0a7ab7$var$CollapseIcon = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $b90a50544ad30fb8$export$f04a61298a47a40f))`
    color: #5c7080;
`;
const $efb7d3097a0a7ab7$var$collectControlPaths = (element)=>{
    if (!element) return [];
    if (element.type === 'Control') {
        const path = $efb7d3097a0a7ab7$var$parseScopePath(element.scope);
        return [
            path.length ? '/' + path.join('/') : ''
        ];
    }
    if (element.elements) return element.elements.flatMap($efb7d3097a0a7ab7$var$collectControlPaths);
    return [];
};
const $efb7d3097a0a7ab7$var$collectGroupErrors = (element, errors)=>{
    const paths = $efb7d3097a0a7ab7$var$collectControlPaths(element);
    return errors.filter((e)=>{
        const ip = e.instancePath || '';
        return paths.some((p)=>ip === p || ip.startsWith(p + '/'));
    });
};
const $efb7d3097a0a7ab7$var$PortalContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`${(0, $4a49823ead28a6dc$export$9cda184b27147279)}`;
const $efb7d3097a0a7ab7$var$PANEL_WIDTH = 'min(1080px, 90vw)';
const $efb7d3097a0a7ab7$var$PANEL_MODES = {
    popover: true,
    overlay: true,
    drawer: true
};
const $efb7d3097a0a7ab7$var$EditModeGroup = ({ element: element, depth: depth, errors: errors, readonly: readonly, children: children })=>{
    const editMode = element.options?.editMode || (element.options?.collapsed != null ? 'collapsible' : undefined);
    const [collapsed, setCollapsed] = (0, $kYL7Z.useState)(!!element.options?.collapsed);
    const [panelOpen, setPanelOpen] = (0, $kYL7Z.useState)(false);
    const [headerExtra, setHeaderExtra] = (0, $kYL7Z.useState)(null);
    const headerExtraKeyRef = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useRef(null);
    const stableSetHeaderExtra = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useCallback((key, tags)=>{
        if (key !== headerExtraKeyRef.current) {
            headerExtraKeyRef.current = key;
            setHeaderExtra(tags);
        }
    }, []);
    const contentHidden = editMode === 'collapsible' ? collapsed : !!$efb7d3097a0a7ab7$var$PANEL_MODES[editMode];
    const groupErrors = contentHidden ? $efb7d3097a0a7ab7$var$collectGroupErrors(element, errors) : [];
    const expandGroup = ()=>{
        if (editMode === 'collapsible') setCollapsed(false);
        else if ($efb7d3097a0a7ab7$var$PANEL_MODES[editMode]) setPanelOpen(true);
    };
    const content = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$d2615da4cc5487a7).Provider, {
        value: stableSetHeaderExtra,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$VerticalLayoutWrapper, {
            style: {
                marginTop: 8
            },
            children: children
        })
    });
    // Default (no editMode): always expanded, no interactivity
    if (!editMode) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupCard, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
                as: "div",
                style: {
                    cursor: 'default'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                        as: $efb7d3097a0a7ab7$var$headingFor(depth),
                        style: {
                            margin: 0
                        },
                        children: element.label
                    }),
                    headerExtra
                ]
            }),
            content
        ]
    });
    // Collapsible: current caret toggle behavior
    if (editMode === 'collapsible') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupCard, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
                as: "div",
                style: {
                    cursor: 'default'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$CollapseIcon, {
                        icon: collapsed ? 'caret-right' : 'caret-down',
                        onClick: ()=>setCollapsed((c)=>!c)
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                        as: $efb7d3097a0a7ab7$var$headingFor(depth),
                        style: {
                            margin: 0
                        },
                        children: element.label
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                        errors: groupErrors,
                        onClick: expandGroup
                    }),
                    headerExtra
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $e4a7ce8c396337d4$export$78768a9af065a7b), {
                isOpen: !collapsed,
                keepChildrenMounted: true,
                children: content
            })
        ]
    });
    // Popover: edit icon, hover opens popover with content
    const pw = element.options?.panelWidth || $efb7d3097a0a7ab7$var$PANEL_WIDTH;
    if (editMode === 'popover') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupCard, {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
            as: "div",
            style: {
                cursor: 'default'
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                    interactionKind: "hover",
                    placement: "right-start",
                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$PortalContent, {
                        style: {
                            padding: 12,
                            width: pw,
                            maxHeight: 400,
                            overflow: 'auto'
                        },
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                                as: $efb7d3097a0a7ab7$var$headingFor(depth),
                                style: {
                                    margin: '0 0 8px'
                                },
                                children: element.label
                            }),
                            content
                        ]
                    }),
                    hoverOpenDelay: 200,
                    hoverCloseDelay: 100,
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: readonly ? 'eye-open' : 'edit',
                        style: {
                            color: '#5c7080',
                            cursor: 'pointer'
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                    as: $efb7d3097a0a7ab7$var$headingFor(depth),
                    style: {
                        margin: 0
                    },
                    children: element.label
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                    errors: groupErrors,
                    onClick: expandGroup
                }),
                headerExtra
            ]
        })
    });
    // Overlay / Drawer: edit icon, click opens Dialog or Drawer
    const Panel = editMode === 'drawer' ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        isOpen: panelOpen,
        onClose: ()=>setPanelOpen(false),
        size: pw,
        title: element.label,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$PortalContent, {
            style: {
                padding: 20
            },
            children: content
        })
    }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
        isOpen: panelOpen,
        onClose: ()=>setPanelOpen(false),
        title: element.label,
        style: {
            width: pw
        },
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$PortalContent, {
                children: content
            })
        })
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupCard, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
                as: "div",
                style: {
                    cursor: 'default'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: readonly ? 'eye-open' : 'edit',
                        style: {
                            color: '#5c7080',
                            cursor: 'pointer'
                        },
                        onClick: ()=>setPanelOpen(true)
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                        as: $efb7d3097a0a7ab7$var$headingFor(depth),
                        style: {
                            margin: 0
                        },
                        children: element.label
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                        errors: groupErrors,
                        onClick: expandGroup
                    }),
                    headerExtra
                ]
            }),
            Panel
        ]
    });
};
const $efb7d3097a0a7ab7$var$CollectionGroup = ({ label: label, title: title, description: description, depth: depth, editMode: editModeProp, initialCollapsed: initialCollapsed, readonly: readonly, errors: groupErrors, panelWidth: panelWidth, children: children })=>{
    const editMode = editModeProp || (initialCollapsed != null ? 'collapsible' : undefined);
    const [collapsed, setCollapsed] = (0, $kYL7Z.useState)(!!initialCollapsed);
    const [panelOpen, setPanelOpen] = (0, $kYL7Z.useState)(false);
    const [headerExtra, setHeaderExtra] = (0, $kYL7Z.useState)(null);
    const headerExtraKeyRef = (0, $kYL7Z.useRef)(null);
    const stableSetHeaderExtra = (0, $kYL7Z.useCallback)((key, tags)=>{
        if (key !== headerExtraKeyRef.current) {
            headerExtraKeyRef.current = key;
            setHeaderExtra(tags);
        }
    }, []);
    const expand = (0, $kYL7Z.useCallback)(()=>{
        if (editMode === 'collapsible') setCollapsed(false);
        else if ($efb7d3097a0a7ab7$var$PANEL_MODES[editMode]) setPanelOpen(true);
    }, [
        editMode
    ]);
    const collectionCtx = (0, $kYL7Z.useMemo)(()=>({
            setHeaderExtra: stableSetHeaderExtra,
            expand: expand
        }), [
        stableSetHeaderExtra,
        expand
    ]);
    const contentHidden = editMode === 'collapsible' ? collapsed : !!$efb7d3097a0a7ab7$var$PANEL_MODES[editMode];
    const visibleErrors = contentHidden ? groupErrors || [] : [];
    const inner = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$53146c55f8a78b).Provider, {
        value: collectionCtx,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$d2615da4cc5487a7).Provider, {
            value: null,
            children: children
        })
    });
    // Default (no editMode): card with title/label + headerExtra + description + children
    if (!editMode) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupCard, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
                as: "div",
                style: {
                    cursor: 'default'
                },
                children: [
                    title || label && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                        as: $efb7d3097a0a7ab7$var$headingFor(depth),
                        style: {
                            margin: 0
                        },
                        children: label
                    }),
                    headerExtra
                ]
            }),
            description,
            inner
        ]
    });
    // Collapsible: caret toggle
    if (editMode === 'collapsible') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupCard, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
                as: "div",
                style: {
                    cursor: 'default'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$CollapseIcon, {
                        icon: collapsed ? 'caret-right' : 'caret-down',
                        onClick: ()=>setCollapsed((c)=>!c)
                    }),
                    title || label && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                        as: $efb7d3097a0a7ab7$var$headingFor(depth),
                        style: {
                            margin: 0
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                        errors: visibleErrors,
                        onClick: expand
                    }),
                    headerExtra
                ]
            }),
            description,
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $e4a7ce8c396337d4$export$78768a9af065a7b), {
                isOpen: !collapsed,
                keepChildrenMounted: true,
                children: inner
            })
        ]
    });
    // Popover: hover opens popover with title + description + headerExtra + children
    const pw = panelWidth || $efb7d3097a0a7ab7$var$PANEL_WIDTH;
    if (editMode === 'popover') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupCard, {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
            as: "div",
            style: {
                cursor: 'default'
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                    interactionKind: "hover",
                    placement: "right-start",
                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$PortalContent, {
                        style: {
                            padding: 12,
                            width: pw,
                            maxHeight: 400,
                            overflow: 'auto'
                        },
                        children: [
                            title || label && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                                as: $efb7d3097a0a7ab7$var$headingFor(depth),
                                style: {
                                    margin: '0 0 8px'
                                },
                                children: label
                            }),
                            description,
                            headerExtra,
                            inner
                        ]
                    }),
                    hoverOpenDelay: 200,
                    hoverCloseDelay: 100,
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: readonly ? 'eye-open' : 'edit',
                        style: {
                            color: '#5c7080',
                            cursor: 'pointer'
                        }
                    })
                }),
                label && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                    as: $efb7d3097a0a7ab7$var$headingFor(depth),
                    style: {
                        margin: 0
                    },
                    children: label
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                    errors: visibleErrors,
                    onClick: expand
                })
            ]
        })
    });
    // Drawer / Overlay: click opens panel
    const panelTitle = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
        style: {
            display: 'flex',
            alignItems: 'center',
            gap: 6
        },
        children: [
            title || label,
            headerExtra,
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                errors: groupErrors || []
            })
        ]
    });
    const Panel = editMode === 'drawer' ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        isOpen: panelOpen,
        onClose: ()=>setPanelOpen(false),
        size: pw,
        title: panelTitle,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$PortalContent, {
            style: {
                padding: 20
            },
            children: [
                description,
                inner
            ]
        })
    }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
        isOpen: panelOpen,
        onClose: ()=>setPanelOpen(false),
        title: panelTitle,
        style: {
            width: pw
        },
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$PortalContent, {
                children: [
                    description,
                    inner
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupCard, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$GroupHeader, {
                as: "div",
                style: {
                    cursor: 'default'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: readonly ? 'eye-open' : 'edit',
                        style: {
                            color: '#5c7080',
                            cursor: 'pointer'
                        },
                        onClick: ()=>setPanelOpen(true)
                    }),
                    label && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupLabel, {
                        as: $efb7d3097a0a7ab7$var$headingFor(depth),
                        style: {
                            margin: 0
                        },
                        children: label
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$270fdfb6d7e81102), {
                        errors: visibleErrors,
                        onClick: expand
                    })
                ]
            }),
            Panel
        ]
    });
};
// --- Schema → field resolution ---
const $efb7d3097a0a7ab7$var$isType = (schema, t)=>schema.type === t || Array.isArray(schema.type) && schema.type.includes(t);
const $efb7d3097a0a7ab7$var$resolveField = (fieldSchema, options)=>{
    // options.renderer takes priority — lets consumers inject custom field types
    if (options?.renderer) return options.renderer;
    if (options?.levels) return 'cascading-select';
    if ($efb7d3097a0a7ab7$var$isType(fieldSchema, 'boolean') || options?.toggle) return 'switch';
    // Object: nested:false opt-out → JSON textarea; otherwise auto-nest
    if ($efb7d3097a0a7ab7$var$isType(fieldSchema, 'object') && options?.nested === false) return 'json-textarea';
    if ($efb7d3097a0a7ab7$var$isType(fieldSchema, 'object') && options?.multi) return 'json-textarea'; // backward compat
    if ($efb7d3097a0a7ab7$var$isType(fieldSchema, 'object') && (fieldSchema.properties || fieldSchema.additionalProperties)) return 'object';
    if (options?.multi) return 'textarea';
    if (options?.multiselect) return 'multiselect';
    // Array: objects → array-of-objects; primitives → multiselect
    if ($efb7d3097a0a7ab7$var$isType(fieldSchema, 'array') && fieldSchema.items?.type === 'object' && fieldSchema.items?.properties) return 'array-of-objects';
    if ($efb7d3097a0a7ab7$var$isType(fieldSchema, 'array')) return 'multiselect';
    if (fieldSchema.format === 'date-time') return 'date-picker';
    if (fieldSchema.enum) return 'select';
    if (fieldSchema.oneOf) return 'select';
    if (fieldSchema.examples) return 'select';
    return 'text';
};
const $efb7d3097a0a7ab7$var$buildFieldProps = (fieldSchema, value, label, disabled, error, options, required)=>{
    const displayLabel = required ? `${label} (required)` : label;
    const base = {
        label: displayLabel,
        value: value,
        disabled: disabled,
        error: error,
        icon: options?.icon
    };
    switch($efb7d3097a0a7ab7$var$resolveField(fieldSchema, options)){
        case 'switch':
            return {
                field: 'switch',
                props: base
            };
        case 'textarea':
            return {
                field: 'textarea',
                props: {
                    ...base,
                    rows: options?.rows
                }
            };
        case 'json-textarea':
            return {
                field: 'json-textarea',
                props: {
                    ...base,
                    rows: options?.rows,
                    schema: fieldSchema
                }
            };
        case 'multiselect':
            {
                const itemSchema = fieldSchema.items || fieldSchema;
                let msOptions;
                let allowCreate = false;
                if (itemSchema.examples) {
                    msOptions = itemSchema.examples.map((v)=>({
                            label: String(v),
                            value: v
                        }));
                    allowCreate = true;
                } else if (itemSchema.enum) msOptions = itemSchema.enum.map((v)=>({
                        label: String(v),
                        value: v
                    }));
                else if (itemSchema.oneOf) msOptions = itemSchema.oneOf.filter((o)=>o.const !== '').map((o)=>({
                        label: o.title || String(o.const),
                        value: o.const
                    }));
                else {
                    msOptions = [];
                    allowCreate = true;
                }
                const msNullable = Array.isArray(fieldSchema.type) && fieldSchema.type.includes('null');
                return {
                    field: 'multiselect',
                    props: {
                        ...base,
                        rawLabel: label,
                        options: msOptions,
                        allowCreate: allowCreate,
                        nullable: msNullable,
                        placeholder: options?.placeholder,
                        fill: options?.fill,
                        matchTargetWidth: options?.matchTargetWidth,
                        showMax: options?.showMax
                    }
                };
            }
        case 'date-picker':
            return {
                field: 'date-picker',
                props: {
                    ...base,
                    time: options?.time,
                    fill: options?.fill
                }
            };
        case 'select':
            {
                let selectOptions;
                let allowCreate = false;
                if (fieldSchema.examples) {
                    selectOptions = fieldSchema.examples.map((v)=>({
                            label: String(v),
                            value: v
                        }));
                    allowCreate = true;
                } else if (fieldSchema.enum) selectOptions = fieldSchema.enum.map((v)=>({
                        label: String(v),
                        value: v
                    }));
                else if (fieldSchema.oneOf) selectOptions = fieldSchema.oneOf.filter((o)=>o.const !== '').map((o)=>({
                        label: o.title || String(o.const),
                        value: o.const
                    }));
                return {
                    field: 'select',
                    props: {
                        ...base,
                        options: selectOptions,
                        required: required,
                        allowCreate: allowCreate,
                        fill: options?.fill,
                        matchTargetWidth: options?.matchTargetWidth
                    }
                };
            }
        default:
            {
                const nullable = Array.isArray(fieldSchema.type) && fieldSchema.type.includes('null');
                const optional = !required || nullable;
                return {
                    field: 'text',
                    props: {
                        ...base,
                        nullable: nullable,
                        optional: optional
                    }
                };
            }
    }
};
// Built-in field registry
const $efb7d3097a0a7ab7$var$builtinFields = {
    text: (0, $ae01e54584616062$export$2c73285ae9390cec),
    select: (0, $ff643fbd30c6097b$export$d55b50a564d0b931),
    multiselect: (0, $5b1fe30c6fd5e00d$export$4efd8d874a0cb609),
    switch: (0, $975d12346ccd0e6b$export$208c2e617baf9fc3),
    textarea: (0, $4d2d3b6573676c4d$export$301bf6213f61d17f),
    'json-textarea': (0, $7d01f98e6cb87248$export$a724837acbf4d78b),
    'date-picker': (0, $b8e847414b2fda26$export$34dc4cfa15ead1)
};
// --- Auto-layout for nested objects ---
const $efb7d3097a0a7ab7$var$generateAutoLayout = (objectSchema, horizontal)=>({
        type: horizontal ? 'HorizontalLayout' : 'VerticalLayout',
        elements: Object.keys(objectSchema.properties).map((key)=>({
                type: 'Control',
                scope: '#/properties/' + key
            }))
    });
// Strip header fields (itemTitle, itemDescription) from a UI schema so they only render in the card header
const $efb7d3097a0a7ab7$var$stripHeaderControls = (uischema, fields)=>{
    if (!fields.length || !uischema) return uischema;
    const scopes = new Set(fields.map((f)=>'#/properties/' + f));
    if (uischema.type === 'Control') return scopes.has(uischema.scope) ? null : uischema;
    if (uischema.elements) {
        const filtered = uischema.elements.map((el)=>$efb7d3097a0a7ab7$var$stripHeaderControls(el, fields)).filter(Boolean);
        return {
            ...uischema,
            elements: filtered
        };
    }
    return uischema;
};
// --- Recursive element renderer ---
const $efb7d3097a0a7ab7$var$RenderElement = ({ element: element, schema: schema, data: data, readonly: readonly, errors: errors, renderers: renderers, depth: depth = 0, onChange: onChange })=>{
    const recurse = (child, i)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$RenderElement, {
            element: child,
            schema: schema,
            data: data,
            readonly: readonly,
            errors: errors,
            renderers: renderers,
            depth: depth,
            onChange: onChange
        }, i);
    switch(element.type){
        case 'VerticalLayout':
            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$VerticalLayoutWrapper, {
                children: element.elements.map(recurse)
            });
        case 'HorizontalLayout':
            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$HorizontalLayoutWrapper, {
                $wrap: element.options?.wrap,
                children: element.elements.map(recurse)
            });
        case 'Group':
            {
                const hasResolvable = (els)=>els.some((el)=>{
                        if (el.type === 'Control') return !!(0, $adeac7fc1fb1e32e$export$d463cb62e398d222)(schema, $efb7d3097a0a7ab7$var$parseScopePath(el.scope), data);
                        return el.elements ? hasResolvable(el.elements) : false;
                    });
                if (!hasResolvable(element.elements)) {
                    if (element.label) console.warn(`[SchemaForm] Group "${element.label}" hidden \u{2014} no resolvable fields`);
                    return null;
                }
                if (!element.label) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$GroupCard, {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$VerticalLayoutWrapper, {
                        children: element.elements.map(recurse)
                    })
                });
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$EditModeGroup, {
                    element: element,
                    depth: depth,
                    errors: errors,
                    readonly: readonly,
                    children: element.elements.map(recurse)
                });
            }
        case 'Control':
            {
                const path = $efb7d3097a0a7ab7$var$parseScopePath(element.scope);
                const fieldSchema = (0, $adeac7fc1fb1e32e$export$d463cb62e398d222)(schema, path, data);
                if (!fieldSchema) return null;
                const value = (0, $adeac7fc1fb1e32e$export$44b5bed83342a92f)(data, path);
                const fieldKey = path[path.length - 1];
                const label = element.label ?? (fieldKey ? $efb7d3097a0a7ab7$var$labelFromKey(fieldKey) : '');
                const instancePath = path.length ? '/' + path.join('/') : '';
                const error = errors.find((e)=>e.instancePath === instancePath);
                // Check if field is required by its parent schema
                const parentPath = path.slice(0, -1);
                const parentSchema = parentPath.length === 0 ? schema : (0, $adeac7fc1fb1e32e$export$d463cb62e398d222)(schema, parentPath, data);
                const required = (parentSchema?.required || []).includes(fieldKey);
                const disabled = readonly || fieldSchema.readOnly === true || element.options?.disabled === true || element.rule?.effect === 'DISABLE';
                const handleChange = (newValue)=>{
                    onChange($efb7d3097a0a7ab7$var$setByPath(data, path, newValue));
                };
                // Custom renderer — gets full context
                const rendererName = element.options?.renderer;
                if (rendererName && renderers?.[rendererName]) {
                    const CustomRenderer = renderers[rendererName];
                    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)(CustomRenderer, {
                        label: label,
                        value: value,
                        disabled: disabled,
                        error: error,
                        required: required,
                        schema: fieldSchema,
                        data: data,
                        options: element.options,
                        onChange: handleChange
                    });
                }
                // Auto-nested object — generate a Group with Controls for each property
                const fieldType = $efb7d3097a0a7ab7$var$resolveField(fieldSchema, element.options);
                if (fieldType === 'object') {
                    const allowRenaming = element.options?.allowPropertyRenaming;
                    const additionalPropsSchema = fieldSchema.additionalProperties;
                    // Dynamic object: editable keys and/or additional properties
                    if (allowRenaming || additionalPropsSchema) {
                        const horizontal = element.options?.horizontal;
                        const entrySchema = typeof additionalPropsSchema === 'object' ? additionalPropsSchema : null;
                        const getEntrySchema = (key)=>{
                            let base = fieldSchema.properties?.[key] || entrySchema;
                            if (fieldSchema.dependentSchemas && value && typeof value === 'object') {
                                for (const [depKey, depSchema] of Object.entries(fieldSchema.dependentSchemas))if (depKey in value && depSchema?.properties?.[key]) base = (0, $adeac7fc1fb1e32e$export$106587181eda0dce)(base, depSchema.properties[key]);
                            }
                            return base;
                        };
                        const entryErrors = (key)=>errors.filter((e)=>e.instancePath.startsWith(instancePath + '/' + key + '/')).map((e)=>({
                                    ...e,
                                    instancePath: e.instancePath.slice(instancePath.length + ('/' + key).length)
                                }));
                        const titleKey = element.options?.itemTitle;
                        const titleVal = titleKey && value && typeof value === 'object' && !Array.isArray(value) && value[titleKey] !== undefined ? value[titleKey] : undefined;
                        const titlePropSchema = titleVal !== undefined ? fieldSchema.properties?.[titleKey] : null;
                        const collectionTitle = titleVal !== undefined ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$f9d7171ad5f156a8), {
                            value: titleVal,
                            disabled: disabled || !!titlePropSchema?.readOnly || !!element.options?.itemTitleReadOnly,
                            error: errors.find((e)=>e.instancePath === instancePath + '/' + titleKey),
                            type: titlePropSchema?.type,
                            depth: depth,
                            placeholder: `(Edit ${titleKey})`,
                            onChange: (newVal)=>handleChange({
                                    ...value,
                                    [titleKey]: newVal
                                })
                        }) : undefined;
                        const descKey = element.options?.itemDescription;
                        const descVal = descKey && value && typeof value === 'object' && !Array.isArray(value) && value[descKey] !== undefined ? value[descKey] : undefined;
                        const descPropSchema = descVal !== undefined ? fieldSchema.properties?.[descKey] : null;
                        const collectionDesc = descVal !== undefined ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$1c673afd5aa0b669), {
                            value: descVal,
                            disabled: disabled || !!descPropSchema?.readOnly || !!element.options?.itemDescriptionReadOnly,
                            error: errors.find((e)=>e.instancePath === instancePath + '/' + descKey),
                            type: descPropSchema?.type,
                            depth: depth,
                            placeholder: `(Edit ${descKey})`,
                            onChange: (newVal)=>handleChange({
                                    ...value,
                                    [descKey]: newVal
                                })
                        }) : undefined;
                        const itemOpts = element.options?.itemUISchema?.options;
                        const subErrors = errors.filter((e)=>{
                            const ip = e.instancePath || '';
                            return ip === instancePath || ip.startsWith(instancePath + '/');
                        });
                        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$CollectionGroup, {
                            label: label,
                            depth: depth,
                            title: collectionTitle,
                            description: collectionDesc,
                            editMode: element.options?.editMode,
                            initialCollapsed: element.options?.collapsed,
                            readonly: readonly,
                            errors: subErrors,
                            panelWidth: element.options?.panelWidth,
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c7955e0af01d9b79$export$d142a6500a7b8fab), {
                                value: value || {},
                                disabled: disabled,
                                readonly: readonly,
                                reorderable: element.options?.reorderable !== false,
                                editMode: itemOpts?.editMode,
                                initialCollapsed: itemOpts?.collapsed,
                                entrySchema: entrySchema,
                                allowRenaming: !!allowRenaming,
                                propertyNames: fieldSchema.propertyNames?.enum,
                                fill: element.options?.fill,
                                depth: depth,
                                itemTitle: itemOpts?.itemTitle,
                                itemTitleReadOnly: itemOpts?.itemTitleReadOnly,
                                itemTitleType: entrySchema?.properties?.[itemOpts?.itemTitle]?.type,
                                itemDescription: itemOpts?.itemDescription,
                                itemDescriptionReadOnly: itemOpts?.itemDescriptionReadOnly,
                                itemDescriptionType: entrySchema?.properties?.[itemOpts?.itemDescription]?.type,
                                panelWidth: itemOpts?.panelWidth,
                                entryErrors: entryErrors,
                                error: error,
                                renderEntry: (entryValue, key, onEntryChange)=>{
                                    const s = getEntrySchema(key);
                                    if (!s || !s.properties) return null;
                                    let layout = element.options?.itemUISchemas?.[key] || element.options?.itemUISchema || $efb7d3097a0a7ab7$var$generateAutoLayout(s, horizontal);
                                    if (layout.type === 'Control' && !$efb7d3097a0a7ab7$var$parseScopePath(layout.scope).length && s.properties) layout = layout.options?.itemUISchema || $efb7d3097a0a7ab7$var$generateAutoLayout(s, layout.options?.horizontal || horizontal);
                                    const headerFields = [
                                        itemOpts?.itemTitle,
                                        itemOpts?.itemDescription
                                    ].filter(Boolean);
                                    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$RenderElement, {
                                        element: $efb7d3097a0a7ab7$var$stripHeaderControls(layout, headerFields),
                                        schema: s,
                                        data: entryValue || {},
                                        readonly: readonly,
                                        errors: entryErrors(key),
                                        renderers: renderers,
                                        depth: depth + 1,
                                        onChange: onEntryChange
                                    });
                                },
                                onChange: handleChange
                            })
                        });
                    }
                    const innerLayout = element.options?.itemUISchema || $efb7d3097a0a7ab7$var$generateAutoLayout(fieldSchema, element.options?.horizontal);
                    // Root-scope object: render layout directly, no collection group wrapper
                    if (path.length === 0) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$RenderElement, {
                        element: innerLayout,
                        schema: schema,
                        data: data,
                        readonly: readonly,
                        errors: errors,
                        renderers: renderers,
                        depth: depth,
                        onChange: onChange
                    });
                    const objTitleKey = element.options?.itemTitle;
                    const objTitleVal = objTitleKey && value && typeof value === 'object' && !Array.isArray(value) && value[objTitleKey] !== undefined ? value[objTitleKey] : undefined;
                    const objTitlePropSchema = objTitleVal !== undefined ? fieldSchema.properties?.[objTitleKey] : null;
                    const objTitle = objTitleVal !== undefined ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$f9d7171ad5f156a8), {
                        value: objTitleVal,
                        disabled: disabled || !!objTitlePropSchema?.readOnly || !!element.options?.itemTitleReadOnly,
                        error: errors.find((e)=>e.instancePath === instancePath + '/' + objTitleKey),
                        type: objTitlePropSchema?.type,
                        depth: depth,
                        placeholder: `(Edit ${objTitleKey})`,
                        onChange: (newVal)=>handleChange({
                                ...value,
                                [objTitleKey]: newVal
                            })
                    }) : undefined;
                    const objDescKey = element.options?.itemDescription;
                    const objDescVal = objDescKey && value && typeof value === 'object' && !Array.isArray(value) && value[objDescKey] !== undefined ? value[objDescKey] : undefined;
                    const objDescPropSchema = objDescVal !== undefined ? fieldSchema.properties?.[objDescKey] : null;
                    const objDesc = objDescVal !== undefined ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $cd7c29a731f3402d$export$1c673afd5aa0b669), {
                        value: objDescVal,
                        disabled: disabled || !!objDescPropSchema?.readOnly || !!element.options?.itemDescriptionReadOnly,
                        error: errors.find((e)=>e.instancePath === instancePath + '/' + objDescKey),
                        type: objDescPropSchema?.type,
                        depth: depth,
                        placeholder: `(Edit ${objDescKey})`,
                        onChange: (newVal)=>handleChange({
                                ...value,
                                [objDescKey]: newVal
                            })
                    }) : undefined;
                    const headerFields = [
                        objTitleKey,
                        objDescKey
                    ].filter(Boolean);
                    const subErrors = errors.filter((e)=>{
                        const ip = e.instancePath || '';
                        return ip === instancePath || ip.startsWith(instancePath + '/');
                    });
                    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$CollectionGroup, {
                        label: label,
                        depth: depth,
                        title: objTitle,
                        description: objDesc,
                        editMode: element.options?.editMode,
                        initialCollapsed: element.options?.collapsed,
                        readonly: readonly,
                        errors: subErrors,
                        panelWidth: element.options?.panelWidth,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$RenderElement, {
                            element: $efb7d3097a0a7ab7$var$stripHeaderControls(innerLayout, headerFields),
                            schema: schema,
                            data: data,
                            readonly: readonly,
                            errors: errors,
                            renderers: renderers,
                            depth: depth + 1,
                            onChange: onChange
                        })
                    });
                }
                // Array of objects — render items as cards with nested fields
                if (fieldType === 'array-of-objects') {
                    const itemSchema = fieldSchema.items;
                    const horizontal = element.options?.horizontal;
                    const itemErrors = (index)=>errors.filter((e)=>e.instancePath.startsWith(instancePath + '/' + index + '/')).map((e)=>({
                                ...e,
                                instancePath: e.instancePath.slice(instancePath.length + ('/' + index).length)
                            }));
                    const arrItemOpts = element.options?.itemUISchema?.options;
                    const subErrors = errors.filter((e)=>{
                        const ip = e.instancePath || '';
                        return ip === instancePath || ip.startsWith(instancePath + '/');
                    });
                    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$CollectionGroup, {
                        label: label,
                        depth: depth,
                        editMode: element.options?.editMode,
                        initialCollapsed: element.options?.collapsed,
                        readonly: readonly,
                        errors: subErrors,
                        panelWidth: element.options?.panelWidth,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6594c3cd3a940aa3$export$42efeba470be9198), {
                            value: value || [],
                            nullable: Array.isArray(fieldSchema.type) && fieldSchema.type.includes('null'),
                            disabled: disabled,
                            readonly: readonly,
                            reorderable: element.options?.reorderable !== false,
                            horizontal: element.options?.horizontal,
                            editMode: arrItemOpts?.editMode,
                            initialCollapsed: arrItemOpts?.collapsed,
                            maxItems: fieldSchema.maxItems,
                            itemSchema: itemSchema,
                            depth: depth,
                            itemTitle: arrItemOpts?.itemTitle,
                            itemTitleReadOnly: arrItemOpts?.itemTitleReadOnly,
                            itemTitleType: itemSchema.properties?.[arrItemOpts?.itemTitle]?.type,
                            itemDescription: arrItemOpts?.itemDescription,
                            itemDescriptionReadOnly: arrItemOpts?.itemDescriptionReadOnly,
                            itemDescriptionType: itemSchema.properties?.[arrItemOpts?.itemDescription]?.type,
                            panelWidth: arrItemOpts?.panelWidth,
                            itemErrors: itemErrors,
                            error: error,
                            renderItem: (item, index, onItemChange)=>{
                                let layout = element.options?.itemUISchema || $efb7d3097a0a7ab7$var$generateAutoLayout(itemSchema, horizontal);
                                if (layout.type === 'Control' && !$efb7d3097a0a7ab7$var$parseScopePath(layout.scope).length && itemSchema.properties) layout = layout.options?.itemUISchema || $efb7d3097a0a7ab7$var$generateAutoLayout(itemSchema, layout.options?.horizontal || horizontal);
                                const headerFields = [
                                    arrItemOpts?.itemTitle,
                                    arrItemOpts?.itemDescription
                                ].filter(Boolean);
                                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$RenderElement, {
                                    element: $efb7d3097a0a7ab7$var$stripHeaderControls(layout, headerFields),
                                    schema: itemSchema,
                                    data: item || {},
                                    readonly: readonly,
                                    errors: itemErrors(index),
                                    renderers: renderers,
                                    depth: depth + 1,
                                    onChange: onItemChange
                                });
                            },
                            onChange: handleChange
                        })
                    });
                }
                // Cascading select — multi-level dependent selector
                if (fieldType === 'cascading-select') {
                    const subErrors = errors.filter((e)=>e.instancePath === instancePath || e.instancePath.startsWith(instancePath + '/'));
                    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0007956562a61430$export$78df0038885c98f9), {
                        label: required ? `${label} (required)` : label,
                        value: value || {},
                        disabled: disabled,
                        error: subErrors[0],
                        levels: element.options.levels,
                        multi: element.options.multi,
                        onChange: handleChange
                    });
                }
                // Built-in field
                const { field: field, props: props } = $efb7d3097a0a7ab7$var$buildFieldProps(fieldSchema, value, label, disabled, error, element.options, required);
                const FieldComponent = $efb7d3097a0a7ab7$var$builtinFields[field];
                const fieldEl = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)(FieldComponent, {
                    ...props,
                    onChange: handleChange
                });
                const { minWidth: minWidth, maxWidth: maxWidth } = element.options || {};
                if (minWidth || maxWidth) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    style: {
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    },
                    children: fieldEl
                });
                return fieldEl;
            }
        default:
            return null;
    }
};
// --- Debug overlay (REACT_APP_DEBUG_FORMS=true) ---
const $efb7d3097a0a7ab7$var$DEBUG_FORMS = false;
const $efb7d3097a0a7ab7$var$DebugOverlay = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin-top: 8px;
    border: 1px dashed rgba(17, 20, 24, 0.3);
    border-radius: 6px;
    overflow: hidden;
`;
const $efb7d3097a0a7ab7$var$DebugHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 4px 8px;
    font-size: 11px;
    font-weight: 600;
    color: #5c7080;
    background: rgba(17, 20, 24, 0.04);
    cursor: pointer;
    user-select: none;
`;
const $efb7d3097a0a7ab7$var$DebugTextArea = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).textarea`
    width: 100%;
    border: none;
    outline: none;
    resize: vertical;
    padding: 8px;
    font-family: monospace;
    font-size: 12px;
    line-height: 1.4;
    color: #394b59;
    background: rgba(17, 20, 24, 0.02);
    box-sizing: border-box;
`;
// --- Main component ---
const $efb7d3097a0a7ab7$var$toErrorList = (errors)=>errors.map((e)=>({
            [e.instancePath || '/']: e.message
        }));
const $efb7d3097a0a7ab7$export$becd7412971443d4 = /*#__PURE__*/ (0, $kYL7Z.memo)(({ schema: schema, uischema: uischema, data: data, readonly: readonly = false, depth: depth = 0, renderers: renderers, style: style, className: className, onChange: onChange })=>{
    const handleChange = (newData)=>{
        if (!onChange) return;
        const errors = (0, $adeac7fc1fb1e32e$export$a22775fa5e2eebd9)(schema, newData);
        onChange({
            data: newData,
            errors: $efb7d3097a0a7ab7$var$toErrorList(errors)
        });
    };
    const errors = (0, $kYL7Z.useMemo)(()=>(0, $adeac7fc1fb1e32e$export$a22775fa5e2eebd9)(schema, data), [
        schema,
        data
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$FormRoot, {
        style: style,
        className: className,
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$RenderElement, {
                element: uischema,
                schema: schema,
                data: data,
                readonly: readonly,
                errors: errors,
                renderers: renderers,
                depth: depth,
                onChange: handleChange
            }),
            $efb7d3097a0a7ab7$var$DEBUG_FORMS && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($efb7d3097a0a7ab7$var$DebugOverlay, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$DebugHeader, {
                        children: "Form Data"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($efb7d3097a0a7ab7$var$DebugTextArea, {
                        readOnly: true,
                        rows: Math.min(JSON.stringify(data, null, 2).split('\n').length, 20),
                        value: JSON.stringify(data, null, 2)
                    })
                ]
            })
        ]
    });
}, (prev, next)=>prev.schema === next.schema && prev.uischema === next.uischema && prev.data === next.data && prev.readonly === next.readonly && prev.depth === next.depth && prev.renderers === next.renderers && prev.style === next.style && prev.className === next.className);


const $301b430ddba68118$var$_OrgSchema = {
    type: "object",
    required: [
        "name"
    ],
    properties: {
        name: {
            type: "string",
            maxLength: 128
        },
        options: {
            type: "object",
            required: [
                "startOfWeek"
            ],
            properties: {
                startOfWeek: {
                    type: "string",
                    enum: [
                        "sunday",
                        "monday"
                    ]
                },
                showSettingUpLocations: {
                    type: "boolean",
                    default: false
                },
                disableAgeAndGenderOnFrontEnd: {
                    type: "boolean",
                    default: false
                },
                ignoreLingerUnderOverride: {
                    type: "boolean",
                    default: false
                },
                isDemoUser: {
                    type: "boolean",
                    default: false
                },
                orgHasStaffDetection: {
                    type: "boolean",
                    default: false
                },
                showDemoLivePage: {
                    type: "boolean",
                    default: false
                },
                showHeadcountPlanner: {
                    type: "boolean",
                    default: false
                },
                showLivePage: {
                    type: "boolean",
                    default: false
                },
                hasInteractionHeatmaps: {
                    type: "boolean",
                    default: false
                },
                useCaptureRateV2: {
                    type: "boolean",
                    default: false
                }
            }
        }
    }
};
const $301b430ddba68118$var$_UIOrgSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Group",
            label: "Information",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/name"
                }
            ]
        },
        {
            type: "Group",
            label: "Options",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/options/properties/startOfWeek"
                },
                ...Object.keys($301b430ddba68118$var$_OrgSchema.properties.options.properties).filter((key)=>$301b430ddba68118$var$_OrgSchema.properties.options.properties[key].type === "boolean").map((key)=>({
                        type: "Control",
                        scope: "#/properties/options/properties/" + key,
                        options: {
                            toggle: true
                        }
                    }))
            ]
        }
    ]
};
const $301b430ddba68118$var$ContentWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).form`
  width: 90%;
  margin: 2em auto;
  overflow: auto;
`;
const $301b430ddba68118$var$StyledButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    display: block;
    margin: 2em auto;
`;
const $301b430ddba68118$export$1388bbe784880b7c = ({ isOpen: isOpen, onClose: onClose, onSave: onSave })=>{
    const [formData, setFormData] = (0, $kYL7Z.useState)({
        name: "",
        options: {
            startOfWeek: "monday",
            showSettingUpLocations: false,
            disableAgeAndGenderOnFrontEnd: false,
            ignoreLingerUnderOverride: false,
            isDemoUser: false,
            orgHasStaffDetection: false,
            showDemoLivePage: false,
            showHeadcountPlanner: false,
            showLivePage: false,
            hasInteractionHeatmaps: false,
            useCaptureRateV2: true
        }
    });
    const [hasFormError, setHasFormError] = (0, $kYL7Z.useState)(false);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        title: "Creating an organisation",
        isOpen: isOpen,
        onClose: onClose,
        size: "50%",
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($301b430ddba68118$var$ContentWrapper, {
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                    schema: $301b430ddba68118$var$_OrgSchema,
                    uischema: $301b430ddba68118$var$_UIOrgSchema,
                    data: formData,
                    onChange: ({ data: data, errors: errors })=>{
                        setHasFormError(!!errors.length);
                        setFormData(data);
                    }
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($301b430ddba68118$var$StyledButton, {
                    text: "Create",
                    intent: "primary",
                    fill: true,
                    disabled: hasFormError,
                    onClick: ()=>onSave({
                            ...formData
                        })
                })
            ]
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");

var $kYL7Z = parcelRequire("kYL7Z");

var $cRanb = parcelRequire("cRanb");
function $2f1546e0ec584d2b$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $2f1546e0ec584d2b$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $2f1546e0ec584d2b$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $2f1546e0ec584d2b$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $2f1546e0ec584d2b$export$2e2bcd8739ae039 = $2f1546e0ec584d2b$export$4f5d2d50c9deca37;



//#region src/utils/colSpanUtils.ts
function $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, args) {
    const colSpan = typeof column.colSpan === "function" ? column.colSpan(args) : 1;
    if (Number.isInteger(colSpan) && colSpan > 1 && (!column.frozen || column.idx + colSpan - 1 <= lastFrozenColumnIndex)) return colSpan;
    return void 0;
}
//#endregion
//#region src/utils/domUtils.ts
function $7829d25231ee1190$var$stopPropagation(event) {
    event.stopPropagation();
}
function $7829d25231ee1190$var$scrollIntoView(element, behavior = "instant") {
    element?.scrollIntoView({
        inline: "nearest",
        block: "nearest",
        behavior: behavior
    });
}
//#endregion
//#region src/utils/eventUtils.ts
function $7829d25231ee1190$var$createCellEvent(event) {
    let defaultPrevented = false;
    const cellEvent = {
        ...event,
        preventGridDefault () {
            defaultPrevented = true;
        },
        isGridDefaultPrevented () {
            return defaultPrevented;
        }
    };
    Object.setPrototypeOf(cellEvent, Object.getPrototypeOf(event));
    return cellEvent;
}
//#endregion
//#region src/utils/keyboardUtils.ts
const $7829d25231ee1190$var$nonInputKeys = new Set([
    "Unidentified",
    "Alt",
    "AltGraph",
    "CapsLock",
    "Control",
    "Fn",
    "FnLock",
    "Meta",
    "NumLock",
    "ScrollLock",
    "Shift",
    "Tab",
    "ArrowDown",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "End",
    "Home",
    "PageDown",
    "PageUp",
    "Insert",
    "ContextMenu",
    "Escape",
    "Pause",
    "Play",
    "PrintScreen",
    "F1",
    "F3",
    "F4",
    "F5",
    "F6",
    "F7",
    "F8",
    "F9",
    "F10",
    "F11",
    "F12"
]);
function $7829d25231ee1190$var$isCtrlKeyHeldDown(e) {
    return (e.ctrlKey || e.metaKey) && e.key !== "Control";
}
const $7829d25231ee1190$var$vKey = 86;
function $7829d25231ee1190$var$isDefaultCellInput(event, isUserHandlingPaste) {
    if ($7829d25231ee1190$var$isCtrlKeyHeldDown(event) && (event.keyCode !== $7829d25231ee1190$var$vKey || isUserHandlingPaste)) return false;
    return !$7829d25231ee1190$var$nonInputKeys.has(event.key);
}
/**
* By default, the following navigation keys are enabled while an editor is open, under specific conditions:
* - Tab:
*   - The editor must be an <input>, a <textarea>, or a <select> element.
*   - The editor element must be the only immediate child of the editor container/a label.
*/ function $7829d25231ee1190$var$onEditorNavigation({ key: key, target: target }) {
    if (key === "Tab" && (target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement || target instanceof HTMLSelectElement)) return target.closest(".rdg-editor-container")?.querySelectorAll("input, textarea, select").length === 1;
    return false;
}
function $7829d25231ee1190$var$getLeftRightKey(direction) {
    const isRtl = direction === "rtl";
    return {
        leftKey: isRtl ? "ArrowRight" : "ArrowLeft",
        rightKey: isRtl ? "ArrowLeft" : "ArrowRight"
    };
}
//#endregion
//#region src/utils/renderMeasuringCells.tsx
const $7829d25231ee1190$var$measuringCellClassname = "mlln6zg7-0-0-beta-57";
function $7829d25231ee1190$var$renderMeasuringCells(viewportColumns) {
    return viewportColumns.map(({ key: key, idx: idx, minWidth: minWidth, maxWidth: maxWidth })=>/* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: $7829d25231ee1190$var$measuringCellClassname,
            style: {
                gridColumnStart: idx + 1,
                minWidth: minWidth,
                maxWidth: maxWidth
            },
            "data-measuring-cell-key": key
        }, key));
}
//#endregion
//#region src/utils/selectedCellUtils.ts
function $7829d25231ee1190$var$isSelectedCellEditable({ selectedPosition: selectedPosition, columns: columns, rows: rows }) {
    const column = columns[selectedPosition.idx];
    const row$1 = rows[selectedPosition.rowIdx];
    return $7829d25231ee1190$var$isCellEditableUtil(column, row$1);
}
function $7829d25231ee1190$var$isCellEditableUtil(column, row$1) {
    return column.renderEditCell != null && (typeof column.editable === "function" ? column.editable(row$1) : column.editable) !== false;
}
function $7829d25231ee1190$var$getSelectedCellColSpan({ rows: rows, topSummaryRows: topSummaryRows, bottomSummaryRows: bottomSummaryRows, rowIdx: rowIdx, mainHeaderRowIdx: mainHeaderRowIdx, lastFrozenColumnIndex: lastFrozenColumnIndex, column: column }) {
    const topSummaryRowsCount = topSummaryRows?.length ?? 0;
    if (rowIdx === mainHeaderRowIdx) return $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
        type: "HEADER"
    });
    if (topSummaryRows && rowIdx > mainHeaderRowIdx && rowIdx <= topSummaryRowsCount + mainHeaderRowIdx) return $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
        type: "SUMMARY",
        row: topSummaryRows[rowIdx + topSummaryRowsCount]
    });
    if (rowIdx >= 0 && rowIdx < rows.length) {
        const row$1 = rows[rowIdx];
        return $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
            type: "ROW",
            row: row$1
        });
    }
    if (bottomSummaryRows) return $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
        type: "SUMMARY",
        row: bottomSummaryRows[rowIdx - rows.length]
    });
    return void 0;
}
function $7829d25231ee1190$var$getNextSelectedCellPosition({ moveUp: moveUp, moveNext: moveNext, cellNavigationMode: cellNavigationMode, columns: columns, colSpanColumns: colSpanColumns, rows: rows, topSummaryRows: topSummaryRows, bottomSummaryRows: bottomSummaryRows, minRowIdx: minRowIdx, mainHeaderRowIdx: mainHeaderRowIdx, maxRowIdx: maxRowIdx, currentPosition: { idx: currentIdx, rowIdx: currentRowIdx }, nextPosition: nextPosition, lastFrozenColumnIndex: lastFrozenColumnIndex, isCellWithinBounds: isCellWithinBounds }) {
    let { idx: nextIdx, rowIdx: nextRowIdx } = nextPosition;
    const columnsCount = columns.length;
    const setColSpan = (moveNext$1)=>{
        for (const column of colSpanColumns){
            const colIdx = column.idx;
            if (colIdx > nextIdx) break;
            const colSpan = $7829d25231ee1190$var$getSelectedCellColSpan({
                rows: rows,
                topSummaryRows: topSummaryRows,
                bottomSummaryRows: bottomSummaryRows,
                rowIdx: nextRowIdx,
                mainHeaderRowIdx: mainHeaderRowIdx,
                lastFrozenColumnIndex: lastFrozenColumnIndex,
                column: column
            });
            if (colSpan && nextIdx > colIdx && nextIdx < colSpan + colIdx) {
                nextIdx = colIdx + (moveNext$1 ? colSpan : 0);
                break;
            }
        }
    };
    const getParentRowIdx = (parent)=>{
        return parent.level + mainHeaderRowIdx;
    };
    const setHeaderGroupColAndRowSpan = ()=>{
        if (moveNext) {
            const nextColumn = columns[nextIdx];
            let parent = nextColumn.parent;
            while(parent !== void 0){
                const parentRowIdx = getParentRowIdx(parent);
                if (nextRowIdx === parentRowIdx) {
                    nextIdx = parent.idx + parent.colSpan;
                    break;
                }
                parent = parent.parent;
            }
        } else if (moveUp) {
            const nextColumn = columns[nextIdx];
            let parent = nextColumn.parent;
            let found = false;
            while(parent !== void 0){
                const parentRowIdx = getParentRowIdx(parent);
                if (nextRowIdx >= parentRowIdx) {
                    nextIdx = parent.idx;
                    nextRowIdx = parentRowIdx;
                    found = true;
                    break;
                }
                parent = parent.parent;
            }
            if (!found) {
                nextIdx = currentIdx;
                nextRowIdx = currentRowIdx;
            }
        }
    };
    if (isCellWithinBounds(nextPosition)) {
        setColSpan(moveNext);
        if (nextRowIdx < mainHeaderRowIdx) setHeaderGroupColAndRowSpan();
    }
    if (cellNavigationMode === "CHANGE_ROW") {
        const isAfterLastColumn = nextIdx === columnsCount;
        const isBeforeFirstColumn = nextIdx === -1;
        if (isAfterLastColumn) {
            const isLastRow = nextRowIdx === maxRowIdx;
            if (!isLastRow) {
                nextIdx = 0;
                nextRowIdx += 1;
            }
        } else if (isBeforeFirstColumn) {
            const isFirstRow = nextRowIdx === minRowIdx;
            if (!isFirstRow) {
                nextRowIdx -= 1;
                nextIdx = columnsCount - 1;
            }
            setColSpan(false);
        }
    }
    if (nextRowIdx < mainHeaderRowIdx && nextIdx > -1 && nextIdx < columnsCount) {
        const nextColumn = columns[nextIdx];
        let parent = nextColumn.parent;
        const nextParentRowIdx = nextRowIdx;
        nextRowIdx = mainHeaderRowIdx;
        while(parent !== void 0){
            const parentRowIdx = getParentRowIdx(parent);
            if (parentRowIdx >= nextParentRowIdx) {
                nextRowIdx = parentRowIdx;
                nextIdx = parent.idx;
            }
            parent = parent.parent;
        }
    }
    return {
        idx: nextIdx,
        rowIdx: nextRowIdx
    };
}
function $7829d25231ee1190$var$canExitGrid({ maxColIdx: maxColIdx, minRowIdx: minRowIdx, maxRowIdx: maxRowIdx, selectedPosition: { rowIdx: rowIdx, idx: idx }, shiftKey: shiftKey }) {
    const atLastCellInRow = idx === maxColIdx;
    const atFirstCellInRow = idx === 0;
    const atLastRow = rowIdx === maxRowIdx;
    const atFirstRow = rowIdx === minRowIdx;
    return shiftKey ? atFirstCellInRow && atFirstRow : atLastCellInRow && atLastRow;
}
//#endregion
//#region src/style/cell.ts
const $7829d25231ee1190$var$cell = "cj343x07-0-0-beta-57";
const $7829d25231ee1190$var$cellClassname = `rdg-cell ${$7829d25231ee1190$var$cell}`;
const $7829d25231ee1190$var$cellFrozen = "csofj7r7-0-0-beta-57";
const $7829d25231ee1190$var$cellFrozenClassname = `rdg-cell-frozen ${$7829d25231ee1190$var$cellFrozen}`;
const $7829d25231ee1190$var$cellDragHandle = "ch2wcw87-0-0-beta-57";
const $7829d25231ee1190$var$cellDragHandleFrozenClassname = "c1wvphzh7-0-0-beta-57";
const $7829d25231ee1190$var$cellDragHandleClassname = `rdg-cell-drag-handle ${$7829d25231ee1190$var$cellDragHandle}`;
//#endregion
//#region src/utils/styleUtils.ts
function $7829d25231ee1190$var$getRowStyle(rowIdx) {
    return {
        "--rdg-grid-row-start": rowIdx
    };
}
function $7829d25231ee1190$var$getHeaderCellStyle(column, rowIdx, rowSpan) {
    const gridRowEnd = rowIdx + 1;
    const paddingBlockStart = `calc(${rowSpan - 1} * var(--rdg-header-row-height))`;
    if (column.parent === void 0) return {
        insetBlockStart: 0,
        gridRowStart: 1,
        gridRowEnd: gridRowEnd,
        paddingBlockStart: paddingBlockStart
    };
    return {
        insetBlockStart: `calc(${rowIdx - rowSpan} * var(--rdg-header-row-height))`,
        gridRowStart: gridRowEnd - rowSpan,
        gridRowEnd: gridRowEnd,
        paddingBlockStart: paddingBlockStart
    };
}
function $7829d25231ee1190$var$getCellStyle(column, colSpan = 1) {
    const index = column.idx + 1;
    return {
        gridColumnStart: index,
        gridColumnEnd: index + colSpan,
        insetInlineStart: column.frozen ? `var(--rdg-frozen-left-${column.idx})` : void 0
    };
}
function $7829d25231ee1190$var$getCellClassname(column, ...extraClasses) {
    return (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$cellClassname, {
        [$7829d25231ee1190$var$cellFrozenClassname]: column.frozen
    }, ...extraClasses);
}
//#endregion
//#region src/utils/index.ts
const { min: $7829d25231ee1190$var$min, max: $7829d25231ee1190$var$max, floor: $7829d25231ee1190$var$floor, sign: $7829d25231ee1190$var$sign, abs: $7829d25231ee1190$var$abs } = Math;
function $7829d25231ee1190$var$assertIsValidKeyGetter(keyGetter) {
    if (typeof keyGetter !== "function") throw new Error("Please specify the rowKeyGetter prop to use selection");
}
function $7829d25231ee1190$var$clampColumnWidth(width, { minWidth: minWidth, maxWidth: maxWidth }) {
    width = $7829d25231ee1190$var$max(width, minWidth);
    if (typeof maxWidth === "number" && maxWidth >= minWidth) return $7829d25231ee1190$var$min(width, maxWidth);
    return width;
}
function $7829d25231ee1190$var$getHeaderCellRowSpan(column, rowIdx) {
    return column.parent === void 0 ? rowIdx : column.level - column.parent.level;
}
//#endregion
//#region src/cellRenderers/renderCheckbox.tsx
const $7829d25231ee1190$var$checkbox = "c1bn88vv7-0-0-beta-57";
const $7829d25231ee1190$var$checkboxClassname = `rdg-checkbox-input ${$7829d25231ee1190$var$checkbox}`;
function $7829d25231ee1190$export$ade4cf7dfdc949fa({ onChange: onChange, indeterminate: indeterminate, ...props }) {
    function handleChange(e) {
        onChange(e.target.checked, e.nativeEvent.shiftKey);
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("input", {
        ref: (el)=>{
            if (el) el.indeterminate = indeterminate === true;
        },
        type: "checkbox",
        className: $7829d25231ee1190$var$checkboxClassname,
        onChange: handleChange,
        ...props
    });
}
//#endregion
//#region src/cellRenderers/renderToggleGroup.tsx
const $7829d25231ee1190$var$groupCellContent = "g1s9ylgp7-0-0-beta-57";
const $7829d25231ee1190$var$groupCellContentClassname = `rdg-group-cell-content ${$7829d25231ee1190$var$groupCellContent}`;
const $7829d25231ee1190$var$caret = "cz54e4y7-0-0-beta-57";
const $7829d25231ee1190$var$caretClassname = `rdg-caret ${$7829d25231ee1190$var$caret}`;
function $7829d25231ee1190$export$623abc142db48841(props) {
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$export$af3ec21f6cfb5e30, {
        ...props
    });
}
function $7829d25231ee1190$export$af3ec21f6cfb5e30({ groupKey: groupKey, isExpanded: isExpanded, tabIndex: tabIndex, toggleGroup: toggleGroup }) {
    function handleKeyDown({ key: key }) {
        if (key === "Enter") toggleGroup();
    }
    const d = isExpanded ? "M1 1 L 7 7 L 13 1" : "M1 7 L 7 1 L 13 7";
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
        className: $7829d25231ee1190$var$groupCellContentClassname,
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        children: [
            groupKey,
            /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("svg", {
                viewBox: "0 0 14 8",
                width: "14",
                height: "8",
                className: $7829d25231ee1190$var$caretClassname,
                "aria-hidden": true,
                children: /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("path", {
                    d: d
                })
            })
        ]
    });
}
//#endregion
//#region src/cellRenderers/renderValue.tsx
function $7829d25231ee1190$export$c0c0f59166d66116(props) {
    try {
        return props.row[props.column.key];
    } catch  {
        return null;
    }
}
//#endregion
//#region src/DataGridDefaultRenderersContext.ts
const $7829d25231ee1190$export$2bb5fbcb8b262dfb = (0, $kYL7Z.createContext)(void 0);
function $7829d25231ee1190$var$useDefaultRenderers() {
    return (0, $kYL7Z.useContext)($7829d25231ee1190$export$2bb5fbcb8b262dfb);
}
//#endregion
//#region src/cellRenderers/SelectCellFormatter.tsx
function $7829d25231ee1190$export$38ad6414f4075b66({ value: value, tabIndex: tabIndex, indeterminate: indeterminate, disabled: disabled, onChange: onChange, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy }) {
    const renderCheckbox$1 = $7829d25231ee1190$var$useDefaultRenderers().renderCheckbox;
    return renderCheckbox$1({
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex,
        indeterminate: indeterminate,
        disabled: disabled,
        checked: value,
        onChange: onChange
    });
}
//#endregion
//#region src/hooks/useRowSelection.ts
const $7829d25231ee1190$var$RowSelectionContext = (0, $kYL7Z.createContext)(void 0);
const $7829d25231ee1190$var$RowSelectionChangeContext = (0, $kYL7Z.createContext)(void 0);
function $7829d25231ee1190$export$4e5ce46ca43d2ed5() {
    const rowSelectionContext = (0, $kYL7Z.useContext)($7829d25231ee1190$var$RowSelectionContext);
    const rowSelectionChangeContext = (0, $kYL7Z.useContext)($7829d25231ee1190$var$RowSelectionChangeContext);
    if (rowSelectionContext === void 0 || rowSelectionChangeContext === void 0) throw new Error("useRowSelection must be used within renderCell");
    return {
        isRowSelectionDisabled: rowSelectionContext.isRowSelectionDisabled,
        isRowSelected: rowSelectionContext.isRowSelected,
        onRowSelectionChange: rowSelectionChangeContext
    };
}
const $7829d25231ee1190$var$HeaderRowSelectionContext = (0, $kYL7Z.createContext)(void 0);
const $7829d25231ee1190$var$HeaderRowSelectionChangeContext = (0, $kYL7Z.createContext)(void 0);
function $7829d25231ee1190$export$c594c270a279937b() {
    const headerRowSelectionContext = (0, $kYL7Z.useContext)($7829d25231ee1190$var$HeaderRowSelectionContext);
    const headerRowSelectionChangeContext = (0, $kYL7Z.useContext)($7829d25231ee1190$var$HeaderRowSelectionChangeContext);
    if (headerRowSelectionContext === void 0 || headerRowSelectionChangeContext === void 0) throw new Error("useHeaderRowSelection must be used within renderHeaderCell");
    return {
        isIndeterminate: headerRowSelectionContext.isIndeterminate,
        isRowSelected: headerRowSelectionContext.isRowSelected,
        onRowSelectionChange: headerRowSelectionChangeContext
    };
}
//#endregion
//#region src/Columns.tsx
const $7829d25231ee1190$export$eae764166299b939 = "rdg-select-column";
function $7829d25231ee1190$var$HeaderRenderer(props) {
    const { isIndeterminate: isIndeterminate, isRowSelected: isRowSelected, onRowSelectionChange: onRowSelectionChange } = $7829d25231ee1190$export$c594c270a279937b();
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$export$38ad6414f4075b66, {
        "aria-label": "Select All",
        tabIndex: props.tabIndex,
        indeterminate: isIndeterminate,
        value: isRowSelected,
        onChange: (checked)=>{
            onRowSelectionChange({
                checked: isIndeterminate ? false : checked
            });
        }
    });
}
function $7829d25231ee1190$var$SelectFormatter(props) {
    const { isRowSelectionDisabled: isRowSelectionDisabled, isRowSelected: isRowSelected, onRowSelectionChange: onRowSelectionChange } = $7829d25231ee1190$export$4e5ce46ca43d2ed5();
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$export$38ad6414f4075b66, {
        "aria-label": "Select",
        tabIndex: props.tabIndex,
        disabled: isRowSelectionDisabled,
        value: isRowSelected,
        onChange: (checked, isShiftClick)=>{
            onRowSelectionChange({
                row: props.row,
                checked: checked,
                isShiftClick: isShiftClick
            });
        }
    });
}
function $7829d25231ee1190$var$SelectGroupFormatter(props) {
    const { isRowSelected: isRowSelected, onRowSelectionChange: onRowSelectionChange } = $7829d25231ee1190$export$4e5ce46ca43d2ed5();
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$export$38ad6414f4075b66, {
        "aria-label": "Select Group",
        tabIndex: props.tabIndex,
        value: isRowSelected,
        onChange: (checked)=>{
            onRowSelectionChange({
                row: props.row,
                checked: checked,
                isShiftClick: false
            });
        }
    });
}
const $7829d25231ee1190$export$9a88921b3aa404b3 = {
    key: $7829d25231ee1190$export$eae764166299b939,
    name: "",
    width: 35,
    minWidth: 35,
    maxWidth: 35,
    resizable: false,
    sortable: false,
    frozen: true,
    renderHeaderCell (props) {
        return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$HeaderRenderer, {
            ...props
        });
    },
    renderCell (props) {
        return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$SelectFormatter, {
            ...props
        });
    },
    renderGroupCell (props) {
        return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$SelectGroupFormatter, {
            ...props
        });
    }
};
//#endregion
//#region src/renderHeaderCell.tsx
const $7829d25231ee1190$var$headerSortCellClassname = "h44jtk67-0-0-beta-57";
const $7829d25231ee1190$var$headerSortName = "hcgkhxz7-0-0-beta-57";
const $7829d25231ee1190$var$headerSortNameClassname = `rdg-header-sort-name ${$7829d25231ee1190$var$headerSortName}`;
function $7829d25231ee1190$export$5f862125c2a3adea({ column: column, sortDirection: sortDirection, priority: priority }) {
    if (!column.sortable) return column.name;
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$SortableHeaderCell, {
        sortDirection: sortDirection,
        priority: priority,
        children: column.name
    });
}
function $7829d25231ee1190$var$SortableHeaderCell({ sortDirection: sortDirection, priority: priority, children: children }) {
    const renderSortStatus$1 = $7829d25231ee1190$var$useDefaultRenderers().renderSortStatus;
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
        className: $7829d25231ee1190$var$headerSortCellClassname,
        children: [
            /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                className: $7829d25231ee1190$var$headerSortNameClassname,
                children: children
            }),
            /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                children: renderSortStatus$1({
                    sortDirection: sortDirection,
                    priority: priority
                })
            })
        ]
    });
}
//#endregion
//#region src/hooks/useCalculatedColumns.ts
const $7829d25231ee1190$var$DEFAULT_COLUMN_WIDTH = "auto";
const $7829d25231ee1190$var$DEFAULT_COLUMN_MIN_WIDTH = 50;
function $7829d25231ee1190$var$useCalculatedColumns({ rawColumns: rawColumns, defaultColumnOptions: defaultColumnOptions, getColumnWidth: getColumnWidth, viewportWidth: viewportWidth, scrollLeft: scrollLeft, enableVirtualization: enableVirtualization }) {
    const defaultWidth = defaultColumnOptions?.width ?? $7829d25231ee1190$var$DEFAULT_COLUMN_WIDTH;
    const defaultMinWidth = defaultColumnOptions?.minWidth ?? $7829d25231ee1190$var$DEFAULT_COLUMN_MIN_WIDTH;
    const defaultMaxWidth = defaultColumnOptions?.maxWidth ?? void 0;
    const defaultRenderCell$1 = defaultColumnOptions?.renderCell ?? $7829d25231ee1190$export$c0c0f59166d66116;
    const defaultRenderHeaderCell = defaultColumnOptions?.renderHeaderCell ?? $7829d25231ee1190$export$5f862125c2a3adea;
    const defaultSortable = defaultColumnOptions?.sortable ?? false;
    const defaultResizable = defaultColumnOptions?.resizable ?? false;
    const defaultDraggable = defaultColumnOptions?.draggable ?? false;
    const { columns: columns, colSpanColumns: colSpanColumns, lastFrozenColumnIndex: lastFrozenColumnIndex, headerRowsCount: headerRowsCount } = (0, $kYL7Z.useMemo)(()=>{
        let lastFrozenColumnIndex$1 = -1;
        let headerRowsCount$1 = 1;
        const columns$1 = [];
        collectColumns(rawColumns, 1);
        function collectColumns(rawColumns$1, level, parent) {
            for (const rawColumn of rawColumns$1){
                if ("children" in rawColumn) {
                    const calculatedColumnParent = {
                        name: rawColumn.name,
                        parent: parent,
                        idx: -1,
                        colSpan: 0,
                        level: 0,
                        headerCellClass: rawColumn.headerCellClass
                    };
                    collectColumns(rawColumn.children, level + 1, calculatedColumnParent);
                    continue;
                }
                const frozen = rawColumn.frozen ?? false;
                const column = {
                    ...rawColumn,
                    parent: parent,
                    idx: 0,
                    level: 0,
                    frozen: frozen,
                    width: rawColumn.width ?? defaultWidth,
                    minWidth: rawColumn.minWidth ?? defaultMinWidth,
                    maxWidth: rawColumn.maxWidth ?? defaultMaxWidth,
                    sortable: rawColumn.sortable ?? defaultSortable,
                    resizable: rawColumn.resizable ?? defaultResizable,
                    draggable: rawColumn.draggable ?? defaultDraggable,
                    renderCell: rawColumn.renderCell ?? defaultRenderCell$1,
                    renderHeaderCell: rawColumn.renderHeaderCell ?? defaultRenderHeaderCell
                };
                columns$1.push(column);
                if (frozen) lastFrozenColumnIndex$1++;
                if (level > headerRowsCount$1) headerRowsCount$1 = level;
            }
        }
        columns$1.sort(({ key: aKey, frozen: frozenA }, { key: bKey, frozen: frozenB })=>{
            if (aKey === $7829d25231ee1190$export$eae764166299b939) return -1;
            if (bKey === $7829d25231ee1190$export$eae764166299b939) return 1;
            if (frozenA) {
                if (frozenB) return 0;
                return -1;
            }
            if (frozenB) return 1;
            return 0;
        });
        const colSpanColumns$1 = [];
        columns$1.forEach((column, idx)=>{
            column.idx = idx;
            $7829d25231ee1190$var$updateColumnParent(column, idx, 0);
            if (column.colSpan != null) colSpanColumns$1.push(column);
        });
        return {
            columns: columns$1,
            colSpanColumns: colSpanColumns$1,
            lastFrozenColumnIndex: lastFrozenColumnIndex$1,
            headerRowsCount: headerRowsCount$1
        };
    }, [
        rawColumns,
        defaultWidth,
        defaultMinWidth,
        defaultMaxWidth,
        defaultRenderCell$1,
        defaultRenderHeaderCell,
        defaultResizable,
        defaultSortable,
        defaultDraggable
    ]);
    const { templateColumns: templateColumns, layoutCssVars: layoutCssVars, totalFrozenColumnWidth: totalFrozenColumnWidth, columnMetrics: columnMetrics } = (0, $kYL7Z.useMemo)(()=>{
        const columnMetrics$1 = new Map();
        let left = 0;
        let totalFrozenColumnWidth$1 = 0;
        const templateColumns$1 = [];
        for (const column of columns){
            let width = getColumnWidth(column);
            if (typeof width === "number") width = $7829d25231ee1190$var$clampColumnWidth(width, column);
            else width = column.minWidth;
            templateColumns$1.push(`${width}px`);
            columnMetrics$1.set(column, {
                width: width,
                left: left
            });
            left += width;
        }
        if (lastFrozenColumnIndex !== -1) {
            const columnMetric = columnMetrics$1.get(columns[lastFrozenColumnIndex]);
            totalFrozenColumnWidth$1 = columnMetric.left + columnMetric.width;
        }
        const layoutCssVars$1 = {};
        for(let i = 0; i <= lastFrozenColumnIndex; i++){
            const column = columns[i];
            layoutCssVars$1[`--rdg-frozen-left-${column.idx}`] = `${columnMetrics$1.get(column).left}px`;
        }
        return {
            templateColumns: templateColumns$1,
            layoutCssVars: layoutCssVars$1,
            totalFrozenColumnWidth: totalFrozenColumnWidth$1,
            columnMetrics: columnMetrics$1
        };
    }, [
        getColumnWidth,
        columns,
        lastFrozenColumnIndex
    ]);
    const [colOverscanStartIdx, colOverscanEndIdx] = (0, $kYL7Z.useMemo)(()=>{
        if (!enableVirtualization) return [
            0,
            columns.length - 1
        ];
        const viewportLeft = scrollLeft + totalFrozenColumnWidth;
        const viewportRight = scrollLeft + viewportWidth;
        const lastColIdx = columns.length - 1;
        const firstUnfrozenColumnIdx = $7829d25231ee1190$var$min(lastFrozenColumnIndex + 1, lastColIdx);
        if (viewportLeft >= viewportRight) return [
            firstUnfrozenColumnIdx,
            firstUnfrozenColumnIdx
        ];
        let colVisibleStartIdx = firstUnfrozenColumnIdx;
        while(colVisibleStartIdx < lastColIdx){
            const { left: left, width: width } = columnMetrics.get(columns[colVisibleStartIdx]);
            if (left + width > viewportLeft) break;
            colVisibleStartIdx++;
        }
        let colVisibleEndIdx = colVisibleStartIdx;
        while(colVisibleEndIdx < lastColIdx){
            const { left: left, width: width } = columnMetrics.get(columns[colVisibleEndIdx]);
            if (left + width >= viewportRight) break;
            colVisibleEndIdx++;
        }
        const colOverscanStartIdx$1 = $7829d25231ee1190$var$max(firstUnfrozenColumnIdx, colVisibleStartIdx - 1);
        const colOverscanEndIdx$1 = $7829d25231ee1190$var$min(lastColIdx, colVisibleEndIdx + 1);
        return [
            colOverscanStartIdx$1,
            colOverscanEndIdx$1
        ];
    }, [
        columnMetrics,
        columns,
        lastFrozenColumnIndex,
        scrollLeft,
        totalFrozenColumnWidth,
        viewportWidth,
        enableVirtualization
    ]);
    return {
        columns: columns,
        colSpanColumns: colSpanColumns,
        colOverscanStartIdx: colOverscanStartIdx,
        colOverscanEndIdx: colOverscanEndIdx,
        templateColumns: templateColumns,
        layoutCssVars: layoutCssVars,
        headerRowsCount: headerRowsCount,
        lastFrozenColumnIndex: lastFrozenColumnIndex,
        totalFrozenColumnWidth: totalFrozenColumnWidth
    };
}
function $7829d25231ee1190$var$updateColumnParent(column, index, level) {
    if (level < column.level) column.level = level;
    if (column.parent !== void 0) {
        const { parent: parent } = column;
        if (parent.idx === -1) parent.idx = index;
        parent.colSpan += 1;
        $7829d25231ee1190$var$updateColumnParent(parent, index, level - 1);
    }
}
//#endregion
//#region src/hooks/useColumnWidths.ts
function $7829d25231ee1190$var$useColumnWidths(columns, viewportColumns, templateColumns, gridRef, gridWidth, columnWidths, onColumnWidthsChange, onColumnResize, setColumnResizing) {
    const [columnToAutoResize, setColumnToAutoResize] = (0, $kYL7Z.useState)(null);
    const [columnsToMeasureOnResize, setColumnsToMeasureOnResize] = (0, $kYL7Z.useState)(null);
    const [prevGridWidth, setPreviousGridWidth] = (0, $kYL7Z.useState)(gridWidth);
    const columnsCanFlex = columns.length === viewportColumns.length;
    const ignorePreviouslyMeasuredColumnsOnGridWidthChange = columnsCanFlex && gridWidth !== prevGridWidth;
    const newTemplateColumns = [
        ...templateColumns
    ];
    const columnsToMeasure = [];
    for (const { key: key, idx: idx, width: width } of viewportColumns){
        const columnWidth = columnWidths.get(key);
        if (key === columnToAutoResize?.key) {
            newTemplateColumns[idx] = columnToAutoResize.width === "max-content" ? columnToAutoResize.width : `${columnToAutoResize.width}px`;
            columnsToMeasure.push(key);
        } else if (typeof width === "string" && columnWidth?.type !== "resized" && (ignorePreviouslyMeasuredColumnsOnGridWidthChange || columnsToMeasureOnResize?.has(key) === true || columnWidth === void 0)) {
            newTemplateColumns[idx] = width;
            columnsToMeasure.push(key);
        }
    }
    const gridTemplateColumns = newTemplateColumns.join(" ");
    (0, $kYL7Z.useLayoutEffect)(updateMeasuredAndResizedWidths);
    function updateMeasuredAndResizedWidths() {
        setPreviousGridWidth(gridWidth);
        if (columnsToMeasure.length === 0) return;
        const newColumnWidths = new Map(columnWidths);
        let hasChanges = false;
        for (const key of columnsToMeasure){
            const measuredWidth = $7829d25231ee1190$var$measureColumnWidth(gridRef, key);
            hasChanges ||= measuredWidth !== columnWidths.get(key)?.width;
            if (measuredWidth === void 0) newColumnWidths.delete(key);
            else newColumnWidths.set(key, {
                type: "measured",
                width: measuredWidth
            });
        }
        if (columnToAutoResize !== null) {
            const resizingKey = columnToAutoResize.key;
            const oldWidth = columnWidths.get(resizingKey)?.width;
            const newWidth = $7829d25231ee1190$var$measureColumnWidth(gridRef, resizingKey);
            if (newWidth !== void 0 && oldWidth !== newWidth) {
                hasChanges = true;
                newColumnWidths.set(resizingKey, {
                    type: "resized",
                    width: newWidth
                });
            }
            setColumnToAutoResize(null);
        }
        if (hasChanges) onColumnWidthsChange(newColumnWidths);
    }
    function handleColumnResize(column, nextWidth) {
        const { key: resizingKey } = column;
        (0, $cRanb.flushSync)(()=>{
            if (columnsCanFlex) {
                const columnsToRemeasure = new Set();
                for (const { key: key, width: width } of viewportColumns)if (resizingKey !== key && typeof width === "string" && columnWidths.get(key)?.type !== "resized") columnsToRemeasure.add(key);
                setColumnsToMeasureOnResize(columnsToRemeasure);
            }
            setColumnToAutoResize({
                key: resizingKey,
                width: nextWidth
            });
            setColumnResizing(typeof nextWidth === "number");
        });
        setColumnsToMeasureOnResize(null);
        if (onColumnResize) {
            const previousWidth = columnWidths.get(resizingKey)?.width;
            const newWidth = typeof nextWidth === "number" ? nextWidth : $7829d25231ee1190$var$measureColumnWidth(gridRef, resizingKey);
            if (newWidth !== void 0 && newWidth !== previousWidth) onColumnResize(column, newWidth);
        }
    }
    return {
        gridTemplateColumns: gridTemplateColumns,
        handleColumnResize: handleColumnResize
    };
}
function $7829d25231ee1190$var$measureColumnWidth(gridRef, key) {
    const selector = `[data-measuring-cell-key="${CSS.escape(key)}"]`;
    const measuringCell = gridRef.current?.querySelector(selector);
    return measuringCell?.getBoundingClientRect().width;
}
//#endregion
//#region src/hooks/useGridDimensions.ts
function $7829d25231ee1190$var$useGridDimensions() {
    const gridRef = (0, $kYL7Z.useRef)(null);
    const [inlineSize, setInlineSize] = (0, $kYL7Z.useState)(1);
    const [blockSize, setBlockSize] = (0, $kYL7Z.useState)(1);
    const [horizontalScrollbarHeight, setHorizontalScrollbarHeight] = (0, $kYL7Z.useState)(0);
    (0, $kYL7Z.useLayoutEffect)(()=>{
        const { ResizeObserver: ResizeObserver } = window;
        if (ResizeObserver == null) return;
        const { clientWidth: clientWidth, clientHeight: clientHeight, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = gridRef.current;
        const { width: width, height: height } = gridRef.current.getBoundingClientRect();
        const initialHorizontalScrollbarHeight = offsetHeight - clientHeight;
        const initialWidth = width - offsetWidth + clientWidth;
        const initialHeight = height - initialHorizontalScrollbarHeight;
        setInlineSize(initialWidth);
        setBlockSize(initialHeight);
        setHorizontalScrollbarHeight(initialHorizontalScrollbarHeight);
        const resizeObserver = new ResizeObserver((entries)=>{
            const size = entries[0].contentBoxSize[0];
            const { clientHeight: clientHeight$1, offsetHeight: offsetHeight$1 } = gridRef.current;
            (0, $cRanb.flushSync)(()=>{
                setInlineSize(size.inlineSize);
                setBlockSize(size.blockSize);
                setHorizontalScrollbarHeight(offsetHeight$1 - clientHeight$1);
            });
        });
        resizeObserver.observe(gridRef.current);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, []);
    return [
        gridRef,
        inlineSize,
        blockSize,
        horizontalScrollbarHeight
    ];
}
//#endregion
//#region src/hooks/useLatestFunc.ts
function $7829d25231ee1190$var$useLatestFunc(fn) {
    const ref = (0, $kYL7Z.useRef)(fn);
    (0, $kYL7Z.useLayoutEffect)(()=>{
        ref.current = fn;
    });
    const callbackFn = (0, $kYL7Z.useCallback)((...args)=>{
        ref.current(...args);
    }, []);
    return fn ? callbackFn : fn;
}
//#endregion
//#region src/hooks/useRovingTabIndex.ts
function $7829d25231ee1190$var$useRovingTabIndex(isSelected) {
    const [isChildFocused, setIsChildFocused] = (0, $kYL7Z.useState)(false);
    if (isChildFocused && !isSelected) setIsChildFocused(false);
    function onFocus(event) {
        if (event.target === event.currentTarget) {
            const elementToFocus = event.currentTarget.querySelector("[tabindex=\"0\"]");
            if (elementToFocus !== null) {
                elementToFocus.focus({
                    preventScroll: true
                });
                setIsChildFocused(true);
            } else setIsChildFocused(false);
        } else setIsChildFocused(true);
    }
    const isFocusable = isSelected && !isChildFocused;
    return {
        tabIndex: isFocusable ? 0 : -1,
        childTabIndex: isSelected ? 0 : -1,
        onFocus: isSelected ? onFocus : void 0
    };
}
//#endregion
//#region src/hooks/useViewportColumns.ts
function $7829d25231ee1190$var$useViewportColumns({ columns: columns, colSpanColumns: colSpanColumns, rows: rows, topSummaryRows: topSummaryRows, bottomSummaryRows: bottomSummaryRows, colOverscanStartIdx: colOverscanStartIdx, colOverscanEndIdx: colOverscanEndIdx, lastFrozenColumnIndex: lastFrozenColumnIndex, rowOverscanStartIdx: rowOverscanStartIdx, rowOverscanEndIdx: rowOverscanEndIdx }) {
    const startIdx = (0, $kYL7Z.useMemo)(()=>{
        if (colOverscanStartIdx === 0) return 0;
        let startIdx$1 = colOverscanStartIdx;
        const updateStartIdx = (colIdx, colSpan)=>{
            if (colSpan !== void 0 && colIdx + colSpan > colOverscanStartIdx) {
                startIdx$1 = colIdx;
                return true;
            }
            return false;
        };
        for (const column of colSpanColumns){
            const colIdx = column.idx;
            if (colIdx >= startIdx$1) break;
            if (updateStartIdx(colIdx, $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
                type: "HEADER"
            }))) break;
            for(let rowIdx = rowOverscanStartIdx; rowIdx <= rowOverscanEndIdx; rowIdx++){
                const row$1 = rows[rowIdx];
                if (updateStartIdx(colIdx, $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
                    type: "ROW",
                    row: row$1
                }))) break;
            }
            if (topSummaryRows != null) {
                for (const row$1 of topSummaryRows)if (updateStartIdx(colIdx, $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
                    type: "SUMMARY",
                    row: row$1
                }))) break;
            }
            if (bottomSummaryRows != null) {
                for (const row$1 of bottomSummaryRows)if (updateStartIdx(colIdx, $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
                    type: "SUMMARY",
                    row: row$1
                }))) break;
            }
        }
        return startIdx$1;
    }, [
        rowOverscanStartIdx,
        rowOverscanEndIdx,
        rows,
        topSummaryRows,
        bottomSummaryRows,
        colOverscanStartIdx,
        lastFrozenColumnIndex,
        colSpanColumns
    ]);
    return (0, $kYL7Z.useMemo)(()=>{
        const viewportColumns = [];
        for(let colIdx = 0; colIdx <= colOverscanEndIdx; colIdx++){
            const column = columns[colIdx];
            if (colIdx < startIdx && !column.frozen) continue;
            viewportColumns.push(column);
        }
        return viewportColumns;
    }, [
        startIdx,
        colOverscanEndIdx,
        columns
    ]);
}
//#endregion
//#region src/hooks/useViewportRows.ts
function $7829d25231ee1190$var$useViewportRows({ rows: rows, rowHeight: rowHeight, clientHeight: clientHeight, scrollTop: scrollTop, enableVirtualization: enableVirtualization }) {
    const { totalRowHeight: totalRowHeight, gridTemplateRows: gridTemplateRows, getRowTop: getRowTop, getRowHeight: getRowHeight, findRowIdx: findRowIdx } = (0, $kYL7Z.useMemo)(()=>{
        if (typeof rowHeight === "number") return {
            totalRowHeight: rowHeight * rows.length,
            gridTemplateRows: ` repeat(${rows.length}, ${rowHeight}px)`,
            getRowTop: (rowIdx)=>rowIdx * rowHeight,
            getRowHeight: ()=>rowHeight,
            findRowIdx: (offset)=>$7829d25231ee1190$var$floor(offset / rowHeight)
        };
        let totalRowHeight$1 = 0;
        let gridTemplateRows$1 = " ";
        const rowPositions = rows.map((row$1)=>{
            const currentRowHeight = rowHeight(row$1);
            const position = {
                top: totalRowHeight$1,
                height: currentRowHeight
            };
            gridTemplateRows$1 += `${currentRowHeight}px `;
            totalRowHeight$1 += currentRowHeight;
            return position;
        });
        const validateRowIdx = (rowIdx)=>{
            return $7829d25231ee1190$var$max(0, $7829d25231ee1190$var$min(rows.length - 1, rowIdx));
        };
        return {
            totalRowHeight: totalRowHeight$1,
            gridTemplateRows: gridTemplateRows$1,
            getRowTop: (rowIdx)=>rowPositions[validateRowIdx(rowIdx)].top,
            getRowHeight: (rowIdx)=>rowPositions[validateRowIdx(rowIdx)].height,
            findRowIdx (offset) {
                let start = 0;
                let end = rowPositions.length - 1;
                while(start <= end){
                    const middle = start + $7829d25231ee1190$var$floor((end - start) / 2);
                    const currentOffset = rowPositions[middle].top;
                    if (currentOffset === offset) return middle;
                    if (currentOffset < offset) start = middle + 1;
                    else if (currentOffset > offset) end = middle - 1;
                    if (start > end) return end;
                }
                return 0;
            }
        };
    }, [
        rowHeight,
        rows
    ]);
    let rowOverscanStartIdx = 0;
    let rowOverscanEndIdx = rows.length - 1;
    if (enableVirtualization) {
        const overscanThreshold = 4;
        const rowVisibleStartIdx = findRowIdx(scrollTop);
        const rowVisibleEndIdx = findRowIdx(scrollTop + clientHeight);
        rowOverscanStartIdx = $7829d25231ee1190$var$max(0, rowVisibleStartIdx - overscanThreshold);
        rowOverscanEndIdx = $7829d25231ee1190$var$min(rows.length - 1, rowVisibleEndIdx + overscanThreshold);
    }
    return {
        rowOverscanStartIdx: rowOverscanStartIdx,
        rowOverscanEndIdx: rowOverscanEndIdx,
        totalRowHeight: totalRowHeight,
        gridTemplateRows: gridTemplateRows,
        getRowTop: getRowTop,
        getRowHeight: getRowHeight,
        findRowIdx: findRowIdx
    };
}
//#endregion
//#region src/Cell.tsx
const $7829d25231ee1190$var$cellDraggedOver = "c6ra8a37-0-0-beta-57";
const $7829d25231ee1190$var$cellDraggedOverClassname = `rdg-cell-dragged-over ${$7829d25231ee1190$var$cellDraggedOver}`;
function $7829d25231ee1190$var$Cell({ column: column, colSpan: colSpan, isCellSelected: isCellSelected, isDraggedOver: isDraggedOver, row: row$1, rowIdx: rowIdx, className: className, onMouseDown: onMouseDown, onCellMouseDown: onCellMouseDown, onClick: onClick, onCellClick: onCellClick, onDoubleClick: onDoubleClick, onCellDoubleClick: onCellDoubleClick, onContextMenu: onContextMenu, onCellContextMenu: onCellContextMenu, onRowChange: onRowChange, selectCell: selectCell, style: style, ...props }) {
    const { tabIndex: tabIndex, childTabIndex: childTabIndex, onFocus: onFocus } = $7829d25231ee1190$var$useRovingTabIndex(isCellSelected);
    const { cellClass: cellClass } = column;
    className = $7829d25231ee1190$var$getCellClassname(column, {
        [$7829d25231ee1190$var$cellDraggedOverClassname]: isDraggedOver
    }, typeof cellClass === "function" ? cellClass(row$1) : cellClass, className);
    const isEditable = $7829d25231ee1190$var$isCellEditableUtil(column, row$1);
    function selectCellWrapper(enableEditor) {
        selectCell({
            rowIdx: rowIdx,
            idx: column.idx
        }, {
            enableEditor: enableEditor
        });
    }
    function handleMouseEvent(event, eventHandler) {
        let eventHandled = false;
        if (eventHandler) {
            const cellEvent = $7829d25231ee1190$var$createCellEvent(event);
            eventHandler({
                rowIdx: rowIdx,
                row: row$1,
                column: column,
                selectCell: selectCellWrapper
            }, cellEvent);
            eventHandled = cellEvent.isGridDefaultPrevented();
        }
        return eventHandled;
    }
    function handleMouseDown(event) {
        onMouseDown?.(event);
        if (!handleMouseEvent(event, onCellMouseDown)) selectCellWrapper();
    }
    function handleClick(event) {
        onClick?.(event);
        handleMouseEvent(event, onCellClick);
    }
    function handleDoubleClick(event) {
        onDoubleClick?.(event);
        if (!handleMouseEvent(event, onCellDoubleClick)) selectCellWrapper(true);
    }
    function handleContextMenu(event) {
        onContextMenu?.(event);
        handleMouseEvent(event, onCellContextMenu);
    }
    function handleRowChange(newRow) {
        onRowChange(column, newRow);
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "gridcell",
        "aria-colindex": column.idx + 1,
        "aria-colspan": colSpan,
        "aria-selected": isCellSelected,
        "aria-readonly": !isEditable || void 0,
        tabIndex: tabIndex,
        className: className,
        style: {
            ...$7829d25231ee1190$var$getCellStyle(column, colSpan),
            ...style
        },
        onClick: handleClick,
        onMouseDown: handleMouseDown,
        onDoubleClick: handleDoubleClick,
        onContextMenu: handleContextMenu,
        onFocus: onFocus,
        ...props,
        children: column.renderCell({
            column: column,
            row: row$1,
            rowIdx: rowIdx,
            isCellEditable: isEditable,
            tabIndex: childTabIndex,
            onRowChange: handleRowChange
        })
    });
}
const $7829d25231ee1190$var$CellComponent = (0, $kYL7Z.memo)($7829d25231ee1190$var$Cell);
var $7829d25231ee1190$export$f6f0c3fe4ec306ea = $7829d25231ee1190$var$CellComponent;
function $7829d25231ee1190$var$defaultRenderCell(key, props) {
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$CellComponent, {
        ...props
    }, key);
}
//#endregion
//#region src/EditCell.tsx
const $7829d25231ee1190$var$canUsePostTask = typeof scheduler === "object" && typeof scheduler.postTask === "function";
const $7829d25231ee1190$var$cellEditing = "cis5rrm7-0-0-beta-57";
function $7829d25231ee1190$var$EditCell({ column: column, colSpan: colSpan, row: row$1, rowIdx: rowIdx, onRowChange: onRowChange, closeEditor: closeEditor, onKeyDown: onKeyDown, navigate: navigate }) {
    const captureEventRef = (0, $kYL7Z.useRef)(void 0);
    const abortControllerRef = (0, $kYL7Z.useRef)(void 0);
    const frameRequestRef = (0, $kYL7Z.useRef)(void 0);
    const commitOnOutsideClick = column.editorOptions?.commitOnOutsideClick ?? true;
    const commitOnOutsideMouseDown = $7829d25231ee1190$var$useLatestFunc(()=>{
        onClose(true, false);
    });
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (!commitOnOutsideClick) return;
        function onWindowCaptureMouseDown(event) {
            captureEventRef.current = event;
            if ($7829d25231ee1190$var$canUsePostTask) {
                const abortController = new AbortController();
                const { signal: signal } = abortController;
                abortControllerRef.current = abortController;
                scheduler.postTask(commitOnOutsideMouseDown, {
                    priority: "user-blocking",
                    signal: signal
                }).catch(()=>{});
            } else frameRequestRef.current = requestAnimationFrame(commitOnOutsideMouseDown);
        }
        function onWindowMouseDown(event) {
            if (captureEventRef.current === event) commitOnOutsideMouseDown();
        }
        addEventListener("mousedown", onWindowCaptureMouseDown, {
            capture: true
        });
        addEventListener("mousedown", onWindowMouseDown);
        return ()=>{
            removeEventListener("mousedown", onWindowCaptureMouseDown, {
                capture: true
            });
            removeEventListener("mousedown", onWindowMouseDown);
            cancelTask();
        };
    }, [
        commitOnOutsideClick,
        commitOnOutsideMouseDown
    ]);
    function cancelTask() {
        captureEventRef.current = void 0;
        if (abortControllerRef.current !== void 0) {
            abortControllerRef.current.abort();
            abortControllerRef.current = void 0;
        }
        if (frameRequestRef.current !== void 0) {
            cancelAnimationFrame(frameRequestRef.current);
            frameRequestRef.current = void 0;
        }
    }
    function handleKeyDown(event) {
        if (onKeyDown) {
            const cellEvent = $7829d25231ee1190$var$createCellEvent(event);
            onKeyDown({
                mode: "EDIT",
                row: row$1,
                column: column,
                rowIdx: rowIdx,
                navigate () {
                    navigate(event);
                },
                onClose: onClose
            }, cellEvent);
            if (cellEvent.isGridDefaultPrevented()) return;
        }
        if (event.key === "Escape") onClose();
        else if (event.key === "Enter") onClose(true);
        else if ($7829d25231ee1190$var$onEditorNavigation(event)) navigate(event);
    }
    function onClose(commitChanges = false, shouldFocusCell = true) {
        if (commitChanges) onRowChange(row$1, true, shouldFocusCell);
        else closeEditor(shouldFocusCell);
    }
    function onEditorRowChange(row$2, commitChangesAndFocus = false) {
        onRowChange(row$2, commitChangesAndFocus, commitChangesAndFocus);
    }
    const { cellClass: cellClass } = column;
    const className = $7829d25231ee1190$var$getCellClassname(column, "rdg-editor-container", !column.editorOptions?.displayCellContent && $7829d25231ee1190$var$cellEditing, typeof cellClass === "function" ? cellClass(row$1) : cellClass);
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "gridcell",
        "aria-colindex": column.idx + 1,
        "aria-colspan": colSpan,
        "aria-selected": true,
        className: className,
        style: $7829d25231ee1190$var$getCellStyle(column, colSpan),
        onKeyDown: handleKeyDown,
        onMouseDownCapture: cancelTask,
        children: column.renderEditCell != null && /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
            children: [
                column.renderEditCell({
                    column: column,
                    row: row$1,
                    rowIdx: rowIdx,
                    onRowChange: onEditorRowChange,
                    onClose: onClose
                }),
                column.editorOptions?.displayCellContent && column.renderCell({
                    column: column,
                    row: row$1,
                    rowIdx: rowIdx,
                    isCellEditable: true,
                    tabIndex: -1,
                    onRowChange: onEditorRowChange
                })
            ]
        })
    });
}
//#endregion
//#region src/GroupedColumnHeaderCell.tsx
function $7829d25231ee1190$var$GroupedColumnHeaderCell({ column: column, rowIdx: rowIdx, isCellSelected: isCellSelected, selectCell: selectCell }) {
    const { tabIndex: tabIndex, onFocus: onFocus } = $7829d25231ee1190$var$useRovingTabIndex(isCellSelected);
    const { colSpan: colSpan } = column;
    const rowSpan = $7829d25231ee1190$var$getHeaderCellRowSpan(column, rowIdx);
    const index = column.idx + 1;
    function onMouseDown() {
        selectCell({
            idx: column.idx,
            rowIdx: rowIdx
        });
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "columnheader",
        "aria-colindex": index,
        "aria-colspan": colSpan,
        "aria-rowspan": rowSpan,
        "aria-selected": isCellSelected,
        tabIndex: tabIndex,
        className: (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$cellClassname, column.headerCellClass),
        style: {
            ...$7829d25231ee1190$var$getHeaderCellStyle(column, rowIdx, rowSpan),
            gridColumnStart: index,
            gridColumnEnd: index + colSpan
        },
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        children: column.name
    });
}
//#endregion
//#region src/HeaderCell.tsx
const $7829d25231ee1190$var$cellSortableClassname = "c6l2wv17-0-0-beta-57";
const $7829d25231ee1190$var$cellResizable = "c1kqdw7y7-0-0-beta-57";
const $7829d25231ee1190$var$cellResizableClassname = `rdg-cell-resizable ${$7829d25231ee1190$var$cellResizable}`;
const $7829d25231ee1190$var$resizeHandleClassname = "r1y6ywlx7-0-0-beta-57";
const $7829d25231ee1190$var$cellDraggableClassname = "rdg-cell-draggable";
const $7829d25231ee1190$var$cellDragging = "c1bezg5o7-0-0-beta-57";
const $7829d25231ee1190$var$cellDraggingClassname = `rdg-cell-dragging ${$7829d25231ee1190$var$cellDragging}`;
const $7829d25231ee1190$var$cellOver = "c1vc96037-0-0-beta-57";
const $7829d25231ee1190$var$cellOverClassname = `rdg-cell-drag-over ${$7829d25231ee1190$var$cellOver}`;
const $7829d25231ee1190$var$dragImageClassname = "d8rwc9w7-0-0-beta-57";
function $7829d25231ee1190$var$HeaderCell({ column: column, colSpan: colSpan, rowIdx: rowIdx, isCellSelected: isCellSelected, onColumnResize: onColumnResize, onColumnResizeEnd: onColumnResizeEnd, onColumnsReorder: onColumnsReorder, sortColumns: sortColumns, onSortColumnsChange: onSortColumnsChange, selectCell: selectCell, shouldFocusGrid: shouldFocusGrid, direction: direction, draggedColumnKey: draggedColumnKey, setDraggedColumnKey: setDraggedColumnKey }) {
    const [isOver, setIsOver] = (0, $kYL7Z.useState)(false);
    const dragImageRef = (0, $kYL7Z.useRef)(null);
    const isDragging = draggedColumnKey === column.key;
    const rowSpan = $7829d25231ee1190$var$getHeaderCellRowSpan(column, rowIdx);
    const { tabIndex: tabIndex, childTabIndex: childTabIndex, onFocus: onFocus } = $7829d25231ee1190$var$useRovingTabIndex(shouldFocusGrid || isCellSelected);
    const sortIndex = sortColumns?.findIndex((sort)=>sort.columnKey === column.key);
    const sortColumn = sortIndex !== void 0 && sortIndex > -1 ? sortColumns[sortIndex] : void 0;
    const sortDirection = sortColumn?.direction;
    const priority = sortColumn !== void 0 && sortColumns.length > 1 ? sortIndex + 1 : void 0;
    const ariaSort = sortDirection && !priority ? sortDirection === "ASC" ? "ascending" : "descending" : void 0;
    const { sortable: sortable, resizable: resizable, draggable: draggable } = column;
    const className = $7829d25231ee1190$var$getCellClassname(column, column.headerCellClass, {
        [$7829d25231ee1190$var$cellSortableClassname]: sortable,
        [$7829d25231ee1190$var$cellResizableClassname]: resizable,
        [$7829d25231ee1190$var$cellDraggableClassname]: draggable,
        [$7829d25231ee1190$var$cellDraggingClassname]: isDragging,
        [$7829d25231ee1190$var$cellOverClassname]: isOver
    });
    function onSort(ctrlClick) {
        if (onSortColumnsChange == null) return;
        const { sortDescendingFirst: sortDescendingFirst } = column;
        if (sortColumn === void 0) {
            const nextSort = {
                columnKey: column.key,
                direction: sortDescendingFirst ? "DESC" : "ASC"
            };
            onSortColumnsChange(sortColumns && ctrlClick ? [
                ...sortColumns,
                nextSort
            ] : [
                nextSort
            ]);
        } else {
            let nextSortColumn;
            if (sortDescendingFirst === true && sortDirection === "DESC" || sortDescendingFirst !== true && sortDirection === "ASC") nextSortColumn = {
                columnKey: column.key,
                direction: sortDirection === "ASC" ? "DESC" : "ASC"
            };
            if (ctrlClick) {
                const nextSortColumns = [
                    ...sortColumns
                ];
                if (nextSortColumn) nextSortColumns[sortIndex] = nextSortColumn;
                else nextSortColumns.splice(sortIndex, 1);
                onSortColumnsChange(nextSortColumns);
            } else onSortColumnsChange(nextSortColumn ? [
                nextSortColumn
            ] : []);
        }
    }
    function handleFocus(event) {
        onFocus?.(event);
        if (shouldFocusGrid) selectCell({
            idx: 0,
            rowIdx: rowIdx
        });
    }
    function onMouseDown() {
        selectCell({
            idx: column.idx,
            rowIdx: rowIdx
        });
    }
    function onClick(event) {
        if (sortable) onSort(event.ctrlKey || event.metaKey);
    }
    function onKeyDown(event) {
        const { key: key } = event;
        if (sortable && (key === " " || key === "Enter")) {
            event.preventDefault();
            onSort(event.ctrlKey || event.metaKey);
        } else if (resizable && $7829d25231ee1190$var$isCtrlKeyHeldDown(event) && (key === "ArrowLeft" || key === "ArrowRight")) {
            event.stopPropagation();
            const { width: width } = event.currentTarget.getBoundingClientRect();
            const { leftKey: leftKey } = $7829d25231ee1190$var$getLeftRightKey(direction);
            const offset = key === leftKey ? -10 : 10;
            const newWidth = $7829d25231ee1190$var$clampColumnWidth(width + offset, column);
            if (newWidth !== width) onColumnResize(column, newWidth);
        }
    }
    function onDragStart(event) {
        (0, $cRanb.flushSync)(()=>{
            setDraggedColumnKey(column.key);
        });
        event.dataTransfer.setDragImage(dragImageRef.current, 0, 0);
        event.dataTransfer.dropEffect = "move";
    }
    function onDragEnd() {
        setDraggedColumnKey(void 0);
    }
    function onDragOver(event) {
        event.preventDefault();
        event.dataTransfer.dropEffect = "move";
    }
    function onDrop(event) {
        setIsOver(false);
        event.preventDefault();
        onColumnsReorder?.(draggedColumnKey, column.key);
    }
    function onDragEnter(event) {
        if ($7829d25231ee1190$var$isEventPertinent(event)) setIsOver(true);
    }
    function onDragLeave(event) {
        if ($7829d25231ee1190$var$isEventPertinent(event)) setIsOver(false);
    }
    let dragTargetProps;
    let dropTargetProps;
    if (draggable) {
        dragTargetProps = {
            draggable: true,
            onDragStart: onDragStart,
            onDragEnd: onDragEnd
        };
        if (draggedColumnKey !== void 0 && draggedColumnKey !== column.key) dropTargetProps = {
            onDragOver: onDragOver,
            onDragEnter: onDragEnter,
            onDragLeave: onDragLeave,
            onDrop: onDrop
        };
    }
    const style = {
        ...$7829d25231ee1190$var$getHeaderCellStyle(column, rowIdx, rowSpan),
        ...$7829d25231ee1190$var$getCellStyle(column, colSpan)
    };
    const content = column.renderHeaderCell({
        column: column,
        sortDirection: sortDirection,
        priority: priority,
        tabIndex: childTabIndex
    });
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            isDragging && /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                ref: dragImageRef,
                style: style,
                className: $7829d25231ee1190$var$getCellClassname(column, column.headerCellClass, $7829d25231ee1190$var$dragImageClassname),
                children: content
            }),
            /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                role: "columnheader",
                "aria-colindex": column.idx + 1,
                "aria-colspan": colSpan,
                "aria-rowspan": rowSpan,
                "aria-selected": isCellSelected,
                "aria-sort": ariaSort,
                tabIndex: tabIndex,
                className: className,
                style: style,
                onMouseDown: onMouseDown,
                onFocus: handleFocus,
                onClick: onClick,
                onKeyDown: onKeyDown,
                ...dragTargetProps,
                ...dropTargetProps,
                children: [
                    content,
                    resizable && /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$ResizeHandle, {
                        direction: direction,
                        column: column,
                        onColumnResize: onColumnResize,
                        onColumnResizeEnd: onColumnResizeEnd
                    })
                ]
            })
        ]
    });
}
function $7829d25231ee1190$var$ResizeHandle({ direction: direction, column: column, onColumnResize: onColumnResize, onColumnResizeEnd: onColumnResizeEnd }) {
    const resizingOffsetRef = (0, $kYL7Z.useRef)(void 0);
    const isRtl = direction === "rtl";
    function onPointerDown(event) {
        if (event.pointerType === "mouse" && event.buttons !== 1) return;
        event.preventDefault();
        const { currentTarget: currentTarget, pointerId: pointerId } = event;
        currentTarget.setPointerCapture(pointerId);
        const headerCell = currentTarget.parentElement;
        const { right: right, left: left } = headerCell.getBoundingClientRect();
        resizingOffsetRef.current = isRtl ? event.clientX - left : right - event.clientX;
    }
    function onPointerMove(event) {
        const offset = resizingOffsetRef.current;
        if (offset === void 0) return;
        const { width: width, right: right, left: left } = event.currentTarget.parentElement.getBoundingClientRect();
        let newWidth = isRtl ? right + offset - event.clientX : event.clientX + offset - left;
        newWidth = $7829d25231ee1190$var$clampColumnWidth(newWidth, column);
        if (width > 0 && newWidth !== width) onColumnResize(column, newWidth);
    }
    function onLostPointerCapture() {
        onColumnResizeEnd();
        resizingOffsetRef.current = void 0;
    }
    function onDoubleClick() {
        onColumnResize(column, "max-content");
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: $7829d25231ee1190$var$resizeHandleClassname,
        onClick: $7829d25231ee1190$var$stopPropagation,
        onPointerDown: onPointerDown,
        onPointerMove: onPointerMove,
        onLostPointerCapture: onLostPointerCapture,
        onDoubleClick: onDoubleClick
    });
}
function $7829d25231ee1190$var$isEventPertinent(event) {
    const relatedTarget = event.relatedTarget;
    return !event.currentTarget.contains(relatedTarget);
}
//#endregion
//#region src/style/row.ts
const $7829d25231ee1190$var$row = "r1upfr807-0-0-beta-57";
const $7829d25231ee1190$var$rowClassname = `rdg-row ${$7829d25231ee1190$var$row}`;
const $7829d25231ee1190$var$rowSelected = "r190mhd37-0-0-beta-57";
const $7829d25231ee1190$var$rowSelectedClassname = "rdg-row-selected";
const $7829d25231ee1190$var$rowSelectedWithFrozenCell = "r139qu9m7-0-0-beta-57";
const $7829d25231ee1190$var$topSummaryRowClassname = "rdg-top-summary-row";
const $7829d25231ee1190$var$bottomSummaryRowClassname = "rdg-bottom-summary-row";
//#endregion
//#region src/HeaderRow.tsx
const $7829d25231ee1190$var$headerRow = "h10tskcx7-0-0-beta-57";
const $7829d25231ee1190$var$headerRowClassname = `rdg-header-row ${$7829d25231ee1190$var$headerRow}`;
function $7829d25231ee1190$var$HeaderRow({ headerRowClass: headerRowClass, rowIdx: rowIdx, columns: columns, onColumnResize: onColumnResize, onColumnResizeEnd: onColumnResizeEnd, onColumnsReorder: onColumnsReorder, sortColumns: sortColumns, onSortColumnsChange: onSortColumnsChange, lastFrozenColumnIndex: lastFrozenColumnIndex, selectedCellIdx: selectedCellIdx, selectCell: selectCell, shouldFocusGrid: shouldFocusGrid, direction: direction }) {
    const [draggedColumnKey, setDraggedColumnKey] = (0, $kYL7Z.useState)();
    const cells = [];
    for(let index = 0; index < columns.length; index++){
        const column = columns[index];
        const colSpan = $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
            type: "HEADER"
        });
        if (colSpan !== void 0) index += colSpan - 1;
        cells.push(/* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$HeaderCell, {
            column: column,
            colSpan: colSpan,
            rowIdx: rowIdx,
            isCellSelected: selectedCellIdx === column.idx,
            onColumnResize: onColumnResize,
            onColumnResizeEnd: onColumnResizeEnd,
            onColumnsReorder: onColumnsReorder,
            onSortColumnsChange: onSortColumnsChange,
            sortColumns: sortColumns,
            selectCell: selectCell,
            shouldFocusGrid: shouldFocusGrid && index === 0,
            direction: direction,
            draggedColumnKey: draggedColumnKey,
            setDraggedColumnKey: setDraggedColumnKey
        }, column.key));
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "row",
        "aria-rowindex": rowIdx,
        className: (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$headerRowClassname, {
            [$7829d25231ee1190$var$rowSelectedClassname]: selectedCellIdx === -1
        }, headerRowClass),
        children: cells
    });
}
var $7829d25231ee1190$var$HeaderRow_default = (0, $kYL7Z.memo)($7829d25231ee1190$var$HeaderRow);
//#endregion
//#region src/GroupedColumnHeaderRow.tsx
function $7829d25231ee1190$var$GroupedColumnHeaderRow({ rowIdx: rowIdx, level: level, columns: columns, selectedCellIdx: selectedCellIdx, selectCell: selectCell }) {
    const cells = [];
    const renderedParents = new Set();
    for (const column of columns){
        let { parent: parent } = column;
        if (parent === void 0) continue;
        while(parent.level > level){
            if (parent.parent === void 0) break;
            parent = parent.parent;
        }
        if (parent.level === level && !renderedParents.has(parent)) {
            renderedParents.add(parent);
            const { idx: idx } = parent;
            cells.push(/* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$GroupedColumnHeaderCell, {
                column: parent,
                rowIdx: rowIdx,
                isCellSelected: selectedCellIdx === idx,
                selectCell: selectCell
            }, idx));
        }
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "row",
        "aria-rowindex": rowIdx,
        className: $7829d25231ee1190$var$headerRowClassname,
        children: cells
    });
}
var $7829d25231ee1190$var$GroupedColumnHeaderRow_default = (0, $kYL7Z.memo)($7829d25231ee1190$var$GroupedColumnHeaderRow);
//#endregion
//#region src/Row.tsx
function $7829d25231ee1190$var$Row({ className: className, rowIdx: rowIdx, gridRowStart: gridRowStart, selectedCellIdx: selectedCellIdx, isRowSelectionDisabled: isRowSelectionDisabled, isRowSelected: isRowSelected, draggedOverCellIdx: draggedOverCellIdx, lastFrozenColumnIndex: lastFrozenColumnIndex, row: row$1, viewportColumns: viewportColumns, selectedCellEditor: selectedCellEditor, onCellMouseDown: onCellMouseDown, onCellClick: onCellClick, onCellDoubleClick: onCellDoubleClick, onCellContextMenu: onCellContextMenu, rowClass: rowClass, onRowChange: onRowChange, selectCell: selectCell, style: style, ...props }) {
    const renderCell = $7829d25231ee1190$var$useDefaultRenderers().renderCell;
    const handleRowChange = $7829d25231ee1190$var$useLatestFunc((column, newRow)=>{
        onRowChange(column, rowIdx, newRow);
    });
    className = (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$rowClassname, `rdg-row-${rowIdx % 2 === 0 ? "even" : "odd"}`, {
        [$7829d25231ee1190$var$rowSelectedClassname]: selectedCellIdx === -1
    }, rowClass?.(row$1, rowIdx), className);
    const cells = [];
    for(let index = 0; index < viewportColumns.length; index++){
        const column = viewportColumns[index];
        const { idx: idx } = column;
        const colSpan = $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
            type: "ROW",
            row: row$1
        });
        if (colSpan !== void 0) index += colSpan - 1;
        const isCellSelected = selectedCellIdx === idx;
        if (isCellSelected && selectedCellEditor) cells.push(selectedCellEditor);
        else cells.push(renderCell(column.key, {
            column: column,
            colSpan: colSpan,
            row: row$1,
            rowIdx: rowIdx,
            isDraggedOver: draggedOverCellIdx === idx,
            isCellSelected: isCellSelected,
            onCellMouseDown: onCellMouseDown,
            onCellClick: onCellClick,
            onCellDoubleClick: onCellDoubleClick,
            onCellContextMenu: onCellContextMenu,
            onRowChange: handleRowChange,
            selectCell: selectCell
        }));
    }
    const selectionValue = (0, $kYL7Z.useMemo)(()=>({
            isRowSelected: isRowSelected,
            isRowSelectionDisabled: isRowSelectionDisabled
        }), [
        isRowSelectionDisabled,
        isRowSelected
    ]);
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$RowSelectionContext, {
        value: selectionValue,
        children: /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            role: "row",
            className: className,
            style: {
                ...$7829d25231ee1190$var$getRowStyle(gridRowStart),
                ...style
            },
            ...props,
            children: cells
        })
    });
}
const $7829d25231ee1190$var$RowComponent = (0, $kYL7Z.memo)($7829d25231ee1190$var$Row);
var $7829d25231ee1190$export$b59bdbef9ce70de2 = $7829d25231ee1190$var$RowComponent;
function $7829d25231ee1190$var$defaultRenderRow(key, props) {
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$RowComponent, {
        ...props
    }, key);
}
//#endregion
//#region src/ScrollToCell.tsx
function $7829d25231ee1190$var$ScrollToCell({ scrollToPosition: { idx: idx, rowIdx: rowIdx }, gridRef: gridRef, setScrollToCellPosition: setScrollToCellPosition }) {
    const ref = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useLayoutEffect)(()=>{
        $7829d25231ee1190$var$scrollIntoView(ref.current, "auto");
    });
    (0, $kYL7Z.useLayoutEffect)(()=>{
        function removeScrollToCell() {
            setScrollToCellPosition(null);
        }
        const observer = new IntersectionObserver(removeScrollToCell, {
            root: gridRef.current,
            threshold: 1
        });
        observer.observe(ref.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        gridRef,
        setScrollToCellPosition
    ]);
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        ref: ref,
        style: {
            gridColumn: idx === void 0 ? "1/-1" : idx + 1,
            gridRow: rowIdx === void 0 ? "1/-1" : rowIdx + 2
        }
    });
}
//#endregion
//#region src/sortStatus.tsx
const $7829d25231ee1190$var$arrow = "a3ejtar7-0-0-beta-57";
const $7829d25231ee1190$var$arrowClassname = `rdg-sort-arrow ${$7829d25231ee1190$var$arrow}`;
function $7829d25231ee1190$var$renderSortStatus({ sortDirection: sortDirection, priority: priority }) {
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            $7829d25231ee1190$export$f50fcc91f5334af0({
                sortDirection: sortDirection
            }),
            $7829d25231ee1190$export$125087b2b6a594a7({
                priority: priority
            })
        ]
    });
}
function $7829d25231ee1190$export$f50fcc91f5334af0({ sortDirection: sortDirection }) {
    if (sortDirection === void 0) return null;
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("svg", {
        viewBox: "0 0 12 8",
        width: "12",
        height: "8",
        className: $7829d25231ee1190$var$arrowClassname,
        "aria-hidden": true,
        children: /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: sortDirection === "ASC" ? "M0 8 6 0 12 8" : "M0 0 6 8 12 0"
        })
    });
}
function $7829d25231ee1190$export$125087b2b6a594a7({ priority: priority }) {
    return priority;
}
//#endregion
//#region src/style/core.ts
const $7829d25231ee1190$var$root = "rnvodz57-0-0-beta-57";
const $7829d25231ee1190$var$rootClassname = `rdg ${$7829d25231ee1190$var$root}`;
const $7829d25231ee1190$var$viewportDragging = "vlqv91k7-0-0-beta-57";
const $7829d25231ee1190$var$viewportDraggingClassname = `rdg-viewport-dragging ${$7829d25231ee1190$var$viewportDragging}`;
const $7829d25231ee1190$var$focusSinkClassname = "f1lsfrzw7-0-0-beta-57";
const $7829d25231ee1190$var$focusSinkHeaderAndSummaryClassname = "f1cte0lg7-0-0-beta-57";
//#endregion
//#region src/SummaryCell.tsx
const $7829d25231ee1190$var$summaryCellClassname = "s8wc6fl7-0-0-beta-57";
function $7829d25231ee1190$var$SummaryCell({ column: column, colSpan: colSpan, row: row$1, rowIdx: rowIdx, isCellSelected: isCellSelected, selectCell: selectCell }) {
    const { tabIndex: tabIndex, childTabIndex: childTabIndex, onFocus: onFocus } = $7829d25231ee1190$var$useRovingTabIndex(isCellSelected);
    const { summaryCellClass: summaryCellClass } = column;
    const className = $7829d25231ee1190$var$getCellClassname(column, $7829d25231ee1190$var$summaryCellClassname, typeof summaryCellClass === "function" ? summaryCellClass(row$1) : summaryCellClass);
    function onMouseDown() {
        selectCell({
            rowIdx: rowIdx,
            idx: column.idx
        });
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "gridcell",
        "aria-colindex": column.idx + 1,
        "aria-colspan": colSpan,
        "aria-selected": isCellSelected,
        tabIndex: tabIndex,
        className: className,
        style: $7829d25231ee1190$var$getCellStyle(column, colSpan),
        onMouseDown: onMouseDown,
        onFocus: onFocus,
        children: column.renderSummaryCell?.({
            column: column,
            row: row$1,
            tabIndex: childTabIndex
        })
    });
}
var $7829d25231ee1190$var$SummaryCell_default = (0, $kYL7Z.memo)($7829d25231ee1190$var$SummaryCell);
//#endregion
//#region src/SummaryRow.tsx
const $7829d25231ee1190$var$summaryRow = "skuhp557-0-0-beta-57";
const $7829d25231ee1190$var$topSummaryRow = "tf8l5ub7-0-0-beta-57";
const $7829d25231ee1190$var$summaryRowClassname = `rdg-summary-row ${$7829d25231ee1190$var$summaryRow}`;
function $7829d25231ee1190$var$SummaryRow({ rowIdx: rowIdx, gridRowStart: gridRowStart, row: row$1, viewportColumns: viewportColumns, top: top, bottom: bottom, lastFrozenColumnIndex: lastFrozenColumnIndex, selectedCellIdx: selectedCellIdx, isTop: isTop, selectCell: selectCell, "aria-rowindex": ariaRowIndex }) {
    const cells = [];
    for(let index = 0; index < viewportColumns.length; index++){
        const column = viewportColumns[index];
        const colSpan = $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
            type: "SUMMARY",
            row: row$1
        });
        if (colSpan !== void 0) index += colSpan - 1;
        const isCellSelected = selectedCellIdx === column.idx;
        cells.push(/* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$SummaryCell_default, {
            column: column,
            colSpan: colSpan,
            row: row$1,
            rowIdx: rowIdx,
            isCellSelected: isCellSelected,
            selectCell: selectCell
        }, column.key));
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "row",
        "aria-rowindex": ariaRowIndex,
        className: (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$rowClassname, `rdg-row-${rowIdx % 2 === 0 ? "even" : "odd"}`, $7829d25231ee1190$var$summaryRowClassname, {
            [$7829d25231ee1190$var$rowSelectedClassname]: selectedCellIdx === -1,
            [`${$7829d25231ee1190$var$topSummaryRowClassname} ${$7829d25231ee1190$var$topSummaryRow}`]: isTop,
            [$7829d25231ee1190$var$bottomSummaryRowClassname]: !isTop
        }),
        style: {
            ...$7829d25231ee1190$var$getRowStyle(gridRowStart),
            "--rdg-summary-row-top": top !== void 0 ? `${top}px` : void 0,
            "--rdg-summary-row-bottom": bottom !== void 0 ? `${bottom}px` : void 0
        },
        children: cells
    });
}
var $7829d25231ee1190$var$SummaryRow_default = (0, $kYL7Z.memo)($7829d25231ee1190$var$SummaryRow);
//#endregion
//#region src/DataGrid.tsx
/**
* Main API Component to render a data grid of rows and columns
*
* @example
*
* <DataGrid columns={columns} rows={rows} />
*/ function $7829d25231ee1190$export$c8dd51eb24f71762(props) {
    const { ref: ref, columns: rawColumns, rows: rows, topSummaryRows: topSummaryRows, bottomSummaryRows: bottomSummaryRows, rowKeyGetter: rowKeyGetter, onRowsChange: onRowsChange, rowHeight: rawRowHeight, headerRowHeight: rawHeaderRowHeight, summaryRowHeight: rawSummaryRowHeight, columnWidths: columnWidthsRaw, onColumnWidthsChange: onColumnWidthsChangeRaw, selectedRows: selectedRows, isRowSelectionDisabled: isRowSelectionDisabled, onSelectedRowsChange: onSelectedRowsChange, sortColumns: sortColumns, onSortColumnsChange: onSortColumnsChange, defaultColumnOptions: defaultColumnOptions, onCellMouseDown: onCellMouseDown, onCellClick: onCellClick, onCellDoubleClick: onCellDoubleClick, onCellContextMenu: onCellContextMenu, onCellKeyDown: onCellKeyDown, onSelectedCellChange: onSelectedCellChange, onScroll: onScroll, onColumnResize: onColumnResize, onColumnsReorder: onColumnsReorder, onFill: onFill, onCellCopy: onCellCopy, onCellPaste: onCellPaste, enableVirtualization: rawEnableVirtualization, renderers: renderers, className: className, style: style, rowClass: rowClass, headerRowClass: headerRowClass, direction: rawDirection, role: rawRole, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-description": ariaDescription, "aria-describedby": ariaDescribedBy, "aria-rowcount": rawAriaRowCount, "data-testid": testId, "data-cy": dataCy } = props;
    /**
	* defaults
	*/ const defaultRenderers = $7829d25231ee1190$var$useDefaultRenderers();
    const role = rawRole ?? "grid";
    const rowHeight = rawRowHeight ?? 35;
    const headerRowHeight = rawHeaderRowHeight ?? (typeof rowHeight === "number" ? rowHeight : 35);
    const summaryRowHeight = rawSummaryRowHeight ?? (typeof rowHeight === "number" ? rowHeight : 35);
    const renderRow = renderers?.renderRow ?? defaultRenderers?.renderRow ?? $7829d25231ee1190$var$defaultRenderRow;
    const renderCell = renderers?.renderCell ?? defaultRenderers?.renderCell ?? $7829d25231ee1190$var$defaultRenderCell;
    const renderSortStatus$1 = renderers?.renderSortStatus ?? defaultRenderers?.renderSortStatus ?? $7829d25231ee1190$var$renderSortStatus;
    const renderCheckbox$1 = renderers?.renderCheckbox ?? defaultRenderers?.renderCheckbox ?? $7829d25231ee1190$export$ade4cf7dfdc949fa;
    const noRowsFallback = renderers?.noRowsFallback ?? defaultRenderers?.noRowsFallback;
    const enableVirtualization = rawEnableVirtualization ?? true;
    const direction = rawDirection ?? "ltr";
    /**
	* states
	*/ const [scrollTop, setScrollTop] = (0, $kYL7Z.useState)(0);
    const [scrollLeft, setScrollLeft] = (0, $kYL7Z.useState)(0);
    const [columnWidthsInternal, setColumnWidthsInternal] = (0, $kYL7Z.useState)(()=>columnWidthsRaw ?? new Map());
    const [isColumnResizing, setColumnResizing] = (0, $kYL7Z.useState)(false);
    const [isDragging, setDragging] = (0, $kYL7Z.useState)(false);
    const [draggedOverRowIdx, setDraggedOverRowIdx] = (0, $kYL7Z.useState)(void 0);
    const [scrollToPosition, setScrollToPosition] = (0, $kYL7Z.useState)(null);
    const [shouldFocusCell, setShouldFocusCell] = (0, $kYL7Z.useState)(false);
    const [previousRowIdx, setPreviousRowIdx] = (0, $kYL7Z.useState)(-1);
    const isColumnWidthsControlled = columnWidthsRaw != null && onColumnWidthsChangeRaw != null && !isColumnResizing;
    const columnWidths = isColumnWidthsControlled ? columnWidthsRaw : columnWidthsInternal;
    const onColumnWidthsChange = isColumnWidthsControlled ? (columnWidths$1)=>{
        setColumnWidthsInternal(columnWidths$1);
        onColumnWidthsChangeRaw(columnWidths$1);
    } : setColumnWidthsInternal;
    const getColumnWidth = (0, $kYL7Z.useCallback)((column)=>{
        return columnWidths.get(column.key)?.width ?? column.width;
    }, [
        columnWidths
    ]);
    const [gridRef, gridWidth, gridHeight, horizontalScrollbarHeight] = $7829d25231ee1190$var$useGridDimensions();
    const { columns: columns, colSpanColumns: colSpanColumns, lastFrozenColumnIndex: lastFrozenColumnIndex, headerRowsCount: headerRowsCount, colOverscanStartIdx: colOverscanStartIdx, colOverscanEndIdx: colOverscanEndIdx, templateColumns: templateColumns, layoutCssVars: layoutCssVars, totalFrozenColumnWidth: totalFrozenColumnWidth } = $7829d25231ee1190$var$useCalculatedColumns({
        rawColumns: rawColumns,
        defaultColumnOptions: defaultColumnOptions,
        getColumnWidth: getColumnWidth,
        scrollLeft: scrollLeft,
        viewportWidth: gridWidth,
        enableVirtualization: enableVirtualization
    });
    const topSummaryRowsCount = topSummaryRows?.length ?? 0;
    const bottomSummaryRowsCount = bottomSummaryRows?.length ?? 0;
    const summaryRowsCount = topSummaryRowsCount + bottomSummaryRowsCount;
    const headerAndTopSummaryRowsCount = headerRowsCount + topSummaryRowsCount;
    const groupedColumnHeaderRowsCount = headerRowsCount - 1;
    const minRowIdx = -headerAndTopSummaryRowsCount;
    const mainHeaderRowIdx = minRowIdx + groupedColumnHeaderRowsCount;
    const maxRowIdx = rows.length + bottomSummaryRowsCount - 1;
    const [selectedPosition, setSelectedPosition] = (0, $kYL7Z.useState)(()=>({
            idx: -1,
            rowIdx: minRowIdx - 1,
            mode: "SELECT"
        }));
    /**
	* refs
	*/ const focusSinkRef = (0, $kYL7Z.useRef)(null);
    /**
	* computed values
	*/ const isTreeGrid = role === "treegrid";
    const headerRowsHeight = headerRowsCount * headerRowHeight;
    const summaryRowsHeight = summaryRowsCount * summaryRowHeight;
    const clientHeight = gridHeight - headerRowsHeight - summaryRowsHeight;
    const isSelectable = selectedRows != null && onSelectedRowsChange != null;
    const { leftKey: leftKey, rightKey: rightKey } = $7829d25231ee1190$var$getLeftRightKey(direction);
    const ariaRowCount = rawAriaRowCount ?? headerRowsCount + rows.length + summaryRowsCount;
    const defaultGridComponents = (0, $kYL7Z.useMemo)(()=>({
            renderCheckbox: renderCheckbox$1,
            renderSortStatus: renderSortStatus$1,
            renderCell: renderCell
        }), [
        renderCheckbox$1,
        renderSortStatus$1,
        renderCell
    ]);
    const headerSelectionValue = (0, $kYL7Z.useMemo)(()=>{
        let hasSelectedRow = false;
        let hasUnselectedRow = false;
        if (rowKeyGetter != null && selectedRows != null && selectedRows.size > 0) for (const row$1 of rows){
            if (selectedRows.has(rowKeyGetter(row$1))) hasSelectedRow = true;
            else hasUnselectedRow = true;
            if (hasSelectedRow && hasUnselectedRow) break;
        }
        return {
            isRowSelected: hasSelectedRow && !hasUnselectedRow,
            isIndeterminate: hasSelectedRow && hasUnselectedRow
        };
    }, [
        rows,
        selectedRows,
        rowKeyGetter
    ]);
    const { rowOverscanStartIdx: rowOverscanStartIdx, rowOverscanEndIdx: rowOverscanEndIdx, totalRowHeight: totalRowHeight, gridTemplateRows: gridTemplateRows, getRowTop: getRowTop, getRowHeight: getRowHeight, findRowIdx: findRowIdx } = $7829d25231ee1190$var$useViewportRows({
        rows: rows,
        rowHeight: rowHeight,
        clientHeight: clientHeight,
        scrollTop: scrollTop,
        enableVirtualization: enableVirtualization
    });
    const viewportColumns = $7829d25231ee1190$var$useViewportColumns({
        columns: columns,
        colSpanColumns: colSpanColumns,
        colOverscanStartIdx: colOverscanStartIdx,
        colOverscanEndIdx: colOverscanEndIdx,
        lastFrozenColumnIndex: lastFrozenColumnIndex,
        rowOverscanStartIdx: rowOverscanStartIdx,
        rowOverscanEndIdx: rowOverscanEndIdx,
        rows: rows,
        topSummaryRows: topSummaryRows,
        bottomSummaryRows: bottomSummaryRows
    });
    const { gridTemplateColumns: gridTemplateColumns, handleColumnResize: handleColumnResize } = $7829d25231ee1190$var$useColumnWidths(columns, viewportColumns, templateColumns, gridRef, gridWidth, columnWidths, onColumnWidthsChange, onColumnResize, setColumnResizing);
    const minColIdx = isTreeGrid ? -1 : 0;
    const maxColIdx = columns.length - 1;
    const selectedCellIsWithinSelectionBounds = isCellWithinSelectionBounds(selectedPosition);
    const selectedCellIsWithinViewportBounds = isCellWithinViewportBounds(selectedPosition);
    const scrollHeight = headerRowHeight + totalRowHeight + summaryRowsHeight + horizontalScrollbarHeight;
    /**
	* The identity of the wrapper function is stable so it won't break memoization
	*/ const handleColumnResizeLatest = $7829d25231ee1190$var$useLatestFunc(handleColumnResize);
    const handleColumnResizeEndLatest = $7829d25231ee1190$var$useLatestFunc(handleColumnResizeEnd);
    const onColumnsReorderLastest = $7829d25231ee1190$var$useLatestFunc(onColumnsReorder);
    const onSortColumnsChangeLatest = $7829d25231ee1190$var$useLatestFunc(onSortColumnsChange);
    const onCellMouseDownLatest = $7829d25231ee1190$var$useLatestFunc(onCellMouseDown);
    const onCellClickLatest = $7829d25231ee1190$var$useLatestFunc(onCellClick);
    const onCellDoubleClickLatest = $7829d25231ee1190$var$useLatestFunc(onCellDoubleClick);
    const onCellContextMenuLatest = $7829d25231ee1190$var$useLatestFunc(onCellContextMenu);
    const selectHeaderRowLatest = $7829d25231ee1190$var$useLatestFunc(selectHeaderRow);
    const selectRowLatest = $7829d25231ee1190$var$useLatestFunc(selectRow);
    const handleFormatterRowChangeLatest = $7829d25231ee1190$var$useLatestFunc(updateRow);
    const selectCellLatest = $7829d25231ee1190$var$useLatestFunc(selectCell);
    const selectHeaderCellLatest = $7829d25231ee1190$var$useLatestFunc(selectHeaderCell);
    /**
	* callbacks
	*/ const focusCell = (0, $kYL7Z.useCallback)((shouldScroll = true)=>{
        const cell$1 = $7829d25231ee1190$var$getCellToScroll(gridRef.current);
        if (cell$1 === null) return;
        if (shouldScroll) $7829d25231ee1190$var$scrollIntoView(cell$1);
        cell$1.focus({
            preventScroll: true
        });
    }, [
        gridRef
    ]);
    /**
	* effects
	*/ (0, $kYL7Z.useLayoutEffect)(()=>{
        if (shouldFocusCell) {
            if (focusSinkRef.current !== null && selectedPosition.idx === -1) {
                focusSinkRef.current.focus({
                    preventScroll: true
                });
                $7829d25231ee1190$var$scrollIntoView(focusSinkRef.current);
            } else focusCell();
            setShouldFocusCell(false);
        }
    }, [
        shouldFocusCell,
        focusCell,
        selectedPosition.idx
    ]);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>({
            element: gridRef.current,
            scrollToCell ({ idx: idx, rowIdx: rowIdx }) {
                const scrollToIdx = idx !== void 0 && idx > lastFrozenColumnIndex && idx < columns.length ? idx : void 0;
                const scrollToRowIdx = rowIdx !== void 0 && isRowIdxWithinViewportBounds(rowIdx) ? rowIdx : void 0;
                if (scrollToIdx !== void 0 || scrollToRowIdx !== void 0) setScrollToPosition({
                    idx: scrollToIdx,
                    rowIdx: scrollToRowIdx
                });
            },
            selectCell: selectCell
        }));
    /**
	* event handlers
	*/ function selectHeaderRow(args) {
        if (!onSelectedRowsChange) return;
        $7829d25231ee1190$var$assertIsValidKeyGetter(rowKeyGetter);
        const newSelectedRows = new Set(selectedRows);
        for (const row$1 of rows){
            if (isRowSelectionDisabled?.(row$1) === true) continue;
            const rowKey = rowKeyGetter(row$1);
            if (args.checked) newSelectedRows.add(rowKey);
            else newSelectedRows.delete(rowKey);
        }
        onSelectedRowsChange(newSelectedRows);
    }
    function selectRow(args) {
        if (!onSelectedRowsChange) return;
        $7829d25231ee1190$var$assertIsValidKeyGetter(rowKeyGetter);
        const { row: row$1, checked: checked, isShiftClick: isShiftClick } = args;
        if (isRowSelectionDisabled?.(row$1) === true) return;
        const newSelectedRows = new Set(selectedRows);
        const rowKey = rowKeyGetter(row$1);
        const rowIdx = rows.indexOf(row$1);
        setPreviousRowIdx(rowIdx);
        if (checked) newSelectedRows.add(rowKey);
        else newSelectedRows.delete(rowKey);
        if (isShiftClick && previousRowIdx !== -1 && previousRowIdx !== rowIdx && previousRowIdx < rows.length) {
            const step = $7829d25231ee1190$var$sign(rowIdx - previousRowIdx);
            for(let i = previousRowIdx + step; i !== rowIdx; i += step){
                const row$2 = rows[i];
                if (isRowSelectionDisabled?.(row$2) === true) continue;
                if (checked) newSelectedRows.add(rowKeyGetter(row$2));
                else newSelectedRows.delete(rowKeyGetter(row$2));
            }
        }
        onSelectedRowsChange(newSelectedRows);
    }
    function handleKeyDown(event) {
        const { idx: idx, rowIdx: rowIdx, mode: mode } = selectedPosition;
        if (mode === "EDIT") return;
        if (onCellKeyDown && isRowIdxWithinViewportBounds(rowIdx)) {
            const row$1 = rows[rowIdx];
            const cellEvent = $7829d25231ee1190$var$createCellEvent(event);
            onCellKeyDown({
                mode: "SELECT",
                row: row$1,
                column: columns[idx],
                rowIdx: rowIdx,
                selectCell: selectCell
            }, cellEvent);
            if (cellEvent.isGridDefaultPrevented()) return;
        }
        if (!(event.target instanceof Element)) return;
        const isCellEvent = event.target.closest(".rdg-cell") !== null;
        const isRowEvent = isTreeGrid && event.target === focusSinkRef.current;
        if (!isCellEvent && !isRowEvent) return;
        switch(event.key){
            case "ArrowUp":
            case "ArrowDown":
            case "ArrowLeft":
            case "ArrowRight":
            case "Tab":
            case "Home":
            case "End":
            case "PageUp":
            case "PageDown":
                navigate(event);
                break;
            default:
                handleCellInput(event);
                break;
        }
    }
    function handleScroll(event) {
        const { scrollTop: scrollTop$1, scrollLeft: scrollLeft$1 } = event.currentTarget;
        (0, $cRanb.flushSync)(()=>{
            setScrollTop(scrollTop$1);
            setScrollLeft($7829d25231ee1190$var$abs(scrollLeft$1));
        });
        onScroll?.(event);
    }
    function updateRow(column, rowIdx, row$1) {
        if (typeof onRowsChange !== "function") return;
        if (row$1 === rows[rowIdx]) return;
        const updatedRows = rows.with(rowIdx, row$1);
        onRowsChange(updatedRows, {
            indexes: [
                rowIdx
            ],
            column: column
        });
    }
    function commitEditorChanges() {
        if (selectedPosition.mode !== "EDIT") return;
        updateRow(columns[selectedPosition.idx], selectedPosition.rowIdx, selectedPosition.row);
    }
    function handleCellCopy(event) {
        if (!selectedCellIsWithinViewportBounds) return;
        const { idx: idx, rowIdx: rowIdx } = selectedPosition;
        onCellCopy?.({
            row: rows[rowIdx],
            column: columns[idx]
        }, event);
    }
    function handleCellPaste(event) {
        if (!onCellPaste || !onRowsChange || !isCellEditable(selectedPosition)) return;
        const { idx: idx, rowIdx: rowIdx } = selectedPosition;
        const column = columns[idx];
        const updatedRow = onCellPaste({
            row: rows[rowIdx],
            column: column
        }, event);
        updateRow(column, rowIdx, updatedRow);
    }
    function handleCellInput(event) {
        if (!selectedCellIsWithinViewportBounds) return;
        const row$1 = rows[selectedPosition.rowIdx];
        const { key: key, shiftKey: shiftKey } = event;
        if (isSelectable && shiftKey && key === " ") {
            $7829d25231ee1190$var$assertIsValidKeyGetter(rowKeyGetter);
            const rowKey = rowKeyGetter(row$1);
            selectRow({
                row: row$1,
                checked: !selectedRows.has(rowKey),
                isShiftClick: false
            });
            event.preventDefault();
            return;
        }
        if (isCellEditable(selectedPosition) && $7829d25231ee1190$var$isDefaultCellInput(event, onCellPaste != null)) setSelectedPosition(({ idx: idx, rowIdx: rowIdx })=>({
                idx: idx,
                rowIdx: rowIdx,
                mode: "EDIT",
                row: row$1,
                originalRow: row$1
            }));
    }
    function handleColumnResizeEnd() {
        if (isColumnResizing) {
            onColumnWidthsChangeRaw?.(columnWidths);
            setColumnResizing(false);
        }
    }
    function handleDragHandlePointerDown(event) {
        event.preventDefault();
        if (event.pointerType === "mouse" && event.buttons !== 1) return;
        setDragging(true);
        event.currentTarget.setPointerCapture(event.pointerId);
    }
    function handleDragHandlePointerMove(event) {
        const gridEl = gridRef.current;
        const headerAndTopSummaryRowsHeight = headerRowsHeight + topSummaryRowsCount * summaryRowHeight;
        const offset = scrollTop - headerAndTopSummaryRowsHeight + event.clientY - gridEl.getBoundingClientRect().top;
        const overRowIdx = findRowIdx(offset);
        setDraggedOverRowIdx(overRowIdx);
        const ariaRowIndex = headerAndTopSummaryRowsCount + overRowIdx + 1;
        const el = gridEl.querySelector(`:scope > [aria-rowindex="${ariaRowIndex}"] > [aria-colindex="${selectedPosition.idx + 1}"]`);
        $7829d25231ee1190$var$scrollIntoView(el);
    }
    function handleDragHandleLostPointerCapture() {
        setDragging(false);
        if (draggedOverRowIdx === void 0) return;
        const { rowIdx: rowIdx } = selectedPosition;
        const [startRowIndex, endRowIndex] = rowIdx < draggedOverRowIdx ? [
            rowIdx + 1,
            draggedOverRowIdx + 1
        ] : [
            draggedOverRowIdx,
            rowIdx
        ];
        updateRows(startRowIndex, endRowIndex);
        setDraggedOverRowIdx(void 0);
    }
    function handleDragHandleClick() {
        focusCell(false);
    }
    function handleDragHandleDoubleClick(event) {
        event.stopPropagation();
        updateRows(selectedPosition.rowIdx + 1, rows.length);
    }
    function updateRows(startRowIdx, endRowIdx) {
        if (onRowsChange == null) return;
        const { rowIdx: rowIdx, idx: idx } = selectedPosition;
        const column = columns[idx];
        const sourceRow = rows[rowIdx];
        const updatedRows = [
            ...rows
        ];
        const indexes = [];
        for(let i = startRowIdx; i < endRowIdx; i++)if (isCellEditable({
            rowIdx: i,
            idx: idx
        })) {
            const updatedRow = onFill({
                columnKey: column.key,
                sourceRow: sourceRow,
                targetRow: rows[i]
            });
            if (updatedRow !== rows[i]) {
                updatedRows[i] = updatedRow;
                indexes.push(i);
            }
        }
        if (indexes.length > 0) onRowsChange(updatedRows, {
            indexes: indexes,
            column: column
        });
    }
    /**
	* utils
	*/ function isColIdxWithinSelectionBounds(idx) {
        return idx >= minColIdx && idx <= maxColIdx;
    }
    function isRowIdxWithinViewportBounds(rowIdx) {
        return rowIdx >= 0 && rowIdx < rows.length;
    }
    function isCellWithinSelectionBounds({ idx: idx, rowIdx: rowIdx }) {
        return rowIdx >= minRowIdx && rowIdx <= maxRowIdx && isColIdxWithinSelectionBounds(idx);
    }
    function isCellWithinEditBounds({ idx: idx, rowIdx: rowIdx }) {
        return isRowIdxWithinViewportBounds(rowIdx) && idx >= 0 && idx <= maxColIdx;
    }
    function isCellWithinViewportBounds({ idx: idx, rowIdx: rowIdx }) {
        return isRowIdxWithinViewportBounds(rowIdx) && isColIdxWithinSelectionBounds(idx);
    }
    function isCellEditable(position) {
        return isCellWithinEditBounds(position) && $7829d25231ee1190$var$isSelectedCellEditable({
            columns: columns,
            rows: rows,
            selectedPosition: position
        });
    }
    function selectCell(position, options) {
        if (!isCellWithinSelectionBounds(position)) return;
        commitEditorChanges();
        const samePosition = $7829d25231ee1190$var$isSamePosition(selectedPosition, position);
        if (options?.enableEditor && isCellEditable(position)) {
            const row$1 = rows[position.rowIdx];
            setSelectedPosition({
                ...position,
                mode: "EDIT",
                row: row$1,
                originalRow: row$1
            });
        } else if (samePosition) $7829d25231ee1190$var$scrollIntoView($7829d25231ee1190$var$getCellToScroll(gridRef.current));
        else {
            setShouldFocusCell(options?.shouldFocusCell === true);
            setSelectedPosition({
                ...position,
                mode: "SELECT"
            });
        }
        if (onSelectedCellChange && !samePosition) onSelectedCellChange({
            rowIdx: position.rowIdx,
            row: isRowIdxWithinViewportBounds(position.rowIdx) ? rows[position.rowIdx] : void 0,
            column: columns[position.idx]
        });
    }
    function selectHeaderCell({ idx: idx, rowIdx: rowIdx }) {
        selectCell({
            rowIdx: minRowIdx + rowIdx - 1,
            idx: idx
        });
    }
    function getNextPosition(key, ctrlKey, shiftKey) {
        const { idx: idx, rowIdx: rowIdx } = selectedPosition;
        const isRowSelected = selectedCellIsWithinSelectionBounds && idx === -1;
        switch(key){
            case "ArrowUp":
                return {
                    idx: idx,
                    rowIdx: rowIdx - 1
                };
            case "ArrowDown":
                return {
                    idx: idx,
                    rowIdx: rowIdx + 1
                };
            case leftKey:
                return {
                    idx: idx - 1,
                    rowIdx: rowIdx
                };
            case rightKey:
                return {
                    idx: idx + 1,
                    rowIdx: rowIdx
                };
            case "Tab":
                return {
                    idx: idx + (shiftKey ? -1 : 1),
                    rowIdx: rowIdx
                };
            case "Home":
                if (isRowSelected) return {
                    idx: idx,
                    rowIdx: minRowIdx
                };
                return {
                    idx: 0,
                    rowIdx: ctrlKey ? minRowIdx : rowIdx
                };
            case "End":
                if (isRowSelected) return {
                    idx: idx,
                    rowIdx: maxRowIdx
                };
                return {
                    idx: maxColIdx,
                    rowIdx: ctrlKey ? maxRowIdx : rowIdx
                };
            case "PageUp":
                {
                    if (selectedPosition.rowIdx === minRowIdx) return selectedPosition;
                    const nextRowY = getRowTop(rowIdx) + getRowHeight(rowIdx) - clientHeight;
                    return {
                        idx: idx,
                        rowIdx: nextRowY > 0 ? findRowIdx(nextRowY) : 0
                    };
                }
            case "PageDown":
                {
                    if (selectedPosition.rowIdx >= rows.length) return selectedPosition;
                    const nextRowY = getRowTop(rowIdx) + clientHeight;
                    return {
                        idx: idx,
                        rowIdx: nextRowY < totalRowHeight ? findRowIdx(nextRowY) : rows.length - 1
                    };
                }
            default:
                return selectedPosition;
        }
    }
    function navigate(event) {
        const { key: key, shiftKey: shiftKey } = event;
        let cellNavigationMode = "NONE";
        if (key === "Tab") {
            if ($7829d25231ee1190$var$canExitGrid({
                shiftKey: shiftKey,
                maxColIdx: maxColIdx,
                minRowIdx: minRowIdx,
                maxRowIdx: maxRowIdx,
                selectedPosition: selectedPosition
            })) {
                commitEditorChanges();
                return;
            }
            cellNavigationMode = "CHANGE_ROW";
        }
        event.preventDefault();
        const ctrlKey = $7829d25231ee1190$var$isCtrlKeyHeldDown(event);
        const nextPosition = getNextPosition(key, ctrlKey, shiftKey);
        if ($7829d25231ee1190$var$isSamePosition(selectedPosition, nextPosition)) return;
        const nextSelectedCellPosition = $7829d25231ee1190$var$getNextSelectedCellPosition({
            moveUp: key === "ArrowUp",
            moveNext: key === rightKey || key === "Tab" && !shiftKey,
            columns: columns,
            colSpanColumns: colSpanColumns,
            rows: rows,
            topSummaryRows: topSummaryRows,
            bottomSummaryRows: bottomSummaryRows,
            minRowIdx: minRowIdx,
            mainHeaderRowIdx: mainHeaderRowIdx,
            maxRowIdx: maxRowIdx,
            lastFrozenColumnIndex: lastFrozenColumnIndex,
            cellNavigationMode: cellNavigationMode,
            currentPosition: selectedPosition,
            nextPosition: nextPosition,
            isCellWithinBounds: isCellWithinSelectionBounds
        });
        selectCell(nextSelectedCellPosition, {
            shouldFocusCell: true
        });
    }
    function getDraggedOverCellIdx(currentRowIdx) {
        if (draggedOverRowIdx === void 0) return;
        const { rowIdx: rowIdx } = selectedPosition;
        const isDraggedOver = rowIdx < draggedOverRowIdx ? rowIdx < currentRowIdx && currentRowIdx <= draggedOverRowIdx : rowIdx > currentRowIdx && currentRowIdx >= draggedOverRowIdx;
        return isDraggedOver ? selectedPosition.idx : void 0;
    }
    function getDragHandle() {
        if (onFill == null || selectedPosition.mode === "EDIT" || !isCellWithinViewportBounds(selectedPosition)) return;
        const { idx: idx, rowIdx: rowIdx } = selectedPosition;
        const column = columns[idx];
        if (column.renderEditCell == null || column.editable === false) return;
        const isLastRow = rowIdx === maxRowIdx;
        const columnWidth = getColumnWidth(column);
        const colSpan = column.colSpan?.({
            type: "ROW",
            row: rows[rowIdx]
        }) ?? 1;
        const { insetInlineStart: insetInlineStart, ...style$1 } = $7829d25231ee1190$var$getCellStyle(column, colSpan);
        const marginEnd = "calc(var(--rdg-drag-handle-size) * -0.5 + 1px)";
        const isLastColumn = column.idx + colSpan - 1 === maxColIdx;
        const dragHandleStyle = {
            ...style$1,
            gridRowStart: headerAndTopSummaryRowsCount + rowIdx + 1,
            marginInlineEnd: isLastColumn ? void 0 : marginEnd,
            marginBlockEnd: isLastRow ? void 0 : marginEnd,
            insetInlineStart: insetInlineStart ? `calc(${insetInlineStart} + ${columnWidth}px + var(--rdg-drag-handle-size) * -0.5 - 1px)` : void 0
        };
        return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            style: dragHandleStyle,
            className: (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$cellDragHandleClassname, column.frozen && $7829d25231ee1190$var$cellDragHandleFrozenClassname),
            onPointerDown: handleDragHandlePointerDown,
            onPointerMove: isDragging ? handleDragHandlePointerMove : void 0,
            onLostPointerCapture: isDragging ? handleDragHandleLostPointerCapture : void 0,
            onClick: handleDragHandleClick,
            onDoubleClick: handleDragHandleDoubleClick
        });
    }
    function getCellEditor(rowIdx) {
        if (selectedPosition.rowIdx !== rowIdx || selectedPosition.mode === "SELECT") return;
        const { idx: idx, row: row$1 } = selectedPosition;
        const column = columns[idx];
        const colSpan = $7829d25231ee1190$var$getColSpan(column, lastFrozenColumnIndex, {
            type: "ROW",
            row: row$1
        });
        const closeOnExternalRowChange = column.editorOptions?.closeOnExternalRowChange ?? true;
        const closeEditor = (shouldFocusCell$1)=>{
            setShouldFocusCell(shouldFocusCell$1);
            setSelectedPosition(({ idx: idx$1, rowIdx: rowIdx$1 })=>({
                    idx: idx$1,
                    rowIdx: rowIdx$1,
                    mode: "SELECT"
                }));
        };
        const onRowChange = (row$2, commitChanges, shouldFocusCell$1)=>{
            if (commitChanges) (0, $cRanb.flushSync)(()=>{
                updateRow(column, selectedPosition.rowIdx, row$2);
                closeEditor(shouldFocusCell$1);
            });
            else setSelectedPosition((position)=>({
                    ...position,
                    row: row$2
                }));
        };
        if (closeOnExternalRowChange && rows[selectedPosition.rowIdx] !== selectedPosition.originalRow) closeEditor(false);
        return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$EditCell, {
            column: column,
            colSpan: colSpan,
            row: row$1,
            rowIdx: rowIdx,
            onRowChange: onRowChange,
            closeEditor: closeEditor,
            onKeyDown: onCellKeyDown,
            navigate: navigate
        }, column.key);
    }
    function getRowViewportColumns(rowIdx) {
        const selectedColumn = selectedPosition.idx === -1 ? void 0 : columns[selectedPosition.idx];
        if (selectedColumn !== void 0 && selectedPosition.rowIdx === rowIdx && !viewportColumns.includes(selectedColumn)) return selectedPosition.idx > colOverscanEndIdx ? [
            ...viewportColumns,
            selectedColumn
        ] : [
            ...viewportColumns.slice(0, lastFrozenColumnIndex + 1),
            selectedColumn,
            ...viewportColumns.slice(lastFrozenColumnIndex + 1)
        ];
        return viewportColumns;
    }
    function getViewportRows() {
        const rowElements = [];
        const { idx: selectedIdx, rowIdx: selectedRowIdx } = selectedPosition;
        const startRowIdx = selectedCellIsWithinViewportBounds && selectedRowIdx < rowOverscanStartIdx ? rowOverscanStartIdx - 1 : rowOverscanStartIdx;
        const endRowIdx = selectedCellIsWithinViewportBounds && selectedRowIdx > rowOverscanEndIdx ? rowOverscanEndIdx + 1 : rowOverscanEndIdx;
        for(let viewportRowIdx = startRowIdx; viewportRowIdx <= endRowIdx; viewportRowIdx++){
            const isRowOutsideViewport = viewportRowIdx === rowOverscanStartIdx - 1 || viewportRowIdx === rowOverscanEndIdx + 1;
            const rowIdx = isRowOutsideViewport ? selectedRowIdx : viewportRowIdx;
            let rowColumns = viewportColumns;
            const selectedColumn = selectedIdx === -1 ? void 0 : columns[selectedIdx];
            if (selectedColumn !== void 0) {
                if (isRowOutsideViewport) rowColumns = [
                    selectedColumn
                ];
                else rowColumns = getRowViewportColumns(rowIdx);
            }
            const row$1 = rows[rowIdx];
            const gridRowStart = headerAndTopSummaryRowsCount + rowIdx + 1;
            let key = rowIdx;
            let isRowSelected = false;
            if (typeof rowKeyGetter === "function") {
                key = rowKeyGetter(row$1);
                isRowSelected = selectedRows?.has(key) ?? false;
            }
            rowElements.push(renderRow(key, {
                "aria-rowindex": headerAndTopSummaryRowsCount + rowIdx + 1,
                "aria-selected": isSelectable ? isRowSelected : void 0,
                rowIdx: rowIdx,
                row: row$1,
                viewportColumns: rowColumns,
                isRowSelectionDisabled: isRowSelectionDisabled?.(row$1) ?? false,
                isRowSelected: isRowSelected,
                onCellMouseDown: onCellMouseDownLatest,
                onCellClick: onCellClickLatest,
                onCellDoubleClick: onCellDoubleClickLatest,
                onCellContextMenu: onCellContextMenuLatest,
                rowClass: rowClass,
                gridRowStart: gridRowStart,
                selectedCellIdx: selectedRowIdx === rowIdx ? selectedIdx : void 0,
                draggedOverCellIdx: getDraggedOverCellIdx(rowIdx),
                lastFrozenColumnIndex: lastFrozenColumnIndex,
                onRowChange: handleFormatterRowChangeLatest,
                selectCell: selectCellLatest,
                selectedCellEditor: getCellEditor(rowIdx)
            }));
        }
        return rowElements;
    }
    if (selectedPosition.idx > maxColIdx || selectedPosition.rowIdx > maxRowIdx) {
        setSelectedPosition({
            idx: -1,
            rowIdx: minRowIdx - 1,
            mode: "SELECT"
        });
        setDraggedOverRowIdx(void 0);
    }
    if (isColumnWidthsControlled && columnWidthsInternal !== columnWidthsRaw) setColumnWidthsInternal(columnWidthsRaw);
    let templateRows = `repeat(${headerRowsCount}, ${headerRowHeight}px)`;
    if (topSummaryRowsCount > 0) templateRows += ` repeat(${topSummaryRowsCount}, ${summaryRowHeight}px)`;
    if (rows.length > 0) templateRows += gridTemplateRows;
    if (bottomSummaryRowsCount > 0) templateRows += ` repeat(${bottomSummaryRowsCount}, ${summaryRowHeight}px)`;
    const isGroupRowFocused = selectedPosition.idx === -1 && selectedPosition.rowIdx !== minRowIdx - 1;
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        role: role,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-description": ariaDescription,
        "aria-describedby": ariaDescribedBy,
        "aria-multiselectable": isSelectable ? true : void 0,
        "aria-colcount": columns.length,
        "aria-rowcount": ariaRowCount,
        tabIndex: -1,
        className: (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$rootClassname, {
            [$7829d25231ee1190$var$viewportDraggingClassname]: isDragging
        }, className),
        style: {
            ...style,
            scrollPaddingInlineStart: selectedPosition.idx > lastFrozenColumnIndex || scrollToPosition?.idx !== void 0 ? `${totalFrozenColumnWidth}px` : void 0,
            scrollPaddingBlock: isRowIdxWithinViewportBounds(selectedPosition.rowIdx) || scrollToPosition?.rowIdx !== void 0 ? `${headerRowsHeight + topSummaryRowsCount * summaryRowHeight}px ${bottomSummaryRowsCount * summaryRowHeight}px` : void 0,
            gridTemplateColumns: gridTemplateColumns,
            gridTemplateRows: templateRows,
            "--rdg-header-row-height": `${headerRowHeight}px`,
            "--rdg-scroll-height": `${scrollHeight}px`,
            ...layoutCssVars
        },
        dir: direction,
        ref: gridRef,
        onScroll: handleScroll,
        onKeyDown: handleKeyDown,
        onCopy: handleCellCopy,
        onPaste: handleCellPaste,
        "data-testid": testId,
        "data-cy": dataCy,
        children: [
            /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)($7829d25231ee1190$export$2bb5fbcb8b262dfb, {
                value: defaultGridComponents,
                children: [
                    /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$HeaderRowSelectionChangeContext, {
                        value: selectHeaderRowLatest,
                        children: /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)($7829d25231ee1190$var$HeaderRowSelectionContext, {
                            value: headerSelectionValue,
                            children: [
                                Array.from({
                                    length: groupedColumnHeaderRowsCount
                                }, (_, index)=>/* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$GroupedColumnHeaderRow_default, {
                                        rowIdx: index + 1,
                                        level: -groupedColumnHeaderRowsCount + index,
                                        columns: getRowViewportColumns(minRowIdx + index),
                                        selectedCellIdx: selectedPosition.rowIdx === minRowIdx + index ? selectedPosition.idx : void 0,
                                        selectCell: selectHeaderCellLatest
                                    }, index)),
                                /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$HeaderRow_default, {
                                    headerRowClass: headerRowClass,
                                    rowIdx: headerRowsCount,
                                    columns: getRowViewportColumns(mainHeaderRowIdx),
                                    onColumnResize: handleColumnResizeLatest,
                                    onColumnResizeEnd: handleColumnResizeEndLatest,
                                    onColumnsReorder: onColumnsReorderLastest,
                                    sortColumns: sortColumns,
                                    onSortColumnsChange: onSortColumnsChangeLatest,
                                    lastFrozenColumnIndex: lastFrozenColumnIndex,
                                    selectedCellIdx: selectedPosition.rowIdx === mainHeaderRowIdx ? selectedPosition.idx : void 0,
                                    selectCell: selectHeaderCellLatest,
                                    shouldFocusGrid: !selectedCellIsWithinSelectionBounds,
                                    direction: direction
                                })
                            ]
                        })
                    }),
                    rows.length === 0 && noRowsFallback ? noRowsFallback : /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                        children: [
                            topSummaryRows?.map((row$1, rowIdx)=>{
                                const gridRowStart = headerRowsCount + 1 + rowIdx;
                                const summaryRowIdx = mainHeaderRowIdx + 1 + rowIdx;
                                const isSummaryRowSelected = selectedPosition.rowIdx === summaryRowIdx;
                                const top = headerRowsHeight + summaryRowHeight * rowIdx;
                                return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$SummaryRow_default, {
                                    "aria-rowindex": gridRowStart,
                                    rowIdx: summaryRowIdx,
                                    gridRowStart: gridRowStart,
                                    row: row$1,
                                    top: top,
                                    bottom: void 0,
                                    viewportColumns: getRowViewportColumns(summaryRowIdx),
                                    lastFrozenColumnIndex: lastFrozenColumnIndex,
                                    selectedCellIdx: isSummaryRowSelected ? selectedPosition.idx : void 0,
                                    isTop: true,
                                    selectCell: selectCellLatest
                                }, rowIdx);
                            }),
                            /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$RowSelectionChangeContext, {
                                value: selectRowLatest,
                                children: getViewportRows()
                            }),
                            bottomSummaryRows?.map((row$1, rowIdx)=>{
                                const gridRowStart = headerAndTopSummaryRowsCount + rows.length + rowIdx + 1;
                                const summaryRowIdx = rows.length + rowIdx;
                                const isSummaryRowSelected = selectedPosition.rowIdx === summaryRowIdx;
                                const top = clientHeight > totalRowHeight ? gridHeight - summaryRowHeight * (bottomSummaryRows.length - rowIdx) : void 0;
                                const bottom = top === void 0 ? summaryRowHeight * (bottomSummaryRows.length - 1 - rowIdx) : void 0;
                                return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$SummaryRow_default, {
                                    "aria-rowindex": ariaRowCount - bottomSummaryRowsCount + rowIdx + 1,
                                    rowIdx: summaryRowIdx,
                                    gridRowStart: gridRowStart,
                                    row: row$1,
                                    top: top,
                                    bottom: bottom,
                                    viewportColumns: getRowViewportColumns(summaryRowIdx),
                                    lastFrozenColumnIndex: lastFrozenColumnIndex,
                                    selectedCellIdx: isSummaryRowSelected ? selectedPosition.idx : void 0,
                                    isTop: false,
                                    selectCell: selectCellLatest
                                }, rowIdx);
                            })
                        ]
                    })
                ]
            }),
            getDragHandle(),
            $7829d25231ee1190$var$renderMeasuringCells(viewportColumns),
            isTreeGrid && /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                ref: focusSinkRef,
                tabIndex: isGroupRowFocused ? 0 : -1,
                className: (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$focusSinkClassname, {
                    [$7829d25231ee1190$var$focusSinkHeaderAndSummaryClassname]: !isRowIdxWithinViewportBounds(selectedPosition.rowIdx),
                    [$7829d25231ee1190$var$rowSelected]: isGroupRowFocused,
                    [$7829d25231ee1190$var$rowSelectedWithFrozenCell]: isGroupRowFocused && lastFrozenColumnIndex !== -1
                }),
                style: {
                    gridRowStart: selectedPosition.rowIdx + headerAndTopSummaryRowsCount + 1
                }
            }),
            scrollToPosition !== null && /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$ScrollToCell, {
                scrollToPosition: scrollToPosition,
                setScrollToCellPosition: setScrollToPosition,
                gridRef: gridRef
            })
        ]
    });
}
function $7829d25231ee1190$var$getCellToScroll(gridEl) {
    return gridEl.querySelector(":scope > [role=\"row\"] > [tabindex=\"0\"]");
}
function $7829d25231ee1190$var$isSamePosition(p1, p2) {
    return p1.idx === p2.idx && p1.rowIdx === p2.rowIdx;
}
//#endregion
//#region src/GroupCell.tsx
function $7829d25231ee1190$var$GroupCell({ id: id, groupKey: groupKey, childRows: childRows, isExpanded: isExpanded, isCellSelected: isCellSelected, column: column, row: row$1, groupColumnIndex: groupColumnIndex, isGroupByColumn: isGroupByColumn, toggleGroup: toggleGroupWrapper }) {
    const { tabIndex: tabIndex, childTabIndex: childTabIndex, onFocus: onFocus } = $7829d25231ee1190$var$useRovingTabIndex(isCellSelected);
    function toggleGroup() {
        toggleGroupWrapper(id);
    }
    const isLevelMatching = isGroupByColumn && groupColumnIndex === column.idx;
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        role: "gridcell",
        "aria-colindex": column.idx + 1,
        "aria-selected": isCellSelected,
        tabIndex: tabIndex,
        className: $7829d25231ee1190$var$getCellClassname(column),
        style: {
            ...$7829d25231ee1190$var$getCellStyle(column),
            cursor: isLevelMatching ? "pointer" : "default"
        },
        onMouseDown: (event)=>{
            event.preventDefault();
        },
        onClick: isLevelMatching ? toggleGroup : void 0,
        onFocus: onFocus,
        children: (!isGroupByColumn || isLevelMatching) && column.renderGroupCell?.({
            groupKey: groupKey,
            childRows: childRows,
            column: column,
            row: row$1,
            isExpanded: isExpanded,
            tabIndex: childTabIndex,
            toggleGroup: toggleGroup
        })
    }, column.key);
}
var $7829d25231ee1190$var$GroupCell_default = (0, $kYL7Z.memo)($7829d25231ee1190$var$GroupCell);
//#endregion
//#region src/GroupRow.tsx
const $7829d25231ee1190$var$groupRow = "g1yxluv37-0-0-beta-57";
const $7829d25231ee1190$var$groupRowClassname = `rdg-group-row ${$7829d25231ee1190$var$groupRow}`;
function $7829d25231ee1190$var$GroupedRow({ className: className, row: row$1, rowIdx: rowIdx, viewportColumns: viewportColumns, selectedCellIdx: selectedCellIdx, isRowSelected: isRowSelected, selectCell: selectCell, gridRowStart: gridRowStart, groupBy: groupBy, toggleGroup: toggleGroup, isRowSelectionDisabled: isRowSelectionDisabled, ...props }) {
    const idx = viewportColumns[0].key === $7829d25231ee1190$export$eae764166299b939 ? row$1.level + 1 : row$1.level;
    function handleSelectGroup() {
        selectCell({
            rowIdx: rowIdx,
            idx: -1
        }, {
            shouldFocusCell: true
        });
    }
    const selectionValue = (0, $kYL7Z.useMemo)(()=>({
            isRowSelectionDisabled: false,
            isRowSelected: isRowSelected
        }), [
        isRowSelected
    ]);
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$RowSelectionContext, {
        value: selectionValue,
        children: /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            role: "row",
            "aria-level": row$1.level + 1,
            "aria-setsize": row$1.setSize,
            "aria-posinset": row$1.posInSet + 1,
            "aria-expanded": row$1.isExpanded,
            className: (0, $2f1546e0ec584d2b$export$2e2bcd8739ae039)($7829d25231ee1190$var$rowClassname, $7829d25231ee1190$var$groupRowClassname, `rdg-row-${rowIdx % 2 === 0 ? "even" : "odd"}`, selectedCellIdx === -1 && $7829d25231ee1190$var$rowSelectedClassname, className),
            onMouseDown: handleSelectGroup,
            style: $7829d25231ee1190$var$getRowStyle(gridRowStart),
            ...props,
            children: viewportColumns.map((column)=>/* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$GroupCell_default, {
                    id: row$1.id,
                    groupKey: row$1.groupKey,
                    childRows: row$1.childRows,
                    isExpanded: row$1.isExpanded,
                    isCellSelected: selectedCellIdx === column.idx,
                    column: column,
                    row: row$1,
                    groupColumnIndex: idx,
                    toggleGroup: toggleGroup,
                    isGroupByColumn: groupBy.includes(column.key)
                }, column.key))
        })
    });
}
var $7829d25231ee1190$var$GroupRow_default = (0, $kYL7Z.memo)($7829d25231ee1190$var$GroupedRow);
//#endregion
//#region src/TreeDataGrid.tsx
function $7829d25231ee1190$export$d5257cd7af1adc6b({ columns: rawColumns, rows: rawRows, rowHeight: rawRowHeight, rowKeyGetter: rawRowKeyGetter, onCellKeyDown: rawOnCellKeyDown, onCellCopy: rawOnCellCopy, onCellPaste: rawOnCellPaste, onRowsChange: onRowsChange, selectedRows: rawSelectedRows, onSelectedRowsChange: rawOnSelectedRowsChange, renderers: renderers, groupBy: rawGroupBy, rowGrouper: rowGrouper, expandedGroupIds: expandedGroupIds, onExpandedGroupIdsChange: onExpandedGroupIdsChange, groupIdGetter: rawGroupIdGetter, ...props }) {
    const defaultRenderers = $7829d25231ee1190$var$useDefaultRenderers();
    const rawRenderRow = renderers?.renderRow ?? defaultRenderers?.renderRow ?? $7829d25231ee1190$var$defaultRenderRow;
    const headerAndTopSummaryRowsCount = 1 + (props.topSummaryRows?.length ?? 0);
    const { leftKey: leftKey, rightKey: rightKey } = $7829d25231ee1190$var$getLeftRightKey(props.direction);
    const toggleGroupLatest = $7829d25231ee1190$var$useLatestFunc(toggleGroup);
    const groupIdGetter = rawGroupIdGetter ?? $7829d25231ee1190$var$defaultGroupIdGetter;
    const { columns: columns, groupBy: groupBy } = (0, $kYL7Z.useMemo)(()=>{
        const columns$1 = rawColumns.toSorted(({ key: aKey }, { key: bKey })=>{
            if (aKey === $7829d25231ee1190$export$eae764166299b939) return -1;
            if (bKey === $7829d25231ee1190$export$eae764166299b939) return 1;
            if (rawGroupBy.includes(aKey)) {
                if (rawGroupBy.includes(bKey)) return rawGroupBy.indexOf(aKey) - rawGroupBy.indexOf(bKey);
                return -1;
            }
            if (rawGroupBy.includes(bKey)) return 1;
            return 0;
        });
        const groupBy$1 = [];
        for (const [index, column] of columns$1.entries())if (rawGroupBy.includes(column.key)) {
            groupBy$1.push(column.key);
            columns$1[index] = {
                ...column,
                frozen: true,
                renderCell: ()=>null,
                renderGroupCell: column.renderGroupCell ?? $7829d25231ee1190$export$623abc142db48841,
                editable: false
            };
        }
        return {
            columns: columns$1,
            groupBy: groupBy$1
        };
    }, [
        rawColumns,
        rawGroupBy
    ]);
    const [groupedRows, rowsCount] = (0, $kYL7Z.useMemo)(()=>{
        if (groupBy.length === 0) return [
            void 0,
            rawRows.length
        ];
        const groupRows = (rows$1, [groupByKey, ...remainingGroupByKeys], startRowIndex)=>{
            let groupRowsCount = 0;
            const groups = {};
            for (const [key, childRows] of Object.entries(rowGrouper(rows$1, groupByKey))){
                const [childGroups, childRowsCount] = remainingGroupByKeys.length === 0 ? [
                    childRows,
                    childRows.length
                ] : groupRows(childRows, remainingGroupByKeys, startRowIndex + groupRowsCount + 1);
                groups[key] = {
                    childRows: childRows,
                    childGroups: childGroups,
                    startRowIndex: startRowIndex + groupRowsCount
                };
                groupRowsCount += childRowsCount + 1;
            }
            return [
                groups,
                groupRowsCount
            ];
        };
        return groupRows(rawRows, groupBy, 0);
    }, [
        groupBy,
        rowGrouper,
        rawRows
    ]);
    const [rows, isGroupRow] = (0, $kYL7Z.useMemo)(()=>{
        const allGroupRows = new Set();
        if (!groupedRows) return [
            rawRows,
            isGroupRow$1
        ];
        const flattenedRows = [];
        const expandGroup = (rows$1, parentId, level)=>{
            if ($7829d25231ee1190$var$isReadonlyArray(rows$1)) {
                flattenedRows.push(...rows$1);
                return;
            }
            Object.keys(rows$1).forEach((groupKey, posInSet, keys)=>{
                const id = groupIdGetter(groupKey, parentId);
                const isExpanded = expandedGroupIds.has(id);
                const { childRows: childRows, childGroups: childGroups, startRowIndex: startRowIndex } = rows$1[groupKey];
                const groupRow$1 = {
                    id: id,
                    parentId: parentId,
                    groupKey: groupKey,
                    isExpanded: isExpanded,
                    childRows: childRows,
                    level: level,
                    posInSet: posInSet,
                    startRowIndex: startRowIndex,
                    setSize: keys.length
                };
                flattenedRows.push(groupRow$1);
                allGroupRows.add(groupRow$1);
                if (isExpanded) expandGroup(childGroups, id, level + 1);
            });
        };
        expandGroup(groupedRows, void 0, 0);
        return [
            flattenedRows,
            isGroupRow$1
        ];
        function isGroupRow$1(row$1) {
            return allGroupRows.has(row$1);
        }
    }, [
        expandedGroupIds,
        groupedRows,
        rawRows,
        groupIdGetter
    ]);
    const rowHeight = (0, $kYL7Z.useMemo)(()=>{
        if (typeof rawRowHeight === "function") return (row$1)=>{
            if (isGroupRow(row$1)) return rawRowHeight({
                type: "GROUP",
                row: row$1
            });
            return rawRowHeight({
                type: "ROW",
                row: row$1
            });
        };
        return rawRowHeight;
    }, [
        isGroupRow,
        rawRowHeight
    ]);
    const getParentRowAndIndex = (0, $kYL7Z.useCallback)((row$1)=>{
        const rowIdx = rows.indexOf(row$1);
        for(let i = rowIdx - 1; i >= 0; i--){
            const parentRow = rows[i];
            if (isGroupRow(parentRow) && (!isGroupRow(row$1) || row$1.parentId === parentRow.id)) return [
                parentRow,
                i
            ];
        }
        return void 0;
    }, [
        isGroupRow,
        rows
    ]);
    const rowKeyGetter = (0, $kYL7Z.useCallback)((row$1)=>{
        if (isGroupRow(row$1)) return row$1.id;
        if (typeof rawRowKeyGetter === "function") return rawRowKeyGetter(row$1);
        const parentRowAndIndex = getParentRowAndIndex(row$1);
        if (parentRowAndIndex !== void 0) {
            const { startRowIndex: startRowIndex, childRows: childRows } = parentRowAndIndex[0];
            const groupIndex = childRows.indexOf(row$1);
            return startRowIndex + groupIndex + 1;
        }
        return rows.indexOf(row$1);
    }, [
        getParentRowAndIndex,
        isGroupRow,
        rawRowKeyGetter,
        rows
    ]);
    const selectedRows = (0, $kYL7Z.useMemo)(()=>{
        if (rawSelectedRows == null) return null;
        $7829d25231ee1190$var$assertIsValidKeyGetter(rawRowKeyGetter);
        const selectedRows$1 = new Set(rawSelectedRows);
        for (const row$1 of rows)if (isGroupRow(row$1)) {
            const isGroupRowSelected = row$1.childRows.every((cr)=>rawSelectedRows.has(rawRowKeyGetter(cr)));
            if (isGroupRowSelected) selectedRows$1.add(row$1.id);
        }
        return selectedRows$1;
    }, [
        isGroupRow,
        rawRowKeyGetter,
        rawSelectedRows,
        rows
    ]);
    function onSelectedRowsChange(newSelectedRows) {
        if (!rawOnSelectedRowsChange) return;
        $7829d25231ee1190$var$assertIsValidKeyGetter(rawRowKeyGetter);
        const newRawSelectedRows = new Set(rawSelectedRows);
        for (const row$1 of rows){
            const key = rowKeyGetter(row$1);
            if (selectedRows?.has(key) && !newSelectedRows.has(key)) {
                if (isGroupRow(row$1)) for (const cr of row$1.childRows)newRawSelectedRows.delete(rawRowKeyGetter(cr));
                else newRawSelectedRows.delete(key);
            } else if (!selectedRows?.has(key) && newSelectedRows.has(key)) {
                if (isGroupRow(row$1)) for (const cr of row$1.childRows)newRawSelectedRows.add(rawRowKeyGetter(cr));
                else newRawSelectedRows.add(key);
            }
        }
        rawOnSelectedRowsChange(newRawSelectedRows);
    }
    function handleKeyDown(args, event) {
        rawOnCellKeyDown?.(args, event);
        if (event.isGridDefaultPrevented()) return;
        if (args.mode === "EDIT") return;
        const { column: column, rowIdx: rowIdx, selectCell: selectCell } = args;
        const idx = column?.idx ?? -1;
        const row$1 = rows[rowIdx];
        if (!isGroupRow(row$1)) return;
        if (idx === -1 && (event.key === leftKey && row$1.isExpanded || event.key === rightKey && !row$1.isExpanded)) {
            event.preventDefault();
            event.preventGridDefault();
            toggleGroup(row$1.id);
        }
        if (idx === -1 && event.key === leftKey && !row$1.isExpanded && row$1.level !== 0) {
            const parentRowAndIndex = getParentRowAndIndex(row$1);
            if (parentRowAndIndex !== void 0) {
                event.preventGridDefault();
                selectCell({
                    idx: idx,
                    rowIdx: parentRowAndIndex[1]
                });
            }
        }
    }
    function handleCellCopy({ row: row$1, column: column }, event) {
        if (!isGroupRow(row$1)) rawOnCellCopy?.({
            row: row$1,
            column: column
        }, event);
    }
    function handleCellPaste({ row: row$1, column: column }, event) {
        return isGroupRow(row$1) ? row$1 : rawOnCellPaste({
            row: row$1,
            column: column
        }, event);
    }
    function handleRowsChange(updatedRows, { indexes: indexes, column: column }) {
        if (!onRowsChange) return;
        const updatedRawRows = [
            ...rawRows
        ];
        const rawIndexes = [];
        for (const index of indexes){
            const rawIndex = rawRows.indexOf(rows[index]);
            updatedRawRows[rawIndex] = updatedRows[index];
            rawIndexes.push(rawIndex);
        }
        onRowsChange(updatedRawRows, {
            indexes: rawIndexes,
            column: column
        });
    }
    function toggleGroup(groupId) {
        const newExpandedGroupIds = new Set(expandedGroupIds);
        if (newExpandedGroupIds.has(groupId)) newExpandedGroupIds.delete(groupId);
        else newExpandedGroupIds.add(groupId);
        onExpandedGroupIdsChange(newExpandedGroupIds);
    }
    function renderRow(key, { row: row$1, rowClass: rowClass, onCellMouseDown: onCellMouseDown, onCellClick: onCellClick, onCellDoubleClick: onCellDoubleClick, onCellContextMenu: onCellContextMenu, onRowChange: onRowChange, lastFrozenColumnIndex: lastFrozenColumnIndex, draggedOverCellIdx: draggedOverCellIdx, selectedCellEditor: selectedCellEditor, ...rowProps }) {
        if (isGroupRow(row$1)) {
            const { startRowIndex: startRowIndex } = row$1;
            return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$var$GroupRow_default, {
                ...rowProps,
                "aria-rowindex": headerAndTopSummaryRowsCount + startRowIndex + 1,
                row: row$1,
                groupBy: groupBy,
                toggleGroup: toggleGroupLatest
            }, key);
        }
        let ariaRowIndex = rowProps["aria-rowindex"];
        const parentRowAndIndex = getParentRowAndIndex(row$1);
        if (parentRowAndIndex !== void 0) {
            const { startRowIndex: startRowIndex, childRows: childRows } = parentRowAndIndex[0];
            const groupIndex = childRows.indexOf(row$1);
            ariaRowIndex = startRowIndex + headerAndTopSummaryRowsCount + groupIndex + 2;
        }
        return rawRenderRow(key, {
            ...rowProps,
            "aria-rowindex": ariaRowIndex,
            row: row$1,
            rowClass: rowClass,
            onCellMouseDown: onCellMouseDown,
            onCellClick: onCellClick,
            onCellDoubleClick: onCellDoubleClick,
            onCellContextMenu: onCellContextMenu,
            onRowChange: onRowChange,
            lastFrozenColumnIndex: lastFrozenColumnIndex,
            draggedOverCellIdx: draggedOverCellIdx,
            selectedCellEditor: selectedCellEditor
        });
    }
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)($7829d25231ee1190$export$c8dd51eb24f71762, {
        ...props,
        role: "treegrid",
        "aria-rowcount": rowsCount + 1 + (props.topSummaryRows?.length ?? 0) + (props.bottomSummaryRows?.length ?? 0),
        columns: columns,
        rows: rows,
        rowHeight: rowHeight,
        rowKeyGetter: rowKeyGetter,
        onRowsChange: handleRowsChange,
        selectedRows: selectedRows,
        onSelectedRowsChange: onSelectedRowsChange,
        onCellKeyDown: handleKeyDown,
        onCellCopy: handleCellCopy,
        onCellPaste: rawOnCellPaste ? handleCellPaste : void 0,
        renderers: {
            ...renderers,
            renderRow: renderRow
        }
    });
}
function $7829d25231ee1190$var$defaultGroupIdGetter(groupKey, parentId) {
    return parentId !== void 0 ? `${parentId}__${groupKey}` : groupKey;
}
function $7829d25231ee1190$var$isReadonlyArray(arr) {
    return Array.isArray(arr);
}
//#endregion
//#region src/editors/textEditor.tsx
const $7829d25231ee1190$var$textEditorInternalClassname = "t7vyx3i7-0-0-beta-57";
const $7829d25231ee1190$var$textEditorClassname = `rdg-text-editor ${$7829d25231ee1190$var$textEditorInternalClassname}`;
function $7829d25231ee1190$var$autoFocusAndSelect(input) {
    input?.focus();
    input?.select();
}
function $7829d25231ee1190$export$68ed99b350adf30a({ row: row$1, column: column, onRowChange: onRowChange, onClose: onClose }) {
    return /* @__PURE__ */ (0, $fc31e5e9fc16a880$exports.jsx)("input", {
        className: $7829d25231ee1190$var$textEditorClassname,
        ref: $7829d25231ee1190$var$autoFocusAndSelect,
        value: row$1[column.key],
        onChange: (event)=>onRowChange({
                ...row$1,
                [column.key]: event.target.value
            }),
        onBlur: ()=>onClose(true, false)
    });
}





const $f448bea4af9ba462$var$_DataGridContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    overflow: hidden;

    [role="columnheader"] {
        background-color: var(--rdg-header-background-color, #f9f9f9);
    }

    .filter-cell {
        padding: 0 8px;
        display: flex;
        align-items: center;
        gap: 6px;
        flex-wrap: wrap;

        .filter-cell-header {
            display: flex;
            align-items: center;
            gap: 6px;
            white-space: nowrap;
        }

        .filter-icon-target {
            display: flex;
            align-items: center;
            cursor: pointer;
        }

        .default-filter {
            flex: 1 1 60px;
            min-width: 60px;

            input {
                height: 22px;
                font-size: 12px;
            }
        }
    }


`;
const $f448bea4af9ba462$var$_FilterPopoverContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 280px;

    .filter-combinator {
        display: flex;
        justify-content: center;
    }

    .filter-condition {
        display: flex;
        align-items: center;
        gap: 4px;
        flex-wrap: nowrap;

        [class*="bp"][class*="-input-group"] {
            flex: 1;
            min-width: 0;

            input {
                height: 24px;
                font-size: 12px;
            }
        }
    }

    .filter-mode-tag {
        cursor: pointer;
        user-select: none;
        flex-shrink: 0;

        &:focus {
            outline: none;
        }

        [class*="bp"][class*="-icon"] {
            margin-right: 4px;
        }
    }

    .filter-add-row {
        display: flex;
        justify-content: space-between;
    }
`;
function $f448bea4af9ba462$var$defaultFilterFn(row, columnKey, term) {
    const parts = columnKey.split('.');
    let value = parts.reduce((acc, part)=>acc && acc[part], row);
    if (value && String(value).toLowerCase().includes(term)) return true;
    const parent = parts.length > 1 ? parts.slice(0, -1).reduce((acc, part)=>acc && acc[part], row) : row;
    if (parent) {
        if (parent._id && String(parent._id).toLowerCase().includes(term)) return true;
        if (parent.id && String(parent.id).toLowerCase().includes(term)) return true;
    }
    return false;
}
const $f448bea4af9ba462$var$FILTER_MODES = [
    {
        key: 'include',
        label: 'Includes',
        icon: 'filter-keep',
        needsText: true
    },
    {
        key: 'exclude',
        label: 'Excludes',
        icon: 'filter-remove',
        needsText: true
    },
    {
        key: 'empty',
        label: 'Empty',
        icon: 'cross-circle',
        needsText: false
    },
    {
        key: 'not-empty',
        label: 'Not Empty',
        icon: 'tick-circle',
        needsText: false
    }
];
function $f448bea4af9ba462$var$resolveValue(row, columnKey) {
    const parts = columnKey.split('.');
    return parts.reduce((acc, part)=>acc && acc[part], row);
}
function $f448bea4af9ba462$var$testCondition(row, columnKey, condition, columnFilterFns) {
    const { filterTerm: filterTerm, mode: mode = 'include' } = condition;
    if (mode === 'empty') {
        const val = $f448bea4af9ba462$var$resolveValue(row, columnKey);
        return val == null || val === '';
    }
    if (mode === 'not-empty') {
        const val = $f448bea4af9ba462$var$resolveValue(row, columnKey);
        return val != null && val !== '';
    }
    if (!filterTerm) return true;
    const term = filterTerm.toLowerCase();
    const fn = columnFilterFns?.[columnKey] || $f448bea4af9ba462$var$defaultFilterFn;
    const match = fn(row, columnKey, term);
    return mode === 'exclude' ? !match : match;
}
function $f448bea4af9ba462$var$filterRows(rows, filters, columnFilterFns) {
    return rows.filter((row)=>{
        return Object.keys(filters).every((columnKey)=>{
            const colFilter = filters[columnKey];
            const conditions = colFilter.conditions || [];
            const combinator = colFilter.combinator || 'and';
            const active = conditions.filter((c)=>!$f448bea4af9ba462$var$FILTER_MODES.find((m)=>m.key === c.mode)?.needsText || c.filterTerm);
            if (active.length === 0) return true;
            if (combinator === 'and') return active.every((c)=>$f448bea4af9ba462$var$testCondition(row, columnKey, c, columnFilterFns));
            else return active.some((c)=>$f448bea4af9ba462$var$testCondition(row, columnKey, c, columnFilterFns));
        });
    });
}
function $f448bea4af9ba462$var$sortRows(column, direction, rows) {
    const comparer = (a, b)=>{
        let a_value = column.split('.').reduce((acc, part)=>acc && acc[part], a);
        let b_value = column.split('.').reduce((acc, part)=>acc && acc[part], b);
        return (a_value > b_value ? 1 : -1) * (direction === 'ASC' ? 1 : -1);
    };
    return direction === 'NONE' ? rows : [
        ...rows
    ].sort(comparer);
}
function $f448bea4af9ba462$var$FilterConditionRow({ columnKey: columnKey, index: index, condition: condition, setFilters: setFilters }) {
    const modeInfo = $f448bea4af9ba462$var$FILTER_MODES.find((m)=>m.key === condition.mode) || $f448bea4af9ba462$var$FILTER_MODES[0];
    const updateCondition = (updates)=>{
        setFilters((prev)=>{
            const colFilter = {
                ...prev[columnKey] || {
                    conditions: [],
                    combinator: 'and'
                }
            };
            const conditions = [
                ...colFilter.conditions || []
            ];
            conditions[index] = {
                ...conditions[index],
                ...updates
            };
            return {
                ...prev,
                [columnKey]: {
                    ...colFilter,
                    conditions: conditions
                }
            };
        });
    };
    const removeCondition = ()=>{
        setFilters((prev)=>{
            const colFilter = {
                ...prev[columnKey] || {
                    conditions: [],
                    combinator: 'and'
                }
            };
            const conditions = (colFilter.conditions || []).filter((_, i)=>i !== index);
            if (conditions.length === 0) {
                const next = {
                    ...prev
                };
                delete next[columnKey];
                return next;
            }
            return {
                ...prev,
                [columnKey]: {
                    ...colFilter,
                    conditions: conditions
                }
            };
        });
    };
    const modeTag = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
        interactionKind: "hover",
        hoverOpenDelay: 150,
        hoverCloseDelay: 200,
        placement: "bottom-start",
        minimal: true,
        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
            small: true,
            children: $f448bea4af9ba462$var$FILTER_MODES.map((m)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                    icon: m.icon,
                    text: m.label,
                    active: condition.mode === m.key,
                    onMouseDown: (e)=>e.preventDefault(),
                    onClick: (e)=>{
                        e.stopPropagation();
                        updateCondition({
                            mode: m.key,
                            ...m.needsText ? {} : {
                                filterTerm: ''
                            }
                        });
                    }
                }, m.key))
        }),
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            className: "filter-mode-tag",
            minimal: condition.mode === 'include',
            intent: condition.mode === 'include' ? 'none' : 'warning',
            tabIndex: -1,
            size: "small",
            icon: modeInfo.icon,
            onMouseDown: (e)=>e.preventDefault(),
            onClick: (e)=>e.stopPropagation(),
            children: !modeInfo.needsText ? modeInfo.label : null
        })
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: "filter-condition",
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                minimal: true,
                small: true,
                icon: "small-cross",
                onClick: removeCondition
            }),
            modeInfo.needsText ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                small: true,
                value: condition.filterTerm || '',
                onChange: (e)=>updateCondition({
                        filterTerm: e.target.value
                    }),
                onKeyDown: (e)=>e.stopPropagation(),
                onClick: (e)=>e.stopPropagation(),
                placeholder: `${modeInfo.label}...`,
                leftElement: modeTag
            }) : modeTag
        ]
    });
}
function $f448bea4af9ba462$var$FilterableHeaderCell({ column: column, filters: filters, setFilters: setFilters }) {
    const colFilter = filters[column.key];
    const conditions = colFilter?.conditions || [];
    const combinator = colFilter?.combinator || 'and';
    const hasActive = conditions.some((c)=>{
        const m = $f448bea4af9ba462$var$FILTER_MODES.find((fm)=>fm.key === c.mode);
        return m && (!m.needsText || c.filterTerm);
    });
    const showDefault = column.showDefaultFilter;
    const defaultTerm = showDefault ? conditions.find((c)=>c.mode === 'include')?.filterTerm || '' : '';
    const setDefaultTerm = (value)=>{
        setFilters((prev)=>{
            const existing = prev[column.key] || {
                conditions: [],
                combinator: 'and'
            };
            const conds = [
                ...existing.conditions || []
            ];
            const idx = conds.findIndex((c)=>c.mode === 'include');
            if (!value) {
                // Remove the include condition
                if (idx !== -1) conds.splice(idx, 1);
                if (conds.length === 0) {
                    const next = {
                        ...prev
                    };
                    delete next[column.key];
                    return next;
                }
            } else if (idx !== -1) conds[idx] = {
                ...conds[idx],
                filterTerm: value
            };
            else conds.push({
                mode: 'include',
                filterTerm: value
            });
            return {
                ...prev,
                [column.key]: {
                    ...existing,
                    conditions: conds
                }
            };
        });
    };
    const addCondition = ()=>{
        setFilters((prev)=>{
            const existing = prev[column.key] || {
                conditions: [],
                combinator: 'and'
            };
            const conditions = [
                ...existing.conditions || [],
                {
                    mode: 'include',
                    filterTerm: ''
                }
            ];
            return {
                ...prev,
                [column.key]: {
                    ...existing,
                    conditions: conditions
                }
            };
        });
    };
    const toggleCombinator = ()=>{
        setFilters((prev)=>{
            const existing = prev[column.key] || {
                conditions: [],
                combinator: 'and'
            };
            return {
                ...prev,
                [column.key]: {
                    ...existing,
                    combinator: existing.combinator === 'and' ? 'or' : 'and'
                }
            };
        });
    };
    const clearAll = ()=>{
        setFilters((prev)=>{
            const next = {
                ...prev
            };
            delete next[column.key];
            return next;
        });
    };
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    const hoverTimeout = (0, $kYL7Z.useRef)(null);
    const openPopover = ()=>{
        clearTimeout(hoverTimeout.current);
        if (conditions.length === 0) addCondition();
        setIsOpen(true);
    };
    const scheduleClose = ()=>{
        hoverTimeout.current = setTimeout(()=>setIsOpen(false), 300);
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: "filter-cell",
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                className: "filter-cell-header",
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                        isOpen: isOpen,
                        onInteraction: (next)=>{
                            if (!next) scheduleClose();
                        },
                        placement: "bottom-start",
                        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($f448bea4af9ba462$var$_FilterPopoverContent, {
                            onClick: (e)=>e.stopPropagation(),
                            onKeyDown: (e)=>e.stopPropagation(),
                            onMouseEnter: openPopover,
                            onMouseLeave: scheduleClose,
                            children: [
                                conditions.length > 1 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                    className: "filter-combinator",
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $9aea662359a2cfdc$export$69b1032f2ecdf404), {
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                small: true,
                                                text: "And",
                                                active: combinator === 'and',
                                                intent: combinator === 'and' ? 'primary' : 'none',
                                                onClick: toggleCombinator
                                            }),
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                small: true,
                                                text: "Or",
                                                active: combinator === 'or',
                                                intent: combinator === 'or' ? 'primary' : 'none',
                                                onClick: toggleCombinator
                                            })
                                        ]
                                    })
                                }),
                                conditions.map((cond, i)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($f448bea4af9ba462$var$FilterConditionRow, {
                                        columnKey: column.key,
                                        index: i,
                                        condition: cond,
                                        setFilters: setFilters
                                    }, i)),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                    className: "filter-add-row",
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            small: true,
                                            minimal: true,
                                            icon: "plus",
                                            text: "Add condition",
                                            onClick: addCondition
                                        }),
                                        conditions.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            small: true,
                                            minimal: true,
                                            icon: "trash",
                                            intent: "danger",
                                            text: "Clear",
                                            onClick: clearAll
                                        })
                                    ]
                                })
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                            className: "filter-icon-target",
                            onClick: (e)=>{
                                e.stopPropagation();
                                setIsOpen((prev)=>!prev);
                            },
                            onMouseEnter: openPopover,
                            onMouseLeave: scheduleClose,
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                icon: hasActive ? 'filter-keep' : 'filter',
                                size: 12,
                                intent: hasActive ? 'primary' : 'none'
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                        children: column.name
                    })
                ]
            }),
            showDefault && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                className: "default-filter",
                small: true,
                value: defaultTerm,
                onChange: (e)=>setDefaultTerm(e.target.value),
                onKeyDown: (e)=>e.stopPropagation(),
                onClick: (e)=>e.stopPropagation(),
                placeholder: `${$f448bea4af9ba462$var$FILTER_MODES[0].label}...`
            })
        ]
    });
}
function $f448bea4af9ba462$var$translateColumns(columns, hasFilters, filters, setFilters) {
    return columns.map((col)=>{
        const v7 = {
            ...col
        };
        // formatter → renderCell
        if (col.formatter && !col.renderCell) {
            v7.renderCell = col.formatter;
            delete v7.formatter;
        }
        // locked → frozen
        if (col.locked != null) {
            v7.frozen = col.locked;
            delete v7.locked;
        }
        // filterable → renderHeaderCell
        if (col.filterable && !col.renderHeaderCell) v7.renderHeaderCell = (props)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($f448bea4af9ba462$var$FilterableHeaderCell, {
                column: props.column,
                filters: filters,
                setFilters: setFilters
            });
        delete v7.filterable;
        return v7;
    });
}
const $f448bea4af9ba462$export$fea56d2ed3e1a888 = ({ columns: columns, data: data, defaultSort: defaultSort, defaultSortDirection: defaultSortDirection, rowHeight: rowHeight, headerRowHeight: headerRowHeight, rowClass: rowClass, fitHeight: fitHeight, columnFilterFns: columnFilterFns, onCount: onCount })=>{
    const containerRef = (0, $kYL7Z.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $kYL7Z.useState)(window.innerHeight);
    const [filters, setFilters] = (0, $kYL7Z.useState)({});
    const [sorting, setSorting] = (0, $kYL7Z.useState)({
        column: defaultSort ?? 'name',
        direction: defaultSortDirection ?? 'ASC'
    });
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (containerRef.current) {
            const top = containerRef.current.getBoundingClientRect().top;
            setMaxHeight(Math.max(window.innerHeight - top - 40, 200));
        }
    }, [
        data.length
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        const onResize = ()=>{
            if (containerRef.current) {
                const top = containerRef.current.getBoundingClientRect().top;
                setMaxHeight(Math.max(window.innerHeight - top - 40, 200));
            }
        };
        window.addEventListener('resize', onResize);
        return ()=>window.removeEventListener('resize', onResize);
    }, []);
    const hasFilters = (0, $kYL7Z.useMemo)(()=>columns?.some((c)=>c.filterable), [
        columns
    ]);
    const hasDefaultFilter = (0, $kYL7Z.useMemo)(()=>columns?.some((c)=>c.showDefaultFilter), [
        columns
    ]);
    const v7Columns = (0, $kYL7Z.useMemo)(()=>$f448bea4af9ba462$var$translateColumns(columns || [], hasFilters, filters, setFilters), [
        columns,
        hasFilters,
        filters
    ]);
    const selection = (0, $kYL7Z.useMemo)(()=>{
        const filtered = $f448bea4af9ba462$var$filterRows(data, filters, columnFilterFns);
        return $f448bea4af9ba462$var$sortRows(sorting.column, sorting.direction, filtered);
    }, [
        data,
        filters,
        sorting,
        columnFilterFns
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        onCount?.(selection.length, data.length);
    }, [
        selection.length,
        data.length
    ]);
    const sortColumns = (0, $kYL7Z.useMemo)(()=>{
        if (sorting.direction === 'NONE') return [];
        return [
            {
                columnKey: sorting.column,
                direction: sorting.direction
            }
        ];
    }, [
        sorting
    ]);
    const rh = rowHeight || 35;
    const hh = headerRowHeight || (hasDefaultFilter ? 55 : 35);
    const contentHeight = selection.length * rh + hh + 4;
    const height = fitHeight ? contentHeight + 17 : Math.min(contentHeight + rh, maxHeight);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($f448bea4af9ba462$var$_DataGridContainer, {
        ref: containerRef,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7829d25231ee1190$export$c8dd51eb24f71762), {
            className: "rdg-light",
            style: {
                height: height
            },
            columns: v7Columns,
            rows: selection,
            rowKeyGetter: (row)=>row.id ?? row._id,
            rowHeight: rh,
            headerRowHeight: hh,
            sortColumns: sortColumns,
            onSortColumnsChange: (newSortColumns)=>{
                if (newSortColumns.length === 0) // Toggled off — cycle to NONE
                setSorting((prev)=>({
                        ...prev,
                        direction: 'NONE'
                    }));
                else {
                    const sc = newSortColumns[newSortColumns.length - 1];
                    setSorting({
                        column: sc.columnKey,
                        direction: sc.direction
                    });
                }
            },
            rowClass: rowClass,
            defaultColumnOptions: {
                sortable: true
            }
        })
    });
};





const $ae042dd50ed2daac$export$9b9f695373d1284f = (dateStr)=>{
    if (!dateStr) return '-';
    let remaining = Math.floor((Date.now() - new Date(dateStr).getTime()) / 60000);
    const units = [
        [
            'y',
            525960
        ],
        [
            'mo',
            43830
        ],
        [
            'w',
            10080
        ],
        [
            'd',
            1440
        ],
        [
            'h',
            60
        ],
        [
            'm',
            1
        ]
    ];
    const parts = [];
    for (const [label, size] of units){
        const count = Math.floor(remaining / size);
        if (count > 0) {
            parts.push(count + label);
            remaining -= count * size;
        }
        if (parts.length === 2) break;
    }
    return (parts.length ? parts.join(' ') : '0m') + ' ago';
};


// -------------------------------------------------
// ----------------------------------- columns model
const $0aaed139e070878b$var$OrganisationModelColumns = [
    {
        key: 'name',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true,
        showDefaultFilter: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/orgs/' + params.row.id,
                children: params.row.name
            })
    },
    {
        key: 'locations',
        name: 'Locations',
        width: 90,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/locs?org=' + params.row.id,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    round: true,
                    interactive: true,
                    children: "Locations"
                })
            })
    },
    {
        key: 'devices',
        name: 'Devices',
        width: 90,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/devs?org=' + params.row.id,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    round: true,
                    interactive: true,
                    children: "Devices"
                })
            })
    },
    {
        key: 'cameras',
        name: 'Cameras',
        width: 90,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/recs?org=' + params.row.id,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    round: true,
                    interactive: true,
                    children: "Cameras"
                })
            })
    },
    {
        key: 'users',
        name: 'Users',
        width: 90,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/orgs/' + params.row.id + '/users',
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    round: true,
                    interactive: true,
                    children: "Users"
                })
            })
    },
    {
        key: 'options.showSettingUpLocations',
        name: 'Show Setting Up Locations',
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row?.options?.showSettingUpLocations
            })
    },
    {
        key: 'options.startOfWeek',
        name: 'Start of Week',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.options?.startOfWeek || 'default'
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.createdAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
            })
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.updatedAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
            })
    }
];
const $0aaed139e070878b$export$4cba08f767c44a88 = ()=>{
    const { setLoading: setLoading, setNav: setNav, setCount: setCount } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [data, setData] = (0, $kYL7Z.useState)(null);
    const [creating, setCreating] = (0, $kYL7Z.useState)(false);
    const toggleCreating = (0, $kYL7Z.useCallback)(()=>{
        setCreating((prev)=>!prev);
    }, []);
    (0, $kYL7Z.useEffect)(()=>{
        setNav({
            right: [
                {
                    name: "Create",
                    onClick: toggleCreating,
                    icon: "add"
                }
            ]
        });
    }, [
        toggleCreating
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        console.log("loading orgs");
        setLoading({
            status: true,
            location: "Loading organisations..."
        });
        (0, $5a9cade4af2d6a52$export$d030b7498dcede47).list().then((response)=>{
            console.log("Loaded " + response.length + " orgs");
            setData(response);
            setLoading({
                status: false,
                location: "All organisations"
            });
        }).catch((error)=>{
            console.error(error);
            setLoading({
                status: false,
                location: "Failed to load organisations..."
            });
            setData(error);
        });
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $301b430ddba68118$export$1388bbe784880b7c), {
                isOpen: creating,
                onClose: toggleCreating,
                onSave: (info)=>{
                    const currentNavContext = "All organisations";
                    toggleCreating();
                    setLoading({
                        status: true,
                        location: `Creating organisation ${info.name}...`
                    });
                    (0, $5a9cade4af2d6a52$export$d030b7498dcede47).create(info).then((ret)=>{
                        console.log("Created organisation: ", ret);
                        (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                            message: `Created organisation ${ret.name}`
                        });
                        setData((prev)=>[
                                ...prev,
                                ret
                            ]);
                    }).catch((err)=>{
                        console.log(err);
                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                            message: "Failed to create organisation: " + err.message,
                            timeout: 5000
                        });
                    }).finally(()=>{
                        setLoading({
                            status: false,
                            location: currentNavContext
                        });
                    });
                }
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                columns: $0aaed139e070878b$var$OrganisationModelColumns,
                data: data ?? [],
                defaultSort: "name",
                onCount: (filtered, total)=>setCount({
                        filtered: filtered,
                        total: total
                    })
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");

var $i5w0I = parcelRequire("i5w0I");






var $kYL7Z = parcelRequire("kYL7Z");







var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $9c54f0b7e016c484$export$edf27be85e5f6da0 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "error",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM220 80H180V120H220V80zM220 140H180V320H220V140z" : "M159.8 320.2C71.4 320.2 -0.2 248.6 -0.2 160.2S71.4 0.2 159.8 0.2S319.8 71.8 319.8 160.2S248.2 320.2 159.8 320.2zM179.8 60.2H139.8V100.2H179.8V60.2zM179.8 120.2H139.8V260.2H179.8V120.2z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$9c54f0b7e016c484$export$edf27be85e5f6da0.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$9c54f0b7e016c484$export$edf27be85e5f6da0.displayName = `Blueprint6.Icon.Error`;
var $9c54f0b7e016c484$export$2e2bcd8739ae039 = $9c54f0b7e016c484$export$edf27be85e5f6da0;



var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $d8d562c2fe4de7cd$export$537f90e5673bf429 = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "info-sign",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M200 400C89.6 400 0 310.4 0 200C0 89.6 89.6 0 200 0S400 89.6 400 200C400 310.4 310.4 400 200 400zM180 320H220V280H180V320zM260 80H140V100H180V240H160V260H220V100H260V80z" : "M160 320C71.6 320 0 248.4 0 160S71.6 0 160 0S320 71.6 320 160S248.4 320 160 320zM140 260H180V220H140V260zM200 60H120V80H140V180H120V200H180V80H200V60z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$d8d562c2fe4de7cd$export$537f90e5673bf429.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$d8d562c2fe4de7cd$export$537f90e5673bf429.displayName = `Blueprint6.Icon.InfoSign`;
var $d8d562c2fe4de7cd$export$2e2bcd8739ae039 = $d8d562c2fe4de7cd$export$537f90e5673bf429;



var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $cdd3daaf89b329ca$export$b1778e7c62739fdb = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "tick",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M340 320C334.4 320 329.4 317.8 325.8 314.2L140 128.2L74.2 194C70.6 197.8 65.6 200 60 200C49 200 40 191 40 180C40 174.4 42.2 169.4 45.8 165.8L125.8 85.8C129.4 82.2 134.4 80 140 80S150.6 82.2 154.2 85.8L354.2000000000001 285.8C357.8 289.4 360 294.4 360 300C360 311 351 320 340 320z" : "M280 260C274.4000000000001 260 269.4000000000001 257.8 265.8 254.2L120 108.2L54.2 174.2C50.6 177.8 45.6 180 40 180C29 180 20 171 20 160C20 154.4 22.2 149.4 25.8 145.8L105.8 65.8C109.4 62.2 114.4 60 120 60S130.6 62.2 134.2 65.8L294.2000000000001 225.8C297.8 229.4 300 234.4 300 240C300 251 291 260 280 260z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$cdd3daaf89b329ca$export$b1778e7c62739fdb.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$cdd3daaf89b329ca$export$b1778e7c62739fdb.displayName = `Blueprint6.Icon.Tick`;
var $cdd3daaf89b329ca$export$2e2bcd8739ae039 = $cdd3daaf89b329ca$export$b1778e7c62739fdb;



var $kYL7Z = parcelRequire("kYL7Z");

var $6Y6tm = parcelRequire("6Y6tm");

const $6939c957e163b044$export$d15cd06a1394dc1f = $kYL7Z.forwardRef((props, ref)=>{
    const isLarge = props.size >= (0, $6Y6tm.IconSize).LARGE;
    const pixelGridSize = isLarge ? (0, $6Y6tm.IconSize).LARGE : (0, $6Y6tm.IconSize).STANDARD;
    const translation = `${-1 * pixelGridSize / 0.05 / 2}`;
    const style = {
        transformOrigin: "center"
    };
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $8f558ced286a8918$export$5529589efc4d4370), {
        iconName: "warning-sign",
        ref: ref,
        ...props,
        children: (0, $fc31e5e9fc16a880$exports.jsx)("path", {
            d: isLarge ? "M397.2 49.6C397.2 49.6 397.4000000000001 49.8000000000001 397.4000000000001 49.8000000000001L217.4 369.8000000000001C217.4 369.8000000000001 217.2 369.6 217.2 369.6C213.8 375.8 207.4 380 200 380S186.2 375.8 182.8 369.6L182.6 369.8L2.6 49.8L2.8 49.5999999999999C1.2 46.8 0 43.6 0 40C0 29 9 20 20 20H380C391 20 400 29 400 40C400 43.6 398.8 46.8 397.2 49.6zM220 60H180V100H220V60zM220 120H180V280H220V120z" : "M316.8 50L317 50.2L177 290.2L176.8 290C173.4 296 167.2 300 159.8 300S146.4 296 142.8 290C142.8 290 142.6 290.2 142.6 290.2L2.6 50.2L2.8 50C1 47 -0.2 43.8 -0.2 40C-0.2 29 8.8 20 19.8 20H299.8C310.8 20 319.8 29 319.8 40C319.8 43.8 318.6 47 316.8 50zM179.8 60.2H139.8V100.2H179.8V60.2zM179.8 120.2H139.8V220.2H179.8V120.2z",
            fillRule: "evenodd",
            transform: `scale(0.05, -0.05) translate(${translation}, ${translation})`,
            style: style
        })
    });
});
$6939c957e163b044$export$d15cd06a1394dc1f.defaultProps = {
    size: (0, $6Y6tm.IconSize).STANDARD
};
$6939c957e163b044$export$d15cd06a1394dc1f.displayName = `Blueprint6.Icon.WarningSign`;
var $6939c957e163b044$export$2e2bcd8739ae039 = $6939c957e163b044$export$d15cd06a1394dc1f;





const $95ca98770ad4e8f2$export$97a5aca3dea8edc7 = (props)=>{
    const { className: className, children: children, icon: icon, intent: intent, title: title, compact: compact, minimal: minimal = false, ...htmlProps } = props;
    const iconElement = $95ca98770ad4e8f2$var$renderIcon(icon, intent);
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).CALLOUT, (0, $2cfd35af7ec11fdd$exports).intentClass(intent), className, {
        [(0, $2cfd35af7ec11fdd$exports).CALLOUT_HAS_BODY_CONTENT]: !(0, $5f04c694ca05154e$exports).isReactNodeEmpty(children),
        [(0, $2cfd35af7ec11fdd$exports).CALLOUT_ICON]: iconElement != null,
        [(0, $2cfd35af7ec11fdd$exports).COMPACT]: compact,
        [(0, $2cfd35af7ec11fdd$exports).MINIMAL]: minimal
    });
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        className: classes,
        ...htmlProps,
        children: [
            iconElement,
            title && (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$88ef9fdaf11f7a1f), {
                children: title
            }),
            children
        ]
    });
};
$95ca98770ad4e8f2$export$97a5aca3dea8edc7.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Callout`;
const $95ca98770ad4e8f2$var$renderIcon = (icon, intent)=>{
    // 1. no icon
    if (icon === null || icon === false) return undefined;
    const iconProps = {
        "aria-hidden": true,
        tabIndex: -1
    };
    // 2. icon specified by name or as a custom SVG element
    if (icon !== undefined) return (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
        icon: icon,
        ...iconProps
    });
    // 3. icon specified by intent prop
    switch(intent){
        case (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).DANGER:
            return (0, $fc31e5e9fc16a880$exports.jsx)((0, $9c54f0b7e016c484$export$edf27be85e5f6da0), {
                ...iconProps
            });
        case (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).PRIMARY:
            return (0, $fc31e5e9fc16a880$exports.jsx)((0, $d8d562c2fe4de7cd$export$537f90e5673bf429), {
                ...iconProps
            });
        case (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).WARNING:
            return (0, $fc31e5e9fc16a880$exports.jsx)((0, $6939c957e163b044$export$d15cd06a1394dc1f), {
                ...iconProps
            });
        case (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).SUCCESS:
            return (0, $fc31e5e9fc16a880$exports.jsx)((0, $cdd3daaf89b329ca$export$b1778e7c62739fdb), {
                ...iconProps
            });
        default:
            return undefined;
    }
};




var $kYL7Z = parcelRequire("kYL7Z");

const $e5fa259207c7c08d$export$7bbfb2d443473050 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { actions: actions, children: children, className: className, minimal: minimal = false, ...htmlProps } = props;
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        ...htmlProps,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).DIALOG_FOOTER, className, {
            [(0, $2cfd35af7ec11fdd$exports).DIALOG_FOOTER_FIXED]: !minimal
        }),
        ref: ref,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).DIALOG_FOOTER_MAIN_SECTION,
                children: children
            }),
            actions != null && (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).DIALOG_FOOTER_ACTIONS,
                children: actions
            })
        ]
    });
});
$e5fa259207c7c08d$export$7bbfb2d443473050.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.DialogFooter`;







const $aafdab9c8cbcf6ef$var$SEND_TYPE_ALL = 'email - all org users';
const $aafdab9c8cbcf6ef$var$SEND_TYPE_SPECIFIC = 'email - specific users';
const $aafdab9c8cbcf6ef$var$CADENCES = [
    'hourly',
    'daily',
    'weekly',
    'monthly'
];
const $aafdab9c8cbcf6ef$var$DAY_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
const $aafdab9c8cbcf6ef$var$formatHour = (h)=>{
    if (h === 0) return '12am';
    if (h === 12) return '12pm';
    return h > 12 ? `${h - 12}pm` : `${h}am`;
};
const $aafdab9c8cbcf6ef$var$ordinalSuffix = (n)=>{
    const s = [
        'th',
        'st',
        'nd',
        'rd'
    ];
    const v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
};
const $aafdab9c8cbcf6ef$var$Section = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin-bottom: 1em;
`;
const $aafdab9c8cbcf6ef$var$SectionHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid #ced9e0;
    font-weight: 600;
`;
const $aafdab9c8cbcf6ef$var$ScheduleRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 6px;
`;
const $aafdab9c8cbcf6ef$var$initState = (job)=>{
    if (!job) return {
        dashboardReportId: '',
        restrictToLocations: [],
        sendType: $aafdab9c8cbcf6ef$var$SEND_TYPE_ALL,
        toEmails: [],
        cadence: 'weekly',
        sendDay: 1,
        sendHour: 9,
        impersonationAuth0Id: '',
        scheduledSendingDisabled: false
    };
    return {
        dashboardReportId: job.dashboardReportToImage?.dashboardReportId || '',
        restrictToLocations: job.dashboardReportToImage?.restrictToLocations || [],
        sendType: job.distribution?.sendType || $aafdab9c8cbcf6ef$var$SEND_TYPE_ALL,
        toEmails: job.distribution?.toEmails?.filter(Boolean) || [],
        cadence: job.schedule?.cadence || 'weekly',
        sendDay: job.schedule?.sendDay ?? 1,
        sendHour: job.schedule?.sendHour ?? 9,
        impersonationAuth0Id: job.impersonationAuth0Id || '',
        scheduledSendingDisabled: !!job.scheduledSendingDisabled
    };
};
const $aafdab9c8cbcf6ef$var$buildPayload = (state, orgid)=>({
        jobType: 'dashboardReportToImage',
        organisation: orgid,
        impersonationAuth0Id: state.impersonationAuth0Id,
        scheduledSendingDisabled: state.scheduledSendingDisabled,
        distribution: {
            sendType: state.sendType,
            toEmails: state.sendType === $aafdab9c8cbcf6ef$var$SEND_TYPE_SPECIFIC ? state.toEmails : []
        },
        schedule: {
            cadence: state.cadence,
            ...[
                'daily',
                'weekly',
                'monthly'
            ].includes(state.cadence) ? {
                sendHour: state.sendHour
            } : {},
            ...[
                'weekly',
                'monthly'
            ].includes(state.cadence) ? {
                sendDay: state.sendDay
            } : {}
        },
        dashboardReportToImage: {
            dashboardReportId: state.dashboardReportId,
            restrictToLocations: state.restrictToLocations
        }
    });
const $aafdab9c8cbcf6ef$var$validate = (state)=>{
    if (!state.impersonationAuth0Id) return 'Impersonation user is required';
    if (!state.dashboardReportId) return 'Dashboard Report is required';
    if (state.sendType === $aafdab9c8cbcf6ef$var$SEND_TYPE_SPECIFIC && !state.toEmails.length) return 'Select at least one recipient';
    if (!state.cadence) return 'Select a cadence';
    return null;
};
const $aafdab9c8cbcf6ef$export$55cd9249a575360 = ({ isOpen: isOpen, onClose: onClose, orgid: orgid, job: job, onSaved: onSaved })=>{
    const [state, setState] = (0, $kYL7Z.useState)(()=>$aafdab9c8cbcf6ef$var$initState(job));
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const [error, setError] = (0, $kYL7Z.useState)(null);
    const isEdit = !!job;
    const isCsv = job?.jobType === 'csvExtraction';
    // Reference data
    const [orgReports, setOrgReports] = (0, $kYL7Z.useState)(null);
    const [orgLocations, setOrgLocations] = (0, $kYL7Z.useState)(null);
    const [orgUsers, setOrgUsers] = (0, $kYL7Z.useState)(null);
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen) {
            setState($aafdab9c8cbcf6ef$var$initState(job));
            setError(null);
        }
    }, [
        isOpen,
        job
    ]);
    // Fetch reference data when dialog opens
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen) return;
        (0, $5a9cade4af2d6a52$export$c0572ad6b22dbd1a).list().then((all)=>{
            setOrgReports(all.filter((r)=>r.organisation === orgid));
        }).catch(()=>setOrgReports([]));
        (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).list({
            withinOrganisations: orgid
        }).then((locs)=>{
            setOrgLocations(locs);
        }).catch(()=>setOrgLocations([]));
        Promise.all([
            $aa27e6f0058e6325$export$7652f722913b5d7.list(orgid),
            $aa27e6f0058e6325$export$7652f722913b5d7.listAdopted(orgid)
        ]).then(([usersRes, adoptedRes])=>{
            const allUsers = [
                ...usersRes.data || [],
                ...adoptedRes.data || []
            ];
            setOrgUsers(allUsers);
            // Auto-default impersonation to the Aura reports user when creating
            if (!job) {
                const auraUser = allUsers.find((u)=>(u.email || '').endsWith('@auravision.ai') && /^reports\+/i.test(u.email)) || allUsers.find((u)=>(u.email || '').endsWith('@auravision.ai'));
                if (auraUser) setState((prev)=>prev.impersonationAuth0Id ? prev : {
                        ...prev,
                        impersonationAuth0Id: auraUser.auth0Id
                    });
            }
        }).catch(()=>setOrgUsers([]));
    }, [
        isOpen,
        orgid,
        job
    ]);
    const set = (0, $kYL7Z.useCallback)((patch)=>setState((prev)=>({
                ...prev,
                ...patch
            })), []);
    const handleSave = (0, $kYL7Z.useCallback)(async ()=>{
        const err = $aafdab9c8cbcf6ef$var$validate(state);
        if (err) {
            setError(err);
            return;
        }
        setError(null);
        setLoading(true);
        try {
            const payload = $aafdab9c8cbcf6ef$var$buildPayload(state, orgid);
            if (isEdit) {
                await (0, $5a9cade4af2d6a52$export$8fe3681f0fd2c0ee).update(job.id, payload);
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: 'Schedule updated'
                });
            } else {
                await (0, $5a9cade4af2d6a52$export$8fe3681f0fd2c0ee).create(payload);
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: 'Schedule created'
                });
            }
            onSaved();
            onClose();
        } catch (e) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: e?.message ?? 'Failed to save'
            });
            setError(e?.message ?? 'Failed to save');
        } finally{
            setLoading(false);
        }
    }, [
        state,
        orgid,
        job,
        isEdit,
        onSaved,
        onClose
    ]);
    const handleDelete = (0, $kYL7Z.useCallback)(async ()=>{
        if (!job) return;
        setLoading(true);
        try {
            await (0, $5a9cade4af2d6a52$export$8fe3681f0fd2c0ee).remove(job.id);
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: 'Schedule deleted'
            });
            onSaved();
            onClose();
        } catch (e) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: e?.message ?? 'Failed to delete'
            });
        } finally{
            setLoading(false);
        }
    }, [
        job,
        onSaved,
        onClose
    ]);
    const dataLoaded = orgReports && orgLocations && orgUsers;
    const selectedReport = orgReports?.find((r)=>r.id === state.dashboardReportId);
    const selectedUser = orgUsers?.find((u)=>u.auth0Id === state.impersonationAuth0Id);
    const selectedLocations = orgLocations?.filter((l)=>state.restrictToLocations.includes(l.id)) || [];
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
        isOpen: isOpen,
        onClose: onClose,
        title: isEdit ? isCsv ? 'CSV Schedule (read-only)' : 'Edit Scheduled Report' : 'New Scheduled Report',
        icon: isEdit ? 'edit' : 'add',
        style: {
            width: 600
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
                children: !dataLoaded ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        justifyContent: 'center',
                        padding: '2em'
                    },
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                        size: 24
                    })
                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                    children: [
                        isCsv && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                            intent: "warning",
                            icon: "info-sign",
                            style: {
                                marginBottom: '1em'
                            },
                            children: "CSV extraction schedules cannot be edited. You can only delete them."
                        }),
                        !isCsv && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($aafdab9c8cbcf6ef$var$Section, {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                                checked: !state.scheduledSendingDisabled,
                                onChange: ()=>set({
                                        scheduledSendingDisabled: !state.scheduledSendingDisabled
                                    }),
                                label: "Enabled",
                                style: {
                                    margin: 0
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$Section, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$SectionHeader, {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                            icon: "document",
                                            intent: "primary"
                                        }),
                                        "Report"
                                    ]
                                }),
                                isCsv ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                    style: {
                                        fontSize: 13,
                                        color: '#5c7080'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                                    children: "Type:"
                                                }),
                                                " CSV Extraction"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                                    children: "Path:"
                                                }),
                                                " ",
                                                job.csvExtraction?.dashboardPath || "\u2014"
                                            ]
                                        }),
                                        job.csvExtraction?.csvDownloadButtonSelector && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                                    children: "Selector:"
                                                }),
                                                " ",
                                                job.csvExtraction.csvDownloadButtonSelector
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                                            label: "Dashboard Report",
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                                                items: orgReports,
                                                itemPredicate: (query, r)=>r.name.toLowerCase().includes(query.toLowerCase()),
                                                itemRenderer: (r, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                        text: r.name,
                                                        label: r.status,
                                                        onClick: handleClick,
                                                        active: modifiers.active,
                                                        selected: state.dashboardReportId === r.id
                                                    }, r.id),
                                                onItemSelect: (r)=>set({
                                                        dashboardReportId: r.id
                                                    }),
                                                popoverProps: {
                                                    minimal: true,
                                                    matchTargetWidth: true
                                                },
                                                menuProps: {
                                                    style: {
                                                        maxHeight: 450,
                                                        overflowY: 'auto'
                                                    }
                                                },
                                                fill: true,
                                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                    fill: true,
                                                    text: selectedReport ? selectedReport.name : 'Select a report...',
                                                    endIcon: "caret-down"
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                                            label: "Restrict to Locations",
                                            helperText: "Leave empty to include all locations",
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c302f4df8217899c$export$1e7dfd31545b5809), {
                                                items: orgLocations,
                                                selectedItems: selectedLocations,
                                                itemPredicate: (query, loc)=>loc.name.toLowerCase().includes(query.toLowerCase()),
                                                itemRenderer: (loc, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                        text: loc.name,
                                                        onClick: handleClick,
                                                        active: modifiers.active,
                                                        selected: state.restrictToLocations.includes(loc.id),
                                                        icon: state.restrictToLocations.includes(loc.id) ? 'tick' : 'blank'
                                                    }, loc.id),
                                                tagRenderer: (loc)=>loc.name,
                                                onItemSelect: (loc)=>{
                                                    const has = state.restrictToLocations.includes(loc.id);
                                                    set({
                                                        restrictToLocations: has ? state.restrictToLocations.filter((id)=>id !== loc.id) : [
                                                            ...state.restrictToLocations,
                                                            loc.id
                                                        ]
                                                    });
                                                },
                                                onRemove: (loc)=>{
                                                    set({
                                                        restrictToLocations: state.restrictToLocations.filter((id)=>id !== loc.id)
                                                    });
                                                },
                                                tagInputProps: {
                                                    placeholder: 'All locations'
                                                },
                                                popoverProps: {
                                                    minimal: true,
                                                    matchTargetWidth: true
                                                },
                                                menuProps: {
                                                    style: {
                                                        maxHeight: 450,
                                                        overflowY: 'auto'
                                                    }
                                                },
                                                fill: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$Section, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$SectionHeader, {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                            icon: "envelope",
                                            intent: "primary"
                                        }),
                                        "Distribution"
                                    ]
                                }),
                                isCsv ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                    style: {
                                        fontSize: 13,
                                        color: '#5c7080'
                                    },
                                    children: job.distribution?.sendType === $aafdab9c8cbcf6ef$var$SEND_TYPE_ALL ? 'All org users' : (job.distribution?.toEmails || []).join(', ') || "\u2014"
                                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: '1em',
                                        alignItems: 'flex-start',
                                        flexDirection: 'column'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                                            items: [
                                                {
                                                    value: $aafdab9c8cbcf6ef$var$SEND_TYPE_ALL,
                                                    label: 'All org users'
                                                },
                                                {
                                                    value: $aafdab9c8cbcf6ef$var$SEND_TYPE_SPECIFIC,
                                                    label: 'Specific users'
                                                }
                                            ],
                                            itemRenderer: (item, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                    text: item.label,
                                                    onClick: handleClick,
                                                    active: modifiers.active,
                                                    selected: state.sendType === item.value
                                                }, item.value),
                                            onItemSelect: (item)=>set({
                                                    sendType: item.value
                                                }),
                                            filterable: false,
                                            popoverProps: {
                                                minimal: true
                                            },
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                text: state.sendType === $aafdab9c8cbcf6ef$var$SEND_TYPE_ALL ? 'All org users' : 'Specific users',
                                                endIcon: "caret-down"
                                            })
                                        }),
                                        state.sendType === $aafdab9c8cbcf6ef$var$SEND_TYPE_SPECIFIC && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                                            label: "Recipients",
                                            style: {
                                                width: '100%'
                                            },
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c302f4df8217899c$export$1e7dfd31545b5809), {
                                                items: orgUsers,
                                                selectedItems: orgUsers.filter((u)=>state.toEmails.includes(u.email)),
                                                itemPredicate: (query, u)=>{
                                                    const q = query.toLowerCase();
                                                    return (u.email || '').toLowerCase().includes(q) || (u.fullName || '').toLowerCase().includes(q);
                                                },
                                                itemRenderer: (u, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                        text: u.fullName || u.email,
                                                        label: u.email,
                                                        onClick: handleClick,
                                                        active: modifiers.active,
                                                        selected: state.toEmails.includes(u.email),
                                                        icon: state.toEmails.includes(u.email) ? 'tick' : 'blank'
                                                    }, u.id),
                                                tagRenderer: (u)=>u.fullName || u.email,
                                                onItemSelect: (u)=>{
                                                    const has = state.toEmails.includes(u.email);
                                                    set({
                                                        toEmails: has ? state.toEmails.filter((e)=>e !== u.email) : [
                                                            ...state.toEmails,
                                                            u.email
                                                        ]
                                                    });
                                                },
                                                onRemove: (u)=>{
                                                    set({
                                                        toEmails: state.toEmails.filter((e)=>e !== u.email)
                                                    });
                                                },
                                                tagInputProps: {
                                                    placeholder: 'Select users...'
                                                },
                                                popoverProps: {
                                                    minimal: true,
                                                    matchTargetWidth: true
                                                },
                                                menuProps: {
                                                    style: {
                                                        maxHeight: 450,
                                                        overflowY: 'auto'
                                                    }
                                                },
                                                fill: true
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$Section, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$SectionHeader, {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                            icon: "timeline-events",
                                            intent: "primary"
                                        }),
                                        "Schedule"
                                    ]
                                }),
                                isCsv ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                    style: {
                                        fontSize: 13,
                                        color: '#5c7080'
                                    },
                                    children: [
                                        job.schedule?.cadence || "\u2014",
                                        job.schedule?.sendHour != null && ` at ${$aafdab9c8cbcf6ef$var$formatHour(job.schedule.sendHour)} UTC`
                                    ]
                                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$ScheduleRow, {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                            minimal: true,
                                            content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                                                children: $aafdab9c8cbcf6ef$var$CADENCES.map((c)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                        text: c.charAt(0).toUpperCase() + c.slice(1),
                                                        icon: state.cadence === c ? 'tick' : 'blank',
                                                        onClick: ()=>set({
                                                                cadence: c
                                                            })
                                                    }, c))
                                            }),
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                text: state.cadence.charAt(0).toUpperCase() + state.cadence.slice(1),
                                                endIcon: "caret-down"
                                            })
                                        }),
                                        state.cadence === 'weekly' && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                                    children: "on"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                                    minimal: true,
                                                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                                                        children: [
                                                            1,
                                                            2,
                                                            3,
                                                            4,
                                                            5,
                                                            6,
                                                            0
                                                        ].map((d)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                                text: $aafdab9c8cbcf6ef$var$DAY_NAMES[d],
                                                                icon: state.sendDay === d ? 'tick' : 'blank',
                                                                onClick: ()=>set({
                                                                        sendDay: d
                                                                    })
                                                            }, d))
                                                    }),
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                        text: $aafdab9c8cbcf6ef$var$DAY_NAMES[state.sendDay],
                                                        endIcon: "caret-down"
                                                    })
                                                })
                                            ]
                                        }),
                                        state.cadence === 'monthly' && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                                    children: "on the"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                                    minimal: true,
                                                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                                                        children: Array.from({
                                                            length: 31
                                                        }, (_, i)=>i + 1).map((d)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                                text: $aafdab9c8cbcf6ef$var$ordinalSuffix(d),
                                                                icon: state.sendDay === d ? 'tick' : 'blank',
                                                                onClick: ()=>set({
                                                                        sendDay: d
                                                                    })
                                                            }, d))
                                                    }),
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                        text: $aafdab9c8cbcf6ef$var$ordinalSuffix(state.sendDay),
                                                        endIcon: "caret-down"
                                                    })
                                                })
                                            ]
                                        }),
                                        [
                                            'daily',
                                            'weekly',
                                            'monthly'
                                        ].includes(state.cadence) && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                                    children: "at"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                                    minimal: true,
                                                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                                                        children: Array.from({
                                                            length: 24
                                                        }, (_, i)=>i).map((h)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                                text: $aafdab9c8cbcf6ef$var$formatHour(h),
                                                                icon: state.sendHour === h ? 'tick' : 'blank',
                                                                onClick: ()=>set({
                                                                        sendHour: h
                                                                    })
                                                            }, h))
                                                    }),
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                        text: $aafdab9c8cbcf6ef$var$formatHour(state.sendHour),
                                                        endIcon: "caret-down"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                                    style: {
                                                        color: '#5c7080',
                                                        fontSize: 12
                                                    },
                                                    children: "UTC"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$Section, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($aafdab9c8cbcf6ef$var$SectionHeader, {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                            icon: "person",
                                            intent: "primary"
                                        }),
                                        "Impersonation"
                                    ]
                                }),
                                isCsv ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                    style: {
                                        fontSize: 13,
                                        color: '#5c7080'
                                    },
                                    children: job.impersonationAuth0Id || "\u2014"
                                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                                    label: "Run as user",
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                                        items: orgUsers,
                                        itemPredicate: (query, u)=>{
                                            const q = query.toLowerCase();
                                            return (u.email || '').toLowerCase().includes(q) || (u.fullName || '').toLowerCase().includes(q) || (u.auth0Id || '').toLowerCase().includes(q);
                                        },
                                        itemRenderer: (u, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                text: u.fullName || u.email,
                                                label: u.email,
                                                onClick: handleClick,
                                                active: modifiers.active,
                                                selected: state.impersonationAuth0Id === u.auth0Id
                                            }, u.id),
                                        onItemSelect: (u)=>set({
                                                impersonationAuth0Id: u.auth0Id
                                            }),
                                        popoverProps: {
                                            minimal: true,
                                            matchTargetWidth: true
                                        },
                                        menuProps: {
                                            style: {
                                                maxHeight: 450,
                                                overflowY: 'auto'
                                            }
                                        },
                                        fill: true,
                                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            fill: true,
                                            text: selectedUser ? selectedUser.fullName || selectedUser.email : 'Select a user...',
                                            endIcon: "caret-down"
                                        })
                                    })
                                })
                            ]
                        }),
                        error && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                            intent: "warning",
                            children: error
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $e5fa259207c7c08d$export$7bbfb2d443473050), {
                actions: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '0.5em',
                        width: '100%',
                        justifyContent: isEdit ? 'space-between' : 'flex-end'
                    },
                    children: [
                        isEdit && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            intent: "danger",
                            icon: "trash",
                            text: "Delete",
                            disabled: loading,
                            onClick: handleDelete
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: '0.5em'
                            },
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    text: isCsv ? 'Close' : 'Cancel',
                                    onClick: onClose,
                                    disabled: loading
                                }),
                                !isCsv && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    intent: "primary",
                                    text: loading ? 'Saving...' : isEdit ? 'Save' : 'Create',
                                    disabled: loading || !dataLoaded,
                                    onClick: handleSave
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


const $529680d6a92888ed$var$ReportsCard = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $0199c8413a0068dd$export$60332b2344f7fe41))`
    padding: 12px;
    border-radius: 20px;
    background: white !important;
    &[class*="bp"][class*="-card"] {
        box-shadow: 0 0 0 1px rgba(17, 20, 24, 0.1),
                    0 1px 1px rgba(17, 20, 24, 0.1),
                    0 2px 6px rgba(17, 20, 24, 0.1);
    }
`;
const $529680d6a92888ed$var$ReportsHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;
`;
const $529680d6a92888ed$var$EmailList = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 8px 12px;
    font-size: 13px;
    max-width: 320px;
    div { padding: 2px 0; }
`;
const $529680d6a92888ed$var$DAY_NAMES = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];
const $529680d6a92888ed$var$JOB_TYPE_LABELS = {
    dashboardReportToImage: 'Report',
    csvExtraction: 'CSV'
};
const $529680d6a92888ed$var$formatHour = (h)=>{
    if (h === 0) return '12am';
    if (h === 12) return '12pm';
    return h > 12 ? `${h - 12}pm` : `${h}am`;
};
const $529680d6a92888ed$var$formatSchedule = (schedule)=>{
    if (!schedule?.cadence || schedule.cadence === 'none') return "\u2014";
    const hour = $529680d6a92888ed$var$formatHour(schedule.sendHour ?? 0);
    if (schedule.cadence === 'hourly') return 'Hourly';
    if (schedule.cadence === 'daily') return `Daily at ${hour}`;
    if (schedule.cadence === 'weekly') return `Weekly on ${$529680d6a92888ed$var$DAY_NAMES[schedule.sendDay] || 'day ' + schedule.sendDay} at ${hour}`;
    if (schedule.cadence === 'monthly') return `Monthly on the ${schedule.sendDay}${schedule.sendDay === 1 ? 'st' : schedule.sendDay === 2 ? 'nd' : schedule.sendDay === 3 ? 'rd' : 'th'} at ${hour}`;
    return schedule.cadence;
};
const $529680d6a92888ed$var$DistributionCell = ({ row: row })=>{
    const d = row.distribution;
    if (d?.sendType === 'email - all org users') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        minimal: true,
        round: true,
        icon: "people",
        children: "All users"
    });
    const emails = d?.toEmails?.filter(Boolean) || [];
    if (!emails.length) return "\u2014";
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
        minimal: true,
        position: "bottom",
        interactionKind: "hover",
        hoverOpenDelay: 200,
        hoverCloseDelay: 100,
        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($529680d6a92888ed$var$EmailList, {
            children: emails.map((e)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    children: e
                }, e))
        }),
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            minimal: true,
            round: true,
            interactive: true,
            icon: "envelope",
            children: [
                emails.length,
                " recipient",
                emails.length !== 1 ? 's' : ''
            ]
        })
    });
};
const $529680d6a92888ed$var$DetailsCell = ({ row: row })=>{
    const imp = encodeURIComponent(row.impersonationAuth0Id);
    if (row.dashboardReportToImage) {
        const reportId = row.dashboardReportToImage.dashboardReportId;
        const locs = row.dashboardReportToImage.restrictToLocations?.length;
        const href = `${(0, $a13d063d3fb3aa31$export$fa3559c82ed925a)}/reports/${reportId}?impersonateId=${imp}`;
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
            style: {
                fontSize: 12
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("a", {
                    href: href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    children: reportId
                }),
                locs > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                    style: {
                        color: '#5c7080'
                    },
                    children: [
                        " \xb7 ",
                        locs,
                        " loc",
                        locs !== 1 ? 's' : ''
                    ]
                })
            ]
        });
    }
    if (row.csvExtraction) {
        const path = row.csvExtraction.dashboardPath || '';
        const [basePath, hash] = path.split('#');
        const href = `${(0, $a13d063d3fb3aa31$export$fa3559c82ed925a)}${basePath}${hash ? '#' + hash : ''}&impersonateId=${imp}`;
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
            style: {
                fontSize: 12
            },
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("a", {
                href: href,
                target: "_blank",
                rel: "noopener noreferrer",
                children: basePath || 'CSV'
            })
        });
    }
    return "\u2014";
};
const $529680d6a92888ed$var$makeColumns = (onEdit)=>[
        {
            key: 'id',
            name: 'ID',
            width: 220,
            resizable: true,
            sortable: true,
            filterable: true,
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "edit",
                            size: 14,
                            style: {
                                cursor: 'pointer',
                                color: '#5c7080',
                                flexShrink: 0
                            },
                            onClick: (e)=>{
                                e.stopPropagation();
                                onEdit(row);
                            }
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                            style: {
                                overflow: 'hidden',
                                textOverflow: 'ellipsis'
                            },
                            children: row.id
                        })
                    ]
                })
        },
        {
            key: 'jobType',
            name: 'Type',
            width: 80,
            resizable: true,
            sortable: true,
            filterable: true,
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    round: true,
                    small: true,
                    intent: "primary",
                    children: $529680d6a92888ed$var$JOB_TYPE_LABELS[row.jobType] || row.jobType
                })
        },
        {
            key: 'scheduleText',
            name: 'Schedule',
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'distributionText',
            name: 'Distribution',
            resizable: true,
            sortable: true,
            filterable: true,
            renderCell: $529680d6a92888ed$var$DistributionCell
        },
        {
            key: 'enabled',
            name: 'Status',
            width: 90,
            resizable: true,
            sortable: true,
            filterable: true,
            renderCell: ({ row: row })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    intent: row.scheduledSendingDisabled ? 'warning' : 'success',
                    children: row.scheduledSendingDisabled ? 'Disabled' : 'Active'
                })
        },
        {
            key: 'details',
            name: 'Details',
            resizable: true,
            sortable: true,
            filterable: true,
            renderCell: $529680d6a92888ed$var$DetailsCell
        },
        {
            key: 'impersonationAuth0Id',
            name: 'Impersonating',
            resizable: true,
            sortable: true,
            filterable: true
        }
    ];
const $529680d6a92888ed$var$prepareRow = (r)=>({
        ...r,
        scheduleText: $529680d6a92888ed$var$formatSchedule(r.schedule),
        distributionText: r.distribution?.sendType === 'email - all org users' ? 'All users' : (r.distribution?.toEmails?.filter(Boolean) || []).join(', '),
        enabled: r.scheduledSendingDisabled ? 'Disabled' : 'Active',
        details: r.dashboardReportToImage?.dashboardReportId || r.csvExtraction?.dashboardPath?.split('#')[0] || ''
    });
const $529680d6a92888ed$export$fb7347eee3e2dcee = ({ orgid: orgid })=>{
    const [collapsed, setCollapsed] = (0, $kYL7Z.useState)(true);
    const [reports, setReports] = (0, $kYL7Z.useState)(null);
    const [loaded, setLoaded] = (0, $kYL7Z.useState)(false);
    const [dialogOpen, setDialogOpen] = (0, $kYL7Z.useState)(false);
    const [editingJob, setEditingJob] = (0, $kYL7Z.useState)(null);
    const loadReports = (0, $kYL7Z.useCallback)(()=>{
        (0, $5a9cade4af2d6a52$export$8fe3681f0fd2c0ee).list().then((all)=>{
            setReports(all.filter((r)=>r.organisation === orgid).map($529680d6a92888ed$var$prepareRow));
            setLoaded(true);
        }).catch((err)=>{
            console.log("Failed to load scheduled reports: " + err.message);
            setReports([]);
            setLoaded(true);
        });
    }, [
        orgid
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (collapsed || loaded) return;
        loadReports();
    }, [
        collapsed,
        loaded,
        loadReports
    ]);
    const handleEdit = (0, $kYL7Z.useCallback)((row)=>{
        setEditingJob(row);
        setDialogOpen(true);
    }, []);
    const handleCreate = (0, $kYL7Z.useCallback)((e)=>{
        e.stopPropagation();
        setEditingJob(null);
        setDialogOpen(true);
    }, []);
    const handleSaved = (0, $kYL7Z.useCallback)(()=>{
        loadReports();
    }, [
        loadReports
    ]);
    const columns = $529680d6a92888ed$var$makeColumns(handleEdit);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($529680d6a92888ed$var$ReportsCard, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($529680d6a92888ed$var$ReportsHeader, {
                onClick: ()=>setCollapsed((c)=>!c),
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: collapsed ? "caret-right" : "caret-down",
                        style: {
                            color: '#5c7080'
                        }
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$88ef9fdaf11f7a1f), {
                        style: {
                            margin: 0
                        },
                        children: "Scheduled Reports"
                    }),
                    loaded && reports && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        round: true,
                        children: reports.length
                    }),
                    !collapsed && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        small: true,
                        minimal: true,
                        icon: "add",
                        intent: "primary",
                        onClick: handleCreate,
                        style: {
                            marginLeft: 'auto'
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $e4a7ce8c396337d4$export$78768a9af065a7b), {
                isOpen: !collapsed,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    style: {
                        paddingTop: '0.5em'
                    },
                    children: !loaded ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                        size: 20
                    }) : !reports.length ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        icon: "info-sign",
                        children: "No scheduled reports for this organisation"
                    }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                        columns: columns,
                        data: reports,
                        defaultSort: "scheduleText",
                        fitHeight: true
                    })
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aafdab9c8cbcf6ef$export$55cd9249a575360), {
                isOpen: dialogOpen,
                onClose: ()=>setDialogOpen(false),
                orgid: orgid,
                job: editingJob,
                onSaved: handleSaved
            })
        ]
    });
};


const $c1876c497f392709$var$_orgSchema = {
    type: "object",
    required: [
        "id",
        "name"
    ],
    properties: {
        id: {
            type: "string",
            pattern: "^[a-f\\d]{23,26}$",
            readOnly: true
        },
        name: {
            type: "string"
        },
        createdAt: {
            type: "string",
            readOnly: true
        },
        updatedAt: {
            type: "string",
            readOnly: true
        },
        theme: {
            type: [
                "string",
                "null"
            ],
            pattern: "^[a-f\\d]{23,26}$"
        },
        options: {
            type: "object",
            required: [
                "startOfWeek"
            ],
            properties: {
                startOfWeek: {
                    type: "string",
                    enum: [
                        "sunday",
                        "monday"
                    ]
                },
                showSettingUpLocations: {
                    type: "boolean",
                    default: false
                },
                disableAgeAndGenderOnFrontEnd: {
                    type: "boolean",
                    default: false
                },
                ignoreLingerUnderOverride: {
                    type: "boolean",
                    default: false
                },
                isDemoUser: {
                    type: "boolean",
                    default: false
                },
                orgHasStaffDetection: {
                    type: "boolean",
                    default: false
                },
                showDemoLivePage: {
                    type: "boolean",
                    default: false
                },
                showHeadcountPlanner: {
                    type: "boolean",
                    default: false
                },
                showLivePage: {
                    type: "boolean",
                    default: false
                },
                hasInteractionHeatmaps: {
                    type: "boolean",
                    default: false
                },
                useCaptureRateV2: {
                    type: "boolean",
                    default: false
                }
            }
        }
    }
};
const $c1876c497f392709$var$_uiInfoSchema = {
    type: "Group",
    label: "Configuration",
    elements: [
        {
            type: "HorizontalLayout",
            elements: [
                {
                    type: "Control",
                    scope: "#/properties/name"
                },
                {
                    type: "Control",
                    scope: "#/properties/id",
                    options: {
                        disabled: true
                    }
                },
                {
                    type: "Control",
                    scope: "#/properties/createdAt",
                    options: {
                        disabled: true
                    }
                },
                {
                    type: "Control",
                    scope: "#/properties/updatedAt",
                    options: {
                        disabled: true
                    }
                }
            ]
        }
    ]
};
const $c1876c497f392709$var$_uiOptionsSchema = {
    type: "Group",
    label: "Options",
    options: {
        collapsed: true
    },
    elements: [
        {
            type: "Control",
            scope: "#/properties/options/properties/startOfWeek"
        },
        ...Object.keys($c1876c497f392709$var$_orgSchema.properties.options.properties).filter((key)=>$c1876c497f392709$var$_orgSchema.properties.options.properties[key].type === "boolean").map((key)=>({
                type: "Control",
                scope: "#/properties/options/properties/" + key,
                options: {
                    toggle: true
                }
            }))
    ]
};
const $c1876c497f392709$var$METRIC_KEYS_BY_SECTION = {
    movement: [
        "entries",
        "passers_by",
        "capture_rate",
        "average_dwell_time",
        "average_occupancy"
    ],
    movementWithFilters: [
        "internal_line_crossings",
        "internal_entries",
        "internal_passers_by",
        "internal_capture_rate",
        "internal_line_crossings_per_location_entrant"
    ],
    zones: [
        "area_entries",
        "area_total_dwell_time",
        "area_average_dwell_time",
        "area_average_occupancy",
        "area_max_occupancy",
        "area_utilisation",
        "area_entries_per_location_entrant",
        "area_dwell_per_location_entrant"
    ],
    serviceAreas: [
        "area_entries",
        "area_total_dwell_time",
        "area_average_dwell_time",
        "area_average_occupancy",
        "area_max_occupancy",
        "area_utilisation",
        "area_entries_per_location_entrant",
        "area_dwell_per_location_entrant"
    ],
    sales: [
        "sales_transaction_count",
        "sales_volume",
        "sales_atv",
        "sales_units",
        "sales_upt",
        "sales_conversion_rate"
    ]
};
const $c1876c497f392709$var$_expandTaxonomyLevels = (taxonomies)=>{
    const levels = new Set();
    for (const tax of taxonomies){
        const parts = tax.split(':');
        for(let i = 1; i <= parts.length; i++)levels.add(parts.slice(0, i).join(':'));
    }
    return [
        ...levels
    ].sort();
};
const $c1876c497f392709$var$_isEmpty = (v)=>v === null || v === '' || Array.isArray(v) && v.length === 0;
const $c1876c497f392709$var$_sanitize = (schema, data)=>{
    if (data == null || typeof data !== 'object' || Array.isArray(data)) return data;
    const result = {};
    for (const [key, value] of Object.entries(data)){
        if ($c1876c497f392709$var$_isEmpty(value)) continue;
        const fieldSchema = schema?.properties?.[key] || schema?.additionalProperties;
        result[key] = typeof value === 'object' ? $c1876c497f392709$var$_sanitize(fieldSchema, value) : value;
    }
    return result;
};
const $c1876c497f392709$var$_stripEndpoints = (config)=>{
    const result = {};
    for (const [key, section] of Object.entries(config)){
        if (!section) continue;
        const { metrics: metrics, ...rest } = section;
        result[key] = {
            ...rest,
            metrics: metrics?.map(({ endpoint: endpoint, ...m })=>m)
        };
    }
    return result;
};
const $c1876c497f392709$var$_buildMetricsSchema = (taxonomies, keysAndValues)=>{
    const allMetricKeys = [
        ...new Set(Object.values($c1876c497f392709$var$METRIC_KEYS_BY_SECTION).flat())
    ].sort();
    return {
        type: "object",
        minProperties: 1,
        errorMessage: {
            minProperties: "Add at least one metric section"
        },
        propertyNames: {
            enum: Object.keys($c1876c497f392709$var$METRIC_KEYS_BY_SECTION)
        },
        additionalProperties: {
            type: "object",
            required: [
                "title",
                "description",
                "metrics"
            ],
            errorMessage: {
                required: {
                    title: "Section title is required",
                    description: "Section description is required",
                    metrics: "Add at least one metric"
                }
            },
            properties: {
                title: {
                    type: "string",
                    minLength: 1,
                    errorMessage: {
                        minLength: "Title cannot be empty"
                    }
                },
                description: {
                    type: "string"
                },
                metrics: {
                    type: "array",
                    minItems: 1,
                    errorMessage: {
                        minItems: "Add at least one metric"
                    },
                    items: {
                        type: "object",
                        required: [
                            "key",
                            "label",
                            "description"
                        ],
                        errorMessage: {
                            required: {
                                key: "Metric key is required",
                                label: "Metric label is required",
                                description: "Metric description is required"
                            }
                        },
                        properties: {
                            showOnStartup: {
                                type: "boolean"
                            },
                            key: {
                                type: "string",
                                enum: allMetricKeys,
                                errorMessage: {
                                    enum: "Pick a valid metric key"
                                }
                            },
                            label: {
                                type: "string",
                                minLength: 1,
                                maxLength: 50,
                                errorMessage: {
                                    minLength: "Label cannot be empty",
                                    maxLength: "Label must be 50 characters or fewer"
                                }
                            },
                            description: {
                                type: "string",
                                minLength: 1,
                                maxLength: 150,
                                errorMessage: {
                                    minLength: "Description cannot be empty",
                                    maxLength: "Description must be 150 characters or fewer"
                                }
                            }
                        }
                    }
                }
            }
        },
        dependentSchemas: Object.fromEntries(Object.entries($c1876c497f392709$var$METRIC_KEYS_BY_SECTION).map(([section, keys])=>{
            const taxonomyProps = section === 'zones' || section === 'serviceAreas' ? {
                taxonomyBlockFilter: {
                    type: [
                        "string",
                        "null"
                    ],
                    ...taxonomies?.length ? {
                        examples: taxonomies
                    } : {}
                },
                taxonomyAllowFilter: {
                    type: [
                        "string",
                        "null"
                    ],
                    ...taxonomies?.length ? {
                        examples: taxonomies
                    } : {}
                },
                taxonomySelectLabel: {
                    type: [
                        "string",
                        "null"
                    ]
                },
                showOnStartupTaxonomies: {
                    type: [
                        "array",
                        "null"
                    ],
                    items: {
                        type: "string",
                        ...taxonomies?.length ? {
                            examples: taxonomies
                        } : {}
                    }
                }
            } : {};
            const filterProps = section === 'movementWithFilters' ? {
                showOnStartupFilters: {
                    type: [
                        "array",
                        "null"
                    ],
                    items: {
                        type: "object",
                        required: [
                            "key",
                            "values"
                        ],
                        errorMessage: {
                            required: {
                                key: "Filter key is required",
                                values: "Filter values are required"
                            }
                        },
                        properties: {
                            key: {
                                type: "string",
                                ...keysAndValues?.keys?.length ? {
                                    examples: keysAndValues.keys
                                } : {}
                            },
                            values: {
                                type: "array",
                                items: {
                                    type: "string",
                                    ...keysAndValues?.values?.length ? {
                                        examples: keysAndValues.values
                                    } : {}
                                }
                            }
                        },
                        additionalProperties: false
                    }
                }
            } : {};
            return [
                section,
                {
                    properties: {
                        [section]: {
                            properties: {
                                ...taxonomyProps,
                                ...filterProps,
                                metrics: {
                                    items: {
                                        properties: {
                                            key: {
                                                enum: keys,
                                                errorMessage: {
                                                    enum: "Invalid metric key for this section"
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            ];
        }))
    };
};
const $c1876c497f392709$var$_uiMetricsSchema = {
    type: "Control",
    label: "Available Metrics",
    scope: "#",
    options: {
        collapsed: true,
        itemUISchema: {
            type: "Control",
            options: {
                editMode: 'drawer',
                itemTitle: 'title',
                itemDescription: 'description',
                itemUISchema: {
                    type: 'VerticalLayout',
                    elements: [
                        {
                            type: 'Control',
                            scope: '#/properties/metrics',
                            options: {
                                itemUISchema: {
                                    type: 'Control',
                                    options: {
                                        itemTitle: 'label',
                                        itemDescription: 'description',
                                        itemUISchema: {
                                            type: "HorizontalLayout",
                                            options: {
                                                wrap: false
                                            },
                                            elements: [
                                                {
                                                    type: "Control",
                                                    scope: "#/properties/key",
                                                    options: {
                                                        fill: true,
                                                        maxWidth: '250px'
                                                    }
                                                },
                                                {
                                                    type: "Control",
                                                    scope: "#/properties/showOnStartup",
                                                    options: {
                                                        toggle: true,
                                                        maxWidth: '180px'
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            }
                        },
                        {
                            type: "Group",
                            label: "Advanced",
                            options: {
                                collapsed: true
                            },
                            elements: [
                                {
                                    type: "HorizontalLayout",
                                    elements: [
                                        {
                                            type: "Control",
                                            scope: "#/properties/taxonomyBlockFilter",
                                            options: {
                                                fill: true
                                            }
                                        },
                                        {
                                            type: "Control",
                                            scope: "#/properties/taxonomyAllowFilter",
                                            options: {
                                                fill: true
                                            }
                                        },
                                        {
                                            type: "Control",
                                            scope: "#/properties/taxonomySelectLabel",
                                            options: {
                                                fill: true
                                            }
                                        }
                                    ]
                                },
                                {
                                    type: "VerticalLayout",
                                    elements: [
                                        {
                                            type: "Control",
                                            scope: "#/properties/showOnStartupTaxonomies",
                                            options: {
                                                fill: true
                                            }
                                        },
                                        {
                                            type: "Control",
                                            scope: "#/properties/showOnStartupFilters",
                                            options: {
                                                fill: true,
                                                horizontal: true,
                                                itemUISchema: {
                                                    type: "Control",
                                                    options: {
                                                        wrap: true,
                                                        horizontal: true
                                                    }
                                                }
                                            }
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            }
        }
    }
};
const $c1876c497f392709$export$9f25378ee5d9fb53 = ({ orgid: orgid })=>{
    const { setLoading: setLoading, setNav: setNav, setControls: setControls } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [info, setInfo] = (0, $kYL7Z.useState)(null);
    const [editing, setEditing] = (0, $kYL7Z.useState)(false);
    const [editErrors, setEditErrors] = (0, $kYL7Z.useState)(false);
    const [metricsData, setMetricsData] = (0, $kYL7Z.useState)(null);
    const [metricsErrors, setMetricsErrors] = (0, $kYL7Z.useState)(false);
    const [optionsDirty, setOptionsDirty] = (0, $kYL7Z.useState)(false);
    const [metricsDirty, setMetricsDirty] = (0, $kYL7Z.useState)(false);
    const [taxonomiesInUse, setTaxonomiesInUse] = (0, $kYL7Z.useState)(null);
    const [keysAndValuesInUse, setKeysAndValuesInUse] = (0, $kYL7Z.useState)(null);
    const metricsSchema = (0, $kYL7Z.useMemo)(()=>$c1876c497f392709$var$_buildMetricsSchema(taxonomiesInUse, keysAndValuesInUse), [
        taxonomiesInUse,
        keysAndValuesInUse
    ]);
    // editing toggle — update controls and handle save
    (0, $kYL7Z.useEffect)(()=>{
        setControls([
            {
                name: editing ? "Save" : "Edit",
                onClick: ()=>setEditing((prev)=>!prev),
                icon: editing ? "floppy-disk" : "edit",
                confirm: editing
            }
        ]);
        if (!editing && info) {
            if (editErrors || metricsErrors) {
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: "Some fields are wrong",
                    timeout: 5000
                });
                setEditing(true);
                return;
            }
            const saves = [];
            if (optionsDirty) saves.push((0, $5a9cade4af2d6a52$export$d030b7498dcede47).update(orgid, {
                options: info.options
            }).then((updatedInfo)=>{
                setInfo(updatedInfo);
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: "Updated " + updatedInfo.name
                });
            }).catch((err)=>{
                console.log(err);
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: "Failed to save org: " + err.message,
                    timeout: 5000
                });
                throw err;
            }));
            if (metricsDirty) saves.push((0, $5a9cade4af2d6a52$export$d030b7498dcede47).availableMetrics.update(orgid, $c1876c497f392709$var$_sanitize(metricsSchema, metricsData)).then((resp)=>{
                setMetricsData($c1876c497f392709$var$_stripEndpoints(resp.config));
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: "Updated available metrics"
                });
            }).catch((err)=>{
                console.log(err);
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: "Failed to save metrics: " + err.message,
                    timeout: 5000
                });
                throw err;
            }));
            if (saves.length) {
                setLoading({
                    status: true,
                    location: "Saving..."
                });
                Promise.allSettled(saves).then((results)=>{
                    setOptionsDirty(false);
                    setMetricsDirty(false);
                    if (results.some((r)=>r.status === 'rejected')) setEditing(true);
                    setLoading({
                        status: false,
                        location: info.name + " (" + orgid + ")"
                    });
                });
            }
        }
        return ()=>setControls([]);
    }, [
        editing
    ]);
    // load organisation data
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Loading orgid: " + orgid);
        setLoading({
            status: true,
            location: "Loading organisation: " + orgid
        });
        (0, $5a9cade4af2d6a52$export$d030b7498dcede47).get(orgid).then((loadedInfo)=>{
            console.log("Loaded orgid: " + orgid);
            setInfo(loadedInfo);
            setNav({
                right: [
                    {
                        name: "Locations",
                        path: "/locs?org=" + orgid,
                        icon: "area-of-interest"
                    },
                    {
                        name: "Devices",
                        path: "/devs?org=" + orgid,
                        icon: "desktop"
                    },
                    {
                        name: "Cameras",
                        path: "/recs?org=" + orgid,
                        icon: "camera"
                    },
                    {
                        name: "Users",
                        path: "/orgs/" + orgid + "/users",
                        icon: "people"
                    }
                ]
            });
            setLoading({
                status: false,
                location: loadedInfo.name + " (" + loadedInfo.id + ")" + " ... loading extra resources"
            });
            // fetch extra resources (taxonomies, keys and values from lineContexts)
            (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).list({
                include: 'areaContexts,lineContexts',
                withinOrganisations: orgid
            }).then((recs)=>{
                const allAreaContexts = (0, $i5w0I.flatten)(recs.map((r)=>r.areaContexts)).filter(Boolean);
                const allLineContexts = (0, $i5w0I.flatten)(recs.map((r)=>r.lineContexts)).filter(Boolean);
                setTaxonomiesInUse($c1876c497f392709$var$_expandTaxonomyLevels((0, $i5w0I.uniq)(allAreaContexts.map((ac)=>ac.taxonomy).filter(Boolean))));
                const kv = allLineContexts.filter((lc)=>lc.type === 'within-location-entry' || lc.type === 'within-location-pass-by').reduce((acc, lc)=>{
                    lc.metadata.forEach(({ key: key, value: value })=>{
                        acc.keys = (0, $i5w0I.uniq)([
                            ...acc.keys,
                            key
                        ]);
                        acc.values = (0, $i5w0I.uniq)([
                            ...acc.values,
                            value
                        ]);
                    });
                    return acc;
                }, {
                    keys: [],
                    values: []
                });
                setKeysAndValuesInUse({
                    keys: kv.keys.sort(),
                    values: kv.values.sort()
                });
                setLoading({
                    status: false,
                    location: loadedInfo.name + " (" + loadedInfo.id + ")"
                });
            }).catch((err)=>{
                console.log("Failed to load extra resources: " + err.message);
                setLoading({
                    status: false,
                    location: loadedInfo.name + " (" + loadedInfo.id + ")"
                });
            });
        }).catch((error)=>{
            setLoading({
                status: false,
                location: "Failed to load organisation..."
            });
            console.log("Failed to load: " + error.message);
        });
        (0, $5a9cade4af2d6a52$export$d030b7498dcede47).availableMetrics.get(orgid).then((resp)=>{
            setMetricsData($c1876c497f392709$var$_sanitize(metricsSchema, $c1876c497f392709$var$_stripEndpoints(resp.config)));
        }).catch((err)=>{
            console.log("Failed to load available metrics: " + err.message);
        });
    }, []);
    if (!info) return null;
    const handleOrgChange = ({ data: data, errors: errors })=>{
        setInfo(data);
        setEditErrors(!!errors.length);
        setOptionsDirty(true);
    };
    const handleMetricsChange = ({ data: data, errors: errors })=>{
        setMetricsData(data);
        setMetricsErrors(!!errors.length);
        setMetricsDirty(true);
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '12px'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                schema: $c1876c497f392709$var$_orgSchema,
                uischema: $c1876c497f392709$var$_uiInfoSchema,
                data: info,
                readonly: !editing,
                onChange: handleOrgChange
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                schema: $c1876c497f392709$var$_orgSchema,
                uischema: $c1876c497f392709$var$_uiOptionsSchema,
                data: info,
                readonly: !editing,
                onChange: handleOrgChange
            }),
            metricsData && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                schema: metricsSchema,
                uischema: $c1876c497f392709$var$_uiMetricsSchema,
                data: metricsData,
                readonly: !editing,
                onChange: handleMetricsChange
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $529680d6a92888ed$export$fb7347eee3e2dcee), {
                orgid: orgid
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");









var $kYL7Z = parcelRequire("kYL7Z");

var $i5w0I = parcelRequire("i5w0I");



var $kYL7Z = parcelRequire("kYL7Z");






const $0557f9662be477d9$export$caec2af78bcc877f = (props)=>{
    const { cancelButtonText: cancelButtonText, canEscapeKeyCancel: canEscapeKeyCancel = false, canOutsideClickCancel: canOutsideClickCancel = false, children: children, className: className, confirmButtonText: confirmButtonText = "OK", icon: icon, intent: intent, isOpen: isOpen = false, loading: loading = false, onCancel: onCancel, onClose: onClose, onConfirm: onConfirm, ...overlayProps } = props;
    (0, $782dccc2198ae4be$export$fa00fc37980674c4)(()=>{
        if (onClose == null && cancelButtonText == null !== (onCancel == null)) console.warn((0, $5bed6f2a5e88b283$export$5b85f29a2be29baf));
        const hasCancelHandler = onCancel != null || onClose != null;
        if (canEscapeKeyCancel && !hasCancelHandler) console.warn((0, $5bed6f2a5e88b283$export$f6e5524776d50d97));
        if (canOutsideClickCancel && !hasCancelHandler) console.warn((0, $5bed6f2a5e88b283$export$b72cc84fa7249bbc));
    }, [
        canEscapeKeyCancel,
        canOutsideClickCancel,
        cancelButtonText,
        onCancel,
        onClose
    ]);
    const internalHandleCallbacks = (0, $kYL7Z.useCallback)((confirmed, event)=>{
        (confirmed ? onConfirm : onCancel)?.(event);
        onClose?.(confirmed, event);
    }, [
        onCancel,
        onClose,
        onConfirm
    ]);
    const handleCancel = (0, $kYL7Z.useCallback)((event)=>internalHandleCallbacks(false, event), [
        internalHandleCallbacks
    ]);
    const handleConfirm = (0, $kYL7Z.useCallback)((event)=>internalHandleCallbacks(true, event), [
        internalHandleCallbacks
    ]);
    return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
        ...overlayProps,
        role: "alertdialog",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).ALERT, className),
        canEscapeKeyClose: canEscapeKeyCancel,
        canOutsideClickClose: canOutsideClickCancel,
        isOpen: isOpen,
        onClose: handleCancel,
        children: [
            (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).ALERT_BODY,
                children: [
                    (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: icon,
                        size: 40,
                        intent: intent
                    }),
                    (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                        className: (0, $2cfd35af7ec11fdd$exports).ALERT_CONTENTS,
                        children: children
                    })
                ]
            }),
            (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).ALERT_FOOTER,
                children: [
                    (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        loading: loading,
                        intent: intent,
                        text: confirmButtonText,
                        onClick: handleConfirm
                    }),
                    cancelButtonText && (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        text: cancelButtonText,
                        disabled: loading,
                        onClick: handleCancel
                    })
                ]
            })
        ]
    });
};
$0557f9662be477d9$export$caec2af78bcc877f.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Alert`;



var $kYL7Z = parcelRequire("kYL7Z");








var $kYL7Z = parcelRequire("kYL7Z");





var $kYL7Z = parcelRequire("kYL7Z");




/*
 * Copyright 2023 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $kYL7Z = parcelRequire("kYL7Z");
function $ec9054484c160ae9$export$77740a1d363c1546(props) {
    const [checkedStateForUncontrolledMode, setChecked] = (0, $kYL7Z.useState)(()=>props.defaultChecked ?? false);
    // If the checked prop is passed, this input is in "controlled mode" and
    // should always reflect the value of the controlled prop. Any internal
    // state tracked for "uncontrolled mode" should be ignored.
    const checked = props.checked ?? checkedStateForUncontrolledMode;
    const onChange = (0, $kYL7Z.useCallback)((e)=>{
        setChecked((c)=>!c);
        props.onChange?.(e);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.onChange
    ]);
    return {
        checked: checked,
        onChange: onChange
    };
}


const $3f2667caefcbf635$export$f150d40a25abf0b = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { alignIndicator: alignIndicator = (0, $ff848d68cab849d9$export$9d7927214ed7d2cf).END, checked: _checked, children: children, className: className, controlKind: controlKind, defaultChecked: _defaultChecked, disabled: disabled, inputProps: inputProps, inputRef: inputRef, label: label, onChange: _onChange, showAsSelectedWhenChecked: showAsSelectedWhenChecked = true, value: value, ...cardProps } = props;
    const { checked: checked, onChange: onChange } = (0, $ec9054484c160ae9$export$77740a1d363c1546)(props);
    // use a container element to achieve a good flex layout
    const labelElement = (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: (0, $2cfd35af7ec11fdd$exports).CONTROL_CARD_LABEL,
        children: children ?? label
    });
    const controlProps = {
        alignIndicator: alignIndicator,
        checked: checked,
        disabled: disabled,
        inline: true,
        inputRef: inputRef,
        labelElement: labelElement,
        onChange: onChange,
        value: value,
        ...inputProps
    };
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).CONTROL_CARD, className, {
        [(0, $2cfd35af7ec11fdd$exports).SELECTED]: showAsSelectedWhenChecked && checked
    });
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $0199c8413a0068dd$export$60332b2344f7fe41), {
        interactive: !disabled,
        className: classes,
        ref: ref,
        ...cardProps,
        children: controlKind === "switch" ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
            ...controlProps
        }) : controlKind === "checkbox" ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
            ...controlProps
        }) : controlKind === "radio" ? (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$d7b12c4107be0d61), {
            ...controlProps
        }) : labelElement
    });
});
$3f2667caefcbf635$export$f150d40a25abf0b.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.ControlCard`;


const $81a41d6e2eb53e9e$export$f8afaea2e9656b91 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const className = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(props.className, (0, $2cfd35af7ec11fdd$exports).RADIO_CONTROL_CARD);
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $3f2667caefcbf635$export$f150d40a25abf0b), {
        ...props,
        className: className,
        controlKind: "radio",
        ref: ref
    });
});
$81a41d6e2eb53e9e$export$f8afaea2e9656b91.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.RadioCard`;



const $916d3d59637789ee$export$a98f0dcb43a68a25 = (props)=>{
    const { children: children, className: className, disabled: disabled, inline: inline, label: label, name: name, onChange: onChange, options: options, selectedValue: selectedValue, ...htmlProps } = props;
    // a unique name for this group, which can be overridden by `name` prop.
    const autoGroupName = (0, $kYL7Z.useMemo)(()=>$916d3d59637789ee$var$nextName(), []);
    const labelId = (0, $kYL7Z.useMemo)(()=>(0, $f141b3b4d406798c$export$8b15d37bc3f197d4)("label"), []);
    (0, $782dccc2198ae4be$export$fa00fc37980674c4)(()=>{
        if (children != null && options != null) console.warn($5bed6f2a5e88b283$export$85aa0d720577b224);
    }, [
        children,
        options
    ]);
    const getRadioProps = (0, $kYL7Z.useCallback)((optionProps)=>{
        const { className: optionClassName, disabled: optionDisabled, value: value } = optionProps;
        return {
            checked: value === selectedValue,
            className: optionClassName,
            disabled: optionDisabled || disabled,
            inline: inline,
            name: name == null ? autoGroupName : name,
            onChange: onChange,
            value: value
        };
    }, [
        autoGroupName,
        disabled,
        inline,
        name,
        onChange,
        selectedValue
    ]);
    const renderChildren = ()=>{
        return (0, $kYL7Z.Children).map(children, (child)=>{
            if ((0, $dd6a2a6ae729b1ca$export$8bb8d43ade7732d8)(child, (0, $4e9bf29f7973618d$export$d7b12c4107be0d61)) || (0, $dd6a2a6ae729b1ca$export$8bb8d43ade7732d8)(child, (0, $81a41d6e2eb53e9e$export$f8afaea2e9656b91))) return (0, $kYL7Z.cloneElement)(// Need this cast here to suppress a TS error caused by differing `ref` types for the Radio and
            // RadioCard components. We aren't injecting a ref, so we don't need to be strict about that
            // incompatibility.
            child, getRadioProps(child.props));
            return child;
        });
    };
    const renderOptions = ()=>{
        return options?.map((option)=>(0, $kYL7Z.createElement)((0, $4e9bf29f7973618d$export$d7b12c4107be0d61), {
                ...getRadioProps(option),
                key: option.value,
                labelElement: option.label || option.value
            }));
    };
    return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        role: "radiogroup",
        "aria-labelledby": label ? labelId : undefined,
        ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(htmlProps),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).RADIO_GROUP, className),
        children: [
            label && (0, $fc31e5e9fc16a880$exports.jsx)("label", {
                className: (0, $2cfd35af7ec11fdd$exports).LABEL,
                id: labelId,
                children: label
            }),
            Array.isArray(options) ? renderOptions() : renderChildren()
        ]
    });
};
$916d3d59637789ee$export$a98f0dcb43a68a25.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.RadioGroup`;
let $916d3d59637789ee$var$counter = 0;
function $916d3d59637789ee$var$nextName() {
    return `${$916d3d59637789ee$export$a98f0dcb43a68a25.displayName}-${$916d3d59637789ee$var$counter++}`;
}



var $72e6dd2cda88a181$export$2e2bcd8739ae039 = (selectedOrgName)=>({
        'Analytics data viewer': {
            checkedByDefaultForNewUserInvite: true,
            deleteDisabled: true,
            createDisabled: false,
            label: 'Analytics data viewer',
            description: 'Can access this organisations data on the dashboard (required)'
        },
        'Client Admin - Auth Service Administration': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company' ? true : false,
            label: 'User Admin',
            description: 'Can view, add, edit and delete users within this organisation (disabled for Demo Company users)'
        },
        'Data Viewer - Auth Service Access': {
            checkedByDefaultForNewUserInvite: true,
            deleteDisabled: true,
            createDisabled: false,
            label: 'Basic user access',
            description: 'Can view and edit their own account (required)'
        },
        'Analytics data viewer - manage reports': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company' ? true : false,
            label: 'Manage reports',
            description: 'Can create, edit and remove dashboard reports and email report schedules (disabled for Demo Company users)'
        },
        'Client Admin - manage locations': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company' ? true : false,
            label: 'Manage locations',
            description: 'Can create, edit and remove locations (disabled for Demo Company users)'
        },
        'Client Admin - camera and device set up': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company' ? true : false,
            label: 'Access to the cameras tool',
            description: 'Can log in to the cameras tool and edit lines and areas'
        },
        'Analytics data viewer - manage campaigns': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company' ? true : false,
            label: 'Manage campaigns',
            description: 'Can create, edit and remove dashboard campaigns (disabled for Demo Company users)'
        }
    });




const $05f420f22130a355$var$FormWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    width: 90%;
    margin: 2em auto;
`;
const $05f420f22130a355$var$Section = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin-bottom: 2em;
`;
const $05f420f22130a355$var$Table = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).table`
    width: 100%;
    margin: 1em 0;
`;
const $05f420f22130a355$var$SmallLabel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).p`
    color: #555;
    font-size: 12px;
    margin: 0;
    ${(props)=>props.$marginBottom ? 'margin-bottom: 1em' : ''}
`;
const $05f420f22130a355$export$91d3ef6160facf05 = ({ user: user, orgId: orgId, orgName: orgName, isOpen: isOpen, onClose: onClose, onUserUpdated: onUserUpdated, onUserDeleted: onUserDeleted })=>{
    // edit user state
    const [fullName, setFullName] = (0, $kYL7Z.useState)('');
    const [status, setStatus] = (0, $kYL7Z.useState)('');
    const [editLoading, setEditLoading] = (0, $kYL7Z.useState)(false);
    // roles state
    const [currentRoles, setCurrentRoles] = (0, $kYL7Z.useState)([]);
    const [availableRoles, setAvailableRoles] = (0, $kYL7Z.useState)([]);
    const [roleToAdd, setRoleToAdd] = (0, $kYL7Z.useState)('');
    const [rolesLoading, setRolesLoading] = (0, $kYL7Z.useState)(false);
    const [roleResponse, setRoleResponse] = (0, $kYL7Z.useState)({});
    // delete state
    const [deleteAlertOpen, setDeleteAlertOpen] = (0, $kYL7Z.useState)(false);
    const [deleteLoading, setDeleteLoading] = (0, $kYL7Z.useState)(false);
    const roleMappings = (0, $72e6dd2cda88a181$export$2e2bcd8739ae039)(orgName);
    // initialise form when drawer opens
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen && user) {
            setFullName(user.fullName || '');
            setStatus(user.status || '');
            setRoleResponse({});
        }
    }, [
        isOpen,
        user
    ]);
    // fetch roles when drawer opens
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen || !user) return;
        async function fetchRoles() {
            setRolesLoading(true);
            try {
                const { data: allRoles } = await $aa27e6f0058e6325$export$8e77a375f9a5908e.list();
                const { data: userRoles } = await $aa27e6f0058e6325$export$7652f722913b5d7.rolesForUser(user.id, orgId);
                const available = allRoles.filter((r)=>{
                    const mapping = roleMappings[r.name] || {};
                    if (mapping.createDisabled) return false;
                    return !userRoles.find((cr)=>cr.id === r.id);
                });
                setCurrentRoles(userRoles);
                setAvailableRoles(available);
                setRoleToAdd(available.length > 0 ? available[0].id : '');
            } catch (e) {
                console.error(e);
            } finally{
                setRolesLoading(false);
            }
        }
        fetchRoles();
    }, [
        isOpen,
        user
    ]);
    const editUser = async (e)=>{
        e.preventDefault();
        setEditLoading(true);
        try {
            await $aa27e6f0058e6325$export$7652f722913b5d7.update(user.id, {
                ...(0, $i5w0I.pick)(user, 'primaryOrgId'),
                email: user.email,
                fullName: fullName,
                status: status
            });
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: 'User updated'
            });
            onUserUpdated();
        } catch (e) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Failed to update user'
            });
        } finally{
            setEditLoading(false);
        }
    };
    const removeRole = async (role)=>{
        setRoleResponse({
            type: 'info',
            text: 'Removing...'
        });
        try {
            await $aa27e6f0058e6325$export$7652f722913b5d7.removeRole(user.id, orgId, role.id);
            setCurrentRoles((prev)=>prev.filter((r)=>r.id !== role.id));
            setAvailableRoles((prev)=>{
                const updated = [
                    ...prev,
                    role
                ];
                setRoleToAdd(updated[0]?.id || '');
                return updated;
            });
            setRoleResponse({
                type: 'success',
                text: 'Role removed'
            });
        } catch (e) {
            setRoleResponse({
                type: 'danger',
                text: 'Could not remove role'
            });
        }
    };
    const addRole = async ()=>{
        if (!roleToAdd) return;
        setRoleResponse({
            type: 'info',
            text: 'Adding...'
        });
        try {
            await $aa27e6f0058e6325$export$7652f722913b5d7.addRole(user.id, orgId, roleToAdd);
            const added = availableRoles.find((r)=>Number(r.id) === Number(roleToAdd));
            setAvailableRoles((prev)=>{
                const updated = prev.filter((r)=>Number(r.id) !== Number(roleToAdd));
                setRoleToAdd(updated[0]?.id || '');
                return updated;
            });
            setCurrentRoles((prev)=>[
                    ...prev,
                    added
                ]);
            setRoleResponse({
                type: 'success',
                text: 'Role added'
            });
        } catch (e) {
            setRoleResponse({
                type: 'danger',
                text: 'Could not add role'
            });
        }
    };
    const deleteUser = async ()=>{
        setDeleteLoading(true);
        try {
            await $aa27e6f0058e6325$export$7652f722913b5d7.delete(user.id);
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `${user.email} deleted`
            });
            setDeleteAlertOpen(false);
            onUserDeleted();
        } catch (e) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Could not delete user'
            });
        } finally{
            setDeleteLoading(false);
        }
    };
    if (!user) return null;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
                icon: "person",
                title: user.email,
                isOpen: isOpen,
                onClose: onClose,
                size: "40%",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($05f420f22130a355$var$FormWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($05f420f22130a355$var$Section, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("h3", {
                                    children: "Edit User"
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("form", {
                                    onSubmit: editUser,
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                                            label: "Email",
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                                                value: user.email,
                                                disabled: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                                            label: "Full name",
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                                                value: fullName,
                                                onChange: (e)=>setFullName(e.target.value)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $916d3d59637789ee$export$a98f0dcb43a68a25), {
                                            label: "Status",
                                            onChange: (e)=>setStatus(e.target.value),
                                            selectedValue: status,
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$d7b12c4107be0d61), {
                                                    label: "Active",
                                                    value: "active"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$d7b12c4107be0d61), {
                                                    label: "Created (prompted for name on dashboard)",
                                                    value: "created"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$d7b12c4107be0d61), {
                                                    label: "Inactive (can log in but no data access)",
                                                    value: "inactive"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            type: "submit",
                                            loading: editLoading,
                                            intent: "primary",
                                            text: "Update user"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($05f420f22130a355$var$Section, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("h3", {
                                    children: [
                                        "Roles in ",
                                        orgName
                                    ]
                                }),
                                rolesLoading ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                                    size: 30
                                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($05f420f22130a355$var$Table, {
                                            className: "bp6-html-table bp6-html-table-bordered bp6-interactive",
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("th", {
                                                                children: "Role"
                                                            }),
                                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("th", {
                                                                children: "Actions"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("tbody", {
                                                    children: currentRoles.map((role)=>{
                                                        if (!role) return null;
                                                        const mapping = roleMappings[role.name] || {};
                                                        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("td", {
                                                                    children: [
                                                                        mapping.label || role.name,
                                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($05f420f22130a355$var$SmallLabel, {
                                                                            children: mapping.description
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                                        small: true,
                                                                        intent: "warning",
                                                                        text: "Remove",
                                                                        disabled: mapping.deleteDisabled !== false,
                                                                        onClick: ()=>removeRole(role)
                                                                    })
                                                                })
                                                            ]
                                                        }, role.id);
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                                            title: "Assign a new role",
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($05f420f22130a355$var$SmallLabel, {
                                                    $marginBottom: true,
                                                    children: 'Only shows roles not marked as "Internal use only".'
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9e675beb9e64c244$export$49d2a72fcffd1efe), {
                                                            onChange: (e)=>setRoleToAdd(e.target.value),
                                                            value: roleToAdd,
                                                            options: availableRoles.length === 0 ? [
                                                                {
                                                                    label: 'No other roles to add...',
                                                                    value: ''
                                                                }
                                                            ] : availableRoles.map((role)=>{
                                                                const mapping = roleMappings[role.name] || {};
                                                                const desc = mapping.description ? ` (${mapping.description})` : '';
                                                                return {
                                                                    label: (mapping.label || role.name) + desc,
                                                                    value: role.id
                                                                };
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                            text: "Add",
                                                            intent: "primary",
                                                            onClick: addRole
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        roleResponse.type && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                                            intent: roleResponse.type,
                                            children: roleResponse.text
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($05f420f22130a355$var$Section, {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                                intent: "danger",
                                title: "Danger zone",
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    intent: "danger",
                                    icon: "trash",
                                    text: "Delete user",
                                    onClick: ()=>setDeleteAlertOpen(true)
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0557f9662be477d9$export$caec2af78bcc877f), {
                isOpen: deleteAlertOpen,
                cancelButtonText: "Cancel",
                confirmButtonText: "Delete user",
                intent: "danger",
                icon: deleteLoading ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                    size: 40
                }) : "trash",
                canEscapeKeyCancel: true,
                canOutsideClickCancel: true,
                onCancel: ()=>setDeleteAlertOpen(false),
                onConfirm: deleteUser,
                children: [
                    "Are you sure you want to delete ",
                    user.email,
                    "?"
                ]
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");





const $3735da1696086161$var$FormWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).form`
  width: 90%;
  margin: 2em auto;
`;
const $3735da1696086161$var$SmallLabel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).p`
  color: #555;
  font-size: 12px;
  margin: 0 0 2em 0;
`;
const $3735da1696086161$var$HostHint = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
  color: #555;
  font-size: 12px;
  margin-left: 0.5em;
`;
const $3735da1696086161$export$98d7f60976eebcb8 = {
    webclient: 'webclient',
    dashboardRag: 'dashboard-rag'
};
// The new dashboard hostname. PRERELEASE_DASHBOARD_APP_BASE names the new dashboard in
// both env files; the same variable drives the "Prerelease" impersonate button in many.js.
const $3735da1696086161$var$newDashboardBase = ()=>$a13d063d3fb3aa31$export$1bc62597831f80f3;
const $3735da1696086161$export$f6c560b01fbb6f64 = ()=>[
        {
            value: $3735da1696086161$export$98d7f60976eebcb8.webclient,
            label: 'Dashboard V1',
            base: $a13d063d3fb3aa31$export$fa3559c82ed925a
        },
        {
            value: $3735da1696086161$export$98d7f60976eebcb8.dashboardRag,
            label: 'Dashboard V2',
            base: $3735da1696086161$var$newDashboardBase()
        }
    ];
const $3735da1696086161$export$f978a098b6639135 = (base)=>{
    try {
        return new URL(base).host;
    } catch  {
        return base || '';
    }
};
const $3735da1696086161$export$51ed1e92abe9a207 = ()=>Boolean($3735da1696086161$var$newDashboardBase());
const $3735da1696086161$export$2bbb5fd4c492436c = (selected)=>$3735da1696086161$export$51ed1e92abe9a207() && selected === $3735da1696086161$export$98d7f60976eebcb8.dashboardRag ? selected : undefined;
const $3735da1696086161$var$getRoleMappings = (selectedOrgName)=>({
        'Analytics data viewer': {
            checkedByDefaultForNewUserInvite: true,
            deleteDisabled: true,
            createDisabled: false,
            label: 'Analytics data viewer',
            description: 'Can access this organisations data on the dashboard (required)'
        },
        'Client Admin - Auth Service Administration': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company',
            label: 'User Admin',
            description: 'Can view, add, edit and delete users within this organisation (disabled for Demo Company users)'
        },
        'Data Viewer - Auth Service Access': {
            checkedByDefaultForNewUserInvite: true,
            deleteDisabled: true,
            createDisabled: false,
            label: 'Basic user access',
            description: 'Can view and edit their own account (required)'
        },
        'Analytics data viewer - manage reports': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company',
            label: 'Manage reports',
            description: 'Can create, edit and remove dashboard reports and email report schedules (disabled for Demo Company users)'
        },
        'Client Admin - manage locations': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company',
            label: 'Manage locations',
            description: 'Can create, edit and remove locations (disabled for Demo Company users)'
        },
        'Client Admin - camera and device set up': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company',
            label: 'Access to the cameras tool',
            description: 'Can log in to the cameras tool and edit lines and areas'
        },
        'Analytics data viewer - manage campaigns': {
            checkedByDefaultForNewUserInvite: false,
            deleteDisabled: false,
            createDisabled: selectedOrgName === 'Demo Company',
            label: 'Manage campaigns',
            description: 'Can create, edit and remove dashboard campaigns (disabled for Demo Company users)'
        }
    });
const $3735da1696086161$export$26baa3e450ed80b8 = ({ isOpen: isOpen, onClose: onClose, selectedOrg: selectedOrg })=>{
    const [roles, setRoles] = (0, $kYL7Z.useState)([]);
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const [inviteResponse, setInviteResponse] = (0, $kYL7Z.useState)({});
    const [targetApp, setTargetApp] = (0, $kYL7Z.useState)($3735da1696086161$export$98d7f60976eebcb8.webclient);
    const formRef = (0, $kYL7Z.useRef)(null);
    const emailInput = (0, $kYL7Z.useRef)(null);
    const roleCheckboxes = (0, $kYL7Z.useRef)(null);
    const roleMappings = $3735da1696086161$var$getRoleMappings(selectedOrg?.name);
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen) {
            if (emailInput.current) emailInput.current.focus();
            setInviteResponse({});
            setTargetApp($3735da1696086161$export$98d7f60976eebcb8.webclient);
            $aa27e6f0058e6325$export$8e77a375f9a5908e.list().then(({ data: data })=>setRoles(data)).catch((e)=>console.error(e));
        }
    }, [
        isOpen
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!roleCheckboxes.current) return;
        const checkboxes = roleCheckboxes.current.querySelectorAll('input[type=checkbox]');
        if (!checkboxes) return;
        checkboxes.forEach((cb)=>{
            const mapping = roleMappings[cb.name];
            if (mapping?.checkedByDefaultForNewUserInvite) cb.checked = true;
        });
    }, [
        roleMappings,
        roles
    ]);
    const inviteUser = async (e)=>{
        e.preventDefault();
        const email = emailInput.current.value;
        const roleIds = Array.from(roleCheckboxes.current.querySelectorAll('input[type=checkbox]:checked')).map((el)=>el.value);
        if (!roleIds.length) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'No roles selected'
            });
            return;
        }
        setLoading(true);
        setInviteResponse({});
        try {
            await $aa27e6f0058e6325$export$dd37b42f82fee9c3.send(email, roleIds, selectedOrg, $3735da1696086161$export$2bbb5fd4c492436c(targetApp));
            setInviteResponse({
                type: 'success',
                text: 'Invite sent to user'
            });
        } catch  {
            setInviteResponse({
                type: 'warning',
                text: 'There was an error'
            });
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        icon: "person",
        title: "Add a new user",
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($3735da1696086161$var$FormWrapper, {
            ref: formRef,
            onSubmit: inviteUser,
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    helperText: "This needs to be an actual email address - this person will recieve an email to set their password",
                    label: "Email address",
                    labelFor: "text-input",
                    labelInfo: "(required)",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                        id: "text-input",
                        required: true,
                        inputRef: emailInput,
                        type: "email"
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    label: "Organisation",
                    labelFor: "text-input",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                        id: "text-input",
                        value: selectedOrg?.name || '',
                        disabled: true
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    label: "Roles",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                        ref: roleCheckboxes,
                        children: roles.map((role)=>{
                            const roleMapping = roleMappings[role.name];
                            if (!roleMapping) return null;
                            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                                        disabled: roleMapping.createDisabled || roleMapping.deleteDisabled,
                                        name: role.name,
                                        value: role.id,
                                        children: roleMapping.label
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($3735da1696086161$var$SmallLabel, {
                                        children: roleMapping.description
                                    })
                                ]
                            }, role.id);
                        })
                    })
                }),
                $3735da1696086161$export$51ed1e92abe9a207() && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    label: "Dashboard this user will be sent to",
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $916d3d59637789ee$export$a98f0dcb43a68a25), {
                            onChange: (e)=>setTargetApp(e.target.value),
                            selectedValue: targetApp,
                            children: $3735da1696086161$export$f6c560b01fbb6f64().map((app)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$d7b12c4107be0d61), {
                                    value: app.value,
                                    labelElement: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                        children: [
                                            app.label,
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($3735da1696086161$var$HostHint, {
                                                children: $3735da1696086161$export$f978a098b6639135(app.base)
                                            })
                                        ]
                                    })
                                }, app.value))
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($3735da1696086161$var$SmallLabel, {
                            children: "The password-setup email takes the user to this dashboard. Users invited from inside a dashboard are sent to that dashboard automatically."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    type: "submit",
                    loading: loading,
                    intent: "primary",
                    children: "Add user to this organisation"
                }),
                inviteResponse.type && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                    intent: inviteResponse.type,
                    children: inviteResponse.text
                })
            ]
        })
    });
};



// -------------------------------------------------
// ----------------------------------- columns model
const $989e039240e881cc$var$getUserModelColumns = (onEditUser)=>[
        {
            key: 'id',
            name: 'Id',
            width: 50
        },
        {
            key: 'fullName',
            name: 'Name',
            // width: 200,
            resizable: true,
            sortable: true,
            filterable: true,
            showDefaultFilter: true
        },
        {
            key: 'email',
            name: 'Email',
            // width: 300,
            resizable: true,
            sortable: true,
            filterable: true,
            showDefaultFilter: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("a", {
                    href: 'mailto:' + params.row.email,
                    children: params.row.email
                })
        },
        {
            key: 'auth0Id',
            name: 'Auth0 Id',
            // width: 300,
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'status',
            name: 'Status',
            width: 80,
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'type',
            name: 'Type',
            width: 80,
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'primaryOrgName',
            name: 'Active org',
            width: 100,
            resizable: true,
            sortable: true,
            filterable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                    to: '/orgs/' + params.row.primaryOrgId,
                    children: params.row.primaryOrgName
                })
        },
        {
            key: 'ownerOrgName',
            name: 'Owner org',
            width: 100,
            resizable: true,
            sortable: true,
            filterable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                    to: '/orgs/' + params.row.ownerOrgId,
                    children: params.row.ownerOrgName
                })
        },
        {
            key: 'usersOrgs',
            name: 'Other orgs',
            width: 100,
            resizable: true,
            formatter: (params)=>{
                const value = params.row.usersOrgs;
                if (!value) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                    size: 12
                });
                if (typeof value === 'string') return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    children: value
                });
                if (value.length > 1) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                    placement: "bottom",
                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                        children: value.map((org)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                text: org.name,
                                href: '/orgs/' + org.id + '/users'
                            }, org.id))
                    }),
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        rightIcon: "caret-down",
                        text: `${value.length} orgs`,
                        small: true
                    })
                });
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    children: "-"
                });
            }
        },
        {
            key: 'adopted',
            name: 'Adopted',
            width: 75,
            resizable: true,
            sortable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                    checked: !!params.row?.adopted
                })
        },
        {
            key: 'createdAt',
            name: 'Created',
            width: 100,
            resizable: true,
            sortable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                    title: params.row.createdAt,
                    children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
                })
        },
        {
            key: 'updatedAt',
            name: 'Updated',
            width: 100,
            resizable: true,
            sortable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                    title: params.row.updatedAt,
                    children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
                })
        },
        {
            key: 'edit',
            name: 'Edit',
            width: 60,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    icon: "edit",
                    round: true,
                    interactive: true,
                    onClick: ()=>onEditUser(params.row)
                })
        },
        {
            key: 'impersonate',
            name: 'Impersonate',
            width: (0, $a13d063d3fb3aa31$export$1bc62597831f80f3) ? 175 : 110,
            formatter: (params)=>{
                const impUrl = (base)=>`${base}/?impersonateId=${encodeURIComponent(params.row.auth0Id)}`;
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$59a34841c163ed64), {
                            size: "small",
                            variant: "outlined",
                            intent: "primary",
                            href: impUrl((0, $a13d063d3fb3aa31$export$fa3559c82ed925a)),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: (0, $a13d063d3fb3aa31$export$4625fcba3fc11d47) === 'prod' ? 'Production' : 'UAT'
                        }),
                        (0, $a13d063d3fb3aa31$export$1bc62597831f80f3) && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$59a34841c163ed64), {
                            size: "small",
                            variant: "outlined",
                            intent: "success",
                            href: impUrl((0, $a13d063d3fb3aa31$export$1bc62597831f80f3)),
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Dash"
                        })
                    ]
                });
            }
        }
    ];
const $989e039240e881cc$export$6b69323c17febc33 = ({ orgId: orgId })=>{
    const { setLoading: setLoading, setNav: setNav, setControls: setControls, setCount: setCount } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [data, setData] = (0, $kYL7Z.useState)(null);
    const [orgName, setOrgName] = (0, $kYL7Z.useState)('');
    const [selectedUser, setSelectedUser] = (0, $kYL7Z.useState)(null);
    const [inviting, setInviting] = (0, $kYL7Z.useState)(false);
    const [fetchTrigger, setFetchTrigger] = (0, $kYL7Z.useState)(0);
    const toggleInviting = (0, $kYL7Z.useCallback)(()=>setInviting((prev)=>!prev), []);
    const columns = (0, $kYL7Z.useMemo)(()=>$989e039240e881cc$var$getUserModelColumns(setSelectedUser), []);
    (0, $kYL7Z.useEffect)(()=>{
        console.log("loading users for org", orgId);
        setLoading({
            status: true,
            location: "Loading users..."
        });
        Promise.all([
            (0, $5a9cade4af2d6a52$export$d030b7498dcede47).list(),
            $aa27e6f0058e6325$export$7652f722913b5d7.list(orgId),
            $aa27e6f0058e6325$export$7652f722913b5d7.listAdopted(orgId)
        ]).then(([orgs, usersRes, adoptedRes])=>{
            const getOrgName = (id)=>{
                const org = orgs.find((o)=>o.id === id);
                return org?.name ?? id ?? '-';
            };
            const allUsers = [
                ...(usersRes.data || []).map((u)=>({
                        ...u,
                        adopted: false
                    })),
                ...(adoptedRes.data || []).map((u)=>({
                        ...u,
                        adopted: true
                    }))
            ];
            const enriched = allUsers.map((user)=>({
                    ...user,
                    primaryOrgName: getOrgName(user.primaryOrgId),
                    ownerOrgName: getOrgName(user.ownerOrgId)
                }));
            const resolvedOrgName = getOrgName(orgId);
            console.log("Loaded " + enriched.length + " users");
            setData(enriched);
            setOrgName(resolvedOrgName);
            setLoading({
                status: false,
                location: resolvedOrgName + " users"
            });
            setNav({
                left: [
                    {
                        name: getOrgName(orgId),
                        path: "/orgs/" + orgId,
                        icon: "office",
                        subpaths: [
                            {
                                name: "Locations",
                                icon: "area-of-interest",
                                path: '/locs?org=' + orgId
                            },
                            {
                                name: "Devices",
                                icon: "desktop",
                                path: '/devs?org=' + orgId
                            },
                            {
                                name: "Cameras",
                                icon: "camera",
                                path: '/recs?org=' + orgId
                            },
                            {
                                name: "Users",
                                icon: "people",
                                path: '/orgs/' + orgId + '/users'
                            }
                        ]
                    }
                ]
            });
            setControls([
                {
                    name: "Invite User",
                    onClick: toggleInviting,
                    icon: "new-person"
                }
            ]);
            // fetch orgs for each user in background
            Promise.all(enriched.map(async (user)=>{
                try {
                    const { data: userOrgs } = await $aa27e6f0058e6325$export$7652f722913b5d7.organisationsForUser(user.id, true);
                    return {
                        ...user,
                        usersOrgs: userOrgs.map((o)=>({
                                id: o.orgId,
                                name: getOrgName(o.orgId)
                            }))
                    };
                } catch  {
                    return {
                        ...user,
                        usersOrgs: 'Unknown'
                    };
                }
            })).then((usersWithOrgs)=>setData(usersWithOrgs));
        }).catch((error)=>{
            console.error(error);
            setLoading({
                status: false,
                location: "Failed to load users..."
            });
            setData([]);
        });
    }, [
        fetchTrigger
    ]);
    const refetch = (0, $kYL7Z.useCallback)(()=>{
        setSelectedUser(null);
        setFetchTrigger((prev)=>prev + 1);
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                columns: columns,
                data: data ?? [],
                defaultSort: "fullName",
                onCount: (filtered, total)=>setCount({
                        filtered: filtered,
                        total: total
                    })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $05f420f22130a355$export$91d3ef6160facf05), {
                user: selectedUser,
                orgId: orgId,
                orgName: orgName,
                isOpen: !!selectedUser,
                onClose: ()=>setSelectedUser(null),
                onUserUpdated: refetch,
                onUserDeleted: refetch
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3735da1696086161$export$26baa3e450ed80b8), {
                isOpen: inviting,
                onClose: ()=>{
                    setInviting(false);
                    refetch();
                },
                selectedOrg: {
                    id: orgId,
                    name: orgName
                }
            })
        ]
    });
};


const $79684e8533829ba6$var$OneOrgRoute = ()=>{
    const { resid: resid } = (0, $3c99a37f3fed1403$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c1876c497f392709$export$9f25378ee5d9fb53), {
        orgid: resid
    });
};
const $79684e8533829ba6$var$ManyUsersRoute = ()=>{
    const { resid: resid } = (0, $3c99a37f3fed1403$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $989e039240e881cc$export$6b69323c17febc33), {
        orgId: resid
    });
};
const $79684e8533829ba6$export$a410a7e73c6e2728 = ()=>{
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Orgs page");
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $3c99a37f3fed1403$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0aaed139e070878b$export$4cba08f767c44a88), {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/:resid",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($79684e8533829ba6$var$OneOrgRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/:resid/users",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($79684e8533829ba6$var$ManyUsersRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $92e6067166fae914$export$3cb69218ff952ef8), {})
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");

var $cRanb = parcelRequire("cRanb");
// This file is automatically updated by the build process.
const $7c3acd9b84fb12ed$export$a4ad2735b021c132 = '1.9.0';
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $7c3acd9b84fb12ed$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7c3acd9b84fb12ed$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $7c3acd9b84fb12ed$var$MSG_REPEATED_SET_OPTIONS = (options)=>`The setOptions() function should only be called once. The options passed ` + `to the additional call (${JSON.stringify(options)}) will be ignored.`;
const $7c3acd9b84fb12ed$var$MSG_IMPORT_LIBRARY_EXISTS = (options)=>`The google.maps.importLibrary() function is already defined, and ` + `@googlemaps/js-api-loader will use the existing function instead of ` + `overwriting it. The options passed to setOptions ` + `(${JSON.stringify(options)}) will be ignored.`;
const $7c3acd9b84fb12ed$var$MSG_SET_OPTIONS_NOT_CALLED = "No options were set before calling importLibrary. Make sure to configure the loader using setOptions().";
const $7c3acd9b84fb12ed$var$MSG_SCRIPT_ELEMENT_EXISTS = "There already is a script loading the Google Maps JavaScript API, and no google.maps.importLibrary function is defined. @googlemaps/js-api-loader will proceed to bootstrap the API with the specified options, but the existing script might cause problems using the API. Make sure to remove the script loading the API.";
const $7c3acd9b84fb12ed$var$MSG_API_KEY_USED = "The 'apiKey' parameter was used in setOptions(), but 'key' is the correct parameter name. Please update your configuration.";
const $7c3acd9b84fb12ed$var$MSG_TRUSTED_TYPES_POLICY_FAILED = (policyName, error)=>`Failed to create Trusted Types policy "${policyName}": ${error instanceof Error ? error.message : String(error)}.\n\n` + `If your Content Security Policy uses "require-trusted-types-for 'script'", ` + `allow this policy with "trusted-types ${policyName} google-maps-api-loader google-maps-api#html lit-html". ` + `The "google-maps-api-loader", "lit-html", and "google-maps-api#html" policies are required for full Maps JavaScript API execution. ` + `Falling back to a string script URL.`;
const $7c3acd9b84fb12ed$var$__DEV__$1 = false;
const $7c3acd9b84fb12ed$var$logDevWarning = $7c3acd9b84fb12ed$var$__DEV__$1 ? (message)=>{
    console.warn(`[@googlemaps/js-api-loader] ${message}`);
} : ()=>{};
const $7c3acd9b84fb12ed$var$logDevNotice = $7c3acd9b84fb12ed$var$__DEV__$1 ? (message)=>{
    console.info(`[@googlemaps/js-api-loader] ${message}`);
} : ()=>{};
/*
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $7c3acd9b84fb12ed$var$TRUSTED_TYPES_POLICY_NAME = "@googlemaps/js-api-loader";
const $7c3acd9b84fb12ed$var$fallbackPolicy = {
    createScriptURL: (url)=>url
};
let $7c3acd9b84fb12ed$var$policy;
/*
 * Tries to create a Trusted Types policy when supported. Falls back to a string passthrough
 * when Trusted Types is unsupported, blocked by CSP, or already registered.
 */ function $7c3acd9b84fb12ed$var$getPolicy() {
    if ($7c3acd9b84fb12ed$var$policy) return $7c3acd9b84fb12ed$var$policy;
    const trustedTypes = globalThis.trustedTypes;
    if (!trustedTypes) {
        $7c3acd9b84fb12ed$var$policy = $7c3acd9b84fb12ed$var$fallbackPolicy;
        return $7c3acd9b84fb12ed$var$policy;
    }
    try {
        $7c3acd9b84fb12ed$var$policy = trustedTypes.createPolicy($7c3acd9b84fb12ed$var$TRUSTED_TYPES_POLICY_NAME, {
            createScriptURL: (url)=>url
        });
    } catch (e) {
        $7c3acd9b84fb12ed$var$logDevWarning($7c3acd9b84fb12ed$var$MSG_TRUSTED_TYPES_POLICY_FAILED($7c3acd9b84fb12ed$var$TRUSTED_TYPES_POLICY_NAME, e));
        $7c3acd9b84fb12ed$var$policy = $7c3acd9b84fb12ed$var$fallbackPolicy;
    }
    return $7c3acd9b84fb12ed$var$policy;
}
function $7c3acd9b84fb12ed$var$setScriptSrc(script, src) {
    script.src = $7c3acd9b84fb12ed$var$getPolicy().createScriptURL(src);
}
/*
 * Copyright 2025 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */ const $7c3acd9b84fb12ed$var$bootstrap = (bootstrapParams)=>{
    var bootstrapPromise;
    var script;
    var bootstrapParamsKey;
    var PRODUCT_NAME = "The Google Maps JavaScript API";
    var GOOGLE = "google";
    var IMPORT_API_NAME = "importLibrary";
    var PENDING_BOOTSTRAP_KEY = "__ib__";
    var doc = document;
    var global_ = window;
    var google_ = global_[GOOGLE] || (global_[GOOGLE] = {});
    var namespace = google_.maps || (google_.maps = {});
    var libraries = new Set();
    var searchParams = new URLSearchParams();
    var triggerBootstrap = ()=>bootstrapPromise || (bootstrapPromise = new Promise(async (resolve, reject)=>{
            await (script = doc.createElement("script"));
            searchParams.set("libraries", [
                ...libraries
            ] + "");
            for(bootstrapParamsKey in bootstrapParams)searchParams.set(bootstrapParamsKey.replace(/[A-Z]/g, (g)=>"_" + g[0].toLowerCase()), bootstrapParams[bootstrapParamsKey]);
            searchParams.set("callback", GOOGLE + ".maps." + PENDING_BOOTSTRAP_KEY);
            $7c3acd9b84fb12ed$var$setScriptSrc(script, "https://maps.googleapis.com/maps/api/js?" + searchParams);
            namespace[PENDING_BOOTSTRAP_KEY] = resolve;
            script.onerror = ()=>bootstrapPromise = reject(Error(PRODUCT_NAME + " could not load."));
            script.nonce = doc.querySelector("script[nonce]")?.nonce || "";
            doc.head.append(script);
        }));
    namespace[IMPORT_API_NAME] ? console.warn(PRODUCT_NAME + " only loads once. Ignoring:", bootstrapParams) : namespace[IMPORT_API_NAME] = (libraryName, ...args)=>libraries.add(libraryName) && triggerBootstrap().then(()=>namespace[IMPORT_API_NAME](libraryName, ...args));
};
/*
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $7c3acd9b84fb12ed$var$__DEV__ = false;
let $7c3acd9b84fb12ed$var$setOptionsWasCalled_ = false;
/**
 * Sets the options for the Maps JavaScript API.
 *
 * Has to be called before any library is loaded.
 *
 * See https://developers.google.com/maps/documentation/javascript/load-maps-js-api#required_parameters
 * for the full documentation of available options.
 *
 * @param options The options to set.
 */ function $7c3acd9b84fb12ed$var$setOptions(options) {
    if ($7c3acd9b84fb12ed$var$setOptionsWasCalled_) {
        $7c3acd9b84fb12ed$var$logDevWarning($7c3acd9b84fb12ed$var$MSG_REPEATED_SET_OPTIONS(options));
        return;
    }
    if (options.apiKey) {
        $7c3acd9b84fb12ed$var$logDevWarning($7c3acd9b84fb12ed$var$MSG_API_KEY_USED);
        if (!options.key) options.key = options.apiKey;
    }
    $7c3acd9b84fb12ed$var$installImportLibrary_(options);
    $7c3acd9b84fb12ed$var$setOptionsWasCalled_ = true;
}
async function $7c3acd9b84fb12ed$var$importLibrary(libraryName) {
    if (!$7c3acd9b84fb12ed$var$setOptionsWasCalled_) $7c3acd9b84fb12ed$var$logDevWarning($7c3acd9b84fb12ed$var$MSG_SET_OPTIONS_NOT_CALLED);
    if (!window?.google?.maps?.importLibrary) throw new Error("google.maps.importLibrary is not installed.");
    return await google.maps.importLibrary(libraryName);
}
/**
 * The installImportLibrary_ function makes sure that a usable version of the
 * `google.maps.importLibrary` function exists.
 */ function $7c3acd9b84fb12ed$var$installImportLibrary_(options) {
    const importLibraryExists = Boolean(window.google?.maps?.importLibrary);
    if (importLibraryExists) $7c3acd9b84fb12ed$var$logDevNotice($7c3acd9b84fb12ed$var$MSG_IMPORT_LIBRARY_EXISTS(options));
    else if ($7c3acd9b84fb12ed$var$__DEV__) {
        const scriptEl = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
        if (scriptEl) $7c3acd9b84fb12ed$var$logDevWarning($7c3acd9b84fb12ed$var$MSG_SCRIPT_ELEMENT_EXISTS);
    }
    // If the google.maps.importLibrary function already exists, bootstrap()
    // won't do anything, so we won't call it
    if (!importLibraryExists) $7c3acd9b84fb12ed$var$bootstrap(options);
}
const $7c3acd9b84fb12ed$export$647ae9f9d14aeffc = {
    NOT_LOADED: 'NOT_LOADED',
    LOADING: 'LOADING',
    LOADED: 'LOADED',
    FAILED: 'FAILED',
    AUTH_FAILURE: 'AUTH_FAILURE'
};
const $7c3acd9b84fb12ed$var$DEFAULT_SOLUTION_CHANNEL = 'GMP_visgl_rgmlibrary_v1_default';
const $7c3acd9b84fb12ed$var$DEFAULT_INTERNAL_USAGE_ATTRIBUTION_IDS = [
    `gmp_visgl_reactgooglemaps_v${$7c3acd9b84fb12ed$export$a4ad2735b021c132}`
];
const $7c3acd9b84fb12ed$export$84e9974bcf67d1d = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext(null);
// loading the Maps JavaScript API can only happen once in the runtime, so these
// variables are kept at the module level.
let $7c3acd9b84fb12ed$var$loadingStatus = $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.NOT_LOADED;
let $7c3acd9b84fb12ed$var$serializedApiParams;
const $7c3acd9b84fb12ed$var$listeners = new Set();
/**
 * Called to update the local status and notify the listeners for any mounted
 * components.
 * @internal
 */ function $7c3acd9b84fb12ed$var$updateLoadingStatus(status) {
    if (status === $7c3acd9b84fb12ed$var$loadingStatus) return;
    $7c3acd9b84fb12ed$var$loadingStatus = status;
    $7c3acd9b84fb12ed$var$listeners.forEach((listener)=>listener($7c3acd9b84fb12ed$var$loadingStatus));
}
/**
 * Local hook to set up the map-instance management context.
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMapInstances() {
    const [mapInstances, setMapInstances] = (0, $kYL7Z.useState)({});
    const addMapInstance = (mapInstance, id = 'default')=>{
        setMapInstances((instances)=>Object.assign(Object.assign({}, instances), {
                [id]: mapInstance
            }));
    };
    const removeMapInstance = (id = 'default')=>{
        setMapInstances((_a)=>{
            var _b = id;
            _a[_b];
            var remaining = $7c3acd9b84fb12ed$var$__rest(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return remaining;
        });
    };
    const clearMapInstances = ()=>{
        setMapInstances({});
    };
    return {
        mapInstances: mapInstances,
        addMapInstance: addMapInstance,
        removeMapInstance: removeMapInstance,
        clearMapInstances: clearMapInstances
    };
}
/**
 * local hook to set up the 3D map-instance management context.
 */ function $7c3acd9b84fb12ed$var$useMap3DInstances() {
    const [map3dInstances, setMap3DInstances] = (0, $kYL7Z.useState)({});
    const addMap3DInstance = (map3dInstance, id = 'default')=>{
        setMap3DInstances((instances)=>Object.assign(Object.assign({}, instances), {
                [id]: map3dInstance
            }));
    };
    const removeMap3DInstance = (id = 'default')=>{
        setMap3DInstances((_a)=>{
            var _b = id;
            _a[_b];
            var remaining = $7c3acd9b84fb12ed$var$__rest(_a, [
                typeof _b === "symbol" ? _b : _b + ""
            ]);
            return remaining;
        });
    };
    const clearMap3DInstances = ()=>{
        setMap3DInstances({});
    };
    return {
        map3dInstances: map3dInstances,
        addMap3DInstance: addMap3DInstance,
        removeMap3DInstance: removeMap3DInstance,
        clearMap3DInstances: clearMap3DInstances
    };
}
/**
 * Local hook to handle the loading of the maps API.
 * @internal
 */ function $7c3acd9b84fb12ed$var$useGoogleMapsApiLoader(props) {
    const { onLoad: onLoad, onError: onError, apiKey: apiKey, version: version, libraries: libraries = [], region: region, language: language, authReferrerPolicy: authReferrerPolicy, channel: channel, solutionChannel: solutionChannel, fetchAppCheckToken: fetchAppCheckToken } = props;
    const [status, setStatus] = (0, $kYL7Z.useState)($7c3acd9b84fb12ed$var$loadingStatus);
    const [loadedLibraries, addLoadedLibrary] = (0, $kYL7Z.useReducer)((loadedLibraries, action)=>{
        return loadedLibraries[action.name] ? loadedLibraries : Object.assign(Object.assign({}, loadedLibraries), {
            [action.name]: action.value
        });
    }, {});
    const currentSerializedParams = (0, $kYL7Z.useMemo)(()=>{
        const params = {
            apiKey: apiKey,
            version: version,
            libraries: libraries.join(','),
            region: region,
            language: language,
            authReferrerPolicy: authReferrerPolicy,
            channel: channel,
            solutionChannel: solutionChannel
        };
        return JSON.stringify(params);
    }, [
        apiKey,
        version,
        libraries,
        region,
        language,
        authReferrerPolicy,
        channel,
        solutionChannel
    ]);
    const importLibraryCallback = (0, $kYL7Z.useCallback)((name)=>$7c3acd9b84fb12ed$var$__awaiter(this, void 0, void 0, function*() {
            if (loadedLibraries[name]) return loadedLibraries[name];
            const res = yield $7c3acd9b84fb12ed$var$importLibrary(name);
            addLoadedLibrary({
                name: name,
                value: res
            });
            return res;
        }), [
        loadedLibraries
    ]);
    // effect: we want to get notified of global loading-status changes
    (0, $kYL7Z.useEffect)(()=>{
        $7c3acd9b84fb12ed$var$listeners.add(setStatus);
        // sync component state on mount (shouldn't be different from the initial state)
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional synchronization of status from singleton
        setStatus($7c3acd9b84fb12ed$var$loadingStatus);
        return ()=>{
            $7c3acd9b84fb12ed$var$listeners.delete(setStatus);
        };
    }, []);
    // effect: set and store options
    (0, $kYL7Z.useEffect)(()=>{
        (()=>$7c3acd9b84fb12ed$var$__awaiter(this, void 0, void 0, function*() {
                var _a, _b;
                try {
                    // This indicates that the API has been loaded with a different set of parameters.
                    // While this is not blocking, it's not recommended and we should warn the user.
                    if ($7c3acd9b84fb12ed$var$serializedApiParams && $7c3acd9b84fb12ed$var$serializedApiParams !== currentSerializedParams) console.warn(`The Google Maps JavaScript API has already been loaded with different parameters. ` + `The new parameters will be ignored. If you need to use different parameters, ` + `please refresh the page.`);
                    const librariesToLoad = [
                        'core',
                        'maps',
                        ...libraries
                    ];
                    const options = Object.fromEntries(Object.entries({
                        key: apiKey,
                        v: version,
                        libraries: libraries,
                        region: region,
                        language: language,
                        authReferrerPolicy: authReferrerPolicy
                    }).filter(([, value])=>value !== undefined));
                    if (channel !== undefined && channel >= 0 && channel <= 999) options.channel = String(channel);
                    // solution-channel: when undefined, use the default; otherwise use
                    // an explicit value.
                    if (solutionChannel === undefined) options.solutionChannel = $7c3acd9b84fb12ed$var$DEFAULT_SOLUTION_CHANNEL;
                    else if (solutionChannel !== '') options.solutionChannel = solutionChannel;
                    // If the google.maps namespace is already available, the API has been loaded externally.
                    if ((_b = (_a = window.google) === null || _a === void 0 ? void 0 : _a.maps) === null || _b === void 0 ? void 0 : _b.importLibrary) {
                        const shouldUpdateLoadingStatus = !$7c3acd9b84fb12ed$var$serializedApiParams;
                        if (shouldUpdateLoadingStatus) {
                            $7c3acd9b84fb12ed$var$serializedApiParams = currentSerializedParams;
                            $7c3acd9b84fb12ed$var$setOptions(options);
                        }
                        yield Promise.all(librariesToLoad.map((name)=>importLibraryCallback(name)));
                        if (shouldUpdateLoadingStatus) $7c3acd9b84fb12ed$var$updateLoadingStatus($7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADED);
                        if (onLoad) onLoad();
                        return;
                    }
                    // Abort if the API is already loading or has been loaded.
                    if ($7c3acd9b84fb12ed$var$loadingStatus === $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADING || $7c3acd9b84fb12ed$var$loadingStatus === $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADED) {
                        if ($7c3acd9b84fb12ed$var$loadingStatus === $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADED && onLoad) onLoad();
                        return;
                    }
                    $7c3acd9b84fb12ed$var$serializedApiParams = currentSerializedParams;
                    $7c3acd9b84fb12ed$var$updateLoadingStatus($7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADING);
                    // this will actually trigger loading the maps API
                    $7c3acd9b84fb12ed$var$setOptions(options);
                    // wait for all requested libraries (inluding 'core' and 'maps') to
                    // finish loading
                    yield Promise.all(librariesToLoad.map((name)=>importLibraryCallback(name)));
                    $7c3acd9b84fb12ed$var$updateLoadingStatus($7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADED);
                    if (onLoad) onLoad();
                } catch (error) {
                    $7c3acd9b84fb12ed$var$updateLoadingStatus($7c3acd9b84fb12ed$export$647ae9f9d14aeffc.FAILED);
                    if (onError) onError(error);
                    else console.error('The Google Maps JavaScript API failed to load.', error);
                }
            }))();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        currentSerializedParams,
        onLoad,
        onError,
        importLibraryCallback,
        libraries
    ]);
    // set the fetchAppCheckToken if provided
    (0, $kYL7Z.useEffect)(()=>{
        if (status !== $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADED) return;
        const settings = google.maps.Settings.getInstance();
        if (fetchAppCheckToken) settings.fetchAppCheckToken = fetchAppCheckToken;
    }, [
        status,
        fetchAppCheckToken
    ]);
    return {
        status: status,
        loadedLibraries: loadedLibraries,
        importLibrary: importLibraryCallback
    };
}
function $7c3acd9b84fb12ed$var$useInternalUsageAttributionIds(props) {
    return (0, $kYL7Z.useMemo)(()=>props.disableUsageAttribution ? null : $7c3acd9b84fb12ed$var$DEFAULT_INTERNAL_USAGE_ATTRIBUTION_IDS, [
        props.disableUsageAttribution
    ]);
}
/**
 * Component to wrap the components from this library and load the Google Maps JavaScript API
 */ const $7c3acd9b84fb12ed$export$434374b2a40d237 = (props)=>{
    const { children: children } = props, loaderProps = $7c3acd9b84fb12ed$var$__rest(props, [
        "children"
    ]);
    const { mapInstances: mapInstances, addMapInstance: addMapInstance, removeMapInstance: removeMapInstance, clearMapInstances: clearMapInstances } = $7c3acd9b84fb12ed$var$useMapInstances();
    const { map3dInstances: map3dInstances, addMap3DInstance: addMap3DInstance, removeMap3DInstance: removeMap3DInstance, clearMap3DInstances: clearMap3DInstances } = $7c3acd9b84fb12ed$var$useMap3DInstances();
    const { status: status, loadedLibraries: loadedLibraries, importLibrary: importLibrary } = $7c3acd9b84fb12ed$var$useGoogleMapsApiLoader(loaderProps);
    const internalUsageAttributionIds = $7c3acd9b84fb12ed$var$useInternalUsageAttributionIds(loaderProps);
    const contextValue = (0, $kYL7Z.useMemo)(()=>({
            mapInstances: mapInstances,
            addMapInstance: addMapInstance,
            removeMapInstance: removeMapInstance,
            clearMapInstances: clearMapInstances,
            map3dInstances: map3dInstances,
            addMap3DInstance: addMap3DInstance,
            removeMap3DInstance: removeMap3DInstance,
            clearMap3DInstances: clearMap3DInstances,
            status: status,
            loadedLibraries: loadedLibraries,
            importLibrary: importLibrary,
            internalUsageAttributionIds: internalUsageAttributionIds
        }), [
        mapInstances,
        addMapInstance,
        removeMapInstance,
        clearMapInstances,
        map3dInstances,
        addMap3DInstance,
        removeMap3DInstance,
        clearMap3DInstances,
        status,
        loadedLibraries,
        importLibrary,
        internalUsageAttributionIds
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$export$84e9974bcf67d1d.Provider, {
        value: contextValue
    }, children);
};
/**
 * @internal
 * Resets module-level state for testing purposes only.
 * This should never be used in production code.
 */ function $7c3acd9b84fb12ed$export$3672cbbeb4da7cb1() {
    $7c3acd9b84fb12ed$var$loadingStatus = $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.NOT_LOADED;
    $7c3acd9b84fb12ed$var$serializedApiParams = undefined;
    $7c3acd9b84fb12ed$var$listeners.clear();
}
/**
 * Sets up effects to bind event-handlers for all event-props in MapEventProps.
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMapEvents(map, props) {
    // note: calling a useEffect hook from within a loop is prohibited by the
    // rules of hooks, but it's ok here since it's unconditional and the number
    // and order of iterations is always strictly the same.
    // (see https://legacy.reactjs.org/docs/hooks-rules.html)
    for (const propName of $7c3acd9b84fb12ed$var$eventPropNames){
        // fixme: this cast is essentially a 'trust me, bro' for typescript, but
        //   a proper solution seems way too complicated right now
        const handler = props[propName];
        const eventType = $7c3acd9b84fb12ed$var$propNameToEventType[propName];
        // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $kYL7Z.useEffect)(()=>{
            if (!map) return;
            if (!handler) return;
            const listener = google.maps.event.addListener(map, eventType, (ev)=>{
                handler($7c3acd9b84fb12ed$var$createMapEvent(eventType, map, ev));
            });
            return ()=>listener.remove();
        }, [
            map,
            eventType,
            handler
        ]);
    }
}
/**
 * Create the wrapped map-events used for the event-props.
 * @param type the event type as it is specified to the maps api
 * @param map the map instance the event originates from
 * @param srcEvent the source-event if there is one.
 */ function $7c3acd9b84fb12ed$var$createMapEvent(type, map, srcEvent) {
    var _a;
    const ev = {
        type: type,
        map: map,
        detail: {},
        stoppable: false,
        stop: ()=>{}
    };
    if ($7c3acd9b84fb12ed$var$cameraEventTypes.includes(type)) {
        const camEvent = ev;
        const center = map.getCenter();
        const zoom = map.getZoom();
        const heading = map.getHeading() || 0;
        const tilt = map.getTilt() || 0;
        const bounds = map.getBounds();
        if (!center || !bounds || !Number.isFinite(zoom)) console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new");
        camEvent.detail = {
            center: (center === null || center === void 0 ? void 0 : center.toJSON()) || {
                lat: 0,
                lng: 0
            },
            zoom: zoom || 0,
            heading: heading,
            tilt: tilt,
            bounds: (bounds === null || bounds === void 0 ? void 0 : bounds.toJSON()) || {
                north: 90,
                east: 180,
                south: -90,
                west: -180
            }
        };
        return camEvent;
    } else if ($7c3acd9b84fb12ed$var$mouseEventTypes.includes(type)) {
        if (!srcEvent) throw new Error('[createEvent] mouse events must provide a srcEvent');
        const mouseEvent = ev;
        mouseEvent.domEvent = srcEvent.domEvent;
        mouseEvent.stoppable = true;
        mouseEvent.stop = ()=>srcEvent.stop();
        mouseEvent.detail = {
            latLng: ((_a = srcEvent.latLng) === null || _a === void 0 ? void 0 : _a.toJSON()) || null,
            placeId: srcEvent.placeId
        };
        return mouseEvent;
    }
    return ev;
}
/**
 * maps the camelCased names of event-props to the corresponding event-types
 * used in the maps API.
 */ const $7c3acd9b84fb12ed$var$propNameToEventType = {
    onBoundsChanged: 'bounds_changed',
    onCenterChanged: 'center_changed',
    onClick: 'click',
    onContextmenu: 'contextmenu',
    onDblclick: 'dblclick',
    onDrag: 'drag',
    onDragend: 'dragend',
    onDragstart: 'dragstart',
    onHeadingChanged: 'heading_changed',
    onIdle: 'idle',
    onIsFractionalZoomEnabledChanged: 'isfractionalzoomenabled_changed',
    onMapCapabilitiesChanged: 'mapcapabilities_changed',
    onMapTypeIdChanged: 'maptypeid_changed',
    onMousemove: 'mousemove',
    onMouseout: 'mouseout',
    onMouseover: 'mouseover',
    onProjectionChanged: 'projection_changed',
    onRenderingTypeChanged: 'renderingtype_changed',
    onTilesLoaded: 'tilesloaded',
    onTiltChanged: 'tilt_changed',
    onZoomChanged: 'zoom_changed',
    // note: onCameraChanged is an alias for the bounds_changed event,
    // since that is going to be fired in every situation where the camera is
    // updated.
    onCameraChanged: 'bounds_changed'
};
const $7c3acd9b84fb12ed$var$cameraEventTypes = [
    'bounds_changed',
    'center_changed',
    'heading_changed',
    'tilt_changed',
    'zoom_changed'
];
const $7c3acd9b84fb12ed$var$mouseEventTypes = [
    'click',
    'contextmenu',
    'dblclick',
    'mousemove',
    'mouseout',
    'mouseover'
];
const $7c3acd9b84fb12ed$var$eventPropNames = Object.keys($7c3acd9b84fb12ed$var$propNameToEventType);
/* eslint-disable react-hooks/refs */ // refs should not be used in render because changes to refs won't
// trigger a re-render, making them unreliable for holding state.
// In this case though, that is exactly what we want.
function $7c3acd9b84fb12ed$var$useMemoized(value, isEqual) {
    const ref = (0, $kYL7Z.useRef)(value);
    if (!isEqual(value, ref.current)) ref.current = value;
    return ref.current;
}
function $7c3acd9b84fb12ed$var$useCustomCompareEffect(effect, dependencies, isEqual) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $kYL7Z.useEffect)(effect, [
        $7c3acd9b84fb12ed$var$useMemoized(dependencies, isEqual)
    ]);
}
const { getOwnPropertyNames: $7c3acd9b84fb12ed$var$getOwnPropertyNames, getOwnPropertySymbols: $7c3acd9b84fb12ed$var$getOwnPropertySymbols } = Object;
// eslint-disable-next-line @typescript-eslint/unbound-method
const { hasOwnProperty: $7c3acd9b84fb12ed$var$hasOwnProperty } = Object.prototype;
/**
 * Combine two comparators into a single comparators.
 */ function $7c3acd9b84fb12ed$var$combineComparators(comparatorA, comparatorB) {
    return function isEqual(a, b, state) {
        return comparatorA(a, b, state) && comparatorB(a, b, state);
    };
}
/**
 * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
 * for circular references to be safely included in the comparison without creating
 * stack overflows.
 */ function $7c3acd9b84fb12ed$var$createIsCircular(areItemsEqual) {
    return function isCircular(a, b, state) {
        if (!a || !b || typeof a !== 'object' || typeof b !== 'object') return areItemsEqual(a, b, state);
        const { cache: cache } = state;
        const cachedA = cache.get(a);
        const cachedB = cache.get(b);
        if (cachedA && cachedB) return cachedA === b && cachedB === a;
        cache.set(a, b);
        cache.set(b, a);
        const result = areItemsEqual(a, b, state);
        cache.delete(a);
        cache.delete(b);
        return result;
    };
}
/**
 * Get the properties to strictly examine, which include both own properties that are
 * not enumerable and symbol properties.
 */ function $7c3acd9b84fb12ed$var$getStrictProperties(object) {
    return $7c3acd9b84fb12ed$var$getOwnPropertyNames(object).concat($7c3acd9b84fb12ed$var$getOwnPropertySymbols(object));
}
/**
 * Whether the object contains the property passed as an own property.
 */ const $7c3acd9b84fb12ed$var$hasOwn = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.hasOwn || ((object, property)=>$7c3acd9b84fb12ed$var$hasOwnProperty.call(object, property));
const $7c3acd9b84fb12ed$var$PREACT_VNODE = '__v';
const $7c3acd9b84fb12ed$var$PREACT_OWNER = '__o';
const $7c3acd9b84fb12ed$var$REACT_OWNER = '_owner';
const { getOwnPropertyDescriptor: $7c3acd9b84fb12ed$var$getOwnPropertyDescriptor, keys: $7c3acd9b84fb12ed$var$keys } = Object;
/**
 * Whether the values passed are equal based on a [SameValue](https://262.ecma-international.org/7.0/#sec-samevalue) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`) or both are `NaN`.
 *
 * @note
 * When available in the environment, this is just a re-export of the global
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is) method.
 */ const $7c3acd9b84fb12ed$var$sameValueEqual = // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
Object.is || function sameValueEqual(a, b) {
    return a === b ? a !== 0 || 1 / a === 1 / b : a !== a && b !== b;
};
/**
 * Whether the values passed are equal based on a
 * [Strict Equality Comparison](https://262.ecma-international.org/7.0/#sec-strict-equality-comparison) basis.
 * Simplified, this maps to if the two values are referentially equal to one another (`a === b`).
 *
 * @note
 * This is mainly available as a convenience function, such as being a default when a function to determine equality between
 * two objects is used.
 */ function $7c3acd9b84fb12ed$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Whether the array buffers are equal in value.
 */ function $7c3acd9b84fb12ed$var$areArrayBuffersEqual(a, b) {
    return a.byteLength === b.byteLength && $7c3acd9b84fb12ed$var$areTypedArraysEqual(new Uint8Array(a), new Uint8Array(b));
}
/**
 * Whether the arrays are equal in value.
 */ function $7c3acd9b84fb12ed$var$areArraysEqual(a, b, state) {
    let index = a.length;
    if (b.length !== index) return false;
    while(index-- > 0){
        if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
    }
    return true;
}
/**
 * Whether the dataviews are equal in value.
 */ function $7c3acd9b84fb12ed$var$areDataViewsEqual(a, b) {
    return a.byteLength === b.byteLength && $7c3acd9b84fb12ed$var$areTypedArraysEqual(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength));
}
/**
 * Whether the dates passed are equal in value.
 */ function $7c3acd9b84fb12ed$var$areDatesEqual(a, b) {
    return $7c3acd9b84fb12ed$var$sameValueEqual(a.getTime(), b.getTime());
}
/**
 * Whether the errors passed are equal in value.
 */ function $7c3acd9b84fb12ed$var$areErrorsEqual(a, b) {
    return a.name === b.name && a.message === b.message && a.cause === b.cause && a.stack === b.stack;
}
/**
 * Whether the `Map`s are equal in value.
 */ function $7c3acd9b84fb12ed$var$areMapsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Array(size);
    const aIterable = a.entries();
    let aResult;
    let bResult;
    let index = 0;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.entries();
        let hasMatch = false;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (matchedIndices[matchIndex]) {
                matchIndex++;
                continue;
            }
            const aEntry = aResult.value;
            const bEntry = bResult.value;
            if (state.equals(aEntry[0], bEntry[0], index, matchIndex, a, b, state) && state.equals(aEntry[1], bEntry[1], aEntry[0], bEntry[0], a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
        index++;
    }
    return true;
}
/**
 * Whether the objects are equal in value.
 */ function $7c3acd9b84fb12ed$var$areObjectsEqual(a, b, state) {
    const properties = $7c3acd9b84fb12ed$var$keys(a);
    let index = properties.length;
    if ($7c3acd9b84fb12ed$var$keys(b).length !== index) return false;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        if (!$7c3acd9b84fb12ed$var$isPropertyEqual(a, b, state, properties[index])) return false;
    }
    return true;
}
/**
 * Whether the objects are equal in value with strict property checking.
 */ function $7c3acd9b84fb12ed$var$areObjectsEqualStrict(a, b, state) {
    const properties = $7c3acd9b84fb12ed$var$getStrictProperties(a);
    let index = properties.length;
    if ($7c3acd9b84fb12ed$var$getStrictProperties(b).length !== index) return false;
    let property;
    let descriptorA;
    let descriptorB;
    // Decrementing `while` showed faster results than either incrementing or
    // decrementing `for` loop and than an incrementing `while` loop. Declarative
    // methods like `some` / `every` were not used to avoid incurring the garbage
    // cost of anonymous callbacks.
    while(index-- > 0){
        property = properties[index];
        if (!$7c3acd9b84fb12ed$var$isPropertyEqual(a, b, state, property)) return false;
        descriptorA = $7c3acd9b84fb12ed$var$getOwnPropertyDescriptor(a, property);
        descriptorB = $7c3acd9b84fb12ed$var$getOwnPropertyDescriptor(b, property);
        if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
    }
    return true;
}
/**
 * Whether the primitive wrappers passed are equal in value.
 */ function $7c3acd9b84fb12ed$var$arePrimitiveWrappersEqual(a, b) {
    return $7c3acd9b84fb12ed$var$sameValueEqual(a.valueOf(), b.valueOf());
}
/**
 * Whether the regexps passed are equal in value.
 */ function $7c3acd9b84fb12ed$var$areRegExpsEqual(a, b) {
    return a.source === b.source && a.flags === b.flags;
}
/**
 * Whether the `Set`s are equal in value.
 */ function $7c3acd9b84fb12ed$var$areSetsEqual(a, b, state) {
    const size = a.size;
    if (size !== b.size) return false;
    if (!size) return true;
    const matchedIndices = new Array(size);
    const aIterable = a.values();
    let aResult;
    let bResult;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    while(aResult = aIterable.next()){
        if (aResult.done) break;
        const bIterable = b.values();
        let hasMatch = false;
        let matchIndex = 0;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        while(bResult = bIterable.next()){
            if (bResult.done) break;
            if (!matchedIndices[matchIndex] && state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state)) {
                hasMatch = matchedIndices[matchIndex] = true;
                break;
            }
            matchIndex++;
        }
        if (!hasMatch) return false;
    }
    return true;
}
/**
 * Whether the TypedArray instances are equal in value.
 */ function $7c3acd9b84fb12ed$var$areTypedArraysEqual(a, b) {
    let index = a.byteLength;
    if (b.byteLength !== index || a.byteOffset !== b.byteOffset) return false;
    while(index-- > 0){
        if (a[index] !== b[index]) return false;
    }
    return true;
}
/**
 * Whether the URL instances are equal in value.
 */ function $7c3acd9b84fb12ed$var$areUrlsEqual(a, b) {
    return a.hostname === b.hostname && a.pathname === b.pathname && a.protocol === b.protocol && a.port === b.port && a.hash === b.hash && a.username === b.username && a.password === b.password;
}
function $7c3acd9b84fb12ed$var$isPropertyEqual(a, b, state, property) {
    if ((property === $7c3acd9b84fb12ed$var$REACT_OWNER || property === $7c3acd9b84fb12ed$var$PREACT_OWNER || property === $7c3acd9b84fb12ed$var$PREACT_VNODE) && (a.$$typeof || b.$$typeof)) return true;
    return $7c3acd9b84fb12ed$var$hasOwn(b, property) && state.equals(a[property], b[property], property, property, a, b, state);
}
// eslint-disable-next-line @typescript-eslint/unbound-method
const $7c3acd9b84fb12ed$var$toString = Object.prototype.toString;
/**
 * Create a comparator method based on the type-specific equality comparators passed.
 */ function $7c3acd9b84fb12ed$var$createEqualityComparator(config) {
    const supportedComparatorMap = $7c3acd9b84fb12ed$var$createSupportedComparatorMap(config);
    const { areArraysEqual: areArraysEqual, areDatesEqual: areDatesEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, getUnsupportedCustomComparator: getUnsupportedCustomComparator } = config;
    /**
     * compare the value of the two objects and return true if they are equivalent in values
     */ return function comparator(a, b, state) {
        // If the items are strictly equal, no need to do a value comparison.
        if (a === b) return true;
        // If either of the items are nullish and fail the strictly equal check
        // above, then they must be unequal.
        if (a == null || b == null) return false;
        const type = typeof a;
        if (type !== typeof b) return false;
        if (type !== 'object') {
            if (type === 'number' || type === 'bigint') return areNumbersEqual(a, b, state);
            if (type === 'function') return areFunctionsEqual(a, b, state);
            // If a primitive value that is not strictly equal, it must be unequal.
            return false;
        }
        const constructor = a.constructor;
        // Checks are listed in order of commonality of use-case:
        //   1. Common complex object types (plain object, array)
        //   2. Common data values (date, regexp)
        //   3. Less-common complex object types (map, set)
        //   4. Less-common data values (promise, primitive wrappers)
        // Inherently this is both subjective and assumptive, however
        // when reviewing comparable libraries in the wild this order
        // appears to be generally consistent.
        // Constructors should match, otherwise there is potential for false positives
        // between class and subclass or custom object and POJO.
        if (constructor !== b.constructor) return false;
        // Try to fast-path equality checks for other complex object types in the
        // same realm to avoid capturing the string tag. Strict equality is used
        // instead of `instanceof` because it is more performant for the common
        // use-case. If someone is creating a subclass from a native class, it will be
        // handled with the string tag comparison.
        if (constructor === Object) return areObjectsEqual(a, b, state);
        if (constructor === Array) return areArraysEqual(a, b, state);
        if (constructor === Date) return areDatesEqual(a, b, state);
        if (constructor === RegExp) return areRegExpsEqual(a, b, state);
        if (constructor === Map) return areMapsEqual(a, b, state);
        if (constructor === Set) return areSetsEqual(a, b, state);
        if (constructor === Promise) // Avoid tag checks for promise values, since we know if they are not referentially equal
        // then they are not equal.
        return false;
        // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
        // the string tag or doing an `instanceof` in edge cases.
        if (Array.isArray(a)) return areArraysEqual(a, b, state);
        // Since this is a custom object, capture the string tag to determining its type.
        // This is reasonably performant in modern environments like v8 and SpiderMonkey.
        const tag = $7c3acd9b84fb12ed$var$toString.call(a);
        const supportedComparator = supportedComparatorMap[tag];
        if (supportedComparator) return supportedComparator(a, b, state);
        const unsupportedCustomComparator = getUnsupportedCustomComparator && getUnsupportedCustomComparator(a, b, state, tag);
        if (unsupportedCustomComparator) return unsupportedCustomComparator(a, b, state);
        // If not matching any tags that require a specific type of comparison, then we hard-code false because
        // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
        //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
        //     comparison that can be made.
        //   - For types that can be introspected but do not have an objective definition of what
        //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
        // In all cases, these decisions should be reevaluated based on changes to the language and
        // common development practices.
        return false;
    };
}
/**
 * Create the configuration object used for building comparators.
 */ function $7c3acd9b84fb12ed$var$createEqualityComparatorConfig({ circular: circular, createCustomConfig: createCustomConfig, strict: strict }) {
    let config = {
        areArrayBuffersEqual: $7c3acd9b84fb12ed$var$areArrayBuffersEqual,
        areArraysEqual: strict ? $7c3acd9b84fb12ed$var$areObjectsEqualStrict : $7c3acd9b84fb12ed$var$areArraysEqual,
        areDataViewsEqual: $7c3acd9b84fb12ed$var$areDataViewsEqual,
        areDatesEqual: $7c3acd9b84fb12ed$var$areDatesEqual,
        areErrorsEqual: $7c3acd9b84fb12ed$var$areErrorsEqual,
        areFunctionsEqual: $7c3acd9b84fb12ed$var$strictEqual,
        areMapsEqual: strict ? $7c3acd9b84fb12ed$var$combineComparators($7c3acd9b84fb12ed$var$areMapsEqual, $7c3acd9b84fb12ed$var$areObjectsEqualStrict) : $7c3acd9b84fb12ed$var$areMapsEqual,
        areNumbersEqual: $7c3acd9b84fb12ed$var$sameValueEqual,
        areObjectsEqual: strict ? $7c3acd9b84fb12ed$var$areObjectsEqualStrict : $7c3acd9b84fb12ed$var$areObjectsEqual,
        arePrimitiveWrappersEqual: $7c3acd9b84fb12ed$var$arePrimitiveWrappersEqual,
        areRegExpsEqual: $7c3acd9b84fb12ed$var$areRegExpsEqual,
        areSetsEqual: strict ? $7c3acd9b84fb12ed$var$combineComparators($7c3acd9b84fb12ed$var$areSetsEqual, $7c3acd9b84fb12ed$var$areObjectsEqualStrict) : $7c3acd9b84fb12ed$var$areSetsEqual,
        areTypedArraysEqual: strict ? $7c3acd9b84fb12ed$var$combineComparators($7c3acd9b84fb12ed$var$areTypedArraysEqual, $7c3acd9b84fb12ed$var$areObjectsEqualStrict) : $7c3acd9b84fb12ed$var$areTypedArraysEqual,
        areUrlsEqual: $7c3acd9b84fb12ed$var$areUrlsEqual,
        getUnsupportedCustomComparator: undefined
    };
    if (createCustomConfig) config = Object.assign({}, config, createCustomConfig(config));
    if (circular) {
        const areArraysEqual = $7c3acd9b84fb12ed$var$createIsCircular(config.areArraysEqual);
        const areMapsEqual = $7c3acd9b84fb12ed$var$createIsCircular(config.areMapsEqual);
        const areObjectsEqual = $7c3acd9b84fb12ed$var$createIsCircular(config.areObjectsEqual);
        const areSetsEqual = $7c3acd9b84fb12ed$var$createIsCircular(config.areSetsEqual);
        config = Object.assign({}, config, {
            areArraysEqual: areArraysEqual,
            areMapsEqual: areMapsEqual,
            areObjectsEqual: areObjectsEqual,
            areSetsEqual: areSetsEqual
        });
    }
    return config;
}
/**
 * Default equality comparator pass-through, used as the standard `isEqual` creator for
 * use inside the built comparator.
 */ function $7c3acd9b84fb12ed$var$createInternalEqualityComparator(compare) {
    return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
        return compare(a, b, state);
    };
}
/**
 * Create the `isEqual` function used by the consuming application.
 */ function $7c3acd9b84fb12ed$var$createIsEqual({ circular: circular, comparator: comparator, createState: createState, equals: equals, strict: strict }) {
    if (createState) return function isEqual(a, b) {
        const { cache: cache = circular ? new WeakMap() : undefined, meta: meta } = createState();
        return comparator(a, b, {
            cache: cache,
            equals: equals,
            meta: meta,
            strict: strict
        });
    };
    if (circular) return function isEqual(a, b) {
        return comparator(a, b, {
            cache: new WeakMap(),
            equals: equals,
            meta: undefined,
            strict: strict
        });
    };
    const state = {
        cache: undefined,
        equals: equals,
        meta: undefined,
        strict: strict
    };
    return function isEqual(a, b) {
        return comparator(a, b, state);
    };
}
/**
 * Create a map of `toString()` values to their respective handlers for `tag`-based lookups.
 */ function $7c3acd9b84fb12ed$var$createSupportedComparatorMap({ areArrayBuffersEqual: areArrayBuffersEqual, areArraysEqual: areArraysEqual, areDataViewsEqual: areDataViewsEqual, areDatesEqual: areDatesEqual, areErrorsEqual: areErrorsEqual, areFunctionsEqual: areFunctionsEqual, areMapsEqual: areMapsEqual, areNumbersEqual: areNumbersEqual, areObjectsEqual: areObjectsEqual, arePrimitiveWrappersEqual: arePrimitiveWrappersEqual, areRegExpsEqual: areRegExpsEqual, areSetsEqual: areSetsEqual, areTypedArraysEqual: areTypedArraysEqual, areUrlsEqual: areUrlsEqual }) {
    return {
        '[object Arguments]': areObjectsEqual,
        '[object Array]': areArraysEqual,
        '[object ArrayBuffer]': areArrayBuffersEqual,
        '[object AsyncGeneratorFunction]': areFunctionsEqual,
        '[object BigInt]': areNumbersEqual,
        '[object BigInt64Array]': areTypedArraysEqual,
        '[object BigUint64Array]': areTypedArraysEqual,
        '[object Boolean]': arePrimitiveWrappersEqual,
        '[object DataView]': areDataViewsEqual,
        '[object Date]': areDatesEqual,
        // If an error tag, it should be tested explicitly. Like RegExp, the properties are not
        // enumerable, and therefore will give false positives if tested like a standard object.
        '[object Error]': areErrorsEqual,
        '[object Float16Array]': areTypedArraysEqual,
        '[object Float32Array]': areTypedArraysEqual,
        '[object Float64Array]': areTypedArraysEqual,
        '[object Function]': areFunctionsEqual,
        '[object GeneratorFunction]': areFunctionsEqual,
        '[object Int8Array]': areTypedArraysEqual,
        '[object Int16Array]': areTypedArraysEqual,
        '[object Int32Array]': areTypedArraysEqual,
        '[object Map]': areMapsEqual,
        '[object Number]': arePrimitiveWrappersEqual,
        '[object Object]': (a, b, state)=>// The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            typeof a.then !== 'function' && typeof b.then !== 'function' && areObjectsEqual(a, b, state),
        // For RegExp, the properties are not enumerable, and therefore will give false positives if
        // tested like a standard object.
        '[object RegExp]': areRegExpsEqual,
        '[object Set]': areSetsEqual,
        '[object String]': arePrimitiveWrappersEqual,
        '[object URL]': areUrlsEqual,
        '[object Uint8Array]': areTypedArraysEqual,
        '[object Uint8ClampedArray]': areTypedArraysEqual,
        '[object Uint16Array]': areTypedArraysEqual,
        '[object Uint32Array]': areTypedArraysEqual
    };
}
/**
 * Whether the items passed are deeply-equal in value.
 */ const $7c3acd9b84fb12ed$var$deepEqual = $7c3acd9b84fb12ed$var$createCustomEqual();
/**
 * Whether the items passed are deeply-equal in value based on strict comparison.
 */ $7c3acd9b84fb12ed$var$createCustomEqual({
    strict: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references.
 */ $7c3acd9b84fb12ed$var$createCustomEqual({
    circular: true
});
/**
 * Whether the items passed are deeply-equal in value, including circular references,
 * based on strict comparison.
 */ $7c3acd9b84fb12ed$var$createCustomEqual({
    circular: true,
    strict: true
});
/**
 * Whether the items passed are shallowly-equal in value.
 */ $7c3acd9b84fb12ed$var$createCustomEqual({
    createInternalComparator: ()=>$7c3acd9b84fb12ed$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value based on strict comparison
 */ $7c3acd9b84fb12ed$var$createCustomEqual({
    strict: true,
    createInternalComparator: ()=>$7c3acd9b84fb12ed$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references.
 */ $7c3acd9b84fb12ed$var$createCustomEqual({
    circular: true,
    createInternalComparator: ()=>$7c3acd9b84fb12ed$var$sameValueEqual
});
/**
 * Whether the items passed are shallowly-equal in value, including circular references,
 * based on strict comparison.
 */ $7c3acd9b84fb12ed$var$createCustomEqual({
    circular: true,
    createInternalComparator: ()=>$7c3acd9b84fb12ed$var$sameValueEqual,
    strict: true
});
/**
 * Create a custom equality comparison method.
 *
 * This can be done to create very targeted comparisons in extreme hot-path scenarios
 * where the standard methods are not performant enough, but can also be used to provide
 * support for legacy environments that do not support expected features like
 * `RegExp.prototype.flags` out of the box.
 */ function $7c3acd9b84fb12ed$var$createCustomEqual(options = {}) {
    const { circular: circular = false, createInternalComparator: createCustomInternalComparator, createState: createState, strict: strict = false } = options;
    const config = $7c3acd9b84fb12ed$var$createEqualityComparatorConfig(options);
    const comparator = $7c3acd9b84fb12ed$var$createEqualityComparator(config);
    const equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : $7c3acd9b84fb12ed$var$createInternalEqualityComparator(comparator);
    return $7c3acd9b84fb12ed$var$createIsEqual({
        circular: circular,
        comparator: comparator,
        createState: createState,
        equals: equals,
        strict: strict
    });
}
function $7c3acd9b84fb12ed$var$useDeepCompareEffect(effect, dependencies) {
    $7c3acd9b84fb12ed$var$useCustomCompareEffect(effect, dependencies, $7c3acd9b84fb12ed$var$deepEqual);
}
const $7c3acd9b84fb12ed$var$mapOptionKeys = new Set([
    'backgroundColor',
    'clickableIcons',
    'controlSize',
    'disableDefaultUI',
    'disableDoubleClickZoom',
    'draggable',
    'draggableCursor',
    'draggingCursor',
    'fullscreenControl',
    'fullscreenControlOptions',
    'gestureHandling',
    'headingInteractionEnabled',
    'isFractionalZoomEnabled',
    'keyboardShortcuts',
    'mapTypeControl',
    'mapTypeControlOptions',
    'mapTypeId',
    'maxZoom',
    'minZoom',
    'noClear',
    'panControl',
    'panControlOptions',
    'restriction',
    'rotateControl',
    'rotateControlOptions',
    'scaleControl',
    'scaleControlOptions',
    'scrollwheel',
    'streetView',
    'streetViewControl',
    'streetViewControlOptions',
    'styles',
    'tiltInteractionEnabled',
    'zoomControl',
    'zoomControlOptions'
]);
/**
 * Internal hook to update the map-options when props are changed.
 *
 * @param map the map instance
 * @param mapProps the props to update the map-instance with
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMapOptions(map, mapProps) {
    /* eslint-disable react-hooks/exhaustive-deps --
     *
     * The following effects aren't triggered when the map is changed.
     * In that case, the values will be or have been passed to the map
     * constructor via mapOptions.
     */ const mapOptions = {};
    const keys = Object.keys(mapProps);
    for (const key of keys){
        if (!$7c3acd9b84fb12ed$var$mapOptionKeys.has(key)) continue;
        mapOptions[key] = mapProps[key];
    }
    // update the map options when mapOptions is changed
    // Note: due to the destructuring above, mapOptions will be seen as changed
    //   with every re-render, so we're assuming the maps-api will properly
    //   deal with unchanged option-values passed into setOptions.
    $7c3acd9b84fb12ed$var$useDeepCompareEffect(()=>{
        if (!map) return;
        map.setOptions(mapOptions);
    }, [
        mapOptions
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }
function $7c3acd9b84fb12ed$export$e5822ec3438c5de1() {
    var _a;
    return ((_a = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$84e9974bcf67d1d)) === null || _a === void 0 ? void 0 : _a.status) || $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.NOT_LOADED;
}
/**
 * Internal hook that updates the camera when deck.gl viewState changes.
 * @internal
 */ function $7c3acd9b84fb12ed$var$useDeckGLCameraUpdate(map, props) {
    const { viewport: viewport, viewState: viewState } = props;
    const isDeckGlControlled = !!viewport;
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (!map || !viewState) return;
        const { latitude: latitude, longitude: longitude, bearing: heading, pitch: tilt, zoom: zoom } = viewState;
        map.moveCamera({
            center: {
                lat: latitude,
                lng: longitude
            },
            heading: heading,
            tilt: tilt,
            zoom: zoom + 1
        });
    }, [
        map,
        viewState
    ]);
    return isDeckGlControlled;
}
function $7c3acd9b84fb12ed$export$82fba3567e3760d8(obj) {
    if (!obj || typeof obj !== 'object') return false;
    if (!('lat' in obj && 'lng' in obj)) return false;
    return Number.isFinite(obj.lat) && Number.isFinite(obj.lng);
}
function $7c3acd9b84fb12ed$export$e6f27d7c3c3233eb(a, b) {
    if (!a || !b) return false;
    const A = $7c3acd9b84fb12ed$export$988c27a52d63c3b9(a);
    const B = $7c3acd9b84fb12ed$export$988c27a52d63c3b9(b);
    if (A.lat !== B.lat || A.lng !== B.lng) return false;
    return true;
}
function $7c3acd9b84fb12ed$export$988c27a52d63c3b9(obj) {
    if ($7c3acd9b84fb12ed$export$82fba3567e3760d8(obj)) return obj;
    return obj.toJSON();
}
function $7c3acd9b84fb12ed$export$26cbfc0dea0ade67(obj) {
    if ('north' in obj && 'south' in obj && 'east' in obj && 'west' in obj) return obj;
    const ne = obj.getNorthEast().toJSON();
    const sw = obj.getSouthWest().toJSON();
    return {
        north: ne.lat,
        east: ne.lng,
        south: sw.lat,
        west: sw.lng
    };
}
function $7c3acd9b84fb12ed$export$c0cfaae65aded47(a, b) {
    if (!a || !b) return false;
    const A = $7c3acd9b84fb12ed$export$26cbfc0dea0ade67(a);
    const B = $7c3acd9b84fb12ed$export$26cbfc0dea0ade67(b);
    return A.north === B.north && A.south === B.south && A.east === B.east && A.west === B.west;
}
/**
 * Compares two paths (arrays of LatLng points) for equality.
 */ function $7c3acd9b84fb12ed$export$69485f8143efb551(a, b) {
    if (!a || !b) return a === b;
    const arrayB = 'getArray' in b ? b.getArray() : b;
    if (a.length !== arrayB.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$7c3acd9b84fb12ed$export$e6f27d7c3c3233eb(a[i], arrayB[i])) return false;
    }
    return true;
}
/**
 * Compares two arrays of paths (for Polygon) for equality.
 */ function $7c3acd9b84fb12ed$export$81bf7c9065d0b5e1(a, b) {
    if (!a || !b) return a === b;
    const arrayB = 'getArray' in b ? b.getArray().map((inner)=>inner.getArray()) : b;
    if (a.length !== arrayB.length) return false;
    for(let i = 0; i < a.length; i++){
        if (!$7c3acd9b84fb12ed$export$69485f8143efb551(a[i], arrayB[i])) return false;
    }
    return true;
}
function $7c3acd9b84fb12ed$var$useMapCameraParams(map, cameraStateRef, mapProps) {
    const center = mapProps.center ? $7c3acd9b84fb12ed$export$988c27a52d63c3b9(mapProps.center) : null;
    let lat = null;
    let lng = null;
    if (center && Number.isFinite(center.lat) && Number.isFinite(center.lng)) {
        lat = center.lat;
        lng = center.lng;
    }
    const zoom = Number.isFinite(mapProps.zoom) ? mapProps.zoom : null;
    const heading = Number.isFinite(mapProps.heading) ? mapProps.heading : null;
    const tilt = Number.isFinite(mapProps.tilt) ? mapProps.tilt : null;
    // the following effect runs for every render of the map component and checks
    // if there are differences between the known state of the map instance
    // (cameraStateRef, which is updated by all bounds_changed events) and the
    // desired state in the props.
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (!map) return;
        const nextCamera = {};
        let needsUpdate = false;
        if (lat !== null && lng !== null && (cameraStateRef.current.center.lat !== lat || cameraStateRef.current.center.lng !== lng)) {
            nextCamera.center = {
                lat: lat,
                lng: lng
            };
            needsUpdate = true;
        }
        if (zoom !== null && cameraStateRef.current.zoom !== zoom) {
            nextCamera.zoom = zoom;
            needsUpdate = true;
        }
        if (heading !== null && cameraStateRef.current.heading !== heading) {
            nextCamera.heading = heading;
            needsUpdate = true;
        }
        if (tilt !== null && cameraStateRef.current.tilt !== tilt) {
            nextCamera.tilt = tilt;
            needsUpdate = true;
        }
        if (needsUpdate) map.moveCamera(nextCamera);
    });
}
const $7c3acd9b84fb12ed$var$AuthFailureMessage = ()=>{
    const style = {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        zIndex: 999,
        display: 'flex',
        flexFlow: 'column nowrap',
        textAlign: 'center',
        justifyContent: 'center',
        fontSize: '.8rem',
        color: 'rgba(0,0,0,0.6)',
        background: '#dddddd',
        padding: '1rem 1.5rem'
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        style: style
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("h2", null, "Error: AuthFailure"), (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function $7c3acd9b84fb12ed$var$useCallbackRef() {
    const [el, setEl] = (0, $kYL7Z.useState)(null);
    const ref = (0, $kYL7Z.useCallback)((value)=>setEl(value), [
        setEl
    ]);
    return [
        el,
        ref
    ];
}
/**
 * Hook to check if the Maps JavaScript API is loaded
 */ function $7c3acd9b84fb12ed$export$71fa1727c43bf612() {
    const status = $7c3acd9b84fb12ed$export$e5822ec3438c5de1();
    return status === $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.LOADED;
}
function $7c3acd9b84fb12ed$var$useForceUpdate() {
    const [, forceUpdate] = (0, $kYL7Z.useReducer)((x)=>x + 1, 0);
    return forceUpdate;
}
function $7c3acd9b84fb12ed$var$handleBoundsChange(map, ref) {
    const center = map.getCenter();
    const zoom = map.getZoom();
    const heading = map.getHeading() || 0;
    const tilt = map.getTilt() || 0;
    const bounds = map.getBounds();
    if (!center || !bounds || !Number.isFinite(zoom)) console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new");
    // fixme: do we need the `undefined` cases for the camera-params? When are they used in the maps API?
    Object.assign(ref.current, {
        center: (center === null || center === void 0 ? void 0 : center.toJSON()) || {
            lat: 0,
            lng: 0
        },
        zoom: zoom || 0,
        heading: heading,
        tilt: tilt
    });
}
/**
 * Creates a mutable ref object to track the last known state of the map camera.
 * This is used in `useMapCameraParams` to reduce stuttering in normal operation
 * by avoiding updates of the map camera with values that have already been processed.
 */ function $7c3acd9b84fb12ed$var$useTrackedCameraStateRef(map) {
    const forceUpdate = $7c3acd9b84fb12ed$var$useForceUpdate();
    const ref = (0, $kYL7Z.useRef)({
        center: {
            lat: 0,
            lng: 0
        },
        heading: 0,
        tilt: 0,
        zoom: 0
    });
    // Record camera state with every bounds_changed event dispatched by the map.
    // This data is used to prevent feeding these values back to the
    // map-instance when a typical "controlled component" setup (state variable is
    // fed into and updated by the map).
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) return;
        const listener = google.maps.event.addListener(map, 'bounds_changed', ()=>{
            $7c3acd9b84fb12ed$var$handleBoundsChange(map, ref);
            // When an event is occured, we have to update during the next cycle.
            // The application could decide to ignore the event and not update any
            // camera props of the map, meaning that in that case we will have to
            // 'undo' the change to the camera.
            forceUpdate();
        });
        return ()=>listener.remove();
    }, [
        map,
        forceUpdate
    ]);
    return ref;
}
/**
 * Stores a stack of map-instances for each mapId. Whenever an
 * instance is used, it is removed from the stack while in use,
 * and returned to the stack when the component unmounts.
 * This allows us to correctly implement caching for multiple
 * maps om the same page, while reusing as much as possible.
 *
 * FIXME: while it should in theory be possible to reuse maps solely
 *   based on mapId/renderingType/colorScheme (as all other parameters can be
 *   changed at runtime), we don't yet have good enough tracking of options to
 *   reliably unset all the options that have been set.
 */ class $7c3acd9b84fb12ed$var$CachedMapStack {
    static has(key) {
        return this.entries[key] && this.entries[key].length > 0;
    }
    static pop(key) {
        if (!this.entries[key]) return null;
        return this.entries[key].pop() || null;
    }
    static push(key, value) {
        if (!this.entries[key]) this.entries[key] = [];
        this.entries[key].push(value);
    }
}
$7c3acd9b84fb12ed$var$CachedMapStack.entries = {};
/**
 * The main hook takes care of creating map-instances and registering them in
 * the api-provider context.
 * @return a tuple of the map-instance created (or null) and the callback
 *   ref that will be used to pass the map-container into this hook.
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMapInstance(props, context) {
    const apiIsLoaded = $7c3acd9b84fb12ed$export$71fa1727c43bf612();
    const [map, setMap] = (0, $kYL7Z.useState)(null);
    const [container, containerRef] = $7c3acd9b84fb12ed$var$useCallbackRef();
    const cameraStateRef = $7c3acd9b84fb12ed$var$useTrackedCameraStateRef(map);
    const { id: id, defaultBounds: defaultBounds, defaultCenter: defaultCenter, defaultZoom: defaultZoom, defaultHeading: defaultHeading, defaultTilt: defaultTilt, reuseMaps: reuseMaps, renderingType: renderingType, colorScheme: colorScheme } = props, mapOptions = $7c3acd9b84fb12ed$var$__rest(props, [
        "id",
        "defaultBounds",
        "defaultCenter",
        "defaultZoom",
        "defaultHeading",
        "defaultTilt",
        "reuseMaps",
        "renderingType",
        "colorScheme"
    ]);
    const hasZoom = props.zoom !== undefined || props.defaultZoom !== undefined;
    const hasCenter = props.center !== undefined || props.defaultCenter !== undefined;
    if (!defaultBounds && (!hasZoom || !hasCenter)) console.warn("<Map> component is missing configuration. You have to provide zoom and center (via the `zoom`/`defaultZoom` and `center`/`defaultCenter` props) or specify the region to show using `defaultBounds`. See https://visgl.github.io/react-google-maps/docs/api-reference/components/map#required");
    // apply default camera props if available and not overwritten by controlled props
    if (!mapOptions.center && defaultCenter) mapOptions.center = defaultCenter;
    if (!mapOptions.zoom && Number.isFinite(defaultZoom)) mapOptions.zoom = defaultZoom;
    if (!mapOptions.heading && Number.isFinite(defaultHeading)) mapOptions.heading = defaultHeading;
    if (!mapOptions.tilt && Number.isFinite(defaultTilt)) mapOptions.tilt = defaultTilt;
    // Handle internalUsageAttributionIds
    const customIds = mapOptions.internalUsageAttributionIds;
    if (customIds == null) // Not specified - use context default (which may be null if disabled)
    mapOptions.internalUsageAttributionIds = context.internalUsageAttributionIds;
    else // Merge context defaults with custom IDs
    mapOptions.internalUsageAttributionIds = [
        ...context.internalUsageAttributionIds || [],
        ...customIds
    ];
    for (const key of Object.keys(mapOptions))if (mapOptions[key] === undefined) delete mapOptions[key];
    const savedMapStateRef = (0, $kYL7Z.useRef)(undefined);
    // create the map instance and register it in the context
    (0, $kYL7Z.useEffect)(()=>{
        if (!container || !apiIsLoaded) return;
        const { addMapInstance: addMapInstance, removeMapInstance: removeMapInstance } = context;
        // note: colorScheme (upcoming feature) isn't yet in the typings, remove once that is fixed:
        const { mapId: mapId } = props;
        const cacheKey = `${mapId || 'default'}:${renderingType || 'default'}:${colorScheme || 'LIGHT'}`;
        let mapDiv;
        let map;
        // a cached map can end up in a broken state (e.g. when the initial
        // map-creation failed because the Maps JavaScript API didn't load
        // correctly). In that case `getDiv()` doesn't return a usable DOM node,
        // so we have to discard the cached instance instead of trying to reuse it.
        const cachedMap = reuseMaps && $7c3acd9b84fb12ed$var$CachedMapStack.has(cacheKey) ? $7c3acd9b84fb12ed$var$CachedMapStack.pop(cacheKey) : null;
        const cachedMapDiv = cachedMap === null || cachedMap === void 0 ? void 0 : cachedMap.getDiv();
        const reusedMap = cachedMap && cachedMapDiv instanceof Node ? cachedMap : null;
        if (reusedMap) {
            map = reusedMap;
            mapDiv = cachedMapDiv;
            container.appendChild(mapDiv);
            map.setOptions(mapOptions);
            // detaching the element from the DOM sometimes causes the map to collapse
            // and no longer render tiles that should be in view after re-attaching it.
            // Triggering moveCamera after remounting should trigger a re-layout of
            // the map.
            setTimeout(()=>map.moveCamera({}), 0);
        } else {
            // discard a broken cached instance so it doesn't get pushed back
            if (cachedMap) google.maps.event.clearInstanceListeners(cachedMap);
            mapDiv = document.createElement('div');
            mapDiv.style.height = '100%';
            container.appendChild(mapDiv);
            map = new google.maps.Map(mapDiv, Object.assign(Object.assign(Object.assign({}, mapOptions), renderingType ? {
                renderingType: renderingType
            } : {}), colorScheme ? {
                colorScheme: colorScheme
            } : {}));
        }
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMap(map);
        addMapInstance(map, id);
        if (defaultBounds) {
            const { padding: padding } = defaultBounds, defBounds = $7c3acd9b84fb12ed$var$__rest(defaultBounds, [
                "padding"
            ]);
            map.fitBounds(defBounds, padding);
        } else if (!hasZoom || !hasCenter) map.fitBounds({
            east: 180,
            west: -180,
            south: -90,
            north: 90
        });
        // the savedMapState is used to restore the camera parameters when the mapId is changed
        if (savedMapStateRef.current) {
            const { mapId: savedMapId, cameraState: savedCameraState } = savedMapStateRef.current;
            if (savedMapId !== mapId) map.moveCamera(savedCameraState);
        }
        return ()=>{
            savedMapStateRef.current = {
                mapId: mapId,
                // eslint-disable-next-line react-hooks/exhaustive-deps
                cameraState: cameraStateRef.current
            };
            // detach the map-div from the dom
            mapDiv.remove();
            if (reuseMaps) // push back on the stack
            $7c3acd9b84fb12ed$var$CachedMapStack.push(cacheKey, map);
            else // remove all event-listeners to minimize the possibility of memory-leaks
            google.maps.event.clearInstanceListeners(map);
            setMap(null);
            removeMapInstance(id);
        };
    }, // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        container,
        apiIsLoaded,
        id,
        // these props can't be changed after initialization and require a new
        // instance to be created
        props.mapId,
        props.renderingType,
        props.colorScheme
    ]);
    return [
        map,
        containerRef,
        cameraStateRef
    ];
}
const $7c3acd9b84fb12ed$export$477ce50570f8b557 = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext(null);
// ColorScheme and RenderingType are redefined here to make them usable before the
// maps API has been fully loaded.
const $7c3acd9b84fb12ed$export$610a58c777d52843 = {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
    FOLLOW_SYSTEM: 'FOLLOW_SYSTEM'
};
const $7c3acd9b84fb12ed$export$245778257f8d6718 = {
    VECTOR: 'VECTOR',
    RASTER: 'RASTER',
    UNINITIALIZED: 'UNINITIALIZED'
};
const $7c3acd9b84fb12ed$export$a5c7b93649eaf8f8 = (props)=>{
    const { children: children, id: id, className: className, style: style } = props;
    const context = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$84e9974bcf67d1d);
    const loadingStatus = $7c3acd9b84fb12ed$export$e5822ec3438c5de1();
    if (!context) throw new Error('<Map> can only be used inside an <ApiProvider> component.');
    const [map, mapRef, cameraStateRef] = $7c3acd9b84fb12ed$var$useMapInstance(props, context);
    $7c3acd9b84fb12ed$var$useMapCameraParams(map, cameraStateRef, props);
    $7c3acd9b84fb12ed$var$useMapEvents(map, props);
    $7c3acd9b84fb12ed$var$useMapOptions(map, props);
    const isDeckGlControlled = $7c3acd9b84fb12ed$var$useDeckGLCameraUpdate(map, props);
    const isControlledExternally = !!props.controlled;
    // disable interactions with the map for externally controlled maps
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) return;
        // fixme: this doesn't seem to belong here (and it's mostly there for convenience anyway).
        //   The reasoning is that a deck.gl canvas will be put on top of the map, rendering
        //   any default map controls pretty much useless
        if (isDeckGlControlled) map.setOptions({
            disableDefaultUI: true
        });
        // disable all control-inputs when the map is controlled externally
        if (isDeckGlControlled || isControlledExternally) map.setOptions({
            gestureHandling: 'none',
            keyboardShortcuts: false
        });
        return ()=>{
            map.setOptions({
                gestureHandling: props.gestureHandling,
                keyboardShortcuts: props.keyboardShortcuts
            });
        };
    }, [
        map,
        isDeckGlControlled,
        isControlledExternally,
        props.gestureHandling,
        props.keyboardShortcuts
    ]);
    // setup a stable cameraOptions object that can be used as dependency
    const center = props.center ? $7c3acd9b84fb12ed$export$988c27a52d63c3b9(props.center) : null;
    let lat = null;
    let lng = null;
    if (center && Number.isFinite(center.lat) && Number.isFinite(center.lng)) {
        lat = center.lat;
        lng = center.lng;
    }
    const cameraOptions = (0, $kYL7Z.useMemo)(()=>{
        var _a, _b, _c;
        return {
            center: {
                lat: lat !== null && lat !== void 0 ? lat : 0,
                lng: lng !== null && lng !== void 0 ? lng : 0
            },
            zoom: (_a = props.zoom) !== null && _a !== void 0 ? _a : 0,
            heading: (_b = props.heading) !== null && _b !== void 0 ? _b : 0,
            tilt: (_c = props.tilt) !== null && _c !== void 0 ? _c : 0
        };
    }, [
        lat,
        lng,
        props.zoom,
        props.heading,
        props.tilt
    ]);
    // externally controlled mode: reject all camera changes that don't correspond to changes in props
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (!map || !isControlledExternally) return;
        map.moveCamera(cameraOptions);
        const listener = map.addListener('bounds_changed', ()=>{
            map.moveCamera(cameraOptions);
        });
        return ()=>listener.remove();
    }, [
        map,
        isControlledExternally,
        cameraOptions
    ]);
    const combinedStyle = (0, $kYL7Z.useMemo)(()=>Object.assign({
            width: '100%',
            height: '100%',
            position: 'relative',
            // when using deckgl, the map should be sent to the back
            zIndex: isDeckGlControlled ? -1 : 0
        }, style), [
        style,
        isDeckGlControlled
    ]);
    const contextValue = (0, $kYL7Z.useMemo)(()=>({
            map: map
        }), [
        map
    ]);
    if (loadingStatus === $7c3acd9b84fb12ed$export$647ae9f9d14aeffc.AUTH_FAILURE) return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        style: Object.assign({
            position: 'relative'
        }, className ? {} : combinedStyle),
        className: className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$var$AuthFailureMessage, null));
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", Object.assign({
        ref: mapRef,
        "data-testid": 'map',
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}), map ? (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$export$477ce50570f8b557.Provider, {
        value: contextValue
    }, children) : null);
};
// The deckGLViewProps flag here indicates to deck.gl that the Map component is
// able to handle viewProps from deck.gl when deck.gl is used to control the map.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$7c3acd9b84fb12ed$export$a5c7b93649eaf8f8.deckGLViewProps = true;
const $7c3acd9b84fb12ed$var$shownMessages = new Set();
function $7c3acd9b84fb12ed$var$logErrorOnce(...args) {
    const key = JSON.stringify(args);
    if (!$7c3acd9b84fb12ed$var$shownMessages.has(key)) {
        $7c3acd9b84fb12ed$var$shownMessages.add(key);
        console.error(...args);
    }
}
/**
 * Retrieves a map-instance from the context. This is either an instance
 * identified by id or the parent map instance if no id is specified.
 * Returns null if neither can be found.
 */ const $7c3acd9b84fb12ed$export$86f8f9f08863e403 = (id = null)=>{
    const ctx = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$84e9974bcf67d1d);
    const { map: map } = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$477ce50570f8b557) || {};
    if (ctx === null) {
        $7c3acd9b84fb12ed$var$logErrorOnce("useMap(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap()` from is a sibling of the <APIProvider>.");
        return null;
    }
    const { mapInstances: mapInstances } = ctx;
    // if an id is specified, the corresponding map or null is returned
    if (id !== null) return mapInstances[id] || null;
    // otherwise, return the closest ancestor
    if (map) return map;
    // finally, return the default map instance
    return mapInstances['default'] || null;
};
function $7c3acd9b84fb12ed$export$5b40cf36c69caef7(name) {
    var _a;
    const apiIsLoaded = $7c3acd9b84fb12ed$export$71fa1727c43bf612();
    const ctx = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$84e9974bcf67d1d);
    (0, $kYL7Z.useEffect)(()=>{
        if (!apiIsLoaded || !ctx) return;
        // Trigger loading the libraries via our proxy-method.
        // The returned promise is ignored, since importLibrary will update loadedLibraries
        // list in the context, triggering a re-render.
        ctx.importLibrary(name);
    }, [
        apiIsLoaded,
        ctx,
        name
    ]);
    return (_a = ctx === null || ctx === void 0 ? void 0 : ctx.loadedLibraries[name]) !== null && _a !== void 0 ? _a : null;
}
// Copyright (c) 2025 Sanity
// This file is derived from sanity-io/use-effect-event (MIT Licensed)
//
// https://github.com/sanity-io/use-effect-event
/**
 * A clone of the React namespace for reading APIs that may be missing in older
 * supported React versions. Bundlers can rewrite direct React.someNewApi reads
 * into named imports, which breaks React 17. Reading from this cloned object
 * keeps those lookups optional.
 *
 * @see https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
 */ const $7c3acd9b84fb12ed$var$SafeReact = Object.assign({}, $kYL7Z);
const $7c3acd9b84fb12ed$var$useInsertionEffect = $7c3acd9b84fb12ed$var$SafeReact.useInsertionEffect;
const $7c3acd9b84fb12ed$var$useSafeInsertionEffect = // React 17 doesn't have useInsertionEffect.
$7c3acd9b84fb12ed$var$useInsertionEffect && // Preact replaces useInsertionEffect with useLayoutEffect and fires too late.
$7c3acd9b84fb12ed$var$useInsertionEffect !== $7c3acd9b84fb12ed$var$SafeReact.useLayoutEffect ? $7c3acd9b84fb12ed$var$useInsertionEffect : (fn)=>{
    fn();
};
function $7c3acd9b84fb12ed$var$forbiddenInRender() {
    throw new Error('useEffectEvent: invalid call during rendering.');
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7c3acd9b84fb12ed$var$useEffectEventPolyfill(fn) {
    /**
     * Initialize the ref with `forbiddenInRender`, to catch illegal calls during
     * rendering. After the insertion effect ran, the ref will contain the actual
     * function, so all effects can see the actual value.
     */ const ref = (0, $kYL7Z.useRef)($7c3acd9b84fb12ed$var$forbiddenInRender);
    $7c3acd9b84fb12ed$var$useSafeInsertionEffect(()=>{
        ref.current = fn;
    }, [
        fn
    ]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...args)=>ref.current(...args);
}
/**
 * Uses a polyfill implementation of `useEffectEvent`. The native useEffectEvent
 * implementation was causing issues that we do not fully understand yet.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c3acd9b84fb12ed$var$useEffectEvent = $7c3acd9b84fb12ed$var$useEffectEventPolyfill;
/* eslint-disable @typescript-eslint/no-explicit-any */ const $7c3acd9b84fb12ed$var$noop$1 = ()=>{};
/**
 * Internally used to bind events to Maps JavaScript API objects.
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMapsEventListener(target, name, callback) {
    const eventFn = $7c3acd9b84fb12ed$var$useEffectEvent(callback !== null && callback !== void 0 ? callback : $7c3acd9b84fb12ed$var$noop$1);
    const isCallbackDefined = Boolean(callback);
    (0, $kYL7Z.useEffect)(()=>{
        if (!target || !name || !isCallbackDefined) return;
        const listener = google.maps.event.addListener(target, name, eventFn);
        return ()=>listener.remove();
    }, [
        target,
        name,
        isCallbackDefined
    ]);
}
/* eslint-disable react-hooks/immutability -- Google Maps API objects are designed to be mutated */ /**
 * Internally used to copy values from props into API-Objects
 * whenever they change.
 *
 * @example
 *   usePropBinding(marker, 'position', position);
 *
 * @internal
 */ function $7c3acd9b84fb12ed$var$usePropBinding(object, prop, value) {
    (0, $kYL7Z.useEffect)(()=>{
        if (!object) return;
        // We use any here because GmpWritableElementProp<T[K]> is a broader type than T[K]
        // and can't be assigned directly without this cast.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        object[prop] = value;
    }, [
        object,
        prop,
        value
    ]);
}
/* eslint-disable @typescript-eslint/no-explicit-any */ const $7c3acd9b84fb12ed$var$noop = ()=>{};
/**
 * Internally used to bind events to DOM nodes.
 * @internal
 */ function $7c3acd9b84fb12ed$var$useDomEventListener(target, name, callback) {
    const eventFn = $7c3acd9b84fb12ed$var$useEffectEvent(callback !== null && callback !== void 0 ? callback : $7c3acd9b84fb12ed$var$noop);
    const isCallbackDefined = Boolean(callback);
    (0, $kYL7Z.useEffect)(()=>{
        if (!target || !name || !isCallbackDefined) return;
        // Note: eventFn is not guaranteed to be stable across renders, so we need
        // to use a local variable to be sure to remove the very same listener
        // function that has been added
        const listenerCallback = eventFn;
        target.addEventListener(name, listenerCallback);
        return ()=>target.removeEventListener(name, listenerCallback);
    }, [
        target,
        name,
        isCallbackDefined
    ]);
}
// Global style manager to track rendered styles and avoid duplicates
class $7c3acd9b84fb12ed$var$GlobalStyleManager {
    constructor(){
        this.renderedStyles = new Set();
        this.styleElement = null;
    }
    getStyleElement() {
        if (!this.styleElement) {
            this.styleElement = document.createElement('style');
            this.styleElement.setAttribute('data-rgm-anchor-styles', '');
            document.head.appendChild(this.styleElement);
        }
        return this.styleElement;
    }
    addAdvancedMarkerPointerEventsOverwrite() {
        if (this.renderedStyles.has('marker-pointer-events')) return;
        const styleElement = this.getStyleElement();
        styleElement.textContent += `
      gmp-advanced-marker[data-origin='rgm'] {
        pointer-events: none !important;
      }
    `;
        this.renderedStyles.add('marker-pointer-events');
    }
    cleanup() {
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
            this.renderedStyles.clear();
        }
    }
}
const $7c3acd9b84fb12ed$var$globalStyleManager = new $7c3acd9b84fb12ed$var$GlobalStyleManager();
function $7c3acd9b84fb12ed$var$isVersionGreaterEqual(major, minor) {
    var _a;
    if (!((_a = google === null || google === void 0 ? void 0 : google.maps) === null || _a === void 0 ? void 0 : _a.version)) return undefined;
    const version = google.maps.version.split('.');
    const currentMajor = parseInt(version[0], 10);
    const currentMinor = parseInt(version[1], 10);
    return currentMajor > major || currentMajor === major && currentMinor >= minor;
}
/**
 * Copy of the `google.maps.CollisionBehavior` constants.
 * They have to be duplicated here since we can't wait for the maps API to load to be able to use them.
 */ const $7c3acd9b84fb12ed$export$780450305ded336e = {
    REQUIRED: 'REQUIRED',
    REQUIRED_AND_HIDES_OPTIONAL: 'REQUIRED_AND_HIDES_OPTIONAL',
    OPTIONAL_AND_HIDES_LOWER_PRIORITY: 'OPTIONAL_AND_HIDES_LOWER_PRIORITY'
};
const $7c3acd9b84fb12ed$export$14de7bb7593cd5bc = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext(null);
// [xPosition, yPosition] when the top left corner is [0, 0]
/**
 * @deprecated Using `anchorPosition` is deprecated.
 *   Use `anchorLeft` and `anchorTop` instead.
 */ const $7c3acd9b84fb12ed$export$5a0544ba0e628ca7 = {
    TOP_LEFT: [
        '0%',
        '0%'
    ],
    TOP_CENTER: [
        '50%',
        '0%'
    ],
    TOP: [
        '50%',
        '0%'
    ],
    TOP_RIGHT: [
        '100%',
        '0%'
    ],
    LEFT_CENTER: [
        '0%',
        '50%'
    ],
    LEFT_TOP: [
        '0%',
        '0%'
    ],
    LEFT: [
        '0%',
        '50%'
    ],
    LEFT_BOTTOM: [
        '0%',
        '100%'
    ],
    RIGHT_TOP: [
        '100%',
        '0%'
    ],
    RIGHT: [
        '100%',
        '50%'
    ],
    RIGHT_CENTER: [
        '100%',
        '50%'
    ],
    RIGHT_BOTTOM: [
        '100%',
        '100%'
    ],
    BOTTOM_LEFT: [
        '0%',
        '100%'
    ],
    BOTTOM_CENTER: [
        '50%',
        '100%'
    ],
    BOTTOM: [
        '50%',
        '100%'
    ],
    BOTTOM_RIGHT: [
        '100%',
        '100%'
    ],
    CENTER: [
        '50%',
        '50%'
    ]
};
const $7c3acd9b84fb12ed$export$5dd2dc1fc7030ab5 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { children: children, style: style, className: className, anchorPoint: anchorPoint } = props;
    const [marker, contentContainer] = $7c3acd9b84fb12ed$var$useAdvancedMarker(props);
    const advancedMarkerContextValue = (0, $kYL7Z.useMemo)(()=>marker ? {
            marker: marker
        } : null, [
        marker
    ]);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    if (!contentContainer) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$export$14de7bb7593cd5bc.Provider, {
        value: advancedMarkerContextValue
    }, (0, $cRanb.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$var$MarkerContent, {
        anchorPoint: anchorPoint,
        styles: style,
        className: className
    }, children), contentContainer));
});
$7c3acd9b84fb12ed$export$5dd2dc1fc7030ab5.displayName = 'AdvancedMarker';
function $7c3acd9b84fb12ed$export$ee72183bc46d9ec2() {
    const [marker, setMarker] = (0, $kYL7Z.useState)(null);
    const refCallback = (0, $kYL7Z.useCallback)((m)=>{
        setMarker(m);
    }, []);
    return [
        refCallback,
        marker
    ];
}
function $7c3acd9b84fb12ed$export$5f1640ccc146ea2d(marker) {
    return marker.content !== undefined;
}
function $7c3acd9b84fb12ed$var$isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
const $7c3acd9b84fb12ed$var$MarkerContent = ({ children: children, styles: styles, className: className })=>{
    /* AdvancedMarker div that user can give styles and classes */ return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        className: className,
        style: styles
    }, children);
};
function $7c3acd9b84fb12ed$var$useAdvancedMarker(props) {
    const [marker, setMarker] = (0, $kYL7Z.useState)(null);
    const [contentContainer, setContentContainer] = (0, $kYL7Z.useState)(null);
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    const markerLibrary = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('marker');
    const { children: children, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, collisionBehavior: collisionBehavior, clickable: clickable, draggable: draggable, position: position, title: title, zIndex: zIndex, anchorPoint: anchorPoint, anchorLeft: anchorLeft, anchorTop: anchorTop } = props;
    const numChildren = (0, $kYL7Z.Children).count(children);
    // create an AdvancedMarkerElement instance and add it to the map once available
    (0, $kYL7Z.useEffect)(()=>{
        if (!map || !markerLibrary) return;
        const newMarker = new markerLibrary.AdvancedMarkerElement();
        newMarker.map = map;
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMarker(newMarker);
        // create the container for marker content if there are children
        let contentElement = null;
        if (numChildren > 0) {
            contentElement = document.createElement('div');
            newMarker.content = contentElement;
            setContentContainer(contentElement);
        }
        return ()=>{
            newMarker.map = null;
            contentElement === null || contentElement === void 0 || contentElement.remove();
            setMarker(null);
            setContentContainer(null);
        };
    }, [
        map,
        markerLibrary,
        numChildren
    ]);
    // When no children are present we don't have our own wrapper div
    // which usually gets the user provided className. In this case
    // we set the className directly on the marker.content element that comes
    // with the AdvancedMarker.
    (0, $kYL7Z.useEffect)(()=>{
        if (!(marker === null || marker === void 0 ? void 0 : marker.content) || !$7c3acd9b84fb12ed$var$isElementNode(marker.content) || numChildren > 0) return;
        marker.content.className = className !== null && className !== void 0 ? className : '';
    }, [
        marker,
        className,
        numChildren
    ]);
    $7c3acd9b84fb12ed$var$useAdvancedMarkerAnchoring(marker, anchorPoint, anchorLeft, anchorTop, numChildren > 0);
    // copy other props
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'position', position);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'title', title !== null && title !== void 0 ? title : '');
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'zIndex', zIndex);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'collisionBehavior', collisionBehavior);
    // set gmpDraggable from props (when unspecified, it's true if any drag-event
    // callbacks are specified)
    (0, $kYL7Z.useEffect)(()=>{
        if (!marker) return;
        if (draggable !== undefined) marker.gmpDraggable = draggable;
        else if (onDrag || onDragStart || onDragEnd) marker.gmpDraggable = true;
        else marker.gmpDraggable = false;
    }, [
        marker,
        draggable,
        onDrag,
        onDragEnd,
        onDragStart
    ]);
    // set gmpClickable from props (when unspecified, it's true if any interactive
    // event callbacks are specified)
    (0, $kYL7Z.useEffect)(()=>{
        if (!marker) return;
        // when clickable is defined, we will always use its value for gmpClickable.
        // otherwise we auto-detect based on existing event-handlers.
        const gmpClickable = clickable !== undefined ? clickable : Boolean(onClick) || Boolean(onKeyDown) || Boolean(onKeyUp) || Boolean(onMouseEnter) || Boolean(onMouseLeave);
        // gmpClickable is only available in beta version of the
        // maps api (as of 2024-10-10)
        marker.gmpClickable = gmpClickable;
        // keep pointer/cursor styles in sync for markers with custom content.
        // Non-clickable custom HTML must disable pointer targeting explicitly so
        // interactions fall through to the map underneath.
        if ((marker === null || marker === void 0 ? void 0 : marker.content) && $7c3acd9b84fb12ed$var$isElementNode(marker.content)) {
            marker.content.style.pointerEvents = gmpClickable ? 'all' : 'none';
            marker.content.style.cursor = gmpClickable && onClick ? 'pointer' : '';
        }
    }, [
        marker,
        clickable,
        onClick,
        onKeyDown,
        onKeyUp,
        onMouseEnter,
        onMouseLeave
    ]);
    $7c3acd9b84fb12ed$var$useMapsEventListener(marker, 'drag', onDrag);
    $7c3acd9b84fb12ed$var$useMapsEventListener(marker, 'dragstart', onDragStart);
    $7c3acd9b84fb12ed$var$useMapsEventListener(marker, 'dragend', onDragEnd);
    $7c3acd9b84fb12ed$var$useDomEventListener(marker, 'gmp-click', onClick);
    $7c3acd9b84fb12ed$var$useDomEventListener(marker, 'keydown', onKeyDown);
    $7c3acd9b84fb12ed$var$useDomEventListener(marker, 'keyup', onKeyUp);
    $7c3acd9b84fb12ed$var$useDomEventListener(marker, 'mouseenter', onMouseEnter);
    $7c3acd9b84fb12ed$var$useDomEventListener(marker, 'mouseleave', onMouseLeave);
    return [
        marker,
        contentContainer
    ];
}
function $7c3acd9b84fb12ed$var$useAdvancedMarkerAnchoring(marker, anchorPoint, anchorLeft, anchorTop, hasChildren) {
    (0, $kYL7Z.useEffect)(()=>{
        if (!marker || !hasChildren) return;
        // The anchorLeft and anchorTop options are available since version 3.62.9c
        // With the release of 3.65 (~May 2026) there will no longer be a version
        // that doesn't support it.
        const anchorOptionsSupported = $7c3acd9b84fb12ed$var$isVersionGreaterEqual(3, 62);
        const contentElement = marker.content;
        if (!contentElement || !$7c3acd9b84fb12ed$var$isElementNode(contentElement)) return;
        if (anchorLeft !== undefined || anchorTop !== undefined) {
            if (!anchorOptionsSupported) console.warn("AdvancedMarker: The anchorLeft and anchorTop props are only supported in Google Maps API version 3.62 and above. " + `The current version is ${google.maps.version}.`);
            marker.anchorLeft = anchorLeft;
            marker.anchorTop = anchorTop;
            // when anchorLeft and/or anchorTop are set, we'll ignore the anchorPoint
            if (anchorPoint !== undefined) console.warn("AdvancedMarker: the anchorPoint prop is ignored when anchorLeft and/or anchorTop are set.");
            return;
        }
        if (anchorPoint !== undefined) {
            // TODO: add console.warn in a future version to inform about deprecation
            const [x, y] = anchorPoint !== null && anchorPoint !== void 0 ? anchorPoint : $7c3acd9b84fb12ed$export$5a0544ba0e628ca7['BOTTOM'];
            // NOTE: since x and y can be any valid CSS length-percentage
            //   value, we need to use calc() to negate them.
            const translateX = `calc(-1 * ${x})`;
            const translateY = `calc(-1 * ${y})`;
            if (anchorOptionsSupported) {
                // implement anchorPoint using the new anchorLeft and anchorTop options
                marker.anchorLeft = translateX;
                marker.anchorTop = translateY;
                // reset transform from legacy implementation
                contentElement.style.transform = '';
            } else {
                // The "translate(50%, 100%)" counters and resets the default
                // anchoring of the advanced marker element from the api
                contentElement.style.transform = `translate(50%, 100%) translate(${translateX}, ${translateY})`;
                // data-origin is needed to identify the custom marker content in the
                // InfoWindow component as well as in the global CSS used to disable
                // the pointer event when anchor points are used in older Google Maps
                // versions.
                marker.dataset.origin = 'rgm';
                $7c3acd9b84fb12ed$var$globalStyleManager.addAdvancedMarkerPointerEventsOverwrite();
            }
        }
    }, [
        marker,
        anchorPoint,
        anchorLeft,
        anchorTop,
        hasChildren
    ]);
}
function $7c3acd9b84fb12ed$var$useCircle(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onRadiusChanged: onRadiusChanged, onCenterChanged: onCenterChanged, center: center, defaultCenter: defaultCenter, radius: radius, defaultRadius: defaultRadius } = props, destructuredOptions = $7c3acd9b84fb12ed$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onRadiusChanged",
        "onCenterChanged",
        "center",
        "defaultCenter",
        "radius",
        "defaultRadius"
    ]);
    const [circle, setCircle] = (0, $kYL7Z.useState)(null);
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    // Memoize options with automatic inference of clickable/draggable/editable
    const circleOptions = $7c3acd9b84fb12ed$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onCenterChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onRadiusChanged)
    }), $7c3acd9b84fb12ed$var$deepEqual);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Circle> has to be inside a Map component.');
            return;
        }
        const newCircle = new google.maps.Circle(Object.assign(Object.assign({}, circleOptions), {
            center: center !== null && center !== void 0 ? center : defaultCenter,
            radius: radius !== null && radius !== void 0 ? radius : defaultRadius
        }));
        newCircle.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setCircle(newCircle);
        return ()=>{
            newCircle.setMap(null);
            setCircle(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- circle options are handled separately to avoid recreating the instance
    }, [
        map
    ]);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'click', onClick);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'drag', onDrag);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'dragstart', onDragStart);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'dragend', onDragEnd);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'mouseover', onMouseOver);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'mouseout', onMouseOut);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'radius_changed', onRadiusChanged ? ()=>{
        const newRadius = circle === null || circle === void 0 ? void 0 : circle.getRadius();
        if (newRadius !== undefined) onRadiusChanged(newRadius);
    } : null);
    $7c3acd9b84fb12ed$var$useMapsEventListener(circle, 'center_changed', onCenterChanged ? ()=>{
        onCenterChanged(circle === null || circle === void 0 ? void 0 : circle.getCenter());
    } : null);
    (0, $kYL7Z.useEffect)(()=>{
        if (!circle) return;
        circle.setOptions(circleOptions);
    }, [
        circle,
        circleOptions
    ]);
    // Sync controlled center prop with the circle instance
    (0, $kYL7Z.useEffect)(()=>{
        if (!circle || !center) return;
        if (!$7c3acd9b84fb12ed$export$e6f27d7c3c3233eb(center, circle.getCenter())) circle.setCenter(center);
    }, [
        circle,
        center
    ]);
    // Sync controlled radius prop with the circle instance
    (0, $kYL7Z.useEffect)(()=>{
        if (!circle || radius === undefined) return;
        if (radius !== circle.getRadius()) circle.setRadius(radius);
    }, [
        circle,
        radius
    ]);
    return circle;
}
const $7c3acd9b84fb12ed$export$c89a927ffc67e6fa = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const circle = $7c3acd9b84fb12ed$var$useCircle(props);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>circle, [
        circle
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null);
});
$7c3acd9b84fb12ed$export$c89a927ffc67e6fa.displayName = 'Circle';
function $7c3acd9b84fb12ed$var$setValueForStyles(element, styles, prevStyles) {
    if (styles != null && typeof styles !== 'object') throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
    const elementStyle = element.style;
    // without `prevStyles`, just set all values
    if (prevStyles == null) {
        if (styles == null) return;
        for(const styleName in styles){
            if (!styles.hasOwnProperty(styleName)) continue;
            $7c3acd9b84fb12ed$var$setValueForStyle(elementStyle, styleName, styles[styleName]);
        }
        return;
    }
    // unset all styles in `prevStyles` that aren't in `styles`
    for(const styleName in prevStyles)if (prevStyles.hasOwnProperty(styleName) && (styles == null || !styles.hasOwnProperty(styleName))) {
        // Clear style
        const isCustomProperty = styleName.indexOf('--') === 0;
        if (isCustomProperty) elementStyle.setProperty(styleName, '');
        else if (styleName === 'float') elementStyle.cssFloat = '';
        else elementStyle[styleName] = '';
    }
    // only assign values from `styles` that are different from `prevStyles`
    if (styles == null) return;
    for(const styleName in styles){
        const value = styles[styleName];
        if (styles.hasOwnProperty(styleName) && prevStyles[styleName] !== value) $7c3acd9b84fb12ed$var$setValueForStyle(elementStyle, styleName, value);
    }
}
function $7c3acd9b84fb12ed$var$setValueForStyle(elementStyle, styleName, value) {
    const isCustomProperty = styleName.indexOf('--') === 0;
    // falsy values will unset the style property
    if (value == null || typeof value === 'boolean' || value === '') {
        if (isCustomProperty) elementStyle.setProperty(styleName, '');
        else if (styleName === 'float') elementStyle.cssFloat = '';
        else elementStyle[styleName] = '';
    } else if (isCustomProperty) elementStyle.setProperty(styleName, value);
    else if (typeof value === 'number' && value !== 0 && !$7c3acd9b84fb12ed$var$isUnitlessNumber(styleName)) elementStyle[styleName] = value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
    else if (styleName === 'float') elementStyle.cssFloat = value;
    else elementStyle[styleName] = ('' + value).trim();
}
// CSS properties which accept numbers but are not in units of "px".
const $7c3acd9b84fb12ed$var$unitlessNumbers = new Set([
    'animationIterationCount',
    'aspectRatio',
    'borderImageOutset',
    'borderImageSlice',
    'borderImageWidth',
    'boxFlex',
    'boxFlexGroup',
    'boxOrdinalGroup',
    'columnCount',
    'columns',
    'flex',
    'flexGrow',
    'flexPositive',
    'flexShrink',
    'flexNegative',
    'flexOrder',
    'gridArea',
    'gridRow',
    'gridRowEnd',
    'gridRowSpan',
    'gridRowStart',
    'gridColumn',
    'gridColumnEnd',
    'gridColumnSpan',
    'gridColumnStart',
    'fontWeight',
    'lineClamp',
    'lineHeight',
    'opacity',
    'order',
    'orphans',
    'scale',
    'tabSize',
    'widows',
    'zIndex',
    'zoom',
    'fillOpacity',
    'floodOpacity',
    'stopOpacity',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth'
]);
function $7c3acd9b84fb12ed$var$isUnitlessNumber(name) {
    return $7c3acd9b84fb12ed$var$unitlessNumbers.has(name);
}
/**
 * Component to render an Info Window with the Maps JavaScript API
 */ const $7c3acd9b84fb12ed$export$6cfec3928ae8881a = (props)=>{
    const { children: // content options
    children, headerContent: headerContent, style: style, className: className, pixelOffset: pixelOffset, anchor: // open options
    anchor, shouldFocus: shouldFocus, onClose: // events
    onClose, onCloseClick: onCloseClick } = props, // other options
    volatileInfoWindowOptions = $7c3acd9b84fb12ed$var$__rest(props, [
        "children",
        "headerContent",
        "style",
        "className",
        "pixelOffset",
        "anchor",
        "shouldFocus",
        "onClose",
        "onCloseClick"
    ]);
    // ## create infowindow instance once the mapsLibrary is available.
    const mapsLibrary = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('maps');
    const [infoWindow, setInfoWindow] = (0, $kYL7Z.useState)(null);
    const contentContainerRef = (0, $kYL7Z.useRef)(null);
    const headerContainerRef = (0, $kYL7Z.useRef)(null);
    const infoWindowOptions = $7c3acd9b84fb12ed$var$useMemoized(volatileInfoWindowOptions, $7c3acd9b84fb12ed$var$deepEqual);
    // ---- initial mount: create content- and header container, create and
    // configure the InfoWindow instance
    (0, $kYL7Z.useEffect)(()=>{
        if (!mapsLibrary) return;
        contentContainerRef.current = document.createElement('div');
        headerContainerRef.current = document.createElement('div');
        const opts = Object.assign({}, infoWindowOptions);
        if (pixelOffset) opts.pixelOffset = new google.maps.Size(pixelOffset[0], pixelOffset[1]);
        if (headerContent) // if headerContent is specified as string we can directly forward it,
        // otherwise we'll pass the element the portal will render into
        opts.headerContent = typeof headerContent === 'string' ? headerContent : headerContainerRef.current;
        // intentionally shadowing the state variables here
        const infoWindow = new google.maps.InfoWindow(opts);
        infoWindow.setContent(contentContainerRef.current);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setInfoWindow(infoWindow);
        // unmount: remove infoWindow and content elements (note: close is called in a different effect-cleanup)
        return ()=>{
            var _a, _b;
            infoWindow.setContent(null);
            (_a = contentContainerRef.current) === null || _a === void 0 || _a.remove();
            (_b = headerContainerRef.current) === null || _b === void 0 || _b.remove();
            contentContainerRef.current = null;
            headerContainerRef.current = null;
            setInfoWindow(null);
        };
    }, // `infoWindowOptions` and other props are missing from dependencies:
    //
    // We don't want to re-create the infowindow instance
    // when the options change.
    // Updating the options is handled in the useEffect below.
    //
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        mapsLibrary
    ]);
    // ---- update className and styles for `contentContainer`
    // prevStyleRef stores previously applied style properties, so they can be
    // removed when unset
    const prevStyleRef = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (!infoWindow || !contentContainerRef.current) return;
        $7c3acd9b84fb12ed$var$setValueForStyles(contentContainerRef.current, style || null, prevStyleRef.current);
        prevStyleRef.current = style || null;
        if (className !== contentContainerRef.current.className) contentContainerRef.current.className = className || '';
    }, [
        infoWindow,
        className,
        style
    ]);
    // ---- update options
    (0, $kYL7Z.useEffect)(()=>{
        if (!infoWindow) return;
        const opts = Object.assign({}, infoWindowOptions);
        if (!pixelOffset) opts.pixelOffset = null;
        else opts.pixelOffset = new google.maps.Size(pixelOffset[0], pixelOffset[1]);
        if (!headerContent) opts.headerContent = null;
        else opts.headerContent = typeof headerContent === 'string' ? headerContent : headerContainerRef.current;
        infoWindow.setOptions(opts);
    }, // dependency `infoWindow` isn't needed since options are also passed
    // to the constructor when a new infoWindow is created.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        infoWindowOptions,
        pixelOffset,
        headerContent
    ]);
    // ---- bind event handlers
    $7c3acd9b84fb12ed$var$useMapsEventListener(infoWindow, 'close', onClose);
    $7c3acd9b84fb12ed$var$useMapsEventListener(infoWindow, 'closeclick', onCloseClick);
    // ---- open info window when content and map are available
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    (0, $kYL7Z.useEffect)(()=>{
        var _a;
        // `anchor === null` means an anchor is defined but not ready yet.
        if (!map || !infoWindow || anchor === null) return;
        const isOpenedWithAnchor = !!anchor;
        const openOptions = {
            map: map
        };
        if (anchor) {
            openOptions.anchor = anchor;
            // Only do the infowindow adjusting when dealing with an AdvancedMarker
            if ($7c3acd9b84fb12ed$export$5f1640ccc146ea2d(anchor) && anchor.content instanceof Element) {
                const anchorBcr = anchor === null || anchor === void 0 ? void 0 : anchor.getBoundingClientRect();
                // This checks whether or not the anchor has custom content with our own
                // div wrapper. If not, that means we have a regular AdvancedMarker without
                // children, or an AdvancedMarker that uses the anchorLeft/anchorTop props.
                // In that case we do not want to adjust the infowindow since it is all handled correctly
                // by the Google Maps API.
                if (anchorBcr && anchor.dataset.origin === 'rgm') {
                    // We can safely typecast here since we control that element and we know that
                    // it is a div
                    const anchorDomContent = (_a = anchor.content.firstElementChild) === null || _a === void 0 ? void 0 : _a.firstElementChild;
                    const contentBcr = anchorDomContent === null || anchorDomContent === void 0 ? void 0 : anchorDomContent.getBoundingClientRect();
                    // center infowindow above marker
                    const anchorOffsetX = contentBcr.x - anchorBcr.x + (contentBcr.width - anchorBcr.width) / 2;
                    const anchorOffsetY = contentBcr.y - anchorBcr.y;
                    const opts = Object.assign({}, infoWindowOptions);
                    opts.pixelOffset = new google.maps.Size(pixelOffset ? pixelOffset[0] + anchorOffsetX : anchorOffsetX, pixelOffset ? pixelOffset[1] + anchorOffsetY : anchorOffsetY);
                    infoWindow.setOptions(opts);
                }
            }
        }
        if (shouldFocus !== undefined) openOptions.shouldFocus = shouldFocus;
        infoWindow.open(openOptions);
        return ()=>{
            // Note: when the infowindow has an anchor, it will automatically show up again when the
            // anchor was removed from the map before infoWindow.close() is called but the it gets
            // added back to the map after that.
            // More information here: https://issuetracker.google.com/issues/343750849
            if (isOpenedWithAnchor) infoWindow.set('anchor', null);
            infoWindow.close();
        };
    }, [
        infoWindow,
        anchor,
        map,
        shouldFocus,
        infoWindowOptions,
        pixelOffset
    ]);
    /* eslint-disable react-hooks/refs -- intentional access to refs during render to avoid cascading renders when creating portals */ return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null, contentContainerRef.current && (0, $cRanb.createPortal)(children, contentContainerRef.current), headerContainerRef.current !== null && (0, $cRanb.createPortal)(headerContent, headerContainerRef.current));
/* eslint-enable react-hooks/refs */ };
/**
 * Extracts paths as a nested array from a Polygon instance.
 */ function $7c3acd9b84fb12ed$var$getPathsArray(polygon) {
    const mvcPaths = polygon.getPaths();
    const result = [];
    for(let i = 0; i < mvcPaths.getLength(); i++)result.push(mvcPaths.getAt(i).getArray());
    return result;
}
function $7c3acd9b84fb12ed$var$usePolygon(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onPathsChanged: onPathsChanged, polygon: externalPolygon, encodedPaths: encodedPaths, paths: paths, defaultPaths: defaultPaths } = props, destructuredOptions = $7c3acd9b84fb12ed$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onPathsChanged",
        "polygon",
        "encodedPaths",
        "paths",
        "defaultPaths"
    ]);
    const [polygon, setPolygon] = (0, $kYL7Z.useState)(null);
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    const geometryLibrary = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('geometry');
    // Track if we're programmatically updating to avoid firing onPathsChanged
    const isUpdatingRef = (0, $kYL7Z.useRef)(false);
    // Memoize options with automatic inference of clickable/draggable/editable
    const polygonOptions = $7c3acd9b84fb12ed$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onPathsChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onPathsChanged)
    }), $7c3acd9b84fb12ed$var$deepEqual);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Polygon> has to be inside a Map component.');
            return;
        }
        // Use provided instance or create a new one
        let instance;
        if (externalPolygon) {
            instance = externalPolygon;
            // Apply initial paths and options to the existing instance
            const initialPaths = paths !== null && paths !== void 0 ? paths : defaultPaths;
            if (initialPaths && Array.isArray(initialPaths)) instance.setPaths(initialPaths);
            instance.setOptions(polygonOptions);
        } else {
            const initialPaths = paths !== null && paths !== void 0 ? paths : defaultPaths;
            const polygonOptionsWithPaths = Object.assign({}, polygonOptions);
            // Google Maps throws "not an Array" error if paths is undefined
            if (initialPaths && Array.isArray(initialPaths)) polygonOptionsWithPaths.paths = initialPaths;
            instance = new google.maps.Polygon(polygonOptionsWithPaths);
        }
        instance.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setPolygon(instance);
        return ()=>{
            instance.setMap(null);
            setPolygon(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options are handled separately to avoid recreating the instance
    }, [
        map,
        externalPolygon
    ]);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polygon, 'click', onClick);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polygon, 'drag', onDrag);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polygon, 'dragstart', onDragStart);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polygon, 'mouseover', onMouseOver);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polygon, 'mouseout', onMouseOut);
    // Fire onPathsChanged on dragend (when whole polygon is dragged)
    $7c3acd9b84fb12ed$var$useMapsEventListener(polygon, 'dragend', (e)=>{
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(e);
        if (onPathsChanged && polygon && !isUpdatingRef.current) onPathsChanged($7c3acd9b84fb12ed$var$getPathsArray(polygon));
    });
    // Subscribe to MVCArray events for vertex-level edits
    (0, $kYL7Z.useEffect)(()=>{
        if (!polygon || !onPathsChanged) return;
        const listeners = [];
        const mvcPaths = polygon.getPaths();
        if (typeof mvcPaths.getLength !== 'function' || typeof mvcPaths.getAt !== 'function') return;
        const handlePathsChange = ()=>{
            if (!isUpdatingRef.current) onPathsChanged($7c3acd9b84fb12ed$var$getPathsArray(polygon));
        };
        // Subscribe to each inner path's events
        const subscribeToInnerPath = (innerPath)=>{
            listeners.push(google.maps.event.addListener(innerPath, 'insert_at', handlePathsChange));
            listeners.push(google.maps.event.addListener(innerPath, 'remove_at', handlePathsChange));
            listeners.push(google.maps.event.addListener(innerPath, 'set_at', handlePathsChange));
        };
        // Subscribe to existing inner paths
        for(let i = 0; i < mvcPaths.getLength(); i++)subscribeToInnerPath(mvcPaths.getAt(i));
        // Subscribe to outer array changes (paths added/removed)
        listeners.push(google.maps.event.addListener(mvcPaths, 'insert_at', (index)=>{
            subscribeToInnerPath(mvcPaths.getAt(index));
            handlePathsChange();
        }));
        listeners.push(google.maps.event.addListener(mvcPaths, 'set_at', (index)=>{
            subscribeToInnerPath(mvcPaths.getAt(index));
            handlePathsChange();
        }));
        listeners.push(google.maps.event.addListener(mvcPaths, 'remove_at', handlePathsChange));
        return ()=>{
            listeners.forEach((listener)=>listener.remove());
        };
    }, [
        polygon,
        onPathsChanged,
        paths,
        encodedPaths,
        polygonOptions.editable,
        polygonOptions.draggable
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!polygon) return;
        polygon.setOptions(polygonOptions);
    }, [
        polygon,
        polygonOptions
    ]);
    // Sync controlled paths prop with the polygon instance
    (0, $kYL7Z.useEffect)(()=>{
        if (!polygon || !paths) return;
        if (!Array.isArray(paths)) return;
        // Normalize to nested array for comparison
        const firstPath = paths[0];
        const normalizedPaths = Array.isArray(firstPath) ? paths : [
            paths
        ];
        const currentPaths = polygon.getPaths();
        if (!$7c3acd9b84fb12ed$export$81bf7c9065d0b5e1(normalizedPaths, currentPaths)) {
            isUpdatingRef.current = true;
            polygon.setPaths(paths);
            isUpdatingRef.current = false;
        }
    }, [
        polygon,
        paths
    ]);
    // Handle encoded paths
    (0, $kYL7Z.useEffect)(()=>{
        if (!polygon || !encodedPaths || !geometryLibrary) return;
        isUpdatingRef.current = true;
        const decodedPaths = encodedPaths.map((encodedPath)=>geometryLibrary.encoding.decodePath(encodedPath));
        polygon.setPaths(decodedPaths);
        isUpdatingRef.current = false;
    }, [
        polygon,
        encodedPaths,
        geometryLibrary
    ]);
    return polygon;
}
const $7c3acd9b84fb12ed$export$7d31b617c820d435 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const polygon = $7c3acd9b84fb12ed$var$usePolygon(props);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>polygon, [
        polygon
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null);
});
$7c3acd9b84fb12ed$export$7d31b617c820d435.displayName = 'Polygon';
function $7c3acd9b84fb12ed$var$usePolyline(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onPathChanged: onPathChanged, polyline: externalPolyline, encodedPath: encodedPath, path: path, defaultPath: defaultPath } = props, destructuredOptions = $7c3acd9b84fb12ed$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onPathChanged",
        "polyline",
        "encodedPath",
        "path",
        "defaultPath"
    ]);
    const [polyline, setPolyline] = (0, $kYL7Z.useState)(null);
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    const geometryLibrary = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('geometry');
    // Track if we're programmatically updating to avoid firing onPathChanged
    const isUpdatingRef = (0, $kYL7Z.useRef)(false);
    // Memoize options with automatic inference of clickable/draggable/editable
    const polylineOptions = $7c3acd9b84fb12ed$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onPathChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onPathChanged)
    }), $7c3acd9b84fb12ed$var$deepEqual);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Polyline> has to be inside a Map component.');
            return;
        }
        // Use provided instance or create a new one
        let instance;
        if (externalPolyline) {
            instance = externalPolyline;
            // Apply initial path and options to the existing instance
            const initialPath = path !== null && path !== void 0 ? path : defaultPath;
            if (initialPath && Array.isArray(initialPath)) instance.setPath(initialPath);
            instance.setOptions(polylineOptions);
        } else {
            const initialPath = path !== null && path !== void 0 ? path : defaultPath;
            const polylineOptionsWithPath = Object.assign({}, polylineOptions);
            // Google Maps throws "not an Array" error if path is undefined
            if (initialPath && Array.isArray(initialPath)) polylineOptionsWithPath.path = initialPath;
            instance = new google.maps.Polyline(polylineOptionsWithPath);
        }
        instance.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setPolyline(instance);
        return ()=>{
            instance.setMap(null);
            setPolyline(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- options are handled separately to avoid recreating the instance
    }, [
        map,
        externalPolyline
    ]);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polyline, 'click', onClick);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polyline, 'drag', onDrag);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polyline, 'dragstart', onDragStart);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polyline, 'mouseover', onMouseOver);
    $7c3acd9b84fb12ed$var$useMapsEventListener(polyline, 'mouseout', onMouseOut);
    // Fire onPathChanged on dragend (when whole polyline is dragged)
    $7c3acd9b84fb12ed$var$useMapsEventListener(polyline, 'dragend', (e)=>{
        onDragEnd === null || onDragEnd === void 0 || onDragEnd(e);
        if (onPathChanged && polyline && !isUpdatingRef.current) onPathChanged(polyline.getPath().getArray());
    });
    // Subscribe to MVCArray events for vertex-level edits
    (0, $kYL7Z.useEffect)(()=>{
        if (!polyline || !onPathChanged) return;
        const mvcPath = polyline.getPath();
        if (!mvcPath) return;
        const handlePathChange = ()=>{
            if (!isUpdatingRef.current) onPathChanged(mvcPath.getArray());
        };
        const listeners = [
            google.maps.event.addListener(mvcPath, 'insert_at', handlePathChange),
            google.maps.event.addListener(mvcPath, 'remove_at', handlePathChange),
            google.maps.event.addListener(mvcPath, 'set_at', handlePathChange)
        ];
        return ()=>{
            listeners.forEach((listener)=>listener.remove());
        };
    }, [
        polyline,
        onPathChanged,
        path,
        encodedPath,
        polylineOptions.editable,
        polylineOptions.draggable
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!polyline) return;
        polyline.setOptions(polylineOptions);
    }, [
        polyline,
        polylineOptions
    ]);
    // Sync controlled path prop with the polyline instance
    (0, $kYL7Z.useEffect)(()=>{
        if (!polyline || !path) return;
        const currentPath = polyline.getPath();
        if (!$7c3acd9b84fb12ed$export$69485f8143efb551(path, currentPath)) {
            isUpdatingRef.current = true;
            polyline.setPath(path);
            isUpdatingRef.current = false;
        }
    }, [
        polyline,
        path
    ]);
    // Handle encoded path
    (0, $kYL7Z.useEffect)(()=>{
        if (!polyline || !encodedPath || !geometryLibrary) return;
        isUpdatingRef.current = true;
        const decodedPath = geometryLibrary.encoding.decodePath(encodedPath);
        polyline.setPath(decodedPath);
        isUpdatingRef.current = false;
    }, [
        polyline,
        encodedPath,
        geometryLibrary
    ]);
    return polyline;
}
const $7c3acd9b84fb12ed$export$79f3ee03e63e7073 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const polyline = $7c3acd9b84fb12ed$var$usePolyline(props);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>polyline, [
        polyline
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null);
});
$7c3acd9b84fb12ed$export$79f3ee03e63e7073.displayName = 'Polyline';
const $7c3acd9b84fb12ed$var$DEFAULT_CAMERA_STATE = {
    center: {
        lat: 0,
        lng: 0,
        altitude: 0
    },
    range: 0,
    heading: 0,
    tilt: 0,
    roll: 0
};
/**
 * Camera property names that correspond to gmp-*change events.
 */ const $7c3acd9b84fb12ed$var$CAMERA_PROPS = [
    'center',
    'range',
    'heading',
    'tilt',
    'roll'
];
/**
 * Updates the camera state ref with values from the map element.
 */ function $7c3acd9b84fb12ed$var$updateCameraState(map3d, ref, prop) {
    const value = map3d[prop];
    if (value == null) return;
    if (prop === 'center') {
        // The center property returns a LatLngAltitude object, convert to literal
        const center = value;
        ref.current.center = center.toJSON ? center.toJSON() : center;
    } else ref.current[prop] = value;
}
/**
 * Creates a mutable ref object to track the last known state of the 3D map camera.
 * This is used in `useMap3DCameraParams` to reduce stuttering by avoiding updates
 * of the map camera with values that have already been processed.
 *
 * @internal
 */ function $7c3acd9b84fb12ed$var$useTrackedCameraStateRef3D(map3d) {
    const forceUpdate = $7c3acd9b84fb12ed$var$useForceUpdate();
    const ref = (0, $kYL7Z.useRef)(Object.assign({}, $7c3acd9b84fb12ed$var$DEFAULT_CAMERA_STATE));
    (0, $kYL7Z.useEffect)(()=>{
        if (!map3d) return;
        const listeners = [];
        for (const prop of $7c3acd9b84fb12ed$var$CAMERA_PROPS){
            const eventName = `gmp-${prop}change`;
            const handler = ()=>{
                $7c3acd9b84fb12ed$var$updateCameraState(map3d, ref, prop);
                forceUpdate();
            };
            map3d.addEventListener(eventName, handler);
            listeners.push(()=>map3d.removeEventListener(eventName, handler));
        }
        return ()=>{
            for (const removeListener of listeners)removeListener();
        };
    }, [
        map3d,
        forceUpdate
    ]);
    return ref;
}
/**
 * Hook to manage the Map3DElement instance lifecycle.
 *
 * Handles:
 * - Waiting for the 'maps3d' library to load
 * - Waiting for the 'gmp-map-3d' custom element to be defined
 * - Creating a callback ref for the element
 * - Applying initial options when the element is ready
 * - Tracking camera state
 *
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMap3DInstance(props) {
    const maps3dLib = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('maps3d');
    const [customElementReady, setCustomElementReady] = (0, $kYL7Z.useState)(false);
    const [, containerRef] = $7c3acd9b84fb12ed$var$useCallbackRef();
    const [map3d, map3dRef] = $7c3acd9b84fb12ed$var$useCallbackRef();
    const cameraStateRef = $7c3acd9b84fb12ed$var$useTrackedCameraStateRef3D(map3d);
    (0, $kYL7Z.useEffect)(()=>{
        customElements.whenDefined('gmp-map-3d').then(()=>{
            setCustomElementReady(true);
        });
    }, []);
    // Apply initial options once when the element is first available
    (0, $kYL7Z.useEffect)(()=>{
        if (!map3d) return;
        const { center: center, heading: heading, tilt: tilt, range: range, roll: roll, defaultCenter: defaultCenter, defaultHeading: defaultHeading, defaultTilt: defaultTilt, defaultRange: defaultRange, defaultRoll: defaultRoll, id: // Non-element props to exclude
        id, style: style, className: className, children: children, onCenterChanged: onCenterChanged, onHeadingChanged: onHeadingChanged, onTiltChanged: onTiltChanged, onRangeChanged: onRangeChanged, onRollChanged: onRollChanged, onCameraChanged: onCameraChanged, onClick: onClick, onSteadyChange: onSteadyChange, onAnimationEnd: onAnimationEnd, onError: onError, mode: mode, gestureHandling: gestureHandling } = props, elementOptions = $7c3acd9b84fb12ed$var$__rest(props, [
            "center",
            "heading",
            "tilt",
            "range",
            "roll",
            "defaultCenter",
            "defaultHeading",
            "defaultTilt",
            "defaultRange",
            "defaultRoll",
            "id",
            "style",
            "className",
            "children",
            "onCenterChanged",
            "onHeadingChanged",
            "onTiltChanged",
            "onRangeChanged",
            "onRollChanged",
            "onCameraChanged",
            "onClick",
            "onSteadyChange",
            "onAnimationEnd",
            "onError",
            "mode",
            "gestureHandling"
        ]);
        const initialCenter = center !== null && center !== void 0 ? center : defaultCenter;
        const initialHeading = heading !== null && heading !== void 0 ? heading : defaultHeading;
        const initialTilt = tilt !== null && tilt !== void 0 ? tilt : defaultTilt;
        const initialRange = range !== null && range !== void 0 ? range : defaultRange;
        const initialRoll = roll !== null && roll !== void 0 ? roll : defaultRoll;
        const initialOptions = Object.assign({}, elementOptions);
        if (initialCenter) initialOptions.center = initialCenter;
        if (initialHeading !== undefined) initialOptions.heading = initialHeading;
        if (initialTilt !== undefined) initialOptions.tilt = initialTilt;
        if (initialRange !== undefined) initialOptions.range = initialRange;
        if (initialRoll !== undefined) initialOptions.roll = initialRoll;
        Object.assign(map3d, initialOptions);
    }, // this effect should only run when the map3d element first becomes
    // available, so we skip re-running it when other props change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        map3d
    ]);
    const isReady = !!maps3dLib && customElementReady;
    return [
        map3d,
        containerRef,
        map3dRef,
        cameraStateRef,
        isReady
    ];
}
/* eslint-disable react-hooks/immutability -- Google Maps API objects are designed to be mutated */ /**
 * Converts a LatLngAltitude or LatLngAltitudeLiteral to a literal object.
 */ function $7c3acd9b84fb12ed$var$toLatLngAltitudeLiteral(value) {
    if (!value) return null;
    // Check if it's a LatLngAltitude object with toJSON method
    if ('toJSON' in value && typeof value.toJSON === 'function') return value.toJSON();
    return value;
}
/**
 * Hook to update Map3D camera parameters when props change.
 * Compares the current camera state with props and updates only when there are differences.
 *
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMap3DCameraParams(map3d, cameraStateRef, props) {
    var _a, _b, _c, _d, _e, _f, _g;
    const centerLiteral = $7c3acd9b84fb12ed$var$toLatLngAltitudeLiteral(props.center);
    const lat = (_a = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.lat) !== null && _a !== void 0 ? _a : null;
    const lng = (_b = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.lng) !== null && _b !== void 0 ? _b : null;
    const altitude = (_c = centerLiteral === null || centerLiteral === void 0 ? void 0 : centerLiteral.altitude) !== null && _c !== void 0 ? _c : null;
    const range = (_d = props.range) !== null && _d !== void 0 ? _d : null;
    const heading = (_e = props.heading) !== null && _e !== void 0 ? _e : null;
    const tilt = (_f = props.tilt) !== null && _f !== void 0 ? _f : null;
    const roll = (_g = props.roll) !== null && _g !== void 0 ? _g : null;
    // Runs on every render to sync controlled camera props with the map element
    (0, $kYL7Z.useLayoutEffect)(()=>{
        var _a;
        if (!map3d) return;
        const currentState = cameraStateRef.current;
        if (lat !== null && lng !== null && (currentState.center.lat !== lat || currentState.center.lng !== lng || altitude !== null && currentState.center.altitude !== altitude)) map3d.center = {
            lat: lat,
            lng: lng,
            altitude: (_a = altitude !== null && altitude !== void 0 ? altitude : currentState.center.altitude) !== null && _a !== void 0 ? _a : 0
        };
        if (range !== null && currentState.range !== range) map3d.range = range;
        if (heading !== null && currentState.heading !== heading) map3d.heading = heading;
        if (tilt !== null && currentState.tilt !== tilt) map3d.tilt = tilt;
        if (roll !== null && currentState.roll !== roll) map3d.roll = roll;
    });
}
/**
 * Camera-related event types for the aggregated onCameraChanged handler.
 */ const $7c3acd9b84fb12ed$var$CAMERA_EVENTS = [
    'gmp-centerchange',
    'gmp-headingchange',
    'gmp-tiltchange',
    'gmp-rangechange',
    'gmp-rollchange'
];
/**
 * Creates a camera changed event with current camera state.
 */ function $7c3acd9b84fb12ed$var$createCameraEvent(map3d, type) {
    const center = map3d.center;
    // Normalize center to LatLngAltitudeLiteral
    // If center is a LatLngAltitude class instance, it has a toJSON method
    // Otherwise it's already a literal object
    let centerLiteral;
    if (center && 'toJSON' in center && typeof center.toJSON === 'function') centerLiteral = center.toJSON();
    else if (center) centerLiteral = center;
    else centerLiteral = {
        lat: 0,
        lng: 0,
        altitude: 0
    };
    return {
        type: type,
        map3d: map3d,
        detail: {
            center: centerLiteral,
            range: map3d.range || 0,
            heading: map3d.heading || 0,
            tilt: map3d.tilt || 0,
            roll: map3d.roll || 0
        }
    };
}
/**
 * Creates a click event from a LocationClickEvent or PlaceClickEvent.
 */ function $7c3acd9b84fb12ed$var$createClickEvent(map3d, srcEvent) {
    const placeClickEvent = srcEvent;
    return {
        type: 'gmp-click',
        map3d: map3d,
        detail: {
            position: srcEvent.position || null,
            placeId: placeClickEvent.placeId
        }
    };
}
/**
 * Creates a steady change event.
 */ function $7c3acd9b84fb12ed$var$createSteadyChangeEvent(map3d, srcEvent) {
    return {
        type: 'gmp-steadychange',
        map3d: map3d,
        detail: {
            isSteady: srcEvent.isSteady
        }
    };
}
/**
 * Hook to set up event handlers for Map3D events.
 *
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMap3DEvents(map3d, props) {
    const { onCenterChanged: onCenterChanged, onHeadingChanged: onHeadingChanged, onTiltChanged: onTiltChanged, onRangeChanged: onRangeChanged, onRollChanged: onRollChanged, onCameraChanged: onCameraChanged, onClick: onClick, onSteadyChange: onSteadyChange, onAnimationEnd: onAnimationEnd, onError: onError } = props;
    $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, 'gmp-centerchange', onCenterChanged, $7c3acd9b84fb12ed$var$createCameraEvent);
    $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, 'gmp-headingchange', onHeadingChanged, $7c3acd9b84fb12ed$var$createCameraEvent);
    $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, 'gmp-tiltchange', onTiltChanged, $7c3acd9b84fb12ed$var$createCameraEvent);
    $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, 'gmp-rangechange', onRangeChanged, $7c3acd9b84fb12ed$var$createCameraEvent);
    $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, 'gmp-rollchange', onRollChanged, $7c3acd9b84fb12ed$var$createCameraEvent);
    // onCameraChanged aggregates all camera property change events into one handler
    (0, $kYL7Z.useEffect)(()=>{
        if (!map3d || !onCameraChanged) return;
        const handler = ()=>{
            onCameraChanged($7c3acd9b84fb12ed$var$createCameraEvent(map3d, 'camerachange'));
        };
        for (const eventName of $7c3acd9b84fb12ed$var$CAMERA_EVENTS)map3d.addEventListener(eventName, handler);
        return ()=>{
            for (const eventName of $7c3acd9b84fb12ed$var$CAMERA_EVENTS)map3d.removeEventListener(eventName, handler);
        };
    }, [
        map3d,
        onCameraChanged
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map3d || !onClick) return;
        const handler = (ev)=>{
            onClick($7c3acd9b84fb12ed$var$createClickEvent(map3d, ev));
        };
        map3d.addEventListener('gmp-click', handler);
        return ()=>map3d.removeEventListener('gmp-click', handler);
    }, [
        map3d,
        onClick
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map3d || !onSteadyChange) return;
        const handler = (ev)=>{
            onSteadyChange($7c3acd9b84fb12ed$var$createSteadyChangeEvent(map3d, ev));
        };
        map3d.addEventListener('gmp-steadychange', handler);
        return ()=>map3d.removeEventListener('gmp-steadychange', handler);
    }, [
        map3d,
        onSteadyChange
    ]);
    $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, 'gmp-animationend', onAnimationEnd, (map3d, type)=>({
            type: type,
            map3d: map3d
        }));
    $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, 'gmp-error', onError, (map3d, type)=>({
            type: type,
            map3d: map3d
        }));
}
/**
 * Helper hook for individual events.
 */ function $7c3acd9b84fb12ed$var$useMap3DEvent(map3d, eventName, handler, createEvent) {
    (0, $kYL7Z.useEffect)(()=>{
        if (!map3d || !handler) return;
        const listener = ()=>{
            handler(createEvent(map3d, eventName));
        };
        map3d.addEventListener(eventName, listener);
        return ()=>map3d.removeEventListener(eventName, listener);
    }, [
        map3d,
        eventName,
        handler,
        createEvent
    ]);
}
/**
 * Set of option keys that can be updated on Map3DElement.
 * Camera props (center, heading, tilt, range, roll) are handled separately.
 */ const $7c3acd9b84fb12ed$var$MAP_3D_OPTION_KEYS = new Set([
    'bounds',
    'defaultUIHidden',
    'gestureHandling',
    'internalUsageAttributionIds',
    'maxAltitude',
    'maxHeading',
    'maxTilt',
    'minAltitude',
    'minHeading',
    'minTilt',
    'mode'
]);
/**
 * Hook to update Map3D options when props change.
 *
 * @internal
 */ function $7c3acd9b84fb12ed$var$useMap3DOptions(map3d, props) {
    // Filter props to only include valid option keys, memoized to avoid
    // creating a new object on every render
    const options = (0, $kYL7Z.useMemo)(()=>{
        const result = {};
        const keys = Object.keys(props);
        for (const key of keys){
            if (!$7c3acd9b84fb12ed$var$MAP_3D_OPTION_KEYS.has(key)) continue;
            const value = props[key];
            if (value === undefined) continue;
            result[key] = value;
        }
        return result;
    }, [
        props
    ]);
    $7c3acd9b84fb12ed$var$useDeepCompareEffect(()=>{
        if (!map3d) return;
        Object.assign(map3d, options);
    }, [
        map3d,
        options
    ]);
}
/**
 * MapMode for specifying how the 3D map should be rendered.
 * This mirrors google.maps.maps3d.MapMode but is available without waiting for the API to load.
 */ const $7c3acd9b84fb12ed$export$39cf3280165f92aa = {
    /** This map mode displays a transparent layer of major streets on satellite imagery. */ HYBRID: 'HYBRID',
    /** This map mode displays satellite or photorealistic imagery. */ SATELLITE: 'SATELLITE'
};
/**
 * GestureHandling for specifying how gesture events should be handled on the map.
 * This mirrors google.maps.maps3d.GestureHandling but is available without waiting for the API to load.
 */ const $7c3acd9b84fb12ed$export$9ac34b33b94379d1 = {
    /**
     * This lets the map choose whether to use cooperative or greedy gesture handling.
     * This is the default behavior if not specified.
     */ AUTO: 'AUTO',
    /**
     * This forces cooperative mode, where modifier keys or two-finger gestures
     * are required to scroll the map.
     */ COOPERATIVE: 'COOPERATIVE',
    /**
     * This forces greedy mode, where the host page cannot be scrolled from user
     * events on the map element.
     */ GREEDY: 'GREEDY'
};
/**
 * React context for accessing the Map3D instance from child components.
 */ const $7c3acd9b84fb12ed$export$b4118d11ca82abca = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createContext(null);
/**
 * Default styles for the map container.
 */ const $7c3acd9b84fb12ed$var$DEFAULT_CONTAINER_STYLE = {
    width: '100%',
    height: '100%',
    position: 'relative'
};
/**
 * A React component that renders a 3D map using the Google Maps JavaScript API.
 *
 * @example
 * ```tsx
 * <APIProvider apiKey={API_KEY}>
 *   <Map3D
 *     defaultCenter={{ lat: 37.7749, lng: -122.4194, altitude: 1000 }}
 *     defaultRange={5000}
 *     defaultHeading={0}
 *     defaultTilt={45}
 *   />
 * </APIProvider>
 * ```
 */ const $7c3acd9b84fb12ed$export$e9000d5af15800a8 = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const { children: children, id: id, className: className, style: style } = props;
    // Verify we're inside an APIProvider
    const context = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$84e9974bcf67d1d);
    if (!context) throw new Error('<Map3D> can only be used inside an <APIProvider> component.');
    const { addMap3DInstance: addMap3DInstance, removeMap3DInstance: removeMap3DInstance } = context;
    const [map3d, containerRef, map3dRef, cameraStateRef, isReady] = $7c3acd9b84fb12ed$var$useMap3DInstance(props);
    $7c3acd9b84fb12ed$var$useMap3DCameraParams(map3d, cameraStateRef, props);
    $7c3acd9b84fb12ed$var$useMap3DEvents(map3d, props);
    $7c3acd9b84fb12ed$var$useMap3DOptions(map3d, props);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map3d) return;
        const instanceId = id !== null && id !== void 0 ? id : 'default';
        addMap3DInstance(map3d, instanceId);
        return ()=>{
            removeMap3DInstance(instanceId);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        map3d,
        id
    ]);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>({
            map3d: map3d,
            flyCameraAround: (options)=>{
                map3d === null || map3d === void 0 || map3d.flyCameraAround(options);
            },
            flyCameraTo: (options)=>{
                map3d === null || map3d === void 0 || map3d.flyCameraTo(options);
            },
            stopCameraAnimation: ()=>{
                map3d === null || map3d === void 0 || map3d.stopCameraAnimation();
            }
        }), [
        map3d
    ]);
    const combinedStyle = (0, $kYL7Z.useMemo)(()=>Object.assign(Object.assign({}, $7c3acd9b84fb12ed$var$DEFAULT_CONTAINER_STYLE), style), [
        style
    ]);
    const contextValue = (0, $kYL7Z.useMemo)(()=>({
            map3d: map3d
        }), [
        map3d
    ]);
    if (!isReady) return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", Object.assign({
        ref: containerRef,
        "data-testid": "map-3d",
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}));
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", Object.assign({
        ref: containerRef,
        "data-testid": "map-3d",
        style: className ? undefined : combinedStyle,
        className: className
    }, id ? {
        id: id
    } : {}), (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("gmp-map-3d", {
        ref: map3dRef,
        style: {
            width: '100%',
            height: '100%'
        }
    }, map3d && (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$export$b4118d11ca82abca.Provider, {
        value: contextValue
    }, children)));
});
$7c3acd9b84fb12ed$export$e9000d5af15800a8.displayName = 'Map3D';
const $7c3acd9b84fb12ed$export$f2451a5061be5eec = (0, $kYL7Z.createContext)(null);
/**
 * Hook to access the Marker3D context.
 */ function $7c3acd9b84fb12ed$export$77f6962a5c3dbd02() {
    return (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$f2451a5061be5eec);
}
/**
 * AltitudeMode for specifying how altitude is interpreted for 3D elements.
 * This mirrors google.maps.maps3d.AltitudeMode but is available without waiting for the API to load.
 */ const $7c3acd9b84fb12ed$export$daecfdca8d2f39c6 = {
    /** Allows to express objects relative to the average mean sea level. */ ABSOLUTE: 'ABSOLUTE',
    /** Allows to express objects placed on the ground. */ CLAMP_TO_GROUND: 'CLAMP_TO_GROUND',
    /** Allows to express objects relative to the ground surface. */ RELATIVE_TO_GROUND: 'RELATIVE_TO_GROUND',
    /** Allows to express objects relative to the highest of ground+building+water surface. */ RELATIVE_TO_MESH: 'RELATIVE_TO_MESH'
};
/**
 * Marker3D component for displaying markers on a Map3D.
 *
 * Automatically uses Marker3DInteractiveElement when onClick is provided,
 * otherwise uses Marker3DElement.
 *
 * Children can include:
 * - `<img>` elements (automatically wrapped in <template>)
 * - `<svg>` elements (automatically wrapped in <template>)
 * - PinElement instances (passed through directly)
 *
 * @example
 * ```tsx
 * // Basic marker
 * <Marker3D position={{ lat: 37.7749, lng: -122.4194 }} label="SF" />
 *
 * // Interactive marker
 * <Marker3D
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   onClick={() => console.log('clicked')}
 *   title="Click me"
 * />
 *
 * // Custom marker with image
 * <Marker3D position={{ lat: 37.7749, lng: -122.4194 }}>
 *   <img src="/icon.png" width={32} height={32} />
 * </Marker3D>
 * ```
 */ const $7c3acd9b84fb12ed$export$9fe96214cc610e48 = (0, $kYL7Z.forwardRef)(function Marker3D(props, ref) {
    const { children: children, onClick: onClick, position: position, altitudeMode: altitudeMode, collisionBehavior: collisionBehavior, drawsWhenOccluded: drawsWhenOccluded, extruded: extruded, label: label, sizePreserved: sizePreserved, zIndex: zIndex, title: title } = props;
    const isInteractive = Boolean(onClick);
    const [marker, setMarker] = (0, $kYL7Z.useState)(null);
    // Track if a child component (like Pin) is handling its own content
    const [contentHandledExternally, setContentHandledExternally] = (0, $kYL7Z.useState)(false);
    // Create a container for rendering React children to be wrapped and relocated
    // into the parent gmp-marker-3d element.
    const contentContainer = (0, $kYL7Z.useMemo)(()=>{
        const container = document.createElement('div');
        container.style.display = 'none';
        document.body.appendChild(container);
        return container;
    }, []);
    // Remove the container on unmount
    (0, $kYL7Z.useEffect)(()=>{
        return ()=>contentContainer.remove();
    }, [
        contentContainer
    ]);
    // Callback ref that sets both internal state and forwards the ref
    const markerRef = (0, $kYL7Z.useCallback)((node)=>{
        setMarker(node);
        if (typeof ref === 'function') ref(node);
        else if (ref) ref.current = node;
    }, [
        ref
    ]);
    $7c3acd9b84fb12ed$var$useDomEventListener(marker, 'gmp-click', onClick);
    // Move React children to marker's slot, wrapping img/svg in <template> as required by the API
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (contentHandledExternally) return;
        if (!marker || !contentContainer) return;
        while(marker.firstChild)marker.removeChild(marker.firstChild);
        const childNodes = Array.from(contentContainer.childNodes);
        for (const node of childNodes){
            if (node.nodeType !== Node.ELEMENT_NODE) continue;
            const element = node;
            const tagName = element.tagName.toLowerCase();
            if (tagName === 'img' || tagName === 'svg') {
                const template = document.createElement('template');
                template.content.appendChild(element.cloneNode(true));
                marker.appendChild(template);
            } else marker.appendChild(element.cloneNode(true));
        }
    }, [
        marker,
        contentContainer,
        children,
        contentHandledExternally
    ]);
    const contextValue = (0, $kYL7Z.useMemo)(()=>({
            marker: marker,
            setContentHandledExternally: setContentHandledExternally
        }), [
        marker
    ]);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'position', position);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'altitudeMode', altitudeMode);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'collisionBehavior', collisionBehavior);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'drawsWhenOccluded', drawsWhenOccluded);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'extruded', extruded);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'label', label);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'sizePreserved', sizePreserved);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'zIndex', zIndex);
    $7c3acd9b84fb12ed$var$usePropBinding(marker, 'title', title !== null && title !== void 0 ? title : '');
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$export$f2451a5061be5eec.Provider, {
        value: contextValue
    }, isInteractive ? (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("gmp-marker-3d-interactive", {
        ref: markerRef
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("gmp-marker-3d", {
        ref: markerRef
    }), (0, $cRanb.createPortal)(children, contentContainer));
});
$7c3acd9b84fb12ed$export$9fe96214cc610e48.displayName = 'Marker3D';
/**
 * Popover component for displaying info windows on a Map3D.
 *
 * Similar to InfoWindow for 2D maps, Popover provides a way to show
 * contextual information at a specific location or attached to a marker
 * on a 3D map.
 *
 * @example
 * ```tsx
 * // Basic popover at position
 * <Popover
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   open={isOpen}
 * >
 *   <div>Hello from San Francisco!</div>
 * </Popover>
 *
 * // Popover anchored to a marker (place as sibling, use anchor prop)
 * <Marker3D
 *   ref={markerRef}
 *   position={{ lat: 37.7749, lng: -122.4194 }}
 *   onClick={() => setOpen(true)}
 * />
 * <Popover
 *   anchor={markerRef.current}
 *   open={isOpen}
 *   onClose={() => setOpen(false)}
 * >
 *   <div>Marker info</div>
 * </Popover>
 * ```
 */ const $7c3acd9b84fb12ed$export$5b6b19405a83ff9d = (0, $kYL7Z.forwardRef)(function Popover(props, ref) {
    var _a;
    const { children: children, headerContent: headerContent, style: style, className: className, open: open = true, position: position, anchor: anchor, anchorId: anchorId, altitudeMode: altitudeMode, lightDismissDisabled: lightDismissDisabled, autoPanDisabled: autoPanDisabled, onClose: onClose } = props;
    const [popover, setPopover] = (0, $kYL7Z.useState)(null);
    const prevStyleRef = (0, $kYL7Z.useRef)(null);
    // Forward the ref to the parent
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>popover, [
        popover
    ]);
    // Observe the open attribute and call onClose when popover is automatically
    // closed by the Maps API (light dismiss)
    $7c3acd9b84fb12ed$var$usePopoverCloseObserver(popover, open, onClose);
    // Set properties on the popover element
    $7c3acd9b84fb12ed$var$usePropBinding(popover, 'open', open !== null && open !== void 0 ? open : false);
    $7c3acd9b84fb12ed$var$usePropBinding(popover, 'altitudeMode', altitudeMode);
    $7c3acd9b84fb12ed$var$usePropBinding(popover, 'lightDismissDisabled', lightDismissDisabled);
    $7c3acd9b84fb12ed$var$usePropBinding(popover, 'autoPanDisabled', autoPanDisabled);
    // positionAnchor accepts a position, marker element, or marker ID string
    const positionAnchor = (_a = anchor !== null && anchor !== void 0 ? anchor : anchorId) !== null && _a !== void 0 ? _a : position;
    $7c3acd9b84fb12ed$var$usePropBinding(popover, 'positionAnchor', positionAnchor);
    // Set styles via ref for compatibility with older React versions
    (0, $kYL7Z.useLayoutEffect)(()=>{
        if (!popover) return;
        $7c3acd9b84fb12ed$var$setValueForStyles(popover, style || null, prevStyleRef.current);
        prevStyleRef.current = style || null;
    }, [
        popover,
        style
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("gmp-popover", {
        ref: setPopover,
        className: className
    }, headerContent && (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        slot: "header"
    }, headerContent), children);
});
$7c3acd9b84fb12ed$export$5b6b19405a83ff9d.displayName = 'Popover';
/**
 * Custom hook to observe the open attribute of a popover element
 * and call onClose when it transitions from open to closed due to light dismiss.
 * Does not call onClose when the open prop changes programmatically.
 */ function $7c3acd9b84fb12ed$var$usePopoverCloseObserver(popover, open, onClose) {
    const previousOpenState = (0, $kYL7Z.useRef)(undefined);
    const openPropRef = (0, $kYL7Z.useRef)(open);
    // Track the open prop value
    (0, $kYL7Z.useEffect)(()=>{
        openPropRef.current = open;
    }, [
        open
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!popover || !onClose) return;
        const observer = new MutationObserver((mutations)=>{
            for (const mutation of mutations)if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
                const isOpen = popover.hasAttribute('open');
                // Only call onClose when:
                // 1. Transitioning from open to closed
                // 2. The prop hasn't changed to false (meaning this was light dismiss, not programmatic)
                if (previousOpenState.current === true && !isOpen && openPropRef.current !== false) onClose();
                previousOpenState.current = isOpen;
            }
        });
        observer.observe(popover, {
            attributes: true,
            attributeFilter: [
                'open'
            ]
        });
        // Initialize the previous state
        previousOpenState.current = popover.hasAttribute('open');
        return ()=>{
            observer.disconnect();
        };
    }, [
        popover,
        onClose
    ]);
}
/**
 * Formats a location into a string representation suitable for Google Static Maps API.
 *
 * @param location - The location to format, can be either a string or an object with lat/lng properties
 * @returns A string representation of the location in the format "lat,lng" or the original string
 *
 * @example
 * // Returns "40.714728,-73.998672"
 * formatLocation({ lat: 40.714728, lng: -73.998672 })
 *
 * @example
 * // Returns "New York, NY"
 * formatLocation("New York, NY")
 */ function $7c3acd9b84fb12ed$var$formatLocation(location) {
    return typeof location === 'string' ? location : `${location.lat},${location.lng}`;
}
// Used for removing the leading pipe from the param string
function $7c3acd9b84fb12ed$var$formatParam(string) {
    return string.slice(1);
}
/**
 * Assembles marker parameters for static maps.
 *
 * This function takes an array of markers and groups them by their style properties.
 * It then creates a string representation of these markers, including their styles and locations,
 * which can be used as parameters for static map APIs.
 *
 * @param {StaticMapsMarker[]} [markers=[]] - An array of markers to be processed. Each marker can have properties such as color, label, size, scale, icon, anchor, and location.
 * @returns {string[]} An array of strings, each representing a group of markers with their styles and locations.
 *
 * @example
 * const markers = [
 *   { color: 'blue', label: 'A', size: 'mid', location: '40.714728,-73.998672' },
 *   { color: 'blue', label: 'B', size: 'mid', location: '40.714728,-73.998672' },
 *   { icon: 'http://example.com/icon.png', location: { lat: 40.714728, lng: -73.998672 } }
 * ];
 * const params = assembleMarkerParams(markers);
 * // Params will be an array of strings representing the marker parameters
 * Example output: [
 *   "color:blue|label:A|size:mid|40.714728,-73.998672|40.714728,-73.998672",
 *   "color:blue|label:B|size:mid|40.714728,-73.998672|40.714728,-73.998672",
 *   "icon:http://example.com/icon.png|40.714728,-73.998672"
 * ]
 */ function $7c3acd9b84fb12ed$var$assembleMarkerParams(markers = []) {
    const markerParams = [];
    // Group markers by style
    const markersByStyle = markers === null || markers === void 0 ? void 0 : markers.reduce((styles, marker)=>{
        const { color: color = 'red', label: label, size: size, scale: scale, icon: icon, anchor: anchor } = marker;
        // Create a unique style key based on either icon properties or standard marker properties
        const relevantProps = icon ? [
            icon,
            anchor,
            scale
        ] : [
            color,
            label,
            size
        ];
        const key = relevantProps.filter(Boolean).join('-');
        styles[key] = styles[key] || [];
        styles[key].push(marker);
        return styles;
    }, {});
    Object.values(markersByStyle !== null && markersByStyle !== void 0 ? markersByStyle : {}).forEach((markers)=>{
        let markerParam = '';
        const { icon: icon } = markers[0];
        // Create marker style from first marker in group since all markers share the same style.
        Object.entries(markers[0]).forEach(([key, value])=>{
            // Determine which properties to include based on whether marker uses custom icon
            const relevantKeys = icon ? [
                'icon',
                'anchor',
                'scale'
            ] : [
                'color',
                'label',
                'size'
            ];
            if (relevantKeys.includes(key)) markerParam += `|${key}:${value}`;
        });
        // Add location coordinates for each marker in the style group
        // Handles both string locations and lat/lng object formats.
        for (const marker of markers){
            const location = typeof marker.location === 'string' ? marker.location : `${marker.location.lat},${marker.location.lng}`;
            markerParam += `|${location}`;
        }
        markerParams.push(markerParam);
    });
    return markerParams.map($7c3acd9b84fb12ed$var$formatParam);
}
// Style properties that can be applied to paths in the Static Maps API
const $7c3acd9b84fb12ed$var$PATH_STYLE_KEYS = [
    'color',
    'weight',
    'fillcolor',
    'geodesic'
];
/**
 * Builds the style portion of a path parameter string.
 * @param path - The path object containing style properties
 * @returns A string with style parameters in the format "|key:value"
 */ function $7c3acd9b84fb12ed$var$buildStyleParams(path) {
    let styleParams = '';
    $7c3acd9b84fb12ed$var$PATH_STYLE_KEYS.forEach((key)=>{
        if (path[key] !== undefined) styleParams += `|${key}:${path[key]}`;
    });
    return styleParams;
}
/**
 * Builds the coordinates portion of a path parameter string.
 * @param coordinates - Either a string or array of location objects
 * @returns A string with coordinates in the format "|lat,lng|lat,lng"
 */ function $7c3acd9b84fb12ed$var$buildCoordinateParams(coordinates) {
    if (typeof coordinates === 'string') return `|${decodeURIComponent(coordinates)}`;
    return coordinates.map((location)=>`|${$7c3acd9b84fb12ed$var$formatLocation(location)}`).join('');
}
/**
 * Assembles path parameters for the Static Maps API from an array of paths.
 *
 * This function constructs a string of path parameters for each path. Each path parameter string
 * includes the style properties and the coordinates of the paths.
 *
 * @param {Array<StaticMapsPath>} [paths=[]] - An array of paths to be assembled into path parameters.
 * @returns {Array<string>} An array of path parameter strings.
 *
 * @example
 * ```typescript
 * const paths = [
 *   {
 *     color: 'red',
 *     weight: 5,
 *     coordinates: [
 *       { lat: 40.714728, lng: -73.998672 },
 *       { lat: 40.718217, lng: -73.998284 }
 *     ]
 *   }
 * ];
 *
 * const pathParams = assemblePathParams(paths);
 * // Output: ['color:red|weight:5|40.714728,-73.998672|40.718217,-73.998284']
 * ```
 */ function $7c3acd9b84fb12ed$var$assemblePathParams(paths = []) {
    return paths.map((path)=>{
        const styleParams = $7c3acd9b84fb12ed$var$buildStyleParams(path);
        const coordinateParams = $7c3acd9b84fb12ed$var$buildCoordinateParams(path.coordinates);
        const pathParam = styleParams + coordinateParams;
        return $7c3acd9b84fb12ed$var$formatParam(pathParam);
    });
}
/**
 * Converts an array of Google Maps style objects into an array of style strings
 * compatible with the Google Static Maps API.
 *
 * @param styles - An array of Google Maps MapTypeStyle objects that define the styling rules
 * @returns An array of formatted style strings ready to be used with the Static Maps API
 *
 * @example
 * const styles = [{
 *   featureType: "road",
 *   elementType: "geometry",
 *   stylers: [{color: "#ff0000"}, {weight: 1}]
 * }];
 *
 * const styleStrings = assembleMapTypeStyles(styles);
 * // Returns: ["|feature:road|element:geometry|color:0xff0000|weight:1"]
 *
 * Each style string follows the format:
 * "feature:{featureType}|element:{elementType}|{stylerName}:{stylerValue}"
 *
 * Note: Color values with hexadecimal notation (#) are automatically converted
 * to the required 0x format for the Static Maps API.
 */ function $7c3acd9b84fb12ed$var$assembleMapTypeStyles(styles) {
    return styles.map((mapTypeStyle)=>{
        const { featureType: featureType, elementType: elementType, stylers: stylers = [] } = mapTypeStyle;
        let styleString = '';
        if (featureType) styleString += `|feature:${featureType}`;
        if (elementType) styleString += `|element:${elementType}`;
        for (const styler of stylers)Object.entries(styler).forEach(([name, value])=>{
            styleString += `|${name}:${String(value).replace('#', '0x')}`;
        });
        return styleString;
    }).map($7c3acd9b84fb12ed$var$formatParam);
}
const $7c3acd9b84fb12ed$var$STATIC_MAPS_BASE = 'https://maps.googleapis.com/maps/api/staticmap';
/**
 * Creates a URL for the Google Static Maps API with the specified parameters.
 *
 * @param {Object} options - The configuration options for the static map
 * @param {string} options.apiKey - Your Google Maps API key (required)
 * @param {number} options.width - The width of the map image in pixels (required)
 * @param {number} options.height - The height of the map image in pixels (required)
 * @param {StaticMapsLocation} [options.center] - The center point of the map (lat/lng or address).
 *  Required if no markers or paths or "visible locations" are provided.
 * @param {number} [options.zoom] - The zoom level of the map. Required if no markers or paths or "visible locations" are provided.
 * @param {1|2|4} [options.scale] - The resolution of the map (1, 2, or 4)
 * @param {string} [options.format] - The image format (png, png8, png32, gif, jpg, jpg-baseline)
 * @param {string} [options.mapType] - The type of map (roadmap, satellite, terrain, hybrid)
 * @param {string} [options.language] - The language of the map labels
 * @param {string} [options.region] - The region code for the map
 * @param {string} [options.map_id] - The Cloud-based map style ID
 * @param {StaticMapsMarker[]} [options.markers=[]] - Array of markers to display on the map
 * @param {StaticMapsPath[]} [options.paths=[]] - Array of paths to display on the map
 * @param {StaticMapsLocation[]} [options.visible=[]] - Array of locations that should be visible on the map
 * @param {MapTypeStyle[]} [options.style=[]] - Array of style objects to customize the map appearance
 *
 * @returns {string} The complete Google Static Maps API URL
 *
 * @throws {Error} If API key is not provided
 * @throws {Error} If width or height is not provided
 *
 * @example
 * const url = createStaticMapsUrl({
 *   apiKey: 'YOUR_API_KEY',
 *   width: 600,
 *   height: 400,
 *   center: { lat: 40.714728, lng: -73.998672 },
 *   zoom: 12,
 *   markers: [
 *     {
 *       location: { lat: 40.714728, lng: -73.998672 },
 *       color: 'red',
 *       label: 'A'
 *     }
 *   ],
 *   paths: [
 *     {
 *       coordinates: [
 *         { lat: 40.714728, lng: -73.998672 },
 *         { lat: 40.719728, lng: -73.991672 }
 *       ],
 *       color: '0x0000ff',
 *       weight: 5
 *     }
 *   ],
 *   style: [
 *     {
 *       featureType: 'road',
 *       elementType: 'geometry',
 *       stylers: [{color: '#00ff00'}]
 *     }
 *   ]
 * });
 *
 * // Results in URL similar to:
 * // https://maps.googleapis.com/maps/api/staticmap?key=YOUR_API_KEY
 * // &size=600x400
 * // &center=40.714728,-73.998672&zoom=12
 * // &markers=color:red|label:A|40.714728,-73.998672
 * // &path=color:0x0000ff|weight:5|40.714728,-73.998672|40.719728,-73.991672
 * // &style=feature:road|element:geometry|color:0x00ff00
 */ function $7c3acd9b84fb12ed$export$5b07f2165c617d35({ apiKey: apiKey, width: width, height: height, center: center, zoom: zoom, scale: scale, format: format, mapType: mapType, language: language, region: region, mapId: mapId, markers: markers = [], paths: paths = [], visible: visible = [], style: style = [] }) {
    if (!apiKey) console.warn('API key is required');
    if (!width || !height) console.warn('Width and height are required');
    const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        key: apiKey,
        size: `${width}x${height}`
    }, center && {
        center: $7c3acd9b84fb12ed$var$formatLocation(center)
    }), zoom && {
        zoom: zoom
    }), scale && {
        scale: scale
    }), format && {
        format: format
    }), mapType && {
        maptype: mapType
    }), language && {
        language: language
    }), region && {
        region: region
    }), mapId && {
        map_id: mapId
    });
    const url = new URL($7c3acd9b84fb12ed$var$STATIC_MAPS_BASE);
    // Params that don't need special handling
    Object.entries(params).forEach(([key, value])=>{
        url.searchParams.append(key, String(value));
    });
    // Assemble Markers
    for (const markerParam of $7c3acd9b84fb12ed$var$assembleMarkerParams(markers))url.searchParams.append('markers', markerParam);
    // Assemble Paths
    for (const pathParam of $7c3acd9b84fb12ed$var$assemblePathParams(paths))url.searchParams.append('path', pathParam);
    // Assemble visible locations
    if (visible.length) url.searchParams.append('visible', visible.map((location)=>$7c3acd9b84fb12ed$var$formatLocation(location)).join('|'));
    // Assemble Map Type Styles
    for (const styleString of $7c3acd9b84fb12ed$var$assembleMapTypeStyles(style))url.searchParams.append('style', styleString);
    return url.toString();
}
const $7c3acd9b84fb12ed$export$ea9999dae6eb05c6 = (props)=>{
    const { url: url, className: className } = props;
    if (!url) throw new Error('URL is required');
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("img", {
        className: className,
        src: url,
        width: "100%"
    });
};
/**
 * Copy of the `google.maps.ControlPosition` constants.
 * They have to be duplicated here since we can't wait for the maps API to load to be able to use them.
 */ const $7c3acd9b84fb12ed$export$90e210fd0946c45e = {
    TOP_LEFT: 1,
    TOP_CENTER: 2,
    TOP: 2,
    TOP_RIGHT: 3,
    LEFT_CENTER: 4,
    LEFT_TOP: 5,
    LEFT: 5,
    LEFT_BOTTOM: 6,
    RIGHT_TOP: 7,
    RIGHT: 7,
    RIGHT_CENTER: 8,
    RIGHT_BOTTOM: 9,
    BOTTOM_LEFT: 10,
    BOTTOM_CENTER: 11,
    BOTTOM: 11,
    BOTTOM_RIGHT: 12,
    CENTER: 13,
    BLOCK_START_INLINE_START: 14,
    BLOCK_START_INLINE_CENTER: 15,
    BLOCK_START_INLINE_END: 16,
    INLINE_START_BLOCK_CENTER: 17,
    INLINE_START_BLOCK_START: 18,
    INLINE_START_BLOCK_END: 19,
    INLINE_END_BLOCK_START: 20,
    INLINE_END_BLOCK_CENTER: 21,
    INLINE_END_BLOCK_END: 22,
    BLOCK_END_INLINE_START: 23,
    BLOCK_END_INLINE_CENTER: 24,
    BLOCK_END_INLINE_END: 25
};
const $7c3acd9b84fb12ed$export$68000b548d3309a0 = ({ children: children, position: position, className: className })=>{
    const controlContainer = (0, $kYL7Z.useMemo)(()=>document.createElement('div'), []);
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    (0, $kYL7Z.useEffect)(()=>{
        // eslint-disable-next-line react-hooks/immutability -- the control container DOM node is intentionally mutated from effects
        controlContainer.className = className !== null && className !== void 0 ? className : '';
    }, [
        controlContainer,
        className
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) return;
        const controls = map.controls[position];
        controls.push(controlContainer);
        return ()=>{
            const controlsArray = controls.getArray();
            // controlsArray could be undefined if the map is in an undefined state (e.g. invalid API-key, see #276
            if (!controlsArray) return;
            const index = controlsArray.indexOf(controlContainer);
            controls.removeAt(index);
        };
    }, [
        controlContainer,
        map,
        position
    ]);
    return (0, $cRanb.createPortal)(children, controlContainer);
};
function $7c3acd9b84fb12ed$var$useMarker(props) {
    const [marker, setMarker] = (0, $kYL7Z.useState)(null);
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut } = props, markerOptions = $7c3acd9b84fb12ed$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut"
    ]);
    const { position: position, draggable: draggable } = markerOptions;
    // create marker instance and add to the map once the map is available
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Marker> has to be inside a Map component.');
            return;
        }
        const newMarker = new google.maps.Marker(markerOptions);
        newMarker.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setMarker(newMarker);
        return ()=>{
            newMarker.setMap(null);
            setMarker(null);
        };
    // We do not want to re-render the whole marker when the options change.
    // Marker options update is handled in a useEffect below.
    // Excluding markerOptions from dependency array on purpose here.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        map
    ]);
    // attach and re-attach event-handlers when any of the properties change
    (0, $kYL7Z.useEffect)(()=>{
        if (!marker) return;
        const m = marker;
        // Add event listeners
        const gme = google.maps.event;
        if (onClick) gme.addListener(m, 'click', onClick);
        if (onDrag) gme.addListener(m, 'drag', onDrag);
        if (onDragStart) gme.addListener(m, 'dragstart', onDragStart);
        if (onDragEnd) gme.addListener(m, 'dragend', onDragEnd);
        if (onMouseOver) gme.addListener(m, 'mouseover', onMouseOver);
        if (onMouseOut) gme.addListener(m, 'mouseout', onMouseOut);
        marker.setDraggable(Boolean(draggable));
        return ()=>{
            gme.clearInstanceListeners(m);
        };
    }, [
        marker,
        draggable,
        onClick,
        onDrag,
        onDragStart,
        onDragEnd,
        onMouseOver,
        onMouseOut
    ]);
    // update markerOptions (note the dependencies aren't properly checked
    // here, we just assume that setOptions is smart enough to not waste a
    // lot of time updating values that didn't change)
    (0, $kYL7Z.useEffect)(()=>{
        if (!marker) return;
        if (markerOptions) marker.setOptions(markerOptions);
    }, [
        marker,
        markerOptions
    ]);
    // update position when changed
    (0, $kYL7Z.useEffect)(()=>{
        // Should not update position when draggable
        if (draggable || !position || !marker) return;
        marker.setPosition(position);
    }, [
        draggable,
        position,
        marker
    ]);
    return marker;
}
/**
 * Component to render a marker on a map
 */ const $7c3acd9b84fb12ed$export$e98856a975cab58e = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const marker = $7c3acd9b84fb12ed$var$useMarker(props);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>marker, [
        marker
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null);
});
$7c3acd9b84fb12ed$export$e98856a975cab58e.displayName = 'Marker';
function $7c3acd9b84fb12ed$export$89f3a749231786c6() {
    const [marker, setMarker] = (0, $kYL7Z.useState)(null);
    const refCallback = (0, $kYL7Z.useCallback)((m)=>{
        setMarker(m);
    }, []);
    return [
        refCallback,
        marker
    ];
}
/**
 * Legacy implementation of Pin component for Maps API < 3.62
 * Component to configure the appearance of an AdvancedMarker or Marker3D
 */ const $7c3acd9b84fb12ed$var$PinLegacy = (props)=>{
    const advancedMarkerContext = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$14de7bb7593cd5bc);
    const marker3dContext = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$f2451a5061be5eec);
    const advancedMarker = advancedMarkerContext === null || advancedMarkerContext === void 0 ? void 0 : advancedMarkerContext.marker;
    const marker3d = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.marker;
    const setContentHandledExternally = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.setContentHandledExternally;
    const glyphContainer = (0, $kYL7Z.useMemo)(()=>document.createElement('div'), []);
    // Load marker library for Marker3D case (AdvancedMarker already has it loaded)
    const markerLibrary = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('marker');
    // Signal to Marker3D that we're handling content
    (0, $kYL7Z.useEffect)(()=>{
        if (marker3d && setContentHandledExternally) {
            setContentHandledExternally(true);
            return ()=>setContentHandledExternally(false);
        }
    }, [
        marker3d,
        setContentHandledExternally
    ]);
    // Handle Marker3D case - append PinElement directly
    (0, $kYL7Z.useEffect)(()=>{
        if (!marker3d || !markerLibrary) return;
        const pinViewOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinViewOptions);
        // Set glyph to glyph container if children are present
        if (props.children) pinElement.glyph = glyphContainer;
        // Append PinElement directly to Marker3D (not in a template)
        // PinElement is a special element that Marker3D can handle natively
        while(marker3d.firstChild)marker3d.removeChild(marker3d.firstChild);
        marker3d.append(pinElement);
        return ()=>{
        // Cleanup handled by marker3d removal
        };
    }, [
        marker3d,
        markerLibrary,
        glyphContainer,
        props
    ]);
    // Create Pin View instance for AdvancedMarker
    (0, $kYL7Z.useEffect)(()=>{
        var _a;
        // Skip if we're in Marker3D context
        if (marker3d) return;
        if (!advancedMarker) {
            if (advancedMarker === undefined && marker3d === undefined) console.error('The <Pin> component can only be used inside <AdvancedMarker> or <Marker3D>.');
            return;
        }
        if (props.glyph && props.children) $7c3acd9b84fb12ed$var$logErrorOnce('The <Pin> component only uses children to render the glyph if both the glyph property and children are present.');
        if ((0, $kYL7Z.Children).count(props.children) > 1) $7c3acd9b84fb12ed$var$logErrorOnce('Passing multiple children to the <Pin> component might lead to unexpected results.');
        const pinViewOptions = Object.assign({}, props);
        const pinElement = new google.maps.marker.PinElement(pinViewOptions);
        // Set glyph to glyph container if children are present (rendered via portal).
        // If both props.glyph and props.children are present, props.children takes priority.
        if (props.children) pinElement.glyph = glyphContainer;
        // Set content of Advanced Marker View to the Pin View element
        // Here we are selecting the anchor container.
        // The hierarchy is as follows:
        // "advancedMarker.content" (from google) -> "anchor container"
        const markerContent = (_a = advancedMarker.content) === null || _a === void 0 ? void 0 : _a.firstChild;
        while(markerContent === null || markerContent === void 0 ? void 0 : markerContent.firstChild)markerContent.removeChild(markerContent.firstChild);
        if (markerContent) markerContent.appendChild(pinElement.element);
    }, [
        advancedMarker,
        glyphContainer,
        marker3d,
        props
    ]);
    return (0, $cRanb.createPortal)(props.children, glyphContainer);
};
/**
 * Modern implementation of Pin component for Maps API >= 3.62
 * Uses the new custom element API with glyphSrc/glyphText properties
 * Component to configure the appearance of an AdvancedMarker or Marker3D
 */ const $7c3acd9b84fb12ed$var$PinModern = (props)=>{
    const { children: children } = props;
    const advancedMarkerContext = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$14de7bb7593cd5bc);
    const marker3dContext = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$f2451a5061be5eec);
    const advancedMarker = advancedMarkerContext === null || advancedMarkerContext === void 0 ? void 0 : advancedMarkerContext.marker;
    const marker3d = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.marker;
    const setContentHandledExternally = marker3dContext === null || marker3dContext === void 0 ? void 0 : marker3dContext.setContentHandledExternally;
    const glyphContainer = (0, $kYL7Z.useMemo)(()=>document.createElement('div'), []);
    const markerLibrary = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('marker');
    // Signal to Marker3D that we're handling content
    (0, $kYL7Z.useEffect)(()=>{
        if (marker3d && setContentHandledExternally) {
            setContentHandledExternally(true);
            return ()=>setContentHandledExternally(false);
        }
    }, [
        marker3d,
        setContentHandledExternally
    ]);
    // Handle Marker3D case
    (0, $kYL7Z.useEffect)(()=>{
        if (!marker3d || !markerLibrary) return;
        const pinOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinOptions);
        // Children still rendered via portal into a container
        if (children) // In modern API, DOM children of PinElement serve as glyph
        pinElement.appendChild(glyphContainer);
        // Append PinElement directly (not .element - that's deprecated)
        while(marker3d.firstChild)marker3d.removeChild(marker3d.firstChild);
        marker3d.appendChild(pinElement);
        return ()=>{
        // Cleanup handled by marker3d removal
        };
    }, [
        marker3d,
        markerLibrary,
        glyphContainer,
        children,
        props
    ]);
    // Handle AdvancedMarker case
    (0, $kYL7Z.useEffect)(()=>{
        var _a;
        if (marker3d) return; // Skip if in Marker3D context
        if (!advancedMarker || !markerLibrary) {
            if (advancedMarker === undefined && marker3d === undefined) console.error('The <Pin> component can only be used inside <AdvancedMarker> or <Marker3D>.');
            return;
        }
        if ((props.glyphSrc || props.glyphText) && children) $7c3acd9b84fb12ed$var$logErrorOnce('The <Pin> component only uses children to render the glyph if both glyphSrc/glyphText and children are present.');
        if ((0, $kYL7Z.Children).count(children) > 1) $7c3acd9b84fb12ed$var$logErrorOnce('Passing multiple children to the <Pin> component might lead to unexpected results.');
        const pinOptions = Object.assign({}, props);
        const pinElement = new markerLibrary.PinElement(pinOptions);
        // Children rendered via portal into container
        if (children) pinElement.appendChild(glyphContainer);
        const markerContent = (_a = advancedMarker.content) === null || _a === void 0 ? void 0 : _a.firstChild;
        while(markerContent === null || markerContent === void 0 ? void 0 : markerContent.firstChild)markerContent.removeChild(markerContent.firstChild);
        if (markerContent) // In modern API, append PinElement directly (not .element)
        markerContent.appendChild(pinElement);
    }, [
        advancedMarker,
        markerLibrary,
        glyphContainer,
        marker3d,
        children,
        props
    ]);
    return (0, $cRanb.createPortal)(children, glyphContainer);
};
/**
 * Component to configure the appearance of an AdvancedMarker or Marker3D.
 *
 * Automatically detects the Maps API version and uses the appropriate implementation:
 * - Legacy implementation (< 3.62): Uses the original PinElement API with glyph property
 * - Modern implementation (≥ 3.62): Uses the new custom element API with glyphSrc/glyphText
 *
 * @example
 * ```tsx
 * // Basic usage
 * <AdvancedMarker position={{lat: 0, lng: 0}}>
 *   <Pin background="#FF0000" glyphColor="#FFFFFF" />
 * </AdvancedMarker>
 *
 * // With custom glyph (legacy)
 * <Pin glyph="📍" />
 *
 * // With custom glyph (modern, recommended for Maps API 3.62+)
 * <Pin glyphText="📍" />
 * <Pin glyphSrc="https://example.com/icon.png" />
 *
 * // With React children as glyph
 * <Pin>
 *   <CustomIcon />
 * </Pin>
 * ```
 */ const $7c3acd9b84fb12ed$export$656559010049c8e = (props)=>{
    var _a;
    const markerLibrary = $7c3acd9b84fb12ed$export$5b40cf36c69caef7('marker');
    // Detect capability after the marker library is loaded
    const isModern = (0, $kYL7Z.useMemo)(()=>{
        if (!markerLibrary) return false;
        // Check if <gmp-pin> custom element exists
        // This happens while loading the marker library in Maps API 3.62+
        return typeof customElements !== 'undefined' && customElements.get('gmp-pin') !== undefined;
    }, [
        markerLibrary
    ]);
    // Wait for marker library to load before rendering
    if (!markerLibrary) return null;
    // Map props based on which implementation we're using
    if (isModern) {
        // Modern: map old glyph prop to new glyphSrc/glyphText
        const { glyph: glyph, glyphSrc: glyphSrc, glyphText: glyphText } = props, restProps = $7c3acd9b84fb12ed$var$__rest(props, [
            "glyph",
            "glyphSrc",
            "glyphText"
        ]);
        const isUrl = glyph instanceof URL || typeof glyph === 'string' && glyph.startsWith('http');
        const finalGlyphText = glyphText !== null && glyphText !== void 0 ? glyphText : typeof glyph === 'string' && !isUrl ? glyph : undefined;
        const finalGlyphSrc = glyphSrc !== null && glyphSrc !== void 0 ? glyphSrc : isUrl ? String(glyph) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$var$PinModern, Object.assign({}, restProps, {
            glyphText: finalGlyphText,
            glyphSrc: finalGlyphSrc
        }));
    } else {
        // Legacy: map new glyphSrc/glyphText to old glyph prop
        const { glyph: glyph, glyphSrc: glyphSrc, glyphText: glyphText } = props, restProps = $7c3acd9b84fb12ed$var$__rest(props, [
            "glyph",
            "glyphSrc",
            "glyphText"
        ]);
        const finalGlyph = (_a = glyph !== null && glyph !== void 0 ? glyph : glyphSrc) !== null && _a !== void 0 ? _a : glyphText;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($7c3acd9b84fb12ed$var$PinLegacy, Object.assign({}, restProps, {
            glyph: finalGlyph
        }));
    }
};
function $7c3acd9b84fb12ed$var$useRectangle(props) {
    var _a, _b, _c;
    const { onClick: onClick, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onBoundsChanged: onBoundsChanged, bounds: bounds, defaultBounds: defaultBounds } = props, destructuredOptions = $7c3acd9b84fb12ed$var$__rest(props, [
        "onClick",
        "onDrag",
        "onDragStart",
        "onDragEnd",
        "onMouseOver",
        "onMouseOut",
        "onBoundsChanged",
        "bounds",
        "defaultBounds"
    ]);
    const [rectangle, setRectangle] = (0, $kYL7Z.useState)(null);
    const map = $7c3acd9b84fb12ed$export$86f8f9f08863e403();
    // Memoize options with automatic inference of clickable/draggable/editable
    const rectangleOptions = $7c3acd9b84fb12ed$var$useMemoized(Object.assign(Object.assign({}, destructuredOptions), {
        clickable: (_a = destructuredOptions.clickable) !== null && _a !== void 0 ? _a : Boolean(onClick),
        draggable: (_b = destructuredOptions.draggable) !== null && _b !== void 0 ? _b : Boolean(onDrag || onDragStart || onDragEnd || onBoundsChanged),
        editable: (_c = destructuredOptions.editable) !== null && _c !== void 0 ? _c : Boolean(onBoundsChanged)
    }), $7c3acd9b84fb12ed$var$deepEqual);
    (0, $kYL7Z.useEffect)(()=>{
        if (!map) {
            if (map === undefined) console.error('<Rectangle> has to be inside a Map component.');
            return;
        }
        const newRectangle = new google.maps.Rectangle(Object.assign(Object.assign({}, rectangleOptions), {
            bounds: bounds !== null && bounds !== void 0 ? bounds : defaultBounds
        }));
        newRectangle.setMap(map);
        // eslint-disable-next-line react-hooks/set-state-in-effect -- intentional to sync the imperative instance with state
        setRectangle(newRectangle);
        return ()=>{
            newRectangle.setMap(null);
            setRectangle(null);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- rectangle options are handled separately to avoid recreating the instance
    }, [
        map
    ]);
    $7c3acd9b84fb12ed$var$useMapsEventListener(rectangle, 'click', onClick);
    $7c3acd9b84fb12ed$var$useMapsEventListener(rectangle, 'drag', onDrag);
    $7c3acd9b84fb12ed$var$useMapsEventListener(rectangle, 'dragstart', onDragStart);
    $7c3acd9b84fb12ed$var$useMapsEventListener(rectangle, 'dragend', onDragEnd);
    $7c3acd9b84fb12ed$var$useMapsEventListener(rectangle, 'mouseover', onMouseOver);
    $7c3acd9b84fb12ed$var$useMapsEventListener(rectangle, 'mouseout', onMouseOut);
    $7c3acd9b84fb12ed$var$useMapsEventListener(rectangle, 'bounds_changed', onBoundsChanged ? ()=>{
        onBoundsChanged(rectangle === null || rectangle === void 0 ? void 0 : rectangle.getBounds());
    } : null);
    (0, $kYL7Z.useEffect)(()=>{
        if (!rectangle) return;
        rectangle.setOptions(rectangleOptions);
    }, [
        rectangle,
        rectangleOptions
    ]);
    // Sync controlled bounds prop with the rectangle instance
    (0, $kYL7Z.useEffect)(()=>{
        if (!rectangle || !bounds) return;
        if (!$7c3acd9b84fb12ed$export$c0cfaae65aded47(bounds, rectangle.getBounds())) rectangle.setBounds(bounds);
    }, [
        rectangle,
        bounds
    ]);
    return rectangle;
}
const $7c3acd9b84fb12ed$export$4617fb02663045ef = (0, $kYL7Z.forwardRef)((props, ref)=>{
    const rectangle = $7c3acd9b84fb12ed$var$useRectangle(props);
    (0, $kYL7Z.useImperativeHandle)(ref, ()=>rectangle, [
        rectangle
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Fragment, null);
});
$7c3acd9b84fb12ed$export$4617fb02663045ef.displayName = 'Rectangle';
/**
 * Hook to retrieve a Map3DElement instance from context.
 *
 * When called without an id, it returns the map from the nearest parent Map3D
 * component. When called with an id, it retrieves the map with that id from
 * the APIProvider context.
 *
 * @param id - Optional id of the map to retrieve. If not specified, returns
 *   the parent map instance or the default map instance.
 *
 * @example
 * ```tsx
 * // Get the parent Map3D instance
 * function MyComponent() {
 *   const map3d = useMap3D();
 *   // ...
 * }
 *
 * // Get a specific Map3D instance by id
 * function ControlPanel() {
 *   const mainMap = useMap3D('main-map');
 *   const miniMap = useMap3D('mini-map');
 *   // ...
 * }
 * ```
 */ function $7c3acd9b84fb12ed$export$e9723f028e220f29(id = null) {
    const apiContext = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$84e9974bcf67d1d);
    const map3dContext = (0, $kYL7Z.useContext)($7c3acd9b84fb12ed$export$b4118d11ca82abca);
    if (apiContext === null) {
        $7c3acd9b84fb12ed$var$logErrorOnce("useMap3D(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap3D()` from is a child of the <APIProvider>.");
        return null;
    }
    const { map3dInstances: map3dInstances } = apiContext;
    // Lookup priority: explicit id > parent context > default instance
    if (id !== null) return map3dInstances[id] || null;
    if (map3dContext === null || map3dContext === void 0 ? void 0 : map3dContext.map3d) return map3dContext.map3d;
    return map3dInstances['default'] || null;
}
const $7c3acd9b84fb12ed$var$mapLinear = (x, a1, a2, b1, b2)=>b1 + (x - a1) * (b2 - b1) / (a2 - a1);
const $7c3acd9b84fb12ed$var$getMapMaxTilt = (zoom)=>{
    if (zoom <= 10) return 30;
    if (zoom >= 15.5) return 67.5;
    // range [10...14]
    if (zoom <= 14) return $7c3acd9b84fb12ed$var$mapLinear(zoom, 10, 14, 30, 45);
    // range [14...15.5]
    return $7c3acd9b84fb12ed$var$mapLinear(zoom, 14, 15.5, 45, 67.5);
};
/**
 * Function to limit the tilt range of the Google map when updating the view state
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7c3acd9b84fb12ed$export$2849c0466f0d3b14 = ({ viewState: viewState })=>{
    const pitch = viewState.pitch;
    const gmZoom = viewState.zoom + 1;
    const maxTilt = $7c3acd9b84fb12ed$var$getMapMaxTilt(gmZoom);
    return Object.assign(Object.assign({}, viewState), {
        fovy: 25,
        pitch: Math.min(maxTilt, pitch)
    });
};




var $kYL7Z = parcelRequire("kYL7Z");



var $df41e5b15345a476$exports = {};

var $df41e5b15345a476$var$moment = $df41e5b15345a476$exports = (parcelRequire("kij1l"));

$df41e5b15345a476$var$moment.tz.load((parcelRequire("dXDHh")));


var $1102f92b2d220c0d$exports = {};
"use strict";
var $1102f92b2d220c0d$var$__importDefault = $1102f92b2d220c0d$exports && $1102f92b2d220c0d$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1102f92b2d220c0d$exports, "__esModule", {
    value: true
});
$1102f92b2d220c0d$exports.customList = $1102f92b2d220c0d$exports.customArray = $1102f92b2d220c0d$exports.findOne = $1102f92b2d220c0d$exports.filter = $1102f92b2d220c0d$exports.all = $1102f92b2d220c0d$exports.utils = void 0;

const $1102f92b2d220c0d$var$groupBy_1 = $1102f92b2d220c0d$var$__importDefault((parcelRequire("lS2PV")));

const $1102f92b2d220c0d$var$supplant_1 = $1102f92b2d220c0d$var$__importDefault((parcelRequire("eUVR3")));

const $1102f92b2d220c0d$var$countriesData_1 = $1102f92b2d220c0d$var$__importDefault((parcelRequire("eOcqU")));
$1102f92b2d220c0d$exports.utils = {
    groupBy: $1102f92b2d220c0d$var$groupBy_1.default
};
function $1102f92b2d220c0d$var$all() {
    return $1102f92b2d220c0d$var$countriesData_1.default;
}
$1102f92b2d220c0d$exports.all = $1102f92b2d220c0d$var$all;
function $1102f92b2d220c0d$var$filter(countryProperty, value) {
    return $1102f92b2d220c0d$var$countriesData_1.default.filter((countryData)=>countryData[countryProperty] === value);
}
$1102f92b2d220c0d$exports.filter = $1102f92b2d220c0d$var$filter;
function $1102f92b2d220c0d$var$findOne(countryProperty, value) {
    return $1102f92b2d220c0d$var$countriesData_1.default.find((countryData)=>countryData[countryProperty] === value);
}
$1102f92b2d220c0d$exports.findOne = $1102f92b2d220c0d$var$findOne;
function $1102f92b2d220c0d$var$customArray(fields = {
    name: "{countryNameEn} ({countryCode})",
    value: "{countryCode}"
}, { sortBy: sortBy, sortDataBy: sortDataBy, filter: filterFunc } = {}) {
    const finalCollection = [];
    let data = $1102f92b2d220c0d$var$countriesData_1.default;
    if (typeof filterFunc === "function") data = data.filter(filterFunc);
    if (sortDataBy) {
        const collator = new Intl.Collator([], {
            sensitivity: "accent"
        });
        data.sort((a, b)=>collator.compare(a[sortDataBy], b[sortDataBy]));
    }
    data.forEach((countryData)=>{
        const collectionObject = {};
        for(const field in fields)collectionObject[field] = (0, $1102f92b2d220c0d$var$supplant_1.default)(fields[field], countryData);
        finalCollection.push(collectionObject);
    });
    if (sortBy && fields[sortBy]) {
        const collator = new Intl.Collator([], {
            sensitivity: "accent"
        });
        finalCollection.sort((a, b)=>collator.compare(a[sortBy], b[sortBy]));
    }
    return finalCollection;
}
$1102f92b2d220c0d$exports.customArray = $1102f92b2d220c0d$var$customArray;
function $1102f92b2d220c0d$var$customList(key = "countryCode", label = "{countryNameEn} ({countryCode})", { filter: filterFunc } = {}) {
    const finalObject = {};
    let data = $1102f92b2d220c0d$var$countriesData_1.default;
    if (typeof filterFunc === "function") data = data.filter(filterFunc);
    data.forEach((countryData)=>{
        const value = (0, $1102f92b2d220c0d$var$supplant_1.default)(label, countryData);
        finalObject[String(countryData[key])] = value;
    });
    return finalObject;
}
$1102f92b2d220c0d$exports.customList = $1102f92b2d220c0d$var$customList;


var $a8fef35c216e9dac$export$6565f9f03506010b;
var $a8fef35c216e9dac$export$142596e469219c06;
var $a8fef35c216e9dac$export$98e628dec113755e;
var $a8fef35c216e9dac$export$e45cb6485273080e;
var $a8fef35c216e9dac$export$1f6c9cc012ebacae;
var $a8fef35c216e9dac$export$e5ad74579c86b003;
var $a8fef35c216e9dac$export$d8d14fdd4313cced;
var $a8fef35c216e9dac$export$4051a07651545597;
var $5888c65d28e4005b$exports = {};
function $5888c65d28e4005b$var$truthy(d) {
    return d;
}
function $5888c65d28e4005b$var$first(array, callback, context) {
    var callback = callback || $5888c65d28e4005b$var$truthy, context = context || array, value;
    for(var i = 0, l = array.length; i < l; i += 1){
        if (value = callback.call(context, array[i], i)) return array[i];
    }
}
$5888c65d28e4005b$exports = $5888c65d28e4005b$var$first;


var $ae628098ba663ed7$exports = {};
var $ae628098ba663ed7$var$nub = $ae628098ba663ed7$exports = function(xs, cmp) {
    if (typeof xs === 'function' || cmp) return $ae628098ba663ed7$var$nub.by(xs, cmp);
    var keys = {
        'object': [],
        'function': [],
        'string': {},
        'number': {},
        'boolean': {},
        'undefined': {}
    };
    var res = [];
    for(var i = 0; i < xs.length; i++){
        var x = xs[i];
        var recs = x === '__proto__' ? keys.objects : keys[typeof x] || keys.objects;
        if (Array.isArray(recs)) {
            if (recs.indexOf(x) < 0) {
                recs.push(x);
                res.push(x);
            }
        } else if (!Object.hasOwnProperty.call(recs, x)) {
            recs[x] = true;
            res.push(x);
        }
    }
    return res;
};
$ae628098ba663ed7$var$nub.by = function(xs, cmp) {
    if (typeof xs === 'function') {
        var cmp_ = cmp;
        cmp = xs;
        xs = cmp_;
    }
    var res = [];
    for(var i = 0; i < xs.length; i++){
        var x = xs[i];
        var found = false;
        for(var j = 0; j < res.length; j++){
            var y = res[j];
            if (cmp.call(res, x, y)) {
                found = true;
                break;
            }
        }
        if (!found) res.push(x);
    }
    return res;
};


var $8539891341747ee3$exports = {};
/*
	Follows ISO 4217, https://www.iso.org/iso-4217-currency-codes.html
	See https://www.currency-iso.org/dam/downloads/lists/list_one.xml
	Data last updated 2024-06-25
*/ $8539891341747ee3$exports = [
    {
        "code": "AED",
        "number": "784",
        "digits": 2,
        "currency": "UAE Dirham",
        "countries": [
            "United Arab Emirates (The)"
        ]
    },
    {
        "code": "AFN",
        "number": "971",
        "digits": 2,
        "currency": "Afghani",
        "countries": [
            "Afghanistan"
        ]
    },
    {
        "code": "ALL",
        "number": "008",
        "digits": 2,
        "currency": "Lek",
        "countries": [
            "Albania"
        ]
    },
    {
        "code": "AMD",
        "number": "051",
        "digits": 2,
        "currency": "Armenian Dram",
        "countries": [
            "Armenia"
        ]
    },
    {
        "code": "ANG",
        "number": "532",
        "digits": 2,
        "currency": "Netherlands Antillean Guilder",
        "countries": [
            "Cura\xe7ao",
            "Sint Maarten (Dutch Part)"
        ]
    },
    {
        "code": "AOA",
        "number": "973",
        "digits": 2,
        "currency": "Kwanza",
        "countries": [
            "Angola"
        ]
    },
    {
        "code": "ARS",
        "number": "032",
        "digits": 2,
        "currency": "Argentine Peso",
        "countries": [
            "Argentina"
        ]
    },
    {
        "code": "AUD",
        "number": "036",
        "digits": 2,
        "currency": "Australian Dollar",
        "countries": [
            "Australia",
            "Christmas Island",
            "Cocos (Keeling) Islands (The)",
            "Heard Island and Mcdonald Islands",
            "Kiribati",
            "Nauru",
            "Norfolk Island",
            "Tuvalu"
        ]
    },
    {
        "code": "AWG",
        "number": "533",
        "digits": 2,
        "currency": "Aruban Florin",
        "countries": [
            "Aruba"
        ]
    },
    {
        "code": "AZN",
        "number": "944",
        "digits": 2,
        "currency": "Azerbaijan Manat",
        "countries": [
            "Azerbaijan"
        ]
    },
    {
        "code": "BAM",
        "number": "977",
        "digits": 2,
        "currency": "Convertible Mark",
        "countries": [
            "Bosnia and Herzegovina"
        ]
    },
    {
        "code": "BBD",
        "number": "052",
        "digits": 2,
        "currency": "Barbados Dollar",
        "countries": [
            "Barbados"
        ]
    },
    {
        "code": "BDT",
        "number": "050",
        "digits": 2,
        "currency": "Taka",
        "countries": [
            "Bangladesh"
        ]
    },
    {
        "code": "BGN",
        "number": "975",
        "digits": 2,
        "currency": "Bulgarian Lev",
        "countries": [
            "Bulgaria"
        ]
    },
    {
        "code": "BHD",
        "number": "048",
        "digits": 3,
        "currency": "Bahraini Dinar",
        "countries": [
            "Bahrain"
        ]
    },
    {
        "code": "BIF",
        "number": "108",
        "digits": 0,
        "currency": "Burundi Franc",
        "countries": [
            "Burundi"
        ]
    },
    {
        "code": "BMD",
        "number": "060",
        "digits": 2,
        "currency": "Bermudian Dollar",
        "countries": [
            "Bermuda"
        ]
    },
    {
        "code": "BND",
        "number": "096",
        "digits": 2,
        "currency": "Brunei Dollar",
        "countries": [
            "Brunei Darussalam"
        ]
    },
    {
        "code": "BOB",
        "number": "068",
        "digits": 2,
        "currency": "Boliviano",
        "countries": [
            "Bolivia (Plurinational State Of)"
        ]
    },
    {
        "code": "BOV",
        "number": "984",
        "digits": 2,
        "currency": "Mvdol",
        "countries": [
            "Bolivia (Plurinational State Of)"
        ]
    },
    {
        "code": "BRL",
        "number": "986",
        "digits": 2,
        "currency": "Brazilian Real",
        "countries": [
            "Brazil"
        ]
    },
    {
        "code": "BSD",
        "number": "044",
        "digits": 2,
        "currency": "Bahamian Dollar",
        "countries": [
            "Bahamas (The)"
        ]
    },
    {
        "code": "BTN",
        "number": "064",
        "digits": 2,
        "currency": "Ngultrum",
        "countries": [
            "Bhutan"
        ]
    },
    {
        "code": "BWP",
        "number": "072",
        "digits": 2,
        "currency": "Pula",
        "countries": [
            "Botswana"
        ]
    },
    {
        "code": "BYN",
        "number": "933",
        "digits": 2,
        "currency": "Belarusian Ruble",
        "countries": [
            "Belarus"
        ]
    },
    {
        "code": "BZD",
        "number": "084",
        "digits": 2,
        "currency": "Belize Dollar",
        "countries": [
            "Belize"
        ]
    },
    {
        "code": "CAD",
        "number": "124",
        "digits": 2,
        "currency": "Canadian Dollar",
        "countries": [
            "Canada"
        ]
    },
    {
        "code": "CDF",
        "number": "976",
        "digits": 2,
        "currency": "Congolese Franc",
        "countries": [
            "Congo (The Democratic Republic of The)"
        ]
    },
    {
        "code": "CHE",
        "number": "947",
        "digits": 2,
        "currency": "WIR Euro",
        "countries": [
            "Switzerland"
        ]
    },
    {
        "code": "CHF",
        "number": "756",
        "digits": 2,
        "currency": "Swiss Franc",
        "countries": [
            "Liechtenstein",
            "Switzerland"
        ]
    },
    {
        "code": "CHW",
        "number": "948",
        "digits": 2,
        "currency": "WIR Franc",
        "countries": [
            "Switzerland"
        ]
    },
    {
        "code": "CLF",
        "number": "990",
        "digits": 4,
        "currency": "Unidad de Fomento",
        "countries": [
            "Chile"
        ]
    },
    {
        "code": "CLP",
        "number": "152",
        "digits": 0,
        "currency": "Chilean Peso",
        "countries": [
            "Chile"
        ]
    },
    {
        "code": "CNY",
        "number": "156",
        "digits": 2,
        "currency": "Yuan Renminbi",
        "countries": [
            "China"
        ]
    },
    {
        "code": "COP",
        "number": "170",
        "digits": 2,
        "currency": "Colombian Peso",
        "countries": [
            "Colombia"
        ]
    },
    {
        "code": "COU",
        "number": "970",
        "digits": 2,
        "currency": "Unidad de Valor Real",
        "countries": [
            "Colombia"
        ]
    },
    {
        "code": "CRC",
        "number": "188",
        "digits": 2,
        "currency": "Costa Rican Colon",
        "countries": [
            "Costa Rica"
        ]
    },
    {
        "code": "CUC",
        "number": "931",
        "digits": 2,
        "currency": "Peso Convertible",
        "countries": [
            "Cuba"
        ]
    },
    {
        "code": "CUP",
        "number": "192",
        "digits": 2,
        "currency": "Cuban Peso",
        "countries": [
            "Cuba"
        ]
    },
    {
        "code": "CVE",
        "number": "132",
        "digits": 2,
        "currency": "Cabo Verde Escudo",
        "countries": [
            "Cabo Verde"
        ]
    },
    {
        "code": "CZK",
        "number": "203",
        "digits": 2,
        "currency": "Czech Koruna",
        "countries": [
            "Czechia"
        ]
    },
    {
        "code": "DJF",
        "number": "262",
        "digits": 0,
        "currency": "Djibouti Franc",
        "countries": [
            "Djibouti"
        ]
    },
    {
        "code": "DKK",
        "number": "208",
        "digits": 2,
        "currency": "Danish Krone",
        "countries": [
            "Denmark",
            "Faroe Islands (The)",
            "Greenland"
        ]
    },
    {
        "code": "DOP",
        "number": "214",
        "digits": 2,
        "currency": "Dominican Peso",
        "countries": [
            "Dominican Republic (The)"
        ]
    },
    {
        "code": "DZD",
        "number": "012",
        "digits": 2,
        "currency": "Algerian Dinar",
        "countries": [
            "Algeria"
        ]
    },
    {
        "code": "EGP",
        "number": "818",
        "digits": 2,
        "currency": "Egyptian Pound",
        "countries": [
            "Egypt"
        ]
    },
    {
        "code": "ERN",
        "number": "232",
        "digits": 2,
        "currency": "Nakfa",
        "countries": [
            "Eritrea"
        ]
    },
    {
        "code": "ETB",
        "number": "230",
        "digits": 2,
        "currency": "Ethiopian Birr",
        "countries": [
            "Ethiopia"
        ]
    },
    {
        "code": "EUR",
        "number": "978",
        "digits": 2,
        "currency": "Euro",
        "countries": [
            "\xc5land Islands",
            "Andorra",
            "Austria",
            "Belgium",
            "Croatia",
            "Cyprus",
            "Estonia",
            "European Union",
            "Finland",
            "France",
            "French Guiana",
            "French Southern Territories (The)",
            "Germany",
            "Greece",
            "Guadeloupe",
            "Holy See (The)",
            "Ireland",
            "Italy",
            "Latvia",
            "Lithuania",
            "Luxembourg",
            "Malta",
            "Martinique",
            "Mayotte",
            "Monaco",
            "Montenegro",
            "Netherlands (The)",
            "Portugal",
            "R\xe9union",
            "Saint Barth\xe9lemy",
            "Saint Martin (French Part)",
            "Saint Pierre and Miquelon",
            "San Marino",
            "Slovakia",
            "Slovenia",
            "Spain"
        ]
    },
    {
        "code": "FJD",
        "number": "242",
        "digits": 2,
        "currency": "Fiji Dollar",
        "countries": [
            "Fiji"
        ]
    },
    {
        "code": "FKP",
        "number": "238",
        "digits": 2,
        "currency": "Falkland Islands Pound",
        "countries": [
            "Falkland Islands (The) [Malvinas]"
        ]
    },
    {
        "code": "GBP",
        "number": "826",
        "digits": 2,
        "currency": "Pound Sterling",
        "countries": [
            "Guernsey",
            "Isle of Man",
            "Jersey",
            "United Kingdom of Great Britain and Northern Ireland (The)"
        ]
    },
    {
        "code": "GEL",
        "number": "981",
        "digits": 2,
        "currency": "Lari",
        "countries": [
            "Georgia"
        ]
    },
    {
        "code": "GHS",
        "number": "936",
        "digits": 2,
        "currency": "Ghana Cedi",
        "countries": [
            "Ghana"
        ]
    },
    {
        "code": "GIP",
        "number": "292",
        "digits": 2,
        "currency": "Gibraltar Pound",
        "countries": [
            "Gibraltar"
        ]
    },
    {
        "code": "GMD",
        "number": "270",
        "digits": 2,
        "currency": "Dalasi",
        "countries": [
            "Gambia (The)"
        ]
    },
    {
        "code": "GNF",
        "number": "324",
        "digits": 0,
        "currency": "Guinean Franc",
        "countries": [
            "Guinea"
        ]
    },
    {
        "code": "GTQ",
        "number": "320",
        "digits": 2,
        "currency": "Quetzal",
        "countries": [
            "Guatemala"
        ]
    },
    {
        "code": "GYD",
        "number": "328",
        "digits": 2,
        "currency": "Guyana Dollar",
        "countries": [
            "Guyana"
        ]
    },
    {
        "code": "HKD",
        "number": "344",
        "digits": 2,
        "currency": "Hong Kong Dollar",
        "countries": [
            "Hong Kong"
        ]
    },
    {
        "code": "HNL",
        "number": "340",
        "digits": 2,
        "currency": "Lempira",
        "countries": [
            "Honduras"
        ]
    },
    {
        "code": "HTG",
        "number": "332",
        "digits": 2,
        "currency": "Gourde",
        "countries": [
            "Haiti"
        ]
    },
    {
        "code": "HUF",
        "number": "348",
        "digits": 2,
        "currency": "Forint",
        "countries": [
            "Hungary"
        ]
    },
    {
        "code": "IDR",
        "number": "360",
        "digits": 2,
        "currency": "Rupiah",
        "countries": [
            "Indonesia"
        ]
    },
    {
        "code": "ILS",
        "number": "376",
        "digits": 2,
        "currency": "New Israeli Sheqel",
        "countries": [
            "Israel"
        ]
    },
    {
        "code": "INR",
        "number": "356",
        "digits": 2,
        "currency": "Indian Rupee",
        "countries": [
            "Bhutan",
            "India"
        ]
    },
    {
        "code": "IQD",
        "number": "368",
        "digits": 3,
        "currency": "Iraqi Dinar",
        "countries": [
            "Iraq"
        ]
    },
    {
        "code": "IRR",
        "number": "364",
        "digits": 2,
        "currency": "Iranian Rial",
        "countries": [
            "Iran (Islamic Republic Of)"
        ]
    },
    {
        "code": "ISK",
        "number": "352",
        "digits": 0,
        "currency": "Iceland Krona",
        "countries": [
            "Iceland"
        ]
    },
    {
        "code": "JMD",
        "number": "388",
        "digits": 2,
        "currency": "Jamaican Dollar",
        "countries": [
            "Jamaica"
        ]
    },
    {
        "code": "JOD",
        "number": "400",
        "digits": 3,
        "currency": "Jordanian Dinar",
        "countries": [
            "Jordan"
        ]
    },
    {
        "code": "JPY",
        "number": "392",
        "digits": 0,
        "currency": "Yen",
        "countries": [
            "Japan"
        ]
    },
    {
        "code": "KES",
        "number": "404",
        "digits": 2,
        "currency": "Kenyan Shilling",
        "countries": [
            "Kenya"
        ]
    },
    {
        "code": "KGS",
        "number": "417",
        "digits": 2,
        "currency": "Som",
        "countries": [
            "Kyrgyzstan"
        ]
    },
    {
        "code": "KHR",
        "number": "116",
        "digits": 2,
        "currency": "Riel",
        "countries": [
            "Cambodia"
        ]
    },
    {
        "code": "KMF",
        "number": "174",
        "digits": 0,
        "currency": "Comorian Franc ",
        "countries": [
            "Comoros (The)"
        ]
    },
    {
        "code": "KPW",
        "number": "408",
        "digits": 2,
        "currency": "North Korean Won",
        "countries": [
            "Korea (The Democratic People\u2019s Republic Of)"
        ]
    },
    {
        "code": "KRW",
        "number": "410",
        "digits": 0,
        "currency": "Won",
        "countries": [
            "Korea (The Republic Of)"
        ]
    },
    {
        "code": "KWD",
        "number": "414",
        "digits": 3,
        "currency": "Kuwaiti Dinar",
        "countries": [
            "Kuwait"
        ]
    },
    {
        "code": "KYD",
        "number": "136",
        "digits": 2,
        "currency": "Cayman Islands Dollar",
        "countries": [
            "Cayman Islands (The)"
        ]
    },
    {
        "code": "KZT",
        "number": "398",
        "digits": 2,
        "currency": "Tenge",
        "countries": [
            "Kazakhstan"
        ]
    },
    {
        "code": "LAK",
        "number": "418",
        "digits": 2,
        "currency": "Lao Kip",
        "countries": [
            "Lao People\u2019s Democratic Republic (The)"
        ]
    },
    {
        "code": "LBP",
        "number": "422",
        "digits": 2,
        "currency": "Lebanese Pound",
        "countries": [
            "Lebanon"
        ]
    },
    {
        "code": "LKR",
        "number": "144",
        "digits": 2,
        "currency": "Sri Lanka Rupee",
        "countries": [
            "Sri Lanka"
        ]
    },
    {
        "code": "LRD",
        "number": "430",
        "digits": 2,
        "currency": "Liberian Dollar",
        "countries": [
            "Liberia"
        ]
    },
    {
        "code": "LSL",
        "number": "426",
        "digits": 2,
        "currency": "Loti",
        "countries": [
            "Lesotho"
        ]
    },
    {
        "code": "LYD",
        "number": "434",
        "digits": 3,
        "currency": "Libyan Dinar",
        "countries": [
            "Libya"
        ]
    },
    {
        "code": "MAD",
        "number": "504",
        "digits": 2,
        "currency": "Moroccan Dirham",
        "countries": [
            "Morocco",
            "Western Sahara"
        ]
    },
    {
        "code": "MDL",
        "number": "498",
        "digits": 2,
        "currency": "Moldovan Leu",
        "countries": [
            "Moldova (The Republic Of)"
        ]
    },
    {
        "code": "MGA",
        "number": "969",
        "digits": 2,
        "currency": "Malagasy Ariary",
        "countries": [
            "Madagascar"
        ]
    },
    {
        "code": "MKD",
        "number": "807",
        "digits": 2,
        "currency": "Denar",
        "countries": [
            "North Macedonia"
        ]
    },
    {
        "code": "MMK",
        "number": "104",
        "digits": 2,
        "currency": "Kyat",
        "countries": [
            "Myanmar"
        ]
    },
    {
        "code": "MNT",
        "number": "496",
        "digits": 2,
        "currency": "Tugrik",
        "countries": [
            "Mongolia"
        ]
    },
    {
        "code": "MOP",
        "number": "446",
        "digits": 2,
        "currency": "Pataca",
        "countries": [
            "Macao"
        ]
    },
    {
        "code": "MRU",
        "number": "929",
        "digits": 2,
        "currency": "Ouguiya",
        "countries": [
            "Mauritania"
        ]
    },
    {
        "code": "MUR",
        "number": "480",
        "digits": 2,
        "currency": "Mauritius Rupee",
        "countries": [
            "Mauritius"
        ]
    },
    {
        "code": "MVR",
        "number": "462",
        "digits": 2,
        "currency": "Rufiyaa",
        "countries": [
            "Maldives"
        ]
    },
    {
        "code": "MWK",
        "number": "454",
        "digits": 2,
        "currency": "Malawi Kwacha",
        "countries": [
            "Malawi"
        ]
    },
    {
        "code": "MXN",
        "number": "484",
        "digits": 2,
        "currency": "Mexican Peso",
        "countries": [
            "Mexico"
        ]
    },
    {
        "code": "MXV",
        "number": "979",
        "digits": 2,
        "currency": "Mexican Unidad de Inversion (UDI)",
        "countries": [
            "Mexico"
        ]
    },
    {
        "code": "MYR",
        "number": "458",
        "digits": 2,
        "currency": "Malaysian Ringgit",
        "countries": [
            "Malaysia"
        ]
    },
    {
        "code": "MZN",
        "number": "943",
        "digits": 2,
        "currency": "Mozambique Metical",
        "countries": [
            "Mozambique"
        ]
    },
    {
        "code": "NAD",
        "number": "516",
        "digits": 2,
        "currency": "Namibia Dollar",
        "countries": [
            "Namibia"
        ]
    },
    {
        "code": "NGN",
        "number": "566",
        "digits": 2,
        "currency": "Naira",
        "countries": [
            "Nigeria"
        ]
    },
    {
        "code": "NIO",
        "number": "558",
        "digits": 2,
        "currency": "Cordoba Oro",
        "countries": [
            "Nicaragua"
        ]
    },
    {
        "code": "NOK",
        "number": "578",
        "digits": 2,
        "currency": "Norwegian Krone",
        "countries": [
            "Bouvet Island",
            "Norway",
            "Svalbard and Jan Mayen"
        ]
    },
    {
        "code": "NPR",
        "number": "524",
        "digits": 2,
        "currency": "Nepalese Rupee",
        "countries": [
            "Nepal"
        ]
    },
    {
        "code": "NZD",
        "number": "554",
        "digits": 2,
        "currency": "New Zealand Dollar",
        "countries": [
            "Cook Islands (The)",
            "New Zealand",
            "Niue",
            "Pitcairn",
            "Tokelau"
        ]
    },
    {
        "code": "OMR",
        "number": "512",
        "digits": 3,
        "currency": "Rial Omani",
        "countries": [
            "Oman"
        ]
    },
    {
        "code": "PAB",
        "number": "590",
        "digits": 2,
        "currency": "Balboa",
        "countries": [
            "Panama"
        ]
    },
    {
        "code": "PEN",
        "number": "604",
        "digits": 2,
        "currency": "Sol",
        "countries": [
            "Peru"
        ]
    },
    {
        "code": "PGK",
        "number": "598",
        "digits": 2,
        "currency": "Kina",
        "countries": [
            "Papua New Guinea"
        ]
    },
    {
        "code": "PHP",
        "number": "608",
        "digits": 2,
        "currency": "Philippine Peso",
        "countries": [
            "Philippines (The)"
        ]
    },
    {
        "code": "PKR",
        "number": "586",
        "digits": 2,
        "currency": "Pakistan Rupee",
        "countries": [
            "Pakistan"
        ]
    },
    {
        "code": "PLN",
        "number": "985",
        "digits": 2,
        "currency": "Zloty",
        "countries": [
            "Poland"
        ]
    },
    {
        "code": "PYG",
        "number": "600",
        "digits": 0,
        "currency": "Guarani",
        "countries": [
            "Paraguay"
        ]
    },
    {
        "code": "QAR",
        "number": "634",
        "digits": 2,
        "currency": "Qatari Rial",
        "countries": [
            "Qatar"
        ]
    },
    {
        "code": "RON",
        "number": "946",
        "digits": 2,
        "currency": "Romanian Leu",
        "countries": [
            "Romania"
        ]
    },
    {
        "code": "RSD",
        "number": "941",
        "digits": 2,
        "currency": "Serbian Dinar",
        "countries": [
            "Serbia"
        ]
    },
    {
        "code": "RUB",
        "number": "643",
        "digits": 2,
        "currency": "Russian Ruble",
        "countries": [
            "Russian Federation (The)"
        ]
    },
    {
        "code": "RWF",
        "number": "646",
        "digits": 0,
        "currency": "Rwanda Franc",
        "countries": [
            "Rwanda"
        ]
    },
    {
        "code": "SAR",
        "number": "682",
        "digits": 2,
        "currency": "Saudi Riyal",
        "countries": [
            "Saudi Arabia"
        ]
    },
    {
        "code": "SBD",
        "number": "090",
        "digits": 2,
        "currency": "Solomon Islands Dollar",
        "countries": [
            "Solomon Islands"
        ]
    },
    {
        "code": "SCR",
        "number": "690",
        "digits": 2,
        "currency": "Seychelles Rupee",
        "countries": [
            "Seychelles"
        ]
    },
    {
        "code": "SDG",
        "number": "938",
        "digits": 2,
        "currency": "Sudanese Pound",
        "countries": [
            "Sudan (The)"
        ]
    },
    {
        "code": "SEK",
        "number": "752",
        "digits": 2,
        "currency": "Swedish Krona",
        "countries": [
            "Sweden"
        ]
    },
    {
        "code": "SGD",
        "number": "702",
        "digits": 2,
        "currency": "Singapore Dollar",
        "countries": [
            "Singapore"
        ]
    },
    {
        "code": "SHP",
        "number": "654",
        "digits": 2,
        "currency": "Saint Helena Pound",
        "countries": [
            "Saint Helena, Ascension and Tristan Da Cunha"
        ]
    },
    {
        "code": "SLE",
        "number": "925",
        "digits": 2,
        "currency": "Leone",
        "countries": [
            "Sierra Leone"
        ]
    },
    {
        "code": "SOS",
        "number": "706",
        "digits": 2,
        "currency": "Somali Shilling",
        "countries": [
            "Somalia"
        ]
    },
    {
        "code": "SRD",
        "number": "968",
        "digits": 2,
        "currency": "Surinam Dollar",
        "countries": [
            "Suriname"
        ]
    },
    {
        "code": "SSP",
        "number": "728",
        "digits": 2,
        "currency": "South Sudanese Pound",
        "countries": [
            "South Sudan"
        ]
    },
    {
        "code": "STN",
        "number": "930",
        "digits": 2,
        "currency": "Dobra",
        "countries": [
            "Sao Tome and Principe"
        ]
    },
    {
        "code": "SVC",
        "number": "222",
        "digits": 2,
        "currency": "El Salvador Colon",
        "countries": [
            "El Salvador"
        ]
    },
    {
        "code": "SYP",
        "number": "760",
        "digits": 2,
        "currency": "Syrian Pound",
        "countries": [
            "Syrian Arab Republic"
        ]
    },
    {
        "code": "SZL",
        "number": "748",
        "digits": 2,
        "currency": "Lilangeni",
        "countries": [
            "Eswatini"
        ]
    },
    {
        "code": "THB",
        "number": "764",
        "digits": 2,
        "currency": "Baht",
        "countries": [
            "Thailand"
        ]
    },
    {
        "code": "TJS",
        "number": "972",
        "digits": 2,
        "currency": "Somoni",
        "countries": [
            "Tajikistan"
        ]
    },
    {
        "code": "TMT",
        "number": "934",
        "digits": 2,
        "currency": "Turkmenistan New Manat",
        "countries": [
            "Turkmenistan"
        ]
    },
    {
        "code": "TND",
        "number": "788",
        "digits": 3,
        "currency": "Tunisian Dinar",
        "countries": [
            "Tunisia"
        ]
    },
    {
        "code": "TOP",
        "number": "776",
        "digits": 2,
        "currency": "Pa\u2019anga",
        "countries": [
            "Tonga"
        ]
    },
    {
        "code": "TRY",
        "number": "949",
        "digits": 2,
        "currency": "Turkish Lira",
        "countries": [
            "T\xfcrki\u0307ye"
        ]
    },
    {
        "code": "TTD",
        "number": "780",
        "digits": 2,
        "currency": "Trinidad and Tobago Dollar",
        "countries": [
            "Trinidad and Tobago"
        ]
    },
    {
        "code": "TWD",
        "number": "901",
        "digits": 2,
        "currency": "New Taiwan Dollar",
        "countries": [
            "Taiwan (Province of China)"
        ]
    },
    {
        "code": "TZS",
        "number": "834",
        "digits": 2,
        "currency": "Tanzanian Shilling",
        "countries": [
            "Tanzania, United Republic Of"
        ]
    },
    {
        "code": "UAH",
        "number": "980",
        "digits": 2,
        "currency": "Hryvnia",
        "countries": [
            "Ukraine"
        ]
    },
    {
        "code": "UGX",
        "number": "800",
        "digits": 0,
        "currency": "Uganda Shilling",
        "countries": [
            "Uganda"
        ]
    },
    {
        "code": "USD",
        "number": "840",
        "digits": 2,
        "currency": "US Dollar",
        "countries": [
            "American Samoa",
            "Bonaire, Sint Eustatius and Saba",
            "British Indian Ocean Territory (The)",
            "Ecuador",
            "El Salvador",
            "Guam",
            "Haiti",
            "Marshall Islands (The)",
            "Micronesia (Federated States Of)",
            "Northern Mariana Islands (The)",
            "Palau",
            "Panama",
            "Puerto Rico",
            "Timor-Leste",
            "Turks and Caicos Islands (The)",
            "United States Minor Outlying Islands (The)",
            "United States of America (The)",
            "Virgin Islands (British)",
            "Virgin Islands (u.s.)"
        ]
    },
    {
        "code": "USN",
        "number": "997",
        "digits": 2,
        "currency": "US Dollar (Next day)",
        "countries": [
            "United States of America (The)"
        ]
    },
    {
        "code": "UYI",
        "number": "940",
        "digits": 0,
        "currency": "Uruguay Peso en Unidades Indexadas (UI)",
        "countries": [
            "Uruguay"
        ]
    },
    {
        "code": "UYU",
        "number": "858",
        "digits": 2,
        "currency": "Peso Uruguayo",
        "countries": [
            "Uruguay"
        ]
    },
    {
        "code": "UYW",
        "number": "927",
        "digits": 4,
        "currency": "Unidad Previsional",
        "countries": [
            "Uruguay"
        ]
    },
    {
        "code": "UZS",
        "number": "860",
        "digits": 2,
        "currency": "Uzbekistan Sum",
        "countries": [
            "Uzbekistan"
        ]
    },
    {
        "code": "VED",
        "number": "926",
        "digits": 2,
        "currency": "Bol\xedvar Soberano",
        "countries": [
            "Venezuela (Bolivarian Republic Of)"
        ]
    },
    {
        "code": "VES",
        "number": "928",
        "digits": 2,
        "currency": "Bol\xedvar Soberano",
        "countries": [
            "Venezuela (Bolivarian Republic Of)"
        ]
    },
    {
        "code": "VND",
        "number": "704",
        "digits": 0,
        "currency": "Dong",
        "countries": [
            "Viet Nam"
        ]
    },
    {
        "code": "VUV",
        "number": "548",
        "digits": 0,
        "currency": "Vatu",
        "countries": [
            "Vanuatu"
        ]
    },
    {
        "code": "WST",
        "number": "882",
        "digits": 2,
        "currency": "Tala",
        "countries": [
            "Samoa"
        ]
    },
    {
        "code": "XAF",
        "number": "950",
        "digits": 0,
        "currency": "CFA Franc BEAC",
        "countries": [
            "Cameroon",
            "Central African Republic (The)",
            "Chad",
            "Congo (The)",
            "Equatorial Guinea",
            "Gabon"
        ]
    },
    {
        "code": "XAG",
        "number": "961",
        "digits": 0,
        "currency": "Silver",
        "countries": [
            "Zz11_silver"
        ]
    },
    {
        "code": "XAU",
        "number": "959",
        "digits": 0,
        "currency": "Gold",
        "countries": [
            "Zz08_gold"
        ]
    },
    {
        "code": "XBA",
        "number": "955",
        "digits": 0,
        "currency": "Bond Markets Unit European Composite Unit (EURCO)",
        "countries": [
            "Zz01_bond Markets Unit European_eurco"
        ]
    },
    {
        "code": "XBB",
        "number": "956",
        "digits": 0,
        "currency": "Bond Markets Unit European Monetary Unit (E.M.U.-6)",
        "countries": [
            "Zz02_bond Markets Unit European_emu-6"
        ]
    },
    {
        "code": "XBC",
        "number": "957",
        "digits": 0,
        "currency": "Bond Markets Unit European Unit of Account 9 (E.U.A.-9)",
        "countries": [
            "Zz03_bond Markets Unit European_eua-9"
        ]
    },
    {
        "code": "XBD",
        "number": "958",
        "digits": 0,
        "currency": "Bond Markets Unit European Unit of Account 17 (E.U.A.-17)",
        "countries": [
            "Zz04_bond Markets Unit European_eua-17"
        ]
    },
    {
        "code": "XCD",
        "number": "951",
        "digits": 2,
        "currency": "East Caribbean Dollar",
        "countries": [
            "Anguilla",
            "Antigua and Barbuda",
            "Dominica",
            "Grenada",
            "Montserrat",
            "Saint Kitts and Nevis",
            "Saint Lucia",
            "Saint Vincent and the Grenadines"
        ]
    },
    {
        "code": "XDR",
        "number": "960",
        "digits": 0,
        "currency": "SDR (Special Drawing Right)",
        "countries": [
            "International Monetary Fund (Imf)\xa0"
        ]
    },
    {
        "code": "XOF",
        "number": "952",
        "digits": 0,
        "currency": "CFA Franc BCEAO",
        "countries": [
            "Benin",
            "Burkina Faso",
            "C\xf4te D'ivoire",
            "Guinea-Bissau",
            "Mali",
            "Niger (The)",
            "Senegal",
            "Togo"
        ]
    },
    {
        "code": "XPD",
        "number": "964",
        "digits": 0,
        "currency": "Palladium",
        "countries": [
            "Zz09_palladium"
        ]
    },
    {
        "code": "XPF",
        "number": "953",
        "digits": 0,
        "currency": "CFP Franc",
        "countries": [
            "French Polynesia",
            "New Caledonia",
            "Wallis and Futuna"
        ]
    },
    {
        "code": "XPT",
        "number": "962",
        "digits": 0,
        "currency": "Platinum",
        "countries": [
            "Zz10_platinum"
        ]
    },
    {
        "code": "XSU",
        "number": "994",
        "digits": 0,
        "currency": "Sucre",
        "countries": [
            "Sistema Unitario De Compensacion Regional De Pagos \"Sucre\""
        ]
    },
    {
        "code": "XTS",
        "number": "963",
        "digits": 0,
        "currency": "Codes specifically reserved for testing purposes",
        "countries": [
            "Zz06_testing_code"
        ]
    },
    {
        "code": "XUA",
        "number": "965",
        "digits": 0,
        "currency": "ADB Unit of Account",
        "countries": [
            "Member Countries of the African Development Bank Group"
        ]
    },
    {
        "code": "XXX",
        "number": "999",
        "digits": 0,
        "currency": "The codes assigned for transactions where no currency is involved",
        "countries": [
            "Zz07_no_currency"
        ]
    },
    {
        "code": "YER",
        "number": "886",
        "digits": 2,
        "currency": "Yemeni Rial",
        "countries": [
            "Yemen"
        ]
    },
    {
        "code": "ZAR",
        "number": "710",
        "digits": 2,
        "currency": "Rand",
        "countries": [
            "Lesotho",
            "Namibia",
            "South Africa"
        ]
    },
    {
        "code": "ZMW",
        "number": "967",
        "digits": 2,
        "currency": "Zambian Kwacha",
        "countries": [
            "Zambia"
        ]
    },
    {
        "code": "ZWG",
        "number": "924",
        "digits": 2,
        "currency": "Zimbabwe Gold",
        "countries": [
            "Zimbabwe"
        ]
    }
];


var $7ccfde4ad14aa808$exports = {};
/*
	Follows ISO 4217, https://www.iso.org/iso-4217-currency-codes.html
	See https://www.currency-iso.org/dam/downloads/lists/list_one.xml
	Data last updated 2024-06-25
*/ $7ccfde4ad14aa808$exports = "2024-06-25";


var $a8fef35c216e9dac$var$code = function(code) {
    code = code.toUpperCase();
    return $5888c65d28e4005b$exports($8539891341747ee3$exports, function(c) {
        return c.code === code;
    });
};
var $a8fef35c216e9dac$var$country = function(country) {
    country = country.toLowerCase();
    return $8539891341747ee3$exports.filter(function(c) {
        return (c.countries.map(function(c) {
            return c.toLowerCase();
        }) || []).indexOf(country) > -1;
    });
};
var $a8fef35c216e9dac$var$number = function(number) {
    return $5888c65d28e4005b$exports($8539891341747ee3$exports, function(c) {
        return c.number === String(number);
    });
};
var $a8fef35c216e9dac$var$codes = function() {
    return $8539891341747ee3$exports.map(function(c) {
        return c.code;
    });
};
var $a8fef35c216e9dac$var$numbers = function() {
    var items = $8539891341747ee3$exports.map(function(c) {
        return c.number;
    });
    // handle cases where number is undefined (e.g. XFU and XBT)
    return items.filter(function(n) {
        if (n) return n;
    });
};
var $a8fef35c216e9dac$var$countries = function() {
    var m = $8539891341747ee3$exports.filter(function(c) {
        return c.countries;
    }).map(function(c) {
        return c.countries;
    });
    return $ae628098ba663ed7$exports(Array.prototype.concat.apply([], m));
};
$a8fef35c216e9dac$export$6565f9f03506010b = $a8fef35c216e9dac$var$code;
$a8fef35c216e9dac$export$142596e469219c06 = $a8fef35c216e9dac$var$country;
$a8fef35c216e9dac$export$98e628dec113755e = $a8fef35c216e9dac$var$number;
$a8fef35c216e9dac$export$e45cb6485273080e = $a8fef35c216e9dac$var$codes;
$a8fef35c216e9dac$export$1f6c9cc012ebacae = $a8fef35c216e9dac$var$numbers;
$a8fef35c216e9dac$export$e5ad74579c86b003 = $a8fef35c216e9dac$var$countries;
$a8fef35c216e9dac$export$d8d14fdd4313cced = $7ccfde4ad14aa808$exports;
$a8fef35c216e9dac$export$4051a07651545597 = $8539891341747ee3$exports;


const $d8e0dde69ea5b073$export$f63c37d36dbc92f5 = Object.keys($1102f92b2d220c0d$exports.customList('countryCode'));
const $d8e0dde69ea5b073$export$360fc9c8fb7a3ce4 = $a8fef35c216e9dac$export$e45cb6485273080e();
const $d8e0dde69ea5b073$export$8ed9fedd0e9c1187 = [
    ...(0, (/*@__PURE__*/$parcel$interopDefault($df41e5b15345a476$exports))).tz.names().filter((name)=>name.includes('/') && !name.includes('Etc/')),
    // Backward compatibility for old recordings
    'PST8PDT',
    'CST6CDT',
    'EST5EDT',
    'MST7MDT'
];
const $d8e0dde69ea5b073$var$OpeningTimesRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    margin-bottom: 0.5em;
`;
const $d8e0dde69ea5b073$var$toInternal = (values)=>values.map((value)=>({
            day: value.day,
            start: new Date(1987, 3, 25, value.startHour, value.startMinute),
            stop: new Date(1987, 3, 25, value.stopHour, value.stopMinute)
        }));
const $d8e0dde69ea5b073$var$toApi = (values)=>values.map((value)=>({
            day: value.day,
            startHour: value.start.getHours(),
            startMinute: value.start.getMinutes(),
            stopHour: value.stop.getHours(),
            stopMinute: value.stop.getMinutes()
        }));
const $d8e0dde69ea5b073$var$hasErrors = (values)=>values.reduce((acc, cur)=>acc || cur.stop.getTime() <= cur.start.getTime(), false);
const $d8e0dde69ea5b073$export$968308fd9c434585 = ({ values: propValues, editing: editing, onChange: onChange })=>{
    const [values, setValues] = (0, $kYL7Z.useState)(()=>$d8e0dde69ea5b073$var$toInternal(propValues));
    const prevPropValues = (0, $kYL7Z.useRef)(propValues);
    // Sync from props when identity changes
    (0, $kYL7Z.useEffect)(()=>{
        if (propValues !== prevPropValues.current) {
            prevPropValues.current = propValues;
            setValues($d8e0dde69ea5b073$var$toInternal(propValues));
        }
    }, [
        propValues
    ]);
    const days = [
        "sun",
        "mon",
        "tue",
        "wed",
        "thu",
        "fri",
        "sat"
    ];
    const handleChange = (index, field, newDate)=>{
        const newValues = values.map((v, i)=>i === index ? {
                ...v,
                [field]: newDate
            } : v);
        setValues(newValues);
        onChange($d8e0dde69ea5b073$var$toApi(newValues), $d8e0dde69ea5b073$var$hasErrors(newValues));
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                children: "Opening Times"
            }),
            values.map((value, index)=>{
                const error = value.stop.getTime() <= value.start.getTime();
                const color = !editing ? "rgb(150,150,150)" : error ? "rgb(255,0,0)" : "rgb(0,0,0)";
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($d8e0dde69ea5b073$var$OpeningTimesRow, {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                            style: {
                                color: color,
                                display: "inline-block",
                                minWidth: "4ch",
                                marginRight: "1em",
                                verticalAlign: "middle"
                            },
                            children: `${days[value.day]}:`
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f80568c1718f0e62$export$5f876910ea565cd3), {
                            precision: (0, $9abbf4372f2fff3e$export$3a3ade082c590099).MINUTE,
                            disabled: !editing,
                            value: value.start,
                            onChange: (start)=>handleChange(index, 'start', start)
                        }, "startPicker"),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                            style: {
                                color: color,
                                display: "inline-block",
                                marginLeft: "0.5em",
                                marginRight: "0.5em",
                                verticalAlign: "middle"
                            },
                            children: "- to -"
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f80568c1718f0e62$export$5f876910ea565cd3), {
                            precision: (0, $9abbf4372f2fff3e$export$3a3ade082c590099).MINUTE,
                            disabled: !editing,
                            value: value.stop,
                            onChange: (stop)=>handleChange(index, 'stop', stop)
                        }, "stopPicker")
                    ]
                }, value.day);
            })
        ]
    });
};




const $bca37fd9a973373b$var$_LocSchema = ({ ...props })=>{
    return {
        type: "object",
        required: [
            "name",
            "organisation",
            "coordinates",
            "timezone",
            "openingTimes"
        ],
        properties: {
            name: {
                type: "string"
            },
            organisation: {
                oneOf: props.availableOrganisations ? props.availableOrganisations.map((org)=>({
                        const: org.id,
                        title: org.name
                    })) : [
                    {
                        const: ""
                    }
                ]
            },
            timezone: {
                type: "string",
                enum: (0, $d8e0dde69ea5b073$export$8ed9fedd0e9c1187)
            },
            currency: {
                type: "string",
                enum: (0, $d8e0dde69ea5b073$export$360fc9c8fb7a3ce4)
            },
            countryCode: {
                type: "string",
                enum: (0, $d8e0dde69ea5b073$export$f63c37d36dbc92f5)
            },
            coordinates: {
                type: "string",
                pattern: "(?<lat>^[-+]?(?:[1-8]?\\d(?:\\.\\d+)?|90(?:\\.0+)?))\\s*,\\s*(?<lng>[-+]?(?:180(?:\\.0+)?|(?:1[0-7]\\d|[1-9]?\\d)(?:\\.\\d+)?))$"
            },
            openingTimes: {
                type: "array",
                minItems: 7,
                maxItems: 7,
                items: {
                    type: "object",
                    properties: {
                        day: {
                            type: "integer",
                            minimum: 0,
                            maximum: 6
                        },
                        startHour: {
                            type: "integer",
                            minimum: 0,
                            maximum: 23
                        },
                        startMinute: {
                            type: "integer",
                            minimum: 0,
                            maximum: 59
                        },
                        stopHour: {
                            type: "integer",
                            minimum: 0,
                            maximum: 23
                        },
                        stopMinute: {
                            type: "integer",
                            minimum: 0,
                            maximum: 59
                        }
                    }
                }
            }
        }
    };
};
const $bca37fd9a973373b$var$_UILocSchema = ()=>({
        type: "VerticalLayout",
        elements: [
            {
                type: "Group",
                elements: [
                    {
                        type: "HorizontalLayout",
                        elements: [
                            {
                                type: "Control",
                                scope: "#/properties/organisation"
                            },
                            {
                                type: "Control",
                                scope: "#/properties/name"
                            }
                        ]
                    },
                    {
                        type: "HorizontalLayout",
                        elements: [
                            {
                                type: "Control",
                                scope: "#/properties/coordinates"
                            },
                            {
                                type: "Control",
                                scope: "#/properties/timezone"
                            },
                            {
                                type: "Control",
                                scope: "#/properties/currency"
                            }
                        ]
                    }
                ]
            }
        ]
    });
const $bca37fd9a973373b$var$ContentWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).form`
  width: 90%;
  margin: 2em auto;
  overflow: auto;
`;
const $bca37fd9a973373b$var$MapSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: block;
    margin: 2em auto;
    width: 90%;
    height: 25em;
`;
const $bca37fd9a973373b$var$SearchBox = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).input`
    margin: 1em;
    width: 50ch;
    font-size: 1.5em;
    border: 5px solid #130a35;
`;
const $bca37fd9a973373b$var$StyledButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    display: block;
    margin: 2em auto;
`;
const $bca37fd9a973373b$var$transformOpeningTimes = (periods)=>{
    // Google Maps opening_hours.periods is an array with {open:x, close:x} objects
    // where x = {day, time, hours, minutes} the array does not contain days in which
    // the place is closed
    const opens = periods.reduce((acc, cur)=>({
            ...acc,
            [cur.open.day]: cur.open
        }), {});
    const close = periods.reduce((acc, cur)=>({
            ...acc,
            [cur.close.day]: cur.close
        }), {});
    return [
        ...Array(7).keys()
    ].reduce((acc, day)=>[
            ...acc,
            {
                day: day,
                startHour: opens[day]?.hours ?? 0,
                startMinute: opens[day]?.minutes ?? 0,
                stopHour: close[day]?.hours ?? 23,
                stopMinute: close[day]?.minutes ?? 59
            }
        ], []);
};
const $bca37fd9a973373b$var$formatName = (name, address, org_name)=>{
    let ret = org_name ? name.toLowerCase().replace(org_name.toLowerCase(), '') : name.toLowerCase();
    ret = ret ? ret.replace(/\w\S*/g, (text)=>text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()) : address ?? name;
    return ret.replace(/[^0-9a-z ]/gi, '');
};
const $bca37fd9a973373b$var$PlaceAutocomplete = ({ onPlaceSelect: onPlaceSelect })=>{
    const [placeAutocomplete, setPlaceAutocomplete] = (0, $kYL7Z.useState)(null);
    const inputRef = (0, $kYL7Z.useRef)(null);
    const places = (0, $7c3acd9b84fb12ed$export$5b40cf36c69caef7)("places");
    const [currentListener, setCurrentListener] = (0, $kYL7Z.useState)(null);
    (0, $kYL7Z.useEffect)(()=>{
        if (!places || !inputRef.current) return;
        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, {
            fields: [
                "geometry",
                "name",
                "formatted_address",
                "opening_hours"
            ]
        }));
    }, [
        places
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!!placeAutocomplete) {
            if (currentListener) currentListener.remove();
            setCurrentListener(placeAutocomplete.addListener("place_changed", ()=>{
                onPlaceSelect(placeAutocomplete.getPlace());
            }));
        }
    }, [
        onPlaceSelect,
        placeAutocomplete
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: "autocomplete-container",
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($bca37fd9a973373b$var$SearchBox, {
            ref: inputRef,
            placeholder: "Search"
        })
    });
};
const $bca37fd9a973373b$var$MapHandler = ({ place: place, marker: marker })=>{
    const map = (0, $7c3acd9b84fb12ed$export$86f8f9f08863e403)();
    (0, $kYL7Z.useEffect)(()=>{
        if (!map || !place || !marker) return;
        if (place.geometry?.viewport) map.fitBounds(place.geometry?.viewport);
        marker.position = place.geometry?.location;
    }, [
        map,
        place,
        marker
    ]);
    return null;
};
const $bca37fd9a973373b$var$GeoCode = ({ latlng: latlng, shouldGeocode: shouldGeocode, after: after })=>{
    const [_latlng, set_latlng] = (0, $kYL7Z.useState)(latlng);
    const geocodingLib = (0, $7c3acd9b84fb12ed$export$5b40cf36c69caef7)('geocoding');
    const geocoder = (0, $kYL7Z.useMemo)(()=>geocodingLib && new geocodingLib.Geocoder(), [
        geocodingLib
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!geocoder) return;
        console.log("Loaded geocode...");
    }, [
        geocoder
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!!geocoder && !!_latlng && shouldGeocode) {
            const latlngSplit = _latlng.split(",");
            geocoder.geocode({
                location: {
                    lat: parseFloat(latlngSplit[0]),
                    lng: parseFloat(latlngSplit[1])
                }
            }).then((result)=>{
                if (result.results?.length) after(result.results[0]);
            }).catch((error)=>{
                console.log(error);
            });
        }
    }, [
        _latlng
    ]);
    if (latlng !== _latlng) set_latlng(latlng);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {});
};
const $bca37fd9a973373b$export$316d81f8f8851977 = ({ isOpen: isOpen, onClose: onClose, onSave: onSave, preSelectedOrg: preSelectedOrg })=>{
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const [selectedOrg, setSelectedOrg] = (0, $kYL7Z.useState)(preSelectedOrg);
    const [selectedPlace, setSelectedPlace] = (0, $kYL7Z.useState)(null);
    const [shouldGeocode, setShouldGeocode] = (0, $kYL7Z.useState)(false);
    const [markerRef, marker] = (0, $7c3acd9b84fb12ed$export$ee72183bc46d9ec2)();
    const [orgMap, setOrgMap] = (0, $kYL7Z.useState)({});
    const [locSchema, setLocSchema] = (0, $kYL7Z.useState)($bca37fd9a973373b$var$_LocSchema({}));
    const [uiLocSchema, setUiLocSchema] = (0, $kYL7Z.useState)($bca37fd9a973373b$var$_UILocSchema(locSchema));
    const [hasCoordinatesError, setHasCoordinatesError] = (0, $kYL7Z.useState)(false);
    const [hasFormError, setHasFormError] = (0, $kYL7Z.useState)(false);
    const [hasOtherError, setHasOtherError] = (0, $kYL7Z.useState)(false);
    const [formData, setFormData] = (0, $kYL7Z.useState)({
        organisation: selectedOrg?.id,
        name: "",
        coordinates: "",
        timezone: "",
        currency: undefined,
        openingTimes: [
            ...Array(7).keys()
        ].reduce((acc, day)=>[
                ...acc,
                {
                    day: day,
                    startHour: 0,
                    startMinute: 0,
                    stopHour: 23,
                    stopMinute: 59
                }
            ], [])
    });
    (0, $kYL7Z.useEffect)(()=>{
        if (preSelectedOrg) {
            setSelectedOrg(preSelectedOrg);
            setFormData((prev)=>({
                    ...prev,
                    organisation: preSelectedOrg.id
                }));
        }
    }, [
        preSelectedOrg
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        // onComponentDidMount
        setLoading(true);
        (0, $5a9cade4af2d6a52$export$d030b7498dcede47).list().then((availableOrganisations)=>{
            availableOrganisations.sort((a, b)=>a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1);
            const _locSchema = $bca37fd9a973373b$var$_LocSchema({
                availableOrganisations: availableOrganisations
            });
            setOrgMap(availableOrganisations.reduce((map, org)=>({
                    ...map,
                    [org.id]: org
                }), {}));
            setLocSchema(_locSchema);
            setUiLocSchema($bca37fd9a973373b$var$_UILocSchema(_locSchema));
            console.log("Loaded available organisations");
        }).catch((error)=>{
            console.log("Failed to load: " + error.message);
        }).finally(()=>setLoading(false));
    }, []);
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen && !hasCoordinatesError) {
            console.log("Fetching timezone for ", formData.coordinates);
            fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${formData.coordinates}&timestamp=${Math.round(+new Date() / 1000)}&key=${(0, $a13d063d3fb3aa31$export$2510a7994c247cf7)}`).then((res)=>res.json()).then((data)=>{
                setFormData((prev)=>({
                        ...prev,
                        timezone: data.timeZoneId
                    }));
            });
        } else if (isOpen) console.log("Coordinates changed with error");
    }, [
        formData.coordinates,
        hasCoordinatesError
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        title: `Creating a location ${selectedOrg ? 'for ' + selectedOrg.name : ''}`,
        isOpen: isOpen,
        onClose: ()=>onClose({
                ...formData
            }),
        size: "75%",
        children: loading ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {}) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($bca37fd9a973373b$var$ContentWrapper, {
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$cb94397127ac9363), {
                    children: "Find a location to create"
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7c3acd9b84fb12ed$export$434374b2a40d237), {
                    apiKey: (0, $a13d063d3fb3aa31$export$d4214b4977c811ed),
                    onLoad: ()=>console.log('Maps API has loaded.'),
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($bca37fd9a973373b$var$MapSection, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7c3acd9b84fb12ed$export$a5c7b93649eaf8f8), {
                                mapId: "create-location",
                                defaultZoom: 15,
                                defaultCenter: {
                                    lat: 51.5266062,
                                    lng: -0.0817229
                                },
                                mapTypeControl: false,
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7c3acd9b84fb12ed$export$5dd2dc1fc7030ab5), {
                                    ref: markerRef,
                                    position: null
                                })
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7c3acd9b84fb12ed$export$68000b548d3309a0), {
                                position: (0, $7c3acd9b84fb12ed$export$90e210fd0946c45e).LEFT_TOP,
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                    className: "autocomplete-control",
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($bca37fd9a973373b$var$PlaceAutocomplete, {
                                        onPlaceSelect: (place)=>{
                                            console.log("Selected place", place);
                                            const data = {
                                                ...formData,
                                                name: $bca37fd9a973373b$var$formatName(place?.name ?? "", place?.formatted_address ?? "", selectedOrg?.name),
                                                coordinates: `${place.geometry.location.lat()},${place.geometry.location.lng()}`
                                            };
                                            if (!!place.opening_hours?.periods?.length) data.openingTimes = $bca37fd9a973373b$var$transformOpeningTimes(place.opening_hours.periods);
                                            setShouldGeocode(false);
                                            setSelectedPlace(place);
                                            setFormData(data);
                                        }
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($bca37fd9a973373b$var$MapHandler, {
                                place: selectedPlace,
                                marker: marker
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($bca37fd9a973373b$var$GeoCode, {
                                latlng: formData.coordinates,
                                shouldGeocode: shouldGeocode,
                                after: (place)=>{
                                    console.log("Geocoded place", place);
                                    setShouldGeocode(false);
                                    setSelectedPlace(place);
                                    setFormData((prev)=>({
                                            ...prev,
                                            name: $bca37fd9a973373b$var$formatName(place?.name ?? "", place?.formatted_address ?? "", selectedOrg?.name)
                                        }));
                                }
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                    children: "And adjust details"
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                    schema: locSchema,
                    uischema: uiLocSchema,
                    data: formData,
                    onChange: ({ data: data, errors: errors })=>{
                        const _hasCoordinatesError = errors.some((e)=>'/coordinates' in e);
                        setHasCoordinatesError(_hasCoordinatesError);
                        setHasFormError(!!errors.length);
                        setShouldGeocode(data.coordinates !== formData.coordinates && !_hasCoordinatesError);
                        setSelectedOrg(orgMap[data.organisation]);
                        setFormData(data);
                    }
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0199c8413a0068dd$export$60332b2344f7fe41), {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d8e0dde69ea5b073$export$968308fd9c434585), {
                        values: formData.openingTimes,
                        editing: true,
                        onChange: (data, errors)=>{
                            setHasOtherError(errors);
                            setFormData({
                                ...formData,
                                openingTimes: data
                            });
                        }
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($bca37fd9a973373b$var$StyledButton, {
                    text: "Create",
                    intent: "primary",
                    fill: true,
                    disabled: hasFormError || hasOtherError,
                    onClick: ()=>{
                        onSave({
                            ...formData
                        }, selectedOrg);
                        onClose({
                            ...formData
                        });
                    }
                })
            ]
        })
    });
};







const $9a4701ac8fc243a2$export$34848ee8632b1f2f = [
    {
        value: 'region',
        label: 'Region',
        description: 'Administrative or territory-based grouping, e.g. north-uk, central-europe, west-coast'
    },
    {
        value: 'group',
        label: 'Group',
        description: 'Operational or brand grouping of locations, e.g. flagship-stores, outlet-stores'
    },
    {
        value: 'territory',
        label: 'Territory',
        description: 'Broad territory or macro-region, e.g. europe, north-america, asia-pacific'
    }
];
const $9a4701ac8fc243a2$export$fe7d799ae8150cf3 = /^[^\n]+$/;
const $9a4701ac8fc243a2$export$e9018291a1fe59a6 = 128;
const $9a4701ac8fc243a2$export$c1517564b74c2252 = (tag)=>tag && typeof tag === 'object' ? `${$9a4701ac8fc243a2$export$34848ee8632b1f2f.find((t)=>t.value === tag.tagType)?.label || tag.tagType}: ${tag.tagValue}` : String(tag ?? '');


// -------------------------------------------------
// ----------------------------------- auto-fit tags
const $b732d80cef0bce13$var$AutoFitTagsCell = ({ tags: tags })=>{
    const containerRef = (0, $kYL7Z.useRef)(null);
    const measureRef = (0, $kYL7Z.useRef)(null);
    const fitRef = (0, $kYL7Z.useRef)(tags.length);
    const [, forceUpdate] = (0, $kYL7Z.useState)(0);
    const compute = (0, $kYL7Z.useCallback)(()=>{
        const container = containerRef.current;
        const measure = measureRef.current;
        if (!container || !measure || !tags.length) return;
        const cell = container.closest('[role="gridcell"]');
        if (!cell) return;
        const available = cell.offsetWidth - 24; // cell padding
        const children = measure.children;
        if (!children.length || available <= 0) return;
        const badgeWidth = children[children.length - 1].offsetWidth + 4;
        let used = 0;
        let fit = 0;
        for(let i = 0; i < tags.length; i++){
            const tagWidth = children[i].offsetWidth + (i > 0 ? 4 : 0);
            const isLast = i === tags.length - 1;
            const spaceNeeded = used + tagWidth + (isLast ? 0 : badgeWidth);
            if (spaceNeeded > available && fit > 0) break;
            used += tagWidth + (i > 0 ? 4 : 0);
            fit++;
        }
        if (fit !== fitRef.current) {
            fitRef.current = fit;
            forceUpdate((n)=>n + 1);
        }
    }, [
        tags
    ]);
    (0, $kYL7Z.useLayoutEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        const cell = container.closest('[role="gridcell"]');
        if (!cell) return;
        compute();
        const ro = new ResizeObserver(compute);
        ro.observe(cell);
        return ()=>ro.disconnect();
    }, [
        compute
    ]);
    if (!tags.length) return null;
    const visibleCount = fitRef.current;
    const remaining = tags.length - visibleCount;
    const content = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
        ref: containerRef,
        style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: 4,
            overflow: 'hidden'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                style: {
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 4,
                    position: 'absolute',
                    visibility: 'hidden',
                    pointerEvents: 'none',
                    whiteSpace: 'nowrap'
                },
                ref: measureRef,
                children: [
                    tags.map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                            minimal: true,
                            small: true,
                            round: true,
                            intent: "primary",
                            children: t
                        }, t)),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        small: true,
                        round: true,
                        children: [
                            "+",
                            tags.length
                        ]
                    })
                ]
            }),
            tags.slice(0, visibleCount).map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    small: true,
                    round: true,
                    intent: "primary",
                    children: t
                }, t)),
            remaining > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                minimal: true,
                small: true,
                round: true,
                children: [
                    "+",
                    remaining
                ]
            })
        ]
    });
    if (remaining <= 0) return content;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
        interactionKind: "hover",
        placement: "right",
        hoverOpenDelay: 200,
        hoverCloseDelay: 100,
        minimal: true,
        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            style: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 4,
                padding: 8,
                maxWidth: 300
            },
            children: tags.map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    small: true,
                    round: true,
                    intent: "primary",
                    children: t
                }, t))
        }),
        children: content
    });
};
// -------------------------------------------------
// ----------------------------------- columns model
const $b732d80cef0bce13$var$LocationModelColumns = [
    {
        key: 'name',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true,
        showDefaultFilter: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/locs/' + params.row.id,
                children: params.row.name
            })
    },
    {
        key: 'devices',
        name: 'Devices',
        width: 90,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/devs?loc=' + params.row.id,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    round: true,
                    interactive: true,
                    children: "Devices"
                })
            })
    },
    {
        key: 'cameras',
        name: 'Cameras',
        width: 90,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/recs?loc=' + params.row.id,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    round: true,
                    interactive: true,
                    children: "Cameras"
                })
            })
    },
    {
        key: 'organisation.name',
        name: 'Organisation',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>{
            const orgid = params.row?.organisation?._id ?? params.row?.organisation?.id;
            return orgid ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/orgs/' + orgid,
                children: params.row.organisation.name
            }) : '';
        }
    },
    {
        key: 'status',
        name: 'Status',
        width: 150,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'timezone',
        name: 'Timezone',
        width: 150,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'currency',
        name: 'Currency',
        width: 150,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'salesDataId',
        name: 'Sales Data ID',
        width: 150,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'tags',
        name: 'Tags',
        width: 150,
        resizable: true,
        filterable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b732d80cef0bce13$var$AutoFitTagsCell, {
                tags: (params.row.tags || []).map((0, $9a4701ac8fc243a2$export$c1517564b74c2252))
            })
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.createdAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
            })
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.updatedAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
            })
    }
];
const $b732d80cef0bce13$export$cf2e13ec3e706a73 = ({ search: search })=>{
    const { setLoading: setLoading, setNav: setNav, setControls: setControls, setCount: setCount, loading: loading } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [data, setData] = (0, $kYL7Z.useState)(null);
    const [org, setOrg] = (0, $kYL7Z.useState)(undefined);
    const [creating, setCreating] = (0, $kYL7Z.useState)(false);
    const toggleCreating = (0, $kYL7Z.useCallback)(()=>{
        setCreating((prev)=>!prev);
    }, []);
    (0, $kYL7Z.useEffect)(()=>{
        setControls([
            {
                name: "Create",
                onClick: toggleCreating,
                icon: "add"
            }
        ]);
    }, [
        toggleCreating
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        console.log("loading locs");
        setLoading({
            status: true,
            location: "Loading locations..."
        });
        (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).list({
            include: "organisationDetails,salesDataId,tagDetails",
            withinOrganisations: search.get('org') || undefined
        }).then(async (locs)=>{
            console.log("Loaded " + locs.length + " locs");
            if (search.get('org')) {
                const fetchedOrg = await (0, $5a9cade4af2d6a52$export$d030b7498dcede47).get(search.get('org'));
                setOrg(fetchedOrg);
                setData(locs);
                setLoading({
                    status: false,
                    location: fetchedOrg.name + " locations"
                });
                setNav({
                    left: [
                        {
                            name: fetchedOrg.name,
                            path: "/orgs/" + fetchedOrg.id,
                            icon: "office",
                            subpaths: [
                                {
                                    name: "Locations",
                                    icon: "area-of-interest",
                                    path: '/locs?org=' + fetchedOrg.id
                                },
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?org=' + fetchedOrg.id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?org=' + fetchedOrg.id
                                },
                                {
                                    name: "Users",
                                    icon: "people",
                                    path: '/orgs/' + fetchedOrg.id + '/users'
                                }
                            ]
                        }
                    ]
                });
            } else {
                setData(locs);
                setLoading({
                    status: false,
                    location: "All locations"
                });
            }
        }).catch((error)=>{
            console.error(error);
            setLoading({
                status: false,
                location: "Failed to load locations..."
            });
            setData(error);
        });
    }, [
        search
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $bca37fd9a973373b$export$316d81f8f8851977), {
                isOpen: creating,
                preSelectedOrg: org,
                onClose: ()=>{
                    toggleCreating();
                },
                onSave: (info, saveOrg)=>{
                    console.log("Creating location: ", info);
                    const currentNavContext = loading.location;
                    setLoading({
                        status: true,
                        location: `Creating location ${info.name} for ${saveOrg.name}...`
                    });
                    (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).create(info).then((ret)=>{
                        ret.organisation = saveOrg;
                        console.log("Created location: ", ret);
                        (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                            message: `Created location ${ret.name} for ${saveOrg.name}`
                        });
                        if (org && org.id === saveOrg.id) setData((prev)=>[
                                ...prev,
                                ret
                            ]);
                    }).catch((err)=>{
                        console.log(err);
                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                            message: "Failed to save " + err.message,
                            timeout: 5000
                        });
                    }).finally(()=>{
                        toggleCreating();
                        setLoading({
                            status: false,
                            location: currentNavContext
                        });
                    });
                }
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                columns: $b732d80cef0bce13$var$LocationModelColumns,
                data: data ?? [],
                defaultSort: "name",
                columnFilterFns: {
                    tags: (row, key, term)=>(row.tags || []).some((t)=>(0, $9a4701ac8fc243a2$export$c1517564b74c2252)(t).toLowerCase().includes(term))
                },
                onCount: (filtered, total)=>setCount({
                        filtered: filtered,
                        total: total
                    })
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");











const $248c6c139b60b4aa$var$TagSelectButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $aa0ed25827418946$export$353f5b6fc5456de1))`
    &[class*="bp"][class*="-button"] {
        border-radius: var(--sf-border-radius, 20px) !important;
        width: ${(p)=>p.fill ? '100%' : 'fit-content'};
        justify-content: space-between;
        background: transparent !important;
        box-shadow: inset 0 0 0 1px rgba(17, 20, 24, 0.2) !important;
    }
`;
const $248c6c139b60b4aa$var$TagButtonContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    overflow: hidden;
    position: relative;
`;
const $248c6c139b60b4aa$var$HiddenTagsList = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 4px;
`;
const $248c6c139b60b4aa$var$MeasureRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    position: absolute;
    visibility: hidden;
    pointer-events: none;
    white-space: nowrap;
`;
const $248c6c139b60b4aa$var$TagRemoveBtn = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    border-radius: 0 10px 10px 0;
    background: rgba(205, 66, 70, 0.75);
    color: white;
    font-size: 12px;
    line-height: 1;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.15s;
`;
const $248c6c139b60b4aa$var$HoverRemoveTag = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $0975f43a8b42d010$export$3288d34c523a1192))`
    position: relative;
    &:hover ${$248c6c139b60b4aa$var$TagRemoveBtn} {
        opacity: 1;
    }
`;
const $248c6c139b60b4aa$var$TagPopoverContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    width: min-content;
`;
const $248c6c139b60b4aa$var$TagPanelContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
`;
const $248c6c139b60b4aa$var$TagPanel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    min-width: 180px;
    max-height: 380px;
    display: flex;
    flex-direction: column;

    &:not(:first-child) {
        border-left: 1px solid rgba(17, 20, 24, 0.15);
    }
`;
const $248c6c139b60b4aa$var$TagPanelHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 6px 10px;
    font-weight: 600;
    font-size: 11px;
    color: #5c7080;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid rgba(17, 20, 24, 0.15);
    white-space: nowrap;
`;
const $248c6c139b60b4aa$var$TagPanelMenu = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f))`
    overflow-y: auto;
    flex: 1;
    max-height: none;
`;
const $248c6c139b60b4aa$var$TagInputBar = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    padding: 6px 7px;
    border-bottom: 1px solid rgba(17, 20, 24, 0.15);
`;
const $248c6c139b60b4aa$var$TagInputRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    padding: 6px 7px;
    border-top: 1px solid rgba(17, 20, 24, 0.15);
    display: flex;
    gap: 4px;

    & [class*="bp"][class*="-input-group"],
    & [class*="bp"][class*="-input"] {
        border-radius: var(--sf-border-radius, 20px) !important;
    }
`;
const $248c6c139b60b4aa$var$tagKey = (tag)=>tag.id || tag.tagType + ':' + tag.tagValue;
const $248c6c139b60b4aa$var$sameTag = (a, b)=>a.id ? a.id === b.id : a.tagType === b.tagType && a.tagValue === b.tagValue;
const $248c6c139b60b4aa$var$TagsRenderer = ({ label: label, value: value, disabled: disabled, options: options, onChange: onChange })=>{
    const [focusedType, setFocusedType] = (0, $kYL7Z.useState)(null);
    const [customValue, setCustomValue] = (0, $kYL7Z.useState)('');
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    const tags = Array.isArray(value) ? value : [];
    const availableTags = options?.availableTags || [];
    // Display: show assigned tags as Tag components, auto-fit
    const assigned = (0, $kYL7Z.useMemo)(()=>[
            ...tags
        ].sort((a, b)=>{
            const ai = (0, $9a4701ac8fc243a2$export$34848ee8632b1f2f).findIndex((t)=>t.value === a.tagType);
            const bi = (0, $9a4701ac8fc243a2$export$34848ee8632b1f2f).findIndex((t)=>t.value === b.tagType);
            return ai !== bi ? ai - bi : a.tagValue.localeCompare(b.tagValue);
        }), [
        tags
    ]);
    const entriesOfFocusedType = (0, $kYL7Z.useMemo)(()=>focusedType ? tags.filter((t)=>t.tagType === focusedType) : [], [
        tags,
        focusedType
    ]);
    // Value suggestions for the focused type (catalog values + current values)
    const suggestions = (0, $kYL7Z.useMemo)(()=>{
        if (!focusedType) return [];
        const catalogEntries = availableTags.filter((t)=>t.tagType === focusedType);
        const missing = entriesOfFocusedType.filter((a)=>!catalogEntries.some((c)=>$248c6c139b60b4aa$var$sameTag(a, c)));
        return [
            ...catalogEntries,
            ...missing
        ].sort((a, b)=>a.tagValue.localeCompare(b.tagValue));
    }, [
        focusedType,
        availableTags,
        entriesOfFocusedType
    ]);
    const isAssigned = (0, $kYL7Z.useCallback)((entry)=>tags.some((t)=>$248c6c139b60b4aa$var$sameTag(entry, t)), [
        tags
    ]);
    const setTagValue = (0, $kYL7Z.useCallback)((type, entry)=>{
        const filtered = tags.filter((t)=>t.tagType !== type);
        if (entry) filtered.push(entry);
        onChange(filtered);
    }, [
        tags,
        onChange
    ]);
    const handleCustomAdd = (0, $kYL7Z.useCallback)(()=>{
        const trimmed = customValue.trim();
        if (!focusedType || !trimmed || !(0, $9a4701ac8fc243a2$export$fe7d799ae8150cf3).test(trimmed) || trimmed.length > (0, $9a4701ac8fc243a2$export$e9018291a1fe59a6)) return;
        const catalogOfType = availableTags.filter((t)=>t.tagType === focusedType);
        const exact = catalogOfType.find((t)=>t.tagValue === trimmed);
        if (exact) {
            setTagValue(focusedType, exact);
            setCustomValue('');
            return;
        }
        const caseInsensitive = catalogOfType.find((t)=>t.tagValue.toLowerCase() === trimmed.toLowerCase());
        if (caseInsensitive) {
            const typeLabel = (0, $9a4701ac8fc243a2$export$34848ee8632b1f2f).find((t)=>t.value === focusedType)?.label;
            if (!window.confirm(`"${trimmed}" already exists for ${typeLabel} as "${caseInsensitive.tagValue}"\nCreate it anyway?`)) return;
            setTagValue(focusedType, {
                tagType: focusedType,
                tagValue: trimmed
            });
            setCustomValue('');
            return;
        }
        setTagValue(focusedType, {
            tagType: focusedType,
            tagValue: trimmed
        });
        setCustomValue('');
    }, [
        focusedType,
        customValue,
        availableTags,
        setTagValue
    ]);
    const handleCustomInput = (0, $kYL7Z.useCallback)((e)=>{
        setCustomValue(e.target.value);
    }, []);
    const handleRemoveEntry = (0, $kYL7Z.useCallback)((entry)=>{
        const key = $248c6c139b60b4aa$var$tagKey(entry);
        onChange(tags.filter((t)=>$248c6c139b60b4aa$var$tagKey(t) !== key));
    }, [
        tags,
        onChange
    ]);
    const measureRef = (0, $kYL7Z.useRef)(null);
    const targetRef = (0, $kYL7Z.useRef)(null);
    const [fitCount, setFitCount] = (0, $kYL7Z.useState)(assigned.length);
    const computeFit = (0, $kYL7Z.useCallback)(()=>{
        const measure = measureRef.current;
        const target = targetRef.current;
        if (!measure || !target || !assigned.length) return;
        const available = target.clientWidth - 60;
        const children = measure.children;
        if (!children.length || available <= 0) return;
        const badgeWidth = children[children.length - 1].offsetWidth + 4;
        let used = 0;
        let fit = 0;
        for(let i = 0; i < assigned.length; i++){
            const tagWidth = children[i].offsetWidth + (i > 0 ? 4 : 0);
            const isLast = i === assigned.length - 1;
            const spaceNeeded = used + tagWidth + (isLast ? 0 : badgeWidth);
            if (spaceNeeded > available && fit > 0) break;
            used += tagWidth + (i > 0 ? 4 : 0);
            fit++;
        }
        if (fit !== fitCount) setFitCount(fit);
    }, [
        assigned,
        fitCount
    ]);
    const measureRefCallback = (0, $kYL7Z.useCallback)((node)=>{
        measureRef.current = node;
        if (node) {
            const formGroup = node.closest('[class*="bp"][class*="-form-group"]');
            targetRef.current = formGroup || node.parentElement;
        }
    }, []);
    (0, $kYL7Z.useLayoutEffect)(()=>{
        const target = targetRef.current;
        if (!target) return;
        computeFit();
        const ro = new ResizeObserver(computeFit);
        ro.observe(target);
        return ()=>ro.disconnect();
    }, [
        computeFit
    ]);
    const buttonContent = assigned.length === 0 ? null : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagButtonContent, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$MeasureRow, {
                ref: measureRefCallback,
                children: [
                    assigned.map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                            minimal: true,
                            small: true,
                            round: true,
                            intent: "primary",
                            children: (0, $9a4701ac8fc243a2$export$c1517564b74c2252)(t)
                        }, $248c6c139b60b4aa$var$tagKey(t))),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        small: true,
                        round: true,
                        children: [
                            "+",
                            assigned.length
                        ]
                    })
                ]
            }),
            assigned.slice(0, fitCount).map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    small: true,
                    round: true,
                    intent: "primary",
                    children: (0, $9a4701ac8fc243a2$export$c1517564b74c2252)(t)
                }, $248c6c139b60b4aa$var$tagKey(t))),
            assigned.length > fitCount && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                placement: "bottom",
                hoverOpenDelay: 200,
                content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$HiddenTagsList, {
                    children: assigned.map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                            small: true,
                            round: true,
                            children: (0, $9a4701ac8fc243a2$export$c1517564b74c2252)(t)
                        }, $248c6c139b60b4aa$var$tagKey(t)))
                }),
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    small: true,
                    round: true,
                    interactive: true,
                    children: [
                        "+",
                        assigned.length - fitCount
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a49823ead28a6dc$export$cacf2b92a5669314), {
        label: label,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            disabled: disabled,
            minimal: true,
            fill: !!options?.fill,
            placement: "bottom-start",
            usePortal: true,
            isOpen: isOpen,
            onInteraction: (nextOpen)=>{
                setIsOpen(nextOpen);
                if (nextOpen) {
                    setFocusedType(null);
                    setCustomValue('');
                }
            },
            content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagPopoverContent, {
                children: [
                    assigned.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$TagInputBar, {
                        children: assigned.map((t)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$HoverRemoveTag, {
                                minimal: true,
                                small: true,
                                round: true,
                                intent: "primary",
                                children: [
                                    (0, $9a4701ac8fc243a2$export$c1517564b74c2252)(t),
                                    !disabled && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$TagRemoveBtn, {
                                        onClick: ()=>handleRemoveEntry(t),
                                        children: "\xd7"
                                    })
                                ]
                            }, $248c6c139b60b4aa$var$tagKey(t)))
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagPanelContainer, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagPanel, {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$TagPanelHeader, {
                                        children: "Tag Type"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$TagPanelMenu, {
                                        children: (0, $9a4701ac8fc243a2$export$34848ee8632b1f2f).map((type)=>{
                                            const entriesOfType = assigned.filter((t)=>t.tagType === type.value);
                                            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                text: type.label,
                                                active: focusedType === type.value,
                                                icon: entriesOfType.length ? 'tick' : 'blank',
                                                labelElement: entriesOfType.length ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                                    style: {
                                                        fontSize: 11,
                                                        color: '#5c7080'
                                                    },
                                                    children: entriesOfType.map((e)=>e.tagValue).join(', ')
                                                }) : null,
                                                title: type.description,
                                                onClick: ()=>{
                                                    setFocusedType(type.value);
                                                    setCustomValue('');
                                                },
                                                shouldDismissPopover: false
                                            }, type.value);
                                        })
                                    })
                                ]
                            }),
                            focusedType && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagPanel, {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagPanelHeader, {
                                        children: [
                                            (0, $9a4701ac8fc243a2$export$34848ee8632b1f2f).find((t)=>t.value === focusedType)?.label,
                                            " Value"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagPanelMenu, {
                                        children: [
                                            entriesOfFocusedType.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                icon: "cross",
                                                text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("em", {
                                                    children: "Clear"
                                                }),
                                                intent: "danger",
                                                onClick: ()=>setTagValue(focusedType, null),
                                                shouldDismissPopover: false
                                            }),
                                            suggestions.map((entry)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                    text: entry.tagValue,
                                                    active: isAssigned(entry),
                                                    icon: isAssigned(entry) ? 'tick' : 'blank',
                                                    onClick: ()=>setTagValue(focusedType, entry),
                                                    shouldDismissPopover: false
                                                }, $248c6c139b60b4aa$var$tagKey(entry)))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$TagInputRow, {
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                                                value: customValue,
                                                onChange: handleCustomInput,
                                                onKeyDown: (e)=>{
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        handleCustomAdd();
                                                    }
                                                },
                                                placeholder: "Custom value...",
                                                small: true,
                                                fill: true
                                            }),
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                                icon: "add",
                                                small: true,
                                                minimal: true,
                                                intent: "success",
                                                disabled: !customValue.trim() || !(0, $9a4701ac8fc243a2$export$fe7d799ae8150cf3).test(customValue.trim()) || customValue.trim().length > (0, $9a4701ac8fc243a2$export$e9018291a1fe59a6),
                                                onClick: handleCustomAdd
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$TagSelectButton, {
                text: buttonContent || 'Select tags\u2026',
                rightIcon: "chevron-down",
                disabled: disabled,
                fill: !!options?.fill
            })
        })
    });
};
const $248c6c139b60b4aa$var$_LocSchema = ({ ...props })=>{
    return {
        type: "object",
        required: [
            "id",
            "name",
            "organisation",
            "status",
            "timezone",
            "coordinates",
            "openingTimes"
        ],
        properties: {
            id: {
                type: "string",
                pattern: "^[a-f\\d]{23,26}$",
                readOnly: true
            },
            name: {
                type: "string"
            },
            createdAt: {
                type: "string",
                readOnly: true
            },
            updatedAt: {
                type: "string",
                readOnly: true
            },
            organisation: {
                oneOf: props.availableOrganisations ? props.availableOrganisations.map((org)=>({
                        const: org.id,
                        title: org.name
                    })) : []
            },
            status: {
                type: "string",
                enum: [
                    'created',
                    'setting up',
                    'operational',
                    'near contract end',
                    'contract ended'
                ]
            },
            goLiveDate: {
                type: "string",
                format: "date-time"
            },
            timezone: {
                type: "string",
                enum: (0, $d8e0dde69ea5b073$export$8ed9fedd0e9c1187)
            },
            currency: {
                type: "string",
                enum: (0, $d8e0dde69ea5b073$export$360fc9c8fb7a3ce4)
            },
            countryCode: {
                type: "string",
                enum: (0, $d8e0dde69ea5b073$export$f63c37d36dbc92f5)
            },
            salesDataId: {
                type: "string"
            },
            tags: {
                type: "array",
                items: {
                    type: "object",
                    properties: {
                        id: {
                            type: "string",
                            pattern: "^[a-f\\d]{23,26}$"
                        },
                        tagType: {
                            type: "string",
                            enum: (0, $9a4701ac8fc243a2$export$34848ee8632b1f2f).map((t)=>t.value)
                        },
                        tagValue: {
                            type: "string",
                            minLength: 1,
                            maxLength: 128,
                            pattern: "^[^\\n]+$"
                        }
                    },
                    required: [
                        "tagType",
                        "tagValue"
                    ]
                }
            },
            coordinates: {
                type: "string",
                pattern: "(?<lat>^[-+]?(?:[1-8]?\\d(?:\\.\\d+)?|90(?:\\.0+)?))\\s*,\\s*(?<lng>[-+]?(?:180(?:\\.0+)?|(?:1[0-7]\\d|[1-9]?\\d)(?:\\.\\d+)?))$"
            },
            openingTimes: {
                type: "array",
                minItems: 7,
                maxItems: 7,
                items: {
                    type: "object",
                    properties: {
                        day: {
                            type: "integer",
                            minimum: 0,
                            maximum: 6
                        },
                        startHour: {
                            type: "integer",
                            minimum: 0,
                            maximum: 23
                        },
                        startMinute: {
                            type: "integer",
                            minimum: 0,
                            maximum: 59
                        },
                        stopHour: {
                            type: "integer",
                            minimum: 0,
                            maximum: 23
                        },
                        stopMinute: {
                            type: "integer",
                            minimum: 0,
                            maximum: 59
                        }
                    }
                }
            }
        }
    };
};
const $248c6c139b60b4aa$var$_UILocSchema = ({ ...props })=>({
        type: "VerticalLayout",
        elements: [
            {
                type: "Group",
                label: "Information",
                elements: [
                    {
                        type: "HorizontalLayout",
                        elements: [
                            {
                                type: "Control",
                                scope: "#/properties/name"
                            },
                            {
                                type: "Control",
                                scope: "#/properties/id",
                                options: {
                                    disabled: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/createdAt",
                                options: {
                                    disabled: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/updatedAt",
                                options: {
                                    disabled: true
                                }
                            }
                        ]
                    }
                ]
            },
            {
                type: "Group",
                label: "Options",
                elements: [
                    {
                        type: "HorizontalLayout",
                        elements: [
                            {
                                type: "Control",
                                scope: "#/properties/organisation",
                                options: {
                                    fill: true,
                                    disabled: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/status",
                                options: {
                                    fill: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/goLiveDate",
                                options: {
                                    fill: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/tags",
                                options: {
                                    fill: true,
                                    renderer: 'tags',
                                    availableTags: props.availableTags || []
                                }
                            }
                        ]
                    },
                    {
                        type: "HorizontalLayout",
                        elements: [
                            {
                                type: "Control",
                                scope: "#/properties/coordinates",
                                options: {
                                    fill: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/timezone",
                                options: {
                                    fill: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/currency",
                                options: {
                                    fill: true
                                }
                            },
                            {
                                type: "Control",
                                scope: "#/properties/salesDataId",
                                options: {
                                    fill: true
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    });
const $248c6c139b60b4aa$var$RoundedCard = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $0199c8413a0068dd$export$60332b2344f7fe41))`
    border-radius: 20px;
`;
const $248c6c139b60b4aa$var$OtherConfigSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 1em;
    padding: 12px;
`;
const $248c6c139b60b4aa$var$OpeningTimesSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    flex-shrink: 0;
`;
const $248c6c139b60b4aa$var$MapSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    flex: 1;
    min-width: 0;
    min-height: 300px;
    overflow: hidden;
`;
const $248c6c139b60b4aa$var$normaliseOpeningTimes = (openingTimes)=>{
    // fill in missing opening times and sort the array
    const filled = openingTimes?.length ? openingTimes.sort((a, b)=>a.day - b.day) : [
        ...Array(7).keys()
    ].reduce((acc, day)=>[
            ...acc,
            {
                day: day,
                startHour: 0,
                startMinute: 0,
                stopHour: 23,
                stopMinute: 59
            }
        ], []);
    // some opening times objects have an ID for some reason...
    return filled.map((ot)=>{
        const { _id: _id, ...periods } = ot;
        return periods;
    });
};
const $248c6c139b60b4aa$export$ee7b1a31abc7525d = ({ locid: locid })=>{
    const { setLoading: setLoading, setNav: setNav, setControls: setControls } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [info, setInfo] = (0, $kYL7Z.useState)(null);
    const [editing, setEditing] = (0, $kYL7Z.useState)(false);
    const [editErrors, setEditErrors] = (0, $kYL7Z.useState)(false);
    const [otErrors, setOtErrors] = (0, $kYL7Z.useState)(false);
    const [options, setOptions] = (0, $kYL7Z.useState)({});
    const savedTagIdsRef = (0, $kYL7Z.useRef)([]);
    const loadTagCatalog = (0, $kYL7Z.useCallback)(async ()=>{
        const fetched = await (0, $5a9cade4af2d6a52$export$45b22599efdf0a89).list({
            withinOrganisations: info.organisation,
            targetCollection: 'locations'
        });
        if (fetched === false) throw new Error('401');
        const sorted = [
            ...fetched
        ].sort((a, b)=>a.tagValue.localeCompare(b.tagValue));
        setOptions((prev)=>({
                ...prev,
                availableTags: sorted
            }));
        return sorted;
    }, [
        info?.organisation
    ]);
    // editing toggle — update controls and handle save
    (0, $kYL7Z.useEffect)(()=>{
        setControls([
            {
                name: editing ? "Save" : "Edit",
                onClick: ()=>setEditing((prev)=>!prev),
                icon: editing ? "floppy-disk" : "edit",
                confirm: editing
            }
        ]);
        if (!editing && info) {
            if (editErrors || otErrors) {
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: "Some fields are wrong",
                    timeout: 5000
                });
                setEditing(true);
            } else {
                setLoading({
                    status: true,
                    location: "Saving location..."
                });
                const applyRefresh = (loc)=>{
                    loc.tags = loc.tags || [];
                    loc.openingTimes = $248c6c139b60b4aa$var$normaliseOpeningTimes(loc.openingTimes);
                    savedTagIdsRef.current = loc.tags.map((t)=>t.id);
                    setInfo(loc);
                };
                (async ()=>{
                    const selectedIds = info.tags.filter((t)=>t.id).map((t)=>t.id);
                    const pending = info.tags.filter((t)=>!t.id);
                    let createdAny = false;
                    let catalogRefreshed = false;
                    for (const pendingTag of pending){
                        createdAny = true;
                        try {
                            const created = await (0, $5a9cade4af2d6a52$export$45b22599efdf0a89).create({
                                organisation: info.organisation,
                                targetCollection: 'locations',
                                tagType: pendingTag.tagType,
                                tagValue: pendingTag.tagValue
                            }, {
                                disableErrorToasts: true
                            });
                            if (created === false) throw new Error('401');
                            selectedIds.push(created.id);
                        } catch (err) {
                            if (err.message !== '409') throw err;
                            const catalog = await loadTagCatalog();
                            catalogRefreshed = true;
                            const match = catalog.find((t)=>t.tagType === pendingTag.tagType && t.tagValue === pendingTag.tagValue);
                            if (!match) throw err;
                            selectedIds.push(match.id);
                        }
                    }
                    const toRemove = savedTagIdsRef.current.filter((id)=>!selectedIds.includes(id));
                    const toAdd = selectedIds.filter((id)=>!savedTagIdsRef.current.includes(id));
                    for (const tagId of toRemove)try {
                        const result = await (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).unassignTag(locid, tagId, {
                            disableErrorToasts: true
                        });
                        if (result === false) throw new Error('401');
                    } catch (err) {
                        if (err.message !== '404') throw err;
                    }
                    for (const tagId of toAdd)try {
                        const result = await (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).assignTag(locid, tagId, {
                            disableErrorToasts: true
                        });
                        if (result === false) throw new Error('401');
                    } catch (err) {
                        if (err.message === '404') {
                            await loadTagCatalog();
                            throw new Error("unable to add tag to location as the tag does not exist");
                        }
                        if (err.message !== '409') throw err;
                    }
                    const updated = await (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).update(locid, {
                        name: info.name,
                        status: info.status,
                        coordinates: info.coordinates,
                        timezone: info.timezone,
                        currency: info.currency,
                        openingTimes: info.openingTimes,
                        goLiveDate: info.goLiveDate,
                        salesDataId: info.salesDataId
                    });
                    if (updated === false) throw new Error('401');
                    const refreshed = await (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).get(locid);
                    if (refreshed === false) throw new Error('401');
                    applyRefresh(refreshed);
                    if (createdAny && !catalogRefreshed) await loadTagCatalog();
                    (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                        message: "Updated " + refreshed.name
                    });
                })().catch(async (err)=>{
                    console.log(err);
                    (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                        message: "Failed to save - " + err.message,
                        timeout: 5000
                    });
                    try {
                        const refetched = await (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).get(locid);
                        if (refetched !== false) applyRefresh(refetched);
                    } catch (refetchErr) {
                        console.log(refetchErr);
                    }
                    setEditing(true);
                }).finally(()=>{
                    setLoading({
                        status: false,
                        location: info.name + " (" + locid + ")"
                    });
                });
            }
        }
        return ()=>setControls([]);
    }, [
        editing
    ]);
    // load location data
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Loading locid: " + locid);
        setLoading({
            status: true,
            location: "Loading location: " + locid
        });
        (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).get(locid, {
            include: "organisationDetails"
        }).then(async (loadedInfo)=>{
            console.log("Loaded locid: " + locid);
            // load options
            const availableOrganisations = await (0, $5a9cade4af2d6a52$export$d030b7498dcede47).list();
            loadedInfo.openingTimes = $248c6c139b60b4aa$var$normaliseOpeningTimes(loadedInfo.openingTimes);
            loadedInfo.tags = loadedInfo.tags || [];
            savedTagIdsRef.current = loadedInfo.tags.map((t)=>t.id);
            // Check with Google if the timezone is correct
            if (typeof loadedInfo.coordinates !== "undefined" && loadedInfo.timezone !== "undefined") fetch(`https://maps.googleapis.com/maps/api/timezone/json?location=${loadedInfo.coordinates}&timestamp=${Math.round(+new Date() / 1000)}&key=${(0, $a13d063d3fb3aa31$export$2510a7994c247cf7)}`).then((res)=>res.json()).then((data)=>{
                if (loadedInfo.timezone !== data.timeZoneId) window.confirm(`Timezone might be incorrect?\nGoogle says it should be ${data.timeZoneId}`);
            });
            setOptions({
                availableOrganisations: availableOrganisations.sort((a, b)=>a.name.localeCompare(b.name))
            });
            setInfo({
                ...loadedInfo,
                organisation: loadedInfo.organisation?._id
            });
            setNav({
                left: loadedInfo.organisation ? [
                    {
                        name: loadedInfo.organisation.name,
                        path: "/orgs/" + loadedInfo.organisation._id,
                        icon: "office",
                        subpaths: [
                            {
                                name: "Locations",
                                icon: "area-of-interest",
                                path: '/locs?org=' + loadedInfo.organisation._id
                            },
                            {
                                name: "Devices",
                                icon: "desktop",
                                path: '/devs?org=' + loadedInfo.organisation._id
                            },
                            {
                                name: "Cameras",
                                icon: "camera",
                                path: '/recs?org=' + loadedInfo.organisation._id
                            },
                            {
                                name: "Users",
                                icon: "people",
                                path: '/orgs/' + loadedInfo.organisation._id + '/users'
                            }
                        ]
                    }
                ] : [],
                right: [
                    {
                        name: "Devices",
                        path: "/devs?loc=" + locid,
                        icon: "desktop"
                    },
                    {
                        name: "Cameras",
                        path: "/recs?loc=" + locid,
                        icon: "camera"
                    }
                ]
            });
            setLoading({
                status: false,
                location: loadedInfo.name + " (" + loadedInfo.id + ")"
            });
        }).catch((error)=>{
            setLoading({
                status: false,
                location: "Failed to load location..."
            });
            console.log("Failed to load: " + error.message);
        });
    }, []);
    // load extra resources (tag catalog) when info changes
    (0, $kYL7Z.useEffect)(()=>{
        if (!info?.organisation) return;
        const locLabel = info.name + " (" + info.id + ")";
        setLoading({
            status: false,
            location: locLabel + " ... loading extra resources"
        });
        loadTagCatalog().then(()=>{
            setLoading({
                status: false,
                location: locLabel
            });
            console.log("Loaded extra resources (tags)");
        }).catch((error)=>{
            console.log("Failed to load extra resources: " + error.message);
            setLoading({
                status: false,
                location: locLabel + " ... failed to load extra resources"
            });
        });
    }, [
        info?.organisation
    ]);
    if (!info) return null;
    const coords = info?.coordinates?.split(",").map((c)=>parseFloat(c)) || [
        0,
        0
    ];
    const locSchema = $248c6c139b60b4aa$var$_LocSchema({
        ...options
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $kYL7Z.Fragment), {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $7c3acd9b84fb12ed$export$434374b2a40d237), {
            apiKey: (0, $a13d063d3fb3aa31$export$d4214b4977c811ed),
            onLoad: ()=>console.log('Maps API has loaded.'),
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                    schema: locSchema,
                    uischema: $248c6c139b60b4aa$var$_UILocSchema({
                        ...options
                    }),
                    data: info,
                    readonly: !editing,
                    renderers: {
                        tags: $248c6c139b60b4aa$var$TagsRenderer
                    },
                    onChange: ({ data: data, errors: errors })=>{
                        setInfo(data);
                        setEditErrors(!!errors.length);
                    }
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$RoundedCard, {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($248c6c139b60b4aa$var$OtherConfigSection, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$OpeningTimesSection, {
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d8e0dde69ea5b073$export$968308fd9c434585), {
                                    values: info.openingTimes,
                                    editing: editing,
                                    onChange: (data, errors)=>{
                                        setInfo((prev)=>({
                                                ...prev,
                                                openingTimes: data
                                            }));
                                        setOtErrors(errors);
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($248c6c139b60b4aa$var$MapSection, {
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7c3acd9b84fb12ed$export$a5c7b93649eaf8f8), {
                                    mapId: locid,
                                    defaultZoom: 15,
                                    defaultCenter: {
                                        lat: coords[0],
                                        lng: coords[1]
                                    },
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7c3acd9b84fb12ed$export$5dd2dc1fc7030ab5), {
                                        position: {
                                            lat: coords[0],
                                            lng: coords[1]
                                        },
                                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7c3acd9b84fb12ed$export$656559010049c8e), {
                                            background: 'rgb(255,0,0)',
                                            glyphColor: '#000',
                                            borderColor: '#000'
                                        })
                                    })
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};


const $c4ba356affd95277$var$OneLocRoute = ()=>{
    const { resid: resid } = (0, $3c99a37f3fed1403$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $248c6c139b60b4aa$export$ee7b1a31abc7525d), {
        locid: resid
    });
};
const $c4ba356affd95277$var$ManyLocsRoute = ()=>{
    const location = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b732d80cef0bce13$export$cf2e13ec3e706a73), {
        search: new URLSearchParams(location.search)
    });
};
const $c4ba356affd95277$export$945eb84e823d1310 = ()=>{
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Locs page");
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $3c99a37f3fed1403$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c4ba356affd95277$var$ManyLocsRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/:resid",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c4ba356affd95277$var$OneLocRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $92e6067166fae914$export$3cb69218ff952ef8), {})
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");






// -------------------------------------------------
// ----------------------------------- columns model
const $f91b0515215ed5a9$var$DevicesModelColumns = [
    {
        key: 'name',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true,
        showDefaultFilter: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/devs/' + params.row.id,
                children: params.row.name
            })
    },
    {
        key: 'cameras',
        name: 'Cameras',
        width: 100,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/recs?dev=' + params.row.id,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    round: true,
                    interactive: true,
                    children: "Cameras"
                })
            })
    },
    {
        key: 'organisation.name',
        name: 'Organisation',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.organisation?._id ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/orgs/' + params.row.organisation._id,
                children: params.row.organisation.name
            }) : ''
    },
    {
        key: 'location.name',
        name: 'Location',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.location?._id ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/locs/' + params.row.location._id,
                children: params.row.location.name
            }) : ''
    },
    {
        key: 'location.status',
        name: 'Location Status',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.location?.status || ''
    },
    {
        key: 'releaseChannel',
        name: 'Release',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'hardwareClass',
        name: 'Type',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'status',
        name: 'Status',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.createdAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
            })
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.updatedAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
            })
    }
];
const $f91b0515215ed5a9$export$28593712d0a69baa = ({ search: search })=>{
    const { setLoading: setLoading, setNav: setNav, setCount: setCount } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [data, setData] = (0, $kYL7Z.useState)(null);
    (0, $kYL7Z.useEffect)(()=>{
        if (search.get('org') && search.get('loc')) {
            setLoading({
                status: false,
                location: 'Cannot filter by both organisation and location'
            });
            setData(null);
        } else {
            setLoading({
                status: true,
                location: "Loading devices..."
            });
            (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).list({
                include: 'organisationDetails,locationDetails,locationDetailsWithoutTransactions',
                withinOrganisations: search.get("org") || undefined,
                withinLocations: search.get("loc") || undefined
            }).then(async (response)=>{
                setLoading({
                    status: true,
                    location: search.get("org") ? `Loading organisation ${search.get("org")}` : search.get("loc") ? `Loading location ${search.get("loc")}` : `Loaded ${response.length} devices`
                });
                const org = search.get('org') ? await (0, $5a9cade4af2d6a52$export$d030b7498dcede47).get(search.get('org')) : undefined;
                const loc = search.get("loc") ? await (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).get(search.get("loc"), {
                    include: "organisationDetails"
                }) : undefined;
                setData(response);
                setLoading({
                    status: false,
                    location: search.get('org') ? response.length ? response[0].organisation.name + " Devices" : "No devices for this organisation" : search.get('loc') ? response.length ? "Devices in " + response[0].location.name : "No devices for this location" : "All devices"
                });
                setNav({
                    left: org ? [
                        {
                            name: org.name,
                            path: "/orgs/" + org.id,
                            icon: "office",
                            subpaths: [
                                {
                                    name: "Locations",
                                    icon: "area-of-interest",
                                    path: '/locs?org=' + org.id
                                },
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?org=' + org.id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?org=' + org.id
                                },
                                {
                                    name: "Users",
                                    icon: "people",
                                    path: '/orgs/' + org.id + '/users'
                                }
                            ]
                        }
                    ] : loc ? [
                        {
                            name: loc.organisation.name,
                            path: "/orgs/" + loc.organisation._id,
                            icon: "office",
                            subpaths: [
                                {
                                    name: "Locations",
                                    icon: "area-of-interest",
                                    path: '/locs?org=' + loc.organisation._id
                                },
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?org=' + loc.organisation._id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?org=' + loc.organisation._id
                                },
                                {
                                    name: "Users",
                                    icon: "people",
                                    path: '/orgs/' + loc.organisation._id + '/users'
                                }
                            ]
                        },
                        {
                            name: loc.name,
                            path: "/locs/" + loc.id,
                            icon: "area-of-interest",
                            subpaths: [
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?loc=' + loc.id
                                }
                            ]
                        }
                    ] : undefined
                });
            }).catch((error)=>{
                setLoading({
                    status: false,
                    location: `Failed to load devices: ${error.message}`
                });
                setData(null);
            });
        }
    }, [
        search
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
        columns: $f91b0515215ed5a9$var$DevicesModelColumns,
        data: data ?? [],
        defaultSort: "name",
        onCount: (filtered, total)=>setCount({
                filtered: filtered,
                total: total
            })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");







const $5de557269f9457a9$var$AdvancedToggle = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    justify-content: flex-end;
    padding: 0.5em 0.5em 0;

    [class*="bp"][class*="-switch"] {
        margin-bottom: 0;
    }
`;
const $5de557269f9457a9$var$_DevSchema = ({ ...props })=>({
        type: "object",
        required: [
            "id",
            "name",
            "organisation"
        ],
        properties: {
            id: {
                type: "string",
                pattern: "^[a-f\\d]{23,26}$",
                readOnly: true
            },
            name: {
                type: "string"
            },
            createdAt: {
                type: "string",
                readOnly: true
            },
            updatedAt: {
                type: "string",
                readOnly: true
            },
            organisation: {
                oneOf: props.availableOrganisations && props.availableOrganisations.length ? props.availableOrganisations.map((org)=>({
                        const: org.id,
                        title: org.name
                    })) : [
                    {
                        const: ""
                    }
                ]
            },
            location: {
                oneOf: props.availableLocations && props.availableLocations.length ? props.availableLocations.map((loc)=>({
                        const: loc.id,
                        title: loc.name
                    })) : [
                    {
                        const: ""
                    }
                ]
            },
            status: {
                type: "string",
                enum: [
                    'av received',
                    'provisioned',
                    'assigned',
                    'dispatched',
                    'client received',
                    'connection confirmed',
                    'decommissioned'
                ]
            },
            hardwareClass: {
                type: "string",
                enum: [
                    'cbu',
                    'apu',
                    'nuc'
                ]
            },
            releaseChannel: {
                type: "string",
                enum: [
                    'edge',
                    'beta',
                    'candidate',
                    'stable'
                ]
            },
            hardwareModel: {
                type: "string"
            },
            configuration: {
                type: "object",
                properties: {
                    ML_Model: {
                        type: "object",
                        properties: {
                            detection_weights_path: {
                                type: "string"
                            },
                            training_config_path: {
                                type: "string"
                            }
                        }
                    }
                }
            }
        }
    });
const $5de557269f9457a9$var$_UIDevSchema = {
    type: "VerticalLayout",
    elements: [
        {
            type: "Group",
            label: "Information",
            elements: [
                {
                    type: "HorizontalLayout",
                    elements: [
                        {
                            type: "Control",
                            scope: "#/properties/name",
                            options: {
                                disabled: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/id",
                            options: {
                                disabled: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/createdAt",
                            options: {
                                disabled: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/updatedAt",
                            options: {
                                disabled: true
                            }
                        }
                    ]
                }
            ]
        },
        {
            type: "Group",
            label: "Options",
            elements: [
                {
                    type: "HorizontalLayout",
                    elements: [
                        {
                            type: "Control",
                            scope: "#/properties/organisation",
                            options: {
                                fill: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/location",
                            options: {
                                fill: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/status",
                            options: {
                                fill: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/hardwareClass",
                            options: {
                                fill: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/releaseChannel",
                            options: {
                                fill: true
                            }
                        },
                        {
                            type: "Control",
                            scope: "#/properties/hardwareModel"
                        }
                    ]
                }
            ]
        }
    ]
};
const $5de557269f9457a9$var$_UIConfigSimple = {
    type: "Group",
    label: "Configuration",
    options: {
        collapsed: true
    },
    elements: [
        {
            type: "Control",
            label: "Detection Weights Path",
            scope: "#/properties/configuration/properties/ML_Model/properties/detection_weights_path"
        },
        {
            type: "Control",
            label: "Training Config Path",
            scope: "#/properties/configuration/properties/ML_Model/properties/training_config_path"
        }
    ]
};
const $5de557269f9457a9$var$_UIConfigAdvanced = {
    type: "Group",
    elements: [
        {
            type: "Control",
            label: "Configuration",
            scope: "#/properties/configuration",
            options: {
                nested: false,
                rows: 25
            }
        }
    ]
};
const $5de557269f9457a9$export$d611370310be2eb5 = ({ devid: devid })=>{
    const [info, setInfo] = (0, $kYL7Z.useState)(null);
    const [editing, setEditing] = (0, $kYL7Z.useState)(false);
    const [editErrors, setEditErrors] = (0, $kYL7Z.useState)(false);
    const [advanced, setAdvanced] = (0, $kYL7Z.useState)(false);
    const [options, setOptions] = (0, $kYL7Z.useState)({});
    const navigate = (0, $3c99a37f3fed1403$export$9770f232ac06a008)();
    const { setNav: setNav, setControls: setControls, setLoading: setLoading } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const schema = (0, $kYL7Z.useMemo)(()=>$5de557269f9457a9$var$_DevSchema(options), [
        options
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        setControls([
            {
                name: "Control",
                onClick: ()=>navigate(`/devs/${devid}/control`),
                icon: "dashboard"
            },
            {
                name: editing ? "Save" : "Edit",
                onClick: ()=>setEditing((prev)=>!prev),
                icon: editing ? "floppy-disk" : "edit",
                confirm: editing
            }
        ]);
        if (!editing && info) {
            if (editErrors) {
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: info?.location && options.availableOrganisations?.length && !options.availableLocations?.map((loc)=>loc.id).includes(info.location) ? "Location does not belong to the same organisation" : "Some fields are wrong",
                    timeout: 5000
                });
                setEditing(true); // keep editing because of errors
            } else {
                setLoading({
                    status: true,
                    location: "Saving configuration..."
                });
                (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).update(devid, {
                    organisation: info.organisation,
                    location: info.location,
                    hardwareClass: info.hardwareClass,
                    hardwareModel: info.hardwareModel,
                    releaseChannel: info.releaseChannel,
                    status: info.status,
                    configuration: info.configuration
                }).then(()=>{
                    // too many things change so better to reload - this will reset loading status and editing state
                    window.location.reload();
                }).catch((err)=>{
                    console.log(err);
                    (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                        message: "Failed to save " + err.message,
                        timeout: 5000
                    });
                    setEditing(true); // keep editing because of errors
                });
            }
        }
        return ()=>setControls([]);
    }, [
        editing
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        setLoading({
            status: true,
            location: `Loading device ${devid}`
        });
        (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).get(devid, {
            include: 'organisationDetails,locationDetails,recordings'
        }).then(async (apu)=>{
            if (!apu.configuration) apu.configuration = {};
            setLoading({
                status: true,
                location: `Loading options`
            });
            const availableOrganisations = await (0, $5a9cade4af2d6a52$export$d030b7498dcede47).list();
            const availableLocations = apu.organisation ? await (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).list({
                withinOrganisations: apu.organisation._id
            }) : [];
            if (!!apu.location?._id && !!availableOrganisations.length && !availableLocations.map((loc)=>loc.id).includes(apu.location._id)) window.confirm("Device's location does not belong to the same organisation");
            setOptions({
                availableOrganisations: availableOrganisations.sort((a, b)=>a.name.localeCompare(b.name)),
                availableLocations: availableLocations.sort((a, b)=>a.name.localeCompare(b.name))
            });
            setInfo({
                ...apu,
                organisation: apu.organisation?._id,
                location: apu.location?._id
            });
            setNav({
                left: [
                    ...apu.organisation?.name ? [
                        {
                            name: apu.organisation.name,
                            path: "/orgs/" + apu.organisation._id,
                            icon: "office",
                            subpaths: [
                                {
                                    name: "Locations",
                                    icon: "area-of-interest",
                                    path: '/locs?org=' + apu.organisation._id
                                },
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?org=' + apu.organisation._id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?org=' + apu.organisation._id
                                },
                                {
                                    name: "Users",
                                    icon: "people",
                                    path: '/orgs/' + apu.organisation._id + '/users'
                                }
                            ]
                        }
                    ] : [],
                    ...apu.location?.name ? [
                        {
                            name: apu.location.name,
                            path: "/locs/" + apu.location._id,
                            icon: "area-of-interest",
                            subpaths: [
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?loc=' + apu.location._id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?loc=' + apu.location._id
                                }
                            ]
                        }
                    ] : []
                ],
                right: [
                    {
                        name: "Cameras",
                        path: "/recs?dev=" + apu.id,
                        icon: "camera"
                    }
                ]
            });
            setLoading({
                status: false,
                location: `${apu.name} (${devid})`
            });
        }).catch(()=>{
            setLoading({
                status: false,
                location: `Failed to load device ${devid}`
            });
        });
    }, []);
    const handleChange = ({ data: data, errors: errors })=>{
        setEditErrors(!!errors.length);
        setInfo(data);
        if (data.organisation && data.organisation !== info.organisation) (0, $5a9cade4af2d6a52$export$c2de8e0aab246379).list({
            withinOrganisations: data.organisation
        }).then((locs)=>{
            setOptions({
                ...options,
                availableLocations: locs.sort((a, b)=>a.name.localeCompare(b.name))
            });
        });
    };
    return !info ? null : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                schema: schema,
                uischema: $5de557269f9457a9$var$_UIDevSchema,
                data: info,
                readonly: !editing,
                onChange: handleChange
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($5de557269f9457a9$var$AdvancedToggle, {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                    label: "Advanced",
                    checked: advanced,
                    onChange: ()=>setAdvanced((prev)=>!prev),
                    disabled: !editing
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                schema: schema,
                uischema: advanced ? $5de557269f9457a9$var$_UIConfigAdvanced : $5de557269f9457a9$var$_UIConfigSimple,
                data: info,
                readonly: !editing,
                onChange: handleChange
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");



var $kYL7Z = parcelRequire("kYL7Z");





const $4a6991bd1029054c$export$2cc70c27483441ce = (0, $kYL7Z.memo)(function ContextMenuPopover(props) {
    const { content: content, popoverClassName: popoverClassName, onClose: onClose, isDarkTheme: isDarkTheme = false, rootBoundary: rootBoundary = "viewport", targetOffset: targetOffset, transitionDuration: transitionDuration = 100, ...popoverProps } = props;
    const cancelContextMenu = (0, $kYL7Z.useCallback)((e)=>e.preventDefault(), []);
    // Popover should attach its ref to the virtual target we render inside a Portal, not the "inline" child target
    const renderTarget = (0, $kYL7Z.useCallback)(({ ref: ref })=>(0, $fc31e5e9fc16a880$exports.jsx)((0, $559b5482c85e619c$export$602eac185826482c), {
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).CONTEXT_MENU_VIRTUAL_TARGET,
                style: targetOffset,
                ref: ref
            })
        }), [
        targetOffset
    ]);
    const handleInteraction = (0, $kYL7Z.useCallback)((nextOpenState)=>{
        if (!nextOpenState) onClose?.();
    }, [
        onClose
    ]);
    return (0, $kYL7Z.createElement)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
        placement: "right-start",
        rootBoundary: rootBoundary,
        transitionDuration: transitionDuration,
        ...popoverProps,
        content: // this prevents right-clicking inside our context menu
        (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            onContextMenu: cancelContextMenu,
            children: content
        }),
        enforceFocus: false,
        // Generate key based on offset so that a new Popover instance is created
        // when offset changes, to force recomputing position.
        key: $4a6991bd1029054c$var$getPopoverKey(targetOffset),
        hasBackdrop: true,
        backdropProps: {
            className: (0, $2cfd35af7ec11fdd$exports).CONTEXT_MENU_BACKDROP
        },
        minimal: true,
        onInteraction: handleInteraction,
        popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).CONTEXT_MENU_POPOVER, popoverClassName, {
            [(0, $2cfd35af7ec11fdd$exports).DARK]: isDarkTheme
        }),
        positioningStrategy: "fixed",
        renderTarget: renderTarget
    });
});
$4a6991bd1029054c$export$2cc70c27483441ce.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.ContextMenuPopover`;
function $4a6991bd1029054c$var$getPopoverKey(targetOffset) {
    return targetOffset === undefined ? "default" : `${targetOffset.left}x${targetOffset.top}`;
}


const $12102d7b56c6a393$export$8dc6765e8be191c7 = (0, $kYL7Z.forwardRef)((props, userRef)=>{
    const { className: className, children: children, content: content, disabled: disabled = false, onClose: onClose, onContextMenu: onContextMenu, popoverProps: popoverProps, tagName: tagName = "div", ...restProps } = props;
    // ancestor TooltipContext state doesn't affect us since we don't care about parent ContextMenus, we only want to
    // force disable parent Tooltips in certain cases through dispatching actions
    // N.B. any calls to this dispatch function will be no-ops if there is no TooltipProvider ancestor of this component
    const [, tooltipCtxDispatch] = (0, $kYL7Z.useContext)((0, $88fc97e447cf01bc$export$39ae08fa83328b12));
    // click target offset relative to the viewport (e.clientX/clientY), since the target will be rendered in a Portal
    const [targetOffset, setTargetOffset] = (0, $kYL7Z.useState)(undefined);
    // hold a reference to the click mouse event to pass to content/child render functions
    const [mouseEvent, setMouseEvent] = (0, $kYL7Z.useState)();
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    // we need a ref on the child element (or the wrapper we generate) to check for dark theme
    const childRef = (0, $kYL7Z.useRef)(null);
    // If disabled prop is changed, we don't want our old context menu to stick around.
    // If it has just been enabled (disabled = false), then the menu ought to be opened by
    // a new mouse event. Users should not be updating this prop in the onContextMenu callback
    // for this component (that will lead to unpredictable behavior).
    (0, $kYL7Z.useEffect)(()=>{
        setIsOpen(false);
        tooltipCtxDispatch({
            type: "RESET_DISABLED_STATE"
        });
    }, [
        disabled,
        tooltipCtxDispatch
    ]);
    const handlePopoverClose = (0, $kYL7Z.useCallback)(()=>{
        setIsOpen(false);
        setMouseEvent(undefined);
        tooltipCtxDispatch({
            type: "RESET_DISABLED_STATE"
        });
        onClose?.();
    }, [
        onClose,
        tooltipCtxDispatch
    ]);
    // if the menu was just opened, we should check for dark theme (but don't do this on every render)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const isDarkTheme = (0, $kYL7Z.useMemo)(()=>(0, $5f04c694ca05154e$exports).isDarkTheme(childRef.current), [
        childRef,
        isOpen
    ]);
    const contentProps = (0, $kYL7Z.useMemo)(()=>({
            isOpen: isOpen,
            mouseEvent: mouseEvent,
            targetOffset: targetOffset
        }), [
        isOpen,
        mouseEvent,
        targetOffset
    ]);
    // create a memoized function to render the menu so that we can call it if necessary in the "contextmenu" event
    // handler which runs before this render function has a chance to re-run and update the `menu` variable
    const renderMenu = (0, $kYL7Z.useCallback)((menuContentProps)=>disabled ? undefined : (0, $5f04c694ca05154e$exports).isFunction(content) ? content(menuContentProps) : content, [
        disabled,
        content
    ]);
    const menuContent = (0, $kYL7Z.useMemo)(()=>renderMenu(contentProps), [
        contentProps,
        renderMenu
    ]);
    // only render the popover if there is content in the context menu;
    // this avoid doing unnecessary rendering & computation
    const maybePopover = menuContent === undefined ? undefined : (0, $fc31e5e9fc16a880$exports.jsx)((0, $4a6991bd1029054c$export$2cc70c27483441ce), {
        ...popoverProps,
        content: menuContent,
        isDarkTheme: isDarkTheme,
        isOpen: isOpen,
        targetOffset: targetOffset,
        onClose: handlePopoverClose
    });
    const handleContextMenu = (0, $kYL7Z.useCallback)((e)=>{
        // support nested menus (inner menu target would have called preventDefault())
        if (e.defaultPrevented) return;
        // If disabled, we should avoid the extra work in this event handler.
        // Otherwise: if using the child or content function APIs, we need to make sure contentProps gets updated,
        // so we handle the event regardless of whether the consumer returned an undefined menu.
        const shouldHandleEvent = !disabled && ((0, $5f04c694ca05154e$exports).isFunction(children) || (0, $5f04c694ca05154e$exports).isFunction(content) || content !== undefined);
        if (shouldHandleEvent) {
            setIsOpen(true);
            e.persist();
            setMouseEvent(e);
            const newTargetOffset = {
                left: e.clientX,
                top: e.clientY
            };
            setTargetOffset(newTargetOffset);
            tooltipCtxDispatch({
                type: "FORCE_DISABLED_STATE"
            });
            const newMenuContent = renderMenu({
                isOpen: true,
                mouseEvent: e,
                targetOffset: newTargetOffset
            });
            if (newMenuContent === undefined) ;
            else e.preventDefault();
        }
        onContextMenu?.(e);
    }, [
        disabled,
        children,
        content,
        onContextMenu,
        tooltipCtxDispatch,
        renderMenu
    ]);
    const containerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(className, (0, $2cfd35af7ec11fdd$exports).CONTEXT_MENU);
    const child = (0, $5f04c694ca05154e$exports).isFunction(children) ? children({
        className: containerClassName,
        contentProps: contentProps,
        onContextMenu: handleContextMenu,
        popover: maybePopover,
        ref: childRef
    }) : (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            maybePopover,
            (0, $kYL7Z.createElement)(tagName, {
                className: containerClassName,
                onContextMenu: handleContextMenu,
                ref: (0, $7544862da546e887$export$c9058316764c140e)(childRef, userRef),
                ...restProps
            }, children)
        ]
    });
    // force descendant Tooltips to be disabled when this context menu is open
    return (0, $fc31e5e9fc16a880$exports.jsx)((0, $88fc97e447cf01bc$export$f78649fb9ca566b8), {
        forceDisable: isOpen,
        children: child
    });
});
$12102d7b56c6a393$export$8dc6765e8be191c7.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.ContextMenu`;





var $kYL7Z = parcelRequire("kYL7Z");


const $a52c0cc0b7d14ece$var$INTENT_STYLES = {
    primary: {
        bg: 'rgba(45, 114, 210, 0.1)',
        color: '#215db0',
        border: '#215db0'
    },
    success: {
        bg: 'rgba(35, 133, 81, 0.1)',
        color: '#1c6e42',
        border: '#1c6e42'
    },
    warning: {
        bg: 'rgba(200, 118, 25, 0.1)',
        color: '#935610',
        border: '#935610'
    },
    danger: {
        bg: 'rgba(205, 66, 70, 0.1)',
        color: '#ac2f33',
        border: '#ac2f33'
    }
};
const $a52c0cc0b7d14ece$var$StyledCard = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $0199c8413a0068dd$export$60332b2344f7fe41))`
    border-radius: 8px;
    padding: 1em;
    ${({ $intent: $intent })=>{
    const s = $a52c0cc0b7d14ece$var$INTENT_STYLES[$intent];
    return s ? `background-color: ${s.bg};` : '';
}}
`;
const $a52c0cc0b7d14ece$var$Header = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: ${({ $disabled: $disabled })=>$disabled ? 'not-allowed' : 'pointer'};
    opacity: ${({ $disabled: $disabled })=>$disabled ? 0.5 : 1};
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    min-height: 44px;
`;
const $a52c0cc0b7d14ece$var$Title = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    font-weight: 600;
    font-size: 1em;
    ${({ $intent: $intent })=>{
    const s = $a52c0cc0b7d14ece$var$INTENT_STYLES[$intent];
    return s ? `color: ${s.color};` : '';
}}
`;
const $a52c0cc0b7d14ece$export$60332b2344f7fe41 = ({ title: title, intent: intent, disabled: disabled = false, children: children })=>{
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($a52c0cc0b7d14ece$var$StyledCard, {
        $intent: intent,
        elevation: 2,
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($a52c0cc0b7d14ece$var$Header, {
                $disabled: disabled,
                title: disabled ? `${title} is disabled` : isOpen ? `Collapse ${title}` : `Expand ${title}`,
                onClick: ()=>!disabled && setIsOpen((prev)=>!prev),
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($a52c0cc0b7d14ece$var$Title, {
                        $intent: intent,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: isOpen ? "caret-up" : "caret-down"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $e4a7ce8c396337d4$export$78768a9af065a7b), {
                isOpen: isOpen,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    style: {
                        paddingTop: '1em'
                    },
                    children: children
                })
            })
        ]
    });
};






const $0db64f2ac749186b$var$_METHODS = {
    command: {
        HelloCommand: 'GET',
        GetPsInfoCommand: 'GET',
        InternetSpeedTestCommand: 'GET',
        GetCameraStoreCommand: 'GET',
        AvailableCommands: 'GET',
        GetNetworkInfoCommand: 'GET',
        DescribeCommand: 'GET',
        GetThumbnailCommand: 'GET',
        GetONVIFConnectionInfoCommand: 'GET',
        GetArpNeighboursCommand: 'GET',
        GetRecidsStatusCommand: 'GET',
        UpdateHandledRecids: 'PUT',
        UpdateRecidConfiguration: 'PUT',
        UpdateDeviceToken: 'PUT',
        GetSoftwareVersionCommand: 'GET',
        SetStaticONVIFCommand: 'PUT',
        NmapCommand: 'GET',
        GetCameraRegistryCommand: 'GET',
        RemoveCameraRegistryEntryCommand: 'DELETE',
        AddCameraRegistryEntryCommand: 'PUT',
        NVRScanCommand: 'GET',
        DeviceRebootCommand: 'PUT',
        ShutdownCommand: 'PUT',
        GetNodeSnapshotCommand: 'GET',
        GetRegistryMonitorSnapshotCommand: 'GET',
        GetNodeStatsSnapshotCommand: 'GET'
    },
    update: {
        UpdateRecidConfiguration: 'PUT',
        UpdateOpenSSHTunnel: 'PUT',
        UpdateDeviceToken: 'PUT',
        UpdateDeviceConfiguration: 'PUT',
        UpdateHandledRecids: 'PUT',
        LiveStreamCommand: 'PUT'
    }
};
const $0db64f2ac749186b$export$91cea577896d70d9 = {
    command: (command, deviceName, options = null, route = "command", fetchOptions = {})=>{
        if (!$0db64f2ac749186b$var$_METHODS.hasOwnProperty(route)) throw new Error(`Invalid route ${route}`);
        else if (!$0db64f2ac749186b$var$_METHODS[route].hasOwnProperty(command)) throw new Error(`Invalid command ${command} on route ${route}`);
        const method = $0db64f2ac749186b$var$_METHODS[route][command];
        if ([
            'GET',
            'DELETE'
        ].includes(method)) return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$839cb5e51805b1a5)}/api/v1/${route}/devel/${deviceName}/${command}` + (options ? `?${new URLSearchParams(options).toString()}` : ""),
            fetchOptions: {
                method: method,
                ...fetchOptions
            },
            otherOptions: {
                disableErrorToasts: true
            }
        });
        else if ([
            'PUT',
            'POST',
            'PATCH'
        ].includes(method)) return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$839cb5e51805b1a5)}/api/v1/${route}/devel/${deviceName}/${command}`,
            fetchOptions: {
                method: method,
                body: JSON.stringify(options || {}),
                ...fetchOptions
            },
            otherOptions: {
                disableErrorToasts: true
            }
        });
        else throw new Error(`Invalid method ${method}`);
    },
    ping: (deviceName)=>{
        return (0, $4dffb8c44373925a$export$848feb93d8f32b9b)({
            path: `${(0, $a13d063d3fb3aa31$export$839cb5e51805b1a5)}/api/v1/command/devel/${deviceName}/HelloCommand`,
            fetchOptions: {
                method: 'GET'
            }
        });
    }
};



// Ray-casting algorithm based on
// https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html
function $a0ca6e673b0aaaa2$export$2e2bcd8739ae039(point, vs, start, end) {
    var x = point[0], y = point[1];
    var inside = false;
    if (start === undefined) start = 0;
    if (end === undefined) end = vs.length;
    var len = end - start;
    for(var i = 0, j = len - 1; i < len; j = i++){
        var xi = vs[i + start][0], yi = vs[i + start][1];
        var xj = vs[j + start][0], yj = vs[j + start][1];
        var intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}


function $ccc35cfc871b988c$export$bb3edc44842b5f2e(points, signed) {
    if (!points || points.length < 3) return 0;
    let l = points.length;
    let det = 0;
    let isSigned = signed || false;
    points = points.map($ccc35cfc871b988c$var$normalize);
    if (points[0] != points[points.length - 1]) points = points.concat(points[0]);
    for(let i = 0; i < l; i++)det += points[i].x * points[i + 1].y - points[i].y * points[i + 1].x;
    if (isSigned) return det / 2;
    else return Math.abs(det) / 2;
}
function $ccc35cfc871b988c$var$normalize(point) {
    if (Array.isArray(point)) return {
        x: point[0],
        y: point[1]
    };
    else return point;
}


function $82709c280e3db383$var$swap(heap, p, q, heapIndex) {
    const t = heap[p];
    heap[p] = heap[q];
    heap[q] = t;
    if (heapIndex) {
        heap[p]._heapIndex = p;
        heap[q]._heapIndex = q;
    }
}
function $82709c280e3db383$var$up(heap, smaller, index, heapIndex) {
    if (index <= 1) return;
    const parent = Math.floor(index / 2);
    if (smaller(index, parent)) {
        $82709c280e3db383$var$swap(heap, parent, index, heapIndex);
        $82709c280e3db383$var$up(heap, smaller, parent, heapIndex);
    }
}
function $82709c280e3db383$var$down(heap, smaller, index, heapIndex) {
    const left = 2 * index;
    const right = left + 1;
    let next = index;
    if (left < heap.length && smaller(left, next)) next = left;
    if (right < heap.length && smaller(right, next)) next = right;
    if (next !== index) {
        $82709c280e3db383$var$swap(heap, index, next, heapIndex);
        $82709c280e3db383$var$down(heap, smaller, next, heapIndex);
    }
}
function $82709c280e3db383$export$2e2bcd8739ae039(compare = (a, b)=>a - b, heapIndex = false) {
    let data = [
        null
    ]; // 1-index
    const self = {
        push: push,
        pop: pop,
        peek: peek,
        size: size,
        rebuild: rebuild,
        popAndRebuild: popAndRebuild,
        remove: remove,
        get: get
    };
    return self;
    function smaller(p, q) {
        return compare(data[p], data[q]) < 0;
    }
    function push(item) {
        data.push(item);
        if (heapIndex) item._heapIndex = data.length - 1;
        $82709c280e3db383$var$up(data, smaller, data.length - 1, heapIndex);
    }
    function pop() {
        if (data.length === 1) return;
        const root = data[1];
        if (data.length === 2) data.length = 1;
        else {
            data[1] = data.pop();
            if (heapIndex) data[1]._heapIndex = 1;
            $82709c280e3db383$var$down(data, smaller, 1, heapIndex);
        }
        return root;
    }
    function peek() {
        return data[1];
    }
    function size() {
        return data.length - 1;
    }
    function get() {
        return data.slice(1);
    }
    function remove(item) {
        const index = heapIndex ? item._heapIndex : data.indexOf(item);
        if (index < 0) return;
        if (index === data.length - 1) {
            data.pop();
            return;
        }
        const fn = smaller(data.length - 1, index) ? $82709c280e3db383$var$up : $82709c280e3db383$var$down;
        data[index] = data.pop();
        if (heapIndex) data[index]._heapIndex = index;
        fn(data, smaller, index, heapIndex);
    }
    function rebuild(initData) {
        if (Array.isArray(initData)) data = [
            null
        ].concat(initData);
        let i = Math.floor(data.length / 2);
        while(i > 0)$82709c280e3db383$var$down(data, smaller, i--);
        if (heapIndex) data.forEach(function(item, i) {
            if (i > 0) item._heapIndex = i;
        });
        return self;
    }
    function popAndRebuild() {
        data.shift();
        rebuild();
        return data[0];
    }
}


function $74a060047c7d9888$var$areaLL(a, b, c) {
    return Math.abs((a[0] - c[0]) * (b[1] - a[1]) - (a[0] - b[0]) * (c[1] - a[1]));
}
function $74a060047c7d9888$var$areaCompare(p, q) {
    return p.area - q.area;
}
function $74a060047c7d9888$var$calculate(poly, area) {
    const ts = {
        heap: (0, $82709c280e3db383$export$2e2bcd8739ae039)($74a060047c7d9888$var$areaCompare, true)
    };
    let triangle;
    let trianglePrev;
    let a = poly[0];
    let b;
    let c = poly[1];
    const list = [];
    // calculate areas
    for(let i = 2; i < poly.length; i++){
        b = c;
        c = poly[i];
        triangle = {
            a: a,
            b: b,
            c: c,
            area: area(a, b, c),
            next: null,
            prev: trianglePrev,
            _heapIndex: 0
        };
        if (!triangle.area) continue;
        a = b;
        if (trianglePrev) trianglePrev.next = triangle;
        list.push(triangle);
        trianglePrev = triangle;
    }
    ts.first = list[0];
    // create a heap
    ts.heap.rebuild(list);
    return ts;
}
function $74a060047c7d9888$var$eliminate(ts, limit, maxPoints, maxArea, area) {
    let triangle;
    let prevTriangle;
    let nextTriangle;
    let counter = ts.heap.size() - limit;
    while(counter-- > 0){
        triangle = ts.heap.pop();
        prevTriangle = triangle.prev;
        nextTriangle = triangle.next;
        // recalculate neighbors
        if (prevTriangle) {
            ts.heap.remove(prevTriangle);
            prevTriangle.next = triangle.next;
            prevTriangle.c = triangle.c;
            prevTriangle.area = area(prevTriangle.a, prevTriangle.b, prevTriangle.c);
            ts.heap.push(prevTriangle);
        } else ts.first = triangle.next;
        if (nextTriangle) {
            ts.heap.remove(nextTriangle);
            nextTriangle.prev = triangle.prev;
            nextTriangle.a = triangle.a;
            nextTriangle.area = area(nextTriangle.a, nextTriangle.b, nextTriangle.c);
            ts.heap.push(nextTriangle);
        }
        // terminate early if we have no more triangles i.e. we have a line
        if (ts.heap.size() === 0) break;
        else if (ts.heap.size() <= maxPoints - 2 && maxArea && ts.heap.peek().area > maxArea) break;
    }
}
function $74a060047c7d9888$var$collect(triangle) {
    const poly = [
        triangle.a
    ];
    while(true){
        poly.push(triangle.b);
        if (!triangle.next) break;
        triangle = triangle.next;
    }
    poly.push(triangle.c);
    return poly;
}
function $74a060047c7d9888$export$798b53621063651(poly, limit, maxPoints = 1000, maxArea = null, area = $74a060047c7d9888$var$areaLL) {
    if (poly.length < 3 || poly.length <= limit) return poly;
    // compute the simplification
    const ts = $74a060047c7d9888$var$calculate(poly, area);
    $74a060047c7d9888$var$eliminate(ts, limit - 2, Math.min(maxPoints, poly.length), maxArea, area); // limit is in points, and we are counting triangles
    // empty heap - straight line with all triangles empty
    if (!ts.first) return [
        poly[0],
        poly[poly.length - 1]
    ];
    return $74a060047c7d9888$var$collect(ts.first);
}


const $7b598b71dfcbcd89$var$_pointInPolygon = (poly, point)=>{
    return (0, $a0ca6e673b0aaaa2$export$2e2bcd8739ae039)(point.list(), poly.map((p)=>p.list()));
};
const $7b598b71dfcbcd89$export$39dbc3f558091353 = Object.freeze({
    NONE: null,
    GREEN: 'rgb(0, 255, 0)',
    PINK: 'rgb(228, 0, 124)'
});
// Resolve highlight colour, falling back to the default colour
const $7b598b71dfcbcd89$var$_hl = (highlight, fallback)=>highlight || fallback;
const $7b598b71dfcbcd89$var$_hlAlpha = (highlight, fallback)=>{
    if (!highlight) return fallback;
    // Convert rgb to rgba with 0.1 alpha
    return highlight.replace('rgb(', 'rgba(').replace(')', ', 0.1)');
};
// ------------------------
class $7b598b71dfcbcd89$var$StatElem {
    constructor(scale, name){
        this.scale = scale;
        this.name = name;
        this.visible = true;
        this.highlight = $7b598b71dfcbcd89$export$39dbc3f558091353.NONE;
    }
}
// ------------------------
// ------------------------
class $7b598b71dfcbcd89$export$baf26146a414f24a extends $7b598b71dfcbcd89$var$StatElem {
    constructor(x, y, scale = null){
        super(scale, "point");
        this.x = x;
        this.y = y;
        this.radius = 5;
        Object.defineProperty(this, 'magnitude', {
            get: ()=>Math.sqrt(this.x ** 2 + this.y ** 2)
        });
        Object.defineProperty(this, 'inScaleBounds', {
            get: ()=>this.scale && 0 <= this.x && this.x < this.scale.x && 0 <= this.y && this.y < this.scale.y
        });
    }
    asScale(scale) {
        return new $7b598b71dfcbcd89$export$baf26146a414f24a(this.x * scale.x / this.scale.x, this.y * scale.y / this.scale.y, scale);
    }
    asPercent() {
        return this.asScale(new $7b598b71dfcbcd89$export$baf26146a414f24a(1, 1));
    }
    static fromEvent(evt, canvas = null) {
        const event = evt.type.startsWith("touch") ? evt.touches[0] : evt;
        const bounds = evt.currentTarget.getBoundingClientRect();
        const cssX = event.clientX - bounds.left;
        const cssY = event.clientY - bounds.top;
        if (canvas) {
            const scaleX = canvas.width / bounds.width;
            const scaleY = canvas.height / bounds.height;
            return new $7b598b71dfcbcd89$export$baf26146a414f24a(cssX * scaleX, cssY * scaleY, new $7b598b71dfcbcd89$export$baf26146a414f24a(canvas.width, canvas.height));
        }
        return new $7b598b71dfcbcd89$export$baf26146a414f24a(cssX, cssY, new $7b598b71dfcbcd89$export$baf26146a414f24a(bounds.width, bounds.height));
    }
    meOrMyChild(elem) {
        return elem === this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    copy() {
        return new $7b598b71dfcbcd89$export$baf26146a414f24a(this.x, this.y, this.scale?.copy());
    }
    list() {
        return [
            this.x,
            this.y
        ];
    }
    distance(other) {
        return Math.sqrt((this.x - other.x) ** 2 + (this.y - other.y) ** 2);
    }
    angle(other) {
        let ang = Math.atan2(this.y - other.y, this.x - other.x);
        return ang >= 0 ? ang : ang + 2 * Math.PI;
    }
    average(other) {
        return new $7b598b71dfcbcd89$export$baf26146a414f24a((this.x + other.x) / 2, (this.y + other.y) / 2);
    }
    offset(other) {
        return new $7b598b71dfcbcd89$export$baf26146a414f24a(this.x - other.x, this.y - other.y, this.scale);
    }
    move(other) {
        this.x += other.x;
        this.y += other.y;
    }
    contains(point) {
        const s = Math.min(Math.max(this.scale.magnitude / 800, 0.5), 1);
        return this.visible && this.distance(point) <= 4 * this.radius * s ? this : null;
    }
    render(ctx, colour, factor = 1, dpr = 1) {
        ctx.fillStyle = $7b598b71dfcbcd89$var$_hl(this.highlight, colour);
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius * factor * dpr, 0, 2 * Math.PI, false);
        ctx.fill();
    }
    drawLineTo(ctx, other, colour) {
        const prevWidth = ctx.lineWidth;
        ctx.strokeStyle = colour || 'rgb(255, 255, 0)';
        ctx.lineWidth = 4;
        ctx.beginPath();
        ctx.moveTo(this.x, this.y);
        ctx.lineTo(other.x, other.y);
        ctx.closePath();
        ctx.stroke();
        ctx.lineWidth = prevWidth;
    }
}
// ----------------------------------------
// Thin identity marker for curve body hits — enables separate highlighting
class $7b598b71dfcbcd89$export$a7ef81d9e4005664 {
    constructor(curve){
        this.curve = curve;
        this.highlight = $7b598b71dfcbcd89$export$39dbc3f558091353.NONE;
    }
    get visible() {
        return this.curve.visible;
    }
    set visible(v) {
        this.curve.visible = v;
    }
    get scale() {
        return this.curve.scale;
    }
    meOrMyChild(elem) {
        return elem === this;
    }
}
// ----------------------------------------
// ----- Crossable element to rule them all
class $7b598b71dfcbcd89$export$b0e83c3ef8d2db1 extends $7b598b71dfcbcd89$var$StatElem {
    constructor(scale, name, p0, p1, cf, vari){
        super(scale, name);
        this._p0 = p0;
        this._p1 = p1;
        this._cf = cf;
        this._vari = vari;
        // ------- defining properties
        Object.defineProperty(this, 'p0', {
            get: ()=>this._p0,
            set: (p)=>this._p0 = p,
            configurable: true
        });
        Object.defineProperty(this, 'p1', {
            get: ()=>this._p1,
            set: (p)=>this._p1 = p,
            configurable: true
        });
        Object.defineProperty(this, 'points', {
            get: ()=>[
                    this._p0,
                    this._p1
                ]
        });
        Object.defineProperty(this, 'cf', {
            get: ()=>this._cf,
            set: (cf)=>{
                this._cf = Math.abs(cf) < 0.15 ? 0 : cf;
            }
        });
        Object.defineProperty(this, 'vari', {
            get: ()=>this._vari,
            set: (vari)=>{
                this._vari = Math.abs(vari);
            }
        });
        this.vari = vari;
        this.cf = cf; // make sure cf gets updated
        this.body = new $7b598b71dfcbcd89$export$a7ef81d9e4005664(this);
        // ------- helper properties
        Object.defineProperty(this, 'centre', {
            get: ()=>this.p0.average(this.p1)
        });
        Object.defineProperty(this, 'length', {
            get: ()=>this.p0.distance(this.p1)
        });
        Object.defineProperty(this, 'angle', {
            get: ()=>this.p0.angle(this.p1)
        });
        Object.defineProperty(this, 'is_arc', {
            get: ()=>Math.abs(this.cf) > 0
        });
        Object.defineProperty(this, 'radius', {
            get: ()=>0.5 * this.length / Math.abs(this.cf)
        });
        Object.defineProperty(this, 'arc_params', {
            get: ()=>{
                let [arc_xa, arc_ya] = [
                    (this.p1.x - this.p0.x) / 2,
                    (this.p1.y - this.p0.y) / 2
                ];
                let arc_a = Math.sqrt(arc_xa ** 2 + arc_ya ** 2);
                let arc_b = Math.sqrt(this.radius ** 2 - arc_a ** 2);
                let [arc_cx, arc_cy] = [
                    this.p0.x + arc_xa,
                    this.p0.y + arc_ya
                ];
                let pc = new $7b598b71dfcbcd89$export$baf26146a414f24a(arc_cx - Math.sign(this.cf) * arc_b * arc_ya / arc_a, arc_cy + Math.sign(this.cf) * arc_b * arc_xa / arc_a);
                let pa = new $7b598b71dfcbcd89$export$baf26146a414f24a(this.p0.angle(pc), this.p1.angle(pc));
                return {
                    cx: pc.x,
                    cy: pc.y,
                    a_min: 180 / Math.PI * (this.cf > 0 ? pa.x : pa.y),
                    a_max: 180 / Math.PI * (this.cf > 0 ? pa.y : pa.x),
                    r: this.radius,
                    var: Math.round(this.vari * this.scale.magnitude / (this._refMag ?? this.scale.magnitude)),
                    inverted: this.cf < 0
                };
            }
        });
        Object.defineProperty(this, 'line_params', {
            get: ()=>{
                return {
                    x0: this.p0.x,
                    y0: this.p0.y,
                    x1: this.p1.x,
                    y1: this.p1.y,
                    var: Math.round(this.vari * this.scale.magnitude / (this._refMag ?? this.scale.magnitude)),
                    inverted: this.p0.x > this.p1.x ? false : this.p0.x < this.p1.x ? true : this.p0.y > this.p1.y
                };
            }
        });
    }
    copy(name) {
        const ret = new $7b598b71dfcbcd89$export$b0e83c3ef8d2db1(this.scale, name, this.p0.copy(), this.p1.copy(), this.cf, this.vari);
        ret._refMag = this._refMag;
        ret.move(new $7b598b71dfcbcd89$export$baf26146a414f24a(10, 10));
        return ret;
    }
    asScale(scale) {
        const newCurve = new $7b598b71dfcbcd89$export$b0e83c3ef8d2db1(scale, this.name, this.p0.asScale(scale), this.p1.asScale(scale), this.cf, this.vari);
        newCurve._refMag = this._refMag ?? this.scale.magnitude;
        return newCurve;
    }
    move(p) {
        this._p0.move(p);
        this._p1.move(p);
    }
    flip() {
        let [_p0, _p1] = [
            this.p1,
            this.p0
        ];
        this.p0 = _p0;
        this.p1 = _p1;
        this.cf = -1 * this.cf;
    }
    contains(point, points = false) {
        if (!this.visible) return null;
        if (points) return this.p0.contains(point) ?? this.p1.contains(point) ?? null;
        const s = Math.min(Math.max(this.scale.magnitude / 800, 0.5), 1);
        const threshold = 10 * s;
        // Centre grab — return the Curve itself (move)
        if (this.centre.distance(point) <= 4 * this.centre.radius * s) return this;
        // Body hit — return body marker (curvature grab)
        if (this.is_arc) {
            const { cx: cx, cy: cy, a_min: a_min, a_max: a_max } = this.arc_params;
            const distToCenter = Math.sqrt((point.x - cx) ** 2 + (point.y - cy) ** 2);
            if (Math.abs(distToCenter - this.radius) > threshold) return null;
            let ang = Math.atan2(point.y - cy, point.x - cx) * 180 / Math.PI;
            const aMin = a_min % 360;
            const aMax = a_max % 360;
            if (aMin <= aMax) {
                if (ang < aMin) ang += 360;
                return ang >= aMin && ang <= aMax ? this.body : null;
            } else {
                if (ang < aMax) ang += 360;
                return ang >= aMin && ang <= aMax + 360 ? this.body : null;
            }
        } else {
            const dx = this.p1.x - this.p0.x;
            const dy = this.p1.y - this.p0.y;
            const lenSq = dx * dx + dy * dy;
            const t = lenSq === 0 ? 0 : Math.max(0, Math.min(1, ((point.x - this.p0.x) * dx + (point.y - this.p0.y) * dy) / lenSq));
            const projX = this.p0.x + t * dx;
            const projY = this.p0.y + t * dy;
            const dist = Math.sqrt((point.x - projX) ** 2 + (point.y - projY) ** 2);
            return dist <= threshold ? this.body : null;
        }
    }
    remove(point) {
    // cannot remove points from curves
    }
    meOrMyChild(elem, me = true) {
        return me && elem === this || this.body.meOrMyChild(elem) || this.p0.meOrMyChild(elem) || this.p1.meOrMyChild(elem);
    }
    static fromApi({ scale: scale, name: name, ...params }) {
        if ([
            'cx',
            'cy',
            'a_min',
            'a_max',
            'r'
        ].every((p)=>params[p] !== undefined)) {
            // we are constructing from an arc
            const { cx: cx, cy: cy, a_min: a_min, a_max: a_max, r: r } = params;
            const p0 = new $7b598b71dfcbcd89$export$baf26146a414f24a(cx + r * Math.cos(a_min * Math.PI / 180), cy + r * Math.sin(a_min * Math.PI / 180), scale);
            const p1 = new $7b598b71dfcbcd89$export$baf26146a414f24a(cx + r * Math.cos(a_max * Math.PI / 180), cy + r * Math.sin(a_max * Math.PI / 180), scale);
            return new $7b598b71dfcbcd89$export$b0e83c3ef8d2db1(scale, name, params.inverted ? p1 : p0, params.inverted ? p0 : p1, Math.min(0.5 * p0.distance(p1) / params.r, 1) * (params.inverted ? -1 : 1), params.var || 0);
        } else if ([
            'x0',
            'y0',
            'x1',
            'y1'
        ].every((p)=>params[p] !== undefined)) {
            // we are constructing from a line
            // because devices care only about the slope and not the order of the points,
            // but we do care about the order of the points here,
            // we take p0 to be the right most point or if x is equal we take the one on top
            // we then swap them if params.inverted is set to true
            // this accounts for when the line is vertical as the devices do it is considered a positive
            // except of course when it's inverted, then a vertical line is a negative.
            const { x0: x0, y0: y0, x1: x1, y1: y1 } = params;
            const _pa = new $7b598b71dfcbcd89$export$baf26146a414f24a(x0, y0, scale);
            const _pb = new $7b598b71dfcbcd89$export$baf26146a414f24a(x1, y1, scale);
            const [p0, p1] = _pa.x > _pb.x || _pa.x === _pb.x && _pa.y < _pb.y ? [
                _pa,
                _pb
            ] : [
                _pb,
                _pa
            ];
            return new $7b598b71dfcbcd89$export$b0e83c3ef8d2db1(scale, name, params.inverted ? p1 : p0, params.inverted ? p0 : p1, 0, params.var || 0);
        } else // don't know what we're constructing
        throw new Error('Invalid parameters for Curve');
    }
    toApi(arc = false) {
        if (arc) {
            const params = this.arc_params;
            return {
                ...params,
                r: Math.round(params.r)
            };
        }
        const params = this.line_params;
        return {
            ...params,
            x0: Math.round(params.x0),
            y0: Math.round(params.y0),
            x1: Math.round(params.x1),
            y1: Math.round(params.y1)
        };
    }
    render(ctx, dpr = 1) {
        // Body parts (line/arc, vari) use body highlight; triangle + points use curve highlight
        const bodyHl = this.body.highlight || this.highlight;
        let ang = this.angle + Math.PI / 2;
        let centre = this.centre;
        const renderVari = this.vari * this.scale.magnitude / (this._refMag ?? this.scale.magnitude);
        ctx.lineWidth = dpr;
        if (this.is_arc) {
            let { cx: cx, cy: cy, a_min: a_min, a_max: a_max } = this.arc_params;
            let [ang0, ang1] = [
                a_min * Math.PI / 180,
                a_max * Math.PI / 180
            ];
            ctx.strokeStyle = $7b598b71dfcbcd89$var$_hl(bodyHl, 'rgb(255, 0, 0)');
            ctx.beginPath();
            ctx.arc(cx, cy, this.radius, ang0, ang1, false);
            ctx.closePath();
            ctx.stroke();
            ctx.strokeStyle = $7b598b71dfcbcd89$var$_hl(bodyHl, 'rgb(0, 255, 0)');
            ctx.beginPath();
            ctx.arc(cx, cy, this.radius + renderVari, ang0, ang1, false);
            ctx.stroke();
            ctx.beginPath();
            ctx.arc(cx, cy, this.radius - renderVari, ang0, ang1, false);
            ctx.stroke();
        } else {
            ctx.strokeStyle = $7b598b71dfcbcd89$var$_hl(bodyHl, 'rgb(255, 0, 0)');
            ctx.beginPath();
            ctx.moveTo(this.p0.x, this.p0.y);
            ctx.lineTo(this.p1.x, this.p1.y);
            ctx.closePath();
            ctx.stroke();
            const [x_offset, y_offset] = [
                renderVari * Math.sin(this.angle),
                renderVari * -Math.cos(this.angle)
            ];
            ctx.strokeStyle = $7b598b71dfcbcd89$var$_hl(bodyHl, 'rgb(0, 255, 0)');
            ctx.beginPath();
            ctx.moveTo(this.p0.x + x_offset, this.p0.y + y_offset);
            ctx.lineTo(this.p1.x + x_offset, this.p1.y + y_offset);
            ctx.closePath();
            ctx.stroke();
            ctx.beginPath();
            ctx.moveTo(this.p0.x - x_offset, this.p0.y - y_offset);
            ctx.lineTo(this.p1.x - x_offset, this.p1.y - y_offset);
            ctx.closePath();
            ctx.stroke();
        }
        // triangle and point sizing — use display magnitude for visual scaling
        const s = Math.min(Math.max(this.scale.magnitude / (dpr * 800), 0.5), 1) * dpr;
        const t_min = 10.5 * s;
        const t_max = 18.75 * s;
        // render direction triangle
        let t_size = Math.min(Math.max(this.length / 8, t_min), t_max);
        ctx.strokeStyle = $7b598b71dfcbcd89$var$_hl(this.highlight, 'rgb(255, 255, 255)');
        ctx.fillStyle = $7b598b71dfcbcd89$var$_hl(this.highlight, 'rgb(255, 255, 255)');
        ctx.translate(centre.x, centre.y);
        ctx.rotate(ang);
        ctx.beginPath();
        ctx.moveTo(0, -t_size);
        ctx.lineTo(t_size, 0);
        ctx.lineTo(0, t_size);
        ctx.lineTo(0, -t_size);
        ctx.closePath();
        ctx.fill();
        ctx.setTransform(1, 0, 0, 1, 0, 0); // reset translation and rotation
        // render points — scale up on large canvases, unchanged on small
        const pointScale = 0.8 + 0.7 * (s / dpr - 0.5) / 0.5; // 0.8–1.5
        let factor = (0.57 + 0.08 * (t_size - t_min) / (t_max - t_min)) * pointScale;
        this.p0.render(ctx, $7b598b71dfcbcd89$var$_hl(this.highlight, 'rgb(255, 255, 255)'), factor, dpr);
        this.p1.render(ctx, $7b598b71dfcbcd89$var$_hl(this.highlight, 'rgb(255, 255, 255)'), factor, dpr);
    }
}
// ------------------------
class $7b598b71dfcbcd89$export$ea1a111407f37557 extends $7b598b71dfcbcd89$var$StatElem {
    constructor(scale, name, inverted, poly, ignore){
        super(scale, name);
        this.poly = poly;
        this.ignore = ignore;
        this.inverted = inverted;
        Object.defineProperty(this, 'points', {
            get: ()=>this.poly
        });
    }
    asScale(scale) {
        return new $7b598b71dfcbcd89$export$ea1a111407f37557(scale, this.name, this.inverted, this.poly.map((p)=>p.asScale(scale)), this.ignore);
    }
    static fromApi({ scale: scale, name: name, inverted: inverted, poly: poly, ignore: ignore }) {
        return new $7b598b71dfcbcd89$export$ea1a111407f37557(scale, name, inverted, poly.map((p)=>new $7b598b71dfcbcd89$export$baf26146a414f24a(p[0], p[1], scale)), ignore);
    }
    toApi() {
        return {
            color: [
                0,
                0,
                0
            ],
            poly: this.poly.map((p)=>[
                    Math.round(p.x),
                    Math.round(p.y)
                ])
        };
    }
    copy(name) {
        const ret = new $7b598b71dfcbcd89$export$ea1a111407f37557(this.scale, name, this.inverted, this.poly.map((p)=>p.copy()), this.ignore);
        ret.move(new $7b598b71dfcbcd89$export$baf26146a414f24a(10, 10));
        return ret;
    }
    move(p) {
        this.poly.forEach((tp)=>tp.move(p));
    }
    addPoint(point = null) {
        let atIndex = this.poly.length;
        let toInsert = this.poly[this.poly.length - 1].average(this.poly[0]);
        if (!!point) {
            const dists = this.poly.map((p, i, a)=>p.average(a[i + 1] ?? a[0]).distance(point));
            atIndex = dists.indexOf(Math.min(...dists)) + 1;
            toInsert = point.copy();
        }
        toInsert.scale = this.scale;
        this.poly.splice(atIndex, 0, toInsert);
        return toInsert;
    }
    contains(point, points = false) {
        if (!this.visible) return null;
        else if (points) {
            for (const p of this.poly){
                let contains = p.contains(point);
                if (!!contains) return contains;
            }
            return null;
        } else return $7b598b71dfcbcd89$var$_pointInPolygon(this.poly, point) ? this : null;
    }
    remove(point) {
        if (this.poly.length > 3) this.poly = this.poly.filter((p)=>p !== point);
    }
    meOrMyChild(elem, me = true) {
        return me && elem === this || this.poly.some((p)=>p.meOrMyChild(elem));
    }
    render(ctx, dpr = 1) {
        // useful vars
        ctx.lineWidth = dpr;
        const defaultColor = this.ignore ? 'rgb(255, 255, 0)' : 'rgb(0, 0, 255)';
        const defaultFill = this.ignore ? 'rgba(255, 255, 0, 0.1)' : 'rgba(0, 0, 255, 0.1)';
        ctx.strokeStyle = $7b598b71dfcbcd89$var$_hl(this.highlight, defaultColor);
        ctx.fillStyle = this.highlight ? $7b598b71dfcbcd89$var$_hlAlpha(this.highlight, defaultFill) : defaultFill;
        // draw polygon
        ctx.beginPath();
        ctx.moveTo(this.poly[0].x, this.poly[0].y);
        this.poly.slice(1).forEach((p)=>ctx.lineTo(p.x, p.y));
        ctx.closePath();
        ctx.stroke();
        ctx.fill();
        // draw points — use display magnitude for visual scaling
        const s = Math.min(Math.max(this.scale.magnitude / (dpr * 800), 0.5), 1) * dpr;
        const a_min = 110 * s;
        const a_max = 160 * s;
        let t_size = Math.min(Math.max((0, $ccc35cfc871b988c$export$bb3edc44842b5f2e)(this.poly) / 100, a_min), a_max);
        const pointScale = 0.8 + 0.7 * (s / dpr - 0.5) / 0.5; // 0.8–1.5
        let factor = (0.57 + 0.08 * (t_size - a_min) / (a_max - a_min)) * pointScale;
        this.poly.forEach((p)=>{
            p.render(ctx, $7b598b71dfcbcd89$var$_hl(this.highlight, defaultColor), factor, dpr);
        });
    }
}
// -----------------------------------------------------
// -----------------------------------------------------
// -----------------------------------------------------
class $7b598b71dfcbcd89$export$f7f7139cdc56cfb3 {
    constructor(scale, elems){
        this.scale = scale;
        this.elems = elems;
        this.changing = false; // just to signal components if they should freeze the stat elems before changing
        Object.defineProperty(this, 'length', {
            get: ()=>this.elems.length
        });
        Object.defineProperty(this, 'curves', {
            get: ()=>this.elems.filter((elem)=>Object.getPrototypeOf(elem) === $7b598b71dfcbcd89$export$b0e83c3ef8d2db1.prototype).sort((a, b)=>a.name.toLowerCase() > b.name.toLowerCase())
        });
        Object.defineProperty(this, 'areas', {
            get: ()=>this.elems.filter((elem)=>Object.getPrototypeOf(elem) === $7b598b71dfcbcd89$export$ea1a111407f37557.prototype).sort((a, b)=>a.name.toLowerCase() > b.name.toLowerCase())
        });
    }
    asScale(scale) {
        return new $7b598b71dfcbcd89$export$f7f7139cdc56cfb3(scale, this.elems.map((e)=>e.asScale(scale)));
    }
    contains(point, points = true) {
        if (points) for (const e of this.curves.concat(this.areas).map((elem)=>elem.points).flat().sort((a, b)=>a.distance(point) - b.distance(point))){
            let contains = e.contains(point);
            if (!!contains) return contains;
        }
        for (const e of this.curves.concat(this.areas.sort((a, b)=>(0, $ccc35cfc871b988c$export$bb3edc44842b5f2e)(a.poly) - (0, $ccc35cfc871b988c$export$bb3edc44842b5f2e)(b.poly)))){
            let contains = e.contains(point, false);
            if (!!contains) return contains;
        }
        return null;
    }
    remove(elem) {
        this.elems = this.elems.filter((e)=>e !== elem);
        this.elems.map((e)=>e.remove(elem));
    }
    copy(elem) {
        let name_idx = 0;
        let names = this.elems.map((a)=>a.name);
        while(names.includes(`${elem.name}-copy-${name_idx}`))name_idx += 1;
        let newElem = elem.copy(`${elem.name}-copy-${name_idx}`);
        this.elems.push(newElem);
        return newElem;
    }
    addDefault(type, name, props = {}) {
        const [t, b, l, r] = [
            0.1 * this.scale.y,
            0.3 * this.scale.y,
            0.1 * this.scale.x,
            0.3 * this.scale.x
        ];
        const newElem = type === "areas" ? new $7b598b71dfcbcd89$export$ea1a111407f37557(this.scale, name, props.inverted ?? false, props.poly ?? [
            [
                l,
                t
            ],
            [
                r,
                t
            ],
            [
                r,
                b
            ],
            [
                l,
                b
            ]
        ].map((p)=>new $7b598b71dfcbcd89$export$baf26146a414f24a(p[0], p[1], this.scale)), props.ignore ?? false) : type === "lines" ? new $7b598b71dfcbcd89$export$b0e83c3ef8d2db1(this.scale, name, props.p0 ?? new $7b598b71dfcbcd89$export$baf26146a414f24a(r, t, this.scale), props.p1 ?? new $7b598b71dfcbcd89$export$baf26146a414f24a(l, t, this.scale), props.cf ?? 0, props.vari ?? 5) : null;
        if (newElem) this.elems.push(newElem);
        return newElem;
    }
    addFromDrawing(path) {
        let name_idx = 0;
        let names = this.elems.map((a)=>a.name);
        // append the first point to the end to close the loop and run simplification
        path.push(path[0].copy());
        const points = (0, $74a060047c7d9888$export$798b53621063651)(path, 3, 15, this.scale.x * this.scale.y / 200, (a, b, c)=>{
            return Math.abs((a.x - c.x) * (b.y - a.y) - (a.x - b.x) * (c.y - a.y));
        });
        if (points.length === 3) {
            // use path directly
            while(names.includes(`line-${name_idx}`))name_idx += 1;
            this.elems.push(new $7b598b71dfcbcd89$export$b0e83c3ef8d2db1(this.scale, `line-${name_idx}`, path[path.length - 2], path[0], 0, 5));
        } else {
            // remove the last point as we added to close the loop
            while(names.includes(`area-${name_idx}`))name_idx += 1;
            this.elems.push(new $7b598b71dfcbcd89$export$ea1a111407f37557(this.scale, `area-${name_idx}`, false, points.slice(0, points.length - 1), false));
        }
    }
    render(ctx) {
        const displayWidth = parseFloat(ctx.canvas.style.width) || ctx.canvas.width;
        const dpr = ctx.canvas.width / displayWidth;
        this.elems.forEach((elem)=>{
            elem.visible && elem.render(ctx, dpr);
        });
    }
    toApi() {
        return {
            lines: this.curves.reduce((curves, curve)=>({
                    ...curves,
                    [curve.name]: curve.toApi(false)
                }), {}),
            arcs: this.curves.filter((curve)=>curve.is_arc).reduce((curves, curve)=>({
                    ...curves,
                    [curve.name]: curve.toApi(true)
                }), {}),
            areas: {
                trigger: this.areas.filter((area)=>!area.ignore).reduce((areas, area)=>({
                        ...areas,
                        [area.name]: area.toApi()
                    }), {}),
                ignore: this.areas.filter((area)=>area.ignore).reduce((areas, area)=>({
                        ...areas,
                        [area.name]: area.toApi()
                    }), {})
            }
        };
    }
    static fromApi(scale, elemsDict) {
        const elems = [];
        elemsDict = elemsDict || {};
        // curves i.e. lines and arcs
        Object.entries(elemsDict.lines ?? {}).forEach(([name, value])=>{
            elems.push($7b598b71dfcbcd89$export$b0e83c3ef8d2db1.fromApi({
                scale: scale,
                name: name,
                ...elemsDict.arcs[name] ? elemsDict.arcs[name] : value
            }));
        });
        // trigger areas
        Object.entries(elemsDict.areas?.trigger ?? {}).forEach(([name, value])=>{
            elems.push($7b598b71dfcbcd89$export$ea1a111407f37557.fromApi({
                scale: scale,
                name: name,
                inverted: value.inverted,
                poly: value.poly,
                ignore: false
            }));
        });
        // ignore areas
        Object.entries(elemsDict.areas?.ignore ?? {}).forEach(([name, value])=>{
            elems.push($7b598b71dfcbcd89$export$ea1a111407f37557.fromApi({
                scale: scale,
                name: name,
                inverted: value.inverted,
                poly: value.poly,
                ignore: true
            }));
        });
        return new $7b598b71dfcbcd89$export$f7f7139cdc56cfb3(scale, elems);
    }
}



var $kYL7Z = parcelRequire("kYL7Z");


const $a85201d171878a8f$export$7879fcf4b5cbbcfa = /*#__PURE__*/ (0, $kYL7Z.createContext)({});
const $a85201d171878a8f$var$canvasBlock = {
    display: 'block',
    position: 'relative'
};
// 16×16 "X" cursor, hotspot at centre (8,8)
const $a85201d171878a8f$var$deleteCursor = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16'%3E%3Cline x1='2' y1='2' x2='14' y2='14' stroke='white' stroke-width='3'/%3E%3Cline x1='14' y1='2' x2='2' y2='14' stroke='white' stroke-width='3'/%3E%3Cline x1='2' y1='2' x2='14' y2='14' stroke='red' stroke-width='1.5'/%3E%3Cline x1='14' y1='2' x2='2' y2='14' stroke='red' stroke-width='1.5'/%3E%3C/svg%3E") 8 8, crosshair`;
// Maps a line angle (radians) to a perpendicular resize cursor
const $a85201d171878a8f$var$resizeCursors = [
    'e-resize',
    'nw-resize',
    'n-resize',
    'ne-resize'
];
const $a85201d171878a8f$var$curvatureCursor = (angle)=>{
    // Perpendicular to line direction; normalize to [0, π) since opposite directions share cursors
    const perp = ((angle + Math.PI / 2) % Math.PI + Math.PI) % Math.PI;
    const idx = Math.round(perp / (Math.PI / 4)) % 4;
    return $a85201d171878a8f$var$resizeCursors[idx];
};
function $a85201d171878a8f$export$9134750ec17e93b1({ recording: recordingProp, editable: editable = true, maxHeight: maxHeight, highlightedNames: highlightedNames, onBeforeChange: onBeforeChange, onAfterChange: onAfterChange, onElemHover: onElemHover }) {
    const ctx = (0, $kYL7Z.useContext)($a85201d171878a8f$export$7879fcf4b5cbbcfa);
    // Internal state for standalone mode (when recording prop is provided directly)
    const [internalElems, setInternalElems] = (0, $kYL7Z.useState)(null);
    const [internalSelected, setInternalSelected] = (0, $kYL7Z.useState)(null);
    const [internalHovered, setInternalHovered] = (0, $kYL7Z.useState)(null);
    // Use prop recording if provided, otherwise fall back to context
    const standalone = !!recordingProp;
    const recording = recordingProp || ctx.recording;
    const elems = standalone ? internalElems : ctx.elems;
    const selected = standalone ? internalSelected : ctx.selected;
    const setElems = standalone ? setInternalElems : ctx.setElems;
    const setSelected = standalone ? setInternalSelected : ctx.setSelected;
    const hovered = standalone ? internalHovered : ctx.hovered;
    const canvasMode = standalone ? undefined : ctx.canvasMode;
    const setCanvasMode = standalone ? undefined : ctx.setCanvasMode;
    const setHovered = standalone ? setInternalHovered : ctx.setHovered;
    // DOM refs
    const canvasRef = (0, $kYL7Z.useRef)(null);
    const containerRef = (0, $kYL7Z.useRef)(null);
    // Imperative state (not React state — avoids re-renders during load/drag)
    const imageRef = (0, $kYL7Z.useRef)(null);
    const imageLoadedRef = (0, $kYL7Z.useRef)(false);
    const pressRef = (0, $kYL7Z.useRef)({});
    // Canvas mode tracking (survives handler re-registration)
    const addPointPreviewRef = (0, $kYL7Z.useRef)(null);
    const removePointCandidateRef = (0, $kYL7Z.useRef)(null);
    const lastMousePosRef = (0, $kYL7Z.useRef)(null);
    // Cursor hover tracking (survives handler re-registration)
    const hoverElemRef = (0, $kYL7Z.useRef)(null);
    const hoveredParentRef = (0, $kYL7Z.useRef)(null);
    // ---------------------------------------------------------------- updateCanvas
    // Ref so async callbacks (image onload, resize observer) always call latest version
    const updateCanvasRef = (0, $kYL7Z.useRef)(null);
    const hasThumbnail = !!recording?.thumbnails?.[0]?.url;
    const updateCanvas = (0, $kYL7Z.useCallback)(()=>{
        if (!recording) return;
        // Step 1: ensure image is loading
        if (!imageRef.current) {
            if (!hasThumbnail) {
                // No thumbnail — render placeholder
                const canvas = canvasRef.current;
                const container = containerRef.current;
                if (!canvas || !container) return;
                const rect = container.getBoundingClientRect();
                const w = 640, h = 480;
                canvas.width = w;
                canvas.height = h;
                canvas.style.width = rect.width + 'px';
                canvas.style.height = rect.width * (h / w) + 'px';
                const drawCtx = canvas.getContext('2d');
                drawCtx.fillStyle = '#e1e8ed';
                drawCtx.fillRect(0, 0, w, h);
                drawCtx.strokeStyle = '#8a9ba8';
                drawCtx.lineWidth = 2;
                const cx = w / 2, cy = h / 2;
                drawCtx.strokeRect(cx - 20, cy - 15, 40, 30);
                drawCtx.beginPath();
                drawCtx.arc(cx, cy, 10, 0, Math.PI * 2);
                drawCtx.stroke();
                drawCtx.fillStyle = '#8a9ba8';
                drawCtx.font = '16px sans-serif';
                drawCtx.textAlign = 'center';
                drawCtx.textBaseline = 'middle';
                drawCtx.fillText('No thumbnail available', cx, cy + 35);
                imageRef.current = 'none';
                return;
            }
            const image = new Image();
            image.onload = ()=>{
                console.log("Thumbnail loaded");
                imageLoadedRef.current = true;
                updateCanvasRef.current?.();
            };
            image.src = recording.thumbnails[0].url;
            imageRef.current = image;
            return;
        }
        if (!imageLoadedRef.current) return;
        // Step 2: initialise elems from API if needed
        if (!elems) {
            const { statElems: statElems } = recording;
            const scale = new (0, $7b598b71dfcbcd89$export$baf26146a414f24a)(imageRef.current.width, imageRef.current.height);
            setElems((0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3).fromApi(scale, statElems));
            return;
        }
        // Step 3: draw
        const canvas = canvasRef.current;
        const container = containerRef.current;
        if (!canvas || !container) return;
        const rect = container.getBoundingClientRect();
        const drawCtx = canvas.getContext('2d');
        const imgW = imageRef.current.width;
        const imgH = imageRef.current.height;
        const aspect = imgH / imgW;
        // Canvas drawing surface = image dimensions (fixed)
        canvas.width = imgW;
        canvas.height = imgH;
        // CSS display size from container (responsive)
        let displayW = rect.width;
        let displayH = displayW * aspect;
        if (maxHeight && displayH > maxHeight) {
            displayH = maxHeight;
            displayW = displayH / aspect;
        }
        canvas.style.width = displayW + 'px';
        canvas.style.height = displayH + 'px';
        // Draw at native resolution
        drawCtx.drawImage(imageRef.current, 0, 0, imgW, imgH);
        // Apply reactive highlights (hovered, highlightedNames) before render
        const tempHighlights = [];
        if (hovered && hovered !== selected && !hovered.highlight) {
            hovered.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).GREEN;
            tempHighlights.push(hovered);
        }
        if (highlightedNames?.length) elems.elems.forEach((e)=>{
            if (highlightedNames.includes(e.name) && !e.highlight && e !== selected) {
                e.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).GREEN;
                tempHighlights.push(e);
            }
        });
        elems.render(drawCtx);
        // Clear temp highlights (preserves PINK from canvas modes, GREEN from selection)
        tempHighlights.forEach((e)=>{
            e.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
        });
        // If we are drawing a new element, render the in-progress path
        const press = pressRef.current;
        if (press.type === "draw" && press.elem.length > 1) press.elem.slice(1).forEach((p, idx)=>p.drawLineTo(drawCtx, press.elem[idx]));
    }, [
        recording,
        elems,
        setElems,
        maxHeight,
        selected,
        hovered,
        highlightedNames,
        hasThumbnail
    ]);
    updateCanvasRef.current = updateCanvas;
    // ---------------------------------------------------------------- effects
    // Auto-redraw when any draw-relevant state changes
    (0, $kYL7Z.useEffect)(()=>{
        updateCanvas();
    }, [
        updateCanvas
    ]);
    // Reset when recording identity changes (e.g. grid row reuse after sort/filter)
    (0, $kYL7Z.useEffect)(()=>{
        imageRef.current = null;
        imageLoadedRef.current = false;
        if (standalone) {
            setInternalElems(null);
            setInternalSelected(null);
        }
    }, [
        recording?.id,
        standalone
    ]);
    // ResizeObserver on the container — stable, uses ref for latest updateCanvas
    (0, $kYL7Z.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        const observer = new ResizeObserver(()=>updateCanvasRef.current?.());
        observer.observe(container);
        return ()=>observer.disconnect();
    }, []);
    // Update cursor and clean up preview when canvasMode changes
    (0, $kYL7Z.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (canvasMode?.type === 'add-point') {
            if (canvas) canvas.style.cursor = 'crosshair';
            const pos = lastMousePosRef.current;
            if (pos) {
                addPointPreviewRef.current = canvasMode.area.addPoint(pos);
                updateCanvas();
            }
        } else if (canvasMode?.type === 'remove-point') {
            if (canvas) canvas.style.cursor = $a85201d171878a8f$var$deleteCursor;
            const pos = lastMousePosRef.current;
            if (pos) {
                const nearest = canvasMode.area.poly.reduce((best, p)=>!best || p.distance(pos) < best.distance(pos) ? p : best, null);
                if (nearest) nearest.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).PINK;
                removePointCandidateRef.current = nearest;
                updateCanvas();
            }
        } else {
            if (canvas) canvas.style.cursor = 'default';
            // Clean up add-point preview
            const preview = addPointPreviewRef.current;
            if (preview) {
                if (elems) elems.areas.forEach((a)=>{
                    a.poly = a.poly.filter((p)=>p !== preview);
                });
                addPointPreviewRef.current = null;
            }
            // Clean up remove-point highlight
            const candidate = removePointCandidateRef.current;
            if (candidate) {
                candidate.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                removePointCandidateRef.current = null;
            }
            updateCanvas();
        }
    }, [
        canvasMode,
        elems,
        updateCanvas
    ]);
    // ---------------------------------------------------------------- mouse/touch handlers
    (0, $kYL7Z.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas || !editable) return;
        // ---- mousedown / touchstart
        const onPointerDown = (event)=>{
            const press = pressRef.current;
            // Add-point mode: commit the point and exit
            if (canvasMode?.type === 'add-point') {
                event.stopPropagation();
                event.preventDefault();
                const area = canvasMode.area;
                const preview = addPointPreviewRef.current;
                if (preview) area.poly = area.poly.filter((p)=>p !== preview);
                onBeforeChange?.();
                const point = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
                area.addPoint(point);
                onAfterChange?.();
                addPointPreviewRef.current = null;
                setCanvasMode?.(null);
                return;
            }
            // Remove-point mode: remove the highlighted point and exit
            if (canvasMode?.type === 'remove-point') {
                event.stopPropagation();
                event.preventDefault();
                const candidate = removePointCandidateRef.current;
                if (candidate) {
                    candidate.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                    onBeforeChange?.();
                    canvasMode.area.poly = canvasMode.area.poly.filter((p)=>p !== candidate);
                    onAfterChange?.();
                }
                removePointCandidateRef.current = null;
                setCanvasMode?.(null);
                return;
            }
            if (press.ignoreNext) {
                console.log(event, "...ignoring");
                return;
            }
            if (elems) {
                event.stopPropagation();
                event.preventDefault();
                const point = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
                const elem = elems.contains(point);
                if (selected && selected !== elem && elem?.curve !== selected) {
                    console.log("Clear selection");
                    setSelected(undefined);
                    onAfterChange?.();
                }
                pressRef.current = {
                    type: "short",
                    elem: elem,
                    point: point,
                    pressTimer: setTimeout(()=>{
                        pressRef.current = {
                            ...pressRef.current,
                            type: "long"
                        };
                    }, 500),
                    ignoreNext: setTimeout(()=>{
                        pressRef.current = {
                            ...pressRef.current,
                            ignoreNext: null
                        };
                    }, 20)
                };
                if (elem) {
                    elem.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).GREEN;
                    updateCanvas();
                }
            }
        };
        // ---- mousemove / touchmove
        const onPointerMove = (event)=>{
            const press = pressRef.current;
            const newPoint = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
            // Transition from short → drag/scroll/curvature
            if (press.type === "short" && press.point.distance(newPoint) > 3.5) {
                clearTimeout(press.pressTimer);
                if (press.elem && Object.getPrototypeOf(press.elem) === (0, $7b598b71dfcbcd89$export$a7ef81d9e4005664).prototype) {
                    console.log("Curvature drag");
                    pressRef.current = {
                        ...press,
                        type: "curvature"
                    };
                } else {
                    press.elem ? console.log("Dragging") : console.log("Scrolling");
                    pressRef.current = {
                        ...press,
                        type: press.elem ? "drag" : "scroll",
                        moves: [
                            {
                                t: Date.now(),
                                dx: new (0, $7b598b71dfcbcd89$export$baf26146a414f24a)(0, 0, newPoint.scale)
                            }
                        ]
                    };
                }
            } else if (press.type === "long" && press.point.distance(newPoint) > 10) {
                // Transition from long → draw
                console.log("Drawing");
                if (press.elem) {
                    press.elem.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                    updateCanvas();
                }
                pressRef.current = {
                    ...press,
                    type: "draw",
                    elem: [
                        press.point
                    ]
                };
            }
            // Action: drag
            const currentPress = pressRef.current;
            if (currentPress.type === "drag" && newPoint.inScaleBounds) {
                onBeforeChange?.();
                event.stopPropagation();
                event.preventDefault();
                const { elem: elem, point: point, moves: moves } = currentPress;
                const offset = newPoint.offset(point);
                elem.move(offset);
                point.move(offset);
                moves.push({
                    t: Date.now(),
                    dx: offset.asPercent()
                });
                updateCanvas();
            } else if (currentPress.type === "curvature" && newPoint.inScaleBounds) {
                onBeforeChange?.();
                event.stopPropagation();
                event.preventDefault();
                const curve = currentPress.elem.curve;
                const lineDx = curve.p1.x - curve.p0.x;
                const lineDy = curve.p1.y - curve.p0.y;
                const lineLen = curve.length;
                const mid = curve.centre;
                // Signed perpendicular distance from pointer to p0-p1 line
                const cross = lineDy * (newPoint.x - mid.x) - lineDx * (newPoint.y - mid.y);
                const perpDist = cross / lineLen;
                // Clamp sensitivity so short lines aren't too twitchy and long lines aren't sluggish
                const dragDist = Math.min(Math.max(lineLen / 4, 40), 120);
                // Dead zone: snap to straight when pointer is near the line
                const absPerp = Math.abs(perpDist);
                if (absPerp < 10) curve.cf = 0;
                else {
                    // Remap from dead zone edge so t starts at 0, then apply
                    // sub-linear power to flatten near full curvature
                    const remapped = Math.min((absPerp - 10) / (dragDist - 10), 1);
                    curve.cf = Math.sign(perpDist) * Math.pow(remapped, 0.4);
                }
                updateCanvas();
            } else if (currentPress.type === "draw" && newPoint.inScaleBounds) {
                event.stopPropagation();
                event.preventDefault();
                currentPress.elem.push(newPoint);
                updateCanvas();
            }
        };
        // ---- mouseup / touchend / touchcancel
        const onPointerUp = (event)=>{
            const press = pressRef.current;
            if (press.type === "short" || press.type === "long") {
                clearTimeout(press.pressTimer);
                if (!selected && press.elem) {
                    console.log("Selecting...");
                    if (press.elem.curve) press.elem.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                    setSelected(press.elem.curve ?? press.elem);
                    onAfterChange?.();
                } else if (selected && (selected === press.elem || press.elem?.curve === selected)) {
                    console.log("Double click action...");
                    if (press.elem.curve) press.elem.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                    switch(Object.getPrototypeOf(selected)){
                        case (0, $7b598b71dfcbcd89$export$ea1a111407f37557).prototype:
                            onBeforeChange?.();
                            const newPoint = selected.addPoint(press.point);
                            onAfterChange?.();
                            pressRef.current = {
                                type: "drag",
                                elem: newPoint,
                                point: newPoint.copy(),
                                moves: [
                                    {
                                        t: Date.now(),
                                        dx: new (0, $7b598b71dfcbcd89$export$baf26146a414f24a)(0, 0, newPoint.scale)
                                    }
                                ]
                            };
                            return;
                        case (0, $7b598b71dfcbcd89$export$b0e83c3ef8d2db1).prototype:
                            onBeforeChange?.();
                            selected.flip();
                            onAfterChange?.();
                            break;
                    }
                    setSelected(undefined);
                } else if (selected) {
                    console.log("Unselecting...");
                    setSelected(undefined);
                    onAfterChange?.();
                }
            } else if (press.type === "drag") {
                const { elem: elem, moves: moves, selectAfter: selectAfter } = press;
                if (moves.filter((m)=>m.t > Date.now() - 1000).reduce((acc, curr)=>acc + curr.dx.magnitude, 0) > 2) {
                    console.log("Shake action");
                    elems.remove(elem);
                }
                elem.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                setSelected(selectAfter);
                onAfterChange?.();
            } else if (press.type === "curvature") {
                press.elem.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                onAfterChange?.();
            } else if (press.type === "draw") {
                setSelected(undefined);
                onBeforeChange?.();
                elems.addFromDrawing(press.elem);
                onAfterChange?.();
            }
            pressRef.current = {};
            updateCanvas();
        };
        // ---- wheel (vari adjustment when cursor is over a curve's centre)
        let wheelAccum = 0;
        let wheelEndTimer = null;
        const WHEEL_THRESHOLD = 150; // accumulated deltaY needed per vari step
        const onWheel = (event)=>{
            if (!elems) return;
            const point = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
            const curve = elems.curves.find((c)=>{
                const s = Math.min(Math.max(c.scale.magnitude / 800, 0.5), 1);
                return c.centre.distance(point) <= 20 * s;
            });
            if (curve) {
                event.preventDefault();
                wheelAccum += event.deltaY;
                if (Math.abs(wheelAccum) >= WHEEL_THRESHOLD) {
                    const steps = Math.trunc(wheelAccum / WHEEL_THRESHOLD);
                    wheelAccum -= steps * WHEEL_THRESHOLD;
                    onBeforeChange?.(); // only pushes history once while changing=true
                    curve.vari = Math.max(0, Math.min(30, curve.vari + steps));
                    updateCanvas();
                    // Defer afterChange until scroll gesture ends
                    clearTimeout(wheelEndTimer);
                    wheelEndTimer = setTimeout(()=>onAfterChange?.(), 300);
                }
            } else wheelAccum = 0;
        };
        // ---- cursor tracking
        const onCursorMove = (event)=>{
            lastMousePosRef.current = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
            // Add-point mode: show preview point on nearest edge
            if (canvasMode?.type === 'add-point') {
                const area = canvasMode.area;
                const preview = addPointPreviewRef.current;
                if (preview) area.poly = area.poly.filter((p)=>p !== preview);
                const point = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
                addPointPreviewRef.current = area.addPoint(point);
                canvas.style.cursor = 'crosshair';
                updateCanvas();
                if (hoveredParentRef.current) {
                    hoveredParentRef.current = null;
                    setHovered?.(null);
                }
                return;
            }
            // Remove-point mode: highlight nearest poly point
            if (canvasMode?.type === 'remove-point') {
                const prev = removePointCandidateRef.current;
                if (prev) prev.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                const point = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
                const nearest = canvasMode.area.poly.reduce((best, p)=>!best || p.distance(point) < best.distance(point) ? p : best, null);
                if (nearest) nearest.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).PINK;
                removePointCandidateRef.current = nearest;
                canvas.style.cursor = $a85201d171878a8f$var$deleteCursor;
                updateCanvas();
                if (hoveredParentRef.current) {
                    hoveredParentRef.current = null;
                    setHovered?.(null);
                }
                return;
            }
            if (pressRef.current.type) return;
            if (!elems) {
                canvas.style.cursor = 'default';
                return;
            }
            const point = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
            const hit = elems.contains(point);
            // Update hover highlight — points highlight individually, shapes highlight whole
            const hoverTarget = hit ?? null;
            if (hoverElemRef.current !== hoverTarget) {
                if (hoverElemRef.current?.highlight === (0, $7b598b71dfcbcd89$export$39dbc3f558091353).PINK) hoverElemRef.current.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                if (hoverTarget && !hoverTarget.highlight) hoverTarget.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).PINK;
                hoverElemRef.current = hoverTarget;
                updateCanvas();
            }
            // Notify context of hovered parent element (by reference)
            const parentElem = hit ? elems.elems.find((e)=>e.meOrMyChild(hit)) : null;
            if (parentElem !== hoveredParentRef.current) {
                hoveredParentRef.current = parentElem;
                setHovered?.(parentElem);
            }
            if (!hit) canvas.style.cursor = 'default';
            else if (Object.getPrototypeOf(hit) === (0, $7b598b71dfcbcd89$export$a7ef81d9e4005664).prototype) canvas.style.cursor = $a85201d171878a8f$var$curvatureCursor(hit.curve.angle);
            else if (Object.getPrototypeOf(hit) === (0, $7b598b71dfcbcd89$export$b0e83c3ef8d2db1).prototype) canvas.style.cursor = 'move';
            else if (Object.getPrototypeOf(hit) === (0, $7b598b71dfcbcd89$export$baf26146a414f24a).prototype) canvas.style.cursor = 'grab';
            else canvas.style.cursor = 'move';
        };
        const onCursorLeave = ()=>{
            lastMousePosRef.current = null;
            if (canvasMode?.type === 'add-point') {
                const preview = addPointPreviewRef.current;
                if (preview) {
                    canvasMode.area.poly = canvasMode.area.poly.filter((p)=>p !== preview);
                    addPointPreviewRef.current = null;
                    updateCanvas();
                }
            } else if (canvasMode?.type === 'remove-point') {
                const candidate = removePointCandidateRef.current;
                if (candidate) {
                    candidate.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                    removePointCandidateRef.current = null;
                    updateCanvas();
                }
            }
            if (hoverElemRef.current) {
                if (hoverElemRef.current.highlight === (0, $7b598b71dfcbcd89$export$39dbc3f558091353).PINK) hoverElemRef.current.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
                hoverElemRef.current = null;
                updateCanvas();
            }
            if (hoveredParentRef.current) {
                hoveredParentRef.current = null;
                setHovered?.(null);
            }
            canvas.style.cursor = 'default';
        };
        // Register listeners
        const downEvents = [
            'mousedown',
            'touchstart'
        ];
        const moveEvents = [
            'mousemove',
            'touchmove'
        ];
        const upEvents = [
            'mouseup',
            'touchend',
            'touchcancel'
        ];
        downEvents.forEach((ev)=>canvas.addEventListener(ev, onPointerDown));
        moveEvents.forEach((ev)=>canvas.addEventListener(ev, onPointerMove));
        upEvents.forEach((ev)=>canvas.addEventListener(ev, onPointerUp));
        canvas.addEventListener('wheel', onWheel, {
            passive: false
        });
        canvas.addEventListener('mousemove', onCursorMove);
        canvas.addEventListener('mouseleave', onCursorLeave);
        return ()=>{
            downEvents.forEach((ev)=>canvas.removeEventListener(ev, onPointerDown));
            moveEvents.forEach((ev)=>canvas.removeEventListener(ev, onPointerMove));
            upEvents.forEach((ev)=>canvas.removeEventListener(ev, onPointerUp));
            canvas.removeEventListener('wheel', onWheel);
            canvas.removeEventListener('mousemove', onCursorMove);
            canvas.removeEventListener('mouseleave', onCursorLeave);
            clearTimeout(wheelEndTimer);
        };
    }, [
        editable,
        elems,
        selected,
        canvasMode,
        setSelected,
        setCanvasMode,
        setHovered,
        onBeforeChange,
        onAfterChange,
        updateCanvas
    ]);
    // ---------------------------------------------------------------- hover tracking (non-editable)
    (0, $kYL7Z.useEffect)(()=>{
        const canvas = canvasRef.current;
        if (!canvas || editable) return;
        const onMouseMove = (event)=>{
            if (!elems) return;
            const point = (0, $7b598b71dfcbcd89$export$baf26146a414f24a).fromEvent(event, canvas);
            const hit = elems.contains(point, false);
            // Resolve to parent Curve/Area (hit may be a child Point)
            const elem = hit ? elems.elems.find((e)=>e.meOrMyChild(hit)) : null;
            if (elem !== hovered) {
                onElemHover?.(elem);
                setHovered?.(elem);
            }
        };
        const onMouseLeave = ()=>{
            onElemHover?.(null);
            setHovered?.(null);
        };
        canvas.addEventListener('mousemove', onMouseMove);
        canvas.addEventListener('mouseleave', onMouseLeave);
        return ()=>{
            canvas.removeEventListener('mousemove', onMouseMove);
            canvas.removeEventListener('mouseleave', onMouseLeave);
        };
    }, [
        editable,
        elems,
        hovered,
        onElemHover,
        setHovered
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("canvas", {
        ref: canvasRef,
        style: $a85201d171878a8f$var$canvasBlock,
        width: "150",
        height: "150",
        className: (0, $2cfd35af7ec11fdd$exports).ELEVATION_3
    }));
}



var $kYL7Z = parcelRequire("kYL7Z");


var $kYL7Z = parcelRequire("kYL7Z");
// control: 'tags' — hovering elems highlights tags
// control: 'elems' — hovering tags highlights elems
// control: 'both' — both directions
const $3989e0deb8926acd$export$27ab39ace6da2877 = /*#__PURE__*/ (0, $kYL7Z.createContext)(null);
const $3989e0deb8926acd$export$85c44962397e459e = (ctx, id)=>{
    if (!ctx) return null;
    const { apis: apis } = ctx;
    if (!apis.has(id)) apis.set(id, {
        setHighlightedNames: ()=>{},
        hoverSubscribers: new Set()
    });
    return apis.get(id);
};
const $3989e0deb8926acd$export$5e71ca194ae26770 = ({ control: control = 'both', selectedLineContexts: selectedLineContexts, selectedAreaContexts: selectedAreaContexts, onTagHover: onTagHover, onElemHover: onElemHover, children: children })=>{
    const apis = (0, $kYL7Z.useRef)(new Map());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement($3989e0deb8926acd$export$27ab39ace6da2877.Provider, {
        value: {
            apis: apis.current,
            control: control,
            selectedLineContexts: selectedLineContexts,
            selectedAreaContexts: selectedAreaContexts,
            onTagHover: onTagHover,
            onElemHover: onElemHover
        }
    }, children);
};


const $73bb63be09f7db54$export$4b2d5a8d6a65444a = ({ recording: recording, maxHeight: maxHeight })=>{
    const [highlightedNames, setHighlightedNames] = (0, $kYL7Z.useState)([]);
    const ctx = (0, $kYL7Z.useContext)((0, $3989e0deb8926acd$export$27ab39ace6da2877));
    // Register setter so external components (ContextTags) can highlight elems
    (0, $kYL7Z.useEffect)(()=>{
        const entry = (0, $3989e0deb8926acd$export$85c44962397e459e)(ctx, recording.id);
        if (entry) entry.setHighlightedNames = setHighlightedNames;
        return ()=>{
            const entry = ctx?.apis?.get(recording.id);
            if (entry) entry.setHighlightedNames = ()=>{};
        };
    }, [
        ctx,
        recording.id
    ]);
    // Notify tags when an elem is hovered (per-row + global)
    const handleElemHover = (0, $kYL7Z.useCallback)((elem)=>{
        // Per-row: notify tag subscribers (only if control includes 'tags')
        if (ctx && ctx.control !== 'elems') {
            const entry = ctx.apis?.get(recording.id);
            if (entry) entry.hoverSubscribers.forEach((fn)=>fn(elem));
        }
        // Global callback (always fires)
        ctx?.onElemHover?.(elem, recording);
    }, [
        ctx,
        recording
    ]);
    // Merge hover-driven highlights with provider-level selected contexts
    const allHighlightedNames = (0, $kYL7Z.useMemo)(()=>{
        const names = [
            ...highlightedNames
        ];
        const slc = ctx?.selectedLineContexts;
        if (slc?.length) (recording.lineContexts || []).forEach((lc)=>{
            if (slc.includes(lc.type)) lc.actions.flat().forEach((a)=>{
                if (!names.includes(a.lineId)) names.push(a.lineId);
            });
        });
        const sac = ctx?.selectedAreaContexts;
        if (sac?.length) (recording.areaContexts || []).forEach((ac)=>{
            const key = ac.taxonomy ? `${ac.type}:${ac.taxonomy}` : ac.type;
            if (sac.includes(key) && !names.includes(ac.areaId)) names.push(ac.areaId);
        });
        return names;
    }, [
        highlightedNames,
        ctx?.selectedLineContexts,
        ctx?.selectedAreaContexts,
        recording
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $a85201d171878a8f$export$9134750ec17e93b1), {
        recording: recording,
        editable: false,
        maxHeight: maxHeight,
        onElemHover: handleElemHover,
        highlightedNames: allHighlightedNames
    });
};




var $kYL7Z = parcelRequire("kYL7Z");


const $86ace0d9d7178e4f$export$71a1575a59ac5582 = ({ recording: recording })=>{
    const ctx = (0, $kYL7Z.useContext)((0, $3989e0deb8926acd$export$27ab39ace6da2877));
    const [hoveredElem, setHoveredElem] = (0, $kYL7Z.useState)(null);
    const lineContexts = recording?.lineContexts || [];
    const areaContexts = recording?.areaContexts || [];
    // Subscribe to canvas hover notifications (only if control includes 'tags')
    (0, $kYL7Z.useEffect)(()=>{
        if (ctx?.control === 'elems') return;
        const entry = (0, $3989e0deb8926acd$export$85c44962397e459e)(ctx, recording.id);
        if (!entry) return;
        entry.hoverSubscribers.add(setHoveredElem);
        return ()=>entry.hoverSubscribers.delete(setHoveredElem);
    }, [
        ctx,
        recording.id
    ]);
    // Highlight elems in the preview (only if control includes 'elems')
    const highlightElems = (names)=>{
        if (!ctx || ctx.control === 'tags') return;
        ctx.apis?.get(recording.id)?.setHighlightedNames(names);
    };
    // Group area contexts by type + taxonomy
    const areaGroups = {};
    areaContexts.forEach((ac)=>{
        const key = ac.taxonomy ? `${ac.type}:${ac.taxonomy}` : ac.type;
        if (!areaGroups[key]) areaGroups[key] = {
            label: ac.taxonomy || ac.type,
            type: ac.type,
            taxonomy: ac.taxonomy,
            areaIds: []
        };
        areaGroups[key].areaIds.push(ac.areaId);
    });
    const isLineHighlighted = (lc)=>hoveredElem && lc.actions.flat().some((a)=>a.lineId === hoveredElem.name) || ctx?.selectedLineContexts?.includes(lc.type);
    const isAreaGroupHighlighted = (key)=>hoveredElem && areaGroups[key].areaIds.includes(hoveredElem.name) || ctx?.selectedAreaContexts?.includes(key);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement("div", {
        style: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: 3,
            padding: '2px 0'
        }
    }, lineContexts.map((lc)=>{
        const names = [
            ...new Set(lc.actions.flat().map((a)=>a.lineId))
        ];
        const meta = lc.metadata?.length ? lc.metadata.map((m)=>`${m.key}: ${m.value}`).join(', ') : lc.withinLocationMovementKey || null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            key: lc.id,
            minimal: true,
            interactive: true,
            intent: isLineHighlighted(lc) ? "primary" : "none",
            onMouseEnter: ()=>{
                highlightElems(names);
                ctx?.onTagHover?.({
                    elemType: 'curve',
                    type: lc.type,
                    names: names,
                    recording: recording
                });
            },
            onMouseLeave: ()=>{
                highlightElems([]);
                ctx?.onTagHover?.(null);
            }
        }, lc.type, meta ? `: ${meta}` : '');
    }), Object.entries(areaGroups).map(([key, group])=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).createElement((0, $0975f43a8b42d010$export$3288d34c523a1192), {
            key: key,
            minimal: true,
            interactive: true,
            intent: isAreaGroupHighlighted(key) ? "primary" : "none",
            onMouseEnter: ()=>{
                highlightElems(group.areaIds);
                ctx?.onTagHover?.({
                    elemType: 'area',
                    type: group.type,
                    taxonomy: group.taxonomy,
                    key: key,
                    names: group.areaIds,
                    recording: recording
                });
            },
            onMouseLeave: ()=>{
                highlightElems([]);
                ctx?.onTagHover?.(null);
            }
        }, group.label)));
};


/**
 * Normalizes a SQL API recording into the shape our components expect.
 *
 * SQL format: { recording_id, url, statElems: { lineStatElems: [...], areaStatElems: [...] }, contexts: { lineContexts, areaContexts } }
 * Standard:   { id, thumbnails: [{url}], statElems: { lines, arcs, areas }, lineContexts, areaContexts }
 */ const $bd83c9d554a536e7$export$304a4bbabc539e2c = (rec)=>({
        ...rec,
        id: rec.recording_id,
        thumbnails: [
            {
                url: rec.url
            }
        ],
        statElems: {
            lines: Object.fromEntries((rec.statElems?.lineStatElems || []).map((l)=>[
                    l.line_id,
                    l
                ])),
            arcs: {},
            areas: {
                trigger: Object.fromEntries((rec.statElems?.areaStatElems || []).filter((a)=>a.action_type !== 'ignore').map((a)=>[
                        a.area_id,
                        {
                            poly: JSON.parse(a.poly)
                        }
                    ])),
                ignore: Object.fromEntries((rec.statElems?.areaStatElems || []).filter((a)=>a.action_type === 'ignore').map((a)=>[
                        a.area_id,
                        {
                            poly: JSON.parse(a.poly)
                        }
                    ]))
            }
        },
        lineContexts: (rec.contexts?.lineContexts || []).map((lc)=>({
                ...lc,
                type: lc.line_type
            })),
        areaContexts: (rec.contexts?.areaContexts || []).map((ac)=>({
                ...ac,
                type: ac.area_type
            }))
    });






var $kYL7Z = parcelRequire("kYL7Z");





class $947543e4a33aaa15$export$3e41faf802a29e71 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static defaultProps = {
        disabled: false
    };
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Tab`;
    // this component is never rendered directly; see Tabs#renderTabPanel()
    /* istanbul ignore next */ render() {
        const { className: className, panel: panel } = this.props;
        return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TAB_PANEL, className),
            role: "tablist",
            children: (0, $4fe78071c01b0041$export$f6e2535fb5126e54)(panel) ? panel({
                tabPanelId: "",
                tabTitleId: ""
            }) : panel
        });
    }
}


var $kYL7Z = parcelRequire("kYL7Z");














class $e97ba15da05467f3$export$f5f4479861343295 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.TabTitle`;
    render() {
        const { className: className, children: children, disabled: disabled, id: id, parentId: parentId, selected: selected, title: title, icon: icon, tagContent: tagContent, tagProps: tagProps, ...htmlProps } = this.props;
        const intent = selected ? (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).PRIMARY : (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).NONE;
        const { tabPanelId: tabPanelId, tabTitleId: tabTitleId } = $e97ba15da05467f3$export$475c2f4c17e89795(parentId, id);
        return(// eslint-disable-next-line jsx-a11y/interactive-supports-focus, jsx-a11y/click-events-have-key-events
        (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            ...(0, $b898cefa02f59fb9$export$962dd23b3e663274)(htmlProps),
            "aria-controls": tabPanelId,
            "aria-disabled": disabled,
            "aria-expanded": selected,
            "aria-selected": selected,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TAB, className),
            "data-tab-id": id,
            id: tabTitleId,
            onClick: disabled ? undefined : this.handleClick,
            role: "tab",
            tabIndex: disabled ? undefined : selected ? 0 : -1,
            children: [
                icon != null && (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                    icon: icon,
                    intent: intent,
                    className: (0, $2cfd35af7ec11fdd$exports).TAB_ICON
                }),
                title,
                children,
                tagContent != null && (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    intent: intent,
                    ...tagProps,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TAB_TAG, tagProps?.className),
                    children: tagContent
                })
            ]
        }));
    }
    handleClick = (e)=>this.props.onClick(this.props.id, e);
}
function $e97ba15da05467f3$export$475c2f4c17e89795(parentId, tabId) {
    return {
        tabPanelId: `${(0, $2cfd35af7ec11fdd$exports).TAB_PANEL}_${parentId}_${tabId}`,
        tabTitleId: `${(0, $2cfd35af7ec11fdd$exports).TAB}-title_${parentId}_${tabId}`
    };
}


class $a070dfde42a63799$export$3d96ec278d3efce4 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    render() {
        const { className: className, id: id, parentId: parentId, selectedTabId: selectedTabId, panel: panel, renderActiveTabPanelOnly: renderActiveTabPanelOnly } = this.props;
        const isSelected = id === selectedTabId;
        if (panel === undefined || renderActiveTabPanelOnly && !isSelected) return undefined;
        const { tabTitleId: tabTitleId, tabPanelId: tabPanelId } = (0, $e97ba15da05467f3$export$475c2f4c17e89795)(parentId, id);
        return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            "aria-labelledby": tabTitleId,
            "aria-hidden": !isSelected,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TAB_PANEL, className),
            id: tabPanelId,
            role: "tabpanel",
            children: (0, $5f04c694ca05154e$exports).isFunction(panel) ? panel({
                tabPanelId: tabPanelId,
                tabTitleId: tabTitleId
            }) : panel
        });
    }
}



const $6c2bdbbf2a1df958$export$cd4364b9964725cb = ()=>(0, $fc31e5e9fc16a880$exports.jsx)("div", {
        className: (0, $2cfd35af7ec11fdd$exports).FLEX_EXPANDER
    });
const $6c2bdbbf2a1df958$var$TAB_SELECTOR = `.${(0, $2cfd35af7ec11fdd$exports).TAB}`;
class $6c2bdbbf2a1df958$export$b2539bed5023c21c extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    /**
     * @deprecated Use the `Tab` component directly instead
     *
     * @see https://blueprintjs.com/docs/#core/components/tabs.tab
     */ static Tab = (0, $947543e4a33aaa15$export$3e41faf802a29e71);
    static defaultProps = {
        animate: true,
        fill: false,
        large: false,
        renderActiveTabPanelOnly: false,
        size: "medium",
        vertical: false
    };
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Tabs`;
    static getDerivedStateFromProps({ selectedTabId: selectedTabId }) {
        if (selectedTabId !== undefined) // keep state in sync with controlled prop, so state is canonical source of truth
        return {
            selectedTabId: selectedTabId
        };
        return null;
    }
    tablistElement = null;
    refHandlers = {
        tablist: (tabElement)=>this.tablistElement = tabElement
    };
    constructor(props){
        super(props);
        const selectedTabId = this.getInitialSelectedTabId();
        this.state = {
            selectedTabId: selectedTabId
        };
    }
    render() {
        const { animate: animate, children: children, className: className, fill: fill, large: // eslint-disable-next-line @typescript-eslint/no-deprecated
        large, renderActiveTabPanelOnly: renderActiveTabPanelOnly, size: size = "medium", vertical: vertical } = this.props;
        const { indicatorWrapperStyle: indicatorWrapperStyle, selectedTabId: selectedTabId } = this.state;
        const tabTitles = (0, $kYL7Z.Children).map(children, this.renderTabTitle);
        const tabPanels = this.getTabChildren().filter(renderActiveTabPanelOnly ? (tab)=>tab.props.id === selectedTabId : ()=>true).map(this.renderTabPanel);
        const tabIndicator = animate ? (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: (0, $2cfd35af7ec11fdd$exports).TAB_INDICATOR_WRAPPER,
            style: indicatorWrapperStyle,
            children: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).TAB_INDICATOR
            })
        }) : null;
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TABS, className, {
            [(0, $2cfd35af7ec11fdd$exports).VERTICAL]: vertical,
            [(0, $2cfd35af7ec11fdd$exports).FILL]: fill
        });
        const tabListClasses = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).TAB_LIST, (0, $2cfd35af7ec11fdd$exports).sizeClass(size, {
            large: large
        }));
        return (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: classes,
            children: [
                (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    className: tabListClasses,
                    onKeyDown: this.handleKeyDown,
                    // eslint-disable-next-line @typescript-eslint/no-deprecated
                    onKeyPress: this.handleKeyPress,
                    ref: this.refHandlers.tablist,
                    role: "tablist",
                    children: [
                        tabIndicator,
                        tabTitles
                    ]
                }),
                tabPanels
            ]
        });
    }
    componentDidMount() {
        this.moveSelectionIndicator(false);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.selectedTabId !== prevState.selectedTabId) this.moveSelectionIndicator();
        else if (prevState.selectedTabId != null) {
            // comparing React nodes is difficult to do with simple logic, so
            // shallowly compare just their props as a workaround.
            const didChildrenChange = !(0, $5f04c694ca05154e$exports).arraysEqual(this.getTabChildrenProps(prevProps), this.getTabChildrenProps(), (0, $5f04c694ca05154e$exports).shallowCompareKeys);
            if (didChildrenChange) this.moveSelectionIndicator();
        }
    }
    getInitialSelectedTabId() {
        // NOTE: providing an unknown ID will hide the selection
        const { defaultSelectedTabId: defaultSelectedTabId, selectedTabId: selectedTabId } = this.props;
        if (selectedTabId !== undefined) return selectedTabId;
        else if (defaultSelectedTabId !== undefined) return defaultSelectedTabId;
        else {
            // select first tab in absence of user input
            const tabs = this.getTabChildren();
            return tabs.length === 0 ? undefined : tabs[0].props.id;
        }
    }
    getTabChildrenProps(props = this.props) {
        return this.getTabChildren(props).map((child)=>child.props);
    }
    /** Filters children to only `<Tab>`s */ getTabChildren(props = this.props) {
        return (0, $kYL7Z.Children).toArray(props.children).filter($6c2bdbbf2a1df958$var$isTabElement);
    }
    /** Queries root HTML element for all tabs with optional filter selector */ getTabElements(subselector = "") {
        if (this.tablistElement == null) return [];
        return Array.from(this.tablistElement.querySelectorAll($6c2bdbbf2a1df958$var$TAB_SELECTOR + subselector));
    }
    handleKeyDown = (e)=>{
        const direction = (0, $5f04c694ca05154e$exports).getArrowKeyDirection(e, [
            "ArrowLeft",
            "ArrowUp"
        ], [
            "ArrowRight",
            "ArrowDown"
        ]);
        if (direction === undefined) return;
        const focusedElement = (0, $5f04c694ca05154e$exports).getActiveElement(this.tablistElement)?.closest($6c2bdbbf2a1df958$var$TAB_SELECTOR);
        // rest of this is potentially expensive and futile, so bail if no tab is focused
        if (!focusedElement) return;
        // must rely on DOM state because we have no way of mapping `focusedElement` to a React.JSX.Element
        const enabledTabElements = this.getTabElements('[aria-disabled="false"]');
        const focusedIndex = enabledTabElements.indexOf(focusedElement);
        if (focusedIndex < 0) return;
        e.preventDefault();
        const { length: length } = enabledTabElements;
        // auto-wrapping at 0 and `length`
        const nextFocusedIndex = (focusedIndex + direction + length) % length;
        enabledTabElements[nextFocusedIndex].focus();
    };
    handleKeyPress = (e)=>{
        const targetTabElement = e.target.closest($6c2bdbbf2a1df958$var$TAB_SELECTOR);
        if (targetTabElement != null && (0, $5f04c694ca05154e$exports).isKeyboardClick(e)) {
            e.preventDefault();
            targetTabElement.click();
        }
    };
    handleTabClick = (newTabId, event)=>{
        this.props.onChange?.(newTabId, this.state.selectedTabId, event);
        if (this.props.selectedTabId === undefined) this.setState({
            selectedTabId: newTabId
        });
    };
    /**
     * Calculate the new height, width, and position of the tab indicator.
     * Store the CSS values so the transition animation can start.
     */ moveSelectionIndicator(animate = true) {
        if (this.tablistElement == null || !this.props.animate) return;
        const tabIdSelector = `${$6c2bdbbf2a1df958$var$TAB_SELECTOR}[data-tab-id="${this.state.selectedTabId}"]`;
        const selectedTabElement = this.tablistElement.querySelector(tabIdSelector);
        let indicatorWrapperStyle = {
            display: "none"
        };
        if (selectedTabElement != null) {
            const { clientHeight: clientHeight, clientWidth: clientWidth, offsetLeft: offsetLeft, offsetTop: offsetTop } = selectedTabElement;
            indicatorWrapperStyle = {
                height: clientHeight,
                transform: `translateX(${Math.floor(offsetLeft)}px) translateY(${Math.floor(offsetTop)}px)`,
                width: clientWidth
            };
            if (!animate) indicatorWrapperStyle.transition = "none";
        }
        this.setState({
            indicatorWrapperStyle: indicatorWrapperStyle
        });
    }
    renderTabPanel = (tab)=>{
        const { className: className, panel: panel, id: id, panelClassName: panelClassName } = tab.props;
        if (panel === undefined) return undefined;
        return (0, $kYL7Z.createElement)((0, $a070dfde42a63799$export$3d96ec278d3efce4), {
            ...tab.props,
            key: id,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(className, panelClassName),
            parentId: this.props.id,
            selectedTabId: this.state.selectedTabId
        });
    };
    renderTabTitle = (child)=>{
        if ($6c2bdbbf2a1df958$var$isTabElement(child)) {
            const { id: id } = child.props;
            return (0, $fc31e5e9fc16a880$exports.jsx)((0, $e97ba15da05467f3$export$f5f4479861343295), {
                ...child.props,
                parentId: this.props.id,
                onClick: this.handleTabClick,
                selected: id === this.state.selectedTabId
            });
        }
        return child;
    };
}
function $6c2bdbbf2a1df958$var$isTabElement(child) {
    return (0, $5f04c694ca05154e$exports).isElementOfType(child, (0, $947543e4a33aaa15$export$3e41faf802a29e71));
}





var $kYL7Z = parcelRequire("kYL7Z");

// Styles ----------------------------------------------------------------
// -----------------------------------------------------------------------
const $15ced77767d3eb63$var$StyledTable = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).table`
    display: flex;
    flex-flow: row nowrap;
    width: ${({ $width: $width })=>$width ? $width : '100%'};
    height: ${({ $height: $height })=>$height ? $height : 'auto'};
    margin: ${({ $margin: $margin })=>$margin ? $margin : 'auto'};
    padding: ${({ $padding: $padding })=>$padding ? $padding : 'auto'};
    border: 2px solid ${({ $borderColor: $borderColor })=>$borderColor ? $borderColor : 'transparent'};
    border-radius: ${({ $borderRadius: $borderRadius })=>$borderRadius ? $borderRadius : '0'};
`;
const $15ced77767d3eb63$var$StyledTableBody = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).tbody`
    display: block;
    flex-flow: row nowrap;
    width: 100%;
`;
const $15ced77767d3eb63$var$StyledTableRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).tr`
    display: flex;
    flex-flow: row nowrap;
    width: 100%;
    margin: ${({ $margin: $margin })=>$margin ? $margin : 'auto'};
    padding: ${({ $padding: $padding })=>$padding ? $padding : 'auto'};
    border-bottom: 2px solid ${({ $separatorColor: $separatorColor })=>$separatorColor ? $separatorColor : 'transparent'};
    ${({ $hoverColor: $hoverColor })=>$hoverColor ? `&:hover { background: ${$hoverColor}` : ''}
`;
const $15ced77767d3eb63$var$_CELL_STYLE = (0, $564f85e69a9a6189$export$dbf350e5966cf602)`
    display: flex;
    width: ${({ $span: $span })=>$span ? $span : undefined};
    margin: ${({ $margin: $margin })=>$margin ? $margin : 'auto'};
    padding: ${({ $padding: $padding })=>$padding ? $padding : 'auto'};
    gap: ${({ $gap: $gap })=>$gap ? $gap : 'auto'};
    text-align: ${({ $halign: $halign })=>$halign ? $halign : 'left'};
    justify-content: ${({ $halign: $halign })=>$halign ? $halign : 'left'};
    align-items: ${({ $valign: $valign })=>$valign ? $valign : 'top'};
    ${({ $shouldHover: $shouldHover })=>$shouldHover ? '&:hover { background: silver }' : ''}
`;
const $15ced77767d3eb63$var$StyledTableHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).th`${$15ced77767d3eb63$var$_CELL_STYLE}`;
const $15ced77767d3eb63$var$StyledTableCell = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).td`${$15ced77767d3eb63$var$_CELL_STYLE}`;
// -----------------------------------------------------------------------
// -----------------------------------------------------------------------
// Components ------------------------------------------------------------
// -----------------------------------------------------------------------
const $15ced77767d3eb63$export$54ec01a60f47d33d = ({ children: children, width: width, height: height, margin: margin, padding: padding, borderColor: borderColor, borderRadius: borderRadius, ...rest })=>{
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($15ced77767d3eb63$var$StyledTable, {
        $width: width,
        $height: height,
        $margin: margin,
        $padding: padding,
        $borderColor: borderColor,
        $borderRadius: borderRadius,
        ...rest,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($15ced77767d3eb63$var$StyledTableBody, {
            children: children
        })
    });
};
const $15ced77767d3eb63$export$b59bdbef9ce70de2 = ({ children: children, margin: margin, padding: padding, ...rest })=>{
    // children prop is often not an array, check if it has a length
    const valid_children = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).Children.toArray(children).filter((c)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).isValidElement(c));
    const total_span = !valid_children?.length ? 1 : valid_children.reduce((total, c)=>total + (c.props?.span ?? 1), 0);
    const newChildren = valid_children.map((c)=>{
        return /*#__PURE__*/ (0, $kYL7Z.cloneElement)(c, {
            span: `${100 * (c.props.span ?? 1) / total_span}%`
        });
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($15ced77767d3eb63$var$StyledTableRow, {
        $margin: margin,
        $padding: padding,
        ...rest,
        children: newChildren
    });
};
const $15ced77767d3eb63$export$f6f0c3fe4ec306ea = ({ header: header, span: span, margin: margin, padding: padding, gap: gap, halign: halign, valign: valign, shouldHover: shouldHover, children: children, ...rest })=>{
    const Style = header ? $15ced77767d3eb63$var$StyledTableHeader : $15ced77767d3eb63$var$StyledTableCell;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)(Style, {
        $span: span,
        $margin: margin,
        $padding: padding,
        $gap: gap,
        $halign: halign,
        $valign: valign,
        $shouldHover: shouldHover,
        ...rest,
        children: children
    });
};


// ----- Network Info Dialog -----
const $7e2478d8cc8b2395$var$InfoGrid = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 6px 16px;
    align-items: center;
    font-size: 13px;
`;
const $7e2478d8cc8b2395$var$InfoLabel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    font-weight: 600;
    color: #5c7080;
    white-space: nowrap;
`;
const $7e2478d8cc8b2395$var$InfoValue = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    font-family: monospace;
    word-break: break-all;
`;
const $7e2478d8cc8b2395$var$SectionTitle = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    grid-column: 1 / -1;
    font-weight: 700;
    font-size: 14px;
    margin-top: 12px;
    padding-bottom: 4px;
    border-bottom: 1px solid #e1e8ed;
    &:first-child { margin-top: 0; }
`;
const $7e2478d8cc8b2395$var$InfoRow = ({ label: label, value: value })=>value !== undefined && value !== null && value !== '' ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoLabel, {
                children: label
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoValue, {
                children: String(value)
            })
        ]
    }) : null;
const $7e2478d8cc8b2395$var$ActiveConnectionInfo = ({ active: active })=>{
    if (!active || !Object.keys(active).length) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        minimal: true,
        children: "No active connection"
    });
    const ip4Config = active.Ip4Config || active.Ip4;
    const connectionSettings = active.Connection;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7e2478d8cc8b2395$var$InfoGrid, {
        children: [
            connectionSettings?.connection && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$SectionTitle, {
                        children: "Connection"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "Name",
                        value: connectionSettings.connection.id
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "UUID",
                        value: connectionSettings.connection.uuid
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "Type",
                        value: connectionSettings.connection.type
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "Interface",
                        value: connectionSettings.connection['interface-name']
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "Autoconnect",
                        value: connectionSettings.connection.autoconnect
                    })
                ]
            }),
            connectionSettings?.ipv4 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$SectionTitle, {
                        children: "IPv4 Configuration"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "Method",
                        value: connectionSettings.ipv4.method
                    }),
                    connectionSettings.ipv4.addresses?.map((addr, i)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoLabel, {
                                    children: i === 0 ? 'Address' : `Address ${i + 1}`
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7e2478d8cc8b2395$var$InfoValue, {
                                    children: [
                                        addr[0],
                                        " /",
                                        addr[1],
                                        " via ",
                                        addr[2]
                                    ]
                                })
                            ]
                        }, i)),
                    connectionSettings.ipv4.dns?.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "DNS",
                        value: connectionSettings.ipv4.dns.join(', ')
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                        label: "Route Metric",
                        value: connectionSettings.ipv4['route-metric']
                    })
                ]
            }),
            ip4Config && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$SectionTitle, {
                        children: "Active State"
                    }),
                    ip4Config.AddressData?.map((addr, i)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoLabel, {
                                    children: i === 0 ? 'Address' : `Address ${i + 1}`
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7e2478d8cc8b2395$var$InfoValue, {
                                    children: [
                                        addr.address,
                                        addr.prefix ? `/${addr.prefix}` : ''
                                    ]
                                })
                            ]
                        }, i)),
                    ip4Config.RouteData?.map((route, i)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoLabel, {
                                    children: i === 0 ? 'Route' : `Route ${i + 1}`
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7e2478d8cc8b2395$var$InfoValue, {
                                    children: [
                                        route.dest,
                                        route.prefix ? `/${route.prefix}` : '',
                                        route['next-hop'] ? ` via ${route['next-hop']}` : '',
                                        route.metric !== undefined ? ` metric ${route.metric}` : ''
                                    ]
                                })
                            ]
                        }, i)),
                    ip4Config.Options && Object.entries(ip4Config.Options).map(([key, val])=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoRow, {
                            label: key,
                            value: Array.isArray(val) ? val.join(', ') : val
                        }, key))
                ]
            })
        ]
    });
};
const $7e2478d8cc8b2395$var$AvailableConnectionsList = ({ connections: connections })=>{
    if (!connections?.length) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        minimal: true,
        children: "No available connections"
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoGrid, {
        children: connections.map((con, i)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$InfoLabel, {
                        children: con.connection?.id || `Connection ${i + 1}`
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7e2478d8cc8b2395$var$InfoValue, {
                        children: [
                            con.ipv4?.method || "\u2014",
                            con.ipv4?.addresses?.[0] ? ` \u{2014} ${con.ipv4.addresses[0][0]}` : ''
                        ]
                    })
                ]
            }, i))
    });
};
const $7e2478d8cc8b2395$var$AdapterPanel = ({ adapterInfo: adapterInfo })=>{
    if (!adapterInfo) return null;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            padding: '8px 0'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                style: {
                    marginBottom: 8
                },
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    minimal: true,
                    intent: "primary",
                    children: adapterInfo.type
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$ActiveConnectionInfo, {
                active: adapterInfo.active_connection
            }),
            adapterInfo.available_connections?.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                        style: {
                            marginTop: 16
                        },
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7e2478d8cc8b2395$var$SectionTitle, {
                            children: [
                                "Available Connections (",
                                adapterInfo.available_connections.length,
                                ")"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$AvailableConnectionsList, {
                        connections: adapterInfo.available_connections
                    })
                ]
            })
        ]
    });
};
const $7e2478d8cc8b2395$var$NetworkInfoDialog = ({ isOpen: isOpen, onClose: onClose, adapters: adapters, loading: loading, error: error })=>{
    // Sort adapters so ones with an active connection come first
    const sortedEntries = adapters ? Object.entries(adapters).sort(([, a], [, b])=>{
        const aActive = a.active_connection && Object.keys(a.active_connection).length > 0;
        const bActive = b.active_connection && Object.keys(b.active_connection).length > 0;
        return (bActive ? 1 : 0) - (aActive ? 1 : 0);
    }) : [];
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
        isOpen: isOpen,
        onClose: onClose,
        title: "Network Info",
        icon: "ip-address",
        style: {
            width: 550
        },
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
            children: [
                loading && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                    size: 30
                }),
                error && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    intent: "danger",
                    large: true,
                    fill: true,
                    children: error
                }),
                sortedEntries.length > 0 && !loading && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6c2bdbbf2a1df958$export$b2539bed5023c21c), {
                    defaultSelectedTabId: sortedEntries[0]?.[0],
                    children: sortedEntries.map(([ifname, info])=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $947543e4a33aaa15$export$3e41faf802a29e71), {
                            id: ifname,
                            title: ifname,
                            panel: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$AdapterPanel, {
                                adapterInfo: info
                            })
                        }, ifname))
                })
            ]
        })
    });
};
const $7e2478d8cc8b2395$var$_validIp = (value)=>{
    if (!value) return true;
    const parts = value.split('.');
    if (parts.length !== 4) return false;
    return parts.every((p)=>/^\d{1,3}$/.test(p) && Number(p) >= 0 && Number(p) <= 255);
};
const $7e2478d8cc8b2395$var$_validNetmask = (value)=>{
    if (!value) return true;
    if (!$7e2478d8cc8b2395$var$_validIp(value)) return false;
    // valid netmask is a contiguous run of 1-bits followed by 0-bits
    const num = value.split('.').reduce((acc, octet)=>acc << 8 | Number(octet), 0) >>> 0;
    if (num === 0) return false;
    const inverted = ~num >>> 0;
    return (inverted & inverted + 1) === 0;
};
// ----- Network Control -----
const $7e2478d8cc8b2395$export$1e791ce0f94af3f = ({ onSubmit: onSubmit, onGetInfo: onGetInfo })=>{
    const [advanced, setAdvanced] = (0, $kYL7Z.useState)(false);
    const [config, setConfig] = (0, $kYL7Z.useState)({});
    const [configuring, setConfiguring] = (0, $kYL7Z.useState)(false);
    const [infoOpen, setInfoOpen] = (0, $kYL7Z.useState)(false);
    const [adapters, setAdapters] = (0, $kYL7Z.useState)(null);
    const [infoLoading, setInfoLoading] = (0, $kYL7Z.useState)(false);
    const [infoError, setInfoError] = (0, $kYL7Z.useState)(null);
    (0, $kYL7Z.useEffect)(()=>{
        setConfig({
            ...config,
            gateway: "",
            dns: ""
        });
    }, [
        advanced
    ]);
    const ipValid = $7e2478d8cc8b2395$var$_validIp(config.ip);
    const netmaskValid = $7e2478d8cc8b2395$var$_validNetmask(config.netmask);
    const gatewayValid = $7e2478d8cc8b2395$var$_validIp(config.gateway);
    const dnsValid = $7e2478d8cc8b2395$var$_validIp(config.dns);
    const allValid = ipValid && netmaskValid && gatewayValid && dnsValid;
    const handleSubmit = (0, $kYL7Z.useCallback)(()=>{
        if (!onSubmit || !allValid) return;
        setConfiguring(true);
        Promise.resolve(onSubmit(config)).catch(()=>{}).finally(()=>setConfiguring(false));
    }, [
        onSubmit,
        config,
        allValid
    ]);
    const handleGetInfo = (0, $kYL7Z.useCallback)(()=>{
        if (!onGetInfo) return;
        setInfoOpen(true);
        setInfoLoading(true);
        setInfoError(null);
        onGetInfo().then((resp)=>{
            setAdapters(resp);
        }).catch((err)=>{
            setInfoError(err?.message ?? String(err));
        }).finally(()=>{
            setInfoLoading(false);
        });
    }, [
        onGetInfo
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                            halign: "right",
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                                label: "Advanced",
                                checked: advanced,
                                onChange: ()=>setAdvanced(!advanced)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                span: 1,
                                children: "IP Address"
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                span: 4,
                                halign: "right",
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                                    fill: true,
                                    round: true,
                                    small: true,
                                    placeholder: "e.g. 192.168.1.100",
                                    intent: !ipValid ? "danger" : undefined,
                                    value: config.ip ?? "",
                                    onChange: (e)=>setConfig({
                                            ...config,
                                            ip: e.target.value
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                span: 1,
                                children: "Netmask"
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                span: 4,
                                halign: "right",
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                                    fill: true,
                                    round: true,
                                    small: true,
                                    placeholder: "e.g. 255.255.255.0",
                                    intent: !netmaskValid ? "danger" : undefined,
                                    value: config.netmask ?? "",
                                    onChange: (e)=>setConfig({
                                            ...config,
                                            netmask: e.target.value
                                        })
                                })
                            })
                        ]
                    }),
                    advanced && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        span: 1,
                                        children: "Gateway"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        span: 4,
                                        halign: "right",
                                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                                            fill: true,
                                            round: true,
                                            small: true,
                                            placeholder: "e.g. 192.168.1.1",
                                            intent: !gatewayValid ? "danger" : undefined,
                                            value: config.gateway ?? "",
                                            onChange: (e)=>setConfig({
                                                    ...config,
                                                    gateway: e.target.value
                                                })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        span: 1,
                                        children: "DNS"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        span: 4,
                                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                                            fill: true,
                                            round: true,
                                            small: true,
                                            placeholder: "e.g. 8.8.8.8",
                                            intent: !dnsValid ? "danger" : undefined,
                                            value: config.dns ?? "",
                                            onChange: (e)=>setConfig({
                                                    ...config,
                                                    dns: e.target.value
                                                })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                        margin: "auto auto 20px auto"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                text: configuring ? "Configuring..." : "Configure",
                                loading: configuring,
                                disabled: !allValid,
                                fill: true,
                                onClick: handleSubmit
                            })
                        })
                    }),
                    onGetInfo && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                text: "Network Info",
                                icon: "info-sign",
                                fill: true,
                                minimal: true,
                                onClick: handleGetInfo
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7e2478d8cc8b2395$var$NetworkInfoDialog, {
                isOpen: infoOpen,
                onClose: ()=>setInfoOpen(false),
                adapters: adapters,
                loading: infoLoading,
                error: infoError
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");






class $d5a00f6d9a6cdc43$export$e0a397508a37e5a7 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Suggest`;
    static defaultProps = {
        closeOnSelect: true,
        fill: false,
        openOnKeyDown: false,
        resetOnClose: false
    };
    /** @deprecated no longer necessary now that the TypeScript parser supports type arguments on JSX element tags */ static ofType() {
        return $d5a00f6d9a6cdc43$export$e0a397508a37e5a7;
    }
    state = {
        isOpen: this.props.popoverProps != null && this.props.popoverProps.isOpen || false,
        selectedItem: this.getInitialSelectedItem()
    };
    inputElement = null;
    queryList = null;
    handleInputRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "inputElement", this.props.inputProps?.inputRef);
    handleQueryListRef = (ref)=>this.queryList = ref;
    listboxId = (0, $5f04c694ca05154e$exports).uniqueId("listbox");
    render() {
        // omit props specific to this component, spread the rest.
        const { disabled: disabled, inputProps: inputProps, menuProps: menuProps, popoverProps: popoverProps, ...restProps } = this.props;
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $bd0ad1ca6092f56b$export$53fc189dda010966), {
            ...restProps,
            menuProps: {
                "aria-label": "selectable options",
                ...menuProps,
                id: this.listboxId
            },
            initialActiveItem: this.props.selectedItem ?? undefined,
            onItemSelect: this.handleItemSelect,
            ref: this.handleQueryListRef,
            renderer: this.renderQueryList
        });
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.inputProps?.inputRef !== this.props.inputProps?.inputRef) {
            (0, $7544862da546e887$export$4bb192c7cacf928f)(prevProps.inputProps?.inputRef, null);
            this.handleInputRef = (0, $7544862da546e887$export$e9e0d2af9a57b401)(this, "inputElement", this.props.inputProps?.inputRef);
            (0, $7544862da546e887$export$4bb192c7cacf928f)(this.props.inputProps?.inputRef, this.inputElement);
        }
        // If the selected item prop changes, update the underlying state.
        if (this.props.selectedItem !== undefined && this.props.selectedItem !== this.state.selectedItem) this.setState({
            selectedItem: this.props.selectedItem
        });
        if (this.state.isOpen === false && prevState.isOpen === true) {
            // just closed, likely by keyboard interaction
            // wait until the transition ends so there isn't a flash of content in the popover
            const timeout = this.props.popoverProps?.transitionDuration ?? (0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d).defaultProps.transitionDuration;
            setTimeout(()=>this.maybeResetActiveItemToSelectedItem(), timeout);
        }
        if (this.state.isOpen && !prevState.isOpen && this.queryList != null) this.queryList.scrollActiveItemIntoView();
    }
    renderQueryList = (listProps)=>{
        const { popoverContentProps: popoverContentProps = {}, popoverProps: popoverProps = {}, popoverRef: popoverRef } = this.props;
        const { isOpen: isOpen } = this.state;
        const { handleKeyDown: handleKeyDown, handleKeyUp: handleKeyUp } = listProps;
        // N.B. no need to set `popoverProps.fill` since that is unused with the `renderTarget` API
        return (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
            autoFocus: false,
            enforceFocus: false,
            isOpen: isOpen,
            placement: popoverProps.position || popoverProps.placement ? undefined : "bottom-start",
            ...popoverProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(listProps.className, popoverProps.className),
            content: (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                ...popoverContentProps,
                onKeyDown: handleKeyDown,
                onKeyUp: handleKeyUp,
                children: listProps.itemList
            }),
            interactionKind: "click",
            onInteraction: this.handlePopoverInteraction,
            onOpened: this.handlePopoverOpened,
            onOpening: this.handlePopoverOpening,
            popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $27a0f3536dedad79$exports).SUGGEST_POPOVER, popoverProps.popoverClassName),
            popupKind: (0, $da7063ee0db80208$export$4d5c295289e9b3bf).LISTBOX,
            ref: popoverRef,
            renderTarget: this.getPopoverTargetRenderer(listProps, isOpen)
        });
    };
    // We use the renderTarget API to flatten the rendered DOM and make it easier to implement features like
    // the "fill" prop. Note that we must take `isOpen` as an argument to force this render function to be called
    // again after that state changes.
    getPopoverTargetRenderer = (listProps, isOpen)=>// eslint-disable-next-line react/display-name
        ({ // pull out `isOpen` so that it's not forwarded to the DOM
        isOpen: _isOpen, ref: ref, ...targetProps })=>{
            const { disabled: disabled, fill: fill, inputProps: inputProps = {}, inputValueRenderer: inputValueRenderer, popoverProps: popoverProps = {}, resetOnClose: resetOnClose } = this.props;
            const { selectedItem: selectedItem } = this.state;
            const { handleKeyDown: handleKeyDown, handleKeyUp: handleKeyUp } = listProps;
            const selectedItemText = selectedItem == null ? "" : inputValueRenderer(selectedItem);
            const { autoComplete: autoComplete = "off", placeholder: placeholder = "Search..." } = inputProps;
            // placeholder shows selected item while open.
            const inputPlaceholder = isOpen && selectedItemText ? selectedItemText : placeholder;
            // value shows query when open, and query remains when closed if nothing is selected.
            // if resetOnClose is enabled, then hide query when not open. (see handlePopoverOpening)
            const inputValue = isOpen ? listProps.query : selectedItemText === "" ? resetOnClose ? "" : listProps.query : selectedItemText;
            return (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                "aria-controls": this.listboxId,
                autoComplete: autoComplete,
                disabled: disabled,
                tagName: popoverProps.targetTagName,
                ...targetProps,
                ...inputProps,
                "aria-autocomplete": "list",
                "aria-expanded": isOpen,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))(targetProps.className, inputProps.className),
                fill: fill,
                inputRef: (0, $7544862da546e887$export$c9058316764c140e)(this.handleInputRef, ref),
                onChange: listProps.handleQueryChange,
                onFocus: this.handleInputFocus,
                onKeyDown: this.getTargetKeyDownHandler(handleKeyDown),
                onKeyUp: this.getTargetKeyUpHandler(handleKeyUp),
                placeholder: inputPlaceholder,
                role: "combobox",
                value: inputValue
            });
        };
    selectText = ()=>{
        // wait until the input is properly focused to select the text inside of it
        this.requestAnimationFrame(()=>{
            this.inputElement?.setSelectionRange(0, this.inputElement.value.length);
        });
    };
    handleInputFocus = (event)=>{
        this.selectText();
        // TODO can we leverage Popover.openOnTargetFocus for this?
        if (!this.props.openOnKeyDown) this.setState({
            isOpen: true
        });
        this.props.inputProps?.onFocus?.(event);
    };
    handleItemSelect = (item, event)=>{
        let nextOpenState;
        if (!this.props.closeOnSelect) {
            this.inputElement?.focus();
            this.selectText();
            nextOpenState = true;
        } else {
            this.inputElement?.blur();
            nextOpenState = false;
        }
        // the internal state should only change when uncontrolled.
        if (this.props.selectedItem === undefined) this.setState({
            isOpen: nextOpenState,
            selectedItem: item
        });
        else // otherwise just set the next open state.
        this.setState({
            isOpen: nextOpenState
        });
        this.props.onItemSelect?.(item, event);
    };
    getInitialSelectedItem() {
        // controlled > uncontrolled > default
        if (this.props.selectedItem !== undefined) return this.props.selectedItem;
        else if (this.props.defaultSelectedItem !== undefined) return this.props.defaultSelectedItem;
        else return null;
    }
    // Popover interaction kind is CLICK, so this only handles click events.
    // Note that we defer to the next animation frame in order to get the latest activeElement
    handlePopoverInteraction = (nextOpenState, event)=>this.requestAnimationFrame(()=>{
            const isInputFocused = this.inputElement === (0, $5f04c694ca05154e$exports).getActiveElement(this.inputElement);
            if (this.inputElement != null && !isInputFocused) // the input is no longer focused, we should close the popover
            this.setState({
                isOpen: false
            });
            this.props.popoverProps?.onInteraction?.(nextOpenState, event);
        });
    handlePopoverOpening = (node)=>{
        // reset query before opening instead of when closing to prevent flash of unfiltered items.
        // this is a limitation of the interactions between QueryList state and Popover transitions.
        if (this.props.resetOnClose && this.queryList) this.queryList.setQuery("", true);
        this.props.popoverProps?.onOpening?.(node);
    };
    handlePopoverOpened = (node)=>{
        // scroll active item into view after popover transition completes and all dimensions are stable.
        if (this.queryList != null) this.queryList.scrollActiveItemIntoView();
        this.props.popoverProps?.onOpened?.(node);
    };
    getTargetKeyDownHandler = (handleQueryListKeyDown)=>{
        return (e)=>{
            if (e.key === "Escape" || e.key === "Tab") {
                // By default the escape key will not trigger a blur on the
                // input element. It must be done explicitly.
                if (e.key === "Escape") this.inputElement?.blur();
                this.setState({
                    isOpen: false
                });
            } else if (this.props.openOnKeyDown && e.key !== "Backspace" && e.key !== "ArrowLeft" && e.key !== "ArrowRight") this.setState({
                isOpen: true
            });
            if (this.state.isOpen) handleQueryListKeyDown?.(e);
            this.props.inputProps?.onKeyDown?.(e);
        };
    };
    getTargetKeyUpHandler = (handleQueryListKeyUp)=>{
        return (evt)=>{
            if (this.state.isOpen) handleQueryListKeyUp?.(evt);
            this.props.inputProps?.onKeyUp?.(evt);
        };
    };
    maybeResetActiveItemToSelectedItem() {
        const shouldResetActiveItemToSelectedItem = this.props.activeItem === undefined && this.state.selectedItem !== null && !this.props.resetOnSelect;
        if (this.queryList !== null && shouldResetActiveItemToSelectedItem) this.queryList.setActiveItem(this.props.selectedItem ?? this.state.selectedItem);
    }
}







const $43f9c5d066688a60$var$CreatingCardContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: block;
    padding: 1em;
    
`;
const $43f9c5d066688a60$var$SourceText = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    word-break: break-all;
`;
// The camera registry entries carry the rtsp url plus whatever else the device knows about the
// camera; keep the url as the value and use any human readable field as a hint.
const $43f9c5d066688a60$var$asCamera = (entry)=>{
    if (typeof entry === 'string') return entry.startsWith('rtsp://') ? {
        url: entry,
        label: null
    } : null;
    if (!entry || typeof entry !== 'object') return null;
    const url = entry.rtsp_url;
    if (typeof url !== 'string' || !url.startsWith('rtsp://')) return null;
    const label = [
        entry.name,
        entry.manufacturer,
        entry.model,
        entry.ip,
        entry.hostname
    ].find((v)=>typeof v === 'string' && v.length > 0);
    return {
        url: url,
        label: label ?? null
    };
};
// GetThumbnailCommand answers with a base64 jpeg
const $43f9c5d066688a60$export$e6efc527ae79aa2 = (base64)=>new Blob([
        new Uint8Array(atob(base64).split('').map((c)=>c.charCodeAt(0)))
    ], {
        type: 'image/jpg'
    });
// `width` defaults to whatever keeps the aspect ratio, pass it to resize to an exact size
const $43f9c5d066688a60$export$1fb313a4955d98d1 = (blob, height = 480, width = null, quality = 0.7)=>{
    return new Promise((resolve, reject)=>{
        const img = new Image();
        const url = URL.createObjectURL(blob);
        img.onload = ()=>{
            const ratio = height / img.height;
            // Draw onto canvas
            const canvas = document.createElement("canvas");
            canvas.width = width ?? ratio * img.width;
            canvas.height = height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            // Export as Base64 (jpeg with 70% quality by default)
            const base64String = canvas.toDataURL("image/jpeg", quality);
            URL.revokeObjectURL(url); // Clean up
            resolve({
                img: base64String.split(",")[1],
                height: canvas.height,
                width: canvas.width
            });
        };
        img.onerror = reject;
        img.src = url;
    });
};
const $43f9c5d066688a60$var$CreatingCard = ({ onConfirm: onConfirm })=>{
    const [nameInput, setNameInput] = (0, $kYL7Z.useState)("");
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($43f9c5d066688a60$var$CreatingCardContainer, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                children: "Create thumbnail"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                type: "text",
                leftIcon: "edit",
                placeholder: "Camera name",
                value: nameInput,
                onChange: (e)=>setNameInput(e.target.value),
                onKeyDown: (e)=>e.key === 'Enter' ? onConfirm(nameInput) : null
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                text: "Create recid",
                intent: "primary",
                disabled: nameInput.length === 0,
                onClick: ()=>onConfirm(nameInput)
            })
        ]
    });
};
const $43f9c5d066688a60$var$Thumbnail = ({ thumbnail: thumbnail, onCreate: onCreate, onRemove: onRemove })=>{
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const [showButtons, setShowButtons] = (0, $kYL7Z.useState)(false);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
        onMouseOver: ()=>setShowButtons(true),
        onMouseLeave: ()=>setShowButtons(false),
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                margin: "auto auto 20px auto",
                $separatorColor: "silver"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                    halign: "center",
                    valign: "center",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("img", {
                        src: URL.createObjectURL(thumbnail.blob),
                        alt: "",
                        width: "100%"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        span: 5,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $97da32377aa7cac2$export$f5c9f3c2c4054eec), {
                            fill: true,
                            disabled: true,
                            value: thumbnail.url,
                            autoResize: true
                        })
                    }),
                    showButtons ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        span: 1,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    minimal: true,
                                    icon: "add",
                                    title: "Create recording",
                                    loading: loading,
                                    onClick: ()=>{
                                        if (onCreate) {
                                            setLoading(true);
                                            onCreate(thumbnail.url);
                                            setLoading(false);
                                        }
                                    }
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    minimal: true,
                                    icon: "trash",
                                    title: "Remove",
                                    loading: loading,
                                    onClick: ()=>onRemove && onRemove(thumbnail)
                                })
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
};
const $43f9c5d066688a60$export$d48a38fe1a7d8026 = ({ deviceName: deviceName, onCreate: onCreate })=>{
    const [thumbnails, setThumbnails] = (0, $kYL7Z.useState)([]);
    const [currentText, setCurrentText] = (0, $kYL7Z.useState)('');
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const [creating, setCreating] = (0, $kYL7Z.useState)(null);
    const [cameras, setCameras] = (0, $kYL7Z.useState)([]);
    const [loadingCameras, setLoadingCameras] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        console.log(creating);
    }, [
        creating
    ]);
    const fetchCameras = (0, $kYL7Z.useCallback)((notify = false)=>{
        setLoadingCameras(true);
        console.log(`Getting registered cameras on ${deviceName}`);
        (0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetCameraRegistryCommand', deviceName).then((resp)=>{
            const registry = resp.payload?.resp;
            if (registry?.error) {
                if (notify) (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: registry.error
                });
            } else if (Array.isArray(registry)) {
                const found = registry.map($43f9c5d066688a60$var$asCamera).filter(Boolean);
                // the registry can hold several entries per url (different profiles/probes)
                setCameras([
                    ...new Map(found.map((c)=>[
                            c.url,
                            c
                        ])).values()
                ]);
            } else {
                console.log('Unexpected camera registry response', registry);
                if (notify) (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Failed to get the camera registry'
                });
            }
        }).catch((err)=>{
            console.log(err);
            if (notify) (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? String(err)
            });
        }).finally(()=>setLoadingCameras(false));
    }, [
        deviceName
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        fetchCameras();
    }, [
        fetchCameras
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        span: 1,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            // style={{padding: '10px'}}
                            text: "Request",
                            intent: "primary",
                            loading: loading,
                            onClick: ()=>{
                                if (currentText) {
                                    console.log(`Requesting ${currentText}`);
                                    setLoading(true);
                                    (0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetThumbnailCommand', deviceName, {
                                        source: currentText
                                    }).then((resp)=>{
                                        console.log(`Finished requesting ${currentText}`);
                                        if (resp.payload?.resp?.error) // if the response from the IoTWrapper has an error
                                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                            message: resp.payload.resp.error
                                        });
                                        else {
                                            // ----- construct blob from response
                                            const blob = $43f9c5d066688a60$export$e6efc527ae79aa2(resp.payload.resp);
                                            setThumbnails([
                                                ...thumbnails,
                                                {
                                                    url: currentText,
                                                    blob: blob
                                                }
                                            ].map((t, i)=>({
                                                    ...t,
                                                    id: i
                                                })));
                                            setCurrentText('');
                                        }
                                    }).catch((err)=>{
                                        console.log(err);
                                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                            message: err?.message ?? String(err)
                                        });
                                    }).finally(()=>setLoading(false));
                                } else {
                                    console.log("Nothing to request");
                                    (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                        message: "Please specify an RTSP url"
                                    });
                                }
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        span: 6,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d5a00f6d9a6cdc43$export$e0a397508a37e5a7), {
                            fill: true,
                            disabled: loading,
                            items: cameras,
                            // fully controlled by `currentText`: a null selectedItem keeps Suggest from
                            // replacing the input with the last picked camera once the popover closes
                            selectedItem: null,
                            query: currentText,
                            onQueryChange: setCurrentText,
                            onItemSelect: (camera)=>setCurrentText(camera.url),
                            inputValueRenderer: (camera)=>camera.url,
                            itemPredicate: (query, camera)=>`${camera.url} ${camera.label ?? ''}`.toLowerCase().includes(query.toLowerCase()),
                            itemRenderer: (camera, { handleClick: handleClick, modifiers: modifiers })=>modifiers.matchesPredicate ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                    active: modifiers.active,
                                    text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($43f9c5d066688a60$var$SourceText, {
                                        children: camera.url
                                    }),
                                    label: camera.label ?? undefined,
                                    onClick: handleClick
                                }, camera.url) : null,
                            noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                disabled: true,
                                text: loadingCameras ? "Loading registered cameras\u2026" : cameras.length ? "No matching camera, the url will be used as typed." : "No registered cameras found on this device."
                            }),
                            popoverProps: {
                                minimal: true,
                                matchTargetWidth: true
                            },
                            inputProps: {
                                small: true,
                                placeholder: loadingCameras ? "Loading registered cameras\u2026" : "Pick a registered camera or enter an rtsp url",
                                rightElement: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                                    content: "Reload the device camera registry",
                                    compact: true,
                                    minimal: true,
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                        minimal: true,
                                        small: true,
                                        icon: "refresh",
                                        disabled: loading,
                                        loading: loadingCameras,
                                        onClick: ()=>fetchCameras(true)
                                    })
                                })
                            }
                        })
                    })
                ]
            }),
            thumbnails.map((thumbnail)=>{
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                            isOpen: !!creating && creating.id === thumbnail.id,
                            onClose: ()=>setCreating(null),
                            content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($43f9c5d066688a60$var$CreatingCard, {
                                onConfirm: (name)=>{
                                    console.log(`Creating ${name}`);
                                    $43f9c5d066688a60$export$1fb313a4955d98d1(creating.blob).then(({ img: img, width: width, height: height })=>{
                                        onCreate({
                                            name: name,
                                            img: img,
                                            width: width,
                                            height: height,
                                            source: creating.url
                                        });
                                    }).finally(()=>setCreating(null));
                                }
                            }),
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($43f9c5d066688a60$var$Thumbnail, {
                                thumbnail: thumbnail,
                                onCreate: ()=>setCreating(thumbnail),
                                onRemove: (thumb)=>{
                                    console.log(`Remove thumbnail ${thumb.id}`);
                                    thumbnails.splice(thumb.id, 1);
                                    setThumbnails([
                                        ...thumbnails
                                    ].map((t, i)=>({
                                            ...t,
                                            id: i
                                        })));
                                }
                            })
                        })
                    })
                }, thumbnail.id);
            })
        ]
    });
};


/**
 * Regenerate the thumbnail of an existing recording, mirroring the "Generate thumbnail" button of
 * aura-controltools (auracontroltools/views/recidview.py):
 *
 *   1. take the rtsp url from the recording processing config (`provider.url`)
 *   2. ask the device for a fresh frame (GetThumbnailCommand)
 *   3. apply the grabber transformer chain (`Grabber.transformers`) so the thumbnail matches what
 *      the pipeline actually sees
 *   4. resize to the configured `provider.width` x `provider.height` and post it to the CoreAPI,
 *      reusing the same compression + patch the thumbnails widget uses when creating a recid
 */ 


const $573a15d6227c5afa$var$_canvas = (width, height, fill = null)=>{
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.trunc(width));
    canvas.height = Math.max(1, Math.trunc(height));
    if (fill) {
        const ctx = canvas.getContext('2d');
        ctx.fillStyle = fill;
        ctx.fillRect(0, 0, canvas.width, canvas.height);
    }
    return canvas;
};
const $573a15d6227c5afa$var$_scaled = (canvas, width, height)=>{
    const out = $573a15d6227c5afa$var$_canvas(width, height);
    out.getContext('2d').drawImage(canvas, 0, 0, out.width, out.height);
    return out;
};
/**
 * Port of auracontroltools/tools/transformers.py. Only the transformers that map onto a 2d canvas
 * are implemented; anything else (DewrapTransformer) throws so we never upload a thumbnail that
 * does not match what the device produces.
 */ const $573a15d6227c5afa$var$TRANSFORMERS = {
    IdentityTransformer: (canvas)=>canvas,
    CropTransformer: (canvas, { p: p = [
        0,
        0
    ], q: q = [
        -1,
        -1
    ] })=>{
        const sizes = [
            canvas.width,
            canvas.height
        ];
        // values < 1 are fractions of the image size, >= 1 are pixels
        const start = sizes.map((size, i)=>Math.max(0, Math.trunc(p[i] < 1 ? p[i] * size : p[i])));
        const end = sizes.map((size, i)=>{
            const value = Math.trunc(q[i] < 1 ? q[i] * size : q[i]);
            return value > 1 ? Math.min(value, size) : size;
        });
        const [width, height] = [
            end[0] - start[0],
            end[1] - start[1]
        ];
        if (width <= 0 || height <= 0) throw new Error(`CropTransformer p=${p} q=${q} leaves an empty image`);
        const out = $573a15d6227c5afa$var$_canvas(width, height);
        out.getContext('2d').drawImage(canvas, start[0], start[1], width, height, 0, 0, width, height);
        return out;
    },
    ScaleTransformer: (canvas, { scale: scale = -1, size: size = [
        -1,
        -1
    ], short: short = -1 })=>{
        const { width: width, height: height } = canvas;
        if (typeof scale === 'number' && scale > 0) return $573a15d6227c5afa$var$_scaled(canvas, width * scale, height * scale);
        if (Array.isArray(scale) && scale.length === 2 && scale.every((s)=>s > 0)) return $573a15d6227c5afa$var$_scaled(canvas, width * scale[1], height * scale[0]);
        // size is (height, width), values <= 1 keep the original dimension
        if (Array.isArray(size) && size.length === 2 && size.some((s)=>s > 1)) return $573a15d6227c5afa$var$_scaled(canvas, size[1] > 1 ? size[1] : width, size[0] > 1 ? size[0] : height);
        if (typeof short === 'number' && short > 1) {
            const ratio = short / Math.min(width, height);
            return $573a15d6227c5afa$var$_scaled(canvas, width * ratio, height * ratio);
        }
        return canvas;
    },
    // cv2.warpAffine keeps the original frame size and leaves the uncovered corners black
    RotationTransformer: (canvas, { angle: angle = 90, scale: scale = 1. })=>{
        const { width: width, height: height } = canvas;
        const out = $573a15d6227c5afa$var$_canvas(width, height, '#000');
        const ctx = out.getContext('2d');
        ctx.translate(width / 2, height / 2);
        ctx.rotate(-angle * Math.PI / 180); // cv2 angles are counter-clockwise
        ctx.scale(scale, scale);
        ctx.drawImage(canvas, -width / 2, -height / 2);
        return out;
    },
    ChannelInversionTransformer: (canvas)=>{
        const ctx = canvas.getContext('2d');
        const image = ctx.getImageData(0, 0, canvas.width, canvas.height);
        for(let i = 0; i < image.data.length; i += 4)[image.data[i], image.data[i + 2]] = [
            image.data[i + 2],
            image.data[i]
        ];
        ctx.putImageData(image, 0, 0);
        return canvas;
    }
};
// MultiTransformer.factory takes either a list of {name, params} or a {name: params} mapping
const $573a15d6227c5afa$var$_asTransformerList = (transformers)=>{
    if (!transformers) return [];
    if (Array.isArray(transformers)) return transformers.map((t)=>({
            name: t?.name,
            params: t?.params ?? {}
        }));
    if (typeof transformers === 'object') return Object.entries(transformers).map(([name, params])=>({
            name: name,
            params: params ?? {}
        }));
    return [];
};
const $573a15d6227c5afa$var$_blobToCanvas = (blob)=>new Promise((resolve, reject)=>{
        const img = new Image();
        const url = URL.createObjectURL(blob);
        img.onload = ()=>{
            const canvas = $573a15d6227c5afa$var$_canvas(img.naturalWidth, img.naturalHeight);
            canvas.getContext('2d').drawImage(img, 0, 0);
            URL.revokeObjectURL(url);
            resolve(canvas);
        };
        img.onerror = ()=>{
            URL.revokeObjectURL(url);
            reject(new Error('The device returned an image that could not be decoded'));
        };
        img.src = url;
    });
// png keeps the intermediate lossless, the jpeg compression happens once in resizeBlob
const $573a15d6227c5afa$var$_canvasToBlob = (canvas)=>new Promise((resolve, reject)=>canvas.toBlob((blob)=>blob ? resolve(blob) : reject(new Error('Failed to encode the transformed thumbnail')), 'image/png'));
const $573a15d6227c5afa$var$_transformed = async (blob, transformers)=>{
    const canvas = transformers.reduce((im, { name: name, params: params })=>{
        const transformer = $573a15d6227c5afa$var$TRANSFORMERS[name];
        if (!transformer) throw new Error(`Cannot apply "${name}" in the browser, use aura-controltools for this recording`);
        return transformer(im, params);
    }, await $573a15d6227c5afa$var$_blobToCanvas(blob));
    return $573a15d6227c5afa$var$_canvasToBlob(canvas);
};
const $573a15d6227c5afa$export$4f262652c1b0494b = async ({ deviceName: deviceName, recording: recording })=>{
    const config = recording?.processingConfig;
    const provider = config?.provider;
    if (!provider?.url) throw new Error('The recording has no rtsp url in its processing config');
    const [width, height] = [
        Number(provider.width),
        Number(provider.height)
    ];
    if (!width || !height) throw new Error('The recording has no width/height in its processing config');
    const resp = await (0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetThumbnailCommand', deviceName, {
        source: provider.url
    });
    const payload = resp?.payload?.resp;
    if (typeof payload !== 'string') throw new Error(payload?.error ?? 'The device did not return a thumbnail');
    const transformers = $573a15d6227c5afa$var$_asTransformerList(config?.Grabber?.transformers);
    const frame = transformers.length ? await $573a15d6227c5afa$var$_transformed((0, $43f9c5d066688a60$export$e6efc527ae79aa2)(payload), transformers) : (0, $43f9c5d066688a60$export$e6efc527ae79aa2)(payload);
    // 0.4 is the quality RECID.thumbnail starts at in aura-controltools — the widget can afford 0.7
    // because it downsizes to 480px first, here we keep the full configured resolution
    const { img: img } = await (0, $43f9c5d066688a60$export$1fb313a4955d98d1)(frame, height, width, 0.4);
    await (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).thumbnail.patch(recording.id, {
        base64EncodedJpeg: img
    });
    return {
        width: width,
        height: height
    };
};




var $kYL7Z = parcelRequire("kYL7Z");



const $7882f7fbed3eeef1$var$POLL_INTERVAL = 10000;
const $7882f7fbed3eeef1$var$MAX_POLL_INTERVAL = 60000;
const $7882f7fbed3eeef1$var$BACKOFF_MULTIPLIER = 1.5;
const $7882f7fbed3eeef1$var$MAX_POINTS = 30;
// -- Styled components --
const $7882f7fbed3eeef1$var$DialogContent = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 1em;
    font-size: 14px;
    font-family: 'JetBrains Mono', 'Fira Code', 'SF Mono', monospace;
`;
const $7882f7fbed3eeef1$var$SystemSection = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.75em;
`;
const $7882f7fbed3eeef1$var$MetricCard = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    background: rgba(0, 0, 0, 0.05);
    border-radius: 6px;
    padding: 0.6em 0.8em;
`;
const $7882f7fbed3eeef1$var$MetricHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.3em;
`;
const $7882f7fbed3eeef1$var$MetricTitle = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    font-weight: 600;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
`;
const $7882f7fbed3eeef1$var$MetricDetails = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 0.75em;
    margin-top: 0.3em;
    font-size: 12px;
    color: #5c7080;
`;
const $7882f7fbed3eeef1$var$SectionDivider = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    font-size: 13px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #5c7080;
    &::before {
        content: '';
        flex: 1;
        border-bottom: 1px solid rgba(0,0,0,0.1);
        order: 1;
    }
    & > *:last-child { order: 2; }
`;
const $7882f7fbed3eeef1$var$PipelineGroup = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    background: rgba(0, 0, 0, 0.03);
    border-radius: 6px;
    overflow: hidden;
`;
const $7882f7fbed3eeef1$var$PipelineHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    gap: 0.5em;
    padding: 0.4em 0.6em;
    cursor: pointer;
    user-select: none;
    font-weight: 600;
    font-size: 13px;
    background: rgba(0, 0, 0, 0.04);
    &:hover { background: rgba(0, 0, 0, 0.08); }
`;
const $7882f7fbed3eeef1$var$NodeTable = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    font-size: 12px;
`;
const $7882f7fbed3eeef1$var$NodeRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: grid;
    grid-template-columns: minmax(100px, 1.2fr) 60px 55px 55px 50px 35px 60px;
    gap: 2px;
    padding: 2px 0.6em;
    align-items: center;
    &:nth-child(even) { background: rgba(0, 0, 0, 0.02); }
`;
const $7882f7fbed3eeef1$var$NodeHeaderRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)($7882f7fbed3eeef1$var$NodeRow)`
    font-weight: 600;
    color: #5c7080;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-size: 10px;
    border-bottom: 1px solid rgba(0,0,0,0.08);
    padding-top: 4px;
    padding-bottom: 4px;
`;
const $7882f7fbed3eeef1$var$NodeName = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
const $7882f7fbed3eeef1$var$NumCell = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    text-align: right;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
`;
const $7882f7fbed3eeef1$var$Bar = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    height: 10px;
    border-radius: 2px;
    background: rgba(0,0,0,0.06);
    overflow: hidden;
    position: relative;
`;
const $7882f7fbed3eeef1$var$BarFill = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    height: 100%;
    border-radius: 2px;
    background: ${(p)=>p.$color || '#2965cc'};
    width: ${(p)=>Math.min(p.$pct, 100)}%;
    transition: width 0.3s ease;
`;
const $7882f7fbed3eeef1$var$StatsScroll = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 0.5em;
`;
// -- Sparkline --
const $7882f7fbed3eeef1$var$Sparkline = ({ data: data, color: color, max: max = 100, height: height = 32, width: width = 200 })=>{
    if (!data.length) return null;
    const pad = 2;
    const w = width - pad * 2;
    const h = height - pad * 2;
    const pts = data.map((val, i)=>{
        const x = pad + (data.length === 1 ? w : i / ($7882f7fbed3eeef1$var$MAX_POINTS - 1) * w);
        const y = pad + h - Math.min(val, max) / max * h;
        return `${x},${y}`;
    });
    const area = [
        `${pts[0].split(',')[0]},${height - pad}`,
        ...pts,
        `${pts[pts.length - 1].split(',')[0]},${height - pad}`
    ].join(' ');
    const last = pts[pts.length - 1].split(',');
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("svg", {
        width: "100%",
        height: height,
        viewBox: `0 0 ${width} ${height}`,
        preserveAspectRatio: "none",
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("polygon", {
                points: area,
                fill: color,
                opacity: "0.15"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("polyline", {
                points: pts.join(' '),
                fill: "none",
                stroke: color,
                strokeWidth: "1.5",
                strokeLinejoin: "round",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("circle", {
                cx: last[0],
                cy: last[1],
                r: "2",
                fill: color
            })
        ]
    });
};
// -- Helpers --
const $7882f7fbed3eeef1$var$_formatBytes = (bytes)=>{
    if (bytes == null) return '?';
    const gb = bytes / 1024 ** 3;
    if (gb >= 1) return `${gb.toFixed(1)}G`;
    const mb = bytes / 1024 ** 2;
    return `${mb.toFixed(0)}M`;
};
const $7882f7fbed3eeef1$var$_intentForPercent = (pct)=>{
    if (pct == null) return 'none';
    if (pct >= 90) return 'danger';
    if (pct >= 70) return 'warning';
    return 'success';
};
const $7882f7fbed3eeef1$var$_formatMs = (seconds)=>{
    if (seconds == null || seconds === 'NA') return '-';
    const ms = typeof seconds === 'string' ? parseFloat(seconds) : seconds * 1000;
    if (isNaN(ms)) return '-';
    if (ms >= 1000) return `${(ms / 1000).toFixed(1)}s`;
    if (ms >= 1) return `${ms.toFixed(0)}ms`;
    return `${(ms * 1000).toFixed(0)}us`;
};
const $7882f7fbed3eeef1$var$_formatCount = (n)=>{
    if (n == null) return '-';
    const num = typeof n === 'string' ? parseInt(n, 10) : n;
    if (isNaN(num)) return '-';
    if (num >= 1000000) return `${(num / 1000000).toFixed(1)}M`;
    if (num >= 1000) return `${(num / 1000).toFixed(1)}K`;
    return String(num);
};
const $7882f7fbed3eeef1$var$_delayColor = (ms)=>{
    if (ms == null || isNaN(ms)) return '#ced9e0';
    if (ms > 20000) return '#c23030';
    if (ms > 10000) return '#d99e0b';
    return '#29a634';
};
const $7882f7fbed3eeef1$var$_stateTag = (state)=>{
    if (!state) return null;
    const s = state.toUpperCase();
    const intent = s === 'RUNNING' ? 'success' : s === 'STOPPED' ? 'none' : s === 'CRASHED' ? 'danger' : 'warning';
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        minimal: true,
        round: true,
        intent: intent,
        style: {
            fontSize: 11,
            minHeight: 16,
            padding: '0 5px',
            lineHeight: '16px'
        },
        children: s
    });
};
/**
 * Normalise both APU (flat) and NUC (tree) formats into a common structure:
 * [ { pipeline, state, nodes: [{ name, state, calls, avg, last, max, prods, drops, delay, queue_in }] } ]
 *
 * APU format: { stats: [{ pipeline, name: "NodeType<Inner>", calls: "123", avg: "89" (us), ... }] }
 * NUC format: { type: "Pipeline", children: [{ type: "Node"|"Pipeline", ... }] }
 */ const $7882f7fbed3eeef1$var$_normaliseStats = (raw)=>{
    if (!raw) return [];
    // APU format — flat list
    if (raw.stats && Array.isArray(raw.stats)) {
        const groups = {};
        for (const row of raw.stats){
            const pName = row.pipeline || '_main';
            if (!groups[pName]) groups[pName] = {
                pipeline: pName,
                state: 'RUNNING',
                nodes: []
            };
            // APU times are in microseconds (strings)
            const toMs = (v)=>{
                const n = parseFloat(v);
                return isNaN(n) ? null : n / 1000;
            };
            const toNum = (v)=>{
                const n = parseInt(v, 10);
                return isNaN(n) ? null : n;
            };
            const queueIn = row.queue_in === 'NA' ? null : toNum(row.queue_in);
            const delay = row.delay === 'NA' ? null : toMs(row.delay);
            groups[pName].nodes.push({
                name: row.name?.replace(/^[A-Za-z]+Node<(.+)>$/, '$1') || row.name || '?',
                fullName: row.name || '?',
                state: row.state || 'RUNNING',
                calls: toNum(row.calls),
                avgMs: toMs(row.avg),
                lastMs: toMs(row.last),
                maxMs: toMs(row.max),
                prods: toNum(row.prods),
                drops: toNum(row.drops),
                delayMs: delay,
                queueIn: queueIn
            });
        }
        return Object.values(groups);
    }
    // NUC format — hierarchical tree
    if (raw.type === 'Pipeline' && raw.children) {
        const result = [];
        const mainNodes = [];
        for (const child of raw.children){
            if (child.type === 'Pipeline') {
                const nodes = (child.children || []).filter((n)=>n.type === 'Node' && n.node_mode !== 'initialiser').map((n)=>({
                        name: n.name || '?',
                        fullName: n.name || '?',
                        state: n.state || '?',
                        calls: n.calls ?? null,
                        avgMs: n.avg != null ? n.avg * 1000 : null,
                        lastMs: n.last != null ? n.last * 1000 : null,
                        maxMs: n.max != null ? n.max * 1000 : null,
                        prods: n.prods ?? null,
                        drops: n.drops ?? null,
                        delayMs: n.delay != null ? n.delay * 1000 : null,
                        queueIn: n.queue_in ?? null
                    }));
                if (nodes.length) result.push({
                    pipeline: child.name || '?',
                    state: child.state || '?',
                    nodes: nodes
                });
            } else if (child.type === 'Node' && child.node_mode !== 'initialiser') mainNodes.push({
                name: child.name || '?',
                fullName: child.name || '?',
                state: child.state || '?',
                calls: child.calls ?? null,
                avgMs: child.avg != null ? child.avg * 1000 : null,
                lastMs: child.last != null ? child.last * 1000 : null,
                maxMs: child.max != null ? child.max * 1000 : null,
                prods: child.prods ?? null,
                drops: child.drops ?? null,
                delayMs: child.delay != null ? child.delay * 1000 : null,
                queueIn: child.queue_in ?? null
            });
        }
        if (mainNodes.length) result.unshift({
            pipeline: raw.name || 'Main',
            state: raw.state || '?',
            nodes: mainNodes
        });
        return result;
    }
    return [];
};
// -- Pipeline stats section --
const $7882f7fbed3eeef1$var$PipelineStats = ({ pipelines: pipelines })=>{
    const [collapsed, setCollapsed] = (0, $kYL7Z.useState)({});
    const toggle = (0, $kYL7Z.useCallback)((name)=>{
        setCollapsed((prev)=>({
                ...prev,
                [name]: !prev[name]
            }));
    }, []);
    if (!pipelines.length) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        minimal: true,
        intent: "warning",
        children: "No pipeline data"
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$StatsScroll, {
        children: pipelines.map((p, i)=>{
            const isOpen = !collapsed[p.pipeline];
            const maxDelay = Math.max(...p.nodes.map((n)=>n.delayMs ?? 0));
            const totalDrops = p.nodes.reduce((sum, n)=>sum + (n.drops ?? 0), 0);
            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$PipelineGroup, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$PipelineHeader, {
                        onClick: ()=>toggle(p.pipeline),
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                icon: isOpen ? 'chevron-down' : 'chevron-right',
                                size: 12
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                style: {
                                    flex: 1,
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap'
                                },
                                children: p.pipeline
                            }),
                            $7882f7fbed3eeef1$var$_stateTag(p.state),
                            maxDelay > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                minimal: true,
                                round: true,
                                style: {
                                    fontSize: 11,
                                    minHeight: 16,
                                    padding: '0 5px',
                                    color: $7882f7fbed3eeef1$var$_delayColor(maxDelay)
                                },
                                children: $7882f7fbed3eeef1$var$_formatMs(maxDelay / 1000)
                            }),
                            totalDrops > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                minimal: true,
                                round: true,
                                intent: "danger",
                                style: {
                                    fontSize: 11,
                                    minHeight: 16,
                                    padding: '0 5px'
                                },
                                children: [
                                    $7882f7fbed3eeef1$var$_formatCount(totalDrops),
                                    " drops"
                                ]
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                                style: {
                                    color: '#8a9ba8',
                                    fontSize: 11
                                },
                                children: [
                                    p.nodes.length,
                                    "n"
                                ]
                            })
                        ]
                    }),
                    isOpen && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$NodeTable, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$NodeHeaderRow, {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                        children: "Node"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                        children: "Calls"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                        children: "Avg"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                        children: "Last"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                        children: "Drops"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                        children: "Q"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                                        children: "Delay"
                                    })
                                ]
                            }),
                            p.nodes.map((n, j)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$NodeRow, {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$NodeName, {
                                            title: n.fullName,
                                            children: [
                                                n.state === 'CRASHED' && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                                    icon: "error",
                                                    size: 10,
                                                    intent: "danger",
                                                    style: {
                                                        marginRight: 3
                                                    }
                                                }),
                                                n.name
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                            children: $7882f7fbed3eeef1$var$_formatCount(n.calls)
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                            children: $7882f7fbed3eeef1$var$_formatMs(n.avgMs / 1000)
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                            children: $7882f7fbed3eeef1$var$_formatMs(n.lastMs / 1000)
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                            style: n.drops > 0 ? {
                                                color: '#c23030',
                                                fontWeight: 600
                                            } : undefined,
                                            children: n.drops != null ? $7882f7fbed3eeef1$var$_formatCount(n.drops) : '-'
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$NumCell, {
                                            children: n.queueIn != null ? n.queueIn : '-'
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$Bar, {
                                            title: n.delayMs != null ? `${n.delayMs.toFixed(0)}ms` : '',
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$BarFill, {
                                                $color: $7882f7fbed3eeef1$var$_delayColor(n.delayMs),
                                                $pct: n.delayMs != null ? Math.min(n.delayMs / 30000 * 100, 100) : 0
                                            })
                                        })
                                    ]
                                }, n.name + j))
                        ]
                    })
                ]
            }, p.pipeline + i);
        })
    });
};
// -- Main component --
const $7882f7fbed3eeef1$var$CountdownTimer = ({ loading: loading, seconds: seconds })=>{
    if (seconds == null) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {});
    if (loading) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
        size: 11
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
        style: {
            fontSize: 11,
            color: '#8a9ba8',
            fontVariantNumeric: 'tabular-nums'
        },
        children: [
            seconds,
            "s"
        ]
    });
};
const $7882f7fbed3eeef1$var$_startCountdown = (setCountdown, countdownRef, seconds)=>{
    if (countdownRef.current) clearInterval(countdownRef.current);
    setCountdown(seconds);
    countdownRef.current = setInterval(()=>setCountdown((prev)=>Math.max(prev - 1, 0)), 1000);
};
const $7882f7fbed3eeef1$export$173c2a107baffad4 = ({ deviceName: deviceName, abortController: abortController })=>{
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    const [pipelinesExpanded, setPipelinesExpanded] = (0, $kYL7Z.useState)(false);
    const [history, setHistory] = (0, $kYL7Z.useState)({
        cpu: [],
        ram: [],
        swap: [],
        disk: []
    });
    const [latest, setLatest] = (0, $kYL7Z.useState)(null);
    const [pipelines, setPipelines] = (0, $kYL7Z.useState)([]);
    const [unresponsive, setUnresponsive] = (0, $kYL7Z.useState)(false);
    const [error, setError] = (0, $kYL7Z.useState)(null);
    const [psFetching, setPsFetching] = (0, $kYL7Z.useState)(false);
    const [statsFetching, setStatsFetching] = (0, $kYL7Z.useState)(false);
    const [psCountdown, setPsCountdown] = (0, $kYL7Z.useState)($7882f7fbed3eeef1$var$POLL_INTERVAL / 1000);
    const [statsCountdown, setStatsCountdown] = (0, $kYL7Z.useState)($7882f7fbed3eeef1$var$POLL_INTERVAL / 1000);
    const psTimeoutRef = (0, $kYL7Z.useRef)(null);
    const psCountdownRef = (0, $kYL7Z.useRef)(null);
    const statsTimeoutRef = (0, $kYL7Z.useRef)(null);
    const statsCountdownRef = (0, $kYL7Z.useRef)(null);
    const hiddenSinceRef = (0, $kYL7Z.useRef)(null);
    const psDelayRef = (0, $kYL7Z.useRef)($7882f7fbed3eeef1$var$POLL_INTERVAL);
    const statsDelayRef = (0, $kYL7Z.useRef)($7882f7fbed3eeef1$var$POLL_INTERVAL);
    const schedulePsPoll = (0, $kYL7Z.useCallback)((delay)=>{
        if (psTimeoutRef.current) clearTimeout(psTimeoutRef.current);
        psTimeoutRef.current = setTimeout(()=>{
            if (hiddenSinceRef.current && Date.now() - hiddenSinceRef.current > 300000) return;
            fetchPsInfo();
        }, delay);
    }, []);
    const scheduleStatsPoll = (0, $kYL7Z.useCallback)((delay)=>{
        if (statsTimeoutRef.current) clearTimeout(statsTimeoutRef.current);
        statsTimeoutRef.current = setTimeout(()=>fetchStats(), delay);
    }, []);
    const fetchPsInfo = (0, $kYL7Z.useCallback)(()=>{
        setPsFetching(true);
        const signal = abortController.signal;
        (0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetPsInfoCommand', deviceName, null, 'command', {
            signal: signal
        }).then((resp)=>{
            const isNack = resp.topic?.split('/').pop() === 'nack';
            const data = resp.payload?.resp;
            if (isNack || !data?.cpu) {
                setPsFetching(false);
                const nextDelay = Math.min(psDelayRef.current * $7882f7fbed3eeef1$var$BACKOFF_MULTIPLIER, $7882f7fbed3eeef1$var$MAX_POLL_INTERVAL);
                psDelayRef.current = nextDelay;
                $7882f7fbed3eeef1$var$_startCountdown(setPsCountdown, psCountdownRef, Math.round(nextDelay / 1000));
                schedulePsPoll(nextDelay);
                setUnresponsive(true);
                return;
            }
            setPsFetching(false);
            psDelayRef.current = $7882f7fbed3eeef1$var$POLL_INTERVAL;
            $7882f7fbed3eeef1$var$_startCountdown(setPsCountdown, psCountdownRef, $7882f7fbed3eeef1$var$POLL_INTERVAL / 1000);
            schedulePsPoll($7882f7fbed3eeef1$var$POLL_INTERVAL);
            setUnresponsive(false);
            setError(null);
            setLatest(data);
            setHistory((prev)=>({
                    cpu: [
                        ...prev.cpu,
                        data.cpu?.cpu_percent ?? 0
                    ].slice(-$7882f7fbed3eeef1$var$MAX_POINTS),
                    ram: [
                        ...prev.ram,
                        data.ram?.percent ?? 0
                    ].slice(-$7882f7fbed3eeef1$var$MAX_POINTS),
                    swap: [
                        ...prev.swap,
                        data.swap?.percent ?? 0
                    ].slice(-$7882f7fbed3eeef1$var$MAX_POINTS),
                    disk: [
                        ...prev.disk,
                        data.disk?.percent ?? 0
                    ].slice(-$7882f7fbed3eeef1$var$MAX_POINTS)
                }));
        }).catch((err)=>{
            if (err?.name === 'AbortError') return;
            setPsFetching(false);
            const nextDelay = Math.min(psDelayRef.current * $7882f7fbed3eeef1$var$BACKOFF_MULTIPLIER, $7882f7fbed3eeef1$var$MAX_POLL_INTERVAL);
            psDelayRef.current = nextDelay;
            $7882f7fbed3eeef1$var$_startCountdown(setPsCountdown, psCountdownRef, Math.round(nextDelay / 1000));
            schedulePsPoll(nextDelay);
            setError('Failed to fetch system info');
            setUnresponsive(true);
        });
    }, [
        deviceName
    ]);
    const fetchStats = (0, $kYL7Z.useCallback)(()=>{
        setStatsFetching(true);
        const signal = abortController.signal;
        (0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetNodeStatsSnapshotCommand', deviceName, null, 'command', {
            signal: signal
        }).then((resp)=>{
            const isNack = resp.topic?.split('/').pop() === 'nack';
            const raw = resp.payload?.resp;
            if (isNack || !raw) {
                setStatsFetching(false);
                const nextDelay = Math.min(statsDelayRef.current * $7882f7fbed3eeef1$var$BACKOFF_MULTIPLIER, $7882f7fbed3eeef1$var$MAX_POLL_INTERVAL);
                statsDelayRef.current = nextDelay;
                $7882f7fbed3eeef1$var$_startCountdown(setStatsCountdown, statsCountdownRef, Math.round(nextDelay / 1000));
                scheduleStatsPoll(nextDelay);
                return;
            }
            setStatsFetching(false);
            statsDelayRef.current = $7882f7fbed3eeef1$var$POLL_INTERVAL;
            $7882f7fbed3eeef1$var$_startCountdown(setStatsCountdown, statsCountdownRef, $7882f7fbed3eeef1$var$POLL_INTERVAL / 1000);
            scheduleStatsPoll($7882f7fbed3eeef1$var$POLL_INTERVAL);
            setPipelines($7882f7fbed3eeef1$var$_normaliseStats(raw));
        }).catch((err)=>{
            if (err?.name === 'AbortError') return;
            setStatsFetching(false);
            const nextDelay = Math.min(statsDelayRef.current * $7882f7fbed3eeef1$var$BACKOFF_MULTIPLIER, $7882f7fbed3eeef1$var$MAX_POLL_INTERVAL);
            statsDelayRef.current = nextDelay;
            $7882f7fbed3eeef1$var$_startCountdown(setStatsCountdown, statsCountdownRef, Math.round(nextDelay / 1000));
            scheduleStatsPoll(nextDelay);
        });
    }, [
        deviceName
    ]);
    // PS info polling — runs when dialog is open
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen) return;
        const onVisibilityChange = ()=>{
            if (document.hidden) hiddenSinceRef.current = Date.now();
            else {
                if (hiddenSinceRef.current && Date.now() - hiddenSinceRef.current > 300000) fetchPsInfo();
                hiddenSinceRef.current = null;
            }
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        psDelayRef.current = $7882f7fbed3eeef1$var$POLL_INTERVAL;
        fetchPsInfo();
        return ()=>{
            document.removeEventListener('visibilitychange', onVisibilityChange);
            if (psTimeoutRef.current) clearTimeout(psTimeoutRef.current);
            if (psCountdownRef.current) clearInterval(psCountdownRef.current);
        };
    }, [
        isOpen
    ]);
    // Stats polling — only runs when pipelines section is expanded
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen || !pipelinesExpanded) return;
        statsDelayRef.current = $7882f7fbed3eeef1$var$POLL_INTERVAL;
        fetchStats();
        return ()=>{
            if (statsTimeoutRef.current) clearTimeout(statsTimeoutRef.current);
            if (statsCountdownRef.current) clearInterval(statsCountdownRef.current);
        };
    }, [
        isOpen,
        pipelinesExpanded
    ]);
    const handleClose = (0, $kYL7Z.useCallback)(()=>{
        setIsOpen(false);
        setPipelinesExpanded(false);
        setHistory({
            cpu: [],
            ram: [],
            swap: [],
            disk: []
        });
        setLatest(null);
        setPipelines([]);
        setUnresponsive(false);
        setError(null);
        setPsFetching(false);
        setStatsFetching(false);
        setPsCountdown($7882f7fbed3eeef1$var$POLL_INTERVAL / 1000);
        setStatsCountdown($7882f7fbed3eeef1$var$POLL_INTERVAL / 1000);
        psDelayRef.current = $7882f7fbed3eeef1$var$POLL_INTERVAL;
        statsDelayRef.current = $7882f7fbed3eeef1$var$POLL_INTERVAL;
    }, []);
    const cpuPct = latest?.cpu?.cpu_percent;
    const ramPct = latest?.ram?.percent;
    const swapPct = latest?.swap?.percent;
    const diskPct = latest?.disk?.percent;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                small: true,
                minimal: true,
                icon: "dashboard",
                onClick: ()=>setIsOpen(true)
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
                isOpen: isOpen,
                onClose: handleClose,
                title: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5em'
                    },
                    children: [
                        deviceName,
                        unresponsive && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                            intent: "danger",
                            icon: "warning-sign",
                            minimal: true,
                            style: {
                                fontSize: 11
                            },
                            children: "Not responding"
                        })
                    ]
                }),
                icon: "dashboard",
                style: {
                    width: 660,
                    maxHeight: '90vh',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column'
                },
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$DialogContent, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$SectionDivider, {
                                children: [
                                    "System",
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$CountdownTimer, {
                                        loading: psFetching,
                                        seconds: psCountdown
                                    })
                                ]
                            }),
                            !latest && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                style: {
                                    textAlign: 'center'
                                },
                                children: psFetching ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                                    size: 24
                                }) : unresponsive && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                            icon: "warning-sign",
                                            size: 24
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                            style: {
                                                fontSize: 12,
                                                color: '#8a9ba8',
                                                marginTop: '0.3em'
                                            },
                                            children: [
                                                "Retrying in ",
                                                psCountdown,
                                                "s..."
                                            ]
                                        })
                                    ]
                                })
                            }),
                            latest && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$SystemSection, {
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricCard, {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricTitle, {
                                                            children: "CPU"
                                                        }),
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                            intent: $7882f7fbed3eeef1$var$_intentForPercent(cpuPct),
                                                            minimal: true,
                                                            round: true,
                                                            style: {
                                                                fontSize: 12,
                                                                minHeight: 18,
                                                                padding: '0 6px'
                                                            },
                                                            children: cpuPct != null ? `${cpuPct.toFixed(1)}%` : '?'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$Sparkline, {
                                                    data: history.cpu,
                                                    color: "#2965cc"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricDetails, {
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                                                        children: [
                                                            latest.cpu?.cpu_count ?? '?',
                                                            " cores"
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricCard, {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricTitle, {
                                                            children: "RAM"
                                                        }),
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                            intent: $7882f7fbed3eeef1$var$_intentForPercent(ramPct),
                                                            minimal: true,
                                                            round: true,
                                                            style: {
                                                                fontSize: 12,
                                                                minHeight: 18,
                                                                padding: '0 6px'
                                                            },
                                                            children: ramPct != null ? `${ramPct.toFixed(1)}%` : '?'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$Sparkline, {
                                                    data: history.ram,
                                                    color: "#29a634"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricDetails, {
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                                                        children: [
                                                            $7882f7fbed3eeef1$var$_formatBytes(latest.ram?.used),
                                                            " / ",
                                                            $7882f7fbed3eeef1$var$_formatBytes(latest.ram?.total)
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricCard, {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricTitle, {
                                                            children: "Swap"
                                                        }),
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                            intent: $7882f7fbed3eeef1$var$_intentForPercent(swapPct),
                                                            minimal: true,
                                                            round: true,
                                                            style: {
                                                                fontSize: 12,
                                                                minHeight: 18,
                                                                padding: '0 6px'
                                                            },
                                                            children: swapPct != null ? `${swapPct.toFixed(1)}%` : '?'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$Sparkline, {
                                                    data: history.swap,
                                                    color: "#d99e0b"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricDetails, {
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                                                        children: [
                                                            $7882f7fbed3eeef1$var$_formatBytes(latest.swap?.used),
                                                            " / ",
                                                            $7882f7fbed3eeef1$var$_formatBytes(latest.swap?.total)
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricCard, {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$MetricHeader, {
                                                    children: [
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricTitle, {
                                                            children: "Disk"
                                                        }),
                                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                            intent: $7882f7fbed3eeef1$var$_intentForPercent(diskPct),
                                                            minimal: true,
                                                            round: true,
                                                            style: {
                                                                fontSize: 12,
                                                                minHeight: 18,
                                                                padding: '0 6px'
                                                            },
                                                            children: diskPct != null ? `${diskPct.toFixed(1)}%` : '?'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$Sparkline, {
                                                    data: history.disk,
                                                    color: "#c23030"
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$MetricDetails, {
                                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("span", {
                                                        children: [
                                                            $7882f7fbed3eeef1$var$_formatBytes(latest.disk?.used),
                                                            " / ",
                                                            $7882f7fbed3eeef1$var$_formatBytes(latest.disk?.total)
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7882f7fbed3eeef1$var$SectionDivider, {
                                style: {
                                    cursor: 'pointer'
                                },
                                onClick: ()=>setPipelinesExpanded((prev)=>!prev),
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                        icon: pipelinesExpanded ? 'chevron-down' : 'chevron-right',
                                        size: 14,
                                        style: {
                                            order: 0
                                        }
                                    }),
                                    "Pipelines",
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$CountdownTimer, {
                                        loading: pipelinesExpanded && statsFetching,
                                        seconds: pipelinesExpanded ? statsCountdown : null
                                    })
                                ]
                            }),
                            pipelinesExpanded && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                children: [
                                    !pipelines.length && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                        style: {
                                            textAlign: 'center'
                                        },
                                        children: statsFetching ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                                            size: 20
                                        }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                                    icon: "warning-sign",
                                                    size: 20
                                                }),
                                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                                    style: {
                                                        fontSize: 12,
                                                        color: '#8a9ba8',
                                                        marginTop: '0.3em'
                                                    },
                                                    children: [
                                                        "Retrying in ",
                                                        statsCountdown,
                                                        "s..."
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    pipelines.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7882f7fbed3eeef1$var$PipelineStats, {
                                        pipelines: pipelines
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");





const $07257e639008340f$var$STEP_CHOICE = 'choice';
const $07257e639008340f$var$STEP_REPLACE = 'replace';
const $07257e639008340f$var$STEP_DECOMMISSION = 'decommission';
const $07257e639008340f$var$REPLACE_SELECT = 'select';
const $07257e639008340f$var$REPLACE_DETACH_TARGET = 'detach-target';
const $07257e639008340f$var$REPLACE_RELOCATE_TARGET = 'relocate-target';
const $07257e639008340f$var$REPLACE_MOVE_RECORDINGS = 'move-recordings';
const $07257e639008340f$var$REPLACE_DECOMMISSION_OLD = 'decommission-old';
const $07257e639008340f$var$REPLACE_DONE = 'done';
const $07257e639008340f$var$AURA_ORG_ID = '5ab28c7917186b002ca9942d';
const $07257e639008340f$var$AURA_LOCATION_ID = '5dfb59e00c7bbe00282e3124';
const $07257e639008340f$var$ReplaceStep = ({ deviceId: deviceId, deviceName: deviceName, organisationId: organisationId, locationId: locationId, locationName: locationName, onClose: onClose })=>{
    const [devices, setDevices] = (0, $kYL7Z.useState)(null);
    const [thisDeviceRecs, setThisDeviceRecs] = (0, $kYL7Z.useState)(null);
    const [selected, setSelected] = (0, $kYL7Z.useState)(null);
    const [subStep, setSubStep] = (0, $kYL7Z.useState)($07257e639008340f$var$REPLACE_SELECT);
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).list({
            withinOrganisations: organisationId,
            include: 'recordings'
        }).then((devs)=>{
            const thisDevice = devs.find((d)=>d.id === deviceId);
            setThisDeviceRecs(thisDevice?.recordings ?? []);
            setDevices(devs.filter((d)=>d.id !== deviceId && d.location === locationId));
        }).catch(()=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Failed to load devices'
            });
        });
    }, []);
    const selectedRecs = selected?.recordings ?? [];
    const handleDetachTarget = (0, $kYL7Z.useCallback)(()=>{
        if (!selected) return;
        setLoading(true);
        Promise.allSettled(selectedRecs.map((rec)=>(0, $5a9cade4af2d6a52$export$93b258f6fd606e97).update(rec.id, {
                cameraServer: null
            }))).then((results)=>{
            const failed = results.filter((r)=>r.status === 'rejected');
            if (failed.length) (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: `Failed to detach ${failed.length} of ${selectedRecs.length} recordings`
            });
            else {
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: `Detached ${selectedRecs.length} recording${selectedRecs.length !== 1 ? 's' : ''} from ${selected.name}`
                });
                setSubStep($07257e639008340f$var$REPLACE_RELOCATE_TARGET);
            }
        }).finally(()=>setLoading(false));
    }, [
        selected,
        selectedRecs
    ]);
    const handleRelocateTarget = (0, $kYL7Z.useCallback)(()=>{
        if (!selected || !locationId) return;
        setLoading(true);
        (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).update(selected.id, {
            location: locationId,
            status: 'connection confirmed'
        }).then(()=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `Moved ${selected.name} to ${deviceName}'s location`
            });
            setSubStep($07257e639008340f$var$REPLACE_MOVE_RECORDINGS);
        }).catch((err)=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? 'Failed to move device'
            });
        }).finally(()=>setLoading(false));
    }, [
        selected,
        locationId,
        deviceName
    ]);
    const handleMoveRecordings = (0, $kYL7Z.useCallback)(()=>{
        if (!selected || !thisDeviceRecs?.length) return;
        setLoading(true);
        Promise.allSettled(thisDeviceRecs.map((rec)=>(0, $5a9cade4af2d6a52$export$93b258f6fd606e97).update(rec.id, {
                cameraServer: selected.id
            }))).then((results)=>{
            const failed = results.filter((r)=>r.status === 'rejected');
            if (failed.length) (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: `Failed to move ${failed.length} of ${thisDeviceRecs.length} recordings`
            });
            else {
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: `Moved ${thisDeviceRecs.length} recording${thisDeviceRecs.length !== 1 ? 's' : ''} to ${selected.name}`
                });
                (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', deviceName, null, 'update').catch(()=>{});
                (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', selected.name, null, 'update').catch(()=>{});
                setSubStep($07257e639008340f$var$REPLACE_DECOMMISSION_OLD);
            }
        }).finally(()=>setLoading(false));
    }, [
        selected,
        thisDeviceRecs,
        deviceName
    ]);
    const handleDecommissionOld = (0, $kYL7Z.useCallback)((moveToAura)=>{
        setLoading(true);
        const update = {
            status: 'decommissioned'
        };
        if (moveToAura) {
            update.organisation = $07257e639008340f$var$AURA_ORG_ID;
            update.location = $07257e639008340f$var$AURA_LOCATION_ID;
        }
        (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).update(deviceId, update).then(()=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `${deviceName} has been decommissioned`
            });
            // Fire-and-forget: notify both devices to update their config
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', deviceName, null, 'update').catch(()=>{});
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateDeviceConfiguration', deviceName, null, 'update').catch(()=>{});
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', selected.name, null, 'update').catch(()=>{});
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateDeviceConfiguration', selected.name, null, 'update').catch(()=>{});
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: 'Sent device update commands'
            });
            setSubStep($07257e639008340f$var$REPLACE_DONE);
        }).catch((err)=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? 'Failed to decommission device'
            });
        }).finally(()=>setLoading(false));
    }, [
        deviceId,
        deviceName,
        selected
    ]);
    if (devices == null) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
        size: 24
    });
    if (!devices.length) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        minimal: true,
        intent: "warning",
        icon: "warning-sign",
        children: "No other devices in this organisation and location"
    });
    if (subStep === $07257e639008340f$var$REPLACE_SELECT) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                        position: "right",
                        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                            style: {
                                maxWidth: 220
                            },
                            children: [
                                "The target device must belong to the same organisation and be in ",
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                    children: locationName
                                }),
                                "."
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "info-sign",
                            style: {
                                marginRight: 6,
                                cursor: 'help'
                            }
                        })
                    }),
                    "Select device replacing ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: deviceName
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                items: devices,
                itemPredicate: (query, dev)=>dev.name.toLowerCase().includes(query.toLowerCase()),
                itemRenderer: (dev, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                        text: dev.name,
                        label: `${dev.recordings?.length ?? 0} recs`,
                        onClick: handleClick,
                        active: modifiers.active,
                        selected: selected?.id === dev.id
                    }, dev.id),
                onItemSelect: setSelected,
                popoverProps: {
                    minimal: true,
                    matchTargetWidth: true
                },
                fill: true,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    fill: true,
                    text: selected ? selected.name : 'Select a device...',
                    endIcon: "caret-down",
                    icon: selected ? 'desktop' : undefined
                })
            }),
            selected && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                style: {
                    fontSize: 13,
                    color: '#5c7080'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: selected.name
                    }),
                    " currently has ",
                    selectedRecs.length,
                    " recording",
                    selectedRecs.length !== 1 ? 's' : '',
                    selectedRecs.length > 0 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                        style: {
                            color: '#c23030',
                            marginTop: '0.75em',
                            textAlign: 'center'
                        },
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                icon: "warning-sign",
                                size: 12,
                                style: {
                                    marginRight: 4
                                }
                            }),
                            "The recording",
                            selectedRecs.length !== 1 ? 's' : '',
                            " in ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                children: selected.name
                            }),
                            " would be orphaned.",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("br", {}),
                            "Decommission ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                children: selected.name
                            }),
                            " first to prevent this."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                intent: "primary",
                icon: "swap-horizontal",
                text: selected ? `Replace with ${selected.name}` : 'Replace',
                disabled: !selected,
                onClick: ()=>setSubStep(selectedRecs.length > 0 ? $07257e639008340f$var$REPLACE_DETACH_TARGET : $07257e639008340f$var$REPLACE_RELOCATE_TARGET)
            })
        ]
    });
    if (subStep === $07257e639008340f$var$REPLACE_DETACH_TARGET) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: "Step 1:"
                    }),
                    " Detach ",
                    selectedRecs.length,
                    " recording",
                    selectedRecs.length !== 1 ? 's' : '',
                    " from ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: selected.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0,
                    fontSize: 13,
                    color: '#5c7080'
                },
                children: [
                    selectedRecs.length === 1 ? 'This recording' : 'These recordings',
                    " will be set to have no device. You can reassign ",
                    selectedRecs.length === 1 ? 'it' : 'them',
                    " later."
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                style: {
                    fontSize: 13,
                    color: '#5c7080'
                },
                children: selectedRecs.map((rec)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                        children: [
                            "\u2022 ",
                            rec.id
                        ]
                    }, rec.id))
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                intent: "warning",
                icon: "remove",
                text: loading ? 'Detaching...' : `Detach ${selectedRecs.length} recording${selectedRecs.length !== 1 ? 's' : ''}`,
                disabled: loading,
                onClick: handleDetachTarget
            })
        ]
    });
    if (subStep === $07257e639008340f$var$REPLACE_RELOCATE_TARGET) {
        const stepNum = selectedRecs.length > 0 ? 2 : 1;
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75em'
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("strong", {
                            children: [
                                "Step ",
                                stepNum,
                                ":"
                            ]
                        }),
                        " Move ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: selected.name
                        }),
                        " to ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: locationName || 'unknown location'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                    style: {
                        margin: 0,
                        fontSize: 13,
                        color: '#5c7080'
                    },
                    children: [
                        "This will update ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: selected.name
                        }),
                        "'s location to match ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: deviceName
                        }),
                        "'s (",
                        locationName || 'unknown',
                        ")."
                    ]
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    fill: true,
                    intent: "primary",
                    icon: "map-marker",
                    text: loading ? 'Moving...' : `Move ${selected.name}`,
                    disabled: loading,
                    onClick: handleRelocateTarget
                })
            ]
        });
    }
    if (subStep === $07257e639008340f$var$REPLACE_MOVE_RECORDINGS) {
        const stepNum = (selectedRecs.length > 0 ? 2 : 1) + 1;
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75em'
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("strong", {
                            children: [
                                "Step ",
                                stepNum,
                                ":"
                            ]
                        }),
                        " Move recordings from ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: deviceName
                        }),
                        " to ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: selected.name
                        })
                    ]
                }),
                thisDeviceRecs?.length > 0 ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                            style: {
                                fontSize: 13,
                                color: '#5c7080'
                            },
                            children: thisDeviceRecs.map((rec)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                    children: [
                                        "\u2022 ",
                                        rec.id
                                    ]
                                }, rec.id))
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            fill: true,
                            intent: "primary",
                            icon: "swap-horizontal",
                            text: loading ? 'Moving...' : `Move ${thisDeviceRecs.length} recording${thisDeviceRecs.length !== 1 ? 's' : ''}`,
                            disabled: loading,
                            onClick: handleMoveRecordings
                        })
                    ]
                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("p", {
                            style: {
                                margin: 0,
                                fontSize: 13,
                                color: '#5c7080'
                            },
                            children: "No recordings to move."
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            fill: true,
                            intent: "primary",
                            text: "Continue",
                            onClick: ()=>setSubStep($07257e639008340f$var$REPLACE_DECOMMISSION_OLD)
                        })
                    ]
                })
            ]
        });
    }
    if (subStep === $07257e639008340f$var$REPLACE_DECOMMISSION_OLD) {
        const stepNum = (selectedRecs.length > 0 ? 2 : 1) + 2;
        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.75em'
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                    style: {
                        margin: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("strong", {
                            children: [
                                "Step ",
                                stepNum,
                                ":"
                            ]
                        }),
                        " Decommission ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: deviceName
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                    style: {
                        margin: 0,
                        fontSize: 13,
                        color: '#5c7080'
                    },
                    children: [
                        "Move ",
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                            children: deviceName
                        }),
                        " to the Aura organisation, or just mark it as decommissioned?"
                    ]
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '0.75em'
                    },
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            fill: true,
                            intent: "warning",
                            icon: "office",
                            text: loading ? 'Processing...' : 'Move to Aura & decommission',
                            disabled: loading,
                            onClick: ()=>handleDecommissionOld(true)
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            fill: true,
                            intent: "danger",
                            icon: "remove",
                            text: loading ? 'Processing...' : 'Just decommission',
                            disabled: loading,
                            onClick: ()=>handleDecommissionOld(false)
                        })
                    ]
                })
            ]
        });
    }
    if (subStep === $07257e639008340f$var$REPLACE_DONE) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em',
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: "tick-circle",
                size: 32,
                intent: "success"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: selected.name
                    }),
                    " has replaced ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: deviceName
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                text: "Done",
                onClick: ()=>window.location.reload()
            })
        ]
    });
    return null;
};
const $07257e639008340f$var$DECOM_DETACH = 'detach';
const $07257e639008340f$var$DECOM_SET_STATUS = 'set-status';
const $07257e639008340f$var$DECOM_DONE = 'done';
const $07257e639008340f$var$DecommissionStep = ({ deviceId: deviceId, deviceName: deviceName, organisationId: organisationId })=>{
    const [deviceRecs, setDeviceRecs] = (0, $kYL7Z.useState)(null);
    const [subStep, setSubStep] = (0, $kYL7Z.useState)($07257e639008340f$var$DECOM_DETACH);
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).list({
            withinCameraServers: deviceId
        }).then((recs)=>{
            setDeviceRecs(recs);
        }).catch(()=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Failed to load recordings'
            });
            setDeviceRecs([]);
        });
    }, []);
    const handleDetach = (0, $kYL7Z.useCallback)(()=>{
        if (!deviceRecs?.length) return;
        setLoading(true);
        Promise.allSettled(deviceRecs.map((rec)=>(0, $5a9cade4af2d6a52$export$93b258f6fd606e97).update(rec.id, {
                cameraServer: null
            }))).then((results)=>{
            const failed = results.filter((r)=>r.status === 'rejected');
            if (failed.length) (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: `Failed to detach ${failed.length} of ${deviceRecs.length} recordings`
            });
            else {
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: `Detached ${deviceRecs.length} recording${deviceRecs.length !== 1 ? 's' : ''} from ${deviceName}`
                });
                (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', deviceName, null, 'update').catch(()=>{});
                setSubStep($07257e639008340f$var$DECOM_SET_STATUS);
            }
        }).finally(()=>setLoading(false));
    }, [
        deviceRecs,
        deviceName
    ]);
    const handleDecommission = (0, $kYL7Z.useCallback)((moveToAura)=>{
        setLoading(true);
        const update = {
            status: 'decommissioned'
        };
        if (moveToAura) {
            update.organisation = $07257e639008340f$var$AURA_ORG_ID;
            update.location = $07257e639008340f$var$AURA_LOCATION_ID;
        }
        (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).update(deviceId, update).then(()=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `${deviceName} has been decommissioned`
            });
            // Fire-and-forget: notify device to update its config
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', deviceName, null, 'update').catch(()=>{});
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateDeviceConfiguration', deviceName, null, 'update').catch(()=>{});
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: 'Sent device update commands'
            });
            setSubStep($07257e639008340f$var$DECOM_DONE);
        }).catch((err)=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? 'Failed to decommission device'
            });
        }).finally(()=>setLoading(false));
    }, [
        deviceId,
        deviceName
    ]);
    if (deviceRecs == null) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
        size: 24
    });
    if (subStep === $07257e639008340f$var$DECOM_DETACH) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: "Step 1:"
                    }),
                    " Detach recordings from ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: deviceName
                    })
                ]
            }),
            deviceRecs.length > 0 ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                        style: {
                            fontSize: 13,
                            color: '#5c7080'
                        },
                        children: deviceRecs.map((rec)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                children: [
                                    "\u2022 ",
                                    rec.id
                                ]
                            }, rec.id))
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        fill: true,
                        intent: "warning",
                        icon: "remove",
                        text: loading ? 'Detaching...' : `Detach ${deviceRecs.length} recording${deviceRecs.length !== 1 ? 's' : ''}`,
                        disabled: loading,
                        onClick: handleDetach
                    })
                ]
            }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("p", {
                        style: {
                            margin: 0,
                            fontSize: 13,
                            color: '#5c7080'
                        },
                        children: "No recordings to detach."
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        fill: true,
                        intent: "primary",
                        text: "Continue",
                        onClick: ()=>setSubStep($07257e639008340f$var$DECOM_SET_STATUS)
                    })
                ]
            })
        ]
    });
    if (subStep === $07257e639008340f$var$DECOM_SET_STATUS) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: "Step 2:"
                    }),
                    " Decommission ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: deviceName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0,
                    fontSize: 13,
                    color: '#5c7080'
                },
                children: [
                    "Move ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: deviceName
                    }),
                    " to the Aura organisation, or just mark it as decommissioned?"
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                style: {
                    display: 'flex',
                    gap: '0.75em'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        fill: true,
                        intent: "warning",
                        icon: "office",
                        text: loading ? 'Processing...' : 'Move to Aura & decommission',
                        disabled: loading,
                        onClick: ()=>handleDecommission(true)
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        fill: true,
                        intent: "danger",
                        icon: "remove",
                        text: loading ? 'Processing...' : 'Just decommission',
                        disabled: loading,
                        onClick: ()=>handleDecommission(false)
                    })
                ]
            })
        ]
    });
    if (subStep === $07257e639008340f$var$DECOM_DONE) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em',
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: "tick-circle",
                size: 32,
                intent: "success"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: deviceName
                    }),
                    " has been decommissioned."
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                text: "Done",
                onClick: ()=>window.location.reload()
            })
        ]
    });
    return null;
};
const $07257e639008340f$export$a849a34056f7c844 = ({ deviceName: deviceName, deviceId: deviceId, organisationId: organisationId, locationId: locationId, locationName: locationName })=>{
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    const [step, setStep] = (0, $kYL7Z.useState)($07257e639008340f$var$STEP_CHOICE);
    const handleOpen = (0, $kYL7Z.useCallback)(()=>{
        setStep($07257e639008340f$var$STEP_CHOICE);
        setIsOpen(true);
    }, []);
    const handleClose = (0, $kYL7Z.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const title = step === $07257e639008340f$var$STEP_CHOICE ? 'Decommission device' : step === $07257e639008340f$var$STEP_REPLACE ? 'Replace device' : 'Decommission device';
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                text: "Decommission device",
                intent: "danger",
                icon: "remove",
                onClick: handleOpen
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
                isOpen: isOpen,
                onClose: handleClose,
                title: title,
                icon: step === $07257e639008340f$var$STEP_REPLACE ? 'swap-horizontal' : 'remove',
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
                    children: [
                        step === $07257e639008340f$var$STEP_CHOICE && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.75em'
                            },
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("p", {
                                    style: {
                                        margin: 0
                                    },
                                    children: "Replace this device, or just decommission?"
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: '0.75em'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            fill: true,
                                            icon: "swap-horizontal",
                                            text: "Replace",
                                            intent: "primary",
                                            onClick: ()=>setStep($07257e639008340f$var$STEP_REPLACE)
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            fill: true,
                                            icon: "remove",
                                            text: "Decommission",
                                            intent: "danger",
                                            onClick: ()=>setStep($07257e639008340f$var$STEP_DECOMMISSION)
                                        })
                                    ]
                                })
                            ]
                        }),
                        step === $07257e639008340f$var$STEP_REPLACE && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($07257e639008340f$var$ReplaceStep, {
                            deviceId: deviceId,
                            deviceName: deviceName,
                            organisationId: organisationId,
                            locationId: locationId,
                            locationName: locationName,
                            onClose: handleClose
                        }),
                        step === $07257e639008340f$var$STEP_DECOMMISSION && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($07257e639008340f$var$DecommissionStep, {
                            deviceId: deviceId,
                            deviceName: deviceName,
                            organisationId: organisationId
                        })
                    ]
                })
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");


// https://caniuse.com/mdn-javascript_builtins_number_isfinite
const $b941786f4eb9cb76$var$isFiniteNumber = Number.isFinite || function(value) {
    return typeof value === 'number' && isFinite(value);
};
// https://caniuse.com/mdn-javascript_builtins_number_issafeinteger
const $b941786f4eb9cb76$var$isSafeInteger = Number.isSafeInteger || function(value) {
    return typeof value === 'number' && Math.abs(value) <= $b941786f4eb9cb76$var$MAX_SAFE_INTEGER;
};
const $b941786f4eb9cb76$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
let $b941786f4eb9cb76$export$43a750ddd9f2303e = /*#__PURE__*/ function(ErrorTypes) {
    // Identifier for a network error (loading error / timeout ...)
    ErrorTypes["NETWORK_ERROR"] = "networkError";
    // Identifier for a media Error (video/parsing/mediasource error)
    ErrorTypes["MEDIA_ERROR"] = "mediaError";
    // EME (encrypted media extensions) errors
    ErrorTypes["KEY_SYSTEM_ERROR"] = "keySystemError";
    // Identifier for a mux Error (demuxing/remuxing)
    ErrorTypes["MUX_ERROR"] = "muxError";
    // Identifier for all other errors
    ErrorTypes["OTHER_ERROR"] = "otherError";
    return ErrorTypes;
}({});
let $b941786f4eb9cb76$export$d053ec805ce391aa = /*#__PURE__*/ function(ErrorDetails) {
    ErrorDetails["KEY_SYSTEM_NO_KEYS"] = "keySystemNoKeys";
    ErrorDetails["KEY_SYSTEM_NO_ACCESS"] = "keySystemNoAccess";
    ErrorDetails["KEY_SYSTEM_NO_SESSION"] = "keySystemNoSession";
    ErrorDetails["KEY_SYSTEM_NO_CONFIGURED_LICENSE"] = "keySystemNoConfiguredLicense";
    ErrorDetails["KEY_SYSTEM_LICENSE_REQUEST_FAILED"] = "keySystemLicenseRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED"] = "keySystemServerCertificateRequestFailed";
    ErrorDetails["KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED"] = "keySystemServerCertificateUpdateFailed";
    ErrorDetails["KEY_SYSTEM_SESSION_UPDATE_FAILED"] = "keySystemSessionUpdateFailed";
    ErrorDetails["KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED"] = "keySystemStatusOutputRestricted";
    ErrorDetails["KEY_SYSTEM_STATUS_INTERNAL_ERROR"] = "keySystemStatusInternalError";
    ErrorDetails["KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR"] = "keySystemDestroyMediaKeysError";
    ErrorDetails["KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR"] = "keySystemDestroyCloseSessionError";
    ErrorDetails["KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR"] = "keySystemDestroyRemoveSessionError";
    // Identifier for a manifest load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["MANIFEST_LOAD_ERROR"] = "manifestLoadError";
    // Identifier for a manifest load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["MANIFEST_LOAD_TIMEOUT"] = "manifestLoadTimeOut";
    // Identifier for a manifest parsing error - data: { url : faulty URL, reason : error reason}
    ErrorDetails["MANIFEST_PARSING_ERROR"] = "manifestParsingError";
    // Identifier for a manifest with only incompatible codecs error - data: { url : faulty URL, reason : error reason}
    ErrorDetails["MANIFEST_INCOMPATIBLE_CODECS_ERROR"] = "manifestIncompatibleCodecsError";
    // Identifier for a level which contains no fragments - data: { url: faulty URL, reason: "no fragments found in level", level: index of the bad level }
    ErrorDetails["LEVEL_EMPTY_ERROR"] = "levelEmptyError";
    // Identifier for a level load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["LEVEL_LOAD_ERROR"] = "levelLoadError";
    // Identifier for a level load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["LEVEL_LOAD_TIMEOUT"] = "levelLoadTimeOut";
    // Identifier for a level parse error - data: { url : faulty URL, error: Error, reason: error message }
    ErrorDetails["LEVEL_PARSING_ERROR"] = "levelParsingError";
    // Identifier for a level switch error - data: { level : faulty level Id, event : error description}
    ErrorDetails["LEVEL_SWITCH_ERROR"] = "levelSwitchError";
    // Identifier for an audio track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["AUDIO_TRACK_LOAD_ERROR"] = "audioTrackLoadError";
    // Identifier for an audio track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["AUDIO_TRACK_LOAD_TIMEOUT"] = "audioTrackLoadTimeOut";
    // Identifier for a subtitle track load error - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["SUBTITLE_LOAD_ERROR"] = "subtitleTrackLoadError";
    // Identifier for a subtitle track load timeout - data: { url : faulty URL, response : { code: error code, text: error text }}
    ErrorDetails["SUBTITLE_TRACK_LOAD_TIMEOUT"] = "subtitleTrackLoadTimeOut";
    // Identifier for fragment load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    ErrorDetails["FRAG_LOAD_ERROR"] = "fragLoadError";
    // Identifier for fragment load timeout error - data: { frag : fragment object}
    ErrorDetails["FRAG_LOAD_TIMEOUT"] = "fragLoadTimeOut";
    // Identifier for a fragment decryption error event - data: {id : demuxer Id,frag: fragment object, reason : parsing error description }
    ErrorDetails["FRAG_DECRYPT_ERROR"] = "fragDecryptError";
    // Identifier for a fragment parsing error event - data: { id : demuxer Id, reason : parsing error description }
    // will be renamed DEMUX_PARSING_ERROR and switched to MUX_ERROR in the next major release
    ErrorDetails["FRAG_PARSING_ERROR"] = "fragParsingError";
    // Identifier for a fragment or part load skipped because of a GAP tag or attribute
    ErrorDetails["FRAG_GAP"] = "fragGap";
    // Identifier for a remux alloc error event - data: { id : demuxer Id, frag : fragment object, bytes : nb of bytes on which allocation failed , reason : error text }
    ErrorDetails["REMUX_ALLOC_ERROR"] = "remuxAllocError";
    // Identifier for decrypt key load error - data: { frag : fragment object, response : { code: error code, text: error text }}
    ErrorDetails["KEY_LOAD_ERROR"] = "keyLoadError";
    // Identifier for decrypt key load timeout error - data: { frag : fragment object}
    ErrorDetails["KEY_LOAD_TIMEOUT"] = "keyLoadTimeOut";
    // Triggered when an exception occurs while adding a sourceBuffer to MediaSource - data : { error : exception , mimeType : mimeType }
    ErrorDetails["BUFFER_ADD_CODEC_ERROR"] = "bufferAddCodecError";
    // Triggered when source buffer(s) could not be created using level (manifest CODECS attribute), parsed media, or best guess codec(s) - data: { reason : error reason }
    ErrorDetails["BUFFER_INCOMPATIBLE_CODECS_ERROR"] = "bufferIncompatibleCodecsError";
    // Identifier for a buffer append error - data: append error description
    ErrorDetails["BUFFER_APPEND_ERROR"] = "bufferAppendError";
    // Identifier for a buffer appending error event - data: appending error description
    ErrorDetails["BUFFER_APPENDING_ERROR"] = "bufferAppendingError";
    // Identifier for a buffer stalled error event
    ErrorDetails["BUFFER_STALLED_ERROR"] = "bufferStalledError";
    // Identifier for a buffer full event
    ErrorDetails["BUFFER_FULL_ERROR"] = "bufferFullError";
    // Identifier for a buffer seek over hole event
    ErrorDetails["BUFFER_SEEK_OVER_HOLE"] = "bufferSeekOverHole";
    // Identifier for a buffer nudge on stall (playback is stuck although currentTime is in a buffered area)
    ErrorDetails["BUFFER_NUDGE_ON_STALL"] = "bufferNudgeOnStall";
    // Identifier for a Interstitial Asset List load error - data: { url: faulty URL, response: { code: error code, text: error text } }
    ErrorDetails["ASSET_LIST_LOAD_ERROR"] = "assetListLoadError";
    // Identifier for a Interstitial Asset List load timeout - data: { url: faulty URL, response: { code: error code, text: error text } }
    ErrorDetails["ASSET_LIST_LOAD_TIMEOUT"] = "assetListLoadTimeout";
    // Identifier for a Interstitial Asset List parsing error - data: { url : faulty URL, reason : error reason, response : { code: error code, text: error text }}
    ErrorDetails["ASSET_LIST_PARSING_ERROR"] = "assetListParsingError";
    // Identifier for a Interstitial Asset List parsing error - data: { url : faulty URL, reason : error reason, response : { code: error code, text: error text }}
    ErrorDetails["INTERSTITIAL_ASSET_ITEM_ERROR"] = "interstitialAssetItemError";
    // Identifier for an internal exception happening inside hls.js while handling an event
    ErrorDetails["INTERNAL_EXCEPTION"] = "internalException";
    // Identifier for an internal call to abort a loader
    ErrorDetails["INTERNAL_ABORTED"] = "aborted";
    // Triggered when attachMedia fails
    ErrorDetails["ATTACH_MEDIA_ERROR"] = "attachMediaError";
    // Uncategorized error
    ErrorDetails["UNKNOWN"] = "unknown";
    return ErrorDetails;
}({});
let $b941786f4eb9cb76$export$ada873a34909da65 = /*#__PURE__*/ function(Events) {
    // Fired before MediaSource is attaching to media element
    Events["MEDIA_ATTACHING"] = "hlsMediaAttaching";
    // Fired when MediaSource has been successfully attached to media element
    Events["MEDIA_ATTACHED"] = "hlsMediaAttached";
    // Fired before detaching MediaSource from media element
    Events["MEDIA_DETACHING"] = "hlsMediaDetaching";
    // Fired when MediaSource has been detached from media element
    Events["MEDIA_DETACHED"] = "hlsMediaDetached";
    // Fired when HTMLMediaElement dispatches "ended" event, or stalls at end of VOD program
    Events["MEDIA_ENDED"] = "hlsMediaEnded";
    // Fired after playback stall is resolved with playing, seeked, or ended event following BUFFER_STALLED_ERROR
    Events["STALL_RESOLVED"] = "hlsStallResolved";
    // Fired when the buffer is going to be reset
    Events["BUFFER_RESET"] = "hlsBufferReset";
    // Fired when we know about the codecs that we need buffers for to push into - data: {tracks : { container, codec, levelCodec, initSegment, metadata }}
    Events["BUFFER_CODECS"] = "hlsBufferCodecs";
    // fired when sourcebuffers have been created - data: { tracks : tracks }
    Events["BUFFER_CREATED"] = "hlsBufferCreated";
    // fired when we append a segment to the buffer - data: { segment: segment object }
    Events["BUFFER_APPENDING"] = "hlsBufferAppending";
    // fired when we are done with appending a media segment to the buffer - data : { parent : segment parent that triggered BUFFER_APPENDING, pending : nb of segments waiting for appending for this segment parent}
    Events["BUFFER_APPENDED"] = "hlsBufferAppended";
    // fired when the stream is finished and we want to notify the media buffer that there will be no more data - data: { }
    Events["BUFFER_EOS"] = "hlsBufferEos";
    // fired when all buffers are full to the end of the program, after calling MediaSource.endOfStream() (unless restricted)
    Events["BUFFERED_TO_END"] = "hlsBufferedToEnd";
    // fired when the media buffer should be flushed - data { startOffset, endOffset }
    Events["BUFFER_FLUSHING"] = "hlsBufferFlushing";
    // fired when the media buffer has been flushed - data: { }
    Events["BUFFER_FLUSHED"] = "hlsBufferFlushed";
    // fired to signal that a manifest loading starts - data: { url : manifestURL}
    Events["MANIFEST_LOADING"] = "hlsManifestLoading";
    // fired after manifest has been loaded - data: { levels : [available quality levels], audioTracks : [ available audio tracks ], url : manifestURL, stats : LoaderStats }
    Events["MANIFEST_LOADED"] = "hlsManifestLoaded";
    // fired after manifest has been parsed - data: { levels : [available quality levels], firstLevel : index of first quality level appearing in Manifest}
    Events["MANIFEST_PARSED"] = "hlsManifestParsed";
    // fired when a level switch is requested - data: { level : id of new level }
    Events["LEVEL_SWITCHING"] = "hlsLevelSwitching";
    // fired when a level switch is effective - data: { level : id of new level }
    Events["LEVEL_SWITCHED"] = "hlsLevelSwitched";
    // fired when a level playlist loading starts - data: { url : level URL, level : id of level being loaded}
    Events["LEVEL_LOADING"] = "hlsLevelLoading";
    // fired when a level playlist loading finishes - data: { details : levelDetails object, level : id of loaded level, stats : LoaderStats }
    Events["LEVEL_LOADED"] = "hlsLevelLoaded";
    // fired when a level's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, level : id of updated level }
    Events["LEVEL_UPDATED"] = "hlsLevelUpdated";
    // fired when a level's PTS information has been updated after parsing a fragment - data: { details : levelDetails object, level : id of updated level, drift: PTS drift observed when parsing last fragment }
    Events["LEVEL_PTS_UPDATED"] = "hlsLevelPtsUpdated";
    // fired to notify that levels have changed after removing a level - data: { levels : [available quality levels] }
    Events["LEVELS_UPDATED"] = "hlsLevelsUpdated";
    // fired to notify that audio track lists has been updated - data: { audioTracks : audioTracks }
    Events["AUDIO_TRACKS_UPDATED"] = "hlsAudioTracksUpdated";
    // fired when an audio track switching is requested - data: { id : audio track id }
    Events["AUDIO_TRACK_SWITCHING"] = "hlsAudioTrackSwitching";
    // fired when an audio track switch actually occurs - data: { id : audio track id }
    Events["AUDIO_TRACK_SWITCHED"] = "hlsAudioTrackSwitched";
    // fired when an audio track loading starts - data: { url : audio track URL, id : audio track id }
    Events["AUDIO_TRACK_LOADING"] = "hlsAudioTrackLoading";
    // fired when an audio track loading finishes - data: { details : levelDetails object, id : audio track id, stats : LoaderStats }
    Events["AUDIO_TRACK_LOADED"] = "hlsAudioTrackLoaded";
    // fired when an audio tracks's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, id : track id }
    Events["AUDIO_TRACK_UPDATED"] = "hlsAudioTrackUpdated";
    // fired to notify that subtitle track lists has been updated - data: { subtitleTracks : subtitleTracks }
    Events["SUBTITLE_TRACKS_UPDATED"] = "hlsSubtitleTracksUpdated";
    // fired to notify that subtitle tracks were cleared as a result of stopping the media
    Events["SUBTITLE_TRACKS_CLEARED"] = "hlsSubtitleTracksCleared";
    // fired when an subtitle track switch occurs - data: { id : subtitle track id }
    Events["SUBTITLE_TRACK_SWITCH"] = "hlsSubtitleTrackSwitch";
    // fired when a subtitle track loading starts - data: { url : subtitle track URL, id : subtitle track id }
    Events["SUBTITLE_TRACK_LOADING"] = "hlsSubtitleTrackLoading";
    // fired when a subtitle track loading finishes - data: { details : levelDetails object, id : subtitle track id, stats : LoaderStats }
    Events["SUBTITLE_TRACK_LOADED"] = "hlsSubtitleTrackLoaded";
    // fired when a subtitle  racks's details have been updated based on previous details, after it has been loaded - data: { details : levelDetails object, id : track id }
    Events["SUBTITLE_TRACK_UPDATED"] = "hlsSubtitleTrackUpdated";
    // fired when a subtitle fragment has been processed - data: { success : boolean, frag : the processed frag }
    Events["SUBTITLE_FRAG_PROCESSED"] = "hlsSubtitleFragProcessed";
    // fired when a set of VTTCues to be managed externally has been parsed - data: { type: string, track: string, cues: [ VTTCue ] }
    Events["CUES_PARSED"] = "hlsCuesParsed";
    // fired when a text track to be managed externally is found - data: { tracks: [ { label: string, kind: string, default: boolean } ] }
    Events["NON_NATIVE_TEXT_TRACKS_FOUND"] = "hlsNonNativeTextTracksFound";
    // fired when the first timestamp is found - data: { id : demuxer id, initPTS: initPTS, timescale: timescale, frag : fragment object }
    Events["INIT_PTS_FOUND"] = "hlsInitPtsFound";
    // fired when a fragment loading starts - data: { frag : fragment object }
    Events["FRAG_LOADING"] = "hlsFragLoading";
    // fired when a fragment loading is progressing - data: { frag : fragment object, { trequest, tfirst, loaded } }
    // FRAG_LOAD_PROGRESS = 'hlsFragLoadProgress',
    // Identifier for fragment load aborting for emergency switch down - data: { frag : fragment object }
    Events["FRAG_LOAD_EMERGENCY_ABORTED"] = "hlsFragLoadEmergencyAborted";
    // fired when a fragment loading is completed - data: { frag : fragment object, payload : fragment payload, stats : LoaderStats }
    Events["FRAG_LOADED"] = "hlsFragLoaded";
    // fired when a fragment has finished decrypting - data: { id : demuxer id, frag: fragment object, payload : fragment payload, stats : { tstart, tdecrypt } }
    Events["FRAG_DECRYPTED"] = "hlsFragDecrypted";
    // fired when Init Segment has been extracted from fragment - data: { id : demuxer id, frag: fragment object, moov : moov MP4 box, codecs : codecs found while parsing fragment }
    Events["FRAG_PARSING_INIT_SEGMENT"] = "hlsFragParsingInitSegment";
    // fired when parsing sei text is completed - data: { id : demuxer id, frag: fragment object, samples : [ sei samples pes ] }
    Events["FRAG_PARSING_USERDATA"] = "hlsFragParsingUserdata";
    // fired when parsing id3 is completed - data: { id : demuxer id, frag: fragment object, samples : [ id3 samples pes ] }
    Events["FRAG_PARSING_METADATA"] = "hlsFragParsingMetadata";
    // fired when data have been extracted from fragment - data: { id : demuxer id, frag: fragment object, data1 : moof MP4 box or TS fragments, data2 : mdat MP4 box or null}
    // FRAG_PARSING_DATA = 'hlsFragParsingData',
    // fired when fragment parsing is completed - data: { id : demuxer id, frag: fragment object }
    Events["FRAG_PARSED"] = "hlsFragParsed";
    // fired when fragment remuxed MP4 boxes have all been appended into SourceBuffer - data: { id : demuxer id, frag : fragment object, stats : LoaderStats }
    Events["FRAG_BUFFERED"] = "hlsFragBuffered";
    // fired when fragment matching with current media position is changing - data : { id : demuxer id, frag : fragment object }
    Events["FRAG_CHANGED"] = "hlsFragChanged";
    // Identifier for a FPS drop event - data: { currentDropped, currentDecoded, totalDroppedFrames }
    Events["FPS_DROP"] = "hlsFpsDrop";
    // triggered when FPS drop triggers auto level capping - data: { level, droppedLevel }
    Events["FPS_DROP_LEVEL_CAPPING"] = "hlsFpsDropLevelCapping";
    // triggered when maxAutoLevel changes - data { autoLevelCapping, levels, maxAutoLevel, minAutoLevel, maxHdcpLevel }
    Events["MAX_AUTO_LEVEL_UPDATED"] = "hlsMaxAutoLevelUpdated";
    // Identifier for an error event - data: { type : error type, details : error details, fatal : if true, hls.js cannot/will not try to recover, if false, hls.js will try to recover,other error specific data }
    Events["ERROR"] = "hlsError";
    // fired when hls.js instance starts destroying. Different from MEDIA_DETACHED as one could want to detach and reattach a media to the instance of hls.js to handle mid-rolls for example - data: { }
    Events["DESTROYING"] = "hlsDestroying";
    // fired when a decrypt key loading starts - data: { frag : fragment object }
    Events["KEY_LOADING"] = "hlsKeyLoading";
    // fired when a decrypt key loading is completed - data: { frag : fragment object, keyInfo : KeyLoaderInfo }
    Events["KEY_LOADED"] = "hlsKeyLoaded";
    // deprecated; please use BACK_BUFFER_REACHED - data : { bufferEnd: number }
    Events["LIVE_BACK_BUFFER_REACHED"] = "hlsLiveBackBufferReached";
    // fired when the back buffer is reached as defined by the backBufferLength config option - data : { bufferEnd: number }
    Events["BACK_BUFFER_REACHED"] = "hlsBackBufferReached";
    // fired after steering manifest has been loaded - data: { steeringManifest: SteeringManifest object, url: steering manifest URL }
    Events["STEERING_MANIFEST_LOADED"] = "hlsSteeringManifestLoaded";
    // fired when asset list has begun loading
    Events["ASSET_LIST_LOADING"] = "hlsAssetListLoading";
    // fired when a valid asset list is loaded
    Events["ASSET_LIST_LOADED"] = "hlsAssetListLoaded";
    // fired when the list of Interstitial Events and Interstitial Schedule is updated
    Events["INTERSTITIALS_UPDATED"] = "hlsInterstitialsUpdated";
    // fired when the buffer reaches an Interstitial Schedule boundary (both Primary segments and Interstitial Assets)
    Events["INTERSTITIALS_BUFFERED_TO_BOUNDARY"] = "hlsInterstitialsBufferedToBoundary";
    // fired when a player instance for an Interstitial Asset has been created
    Events["INTERSTITIAL_ASSET_PLAYER_CREATED"] = "hlsInterstitialAssetPlayerCreated";
    // Interstitial playback started
    Events["INTERSTITIAL_STARTED"] = "hlsInterstitialStarted";
    // InterstitialAsset playback started
    Events["INTERSTITIAL_ASSET_STARTED"] = "hlsInterstitialAssetStarted";
    // InterstitialAsset playback ended
    Events["INTERSTITIAL_ASSET_ENDED"] = "hlsInterstitialAssetEnded";
    // InterstitialAsset playback errored
    Events["INTERSTITIAL_ASSET_ERROR"] = "hlsInterstitialAssetError";
    // Interstitial playback ended
    Events["INTERSTITIAL_ENDED"] = "hlsInterstitialEnded";
    // Interstitial schedule resumed primary playback
    Events["INTERSTITIALS_PRIMARY_RESUMED"] = "hlsInterstitialsPrimaryResumed";
    // Interstitial players dispatch this event when playout limit is reached
    Events["PLAYOUT_LIMIT_REACHED"] = "hlsPlayoutLimitReached";
    // Event DateRange cue "enter" event dispatched
    Events["EVENT_CUE_ENTER"] = "hlsEventCueEnter";
    return Events;
}({});
/**
 * Defines each Event type and payload by Event name. Used in {@link hls.js#HlsEventEmitter} to strongly type the event listener API.
 */ var $b941786f4eb9cb76$var$PlaylistContextType = {
    MANIFEST: "manifest",
    LEVEL: "level",
    AUDIO_TRACK: "audioTrack",
    SUBTITLE_TRACK: "subtitleTrack"
};
var $b941786f4eb9cb76$export$e15fb1a9320a1882 = {
    MAIN: "main",
    AUDIO: "audio",
    SUBTITLE: "subtitle"
};
/*
 * compute an Exponential Weighted moving average
 * - https://en.wikipedia.org/wiki/Moving_average#Exponential_moving_average
 *  - heavily inspired from shaka-player
 */ class $b941786f4eb9cb76$var$EWMA {
    //  About half of the estimated value will be from the last |halfLife| samples by weight.
    constructor(halfLife, estimate = 0, weight = 0){
        this.halfLife = void 0;
        this.alpha_ = void 0;
        this.estimate_ = void 0;
        this.totalWeight_ = void 0;
        this.halfLife = halfLife;
        // Larger values of alpha expire historical data more slowly.
        this.alpha_ = halfLife ? Math.exp(Math.log(0.5) / halfLife) : 0;
        this.estimate_ = estimate;
        this.totalWeight_ = weight;
    }
    sample(weight, value) {
        const adjAlpha = Math.pow(this.alpha_, weight);
        this.estimate_ = value * (1 - adjAlpha) + adjAlpha * this.estimate_;
        this.totalWeight_ += weight;
    }
    getTotalWeight() {
        return this.totalWeight_;
    }
    getEstimate() {
        if (this.alpha_) {
            const zeroFactor = 1 - Math.pow(this.alpha_, this.totalWeight_);
            if (zeroFactor) return this.estimate_ / zeroFactor;
        }
        return this.estimate_;
    }
}
/*
 * EWMA Bandwidth Estimator
 *  - heavily inspired from shaka-player
 * Tracks bandwidth samples and estimates available bandwidth.
 * Based on the minimum of two exponentially-weighted moving averages with
 * different half-lives.
 */ class $b941786f4eb9cb76$var$EwmaBandWidthEstimator {
    constructor(slow, fast, defaultEstimate, defaultTTFB = 100){
        this.defaultEstimate_ = void 0;
        this.minWeight_ = void 0;
        this.minDelayMs_ = void 0;
        this.slow_ = void 0;
        this.fast_ = void 0;
        this.defaultTTFB_ = void 0;
        this.ttfb_ = void 0;
        this.defaultEstimate_ = defaultEstimate;
        this.minWeight_ = 0.001;
        this.minDelayMs_ = 50;
        this.slow_ = new $b941786f4eb9cb76$var$EWMA(slow);
        this.fast_ = new $b941786f4eb9cb76$var$EWMA(fast);
        this.defaultTTFB_ = defaultTTFB;
        this.ttfb_ = new $b941786f4eb9cb76$var$EWMA(slow);
    }
    update(slow, fast) {
        const { slow_: slow_, fast_: fast_, ttfb_: ttfb_ } = this;
        if (slow_.halfLife !== slow) this.slow_ = new $b941786f4eb9cb76$var$EWMA(slow, slow_.getEstimate(), slow_.getTotalWeight());
        if (fast_.halfLife !== fast) this.fast_ = new $b941786f4eb9cb76$var$EWMA(fast, fast_.getEstimate(), fast_.getTotalWeight());
        if (ttfb_.halfLife !== slow) this.ttfb_ = new $b941786f4eb9cb76$var$EWMA(slow, ttfb_.getEstimate(), ttfb_.getTotalWeight());
    }
    sample(durationMs, numBytes) {
        durationMs = Math.max(durationMs, this.minDelayMs_);
        const numBits = 8 * numBytes;
        // weight is duration in seconds
        const durationS = durationMs / 1000;
        // value is bandwidth in bits/s
        const bandwidthInBps = numBits / durationS;
        this.fast_.sample(durationS, bandwidthInBps);
        this.slow_.sample(durationS, bandwidthInBps);
    }
    sampleTTFB(ttfb) {
        // weight is frequency curve applied to TTFB in seconds
        // (longer times have less weight with expected input under 1 second)
        const seconds = ttfb / 1000;
        const weight = Math.sqrt(2) * Math.exp(-Math.pow(seconds, 2) / 2);
        this.ttfb_.sample(weight, Math.max(ttfb, 5));
    }
    canEstimate() {
        return this.fast_.getTotalWeight() >= this.minWeight_;
    }
    getEstimate() {
        if (this.canEstimate()) // console.log('slow estimate:'+ Math.round(this.slow_.getEstimate()));
        // console.log('fast estimate:'+ Math.round(this.fast_.getEstimate()));
        // Take the minimum of these two estimates.  This should have the effect of
        // adapting down quickly, but up more slowly.
        return Math.min(this.fast_.getEstimate(), this.slow_.getEstimate());
        else return this.defaultEstimate_;
    }
    getEstimateTTFB() {
        if (this.ttfb_.getTotalWeight() >= this.minWeight_) return this.ttfb_.getEstimate();
        else return this.defaultTTFB_;
    }
    get defaultEstimate() {
        return this.defaultEstimate_;
    }
    destroy() {}
}
function $b941786f4eb9cb76$var$_defineProperty(e, r, t) {
    return (r = $b941786f4eb9cb76$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $b941786f4eb9cb76$var$_extends() {
    return $b941786f4eb9cb76$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $b941786f4eb9cb76$var$_extends.apply(null, arguments);
}
function $b941786f4eb9cb76$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b941786f4eb9cb76$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b941786f4eb9cb76$var$ownKeys(Object(t), true).forEach(function(r) {
            $b941786f4eb9cb76$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b941786f4eb9cb76$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b941786f4eb9cb76$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b941786f4eb9cb76$var$_toPropertyKey(t) {
    var i = $b941786f4eb9cb76$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
class $b941786f4eb9cb76$var$Logger {
    constructor(label, logger){
        this.trace = void 0;
        this.debug = void 0;
        this.log = void 0;
        this.warn = void 0;
        this.info = void 0;
        this.error = void 0;
        const lb = `[${label}]:`;
        this.trace = $b941786f4eb9cb76$var$noop;
        this.debug = logger.debug.bind(null, lb);
        this.log = logger.log.bind(null, lb);
        this.warn = logger.warn.bind(null, lb);
        this.info = logger.info.bind(null, lb);
        this.error = logger.error.bind(null, lb);
    }
}
const $b941786f4eb9cb76$var$noop = function noop() {};
const $b941786f4eb9cb76$var$fakeLogger = {
    trace: $b941786f4eb9cb76$var$noop,
    debug: $b941786f4eb9cb76$var$noop,
    log: $b941786f4eb9cb76$var$noop,
    warn: $b941786f4eb9cb76$var$noop,
    info: $b941786f4eb9cb76$var$noop,
    error: $b941786f4eb9cb76$var$noop
};
function $b941786f4eb9cb76$var$createLogger() {
    return $b941786f4eb9cb76$var$_extends({}, $b941786f4eb9cb76$var$fakeLogger);
}
// let lastCallTime;
// function formatMsgWithTimeInfo(type, msg) {
//   const now = Date.now();
//   const diff = lastCallTime ? '+' + (now - lastCallTime) : '0';
//   lastCallTime = now;
//   msg = (new Date(now)).toISOString() + ' | [' +  type + '] > ' + msg + ' ( ' + diff + ' ms )';
//   return msg;
// }
function $b941786f4eb9cb76$var$consolePrintFn(type, id) {
    const func = self.console[type];
    return func ? func.bind(self.console, `${id ? '[' + id + '] ' : ''}[${type}] >`) : $b941786f4eb9cb76$var$noop;
}
function $b941786f4eb9cb76$var$getLoggerFn(key, debugConfig, id) {
    return debugConfig[key] ? debugConfig[key].bind(debugConfig) : $b941786f4eb9cb76$var$consolePrintFn(key, id);
}
const $b941786f4eb9cb76$var$exportedLogger = $b941786f4eb9cb76$var$createLogger();
function $b941786f4eb9cb76$var$enableLogs(debugConfig, context, id) {
    // check that console is available
    const newLogger = $b941786f4eb9cb76$var$createLogger();
    if (typeof console === 'object' && debugConfig === true || typeof debugConfig === 'object') {
        const keys = [
            // Remove out from list here to hard-disable a log-level
            // 'trace',
            'debug',
            'log',
            'info',
            'warn',
            'error'
        ];
        keys.forEach((key)=>{
            newLogger[key] = $b941786f4eb9cb76$var$getLoggerFn(key, debugConfig, id);
        });
        // Some browsers don't allow to use bind on console object anyway
        // fallback to default if needed
        try {
            newLogger.log(`Debug logs enabled for "${context}" in hls.js version ${"1.6.15"}`);
        } catch (e) {
            /* log fn threw an exception. All logger methods are no-ops. */ return $b941786f4eb9cb76$var$createLogger();
        }
        // global exported logger uses the same functions as new logger without `id`
        keys.forEach((key)=>{
            $b941786f4eb9cb76$var$exportedLogger[key] = $b941786f4eb9cb76$var$getLoggerFn(key, debugConfig);
        });
    } else // Reset global exported logger
    $b941786f4eb9cb76$var$_extends($b941786f4eb9cb76$var$exportedLogger, newLogger);
    return newLogger;
}
const $b941786f4eb9cb76$var$logger = $b941786f4eb9cb76$var$exportedLogger;
function $b941786f4eb9cb76$export$a92854129bc50f89(preferManagedMediaSource = true) {
    if (typeof self === 'undefined') return undefined;
    const mms = (preferManagedMediaSource || !self.MediaSource) && self.ManagedMediaSource;
    return mms || self.MediaSource || self.WebKitMediaSource;
}
function $b941786f4eb9cb76$var$isManagedMediaSource(source) {
    return typeof self !== 'undefined' && source === self.ManagedMediaSource;
}
function $b941786f4eb9cb76$var$isCompatibleTrackChange(currentTracks, requiredTracks) {
    const trackNames = Object.keys(currentTracks);
    const requiredTrackNames = Object.keys(requiredTracks);
    const trackCount = trackNames.length;
    const requiredTrackCount = requiredTrackNames.length;
    return !trackCount || !requiredTrackCount || trackCount === requiredTrackCount && !trackNames.some((name)=>requiredTrackNames.indexOf(name) === -1);
}
// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */ /**
 * Converts a UTF-8 array to a string.
 *
 * @param array - The UTF-8 array to convert
 *
 * @returns The string
 *
 * @group Utils
 *
 * @beta
 */ function $b941786f4eb9cb76$var$utf8ArrayToStr(array, exitOnNull = false) {
    if (typeof TextDecoder !== 'undefined') {
        const decoder = new TextDecoder('utf-8');
        const decoded = decoder.decode(array);
        if (exitOnNull) {
            // grab up to the first null
            const idx = decoded.indexOf('\0');
            return idx !== -1 ? decoded.substring(0, idx) : decoded;
        }
        // remove any null characters
        return decoded.replace(/\0/g, '');
    }
    const len = array.length;
    let c;
    let char2;
    let char3;
    let out = '';
    let i = 0;
    while(i < len){
        c = array[i++];
        if (c === 0x00 && exitOnNull) return out;
        else if (c === 0x00 || c === 0x03) continue;
        switch(c >> 4){
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
                // 0xxxxxxx
                out += String.fromCharCode(c);
                break;
            case 12:
            case 13:
                // 110x xxxx   10xx xxxx
                char2 = array[i++];
                out += String.fromCharCode((c & 0x1f) << 6 | char2 & 0x3f);
                break;
            case 14:
                // 1110 xxxx  10xx xxxx  10xx xxxx
                char2 = array[i++];
                char3 = array[i++];
                out += String.fromCharCode((c & 0x0f) << 12 | (char2 & 0x3f) << 6 | (char3 & 0x3f) << 0);
                break;
        }
    }
    return out;
}
/**
 *  hex dump helper class
 */ function $b941786f4eb9cb76$var$arrayToHex(array) {
    let str = '';
    for(let i = 0; i < array.length; i++){
        let h = array[i].toString(16);
        if (h.length < 2) h = '0' + h;
        str += h;
    }
    return str;
}
function $b941786f4eb9cb76$var$hexToArrayBuffer(str) {
    return Uint8Array.from(str.replace(/^0x/, '').replace(/([\da-fA-F]{2}) ?/g, '0x$1 ').replace(/ +$/, '').split(' ')).buffer;
}
function $b941786f4eb9cb76$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}
var $b941786f4eb9cb76$var$urlToolkit = {
    exports: {}
};
var $b941786f4eb9cb76$var$hasRequiredUrlToolkit;
function $b941786f4eb9cb76$var$requireUrlToolkit() {
    if ($b941786f4eb9cb76$var$hasRequiredUrlToolkit) return $b941786f4eb9cb76$var$urlToolkit.exports;
    $b941786f4eb9cb76$var$hasRequiredUrlToolkit = 1;
    (function(module, exports) {
        // see https://tools.ietf.org/html/rfc1808
        (function(root) {
            var URL_REGEX = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/;
            var FIRST_SEGMENT_REGEX = /^(?=([^\/?#]*))\1([^]*)$/;
            var SLASH_DOT_REGEX = /(?:\/|^)\.(?=\/)/g;
            var SLASH_DOT_DOT_REGEX = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g;
            var URLToolkit = {
                // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
                // E.g
                // With opts.alwaysNormalize = false (default, spec compliant)
                // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
                // With opts.alwaysNormalize = true (not spec compliant)
                // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
                buildAbsoluteURL: function(baseURL, relativeURL, opts) {
                    opts = opts || {};
                    // remove any remaining space and CRLF
                    baseURL = baseURL.trim();
                    relativeURL = relativeURL.trim();
                    if (!relativeURL) {
                        // 2a) If the embedded URL is entirely empty, it inherits the
                        // entire base URL (i.e., is set equal to the base URL)
                        // and we are done.
                        if (!opts.alwaysNormalize) return baseURL;
                        var basePartsForNormalise = URLToolkit.parseURL(baseURL);
                        if (!basePartsForNormalise) throw new Error('Error trying to parse base URL.');
                        basePartsForNormalise.path = URLToolkit.normalizePath(basePartsForNormalise.path);
                        return URLToolkit.buildURLFromParts(basePartsForNormalise);
                    }
                    var relativeParts = URLToolkit.parseURL(relativeURL);
                    if (!relativeParts) throw new Error('Error trying to parse relative URL.');
                    if (relativeParts.scheme) {
                        // 2b) If the embedded URL starts with a scheme name, it is
                        // interpreted as an absolute URL and we are done.
                        if (!opts.alwaysNormalize) return relativeURL;
                        relativeParts.path = URLToolkit.normalizePath(relativeParts.path);
                        return URLToolkit.buildURLFromParts(relativeParts);
                    }
                    var baseParts = URLToolkit.parseURL(baseURL);
                    if (!baseParts) throw new Error('Error trying to parse base URL.');
                    if (!baseParts.netLoc && baseParts.path && baseParts.path[0] !== '/') {
                        // If netLoc missing and path doesn't start with '/', assume everthing before the first '/' is the netLoc
                        // This causes 'example.com/a' to be handled as '//example.com/a' instead of '/example.com/a'
                        var pathParts = FIRST_SEGMENT_REGEX.exec(baseParts.path);
                        baseParts.netLoc = pathParts[1];
                        baseParts.path = pathParts[2];
                    }
                    if (baseParts.netLoc && !baseParts.path) baseParts.path = '/';
                    var builtParts = {
                        // 2c) Otherwise, the embedded URL inherits the scheme of
                        // the base URL.
                        scheme: baseParts.scheme,
                        netLoc: relativeParts.netLoc,
                        path: null,
                        params: relativeParts.params,
                        query: relativeParts.query,
                        fragment: relativeParts.fragment
                    };
                    if (!relativeParts.netLoc) {
                        // 3) If the embedded URL's <net_loc> is non-empty, we skip to
                        // Step 7.  Otherwise, the embedded URL inherits the <net_loc>
                        // (if any) of the base URL.
                        builtParts.netLoc = baseParts.netLoc;
                        // 4) If the embedded URL path is preceded by a slash "/", the
                        // path is not relative and we skip to Step 7.
                        if (relativeParts.path[0] !== '/') {
                            if (!relativeParts.path) {
                                // 5) If the embedded URL path is empty (and not preceded by a
                                // slash), then the embedded URL inherits the base URL path
                                builtParts.path = baseParts.path;
                                // 5a) if the embedded URL's <params> is non-empty, we skip to
                                // step 7; otherwise, it inherits the <params> of the base
                                // URL (if any) and
                                if (!relativeParts.params) {
                                    builtParts.params = baseParts.params;
                                    // 5b) if the embedded URL's <query> is non-empty, we skip to
                                    // step 7; otherwise, it inherits the <query> of the base
                                    // URL (if any) and we skip to step 7.
                                    if (!relativeParts.query) builtParts.query = baseParts.query;
                                }
                            } else {
                                // 6) The last segment of the base URL's path (anything
                                // following the rightmost slash "/", or the entire path if no
                                // slash is present) is removed and the embedded URL's path is
                                // appended in its place.
                                var baseURLPath = baseParts.path;
                                var newPath = baseURLPath.substring(0, baseURLPath.lastIndexOf('/') + 1) + relativeParts.path;
                                builtParts.path = URLToolkit.normalizePath(newPath);
                            }
                        }
                    }
                    if (builtParts.path === null) builtParts.path = opts.alwaysNormalize ? URLToolkit.normalizePath(relativeParts.path) : relativeParts.path;
                    return URLToolkit.buildURLFromParts(builtParts);
                },
                parseURL: function(url) {
                    var parts = URL_REGEX.exec(url);
                    if (!parts) return null;
                    return {
                        scheme: parts[1] || '',
                        netLoc: parts[2] || '',
                        path: parts[3] || '',
                        params: parts[4] || '',
                        query: parts[5] || '',
                        fragment: parts[6] || ''
                    };
                },
                normalizePath: function(path) {
                    // The following operations are
                    // then applied, in order, to the new path:
                    // 6a) All occurrences of "./", where "." is a complete path
                    // segment, are removed.
                    // 6b) If the path ends with "." as a complete path segment,
                    // that "." is removed.
                    path = path.split('').reverse().join('').replace(SLASH_DOT_REGEX, '');
                    // 6c) All occurrences of "<segment>/../", where <segment> is a
                    // complete path segment not equal to "..", are removed.
                    // Removal of these path segments is performed iteratively,
                    // removing the leftmost matching pattern on each iteration,
                    // until no matching pattern remains.
                    // 6d) If the path ends with "<segment>/..", where <segment> is a
                    // complete path segment not equal to "..", that
                    // "<segment>/.." is removed.
                    while(path.length !== (path = path.replace(SLASH_DOT_DOT_REGEX, '')).length);
                    return path.split('').reverse().join('');
                },
                buildURLFromParts: function(parts) {
                    return parts.scheme + parts.netLoc + parts.path + parts.params + parts.query + parts.fragment;
                }
            };
            module.exports = URLToolkit;
        })();
    })($b941786f4eb9cb76$var$urlToolkit);
    return $b941786f4eb9cb76$var$urlToolkit.exports;
}
var $b941786f4eb9cb76$var$urlToolkitExports = $b941786f4eb9cb76$var$requireUrlToolkit();
class $b941786f4eb9cb76$export$792da06d301cf8fe {
    constructor(){
        this.aborted = false;
        this.loaded = 0;
        this.retry = 0;
        this.total = 0;
        this.chunkCount = 0;
        this.bwEstimate = 0;
        this.loading = {
            start: 0,
            first: 0,
            end: 0
        };
        this.parsing = {
            start: 0,
            end: 0
        };
        this.buffering = {
            start: 0,
            first: 0,
            end: 0
        };
    }
}
var $b941786f4eb9cb76$var$ElementaryStreamTypes = {
    AUDIO: "audio",
    VIDEO: "video",
    AUDIOVIDEO: "audiovideo"
};
class $b941786f4eb9cb76$export$dbfafecac5663ca {
    constructor(base){
        this._byteRange = null;
        this._url = null;
        this._stats = null;
        this._streams = null;
        // baseurl is the URL to the playlist
        this.base = void 0;
        // relurl is the portion of the URL that comes from inside the playlist.
        this.relurl = void 0;
        if (typeof base === 'string') base = {
            url: base
        };
        this.base = base;
        $b941786f4eb9cb76$var$makeEnumerable(this, 'stats');
    }
    // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
    setByteRange(value, previous) {
        const params = value.split('@', 2);
        let start;
        if (params.length === 1) start = (previous == null ? void 0 : previous.byteRangeEndOffset) || 0;
        else start = parseInt(params[1]);
        this._byteRange = [
            start,
            parseInt(params[0]) + start
        ];
    }
    get baseurl() {
        return this.base.url;
    }
    get byteRange() {
        if (this._byteRange === null) return [];
        return this._byteRange;
    }
    get byteRangeStartOffset() {
        return this.byteRange[0];
    }
    get byteRangeEndOffset() {
        return this.byteRange[1];
    }
    get elementaryStreams() {
        if (this._streams === null) this._streams = {
            [$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO]: null,
            [$b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO]: null,
            [$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIOVIDEO]: null
        };
        return this._streams;
    }
    set elementaryStreams(value) {
        this._streams = value;
    }
    get hasStats() {
        return this._stats !== null;
    }
    get hasStreams() {
        return this._streams !== null;
    }
    get stats() {
        if (this._stats === null) this._stats = new $b941786f4eb9cb76$export$792da06d301cf8fe();
        return this._stats;
    }
    set stats(value) {
        this._stats = value;
    }
    get url() {
        if (!this._url && this.baseurl && this.relurl) this._url = $b941786f4eb9cb76$var$urlToolkitExports.buildAbsoluteURL(this.baseurl, this.relurl, {
            alwaysNormalize: true
        });
        return this._url || '';
    }
    set url(value) {
        this._url = value;
    }
    clearElementaryStreamInfo() {
        const { elementaryStreams: elementaryStreams } = this;
        elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO] = null;
        elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO] = null;
        elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIOVIDEO] = null;
    }
}
function $b941786f4eb9cb76$var$isMediaFragment(frag) {
    return frag.sn !== 'initSegment';
}
/**
 * Object representing parsed data from an HLS Segment. Found in {@link hls.js#LevelDetails.fragments}.
 */ class $b941786f4eb9cb76$export$ffb0004e005737fa extends $b941786f4eb9cb76$export$dbfafecac5663ca {
    constructor(type, base){
        super(base);
        this._decryptdata = null;
        this._programDateTime = null;
        this._ref = null;
        // Approximate bit rate of the fragment expressed in bits per second (bps) as indicated by the last EXT-X-BITRATE (kbps) tag
        this._bitrate = void 0;
        this.rawProgramDateTime = null;
        this.tagList = [];
        // EXTINF has to be present for a m3u8 to be considered valid
        this.duration = 0;
        // sn notates the sequence number for a segment, and if set to a string can be 'initSegment'
        this.sn = 0;
        // levelkeys are the EXT-X-KEY tags that apply to this segment for decryption
        // core difference from the private field _decryptdata is the lack of the initialized IV
        // _decryptdata will set the IV for this segment based on the segment number in the fragment
        this.levelkeys = void 0;
        // A string representing the fragment type
        this.type = void 0;
        // A reference to the loader. Set while the fragment is loading, and removed afterwards. Used to abort fragment loading
        this.loader = null;
        // A reference to the key loader. Set while the key is loading, and removed afterwards. Used to abort key loading
        this.keyLoader = null;
        // The level/track index to which the fragment belongs
        this.level = -1;
        // The continuity counter of the fragment
        this.cc = 0;
        // The starting Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
        this.startPTS = void 0;
        // The ending Presentation Time Stamp (PTS) of the fragment. Set after transmux complete.
        this.endPTS = void 0;
        // The starting Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
        this.startDTS = void 0;
        // The ending Decode Time Stamp (DTS) of the fragment. Set after transmux complete.
        this.endDTS = void 0;
        // The start time of the fragment, as listed in the manifest. Updated after transmux complete.
        this.start = 0;
        // The offset time (seconds) of the fragment from the start of the Playlist
        this.playlistOffset = 0;
        // Set by `updateFragPTSDTS` in level-helper
        this.deltaPTS = void 0;
        // The maximum starting Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
        this.maxStartPTS = void 0;
        // The minimum ending Presentation Time Stamp (audio/video PTS) of the fragment. Set after transmux complete.
        this.minEndPTS = void 0;
        // Init Segment bytes (unset for media segments)
        this.data = void 0;
        // A flag indicating whether the segment was downloaded in order to test bitrate, and was not buffered
        this.bitrateTest = false;
        // #EXTINF  segment title
        this.title = null;
        // The Media Initialization Section for this segment
        this.initSegment = null;
        // Fragment is the last fragment in the media playlist
        this.endList = void 0;
        // Fragment is marked by an EXT-X-GAP tag indicating that it does not contain media data and should not be loaded
        this.gap = void 0;
        // Deprecated
        this.urlId = 0;
        this.type = type;
    }
    get byteLength() {
        if (this.hasStats) {
            const total = this.stats.total;
            if (total) return total;
        }
        if (this.byteRange.length) {
            const start = this.byteRange[0];
            const end = this.byteRange[1];
            if ($b941786f4eb9cb76$var$isFiniteNumber(start) && $b941786f4eb9cb76$var$isFiniteNumber(end)) return end - start;
        }
        return null;
    }
    get bitrate() {
        if (this.byteLength) return this.byteLength * 8 / this.duration;
        if (this._bitrate) return this._bitrate;
        return null;
    }
    set bitrate(value) {
        this._bitrate = value;
    }
    get decryptdata() {
        var _this$_decryptdata;
        const { levelkeys: levelkeys } = this;
        if (!levelkeys || levelkeys.NONE) return null;
        if (levelkeys.identity) {
            if (!this._decryptdata) this._decryptdata = levelkeys.identity.getDecryptData(this.sn);
        } else if (!((_this$_decryptdata = this._decryptdata) != null && _this$_decryptdata.keyId)) {
            const keyFormats = Object.keys(levelkeys);
            if (keyFormats.length === 1) {
                const levelKey = this._decryptdata = levelkeys[keyFormats[0]] || null;
                if (levelKey) this._decryptdata = levelKey.getDecryptData(this.sn, levelkeys);
            }
        }
        return this._decryptdata;
    }
    get end() {
        return this.start + this.duration;
    }
    get endProgramDateTime() {
        if (this.programDateTime === null) return null;
        const duration = !$b941786f4eb9cb76$var$isFiniteNumber(this.duration) ? 0 : this.duration;
        return this.programDateTime + duration * 1000;
    }
    get encrypted() {
        var _this$_decryptdata2;
        // At the m3u8-parser level we need to add support for manifest signalled keyformats
        // when we want the fragment to start reporting that it is encrypted.
        // Currently, keyFormat will only be set for identity keys
        if ((_this$_decryptdata2 = this._decryptdata) != null && _this$_decryptdata2.encrypted) return true;
        else if (this.levelkeys) {
            var _this$levelkeys$keyFo;
            const keyFormats = Object.keys(this.levelkeys);
            const len = keyFormats.length;
            if (len > 1 || len === 1 && (_this$levelkeys$keyFo = this.levelkeys[keyFormats[0]]) != null && _this$levelkeys$keyFo.encrypted) return true;
        }
        return false;
    }
    get programDateTime() {
        if (this._programDateTime === null && this.rawProgramDateTime) this.programDateTime = Date.parse(this.rawProgramDateTime);
        return this._programDateTime;
    }
    set programDateTime(value) {
        if (!$b941786f4eb9cb76$var$isFiniteNumber(value)) {
            this._programDateTime = this.rawProgramDateTime = null;
            return;
        }
        this._programDateTime = value;
    }
    get ref() {
        if (!$b941786f4eb9cb76$var$isMediaFragment(this)) return null;
        if (!this._ref) this._ref = {
            base: this.base,
            start: this.start,
            duration: this.duration,
            sn: this.sn,
            programDateTime: this.programDateTime
        };
        return this._ref;
    }
    addStart(value) {
        this.setStart(this.start + value);
    }
    setStart(value) {
        this.start = value;
        if (this._ref) this._ref.start = value;
    }
    setDuration(value) {
        this.duration = value;
        if (this._ref) this._ref.duration = value;
    }
    setKeyFormat(keyFormat) {
        const levelkeys = this.levelkeys;
        if (levelkeys) {
            var _this$_decryptdata3;
            const key = levelkeys[keyFormat];
            if (key && !((_this$_decryptdata3 = this._decryptdata) != null && _this$_decryptdata3.keyId)) this._decryptdata = key.getDecryptData(this.sn, levelkeys);
        }
    }
    abortRequests() {
        var _this$loader, _this$keyLoader;
        (_this$loader = this.loader) == null || _this$loader.abort();
        (_this$keyLoader = this.keyLoader) == null || _this$keyLoader.abort();
    }
    setElementaryStreamInfo(type, startPTS, endPTS, startDTS, endDTS, partial = false) {
        const { elementaryStreams: elementaryStreams } = this;
        const info = elementaryStreams[type];
        if (!info) {
            elementaryStreams[type] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS,
                partial: partial
            };
            return;
        }
        info.startPTS = Math.min(info.startPTS, startPTS);
        info.endPTS = Math.max(info.endPTS, endPTS);
        info.startDTS = Math.min(info.startDTS, startDTS);
        info.endDTS = Math.max(info.endDTS, endDTS);
    }
}
/**
 * Object representing parsed data from an HLS Partial Segment. Found in {@link hls.js#LevelDetails.partList}.
 */ class $b941786f4eb9cb76$export$7b5bf7981d51054e extends $b941786f4eb9cb76$export$dbfafecac5663ca {
    constructor(partAttrs, frag, base, index, previous){
        super(base);
        this.fragOffset = 0;
        this.duration = 0;
        this.gap = false;
        this.independent = false;
        this.relurl = void 0;
        this.fragment = void 0;
        this.index = void 0;
        this.duration = partAttrs.decimalFloatingPoint('DURATION');
        this.gap = partAttrs.bool('GAP');
        this.independent = partAttrs.bool('INDEPENDENT');
        this.relurl = partAttrs.enumeratedString('URI');
        this.fragment = frag;
        this.index = index;
        const byteRange = partAttrs.enumeratedString('BYTERANGE');
        if (byteRange) this.setByteRange(byteRange, previous);
        if (previous) this.fragOffset = previous.fragOffset + previous.duration;
    }
    get start() {
        return this.fragment.start + this.fragOffset;
    }
    get end() {
        return this.start + this.duration;
    }
    get loaded() {
        const { elementaryStreams: elementaryStreams } = this;
        return !!(elementaryStreams.audio || elementaryStreams.video || elementaryStreams.audiovideo);
    }
}
function $b941786f4eb9cb76$var$getOwnPropertyDescriptorFromPrototypeChain(object, property) {
    const prototype = Object.getPrototypeOf(object);
    if (prototype) {
        const propertyDescriptor = Object.getOwnPropertyDescriptor(prototype, property);
        if (propertyDescriptor) return propertyDescriptor;
        return $b941786f4eb9cb76$var$getOwnPropertyDescriptorFromPrototypeChain(prototype, property);
    }
}
function $b941786f4eb9cb76$var$makeEnumerable(object, property) {
    const d = $b941786f4eb9cb76$var$getOwnPropertyDescriptorFromPrototypeChain(object, property);
    if (d) {
        d.enumerable = true;
        Object.defineProperty(object, property, d);
    }
}
const $b941786f4eb9cb76$var$UINT32_MAX$1 = Math.pow(2, 32) - 1;
const $b941786f4eb9cb76$var$push = [].push;
// We are using fixed track IDs for driving the MP4 remuxer
// instead of following the TS PIDs.
// There is no reason not to do this and some browsers/SourceBuffer-demuxers
// may not like if there are TrackID "switches"
// See https://github.com/video-dev/hls.js/issues/1331
// Here we are mapping our internal track types to constant MP4 track IDs
// With MSE currently one can only have one track of each, and we are muxing
// whatever video/audio rendition in them.
const $b941786f4eb9cb76$var$RemuxerTrackIdConfig = {
    video: 1,
    audio: 2,
    id3: 3,
    text: 4
};
function $b941786f4eb9cb76$var$bin2str(data) {
    return String.fromCharCode.apply(null, data);
}
function $b941786f4eb9cb76$var$readUint16(buffer, offset) {
    const val = buffer[offset] << 8 | buffer[offset + 1];
    return val < 0 ? 65536 + val : val;
}
function $b941786f4eb9cb76$var$readUint32(buffer, offset) {
    const val = $b941786f4eb9cb76$var$readSint32(buffer, offset);
    return val < 0 ? 4294967296 + val : val;
}
function $b941786f4eb9cb76$var$readUint64(buffer, offset) {
    let result = $b941786f4eb9cb76$var$readUint32(buffer, offset);
    result *= Math.pow(2, 32);
    result += $b941786f4eb9cb76$var$readUint32(buffer, offset + 4);
    return result;
}
function $b941786f4eb9cb76$var$readSint32(buffer, offset) {
    return buffer[offset] << 24 | buffer[offset + 1] << 16 | buffer[offset + 2] << 8 | buffer[offset + 3];
}
// Find "moof" box
function $b941786f4eb9cb76$var$hasMoofData(data) {
    const end = data.byteLength;
    for(let i = 0; i < end;){
        const size = $b941786f4eb9cb76$var$readUint32(data, i);
        if (size > 8 && data[i + 4] === 0x6d && data[i + 5] === 0x6f && data[i + 6] === 0x6f && data[i + 7] === 0x66) return true;
        i = size > 1 ? i + size : end;
    }
    return false;
}
// Find the data for a box specified by its path
function $b941786f4eb9cb76$var$findBox(data, path) {
    const results = [];
    if (!path.length) // short-circuit the search for empty paths
    return results;
    const end = data.byteLength;
    for(let i = 0; i < end;){
        const size = $b941786f4eb9cb76$var$readUint32(data, i);
        const type = $b941786f4eb9cb76$var$bin2str(data.subarray(i + 4, i + 8));
        const endbox = size > 1 ? i + size : end;
        if (type === path[0]) {
            if (path.length === 1) // this is the end of the path and we've found the box we were
            // looking for
            results.push(data.subarray(i + 8, endbox));
            else {
                // recursively search for the next box along the path
                const subresults = $b941786f4eb9cb76$var$findBox(data.subarray(i + 8, endbox), path.slice(1));
                if (subresults.length) $b941786f4eb9cb76$var$push.apply(results, subresults);
            }
        }
        i = endbox;
    }
    // we've finished searching all of data
    return results;
}
function $b941786f4eb9cb76$var$parseSegmentIndex(sidx) {
    const references = [];
    const version = sidx[0];
    // set initial offset, we skip the reference ID (not needed)
    let index = 8;
    const timescale = $b941786f4eb9cb76$var$readUint32(sidx, index);
    index += 4;
    let earliestPresentationTime = 0;
    let firstOffset = 0;
    if (version === 0) {
        earliestPresentationTime = $b941786f4eb9cb76$var$readUint32(sidx, index);
        firstOffset = $b941786f4eb9cb76$var$readUint32(sidx, index + 4);
        index += 8;
    } else {
        earliestPresentationTime = $b941786f4eb9cb76$var$readUint64(sidx, index);
        firstOffset = $b941786f4eb9cb76$var$readUint64(sidx, index + 8);
        index += 16;
    }
    // skip reserved
    index += 2;
    let startByte = sidx.length + firstOffset;
    const referencesCount = $b941786f4eb9cb76$var$readUint16(sidx, index);
    index += 2;
    for(let i = 0; i < referencesCount; i++){
        let referenceIndex = index;
        const referenceInfo = $b941786f4eb9cb76$var$readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        const referenceSize = referenceInfo & 0x7fffffff;
        const referenceType = (referenceInfo & 0x80000000) >>> 31;
        if (referenceType === 1) {
            $b941786f4eb9cb76$var$logger.warn('SIDX has hierarchical references (not supported)');
            return null;
        }
        const subsegmentDuration = $b941786f4eb9cb76$var$readUint32(sidx, referenceIndex);
        referenceIndex += 4;
        references.push({
            referenceSize: referenceSize,
            subsegmentDuration: subsegmentDuration,
            // unscaled
            info: {
                duration: subsegmentDuration / timescale,
                start: startByte,
                end: startByte + referenceSize - 1
            }
        });
        startByte += referenceSize;
        // Skipping 1 bit for |startsWithSap|, 3 bits for |sapType|, and 28 bits
        // for |sapDelta|.
        referenceIndex += 4;
        // skip to next ref
        index = referenceIndex;
    }
    return {
        earliestPresentationTime: earliestPresentationTime,
        timescale: timescale,
        version: version,
        referencesCount: referencesCount,
        references: references
    };
}
/**
 * Parses an MP4 initialization segment and extracts stream type and
 * timescale values for any declared tracks. Timescale values indicate the
 * number of clock ticks per second to assume for time-based values
 * elsewhere in the MP4.
 *
 * To determine the start time of an MP4, you need two pieces of
 * information: the timescale unit and the earliest base media decode
 * time. Multiple timescales can be specified within an MP4 but the
 * base media decode time is always expressed in the timescale from
 * the media header box for the track:
 * ```
 * moov > trak > mdia > mdhd.timescale
 * moov > trak > mdia > hdlr
 * ```
 * @param initSegment the bytes of the init segment
 * @returns a hash of track type to timescale values or null if
 * the init segment is malformed.
 */ function $b941786f4eb9cb76$var$parseInitSegment(initSegment) {
    const result = [];
    const traks = $b941786f4eb9cb76$var$findBox(initSegment, [
        'moov',
        'trak'
    ]);
    for(let i = 0; i < traks.length; i++){
        const trak = traks[i];
        const tkhd = $b941786f4eb9cb76$var$findBox(trak, [
            'tkhd'
        ])[0];
        if (tkhd) {
            let version = tkhd[0];
            const trackId = $b941786f4eb9cb76$var$readUint32(tkhd, version === 0 ? 12 : 20);
            const mdhd = $b941786f4eb9cb76$var$findBox(trak, [
                'mdia',
                'mdhd'
            ])[0];
            if (mdhd) {
                version = mdhd[0];
                const timescale = $b941786f4eb9cb76$var$readUint32(mdhd, version === 0 ? 12 : 20);
                const hdlr = $b941786f4eb9cb76$var$findBox(trak, [
                    'mdia',
                    'hdlr'
                ])[0];
                if (hdlr) {
                    const hdlrType = $b941786f4eb9cb76$var$bin2str(hdlr.subarray(8, 12));
                    const type = {
                        soun: $b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO,
                        vide: $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO
                    }[hdlrType];
                    // Parse codec details
                    const stsdBox = $b941786f4eb9cb76$var$findBox(trak, [
                        'mdia',
                        'minf',
                        'stbl',
                        'stsd'
                    ])[0];
                    const stsd = $b941786f4eb9cb76$var$parseStsd(stsdBox);
                    if (type) {
                        // Add 'audio', 'video', and 'audiovideo' track records that will map to SourceBuffers
                        result[trackId] = {
                            timescale: timescale,
                            type: type,
                            stsd: stsd
                        };
                        result[type] = $b941786f4eb9cb76$var$_objectSpread2({
                            timescale: timescale,
                            id: trackId
                        }, stsd);
                    } else // Add 'meta' and other track records
                    result[trackId] = {
                        timescale: timescale,
                        type: hdlrType,
                        stsd: stsd
                    };
                }
            }
        }
    }
    const trex = $b941786f4eb9cb76$var$findBox(initSegment, [
        'moov',
        'mvex',
        'trex'
    ]);
    trex.forEach((trex)=>{
        const trackId = $b941786f4eb9cb76$var$readUint32(trex, 4);
        const track = result[trackId];
        if (track) track.default = {
            duration: $b941786f4eb9cb76$var$readUint32(trex, 12),
            flags: $b941786f4eb9cb76$var$readUint32(trex, 20)
        };
    });
    return result;
}
function $b941786f4eb9cb76$var$parseStsd(stsd) {
    const sampleEntries = stsd.subarray(8);
    const sampleEntriesEnd = sampleEntries.subarray(86);
    const fourCC = $b941786f4eb9cb76$var$bin2str(sampleEntries.subarray(4, 8));
    let codec = fourCC;
    let supplemental;
    const encrypted = fourCC === 'enca' || fourCC === 'encv';
    if (encrypted) {
        const encBox = $b941786f4eb9cb76$var$findBox(sampleEntries, [
            fourCC
        ])[0];
        const encBoxChildren = encBox.subarray(fourCC === 'enca' ? 28 : 78);
        const sinfs = $b941786f4eb9cb76$var$findBox(encBoxChildren, [
            'sinf'
        ]);
        sinfs.forEach((sinf)=>{
            const schm = $b941786f4eb9cb76$var$findBox(sinf, [
                'schm'
            ])[0];
            if (schm) {
                const scheme = $b941786f4eb9cb76$var$bin2str(schm.subarray(4, 8));
                if (scheme === 'cbcs' || scheme === 'cenc') {
                    const frma = $b941786f4eb9cb76$var$findBox(sinf, [
                        'frma'
                    ])[0];
                    if (frma) // for encrypted content codec fourCC will be in frma
                    codec = $b941786f4eb9cb76$var$bin2str(frma);
                }
            }
        });
    }
    const codecFourCC = codec;
    switch(codec){
        case 'avc1':
        case 'avc2':
        case 'avc3':
        case 'avc4':
            {
                // extract profile + compatibility + level out of avcC box
                const avcCBox = $b941786f4eb9cb76$var$findBox(sampleEntriesEnd, [
                    'avcC'
                ])[0];
                if (avcCBox && avcCBox.length > 3) {
                    codec += '.' + $b941786f4eb9cb76$var$toHex(avcCBox[1]) + $b941786f4eb9cb76$var$toHex(avcCBox[2]) + $b941786f4eb9cb76$var$toHex(avcCBox[3]);
                    supplemental = $b941786f4eb9cb76$var$parseSupplementalDoViCodec(codecFourCC === 'avc1' ? 'dva1' : 'dvav', sampleEntriesEnd);
                }
                break;
            }
        case 'mp4a':
            {
                const codecBox = $b941786f4eb9cb76$var$findBox(sampleEntries, [
                    fourCC
                ])[0];
                const esdsBox = $b941786f4eb9cb76$var$findBox(codecBox.subarray(28), [
                    'esds'
                ])[0];
                if (esdsBox && esdsBox.length > 7) {
                    let i = 4;
                    // ES Descriptor tag
                    if (esdsBox[i++] !== 0x03) break;
                    i = $b941786f4eb9cb76$var$skipBERInteger(esdsBox, i);
                    i += 2; // skip es_id;
                    const flags = esdsBox[i++];
                    if (flags & 0x80) i += 2; // skip dependency es_id
                    if (flags & 0x40) i += esdsBox[i++]; // skip URL
                    // Decoder config descriptor
                    if (esdsBox[i++] !== 0x04) break;
                    i = $b941786f4eb9cb76$var$skipBERInteger(esdsBox, i);
                    const objectType = esdsBox[i++];
                    if (objectType === 0x40) codec += '.' + $b941786f4eb9cb76$var$toHex(objectType);
                    else break;
                    i += 12;
                    // Decoder specific info
                    if (esdsBox[i++] !== 0x05) break;
                    i = $b941786f4eb9cb76$var$skipBERInteger(esdsBox, i);
                    const firstByte = esdsBox[i++];
                    let audioObjectType = (firstByte & 0xf8) >> 3;
                    if (audioObjectType === 31) audioObjectType += 1 + ((firstByte & 0x7) << 3) + ((esdsBox[i] & 0xe0) >> 5);
                    codec += '.' + audioObjectType;
                }
                break;
            }
        case 'hvc1':
        case 'hev1':
            {
                const hvcCBox = $b941786f4eb9cb76$var$findBox(sampleEntriesEnd, [
                    'hvcC'
                ])[0];
                if (hvcCBox && hvcCBox.length > 12) {
                    const profileByte = hvcCBox[1];
                    const profileSpace = [
                        '',
                        'A',
                        'B',
                        'C'
                    ][profileByte >> 6];
                    const generalProfileIdc = profileByte & 0x1f;
                    const profileCompat = $b941786f4eb9cb76$var$readUint32(hvcCBox, 2);
                    const tierFlag = (profileByte & 0x20) >> 5 ? 'H' : 'L';
                    const levelIDC = hvcCBox[12];
                    const constraintIndicator = hvcCBox.subarray(6, 12);
                    codec += '.' + profileSpace + generalProfileIdc;
                    codec += '.' + $b941786f4eb9cb76$var$reverse32BitInt(profileCompat).toString(16).toUpperCase();
                    codec += '.' + tierFlag + levelIDC;
                    let constraintString = '';
                    for(let i = constraintIndicator.length; i--;){
                        const byte = constraintIndicator[i];
                        if (byte || constraintString) {
                            const encodedByte = byte.toString(16).toUpperCase();
                            constraintString = '.' + encodedByte + constraintString;
                        }
                    }
                    codec += constraintString;
                }
                supplemental = $b941786f4eb9cb76$var$parseSupplementalDoViCodec(codecFourCC == 'hev1' ? 'dvhe' : 'dvh1', sampleEntriesEnd);
                break;
            }
        case 'dvh1':
        case 'dvhe':
        case 'dvav':
        case 'dva1':
        case 'dav1':
            codec = $b941786f4eb9cb76$var$parseSupplementalDoViCodec(codec, sampleEntriesEnd) || codec;
            break;
        case 'vp09':
            {
                const vpcCBox = $b941786f4eb9cb76$var$findBox(sampleEntriesEnd, [
                    'vpcC'
                ])[0];
                if (vpcCBox && vpcCBox.length > 6) {
                    const profile = vpcCBox[4];
                    const level = vpcCBox[5];
                    const bitDepth = vpcCBox[6] >> 4 & 0x0f;
                    codec += '.' + $b941786f4eb9cb76$var$addLeadingZero(profile) + '.' + $b941786f4eb9cb76$var$addLeadingZero(level) + '.' + $b941786f4eb9cb76$var$addLeadingZero(bitDepth);
                }
                break;
            }
        case 'av01':
            {
                const av1CBox = $b941786f4eb9cb76$var$findBox(sampleEntriesEnd, [
                    'av1C'
                ])[0];
                if (av1CBox && av1CBox.length > 2) {
                    const profile = av1CBox[1] >>> 5;
                    const level = av1CBox[1] & 0x1f;
                    const tierFlag = av1CBox[2] >>> 7 ? 'H' : 'M';
                    const highBitDepth = (av1CBox[2] & 0x40) >> 6;
                    const twelveBit = (av1CBox[2] & 0x20) >> 5;
                    const bitDepth = profile === 2 && highBitDepth ? twelveBit ? 12 : 10 : highBitDepth ? 10 : 8;
                    const monochrome = (av1CBox[2] & 0x10) >> 4;
                    const chromaSubsamplingX = (av1CBox[2] & 0x08) >> 3;
                    const chromaSubsamplingY = (av1CBox[2] & 0x04) >> 2;
                    const chromaSamplePosition = av1CBox[2] & 0x03;
                    // TODO: parse color_description_present_flag
                    // default it to BT.709/limited range for now
                    // more info https://aomediacodec.github.io/av1-isobmff/#av1codecconfigurationbox-syntax
                    const colorPrimaries = 1;
                    const transferCharacteristics = 1;
                    const matrixCoefficients = 1;
                    const videoFullRangeFlag = 0;
                    codec += '.' + profile + '.' + $b941786f4eb9cb76$var$addLeadingZero(level) + tierFlag + '.' + $b941786f4eb9cb76$var$addLeadingZero(bitDepth) + '.' + monochrome + '.' + chromaSubsamplingX + chromaSubsamplingY + chromaSamplePosition + '.' + $b941786f4eb9cb76$var$addLeadingZero(colorPrimaries) + '.' + $b941786f4eb9cb76$var$addLeadingZero(transferCharacteristics) + '.' + $b941786f4eb9cb76$var$addLeadingZero(matrixCoefficients) + '.' + videoFullRangeFlag;
                    supplemental = $b941786f4eb9cb76$var$parseSupplementalDoViCodec('dav1', sampleEntriesEnd);
                }
                break;
            }
    }
    return {
        codec: codec,
        encrypted: encrypted,
        supplemental: supplemental
    };
}
function $b941786f4eb9cb76$var$parseSupplementalDoViCodec(fourCC, sampleEntriesEnd) {
    const dvvCResult = $b941786f4eb9cb76$var$findBox(sampleEntriesEnd, [
        'dvvC'
    ]); // used by DoVi Profile 8 to 10
    const dvXCBox = dvvCResult.length ? dvvCResult[0] : $b941786f4eb9cb76$var$findBox(sampleEntriesEnd, [
        'dvcC'
    ])[0]; // used by DoVi Profiles up to 7 and 20
    if (dvXCBox) {
        const doViProfile = dvXCBox[2] >> 1 & 0x7f;
        const doViLevel = dvXCBox[2] << 5 & 0x20 | dvXCBox[3] >> 3 & 0x1f;
        return fourCC + '.' + $b941786f4eb9cb76$var$addLeadingZero(doViProfile) + '.' + $b941786f4eb9cb76$var$addLeadingZero(doViLevel);
    }
}
function $b941786f4eb9cb76$var$reverse32BitInt(val) {
    let result = 0;
    for(let i = 0; i < 32; i++)result |= (val >> i & 1) << 31 - i;
    return result >>> 0;
}
function $b941786f4eb9cb76$var$skipBERInteger(bytes, i) {
    const limit = i + 5;
    while(bytes[i++] & 0x80 && i < limit);
    return i;
}
function $b941786f4eb9cb76$var$toHex(x) {
    return ('0' + x.toString(16).toUpperCase()).slice(-2);
}
function $b941786f4eb9cb76$var$addLeadingZero(num) {
    return (num < 10 ? '0' : '') + num;
}
function $b941786f4eb9cb76$var$patchEncyptionData(initSegment, decryptdata) {
    if (!initSegment || !decryptdata) return;
    const keyId = decryptdata.keyId;
    if (keyId && decryptdata.isCommonEncryption) $b941786f4eb9cb76$var$applyToTencBoxes(initSegment, (tenc, isAudio)=>{
        // Look for default key id (keyID offset is always 8 within the tenc box):
        const tencKeyId = tenc.subarray(8, 24);
        if (!tencKeyId.some((b)=>b !== 0)) {
            $b941786f4eb9cb76$var$logger.log(`[eme] Patching keyId in 'enc${isAudio ? 'a' : 'v'}>sinf>>tenc' box: ${$b941786f4eb9cb76$var$arrayToHex(tencKeyId)} -> ${$b941786f4eb9cb76$var$arrayToHex(keyId)}`);
            tenc.set(keyId, 8);
        }
    });
}
function $b941786f4eb9cb76$var$parseKeyIdsFromTenc(initSegment) {
    const keyIds = [];
    $b941786f4eb9cb76$var$applyToTencBoxes(initSegment, (tenc)=>keyIds.push(tenc.subarray(8, 24)));
    return keyIds;
}
function $b941786f4eb9cb76$var$applyToTencBoxes(initSegment, predicate) {
    const traks = $b941786f4eb9cb76$var$findBox(initSegment, [
        'moov',
        'trak'
    ]);
    traks.forEach((trak)=>{
        const stsd = $b941786f4eb9cb76$var$findBox(trak, [
            'mdia',
            'minf',
            'stbl',
            'stsd'
        ])[0];
        if (!stsd) return;
        const sampleEntries = stsd.subarray(8);
        let encBoxes = $b941786f4eb9cb76$var$findBox(sampleEntries, [
            'enca'
        ]);
        const isAudio = encBoxes.length > 0;
        if (!isAudio) encBoxes = $b941786f4eb9cb76$var$findBox(sampleEntries, [
            'encv'
        ]);
        encBoxes.forEach((enc)=>{
            const encBoxChildren = isAudio ? enc.subarray(28) : enc.subarray(78);
            const sinfBoxes = $b941786f4eb9cb76$var$findBox(encBoxChildren, [
                'sinf'
            ]);
            sinfBoxes.forEach((sinf)=>{
                const tenc = $b941786f4eb9cb76$var$parseSinf(sinf);
                if (tenc) predicate(tenc, isAudio);
            });
        });
    });
}
function $b941786f4eb9cb76$var$parseSinf(sinf) {
    const schm = $b941786f4eb9cb76$var$findBox(sinf, [
        'schm'
    ])[0];
    if (schm) {
        const scheme = $b941786f4eb9cb76$var$bin2str(schm.subarray(4, 8));
        if (scheme === 'cbcs' || scheme === 'cenc') {
            const tenc = $b941786f4eb9cb76$var$findBox(sinf, [
                'schi',
                'tenc'
            ])[0];
            if (tenc) return tenc;
        }
    }
}
/*
  For Reference:
  aligned(8) class TrackFragmentHeaderBox
           extends FullBox(‘tfhd’, 0, tf_flags){
     unsigned int(32)  track_ID;
     // all the following are optional fields
     unsigned int(64)  base_data_offset;
     unsigned int(32)  sample_description_index;
     unsigned int(32)  default_sample_duration;
     unsigned int(32)  default_sample_size;
     unsigned int(32)  default_sample_flags
  }
 */ function $b941786f4eb9cb76$var$getSampleData(data, initData, logger) {
    const tracks = {};
    const trafs = $b941786f4eb9cb76$var$findBox(data, [
        'moof',
        'traf'
    ]);
    for(let i = 0; i < trafs.length; i++){
        const traf = trafs[i];
        // There is only one tfhd & trun per traf
        // This is true for CMAF style content, and we should perhaps check the ftyp
        // and only look for a single trun then, but for ISOBMFF we should check
        // for multiple track runs.
        const tfhd = $b941786f4eb9cb76$var$findBox(traf, [
            'tfhd'
        ])[0];
        // get the track id from the tfhd
        const id = $b941786f4eb9cb76$var$readUint32(tfhd, 4);
        const track = initData[id];
        if (!track) continue;
        tracks[id] || (tracks[id] = {
            start: NaN,
            duration: 0,
            sampleCount: 0,
            timescale: track.timescale,
            type: track.type
        });
        const trackTimes = tracks[id];
        // get start DTS
        const tfdt = $b941786f4eb9cb76$var$findBox(traf, [
            'tfdt'
        ])[0];
        if (tfdt) {
            const version = tfdt[0];
            let baseTime = $b941786f4eb9cb76$var$readUint32(tfdt, 4);
            if (version === 1) {
                // If value is too large, assume signed 64-bit. Negative track fragment decode times are invalid, but they exist in the wild.
                // This prevents large values from being used for initPTS, which can cause playlist sync issues.
                // https://github.com/video-dev/hls.js/issues/5303
                if (baseTime === $b941786f4eb9cb76$var$UINT32_MAX$1) logger.warn(`[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time`);
                else {
                    baseTime *= $b941786f4eb9cb76$var$UINT32_MAX$1 + 1;
                    baseTime += $b941786f4eb9cb76$var$readUint32(tfdt, 8);
                }
            }
            if ($b941786f4eb9cb76$var$isFiniteNumber(baseTime) && (!$b941786f4eb9cb76$var$isFiniteNumber(trackTimes.start) || baseTime < trackTimes.start)) trackTimes.start = baseTime;
        }
        const trackDefault = track.default;
        const tfhdFlags = $b941786f4eb9cb76$var$readUint32(tfhd, 0) | (trackDefault == null ? void 0 : trackDefault.flags);
        let defaultSampleDuration = (trackDefault == null ? void 0 : trackDefault.duration) || 0;
        if (tfhdFlags & 0x000008) {
            // 0x000008 indicates the presence of the default_sample_duration field
            if (tfhdFlags & 0x000002) // 0x000002 indicates the presence of the sample_description_index field, which precedes default_sample_duration
            // If present, the default_sample_duration exists at byte offset 12
            defaultSampleDuration = $b941786f4eb9cb76$var$readUint32(tfhd, 12);
            else // Otherwise, the duration is at byte offset 8
            defaultSampleDuration = $b941786f4eb9cb76$var$readUint32(tfhd, 8);
        }
        const truns = $b941786f4eb9cb76$var$findBox(traf, [
            'trun'
        ]);
        let sampleDTS = trackTimes.start || 0;
        let rawDuration = 0;
        let sampleDuration = defaultSampleDuration;
        for(let j = 0; j < truns.length; j++){
            const trun = truns[j];
            const sampleCount = $b941786f4eb9cb76$var$readUint32(trun, 4);
            const sampleIndex = trackTimes.sampleCount;
            trackTimes.sampleCount += sampleCount;
            // Get duration from samples
            const dataOffsetPresent = trun[3] & 0x01;
            const firstSampleFlagsPresent = trun[3] & 0x04;
            const sampleDurationPresent = trun[2] & 0x01;
            const sampleSizePresent = trun[2] & 0x02;
            const sampleFlagsPresent = trun[2] & 0x04;
            const sampleCompositionTimeOffsetPresent = trun[2] & 0x08;
            let offset = 8;
            let remaining = sampleCount;
            if (dataOffsetPresent) offset += 4;
            if (firstSampleFlagsPresent && sampleCount) {
                const isNonSyncSample = trun[offset + 1] & 0x01;
                if (!isNonSyncSample && trackTimes.keyFrameIndex === undefined) trackTimes.keyFrameIndex = sampleIndex;
                offset += 4;
                if (sampleDurationPresent) {
                    sampleDuration = $b941786f4eb9cb76$var$readUint32(trun, offset);
                    offset += 4;
                } else sampleDuration = defaultSampleDuration;
                if (sampleSizePresent) offset += 4;
                if (sampleCompositionTimeOffsetPresent) offset += 4;
                sampleDTS += sampleDuration;
                rawDuration += sampleDuration;
                remaining--;
            }
            while(remaining--){
                if (sampleDurationPresent) {
                    sampleDuration = $b941786f4eb9cb76$var$readUint32(trun, offset);
                    offset += 4;
                } else sampleDuration = defaultSampleDuration;
                if (sampleSizePresent) offset += 4;
                if (sampleFlagsPresent) {
                    const isNonSyncSample = trun[offset + 1] & 0x01;
                    if (!isNonSyncSample) {
                        if (trackTimes.keyFrameIndex === undefined) {
                            trackTimes.keyFrameIndex = trackTimes.sampleCount - (remaining + 1);
                            trackTimes.keyFrameStart = sampleDTS;
                        }
                    }
                    offset += 4;
                }
                if (sampleCompositionTimeOffsetPresent) offset += 4;
                sampleDTS += sampleDuration;
                rawDuration += sampleDuration;
            }
            if (!rawDuration && defaultSampleDuration) rawDuration += defaultSampleDuration * sampleCount;
        }
        trackTimes.duration += rawDuration;
    }
    if (!Object.keys(tracks).some((trackId)=>tracks[trackId].duration)) {
        // If duration samples are not available in the traf use sidx subsegment_duration
        let sidxMinStart = Infinity;
        let sidxMaxEnd = 0;
        const sidxs = $b941786f4eb9cb76$var$findBox(data, [
            'sidx'
        ]);
        for(let i = 0; i < sidxs.length; i++){
            const sidx = $b941786f4eb9cb76$var$parseSegmentIndex(sidxs[i]);
            if (sidx != null && sidx.references) {
                sidxMinStart = Math.min(sidxMinStart, sidx.earliestPresentationTime / sidx.timescale);
                const subSegmentDuration = sidx.references.reduce((dur, ref)=>dur + ref.info.duration || 0, 0);
                sidxMaxEnd = Math.max(sidxMaxEnd, subSegmentDuration + sidx.earliestPresentationTime / sidx.timescale);
            }
        }
        if (sidxMaxEnd && $b941786f4eb9cb76$var$isFiniteNumber(sidxMaxEnd)) Object.keys(tracks).forEach((trackId)=>{
            if (!tracks[trackId].duration) tracks[trackId].duration = sidxMaxEnd * tracks[trackId].timescale - tracks[trackId].start;
        });
    }
    return tracks;
}
// TODO: Check if the last moof+mdat pair is part of the valid range
function $b941786f4eb9cb76$var$segmentValidRange(data) {
    const segmentedRange = {
        valid: null,
        remainder: null
    };
    const moofs = $b941786f4eb9cb76$var$findBox(data, [
        'moof'
    ]);
    if (moofs.length < 2) {
        segmentedRange.remainder = data;
        return segmentedRange;
    }
    const last = moofs[moofs.length - 1];
    // Offset by 8 bytes; findBox offsets the start by as much
    segmentedRange.valid = data.slice(0, last.byteOffset - 8);
    segmentedRange.remainder = data.slice(last.byteOffset - 8);
    return segmentedRange;
}
function $b941786f4eb9cb76$var$appendUint8Array(data1, data2) {
    const temp = new Uint8Array(data1.length + data2.length);
    temp.set(data1);
    temp.set(data2, data1.length);
    return temp;
}
function $b941786f4eb9cb76$var$parseSamples(timeOffset, track) {
    const seiSamples = [];
    const videoData = track.samples;
    const timescale = track.timescale;
    const trackId = track.id;
    let isHEVCFlavor = false;
    const moofs = $b941786f4eb9cb76$var$findBox(videoData, [
        'moof'
    ]);
    moofs.map((moof)=>{
        const moofOffset = moof.byteOffset - 8;
        const trafs = $b941786f4eb9cb76$var$findBox(moof, [
            'traf'
        ]);
        trafs.map((traf)=>{
            // get the base media decode time from the tfdt
            const baseTime = $b941786f4eb9cb76$var$findBox(traf, [
                'tfdt'
            ]).map((tfdt)=>{
                const version = tfdt[0];
                let result = $b941786f4eb9cb76$var$readUint32(tfdt, 4);
                if (version === 1) {
                    result *= Math.pow(2, 32);
                    result += $b941786f4eb9cb76$var$readUint32(tfdt, 8);
                }
                return result / timescale;
            })[0];
            if (baseTime !== undefined) timeOffset = baseTime;
            return $b941786f4eb9cb76$var$findBox(traf, [
                'tfhd'
            ]).map((tfhd)=>{
                const id = $b941786f4eb9cb76$var$readUint32(tfhd, 4);
                const tfhdFlags = $b941786f4eb9cb76$var$readUint32(tfhd, 0) & 0xffffff;
                const baseDataOffsetPresent = (tfhdFlags & 0x000001) !== 0;
                const sampleDescriptionIndexPresent = (tfhdFlags & 0x000002) !== 0;
                const defaultSampleDurationPresent = (tfhdFlags & 0x000008) !== 0;
                let defaultSampleDuration = 0;
                const defaultSampleSizePresent = (tfhdFlags & 0x000010) !== 0;
                let defaultSampleSize = 0;
                const defaultSampleFlagsPresent = (tfhdFlags & 0x000020) !== 0;
                let tfhdOffset = 8;
                if (id === trackId) {
                    if (baseDataOffsetPresent) tfhdOffset += 8;
                    if (sampleDescriptionIndexPresent) tfhdOffset += 4;
                    if (defaultSampleDurationPresent) {
                        defaultSampleDuration = $b941786f4eb9cb76$var$readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleSizePresent) {
                        defaultSampleSize = $b941786f4eb9cb76$var$readUint32(tfhd, tfhdOffset);
                        tfhdOffset += 4;
                    }
                    if (defaultSampleFlagsPresent) tfhdOffset += 4;
                    if (track.type === 'video') isHEVCFlavor = $b941786f4eb9cb76$var$isHEVC(track.codec);
                    $b941786f4eb9cb76$var$findBox(traf, [
                        'trun'
                    ]).map((trun)=>{
                        const version = trun[0];
                        const flags = $b941786f4eb9cb76$var$readUint32(trun, 0) & 0xffffff;
                        const dataOffsetPresent = (flags & 0x000001) !== 0;
                        let dataOffset = 0;
                        const firstSampleFlagsPresent = (flags & 0x000004) !== 0;
                        const sampleDurationPresent = (flags & 0x000100) !== 0;
                        let sampleDuration = 0;
                        const sampleSizePresent = (flags & 0x000200) !== 0;
                        let sampleSize = 0;
                        const sampleFlagsPresent = (flags & 0x000400) !== 0;
                        const sampleCompositionOffsetsPresent = (flags & 0x000800) !== 0;
                        let compositionOffset = 0;
                        const sampleCount = $b941786f4eb9cb76$var$readUint32(trun, 4);
                        let trunOffset = 8; // past version, flags, and sample count
                        if (dataOffsetPresent) {
                            dataOffset = $b941786f4eb9cb76$var$readUint32(trun, trunOffset);
                            trunOffset += 4;
                        }
                        if (firstSampleFlagsPresent) trunOffset += 4;
                        let sampleOffset = dataOffset + moofOffset;
                        for(let ix = 0; ix < sampleCount; ix++){
                            if (sampleDurationPresent) {
                                sampleDuration = $b941786f4eb9cb76$var$readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleDuration = defaultSampleDuration;
                            if (sampleSizePresent) {
                                sampleSize = $b941786f4eb9cb76$var$readUint32(trun, trunOffset);
                                trunOffset += 4;
                            } else sampleSize = defaultSampleSize;
                            if (sampleFlagsPresent) trunOffset += 4;
                            if (sampleCompositionOffsetsPresent) {
                                if (version === 0) compositionOffset = $b941786f4eb9cb76$var$readUint32(trun, trunOffset);
                                else compositionOffset = $b941786f4eb9cb76$var$readSint32(trun, trunOffset);
                                trunOffset += 4;
                            }
                            if (track.type === $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO) {
                                let naluTotalSize = 0;
                                while(naluTotalSize < sampleSize){
                                    const naluSize = $b941786f4eb9cb76$var$readUint32(videoData, sampleOffset);
                                    sampleOffset += 4;
                                    if ($b941786f4eb9cb76$var$isSEIMessage(isHEVCFlavor, videoData[sampleOffset])) {
                                        const data = videoData.subarray(sampleOffset, sampleOffset + naluSize);
                                        $b941786f4eb9cb76$var$parseSEIMessageFromNALu(data, isHEVCFlavor ? 2 : 1, timeOffset + compositionOffset / timescale, seiSamples);
                                    }
                                    sampleOffset += naluSize;
                                    naluTotalSize += naluSize + 4;
                                }
                            }
                            timeOffset += sampleDuration / timescale;
                        }
                    });
                }
            });
        });
    });
    return seiSamples;
}
function $b941786f4eb9cb76$var$isHEVC(codec) {
    if (!codec) return false;
    const baseCodec = codec.substring(0, 4);
    return baseCodec === 'hvc1' || baseCodec === 'hev1' || // Dolby Vision
    baseCodec === 'dvh1' || baseCodec === 'dvhe';
}
function $b941786f4eb9cb76$var$isSEIMessage(isHEVCFlavor, naluHeader) {
    if (isHEVCFlavor) {
        const naluType = naluHeader >> 1 & 0x3f;
        return naluType === 39 || naluType === 40;
    } else {
        const naluType = naluHeader & 0x1f;
        return naluType === 6;
    }
}
function $b941786f4eb9cb76$var$parseSEIMessageFromNALu(unescapedData, headerSize, pts, samples) {
    const data = $b941786f4eb9cb76$var$discardEPB(unescapedData);
    let seiPtr = 0;
    // skip nal header
    seiPtr += headerSize;
    let payloadType = 0;
    let payloadSize = 0;
    let b = 0;
    while(seiPtr < data.length){
        payloadType = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadType += b;
        }while (b === 0xff);
        // Parse payload size.
        payloadSize = 0;
        do {
            if (seiPtr >= data.length) break;
            b = data[seiPtr++];
            payloadSize += b;
        }while (b === 0xff);
        const leftOver = data.length - seiPtr;
        // Create a variable to process the payload
        let payPtr = seiPtr;
        // Increment the seiPtr to the end of the payload
        if (payloadSize < leftOver) seiPtr += payloadSize;
        else if (payloadSize > leftOver) {
            // Some type of corruption has happened?
            $b941786f4eb9cb76$var$logger.error(`Malformed SEI payload. ${payloadSize} is too small, only ${leftOver} bytes left to parse.`);
            break;
        }
        if (payloadType === 4) {
            const countryCode = data[payPtr++];
            if (countryCode === 181) {
                const providerCode = $b941786f4eb9cb76$var$readUint16(data, payPtr);
                payPtr += 2;
                if (providerCode === 49) {
                    const userStructure = $b941786f4eb9cb76$var$readUint32(data, payPtr);
                    payPtr += 4;
                    if (userStructure === 0x47413934) {
                        const userDataType = data[payPtr++];
                        // Raw CEA-608 bytes wrapped in CEA-708 packet
                        if (userDataType === 3) {
                            const firstByte = data[payPtr++];
                            const totalCCs = 0x1f & firstByte;
                            const enabled = 0x40 & firstByte;
                            const totalBytes = enabled ? 2 + totalCCs * 3 : 0;
                            const byteArray = new Uint8Array(totalBytes);
                            if (enabled) {
                                byteArray[0] = firstByte;
                                for(let i = 1; i < totalBytes; i++)byteArray[i] = data[payPtr++];
                            }
                            samples.push({
                                type: userDataType,
                                payloadType: payloadType,
                                pts: pts,
                                bytes: byteArray
                            });
                        }
                    }
                }
            }
        } else if (payloadType === 5) {
            if (payloadSize > 16) {
                const uuidStrArray = [];
                for(let i = 0; i < 16; i++){
                    const _b = data[payPtr++].toString(16);
                    uuidStrArray.push(_b.length == 1 ? '0' + _b : _b);
                    if (i === 3 || i === 5 || i === 7 || i === 9) uuidStrArray.push('-');
                }
                const length = payloadSize - 16;
                const userDataBytes = new Uint8Array(length);
                for(let i = 0; i < length; i++)userDataBytes[i] = data[payPtr++];
                samples.push({
                    payloadType: payloadType,
                    pts: pts,
                    uuid: uuidStrArray.join(''),
                    userData: $b941786f4eb9cb76$var$utf8ArrayToStr(userDataBytes),
                    userDataBytes: userDataBytes
                });
            }
        }
    }
}
/**
 * remove Emulation Prevention bytes from a RBSP
 */ function $b941786f4eb9cb76$var$discardEPB(data) {
    const length = data.byteLength;
    const EPBPositions = [];
    let i = 1;
    // Find all `Emulation Prevention Bytes`
    while(i < length - 2)if (data[i] === 0 && data[i + 1] === 0 && data[i + 2] === 0x03) {
        EPBPositions.push(i + 2);
        i += 2;
    } else i++;
    // If no Emulation Prevention Bytes were found just return the original
    // array
    if (EPBPositions.length === 0) return data;
    // Create a new array to hold the NAL unit data
    const newLength = length - EPBPositions.length;
    const newData = new Uint8Array(newLength);
    let sourceIndex = 0;
    for(i = 0; i < newLength; sourceIndex++, i++){
        if (sourceIndex === EPBPositions[0]) {
            // Skip this byte
            sourceIndex++;
            // Remove this position index
            EPBPositions.shift();
        }
        newData[i] = data[sourceIndex];
    }
    return newData;
}
function $b941786f4eb9cb76$var$parseEmsg(data) {
    const version = data[0];
    let schemeIdUri = '';
    let value = '';
    let timeScale = 0;
    let presentationTimeDelta = 0;
    let presentationTime = 0;
    let eventDuration = 0;
    let id = 0;
    let offset = 0;
    if (version === 0) {
        while($b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            schemeIdUri += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while($b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            value += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        timeScale = $b941786f4eb9cb76$var$readUint32(data, 12);
        presentationTimeDelta = $b941786f4eb9cb76$var$readUint32(data, 16);
        eventDuration = $b941786f4eb9cb76$var$readUint32(data, 20);
        id = $b941786f4eb9cb76$var$readUint32(data, 24);
        offset = 28;
    } else if (version === 1) {
        offset += 4;
        timeScale = $b941786f4eb9cb76$var$readUint32(data, offset);
        offset += 4;
        const leftPresentationTime = $b941786f4eb9cb76$var$readUint32(data, offset);
        offset += 4;
        const rightPresentationTime = $b941786f4eb9cb76$var$readUint32(data, offset);
        offset += 4;
        presentationTime = 2 ** 32 * leftPresentationTime + rightPresentationTime;
        if (!$b941786f4eb9cb76$var$isSafeInteger(presentationTime)) {
            presentationTime = Number.MAX_SAFE_INTEGER;
            $b941786f4eb9cb76$var$logger.warn('Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box');
        }
        eventDuration = $b941786f4eb9cb76$var$readUint32(data, offset);
        offset += 4;
        id = $b941786f4eb9cb76$var$readUint32(data, offset);
        offset += 4;
        while($b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            schemeIdUri += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        schemeIdUri += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
        while($b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1)) !== '\0'){
            value += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
            offset += 1;
        }
        value += $b941786f4eb9cb76$var$bin2str(data.subarray(offset, offset + 1));
        offset += 1;
    }
    const payload = data.subarray(offset, data.byteLength);
    return {
        schemeIdUri: schemeIdUri,
        value: value,
        timeScale: timeScale,
        presentationTime: presentationTime,
        presentationTimeDelta: presentationTimeDelta,
        eventDuration: eventDuration,
        id: id,
        payload: payload
    };
}
function $b941786f4eb9cb76$var$mp4Box(type, ...payload) {
    const len = payload.length;
    let size = 8;
    let i = len;
    while(i--)size += payload[i].byteLength;
    const result = new Uint8Array(size);
    result[0] = size >> 24 & 0xff;
    result[1] = size >> 16 & 0xff;
    result[2] = size >> 8 & 0xff;
    result[3] = size & 0xff;
    result.set(type, 4);
    for(i = 0, size = 8; i < len; i++){
        result.set(payload[i], size);
        size += payload[i].byteLength;
    }
    return result;
}
function $b941786f4eb9cb76$var$mp4pssh(systemId, keyids, data) {
    if (systemId.byteLength !== 16) throw new RangeError('Invalid system id');
    let version;
    let kids;
    version = 0;
    kids = new Uint8Array();
    let kidCount;
    if (version > 0) {
        kidCount = new Uint8Array(4);
        if (keyids.length > 0) new DataView(kidCount.buffer).setUint32(0, keyids.length, false);
    } else kidCount = new Uint8Array();
    const dataSize = new Uint8Array(4);
    if (data.byteLength > 0) new DataView(dataSize.buffer).setUint32(0, data.byteLength, false);
    return $b941786f4eb9cb76$var$mp4Box([
        112,
        115,
        115,
        104
    ], new Uint8Array([
        version,
        0x00,
        0x00,
        0x00 // Flags
    ]), systemId, // 16 bytes
    kidCount, kids, dataSize, data);
}
function $b941786f4eb9cb76$var$parseMultiPssh(initData) {
    const results = [];
    if (initData instanceof ArrayBuffer) {
        const length = initData.byteLength;
        let offset = 0;
        while(offset + 32 < length){
            const view = new DataView(initData, offset);
            const pssh = $b941786f4eb9cb76$var$parsePssh(view);
            results.push(pssh);
            offset += pssh.size;
        }
    }
    return results;
}
function $b941786f4eb9cb76$var$parsePssh(view) {
    const size = view.getUint32(0);
    const offset = view.byteOffset;
    const length = view.byteLength;
    if (length < size) return {
        offset: offset,
        size: length
    };
    const type = view.getUint32(4);
    if (type !== 0x70737368) return {
        offset: offset,
        size: size
    };
    const version = view.getUint32(8) >>> 24;
    if (version !== 0 && version !== 1) return {
        offset: offset,
        size: size
    };
    const buffer = view.buffer;
    const systemId = $b941786f4eb9cb76$var$arrayToHex(new Uint8Array(buffer, offset + 12, 16));
    let kids = null;
    let data = null;
    let dataSizeOffset = 0;
    if (version === 0) dataSizeOffset = 28;
    else {
        const kidCounts = view.getUint32(28);
        if (!kidCounts || length < 32 + kidCounts * 16) return {
            offset: offset,
            size: size
        };
        kids = [];
        for(let i = 0; i < kidCounts; i++)kids.push(new Uint8Array(buffer, offset + 32 + i * 16, 16));
        dataSizeOffset = 32 + kidCounts * 16;
    }
    if (!dataSizeOffset) return {
        offset: offset,
        size: size
    };
    const dataSizeOrKidCount = view.getUint32(dataSizeOffset);
    if (size - 32 < dataSizeOrKidCount) return {
        offset: offset,
        size: size
    };
    data = new Uint8Array(buffer, offset + dataSizeOffset + 4, dataSizeOrKidCount);
    return {
        version: version,
        systemId: systemId,
        kids: kids,
        data: data,
        offset: offset,
        size: size
    };
}
const $b941786f4eb9cb76$var$userAgentHevcSupportIsInaccurate = ()=>{
    return /\(Windows.+Firefox\//i.test(navigator.userAgent);
};
// from http://mp4ra.org/codecs.html
// values indicate codec selection preference (lower is higher priority)
const $b941786f4eb9cb76$var$sampleEntryCodesISO = {
    audio: {
        a3ds: 1,
        'ac-3': 0.95,
        'ac-4': 1,
        alac: 0.9,
        alaw: 1,
        dra1: 1,
        'dts+': 1,
        'dts-': 1,
        dtsc: 1,
        dtse: 1,
        dtsh: 1,
        'ec-3': 0.9,
        enca: 1,
        fLaC: 0.9,
        // MP4-RA listed codec entry for FLAC
        flac: 0.9,
        // legacy browser codec name for FLAC
        FLAC: 0.9,
        // some manifests may list "FLAC" with Apple's tools
        g719: 1,
        g726: 1,
        m4ae: 1,
        mha1: 1,
        mha2: 1,
        mhm1: 1,
        mhm2: 1,
        mlpa: 1,
        mp4a: 1,
        'raw ': 1,
        Opus: 1,
        opus: 1,
        // browsers expect this to be lowercase despite MP4RA says 'Opus'
        samr: 1,
        sawb: 1,
        sawp: 1,
        sevc: 1,
        sqcp: 1,
        ssmv: 1,
        twos: 1,
        ulaw: 1
    },
    video: {
        avc1: 1,
        avc2: 1,
        avc3: 1,
        avc4: 1,
        avcp: 1,
        av01: 0.8,
        dav1: 0.8,
        drac: 1,
        dva1: 1,
        dvav: 1,
        dvh1: 0.7,
        dvhe: 0.7,
        encv: 1,
        hev1: 0.75,
        hvc1: 0.75,
        mjp2: 1,
        mp4v: 1,
        mvc1: 1,
        mvc2: 1,
        mvc3: 1,
        mvc4: 1,
        resv: 1,
        rv60: 1,
        s263: 1,
        svc1: 1,
        svc2: 1,
        'vc-1': 1,
        vp08: 1,
        vp09: 0.9
    },
    text: {
        stpp: 1,
        wvtt: 1
    }
};
function $b941786f4eb9cb76$var$isCodecType(codec, type) {
    const typeCodes = $b941786f4eb9cb76$var$sampleEntryCodesISO[type];
    return !!typeCodes && !!typeCodes[codec.slice(0, 4)];
}
function $b941786f4eb9cb76$var$areCodecsMediaSourceSupported(codecs, type, preferManagedMediaSource = true) {
    return !codecs.split(',').some((codec)=>!$b941786f4eb9cb76$var$isCodecMediaSourceSupported(codec, type, preferManagedMediaSource));
}
function $b941786f4eb9cb76$var$isCodecMediaSourceSupported(codec, type, preferManagedMediaSource = true) {
    var _MediaSource$isTypeSu;
    const MediaSource = $b941786f4eb9cb76$export$a92854129bc50f89(preferManagedMediaSource);
    return (_MediaSource$isTypeSu = MediaSource == null ? void 0 : MediaSource.isTypeSupported($b941786f4eb9cb76$var$mimeTypeForCodec(codec, type))) != null ? _MediaSource$isTypeSu : false;
}
function $b941786f4eb9cb76$var$mimeTypeForCodec(codec, type) {
    return `${type}/mp4;codecs=${codec}`;
}
function $b941786f4eb9cb76$var$videoCodecPreferenceValue(videoCodec) {
    if (videoCodec) {
        const fourCC = videoCodec.substring(0, 4);
        return $b941786f4eb9cb76$var$sampleEntryCodesISO.video[fourCC];
    }
    return 2;
}
function $b941786f4eb9cb76$var$codecsSetSelectionPreferenceValue(codecSet) {
    const limitedHevcSupport = $b941786f4eb9cb76$var$userAgentHevcSupportIsInaccurate();
    return codecSet.split(',').reduce((num, fourCC)=>{
        const lowerPriority = limitedHevcSupport && $b941786f4eb9cb76$var$isHEVC(fourCC);
        const preferenceValue = lowerPriority ? 9 : $b941786f4eb9cb76$var$sampleEntryCodesISO.video[fourCC];
        if (preferenceValue) return (preferenceValue * 2 + num) / (num ? 3 : 2);
        return ($b941786f4eb9cb76$var$sampleEntryCodesISO.audio[fourCC] + num) / (num ? 2 : 1);
    }, 0);
}
const $b941786f4eb9cb76$var$CODEC_COMPATIBLE_NAMES = {};
function $b941786f4eb9cb76$var$getCodecCompatibleNameLower(lowerCaseCodec, preferManagedMediaSource = true) {
    if ($b941786f4eb9cb76$var$CODEC_COMPATIBLE_NAMES[lowerCaseCodec]) return $b941786f4eb9cb76$var$CODEC_COMPATIBLE_NAMES[lowerCaseCodec];
    const codecsToCheck = {
        // Idealy fLaC and Opus would be first (spec-compliant) but
        // some browsers will report that fLaC is supported then fail.
        // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
        flac: [
            'flac',
            'fLaC',
            'FLAC'
        ],
        opus: [
            'opus',
            'Opus'
        ],
        // Replace audio codec info if browser does not support mp4a.40.34,
        // and demuxer can fallback to 'audio/mpeg' or 'audio/mp4;codecs="mp3"'
        'mp4a.40.34': [
            'mp3'
        ]
    }[lowerCaseCodec];
    for(let i = 0; i < codecsToCheck.length; i++){
        var _getMediaSource;
        if ($b941786f4eb9cb76$var$isCodecMediaSourceSupported(codecsToCheck[i], 'audio', preferManagedMediaSource)) {
            $b941786f4eb9cb76$var$CODEC_COMPATIBLE_NAMES[lowerCaseCodec] = codecsToCheck[i];
            return codecsToCheck[i];
        } else if (codecsToCheck[i] === 'mp3' && (_getMediaSource = $b941786f4eb9cb76$export$a92854129bc50f89(preferManagedMediaSource)) != null && _getMediaSource.isTypeSupported('audio/mpeg')) return '';
    }
    return lowerCaseCodec;
}
const $b941786f4eb9cb76$var$AUDIO_CODEC_REGEXP = /flac|opus|mp4a\.40\.34/i;
function $b941786f4eb9cb76$var$getCodecCompatibleName(codec, preferManagedMediaSource = true) {
    return codec.replace($b941786f4eb9cb76$var$AUDIO_CODEC_REGEXP, (m)=>$b941786f4eb9cb76$var$getCodecCompatibleNameLower(m.toLowerCase(), preferManagedMediaSource));
}
function $b941786f4eb9cb76$var$replaceVideoCodec(originalCodecs, newVideoCodec) {
    const codecs = [];
    if (originalCodecs) {
        const allCodecs = originalCodecs.split(',');
        for(let i = 0; i < allCodecs.length; i++)if (!$b941786f4eb9cb76$var$isCodecType(allCodecs[i], 'video')) codecs.push(allCodecs[i]);
    }
    if (newVideoCodec) codecs.push(newVideoCodec);
    return codecs.join(',');
}
function $b941786f4eb9cb76$var$pickMostCompleteCodecName(parsedCodec, levelCodec) {
    // Parsing of mp4a codecs strings in mp4-tools from media is incomplete as of d8c6c7a
    // so use level codec is parsed codec is unavailable or incomplete
    if (parsedCodec && (parsedCodec.length > 4 || [
        'ac-3',
        'ec-3',
        'alac',
        'fLaC',
        'Opus'
    ].indexOf(parsedCodec) !== -1)) {
        if ($b941786f4eb9cb76$var$isCodecSupportedAsType(parsedCodec, 'audio') || $b941786f4eb9cb76$var$isCodecSupportedAsType(parsedCodec, 'video')) return parsedCodec;
    }
    if (levelCodec) {
        const levelCodecs = levelCodec.split(',');
        if (levelCodecs.length > 1) {
            if (parsedCodec) for(let i = levelCodecs.length; i--;){
                if (levelCodecs[i].substring(0, 4) === parsedCodec.substring(0, 4)) return levelCodecs[i];
            }
            return levelCodecs[0];
        }
    }
    return levelCodec || parsedCodec;
}
function $b941786f4eb9cb76$var$isCodecSupportedAsType(codec, type) {
    return $b941786f4eb9cb76$var$isCodecType(codec, type) && $b941786f4eb9cb76$var$isCodecMediaSourceSupported(codec, type);
}
function $b941786f4eb9cb76$var$convertAVC1ToAVCOTI(videoCodecs) {
    // Convert avc1 codec string from RFC-4281 to RFC-6381 for MediaSource.isTypeSupported
    // Examples: avc1.66.30 to avc1.42001e and avc1.77.30,avc1.66.30 to avc1.4d001e,avc1.42001e.
    const codecs = videoCodecs.split(',');
    for(let i = 0; i < codecs.length; i++){
        const avcdata = codecs[i].split('.');
        // only convert codec strings starting with avc1 (Examples: avc1.64001f,dvh1.05.07)
        if (avcdata.length > 2 && avcdata[0] === 'avc1') codecs[i] = `avc1.${parseInt(avcdata[1]).toString(16)}${('000' + parseInt(avcdata[2]).toString(16)).slice(-4)}`;
    }
    return codecs.join(',');
}
function $b941786f4eb9cb76$var$fillInMissingAV01Params(videoCodec) {
    // Used to fill in incomplete AV1 playlist CODECS strings for mediaCapabilities.decodingInfo queries
    if (videoCodec.startsWith('av01.')) {
        const av1params = videoCodec.split('.');
        const placeholders = [
            '0',
            '111',
            '01',
            '01',
            '01',
            '0'
        ];
        for(let i = av1params.length; i > 4 && i < 10; i++)av1params[i] = placeholders[i - 4];
        return av1params.join('.');
    }
    return videoCodec;
}
function $b941786f4eb9cb76$var$getM2TSSupportedAudioTypes(preferManagedMediaSource) {
    const MediaSource = $b941786f4eb9cb76$export$a92854129bc50f89(preferManagedMediaSource) || {
        isTypeSupported: ()=>false
    };
    return {
        mpeg: MediaSource.isTypeSupported('audio/mpeg'),
        mp3: MediaSource.isTypeSupported('audio/mp4; codecs="mp3"'),
        ac3: MediaSource.isTypeSupported('audio/mp4; codecs="ac-3"')
    };
}
function $b941786f4eb9cb76$var$getCodecsForMimeType(mimeType) {
    return mimeType.replace(/^.+codecs=["']?([^"']+).*$/, '$1');
}
// @ts-ignore
const $b941786f4eb9cb76$var$supportedResult = {
    supported: true,
    powerEfficient: true,
    smooth: true
};
// @ts-ignore
const $b941786f4eb9cb76$var$unsupportedResult = {
    supported: false,
    smooth: false,
    powerEfficient: false
};
const $b941786f4eb9cb76$var$SUPPORTED_INFO_DEFAULT = {
    supported: true,
    configurations: [],
    decodingInfoResults: [
        $b941786f4eb9cb76$var$supportedResult
    ]
};
function $b941786f4eb9cb76$var$getUnsupportedResult(error, configurations) {
    return {
        supported: false,
        configurations: configurations,
        decodingInfoResults: [
            $b941786f4eb9cb76$var$unsupportedResult
        ],
        error: error
    };
}
function $b941786f4eb9cb76$var$requiresMediaCapabilitiesDecodingInfo(level, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference) {
    // Only test support when configuration is exceeds minimum options
    const videoCodecs = level.videoCodec;
    const audioGroups = level.audioCodec ? level.audioGroups : null;
    const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
    const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
    const maxChannels = channelsPreference ? parseInt(channelsPreference) : audioCodecPreference ? Infinity : 2;
    let audioChannels = null;
    if (audioGroups != null && audioGroups.length) try {
        if (audioGroups.length === 1 && audioGroups[0]) audioChannels = audioTracksByGroup.groups[audioGroups[0]].channels;
        else audioChannels = audioGroups.reduce((acc, groupId)=>{
            if (groupId) {
                const audioTrackGroup = audioTracksByGroup.groups[groupId];
                if (!audioTrackGroup) throw new Error(`Audio track group ${groupId} not found`);
                // Sum all channel key values
                Object.keys(audioTrackGroup.channels).forEach((key)=>{
                    acc[key] = (acc[key] || 0) + audioTrackGroup.channels[key];
                });
            }
            return acc;
        }, {
            2: 0
        });
    } catch (error) {
        return true;
    }
    return videoCodecs !== undefined && // Force media capabilities check for HEVC to avoid failure on Windows
    (videoCodecs.split(',').some((videoCodec)=>$b941786f4eb9cb76$var$isHEVC(videoCodec)) || level.width > 1920 && level.height > 1088 || level.height > 1920 && level.width > 1088 || level.frameRate > Math.max(currentFrameRate, 30) || level.videoRange !== 'SDR' && level.videoRange !== currentVideoRange || level.bitrate > Math.max(currentBw, 8e6)) || !!audioChannels && $b941786f4eb9cb76$var$isFiniteNumber(maxChannels) && Object.keys(audioChannels).some((channels)=>parseInt(channels) > maxChannels);
}
function $b941786f4eb9cb76$var$getMediaDecodingInfoPromise(level, audioTracksByGroup, mediaCapabilities, cache = {}) {
    const videoCodecs = level.videoCodec;
    if (!videoCodecs && !level.audioCodec || !mediaCapabilities) return Promise.resolve($b941786f4eb9cb76$var$SUPPORTED_INFO_DEFAULT);
    const configurations = [];
    const videoDecodeList = $b941786f4eb9cb76$var$makeVideoConfigurations(level);
    const videoCount = videoDecodeList.length;
    const audioDecodeList = $b941786f4eb9cb76$var$makeAudioConfigurations(level, audioTracksByGroup, videoCount > 0);
    const audioCount = audioDecodeList.length;
    for(let i = videoCount || 1 * audioCount || 1; i--;){
        const configuration = {
            type: 'media-source'
        };
        if (videoCount) configuration.video = videoDecodeList[i % videoCount];
        if (audioCount) {
            configuration.audio = audioDecodeList[i % audioCount];
            const audioBitrate = configuration.audio.bitrate;
            if (configuration.video && audioBitrate) configuration.video.bitrate -= audioBitrate;
        }
        configurations.push(configuration);
    }
    if (videoCodecs) {
        // Override Windows Firefox HEVC MediaCapabilities result (https://github.com/video-dev/hls.js/issues/7046)
        const ua = navigator.userAgent;
        if (videoCodecs.split(',').some((videoCodec)=>$b941786f4eb9cb76$var$isHEVC(videoCodec)) && $b941786f4eb9cb76$var$userAgentHevcSupportIsInaccurate()) return Promise.resolve($b941786f4eb9cb76$var$getUnsupportedResult(new Error(`Overriding Windows Firefox HEVC MediaCapabilities result based on user-agent string: (${ua})`), configurations));
    }
    return Promise.all(configurations.map((configuration)=>{
        // Cache MediaCapabilities promises
        const decodingInfoKey = $b941786f4eb9cb76$var$getMediaDecodingInfoKey(configuration);
        return cache[decodingInfoKey] || (cache[decodingInfoKey] = mediaCapabilities.decodingInfo(configuration));
    })).then((decodingInfoResults)=>({
            supported: !decodingInfoResults.some((info)=>!info.supported),
            configurations: configurations,
            decodingInfoResults: decodingInfoResults
        })).catch((error)=>({
            supported: false,
            configurations: configurations,
            decodingInfoResults: [],
            error: error
        }));
}
function $b941786f4eb9cb76$var$makeVideoConfigurations(level) {
    var _level$videoCodec;
    const videoCodecs = (_level$videoCodec = level.videoCodec) == null ? void 0 : _level$videoCodec.split(',');
    const bitrate = $b941786f4eb9cb76$var$getVariantDecodingBitrate(level);
    const width = level.width || 640;
    const height = level.height || 480;
    // Assume a framerate of 30fps since MediaCapabilities will not accept Level default of 0.
    const framerate = level.frameRate || 30;
    const videoRange = level.videoRange.toLowerCase();
    return videoCodecs ? videoCodecs.map((videoCodec)=>{
        const videoConfiguration = {
            contentType: $b941786f4eb9cb76$var$mimeTypeForCodec($b941786f4eb9cb76$var$fillInMissingAV01Params(videoCodec), 'video'),
            width: width,
            height: height,
            bitrate: bitrate,
            framerate: framerate
        };
        if (videoRange !== 'sdr') videoConfiguration.transferFunction = videoRange;
        return videoConfiguration;
    }) : [];
}
function $b941786f4eb9cb76$var$makeAudioConfigurations(level, audioTracksByGroup, hasVideo) {
    var _level$audioCodec;
    const audioCodecs = (_level$audioCodec = level.audioCodec) == null ? void 0 : _level$audioCodec.split(',');
    const combinedBitrate = $b941786f4eb9cb76$var$getVariantDecodingBitrate(level);
    if (audioCodecs && level.audioGroups) return level.audioGroups.reduce((configurations, audioGroupId)=>{
        var _audioTracksByGroup$g;
        const tracks = audioGroupId ? (_audioTracksByGroup$g = audioTracksByGroup.groups[audioGroupId]) == null ? void 0 : _audioTracksByGroup$g.tracks : null;
        if (tracks) return tracks.reduce((configs, audioTrack)=>{
            if (audioTrack.groupId === audioGroupId) {
                const channelsNumber = parseFloat(audioTrack.channels || '');
                audioCodecs.forEach((audioCodec)=>{
                    const audioConfiguration = {
                        contentType: $b941786f4eb9cb76$var$mimeTypeForCodec(audioCodec, 'audio'),
                        bitrate: hasVideo ? $b941786f4eb9cb76$var$estimatedAudioBitrate(audioCodec, combinedBitrate) : combinedBitrate
                    };
                    if (channelsNumber) audioConfiguration.channels = '' + channelsNumber;
                    configs.push(audioConfiguration);
                });
            }
            return configs;
        }, configurations);
        return configurations;
    }, []);
    return [];
}
function $b941786f4eb9cb76$var$estimatedAudioBitrate(audioCodec, levelBitrate) {
    if (levelBitrate <= 1) return 1;
    let audioBitrate = 128000;
    if (audioCodec === 'ec-3') audioBitrate = 768000;
    else if (audioCodec === 'ac-3') audioBitrate = 640000;
    return Math.min(levelBitrate / 2, audioBitrate); // Don't exceed some % of level bitrate
}
function $b941786f4eb9cb76$var$getVariantDecodingBitrate(level) {
    return Math.ceil(Math.max(level.bitrate * 0.9, level.averageBitrate) / 1000) * 1000 || 1;
}
function $b941786f4eb9cb76$var$getMediaDecodingInfoKey(config) {
    let key = '';
    const { audio: audio, video: video } = config;
    if (video) {
        const codec = $b941786f4eb9cb76$var$getCodecsForMimeType(video.contentType);
        key += `${codec}_r${video.height}x${video.width}f${Math.ceil(video.framerate)}${video.transferFunction || 'sd'}_${Math.ceil(video.bitrate / 1e5)}`;
    }
    if (audio) {
        const codec = $b941786f4eb9cb76$var$getCodecsForMimeType(audio.contentType);
        key += `${video ? '_' : ''}${codec}_c${audio.channels}`;
    }
    return key;
}
const $b941786f4eb9cb76$var$HdcpLevels = [
    'NONE',
    'TYPE-0',
    'TYPE-1',
    null
];
function $b941786f4eb9cb76$var$isHdcpLevel(value) {
    return $b941786f4eb9cb76$var$HdcpLevels.indexOf(value) > -1;
}
const $b941786f4eb9cb76$var$VideoRangeValues = [
    'SDR',
    'PQ',
    'HLG'
];
function $b941786f4eb9cb76$var$isVideoRange(value) {
    return !!value && $b941786f4eb9cb76$var$VideoRangeValues.indexOf(value) > -1;
}
var $b941786f4eb9cb76$export$5d29c5ea940312ed = {
    No: "",
    Yes: "YES",
    v2: "v2"
};
function $b941786f4eb9cb76$var$getSkipValue(details) {
    const { canSkipUntil: canSkipUntil, canSkipDateRanges: canSkipDateRanges, age: age } = details;
    // A Client SHOULD NOT request a Playlist Delta Update unless it already
    // has a version of the Playlist that is no older than one-half of the Skip Boundary.
    // @see: https://datatracker.ietf.org/doc/html/draft-pantos-hls-rfc8216bis#section-6.3.7
    const playlistRecentEnough = age < canSkipUntil / 2;
    if (canSkipUntil && playlistRecentEnough) {
        if (canSkipDateRanges) return $b941786f4eb9cb76$export$5d29c5ea940312ed.v2;
        return $b941786f4eb9cb76$export$5d29c5ea940312ed.Yes;
    }
    return $b941786f4eb9cb76$export$5d29c5ea940312ed.No;
}
class $b941786f4eb9cb76$export$b1713430eaae90a7 {
    constructor(msn, part, skip){
        this.msn = void 0;
        this.part = void 0;
        this.skip = void 0;
        this.msn = msn;
        this.part = part;
        this.skip = skip;
    }
    addDirectives(uri) {
        const url = new self.URL(uri);
        if (this.msn !== undefined) url.searchParams.set('_HLS_msn', this.msn.toString());
        if (this.part !== undefined) url.searchParams.set('_HLS_part', this.part.toString());
        if (this.skip) url.searchParams.set('_HLS_skip', this.skip);
        return url.href;
    }
}
class $b941786f4eb9cb76$export$ca664994d1d54bff {
    constructor(data){
        this._attrs = void 0;
        this.audioCodec = void 0;
        this.bitrate = void 0;
        this.codecSet = void 0;
        this.url = void 0;
        this.frameRate = void 0;
        this.height = void 0;
        this.id = void 0;
        this.name = void 0;
        this.supplemental = void 0;
        this.videoCodec = void 0;
        this.width = void 0;
        this.details = void 0;
        this.fragmentError = 0;
        this.loadError = 0;
        this.loaded = void 0;
        this.realBitrate = 0;
        this.supportedPromise = void 0;
        this.supportedResult = void 0;
        this._avgBitrate = 0;
        this._audioGroups = void 0;
        this._subtitleGroups = void 0;
        // Deprecated (retained for backwards compatibility)
        this._urlId = 0;
        this.url = [
            data.url
        ];
        this._attrs = [
            data.attrs
        ];
        this.bitrate = data.bitrate;
        if (data.details) this.details = data.details;
        this.id = data.id || 0;
        this.name = data.name;
        this.width = data.width || 0;
        this.height = data.height || 0;
        this.frameRate = data.attrs.optionalFloat('FRAME-RATE', 0);
        this._avgBitrate = data.attrs.decimalInteger('AVERAGE-BANDWIDTH');
        this.audioCodec = data.audioCodec;
        this.videoCodec = data.videoCodec;
        this.codecSet = [
            data.videoCodec,
            data.audioCodec
        ].filter((c)=>!!c).map((s)=>s.substring(0, 4)).join(',');
        if ('supplemental' in data) {
            var _data$supplemental;
            this.supplemental = data.supplemental;
            const supplementalVideo = (_data$supplemental = data.supplemental) == null ? void 0 : _data$supplemental.videoCodec;
            if (supplementalVideo && supplementalVideo !== data.videoCodec) this.codecSet += `,${supplementalVideo.substring(0, 4)}`;
        }
        this.addGroupId('audio', data.attrs.AUDIO);
        this.addGroupId('text', data.attrs.SUBTITLES);
    }
    get maxBitrate() {
        return Math.max(this.realBitrate, this.bitrate);
    }
    get averageBitrate() {
        return this._avgBitrate || this.realBitrate || this.bitrate;
    }
    get attrs() {
        return this._attrs[0];
    }
    get codecs() {
        return this.attrs.CODECS || '';
    }
    get pathwayId() {
        return this.attrs['PATHWAY-ID'] || '.';
    }
    get videoRange() {
        return this.attrs['VIDEO-RANGE'] || 'SDR';
    }
    get score() {
        return this.attrs.optionalFloat('SCORE', 0);
    }
    get uri() {
        return this.url[0] || '';
    }
    hasAudioGroup(groupId) {
        return $b941786f4eb9cb76$var$hasGroup(this._audioGroups, groupId);
    }
    hasSubtitleGroup(groupId) {
        return $b941786f4eb9cb76$var$hasGroup(this._subtitleGroups, groupId);
    }
    get audioGroups() {
        return this._audioGroups;
    }
    get subtitleGroups() {
        return this._subtitleGroups;
    }
    addGroupId(type, groupId) {
        if (!groupId) return;
        if (type === 'audio') {
            let audioGroups = this._audioGroups;
            if (!audioGroups) audioGroups = this._audioGroups = [];
            if (audioGroups.indexOf(groupId) === -1) audioGroups.push(groupId);
        } else if (type === 'text') {
            let subtitleGroups = this._subtitleGroups;
            if (!subtitleGroups) subtitleGroups = this._subtitleGroups = [];
            if (subtitleGroups.indexOf(groupId) === -1) subtitleGroups.push(groupId);
        }
    }
    // Deprecated methods (retained for backwards compatibility)
    get urlId() {
        return 0;
    }
    set urlId(value) {}
    get audioGroupIds() {
        return this.audioGroups ? [
            this.audioGroupId
        ] : undefined;
    }
    get textGroupIds() {
        return this.subtitleGroups ? [
            this.textGroupId
        ] : undefined;
    }
    get audioGroupId() {
        var _this$audioGroups;
        return (_this$audioGroups = this.audioGroups) == null ? void 0 : _this$audioGroups[0];
    }
    get textGroupId() {
        var _this$subtitleGroups;
        return (_this$subtitleGroups = this.subtitleGroups) == null ? void 0 : _this$subtitleGroups[0];
    }
    addFallback() {}
}
function $b941786f4eb9cb76$var$hasGroup(groups, groupId) {
    if (!groupId || !groups) return false;
    return groups.indexOf(groupId) !== -1;
}
/**
 * @returns Whether we can detect and validate HDR capability within the window context
 */ function $b941786f4eb9cb76$var$isHdrSupported() {
    if (typeof matchMedia === 'function') {
        const mediaQueryList = matchMedia('(dynamic-range: high)');
        const badQuery = matchMedia('bad query');
        if (mediaQueryList.media !== badQuery.media) return mediaQueryList.matches === true;
    }
    return false;
}
/**
 * Sanitizes inputs to return the active video selection options for HDR/SDR.
 * When both inputs are null:
 *
 *    `{ preferHDR: false, allowedVideoRanges: [] }`
 *
 * When `currentVideoRange` non-null, maintain the active range:
 *
 *    `{ preferHDR: currentVideoRange !== 'SDR', allowedVideoRanges: [currentVideoRange] }`
 *
 * When VideoSelectionOption non-null:
 *
 *  - Allow all video ranges if `allowedVideoRanges` unspecified.
 *  - If `preferHDR` is non-null use the value to filter `allowedVideoRanges`.
 *  - Else check window for HDR support and set `preferHDR` to the result.
 *
 * @param currentVideoRange
 * @param videoPreference
 */ function $b941786f4eb9cb76$var$getVideoSelectionOptions(currentVideoRange, videoPreference) {
    let preferHDR = false;
    let allowedVideoRanges = [];
    if (currentVideoRange) {
        preferHDR = currentVideoRange !== 'SDR';
        allowedVideoRanges = [
            currentVideoRange
        ];
    }
    if (videoPreference) {
        allowedVideoRanges = videoPreference.allowedVideoRanges || $b941786f4eb9cb76$var$VideoRangeValues.slice(0);
        const allowAutoPreferHDR = allowedVideoRanges.join('') !== 'SDR' && !videoPreference.videoCodec;
        preferHDR = videoPreference.preferHDR !== undefined ? videoPreference.preferHDR : allowAutoPreferHDR && $b941786f4eb9cb76$var$isHdrSupported();
        if (!preferHDR) allowedVideoRanges = [
            'SDR'
        ];
    }
    return {
        preferHDR: preferHDR,
        allowedVideoRanges: allowedVideoRanges
    };
}
const $b941786f4eb9cb76$var$omitCircularRefsReplacer = (replacer)=>{
    const known = new WeakSet();
    return (_, value)=>{
        if (replacer) value = replacer(_, value);
        if (typeof value === 'object' && value !== null) {
            if (known.has(value)) return;
            known.add(value);
        }
        return value;
    };
};
const $b941786f4eb9cb76$var$stringify = (object, replacer)=>JSON.stringify(object, $b941786f4eb9cb76$var$omitCircularRefsReplacer(replacer));
function $b941786f4eb9cb76$var$getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference) {
    const codecSets = Object.keys(codecTiers);
    const channelsPreference = audioPreference == null ? void 0 : audioPreference.channels;
    const audioCodecPreference = audioPreference == null ? void 0 : audioPreference.audioCodec;
    const videoCodecPreference = videoPreference == null ? void 0 : videoPreference.videoCodec;
    const preferStereo = channelsPreference && parseInt(channelsPreference) === 2;
    // Use first level set to determine stereo, and minimum resolution and framerate
    let hasStereo = false;
    let hasCurrentVideoRange = false;
    let minHeight = Infinity;
    let minFramerate = Infinity;
    let minBitrate = Infinity;
    let minIndex = Infinity;
    let selectedScore = 0;
    let videoRanges = [];
    const { preferHDR: preferHDR, allowedVideoRanges: allowedVideoRanges } = $b941786f4eb9cb76$var$getVideoSelectionOptions(currentVideoRange, videoPreference);
    for(let i = codecSets.length; i--;){
        const tier = codecTiers[codecSets[i]];
        hasStereo || (hasStereo = tier.channels[2] > 0);
        minHeight = Math.min(minHeight, tier.minHeight);
        minFramerate = Math.min(minFramerate, tier.minFramerate);
        minBitrate = Math.min(minBitrate, tier.minBitrate);
        const matchingVideoRanges = allowedVideoRanges.filter((range)=>tier.videoRanges[range] > 0);
        if (matchingVideoRanges.length > 0) hasCurrentVideoRange = true;
    }
    minHeight = $b941786f4eb9cb76$var$isFiniteNumber(minHeight) ? minHeight : 0;
    minFramerate = $b941786f4eb9cb76$var$isFiniteNumber(minFramerate) ? minFramerate : 0;
    const maxHeight = Math.max(1080, minHeight);
    const maxFramerate = Math.max(30, minFramerate);
    minBitrate = $b941786f4eb9cb76$var$isFiniteNumber(minBitrate) ? minBitrate : currentBw;
    currentBw = Math.max(minBitrate, currentBw);
    // If there are no variants with matching preference, set currentVideoRange to undefined
    if (!hasCurrentVideoRange) currentVideoRange = undefined;
    const hasMultipleSets = codecSets.length > 1;
    const codecSet = codecSets.reduce((selected, candidate)=>{
        // Remove candiates which do not meet bitrate, default audio, stereo or channels preference, 1080p or lower, 30fps or lower, or SDR/HDR selection if present
        const candidateTier = codecTiers[candidate];
        if (candidate === selected) return selected;
        videoRanges = hasCurrentVideoRange ? allowedVideoRanges.filter((range)=>candidateTier.videoRanges[range] > 0) : [];
        if (hasMultipleSets) {
            if (candidateTier.minBitrate > currentBw) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `min bitrate of ${candidateTier.minBitrate} > current estimate of ${currentBw}`);
                return selected;
            }
            if (!candidateTier.hasDefaultAudio) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `no renditions with default or auto-select sound found`);
                return selected;
            }
            if (audioCodecPreference && candidate.indexOf(audioCodecPreference.substring(0, 4)) % 5 !== 0) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `audio codec preference "${audioCodecPreference}" not found`);
                return selected;
            }
            if (channelsPreference && !preferStereo) {
                if (!candidateTier.channels[channelsPreference]) {
                    $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `no renditions with ${channelsPreference} channel sound found (channels options: ${Object.keys(candidateTier.channels)})`);
                    return selected;
                }
            } else if ((!audioCodecPreference || preferStereo) && hasStereo && candidateTier.channels['2'] === 0) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `no renditions with stereo sound found`);
                return selected;
            }
            if (candidateTier.minHeight > maxHeight) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `min resolution of ${candidateTier.minHeight} > maximum of ${maxHeight}`);
                return selected;
            }
            if (candidateTier.minFramerate > maxFramerate) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `min framerate of ${candidateTier.minFramerate} > maximum of ${maxFramerate}`);
                return selected;
            }
            if (!videoRanges.some((range)=>candidateTier.videoRanges[range] > 0)) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `no variants with VIDEO-RANGE of ${$b941786f4eb9cb76$var$stringify(videoRanges)} found`);
                return selected;
            }
            if (videoCodecPreference && candidate.indexOf(videoCodecPreference.substring(0, 4)) % 5 !== 0) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `video codec preference "${videoCodecPreference}" not found`);
                return selected;
            }
            if (candidateTier.maxScore < selectedScore) {
                $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(candidate, `max score of ${candidateTier.maxScore} < selected max of ${selectedScore}`);
                return selected;
            }
        }
        // Remove candiates with less preferred codecs or more errors
        if (selected && ($b941786f4eb9cb76$var$codecsSetSelectionPreferenceValue(candidate) >= $b941786f4eb9cb76$var$codecsSetSelectionPreferenceValue(selected) || candidateTier.fragmentError > codecTiers[selected].fragmentError)) return selected;
        minIndex = candidateTier.minIndex;
        selectedScore = candidateTier.maxScore;
        return candidate;
    }, undefined);
    return {
        codecSet: codecSet,
        videoRanges: videoRanges,
        preferHDR: preferHDR,
        minFramerate: minFramerate,
        minBitrate: minBitrate,
        minIndex: minIndex
    };
}
function $b941786f4eb9cb76$var$logStartCodecCandidateIgnored(codeSet, reason) {
    $b941786f4eb9cb76$var$logger.log(`[abr] start candidates with "${codeSet}" ignored because ${reason}`);
}
function $b941786f4eb9cb76$var$getAudioTracksByGroup(allAudioTracks) {
    return allAudioTracks.reduce((audioTracksByGroup, track)=>{
        let trackGroup = audioTracksByGroup.groups[track.groupId];
        if (!trackGroup) trackGroup = audioTracksByGroup.groups[track.groupId] = {
            tracks: [],
            channels: {
                2: 0
            },
            hasDefault: false,
            hasAutoSelect: false
        };
        trackGroup.tracks.push(track);
        const channelsKey = track.channels || '2';
        trackGroup.channels[channelsKey] = (trackGroup.channels[channelsKey] || 0) + 1;
        trackGroup.hasDefault = trackGroup.hasDefault || track.default;
        trackGroup.hasAutoSelect = trackGroup.hasAutoSelect || track.autoselect;
        if (trackGroup.hasDefault) audioTracksByGroup.hasDefaultAudio = true;
        if (trackGroup.hasAutoSelect) audioTracksByGroup.hasAutoSelectAudio = true;
        return audioTracksByGroup;
    }, {
        hasDefaultAudio: false,
        hasAutoSelectAudio: false,
        groups: {}
    });
}
function $b941786f4eb9cb76$var$getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel) {
    return levels.slice(minAutoLevel, maxAutoLevel + 1).reduce((tiers, level, index)=>{
        if (!level.codecSet) return tiers;
        const audioGroups = level.audioGroups;
        let tier = tiers[level.codecSet];
        if (!tier) tiers[level.codecSet] = tier = {
            minBitrate: Infinity,
            minHeight: Infinity,
            minFramerate: Infinity,
            minIndex: index,
            maxScore: 0,
            videoRanges: {
                SDR: 0
            },
            channels: {
                '2': 0
            },
            hasDefaultAudio: !audioGroups,
            fragmentError: 0
        };
        tier.minBitrate = Math.min(tier.minBitrate, level.bitrate);
        const lesserWidthOrHeight = Math.min(level.height, level.width);
        tier.minHeight = Math.min(tier.minHeight, lesserWidthOrHeight);
        tier.minFramerate = Math.min(tier.minFramerate, level.frameRate);
        tier.minIndex = Math.min(tier.minIndex, index);
        tier.maxScore = Math.max(tier.maxScore, level.score);
        tier.fragmentError += level.fragmentError;
        tier.videoRanges[level.videoRange] = (tier.videoRanges[level.videoRange] || 0) + 1;
        if (audioGroups) audioGroups.forEach((audioGroupId)=>{
            if (!audioGroupId) return;
            const audioGroup = audioTracksByGroup.groups[audioGroupId];
            if (!audioGroup) return;
            // Default audio is any group with DEFAULT=YES, or if missing then any group with AUTOSELECT=YES, or all variants
            tier.hasDefaultAudio = tier.hasDefaultAudio || audioTracksByGroup.hasDefaultAudio ? audioGroup.hasDefault : audioGroup.hasAutoSelect || !audioTracksByGroup.hasDefaultAudio && !audioTracksByGroup.hasAutoSelectAudio;
            Object.keys(audioGroup.channels).forEach((channels)=>{
                tier.channels[channels] = (tier.channels[channels] || 0) + audioGroup.channels[channels];
            });
        });
        return tiers;
    }, {});
}
function $b941786f4eb9cb76$var$getBasicSelectionOption(option) {
    if (!option) return option;
    const { lang: lang, assocLang: assocLang, characteristics: characteristics, channels: channels, audioCodec: audioCodec } = option;
    return {
        lang: lang,
        assocLang: assocLang,
        characteristics: characteristics,
        channels: channels,
        audioCodec: audioCodec
    };
}
function $b941786f4eb9cb76$var$findMatchingOption(option, tracks, matchPredicate) {
    if ('attrs' in option) {
        const index = tracks.indexOf(option);
        if (index !== -1) return index;
    }
    for(let i = 0; i < tracks.length; i++){
        const track = tracks[i];
        if ($b941786f4eb9cb76$var$matchesOption(option, track, matchPredicate)) return i;
    }
    return -1;
}
function $b941786f4eb9cb76$var$matchesOption(option, track, matchPredicate) {
    const { groupId: groupId, name: name, lang: lang, assocLang: assocLang, default: isDefault } = option;
    const forced = option.forced;
    return (groupId === undefined || track.groupId === groupId) && (name === undefined || track.name === name) && (lang === undefined || $b941786f4eb9cb76$var$languagesMatch(lang, track.lang)) && (lang === undefined || track.assocLang === assocLang) && (isDefault === undefined || track.default === isDefault) && (forced === undefined || track.forced === forced) && (!('characteristics' in option) || $b941786f4eb9cb76$var$characteristicsMatch(option.characteristics || '', track.characteristics)) && (matchPredicate === undefined || matchPredicate(option, track));
}
function $b941786f4eb9cb76$var$languagesMatch(languageA, languageB = '--') {
    if (languageA.length === languageB.length) return languageA === languageB;
    return languageA.startsWith(languageB) || languageB.startsWith(languageA);
}
function $b941786f4eb9cb76$var$characteristicsMatch(characteristicsA, characteristicsB = '') {
    const arrA = characteristicsA.split(',');
    const arrB = characteristicsB.split(',');
    // Expects each item to be unique:
    return arrA.length === arrB.length && !arrA.some((el)=>arrB.indexOf(el) === -1);
}
function $b941786f4eb9cb76$var$audioMatchPredicate(option, track) {
    const { audioCodec: audioCodec, channels: channels } = option;
    return (audioCodec === undefined || (track.audioCodec || '').substring(0, 4) === audioCodec.substring(0, 4)) && (channels === undefined || channels === (track.channels || '2'));
}
function $b941786f4eb9cb76$var$findClosestLevelWithAudioGroup(option, levels, allAudioTracks, searchIndex, matchPredicate) {
    const currentLevel = levels[searchIndex];
    // Are there variants with same URI as current level?
    // If so, find a match that does not require any level URI change
    const variants = levels.reduce((variantMap, level, index)=>{
        const uri = level.uri;
        const renditions = variantMap[uri] || (variantMap[uri] = []);
        renditions.push(index);
        return variantMap;
    }, {});
    const renditions = variants[currentLevel.uri];
    if (renditions.length > 1) searchIndex = Math.max.apply(Math, renditions);
    // Find best match
    const currentVideoRange = currentLevel.videoRange;
    const currentFrameRate = currentLevel.frameRate;
    const currentVideoCodec = currentLevel.codecSet.substring(0, 4);
    const matchingVideo = $b941786f4eb9cb76$var$searchDownAndUpList(levels, searchIndex, (level)=>{
        if (level.videoRange !== currentVideoRange || level.frameRate !== currentFrameRate || level.codecSet.substring(0, 4) !== currentVideoCodec) return false;
        const audioGroups = level.audioGroups;
        const tracks = allAudioTracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
        return $b941786f4eb9cb76$var$findMatchingOption(option, tracks, matchPredicate) > -1;
    });
    if (matchingVideo > -1) return matchingVideo;
    return $b941786f4eb9cb76$var$searchDownAndUpList(levels, searchIndex, (level)=>{
        const audioGroups = level.audioGroups;
        const tracks = allAudioTracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
        return $b941786f4eb9cb76$var$findMatchingOption(option, tracks, matchPredicate) > -1;
    });
}
function $b941786f4eb9cb76$var$searchDownAndUpList(arr, searchIndex, predicate) {
    for(let i = searchIndex; i > -1; i--){
        if (predicate(arr[i])) return i;
    }
    for(let i = searchIndex + 1; i < arr.length; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}
function $b941786f4eb9cb76$var$useAlternateAudio(audioTrackUrl, hls) {
    var _hls$loadLevelObj;
    return !!audioTrackUrl && audioTrackUrl !== ((_hls$loadLevelObj = hls.loadLevelObj) == null ? void 0 : _hls$loadLevelObj.uri);
}
class $b941786f4eb9cb76$export$264ac4b6e832e14e extends $b941786f4eb9cb76$var$Logger {
    constructor(_hls){
        super('abr', _hls.logger);
        this.hls = void 0;
        this.lastLevelLoadSec = 0;
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        this._nextAutoLevel = -1;
        this.nextAutoLevelKey = '';
        this.audioTracksByGroup = null;
        this.codecTiers = null;
        this.timer = -1;
        this.fragCurrent = null;
        this.partCurrent = null;
        this.bitrateTestDelay = 0;
        this.rebufferNotice = -1;
        this.supportedCache = {};
        this.bwEstimator = void 0;
        /*
        This method monitors the download rate of the current fragment, and will downswitch if that fragment will not load
        quickly enough to prevent underbuffering
      */ this._abandonRulesCheck = (levelLoaded)=>{
            var _ref;
            const { fragCurrent: frag, partCurrent: part, hls: hls } = this;
            const { autoLevelEnabled: autoLevelEnabled, media: media } = hls;
            if (!frag || !media) return;
            const now = performance.now();
            const stats = part ? part.stats : frag.stats;
            const duration = part ? part.duration : frag.duration;
            const timeLoading = now - stats.loading.start;
            const minAutoLevel = hls.minAutoLevel;
            const loadingFragForLevel = frag.level;
            const currentAutoLevel = this._nextAutoLevel;
            // If frag loading is aborted, complete, or from lowest level, stop timer and return
            if (stats.aborted || stats.loaded && stats.loaded === stats.total || loadingFragForLevel <= minAutoLevel) {
                this.clearTimer();
                // reset forced auto level value so that next level will be selected
                this._nextAutoLevel = -1;
                return;
            }
            // This check only runs if we're in ABR mode
            if (!autoLevelEnabled) return;
            // Must be loading/loaded a new level or be in a playing state
            const fragBlockingSwitch = currentAutoLevel > -1 && currentAutoLevel !== loadingFragForLevel;
            const levelChange = !!levelLoaded || fragBlockingSwitch;
            if (!levelChange && (media.paused || !media.playbackRate || !media.readyState)) return;
            const bufferInfo = hls.mainForwardBufferInfo;
            if (!levelChange && bufferInfo === null) return;
            const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
            const playbackRate = Math.abs(media.playbackRate);
            // To maintain stable adaptive playback, only begin monitoring frag loading after half or more of its playback duration has passed
            if (timeLoading <= Math.max(ttfbEstimate, 1000 * (duration / (playbackRate * 2)))) return;
            // bufferStarvationDelay is an estimate of the amount time (in seconds) it will take to exhaust the buffer
            const bufferStarvationDelay = bufferInfo ? bufferInfo.len / playbackRate : 0;
            const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
            const loadedFirstByte = stats.loaded && ttfb > -1;
            const bwEstimate = this.getBwEstimate();
            const levels = hls.levels;
            const level = levels[loadingFragForLevel];
            const expectedLen = Math.max(stats.loaded, Math.round(duration * (frag.bitrate || level.averageBitrate) / 8));
            let timeStreaming = loadedFirstByte ? timeLoading - ttfb : timeLoading;
            if (timeStreaming < 1 && loadedFirstByte) timeStreaming = Math.min(timeLoading, stats.loaded * 8 / bwEstimate);
            const loadRate = loadedFirstByte ? stats.loaded * 1000 / timeStreaming : 0;
            // fragLoadDelay is an estimate of the time (in seconds) it will take to buffer the remainder of the fragment
            const ttfbSeconds = ttfbEstimate / 1000;
            const fragLoadedDelay = loadRate ? (expectedLen - stats.loaded) / loadRate : expectedLen * 8 / bwEstimate + ttfbSeconds;
            // Only downswitch if the time to finish loading the current fragment is greater than the amount of buffer left
            if (fragLoadedDelay <= bufferStarvationDelay) return;
            const bwe = loadRate ? loadRate * 8 : bwEstimate;
            const live = ((_ref = (levelLoaded == null ? void 0 : levelLoaded.details) || this.hls.latestLevelDetails) == null ? void 0 : _ref.live) === true;
            const abrBandWidthUpFactor = this.hls.config.abrBandWidthUpFactor;
            let fragLevelNextLoadedDelay = Number.POSITIVE_INFINITY;
            let nextLoadLevel;
            // Iterate through lower level and try to find the largest one that avoids rebuffering
            for(nextLoadLevel = loadingFragForLevel - 1; nextLoadLevel > minAutoLevel; nextLoadLevel--){
                // compute time to load next fragment at lower level
                // 8 = bits per byte (bps/Bps)
                const levelNextBitrate = levels[nextLoadLevel].maxBitrate;
                const requiresLevelLoad = !levels[nextLoadLevel].details || live;
                fragLevelNextLoadedDelay = this.getTimeToLoadFrag(ttfbSeconds, bwe, duration * levelNextBitrate, requiresLevelLoad);
                if (fragLevelNextLoadedDelay < Math.min(bufferStarvationDelay, duration + ttfbSeconds)) break;
            }
            // Only emergency switch down if it takes less time to load a new fragment at lowest level instead of continuing
            // to load the current one
            if (fragLevelNextLoadedDelay >= fragLoadedDelay) return;
            // if estimated load time of new segment is completely unreasonable, ignore and do not emergency switch down
            if (fragLevelNextLoadedDelay > duration * 10) return;
            if (loadedFirstByte) // If there has been loading progress, sample bandwidth using loading time offset by minimum TTFB time
            this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
            else // If there has been no loading progress, sample TTFB
            this.bwEstimator.sampleTTFB(timeLoading);
            const nextLoadLevelBitrate = levels[nextLoadLevel].maxBitrate;
            if (this.getBwEstimate() * abrBandWidthUpFactor > nextLoadLevelBitrate) this.resetEstimator(nextLoadLevelBitrate);
            const bestSwitchLevel = this.findBestLevel(nextLoadLevelBitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
            if (bestSwitchLevel > -1) nextLoadLevel = bestSwitchLevel;
            this.warn(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of level ${loadingFragForLevel} is loading too slowly;
      Fragment duration: ${frag.duration.toFixed(3)}
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s
      Estimated load time for current fragment: ${fragLoadedDelay.toFixed(3)} s
      Estimated load time for down switch fragment: ${fragLevelNextLoadedDelay.toFixed(3)} s
      TTFB estimate: ${ttfb | 0} ms
      Current BW estimate: ${$b941786f4eb9cb76$var$isFiniteNumber(bwEstimate) ? bwEstimate | 0 : 'Unknown'} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${nextLoadLevel} @ ${nextLoadLevelBitrate | 0} bps`);
            hls.nextLoadLevel = hls.nextAutoLevel = nextLoadLevel;
            this.clearTimer();
            const abortAndSwitch = ()=>{
                // Are nextLoadLevel details available or is stream-controller still in "WAITING_LEVEL" state?
                this.clearTimer();
                if (this.fragCurrent === frag && this.hls.loadLevel === nextLoadLevel && nextLoadLevel > 0) {
                    const bufferStarvationDelay = this.getStarvationDelay();
                    this.warn(`Aborting inflight request ${nextLoadLevel > 0 ? 'and switching down' : ''}
      Fragment duration: ${frag.duration.toFixed(3)} s
      Time to underbuffer: ${bufferStarvationDelay.toFixed(3)} s`);
                    frag.abortRequests();
                    this.fragCurrent = this.partCurrent = null;
                    if (nextLoadLevel > minAutoLevel) {
                        let lowestSwitchLevel = this.findBestLevel(this.hls.levels[minAutoLevel].bitrate, minAutoLevel, nextLoadLevel, 0, bufferStarvationDelay, 1, 1);
                        if (lowestSwitchLevel === -1) lowestSwitchLevel = minAutoLevel;
                        this.hls.nextLoadLevel = this.hls.nextAutoLevel = lowestSwitchLevel;
                        this.resetEstimator(this.hls.levels[lowestSwitchLevel].bitrate);
                    }
                }
            };
            if (fragBlockingSwitch || fragLoadedDelay > fragLevelNextLoadedDelay * 2) abortAndSwitch();
            else this.timer = self.setInterval(abortAndSwitch, fragLevelNextLoadedDelay * 1000);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOAD_EMERGENCY_ABORTED, {
                frag: frag,
                part: part,
                stats: stats
            });
        };
        this.hls = _hls;
        this.bwEstimator = this.initEstimator();
        this.registerListeners();
    }
    resetEstimator(abrEwmaDefaultEstimate) {
        if (abrEwmaDefaultEstimate) {
            this.log(`setting initial bwe to ${abrEwmaDefaultEstimate}`);
            this.hls.config.abrEwmaDefaultEstimate = abrEwmaDefaultEstimate;
        }
        this.firstSelection = -1;
        this.bwEstimator = this.initEstimator();
    }
    initEstimator() {
        const config = this.hls.config;
        return new $b941786f4eb9cb76$var$EwmaBandWidthEstimator(config.abrEwmaSlowVoD, config.abrEwmaFastVoD, config.abrEwmaDefaultEstimate);
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    destroy() {
        this.unregisterListeners();
        this.clearTimer();
        // @ts-ignore
        this.hls = this._abandonRulesCheck = this.supportedCache = null;
        this.fragCurrent = this.partCurrent = null;
    }
    onManifestLoading(event, data) {
        this.lastLoadedFragLevel = -1;
        this.firstSelection = -1;
        this.lastLevelLoadSec = 0;
        this.supportedCache = {};
        this.fragCurrent = this.partCurrent = null;
        this.onLevelsUpdated();
        this.clearTimer();
    }
    onLevelsUpdated() {
        if (this.lastLoadedFragLevel > -1 && this.fragCurrent) this.lastLoadedFragLevel = this.fragCurrent.level;
        this._nextAutoLevel = -1;
        this.onMaxAutoLevelUpdated();
        this.codecTiers = null;
        this.audioTracksByGroup = null;
    }
    onMaxAutoLevelUpdated() {
        this.firstSelection = -1;
        this.nextAutoLevelKey = '';
    }
    onFragLoading(event, data) {
        const frag = data.frag;
        if (this.ignoreFragment(frag)) return;
        if (!frag.bitrateTest) {
            var _data$part;
            this.fragCurrent = frag;
            this.partCurrent = (_data$part = data.part) != null ? _data$part : null;
        }
        this.clearTimer();
        this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
    onLevelSwitching(event, data) {
        this.clearTimer();
    }
    onError(event, data) {
        if (data.fatal) return;
        switch(data.details){
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                // Reset last loaded level so that a new selection can be made after calling recoverMediaError
                this.lastLoadedFragLevel = -1;
                this.firstSelection = -1;
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
                {
                    const frag = data.frag;
                    const { fragCurrent: fragCurrent, partCurrent: part } = this;
                    if (frag && fragCurrent && frag.sn === fragCurrent.sn && frag.level === fragCurrent.level) {
                        const now = performance.now();
                        const stats = part ? part.stats : frag.stats;
                        const timeLoading = now - stats.loading.start;
                        const ttfb = stats.loading.first ? stats.loading.first - stats.loading.start : -1;
                        const loadedFirstByte = stats.loaded && ttfb > -1;
                        if (loadedFirstByte) {
                            const ttfbEstimate = this.bwEstimator.getEstimateTTFB();
                            this.bwEstimator.sample(timeLoading - Math.min(ttfbEstimate, ttfb), stats.loaded);
                        } else this.bwEstimator.sampleTTFB(timeLoading);
                    }
                    break;
                }
        }
    }
    getTimeToLoadFrag(timeToFirstByteSec, bandwidth, fragSizeBits, isSwitch) {
        const fragLoadSec = timeToFirstByteSec + fragSizeBits / bandwidth;
        const playlistLoadSec = isSwitch ? timeToFirstByteSec + this.lastLevelLoadSec : 0;
        return fragLoadSec + playlistLoadSec;
    }
    onLevelLoaded(event, data) {
        const config = this.hls.config;
        const { loading: loading } = data.stats;
        const timeLoadingMs = loading.end - loading.first;
        if ($b941786f4eb9cb76$var$isFiniteNumber(timeLoadingMs)) this.lastLevelLoadSec = timeLoadingMs / 1000;
        if (data.details.live) this.bwEstimator.update(config.abrEwmaSlowLive, config.abrEwmaFastLive);
        else this.bwEstimator.update(config.abrEwmaSlowVoD, config.abrEwmaFastVoD);
        if (this.timer > -1) this._abandonRulesCheck(data.levelInfo);
    }
    onFragLoaded(event, { frag: frag, part: part }) {
        const stats = part ? part.stats : frag.stats;
        if (frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) this.bwEstimator.sampleTTFB(stats.loading.first - stats.loading.start);
        if (this.ignoreFragment(frag)) return;
        // stop monitoring bw once frag loaded
        this.clearTimer();
        // reset forced auto level value so that next level will be selected
        if (frag.level === this._nextAutoLevel) this._nextAutoLevel = -1;
        this.firstSelection = -1;
        // compute level average bitrate
        if (this.hls.config.abrMaxWithRealBitrate) {
            const duration = part ? part.duration : frag.duration;
            const level = this.hls.levels[frag.level];
            const loadedBytes = (level.loaded ? level.loaded.bytes : 0) + stats.loaded;
            const loadedDuration = (level.loaded ? level.loaded.duration : 0) + duration;
            level.loaded = {
                bytes: loadedBytes,
                duration: loadedDuration
            };
            level.realBitrate = Math.round(8 * loadedBytes / loadedDuration);
        }
        if (frag.bitrateTest) {
            const fragBufferedData = {
                stats: stats,
                frag: frag,
                part: part,
                id: frag.type
            };
            this.onFragBuffered($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, fragBufferedData);
            frag.bitrateTest = false;
        } else // store level id after successful fragment load for playback
        this.lastLoadedFragLevel = frag.level;
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        const stats = part != null && part.stats.loaded ? part.stats : frag.stats;
        if (stats.aborted) return;
        if (this.ignoreFragment(frag)) return;
        // Use the difference between parsing and request instead of buffering and request to compute fragLoadingProcessing;
        // rationale is that buffer appending only happens once media is attached. This can happen when config.startFragPrefetch
        // is used. If we used buffering in that case, our BW estimate sample will be very large.
        const processingMs = stats.parsing.end - stats.loading.start - Math.min(stats.loading.first - stats.loading.start, this.bwEstimator.getEstimateTTFB());
        this.bwEstimator.sample(processingMs, stats.loaded);
        stats.bwEstimate = this.getBwEstimate();
        if (frag.bitrateTest) this.bitrateTestDelay = processingMs / 1000;
        else this.bitrateTestDelay = 0;
    }
    ignoreFragment(frag) {
        // Only count non-alt-audio frags which were actually buffered in our BW calculations
        return frag.type !== $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN || frag.sn === 'initSegment';
    }
    clearTimer() {
        if (this.timer > -1) {
            self.clearInterval(this.timer);
            this.timer = -1;
        }
    }
    get firstAutoLevel() {
        const { maxAutoLevel: maxAutoLevel, minAutoLevel: minAutoLevel } = this.hls;
        const bwEstimate = this.getBwEstimate();
        const maxStartDelay = this.hls.config.maxStarvationDelay;
        const abrAutoLevel = this.findBestLevel(bwEstimate, minAutoLevel, maxAutoLevel, 0, maxStartDelay, 1, 1);
        if (abrAutoLevel > -1) return abrAutoLevel;
        const firstLevel = this.hls.firstLevel;
        const clamped = Math.min(Math.max(firstLevel, minAutoLevel), maxAutoLevel);
        this.warn(`Could not find best starting auto level. Defaulting to first in playlist ${firstLevel} clamped to ${clamped}`);
        return clamped;
    }
    get forcedAutoLevel() {
        if (this.nextAutoLevelKey) return -1;
        return this._nextAutoLevel;
    }
    // return next auto level
    get nextAutoLevel() {
        const forcedAutoLevel = this.forcedAutoLevel;
        const bwEstimator = this.bwEstimator;
        const useEstimate = bwEstimator.canEstimate();
        const loadedFirstFrag = this.lastLoadedFragLevel > -1;
        // in case next auto level has been forced, and bw not available or not reliable, return forced value
        if (forcedAutoLevel !== -1 && (!useEstimate || !loadedFirstFrag || this.nextAutoLevelKey === this.getAutoLevelKey())) return forcedAutoLevel;
        // compute next level using ABR logic
        const nextABRAutoLevel = useEstimate && loadedFirstFrag ? this.getNextABRAutoLevel() : this.firstAutoLevel;
        // use forced auto level while it hasn't errored more than ABR selection
        if (forcedAutoLevel !== -1) {
            const levels = this.hls.levels;
            if (levels.length > Math.max(forcedAutoLevel, nextABRAutoLevel) && levels[forcedAutoLevel].loadError <= levels[nextABRAutoLevel].loadError) return forcedAutoLevel;
        }
        // save result until state has changed
        this._nextAutoLevel = nextABRAutoLevel;
        this.nextAutoLevelKey = this.getAutoLevelKey();
        return nextABRAutoLevel;
    }
    getAutoLevelKey() {
        return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
    }
    getNextABRAutoLevel() {
        const { fragCurrent: fragCurrent, partCurrent: partCurrent, hls: hls } = this;
        if (hls.levels.length <= 1) return hls.loadLevel;
        const { maxAutoLevel: maxAutoLevel, config: config, minAutoLevel: minAutoLevel } = hls;
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        const avgbw = this.getBwEstimate();
        // bufferStarvationDelay is the wall-clock time left until the playback buffer is exhausted.
        const bufferStarvationDelay = this.getStarvationDelay();
        let bwFactor = config.abrBandWidthFactor;
        let bwUpFactor = config.abrBandWidthUpFactor;
        // First, look to see if we can find a level matching with our avg bandwidth AND that could also guarantee no rebuffering at all
        if (bufferStarvationDelay) {
            const _bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, 0, bwFactor, bwUpFactor);
            if (_bestLevel >= 0) {
                this.rebufferNotice = -1;
                return _bestLevel;
            }
        }
        // not possible to get rid of rebuffering... try to find level that will guarantee less than maxStarvationDelay of rebuffering
        let maxStarvationDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxStarvationDelay) : config.maxStarvationDelay;
        if (!bufferStarvationDelay) {
            // in case buffer is empty, let's check if previous fragment was loaded to perform a bitrate test
            const bitrateTestDelay = this.bitrateTestDelay;
            if (bitrateTestDelay) {
                // if it is the case, then we need to adjust our max starvation delay using maxLoadingDelay config value
                // max video loading delay used in  automatic start level selection :
                // in that mode ABR controller will ensure that video loading time (ie the time to fetch the first fragment at lowest quality level +
                // the time to fetch the fragment at the appropriate quality level is less than ```maxLoadingDelay``` )
                // cap maxLoadingDelay and ensure it is not bigger 'than bitrate test' frag duration
                const maxLoadingDelay = currentFragDuration ? Math.min(currentFragDuration, config.maxLoadingDelay) : config.maxLoadingDelay;
                maxStarvationDelay = maxLoadingDelay - bitrateTestDelay;
                this.info(`bitrate test took ${Math.round(1000 * bitrateTestDelay)}ms, set first fragment max fetchDuration to ${Math.round(1000 * maxStarvationDelay)} ms`);
                // don't use conservative factor on bitrate test
                bwFactor = bwUpFactor = 1;
            }
        }
        const bestLevel = this.findBestLevel(avgbw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor);
        if (this.rebufferNotice !== bestLevel) {
            this.rebufferNotice = bestLevel;
            this.info(`${bufferStarvationDelay ? 'rebuffering expected' : 'buffer is empty'}, optimal quality level ${bestLevel}`);
        }
        if (bestLevel > -1) return bestLevel;
        // If no matching level found, see if min auto level would be a better option
        const minLevel = hls.levels[minAutoLevel];
        const autoLevel = hls.loadLevelObj;
        if (autoLevel && (minLevel == null ? void 0 : minLevel.bitrate) < autoLevel.bitrate) return minAutoLevel;
        // or if bitrate is not lower, continue to use loadLevel
        return hls.loadLevel;
    }
    getStarvationDelay() {
        const hls = this.hls;
        const media = hls.media;
        if (!media) return Infinity;
        // playbackRate is the absolute value of the playback rate; if media.playbackRate is 0, we use 1 to load as
        // if we're playing back at the normal rate.
        const playbackRate = media && media.playbackRate !== 0 ? Math.abs(media.playbackRate) : 1.0;
        const bufferInfo = hls.mainForwardBufferInfo;
        return (bufferInfo ? bufferInfo.len : 0) / playbackRate;
    }
    getBwEstimate() {
        return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
    }
    findBestLevel(currentBw, minAutoLevel, maxAutoLevel, bufferStarvationDelay, maxStarvationDelay, bwFactor, bwUpFactor) {
        var _this$hls$latestLevel;
        const maxFetchDuration = bufferStarvationDelay + maxStarvationDelay;
        const lastLoadedFragLevel = this.lastLoadedFragLevel;
        const selectionBaseLevel = lastLoadedFragLevel === -1 ? this.hls.firstLevel : lastLoadedFragLevel;
        const { fragCurrent: fragCurrent, partCurrent: partCurrent } = this;
        const { levels: levels, allAudioTracks: allAudioTracks, loadLevel: loadLevel, config: config } = this.hls;
        if (levels.length === 1) return 0;
        const level = levels[selectionBaseLevel];
        const live = !!((_this$hls$latestLevel = this.hls.latestLevelDetails) != null && _this$hls$latestLevel.live);
        const firstSelection = loadLevel === -1 || lastLoadedFragLevel === -1;
        let currentCodecSet;
        let currentVideoRange = 'SDR';
        let currentFrameRate = (level == null ? void 0 : level.frameRate) || 0;
        const { audioPreference: audioPreference, videoPreference: videoPreference } = config;
        const audioTracksByGroup = this.audioTracksByGroup || (this.audioTracksByGroup = $b941786f4eb9cb76$var$getAudioTracksByGroup(allAudioTracks));
        let minStartIndex = -1;
        if (firstSelection) {
            if (this.firstSelection !== -1) return this.firstSelection;
            const codecTiers = this.codecTiers || (this.codecTiers = $b941786f4eb9cb76$var$getCodecTiers(levels, audioTracksByGroup, minAutoLevel, maxAutoLevel));
            const startTier = $b941786f4eb9cb76$var$getStartCodecTier(codecTiers, currentVideoRange, currentBw, audioPreference, videoPreference);
            const { codecSet: codecSet, videoRanges: videoRanges, minFramerate: minFramerate, minBitrate: minBitrate, minIndex: minIndex, preferHDR: preferHDR } = startTier;
            minStartIndex = minIndex;
            currentCodecSet = codecSet;
            currentVideoRange = preferHDR ? videoRanges[videoRanges.length - 1] : videoRanges[0];
            currentFrameRate = minFramerate;
            currentBw = Math.max(currentBw, minBitrate);
            this.log(`picked start tier ${$b941786f4eb9cb76$var$stringify(startTier)}`);
        } else {
            currentCodecSet = level == null ? void 0 : level.codecSet;
            currentVideoRange = level == null ? void 0 : level.videoRange;
        }
        const currentFragDuration = partCurrent ? partCurrent.duration : fragCurrent ? fragCurrent.duration : 0;
        const ttfbEstimateSec = this.bwEstimator.getEstimateTTFB() / 1000;
        const levelsSkipped = [];
        for(let i = maxAutoLevel; i >= minAutoLevel; i--){
            var _levelInfo$supportedR;
            const levelInfo = levels[i];
            const upSwitch = i > selectionBaseLevel;
            if (!levelInfo) continue;
            if (config.useMediaCapabilities && !levelInfo.supportedResult && !levelInfo.supportedPromise) {
                const mediaCapabilities = navigator.mediaCapabilities;
                if (typeof (mediaCapabilities == null ? void 0 : mediaCapabilities.decodingInfo) === 'function' && $b941786f4eb9cb76$var$requiresMediaCapabilitiesDecodingInfo(levelInfo, audioTracksByGroup, currentVideoRange, currentFrameRate, currentBw, audioPreference)) {
                    levelInfo.supportedPromise = $b941786f4eb9cb76$var$getMediaDecodingInfoPromise(levelInfo, audioTracksByGroup, mediaCapabilities, this.supportedCache);
                    levelInfo.supportedPromise.then((decodingInfo)=>{
                        if (!this.hls) return;
                        levelInfo.supportedResult = decodingInfo;
                        const levels = this.hls.levels;
                        const index = levels.indexOf(levelInfo);
                        if (decodingInfo.error) this.warn(`MediaCapabilities decodingInfo error: "${decodingInfo.error}" for level ${index} ${$b941786f4eb9cb76$var$stringify(decodingInfo)}`);
                        else if (!decodingInfo.supported) {
                            this.warn(`Unsupported MediaCapabilities decodingInfo result for level ${index} ${$b941786f4eb9cb76$var$stringify(decodingInfo)}`);
                            if (index > -1 && levels.length > 1) {
                                this.log(`Removing unsupported level ${index}`);
                                this.hls.removeLevel(index);
                                if (this.hls.loadLevel === -1) this.hls.nextLoadLevel = 0;
                            }
                        } else if (decodingInfo.decodingInfoResults.some((info)=>info.smooth === false || info.powerEfficient === false)) this.log(`MediaCapabilities decodingInfo for level ${index} not smooth or powerEfficient: ${$b941786f4eb9cb76$var$stringify(decodingInfo)}`);
                    }).catch((error)=>{
                        this.warn(`Error handling MediaCapabilities decodingInfo: ${error}`);
                    });
                } else levelInfo.supportedResult = $b941786f4eb9cb76$var$SUPPORTED_INFO_DEFAULT;
            }
            // skip candidates which change codec-family or video-range,
            // and which decrease or increase frame-rate for up and down-switch respectfully
            if (currentCodecSet && levelInfo.codecSet !== currentCodecSet || currentVideoRange && levelInfo.videoRange !== currentVideoRange || upSwitch && currentFrameRate > levelInfo.frameRate || !upSwitch && currentFrameRate > 0 && currentFrameRate < levelInfo.frameRate || (_levelInfo$supportedR = levelInfo.supportedResult) != null && (_levelInfo$supportedR = _levelInfo$supportedR.decodingInfoResults) != null && _levelInfo$supportedR.some((info)=>info.smooth === false)) {
                if (!firstSelection || i !== minStartIndex) {
                    levelsSkipped.push(i);
                    continue;
                }
            }
            const levelDetails = levelInfo.details;
            const avgDuration = (partCurrent ? levelDetails == null ? void 0 : levelDetails.partTarget : levelDetails == null ? void 0 : levelDetails.averagetargetduration) || currentFragDuration;
            let adjustedbw;
            // follow algorithm captured from stagefright :
            // https://android.googlesource.com/platform/frameworks/av/+/master/media/libstagefright/httplive/LiveSession.cpp
            // Pick the highest bandwidth stream below or equal to estimated bandwidth.
            // consider only 80% of the available bandwidth, but if we are switching up,
            // be even more conservative (70%) to avoid overestimating and immediately
            // switching back.
            if (!upSwitch) adjustedbw = bwFactor * currentBw;
            else adjustedbw = bwUpFactor * currentBw;
            // Use average bitrate when starvation delay (buffer length) is gt or eq two segment durations and rebuffering is not expected (maxStarvationDelay > 0)
            const bitrate = currentFragDuration && bufferStarvationDelay >= currentFragDuration * 2 && maxStarvationDelay === 0 ? levelInfo.averageBitrate : levelInfo.maxBitrate;
            const fetchDuration = this.getTimeToLoadFrag(ttfbEstimateSec, adjustedbw, bitrate * avgDuration, levelDetails === undefined);
            const canSwitchWithinTolerance = // if adjusted bw is greater than level bitrate AND
            adjustedbw >= bitrate && // no level change, or new level has no error history
            (i === lastLoadedFragLevel || levelInfo.loadError === 0 && levelInfo.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
            // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
            // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
            (fetchDuration <= ttfbEstimateSec || !$b941786f4eb9cb76$var$isFiniteNumber(fetchDuration) || live && !this.bitrateTestDelay || fetchDuration < maxFetchDuration);
            if (canSwitchWithinTolerance) {
                const forcedAutoLevel = this.forcedAutoLevel;
                if (i !== loadLevel && (forcedAutoLevel === -1 || forcedAutoLevel !== loadLevel)) {
                    if (levelsSkipped.length) this.trace(`Skipped level(s) ${levelsSkipped.join(',')} of ${maxAutoLevel} max with CODECS and VIDEO-RANGE:"${levels[levelsSkipped[0]].codecs}" ${levels[levelsSkipped[0]].videoRange}; not compatible with "${currentCodecSet}" ${currentVideoRange}`);
                    this.info(`switch candidate:${selectionBaseLevel}->${i} adjustedbw(${Math.round(adjustedbw)})-bitrate=${Math.round(adjustedbw - bitrate)} ttfb:${ttfbEstimateSec.toFixed(1)} avgDuration:${avgDuration.toFixed(1)} maxFetchDuration:${maxFetchDuration.toFixed(1)} fetchDuration:${fetchDuration.toFixed(1)} firstSelection:${firstSelection} codecSet:${levelInfo.codecSet} videoRange:${levelInfo.videoRange} hls.loadLevel:${loadLevel}`);
                }
                if (firstSelection) this.firstSelection = i;
                // as we are looping from highest to lowest, this will return the best achievable quality level
                return i;
            }
        }
        // not enough time budget even with quality level 0 ... rebuffering might happen
        return -1;
    }
    set nextAutoLevel(nextLevel) {
        const value = this.deriveNextAutoLevel(nextLevel);
        if (this._nextAutoLevel !== value) {
            this.nextAutoLevelKey = '';
            this._nextAutoLevel = value;
        }
    }
    deriveNextAutoLevel(nextLevel) {
        const { maxAutoLevel: maxAutoLevel, minAutoLevel: minAutoLevel } = this.hls;
        return Math.min(Math.max(nextLevel, minAutoLevel), maxAutoLevel);
    }
}
const $b941786f4eb9cb76$var$BinarySearch = {
    /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */ search: function(list, comparisonFn) {
        let minIndex = 0;
        let maxIndex = list.length - 1;
        let currentIndex = null;
        let currentElement = null;
        while(minIndex <= maxIndex){
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = list[currentIndex];
            const comparisonResult = comparisonFn(currentElement);
            if (comparisonResult > 0) minIndex = currentIndex + 1;
            else if (comparisonResult < 0) maxIndex = currentIndex - 1;
            else return currentElement;
        }
        return null;
    }
};
/**
 * Returns first fragment whose endPdt value exceeds the given PDT, or null.
 * @param fragments - The array of candidate fragments
 * @param PDTValue - The PDT value which must be exceeded
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 */ function $b941786f4eb9cb76$var$findFragmentByPDT(fragments, PDTValue, maxFragLookUpTolerance) {
    if (PDTValue === null || !Array.isArray(fragments) || !fragments.length || !$b941786f4eb9cb76$var$isFiniteNumber(PDTValue)) return null;
    // if less than start
    const startPDT = fragments[0].programDateTime;
    if (PDTValue < (startPDT || 0)) return null;
    const endPDT = fragments[fragments.length - 1].endProgramDateTime;
    if (PDTValue >= (endPDT || 0)) return null;
    for(let seg = 0; seg < fragments.length; ++seg){
        const frag = fragments[seg];
        if ($b941786f4eb9cb76$var$pdtWithinToleranceTest(PDTValue, maxFragLookUpTolerance, frag)) return frag;
    }
    return null;
}
/**
 * Finds a fragment based on the SN of the previous fragment; or based on the needs of the current buffer.
 * This method compensates for small buffer gaps by applying a tolerance to the start of any candidate fragment, thus
 * breaking any traps which would cause the same fragment to be continuously selected within a small range.
 * @param fragPrevious - The last frag successfully appended
 * @param fragments - The array of candidate fragments
 * @param bufferEnd - The end of the contiguous buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start/end can be within in order to be considered contiguous
 * @returns a matching fragment or null
 */ function $b941786f4eb9cb76$var$findFragmentByPTS(fragPrevious, fragments, bufferEnd = 0, maxFragLookUpTolerance = 0, nextFragLookupTolerance = 0.005) {
    let fragNext = null;
    if (fragPrevious) {
        fragNext = fragments[1 + fragPrevious.sn - fragments[0].sn] || null;
        // check for buffer-end rounding error
        const bufferEdgeError = fragPrevious.endDTS - bufferEnd;
        if (bufferEdgeError > 0 && bufferEdgeError < 0.0000015) bufferEnd += 0.0000015;
        if (fragNext && fragPrevious.level !== fragNext.level && fragNext.end <= fragPrevious.end) fragNext = fragments[2 + fragPrevious.sn - fragments[0].sn] || null;
    } else if (bufferEnd === 0 && fragments[0].start === 0) fragNext = fragments[0];
    // Prefer the next fragment if it's within tolerance
    if (fragNext && ((!fragPrevious || fragPrevious.level === fragNext.level) && $b941786f4eb9cb76$var$fragmentWithinToleranceTest(bufferEnd, maxFragLookUpTolerance, fragNext) === 0 || $b941786f4eb9cb76$var$fragmentWithinFastStartSwitch(fragNext, fragPrevious, Math.min(nextFragLookupTolerance, maxFragLookUpTolerance)))) return fragNext;
    // We might be seeking past the tolerance so find the best match
    const foundFragment = $b941786f4eb9cb76$var$BinarySearch.search(fragments, $b941786f4eb9cb76$var$fragmentWithinToleranceTest.bind(null, bufferEnd, maxFragLookUpTolerance));
    if (foundFragment && (foundFragment !== fragPrevious || !fragNext)) return foundFragment;
    // If no match was found return the next fragment after fragPrevious, or null
    return fragNext;
}
function $b941786f4eb9cb76$var$fragmentWithinFastStartSwitch(fragNext, fragPrevious, nextFragLookupTolerance) {
    if (fragPrevious && fragPrevious.start === 0 && fragPrevious.level < fragNext.level && (fragPrevious.endPTS || 0) > 0) {
        const firstDuration = fragPrevious.tagList.reduce((duration, tag)=>{
            if (tag[0] === 'INF') duration += parseFloat(tag[1]);
            return duration;
        }, nextFragLookupTolerance);
        return fragNext.start <= firstDuration;
    }
    return false;
}
/**
 * The test function used by the findFragmentBySn's BinarySearch to look for the best match to the current buffer conditions.
 * @param candidate - The fragment to test
 * @param bufferEnd - The end of the current buffered range the playhead is currently within
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns 0 if it matches, 1 if too low, -1 if too high
 */ function $b941786f4eb9cb76$var$fragmentWithinToleranceTest(bufferEnd = 0, maxFragLookUpTolerance = 0, candidate) {
    // eagerly accept an accurate match (no tolerance)
    if (candidate.start <= bufferEnd && candidate.start + candidate.duration > bufferEnd) return 0;
    // offset should be within fragment boundary - config.maxFragLookUpTolerance
    // this is to cope with situations like
    // bufferEnd = 9.991
    // frag[Ø] : [0,10]
    // frag[1] : [10,20]
    // bufferEnd is within frag[0] range ... although what we are expecting is to return frag[1] here
    //              frag start               frag start+duration
    //                  |-----------------------------|
    //              <--->                         <--->
    //  ...--------><-----------------------------><---------....
    // previous frag         matching fragment         next frag
    //  return -1             return 0                 return 1
    // logger.log(`level/sn/start/end/bufEnd:${level}/${candidate.sn}/${candidate.start}/${(candidate.start+candidate.duration)}/${bufferEnd}`);
    // Set the lookup tolerance to be small enough to detect the current segment - ensures we don't skip over very small segments
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0));
    if (candidate.start + candidate.duration - candidateLookupTolerance <= bufferEnd) return 1;
    else if (candidate.start - candidateLookupTolerance > bufferEnd && candidate.start) // if maxFragLookUpTolerance will have negative value then don't return -1 for first element
    return -1;
    return 0;
}
/**
 * The test function used by the findFragmentByPdt's BinarySearch to look for the best match to the current buffer conditions.
 * This function tests the candidate's program date time values, as represented in Unix time
 * @param candidate - The fragment to test
 * @param pdtBufferEnd - The Unix time representing the end of the current buffered range
 * @param maxFragLookUpTolerance - The amount of time that a fragment's start can be within in order to be considered contiguous
 * @returns true if contiguous, false otherwise
 */ function $b941786f4eb9cb76$var$pdtWithinToleranceTest(pdtBufferEnd, maxFragLookUpTolerance, candidate) {
    const candidateLookupTolerance = Math.min(maxFragLookUpTolerance, candidate.duration + (candidate.deltaPTS ? candidate.deltaPTS : 0)) * 1000;
    // endProgramDateTime can be null, default to zero
    const endProgramDateTime = candidate.endProgramDateTime || 0;
    return endProgramDateTime - candidateLookupTolerance > pdtBufferEnd;
}
function $b941786f4eb9cb76$var$findNearestWithCC(details, cc, pos) {
    if (details) {
        if (details.startCC <= cc && details.endCC >= cc) {
            let fragments = details.fragments;
            const { fragmentHint: fragmentHint } = details;
            if (fragmentHint) fragments = fragments.concat(fragmentHint);
            let closest;
            $b941786f4eb9cb76$var$BinarySearch.search(fragments, (candidate)=>{
                if (candidate.cc < cc) return 1;
                if (candidate.cc > cc) return -1;
                closest = candidate;
                if (candidate.end <= pos) return 1;
                if (candidate.start > pos) return -1;
                return 0;
            });
            return closest || null;
        }
    }
    return null;
}
function $b941786f4eb9cb76$var$isTimeoutError(error) {
    switch(error.details){
        case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
        case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
        case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT:
        case $b941786f4eb9cb76$export$d053ec805ce391aa.MANIFEST_LOAD_TIMEOUT:
            return true;
    }
    return false;
}
function $b941786f4eb9cb76$var$isKeyError(error) {
    return error.details.startsWith('key');
}
function $b941786f4eb9cb76$var$isUnusableKeyError(error) {
    return $b941786f4eb9cb76$var$isKeyError(error) && !!error.frag && !error.frag.decryptdata;
}
function $b941786f4eb9cb76$var$getRetryConfig(loadPolicy, error) {
    const isTimeout = $b941786f4eb9cb76$var$isTimeoutError(error);
    return loadPolicy.default[`${isTimeout ? 'timeout' : 'error'}Retry`];
}
function $b941786f4eb9cb76$var$getRetryDelay(retryConfig, retryCount) {
    // exponential backoff capped to max retry delay
    const backoffFactor = retryConfig.backoff === 'linear' ? 1 : Math.pow(2, retryCount);
    return Math.min(backoffFactor * retryConfig.retryDelayMs, retryConfig.maxRetryDelayMs);
}
function $b941786f4eb9cb76$var$getLoaderConfigWithoutReties(loderConfig) {
    return $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, loderConfig), {
        errorRetry: null,
        timeoutRetry: null
    });
}
function $b941786f4eb9cb76$var$shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse) {
    if (!retryConfig) return false;
    const httpStatus = loaderResponse == null ? void 0 : loaderResponse.code;
    const retry = retryCount < retryConfig.maxNumRetry && ($b941786f4eb9cb76$var$retryForHttpStatus(httpStatus) || !!isTimeout);
    return retryConfig.shouldRetry ? retryConfig.shouldRetry(retryConfig, retryCount, isTimeout, loaderResponse, retry) : retry;
}
function $b941786f4eb9cb76$var$retryForHttpStatus(httpStatus) {
    // Do not retry on status 4xx, status 0 (CORS error), or undefined (decrypt/gap/parse error)
    return $b941786f4eb9cb76$var$offlineHttpStatus(httpStatus) || !!httpStatus && (httpStatus < 400 || httpStatus > 499);
}
function $b941786f4eb9cb76$var$offlineHttpStatus(httpStatus) {
    return httpStatus === 0 && navigator.onLine === false;
}
var $b941786f4eb9cb76$export$679390c50dd617e4 = {
    DoNothing: 0,
    SendEndCallback: 1,
    SendAlternateToPenaltyBox: 2,
    RemoveAlternatePermanently: 3,
    InsertDiscontinuity: 4,
    RetryRequest: 5
};
var $b941786f4eb9cb76$export$f377ad9144b2d7af = {
    None: 0,
    MoveAllAlternatesMatchingHost: 1,
    MoveAllAlternatesMatchingHDCP: 2,
    MoveAllAlternatesMatchingKey: 4,
    SwitchToSDR: 8
};
class $b941786f4eb9cb76$export$2f5b22783539ff2 extends $b941786f4eb9cb76$var$Logger {
    constructor(hls){
        super('error-controller', hls.logger);
        this.hls = void 0;
        this.playlistError = 0;
        this.hls = hls;
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onErrorOut, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
    }
    destroy() {
        this.unregisterListeners();
        // @ts-ignore
        this.hls = null;
    }
    startLoad(startPosition) {}
    stopLoad() {
        this.playlistError = 0;
    }
    getVariantLevelIndex(frag) {
        if ((frag == null ? void 0 : frag.type) === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) return frag.level;
        return this.getVariantIndex();
    }
    getVariantIndex() {
        var _hls$loadLevelObj;
        const hls = this.hls;
        const currentLevel = hls.currentLevel;
        if ((_hls$loadLevelObj = hls.loadLevelObj) != null && _hls$loadLevelObj.details || currentLevel === -1) return hls.loadLevel;
        return currentLevel;
    }
    variantHasKey(level, keyInError) {
        if (level) {
            var _level$details;
            if ((_level$details = level.details) != null && _level$details.hasKey(keyInError)) return true;
            const audioGroupsIds = level.audioGroups;
            if (audioGroupsIds) {
                const audioTracks = this.hls.allAudioTracks.filter((track)=>audioGroupsIds.indexOf(track.groupId) >= 0);
                return audioTracks.some((track)=>{
                    var _track$details;
                    return (_track$details = track.details) == null ? void 0 : _track$details.hasKey(keyInError);
                });
            }
        }
        return false;
    }
    onManifestLoading() {
        this.playlistError = 0;
    }
    onLevelUpdated() {
        this.playlistError = 0;
    }
    onError(event, data) {
        var _data$frag;
        if (data.fatal) return;
        const hls = this.hls;
        const context = data.context;
        switch(data.details){
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR:
                // ignore empty segment errors marked as gap
                if ((_data$frag = data.frag) != null && _data$frag.gap) {
                    data.errorAction = $b941786f4eb9cb76$var$createDoNothingErrorAction();
                    return;
                }
            // falls through
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR:
                // Switch level if possible, otherwise allow retry count to reach max error retries
                data.errorAction = this.getFragRetryOrSwitchAction(data);
                data.errorAction.action = $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox;
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_EMPTY_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_PARSING_ERROR:
                {
                    var _data$context;
                    // Only retry when empty and live
                    const levelIndex = data.parent === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN ? data.level : hls.loadLevel;
                    if (data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_EMPTY_ERROR && !!((_data$context = data.context) != null && (_data$context = _data$context.levelDetails) != null && _data$context.live)) data.errorAction = this.getPlaylistRetryOrSwitchAction(data, levelIndex);
                    else {
                        // Escalate to fatal if not retrying or switching
                        data.levelRetry = false;
                        data.errorAction = this.getLevelSwitchAction(data, levelIndex);
                    }
                }
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT:
                if (typeof (context == null ? void 0 : context.level) === 'number') data.errorAction = this.getPlaylistRetryOrSwitchAction(data, context.level);
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_TIMEOUT:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.SUBTITLE_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.SUBTITLE_TRACK_LOAD_TIMEOUT:
                if (context) {
                    const level = hls.loadLevelObj;
                    if (level && (context.type === $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK && level.hasAudioGroup(context.groupId) || context.type === $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK && level.hasSubtitleGroup(context.groupId))) {
                        // Perform Pathway switch or Redundant failover if possible for fastest recovery
                        // otherwise allow playlist retry count to reach max error retries
                        data.errorAction = this.getPlaylistRetryOrSwitchAction(data, hls.loadLevel);
                        data.errorAction.action = $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox;
                        data.errorAction.flags = $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost;
                        return;
                    }
                }
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
                data.errorAction = {
                    action: $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox,
                    flags: $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHDCP
                };
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_SESSION_UPDATE_FAILED:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_STATUS_INTERNAL_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_NO_SESSION:
                data.errorAction = {
                    action: $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox,
                    flags: $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingKey
                };
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.REMUX_ALLOC_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                // Buffer-controller can set errorAction when append errors can be ignored or resolved locally
                if (!data.errorAction) {
                    var _data$level;
                    data.errorAction = this.getLevelSwitchAction(data, (_data$level = data.level) != null ? _data$level : hls.loadLevel);
                }
                return;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_EXCEPTION:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPENDING_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_FULL_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_SWITCH_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_STALLED_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_SEEK_OVER_HOLE:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_NUDGE_ON_STALL:
                data.errorAction = $b941786f4eb9cb76$var$createDoNothingErrorAction();
                return;
        }
        if (data.type === $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR) {
            // Do not retry level. Should be fatal if ErrorDetails.KEY_SYSTEM_<ERROR> not handled with early return above.
            data.levelRetry = false;
            data.errorAction = $b941786f4eb9cb76$var$createDoNothingErrorAction();
        }
    }
    getPlaylistRetryOrSwitchAction(data, levelIndex) {
        const hls = this.hls;
        const retryConfig = $b941786f4eb9cb76$var$getRetryConfig(hls.config.playlistLoadPolicy, data);
        const retryCount = this.playlistError++;
        const retry = $b941786f4eb9cb76$var$shouldRetry(retryConfig, retryCount, $b941786f4eb9cb76$var$isTimeoutError(data), data.response);
        if (retry) return {
            action: $b941786f4eb9cb76$export$679390c50dd617e4.RetryRequest,
            flags: $b941786f4eb9cb76$export$f377ad9144b2d7af.None,
            retryConfig: retryConfig,
            retryCount: retryCount
        };
        const errorAction = this.getLevelSwitchAction(data, levelIndex);
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = retryCount;
        }
        return errorAction;
    }
    getFragRetryOrSwitchAction(data) {
        const hls = this.hls;
        // Share fragment error count accross media options (main, audio, subs)
        // This allows for level based rendition switching when media option assets fail
        const variantLevelIndex = this.getVariantLevelIndex(data.frag);
        const level = hls.levels[variantLevelIndex];
        const { fragLoadPolicy: fragLoadPolicy, keyLoadPolicy: keyLoadPolicy } = hls.config;
        const retryConfig = $b941786f4eb9cb76$var$getRetryConfig($b941786f4eb9cb76$var$isKeyError(data) ? keyLoadPolicy : fragLoadPolicy, data);
        const fragmentErrors = hls.levels.reduce((acc, level)=>acc + level.fragmentError, 0);
        // Switch levels when out of retried or level index out of bounds
        if (level) {
            if (data.details !== $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP) level.fragmentError++;
            if (!$b941786f4eb9cb76$var$isUnusableKeyError(data)) {
                const retry = $b941786f4eb9cb76$var$shouldRetry(retryConfig, fragmentErrors, $b941786f4eb9cb76$var$isTimeoutError(data), data.response);
                if (retry) return {
                    action: $b941786f4eb9cb76$export$679390c50dd617e4.RetryRequest,
                    flags: $b941786f4eb9cb76$export$f377ad9144b2d7af.None,
                    retryConfig: retryConfig,
                    retryCount: fragmentErrors
                };
            }
        }
        // Reach max retry count, or Missing level reference
        // Switch to valid index
        const errorAction = this.getLevelSwitchAction(data, variantLevelIndex);
        // Add retry details to allow skipping of FRAG_PARSING_ERROR
        if (retryConfig) {
            errorAction.retryConfig = retryConfig;
            errorAction.retryCount = fragmentErrors;
        }
        return errorAction;
    }
    getLevelSwitchAction(data, levelIndex) {
        const hls = this.hls;
        if (levelIndex === null || levelIndex === undefined) levelIndex = hls.loadLevel;
        const level = this.hls.levels[levelIndex];
        if (level) {
            var _data$frag2, _data$context2;
            const errorDetails = data.details;
            level.loadError++;
            if (errorDetails === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR) level.fragmentError++;
            // Search for next level to retry
            let nextLevel = -1;
            const { levels: levels, loadLevel: loadLevel, minAutoLevel: minAutoLevel, maxAutoLevel: maxAutoLevel } = hls;
            if (!hls.autoLevelEnabled && !hls.config.preserveManualLevelOnError) hls.loadLevel = -1;
            const fragErrorType = (_data$frag2 = data.frag) == null ? void 0 : _data$frag2.type;
            // Find alternate audio codec if available on audio codec error
            const isAudioCodecError = fragErrorType === $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO && errorDetails === $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR || data.sourceBufferName === 'audio' && (errorDetails === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR || errorDetails === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR);
            const findAudioCodecAlternate = isAudioCodecError && levels.some(({ audioCodec: audioCodec })=>level.audioCodec !== audioCodec);
            // Find alternate video codec if available on video codec error
            const isVideoCodecError = data.sourceBufferName === 'video' && (errorDetails === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR || errorDetails === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR);
            const findVideoCodecAlternate = isVideoCodecError && levels.some(({ codecSet: codecSet, audioCodec: audioCodec })=>level.codecSet !== codecSet && level.audioCodec === audioCodec);
            const { type: playlistErrorType, groupId: playlistErrorGroupId } = (_data$context2 = data.context) != null ? _data$context2 : {};
            for(let i = levels.length; i--;){
                const candidate = (i + loadLevel) % levels.length;
                if (candidate !== loadLevel && candidate >= minAutoLevel && candidate <= maxAutoLevel && levels[candidate].loadError === 0) {
                    var _level$audioGroups, _level$subtitleGroups;
                    const levelCandidate = levels[candidate];
                    // Skip level switch if GAP tag is found in next level at same position
                    if (errorDetails === $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP && fragErrorType === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN && data.frag) {
                        const levelDetails = levels[candidate].details;
                        if (levelDetails) {
                            const fragCandidate = $b941786f4eb9cb76$var$findFragmentByPTS(data.frag, levelDetails.fragments, data.frag.start);
                            if (fragCandidate != null && fragCandidate.gap) continue;
                        }
                    } else if (playlistErrorType === $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK && levelCandidate.hasAudioGroup(playlistErrorGroupId) || playlistErrorType === $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK && levelCandidate.hasSubtitleGroup(playlistErrorGroupId)) continue;
                    else if (fragErrorType === $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO && (_level$audioGroups = level.audioGroups) != null && _level$audioGroups.some((groupId)=>levelCandidate.hasAudioGroup(groupId)) || fragErrorType === $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE && (_level$subtitleGroups = level.subtitleGroups) != null && _level$subtitleGroups.some((groupId)=>levelCandidate.hasSubtitleGroup(groupId)) || findAudioCodecAlternate && level.audioCodec === levelCandidate.audioCodec || findVideoCodecAlternate && level.codecSet === levelCandidate.codecSet || !findAudioCodecAlternate && level.codecSet !== levelCandidate.codecSet) continue;
                    nextLevel = candidate;
                    break;
                }
            }
            if (nextLevel > -1 && hls.loadLevel !== nextLevel) {
                data.levelRetry = true;
                this.playlistError = 0;
                return {
                    action: $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox,
                    flags: $b941786f4eb9cb76$export$f377ad9144b2d7af.None,
                    nextAutoLevel: nextLevel
                };
            }
        }
        // No levels to switch / Manual level selection / Level not found
        // Resolve with Pathway switch, Redundant fail-over, or stay on lowest Level
        return {
            action: $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox,
            flags: $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost
        };
    }
    onErrorOut(event, data) {
        var _data$errorAction;
        switch((_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.action){
            case $b941786f4eb9cb76$export$679390c50dd617e4.DoNothing:
                break;
            case $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox:
                this.sendAlternateToPenaltyBox(data);
                if (!data.errorAction.resolved && data.details !== $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP) data.fatal = true;
                else if (/MediaSource readyState: ended/.test(data.error.message)) {
                    this.warn(`MediaSource ended after "${data.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`);
                    this.hls.recoverMediaError();
                }
                break;
            case $b941786f4eb9cb76$export$679390c50dd617e4.RetryRequest:
                break;
        }
        if (data.fatal) {
            this.hls.stopLoad();
            return;
        }
    }
    sendAlternateToPenaltyBox(data) {
        const hls = this.hls;
        const errorAction = data.errorAction;
        if (!errorAction) return;
        const { flags: flags } = errorAction;
        const nextAutoLevel = errorAction.nextAutoLevel;
        switch(flags){
            case $b941786f4eb9cb76$export$f377ad9144b2d7af.None:
                this.switchLevel(data, nextAutoLevel);
                break;
            case $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHDCP:
                {
                    const levelIndex = this.getVariantLevelIndex(data.frag);
                    const level = hls.levels[levelIndex];
                    const restrictedHdcpLevel = level == null ? void 0 : level.attrs['HDCP-LEVEL'];
                    errorAction.hdcpLevel = restrictedHdcpLevel;
                    if (restrictedHdcpLevel === 'NONE') this.warn(`HDCP policy resticted output with HDCP-LEVEL=NONE`);
                    else if (restrictedHdcpLevel) {
                        hls.maxHdcpLevel = $b941786f4eb9cb76$var$HdcpLevels[$b941786f4eb9cb76$var$HdcpLevels.indexOf(restrictedHdcpLevel) - 1];
                        errorAction.resolved = true;
                        this.warn(`Restricting playback to HDCP-LEVEL of "${hls.maxHdcpLevel}" or lower`);
                        break;
                    }
                // Fallthrough when no HDCP-LEVEL attribute is found
                }
            // eslint-disable-next-line no-fallthrough
            case $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingKey:
                {
                    const levelKey = data.decryptdata;
                    if (levelKey) {
                        // Penalize all levels with key
                        const levels = this.hls.levels;
                        const levelCountWithError = levels.length;
                        for(let i = levelCountWithError; i--;)if (this.variantHasKey(levels[i], levelKey)) {
                            var _levels$i$audioGroups, _data$frag3;
                            this.log(`Banned key found in level ${i} (${levels[i].bitrate}bps) or audio group "${(_levels$i$audioGroups = levels[i].audioGroups) == null ? void 0 : _levels$i$audioGroups.join(',')}" (${(_data$frag3 = data.frag) == null ? void 0 : _data$frag3.type} fragment) ${$b941786f4eb9cb76$var$arrayToHex(levelKey.keyId || [])}`);
                            levels[i].fragmentError++;
                            levels[i].loadError++;
                            this.log(`Removing level ${i} with key error (${data.error})`);
                            this.hls.removeLevel(i);
                        }
                        const frag = data.frag;
                        if (this.hls.levels.length < levelCountWithError) errorAction.resolved = true;
                        else if (frag && frag.type !== $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) {
                            // Ignore key error for audio track with unmatched key (main session error)
                            const fragLevelKey = frag.decryptdata;
                            if (fragLevelKey && !levelKey.matches(fragLevelKey)) errorAction.resolved = true;
                        }
                    }
                    break;
                }
        }
        // If not resolved by previous actions try to switch to next level
        if (!errorAction.resolved) this.switchLevel(data, nextAutoLevel);
    }
    switchLevel(data, levelIndex) {
        if (levelIndex !== undefined && data.errorAction) {
            this.warn(`switching to level ${levelIndex} after ${data.details}`);
            this.hls.nextAutoLevel = levelIndex;
            data.errorAction.resolved = true;
            // Stream controller is responsible for this but won't switch on false start
            this.hls.nextLoadLevel = this.hls.nextAutoLevel;
            if (data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR && data.mimeType && data.sourceBufferName !== 'audiovideo') {
                const codec = $b941786f4eb9cb76$var$getCodecsForMimeType(data.mimeType);
                const levels = this.hls.levels;
                for(let i = levels.length; i--;)if (levels[i][`${data.sourceBufferName}Codec`] === codec) {
                    this.log(`Removing level ${i} for ${data.details} ("${codec}" not supported)`);
                    this.hls.removeLevel(i);
                }
            }
        }
    }
}
function $b941786f4eb9cb76$var$createDoNothingErrorAction(resolved) {
    const errorAction = {
        action: $b941786f4eb9cb76$export$679390c50dd617e4.DoNothing,
        flags: $b941786f4eb9cb76$export$f377ad9144b2d7af.None
    };
    if (resolved) errorAction.resolved = true;
    return errorAction;
}
var $b941786f4eb9cb76$var$FragmentState = {
    NOT_LOADED: "NOT_LOADED",
    APPENDING: "APPENDING",
    PARTIAL: "PARTIAL",
    OK: "OK"
};
class $b941786f4eb9cb76$var$FragmentTracker {
    constructor(hls){
        this.activePartLists = Object.create(null);
        this.endListFragments = Object.create(null);
        this.fragments = Object.create(null);
        this.timeRanges = Object.create(null);
        this.bufferPadding = 0.2;
        this.hls = void 0;
        this.hasGaps = false;
        this.hls = hls;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        }
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        }
    }
    destroy() {
        this._unregisterListeners();
        // @ts-ignore
        this.hls = // @ts-ignore
        this.fragments = // @ts-ignore
        this.activePartLists = // @ts-ignore
        this.endListFragments = this.timeRanges = null;
    }
    /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */ getAppendedFrag(position, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (activeParts) for(let i = activeParts.length; i--;){
            const activePart = activeParts[i];
            if (!activePart) break;
            if (activePart.start <= position && position <= activePart.end && activePart.loaded) return activePart;
        }
        return this.getBufferedFrag(position, levelType);
    }
    /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */ getBufferedFrag(position, levelType) {
        return this.getFragAtPos(position, levelType, true);
    }
    getFragAtPos(position, levelType, buffered) {
        const { fragments: fragments } = this;
        const keys = Object.keys(fragments);
        for(let i = keys.length; i--;){
            const fragmentEntity = fragments[keys[i]];
            if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === levelType && (!buffered || fragmentEntity.buffered)) {
                const frag = fragmentEntity.body;
                if (frag.start <= position && position <= frag.end) return frag;
            }
        }
        return null;
    }
    /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */ detectEvictedFragments(elementaryStream, timeRange, playlistType, appendedPart, removeAppending) {
        if (this.timeRanges) this.timeRanges[elementaryStream] = timeRange;
        // Check if any flagged fragments have been unloaded
        // excluding anything newer than appendedPartSn
        const appendedPartSn = (appendedPart == null ? void 0 : appendedPart.fragment.sn) || -1;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            if (appendedPartSn >= fragmentEntity.body.sn) return;
            if (!fragmentEntity.buffered && (!fragmentEntity.loaded || removeAppending)) {
                if (fragmentEntity.body.type === playlistType) this.removeFragment(fragmentEntity.body);
                return;
            }
            const esData = fragmentEntity.range[elementaryStream];
            if (!esData) return;
            if (esData.time.length === 0) {
                this.removeFragment(fragmentEntity.body);
                return;
            }
            esData.time.some((time1)=>{
                const isNotBuffered = !this.isTimeBuffered(time1.startPTS, time1.endPTS, timeRange);
                if (isNotBuffered) // Unregister partial fragment as it needs to load again to be reused
                this.removeFragment(fragmentEntity.body);
                return isNotBuffered;
            });
        });
    }
    /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */ detectPartialFragments(data) {
        const timeRanges = this.timeRanges;
        if (!timeRanges || data.frag.sn === 'initSegment') return;
        const frag = data.frag;
        const fragKey = $b941786f4eb9cb76$var$getFragmentKey(frag);
        const fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity || fragmentEntity.buffered && frag.gap) return;
        const isFragHint = !frag.relurl;
        Object.keys(timeRanges).forEach((elementaryStream)=>{
            const streamInfo = frag.elementaryStreams[elementaryStream];
            if (!streamInfo) return;
            const timeRange = timeRanges[elementaryStream];
            const partial = isFragHint || streamInfo.partial === true;
            fragmentEntity.range[elementaryStream] = this.getBufferedTimes(frag, data.part, partial, timeRange);
        });
        fragmentEntity.loaded = null;
        if (Object.keys(fragmentEntity.range).length) {
            this.bufferedEnd(fragmentEntity, frag);
            if (!$b941786f4eb9cb76$var$isPartial(fragmentEntity)) // Remove older fragment parts from lookup after frag is tracked as buffered
            this.removeParts(frag.sn - 1, frag.type);
        } else // remove fragment if nothing was appended
        this.removeFragment(fragmentEntity.body);
    }
    bufferedEnd(fragmentEntity, frag) {
        fragmentEntity.buffered = true;
        const endList = fragmentEntity.body.endList = frag.endList || fragmentEntity.body.endList;
        if (endList) this.endListFragments[fragmentEntity.body.type] = fragmentEntity;
    }
    removeParts(snToKeep, levelType) {
        const activeParts = this.activePartLists[levelType];
        if (!activeParts) return;
        this.activePartLists[levelType] = $b941786f4eb9cb76$var$filterParts(activeParts, (part)=>part.fragment.sn >= snToKeep);
    }
    fragBuffered(frag, force) {
        const fragKey = $b941786f4eb9cb76$var$getFragmentKey(frag);
        let fragmentEntity = this.fragments[fragKey];
        if (!fragmentEntity && force) {
            fragmentEntity = this.fragments[fragKey] = {
                body: frag,
                appendedPTS: null,
                loaded: null,
                buffered: false,
                range: Object.create(null)
            };
            if (frag.gap) this.hasGaps = true;
        }
        if (fragmentEntity) {
            fragmentEntity.loaded = null;
            this.bufferedEnd(fragmentEntity, frag);
        }
    }
    getBufferedTimes(fragment, part, partial, timeRange) {
        const buffered = {
            time: [],
            partial: partial
        };
        const startPTS = fragment.start;
        const endPTS = fragment.end;
        const minEndPTS = fragment.minEndPTS || endPTS;
        const maxStartPTS = fragment.maxStartPTS || startPTS;
        for(let i = 0; i < timeRange.length; i++){
            const startTime = timeRange.start(i) - this.bufferPadding;
            const endTime = timeRange.end(i) + this.bufferPadding;
            if (maxStartPTS >= startTime && minEndPTS <= endTime) {
                // Fragment is entirely contained in buffer
                // No need to check the other timeRange times since it's completely playable
                buffered.time.push({
                    startPTS: Math.max(startPTS, timeRange.start(i)),
                    endPTS: Math.min(endPTS, timeRange.end(i))
                });
                break;
            } else if (startPTS < endTime && endPTS > startTime) {
                const start = Math.max(startPTS, timeRange.start(i));
                const end = Math.min(endPTS, timeRange.end(i));
                if (end > start) {
                    buffered.partial = true;
                    // Check for intersection with buffer
                    // Get playable sections of the fragment
                    buffered.time.push({
                        startPTS: start,
                        endPTS: end
                    });
                }
            } else if (endPTS <= startTime) break;
        }
        return buffered;
    }
    /**
   * Gets the partial fragment for a certain time
   */ getPartialFragment(time1) {
        let bestFragment = null;
        let timePadding;
        let startTime;
        let endTime;
        let bestOverlap = 0;
        const { bufferPadding: bufferPadding, fragments: fragments } = this;
        Object.keys(fragments).forEach((key)=>{
            const fragmentEntity = fragments[key];
            if (!fragmentEntity) return;
            if ($b941786f4eb9cb76$var$isPartial(fragmentEntity)) {
                startTime = fragmentEntity.body.start - bufferPadding;
                endTime = fragmentEntity.body.end + bufferPadding;
                if (time1 >= startTime && time1 <= endTime) {
                    // Use the fragment that has the most padding from start and end time
                    timePadding = Math.min(time1 - startTime, endTime - time1);
                    if (bestOverlap <= timePadding) {
                        bestFragment = fragmentEntity.body;
                        bestOverlap = timePadding;
                    }
                }
            }
        });
        return bestFragment;
    }
    isEndListAppended(type) {
        const lastFragmentEntity = this.endListFragments[type];
        return lastFragmentEntity !== undefined && (lastFragmentEntity.buffered || $b941786f4eb9cb76$var$isPartial(lastFragmentEntity));
    }
    getState(fragment) {
        const fragKey = $b941786f4eb9cb76$var$getFragmentKey(fragment);
        const fragmentEntity = this.fragments[fragKey];
        if (fragmentEntity) {
            if (!fragmentEntity.buffered) return $b941786f4eb9cb76$var$FragmentState.APPENDING;
            else if ($b941786f4eb9cb76$var$isPartial(fragmentEntity)) return $b941786f4eb9cb76$var$FragmentState.PARTIAL;
            else return $b941786f4eb9cb76$var$FragmentState.OK;
        }
        return $b941786f4eb9cb76$var$FragmentState.NOT_LOADED;
    }
    isTimeBuffered(startPTS, endPTS, timeRange) {
        let startTime;
        let endTime;
        for(let i = 0; i < timeRange.length; i++){
            startTime = timeRange.start(i) - this.bufferPadding;
            endTime = timeRange.end(i) + this.bufferPadding;
            if (startPTS >= startTime && endPTS <= endTime) return true;
            if (endPTS <= startTime) // No need to check the rest of the timeRange as it is in order
            return false;
        }
        return false;
    }
    onManifestLoading() {
        this.removeAllFragments();
    }
    onFragLoaded(event, data) {
        // don't track initsegment (for which sn is not a number)
        // don't track frags used for bitrateTest, they're irrelevant.
        if (data.frag.sn === 'initSegment' || data.frag.bitrateTest) return;
        const frag = data.frag;
        // Fragment entity `loaded` FragLoadedData is null when loading parts
        const loaded = data.part ? null : data;
        const fragKey = $b941786f4eb9cb76$var$getFragmentKey(frag);
        this.fragments[fragKey] = {
            body: frag,
            appendedPTS: null,
            loaded: loaded,
            buffered: false,
            range: Object.create(null)
        };
    }
    onBufferAppended(event, data) {
        const { frag: frag, part: part, timeRanges: timeRanges, type: type } = data;
        if (frag.sn === 'initSegment') return;
        const playlistType = frag.type;
        if (part) {
            let activeParts = this.activePartLists[playlistType];
            if (!activeParts) this.activePartLists[playlistType] = activeParts = [];
            activeParts.push(part);
        }
        // Store the latest timeRanges loaded in the buffer
        this.timeRanges = timeRanges;
        const timeRange = timeRanges[type];
        this.detectEvictedFragments(type, timeRange, playlistType, part);
    }
    onFragBuffered(event, data) {
        this.detectPartialFragments(data);
    }
    hasFragment(fragment) {
        const fragKey = $b941786f4eb9cb76$var$getFragmentKey(fragment);
        return !!this.fragments[fragKey];
    }
    hasFragments(type) {
        const { fragments: fragments } = this;
        const keys = Object.keys(fragments);
        if (!type) return keys.length > 0;
        for(let i = keys.length; i--;){
            const fragmentEntity = fragments[keys[i]];
            if ((fragmentEntity == null ? void 0 : fragmentEntity.body.type) === type) return true;
        }
        return false;
    }
    hasParts(type) {
        var _this$activePartLists;
        return !!((_this$activePartLists = this.activePartLists[type]) != null && _this$activePartLists.length);
    }
    removeFragmentsInRange(start, end, playlistType, withGapOnly, unbufferedOnly) {
        if (withGapOnly && !this.hasGaps) return;
        Object.keys(this.fragments).forEach((key)=>{
            const fragmentEntity = this.fragments[key];
            if (!fragmentEntity) return;
            const frag = fragmentEntity.body;
            if (frag.type !== playlistType || withGapOnly && !frag.gap) return;
            if (frag.start < end && frag.end > start && (fragmentEntity.buffered || unbufferedOnly)) this.removeFragment(frag);
        });
    }
    removeFragment(fragment) {
        const fragKey = $b941786f4eb9cb76$var$getFragmentKey(fragment);
        fragment.clearElementaryStreamInfo();
        const activeParts = this.activePartLists[fragment.type];
        if (activeParts) {
            const snToRemove = fragment.sn;
            this.activePartLists[fragment.type] = $b941786f4eb9cb76$var$filterParts(activeParts, (part)=>part.fragment.sn !== snToRemove);
        }
        delete this.fragments[fragKey];
        if (fragment.endList) delete this.endListFragments[fragment.type];
    }
    removeAllFragments() {
        var _this$hls;
        this.fragments = Object.create(null);
        this.endListFragments = Object.create(null);
        this.activePartLists = Object.create(null);
        this.hasGaps = false;
        const partlist = (_this$hls = this.hls) == null || (_this$hls = _this$hls.latestLevelDetails) == null ? void 0 : _this$hls.partList;
        if (partlist) partlist.forEach((part)=>part.clearElementaryStreamInfo());
    }
}
function $b941786f4eb9cb76$var$isPartial(fragmentEntity) {
    var _fragmentEntity$range, _fragmentEntity$range2, _fragmentEntity$range3;
    return fragmentEntity.buffered && !!(fragmentEntity.body.gap || (_fragmentEntity$range = fragmentEntity.range.video) != null && _fragmentEntity$range.partial || (_fragmentEntity$range2 = fragmentEntity.range.audio) != null && _fragmentEntity$range2.partial || (_fragmentEntity$range3 = fragmentEntity.range.audiovideo) != null && _fragmentEntity$range3.partial);
}
function $b941786f4eb9cb76$var$getFragmentKey(fragment) {
    return `${fragment.type}_${fragment.level}_${fragment.sn}`;
}
function $b941786f4eb9cb76$var$filterParts(partList, predicate) {
    return partList.filter((part)=>{
        const keep = predicate(part);
        if (!keep) part.clearElementaryStreamInfo();
        return keep;
    });
}
var $b941786f4eb9cb76$var$DecrypterAesMode = {
    cbc: 0,
    ctr: 1
};
class $b941786f4eb9cb76$var$AESCrypto {
    constructor(subtle, iv, aesMode){
        this.subtle = void 0;
        this.aesIV = void 0;
        this.aesMode = void 0;
        this.subtle = subtle;
        this.aesIV = iv;
        this.aesMode = aesMode;
    }
    decrypt(data, key) {
        switch(this.aesMode){
            case $b941786f4eb9cb76$var$DecrypterAesMode.cbc:
                return this.subtle.decrypt({
                    name: 'AES-CBC',
                    iv: this.aesIV
                }, key, data);
            case $b941786f4eb9cb76$var$DecrypterAesMode.ctr:
                return this.subtle.decrypt({
                    name: 'AES-CTR',
                    counter: this.aesIV,
                    length: 64
                }, //64 : NIST SP800-38A standard suggests that the counter should occupy half of the counter block
                key, data);
            default:
                throw new Error(`[AESCrypto] invalid aes mode ${this.aesMode}`);
        }
    }
}
// PKCS7
function $b941786f4eb9cb76$var$removePadding(array) {
    const outputBytes = array.byteLength;
    const paddingBytes = outputBytes && new DataView(array.buffer).getUint8(outputBytes - 1);
    if (paddingBytes) return array.slice(0, outputBytes - paddingBytes);
    return array;
}
class $b941786f4eb9cb76$var$AESDecryptor {
    constructor(){
        this.rcon = [
            0x0,
            0x1,
            0x2,
            0x4,
            0x8,
            0x10,
            0x20,
            0x40,
            0x80,
            0x1b,
            0x36
        ];
        this.subMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.invSubMix = [
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256),
            new Uint32Array(256)
        ];
        this.sBox = new Uint32Array(256);
        this.invSBox = new Uint32Array(256);
        this.key = new Uint32Array(0);
        this.ksRows = 0;
        this.keySize = 0;
        this.keySchedule = void 0;
        this.invKeySchedule = void 0;
        this.initTable();
    }
    // Using view.getUint32() also swaps the byte order.
    uint8ArrayToUint32Array_(arrayBuffer) {
        const view = new DataView(arrayBuffer);
        const newArray = new Uint32Array(4);
        for(let i = 0; i < 4; i++)newArray[i] = view.getUint32(i * 4);
        return newArray;
    }
    initTable() {
        const sBox = this.sBox;
        const invSBox = this.invSBox;
        const subMix = this.subMix;
        const subMix0 = subMix[0];
        const subMix1 = subMix[1];
        const subMix2 = subMix[2];
        const subMix3 = subMix[3];
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const d = new Uint32Array(256);
        let x = 0;
        let xi = 0;
        let i = 0;
        for(i = 0; i < 256; i++)if (i < 128) d[i] = i << 1;
        else d[i] = i << 1 ^ 0x11b;
        for(i = 0; i < 256; i++){
            let sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
            sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
            sBox[x] = sx;
            invSBox[sx] = x;
            // Compute multiplication
            const x2 = d[x];
            const x4 = d[x2];
            const x8 = d[x4];
            // Compute sub/invSub bytes, mix columns tables
            let t = d[sx] * 0x101 ^ sx * 0x1010100;
            subMix0[x] = t << 24 | t >>> 8;
            subMix1[x] = t << 16 | t >>> 16;
            subMix2[x] = t << 8 | t >>> 24;
            subMix3[x] = t;
            // Compute inv sub bytes, inv mix columns tables
            t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
            invSubMix0[sx] = t << 24 | t >>> 8;
            invSubMix1[sx] = t << 16 | t >>> 16;
            invSubMix2[sx] = t << 8 | t >>> 24;
            invSubMix3[sx] = t;
            // Compute next counter
            if (!x) x = xi = 1;
            else {
                x = x2 ^ d[d[d[x8 ^ x2]]];
                xi ^= d[d[xi]];
            }
        }
    }
    expandKey(keyBuffer) {
        // convert keyBuffer to Uint32Array
        const key = this.uint8ArrayToUint32Array_(keyBuffer);
        let sameKey = true;
        let offset = 0;
        while(offset < key.length && sameKey){
            sameKey = key[offset] === this.key[offset];
            offset++;
        }
        if (sameKey) return;
        this.key = key;
        const keySize = this.keySize = key.length;
        if (keySize !== 4 && keySize !== 6 && keySize !== 8) throw new Error('Invalid aes key size=' + keySize);
        const ksRows = this.ksRows = (keySize + 6 + 1) * 4;
        let ksRow;
        let invKsRow;
        const keySchedule = this.keySchedule = new Uint32Array(ksRows);
        const invKeySchedule = this.invKeySchedule = new Uint32Array(ksRows);
        const sbox = this.sBox;
        const rcon = this.rcon;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        let prev;
        let t;
        for(ksRow = 0; ksRow < ksRows; ksRow++){
            if (ksRow < keySize) {
                prev = keySchedule[ksRow] = key[ksRow];
                continue;
            }
            t = prev;
            if (ksRow % keySize === 0) {
                // Rot word
                t = t << 8 | t >>> 24;
                // Sub word
                t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
                // Mix Rcon
                t ^= rcon[ksRow / keySize | 0] << 24;
            } else if (keySize > 6 && ksRow % keySize === 4) // Sub word
            t = sbox[t >>> 24] << 24 | sbox[t >>> 16 & 0xff] << 16 | sbox[t >>> 8 & 0xff] << 8 | sbox[t & 0xff];
            keySchedule[ksRow] = prev = (keySchedule[ksRow - keySize] ^ t) >>> 0;
        }
        for(invKsRow = 0; invKsRow < ksRows; invKsRow++){
            ksRow = ksRows - invKsRow;
            if (invKsRow & 3) t = keySchedule[ksRow];
            else t = keySchedule[ksRow - 4];
            if (invKsRow < 4 || ksRow <= 4) invKeySchedule[invKsRow] = t;
            else invKeySchedule[invKsRow] = invSubMix0[sbox[t >>> 24]] ^ invSubMix1[sbox[t >>> 16 & 0xff]] ^ invSubMix2[sbox[t >>> 8 & 0xff]] ^ invSubMix3[sbox[t & 0xff]];
            invKeySchedule[invKsRow] = invKeySchedule[invKsRow] >>> 0;
        }
    }
    // Adding this as a method greatly improves performance.
    networkToHostOrderSwap(word) {
        return word << 24 | (word & 0xff00) << 8 | (word & 0xff0000) >> 8 | word >>> 24;
    }
    decrypt(inputArrayBuffer, offset, aesIV) {
        const nRounds = this.keySize + 6;
        const invKeySchedule = this.invKeySchedule;
        const invSBOX = this.invSBox;
        const invSubMix = this.invSubMix;
        const invSubMix0 = invSubMix[0];
        const invSubMix1 = invSubMix[1];
        const invSubMix2 = invSubMix[2];
        const invSubMix3 = invSubMix[3];
        const initVector = this.uint8ArrayToUint32Array_(aesIV);
        let initVector0 = initVector[0];
        let initVector1 = initVector[1];
        let initVector2 = initVector[2];
        let initVector3 = initVector[3];
        const inputInt32 = new Int32Array(inputArrayBuffer);
        const outputInt32 = new Int32Array(inputInt32.length);
        let t0, t1, t2, t3;
        let s0, s1, s2, s3;
        let inputWords0, inputWords1, inputWords2, inputWords3;
        let ksRow, i;
        const swapWord = this.networkToHostOrderSwap;
        while(offset < inputInt32.length){
            inputWords0 = swapWord(inputInt32[offset]);
            inputWords1 = swapWord(inputInt32[offset + 1]);
            inputWords2 = swapWord(inputInt32[offset + 2]);
            inputWords3 = swapWord(inputInt32[offset + 3]);
            s0 = inputWords0 ^ invKeySchedule[0];
            s1 = inputWords3 ^ invKeySchedule[1];
            s2 = inputWords2 ^ invKeySchedule[2];
            s3 = inputWords1 ^ invKeySchedule[3];
            ksRow = 4;
            // Iterate through the rounds of decryption
            for(i = 1; i < nRounds; i++){
                t0 = invSubMix0[s0 >>> 24] ^ invSubMix1[s1 >> 16 & 0xff] ^ invSubMix2[s2 >> 8 & 0xff] ^ invSubMix3[s3 & 0xff] ^ invKeySchedule[ksRow];
                t1 = invSubMix0[s1 >>> 24] ^ invSubMix1[s2 >> 16 & 0xff] ^ invSubMix2[s3 >> 8 & 0xff] ^ invSubMix3[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
                t2 = invSubMix0[s2 >>> 24] ^ invSubMix1[s3 >> 16 & 0xff] ^ invSubMix2[s0 >> 8 & 0xff] ^ invSubMix3[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
                t3 = invSubMix0[s3 >>> 24] ^ invSubMix1[s0 >> 16 & 0xff] ^ invSubMix2[s1 >> 8 & 0xff] ^ invSubMix3[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
                // Update state
                s0 = t0;
                s1 = t1;
                s2 = t2;
                s3 = t3;
                ksRow = ksRow + 4;
            }
            // Shift rows, sub bytes, add round key
            t0 = invSBOX[s0 >>> 24] << 24 ^ invSBOX[s1 >> 16 & 0xff] << 16 ^ invSBOX[s2 >> 8 & 0xff] << 8 ^ invSBOX[s3 & 0xff] ^ invKeySchedule[ksRow];
            t1 = invSBOX[s1 >>> 24] << 24 ^ invSBOX[s2 >> 16 & 0xff] << 16 ^ invSBOX[s3 >> 8 & 0xff] << 8 ^ invSBOX[s0 & 0xff] ^ invKeySchedule[ksRow + 1];
            t2 = invSBOX[s2 >>> 24] << 24 ^ invSBOX[s3 >> 16 & 0xff] << 16 ^ invSBOX[s0 >> 8 & 0xff] << 8 ^ invSBOX[s1 & 0xff] ^ invKeySchedule[ksRow + 2];
            t3 = invSBOX[s3 >>> 24] << 24 ^ invSBOX[s0 >> 16 & 0xff] << 16 ^ invSBOX[s1 >> 8 & 0xff] << 8 ^ invSBOX[s2 & 0xff] ^ invKeySchedule[ksRow + 3];
            // Write
            outputInt32[offset] = swapWord(t0 ^ initVector0);
            outputInt32[offset + 1] = swapWord(t3 ^ initVector1);
            outputInt32[offset + 2] = swapWord(t2 ^ initVector2);
            outputInt32[offset + 3] = swapWord(t1 ^ initVector3);
            // reset initVector to last 4 unsigned int
            initVector0 = inputWords0;
            initVector1 = inputWords1;
            initVector2 = inputWords2;
            initVector3 = inputWords3;
            offset = offset + 4;
        }
        return outputInt32.buffer;
    }
}
class $b941786f4eb9cb76$var$FastAESKey {
    constructor(subtle, key, aesMode){
        this.subtle = void 0;
        this.key = void 0;
        this.aesMode = void 0;
        this.subtle = subtle;
        this.key = key;
        this.aesMode = aesMode;
    }
    expandKey() {
        const subtleAlgoName = $b941786f4eb9cb76$var$getSubtleAlgoName(this.aesMode);
        return this.subtle.importKey('raw', this.key, {
            name: subtleAlgoName
        }, false, [
            'encrypt',
            'decrypt'
        ]);
    }
}
function $b941786f4eb9cb76$var$getSubtleAlgoName(aesMode) {
    switch(aesMode){
        case $b941786f4eb9cb76$var$DecrypterAesMode.cbc:
            return 'AES-CBC';
        case $b941786f4eb9cb76$var$DecrypterAesMode.ctr:
            return 'AES-CTR';
        default:
            throw new Error(`[FastAESKey] invalid aes mode ${aesMode}`);
    }
}
const $b941786f4eb9cb76$var$CHUNK_SIZE = 16; // 16 bytes, 128 bits
class $b941786f4eb9cb76$var$Decrypter {
    constructor(config, { removePKCS7Padding: removePKCS7Padding = true } = {}){
        this.logEnabled = true;
        this.removePKCS7Padding = void 0;
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
        this.useSoftware = void 0;
        this.enableSoftwareAES = void 0;
        this.enableSoftwareAES = config.enableSoftwareAES;
        this.removePKCS7Padding = removePKCS7Padding;
        // built in decryptor expects PKCS7 padding
        if (removePKCS7Padding) try {
            const browserCrypto = self.crypto;
            if (browserCrypto) this.subtle = browserCrypto.subtle || browserCrypto.webkitSubtle;
        } catch (e) {
        /* no-op */ }
        this.useSoftware = !this.subtle;
    }
    destroy() {
        this.subtle = null;
        this.softwareDecrypter = null;
        this.key = null;
        this.fastAesKey = null;
        this.remainderData = null;
        this.currentIV = null;
        this.currentResult = null;
    }
    isSync() {
        return this.useSoftware;
    }
    flush() {
        const { currentResult: currentResult, remainderData: remainderData } = this;
        if (!currentResult || remainderData) {
            this.reset();
            return null;
        }
        const data = new Uint8Array(currentResult);
        this.reset();
        if (this.removePKCS7Padding) return $b941786f4eb9cb76$var$removePadding(data);
        return data;
    }
    reset() {
        this.currentResult = null;
        this.currentIV = null;
        this.remainderData = null;
        if (this.softwareDecrypter) this.softwareDecrypter = null;
    }
    decrypt(data, key, iv, aesMode) {
        if (this.useSoftware) return new Promise((resolve, reject)=>{
            const dataView = ArrayBuffer.isView(data) ? data : new Uint8Array(data);
            this.softwareDecrypt(dataView, key, iv, aesMode);
            const decryptResult = this.flush();
            if (decryptResult) resolve(decryptResult.buffer);
            else reject(new Error('[softwareDecrypt] Failed to decrypt data'));
        });
        return this.webCryptoDecrypt(new Uint8Array(data), key, iv, aesMode);
    }
    // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
    // data is handled in the flush() call
    softwareDecrypt(data, key, iv, aesMode) {
        const { currentIV: currentIV, currentResult: currentResult, remainderData: remainderData } = this;
        if (aesMode !== $b941786f4eb9cb76$var$DecrypterAesMode.cbc || key.byteLength !== 16) {
            $b941786f4eb9cb76$var$logger.warn('SoftwareDecrypt: can only handle AES-128-CBC');
            return null;
        }
        this.logOnce('JS AES decrypt');
        // The output is staggered during progressive parsing - the current result is cached, and emitted on the next call
        // This is done in order to strip PKCS7 padding, which is found at the end of each segment. We only know we've reached
        // the end on flush(), but by that time we have already received all bytes for the segment.
        // Progressive decryption does not work with WebCrypto
        if (remainderData) {
            data = $b941786f4eb9cb76$var$appendUint8Array(remainderData, data);
            this.remainderData = null;
        }
        // Byte length must be a multiple of 16 (AES-128 = 128 bit blocks = 16 bytes)
        const currentChunk = this.getValidChunk(data);
        if (!currentChunk.length) return null;
        if (currentIV) iv = currentIV;
        let softwareDecrypter = this.softwareDecrypter;
        if (!softwareDecrypter) softwareDecrypter = this.softwareDecrypter = new $b941786f4eb9cb76$var$AESDecryptor();
        softwareDecrypter.expandKey(key);
        const result = currentResult;
        this.currentResult = softwareDecrypter.decrypt(currentChunk.buffer, 0, iv);
        this.currentIV = currentChunk.slice(-16).buffer;
        if (!result) return null;
        return result;
    }
    webCryptoDecrypt(data, key, iv, aesMode) {
        if (this.key !== key || !this.fastAesKey) {
            if (!this.subtle) return Promise.resolve(this.onWebCryptoError(data, key, iv, aesMode));
            this.key = key;
            this.fastAesKey = new $b941786f4eb9cb76$var$FastAESKey(this.subtle, key, aesMode);
        }
        return this.fastAesKey.expandKey().then((aesKey)=>{
            // decrypt using web crypto
            if (!this.subtle) return Promise.reject(new Error('web crypto not initialized'));
            this.logOnce('WebCrypto AES decrypt');
            const crypto1 = new $b941786f4eb9cb76$var$AESCrypto(this.subtle, new Uint8Array(iv), aesMode);
            return crypto1.decrypt(data.buffer, aesKey);
        }).catch((err)=>{
            $b941786f4eb9cb76$var$logger.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${err.name}: ${err.message}`);
            return this.onWebCryptoError(data, key, iv, aesMode);
        });
    }
    onWebCryptoError(data, key, iv, aesMode) {
        const enableSoftwareAES = this.enableSoftwareAES;
        if (enableSoftwareAES) {
            this.useSoftware = true;
            this.logEnabled = true;
            this.softwareDecrypt(data, key, iv, aesMode);
            const decryptResult = this.flush();
            if (decryptResult) return decryptResult.buffer;
        }
        throw new Error('WebCrypto' + (enableSoftwareAES ? ' and softwareDecrypt' : '') + ': failed to decrypt data');
    }
    getValidChunk(data) {
        let currentChunk = data;
        const splitPoint = data.length - data.length % $b941786f4eb9cb76$var$CHUNK_SIZE;
        if (splitPoint !== data.length) {
            currentChunk = data.slice(0, splitPoint);
            this.remainderData = data.slice(splitPoint);
        }
        return currentChunk;
    }
    logOnce(msg) {
        if (!this.logEnabled) return;
        $b941786f4eb9cb76$var$logger.log(`[decrypter]: ${msg}`);
        this.logEnabled = false;
    }
}
const $b941786f4eb9cb76$var$MIN_CHUNK_SIZE = Math.pow(2, 17); // 128kb
class $b941786f4eb9cb76$var$FragmentLoader {
    constructor(config){
        this.config = void 0;
        this.loader = null;
        this.partLoadTimeout = -1;
        this.config = config;
    }
    destroy() {
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
    }
    abort() {
        if (this.loader) // Abort the loader for current fragment. Only one may load at any given time
        this.loader.abort();
    }
    load(frag, onProgress) {
        const url = frag.url;
        if (!url) return Promise.reject(new $b941786f4eb9cb76$var$LoadError({
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_ERROR,
            fatal: false,
            frag: frag,
            error: new Error(`Fragment does not have a ${url ? 'part list' : 'url'}`),
            networkDetails: null
        }));
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap) {
                if (frag.tagList.some((tags)=>tags[0] === 'GAP')) {
                    reject($b941786f4eb9cb76$var$createGapLoadError(frag));
                    return;
                } else // Reset temporary treatment as GAP tag
                frag.gap = false;
            }
            const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = $b941786f4eb9cb76$var$createLoaderContext(frag);
            frag.loader = loader;
            const loadPolicy = $b941786f4eb9cb76$var$getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: frag.sn === 'initSegment' ? Infinity : $b941786f4eb9cb76$var$MIN_CHUNK_SIZE
            };
            // Assign frag stats to the loader's stats reference
            frag.stats = loader.stats;
            const callbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    let payload = response.data;
                    if (context.resetIV && frag.decryptdata) {
                        frag.decryptdata.iv = new Uint8Array(payload.slice(0, 16));
                        payload = payload.slice(16);
                    }
                    resolve({
                        frag: frag,
                        part: null,
                        payload: payload,
                        networkDetails: networkDetails
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new $b941786f4eb9cb76$var$LoadError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag: frag,
                        response: $b941786f4eb9cb76$var$_objectSpread2({
                            url: url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $b941786f4eb9cb76$var$LoadError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_ABORTED,
                        fatal: false,
                        frag: frag,
                        error: new Error('Aborted'),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $b941786f4eb9cb76$var$LoadError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag: frag,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                }
            };
            if (onProgress) callbacks.onProgress = (stats, context, data, networkDetails)=>onProgress({
                    frag: frag,
                    part: null,
                    payload: data,
                    networkDetails: networkDetails
                });
            loader.load(loaderContext, loaderConfig, callbacks);
        });
    }
    loadPart(frag, part, onProgress) {
        this.abort();
        const config = this.config;
        const FragmentILoader = config.fLoader;
        const DefaultILoader = config.loader;
        return new Promise((resolve, reject)=>{
            if (this.loader) this.loader.destroy();
            if (frag.gap || part.gap) {
                reject($b941786f4eb9cb76$var$createGapLoadError(frag, part));
                return;
            }
            const loader = this.loader = FragmentILoader ? new FragmentILoader(config) : new DefaultILoader(config);
            const loaderContext = $b941786f4eb9cb76$var$createLoaderContext(frag, part);
            frag.loader = loader;
            // Should we define another load policy for parts?
            const loadPolicy = $b941786f4eb9cb76$var$getLoaderConfigWithoutReties(config.fragLoadPolicy.default);
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0,
                highWaterMark: $b941786f4eb9cb76$var$MIN_CHUNK_SIZE
            };
            // Assign part stats to the loader's stats reference
            part.stats = loader.stats;
            loader.load(loaderContext, loaderConfig, {
                onSuccess: (response, stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    this.updateStatsFromPart(frag, part);
                    const partLoadedData = {
                        frag: frag,
                        part: part,
                        payload: response.data,
                        networkDetails: networkDetails
                    };
                    onProgress(partLoadedData);
                    resolve(partLoadedData);
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(frag, loader);
                    reject(new $b941786f4eb9cb76$var$LoadError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_ERROR,
                        fatal: false,
                        frag: frag,
                        part: part,
                        response: $b941786f4eb9cb76$var$_objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response),
                        error: new Error(`HTTP Error ${response.code} ${response.text}`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onAbort: (stats, context, networkDetails)=>{
                    frag.stats.aborted = part.stats.aborted;
                    this.resetLoader(frag, loader);
                    reject(new $b941786f4eb9cb76$var$LoadError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_ABORTED,
                        fatal: false,
                        frag: frag,
                        part: part,
                        error: new Error('Aborted'),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(frag, loader);
                    reject(new $b941786f4eb9cb76$var$LoadError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT,
                        fatal: false,
                        frag: frag,
                        part: part,
                        error: new Error(`Timeout after ${loaderConfig.timeout}ms`),
                        networkDetails: networkDetails,
                        stats: stats
                    }));
                }
            });
        });
    }
    updateStatsFromPart(frag, part) {
        const fragStats = frag.stats;
        const partStats = part.stats;
        const partTotal = partStats.total;
        fragStats.loaded += partStats.loaded;
        if (partTotal) {
            const estTotalParts = Math.round(frag.duration / part.duration);
            const estLoadedParts = Math.min(Math.round(fragStats.loaded / partTotal), estTotalParts);
            const estRemainingParts = estTotalParts - estLoadedParts;
            const estRemainingBytes = estRemainingParts * Math.round(fragStats.loaded / estLoadedParts);
            fragStats.total = fragStats.loaded + estRemainingBytes;
        } else fragStats.total = Math.max(fragStats.loaded, fragStats.total);
        const fragLoading = fragStats.loading;
        const partLoading = partStats.loading;
        if (fragLoading.start) // add to fragment loader latency
        fragLoading.first += partLoading.first - partLoading.start;
        else {
            fragLoading.start = partLoading.start;
            fragLoading.first = partLoading.first;
        }
        fragLoading.end = partLoading.end;
    }
    resetLoader(frag, loader) {
        frag.loader = null;
        if (this.loader === loader) {
            self.clearTimeout(this.partLoadTimeout);
            this.loader = null;
        }
        loader.destroy();
    }
}
function $b941786f4eb9cb76$var$createLoaderContext(frag, part = null) {
    const segment = part || frag;
    const loaderContext = {
        frag: frag,
        part: part,
        responseType: 'arraybuffer',
        url: segment.url,
        headers: {},
        rangeStart: 0,
        rangeEnd: 0
    };
    const start = segment.byteRangeStartOffset;
    const end = segment.byteRangeEndOffset;
    if ($b941786f4eb9cb76$var$isFiniteNumber(start) && $b941786f4eb9cb76$var$isFiniteNumber(end)) {
        var _frag$decryptdata;
        let byteRangeStart = start;
        let byteRangeEnd = end;
        if (frag.sn === 'initSegment' && $b941786f4eb9cb76$var$isMethodFullSegmentAesCbc((_frag$decryptdata = frag.decryptdata) == null ? void 0 : _frag$decryptdata.method)) {
            // MAP segment encrypted with method 'AES-128' or 'AES-256' (cbc), when served with HTTP Range,
            // has the unencrypted size specified in the range.
            // Ref: https://tools.ietf.org/html/draft-pantos-hls-rfc8216bis-08#section-6.3.6
            const fragmentLen = end - start;
            if (fragmentLen % 16) byteRangeEnd = end + (16 - fragmentLen % 16);
            if (start !== 0) {
                loaderContext.resetIV = true;
                byteRangeStart = start - 16;
            }
        }
        loaderContext.rangeStart = byteRangeStart;
        loaderContext.rangeEnd = byteRangeEnd;
    }
    return loaderContext;
}
function $b941786f4eb9cb76$var$createGapLoadError(frag, part) {
    const error = new Error(`GAP ${frag.gap ? 'tag' : 'attribute'} found`);
    const errorData = {
        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
        details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP,
        fatal: false,
        frag: frag,
        error: error,
        networkDetails: null
    };
    if (part) errorData.part = part;
    (part ? part : frag).stats.aborted = true;
    return new $b941786f4eb9cb76$var$LoadError(errorData);
}
function $b941786f4eb9cb76$var$isMethodFullSegmentAesCbc(method) {
    return method === 'AES-128' || method === 'AES-256';
}
class $b941786f4eb9cb76$var$LoadError extends Error {
    constructor(data){
        super(data.error.message);
        this.data = void 0;
        this.data = data;
    }
}
/**
 * @ignore
 * Sub-class specialization of EventHandler base class.
 *
 * TaskLoop allows to schedule a task function being called (optionnaly repeatedly) on the main loop,
 * scheduled asynchroneously, avoiding recursive calls in the same tick.
 *
 * The task itself is implemented in `doTick`. It can be requested and called for single execution
 * using the `tick` method.
 *
 * It will be assured that the task execution method (`tick`) only gets called once per main loop "tick",
 * no matter how often it gets requested for execution. Execution in further ticks will be scheduled accordingly.
 *
 * If further execution requests have already been scheduled on the next tick, it can be checked with `hasNextTick`,
 * and cancelled with `clearNextTick`.
 *
 * The task can be scheduled as an interval repeatedly with a period as parameter (see `setInterval`, `clearInterval`).
 *
 * Sub-classes need to implement the `doTick` method which will effectively have the task execution routine.
 *
 * Further explanations:
 *
 * The baseclass has a `tick` method that will schedule the doTick call. It may be called synchroneously
 * only for a stack-depth of one. On re-entrant calls, sub-sequent calls are scheduled for next main loop ticks.
 *
 * When the task execution (`tick` method) is called in re-entrant way this is detected and
 * we are limiting the task execution per call stack to exactly one, but scheduling/post-poning further
 * task processing on the next main loop iteration (also known as "next tick" in the Node/JS runtime lingo).
 */ class $b941786f4eb9cb76$var$TaskLoop extends $b941786f4eb9cb76$var$Logger {
    constructor(label, logger){
        super(label, logger);
        this._boundTick = void 0;
        this._tickTimer = null;
        this._tickInterval = null;
        this._tickCallCount = 0;
        this._boundTick = this.tick.bind(this);
    }
    destroy() {
        this.onHandlerDestroying();
        this.onHandlerDestroyed();
    }
    onHandlerDestroying() {
        // clear all timers before unregistering from event bus
        this.clearNextTick();
        this.clearInterval();
    }
    onHandlerDestroyed() {}
    hasInterval() {
        return !!this._tickInterval;
    }
    hasNextTick() {
        return !!this._tickTimer;
    }
    /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */ setInterval(millis) {
        if (!this._tickInterval) {
            this._tickCallCount = 0;
            this._tickInterval = self.setInterval(this._boundTick, millis);
            return true;
        }
        return false;
    }
    /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */ clearInterval() {
        if (this._tickInterval) {
            self.clearInterval(this._tickInterval);
            this._tickInterval = null;
            return true;
        }
        return false;
    }
    /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */ clearNextTick() {
        if (this._tickTimer) {
            self.clearTimeout(this._tickTimer);
            this._tickTimer = null;
            return true;
        }
        return false;
    }
    /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */ tick() {
        this._tickCallCount++;
        if (this._tickCallCount === 1) {
            this.doTick();
            // re-entrant call to tick from previous doTick call stack
            // -> schedule a call on the next main loop iteration to process this task processing request
            if (this._tickCallCount > 1) // make sure only one timer exists at any time at max
            this.tickImmediate();
            this._tickCallCount = 0;
        }
    }
    tickImmediate() {
        this.clearNextTick();
        this._tickTimer = self.setTimeout(this._boundTick, 0);
    }
    /**
   * For subclass to implement task logic
   * @abstract
   */ doTick() {}
}
class $b941786f4eb9cb76$export$ce0708ece532c9c {
    constructor(level, sn, id, size = 0, part = -1, partial = false){
        this.level = void 0;
        this.sn = void 0;
        this.part = void 0;
        this.id = void 0;
        this.size = void 0;
        this.partial = void 0;
        this.transmuxing = $b941786f4eb9cb76$var$getNewPerformanceTiming();
        this.buffering = {
            audio: $b941786f4eb9cb76$var$getNewPerformanceTiming(),
            video: $b941786f4eb9cb76$var$getNewPerformanceTiming(),
            audiovideo: $b941786f4eb9cb76$var$getNewPerformanceTiming()
        };
        this.level = level;
        this.sn = sn;
        this.id = id;
        this.size = size;
        this.part = part;
        this.partial = partial;
    }
}
function $b941786f4eb9cb76$var$getNewPerformanceTiming() {
    return {
        start: 0,
        executeStart: 0,
        executeEnd: 0,
        end: 0
    };
}
/**
 * Provides methods dealing with buffer length retrieval for example.
 *
 * In general, a helper around HTML5 MediaElement TimeRanges gathered from `buffered` property.
 *
 * Also @see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/buffered
 */ const $b941786f4eb9cb76$var$noopBuffered = {
    length: 0,
    start: ()=>0,
    end: ()=>0
};
class $b941786f4eb9cb76$var$BufferHelper {
    /**
   * Return true if `media`'s buffered include `position`
   */ static isBuffered(media, position) {
        if (media) {
            const buffered = $b941786f4eb9cb76$var$BufferHelper.getBuffered(media);
            for(let i = buffered.length; i--;){
                if (position >= buffered.start(i) && position <= buffered.end(i)) return true;
            }
        }
        return false;
    }
    static bufferedRanges(media) {
        if (media) {
            const timeRanges = $b941786f4eb9cb76$var$BufferHelper.getBuffered(media);
            return $b941786f4eb9cb76$var$BufferHelper.timeRangesToArray(timeRanges);
        }
        return [];
    }
    static timeRangesToArray(timeRanges) {
        const buffered = [];
        for(let i = 0; i < timeRanges.length; i++)buffered.push({
            start: timeRanges.start(i),
            end: timeRanges.end(i)
        });
        return buffered;
    }
    static bufferInfo(media, pos, maxHoleDuration) {
        if (media) {
            const buffered = $b941786f4eb9cb76$var$BufferHelper.bufferedRanges(media);
            if (buffered.length) return $b941786f4eb9cb76$var$BufferHelper.bufferedInfo(buffered, pos, maxHoleDuration);
        }
        return {
            len: 0,
            start: pos,
            end: pos,
            bufferedIndex: -1
        };
    }
    static bufferedInfo(buffered, pos, maxHoleDuration) {
        pos = Math.max(0, pos);
        // sort on buffer.start/smaller end (IE does not always return sorted buffered range)
        if (buffered.length > 1) buffered.sort((a, b)=>a.start - b.start || b.end - a.end);
        let bufferedIndex = -1;
        let buffered2 = [];
        if (maxHoleDuration) // there might be some small holes between buffer time range
        // consider that holes smaller than maxHoleDuration are irrelevant and build another
        // buffer time range representations that discards those holes
        for(let i = 0; i < buffered.length; i++){
            if (pos >= buffered[i].start && pos <= buffered[i].end) bufferedIndex = i;
            const buf2len = buffered2.length;
            if (buf2len) {
                const buf2end = buffered2[buf2len - 1].end;
                // if small hole (value between 0 or maxHoleDuration ) or overlapping (negative)
                if (buffered[i].start - buf2end < maxHoleDuration) // merge overlapping time ranges
                // update lastRange.end only if smaller than item.end
                // e.g.  [ 1, 15] with  [ 2,8] => [ 1,15] (no need to modify lastRange.end)
                // whereas [ 1, 8] with  [ 2,15] => [ 1,15] ( lastRange should switch from [1,8] to [1,15])
                {
                    if (buffered[i].end > buf2end) buffered2[buf2len - 1].end = buffered[i].end;
                } else // big hole
                buffered2.push(buffered[i]);
            } else // first value
            buffered2.push(buffered[i]);
        }
        else buffered2 = buffered;
        let bufferLen = 0;
        let nextStart;
        // bufferStart and bufferEnd are buffer boundaries around current playback position (pos)
        let bufferStart = pos;
        let bufferEnd = pos;
        for(let i = 0; i < buffered2.length; i++){
            const start = buffered2[i].start;
            const end = buffered2[i].end;
            // logger.log('buf start/end:' + buffered.start(i) + '/' + buffered.end(i));
            if (bufferedIndex === -1 && pos >= start && pos <= end) bufferedIndex = i;
            if (pos + maxHoleDuration >= start && pos < end) {
                // play position is inside this buffer TimeRange, retrieve end of buffer position and buffer length
                bufferStart = start;
                bufferEnd = end;
                bufferLen = bufferEnd - pos;
            } else if (pos + maxHoleDuration < start) {
                nextStart = start;
                break;
            }
        }
        return {
            len: bufferLen,
            start: bufferStart || 0,
            end: bufferEnd || 0,
            nextStart: nextStart,
            buffered: buffered,
            bufferedIndex: bufferedIndex
        };
    }
    /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */ static getBuffered(media) {
        try {
            return media.buffered || $b941786f4eb9cb76$var$noopBuffered;
        } catch (e) {
            $b941786f4eb9cb76$var$logger.log('failed to get media.buffered', e);
            return $b941786f4eb9cb76$var$noopBuffered;
        }
    }
}
const $b941786f4eb9cb76$var$VARIABLE_REPLACEMENT_REGEX = /\{\$([a-zA-Z0-9-_]+)\}/g;
function $b941786f4eb9cb76$var$hasVariableReferences(str) {
    return $b941786f4eb9cb76$var$VARIABLE_REPLACEMENT_REGEX.test(str);
}
function $b941786f4eb9cb76$var$substituteVariables(parsed, value) {
    if (parsed.variableList !== null || parsed.hasVariableRefs) {
        const variableList = parsed.variableList;
        return value.replace($b941786f4eb9cb76$var$VARIABLE_REPLACEMENT_REGEX, (variableReference)=>{
            const variableName = variableReference.substring(2, variableReference.length - 1);
            const variableValue = variableList == null ? void 0 : variableList[variableName];
            if (variableValue === undefined) {
                parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${variableName}"`));
                return variableReference;
            }
            return variableValue;
        });
    }
    return value;
}
function $b941786f4eb9cb76$var$addVariableDefinition(parsed, attr, parentUrl) {
    let variableList = parsed.variableList;
    if (!variableList) parsed.variableList = variableList = {};
    let NAME;
    let VALUE;
    if ('QUERYPARAM' in attr) {
        NAME = attr.QUERYPARAM;
        try {
            const searchParams = new self.URL(parentUrl).searchParams;
            if (searchParams.has(NAME)) VALUE = searchParams.get(NAME);
            else throw new Error(`"${NAME}" does not match any query parameter in URI: "${parentUrl}"`);
        } catch (error) {
            parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${error.message}`));
        }
    } else {
        NAME = attr.NAME;
        VALUE = attr.VALUE;
    }
    if (NAME in variableList) parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${NAME}"`));
    else variableList[NAME] = VALUE || '';
}
function $b941786f4eb9cb76$var$importVariableDefinition(parsed, attr, sourceVariableList) {
    const IMPORT = attr.IMPORT;
    if (sourceVariableList && IMPORT in sourceVariableList) {
        let variableList = parsed.variableList;
        if (!variableList) parsed.variableList = variableList = {};
        variableList[IMPORT] = sourceVariableList[IMPORT];
    } else parsed.playlistParsingError || (parsed.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${IMPORT}"`));
}
const $b941786f4eb9cb76$var$DECIMAL_RESOLUTION_REGEX = /^(\d+)x(\d+)$/;
const $b941786f4eb9cb76$var$ATTR_LIST_REGEX = /(.+?)=(".*?"|.*?)(?:,|$)/g;
// adapted from https://github.com/kanongil/node-m3u8parse/blob/master/attrlist.js
class $b941786f4eb9cb76$export$3b2a5864ee72b619 {
    constructor(attrs, parsed){
        if (typeof attrs === 'string') attrs = $b941786f4eb9cb76$export$3b2a5864ee72b619.parseAttrList(attrs, parsed);
        $b941786f4eb9cb76$var$_extends(this, attrs);
    }
    get clientAttrs() {
        return Object.keys(this).filter((attr)=>attr.substring(0, 2) === 'X-');
    }
    decimalInteger(attrName) {
        const intValue = parseInt(this[attrName], 10);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    hexadecimalInteger(attrName) {
        if (this[attrName]) {
            let stringValue = (this[attrName] || '0x').slice(2);
            stringValue = (stringValue.length & 1 ? '0' : '') + stringValue;
            const value = new Uint8Array(stringValue.length / 2);
            for(let i = 0; i < stringValue.length / 2; i++)value[i] = parseInt(stringValue.slice(i * 2, i * 2 + 2), 16);
            return value;
        }
        return null;
    }
    hexadecimalIntegerAsNumber(attrName) {
        const intValue = parseInt(this[attrName], 16);
        if (intValue > Number.MAX_SAFE_INTEGER) return Infinity;
        return intValue;
    }
    decimalFloatingPoint(attrName) {
        return parseFloat(this[attrName]);
    }
    optionalFloat(attrName, defaultValue) {
        const value = this[attrName];
        return value ? parseFloat(value) : defaultValue;
    }
    enumeratedString(attrName) {
        return this[attrName];
    }
    enumeratedStringList(attrName, dict) {
        const attrValue = this[attrName];
        return (attrValue ? attrValue.split(/[ ,]+/) : []).reduce((result, identifier)=>{
            result[identifier.toLowerCase()] = true;
            return result;
        }, dict);
    }
    bool(attrName) {
        return this[attrName] === 'YES';
    }
    decimalResolution(attrName) {
        const res = $b941786f4eb9cb76$var$DECIMAL_RESOLUTION_REGEX.exec(this[attrName]);
        if (res === null) return undefined;
        return {
            width: parseInt(res[1], 10),
            height: parseInt(res[2], 10)
        };
    }
    static parseAttrList(input, parsed) {
        let match;
        const attrs = {};
        const quote = '"';
        $b941786f4eb9cb76$var$ATTR_LIST_REGEX.lastIndex = 0;
        while((match = $b941786f4eb9cb76$var$ATTR_LIST_REGEX.exec(input)) !== null){
            const name = match[1].trim();
            let value = match[2];
            const quotedString = value.indexOf(quote) === 0 && value.lastIndexOf(quote) === value.length - 1;
            let hexadecimalSequence = false;
            if (quotedString) value = value.slice(1, -1);
            else switch(name){
                case 'IV':
                case 'SCTE35-CMD':
                case 'SCTE35-IN':
                case 'SCTE35-OUT':
                    hexadecimalSequence = true;
            }
            if (parsed && (quotedString || hexadecimalSequence)) value = $b941786f4eb9cb76$var$substituteVariables(parsed, value);
            else if (!hexadecimalSequence && !quotedString) switch(name){
                case 'CLOSED-CAPTIONS':
                    if (value === 'NONE') break;
                // falls through
                case 'ALLOWED-CPC':
                case 'CLASS':
                case 'ASSOC-LANGUAGE':
                case 'AUDIO':
                case 'BYTERANGE':
                case 'CHANNELS':
                case 'CHARACTERISTICS':
                case 'CODECS':
                case 'DATA-ID':
                case 'END-DATE':
                case 'GROUP-ID':
                case 'ID':
                case 'IMPORT':
                case 'INSTREAM-ID':
                case 'KEYFORMAT':
                case 'KEYFORMATVERSIONS':
                case 'LANGUAGE':
                case 'NAME':
                case 'PATHWAY-ID':
                case 'QUERYPARAM':
                case 'RECENTLY-REMOVED-DATERANGES':
                case 'SERVER-URI':
                case 'STABLE-RENDITION-ID':
                case 'STABLE-VARIANT-ID':
                case 'START-DATE':
                case 'SUBTITLES':
                case 'SUPPLEMENTAL-CODECS':
                case 'URI':
                case 'VALUE':
                case 'VIDEO':
                case 'X-ASSET-LIST':
                case 'X-ASSET-URI':
                    // Since we are not checking tag:attribute combination, just warn rather than ignoring attribute
                    $b941786f4eb9cb76$var$logger.warn(`${input}: attribute ${name} is missing quotes`);
            }
            attrs[name] = value;
        }
        return attrs;
    }
}
// Avoid exporting const enum so that these values can be inlined
const $b941786f4eb9cb76$var$CLASS_INTERSTITIAL = 'com.apple.hls.interstitial';
function $b941786f4eb9cb76$var$isDateRangeCueAttribute(attrName) {
    return attrName !== "ID" && attrName !== "CLASS" && attrName !== "CUE" && attrName !== "START-DATE" && attrName !== "DURATION" && attrName !== "END-DATE" && attrName !== "END-ON-NEXT";
}
function $b941786f4eb9cb76$var$isSCTE35Attribute(attrName) {
    return attrName === "SCTE35-OUT" || attrName === "SCTE35-IN" || attrName === "SCTE35-CMD";
}
class $b941786f4eb9cb76$export$829bd850c745b6e {
    constructor(dateRangeAttr, dateRangeWithSameId, tagCount = 0){
        var _dateRangeWithSameId$;
        this.attr = void 0;
        this.tagAnchor = void 0;
        this.tagOrder = void 0;
        this._startDate = void 0;
        this._endDate = void 0;
        this._dateAtEnd = void 0;
        this._cue = void 0;
        this._badValueForSameId = void 0;
        this.tagAnchor = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagAnchor) || null;
        this.tagOrder = (_dateRangeWithSameId$ = dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.tagOrder) != null ? _dateRangeWithSameId$ : tagCount;
        if (dateRangeWithSameId) {
            const previousAttr = dateRangeWithSameId.attr;
            for(const key in previousAttr)if (Object.prototype.hasOwnProperty.call(dateRangeAttr, key) && dateRangeAttr[key] !== previousAttr[key]) {
                $b941786f4eb9cb76$var$logger.warn(`DATERANGE tag attribute: "${key}" does not match for tags with ID: "${dateRangeAttr.ID}"`);
                this._badValueForSameId = key;
                break;
            }
            // Merge DateRange tags with the same ID
            dateRangeAttr = $b941786f4eb9cb76$var$_extends(new $b941786f4eb9cb76$export$3b2a5864ee72b619({}), previousAttr, dateRangeAttr);
        }
        this.attr = dateRangeAttr;
        if (dateRangeWithSameId) {
            this._startDate = dateRangeWithSameId._startDate;
            this._cue = dateRangeWithSameId._cue;
            this._endDate = dateRangeWithSameId._endDate;
            this._dateAtEnd = dateRangeWithSameId._dateAtEnd;
        } else this._startDate = new Date(dateRangeAttr["START-DATE"]);
        if ("END-DATE" in this.attr) {
            const endDate = (dateRangeWithSameId == null ? void 0 : dateRangeWithSameId.endDate) || new Date(this.attr["END-DATE"]);
            if ($b941786f4eb9cb76$var$isFiniteNumber(endDate.getTime())) this._endDate = endDate;
        }
    }
    get id() {
        return this.attr.ID;
    }
    get class() {
        return this.attr.CLASS;
    }
    get cue() {
        const _cue = this._cue;
        if (_cue === undefined) return this._cue = this.attr.enumeratedStringList(this.attr.CUE ? 'CUE' : 'X-CUE', {
            pre: false,
            post: false,
            once: false
        });
        return _cue;
    }
    get startTime() {
        const { tagAnchor: tagAnchor } = this;
        // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
        if (tagAnchor === null || tagAnchor.programDateTime === null) {
            $b941786f4eb9cb76$var$logger.warn(`Expected tagAnchor Fragment with PDT set for DateRange "${this.id}": ${tagAnchor}`);
            return NaN;
        }
        return tagAnchor.start + (this.startDate.getTime() - tagAnchor.programDateTime) / 1000;
    }
    get startDate() {
        return this._startDate;
    }
    get endDate() {
        const dateAtEnd = this._endDate || this._dateAtEnd;
        if (dateAtEnd) return dateAtEnd;
        const duration = this.duration;
        if (duration !== null) return this._dateAtEnd = new Date(this._startDate.getTime() + duration * 1000);
        return null;
    }
    get duration() {
        if ("DURATION" in this.attr) {
            const duration = this.attr.decimalFloatingPoint("DURATION");
            if ($b941786f4eb9cb76$var$isFiniteNumber(duration)) return duration;
        } else if (this._endDate) return (this._endDate.getTime() - this._startDate.getTime()) / 1000;
        return null;
    }
    get plannedDuration() {
        if ("PLANNED-DURATION" in this.attr) return this.attr.decimalFloatingPoint("PLANNED-DURATION");
        return null;
    }
    get endOnNext() {
        return this.attr.bool("END-ON-NEXT");
    }
    get isInterstitial() {
        return this.class === $b941786f4eb9cb76$var$CLASS_INTERSTITIAL;
    }
    get isValid() {
        return !!this.id && !this._badValueForSameId && $b941786f4eb9cb76$var$isFiniteNumber(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class) && (!this.attr.CUE || !this.cue.pre && !this.cue.post || this.cue.pre !== this.cue.post) && (!this.isInterstitial || 'X-ASSET-URI' in this.attr || 'X-ASSET-LIST' in this.attr);
    }
}
const $b941786f4eb9cb76$var$DEFAULT_TARGET_DURATION = 10;
/**
 * Object representing parsed data from an HLS Media Playlist. Found in {@link hls.js#Level.details}.
 */ class $b941786f4eb9cb76$export$9eda1d8aef4189e9 {
    constructor(baseUrl){
        this.PTSKnown = false;
        this.alignedSliding = false;
        this.averagetargetduration = void 0;
        this.endCC = 0;
        this.endSN = 0;
        this.fragments = void 0;
        this.fragmentHint = void 0;
        this.partList = null;
        this.dateRanges = void 0;
        this.dateRangeTagCount = 0;
        this.live = true;
        this.requestScheduled = -1;
        this.ageHeader = 0;
        this.advancedDateTime = void 0;
        this.updated = true;
        this.advanced = true;
        this.misses = 0;
        this.startCC = 0;
        this.startSN = 0;
        this.startTimeOffset = null;
        this.targetduration = 0;
        this.totalduration = 0;
        this.type = null;
        this.url = void 0;
        this.m3u8 = '';
        this.version = null;
        this.canBlockReload = false;
        this.canSkipUntil = 0;
        this.canSkipDateRanges = false;
        this.skippedSegments = 0;
        this.recentlyRemovedDateranges = void 0;
        this.partHoldBack = 0;
        this.holdBack = 0;
        this.partTarget = 0;
        this.preloadHint = void 0;
        this.renditionReports = void 0;
        this.tuneInGoal = 0;
        this.deltaUpdateFailed = void 0;
        this.driftStartTime = 0;
        this.driftEndTime = 0;
        this.driftStart = 0;
        this.driftEnd = 0;
        this.encryptedFragments = void 0;
        this.playlistParsingError = null;
        this.variableList = null;
        this.hasVariableRefs = false;
        this.appliedTimelineOffset = void 0;
        this.fragments = [];
        this.encryptedFragments = [];
        this.dateRanges = {};
        this.url = baseUrl;
    }
    reloaded(previous) {
        if (!previous) {
            this.advanced = true;
            this.updated = true;
            return;
        }
        const partSnDiff = this.lastPartSn - previous.lastPartSn;
        const partIndexDiff = this.lastPartIndex - previous.lastPartIndex;
        this.updated = this.endSN !== previous.endSN || !!partIndexDiff || !!partSnDiff || !this.live;
        this.advanced = this.endSN > previous.endSN || partSnDiff > 0 || partSnDiff === 0 && partIndexDiff > 0;
        if (this.updated || this.advanced) this.misses = Math.floor(previous.misses * 0.6);
        else this.misses = previous.misses + 1;
    }
    hasKey(levelKey) {
        return this.encryptedFragments.some((frag)=>{
            let decryptdata = frag.decryptdata;
            if (!decryptdata) {
                frag.setKeyFormat(levelKey.keyFormat);
                decryptdata = frag.decryptdata;
            }
            return !!decryptdata && levelKey.matches(decryptdata);
        });
    }
    get hasProgramDateTime() {
        if (this.fragments.length) return $b941786f4eb9cb76$var$isFiniteNumber(this.fragments[this.fragments.length - 1].programDateTime);
        return false;
    }
    get levelTargetDuration() {
        return this.averagetargetduration || this.targetduration || $b941786f4eb9cb76$var$DEFAULT_TARGET_DURATION;
    }
    get drift() {
        const runTime = this.driftEndTime - this.driftStartTime;
        if (runTime > 0) {
            const runDuration = this.driftEnd - this.driftStart;
            return runDuration * 1000 / runTime;
        }
        return 1;
    }
    get edge() {
        return this.partEnd || this.fragmentEnd;
    }
    get partEnd() {
        var _this$partList;
        if ((_this$partList = this.partList) != null && _this$partList.length) return this.partList[this.partList.length - 1].end;
        return this.fragmentEnd;
    }
    get fragmentEnd() {
        if (this.fragments.length) return this.fragments[this.fragments.length - 1].end;
        return 0;
    }
    get fragmentStart() {
        if (this.fragments.length) return this.fragments[0].start;
        return 0;
    }
    get age() {
        if (this.advancedDateTime) return Math.max(Date.now() - this.advancedDateTime, 0) / 1000;
        return 0;
    }
    get lastPartIndex() {
        var _this$partList2;
        if ((_this$partList2 = this.partList) != null && _this$partList2.length) return this.partList[this.partList.length - 1].index;
        return -1;
    }
    get maxPartIndex() {
        const partList = this.partList;
        if (partList) {
            const lastIndex = this.lastPartIndex;
            if (lastIndex !== -1) {
                for(let i = partList.length; i--;){
                    if (partList[i].index > lastIndex) return partList[i].index;
                }
                return lastIndex;
            }
        }
        return 0;
    }
    get lastPartSn() {
        var _this$partList3;
        if ((_this$partList3 = this.partList) != null && _this$partList3.length) return this.partList[this.partList.length - 1].fragment.sn;
        return this.endSN;
    }
    get expired() {
        if (this.live && this.age && this.misses < 3) {
            const playlistWindowDuration = this.partEnd - this.fragmentStart;
            return this.age > Math.max(playlistWindowDuration, this.totalduration) + this.levelTargetDuration;
        }
        return false;
    }
}
function $b941786f4eb9cb76$var$arrayValuesMatch(a, b) {
    if (a.length === b.length) return !a.some((value, i)=>value !== b[i]);
    return false;
}
function $b941786f4eb9cb76$var$optionalArrayValuesMatch(a, b) {
    if (!a && !b) return true;
    if (!a || !b) return false;
    return $b941786f4eb9cb76$var$arrayValuesMatch(a, b);
}
function $b941786f4eb9cb76$var$isFullSegmentEncryption(method) {
    return method === 'AES-128' || method === 'AES-256' || method === 'AES-256-CTR';
}
function $b941786f4eb9cb76$var$getAesModeFromFullSegmentMethod(method) {
    switch(method){
        case 'AES-128':
        case 'AES-256':
            return $b941786f4eb9cb76$var$DecrypterAesMode.cbc;
        case 'AES-256-CTR':
            return $b941786f4eb9cb76$var$DecrypterAesMode.ctr;
        default:
            throw new Error(`invalid full segment method ${method}`);
    }
}
function $b941786f4eb9cb76$var$base64Decode(base64encodedStr) {
    return Uint8Array.from(atob(base64encodedStr), (c)=>c.charCodeAt(0));
}
// breaking up those two types in order to clarify what is happening in the decoding path.
// http://stackoverflow.com/questions/8936984/uint8array-to-string-in-javascript/22373197
// http://www.onicos.com/staff/iz/amuse/javascript/expert/utf.txt
/* utf.js - UTF-8 <=> UTF-16 convertion
 *
 * Copyright (C) 1999 Masanao Izumo <iz@onicos.co.jp>
 * Version: 1.0
 * LastModified: Dec 25 1999
 * This library is free.  You can redistribute it and/or modify it.
 */ function $b941786f4eb9cb76$var$strToUtf8array(str) {
    return Uint8Array.from(unescape(encodeURIComponent(str)), (c)=>c.charCodeAt(0));
}
function $b941786f4eb9cb76$var$getKeyIdBytes(str) {
    const keyIdbytes = $b941786f4eb9cb76$var$strToUtf8array(str).subarray(0, 16);
    const paddedkeyIdbytes = new Uint8Array(16);
    paddedkeyIdbytes.set(keyIdbytes, 16 - keyIdbytes.length);
    return paddedkeyIdbytes;
}
function $b941786f4eb9cb76$var$changeEndianness(keyId) {
    const swap = function swap(array, from, to) {
        const cur = array[from];
        array[from] = array[to];
        array[to] = cur;
    };
    swap(keyId, 0, 3);
    swap(keyId, 1, 2);
    swap(keyId, 4, 5);
    swap(keyId, 6, 7);
}
function $b941786f4eb9cb76$var$convertDataUriToArrayBytes(uri) {
    // data:[<media type][;attribute=value][;base64],<data>
    const colonsplit = uri.split(':');
    let keydata = null;
    if (colonsplit[0] === 'data' && colonsplit.length === 2) {
        const semicolonsplit = colonsplit[1].split(';');
        const commasplit = semicolonsplit[semicolonsplit.length - 1].split(',');
        if (commasplit.length === 2) {
            const isbase64 = commasplit[0] === 'base64';
            const data = commasplit[1];
            if (isbase64) {
                semicolonsplit.splice(-1, 1); // remove from processing
                keydata = $b941786f4eb9cb76$var$base64Decode(data);
            } else keydata = $b941786f4eb9cb76$var$getKeyIdBytes(data);
        }
    }
    return keydata;
}
/** returns `undefined` is `self` is missing, e.g. in node */ const $b941786f4eb9cb76$var$optionalSelf = typeof self !== 'undefined' ? self : undefined;
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Navigator/requestMediaKeySystemAccess
 */ var $b941786f4eb9cb76$export$1c7b21e05766136c = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.fps",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "com.widevine.alpha"
};
// Playlist #EXT-X-KEY KEYFORMAT values
var $b941786f4eb9cb76$export$adbe91680a33e4e2 = {
    CLEARKEY: "org.w3.clearkey",
    FAIRPLAY: "com.apple.streamingkeydelivery",
    PLAYREADY: "com.microsoft.playready",
    WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function $b941786f4eb9cb76$var$keySystemFormatToKeySystemDomain(format) {
    switch(format){
        case $b941786f4eb9cb76$export$adbe91680a33e4e2.FAIRPLAY:
            return $b941786f4eb9cb76$export$1c7b21e05766136c.FAIRPLAY;
        case $b941786f4eb9cb76$export$adbe91680a33e4e2.PLAYREADY:
            return $b941786f4eb9cb76$export$1c7b21e05766136c.PLAYREADY;
        case $b941786f4eb9cb76$export$adbe91680a33e4e2.WIDEVINE:
            return $b941786f4eb9cb76$export$1c7b21e05766136c.WIDEVINE;
        case $b941786f4eb9cb76$export$adbe91680a33e4e2.CLEARKEY:
            return $b941786f4eb9cb76$export$1c7b21e05766136c.CLEARKEY;
    }
}
function $b941786f4eb9cb76$var$keySystemDomainToKeySystemFormat(keySystem) {
    switch(keySystem){
        case $b941786f4eb9cb76$export$1c7b21e05766136c.FAIRPLAY:
            return $b941786f4eb9cb76$export$adbe91680a33e4e2.FAIRPLAY;
        case $b941786f4eb9cb76$export$1c7b21e05766136c.PLAYREADY:
            return $b941786f4eb9cb76$export$adbe91680a33e4e2.PLAYREADY;
        case $b941786f4eb9cb76$export$1c7b21e05766136c.WIDEVINE:
            return $b941786f4eb9cb76$export$adbe91680a33e4e2.WIDEVINE;
        case $b941786f4eb9cb76$export$1c7b21e05766136c.CLEARKEY:
            return $b941786f4eb9cb76$export$adbe91680a33e4e2.CLEARKEY;
    }
}
function $b941786f4eb9cb76$var$getKeySystemsForConfig(config) {
    const { drmSystems: drmSystems, widevineLicenseUrl: widevineLicenseUrl } = config;
    const keySystemsToAttempt = drmSystems ? [
        $b941786f4eb9cb76$export$1c7b21e05766136c.FAIRPLAY,
        $b941786f4eb9cb76$export$1c7b21e05766136c.WIDEVINE,
        $b941786f4eb9cb76$export$1c7b21e05766136c.PLAYREADY,
        $b941786f4eb9cb76$export$1c7b21e05766136c.CLEARKEY
    ].filter((keySystem)=>!!drmSystems[keySystem]) : [];
    if (!keySystemsToAttempt[$b941786f4eb9cb76$export$1c7b21e05766136c.WIDEVINE] && widevineLicenseUrl) keySystemsToAttempt.push($b941786f4eb9cb76$export$1c7b21e05766136c.WIDEVINE);
    return keySystemsToAttempt;
}
const $b941786f4eb9cb76$export$fd6ce47fe824665a = function(_optionalSelf$navigat) {
    if ($b941786f4eb9cb76$var$optionalSelf != null && (_optionalSelf$navigat = $b941786f4eb9cb76$var$optionalSelf.navigator) != null && _optionalSelf$navigat.requestMediaKeySystemAccess) return self.navigator.requestMediaKeySystemAccess.bind(self.navigator);
    else return null;
}();
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/MediaKeySystemConfiguration
 */ function $b941786f4eb9cb76$var$getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, drmSystemOptions) {
    let initDataTypes;
    switch(keySystem){
        case $b941786f4eb9cb76$export$1c7b21e05766136c.FAIRPLAY:
            initDataTypes = [
                'cenc',
                'sinf'
            ];
            break;
        case $b941786f4eb9cb76$export$1c7b21e05766136c.WIDEVINE:
        case $b941786f4eb9cb76$export$1c7b21e05766136c.PLAYREADY:
            initDataTypes = [
                'cenc'
            ];
            break;
        case $b941786f4eb9cb76$export$1c7b21e05766136c.CLEARKEY:
            initDataTypes = [
                'cenc',
                'keyids'
            ];
            break;
        default:
            throw new Error(`Unknown key-system: ${keySystem}`);
    }
    return $b941786f4eb9cb76$var$createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions);
}
function $b941786f4eb9cb76$var$createMediaKeySystemConfigurations(initDataTypes, audioCodecs, videoCodecs, drmSystemOptions) {
    const baseConfig = {
        initDataTypes: initDataTypes,
        persistentState: drmSystemOptions.persistentState || 'optional',
        distinctiveIdentifier: drmSystemOptions.distinctiveIdentifier || 'optional',
        sessionTypes: drmSystemOptions.sessionTypes || [
            drmSystemOptions.sessionType || 'temporary'
        ],
        audioCapabilities: audioCodecs.map((codec)=>({
                contentType: `audio/mp4; codecs=${codec}`,
                robustness: drmSystemOptions.audioRobustness || '',
                encryptionScheme: drmSystemOptions.audioEncryptionScheme || null
            })),
        videoCapabilities: videoCodecs.map((codec)=>({
                contentType: `video/mp4; codecs=${codec}`,
                robustness: drmSystemOptions.videoRobustness || '',
                encryptionScheme: drmSystemOptions.videoEncryptionScheme || null
            }))
    };
    return [
        baseConfig
    ];
}
function $b941786f4eb9cb76$var$isPersistentSessionType(drmSystemOptions) {
    var _drmSystemOptions$ses;
    return !!drmSystemOptions && (drmSystemOptions.sessionType === 'persistent-license' || !!((_drmSystemOptions$ses = drmSystemOptions.sessionTypes) != null && _drmSystemOptions$ses.some((type)=>type === 'persistent-license')));
}
function $b941786f4eb9cb76$var$parsePlayReadyWRM(keyBytes) {
    const keyBytesUtf16 = new Uint16Array(keyBytes.buffer, keyBytes.byteOffset, keyBytes.byteLength / 2);
    const keyByteStr = String.fromCharCode.apply(null, Array.from(keyBytesUtf16));
    // Parse Playready WRMHeader XML
    const xmlKeyBytes = keyByteStr.substring(keyByteStr.indexOf('<'), keyByteStr.length);
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlKeyBytes, 'text/xml');
    const keyData = xmlDoc.getElementsByTagName('KID')[0];
    if (keyData) {
        const keyId = keyData.childNodes[0] ? keyData.childNodes[0].nodeValue : keyData.getAttribute('VALUE');
        if (keyId) {
            const keyIdArray = $b941786f4eb9cb76$var$base64Decode(keyId).subarray(0, 16);
            // KID value in PRO is a base64-encoded little endian GUID interpretation of UUID
            // KID value in ‘tenc’ is a big endian UUID GUID interpretation of UUID
            $b941786f4eb9cb76$var$changeEndianness(keyIdArray);
            return keyIdArray;
        }
    }
    return null;
}
let $b941786f4eb9cb76$var$keyUriToKeyIdMap = {};
class $b941786f4eb9cb76$export$ca24892a09b21f29 {
    static clearKeyUriToKeyIdMap() {
        $b941786f4eb9cb76$var$keyUriToKeyIdMap = {};
    }
    static setKeyIdForUri(uri, keyId) {
        $b941786f4eb9cb76$var$keyUriToKeyIdMap[uri] = keyId;
    }
    static addKeyIdForUri(uri) {
        const val = Object.keys($b941786f4eb9cb76$var$keyUriToKeyIdMap).length % Number.MAX_SAFE_INTEGER;
        const keyId = new Uint8Array(16);
        const dv = new DataView(keyId.buffer, 12, 4); // Just set the last 4 bytes
        dv.setUint32(0, val);
        $b941786f4eb9cb76$var$keyUriToKeyIdMap[uri] = keyId;
        return keyId;
    }
    constructor(method, uri, format, formatversions = [
        1
    ], iv = null, keyId){
        this.uri = void 0;
        this.method = void 0;
        this.keyFormat = void 0;
        this.keyFormatVersions = void 0;
        this.encrypted = void 0;
        this.isCommonEncryption = void 0;
        this.iv = null;
        this.key = null;
        this.keyId = null;
        this.pssh = null;
        this.method = method;
        this.uri = uri;
        this.keyFormat = format;
        this.keyFormatVersions = formatversions;
        this.iv = iv;
        this.encrypted = method ? method !== 'NONE' : false;
        this.isCommonEncryption = this.encrypted && !$b941786f4eb9cb76$var$isFullSegmentEncryption(method);
        if (keyId != null && keyId.startsWith('0x')) this.keyId = new Uint8Array($b941786f4eb9cb76$var$hexToArrayBuffer(keyId));
    }
    matches(key) {
        return key.uri === this.uri && key.method === this.method && key.encrypted === this.encrypted && key.keyFormat === this.keyFormat && $b941786f4eb9cb76$var$arrayValuesMatch(key.keyFormatVersions, this.keyFormatVersions) && $b941786f4eb9cb76$var$optionalArrayValuesMatch(key.iv, this.iv) && $b941786f4eb9cb76$var$optionalArrayValuesMatch(key.keyId, this.keyId);
    }
    isSupported() {
        // If it's Segment encryption or No encryption, just select that key system
        if (this.method) {
            if ($b941786f4eb9cb76$var$isFullSegmentEncryption(this.method) || this.method === 'NONE') return true;
            if (this.keyFormat === 'identity') // Maintain support for clear SAMPLE-AES with MPEG-3 TS
            return this.method === 'SAMPLE-AES';
            else switch(this.keyFormat){
                case $b941786f4eb9cb76$export$adbe91680a33e4e2.FAIRPLAY:
                case $b941786f4eb9cb76$export$adbe91680a33e4e2.WIDEVINE:
                case $b941786f4eb9cb76$export$adbe91680a33e4e2.PLAYREADY:
                case $b941786f4eb9cb76$export$adbe91680a33e4e2.CLEARKEY:
                    return [
                        'SAMPLE-AES',
                        'SAMPLE-AES-CENC',
                        'SAMPLE-AES-CTR'
                    ].indexOf(this.method) !== -1;
            }
        }
        return false;
    }
    getDecryptData(sn, levelKeys) {
        if (!this.encrypted || !this.uri) return null;
        if ($b941786f4eb9cb76$var$isFullSegmentEncryption(this.method)) {
            let iv = this.iv;
            if (!iv) {
                if (typeof sn !== 'number') {
                    // We are fetching decryption data for a initialization segment
                    // If the segment was encrypted with AES-128/256
                    // It must have an IV defined. We cannot substitute the Segment Number in.
                    $b941786f4eb9cb76$var$logger.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`);
                    // Explicitly set sn to resulting value from implicit conversions 'initSegment' values for IV generation.
                    sn = 0;
                }
                iv = $b941786f4eb9cb76$var$createInitializationVector(sn);
            }
            const decryptdata = new $b941786f4eb9cb76$export$ca24892a09b21f29(this.method, this.uri, 'identity', this.keyFormatVersions, iv);
            return decryptdata;
        }
        if (this.keyId) {
            // Handle case where key id is changed in KEY_LOADING event handler #7542#issuecomment-3305203929
            const assignedKeyId = $b941786f4eb9cb76$var$keyUriToKeyIdMap[this.uri];
            if (assignedKeyId && !$b941786f4eb9cb76$var$arrayValuesMatch(this.keyId, assignedKeyId)) $b941786f4eb9cb76$export$ca24892a09b21f29.setKeyIdForUri(this.uri, this.keyId);
            if (this.pssh) return this;
        }
        // Key bytes are signalled the KEYID attribute, typically only found on WideVine KEY tags
        // Initialize keyId if possible
        const keyBytes = $b941786f4eb9cb76$var$convertDataUriToArrayBytes(this.uri);
        if (keyBytes) switch(this.keyFormat){
            case $b941786f4eb9cb76$export$adbe91680a33e4e2.WIDEVINE:
                // Setting `pssh` on this LevelKey/DecryptData allows HLS.js to generate a session using
                // the playlist-key before the "encrypted" event. (Comment out to only use "encrypted" path.)
                this.pssh = keyBytes;
                // In case of Widevine, if KEYID is not in the playlist, assume only two fields in the pssh KEY tag URI.
                if (!this.keyId) {
                    const results = $b941786f4eb9cb76$var$parseMultiPssh(keyBytes.buffer);
                    if (results.length) {
                        var _psshData$kids;
                        const psshData = results[0];
                        this.keyId = (_psshData$kids = psshData.kids) != null && _psshData$kids.length ? psshData.kids[0] : null;
                    }
                }
                if (!this.keyId) this.keyId = $b941786f4eb9cb76$var$getKeyIdFromPlayReadyKey(levelKeys);
                break;
            case $b941786f4eb9cb76$export$adbe91680a33e4e2.PLAYREADY:
                {
                    const PlayReadyKeySystemUUID = new Uint8Array([
                        0x9a,
                        0x04,
                        0xf0,
                        0x79,
                        0x98,
                        0x40,
                        0x42,
                        0x86,
                        0xab,
                        0x92,
                        0xe6,
                        0x5b,
                        0xe0,
                        0x88,
                        0x5f,
                        0x95
                    ]);
                    // Setting `pssh` on this LevelKey/DecryptData allows HLS.js to generate a session using
                    // the playlist-key before the "encrypted" event. (Comment out to only use "encrypted" path.)
                    this.pssh = $b941786f4eb9cb76$var$mp4pssh(PlayReadyKeySystemUUID, null, keyBytes);
                    this.keyId = $b941786f4eb9cb76$var$parsePlayReadyWRM(keyBytes);
                    break;
                }
            default:
                {
                    let keydata = keyBytes.subarray(0, 16);
                    if (keydata.length !== 16) {
                        const padded = new Uint8Array(16);
                        padded.set(keydata, 16 - keydata.length);
                        keydata = padded;
                    }
                    this.keyId = keydata;
                    break;
                }
        }
        // Default behavior: get keyId from other KEY tag or URI lookup
        if (!this.keyId || this.keyId.byteLength !== 16) {
            let keyId;
            keyId = $b941786f4eb9cb76$var$getKeyIdFromWidevineKey(levelKeys);
            if (!keyId) {
                keyId = $b941786f4eb9cb76$var$getKeyIdFromPlayReadyKey(levelKeys);
                if (!keyId) keyId = $b941786f4eb9cb76$var$keyUriToKeyIdMap[this.uri];
            }
            if (keyId) {
                this.keyId = keyId;
                $b941786f4eb9cb76$export$ca24892a09b21f29.setKeyIdForUri(this.uri, keyId);
            }
        }
        return this;
    }
}
function $b941786f4eb9cb76$var$getKeyIdFromWidevineKey(levelKeys) {
    const widevineKey = levelKeys == null ? void 0 : levelKeys[$b941786f4eb9cb76$export$adbe91680a33e4e2.WIDEVINE];
    if (widevineKey) return widevineKey.keyId;
    return null;
}
function $b941786f4eb9cb76$var$getKeyIdFromPlayReadyKey(levelKeys) {
    const playReadyKey = levelKeys == null ? void 0 : levelKeys[$b941786f4eb9cb76$export$adbe91680a33e4e2.PLAYREADY];
    if (playReadyKey) {
        const playReadyKeyBytes = $b941786f4eb9cb76$var$convertDataUriToArrayBytes(playReadyKey.uri);
        if (playReadyKeyBytes) return $b941786f4eb9cb76$var$parsePlayReadyWRM(playReadyKeyBytes);
    }
    return null;
}
function $b941786f4eb9cb76$var$createInitializationVector(segmentNumber) {
    const uint8View = new Uint8Array(16);
    for(let i = 12; i < 16; i++)uint8View[i] = segmentNumber >> 8 * (15 - i) & 0xff;
    return uint8View;
}
const $b941786f4eb9cb76$var$MASTER_PLAYLIST_REGEX = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g;
const $b941786f4eb9cb76$var$MASTER_PLAYLIST_MEDIA_REGEX = /#EXT-X-MEDIA:(.*)/g;
const $b941786f4eb9cb76$var$IS_MEDIA_PLAYLIST = /^#EXT(?:INF|-X-TARGETDURATION):/m; // Handle empty Media Playlist (first EXTINF not signaled, but TARGETDURATION present)
const $b941786f4eb9cb76$var$LEVEL_PLAYLIST_REGEX_FAST = new RegExp([
    /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
    // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
    /(?!#) *(\S[^\r\n]*)/.source,
    // segment URI, group 3 => the URI (note newline is not eaten)
    /#.*/.source // All other non-segment oriented tags will match with all groups empty
].join('|'), 'g');
const $b941786f4eb9cb76$var$LEVEL_PLAYLIST_REGEX_SLOW = new RegExp([
    /#EXT-X-(PROGRAM-DATE-TIME|BYTERANGE|DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source,
    /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source,
    /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source,
    /(#)([^:]*):(.*)/.source,
    /(#)(.*)(?:.*)\r?\n?/.source
].join('|'));
class $b941786f4eb9cb76$export$c1bd440a1b47590d {
    static findGroup(groups, mediaGroupId) {
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            if (group.id === mediaGroupId) return group;
        }
    }
    static resolve(url, baseUrl) {
        return $b941786f4eb9cb76$var$urlToolkitExports.buildAbsoluteURL(baseUrl, url, {
            alwaysNormalize: true
        });
    }
    static isMediaPlaylist(str) {
        return $b941786f4eb9cb76$var$IS_MEDIA_PLAYLIST.test(str);
    }
    static parseMasterPlaylist(string, baseurl) {
        const hasVariableRefs = $b941786f4eb9cb76$var$hasVariableReferences(string);
        const parsed = {
            contentSteering: null,
            levels: [],
            playlistParsingError: null,
            sessionData: null,
            sessionKeys: null,
            startTimeOffset: null,
            variableList: null,
            hasVariableRefs: hasVariableRefs
        };
        const levelsWithKnownCodecs = [];
        $b941786f4eb9cb76$var$MASTER_PLAYLIST_REGEX.lastIndex = 0;
        if (!string.startsWith('#EXTM3U')) {
            parsed.playlistParsingError = new Error('no EXTM3U delimiter');
            return parsed;
        }
        let result;
        while((result = $b941786f4eb9cb76$var$MASTER_PLAYLIST_REGEX.exec(string)) != null){
            if (result[1]) {
                var _level$unknownCodecs;
                // '#EXT-X-STREAM-INF' is found, parse level tag  in group 1
                const attrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(result[1], parsed);
                const uri = $b941786f4eb9cb76$var$substituteVariables(parsed, result[2]);
                const level = {
                    attrs: attrs,
                    bitrate: attrs.decimalInteger('BANDWIDTH') || attrs.decimalInteger('AVERAGE-BANDWIDTH'),
                    name: attrs.NAME,
                    url: $b941786f4eb9cb76$export$c1bd440a1b47590d.resolve(uri, baseurl)
                };
                const resolution = attrs.decimalResolution('RESOLUTION');
                if (resolution) {
                    level.width = resolution.width;
                    level.height = resolution.height;
                }
                $b941786f4eb9cb76$var$setCodecs(attrs.CODECS, level);
                const supplementalCodecs = attrs['SUPPLEMENTAL-CODECS'];
                if (supplementalCodecs) {
                    level.supplemental = {};
                    $b941786f4eb9cb76$var$setCodecs(supplementalCodecs, level.supplemental);
                }
                if (!((_level$unknownCodecs = level.unknownCodecs) != null && _level$unknownCodecs.length)) levelsWithKnownCodecs.push(level);
                parsed.levels.push(level);
            } else if (result[3]) {
                const tag = result[3];
                const attributes = result[4];
                switch(tag){
                    case 'SESSION-DATA':
                        {
                            // #EXT-X-SESSION-DATA
                            const sessionAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(attributes, parsed);
                            const dataId = sessionAttrs['DATA-ID'];
                            if (dataId) {
                                if (parsed.sessionData === null) parsed.sessionData = {};
                                parsed.sessionData[dataId] = sessionAttrs;
                            }
                            break;
                        }
                    case 'SESSION-KEY':
                        {
                            // #EXT-X-SESSION-KEY
                            const sessionKey = $b941786f4eb9cb76$var$parseKey(attributes, baseurl, parsed);
                            if (sessionKey.encrypted && sessionKey.isSupported()) {
                                if (parsed.sessionKeys === null) parsed.sessionKeys = [];
                                parsed.sessionKeys.push(sessionKey);
                            } else $b941786f4eb9cb76$var$logger.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${attributes}"`);
                            break;
                        }
                    case 'DEFINE':
                        // #EXT-X-DEFINE
                        {
                            const variableAttributes = new $b941786f4eb9cb76$export$3b2a5864ee72b619(attributes, parsed);
                            $b941786f4eb9cb76$var$addVariableDefinition(parsed, variableAttributes, baseurl);
                        }
                        break;
                    case 'CONTENT-STEERING':
                        {
                            // #EXT-X-CONTENT-STEERING
                            const contentSteeringAttributes = new $b941786f4eb9cb76$export$3b2a5864ee72b619(attributes, parsed);
                            parsed.contentSteering = {
                                uri: $b941786f4eb9cb76$export$c1bd440a1b47590d.resolve(contentSteeringAttributes['SERVER-URI'], baseurl),
                                pathwayId: contentSteeringAttributes['PATHWAY-ID'] || '.'
                            };
                            break;
                        }
                    case 'START':
                        // #EXT-X-START
                        parsed.startTimeOffset = $b941786f4eb9cb76$var$parseStartTimeOffset(attributes);
                        break;
                }
            }
        }
        // Filter out levels with unknown codecs if it does not remove all levels
        const stripUnknownCodecLevels = levelsWithKnownCodecs.length > 0 && levelsWithKnownCodecs.length < parsed.levels.length;
        parsed.levels = stripUnknownCodecLevels ? levelsWithKnownCodecs : parsed.levels;
        if (parsed.levels.length === 0) parsed.playlistParsingError = new Error('no levels found in manifest');
        return parsed;
    }
    static parseMasterPlaylistMedia(string, baseurl, parsed) {
        let result;
        const results = {};
        const levels = parsed.levels;
        const groupsByType = {
            AUDIO: levels.map((level)=>({
                    id: level.attrs.AUDIO,
                    audioCodec: level.audioCodec
                })),
            SUBTITLES: levels.map((level)=>({
                    id: level.attrs.SUBTITLES,
                    textCodec: level.textCodec
                })),
            'CLOSED-CAPTIONS': []
        };
        let id = 0;
        $b941786f4eb9cb76$var$MASTER_PLAYLIST_MEDIA_REGEX.lastIndex = 0;
        while((result = $b941786f4eb9cb76$var$MASTER_PLAYLIST_MEDIA_REGEX.exec(string)) !== null){
            const attrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(result[1], parsed);
            const type = attrs.TYPE;
            if (type) {
                const groups = groupsByType[type];
                const medias = results[type] || [];
                results[type] = medias;
                const lang = attrs.LANGUAGE;
                const assocLang = attrs['ASSOC-LANGUAGE'];
                const channels = attrs.CHANNELS;
                const characteristics = attrs.CHARACTERISTICS;
                const instreamId = attrs['INSTREAM-ID'];
                const media = {
                    attrs: attrs,
                    bitrate: 0,
                    id: id++,
                    groupId: attrs['GROUP-ID'] || '',
                    name: attrs.NAME || lang || '',
                    type: type,
                    default: attrs.bool('DEFAULT'),
                    autoselect: attrs.bool('AUTOSELECT'),
                    forced: attrs.bool('FORCED'),
                    lang: lang,
                    url: attrs.URI ? $b941786f4eb9cb76$export$c1bd440a1b47590d.resolve(attrs.URI, baseurl) : ''
                };
                if (assocLang) media.assocLang = assocLang;
                if (channels) media.channels = channels;
                if (characteristics) media.characteristics = characteristics;
                if (instreamId) media.instreamId = instreamId;
                if (groups != null && groups.length) {
                    // If there are audio or text groups signalled in the manifest, let's look for a matching codec string for this track
                    // If we don't find the track signalled, lets use the first audio groups codec we have
                    // Acting as a best guess
                    const groupCodec = $b941786f4eb9cb76$export$c1bd440a1b47590d.findGroup(groups, media.groupId) || groups[0];
                    $b941786f4eb9cb76$var$assignCodec(media, groupCodec, 'audioCodec');
                    $b941786f4eb9cb76$var$assignCodec(media, groupCodec, 'textCodec');
                }
                medias.push(media);
            }
        }
        return results;
    }
    static parseLevelPlaylist(string, baseurl, id, type, levelUrlId, multivariantVariableList) {
        var _LEVEL_PLAYLIST_REGEX;
        const base = {
            url: baseurl
        };
        const level = new $b941786f4eb9cb76$export$9eda1d8aef4189e9(baseurl);
        const fragments = level.fragments;
        const programDateTimes = [];
        // The most recent init segment seen (applies to all subsequent segments)
        let currentInitSegment = null;
        let currentSN = 0;
        let currentPart = 0;
        let totalduration = 0;
        let discontinuityCounter = 0;
        let currentBitrate = 0;
        let prevFrag = null;
        let frag = new $b941786f4eb9cb76$export$ffb0004e005737fa(type, base);
        let result;
        let i;
        let levelkeys;
        let firstPdtIndex = -1;
        let createNextFrag = false;
        let nextByteRange = null;
        let serverControlAttrs;
        $b941786f4eb9cb76$var$LEVEL_PLAYLIST_REGEX_FAST.lastIndex = 0;
        level.m3u8 = string;
        level.hasVariableRefs = $b941786f4eb9cb76$var$hasVariableReferences(string);
        if (((_LEVEL_PLAYLIST_REGEX = $b941786f4eb9cb76$var$LEVEL_PLAYLIST_REGEX_FAST.exec(string)) == null ? void 0 : _LEVEL_PLAYLIST_REGEX[0]) !== '#EXTM3U') {
            level.playlistParsingError = new Error('Missing format identifier #EXTM3U');
            return level;
        }
        while((result = $b941786f4eb9cb76$var$LEVEL_PLAYLIST_REGEX_FAST.exec(string)) !== null){
            if (createNextFrag) {
                createNextFrag = false;
                frag = new $b941786f4eb9cb76$export$ffb0004e005737fa(type, base);
                // setup the next fragment for part loading
                frag.playlistOffset = totalduration;
                frag.setStart(totalduration);
                frag.sn = currentSN;
                frag.cc = discontinuityCounter;
                if (currentBitrate) frag.bitrate = currentBitrate;
                frag.level = id;
                if (currentInitSegment) {
                    frag.initSegment = currentInitSegment;
                    if (currentInitSegment.rawProgramDateTime) {
                        frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                        currentInitSegment.rawProgramDateTime = null;
                    }
                    if (nextByteRange) {
                        frag.setByteRange(nextByteRange);
                        nextByteRange = null;
                    }
                }
            }
            const duration = result[1];
            if (duration) {
                // INF
                frag.duration = parseFloat(duration);
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const title = (' ' + result[2]).slice(1);
                frag.title = title || null;
                frag.tagList.push(title ? [
                    'INF',
                    duration,
                    title
                ] : [
                    'INF',
                    duration
                ]);
            } else if (result[3]) // url
            {
                if ($b941786f4eb9cb76$var$isFiniteNumber(frag.duration)) {
                    frag.playlistOffset = totalduration;
                    frag.setStart(totalduration);
                    if (levelkeys) $b941786f4eb9cb76$var$setFragLevelKeys(frag, levelkeys, level);
                    frag.sn = currentSN;
                    frag.level = id;
                    frag.cc = discontinuityCounter;
                    fragments.push(frag);
                    // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                    const uri = (' ' + result[3]).slice(1);
                    frag.relurl = $b941786f4eb9cb76$var$substituteVariables(level, uri);
                    $b941786f4eb9cb76$var$assignProgramDateTime(frag, prevFrag, programDateTimes);
                    prevFrag = frag;
                    totalduration += frag.duration;
                    currentSN++;
                    currentPart = 0;
                    createNextFrag = true;
                }
            } else {
                result = result[0].match($b941786f4eb9cb76$var$LEVEL_PLAYLIST_REGEX_SLOW);
                if (!result) {
                    $b941786f4eb9cb76$var$logger.warn('No matches on slow regex match for level playlist!');
                    continue;
                }
                for(i = 1; i < result.length; i++){
                    if (result[i] !== undefined) break;
                }
                // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                const tag = (' ' + result[i]).slice(1);
                const value1 = (' ' + result[i + 1]).slice(1);
                const value2 = result[i + 2] ? (' ' + result[i + 2]).slice(1) : null;
                switch(tag){
                    case 'BYTERANGE':
                        if (prevFrag) frag.setByteRange(value1, prevFrag);
                        else frag.setByteRange(value1);
                        break;
                    case 'PROGRAM-DATE-TIME':
                        // avoid sliced strings    https://github.com/video-dev/hls.js/issues/939
                        frag.rawProgramDateTime = value1;
                        frag.tagList.push([
                            'PROGRAM-DATE-TIME',
                            value1
                        ]);
                        if (firstPdtIndex === -1) firstPdtIndex = fragments.length;
                        break;
                    case 'PLAYLIST-TYPE':
                        if (level.type) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.type = value1.toUpperCase();
                        break;
                    case 'MEDIA-SEQUENCE':
                        if (level.startSN !== 0) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        else if (fragments.length > 0) $b941786f4eb9cb76$var$assignMustAppearBeforeSegmentsError(level, tag, result);
                        currentSN = level.startSN = parseInt(value1);
                        break;
                    case 'SKIP':
                        {
                            if (level.skippedSegments) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                            const skipAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1, level);
                            const skippedSegments = skipAttrs.decimalInteger('SKIPPED-SEGMENTS');
                            if ($b941786f4eb9cb76$var$isFiniteNumber(skippedSegments)) {
                                level.skippedSegments += skippedSegments;
                                // This will result in fragments[] containing undefined values, which we will fill in with `mergeDetails`
                                for(let _i = skippedSegments; _i--;)fragments.push(null);
                                currentSN += skippedSegments;
                            }
                            const recentlyRemovedDateranges = skipAttrs.enumeratedString('RECENTLY-REMOVED-DATERANGES');
                            if (recentlyRemovedDateranges) level.recentlyRemovedDateranges = (level.recentlyRemovedDateranges || []).concat(recentlyRemovedDateranges.split('\t'));
                            break;
                        }
                    case 'TARGETDURATION':
                        if (level.targetduration !== 0) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.targetduration = Math.max(parseInt(value1), 1);
                        break;
                    case 'VERSION':
                        if (level.version !== null) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.version = parseInt(value1);
                        break;
                    case 'INDEPENDENT-SEGMENTS':
                        break;
                    case 'ENDLIST':
                        if (!level.live) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        level.live = false;
                        break;
                    case '#':
                        if (value1 || value2) frag.tagList.push(value2 ? [
                            value1,
                            value2
                        ] : [
                            value1
                        ]);
                        break;
                    case 'DISCONTINUITY':
                        discontinuityCounter++;
                        frag.tagList.push([
                            'DIS'
                        ]);
                        break;
                    case 'GAP':
                        frag.gap = true;
                        frag.tagList.push([
                            tag
                        ]);
                        break;
                    case 'BITRATE':
                        frag.tagList.push([
                            tag,
                            value1
                        ]);
                        currentBitrate = parseInt(value1) * 1000;
                        if ($b941786f4eb9cb76$var$isFiniteNumber(currentBitrate)) frag.bitrate = currentBitrate;
                        else currentBitrate = 0;
                        break;
                    case 'DATERANGE':
                        {
                            const dateRangeAttr = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1, level);
                            const dateRange = new $b941786f4eb9cb76$export$829bd850c745b6e(dateRangeAttr, level.dateRanges[dateRangeAttr.ID], level.dateRangeTagCount);
                            level.dateRangeTagCount++;
                            if (dateRange.isValid || level.skippedSegments) level.dateRanges[dateRange.id] = dateRange;
                            else $b941786f4eb9cb76$var$logger.warn(`Ignoring invalid DATERANGE tag: "${value1}"`);
                            // Add to fragment tag list for backwards compatibility (< v1.2.0)
                            frag.tagList.push([
                                'EXT-X-DATERANGE',
                                value1
                            ]);
                            break;
                        }
                    case 'DEFINE':
                        {
                            const variableAttributes = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1, level);
                            if ('IMPORT' in variableAttributes) $b941786f4eb9cb76$var$importVariableDefinition(level, variableAttributes, multivariantVariableList);
                            else $b941786f4eb9cb76$var$addVariableDefinition(level, variableAttributes, baseurl);
                        }
                        break;
                    case 'DISCONTINUITY-SEQUENCE':
                        if (level.startCC !== 0) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        else if (fragments.length > 0) $b941786f4eb9cb76$var$assignMustAppearBeforeSegmentsError(level, tag, result);
                        level.startCC = discontinuityCounter = parseInt(value1);
                        break;
                    case 'KEY':
                        {
                            const levelKey = $b941786f4eb9cb76$var$parseKey(value1, baseurl, level);
                            if (levelKey.isSupported()) {
                                if (levelKey.method === 'NONE') {
                                    levelkeys = undefined;
                                    break;
                                }
                                if (!levelkeys) levelkeys = {};
                                const currentKey = levelkeys[levelKey.keyFormat];
                                // Ignore duplicate playlist KEY tags
                                if (!(currentKey != null && currentKey.matches(levelKey))) {
                                    if (currentKey) levelkeys = $b941786f4eb9cb76$var$_extends({}, levelkeys);
                                    levelkeys[levelKey.keyFormat] = levelKey;
                                }
                            } else $b941786f4eb9cb76$var$logger.warn(`[Keys] Ignoring unsupported EXT-X-KEY tag: "${value1}"${''}`);
                            break;
                        }
                    case 'START':
                        level.startTimeOffset = $b941786f4eb9cb76$var$parseStartTimeOffset(value1);
                        break;
                    case 'MAP':
                        {
                            const mapAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1, level);
                            if (frag.duration) {
                                // Initial segment tag is after segment duration tag.
                                //   #EXTINF: 6.0
                                //   #EXT-X-MAP:URI="init.mp4
                                const init = new $b941786f4eb9cb76$export$ffb0004e005737fa(type, base);
                                $b941786f4eb9cb76$var$setInitSegment(init, mapAttrs, id, levelkeys);
                                currentInitSegment = init;
                                frag.initSegment = currentInitSegment;
                                if (currentInitSegment.rawProgramDateTime && !frag.rawProgramDateTime) frag.rawProgramDateTime = currentInitSegment.rawProgramDateTime;
                            } else {
                                // Initial segment tag is before segment duration tag
                                // Handle case where EXT-X-MAP is declared after EXT-X-BYTERANGE
                                const end = frag.byteRangeEndOffset;
                                if (end) {
                                    const start = frag.byteRangeStartOffset;
                                    nextByteRange = `${end - start}@${start}`;
                                } else nextByteRange = null;
                                $b941786f4eb9cb76$var$setInitSegment(frag, mapAttrs, id, levelkeys);
                                currentInitSegment = frag;
                                createNextFrag = true;
                            }
                            currentInitSegment.cc = discontinuityCounter;
                            break;
                        }
                    case 'SERVER-CONTROL':
                        if (serverControlAttrs) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                        serverControlAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1);
                        level.canBlockReload = serverControlAttrs.bool('CAN-BLOCK-RELOAD');
                        level.canSkipUntil = serverControlAttrs.optionalFloat('CAN-SKIP-UNTIL', 0);
                        level.canSkipDateRanges = level.canSkipUntil > 0 && serverControlAttrs.bool('CAN-SKIP-DATERANGES');
                        level.partHoldBack = serverControlAttrs.optionalFloat('PART-HOLD-BACK', 0);
                        level.holdBack = serverControlAttrs.optionalFloat('HOLD-BACK', 0);
                        break;
                    case 'PART-INF':
                        {
                            if (level.partTarget) $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result);
                            const partInfAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1);
                            level.partTarget = partInfAttrs.decimalFloatingPoint('PART-TARGET');
                            break;
                        }
                    case 'PART':
                        {
                            let partList = level.partList;
                            if (!partList) partList = level.partList = [];
                            const previousFragmentPart = currentPart > 0 ? partList[partList.length - 1] : undefined;
                            const index = currentPart++;
                            const partAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1, level);
                            const part = new $b941786f4eb9cb76$export$7b5bf7981d51054e(partAttrs, frag, base, index, previousFragmentPart);
                            partList.push(part);
                            frag.duration += part.duration;
                            break;
                        }
                    case 'PRELOAD-HINT':
                        {
                            const preloadHintAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1, level);
                            level.preloadHint = preloadHintAttrs;
                            break;
                        }
                    case 'RENDITION-REPORT':
                        {
                            const renditionReportAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(value1, level);
                            level.renditionReports = level.renditionReports || [];
                            level.renditionReports.push(renditionReportAttrs);
                            break;
                        }
                    default:
                        $b941786f4eb9cb76$var$logger.warn(`line parsed but not handled: ${result}`);
                        break;
                }
            }
        }
        if (prevFrag && !prevFrag.relurl) {
            fragments.pop();
            totalduration -= prevFrag.duration;
            if (level.partList) level.fragmentHint = prevFrag;
        } else if (level.partList) {
            $b941786f4eb9cb76$var$assignProgramDateTime(frag, prevFrag, programDateTimes);
            frag.cc = discontinuityCounter;
            level.fragmentHint = frag;
            if (levelkeys) $b941786f4eb9cb76$var$setFragLevelKeys(frag, levelkeys, level);
        }
        if (!level.targetduration) level.playlistParsingError = new Error(`Missing Target Duration`);
        const fragmentLength = fragments.length;
        const firstFragment = fragments[0];
        const lastFragment = fragments[fragmentLength - 1];
        totalduration += level.skippedSegments * level.targetduration;
        if (totalduration > 0 && fragmentLength && lastFragment) {
            level.averagetargetduration = totalduration / fragmentLength;
            const lastSn = lastFragment.sn;
            level.endSN = lastSn !== 'initSegment' ? lastSn : 0;
            if (!level.live) lastFragment.endList = true;
            /**
       * Backfill any missing PDT values
       * "If the first EXT-X-PROGRAM-DATE-TIME tag in a Playlist appears after
       * one or more Media Segment URIs, the client SHOULD extrapolate
       * backward from that tag (using EXTINF durations and/or media
       * timestamps) to associate dates with those segments."
       * We have already extrapolated forward, but all fragments up to the first instance of PDT do not have their PDTs
       * computed.
       */ if (firstPdtIndex > 0) {
                $b941786f4eb9cb76$var$backfillProgramDateTimes(fragments, firstPdtIndex);
                if (firstFragment) programDateTimes.unshift(firstFragment);
            }
        }
        if (level.fragmentHint) totalduration += level.fragmentHint.duration;
        level.totalduration = totalduration;
        if (programDateTimes.length && level.dateRangeTagCount && firstFragment) $b941786f4eb9cb76$var$mapDateRanges(programDateTimes, level);
        level.endCC = discontinuityCounter;
        return level;
    }
}
function $b941786f4eb9cb76$var$mapDateRanges(programDateTimes, details) {
    // Make sure DateRanges are mapped to a ProgramDateTime tag that applies a date to a segment that overlaps with its start date
    let programDateTimeCount = programDateTimes.length;
    if (!programDateTimeCount) {
        if (details.hasProgramDateTime) {
            const lastFragment = details.fragments[details.fragments.length - 1];
            programDateTimes.push(lastFragment);
            programDateTimeCount++;
        } else // no segments with EXT-X-PROGRAM-DATE-TIME references in playlist history
        return;
    }
    const lastProgramDateTime = programDateTimes[programDateTimeCount - 1];
    const playlistEnd = details.live ? Infinity : details.totalduration;
    const dateRangeIds = Object.keys(details.dateRanges);
    for(let i = dateRangeIds.length; i--;){
        const dateRange = details.dateRanges[dateRangeIds[i]];
        const startDateTime = dateRange.startDate.getTime();
        dateRange.tagAnchor = lastProgramDateTime.ref;
        for(let j = programDateTimeCount; j--;){
            var _programDateTimes$j;
            if (((_programDateTimes$j = programDateTimes[j]) == null ? void 0 : _programDateTimes$j.sn) < details.startSN) break;
            const fragIndex = $b941786f4eb9cb76$var$findFragmentWithStartDate(details, startDateTime, programDateTimes, j, playlistEnd);
            if (fragIndex !== -1) {
                dateRange.tagAnchor = details.fragments[fragIndex].ref;
                break;
            }
        }
    }
}
function $b941786f4eb9cb76$var$findFragmentWithStartDate(details, startDateTime, programDateTimes, index, endTime) {
    const pdtFragment = programDateTimes[index];
    if (pdtFragment) {
        // find matching range between PDT tags
        const pdtStart = pdtFragment.programDateTime;
        if (startDateTime >= pdtStart || index === 0) {
            var _programDateTimes;
            const durationBetweenPdt = (((_programDateTimes = programDateTimes[index + 1]) == null ? void 0 : _programDateTimes.start) || endTime) - pdtFragment.start;
            if (startDateTime <= pdtStart + durationBetweenPdt * 1000) {
                // map to fragment with date-time range
                const startIndex = programDateTimes[index].sn - details.startSN;
                if (startIndex < 0) return -1;
                const fragments = details.fragments;
                if (fragments.length > programDateTimes.length) {
                    const endSegment = programDateTimes[index + 1] || fragments[fragments.length - 1];
                    const endIndex = endSegment.sn - details.startSN;
                    for(let i = endIndex; i > startIndex; i--){
                        const fragStartDateTime = fragments[i].programDateTime;
                        if (startDateTime >= fragStartDateTime && startDateTime < fragStartDateTime + fragments[i].duration * 1000) return i;
                    }
                }
                return startIndex;
            }
        }
    }
    return -1;
}
function $b941786f4eb9cb76$var$parseKey(keyTagAttributes, baseurl, parsed) {
    var _keyAttrs$METHOD, _keyAttrs$KEYFORMAT;
    // https://tools.ietf.org/html/rfc8216#section-4.3.2.4
    const keyAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(keyTagAttributes, parsed);
    const decryptmethod = (_keyAttrs$METHOD = keyAttrs.METHOD) != null ? _keyAttrs$METHOD : '';
    const decrypturi = keyAttrs.URI;
    const decryptiv = keyAttrs.hexadecimalInteger('IV');
    const decryptkeyformatversions = keyAttrs.KEYFORMATVERSIONS;
    // From RFC: This attribute is OPTIONAL; its absence indicates an implicit value of "identity".
    const decryptkeyformat = (_keyAttrs$KEYFORMAT = keyAttrs.KEYFORMAT) != null ? _keyAttrs$KEYFORMAT : 'identity';
    if (decrypturi && keyAttrs.IV && !decryptiv) $b941786f4eb9cb76$var$logger.error(`Invalid IV: ${keyAttrs.IV}`);
    // If decrypturi is a URI with a scheme, then baseurl will be ignored
    // No uri is allowed when METHOD is NONE
    const resolvedUri = decrypturi ? $b941786f4eb9cb76$export$c1bd440a1b47590d.resolve(decrypturi, baseurl) : '';
    const keyFormatVersions = (decryptkeyformatversions ? decryptkeyformatversions : '1').split('/').map(Number).filter(Number.isFinite);
    return new $b941786f4eb9cb76$export$ca24892a09b21f29(decryptmethod, resolvedUri, decryptkeyformat, keyFormatVersions, decryptiv, keyAttrs.KEYID);
}
function $b941786f4eb9cb76$var$parseStartTimeOffset(startAttributes) {
    const startAttrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(startAttributes);
    const startTimeOffset = startAttrs.decimalFloatingPoint('TIME-OFFSET');
    if ($b941786f4eb9cb76$var$isFiniteNumber(startTimeOffset)) return startTimeOffset;
    return null;
}
function $b941786f4eb9cb76$var$setCodecs(codecsAttributeValue, level) {
    let codecs = (codecsAttributeValue || '').split(/[ ,]+/).filter((c)=>c);
    [
        'video',
        'audio',
        'text'
    ].forEach((type)=>{
        const filtered = codecs.filter((codec)=>$b941786f4eb9cb76$var$isCodecType(codec, type));
        if (filtered.length) {
            // Comma separated list of all codecs for type
            level[`${type}Codec`] = filtered.map((c)=>c.split('/')[0]).join(',');
            // Remove known codecs so that only unknownCodecs are left after iterating through each type
            codecs = codecs.filter((codec)=>filtered.indexOf(codec) === -1);
        }
    });
    level.unknownCodecs = codecs;
}
function $b941786f4eb9cb76$var$assignCodec(media, groupItem, codecProperty) {
    const codecValue = groupItem[codecProperty];
    if (codecValue) media[codecProperty] = codecValue;
}
function $b941786f4eb9cb76$var$backfillProgramDateTimes(fragments, firstPdtIndex) {
    let fragPrev = fragments[firstPdtIndex];
    for(let i = firstPdtIndex; i--;){
        const frag = fragments[i];
        // Exit on delta-playlist skipped segments
        if (!frag) return;
        frag.programDateTime = fragPrev.programDateTime - frag.duration * 1000;
        fragPrev = frag;
    }
}
function $b941786f4eb9cb76$var$assignProgramDateTime(frag, prevFrag, programDateTimes) {
    if (frag.rawProgramDateTime) programDateTimes.push(frag);
    else if (prevFrag != null && prevFrag.programDateTime) frag.programDateTime = prevFrag.endProgramDateTime;
}
function $b941786f4eb9cb76$var$setInitSegment(frag, mapAttrs, id, levelkeys) {
    frag.relurl = mapAttrs.URI;
    if (mapAttrs.BYTERANGE) frag.setByteRange(mapAttrs.BYTERANGE);
    frag.level = id;
    frag.sn = 'initSegment';
    if (levelkeys) frag.levelkeys = levelkeys;
    frag.initSegment = null;
}
function $b941786f4eb9cb76$var$setFragLevelKeys(frag, levelkeys, level) {
    frag.levelkeys = levelkeys;
    const { encryptedFragments: encryptedFragments } = level;
    if ((!encryptedFragments.length || encryptedFragments[encryptedFragments.length - 1].levelkeys !== levelkeys) && Object.keys(levelkeys).some((format)=>levelkeys[format].isCommonEncryption)) encryptedFragments.push(frag);
}
function $b941786f4eb9cb76$var$assignMultipleMediaPlaylistTagOccuranceError(level, tag, result) {
    level.playlistParsingError = new Error(`#EXT-X-${tag} must not appear more than once (${result[0]})`);
}
function $b941786f4eb9cb76$var$assignMustAppearBeforeSegmentsError(level, tag, result) {
    level.playlistParsingError = new Error(`#EXT-X-${tag} must appear before the first Media Segment (${result[0]})`);
}
function $b941786f4eb9cb76$var$updateFromToPTS(fragFrom, fragTo) {
    const fragToPTS = fragTo.startPTS;
    // if we know startPTS[toIdx]
    if ($b941786f4eb9cb76$var$isFiniteNumber(fragToPTS)) {
        // update fragment duration.
        // it helps to fix drifts between playlist reported duration and fragment real duration
        let duration = 0;
        let frag;
        if (fragTo.sn > fragFrom.sn) {
            duration = fragToPTS - fragFrom.start;
            frag = fragFrom;
        } else {
            duration = fragFrom.start - fragToPTS;
            frag = fragTo;
        }
        if (frag.duration !== duration) frag.setDuration(duration);
    // we dont know startPTS[toIdx]
    } else if (fragTo.sn > fragFrom.sn) {
        const contiguous = fragFrom.cc === fragTo.cc;
        // TODO: With part-loading end/durations we need to confirm the whole fragment is loaded before using (or setting) minEndPTS
        if (contiguous && fragFrom.minEndPTS) fragTo.setStart(fragFrom.start + (fragFrom.minEndPTS - fragFrom.start));
        else fragTo.setStart(fragFrom.start + fragFrom.duration);
    } else fragTo.setStart(Math.max(fragFrom.start - fragTo.duration, 0));
}
function $b941786f4eb9cb76$var$updateFragPTSDTS(details, frag, startPTS, endPTS, startDTS, endDTS, logger) {
    const parsedMediaDuration = endPTS - startPTS;
    if (parsedMediaDuration <= 0) {
        logger.warn('Fragment should have a positive duration', frag);
        endPTS = startPTS + frag.duration;
        endDTS = startDTS + frag.duration;
    }
    let maxStartPTS = startPTS;
    let minEndPTS = endPTS;
    const fragStartPts = frag.startPTS;
    const fragEndPts = frag.endPTS;
    if ($b941786f4eb9cb76$var$isFiniteNumber(fragStartPts)) {
        // delta PTS between audio and video
        const deltaPTS = Math.abs(fragStartPts - startPTS);
        if (details && deltaPTS > details.totalduration) logger.warn(`media timestamps and playlist times differ by ${deltaPTS}s for level ${frag.level} ${details.url}`);
        else if (!$b941786f4eb9cb76$var$isFiniteNumber(frag.deltaPTS)) frag.deltaPTS = deltaPTS;
        else frag.deltaPTS = Math.max(deltaPTS, frag.deltaPTS);
        maxStartPTS = Math.max(startPTS, fragStartPts);
        startPTS = Math.min(startPTS, fragStartPts);
        startDTS = frag.startDTS !== undefined ? Math.min(startDTS, frag.startDTS) : startDTS;
        minEndPTS = Math.min(endPTS, fragEndPts);
        endPTS = Math.max(endPTS, fragEndPts);
        endDTS = frag.endDTS !== undefined ? Math.max(endDTS, frag.endDTS) : endDTS;
    }
    const drift = startPTS - frag.start;
    if (frag.start !== 0) frag.setStart(startPTS);
    frag.setDuration(endPTS - frag.start);
    frag.startPTS = startPTS;
    frag.maxStartPTS = maxStartPTS;
    frag.startDTS = startDTS;
    frag.endPTS = endPTS;
    frag.minEndPTS = minEndPTS;
    frag.endDTS = endDTS;
    const sn = frag.sn;
    // exit if sn out of range
    if (!details || sn < details.startSN || sn > details.endSN) return 0;
    let i;
    const fragIdx = sn - details.startSN;
    const fragments = details.fragments;
    // update frag reference in fragments array
    // rationale is that fragments array might not contain this frag object.
    // this will happen if playlist has been refreshed between frag loading and call to updateFragPTSDTS()
    // if we don't update frag, we won't be able to propagate PTS info on the playlist
    // resulting in invalid sliding computation
    fragments[fragIdx] = frag;
    // adjust fragment PTS/duration from seqnum-1 to frag 0
    for(i = fragIdx; i > 0; i--)$b941786f4eb9cb76$var$updateFromToPTS(fragments[i], fragments[i - 1]);
    // adjust fragment PTS/duration from seqnum to last frag
    for(i = fragIdx; i < fragments.length - 1; i++)$b941786f4eb9cb76$var$updateFromToPTS(fragments[i], fragments[i + 1]);
    if (details.fragmentHint) $b941786f4eb9cb76$var$updateFromToPTS(fragments[fragments.length - 1], details.fragmentHint);
    details.PTSKnown = details.alignedSliding = true;
    return drift;
}
function $b941786f4eb9cb76$var$mergeDetails(oldDetails, newDetails, logger) {
    if (oldDetails === newDetails) return;
    // Track the last initSegment processed. Initialize it to the last one on the timeline.
    let currentInitSegment = null;
    const oldFragments = oldDetails.fragments;
    for(let i = oldFragments.length - 1; i >= 0; i--){
        const oldInit = oldFragments[i].initSegment;
        if (oldInit) {
            currentInitSegment = oldInit;
            break;
        }
    }
    if (oldDetails.fragmentHint) // prevent PTS and duration from being adjusted on the next hint
    delete oldDetails.fragmentHint.endPTS;
    // check if old/new playlists have fragments in common
    // loop through overlapping SN and update startPTS, cc, and duration if any found
    let PTSFrag;
    $b941786f4eb9cb76$var$mapFragmentIntersection(oldDetails, newDetails, (oldFrag, newFrag, newFragIndex, newFragments)=>{
        if ((!newDetails.startCC || newDetails.skippedSegments) && newFrag.cc !== oldFrag.cc) {
            const ccOffset = oldFrag.cc - newFrag.cc;
            for(let i = newFragIndex; i < newFragments.length; i++)newFragments[i].cc += ccOffset;
            newDetails.endCC = newFragments[newFragments.length - 1].cc;
        }
        if ($b941786f4eb9cb76$var$isFiniteNumber(oldFrag.startPTS) && $b941786f4eb9cb76$var$isFiniteNumber(oldFrag.endPTS)) {
            newFrag.setStart(newFrag.startPTS = oldFrag.startPTS);
            newFrag.startDTS = oldFrag.startDTS;
            newFrag.maxStartPTS = oldFrag.maxStartPTS;
            newFrag.endPTS = oldFrag.endPTS;
            newFrag.endDTS = oldFrag.endDTS;
            newFrag.minEndPTS = oldFrag.minEndPTS;
            newFrag.setDuration(oldFrag.endPTS - oldFrag.startPTS);
            if (newFrag.duration) PTSFrag = newFrag;
            // PTS is known when any segment has startPTS and endPTS
            newDetails.PTSKnown = newDetails.alignedSliding = true;
        }
        if (oldFrag.hasStreams) newFrag.elementaryStreams = oldFrag.elementaryStreams;
        newFrag.loader = oldFrag.loader;
        if (oldFrag.hasStats) newFrag.stats = oldFrag.stats;
        if (oldFrag.initSegment) {
            newFrag.initSegment = oldFrag.initSegment;
            currentInitSegment = oldFrag.initSegment;
        }
    });
    const newFragments = newDetails.fragments;
    const fragmentsToCheck = newDetails.fragmentHint ? newFragments.concat(newDetails.fragmentHint) : newFragments;
    if (currentInitSegment) fragmentsToCheck.forEach((frag)=>{
        var _currentInitSegment;
        if (frag && (!frag.initSegment || frag.initSegment.relurl === ((_currentInitSegment = currentInitSegment) == null ? void 0 : _currentInitSegment.relurl))) frag.initSegment = currentInitSegment;
    });
    if (newDetails.skippedSegments) {
        newDetails.deltaUpdateFailed = newFragments.some((frag)=>!frag);
        if (newDetails.deltaUpdateFailed) {
            logger.warn('[level-helper] Previous playlist missing segments skipped in delta playlist');
            for(let i = newDetails.skippedSegments; i--;)newFragments.shift();
            newDetails.startSN = newFragments[0].sn;
        } else {
            if (newDetails.canSkipDateRanges) newDetails.dateRanges = $b941786f4eb9cb76$var$mergeDateRanges(oldDetails.dateRanges, newDetails, logger);
            const programDateTimes = oldDetails.fragments.filter((frag)=>frag.rawProgramDateTime);
            if (oldDetails.hasProgramDateTime && !newDetails.hasProgramDateTime) {
                for(let i = 1; i < fragmentsToCheck.length; i++)if (fragmentsToCheck[i].programDateTime === null) $b941786f4eb9cb76$var$assignProgramDateTime(fragmentsToCheck[i], fragmentsToCheck[i - 1], programDateTimes);
            }
            $b941786f4eb9cb76$var$mapDateRanges(programDateTimes, newDetails);
        }
        newDetails.endCC = newFragments[newFragments.length - 1].cc;
    }
    if (!newDetails.startCC) {
        var _fragPriorToNewStart$;
        const fragPriorToNewStart = $b941786f4eb9cb76$var$getFragmentWithSN(oldDetails, newDetails.startSN - 1);
        newDetails.startCC = (_fragPriorToNewStart$ = fragPriorToNewStart == null ? void 0 : fragPriorToNewStart.cc) != null ? _fragPriorToNewStart$ : newFragments[0].cc;
    }
    // Merge parts
    $b941786f4eb9cb76$var$mapPartIntersection(oldDetails.partList, newDetails.partList, (oldPart, newPart)=>{
        newPart.elementaryStreams = oldPart.elementaryStreams;
        newPart.stats = oldPart.stats;
    });
    // if at least one fragment contains PTS info, recompute PTS information for all fragments
    if (PTSFrag) $b941786f4eb9cb76$var$updateFragPTSDTS(newDetails, PTSFrag, PTSFrag.startPTS, PTSFrag.endPTS, PTSFrag.startDTS, PTSFrag.endDTS, logger);
    else // ensure that delta is within oldFragments range
    // also adjust sliding in case delta is 0 (we could have old=[50-60] and new=old=[50-61])
    // in that case we also need to adjust start offset of all fragments
    $b941786f4eb9cb76$var$adjustSliding(oldDetails, newDetails);
    if (newFragments.length) newDetails.totalduration = newDetails.edge - newFragments[0].start;
    newDetails.driftStartTime = oldDetails.driftStartTime;
    newDetails.driftStart = oldDetails.driftStart;
    const advancedDateTime = newDetails.advancedDateTime;
    if (newDetails.advanced && advancedDateTime) {
        const edge = newDetails.edge;
        if (!newDetails.driftStart) {
            newDetails.driftStartTime = advancedDateTime;
            newDetails.driftStart = edge;
        }
        newDetails.driftEndTime = advancedDateTime;
        newDetails.driftEnd = edge;
    } else {
        newDetails.driftEndTime = oldDetails.driftEndTime;
        newDetails.driftEnd = oldDetails.driftEnd;
        newDetails.advancedDateTime = oldDetails.advancedDateTime;
    }
    if (newDetails.requestScheduled === -1) newDetails.requestScheduled = oldDetails.requestScheduled;
}
function $b941786f4eb9cb76$var$mergeDateRanges(oldDateRanges, newDetails, logger) {
    const { dateRanges: deltaDateRanges, recentlyRemovedDateranges: recentlyRemovedDateranges } = newDetails;
    const dateRanges = $b941786f4eb9cb76$var$_extends({}, oldDateRanges);
    if (recentlyRemovedDateranges) recentlyRemovedDateranges.forEach((id)=>{
        delete dateRanges[id];
    });
    const mergeIds = Object.keys(dateRanges);
    const mergeCount = mergeIds.length;
    if (!mergeCount) return deltaDateRanges;
    Object.keys(deltaDateRanges).forEach((id)=>{
        const mergedDateRange = dateRanges[id];
        const dateRange = new $b941786f4eb9cb76$export$829bd850c745b6e(deltaDateRanges[id].attr, mergedDateRange);
        if (dateRange.isValid) {
            dateRanges[id] = dateRange;
            if (!mergedDateRange) dateRange.tagOrder += mergeCount;
        } else logger.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${$b941786f4eb9cb76$var$stringify(deltaDateRanges[id].attr)}"`);
    });
    return dateRanges;
}
function $b941786f4eb9cb76$var$mapPartIntersection(oldParts, newParts, intersectionFn) {
    if (oldParts && newParts) {
        let delta = 0;
        for(let i = 0, len = oldParts.length; i <= len; i++){
            const oldPart = oldParts[i];
            const newPart = newParts[i + delta];
            if (oldPart && newPart && oldPart.index === newPart.index && oldPart.fragment.sn === newPart.fragment.sn) intersectionFn(oldPart, newPart);
            else delta--;
        }
    }
}
function $b941786f4eb9cb76$var$mapFragmentIntersection(oldDetails, newDetails, intersectionFn) {
    const skippedSegments = newDetails.skippedSegments;
    const start = Math.max(oldDetails.startSN, newDetails.startSN) - newDetails.startSN;
    const end = (oldDetails.fragmentHint ? 1 : 0) + (skippedSegments ? newDetails.endSN : Math.min(oldDetails.endSN, newDetails.endSN)) - newDetails.startSN;
    const delta = newDetails.startSN - oldDetails.startSN;
    const newFrags = newDetails.fragmentHint ? newDetails.fragments.concat(newDetails.fragmentHint) : newDetails.fragments;
    const oldFrags = oldDetails.fragmentHint ? oldDetails.fragments.concat(oldDetails.fragmentHint) : oldDetails.fragments;
    for(let i = start; i <= end; i++){
        const oldFrag = oldFrags[delta + i];
        let newFrag = newFrags[i];
        if (skippedSegments && !newFrag && oldFrag) // Fill in skipped segments in delta playlist
        newFrag = newDetails.fragments[i] = oldFrag;
        if (oldFrag && newFrag) {
            intersectionFn(oldFrag, newFrag, i, newFrags);
            const uriBefore = oldFrag.relurl;
            const uriAfter = newFrag.relurl;
            if (uriBefore && $b941786f4eb9cb76$var$notEqualAfterStrippingQueries(uriBefore, uriAfter)) {
                newDetails.playlistParsingError = $b941786f4eb9cb76$var$getSequenceError(`media sequence mismatch ${newFrag.sn}:`, oldDetails, newDetails, oldFrag, newFrag);
                return;
            } else if (oldFrag.cc !== newFrag.cc) {
                newDetails.playlistParsingError = $b941786f4eb9cb76$var$getSequenceError(`discontinuity sequence mismatch (${oldFrag.cc}!=${newFrag.cc})`, oldDetails, newDetails, oldFrag, newFrag);
                return;
            }
        }
    }
}
function $b941786f4eb9cb76$var$getSequenceError(message, oldDetails, newDetails, oldFrag, newFrag) {
    return new Error(`${message} ${newFrag.url}
Playlist starting @${oldDetails.startSN}
${oldDetails.m3u8}

Playlist starting @${newDetails.startSN}
${newDetails.m3u8}`);
}
function $b941786f4eb9cb76$var$adjustSliding(oldDetails, newDetails, matchingStableVariantOrRendition = true) {
    const delta = newDetails.startSN + newDetails.skippedSegments - oldDetails.startSN;
    const oldFragments = oldDetails.fragments;
    const advancedOrStable = delta >= 0;
    let sliding = 0;
    if (advancedOrStable && delta < oldFragments.length) sliding = oldFragments[delta].start;
    else if (advancedOrStable && newDetails.startSN === oldDetails.endSN + 1) sliding = oldDetails.fragmentEnd;
    else if (advancedOrStable && matchingStableVariantOrRendition) // align with expected position (updated playlist start sequence is past end sequence of last update)
    sliding = oldDetails.fragmentStart + delta * newDetails.levelTargetDuration;
    else if (!newDetails.skippedSegments && newDetails.fragmentStart === 0) // align new start with old (playlist switch has a sequence with no overlap and should not be used for alignment)
    sliding = oldDetails.fragmentStart;
    else // new details already has a sliding offset or has skipped segments
    return;
    $b941786f4eb9cb76$var$addSliding(newDetails, sliding);
}
function $b941786f4eb9cb76$var$addSliding(details, sliding) {
    if (sliding) {
        const fragments = details.fragments;
        for(let i = details.skippedSegments; i < fragments.length; i++)fragments[i].addStart(sliding);
        if (details.fragmentHint) details.fragmentHint.addStart(sliding);
    }
}
function $b941786f4eb9cb76$var$computeReloadInterval(newDetails, distanceToLiveEdgeMs = Infinity) {
    let reloadInterval = 1000 * newDetails.targetduration;
    if (newDetails.updated) {
        // Use last segment duration when shorter than target duration and near live edge
        const fragments = newDetails.fragments;
        const liveEdgeMaxTargetDurations = 4;
        if (fragments.length && reloadInterval * liveEdgeMaxTargetDurations > distanceToLiveEdgeMs) {
            const lastSegmentDuration = fragments[fragments.length - 1].duration * 1000;
            if (lastSegmentDuration < reloadInterval) reloadInterval = lastSegmentDuration;
        }
    } else // estimate = 'miss half average';
    // follow HLS Spec, If the client reloads a Playlist file and finds that it has not
    // changed then it MUST wait for a period of one-half the target
    // duration before retrying.
    reloadInterval /= 2;
    return Math.round(reloadInterval);
}
function $b941786f4eb9cb76$var$getFragmentWithSN(details, sn, fragCurrent) {
    if (!details) return null;
    let fragment = details.fragments[sn - details.startSN];
    if (fragment) return fragment;
    fragment = details.fragmentHint;
    if (fragment && fragment.sn === sn) return fragment;
    if (sn < details.startSN && fragCurrent && fragCurrent.sn === sn) return fragCurrent;
    return null;
}
function $b941786f4eb9cb76$var$getPartWith(details, sn, partIndex) {
    if (!details) return null;
    return $b941786f4eb9cb76$var$findPart(details.partList, sn, partIndex);
}
function $b941786f4eb9cb76$var$findPart(partList, sn, partIndex) {
    if (partList) for(let i = partList.length; i--;){
        const part = partList[i];
        if (part.index === partIndex && part.fragment.sn === sn) return part;
    }
    return null;
}
function $b941786f4eb9cb76$var$reassignFragmentLevelIndexes(levels) {
    levels.forEach((level, index)=>{
        var _level$details;
        (_level$details = level.details) == null || _level$details.fragments.forEach((fragment)=>{
            fragment.level = index;
            if (fragment.initSegment) fragment.initSegment.level = index;
        });
    });
}
function $b941786f4eb9cb76$var$notEqualAfterStrippingQueries(uriBefore, uriAfter) {
    if (uriBefore !== uriAfter && uriAfter) return $b941786f4eb9cb76$var$stripQuery(uriBefore) !== $b941786f4eb9cb76$var$stripQuery(uriAfter);
    return false;
}
function $b941786f4eb9cb76$var$stripQuery(uri) {
    return uri.replace(/\?[^?]*$/, '');
}
function $b941786f4eb9cb76$var$findFirstFragWithCC(fragments, cc) {
    for(let i = 0, len = fragments.length; i < len; i++){
        var _fragments$i;
        if (((_fragments$i = fragments[i]) == null ? void 0 : _fragments$i.cc) === cc) return fragments[i];
    }
    return null;
}
function $b941786f4eb9cb76$var$shouldAlignOnDiscontinuities(refDetails, details) {
    if (refDetails) {
        if (details.startCC < refDetails.endCC && details.endCC > refDetails.startCC) return true;
    }
    return false;
}
function $b941786f4eb9cb76$var$adjustFragmentStart(frag, sliding) {
    const start = frag.start + sliding;
    frag.startPTS = start;
    frag.setStart(start);
    frag.endPTS = start + frag.duration;
}
function $b941786f4eb9cb76$var$adjustSlidingStart(sliding, details) {
    // Update segments
    const fragments = details.fragments;
    for(let i = 0, len = fragments.length; i < len; i++)$b941786f4eb9cb76$var$adjustFragmentStart(fragments[i], sliding);
    // Update LL-HLS parts at the end of the playlist
    if (details.fragmentHint) $b941786f4eb9cb76$var$adjustFragmentStart(details.fragmentHint, sliding);
    details.alignedSliding = true;
}
/**
 * Using the parameters of the last level, this function computes PTS' of the new fragments so that they form a
 * contiguous stream with the last fragments.
 * The PTS of a fragment lets Hls.js know where it fits into a stream - by knowing every PTS, we know which fragment to
 * download at any given time. PTS is normally computed when the fragment is demuxed, so taking this step saves us time
 * and an extra download.
 * @param lastLevel
 * @param details
 */ function $b941786f4eb9cb76$var$alignStream(switchDetails, details) {
    if (!switchDetails) return;
    $b941786f4eb9cb76$var$alignDiscontinuities(details, switchDetails);
    if (!details.alignedSliding) // If the PTS wasn't figured out via discontinuity sequence that means there was no CC increase within the level.
    // Aligning via Program Date Time should therefore be reliable, since PDT should be the same within the same
    // discontinuity sequence.
    $b941786f4eb9cb76$var$alignMediaPlaylistByPDT(details, switchDetails);
    if (!details.alignedSliding && !details.skippedSegments) // Try to align on sn so that we pick a better start fragment.
    // Do not perform this on playlists with delta updates as this is only to align levels on switch
    // and adjustSliding only adjusts fragments after skippedSegments.
    $b941786f4eb9cb76$var$adjustSliding(switchDetails, details, false);
}
/**
 * Ajust the start of fragments in `details` by the difference in time between fragments of the latest
 * shared discontinuity sequence change.
 * @param lastLevel - The details of the last loaded level
 * @param details - The details of the new level
 */ function $b941786f4eb9cb76$var$alignDiscontinuities(details, refDetails) {
    if (!$b941786f4eb9cb76$var$shouldAlignOnDiscontinuities(refDetails, details)) return;
    const targetCC = Math.min(refDetails.endCC, details.endCC);
    const refFrag = $b941786f4eb9cb76$var$findFirstFragWithCC(refDetails.fragments, targetCC);
    const frag = $b941786f4eb9cb76$var$findFirstFragWithCC(details.fragments, targetCC);
    if (!refFrag || !frag) return;
    $b941786f4eb9cb76$var$logger.log(`Aligning playlist at start of dicontinuity sequence ${targetCC}`);
    const delta = refFrag.start - frag.start;
    $b941786f4eb9cb76$var$adjustSlidingStart(delta, details);
}
/**
 * Ensures appropriate time-alignment between renditions based on PDT.
 * This function assumes the timelines represented in `refDetails` are accurate, including the PDTs
 * for the last discontinuity sequence number shared by both playlists when present,
 * and uses the "wallclock"/PDT timeline as a cross-reference to `details`, adjusting the presentation
 * times/timelines of `details` accordingly.
 * Given the asynchronous nature of fetches and initial loads of live `main` and audio/subtitle tracks,
 * the primary purpose of this function is to ensure the "local timelines" of audio/subtitle tracks
 * are aligned to the main/video timeline, using PDT as the cross-reference/"anchor" that should
 * be consistent across playlists, per the HLS spec.
 * @param details - The details of the rendition you'd like to time-align (e.g. an audio rendition).
 * @param refDetails - The details of the reference rendition with start and PDT times for alignment.
 */ function $b941786f4eb9cb76$var$alignMediaPlaylistByPDT(details, refDetails) {
    if (!details.hasProgramDateTime || !refDetails.hasProgramDateTime) return;
    const fragments = details.fragments;
    const refFragments = refDetails.fragments;
    if (!fragments.length || !refFragments.length) return;
    // Calculate a delta to apply to all fragments according to the delta in PDT times and start times
    // of a fragment in the reference details, and a fragment in the target details of the same discontinuity.
    // If a fragment of the same discontinuity was not found use the middle fragment of both.
    let refFrag;
    let frag;
    const targetCC = Math.min(refDetails.endCC, details.endCC);
    if (refDetails.startCC < targetCC && details.startCC < targetCC) {
        refFrag = $b941786f4eb9cb76$var$findFirstFragWithCC(refFragments, targetCC);
        frag = $b941786f4eb9cb76$var$findFirstFragWithCC(fragments, targetCC);
    }
    if (!refFrag || !frag) {
        refFrag = refFragments[Math.floor(refFragments.length / 2)];
        frag = $b941786f4eb9cb76$var$findFirstFragWithCC(fragments, refFrag.cc) || fragments[Math.floor(fragments.length / 2)];
    }
    const refPDT = refFrag.programDateTime;
    const targetPDT = frag.programDateTime;
    if (!refPDT || !targetPDT) return;
    const delta = (targetPDT - refPDT) / 1000 - (frag.start - refFrag.start);
    $b941786f4eb9cb76$var$adjustSlidingStart(delta, details);
}
function $b941786f4eb9cb76$var$addEventListener(el, type, listener) {
    $b941786f4eb9cb76$var$removeEventListener(el, type, listener);
    el.addEventListener(type, listener);
}
function $b941786f4eb9cb76$var$removeEventListener(el, type, listener) {
    el.removeEventListener(type, listener);
}
/**
 *  TimeRanges to string helper
 */ const $b941786f4eb9cb76$var$TimeRanges = {
    toString: function(r) {
        let log = '';
        const len = r.length;
        for(let i = 0; i < len; i++)log += `[${r.start(i).toFixed(3)}-${r.end(i).toFixed(3)}]`;
        return log;
    }
};
const $b941786f4eb9cb76$var$State = {
    STOPPED: 'STOPPED',
    IDLE: 'IDLE',
    KEY_LOADING: 'KEY_LOADING',
    FRAG_LOADING: 'FRAG_LOADING',
    FRAG_LOADING_WAITING_RETRY: 'FRAG_LOADING_WAITING_RETRY',
    WAITING_TRACK: 'WAITING_TRACK',
    PARSING: 'PARSING',
    PARSED: 'PARSED',
    ENDED: 'ENDED',
    ERROR: 'ERROR',
    WAITING_INIT_PTS: 'WAITING_INIT_PTS',
    WAITING_LEVEL: 'WAITING_LEVEL'
};
class $b941786f4eb9cb76$export$946cb951577581c9 extends $b941786f4eb9cb76$var$TaskLoop {
    constructor(hls, fragmentTracker, keyLoader, logPrefix, playlistType){
        super(logPrefix, hls.logger);
        this.hls = void 0;
        this.fragPrevious = null;
        this.fragCurrent = null;
        this.fragmentTracker = void 0;
        this.transmuxer = null;
        this._state = $b941786f4eb9cb76$var$State.STOPPED;
        this.playlistType = void 0;
        this.media = null;
        this.mediaBuffer = null;
        this.config = void 0;
        this.bitrateTest = false;
        this.lastCurrentTime = 0;
        this.nextLoadPosition = 0;
        this.startPosition = 0;
        this.startTimeOffset = null;
        this.retryDate = 0;
        this.levels = null;
        this.fragmentLoader = void 0;
        this.keyLoader = void 0;
        this.levelLastLoaded = null;
        this.startFragRequested = false;
        this.decrypter = void 0;
        this.initPTS = [];
        this.buffering = true;
        this.loadingParts = false;
        this.loopSn = void 0;
        this.onMediaSeeking = ()=>{
            const { config: config, fragCurrent: fragCurrent, media: media, mediaBuffer: mediaBuffer, state: state } = this;
            const currentTime = media ? media.currentTime : 0;
            const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(mediaBuffer ? mediaBuffer : media, currentTime, config.maxBufferHole);
            const noFowardBuffer = !bufferInfo.len;
            this.log(`Media seeking to ${$b941786f4eb9cb76$var$isFiniteNumber(currentTime) ? currentTime.toFixed(3) : currentTime}, state: ${state}, ${noFowardBuffer ? 'out of' : 'in'} buffer`);
            if (this.state === $b941786f4eb9cb76$var$State.ENDED) this.resetLoadingState();
            else if (fragCurrent) {
                // Seeking while frag load is in progress
                const tolerance = config.maxFragLookUpTolerance;
                const fragStartOffset = fragCurrent.start - tolerance;
                const fragEndOffset = fragCurrent.start + fragCurrent.duration + tolerance;
                // if seeking out of buffered range or into new one
                if (noFowardBuffer || fragEndOffset < bufferInfo.start || fragStartOffset > bufferInfo.end) {
                    const pastFragment = currentTime > fragEndOffset;
                    // if the seek position is outside the current fragment range
                    if (currentTime < fragStartOffset || pastFragment) {
                        if (pastFragment && fragCurrent.loader) {
                            this.log(`Cancelling fragment load for seek (sn: ${fragCurrent.sn})`);
                            fragCurrent.abortRequests();
                            this.resetLoadingState();
                        }
                        this.fragPrevious = null;
                    }
                }
            }
            if (media) {
                // Remove gap fragments
                this.fragmentTracker.removeFragmentsInRange(currentTime, Infinity, this.playlistType, true);
                // Don't set lastCurrentTime with backward seeks (allows for frag selection with strict tolerances)
                const lastCurrentTime = this.lastCurrentTime;
                if (currentTime > lastCurrentTime) this.lastCurrentTime = currentTime;
                if (!this.loadingParts) {
                    const bufferEnd = Math.max(bufferInfo.end, currentTime);
                    const shouldLoadParts = this.shouldLoadParts(this.getLevelDetails(), bufferEnd);
                    if (shouldLoadParts) {
                        this.log(`LL-Part loading ON after seeking to ${currentTime.toFixed(2)} with buffer @${bufferEnd.toFixed(2)}`);
                        this.loadingParts = shouldLoadParts;
                    }
                }
            }
            // in case seeking occurs although no media buffered, adjust startPosition and nextLoadPosition to seek target
            if (!this.hls.hasEnoughToStart) {
                this.log(`Setting ${noFowardBuffer ? 'startPosition' : 'nextLoadPosition'} to ${currentTime} for seek without enough to start`);
                this.nextLoadPosition = currentTime;
                if (noFowardBuffer) this.startPosition = currentTime;
            }
            if (noFowardBuffer && this.state === $b941786f4eb9cb76$var$State.IDLE) // Async tick to speed up processing
            this.tickImmediate();
        };
        this.onMediaEnded = ()=>{
            // reset startPosition and lastCurrentTime to restart playback @ stream beginning
            this.log(`setting startPosition to 0 because media ended`);
            this.startPosition = this.lastCurrentTime = 0;
        };
        this.playlistType = playlistType;
        this.hls = hls;
        this.fragmentLoader = new $b941786f4eb9cb76$var$FragmentLoader(hls.config);
        this.keyLoader = keyLoader;
        this.fragmentTracker = fragmentTracker;
        this.config = hls.config;
        this.decrypter = new $b941786f4eb9cb76$var$Decrypter(hls.config);
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    doTick() {
        this.onTickEnd();
    }
    onTickEnd() {}
    startLoad(startPosition) {}
    stopLoad() {
        if (this.state === $b941786f4eb9cb76$var$State.STOPPED) return;
        this.fragmentLoader.abort();
        this.keyLoader.abort(this.playlistType);
        const frag = this.fragCurrent;
        if (frag != null && frag.loader) {
            frag.abortRequests();
            this.fragmentTracker.removeFragment(frag);
        }
        this.resetTransmuxer();
        this.fragCurrent = null;
        this.fragPrevious = null;
        this.clearInterval();
        this.clearNextTick();
        this.state = $b941786f4eb9cb76$var$State.STOPPED;
    }
    get startPositionValue() {
        const { nextLoadPosition: nextLoadPosition, startPosition: startPosition } = this;
        if (startPosition === -1 && nextLoadPosition) return nextLoadPosition;
        return startPosition;
    }
    get bufferingEnabled() {
        return this.buffering;
    }
    pauseBuffering() {
        this.buffering = false;
    }
    resumeBuffering() {
        this.buffering = true;
    }
    get inFlightFrag() {
        return {
            frag: this.fragCurrent,
            state: this.state
        };
    }
    _streamEnded(bufferInfo, levelDetails) {
        // Stream is never "ended" when playlist is live or media is detached
        if (levelDetails.live || !this.media) return false;
        // Stream is not "ended" when nothing is buffered past the start
        const bufferEnd = bufferInfo.end || 0;
        const timelineStart = this.config.timelineOffset || 0;
        if (bufferEnd <= timelineStart) return false;
        // Stream is not "ended" when there is a second buffered range starting before the end of the playlist
        const bufferedRanges = bufferInfo.buffered;
        if (this.config.maxBufferHole && bufferedRanges && bufferedRanges.length > 1) // make sure bufferInfo accounts for any gaps
        bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferedInfo(bufferedRanges, bufferInfo.start, 0);
        const nextStart = bufferInfo.nextStart;
        const hasSecondBufferedRange = nextStart && nextStart > timelineStart && nextStart < levelDetails.edge;
        if (hasSecondBufferedRange) return false;
        // Playhead is in unbuffered region. Marking EoS now could result in Safari failing to dispatch "ended" event following seek on start.
        if (this.media.currentTime < bufferInfo.start) return false;
        const partList = levelDetails.partList;
        // Since the last part isn't guaranteed to correspond to the last playlist segment for Low-Latency HLS,
        // check instead if the last part is buffered.
        if (partList != null && partList.length) {
            const lastPart = partList[partList.length - 1];
            // Checking the midpoint of the part for potential margin of error and related issues.
            // NOTE: Technically I believe parts could yield content that is < the computed duration (including potential a duration of 0)
            // and still be spec-compliant, so there may still be edge cases here. Likewise, there could be issues in end of stream
            // part mismatches for independent audio and video playlists/segments.
            const lastPartBuffered = $b941786f4eb9cb76$var$BufferHelper.isBuffered(this.media, lastPart.start + lastPart.duration / 2);
            return lastPartBuffered;
        }
        const playlistType = levelDetails.fragments[levelDetails.fragments.length - 1].type;
        return this.fragmentTracker.isEndListAppended(playlistType);
    }
    getLevelDetails() {
        if (this.levels && this.levelLastLoaded !== null) return this.levelLastLoaded.details;
    }
    get timelineOffset() {
        const configuredTimelineOffset = this.config.timelineOffset;
        if (configuredTimelineOffset) {
            var _this$getLevelDetails;
            return ((_this$getLevelDetails = this.getLevelDetails()) == null ? void 0 : _this$getLevelDetails.appliedTimelineOffset) || configuredTimelineOffset;
        }
        return 0;
    }
    onMediaAttached(event, data) {
        const media = this.media = this.mediaBuffer = data.media;
        $b941786f4eb9cb76$var$addEventListener(media, 'seeking', this.onMediaSeeking);
        $b941786f4eb9cb76$var$addEventListener(media, 'ended', this.onMediaEnded);
        const config = this.config;
        if (this.levels && config.autoStartLoad && this.state === $b941786f4eb9cb76$var$State.STOPPED) this.startLoad(config.startPosition);
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        const media = this.media;
        if (media === null) return;
        if (media.ended) {
            this.log('MSE detaching and video ended, reset startPosition');
            this.startPosition = this.lastCurrentTime = 0;
        }
        // remove video listeners
        $b941786f4eb9cb76$var$removeEventListener(media, 'seeking', this.onMediaSeeking);
        $b941786f4eb9cb76$var$removeEventListener(media, 'ended', this.onMediaEnded);
        if (this.keyLoader && !transferringMedia) this.keyLoader.detach();
        this.media = this.mediaBuffer = null;
        this.loopSn = undefined;
        if (transferringMedia) {
            this.resetLoadingState();
            this.resetTransmuxer();
            return;
        }
        this.loadingParts = false;
        this.fragmentTracker.removeAllFragments();
        this.stopLoad();
    }
    onManifestLoading() {
        this.initPTS = [];
        this.levels = this.levelLastLoaded = this.fragCurrent = null;
        this.lastCurrentTime = this.startPosition = 0;
        this.startFragRequested = false;
    }
    onError(event, data) {}
    onManifestLoaded(event, data) {
        this.startTimeOffset = data.startTimeOffset;
    }
    onHandlerDestroying() {
        this.stopLoad();
        if (this.transmuxer) {
            this.transmuxer.destroy();
            this.transmuxer = null;
        }
        super.onHandlerDestroying();
        // @ts-ignore
        this.hls = this.onMediaSeeking = this.onMediaEnded = null;
    }
    onHandlerDestroyed() {
        this.state = $b941786f4eb9cb76$var$State.STOPPED;
        if (this.fragmentLoader) this.fragmentLoader.destroy();
        if (this.keyLoader) this.keyLoader.destroy();
        if (this.decrypter) this.decrypter.destroy();
        this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null;
        super.onHandlerDestroyed();
    }
    loadFragment(frag, level, targetBufferTime) {
        this.startFragRequested = true;
        this._loadFragForPlayback(frag, level, targetBufferTime);
    }
    _loadFragForPlayback(fragment, level, targetBufferTime) {
        const progressCallback = (data)=>{
            const frag = data.frag;
            if (this.fragContextChanged(frag)) {
                this.warn(`${frag.type} sn: ${frag.sn}${data.part ? ' part: ' + data.part.index : ''} of ${this.fragInfo(frag, false, data.part)}) was dropped during download.`);
                this.fragmentTracker.removeFragment(frag);
                return;
            }
            frag.stats.chunkCount++;
            this._handleFragmentLoadProgress(data);
        };
        this._doFragLoad(fragment, level, targetBufferTime, progressCallback).then((data)=>{
            if (!data) // if we're here we probably needed to backtrack or are waiting for more parts
            return;
            const state = this.state;
            const frag = data.frag;
            if (this.fragContextChanged(frag)) {
                if (state === $b941786f4eb9cb76$var$State.FRAG_LOADING || !this.fragCurrent && state === $b941786f4eb9cb76$var$State.PARSING) {
                    this.fragmentTracker.removeFragment(frag);
                    this.state = $b941786f4eb9cb76$var$State.IDLE;
                }
                return;
            }
            if ('payload' in data) {
                this.log(`Loaded ${frag.type} sn: ${frag.sn} of ${this.playlistLabel()} ${frag.level}`);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, data);
            }
            // Pass through the whole payload; controllers not implementing progressive loading receive data from this callback
            this._handleFragmentLoadComplete(data);
        }).catch((reason)=>{
            if (this.state === $b941786f4eb9cb76$var$State.STOPPED || this.state === $b941786f4eb9cb76$var$State.ERROR) return;
            this.warn(`Frag error: ${(reason == null ? void 0 : reason.message) || reason}`);
            this.resetFragmentLoading(fragment);
        });
    }
    clearTrackerIfNeeded(frag) {
        var _this$mediaBuffer;
        const { fragmentTracker: fragmentTracker } = this;
        const fragState = fragmentTracker.getState(frag);
        if (fragState === $b941786f4eb9cb76$var$FragmentState.APPENDING) {
            // Lower the max buffer length and try again
            const playlistType = frag.type;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            const minForwardBufferLength = Math.max(frag.duration, bufferedInfo ? bufferedInfo.len : this.config.maxBufferLength);
            // If backtracking, always remove from the tracker without reducing max buffer length
            const backtrackFragment = this.backtrackFragment;
            const backtracked = backtrackFragment ? frag.sn - backtrackFragment.sn : 0;
            if (backtracked === 1 || this.reduceMaxBufferLength(minForwardBufferLength, frag.duration)) fragmentTracker.removeFragment(frag);
        } else if (((_this$mediaBuffer = this.mediaBuffer) == null ? void 0 : _this$mediaBuffer.buffered.length) === 0) // Stop gap for bad tracker / buffer flush behavior
        fragmentTracker.removeAllFragments();
        else if (fragmentTracker.hasParts(frag.type)) {
            // In low latency mode, remove fragments for which only some parts were buffered
            fragmentTracker.detectPartialFragments({
                frag: frag,
                part: null,
                stats: frag.stats,
                id: frag.type
            });
            if (fragmentTracker.getState(frag) === $b941786f4eb9cb76$var$FragmentState.PARTIAL) fragmentTracker.removeFragment(frag);
        }
    }
    checkLiveUpdate(details) {
        if (details.updated && !details.live) {
            // Live stream ended, update fragment tracker
            const lastFragment = details.fragments[details.fragments.length - 1];
            this.fragmentTracker.detectPartialFragments({
                frag: lastFragment,
                part: null,
                stats: lastFragment.stats,
                id: lastFragment.type
            });
        }
        if (!details.fragments[0]) details.deltaUpdateFailed = true;
    }
    waitForLive(levelInfo) {
        const details = levelInfo.details;
        return (details == null ? void 0 : details.live) && details.type !== 'EVENT' && (this.levelLastLoaded !== levelInfo || details.expired);
    }
    flushMainBuffer(startOffset, endOffset, type = null) {
        if (!(startOffset - endOffset)) return;
        // When alternate audio is playing, the audio-stream-controller is responsible for the audio buffer. Otherwise,
        // passing a null type flushes both buffers
        const flushScope = {
            startOffset: startOffset,
            endOffset: endOffset,
            type: type
        };
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, flushScope);
    }
    _loadInitSegment(fragment, level) {
        this._doFragLoad(fragment, level).then((data)=>{
            const frag = data == null ? void 0 : data.frag;
            if (!frag || this.fragContextChanged(frag) || !this.levels) throw new Error('init load aborted');
            return data;
        }).then((data)=>{
            const { hls: hls } = this;
            const { frag: frag, payload: payload } = data;
            const decryptData = frag.decryptdata;
            // check to see if the payload needs to be decrypted
            if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && $b941786f4eb9cb76$var$isFullSegmentEncryption(decryptData.method)) {
                const startTime = self.performance.now();
                // decrypt init segment data
                return this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, $b941786f4eb9cb76$var$getAesModeFromFullSegmentMethod(decryptData.method)).catch((err)=>{
                    hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR,
                        fatal: false,
                        error: err,
                        reason: err.message,
                        frag: frag
                    });
                    throw err;
                }).then((decryptedData)=>{
                    const endTime = self.performance.now();
                    hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_DECRYPTED, {
                        frag: frag,
                        payload: decryptedData,
                        stats: {
                            tstart: startTime,
                            tdecrypt: endTime
                        }
                    });
                    data.payload = decryptedData;
                    return this.completeInitSegmentLoad(data);
                });
            }
            return this.completeInitSegmentLoad(data);
        }).catch((reason)=>{
            if (this.state === $b941786f4eb9cb76$var$State.STOPPED || this.state === $b941786f4eb9cb76$var$State.ERROR) return;
            this.warn(reason);
            this.resetFragmentLoading(fragment);
        });
    }
    completeInitSegmentLoad(data) {
        const { levels: levels } = this;
        if (!levels) throw new Error('init load aborted, missing levels');
        const stats = data.frag.stats;
        if (this.state !== $b941786f4eb9cb76$var$State.STOPPED) this.state = $b941786f4eb9cb76$var$State.IDLE;
        data.frag.data = new Uint8Array(data.payload);
        stats.parsing.start = stats.buffering.start = self.performance.now();
        stats.parsing.end = stats.buffering.end = self.performance.now();
        this.tick();
    }
    unhandledEncryptionError(initSegment, frag) {
        var _tracks$audio, _tracks$video;
        const tracks = initSegment.tracks;
        if (tracks && !frag.encrypted && ((_tracks$audio = tracks.audio) != null && _tracks$audio.encrypted || (_tracks$video = tracks.video) != null && _tracks$video.encrypted) && (!this.config.emeEnabled || !this.keyLoader.emeController)) {
            const media = this.media;
            const error = new Error(`Encrypted track with no key in ${this.fragInfo(frag)} (media ${media ? 'attached mediaKeys: ' + media.mediaKeys : 'detached'})`);
            this.warn(error.message);
            // Ignore if media is detached or mediaKeys are set
            if (!media || media.mediaKeys) return false;
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_NO_KEYS,
                fatal: false,
                error: error,
                frag: frag
            });
            this.resetTransmuxer();
            return true;
        }
        return false;
    }
    fragContextChanged(frag) {
        const { fragCurrent: fragCurrent } = this;
        return !frag || !fragCurrent || frag.sn !== fragCurrent.sn || frag.level !== fragCurrent.level;
    }
    fragBufferedComplete(frag, part) {
        const media = this.mediaBuffer ? this.mediaBuffer : this.media;
        this.log(`Buffered ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.fragInfo(frag, false, part)} > buffer:${media ? $b941786f4eb9cb76$var$TimeRanges.toString($b941786f4eb9cb76$var$BufferHelper.getBuffered(media)) : '(detached)'})`);
        if ($b941786f4eb9cb76$var$isMediaFragment(frag)) {
            var _this$levels;
            if (frag.type !== $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE) {
                const el = frag.elementaryStreams;
                if (!Object.keys(el).some((type)=>!!el[type])) {
                    // empty segment
                    this.state = $b941786f4eb9cb76$var$State.IDLE;
                    return;
                }
            }
            const level = (_this$levels = this.levels) == null ? void 0 : _this$levels[frag.level];
            if (level != null && level.fragmentError) {
                this.log(`Resetting level fragment error count of ${level.fragmentError} on frag buffered`);
                level.fragmentError = 0;
            }
        }
        this.state = $b941786f4eb9cb76$var$State.IDLE;
    }
    _handleFragmentLoadComplete(fragLoadedEndData) {
        const { transmuxer: transmuxer } = this;
        if (!transmuxer) return;
        const { frag: frag, part: part, partsLoaded: partsLoaded } = fragLoadedEndData;
        // If we did not load parts, or loaded all parts, we have complete (not partial) fragment data
        const complete = !partsLoaded || partsLoaded.length === 0 || partsLoaded.some((fragLoaded)=>!fragLoaded);
        const chunkMeta = new $b941786f4eb9cb76$export$ce0708ece532c9c(frag.level, frag.sn, frag.stats.chunkCount + 1, 0, part ? part.index : -1, !complete);
        transmuxer.flush(chunkMeta);
    }
    _handleFragmentLoadProgress(frag) {}
    _doFragLoad(frag, level, targetBufferTime = null, progressCallback) {
        var _frag$decryptdata;
        this.fragCurrent = frag;
        const details = level.details;
        if (!this.levels || !details) throw new Error(`frag load aborted, missing level${details ? '' : ' detail'}s`);
        let keyLoadingPromise = null;
        if (frag.encrypted && !((_frag$decryptdata = frag.decryptdata) != null && _frag$decryptdata.key)) {
            this.log(`Loading key for ${frag.sn} of [${details.startSN}-${details.endSN}], ${this.playlistLabel()} ${frag.level}`);
            this.state = $b941786f4eb9cb76$var$State.KEY_LOADING;
            this.fragCurrent = frag;
            keyLoadingPromise = this.keyLoader.load(frag).then((keyLoadedData)=>{
                if (!this.fragContextChanged(keyLoadedData.frag)) {
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.KEY_LOADED, keyLoadedData);
                    if (this.state === $b941786f4eb9cb76$var$State.KEY_LOADING) this.state = $b941786f4eb9cb76$var$State.IDLE;
                    return keyLoadedData;
                }
            });
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.KEY_LOADING, {
                frag: frag
            });
            if (this.fragCurrent === null) {
                this.log(`context changed in KEY_LOADING`);
                return Promise.resolve(null);
            }
        } else if (!frag.encrypted) {
            keyLoadingPromise = this.keyLoader.loadClear(frag, details.encryptedFragments, this.startFragRequested);
            if (keyLoadingPromise) this.log(`[eme] blocking frag load until media-keys acquired`);
        }
        const fragPrevious = this.fragPrevious;
        if ($b941786f4eb9cb76$var$isMediaFragment(frag) && (!fragPrevious || frag.sn !== fragPrevious.sn)) {
            const shouldLoadParts = this.shouldLoadParts(level.details, frag.end);
            if (shouldLoadParts !== this.loadingParts) {
                this.log(`LL-Part loading ${shouldLoadParts ? 'ON' : 'OFF'} loading sn ${fragPrevious == null ? void 0 : fragPrevious.sn}->${frag.sn}`);
                this.loadingParts = shouldLoadParts;
            }
        }
        targetBufferTime = Math.max(frag.start, targetBufferTime || 0);
        if (this.loadingParts && $b941786f4eb9cb76$var$isMediaFragment(frag)) {
            const partList = details.partList;
            if (partList && progressCallback) {
                if (targetBufferTime > details.fragmentEnd && details.fragmentHint) frag = details.fragmentHint;
                const partIndex = this.getNextPart(partList, frag, targetBufferTime);
                if (partIndex > -1) {
                    const part = partList[partIndex];
                    frag = this.fragCurrent = part.fragment;
                    this.log(`Loading ${frag.type} sn: ${frag.sn} part: ${part.index} (${partIndex}/${partList.length - 1}) of ${this.fragInfo(frag, false, part)}) cc: ${frag.cc} [${details.startSN}-${details.endSN}], target: ${parseFloat(targetBufferTime.toFixed(3))}`);
                    this.nextLoadPosition = part.start + part.duration;
                    this.state = $b941786f4eb9cb76$var$State.FRAG_LOADING;
                    let _result;
                    if (keyLoadingPromise) _result = keyLoadingPromise.then((keyLoadedData)=>{
                        if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) return null;
                        return this.doFragPartsLoad(frag, part, level, progressCallback);
                    }).catch((error)=>this.handleFragLoadError(error));
                    else _result = this.doFragPartsLoad(frag, part, level, progressCallback).catch((error)=>this.handleFragLoadError(error));
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, {
                        frag: frag,
                        part: part,
                        targetBufferTime: targetBufferTime
                    });
                    if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING parts`));
                    return _result;
                } else if (!frag.url || this.loadedEndOfParts(partList, targetBufferTime)) // Fragment hint has no parts
                return Promise.resolve(null);
            }
        }
        if ($b941786f4eb9cb76$var$isMediaFragment(frag) && this.loadingParts) {
            var _details$partList;
            this.log(`LL-Part loading OFF after next part miss @${targetBufferTime.toFixed(2)} Check buffer at sn: ${frag.sn} loaded parts: ${(_details$partList = details.partList) == null ? void 0 : _details$partList.filter((p)=>p.loaded).map((p)=>`[${p.start}-${p.end}]`)}`);
            this.loadingParts = false;
        } else if (!frag.url) // Selected fragment hint for part but not loading parts
        return Promise.resolve(null);
        this.log(`Loading ${frag.type} sn: ${frag.sn} of ${this.fragInfo(frag, false)}) cc: ${frag.cc} ${'[' + details.startSN + '-' + details.endSN + ']'}, target: ${parseFloat(targetBufferTime.toFixed(3))}`);
        // Don't update nextLoadPosition for fragments which are not buffered
        if ($b941786f4eb9cb76$var$isFiniteNumber(frag.sn) && !this.bitrateTest) this.nextLoadPosition = frag.start + frag.duration;
        this.state = $b941786f4eb9cb76$var$State.FRAG_LOADING;
        // Load key before streaming fragment data
        const dataOnProgress = this.config.progressive && frag.type !== $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE;
        let result;
        if (dataOnProgress && keyLoadingPromise) result = keyLoadingPromise.then((keyLoadedData)=>{
            if (!keyLoadedData || this.fragContextChanged(keyLoadedData.frag)) return null;
            return this.fragmentLoader.load(frag, progressCallback);
        }).catch((error)=>this.handleFragLoadError(error));
        else // load unencrypted fragment data with progress event,
        // or handle fragment result after key and fragment are finished loading
        result = Promise.all([
            this.fragmentLoader.load(frag, dataOnProgress ? progressCallback : undefined),
            keyLoadingPromise
        ]).then(([fragLoadedData])=>{
            if (!dataOnProgress && progressCallback) progressCallback(fragLoadedData);
            return fragLoadedData;
        }).catch((error)=>this.handleFragLoadError(error));
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, {
            frag: frag,
            targetBufferTime: targetBufferTime
        });
        if (this.fragCurrent === null) return Promise.reject(new Error(`frag load aborted, context changed in FRAG_LOADING`));
        return result;
    }
    doFragPartsLoad(frag, fromPart, level, progressCallback) {
        return new Promise((resolve, reject)=>{
            var _level$details;
            const partsLoaded = [];
            const initialPartList = (_level$details = level.details) == null ? void 0 : _level$details.partList;
            const loadPart = (part)=>{
                this.fragmentLoader.loadPart(frag, part, progressCallback).then((partLoadedData)=>{
                    partsLoaded[part.index] = partLoadedData;
                    const loadedPart = partLoadedData.part;
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, partLoadedData);
                    const nextPart = $b941786f4eb9cb76$var$getPartWith(level.details, frag.sn, part.index + 1) || $b941786f4eb9cb76$var$findPart(initialPartList, frag.sn, part.index + 1);
                    if (nextPart) loadPart(nextPart);
                    else return resolve({
                        frag: frag,
                        part: loadedPart,
                        partsLoaded: partsLoaded
                    });
                }).catch(reject);
            };
            loadPart(fromPart);
        });
    }
    handleFragLoadError(error) {
        if ('data' in error) {
            const data = error.data;
            if (data.frag && data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_ABORTED) this.handleFragLoadAborted(data.frag, data.part);
            else if (data.frag && data.type === $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR) {
                data.frag.abortRequests();
                this.resetStartWhenNotLoaded();
                this.resetFragmentLoading(data.frag);
            } else this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, data);
        } else this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
            details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_EXCEPTION,
            err: error,
            error: error,
            fatal: true
        });
        return null;
    }
    _handleTransmuxerFlush(chunkMeta) {
        const context = this.getCurrentContext(chunkMeta);
        if (!context || this.state !== $b941786f4eb9cb76$var$State.PARSING) {
            if (!this.fragCurrent && this.state !== $b941786f4eb9cb76$var$State.STOPPED && this.state !== $b941786f4eb9cb76$var$State.ERROR) this.state = $b941786f4eb9cb76$var$State.IDLE;
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const now = self.performance.now();
        frag.stats.parsing.end = now;
        if (part) part.stats.parsing.end = now;
        // See if part loading should be disabled/enabled based on buffer and playback position.
        const levelDetails = this.getLevelDetails();
        const loadingPartsAtEdge = levelDetails && frag.sn > levelDetails.endSN;
        const shouldLoadParts = loadingPartsAtEdge || this.shouldLoadParts(levelDetails, frag.end);
        if (shouldLoadParts !== this.loadingParts) {
            this.log(`LL-Part loading ${shouldLoadParts ? 'ON' : 'OFF'} after parsing segment ending @${frag.end.toFixed(2)}`);
            this.loadingParts = shouldLoadParts;
        }
        this.updateLevelTiming(frag, part, level, chunkMeta.partial);
    }
    shouldLoadParts(details, bufferEnd) {
        if (this.config.lowLatencyMode) {
            if (!details) return this.loadingParts;
            if (details.partList) {
                var _details$fragmentHint;
                // Buffer must be ahead of first part + duration of parts after last segment
                // and playback must be at or past segment adjacent to part list
                const firstPart = details.partList[0];
                // Loading of VTT subtitle parts is not implemented in subtitle-stream-controller (#7460)
                if (firstPart.fragment.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE) return false;
                const safePartStart = firstPart.end + (((_details$fragmentHint = details.fragmentHint) == null ? void 0 : _details$fragmentHint.duration) || 0);
                if (bufferEnd >= safePartStart) {
                    var _this$media;
                    const playhead = this.hls.hasEnoughToStart ? ((_this$media = this.media) == null ? void 0 : _this$media.currentTime) || this.lastCurrentTime : this.getLoadPosition();
                    if (playhead > firstPart.start - firstPart.fragment.duration) return true;
                }
            }
        }
        return false;
    }
    getCurrentContext(chunkMeta) {
        const { levels: levels, fragCurrent: fragCurrent } = this;
        const { level: levelIndex, sn: sn, part: partIndex } = chunkMeta;
        if (!(levels != null && levels[levelIndex])) {
            this.warn(`Levels object was unset while buffering fragment ${sn} of ${this.playlistLabel()} ${levelIndex}. The current chunk will not be buffered.`);
            return null;
        }
        const level = levels[levelIndex];
        const levelDetails = level.details;
        const part = partIndex > -1 ? $b941786f4eb9cb76$var$getPartWith(levelDetails, sn, partIndex) : null;
        const frag = part ? part.fragment : $b941786f4eb9cb76$var$getFragmentWithSN(levelDetails, sn, fragCurrent);
        if (!frag) return null;
        if (fragCurrent && fragCurrent !== frag) frag.stats = fragCurrent.stats;
        return {
            frag: frag,
            part: part,
            level: level
        };
    }
    bufferFragmentData(data, frag, part, chunkMeta, noBacktracking) {
        if (this.state !== $b941786f4eb9cb76$var$State.PARSING) return;
        const { data1: data1, data2: data2 } = data;
        let buffer = data1;
        if (data2) // Combine the moof + mdat so that we buffer with a single append
        buffer = $b941786f4eb9cb76$var$appendUint8Array(data1, data2);
        if (!buffer.length) return;
        const offsetTimestamp = this.initPTS[frag.cc];
        const offset = offsetTimestamp ? -offsetTimestamp.baseTime / offsetTimestamp.timescale : undefined;
        const segment = {
            type: data.type,
            frag: frag,
            part: part,
            chunkMeta: chunkMeta,
            offset: offset,
            parent: frag.type,
            data: buffer
        };
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDING, segment);
        if (data.dropped && data.independent && !part) {
            if (noBacktracking) return;
            // Clear buffer so that we reload previous segments sequentially if required
            this.flushBufferGap(frag);
        }
    }
    flushBufferGap(frag) {
        const media = this.media;
        if (!media) return;
        // If currentTime is not buffered, clear the back buffer so that we can backtrack as much as needed
        if (!$b941786f4eb9cb76$var$BufferHelper.isBuffered(media, media.currentTime)) {
            this.flushMainBuffer(0, frag.start);
            return;
        }
        // Remove back-buffer without interrupting playback to allow back tracking
        const currentTime = media.currentTime;
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const fragDuration = frag.duration;
        const segmentFraction = Math.min(this.config.maxFragLookUpTolerance * 2, fragDuration * 0.25);
        const start = Math.max(Math.min(frag.start - segmentFraction, bufferInfo.end - segmentFraction), currentTime + segmentFraction);
        if (frag.start - start > segmentFraction) this.flushMainBuffer(start, frag.start);
    }
    getFwdBufferInfo(bufferable, type) {
        var _this$media2;
        const pos = this.getLoadPosition();
        if (!$b941786f4eb9cb76$var$isFiniteNumber(pos)) return null;
        const backwardSeek = this.lastCurrentTime > pos;
        const maxBufferHole = backwardSeek || (_this$media2 = this.media) != null && _this$media2.paused ? 0 : this.config.maxBufferHole;
        return this.getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole);
    }
    getFwdBufferInfoAtPos(bufferable, pos, type, maxBufferHole) {
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(bufferable, pos, maxBufferHole);
        // Workaround flaw in getting forward buffer when maxBufferHole is smaller than gap at current pos
        if (bufferInfo.len === 0 && bufferInfo.nextStart !== undefined) {
            const bufferedFragAtPos = this.fragmentTracker.getBufferedFrag(pos, type);
            if (bufferedFragAtPos && (bufferInfo.nextStart <= bufferedFragAtPos.end || bufferedFragAtPos.gap)) {
                const gapDuration = Math.max(Math.min(bufferInfo.nextStart, bufferedFragAtPos.end) - pos, maxBufferHole);
                return $b941786f4eb9cb76$var$BufferHelper.bufferInfo(bufferable, pos, gapDuration);
            }
        }
        return bufferInfo;
    }
    getMaxBufferLength(levelBitrate) {
        const { config: config } = this;
        let maxBufLen;
        if (levelBitrate) maxBufLen = Math.max(8 * config.maxBufferSize / levelBitrate, config.maxBufferLength);
        else maxBufLen = config.maxBufferLength;
        return Math.min(maxBufLen, config.maxMaxBufferLength);
    }
    reduceMaxBufferLength(threshold, fragDuration) {
        const config = this.config;
        const minLength = Math.max(Math.min(threshold - fragDuration, config.maxBufferLength), fragDuration);
        const reducedLength = Math.max(threshold - fragDuration * 3, config.maxMaxBufferLength / 2, minLength);
        if (reducedLength >= minLength) {
            // reduce max buffer length as it might be too high. we do this to avoid loop flushing ...
            config.maxMaxBufferLength = reducedLength;
            this.warn(`Reduce max buffer length to ${reducedLength}s`);
            return true;
        }
        return false;
    }
    getAppendedFrag(position, playlistType = $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) {
        const fragOrPart = this.fragmentTracker ? this.fragmentTracker.getAppendedFrag(position, playlistType) : null;
        if (fragOrPart && 'fragment' in fragOrPart) return fragOrPart.fragment;
        return fragOrPart;
    }
    getNextFragment(pos, levelDetails) {
        const fragments = levelDetails.fragments;
        const fragLen = fragments.length;
        if (!fragLen) return null;
        // find fragment index, contiguous with end of buffer position
        const { config: config } = this;
        const start = fragments[0].start;
        const canLoadParts = config.lowLatencyMode && !!levelDetails.partList;
        let frag = null;
        if (levelDetails.live) {
            const initialLiveManifestSize = config.initialLiveManifestSize;
            if (fragLen < initialLiveManifestSize) {
                this.warn(`Not enough fragments to start playback (have: ${fragLen}, need: ${initialLiveManifestSize})`);
                return null;
            }
            // The real fragment start times for a live stream are only known after the PTS range for that level is known.
            // In order to discover the range, we load the best matching fragment for that level and demux it.
            // Do not load using live logic if the starting frag is requested - we want to use getFragmentAtPosition() so that
            // we get the fragment matching that start time
            if (!levelDetails.PTSKnown && !this.startFragRequested && this.startPosition === -1 || pos < start) {
                var _frag;
                if (canLoadParts && !this.loadingParts) {
                    this.log(`LL-Part loading ON for initial live fragment`);
                    this.loadingParts = true;
                }
                frag = this.getInitialLiveFragment(levelDetails);
                const mainStart = this.hls.startPosition;
                const liveSyncPosition = this.hls.liveSyncPosition;
                const startPosition = frag ? (mainStart !== -1 && mainStart >= start ? mainStart : liveSyncPosition) || frag.start : pos;
                this.log(`Setting startPosition to ${startPosition} to match start frag at live edge. mainStart: ${mainStart} liveSyncPosition: ${liveSyncPosition} frag.start: ${(_frag = frag) == null ? void 0 : _frag.start}`);
                this.startPosition = this.nextLoadPosition = startPosition;
            }
        } else if (pos <= start) // VoD playlist: if loadPosition before start of playlist, load first fragment
        frag = fragments[0];
        // If we haven't run into any special cases already, just load the fragment most closely matching the requested position
        if (!frag) {
            const end = this.loadingParts ? levelDetails.partEnd : levelDetails.fragmentEnd;
            frag = this.getFragmentAtPosition(pos, end, levelDetails);
        }
        let programFrag = this.filterReplacedPrimary(frag, levelDetails);
        if (!programFrag && frag) {
            const curSNIdx = frag.sn - levelDetails.startSN;
            programFrag = this.filterReplacedPrimary(fragments[curSNIdx + 1] || null, levelDetails);
        }
        return this.mapToInitFragWhenRequired(programFrag);
    }
    isLoopLoading(frag, targetBufferTime) {
        const trackerState = this.fragmentTracker.getState(frag);
        return (trackerState === $b941786f4eb9cb76$var$FragmentState.OK || trackerState === $b941786f4eb9cb76$var$FragmentState.PARTIAL && !!frag.gap) && this.nextLoadPosition > targetBufferTime;
    }
    getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, playlistType, maxBufLen) {
        let nextFragment = null;
        if (frag.gap) {
            nextFragment = this.getNextFragment(this.nextLoadPosition, levelDetails);
            if (nextFragment && !nextFragment.gap && bufferInfo.nextStart) {
                // Media buffered after GAP tags should not make the next buffer timerange exceed forward buffer length
                const nextbufferInfo = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, bufferInfo.nextStart, playlistType, 0);
                if (nextbufferInfo !== null && bufferInfo.len + nextbufferInfo.len >= maxBufLen) {
                    // Returning here might result in not finding an audio and video candiate to skip to
                    const sn = nextFragment.sn;
                    if (this.loopSn !== sn) {
                        this.log(`buffer full after gaps in "${playlistType}" playlist starting at sn: ${sn}`);
                        this.loopSn = sn;
                    }
                    return null;
                }
            }
        }
        this.loopSn = undefined;
        return nextFragment;
    }
    get primaryPrefetch() {
        if ($b941786f4eb9cb76$var$interstitialsEnabled(this.config)) {
            var _this$hls$interstitia;
            const playingInterstitial = (_this$hls$interstitia = this.hls.interstitialsManager) == null || (_this$hls$interstitia = _this$hls$interstitia.playingItem) == null ? void 0 : _this$hls$interstitia.event;
            if (playingInterstitial) return true;
        }
        return false;
    }
    filterReplacedPrimary(frag, details) {
        if (!frag) return frag;
        if ($b941786f4eb9cb76$var$interstitialsEnabled(this.config) && frag.type !== $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE) {
            // Do not load fragments outside the buffering schedule segment
            const interstitials = this.hls.interstitialsManager;
            const bufferingItem = interstitials == null ? void 0 : interstitials.bufferingItem;
            if (bufferingItem) {
                const bufferingInterstitial = bufferingItem.event;
                if (bufferingInterstitial) {
                    // Do not stream fragments while buffering Interstitial Events (except for overlap at the start)
                    if (bufferingInterstitial.appendInPlace || Math.abs(frag.start - bufferingItem.start) > 1 || bufferingItem.start === 0) return null;
                } else {
                    // Limit fragment loading to media in schedule item
                    if (frag.end <= bufferingItem.start && (details == null ? void 0 : details.live) === false) // fragment ends by schedule item start
                    // this.fragmentTracker.fragBuffered(frag, true);
                    return null;
                    if (frag.start > bufferingItem.end && bufferingItem.nextEvent) {
                        // fragment is past schedule item end
                        // allow some overflow when not appending in place to prevent stalls
                        if (bufferingItem.nextEvent.appendInPlace || frag.start - bufferingItem.end > 1) return null;
                    }
                }
            }
            // Skip loading of fragments that overlap completely with appendInPlace interstitials
            const playerQueue = interstitials == null ? void 0 : interstitials.playerQueue;
            if (playerQueue) for(let i = playerQueue.length; i--;){
                const interstitial = playerQueue[i].interstitial;
                if (interstitial.appendInPlace && frag.start >= interstitial.startTime && frag.end <= interstitial.resumeTime) return null;
            }
        }
        return frag;
    }
    mapToInitFragWhenRequired(frag) {
        // If an initSegment is present, it must be buffered first
        if (frag != null && frag.initSegment && !frag.initSegment.data && !this.bitrateTest) return frag.initSegment;
        return frag;
    }
    getNextPart(partList, frag, targetBufferTime) {
        let nextPart = -1;
        let contiguous = false;
        let independentAttrOmitted = true;
        for(let i = 0, len = partList.length; i < len; i++){
            const part = partList[i];
            independentAttrOmitted = independentAttrOmitted && !part.independent;
            if (nextPart > -1 && targetBufferTime < part.start) break;
            const loaded = part.loaded;
            if (loaded) nextPart = -1;
            else if (contiguous || (part.independent || independentAttrOmitted) && part.fragment === frag) {
                if (part.fragment !== frag) this.warn(`Need buffer at ${targetBufferTime} but next unloaded part starts at ${part.start}`);
                nextPart = i;
            }
            contiguous = loaded;
        }
        return nextPart;
    }
    loadedEndOfParts(partList, targetBufferTime) {
        let part;
        for(let i = partList.length; i--;){
            part = partList[i];
            if (!part.loaded) return false;
            if (targetBufferTime > part.start) return true;
        }
        return false;
    }
    /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */ getInitialLiveFragment(levelDetails) {
        const fragments = levelDetails.fragments;
        const fragPrevious = this.fragPrevious;
        let frag = null;
        if (fragPrevious) {
            if (levelDetails.hasProgramDateTime) {
                // Prefer using PDT, because it can be accurate enough to choose the correct fragment without knowing the level sliding
                this.log(`Live playlist, switching playlist, load frag with same PDT: ${fragPrevious.programDateTime}`);
                frag = $b941786f4eb9cb76$var$findFragmentByPDT(fragments, fragPrevious.endProgramDateTime, this.config.maxFragLookUpTolerance);
            }
            if (!frag) {
                // SN does not need to be accurate between renditions, but depending on the packaging it may be so.
                const targetSN = fragPrevious.sn + 1;
                if (targetSN >= levelDetails.startSN && targetSN <= levelDetails.endSN) {
                    const fragNext = fragments[targetSN - levelDetails.startSN];
                    // Ensure that we're staying within the continuity range, since PTS resets upon a new range
                    if (fragPrevious.cc === fragNext.cc) {
                        frag = fragNext;
                        this.log(`Live playlist, switching playlist, load frag with next SN: ${frag.sn}`);
                    }
                }
                // It's important to stay within the continuity range if available; otherwise the fragments in the playlist
                // will have the wrong start times
                if (!frag) {
                    frag = $b941786f4eb9cb76$var$findNearestWithCC(levelDetails, fragPrevious.cc, fragPrevious.end);
                    if (frag) this.log(`Live playlist, switching playlist, load frag with same CC: ${frag.sn}`);
                }
            }
        } else {
            // Find a new start fragment when fragPrevious is null
            const liveStart = this.hls.liveSyncPosition;
            if (liveStart !== null) frag = this.getFragmentAtPosition(liveStart, this.bitrateTest ? levelDetails.fragmentEnd : levelDetails.edge, levelDetails);
        }
        return frag;
    }
    /*
  This method finds the best matching fragment given the provided position.
   */ getFragmentAtPosition(bufferEnd, end, levelDetails) {
        const { config: config } = this;
        let { fragPrevious: fragPrevious } = this;
        let { fragments: fragments, endSN: endSN } = levelDetails;
        const { fragmentHint: fragmentHint } = levelDetails;
        const { maxFragLookUpTolerance: maxFragLookUpTolerance } = config;
        const partList = levelDetails.partList;
        const loadingParts = !!(this.loadingParts && partList != null && partList.length && fragmentHint);
        if (loadingParts && !this.bitrateTest && partList[partList.length - 1].fragment.sn === fragmentHint.sn) {
            // Include incomplete fragment with parts at end
            fragments = fragments.concat(fragmentHint);
            endSN = fragmentHint.sn;
        }
        let frag;
        if (bufferEnd < end) {
            var _this$media3;
            const backwardSeek = bufferEnd < this.lastCurrentTime;
            const lookupTolerance = backwardSeek || bufferEnd > end - maxFragLookUpTolerance || (_this$media3 = this.media) != null && _this$media3.paused || !this.startFragRequested ? 0 : maxFragLookUpTolerance;
            // Remove the tolerance if it would put the bufferEnd past the actual end of stream
            // Uses buffer and sequence number to calculate switch segment (required if using EXT-X-DISCONTINUITY-SEQUENCE)
            frag = $b941786f4eb9cb76$var$findFragmentByPTS(fragPrevious, fragments, bufferEnd, lookupTolerance);
        } else // reach end of playlist
        frag = fragments[fragments.length - 1];
        if (frag) {
            const curSNIdx = frag.sn - levelDetails.startSN;
            // Move fragPrevious forward to support forcing the next fragment to load
            // when the buffer catches up to a previously buffered range.
            const fragState = this.fragmentTracker.getState(frag);
            if (fragState === $b941786f4eb9cb76$var$FragmentState.OK || fragState === $b941786f4eb9cb76$var$FragmentState.PARTIAL && frag.gap) fragPrevious = frag;
            if (fragPrevious && frag.sn === fragPrevious.sn && (!loadingParts || partList[0].fragment.sn > frag.sn || !levelDetails.live)) {
                // Force the next fragment to load if the previous one was already selected. This can occasionally happen with
                // non-uniform fragment durations
                const sameLevel = frag.level === fragPrevious.level;
                if (sameLevel) {
                    const nextFrag = fragments[curSNIdx + 1];
                    if (frag.sn < endSN && this.fragmentTracker.getState(nextFrag) !== $b941786f4eb9cb76$var$FragmentState.OK) frag = nextFrag;
                    else frag = null;
                }
            }
        }
        return frag;
    }
    alignPlaylists(details, previousDetails, switchDetails) {
        // TODO: If not for `shouldAlignOnDiscontinuities` requiring fragPrevious.cc,
        //  this could all go in level-helper mergeDetails()
        const length = details.fragments.length;
        if (!length) {
            this.warn(`No fragments in live playlist`);
            return 0;
        }
        const slidingStart = details.fragmentStart;
        const firstLevelLoad = !previousDetails;
        const aligned = details.alignedSliding && $b941786f4eb9cb76$var$isFiniteNumber(slidingStart);
        if (firstLevelLoad || !aligned && !slidingStart) {
            $b941786f4eb9cb76$var$alignStream(switchDetails, details);
            const alignedSlidingStart = details.fragmentStart;
            this.log(`Live playlist sliding: ${alignedSlidingStart.toFixed(2)} start-sn: ${previousDetails ? previousDetails.startSN : 'na'}->${details.startSN} fragments: ${length}`);
            return alignedSlidingStart;
        }
        return slidingStart;
    }
    waitForCdnTuneIn(details) {
        // Wait for Low-Latency CDN Tune-in to get an updated playlist
        const advancePartLimit = 3;
        return details.live && details.canBlockReload && details.partTarget && details.tuneInGoal > Math.max(details.partHoldBack, details.partTarget * advancePartLimit);
    }
    setStartPosition(details, sliding) {
        // compute start position if set to -1. use it straight away if value is defined
        let startPosition = this.startPosition;
        if (startPosition < sliding) startPosition = -1;
        const timelineOffset = this.timelineOffset;
        if (startPosition === -1) {
            // Use Playlist EXT-X-START:TIME-OFFSET when set
            // Prioritize Multivariant Playlist offset so that main, audio, and subtitle stream-controller start times match
            const offsetInMultivariantPlaylist = this.startTimeOffset !== null;
            const startTimeOffset = offsetInMultivariantPlaylist ? this.startTimeOffset : details.startTimeOffset;
            if (startTimeOffset !== null && $b941786f4eb9cb76$var$isFiniteNumber(startTimeOffset)) {
                startPosition = sliding + startTimeOffset;
                if (startTimeOffset < 0) startPosition += details.edge;
                startPosition = Math.min(Math.max(sliding, startPosition), sliding + details.totalduration);
                this.log(`Setting startPosition to ${startPosition} for start time offset ${startTimeOffset} found in ${offsetInMultivariantPlaylist ? 'multivariant' : 'media'} playlist`);
                this.startPosition = startPosition;
            } else if (details.live) {
                // Leave this.startPosition at -1, so that we can use `getInitialLiveFragment` logic when startPosition has
                // not been specified via the config or an as an argument to startLoad (#3736).
                startPosition = this.hls.liveSyncPosition || sliding;
                this.log(`Setting startPosition to -1 to start at live edge ${startPosition}`);
                this.startPosition = -1;
            } else {
                this.log(`setting startPosition to 0 by default`);
                this.startPosition = startPosition = 0;
            }
            this.lastCurrentTime = startPosition + timelineOffset;
        }
        this.nextLoadPosition = startPosition + timelineOffset;
    }
    getLoadPosition() {
        var _this$hls;
        const { media: media } = this;
        // if we have not yet loaded any fragment, start loading from start position
        let pos = 0;
        if ((_this$hls = this.hls) != null && _this$hls.hasEnoughToStart && media) pos = media.currentTime;
        else if (this.nextLoadPosition >= 0) pos = this.nextLoadPosition;
        return pos;
    }
    handleFragLoadAborted(frag, part) {
        if (this.transmuxer && frag.type === this.playlistType && $b941786f4eb9cb76$var$isMediaFragment(frag) && frag.stats.aborted) {
            this.log(`Fragment ${frag.sn}${part ? ' part ' + part.index : ''} of ${this.playlistLabel()} ${frag.level} was aborted`);
            this.resetFragmentLoading(frag);
        }
    }
    resetFragmentLoading(frag) {
        if (!this.fragCurrent || !this.fragContextChanged(frag) && this.state !== $b941786f4eb9cb76$var$State.FRAG_LOADING_WAITING_RETRY) this.state = $b941786f4eb9cb76$var$State.IDLE;
    }
    onFragmentOrKeyLoadError(filterType, data) {
        var _this$hls$latestLevel;
        if (data.chunkMeta && !data.frag) {
            const context = this.getCurrentContext(data.chunkMeta);
            if (context) data.frag = context.frag;
        }
        const frag = data.frag;
        // Handle frag error related to caller's filterType
        if (!frag || frag.type !== filterType || !this.levels) return;
        if (this.fragContextChanged(frag)) {
            var _this$fragCurrent;
            this.warn(`Frag load error must match current frag to retry ${frag.url} > ${(_this$fragCurrent = this.fragCurrent) == null ? void 0 : _this$fragCurrent.url}`);
            return;
        }
        const gapTagEncountered = data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP;
        if (gapTagEncountered) this.fragmentTracker.fragBuffered(frag, true);
        // keep retrying until the limit will be reached
        const errorAction = data.errorAction;
        if (!errorAction) {
            this.state = $b941786f4eb9cb76$var$State.ERROR;
            return;
        }
        const { action: action, flags: flags, retryCount: retryCount = 0, retryConfig: retryConfig } = errorAction;
        const couldRetry = !!retryConfig;
        const retry = couldRetry && action === $b941786f4eb9cb76$export$679390c50dd617e4.RetryRequest;
        const noAlternate = couldRetry && !errorAction.resolved && flags === $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost;
        const live = (_this$hls$latestLevel = this.hls.latestLevelDetails) == null ? void 0 : _this$hls$latestLevel.live;
        if (!retry && noAlternate && $b941786f4eb9cb76$var$isMediaFragment(frag) && !frag.endList && live && !$b941786f4eb9cb76$var$isUnusableKeyError(data)) {
            this.resetFragmentErrors(filterType);
            this.treatAsGap(frag);
            errorAction.resolved = true;
        } else if ((retry || noAlternate) && retryCount < retryConfig.maxNumRetry) {
            var _data$response;
            const offlineStatus = $b941786f4eb9cb76$var$offlineHttpStatus((_data$response = data.response) == null ? void 0 : _data$response.code);
            const delay = $b941786f4eb9cb76$var$getRetryDelay(retryConfig, retryCount);
            this.resetStartWhenNotLoaded();
            this.retryDate = self.performance.now() + delay;
            this.state = $b941786f4eb9cb76$var$State.FRAG_LOADING_WAITING_RETRY;
            errorAction.resolved = true;
            if (offlineStatus) {
                this.log(`Waiting for connection (offline)`);
                this.retryDate = Infinity;
                data.reason = 'offline';
                return;
            }
            this.warn(`Fragment ${frag.sn} of ${filterType} ${frag.level} errored with ${data.details}, retrying loading ${retryCount + 1}/${retryConfig.maxNumRetry} in ${delay}ms`);
        } else if (retryConfig) {
            this.resetFragmentErrors(filterType);
            if (retryCount < retryConfig.maxNumRetry) // Network retry is skipped when level switch is preferred
            {
                if (!gapTagEncountered && action !== $b941786f4eb9cb76$export$679390c50dd617e4.RemoveAlternatePermanently) errorAction.resolved = true;
            } else {
                this.warn(`${data.details} reached or exceeded max retry (${retryCount})`);
                return;
            }
        } else if (action === $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox) this.state = $b941786f4eb9cb76$var$State.WAITING_LEVEL;
        else this.state = $b941786f4eb9cb76$var$State.ERROR;
        // Perform next async tick sooner to speed up error action resolution
        this.tickImmediate();
    }
    checkRetryDate() {
        const now = self.performance.now();
        const retryDate = this.retryDate;
        // if current time is gt than retryDate, or if media seeking let's switch to IDLE state to retry loading
        const waitingForConnection = retryDate === Infinity;
        if (!retryDate || now >= retryDate || waitingForConnection && !$b941786f4eb9cb76$var$offlineHttpStatus(0)) {
            if (waitingForConnection) this.log(`Connection restored (online)`);
            this.resetStartWhenNotLoaded();
            this.state = $b941786f4eb9cb76$var$State.IDLE;
        }
    }
    reduceLengthAndFlushBuffer(data) {
        // if in appending state
        if (this.state === $b941786f4eb9cb76$var$State.PARSING || this.state === $b941786f4eb9cb76$var$State.PARSED) {
            const frag = data.frag;
            const playlistType = data.parent;
            const bufferedInfo = this.getFwdBufferInfo(this.mediaBuffer, playlistType);
            // 0.5 : tolerance needed as some browsers stalls playback before reaching buffered end
            // reduce max buf len if current position is buffered
            const buffered = bufferedInfo && bufferedInfo.len > 0.5;
            if (buffered) this.reduceMaxBufferLength(bufferedInfo.len, (frag == null ? void 0 : frag.duration) || 10);
            const flushBuffer = !buffered;
            if (flushBuffer) // current position is not buffered, but browser is still complaining about buffer full error
            // this happens on IE/Edge, refer to https://github.com/video-dev/hls.js/pull/708
            // in that case flush the whole audio buffer to recover
            this.warn(`Buffer full error while media.currentTime (${this.getLoadPosition()}) is not buffered, flush ${playlistType} buffer`);
            if (frag) {
                this.fragmentTracker.removeFragment(frag);
                this.nextLoadPosition = frag.start;
            }
            this.resetLoadingState();
            return flushBuffer;
        }
        return false;
    }
    resetFragmentErrors(filterType) {
        if (filterType === $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO) // Reset current fragment since audio track audio is essential and may not have a fail-over track
        this.fragCurrent = null;
        // Fragment errors that result in a level switch or redundant fail-over
        // should reset the stream controller state to idle
        if (!this.hls.hasEnoughToStart) this.startFragRequested = false;
        if (this.state !== $b941786f4eb9cb76$var$State.STOPPED) this.state = $b941786f4eb9cb76$var$State.IDLE;
    }
    afterBufferFlushed(media, bufferType, playlistType) {
        if (!media) return;
        // After successful buffer flushing, filter flushed fragments from bufferedFrags use mediaBuffered instead of media
        // (so that we will check against video.buffered ranges in case of alt audio track)
        const bufferedTimeRanges = $b941786f4eb9cb76$var$BufferHelper.getBuffered(media);
        this.fragmentTracker.detectEvictedFragments(bufferType, bufferedTimeRanges, playlistType);
        if (this.state === $b941786f4eb9cb76$var$State.ENDED) this.resetLoadingState();
    }
    resetLoadingState() {
        this.log('Reset loading state');
        this.fragCurrent = null;
        this.fragPrevious = null;
        if (this.state !== $b941786f4eb9cb76$var$State.STOPPED) this.state = $b941786f4eb9cb76$var$State.IDLE;
    }
    resetStartWhenNotLoaded() {
        // if loadedmetadata is not set, it means that first frag request failed
        // in that case, reset startFragRequested flag
        if (!this.hls.hasEnoughToStart) {
            this.startFragRequested = false;
            const level = this.levelLastLoaded;
            const details = level ? level.details : null;
            if (details != null && details.live) {
                // Update the start position and return to IDLE to recover live start
                this.log(`resetting startPosition for live start`);
                this.startPosition = -1;
                this.setStartPosition(details, details.fragmentStart);
                this.resetLoadingState();
            } else this.nextLoadPosition = this.startPosition;
        }
    }
    resetWhenMissingContext(chunkMeta) {
        this.log(`Loading context changed while buffering sn ${chunkMeta.sn} of ${this.playlistLabel()} ${chunkMeta.level === -1 ? '<removed>' : chunkMeta.level}. This chunk will not be buffered.`);
        this.removeUnbufferedFrags();
        this.resetStartWhenNotLoaded();
        this.resetLoadingState();
    }
    removeUnbufferedFrags(start = 0) {
        this.fragmentTracker.removeFragmentsInRange(start, Infinity, this.playlistType, false, true);
    }
    updateLevelTiming(frag, part, level, partial) {
        const details = level.details;
        if (!details) {
            this.warn('level.details undefined');
            return;
        }
        const parsed = Object.keys(frag.elementaryStreams).reduce((result, type)=>{
            const info = frag.elementaryStreams[type];
            if (info) {
                const parsedDuration = info.endPTS - info.startPTS;
                if (parsedDuration <= 0) {
                    // Destroy the transmuxer after it's next time offset failed to advance because duration was <= 0.
                    // The new transmuxer will be configured with a time offset matching the next fragment start,
                    // preventing the timeline from shifting.
                    this.warn(`Could not parse fragment ${frag.sn} ${type} duration reliably (${parsedDuration})`);
                    return result || false;
                }
                const drift = partial ? 0 : $b941786f4eb9cb76$var$updateFragPTSDTS(details, frag, info.startPTS, info.endPTS, info.startDTS, info.endDTS, this);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_PTS_UPDATED, {
                    details: details,
                    level: level,
                    drift: drift,
                    type: type,
                    frag: frag,
                    start: info.startPTS,
                    end: info.endPTS
                });
                return true;
            }
            return result;
        }, false);
        if (!parsed) {
            var _this$transmuxer;
            const mediaNotFound = ((_this$transmuxer = this.transmuxer) == null ? void 0 : _this$transmuxer.error) === null;
            if (level.fragmentError === 0 || mediaNotFound && (level.fragmentError < 2 || frag.endList)) // Mark and track the odd (or last) empty segment as a gap to avoid reloading
            this.treatAsGap(frag, level);
            if (mediaNotFound) {
                const error = new Error(`Found no media in fragment ${frag.sn} of ${this.playlistLabel()} ${frag.level} resetting transmuxer to fallback to playlist timing`);
                this.warn(error.message);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
                    fatal: false,
                    error: error,
                    frag: frag,
                    reason: `Found no media in msn ${frag.sn} of ${this.playlistLabel()} "${level.url}"`
                });
                if (!this.hls) return;
                this.resetTransmuxer();
            }
        // For this error fallthrough. Marking parsed will allow advancing to next fragment.
        }
        this.state = $b941786f4eb9cb76$var$State.PARSED;
        this.log(`Parsed ${frag.type} sn: ${frag.sn}${part ? ' part: ' + part.index : ''} of ${this.fragInfo(frag, false, part)})`);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSED, {
            frag: frag,
            part: part
        });
    }
    playlistLabel() {
        return this.playlistType === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN ? 'level' : 'track';
    }
    fragInfo(frag, pts = true, part) {
        var _ref, _ref2;
        return `${this.playlistLabel()} ${frag.level} (${part ? 'part' : 'frag'}:[${((_ref = pts && !part ? frag.startPTS : (part || frag).start) != null ? _ref : NaN).toFixed(3)}-${((_ref2 = pts && !part ? frag.endPTS : (part || frag).end) != null ? _ref2 : NaN).toFixed(3)}]${part && frag.type === 'main' ? 'INDEPENDENT=' + (part.independent ? 'YES' : 'NO') : ''}`;
    }
    treatAsGap(frag, level) {
        if (level) level.fragmentError++;
        frag.gap = true;
        this.fragmentTracker.removeFragment(frag);
        this.fragmentTracker.fragBuffered(frag, true);
    }
    resetTransmuxer() {
        var _this$transmuxer2;
        (_this$transmuxer2 = this.transmuxer) == null || _this$transmuxer2.reset();
    }
    recoverWorkerError(data) {
        if (data.event === 'demuxerWorker') {
            this.fragmentTracker.removeAllFragments();
            if (this.transmuxer) {
                this.transmuxer.destroy();
                this.transmuxer = null;
            }
            this.resetStartWhenNotLoaded();
            this.resetLoadingState();
        }
    }
    set state(nextState) {
        const previousState = this._state;
        if (previousState !== nextState) {
            this._state = nextState;
            this.log(`${previousState}->${nextState}`);
        }
    }
    get state() {
        return this._state;
    }
}
function $b941786f4eb9cb76$var$interstitialsEnabled(config) {
    return !!config.interstitialsController && config.enableInterstitialPlayback !== false;
}
class $b941786f4eb9cb76$var$ChunkCache {
    constructor(){
        this.chunks = [];
        this.dataLength = 0;
    }
    push(chunk) {
        this.chunks.push(chunk);
        this.dataLength += chunk.length;
    }
    flush() {
        const { chunks: chunks, dataLength: dataLength } = this;
        let result;
        if (!chunks.length) return new Uint8Array(0);
        else if (chunks.length === 1) result = chunks[0];
        else result = $b941786f4eb9cb76$var$concatUint8Arrays(chunks, dataLength);
        this.reset();
        return result;
    }
    reset() {
        this.chunks.length = 0;
        this.dataLength = 0;
    }
}
function $b941786f4eb9cb76$var$concatUint8Arrays(chunks, dataLength) {
    const result = new Uint8Array(dataLength);
    let offset = 0;
    for(let i = 0; i < chunks.length; i++){
        const chunk = chunks[i];
        result.set(chunk, offset);
        offset += chunk.length;
    }
    return result;
}
var $b941786f4eb9cb76$var$eventemitter3 = {
    exports: {}
};
var $b941786f4eb9cb76$var$hasRequiredEventemitter3;
function $b941786f4eb9cb76$var$requireEventemitter3() {
    if ($b941786f4eb9cb76$var$hasRequiredEventemitter3) return $b941786f4eb9cb76$var$eventemitter3.exports;
    $b941786f4eb9cb76$var$hasRequiredEventemitter3 = 1;
    (function(module) {
        var has = Object.prototype.hasOwnProperty, prefix = '~';
        /**
		 * Constructor to create a storage for our `EE` objects.
		 * An `Events` instance is a plain object whose properties are event names.
		 *
		 * @constructor
		 * @private
		 */ function Events() {}
        //
        // We try to not inherit from `Object.prototype`. In some engines creating an
        // instance in this way is faster than calling `Object.create(null)` directly.
        // If `Object.create(null)` is not supported we prefix the event names with a
        // character to make sure that the built-in object properties are not
        // overridden or used as an attack vector.
        //
        if (Object.create) {
            Events.prototype = Object.create(null);
            //
            // This hack is needed because the `__proto__` property is still inherited in
            // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
            //
            if (!new Events().__proto__) prefix = false;
        }
        /**
		 * Representation of a single event listener.
		 *
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
		 * @constructor
		 * @private
		 */ function EE(fn, context, once) {
            this.fn = fn;
            this.context = context;
            this.once = once || false;
        }
        /**
		 * Add a listener for a given event.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} context The context to invoke the listener with.
		 * @param {Boolean} once Specify if the listener is a one-time listener.
		 * @returns {EventEmitter}
		 * @private
		 */ function addListener(emitter, event, fn, context, once) {
            if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
            var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
            if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
            else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
            else emitter._events[evt] = [
                emitter._events[evt],
                listener
            ];
            return emitter;
        }
        /**
		 * Clear event by name.
		 *
		 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
		 * @param {(String|Symbol)} evt The Event name.
		 * @private
		 */ function clearEvent(emitter, evt) {
            if (--emitter._eventsCount === 0) emitter._events = new Events();
            else delete emitter._events[evt];
        }
        /**
		 * Minimal `EventEmitter` interface that is molded against the Node.js
		 * `EventEmitter` interface.
		 *
		 * @constructor
		 * @public
		 */ function EventEmitter() {
            this._events = new Events();
            this._eventsCount = 0;
        }
        /**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @public
		 */ EventEmitter.prototype.eventNames = function eventNames() {
            var names = [], events, name;
            if (this._eventsCount === 0) return names;
            for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
            if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
            return names;
        };
        /**
		 * Return the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Array} The registered listeners.
		 * @public
		 */ EventEmitter.prototype.listeners = function listeners(event) {
            var evt = prefix ? prefix + event : event, handlers = this._events[evt];
            if (!handlers) return [];
            if (handlers.fn) return [
                handlers.fn
            ];
            for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
            return ee;
        };
        /**
		 * Return the number of listeners listening to a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Number} The number of listeners.
		 * @public
		 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
            var evt = prefix ? prefix + event : event, listeners = this._events[evt];
            if (!listeners) return 0;
            if (listeners.fn) return 1;
            return listeners.length;
        };
        /**
		 * Calls each of the listeners registered for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @returns {Boolean} `true` if the event had listeners, else `false`.
		 * @public
		 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return false;
            var listeners = this._events[evt], len = arguments.length, args, i;
            if (listeners.fn) {
                if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
                switch(len){
                    case 1:
                        return listeners.fn.call(listeners.context), true;
                    case 2:
                        return listeners.fn.call(listeners.context, a1), true;
                    case 3:
                        return listeners.fn.call(listeners.context, a1, a2), true;
                    case 4:
                        return listeners.fn.call(listeners.context, a1, a2, a3), true;
                    case 5:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
                    case 6:
                        return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
                }
                for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
                listeners.fn.apply(listeners.context, args);
            } else {
                var length = listeners.length, j;
                for(i = 0; i < length; i++){
                    if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
                    switch(len){
                        case 1:
                            listeners[i].fn.call(listeners[i].context);
                            break;
                        case 2:
                            listeners[i].fn.call(listeners[i].context, a1);
                            break;
                        case 3:
                            listeners[i].fn.call(listeners[i].context, a1, a2);
                            break;
                        case 4:
                            listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                            break;
                        default:
                            if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                            listeners[i].fn.apply(listeners[i].context, args);
                    }
                }
            }
            return true;
        };
        /**
		 * Add a listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.on = function on(event, fn, context) {
            return addListener(this, event, fn, context, false);
        };
        /**
		 * Add a one-time listener for a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn The listener function.
		 * @param {*} [context=this] The context to invoke the listener with.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.once = function once(event, fn, context) {
            return addListener(this, event, fn, context, true);
        };
        /**
		 * Remove the listeners of a given event.
		 *
		 * @param {(String|Symbol)} event The event name.
		 * @param {Function} fn Only remove the listeners that match this function.
		 * @param {*} context Only remove the listeners that have this context.
		 * @param {Boolean} once Only remove one-time listeners.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
            var evt = prefix ? prefix + event : event;
            if (!this._events[evt]) return this;
            if (!fn) {
                clearEvent(this, evt);
                return this;
            }
            var listeners = this._events[evt];
            if (listeners.fn) {
                if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
            } else {
                for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
                //
                // Reset the array, or remove it completely if we have no more listeners.
                //
                if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
                else clearEvent(this, evt);
            }
            return this;
        };
        /**
		 * Remove all listeners, or those of the specified event.
		 *
		 * @param {(String|Symbol)} [event] The event name.
		 * @returns {EventEmitter} `this`.
		 * @public
		 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
            var evt;
            if (event) {
                evt = prefix ? prefix + event : event;
                if (this._events[evt]) clearEvent(this, evt);
            } else {
                this._events = new Events();
                this._eventsCount = 0;
            }
            return this;
        };
        //
        // Alias methods names because people roll like that.
        //
        EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
        EventEmitter.prototype.addListener = EventEmitter.prototype.on;
        //
        // Expose the prefix.
        //
        EventEmitter.prefixed = prefix;
        //
        // Allow `EventEmitter` to be imported as module namespace.
        //
        EventEmitter.EventEmitter = EventEmitter;
        module.exports = EventEmitter;
    })($b941786f4eb9cb76$var$eventemitter3);
    return $b941786f4eb9cb76$var$eventemitter3.exports;
}
var $b941786f4eb9cb76$var$eventemitter3Exports = $b941786f4eb9cb76$var$requireEventemitter3();
var $b941786f4eb9cb76$var$EventEmitter = /*@__PURE__*/ $b941786f4eb9cb76$var$getDefaultExportFromCjs($b941786f4eb9cb76$var$eventemitter3Exports);
const $b941786f4eb9cb76$var$version = "1.6.15";
// ensure the worker ends up in the bundle
// If the worker should not be included this gets aliased to empty.js
const $b941786f4eb9cb76$var$workerStore = {};
function $b941786f4eb9cb76$var$hasUMDWorker() {
    return typeof __HLS_WORKER_BUNDLE__ === 'function';
}
function $b941786f4eb9cb76$var$injectWorker() {
    const workerContext = $b941786f4eb9cb76$var$workerStore[$b941786f4eb9cb76$var$version];
    if (workerContext) {
        workerContext.clientCount++;
        return workerContext;
    }
    const blob = new self.Blob([
        `var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`
    ], {
        type: 'text/javascript'
    });
    const objectURL = self.URL.createObjectURL(blob);
    const worker = new self.Worker(objectURL);
    const result = {
        worker: worker,
        objectURL: objectURL,
        clientCount: 1
    };
    $b941786f4eb9cb76$var$workerStore[$b941786f4eb9cb76$var$version] = result;
    return result;
}
function $b941786f4eb9cb76$var$loadWorker(path) {
    const workerContext = $b941786f4eb9cb76$var$workerStore[path];
    if (workerContext) {
        workerContext.clientCount++;
        return workerContext;
    }
    const scriptURL = new self.URL(path, self.location.href).href;
    const worker = new self.Worker(scriptURL);
    const result = {
        worker: worker,
        scriptURL: scriptURL,
        clientCount: 1
    };
    $b941786f4eb9cb76$var$workerStore[path] = result;
    return result;
}
function $b941786f4eb9cb76$var$removeWorkerFromStore(path) {
    const workerContext = $b941786f4eb9cb76$var$workerStore[path || $b941786f4eb9cb76$var$version];
    if (workerContext) {
        const clientCount = workerContext.clientCount--;
        if (clientCount === 1) {
            const { worker: worker, objectURL: objectURL } = workerContext;
            delete $b941786f4eb9cb76$var$workerStore[path || $b941786f4eb9cb76$var$version];
            if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
            self.URL.revokeObjectURL(objectURL);
            worker.terminate();
        }
    }
}
/**
 * Returns true if an ID3 footer can be found at offset in data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns `true` if an ID3 footer is found
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$isId3Footer(data, offset) {
    /*
   * The footer is a copy of the header, but with a different identifier
   */ if (offset + 10 <= data.length) {
        // look for '3DI' identifier
        if (data[offset] === 0x33 && data[offset + 1] === 0x44 && data[offset + 2] === 0x49) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
}
/**
 * Returns true if an ID3 header can be found at offset in data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns `true` if an ID3 header is found
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$isId3Header(data, offset) {
    /*
   * http://id3.org/id3v2.3.0
   * [0]     = 'I'
   * [1]     = 'D'
   * [2]     = '3'
   * [3,4]   = {Version}
   * [5]     = {Flags}
   * [6-9]   = {ID3 Size}
   *
   * An ID3v2 tag can be detected with the following pattern:
   *  $49 44 33 yy yy xx zz zz zz zz
   * Where yy is less than $FF, xx is the 'flags' byte and zz is less than $80
   */ if (offset + 10 <= data.length) {
        // look for 'ID3' identifier
        if (data[offset] === 0x49 && data[offset + 1] === 0x44 && data[offset + 2] === 0x33) // check version is within range
        {
            if (data[offset + 3] < 0xff && data[offset + 4] < 0xff) {
                // check size is within range
                if (data[offset + 6] < 0x80 && data[offset + 7] < 0x80 && data[offset + 8] < 0x80 && data[offset + 9] < 0x80) return true;
            }
        }
    }
    return false;
}
/**
 * Read ID3 size
 *
 * @param data - The data to read from
 * @param offset - The offset at which to start reading
 *
 * @returns The size
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$readId3Size(data, offset) {
    let size = 0;
    size = (data[offset] & 0x7f) << 21;
    size |= (data[offset + 1] & 0x7f) << 14;
    size |= (data[offset + 2] & 0x7f) << 7;
    size |= data[offset + 3] & 0x7f;
    return size;
}
/**
 * Returns any adjacent ID3 tags found in data starting at offset, as one block of data
 *
 * @param data - The data to search in
 * @param offset - The offset at which to start searching
 *
 * @returns The block of data containing any ID3 tags found
 * or `undefined` if no header is found at the starting offset
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$getId3Data(data, offset) {
    const front = offset;
    let length = 0;
    while($b941786f4eb9cb76$var$isId3Header(data, offset)){
        // ID3 header is 10 bytes
        length += 10;
        const size = $b941786f4eb9cb76$var$readId3Size(data, offset + 6);
        length += size;
        if ($b941786f4eb9cb76$var$isId3Footer(data, offset + 10)) // ID3 footer is 10 bytes
        length += 10;
        offset += length;
    }
    if (length > 0) return data.subarray(front, front + length);
    return undefined;
}
function $b941786f4eb9cb76$var$getAudioConfig(observer, data, offset, manifestCodec) {
    const adtsSamplingRates = [
        96000,
        88200,
        64000,
        48000,
        44100,
        32000,
        24000,
        22050,
        16000,
        12000,
        11025,
        8000,
        7350
    ];
    const byte2 = data[offset + 2];
    const adtsSamplingIndex = byte2 >> 2 & 0xf;
    if (adtsSamplingIndex > 12) {
        const error = new Error(`invalid ADTS sampling index:${adtsSamplingIndex}`);
        observer.emit($b941786f4eb9cb76$export$ada873a34909da65.ERROR, $b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
            details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
            fatal: true,
            error: error,
            reason: error.message
        });
        return;
    }
    // MPEG-4 Audio Object Type (profile_ObjectType+1)
    const adtsObjectType = (byte2 >> 6 & 0x3) + 1;
    const channelCount = data[offset + 3] >> 6 & 0x3 | (byte2 & 1) << 2;
    const codec = 'mp4a.40.' + adtsObjectType;
    /* refer to http://wiki.multimedia.cx/index.php?title=MPEG-4_Audio#Audio_Specific_Config
      ISO/IEC 14496-3 - Table 1.13 — Syntax of AudioSpecificConfig()
    Audio Profile / Audio Object Type
    0: Null
    1: AAC Main
    2: AAC LC (Low Complexity)
    3: AAC SSR (Scalable Sample Rate)
    4: AAC LTP (Long Term Prediction)
    5: SBR (Spectral Band Replication)
    6: AAC Scalable
   sampling freq
    0: 96000 Hz
    1: 88200 Hz
    2: 64000 Hz
    3: 48000 Hz
    4: 44100 Hz
    5: 32000 Hz
    6: 24000 Hz
    7: 22050 Hz
    8: 16000 Hz
    9: 12000 Hz
    10: 11025 Hz
    11: 8000 Hz
    12: 7350 Hz
    13: Reserved
    14: Reserved
    15: frequency is written explictly
    Channel Configurations
    These are the channel configurations:
    0: Defined in AOT Specifc Config
    1: 1 channel: front-center
    2: 2 channels: front-left, front-right
  */ // audioObjectType = profile => profile, the MPEG-4 Audio Object Type minus 1
    const samplerate = adtsSamplingRates[adtsSamplingIndex];
    let aacSampleIndex = adtsSamplingIndex;
    if (adtsObjectType === 5 || adtsObjectType === 29) // HE-AAC uses SBR (Spectral Band Replication) , high frequencies are constructed from low frequencies
    // there is a factor 2 between frame sample rate and output sample rate
    // multiply frequency by 2 (see table above, equivalent to substract 3)
    aacSampleIndex -= 3;
    const config = [
        adtsObjectType << 3 | (aacSampleIndex & 0x0e) >> 1,
        (aacSampleIndex & 0x01) << 7 | channelCount << 3
    ];
    $b941786f4eb9cb76$var$logger.log(`manifest codec:${manifestCodec}, parsed codec:${codec}, channels:${channelCount}, rate:${samplerate} (ADTS object type:${adtsObjectType} sampling index:${adtsSamplingIndex})`);
    return {
        config: config,
        samplerate: samplerate,
        channelCount: channelCount,
        codec: codec,
        parsedCodec: codec,
        manifestCodec: manifestCodec
    };
}
function $b941786f4eb9cb76$var$isHeaderPattern$1(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xf6) === 0xf0;
}
function $b941786f4eb9cb76$var$getHeaderLength(data, offset) {
    return data[offset + 1] & 0x01 ? 7 : 9;
}
function $b941786f4eb9cb76$var$getFullFrameLength(data, offset) {
    return (data[offset + 3] & 0x03) << 11 | data[offset + 4] << 3 | (data[offset + 5] & 0xe0) >>> 5;
}
function $b941786f4eb9cb76$var$canGetFrameLength(data, offset) {
    return offset + 5 < data.length;
}
function $b941786f4eb9cb76$var$isHeader$1(data, offset) {
    // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
    // Layer bits (position 14 and 15) in header should be always 0 for ADTS
    // More info https://wiki.multimedia.cx/index.php?title=ADTS
    return offset + 1 < data.length && $b941786f4eb9cb76$var$isHeaderPattern$1(data, offset);
}
function $b941786f4eb9cb76$var$canParse$1(data, offset) {
    return $b941786f4eb9cb76$var$canGetFrameLength(data, offset) && $b941786f4eb9cb76$var$isHeaderPattern$1(data, offset) && $b941786f4eb9cb76$var$getFullFrameLength(data, offset) <= data.length - offset;
}
function $b941786f4eb9cb76$var$probe$1(data, offset) {
    // same as isHeader but we also check that ADTS frame follows last ADTS frame
    // or end of data is reached
    if ($b941786f4eb9cb76$var$isHeader$1(data, offset)) {
        // ADTS header Length
        const headerLength = $b941786f4eb9cb76$var$getHeaderLength(data, offset);
        if (offset + headerLength >= data.length) return false;
        // ADTS frame Length
        const frameLength = $b941786f4eb9cb76$var$getFullFrameLength(data, offset);
        if (frameLength <= headerLength) return false;
        const newOffset = offset + frameLength;
        return newOffset === data.length || $b941786f4eb9cb76$var$isHeader$1(data, newOffset);
    }
    return false;
}
function $b941786f4eb9cb76$var$initTrackConfig(track, observer, data, offset, audioCodec) {
    if (!track.samplerate) {
        const config = $b941786f4eb9cb76$var$getAudioConfig(observer, data, offset, audioCodec);
        if (!config) return;
        $b941786f4eb9cb76$var$_extends(track, config);
    }
}
function $b941786f4eb9cb76$var$getFrameDuration(samplerate) {
    return 92160000 / samplerate;
}
function $b941786f4eb9cb76$var$parseFrameHeader(data, offset) {
    // The protection skip bit tells us if we have 2 bytes of CRC data at the end of the ADTS header
    const headerLength = $b941786f4eb9cb76$var$getHeaderLength(data, offset);
    if (offset + headerLength <= data.length) {
        // retrieve frame size
        const frameLength = $b941786f4eb9cb76$var$getFullFrameLength(data, offset) - headerLength;
        if (frameLength > 0) // logger.log(`AAC frame, offset/length/total/pts:${offset+headerLength}/${frameLength}/${data.byteLength}`);
        return {
            headerLength: headerLength,
            frameLength: frameLength
        };
    }
}
function $b941786f4eb9cb76$var$appendFrame$2(track, data, offset, pts, frameIndex) {
    const frameDuration = $b941786f4eb9cb76$var$getFrameDuration(track.samplerate);
    const stamp = pts + frameIndex * frameDuration;
    const header = $b941786f4eb9cb76$var$parseFrameHeader(data, offset);
    let unit;
    if (header) {
        const { frameLength: frameLength, headerLength: headerLength } = header;
        const _length = headerLength + frameLength;
        const missing = Math.max(0, offset + _length - data.length);
        // logger.log(`AAC frame ${frameIndex}, pts:${stamp} length@offset/total: ${frameLength}@${offset+headerLength}/${data.byteLength} missing: ${missing}`);
        if (missing) {
            unit = new Uint8Array(_length - headerLength);
            unit.set(data.subarray(offset + headerLength, data.length), 0);
        } else unit = data.subarray(offset + headerLength, offset + _length);
        const _sample = {
            unit: unit,
            pts: stamp
        };
        if (!missing) track.samples.push(_sample);
        return {
            sample: _sample,
            length: _length,
            missing: missing
        };
    }
    // overflow incomplete header
    const length = data.length - offset;
    unit = new Uint8Array(length);
    unit.set(data.subarray(offset, data.length), 0);
    const sample = {
        unit: unit,
        pts: stamp
    };
    return {
        sample: sample,
        length: length,
        missing: -1
    };
}
/**
 * Checks if the given data contains an ID3 tag.
 *
 * @param data - The data to check
 * @param offset - The offset at which to start checking
 *
 * @returns `true` if an ID3 tag is found
 *
 * @group ID3
 *
 * @beta
 */ function $b941786f4eb9cb76$var$canParseId3(data, offset) {
    return $b941786f4eb9cb76$var$isId3Header(data, offset) && $b941786f4eb9cb76$var$readId3Size(data, offset + 6) + 10 <= data.length - offset;
}
function $b941786f4eb9cb76$var$toArrayBuffer(view) {
    if (view instanceof ArrayBuffer) return view;
    else {
        if (view.byteOffset == 0 && view.byteLength == view.buffer.byteLength) // This is a TypedArray over the whole buffer.
        return view.buffer;
        // This is a 'view' on the buffer.  Create a new buffer that only contains
        // the data.  Note that since this isn't an ArrayBuffer, the 'new' call
        // will allocate a new buffer to hold the copy.
        return new Uint8Array(view).buffer;
    }
}
function $b941786f4eb9cb76$var$toUint8(data, offset = 0, length = Infinity) {
    return $b941786f4eb9cb76$var$view(data, offset, length, Uint8Array);
}
function $b941786f4eb9cb76$var$view(data, offset, length, Type) {
    const buffer = $b941786f4eb9cb76$var$unsafeGetArrayBuffer(data);
    let bytesPerElement = 1;
    if ('BYTES_PER_ELEMENT' in Type) bytesPerElement = Type.BYTES_PER_ELEMENT;
    // Absolute end of the |data| view within |buffer|.
    const dataOffset = $b941786f4eb9cb76$var$isArrayBufferView(data) ? data.byteOffset : 0;
    const dataEnd = (dataOffset + data.byteLength) / bytesPerElement;
    // Absolute start of the result within |buffer|.
    const rawStart = (dataOffset + offset) / bytesPerElement;
    const start = Math.floor(Math.max(0, Math.min(rawStart, dataEnd)));
    // Absolute end of the result within |buffer|.
    const end = Math.floor(Math.min(start + Math.max(length, 0), dataEnd));
    return new Type(buffer, start, end - start);
}
function $b941786f4eb9cb76$var$unsafeGetArrayBuffer(view) {
    if (view instanceof ArrayBuffer) return view;
    else return view.buffer;
}
function $b941786f4eb9cb76$var$isArrayBufferView(obj) {
    return obj && obj.buffer instanceof ArrayBuffer && obj.byteLength !== undefined && obj.byteOffset !== undefined;
}
function $b941786f4eb9cb76$var$decodeId3ImageFrame(frame) {
    const metadataFrame = {
        key: frame.type,
        description: '',
        data: '',
        mimeType: null,
        pictureType: null
    };
    const utf8Encoding = 0x03;
    if (frame.size < 2) return undefined;
    if (frame.data[0] !== utf8Encoding) {
        console.log("Ignore frame with unrecognized character encoding");
        return undefined;
    }
    const mimeTypeEndIndex = frame.data.subarray(1).indexOf(0);
    if (mimeTypeEndIndex === -1) return undefined;
    const mimeType = $b941786f4eb9cb76$var$utf8ArrayToStr($b941786f4eb9cb76$var$toUint8(frame.data, 1, mimeTypeEndIndex));
    const pictureType = frame.data[2 + mimeTypeEndIndex];
    const descriptionEndIndex = frame.data.subarray(3 + mimeTypeEndIndex).indexOf(0);
    if (descriptionEndIndex === -1) return undefined;
    const description = $b941786f4eb9cb76$var$utf8ArrayToStr($b941786f4eb9cb76$var$toUint8(frame.data, 3 + mimeTypeEndIndex, descriptionEndIndex));
    let data;
    if (mimeType === '-->') data = $b941786f4eb9cb76$var$utf8ArrayToStr($b941786f4eb9cb76$var$toUint8(frame.data, 4 + mimeTypeEndIndex + descriptionEndIndex));
    else data = $b941786f4eb9cb76$var$toArrayBuffer(frame.data.subarray(4 + mimeTypeEndIndex + descriptionEndIndex));
    metadataFrame.mimeType = mimeType;
    metadataFrame.pictureType = pictureType;
    metadataFrame.description = description;
    metadataFrame.data = data;
    return metadataFrame;
}
/**
 * Decode an ID3 PRIV frame.
 *
 * @param frame - the ID3 PRIV frame
 *
 * @returns The decoded ID3 PRIV frame
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$decodeId3PrivFrame(frame) {
    /*
  Format: <text string>\0<binary data>
  */ if (frame.size < 2) return undefined;
    const owner = $b941786f4eb9cb76$var$utf8ArrayToStr(frame.data, true);
    const privateData = new Uint8Array(frame.data.subarray(owner.length + 1));
    return {
        key: frame.type,
        info: owner,
        data: privateData.buffer
    };
}
/**
 * Decodes an ID3 text frame
 *
 * @param frame - the ID3 text frame
 *
 * @returns The decoded ID3 text frame
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$decodeId3TextFrame(frame) {
    if (frame.size < 2) return undefined;
    if (frame.type === 'TXXX') {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{Value}
    */ let index = 1;
        const description = $b941786f4eb9cb76$var$utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = $b941786f4eb9cb76$var$utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0]   = {Text Encoding}
  [1-?] = {Value}
  */ const text = $b941786f4eb9cb76$var$utf8ArrayToStr(frame.data.subarray(1));
    return {
        key: frame.type,
        info: '',
        data: text
    };
}
/**
 * Decode a URL frame
 *
 * @param frame - the ID3 URL frame
 *
 * @returns The decoded ID3 URL frame
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$decodeId3UrlFrame(frame) {
    if (frame.type === 'WXXX') {
        /*
    Format:
    [0]   = {Text Encoding}
    [1-?] = {Description}\0{URL}
    */ if (frame.size < 2) return undefined;
        let index = 1;
        const description = $b941786f4eb9cb76$var$utf8ArrayToStr(frame.data.subarray(index), true);
        index += description.length + 1;
        const value = $b941786f4eb9cb76$var$utf8ArrayToStr(frame.data.subarray(index));
        return {
            key: frame.type,
            info: description,
            data: value
        };
    }
    /*
  Format:
  [0-?] = {URL}
  */ const url = $b941786f4eb9cb76$var$utf8ArrayToStr(frame.data);
    return {
        key: frame.type,
        info: '',
        data: url
    };
}
/**
 * Decode an ID3 frame.
 *
 * @param frame - the ID3 frame
 *
 * @returns The decoded ID3 frame
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$decodeId3Frame(frame) {
    if (frame.type === 'PRIV') return $b941786f4eb9cb76$var$decodeId3PrivFrame(frame);
    else if (frame.type[0] === 'W') return $b941786f4eb9cb76$var$decodeId3UrlFrame(frame);
    else if (frame.type === 'APIC') return $b941786f4eb9cb76$var$decodeId3ImageFrame(frame);
    return $b941786f4eb9cb76$var$decodeId3TextFrame(frame);
}
/**
 * Returns the data of an ID3 frame.
 *
 * @param data - The data to read from
 *
 * @returns The data of the ID3 frame
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$getId3FrameData(data) {
    /*
  Frame ID       $xx xx xx xx (four characters)
  Size           $xx xx xx xx
  Flags          $xx xx
  */ const type = String.fromCharCode(data[0], data[1], data[2], data[3]);
    const size = $b941786f4eb9cb76$var$readId3Size(data, 4);
    // skip frame id, size, and flags
    const offset = 10;
    return {
        type: type,
        size: size,
        data: data.subarray(offset, offset + size)
    };
}
const $b941786f4eb9cb76$var$HEADER_FOOTER_SIZE = 10;
const $b941786f4eb9cb76$var$FRAME_SIZE = 10;
/**
 * Returns an array of ID3 frames found in all the ID3 tags in the id3Data
 *
 * @param id3Data - The ID3 data containing one or more ID3 tags
 *
 * @returns Array of ID3 frame objects
 *
 * @group ID3
 *
 * @beta
 */ function $b941786f4eb9cb76$var$getId3Frames(id3Data) {
    let offset = 0;
    const frames = [];
    while($b941786f4eb9cb76$var$isId3Header(id3Data, offset)){
        const size = $b941786f4eb9cb76$var$readId3Size(id3Data, offset + 6);
        if (id3Data[offset + 5] >> 6 & 1) // skip extended header
        offset += $b941786f4eb9cb76$var$HEADER_FOOTER_SIZE;
        // skip past ID3 header
        offset += $b941786f4eb9cb76$var$HEADER_FOOTER_SIZE;
        const end = offset + size;
        // loop through frames in the ID3 tag
        while(offset + $b941786f4eb9cb76$var$FRAME_SIZE < end){
            const frameData = $b941786f4eb9cb76$var$getId3FrameData(id3Data.subarray(offset));
            const frame = $b941786f4eb9cb76$var$decodeId3Frame(frameData);
            if (frame) frames.push(frame);
            // skip frame header and frame data
            offset += frameData.size + $b941786f4eb9cb76$var$HEADER_FOOTER_SIZE;
        }
        if ($b941786f4eb9cb76$var$isId3Footer(id3Data, offset)) offset += $b941786f4eb9cb76$var$HEADER_FOOTER_SIZE;
    }
    return frames;
}
/**
 * Returns true if the ID3 frame is an Elementary Stream timestamp frame
 *
 * @param frame - the ID3 frame
 *
 * @returns `true` if the ID3 frame is an Elementary Stream timestamp frame
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$isId3TimestampFrame(frame) {
    return frame && frame.key === 'PRIV' && frame.info === 'com.apple.streaming.transportStreamTimestamp';
}
/**
 * Read a 33 bit timestamp from an ID3 frame.
 *
 * @param timeStampFrame - the ID3 frame
 *
 * @returns The timestamp
 *
 * @internal
 *
 * @group ID3
 */ function $b941786f4eb9cb76$var$readId3Timestamp(timeStampFrame) {
    if (timeStampFrame.data.byteLength === 8) {
        const data = new Uint8Array(timeStampFrame.data);
        // timestamp is 33 bit expressed as a big-endian eight-octet number,
        // with the upper 31 bits set to zero.
        const pts33Bit = data[3] & 0x1;
        let timestamp = (data[4] << 23) + (data[5] << 15) + (data[6] << 7) + data[7];
        timestamp /= 45;
        if (pts33Bit) timestamp += 47721858.84;
         // 2^32 / 90
        return Math.round(timestamp);
    }
    return undefined;
}
/**
 * Searches for the Elementary Stream timestamp found in the ID3 data chunk
 *
 * @param data - Block of data containing one or more ID3 tags
 *
 * @returns The timestamp
 *
 * @group ID3
 *
 * @beta
 */ function $b941786f4eb9cb76$var$getId3Timestamp(data) {
    const frames = $b941786f4eb9cb76$var$getId3Frames(data);
    for(let i = 0; i < frames.length; i++){
        const frame = frames[i];
        if ($b941786f4eb9cb76$var$isId3TimestampFrame(frame)) return $b941786f4eb9cb76$var$readId3Timestamp(frame);
    }
    return undefined;
}
let $b941786f4eb9cb76$export$3f0d1211c87abf7f = /*#__PURE__*/ function(MetadataSchema) {
    MetadataSchema["audioId3"] = "org.id3";
    MetadataSchema["dateRange"] = "com.apple.quicktime.HLS";
    MetadataSchema["emsg"] = "https://aomedia.org/emsg/ID3";
    MetadataSchema["misbklv"] = "urn:misb:KLV:bin:1910.1";
    return MetadataSchema;
}({});
function $b941786f4eb9cb76$var$dummyTrack(type = '', inputTimeScale = 90000) {
    return {
        type: type,
        id: -1,
        pid: -1,
        inputTimeScale: inputTimeScale,
        sequenceNumber: -1,
        samples: [],
        dropped: 0
    };
}
class $b941786f4eb9cb76$var$BaseAudioDemuxer {
    constructor(){
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this.frameIndex = 0;
        this.cachedData = null;
        this.basePTS = null;
        this.initPTS = null;
        this.lastPTS = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this._id3Track = {
            type: 'id3',
            id: 3,
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0
        };
    }
    resetTimeStamp(deaultTimestamp) {
        this.initPTS = deaultTimestamp;
        this.resetContiguity();
    }
    resetContiguity() {
        this.basePTS = null;
        this.lastPTS = null;
        this.frameIndex = 0;
    }
    canParse(data, offset) {
        return false;
    }
    appendFrame(track, data, offset) {}
    // feed incoming data to the front of the parsing pipeline
    demux(data, timeOffset) {
        if (this.cachedData) {
            data = $b941786f4eb9cb76$var$appendUint8Array(this.cachedData, data);
            this.cachedData = null;
        }
        let id3Data = $b941786f4eb9cb76$var$getId3Data(data, 0);
        let offset = id3Data ? id3Data.length : 0;
        let lastDataIndex;
        const track = this._audioTrack;
        const id3Track = this._id3Track;
        const timestamp = id3Data ? $b941786f4eb9cb76$var$getId3Timestamp(id3Data) : undefined;
        const length = data.length;
        if (this.basePTS === null || this.frameIndex === 0 && $b941786f4eb9cb76$var$isFiniteNumber(timestamp)) {
            this.basePTS = $b941786f4eb9cb76$var$initPTSFn(timestamp, timeOffset, this.initPTS);
            this.lastPTS = this.basePTS;
        }
        if (this.lastPTS === null) this.lastPTS = this.basePTS;
        // more expressive than alternative: id3Data?.length
        if (id3Data && id3Data.length > 0) id3Track.samples.push({
            pts: this.lastPTS,
            dts: this.lastPTS,
            data: id3Data,
            type: $b941786f4eb9cb76$export$3f0d1211c87abf7f.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        while(offset < length){
            if (this.canParse(data, offset)) {
                const frame = this.appendFrame(track, data, offset);
                if (frame) {
                    this.frameIndex++;
                    this.lastPTS = frame.sample.pts;
                    offset += frame.length;
                    lastDataIndex = offset;
                } else offset = length;
            } else if ($b941786f4eb9cb76$var$canParseId3(data, offset)) {
                // after a canParse, a call to getId3Data *should* always returns some data
                id3Data = $b941786f4eb9cb76$var$getId3Data(data, offset);
                id3Track.samples.push({
                    pts: this.lastPTS,
                    dts: this.lastPTS,
                    data: id3Data,
                    type: $b941786f4eb9cb76$export$3f0d1211c87abf7f.audioId3,
                    duration: Number.POSITIVE_INFINITY
                });
                offset += id3Data.length;
                lastDataIndex = offset;
            } else offset++;
            if (offset === length && lastDataIndex !== length) {
                const partialData = data.slice(lastDataIndex);
                if (this.cachedData) this.cachedData = $b941786f4eb9cb76$var$appendUint8Array(this.cachedData, partialData);
                else this.cachedData = partialData;
            }
        }
        return {
            audioTrack: track,
            videoTrack: $b941786f4eb9cb76$var$dummyTrack(),
            id3Track: id3Track,
            textTrack: $b941786f4eb9cb76$var$dummyTrack()
        };
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
    }
    flush(timeOffset) {
        // Parse cache in case of remaining frames.
        const cachedData = this.cachedData;
        if (cachedData) {
            this.cachedData = null;
            this.demux(cachedData, 0);
        }
        return {
            audioTrack: this._audioTrack,
            videoTrack: $b941786f4eb9cb76$var$dummyTrack(),
            id3Track: this._id3Track,
            textTrack: $b941786f4eb9cb76$var$dummyTrack()
        };
    }
    destroy() {
        this.cachedData = null;
        // @ts-ignore
        this._audioTrack = this._id3Track = undefined;
    }
}
/**
 * Initialize PTS
 * <p>
 *    use timestamp unless it is undefined, NaN or Infinity
 * </p>
 */ const $b941786f4eb9cb76$var$initPTSFn = (timestamp, timeOffset, initPTS)=>{
    if ($b941786f4eb9cb76$var$isFiniteNumber(timestamp)) return timestamp * 90;
    const init90kHz = initPTS ? initPTS.baseTime * 90000 / initPTS.timescale : 0;
    return timeOffset * 90000 + init90kHz;
};
/**
 *  MPEG parser helper
 */ let $b941786f4eb9cb76$var$chromeVersion$1 = null;
const $b941786f4eb9cb76$var$BitratesMap = [
    32,
    64,
    96,
    128,
    160,
    192,
    224,
    256,
    288,
    320,
    352,
    384,
    416,
    448,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    384,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    160,
    192,
    224,
    256,
    320,
    32,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160,
    176,
    192,
    224,
    256,
    8,
    16,
    24,
    32,
    40,
    48,
    56,
    64,
    80,
    96,
    112,
    128,
    144,
    160
];
const $b941786f4eb9cb76$var$SamplingRateMap = [
    44100,
    48000,
    32000,
    22050,
    24000,
    16000,
    11025,
    12000,
    8000
];
const $b941786f4eb9cb76$var$SamplesCoefficients = [
    // MPEG 2.5
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // Reserved
    [
        0,
        // Reserved
        0,
        // Layer3
        0,
        // Layer2
        0 // Layer1
    ],
    // MPEG 2
    [
        0,
        // Reserved
        72,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ],
    // MPEG 1
    [
        0,
        // Reserved
        144,
        // Layer3
        144,
        // Layer2
        12 // Layer1
    ]
];
const $b941786f4eb9cb76$var$BytesInSlot = [
    0,
    // Reserved
    1,
    // Layer3
    1,
    // Layer2
    4 // Layer1
];
function $b941786f4eb9cb76$var$appendFrame$1(track, data, offset, pts, frameIndex) {
    // Using http://www.datavoyage.com/mpgscript/mpeghdr.htm as a reference
    if (offset + 24 > data.length) return;
    const header = $b941786f4eb9cb76$var$parseHeader(data, offset);
    if (header && offset + header.frameLength <= data.length) {
        const frameDuration = header.samplesPerFrame * 90000 / header.sampleRate;
        const stamp = pts + frameIndex * frameDuration;
        const sample = {
            unit: data.subarray(offset, offset + header.frameLength),
            pts: stamp,
            dts: stamp
        };
        track.config = [];
        track.channelCount = header.channelCount;
        track.samplerate = header.sampleRate;
        track.samples.push(sample);
        return {
            sample: sample,
            length: header.frameLength,
            missing: 0
        };
    }
}
function $b941786f4eb9cb76$var$parseHeader(data, offset) {
    const mpegVersion = data[offset + 1] >> 3 & 3;
    const mpegLayer = data[offset + 1] >> 1 & 3;
    const bitRateIndex = data[offset + 2] >> 4 & 15;
    const sampleRateIndex = data[offset + 2] >> 2 & 3;
    if (mpegVersion !== 1 && bitRateIndex !== 0 && bitRateIndex !== 15 && sampleRateIndex !== 3) {
        const paddingBit = data[offset + 2] >> 1 & 1;
        const channelMode = data[offset + 3] >> 6;
        const columnInBitrates = mpegVersion === 3 ? 3 - mpegLayer : mpegLayer === 3 ? 3 : 4;
        const bitRate = $b941786f4eb9cb76$var$BitratesMap[columnInBitrates * 14 + bitRateIndex - 1] * 1000;
        const columnInSampleRates = mpegVersion === 3 ? 0 : mpegVersion === 2 ? 1 : 2;
        const sampleRate = $b941786f4eb9cb76$var$SamplingRateMap[columnInSampleRates * 3 + sampleRateIndex];
        const channelCount = channelMode === 3 ? 1 : 2; // If bits of channel mode are `11` then it is a single channel (Mono)
        const sampleCoefficient = $b941786f4eb9cb76$var$SamplesCoefficients[mpegVersion][mpegLayer];
        const bytesInSlot = $b941786f4eb9cb76$var$BytesInSlot[mpegLayer];
        const samplesPerFrame = sampleCoefficient * 8 * bytesInSlot;
        const frameLength = Math.floor(sampleCoefficient * bitRate / sampleRate + paddingBit) * bytesInSlot;
        if ($b941786f4eb9cb76$var$chromeVersion$1 === null) {
            const userAgent = navigator.userAgent || '';
            const result = userAgent.match(/Chrome\/(\d+)/i);
            $b941786f4eb9cb76$var$chromeVersion$1 = result ? parseInt(result[1]) : 0;
        }
        const needChromeFix = !!$b941786f4eb9cb76$var$chromeVersion$1 && $b941786f4eb9cb76$var$chromeVersion$1 <= 87;
        if (needChromeFix && mpegLayer === 2 && bitRate >= 224000 && channelMode === 0) // Work around bug in Chromium by setting channelMode to dual-channel (01) instead of stereo (00)
        data[offset + 3] = data[offset + 3] | 0x80;
        return {
            sampleRate: sampleRate,
            channelCount: channelCount,
            frameLength: frameLength,
            samplesPerFrame: samplesPerFrame
        };
    }
}
function $b941786f4eb9cb76$var$isHeaderPattern(data, offset) {
    return data[offset] === 0xff && (data[offset + 1] & 0xe0) === 0xe0 && (data[offset + 1] & 0x06) !== 0x00;
}
function $b941786f4eb9cb76$var$isHeader(data, offset) {
    // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
    // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
    // More info http://www.mp3-tech.org/programmer/frame_header.html
    return offset + 1 < data.length && $b941786f4eb9cb76$var$isHeaderPattern(data, offset);
}
function $b941786f4eb9cb76$var$canParse(data, offset) {
    const headerSize = 4;
    return $b941786f4eb9cb76$var$isHeaderPattern(data, offset) && headerSize <= data.length - offset;
}
function $b941786f4eb9cb76$var$probe(data, offset) {
    // same as isHeader but we also check that MPEG frame follows last MPEG frame
    // or end of data is reached
    if (offset + 1 < data.length && $b941786f4eb9cb76$var$isHeaderPattern(data, offset)) {
        // MPEG header Length
        const headerLength = 4;
        // MPEG frame Length
        const header = $b941786f4eb9cb76$var$parseHeader(data, offset);
        let frameLength = headerLength;
        if (header != null && header.frameLength) frameLength = header.frameLength;
        const newOffset = offset + frameLength;
        return newOffset === data.length || $b941786f4eb9cb76$var$isHeader(data, newOffset);
    }
    return false;
}
/**
 * AAC demuxer
 */ class $b941786f4eb9cb76$var$AACDemuxer extends $b941786f4eb9cb76$var$BaseAudioDemuxer {
    constructor(observer, config){
        super();
        this.observer = void 0;
        this.config = void 0;
        this.observer = observer;
        this.config = config;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/adts',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'aac',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
    static probe(data, logger) {
        if (!data) return false;
        // Check for the ADTS sync word
        // Look for ADTS header | 1111 1111 | 1111 X00X | where X can be either 0 or 1
        // Layer bits (position 14 and 15) in header should be always 0 for ADTS
        // More info https://wiki.multimedia.cx/index.php?title=ADTS
        const id3Data = $b941786f4eb9cb76$var$getId3Data(data, 0);
        let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
        if ($b941786f4eb9cb76$var$probe(data, offset)) return false;
        for(let length = data.length; offset < length; offset++)if ($b941786f4eb9cb76$var$probe$1(data, offset)) {
            logger.log('ADTS sync word found !');
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return $b941786f4eb9cb76$var$canParse$1(data, offset);
    }
    appendFrame(track, data, offset) {
        $b941786f4eb9cb76$var$initTrackConfig(track, this.observer, data, offset, track.manifestCodec);
        const frame = $b941786f4eb9cb76$var$appendFrame$2(track, data, offset, this.basePTS, this.frameIndex);
        if (frame && frame.missing === 0) return frame;
    }
}
const $b941786f4eb9cb76$var$getAudioBSID = (data, offset)=>{
    // check the bsid to confirm ac-3 | ec-3
    let bsid = 0;
    let numBits = 5;
    offset += numBits;
    const temp = new Uint32Array(1); // unsigned 32 bit for temporary storage
    const mask = new Uint32Array(1); // unsigned 32 bit mask value
    const byte = new Uint8Array(1); // unsigned 8 bit for temporary storage
    while(numBits > 0){
        byte[0] = data[offset];
        // read remaining bits, upto 8 bits at a time
        const bits = Math.min(numBits, 8);
        const shift = 8 - bits;
        mask[0] = 0xff000000 >>> 24 + shift << shift;
        temp[0] = (byte[0] & mask[0]) >> shift;
        bsid = !bsid ? temp[0] : bsid << bits | temp[0];
        offset += 1;
        numBits -= bits;
    }
    return bsid;
};
class $b941786f4eb9cb76$var$AC3Demuxer extends $b941786f4eb9cb76$var$BaseAudioDemuxer {
    constructor(observer){
        super();
        this.observer = void 0;
        this.observer = observer;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/ac-3',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'ac3',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    canParse(data, offset) {
        return offset + 64 < data.length;
    }
    appendFrame(track, data, offset) {
        const frameLength = $b941786f4eb9cb76$var$appendFrame(track, data, offset, this.basePTS, this.frameIndex);
        if (frameLength !== -1) {
            const sample = track.samples[track.samples.length - 1];
            return {
                sample: sample,
                length: frameLength,
                missing: 0
            };
        }
    }
    static probe(data) {
        if (!data) return false;
        const id3Data = $b941786f4eb9cb76$var$getId3Data(data, 0);
        if (!id3Data) return false;
        // look for the ac-3 sync bytes
        const offset = id3Data.length;
        if (data[offset] === 0x0b && data[offset + 1] === 0x77 && $b941786f4eb9cb76$var$getId3Timestamp(id3Data) !== undefined && // check the bsid to confirm ac-3
        $b941786f4eb9cb76$var$getAudioBSID(data, offset) < 16) return true;
        return false;
    }
}
function $b941786f4eb9cb76$var$appendFrame(track, data, start, pts, frameIndex) {
    if (start + 8 > data.length) return -1; // not enough bytes left
    if (data[start] !== 0x0b || data[start + 1] !== 0x77) return -1; // invalid magic
    // get sample rate
    const samplingRateCode = data[start + 4] >> 6;
    if (samplingRateCode >= 3) return -1; // invalid sampling rate
    const samplingRateMap = [
        48000,
        44100,
        32000
    ];
    const sampleRate = samplingRateMap[samplingRateCode];
    // get frame size
    const frameSizeCode = data[start + 4] & 0x3f;
    const frameSizeMap = [
        64,
        69,
        96,
        64,
        70,
        96,
        80,
        87,
        120,
        80,
        88,
        120,
        96,
        104,
        144,
        96,
        105,
        144,
        112,
        121,
        168,
        112,
        122,
        168,
        128,
        139,
        192,
        128,
        140,
        192,
        160,
        174,
        240,
        160,
        175,
        240,
        192,
        208,
        288,
        192,
        209,
        288,
        224,
        243,
        336,
        224,
        244,
        336,
        256,
        278,
        384,
        256,
        279,
        384,
        320,
        348,
        480,
        320,
        349,
        480,
        384,
        417,
        576,
        384,
        418,
        576,
        448,
        487,
        672,
        448,
        488,
        672,
        512,
        557,
        768,
        512,
        558,
        768,
        640,
        696,
        960,
        640,
        697,
        960,
        768,
        835,
        1152,
        768,
        836,
        1152,
        896,
        975,
        1344,
        896,
        976,
        1344,
        1024,
        1114,
        1536,
        1024,
        1115,
        1536,
        1152,
        1253,
        1728,
        1152,
        1254,
        1728,
        1280,
        1393,
        1920,
        1280,
        1394,
        1920
    ];
    const frameLength = frameSizeMap[frameSizeCode * 3 + samplingRateCode] * 2;
    if (start + frameLength > data.length) return -1;
    // get channel count
    const channelMode = data[start + 6] >> 5;
    let skipCount = 0;
    if (channelMode === 2) skipCount += 2;
    else {
        if (channelMode & 1 && channelMode !== 1) skipCount += 2;
        if (channelMode & 4) skipCount += 2;
    }
    const lfeon = (data[start + 6] << 8 | data[start + 7]) >> 12 - skipCount & 1;
    const channelsMap = [
        2,
        1,
        2,
        3,
        3,
        4,
        4,
        5
    ];
    const channelCount = channelsMap[channelMode] + lfeon;
    // build dac3 box
    const bsid = data[start + 5] >> 3;
    const bsmod = data[start + 5] & 7;
    const config = new Uint8Array([
        samplingRateCode << 6 | bsid << 1 | bsmod >> 2,
        (bsmod & 3) << 6 | channelMode << 3 | lfeon << 2 | frameSizeCode >> 4,
        frameSizeCode << 4 & 0xe0
    ]);
    const frameDuration = 1536 / sampleRate * 90000;
    const stamp = pts + frameIndex * frameDuration;
    const unit = data.subarray(start, start + frameLength);
    track.config = config;
    track.channelCount = channelCount;
    track.samplerate = sampleRate;
    track.samples.push({
        unit: unit,
        pts: stamp
    });
    return frameLength;
}
/**
 * MP3 demuxer
 */ class $b941786f4eb9cb76$var$MP3Demuxer extends $b941786f4eb9cb76$var$BaseAudioDemuxer {
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        super.resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration);
        this._audioTrack = {
            container: 'audio/mpeg',
            type: 'audio',
            id: 2,
            pid: -1,
            sequenceNumber: 0,
            segmentCodec: 'mp3',
            samples: [],
            manifestCodec: audioCodec,
            duration: trackDuration,
            inputTimeScale: 90000,
            dropped: 0
        };
    }
    static probe(data) {
        if (!data) return false;
        // check if data contains ID3 timestamp and MPEG sync word
        // Look for MPEG header | 1111 1111 | 111X XYZX | where X can be either 0 or 1 and Y or Z should be 1
        // Layer bits (position 14 and 15) in header should be always different from 0 (Layer I or Layer II or Layer III)
        // More info http://www.mp3-tech.org/programmer/frame_header.html
        const id3Data = $b941786f4eb9cb76$var$getId3Data(data, 0);
        let offset = (id3Data == null ? void 0 : id3Data.length) || 0;
        // Check for ac-3|ec-3 sync bytes and return false if present
        if (id3Data && data[offset] === 0x0b && data[offset + 1] === 0x77 && $b941786f4eb9cb76$var$getId3Timestamp(id3Data) !== undefined && // check the bsid to confirm ac-3 or ec-3 (not mp3)
        $b941786f4eb9cb76$var$getAudioBSID(data, offset) <= 16) return false;
        for(let length = data.length; offset < length; offset++)if ($b941786f4eb9cb76$var$probe(data, offset)) {
            $b941786f4eb9cb76$var$logger.log('MPEG Audio sync word found !');
            return true;
        }
        return false;
    }
    canParse(data, offset) {
        return $b941786f4eb9cb76$var$canParse(data, offset);
    }
    appendFrame(track, data, offset) {
        if (this.basePTS === null) return;
        return $b941786f4eb9cb76$var$appendFrame$1(track, data, offset, this.basePTS, this.frameIndex);
    }
}
const $b941786f4eb9cb76$var$emsgSchemePattern = /\/emsg[-/]ID3/i;
class $b941786f4eb9cb76$var$MP4Demuxer {
    constructor(observer, config){
        this.remainderData = null;
        this.timeOffset = 0;
        this.config = void 0;
        this.videoTrack = void 0;
        this.audioTrack = void 0;
        this.id3Track = void 0;
        this.txtTrack = void 0;
        this.config = config;
    }
    resetTimeStamp() {}
    resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        const videoTrack = this.videoTrack = $b941786f4eb9cb76$var$dummyTrack('video', 1);
        const audioTrack = this.audioTrack = $b941786f4eb9cb76$var$dummyTrack('audio', 1);
        const captionTrack = this.txtTrack = $b941786f4eb9cb76$var$dummyTrack('text', 1);
        this.id3Track = $b941786f4eb9cb76$var$dummyTrack('id3', 1);
        this.timeOffset = 0;
        if (!(initSegment != null && initSegment.byteLength)) return;
        const initData = $b941786f4eb9cb76$var$parseInitSegment(initSegment);
        if (initData.video) {
            const { id: id, timescale: timescale, codec: codec, supplemental: supplemental } = initData.video;
            videoTrack.id = id;
            videoTrack.timescale = captionTrack.timescale = timescale;
            videoTrack.codec = codec;
            videoTrack.supplemental = supplemental;
        }
        if (initData.audio) {
            const { id: id, timescale: timescale, codec: codec } = initData.audio;
            audioTrack.id = id;
            audioTrack.timescale = timescale;
            audioTrack.codec = codec;
        }
        captionTrack.id = $b941786f4eb9cb76$var$RemuxerTrackIdConfig.text;
        videoTrack.sampleDuration = 0;
        videoTrack.duration = audioTrack.duration = trackDuration;
    }
    resetContiguity() {
        this.remainderData = null;
    }
    static probe(data) {
        return $b941786f4eb9cb76$var$hasMoofData(data);
    }
    demux(data, timeOffset) {
        this.timeOffset = timeOffset;
        // Load all data into the avc track. The CMAF remuxer will look for the data in the samples object; the rest of the fields do not matter
        let videoSamples = data;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        if (this.config.progressive) {
            // Split the bytestream into two ranges: one encompassing all data up until the start of the last moof, and everything else.
            // This is done to guarantee that we're sending valid data to MSE - when demuxing progressively, we have no guarantee
            // that the fetch loader gives us flush moof+mdat pairs. If we push jagged data to MSE, it will throw an exception.
            if (this.remainderData) videoSamples = $b941786f4eb9cb76$var$appendUint8Array(this.remainderData, data);
            const segmentedData = $b941786f4eb9cb76$var$segmentValidRange(videoSamples);
            this.remainderData = segmentedData.remainder;
            videoTrack.samples = segmentedData.valid || new Uint8Array();
        } else videoTrack.samples = videoSamples;
        const id3Track = this.extractID3Track(videoTrack, timeOffset);
        textTrack.samples = $b941786f4eb9cb76$var$parseSamples(timeOffset, videoTrack);
        return {
            videoTrack: videoTrack,
            audioTrack: this.audioTrack,
            id3Track: id3Track,
            textTrack: this.txtTrack
        };
    }
    flush() {
        const timeOffset = this.timeOffset;
        const videoTrack = this.videoTrack;
        const textTrack = this.txtTrack;
        videoTrack.samples = this.remainderData || new Uint8Array();
        this.remainderData = null;
        const id3Track = this.extractID3Track(videoTrack, this.timeOffset);
        textTrack.samples = $b941786f4eb9cb76$var$parseSamples(timeOffset, videoTrack);
        return {
            videoTrack: videoTrack,
            audioTrack: $b941786f4eb9cb76$var$dummyTrack(),
            id3Track: id3Track,
            textTrack: $b941786f4eb9cb76$var$dummyTrack()
        };
    }
    extractID3Track(videoTrack, timeOffset) {
        const id3Track = this.id3Track;
        if (videoTrack.samples.length) {
            const emsgs = $b941786f4eb9cb76$var$findBox(videoTrack.samples, [
                'emsg'
            ]);
            if (emsgs) emsgs.forEach((data)=>{
                const emsgInfo = $b941786f4eb9cb76$var$parseEmsg(data);
                if ($b941786f4eb9cb76$var$emsgSchemePattern.test(emsgInfo.schemeIdUri)) {
                    const pts = $b941786f4eb9cb76$var$getEmsgStartTime(emsgInfo, timeOffset);
                    let duration = emsgInfo.eventDuration === 0xffffffff ? Number.POSITIVE_INFINITY : emsgInfo.eventDuration / emsgInfo.timeScale;
                    // Safari takes anything <= 0.001 seconds and maps it to Infinity
                    if (duration <= 0.001) duration = Number.POSITIVE_INFINITY;
                    const payload = emsgInfo.payload;
                    id3Track.samples.push({
                        data: payload,
                        len: payload.byteLength,
                        dts: pts,
                        pts: pts,
                        type: $b941786f4eb9cb76$export$3f0d1211c87abf7f.emsg,
                        duration: duration
                    });
                } else if (this.config.enableEmsgKLVMetadata && emsgInfo.schemeIdUri.startsWith('urn:misb:KLV:bin:1910.1')) {
                    const pts = $b941786f4eb9cb76$var$getEmsgStartTime(emsgInfo, timeOffset);
                    id3Track.samples.push({
                        data: emsgInfo.payload,
                        len: emsgInfo.payload.byteLength,
                        dts: pts,
                        pts: pts,
                        type: $b941786f4eb9cb76$export$3f0d1211c87abf7f.misbklv,
                        duration: Number.POSITIVE_INFINITY
                    });
                }
            });
        }
        return id3Track;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        return Promise.reject(new Error('The MP4 demuxer does not support SAMPLE-AES decryption'));
    }
    destroy() {
        // @ts-ignore
        this.config = null;
        this.remainderData = null;
        this.videoTrack = this.audioTrack = this.id3Track = this.txtTrack = undefined;
    }
}
function $b941786f4eb9cb76$var$getEmsgStartTime(emsgInfo, timeOffset) {
    return $b941786f4eb9cb76$var$isFiniteNumber(emsgInfo.presentationTime) ? emsgInfo.presentationTime / emsgInfo.timeScale : timeOffset + emsgInfo.presentationTimeDelta / emsgInfo.timeScale;
}
/**
 * SAMPLE-AES decrypter
 */ class $b941786f4eb9cb76$var$SampleAesDecrypter {
    constructor(observer, config, keyData){
        this.keyData = void 0;
        this.decrypter = void 0;
        this.keyData = keyData;
        this.decrypter = new $b941786f4eb9cb76$var$Decrypter(config, {
            removePKCS7Padding: false
        });
    }
    decryptBuffer(encryptedData) {
        return this.decrypter.decrypt(encryptedData, this.keyData.key.buffer, this.keyData.iv.buffer, $b941786f4eb9cb76$var$DecrypterAesMode.cbc);
    }
    // AAC - encrypt all full 16 bytes blocks starting from offset 16
    decryptAacSample(samples, sampleIndex, callback) {
        const curUnit = samples[sampleIndex].unit;
        if (curUnit.length <= 16) // No encrypted portion in this sample (first 16 bytes is not
        // encrypted, see https://developer.apple.com/library/archive/documentation/AudioVideo/Conceptual/HLS_Sample_Encryption/Encryption/Encryption.html),
        return;
        const encryptedData = curUnit.subarray(16, curUnit.length - curUnit.length % 16);
        const encryptedBuffer = encryptedData.buffer.slice(encryptedData.byteOffset, encryptedData.byteOffset + encryptedData.length);
        this.decryptBuffer(encryptedBuffer).then((decryptedBuffer)=>{
            const decryptedData = new Uint8Array(decryptedBuffer);
            curUnit.set(decryptedData, 16);
            if (!this.decrypter.isSync()) this.decryptAacSamples(samples, sampleIndex + 1, callback);
        }).catch(callback);
    }
    decryptAacSamples(samples, sampleIndex, callback) {
        for(;; sampleIndex++){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            if (samples[sampleIndex].unit.length < 32) continue;
            this.decryptAacSample(samples, sampleIndex, callback);
            if (!this.decrypter.isSync()) return;
        }
    }
    // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
    getAvcEncryptedData(decodedData) {
        const encryptedDataLen = Math.floor((decodedData.length - 48) / 160) * 16 + 16;
        const encryptedData = new Int8Array(encryptedDataLen);
        let outputPos = 0;
        for(let inputPos = 32; inputPos < decodedData.length - 16; inputPos += 160, outputPos += 16)encryptedData.set(decodedData.subarray(inputPos, inputPos + 16), outputPos);
        return encryptedData;
    }
    getAvcDecryptedUnit(decodedData, decryptedData) {
        const uint8DecryptedData = new Uint8Array(decryptedData);
        let inputPos = 0;
        for(let outputPos = 32; outputPos < decodedData.length - 16; outputPos += 160, inputPos += 16)decodedData.set(uint8DecryptedData.subarray(inputPos, inputPos + 16), outputPos);
        return decodedData;
    }
    decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit) {
        const decodedData = $b941786f4eb9cb76$var$discardEPB(curUnit.data);
        const encryptedData = this.getAvcEncryptedData(decodedData);
        this.decryptBuffer(encryptedData.buffer).then((decryptedBuffer)=>{
            curUnit.data = this.getAvcDecryptedUnit(decodedData, decryptedBuffer);
            if (!this.decrypter.isSync()) this.decryptAvcSamples(samples, sampleIndex, unitIndex + 1, callback);
        }).catch(callback);
    }
    decryptAvcSamples(samples, sampleIndex, unitIndex, callback) {
        if (samples instanceof Uint8Array) throw new Error('Cannot decrypt samples of type Uint8Array');
        for(;; sampleIndex++, unitIndex = 0){
            if (sampleIndex >= samples.length) {
                callback();
                return;
            }
            const curUnits = samples[sampleIndex].units;
            for(;; unitIndex++){
                if (unitIndex >= curUnits.length) break;
                const curUnit = curUnits[unitIndex];
                if (curUnit.data.length <= 48 || curUnit.type !== 1 && curUnit.type !== 5) continue;
                this.decryptAvcSample(samples, sampleIndex, unitIndex, callback, curUnit);
                if (!this.decrypter.isSync()) return;
            }
        }
    }
}
class $b941786f4eb9cb76$var$BaseVideoParser {
    constructor(){
        this.VideoSample = null;
    }
    createVideoSample(key, pts, dts) {
        return {
            key: key,
            frame: false,
            pts: pts,
            dts: dts,
            units: [],
            length: 0
        };
    }
    getLastNalUnit(samples) {
        var _VideoSample;
        let VideoSample = this.VideoSample;
        let lastUnit;
        // try to fallback to previous sample if current one is empty
        if (!VideoSample || VideoSample.units.length === 0) VideoSample = samples[samples.length - 1];
        if ((_VideoSample = VideoSample) != null && _VideoSample.units) {
            const units = VideoSample.units;
            lastUnit = units[units.length - 1];
        }
        return lastUnit;
    }
    pushAccessUnit(VideoSample, videoTrack) {
        if (VideoSample.units.length && VideoSample.frame) {
            // if sample does not have PTS/DTS, patch with last sample PTS/DTS
            if (VideoSample.pts === undefined) {
                const samples = videoTrack.samples;
                const nbSamples = samples.length;
                if (nbSamples) {
                    const lastSample = samples[nbSamples - 1];
                    VideoSample.pts = lastSample.pts;
                    VideoSample.dts = lastSample.dts;
                } else {
                    // dropping samples, no timestamp found
                    videoTrack.dropped++;
                    return;
                }
            }
            videoTrack.samples.push(VideoSample);
        }
    }
    parseNALu(track, array, endOfSegment) {
        const len = array.byteLength;
        let state = track.naluState || 0;
        const lastState = state;
        const units = [];
        let i = 0;
        let value;
        let overflow;
        let unitType;
        let lastUnitStart = -1;
        let lastUnitType = 0;
        // logger.log('PES:' + Hex.hexDump(array));
        if (state === -1) {
            // special use case where we found 3 or 4-byte start codes exactly at the end of previous PES packet
            lastUnitStart = 0;
            // NALu type is value read from offset 0
            lastUnitType = this.getNALuType(array, 0);
            state = 0;
            i = 1;
        }
        while(i < len){
            value = array[i++];
            // optimization. state 0 and 1 are the predominant case. let's handle them outside of the switch/case
            if (!state) {
                state = value ? 0 : 1;
                continue;
            }
            if (state === 1) {
                state = value ? 0 : 2;
                continue;
            }
            // here we have state either equal to 2 or 3
            if (!value) state = 3;
            else if (value === 1) {
                overflow = i - state - 1;
                if (lastUnitStart >= 0) {
                    const unit = {
                        data: array.subarray(lastUnitStart, overflow),
                        type: lastUnitType
                    };
                    // logger.log('pushing NALU, type/size:' + unit.type + '/' + unit.data.byteLength);
                    units.push(unit);
                } else {
                    // lastUnitStart is undefined => this is the first start code found in this PES packet
                    // first check if start code delimiter is overlapping between 2 PES packets,
                    // ie it started in last packet (lastState not zero)
                    // and ended at the beginning of this PES packet (i <= 4 - lastState)
                    const lastUnit = this.getLastNalUnit(track.samples);
                    if (lastUnit) {
                        if (lastState && i <= 4 - lastState) // start delimiter overlapping between PES packets
                        // strip start delimiter bytes from the end of last NAL unit
                        // check if lastUnit had a state different from zero
                        {
                            if (lastUnit.state) // strip last bytes
                            lastUnit.data = lastUnit.data.subarray(0, lastUnit.data.byteLength - lastState);
                        }
                        // If NAL units are not starting right at the beginning of the PES packet, push preceding data into previous NAL unit.
                        if (overflow > 0) {
                            // logger.log('first NALU found with overflow:' + overflow);
                            lastUnit.data = $b941786f4eb9cb76$var$appendUint8Array(lastUnit.data, array.subarray(0, overflow));
                            lastUnit.state = 0;
                        }
                    }
                }
                // check if we can read unit type
                if (i < len) {
                    unitType = this.getNALuType(array, i);
                    // logger.log('find NALU @ offset:' + i + ',type:' + unitType);
                    lastUnitStart = i;
                    lastUnitType = unitType;
                    state = 0;
                } else // not enough byte to read unit type. let's read it on next PES parsing
                state = -1;
            } else state = 0;
        }
        if (lastUnitStart >= 0 && state >= 0) {
            const unit = {
                data: array.subarray(lastUnitStart, len),
                type: lastUnitType,
                state: state
            };
            units.push(unit);
        // logger.log('pushing NALU, type/size/state:' + unit.type + '/' + unit.data.byteLength + '/' + state);
        }
        // no NALu found
        if (units.length === 0) {
            // append pes.data to previous NAL unit
            const lastUnit = this.getLastNalUnit(track.samples);
            if (lastUnit) lastUnit.data = $b941786f4eb9cb76$var$appendUint8Array(lastUnit.data, array);
        }
        track.naluState = state;
        return units;
    }
}
/**
 * Parser for exponential Golomb codes, a variable-bitwidth number encoding scheme used by h264.
 */ class $b941786f4eb9cb76$var$ExpGolomb {
    constructor(data){
        this.data = void 0;
        this.bytesAvailable = void 0;
        this.word = void 0;
        this.bitsAvailable = void 0;
        this.data = data;
        // the number of bytes left to examine in this.data
        this.bytesAvailable = data.byteLength;
        // the current word being examined
        this.word = 0; // :uint
        // the number of bits left to examine in the current word
        this.bitsAvailable = 0; // :uint
    }
    // ():void
    loadWord() {
        const data = this.data;
        const bytesAvailable = this.bytesAvailable;
        const position = data.byteLength - bytesAvailable;
        const workingBytes = new Uint8Array(4);
        const availableBytes = Math.min(4, bytesAvailable);
        if (availableBytes === 0) throw new Error('no bytes available');
        workingBytes.set(data.subarray(position, position + availableBytes));
        this.word = new DataView(workingBytes.buffer).getUint32(0);
        // track the amount of this.data that has been processed
        this.bitsAvailable = availableBytes * 8;
        this.bytesAvailable -= availableBytes;
    }
    // (count:int):void
    skipBits(count) {
        let skipBytes; // :int
        count = Math.min(count, this.bytesAvailable * 8 + this.bitsAvailable);
        if (this.bitsAvailable > count) {
            this.word <<= count;
            this.bitsAvailable -= count;
        } else {
            count -= this.bitsAvailable;
            skipBytes = count >> 3;
            count -= skipBytes << 3;
            this.bytesAvailable -= skipBytes;
            this.loadWord();
            this.word <<= count;
            this.bitsAvailable -= count;
        }
    }
    // (size:int):uint
    readBits(size) {
        let bits = Math.min(this.bitsAvailable, size); // :uint
        const valu = this.word >>> 32 - bits; // :uint
        if (size > 32) $b941786f4eb9cb76$var$logger.error('Cannot read more than 32 bits at a time');
        this.bitsAvailable -= bits;
        if (this.bitsAvailable > 0) this.word <<= bits;
        else if (this.bytesAvailable > 0) this.loadWord();
        else throw new Error('no bits available');
        bits = size - bits;
        if (bits > 0 && this.bitsAvailable) return valu << bits | this.readBits(bits);
        else return valu;
    }
    // ():uint
    skipLZ() {
        let leadingZeroCount; // :uint
        for(leadingZeroCount = 0; leadingZeroCount < this.bitsAvailable; ++leadingZeroCount)if ((this.word & 0x80000000 >>> leadingZeroCount) !== 0) {
            // the first bit of working word is 1
            this.word <<= leadingZeroCount;
            this.bitsAvailable -= leadingZeroCount;
            return leadingZeroCount;
        }
        // we exhausted word and still have not found a 1
        this.loadWord();
        return leadingZeroCount + this.skipLZ();
    }
    // ():void
    skipUEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():void
    skipEG() {
        this.skipBits(1 + this.skipLZ());
    }
    // ():uint
    readUEG() {
        const clz = this.skipLZ(); // :uint
        return this.readBits(clz + 1) - 1;
    }
    // ():int
    readEG() {
        const valu = this.readUEG(); // :int
        if (0x01 & valu) // the number is odd if the low order bit is set
        return 1 + valu >>> 1; // add 1 to make it even, and divide by 2
        else return -1 * (valu >>> 1); // divide by two then make it negative
    }
    // Some convenience functions
    // :Boolean
    readBoolean() {
        return this.readBits(1) === 1;
    }
    // ():int
    readUByte() {
        return this.readBits(8);
    }
    // ():int
    readUShort() {
        return this.readBits(16);
    }
    // ():int
    readUInt() {
        return this.readBits(32);
    }
}
class $b941786f4eb9cb76$var$AvcVideoParser extends $b941786f4eb9cb76$var$BaseVideoParser {
    parsePES(track, textTrack, pes, endOfSegment) {
        const units = this.parseNALu(track, pes.data, endOfSegment);
        let VideoSample = this.VideoSample;
        let push;
        let spsfound = false;
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (VideoSample && units.length && !track.audFound) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
        }
        units.forEach((unit)=>{
            var _VideoSample2, _VideoSample3;
            switch(unit.type){
                // NDR
                case 1:
                    {
                        let iskey = false;
                        push = true;
                        const data = unit.data;
                        // only check slice type to detect KF in case SPS found in same packet (any keyframe is preceded by SPS ...)
                        if (spsfound && data.length > 4) {
                            // retrieve slice type by parsing beginning of NAL unit (follow H264 spec, slice_header definition) to detect keyframe embedded in NDR
                            const sliceType = this.readSliceType(data);
                            // 2 : I slice, 4 : SI slice, 7 : I slice, 9: SI slice
                            // SI slice : A slice that is coded using intra prediction only and using quantisation of the prediction samples.
                            // An SI slice can be coded such that its decoded samples can be constructed identically to an SP slice.
                            // I slice: A slice that is not an SI slice that is decoded using intra prediction only.
                            // if (sliceType === 2 || sliceType === 7) {
                            if (sliceType === 2 || sliceType === 4 || sliceType === 7 || sliceType === 9) iskey = true;
                        }
                        if (iskey) {
                            var _VideoSample;
                            // if we have non-keyframe data already, that cannot belong to the same frame as a keyframe, so force a push
                            if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                                this.pushAccessUnit(VideoSample, track);
                                VideoSample = this.VideoSample = null;
                            }
                        }
                        if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                        VideoSample.frame = true;
                        VideoSample.key = iskey;
                        break;
                    // IDR
                    }
                case 5:
                    push = true;
                    // handle PES not starting with AUD
                    // if we have frame data already, that cannot belong to the same frame, so force a push
                    if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = this.VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    VideoSample.frame = true;
                    break;
                // SEI
                case 6:
                    push = true;
                    $b941786f4eb9cb76$var$parseSEIMessageFromNALu(unit.data, 1, pes.pts, textTrack.samples);
                    break;
                case 7:
                    {
                        var _track$pixelRatio, _track$pixelRatio2;
                        push = true;
                        spsfound = true;
                        const sps = unit.data;
                        const config = this.readSPS(sps);
                        if (!track.sps || track.width !== config.width || track.height !== config.height || ((_track$pixelRatio = track.pixelRatio) == null ? void 0 : _track$pixelRatio[0]) !== config.pixelRatio[0] || ((_track$pixelRatio2 = track.pixelRatio) == null ? void 0 : _track$pixelRatio2[1]) !== config.pixelRatio[1]) {
                            track.width = config.width;
                            track.height = config.height;
                            track.pixelRatio = config.pixelRatio;
                            track.sps = [
                                sps
                            ];
                            const codecarray = sps.subarray(1, 4);
                            let codecstring = 'avc1.';
                            for(let i = 0; i < 3; i++){
                                let h = codecarray[i].toString(16);
                                if (h.length < 2) h = '0' + h;
                                codecstring += h;
                            }
                            track.codec = codecstring;
                        }
                        break;
                    }
                // PPS
                case 8:
                    push = true;
                    track.pps = [
                        unit.data
                    ];
                    break;
                // AUD
                case 9:
                    push = true;
                    track.audFound = true;
                    if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
                    break;
                // Filler Data
                case 12:
                    push = true;
                    break;
                default:
                    push = false;
                    break;
            }
            if (VideoSample && push) {
                const units = VideoSample.units;
                units.push(unit);
            }
        });
        // if last PES packet, push samples
        if (endOfSegment && VideoSample) {
            this.pushAccessUnit(VideoSample, track);
            this.VideoSample = null;
        }
    }
    getNALuType(data, offset) {
        return data[offset] & 0x1f;
    }
    readSliceType(data) {
        const eg = new $b941786f4eb9cb76$var$ExpGolomb(data);
        // skip NALu type
        eg.readUByte();
        // discard first_mb_in_slice
        eg.readUEG();
        // return slice_type
        return eg.readUEG();
    }
    /**
   * The scaling list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */ skipScalingList(count, reader) {
        let lastScale = 8;
        let nextScale = 8;
        let deltaScale;
        for(let j = 0; j < count; j++){
            if (nextScale !== 0) {
                deltaScale = reader.readEG();
                nextScale = (lastScale + deltaScale + 256) % 256;
            }
            lastScale = nextScale === 0 ? lastScale : nextScale;
        }
    }
    /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */ readSPS(sps) {
        const eg = new $b941786f4eb9cb76$var$ExpGolomb(sps);
        let frameCropLeftOffset = 0;
        let frameCropRightOffset = 0;
        let frameCropTopOffset = 0;
        let frameCropBottomOffset = 0;
        let numRefFramesInPicOrderCntCycle;
        let scalingListCount;
        let i;
        const readUByte = eg.readUByte.bind(eg);
        const readBits = eg.readBits.bind(eg);
        const readUEG = eg.readUEG.bind(eg);
        const readBoolean = eg.readBoolean.bind(eg);
        const skipBits = eg.skipBits.bind(eg);
        const skipEG = eg.skipEG.bind(eg);
        const skipUEG = eg.skipUEG.bind(eg);
        const skipScalingList = this.skipScalingList.bind(this);
        readUByte();
        const profileIdc = readUByte(); // profile_idc
        readBits(5); // profileCompat constraint_set[0-4]_flag, u(5)
        skipBits(3); // reserved_zero_3bits u(3),
        readUByte(); // level_idc u(8)
        skipUEG(); // seq_parameter_set_id
        // some profiles have more optional data we don't need
        if (profileIdc === 100 || profileIdc === 110 || profileIdc === 122 || profileIdc === 244 || profileIdc === 44 || profileIdc === 83 || profileIdc === 86 || profileIdc === 118 || profileIdc === 128) {
            const chromaFormatIdc = readUEG();
            if (chromaFormatIdc === 3) skipBits(1);
             // separate_colour_plane_flag
            skipUEG(); // bit_depth_luma_minus8
            skipUEG(); // bit_depth_chroma_minus8
            skipBits(1); // qpprime_y_zero_transform_bypass_flag
            if (readBoolean()) {
                // seq_scaling_matrix_present_flag
                scalingListCount = chromaFormatIdc !== 3 ? 8 : 12;
                for(i = 0; i < scalingListCount; i++)if (readBoolean()) {
                    // seq_scaling_list_present_flag[ i ]
                    if (i < 6) skipScalingList(16, eg);
                    else skipScalingList(64, eg);
                }
            }
        }
        skipUEG(); // log2_max_frame_num_minus4
        const picOrderCntType = readUEG();
        if (picOrderCntType === 0) readUEG(); // log2_max_pic_order_cnt_lsb_minus4
        else if (picOrderCntType === 1) {
            skipBits(1); // delta_pic_order_always_zero_flag
            skipEG(); // offset_for_non_ref_pic
            skipEG(); // offset_for_top_to_bottom_field
            numRefFramesInPicOrderCntCycle = readUEG();
            for(i = 0; i < numRefFramesInPicOrderCntCycle; i++)skipEG();
             // offset_for_ref_frame[ i ]
        }
        skipUEG(); // max_num_ref_frames
        skipBits(1); // gaps_in_frame_num_value_allowed_flag
        const picWidthInMbsMinus1 = readUEG();
        const picHeightInMapUnitsMinus1 = readUEG();
        const frameMbsOnlyFlag = readBits(1);
        if (frameMbsOnlyFlag === 0) skipBits(1);
         // mb_adaptive_frame_field_flag
        skipBits(1); // direct_8x8_inference_flag
        if (readBoolean()) {
            // frame_cropping_flag
            frameCropLeftOffset = readUEG();
            frameCropRightOffset = readUEG();
            frameCropTopOffset = readUEG();
            frameCropBottomOffset = readUEG();
        }
        let pixelRatio = [
            1,
            1
        ];
        if (readBoolean()) // vui_parameters_present_flag
        {
            if (readBoolean()) {
                // aspect_ratio_info_present_flag
                const aspectRatioIdc = readUByte();
                switch(aspectRatioIdc){
                    case 1:
                        pixelRatio = [
                            1,
                            1
                        ];
                        break;
                    case 2:
                        pixelRatio = [
                            12,
                            11
                        ];
                        break;
                    case 3:
                        pixelRatio = [
                            10,
                            11
                        ];
                        break;
                    case 4:
                        pixelRatio = [
                            16,
                            11
                        ];
                        break;
                    case 5:
                        pixelRatio = [
                            40,
                            33
                        ];
                        break;
                    case 6:
                        pixelRatio = [
                            24,
                            11
                        ];
                        break;
                    case 7:
                        pixelRatio = [
                            20,
                            11
                        ];
                        break;
                    case 8:
                        pixelRatio = [
                            32,
                            11
                        ];
                        break;
                    case 9:
                        pixelRatio = [
                            80,
                            33
                        ];
                        break;
                    case 10:
                        pixelRatio = [
                            18,
                            11
                        ];
                        break;
                    case 11:
                        pixelRatio = [
                            15,
                            11
                        ];
                        break;
                    case 12:
                        pixelRatio = [
                            64,
                            33
                        ];
                        break;
                    case 13:
                        pixelRatio = [
                            160,
                            99
                        ];
                        break;
                    case 14:
                        pixelRatio = [
                            4,
                            3
                        ];
                        break;
                    case 15:
                        pixelRatio = [
                            3,
                            2
                        ];
                        break;
                    case 16:
                        pixelRatio = [
                            2,
                            1
                        ];
                        break;
                    case 255:
                        pixelRatio = [
                            readUByte() << 8 | readUByte(),
                            readUByte() << 8 | readUByte()
                        ];
                        break;
                }
            }
        }
        return {
            width: Math.ceil((picWidthInMbsMinus1 + 1) * 16 - frameCropLeftOffset * 2 - frameCropRightOffset * 2),
            height: (2 - frameMbsOnlyFlag) * (picHeightInMapUnitsMinus1 + 1) * 16 - (frameMbsOnlyFlag ? 2 : 4) * (frameCropTopOffset + frameCropBottomOffset),
            pixelRatio: pixelRatio
        };
    }
}
class $b941786f4eb9cb76$var$HevcVideoParser extends $b941786f4eb9cb76$var$BaseVideoParser {
    constructor(...args){
        super(...args);
        this.initVPS = null;
    }
    parsePES(track, textTrack, pes, endOfSegment) {
        const units = this.parseNALu(track, pes.data, endOfSegment);
        let VideoSample = this.VideoSample;
        let push;
        let spsfound = false;
        // free pes.data to save up some memory
        pes.data = null;
        // if new NAL units found and last sample still there, let's push ...
        // this helps parsing streams with missing AUD (only do this if AUD never found)
        if (VideoSample && units.length && !track.audFound) {
            this.pushAccessUnit(VideoSample, track);
            VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
        }
        units.forEach((unit)=>{
            var _VideoSample2, _VideoSample3;
            switch(unit.type){
                // NON-IDR, NON RANDOM ACCESS SLICE
                case 0:
                case 1:
                case 2:
                case 3:
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
                    VideoSample.frame = true;
                    push = true;
                    break;
                // CRA, BLA (random access picture)
                case 16:
                case 17:
                case 18:
                case 21:
                    push = true;
                    if (spsfound) {
                        var _VideoSample;
                        // handle PES not starting with AUD
                        // if we have frame data already, that cannot belong to the same frame, so force a push
                        if ((_VideoSample = VideoSample) != null && _VideoSample.frame && !VideoSample.key) {
                            this.pushAccessUnit(VideoSample, track);
                            VideoSample = this.VideoSample = null;
                        }
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    VideoSample.frame = true;
                    break;
                // IDR
                case 19:
                case 20:
                    push = true;
                    // handle PES not starting with AUD
                    // if we have frame data already, that cannot belong to the same frame, so force a push
                    if ((_VideoSample2 = VideoSample) != null && _VideoSample2.frame && !VideoSample.key) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = this.VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    VideoSample.frame = true;
                    break;
                // SEI
                case 39:
                    push = true;
                    $b941786f4eb9cb76$var$parseSEIMessageFromNALu(unit.data, 2, // NALu header size
                    pes.pts, textTrack.samples);
                    break;
                // VPS
                case 32:
                    push = true;
                    if (!track.vps) {
                        if (typeof track.params !== 'object') track.params = {};
                        track.params = $b941786f4eb9cb76$var$_extends(track.params, this.readVPS(unit.data));
                        this.initVPS = unit.data;
                    }
                    track.vps = [
                        unit.data
                    ];
                    break;
                // SPS
                case 33:
                    push = true;
                    spsfound = true;
                    if (track.vps !== undefined && track.vps[0] !== this.initVPS && track.sps !== undefined && !this.matchSPS(track.sps[0], unit.data)) {
                        this.initVPS = track.vps[0];
                        track.sps = track.pps = undefined;
                    }
                    if (!track.sps) {
                        const config = this.readSPS(unit.data);
                        track.width = config.width;
                        track.height = config.height;
                        track.pixelRatio = config.pixelRatio;
                        track.codec = config.codecString;
                        track.sps = [];
                        if (typeof track.params !== 'object') track.params = {};
                        for(const prop in config.params)track.params[prop] = config.params[prop];
                    }
                    this.pushParameterSet(track.sps, unit.data, track.vps);
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(true, pes.pts, pes.dts);
                    VideoSample.key = true;
                    break;
                // PPS
                case 34:
                    push = true;
                    if (typeof track.params === 'object') {
                        if (!track.pps) {
                            track.pps = [];
                            const config = this.readPPS(unit.data);
                            for(const prop in config)track.params[prop] = config[prop];
                        }
                        this.pushParameterSet(track.pps, unit.data, track.vps);
                    }
                    break;
                // ACCESS UNIT DELIMITER
                case 35:
                    push = true;
                    track.audFound = true;
                    if ((_VideoSample3 = VideoSample) != null && _VideoSample3.frame) {
                        this.pushAccessUnit(VideoSample, track);
                        VideoSample = null;
                    }
                    if (!VideoSample) VideoSample = this.VideoSample = this.createVideoSample(false, pes.pts, pes.dts);
                    break;
                default:
                    push = false;
                    break;
            }
            if (VideoSample && push) {
                const units = VideoSample.units;
                units.push(unit);
            }
        });
        // if last PES packet, push samples
        if (endOfSegment && VideoSample) {
            this.pushAccessUnit(VideoSample, track);
            this.VideoSample = null;
        }
    }
    pushParameterSet(parameterSets, data, vps) {
        if (vps && vps[0] === this.initVPS || !vps && !parameterSets.length) parameterSets.push(data);
    }
    getNALuType(data, offset) {
        return (data[offset] & 0x7e) >>> 1;
    }
    ebsp2rbsp(arr) {
        const dst = new Uint8Array(arr.byteLength);
        let dstIdx = 0;
        for(let i = 0; i < arr.byteLength; i++){
            if (i >= 2) {
                // Unescape: Skip 0x03 after 00 00
                if (arr[i] === 0x03 && arr[i - 1] === 0x00 && arr[i - 2] === 0x00) continue;
            }
            dst[dstIdx] = arr[i];
            dstIdx++;
        }
        return new Uint8Array(dst.buffer, 0, dstIdx);
    }
    pushAccessUnit(VideoSample, videoTrack) {
        super.pushAccessUnit(VideoSample, videoTrack);
        if (this.initVPS) this.initVPS = null; // null initVPS to prevent possible track's sps/pps growth until next VPS
    }
    readVPS(vps) {
        const eg = new $b941786f4eb9cb76$var$ExpGolomb(vps);
        // remove header
        eg.readUByte();
        eg.readUByte();
        eg.readBits(4); // video_parameter_set_id
        eg.skipBits(2);
        eg.readBits(6); // max_layers_minus1
        const max_sub_layers_minus1 = eg.readBits(3);
        const temporal_id_nesting_flag = eg.readBoolean();
        // ...vui fps can be here, but empty fps value is not critical for metadata
        return {
            numTemporalLayers: max_sub_layers_minus1 + 1,
            temporalIdNested: temporal_id_nesting_flag
        };
    }
    readSPS(sps) {
        const eg = new $b941786f4eb9cb76$var$ExpGolomb(this.ebsp2rbsp(sps));
        eg.readUByte();
        eg.readUByte();
        eg.readBits(4); //video_parameter_set_id
        const max_sub_layers_minus1 = eg.readBits(3);
        eg.readBoolean(); // temporal_id_nesting_flag
        // profile_tier_level
        const general_profile_space = eg.readBits(2);
        const general_tier_flag = eg.readBoolean();
        const general_profile_idc = eg.readBits(5);
        const general_profile_compatibility_flags_1 = eg.readUByte();
        const general_profile_compatibility_flags_2 = eg.readUByte();
        const general_profile_compatibility_flags_3 = eg.readUByte();
        const general_profile_compatibility_flags_4 = eg.readUByte();
        const general_constraint_indicator_flags_1 = eg.readUByte();
        const general_constraint_indicator_flags_2 = eg.readUByte();
        const general_constraint_indicator_flags_3 = eg.readUByte();
        const general_constraint_indicator_flags_4 = eg.readUByte();
        const general_constraint_indicator_flags_5 = eg.readUByte();
        const general_constraint_indicator_flags_6 = eg.readUByte();
        const general_level_idc = eg.readUByte();
        const sub_layer_profile_present_flags = [];
        const sub_layer_level_present_flags = [];
        for(let i = 0; i < max_sub_layers_minus1; i++){
            sub_layer_profile_present_flags.push(eg.readBoolean());
            sub_layer_level_present_flags.push(eg.readBoolean());
        }
        if (max_sub_layers_minus1 > 0) for(let i = max_sub_layers_minus1; i < 8; i++)eg.readBits(2);
        for(let i = 0; i < max_sub_layers_minus1; i++){
            if (sub_layer_profile_present_flags[i]) {
                eg.readUByte(); // sub_layer_profile_space, sub_layer_tier_flag, sub_layer_profile_idc
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte(); // sub_layer_profile_compatibility_flag
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
                eg.readUByte();
            }
            if (sub_layer_level_present_flags[i]) eg.readUByte();
        }
        eg.readUEG(); // seq_parameter_set_id
        const chroma_format_idc = eg.readUEG();
        if (chroma_format_idc == 3) eg.skipBits(1); //separate_colour_plane_flag
        const pic_width_in_luma_samples = eg.readUEG();
        const pic_height_in_luma_samples = eg.readUEG();
        const conformance_window_flag = eg.readBoolean();
        let pic_left_offset = 0, pic_right_offset = 0, pic_top_offset = 0, pic_bottom_offset = 0;
        if (conformance_window_flag) {
            pic_left_offset += eg.readUEG();
            pic_right_offset += eg.readUEG();
            pic_top_offset += eg.readUEG();
            pic_bottom_offset += eg.readUEG();
        }
        const bit_depth_luma_minus8 = eg.readUEG();
        const bit_depth_chroma_minus8 = eg.readUEG();
        const log2_max_pic_order_cnt_lsb_minus4 = eg.readUEG();
        const sub_layer_ordering_info_present_flag = eg.readBoolean();
        for(let i = sub_layer_ordering_info_present_flag ? 0 : max_sub_layers_minus1; i <= max_sub_layers_minus1; i++){
            eg.skipUEG(); // max_dec_pic_buffering_minus1[i]
            eg.skipUEG(); // max_num_reorder_pics[i]
            eg.skipUEG(); // max_latency_increase_plus1[i]
        }
        eg.skipUEG(); // log2_min_luma_coding_block_size_minus3
        eg.skipUEG(); // log2_diff_max_min_luma_coding_block_size
        eg.skipUEG(); // log2_min_transform_block_size_minus2
        eg.skipUEG(); // log2_diff_max_min_transform_block_size
        eg.skipUEG(); // max_transform_hierarchy_depth_inter
        eg.skipUEG(); // max_transform_hierarchy_depth_intra
        const scaling_list_enabled_flag = eg.readBoolean();
        if (scaling_list_enabled_flag) {
            const sps_scaling_list_data_present_flag = eg.readBoolean();
            if (sps_scaling_list_data_present_flag) {
                for(let sizeId = 0; sizeId < 4; sizeId++)for(let matrixId = 0; matrixId < (sizeId === 3 ? 2 : 6); matrixId++){
                    const scaling_list_pred_mode_flag = eg.readBoolean();
                    if (!scaling_list_pred_mode_flag) eg.readUEG(); // scaling_list_pred_matrix_id_delta
                    else {
                        const coefNum = Math.min(64, 1 << 4 + (sizeId << 1));
                        if (sizeId > 1) eg.readEG();
                        for(let i = 0; i < coefNum; i++)eg.readEG();
                    }
                }
            }
        }
        eg.readBoolean(); // amp_enabled_flag
        eg.readBoolean(); // sample_adaptive_offset_enabled_flag
        const pcm_enabled_flag = eg.readBoolean();
        if (pcm_enabled_flag) {
            eg.readUByte();
            eg.skipUEG();
            eg.skipUEG();
            eg.readBoolean();
        }
        const num_short_term_ref_pic_sets = eg.readUEG();
        let num_delta_pocs = 0;
        for(let i = 0; i < num_short_term_ref_pic_sets; i++){
            let inter_ref_pic_set_prediction_flag = false;
            if (i !== 0) inter_ref_pic_set_prediction_flag = eg.readBoolean();
            if (inter_ref_pic_set_prediction_flag) {
                if (i === num_short_term_ref_pic_sets) eg.readUEG();
                eg.readBoolean();
                eg.readUEG();
                let next_num_delta_pocs = 0;
                for(let j = 0; j <= num_delta_pocs; j++){
                    const used_by_curr_pic_flag = eg.readBoolean();
                    let use_delta_flag = false;
                    if (!used_by_curr_pic_flag) use_delta_flag = eg.readBoolean();
                    if (used_by_curr_pic_flag || use_delta_flag) next_num_delta_pocs++;
                }
                num_delta_pocs = next_num_delta_pocs;
            } else {
                const num_negative_pics = eg.readUEG();
                const num_positive_pics = eg.readUEG();
                num_delta_pocs = num_negative_pics + num_positive_pics;
                for(let j = 0; j < num_negative_pics; j++){
                    eg.readUEG();
                    eg.readBoolean();
                }
                for(let j = 0; j < num_positive_pics; j++){
                    eg.readUEG();
                    eg.readBoolean();
                }
            }
        }
        const long_term_ref_pics_present_flag = eg.readBoolean();
        if (long_term_ref_pics_present_flag) {
            const num_long_term_ref_pics_sps = eg.readUEG();
            for(let i = 0; i < num_long_term_ref_pics_sps; i++){
                for(let j = 0; j < log2_max_pic_order_cnt_lsb_minus4 + 4; j++)eg.readBits(1);
                eg.readBits(1);
            }
        }
        let min_spatial_segmentation_idc = 0;
        let sar_width = 1, sar_height = 1;
        let fps_fixed = true, fps_den = 1, fps_num = 0;
        eg.readBoolean(); // sps_temporal_mvp_enabled_flag
        eg.readBoolean(); // strong_intra_smoothing_enabled_flag
        let default_display_window_flag = false;
        const vui_parameters_present_flag = eg.readBoolean();
        if (vui_parameters_present_flag) {
            const aspect_ratio_info_present_flag = eg.readBoolean();
            if (aspect_ratio_info_present_flag) {
                const aspect_ratio_idc = eg.readUByte();
                const sar_width_table = [
                    1,
                    12,
                    10,
                    16,
                    40,
                    24,
                    20,
                    32,
                    80,
                    18,
                    15,
                    64,
                    160,
                    4,
                    3,
                    2
                ];
                const sar_height_table = [
                    1,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    11,
                    33,
                    11,
                    11,
                    33,
                    99,
                    3,
                    2,
                    1
                ];
                if (aspect_ratio_idc > 0 && aspect_ratio_idc < 16) {
                    sar_width = sar_width_table[aspect_ratio_idc - 1];
                    sar_height = sar_height_table[aspect_ratio_idc - 1];
                } else if (aspect_ratio_idc === 255) {
                    sar_width = eg.readBits(16);
                    sar_height = eg.readBits(16);
                }
            }
            const overscan_info_present_flag = eg.readBoolean();
            if (overscan_info_present_flag) eg.readBoolean();
            const video_signal_type_present_flag = eg.readBoolean();
            if (video_signal_type_present_flag) {
                eg.readBits(3);
                eg.readBoolean();
                const colour_description_present_flag = eg.readBoolean();
                if (colour_description_present_flag) {
                    eg.readUByte();
                    eg.readUByte();
                    eg.readUByte();
                }
            }
            const chroma_loc_info_present_flag = eg.readBoolean();
            if (chroma_loc_info_present_flag) {
                eg.readUEG();
                eg.readUEG();
            }
            eg.readBoolean(); // neutral_chroma_indication_flag
            eg.readBoolean(); // field_seq_flag
            eg.readBoolean(); // frame_field_info_present_flag
            default_display_window_flag = eg.readBoolean();
            if (default_display_window_flag) {
                eg.skipUEG();
                eg.skipUEG();
                eg.skipUEG();
                eg.skipUEG();
            }
            const vui_timing_info_present_flag = eg.readBoolean();
            if (vui_timing_info_present_flag) {
                fps_den = eg.readBits(32);
                fps_num = eg.readBits(32);
                const vui_poc_proportional_to_timing_flag = eg.readBoolean();
                if (vui_poc_proportional_to_timing_flag) eg.readUEG();
                const vui_hrd_parameters_present_flag = eg.readBoolean();
                if (vui_hrd_parameters_present_flag) {
                    //const commonInfPresentFlag = true;
                    //if (commonInfPresentFlag) {
                    const nal_hrd_parameters_present_flag = eg.readBoolean();
                    const vcl_hrd_parameters_present_flag = eg.readBoolean();
                    let sub_pic_hrd_params_present_flag = false;
                    if (nal_hrd_parameters_present_flag || vcl_hrd_parameters_present_flag) {
                        sub_pic_hrd_params_present_flag = eg.readBoolean();
                        if (sub_pic_hrd_params_present_flag) {
                            eg.readUByte();
                            eg.readBits(5);
                            eg.readBoolean();
                            eg.readBits(5);
                        }
                        eg.readBits(4); // bit_rate_scale
                        eg.readBits(4); // cpb_size_scale
                        if (sub_pic_hrd_params_present_flag) eg.readBits(4);
                        eg.readBits(5);
                        eg.readBits(5);
                        eg.readBits(5);
                    }
                    //}
                    for(let i = 0; i <= max_sub_layers_minus1; i++){
                        fps_fixed = eg.readBoolean(); // fixed_pic_rate_general_flag
                        const fixed_pic_rate_within_cvs_flag = fps_fixed || eg.readBoolean();
                        let low_delay_hrd_flag = false;
                        if (fixed_pic_rate_within_cvs_flag) eg.readEG();
                        else low_delay_hrd_flag = eg.readBoolean();
                        const cpb_cnt = low_delay_hrd_flag ? 1 : eg.readUEG() + 1;
                        if (nal_hrd_parameters_present_flag) for(let j = 0; j < cpb_cnt; j++){
                            eg.readUEG();
                            eg.readUEG();
                            if (sub_pic_hrd_params_present_flag) {
                                eg.readUEG();
                                eg.readUEG();
                            }
                            eg.skipBits(1);
                        }
                        if (vcl_hrd_parameters_present_flag) for(let j = 0; j < cpb_cnt; j++){
                            eg.readUEG();
                            eg.readUEG();
                            if (sub_pic_hrd_params_present_flag) {
                                eg.readUEG();
                                eg.readUEG();
                            }
                            eg.skipBits(1);
                        }
                    }
                }
            }
            const bitstream_restriction_flag = eg.readBoolean();
            if (bitstream_restriction_flag) {
                eg.readBoolean(); // tiles_fixed_structure_flag
                eg.readBoolean(); // motion_vectors_over_pic_boundaries_flag
                eg.readBoolean(); // restricted_ref_pic_lists_flag
                min_spatial_segmentation_idc = eg.readUEG();
            }
        }
        let width = pic_width_in_luma_samples, height = pic_height_in_luma_samples;
        if (conformance_window_flag) {
            let chroma_scale_w = 1, chroma_scale_h = 1;
            if (chroma_format_idc === 1) // YUV 420
            chroma_scale_w = chroma_scale_h = 2;
            else if (chroma_format_idc == 2) // YUV 422
            chroma_scale_w = 2;
            width = pic_width_in_luma_samples - chroma_scale_w * pic_right_offset - chroma_scale_w * pic_left_offset;
            height = pic_height_in_luma_samples - chroma_scale_h * pic_bottom_offset - chroma_scale_h * pic_top_offset;
        }
        const profile_space_string = general_profile_space ? [
            'A',
            'B',
            'C'
        ][general_profile_space] : '';
        const profile_compatibility_buf = general_profile_compatibility_flags_1 << 24 | general_profile_compatibility_flags_2 << 16 | general_profile_compatibility_flags_3 << 8 | general_profile_compatibility_flags_4;
        let profile_compatibility_rev = 0;
        for(let i = 0; i < 32; i++)profile_compatibility_rev = (profile_compatibility_rev | (profile_compatibility_buf >> i & 1) << 31 - i) >>> 0; // reverse bit position (and cast as UInt32)
        let profile_compatibility_flags_string = profile_compatibility_rev.toString(16);
        if (general_profile_idc === 1 && profile_compatibility_flags_string === '2') profile_compatibility_flags_string = '6';
        const tier_flag_string = general_tier_flag ? 'H' : 'L';
        return {
            codecString: `hvc1.${profile_space_string}${general_profile_idc}.${profile_compatibility_flags_string}.${tier_flag_string}${general_level_idc}.B0`,
            params: {
                general_tier_flag: general_tier_flag,
                general_profile_idc: general_profile_idc,
                general_profile_space: general_profile_space,
                general_profile_compatibility_flags: [
                    general_profile_compatibility_flags_1,
                    general_profile_compatibility_flags_2,
                    general_profile_compatibility_flags_3,
                    general_profile_compatibility_flags_4
                ],
                general_constraint_indicator_flags: [
                    general_constraint_indicator_flags_1,
                    general_constraint_indicator_flags_2,
                    general_constraint_indicator_flags_3,
                    general_constraint_indicator_flags_4,
                    general_constraint_indicator_flags_5,
                    general_constraint_indicator_flags_6
                ],
                general_level_idc: general_level_idc,
                bit_depth: bit_depth_luma_minus8 + 8,
                bit_depth_luma_minus8: bit_depth_luma_minus8,
                bit_depth_chroma_minus8: bit_depth_chroma_minus8,
                min_spatial_segmentation_idc: min_spatial_segmentation_idc,
                chroma_format_idc: chroma_format_idc,
                frame_rate: {
                    fixed: fps_fixed,
                    fps: fps_num / fps_den
                }
            },
            width: width,
            height: height,
            pixelRatio: [
                sar_width,
                sar_height
            ]
        };
    }
    readPPS(pps) {
        const eg = new $b941786f4eb9cb76$var$ExpGolomb(this.ebsp2rbsp(pps));
        eg.readUByte();
        eg.readUByte();
        eg.skipUEG(); // pic_parameter_set_id
        eg.skipUEG(); // seq_parameter_set_id
        eg.skipBits(2); // dependent_slice_segments_enabled_flag, output_flag_present_flag
        eg.skipBits(3); // num_extra_slice_header_bits
        eg.skipBits(2); // sign_data_hiding_enabled_flag, cabac_init_present_flag
        eg.skipUEG();
        eg.skipUEG();
        eg.skipEG(); // init_qp_minus26
        eg.skipBits(2); // constrained_intra_pred_flag, transform_skip_enabled_flag
        const cu_qp_delta_enabled_flag = eg.readBoolean();
        if (cu_qp_delta_enabled_flag) eg.skipUEG();
        eg.skipEG(); // cb_qp_offset
        eg.skipEG(); // cr_qp_offset
        eg.skipBits(4); // pps_slice_chroma_qp_offsets_present_flag, weighted_pred_flag, weighted_bipred_flag, transquant_bypass_enabled_flag
        const tiles_enabled_flag = eg.readBoolean();
        const entropy_coding_sync_enabled_flag = eg.readBoolean();
        let parallelismType = 1; // slice-based parallel decoding
        if (entropy_coding_sync_enabled_flag && tiles_enabled_flag) parallelismType = 0; // mixed-type parallel decoding
        else if (entropy_coding_sync_enabled_flag) parallelismType = 3; // wavefront-based parallel decoding
        else if (tiles_enabled_flag) parallelismType = 2; // tile-based parallel decoding
        return {
            parallelismType: parallelismType
        };
    }
    matchSPS(sps1, sps2) {
        // compare without headers and VPS related params
        return String.fromCharCode.apply(null, sps1).substr(3) === String.fromCharCode.apply(null, sps2).substr(3);
    }
}
const $b941786f4eb9cb76$var$PACKET_LENGTH = 188;
class $b941786f4eb9cb76$var$TSDemuxer {
    constructor(observer, config, typeSupported, logger){
        this.logger = void 0;
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.sampleAes = null;
        this.pmtParsed = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this._pmtId = -1;
        this._videoTrack = void 0;
        this._audioTrack = void 0;
        this._id3Track = void 0;
        this._txtTrack = void 0;
        this.aacOverFlow = null;
        this.remainderData = null;
        this.videoParser = void 0;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.logger = logger;
        this.videoParser = null;
    }
    static probe(data, logger) {
        const syncOffset = $b941786f4eb9cb76$var$TSDemuxer.syncOffset(data);
        if (syncOffset > 0) logger.warn(`MPEG2-TS detected but first sync word found @ offset ${syncOffset}`);
        return syncOffset !== -1;
    }
    static syncOffset(data) {
        const length = data.length;
        let scanwindow = Math.min($b941786f4eb9cb76$var$PACKET_LENGTH * 5, length - $b941786f4eb9cb76$var$PACKET_LENGTH) + 1;
        let i = 0;
        while(i < scanwindow){
            // a TS init segment should contain at least 2 TS packets: PAT and PMT, each starting with 0x47
            let foundPat = false;
            let packetStart = -1;
            let tsPackets = 0;
            for(let j = i; j < length; j += $b941786f4eb9cb76$var$PACKET_LENGTH){
                if (data[j] === 0x47 && (length - j === $b941786f4eb9cb76$var$PACKET_LENGTH || data[j + $b941786f4eb9cb76$var$PACKET_LENGTH] === 0x47)) {
                    tsPackets++;
                    if (packetStart === -1) {
                        packetStart = j;
                        // First sync word found at offset, increase scan length (#5251)
                        if (packetStart !== 0) scanwindow = Math.min(packetStart + $b941786f4eb9cb76$var$PACKET_LENGTH * 99, data.length - $b941786f4eb9cb76$var$PACKET_LENGTH) + 1;
                    }
                    if (!foundPat) foundPat = $b941786f4eb9cb76$var$parsePID(data, j) === 0;
                    // Sync word found at 0 with 3 packets, or found at offset least 2 packets up to scanwindow (#5501)
                    if (foundPat && tsPackets > 1 && (packetStart === 0 && tsPackets > 2 || j + $b941786f4eb9cb76$var$PACKET_LENGTH > scanwindow)) return packetStart;
                } else if (tsPackets) // Exit if sync word found, but does not contain contiguous packets
                return -1;
                else break;
            }
            i++;
        }
        return -1;
    }
    /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */ static createTrack(type, duration) {
        return {
            container: type === 'video' || type === 'audio' ? 'video/mp2t' : undefined,
            type: type,
            id: $b941786f4eb9cb76$var$RemuxerTrackIdConfig[type],
            pid: -1,
            inputTimeScale: 90000,
            sequenceNumber: 0,
            samples: [],
            dropped: 0,
            duration: type === 'audio' ? duration : undefined
        };
    }
    /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */ resetInitSegment(initSegment, audioCodec, videoCodec, trackDuration) {
        this.pmtParsed = false;
        this._pmtId = -1;
        this._videoTrack = $b941786f4eb9cb76$var$TSDemuxer.createTrack('video');
        this._videoTrack.duration = trackDuration;
        this._audioTrack = $b941786f4eb9cb76$var$TSDemuxer.createTrack('audio', trackDuration);
        this._id3Track = $b941786f4eb9cb76$var$TSDemuxer.createTrack('id3');
        this._txtTrack = $b941786f4eb9cb76$var$TSDemuxer.createTrack('text');
        this._audioTrack.segmentCodec = 'aac';
        // flush any partial content
        this.videoParser = null;
        this.aacOverFlow = null;
        this.remainderData = null;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
    }
    resetTimeStamp() {}
    resetContiguity() {
        const { _audioTrack: _audioTrack, _videoTrack: _videoTrack, _id3Track: _id3Track } = this;
        if (_audioTrack) _audioTrack.pesData = null;
        if (_videoTrack) _videoTrack.pesData = null;
        if (_id3Track) _id3Track.pesData = null;
        this.aacOverFlow = null;
        this.remainderData = null;
    }
    demux(data, timeOffset, isSampleAes = false, flush = false) {
        if (!isSampleAes) this.sampleAes = null;
        let pes;
        const videoTrack = this._videoTrack;
        const audioTrack = this._audioTrack;
        const id3Track = this._id3Track;
        const textTrack = this._txtTrack;
        let videoPid = videoTrack.pid;
        let videoData = videoTrack.pesData;
        let audioPid = audioTrack.pid;
        let id3Pid = id3Track.pid;
        let audioData = audioTrack.pesData;
        let id3Data = id3Track.pesData;
        let unknownPID = null;
        let pmtParsed = this.pmtParsed;
        let pmtId = this._pmtId;
        let len = data.length;
        if (this.remainderData) {
            data = $b941786f4eb9cb76$var$appendUint8Array(this.remainderData, data);
            len = data.length;
            this.remainderData = null;
        }
        if (len < $b941786f4eb9cb76$var$PACKET_LENGTH && !flush) {
            this.remainderData = data;
            return {
                audioTrack: audioTrack,
                videoTrack: videoTrack,
                id3Track: id3Track,
                textTrack: textTrack
            };
        }
        const syncOffset = Math.max(0, $b941786f4eb9cb76$var$TSDemuxer.syncOffset(data));
        len -= (len - syncOffset) % $b941786f4eb9cb76$var$PACKET_LENGTH;
        if (len < data.byteLength && !flush) this.remainderData = new Uint8Array(data.buffer, len, data.buffer.byteLength - len);
        // loop through TS packets
        let tsPacketErrors = 0;
        for(let start = syncOffset; start < len; start += $b941786f4eb9cb76$var$PACKET_LENGTH)if (data[start] === 0x47) {
            const stt = !!(data[start + 1] & 0x40);
            const pid = $b941786f4eb9cb76$var$parsePID(data, start);
            const atf = (data[start + 3] & 0x30) >> 4;
            // if an adaption field is present, its length is specified by the fifth byte of the TS packet header.
            let offset;
            if (atf > 1) {
                offset = start + 5 + data[start + 4];
                // continue if there is only adaptation field
                if (offset === start + $b941786f4eb9cb76$var$PACKET_LENGTH) continue;
            } else offset = start + 4;
            switch(pid){
                case videoPid:
                    if (stt) {
                        if (videoData && (pes = $b941786f4eb9cb76$var$parsePES(videoData, this.logger))) {
                            this.readyVideoParser(videoTrack.segmentCodec);
                            if (this.videoParser !== null) this.videoParser.parsePES(videoTrack, textTrack, pes, false);
                        }
                        videoData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (videoData) {
                        videoData.data.push(data.subarray(offset, start + $b941786f4eb9cb76$var$PACKET_LENGTH));
                        videoData.size += start + $b941786f4eb9cb76$var$PACKET_LENGTH - offset;
                    }
                    break;
                case audioPid:
                    if (stt) {
                        if (audioData && (pes = $b941786f4eb9cb76$var$parsePES(audioData, this.logger))) switch(audioTrack.segmentCodec){
                            case 'aac':
                                this.parseAACPES(audioTrack, pes);
                                break;
                            case 'mp3':
                                this.parseMPEGPES(audioTrack, pes);
                                break;
                            case 'ac3':
                                this.parseAC3PES(audioTrack, pes);
                                break;
                        }
                        audioData = {
                            data: [],
                            size: 0
                        };
                    }
                    if (audioData) {
                        audioData.data.push(data.subarray(offset, start + $b941786f4eb9cb76$var$PACKET_LENGTH));
                        audioData.size += start + $b941786f4eb9cb76$var$PACKET_LENGTH - offset;
                    }
                    break;
                case id3Pid:
                    if (stt) {
                        if (id3Data && (pes = $b941786f4eb9cb76$var$parsePES(id3Data, this.logger))) this.parseID3PES(id3Track, pes);
                        id3Data = {
                            data: [],
                            size: 0
                        };
                    }
                    if (id3Data) {
                        id3Data.data.push(data.subarray(offset, start + $b941786f4eb9cb76$var$PACKET_LENGTH));
                        id3Data.size += start + $b941786f4eb9cb76$var$PACKET_LENGTH - offset;
                    }
                    break;
                case 0:
                    if (stt) offset += data[offset] + 1;
                    pmtId = this._pmtId = $b941786f4eb9cb76$var$parsePAT(data, offset);
                    break;
                case pmtId:
                    {
                        if (stt) offset += data[offset] + 1;
                        const parsedPIDs = $b941786f4eb9cb76$var$parsePMT(data, offset, this.typeSupported, isSampleAes, this.observer, this.logger);
                        // only update track id if track PID found while parsing PMT
                        // this is to avoid resetting the PID to -1 in case
                        // track PID transiently disappears from the stream
                        // this could happen in case of transient missing audio samples for example
                        // NOTE this is only the PID of the track as found in TS,
                        // but we are not using this for MP4 track IDs.
                        videoPid = parsedPIDs.videoPid;
                        if (videoPid > 0) {
                            videoTrack.pid = videoPid;
                            videoTrack.segmentCodec = parsedPIDs.segmentVideoCodec;
                        }
                        audioPid = parsedPIDs.audioPid;
                        if (audioPid > 0) {
                            audioTrack.pid = audioPid;
                            audioTrack.segmentCodec = parsedPIDs.segmentAudioCodec;
                        }
                        id3Pid = parsedPIDs.id3Pid;
                        if (id3Pid > 0) id3Track.pid = id3Pid;
                        if (unknownPID !== null && !pmtParsed) {
                            this.logger.warn(`MPEG-TS PMT found at ${start} after unknown PID '${unknownPID}'. Backtracking to sync byte @${syncOffset} to parse all TS packets.`);
                            unknownPID = null;
                            // we set it to -188, the += 188 in the for loop will reset start to 0
                            start = syncOffset - 188;
                        }
                        pmtParsed = this.pmtParsed = true;
                        break;
                    }
                case 0x11:
                case 0x1fff:
                    break;
                default:
                    unknownPID = pid;
                    break;
            }
        } else tsPacketErrors++;
        if (tsPacketErrors > 0) $b941786f4eb9cb76$var$emitParsingError(this.observer, new Error(`Found ${tsPacketErrors} TS packet/s that do not start with 0x47`), undefined, this.logger);
        videoTrack.pesData = videoData;
        audioTrack.pesData = audioData;
        id3Track.pesData = id3Data;
        const demuxResult = {
            audioTrack: audioTrack,
            videoTrack: videoTrack,
            id3Track: id3Track,
            textTrack: textTrack
        };
        if (flush) this.extractRemainingSamples(demuxResult);
        return demuxResult;
    }
    flush() {
        const { remainderData: remainderData } = this;
        this.remainderData = null;
        let result;
        if (remainderData) result = this.demux(remainderData, -1, false, true);
        else result = {
            videoTrack: this._videoTrack,
            audioTrack: this._audioTrack,
            id3Track: this._id3Track,
            textTrack: this._txtTrack
        };
        this.extractRemainingSamples(result);
        if (this.sampleAes) return this.decrypt(result, this.sampleAes);
        return result;
    }
    extractRemainingSamples(demuxResult) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = demuxResult;
        const videoData = videoTrack.pesData;
        const audioData = audioTrack.pesData;
        const id3Data = id3Track.pesData;
        // try to parse last PES packets
        let pes;
        if (videoData && (pes = $b941786f4eb9cb76$var$parsePES(videoData, this.logger))) {
            this.readyVideoParser(videoTrack.segmentCodec);
            if (this.videoParser !== null) {
                this.videoParser.parsePES(videoTrack, textTrack, pes, true);
                videoTrack.pesData = null;
            }
        } else // either avcData null or PES truncated, keep it for next frag parsing
        videoTrack.pesData = videoData;
        if (audioData && (pes = $b941786f4eb9cb76$var$parsePES(audioData, this.logger))) {
            switch(audioTrack.segmentCodec){
                case 'aac':
                    this.parseAACPES(audioTrack, pes);
                    break;
                case 'mp3':
                    this.parseMPEGPES(audioTrack, pes);
                    break;
                case 'ac3':
                    this.parseAC3PES(audioTrack, pes);
                    break;
            }
            audioTrack.pesData = null;
        } else {
            if (audioData != null && audioData.size) this.logger.log('last AAC PES packet truncated,might overlap between fragments');
            // either audioData null or PES truncated, keep it for next frag parsing
            audioTrack.pesData = audioData;
        }
        if (id3Data && (pes = $b941786f4eb9cb76$var$parsePES(id3Data, this.logger))) {
            this.parseID3PES(id3Track, pes);
            id3Track.pesData = null;
        } else // either id3Data null or PES truncated, keep it for next frag parsing
        id3Track.pesData = id3Data;
    }
    demuxSampleAes(data, keyData, timeOffset) {
        const demuxResult = this.demux(data, timeOffset, true, !this.config.progressive);
        const sampleAes = this.sampleAes = new $b941786f4eb9cb76$var$SampleAesDecrypter(this.observer, this.config, keyData);
        return this.decrypt(demuxResult, sampleAes);
    }
    readyVideoParser(codec) {
        if (this.videoParser === null) {
            if (codec === 'avc') this.videoParser = new $b941786f4eb9cb76$var$AvcVideoParser();
            else if (codec === 'hevc') this.videoParser = new $b941786f4eb9cb76$var$HevcVideoParser();
        }
    }
    decrypt(demuxResult, sampleAes) {
        return new Promise((resolve)=>{
            const { audioTrack: audioTrack, videoTrack: videoTrack } = demuxResult;
            if (audioTrack.samples && audioTrack.segmentCodec === 'aac') sampleAes.decryptAacSamples(audioTrack.samples, 0, ()=>{
                if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                    resolve(demuxResult);
                });
                else resolve(demuxResult);
            });
            else if (videoTrack.samples) sampleAes.decryptAvcSamples(videoTrack.samples, 0, 0, ()=>{
                resolve(demuxResult);
            });
        });
    }
    destroy() {
        if (this.observer) this.observer.removeAllListeners();
        // @ts-ignore
        this.config = this.logger = this.observer = null;
        this.aacOverFlow = this.videoParser = this.remainderData = this.sampleAes = null;
        this._videoTrack = this._audioTrack = this._id3Track = this._txtTrack = undefined;
    }
    parseAACPES(track, pes) {
        let startOffset = 0;
        const aacOverFlow = this.aacOverFlow;
        let data = pes.data;
        if (aacOverFlow) {
            this.aacOverFlow = null;
            const frameMissingBytes = aacOverFlow.missing;
            const sampleLength = aacOverFlow.sample.unit.byteLength;
            // logger.log(`AAC: append overflowing ${sampleLength} bytes to beginning of new PES`);
            if (frameMissingBytes === -1) data = $b941786f4eb9cb76$var$appendUint8Array(aacOverFlow.sample.unit, data);
            else {
                const frameOverflowBytes = sampleLength - frameMissingBytes;
                aacOverFlow.sample.unit.set(data.subarray(0, frameMissingBytes), frameOverflowBytes);
                track.samples.push(aacOverFlow.sample);
                startOffset = aacOverFlow.missing;
            }
        }
        // look for ADTS header (0xFFFx)
        let offset;
        let len;
        for(offset = startOffset, len = data.length; offset < len - 1; offset++){
            if ($b941786f4eb9cb76$var$isHeader$1(data, offset)) break;
        }
        // if ADTS header does not start straight from the beginning of the PES payload, raise an error
        if (offset !== startOffset) {
            let reason;
            const recoverable = offset < len - 1;
            if (recoverable) reason = `AAC PES did not start with ADTS header,offset:${offset}`;
            else reason = 'No ADTS header found in AAC PES';
            $b941786f4eb9cb76$var$emitParsingError(this.observer, new Error(reason), recoverable, this.logger);
            if (!recoverable) return;
        }
        $b941786f4eb9cb76$var$initTrackConfig(track, this.observer, data, offset, this.audioCodec);
        let pts;
        if (pes.pts !== undefined) pts = pes.pts;
        else if (aacOverFlow) {
            // if last AAC frame is overflowing, we should ensure timestamps are contiguous:
            // first sample PTS should be equal to last sample PTS + frameDuration
            const frameDuration = $b941786f4eb9cb76$var$getFrameDuration(track.samplerate);
            pts = aacOverFlow.sample.pts + frameDuration;
        } else {
            this.logger.warn('[tsdemuxer]: AAC PES unknown PTS');
            return;
        }
        // scan for aac samples
        let frameIndex = 0;
        let frame;
        while(offset < len){
            frame = $b941786f4eb9cb76$var$appendFrame$2(track, data, offset, pts, frameIndex);
            offset += frame.length;
            if (!frame.missing) {
                frameIndex++;
                for(; offset < len - 1; offset++){
                    if ($b941786f4eb9cb76$var$isHeader$1(data, offset)) break;
                }
            } else {
                this.aacOverFlow = frame;
                break;
            }
        }
    }
    parseMPEGPES(track, pes) {
        const data = pes.data;
        const length = data.length;
        let frameIndex = 0;
        let offset = 0;
        const pts = pes.pts;
        if (pts === undefined) {
            this.logger.warn('[tsdemuxer]: MPEG PES unknown PTS');
            return;
        }
        while(offset < length)if ($b941786f4eb9cb76$var$isHeader(data, offset)) {
            const frame = $b941786f4eb9cb76$var$appendFrame$1(track, data, offset, pts, frameIndex);
            if (frame) {
                offset += frame.length;
                frameIndex++;
            } else break;
        } else // nothing found, keep looking
        offset++;
    }
    parseAC3PES(track, pes) {
        {
            const data = pes.data;
            const pts = pes.pts;
            if (pts === undefined) {
                this.logger.warn('[tsdemuxer]: AC3 PES unknown PTS');
                return;
            }
            const length = data.length;
            let frameIndex = 0;
            let offset = 0;
            let parsed;
            while(offset < length && (parsed = $b941786f4eb9cb76$var$appendFrame(track, data, offset, pts, frameIndex++)) > 0)offset += parsed;
        }
    }
    parseID3PES(id3Track, pes) {
        if (pes.pts === undefined) {
            this.logger.warn('[tsdemuxer]: ID3 PES unknown PTS');
            return;
        }
        const id3Sample = $b941786f4eb9cb76$var$_extends({}, pes, {
            type: this._videoTrack ? $b941786f4eb9cb76$export$3f0d1211c87abf7f.emsg : $b941786f4eb9cb76$export$3f0d1211c87abf7f.audioId3,
            duration: Number.POSITIVE_INFINITY
        });
        id3Track.samples.push(id3Sample);
    }
}
function $b941786f4eb9cb76$var$parsePID(data, offset) {
    // pid is a 13-bit field starting at the last bit of TS[1]
    return ((data[offset + 1] & 0x1f) << 8) + data[offset + 2];
}
function $b941786f4eb9cb76$var$parsePAT(data, offset) {
    // skip the PSI header and parse the first PMT entry
    return (data[offset + 10] & 0x1f) << 8 | data[offset + 11];
}
function $b941786f4eb9cb76$var$parsePMT(data, offset, typeSupported, isSampleAes, observer, logger) {
    const result = {
        audioPid: -1,
        videoPid: -1,
        id3Pid: -1,
        segmentVideoCodec: 'avc',
        segmentAudioCodec: 'aac'
    };
    const sectionLength = (data[offset + 1] & 0x0f) << 8 | data[offset + 2];
    const tableEnd = offset + 3 + sectionLength - 4;
    // to determine where the table is, we have to figure out how
    // long the program info descriptors are
    const programInfoLength = (data[offset + 10] & 0x0f) << 8 | data[offset + 11];
    // advance the offset to the first entry in the mapping table
    offset += 12 + programInfoLength;
    while(offset < tableEnd){
        const pid = $b941786f4eb9cb76$var$parsePID(data, offset);
        const esInfoLength = (data[offset + 3] & 0x0f) << 8 | data[offset + 4];
        switch(data[offset]){
            case 0xcf:
                // SAMPLE-AES AAC
                if (!isSampleAes) {
                    $b941786f4eb9cb76$var$logEncryptedSamplesFoundInUnencryptedStream('ADTS AAC', logger);
                    break;
                }
            /* falls through */ case 0x0f:
                // ISO/IEC 13818-7 ADTS AAC (MPEG-2 lower bit-rate audio)
                // logger.log('AAC PID:'  + pid);
                if (result.audioPid === -1) result.audioPid = pid;
                break;
            // Packetized metadata (ID3)
            case 0x15:
                // logger.log('ID3 PID:'  + pid);
                if (result.id3Pid === -1) result.id3Pid = pid;
                break;
            case 0xdb:
                // SAMPLE-AES AVC
                if (!isSampleAes) {
                    $b941786f4eb9cb76$var$logEncryptedSamplesFoundInUnencryptedStream('H.264', logger);
                    break;
                }
            /* falls through */ case 0x1b:
                // ITU-T Rec. H.264 and ISO/IEC 14496-10 (lower bit-rate video)
                // logger.log('AVC PID:'  + pid);
                if (result.videoPid === -1) result.videoPid = pid;
                break;
            // ISO/IEC 11172-3 (MPEG-1 audio)
            // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
            case 0x03:
            case 0x04:
                // logger.log('MPEG PID:'  + pid);
                if (!typeSupported.mpeg && !typeSupported.mp3) logger.log('MPEG audio found, not supported in this browser');
                else if (result.audioPid === -1) {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'mp3';
                }
                break;
            case 0xc1:
                // SAMPLE-AES AC3
                if (!isSampleAes) {
                    $b941786f4eb9cb76$var$logEncryptedSamplesFoundInUnencryptedStream('AC-3', logger);
                    break;
                }
            /* falls through */ case 0x81:
                if (!typeSupported.ac3) logger.log('AC-3 audio found, not supported in this browser');
                else if (result.audioPid === -1) {
                    result.audioPid = pid;
                    result.segmentAudioCodec = 'ac3';
                }
                break;
            case 0x06:
                // stream_type 6 can mean a lot of different things in case of DVB.
                // We need to look at the descriptors. Right now, we're only interested
                // in AC-3 audio, so we do the descriptor parsing only when we don't have
                // an audio PID yet.
                if (result.audioPid === -1 && esInfoLength > 0) {
                    let parsePos = offset + 5;
                    let remaining = esInfoLength;
                    while(remaining > 2){
                        const descriptorId = data[parsePos];
                        switch(descriptorId){
                            case 0x6a:
                                if (typeSupported.ac3 !== true) logger.log('AC-3 audio found, not supported in this browser for now');
                                else {
                                    result.audioPid = pid;
                                    result.segmentAudioCodec = 'ac3';
                                }
                                break;
                        }
                        const descriptorLen = data[parsePos + 1] + 2;
                        parsePos += descriptorLen;
                        remaining -= descriptorLen;
                    }
                }
                break;
            case 0xc2:
            /* falls through */ case 0x87:
                $b941786f4eb9cb76$var$emitParsingError(observer, new Error('Unsupported EC-3 in M2TS found'), undefined, logger);
                return result;
            case 0x24:
                if (result.videoPid === -1) {
                    result.videoPid = pid;
                    result.segmentVideoCodec = 'hevc';
                    logger.log('HEVC in M2TS found');
                }
                break;
        }
        // move to the next table entry
        // skip past the elementary stream descriptors, if present
        offset += esInfoLength + 5;
    }
    return result;
}
function $b941786f4eb9cb76$var$emitParsingError(observer, error, levelRetry, logger) {
    logger.warn(`parsing error: ${error.message}`);
    observer.emit($b941786f4eb9cb76$export$ada873a34909da65.ERROR, $b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
        details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
        fatal: false,
        levelRetry: levelRetry,
        error: error,
        reason: error.message
    });
}
function $b941786f4eb9cb76$var$logEncryptedSamplesFoundInUnencryptedStream(type, logger) {
    logger.log(`${type} with AES-128-CBC encryption found in unencrypted stream`);
}
function $b941786f4eb9cb76$var$parsePES(stream, logger) {
    let i = 0;
    let frag;
    let pesLen;
    let pesHdrLen;
    let pesPts;
    let pesDts;
    const data = stream.data;
    // safety check
    if (!stream || stream.size === 0) return null;
    // we might need up to 19 bytes to read PES header
    // if first chunk of data is less than 19 bytes, let's merge it with following ones until we get 19 bytes
    // usually only one merge is needed (and this is rare ...)
    while(data[0].length < 19 && data.length > 1){
        data[0] = $b941786f4eb9cb76$var$appendUint8Array(data[0], data[1]);
        data.splice(1, 1);
    }
    // retrieve PTS/DTS from first fragment
    frag = data[0];
    const pesPrefix = (frag[0] << 16) + (frag[1] << 8) + frag[2];
    if (pesPrefix === 1) {
        pesLen = (frag[4] << 8) + frag[5];
        // if PES parsed length is not zero and greater than total received length, stop parsing. PES might be truncated
        // minus 6 : PES header size
        if (pesLen && pesLen > stream.size - 6) return null;
        const pesFlags = frag[7];
        if (pesFlags & 0xc0) {
            /* PES header described here : http://dvd.sourceforge.net/dvdinfo/pes-hdr.html
          as PTS / DTS is 33 bit we cannot use bitwise operator in JS,
          as Bitwise operators treat their operands as a sequence of 32 bits */ pesPts = (frag[9] & 0x0e) * 536870912 + // 1 << 29
            (frag[10] & 0xff) * 4194304 + // 1 << 22
            (frag[11] & 0xfe) * 16384 + // 1 << 14
            (frag[12] & 0xff) * 128 + // 1 << 7
            (frag[13] & 0xfe) / 2;
            if (pesFlags & 0x40) {
                pesDts = (frag[14] & 0x0e) * 536870912 + // 1 << 29
                (frag[15] & 0xff) * 4194304 + // 1 << 22
                (frag[16] & 0xfe) * 16384 + // 1 << 14
                (frag[17] & 0xff) * 128 + // 1 << 7
                (frag[18] & 0xfe) / 2;
                if (pesPts - pesDts > 5400000) {
                    logger.warn(`${Math.round((pesPts - pesDts) / 90000)}s delta between PTS and DTS, align them`);
                    pesPts = pesDts;
                }
            } else pesDts = pesPts;
        }
        pesHdrLen = frag[8];
        // 9 bytes : 6 bytes for PES header + 3 bytes for PES extension
        let payloadStartOffset = pesHdrLen + 9;
        if (stream.size <= payloadStartOffset) return null;
        stream.size -= payloadStartOffset;
        // reassemble PES packet
        const pesData = new Uint8Array(stream.size);
        for(let j = 0, dataLen = data.length; j < dataLen; j++){
            frag = data[j];
            let len = frag.byteLength;
            if (payloadStartOffset) {
                if (payloadStartOffset > len) {
                    // trim full frag if PES header bigger than frag
                    payloadStartOffset -= len;
                    continue;
                } else {
                    // trim partial frag if PES header smaller than frag
                    frag = frag.subarray(payloadStartOffset);
                    len -= payloadStartOffset;
                    payloadStartOffset = 0;
                }
            }
            pesData.set(frag, i);
            i += len;
        }
        if (pesLen) // payload size : remove PES header + PES extension
        pesLen -= pesHdrLen + 3;
        return {
            data: pesData,
            pts: pesPts,
            dts: pesDts,
            len: pesLen
        };
    }
    return null;
}
/**
 *  AAC helper
 */ class $b941786f4eb9cb76$var$AAC {
    static getSilentFrame(codec, channelCount) {
        switch(codec){
            case 'mp4a.40.2':
                if (channelCount === 1) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 2) return new Uint8Array([
                    0x21,
                    0x00,
                    0x49,
                    0x90,
                    0x02,
                    0x19,
                    0x00,
                    0x23,
                    0x80
                ]);
                else if (channelCount === 3) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x8e
                ]);
                else if (channelCount === 4) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x80,
                    0x2c,
                    0x80,
                    0x08,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 5) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x38
                ]);
                else if (channelCount === 6) return new Uint8Array([
                    0x00,
                    0xc8,
                    0x00,
                    0x80,
                    0x20,
                    0x84,
                    0x01,
                    0x26,
                    0x40,
                    0x08,
                    0x64,
                    0x00,
                    0x82,
                    0x30,
                    0x04,
                    0x99,
                    0x00,
                    0x21,
                    0x90,
                    0x02,
                    0x00,
                    0xb2,
                    0x00,
                    0x20,
                    0x08,
                    0xe0
                ]);
                break;
            // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
            default:
                if (channelCount === 1) // ffmpeg -y -f lavfi -i "aevalsrc=0:d=0.05" -c:a libfdk_aac -profile:a aac_he -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x4e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x1c,
                    0x6,
                    0xf1,
                    0xc1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 2) // ffmpeg -y -f lavfi -i "aevalsrc=0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                else if (channelCount === 3) // ffmpeg -y -f lavfi -i "aevalsrc=0|0|0:d=0.05" -c:a libfdk_aac -profile:a aac_he_v2 -b:a 4k output.aac && hexdump -v -e '16/1 "0x%x," "\n"' -v output.aac
                return new Uint8Array([
                    0x1,
                    0x40,
                    0x22,
                    0x80,
                    0xa3,
                    0x5e,
                    0xe6,
                    0x80,
                    0xba,
                    0x8,
                    0x0,
                    0x0,
                    0x0,
                    0x0,
                    0x95,
                    0x0,
                    0x6,
                    0xf1,
                    0xa1,
                    0xa,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5a,
                    0x5e
                ]);
                break;
        }
        return undefined;
    }
}
/**
 * Generate MP4 Box
 */ const $b941786f4eb9cb76$var$UINT32_MAX = Math.pow(2, 32) - 1;
class $b941786f4eb9cb76$var$MP4 {
    static init() {
        $b941786f4eb9cb76$var$MP4.types = {
            avc1: [],
            // codingname
            avcC: [],
            hvc1: [],
            hvcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            '.mp3': [],
            dac3: [],
            'ac-3': [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: [],
            smhd: []
        };
        let i;
        for(i in $b941786f4eb9cb76$var$MP4.types)if ($b941786f4eb9cb76$var$MP4.types.hasOwnProperty(i)) $b941786f4eb9cb76$var$MP4.types[i] = [
            i.charCodeAt(0),
            i.charCodeAt(1),
            i.charCodeAt(2),
            i.charCodeAt(3)
        ];
        const videoHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x76,
            0x69,
            0x64,
            0x65,
            // handler_type: 'vide'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x56,
            0x69,
            0x64,
            0x65,
            0x6f,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'VideoHandler'
        ]);
        const audioHdlr = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0x73,
            0x6f,
            0x75,
            0x6e,
            // handler_type: 'soun'
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x53,
            0x6f,
            0x75,
            0x6e,
            0x64,
            0x48,
            0x61,
            0x6e,
            0x64,
            0x6c,
            0x65,
            0x72,
            0x00 // name: 'SoundHandler'
        ]);
        $b941786f4eb9cb76$var$MP4.HDLR_TYPES = {
            video: videoHdlr,
            audio: audioHdlr
        };
        const dref = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01,
            // entry_count
            0x00,
            0x00,
            0x00,
            0x0c,
            // entry_size
            0x75,
            0x72,
            0x6c,
            0x20,
            // 'url' type
            0x00,
            // version 0
            0x00,
            0x00,
            0x01 // entry_flags
        ]);
        const stco = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00 // entry_count
        ]);
        $b941786f4eb9cb76$var$MP4.STTS = $b941786f4eb9cb76$var$MP4.STSC = $b941786f4eb9cb76$var$MP4.STCO = stco;
        $b941786f4eb9cb76$var$MP4.STSZ = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            // sample_size
            0x00,
            0x00,
            0x00,
            0x00 // sample_count
        ]);
        $b941786f4eb9cb76$var$MP4.VMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x01,
            // flags
            0x00,
            0x00,
            // graphicsmode
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00 // opcolor
        ]);
        $b941786f4eb9cb76$var$MP4.SMHD = new Uint8Array([
            0x00,
            // version
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            // balance
            0x00,
            0x00 // reserved
        ]);
        $b941786f4eb9cb76$var$MP4.STSD = new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x01
        ]); // entry_count
        const majorBrand = new Uint8Array([
            105,
            115,
            111,
            109
        ]); // isom
        const avc1Brand = new Uint8Array([
            97,
            118,
            99,
            49
        ]); // avc1
        const minorVersion = new Uint8Array([
            0,
            0,
            0,
            1
        ]);
        $b941786f4eb9cb76$var$MP4.FTYP = $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.ftyp, majorBrand, minorVersion, majorBrand, avc1Brand);
        $b941786f4eb9cb76$var$MP4.DINF = $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.dinf, $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.dref, dref));
    }
    static box(type, ...payload) {
        let size = 8;
        let i = payload.length;
        const len = i;
        // calculate the total size we need to allocate
        while(i--)size += payload[i].byteLength;
        const result = new Uint8Array(size);
        result[0] = size >> 24 & 0xff;
        result[1] = size >> 16 & 0xff;
        result[2] = size >> 8 & 0xff;
        result[3] = size & 0xff;
        result.set(type, 4);
        // copy the payload into the result
        for(i = 0, size = 8; i < len; i++){
            // copy payload[i] array @ offset size
            result.set(payload[i], size);
            size += payload[i].byteLength;
        }
        return result;
    }
    static hdlr(type) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.hdlr, $b941786f4eb9cb76$var$MP4.HDLR_TYPES[type]);
    }
    static mdat(data) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.mdat, data);
    }
    static mdhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.mdhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x55,
            0xc4,
            // 'und' language (undetermined)
            0x00,
            0x00
        ]));
    }
    static mdia(track) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.mdia, $b941786f4eb9cb76$var$MP4.mdhd(track.timescale || 0, track.duration || 0), $b941786f4eb9cb76$var$MP4.hdlr(track.type), $b941786f4eb9cb76$var$MP4.minf(track));
    }
    static mfhd(sequenceNumber) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.mfhd, new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00,
            // flags
            sequenceNumber >> 24,
            sequenceNumber >> 16 & 0xff,
            sequenceNumber >> 8 & 0xff,
            sequenceNumber & 0xff // sequence_number
        ]));
    }
    static minf(track) {
        if (track.type === 'audio') return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.minf, $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.smhd, $b941786f4eb9cb76$var$MP4.SMHD), $b941786f4eb9cb76$var$MP4.DINF, $b941786f4eb9cb76$var$MP4.stbl(track));
        else return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.minf, $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.vmhd, $b941786f4eb9cb76$var$MP4.VMHD), $b941786f4eb9cb76$var$MP4.DINF, $b941786f4eb9cb76$var$MP4.stbl(track));
    }
    static moof(sn, baseMediaDecodeTime, track) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.moof, $b941786f4eb9cb76$var$MP4.mfhd(sn), $b941786f4eb9cb76$var$MP4.traf(track, baseMediaDecodeTime));
    }
    static moov(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = $b941786f4eb9cb76$var$MP4.trak(tracks[i]);
        return $b941786f4eb9cb76$var$MP4.box.apply(null, [
            $b941786f4eb9cb76$var$MP4.types.moov,
            $b941786f4eb9cb76$var$MP4.mvhd(tracks[0].timescale || 0, tracks[0].duration || 0)
        ].concat(boxes).concat($b941786f4eb9cb76$var$MP4.mvex(tracks)));
    }
    static mvex(tracks) {
        let i = tracks.length;
        const boxes = [];
        while(i--)boxes[i] = $b941786f4eb9cb76$var$MP4.trex(tracks[i]);
        return $b941786f4eb9cb76$var$MP4.box.apply(null, [
            $b941786f4eb9cb76$var$MP4.types.mvex,
            ...boxes
        ]);
    }
    static mvhd(timescale, duration) {
        duration *= timescale;
        const upperWordDuration = Math.floor(duration / ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        const bytes = new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            timescale >> 24 & 0xff,
            timescale >> 16 & 0xff,
            timescale >> 8 & 0xff,
            timescale & 0xff,
            // timescale
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x01,
            0x00,
            0x00,
            // 1.0 rate
            0x01,
            0x00,
            // 1.0 volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            0xff,
            0xff,
            0xff,
            0xff // next_track_ID
        ]);
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.mvhd, bytes);
    }
    static sdtp(track) {
        const samples = track.samples || [];
        const bytes = new Uint8Array(4 + samples.length);
        let i;
        let flags;
        // leave the full box header (4 bytes) all zero
        // write the sample table
        for(i = 0; i < samples.length; i++){
            flags = samples[i].flags;
            bytes[i + 4] = flags.dependsOn << 4 | flags.isDependedOn << 2 | flags.hasRedundancy;
        }
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.sdtp, bytes);
    }
    static stbl(track) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stbl, $b941786f4eb9cb76$var$MP4.stsd(track), $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stts, $b941786f4eb9cb76$var$MP4.STTS), $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stsc, $b941786f4eb9cb76$var$MP4.STSC), $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stsz, $b941786f4eb9cb76$var$MP4.STSZ), $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stco, $b941786f4eb9cb76$var$MP4.STCO));
    }
    static avc1(track) {
        let sps = [];
        let pps = [];
        let i;
        let data;
        let len;
        // assemble the SPSs
        for(i = 0; i < track.sps.length; i++){
            data = track.sps[i];
            len = data.byteLength;
            sps.push(len >>> 8 & 0xff);
            sps.push(len & 0xff);
            // SPS
            sps = sps.concat(Array.prototype.slice.call(data));
        }
        // assemble the PPSs
        for(i = 0; i < track.pps.length; i++){
            data = track.pps[i];
            len = data.byteLength;
            pps.push(len >>> 8 & 0xff);
            pps.push(len & 0xff);
            pps = pps.concat(Array.prototype.slice.call(data));
        }
        const avcc = $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.avcC, new Uint8Array([
            0x01,
            // version
            sps[3],
            // profile
            sps[4],
            // profile compat
            sps[5],
            // level
            255,
            // lengthSizeMinusOne, hard-coded to 4 bytes
            0xe0 | track.sps.length // 3bit reserved (111) + numOfSequenceParameterSets
        ].concat(sps).concat([
            track.pps.length // numOfPictureParameterSets
        ]).concat(pps))); // "PPS"
        const width = track.width;
        const height = track.height;
        const hSpacing = track.pixelRatio[0];
        const vSpacing = track.pixelRatio[1];
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.avc1, new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            // pre_defined
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            width >> 8 & 0xff,
            width & 0xff,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            // height
            0x00,
            0x48,
            0x00,
            0x00,
            // horizresolution
            0x00,
            0x48,
            0x00,
            0x00,
            // vertresolution
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // frame_count
            0x12,
            0x64,
            0x61,
            0x69,
            0x6c,
            // dailymotion/hls.js
            0x79,
            0x6d,
            0x6f,
            0x74,
            0x69,
            0x6f,
            0x6e,
            0x2f,
            0x68,
            0x6c,
            0x73,
            0x2e,
            0x6a,
            0x73,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // compressorname
            0x00,
            0x18,
            // depth = 24
            0x11,
            0x11
        ]), // pre_defined = -1
        avcc, $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.btrt, new Uint8Array([
            0x00,
            0x1c,
            0x9c,
            0x80,
            // bufferSizeDB
            0x00,
            0x2d,
            0xc6,
            0xc0,
            // maxBitrate
            0x00,
            0x2d,
            0xc6,
            0xc0
        ])), // avgBitrate
        $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.pasp, new Uint8Array([
            hSpacing >> 24,
            // hSpacing
            hSpacing >> 16 & 0xff,
            hSpacing >> 8 & 0xff,
            hSpacing & 0xff,
            vSpacing >> 24,
            // vSpacing
            vSpacing >> 16 & 0xff,
            vSpacing >> 8 & 0xff,
            vSpacing & 0xff
        ])));
    }
    static esds(track) {
        const config = track.config;
        return new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            0x03,
            // descriptor_type
            0x19,
            // length
            0x00,
            0x01,
            // es_id
            0x00,
            // stream_priority
            0x04,
            // descriptor_type
            0x11,
            // length
            0x40,
            // codec : mpeg4_audio
            0x15,
            // stream_type
            0x00,
            0x00,
            0x00,
            // buffer_size
            0x00,
            0x00,
            0x00,
            0x00,
            // maxBitrate
            0x00,
            0x00,
            0x00,
            0x00,
            // avgBitrate
            0x05,
            // descriptor_type
            0x02,
            // length
            ...config,
            0x06,
            0x01,
            0x02 // GASpecificConfig)); // length + audio config descriptor
        ]);
    }
    static audioStsd(track) {
        const samplerate = track.samplerate || 0;
        return new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            track.channelCount || 0,
            // channelcount
            0x00,
            0x10,
            // sampleSize:16bits
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved2
            samplerate >> 8 & 0xff,
            samplerate & 0xff,
            //
            0x00,
            0x00
        ]);
    }
    static mp4a(track) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.mp4a, $b941786f4eb9cb76$var$MP4.audioStsd(track), $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.esds, $b941786f4eb9cb76$var$MP4.esds(track)));
    }
    static mp3(track) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types['.mp3'], $b941786f4eb9cb76$var$MP4.audioStsd(track));
    }
    static ac3(track) {
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types['ac-3'], $b941786f4eb9cb76$var$MP4.audioStsd(track), $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.dac3, track.config));
    }
    static stsd(track) {
        const { segmentCodec: segmentCodec } = track;
        if (track.type === 'audio') {
            if (segmentCodec === 'aac') return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stsd, $b941786f4eb9cb76$var$MP4.STSD, $b941786f4eb9cb76$var$MP4.mp4a(track));
            if (segmentCodec === 'ac3' && track.config) return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stsd, $b941786f4eb9cb76$var$MP4.STSD, $b941786f4eb9cb76$var$MP4.ac3(track));
            if (segmentCodec === 'mp3' && track.codec === 'mp3') return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stsd, $b941786f4eb9cb76$var$MP4.STSD, $b941786f4eb9cb76$var$MP4.mp3(track));
        } else {
            if (track.pps && track.sps) {
                if (segmentCodec === 'avc') return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stsd, $b941786f4eb9cb76$var$MP4.STSD, $b941786f4eb9cb76$var$MP4.avc1(track));
                if (segmentCodec === 'hevc' && track.vps) return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.stsd, $b941786f4eb9cb76$var$MP4.STSD, $b941786f4eb9cb76$var$MP4.hvc1(track));
            } else throw new Error(`video track missing pps or sps`);
        }
        throw new Error(`unsupported ${track.type} segment codec (${segmentCodec}/${track.codec})`);
    }
    static tkhd(track) {
        const id = track.id;
        const duration = (track.duration || 0) * (track.timescale || 0);
        const width = track.width || 0;
        const height = track.height || 0;
        const upperWordDuration = Math.floor(duration / ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        const lowerWordDuration = Math.floor(duration % ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.tkhd, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x07,
            // flags
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x02,
            // creation_time
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x03,
            // modification_time
            id >> 24 & 0xff,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            upperWordDuration >> 24,
            upperWordDuration >> 16 & 0xff,
            upperWordDuration >> 8 & 0xff,
            upperWordDuration & 0xff,
            lowerWordDuration >> 24,
            lowerWordDuration >> 16 & 0xff,
            lowerWordDuration >> 8 & 0xff,
            lowerWordDuration & 0xff,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            // layer
            0x00,
            0x00,
            // alternate_group
            0x00,
            0x00,
            // non-audio track volume
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x01,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x40,
            0x00,
            0x00,
            0x00,
            // transformation: unity matrix
            width >> 8 & 0xff,
            width & 0xff,
            0x00,
            0x00,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            0x00,
            0x00 // height
        ]));
    }
    static traf(track, baseMediaDecodeTime) {
        const sampleDependencyTable = $b941786f4eb9cb76$var$MP4.sdtp(track);
        const id = track.id;
        const upperWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime / ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        const lowerWordBaseMediaDecodeTime = Math.floor(baseMediaDecodeTime % ($b941786f4eb9cb76$var$UINT32_MAX + 1));
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.traf, $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.tfhd, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff // track_ID
        ])), $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.tfdt, new Uint8Array([
            0x01,
            // version 1
            0x00,
            0x00,
            0x00,
            // flags
            upperWordBaseMediaDecodeTime >> 24,
            upperWordBaseMediaDecodeTime >> 16 & 0xff,
            upperWordBaseMediaDecodeTime >> 8 & 0xff,
            upperWordBaseMediaDecodeTime & 0xff,
            lowerWordBaseMediaDecodeTime >> 24,
            lowerWordBaseMediaDecodeTime >> 16 & 0xff,
            lowerWordBaseMediaDecodeTime >> 8 & 0xff,
            lowerWordBaseMediaDecodeTime & 0xff
        ])), $b941786f4eb9cb76$var$MP4.trun(track, sampleDependencyTable.length + 16 + // tfhd
        20 + // tfdt
        8 + // traf header
        16 + // mfhd
        8 + // moof header
        8), // mdat header
        sampleDependencyTable);
    }
    /**
   * Generate a track box.
   * @param track a track definition
   */ static trak(track) {
        track.duration = track.duration || 0xffffffff;
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.trak, $b941786f4eb9cb76$var$MP4.tkhd(track), $b941786f4eb9cb76$var$MP4.mdia(track));
    }
    static trex(track) {
        const id = track.id;
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.trex, new Uint8Array([
            0x00,
            // version 0
            0x00,
            0x00,
            0x00,
            // flags
            id >> 24,
            id >> 16 & 0xff,
            id >> 8 & 0xff,
            id & 0xff,
            // track_ID
            0x00,
            0x00,
            0x00,
            0x01,
            // default_sample_description_index
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_duration
            0x00,
            0x00,
            0x00,
            0x00,
            // default_sample_size
            0x00,
            0x01,
            0x00,
            0x01 // default_sample_flags
        ]));
    }
    static trun(track, offset) {
        const samples = track.samples || [];
        const len = samples.length;
        const arraylen = 12 + 16 * len;
        const array = new Uint8Array(arraylen);
        let i;
        let sample;
        let duration;
        let size;
        let flags;
        let cts;
        offset += 8 + arraylen;
        array.set([
            track.type === 'video' ? 0x01 : 0x00,
            // version 1 for video with signed-int sample_composition_time_offset
            0x00,
            0x0f,
            0x01,
            // flags
            len >>> 24 & 0xff,
            len >>> 16 & 0xff,
            len >>> 8 & 0xff,
            len & 0xff,
            // sample_count
            offset >>> 24 & 0xff,
            offset >>> 16 & 0xff,
            offset >>> 8 & 0xff,
            offset & 0xff // data_offset
        ], 0);
        for(i = 0; i < len; i++){
            sample = samples[i];
            duration = sample.duration;
            size = sample.size;
            flags = sample.flags;
            cts = sample.cts;
            array.set([
                duration >>> 24 & 0xff,
                duration >>> 16 & 0xff,
                duration >>> 8 & 0xff,
                duration & 0xff,
                // sample_duration
                size >>> 24 & 0xff,
                size >>> 16 & 0xff,
                size >>> 8 & 0xff,
                size & 0xff,
                // sample_size
                flags.isLeading << 2 | flags.dependsOn,
                flags.isDependedOn << 6 | flags.hasRedundancy << 4 | flags.paddingValue << 1 | flags.isNonSync,
                flags.degradPrio & 61440,
                flags.degradPrio & 0x0f,
                // sample_flags
                cts >>> 24 & 0xff,
                cts >>> 16 & 0xff,
                cts >>> 8 & 0xff,
                cts & 0xff // sample_composition_time_offset
            ], 12 + 16 * i);
        }
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.trun, array);
    }
    static initSegment(tracks) {
        if (!$b941786f4eb9cb76$var$MP4.types) $b941786f4eb9cb76$var$MP4.init();
        const movie = $b941786f4eb9cb76$var$MP4.moov(tracks);
        const result = $b941786f4eb9cb76$var$appendUint8Array($b941786f4eb9cb76$var$MP4.FTYP, movie);
        return result;
    }
    static hvc1(track) {
        const ps = track.params;
        const units = [
            track.vps,
            track.sps,
            track.pps
        ];
        const NALuLengthSize = 4;
        const config = new Uint8Array([
            0x01,
            ps.general_profile_space << 6 | (ps.general_tier_flag ? 32 : 0) | ps.general_profile_idc,
            ps.general_profile_compatibility_flags[0],
            ps.general_profile_compatibility_flags[1],
            ps.general_profile_compatibility_flags[2],
            ps.general_profile_compatibility_flags[3],
            ps.general_constraint_indicator_flags[0],
            ps.general_constraint_indicator_flags[1],
            ps.general_constraint_indicator_flags[2],
            ps.general_constraint_indicator_flags[3],
            ps.general_constraint_indicator_flags[4],
            ps.general_constraint_indicator_flags[5],
            ps.general_level_idc,
            240 | ps.min_spatial_segmentation_idc >> 8,
            255 & ps.min_spatial_segmentation_idc,
            252 | ps.parallelismType,
            252 | ps.chroma_format_idc,
            248 | ps.bit_depth_luma_minus8,
            248 | ps.bit_depth_chroma_minus8,
            0x00,
            parseInt(ps.frame_rate.fps),
            NALuLengthSize - 1 | ps.temporal_id_nested << 2 | ps.num_temporal_layers << 3 | (ps.frame_rate.fixed ? 64 : 0),
            units.length
        ]);
        // compute hvcC size in bytes
        let length = config.length;
        for(let i = 0; i < units.length; i += 1){
            length += 3;
            for(let j = 0; j < units[i].length; j += 1)length += 2 + units[i][j].length;
        }
        const hvcC = new Uint8Array(length);
        hvcC.set(config, 0);
        length = config.length;
        // append parameter set units: one vps, one or more sps and pps
        const iMax = units.length - 1;
        for(let i = 0; i < units.length; i += 1){
            hvcC.set(new Uint8Array([
                32 + i | (i === iMax ? 128 : 0),
                0x00,
                units[i].length
            ]), length);
            length += 3;
            for(let j = 0; j < units[i].length; j += 1){
                hvcC.set(new Uint8Array([
                    units[i][j].length >> 8,
                    units[i][j].length & 255
                ]), length);
                length += 2;
                hvcC.set(units[i][j], length);
                length += units[i][j].length;
            }
        }
        const hvcc = $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.hvcC, hvcC);
        const width = track.width;
        const height = track.height;
        const hSpacing = track.pixelRatio[0];
        const vSpacing = track.pixelRatio[1];
        return $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.hvc1, new Uint8Array([
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // data_reference_index
            0x00,
            0x00,
            // pre_defined
            0x00,
            0x00,
            // reserved
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // pre_defined
            width >> 8 & 0xff,
            width & 0xff,
            // width
            height >> 8 & 0xff,
            height & 0xff,
            // height
            0x00,
            0x48,
            0x00,
            0x00,
            // horizresolution
            0x00,
            0x48,
            0x00,
            0x00,
            // vertresolution
            0x00,
            0x00,
            0x00,
            0x00,
            // reserved
            0x00,
            0x01,
            // frame_count
            0x12,
            0x64,
            0x61,
            0x69,
            0x6c,
            // dailymotion/hls.js
            0x79,
            0x6d,
            0x6f,
            0x74,
            0x69,
            0x6f,
            0x6e,
            0x2f,
            0x68,
            0x6c,
            0x73,
            0x2e,
            0x6a,
            0x73,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            0x00,
            // compressorname
            0x00,
            0x18,
            // depth = 24
            0x11,
            0x11
        ]), // pre_defined = -1
        hvcc, $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.btrt, new Uint8Array([
            0x00,
            0x1c,
            0x9c,
            0x80,
            // bufferSizeDB
            0x00,
            0x2d,
            0xc6,
            0xc0,
            // maxBitrate
            0x00,
            0x2d,
            0xc6,
            0xc0
        ])), // avgBitrate
        $b941786f4eb9cb76$var$MP4.box($b941786f4eb9cb76$var$MP4.types.pasp, new Uint8Array([
            hSpacing >> 24,
            // hSpacing
            hSpacing >> 16 & 0xff,
            hSpacing >> 8 & 0xff,
            hSpacing & 0xff,
            vSpacing >> 24,
            // vSpacing
            vSpacing >> 16 & 0xff,
            vSpacing >> 8 & 0xff,
            vSpacing & 0xff
        ])));
    }
}
$b941786f4eb9cb76$var$MP4.types = void 0;
$b941786f4eb9cb76$var$MP4.HDLR_TYPES = void 0;
$b941786f4eb9cb76$var$MP4.STTS = void 0;
$b941786f4eb9cb76$var$MP4.STSC = void 0;
$b941786f4eb9cb76$var$MP4.STCO = void 0;
$b941786f4eb9cb76$var$MP4.STSZ = void 0;
$b941786f4eb9cb76$var$MP4.VMHD = void 0;
$b941786f4eb9cb76$var$MP4.SMHD = void 0;
$b941786f4eb9cb76$var$MP4.STSD = void 0;
$b941786f4eb9cb76$var$MP4.FTYP = void 0;
$b941786f4eb9cb76$var$MP4.DINF = void 0;
const $b941786f4eb9cb76$var$MPEG_TS_CLOCK_FREQ_HZ = 90000;
function $b941786f4eb9cb76$var$toTimescaleFromBase(baseTime, destScale, srcBase = 1, round = false) {
    const result = baseTime * destScale * srcBase; // equivalent to `(value * scale) / (1 / base)`
    return round ? Math.round(result) : result;
}
function $b941786f4eb9cb76$var$toTimescaleFromScale(baseTime, destScale, srcScale = 1, round = false) {
    return $b941786f4eb9cb76$var$toTimescaleFromBase(baseTime, destScale, 1 / srcScale, round);
}
function $b941786f4eb9cb76$var$toMsFromMpegTsClock(baseTime, round = false) {
    return $b941786f4eb9cb76$var$toTimescaleFromBase(baseTime, 1000, 1 / $b941786f4eb9cb76$var$MPEG_TS_CLOCK_FREQ_HZ, round);
}
function $b941786f4eb9cb76$var$toMpegTsClockFromTimescale(baseTime, srcScale = 1) {
    return $b941786f4eb9cb76$var$toTimescaleFromBase(baseTime, $b941786f4eb9cb76$var$MPEG_TS_CLOCK_FREQ_HZ, 1 / srcScale);
}
function $b941786f4eb9cb76$var$timestampToString(timestamp) {
    const { baseTime: baseTime, timescale: timescale, trackId: trackId } = timestamp;
    return `${baseTime / timescale} (${baseTime}/${timescale}) trackId: ${trackId}`;
}
const $b941786f4eb9cb76$var$MAX_SILENT_FRAME_DURATION = 10000; // 10 seconds
const $b941786f4eb9cb76$var$AAC_SAMPLES_PER_FRAME = 1024;
const $b941786f4eb9cb76$var$MPEG_AUDIO_SAMPLE_PER_FRAME = 1152;
const $b941786f4eb9cb76$var$AC3_SAMPLES_PER_FRAME = 1536;
let $b941786f4eb9cb76$var$chromeVersion = null;
let $b941786f4eb9cb76$var$safariWebkitVersion = null;
function $b941786f4eb9cb76$var$createMp4Sample(isKeyframe, duration, size, cts) {
    return {
        duration: duration,
        size: size,
        cts: cts,
        flags: {
            isLeading: 0,
            isDependedOn: 0,
            hasRedundancy: 0,
            degradPrio: 0,
            dependsOn: isKeyframe ? 2 : 1,
            isNonSync: isKeyframe ? 0 : 1
        }
    };
}
class $b941786f4eb9cb76$var$MP4Remuxer extends $b941786f4eb9cb76$var$Logger {
    constructor(observer, config, typeSupported, logger){
        super('mp4-remuxer', logger);
        this.observer = void 0;
        this.config = void 0;
        this.typeSupported = void 0;
        this.ISGenerated = false;
        this._initPTS = null;
        this._initDTS = null;
        this.nextVideoTs = null;
        this.nextAudioTs = null;
        this.videoSampleDuration = null;
        this.isAudioContiguous = false;
        this.isVideoContiguous = false;
        this.videoTrackConfig = void 0;
        this.observer = observer;
        this.config = config;
        this.typeSupported = typeSupported;
        this.ISGenerated = false;
        if ($b941786f4eb9cb76$var$chromeVersion === null) {
            const userAgent = navigator.userAgent || '';
            const result = userAgent.match(/Chrome\/(\d+)/i);
            $b941786f4eb9cb76$var$chromeVersion = result ? parseInt(result[1]) : 0;
        }
        if ($b941786f4eb9cb76$var$safariWebkitVersion === null) {
            const result = navigator.userAgent.match(/Safari\/(\d+)/i);
            $b941786f4eb9cb76$var$safariWebkitVersion = result ? parseInt(result[1]) : 0;
        }
    }
    destroy() {
        // @ts-ignore
        this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
    }
    resetTimeStamp(defaultTimeStamp) {
        const initPTS = this._initPTS;
        if (!initPTS || !defaultTimeStamp || defaultTimeStamp.trackId !== initPTS.trackId || defaultTimeStamp.baseTime !== initPTS.baseTime || defaultTimeStamp.timescale !== initPTS.timescale) this.log(`Reset initPTS: ${initPTS ? $b941786f4eb9cb76$var$timestampToString(initPTS) : initPTS} > ${defaultTimeStamp ? $b941786f4eb9cb76$var$timestampToString(defaultTimeStamp) : defaultTimeStamp}`);
        this._initPTS = this._initDTS = defaultTimeStamp;
    }
    resetNextTimestamp() {
        this.log('reset next timestamp');
        this.isVideoContiguous = false;
        this.isAudioContiguous = false;
    }
    resetInitSegment() {
        this.log('ISGenerated flag reset');
        this.ISGenerated = false;
        this.videoTrackConfig = undefined;
    }
    getVideoStartPts(videoSamples) {
        // Get the minimum PTS value relative to the first sample's PTS, normalized for 33-bit wrapping
        let rolloverDetected = false;
        const firstPts = videoSamples[0].pts;
        const startPTS = videoSamples.reduce((minPTS, sample)=>{
            let pts = sample.pts;
            let delta = pts - minPTS;
            if (delta < -4294967296) {
                // 2^32, see PTSNormalize for reasoning, but we're hitting a rollover here, and we don't want that to impact the timeOffset calculation
                rolloverDetected = true;
                pts = $b941786f4eb9cb76$var$normalizePts(pts, firstPts);
                delta = pts - minPTS;
            }
            if (delta > 0) return minPTS;
            return pts;
        }, firstPts);
        if (rolloverDetected) this.debug('PTS rollover detected');
        return startPTS;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, flush, playlistType) {
        let video;
        let audio;
        let initSegment;
        let text;
        let id3;
        let independent;
        let audioTimeOffset = timeOffset;
        let videoTimeOffset = timeOffset;
        // If we're remuxing audio and video progressively, wait until we've received enough samples for each track before proceeding.
        // This is done to synchronize the audio and video streams. We know if the current segment will have samples if the "pid"
        // parameter is greater than -1. The pid is set when the PMT is parsed, which contains the tracks list.
        // However, if the initSegment has already been generated, or we've reached the end of a segment (flush),
        // then we can remux one track without waiting for the other.
        const hasAudio = audioTrack.pid > -1;
        const hasVideo = videoTrack.pid > -1;
        const length = videoTrack.samples.length;
        const enoughAudioSamples = audioTrack.samples.length > 0;
        const enoughVideoSamples = flush && length > 0 || length > 1;
        const canRemuxAvc = (!hasAudio || enoughAudioSamples) && (!hasVideo || enoughVideoSamples) || this.ISGenerated || flush;
        if (canRemuxAvc) {
            if (this.ISGenerated) {
                var _videoTrack$pixelRati, _config$pixelRatio, _videoTrack$pixelRati2, _config$pixelRatio2;
                const config = this.videoTrackConfig;
                if (config && (videoTrack.width !== config.width || videoTrack.height !== config.height || ((_videoTrack$pixelRati = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati[0]) !== ((_config$pixelRatio = config.pixelRatio) == null ? void 0 : _config$pixelRatio[0]) || ((_videoTrack$pixelRati2 = videoTrack.pixelRatio) == null ? void 0 : _videoTrack$pixelRati2[1]) !== ((_config$pixelRatio2 = config.pixelRatio) == null ? void 0 : _config$pixelRatio2[1])) || !config && enoughVideoSamples || this.nextAudioTs === null && enoughAudioSamples) this.resetInitSegment();
            }
            if (!this.ISGenerated) initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
            const isVideoContiguous = this.isVideoContiguous;
            let firstKeyFrameIndex = -1;
            let firstKeyFramePTS;
            if (enoughVideoSamples) {
                firstKeyFrameIndex = $b941786f4eb9cb76$var$findKeyframeIndex(videoTrack.samples);
                if (!isVideoContiguous && this.config.forceKeyFrameOnDiscontinuity) {
                    independent = true;
                    if (firstKeyFrameIndex > 0) {
                        this.warn(`Dropped ${firstKeyFrameIndex} out of ${length} video samples due to a missing keyframe`);
                        const startPTS = this.getVideoStartPts(videoTrack.samples);
                        videoTrack.samples = videoTrack.samples.slice(firstKeyFrameIndex);
                        videoTrack.dropped += firstKeyFrameIndex;
                        videoTimeOffset += (videoTrack.samples[0].pts - startPTS) / videoTrack.inputTimeScale;
                        firstKeyFramePTS = videoTimeOffset;
                    } else if (firstKeyFrameIndex === -1) {
                        this.warn(`No keyframe found out of ${length} video samples`);
                        independent = false;
                    }
                }
            }
            if (this.ISGenerated) {
                if (enoughAudioSamples && enoughVideoSamples) {
                    // timeOffset is expected to be the offset of the first timestamp of this fragment (first DTS)
                    // if first audio DTS is not aligned with first video DTS then we need to take that into account
                    // when providing timeOffset to remuxAudio / remuxVideo. if we don't do that, there might be a permanent / small
                    // drift between audio and video streams
                    const startPTS = this.getVideoStartPts(videoTrack.samples);
                    const tsDelta = $b941786f4eb9cb76$var$normalizePts(audioTrack.samples[0].pts, startPTS) - startPTS;
                    const audiovideoTimestampDelta = tsDelta / videoTrack.inputTimeScale;
                    audioTimeOffset += Math.max(0, audiovideoTimestampDelta);
                    videoTimeOffset += Math.max(0, -audiovideoTimestampDelta);
                }
                // Purposefully remuxing audio before video, so that remuxVideo can use nextAudioPts, which is calculated in remuxAudio.
                if (enoughAudioSamples) {
                    // if initSegment was generated without audio samples, regenerate it again
                    if (!audioTrack.samplerate) {
                        this.warn('regenerate InitSegment as audio detected');
                        initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                    }
                    audio = this.remuxAudio(audioTrack, audioTimeOffset, this.isAudioContiguous, accurateTimeOffset, hasVideo || enoughVideoSamples || playlistType === $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO ? videoTimeOffset : undefined);
                    if (enoughVideoSamples) {
                        const audioTrackLength = audio ? audio.endPTS - audio.startPTS : 0;
                        // if initSegment was generated without video samples, regenerate it again
                        if (!videoTrack.inputTimeScale) {
                            this.warn('regenerate InitSegment as video detected');
                            initSegment = this.generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset);
                        }
                        video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, audioTrackLength);
                    }
                } else if (enoughVideoSamples) video = this.remuxVideo(videoTrack, videoTimeOffset, isVideoContiguous, 0);
                if (video) {
                    video.firstKeyFrame = firstKeyFrameIndex;
                    video.independent = firstKeyFrameIndex !== -1;
                    video.firstKeyFramePTS = firstKeyFramePTS;
                }
            }
        }
        // Allow ID3 and text to remux, even if more audio/video samples are required
        if (this.ISGenerated && this._initPTS && this._initDTS) {
            if (id3Track.samples.length) id3 = $b941786f4eb9cb76$var$flushTextTrackMetadataCueSamples(id3Track, timeOffset, this._initPTS, this._initDTS);
            if (textTrack.samples.length) text = $b941786f4eb9cb76$var$flushTextTrackUserdataCueSamples(textTrack, timeOffset, this._initPTS);
        }
        return {
            audio: audio,
            video: video,
            initSegment: initSegment,
            independent: independent,
            text: text,
            id3: id3
        };
    }
    computeInitPts(basetime, timescale, presentationTime, type) {
        const offset = Math.round(presentationTime * timescale);
        let timestamp = $b941786f4eb9cb76$var$normalizePts(basetime, offset);
        if (timestamp < offset + timescale) {
            this.log(`Adjusting PTS for rollover in timeline near ${(offset - timestamp) / timescale} ${type}`);
            while(timestamp < offset + timescale)timestamp += 8589934592;
        }
        return timestamp - offset;
    }
    generateIS(audioTrack, videoTrack, timeOffset, accurateTimeOffset) {
        const audioSamples = audioTrack.samples;
        const videoSamples = videoTrack.samples;
        const typeSupported = this.typeSupported;
        const tracks = {};
        const _initPTS = this._initPTS;
        let computePTSDTS = !_initPTS || accurateTimeOffset;
        let container = 'audio/mp4';
        let initPTS;
        let initDTS;
        let timescale;
        let trackId = -1;
        if (computePTSDTS) initPTS = initDTS = Infinity;
        if (audioTrack.config && audioSamples.length) {
            // let's use audio sampling rate as MP4 time scale.
            // rationale is that there is a integer nb of audio frames per audio sample (1024 for AAC)
            // using audio sampling rate here helps having an integer MP4 frame duration
            // this avoids potential rounding issue and AV sync issue
            audioTrack.timescale = audioTrack.samplerate;
            switch(audioTrack.segmentCodec){
                case 'mp3':
                    if (typeSupported.mpeg) {
                        // Chrome and Safari
                        container = 'audio/mpeg';
                        audioTrack.codec = '';
                    } else if (typeSupported.mp3) // Firefox
                    audioTrack.codec = 'mp3';
                    break;
                case 'ac3':
                    audioTrack.codec = 'ac-3';
                    break;
            }
            tracks.audio = {
                id: 'audio',
                container: container,
                codec: audioTrack.codec,
                initSegment: audioTrack.segmentCodec === 'mp3' && typeSupported.mpeg ? new Uint8Array(0) : $b941786f4eb9cb76$var$MP4.initSegment([
                    audioTrack
                ]),
                metadata: {
                    channelCount: audioTrack.channelCount
                }
            };
            if (computePTSDTS) {
                trackId = audioTrack.id;
                timescale = audioTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) // remember first PTS of this demuxing context. for audio, PTS = DTS
                initPTS = initDTS = this.computeInitPts(audioSamples[0].pts, timescale, timeOffset, 'audio');
                else computePTSDTS = false;
            }
        }
        if (videoTrack.sps && videoTrack.pps && videoSamples.length) {
            // let's use input time scale as MP4 video timescale
            // we use input time scale straight away to avoid rounding issues on frame duration / cts computation
            videoTrack.timescale = videoTrack.inputTimeScale;
            tracks.video = {
                id: 'main',
                container: 'video/mp4',
                codec: videoTrack.codec,
                initSegment: $b941786f4eb9cb76$var$MP4.initSegment([
                    videoTrack
                ]),
                metadata: {
                    width: videoTrack.width,
                    height: videoTrack.height
                }
            };
            if (computePTSDTS) {
                trackId = videoTrack.id;
                timescale = videoTrack.inputTimeScale;
                if (!_initPTS || timescale !== _initPTS.timescale) {
                    const basePTS = this.getVideoStartPts(videoSamples);
                    const baseDTS = $b941786f4eb9cb76$var$normalizePts(videoSamples[0].dts, basePTS);
                    const videoInitDTS = this.computeInitPts(baseDTS, timescale, timeOffset, 'video');
                    const videoInitPTS = this.computeInitPts(basePTS, timescale, timeOffset, 'video');
                    initDTS = Math.min(initDTS, videoInitDTS);
                    initPTS = Math.min(initPTS, videoInitPTS);
                } else computePTSDTS = false;
            }
            this.videoTrackConfig = {
                width: videoTrack.width,
                height: videoTrack.height,
                pixelRatio: videoTrack.pixelRatio
            };
        }
        if (Object.keys(tracks).length) {
            this.ISGenerated = true;
            if (computePTSDTS) {
                if (_initPTS) this.warn(`Timestamps at playlist time: ${accurateTimeOffset ? '' : '~'}${timeOffset} ${initPTS / timescale} != initPTS: ${_initPTS.baseTime / _initPTS.timescale} (${_initPTS.baseTime}/${_initPTS.timescale}) trackId: ${_initPTS.trackId}`);
                this.log(`Found initPTS at playlist time: ${timeOffset} offset: ${initPTS / timescale} (${initPTS}/${timescale}) trackId: ${trackId}`);
                this._initPTS = {
                    baseTime: initPTS,
                    timescale: timescale,
                    trackId: trackId
                };
                this._initDTS = {
                    baseTime: initDTS,
                    timescale: timescale,
                    trackId: trackId
                };
            } else initPTS = timescale = undefined;
            return {
                tracks: tracks,
                initPTS: initPTS,
                timescale: timescale,
                trackId: trackId
            };
        }
    }
    remuxVideo(track, timeOffset, contiguous, audioTrackLength) {
        const timeScale = track.inputTimeScale;
        const inputSamples = track.samples;
        const outputSamples = [];
        const nbSamples = inputSamples.length;
        const initPTS = this._initPTS;
        const initTime = initPTS.baseTime * timeScale / initPTS.timescale;
        let nextVideoTs = this.nextVideoTs;
        let offset = 8;
        let mp4SampleDuration = this.videoSampleDuration;
        let firstDTS;
        let lastDTS;
        let minPTS = Number.POSITIVE_INFINITY;
        let maxPTS = Number.NEGATIVE_INFINITY;
        let sortSamples = false;
        // if parsed fragment is contiguous with last one, let's use last DTS value as reference
        if (!contiguous || nextVideoTs === null) {
            const pts = initTime + timeOffset * timeScale;
            const cts = inputSamples[0].pts - $b941786f4eb9cb76$var$normalizePts(inputSamples[0].dts, inputSamples[0].pts);
            if ($b941786f4eb9cb76$var$chromeVersion && nextVideoTs !== null && Math.abs(pts - cts - (nextVideoTs + initTime)) < 15000) // treat as contigous to adjust samples that would otherwise produce video buffer gaps in Chrome
            contiguous = true;
            else // if not contiguous, let's use target timeOffset
            nextVideoTs = pts - cts - initTime;
        }
        // PTS is coded on 33bits, and can loop from -2^32 to 2^32
        // PTSNormalize will make PTS/DTS value monotonic, we use last known DTS value as reference value
        const nextVideoPts = nextVideoTs + initTime;
        for(let i = 0; i < nbSamples; i++){
            const sample = inputSamples[i];
            sample.pts = $b941786f4eb9cb76$var$normalizePts(sample.pts, nextVideoPts);
            sample.dts = $b941786f4eb9cb76$var$normalizePts(sample.dts, nextVideoPts);
            if (sample.dts < inputSamples[i > 0 ? i - 1 : i].dts) sortSamples = true;
        }
        // sort video samples by DTS then PTS then demux id order
        if (sortSamples) inputSamples.sort(function(a, b) {
            const deltadts = a.dts - b.dts;
            const deltapts = a.pts - b.pts;
            return deltadts || deltapts;
        });
        // Get first/last DTS
        firstDTS = inputSamples[0].dts;
        lastDTS = inputSamples[inputSamples.length - 1].dts;
        // Sample duration (as expected by trun MP4 boxes), should be the delta between sample DTS
        // set this constant duration as being the avg delta between consecutive DTS.
        const inputDuration = lastDTS - firstDTS;
        const averageSampleDuration = inputDuration ? Math.round(inputDuration / (nbSamples - 1)) : mp4SampleDuration || track.inputTimeScale / 30;
        // if fragment are contiguous, detect hole/overlapping between fragments
        if (contiguous) {
            // check timestamp continuity across consecutive fragments (this is to remove inter-fragment gap/hole)
            const delta = firstDTS - nextVideoPts;
            const foundHole = delta > averageSampleDuration;
            const foundOverlap = delta < -1;
            if (foundHole || foundOverlap) {
                if (foundHole) this.warn(`${(track.segmentCodec || '').toUpperCase()}: ${$b941786f4eb9cb76$var$toMsFromMpegTsClock(delta, true)} ms (${delta}dts) hole between fragments detected at ${timeOffset.toFixed(3)}`);
                else this.warn(`${(track.segmentCodec || '').toUpperCase()}: ${$b941786f4eb9cb76$var$toMsFromMpegTsClock(-delta, true)} ms (${delta}dts) overlapping between fragments detected at ${timeOffset.toFixed(3)}`);
                if (!foundOverlap || nextVideoPts >= inputSamples[0].pts || $b941786f4eb9cb76$var$chromeVersion) {
                    firstDTS = nextVideoPts;
                    const firstPTS = inputSamples[0].pts - delta;
                    if (foundHole) {
                        inputSamples[0].dts = firstDTS;
                        inputSamples[0].pts = firstPTS;
                    } else {
                        let isPTSOrderRetained = true;
                        for(let i = 0; i < inputSamples.length; i++){
                            if (inputSamples[i].dts > firstPTS && isPTSOrderRetained) break;
                            const prevPTS = inputSamples[i].pts;
                            inputSamples[i].dts -= delta;
                            inputSamples[i].pts -= delta;
                            // check to see if this sample's PTS order has changed
                            // relative to the next one
                            if (i < inputSamples.length - 1) {
                                const nextSamplePTS = inputSamples[i + 1].pts;
                                const currentSamplePTS = inputSamples[i].pts;
                                const currentOrder = nextSamplePTS <= currentSamplePTS;
                                const prevOrder = nextSamplePTS <= prevPTS;
                                isPTSOrderRetained = currentOrder == prevOrder;
                            }
                        }
                    }
                    this.log(`Video: Initial PTS/DTS adjusted: ${$b941786f4eb9cb76$var$toMsFromMpegTsClock(firstPTS, true)}/${$b941786f4eb9cb76$var$toMsFromMpegTsClock(firstDTS, true)}, delta: ${$b941786f4eb9cb76$var$toMsFromMpegTsClock(delta, true)} ms`);
                }
            }
        }
        firstDTS = Math.max(0, firstDTS);
        let nbNalu = 0;
        let naluLen = 0;
        let dtsStep = firstDTS;
        for(let i = 0; i < nbSamples; i++){
            // compute total/avc sample length and nb of NAL units
            const sample = inputSamples[i];
            const units = sample.units;
            const nbUnits = units.length;
            let sampleLen = 0;
            for(let j = 0; j < nbUnits; j++)sampleLen += units[j].data.length;
            naluLen += sampleLen;
            nbNalu += nbUnits;
            sample.length = sampleLen;
            // ensure sample monotonic DTS
            if (sample.dts < dtsStep) {
                sample.dts = dtsStep;
                dtsStep += averageSampleDuration / 4 | 0 || 1;
            } else dtsStep = sample.dts;
            minPTS = Math.min(sample.pts, minPTS);
            maxPTS = Math.max(sample.pts, maxPTS);
        }
        lastDTS = inputSamples[nbSamples - 1].dts;
        /* concatenate the video data and construct the mdat in place
      (need 8 more bytes to fill length and mpdat type) */ const mdatSize = naluLen + 4 * nbNalu + 8;
        let mdat;
        try {
            mdat = new Uint8Array(mdatSize);
        } catch (err) {
            this.observer.emit($b941786f4eb9cb76$export$ada873a34909da65.ERROR, $b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MUX_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.REMUX_ALLOC_ERROR,
                fatal: false,
                error: err,
                bytes: mdatSize,
                reason: `fail allocating video mdat ${mdatSize}`
            });
            return;
        }
        const view = new DataView(mdat.buffer);
        view.setUint32(0, mdatSize);
        mdat.set($b941786f4eb9cb76$var$MP4.types.mdat, 4);
        let stretchedLastFrame = false;
        let minDtsDelta = Number.POSITIVE_INFINITY;
        let minPtsDelta = Number.POSITIVE_INFINITY;
        let maxDtsDelta = Number.NEGATIVE_INFINITY;
        let maxPtsDelta = Number.NEGATIVE_INFINITY;
        for(let i = 0; i < nbSamples; i++){
            const VideoSample = inputSamples[i];
            const VideoSampleUnits = VideoSample.units;
            let mp4SampleLength = 0;
            // convert NALU bitstream to MP4 format (prepend NALU with size field)
            for(let j = 0, nbUnits = VideoSampleUnits.length; j < nbUnits; j++){
                const unit = VideoSampleUnits[j];
                const unitData = unit.data;
                const unitDataLen = unit.data.byteLength;
                view.setUint32(offset, unitDataLen);
                offset += 4;
                mdat.set(unitData, offset);
                offset += unitDataLen;
                mp4SampleLength += 4 + unitDataLen;
            }
            // expected sample duration is the Decoding Timestamp diff of consecutive samples
            let ptsDelta;
            if (i < nbSamples - 1) {
                mp4SampleDuration = inputSamples[i + 1].dts - VideoSample.dts;
                ptsDelta = inputSamples[i + 1].pts - VideoSample.pts;
            } else {
                const config = this.config;
                const lastFrameDuration = i > 0 ? VideoSample.dts - inputSamples[i - 1].dts : averageSampleDuration;
                ptsDelta = i > 0 ? VideoSample.pts - inputSamples[i - 1].pts : averageSampleDuration;
                if (config.stretchShortVideoTrack && this.nextAudioTs !== null) {
                    // In some cases, a segment's audio track duration may exceed the video track duration.
                    // Since we've already remuxed audio, and we know how long the audio track is, we look to
                    // see if the delta to the next segment is longer than maxBufferHole.
                    // If so, playback would potentially get stuck, so we artificially inflate
                    // the duration of the last frame to minimize any potential gap between segments.
                    const gapTolerance = Math.floor(config.maxBufferHole * timeScale);
                    const deltaToFrameEnd = (audioTrackLength ? minPTS + audioTrackLength * timeScale : this.nextAudioTs + initTime) - VideoSample.pts;
                    if (deltaToFrameEnd > gapTolerance) {
                        // We subtract lastFrameDuration from deltaToFrameEnd to try to prevent any video
                        // frame overlap. maxBufferHole should be >> lastFrameDuration anyway.
                        mp4SampleDuration = deltaToFrameEnd - lastFrameDuration;
                        if (mp4SampleDuration < 0) mp4SampleDuration = lastFrameDuration;
                        else stretchedLastFrame = true;
                        this.log(`It is approximately ${deltaToFrameEnd / 90} ms to the next segment; using duration ${mp4SampleDuration / 90} ms for the last video frame.`);
                    } else mp4SampleDuration = lastFrameDuration;
                } else mp4SampleDuration = lastFrameDuration;
            }
            const compositionTimeOffset = Math.round(VideoSample.pts - VideoSample.dts);
            minDtsDelta = Math.min(minDtsDelta, mp4SampleDuration);
            maxDtsDelta = Math.max(maxDtsDelta, mp4SampleDuration);
            minPtsDelta = Math.min(minPtsDelta, ptsDelta);
            maxPtsDelta = Math.max(maxPtsDelta, ptsDelta);
            outputSamples.push($b941786f4eb9cb76$var$createMp4Sample(VideoSample.key, mp4SampleDuration, mp4SampleLength, compositionTimeOffset));
        }
        if (outputSamples.length) {
            if ($b941786f4eb9cb76$var$chromeVersion) {
                if ($b941786f4eb9cb76$var$chromeVersion < 70) {
                    // Chrome workaround, mark first sample as being a Random Access Point (keyframe) to avoid sourcebuffer append issue
                    // https://code.google.com/p/chromium/issues/detail?id=229412
                    const flags = outputSamples[0].flags;
                    flags.dependsOn = 2;
                    flags.isNonSync = 0;
                }
            } else if ($b941786f4eb9cb76$var$safariWebkitVersion) // Fix for "CNN special report, with CC" in test-streams (Safari browser only)
            // Ignore DTS when frame durations are irregular. Safari MSE does not handle this leading to gaps.
            {
                if (maxPtsDelta - minPtsDelta < maxDtsDelta - minDtsDelta && averageSampleDuration / maxDtsDelta < 0.025 && outputSamples[0].cts === 0) {
                    this.warn('Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.');
                    let dts = firstDTS;
                    for(let i = 0, len = outputSamples.length; i < len; i++){
                        const nextDts = dts + outputSamples[i].duration;
                        const pts = dts + outputSamples[i].cts;
                        if (i < len - 1) {
                            const nextPts = nextDts + outputSamples[i + 1].cts;
                            outputSamples[i].duration = nextPts - pts;
                        } else outputSamples[i].duration = i ? outputSamples[i - 1].duration : averageSampleDuration;
                        outputSamples[i].cts = 0;
                        dts = nextDts;
                    }
                }
            }
        }
        // next AVC/HEVC sample DTS should be equal to last sample DTS + last sample duration (in PES timescale)
        mp4SampleDuration = stretchedLastFrame || !mp4SampleDuration ? averageSampleDuration : mp4SampleDuration;
        const endDTS = lastDTS + mp4SampleDuration;
        this.nextVideoTs = nextVideoTs = endDTS - initTime;
        this.videoSampleDuration = mp4SampleDuration;
        this.isVideoContiguous = true;
        const moof = $b941786f4eb9cb76$var$MP4.moof(track.sequenceNumber++, firstDTS, $b941786f4eb9cb76$var$_extends(track, {
            samples: outputSamples
        }));
        const type = 'video';
        const data = {
            data1: moof,
            data2: mdat,
            startPTS: (minPTS - initTime) / timeScale,
            endPTS: (maxPTS + mp4SampleDuration - initTime) / timeScale,
            startDTS: (firstDTS - initTime) / timeScale,
            endDTS: nextVideoTs / timeScale,
            type: type,
            hasAudio: false,
            hasVideo: true,
            nb: outputSamples.length,
            dropped: track.dropped
        };
        track.samples = [];
        track.dropped = 0;
        return data;
    }
    getSamplesPerFrame(track) {
        switch(track.segmentCodec){
            case 'mp3':
                return $b941786f4eb9cb76$var$MPEG_AUDIO_SAMPLE_PER_FRAME;
            case 'ac3':
                return $b941786f4eb9cb76$var$AC3_SAMPLES_PER_FRAME;
            default:
                return $b941786f4eb9cb76$var$AAC_SAMPLES_PER_FRAME;
        }
    }
    remuxAudio(track, timeOffset, contiguous, accurateTimeOffset, videoTimeOffset) {
        const inputTimeScale = track.inputTimeScale;
        const mp4timeScale = track.samplerate ? track.samplerate : inputTimeScale;
        const scaleFactor = inputTimeScale / mp4timeScale;
        const mp4SampleDuration = this.getSamplesPerFrame(track);
        const inputSampleDuration = mp4SampleDuration * scaleFactor;
        const initPTS = this._initPTS;
        const rawMPEG = track.segmentCodec === 'mp3' && this.typeSupported.mpeg;
        const outputSamples = [];
        const alignedWithVideo = videoTimeOffset !== undefined;
        let inputSamples = track.samples;
        let offset = rawMPEG ? 0 : 8;
        let nextAudioTs = this.nextAudioTs || -1;
        // window.audioSamples ? window.audioSamples.push(inputSamples.map(s => s.pts)) : (window.audioSamples = [inputSamples.map(s => s.pts)]);
        // for audio samples, also consider consecutive fragments as being contiguous (even if a level switch occurs),
        // for sake of clarity:
        // consecutive fragments are frags with
        //  - less than 100ms gaps between new time offset (if accurate) and next expected PTS OR
        //  - less than 20 audio frames distance
        // contiguous fragments are consecutive fragments from same quality level (same level, new SN = old SN + 1)
        // this helps ensuring audio continuity
        // and this also avoids audio glitches/cut when switching quality, or reporting wrong duration on first audio frame
        const initTime = initPTS.baseTime * inputTimeScale / initPTS.timescale;
        const timeOffsetMpegTS = initTime + timeOffset * inputTimeScale;
        this.isAudioContiguous = contiguous = contiguous || inputSamples.length && nextAudioTs > 0 && (accurateTimeOffset && Math.abs(timeOffsetMpegTS - (nextAudioTs + initTime)) < 9000 || Math.abs($b941786f4eb9cb76$var$normalizePts(inputSamples[0].pts, timeOffsetMpegTS) - (nextAudioTs + initTime)) < 20 * inputSampleDuration);
        // compute normalized PTS
        inputSamples.forEach(function(sample) {
            sample.pts = $b941786f4eb9cb76$var$normalizePts(sample.pts, timeOffsetMpegTS);
        });
        if (!contiguous || nextAudioTs < 0) {
            const sampleCount = inputSamples.length;
            // filter out sample with negative PTS that are not playable anyway
            // if we don't remove these negative samples, they will shift all audio samples forward.
            // leading to audio overlap between current / next fragment
            inputSamples = inputSamples.filter((sample)=>sample.pts >= 0);
            if (sampleCount !== inputSamples.length) this.warn(`Removed ${inputSamples.length - sampleCount} of ${sampleCount} samples (initPTS ${initTime} / ${inputTimeScale})`);
            // in case all samples have negative PTS, and have been filtered out, return now
            if (!inputSamples.length) return;
            if (videoTimeOffset === 0) // Set the start to match video so that start gaps larger than inputSampleDuration are filled with silence
            nextAudioTs = 0;
            else if (accurateTimeOffset && !alignedWithVideo) // When not seeking, not live, and LevelDetails.PTSKnown, use fragment start as predicted next audio PTS
            nextAudioTs = Math.max(0, timeOffsetMpegTS - initTime);
            else // if frags are not contiguous and if we cant trust time offset, let's use first sample PTS as next audio PTS
            nextAudioTs = inputSamples[0].pts - initTime;
        }
        // If the audio track is missing samples, the frames seem to get "left-shifted" within the
        // resulting mp4 segment, causing sync issues and leaving gaps at the end of the audio segment.
        // In an effort to prevent this from happening, we inject frames here where there are gaps.
        // When possible, we inject a silent frame; when that's not possible, we duplicate the last
        // frame.
        if (track.segmentCodec === 'aac') {
            const maxAudioFramesDrift = this.config.maxAudioFramesDrift;
            for(let i = 0, nextPts = nextAudioTs + initTime; i < inputSamples.length; i++){
                // First, let's see how far off this frame is from where we expect it to be
                const sample = inputSamples[i];
                const pts = sample.pts;
                const delta = pts - nextPts;
                const duration = Math.abs(1000 * delta / inputTimeScale);
                // When remuxing with video, if we're overlapping by more than a duration, drop this sample to stay in sync
                if (delta <= -maxAudioFramesDrift * inputSampleDuration && alignedWithVideo) {
                    if (i === 0) {
                        this.warn(`Audio frame @ ${(pts / inputTimeScale).toFixed(3)}s overlaps marker by ${Math.round(1000 * delta / inputTimeScale)} ms.`);
                        this.nextAudioTs = nextAudioTs = pts - initTime;
                        nextPts = pts;
                    }
                } else if (delta >= maxAudioFramesDrift * inputSampleDuration && duration < $b941786f4eb9cb76$var$MAX_SILENT_FRAME_DURATION && alignedWithVideo) {
                    let missing = Math.round(delta / inputSampleDuration);
                    // Adjust nextPts so that silent samples are aligned with media pts. This will prevent media samples from
                    // later being shifted if nextPts is based on timeOffset and delta is not a multiple of inputSampleDuration.
                    nextPts = pts - missing * inputSampleDuration;
                    while(nextPts < 0 && missing && inputSampleDuration){
                        missing--;
                        nextPts += inputSampleDuration;
                    }
                    if (i === 0) this.nextAudioTs = nextAudioTs = nextPts - initTime;
                    this.warn(`Injecting ${missing} audio frames @ ${((nextPts - initTime) / inputTimeScale).toFixed(3)}s due to ${Math.round(1000 * delta / inputTimeScale)} ms gap.`);
                    for(let j = 0; j < missing; j++){
                        let fillFrame = $b941786f4eb9cb76$var$AAC.getSilentFrame(track.parsedCodec || track.manifestCodec || track.codec, track.channelCount);
                        if (!fillFrame) {
                            this.log('Unable to get silent frame for given audio codec; duplicating last frame instead.');
                            fillFrame = sample.unit.subarray();
                        }
                        inputSamples.splice(i, 0, {
                            unit: fillFrame,
                            pts: nextPts
                        });
                        nextPts += inputSampleDuration;
                        i++;
                    }
                }
                sample.pts = nextPts;
                nextPts += inputSampleDuration;
            }
        }
        let firstPTS = null;
        let lastPTS = null;
        let mdat;
        let mdatSize = 0;
        let sampleLength = inputSamples.length;
        while(sampleLength--)mdatSize += inputSamples[sampleLength].unit.byteLength;
        for(let j = 0, _nbSamples = inputSamples.length; j < _nbSamples; j++){
            const audioSample = inputSamples[j];
            const unit = audioSample.unit;
            let pts = audioSample.pts;
            if (lastPTS !== null) {
                // If we have more than one sample, set the duration of the sample to the "real" duration; the PTS diff with
                // the previous sample
                const prevSample = outputSamples[j - 1];
                prevSample.duration = Math.round((pts - lastPTS) / scaleFactor);
            } else {
                if (contiguous && track.segmentCodec === 'aac') // set PTS/DTS to expected PTS/DTS
                pts = nextAudioTs + initTime;
                // remember first PTS of our audioSamples
                firstPTS = pts;
                if (mdatSize > 0) {
                    /* concatenate the audio data and construct the mdat in place
            (need 8 more bytes to fill length and mdat type) */ mdatSize += offset;
                    try {
                        mdat = new Uint8Array(mdatSize);
                    } catch (err) {
                        this.observer.emit($b941786f4eb9cb76$export$ada873a34909da65.ERROR, $b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MUX_ERROR,
                            details: $b941786f4eb9cb76$export$d053ec805ce391aa.REMUX_ALLOC_ERROR,
                            fatal: false,
                            error: err,
                            bytes: mdatSize,
                            reason: `fail allocating audio mdat ${mdatSize}`
                        });
                        return;
                    }
                    if (!rawMPEG) {
                        const view = new DataView(mdat.buffer);
                        view.setUint32(0, mdatSize);
                        mdat.set($b941786f4eb9cb76$var$MP4.types.mdat, 4);
                    }
                } else // no audio samples
                return;
            }
            mdat.set(unit, offset);
            const unitLen = unit.byteLength;
            offset += unitLen;
            // Default the sample's duration to the computed mp4SampleDuration, which will either be 1024 for AAC or 1152 for MPEG
            // In the case that we have 1 sample, this will be the duration. If we have more than one sample, the duration
            // becomes the PTS diff with the previous sample
            outputSamples.push($b941786f4eb9cb76$var$createMp4Sample(true, mp4SampleDuration, unitLen, 0));
            lastPTS = pts;
        }
        // We could end up with no audio samples if all input samples were overlapping with the previously remuxed ones
        const nbSamples = outputSamples.length;
        if (!nbSamples) return;
        // The next audio sample PTS should be equal to last sample PTS + duration
        const lastSample = outputSamples[outputSamples.length - 1];
        nextAudioTs = lastPTS - initTime;
        this.nextAudioTs = nextAudioTs + scaleFactor * lastSample.duration;
        // Set the track samples from inputSamples to outputSamples before remuxing
        const moof = rawMPEG ? new Uint8Array(0) : $b941786f4eb9cb76$var$MP4.moof(track.sequenceNumber++, firstPTS / scaleFactor, $b941786f4eb9cb76$var$_extends({}, track, {
            samples: outputSamples
        }));
        // Clear the track samples. This also clears the samples array in the demuxer, since the reference is shared
        track.samples = [];
        const start = (firstPTS - initTime) / inputTimeScale;
        const end = this.nextAudioTs / inputTimeScale;
        const type = 'audio';
        const audioData = {
            data1: moof,
            data2: mdat,
            startPTS: start,
            endPTS: end,
            startDTS: start,
            endDTS: end,
            type: type,
            hasAudio: true,
            hasVideo: false,
            nb: nbSamples
        };
        this.isAudioContiguous = true;
        return audioData;
    }
}
function $b941786f4eb9cb76$var$normalizePts(value, reference) {
    let offset;
    if (reference === null) return value;
    if (reference < value) // - 2^33
    offset = -8589934592;
    else // + 2^33
    offset = 8589934592;
    /* PTS is 33bit (from 0 to 2^33 -1)
    if diff between value and reference is bigger than half of the amplitude (2^32) then it means that
    PTS looping occured. fill the gap */ while(Math.abs(value - reference) > 4294967296)value += offset;
    return value;
}
function $b941786f4eb9cb76$var$findKeyframeIndex(samples) {
    for(let i = 0; i < samples.length; i++){
        if (samples[i].key) return i;
    }
    return -1;
}
function $b941786f4eb9cb76$var$flushTextTrackMetadataCueSamples(track, timeOffset, initPTS, initDTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting id3 pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = $b941786f4eb9cb76$var$normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
        sample.dts = $b941786f4eb9cb76$var$normalizePts(sample.dts - initDTS.baseTime * inputTimeScale / initDTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    const samples = track.samples;
    track.samples = [];
    return {
        samples: samples
    };
}
function $b941786f4eb9cb76$var$flushTextTrackUserdataCueSamples(track, timeOffset, initPTS) {
    const length = track.samples.length;
    if (!length) return;
    const inputTimeScale = track.inputTimeScale;
    for(let index = 0; index < length; index++){
        const sample = track.samples[index];
        // setting text pts, dts to relative time
        // using this._initPTS and this._initDTS to calculate relative time
        sample.pts = $b941786f4eb9cb76$var$normalizePts(sample.pts - initPTS.baseTime * inputTimeScale / initPTS.timescale, timeOffset * inputTimeScale) / inputTimeScale;
    }
    track.samples.sort((a, b)=>a.pts - b.pts);
    const samples = track.samples;
    track.samples = [];
    return {
        samples: samples
    };
}
class $b941786f4eb9cb76$var$PassThroughRemuxer extends $b941786f4eb9cb76$var$Logger {
    constructor(observer, config, typeSupported, logger){
        super('passthrough-remuxer', logger);
        this.emitInitSegment = false;
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initData = void 0;
        this.initPTS = null;
        this.initTracks = void 0;
        this.lastEndTime = null;
        this.isVideoContiguous = false;
    }
    destroy() {}
    resetTimeStamp(defaultInitPTS) {
        this.lastEndTime = null;
        const initPTS = this.initPTS;
        if (initPTS && defaultInitPTS) {
            if (initPTS.baseTime === defaultInitPTS.baseTime && initPTS.timescale === defaultInitPTS.timescale) return;
        }
        this.initPTS = defaultInitPTS;
    }
    resetNextTimestamp() {
        this.isVideoContiguous = false;
        this.lastEndTime = null;
    }
    resetInitSegment(initSegment, audioCodec, videoCodec, decryptdata) {
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.generateInitSegment(initSegment, decryptdata);
        this.emitInitSegment = true;
    }
    generateInitSegment(initSegment, decryptdata) {
        let { audioCodec: audioCodec, videoCodec: videoCodec } = this;
        if (!(initSegment != null && initSegment.byteLength)) {
            this.initTracks = undefined;
            this.initData = undefined;
            return;
        }
        const { audio: audio, video: video } = this.initData = $b941786f4eb9cb76$var$parseInitSegment(initSegment);
        if (decryptdata) $b941786f4eb9cb76$var$patchEncyptionData(initSegment, decryptdata);
        else {
            const eitherTrack = audio || video;
            if (eitherTrack != null && eitherTrack.encrypted) this.warn(`Init segment with encrypted track with has no key ("${eitherTrack.codec}")!`);
        }
        // Get codec from initSegment
        if (audio) audioCodec = $b941786f4eb9cb76$var$getParsedTrackCodec(audio, $b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO, this);
        if (video) videoCodec = $b941786f4eb9cb76$var$getParsedTrackCodec(video, $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO, this);
        const tracks = {};
        if (audio && video) tracks.audiovideo = {
            container: 'video/mp4',
            codec: audioCodec + ',' + videoCodec,
            supplemental: video.supplemental,
            encrypted: video.encrypted,
            initSegment: initSegment,
            id: 'main'
        };
        else if (audio) tracks.audio = {
            container: 'audio/mp4',
            codec: audioCodec,
            encrypted: audio.encrypted,
            initSegment: initSegment,
            id: 'audio'
        };
        else if (video) tracks.video = {
            container: 'video/mp4',
            codec: videoCodec,
            supplemental: video.supplemental,
            encrypted: video.encrypted,
            initSegment: initSegment,
            id: 'main'
        };
        else this.warn('initSegment does not contain moov or trak boxes.');
        this.initTracks = tracks;
    }
    remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset) {
        var _initData, _initData2;
        let { initPTS: initPTS, lastEndTime: lastEndTime } = this;
        const result = {
            audio: undefined,
            video: undefined,
            text: textTrack,
            id3: id3Track,
            initSegment: undefined
        };
        // If we haven't yet set a lastEndDTS, or it was reset, set it to the provided timeOffset. We want to use the
        // lastEndDTS over timeOffset whenever possible; during progressive playback, the media source will not update
        // the media duration (which is what timeOffset is provided as) before we need to process the next chunk.
        if (!$b941786f4eb9cb76$var$isFiniteNumber(lastEndTime)) lastEndTime = this.lastEndTime = timeOffset || 0;
        // The binary segment data is added to the videoTrack in the mp4demuxer. We don't check to see if the data is only
        // audio or video (or both); adding it to video was an arbitrary choice.
        const data = videoTrack.samples;
        if (!data.length) return result;
        const initSegment = {
            initPTS: undefined,
            timescale: undefined,
            trackId: undefined
        };
        let initData = this.initData;
        if (!((_initData = initData) != null && _initData.length)) {
            this.generateInitSegment(data);
            initData = this.initData;
        }
        if (!((_initData2 = initData) != null && _initData2.length)) {
            // We can't remux if the initSegment could not be generated
            this.warn('Failed to generate initSegment.');
            return result;
        }
        if (this.emitInitSegment) {
            initSegment.tracks = this.initTracks;
            this.emitInitSegment = false;
        }
        const trackSampleData = $b941786f4eb9cb76$var$getSampleData(data, initData, this);
        const audioSampleTimestamps = initData.audio ? trackSampleData[initData.audio.id] : null;
        const videoSampleTimestamps = initData.video ? trackSampleData[initData.video.id] : null;
        const videoStartTime = $b941786f4eb9cb76$var$toStartEndOrDefault(videoSampleTimestamps, Infinity);
        const audioStartTime = $b941786f4eb9cb76$var$toStartEndOrDefault(audioSampleTimestamps, Infinity);
        const videoEndTime = $b941786f4eb9cb76$var$toStartEndOrDefault(videoSampleTimestamps, 0, true);
        const audioEndTime = $b941786f4eb9cb76$var$toStartEndOrDefault(audioSampleTimestamps, 0, true);
        let decodeTime = timeOffset;
        let duration = 0;
        const syncOnAudio = audioSampleTimestamps && (!videoSampleTimestamps || !initPTS && audioStartTime < videoStartTime || initPTS && initPTS.trackId === initData.audio.id);
        const baseOffsetSamples = syncOnAudio ? audioSampleTimestamps : videoSampleTimestamps;
        if (baseOffsetSamples) {
            const timescale = baseOffsetSamples.timescale;
            const baseTime = baseOffsetSamples.start - timeOffset * timescale;
            const trackId = syncOnAudio ? initData.audio.id : initData.video.id;
            decodeTime = baseOffsetSamples.start / timescale;
            duration = syncOnAudio ? audioEndTime - audioStartTime : videoEndTime - videoStartTime;
            if ((accurateTimeOffset || !initPTS) && ($b941786f4eb9cb76$var$isInvalidInitPts(initPTS, decodeTime, timeOffset, duration) || timescale !== initPTS.timescale)) {
                if (initPTS) this.warn(`Timestamps at playlist time: ${accurateTimeOffset ? '' : '~'}${timeOffset} ${baseTime / timescale} != initPTS: ${initPTS.baseTime / initPTS.timescale} (${initPTS.baseTime}/${initPTS.timescale}) trackId: ${initPTS.trackId}`);
                this.log(`Found initPTS at playlist time: ${timeOffset} offset: ${decodeTime - timeOffset} (${baseTime}/${timescale}) trackId: ${trackId}`);
                initPTS = null;
                initSegment.initPTS = baseTime;
                initSegment.timescale = timescale;
                initSegment.trackId = trackId;
            }
        } else this.warn(`No audio or video samples found for initPTS at playlist time: ${timeOffset}`);
        if (!initPTS) {
            if (!initSegment.timescale || initSegment.trackId === undefined || initSegment.initPTS === undefined) {
                this.warn('Could not set initPTS');
                initSegment.initPTS = decodeTime;
                initSegment.timescale = 1;
                initSegment.trackId = -1;
            }
            this.initPTS = initPTS = {
                baseTime: initSegment.initPTS,
                timescale: initSegment.timescale,
                trackId: initSegment.trackId
            };
        } else {
            initSegment.initPTS = initPTS.baseTime;
            initSegment.timescale = initPTS.timescale;
            initSegment.trackId = initPTS.trackId;
        }
        const startTime = decodeTime - initPTS.baseTime / initPTS.timescale;
        const endTime = startTime + duration;
        if (duration > 0) this.lastEndTime = endTime;
        else {
            this.warn('Duration parsed from mp4 should be greater than zero');
            this.resetNextTimestamp();
        }
        const hasAudio = !!initData.audio;
        const hasVideo = !!initData.video;
        let type = '';
        if (hasAudio) type += 'audio';
        if (hasVideo) type += 'video';
        const encrypted = (initData.audio ? initData.audio.encrypted : false) || (initData.video ? initData.video.encrypted : false);
        const track = {
            data1: data,
            startPTS: startTime,
            startDTS: startTime,
            endPTS: endTime,
            endDTS: endTime,
            type: type,
            hasAudio: hasAudio,
            hasVideo: hasVideo,
            nb: 1,
            dropped: 0,
            encrypted: encrypted
        };
        result.audio = hasAudio && !hasVideo ? track : undefined;
        result.video = hasVideo ? track : undefined;
        const videoSampleCount = videoSampleTimestamps == null ? void 0 : videoSampleTimestamps.sampleCount;
        if (videoSampleCount) {
            const firstKeyFrame = videoSampleTimestamps.keyFrameIndex;
            const independent = firstKeyFrame !== -1;
            track.nb = videoSampleCount;
            track.dropped = firstKeyFrame === 0 || this.isVideoContiguous ? 0 : independent ? firstKeyFrame : videoSampleCount;
            track.independent = independent;
            track.firstKeyFrame = firstKeyFrame;
            if (independent && videoSampleTimestamps.keyFrameStart) track.firstKeyFramePTS = (videoSampleTimestamps.keyFrameStart - initPTS.baseTime) / initPTS.timescale;
            if (!this.isVideoContiguous) result.independent = independent;
            this.isVideoContiguous || (this.isVideoContiguous = independent);
            if (track.dropped) this.warn(`fmp4 does not start with IDR: firstIDR ${firstKeyFrame}/${videoSampleCount} dropped: ${track.dropped} start: ${track.firstKeyFramePTS || 'NA'}`);
        }
        result.initSegment = initSegment;
        result.id3 = $b941786f4eb9cb76$var$flushTextTrackMetadataCueSamples(id3Track, timeOffset, initPTS, initPTS);
        if (textTrack.samples.length) result.text = $b941786f4eb9cb76$var$flushTextTrackUserdataCueSamples(textTrack, timeOffset, initPTS);
        return result;
    }
}
function $b941786f4eb9cb76$var$toStartEndOrDefault(trackTimes, defaultValue, end = false) {
    return (trackTimes == null ? void 0 : trackTimes.start) !== undefined ? (trackTimes.start + (end ? trackTimes.duration : 0)) / trackTimes.timescale : defaultValue;
}
function $b941786f4eb9cb76$var$isInvalidInitPts(initPTS, startDTS, timeOffset, duration) {
    if (initPTS === null) return true;
    // InitPTS is invalid when distance from program would be more than segment duration or a minimum of one second
    const minDuration = Math.max(duration, 1);
    const startTime = startDTS - initPTS.baseTime / initPTS.timescale;
    return Math.abs(startTime - timeOffset) > minDuration;
}
function $b941786f4eb9cb76$var$getParsedTrackCodec(track, type, logger) {
    const parsedCodec = track.codec;
    if (parsedCodec && parsedCodec.length > 4) return parsedCodec;
    if (type === $b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO) {
        if (parsedCodec === 'ec-3' || parsedCodec === 'ac-3' || parsedCodec === 'alac') return parsedCodec;
        if (parsedCodec === 'fLaC' || parsedCodec === 'Opus') {
            // Opting not to get `preferManagedMediaSource` from player config for isSupported() check for simplicity
            const preferManagedMediaSource = false;
            return $b941786f4eb9cb76$var$getCodecCompatibleName(parsedCodec, preferManagedMediaSource);
        }
        logger.warn(`Unhandled audio codec "${parsedCodec}" in mp4 MAP`);
        return parsedCodec || 'mp4a';
    }
    // Provide defaults based on codec type
    // This allows for some playback of some fmp4 playlists without CODECS defined in manifest
    logger.warn(`Unhandled video codec "${parsedCodec}" in mp4 MAP`);
    return parsedCodec || 'avc1';
}
let $b941786f4eb9cb76$var$now;
// performance.now() not available on WebWorker, at least on Safari Desktop
try {
    $b941786f4eb9cb76$var$now = self.performance.now.bind(self.performance);
} catch (err) {
    $b941786f4eb9cb76$var$now = Date.now;
}
const $b941786f4eb9cb76$var$muxConfig = [
    {
        demux: $b941786f4eb9cb76$var$MP4Demuxer,
        remux: $b941786f4eb9cb76$var$PassThroughRemuxer
    },
    {
        demux: $b941786f4eb9cb76$var$TSDemuxer,
        remux: $b941786f4eb9cb76$var$MP4Remuxer
    },
    {
        demux: $b941786f4eb9cb76$var$AACDemuxer,
        remux: $b941786f4eb9cb76$var$MP4Remuxer
    },
    {
        demux: $b941786f4eb9cb76$var$MP3Demuxer,
        remux: $b941786f4eb9cb76$var$MP4Remuxer
    }
];
$b941786f4eb9cb76$var$muxConfig.splice(2, 0, {
    demux: $b941786f4eb9cb76$var$AC3Demuxer,
    remux: $b941786f4eb9cb76$var$MP4Remuxer
});
class $b941786f4eb9cb76$var$Transmuxer {
    constructor(observer, typeSupported, config, vendor, id, logger){
        this.asyncResult = false;
        this.logger = void 0;
        this.observer = void 0;
        this.typeSupported = void 0;
        this.config = void 0;
        this.id = void 0;
        this.demuxer = void 0;
        this.remuxer = void 0;
        this.decrypter = void 0;
        this.probe = void 0;
        this.decryptionPromise = null;
        this.transmuxConfig = void 0;
        this.currentTransmuxState = void 0;
        this.observer = observer;
        this.typeSupported = typeSupported;
        this.config = config;
        this.id = id;
        this.logger = logger;
    }
    configure(transmuxConfig) {
        this.transmuxConfig = transmuxConfig;
        if (this.decrypter) this.decrypter.reset();
    }
    push(data, decryptdata, chunkMeta, state) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = $b941786f4eb9cb76$var$now();
        let uintData = new Uint8Array(data);
        const { currentTransmuxState: currentTransmuxState, transmuxConfig: transmuxConfig } = this;
        if (state) this.currentTransmuxState = state;
        const { contiguous: contiguous, discontinuity: discontinuity, trackSwitch: trackSwitch, accurateTimeOffset: accurateTimeOffset, timeOffset: timeOffset, initSegmentChange: initSegmentChange } = state || currentTransmuxState;
        const { audioCodec: audioCodec, videoCodec: videoCodec, defaultInitPts: defaultInitPts, duration: duration, initSegmentData: initSegmentData } = transmuxConfig;
        const keyData = $b941786f4eb9cb76$var$getEncryptionType(uintData, decryptdata);
        if (keyData && $b941786f4eb9cb76$var$isFullSegmentEncryption(keyData.method)) {
            const decrypter = this.getDecrypter();
            const aesMode = $b941786f4eb9cb76$var$getAesModeFromFullSegmentMethod(keyData.method);
            // Software decryption is synchronous; webCrypto is not
            if (decrypter.isSync()) {
                // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
                // data is handled in the flush() call
                let decryptedData = decrypter.softwareDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode);
                // For Low-Latency HLS Parts, decrypt in place, since part parsing is expected on push progress
                const loadingParts = chunkMeta.part > -1;
                if (loadingParts) {
                    const _data = decrypter.flush();
                    decryptedData = _data ? _data.buffer : _data;
                }
                if (!decryptedData) {
                    stats.executeEnd = $b941786f4eb9cb76$var$now();
                    return $b941786f4eb9cb76$var$emptyResult(chunkMeta);
                }
                uintData = new Uint8Array(decryptedData);
            } else {
                this.asyncResult = true;
                this.decryptionPromise = decrypter.webCryptoDecrypt(uintData, keyData.key.buffer, keyData.iv.buffer, aesMode).then((decryptedData)=>{
                    // Calling push here is important; if flush() is called while this is still resolving, this ensures that
                    // the decrypted data has been transmuxed
                    const result = this.push(decryptedData, null, chunkMeta);
                    this.decryptionPromise = null;
                    return result;
                });
                return this.decryptionPromise;
            }
        }
        const resetMuxers = this.needsProbing(discontinuity, trackSwitch);
        if (resetMuxers) {
            const error = this.configureTransmuxer(uintData);
            if (error) {
                this.logger.warn(`[transmuxer] ${error.message}`);
                this.observer.emit($b941786f4eb9cb76$export$ada873a34909da65.ERROR, $b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
                    fatal: false,
                    error: error,
                    reason: error.message
                });
                stats.executeEnd = $b941786f4eb9cb76$var$now();
                return $b941786f4eb9cb76$var$emptyResult(chunkMeta);
            }
        }
        if (discontinuity || trackSwitch || initSegmentChange || resetMuxers) this.resetInitSegment(initSegmentData, audioCodec, videoCodec, duration, decryptdata);
        if (discontinuity || initSegmentChange || resetMuxers) this.resetInitialTimestamp(defaultInitPts);
        if (!contiguous) this.resetContiguity();
        const result = this.transmux(uintData, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        this.asyncResult = $b941786f4eb9cb76$var$isPromise(result);
        const currentState = this.currentTransmuxState;
        currentState.contiguous = true;
        currentState.discontinuity = false;
        currentState.trackSwitch = false;
        stats.executeEnd = $b941786f4eb9cb76$var$now();
        return result;
    }
    // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
    flush(chunkMeta) {
        const stats = chunkMeta.transmuxing;
        stats.executeStart = $b941786f4eb9cb76$var$now();
        const { decrypter: decrypter, currentTransmuxState: currentTransmuxState, decryptionPromise: decryptionPromise } = this;
        if (decryptionPromise) {
            this.asyncResult = true;
            // Upon resolution, the decryption promise calls push() and returns its TransmuxerResult up the stack. Therefore
            // only flushing is required for async decryption
            return decryptionPromise.then(()=>{
                return this.flush(chunkMeta);
            });
        }
        const transmuxResults = [];
        const { timeOffset: timeOffset } = currentTransmuxState;
        if (decrypter) {
            // The decrypter may have data cached, which needs to be demuxed. In this case we'll have two TransmuxResults
            // This happens in the case that we receive only 1 push call for a segment (either for non-progressive downloads,
            // or for progressive downloads with small segments)
            const decryptedData = decrypter.flush();
            if (decryptedData) // Push always returns a TransmuxerResult if decryptdata is null
            transmuxResults.push(this.push(decryptedData.buffer, null, chunkMeta));
        }
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) {
            // If probing failed, then Hls.js has been given content its not able to handle
            stats.executeEnd = $b941786f4eb9cb76$var$now();
            const emptyResults = [
                $b941786f4eb9cb76$var$emptyResult(chunkMeta)
            ];
            if (this.asyncResult) return Promise.resolve(emptyResults);
            return emptyResults;
        }
        const demuxResultOrPromise = demuxer.flush(timeOffset);
        if ($b941786f4eb9cb76$var$isPromise(demuxResultOrPromise)) {
            this.asyncResult = true;
            // Decrypt final SAMPLE-AES samples
            return demuxResultOrPromise.then((demuxResult)=>{
                this.flushRemux(transmuxResults, demuxResult, chunkMeta);
                return transmuxResults;
            });
        }
        this.flushRemux(transmuxResults, demuxResultOrPromise, chunkMeta);
        if (this.asyncResult) return Promise.resolve(transmuxResults);
        return transmuxResults;
    }
    flushRemux(transmuxResults, demuxResult, chunkMeta) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = demuxResult;
        const { accurateTimeOffset: accurateTimeOffset, timeOffset: timeOffset } = this.currentTransmuxState;
        this.logger.log(`[transmuxer.ts]: Flushed ${this.id} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? ' part: ' + chunkMeta.part : ''} of ${this.id === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN ? 'level' : 'track'} ${chunkMeta.level}`);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, true, this.id);
        transmuxResults.push({
            remuxResult: remuxResult,
            chunkMeta: chunkMeta
        });
        chunkMeta.transmuxing.executeEnd = $b941786f4eb9cb76$var$now();
    }
    resetInitialTimestamp(defaultInitPts) {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetTimeStamp(defaultInitPts);
        remuxer.resetTimeStamp(defaultInitPts);
    }
    resetContiguity() {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetContiguity();
        remuxer.resetNextTimestamp();
    }
    resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration, decryptdata) {
        const { demuxer: demuxer, remuxer: remuxer } = this;
        if (!demuxer || !remuxer) return;
        demuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, trackDuration);
        remuxer.resetInitSegment(initSegmentData, audioCodec, videoCodec, decryptdata);
    }
    destroy() {
        if (this.demuxer) {
            this.demuxer.destroy();
            this.demuxer = undefined;
        }
        if (this.remuxer) {
            this.remuxer.destroy();
            this.remuxer = undefined;
        }
    }
    transmux(data, keyData, timeOffset, accurateTimeOffset, chunkMeta) {
        let result;
        if (keyData && keyData.method === 'SAMPLE-AES') result = this.transmuxSampleAes(data, keyData, timeOffset, accurateTimeOffset, chunkMeta);
        else result = this.transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta);
        return result;
    }
    transmuxUnencrypted(data, timeOffset, accurateTimeOffset, chunkMeta) {
        const { audioTrack: audioTrack, videoTrack: videoTrack, id3Track: id3Track, textTrack: textTrack } = this.demuxer.demux(data, timeOffset, false, !this.config.progressive);
        const remuxResult = this.remuxer.remux(audioTrack, videoTrack, id3Track, textTrack, timeOffset, accurateTimeOffset, false, this.id);
        return {
            remuxResult: remuxResult,
            chunkMeta: chunkMeta
        };
    }
    transmuxSampleAes(data, decryptData, timeOffset, accurateTimeOffset, chunkMeta) {
        return this.demuxer.demuxSampleAes(data, decryptData, timeOffset).then((demuxResult)=>{
            const remuxResult = this.remuxer.remux(demuxResult.audioTrack, demuxResult.videoTrack, demuxResult.id3Track, demuxResult.textTrack, timeOffset, accurateTimeOffset, false, this.id);
            return {
                remuxResult: remuxResult,
                chunkMeta: chunkMeta
            };
        });
    }
    configureTransmuxer(data) {
        const { config: config, observer: observer, typeSupported: typeSupported } = this;
        // probe for content type
        let mux;
        for(let i = 0, len = $b941786f4eb9cb76$var$muxConfig.length; i < len; i++){
            var _muxConfig$i$demux;
            if ((_muxConfig$i$demux = $b941786f4eb9cb76$var$muxConfig[i].demux) != null && _muxConfig$i$demux.probe(data, this.logger)) {
                mux = $b941786f4eb9cb76$var$muxConfig[i];
                break;
            }
        }
        if (!mux) return new Error('Failed to find demuxer by probing fragment data');
        // so let's check that current remuxer and demuxer are still valid
        const demuxer = this.demuxer;
        const remuxer = this.remuxer;
        const Remuxer = mux.remux;
        const Demuxer = mux.demux;
        if (!remuxer || !(remuxer instanceof Remuxer)) this.remuxer = new Remuxer(observer, config, typeSupported, this.logger);
        if (!demuxer || !(demuxer instanceof Demuxer)) {
            this.demuxer = new Demuxer(observer, config, typeSupported, this.logger);
            this.probe = Demuxer.probe;
        }
    }
    needsProbing(discontinuity, trackSwitch) {
        // in case of continuity change, or track switch
        // we might switch from content type (AAC container to TS container, or TS to fmp4 for example)
        return !this.demuxer || !this.remuxer || discontinuity || trackSwitch;
    }
    getDecrypter() {
        let decrypter = this.decrypter;
        if (!decrypter) decrypter = this.decrypter = new $b941786f4eb9cb76$var$Decrypter(this.config);
        return decrypter;
    }
}
function $b941786f4eb9cb76$var$getEncryptionType(data, decryptData) {
    let encryptionType = null;
    if (data.byteLength > 0 && (decryptData == null ? void 0 : decryptData.key) != null && decryptData.iv !== null && decryptData.method != null) encryptionType = decryptData;
    return encryptionType;
}
const $b941786f4eb9cb76$var$emptyResult = (chunkMeta)=>({
        remuxResult: {},
        chunkMeta: chunkMeta
    });
function $b941786f4eb9cb76$var$isPromise(p) {
    return 'then' in p && p.then instanceof Function;
}
class $b941786f4eb9cb76$var$TransmuxConfig {
    constructor(audioCodec, videoCodec, initSegmentData, duration, defaultInitPts){
        this.audioCodec = void 0;
        this.videoCodec = void 0;
        this.initSegmentData = void 0;
        this.duration = void 0;
        this.defaultInitPts = void 0;
        this.audioCodec = audioCodec;
        this.videoCodec = videoCodec;
        this.initSegmentData = initSegmentData;
        this.duration = duration;
        this.defaultInitPts = defaultInitPts || null;
    }
}
class $b941786f4eb9cb76$var$TransmuxState {
    constructor(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange){
        this.discontinuity = void 0;
        this.contiguous = void 0;
        this.accurateTimeOffset = void 0;
        this.trackSwitch = void 0;
        this.timeOffset = void 0;
        this.initSegmentChange = void 0;
        this.discontinuity = discontinuity;
        this.contiguous = contiguous;
        this.accurateTimeOffset = accurateTimeOffset;
        this.trackSwitch = trackSwitch;
        this.timeOffset = timeOffset;
        this.initSegmentChange = initSegmentChange;
    }
}
let $b941786f4eb9cb76$var$transmuxerInstanceCount = 0;
class $b941786f4eb9cb76$var$TransmuxerInterface {
    constructor(_hls, id, onTransmuxComplete, onFlush){
        this.error = null;
        this.hls = void 0;
        this.id = void 0;
        this.instanceNo = $b941786f4eb9cb76$var$transmuxerInstanceCount++;
        this.observer = void 0;
        this.frag = null;
        this.part = null;
        this.useWorker = void 0;
        this.workerContext = null;
        this.transmuxer = null;
        this.onTransmuxComplete = void 0;
        this.onFlush = void 0;
        this.onWorkerMessage = (event)=>{
            const data = event.data;
            const hls = this.hls;
            if (!hls || !(data != null && data.event) || data.instanceNo !== this.instanceNo) return;
            switch(data.event){
                case 'init':
                    {
                        var _this$workerContext;
                        const objectURL = (_this$workerContext = this.workerContext) == null ? void 0 : _this$workerContext.objectURL;
                        if (objectURL) // revoke the Object URL that was used to create transmuxer worker, so as not to leak it
                        self.URL.revokeObjectURL(objectURL);
                        break;
                    }
                case 'transmuxComplete':
                    this.handleTransmuxComplete(data.data);
                    break;
                case 'flush':
                    this.onFlush(data.data);
                    break;
                // pass logs from the worker thread to the main logger
                case 'workerLog':
                    if (hls.logger[data.data.logType]) hls.logger[data.data.logType](data.data.message);
                    break;
                default:
                    data.data = data.data || {};
                    data.data.frag = this.frag;
                    data.data.part = this.part;
                    data.data.id = this.id;
                    hls.trigger(data.event, data.data);
                    break;
            }
        };
        this.onWorkerError = (event)=>{
            if (!this.hls) return;
            const error = new Error(`${event.message}  (${event.filename}:${event.lineno})`);
            this.hls.config.enableWorker = false;
            this.hls.logger.warn(`Error in "${this.id}" Web Worker, fallback to inline`);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_EXCEPTION,
                fatal: false,
                event: 'demuxerWorker',
                error: error
            });
        };
        const config = _hls.config;
        this.hls = _hls;
        this.id = id;
        this.useWorker = !!config.enableWorker;
        this.onTransmuxComplete = onTransmuxComplete;
        this.onFlush = onFlush;
        const forwardMessage = (ev, data)=>{
            data = data || {};
            data.frag = this.frag || undefined;
            if (ev === $b941786f4eb9cb76$export$ada873a34909da65.ERROR) {
                data;
                data.parent = this.id;
                data.part = this.part;
                this.error = data.error;
            }
            this.hls.trigger(ev, data);
        };
        // forward events to main thread
        this.observer = new $b941786f4eb9cb76$var$EventEmitter();
        this.observer.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_DECRYPTED, forwardMessage);
        this.observer.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, forwardMessage);
        const m2tsTypeSupported = $b941786f4eb9cb76$var$getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
        if (this.useWorker && typeof Worker !== 'undefined') {
            const logger = this.hls.logger;
            const canCreateWorker = config.workerPath || $b941786f4eb9cb76$var$hasUMDWorker();
            if (canCreateWorker) {
                try {
                    if (config.workerPath) {
                        logger.log(`loading Web Worker ${config.workerPath} for "${id}"`);
                        this.workerContext = $b941786f4eb9cb76$var$loadWorker(config.workerPath);
                    } else {
                        logger.log(`injecting Web Worker for "${id}"`);
                        this.workerContext = $b941786f4eb9cb76$var$injectWorker();
                    }
                    const { worker: worker } = this.workerContext;
                    worker.addEventListener('message', this.onWorkerMessage);
                    worker.addEventListener('error', this.onWorkerError);
                    worker.postMessage({
                        instanceNo: this.instanceNo,
                        cmd: 'init',
                        typeSupported: m2tsTypeSupported,
                        id: id,
                        config: $b941786f4eb9cb76$var$stringify(config)
                    });
                } catch (err) {
                    logger.warn(`Error setting up "${id}" Web Worker, fallback to inline`, err);
                    this.terminateWorker();
                    this.error = null;
                    this.transmuxer = new $b941786f4eb9cb76$var$Transmuxer(this.observer, m2tsTypeSupported, config, '', id, _hls.logger);
                }
                return;
            }
        }
        this.transmuxer = new $b941786f4eb9cb76$var$Transmuxer(this.observer, m2tsTypeSupported, config, '', id, _hls.logger);
    }
    reset() {
        this.frag = null;
        this.part = null;
        if (this.workerContext) {
            const instanceNo = this.instanceNo;
            this.instanceNo = $b941786f4eb9cb76$var$transmuxerInstanceCount++;
            const config = this.hls.config;
            const m2tsTypeSupported = $b941786f4eb9cb76$var$getM2TSSupportedAudioTypes(config.preferManagedMediaSource);
            this.workerContext.worker.postMessage({
                instanceNo: this.instanceNo,
                cmd: 'reset',
                resetNo: instanceNo,
                typeSupported: m2tsTypeSupported,
                id: this.id,
                config: $b941786f4eb9cb76$var$stringify(config)
            });
        }
    }
    terminateWorker() {
        if (this.workerContext) {
            const { worker: worker } = this.workerContext;
            this.workerContext = null;
            worker.removeEventListener('message', this.onWorkerMessage);
            worker.removeEventListener('error', this.onWorkerError);
            $b941786f4eb9cb76$var$removeWorkerFromStore(this.hls.config.workerPath);
        }
    }
    destroy() {
        if (this.workerContext) {
            this.terminateWorker();
            // @ts-ignore
            this.onWorkerMessage = this.onWorkerError = null;
        } else {
            const transmuxer = this.transmuxer;
            if (transmuxer) {
                transmuxer.destroy();
                this.transmuxer = null;
            }
        }
        const observer = this.observer;
        if (observer) observer.removeAllListeners();
        this.frag = null;
        this.part = null;
        // @ts-ignore
        this.observer = null;
        // @ts-ignore
        this.hls = null;
    }
    push(data, initSegmentData, audioCodec, videoCodec, frag, part, duration, accurateTimeOffset, chunkMeta, defaultInitPTS) {
        var _frag$initSegment, _lastFrag$initSegment;
        chunkMeta.transmuxing.start = self.performance.now();
        const { instanceNo: instanceNo, transmuxer: transmuxer } = this;
        const timeOffset = part ? part.start : frag.start;
        // TODO: push "clear-lead" decrypt data for unencrypted fragments in streams with encrypted ones
        const decryptdata = frag.decryptdata;
        const lastFrag = this.frag;
        const discontinuity = !(lastFrag && frag.cc === lastFrag.cc);
        const trackSwitch = !(lastFrag && chunkMeta.level === lastFrag.level);
        const snDiff = lastFrag ? chunkMeta.sn - lastFrag.sn : -1;
        const partDiff = this.part ? chunkMeta.part - this.part.index : -1;
        const progressive = snDiff === 0 && chunkMeta.id > 1 && chunkMeta.id === (lastFrag == null ? void 0 : lastFrag.stats.chunkCount);
        const contiguous = !trackSwitch && (snDiff === 1 || snDiff === 0 && (partDiff === 1 || progressive && partDiff <= 0));
        const now = self.performance.now();
        if (trackSwitch || snDiff || frag.stats.parsing.start === 0) frag.stats.parsing.start = now;
        if (part && (partDiff || !contiguous)) part.stats.parsing.start = now;
        const initSegmentChange = !(lastFrag && ((_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.url) === ((_lastFrag$initSegment = lastFrag.initSegment) == null ? void 0 : _lastFrag$initSegment.url));
        const state = new $b941786f4eb9cb76$var$TransmuxState(discontinuity, contiguous, accurateTimeOffset, trackSwitch, timeOffset, initSegmentChange);
        if (!contiguous || discontinuity || initSegmentChange) {
            this.hls.logger.log(`[transmuxer-interface]: Starting new transmux session for ${frag.type} sn: ${chunkMeta.sn}${chunkMeta.part > -1 ? ' part: ' + chunkMeta.part : ''} ${this.id === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN ? 'level' : 'track'}: ${chunkMeta.level} id: ${chunkMeta.id}
        discontinuity: ${discontinuity}
        trackSwitch: ${trackSwitch}
        contiguous: ${contiguous}
        accurateTimeOffset: ${accurateTimeOffset}
        timeOffset: ${timeOffset}
        initSegmentChange: ${initSegmentChange}`);
            const config = new $b941786f4eb9cb76$var$TransmuxConfig(audioCodec, videoCodec, initSegmentData, duration, defaultInitPTS);
            this.configureTransmuxer(config);
        }
        this.frag = frag;
        this.part = part;
        // Frags with sn of 'initSegment' are not transmuxed
        if (this.workerContext) // post fragment payload as transferable objects for ArrayBuffer (no copy)
        this.workerContext.worker.postMessage({
            instanceNo: instanceNo,
            cmd: 'demux',
            data: data,
            decryptdata: decryptdata,
            chunkMeta: chunkMeta,
            state: state
        }, data instanceof ArrayBuffer ? [
            data
        ] : []);
        else if (transmuxer) {
            const transmuxResult = transmuxer.push(data, decryptdata, chunkMeta, state);
            if ($b941786f4eb9cb76$var$isPromise(transmuxResult)) transmuxResult.then((data)=>{
                this.handleTransmuxComplete(data);
            }).catch((error)=>{
                this.transmuxerError(error, chunkMeta, 'transmuxer-interface push error');
            });
            else this.handleTransmuxComplete(transmuxResult);
        }
    }
    flush(chunkMeta) {
        chunkMeta.transmuxing.start = self.performance.now();
        const { instanceNo: instanceNo, transmuxer: transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            instanceNo: instanceNo,
            cmd: 'flush',
            chunkMeta: chunkMeta
        });
        else if (transmuxer) {
            const transmuxResult = transmuxer.flush(chunkMeta);
            if ($b941786f4eb9cb76$var$isPromise(transmuxResult)) transmuxResult.then((data)=>{
                this.handleFlushResult(data, chunkMeta);
            }).catch((error)=>{
                this.transmuxerError(error, chunkMeta, 'transmuxer-interface flush error');
            });
            else this.handleFlushResult(transmuxResult, chunkMeta);
        }
    }
    transmuxerError(error, chunkMeta, reason) {
        if (!this.hls) return;
        this.error = error;
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
            details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR,
            chunkMeta: chunkMeta,
            frag: this.frag || undefined,
            part: this.part || undefined,
            fatal: false,
            error: error,
            err: error,
            reason: reason
        });
    }
    handleFlushResult(results, chunkMeta) {
        results.forEach((result)=>{
            this.handleTransmuxComplete(result);
        });
        this.onFlush(chunkMeta);
    }
    configureTransmuxer(config) {
        const { instanceNo: instanceNo, transmuxer: transmuxer } = this;
        if (this.workerContext) this.workerContext.worker.postMessage({
            instanceNo: instanceNo,
            cmd: 'configure',
            config: config
        });
        else if (transmuxer) transmuxer.configure(config);
    }
    handleTransmuxComplete(result) {
        result.chunkMeta.transmuxing.end = self.performance.now();
        this.onTransmuxComplete(result);
    }
}
const $b941786f4eb9cb76$var$TICK_INTERVAL$3 = 100; // how often to tick in ms
class $b941786f4eb9cb76$export$352c47a33fc91a8b extends $b941786f4eb9cb76$export$946cb951577581c9 {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, 'audio-stream-controller', $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO);
        this.mainAnchor = null;
        this.mainFragLoading = null;
        this.audioOnly = false;
        this.bufferedTrack = null;
        this.switchingTrack = null;
        this.trackId = -1;
        this.waitingData = null;
        this.mainDetails = null;
        this.flushing = false;
        this.bufferFlushed = false;
        this.cachedTrackLoadedData = null;
        this.registerListeners();
    }
    onHandlerDestroying() {
        this.unregisterListeners();
        super.onHandlerDestroying();
        this.resetItem();
    }
    resetItem() {
        this.mainDetails = this.mainAnchor = this.mainFragLoading = this.bufferedTrack = this.switchingTrack = this.waitingData = this.cachedTrackLoadedData = null;
    }
    registerListeners() {
        super.registerListeners();
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        super.unregisterListeners();
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
    onInitPtsFound(event, { frag: frag, id: id, initPTS: initPTS, timescale: timescale, trackId: trackId }) {
        // Always update the new INIT PTS
        // Can change due level switch
        if (id === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) {
            const cc = frag.cc;
            const inFlightFrag = this.fragCurrent;
            this.initPTS[cc] = {
                baseTime: initPTS,
                timescale: timescale,
                trackId: trackId
            };
            this.log(`InitPTS for cc: ${cc} found from main: ${initPTS / timescale} (${initPTS}/${timescale}) trackId: ${trackId}`);
            this.mainAnchor = frag;
            // If we are waiting, tick immediately to unblock audio fragment transmuxing
            if (this.state === $b941786f4eb9cb76$var$State.WAITING_INIT_PTS) {
                const waitingData = this.waitingData;
                if (!waitingData && !this.loadingParts || waitingData && waitingData.frag.cc !== cc) this.syncWithAnchor(frag, waitingData == null ? void 0 : waitingData.frag);
            } else if (!this.hls.hasEnoughToStart && inFlightFrag && inFlightFrag.cc !== cc) {
                inFlightFrag.abortRequests();
                this.syncWithAnchor(frag, inFlightFrag);
            } else if (this.state === $b941786f4eb9cb76$var$State.IDLE) this.tick();
        }
    }
    getLoadPosition() {
        if (!this.startFragRequested && this.nextLoadPosition >= 0) return this.nextLoadPosition;
        return super.getLoadPosition();
    }
    syncWithAnchor(mainAnchor, waitingToAppend) {
        var _this$mainFragLoading;
        // Drop waiting fragment if videoTrackCC has changed since waitingFragment was set and initPTS was not found
        const mainFragLoading = ((_this$mainFragLoading = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading.frag) || null;
        if (waitingToAppend) {
            if ((mainFragLoading == null ? void 0 : mainFragLoading.cc) === waitingToAppend.cc) // Wait for loading frag to complete and INIT_PTS_FOUND
            return;
        }
        const targetDiscontinuity = (mainFragLoading || mainAnchor).cc;
        const trackDetails = this.getLevelDetails();
        const pos = this.getLoadPosition();
        const syncFrag = $b941786f4eb9cb76$var$findNearestWithCC(trackDetails, targetDiscontinuity, pos);
        // Only stop waiting for audioFrag.cc if an audio segment of the same discontinuity domain (cc) is found
        if (syncFrag) {
            this.log(`Syncing with main frag at ${syncFrag.start} cc ${syncFrag.cc}`);
            this.startFragRequested = false;
            this.nextLoadPosition = syncFrag.start;
            this.resetLoadingState();
            if (this.state === $b941786f4eb9cb76$var$State.IDLE) this.doTickIdle();
        }
    }
    startLoad(startPosition, skipSeekToStartPosition) {
        if (!this.levels) {
            this.startPosition = startPosition;
            this.state = $b941786f4eb9cb76$var$State.STOPPED;
            return;
        }
        const lastCurrentTime = this.lastCurrentTime;
        this.stopLoad();
        this.setInterval($b941786f4eb9cb76$var$TICK_INTERVAL$3);
        if (lastCurrentTime > 0 && startPosition === -1) {
            this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
            startPosition = lastCurrentTime;
            this.state = $b941786f4eb9cb76$var$State.IDLE;
        } else this.state = $b941786f4eb9cb76$var$State.WAITING_TRACK;
        this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
        this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
        this.tick();
    }
    doTick() {
        switch(this.state){
            case $b941786f4eb9cb76$var$State.IDLE:
                this.doTickIdle();
                break;
            case $b941786f4eb9cb76$var$State.WAITING_TRACK:
                {
                    const { levels: levels, trackId: trackId } = this;
                    const currenTrack = levels == null ? void 0 : levels[trackId];
                    const details = currenTrack == null ? void 0 : currenTrack.details;
                    if (details && !this.waitForLive(currenTrack)) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = $b941786f4eb9cb76$var$State.WAITING_INIT_PTS;
                    }
                    break;
                }
            case $b941786f4eb9cb76$var$State.FRAG_LOADING_WAITING_RETRY:
                this.checkRetryDate();
                break;
            case $b941786f4eb9cb76$var$State.WAITING_INIT_PTS:
                {
                    // Ensure we don't get stuck in the WAITING_INIT_PTS state if the waiting frag CC doesn't match any initPTS
                    const waitingData = this.waitingData;
                    if (waitingData) {
                        const { frag: frag, part: part, cache: cache, complete: complete } = waitingData;
                        const mainAnchor = this.mainAnchor;
                        if (this.initPTS[frag.cc] !== undefined) {
                            this.waitingData = null;
                            this.state = $b941786f4eb9cb76$var$State.FRAG_LOADING;
                            const payload = cache.flush().buffer;
                            const data = {
                                frag: frag,
                                part: part,
                                payload: payload,
                                networkDetails: null
                            };
                            this._handleFragmentLoadProgress(data);
                            if (complete) super._handleFragmentLoadComplete(data);
                        } else if (mainAnchor && mainAnchor.cc !== waitingData.frag.cc) this.syncWithAnchor(mainAnchor, waitingData.frag);
                    } else this.state = $b941786f4eb9cb76$var$State.IDLE;
                }
        }
        this.onTickEnd();
    }
    resetLoadingState() {
        const waitingData = this.waitingData;
        if (waitingData) {
            this.fragmentTracker.removeFragment(waitingData.frag);
            this.waitingData = null;
        }
        super.resetLoadingState();
    }
    onTickEnd() {
        const { media: media } = this;
        if (!(media != null && media.readyState)) // Exit early if we don't have media or if the media hasn't buffered anything yet (readyState 0)
        return;
        this.lastCurrentTime = media.currentTime;
    }
    doTickIdle() {
        var _this$mainFragLoading2;
        const { hls: hls, levels: levels, media: media, trackId: trackId } = this;
        const config = hls.config;
        // 1. if buffering is suspended
        // 2. if video not attached AND
        //    start fragment already requested OR start frag prefetch not enabled
        // 3. if tracks or track not loaded and selected
        // then exit loop
        // => if media not attached but start frag prefetch is enabled and start frag not requested yet, we will not exit loop
        if (!this.buffering || !media && !this.primaryPrefetch && (this.startFragRequested || !config.startFragPrefetch) || !(levels != null && levels[trackId])) return;
        const levelInfo = levels[trackId];
        const trackDetails = levelInfo.details;
        if (!trackDetails || this.waitForLive(levelInfo) || this.waitForCdnTuneIn(trackDetails)) {
            this.state = $b941786f4eb9cb76$var$State.WAITING_TRACK;
            this.startFragRequested = false;
            return;
        }
        const bufferable = this.mediaBuffer ? this.mediaBuffer : this.media;
        if (this.bufferFlushed && bufferable) {
            this.bufferFlushed = false;
            this.afterBufferFlushed(bufferable, $b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO, $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO);
        }
        const bufferInfo = this.getFwdBufferInfo(bufferable, $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO);
        if (bufferInfo === null) return;
        if (!this.switchingTrack && this._streamEnded(bufferInfo, trackDetails)) {
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_EOS, {
                type: 'audio'
            });
            this.state = $b941786f4eb9cb76$var$State.ENDED;
            return;
        }
        const bufferLen = bufferInfo.len;
        const maxBufLen = hls.maxBufferLength;
        const fragments = trackDetails.fragments;
        const start = fragments[0].start;
        const loadPosition = this.getLoadPosition();
        const targetBufferTime = this.flushing ? loadPosition : bufferInfo.end;
        if (this.switchingTrack && media) {
            const pos = loadPosition;
            // if currentTime (pos) is less than alt audio playlist start time, it means that alt audio is ahead of currentTime
            if (trackDetails.PTSKnown && pos < start) // if everything is buffered from pos to start or if audio buffer upfront, let's seek to start
            {
                if (bufferInfo.end > start || bufferInfo.nextStart) {
                    this.log('Alt audio track ahead of main track, seek to start of alt audio track');
                    media.currentTime = start + 0.05;
                }
            }
        }
        // if buffer length is less than maxBufLen, or near the end, find a fragment to load
        if (bufferLen >= maxBufLen && !this.switchingTrack && targetBufferTime < fragments[fragments.length - 1].start) return;
        let frag = this.getNextFragment(targetBufferTime, trackDetails);
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) frag = this.getNextFragmentLoopLoading(frag, trackDetails, bufferInfo, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN, maxBufLen);
        if (!frag) {
            this.bufferFlushed = true;
            return;
        }
        // Request audio segments up to one fragment ahead of main stream-controller
        let mainFragLoading = ((_this$mainFragLoading2 = this.mainFragLoading) == null ? void 0 : _this$mainFragLoading2.frag) || null;
        if (!this.audioOnly && this.startFragRequested && mainFragLoading && $b941786f4eb9cb76$var$isMediaFragment(frag) && !frag.endList && (!trackDetails.live || !this.loadingParts && targetBufferTime < this.hls.liveSyncPosition)) {
            if (this.fragmentTracker.getState(mainFragLoading) === $b941786f4eb9cb76$var$FragmentState.OK) this.mainFragLoading = mainFragLoading = null;
            if (mainFragLoading && $b941786f4eb9cb76$var$isMediaFragment(mainFragLoading)) {
                if (frag.start > mainFragLoading.end) {
                    // Get buffered frag at target position from tracker (loaded out of sequence)
                    const mainFragAtPos = this.fragmentTracker.getFragAtPos(targetBufferTime, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
                    if (mainFragAtPos && mainFragAtPos.end > mainFragLoading.end) {
                        mainFragLoading = mainFragAtPos;
                        this.mainFragLoading = {
                            frag: mainFragAtPos,
                            targetBufferTime: null
                        };
                    }
                }
                const atBufferSyncLimit = frag.start > mainFragLoading.end;
                if (atBufferSyncLimit) return;
            }
        }
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    onMediaDetaching(event, data) {
        this.bufferFlushed = this.flushing = false;
        super.onMediaDetaching(event, data);
    }
    onAudioTracksUpdated(event, { audioTracks: audioTracks }) {
        // Reset tranxmuxer is essential for large context switches (Content Steering)
        this.resetTransmuxer();
        this.levels = audioTracks.map((mediaPlaylist)=>new $b941786f4eb9cb76$export$ca664994d1d54bff(mediaPlaylist));
    }
    onAudioTrackSwitching(event, data) {
        // if any URL found on new audio track, it is an alternate audio track
        const altAudio = !!data.url;
        this.trackId = data.id;
        const { fragCurrent: fragCurrent } = this;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.removeUnbufferedFrags(fragCurrent.start);
        }
        this.resetLoadingState();
        // should we switch tracks ?
        if (altAudio) {
            this.switchingTrack = data;
            // main audio track are handled by stream-controller, just do something if switching to alt audio track
            this.flushAudioIfNeeded(data);
            if (this.state !== $b941786f4eb9cb76$var$State.STOPPED) {
                // switching to audio track, start timer if not already started
                this.setInterval($b941786f4eb9cb76$var$TICK_INTERVAL$3);
                this.state = $b941786f4eb9cb76$var$State.IDLE;
                this.tick();
            }
        } else {
            // destroy useless transmuxer when switching audio to main
            this.resetTransmuxer();
            this.switchingTrack = null;
            this.bufferedTrack = data;
            this.clearInterval();
        }
    }
    onManifestLoading() {
        super.onManifestLoading();
        this.bufferFlushed = this.flushing = this.audioOnly = false;
        this.resetItem();
        this.trackId = -1;
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
        const cachedTrackLoadedData = this.cachedTrackLoadedData;
        if (cachedTrackLoadedData) {
            this.cachedTrackLoadedData = null;
            this.onAudioTrackLoaded($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADED, cachedTrackLoadedData);
        }
    }
    onAudioTrackLoaded(event, data) {
        var _trackLevel$details;
        const { levels: levels } = this;
        const { details: newDetails, id: trackId, groupId: groupId, track: track } = data;
        if (!levels) {
            this.warn(`Audio tracks reset while loading track ${trackId} "${track.name}" of "${groupId}"`);
            return;
        }
        const mainDetails = this.mainDetails;
        if (!mainDetails || newDetails.endCC > mainDetails.endCC || mainDetails.expired) {
            this.cachedTrackLoadedData = data;
            if (this.state !== $b941786f4eb9cb76$var$State.STOPPED) this.state = $b941786f4eb9cb76$var$State.WAITING_TRACK;
            return;
        }
        this.cachedTrackLoadedData = null;
        this.log(`Audio track ${trackId} "${track.name}" of "${groupId}" loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
        const trackLevel = levels[trackId];
        let sliding = 0;
        if (newDetails.live || (_trackLevel$details = trackLevel.details) != null && _trackLevel$details.live) {
            this.checkLiveUpdate(newDetails);
            if (newDetails.deltaUpdateFailed) return;
            if (trackLevel.details) {
                var _this$levelLastLoaded;
                sliding = this.alignPlaylists(newDetails, trackLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
            }
            if (!newDetails.alignedSliding) {
                // Align audio rendition with the "main" playlist on discontinuity change
                // or program-date-time (PDT)
                $b941786f4eb9cb76$var$alignDiscontinuities(newDetails, mainDetails);
                if (!newDetails.alignedSliding) $b941786f4eb9cb76$var$alignMediaPlaylistByPDT(newDetails, mainDetails);
                sliding = newDetails.fragmentStart;
            }
        }
        trackLevel.details = newDetails;
        this.levelLastLoaded = trackLevel;
        // compute start position if we are aligned with the main playlist
        if (!this.startFragRequested) this.setStartPosition(mainDetails, sliding);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_UPDATED, {
            details: newDetails,
            id: trackId,
            groupId: data.groupId
        });
        // only switch back to IDLE state if we were waiting for track to start downloading a new fragment
        if (this.state === $b941786f4eb9cb76$var$State.WAITING_TRACK && !this.waitForCdnTuneIn(newDetails)) this.state = $b941786f4eb9cb76$var$State.IDLE;
        // trigger handler right now
        this.tick();
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const frag = data.frag;
        const { part: part, payload: payload } = data;
        const { config: config, trackId: trackId, levels: levels } = this;
        if (!levels) {
            this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const track = levels[trackId];
        if (!track) {
            this.warn('Audio track is undefined on fragment load progress');
            return;
        }
        const details = track.details;
        if (!details) {
            this.warn('Audio track details undefined on fragment load progress');
            this.removeUnbufferedFrags(frag.start);
            return;
        }
        const audioCodec = config.defaultAudioCodec || track.audioCodec || 'mp4a.40.2';
        let transmuxer = this.transmuxer;
        if (!transmuxer) transmuxer = this.transmuxer = new $b941786f4eb9cb76$var$TransmuxerInterface(this.hls, $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        // Check if we have video initPTS
        // If not we need to wait for it
        const initPTS = this.initPTS[frag.cc];
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        if (initPTS !== undefined) {
            // this.log(`Transmuxing ${sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
            const accurateTimeOffset = false; // details.PTSKnown || !details.live;
            const partIndex = part ? part.index : -1;
            const partial = partIndex !== -1;
            const chunkMeta = new $b941786f4eb9cb76$export$ce0708ece532c9c(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
            transmuxer.push(payload, initSegmentData, audioCodec, '', frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
        } else {
            this.log(`Unknown video PTS for cc ${frag.cc}, waiting for video PTS before demuxing audio frag ${frag.sn} of [${details.startSN} ,${details.endSN}],track ${trackId}`);
            const { cache: cache } = this.waitingData = this.waitingData || {
                frag: frag,
                part: part,
                cache: new $b941786f4eb9cb76$var$ChunkCache(),
                complete: false
            };
            cache.push(new Uint8Array(payload));
            if (this.state !== $b941786f4eb9cb76$var$State.STOPPED) this.state = $b941786f4eb9cb76$var$State.WAITING_INIT_PTS;
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        if (this.waitingData) {
            this.waitingData.complete = true;
            return;
        }
        super._handleFragmentLoadComplete(fragLoadedData);
    }
    onBufferReset() {
        // reset reference to sourcebuffers
        this.mediaBuffer = null;
    }
    onBufferCreated(event, data) {
        this.bufferFlushed = this.flushing = false;
        const audioTrack = data.tracks.audio;
        if (audioTrack) this.mediaBuffer = audioTrack.buffer || null;
    }
    onFragLoading(event, data) {
        if (!this.audioOnly && data.frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN && $b941786f4eb9cb76$var$isMediaFragment(data.frag)) {
            this.mainFragLoading = data;
            if (this.state === $b941786f4eb9cb76$var$State.IDLE) this.tick();
        }
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        if (frag.type !== $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO) {
            if (!this.audioOnly && frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN && !frag.elementaryStreams.video && !frag.elementaryStreams.audiovideo) {
                this.audioOnly = true;
                this.mainFragLoading = null;
            }
            return;
        }
        if (this.fragContextChanged(frag)) {
            // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
            // Avoid setting state back to IDLE or concluding the audio switch; otherwise, the switched-to track will not buffer
            this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : 'false'}`);
            return;
        }
        if ($b941786f4eb9cb76$var$isMediaFragment(frag)) {
            this.fragPrevious = frag;
            const track = this.switchingTrack;
            if (track) {
                this.bufferedTrack = track;
                this.switchingTrack = null;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, $b941786f4eb9cb76$var$_objectSpread2({}, track));
            }
        }
        this.fragBufferedComplete(frag, part);
        if (this.media) this.tick();
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = $b941786f4eb9cb76$var$State.ERROR;
            return;
        }
        switch(data.details){
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError($b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO, data);
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_TIMEOUT:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading track, if not retrying to load track, switch back to IDLE
                if (!data.levelRetry && this.state === $b941786f4eb9cb76$var$State.WAITING_TRACK && ((_data$context = data.context) == null ? void 0 : _data$context.type) === $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK) this.state = $b941786f4eb9cb76$var$State.IDLE;
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                if (data.parent !== 'audio') return;
                if (!this.reduceLengthAndFlushBuffer(data)) this.resetLoadingState();
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_FULL_ERROR:
                if (data.parent !== 'audio') return;
                if (this.reduceLengthAndFlushBuffer(data)) {
                    this.bufferedTrack = null;
                    super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
                }
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    onBufferFlushing(event, { type: type }) {
        if (type !== $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO) this.flushing = true;
    }
    onBufferFlushed(event, { type: type }) {
        if (type !== $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO) {
            this.flushing = false;
            this.bufferFlushed = true;
            if (this.state === $b941786f4eb9cb76$var$State.ENDED) this.state = $b941786f4eb9cb76$var$State.IDLE;
            const mediaBuffer = this.mediaBuffer || this.media;
            if (mediaBuffer) {
                this.afterBufferFlushed(mediaBuffer, type, $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO);
                this.tick();
            }
        }
    }
    _handleTransmuxComplete(transmuxResult) {
        var _id3$samples;
        const id = 'audio';
        const { hls: hls } = this;
        const { remuxResult: remuxResult, chunkMeta: chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const { details: details } = level;
        const { audio: audio, text: text, id3: id3, initSegment: initSegment } = remuxResult;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag) || !details) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = $b941786f4eb9cb76$var$State.PARSING;
        if (this.switchingTrack && audio) this.completeAudioSwitch(this.switchingTrack);
        if (initSegment != null && initSegment.tracks) {
            const mapFragment = frag.initSegment || frag;
            if (this.unhandledEncryptionError(initSegment, frag)) return;
            this._bufferInitSegment(level, initSegment.tracks, mapFragment, chunkMeta);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_INIT_SEGMENT, {
                frag: mapFragment,
                id: id,
                tracks: initSegment.tracks
            });
        // Only flush audio from old audio tracks when PTS is known on new audio track
        }
        if (audio) {
            const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = audio;
            if (part) part.elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS
            };
            frag.setElementaryStreamInfo($b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (id3 != null && (_id3$samples = id3.samples) != null && _id3$samples.length) {
            const emittedID3 = $b941786f4eb9cb76$var$_extends({
                id: id,
                frag: frag,
                details: details
            }, id3);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_METADATA, emittedID3);
        }
        if (text) {
            const emittedText = $b941786f4eb9cb76$var$_extends({
                id: id,
                frag: frag,
                details: details
            }, text);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
        if (this.state !== $b941786f4eb9cb76$var$State.PARSING) return;
        // delete any video track found on audio transmuxer
        if (tracks.video) delete tracks.video;
        if (tracks.audiovideo) delete tracks.audiovideo;
        // include levelCodec in audio and video tracks
        if (!tracks.audio) return;
        const track = tracks.audio;
        track.id = $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO;
        const variantAudioCodecs = currentLevel.audioCodec;
        this.log(`Init audio buffer, container:${track.container}, codecs[level/parsed]=[${variantAudioCodecs}/${track.codec}]`);
        // SourceBuffer will use track.levelCodec if defined
        if (variantAudioCodecs && variantAudioCodecs.split(',').length === 1) track.levelCodec = variantAudioCodecs;
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, tracks);
        const initSegment = track.initSegment;
        if (initSegment != null && initSegment.byteLength) {
            const segment = {
                type: 'audio',
                frag: frag,
                part: null,
                chunkMeta: chunkMeta,
                parent: frag.type,
                data: initSegment
            };
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDING, segment);
        }
        // trigger handler right now
        this.tickImmediate();
    }
    loadFragment(frag, track, targetBufferTime) {
        // only load if fragment is not loaded or if in audio switch
        const fragState = this.fragmentTracker.getState(frag);
        // we force a frag loading in audio switch as fragment tracker might not have evicted previous frags in case of quick audio switch
        if (this.switchingTrack || fragState === $b941786f4eb9cb76$var$FragmentState.NOT_LOADED || fragState === $b941786f4eb9cb76$var$FragmentState.PARTIAL) {
            var _track$details;
            if (!$b941786f4eb9cb76$var$isMediaFragment(frag)) this._loadInitSegment(frag, track);
            else if ((_track$details = track.details) != null && _track$details.live && !this.initPTS[frag.cc]) {
                this.log(`Waiting for video PTS in continuity counter ${frag.cc} of live stream before loading audio fragment ${frag.sn} of level ${this.trackId}`);
                this.state = $b941786f4eb9cb76$var$State.WAITING_INIT_PTS;
                const mainDetails = this.mainDetails;
                if (mainDetails && mainDetails.fragmentStart !== track.details.fragmentStart) $b941786f4eb9cb76$var$alignMediaPlaylistByPDT(track.details, mainDetails);
            } else super.loadFragment(frag, track, targetBufferTime);
        } else this.clearTrackerIfNeeded(frag);
    }
    flushAudioIfNeeded(switchingTrack) {
        if (this.media && this.bufferedTrack) {
            const { name: name, lang: lang, assocLang: assocLang, characteristics: characteristics, audioCodec: audioCodec, channels: channels } = this.bufferedTrack;
            if (!$b941786f4eb9cb76$var$matchesOption({
                name: name,
                lang: lang,
                assocLang: assocLang,
                characteristics: characteristics,
                audioCodec: audioCodec,
                channels: channels
            }, switchingTrack, $b941786f4eb9cb76$var$audioMatchPredicate)) {
                if ($b941786f4eb9cb76$var$useAlternateAudio(switchingTrack.url, this.hls)) {
                    this.log('Switching audio track : flushing all audio');
                    super.flushMainBuffer(0, Number.POSITIVE_INFINITY, 'audio');
                    this.bufferedTrack = null;
                } else // Main is being buffered. Set bufferedTrack so that it is flushed when switching back to alt-audio
                this.bufferedTrack = switchingTrack;
            }
        }
    }
    completeAudioSwitch(switchingTrack) {
        const { hls: hls } = this;
        this.flushAudioIfNeeded(switchingTrack);
        this.bufferedTrack = switchingTrack;
        this.switchingTrack = null;
        hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, $b941786f4eb9cb76$var$_objectSpread2({}, switchingTrack));
    }
}
class $b941786f4eb9cb76$export$d94ec24774c8b986 extends $b941786f4eb9cb76$var$Logger {
    constructor(hls, logPrefix){
        super(logPrefix, hls.logger);
        this.hls = void 0;
        this.canLoad = false;
        this.timer = -1;
        this.hls = hls;
    }
    destroy() {
        this.clearTimer();
        // @ts-ignore
        this.hls = this.log = this.warn = null;
    }
    clearTimer() {
        if (this.timer !== -1) {
            self.clearTimeout(this.timer);
            this.timer = -1;
        }
    }
    startLoad() {
        this.canLoad = true;
        this.loadPlaylist();
    }
    stopLoad() {
        this.canLoad = false;
        this.clearTimer();
    }
    switchParams(playlistUri, previous, current) {
        const renditionReports = previous == null ? void 0 : previous.renditionReports;
        if (renditionReports) {
            let foundIndex = -1;
            for(let i = 0; i < renditionReports.length; i++){
                const attr = renditionReports[i];
                let uri;
                try {
                    uri = new self.URL(attr.URI, previous.url).href;
                } catch (error) {
                    this.warn(`Could not construct new URL for Rendition Report: ${error}`);
                    uri = attr.URI || '';
                }
                // Use exact match. Otherwise, the last partial match, if any, will be used
                // (Playlist URI includes a query string that the Rendition Report does not)
                if (uri === playlistUri) {
                    foundIndex = i;
                    break;
                } else if (uri === playlistUri.substring(0, uri.length)) foundIndex = i;
            }
            if (foundIndex !== -1) {
                const attr = renditionReports[foundIndex];
                const msn = parseInt(attr['LAST-MSN']) || previous.lastPartSn;
                let part = parseInt(attr['LAST-PART']) || previous.lastPartIndex;
                if (this.hls.config.lowLatencyMode) {
                    const currentGoal = Math.min(previous.age - previous.partTarget, previous.targetduration);
                    if (part >= 0 && currentGoal > previous.partTarget) part += 1;
                }
                const skip = current && $b941786f4eb9cb76$var$getSkipValue(current);
                return new $b941786f4eb9cb76$export$b1713430eaae90a7(msn, part >= 0 ? part : undefined, skip);
            }
        }
    }
    loadPlaylist(hlsUrlParameters) {
        // Loading is handled by the subclasses
        this.clearTimer();
    }
    loadingPlaylist(playlist, hlsUrlParameters) {
        // Loading is handled by the subclasses
        this.clearTimer();
    }
    shouldLoadPlaylist(playlist) {
        return this.canLoad && !!playlist && !!playlist.url && (!playlist.details || playlist.details.live);
    }
    getUrlWithDirectives(uri, hlsUrlParameters) {
        if (hlsUrlParameters) try {
            return hlsUrlParameters.addDirectives(uri);
        } catch (error) {
            this.warn(`Could not construct new URL with HLS Delivery Directives: ${error}`);
        }
        return uri;
    }
    playlistLoaded(index, data, previousDetails) {
        const { details: details, stats: stats } = data;
        // Set last updated date-time
        const now = self.performance.now();
        const elapsed = stats.loading.first ? Math.max(0, now - stats.loading.first) : 0;
        details.advancedDateTime = Date.now() - elapsed;
        // shift fragment starts with timelineOffset
        const timelineOffset = this.hls.config.timelineOffset;
        if (timelineOffset !== details.appliedTimelineOffset) {
            const offset = Math.max(timelineOffset || 0, 0);
            details.appliedTimelineOffset = offset;
            details.fragments.forEach((frag)=>{
                frag.setStart(frag.playlistOffset + offset);
            });
        }
        // if current playlist is a live playlist, arm a timer to reload it
        if (details.live || previousDetails != null && previousDetails.live) {
            const levelOrTrack = 'levelInfo' in data ? data.levelInfo : data.track;
            details.reloaded(previousDetails);
            // Merge live playlists to adjust fragment starts and fill in delta playlist skipped segments
            if (previousDetails && details.fragments.length > 0) {
                $b941786f4eb9cb76$var$mergeDetails(previousDetails, details, this);
                const error = details.playlistParsingError;
                if (error) {
                    this.warn(error);
                    const hls = this.hls;
                    if (!hls.config.ignorePlaylistParsingErrors) {
                        var _details$fragments$;
                        const { networkDetails: networkDetails } = data;
                        hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                            details: $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_PARSING_ERROR,
                            fatal: false,
                            url: details.url,
                            error: error,
                            reason: error.message,
                            level: data.level || undefined,
                            parent: (_details$fragments$ = details.fragments[0]) == null ? void 0 : _details$fragments$.type,
                            networkDetails: networkDetails,
                            stats: stats
                        });
                        return;
                    }
                    details.playlistParsingError = null;
                }
            }
            if (details.requestScheduled === -1) details.requestScheduled = stats.loading.start;
            const bufferInfo = this.hls.mainForwardBufferInfo;
            const position = bufferInfo ? bufferInfo.end - bufferInfo.len : 0;
            const distanceToLiveEdgeMs = (details.edge - position) * 1000;
            const reloadInterval = $b941786f4eb9cb76$var$computeReloadInterval(details, distanceToLiveEdgeMs);
            if (details.requestScheduled + reloadInterval < now) details.requestScheduled = now;
            else details.requestScheduled += reloadInterval;
            this.log(`live playlist ${index} ${details.advanced ? 'REFRESHED ' + details.lastPartSn + '-' + details.lastPartIndex : details.updated ? 'UPDATED' : 'MISSED'}`);
            if (!this.canLoad || !details.live) return;
            let deliveryDirectives;
            let msn = undefined;
            let part = undefined;
            if (details.canBlockReload && details.endSN && details.advanced) {
                // Load level with LL-HLS delivery directives
                const lowLatencyMode = this.hls.config.lowLatencyMode;
                const lastPartSn = details.lastPartSn;
                const endSn = details.endSN;
                const lastPartIndex = details.lastPartIndex;
                const hasParts = lastPartIndex !== -1;
                const atLastPartOfSegment = lastPartSn === endSn;
                if (hasParts) {
                    // When low latency mode is disabled, request the last part of the next segment
                    if (atLastPartOfSegment) {
                        msn = endSn + 1;
                        part = lowLatencyMode ? 0 : lastPartIndex;
                    } else {
                        msn = lastPartSn;
                        part = lowLatencyMode ? lastPartIndex + 1 : details.maxPartIndex;
                    }
                } else msn = endSn + 1;
                // Low-Latency CDN Tune-in: "age" header and time since load indicates we're behind by more than one part
                // Update directives to obtain the Playlist that has the estimated additional duration of media
                const lastAdvanced = details.age;
                const cdnAge = lastAdvanced + details.ageHeader;
                let currentGoal = Math.min(cdnAge - details.partTarget, details.targetduration * 1.5);
                if (currentGoal > 0) {
                    if (cdnAge > details.targetduration * 3) {
                        // Omit segment and part directives when the last response was more than 3 target durations ago,
                        this.log(`Playlist last advanced ${lastAdvanced.toFixed(2)}s ago. Omitting segment and part directives.`);
                        msn = undefined;
                        part = undefined;
                    } else if (previousDetails != null && previousDetails.tuneInGoal && cdnAge - details.partTarget > previousDetails.tuneInGoal) {
                        // If we attempted to get the next or latest playlist update, but currentGoal increased,
                        // then we either can't catchup, or the "age" header cannot be trusted.
                        this.warn(`CDN Tune-in goal increased from: ${previousDetails.tuneInGoal} to: ${currentGoal} with playlist age: ${details.age}`);
                        currentGoal = 0;
                    } else {
                        const segments = Math.floor(currentGoal / details.targetduration);
                        msn += segments;
                        if (part !== undefined) {
                            const parts = Math.round(currentGoal % details.targetduration / details.partTarget);
                            part += parts;
                        }
                        this.log(`CDN Tune-in age: ${details.ageHeader}s last advanced ${lastAdvanced.toFixed(2)}s goal: ${currentGoal} skip sn ${segments} to part ${part}`);
                    }
                    details.tuneInGoal = currentGoal;
                }
                deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
                if (lowLatencyMode || !atLastPartOfSegment) {
                    details.requestScheduled = now;
                    this.loadingPlaylist(levelOrTrack, deliveryDirectives);
                    return;
                }
            } else if (details.canBlockReload || details.canSkipUntil) deliveryDirectives = this.getDeliveryDirectives(details, data.deliveryDirectives, msn, part);
            if (deliveryDirectives && msn !== undefined && details.canBlockReload) details.requestScheduled = stats.loading.first + Math.max(reloadInterval - elapsed * 2, reloadInterval / 2);
            this.scheduleLoading(levelOrTrack, deliveryDirectives, details);
        } else this.clearTimer();
    }
    scheduleLoading(levelOrTrack, deliveryDirectives, updatedDetails) {
        const details = updatedDetails || levelOrTrack.details;
        if (!details) {
            this.loadingPlaylist(levelOrTrack, deliveryDirectives);
            return;
        }
        const now = self.performance.now();
        const requestScheduled = details.requestScheduled;
        if (now >= requestScheduled) {
            this.loadingPlaylist(levelOrTrack, deliveryDirectives);
            return;
        }
        const estimatedTimeUntilUpdate = requestScheduled - now;
        this.log(`reload live playlist ${levelOrTrack.name || levelOrTrack.bitrate + 'bps'} in ${Math.round(estimatedTimeUntilUpdate)} ms`);
        this.clearTimer();
        this.timer = self.setTimeout(()=>this.loadingPlaylist(levelOrTrack, deliveryDirectives), estimatedTimeUntilUpdate);
    }
    getDeliveryDirectives(details, previousDeliveryDirectives, msn, part) {
        let skip = $b941786f4eb9cb76$var$getSkipValue(details);
        if (previousDeliveryDirectives != null && previousDeliveryDirectives.skip && details.deltaUpdateFailed) {
            msn = previousDeliveryDirectives.msn;
            part = previousDeliveryDirectives.part;
            skip = $b941786f4eb9cb76$export$5d29c5ea940312ed.No;
        }
        return new $b941786f4eb9cb76$export$b1713430eaae90a7(msn, part, skip);
    }
    checkRetry(errorEvent) {
        const errorDetails = errorEvent.details;
        const isTimeout = $b941786f4eb9cb76$var$isTimeoutError(errorEvent);
        const errorAction = errorEvent.errorAction;
        const { action: action, retryCount: retryCount = 0, retryConfig: retryConfig } = errorAction || {};
        const retry = !!errorAction && !!retryConfig && (action === $b941786f4eb9cb76$export$679390c50dd617e4.RetryRequest || !errorAction.resolved && action === $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox);
        if (retry) {
            var _errorEvent$context;
            if (retryCount >= retryConfig.maxNumRetry) return false;
            if (isTimeout && (_errorEvent$context = errorEvent.context) != null && _errorEvent$context.deliveryDirectives) {
                // The LL-HLS request already timed out so retry immediately
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" without delivery-directives`);
                this.loadPlaylist();
            } else {
                const delay = $b941786f4eb9cb76$var$getRetryDelay(retryConfig, retryCount);
                // Schedule level/track reload
                this.clearTimer();
                this.timer = self.setTimeout(()=>this.loadPlaylist(), delay);
                this.warn(`Retrying playlist loading ${retryCount + 1}/${retryConfig.maxNumRetry} after "${errorDetails}" in ${delay}ms`);
            }
            // `levelRetry = true` used to inform other controllers that a retry is happening
            errorEvent.levelRetry = true;
            errorAction.resolved = true;
        }
        return retry;
    }
}
function $b941786f4eb9cb76$var$subtitleOptionsIdentical(trackList1, trackList2) {
    if (trackList1.length !== trackList2.length) return false;
    for(let i = 0; i < trackList1.length; i++){
        if (!$b941786f4eb9cb76$var$mediaAttributesIdentical(trackList1[i].attrs, trackList2[i].attrs)) return false;
    }
    return true;
}
function $b941786f4eb9cb76$var$mediaAttributesIdentical(attrs1, attrs2, customAttributes) {
    // Media options with the same rendition ID must be bit identical
    const stableRenditionId = attrs1['STABLE-RENDITION-ID'];
    if (stableRenditionId && !customAttributes) return stableRenditionId === attrs2['STABLE-RENDITION-ID'];
    // When rendition ID is not present, compare attributes
    return !(customAttributes || [
        'LANGUAGE',
        'NAME',
        'CHARACTERISTICS',
        'AUTOSELECT',
        'DEFAULT',
        'FORCED',
        'ASSOC-LANGUAGE'
    ]).some((subtitleAttribute)=>attrs1[subtitleAttribute] !== attrs2[subtitleAttribute]);
}
function $b941786f4eb9cb76$var$subtitleTrackMatchesTextTrack(subtitleTrack, textTrack) {
    return textTrack.label.toLowerCase() === subtitleTrack.name.toLowerCase() && (!textTrack.language || textTrack.language.toLowerCase() === (subtitleTrack.lang || '').toLowerCase());
}
class $b941786f4eb9cb76$export$befb88bd9e19246 extends $b941786f4eb9cb76$export$d94ec24774c8b986 {
    constructor(hls){
        super(hls, 'audio-track-controller');
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
        this.registerListeners();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.currentTrack = null;
        super.destroy();
    }
    onManifestLoading() {
        this.tracks = [];
        this.tracksInGroup = [];
        this.groupIds = null;
        this.currentTrack = null;
        this.trackId = -1;
        this.selectDefaultTrack = true;
    }
    onManifestParsed(event, data) {
        this.tracks = data.audioTracks || [];
    }
    onAudioTrackLoaded(event, data) {
        const { id: id, groupId: groupId, details: details } = data;
        const trackInActiveGroup = this.tracksInGroup[id];
        if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
            this.warn(`Audio track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
            return;
        }
        const curDetails = trackInActiveGroup.details;
        trackInActiveGroup.details = data.details;
        this.log(`Audio track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!levelInfo) return;
        const audioGroups = levelInfo.audioGroups || null;
        const currentGroups = this.groupIds;
        let currentTrack = this.currentTrack;
        if (!audioGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (audioGroups == null ? void 0 : audioGroups.length) || audioGroups != null && audioGroups.some((groupId)=>(currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
            this.groupIds = audioGroups;
            this.trackId = -1;
            this.currentTrack = null;
            const audioTracks = this.tracks.filter((track)=>!audioGroups || audioGroups.indexOf(track.groupId) !== -1);
            if (audioTracks.length) {
                // Disable selectDefaultTrack if there are no default tracks
                if (this.selectDefaultTrack && !audioTracks.some((track)=>track.default)) this.selectDefaultTrack = false;
                // track.id should match hls.audioTracks index
                audioTracks.forEach((track, i)=>{
                    track.id = i;
                });
            } else if (!currentTrack && !this.tracksInGroup.length) // Do not dispatch AUDIO_TRACKS_UPDATED when there were and are no tracks
            return;
            this.tracksInGroup = audioTracks;
            // Find preferred track
            const audioPreference = this.hls.config.audioPreference;
            if (!currentTrack && audioPreference) {
                const groupIndex = $b941786f4eb9cb76$var$findMatchingOption(audioPreference, audioTracks, $b941786f4eb9cb76$var$audioMatchPredicate);
                if (groupIndex > -1) currentTrack = audioTracks[groupIndex];
                else {
                    const allIndex = $b941786f4eb9cb76$var$findMatchingOption(audioPreference, this.tracks);
                    currentTrack = this.tracks[allIndex];
                }
            }
            // Select initial track
            let trackId = this.findTrackId(currentTrack);
            if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
            // Dispatch events and load track if needed
            const audioTracksUpdated = {
                audioTracks: audioTracks
            };
            this.log(`Updating audio tracks, ${audioTracks.length} track(s) found in group(s): ${audioGroups == null ? void 0 : audioGroups.join(',')}`);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACKS_UPDATED, audioTracksUpdated);
            const selectedTrackId = this.trackId;
            if (trackId !== -1 && selectedTrackId === -1) this.setAudioTrack(trackId);
            else if (audioTracks.length && selectedTrackId === -1) {
                var _this$groupIds;
                const error = new Error(`No audio track selected for current audio group-ID(s): ${(_this$groupIds = this.groupIds) == null ? void 0 : _this$groupIds.join(',')} track count: ${audioTracks.length}`);
                this.warn(error.message);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR,
                    fatal: true,
                    error: error
                });
            }
        }
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) this.checkRetry(data);
    }
    get allAudioTracks() {
        return this.tracks;
    }
    get audioTracks() {
        return this.tracksInGroup;
    }
    get audioTrack() {
        return this.trackId;
    }
    set audioTrack(newId) {
        // If audio track is selected from API then don't choose from the manifest default track
        this.selectDefaultTrack = false;
        this.setAudioTrack(newId);
    }
    setAudioOption(audioOption) {
        const hls = this.hls;
        hls.config.audioPreference = audioOption;
        if (audioOption) {
            const allAudioTracks = this.allAudioTracks;
            this.selectDefaultTrack = false;
            if (allAudioTracks.length) {
                // First see if current option matches (no switch op)
                const currentTrack = this.currentTrack;
                if (currentTrack && $b941786f4eb9cb76$var$matchesOption(audioOption, currentTrack, $b941786f4eb9cb76$var$audioMatchPredicate)) return currentTrack;
                // Find option in available tracks (tracksInGroup)
                const groupIndex = $b941786f4eb9cb76$var$findMatchingOption(audioOption, this.tracksInGroup, $b941786f4eb9cb76$var$audioMatchPredicate);
                if (groupIndex > -1) {
                    const track = this.tracksInGroup[groupIndex];
                    this.setAudioTrack(groupIndex);
                    return track;
                } else if (currentTrack) {
                    // Find option in nearest level audio group
                    let searchIndex = hls.loadLevel;
                    if (searchIndex === -1) searchIndex = hls.firstAutoLevel;
                    const switchIndex = $b941786f4eb9cb76$var$findClosestLevelWithAudioGroup(audioOption, hls.levels, allAudioTracks, searchIndex, $b941786f4eb9cb76$var$audioMatchPredicate);
                    if (switchIndex === -1) // could not find matching variant
                    return null;
                    // and switch level to acheive the audio group switch
                    hls.nextLoadLevel = switchIndex;
                }
                if (audioOption.channels || audioOption.audioCodec) {
                    // Could not find a match with codec / channels predicate
                    // Find a match without channels or codec
                    const withoutCodecAndChannelsMatch = $b941786f4eb9cb76$var$findMatchingOption(audioOption, allAudioTracks);
                    if (withoutCodecAndChannelsMatch > -1) return allAudioTracks[withoutCodecAndChannelsMatch];
                }
            }
        }
        return null;
    }
    setAudioTrack(newId) {
        const tracks = this.tracksInGroup;
        // check if level idx is valid
        if (newId < 0 || newId >= tracks.length) {
            this.warn(`Invalid audio track id: ${newId}`);
            return;
        }
        this.selectDefaultTrack = false;
        const lastTrack = this.currentTrack;
        const track = tracks[newId];
        const trackLoaded = track.details && !track.details.live;
        if (newId === this.trackId && track === lastTrack && trackLoaded) return;
        this.log(`Switching to audio-track ${newId} "${track.name}" lang:${track.lang} group:${track.groupId} channels:${track.channels}`);
        this.trackId = newId;
        this.currentTrack = track;
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, $b941786f4eb9cb76$var$_objectSpread2({}, track));
        // Do not reload track unless live
        if (trackLoaded) return;
        const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
        this.loadPlaylist(hlsUrlParameters);
    }
    findTrackId(currentTrack) {
        const audioTracks = this.tracksInGroup;
        for(let i = 0; i < audioTracks.length; i++){
            const track = audioTracks[i];
            if (this.selectDefaultTrack && !track.default) continue;
            if (!currentTrack || $b941786f4eb9cb76$var$matchesOption(currentTrack, track, $b941786f4eb9cb76$var$audioMatchPredicate)) return i;
        }
        if (currentTrack) {
            const { name: name, lang: lang, assocLang: assocLang, characteristics: characteristics, audioCodec: audioCodec, channels: channels } = currentTrack;
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if ($b941786f4eb9cb76$var$matchesOption({
                    name: name,
                    lang: lang,
                    assocLang: assocLang,
                    characteristics: characteristics,
                    audioCodec: audioCodec,
                    channels: channels
                }, track, $b941786f4eb9cb76$var$audioMatchPredicate)) return i;
            }
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if ($b941786f4eb9cb76$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE',
                    'ASSOC-LANGUAGE',
                    'CHARACTERISTICS'
                ])) return i;
            }
            for(let i = 0; i < audioTracks.length; i++){
                const track = audioTracks[i];
                if ($b941786f4eb9cb76$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE'
                ])) return i;
            }
        }
        return -1;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        const audioTrack = this.currentTrack;
        if (!this.shouldLoadPlaylist(audioTrack)) return;
        // Do not load audio rendition with URI matching main variant URI
        if ($b941786f4eb9cb76$var$useAlternateAudio(audioTrack.url, this.hls)) this.scheduleLoading(audioTrack, hlsUrlParameters);
    }
    loadingPlaylist(audioTrack, hlsUrlParameters) {
        super.loadingPlaylist(audioTrack, hlsUrlParameters);
        const id = audioTrack.id;
        const groupId = audioTrack.groupId;
        const url = this.getUrlWithDirectives(audioTrack.url, hlsUrlParameters);
        const details = audioTrack.details;
        const age = details == null ? void 0 : details.age;
        this.log(`Loading audio-track ${id} "${audioTrack.name}" lang:${audioTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type : '') : ''} ${url}`);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADING, {
            url: url,
            id: id,
            groupId: groupId,
            deliveryDirectives: hlsUrlParameters || null,
            track: audioTrack
        });
    }
}
class $b941786f4eb9cb76$var$BufferOperationQueue {
    constructor(sourceBufferReference){
        this.tracks = void 0;
        this.queues = {
            video: [],
            audio: [],
            audiovideo: []
        };
        this.tracks = sourceBufferReference;
    }
    destroy() {
        this.tracks = this.queues = null;
    }
    append(operation, type, pending) {
        if (this.queues === null || this.tracks === null) return;
        const queue = this.queues[type];
        queue.push(operation);
        if (queue.length === 1 && !pending) this.executeNext(type);
    }
    appendBlocker(type) {
        return new Promise((resolve)=>{
            const operation = {
                label: 'async-blocker',
                execute: resolve,
                onStart: ()=>{},
                onComplete: ()=>{},
                onError: ()=>{}
            };
            this.append(operation, type);
        });
    }
    prependBlocker(type) {
        return new Promise((resolve)=>{
            if (this.queues) {
                const operation = {
                    label: 'async-blocker-prepend',
                    execute: resolve,
                    onStart: ()=>{},
                    onComplete: ()=>{},
                    onError: ()=>{}
                };
                this.queues[type].unshift(operation);
            }
        });
    }
    removeBlockers() {
        if (this.queues === null) return;
        [
            this.queues.video,
            this.queues.audio,
            this.queues.audiovideo
        ].forEach((queue)=>{
            var _queue$;
            const label = (_queue$ = queue[0]) == null ? void 0 : _queue$.label;
            if (label === 'async-blocker' || label === 'async-blocker-prepend') {
                queue[0].execute();
                queue.splice(0, 1);
            }
        });
    }
    unblockAudio(op) {
        if (this.queues === null) return;
        const queue = this.queues.audio;
        if (queue[0] === op) this.shiftAndExecuteNext('audio');
    }
    executeNext(type) {
        if (this.queues === null || this.tracks === null) return;
        const queue = this.queues[type];
        if (queue.length) {
            const operation = queue[0];
            try {
                // Operations are expected to result in an 'updateend' event being fired. If not, the queue will lock. Operations
                // which do not end with this event must call _onSBUpdateEnd manually
                operation.execute();
            } catch (error) {
                var _this$tracks$type;
                operation.onError(error);
                if (this.queues === null || this.tracks === null) return;
                // Only shift the current operation off, otherwise the updateend handler will do this for us
                const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
                if (!(sb != null && sb.updating)) this.shiftAndExecuteNext(type);
            }
        }
    }
    shiftAndExecuteNext(type) {
        if (this.queues === null) return;
        this.queues[type].shift();
        this.executeNext(type);
    }
    current(type) {
        var _this$queues;
        return ((_this$queues = this.queues) == null ? void 0 : _this$queues[type][0]) || null;
    }
    toString() {
        const { queues: queues, tracks: tracks } = this;
        if (queues === null || tracks === null) return `<destroyed>`;
        return `
${this.list('video')}
${this.list('audio')}
${this.list('audiovideo')}}`;
    }
    list(type) {
        var _this$queues2, _this$tracks;
        return (_this$queues2 = this.queues) != null && _this$queues2[type] || (_this$tracks = this.tracks) != null && _this$tracks[type] ? `${type}: (${this.listSbInfo(type)}) ${this.listOps(type)}` : '';
    }
    listSbInfo(type) {
        var _this$tracks2;
        const track = (_this$tracks2 = this.tracks) == null ? void 0 : _this$tracks2[type];
        const sb = track == null ? void 0 : track.buffer;
        if (!sb) return 'none';
        return `SourceBuffer${sb.updating ? ' updating' : ''}${track.ended ? ' ended' : ''}${track.ending ? ' ending' : ''}`;
    }
    listOps(type) {
        var _this$queues3;
        return ((_this$queues3 = this.queues) == null ? void 0 : _this$queues3[type].map((op)=>op.label).join(', ')) || '';
    }
}
const $b941786f4eb9cb76$var$VIDEO_CODEC_PROFILE_REPLACE = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/;
const $b941786f4eb9cb76$var$TRACK_REMOVED_ERROR_NAME = 'HlsJsTrackRemovedError';
class $b941786f4eb9cb76$var$HlsJsTrackRemovedError extends Error {
    constructor(message){
        super(message);
        this.name = $b941786f4eb9cb76$var$TRACK_REMOVED_ERROR_NAME;
    }
}
class $b941786f4eb9cb76$export$2057e53fd83d2d77 extends $b941786f4eb9cb76$var$Logger {
    constructor(hls, fragmentTracker){
        super('buffer-controller', hls.logger);
        this.hls = void 0;
        this.fragmentTracker = void 0;
        // The level details used to determine duration, target-duration and live
        this.details = null;
        // cache the self generated object url to detect hijack of video tag
        this._objectUrl = null;
        // A queue of buffer operations which require the SourceBuffer to not be updating upon execution
        this.operationQueue = null;
        // The total number track codecs expected before any sourceBuffers are created (2: audio and video or 1: audiovideo | audio | video)
        this.bufferCodecEventsTotal = 0;
        // A reference to the attached media element
        this.media = null;
        // A reference to the active media source
        this.mediaSource = null;
        // Last MP3 audio chunk appended
        this.lastMpegAudioChunk = null;
        // Audio fragment blocked from appending until corresponding video appends or context changes
        this.blockedAudioAppend = null;
        // Keep track of video append position for unblocking audio
        this.lastVideoAppendEnd = 0;
        // Whether or not to use ManagedMediaSource API and append source element to media element.
        this.appendSource = void 0;
        // Transferred MediaSource information used to detmerine if duration end endstream may be appended
        this.transferData = void 0;
        // Directives used to override default MediaSource handling
        this.overrides = void 0;
        // Error counters
        this.appendErrors = {
            audio: 0,
            video: 0,
            audiovideo: 0
        };
        // Record of required or created buffers by type. SourceBuffer is stored in Track.buffer once created.
        this.tracks = {};
        // Array of SourceBuffer type and SourceBuffer (or null). One entry per TrackSet in this.tracks.
        this.sourceBuffers = [
            [
                null,
                null
            ],
            [
                null,
                null
            ]
        ];
        this._onEndStreaming = (event)=>{
            var _this$mediaSource;
            if (!this.hls) return;
            if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) !== 'open') return;
            this.hls.pauseBuffering();
        };
        this._onStartStreaming = (event)=>{
            if (!this.hls) return;
            this.hls.resumeBuffering();
        };
        // Keep as arrow functions so that we can directly reference these functions directly as event listeners
        this._onMediaSourceOpen = (e)=>{
            const { media: media, mediaSource: mediaSource } = this;
            if (e) this.log('Media source opened');
            if (!media || !mediaSource) return;
            // once received, don't listen anymore to sourceopen event
            mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
            media.removeEventListener('emptied', this._onMediaEmptied);
            this.updateDuration();
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, {
                media: media,
                mediaSource: mediaSource
            });
            if (this.mediaSource !== null) this.checkPendingTracks();
        };
        this._onMediaSourceClose = ()=>{
            this.log('Media source closed');
        };
        this._onMediaSourceEnded = ()=>{
            this.log('Media source ended');
        };
        this._onMediaEmptied = ()=>{
            const { mediaSrc: mediaSrc, _objectUrl: _objectUrl } = this;
            if (mediaSrc !== _objectUrl) this.error(`Media element src was set while attaching MediaSource (${_objectUrl} > ${mediaSrc})`);
        };
        this.hls = hls;
        this.fragmentTracker = fragmentTracker;
        this.appendSource = $b941786f4eb9cb76$var$isManagedMediaSource($b941786f4eb9cb76$export$a92854129bc50f89(hls.config.preferManagedMediaSource));
        this.initTracks();
        this.registerListeners();
    }
    hasSourceTypes() {
        return Object.keys(this.tracks).length > 0;
    }
    destroy() {
        this.unregisterListeners();
        this.details = null;
        this.lastMpegAudioChunk = this.blockedAudioAppend = null;
        this.transferData = this.overrides = undefined;
        if (this.operationQueue) {
            this.operationQueue.destroy();
            this.operationQueue = null;
        }
        // @ts-ignore
        this.hls = this.fragmentTracker = null;
        // @ts-ignore
        this._onMediaSourceOpen = this._onMediaSourceClose = null;
        // @ts-ignore
        this._onMediaSourceEnded = null;
        // @ts-ignore
        this._onStartStreaming = this._onEndStreaming = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_EOS, this.onBufferEos, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSED, this.onFragParsed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_CHANGED, this.onFragChanged, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_RESET, this.onBufferReset, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDING, this.onBufferAppending, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_EOS, this.onBufferEos, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSED, this.onFragParsed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_CHANGED, this.onFragChanged, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    transferMedia() {
        const { media: media, mediaSource: mediaSource } = this;
        if (!media) return null;
        const tracks = {};
        if (this.operationQueue) {
            const updating = this.isUpdating();
            if (!updating) this.operationQueue.removeBlockers();
            const queued = this.isQueued();
            if (updating || queued) this.warn(`Transfering MediaSource with${queued ? ' operations in queue' : ''}${updating ? ' updating SourceBuffer(s)' : ''} ${this.operationQueue}`);
            this.operationQueue.destroy();
        }
        const transferData = this.transferData;
        if (!this.sourceBufferCount && transferData && transferData.mediaSource === mediaSource) $b941786f4eb9cb76$var$_extends(tracks, transferData.tracks);
        else this.sourceBuffers.forEach((tuple)=>{
            const [type] = tuple;
            if (type) {
                tracks[type] = $b941786f4eb9cb76$var$_extends({}, this.tracks[type]);
                this.removeBuffer(type);
            }
            tuple[0] = tuple[1] = null;
        });
        return {
            media: media,
            mediaSource: mediaSource,
            tracks: tracks
        };
    }
    initTracks() {
        const tracks = {};
        this.sourceBuffers = [
            [
                null,
                null
            ],
            [
                null,
                null
            ]
        ];
        this.tracks = tracks;
        this.resetQueue();
        this.resetAppendErrors();
        this.lastMpegAudioChunk = this.blockedAudioAppend = null;
        this.lastVideoAppendEnd = 0;
    }
    onManifestLoading() {
        this.bufferCodecEventsTotal = 0;
        this.details = null;
    }
    onManifestParsed(event, data) {
        var _this$transferData;
        // in case of alt audio 2 BUFFER_CODECS events will be triggered, one per stream controller
        // sourcebuffers will be created all at once when the expected nb of tracks will be reached
        // in case alt audio is not used, only one BUFFER_CODEC event will be fired from main stream controller
        // it will contain the expected nb of source buffers, no need to compute it
        let codecEvents = 2;
        if (data.audio && !data.video || !data.altAudio) codecEvents = 1;
        this.bufferCodecEventsTotal = codecEvents;
        this.log(`${codecEvents} bufferCodec event(s) expected.`);
        if ((_this$transferData = this.transferData) != null && _this$transferData.mediaSource && this.sourceBufferCount && codecEvents) this.bufferCreated();
    }
    onMediaAttaching(event, data) {
        const media = this.media = data.media;
        this.transferData = this.overrides = undefined;
        const MediaSource = $b941786f4eb9cb76$export$a92854129bc50f89(this.appendSource);
        if (MediaSource) {
            const transferringMedia = !!data.mediaSource;
            if (transferringMedia || data.overrides) {
                this.transferData = data;
                this.overrides = data.overrides;
            }
            const ms = this.mediaSource = data.mediaSource || new MediaSource();
            this.assignMediaSource(ms);
            if (transferringMedia) {
                this._objectUrl = media.src;
                this.attachTransferred();
            } else {
                // cache the locally generated object url
                const objectUrl = this._objectUrl = self.URL.createObjectURL(ms);
                // link video and media Source
                if (this.appendSource) try {
                    media.removeAttribute('src');
                    // ManagedMediaSource will not open without disableRemotePlayback set to false or source alternatives
                    const MMS = self.ManagedMediaSource;
                    media.disableRemotePlayback = media.disableRemotePlayback || MMS && ms instanceof MMS;
                    $b941786f4eb9cb76$var$removeSourceChildren(media);
                    $b941786f4eb9cb76$var$addSource(media, objectUrl);
                    media.load();
                } catch (error) {
                    media.src = objectUrl;
                }
                else media.src = objectUrl;
            }
            media.addEventListener('emptied', this._onMediaEmptied);
        }
    }
    assignMediaSource(ms) {
        var _this$transferData2, _ms$constructor;
        this.log(`${((_this$transferData2 = this.transferData) == null ? void 0 : _this$transferData2.mediaSource) === ms ? 'transferred' : 'created'} media source: ${(_ms$constructor = ms.constructor) == null ? void 0 : _ms$constructor.name}`);
        // MediaSource listeners are arrow functions with a lexical scope, and do not need to be bound
        ms.addEventListener('sourceopen', this._onMediaSourceOpen);
        ms.addEventListener('sourceended', this._onMediaSourceEnded);
        ms.addEventListener('sourceclose', this._onMediaSourceClose);
        if (this.appendSource) {
            ms.addEventListener('startstreaming', this._onStartStreaming);
            ms.addEventListener('endstreaming', this._onEndStreaming);
        }
    }
    attachTransferred() {
        const media = this.media;
        const data = this.transferData;
        if (!data || !media) return;
        const requiredTracks = this.tracks;
        const transferredTracks = data.tracks;
        const trackNames = transferredTracks ? Object.keys(transferredTracks) : null;
        const trackCount = trackNames ? trackNames.length : 0;
        const mediaSourceOpenCallback = ()=>{
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            Promise.resolve().then(()=>{
                if (this.media && this.mediaSourceOpenOrEnded) this._onMediaSourceOpen();
            });
        };
        if (transferredTracks && trackNames && trackCount) {
            if (!this.tracksReady) {
                // Wait for CODECS event(s)
                this.hls.config.startFragPrefetch = true;
                this.log(`attachTransferred: waiting for SourceBuffer track info`);
                return;
            }
            this.log(`attachTransferred: (bufferCodecEventsTotal ${this.bufferCodecEventsTotal})
required tracks: ${$b941786f4eb9cb76$var$stringify(requiredTracks, (key, value)=>key === 'initSegment' ? undefined : value)};
transfer tracks: ${$b941786f4eb9cb76$var$stringify(transferredTracks, (key, value)=>key === 'initSegment' ? undefined : value)}}`);
            if (!$b941786f4eb9cb76$var$isCompatibleTrackChange(transferredTracks, requiredTracks)) {
                // destroy attaching media source
                data.mediaSource = null;
                data.tracks = undefined;
                const currentTime = media.currentTime;
                const details = this.details;
                const startTime = Math.max(currentTime, (details == null ? void 0 : details.fragments[0].start) || 0);
                if (startTime - currentTime > 1) {
                    this.log(`attachTransferred: waiting for playback to reach new tracks start time ${currentTime} -> ${startTime}`);
                    return;
                }
                this.warn(`attachTransferred: resetting MediaSource for incompatible tracks ("${Object.keys(transferredTracks)}"->"${Object.keys(requiredTracks)}") start time: ${startTime} currentTime: ${currentTime}`);
                this.onMediaDetaching($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, {});
                this.onMediaAttaching($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, data);
                media.currentTime = startTime;
                return;
            }
            this.transferData = undefined;
            trackNames.forEach((trackName)=>{
                const type = trackName;
                const track = transferredTracks[type];
                if (track) {
                    const sb = track.buffer;
                    if (sb) {
                        // Purge fragment tracker of ejected segments for existing buffer
                        const fragmentTracker = this.fragmentTracker;
                        const playlistType = track.id;
                        if (fragmentTracker.hasFragments(playlistType) || fragmentTracker.hasParts(playlistType)) {
                            const bufferedTimeRanges = $b941786f4eb9cb76$var$BufferHelper.getBuffered(sb);
                            fragmentTracker.detectEvictedFragments(type, bufferedTimeRanges, playlistType, null, true);
                        }
                        // Transfer SourceBuffer
                        const sbIndex = $b941786f4eb9cb76$var$sourceBufferNameToIndex(type);
                        const sbTuple = [
                            type,
                            sb
                        ];
                        this.sourceBuffers[sbIndex] = sbTuple;
                        if (sb.updating && this.operationQueue) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        this.operationQueue.prependBlocker(type);
                        this.trackSourceBuffer(type, track);
                    }
                }
            });
            mediaSourceOpenCallback();
            this.bufferCreated();
        } else {
            this.log(`attachTransferred: MediaSource w/o SourceBuffers`);
            mediaSourceOpenCallback();
        }
    }
    get mediaSourceOpenOrEnded() {
        var _this$mediaSource2;
        const readyState = (_this$mediaSource2 = this.mediaSource) == null ? void 0 : _this$mediaSource2.readyState;
        return readyState === 'open' || readyState === 'ended';
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        this.transferData = this.overrides = undefined;
        const { media: media, mediaSource: mediaSource, _objectUrl: _objectUrl } = this;
        if (mediaSource) {
            this.log(`media source ${transferringMedia ? 'transferring' : 'detaching'}`);
            if (transferringMedia) {
                // Detach SourceBuffers without removing from MediaSource
                // and leave `tracks` (required SourceBuffers configuration)
                this.sourceBuffers.forEach(([type])=>{
                    if (type) this.removeBuffer(type);
                });
                this.resetQueue();
            } else {
                if (this.mediaSourceOpenOrEnded) {
                    const open = mediaSource.readyState === 'open';
                    try {
                        const sourceBuffers = mediaSource.sourceBuffers;
                        for(let i = sourceBuffers.length; i--;){
                            if (open) sourceBuffers[i].abort();
                            mediaSource.removeSourceBuffer(sourceBuffers[i]);
                        }
                        if (open) // endOfStream could trigger exception if any sourcebuffer is in updating state
                        // we don't really care about checking sourcebuffer state here,
                        // as we are anyway detaching the MediaSource
                        // let's just avoid this exception to propagate
                        mediaSource.endOfStream();
                    } catch (err) {
                        this.warn(`onMediaDetaching: ${err.message} while calling endOfStream`);
                    }
                }
                // Clean up the SourceBuffers by invoking onBufferReset
                if (this.sourceBufferCount) this.onBufferReset();
            }
            mediaSource.removeEventListener('sourceopen', this._onMediaSourceOpen);
            mediaSource.removeEventListener('sourceended', this._onMediaSourceEnded);
            mediaSource.removeEventListener('sourceclose', this._onMediaSourceClose);
            if (this.appendSource) {
                mediaSource.removeEventListener('startstreaming', this._onStartStreaming);
                mediaSource.removeEventListener('endstreaming', this._onEndStreaming);
            }
            this.mediaSource = null;
            this._objectUrl = null;
        }
        // Detach properly the MediaSource from the HTMLMediaElement as
        // suggested in https://github.com/w3c/media-source/issues/53.
        if (media) {
            media.removeEventListener('emptied', this._onMediaEmptied);
            if (!transferringMedia) {
                if (_objectUrl) self.URL.revokeObjectURL(_objectUrl);
                // clean up video tag src only if it's our own url. some external libraries might
                // hijack the video tag and change its 'src' without destroying the Hls instance first
                if (this.mediaSrc === _objectUrl) {
                    media.removeAttribute('src');
                    if (this.appendSource) $b941786f4eb9cb76$var$removeSourceChildren(media);
                    media.load();
                } else this.warn('media|source.src was changed by a third party - skip cleanup');
            }
            this.media = null;
        }
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHED, data);
    }
    onBufferReset() {
        this.sourceBuffers.forEach(([type])=>{
            if (type) this.resetBuffer(type);
        });
        this.initTracks();
    }
    resetBuffer(type) {
        var _this$tracks$type;
        const sb = (_this$tracks$type = this.tracks[type]) == null ? void 0 : _this$tracks$type.buffer;
        this.removeBuffer(type);
        if (sb) try {
            var _this$mediaSource3;
            if ((_this$mediaSource3 = this.mediaSource) != null && _this$mediaSource3.sourceBuffers.length) this.mediaSource.removeSourceBuffer(sb);
        } catch (err) {
            this.warn(`onBufferReset ${type}`, err);
        }
        delete this.tracks[type];
    }
    removeBuffer(type) {
        this.removeBufferListeners(type);
        this.sourceBuffers[$b941786f4eb9cb76$var$sourceBufferNameToIndex(type)] = [
            null,
            null
        ];
        const track = this.tracks[type];
        if (track) track.buffer = undefined;
    }
    resetQueue() {
        if (this.operationQueue) this.operationQueue.destroy();
        this.operationQueue = new $b941786f4eb9cb76$var$BufferOperationQueue(this.tracks);
    }
    onBufferCodecs(event, data) {
        var _data$audio;
        const tracks = this.tracks;
        const trackNames = Object.keys(data);
        this.log(`BUFFER_CODECS: "${trackNames}" (current SB count ${this.sourceBufferCount})`);
        const unmuxedToMuxed = 'audiovideo' in data && (tracks.audio || tracks.video) || tracks.audiovideo && ('audio' in data || 'video' in data);
        const muxedToUnmuxed = !unmuxedToMuxed && this.sourceBufferCount && this.media && trackNames.some((sbName)=>!tracks[sbName]);
        if (unmuxedToMuxed || muxedToUnmuxed) {
            this.warn(`Unsupported transition between "${Object.keys(tracks)}" and "${trackNames}" SourceBuffers`);
            // Do not add incompatible track ('audiovideo' <-> 'video'/'audio').
            // Allow following onBufferAppending handle to trigger BUFFER_APPEND_ERROR.
            // This will either be resolved by level switch or could be handled with recoverMediaError().
            return;
        }
        trackNames.forEach((trackName)=>{
            var _this$transferData3, _trackCodec;
            const parsedTrack = data[trackName];
            const { id: id, codec: codec, levelCodec: levelCodec, container: container, metadata: metadata, supplemental: supplemental } = parsedTrack;
            let track = tracks[trackName];
            const transferredTrack = (_this$transferData3 = this.transferData) == null || (_this$transferData3 = _this$transferData3.tracks) == null ? void 0 : _this$transferData3[trackName];
            const sbTrack = transferredTrack != null && transferredTrack.buffer ? transferredTrack : track;
            const sbCodec = (sbTrack == null ? void 0 : sbTrack.pendingCodec) || (sbTrack == null ? void 0 : sbTrack.codec);
            const trackLevelCodec = sbTrack == null ? void 0 : sbTrack.levelCodec;
            if (!track) track = tracks[trackName] = {
                buffer: undefined,
                listeners: [],
                codec: codec,
                supplemental: supplemental,
                container: container,
                levelCodec: levelCodec,
                metadata: metadata,
                id: id
            };
            // check if SourceBuffer codec needs to change
            const currentCodecFull = $b941786f4eb9cb76$var$pickMostCompleteCodecName(sbCodec, trackLevelCodec);
            const currentCodec = currentCodecFull == null ? void 0 : currentCodecFull.replace($b941786f4eb9cb76$var$VIDEO_CODEC_PROFILE_REPLACE, '$1');
            let trackCodec = $b941786f4eb9cb76$var$pickMostCompleteCodecName(codec, levelCodec);
            const nextCodec = (_trackCodec = trackCodec) == null ? void 0 : _trackCodec.replace($b941786f4eb9cb76$var$VIDEO_CODEC_PROFILE_REPLACE, '$1');
            if (trackCodec && currentCodecFull && currentCodec !== nextCodec) {
                if (trackName.slice(0, 5) === 'audio') trackCodec = $b941786f4eb9cb76$var$getCodecCompatibleName(trackCodec, this.appendSource);
                this.log(`switching codec ${sbCodec} to ${trackCodec}`);
                if (trackCodec !== (track.pendingCodec || track.codec)) track.pendingCodec = trackCodec;
                track.container = container;
                this.appendChangeType(trackName, container, trackCodec);
            }
        });
        if (this.tracksReady || this.sourceBufferCount) data.tracks = this.sourceBufferTracks;
        // if sourcebuffers already created, do nothing ...
        if (this.sourceBufferCount) return;
        if (this.bufferCodecEventsTotal > 1 && !this.tracks.video && !data.video && ((_data$audio = data.audio) == null ? void 0 : _data$audio.id) === 'main') {
            // MVP is missing CODECS and only audio was found in main segment (#7524)
            this.log(`Main audio-only`);
            this.bufferCodecEventsTotal = 1;
        }
        if (this.mediaSourceOpenOrEnded) this.checkPendingTracks();
    }
    get sourceBufferTracks() {
        return Object.keys(this.tracks).reduce((baseTracks, type)=>{
            const track = this.tracks[type];
            baseTracks[type] = {
                id: track.id,
                container: track.container,
                codec: track.codec,
                levelCodec: track.levelCodec
            };
            return baseTracks;
        }, {});
    }
    appendChangeType(type, container, codec) {
        const mimeType = `${container};codecs=${codec}`;
        const operation = {
            label: `change-type=${mimeType}`,
            execute: ()=>{
                const track = this.tracks[type];
                if (track) {
                    const sb = track.buffer;
                    if (sb != null && sb.changeType) {
                        this.log(`changing ${type} sourceBuffer type to ${mimeType}`);
                        sb.changeType(mimeType);
                        track.codec = codec;
                        track.container = container;
                    }
                }
                this.shiftAndExecuteNext(type);
            },
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: (error)=>{
                this.warn(`Failed to change ${type} SourceBuffer type`, error);
            }
        };
        this.append(operation, type, this.isPending(this.tracks[type]));
    }
    blockAudio(partOrFrag) {
        var _this$fragmentTracker;
        const pStart = partOrFrag.start;
        const pTime = pStart + partOrFrag.duration * 0.05;
        const atGap = ((_this$fragmentTracker = this.fragmentTracker.getAppendedFrag(pStart, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN)) == null ? void 0 : _this$fragmentTracker.gap) === true;
        if (atGap) return;
        const op = {
            label: 'block-audio',
            execute: ()=>{
                var _this$fragmentTracker2;
                const videoTrack = this.tracks.video;
                if (this.lastVideoAppendEnd > pTime || videoTrack != null && videoTrack.buffer && $b941786f4eb9cb76$var$BufferHelper.isBuffered(videoTrack.buffer, pTime) || ((_this$fragmentTracker2 = this.fragmentTracker.getAppendedFrag(pTime, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN)) == null ? void 0 : _this$fragmentTracker2.gap) === true) {
                    this.blockedAudioAppend = null;
                    this.shiftAndExecuteNext('audio');
                }
            },
            onStart: ()=>{},
            onComplete: ()=>{},
            onError: (error)=>{
                this.warn('Error executing block-audio operation', error);
            }
        };
        this.blockedAudioAppend = {
            op: op,
            frag: partOrFrag
        };
        this.append(op, 'audio', true);
    }
    unblockAudio() {
        const { blockedAudioAppend: blockedAudioAppend, operationQueue: operationQueue } = this;
        if (blockedAudioAppend && operationQueue) {
            this.blockedAudioAppend = null;
            operationQueue.unblockAudio(blockedAudioAppend.op);
        }
    }
    onBufferAppending(event, eventData) {
        const { tracks: tracks } = this;
        const { data: data, type: type, parent: parent, frag: frag, part: part, chunkMeta: chunkMeta, offset: offset } = eventData;
        const chunkStats = chunkMeta.buffering[type];
        const { sn: sn, cc: cc } = frag;
        const bufferAppendingStart = self.performance.now();
        chunkStats.start = bufferAppendingStart;
        const fragBuffering = frag.stats.buffering;
        const partBuffering = part ? part.stats.buffering : null;
        if (fragBuffering.start === 0) fragBuffering.start = bufferAppendingStart;
        if (partBuffering && partBuffering.start === 0) partBuffering.start = bufferAppendingStart;
        // TODO: Only update timestampOffset when audio/mpeg fragment or part is not contiguous with previously appended
        // Adjusting `SourceBuffer.timestampOffset` (desired point in the timeline where the next frames should be appended)
        // in Chrome browser when we detect MPEG audio container and time delta between level PTS and `SourceBuffer.timestampOffset`
        // is greater than 100ms (this is enough to handle seek for VOD or level change for LIVE videos).
        // More info here: https://github.com/video-dev/hls.js/issues/332#issuecomment-257986486
        const audioTrack = tracks.audio;
        let checkTimestampOffset = false;
        if (type === 'audio' && (audioTrack == null ? void 0 : audioTrack.container) === 'audio/mpeg') {
            checkTimestampOffset = !this.lastMpegAudioChunk || chunkMeta.id === 1 || this.lastMpegAudioChunk.sn !== chunkMeta.sn;
            this.lastMpegAudioChunk = chunkMeta;
        }
        // Block audio append until overlapping video append
        const videoTrack = tracks.video;
        const videoSb = videoTrack == null ? void 0 : videoTrack.buffer;
        if (videoSb && sn !== 'initSegment') {
            const partOrFrag = part || frag;
            const blockedAudioAppend = this.blockedAudioAppend;
            if (type === 'audio' && parent !== 'main' && !this.blockedAudioAppend && !(videoTrack.ending || videoTrack.ended)) {
                const pStart = partOrFrag.start;
                const pTime = pStart + partOrFrag.duration * 0.05;
                const vbuffered = videoSb.buffered;
                const vappending = this.currentOp('video');
                if (!vbuffered.length && !vappending) // wait for video before appending audio
                this.blockAudio(partOrFrag);
                else if (!vappending && !$b941786f4eb9cb76$var$BufferHelper.isBuffered(videoSb, pTime) && this.lastVideoAppendEnd < pTime) // audio is ahead of video
                this.blockAudio(partOrFrag);
            } else if (type === 'video') {
                const videoAppendEnd = partOrFrag.end;
                if (blockedAudioAppend) {
                    const audioStart = blockedAudioAppend.frag.start;
                    if (videoAppendEnd > audioStart || videoAppendEnd < this.lastVideoAppendEnd || $b941786f4eb9cb76$var$BufferHelper.isBuffered(videoSb, audioStart)) this.unblockAudio();
                }
                this.lastVideoAppendEnd = videoAppendEnd;
            }
        }
        const fragStart = (part || frag).start;
        const operation = {
            label: `append-${type}`,
            execute: ()=>{
                var _this$tracks$type2;
                chunkStats.executeStart = self.performance.now();
                const sb = (_this$tracks$type2 = this.tracks[type]) == null ? void 0 : _this$tracks$type2.buffer;
                if (sb) {
                    if (checkTimestampOffset) this.updateTimestampOffset(sb, fragStart, 0.1, type, sn, cc);
                    else if (offset !== undefined && $b941786f4eb9cb76$var$isFiniteNumber(offset)) this.updateTimestampOffset(sb, offset, 0.000001, type, sn, cc);
                }
                this.appendExecutor(data, type);
            },
            onStart: ()=>{
            // logger.debug(`[buffer-controller]: ${type} SourceBuffer updatestart`);
            },
            onComplete: ()=>{
                // logger.debug(`[buffer-controller]: ${type} SourceBuffer updateend`);
                const end = self.performance.now();
                chunkStats.executeEnd = chunkStats.end = end;
                if (fragBuffering.first === 0) fragBuffering.first = end;
                if (partBuffering && partBuffering.first === 0) partBuffering.first = end;
                const timeRanges = {};
                this.sourceBuffers.forEach(([type, sb])=>{
                    if (type) timeRanges[type] = $b941786f4eb9cb76$var$BufferHelper.getBuffered(sb);
                });
                this.appendErrors[type] = 0;
                if (type === 'audio' || type === 'video') this.appendErrors.audiovideo = 0;
                else {
                    this.appendErrors.audio = 0;
                    this.appendErrors.video = 0;
                }
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, {
                    type: type,
                    frag: frag,
                    part: part,
                    chunkMeta: chunkMeta,
                    parent: frag.type,
                    timeRanges: timeRanges
                });
            },
            onError: (error)=>{
                var _this$media;
                // in case any error occured while appending, put back segment in segments table
                const event = {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                    parent: frag.type,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR,
                    sourceBufferName: type,
                    frag: frag,
                    part: part,
                    chunkMeta: chunkMeta,
                    error: error,
                    err: error,
                    fatal: false
                };
                const mediaError = (_this$media = this.media) == null ? void 0 : _this$media.error;
                if (error.code === DOMException.QUOTA_EXCEEDED_ERR || error.name == 'QuotaExceededError' || `quota` in error) // QuotaExceededError: http://www.w3.org/TR/html5/infrastructure.html#quotaexceedederror
                // let's stop appending any segments, and report BUFFER_FULL_ERROR error
                event.details = $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_FULL_ERROR;
                else if (error.code === DOMException.INVALID_STATE_ERR && this.mediaSourceOpenOrEnded && !mediaError) // Allow retry for "Failed to execute 'appendBuffer' on 'SourceBuffer': This SourceBuffer is still processing" errors
                event.errorAction = $b941786f4eb9cb76$var$createDoNothingErrorAction(true);
                else if (error.name === $b941786f4eb9cb76$var$TRACK_REMOVED_ERROR_NAME && this.sourceBufferCount === 0) // Do nothing if sourceBuffers were removed (media is detached and append was not aborted)
                event.errorAction = $b941786f4eb9cb76$var$createDoNothingErrorAction(true);
                else {
                    const appendErrorCount = ++this.appendErrors[type];
                    /* with UHD content, we could get loop of quota exceeded error until
            browser is able to evict some data from sourcebuffer. Retrying can help recover.
          */ this.warn(`Failed ${appendErrorCount}/${this.hls.config.appendErrorMaxRetry} times to append segment in "${type}" sourceBuffer (${mediaError ? mediaError : 'no media error'})`);
                    if (appendErrorCount >= this.hls.config.appendErrorMaxRetry || !!mediaError) event.fatal = true;
                }
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, event);
            }
        };
        this.log(`queuing "${type}" append sn: ${sn}${part ? ' p: ' + part.index : ''} of ${frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN ? 'level' : 'track'} ${frag.level} cc: ${cc}`);
        this.append(operation, type, this.isPending(this.tracks[type]));
    }
    getFlushOp(type, start, end) {
        this.log(`queuing "${type}" remove ${start}-${end}`);
        return {
            label: 'remove',
            execute: ()=>{
                this.removeExecutor(type, start, end);
            },
            onStart: ()=>{
            // logger.debug(`[buffer-controller]: Started flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
            },
            onComplete: ()=>{
                // logger.debug(`[buffer-controller]: Finished flushing ${data.startOffset} -> ${data.endOffset} for ${type} Source Buffer`);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, {
                    type: type
                });
            },
            onError: (error)=>{
                this.warn(`Failed to remove ${start}-${end} from "${type}" SourceBuffer`, error);
            }
        };
    }
    onBufferFlushing(event, data) {
        const { type: type, startOffset: startOffset, endOffset: endOffset } = data;
        if (type) this.append(this.getFlushOp(type, startOffset, endOffset), type);
        else this.sourceBuffers.forEach(([type])=>{
            if (type) this.append(this.getFlushOp(type, startOffset, endOffset), type);
        });
    }
    onFragParsed(event, data) {
        const { frag: frag, part: part } = data;
        const buffersAppendedTo = [];
        const elementaryStreams = part ? part.elementaryStreams : frag.elementaryStreams;
        if (elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIOVIDEO]) buffersAppendedTo.push('audiovideo');
        else {
            if (elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO]) buffersAppendedTo.push('audio');
            if (elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO]) buffersAppendedTo.push('video');
        }
        const onUnblocked = ()=>{
            const now = self.performance.now();
            frag.stats.buffering.end = now;
            if (part) part.stats.buffering.end = now;
            const stats = part ? part.stats : frag.stats;
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, {
                frag: frag,
                part: part,
                stats: stats,
                id: frag.type
            });
        };
        if (buffersAppendedTo.length === 0) this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${frag.type} level: ${frag.level} sn: ${frag.sn}`);
        this.blockBuffers(onUnblocked, buffersAppendedTo).catch((error)=>{
            this.warn(`Fragment buffered callback ${error}`);
            this.stepOperationQueue(this.sourceBufferTypes);
        });
    }
    onFragChanged(event, data) {
        this.trimBuffers();
    }
    get bufferedToEnd() {
        return this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type])=>{
            if (type) {
                const track = this.tracks[type];
                if (track) return !track.ended || track.ending;
            }
            return false;
        });
    }
    // on BUFFER_EOS mark matching sourcebuffer(s) as "ending" and "ended" and queue endOfStream after remaining operations(s)
    // an undefined data.type will mark all buffers as EOS.
    onBufferEos(event, data) {
        var _this$overrides;
        this.sourceBuffers.forEach(([type])=>{
            if (type) {
                const track = this.tracks[type];
                if (!data.type || data.type === type) {
                    track.ending = true;
                    if (!track.ended) {
                        track.ended = true;
                        this.log(`${type} buffer reached EOS`);
                    }
                }
            }
        });
        const allowEndOfStream = ((_this$overrides = this.overrides) == null ? void 0 : _this$overrides.endOfStream) !== false;
        const allTracksEnding = this.sourceBufferCount > 0 && !this.sourceBuffers.some(([type])=>{
            var _this$tracks$type3;
            return type && !((_this$tracks$type3 = this.tracks[type]) != null && _this$tracks$type3.ended);
        });
        if (allTracksEnding) {
            if (allowEndOfStream) {
                this.log(`Queueing EOS`);
                this.blockUntilOpen(()=>{
                    this.tracksEnded();
                    const { mediaSource: mediaSource } = this;
                    if (!mediaSource || mediaSource.readyState !== 'open') {
                        if (mediaSource) this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${mediaSource.readyState}`);
                        return;
                    }
                    this.log(`Calling mediaSource.endOfStream()`);
                    // Allow this to throw and be caught by the enqueueing function
                    mediaSource.endOfStream();
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFERED_TO_END, undefined);
                });
            } else {
                this.tracksEnded();
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFERED_TO_END, undefined);
            }
        } else if (data.type === 'video') // Make sure pending audio appends are unblocked when video reaches end
        this.unblockAudio();
    }
    tracksEnded() {
        this.sourceBuffers.forEach(([type])=>{
            if (type !== null) {
                const track = this.tracks[type];
                if (track) track.ending = false;
            }
        });
    }
    onLevelUpdated(event, { details: details }) {
        if (!details.fragments.length) return;
        this.details = details;
        this.updateDuration();
    }
    updateDuration() {
        this.blockUntilOpen(()=>{
            const durationAndRange = this.getDurationAndRange();
            if (!durationAndRange) return;
            this.updateMediaSource(durationAndRange);
        });
    }
    onError(event, data) {
        if (data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR && data.frag) {
            var _data$errorAction;
            const nextAutoLevel = (_data$errorAction = data.errorAction) == null ? void 0 : _data$errorAction.nextAutoLevel;
            if ($b941786f4eb9cb76$var$isFiniteNumber(nextAutoLevel) && nextAutoLevel !== data.frag.level) this.resetAppendErrors();
        }
    }
    resetAppendErrors() {
        this.appendErrors = {
            audio: 0,
            video: 0,
            audiovideo: 0
        };
    }
    trimBuffers() {
        const { hls: hls, details: details, media: media } = this;
        if (!media || details === null) return;
        if (!this.sourceBufferCount) return;
        const config = hls.config;
        const currentTime = media.currentTime;
        const targetDuration = details.levelTargetDuration;
        // Support for deprecated liveBackBufferLength
        const backBufferLength = details.live && config.liveBackBufferLength !== null ? config.liveBackBufferLength : config.backBufferLength;
        if ($b941786f4eb9cb76$var$isFiniteNumber(backBufferLength) && backBufferLength >= 0) {
            const maxBackBufferLength = Math.max(backBufferLength, targetDuration);
            const targetBackBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration - maxBackBufferLength;
            this.flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition);
        }
        const frontBufferFlushThreshold = config.frontBufferFlushThreshold;
        if ($b941786f4eb9cb76$var$isFiniteNumber(frontBufferFlushThreshold) && frontBufferFlushThreshold > 0) {
            const frontBufferLength = Math.max(config.maxBufferLength, frontBufferFlushThreshold);
            const maxFrontBufferLength = Math.max(frontBufferLength, targetDuration);
            const targetFrontBufferPosition = Math.floor(currentTime / targetDuration) * targetDuration + maxFrontBufferLength;
            this.flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition);
        }
    }
    flushBackBuffer(currentTime, targetDuration, targetBackBufferPosition) {
        this.sourceBuffers.forEach(([type, sb])=>{
            if (sb) {
                const buffered = $b941786f4eb9cb76$var$BufferHelper.getBuffered(sb);
                // when target buffer start exceeds actual buffer start
                if (buffered.length > 0 && targetBackBufferPosition > buffered.start(0)) {
                    var _this$details;
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    // Support for deprecated event:
                    const track = this.tracks[type];
                    if ((_this$details = this.details) != null && _this$details.live) this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LIVE_BACK_BUFFER_REACHED, {
                        bufferEnd: targetBackBufferPosition
                    });
                    else if (track != null && track.ended) {
                        this.log(`Cannot flush ${type} back buffer while SourceBuffer is in ended state`);
                        return;
                    }
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, {
                        startOffset: 0,
                        endOffset: targetBackBufferPosition,
                        type: type
                    });
                }
            }
        });
    }
    flushFrontBuffer(currentTime, targetDuration, targetFrontBufferPosition) {
        this.sourceBuffers.forEach(([type, sb])=>{
            if (sb) {
                const buffered = $b941786f4eb9cb76$var$BufferHelper.getBuffered(sb);
                const numBufferedRanges = buffered.length;
                // The buffer is either empty or contiguous
                if (numBufferedRanges < 2) return;
                const bufferStart = buffered.start(numBufferedRanges - 1);
                const bufferEnd = buffered.end(numBufferedRanges - 1);
                // No flush if we can tolerate the current buffer length or the current buffer range we would flush is contiguous with current position
                if (targetFrontBufferPosition > bufferStart || currentTime >= bufferStart && currentTime <= bufferEnd) return;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, {
                    startOffset: bufferStart,
                    endOffset: Infinity,
                    type: type
                });
            }
        });
    }
    /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */ getDurationAndRange() {
        var _this$overrides2;
        const { details: details, mediaSource: mediaSource } = this;
        if (!details || !this.media || (mediaSource == null ? void 0 : mediaSource.readyState) !== 'open') return null;
        const playlistEnd = details.edge;
        if (details.live && this.hls.config.liveDurationInfinity) {
            const len = details.fragments.length;
            if (len && !!mediaSource.setLiveSeekableRange) {
                const start = Math.max(0, details.fragmentStart);
                const end = Math.max(start, playlistEnd);
                return {
                    duration: Infinity,
                    start: start,
                    end: end
                };
            }
            return {
                duration: Infinity
            };
        }
        const overrideDuration = (_this$overrides2 = this.overrides) == null ? void 0 : _this$overrides2.duration;
        if (overrideDuration) {
            if (!$b941786f4eb9cb76$var$isFiniteNumber(overrideDuration)) return null;
            return {
                duration: overrideDuration
            };
        }
        const mediaDuration = this.media.duration;
        const msDuration = $b941786f4eb9cb76$var$isFiniteNumber(mediaSource.duration) ? mediaSource.duration : 0;
        if (playlistEnd > msDuration && playlistEnd > mediaDuration || !$b941786f4eb9cb76$var$isFiniteNumber(mediaDuration)) return {
            duration: playlistEnd
        };
        return null;
    }
    updateMediaSource({ duration: duration, start: start, end: end }) {
        const mediaSource = this.mediaSource;
        if (!this.media || !mediaSource || mediaSource.readyState !== 'open') return;
        if (mediaSource.duration !== duration) {
            if ($b941786f4eb9cb76$var$isFiniteNumber(duration)) this.log(`Updating MediaSource duration to ${duration.toFixed(3)}`);
            mediaSource.duration = duration;
        }
        if (start !== undefined && end !== undefined) {
            this.log(`MediaSource duration is set to ${mediaSource.duration}. Setting seekable range to ${start}-${end}.`);
            mediaSource.setLiveSeekableRange(start, end);
        }
    }
    get tracksReady() {
        const pendingTrackCount = this.pendingTrackCount;
        return pendingTrackCount > 0 && (pendingTrackCount >= this.bufferCodecEventsTotal || this.isPending(this.tracks.audiovideo));
    }
    checkPendingTracks() {
        const { bufferCodecEventsTotal: bufferCodecEventsTotal, pendingTrackCount: pendingTrackCount, tracks: tracks } = this;
        this.log(`checkPendingTracks (pending: ${pendingTrackCount} codec events expected: ${bufferCodecEventsTotal}) ${$b941786f4eb9cb76$var$stringify(tracks)}`);
        // Check if we've received all of the expected bufferCodec events. When none remain, create all the sourceBuffers at once.
        // This is important because the MSE spec allows implementations to throw QuotaExceededErrors if creating new sourceBuffers after
        // data has been appended to existing ones.
        // 2 tracks is the max (one for audio, one for video). If we've reach this max go ahead and create the buffers.
        if (this.tracksReady) {
            var _this$transferData4;
            const transferredTracks = (_this$transferData4 = this.transferData) == null ? void 0 : _this$transferData4.tracks;
            if (transferredTracks && Object.keys(transferredTracks).length) this.attachTransferred();
            else // ok, let's create them now !
            this.createSourceBuffers();
        }
    }
    bufferCreated() {
        if (this.sourceBufferCount) {
            const tracks = {};
            this.sourceBuffers.forEach(([type, buffer])=>{
                if (type) {
                    const track = this.tracks[type];
                    tracks[type] = {
                        buffer: buffer,
                        container: track.container,
                        codec: track.codec,
                        supplemental: track.supplemental,
                        levelCodec: track.levelCodec,
                        id: track.id,
                        metadata: track.metadata
                    };
                }
            });
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CREATED, {
                tracks: tracks
            });
            this.log(`SourceBuffers created. Running queue: ${this.operationQueue}`);
            this.sourceBuffers.forEach(([type])=>{
                this.executeNext(type);
            });
        } else {
            const error = new Error('could not create source buffer for media codec(s)');
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_INCOMPATIBLE_CODECS_ERROR,
                fatal: true,
                error: error,
                reason: error.message
            });
        }
    }
    createSourceBuffers() {
        const { tracks: tracks, sourceBuffers: sourceBuffers, mediaSource: mediaSource } = this;
        if (!mediaSource) throw new Error('createSourceBuffers called when mediaSource was null');
        for(const trackName in tracks){
            const type = trackName;
            const track = tracks[type];
            if (this.isPending(track)) {
                const codec = this.getTrackCodec(track, type);
                const mimeType = `${track.container};codecs=${codec}`;
                track.codec = codec;
                this.log(`creating sourceBuffer(${mimeType})${this.currentOp(type) ? ' Queued' : ''} ${$b941786f4eb9cb76$var$stringify(track)}`);
                try {
                    const sb = mediaSource.addSourceBuffer(mimeType);
                    const sbIndex = $b941786f4eb9cb76$var$sourceBufferNameToIndex(type);
                    const sbTuple = [
                        type,
                        sb
                    ];
                    sourceBuffers[sbIndex] = sbTuple;
                    track.buffer = sb;
                } catch (error) {
                    var _this$operationQueue;
                    this.error(`error while trying to add sourceBuffer: ${error.message}`);
                    // remove init segment from queue and delete track info
                    this.shiftAndExecuteNext(type);
                    (_this$operationQueue = this.operationQueue) == null || _this$operationQueue.removeBlockers();
                    delete this.tracks[type];
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR,
                        fatal: false,
                        error: error,
                        sourceBufferName: type,
                        mimeType: mimeType,
                        parent: track.id
                    });
                    return;
                }
                this.trackSourceBuffer(type, track);
            }
        }
        this.bufferCreated();
    }
    getTrackCodec(track, trackName) {
        // Use supplemental video codec when supported when adding SourceBuffer (#5558)
        const supplementalCodec = track.supplemental;
        let trackCodec = track.codec;
        if (supplementalCodec && (trackName === 'video' || trackName === 'audiovideo') && $b941786f4eb9cb76$var$areCodecsMediaSourceSupported(supplementalCodec, 'video')) trackCodec = $b941786f4eb9cb76$var$replaceVideoCodec(trackCodec, supplementalCodec);
        const codec = $b941786f4eb9cb76$var$pickMostCompleteCodecName(trackCodec, track.levelCodec);
        if (codec) {
            if (trackName.slice(0, 5) === 'audio') return $b941786f4eb9cb76$var$getCodecCompatibleName(codec, this.appendSource);
            return codec;
        }
        return '';
    }
    trackSourceBuffer(type, track) {
        const buffer = track.buffer;
        if (!buffer) return;
        const codec = this.getTrackCodec(track, type);
        this.tracks[type] = {
            buffer: buffer,
            codec: codec,
            container: track.container,
            levelCodec: track.levelCodec,
            supplemental: track.supplemental,
            metadata: track.metadata,
            id: track.id,
            listeners: []
        };
        this.removeBufferListeners(type);
        this.addBufferListener(type, 'updatestart', this.onSBUpdateStart);
        this.addBufferListener(type, 'updateend', this.onSBUpdateEnd);
        this.addBufferListener(type, 'error', this.onSBUpdateError);
        // ManagedSourceBuffer bufferedchange event
        if (this.appendSource) this.addBufferListener(type, 'bufferedchange', (type, event)=>{
            // If media was ejected check for a change. Added ranges are redundant with changes on 'updateend' event.
            const removedRanges = event.removedRanges;
            if (removedRanges != null && removedRanges.length) this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, {
                type: type
            });
        });
    }
    get mediaSrc() {
        var _this$media2, _this$media2$querySel;
        const media = ((_this$media2 = this.media) == null || (_this$media2$querySel = _this$media2.querySelector) == null ? void 0 : _this$media2$querySel.call(_this$media2, 'source')) || this.media;
        return media == null ? void 0 : media.src;
    }
    onSBUpdateStart(type) {
        const operation = this.currentOp(type);
        if (!operation) return;
        operation.onStart();
    }
    onSBUpdateEnd(type) {
        var _this$mediaSource4;
        if (((_this$mediaSource4 = this.mediaSource) == null ? void 0 : _this$mediaSource4.readyState) === 'closed') {
            this.resetBuffer(type);
            return;
        }
        const operation = this.currentOp(type);
        if (!operation) return;
        operation.onComplete();
        this.shiftAndExecuteNext(type);
    }
    onSBUpdateError(type, event) {
        var _this$mediaSource5;
        const error = new Error(`${type} SourceBuffer error. MediaSource readyState: ${(_this$mediaSource5 = this.mediaSource) == null ? void 0 : _this$mediaSource5.readyState}`);
        this.error(`${error}`, event);
        // according to http://www.w3.org/TR/media-source/#sourcebuffer-append-error
        // SourceBuffer errors are not necessarily fatal; if so, the HTMLMediaElement will fire an error event
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
            details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPENDING_ERROR,
            sourceBufferName: type,
            error: error,
            fatal: false
        });
        // updateend is always fired after error, so we'll allow that to shift the current operation off of the queue
        const operation = this.currentOp(type);
        if (operation) operation.onError(error);
    }
    updateTimestampOffset(sb, timestampOffset, tolerance, type, sn, cc) {
        const delta = timestampOffset - sb.timestampOffset;
        if (Math.abs(delta) >= tolerance) {
            this.log(`Updating ${type} SourceBuffer timestampOffset to ${timestampOffset} (sn: ${sn} cc: ${cc})`);
            sb.timestampOffset = timestampOffset;
        }
    }
    // This method must result in an updateend event; if remove is not called, onSBUpdateEnd must be called manually
    removeExecutor(type, startOffset, endOffset) {
        const { media: media, mediaSource: mediaSource } = this;
        const track = this.tracks[type];
        const sb = track == null ? void 0 : track.buffer;
        if (!media || !mediaSource || !sb) {
            this.warn(`Attempting to remove from the ${type} SourceBuffer, but it does not exist`);
            this.shiftAndExecuteNext(type);
            return;
        }
        const mediaDuration = $b941786f4eb9cb76$var$isFiniteNumber(media.duration) ? media.duration : Infinity;
        const msDuration = $b941786f4eb9cb76$var$isFiniteNumber(mediaSource.duration) ? mediaSource.duration : Infinity;
        const removeStart = Math.max(0, startOffset);
        const removeEnd = Math.min(endOffset, mediaDuration, msDuration);
        if (removeEnd > removeStart && (!track.ending || track.ended)) {
            track.ended = false;
            this.log(`Removing [${removeStart},${removeEnd}] from the ${type} SourceBuffer`);
            sb.remove(removeStart, removeEnd);
        } else // Cycle the queue
        this.shiftAndExecuteNext(type);
    }
    // This method must result in an updateend event; if append is not called, onSBUpdateEnd must be called manually
    appendExecutor(data, type) {
        const track = this.tracks[type];
        const sb = track == null ? void 0 : track.buffer;
        if (!sb) throw new $b941786f4eb9cb76$var$HlsJsTrackRemovedError(`Attempting to append to the ${type} SourceBuffer, but it does not exist`);
        track.ending = false;
        track.ended = false;
        sb.appendBuffer(data);
    }
    blockUntilOpen(callback) {
        if (this.isUpdating() || this.isQueued()) this.blockBuffers(callback).catch((error)=>{
            this.warn(`SourceBuffer blocked callback ${error}`);
            this.stepOperationQueue(this.sourceBufferTypes);
        });
        else try {
            callback();
        } catch (error) {
            this.warn(`Callback run without blocking ${this.operationQueue} ${error}`);
        }
    }
    isUpdating() {
        return this.sourceBuffers.some(([type, sb])=>type && sb.updating);
    }
    isQueued() {
        return this.sourceBuffers.some(([type])=>type && !!this.currentOp(type));
    }
    isPending(track) {
        return !!track && !track.buffer;
    }
    // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
    // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
    // upon completion, since we already do it here
    blockBuffers(onUnblocked, bufferNames = this.sourceBufferTypes) {
        if (!bufferNames.length) {
            this.log('Blocking operation requested, but no SourceBuffers exist');
            return Promise.resolve().then(onUnblocked);
        }
        const { operationQueue: operationQueue } = this;
        // logger.debug(`[buffer-controller]: Blocking ${buffers} SourceBuffer`);
        const blockingOperations = bufferNames.map((type)=>this.appendBlocker(type));
        const audioBlocked = bufferNames.length > 1 && !!this.blockedAudioAppend;
        if (audioBlocked) this.unblockAudio();
        return Promise.all(blockingOperations).then((result)=>{
            if (operationQueue !== this.operationQueue) return;
            // logger.debug(`[buffer-controller]: Blocking operation resolved; unblocking ${buffers} SourceBuffer`);
            onUnblocked();
            this.stepOperationQueue(this.sourceBufferTypes);
        });
    }
    stepOperationQueue(bufferNames) {
        bufferNames.forEach((type)=>{
            var _this$tracks$type4;
            const sb = (_this$tracks$type4 = this.tracks[type]) == null ? void 0 : _this$tracks$type4.buffer;
            // Only cycle the queue if the SB is not updating. There's a bug in Chrome which sets the SB updating flag to
            // true when changing the MediaSource duration (https://bugs.chromium.org/p/chromium/issues/detail?id=959359&can=2&q=mediasource%20duration)
            // While this is a workaround, it's probably useful to have around
            if (!sb || sb.updating) return;
            this.shiftAndExecuteNext(type);
        });
    }
    append(operation, type, pending) {
        if (this.operationQueue) this.operationQueue.append(operation, type, pending);
    }
    appendBlocker(type) {
        if (this.operationQueue) return this.operationQueue.appendBlocker(type);
    }
    currentOp(type) {
        if (this.operationQueue) return this.operationQueue.current(type);
        return null;
    }
    executeNext(type) {
        if (type && this.operationQueue) this.operationQueue.executeNext(type);
    }
    shiftAndExecuteNext(type) {
        if (this.operationQueue) this.operationQueue.shiftAndExecuteNext(type);
    }
    get pendingTrackCount() {
        return Object.keys(this.tracks).reduce((acc, type)=>acc + (this.isPending(this.tracks[type]) ? 1 : 0), 0);
    }
    get sourceBufferCount() {
        return this.sourceBuffers.reduce((acc, [type])=>acc + (type ? 1 : 0), 0);
    }
    get sourceBufferTypes() {
        return this.sourceBuffers.map(([type])=>type).filter((type)=>!!type);
    }
    addBufferListener(type, event, fn) {
        const track = this.tracks[type];
        if (!track) return;
        const buffer = track.buffer;
        if (!buffer) return;
        const listener = fn.bind(this, type);
        track.listeners.push({
            event: event,
            listener: listener
        });
        buffer.addEventListener(event, listener);
    }
    removeBufferListeners(type) {
        const track = this.tracks[type];
        if (!track) return;
        const buffer = track.buffer;
        if (!buffer) return;
        track.listeners.forEach((l)=>{
            buffer.removeEventListener(l.event, l.listener);
        });
        track.listeners.length = 0;
    }
}
function $b941786f4eb9cb76$var$removeSourceChildren(node) {
    const sourceChildren = node.querySelectorAll('source');
    [].slice.call(sourceChildren).forEach((source)=>{
        node.removeChild(source);
    });
}
function $b941786f4eb9cb76$var$addSource(media, url) {
    const source = self.document.createElement('source');
    source.type = 'video/mp4';
    source.src = url;
    media.appendChild(source);
}
function $b941786f4eb9cb76$var$sourceBufferNameToIndex(type) {
    return type === 'audio' ? 1 : 0;
}
class $b941786f4eb9cb76$export$24bc69225d44061c {
    constructor(hls){
        this.hls = void 0;
        this.autoLevelCapping = void 0;
        this.firstLevel = void 0;
        this.media = void 0;
        this.restrictedLevels = void 0;
        this.timer = void 0;
        this.clientRect = void 0;
        this.streamController = void 0;
        this.hls = hls;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        this.firstLevel = -1;
        this.media = null;
        this.restrictedLevels = [];
        this.timer = undefined;
        this.clientRect = null;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    destroy() {
        if (this.hls) this.unregisterListener();
        if (this.timer) this.stopCapping();
        this.media = null;
        this.clientRect = null;
        // @ts-ignore
        this.hls = this.streamController = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    unregisterListener() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    onFpsDropLevelCapping(event, data) {
        // Don't add a restricted level more than once
        const level = this.hls.levels[data.droppedLevel];
        if (this.isLevelAllowed(level)) this.restrictedLevels.push({
            bitrate: level.bitrate,
            height: level.height,
            width: level.width
        });
    }
    onMediaAttaching(event, data) {
        this.media = data.media instanceof HTMLVideoElement ? data.media : null;
        this.clientRect = null;
        if (this.timer && this.hls.levels.length) this.detectPlayerSize();
    }
    onManifestParsed(event, data) {
        const hls = this.hls;
        this.restrictedLevels = [];
        this.firstLevel = data.firstLevel;
        if (hls.config.capLevelToPlayerSize && data.video) // Start capping immediately if the manifest has signaled video codecs
        this.startCapping();
    }
    onLevelsUpdated(event, data) {
        if (this.timer && $b941786f4eb9cb76$var$isFiniteNumber(this.autoLevelCapping)) this.detectPlayerSize();
    }
    // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
    // to the first level
    onBufferCodecs(event, data) {
        const hls = this.hls;
        if (hls.config.capLevelToPlayerSize && data.video) // If the manifest did not signal a video codec capping has been deferred until we're certain video is present
        this.startCapping();
    }
    onMediaDetaching() {
        this.stopCapping();
        this.media = null;
    }
    detectPlayerSize() {
        if (this.media) {
            if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
                this.clientRect = null;
                return;
            }
            const levels = this.hls.levels;
            if (levels.length) {
                const hls = this.hls;
                const maxLevel = this.getMaxLevel(levels.length - 1);
                if (maxLevel !== this.autoLevelCapping) hls.logger.log(`Setting autoLevelCapping to ${maxLevel}: ${levels[maxLevel].height}p@${levels[maxLevel].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`);
                hls.autoLevelCapping = maxLevel;
                if (hls.autoLevelEnabled && hls.autoLevelCapping > this.autoLevelCapping && this.streamController) // if auto level capping has a higher value for the previous one, flush the buffer using nextLevelSwitch
                // usually happen when the user go to the fullscreen mode.
                this.streamController.nextLevelSwitch();
                this.autoLevelCapping = hls.autoLevelCapping;
            }
        }
    }
    /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */ getMaxLevel(capLevelIndex) {
        const levels = this.hls.levels;
        if (!levels.length) return -1;
        const validLevels = levels.filter((level, index)=>this.isLevelAllowed(level) && index <= capLevelIndex);
        this.clientRect = null;
        return $b941786f4eb9cb76$export$24bc69225d44061c.getMaxLevelByMediaSize(validLevels, this.mediaWidth, this.mediaHeight);
    }
    startCapping() {
        if (this.timer) // Don't reset capping if started twice; this can happen if the manifest signals a video codec
        return;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        self.clearInterval(this.timer);
        this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1000);
        this.detectPlayerSize();
    }
    stopCapping() {
        this.restrictedLevels = [];
        this.firstLevel = -1;
        this.autoLevelCapping = Number.POSITIVE_INFINITY;
        if (this.timer) {
            self.clearInterval(this.timer);
            this.timer = undefined;
        }
    }
    getDimensions() {
        if (this.clientRect) return this.clientRect;
        const media = this.media;
        const boundsRect = {
            width: 0,
            height: 0
        };
        if (media) {
            const clientRect = media.getBoundingClientRect();
            boundsRect.width = clientRect.width;
            boundsRect.height = clientRect.height;
            if (!boundsRect.width && !boundsRect.height) {
                // When the media element has no width or height (equivalent to not being in the DOM),
                // then use its width and height attributes (media.width, media.height)
                boundsRect.width = clientRect.right - clientRect.left || media.width || 0;
                boundsRect.height = clientRect.bottom - clientRect.top || media.height || 0;
            }
        }
        this.clientRect = boundsRect;
        return boundsRect;
    }
    get mediaWidth() {
        return this.getDimensions().width * this.contentScaleFactor;
    }
    get mediaHeight() {
        return this.getDimensions().height * this.contentScaleFactor;
    }
    get contentScaleFactor() {
        let pixelRatio = 1;
        if (!this.hls.config.ignoreDevicePixelRatio) try {
            pixelRatio = self.devicePixelRatio;
        } catch (e) {
        /* no-op */ }
        return Math.min(pixelRatio, this.hls.config.maxDevicePixelRatio);
    }
    isLevelAllowed(level) {
        const restrictedLevels = this.restrictedLevels;
        return !restrictedLevels.some((restrictedLevel)=>{
            return level.bitrate === restrictedLevel.bitrate && level.width === restrictedLevel.width && level.height === restrictedLevel.height;
        });
    }
    static getMaxLevelByMediaSize(levels, width, height) {
        if (!(levels != null && levels.length)) return -1;
        // Levels can have the same dimensions but differing bandwidths - since levels are ordered, we can look to the next
        // to determine whether we've chosen the greatest bandwidth for the media's dimensions
        const atGreatestBandwidth = (curLevel, nextLevel)=>{
            if (!nextLevel) return true;
            return curLevel.width !== nextLevel.width || curLevel.height !== nextLevel.height;
        };
        // If we run through the loop without breaking, the media's dimensions are greater than every level, so default to
        // the max level
        let maxLevelIndex = levels.length - 1;
        // Prevent changes in aspect-ratio from causing capping to toggle back and forth
        const squareSize = Math.max(width, height);
        for(let i = 0; i < levels.length; i += 1){
            const level = levels[i];
            if ((level.width >= squareSize || level.height >= squareSize) && atGreatestBandwidth(level, levels[i + 1])) {
                maxLevelIndex = i;
                break;
            }
        }
        return maxLevelIndex;
    }
}
/**
 * Common Media Object Type
 *
 * @internal
 */ const $b941786f4eb9cb76$var$CmObjectType = {
    /**
   * text file, such as a manifest or playlist
   */ MANIFEST: 'm',
    /**
   * audio only
   */ AUDIO: 'a',
    /**
   * video only
   */ VIDEO: 'v',
    /**
   * muxed audio and video
   */ MUXED: 'av',
    /**
   * init segment
   */ INIT: 'i',
    /**
   * caption or subtitle
   */ CAPTION: 'c',
    /**
   * ISOBMFF timed text track
   */ TIMED_TEXT: 'tt',
    /**
   * cryptographic key, license or certificate.
   */ KEY: 'k',
    /**
   * other
   */ OTHER: 'o'
};
/**
 * Common Media Client Data Object Type
 *
 * @group CMCD
 *
 * @beta
 *
 * @enum
 */ const $b941786f4eb9cb76$var$CmcdObjectType = $b941786f4eb9cb76$var$CmObjectType;
/**
 * Common Media Streaming Format
 *
 * @internal
 */ const $b941786f4eb9cb76$var$CmStreamingFormat = {
    /**
   * HTTP Live Streaming (HLS)
   */ HLS: 'h'
};
/**
 * Common Media Client Data Streaming Format
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CmcdStreamingFormat = $b941786f4eb9cb76$var$CmStreamingFormat;
/**
 * Structured Field Item
 *
 * @group Structured Field
 *
 * @beta
 */ class $b941786f4eb9cb76$var$SfItem {
    constructor(value, params){
        if (Array.isArray(value)) value = value.map((v)=>v instanceof $b941786f4eb9cb76$var$SfItem ? v : new $b941786f4eb9cb76$var$SfItem(v));
        this.value = value;
        this.params = params;
    }
}
const $b941786f4eb9cb76$var$DICT = 'Dict';
function $b941786f4eb9cb76$var$format(value) {
    if (Array.isArray(value)) return JSON.stringify(value);
    if (value instanceof Map) return 'Map{}';
    if (value instanceof Set) return 'Set{}';
    if (typeof value === 'object') return JSON.stringify(value);
    return String(value);
}
function $b941786f4eb9cb76$var$throwError(action, src, type, cause) {
    return new Error(`failed to ${action} "${$b941786f4eb9cb76$var$format(src)}" as ${type}`, {
        cause: cause
    });
}
function $b941786f4eb9cb76$var$serializeError(src, type, cause) {
    return $b941786f4eb9cb76$var$throwError('serialize', src, type, cause);
}
/**
 * A class to represent structured field tokens when `Symbol` is not available.
 *
 * @group Structured Field
 *
 * @beta
 */ class $b941786f4eb9cb76$var$SfToken {
    constructor(description){
        this.description = description;
    }
}
const $b941786f4eb9cb76$var$BARE_ITEM = 'Bare Item';
const $b941786f4eb9cb76$var$BOOLEAN = 'Boolean';
// 4.1.9.  Serializing a Boolean
//
// Given a Boolean as input_boolean, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  If input_boolean is not a boolean, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append "?" to output.
//
// 4.  If input_boolean is true, append "1" to output.
//
// 5.  If input_boolean is false, append "0" to output.
//
// 6.  Return output.
function $b941786f4eb9cb76$var$serializeBoolean(value) {
    if (typeof value !== 'boolean') throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$BOOLEAN);
    return value ? '?1' : '?0';
}
/**
 * Encodes binary data to base64
 *
 * @param binary - The binary data to encode
 * @returns The base64 encoded string
 *
 * @group Utils
 *
 * @beta
 */ function $b941786f4eb9cb76$var$encodeBase64(binary) {
    return btoa(String.fromCharCode(...binary));
}
const $b941786f4eb9cb76$var$BYTES = 'Byte Sequence';
// 4.1.8.  Serializing a Byte Sequence
//
// Given a Byte Sequence as input_bytes, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_bytes is not a sequence of bytes, fail serialization.
//
// 2.  Let output be an empty string.
//
// 3.  Append ":" to output.
//
// 4.  Append the result of base64-encoding input_bytes as per
//     [RFC4648], Section 4, taking account of the requirements below.
//
// 5.  Append ":" to output.
//
// 6.  Return output.
//
// The encoded data is required to be padded with "=", as per [RFC4648],
// Section 3.2.
//
// Likewise, encoded data SHOULD have pad bits set to zero, as per
// [RFC4648], Section 3.5, unless it is not possible to do so due to
// implementation constraints.
function $b941786f4eb9cb76$var$serializeByteSequence(value) {
    if (ArrayBuffer.isView(value) === false) throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$BYTES);
    return `:${$b941786f4eb9cb76$var$encodeBase64(value)}:`;
}
const $b941786f4eb9cb76$var$INTEGER = 'Integer';
function $b941786f4eb9cb76$var$isInvalidInt(value) {
    return value < -999999999999999 || 999999999999999 < value;
}
// 4.1.4.  Serializing an Integer
//
// Given an Integer as input_integer, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  If input_integer is not an integer in the range of
//     -999,999,999,999,999 to 999,999,999,999,999 inclusive, fail
//     serialization.
//
// 2.  Let output be an empty string.
//
// 3.  If input_integer is less than (but not equal to) 0, append "-" to
//     output.
//
// 4.  Append input_integer's numeric value represented in base 10 using
//     only decimal digits to output.
//
// 5.  Return output.
function $b941786f4eb9cb76$var$serializeInteger(value) {
    if ($b941786f4eb9cb76$var$isInvalidInt(value)) throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$INTEGER);
    return value.toString();
}
// 4.1.10.  Serializing a Date
//
// Given a Date as input_integer, return an ASCII string suitable for
// use in an HTTP field value.
// 1.  Let output be "@".
// 2.  Append to output the result of running Serializing an Integer
//     with input_date (Section 4.1.4).
// 3.  Return output.
function $b941786f4eb9cb76$var$serializeDate(value) {
    return `@${$b941786f4eb9cb76$var$serializeInteger(value.getTime() / 1000)}`;
}
/**
 * This implements the rounding procedure described in step 2 of the "Serializing a Decimal" specification.
 * This rounding style is known as "even rounding", "banker's rounding", or "commercial rounding".
 *
 * @param value - The value to round
 * @param precision - The number of decimal places to round to
 * @returns The rounded value
 *
 * @group Utils
 *
 * @beta
 */ function $b941786f4eb9cb76$var$roundToEven(value, precision) {
    if (value < 0) return -$b941786f4eb9cb76$var$roundToEven(-value, precision);
    const decimalShift = Math.pow(10, precision);
    const isEquidistant = Math.abs(value * decimalShift % 1 - 0.5) < Number.EPSILON;
    if (isEquidistant) {
        // If the tail of the decimal place is 'equidistant' we round to the nearest even value
        const flooredValue = Math.floor(value * decimalShift);
        return (flooredValue % 2 === 0 ? flooredValue : flooredValue + 1) / decimalShift;
    } else // Otherwise, proceed as normal
    return Math.round(value * decimalShift) / decimalShift;
}
const $b941786f4eb9cb76$var$DECIMAL = 'Decimal';
// 4.1.5.  Serializing a Decimal
//
// Given a decimal number as input_decimal, return an ASCII string
// suitable for use in a HTTP field value.
//
// 1.   If input_decimal is not a decimal number, fail serialization.
//
// 2.   If input_decimal has more than three significant digits to the
//      right of the decimal point, round it to three decimal places,
//      rounding the final digit to the nearest value, or to the even
//      value if it is equidistant.
//
// 3.   If input_decimal has more than 12 significant digits to the left
//      of the decimal point after rounding, fail serialization.
//
// 4.   Let output be an empty string.
//
// 5.   If input_decimal is less than (but not equal to) 0, append "-"
//      to output.
//
// 6.   Append input_decimal's integer component represented in base 10
//      (using only decimal digits) to output; if it is zero, append
//      "0".
//
// 7.   Append "." to output.
//
// 8.   If input_decimal's fractional component is zero, append "0" to
//      output.
//
// 9.   Otherwise, append the significant digits of input_decimal's
//      fractional component represented in base 10 (using only decimal
//      digits) to output.
//
// 10.  Return output.
function $b941786f4eb9cb76$var$serializeDecimal(value) {
    const roundedValue = $b941786f4eb9cb76$var$roundToEven(value, 3); // round to 3 decimal places
    if (Math.floor(Math.abs(roundedValue)).toString().length > 12) throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$DECIMAL);
    const stringValue = roundedValue.toString();
    return stringValue.includes('.') ? stringValue : `${stringValue}.0`;
}
const $b941786f4eb9cb76$var$STRING = 'String';
const $b941786f4eb9cb76$var$STRING_REGEX = /[\x00-\x1f\x7f]+/;
// 4.1.6.  Serializing a String
//
// Given a String as input_string, return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Convert input_string into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_string contains characters in the range %x00-1f or %x7f
//     (i.e., not in VCHAR or SP), fail serialization.
//
// 3.  Let output be the string DQUOTE.
//
// 4.  For each character char in input_string:
//
//     1.  If char is "\" or DQUOTE:
//
//         1.  Append "\" to output.
//
//     2.  Append char to output.
//
// 5.  Append DQUOTE to output.
//
// 6.  Return output.
function $b941786f4eb9cb76$var$serializeString(value) {
    if ($b941786f4eb9cb76$var$STRING_REGEX.test(value)) throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$STRING);
    return `"${value.replace(/\\/g, `\\\\`).replace(/"/g, `\\"`)}"`;
}
/**
 * Converts a symbol to a string.
 *
 * @param symbol - The symbol to convert.
 *
 * @returns The string representation of the symbol.
 *
 * @internal
 */ function $b941786f4eb9cb76$var$symbolToStr(symbol) {
    return symbol.description || symbol.toString().slice(7, -1);
}
const $b941786f4eb9cb76$var$TOKEN = 'Token';
function $b941786f4eb9cb76$var$serializeToken(token) {
    const value = $b941786f4eb9cb76$var$symbolToStr(token);
    if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(value) === false) throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$TOKEN);
    return value;
}
// 4.1.3.1.  Serializing a Bare Item
//
// Given an Item as input_item, return an ASCII string suitable for use
// in a HTTP field value.
//
// 1.  If input_item is an Integer, return the result of running
//     Serializing an Integer (Section 4.1.4) with input_item.
//
// 2.  If input_item is a Decimal, return the result of running
//     Serializing a Decimal (Section 4.1.5) with input_item.
//
// 3.  If input_item is a String, return the result of running
//     Serializing a String (Section 4.1.6) with input_item.
//
// 4.  If input_item is a Token, return the result of running
//     Serializing a Token (Section 4.1.7) with input_item.
//
// 5.  If input_item is a Boolean, return the result of running
//     Serializing a Boolean (Section 4.1.9) with input_item.
//
// 6.  If input_item is a Byte Sequence, return the result of running
//     Serializing a Byte Sequence (Section 4.1.8) with input_item.
//
// 7.  If input_item is a Date, return the result of running Serializing
//     a Date (Section 4.1.10) with input_item.
//
// 8.  Otherwise, fail serialization.
function $b941786f4eb9cb76$var$serializeBareItem(value) {
    switch(typeof value){
        case 'number':
            if (!$b941786f4eb9cb76$var$isFiniteNumber(value)) throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$BARE_ITEM);
            if (Number.isInteger(value)) return $b941786f4eb9cb76$var$serializeInteger(value);
            return $b941786f4eb9cb76$var$serializeDecimal(value);
        case 'string':
            return $b941786f4eb9cb76$var$serializeString(value);
        case 'symbol':
            return $b941786f4eb9cb76$var$serializeToken(value);
        case 'boolean':
            return $b941786f4eb9cb76$var$serializeBoolean(value);
        case 'object':
            if (value instanceof Date) return $b941786f4eb9cb76$var$serializeDate(value);
            if (value instanceof Uint8Array) return $b941786f4eb9cb76$var$serializeByteSequence(value);
            if (value instanceof $b941786f4eb9cb76$var$SfToken) return $b941786f4eb9cb76$var$serializeToken(value);
        default:
            // fail
            throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$BARE_ITEM);
    }
}
const $b941786f4eb9cb76$var$KEY = 'Key';
// 4.1.1.3.  Serializing a Key
//
// Given a key as input_key, return an ASCII string suitable for use in
// a HTTP field value.
//
// 1.  Convert input_key into a sequence of ASCII characters; if
//     conversion fails, fail serialization.
//
// 2.  If input_key contains characters not in lcalpha, DIGIT, "_", "-",
//     ".", or "*" fail serialization.
//
// 3.  If the first character of input_key is not lcalpha or "*", fail
//     serialization.
//
// 4.  Let output be an empty string.
//
// 5.  Append input_key to output.
//
// 6.  Return output.
function $b941786f4eb9cb76$var$serializeKey(value) {
    if (/^[a-z*][a-z0-9\-_.*]*$/.test(value) === false) throw $b941786f4eb9cb76$var$serializeError(value, $b941786f4eb9cb76$var$KEY);
    return value;
}
// 4.1.1.2.  Serializing Parameters
//
// Given an ordered Dictionary as input_parameters (each member having a
// param_name and a param_value), return an ASCII string suitable for
// use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each param_name with a value of param_value in
//     input_parameters:
//
//     1.  Append ";" to output.
//
//     2.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with param_name to output.
//
//     3.  If param_value is not Boolean true:
//
//         1.  Append "=" to output.
//
//         2.  Append the result of running Serializing a bare Item
//             (Section 4.1.3.1) with param_value to output.
//
// 3.  Return output.
function $b941786f4eb9cb76$var$serializeParams(params) {
    if (params == null) return '';
    return Object.entries(params).map(([key, value])=>{
        if (value === true) return `;${$b941786f4eb9cb76$var$serializeKey(key)}`; // omit true
        return `;${$b941786f4eb9cb76$var$serializeKey(key)}=${$b941786f4eb9cb76$var$serializeBareItem(value)}`;
    }).join('');
}
// 4.1.3.  Serializing an Item
//
// Given an Item as bare_item and Parameters as item_parameters, return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  Append the result of running Serializing a Bare Item
//     Section 4.1.3.1 with bare_item to output.
//
// 3.  Append the result of running Serializing Parameters
//     Section 4.1.1.2 with item_parameters to output.
//
// 4.  Return output.
function $b941786f4eb9cb76$var$serializeItem(value) {
    if (value instanceof $b941786f4eb9cb76$var$SfItem) return `${$b941786f4eb9cb76$var$serializeBareItem(value.value)}${$b941786f4eb9cb76$var$serializeParams(value.params)}`;
    else return $b941786f4eb9cb76$var$serializeBareItem(value);
}
// 4.1.1.1.  Serializing an Inner List
//
// Given an array of (member_value, parameters) tuples as inner_list,
// and parameters as list_parameters, return an ASCII string suitable
// for use in a HTTP field value.
//
// 1.  Let output be the string "(".
//
// 2.  For each (member_value, parameters) of inner_list:
//
//     1.  Append the result of running Serializing an Item
//         (Section 4.1.3) with (member_value, parameters) to output.
//
//     2.  If more values remain in inner_list, append a single SP to
//         output.
//
// 3.  Append ")" to output.
//
// 4.  Append the result of running Serializing Parameters
//     (Section 4.1.1.2) with list_parameters to output.
//
// 5.  Return output.
function $b941786f4eb9cb76$var$serializeInnerList(value) {
    return `(${value.value.map($b941786f4eb9cb76$var$serializeItem).join(' ')})${$b941786f4eb9cb76$var$serializeParams(value.params)}`;
}
// 4.1.2.  Serializing a Dictionary
//
// Given an ordered Dictionary as input_dictionary (each member having a
// member_name and a tuple value of (member_value, parameters)), return
// an ASCII string suitable for use in a HTTP field value.
//
// 1.  Let output be an empty string.
//
// 2.  For each member_name with a value of (member_value, parameters)
//     in input_dictionary:
//
//     1.  Append the result of running Serializing a Key
//         (Section 4.1.1.3) with member's member_name to output.
//
//     2.  If member_value is Boolean true:
//
//         1.  Append the result of running Serializing Parameters
//             (Section 4.1.1.2) with parameters to output.
//
//     3.  Otherwise:
//
//         1.  Append "=" to output.
//
//         2.  If member_value is an array, append the result of running
//             Serializing an Inner List (Section 4.1.1.1) with
//             (member_value, parameters) to output.
//
//         3.  Otherwise, append the result of running Serializing an
//             Item (Section 4.1.3) with (member_value, parameters) to
//             output.
//
//     4.  If more members remain in input_dictionary:
//
//         1.  Append "," to output.
//
//         2.  Append a single SP to output.
//
// 3.  Return output.
function $b941786f4eb9cb76$var$serializeDict(dict, options = {
    whitespace: true
}) {
    if (typeof dict !== 'object' || dict == null) throw $b941786f4eb9cb76$var$serializeError(dict, $b941786f4eb9cb76$var$DICT);
    const entries = dict instanceof Map ? dict.entries() : Object.entries(dict);
    const optionalWhiteSpace = (options === null || options === void 0 ? void 0 : options.whitespace) ? ' ' : '';
    return Array.from(entries).map(([key, item])=>{
        if (item instanceof $b941786f4eb9cb76$var$SfItem === false) item = new $b941786f4eb9cb76$var$SfItem(item);
        let output = $b941786f4eb9cb76$var$serializeKey(key);
        if (item.value === true) output += $b941786f4eb9cb76$var$serializeParams(item.params);
        else {
            output += '=';
            if (Array.isArray(item.value)) output += $b941786f4eb9cb76$var$serializeInnerList(item);
            else output += $b941786f4eb9cb76$var$serializeItem(item);
        }
        return output;
    }).join(`,${optionalWhiteSpace}`);
}
/**
 * Encode an object into a structured field dictionary
 *
 * @param value - The structured field dictionary to encode
 * @param options - Encoding options
 *
 * @returns The structured field string
 *
 * @group Structured Field
 *
 * @beta
 */ function $b941786f4eb9cb76$var$encodeSfDict(value, options) {
    return $b941786f4eb9cb76$var$serializeDict(value, options);
}
/**
 * CMCD object header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_OBJECT = 'CMCD-Object';
/**
 * CMCD request header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_REQUEST = 'CMCD-Request';
/**
 * CMCD session header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_SESSION = 'CMCD-Session';
/**
 * CMCD status header name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_STATUS = 'CMCD-Status';
/**
 * The map of CMCD keys to their appropriate header shard.
 *
 * @group CMCD
 *
 * @internal
 */ const $b941786f4eb9cb76$var$CMCD_HEADER_MAP = {
    // Object
    br: $b941786f4eb9cb76$var$CMCD_OBJECT,
    ab: $b941786f4eb9cb76$var$CMCD_OBJECT,
    d: $b941786f4eb9cb76$var$CMCD_OBJECT,
    ot: $b941786f4eb9cb76$var$CMCD_OBJECT,
    tb: $b941786f4eb9cb76$var$CMCD_OBJECT,
    tpb: $b941786f4eb9cb76$var$CMCD_OBJECT,
    lb: $b941786f4eb9cb76$var$CMCD_OBJECT,
    tab: $b941786f4eb9cb76$var$CMCD_OBJECT,
    lab: $b941786f4eb9cb76$var$CMCD_OBJECT,
    url: $b941786f4eb9cb76$var$CMCD_OBJECT,
    // Request
    pb: $b941786f4eb9cb76$var$CMCD_REQUEST,
    bl: $b941786f4eb9cb76$var$CMCD_REQUEST,
    tbl: $b941786f4eb9cb76$var$CMCD_REQUEST,
    dl: $b941786f4eb9cb76$var$CMCD_REQUEST,
    ltc: $b941786f4eb9cb76$var$CMCD_REQUEST,
    mtp: $b941786f4eb9cb76$var$CMCD_REQUEST,
    nor: $b941786f4eb9cb76$var$CMCD_REQUEST,
    nrr: $b941786f4eb9cb76$var$CMCD_REQUEST,
    rc: $b941786f4eb9cb76$var$CMCD_REQUEST,
    sn: $b941786f4eb9cb76$var$CMCD_REQUEST,
    sta: $b941786f4eb9cb76$var$CMCD_REQUEST,
    su: $b941786f4eb9cb76$var$CMCD_REQUEST,
    ttfb: $b941786f4eb9cb76$var$CMCD_REQUEST,
    ttfbb: $b941786f4eb9cb76$var$CMCD_REQUEST,
    ttlb: $b941786f4eb9cb76$var$CMCD_REQUEST,
    cmsdd: $b941786f4eb9cb76$var$CMCD_REQUEST,
    cmsds: $b941786f4eb9cb76$var$CMCD_REQUEST,
    smrt: $b941786f4eb9cb76$var$CMCD_REQUEST,
    df: $b941786f4eb9cb76$var$CMCD_REQUEST,
    cs: $b941786f4eb9cb76$var$CMCD_REQUEST,
    // TODO: Which header to put the `ts` field is not defined yet.
    ts: $b941786f4eb9cb76$var$CMCD_REQUEST,
    // Session
    cid: $b941786f4eb9cb76$var$CMCD_SESSION,
    pr: $b941786f4eb9cb76$var$CMCD_SESSION,
    sf: $b941786f4eb9cb76$var$CMCD_SESSION,
    sid: $b941786f4eb9cb76$var$CMCD_SESSION,
    st: $b941786f4eb9cb76$var$CMCD_SESSION,
    v: $b941786f4eb9cb76$var$CMCD_SESSION,
    msd: $b941786f4eb9cb76$var$CMCD_SESSION,
    // Status
    bs: $b941786f4eb9cb76$var$CMCD_STATUS,
    bsd: $b941786f4eb9cb76$var$CMCD_STATUS,
    cdn: $b941786f4eb9cb76$var$CMCD_STATUS,
    rtp: $b941786f4eb9cb76$var$CMCD_STATUS,
    bg: $b941786f4eb9cb76$var$CMCD_STATUS,
    pt: $b941786f4eb9cb76$var$CMCD_STATUS,
    ec: $b941786f4eb9cb76$var$CMCD_STATUS,
    e: $b941786f4eb9cb76$var$CMCD_STATUS
};
/**
 * CMCD header fields.
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CmcdHeaderField = {
    /**
   * keys whose values vary with each request.
   */ REQUEST: $b941786f4eb9cb76$var$CMCD_REQUEST
};
function $b941786f4eb9cb76$var$createHeaderMap(headerMap) {
    return Object.keys(headerMap).reduce((acc, field)=>{
        var _a;
        (_a = headerMap[field]) === null || _a === void 0 || _a.forEach((key)=>acc[key] = field);
        return acc;
    }, {});
}
/**
 * Group a CMCD data object into header shards
 *
 * @param cmcd - The CMCD data object to convert.
 * @param customHeaderMap - A map of CMCD header fields to custom CMCD keys.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 */ function $b941786f4eb9cb76$var$groupCmcdHeaders(cmcd, customHeaderMap) {
    const result = {};
    if (!cmcd) return result;
    const keys = Object.keys(cmcd);
    const custom = customHeaderMap ? $b941786f4eb9cb76$var$createHeaderMap(customHeaderMap) : {};
    return keys.reduce((acc, key)=>{
        var _a;
        const field = $b941786f4eb9cb76$var$CMCD_HEADER_MAP[key] || custom[key] || $b941786f4eb9cb76$var$CmcdHeaderField.REQUEST;
        const data = (_a = acc[field]) !== null && _a !== void 0 ? _a : acc[field] = {};
        data[key] = cmcd[key];
        return acc;
    }, result);
}
/**
 * Checks if the given key is a token field.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a token field.
 *
 * @internal
 */ function $b941786f4eb9cb76$var$isTokenField(key) {
    return [
        'ot',
        'sf',
        'st',
        'e',
        'sta'
    ].includes(key);
}
/**
 * Checks if the given value is valid
 *
 * @param value - The value to check.
 *
 * @returns `true` if the key is a value is valid.
 *
 * @internal
 */ function $b941786f4eb9cb76$var$isValid(value) {
    if (typeof value === 'number') return $b941786f4eb9cb76$var$isFiniteNumber(value);
    return value != null && value !== '' && value !== false;
}
/**
 * CMCD event mode variable name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_EVENT_MODE = 'event';
/**
 * Constructs a relative path from a URL.
 *
 * @param url - The destination URL
 * @param base - The base URL
 * @returns The relative path
 *
 * @group Utils
 *
 * @beta
 */ function $b941786f4eb9cb76$var$urlToRelativePath(url, base) {
    const to = new URL(url);
    const from = new URL(base);
    if (to.origin !== from.origin) return url;
    const toPath = to.pathname.split('/').slice(1);
    const fromPath = from.pathname.split('/').slice(1, -1);
    // remove common parents
    while(toPath[0] === fromPath[0]){
        toPath.shift();
        fromPath.shift();
    }
    // add back paths
    while(fromPath.length){
        fromPath.shift();
        toPath.unshift('..');
    }
    const relativePath = toPath.join('/');
    // preserve query parameters and hash of the destination url
    return relativePath + to.search + to.hash;
}
const $b941786f4eb9cb76$var$toRounded = (value)=>Math.round(value);
const $b941786f4eb9cb76$var$toUrlSafe = (value, options)=>{
    if (Array.isArray(value)) return value.map((item)=>$b941786f4eb9cb76$var$toUrlSafe(item, options));
    if (value instanceof $b941786f4eb9cb76$var$SfItem && typeof value.value === 'string') return new $b941786f4eb9cb76$var$SfItem($b941786f4eb9cb76$var$toUrlSafe(value.value, options), value.params);
    else {
        if (options.baseUrl) value = $b941786f4eb9cb76$var$urlToRelativePath(value, options.baseUrl);
        return options.version === 1 ? encodeURIComponent(value) : value;
    }
};
const $b941786f4eb9cb76$var$toHundred = (value)=>$b941786f4eb9cb76$var$toRounded(value / 100) * 100;
const $b941786f4eb9cb76$var$nor = (value, options)=>{
    let norValue = value;
    if (options.version >= 2) {
        if (value instanceof $b941786f4eb9cb76$var$SfItem && typeof value.value === 'string') norValue = new $b941786f4eb9cb76$var$SfItem([
            value
        ]);
        else if (typeof value === 'string') norValue = [
            value
        ];
    }
    return $b941786f4eb9cb76$var$toUrlSafe(norValue, options);
};
/**
 * The default formatters for CMCD values.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_FORMATTER_MAP = {
    /**
   * Bitrate (kbps) rounded integer
   */ br: $b941786f4eb9cb76$var$toRounded,
    /**
   * Duration (milliseconds) rounded integer
   */ d: $b941786f4eb9cb76$var$toRounded,
    /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */ bl: $b941786f4eb9cb76$var$toHundred,
    /**
   * Deadline (milliseconds) rounded nearest 100ms
   */ dl: $b941786f4eb9cb76$var$toHundred,
    /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */ mtp: $b941786f4eb9cb76$var$toHundred,
    nor: /**
   * Next Object Request URL encoded
   */ $b941786f4eb9cb76$var$nor,
    /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */ rtp: $b941786f4eb9cb76$var$toHundred,
    /**
   * Top Bitrate (kbps) rounded integer
   */ tb: $b941786f4eb9cb76$var$toRounded
};
/**
 * CMCD request mode variable name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_REQUEST_MODE = 'request';
/**
 * CMCD response mode variable name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_RESPONSE_MODE = 'response';
/**
 * Defines the common keys for CMCD (Common Media Client Data) version 2.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_COMMON_KEYS = [
    'ab',
    'bg',
    'bl',
    'br',
    'bs',
    'bsd',
    'cdn',
    'cid',
    'cs',
    'df',
    'ec',
    'lab',
    'lb',
    'ltc',
    'msd',
    'mtp',
    'pb',
    'pr',
    'pt',
    'sf',
    'sid',
    'sn',
    'st',
    'sta',
    'tab',
    'tb',
    'tbl',
    'tpb',
    'ts',
    'v'
];
/**
 * Defines the event-specific keys for CMCD (Common Media Client Data) version 2.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_EVENT_KEYS = [
    'e'
];
const $b941786f4eb9cb76$var$CUSTOM_KEY_REGEX = /^[a-zA-Z0-9-.]+-[a-zA-Z0-9-.]+$/;
/**
 * Check if a key is a custom key.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a custom key, `false` otherwise.
 *
 * @group CMCD
 *
 * @beta
 */ function $b941786f4eb9cb76$var$isCmcdCustomKey(key) {
    return $b941786f4eb9cb76$var$CUSTOM_KEY_REGEX.test(key);
}
/**
 * Check if a key is a valid CMCD event key.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a valid CMCD event key, `false` otherwise.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/isCmcdEventKey.test.ts#example}
 */ function $b941786f4eb9cb76$var$isCmcdEventKey(key) {
    return $b941786f4eb9cb76$var$CMCD_COMMON_KEYS.includes(key) || $b941786f4eb9cb76$var$CMCD_EVENT_KEYS.includes(key) || $b941786f4eb9cb76$var$isCmcdCustomKey(key);
}
/**
 * Defines the request-specific keys for CMCD (Common Media Client Data) version 2.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_REQUEST_KEYS = [
    'd',
    'dl',
    'nor',
    'ot',
    'rtp',
    'su'
];
/**
 * Check if a key is a valid CMCD request key.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a valid CMCD request key, `false` otherwise.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/isCmcdRequestKey.test.ts#example}
 */ function $b941786f4eb9cb76$var$isCmcdRequestKey(key) {
    return $b941786f4eb9cb76$var$CMCD_COMMON_KEYS.includes(key) || $b941786f4eb9cb76$var$CMCD_REQUEST_KEYS.includes(key) || $b941786f4eb9cb76$var$isCmcdCustomKey(key);
}
/**
 * CMCD v2 - Response-only and timing keys.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_RESPONSE_KEYS = [
    'cmsdd',
    'cmsds',
    'rc',
    'smrt',
    'ttfb',
    'ttfbb',
    'ttlb',
    'url'
];
/**
 * Check if a key is a valid CMCD response key.
 *
 * @param key - The key to check.
 *
 * @returns `true` if the key is a valid CMCD request key, `false` otherwise.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/isCmcdResponseKey.test.ts#example}
 */ function $b941786f4eb9cb76$var$isCmcdResponseKey(key) {
    return $b941786f4eb9cb76$var$CMCD_COMMON_KEYS.includes(key) || $b941786f4eb9cb76$var$CMCD_REQUEST_KEYS.includes(key) || $b941786f4eb9cb76$var$CMCD_RESPONSE_KEYS.includes(key) || $b941786f4eb9cb76$var$isCmcdCustomKey(key);
}
/**
 * Defines the keys for CMCD (Common Media Client Data) version 1.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_V1_KEYS = [
    'bl',
    'br',
    'bs',
    'cid',
    'd',
    'dl',
    'mtp',
    'nor',
    'nrr',
    'ot',
    'pr',
    'rtp',
    'sf',
    'sid',
    'st',
    'su',
    'tb',
    'v'
];
/**
 * Filter function for CMCD v1 keys.
 *
 * @param key - The CMCD key to filter.
 *
 * @returns `true` if the key should be included, `false` otherwise.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/isCmcdV1Key.test.ts#example}
 */ function $b941786f4eb9cb76$var$isCmcdV1Key(key) {
    return $b941786f4eb9cb76$var$CMCD_V1_KEYS.includes(key) || $b941786f4eb9cb76$var$isCmcdCustomKey(key);
}
const $b941786f4eb9cb76$var$filterMap = {
    [$b941786f4eb9cb76$var$CMCD_RESPONSE_MODE]: $b941786f4eb9cb76$var$isCmcdResponseKey,
    [$b941786f4eb9cb76$var$CMCD_EVENT_MODE]: $b941786f4eb9cb76$var$isCmcdEventKey,
    [$b941786f4eb9cb76$var$CMCD_REQUEST_MODE]: $b941786f4eb9cb76$var$isCmcdRequestKey
};
/**
 * Convert a generic object to CMCD data.
 *
 * @param obj - The CMCD object to process.
 * @param options - Options for encoding.
 *
 * @group CMCD
 *
 * @beta
 */ function $b941786f4eb9cb76$var$prepareCmcdData(obj, options = {}) {
    const results = {};
    if (obj == null || typeof obj !== 'object') return results;
    const version = options.version || obj['v'] || 1;
    const reportingMode = options.reportingMode || $b941786f4eb9cb76$var$CMCD_REQUEST_MODE;
    const keyFilter = version === 1 ? $b941786f4eb9cb76$var$isCmcdV1Key : $b941786f4eb9cb76$var$filterMap[reportingMode];
    // Filter keys based on the version, reporting mode and options
    let keys = Object.keys(obj).filter(keyFilter);
    const filter = options.filter;
    if (typeof filter === 'function') keys = keys.filter(filter);
    // Ensure all required keys are present before sorting
    const needsTimestamp = reportingMode === $b941786f4eb9cb76$var$CMCD_RESPONSE_MODE || reportingMode === $b941786f4eb9cb76$var$CMCD_EVENT_MODE;
    if (needsTimestamp && !keys.includes('ts')) keys.push('ts');
    if (version > 1 && !keys.includes('v')) keys.push('v');
    const formatters = $b941786f4eb9cb76$var$_extends({}, $b941786f4eb9cb76$var$CMCD_FORMATTER_MAP, options.formatters);
    const formatterOptions = {
        version: version,
        reportingMode: reportingMode,
        baseUrl: options.baseUrl
    };
    keys.sort().forEach((key)=>{
        let value = obj[key];
        const formatter = formatters[key];
        if (typeof formatter === 'function') value = formatter(value, formatterOptions);
        // Version should only be reported if not equal to 1.
        if (key === 'v') {
            if (version === 1) return;
            else value = version;
        }
        // Playback rate should only be sent if not equal to 1.
        if (key == 'pr' && value === 1) return;
        // Ensure a timestamp is set for response and event modes
        if (needsTimestamp && key === 'ts' && !$b941786f4eb9cb76$var$isFiniteNumber(value)) value = Date.now();
        // ignore invalid values
        if (!$b941786f4eb9cb76$var$isValid(value)) return;
        if ($b941786f4eb9cb76$var$isTokenField(key) && typeof value === 'string') value = new $b941786f4eb9cb76$var$SfToken(value);
        results[key] = value;
    });
    return results;
}
/**
 * Convert a CMCD data object to request headers
 *
 * @param cmcd - The CMCD data object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD header shards.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/toCmcdHeaders.test.ts#example}
 */ function $b941786f4eb9cb76$var$toCmcdHeaders(cmcd, options = {}) {
    const result = {};
    if (!cmcd) return result;
    const data = $b941786f4eb9cb76$var$prepareCmcdData(cmcd, options);
    const shards = $b941786f4eb9cb76$var$groupCmcdHeaders(data, options === null || options === void 0 ? void 0 : options.customHeaderMap);
    return Object.entries(shards).reduce((acc, [field, value])=>{
        const shard = $b941786f4eb9cb76$var$encodeSfDict(value, {
            whitespace: false
        });
        if (shard) acc[field] = shard;
        return acc;
    }, result);
}
/**
 * Append CMCD query args to a header object.
 *
 * @param headers - The headers to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Encode options.
 *
 * @returns The headers with the CMCD header shards appended.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/appendCmcdHeaders.test.ts#example}
 */ function $b941786f4eb9cb76$var$appendCmcdHeaders(headers, cmcd, options) {
    return $b941786f4eb9cb76$var$_extends(headers, $b941786f4eb9cb76$var$toCmcdHeaders(cmcd, options));
}
/**
 * CMCD parameter name.
 *
 * @group CMCD
 *
 * @beta
 */ const $b941786f4eb9cb76$var$CMCD_PARAM = 'CMCD';
/**
 * Encode a CMCD object to a string.
 *
 * @param cmcd - The CMCD object to encode.
 * @param options - Options for encoding.
 *
 * @returns The encoded CMCD string.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/encodeCmcd.test.ts#example}
 */ function $b941786f4eb9cb76$var$encodeCmcd(cmcd, options = {}) {
    if (!cmcd) return '';
    return $b941786f4eb9cb76$var$encodeSfDict($b941786f4eb9cb76$var$prepareCmcdData(cmcd, options), {
        whitespace: false
    });
}
/**
 * Convert a CMCD data object to a URL encoded string.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL encoded CMCD data.
 *
 * @group CMCD
 *
 * @beta
 */ function $b941786f4eb9cb76$var$toCmcdUrl(cmcd, options = {}) {
    if (!cmcd) return '';
    const params = $b941786f4eb9cb76$var$encodeCmcd(cmcd, options);
    return encodeURIComponent(params);
}
/**
 * Convert a CMCD data object to a query arg.
 *
 * @param cmcd - The CMCD object to convert.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The CMCD query arg.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/toCmcdQuery.test.ts#example}
 */ function $b941786f4eb9cb76$var$toCmcdQuery(cmcd, options = {}) {
    if (!cmcd) return '';
    const value = $b941786f4eb9cb76$var$toCmcdUrl(cmcd, options);
    return `${$b941786f4eb9cb76$var$CMCD_PARAM}=${value}`;
}
const $b941786f4eb9cb76$var$REGEX = /CMCD=[^&#]+/;
/**
 * Append CMCD query args to a URL.
 *
 * @param url - The URL to append to.
 * @param cmcd - The CMCD object to append.
 * @param options - Options for encoding the CMCD object.
 *
 * @returns The URL with the CMCD query args appended.
 *
 * @group CMCD
 *
 * @beta
 *
 * @example
 * {@includeCode ../../test/cmcd/appendCmcdQuery.test.ts#example}
 */ function $b941786f4eb9cb76$var$appendCmcdQuery(url, cmcd, options) {
    // TODO: Replace with URLSearchParams once we drop Safari < 10.1 & Chrome < 49 support.
    // https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
    const query = $b941786f4eb9cb76$var$toCmcdQuery(cmcd, options);
    if (!query) return url;
    if ($b941786f4eb9cb76$var$REGEX.test(url)) return url.replace($b941786f4eb9cb76$var$REGEX, query);
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}${query}`;
}
/**
 * Controller to deal with Common Media Client Data (CMCD)
 * @see https://cdn.cta.tech/cta/media/media/resources/standards/pdfs/cta-5004-final.pdf
 */ class $b941786f4eb9cb76$export$953f29a3a19a03d {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = void 0;
        this.sid = void 0;
        this.cid = void 0;
        this.useHeaders = false;
        this.includeKeys = void 0;
        this.initialized = false;
        this.starved = false;
        this.buffering = true;
        this.audioBuffer = void 0;
        this.videoBuffer = void 0;
        this.onWaiting = ()=>{
            if (this.initialized) this.starved = true;
            this.buffering = true;
        };
        this.onPlaying = ()=>{
            if (!this.initialized) this.initialized = true;
            this.buffering = false;
        };
        /**
     * Apply CMCD data to a manifest request.
     */ this.applyPlaylistData = (context)=>{
            try {
                this.apply(context, {
                    ot: $b941786f4eb9cb76$var$CmcdObjectType.MANIFEST,
                    su: !this.initialized
                });
            } catch (error) {
                this.hls.logger.warn('Could not generate manifest CMCD data.', error);
            }
        };
        /**
     * Apply CMCD data to a segment request
     */ this.applyFragmentData = (context)=>{
            try {
                const { frag: frag, part: part } = context;
                const level = this.hls.levels[frag.level];
                const ot = this.getObjectType(frag);
                const data = {
                    d: (part || frag).duration * 1000,
                    ot: ot
                };
                if (ot === $b941786f4eb9cb76$var$CmcdObjectType.VIDEO || ot === $b941786f4eb9cb76$var$CmcdObjectType.AUDIO || ot == $b941786f4eb9cb76$var$CmcdObjectType.MUXED) {
                    data.br = level.bitrate / 1000;
                    data.tb = this.getTopBandwidth(ot) / 1000;
                    data.bl = this.getBufferLength(ot);
                }
                const next = part ? this.getNextPart(part) : this.getNextFrag(frag);
                if (next != null && next.url && next.url !== frag.url) data.nor = next.url;
                this.apply(context, data);
            } catch (error) {
                this.hls.logger.warn('Could not generate segment CMCD data.', error);
            }
        };
        this.hls = hls;
        const config = this.config = hls.config;
        const { cmcd: cmcd } = config;
        if (cmcd != null) {
            config.pLoader = this.createPlaylistLoader();
            config.fLoader = this.createFragmentLoader();
            this.sid = cmcd.sessionId || hls.sessionId;
            this.cid = cmcd.contentId;
            this.useHeaders = cmcd.useHeaders === true;
            this.includeKeys = cmcd.includeKeys;
            this.registerListeners();
        }
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetached();
        // @ts-ignore
        this.hls = this.config = this.audioBuffer = this.videoBuffer = null;
        // @ts-ignore
        this.onWaiting = this.onPlaying = this.media = null;
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener('waiting', this.onWaiting);
        this.media.addEventListener('playing', this.onPlaying);
    }
    onMediaDetached() {
        if (!this.media) return;
        this.media.removeEventListener('waiting', this.onWaiting);
        this.media.removeEventListener('playing', this.onPlaying);
        // @ts-ignore
        this.media = null;
    }
    onBufferCreated(event, data) {
        var _data$tracks$audio, _data$tracks$video;
        this.audioBuffer = (_data$tracks$audio = data.tracks.audio) == null ? void 0 : _data$tracks$audio.buffer;
        this.videoBuffer = (_data$tracks$video = data.tracks.video) == null ? void 0 : _data$tracks$video.buffer;
    }
    /**
   * Create baseline CMCD data
   */ createData() {
        var _this$media;
        return {
            v: 1,
            sf: $b941786f4eb9cb76$var$CmcdStreamingFormat.HLS,
            sid: this.sid,
            cid: this.cid,
            pr: (_this$media = this.media) == null ? void 0 : _this$media.playbackRate,
            mtp: this.hls.bandwidthEstimate / 1000
        };
    }
    /**
   * Apply CMCD data to a request.
   */ apply(context, data = {}) {
        // apply baseline data
        $b941786f4eb9cb76$var$_extends(data, this.createData());
        const isVideo = data.ot === $b941786f4eb9cb76$var$CmcdObjectType.INIT || data.ot === $b941786f4eb9cb76$var$CmcdObjectType.VIDEO || data.ot === $b941786f4eb9cb76$var$CmcdObjectType.MUXED;
        if (this.starved && isVideo) {
            data.bs = true;
            data.su = true;
            this.starved = false;
        }
        if (data.su == null) data.su = this.buffering;
        // TODO: Implement rtp, nrr, dl
        const { includeKeys: includeKeys } = this;
        if (includeKeys) data = Object.keys(data).reduce((acc, key)=>{
            includeKeys.includes(key) && (acc[key] = data[key]);
            return acc;
        }, {});
        const options = {
            baseUrl: context.url
        };
        if (this.useHeaders) {
            if (!context.headers) context.headers = {};
            $b941786f4eb9cb76$var$appendCmcdHeaders(context.headers, data, options);
        } else context.url = $b941786f4eb9cb76$var$appendCmcdQuery(context.url, data, options);
    }
    getNextFrag(fragment) {
        var _this$hls$levels$frag;
        const levelDetails = (_this$hls$levels$frag = this.hls.levels[fragment.level]) == null ? void 0 : _this$hls$levels$frag.details;
        if (levelDetails) {
            const index = fragment.sn - levelDetails.startSN;
            return levelDetails.fragments[index + 1];
        }
        return undefined;
    }
    getNextPart(part) {
        var _this$hls$levels$frag2;
        const { index: index, fragment: fragment } = part;
        const partList = (_this$hls$levels$frag2 = this.hls.levels[fragment.level]) == null || (_this$hls$levels$frag2 = _this$hls$levels$frag2.details) == null ? void 0 : _this$hls$levels$frag2.partList;
        if (partList) {
            const { sn: sn } = fragment;
            for(let i = partList.length - 1; i >= 0; i--){
                const p = partList[i];
                if (p.index === index && p.fragment.sn === sn) return partList[i + 1];
            }
        }
        return undefined;
    }
    /**
   * The CMCD object type.
   */ getObjectType(fragment) {
        const { type: type } = fragment;
        if (type === 'subtitle') return $b941786f4eb9cb76$var$CmcdObjectType.TIMED_TEXT;
        if (fragment.sn === 'initSegment') return $b941786f4eb9cb76$var$CmcdObjectType.INIT;
        if (type === 'audio') return $b941786f4eb9cb76$var$CmcdObjectType.AUDIO;
        if (type === 'main') {
            if (!this.hls.audioTracks.length) return $b941786f4eb9cb76$var$CmcdObjectType.MUXED;
            return $b941786f4eb9cb76$var$CmcdObjectType.VIDEO;
        }
        return undefined;
    }
    /**
   * Get the highest bitrate.
   */ getTopBandwidth(type) {
        let bitrate = 0;
        let levels;
        const hls = this.hls;
        if (type === $b941786f4eb9cb76$var$CmcdObjectType.AUDIO) levels = hls.audioTracks;
        else {
            const max = hls.maxAutoLevel;
            const len = max > -1 ? max + 1 : hls.levels.length;
            levels = hls.levels.slice(0, len);
        }
        levels.forEach((level)=>{
            if (level.bitrate > bitrate) bitrate = level.bitrate;
        });
        return bitrate > 0 ? bitrate : NaN;
    }
    /**
   * Get the buffer length for a media type in milliseconds
   */ getBufferLength(type) {
        const media = this.media;
        const buffer = type === $b941786f4eb9cb76$var$CmcdObjectType.AUDIO ? this.audioBuffer : this.videoBuffer;
        if (!buffer || !media) return NaN;
        const info = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(buffer, media.currentTime, this.config.maxBufferHole);
        return info.len * 1000;
    }
    /**
   * Create a playlist loader
   */ createPlaylistLoader() {
        const { pLoader: pLoader } = this.config;
        const apply = this.applyPlaylistData;
        const Ctor = pLoader || this.config.loader;
        return class CmcdPlaylistLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
    /**
   * Create a playlist loader
   */ createFragmentLoader() {
        const { fLoader: fLoader } = this.config;
        const apply = this.applyFragmentData;
        const Ctor = fLoader || this.config.loader;
        return class CmcdFragmentLoader {
            constructor(config){
                this.loader = void 0;
                this.loader = new Ctor(config);
            }
            get stats() {
                return this.loader.stats;
            }
            get context() {
                return this.loader.context;
            }
            destroy() {
                this.loader.destroy();
            }
            abort() {
                this.loader.abort();
            }
            load(context, config, callbacks) {
                apply(context);
                this.loader.load(context, config, callbacks);
            }
        };
    }
}
const $b941786f4eb9cb76$var$PATHWAY_PENALTY_DURATION_MS = 300000;
class $b941786f4eb9cb76$export$52a61818002372cb extends $b941786f4eb9cb76$var$Logger {
    constructor(hls){
        super('content-steering', hls.logger);
        this.hls = void 0;
        this.loader = null;
        this.uri = null;
        this.pathwayId = '.';
        this._pathwayPriority = null;
        this.timeToLoad = 300;
        this.reloadTimer = -1;
        this.updated = 0;
        this.started = false;
        this.enabled = true;
        this.levels = null;
        this.audioTracks = null;
        this.subtitleTracks = null;
        this.penalizedPathways = {};
        this.hls = hls;
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const hls = this.hls;
        if (!hls) return;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    pathways() {
        return (this.levels || []).reduce((pathways, level)=>{
            if (pathways.indexOf(level.pathwayId) === -1) pathways.push(level.pathwayId);
            return pathways;
        }, []);
    }
    get pathwayPriority() {
        return this._pathwayPriority;
    }
    set pathwayPriority(pathwayPriority) {
        this.updatePathwayPriority(pathwayPriority);
    }
    startLoad() {
        this.started = true;
        this.clearTimeout();
        if (this.enabled && this.uri) {
            if (this.updated) {
                const ttl = this.timeToLoad * 1000 - (performance.now() - this.updated);
                if (ttl > 0) {
                    this.scheduleRefresh(this.uri, ttl);
                    return;
                }
            }
            this.loadSteeringManifest(this.uri);
        }
    }
    stopLoad() {
        this.started = false;
        if (this.loader) {
            this.loader.destroy();
            this.loader = null;
        }
        this.clearTimeout();
    }
    clearTimeout() {
        if (this.reloadTimer !== -1) {
            self.clearTimeout(this.reloadTimer);
            this.reloadTimer = -1;
        }
    }
    destroy() {
        this.unregisterListeners();
        this.stopLoad();
        // @ts-ignore
        this.hls = null;
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    removeLevel(levelToRemove) {
        const levels = this.levels;
        if (levels) this.levels = levels.filter((level)=>level !== levelToRemove);
    }
    onManifestLoading() {
        this.stopLoad();
        this.enabled = true;
        this.timeToLoad = 300;
        this.updated = 0;
        this.uri = null;
        this.pathwayId = '.';
        this.levels = this.audioTracks = this.subtitleTracks = null;
    }
    onManifestLoaded(event, data) {
        const { contentSteering: contentSteering } = data;
        if (contentSteering === null) return;
        this.pathwayId = contentSteering.pathwayId;
        this.uri = contentSteering.uri;
        if (this.started) this.startLoad();
    }
    onManifestParsed(event, data) {
        this.audioTracks = data.audioTracks;
        this.subtitleTracks = data.subtitleTracks;
    }
    onError(event, data) {
        const { errorAction: errorAction } = data;
        if ((errorAction == null ? void 0 : errorAction.action) === $b941786f4eb9cb76$export$679390c50dd617e4.SendAlternateToPenaltyBox && errorAction.flags === $b941786f4eb9cb76$export$f377ad9144b2d7af.MoveAllAlternatesMatchingHost) {
            const levels = this.levels;
            let pathwayPriority = this._pathwayPriority;
            let errorPathway = this.pathwayId;
            if (data.context) {
                const { groupId: groupId, pathwayId: pathwayId, type: type } = data.context;
                if (groupId && levels) errorPathway = this.getPathwayForGroupId(groupId, type, errorPathway);
                else if (pathwayId) errorPathway = pathwayId;
            }
            if (!(errorPathway in this.penalizedPathways)) this.penalizedPathways[errorPathway] = performance.now();
            if (!pathwayPriority && levels) // If PATHWAY-PRIORITY was not provided, list pathways for error handling
            pathwayPriority = this.pathways();
            if (pathwayPriority && pathwayPriority.length > 1) {
                this.updatePathwayPriority(pathwayPriority);
                errorAction.resolved = this.pathwayId !== errorPathway;
            }
            if (data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR && !data.fatal) // Error will become fatal in buffer-controller when reaching `appendErrorMaxRetry`
            // Stream-controllers are expected to reduce buffer length even if this is not deemed a QuotaExceededError
            errorAction.resolved = true;
            else if (!errorAction.resolved) this.warn(`Could not resolve ${data.details} ("${data.error.message}") with content-steering for Pathway: ${errorPathway} levels: ${levels ? levels.length : levels} priorities: ${$b941786f4eb9cb76$var$stringify(pathwayPriority)} penalized: ${$b941786f4eb9cb76$var$stringify(this.penalizedPathways)}`);
        }
    }
    filterParsedLevels(levels) {
        // Filter levels to only include those that are in the initial pathway
        this.levels = levels;
        let pathwayLevels = this.getLevelsForPathway(this.pathwayId);
        if (pathwayLevels.length === 0) {
            const pathwayId = levels[0].pathwayId;
            this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${pathwayId}"`);
            pathwayLevels = this.getLevelsForPathway(pathwayId);
            this.pathwayId = pathwayId;
        }
        if (pathwayLevels.length !== levels.length) this.log(`Found ${pathwayLevels.length}/${levels.length} levels in Pathway "${this.pathwayId}"`);
        return pathwayLevels;
    }
    getLevelsForPathway(pathwayId) {
        if (this.levels === null) return [];
        return this.levels.filter((level)=>pathwayId === level.pathwayId);
    }
    updatePathwayPriority(pathwayPriority) {
        this._pathwayPriority = pathwayPriority;
        let levels;
        // Evaluate if we should remove the pathway from the penalized list
        const penalizedPathways = this.penalizedPathways;
        const now = performance.now();
        Object.keys(penalizedPathways).forEach((pathwayId)=>{
            if (now - penalizedPathways[pathwayId] > $b941786f4eb9cb76$var$PATHWAY_PENALTY_DURATION_MS) delete penalizedPathways[pathwayId];
        });
        for(let i = 0; i < pathwayPriority.length; i++){
            const pathwayId = pathwayPriority[i];
            if (pathwayId in penalizedPathways) continue;
            if (pathwayId === this.pathwayId) return;
            const selectedIndex = this.hls.nextLoadLevel;
            const selectedLevel = this.hls.levels[selectedIndex];
            levels = this.getLevelsForPathway(pathwayId);
            if (levels.length > 0) {
                this.log(`Setting Pathway to "${pathwayId}"`);
                this.pathwayId = pathwayId;
                $b941786f4eb9cb76$var$reassignFragmentLevelIndexes(levels);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, {
                    levels: levels
                });
                // Set LevelController's level to trigger LEVEL_SWITCHING which loads playlist if needed
                const levelAfterChange = this.hls.levels[selectedIndex];
                if (selectedLevel && levelAfterChange && this.levels) {
                    if (levelAfterChange.attrs['STABLE-VARIANT-ID'] !== selectedLevel.attrs['STABLE-VARIANT-ID'] && levelAfterChange.bitrate !== selectedLevel.bitrate) this.log(`Unstable Pathways change from bitrate ${selectedLevel.bitrate} to ${levelAfterChange.bitrate}`);
                    this.hls.nextLoadLevel = selectedIndex;
                }
                break;
            }
        }
    }
    getPathwayForGroupId(groupId, type, defaultPathway) {
        const levels = this.getLevelsForPathway(defaultPathway).concat(this.levels || []);
        for(let i = 0; i < levels.length; i++){
            if (type === $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK && levels[i].hasAudioGroup(groupId) || type === $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK && levels[i].hasSubtitleGroup(groupId)) return levels[i].pathwayId;
        }
        return defaultPathway;
    }
    clonePathways(pathwayClones) {
        const levels = this.levels;
        if (!levels) return;
        const audioGroupCloneMap = {};
        const subtitleGroupCloneMap = {};
        pathwayClones.forEach((pathwayClone)=>{
            const { ID: cloneId, 'BASE-ID': baseId, 'URI-REPLACEMENT': uriReplacement } = pathwayClone;
            if (levels.some((level)=>level.pathwayId === cloneId)) return;
            const clonedVariants = this.getLevelsForPathway(baseId).map((baseLevel)=>{
                const attributes = new $b941786f4eb9cb76$export$3b2a5864ee72b619(baseLevel.attrs);
                attributes['PATHWAY-ID'] = cloneId;
                const clonedAudioGroupId = attributes.AUDIO && `${attributes.AUDIO}_clone_${cloneId}`;
                const clonedSubtitleGroupId = attributes.SUBTITLES && `${attributes.SUBTITLES}_clone_${cloneId}`;
                if (clonedAudioGroupId) {
                    audioGroupCloneMap[attributes.AUDIO] = clonedAudioGroupId;
                    attributes.AUDIO = clonedAudioGroupId;
                }
                if (clonedSubtitleGroupId) {
                    subtitleGroupCloneMap[attributes.SUBTITLES] = clonedSubtitleGroupId;
                    attributes.SUBTITLES = clonedSubtitleGroupId;
                }
                const url = $b941786f4eb9cb76$var$performUriReplacement(baseLevel.uri, attributes['STABLE-VARIANT-ID'], 'PER-VARIANT-URIS', uriReplacement);
                const clonedLevel = new $b941786f4eb9cb76$export$ca664994d1d54bff({
                    attrs: attributes,
                    audioCodec: baseLevel.audioCodec,
                    bitrate: baseLevel.bitrate,
                    height: baseLevel.height,
                    name: baseLevel.name,
                    url: url,
                    videoCodec: baseLevel.videoCodec,
                    width: baseLevel.width
                });
                if (baseLevel.audioGroups) for(let i = 1; i < baseLevel.audioGroups.length; i++)clonedLevel.addGroupId('audio', `${baseLevel.audioGroups[i]}_clone_${cloneId}`);
                if (baseLevel.subtitleGroups) for(let i = 1; i < baseLevel.subtitleGroups.length; i++)clonedLevel.addGroupId('text', `${baseLevel.subtitleGroups[i]}_clone_${cloneId}`);
                return clonedLevel;
            });
            levels.push(...clonedVariants);
            $b941786f4eb9cb76$var$cloneRenditionGroups(this.audioTracks, audioGroupCloneMap, uriReplacement, cloneId);
            $b941786f4eb9cb76$var$cloneRenditionGroups(this.subtitleTracks, subtitleGroupCloneMap, uriReplacement, cloneId);
        });
    }
    loadSteeringManifest(uri) {
        const config = this.hls.config;
        const Loader = config.loader;
        if (this.loader) this.loader.destroy();
        this.loader = new Loader(config);
        let url;
        try {
            url = new self.URL(uri);
        } catch (error) {
            this.enabled = false;
            this.log(`Failed to parse Steering Manifest URI: ${uri}`);
            return;
        }
        if (url.protocol !== 'data:') {
            const throughput = (this.hls.bandwidthEstimate || config.abrEwmaDefaultEstimate) | 0;
            url.searchParams.set('_HLS_pathway', this.pathwayId);
            url.searchParams.set('_HLS_throughput', '' + throughput);
        }
        const context = {
            responseType: 'json',
            url: url.href
        };
        const loadPolicy = config.steeringManifestLoadPolicy.default;
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const callbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                this.log(`Loaded steering manifest: "${url}"`);
                const steeringData = response.data;
                if ((steeringData == null ? void 0 : steeringData.VERSION) !== 1) {
                    this.log(`Steering VERSION ${steeringData.VERSION} not supported!`);
                    return;
                }
                this.updated = performance.now();
                this.timeToLoad = steeringData.TTL;
                const { 'RELOAD-URI': reloadUri, 'PATHWAY-CLONES': pathwayClones, 'PATHWAY-PRIORITY': pathwayPriority } = steeringData;
                if (reloadUri) try {
                    this.uri = new self.URL(reloadUri, url).href;
                } catch (error) {
                    this.enabled = false;
                    this.log(`Failed to parse Steering Manifest RELOAD-URI: ${reloadUri}`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url);
                if (pathwayClones) this.clonePathways(pathwayClones);
                const loadedSteeringData = {
                    steeringManifest: steeringData,
                    url: url.toString()
                };
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.STEERING_MANIFEST_LOADED, loadedSteeringData);
                if (pathwayPriority) this.updatePathwayPriority(pathwayPriority);
            },
            onError: (error, context, networkDetails, stats)=>{
                this.log(`Error loading steering manifest: ${error.code} ${error.text} (${context.url})`);
                this.stopLoad();
                if (error.code === 410) {
                    this.enabled = false;
                    this.log(`Steering manifest ${context.url} no longer available`);
                    return;
                }
                let ttl = this.timeToLoad * 1000;
                if (error.code === 429) {
                    const loader = this.loader;
                    if (typeof (loader == null ? void 0 : loader.getResponseHeader) === 'function') {
                        const retryAfter = loader.getResponseHeader('Retry-After');
                        if (retryAfter) ttl = parseFloat(retryAfter) * 1000;
                    }
                    this.log(`Steering manifest ${context.url} rate limited`);
                    return;
                }
                this.scheduleRefresh(this.uri || context.url, ttl);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.log(`Timeout loading steering manifest (${context.url})`);
                this.scheduleRefresh(this.uri || context.url);
            }
        };
        this.log(`Requesting steering manifest: ${url}`);
        this.loader.load(context, loaderConfig, callbacks);
    }
    scheduleRefresh(uri, ttlMs = this.timeToLoad * 1000) {
        this.clearTimeout();
        this.reloadTimer = self.setTimeout(()=>{
            var _this$hls;
            const media = (_this$hls = this.hls) == null ? void 0 : _this$hls.media;
            if (media && !media.ended) {
                this.loadSteeringManifest(uri);
                return;
            }
            this.scheduleRefresh(uri, this.timeToLoad * 1000);
        }, ttlMs);
    }
}
function $b941786f4eb9cb76$var$cloneRenditionGroups(tracks, groupCloneMap, uriReplacement, cloneId) {
    if (!tracks) return;
    Object.keys(groupCloneMap).forEach((audioGroupId)=>{
        const clonedTracks = tracks.filter((track)=>track.groupId === audioGroupId).map((track)=>{
            const clonedTrack = $b941786f4eb9cb76$var$_extends({}, track);
            clonedTrack.details = undefined;
            clonedTrack.attrs = new $b941786f4eb9cb76$export$3b2a5864ee72b619(clonedTrack.attrs);
            clonedTrack.url = clonedTrack.attrs.URI = $b941786f4eb9cb76$var$performUriReplacement(track.url, track.attrs['STABLE-RENDITION-ID'], 'PER-RENDITION-URIS', uriReplacement);
            clonedTrack.groupId = clonedTrack.attrs['GROUP-ID'] = groupCloneMap[audioGroupId];
            clonedTrack.attrs['PATHWAY-ID'] = cloneId;
            return clonedTrack;
        });
        tracks.push(...clonedTracks);
    });
}
function $b941786f4eb9cb76$var$performUriReplacement(uri, stableId, perOptionKey, uriReplacement) {
    const { HOST: host, PARAMS: params, [perOptionKey]: perOptionUris } = uriReplacement;
    let perVariantUri;
    if (stableId) {
        perVariantUri = perOptionUris == null ? void 0 : perOptionUris[stableId];
        if (perVariantUri) uri = perVariantUri;
    }
    const url = new self.URL(uri);
    if (host && !perVariantUri) url.host = host;
    if (params) Object.keys(params).sort().forEach((key)=>{
        if (key) url.searchParams.set(key, params[key]);
    });
    return url.href;
}
/**
 * Controller to deal with encrypted media extensions (EME)
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Encrypted_Media_Extensions_API
 *
 * @class
 * @constructor
 */ class $b941786f4eb9cb76$export$bd16919f25cf2fc5 extends $b941786f4eb9cb76$var$Logger {
    constructor(hls){
        super('eme', hls.logger);
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.mediaResolved = void 0;
        this.keyFormatPromise = null;
        this.keySystemAccessPromises = {};
        this._requestLicenseFailureCount = 0;
        this.mediaKeySessions = [];
        this.keyIdToKeySessionPromise = {};
        this.mediaKeys = null;
        this.setMediaKeysQueue = $b941786f4eb9cb76$export$bd16919f25cf2fc5.CDMCleanupPromise ? [
            $b941786f4eb9cb76$export$bd16919f25cf2fc5.CDMCleanupPromise
        ] : [];
        this.bannedKeyIds = {};
        this.onMediaEncrypted = (event)=>{
            const { initDataType: initDataType, initData: initData } = event;
            const logMessage = `"${event.type}" event: init data type: "${initDataType}"`;
            this.debug(logMessage);
            // Ignore event when initData is null
            if (initData === null) return;
            if (!this.keyFormatPromise) {
                let keySystems = Object.keys(this.keySystemAccessPromises);
                if (!keySystems.length) keySystems = $b941786f4eb9cb76$var$getKeySystemsForConfig(this.config);
                const keyFormats = keySystems.map($b941786f4eb9cb76$var$keySystemDomainToKeySystemFormat).filter((k)=>!!k);
                this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
            }
            this.keyFormatPromise.then((keySystemFormat)=>{
                const keySystem = $b941786f4eb9cb76$var$keySystemFormatToKeySystemDomain(keySystemFormat);
                if (initDataType !== 'sinf' || keySystem !== $b941786f4eb9cb76$export$1c7b21e05766136c.FAIRPLAY) {
                    this.log(`Ignoring "${event.type}" event with init data type: "${initDataType}" for selected key-system ${keySystem}`);
                    return;
                }
                // Match sinf keyId to playlist skd://keyId=
                let keyId;
                try {
                    const json = $b941786f4eb9cb76$var$bin2str(new Uint8Array(initData));
                    const sinf = $b941786f4eb9cb76$var$base64Decode(JSON.parse(json).sinf);
                    const tenc = $b941786f4eb9cb76$var$parseSinf(sinf);
                    if (!tenc) throw new Error(`'schm' box missing or not cbcs/cenc with schi > tenc`);
                    keyId = new Uint8Array(tenc.subarray(8, 24));
                } catch (error) {
                    this.warn(`${logMessage} Failed to parse sinf: ${error}`);
                    return;
                }
                const keyIdHex = $b941786f4eb9cb76$var$arrayToHex(keyId);
                const { keyIdToKeySessionPromise: keyIdToKeySessionPromise, mediaKeySessions: mediaKeySessions } = this;
                let keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex];
                for(let i = 0; i < mediaKeySessions.length; i++){
                    // Match playlist key
                    const keyContext = mediaKeySessions[i];
                    const decryptdata = keyContext.decryptdata;
                    if (!decryptdata.keyId) continue;
                    const oldKeyIdHex = $b941786f4eb9cb76$var$arrayToHex(decryptdata.keyId);
                    if ($b941786f4eb9cb76$var$arrayValuesMatch(keyId, decryptdata.keyId) || decryptdata.uri.replace(/-/g, '').indexOf(keyIdHex) !== -1) {
                        keySessionContextPromise = keyIdToKeySessionPromise[oldKeyIdHex];
                        if (!keySessionContextPromise) continue;
                        if (decryptdata.pssh) break;
                        delete keyIdToKeySessionPromise[oldKeyIdHex];
                        decryptdata.pssh = new Uint8Array(initData);
                        decryptdata.keyId = keyId;
                        keySessionContextPromise = keyIdToKeySessionPromise[keyIdHex] = keySessionContextPromise.then(()=>{
                            return this.generateRequestWithPreferredKeySession(keyContext, initDataType, initData, 'encrypted-event-key-match');
                        });
                        keySessionContextPromise.catch((error)=>this.handleError(error));
                        break;
                    }
                }
                if (!keySessionContextPromise) this.handleError(new Error(`Key ID ${keyIdHex} not encountered in playlist. Key-system sessions ${mediaKeySessions.length}.`));
            }).catch((error)=>this.handleError(error));
        };
        this.onWaitingForKey = (event)=>{
            this.log(`"${event.type}" event`);
        };
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    destroy() {
        this.onDestroying();
        this.onMediaDetached();
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.requestMediaKeySystemAccessFunc = null;
        config.licenseXhrSetup = config.licenseResponseCallback = undefined;
        config.drmSystems = config.drmSystemOptions = {};
        // @ts-ignore
        this.hls = this.config = this.keyIdToKeySessionPromise = null;
        // @ts-ignore
        this.onMediaEncrypted = this.onWaitingForKey = null;
    }
    registerListeners() {
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
    }
    unregisterListeners() {
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHED, this.onMediaDetached, this);
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
    }
    getLicenseServerUrl(keySystem) {
        const { drmSystems: drmSystems, widevineLicenseUrl: widevineLicenseUrl } = this.config;
        const keySystemConfiguration = drmSystems == null ? void 0 : drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.licenseUrl;
        // For backward compatibility
        if (keySystem === $b941786f4eb9cb76$export$1c7b21e05766136c.WIDEVINE && widevineLicenseUrl) return widevineLicenseUrl;
    }
    getLicenseServerUrlOrThrow(keySystem) {
        const url = this.getLicenseServerUrl(keySystem);
        if (url === undefined) throw new Error(`no license server URL configured for key-system "${keySystem}"`);
        return url;
    }
    getServerCertificateUrl(keySystem) {
        const { drmSystems: drmSystems } = this.config;
        const keySystemConfiguration = drmSystems == null ? void 0 : drmSystems[keySystem];
        if (keySystemConfiguration) return keySystemConfiguration.serverCertificateUrl;
        else this.log(`No Server Certificate in config.drmSystems["${keySystem}"]`);
    }
    attemptKeySystemAccess(keySystemsToAttempt) {
        const levels = this.hls.levels;
        const uniqueCodec = (value, i, a)=>!!value && a.indexOf(value) === i;
        const audioCodecs = levels.map((level)=>level.audioCodec).filter(uniqueCodec);
        const videoCodecs = levels.map((level)=>level.videoCodec).filter(uniqueCodec);
        if (audioCodecs.length + videoCodecs.length === 0) videoCodecs.push('avc1.42e01e');
        return new Promise((resolve, reject)=>{
            const attempt = (keySystems)=>{
                const keySystem = keySystems.shift();
                this.getMediaKeysPromise(keySystem, audioCodecs, videoCodecs).then((mediaKeys)=>resolve({
                        keySystem: keySystem,
                        mediaKeys: mediaKeys
                    })).catch((error)=>{
                    if (keySystems.length) attempt(keySystems);
                    else if (error instanceof $b941786f4eb9cb76$var$EMEKeyError) reject(error);
                    else reject(new $b941786f4eb9cb76$var$EMEKeyError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_NO_ACCESS,
                        error: error,
                        fatal: true
                    }, error.message));
                });
            };
            attempt(keySystemsToAttempt);
        });
    }
    requestMediaKeySystemAccess(keySystem, supportedConfigurations) {
        const { requestMediaKeySystemAccessFunc: requestMediaKeySystemAccessFunc } = this.config;
        if (!(typeof requestMediaKeySystemAccessFunc === 'function')) {
            let errMessage = `Configured requestMediaKeySystemAccess is not a function ${requestMediaKeySystemAccessFunc}`;
            if ($b941786f4eb9cb76$export$fd6ce47fe824665a === null && self.location.protocol === 'http:') errMessage = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`;
            return Promise.reject(new Error(errMessage));
        }
        return requestMediaKeySystemAccessFunc(keySystem, supportedConfigurations);
    }
    getMediaKeysPromise(keySystem, audioCodecs, videoCodecs) {
        var _keySystemAccessPromi;
        // This can throw, but is caught in event handler callpath
        const mediaKeySystemConfigs = $b941786f4eb9cb76$var$getSupportedMediaKeySystemConfigurations(keySystem, audioCodecs, videoCodecs, this.config.drmSystemOptions || {});
        let keySystemAccessPromises = this.keySystemAccessPromises[keySystem];
        let keySystemAccess = (_keySystemAccessPromi = keySystemAccessPromises) == null ? void 0 : _keySystemAccessPromi.keySystemAccess;
        if (!keySystemAccess) {
            this.log(`Requesting encrypted media "${keySystem}" key-system access with config: ${$b941786f4eb9cb76$var$stringify(mediaKeySystemConfigs)}`);
            keySystemAccess = this.requestMediaKeySystemAccess(keySystem, mediaKeySystemConfigs);
            const keySystemAccessPromisesNew = keySystemAccessPromises = this.keySystemAccessPromises[keySystem] = {
                keySystemAccess: keySystemAccess
            };
            keySystemAccess.catch((error)=>{
                this.log(`Failed to obtain access to key-system "${keySystem}": ${error}`);
            });
            return keySystemAccess.then((mediaKeySystemAccess)=>{
                this.log(`Access for key-system "${mediaKeySystemAccess.keySystem}" obtained`);
                const certificateRequest = this.fetchServerCertificate(keySystem);
                this.log(`Create media-keys for "${keySystem}"`);
                const mediaKeys = keySystemAccessPromisesNew.mediaKeys = mediaKeySystemAccess.createMediaKeys().then((mediaKeys)=>{
                    this.log(`Media-keys created for "${keySystem}"`);
                    keySystemAccessPromisesNew.hasMediaKeys = true;
                    return certificateRequest.then((certificate)=>{
                        if (certificate) return this.setMediaKeysServerCertificate(mediaKeys, keySystem, certificate);
                        return mediaKeys;
                    });
                });
                mediaKeys.catch((error)=>{
                    this.error(`Failed to create media-keys for "${keySystem}"}: ${error}`);
                });
                return mediaKeys;
            });
        }
        return keySystemAccess.then(()=>keySystemAccessPromises.mediaKeys);
    }
    createMediaKeySessionContext({ decryptdata: decryptdata, keySystem: keySystem, mediaKeys: mediaKeys }) {
        this.log(`Creating key-system session "${keySystem}" keyId: ${$b941786f4eb9cb76$var$arrayToHex(decryptdata.keyId || [])} keyUri: ${decryptdata.uri}`);
        const mediaKeysSession = mediaKeys.createSession();
        const mediaKeySessionContext = {
            decryptdata: decryptdata,
            keySystem: keySystem,
            mediaKeys: mediaKeys,
            mediaKeysSession: mediaKeysSession,
            keyStatus: 'status-pending'
        };
        this.mediaKeySessions.push(mediaKeySessionContext);
        return mediaKeySessionContext;
    }
    renewKeySession(mediaKeySessionContext) {
        const decryptdata = mediaKeySessionContext.decryptdata;
        if (decryptdata.pssh) {
            const keySessionContext = this.createMediaKeySessionContext(mediaKeySessionContext);
            const keyId = $b941786f4eb9cb76$var$getKeyIdString(decryptdata);
            const scheme = 'cenc';
            this.keyIdToKeySessionPromise[keyId] = this.generateRequestWithPreferredKeySession(keySessionContext, scheme, decryptdata.pssh.buffer, 'expired');
        } else this.warn(`Could not renew expired session. Missing pssh initData.`);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.removeSession(mediaKeySessionContext);
    }
    updateKeySession(mediaKeySessionContext, data) {
        const keySession = mediaKeySessionContext.mediaKeysSession;
        this.log(`Updating key-session "${keySession.sessionId}" for keyId ${$b941786f4eb9cb76$var$arrayToHex(mediaKeySessionContext.decryptdata.keyId || [])}
      } (data length: ${data.byteLength})`);
        return keySession.update(data);
    }
    getSelectedKeySystemFormats() {
        return Object.keys(this.keySystemAccessPromises).map((keySystem)=>({
                keySystem: keySystem,
                hasMediaKeys: this.keySystemAccessPromises[keySystem].hasMediaKeys
            })).filter(({ hasMediaKeys: hasMediaKeys })=>!!hasMediaKeys).map(({ keySystem: keySystem })=>$b941786f4eb9cb76$var$keySystemDomainToKeySystemFormat(keySystem)).filter((keySystem)=>!!keySystem);
    }
    getKeySystemAccess(keySystemsToAttempt) {
        return this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem: keySystem, mediaKeys: mediaKeys })=>{
            return this.attemptSetMediaKeys(keySystem, mediaKeys);
        });
    }
    selectKeySystem(keySystemsToAttempt) {
        return new Promise((resolve, reject)=>{
            this.getKeySystemSelectionPromise(keySystemsToAttempt).then(({ keySystem: keySystem })=>{
                const keySystemFormat = $b941786f4eb9cb76$var$keySystemDomainToKeySystemFormat(keySystem);
                if (keySystemFormat) resolve(keySystemFormat);
                else reject(new Error(`Unable to find format for key-system "${keySystem}"`));
            }).catch(reject);
        });
    }
    selectKeySystemFormat(frag) {
        const keyFormats = Object.keys(frag.levelkeys || {});
        if (!this.keyFormatPromise) {
            this.log(`Selecting key-system from fragment (sn: ${frag.sn} ${frag.type}: ${frag.level}) key formats ${keyFormats.join(', ')}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
        return this.keyFormatPromise;
    }
    getKeyFormatPromise(keyFormats) {
        const keySystemsInConfig = $b941786f4eb9cb76$var$getKeySystemsForConfig(this.config);
        const keySystemsToAttempt = keyFormats.map($b941786f4eb9cb76$var$keySystemFormatToKeySystemDomain).filter((value)=>!!value && keySystemsInConfig.indexOf(value) !== -1);
        return this.selectKeySystem(keySystemsToAttempt);
    }
    getKeyStatus(decryptdata) {
        const { mediaKeySessions: mediaKeySessions } = this;
        for(let i = 0; i < mediaKeySessions.length; i++){
            const status1 = $b941786f4eb9cb76$var$getKeyStatus(decryptdata, mediaKeySessions[i]);
            if (status1) return status1;
        }
        return undefined;
    }
    loadKey(data) {
        const decryptdata = data.keyInfo.decryptdata;
        const keyId = $b941786f4eb9cb76$var$getKeyIdString(decryptdata);
        const badStatus = this.bannedKeyIds[keyId];
        if (badStatus || this.getKeyStatus(decryptdata) === 'internal-error') {
            const error = $b941786f4eb9cb76$var$getKeyStatusError(badStatus || 'internal-error', decryptdata);
            this.handleError(error, data.frag);
            return Promise.reject(error);
        }
        const keyDetails = `(keyId: ${keyId} format: "${decryptdata.keyFormat}" method: ${decryptdata.method} uri: ${decryptdata.uri})`;
        this.log(`Starting session for key ${keyDetails}`);
        const keyContextPromise = this.keyIdToKeySessionPromise[keyId];
        if (!keyContextPromise) {
            const keySessionContextPromise = this.getKeySystemForKeyPromise(decryptdata).then(({ keySystem: keySystem, mediaKeys: mediaKeys })=>{
                this.throwIfDestroyed();
                this.log(`Handle encrypted media sn: ${data.frag.sn} ${data.frag.type}: ${data.frag.level} using key ${keyDetails}`);
                return this.attemptSetMediaKeys(keySystem, mediaKeys).then(()=>{
                    this.throwIfDestroyed();
                    return this.createMediaKeySessionContext({
                        keySystem: keySystem,
                        mediaKeys: mediaKeys,
                        decryptdata: decryptdata
                    });
                });
            }).then((keySessionContext)=>{
                const scheme = 'cenc';
                const initData = decryptdata.pssh ? decryptdata.pssh.buffer : null;
                return this.generateRequestWithPreferredKeySession(keySessionContext, scheme, initData, 'playlist-key');
            });
            keySessionContextPromise.catch((error)=>this.handleError(error, data.frag));
            this.keyIdToKeySessionPromise[keyId] = keySessionContextPromise;
            return keySessionContextPromise;
        }
        // Re-emit error for playlist key loading
        keyContextPromise.catch((error)=>{
            if (error instanceof $b941786f4eb9cb76$var$EMEKeyError) {
                const errorData = $b941786f4eb9cb76$var$_objectSpread2({}, error.data);
                if (this.getKeyStatus(decryptdata) === 'internal-error') errorData.decryptdata = decryptdata;
                const clonedError = new $b941786f4eb9cb76$var$EMEKeyError(errorData, error.message);
                this.handleError(clonedError, data.frag);
            }
        });
        return keyContextPromise;
    }
    throwIfDestroyed(message = 'Invalid state') {
        if (!this.hls) throw new Error('invalid state');
    }
    handleError(error, frag) {
        if (!this.hls) return;
        if (error instanceof $b941786f4eb9cb76$var$EMEKeyError) {
            if (frag) error.data.frag = frag;
            const levelKey = error.data.decryptdata;
            this.error(`${error.message}${levelKey ? ` (${$b941786f4eb9cb76$var$arrayToHex(levelKey.keyId || [])})` : ''}`);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, error.data);
        } else {
            this.error(error.message);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_NO_KEYS,
                error: error,
                fatal: true
            });
        }
    }
    getKeySystemForKeyPromise(decryptdata) {
        const keyId = $b941786f4eb9cb76$var$getKeyIdString(decryptdata);
        const mediaKeySessionContext = this.keyIdToKeySessionPromise[keyId];
        if (!mediaKeySessionContext) {
            const keySystem = $b941786f4eb9cb76$var$keySystemFormatToKeySystemDomain(decryptdata.keyFormat);
            const keySystemsToAttempt = keySystem ? [
                keySystem
            ] : $b941786f4eb9cb76$var$getKeySystemsForConfig(this.config);
            return this.attemptKeySystemAccess(keySystemsToAttempt);
        }
        return mediaKeySessionContext;
    }
    getKeySystemSelectionPromise(keySystemsToAttempt) {
        if (!keySystemsToAttempt.length) keySystemsToAttempt = $b941786f4eb9cb76$var$getKeySystemsForConfig(this.config);
        if (keySystemsToAttempt.length === 0) throw new $b941786f4eb9cb76$var$EMEKeyError({
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
            details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
            fatal: true
        }, `Missing key-system license configuration options ${$b941786f4eb9cb76$var$stringify({
            drmSystems: this.config.drmSystems
        })}`);
        return this.attemptKeySystemAccess(keySystemsToAttempt);
    }
    attemptSetMediaKeys(keySystem, mediaKeys) {
        this.mediaResolved = undefined;
        if (this.mediaKeys === mediaKeys) return Promise.resolve();
        const queue = this.setMediaKeysQueue.slice();
        this.log(`Setting media-keys for "${keySystem}"`);
        // Only one setMediaKeys() can run at one time, and multiple setMediaKeys() operations
        // can be queued for execution for multiple key sessions.
        const setMediaKeysPromise = Promise.all(queue).then(()=>{
            if (!this.media) return new Promise((resolve, reject)=>{
                this.mediaResolved = ()=>{
                    this.mediaResolved = undefined;
                    if (!this.media) return reject(new Error('Attempted to set mediaKeys without media element attached'));
                    this.mediaKeys = mediaKeys;
                    this.media.setMediaKeys(mediaKeys).then(resolve).catch(reject);
                };
            });
            return this.media.setMediaKeys(mediaKeys);
        });
        this.mediaKeys = mediaKeys;
        this.setMediaKeysQueue.push(setMediaKeysPromise);
        return setMediaKeysPromise.then(()=>{
            this.log(`Media-keys set for "${keySystem}"`);
            queue.push(setMediaKeysPromise);
            this.setMediaKeysQueue = this.setMediaKeysQueue.filter((p)=>queue.indexOf(p) === -1);
        });
    }
    generateRequestWithPreferredKeySession(context, initDataType, initData, reason) {
        var _this$config$drmSyste;
        const generateRequestFilter = (_this$config$drmSyste = this.config.drmSystems) == null || (_this$config$drmSyste = _this$config$drmSyste[context.keySystem]) == null ? void 0 : _this$config$drmSyste.generateRequest;
        if (generateRequestFilter) try {
            const mappedInitData = generateRequestFilter.call(this.hls, initDataType, initData, context);
            if (!mappedInitData) throw new Error('Invalid response from configured generateRequest filter');
            initDataType = mappedInitData.initDataType;
            initData = mappedInitData.initData ? mappedInitData.initData : null;
            context.decryptdata.pssh = initData ? new Uint8Array(initData) : null;
        } catch (error) {
            this.warn(error.message);
            if (this.hls && this.hls.config.debug) throw error;
        }
        if (initData === null) {
            this.log(`Skipping key-session request for "${reason}" (no initData)`);
            return Promise.resolve(context);
        }
        const keyId = $b941786f4eb9cb76$var$getKeyIdString(context.decryptdata);
        const keyUri = context.decryptdata.uri;
        this.log(`Generating key-session request for "${reason}" keyId: ${keyId} URI: ${keyUri} (init data type: ${initDataType} length: ${initData.byteLength})`);
        const licenseStatus = new $b941786f4eb9cb76$var$EventEmitter();
        const onmessage = context._onmessage = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit('error', new Error('invalid state'));
                return;
            }
            const { messageType: messageType, message: message } = event;
            this.log(`"${messageType}" message event for session "${keySession.sessionId}" message size: ${message.byteLength}`);
            if (messageType === 'license-request' || messageType === 'license-renewal') this.renewLicense(context, message).catch((error)=>{
                if (licenseStatus.eventNames().length) licenseStatus.emit('error', error);
                else this.handleError(error);
            });
            else if (messageType === 'license-release') {
                if (context.keySystem === $b941786f4eb9cb76$export$1c7b21e05766136c.FAIRPLAY) this.updateKeySession(context, $b941786f4eb9cb76$var$strToUtf8array('acknowledged')).then(()=>this.removeSession(context)).catch((error)=>this.handleError(error));
            } else this.warn(`unhandled media key message type "${messageType}"`);
        };
        const handleKeyStatus = (keyStatus, context)=>{
            context.keyStatus = keyStatus;
            let keyError;
            if (keyStatus.startsWith('usable')) licenseStatus.emit('resolved');
            else if (keyStatus === 'internal-error' || keyStatus === 'output-restricted' || keyStatus === 'output-downscaled') keyError = $b941786f4eb9cb76$var$getKeyStatusError(keyStatus, context.decryptdata);
            else if (keyStatus === 'expired') keyError = new Error(`key expired (keyId: ${keyId})`);
            else if (keyStatus === 'released') keyError = new Error(`key released`);
            else if (keyStatus === 'status-pending') ;
            else this.warn(`unhandled key status change "${keyStatus}" (keyId: ${keyId})`);
            if (keyError) {
                if (licenseStatus.eventNames().length) licenseStatus.emit('error', keyError);
                else this.handleError(keyError);
            }
        };
        const onkeystatuseschange = context._onkeystatuseschange = (event)=>{
            const keySession = context.mediaKeysSession;
            if (!keySession) {
                licenseStatus.emit('error', new Error('invalid state'));
                return;
            }
            const keyStatuses = this.getKeyStatuses(context);
            const keyIds = Object.keys(keyStatuses);
            // exit if all keys are status-pending
            if (!keyIds.some((id)=>keyStatuses[id] !== 'status-pending')) return;
            // renew when a key status for a levelKey comes back expired
            if (keyStatuses[keyId] === 'expired') {
                // renew when a key status comes back expired
                this.log(`Expired key ${$b941786f4eb9cb76$var$stringify(keyStatuses)} in key-session "${context.mediaKeysSession.sessionId}"`);
                this.renewKeySession(context);
                return;
            }
            let keyStatus = keyStatuses[keyId];
            if (keyStatus) // handle status of current key
            handleKeyStatus(keyStatus, context);
            else {
                var _context$keyStatusTim;
                // Timeout key-status
                const timeout = 1000;
                context.keyStatusTimeouts || (context.keyStatusTimeouts = {});
                (_context$keyStatusTim = context.keyStatusTimeouts)[keyId] || (_context$keyStatusTim[keyId] = self.setTimeout(()=>{
                    if (!context.mediaKeysSession || !this.mediaKeys) return;
                    // Find key status in another session if missing (PlayReady #7519 no key-status "single-key" setup with shared key)
                    const sessionKeyStatus = this.getKeyStatus(context.decryptdata);
                    if (sessionKeyStatus && sessionKeyStatus !== 'status-pending') {
                        this.log(`No status for keyId ${keyId} in key-session "${context.mediaKeysSession.sessionId}". Using session key-status ${sessionKeyStatus} from other session.`);
                        return handleKeyStatus(sessionKeyStatus, context);
                    }
                    // Timeout key with internal-error
                    this.log(`key status for ${keyId} in key-session "${context.mediaKeysSession.sessionId}" timed out after ${timeout}ms`);
                    keyStatus = 'internal-error';
                    handleKeyStatus(keyStatus, context);
                }, timeout));
                this.log(`No status for keyId ${keyId} (${$b941786f4eb9cb76$var$stringify(keyStatuses)}).`);
            }
        };
        $b941786f4eb9cb76$var$addEventListener(context.mediaKeysSession, 'message', onmessage);
        $b941786f4eb9cb76$var$addEventListener(context.mediaKeysSession, 'keystatuseschange', onkeystatuseschange);
        const keyUsablePromise = new Promise((resolve, reject)=>{
            licenseStatus.on('error', reject);
            licenseStatus.on('resolved', resolve);
        });
        return context.mediaKeysSession.generateRequest(initDataType, initData).then(()=>{
            this.log(`Request generated for key-session "${context.mediaKeysSession.sessionId}" keyId: ${keyId} URI: ${keyUri}`);
        }).catch((error)=>{
            throw new $b941786f4eb9cb76$var$EMEKeyError({
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_NO_SESSION,
                error: error,
                decryptdata: context.decryptdata,
                fatal: false
            }, `Error generating key-session request: ${error}`);
        }).then(()=>keyUsablePromise).catch((error)=>{
            licenseStatus.removeAllListeners();
            return this.removeSession(context).then(()=>{
                throw error;
            });
        }).then(()=>{
            licenseStatus.removeAllListeners();
            return context;
        });
    }
    getKeyStatuses(mediaKeySessionContext) {
        const keyStatuses = {};
        mediaKeySessionContext.mediaKeysSession.keyStatuses.forEach((status1, keyId)=>{
            // keyStatuses.forEach is not standard API so the callback value looks weird on xboxone
            // xboxone callback(keyId, status) so we need to exchange them
            if (typeof keyId === 'string' && typeof status1 === 'object') {
                const temp = keyId;
                keyId = status1;
                status1 = temp;
            }
            const keyIdArray = 'buffer' in keyId ? new Uint8Array(keyId.buffer, keyId.byteOffset, keyId.byteLength) : new Uint8Array(keyId);
            if (mediaKeySessionContext.keySystem === $b941786f4eb9cb76$export$1c7b21e05766136c.PLAYREADY && keyIdArray.length === 16) {
                // On some devices, the key ID has already been converted for endianness.
                // In such cases, this key ID is the one we need to cache.
                const originKeyIdWithStatusChange = $b941786f4eb9cb76$var$arrayToHex(keyIdArray);
                // Cache the original key IDs to ensure compatibility across all cases.
                keyStatuses[originKeyIdWithStatusChange] = status1;
                $b941786f4eb9cb76$var$changeEndianness(keyIdArray);
            }
            const keyIdWithStatusChange = $b941786f4eb9cb76$var$arrayToHex(keyIdArray);
            // Add to banned keys to prevent playlist usage and license requests
            if (status1 === 'internal-error') this.bannedKeyIds[keyIdWithStatusChange] = status1;
            this.log(`key status change "${status1}" for keyStatuses keyId: ${keyIdWithStatusChange} key-session "${mediaKeySessionContext.mediaKeysSession.sessionId}"`);
            keyStatuses[keyIdWithStatusChange] = status1;
        });
        return keyStatuses;
    }
    fetchServerCertificate(keySystem) {
        const config = this.config;
        const Loader = config.loader;
        const certLoader = new Loader(config);
        const url = this.getServerCertificateUrl(keySystem);
        if (!url) return Promise.resolve();
        this.log(`Fetching server certificate for "${keySystem}"`);
        return new Promise((resolve, reject)=>{
            const loaderContext = {
                responseType: 'arraybuffer',
                url: url
            };
            const loadPolicy = config.certLoadPolicy.default;
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    resolve(response.data);
                },
                onError: (response, contex, networkDetails, stats)=>{
                    reject(new $b941786f4eb9cb76$var$EMEKeyError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails: networkDetails,
                        response: $b941786f4eb9cb76$var$_objectSpread2({
                            url: loaderContext.url,
                            data: undefined
                        }, response)
                    }, `"${keySystem}" certificate request failed (${url}). Status: ${response.code} (${response.text})`));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    reject(new $b941786f4eb9cb76$var$EMEKeyError({
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
                        fatal: true,
                        networkDetails: networkDetails,
                        response: {
                            url: loaderContext.url,
                            data: undefined
                        }
                    }, `"${keySystem}" certificate request timed out (${url})`));
                },
                onAbort: (stats, context, networkDetails)=>{
                    reject(new Error('aborted'));
                }
            };
            certLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    setMediaKeysServerCertificate(mediaKeys, keySystem, cert) {
        return new Promise((resolve, reject)=>{
            mediaKeys.setServerCertificate(cert).then((success)=>{
                this.log(`setServerCertificate ${success ? 'success' : 'not supported by CDM'} (${cert.byteLength}) on "${keySystem}"`);
                resolve(mediaKeys);
            }).catch((error)=>{
                reject(new $b941786f4eb9cb76$var$EMEKeyError({
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
                    error: error,
                    fatal: true
                }, error.message));
            });
        });
    }
    renewLicense(context, keyMessage) {
        return this.requestLicense(context, new Uint8Array(keyMessage)).then((data)=>{
            return this.updateKeySession(context, new Uint8Array(data)).catch((error)=>{
                throw new $b941786f4eb9cb76$var$EMEKeyError({
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_SESSION_UPDATE_FAILED,
                    decryptdata: context.decryptdata,
                    error: error,
                    fatal: false
                }, error.message);
            });
        });
    }
    unpackPlayReadyKeyMessage(xhr, licenseChallenge) {
        // On Edge, the raw license message is UTF-16-encoded XML.  We need
        // to unpack the Challenge element (base64-encoded string containing the
        // actual license request) and any HttpHeader elements (sent as request
        // headers).
        // For PlayReady CDMs, we need to dig the Challenge out of the XML.
        const xmlString = String.fromCharCode.apply(null, new Uint16Array(licenseChallenge.buffer));
        if (!xmlString.includes('PlayReadyKeyMessage')) {
            // This does not appear to be a wrapped message as on Edge.  Some
            // clients do not need this unwrapping, so we will assume this is one of
            // them.  Note that "xml" at this point probably looks like random
            // garbage, since we interpreted UTF-8 as UTF-16.
            xhr.setRequestHeader('Content-Type', 'text/xml; charset=utf-8');
            return licenseChallenge;
        }
        const keyMessageXml = new DOMParser().parseFromString(xmlString, 'application/xml');
        // Set request headers.
        const headers = keyMessageXml.querySelectorAll('HttpHeader');
        if (headers.length > 0) {
            let header;
            for(let i = 0, len = headers.length; i < len; i++){
                var _header$querySelector, _header$querySelector2;
                header = headers[i];
                const name = (_header$querySelector = header.querySelector('name')) == null ? void 0 : _header$querySelector.textContent;
                const value = (_header$querySelector2 = header.querySelector('value')) == null ? void 0 : _header$querySelector2.textContent;
                if (name && value) xhr.setRequestHeader(name, value);
            }
        }
        const challengeElement = keyMessageXml.querySelector('Challenge');
        const challengeText = challengeElement == null ? void 0 : challengeElement.textContent;
        if (!challengeText) throw new Error(`Cannot find <Challenge> in key message`);
        return $b941786f4eb9cb76$var$strToUtf8array(atob(challengeText));
    }
    setupLicenseXHR(xhr, url, keysListItem, licenseChallenge) {
        const licenseXhrSetup = this.config.licenseXhrSetup;
        if (!licenseXhrSetup) {
            xhr.open('POST', url, true);
            return Promise.resolve({
                xhr: xhr,
                licenseChallenge: licenseChallenge
            });
        }
        return Promise.resolve().then(()=>{
            if (!keysListItem.decryptdata) throw new Error('Key removed');
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).catch((error)=>{
            if (!keysListItem.decryptdata) // Key session removed. Cancel license request.
            throw error;
            // let's try to open before running setup
            xhr.open('POST', url, true);
            return licenseXhrSetup.call(this.hls, xhr, url, keysListItem, licenseChallenge);
        }).then((licenseXhrSetupResult)=>{
            // if licenseXhrSetup did not yet call open, let's do it now
            if (!xhr.readyState) xhr.open('POST', url, true);
            const finalLicenseChallenge = licenseXhrSetupResult ? licenseXhrSetupResult : licenseChallenge;
            return {
                xhr: xhr,
                licenseChallenge: finalLicenseChallenge
            };
        });
    }
    requestLicense(keySessionContext, licenseChallenge) {
        const keyLoadPolicy = this.config.keyLoadPolicy.default;
        return new Promise((resolve, reject)=>{
            const url = this.getLicenseServerUrlOrThrow(keySessionContext.keySystem);
            this.log(`Sending license request to URL: ${url}`);
            const xhr = new XMLHttpRequest();
            xhr.responseType = 'arraybuffer';
            xhr.onreadystatechange = ()=>{
                if (!this.hls || !keySessionContext.mediaKeysSession) return reject(new Error('invalid state'));
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        this._requestLicenseFailureCount = 0;
                        let data = xhr.response;
                        this.log(`License received ${data instanceof ArrayBuffer ? data.byteLength : data}`);
                        const licenseResponseCallback = this.config.licenseResponseCallback;
                        if (licenseResponseCallback) try {
                            data = licenseResponseCallback.call(this.hls, xhr, url, keySessionContext);
                        } catch (error) {
                            this.error(error);
                        }
                        resolve(data);
                    } else {
                        const retryConfig = keyLoadPolicy.errorRetry;
                        const maxNumRetry = retryConfig ? retryConfig.maxNumRetry : 0;
                        this._requestLicenseFailureCount++;
                        if (this._requestLicenseFailureCount > maxNumRetry || xhr.status >= 400 && xhr.status < 500) reject(new $b941786f4eb9cb76$var$EMEKeyError({
                            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
                            details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                            decryptdata: keySessionContext.decryptdata,
                            fatal: true,
                            networkDetails: xhr,
                            response: {
                                url: url,
                                data: undefined,
                                code: xhr.status,
                                text: xhr.statusText
                            }
                        }, `License Request XHR failed (${url}). Status: ${xhr.status} (${xhr.statusText})`));
                        else {
                            const attemptsLeft = maxNumRetry - this._requestLicenseFailureCount + 1;
                            this.warn(`Retrying license request, ${attemptsLeft} attempts left`);
                            this.requestLicense(keySessionContext, licenseChallenge).then(resolve, reject);
                        }
                    }
                }
            };
            if (keySessionContext.licenseXhr && keySessionContext.licenseXhr.readyState !== XMLHttpRequest.DONE) keySessionContext.licenseXhr.abort();
            keySessionContext.licenseXhr = xhr;
            this.setupLicenseXHR(xhr, url, keySessionContext, licenseChallenge).then(({ xhr: xhr, licenseChallenge: licenseChallenge })=>{
                if (keySessionContext.keySystem == $b941786f4eb9cb76$export$1c7b21e05766136c.PLAYREADY) licenseChallenge = this.unpackPlayReadyKeyMessage(xhr, licenseChallenge);
                xhr.send(licenseChallenge);
            }).catch(reject);
        });
    }
    onDestroying() {
        this.unregisterListeners();
        this._clear();
    }
    onMediaAttached(event, data) {
        if (!this.config.emeEnabled) return;
        const media = data.media;
        // keep reference of media
        this.media = media;
        $b941786f4eb9cb76$var$addEventListener(media, 'encrypted', this.onMediaEncrypted);
        $b941786f4eb9cb76$var$addEventListener(media, 'waitingforkey', this.onWaitingForKey);
        const mediaResolved = this.mediaResolved;
        if (mediaResolved) mediaResolved();
        else this.mediaKeys = media.mediaKeys;
    }
    onMediaDetached() {
        const media = this.media;
        if (media) {
            $b941786f4eb9cb76$var$removeEventListener(media, 'encrypted', this.onMediaEncrypted);
            $b941786f4eb9cb76$var$removeEventListener(media, 'waitingforkey', this.onWaitingForKey);
            this.media = null;
            this.mediaKeys = null;
        }
    }
    _clear() {
        var _media$setMediaKeys;
        this._requestLicenseFailureCount = 0;
        this.keyIdToKeySessionPromise = {};
        this.bannedKeyIds = {};
        const mediaResolved = this.mediaResolved;
        if (mediaResolved) mediaResolved();
        if (!this.mediaKeys && !this.mediaKeySessions.length) return;
        const media = this.media;
        const mediaKeysList = this.mediaKeySessions.slice();
        this.mediaKeySessions = [];
        this.mediaKeys = null;
        $b941786f4eb9cb76$export$ca24892a09b21f29.clearKeyUriToKeyIdMap();
        // Close all sessions and remove media keys from the video element.
        const keySessionCount = mediaKeysList.length;
        $b941786f4eb9cb76$export$bd16919f25cf2fc5.CDMCleanupPromise = Promise.all(mediaKeysList.map((mediaKeySessionContext)=>this.removeSession(mediaKeySessionContext)).concat((media == null || (_media$setMediaKeys = media.setMediaKeys(null)) == null ? void 0 : _media$setMediaKeys.catch((error)=>{
            this.log(`Could not clear media keys: ${error}`);
            if (!this.hls) return;
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR,
                fatal: false,
                error: new Error(`Could not clear media keys: ${error}`)
            });
        })) || Promise.resolve())).catch((error)=>{
            this.log(`Could not close sessions and clear media keys: ${error}`);
            if (!this.hls) return;
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
                fatal: false,
                error: new Error(`Could not close sessions and clear media keys: ${error}`)
            });
        }).then(()=>{
            if (keySessionCount) this.log('finished closing key sessions and clearing media keys');
        });
    }
    onManifestLoading() {
        this._clear();
    }
    onManifestLoaded(event, { sessionKeys: sessionKeys }) {
        if (!sessionKeys || !this.config.emeEnabled) return;
        if (!this.keyFormatPromise) {
            const keyFormats = sessionKeys.reduce((formats, sessionKey)=>{
                if (formats.indexOf(sessionKey.keyFormat) === -1) formats.push(sessionKey.keyFormat);
                return formats;
            }, []);
            this.log(`Selecting key-system from session-keys ${keyFormats.join(', ')}`);
            this.keyFormatPromise = this.getKeyFormatPromise(keyFormats);
        }
    }
    removeSession(mediaKeySessionContext) {
        const { mediaKeysSession: mediaKeysSession, licenseXhr: licenseXhr, decryptdata: decryptdata } = mediaKeySessionContext;
        if (mediaKeysSession) {
            this.log(`Remove licenses and keys and close session "${mediaKeysSession.sessionId}" keyId: ${$b941786f4eb9cb76$var$arrayToHex((decryptdata == null ? void 0 : decryptdata.keyId) || [])}`);
            if (mediaKeySessionContext._onmessage) {
                mediaKeysSession.removeEventListener('message', mediaKeySessionContext._onmessage);
                mediaKeySessionContext._onmessage = undefined;
            }
            if (mediaKeySessionContext._onkeystatuseschange) {
                mediaKeysSession.removeEventListener('keystatuseschange', mediaKeySessionContext._onkeystatuseschange);
                mediaKeySessionContext._onkeystatuseschange = undefined;
            }
            if (licenseXhr && licenseXhr.readyState !== XMLHttpRequest.DONE) licenseXhr.abort();
            mediaKeySessionContext.mediaKeysSession = mediaKeySessionContext.decryptdata = mediaKeySessionContext.licenseXhr = undefined;
            const index = this.mediaKeySessions.indexOf(mediaKeySessionContext);
            if (index > -1) this.mediaKeySessions.splice(index, 1);
            const { keyStatusTimeouts: keyStatusTimeouts } = mediaKeySessionContext;
            if (keyStatusTimeouts) Object.keys(keyStatusTimeouts).forEach((keyId)=>self.clearTimeout(keyStatusTimeouts[keyId]));
            const { drmSystemOptions: drmSystemOptions } = this.config;
            const removePromise = $b941786f4eb9cb76$var$isPersistentSessionType(drmSystemOptions) ? new Promise((resolve, reject)=>{
                self.setTimeout(()=>reject(new Error(`MediaKeySession.remove() timeout`)), 8000);
                mediaKeysSession.remove().then(resolve).catch(reject);
            }) : Promise.resolve();
            return removePromise.catch((error)=>{
                this.log(`Could not remove session: ${error}`);
                if (!this.hls) return;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR,
                    fatal: false,
                    error: new Error(`Could not remove session: ${error}`)
                });
            }).then(()=>{
                return mediaKeysSession.close();
            }).catch((error)=>{
                this.log(`Could not close session: ${error}`);
                if (!this.hls) return;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
                    fatal: false,
                    error: new Error(`Could not close session: ${error}`)
                });
            });
        }
        return Promise.resolve();
    }
}
$b941786f4eb9cb76$export$bd16919f25cf2fc5.CDMCleanupPromise = void 0;
function $b941786f4eb9cb76$var$getKeyIdString(decryptdata) {
    if (!decryptdata) throw new Error('Could not read keyId of undefined decryptdata');
    if (decryptdata.keyId === null) throw new Error('keyId is null');
    return $b941786f4eb9cb76$var$arrayToHex(decryptdata.keyId);
}
function $b941786f4eb9cb76$var$getKeyStatus(decryptdata, keyContext) {
    if (decryptdata.keyId && keyContext.mediaKeysSession.keyStatuses.has(decryptdata.keyId)) return keyContext.mediaKeysSession.keyStatuses.get(decryptdata.keyId);
    if (decryptdata.matches(keyContext.decryptdata)) return keyContext.keyStatus;
    return undefined;
}
class $b941786f4eb9cb76$var$EMEKeyError extends Error {
    constructor(data, message){
        super(message);
        this.data = void 0;
        data.error || (data.error = new Error(message));
        this.data = data;
        data.err = data.error;
    }
}
function $b941786f4eb9cb76$var$getKeyStatusError(keyStatus, decryptdata) {
    const outputRestricted = keyStatus === 'output-restricted';
    const details = outputRestricted ? $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED : $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_SYSTEM_STATUS_INTERNAL_ERROR;
    return new $b941786f4eb9cb76$var$EMEKeyError({
        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.KEY_SYSTEM_ERROR,
        details: details,
        fatal: false,
        decryptdata: decryptdata
    }, outputRestricted ? 'HDCP level output restricted' : `key status changed to "${keyStatus}"`);
}
class $b941786f4eb9cb76$export$ca3da7ea73955a38 {
    constructor(hls){
        this.hls = void 0;
        this.isVideoPlaybackQualityAvailable = false;
        this.timer = void 0;
        this.media = null;
        this.lastTime = void 0;
        this.lastDroppedFrames = 0;
        this.lastDecodedFrames = 0;
        // stream controller must be provided as a dependency!
        this.streamController = void 0;
        this.hls = hls;
        this.registerListeners();
    }
    setStreamController(streamController) {
        this.streamController = streamController;
    }
    registerListeners() {
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    unregisterListeners() {
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
    }
    destroy() {
        if (this.timer) clearInterval(this.timer);
        this.unregisterListeners();
        this.isVideoPlaybackQualityAvailable = false;
        this.media = null;
    }
    onMediaAttaching(event, data) {
        const config = this.hls.config;
        if (config.capLevelOnFPSDrop) {
            const media = data.media instanceof self.HTMLVideoElement ? data.media : null;
            this.media = media;
            if (media && typeof media.getVideoPlaybackQuality === 'function') this.isVideoPlaybackQualityAvailable = true;
            self.clearInterval(this.timer);
            this.timer = self.setInterval(this.checkFPSInterval.bind(this), config.fpsDroppedMonitoringPeriod);
        }
    }
    onMediaDetaching() {
        this.media = null;
    }
    checkFPS(video, decodedFrames, droppedFrames) {
        const currentTime = performance.now();
        if (decodedFrames) {
            if (this.lastTime) {
                const currentPeriod = currentTime - this.lastTime;
                const currentDropped = droppedFrames - this.lastDroppedFrames;
                const currentDecoded = decodedFrames - this.lastDecodedFrames;
                const droppedFPS = 1000 * currentDropped / currentPeriod;
                const hls = this.hls;
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FPS_DROP, {
                    currentDropped: currentDropped,
                    currentDecoded: currentDecoded,
                    totalDroppedFrames: droppedFrames
                });
                if (droppedFPS > 0) // hls.logger.log('checkFPS : droppedFPS/decodedFPS:' + droppedFPS/(1000 * currentDecoded / currentPeriod));
                {
                    if (currentDropped > hls.config.fpsDroppedMonitoringThreshold * currentDecoded) {
                        let currentLevel = hls.currentLevel;
                        hls.logger.warn('drop FPS ratio greater than max allowed value for currentLevel: ' + currentLevel);
                        if (currentLevel > 0 && (hls.autoLevelCapping === -1 || hls.autoLevelCapping >= currentLevel)) {
                            currentLevel = currentLevel - 1;
                            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FPS_DROP_LEVEL_CAPPING, {
                                level: currentLevel,
                                droppedLevel: hls.currentLevel
                            });
                            hls.autoLevelCapping = currentLevel;
                            this.streamController.nextLevelSwitch();
                        }
                    }
                }
            }
            this.lastTime = currentTime;
            this.lastDroppedFrames = droppedFrames;
            this.lastDecodedFrames = decodedFrames;
        }
    }
    checkFPSInterval() {
        const video = this.media;
        if (video) {
            if (this.isVideoPlaybackQualityAvailable) {
                const videoPlaybackQuality = video.getVideoPlaybackQuality();
                this.checkFPS(video, videoPlaybackQuality.totalVideoFrames, videoPlaybackQuality.droppedVideoFrames);
            } else // HTMLVideoElement doesn't include the webkit types
            this.checkFPS(video, video.webkitDecodedFrameCount, video.webkitDroppedFrameCount);
        }
    }
}
function $b941786f4eb9cb76$var$sendAddTrackEvent(track, videoEl) {
    let event;
    try {
        event = new Event('addtrack');
    } catch (err) {
        // for IE11
        event = document.createEvent('Event');
        event.initEvent('addtrack', false, false);
    }
    event.track = track;
    videoEl.dispatchEvent(event);
}
function $b941786f4eb9cb76$var$addCueToTrack(track, cue) {
    // Sometimes there are cue overlaps on segmented vtts so the same
    // cue can appear more than once in different vtt files.
    // This avoid showing duplicated cues with same timecode and text.
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues && !track.cues.getCueById(cue.id)) try {
        track.addCue(cue);
        if (!track.cues.getCueById(cue.id)) throw new Error(`addCue is failed for: ${cue}`);
    } catch (err) {
        $b941786f4eb9cb76$var$logger.debug(`[texttrack-utils]: ${err}`);
        try {
            const textTrackCue = new self.TextTrackCue(cue.startTime, cue.endTime, cue.text);
            textTrackCue.id = cue.id;
            track.addCue(textTrackCue);
        } catch (err2) {
            $b941786f4eb9cb76$var$logger.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${err2}`);
        }
    }
    if (mode === 'disabled') track.mode = mode;
}
function $b941786f4eb9cb76$var$clearCurrentCues(track, enterHandler) {
    // When track.mode is disabled, track.cues will be null.
    // To guarantee the removal of cues, we need to temporarily
    // change the mode to hidden
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues) for(let i = track.cues.length; i--;){
        if (enterHandler) track.cues[i].removeEventListener('enter', enterHandler);
        track.removeCue(track.cues[i]);
    }
    if (mode === 'disabled') track.mode = mode;
}
function $b941786f4eb9cb76$var$removeCuesInRange(track, start, end, predicate) {
    const mode = track.mode;
    if (mode === 'disabled') track.mode = 'hidden';
    if (track.cues && track.cues.length > 0) {
        const cues = $b941786f4eb9cb76$var$getCuesInRange(track.cues, start, end);
        for(let i = 0; i < cues.length; i++)if (!predicate || predicate(cues[i])) track.removeCue(cues[i]);
    }
    if (mode === 'disabled') track.mode = mode;
}
// Find first cue starting at or after given time.
// Modified version of binary search O(log(n)).
function $b941786f4eb9cb76$var$getFirstCueIndexFromTime(cues, time1) {
    // If first cue starts at or after time, start there
    if (time1 <= cues[0].startTime) return 0;
    // If the last cue ends before time there is no overlap
    const len = cues.length - 1;
    if (time1 > cues[len].endTime) return -1;
    let left = 0;
    let right = len;
    let mid;
    while(left <= right){
        mid = Math.floor((right + left) / 2);
        if (time1 < cues[mid].startTime) right = mid - 1;
        else if (time1 > cues[mid].startTime && left < len) left = mid + 1;
        else // If it's not lower or higher, it must be equal.
        return mid;
    }
    // At this point, left and right have swapped.
    // No direct match was found, left or right element must be the closest. Check which one has the smallest diff.
    return cues[left].startTime - time1 < time1 - cues[right].startTime ? left : right;
}
function $b941786f4eb9cb76$var$getCuesInRange(cues, start, end) {
    const cuesFound = [];
    const firstCueInRange = $b941786f4eb9cb76$var$getFirstCueIndexFromTime(cues, start);
    if (firstCueInRange > -1) for(let i = firstCueInRange, len = cues.length; i < len; i++){
        const cue = cues[i];
        if (cue.startTime >= start && cue.endTime <= end) cuesFound.push(cue);
        else if (cue.startTime > end) return cuesFound;
    }
    return cuesFound;
}
function $b941786f4eb9cb76$var$filterSubtitleTracks(textTrackList) {
    const tracks = [];
    for(let i = 0; i < textTrackList.length; i++){
        const track = textTrackList[i];
        // Edge adds a track without a label; we don't want to use it
        if ((track.kind === 'subtitles' || track.kind === 'captions') && track.label) tracks.push(textTrackList[i]);
    }
    return tracks;
}
class $b941786f4eb9cb76$export$e287517d6ed8b132 extends $b941786f4eb9cb76$export$d94ec24774c8b986 {
    constructor(hls){
        super(hls, 'subtitle-track-controller');
        this.media = null;
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
        this.queuedDefaultTrack = -1;
        this.useTextTrackPolling = false;
        this.subtitlePollingInterval = -1;
        this._subtitleDisplay = true;
        this.asyncPollTrackChange = ()=>this.pollTrackChange(0);
        this.onTextTracksChanged = ()=>{
            if (!this.useTextTrackPolling) self.clearInterval(this.subtitlePollingInterval);
            // Media is undefined when switching streams via loadSource()
            if (!this.media || !this.hls.config.renderTextTracksNatively) return;
            let textTrack = null;
            const tracks = $b941786f4eb9cb76$var$filterSubtitleTracks(this.media.textTracks);
            for(let i = 0; i < tracks.length; i++){
                if (tracks[i].mode === 'hidden') // Do not break in case there is a following track with showing.
                textTrack = tracks[i];
                else if (tracks[i].mode === 'showing') {
                    textTrack = tracks[i];
                    break;
                }
            }
            // Find internal track index for TextTrack
            const trackId = this.findTrackForTextTrack(textTrack);
            if (this.subtitleTrack !== trackId) this.setSubtitleTrack(trackId);
        };
        this.registerListeners();
    }
    destroy() {
        this.unregisterListeners();
        this.tracks.length = 0;
        this.tracksInGroup.length = 0;
        this.currentTrack = null;
        // @ts-ignore
        this.onTextTracksChanged = this.asyncPollTrackChange = null;
        super.destroy();
    }
    get subtitleDisplay() {
        return this._subtitleDisplay;
    }
    set subtitleDisplay(value) {
        this._subtitleDisplay = value;
        if (this.trackId > -1) this.toggleTrackModes();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHING, this.onLevelSwitching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    // Listen for subtitle track change, then extract the current track ID.
    onMediaAttached(event, data) {
        this.media = data.media;
        if (!this.media) return;
        if (this.queuedDefaultTrack > -1) {
            this.subtitleTrack = this.queuedDefaultTrack;
            this.queuedDefaultTrack = -1;
        }
        this.useTextTrackPolling = !(this.media.textTracks && 'onchange' in this.media.textTracks);
        if (this.useTextTrackPolling) this.pollTrackChange(500);
        else this.media.textTracks.addEventListener('change', this.asyncPollTrackChange);
    }
    pollTrackChange(timeout) {
        self.clearInterval(this.subtitlePollingInterval);
        this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, timeout);
    }
    onMediaDetaching(event, data) {
        const media = this.media;
        if (!media) return;
        const transferringMedia = !!data.transferMedia;
        self.clearInterval(this.subtitlePollingInterval);
        if (!this.useTextTrackPolling) media.textTracks.removeEventListener('change', this.asyncPollTrackChange);
        if (this.trackId > -1) this.queuedDefaultTrack = this.trackId;
        // Disable all subtitle tracks before detachment so when reattached only tracks in that content are enabled.
        this.subtitleTrack = -1;
        this.media = null;
        if (transferringMedia) return;
        const textTracks = $b941786f4eb9cb76$var$filterSubtitleTracks(media.textTracks);
        // Clear loaded cues on media detachment from tracks
        textTracks.forEach((track)=>{
            $b941786f4eb9cb76$var$clearCurrentCues(track);
        });
    }
    onManifestLoading() {
        this.tracks = [];
        this.groupIds = null;
        this.tracksInGroup = [];
        this.trackId = -1;
        this.currentTrack = null;
        this.selectDefaultTrack = true;
    }
    // Fired whenever a new manifest is loaded.
    onManifestParsed(event, data) {
        this.tracks = data.subtitleTracks;
    }
    onSubtitleTrackLoaded(event, data) {
        const { id: id, groupId: groupId, details: details } = data;
        const trackInActiveGroup = this.tracksInGroup[id];
        if (!trackInActiveGroup || trackInActiveGroup.groupId !== groupId) {
            this.warn(`Subtitle track with id:${id} and group:${groupId} not found in active group ${trackInActiveGroup == null ? void 0 : trackInActiveGroup.groupId}`);
            return;
        }
        const curDetails = trackInActiveGroup.details;
        trackInActiveGroup.details = data.details;
        this.log(`Subtitle track ${id} "${trackInActiveGroup.name}" lang:${trackInActiveGroup.lang} group:${groupId} loaded [${details.startSN}-${details.endSN}]`);
        if (id === this.trackId) this.playlistLoaded(id, data, curDetails);
    }
    onLevelLoading(event, data) {
        this.switchLevel(data.level);
    }
    onLevelSwitching(event, data) {
        this.switchLevel(data.level);
    }
    switchLevel(levelIndex) {
        const levelInfo = this.hls.levels[levelIndex];
        if (!levelInfo) return;
        const subtitleGroups = levelInfo.subtitleGroups || null;
        const currentGroups = this.groupIds;
        let currentTrack = this.currentTrack;
        if (!subtitleGroups || (currentGroups == null ? void 0 : currentGroups.length) !== (subtitleGroups == null ? void 0 : subtitleGroups.length) || subtitleGroups != null && subtitleGroups.some((groupId)=>(currentGroups == null ? void 0 : currentGroups.indexOf(groupId)) === -1)) {
            this.groupIds = subtitleGroups;
            this.trackId = -1;
            this.currentTrack = null;
            const subtitleTracks = this.tracks.filter((track)=>!subtitleGroups || subtitleGroups.indexOf(track.groupId) !== -1);
            if (subtitleTracks.length) {
                // Disable selectDefaultTrack if there are no default tracks
                if (this.selectDefaultTrack && !subtitleTracks.some((track)=>track.default)) this.selectDefaultTrack = false;
                // track.id should match hls.audioTracks index
                subtitleTracks.forEach((track, i)=>{
                    track.id = i;
                });
            } else if (!currentTrack && !this.tracksInGroup.length) // Do not dispatch SUBTITLE_TRACKS_UPDATED when there were and are no tracks
            return;
            this.tracksInGroup = subtitleTracks;
            // Find preferred track
            const subtitlePreference = this.hls.config.subtitlePreference;
            if (!currentTrack && subtitlePreference) {
                this.selectDefaultTrack = false;
                const groupIndex = $b941786f4eb9cb76$var$findMatchingOption(subtitlePreference, subtitleTracks);
                if (groupIndex > -1) currentTrack = subtitleTracks[groupIndex];
                else {
                    const allIndex = $b941786f4eb9cb76$var$findMatchingOption(subtitlePreference, this.tracks);
                    currentTrack = this.tracks[allIndex];
                }
            }
            // Select initial track
            let trackId = this.findTrackId(currentTrack);
            if (trackId === -1 && currentTrack) trackId = this.findTrackId(null);
            // Dispatch events and load track if needed
            const subtitleTracksUpdated = {
                subtitleTracks: subtitleTracks
            };
            this.log(`Updating subtitle tracks, ${subtitleTracks.length} track(s) found in "${subtitleGroups == null ? void 0 : subtitleGroups.join(',')}" group-id`);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, subtitleTracksUpdated);
            if (trackId !== -1 && this.trackId === -1) this.setSubtitleTrack(trackId);
        }
    }
    findTrackId(currentTrack) {
        const tracks = this.tracksInGroup;
        const selectDefault = this.selectDefaultTrack;
        for(let i = 0; i < tracks.length; i++){
            const track = tracks[i];
            if (selectDefault && !track.default || !selectDefault && !currentTrack) continue;
            if (!currentTrack || $b941786f4eb9cb76$var$matchesOption(track, currentTrack)) return i;
        }
        if (currentTrack) {
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if ($b941786f4eb9cb76$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE',
                    'ASSOC-LANGUAGE',
                    'CHARACTERISTICS'
                ])) return i;
            }
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if ($b941786f4eb9cb76$var$mediaAttributesIdentical(currentTrack.attrs, track.attrs, [
                    'LANGUAGE'
                ])) return i;
            }
        }
        return -1;
    }
    findTrackForTextTrack(textTrack) {
        if (textTrack) {
            const tracks = this.tracksInGroup;
            for(let i = 0; i < tracks.length; i++){
                const track = tracks[i];
                if ($b941786f4eb9cb76$var$subtitleTrackMatchesTextTrack(track, textTrack)) return i;
            }
        }
        return -1;
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK && data.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(data.context.groupId) !== -1)) this.checkRetry(data);
    }
    get allSubtitleTracks() {
        return this.tracks;
    }
    /** get alternate subtitle tracks list from playlist **/ get subtitleTracks() {
        return this.tracksInGroup;
    }
    /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/ get subtitleTrack() {
        return this.trackId;
    }
    set subtitleTrack(newId) {
        this.selectDefaultTrack = false;
        this.setSubtitleTrack(newId);
    }
    setSubtitleOption(subtitleOption) {
        this.hls.config.subtitlePreference = subtitleOption;
        if (subtitleOption) {
            if (subtitleOption.id === -1) {
                this.setSubtitleTrack(-1);
                return null;
            }
            const allSubtitleTracks = this.allSubtitleTracks;
            this.selectDefaultTrack = false;
            if (allSubtitleTracks.length) {
                // First see if current option matches (no switch op)
                const currentTrack = this.currentTrack;
                if (currentTrack && $b941786f4eb9cb76$var$matchesOption(subtitleOption, currentTrack)) return currentTrack;
                // Find option in current group
                const groupIndex = $b941786f4eb9cb76$var$findMatchingOption(subtitleOption, this.tracksInGroup);
                if (groupIndex > -1) {
                    const track = this.tracksInGroup[groupIndex];
                    this.setSubtitleTrack(groupIndex);
                    return track;
                } else if (currentTrack) // If this is not the initial selection return null
                // option should have matched one in active group
                return null;
                else {
                    // Find the option in all tracks for initial selection
                    const allIndex = $b941786f4eb9cb76$var$findMatchingOption(subtitleOption, allSubtitleTracks);
                    if (allIndex > -1) return allSubtitleTracks[allIndex];
                }
            }
        }
        return null;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        if (this.shouldLoadPlaylist(this.currentTrack)) this.scheduleLoading(this.currentTrack, hlsUrlParameters);
    }
    loadingPlaylist(currentTrack, hlsUrlParameters) {
        super.loadingPlaylist(currentTrack, hlsUrlParameters);
        const id = currentTrack.id;
        const groupId = currentTrack.groupId;
        const url = this.getUrlWithDirectives(currentTrack.url, hlsUrlParameters);
        const details = currentTrack.details;
        const age = details == null ? void 0 : details.age;
        this.log(`Loading subtitle ${id} "${currentTrack.name}" lang:${currentTrack.lang} group:${groupId}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type : '') : ''} ${url}`);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADING, {
            url: url,
            id: id,
            groupId: groupId,
            deliveryDirectives: hlsUrlParameters || null,
            track: currentTrack
        });
    }
    /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */ toggleTrackModes() {
        const { media: media } = this;
        if (!media) return;
        const textTracks = $b941786f4eb9cb76$var$filterSubtitleTracks(media.textTracks);
        const currentTrack = this.currentTrack;
        let nextTrack;
        if (currentTrack) {
            nextTrack = textTracks.filter((textTrack)=>$b941786f4eb9cb76$var$subtitleTrackMatchesTextTrack(currentTrack, textTrack))[0];
            if (!nextTrack) this.warn(`Unable to find subtitle TextTrack with name "${currentTrack.name}" and language "${currentTrack.lang}"`);
        }
        [].slice.call(textTracks).forEach((track)=>{
            if (track.mode !== 'disabled' && track !== nextTrack) track.mode = 'disabled';
        });
        if (nextTrack) {
            const mode = this.subtitleDisplay ? 'showing' : 'hidden';
            if (nextTrack.mode !== mode) nextTrack.mode = mode;
        }
    }
    /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */ setSubtitleTrack(newId) {
        const tracks = this.tracksInGroup;
        // setting this.subtitleTrack will trigger internal logic
        // if media has not been attached yet, it will fail
        // we keep a reference to the default track id
        // and we'll set subtitleTrack when onMediaAttached is triggered
        if (!this.media) {
            this.queuedDefaultTrack = newId;
            return;
        }
        // exit if track id as already set or invalid
        if (newId < -1 || newId >= tracks.length || !$b941786f4eb9cb76$var$isFiniteNumber(newId)) {
            this.warn(`Invalid subtitle track id: ${newId}`);
            return;
        }
        this.selectDefaultTrack = false;
        const lastTrack = this.currentTrack;
        const track = tracks[newId] || null;
        this.trackId = newId;
        this.currentTrack = track;
        this.toggleTrackModes();
        if (!track) {
            // switch to -1
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, {
                id: newId
            });
            return;
        }
        const trackLoaded = !!track.details && !track.details.live;
        if (newId === this.trackId && track === lastTrack && trackLoaded) return;
        this.log(`Switching to subtitle-track ${newId}` + (track ? ` "${track.name}" lang:${track.lang} group:${track.groupId}` : ''));
        const { id: id, groupId: groupId = '', name: name, type: type, url: url } = track;
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, {
            id: id,
            groupId: groupId,
            name: name,
            type: type,
            url: url
        });
        const hlsUrlParameters = this.switchParams(track.url, lastTrack == null ? void 0 : lastTrack.details, track.details);
        this.loadPlaylist(hlsUrlParameters);
    }
}
/**
 * Generate a random v4 UUID
 *
 * @returns A random v4 UUID
 *
 * @group Utils
 *
 * @beta
 */ function $b941786f4eb9cb76$var$uuid() {
    try {
        return crypto.randomUUID();
    } catch (error) {
        try {
            const url = URL.createObjectURL(new Blob());
            const uuid = url.toString();
            URL.revokeObjectURL(url);
            return uuid.slice(uuid.lastIndexOf('/') + 1);
        } catch (error) {
            let dt = new Date().getTime();
            const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
                const r = (dt + Math.random() * 16) % 16 | 0;
                dt = Math.floor(dt / 16);
                return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
            });
            return uuid;
        }
    }
}
// From https://github.com/darkskyapp/string-hash
function $b941786f4eb9cb76$var$hash(text) {
    let hash = 5381;
    let i = text.length;
    while(i)hash = hash * 33 ^ text.charCodeAt(--i);
    return (hash >>> 0).toString();
}
const $b941786f4eb9cb76$var$ALIGNED_END_THRESHOLD_SECONDS = 0.025;
let $b941786f4eb9cb76$var$TimelineOccupancy = /*#__PURE__*/ function(TimelineOccupancy) {
    TimelineOccupancy[TimelineOccupancy["Point"] = 0] = "Point";
    TimelineOccupancy[TimelineOccupancy["Range"] = 1] = "Range";
    return TimelineOccupancy;
}({});
function $b941786f4eb9cb76$var$generateAssetIdentifier(interstitial, uri, assetListIndex) {
    return `${interstitial.identifier}-${assetListIndex + 1}-${$b941786f4eb9cb76$var$hash(uri)}`;
}
class $b941786f4eb9cb76$var$InterstitialEvent {
    constructor(dateRange, base){
        this.base = void 0;
        this._duration = null;
        this._timelineStart = null;
        this.appendInPlaceDisabled = void 0;
        this.appendInPlaceStarted = void 0;
        this.dateRange = void 0;
        this.hasPlayed = false;
        this.cumulativeDuration = 0;
        this.resumeOffset = NaN;
        this.playoutLimit = NaN;
        this.restrictions = {
            skip: false,
            jump: false
        };
        this.snapOptions = {
            out: false,
            in: false
        };
        this.assetList = [];
        this.assetListLoader = void 0;
        this.assetListResponse = null;
        this.resumeAnchor = void 0;
        this.error = void 0;
        this.resetOnResume = void 0;
        this.base = base;
        this.dateRange = dateRange;
        this.setDateRange(dateRange);
    }
    setDateRange(dateRange) {
        this.dateRange = dateRange;
        this.resumeOffset = dateRange.attr.optionalFloat('X-RESUME-OFFSET', this.resumeOffset);
        this.playoutLimit = dateRange.attr.optionalFloat('X-PLAYOUT-LIMIT', this.playoutLimit);
        this.restrictions = dateRange.attr.enumeratedStringList('X-RESTRICT', this.restrictions);
        this.snapOptions = dateRange.attr.enumeratedStringList('X-SNAP', this.snapOptions);
    }
    reset() {
        var _this$assetListLoader;
        this.appendInPlaceStarted = false;
        (_this$assetListLoader = this.assetListLoader) == null || _this$assetListLoader.destroy();
        this.assetListLoader = undefined;
        if (!this.supplementsPrimary) {
            this.assetListResponse = null;
            this.assetList = [];
            this._duration = null;
        }
    // `error?` is reset when seeking back over interstitial `startOffset`
    //  using `schedule.resetErrorsInRange(start, end)`.
    }
    isAssetPastPlayoutLimit(assetIndex) {
        var _this$assetList$asset;
        if (assetIndex > 0 && assetIndex >= this.assetList.length) return true;
        const playoutLimit = this.playoutLimit;
        if (assetIndex <= 0 || isNaN(playoutLimit)) return false;
        if (playoutLimit === 0) return true;
        const assetOffset = ((_this$assetList$asset = this.assetList[assetIndex]) == null ? void 0 : _this$assetList$asset.startOffset) || 0;
        return assetOffset > playoutLimit;
    }
    findAssetIndex(asset) {
        const index = this.assetList.indexOf(asset);
        return index;
    }
    get identifier() {
        return this.dateRange.id;
    }
    get startDate() {
        return this.dateRange.startDate;
    }
    get startTime() {
        // Primary media timeline start time
        const startTime = this.dateRange.startTime;
        if (this.snapOptions.out) {
            const frag = this.dateRange.tagAnchor;
            if (frag) return $b941786f4eb9cb76$var$getSnapToFragmentTime(startTime, frag);
        }
        return startTime;
    }
    get startOffset() {
        return this.cue.pre ? 0 : this.startTime;
    }
    get startIsAligned() {
        if (this.startTime === 0 || this.snapOptions.out) return true;
        const frag = this.dateRange.tagAnchor;
        if (frag) {
            const startTime = this.dateRange.startTime;
            const snappedStart = $b941786f4eb9cb76$var$getSnapToFragmentTime(startTime, frag);
            return startTime - snappedStart < 0.1;
        }
        return false;
    }
    get resumptionOffset() {
        const resumeOffset = this.resumeOffset;
        const offset = $b941786f4eb9cb76$var$isFiniteNumber(resumeOffset) ? resumeOffset : this.duration;
        return this.cumulativeDuration + offset;
    }
    get resumeTime() {
        // Primary media timeline resumption time
        const resumeTime = this.startOffset + this.resumptionOffset;
        if (this.snapOptions.in) {
            const frag = this.resumeAnchor;
            if (frag) return $b941786f4eb9cb76$var$getSnapToFragmentTime(resumeTime, frag);
        }
        return resumeTime;
    }
    get appendInPlace() {
        if (this.appendInPlaceStarted) return true;
        if (this.appendInPlaceDisabled) return false;
        if (!this.cue.once && !this.cue.pre && // preroll starts at startPosition before startPosition is known (live)
        this.startIsAligned && (isNaN(this.playoutLimit) && isNaN(this.resumeOffset) || this.resumeOffset && this.duration && Math.abs(this.resumeOffset - this.duration) < $b941786f4eb9cb76$var$ALIGNED_END_THRESHOLD_SECONDS)) return true;
        return false;
    }
    set appendInPlace(value) {
        if (this.appendInPlaceStarted) {
            this.resetOnResume = !value;
            return;
        }
        this.appendInPlaceDisabled = !value;
    }
    // Extended timeline start time
    get timelineStart() {
        if (this._timelineStart !== null) return this._timelineStart;
        return this.startTime;
    }
    set timelineStart(value) {
        this._timelineStart = value;
    }
    get duration() {
        const playoutLimit = this.playoutLimit;
        let duration;
        if (this._duration !== null) duration = this._duration;
        else if (this.dateRange.duration) duration = this.dateRange.duration;
        else duration = this.dateRange.plannedDuration || 0;
        if (!isNaN(playoutLimit) && playoutLimit < duration) duration = playoutLimit;
        return duration;
    }
    set duration(value) {
        this._duration = value;
    }
    get cue() {
        return this.dateRange.cue;
    }
    get timelineOccupancy() {
        if (this.dateRange.attr['X-TIMELINE-OCCUPIES'] === 'RANGE') return $b941786f4eb9cb76$var$TimelineOccupancy.Range;
        return $b941786f4eb9cb76$var$TimelineOccupancy.Point;
    }
    get supplementsPrimary() {
        return this.dateRange.attr['X-TIMELINE-STYLE'] === 'PRIMARY';
    }
    get contentMayVary() {
        return this.dateRange.attr['X-CONTENT-MAY-VARY'] !== 'NO';
    }
    get assetUrl() {
        return this.dateRange.attr['X-ASSET-URI'];
    }
    get assetListUrl() {
        return this.dateRange.attr['X-ASSET-LIST'];
    }
    get baseUrl() {
        return this.base.url;
    }
    get assetListLoaded() {
        return this.assetList.length > 0 || this.assetListResponse !== null;
    }
    toString() {
        return $b941786f4eb9cb76$var$eventToString(this);
    }
}
function $b941786f4eb9cb76$var$getSnapToFragmentTime(time1, frag) {
    return time1 - frag.start < frag.duration / 2 && !(Math.abs(time1 - (frag.start + frag.duration)) < $b941786f4eb9cb76$var$ALIGNED_END_THRESHOLD_SECONDS) ? frag.start : frag.start + frag.duration;
}
function $b941786f4eb9cb76$var$getInterstitialUrl(uri, sessionId, baseUrl) {
    const url = new self.URL(uri, baseUrl);
    if (url.protocol !== 'data:') url.searchParams.set('_HLS_primary_id', sessionId);
    return url;
}
function $b941786f4eb9cb76$var$getNextAssetIndex(interstitial, assetListIndex) {
    while((_interstitial$assetLi = interstitial.assetList[++assetListIndex]) != null && _interstitial$assetLi.error)var _interstitial$assetLi;
     /* no-op */ 
    return assetListIndex;
}
function $b941786f4eb9cb76$var$eventToString(interstitial) {
    return `["${interstitial.identifier}" ${interstitial.cue.pre ? '<pre>' : interstitial.cue.post ? '<post>' : ''}${interstitial.timelineStart.toFixed(2)}-${interstitial.resumeTime.toFixed(2)}]`;
}
function $b941786f4eb9cb76$var$eventAssetToString(asset) {
    const start = asset.timelineStart;
    const duration = asset.duration || 0;
    return `["${asset.identifier}" ${start.toFixed(2)}-${(start + duration).toFixed(2)}]`;
}
class $b941786f4eb9cb76$var$HlsAssetPlayer {
    constructor(HlsPlayerClass, userConfig, interstitial, assetItem){
        this.hls = void 0;
        this.interstitial = void 0;
        this.assetItem = void 0;
        this.tracks = null;
        this.hasDetails = false;
        this.mediaAttached = null;
        this._currentTime = void 0;
        this._bufferedEosTime = void 0;
        this.checkPlayout = ()=>{
            if (this.reachedPlayout(this.currentTime) && this.hls) this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.PLAYOUT_LIMIT_REACHED, {});
        };
        const hls = this.hls = new HlsPlayerClass(userConfig);
        this.interstitial = interstitial;
        this.assetItem = assetItem;
        const detailsLoaded = ()=>{
            this.hasDetails = true;
        };
        hls.once($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, detailsLoaded);
        hls.once($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADED, detailsLoaded);
        hls.once($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, detailsLoaded);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, (name, { media: media })=>{
            this.removeMediaListeners();
            this.mediaAttached = media;
            const event = this.interstitial;
            if (event.playoutLimit) {
                media.addEventListener('timeupdate', this.checkPlayout);
                if (this.appendInPlace) hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, ()=>{
                    const bufferedEnd = this.bufferedEnd;
                    if (this.reachedPlayout(bufferedEnd)) {
                        this._bufferedEosTime = bufferedEnd;
                        hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFERED_TO_END, undefined);
                    }
                });
            }
        });
    }
    get appendInPlace() {
        return this.interstitial.appendInPlace;
    }
    loadSource() {
        const hls = this.hls;
        if (!hls) return;
        if (!hls.url) {
            let uri = this.assetItem.uri;
            try {
                uri = $b941786f4eb9cb76$var$getInterstitialUrl(uri, hls.config.primarySessionId || '').href;
            } catch (error) {
            // Ignore error parsing ASSET_URI or adding _HLS_primary_id to it. The
            // issue should surface as an INTERSTITIAL_ASSET_ERROR loading the asset.
            }
            hls.loadSource(uri);
        } else if (hls.levels.length && !hls.started) hls.startLoad(-1, true);
    }
    bufferedInPlaceToEnd(media) {
        var _this$hls;
        if (!this.appendInPlace) return false;
        if ((_this$hls = this.hls) != null && _this$hls.bufferedToEnd) return true;
        if (!media) return false;
        const duration = Math.min(this._bufferedEosTime || Infinity, this.duration);
        const start = this.timelineOffset;
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(media, start, 0);
        const bufferedEnd = this.getAssetTime(bufferInfo.end);
        return bufferedEnd >= duration - 0.02;
    }
    reachedPlayout(time1) {
        const interstitial = this.interstitial;
        const playoutLimit = interstitial.playoutLimit;
        return this.startOffset + time1 >= playoutLimit;
    }
    get destroyed() {
        var _this$hls2;
        return !((_this$hls2 = this.hls) != null && _this$hls2.userConfig);
    }
    get assetId() {
        return this.assetItem.identifier;
    }
    get interstitialId() {
        return this.assetItem.parentIdentifier;
    }
    get media() {
        var _this$hls3;
        return ((_this$hls3 = this.hls) == null ? void 0 : _this$hls3.media) || null;
    }
    get bufferedEnd() {
        const media = this.media || this.mediaAttached;
        if (!media) {
            if (this._bufferedEosTime) return this._bufferedEosTime;
            return this.currentTime;
        }
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(media, media.currentTime, 0.001);
        return this.getAssetTime(bufferInfo.end);
    }
    get currentTime() {
        const media = this.media || this.mediaAttached;
        if (!media) return this._currentTime || 0;
        return this.getAssetTime(media.currentTime);
    }
    get duration() {
        const duration = this.assetItem.duration;
        if (!duration) return 0;
        const playoutLimit = this.interstitial.playoutLimit;
        if (playoutLimit) {
            const assetPlayout = playoutLimit - this.startOffset;
            if (assetPlayout > 0 && assetPlayout < duration) return assetPlayout;
        }
        return duration;
    }
    get remaining() {
        const duration = this.duration;
        if (!duration) return 0;
        return Math.max(0, duration - this.currentTime);
    }
    get startOffset() {
        return this.assetItem.startOffset;
    }
    get timelineOffset() {
        var _this$hls4;
        return ((_this$hls4 = this.hls) == null ? void 0 : _this$hls4.config.timelineOffset) || 0;
    }
    set timelineOffset(value) {
        const timelineOffset = this.timelineOffset;
        if (value !== timelineOffset) {
            const diff = value - timelineOffset;
            if (Math.abs(diff) > 1 / 90000 && this.hls) {
                if (this.hasDetails) throw new Error(`Cannot set timelineOffset after playlists are loaded`);
                this.hls.config.timelineOffset = value;
            }
        }
    }
    getAssetTime(time1) {
        const timelineOffset = this.timelineOffset;
        const duration = this.duration;
        return Math.min(Math.max(0, time1 - timelineOffset), duration);
    }
    removeMediaListeners() {
        const media = this.mediaAttached;
        if (media) {
            this._currentTime = media.currentTime;
            this.bufferSnapShot();
            media.removeEventListener('timeupdate', this.checkPlayout);
        }
    }
    bufferSnapShot() {
        if (this.mediaAttached) {
            var _this$hls5;
            if ((_this$hls5 = this.hls) != null && _this$hls5.bufferedToEnd) this._bufferedEosTime = this.bufferedEnd;
        }
    }
    destroy() {
        this.removeMediaListeners();
        if (this.hls) this.hls.destroy();
        this.hls = null;
        // @ts-ignore
        this.tracks = this.mediaAttached = this.checkPlayout = null;
    }
    attachMedia(data) {
        var _this$hls6;
        this.loadSource();
        (_this$hls6 = this.hls) == null || _this$hls6.attachMedia(data);
    }
    detachMedia() {
        var _this$hls7;
        this.removeMediaListeners();
        this.mediaAttached = null;
        (_this$hls7 = this.hls) == null || _this$hls7.detachMedia();
    }
    resumeBuffering() {
        var _this$hls8;
        (_this$hls8 = this.hls) == null || _this$hls8.resumeBuffering();
    }
    pauseBuffering() {
        var _this$hls9;
        (_this$hls9 = this.hls) == null || _this$hls9.pauseBuffering();
    }
    transferMedia() {
        var _this$hls0;
        this.bufferSnapShot();
        return ((_this$hls0 = this.hls) == null ? void 0 : _this$hls0.transferMedia()) || null;
    }
    resetDetails() {
        const hls = this.hls;
        if (hls && this.hasDetails) {
            hls.stopLoad();
            const deleteDetails = (obj)=>delete obj.details;
            hls.levels.forEach(deleteDetails);
            hls.allAudioTracks.forEach(deleteDetails);
            hls.allSubtitleTracks.forEach(deleteDetails);
            this.hasDetails = false;
        }
    }
    on(event, listener, context) {
        var _this$hls1;
        (_this$hls1 = this.hls) == null || _this$hls1.on(event, listener);
    }
    once(event, listener, context) {
        var _this$hls10;
        (_this$hls10 = this.hls) == null || _this$hls10.once(event, listener);
    }
    off(event, listener, context) {
        var _this$hls11;
        (_this$hls11 = this.hls) == null || _this$hls11.off(event, listener);
    }
    toString() {
        var _this$hls12;
        return `HlsAssetPlayer: ${$b941786f4eb9cb76$var$eventAssetToString(this.assetItem)} ${(_this$hls12 = this.hls) == null ? void 0 : _this$hls12.sessionId} ${this.appendInPlace ? 'append-in-place' : ''}`;
    }
}
const $b941786f4eb9cb76$var$ABUTTING_THRESHOLD_SECONDS = 0.033;
class $b941786f4eb9cb76$var$InterstitialsSchedule extends $b941786f4eb9cb76$var$Logger {
    constructor(onScheduleUpdate, logger){
        super('interstitials-sched', logger);
        this.onScheduleUpdate = void 0;
        this.eventMap = {};
        this.events = null;
        this.items = null;
        this.durations = {
            primary: 0,
            playout: 0,
            integrated: 0
        };
        this.onScheduleUpdate = onScheduleUpdate;
    }
    destroy() {
        this.reset();
        // @ts-ignore
        this.onScheduleUpdate = null;
    }
    reset() {
        this.eventMap = {};
        this.setDurations(0, 0, 0);
        if (this.events) this.events.forEach((interstitial)=>interstitial.reset());
        this.events = this.items = null;
    }
    resetErrorsInRange(start, end) {
        if (this.events) return this.events.reduce((count, interstitial)=>{
            if (start <= interstitial.startOffset && end > interstitial.startOffset) {
                delete interstitial.error;
                return count + 1;
            }
            return count;
        }, 0);
        return 0;
    }
    get duration() {
        const items = this.items;
        return items ? items[items.length - 1].end : 0;
    }
    get length() {
        return this.items ? this.items.length : 0;
    }
    getEvent(identifier) {
        return identifier ? this.eventMap[identifier] || null : null;
    }
    hasEvent(identifier) {
        return identifier in this.eventMap;
    }
    findItemIndex(item, time1) {
        if (item.event) // Find Event Item
        return this.findEventIndex(item.event.identifier);
        // Find Primary Item
        let index = -1;
        if (item.nextEvent) index = this.findEventIndex(item.nextEvent.identifier) - 1;
        else if (item.previousEvent) index = this.findEventIndex(item.previousEvent.identifier) + 1;
        const items = this.items;
        if (items) {
            if (!items[index]) {
                if (time1 === undefined) time1 = item.start;
                index = this.findItemIndexAtTime(time1);
            }
            // Only return index of a Primary Item
            while(index >= 0 && (_items$index = items[index]) != null && _items$index.event){
                var _items$index;
                // If index found is an interstitial it is not a valid result as it should have been matched up top
                // decrement until result is negative (not found) or a primary segment
                index--;
            }
        }
        return index;
    }
    findItemIndexAtTime(timelinePos, timelineType) {
        const items = this.items;
        if (items) for(let i = 0; i < items.length; i++){
            let timeRange = items[i];
            if (timelineType && timelineType !== 'primary') timeRange = timeRange[timelineType];
            if (timelinePos === timeRange.start || timelinePos > timeRange.start && timelinePos < timeRange.end) return i;
        }
        return -1;
    }
    findJumpRestrictedIndex(startIndex, endIndex) {
        const items = this.items;
        if (items) for(let i = startIndex; i <= endIndex; i++){
            if (!items[i]) break;
            const event = items[i].event;
            if (event != null && event.restrictions.jump && !event.appendInPlace) return i;
        }
        return -1;
    }
    findEventIndex(identifier) {
        const items = this.items;
        if (items) for(let i = items.length; i--;){
            var _items$i$event;
            if (((_items$i$event = items[i].event) == null ? void 0 : _items$i$event.identifier) === identifier) return i;
        }
        return -1;
    }
    findAssetIndex(event, timelinePos) {
        const assetList = event.assetList;
        const length = assetList.length;
        if (length > 1) for(let i = 0; i < length; i++){
            const asset = assetList[i];
            if (!asset.error) {
                const timelineStart = asset.timelineStart;
                if (timelinePos === timelineStart || timelinePos > timelineStart && (timelinePos < timelineStart + (asset.duration || 0) || i === length - 1)) return i;
            }
        }
        return 0;
    }
    get assetIdAtEnd() {
        var _this$items;
        const interstitialAtEnd = (_this$items = this.items) == null || (_this$items = _this$items[this.length - 1]) == null ? void 0 : _this$items.event;
        if (interstitialAtEnd) {
            const assetList = interstitialAtEnd.assetList;
            const assetAtEnd = assetList[assetList.length - 1];
            if (assetAtEnd) return assetAtEnd.identifier;
        }
        return null;
    }
    parseInterstitialDateRanges(mediaSelection, enableAppendInPlace) {
        const details = mediaSelection.main.details;
        const { dateRanges: dateRanges } = details;
        const previousInterstitialEvents = this.events;
        const interstitialEvents = this.parseDateRanges(dateRanges, {
            url: details.url
        }, enableAppendInPlace);
        const ids = Object.keys(dateRanges);
        const removedInterstitials = previousInterstitialEvents ? previousInterstitialEvents.filter((event)=>!ids.includes(event.identifier)) : [];
        if (interstitialEvents.length) // pre-rolls, post-rolls, and events with the same start time are played in playlist tag order
        // all other events are ordered by start time
        interstitialEvents.sort((a, b)=>{
            const aPre = a.cue.pre;
            const aPost = a.cue.post;
            const bPre = b.cue.pre;
            const bPost = b.cue.post;
            if (aPre && !bPre) return -1;
            if (bPre && !aPre) return 1;
            if (aPost && !bPost) return 1;
            if (bPost && !aPost) return -1;
            if (!aPre && !bPre && !aPost && !bPost) {
                const startA = a.startTime;
                const startB = b.startTime;
                if (startA !== startB) return startA - startB;
            }
            return a.dateRange.tagOrder - b.dateRange.tagOrder;
        });
        this.events = interstitialEvents;
        // Clear removed DateRanges from buffered list (kills playback of active Interstitials)
        removedInterstitials.forEach((interstitial)=>{
            this.removeEvent(interstitial);
        });
        this.updateSchedule(mediaSelection, removedInterstitials);
    }
    updateSchedule(mediaSelection, removedInterstitials = [], forceUpdate = false) {
        const events = this.events || [];
        if (events.length || removedInterstitials.length || this.length < 2) {
            const currentItems = this.items;
            const updatedItems = this.parseSchedule(events, mediaSelection);
            const updated = forceUpdate || removedInterstitials.length || (currentItems == null ? void 0 : currentItems.length) !== updatedItems.length || updatedItems.some((item, i)=>{
                return Math.abs(item.playout.start - currentItems[i].playout.start) > 0.005 || Math.abs(item.playout.end - currentItems[i].playout.end) > 0.005;
            });
            if (updated) {
                this.items = updatedItems;
                // call interstitials-controller onScheduleUpdated()
                this.onScheduleUpdate(removedInterstitials, currentItems);
            }
        }
    }
    parseDateRanges(dateRanges, baseData, enableAppendInPlace) {
        const interstitialEvents = [];
        const ids = Object.keys(dateRanges);
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const dateRange = dateRanges[id];
            if (dateRange.isInterstitial) {
                let interstitial = this.eventMap[id];
                if (interstitial) // Update InterstitialEvent already parsed and mapped
                // This retains already loaded duration and loaded asset list info
                interstitial.setDateRange(dateRange);
                else {
                    interstitial = new $b941786f4eb9cb76$var$InterstitialEvent(dateRange, baseData);
                    this.eventMap[id] = interstitial;
                    if (enableAppendInPlace === false) interstitial.appendInPlace = enableAppendInPlace;
                }
                interstitialEvents.push(interstitial);
            }
        }
        return interstitialEvents;
    }
    parseSchedule(interstitialEvents, mediaSelection) {
        const schedule = [];
        const details = mediaSelection.main.details;
        const primaryDuration = details.live ? Infinity : details.edge;
        let playoutDuration = 0;
        // Filter events that have errored from the schedule (Primary fallback)
        interstitialEvents = interstitialEvents.filter((event)=>!event.error && !(event.cue.once && event.hasPlayed));
        if (interstitialEvents.length) {
            // Update Schedule
            this.resolveOffsets(interstitialEvents, mediaSelection);
            // Populate Schedule with Interstitial Event and Primary Segment Items
            let primaryPosition = 0;
            let integratedTime = 0;
            interstitialEvents.forEach((interstitial, i)=>{
                const preroll = interstitial.cue.pre;
                const postroll = interstitial.cue.post;
                const previousEvent = interstitialEvents[i - 1] || null;
                const appendInPlace = interstitial.appendInPlace;
                const eventStart = postroll ? primaryDuration : interstitial.startOffset;
                const interstitialDuration = interstitial.duration;
                const timelineDuration = interstitial.timelineOccupancy === $b941786f4eb9cb76$var$TimelineOccupancy.Range ? interstitialDuration : 0;
                const resumptionOffset = interstitial.resumptionOffset;
                const inSameStartTimeSequence = (previousEvent == null ? void 0 : previousEvent.startTime) === eventStart;
                const start = eventStart + interstitial.cumulativeDuration;
                let end = appendInPlace ? start + interstitialDuration : eventStart + resumptionOffset;
                if (preroll || !postroll && eventStart <= 0) {
                    // preroll or in-progress midroll
                    const integratedStart = integratedTime;
                    integratedTime += timelineDuration;
                    interstitial.timelineStart = start;
                    const playoutStart = playoutDuration;
                    playoutDuration += interstitialDuration;
                    schedule.push({
                        event: interstitial,
                        start: start,
                        end: end,
                        playout: {
                            start: playoutStart,
                            end: playoutDuration
                        },
                        integrated: {
                            start: integratedStart,
                            end: integratedTime
                        }
                    });
                } else if (eventStart <= primaryDuration) {
                    if (!inSameStartTimeSequence) {
                        const segmentDuration = eventStart - primaryPosition;
                        // Do not schedule a primary segment if interstitials are abutting by less than ABUTTING_THRESHOLD_SECONDS
                        if (segmentDuration > $b941786f4eb9cb76$var$ABUTTING_THRESHOLD_SECONDS) {
                            // primary segment
                            const timelineStart = primaryPosition;
                            const _integratedStart = integratedTime;
                            integratedTime += segmentDuration;
                            const _playoutStart = playoutDuration;
                            playoutDuration += segmentDuration;
                            const primarySegment = {
                                previousEvent: interstitialEvents[i - 1] || null,
                                nextEvent: interstitial,
                                start: timelineStart,
                                end: timelineStart + segmentDuration,
                                playout: {
                                    start: _playoutStart,
                                    end: playoutDuration
                                },
                                integrated: {
                                    start: _integratedStart,
                                    end: integratedTime
                                }
                            };
                            schedule.push(primarySegment);
                        } else if (segmentDuration > 0 && previousEvent) {
                            // Add previous event `resumeTime` (based on duration or resumeOffset) so that it ends aligned with this one
                            previousEvent.cumulativeDuration += segmentDuration;
                            schedule[schedule.length - 1].end = eventStart;
                        }
                    }
                    // midroll / postroll
                    if (postroll) end = start;
                    interstitial.timelineStart = start;
                    const integratedStart = integratedTime;
                    integratedTime += timelineDuration;
                    const playoutStart = playoutDuration;
                    playoutDuration += interstitialDuration;
                    schedule.push({
                        event: interstitial,
                        start: start,
                        end: end,
                        playout: {
                            start: playoutStart,
                            end: playoutDuration
                        },
                        integrated: {
                            start: integratedStart,
                            end: integratedTime
                        }
                    });
                } else // Interstitial starts after end of primary VOD - not included in schedule
                return;
                const resumeTime = interstitial.resumeTime;
                if (postroll || resumeTime > primaryDuration) primaryPosition = primaryDuration;
                else primaryPosition = resumeTime;
            });
            if (primaryPosition < primaryDuration) {
                var _schedule;
                // last primary segment
                const timelineStart = primaryPosition;
                const integratedStart = integratedTime;
                const segmentDuration = primaryDuration - primaryPosition;
                integratedTime += segmentDuration;
                const playoutStart = playoutDuration;
                playoutDuration += segmentDuration;
                schedule.push({
                    previousEvent: ((_schedule = schedule[schedule.length - 1]) == null ? void 0 : _schedule.event) || null,
                    nextEvent: null,
                    start: primaryPosition,
                    end: timelineStart + segmentDuration,
                    playout: {
                        start: playoutStart,
                        end: playoutDuration
                    },
                    integrated: {
                        start: integratedStart,
                        end: integratedTime
                    }
                });
            }
            this.setDurations(primaryDuration, playoutDuration, integratedTime);
        } else {
            // no interstials - schedule is one primary segment
            const start = 0;
            schedule.push({
                previousEvent: null,
                nextEvent: null,
                start: start,
                end: primaryDuration,
                playout: {
                    start: start,
                    end: primaryDuration
                },
                integrated: {
                    start: start,
                    end: primaryDuration
                }
            });
            this.setDurations(primaryDuration, primaryDuration, primaryDuration);
        }
        return schedule;
    }
    setDurations(primary, playout, integrated) {
        this.durations = {
            primary: primary,
            playout: playout,
            integrated: integrated
        };
    }
    resolveOffsets(interstitialEvents, mediaSelection) {
        const details = mediaSelection.main.details;
        const primaryDuration = details.live ? Infinity : details.edge;
        // First resolve cumulative resumption offsets for Interstitials that start at the same DateTime
        let cumulativeDuration = 0;
        let lastScheduledStart = -1;
        interstitialEvents.forEach((interstitial, i)=>{
            const preroll = interstitial.cue.pre;
            const postroll = interstitial.cue.post;
            const eventStart = preroll ? 0 : postroll ? primaryDuration : interstitial.startTime;
            this.updateAssetDurations(interstitial);
            // X-RESUME-OFFSET values of interstitials scheduled at the same time are cumulative
            const inSameStartTimeSequence = lastScheduledStart === eventStart;
            if (inSameStartTimeSequence) interstitial.cumulativeDuration = cumulativeDuration;
            else {
                cumulativeDuration = 0;
                lastScheduledStart = eventStart;
            }
            if (!postroll && interstitial.snapOptions.in) // FIXME: Include audio playlist in snapping
            interstitial.resumeAnchor = $b941786f4eb9cb76$var$findFragmentByPTS(null, details.fragments, interstitial.startOffset + interstitial.resumptionOffset, 0, 0) || undefined;
            // Check if primary fragments align with resumption offset and disable appendInPlace if they do not
            if (interstitial.appendInPlace && !interstitial.appendInPlaceStarted) {
                const alignedSegmentStart = this.primaryCanResumeInPlaceAt(interstitial, mediaSelection);
                if (!alignedSegmentStart) interstitial.appendInPlace = false;
            }
            if (!interstitial.appendInPlace && i + 1 < interstitialEvents.length) {
                // abutting Interstitials must use the same MediaSource strategy, this applies to all whether or not they are back to back:
                const timeBetween = interstitialEvents[i + 1].startTime - interstitialEvents[i].resumeTime;
                if (timeBetween < $b941786f4eb9cb76$var$ABUTTING_THRESHOLD_SECONDS) {
                    interstitialEvents[i + 1].appendInPlace = false;
                    if (interstitialEvents[i + 1].appendInPlace) this.warn(`Could not change append strategy for abutting event ${interstitial}`);
                }
            }
            // Update cumulativeDuration for next abutting interstitial with the same start date
            const resumeOffset = $b941786f4eb9cb76$var$isFiniteNumber(interstitial.resumeOffset) ? interstitial.resumeOffset : interstitial.duration;
            cumulativeDuration += resumeOffset;
        });
    }
    primaryCanResumeInPlaceAt(interstitial, mediaSelection) {
        const resumeTime = interstitial.resumeTime;
        const resumesInPlaceAt = interstitial.startTime + interstitial.resumptionOffset;
        if (Math.abs(resumeTime - resumesInPlaceAt) > $b941786f4eb9cb76$var$ALIGNED_END_THRESHOLD_SECONDS) {
            this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with estimated timeline end ${resumesInPlaceAt}`);
            return false;
        }
        const playlists = Object.keys(mediaSelection);
        return !playlists.some((playlistType)=>{
            const details = mediaSelection[playlistType].details;
            const playlistEnd = details.edge;
            if (resumeTime >= playlistEnd) {
                // Live playback - resumption segments are not yet available
                this.log(`"${interstitial.identifier}" resumption ${resumeTime} past ${playlistType} playlist end ${playlistEnd}`);
                // Assume alignment is possible (or reset can take place)
                return false;
            }
            const startFragment = $b941786f4eb9cb76$var$findFragmentByPTS(null, details.fragments, resumeTime);
            if (!startFragment) {
                this.log(`"${interstitial.identifier}" resumption ${resumeTime} does not align with any fragments in ${playlistType} playlist (${details.fragStart}-${details.fragmentEnd})`);
                return true;
            }
            const allowance = playlistType === 'audio' ? 0.175 : 0;
            const alignedWithSegment = Math.abs(startFragment.start - resumeTime) < $b941786f4eb9cb76$var$ALIGNED_END_THRESHOLD_SECONDS + allowance || Math.abs(startFragment.end - resumeTime) < $b941786f4eb9cb76$var$ALIGNED_END_THRESHOLD_SECONDS + allowance;
            if (!alignedWithSegment) {
                this.log(`"${interstitial.identifier}" resumption ${resumeTime} not aligned with ${playlistType} fragment bounds (${startFragment.start}-${startFragment.end} sn: ${startFragment.sn} cc: ${startFragment.cc})`);
                return true;
            }
            return false;
        });
    }
    updateAssetDurations(interstitial) {
        if (!interstitial.assetListLoaded) return;
        const eventStart = interstitial.timelineStart;
        let sumDuration = 0;
        let hasUnknownDuration = false;
        let hasErrors = false;
        for(let i = 0; i < interstitial.assetList.length; i++){
            const asset = interstitial.assetList[i];
            const timelineStart = eventStart + sumDuration;
            asset.startOffset = sumDuration;
            asset.timelineStart = timelineStart;
            hasUnknownDuration || (hasUnknownDuration = asset.duration === null);
            hasErrors || (hasErrors = !!asset.error);
            const duration = asset.error ? 0 : asset.duration || 0;
            sumDuration += duration;
        }
        // Use the sum of known durations when it is greater than the stated duration
        if (hasUnknownDuration && !hasErrors) interstitial.duration = Math.max(sumDuration, interstitial.duration);
        else interstitial.duration = sumDuration;
    }
    removeEvent(interstitial) {
        interstitial.reset();
        delete this.eventMap[interstitial.identifier];
    }
}
function $b941786f4eb9cb76$var$segmentToString(segment) {
    return `[${segment.event ? '"' + segment.event.identifier + '"' : 'primary'}: ${segment.start.toFixed(2)}-${segment.end.toFixed(2)}]`;
}
class $b941786f4eb9cb76$var$AssetListLoader {
    constructor(hls){
        this.hls = void 0;
        this.hls = hls;
    }
    destroy() {
        // @ts-ignore
        this.hls = null;
    }
    loadAssetList(interstitial, hlsStartOffset) {
        const assetListUrl = interstitial.assetListUrl;
        let url;
        try {
            url = $b941786f4eb9cb76$var$getInterstitialUrl(assetListUrl, this.hls.sessionId, interstitial.baseUrl);
        } catch (error) {
            const errorData = this.assignAssetListError(interstitial, $b941786f4eb9cb76$export$d053ec805ce391aa.ASSET_LIST_LOAD_ERROR, error, assetListUrl);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, errorData);
            return;
        }
        if (hlsStartOffset && url.protocol !== 'data:') url.searchParams.set('_HLS_start_offset', '' + hlsStartOffset);
        const config = this.hls.config;
        const Loader = config.loader;
        const loader = new Loader(config);
        const context = {
            responseType: 'json',
            url: url.href
        };
        const loadPolicy = config.interstitialAssetListLoadPolicy.default;
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: 0,
            retryDelay: 0,
            maxRetryDelay: 0
        };
        const callbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                const assetListResponse = response.data;
                const assets = assetListResponse == null ? void 0 : assetListResponse.ASSETS;
                if (!Array.isArray(assets)) {
                    const errorData = this.assignAssetListError(interstitial, $b941786f4eb9cb76$export$d053ec805ce391aa.ASSET_LIST_PARSING_ERROR, new Error(`Invalid interstitial asset list`), context.url, stats, networkDetails);
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, errorData);
                    return;
                }
                interstitial.assetListResponse = assetListResponse;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ASSET_LIST_LOADED, {
                    event: interstitial,
                    assetListResponse: assetListResponse,
                    networkDetails: networkDetails
                });
            },
            onError: (error, context, networkDetails, stats)=>{
                const errorData = this.assignAssetListError(interstitial, $b941786f4eb9cb76$export$d053ec805ce391aa.ASSET_LIST_LOAD_ERROR, new Error(`Error loading X-ASSET-LIST: HTTP status ${error.code} ${error.text} (${context.url})`), context.url, stats, networkDetails);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, errorData);
            },
            onTimeout: (stats, context, networkDetails)=>{
                const errorData = this.assignAssetListError(interstitial, $b941786f4eb9cb76$export$d053ec805ce391aa.ASSET_LIST_LOAD_TIMEOUT, new Error(`Timeout loading X-ASSET-LIST (${context.url})`), context.url, stats, networkDetails);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, errorData);
            }
        };
        loader.load(context, loaderConfig, callbacks);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ASSET_LIST_LOADING, {
            event: interstitial
        });
        return loader;
    }
    assignAssetListError(interstitial, details, error, url, stats, networkDetails) {
        interstitial.error = error;
        return {
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: details,
            fatal: false,
            interstitial: interstitial,
            url: url,
            error: error,
            networkDetails: networkDetails,
            stats: stats
        };
    }
}
function $b941786f4eb9cb76$var$playWithCatch(media) {
    var _media$play;
    media == null || (_media$play = media.play()) == null || _media$play.catch(()=>{
    /* no-op */ });
}
function $b941786f4eb9cb76$var$timelineMessage(label, time1) {
    return `[${label}] Advancing timeline position to ${time1}`;
}
class $b941786f4eb9cb76$var$InterstitialsController extends $b941786f4eb9cb76$var$Logger {
    constructor(hls, HlsPlayerClass){
        super('interstitials', hls.logger);
        this.HlsPlayerClass = void 0;
        this.hls = void 0;
        this.assetListLoader = void 0;
        // Last updated LevelDetails
        this.mediaSelection = null;
        this.altSelection = null;
        // Media and MediaSource/SourceBuffers
        this.media = null;
        this.detachedData = null;
        this.requiredTracks = null;
        // Public Interface for Interstitial playback state and control
        this.manager = null;
        // Interstitial Asset Players
        this.playerQueue = [];
        // Timeline position tracking
        this.bufferedPos = -1;
        this.timelinePos = -1;
        // Schedule
        this.schedule = void 0;
        // Schedule playback and buffering state
        this.playingItem = null;
        this.bufferingItem = null;
        this.waitingItem = null;
        this.endedItem = null;
        this.playingAsset = null;
        this.endedAsset = null;
        this.bufferingAsset = null;
        this.shouldPlay = false;
        this.onPlay = ()=>{
            this.shouldPlay = true;
        };
        this.onPause = ()=>{
            this.shouldPlay = false;
        };
        this.onSeeking = ()=>{
            const currentTime = this.currentTime;
            if (currentTime === undefined || this.playbackDisabled || !this.schedule) return;
            const diff = currentTime - this.timelinePos;
            const roundingError = Math.abs(diff) < 1 / 705600000; // one flick
            if (roundingError) return;
            const backwardSeek = diff <= -0.01;
            this.timelinePos = currentTime;
            this.bufferedPos = currentTime;
            // Check if seeking out of an item
            const playingItem = this.playingItem;
            if (!playingItem) {
                this.checkBuffer();
                return;
            }
            if (backwardSeek) {
                const resetCount = this.schedule.resetErrorsInRange(currentTime, currentTime - diff);
                if (resetCount) this.updateSchedule(true);
            }
            this.checkBuffer();
            if (backwardSeek && currentTime < playingItem.start || currentTime >= playingItem.end) {
                var _this$media;
                const playingIndex = this.findItemIndex(playingItem);
                let scheduleIndex = this.schedule.findItemIndexAtTime(currentTime);
                if (scheduleIndex === -1) {
                    scheduleIndex = playingIndex + (backwardSeek ? -1 : 1);
                    this.log(`seeked ${backwardSeek ? 'back ' : ''}to position not covered by schedule ${currentTime} (resolving from ${playingIndex} to ${scheduleIndex})`);
                }
                if (!this.isInterstitial(playingItem) && (_this$media = this.media) != null && _this$media.paused) this.shouldPlay = false;
                if (!backwardSeek) // check if an Interstitial between the current item and target item has an X-RESTRICT JUMP restriction
                {
                    if (scheduleIndex > playingIndex) {
                        const jumpIndex = this.schedule.findJumpRestrictedIndex(playingIndex + 1, scheduleIndex);
                        if (jumpIndex > playingIndex) {
                            this.setSchedulePosition(jumpIndex);
                            return;
                        }
                    }
                }
                this.setSchedulePosition(scheduleIndex);
                return;
            }
            // Check if seeking out of an asset (assumes same item following above check)
            const playingAsset = this.playingAsset;
            if (!playingAsset) {
                // restart Interstitial at end
                if (this.playingLastItem && this.isInterstitial(playingItem)) {
                    const restartAsset = playingItem.event.assetList[0];
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (restartAsset) {
                        this.endedItem = this.playingItem;
                        this.playingItem = null;
                        this.setScheduleToAssetAtTime(currentTime, restartAsset);
                    }
                }
                return;
            }
            const start = playingAsset.timelineStart;
            const duration = playingAsset.duration || 0;
            if (backwardSeek && currentTime < start || currentTime >= start + duration) {
                var _playingItem$event;
                if ((_playingItem$event = playingItem.event) != null && _playingItem$event.appendInPlace) {
                    // Return SourceBuffer(s) to primary player and flush
                    this.clearAssetPlayers(playingItem.event, playingItem);
                    this.flushFrontBuffer(currentTime);
                }
                this.setScheduleToAssetAtTime(currentTime, playingAsset);
            }
        };
        this.onTimeupdate = ()=>{
            const currentTime = this.currentTime;
            if (currentTime === undefined || this.playbackDisabled) return;
            // Only allow timeupdate to advance primary position, seeking is used for jumping back
            // this prevents primaryPos from being reset to 0 after re-attach
            if (currentTime > this.timelinePos) {
                this.timelinePos = currentTime;
                if (currentTime > this.bufferedPos) this.checkBuffer();
            } else return;
            // Check if playback has entered the next item
            const playingItem = this.playingItem;
            if (!playingItem || this.playingLastItem) return;
            if (currentTime >= playingItem.end) {
                this.timelinePos = playingItem.end;
                const playingIndex = this.findItemIndex(playingItem);
                this.setSchedulePosition(playingIndex + 1);
            }
            // Check if playback has entered the next asset
            const playingAsset = this.playingAsset;
            if (!playingAsset) return;
            const end = playingAsset.timelineStart + (playingAsset.duration || 0);
            if (currentTime >= end) this.setScheduleToAssetAtTime(currentTime, playingAsset);
        };
        // Schedule update callback
        this.onScheduleUpdate = (removedInterstitials, previousItems)=>{
            const schedule = this.schedule;
            if (!schedule) return;
            const playingItem = this.playingItem;
            const interstitialEvents = schedule.events || [];
            const scheduleItems = schedule.items || [];
            const durations = schedule.durations;
            const removedIds = removedInterstitials.map((interstitial)=>interstitial.identifier);
            const interstitialsUpdated = !!(interstitialEvents.length || removedIds.length);
            if (interstitialsUpdated || previousItems) this.log(`INTERSTITIALS_UPDATED (${interstitialEvents.length}): ${interstitialEvents}
Schedule: ${scheduleItems.map((seg)=>$b941786f4eb9cb76$var$segmentToString(seg))} pos: ${this.timelinePos}`);
            if (removedIds.length) this.log(`Removed events ${removedIds}`);
            // Update schedule item references
            // Do not replace Interstitial playingItem without a match - used for INTERSTITIAL_ASSET_ENDED and INTERSTITIAL_ENDED
            let updatedPlayingItem = null;
            let updatedBufferingItem = null;
            if (playingItem) {
                updatedPlayingItem = this.updateItem(playingItem, this.timelinePos);
                if (this.itemsMatch(playingItem, updatedPlayingItem)) this.playingItem = updatedPlayingItem;
                else this.waitingItem = this.endedItem = null;
            }
            // Clear waitingItem if it has been removed from the schedule
            this.waitingItem = this.updateItem(this.waitingItem);
            this.endedItem = this.updateItem(this.endedItem);
            // Do not replace Interstitial bufferingItem without a match - used for transfering media element or source
            const bufferingItem = this.bufferingItem;
            if (bufferingItem) {
                updatedBufferingItem = this.updateItem(bufferingItem, this.bufferedPos);
                if (this.itemsMatch(bufferingItem, updatedBufferingItem)) this.bufferingItem = updatedBufferingItem;
                else if (bufferingItem.event) {
                    // Interstitial removed from schedule (Live -> VOD or other scenario where Start Date is outside the range of VOD Playlist)
                    this.bufferingItem = this.playingItem;
                    this.clearInterstitial(bufferingItem.event, null);
                }
            }
            removedInterstitials.forEach((interstitial)=>{
                interstitial.assetList.forEach((asset)=>{
                    this.clearAssetPlayer(asset.identifier, null);
                });
            });
            this.playerQueue.forEach((player)=>{
                if (player.interstitial.appendInPlace) {
                    const timelineStart = player.assetItem.timelineStart;
                    const diff = player.timelineOffset - timelineStart;
                    if (diff) try {
                        player.timelineOffset = timelineStart;
                    } catch (e) {
                        if (Math.abs(diff) > $b941786f4eb9cb76$var$ALIGNED_END_THRESHOLD_SECONDS) this.warn(`${e} ("${player.assetId}" ${player.timelineOffset}->${timelineStart})`);
                    }
                }
            });
            if (interstitialsUpdated || previousItems) {
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIALS_UPDATED, {
                    events: interstitialEvents.slice(0),
                    schedule: scheduleItems.slice(0),
                    durations: durations,
                    removedIds: removedIds
                });
                if (this.isInterstitial(playingItem) && removedIds.includes(playingItem.event.identifier)) {
                    this.warn(`Interstitial "${playingItem.event.identifier}" removed while playing`);
                    this.primaryFallback(playingItem.event);
                    return;
                }
                if (playingItem) this.trimInPlace(updatedPlayingItem, playingItem);
                if (bufferingItem && updatedBufferingItem !== updatedPlayingItem) this.trimInPlace(updatedBufferingItem, bufferingItem);
                // Check if buffered to new Interstitial event boundary
                // (Live update publishes Interstitial with new segment)
                this.checkBuffer();
            }
        };
        this.hls = hls;
        this.HlsPlayerClass = HlsPlayerClass;
        this.assetListLoader = new $b941786f4eb9cb76$var$AssetListLoader(hls);
        this.schedule = new $b941786f4eb9cb76$var$InterstitialsSchedule(this.onScheduleUpdate, hls.logger);
        this.registerListeners();
    }
    registerListeners() {
        const hls = this.hls;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (hls) {
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFERED_TO_END, this.onBufferedToEnd, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ENDED, this.onMediaEnded, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
        }
    }
    unregisterListeners() {
        const hls = this.hls;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (hls) {
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.ASSET_LIST_LOADED, this.onAssetListLoaded, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFERED_TO_END, this.onBufferedToEnd, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ENDED, this.onMediaEnded, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.DESTROYING, this.onDestroying, this);
        }
    }
    startLoad() {
        // TODO: startLoad - check for waitingItem and retry by resetting schedule
        this.resumeBuffering();
    }
    stopLoad() {
        // TODO: stopLoad - stop all scheule.events[].assetListLoader?.abort() then delete the loaders
        this.pauseBuffering();
    }
    resumeBuffering() {
        var _this$getBufferingPla;
        (_this$getBufferingPla = this.getBufferingPlayer()) == null || _this$getBufferingPla.resumeBuffering();
    }
    pauseBuffering() {
        var _this$getBufferingPla2;
        (_this$getBufferingPla2 = this.getBufferingPlayer()) == null || _this$getBufferingPla2.pauseBuffering();
    }
    destroy() {
        this.unregisterListeners();
        this.stopLoad();
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (this.assetListLoader) this.assetListLoader.destroy();
        this.emptyPlayerQueue();
        this.clearScheduleState();
        if (this.schedule) this.schedule.destroy();
        this.media = this.detachedData = this.mediaSelection = this.requiredTracks = this.altSelection = this.schedule = this.manager = null;
        // @ts-ignore
        this.hls = this.HlsPlayerClass = this.log = null;
        // @ts-ignore
        this.assetListLoader = null;
        // @ts-ignore
        this.onPlay = this.onPause = this.onSeeking = this.onTimeupdate = null;
        // @ts-ignore
        this.onScheduleUpdate = null;
    }
    onDestroying() {
        const media = this.primaryMedia || this.media;
        if (media) this.removeMediaListeners(media);
    }
    removeMediaListeners(media) {
        $b941786f4eb9cb76$var$removeEventListener(media, 'play', this.onPlay);
        $b941786f4eb9cb76$var$removeEventListener(media, 'pause', this.onPause);
        $b941786f4eb9cb76$var$removeEventListener(media, 'seeking', this.onSeeking);
        $b941786f4eb9cb76$var$removeEventListener(media, 'timeupdate', this.onTimeupdate);
    }
    onMediaAttaching(event, data) {
        const media = this.media = data.media;
        $b941786f4eb9cb76$var$addEventListener(media, 'seeking', this.onSeeking);
        $b941786f4eb9cb76$var$addEventListener(media, 'timeupdate', this.onTimeupdate);
        $b941786f4eb9cb76$var$addEventListener(media, 'play', this.onPlay);
        $b941786f4eb9cb76$var$addEventListener(media, 'pause', this.onPause);
    }
    onMediaAttached(event, data) {
        const playingItem = this.effectivePlayingItem;
        const detachedMedia = this.detachedData;
        this.detachedData = null;
        if (playingItem === null) this.checkStart();
        else if (!detachedMedia) {
            // Resume schedule after detached externally
            this.clearScheduleState();
            const playingIndex = this.findItemIndex(playingItem);
            this.setSchedulePosition(playingIndex);
        }
    }
    clearScheduleState() {
        this.log(`clear schedule state`);
        this.playingItem = this.bufferingItem = this.waitingItem = this.endedItem = this.playingAsset = this.endedAsset = this.bufferingAsset = null;
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        const media = this.media;
        this.media = null;
        if (transferringMedia) return;
        if (media) this.removeMediaListeners(media);
        // If detachMedia is called while in an Interstitial, detach the asset player as well and reset the schedule position
        if (this.detachedData) {
            const player = this.getBufferingPlayer();
            if (player) {
                this.log(`Removing schedule state for detachedData and ${player}`);
                this.playingAsset = this.endedAsset = this.bufferingAsset = this.bufferingItem = this.waitingItem = this.detachedData = null;
                player.detachMedia();
            }
            this.shouldPlay = false;
        }
    }
    get interstitialsManager() {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (!this.hls) return null;
        if (this.manager) return this.manager;
        const c = this;
        const effectiveBufferingItem = ()=>c.bufferingItem || c.waitingItem;
        const getAssetPlayer = (asset)=>asset ? c.getAssetPlayer(asset.identifier) : asset;
        const getMappedTime = (item, timelineType, asset, controllerField, assetPlayerField)=>{
            if (item) {
                let time1 = item[timelineType].start;
                const interstitial = item.event;
                if (interstitial) {
                    if (timelineType === 'playout' || interstitial.timelineOccupancy !== $b941786f4eb9cb76$var$TimelineOccupancy.Point) {
                        const assetPlayer = getAssetPlayer(asset);
                        if ((assetPlayer == null ? void 0 : assetPlayer.interstitial) === interstitial) time1 += assetPlayer.assetItem.startOffset + assetPlayer[assetPlayerField];
                    }
                } else {
                    const value = controllerField === 'bufferedPos' ? getBufferedEnd() : c[controllerField];
                    time1 += value - item.start;
                }
                return time1;
            }
            return 0;
        };
        const findMappedTime = (primaryTime, timelineType)=>{
            var _c$schedule;
            if (primaryTime !== 0 && timelineType !== 'primary' && (_c$schedule = c.schedule) != null && _c$schedule.length) {
                var _c$schedule$items;
                const index = c.schedule.findItemIndexAtTime(primaryTime);
                const item = (_c$schedule$items = c.schedule.items) == null ? void 0 : _c$schedule$items[index];
                if (item) {
                    const diff = item[timelineType].start - item.start;
                    return primaryTime + diff;
                }
            }
            return primaryTime;
        };
        const getBufferedEnd = ()=>{
            const value = c.bufferedPos;
            if (value === Number.MAX_VALUE) return getMappedDuration('primary');
            return Math.max(value, 0);
        };
        const getMappedDuration = (timelineType)=>{
            var _c$primaryDetails, _c$schedule2;
            if ((_c$primaryDetails = c.primaryDetails) != null && _c$primaryDetails.live) // return end of last event item or playlist
            return c.primaryDetails.edge;
            return ((_c$schedule2 = c.schedule) == null ? void 0 : _c$schedule2.durations[timelineType]) || 0;
        };
        const seekTo = (time1, timelineType)=>{
            var _item$event, _c$schedule$items2;
            const item = c.effectivePlayingItem;
            if (item != null && (_item$event = item.event) != null && _item$event.restrictions.skip || !c.schedule) return;
            c.log(`seek to ${time1} "${timelineType}"`);
            const playingItem = c.effectivePlayingItem;
            const targetIndex = c.schedule.findItemIndexAtTime(time1, timelineType);
            const targetItem = (_c$schedule$items2 = c.schedule.items) == null ? void 0 : _c$schedule$items2[targetIndex];
            const bufferingPlayer = c.getBufferingPlayer();
            const bufferingInterstitial = bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial;
            const appendInPlace = bufferingInterstitial == null ? void 0 : bufferingInterstitial.appendInPlace;
            const seekInItem = playingItem && c.itemsMatch(playingItem, targetItem);
            if (playingItem && (appendInPlace || seekInItem)) {
                // seek in asset player or primary media (appendInPlace)
                const assetPlayer = getAssetPlayer(c.playingAsset);
                const media = (assetPlayer == null ? void 0 : assetPlayer.media) || c.primaryMedia;
                if (media) {
                    const currentTime = timelineType === 'primary' ? media.currentTime : getMappedTime(playingItem, timelineType, c.playingAsset, 'timelinePos', 'currentTime');
                    const diff = time1 - currentTime;
                    const seekToTime = (appendInPlace ? currentTime : media.currentTime) + diff;
                    if (seekToTime >= 0 && (!assetPlayer || appendInPlace || seekToTime <= assetPlayer.duration)) {
                        media.currentTime = seekToTime;
                        return;
                    }
                }
            }
            // seek out of item or asset
            if (targetItem) {
                let seekToTime = time1;
                if (timelineType !== 'primary') {
                    const primarySegmentStart = targetItem[timelineType].start;
                    const diff = time1 - primarySegmentStart;
                    seekToTime = targetItem.start + diff;
                }
                const targetIsPrimary = !c.isInterstitial(targetItem);
                if ((!c.isInterstitial(playingItem) || playingItem.event.appendInPlace) && (targetIsPrimary || targetItem.event.appendInPlace)) {
                    const media = c.media || (appendInPlace ? bufferingPlayer == null ? void 0 : bufferingPlayer.media : null);
                    if (media) media.currentTime = seekToTime;
                } else if (playingItem) {
                    // check if an Interstitial between the current item and target item has an X-RESTRICT JUMP restriction
                    const playingIndex = c.findItemIndex(playingItem);
                    if (targetIndex > playingIndex) {
                        const jumpIndex = c.schedule.findJumpRestrictedIndex(playingIndex + 1, targetIndex);
                        if (jumpIndex > playingIndex) {
                            c.setSchedulePosition(jumpIndex);
                            return;
                        }
                    }
                    let assetIndex = 0;
                    if (targetIsPrimary) {
                        c.timelinePos = seekToTime;
                        c.checkBuffer();
                    } else {
                        const assetList = targetItem.event.assetList;
                        const eventTime = time1 - (targetItem[timelineType] || targetItem).start;
                        for(let i = assetList.length; i--;){
                            const asset = assetList[i];
                            if (asset.duration && eventTime >= asset.startOffset && eventTime < asset.startOffset + asset.duration) {
                                assetIndex = i;
                                break;
                            }
                        }
                    }
                    c.setSchedulePosition(targetIndex, assetIndex);
                }
            }
        };
        const getActiveInterstitial = ()=>{
            const playingItem = c.effectivePlayingItem;
            if (c.isInterstitial(playingItem)) return playingItem;
            const bufferingItem = effectiveBufferingItem();
            if (c.isInterstitial(bufferingItem)) return bufferingItem;
            return null;
        };
        const interstitialPlayer = {
            get bufferedEnd () {
                const interstitialItem = effectiveBufferingItem();
                const bufferingItem = c.bufferingItem;
                if (bufferingItem && bufferingItem === interstitialItem) {
                    var _c$bufferingAsset;
                    return getMappedTime(bufferingItem, 'playout', c.bufferingAsset, 'bufferedPos', 'bufferedEnd') - bufferingItem.playout.start || ((_c$bufferingAsset = c.bufferingAsset) == null ? void 0 : _c$bufferingAsset.startOffset) || 0;
                }
                return 0;
            },
            get currentTime () {
                const interstitialItem = getActiveInterstitial();
                const playingItem = c.effectivePlayingItem;
                if (playingItem && playingItem === interstitialItem) return getMappedTime(playingItem, 'playout', c.effectivePlayingAsset, 'timelinePos', 'currentTime') - playingItem.playout.start;
                return 0;
            },
            set currentTime (time){
                const interstitialItem = getActiveInterstitial();
                const playingItem = c.effectivePlayingItem;
                if (playingItem && playingItem === interstitialItem) seekTo(time + playingItem.playout.start, 'playout');
            },
            get duration () {
                const interstitialItem = getActiveInterstitial();
                if (interstitialItem) return interstitialItem.playout.end - interstitialItem.playout.start;
                return 0;
            },
            get assetPlayers () {
                var _getActiveInterstitia;
                const assetList = (_getActiveInterstitia = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia.event.assetList;
                if (assetList) return assetList.map((asset)=>c.getAssetPlayer(asset.identifier));
                return [];
            },
            get playingIndex () {
                var _getActiveInterstitia2;
                const interstitial = (_getActiveInterstitia2 = getActiveInterstitial()) == null ? void 0 : _getActiveInterstitia2.event;
                if (interstitial && c.effectivePlayingAsset) return interstitial.findAssetIndex(c.effectivePlayingAsset);
                return -1;
            },
            get scheduleItem () {
                return getActiveInterstitial();
            }
        };
        return this.manager = {
            get events () {
                var _c$schedule3;
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                return ((_c$schedule3 = c.schedule) == null || (_c$schedule3 = _c$schedule3.events) == null ? void 0 : _c$schedule3.slice(0)) || [];
            },
            get schedule () {
                var _c$schedule4;
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                return ((_c$schedule4 = c.schedule) == null || (_c$schedule4 = _c$schedule4.items) == null ? void 0 : _c$schedule4.slice(0)) || [];
            },
            get interstitialPlayer () {
                if (getActiveInterstitial()) return interstitialPlayer;
                return null;
            },
            get playerQueue () {
                return c.playerQueue.slice(0);
            },
            get bufferingAsset () {
                return c.bufferingAsset;
            },
            get bufferingItem () {
                return effectiveBufferingItem();
            },
            get bufferingIndex () {
                const item = effectiveBufferingItem();
                return c.findItemIndex(item);
            },
            get playingAsset () {
                return c.effectivePlayingAsset;
            },
            get playingItem () {
                return c.effectivePlayingItem;
            },
            get playingIndex () {
                const item = c.effectivePlayingItem;
                return c.findItemIndex(item);
            },
            primary: {
                get bufferedEnd () {
                    return getBufferedEnd();
                },
                get currentTime () {
                    const timelinePos = c.timelinePos;
                    return timelinePos > 0 ? timelinePos : 0;
                },
                set currentTime (time){
                    seekTo(time, 'primary');
                },
                get duration () {
                    return getMappedDuration('primary');
                },
                get seekableStart () {
                    var _c$primaryDetails2;
                    return ((_c$primaryDetails2 = c.primaryDetails) == null ? void 0 : _c$primaryDetails2.fragmentStart) || 0;
                }
            },
            integrated: {
                get bufferedEnd () {
                    return getMappedTime(effectiveBufferingItem(), 'integrated', c.bufferingAsset, 'bufferedPos', 'bufferedEnd');
                },
                get currentTime () {
                    return getMappedTime(c.effectivePlayingItem, 'integrated', c.effectivePlayingAsset, 'timelinePos', 'currentTime');
                },
                set currentTime (time){
                    seekTo(time, 'integrated');
                },
                get duration () {
                    return getMappedDuration('integrated');
                },
                get seekableStart () {
                    var _c$primaryDetails3;
                    return findMappedTime(((_c$primaryDetails3 = c.primaryDetails) == null ? void 0 : _c$primaryDetails3.fragmentStart) || 0, 'integrated');
                }
            },
            skip: ()=>{
                const item = c.effectivePlayingItem;
                const event = item == null ? void 0 : item.event;
                if (event && !event.restrictions.skip) {
                    const index = c.findItemIndex(item);
                    if (event.appendInPlace) {
                        const time1 = item.playout.start + item.event.duration;
                        seekTo(time1 + 0.001, 'playout');
                    } else c.advanceAfterAssetEnded(event, index, Infinity);
                }
            }
        };
    }
    // Schedule getters
    get effectivePlayingItem() {
        return this.waitingItem || this.playingItem || this.endedItem;
    }
    get effectivePlayingAsset() {
        return this.playingAsset || this.endedAsset;
    }
    get playingLastItem() {
        var _this$schedule;
        const playingItem = this.playingItem;
        const items = (_this$schedule = this.schedule) == null ? void 0 : _this$schedule.items;
        if (!this.playbackStarted || !playingItem || !items) return false;
        return this.findItemIndex(playingItem) === items.length - 1;
    }
    get playbackStarted() {
        return this.effectivePlayingItem !== null;
    }
    // Media getters and event callbacks
    get currentTime() {
        var _this$bufferingItem, _media;
        if (this.mediaSelection === null) // Do not advance before schedule is known
        return undefined;
        // Ignore currentTime when detached for Interstitial playback with source reset
        const queuedForPlayback = this.waitingItem || this.playingItem;
        if (this.isInterstitial(queuedForPlayback) && !queuedForPlayback.event.appendInPlace) return undefined;
        let media = this.media;
        if (!media && (_this$bufferingItem = this.bufferingItem) != null && (_this$bufferingItem = _this$bufferingItem.event) != null && _this$bufferingItem.appendInPlace) // Observe detached media currentTime when appending in place
        media = this.primaryMedia;
        const currentTime = (_media = media) == null ? void 0 : _media.currentTime;
        if (currentTime === undefined || !$b941786f4eb9cb76$var$isFiniteNumber(currentTime)) return undefined;
        return currentTime;
    }
    get primaryMedia() {
        var _this$detachedData;
        return this.media || ((_this$detachedData = this.detachedData) == null ? void 0 : _this$detachedData.media) || null;
    }
    isInterstitial(item) {
        return !!(item != null && item.event);
    }
    retreiveMediaSource(assetId, toSegment) {
        const player = this.getAssetPlayer(assetId);
        if (player) this.transferMediaFromPlayer(player, toSegment);
    }
    transferMediaFromPlayer(player, toSegment) {
        const appendInPlace = player.interstitial.appendInPlace;
        const playerMedia = player.media;
        if (appendInPlace && playerMedia === this.primaryMedia) {
            this.bufferingAsset = null;
            if (!toSegment || this.isInterstitial(toSegment) && !toSegment.event.appendInPlace) // MediaSource cannot be transfered back to an Interstitial that requires a source reset
            // no-op when toSegment is undefined
            {
                if (toSegment && playerMedia) {
                    this.detachedData = {
                        media: playerMedia
                    };
                    return;
                }
            }
            const attachMediaSourceData = player.transferMedia();
            this.log(`transfer MediaSource from ${player} ${$b941786f4eb9cb76$var$stringify(attachMediaSourceData)}`);
            this.detachedData = attachMediaSourceData;
        } else if (toSegment && playerMedia) this.shouldPlay || (this.shouldPlay = !playerMedia.paused);
    }
    transferMediaTo(player, media) {
        var _this$detachedData2, _attachMediaSourceDat;
        if (player.media === media) return;
        let attachMediaSourceData = null;
        const primaryPlayer = this.hls;
        const isAssetPlayer = player !== primaryPlayer;
        const appendInPlace = isAssetPlayer && player.interstitial.appendInPlace;
        const detachedMediaSource = (_this$detachedData2 = this.detachedData) == null ? void 0 : _this$detachedData2.mediaSource;
        let logFromSource;
        if (primaryPlayer.media) {
            if (appendInPlace) {
                attachMediaSourceData = primaryPlayer.transferMedia();
                this.detachedData = attachMediaSourceData;
            }
            logFromSource = `Primary`;
        } else if (detachedMediaSource) {
            const bufferingPlayer = this.getBufferingPlayer();
            if (bufferingPlayer) {
                attachMediaSourceData = bufferingPlayer.transferMedia();
                logFromSource = `${bufferingPlayer}`;
            } else logFromSource = `detached MediaSource`;
        } else logFromSource = `detached media`;
        if (!attachMediaSourceData) {
            if (detachedMediaSource) {
                attachMediaSourceData = this.detachedData;
                this.log(`using detachedData: MediaSource ${$b941786f4eb9cb76$var$stringify(attachMediaSourceData)}`);
            } else if (!this.detachedData || primaryPlayer.media === media) {
                // Keep interstitial media transition consistent
                const playerQueue = this.playerQueue;
                if (playerQueue.length > 1) playerQueue.forEach((queuedPlayer)=>{
                    if (isAssetPlayer && queuedPlayer.interstitial.appendInPlace !== appendInPlace) {
                        const interstitial = queuedPlayer.interstitial;
                        this.clearInterstitial(queuedPlayer.interstitial, null);
                        interstitial.appendInPlace = false; // setter may be a no-op;
                        // `appendInPlace` getter may still return `true` after insterstitial streaming has begun in that mode.
                        if (interstitial.appendInPlace) this.warn(`Could not change append strategy for queued assets ${interstitial}`);
                    }
                });
                this.hls.detachMedia();
                this.detachedData = {
                    media: media
                };
            }
        }
        const transferring = attachMediaSourceData && 'mediaSource' in attachMediaSourceData && ((_attachMediaSourceDat = attachMediaSourceData.mediaSource) == null ? void 0 : _attachMediaSourceDat.readyState) !== 'closed';
        const dataToAttach = transferring && attachMediaSourceData ? attachMediaSourceData : media;
        this.log(`${transferring ? 'transfering MediaSource' : 'attaching media'} to ${isAssetPlayer ? player : 'Primary'} from ${logFromSource} (media.currentTime: ${media.currentTime})`);
        const schedule = this.schedule;
        if (dataToAttach === attachMediaSourceData && schedule) {
            const isAssetAtEndOfSchedule = isAssetPlayer && player.assetId === schedule.assetIdAtEnd;
            // Prevent asset players from marking EoS on transferred MediaSource
            dataToAttach.overrides = {
                duration: schedule.duration,
                endOfStream: !isAssetPlayer || isAssetAtEndOfSchedule,
                cueRemoval: !isAssetPlayer
            };
        }
        player.attachMedia(dataToAttach);
    }
    onInterstitialCueEnter() {
        this.onTimeupdate();
    }
    // Scheduling methods
    checkStart() {
        const schedule = this.schedule;
        const interstitialEvents = schedule == null ? void 0 : schedule.events;
        if (!interstitialEvents || this.playbackDisabled || !this.media) return;
        // Check buffered to pre-roll
        if (this.bufferedPos === -1) this.bufferedPos = 0;
        // Start stepping through schedule when playback begins for the first time and we have a pre-roll
        const timelinePos = this.timelinePos;
        const effectivePlayingItem = this.effectivePlayingItem;
        if (timelinePos === -1) {
            const startPosition = this.hls.startPosition;
            this.log($b941786f4eb9cb76$var$timelineMessage('checkStart', startPosition));
            this.timelinePos = startPosition;
            if (interstitialEvents.length && interstitialEvents[0].cue.pre) {
                const index = schedule.findEventIndex(interstitialEvents[0].identifier);
                this.setSchedulePosition(index);
            } else if (startPosition >= 0 || !this.primaryLive) {
                const start = this.timelinePos = startPosition > 0 ? startPosition : 0;
                const index = schedule.findItemIndexAtTime(start);
                this.setSchedulePosition(index);
            }
        } else if (effectivePlayingItem && !this.playingItem) {
            const index = schedule.findItemIndex(effectivePlayingItem);
            this.setSchedulePosition(index);
        }
    }
    advanceAssetBuffering(item, assetItem) {
        const interstitial = item.event;
        const assetListIndex = interstitial.findAssetIndex(assetItem);
        const nextAssetIndex = $b941786f4eb9cb76$var$getNextAssetIndex(interstitial, assetListIndex);
        if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) this.bufferedToEvent(item, nextAssetIndex);
        else if (this.schedule) {
            var _this$schedule$items;
            const nextItem = (_this$schedule$items = this.schedule.items) == null ? void 0 : _this$schedule$items[this.findItemIndex(item) + 1];
            if (nextItem) this.bufferedToItem(nextItem);
        }
    }
    advanceAfterAssetEnded(interstitial, index, assetListIndex) {
        const nextAssetIndex = $b941786f4eb9cb76$var$getNextAssetIndex(interstitial, assetListIndex);
        if (!interstitial.isAssetPastPlayoutLimit(nextAssetIndex)) {
            // Advance to next asset list item
            if (interstitial.appendInPlace) {
                const assetItem = interstitial.assetList[nextAssetIndex];
                if (assetItem) this.advanceInPlace(assetItem.timelineStart);
            }
            this.setSchedulePosition(index, nextAssetIndex);
        } else if (this.schedule) {
            // Advance to next schedule segment
            // check if we've reached the end of the program
            const scheduleItems = this.schedule.items;
            if (scheduleItems) {
                const nextIndex = index + 1;
                const scheduleLength = scheduleItems.length;
                if (nextIndex >= scheduleLength) {
                    this.setSchedulePosition(-1);
                    return;
                }
                const resumptionTime = interstitial.resumeTime;
                if (this.timelinePos < resumptionTime) {
                    this.log($b941786f4eb9cb76$var$timelineMessage('advanceAfterAssetEnded', resumptionTime));
                    this.timelinePos = resumptionTime;
                    if (interstitial.appendInPlace) this.advanceInPlace(resumptionTime);
                    this.checkBuffer(this.bufferedPos < resumptionTime);
                }
                this.setSchedulePosition(nextIndex);
            }
        }
    }
    setScheduleToAssetAtTime(time1, playingAsset) {
        const schedule = this.schedule;
        if (!schedule) return;
        const parentIdentifier = playingAsset.parentIdentifier;
        const interstitial = schedule.getEvent(parentIdentifier);
        if (interstitial) {
            const itemIndex = schedule.findEventIndex(parentIdentifier);
            const assetListIndex = schedule.findAssetIndex(interstitial, time1);
            this.advanceAfterAssetEnded(interstitial, itemIndex, assetListIndex - 1);
        }
    }
    setSchedulePosition(index, assetListIndex) {
        var _this$schedule2;
        const scheduleItems = (_this$schedule2 = this.schedule) == null ? void 0 : _this$schedule2.items;
        if (!scheduleItems || this.playbackDisabled) return;
        const scheduledItem = index >= 0 ? scheduleItems[index] : null;
        this.log(`setSchedulePosition ${index}, ${assetListIndex} (${scheduledItem ? $b941786f4eb9cb76$var$segmentToString(scheduledItem) : scheduledItem}) pos: ${this.timelinePos}`);
        // Cleanup current item / asset
        const currentItem = this.waitingItem || this.playingItem;
        const playingLastItem = this.playingLastItem;
        if (this.isInterstitial(currentItem)) {
            const interstitial = currentItem.event;
            const playingAsset = this.playingAsset;
            const assetId = playingAsset == null ? void 0 : playingAsset.identifier;
            const player = assetId ? this.getAssetPlayer(assetId) : null;
            if (player && assetId && (!this.eventItemsMatch(currentItem, scheduledItem) || assetListIndex !== undefined && assetId !== interstitial.assetList[assetListIndex].identifier)) {
                var _this$detachedData3;
                const playingAssetListIndex = interstitial.findAssetIndex(playingAsset);
                this.log(`INTERSTITIAL_ASSET_ENDED ${playingAssetListIndex + 1}/${interstitial.assetList.length} ${$b941786f4eb9cb76$var$eventAssetToString(playingAsset)}`);
                this.endedAsset = playingAsset;
                this.playingAsset = null;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIAL_ASSET_ENDED, {
                    asset: playingAsset,
                    assetListIndex: playingAssetListIndex,
                    event: interstitial,
                    schedule: scheduleItems.slice(0),
                    scheduleIndex: index,
                    player: player
                });
                if (currentItem !== this.playingItem) {
                    // Schedule change occured on INTERSTITIAL_ASSET_ENDED
                    if (this.itemsMatch(currentItem, this.playingItem) && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    !this.playingAsset // INTERSTITIAL_ASSET_ENDED side-effect
                    ) this.advanceAfterAssetEnded(interstitial, this.findItemIndex(this.playingItem), playingAssetListIndex);
                    // Navigation occured on INTERSTITIAL_ASSET_ENDED
                    return;
                }
                this.retreiveMediaSource(assetId, scheduledItem);
                if (player.media && !((_this$detachedData3 = this.detachedData) != null && _this$detachedData3.mediaSource)) player.detachMedia();
            }
            if (!this.eventItemsMatch(currentItem, scheduledItem)) {
                this.endedItem = currentItem;
                this.playingItem = null;
                this.log(`INTERSTITIAL_ENDED ${interstitial} ${$b941786f4eb9cb76$var$segmentToString(currentItem)}`);
                interstitial.hasPlayed = true;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIAL_ENDED, {
                    event: interstitial,
                    schedule: scheduleItems.slice(0),
                    scheduleIndex: index
                });
                // Exiting an Interstitial
                if (interstitial.cue.once) {
                    var _this$schedule3;
                    // Remove interstitial with CUE attribute value of ONCE after it has played
                    this.updateSchedule();
                    const updatedScheduleItems = (_this$schedule3 = this.schedule) == null ? void 0 : _this$schedule3.items;
                    if (scheduledItem && updatedScheduleItems) {
                        const updatedIndex = this.findItemIndex(scheduledItem);
                        this.advanceSchedule(updatedIndex, updatedScheduleItems, assetListIndex, currentItem, playingLastItem);
                    }
                    return;
                }
            }
        }
        this.advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playingLastItem);
    }
    advanceSchedule(index, scheduleItems, assetListIndex, currentItem, playedLastItem) {
        const schedule = this.schedule;
        if (!schedule) return;
        const scheduledItem = scheduleItems[index] || null;
        const media = this.primaryMedia;
        // Cleanup out of range Interstitials
        const playerQueue = this.playerQueue;
        if (playerQueue.length) playerQueue.forEach((player)=>{
            const interstitial = player.interstitial;
            const queuedIndex = schedule.findEventIndex(interstitial.identifier);
            if (queuedIndex < index || queuedIndex > index + 1) this.clearInterstitial(interstitial, scheduledItem);
        });
        // Setup scheduled item
        if (this.isInterstitial(scheduledItem)) {
            this.timelinePos = Math.min(Math.max(this.timelinePos, scheduledItem.start), scheduledItem.end);
            // Handle Interstitial
            const interstitial = scheduledItem.event;
            // find asset index
            if (assetListIndex === undefined) {
                assetListIndex = schedule.findAssetIndex(interstitial, this.timelinePos);
                const assetIndexCandidate = $b941786f4eb9cb76$var$getNextAssetIndex(interstitial, assetListIndex - 1);
                if (interstitial.isAssetPastPlayoutLimit(assetIndexCandidate) || interstitial.appendInPlace && this.timelinePos === scheduledItem.end) {
                    this.advanceAfterAssetEnded(interstitial, index, assetListIndex);
                    return;
                }
                assetListIndex = assetIndexCandidate;
            }
            // Ensure Interstitial is enqueued
            const waitingItem = this.waitingItem;
            if (!this.assetsBuffered(scheduledItem, media)) this.setBufferingItem(scheduledItem);
            let player = this.preloadAssets(interstitial, assetListIndex);
            if (!this.eventItemsMatch(scheduledItem, waitingItem || currentItem)) {
                this.waitingItem = scheduledItem;
                this.log(`INTERSTITIAL_STARTED ${$b941786f4eb9cb76$var$segmentToString(scheduledItem)} ${interstitial.appendInPlace ? 'append in place' : ''}`);
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIAL_STARTED, {
                    event: interstitial,
                    schedule: scheduleItems.slice(0),
                    scheduleIndex: index
                });
            }
            if (!interstitial.assetListLoaded) {
                // Waiting at end of primary content segment
                // Expect setSchedulePosition to be called again once ASSET-LIST is loaded
                this.log(`Waiting for ASSET-LIST to complete loading ${interstitial}`);
                return;
            }
            if (interstitial.assetListLoader) {
                interstitial.assetListLoader.destroy();
                interstitial.assetListLoader = undefined;
            }
            if (!media) {
                this.log(`Waiting for attachMedia to start Interstitial ${interstitial}`);
                return;
            }
            // Update schedule and asset list position now that it can start
            this.waitingItem = this.endedItem = null;
            this.playingItem = scheduledItem;
            // If asset-list is empty or missing asset index, advance to next item
            const assetItem = interstitial.assetList[assetListIndex];
            if (!assetItem) {
                this.advanceAfterAssetEnded(interstitial, index, assetListIndex || 0);
                return;
            }
            // Start Interstitial Playback
            if (!player) player = this.getAssetPlayer(assetItem.identifier);
            if (player === null || player.destroyed) {
                const assetListLength = interstitial.assetList.length;
                this.warn(`asset ${assetListIndex + 1}/${assetListLength} player destroyed ${interstitial}`);
                player = this.createAssetPlayer(interstitial, assetItem, assetListIndex);
                player.loadSource();
            }
            if (!this.eventItemsMatch(scheduledItem, this.bufferingItem)) {
                if (interstitial.appendInPlace && this.isAssetBuffered(assetItem)) return;
            }
            this.startAssetPlayer(player, assetListIndex, scheduleItems, index, media);
            if (this.shouldPlay) $b941786f4eb9cb76$var$playWithCatch(player.media);
        } else if (scheduledItem) {
            this.resumePrimary(scheduledItem, index, currentItem);
            if (this.shouldPlay) $b941786f4eb9cb76$var$playWithCatch(this.hls.media);
        } else if (playedLastItem && this.isInterstitial(currentItem)) {
            // Maintain playingItem state at end of schedule (setSchedulePosition(-1) called to end program)
            // this allows onSeeking handler to update schedule position
            this.endedItem = null;
            this.playingItem = currentItem;
            if (!currentItem.event.appendInPlace) // Media must be re-attached to resume primary schedule if not sharing source
            this.attachPrimary(schedule.durations.primary, null);
        }
    }
    get playbackDisabled() {
        return this.hls.config.enableInterstitialPlayback === false;
    }
    get primaryDetails() {
        var _this$mediaSelection;
        return (_this$mediaSelection = this.mediaSelection) == null ? void 0 : _this$mediaSelection.main.details;
    }
    get primaryLive() {
        var _this$primaryDetails;
        return !!((_this$primaryDetails = this.primaryDetails) != null && _this$primaryDetails.live);
    }
    resumePrimary(scheduledItem, index, fromItem) {
        var _this$detachedData4, _this$schedule4;
        this.playingItem = scheduledItem;
        this.playingAsset = this.endedAsset = null;
        this.waitingItem = this.endedItem = null;
        this.bufferedToItem(scheduledItem);
        this.log(`resuming ${$b941786f4eb9cb76$var$segmentToString(scheduledItem)}`);
        if (!((_this$detachedData4 = this.detachedData) != null && _this$detachedData4.mediaSource)) {
            let timelinePos = this.timelinePos;
            if (timelinePos < scheduledItem.start || timelinePos >= scheduledItem.end) {
                timelinePos = this.getPrimaryResumption(scheduledItem, index);
                this.log($b941786f4eb9cb76$var$timelineMessage('resumePrimary', timelinePos));
                this.timelinePos = timelinePos;
            }
            this.attachPrimary(timelinePos, scheduledItem);
        }
        if (!fromItem) return;
        const scheduleItems = (_this$schedule4 = this.schedule) == null ? void 0 : _this$schedule4.items;
        if (!scheduleItems) return;
        this.log(`INTERSTITIALS_PRIMARY_RESUMED ${$b941786f4eb9cb76$var$segmentToString(scheduledItem)}`);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIALS_PRIMARY_RESUMED, {
            schedule: scheduleItems.slice(0),
            scheduleIndex: index
        });
        this.checkBuffer();
    }
    getPrimaryResumption(scheduledItem, index) {
        const itemStart = scheduledItem.start;
        if (this.primaryLive) {
            const details = this.primaryDetails;
            if (index === 0) return this.hls.startPosition;
            else if (details && (itemStart < details.fragmentStart || itemStart > details.edge)) return this.hls.liveSyncPosition || -1;
        }
        return itemStart;
    }
    isAssetBuffered(asset) {
        const player = this.getAssetPlayer(asset.identifier);
        if (player != null && player.hls) return player.hls.bufferedToEnd;
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0);
        return bufferInfo.end + 1 >= asset.timelineStart + (asset.duration || 0);
    }
    attachPrimary(timelinePos, item, skipSeekToStartPosition) {
        if (item) this.setBufferingItem(item);
        else this.bufferingItem = this.playingItem;
        this.bufferingAsset = null;
        const media = this.primaryMedia;
        if (!media) return;
        const hls = this.hls;
        if (hls.media) this.checkBuffer();
        else {
            this.transferMediaTo(hls, media);
            if (skipSeekToStartPosition) this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
        }
        if (!skipSeekToStartPosition) {
            // Set primary position to resume time
            this.log($b941786f4eb9cb76$var$timelineMessage('attachPrimary', timelinePos));
            this.timelinePos = timelinePos;
            this.startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition);
        }
    }
    startLoadingPrimaryAt(timelinePos, skipSeekToStartPosition) {
        var _hls$mainForwardBuffe;
        const hls = this.hls;
        if (!hls.loadingEnabled || !hls.media || Math.abs((((_hls$mainForwardBuffe = hls.mainForwardBufferInfo) == null ? void 0 : _hls$mainForwardBuffe.start) || hls.media.currentTime) - timelinePos) > 0.5) hls.startLoad(timelinePos, skipSeekToStartPosition);
        else if (!hls.bufferingEnabled) hls.resumeBuffering();
    }
    // HLS.js event callbacks
    onManifestLoading() {
        var _this$schedule5;
        this.stopLoad();
        (_this$schedule5 = this.schedule) == null || _this$schedule5.reset();
        this.emptyPlayerQueue();
        this.clearScheduleState();
        this.shouldPlay = false;
        this.bufferedPos = this.timelinePos = -1;
        this.mediaSelection = this.altSelection = this.manager = this.requiredTracks = null;
        // BUFFER_CODECS listener added here for buffer-controller to handle it first where it adds tracks
        this.hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
        this.hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, this.onBufferCodecs, this);
    }
    onLevelUpdated(event, data) {
        if (data.level === -1 || !this.schedule) // level was removed
        return;
        const main = this.hls.levels[data.level];
        if (!main.details) return;
        const currentSelection = $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, this.mediaSelection || this.altSelection), {}, {
            main: main
        });
        this.mediaSelection = currentSelection;
        this.schedule.parseInterstitialDateRanges(currentSelection, this.hls.config.interstitialAppendInPlace);
        if (!this.effectivePlayingItem && this.schedule.items) this.checkStart();
    }
    onAudioTrackUpdated(event, data) {
        const audio = this.hls.audioTracks[data.id];
        const previousSelection = this.mediaSelection;
        if (!previousSelection) {
            this.altSelection = $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, this.altSelection), {}, {
                audio: audio
            });
            return;
        }
        const currentSelection = $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, previousSelection), {}, {
            audio: audio
        });
        this.mediaSelection = currentSelection;
    }
    onSubtitleTrackUpdated(event, data) {
        const subtitles = this.hls.subtitleTracks[data.id];
        const previousSelection = this.mediaSelection;
        if (!previousSelection) {
            this.altSelection = $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, this.altSelection), {}, {
                subtitles: subtitles
            });
            return;
        }
        const currentSelection = $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, previousSelection), {}, {
            subtitles: subtitles
        });
        this.mediaSelection = currentSelection;
    }
    onAudioTrackSwitching(event, data) {
        const audioOption = $b941786f4eb9cb76$var$getBasicSelectionOption(data);
        this.playerQueue.forEach(({ hls: hls })=>hls && (hls.setAudioOption(data) || hls.setAudioOption(audioOption)));
    }
    onSubtitleTrackSwitch(event, data) {
        const subtitleOption = $b941786f4eb9cb76$var$getBasicSelectionOption(data);
        this.playerQueue.forEach(({ hls: hls })=>hls && (hls.setSubtitleOption(data) || data.id !== -1 && hls.setSubtitleOption(subtitleOption)));
    }
    onBufferCodecs(event, data) {
        const requiredTracks = data.tracks;
        if (requiredTracks) this.requiredTracks = requiredTracks;
    }
    onBufferAppended(event, data) {
        this.checkBuffer();
    }
    onBufferFlushed(event, data) {
        const playingItem = this.playingItem;
        if (playingItem && !this.itemsMatch(playingItem, this.bufferingItem) && !this.isInterstitial(playingItem)) {
            const timelinePos = this.timelinePos;
            this.bufferedPos = timelinePos;
            this.checkBuffer();
        }
    }
    onBufferedToEnd(event) {
        if (!this.schedule) return;
        // Buffered to post-roll
        const interstitialEvents = this.schedule.events;
        if (this.bufferedPos < Number.MAX_VALUE && interstitialEvents) {
            for(let i = 0; i < interstitialEvents.length; i++){
                const interstitial = interstitialEvents[i];
                if (interstitial.cue.post) {
                    var _this$schedule$items2;
                    const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
                    const item = (_this$schedule$items2 = this.schedule.items) == null ? void 0 : _this$schedule$items2[scheduleIndex];
                    if (this.isInterstitial(item) && this.eventItemsMatch(item, this.bufferingItem)) this.bufferedToItem(item, 0);
                    break;
                }
            }
            this.bufferedPos = Number.MAX_VALUE;
        }
    }
    onMediaEnded(event) {
        const playingItem = this.playingItem;
        if (!this.playingLastItem && playingItem) {
            const playingIndex = this.findItemIndex(playingItem);
            this.setSchedulePosition(playingIndex + 1);
        } else this.shouldPlay = false;
    }
    updateItem(previousItem, time1) {
        var _this$schedule6;
        // find item in this.schedule.items;
        const items = (_this$schedule6 = this.schedule) == null ? void 0 : _this$schedule6.items;
        if (previousItem && items) {
            const index = this.findItemIndex(previousItem, time1);
            return items[index] || null;
        }
        return null;
    }
    trimInPlace(updatedItem, itemBeforeUpdate) {
        if (this.isInterstitial(updatedItem) && updatedItem.event.appendInPlace && itemBeforeUpdate.end - updatedItem.end > 0.25) {
            updatedItem.event.assetList.forEach((asset, index)=>{
                if (updatedItem.event.isAssetPastPlayoutLimit(index)) this.clearAssetPlayer(asset.identifier, null);
            });
            const flushStart = updatedItem.end + 0.25;
            const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(this.primaryMedia, flushStart, 0);
            if (bufferInfo.end > flushStart || (bufferInfo.nextStart || 0) > flushStart) {
                this.log(`trim buffered interstitial ${$b941786f4eb9cb76$var$segmentToString(updatedItem)} (was ${$b941786f4eb9cb76$var$segmentToString(itemBeforeUpdate)})`);
                const skipSeekToStartPosition = true;
                this.attachPrimary(flushStart, null, skipSeekToStartPosition);
                this.flushFrontBuffer(flushStart);
            }
        }
    }
    itemsMatch(a, b) {
        return !!b && (a === b || a.event && b.event && this.eventItemsMatch(a, b) || !a.event && !b.event && this.findItemIndex(a) === this.findItemIndex(b));
    }
    eventItemsMatch(a, b) {
        var _b$event;
        return !!b && (a === b || a.event.identifier === ((_b$event = b.event) == null ? void 0 : _b$event.identifier));
    }
    findItemIndex(item, time1) {
        return item && this.schedule ? this.schedule.findItemIndex(item, time1) : -1;
    }
    updateSchedule(forceUpdate = false) {
        var _this$schedule7;
        const mediaSelection = this.mediaSelection;
        if (!mediaSelection) return;
        (_this$schedule7 = this.schedule) == null || _this$schedule7.updateSchedule(mediaSelection, [], forceUpdate);
    }
    // Schedule buffer control
    checkBuffer(starved) {
        var _this$schedule8;
        const items = (_this$schedule8 = this.schedule) == null ? void 0 : _this$schedule8.items;
        if (!items) return;
        // Find when combined forward buffer change reaches next schedule segment
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(this.primaryMedia, this.timelinePos, 0);
        if (starved) this.bufferedPos = this.timelinePos;
        starved || (starved = bufferInfo.len < 1);
        this.updateBufferedPos(bufferInfo.end, items, starved);
    }
    updateBufferedPos(bufferEnd, items, bufferIsEmpty) {
        const schedule = this.schedule;
        const bufferingItem = this.bufferingItem;
        if (this.bufferedPos > bufferEnd || !schedule) return;
        if (items.length === 1 && this.itemsMatch(items[0], bufferingItem)) {
            this.bufferedPos = bufferEnd;
            return;
        }
        const playingItem = this.playingItem;
        const playingIndex = this.findItemIndex(playingItem);
        let bufferEndIndex = schedule.findItemIndexAtTime(bufferEnd);
        if (this.bufferedPos < bufferEnd) {
            var _nextItemToBuffer$eve;
            const bufferingIndex = this.findItemIndex(bufferingItem);
            const nextToBufferIndex = Math.min(bufferingIndex + 1, items.length - 1);
            const nextItemToBuffer = items[nextToBufferIndex];
            if (bufferEndIndex === -1 && bufferingItem && bufferEnd >= bufferingItem.end || (_nextItemToBuffer$eve = nextItemToBuffer.event) != null && _nextItemToBuffer$eve.appendInPlace && bufferEnd + 0.01 >= nextItemToBuffer.start) bufferEndIndex = nextToBufferIndex;
            if (this.isInterstitial(bufferingItem)) {
                const interstitial = bufferingItem.event;
                if (nextToBufferIndex - playingIndex > 1 && interstitial.appendInPlace === false) // do not advance buffering item past Interstitial that requires source reset
                return;
                if (interstitial.assetList.length === 0 && interstitial.assetListLoader) // do not advance buffering item past Interstitial loading asset-list
                return;
            }
            this.bufferedPos = bufferEnd;
            if (bufferEndIndex > bufferingIndex && bufferEndIndex > playingIndex) this.bufferedToItem(nextItemToBuffer);
            else {
                // allow more time than distance from edge for assets to load
                const details = this.primaryDetails;
                if (this.primaryLive && details && bufferEnd > details.edge - details.targetduration && nextItemToBuffer.start < details.edge + this.hls.config.interstitialLiveLookAhead && this.isInterstitial(nextItemToBuffer)) this.preloadAssets(nextItemToBuffer.event, 0);
            }
        } else if (bufferIsEmpty && playingItem && !this.itemsMatch(playingItem, bufferingItem)) {
            if (bufferEndIndex === playingIndex) this.bufferedToItem(playingItem);
            else if (bufferEndIndex === playingIndex + 1) this.bufferedToItem(items[bufferEndIndex]);
        }
    }
    assetsBuffered(item, media) {
        const assetList = item.event.assetList;
        if (assetList.length === 0) return false;
        return !item.event.assetList.some((asset)=>{
            const player = this.getAssetPlayer(asset.identifier);
            return !(player != null && player.bufferedInPlaceToEnd(media));
        });
    }
    setBufferingItem(item) {
        const bufferingLast = this.bufferingItem;
        const schedule = this.schedule;
        if (!this.itemsMatch(item, bufferingLast) && schedule) {
            const { items: items, events: events } = schedule;
            if (!items || !events) return bufferingLast;
            const isInterstitial = this.isInterstitial(item);
            const bufferingPlayer = this.getBufferingPlayer();
            this.bufferingItem = item;
            this.bufferedPos = Math.max(item.start, Math.min(item.end, this.timelinePos));
            const timeRemaining = bufferingPlayer ? bufferingPlayer.remaining : bufferingLast ? bufferingLast.end - this.timelinePos : 0;
            this.log(`INTERSTITIALS_BUFFERED_TO_BOUNDARY ${$b941786f4eb9cb76$var$segmentToString(item)}` + (bufferingLast ? ` (${timeRemaining.toFixed(2)} remaining)` : ''));
            if (!this.playbackDisabled) {
                if (isInterstitial) {
                    const bufferIndex = schedule.findAssetIndex(item.event, this.bufferedPos);
                    // primary fragment loading will exit early in base-stream-controller while `bufferingItem` is set to an Interstitial block
                    item.event.assetList.forEach((asset, i)=>{
                        const player = this.getAssetPlayer(asset.identifier);
                        if (player) {
                            if (i === bufferIndex) player.loadSource();
                            player.resumeBuffering();
                        }
                    });
                } else {
                    this.hls.resumeBuffering();
                    this.playerQueue.forEach((player)=>player.pauseBuffering());
                }
            }
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIALS_BUFFERED_TO_BOUNDARY, {
                events: events.slice(0),
                schedule: items.slice(0),
                bufferingIndex: this.findItemIndex(item),
                playingIndex: this.findItemIndex(this.playingItem)
            });
        } else if (this.bufferingItem !== item) this.bufferingItem = item;
        return bufferingLast;
    }
    bufferedToItem(item, assetListIndex = 0) {
        const bufferingLast = this.setBufferingItem(item);
        if (this.playbackDisabled) return;
        if (this.isInterstitial(item)) // Ensure asset list is loaded
        this.bufferedToEvent(item, assetListIndex);
        else if (bufferingLast !== null) {
            // If primary player is detached, it is also stopped, restart loading at primary position
            this.bufferingAsset = null;
            const detachedData = this.detachedData;
            if (detachedData) {
                if (detachedData.mediaSource) {
                    const skipSeekToStartPosition = true;
                    this.attachPrimary(item.start, item, skipSeekToStartPosition);
                } else this.preloadPrimary(item);
            } else // If not detached seek to resumption point
            this.preloadPrimary(item);
        }
    }
    preloadPrimary(item) {
        const index = this.findItemIndex(item);
        const timelinePos = this.getPrimaryResumption(item, index);
        this.startLoadingPrimaryAt(timelinePos);
    }
    bufferedToEvent(item, assetListIndex) {
        const interstitial = item.event;
        const neverLoaded = interstitial.assetList.length === 0 && !interstitial.assetListLoader;
        const playOnce = interstitial.cue.once;
        if (neverLoaded || !playOnce) {
            // Buffered to Interstitial boundary
            const player = this.preloadAssets(interstitial, assetListIndex);
            if (player != null && player.interstitial.appendInPlace) {
                const media = this.primaryMedia;
                if (media) this.bufferAssetPlayer(player, media);
            }
        }
    }
    preloadAssets(interstitial, assetListIndex) {
        const uri = interstitial.assetUrl;
        const assetListLength = interstitial.assetList.length;
        const neverLoaded = assetListLength === 0 && !interstitial.assetListLoader;
        const playOnce = interstitial.cue.once;
        if (neverLoaded) {
            const timelineStart = interstitial.timelineStart;
            if (interstitial.appendInPlace) {
                var _playingItem$nextEven;
                const playingItem = this.playingItem;
                if (!this.isInterstitial(playingItem) && (playingItem == null || (_playingItem$nextEven = playingItem.nextEvent) == null ? void 0 : _playingItem$nextEven.identifier) === interstitial.identifier) this.flushFrontBuffer(timelineStart + 0.25);
            }
            let hlsStartOffset;
            let liveStartPosition = 0;
            if (!this.playingItem && this.primaryLive) {
                liveStartPosition = this.hls.startPosition;
                if (liveStartPosition === -1) liveStartPosition = this.hls.liveSyncPosition || 0;
            }
            if (liveStartPosition && !(interstitial.cue.pre || interstitial.cue.post)) {
                const startOffset = liveStartPosition - timelineStart;
                if (startOffset > 0) hlsStartOffset = Math.round(startOffset * 1000) / 1000;
            }
            this.log(`Load interstitial asset ${assetListIndex + 1}/${uri ? 1 : assetListLength} ${interstitial}${hlsStartOffset ? ` live-start: ${liveStartPosition} start-offset: ${hlsStartOffset}` : ''}`);
            if (uri) return this.createAsset(interstitial, 0, 0, timelineStart, interstitial.duration, uri);
            const assetListLoader = this.assetListLoader.loadAssetList(interstitial, hlsStartOffset);
            if (assetListLoader) interstitial.assetListLoader = assetListLoader;
        } else if (!playOnce && assetListLength) {
            // Re-buffered to Interstitial boundary, re-create asset player(s)
            for(let i = assetListIndex; i < assetListLength; i++){
                const _asset = interstitial.assetList[i];
                const playerIndex = this.getAssetPlayerQueueIndex(_asset.identifier);
                if ((playerIndex === -1 || this.playerQueue[playerIndex].destroyed) && !_asset.error) this.createAssetPlayer(interstitial, _asset, i);
            }
            const asset = interstitial.assetList[assetListIndex];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (asset) {
                const player = this.getAssetPlayer(asset.identifier);
                if (player) player.loadSource();
                return player;
            }
        }
        return null;
    }
    flushFrontBuffer(startOffset) {
        // Force queued flushing of all buffers
        const requiredTracks = this.requiredTracks;
        if (!requiredTracks) return;
        this.log(`Removing front buffer starting at ${startOffset}`);
        const sourceBufferNames = Object.keys(requiredTracks);
        sourceBufferNames.forEach((type)=>{
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, {
                startOffset: startOffset,
                endOffset: Infinity,
                type: type
            });
        });
    }
    // Interstitial Asset Player control
    getAssetPlayerQueueIndex(assetId) {
        const playerQueue = this.playerQueue;
        for(let i = 0; i < playerQueue.length; i++){
            if (assetId === playerQueue[i].assetId) return i;
        }
        return -1;
    }
    getAssetPlayer(assetId) {
        const index = this.getAssetPlayerQueueIndex(assetId);
        return this.playerQueue[index] || null;
    }
    getBufferingPlayer() {
        const { playerQueue: playerQueue, primaryMedia: primaryMedia } = this;
        if (primaryMedia) for(let i = 0; i < playerQueue.length; i++){
            if (playerQueue[i].media === primaryMedia) return playerQueue[i];
        }
        return null;
    }
    createAsset(interstitial, assetListIndex, startOffset, timelineStart, duration, uri) {
        const assetItem = {
            parentIdentifier: interstitial.identifier,
            identifier: $b941786f4eb9cb76$var$generateAssetIdentifier(interstitial, uri, assetListIndex),
            duration: duration,
            startOffset: startOffset,
            timelineStart: timelineStart,
            uri: uri
        };
        return this.createAssetPlayer(interstitial, assetItem, assetListIndex);
    }
    createAssetPlayer(interstitial, assetItem, assetListIndex) {
        const primary = this.hls;
        const userConfig = primary.userConfig;
        let videoPreference = userConfig.videoPreference;
        const currentLevel = primary.loadLevelObj || primary.levels[primary.currentLevel];
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (videoPreference || currentLevel) {
            videoPreference = $b941786f4eb9cb76$var$_extends({}, videoPreference);
            if (currentLevel.videoCodec) videoPreference.videoCodec = currentLevel.videoCodec;
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (currentLevel.videoRange) videoPreference.allowedVideoRanges = [
                currentLevel.videoRange
            ];
        }
        const selectedAudio = primary.audioTracks[primary.audioTrack];
        const selectedSubtitle = primary.subtitleTracks[primary.subtitleTrack];
        let startPosition = 0;
        if (this.primaryLive || interstitial.appendInPlace) {
            const timePastStart = this.timelinePos - assetItem.timelineStart;
            if (timePastStart > 1) {
                const duration = assetItem.duration;
                if (duration && timePastStart < duration) startPosition = timePastStart;
            }
        }
        const assetId = assetItem.identifier;
        const playerConfig = $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, userConfig), {}, {
            maxMaxBufferLength: Math.min(180, primary.config.maxMaxBufferLength),
            autoStartLoad: true,
            startFragPrefetch: true,
            primarySessionId: primary.sessionId,
            assetPlayerId: assetId,
            abrEwmaDefaultEstimate: primary.bandwidthEstimate,
            interstitialsController: undefined,
            startPosition: startPosition,
            liveDurationInfinity: false,
            testBandwidth: false,
            videoPreference: videoPreference,
            audioPreference: selectedAudio || userConfig.audioPreference,
            subtitlePreference: selectedSubtitle || userConfig.subtitlePreference
        });
        // TODO: limit maxMaxBufferLength in asset players to prevent QEE
        if (interstitial.appendInPlace) {
            interstitial.appendInPlaceStarted = true;
            if (assetItem.timelineStart) playerConfig.timelineOffset = assetItem.timelineStart;
        }
        const cmcd = playerConfig.cmcd;
        if (cmcd != null && cmcd.sessionId && cmcd.contentId) playerConfig.cmcd = $b941786f4eb9cb76$var$_extends({}, cmcd, {
            contentId: $b941786f4eb9cb76$var$hash(assetItem.uri)
        });
        if (this.getAssetPlayer(assetId)) this.warn(`Duplicate date range identifier ${interstitial} and asset ${assetId}`);
        const player = new $b941786f4eb9cb76$var$HlsAssetPlayer(this.HlsPlayerClass, playerConfig, interstitial, assetItem);
        this.playerQueue.push(player);
        interstitial.assetList[assetListIndex] = assetItem;
        // Listen for LevelDetails and PTS change to update duration
        let initialDuration = true;
        const updateAssetPlayerDetails = (details)=>{
            if (details.live) {
                var _this$schedule9;
                const error = new Error(`Interstitials MUST be VOD assets ${interstitial}`);
                const errorData = {
                    fatal: true,
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERSTITIAL_ASSET_ITEM_ERROR,
                    error: error
                };
                const scheduleIndex = ((_this$schedule9 = this.schedule) == null ? void 0 : _this$schedule9.findEventIndex(interstitial.identifier)) || -1;
                this.handleAssetItemError(errorData, interstitial, scheduleIndex, assetListIndex, error.message);
                return;
            }
            // Get time at end of last fragment
            const duration = details.edge - details.fragmentStart;
            const currentAssetDuration = assetItem.duration;
            if (initialDuration || currentAssetDuration === null || duration > currentAssetDuration) {
                initialDuration = false;
                this.log(`Interstitial asset "${assetId}" duration change ${currentAssetDuration} > ${duration}`);
                assetItem.duration = duration;
                // Update schedule with new event and asset duration
                this.updateSchedule();
            }
        };
        player.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, (event, { details: details })=>updateAssetPlayerDetails(details));
        player.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_PTS_UPDATED, (event, { details: details })=>updateAssetPlayerDetails(details));
        player.on($b941786f4eb9cb76$export$ada873a34909da65.EVENT_CUE_ENTER, ()=>this.onInterstitialCueEnter());
        const onBufferCodecs = (event, data)=>{
            const inQueuPlayer = this.getAssetPlayer(assetId);
            if (inQueuPlayer && data.tracks) {
                inQueuPlayer.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, onBufferCodecs);
                inQueuPlayer.tracks = data.tracks;
                const media = this.primaryMedia;
                if (this.bufferingAsset === inQueuPlayer.assetItem && media && !inQueuPlayer.media) this.bufferAssetPlayer(inQueuPlayer, media);
            }
        };
        player.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, onBufferCodecs);
        const bufferedToEnd = ()=>{
            var _this$schedule$items3;
            const inQueuPlayer = this.getAssetPlayer(assetId);
            this.log(`buffered to end of asset ${inQueuPlayer}`);
            if (!inQueuPlayer || !this.schedule) return;
            // Preload at end of asset
            const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
            const item = (_this$schedule$items3 = this.schedule.items) == null ? void 0 : _this$schedule$items3[scheduleIndex];
            if (this.isInterstitial(item)) this.advanceAssetBuffering(item, assetItem);
        };
        player.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFERED_TO_END, bufferedToEnd);
        const endedWithAssetIndex = (assetIndex)=>{
            return ()=>{
                const inQueuPlayer = this.getAssetPlayer(assetId);
                if (!inQueuPlayer || !this.schedule) return;
                this.shouldPlay = true;
                const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
                this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetIndex);
            };
        };
        player.once($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ENDED, endedWithAssetIndex(assetListIndex));
        player.once($b941786f4eb9cb76$export$ada873a34909da65.PLAYOUT_LIMIT_REACHED, endedWithAssetIndex(Infinity));
        player.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, (event, data)=>{
            if (!this.schedule) return;
            const inQueuPlayer = this.getAssetPlayer(assetId);
            if (data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_STALLED_ERROR) {
                if (inQueuPlayer != null && inQueuPlayer.appendInPlace) {
                    this.handleInPlaceStall(interstitial);
                    return;
                }
                this.onTimeupdate();
                this.checkBuffer(true);
                return;
            }
            this.handleAssetItemError(data, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, `Asset player error ${data.error} ${interstitial}`);
        });
        player.on($b941786f4eb9cb76$export$ada873a34909da65.DESTROYING, ()=>{
            const inQueuPlayer = this.getAssetPlayer(assetId);
            if (!inQueuPlayer || !this.schedule) return;
            const error = new Error(`Asset player destroyed unexpectedly ${assetId}`);
            const errorData = {
                fatal: true,
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERSTITIAL_ASSET_ITEM_ERROR,
                error: error
            };
            this.handleAssetItemError(errorData, interstitial, this.schedule.findEventIndex(interstitial.identifier), assetListIndex, error.message);
        });
        this.log(`INTERSTITIAL_ASSET_PLAYER_CREATED ${$b941786f4eb9cb76$var$eventAssetToString(assetItem)}`);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIAL_ASSET_PLAYER_CREATED, {
            asset: assetItem,
            assetListIndex: assetListIndex,
            event: interstitial,
            player: player
        });
        return player;
    }
    clearInterstitial(interstitial, toSegment) {
        this.clearAssetPlayers(interstitial, toSegment);
        // Remove asset list and resolved duration
        interstitial.reset();
    }
    clearAssetPlayers(interstitial, toSegment) {
        interstitial.assetList.forEach((asset)=>{
            this.clearAssetPlayer(asset.identifier, toSegment);
        });
    }
    resetAssetPlayer(assetId) {
        // Reset asset player so that it's timeline can be adjusted without reloading the MVP
        const playerIndex = this.getAssetPlayerQueueIndex(assetId);
        if (playerIndex !== -1) {
            this.log(`reset asset player "${assetId}" after error`);
            const player = this.playerQueue[playerIndex];
            this.transferMediaFromPlayer(player, null);
            player.resetDetails();
        }
    }
    clearAssetPlayer(assetId, toSegment) {
        const playerIndex = this.getAssetPlayerQueueIndex(assetId);
        if (playerIndex !== -1) {
            const player = this.playerQueue[playerIndex];
            this.log(`clear ${player} toSegment: ${toSegment ? $b941786f4eb9cb76$var$segmentToString(toSegment) : toSegment}`);
            this.transferMediaFromPlayer(player, toSegment);
            this.playerQueue.splice(playerIndex, 1);
            player.destroy();
        }
    }
    emptyPlayerQueue() {
        let player;
        while(player = this.playerQueue.pop())player.destroy();
        this.playerQueue = [];
    }
    startAssetPlayer(player, assetListIndex, scheduleItems, scheduleIndex, media) {
        const { interstitial: interstitial, assetItem: assetItem, assetId: assetId } = player;
        const assetListLength = interstitial.assetList.length;
        const playingAsset = this.playingAsset;
        this.endedAsset = null;
        this.playingAsset = assetItem;
        if (!playingAsset || playingAsset.identifier !== assetId) {
            if (playingAsset) {
                // Exiting another Interstitial asset
                this.clearAssetPlayer(playingAsset.identifier, scheduleItems[scheduleIndex]);
                delete playingAsset.error;
            }
            this.log(`INTERSTITIAL_ASSET_STARTED ${assetListIndex + 1}/${assetListLength} ${$b941786f4eb9cb76$var$eventAssetToString(assetItem)}`);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIAL_ASSET_STARTED, {
                asset: assetItem,
                assetListIndex: assetListIndex,
                event: interstitial,
                schedule: scheduleItems.slice(0),
                scheduleIndex: scheduleIndex,
                player: player
            });
        }
        // detach media and attach to interstitial player if it does not have another element attached
        this.bufferAssetPlayer(player, media);
    }
    bufferAssetPlayer(player, media) {
        var _this$schedule$items4, _this$detachedData5;
        if (!this.schedule) return;
        const { interstitial: interstitial, assetItem: assetItem } = player;
        const scheduleIndex = this.schedule.findEventIndex(interstitial.identifier);
        const item = (_this$schedule$items4 = this.schedule.items) == null ? void 0 : _this$schedule$items4[scheduleIndex];
        if (!item) return;
        player.loadSource();
        this.setBufferingItem(item);
        this.bufferingAsset = assetItem;
        const bufferingPlayer = this.getBufferingPlayer();
        if (bufferingPlayer === player) return;
        const appendInPlaceNext = interstitial.appendInPlace;
        if (appendInPlaceNext && (bufferingPlayer == null ? void 0 : bufferingPlayer.interstitial.appendInPlace) === false) // Media is detached and not available to append in place
        return;
        const activeTracks = (bufferingPlayer == null ? void 0 : bufferingPlayer.tracks) || ((_this$detachedData5 = this.detachedData) == null ? void 0 : _this$detachedData5.tracks) || this.requiredTracks;
        if (appendInPlaceNext && assetItem !== this.playingAsset) {
            // Do not buffer another item if tracks are unknown or incompatible
            if (!player.tracks) {
                this.log(`Waiting for track info before buffering ${player}`);
                return;
            }
            if (activeTracks && !$b941786f4eb9cb76$var$isCompatibleTrackChange(activeTracks, player.tracks)) {
                const error = new Error(`Asset ${$b941786f4eb9cb76$var$eventAssetToString(assetItem)} SourceBuffer tracks ('${Object.keys(player.tracks)}') are not compatible with primary content tracks ('${Object.keys(activeTracks)}')`);
                const errorData = {
                    fatal: true,
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERSTITIAL_ASSET_ITEM_ERROR,
                    error: error
                };
                const assetListIndex = interstitial.findAssetIndex(assetItem);
                this.handleAssetItemError(errorData, interstitial, scheduleIndex, assetListIndex, error.message);
                return;
            }
        }
        this.transferMediaTo(player, media);
    }
    handleInPlaceStall(interstitial) {
        const schedule = this.schedule;
        const media = this.primaryMedia;
        if (!schedule || !media) return;
        const currentTime = media.currentTime;
        const foundAssetIndex = schedule.findAssetIndex(interstitial, currentTime);
        const stallingAsset = interstitial.assetList[foundAssetIndex];
        if (stallingAsset) {
            const player = this.getAssetPlayer(stallingAsset.identifier);
            if (player) {
                const assetCurrentTime = player.currentTime || currentTime - stallingAsset.timelineStart;
                const distanceFromEnd = player.duration - assetCurrentTime;
                this.warn(`Stalled at ${assetCurrentTime} of ${assetCurrentTime + distanceFromEnd} in ${player} ${interstitial} (media.currentTime: ${currentTime})`);
                if (assetCurrentTime && (distanceFromEnd / media.playbackRate < 0.5 || player.bufferedInPlaceToEnd(media)) && player.hls) {
                    const scheduleIndex = schedule.findEventIndex(interstitial.identifier);
                    this.advanceAfterAssetEnded(interstitial, scheduleIndex, foundAssetIndex);
                }
            }
        }
    }
    advanceInPlace(time1) {
        const media = this.primaryMedia;
        if (media && media.currentTime < time1) media.currentTime = time1;
    }
    handleAssetItemError(data, interstitial, scheduleIndex, assetListIndex, errorMessage) {
        if (data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_STALLED_ERROR) return;
        const assetItem = interstitial.assetList[assetListIndex] || null;
        this.warn(`INTERSTITIAL_ASSET_ERROR ${assetItem ? $b941786f4eb9cb76$var$eventAssetToString(assetItem) : assetItem} ${data.error}`);
        if (!this.schedule) return;
        const assetId = (assetItem == null ? void 0 : assetItem.identifier) || '';
        const playerIndex = this.getAssetPlayerQueueIndex(assetId);
        const player = this.playerQueue[playerIndex] || null;
        const items = this.schedule.items;
        const interstitialAssetError = $b941786f4eb9cb76$var$_extends({}, data, {
            fatal: false,
            errorAction: $b941786f4eb9cb76$var$createDoNothingErrorAction(true),
            asset: assetItem,
            assetListIndex: assetListIndex,
            event: interstitial,
            schedule: items,
            scheduleIndex: scheduleIndex,
            player: player
        });
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INTERSTITIAL_ASSET_ERROR, interstitialAssetError);
        if (!data.fatal) return;
        const playingAsset = this.playingAsset;
        const bufferingAsset = this.bufferingAsset;
        const error = new Error(errorMessage);
        if (assetItem) {
            this.clearAssetPlayer(assetId, null);
            assetItem.error = error;
        }
        // If all assets in interstitial fail, mark the interstitial with an error
        if (!interstitial.assetList.some((asset)=>!asset.error)) interstitial.error = error;
        else // Reset level details and reload/parse media playlists to align with updated schedule
        for(let i = assetListIndex; i < interstitial.assetList.length; i++)this.resetAssetPlayer(interstitial.assetList[i].identifier);
        this.updateSchedule(true);
        if (interstitial.error) this.primaryFallback(interstitial);
        else if (playingAsset && playingAsset.identifier === assetId) this.advanceAfterAssetEnded(interstitial, scheduleIndex, assetListIndex);
        else if (bufferingAsset && bufferingAsset.identifier === assetId && this.isInterstitial(this.bufferingItem)) this.advanceAssetBuffering(this.bufferingItem, bufferingAsset);
    }
    primaryFallback(interstitial) {
        // Fallback to Primary by on current or future events by updating schedule to skip errored interstitials/assets
        const flushStart = interstitial.timelineStart;
        const playingItem = this.effectivePlayingItem;
        let timelinePos = this.timelinePos;
        // Update schedule now that interstitial/assets are flagged with `error` for fallback
        if (playingItem) {
            this.log(`Fallback to primary from event "${interstitial.identifier}" start: ${flushStart} pos: ${timelinePos} playing: ${$b941786f4eb9cb76$var$segmentToString(playingItem)} error: ${interstitial.error}`);
            if (timelinePos === -1) timelinePos = this.hls.startPosition;
            const newPlayingItem = this.updateItem(playingItem, timelinePos);
            if (this.itemsMatch(playingItem, newPlayingItem)) this.clearInterstitial(interstitial, null);
            if (interstitial.appendInPlace) {
                this.attachPrimary(flushStart, null);
                this.flushFrontBuffer(flushStart);
            }
        } else if (timelinePos === -1) {
            this.checkStart();
            return;
        }
        if (!this.schedule) return;
        const scheduleIndex = this.schedule.findItemIndexAtTime(timelinePos);
        this.setSchedulePosition(scheduleIndex);
    }
    // Asset List loading
    onAssetListLoaded(event, data) {
        var _this$schedule0, _this$bufferingItem2;
        const interstitial = data.event;
        const interstitialId = interstitial.identifier;
        const assets = data.assetListResponse.ASSETS;
        if (!((_this$schedule0 = this.schedule) != null && _this$schedule0.hasEvent(interstitialId))) // Interstitial with id was removed
        return;
        const eventStart = interstitial.timelineStart;
        const previousDuration = interstitial.duration;
        let sumDuration = 0;
        assets.forEach((asset, assetListIndex)=>{
            const duration = parseFloat(asset.DURATION);
            this.createAsset(interstitial, assetListIndex, sumDuration, eventStart + sumDuration, duration, asset.URI);
            sumDuration += duration;
        });
        interstitial.duration = sumDuration;
        this.log(`Loaded asset-list with duration: ${sumDuration} (was: ${previousDuration}) ${interstitial}`);
        const waitingItem = this.waitingItem;
        const waitingForItem = (waitingItem == null ? void 0 : waitingItem.event.identifier) === interstitialId;
        // Update schedule now that asset.DURATION(s) are parsed
        this.updateSchedule();
        const bufferingEvent = (_this$bufferingItem2 = this.bufferingItem) == null ? void 0 : _this$bufferingItem2.event;
        // If buffer reached Interstitial, start buffering first asset
        if (waitingForItem) {
            var _this$schedule$items5;
            // Advance schedule when waiting for asset list data to play
            const scheduleIndex = this.schedule.findEventIndex(interstitialId);
            const item = (_this$schedule$items5 = this.schedule.items) == null ? void 0 : _this$schedule$items5[scheduleIndex];
            if (item) {
                if (!this.playingItem && this.timelinePos > item.end) {
                    // Abandon if new duration is reduced enough to land playback in primary start
                    const index = this.schedule.findItemIndexAtTime(this.timelinePos);
                    if (index !== scheduleIndex) {
                        interstitial.error = new Error(`Interstitial ${assets.length ? 'no longer within playback range' : 'asset-list is empty'} ${this.timelinePos} ${interstitial}`);
                        this.log(interstitial.error.message);
                        this.updateSchedule(true);
                        this.primaryFallback(interstitial);
                        return;
                    }
                }
                this.setBufferingItem(item);
            }
            this.setSchedulePosition(scheduleIndex);
        } else if ((bufferingEvent == null ? void 0 : bufferingEvent.identifier) === interstitialId) {
            const assetItem = interstitial.assetList[0];
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (assetItem) {
                const player = this.getAssetPlayer(assetItem.identifier);
                if (bufferingEvent.appendInPlace) {
                    // If buffering (but not playback) has reached this item transfer media-source
                    const media = this.primaryMedia;
                    if (player && media) this.bufferAssetPlayer(player, media);
                } else if (player) player.loadSource();
            }
        }
    }
    onError(event, data) {
        if (!this.schedule) return;
        switch(data.details){
            case $b941786f4eb9cb76$export$d053ec805ce391aa.ASSET_LIST_PARSING_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.ASSET_LIST_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.ASSET_LIST_LOAD_TIMEOUT:
                {
                    const interstitial = data.interstitial;
                    if (interstitial) {
                        this.updateSchedule(true);
                        this.primaryFallback(interstitial);
                    }
                    break;
                }
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_STALLED_ERROR:
                {
                    const stallingItem = this.endedItem || this.waitingItem || this.playingItem;
                    if (this.isInterstitial(stallingItem) && stallingItem.event.appendInPlace) {
                        this.handleInPlaceStall(stallingItem.event);
                        return;
                    }
                    this.log(`Primary player stall @${this.timelinePos} bufferedPos: ${this.bufferedPos}`);
                    this.onTimeupdate();
                    this.checkBuffer(true);
                    break;
                }
        }
    }
}
const $b941786f4eb9cb76$var$TICK_INTERVAL$2 = 500; // how often to tick in ms
class $b941786f4eb9cb76$export$507c2c1b84e7d645 extends $b941786f4eb9cb76$export$946cb951577581c9 {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, 'subtitle-stream-controller', $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE);
        this.currentTrackId = -1;
        this.tracksBuffered = [];
        this.mainDetails = null;
        this.registerListeners();
    }
    onHandlerDestroying() {
        this.unregisterListeners();
        super.onHandlerDestroying();
        this.mainDetails = null;
    }
    registerListeners() {
        super.registerListeners();
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    unregisterListeners() {
        super.unregisterListeners();
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    startLoad(startPosition, skipSeekToStartPosition) {
        this.stopLoad();
        this.state = $b941786f4eb9cb76$var$State.IDLE;
        this.setInterval($b941786f4eb9cb76$var$TICK_INTERVAL$2);
        this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
        this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
        this.tick();
    }
    onManifestLoading() {
        super.onManifestLoading();
        this.mainDetails = null;
    }
    onMediaDetaching(event, data) {
        this.tracksBuffered = [];
        super.onMediaDetaching(event, data);
    }
    onLevelLoaded(event, data) {
        this.mainDetails = data.details;
    }
    onSubtitleFragProcessed(event, data) {
        const { frag: frag, success: success } = data;
        if (!this.fragContextChanged(frag)) {
            if ($b941786f4eb9cb76$var$isMediaFragment(frag)) this.fragPrevious = frag;
            this.state = $b941786f4eb9cb76$var$State.IDLE;
        }
        if (!success) return;
        const buffered = this.tracksBuffered[this.currentTrackId];
        if (!buffered) return;
        // Create/update a buffered array matching the interface used by BufferHelper.bufferedInfo
        // so we can re-use the logic used to detect how much has been buffered
        let timeRange;
        const fragStart = frag.start;
        for(let i = 0; i < buffered.length; i++)if (fragStart >= buffered[i].start && fragStart <= buffered[i].end) {
            timeRange = buffered[i];
            break;
        }
        const fragEnd = frag.start + frag.duration;
        if (timeRange) timeRange.end = fragEnd;
        else {
            timeRange = {
                start: fragStart,
                end: fragEnd
            };
            buffered.push(timeRange);
        }
        this.fragmentTracker.fragBuffered(frag);
        this.fragBufferedComplete(frag, null);
        if (this.media) this.tick();
    }
    onBufferFlushing(event, data) {
        const { startOffset: startOffset, endOffset: endOffset } = data;
        if (startOffset === 0 && endOffset !== Number.POSITIVE_INFINITY) {
            const endOffsetSubtitles = endOffset - 1;
            if (endOffsetSubtitles <= 0) return;
            data.endOffsetSubtitles = Math.max(0, endOffsetSubtitles);
            this.tracksBuffered.forEach((buffered)=>{
                for(let i = 0; i < buffered.length;){
                    if (buffered[i].end <= endOffsetSubtitles) {
                        buffered.shift();
                        continue;
                    } else if (buffered[i].start < endOffsetSubtitles) buffered[i].start = endOffsetSubtitles;
                    else break;
                    i++;
                }
            });
            this.fragmentTracker.removeFragmentsInRange(startOffset, endOffsetSubtitles, $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE);
        }
    }
    // If something goes wrong, proceed to next frag, if we were processing one.
    onError(event, data) {
        const frag = data.frag;
        if ((frag == null ? void 0 : frag.type) === $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE) {
            if (data.details === $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP) this.fragmentTracker.fragBuffered(frag, true);
            if (this.fragCurrent) this.fragCurrent.abortRequests();
            if (this.state !== $b941786f4eb9cb76$var$State.STOPPED) this.state = $b941786f4eb9cb76$var$State.IDLE;
        }
    }
    // Got all new subtitle levels.
    onSubtitleTracksUpdated(event, { subtitleTracks: subtitleTracks }) {
        if (this.levels && $b941786f4eb9cb76$var$subtitleOptionsIdentical(this.levels, subtitleTracks)) {
            this.levels = subtitleTracks.map((mediaPlaylist)=>new $b941786f4eb9cb76$export$ca664994d1d54bff(mediaPlaylist));
            return;
        }
        this.tracksBuffered = [];
        this.levels = subtitleTracks.map((mediaPlaylist)=>{
            const level = new $b941786f4eb9cb76$export$ca664994d1d54bff(mediaPlaylist);
            this.tracksBuffered[level.id] = [];
            return level;
        });
        this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE);
        this.fragPrevious = null;
        this.mediaBuffer = null;
    }
    onSubtitleTrackSwitch(event, data) {
        var _this$levels;
        this.currentTrackId = data.id;
        if (!((_this$levels = this.levels) != null && _this$levels.length) || this.currentTrackId === -1) {
            this.clearInterval();
            return;
        }
        // Check if track has the necessary details to load fragments
        const currentTrack = this.levels[this.currentTrackId];
        if (currentTrack != null && currentTrack.details) this.mediaBuffer = this.mediaBufferTimeRanges;
        else this.mediaBuffer = null;
        if (currentTrack && this.state !== $b941786f4eb9cb76$var$State.STOPPED) this.setInterval($b941786f4eb9cb76$var$TICK_INTERVAL$2);
    }
    // Got a new set of subtitle fragments.
    onSubtitleTrackLoaded(event, data) {
        var _track$details;
        const { currentTrackId: currentTrackId, levels: levels } = this;
        const { details: newDetails, id: trackId } = data;
        if (!levels) {
            this.warn(`Subtitle tracks were reset while loading level ${trackId}`);
            return;
        }
        const track = levels[trackId];
        if (trackId >= levels.length || !track) return;
        this.log(`Subtitle track ${trackId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''},duration:${newDetails.totalduration}`);
        this.mediaBuffer = this.mediaBufferTimeRanges;
        let sliding = 0;
        if (newDetails.live || (_track$details = track.details) != null && _track$details.live) {
            if (newDetails.deltaUpdateFailed) return;
            const mainDetails = this.mainDetails;
            if (!mainDetails) {
                this.startFragRequested = false;
                return;
            }
            const mainSlidingStartFragment = mainDetails.fragments[0];
            if (!track.details) {
                if (newDetails.hasProgramDateTime && mainDetails.hasProgramDateTime) {
                    $b941786f4eb9cb76$var$alignMediaPlaylistByPDT(newDetails, mainDetails);
                    sliding = newDetails.fragmentStart;
                } else if (mainSlidingStartFragment) {
                    // line up live playlist with main so that fragments in range are loaded
                    sliding = mainSlidingStartFragment.start;
                    $b941786f4eb9cb76$var$addSliding(newDetails, sliding);
                }
            } else {
                var _this$levelLastLoaded;
                sliding = this.alignPlaylists(newDetails, track.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
                if (sliding === 0 && mainSlidingStartFragment) {
                    // realign with main when there is no overlap with last refresh
                    sliding = mainSlidingStartFragment.start;
                    $b941786f4eb9cb76$var$addSliding(newDetails, sliding);
                }
            }
            // compute start position if we are aligned with the main playlist
            if (mainDetails && !this.startFragRequested) this.setStartPosition(mainDetails, sliding);
        }
        track.details = newDetails;
        this.levelLastLoaded = track;
        if (trackId !== currentTrackId) return;
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_UPDATED, {
            details: newDetails,
            id: trackId,
            groupId: data.groupId
        });
        // trigger handler right now
        this.tick();
        // If playlist is misaligned because of bad PDT or drift, delete details to resync with main on reload
        if (newDetails.live && !this.fragCurrent && this.media && this.state === $b941786f4eb9cb76$var$State.IDLE) {
            const foundFrag = $b941786f4eb9cb76$var$findFragmentByPTS(null, newDetails.fragments, this.media.currentTime, 0);
            if (!foundFrag) {
                this.warn('Subtitle playlist not aligned with playback');
                track.details = undefined;
            }
        }
    }
    _handleFragmentLoadComplete(fragLoadedData) {
        const { frag: frag, payload: payload } = fragLoadedData;
        const decryptData = frag.decryptdata;
        const hls = this.hls;
        if (this.fragContextChanged(frag)) return;
        // check to see if the payload needs to be decrypted
        if (payload && payload.byteLength > 0 && decryptData != null && decryptData.key && decryptData.iv && $b941786f4eb9cb76$var$isFullSegmentEncryption(decryptData.method)) {
            const startTime = performance.now();
            // decrypt the subtitles
            this.decrypter.decrypt(new Uint8Array(payload), decryptData.key.buffer, decryptData.iv.buffer, $b941786f4eb9cb76$var$getAesModeFromFullSegmentMethod(decryptData.method)).catch((err)=>{
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR,
                    fatal: false,
                    error: err,
                    reason: err.message,
                    frag: frag
                });
                throw err;
            }).then((decryptedData)=>{
                const endTime = performance.now();
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_DECRYPTED, {
                    frag: frag,
                    payload: decryptedData,
                    stats: {
                        tstart: startTime,
                        tdecrypt: endTime
                    }
                });
            }).catch((err)=>{
                this.warn(`${err.name}: ${err.message}`);
                this.state = $b941786f4eb9cb76$var$State.IDLE;
            });
        }
    }
    doTick() {
        if (!this.media) {
            this.state = $b941786f4eb9cb76$var$State.IDLE;
            return;
        }
        if (this.state === $b941786f4eb9cb76$var$State.IDLE) {
            const { currentTrackId: currentTrackId, levels: levels } = this;
            const track = levels == null ? void 0 : levels[currentTrackId];
            if (!track || !levels.length || !track.details) return;
            if (this.waitForLive(track)) return;
            const { config: config } = this;
            const currentTime = this.getLoadPosition();
            const bufferedInfo = $b941786f4eb9cb76$var$BufferHelper.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], currentTime, config.maxBufferHole);
            const { end: targetBufferTime, len: bufferLen } = bufferedInfo;
            const trackDetails = track.details;
            const maxBufLen = this.hls.maxBufferLength + trackDetails.levelTargetDuration;
            if (bufferLen > maxBufLen) return;
            const fragments = trackDetails.fragments;
            const fragLen = fragments.length;
            const end = trackDetails.edge;
            let foundFrag = null;
            const fragPrevious = this.fragPrevious;
            if (targetBufferTime < end) {
                const tolerance = config.maxFragLookUpTolerance;
                const lookupTolerance = targetBufferTime > end - tolerance ? 0 : tolerance;
                foundFrag = $b941786f4eb9cb76$var$findFragmentByPTS(fragPrevious, fragments, Math.max(fragments[0].start, targetBufferTime), lookupTolerance);
                if (!foundFrag && fragPrevious && fragPrevious.start < fragments[0].start) foundFrag = fragments[0];
            } else foundFrag = fragments[fragLen - 1];
            foundFrag = this.filterReplacedPrimary(foundFrag, track.details);
            if (!foundFrag) return;
            // Load earlier fragment in same discontinuity to make up for misaligned playlists and cues that extend beyond end of segment
            const curSNIdx = foundFrag.sn - trackDetails.startSN;
            const prevFrag = fragments[curSNIdx - 1];
            if (prevFrag && prevFrag.cc === foundFrag.cc && this.fragmentTracker.getState(prevFrag) === $b941786f4eb9cb76$var$FragmentState.NOT_LOADED) foundFrag = prevFrag;
            if (this.fragmentTracker.getState(foundFrag) === $b941786f4eb9cb76$var$FragmentState.NOT_LOADED) {
                // only load if fragment is not loaded
                const fragToLoad = this.mapToInitFragWhenRequired(foundFrag);
                if (fragToLoad) this.loadFragment(fragToLoad, track, targetBufferTime);
            }
        }
    }
    loadFragment(frag, level, targetBufferTime) {
        if (!$b941786f4eb9cb76$var$isMediaFragment(frag)) this._loadInitSegment(frag, level);
        else super.loadFragment(frag, level, targetBufferTime);
    }
    get mediaBufferTimeRanges() {
        return new $b941786f4eb9cb76$var$BufferableInstance(this.tracksBuffered[this.currentTrackId] || []);
    }
}
class $b941786f4eb9cb76$var$BufferableInstance {
    constructor(timeranges){
        this.buffered = void 0;
        const getRange = (name, index, length)=>{
            index = index >>> 0;
            if (index > length - 1) throw new DOMException(`Failed to execute '${name}' on 'TimeRanges': The index provided (${index}) is greater than the maximum bound (${length})`);
            return timeranges[index][name];
        };
        this.buffered = {
            get length () {
                return timeranges.length;
            },
            end (index) {
                return getRange('end', index, timeranges.length);
            },
            start (index) {
                return getRange('start', index, timeranges.length);
            }
        };
    }
}
/**
 *
 * This code was ported from the dash.js project at:
 *   https://github.com/Dash-Industry-Forum/dash.js/blob/development/externals/cea608-parser.js
 *   https://github.com/Dash-Industry-Forum/dash.js/commit/8269b26a761e0853bb21d78780ed945144ecdd4d#diff-71bc295a2d6b6b7093a1d3290d53a4b2
 *
 * The original copyright appears below:
 *
 * The copyright in this software is being made available under the BSD License,
 * included below. This software may be subject to other third party and contributor
 * rights, including patent rights, and no such rights are granted under this license.
 *
 * Copyright (c) 2015-2016, DASH Industry Forum.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification,
 * are permitted provided that the following conditions are met:
 *  1. Redistributions of source code must retain the above copyright notice, this
 *  list of conditions and the following disclaimer.
 *  * Redistributions in binary form must reproduce the above copyright notice,
 *  this list of conditions and the following disclaimer in the documentation and/or
 *  other materials provided with the distribution.
 *  2. Neither the name of Dash Industry Forum nor the names of its
 *  contributors may be used to endorse or promote products derived from this software
 *  without specific prior written permission.
 *
 *  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS AS IS AND ANY
 *  EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 *  WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED.
 *  IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT,
 *  INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT
 *  NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
 *  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY,
 *  WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 *  ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 *  POSSIBILITY OF SUCH DAMAGE.
 */ /**
 *  Exceptions from regular ASCII. CodePoints are mapped to UTF-16 codes
 */ const $b941786f4eb9cb76$var$specialCea608CharsCodes = {
    0x2a: 0xe1,
    // lowercase a, acute accent
    0x5c: 0xe9,
    // lowercase e, acute accent
    0x5e: 0xed,
    // lowercase i, acute accent
    0x5f: 0xf3,
    // lowercase o, acute accent
    0x60: 0xfa,
    // lowercase u, acute accent
    0x7b: 0xe7,
    // lowercase c with cedilla
    0x7c: 0xf7,
    // division symbol
    0x7d: 0xd1,
    // uppercase N tilde
    0x7e: 0xf1,
    // lowercase n tilde
    0x7f: 0x2588,
    // Full block
    // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
    // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
    0x80: 0xae,
    // Registered symbol (R)
    0x81: 0xb0,
    // degree sign
    0x82: 0xbd,
    // 1/2 symbol
    0x83: 0xbf,
    // Inverted (open) question mark
    0x84: 0x2122,
    // Trademark symbol (TM)
    0x85: 0xa2,
    // Cents symbol
    0x86: 0xa3,
    // Pounds sterling
    0x87: 0x266a,
    // Music 8'th note
    0x88: 0xe0,
    // lowercase a, grave accent
    0x89: 0x20,
    // transparent space (regular)
    0x8a: 0xe8,
    // lowercase e, grave accent
    0x8b: 0xe2,
    // lowercase a, circumflex accent
    0x8c: 0xea,
    // lowercase e, circumflex accent
    0x8d: 0xee,
    // lowercase i, circumflex accent
    0x8e: 0xf4,
    // lowercase o, circumflex accent
    0x8f: 0xfb,
    // lowercase u, circumflex accent
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
    0x90: 0xc1,
    // capital letter A with acute
    0x91: 0xc9,
    // capital letter E with acute
    0x92: 0xd3,
    // capital letter O with acute
    0x93: 0xda,
    // capital letter U with acute
    0x94: 0xdc,
    // capital letter U with diaresis
    0x95: 0xfc,
    // lowercase letter U with diaeresis
    0x96: 0x2018,
    // opening single quote
    0x97: 0xa1,
    // inverted exclamation mark
    0x98: 0x2a,
    // asterisk
    0x99: 0x2019,
    // closing single quote
    0x9a: 0x2501,
    // box drawings heavy horizontal
    0x9b: 0xa9,
    // copyright sign
    0x9c: 0x2120,
    // Service mark
    0x9d: 0x2022,
    // (round) bullet
    0x9e: 0x201c,
    // Left double quotation mark
    0x9f: 0x201d,
    // Right double quotation mark
    0xa0: 0xc0,
    // uppercase A, grave accent
    0xa1: 0xc2,
    // uppercase A, circumflex
    0xa2: 0xc7,
    // uppercase C with cedilla
    0xa3: 0xc8,
    // uppercase E, grave accent
    0xa4: 0xca,
    // uppercase E, circumflex
    0xa5: 0xcb,
    // capital letter E with diaresis
    0xa6: 0xeb,
    // lowercase letter e with diaresis
    0xa7: 0xce,
    // uppercase I, circumflex
    0xa8: 0xcf,
    // uppercase I, with diaresis
    0xa9: 0xef,
    // lowercase i, with diaresis
    0xaa: 0xd4,
    // uppercase O, circumflex
    0xab: 0xd9,
    // uppercase U, grave accent
    0xac: 0xf9,
    // lowercase u, grave accent
    0xad: 0xdb,
    // uppercase U, circumflex
    0xae: 0xab,
    // left-pointing double angle quotation mark
    0xaf: 0xbb,
    // right-pointing double angle quotation mark
    // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
    // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
    0xb0: 0xc3,
    // Uppercase A, tilde
    0xb1: 0xe3,
    // Lowercase a, tilde
    0xb2: 0xcd,
    // Uppercase I, acute accent
    0xb3: 0xcc,
    // Uppercase I, grave accent
    0xb4: 0xec,
    // Lowercase i, grave accent
    0xb5: 0xd2,
    // Uppercase O, grave accent
    0xb6: 0xf2,
    // Lowercase o, grave accent
    0xb7: 0xd5,
    // Uppercase O, tilde
    0xb8: 0xf5,
    // Lowercase o, tilde
    0xb9: 0x7b,
    // Open curly brace
    0xba: 0x7d,
    // Closing curly brace
    0xbb: 0x5c,
    // Backslash
    0xbc: 0x5e,
    // Caret
    0xbd: 0x5f,
    // Underscore
    0xbe: 0x7c,
    // Pipe (vertical line)
    0xbf: 0x223c,
    // Tilde operator
    0xc0: 0xc4,
    // Uppercase A, umlaut
    0xc1: 0xe4,
    // Lowercase A, umlaut
    0xc2: 0xd6,
    // Uppercase O, umlaut
    0xc3: 0xf6,
    // Lowercase o, umlaut
    0xc4: 0xdf,
    // Esszett (sharp S)
    0xc5: 0xa5,
    // Yen symbol
    0xc6: 0xa4,
    // Generic currency sign
    0xc7: 0x2503,
    // Box drawings heavy vertical
    0xc8: 0xc5,
    // Uppercase A, ring
    0xc9: 0xe5,
    // Lowercase A, ring
    0xca: 0xd8,
    // Uppercase O, stroke
    0xcb: 0xf8,
    // Lowercase o, strok
    0xcc: 0x250f,
    // Box drawings heavy down and right
    0xcd: 0x2513,
    // Box drawings heavy down and left
    0xce: 0x2517,
    // Box drawings heavy up and right
    0xcf: 0x251b // Box drawings heavy up and left
};
/**
 * Utils
 */ const $b941786f4eb9cb76$var$getCharForByte = (byte)=>String.fromCharCode($b941786f4eb9cb76$var$specialCea608CharsCodes[byte] || byte);
const $b941786f4eb9cb76$var$NR_ROWS = 15;
const $b941786f4eb9cb76$var$NR_COLS = 100;
// Tables to look up row from PAC data
const $b941786f4eb9cb76$var$rowsLowCh1 = {
    0x11: 1,
    0x12: 3,
    0x15: 5,
    0x16: 7,
    0x17: 9,
    0x10: 11,
    0x13: 12,
    0x14: 14
};
const $b941786f4eb9cb76$var$rowsHighCh1 = {
    0x11: 2,
    0x12: 4,
    0x15: 6,
    0x16: 8,
    0x17: 10,
    0x13: 13,
    0x14: 15
};
const $b941786f4eb9cb76$var$rowsLowCh2 = {
    0x19: 1,
    0x1a: 3,
    0x1d: 5,
    0x1e: 7,
    0x1f: 9,
    0x18: 11,
    0x1b: 12,
    0x1c: 14
};
const $b941786f4eb9cb76$var$rowsHighCh2 = {
    0x19: 2,
    0x1a: 4,
    0x1d: 6,
    0x1e: 8,
    0x1f: 10,
    0x1b: 13,
    0x1c: 15
};
const $b941786f4eb9cb76$var$backgroundColors = [
    'white',
    'green',
    'blue',
    'cyan',
    'red',
    'yellow',
    'magenta',
    'black',
    'transparent'
];
class $b941786f4eb9cb76$var$CaptionsLogger {
    constructor(){
        this.time = null;
        this.verboseLevel = 0;
    }
    log(severity, msg) {
        if (this.verboseLevel >= severity) {
            const m = typeof msg === 'function' ? msg() : msg;
            $b941786f4eb9cb76$var$logger.log(`${this.time} [${severity}] ${m}`);
        }
    }
}
const $b941786f4eb9cb76$var$numArrayToHexArray = function numArrayToHexArray(numArray) {
    const hexArray = [];
    for(let j = 0; j < numArray.length; j++)hexArray.push(numArray[j].toString(16));
    return hexArray;
};
class $b941786f4eb9cb76$var$PenState {
    constructor(){
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    }
    reset() {
        this.foreground = 'white';
        this.underline = false;
        this.italics = false;
        this.background = 'black';
        this.flash = false;
    }
    setStyles(styles) {
        const attribs = [
            'foreground',
            'underline',
            'italics',
            'background',
            'flash'
        ];
        for(let i = 0; i < attribs.length; i++){
            const style = attribs[i];
            if (styles.hasOwnProperty(style)) this[style] = styles[style];
        }
    }
    isDefault() {
        return this.foreground === 'white' && !this.underline && !this.italics && this.background === 'black' && !this.flash;
    }
    equals(other) {
        return this.foreground === other.foreground && this.underline === other.underline && this.italics === other.italics && this.background === other.background && this.flash === other.flash;
    }
    copy(newPenState) {
        this.foreground = newPenState.foreground;
        this.underline = newPenState.underline;
        this.italics = newPenState.italics;
        this.background = newPenState.background;
        this.flash = newPenState.flash;
    }
    toString() {
        return 'color=' + this.foreground + ', underline=' + this.underline + ', italics=' + this.italics + ', background=' + this.background + ', flash=' + this.flash;
    }
}
/**
 * Unicode character with styling and background.
 * @constructor
 */ class $b941786f4eb9cb76$var$StyledUnicodeChar {
    constructor(){
        this.uchar = ' ';
        this.penState = new $b941786f4eb9cb76$var$PenState();
    }
    reset() {
        this.uchar = ' ';
        this.penState.reset();
    }
    setChar(uchar, newPenState) {
        this.uchar = uchar;
        this.penState.copy(newPenState);
    }
    setPenState(newPenState) {
        this.penState.copy(newPenState);
    }
    equals(other) {
        return this.uchar === other.uchar && this.penState.equals(other.penState);
    }
    copy(newChar) {
        this.uchar = newChar.uchar;
        this.penState.copy(newChar.penState);
    }
    isEmpty() {
        return this.uchar === ' ' && this.penState.isDefault();
    }
}
/**
 * CEA-608 row consisting of NR_COLS instances of StyledUnicodeChar.
 * @constructor
 */ class $b941786f4eb9cb76$var$Row {
    constructor(logger){
        this.chars = [];
        this.pos = 0;
        this.currPenState = new $b941786f4eb9cb76$var$PenState();
        this.cueStartTime = null;
        this.logger = void 0;
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_COLS; i++)this.chars.push(new $b941786f4eb9cb76$var$StyledUnicodeChar());
        this.logger = logger;
    }
    equals(other) {
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_COLS; i++){
            if (!this.chars[i].equals(other.chars[i])) return false;
        }
        return true;
    }
    copy(other) {
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_COLS; i++)this.chars[i].copy(other.chars[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_COLS; i++)if (!this.chars[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    /**
   *  Set the cursor to a valid column.
   */ setCursor(absPos) {
        if (this.pos !== absPos) this.pos = absPos;
        if (this.pos < 0) {
            this.logger.log(3, 'Negative cursor position ' + this.pos);
            this.pos = 0;
        } else if (this.pos > $b941786f4eb9cb76$var$NR_COLS) {
            this.logger.log(3, 'Too large cursor position ' + this.pos);
            this.pos = $b941786f4eb9cb76$var$NR_COLS;
        }
    }
    /**
   * Move the cursor relative to current position.
   */ moveCursor(relPos) {
        const newPos = this.pos + relPos;
        if (relPos > 1) for(let i = this.pos + 1; i < newPos + 1; i++)this.chars[i].setPenState(this.currPenState);
        this.setCursor(newPos);
    }
    /**
   * Backspace, move one step back and clear character.
   */ backSpace() {
        this.moveCursor(-1);
        this.chars[this.pos].setChar(' ', this.currPenState);
    }
    insertChar(byte) {
        if (byte >= 0x90) // Extended char
        this.backSpace();
        const char = $b941786f4eb9cb76$var$getCharForByte(byte);
        if (this.pos >= $b941786f4eb9cb76$var$NR_COLS) {
            this.logger.log(0, ()=>'Cannot insert ' + byte.toString(16) + ' (' + char + ') at position ' + this.pos + '. Skipping it!');
            return;
        }
        this.chars[this.pos].setChar(char, this.currPenState);
        this.moveCursor(1);
    }
    clearFromPos(startPos) {
        let i;
        for(i = startPos; i < $b941786f4eb9cb76$var$NR_COLS; i++)this.chars[i].reset();
    }
    clear() {
        this.clearFromPos(0);
        this.pos = 0;
        this.currPenState.reset();
    }
    clearToEndOfRow() {
        this.clearFromPos(this.pos);
    }
    getTextString() {
        const chars = [];
        let empty = true;
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_COLS; i++){
            const char = this.chars[i].uchar;
            if (char !== ' ') empty = false;
            chars.push(char);
        }
        if (empty) return '';
        else return chars.join('');
    }
    setPenStyles(styles) {
        this.currPenState.setStyles(styles);
        const currChar = this.chars[this.pos];
        currChar.setPenState(this.currPenState);
    }
}
/**
 * Keep a CEA-608 screen of 32x15 styled characters
 * @constructor
 */ class $b941786f4eb9cb76$var$CaptionScreen {
    constructor(logger){
        this.rows = [];
        this.currRow = $b941786f4eb9cb76$var$NR_ROWS - 1;
        this.nrRollUpRows = null;
        this.lastOutputScreen = null;
        this.logger = void 0;
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_ROWS; i++)this.rows.push(new $b941786f4eb9cb76$var$Row(logger));
        this.logger = logger;
    }
    reset() {
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_ROWS; i++)this.rows[i].clear();
        this.currRow = $b941786f4eb9cb76$var$NR_ROWS - 1;
    }
    equals(other) {
        let equal = true;
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_ROWS; i++)if (!this.rows[i].equals(other.rows[i])) {
            equal = false;
            break;
        }
        return equal;
    }
    copy(other) {
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_ROWS; i++)this.rows[i].copy(other.rows[i]);
    }
    isEmpty() {
        let empty = true;
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_ROWS; i++)if (!this.rows[i].isEmpty()) {
            empty = false;
            break;
        }
        return empty;
    }
    backSpace() {
        const row = this.rows[this.currRow];
        row.backSpace();
    }
    clearToEndOfRow() {
        const row = this.rows[this.currRow];
        row.clearToEndOfRow();
    }
    /**
   * Insert a character (without styling) in the current row.
   */ insertChar(char) {
        const row = this.rows[this.currRow];
        row.insertChar(char);
    }
    setPen(styles) {
        const row = this.rows[this.currRow];
        row.setPenStyles(styles);
    }
    moveCursor(relPos) {
        const row = this.rows[this.currRow];
        row.moveCursor(relPos);
    }
    setCursor(absPos) {
        this.logger.log(2, 'setCursor: ' + absPos);
        const row = this.rows[this.currRow];
        row.setCursor(absPos);
    }
    setPAC(pacData) {
        this.logger.log(2, ()=>'pacData = ' + $b941786f4eb9cb76$var$stringify(pacData));
        let newRow = pacData.row - 1;
        if (this.nrRollUpRows && newRow < this.nrRollUpRows - 1) newRow = this.nrRollUpRows - 1;
        // Make sure this only affects Roll-up Captions by checking this.nrRollUpRows
        if (this.nrRollUpRows && this.currRow !== newRow) {
            // clear all rows first
            for(let i = 0; i < $b941786f4eb9cb76$var$NR_ROWS; i++)this.rows[i].clear();
            // Copy this.nrRollUpRows rows from lastOutputScreen and place it in the newRow location
            // topRowIndex - the start of rows to copy (inclusive index)
            const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
            // We only copy if the last position was already shown.
            // We use the cueStartTime value to check this.
            const lastOutputScreen = this.lastOutputScreen;
            if (lastOutputScreen) {
                const prevLineTime = lastOutputScreen.rows[topRowIndex].cueStartTime;
                const time1 = this.logger.time;
                if (prevLineTime !== null && time1 !== null && prevLineTime < time1) for(let i = 0; i < this.nrRollUpRows; i++)this.rows[newRow - this.nrRollUpRows + i + 1].copy(lastOutputScreen.rows[topRowIndex + i]);
            }
        }
        this.currRow = newRow;
        const row = this.rows[this.currRow];
        if (pacData.indent !== null) {
            const indent = pacData.indent;
            const prevPos = Math.max(indent - 1, 0);
            row.setCursor(pacData.indent);
            pacData.color = row.chars[prevPos].penState.foreground;
        }
        const styles = {
            foreground: pacData.color,
            underline: pacData.underline,
            italics: pacData.italics,
            background: 'black',
            flash: false
        };
        this.setPen(styles);
    }
    /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */ setBkgData(bkgData) {
        this.logger.log(2, ()=>'bkgData = ' + $b941786f4eb9cb76$var$stringify(bkgData));
        this.backSpace();
        this.setPen(bkgData);
        this.insertChar(0x20); // Space
    }
    setRollUpRows(nrRows) {
        this.nrRollUpRows = nrRows;
    }
    rollUp() {
        if (this.nrRollUpRows === null) {
            this.logger.log(3, 'roll_up but nrRollUpRows not set yet');
            return; // Not properly setup
        }
        this.logger.log(1, ()=>this.getDisplayText());
        const topRowIndex = this.currRow + 1 - this.nrRollUpRows;
        const topRow = this.rows.splice(topRowIndex, 1)[0];
        topRow.clear();
        this.rows.splice(this.currRow, 0, topRow);
        this.logger.log(2, 'Rolling up');
    // this.logger.log(VerboseLevel.TEXT, this.get_display_text())
    }
    /**
   * Get all non-empty rows with as unicode text.
   */ getDisplayText(asOneRow) {
        asOneRow = asOneRow || false;
        const displayText = [];
        let text = '';
        let rowNr = -1;
        for(let i = 0; i < $b941786f4eb9cb76$var$NR_ROWS; i++){
            const rowText = this.rows[i].getTextString();
            if (rowText) {
                rowNr = i + 1;
                if (asOneRow) displayText.push('Row ' + rowNr + ": '" + rowText + "'");
                else displayText.push(rowText.trim());
            }
        }
        if (displayText.length > 0) {
            if (asOneRow) text = '[' + displayText.join(' | ') + ']';
            else text = displayText.join('\n');
        }
        return text;
    }
    getTextAndFormat() {
        return this.rows;
    }
}
// var modes = ['MODE_ROLL-UP', 'MODE_POP-ON', 'MODE_PAINT-ON', 'MODE_TEXT'];
class $b941786f4eb9cb76$var$Cea608Channel {
    constructor(channelNumber, outputFilter, logger){
        this.chNr = void 0;
        this.outputFilter = void 0;
        this.mode = void 0;
        this.verbose = void 0;
        this.displayedMemory = void 0;
        this.nonDisplayedMemory = void 0;
        this.lastOutputScreen = void 0;
        this.currRollUpRow = void 0;
        this.writeScreen = void 0;
        this.cueStartTime = void 0;
        this.logger = void 0;
        this.chNr = channelNumber;
        this.outputFilter = outputFilter;
        this.mode = null;
        this.verbose = 0;
        this.displayedMemory = new $b941786f4eb9cb76$var$CaptionScreen(logger);
        this.nonDisplayedMemory = new $b941786f4eb9cb76$var$CaptionScreen(logger);
        this.lastOutputScreen = new $b941786f4eb9cb76$var$CaptionScreen(logger);
        this.currRollUpRow = this.displayedMemory.rows[$b941786f4eb9cb76$var$NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null; // Keeps track of where a cue started.
        this.logger = logger;
    }
    reset() {
        this.mode = null;
        this.displayedMemory.reset();
        this.nonDisplayedMemory.reset();
        this.lastOutputScreen.reset();
        this.outputFilter.reset();
        this.currRollUpRow = this.displayedMemory.rows[$b941786f4eb9cb76$var$NR_ROWS - 1];
        this.writeScreen = this.displayedMemory;
        this.mode = null;
        this.cueStartTime = null;
    }
    getHandler() {
        return this.outputFilter;
    }
    setHandler(newHandler) {
        this.outputFilter = newHandler;
    }
    setPAC(pacData) {
        this.writeScreen.setPAC(pacData);
    }
    setBkgData(bkgData) {
        this.writeScreen.setBkgData(bkgData);
    }
    setMode(newMode) {
        if (newMode === this.mode) return;
        this.mode = newMode;
        this.logger.log(2, ()=>'MODE=' + newMode);
        if (this.mode === 'MODE_POP-ON') this.writeScreen = this.nonDisplayedMemory;
        else {
            this.writeScreen = this.displayedMemory;
            this.writeScreen.reset();
        }
        if (this.mode !== 'MODE_ROLL-UP') {
            this.displayedMemory.nrRollUpRows = null;
            this.nonDisplayedMemory.nrRollUpRows = null;
        }
        this.mode = newMode;
    }
    insertChars(chars) {
        for(let i = 0; i < chars.length; i++)this.writeScreen.insertChar(chars[i]);
        const screen = this.writeScreen === this.displayedMemory ? 'DISP' : 'NON_DISP';
        this.logger.log(2, ()=>screen + ': ' + this.writeScreen.getDisplayText(true));
        if (this.mode === 'MODE_PAINT-ON' || this.mode === 'MODE_ROLL-UP') {
            this.logger.log(1, ()=>'DISPLAYED: ' + this.displayedMemory.getDisplayText(true));
            this.outputDataUpdate();
        }
    }
    ccRCL() {
        // Resume Caption Loading (switch mode to Pop On)
        this.logger.log(2, 'RCL - Resume Caption Loading');
        this.setMode('MODE_POP-ON');
    }
    ccBS() {
        // BackSpace
        this.logger.log(2, 'BS - BackSpace');
        if (this.mode === 'MODE_TEXT') return;
        this.writeScreen.backSpace();
        if (this.writeScreen === this.displayedMemory) this.outputDataUpdate();
    }
    ccAOF() {
    // Reserved (formerly Alarm Off)
    }
    ccAON() {
    // Reserved (formerly Alarm On)
    }
    ccDER() {
        // Delete to End of Row
        this.logger.log(2, 'DER- Delete to End of Row');
        this.writeScreen.clearToEndOfRow();
        this.outputDataUpdate();
    }
    ccRU(nrRows) {
        // Roll-Up Captions-2,3,or 4 Rows
        this.logger.log(2, 'RU(' + nrRows + ') - Roll Up');
        this.writeScreen = this.displayedMemory;
        this.setMode('MODE_ROLL-UP');
        this.writeScreen.setRollUpRows(nrRows);
    }
    ccFON() {
        // Flash On
        this.logger.log(2, 'FON - Flash On');
        this.writeScreen.setPen({
            flash: true
        });
    }
    ccRDC() {
        // Resume Direct Captioning (switch mode to PaintOn)
        this.logger.log(2, 'RDC - Resume Direct Captioning');
        this.setMode('MODE_PAINT-ON');
    }
    ccTR() {
        // Text Restart in text mode (not supported, however)
        this.logger.log(2, 'TR');
        this.setMode('MODE_TEXT');
    }
    ccRTD() {
        // Resume Text Display in Text mode (not supported, however)
        this.logger.log(2, 'RTD');
        this.setMode('MODE_TEXT');
    }
    ccEDM() {
        // Erase Displayed Memory
        this.logger.log(2, 'EDM - Erase Displayed Memory');
        this.displayedMemory.reset();
        this.outputDataUpdate(true);
    }
    ccCR() {
        // Carriage Return
        this.logger.log(2, 'CR - Carriage Return');
        this.writeScreen.rollUp();
        this.outputDataUpdate(true);
    }
    ccENM() {
        // Erase Non-Displayed Memory
        this.logger.log(2, 'ENM - Erase Non-displayed Memory');
        this.nonDisplayedMemory.reset();
    }
    ccEOC() {
        // End of Caption (Flip Memories)
        this.logger.log(2, 'EOC - End Of Caption');
        if (this.mode === 'MODE_POP-ON') {
            const tmp = this.displayedMemory;
            this.displayedMemory = this.nonDisplayedMemory;
            this.nonDisplayedMemory = tmp;
            this.writeScreen = this.nonDisplayedMemory;
            this.logger.log(1, ()=>'DISP: ' + this.displayedMemory.getDisplayText());
        }
        this.outputDataUpdate(true);
    }
    ccTO(nrCols) {
        // Tab Offset 1,2, or 3 columns
        this.logger.log(2, 'TO(' + nrCols + ') - Tab Offset');
        this.writeScreen.moveCursor(nrCols);
    }
    ccMIDROW(secondByte) {
        // Parse MIDROW command
        const styles = {
            flash: false
        };
        styles.underline = secondByte % 2 === 1;
        styles.italics = secondByte >= 0x2e;
        if (!styles.italics) {
            const colorIndex = Math.floor(secondByte / 2) - 0x10;
            const colors = [
                'white',
                'green',
                'blue',
                'cyan',
                'red',
                'yellow',
                'magenta'
            ];
            styles.foreground = colors[colorIndex];
        } else styles.foreground = 'white';
        this.logger.log(2, 'MIDROW: ' + $b941786f4eb9cb76$var$stringify(styles));
        this.writeScreen.setPen(styles);
    }
    outputDataUpdate(dispatch = false) {
        const time1 = this.logger.time;
        if (time1 === null) return;
        if (this.outputFilter) {
            if (this.cueStartTime === null && !this.displayedMemory.isEmpty()) // Start of a new cue
            this.cueStartTime = time1;
            else if (!this.displayedMemory.equals(this.lastOutputScreen)) {
                this.outputFilter.newCue(this.cueStartTime, time1, this.lastOutputScreen);
                if (dispatch && this.outputFilter.dispatchCue) this.outputFilter.dispatchCue();
                this.cueStartTime = this.displayedMemory.isEmpty() ? null : time1;
            }
            this.lastOutputScreen.copy(this.displayedMemory);
        }
    }
    cueSplitAtTime(t) {
        if (this.outputFilter) {
            if (!this.displayedMemory.isEmpty()) {
                if (this.outputFilter.newCue) this.outputFilter.newCue(this.cueStartTime, t, this.displayedMemory);
                this.cueStartTime = t;
            }
        }
    }
}
// Will be 1 or 2 when parsing captions
class $b941786f4eb9cb76$var$Cea608Parser {
    constructor(field, out1, out2){
        this.channels = void 0;
        this.currentChannel = 0;
        this.cmdHistory = $b941786f4eb9cb76$var$createCmdHistory();
        this.logger = void 0;
        const logger = this.logger = new $b941786f4eb9cb76$var$CaptionsLogger();
        this.channels = [
            null,
            new $b941786f4eb9cb76$var$Cea608Channel(field, out1, logger),
            new $b941786f4eb9cb76$var$Cea608Channel(field + 1, out2, logger)
        ];
    }
    getHandler(channel) {
        return this.channels[channel].getHandler();
    }
    setHandler(channel, newHandler) {
        this.channels[channel].setHandler(newHandler);
    }
    /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */ addData(time1, byteList) {
        this.logger.time = time1;
        for(let i = 0; i < byteList.length; i += 2){
            const a = byteList[i] & 0x7f;
            const b = byteList[i + 1] & 0x7f;
            let cmdFound = false;
            let charsFound = null;
            if (a === 0 && b === 0) continue;
            else this.logger.log(3, ()=>'[' + $b941786f4eb9cb76$var$numArrayToHexArray([
                    byteList[i],
                    byteList[i + 1]
                ]) + '] -> (' + $b941786f4eb9cb76$var$numArrayToHexArray([
                    a,
                    b
                ]) + ')');
            const cmdHistory = this.cmdHistory;
            const isControlCode = a >= 0x10 && a <= 0x1f;
            if (isControlCode) {
                // Skip redundant control codes
                if ($b941786f4eb9cb76$var$hasCmdRepeated(a, b, cmdHistory)) {
                    $b941786f4eb9cb76$var$setLastCmd(null, null, cmdHistory);
                    this.logger.log(3, ()=>'Repeated command (' + $b941786f4eb9cb76$var$numArrayToHexArray([
                            a,
                            b
                        ]) + ') is dropped');
                    continue;
                }
                $b941786f4eb9cb76$var$setLastCmd(a, b, this.cmdHistory);
                cmdFound = this.parseCmd(a, b);
                if (!cmdFound) cmdFound = this.parseMidrow(a, b);
                if (!cmdFound) cmdFound = this.parsePAC(a, b);
                if (!cmdFound) cmdFound = this.parseBackgroundAttributes(a, b);
            } else $b941786f4eb9cb76$var$setLastCmd(null, null, cmdHistory);
            if (!cmdFound) {
                charsFound = this.parseChars(a, b);
                if (charsFound) {
                    const currChNr = this.currentChannel;
                    if (currChNr && currChNr > 0) {
                        const channel = this.channels[currChNr];
                        channel.insertChars(charsFound);
                    } else this.logger.log(2, 'No channel found yet. TEXT-MODE?');
                }
            }
            if (!cmdFound && !charsFound) this.logger.log(2, ()=>"Couldn't parse cleaned data " + $b941786f4eb9cb76$var$numArrayToHexArray([
                    a,
                    b
                ]) + ' orig: ' + $b941786f4eb9cb76$var$numArrayToHexArray([
                    byteList[i],
                    byteList[i + 1]
                ]));
        }
    }
    /**
   * Parse Command.
   * @returns True if a command was found
   */ parseCmd(a, b) {
        const cond1 = (a === 0x14 || a === 0x1c || a === 0x15 || a === 0x1d) && b >= 0x20 && b <= 0x2f;
        const cond2 = (a === 0x17 || a === 0x1f) && b >= 0x21 && b <= 0x23;
        if (!(cond1 || cond2)) return false;
        const chNr = a === 0x14 || a === 0x15 || a === 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        if (a === 0x14 || a === 0x15 || a === 0x1c || a === 0x1d) {
            if (b === 0x20) channel.ccRCL();
            else if (b === 0x21) channel.ccBS();
            else if (b === 0x22) channel.ccAOF();
            else if (b === 0x23) channel.ccAON();
            else if (b === 0x24) channel.ccDER();
            else if (b === 0x25) channel.ccRU(2);
            else if (b === 0x26) channel.ccRU(3);
            else if (b === 0x27) channel.ccRU(4);
            else if (b === 0x28) channel.ccFON();
            else if (b === 0x29) channel.ccRDC();
            else if (b === 0x2a) channel.ccTR();
            else if (b === 0x2b) channel.ccRTD();
            else if (b === 0x2c) channel.ccEDM();
            else if (b === 0x2d) channel.ccCR();
            else if (b === 0x2e) channel.ccENM();
            else if (b === 0x2f) channel.ccEOC();
        } else // a == 0x17 || a == 0x1F
        channel.ccTO(b - 0x20);
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Parse midrow styling command
   */ parseMidrow(a, b) {
        let chNr = 0;
        if ((a === 0x11 || a === 0x19) && b >= 0x20 && b <= 0x2f) {
            if (a === 0x11) chNr = 1;
            else chNr = 2;
            if (chNr !== this.currentChannel) {
                this.logger.log(0, 'Mismatch channel in midrow parsing');
                return false;
            }
            const channel = this.channels[chNr];
            if (!channel) return false;
            channel.ccMIDROW(b);
            this.logger.log(3, ()=>'MIDROW (' + $b941786f4eb9cb76$var$numArrayToHexArray([
                    a,
                    b
                ]) + ')');
            return true;
        }
        return false;
    }
    /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */ parsePAC(a, b) {
        let row;
        const case1 = (a >= 0x11 && a <= 0x17 || a >= 0x19 && a <= 0x1f) && b >= 0x40 && b <= 0x7f;
        const case2 = (a === 0x10 || a === 0x18) && b >= 0x40 && b <= 0x5f;
        if (!(case1 || case2)) return false;
        const chNr = a <= 0x17 ? 1 : 2;
        if (b >= 0x40 && b <= 0x5f) row = chNr === 1 ? $b941786f4eb9cb76$var$rowsLowCh1[a] : $b941786f4eb9cb76$var$rowsLowCh2[a];
        else // 0x60 <= b <= 0x7F
        row = chNr === 1 ? $b941786f4eb9cb76$var$rowsHighCh1[a] : $b941786f4eb9cb76$var$rowsHighCh2[a];
        const channel = this.channels[chNr];
        if (!channel) return false;
        channel.setPAC(this.interpretPAC(row, b));
        this.currentChannel = chNr;
        return true;
    }
    /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */ interpretPAC(row, byte) {
        let pacIndex;
        const pacData = {
            color: null,
            italics: false,
            indent: null,
            underline: false,
            row: row
        };
        if (byte > 0x5f) pacIndex = byte - 0x60;
        else pacIndex = byte - 0x40;
        pacData.underline = (pacIndex & 1) === 1;
        if (pacIndex <= 0xd) pacData.color = [
            'white',
            'green',
            'blue',
            'cyan',
            'red',
            'yellow',
            'magenta',
            'white'
        ][Math.floor(pacIndex / 2)];
        else if (pacIndex <= 0xf) {
            pacData.italics = true;
            pacData.color = 'white';
        } else pacData.indent = Math.floor((pacIndex - 0x10) / 2) * 4;
        return pacData; // Note that row has zero offset. The spec uses 1.
    }
    /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */ parseChars(a, b) {
        let channelNr;
        let charCodes = null;
        let charCode1 = null;
        if (a >= 0x19) {
            channelNr = 2;
            charCode1 = a - 8;
        } else {
            channelNr = 1;
            charCode1 = a;
        }
        if (charCode1 >= 0x11 && charCode1 <= 0x13) {
            // Special character
            let oneCode;
            if (charCode1 === 0x11) oneCode = b + 0x50;
            else if (charCode1 === 0x12) oneCode = b + 0x70;
            else oneCode = b + 0x90;
            this.logger.log(2, ()=>"Special char '" + $b941786f4eb9cb76$var$getCharForByte(oneCode) + "' in channel " + channelNr);
            charCodes = [
                oneCode
            ];
        } else if (a >= 0x20 && a <= 0x7f) charCodes = b === 0 ? [
            a
        ] : [
            a,
            b
        ];
        if (charCodes) this.logger.log(3, ()=>'Char codes =  ' + $b941786f4eb9cb76$var$numArrayToHexArray(charCodes).join(','));
        return charCodes;
    }
    /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */ parseBackgroundAttributes(a, b) {
        const case1 = (a === 0x10 || a === 0x18) && b >= 0x20 && b <= 0x2f;
        const case2 = (a === 0x17 || a === 0x1f) && b >= 0x2d && b <= 0x2f;
        if (!(case1 || case2)) return false;
        let index;
        const bkgData = {};
        if (a === 0x10 || a === 0x18) {
            index = Math.floor((b - 0x20) / 2);
            bkgData.background = $b941786f4eb9cb76$var$backgroundColors[index];
            if (b % 2 === 1) bkgData.background = bkgData.background + '_semi';
        } else if (b === 0x2d) bkgData.background = 'transparent';
        else {
            bkgData.foreground = 'black';
            if (b === 0x2f) bkgData.underline = true;
        }
        const chNr = a <= 0x17 ? 1 : 2;
        const channel = this.channels[chNr];
        channel.setBkgData(bkgData);
        return true;
    }
    /**
   * Reset state of parser and its channels.
   */ reset() {
        for(let i = 0; i < Object.keys(this.channels).length; i++){
            const channel = this.channels[i];
            if (channel) channel.reset();
        }
        $b941786f4eb9cb76$var$setLastCmd(null, null, this.cmdHistory);
    }
    /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */ cueSplitAtTime(t) {
        for(let i = 0; i < this.channels.length; i++){
            const channel = this.channels[i];
            if (channel) channel.cueSplitAtTime(t);
        }
    }
}
function $b941786f4eb9cb76$var$setLastCmd(a, b, cmdHistory) {
    cmdHistory.a = a;
    cmdHistory.b = b;
}
function $b941786f4eb9cb76$var$hasCmdRepeated(a, b, cmdHistory) {
    return cmdHistory.a === a && cmdHistory.b === b;
}
function $b941786f4eb9cb76$var$createCmdHistory() {
    return {
        a: null,
        b: null
    };
}
/**
 * Copyright 2013 vtt.js Contributors
 *
 * Licensed under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an 'AS IS' BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $b941786f4eb9cb76$var$VTTCue = function() {
    if ($b941786f4eb9cb76$var$optionalSelf != null && $b941786f4eb9cb76$var$optionalSelf.VTTCue) return self.VTTCue;
    const AllowedDirections = [
        '',
        'lr',
        'rl'
    ];
    const AllowedAlignments = [
        'start',
        'middle',
        'end',
        'left',
        'right'
    ];
    function isAllowedValue(allowed, value) {
        if (typeof value !== 'string') return false;
        // necessary for assuring the generic conforms to the Array interface
        if (!Array.isArray(allowed)) return false;
        // reset the type so that the next narrowing works well
        const lcValue = value.toLowerCase();
        // use the allow list to narrow the type to a specific subset of strings
        if (~allowed.indexOf(lcValue)) return lcValue;
        return false;
    }
    function findDirectionSetting(value) {
        return isAllowedValue(AllowedDirections, value);
    }
    function findAlignSetting(value) {
        return isAllowedValue(AllowedAlignments, value);
    }
    function extend(obj, ...rest) {
        let i = 1;
        for(; i < arguments.length; i++){
            const cobj = arguments[i];
            for(const p in cobj)obj[p] = cobj[p];
        }
        return obj;
    }
    function VTTCue(startTime, endTime, text) {
        const cue = this;
        const baseObj = {
            enumerable: true
        };
        /**
     * Shim implementation specific properties. These properties are not in
     * the spec.
     */ // Lets us know when the VTTCue's data has changed in such a way that we need
        // to recompute its display state. This lets us compute its display state
        // lazily.
        cue.hasBeenReset = false;
        /**
     * VTTCue and TextTrackCue properties
     * http://dev.w3.org/html5/webvtt/#vttcue-interface
     */ let _id = '';
        let _pauseOnExit = false;
        let _startTime = startTime;
        let _endTime = endTime;
        let _text = text;
        let _region = null;
        let _vertical = '';
        let _snapToLines = true;
        let _line = 'auto';
        let _lineAlign = 'start';
        let _position = 50;
        let _positionAlign = 'middle';
        let _size = 50;
        let _align = 'middle';
        Object.defineProperty(cue, 'id', extend({}, baseObj, {
            get: function() {
                return _id;
            },
            set: function(value) {
                _id = '' + value;
            }
        }));
        Object.defineProperty(cue, 'pauseOnExit', extend({}, baseObj, {
            get: function() {
                return _pauseOnExit;
            },
            set: function(value) {
                _pauseOnExit = !!value;
            }
        }));
        Object.defineProperty(cue, 'startTime', extend({}, baseObj, {
            get: function() {
                return _startTime;
            },
            set: function(value) {
                if (typeof value !== 'number') throw new TypeError('Start time must be set to a number.');
                _startTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'endTime', extend({}, baseObj, {
            get: function() {
                return _endTime;
            },
            set: function(value) {
                if (typeof value !== 'number') throw new TypeError('End time must be set to a number.');
                _endTime = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'text', extend({}, baseObj, {
            get: function() {
                return _text;
            },
            set: function(value) {
                _text = '' + value;
                this.hasBeenReset = true;
            }
        }));
        // todo: implement VTTRegion polyfill?
        Object.defineProperty(cue, 'region', extend({}, baseObj, {
            get: function() {
                return _region;
            },
            set: function(value) {
                _region = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'vertical', extend({}, baseObj, {
            get: function() {
                return _vertical;
            },
            set: function(value) {
                const setting = findDirectionSetting(value);
                // Have to check for false because the setting an be an empty string.
                if (setting === false) throw new SyntaxError('An invalid or illegal string was specified.');
                _vertical = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'snapToLines', extend({}, baseObj, {
            get: function() {
                return _snapToLines;
            },
            set: function(value) {
                _snapToLines = !!value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'line', extend({}, baseObj, {
            get: function() {
                return _line;
            },
            set: function(value) {
                if (typeof value !== 'number' && value !== 'auto') throw new SyntaxError('An invalid number or illegal string was specified.');
                _line = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'lineAlign', extend({}, baseObj, {
            get: function() {
                return _lineAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _lineAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'position', extend({}, baseObj, {
            get: function() {
                return _position;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error('Position must be between 0 and 100.');
                _position = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'positionAlign', extend({}, baseObj, {
            get: function() {
                return _positionAlign;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _positionAlign = setting;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'size', extend({}, baseObj, {
            get: function() {
                return _size;
            },
            set: function(value) {
                if (value < 0 || value > 100) throw new Error('Size must be between 0 and 100.');
                _size = value;
                this.hasBeenReset = true;
            }
        }));
        Object.defineProperty(cue, 'align', extend({}, baseObj, {
            get: function() {
                return _align;
            },
            set: function(value) {
                const setting = findAlignSetting(value);
                if (!setting) throw new SyntaxError('An invalid or illegal string was specified.');
                _align = setting;
                this.hasBeenReset = true;
            }
        }));
        /**
     * Other <track> spec defined properties
     */ // http://www.whatwg.org/specs/web-apps/current-work/multipage/the-video-element.html#text-track-cue-display-state
        cue.displayState = undefined;
    }
    /**
   * VTTCue methods
   */ VTTCue.prototype.getCueAsHTML = function() {
        // Assume WebVTT.convertCueToDOMTree is on the global.
        const WebVTT = self.WebVTT;
        return WebVTT.convertCueToDOMTree(self, this.text);
    };
    // this is a polyfill hack
    return VTTCue;
}();
/*
 * Source: https://github.com/mozilla/vtt.js/blob/master/dist/vtt.js
 */ class $b941786f4eb9cb76$var$StringDecoder {
    decode(data, options) {
        if (!data) return '';
        if (typeof data !== 'string') throw new Error('Error - expected string data.');
        return decodeURIComponent(encodeURIComponent(data));
    }
}
// Try to parse input as a time stamp.
function $b941786f4eb9cb76$var$parseTimeStamp(input) {
    function computeSeconds(h, m, s, f) {
        return (h | 0) * 3600 + (m | 0) * 60 + (s | 0) + parseFloat(f || 0);
    }
    const m = input.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
    if (!m) return null;
    if (parseFloat(m[2]) > 59) // Timestamp takes the form of [hours]:[minutes].[milliseconds]
    // First position is hours as it's over 59.
    return computeSeconds(m[2], m[3], 0, m[4]);
    // Timestamp takes the form of [hours (optional)]:[minutes]:[seconds].[milliseconds]
    return computeSeconds(m[1], m[2], m[3], m[4]);
}
// A settings object holds key/value pairs and will ignore anything but the first
// assignment to a specific key.
class $b941786f4eb9cb76$var$Settings {
    constructor(){
        this.values = Object.create(null);
    }
    // Only accept the first assignment to any key.
    set(k, v) {
        if (!this.get(k) && v !== '') this.values[k] = v;
    }
    // Return the value for a key, or a default value.
    // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
    // a number of possible default values as properties where 'defaultKey' is
    // the key of the property that will be chosen; otherwise it's assumed to be
    // a single value.
    get(k, dflt, defaultKey) {
        if (defaultKey) return this.has(k) ? this.values[k] : dflt[defaultKey];
        return this.has(k) ? this.values[k] : dflt;
    }
    // Check whether we have a value for a key.
    has(k) {
        return k in this.values;
    }
    // Accept a setting if its one of the given alternatives.
    alt(k, v, a) {
        for(let n = 0; n < a.length; ++n)if (v === a[n]) {
            this.set(k, v);
            break;
        }
    }
    // Accept a setting if its a valid (signed) integer.
    integer(k, v) {
        if (/^-?\d+$/.test(v)) // integer
        this.set(k, parseInt(v, 10));
    }
    // Accept a setting if its a valid percentage.
    percent(k, v) {
        if (/^([\d]{1,3})(\.[\d]*)?%$/.test(v)) {
            const percent = parseFloat(v);
            if (percent >= 0 && percent <= 100) {
                this.set(k, percent);
                return true;
            }
        }
        return false;
    }
}
// Helper function to parse input into groups separated by 'groupDelim', and
// interpret each group as a key/value pair separated by 'keyValueDelim'.
function $b941786f4eb9cb76$var$parseOptions(input, callback, keyValueDelim, groupDelim) {
    const groups = groupDelim ? input.split(groupDelim) : [
        input
    ];
    for(const i in groups){
        if (typeof groups[i] !== 'string') continue;
        const kv = groups[i].split(keyValueDelim);
        if (kv.length !== 2) continue;
        const k = kv[0];
        const v = kv[1];
        callback(k, v);
    }
}
const $b941786f4eb9cb76$var$defaults = new $b941786f4eb9cb76$var$VTTCue(0, 0, '');
// 'middle' was changed to 'center' in the spec: https://github.com/w3c/webvtt/pull/244
//  Safari doesn't yet support this change, but FF and Chrome do.
const $b941786f4eb9cb76$var$center = $b941786f4eb9cb76$var$defaults.align === 'middle' ? 'middle' : 'center';
function $b941786f4eb9cb76$var$parseCue(input, cue, regionList) {
    // Remember the original input if we need to throw an error.
    const oInput = input;
    // 4.1 WebVTT timestamp
    function consumeTimeStamp() {
        const ts = $b941786f4eb9cb76$var$parseTimeStamp(input);
        if (ts === null) throw new Error('Malformed timestamp: ' + oInput);
        // Remove time stamp from input.
        input = input.replace(/^[^\sa-zA-Z-]+/, '');
        return ts;
    }
    // 4.4.2 WebVTT cue settings
    function consumeCueSettings(input, cue) {
        const settings = new $b941786f4eb9cb76$var$Settings();
        $b941786f4eb9cb76$var$parseOptions(input, function(k, v) {
            let vals;
            switch(k){
                case 'region':
                    // Find the last region we parsed with the same region id.
                    for(let i = regionList.length - 1; i >= 0; i--)if (regionList[i].id === v) {
                        settings.set(k, regionList[i].region);
                        break;
                    }
                    break;
                case 'vertical':
                    settings.alt(k, v, [
                        'rl',
                        'lr'
                    ]);
                    break;
                case 'line':
                    vals = v.split(',');
                    settings.integer(k, vals[0]);
                    if (settings.percent(k, vals[0])) settings.set('snapToLines', false);
                    settings.alt(k, vals[0], [
                        'auto'
                    ]);
                    if (vals.length === 2) settings.alt('lineAlign', vals[1], [
                        'start',
                        $b941786f4eb9cb76$var$center,
                        'end'
                    ]);
                    break;
                case 'position':
                    vals = v.split(',');
                    settings.percent(k, vals[0]);
                    if (vals.length === 2) settings.alt('positionAlign', vals[1], [
                        'start',
                        $b941786f4eb9cb76$var$center,
                        'end',
                        'line-left',
                        'line-right',
                        'auto'
                    ]);
                    break;
                case 'size':
                    settings.percent(k, v);
                    break;
                case 'align':
                    settings.alt(k, v, [
                        'start',
                        $b941786f4eb9cb76$var$center,
                        'end',
                        'left',
                        'right'
                    ]);
                    break;
            }
        }, /:/, /\s/);
        // Apply default values for any missing fields.
        cue.region = settings.get('region', null);
        cue.vertical = settings.get('vertical', '');
        let line = settings.get('line', 'auto');
        if (line === 'auto' && $b941786f4eb9cb76$var$defaults.line === -1) // set numeric line number for Safari
        line = -1;
        cue.line = line;
        cue.lineAlign = settings.get('lineAlign', 'start');
        cue.snapToLines = settings.get('snapToLines', true);
        cue.size = settings.get('size', 100);
        cue.align = settings.get('align', $b941786f4eb9cb76$var$center);
        let position = settings.get('position', 'auto');
        if (position === 'auto' && $b941786f4eb9cb76$var$defaults.position === 50) // set numeric position for Safari
        position = cue.align === 'start' || cue.align === 'left' ? 0 : cue.align === 'end' || cue.align === 'right' ? 100 : 50;
        cue.position = position;
    }
    function skipWhitespace() {
        input = input.replace(/^\s+/, '');
    }
    // 4.1 WebVTT cue timings.
    skipWhitespace();
    cue.startTime = consumeTimeStamp(); // (1) collect cue start time
    skipWhitespace();
    if (input.slice(0, 3) !== '-->') // (3) next characters must match '-->'
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + oInput);
    input = input.slice(3);
    skipWhitespace();
    cue.endTime = consumeTimeStamp(); // (5) collect cue end time
    // 4.1 WebVTT cue settings list.
    skipWhitespace();
    consumeCueSettings(input, cue);
}
function $b941786f4eb9cb76$var$fixLineBreaks(input) {
    return input.replace(/<br(?: \/)?>/gi, '\n');
}
class $b941786f4eb9cb76$var$VTTParser {
    constructor(){
        this.state = 'INITIAL';
        this.buffer = '';
        this.decoder = new $b941786f4eb9cb76$var$StringDecoder();
        this.regionList = [];
        this.cue = null;
        this.oncue = void 0;
        this.onparsingerror = void 0;
        this.onflush = void 0;
    }
    parse(data) {
        const _this = this;
        // If there is no data then we won't decode it, but will just try to parse
        // whatever is in buffer already. This may occur in circumstances, for
        // example when flush() is called.
        if (data) // Try to decode the data that we received.
        _this.buffer += _this.decoder.decode(data, {
            stream: true
        });
        function collectNextLine() {
            let buffer = _this.buffer;
            let pos = 0;
            buffer = $b941786f4eb9cb76$var$fixLineBreaks(buffer);
            while(pos < buffer.length && buffer[pos] !== '\r' && buffer[pos] !== '\n')++pos;
            const line = buffer.slice(0, pos);
            // Advance the buffer early in case we fail below.
            if (buffer[pos] === '\r') ++pos;
            if (buffer[pos] === '\n') ++pos;
            _this.buffer = buffer.slice(pos);
            return line;
        }
        // 3.2 WebVTT metadata header syntax
        function parseHeader(input) {
            $b941786f4eb9cb76$var$parseOptions(input, function(k, v) {
            // switch (k) {
            // case 'region':
            // 3.3 WebVTT region metadata header syntax
            // console.log('parse region', v);
            // parseRegion(v);
            // break;
            // }
            }, /:/);
        }
        // 5.1 WebVTT file parsing.
        try {
            let line = '';
            if (_this.state === 'INITIAL') {
                // We can't start parsing until we have the first line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                line = collectNextLine();
                // strip of UTF-8 BOM if any
                // https://en.wikipedia.org/wiki/Byte_order_mark#UTF-8
                const m = line.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
                if (!(m != null && m[0])) throw new Error('Malformed WebVTT signature.');
                _this.state = 'HEADER';
            }
            let alreadyCollectedLine = false;
            while(_this.buffer){
                // We can't parse a line until we have the full line.
                if (!/\r\n|\n/.test(_this.buffer)) return this;
                if (!alreadyCollectedLine) line = collectNextLine();
                else alreadyCollectedLine = false;
                switch(_this.state){
                    case 'HEADER':
                        // 13-18 - Allow a header (metadata) under the WEBVTT line.
                        if (/:/.test(line)) parseHeader(line);
                        else if (!line) // An empty line terminates the header and starts the body (cues).
                        _this.state = 'ID';
                        continue;
                    case 'NOTE':
                        // Ignore NOTE blocks.
                        if (!line) _this.state = 'ID';
                        continue;
                    case 'ID':
                        // Check for the start of NOTE blocks.
                        if (/^NOTE($|[ \t])/.test(line)) {
                            _this.state = 'NOTE';
                            break;
                        }
                        // 19-29 - Allow any number of line terminators, then initialize new cue values.
                        if (!line) continue;
                        _this.cue = new $b941786f4eb9cb76$var$VTTCue(0, 0, '');
                        _this.state = 'CUE';
                        // 30-39 - Check if self line contains an optional identifier or timing data.
                        if (line.indexOf('-->') === -1) {
                            _this.cue.id = line;
                            continue;
                        }
                    // Process line as start of a cue.
                    /* falls through */ case 'CUE':
                        // 40 - Collect cue timings and settings.
                        if (!_this.cue) {
                            _this.state = 'BADCUE';
                            continue;
                        }
                        try {
                            $b941786f4eb9cb76$var$parseCue(line, _this.cue, _this.regionList);
                        } catch (e) {
                            // In case of an error ignore rest of the cue.
                            _this.cue = null;
                            _this.state = 'BADCUE';
                            continue;
                        }
                        _this.state = 'CUETEXT';
                        continue;
                    case 'CUETEXT':
                        {
                            const hasSubstring = line.indexOf('-->') !== -1;
                            // 34 - If we have an empty line then report the cue.
                            // 35 - If we have the special substring '-->' then report the cue,
                            // but do not collect the line as we need to process the current
                            // one as a new cue.
                            if (!line || hasSubstring && (alreadyCollectedLine = true)) {
                                // We are done parsing self cue.
                                if (_this.oncue && _this.cue) _this.oncue(_this.cue);
                                _this.cue = null;
                                _this.state = 'ID';
                                continue;
                            }
                            if (_this.cue === null) continue;
                            if (_this.cue.text) _this.cue.text += '\n';
                            _this.cue.text += line;
                        }
                        continue;
                    case 'BADCUE':
                        // 54-62 - Collect and discard the remaining cue.
                        if (!line) _this.state = 'ID';
                }
            }
        } catch (e) {
            // If we are currently parsing a cue, report what we have.
            if (_this.state === 'CUETEXT' && _this.cue && _this.oncue) _this.oncue(_this.cue);
            _this.cue = null;
            // Enter BADWEBVTT state if header was not parsed correctly otherwise
            // another exception occurred so enter BADCUE state.
            _this.state = _this.state === 'INITIAL' ? 'BADWEBVTT' : 'BADCUE';
        }
        return this;
    }
    flush() {
        const _this = this;
        try {
            // Finish decoding the stream.
            // _this.buffer += _this.decoder.decode();
            // Synthesize the end of the current cue or region.
            if (_this.cue || _this.state === 'HEADER') {
                _this.buffer += '\n\n';
                _this.parse();
            }
            // If we've flushed, parsed, and we're still on the INITIAL state then
            // that means we don't have enough of the stream to parse the first
            // line.
            if (_this.state === 'INITIAL' || _this.state === 'BADWEBVTT') throw new Error('Malformed WebVTT signature.');
        } catch (e) {
            if (_this.onparsingerror) _this.onparsingerror(e);
        }
        if (_this.onflush) _this.onflush();
        return this;
    }
}
const $b941786f4eb9cb76$var$LINEBREAKS = /\r\n|\n\r|\n|\r/g;
// String.prototype.startsWith is not supported in IE11
const $b941786f4eb9cb76$var$startsWith = function startsWith(inputString, searchString, position = 0) {
    return inputString.slice(position, position + searchString.length) === searchString;
};
const $b941786f4eb9cb76$var$cueString2millis = function cueString2millis(timeString) {
    let ts = parseInt(timeString.slice(-3));
    const secs = parseInt(timeString.slice(-6, -4));
    const mins = parseInt(timeString.slice(-9, -7));
    const hours = timeString.length > 9 ? parseInt(timeString.substring(0, timeString.indexOf(':'))) : 0;
    if (!$b941786f4eb9cb76$var$isFiniteNumber(ts) || !$b941786f4eb9cb76$var$isFiniteNumber(secs) || !$b941786f4eb9cb76$var$isFiniteNumber(mins) || !$b941786f4eb9cb76$var$isFiniteNumber(hours)) throw Error(`Malformed X-TIMESTAMP-MAP: Local:${timeString}`);
    ts += 1000 * secs;
    ts += 60000 * mins;
    ts += 3600000 * hours;
    return ts;
};
// Create a unique hash id for a cue based on start/end times and text.
// This helps timeline-controller to avoid showing repeated captions.
function $b941786f4eb9cb76$var$generateCueId(startTime, endTime, text) {
    return $b941786f4eb9cb76$var$hash(startTime.toString()) + $b941786f4eb9cb76$var$hash(endTime.toString()) + $b941786f4eb9cb76$var$hash(text);
}
const $b941786f4eb9cb76$var$calculateOffset = function calculateOffset(vttCCs, cc, presentationTime) {
    let currCC = vttCCs[cc];
    let prevCC = vttCCs[currCC.prevCC];
    // This is the first discontinuity or cues have been processed since the last discontinuity
    // Offset = current discontinuity time
    if (!prevCC || !prevCC.new && currCC.new) {
        vttCCs.ccOffset = vttCCs.presentationOffset = currCC.start;
        currCC.new = false;
        return;
    }
    // There have been discontinuities since cues were last parsed.
    // Offset = time elapsed
    while((_prevCC = prevCC) != null && _prevCC.new){
        var _prevCC;
        vttCCs.ccOffset += currCC.start - prevCC.start;
        currCC.new = false;
        currCC = prevCC;
        prevCC = vttCCs[currCC.prevCC];
    }
    vttCCs.presentationOffset = presentationTime;
};
function $b941786f4eb9cb76$var$parseWebVTT(vttByteArray, initPTS, vttCCs, cc, timeOffset, callBack, errorCallBack) {
    const parser = new $b941786f4eb9cb76$var$VTTParser();
    // Convert byteArray into string, replacing any somewhat exotic linefeeds with "\n", then split on that character.
    // Uint8Array.prototype.reduce is not implemented in IE11
    const vttLines = $b941786f4eb9cb76$var$utf8ArrayToStr(new Uint8Array(vttByteArray)).trim().replace($b941786f4eb9cb76$var$LINEBREAKS, '\n').split('\n');
    const cues = [];
    const init90kHz = initPTS ? $b941786f4eb9cb76$var$toMpegTsClockFromTimescale(initPTS.baseTime, initPTS.timescale) : 0;
    let cueTime = '00:00.000';
    let timestampMapMPEGTS = 0;
    let timestampMapLOCAL = 0;
    let parsingError;
    let inHeader = true;
    parser.oncue = function(cue) {
        // Adjust cue timing; clamp cues to start no earlier than - and drop cues that don't end after - 0 on timeline.
        const currCC = vttCCs[cc];
        let cueOffset = vttCCs.ccOffset;
        // Calculate subtitle PTS offset
        const webVttMpegTsMapOffset = (timestampMapMPEGTS - init90kHz) / 90000;
        // Update offsets for new discontinuities
        if (currCC != null && currCC.new) {
            if (timestampMapLOCAL !== undefined) // When local time is provided, offset = discontinuity start time - local time
            cueOffset = vttCCs.ccOffset = currCC.start;
            else $b941786f4eb9cb76$var$calculateOffset(vttCCs, cc, webVttMpegTsMapOffset);
        }
        if (webVttMpegTsMapOffset) {
            if (!initPTS) {
                parsingError = new Error('Missing initPTS for VTT MPEGTS');
                return;
            }
            // If we have MPEGTS, offset = presentation time + discontinuity offset
            cueOffset = webVttMpegTsMapOffset - vttCCs.presentationOffset;
        }
        const duration = cue.endTime - cue.startTime;
        const startTime = $b941786f4eb9cb76$var$normalizePts((cue.startTime + cueOffset - timestampMapLOCAL) * 90000, timeOffset * 90000) / 90000;
        cue.startTime = Math.max(startTime, 0);
        cue.endTime = Math.max(startTime + duration, 0);
        //trim trailing webvtt block whitespaces
        const text = cue.text.trim();
        // Fix encoding of special characters
        cue.text = decodeURIComponent(encodeURIComponent(text));
        // If the cue was not assigned an id from the VTT file (line above the content), create one.
        if (!cue.id) cue.id = $b941786f4eb9cb76$var$generateCueId(cue.startTime, cue.endTime, text);
        if (cue.endTime > 0) cues.push(cue);
    };
    parser.onparsingerror = function(error) {
        parsingError = error;
    };
    parser.onflush = function() {
        if (parsingError) {
            errorCallBack(parsingError);
            return;
        }
        callBack(cues);
    };
    // Go through contents line by line.
    vttLines.forEach((line)=>{
        if (inHeader) {
            // Look for X-TIMESTAMP-MAP in header.
            if ($b941786f4eb9cb76$var$startsWith(line, 'X-TIMESTAMP-MAP=')) {
                // Once found, no more are allowed anyway, so stop searching.
                inHeader = false;
                // Extract LOCAL and MPEGTS.
                line.slice(16).split(',').forEach((timestamp)=>{
                    if ($b941786f4eb9cb76$var$startsWith(timestamp, 'LOCAL:')) cueTime = timestamp.slice(6);
                    else if ($b941786f4eb9cb76$var$startsWith(timestamp, 'MPEGTS:')) timestampMapMPEGTS = parseInt(timestamp.slice(7));
                });
                try {
                    // Convert cue time to seconds
                    timestampMapLOCAL = $b941786f4eb9cb76$var$cueString2millis(cueTime) / 1000;
                } catch (error) {
                    parsingError = error;
                }
                // Return without parsing X-TIMESTAMP-MAP line.
                return;
            } else if (line === '') inHeader = false;
        }
        // Parse line by default.
        parser.parse(line + '\n');
    });
    parser.flush();
}
const $b941786f4eb9cb76$var$IMSC1_CODEC = 'stpp.ttml.im1t';
// Time format: h:m:s:frames(.subframes)
const $b941786f4eb9cb76$var$HMSF_REGEX = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/;
// Time format: hours, minutes, seconds, milliseconds, frames, ticks
const $b941786f4eb9cb76$var$TIME_UNIT_REGEX = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/;
const $b941786f4eb9cb76$var$textAlignToLineAlign = {
    left: 'start',
    center: 'center',
    right: 'end',
    start: 'start',
    end: 'end'
};
function $b941786f4eb9cb76$var$parseIMSC1(payload, initPTS, callBack, errorCallBack) {
    const results = $b941786f4eb9cb76$var$findBox(new Uint8Array(payload), [
        'mdat'
    ]);
    if (results.length === 0) {
        errorCallBack(new Error('Could not parse IMSC1 mdat'));
        return;
    }
    const ttmlList = results.map((mdat)=>$b941786f4eb9cb76$var$utf8ArrayToStr(mdat));
    const syncTime = $b941786f4eb9cb76$var$toTimescaleFromScale(initPTS.baseTime, 1, initPTS.timescale);
    try {
        ttmlList.forEach((ttml)=>callBack($b941786f4eb9cb76$var$parseTTML(ttml, syncTime)));
    } catch (error) {
        errorCallBack(error);
    }
}
function $b941786f4eb9cb76$var$parseTTML(ttml, syncTime) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(ttml, 'text/xml');
    const tt = xmlDoc.getElementsByTagName('tt')[0];
    if (!tt) throw new Error('Invalid ttml');
    const defaultRateInfo = {
        frameRate: 30,
        subFrameRate: 1,
        frameRateMultiplier: 0,
        tickRate: 0
    };
    const rateInfo = Object.keys(defaultRateInfo).reduce((result, key)=>{
        result[key] = tt.getAttribute(`ttp:${key}`) || defaultRateInfo[key];
        return result;
    }, {});
    const trim = tt.getAttribute('xml:space') !== 'preserve';
    const styleElements = $b941786f4eb9cb76$var$collectionToDictionary($b941786f4eb9cb76$var$getElementCollection(tt, 'styling', 'style'));
    const regionElements = $b941786f4eb9cb76$var$collectionToDictionary($b941786f4eb9cb76$var$getElementCollection(tt, 'layout', 'region'));
    const cueElements = $b941786f4eb9cb76$var$getElementCollection(tt, 'body', '[begin]');
    return [].map.call(cueElements, (cueElement)=>{
        const cueText = $b941786f4eb9cb76$var$getTextContent(cueElement, trim);
        if (!cueText || !cueElement.hasAttribute('begin')) return null;
        const startTime = $b941786f4eb9cb76$var$parseTtmlTime(cueElement.getAttribute('begin'), rateInfo);
        const duration = $b941786f4eb9cb76$var$parseTtmlTime(cueElement.getAttribute('dur'), rateInfo);
        let endTime = $b941786f4eb9cb76$var$parseTtmlTime(cueElement.getAttribute('end'), rateInfo);
        if (startTime === null) throw $b941786f4eb9cb76$var$timestampParsingError(cueElement);
        if (endTime === null) {
            if (duration === null) throw $b941786f4eb9cb76$var$timestampParsingError(cueElement);
            endTime = startTime + duration;
        }
        const cue = new $b941786f4eb9cb76$var$VTTCue(startTime - syncTime, endTime - syncTime, cueText);
        cue.id = $b941786f4eb9cb76$var$generateCueId(cue.startTime, cue.endTime, cue.text);
        const region = regionElements[cueElement.getAttribute('region')];
        const style = styleElements[cueElement.getAttribute('style')];
        // Apply styles to cue
        const styles = $b941786f4eb9cb76$var$getTtmlStyles(region, style, styleElements);
        const { textAlign: textAlign } = styles;
        if (textAlign) {
            // cue.positionAlign not settable in FF~2016
            const lineAlign = $b941786f4eb9cb76$var$textAlignToLineAlign[textAlign];
            if (lineAlign) cue.lineAlign = lineAlign;
            cue.align = textAlign;
        }
        $b941786f4eb9cb76$var$_extends(cue, styles);
        return cue;
    }).filter((cue)=>cue !== null);
}
function $b941786f4eb9cb76$var$getElementCollection(fromElement, parentName, childName) {
    const parent = fromElement.getElementsByTagName(parentName)[0];
    if (parent) return [].slice.call(parent.querySelectorAll(childName));
    return [];
}
function $b941786f4eb9cb76$var$collectionToDictionary(elementsWithId) {
    return elementsWithId.reduce((dict, element)=>{
        const id = element.getAttribute('xml:id');
        if (id) dict[id] = element;
        return dict;
    }, {});
}
function $b941786f4eb9cb76$var$getTextContent(element, trim) {
    return [].slice.call(element.childNodes).reduce((str, node, i)=>{
        var _node$childNodes;
        if (node.nodeName === 'br' && i) return str + '\n';
        if ((_node$childNodes = node.childNodes) != null && _node$childNodes.length) return $b941786f4eb9cb76$var$getTextContent(node, trim);
        else if (trim) return str + node.textContent.trim().replace(/\s+/g, ' ');
        return str + node.textContent;
    }, '');
}
function $b941786f4eb9cb76$var$getTtmlStyles(region, style, styleElements) {
    const ttsNs = 'http://www.w3.org/ns/ttml#styling';
    let regionStyle = null;
    const styleAttributes = [
        'displayAlign',
        'textAlign',
        'color',
        'backgroundColor',
        'fontSize',
        'fontFamily'
    ];
    const regionStyleName = region != null && region.hasAttribute('style') ? region.getAttribute('style') : null;
    if (regionStyleName && styleElements.hasOwnProperty(regionStyleName)) regionStyle = styleElements[regionStyleName];
    return styleAttributes.reduce((styles, name)=>{
        const value = $b941786f4eb9cb76$var$getAttributeNS(style, ttsNs, name) || $b941786f4eb9cb76$var$getAttributeNS(region, ttsNs, name) || $b941786f4eb9cb76$var$getAttributeNS(regionStyle, ttsNs, name);
        if (value) styles[name] = value;
        return styles;
    }, {});
}
function $b941786f4eb9cb76$var$getAttributeNS(element, ns, name) {
    if (!element) return null;
    return element.hasAttributeNS(ns, name) ? element.getAttributeNS(ns, name) : null;
}
function $b941786f4eb9cb76$var$timestampParsingError(node) {
    return new Error(`Could not parse ttml timestamp ${node}`);
}
function $b941786f4eb9cb76$var$parseTtmlTime(timeAttributeValue, rateInfo) {
    if (!timeAttributeValue) return null;
    let seconds = $b941786f4eb9cb76$var$parseTimeStamp(timeAttributeValue);
    if (seconds === null) {
        if ($b941786f4eb9cb76$var$HMSF_REGEX.test(timeAttributeValue)) seconds = $b941786f4eb9cb76$var$parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo);
        else if ($b941786f4eb9cb76$var$TIME_UNIT_REGEX.test(timeAttributeValue)) seconds = $b941786f4eb9cb76$var$parseTimeUnits(timeAttributeValue, rateInfo);
    }
    return seconds;
}
function $b941786f4eb9cb76$var$parseHoursMinutesSecondsFrames(timeAttributeValue, rateInfo) {
    const m = $b941786f4eb9cb76$var$HMSF_REGEX.exec(timeAttributeValue);
    const frames = (m[4] | 0) + (m[5] | 0) / rateInfo.subFrameRate;
    return (m[1] | 0) * 3600 + (m[2] | 0) * 60 + (m[3] | 0) + frames / rateInfo.frameRate;
}
function $b941786f4eb9cb76$var$parseTimeUnits(timeAttributeValue, rateInfo) {
    const m = $b941786f4eb9cb76$var$TIME_UNIT_REGEX.exec(timeAttributeValue);
    const value = Number(m[1]);
    const unit = m[2];
    switch(unit){
        case 'h':
            return value * 3600;
        case 'm':
            return value * 60;
        case 'ms':
            return value * 1000;
        case 'f':
            return value / rateInfo.frameRate;
        case 't':
            return value / rateInfo.tickRate;
    }
    return value;
}
class $b941786f4eb9cb76$var$OutputFilter {
    constructor(timelineController, trackName){
        this.timelineController = void 0;
        this.cueRanges = [];
        this.trackName = void 0;
        this.startTime = null;
        this.endTime = null;
        this.screen = null;
        this.timelineController = timelineController;
        this.trackName = trackName;
    }
    dispatchCue() {
        if (this.startTime === null) return;
        this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges);
        this.startTime = null;
    }
    newCue(startTime, endTime, screen) {
        if (this.startTime === null || this.startTime > startTime) this.startTime = startTime;
        this.endTime = endTime;
        this.screen = screen;
        this.timelineController.createCaptionsTrack(this.trackName);
    }
    reset() {
        this.cueRanges = [];
        this.startTime = null;
    }
}
class $b941786f4eb9cb76$export$33d15e092164e5ef {
    constructor(hls){
        this.hls = void 0;
        this.media = null;
        this.config = void 0;
        this.enabled = true;
        this.Cues = void 0;
        this.textTracks = [];
        this.tracks = [];
        this.initPTS = [];
        this.unparsedVttFrags = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.cea608Parser1 = void 0;
        this.cea608Parser2 = void 0;
        this.lastCc = -1;
        // Last video (CEA-608) fragment CC
        this.lastSn = -1;
        // Last video (CEA-608) fragment MSN
        this.lastPartIndex = -1;
        // Last video (CEA-608) fragment Part Index
        this.prevCC = -1;
        // Last subtitle fragment CC
        this.vttCCs = $b941786f4eb9cb76$var$newVTTCCs();
        this.captionsProperties = void 0;
        this.hls = hls;
        this.config = hls.config;
        this.Cues = hls.config.cueHandler;
        this.captionsProperties = {
            textTrack1: {
                label: this.config.captionsTextTrack1Label,
                languageCode: this.config.captionsTextTrack1LanguageCode
            },
            textTrack2: {
                label: this.config.captionsTextTrack2Label,
                languageCode: this.config.captionsTextTrack2LanguageCode
            },
            textTrack3: {
                label: this.config.captionsTextTrack3Label,
                languageCode: this.config.captionsTextTrack3LanguageCode
            },
            textTrack4: {
                label: this.config.captionsTextTrack4Label,
                languageCode: this.config.captionsTextTrack4LanguageCode
            }
        };
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
    }
    destroy() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADING, this.onFragLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, this.onFragLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_DECRYPTED, this.onFragDecrypted, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.INIT_PTS_FOUND, this.onInitPtsFound, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
        // @ts-ignore
        this.hls = this.config = this.media = null;
        this.cea608Parser1 = this.cea608Parser2 = undefined;
    }
    initCea608Parsers() {
        const channel1 = new $b941786f4eb9cb76$var$OutputFilter(this, 'textTrack1');
        const channel2 = new $b941786f4eb9cb76$var$OutputFilter(this, 'textTrack2');
        const channel3 = new $b941786f4eb9cb76$var$OutputFilter(this, 'textTrack3');
        const channel4 = new $b941786f4eb9cb76$var$OutputFilter(this, 'textTrack4');
        this.cea608Parser1 = new $b941786f4eb9cb76$var$Cea608Parser(1, channel1, channel2);
        this.cea608Parser2 = new $b941786f4eb9cb76$var$Cea608Parser(3, channel3, channel4);
    }
    addCues(trackName, startTime, endTime, screen, cueRanges) {
        // skip cues which overlap more than 50% with previously parsed time ranges
        let merged = false;
        for(let i = cueRanges.length; i--;){
            const cueRange = cueRanges[i];
            const overlap = $b941786f4eb9cb76$var$intersection(cueRange[0], cueRange[1], startTime, endTime);
            if (overlap >= 0) {
                cueRange[0] = Math.min(cueRange[0], startTime);
                cueRange[1] = Math.max(cueRange[1], endTime);
                merged = true;
                if (overlap / (endTime - startTime) > 0.5) return;
            }
        }
        if (!merged) cueRanges.push([
            startTime,
            endTime
        ]);
        if (this.config.renderTextTracksNatively) {
            const track = this.captionsTracks[trackName];
            this.Cues.newCue(track, startTime, endTime, screen);
        } else {
            const cues = this.Cues.newCue(null, startTime, endTime, screen);
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.CUES_PARSED, {
                type: 'captions',
                cues: cues,
                track: trackName
            });
        }
    }
    // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
    onInitPtsFound(event, { frag: frag, id: id, initPTS: initPTS, timescale: timescale, trackId: trackId }) {
        const { unparsedVttFrags: unparsedVttFrags } = this;
        if (id === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) this.initPTS[frag.cc] = {
            baseTime: initPTS,
            timescale: timescale,
            trackId: trackId
        };
        // Due to asynchronous processing, initial PTS may arrive later than the first VTT fragments are loaded.
        // Parse any unparsed fragments upon receiving the initial PTS.
        if (unparsedVttFrags.length) {
            this.unparsedVttFrags = [];
            unparsedVttFrags.forEach((data)=>{
                if (this.initPTS[data.frag.cc]) this.onFragLoaded($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, data);
                else this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                    success: false,
                    frag: data.frag,
                    error: new Error('Subtitle discontinuity domain does not match main')
                });
            });
        }
    }
    getExistingTrack(label, language) {
        const { media: media } = this;
        if (media) for(let i = 0; i < media.textTracks.length; i++){
            const textTrack = media.textTracks[i];
            if ($b941786f4eb9cb76$var$canReuseVttTextTrack(textTrack, {
                name: label,
                lang: language,
                characteristics: 'transcribes-spoken-dialog,describes-music-and-sound'
            })) return textTrack;
        }
        return null;
    }
    createCaptionsTrack(trackName) {
        if (this.config.renderTextTracksNatively) this.createNativeTrack(trackName);
        else this.createNonNativeTrack(trackName);
    }
    createNativeTrack(trackName) {
        if (this.captionsTracks[trackName]) return;
        const { captionsProperties: captionsProperties, captionsTracks: captionsTracks, media: media } = this;
        const { label: label, languageCode: languageCode } = captionsProperties[trackName];
        // Enable reuse of existing text track.
        const existingTrack = this.getExistingTrack(label, languageCode);
        if (!existingTrack) {
            const textTrack = this.createTextTrack('captions', label, languageCode);
            if (textTrack) {
                // Set a special property on the track so we know it's managed by Hls.js
                textTrack[trackName] = true;
                captionsTracks[trackName] = textTrack;
            }
        } else {
            captionsTracks[trackName] = existingTrack;
            $b941786f4eb9cb76$var$clearCurrentCues(captionsTracks[trackName]);
            $b941786f4eb9cb76$var$sendAddTrackEvent(captionsTracks[trackName], media);
        }
    }
    createNonNativeTrack(trackName) {
        if (this.nonNativeCaptionsTracks[trackName]) return;
        // Create a list of a single track for the provider to consume
        const trackProperties = this.captionsProperties[trackName];
        if (!trackProperties) return;
        const label = trackProperties.label;
        const track = {
            _id: trackName,
            label: label,
            kind: 'captions',
            default: trackProperties.media ? !!trackProperties.media.default : false,
            closedCaptions: trackProperties.media
        };
        this.nonNativeCaptionsTracks[trackName] = track;
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.NON_NATIVE_TEXT_TRACKS_FOUND, {
            tracks: [
                track
            ]
        });
    }
    createTextTrack(kind, label, lang) {
        const media = this.media;
        if (!media) return;
        return media.addTextTrack(kind, label, lang);
    }
    onMediaAttaching(event, data) {
        this.media = data.media;
        if (!data.mediaSource) this._cleanTracks();
    }
    onMediaDetaching(event, data) {
        const transferringMedia = !!data.transferMedia;
        this.media = null;
        if (transferringMedia) return;
        const { captionsTracks: captionsTracks } = this;
        Object.keys(captionsTracks).forEach((trackName)=>{
            $b941786f4eb9cb76$var$clearCurrentCues(captionsTracks[trackName]);
            delete captionsTracks[trackName];
        });
        this.nonNativeCaptionsTracks = {};
    }
    onManifestLoading() {
        // Detect discontinuity in video fragment (CEA-608) parsing
        this.lastCc = -1;
        this.lastSn = -1;
        this.lastPartIndex = -1;
        // Detect discontinuity in subtitle manifests
        this.prevCC = -1;
        this.vttCCs = $b941786f4eb9cb76$var$newVTTCCs();
        // Reset tracks
        this._cleanTracks();
        this.tracks = [];
        this.captionsTracks = {};
        this.nonNativeCaptionsTracks = {};
        this.textTracks = [];
        this.unparsedVttFrags = [];
        this.initPTS = [];
        if (this.cea608Parser1 && this.cea608Parser2) {
            this.cea608Parser1.reset();
            this.cea608Parser2.reset();
        }
    }
    _cleanTracks() {
        // clear outdated subtitles
        const { media: media } = this;
        if (!media) return;
        const textTracks = media.textTracks;
        if (textTracks) for(let i = 0; i < textTracks.length; i++)$b941786f4eb9cb76$var$clearCurrentCues(textTracks[i]);
    }
    onSubtitleTracksUpdated(event, data) {
        const tracks = data.subtitleTracks || [];
        const hasIMSC1 = tracks.some((track)=>track.textCodec === $b941786f4eb9cb76$var$IMSC1_CODEC);
        if (this.config.enableWebVTT || hasIMSC1 && this.config.enableIMSC1) {
            const listIsIdentical = $b941786f4eb9cb76$var$subtitleOptionsIdentical(this.tracks, tracks);
            if (listIsIdentical) {
                this.tracks = tracks;
                return;
            }
            this.textTracks = [];
            this.tracks = tracks;
            if (this.config.renderTextTracksNatively) {
                const media = this.media;
                const inUseTracks = media ? $b941786f4eb9cb76$var$filterSubtitleTracks(media.textTracks) : null;
                this.tracks.forEach((track, index)=>{
                    // Reuse tracks with the same label and lang, but do not reuse 608/708 tracks
                    let textTrack;
                    if (inUseTracks) {
                        let inUseTrack = null;
                        for(let i = 0; i < inUseTracks.length; i++)if (inUseTracks[i] && $b941786f4eb9cb76$var$canReuseVttTextTrack(inUseTracks[i], track)) {
                            inUseTrack = inUseTracks[i];
                            inUseTracks[i] = null;
                            break;
                        }
                        if (inUseTrack) textTrack = inUseTrack;
                    }
                    if (textTrack) $b941786f4eb9cb76$var$clearCurrentCues(textTrack);
                    else {
                        const textTrackKind = $b941786f4eb9cb76$var$captionsOrSubtitlesFromCharacteristics(track);
                        textTrack = this.createTextTrack(textTrackKind, track.name, track.lang);
                        if (textTrack) textTrack.mode = 'disabled';
                    }
                    if (textTrack) this.textTracks.push(textTrack);
                });
                // Warn when video element has captions or subtitle TextTracks carried over from another source
                if (inUseTracks != null && inUseTracks.length) {
                    const unusedTextTracks = inUseTracks.filter((t)=>t !== null).map((t)=>t.label);
                    if (unusedTextTracks.length) this.hls.logger.warn(`Media element contains unused subtitle tracks: ${unusedTextTracks.join(', ')}. Replace media element for each source to clear TextTracks and captions menu.`);
                }
            } else if (this.tracks.length) {
                // Create a list of tracks for the provider to consume
                const tracksList = this.tracks.map((track)=>{
                    return {
                        label: track.name,
                        kind: track.type.toLowerCase(),
                        default: track.default,
                        subtitleTrack: track
                    };
                });
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.NON_NATIVE_TEXT_TRACKS_FOUND, {
                    tracks: tracksList
                });
            }
        }
    }
    onManifestLoaded(event, data) {
        if (this.config.enableCEA708Captions && data.captions) data.captions.forEach((captionsTrack)=>{
            const instreamIdMatch = /(?:CC|SERVICE)([1-4])/.exec(captionsTrack.instreamId);
            if (!instreamIdMatch) return;
            const trackName = `textTrack${instreamIdMatch[1]}`;
            const trackProperties = this.captionsProperties[trackName];
            if (!trackProperties) return;
            trackProperties.label = captionsTrack.name;
            if (captionsTrack.lang) // optional attribute
            trackProperties.languageCode = captionsTrack.lang;
            trackProperties.media = captionsTrack;
        });
    }
    closedCaptionsForLevel(frag) {
        const level = this.hls.levels[frag.level];
        return level == null ? void 0 : level.attrs['CLOSED-CAPTIONS'];
    }
    onFragLoading(event, data) {
        // if this frag isn't contiguous, clear the parser so cues with bad start/end times aren't added to the textTrack
        if (this.enabled && data.frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) {
            var _data$part$index, _data$part;
            const { cea608Parser1: cea608Parser1, cea608Parser2: cea608Parser2, lastSn: lastSn } = this;
            const { cc: cc, sn: sn } = data.frag;
            const partIndex = (_data$part$index = (_data$part = data.part) == null ? void 0 : _data$part.index) != null ? _data$part$index : -1;
            if (cea608Parser1 && cea608Parser2) {
                if (sn !== lastSn + 1 || sn === lastSn && partIndex !== this.lastPartIndex + 1 || cc !== this.lastCc) {
                    cea608Parser1.reset();
                    cea608Parser2.reset();
                }
            }
            this.lastCc = cc;
            this.lastSn = sn;
            this.lastPartIndex = partIndex;
        }
    }
    onFragLoaded(event, data) {
        const { frag: frag, payload: payload } = data;
        if (frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE) {
            // If fragment is subtitle type, parse as WebVTT.
            if (payload.byteLength) {
                const decryptData = frag.decryptdata;
                // fragment after decryption has a stats object
                const decrypted = 'stats' in data;
                // If the subtitles are not encrypted, parse VTTs now. Otherwise, we need to wait.
                if (decryptData == null || !decryptData.encrypted || decrypted) {
                    const trackPlaylistMedia = this.tracks[frag.level];
                    const vttCCs = this.vttCCs;
                    if (!vttCCs[frag.cc]) {
                        vttCCs[frag.cc] = {
                            start: frag.start,
                            prevCC: this.prevCC,
                            new: true
                        };
                        this.prevCC = frag.cc;
                    }
                    if (trackPlaylistMedia && trackPlaylistMedia.textCodec === $b941786f4eb9cb76$var$IMSC1_CODEC) this._parseIMSC1(frag, payload);
                    else this._parseVTTs(data);
                }
            } else // In case there is no payload, finish unsuccessfully.
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: new Error('Empty subtitle payload')
            });
        }
    }
    _parseIMSC1(frag, payload) {
        const hls = this.hls;
        $b941786f4eb9cb76$var$parseIMSC1(payload, this.initPTS[frag.cc], (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            hls.logger.log(`Failed to parse IMSC1: ${error}`);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: error
            });
        });
    }
    _parseVTTs(data) {
        var _frag$initSegment;
        const { frag: frag, payload: payload } = data;
        // We need an initial synchronisation PTS. Store fragments as long as none has arrived
        const { initPTS: initPTS, unparsedVttFrags: unparsedVttFrags } = this;
        const maxAvCC = initPTS.length - 1;
        if (!initPTS[frag.cc] && maxAvCC === -1) {
            unparsedVttFrags.push(data);
            return;
        }
        const hls = this.hls;
        // Parse the WebVTT file contents.
        const payloadWebVTT = (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data ? $b941786f4eb9cb76$var$appendUint8Array(frag.initSegment.data, new Uint8Array(payload)).buffer : payload;
        $b941786f4eb9cb76$var$parseWebVTT(payloadWebVTT, this.initPTS[frag.cc], this.vttCCs, frag.cc, frag.start, (cues)=>{
            this._appendCues(cues, frag.level);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: true,
                frag: frag
            });
        }, (error)=>{
            const missingInitPTS = error.message === 'Missing initPTS for VTT MPEGTS';
            if (missingInitPTS) unparsedVttFrags.push(data);
            else this._fallbackToIMSC1(frag, payload);
            // Something went wrong while parsing. Trigger event with success false.
            hls.logger.log(`Failed to parse VTT cue: ${error}`);
            if (missingInitPTS && maxAvCC > frag.cc) return;
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_FRAG_PROCESSED, {
                success: false,
                frag: frag,
                error: error
            });
        });
    }
    _fallbackToIMSC1(frag, payload) {
        // If textCodec is unknown, try parsing as IMSC1. Set textCodec based on the result
        const trackPlaylistMedia = this.tracks[frag.level];
        if (!trackPlaylistMedia.textCodec) $b941786f4eb9cb76$var$parseIMSC1(payload, this.initPTS[frag.cc], ()=>{
            trackPlaylistMedia.textCodec = $b941786f4eb9cb76$var$IMSC1_CODEC;
            this._parseIMSC1(frag, payload);
        }, ()=>{
            trackPlaylistMedia.textCodec = 'wvtt';
        });
    }
    _appendCues(cues, fragLevel) {
        const hls = this.hls;
        if (this.config.renderTextTracksNatively) {
            const textTrack = this.textTracks[fragLevel];
            // WebVTTParser.parse is an async method and if the currently selected text track mode is set to "disabled"
            // before parsing is done then don't try to access currentTrack.cues.getCueById as cues will be null
            // and trying to access getCueById method of cues will throw an exception
            // Because we check if the mode is disabled, we can force check `cues` below. They can't be null.
            if (!textTrack || textTrack.mode === 'disabled') return;
            cues.forEach((cue)=>$b941786f4eb9cb76$var$addCueToTrack(textTrack, cue));
        } else {
            const currentTrack = this.tracks[fragLevel];
            if (!currentTrack) return;
            const track = currentTrack.default ? 'default' : 'subtitles' + fragLevel;
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.CUES_PARSED, {
                type: 'subtitles',
                cues: cues,
                track: track
            });
        }
    }
    onFragDecrypted(event, data) {
        const { frag: frag } = data;
        if (frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE) this.onFragLoaded($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, data);
    }
    onSubtitleTracksCleared() {
        this.tracks = [];
        this.captionsTracks = {};
    }
    onFragParsingUserdata(event, data) {
        if (!this.enabled || !this.config.enableCEA708Captions) return;
        const { frag: frag, samples: samples } = data;
        if (frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN && this.closedCaptionsForLevel(frag) === 'NONE') return;
        // If the event contains captions (found in the bytes property), push all bytes into the parser immediately
        // It will create the proper timestamps based on the PTS value
        for(let i = 0; i < samples.length; i++){
            const ccBytes = samples[i].bytes;
            if (ccBytes) {
                if (!this.cea608Parser1) this.initCea608Parsers();
                const ccdatas = this.extractCea608Data(ccBytes);
                this.cea608Parser1.addData(samples[i].pts, ccdatas[0]);
                this.cea608Parser2.addData(samples[i].pts, ccdatas[1]);
            }
        }
    }
    onBufferFlushing(event, { startOffset: startOffset, endOffset: endOffset, endOffsetSubtitles: endOffsetSubtitles, type: type }) {
        const { media: media } = this;
        if (!media || media.currentTime < endOffset) return;
        // Clear 608 caption cues from the captions TextTracks when the video back buffer is flushed
        // Forward cues are never removed because we can loose streamed 608 content from recent fragments
        if (!type || type === 'video') {
            const { captionsTracks: captionsTracks } = this;
            Object.keys(captionsTracks).forEach((trackName)=>$b941786f4eb9cb76$var$removeCuesInRange(captionsTracks[trackName], startOffset, endOffset));
        }
        if (this.config.renderTextTracksNatively) // Clear VTT/IMSC1 subtitle cues from the subtitle TextTracks when the back buffer is flushed
        {
            if (startOffset === 0 && endOffsetSubtitles !== undefined) {
                const { textTracks: textTracks } = this;
                Object.keys(textTracks).forEach((trackName)=>$b941786f4eb9cb76$var$removeCuesInRange(textTracks[trackName], startOffset, endOffsetSubtitles));
            }
        }
    }
    extractCea608Data(byteArray) {
        const actualCCBytes = [
            [],
            []
        ];
        const count = byteArray[0] & 0x1f;
        let position = 2;
        for(let j = 0; j < count; j++){
            const tmpByte = byteArray[position++];
            const ccbyte1 = 0x7f & byteArray[position++];
            const ccbyte2 = 0x7f & byteArray[position++];
            if (ccbyte1 === 0 && ccbyte2 === 0) continue;
            const ccValid = (0x04 & tmpByte) !== 0; // Support all four channels
            if (ccValid) {
                const ccType = 0x03 & tmpByte;
                if (0x00 /* CEA608 field1*/  === ccType || 0x01 /* CEA608 field2*/  === ccType) {
                    // Exclude CEA708 CC data.
                    actualCCBytes[ccType].push(ccbyte1);
                    actualCCBytes[ccType].push(ccbyte2);
                }
            }
        }
        return actualCCBytes;
    }
}
function $b941786f4eb9cb76$var$captionsOrSubtitlesFromCharacteristics(track) {
    if (track.characteristics) {
        if (/transcribes-spoken-dialog/gi.test(track.characteristics) && /describes-music-and-sound/gi.test(track.characteristics)) return 'captions';
    }
    return 'subtitles';
}
function $b941786f4eb9cb76$var$canReuseVttTextTrack(inUseTrack, manifestTrack) {
    return !!inUseTrack && inUseTrack.kind === $b941786f4eb9cb76$var$captionsOrSubtitlesFromCharacteristics(manifestTrack) && $b941786f4eb9cb76$var$subtitleTrackMatchesTextTrack(manifestTrack, inUseTrack);
}
function $b941786f4eb9cb76$var$intersection(x1, x2, y1, y2) {
    return Math.min(x2, y2) - Math.max(x1, y1);
}
function $b941786f4eb9cb76$var$newVTTCCs() {
    return {
        ccOffset: 0,
        presentationOffset: 0,
        0: {
            start: 0,
            prevCC: -1,
            new: true
        }
    };
}
const $b941786f4eb9cb76$var$WHITESPACE_CHAR = /\s/;
const $b941786f4eb9cb76$export$ccfbd9d17c71f30b = {
    newCue (track, startTime, endTime, captionScreen) {
        const result = [];
        let row;
        // the type data states this is VTTCue, but it can potentially be a TextTrackCue on old browsers
        let cue;
        let indenting;
        let indent;
        let text;
        const Cue = self.VTTCue || self.TextTrackCue;
        for(let r = 0; r < captionScreen.rows.length; r++){
            row = captionScreen.rows[r];
            indenting = true;
            indent = 0;
            text = '';
            if (!row.isEmpty()) {
                var _track$cues;
                for(let c = 0; c < row.chars.length; c++)if ($b941786f4eb9cb76$var$WHITESPACE_CHAR.test(row.chars[c].uchar) && indenting) indent++;
                else {
                    text += row.chars[c].uchar;
                    indenting = false;
                }
                // To be used for cleaning-up orphaned roll-up captions
                row.cueStartTime = startTime;
                // Give a slight bump to the endTime if it's equal to startTime to avoid a SyntaxError in IE
                if (startTime === endTime) endTime += 0.0001;
                if (indent >= 16) indent--;
                else indent++;
                const cueText = $b941786f4eb9cb76$var$fixLineBreaks(text.trim());
                const id = $b941786f4eb9cb76$var$generateCueId(startTime, endTime, cueText);
                // If this cue already exists in the track do not push it
                if (!(track != null && (_track$cues = track.cues) != null && _track$cues.getCueById(id))) {
                    cue = new Cue(startTime, endTime, cueText);
                    cue.id = id;
                    cue.line = r + 1;
                    cue.align = 'left';
                    // Clamp the position between 10 and 80 percent (CEA-608 PAC indent code)
                    // https://dvcs.w3.org/hg/text-tracks/raw-file/default/608toVTT/608toVTT.html#positioning-in-cea-608
                    // Firefox throws an exception and captions break with out of bounds 0-100 values
                    cue.position = 10 + Math.min(80, Math.floor(indent * 8 / 32) * 10);
                    result.push(cue);
                }
            }
        }
        if (track && result.length) {
            // Sort bottom cues in reverse order so that they render in line order when overlapping in Chrome
            result.sort((cueA, cueB)=>{
                if (cueA.line === 'auto' || cueB.line === 'auto') return 0;
                if (cueA.line > 8 && cueB.line > 8) return cueB.line - cueA.line;
                return cueA.line - cueB.line;
            });
            result.forEach((cue)=>$b941786f4eb9cb76$var$addCueToTrack(track, cue));
        }
        return result;
    }
};
function $b941786f4eb9cb76$export$2ebccc4e6cb246d0() {
    if (// @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request) try {
        new self.ReadableStream({}); // eslint-disable-line no-new
        return true;
    } catch (e) {
    /* noop */ }
    return false;
}
const $b941786f4eb9cb76$var$BYTERANGE = /(\d+)-(\d+)\/(\d+)/;
class $b941786f4eb9cb76$export$199fdd2c96d97926 {
    constructor(config){
        this.fetchSetup = void 0;
        this.requestTimeout = void 0;
        this.request = null;
        this.response = null;
        this.controller = void 0;
        this.context = null;
        this.config = null;
        this.callbacks = null;
        this.stats = void 0;
        this.loader = null;
        this.fetchSetup = config.fetchSetup || $b941786f4eb9cb76$var$getRequest;
        this.controller = new self.AbortController();
        this.stats = new $b941786f4eb9cb76$export$792da06d301cf8fe();
    }
    destroy() {
        this.loader = this.callbacks = this.context = this.config = this.request = null;
        this.abortInternal();
        this.response = null;
        // @ts-ignore
        this.fetchSetup = this.controller = this.stats = null;
    }
    abortInternal() {
        if (this.controller && !this.stats.loading.end) {
            this.stats.aborted = true;
            this.controller.abort();
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.response);
    }
    load(context, config, callbacks) {
        const stats = this.stats;
        if (stats.loading.start) throw new Error('Loader can only be used once.');
        stats.loading.start = self.performance.now();
        const initParams = $b941786f4eb9cb76$var$getRequestParameters(context, this.controller.signal);
        const isArrayBuffer = context.responseType === 'arraybuffer';
        const LENGTH = isArrayBuffer ? 'byteLength' : 'length';
        const { maxTimeToFirstByteMs: maxTimeToFirstByteMs, maxLoadTimeMs: maxLoadTimeMs } = config.loadPolicy;
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.request = this.fetchSetup(context, initParams);
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && $b941786f4eb9cb76$var$isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(()=>{
            if (this.callbacks) {
                this.abortInternal();
                this.callbacks.onTimeout(stats, context, this.response);
            }
        }, config.timeout);
        const fetchPromise = $b941786f4eb9cb76$var$isPromise(this.request) ? this.request.then(self.fetch) : self.fetch(this.request);
        fetchPromise.then((response)=>{
            var _this$callbacks2;
            this.response = this.loader = response;
            const first = Math.max(self.performance.now(), stats.loading.start);
            self.clearTimeout(this.requestTimeout);
            config.timeout = maxLoadTimeMs;
            this.requestTimeout = self.setTimeout(()=>{
                if (this.callbacks) {
                    this.abortInternal();
                    this.callbacks.onTimeout(stats, context, this.response);
                }
            }, maxLoadTimeMs - (first - stats.loading.start));
            if (!response.ok) {
                const { status: status1, statusText: statusText } = response;
                throw new $b941786f4eb9cb76$var$FetchError(statusText || 'fetch, bad network response', status1, response);
            }
            stats.loading.first = first;
            stats.total = $b941786f4eb9cb76$var$getContentLength(response.headers) || stats.total;
            const onProgress = (_this$callbacks2 = this.callbacks) == null ? void 0 : _this$callbacks2.onProgress;
            if (onProgress && $b941786f4eb9cb76$var$isFiniteNumber(config.highWaterMark)) return this.loadProgressively(response, stats, context, config.highWaterMark, onProgress);
            if (isArrayBuffer) return response.arrayBuffer();
            if (context.responseType === 'json') return response.json();
            return response.text();
        }).then((responseData)=>{
            var _this$callbacks3, _this$callbacks4;
            const response = this.response;
            if (!response) throw new Error('loader destroyed');
            self.clearTimeout(this.requestTimeout);
            stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
            const total = responseData[LENGTH];
            if (total) stats.loaded = stats.total = total;
            const loaderResponse = {
                url: response.url,
                data: responseData,
                code: response.status
            };
            const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
            if (onProgress && !$b941786f4eb9cb76$var$isFiniteNumber(config.highWaterMark)) onProgress(stats, context, responseData, response);
            (_this$callbacks4 = this.callbacks) == null || _this$callbacks4.onSuccess(loaderResponse, stats, context, response);
        }).catch((error)=>{
            var _this$callbacks5;
            self.clearTimeout(this.requestTimeout);
            if (stats.aborted) return;
            // CORS errors result in an undefined code. Set it to 0 here to align with XHR's behavior
            // when destroying, 'error' itself can be undefined
            const code = !error ? 0 : error.code || 0;
            const text = !error ? null : error.message;
            (_this$callbacks5 = this.callbacks) == null || _this$callbacks5.onError({
                code: code,
                text: text
            }, context, error ? error.details : null, stats);
        });
    }
    getCacheAge() {
        let result = null;
        if (this.response) {
            const ageHeader = this.response.headers.get('age');
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        return this.response ? this.response.headers.get(name) : null;
    }
    loadProgressively(response, stats, context, highWaterMark = 0, onProgress) {
        const chunkCache = new $b941786f4eb9cb76$var$ChunkCache();
        const reader = response.body.getReader();
        const pump = ()=>{
            return reader.read().then((data)=>{
                if (data.done) {
                    if (chunkCache.dataLength) onProgress(stats, context, chunkCache.flush().buffer, response);
                    return Promise.resolve(new ArrayBuffer(0));
                }
                const chunk = data.value;
                const len = chunk.length;
                stats.loaded += len;
                if (len < highWaterMark || chunkCache.dataLength) {
                    // The current chunk is too small to to be emitted or the cache already has data
                    // Push it to the cache
                    chunkCache.push(chunk);
                    if (chunkCache.dataLength >= highWaterMark) // flush in order to join the typed arrays
                    onProgress(stats, context, chunkCache.flush().buffer, response);
                } else // If there's nothing cached already, and the chache is large enough
                // just emit the progress event
                onProgress(stats, context, chunk.buffer, response);
                return pump();
            }).catch(()=>{
                /* aborted */ return Promise.reject();
            });
        };
        return pump();
    }
}
function $b941786f4eb9cb76$var$getRequestParameters(context, signal) {
    const initParams = {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
        signal: signal,
        headers: new self.Headers($b941786f4eb9cb76$var$_extends({}, context.headers))
    };
    if (context.rangeEnd) initParams.headers.set('Range', 'bytes=' + context.rangeStart + '-' + String(context.rangeEnd - 1));
    return initParams;
}
function $b941786f4eb9cb76$var$getByteRangeLength(byteRangeHeader) {
    const result = $b941786f4eb9cb76$var$BYTERANGE.exec(byteRangeHeader);
    if (result) return parseInt(result[2]) - parseInt(result[1]) + 1;
}
function $b941786f4eb9cb76$var$getContentLength(headers) {
    const contentRange = headers.get('Content-Range');
    if (contentRange) {
        const byteRangeLength = $b941786f4eb9cb76$var$getByteRangeLength(contentRange);
        if ($b941786f4eb9cb76$var$isFiniteNumber(byteRangeLength)) return byteRangeLength;
    }
    const contentLength = headers.get('Content-Length');
    if (contentLength) return parseInt(contentLength);
}
function $b941786f4eb9cb76$var$getRequest(context, initParams) {
    return new self.Request(context.url, initParams);
}
class $b941786f4eb9cb76$var$FetchError extends Error {
    constructor(message, code, details){
        super(message);
        this.code = void 0;
        this.details = void 0;
        this.code = code;
        this.details = details;
    }
}
const $b941786f4eb9cb76$var$AGE_HEADER_LINE_REGEX = /^age:\s*[\d.]+\s*$/im;
class $b941786f4eb9cb76$export$82bde069796904e9 {
    constructor(config){
        this.xhrSetup = void 0;
        this.requestTimeout = void 0;
        this.retryTimeout = void 0;
        this.retryDelay = void 0;
        this.config = null;
        this.callbacks = null;
        this.context = null;
        this.loader = null;
        this.stats = void 0;
        this.xhrSetup = config ? config.xhrSetup || null : null;
        this.stats = new $b941786f4eb9cb76$export$792da06d301cf8fe();
        this.retryDelay = 0;
    }
    destroy() {
        this.callbacks = null;
        this.abortInternal();
        this.loader = null;
        this.config = null;
        this.context = null;
        this.xhrSetup = null;
    }
    abortInternal() {
        const loader = this.loader;
        self.clearTimeout(this.requestTimeout);
        self.clearTimeout(this.retryTimeout);
        if (loader) {
            loader.onreadystatechange = null;
            loader.onprogress = null;
            if (loader.readyState !== 4) {
                this.stats.aborted = true;
                loader.abort();
            }
        }
    }
    abort() {
        var _this$callbacks;
        this.abortInternal();
        if ((_this$callbacks = this.callbacks) != null && _this$callbacks.onAbort) this.callbacks.onAbort(this.stats, this.context, this.loader);
    }
    load(context, config, callbacks) {
        if (this.stats.loading.start) throw new Error('Loader can only be used once.');
        this.stats.loading.start = self.performance.now();
        this.context = context;
        this.config = config;
        this.callbacks = callbacks;
        this.loadInternal();
    }
    loadInternal() {
        const { config: config, context: context } = this;
        if (!config || !context) return;
        const xhr = this.loader = new self.XMLHttpRequest();
        const stats = this.stats;
        stats.loading.first = 0;
        stats.loaded = 0;
        stats.aborted = false;
        const xhrSetup = this.xhrSetup;
        if (xhrSetup) Promise.resolve().then(()=>{
            if (this.loader !== xhr || this.stats.aborted) return;
            return xhrSetup(xhr, context.url);
        }).catch((error)=>{
            if (this.loader !== xhr || this.stats.aborted) return;
            xhr.open('GET', context.url, true);
            return xhrSetup(xhr, context.url);
        }).then(()=>{
            if (this.loader !== xhr || this.stats.aborted) return;
            this.openAndSendXhr(xhr, context, config);
        }).catch((error)=>{
            var _this$callbacks2;
            // IE11 throws an exception on xhr.open if attempting to access an HTTP resource over HTTPS
            (_this$callbacks2 = this.callbacks) == null || _this$callbacks2.onError({
                code: xhr.status,
                text: error.message
            }, context, xhr, stats);
            return;
        });
        else this.openAndSendXhr(xhr, context, config);
    }
    openAndSendXhr(xhr, context, config) {
        if (!xhr.readyState) xhr.open('GET', context.url, true);
        const headers = context.headers;
        const { maxTimeToFirstByteMs: maxTimeToFirstByteMs, maxLoadTimeMs: maxLoadTimeMs } = config.loadPolicy;
        if (headers) for(const header in headers)xhr.setRequestHeader(header, headers[header]);
        if (context.rangeEnd) xhr.setRequestHeader('Range', 'bytes=' + context.rangeStart + '-' + (context.rangeEnd - 1));
        xhr.onreadystatechange = this.readystatechange.bind(this);
        xhr.onprogress = this.loadprogress.bind(this);
        xhr.responseType = context.responseType;
        // setup timeout before we perform request
        self.clearTimeout(this.requestTimeout);
        config.timeout = maxTimeToFirstByteMs && $b941786f4eb9cb76$var$isFiniteNumber(maxTimeToFirstByteMs) ? maxTimeToFirstByteMs : maxLoadTimeMs;
        this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.timeout);
        xhr.send();
    }
    readystatechange() {
        const { context: context, loader: xhr, stats: stats } = this;
        if (!context || !xhr) return;
        const readyState = xhr.readyState;
        const config = this.config;
        // don't proceed if xhr has been aborted
        if (stats.aborted) return;
        // >= HEADERS_RECEIVED
        if (readyState >= 2) {
            if (stats.loading.first === 0) {
                stats.loading.first = Math.max(self.performance.now(), stats.loading.start);
                // readyState >= 2 AND readyState !==4 (readyState = HEADERS_RECEIVED || LOADING) rearm timeout as xhr not finished yet
                if (config.timeout !== config.loadPolicy.maxLoadTimeMs) {
                    self.clearTimeout(this.requestTimeout);
                    config.timeout = config.loadPolicy.maxLoadTimeMs;
                    this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), config.loadPolicy.maxLoadTimeMs - (stats.loading.first - stats.loading.start));
                }
            }
            if (readyState === 4) {
                self.clearTimeout(this.requestTimeout);
                xhr.onreadystatechange = null;
                xhr.onprogress = null;
                const status1 = xhr.status;
                // http status between 200 to 299 are all successful
                const useResponseText = xhr.responseType === 'text' ? xhr.responseText : null;
                if (status1 >= 200 && status1 < 300) {
                    const data = useResponseText != null ? useResponseText : xhr.response;
                    if (data != null) {
                        var _this$callbacks3, _this$callbacks4;
                        stats.loading.end = Math.max(self.performance.now(), stats.loading.first);
                        const len = xhr.responseType === 'arraybuffer' ? data.byteLength : data.length;
                        stats.loaded = stats.total = len;
                        stats.bwEstimate = stats.total * 8000 / (stats.loading.end - stats.loading.first);
                        const onProgress = (_this$callbacks3 = this.callbacks) == null ? void 0 : _this$callbacks3.onProgress;
                        if (onProgress) onProgress(stats, context, data, xhr);
                        const _response = {
                            url: xhr.responseURL,
                            data: data,
                            code: status1
                        };
                        (_this$callbacks4 = this.callbacks) == null || _this$callbacks4.onSuccess(_response, stats, context, xhr);
                        return;
                    }
                }
                // Handle bad status or nullish response
                const retryConfig = config.loadPolicy.errorRetry;
                const retryCount = stats.retry;
                // if max nb of retries reached or if http status between 400 and 499 (such error cannot be recovered, retrying is useless), return error
                const response = {
                    url: context.url,
                    data: undefined,
                    code: status1
                };
                if ($b941786f4eb9cb76$var$shouldRetry(retryConfig, retryCount, false, response)) this.retry(retryConfig);
                else {
                    var _this$callbacks5;
                    $b941786f4eb9cb76$var$logger.error(`${status1} while loading ${context.url}`);
                    (_this$callbacks5 = this.callbacks) == null || _this$callbacks5.onError({
                        code: status1,
                        text: xhr.statusText
                    }, context, xhr, stats);
                }
            }
        }
    }
    loadtimeout() {
        if (!this.config) return;
        const retryConfig = this.config.loadPolicy.timeoutRetry;
        const retryCount = this.stats.retry;
        if ($b941786f4eb9cb76$var$shouldRetry(retryConfig, retryCount, true)) this.retry(retryConfig);
        else {
            var _this$context;
            $b941786f4eb9cb76$var$logger.warn(`timeout while loading ${(_this$context = this.context) == null ? void 0 : _this$context.url}`);
            const callbacks = this.callbacks;
            if (callbacks) {
                this.abortInternal();
                callbacks.onTimeout(this.stats, this.context, this.loader);
            }
        }
    }
    retry(retryConfig) {
        const { context: context, stats: stats } = this;
        this.retryDelay = $b941786f4eb9cb76$var$getRetryDelay(retryConfig, stats.retry);
        stats.retry++;
        $b941786f4eb9cb76$var$logger.warn(`${status ? 'HTTP Status ' + status : 'Timeout'} while loading ${context == null ? void 0 : context.url}, retrying ${stats.retry}/${retryConfig.maxNumRetry} in ${this.retryDelay}ms`);
        // abort and reset internal state
        this.abortInternal();
        this.loader = null;
        // schedule retry
        self.clearTimeout(this.retryTimeout);
        this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
    }
    loadprogress(event) {
        const stats = this.stats;
        stats.loaded = event.loaded;
        if (event.lengthComputable) stats.total = event.total;
    }
    getCacheAge() {
        let result = null;
        if (this.loader && $b941786f4eb9cb76$var$AGE_HEADER_LINE_REGEX.test(this.loader.getAllResponseHeaders())) {
            const ageHeader = this.loader.getResponseHeader('age');
            result = ageHeader ? parseFloat(ageHeader) : null;
        }
        return result;
    }
    getResponseHeader(name) {
        if (this.loader && new RegExp(`^${name}:\\s*[\\d.]+\\s*$`, 'im').test(this.loader.getAllResponseHeaders())) return this.loader.getResponseHeader(name);
        return null;
    }
}
/**
 * @deprecated use fragLoadPolicy.default
 */ /**
 * @deprecated use manifestLoadPolicy.default and playlistLoadPolicy.default
 */ const $b941786f4eb9cb76$var$defaultLoadPolicy = {
    maxTimeToFirstByteMs: 8000,
    maxLoadTimeMs: 20000,
    timeoutRetry: null,
    errorRetry: null
};
/**
 * @ignore
 * If possible, keep hlsDefaultConfig shallow
 * It is cloned whenever a new Hls instance is created, by keeping the config
 * shallow the properties are cloned, and we don't end up manipulating the default
 */ const $b941786f4eb9cb76$var$hlsDefaultConfig = $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({
    autoStartLoad: true,
    // used by stream-controller
    startPosition: -1,
    // used by stream-controller
    defaultAudioCodec: undefined,
    // used by stream-controller
    debug: false,
    // used by logger
    capLevelOnFPSDrop: false,
    // used by fps-controller
    capLevelToPlayerSize: false,
    // used by cap-level-controller
    ignoreDevicePixelRatio: false,
    // used by cap-level-controller
    maxDevicePixelRatio: Number.POSITIVE_INFINITY,
    // used by cap-level-controller
    preferManagedMediaSource: true,
    initialLiveManifestSize: 1,
    // used by stream-controller
    maxBufferLength: 30,
    // used by stream-controller
    backBufferLength: Infinity,
    // used by buffer-controller
    frontBufferFlushThreshold: Infinity,
    startOnSegmentBoundary: false,
    // used by stream-controller
    maxBufferSize: 60000000,
    // used by stream-controller
    maxFragLookUpTolerance: 0.25,
    // used by stream-controller
    maxBufferHole: 0.1,
    // used by stream-controller and gap-controller
    detectStallWithCurrentTimeMs: 1250,
    // used by gap-controller
    highBufferWatchdogPeriod: 2,
    // used by gap-controller
    nudgeOffset: 0.1,
    // used by gap-controller
    nudgeMaxRetry: 3,
    // used by gap-controller
    nudgeOnVideoHole: true,
    // used by gap-controller
    liveSyncMode: 'edge',
    // used by stream-controller
    liveSyncDurationCount: 3,
    // used by latency-controller
    liveSyncOnStallIncrease: 1,
    // used by latency-controller
    liveMaxLatencyDurationCount: Infinity,
    // used by latency-controller
    liveSyncDuration: undefined,
    // used by latency-controller
    liveMaxLatencyDuration: undefined,
    // used by latency-controller
    maxLiveSyncPlaybackRate: 1,
    // used by latency-controller
    liveDurationInfinity: false,
    // used by buffer-controller
    /**
   * @deprecated use backBufferLength
   */ liveBackBufferLength: null,
    // used by buffer-controller
    maxMaxBufferLength: 600,
    // used by stream-controller
    enableWorker: true,
    // used by transmuxer
    workerPath: null,
    // used by transmuxer
    enableSoftwareAES: true,
    // used by decrypter
    startLevel: undefined,
    // used by level-controller
    startFragPrefetch: false,
    // used by stream-controller
    fpsDroppedMonitoringPeriod: 5000,
    // used by fps-controller
    fpsDroppedMonitoringThreshold: 0.2,
    // used by fps-controller
    appendErrorMaxRetry: 3,
    // used by buffer-controller
    ignorePlaylistParsingErrors: false,
    loader: $b941786f4eb9cb76$export$82bde069796904e9,
    // loader: FetchLoader,
    fLoader: undefined,
    // used by fragment-loader
    pLoader: undefined,
    // used by playlist-loader
    xhrSetup: undefined,
    // used by xhr-loader
    licenseXhrSetup: undefined,
    // used by eme-controller
    licenseResponseCallback: undefined,
    // used by eme-controller
    abrController: $b941786f4eb9cb76$export$264ac4b6e832e14e,
    bufferController: $b941786f4eb9cb76$export$2057e53fd83d2d77,
    capLevelController: $b941786f4eb9cb76$export$24bc69225d44061c,
    errorController: $b941786f4eb9cb76$export$2f5b22783539ff2,
    fpsController: $b941786f4eb9cb76$export$ca3da7ea73955a38,
    stretchShortVideoTrack: false,
    // used by mp4-remuxer
    maxAudioFramesDrift: 1,
    // used by mp4-remuxer
    forceKeyFrameOnDiscontinuity: true,
    // used by ts-demuxer
    abrEwmaFastLive: 3,
    // used by abr-controller
    abrEwmaSlowLive: 9,
    // used by abr-controller
    abrEwmaFastVoD: 3,
    // used by abr-controller
    abrEwmaSlowVoD: 9,
    // used by abr-controller
    abrEwmaDefaultEstimate: 5e5,
    // 500 kbps  // used by abr-controller
    abrEwmaDefaultEstimateMax: 5e6,
    // 5 mbps
    abrBandWidthFactor: 0.95,
    // used by abr-controller
    abrBandWidthUpFactor: 0.7,
    // used by abr-controller
    abrMaxWithRealBitrate: false,
    // used by abr-controller
    maxStarvationDelay: 4,
    // used by abr-controller
    maxLoadingDelay: 4,
    // used by abr-controller
    minAutoBitrate: 0,
    // used by hls
    emeEnabled: false,
    // used by eme-controller
    widevineLicenseUrl: undefined,
    // used by eme-controller
    drmSystems: {},
    // used by eme-controller
    drmSystemOptions: {},
    // used by eme-controller
    requestMediaKeySystemAccessFunc: $b941786f4eb9cb76$export$fd6ce47fe824665a,
    // used by eme-controller
    requireKeySystemAccessOnStart: false,
    // used by eme-controller
    testBandwidth: true,
    progressive: false,
    lowLatencyMode: true,
    cmcd: undefined,
    enableDateRangeMetadataCues: true,
    enableEmsgMetadataCues: true,
    enableEmsgKLVMetadata: false,
    enableID3MetadataCues: true,
    enableInterstitialPlayback: true,
    interstitialAppendInPlace: true,
    interstitialLiveLookAhead: 10,
    useMediaCapabilities: true,
    preserveManualLevelOnError: false,
    certLoadPolicy: {
        default: $b941786f4eb9cb76$var$defaultLoadPolicy
    },
    keyLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 8000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: 'linear'
            },
            errorRetry: {
                maxNumRetry: 8,
                retryDelayMs: 1000,
                maxRetryDelayMs: 20000,
                backoff: 'linear'
            }
        }
    },
    manifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: Infinity,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    playlistLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 2,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    fragLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 120000,
            timeoutRetry: {
                maxNumRetry: 4,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 6,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    steeringManifestLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 20000,
            timeoutRetry: {
                maxNumRetry: 2,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 1,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    interstitialAssetListLoadPolicy: {
        default: {
            maxTimeToFirstByteMs: 10000,
            maxLoadTimeMs: 30000,
            timeoutRetry: {
                maxNumRetry: 0,
                retryDelayMs: 0,
                maxRetryDelayMs: 0
            },
            errorRetry: {
                maxNumRetry: 0,
                retryDelayMs: 1000,
                maxRetryDelayMs: 8000
            }
        }
    },
    // These default settings are deprecated in favor of the above policies
    // and are maintained for backwards compatibility
    manifestLoadingTimeOut: 10000,
    manifestLoadingMaxRetry: 1,
    manifestLoadingRetryDelay: 1000,
    manifestLoadingMaxRetryTimeout: 64000,
    levelLoadingTimeOut: 10000,
    levelLoadingMaxRetry: 4,
    levelLoadingRetryDelay: 1000,
    levelLoadingMaxRetryTimeout: 64000,
    fragLoadingTimeOut: 20000,
    fragLoadingMaxRetry: 6,
    fragLoadingRetryDelay: 1000,
    fragLoadingMaxRetryTimeout: 64000
}, $b941786f4eb9cb76$var$timelineConfig()), {}, {
    subtitleStreamController: $b941786f4eb9cb76$export$507c2c1b84e7d645,
    subtitleTrackController: $b941786f4eb9cb76$export$e287517d6ed8b132,
    timelineController: $b941786f4eb9cb76$export$33d15e092164e5ef,
    audioStreamController: $b941786f4eb9cb76$export$352c47a33fc91a8b,
    audioTrackController: $b941786f4eb9cb76$export$befb88bd9e19246,
    emeController: $b941786f4eb9cb76$export$bd16919f25cf2fc5,
    cmcdController: $b941786f4eb9cb76$export$953f29a3a19a03d,
    contentSteeringController: $b941786f4eb9cb76$export$52a61818002372cb,
    interstitialsController: $b941786f4eb9cb76$var$InterstitialsController
});
function $b941786f4eb9cb76$var$timelineConfig() {
    return {
        cueHandler: $b941786f4eb9cb76$export$ccfbd9d17c71f30b,
        // used by timeline-controller
        enableWebVTT: true,
        // used by timeline-controller
        enableIMSC1: true,
        // used by timeline-controller
        enableCEA708Captions: true,
        // used by timeline-controller
        captionsTextTrack1Label: 'English',
        // used by timeline-controller
        captionsTextTrack1LanguageCode: 'en',
        // used by timeline-controller
        captionsTextTrack2Label: 'Spanish',
        // used by timeline-controller
        captionsTextTrack2LanguageCode: 'es',
        // used by timeline-controller
        captionsTextTrack3Label: 'Unknown CC',
        // used by timeline-controller
        captionsTextTrack3LanguageCode: '',
        // used by timeline-controller
        captionsTextTrack4Label: 'Unknown CC',
        // used by timeline-controller
        captionsTextTrack4LanguageCode: '',
        // used by timeline-controller
        renderTextTracksNatively: true
    };
}
/**
 * @ignore
 */ function $b941786f4eb9cb76$var$mergeConfig(defaultConfig, userConfig, logger) {
    if ((userConfig.liveSyncDurationCount || userConfig.liveMaxLatencyDurationCount) && (userConfig.liveSyncDuration || userConfig.liveMaxLatencyDuration)) throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
    if (userConfig.liveMaxLatencyDurationCount !== undefined && (userConfig.liveSyncDurationCount === undefined || userConfig.liveMaxLatencyDurationCount <= userConfig.liveSyncDurationCount)) throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
    if (userConfig.liveMaxLatencyDuration !== undefined && (userConfig.liveSyncDuration === undefined || userConfig.liveMaxLatencyDuration <= userConfig.liveSyncDuration)) throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
    const defaultsCopy = $b941786f4eb9cb76$var$deepCpy(defaultConfig);
    // Backwards compatibility with deprecated config values
    const deprecatedSettingTypes = [
        'manifest',
        'level',
        'frag'
    ];
    const deprecatedSettings = [
        'TimeOut',
        'MaxRetry',
        'RetryDelay',
        'MaxRetryTimeout'
    ];
    deprecatedSettingTypes.forEach((type)=>{
        const policyName = `${type === 'level' ? 'playlist' : type}LoadPolicy`;
        const policyNotSet = userConfig[policyName] === undefined;
        const report = [];
        deprecatedSettings.forEach((setting)=>{
            const deprecatedSetting = `${type}Loading${setting}`;
            const value = userConfig[deprecatedSetting];
            if (value !== undefined && policyNotSet) {
                report.push(deprecatedSetting);
                const settings = defaultsCopy[policyName].default;
                userConfig[policyName] = {
                    default: settings
                };
                switch(setting){
                    case 'TimeOut':
                        settings.maxLoadTimeMs = value;
                        settings.maxTimeToFirstByteMs = value;
                        break;
                    case 'MaxRetry':
                        settings.errorRetry.maxNumRetry = value;
                        settings.timeoutRetry.maxNumRetry = value;
                        break;
                    case 'RetryDelay':
                        settings.errorRetry.retryDelayMs = value;
                        settings.timeoutRetry.retryDelayMs = value;
                        break;
                    case 'MaxRetryTimeout':
                        settings.errorRetry.maxRetryDelayMs = value;
                        settings.timeoutRetry.maxRetryDelayMs = value;
                        break;
                }
            }
        });
        if (report.length) logger.warn(`hls.js config: "${report.join('", "')}" setting(s) are deprecated, use "${policyName}": ${$b941786f4eb9cb76$var$stringify(userConfig[policyName])}`);
    });
    return $b941786f4eb9cb76$var$_objectSpread2($b941786f4eb9cb76$var$_objectSpread2({}, defaultsCopy), userConfig);
}
function $b941786f4eb9cb76$var$deepCpy(obj) {
    if (obj && typeof obj === 'object') {
        if (Array.isArray(obj)) return obj.map($b941786f4eb9cb76$var$deepCpy);
        return Object.keys(obj).reduce((result, key)=>{
            result[key] = $b941786f4eb9cb76$var$deepCpy(obj[key]);
            return result;
        }, {});
    }
    return obj;
}
/**
 * @ignore
 */ function $b941786f4eb9cb76$var$enableStreamingMode(config, logger) {
    const currentLoader = config.loader;
    if (currentLoader !== $b941786f4eb9cb76$export$199fdd2c96d97926 && currentLoader !== $b941786f4eb9cb76$export$82bde069796904e9) {
        // If a developer has configured their own loader, respect that choice
        logger.log('[config]: Custom loader detected, cannot enable progressive streaming');
        config.progressive = false;
    } else {
        const canStreamProgressively = $b941786f4eb9cb76$export$2ebccc4e6cb246d0();
        if (canStreamProgressively) {
            config.loader = $b941786f4eb9cb76$export$199fdd2c96d97926;
            config.progressive = true;
            config.enableSoftwareAES = true;
            logger.log('[config]: Progressive streaming enabled, using FetchLoader');
        }
    }
}
const $b941786f4eb9cb76$var$MAX_START_GAP_JUMP = 2.0;
const $b941786f4eb9cb76$var$SKIP_BUFFER_HOLE_STEP_SECONDS = 0.1;
const $b941786f4eb9cb76$var$SKIP_BUFFER_RANGE_START = 0.05;
const $b941786f4eb9cb76$var$TICK_INTERVAL$1 = 100;
class $b941786f4eb9cb76$var$GapController extends $b941786f4eb9cb76$var$TaskLoop {
    constructor(hls, fragmentTracker){
        super('gap-controller', hls.logger);
        this.hls = void 0;
        this.fragmentTracker = void 0;
        this.media = null;
        this.mediaSource = void 0;
        this.nudgeRetry = 0;
        this.stallReported = false;
        this.stalled = null;
        this.moved = false;
        this.seeking = false;
        this.buffered = {};
        this.lastCurrentTime = 0;
        this.ended = 0;
        this.waiting = 0;
        this.onMediaPlaying = ()=>{
            this.ended = 0;
            this.waiting = 0;
        };
        this.onMediaWaiting = ()=>{
            var _this$media;
            if ((_this$media = this.media) != null && _this$media.seeking) return;
            this.waiting = self.performance.now();
            this.tick();
        };
        this.onMediaEnded = ()=>{
            if (this.hls) {
                var _this$media2;
                // ended is set when triggering MEDIA_ENDED so that we do not trigger it again on stall or on tick with media.ended
                this.ended = ((_this$media2 = this.media) == null ? void 0 : _this$media2.currentTime) || 1;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ENDED, {
                    stalled: false
                });
            }
        };
        this.hls = hls;
        this.fragmentTracker = fragmentTracker;
        this.registerListeners();
    }
    registerListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        }
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDED, this.onBufferAppended, this);
        }
    }
    destroy() {
        super.destroy();
        this.unregisterListeners();
        this.media = this.hls = this.fragmentTracker = null;
        this.mediaSource = undefined;
    }
    onMediaAttached(event, data) {
        this.setInterval($b941786f4eb9cb76$var$TICK_INTERVAL$1);
        this.mediaSource = data.mediaSource;
        const media = this.media = data.media;
        $b941786f4eb9cb76$var$addEventListener(media, 'playing', this.onMediaPlaying);
        $b941786f4eb9cb76$var$addEventListener(media, 'waiting', this.onMediaWaiting);
        $b941786f4eb9cb76$var$addEventListener(media, 'ended', this.onMediaEnded);
    }
    onMediaDetaching(event, data) {
        this.clearInterval();
        const { media: media } = this;
        if (media) {
            $b941786f4eb9cb76$var$removeEventListener(media, 'playing', this.onMediaPlaying);
            $b941786f4eb9cb76$var$removeEventListener(media, 'waiting', this.onMediaWaiting);
            $b941786f4eb9cb76$var$removeEventListener(media, 'ended', this.onMediaEnded);
            this.media = null;
        }
        this.mediaSource = undefined;
    }
    onBufferAppended(event, data) {
        this.buffered = data.timeRanges;
    }
    get hasBuffered() {
        return Object.keys(this.buffered).length > 0;
    }
    tick() {
        var _this$media3;
        if (!((_this$media3 = this.media) != null && _this$media3.readyState) || !this.hasBuffered) return;
        const currentTime = this.media.currentTime;
        this.poll(currentTime, this.lastCurrentTime);
        this.lastCurrentTime = currentTime;
    }
    /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */ poll(currentTime, lastCurrentTime) {
        var _this$hls, _this$hls2;
        const config = (_this$hls = this.hls) == null ? void 0 : _this$hls.config;
        if (!config) return;
        const media = this.media;
        if (!media) return;
        const { seeking: seeking } = media;
        const seeked = this.seeking && !seeking;
        const beginSeek = !this.seeking && seeking;
        const pausedEndedOrHalted = media.paused && !seeking || media.ended || media.playbackRate === 0;
        this.seeking = seeking;
        // The playhead is moving, no-op
        if (currentTime !== lastCurrentTime) {
            if (lastCurrentTime) this.ended = 0;
            this.moved = true;
            if (!seeking) {
                this.nudgeRetry = 0;
                // When crossing between buffered video time ranges, but not audio, flush pipeline with seek (Chrome)
                if (config.nudgeOnVideoHole && !pausedEndedOrHalted && currentTime > lastCurrentTime) this.nudgeOnVideoHole(currentTime, lastCurrentTime);
            }
            if (this.waiting === 0) this.stallResolved(currentTime);
            return;
        }
        // Clear stalled state when beginning or finishing seeking so that we don't report stalls coming out of a seek
        if (beginSeek || seeked) {
            if (seeked) this.stallResolved(currentTime);
            return;
        }
        // The playhead should not be moving
        if (pausedEndedOrHalted) {
            this.nudgeRetry = 0;
            this.stallResolved(currentTime);
            // Fire MEDIA_ENDED to workaround event not being dispatched by browser
            if (!this.ended && media.ended && this.hls) {
                this.ended = currentTime || 1;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ENDED, {
                    stalled: false
                });
            }
            return;
        }
        if (!$b941786f4eb9cb76$var$BufferHelper.getBuffered(media).length) {
            this.nudgeRetry = 0;
            return;
        }
        // Resolve stalls at buffer holes using the main buffer, whose ranges are the intersections of the A/V sourcebuffers
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const nextStart = bufferInfo.nextStart || 0;
        const fragmentTracker = this.fragmentTracker;
        if (seeking && fragmentTracker && this.hls) {
            // Is there a fragment loading/parsing/appending before currentTime?
            const inFlightDependency = $b941786f4eb9cb76$var$getInFlightDependency(this.hls.inFlightFragments, currentTime);
            // Waiting for seeking in a buffered range to complete
            const hasEnoughBuffer = bufferInfo.len > $b941786f4eb9cb76$var$MAX_START_GAP_JUMP;
            // Next buffered range is too far ahead to jump to while still seeking
            const noBufferHole = !nextStart || inFlightDependency || nextStart - currentTime > $b941786f4eb9cb76$var$MAX_START_GAP_JUMP && !fragmentTracker.getPartialFragment(currentTime);
            if (hasEnoughBuffer || noBufferHole) return;
            // Reset moved state when seeking to a point in or before a gap/hole
            this.moved = false;
        }
        // Skip start gaps if we haven't played, but the last poll detected the start of a stall
        // The addition poll gives the browser a chance to jump the gap for us
        const levelDetails = (_this$hls2 = this.hls) == null ? void 0 : _this$hls2.latestLevelDetails;
        if (!this.moved && this.stalled !== null && fragmentTracker) {
            // There is no playable buffer (seeked, waiting for buffer)
            const isBuffered = bufferInfo.len > 0;
            if (!isBuffered && !nextStart) return;
            // Jump start gaps within jump threshold
            const startJump = Math.max(nextStart, bufferInfo.start || 0) - currentTime;
            // When joining a live stream with audio tracks, account for live playlist window sliding by allowing
            // a larger jump over start gaps caused by the audio-stream-controller buffering a start fragment
            // that begins over 1 target duration after the video start position.
            const isLive = !!(levelDetails != null && levelDetails.live);
            const maxStartGapJump = isLive ? levelDetails.targetduration * 2 : $b941786f4eb9cb76$var$MAX_START_GAP_JUMP;
            const appended = $b941786f4eb9cb76$var$appendedFragAtPosition(currentTime, fragmentTracker);
            if (startJump > 0 && (startJump <= maxStartGapJump || appended)) {
                if (!media.paused) this._trySkipBufferHole(appended);
                return;
            }
        }
        // Start tracking stall time
        const detectStallWithCurrentTimeMs = config.detectStallWithCurrentTimeMs;
        const tnow = self.performance.now();
        const tWaiting = this.waiting;
        let stalled = this.stalled;
        if (stalled === null) {
            // Use time of recent "waiting" event
            if (tWaiting > 0 && tnow - tWaiting < detectStallWithCurrentTimeMs) stalled = this.stalled = tWaiting;
            else {
                this.stalled = tnow;
                return;
            }
        }
        const stalledDuration = tnow - stalled;
        if (!seeking && (stalledDuration >= detectStallWithCurrentTimeMs || tWaiting) && this.hls) {
            var _this$mediaSource;
            // Dispatch MEDIA_ENDED when media.ended/ended event is not signalled at end of stream
            if (((_this$mediaSource = this.mediaSource) == null ? void 0 : _this$mediaSource.readyState) === 'ended' && !(levelDetails != null && levelDetails.live) && Math.abs(currentTime - ((levelDetails == null ? void 0 : levelDetails.edge) || 0)) < 1) {
                if (this.ended) return;
                this.ended = currentTime || 1;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ENDED, {
                    stalled: true
                });
                return;
            }
            // Report stalling after trying to fix
            this._reportStall(bufferInfo);
            if (!this.media || !this.hls) return;
        }
        const bufferedWithHoles = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(media, currentTime, config.maxBufferHole);
        this._tryFixBufferStall(bufferedWithHoles, stalledDuration, currentTime);
    }
    stallResolved(currentTime) {
        const stalled = this.stalled;
        if (stalled && this.hls) {
            this.stalled = null;
            // The playhead is now moving, but was previously stalled
            if (this.stallReported) {
                const stalledDuration = self.performance.now() - stalled;
                this.log(`playback not stuck anymore @${currentTime}, after ${Math.round(stalledDuration)}ms`);
                this.stallReported = false;
                this.waiting = 0;
                this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.STALL_RESOLVED, {});
            }
        }
    }
    nudgeOnVideoHole(currentTime, lastCurrentTime) {
        var _this$buffered$audio;
        // Chrome will play one second past a hole in video buffered time ranges without rendering any video from the subsequent range and then stall as long as audio is buffered:
        // https://github.com/video-dev/hls.js/issues/5631
        // https://issues.chromium.org/issues/40280613#comment10
        // Detect the potential for this situation and proactively seek to flush the video pipeline once the playhead passes the start of the video hole.
        // When there are audio and video buffers and currentTime is past the end of the first video buffered range...
        const videoSourceBuffered = this.buffered.video;
        if (this.hls && this.media && this.fragmentTracker && (_this$buffered$audio = this.buffered.audio) != null && _this$buffered$audio.length && videoSourceBuffered && videoSourceBuffered.length > 1 && currentTime > videoSourceBuffered.end(0)) {
            // and audio is buffered at the playhead
            const audioBufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferedInfo($b941786f4eb9cb76$var$BufferHelper.timeRangesToArray(this.buffered.audio), currentTime, 0);
            if (audioBufferInfo.len > 1 && lastCurrentTime >= audioBufferInfo.start) {
                const videoTimes = $b941786f4eb9cb76$var$BufferHelper.timeRangesToArray(videoSourceBuffered);
                const lastBufferedIndex = $b941786f4eb9cb76$var$BufferHelper.bufferedInfo(videoTimes, lastCurrentTime, 0).bufferedIndex;
                // nudge when crossing into another video buffered range (hole).
                if (lastBufferedIndex > -1 && lastBufferedIndex < videoTimes.length - 1) {
                    const bufferedIndex = $b941786f4eb9cb76$var$BufferHelper.bufferedInfo(videoTimes, currentTime, 0).bufferedIndex;
                    const holeStart = videoTimes[lastBufferedIndex].end;
                    const holeEnd = videoTimes[lastBufferedIndex + 1].start;
                    if ((bufferedIndex === -1 || bufferedIndex > lastBufferedIndex) && holeEnd - holeStart < 1 && // `maxBufferHole` may be too small and setting it to 0 should not disable this feature
                    currentTime - holeStart < 2) {
                        const error = new Error(`nudging playhead to flush pipeline after video hole. currentTime: ${currentTime} hole: ${holeStart} -> ${holeEnd} buffered index: ${bufferedIndex}`);
                        this.warn(error.message);
                        // Magic number to flush the pipeline without interuption to audio playback:
                        this.media.currentTime += 0.000001;
                        let frag = $b941786f4eb9cb76$var$appendedFragAtPosition(currentTime, this.fragmentTracker);
                        if (frag && 'fragment' in frag) frag = frag.fragment;
                        else if (!frag) frag = undefined;
                        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(this.media, currentTime, 0);
                        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                            details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_SEEK_OVER_HOLE,
                            fatal: false,
                            error: error,
                            reason: error.message,
                            frag: frag,
                            buffer: bufferInfo.len,
                            bufferInfo: bufferInfo
                        });
                    }
                }
            }
        }
    }
    /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */ _tryFixBufferStall(bufferInfo, stalledDurationMs, currentTime) {
        var _this$hls3, _this$hls4;
        const { fragmentTracker: fragmentTracker, media: media } = this;
        const config = (_this$hls3 = this.hls) == null ? void 0 : _this$hls3.config;
        if (!media || !fragmentTracker || !config) return;
        const levelDetails = (_this$hls4 = this.hls) == null ? void 0 : _this$hls4.latestLevelDetails;
        const appended = $b941786f4eb9cb76$var$appendedFragAtPosition(currentTime, fragmentTracker);
        if (appended || levelDetails != null && levelDetails.live && currentTime < levelDetails.fragmentStart) {
            // Try to skip over the buffer hole caused by a partial fragment
            // This method isn't limited by the size of the gap between buffered ranges
            const targetTime = this._trySkipBufferHole(appended);
            // we return here in this case, meaning
            // the branch below only executes when we haven't seeked to a new position
            if (targetTime || !this.media) return;
        }
        // if we haven't had to skip over a buffer hole of a partial fragment
        // we may just have to "nudge" the playlist as the browser decoding/rendering engine
        // needs to cross some sort of threshold covering all source-buffers content
        // to start playing properly.
        const bufferedRanges = bufferInfo.buffered;
        const adjacentTraversal = this.adjacentTraversal(bufferInfo, currentTime);
        if ((bufferedRanges && bufferedRanges.length > 1 && bufferInfo.len > config.maxBufferHole || bufferInfo.nextStart && (bufferInfo.nextStart - currentTime < config.maxBufferHole || adjacentTraversal)) && (stalledDurationMs > config.highBufferWatchdogPeriod * 1000 || this.waiting)) {
            this.warn('Trying to nudge playhead over buffer-hole');
            // Try to nudge currentTime over a buffer hole if we've been stalling for the configured amount of seconds
            // We only try to jump the hole if it's under the configured size
            this._tryNudgeBuffer(bufferInfo);
        }
    }
    adjacentTraversal(bufferInfo, currentTime) {
        const fragmentTracker = this.fragmentTracker;
        const nextStart = bufferInfo.nextStart;
        if (fragmentTracker && nextStart) {
            const current = fragmentTracker.getFragAtPos(currentTime, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
            const next = fragmentTracker.getFragAtPos(nextStart, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
            if (current && next) return next.sn - current.sn < 2;
        }
        return false;
    }
    /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */ _reportStall(bufferInfo) {
        const { hls: hls, media: media, stallReported: stallReported, stalled: stalled } = this;
        if (!stallReported && stalled !== null && media && hls) {
            // Report stalled error once
            this.stallReported = true;
            const error = new Error(`Playback stalling at @${media.currentTime} due to low buffer (${$b941786f4eb9cb76$var$stringify(bufferInfo)})`);
            this.warn(error.message);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_STALLED_ERROR,
                fatal: false,
                error: error,
                buffer: bufferInfo.len,
                bufferInfo: bufferInfo,
                stalled: {
                    start: stalled
                }
            });
        }
    }
    /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param appended - The fragment or part found at the current time (where playback is stalling).
   * @private
   */ _trySkipBufferHole(appended) {
        var _this$hls5;
        const { fragmentTracker: fragmentTracker, media: media } = this;
        const config = (_this$hls5 = this.hls) == null ? void 0 : _this$hls5.config;
        if (!media || !fragmentTracker || !config) return 0;
        // Check if currentTime is between unbuffered regions of partial fragments
        const currentTime = media.currentTime;
        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(media, currentTime, 0);
        const startTime = currentTime < bufferInfo.start ? bufferInfo.start : bufferInfo.nextStart;
        if (startTime && this.hls) {
            const bufferStarved = bufferInfo.len <= config.maxBufferHole;
            const waiting = bufferInfo.len > 0 && bufferInfo.len < 1 && media.readyState < 3;
            const gapLength = startTime - currentTime;
            if (gapLength > 0 && (bufferStarved || waiting)) {
                // Only allow large gaps to be skipped if it is a start gap, or all fragments in skip range are partial
                if (gapLength > config.maxBufferHole) {
                    let startGap = false;
                    if (currentTime === 0) {
                        const startFrag = fragmentTracker.getAppendedFrag(0, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
                        if (startFrag && startTime < startFrag.end) startGap = true;
                    }
                    if (!startGap && appended) {
                        var _this$hls$loadLevelOb;
                        // Do not seek when selected variant playlist is unloaded
                        if (!((_this$hls$loadLevelOb = this.hls.loadLevelObj) != null && _this$hls$loadLevelOb.details)) return 0;
                        // Do not seek when required fragments are inflight or appending
                        const inFlightDependency = $b941786f4eb9cb76$var$getInFlightDependency(this.hls.inFlightFragments, startTime);
                        if (inFlightDependency) return 0;
                        // Do not seek if we can't walk tracked fragments to end of gap
                        let moreToLoad = false;
                        let pos = appended.end;
                        while(pos < startTime){
                            const provisioned = $b941786f4eb9cb76$var$appendedFragAtPosition(pos, fragmentTracker);
                            if (provisioned) pos += provisioned.duration;
                            else {
                                moreToLoad = true;
                                break;
                            }
                        }
                        if (moreToLoad) return 0;
                    }
                }
                const targetTime = Math.max(startTime + $b941786f4eb9cb76$var$SKIP_BUFFER_RANGE_START, currentTime + $b941786f4eb9cb76$var$SKIP_BUFFER_HOLE_STEP_SECONDS);
                this.warn(`skipping hole, adjusting currentTime from ${currentTime} to ${targetTime}`);
                this.moved = true;
                media.currentTime = targetTime;
                if (!(appended != null && appended.gap)) {
                    const error = new Error(`fragment loaded with buffer holes, seeking from ${currentTime} to ${targetTime}`);
                    const errorData = {
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_SEEK_OVER_HOLE,
                        fatal: false,
                        error: error,
                        reason: error.message,
                        buffer: bufferInfo.len,
                        bufferInfo: bufferInfo
                    };
                    if (appended) {
                        if ('fragment' in appended) errorData.part = appended;
                        else errorData.frag = appended;
                    }
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, errorData);
                }
                return targetTime;
            }
        }
        return 0;
    }
    /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */ _tryNudgeBuffer(bufferInfo) {
        const { hls: hls, media: media, nudgeRetry: nudgeRetry } = this;
        const config = hls == null ? void 0 : hls.config;
        if (!media || !config) return 0;
        const currentTime = media.currentTime;
        this.nudgeRetry++;
        if (nudgeRetry < config.nudgeMaxRetry) {
            const targetTime = currentTime + (nudgeRetry + 1) * config.nudgeOffset;
            // playback stalled in buffered area ... let's nudge currentTime to try to overcome this
            const error = new Error(`Nudging 'currentTime' from ${currentTime} to ${targetTime}`);
            this.warn(error.message);
            media.currentTime = targetTime;
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_NUDGE_ON_STALL,
                error: error,
                fatal: false,
                buffer: bufferInfo.len,
                bufferInfo: bufferInfo
            });
        } else {
            const error = new Error(`Playhead still not moving while enough data buffered @${currentTime} after ${config.nudgeMaxRetry} nudges`);
            this.error(error.message);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_STALLED_ERROR,
                error: error,
                fatal: true,
                buffer: bufferInfo.len,
                bufferInfo: bufferInfo
            });
        }
    }
}
function $b941786f4eb9cb76$var$getInFlightDependency(inFlightFragments, currentTime) {
    const main = $b941786f4eb9cb76$var$inFlight(inFlightFragments.main);
    if (main && main.start <= currentTime) return main;
    const audio = $b941786f4eb9cb76$var$inFlight(inFlightFragments.audio);
    if (audio && audio.start <= currentTime) return audio;
    return null;
}
function $b941786f4eb9cb76$var$inFlight(inFlightData) {
    if (!inFlightData) return null;
    switch(inFlightData.state){
        case $b941786f4eb9cb76$var$State.IDLE:
        case $b941786f4eb9cb76$var$State.STOPPED:
        case $b941786f4eb9cb76$var$State.ENDED:
        case $b941786f4eb9cb76$var$State.ERROR:
            return null;
    }
    return inFlightData.frag;
}
function $b941786f4eb9cb76$var$appendedFragAtPosition(pos, fragmentTracker) {
    return fragmentTracker.getAppendedFrag(pos, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) || fragmentTracker.getPartialFragment(pos);
}
const $b941786f4eb9cb76$var$MIN_CUE_DURATION = 0.25;
function $b941786f4eb9cb76$var$getCueClass() {
    if (typeof self === 'undefined') return undefined;
    return self.VTTCue || self.TextTrackCue;
}
function $b941786f4eb9cb76$var$createCueWithDataFields(Cue, startTime, endTime, data, type) {
    let cue = new Cue(startTime, endTime, '');
    try {
        cue.value = data;
        if (type) cue.type = type;
    } catch (e) {
        cue = new Cue(startTime, endTime, $b941786f4eb9cb76$var$stringify(type ? $b941786f4eb9cb76$var$_objectSpread2({
            type: type
        }, data) : data));
    }
    return cue;
}
// VTTCue latest draft allows an infinite duration, fallback
// to MAX_VALUE if necessary
const $b941786f4eb9cb76$var$MAX_CUE_ENDTIME = (()=>{
    const Cue = $b941786f4eb9cb76$var$getCueClass();
    try {
        Cue && new Cue(0, Number.POSITIVE_INFINITY, '');
    } catch (e) {
        return Number.MAX_VALUE;
    }
    return Number.POSITIVE_INFINITY;
})();
class $b941786f4eb9cb76$var$ID3TrackController {
    constructor(hls){
        this.hls = void 0;
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        this.removeCues = true;
        this.assetCue = void 0;
        this.onEventCueEnter = ()=>{
            if (!this.hls) return;
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.EVENT_CUE_ENTER, {});
        };
        this.hls = hls;
        this._registerListeners();
    }
    destroy() {
        this._unregisterListeners();
        this.id3Track = null;
        this.media = null;
        this.dateRangeCuesAppended = {};
        // @ts-ignore
        this.hls = this.onEventCueEnter = null;
    }
    _registerListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
            hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
        }
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        if (hls) {
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, this.onMediaAttaching, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, this.onBufferFlushing, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
            hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this);
        }
    }
    // Add ID3 metatadata text track.
    onMediaAttaching(event, data) {
        var _data$overrides;
        this.media = data.media;
        if (((_data$overrides = data.overrides) == null ? void 0 : _data$overrides.cueRemoval) === false) this.removeCues = false;
    }
    onMediaAttached() {
        var _this$hls;
        const details = (_this$hls = this.hls) == null ? void 0 : _this$hls.latestLevelDetails;
        if (details) this.updateDateRangeCues(details);
    }
    onMediaDetaching(event, data) {
        this.media = null;
        const transferringMedia = !!data.transferMedia;
        if (transferringMedia) return;
        if (this.id3Track) {
            if (this.removeCues) $b941786f4eb9cb76$var$clearCurrentCues(this.id3Track, this.onEventCueEnter);
            this.id3Track = null;
        }
        this.dateRangeCuesAppended = {};
    }
    onManifestLoading() {
        this.dateRangeCuesAppended = {};
    }
    createTrack(media) {
        const track = this.getID3Track(media.textTracks);
        track.mode = 'hidden';
        return track;
    }
    getID3Track(textTracks) {
        if (!this.media) return;
        for(let i = 0; i < textTracks.length; i++){
            const textTrack = textTracks[i];
            if (textTrack.kind === 'metadata' && textTrack.label === 'id3') {
                // send 'addtrack' when reusing the textTrack for metadata,
                // same as what we do for captions
                $b941786f4eb9cb76$var$sendAddTrackEvent(textTrack, this.media);
                return textTrack;
            }
        }
        return this.media.addTextTrack('metadata', 'id3');
    }
    onFragParsingMetadata(event, data) {
        if (!this.media || !this.hls) return;
        const { enableEmsgMetadataCues: enableEmsgMetadataCues, enableID3MetadataCues: enableID3MetadataCues } = this.hls.config;
        if (!enableEmsgMetadataCues && !enableID3MetadataCues) return;
        const { samples: samples } = data;
        // create track dynamically
        if (!this.id3Track) this.id3Track = this.createTrack(this.media);
        const Cue = $b941786f4eb9cb76$var$getCueClass();
        if (!Cue) return;
        for(let i = 0; i < samples.length; i++){
            const type = samples[i].type;
            if (type === $b941786f4eb9cb76$export$3f0d1211c87abf7f.emsg && !enableEmsgMetadataCues || !enableID3MetadataCues) continue;
            const frames = $b941786f4eb9cb76$var$getId3Frames(samples[i].data);
            const startTime = samples[i].pts;
            let endTime = startTime + samples[i].duration;
            if (endTime > $b941786f4eb9cb76$var$MAX_CUE_ENDTIME) endTime = $b941786f4eb9cb76$var$MAX_CUE_ENDTIME;
            const timeDiff = endTime - startTime;
            if (timeDiff <= 0) endTime = startTime + $b941786f4eb9cb76$var$MIN_CUE_DURATION;
            for(let j = 0; j < frames.length; j++){
                const frame = frames[j];
                // Safari doesn't put the timestamp frame in the TextTrack
                if (!$b941786f4eb9cb76$var$isId3TimestampFrame(frame)) {
                    // add a bounds to any unbounded cues
                    this.updateId3CueEnds(startTime, type);
                    const cue = $b941786f4eb9cb76$var$createCueWithDataFields(Cue, startTime, endTime, frame, type);
                    if (cue) this.id3Track.addCue(cue);
                }
            }
        }
    }
    updateId3CueEnds(startTime, type) {
        var _this$id3Track;
        const cues = (_this$id3Track = this.id3Track) == null ? void 0 : _this$id3Track.cues;
        if (cues) for(let i = cues.length; i--;){
            const cue = cues[i];
            if (cue.type === type && cue.startTime < startTime && cue.endTime === $b941786f4eb9cb76$var$MAX_CUE_ENDTIME) cue.endTime = startTime;
        }
    }
    onBufferFlushing(event, { startOffset: startOffset, endOffset: endOffset, type: type }) {
        const { id3Track: id3Track, hls: hls } = this;
        if (!hls) return;
        const { config: { enableEmsgMetadataCues: enableEmsgMetadataCues, enableID3MetadataCues: enableID3MetadataCues } } = hls;
        if (id3Track && (enableEmsgMetadataCues || enableID3MetadataCues)) {
            let predicate;
            if (type === 'audio') predicate = (cue)=>cue.type === $b941786f4eb9cb76$export$3f0d1211c87abf7f.audioId3 && enableID3MetadataCues;
            else if (type === 'video') predicate = (cue)=>cue.type === $b941786f4eb9cb76$export$3f0d1211c87abf7f.emsg && enableEmsgMetadataCues;
            else predicate = (cue)=>cue.type === $b941786f4eb9cb76$export$3f0d1211c87abf7f.audioId3 && enableID3MetadataCues || cue.type === $b941786f4eb9cb76$export$3f0d1211c87abf7f.emsg && enableEmsgMetadataCues;
            $b941786f4eb9cb76$var$removeCuesInRange(id3Track, startOffset, endOffset, predicate);
        }
    }
    onLevelUpdated(event, { details: details }) {
        this.updateDateRangeCues(details, true);
    }
    onLevelPtsUpdated(event, data) {
        if (Math.abs(data.drift) > 0.01) this.updateDateRangeCues(data.details);
    }
    updateDateRangeCues(details, removeOldCues) {
        if (!this.hls || !this.media) return;
        const { assetPlayerId: assetPlayerId, timelineOffset: timelineOffset, enableDateRangeMetadataCues: enableDateRangeMetadataCues, interstitialsController: interstitialsController } = this.hls.config;
        if (!enableDateRangeMetadataCues) return;
        const Cue = $b941786f4eb9cb76$var$getCueClass();
        if (assetPlayerId && timelineOffset && !interstitialsController) {
            const { fragmentStart: fragmentStart, fragmentEnd: fragmentEnd } = details;
            let cue = this.assetCue;
            if (cue) {
                cue.startTime = fragmentStart;
                cue.endTime = fragmentEnd;
            } else if (Cue) {
                cue = this.assetCue = $b941786f4eb9cb76$var$createCueWithDataFields(Cue, fragmentStart, fragmentEnd, {
                    assetPlayerId: this.hls.config.assetPlayerId
                }, 'hlsjs.interstitial.asset');
                if (cue) {
                    cue.id = assetPlayerId;
                    this.id3Track || (this.id3Track = this.createTrack(this.media));
                    this.id3Track.addCue(cue);
                    cue.addEventListener('enter', this.onEventCueEnter);
                }
            }
        }
        if (!details.hasProgramDateTime) return;
        const { id3Track: id3Track } = this;
        const { dateRanges: dateRanges } = details;
        const ids = Object.keys(dateRanges);
        let dateRangeCuesAppended = this.dateRangeCuesAppended;
        // Remove cues from track not found in details.dateRanges
        if (id3Track && removeOldCues) {
            var _id3Track$cues;
            if ((_id3Track$cues = id3Track.cues) != null && _id3Track$cues.length) {
                const idsToRemove = Object.keys(dateRangeCuesAppended).filter((id)=>!ids.includes(id));
                for(let i = idsToRemove.length; i--;){
                    var _dateRangeCuesAppende;
                    const id = idsToRemove[i];
                    const cues = (_dateRangeCuesAppende = dateRangeCuesAppended[id]) == null ? void 0 : _dateRangeCuesAppende.cues;
                    delete dateRangeCuesAppended[id];
                    if (cues) Object.keys(cues).forEach((key)=>{
                        const cue = cues[key];
                        if (cue) {
                            cue.removeEventListener('enter', this.onEventCueEnter);
                            try {
                                id3Track.removeCue(cue);
                            } catch (e) {
                            /* no-op */ }
                        }
                    });
                }
            } else dateRangeCuesAppended = this.dateRangeCuesAppended = {};
        }
        // Exit if the playlist does not have Date Ranges or does not have Program Date Time
        const lastFragment = details.fragments[details.fragments.length - 1];
        if (ids.length === 0 || !$b941786f4eb9cb76$var$isFiniteNumber(lastFragment == null ? void 0 : lastFragment.programDateTime)) return;
        this.id3Track || (this.id3Track = this.createTrack(this.media));
        for(let i = 0; i < ids.length; i++){
            const id = ids[i];
            const dateRange = dateRanges[id];
            const startTime = dateRange.startTime;
            // Process DateRanges to determine end-time (known DURATION, END-DATE, or END-ON-NEXT)
            const appendedDateRangeCues = dateRangeCuesAppended[id];
            const cues = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.cues) || {};
            let durationKnown = (appendedDateRangeCues == null ? void 0 : appendedDateRangeCues.durationKnown) || false;
            let endTime = $b941786f4eb9cb76$var$MAX_CUE_ENDTIME;
            const { duration: duration, endDate: endDate } = dateRange;
            if (endDate && duration !== null) {
                endTime = startTime + duration;
                durationKnown = true;
            } else if (dateRange.endOnNext && !durationKnown) {
                const nextDateRangeWithSameClass = ids.reduce((candidateDateRange, id)=>{
                    if (id !== dateRange.id) {
                        const otherDateRange = dateRanges[id];
                        if (otherDateRange.class === dateRange.class && otherDateRange.startDate > dateRange.startDate && (!candidateDateRange || dateRange.startDate < candidateDateRange.startDate)) return otherDateRange;
                    }
                    return candidateDateRange;
                }, null);
                if (nextDateRangeWithSameClass) {
                    endTime = nextDateRangeWithSameClass.startTime;
                    durationKnown = true;
                }
            }
            // Create TextTrack Cues for each MetadataGroup Item (select DateRange attribute)
            // This is to emulate Safari HLS playback handling of DateRange tags
            const attributes = Object.keys(dateRange.attr);
            for(let j = 0; j < attributes.length; j++){
                const key = attributes[j];
                if (!$b941786f4eb9cb76$var$isDateRangeCueAttribute(key)) continue;
                const cue = cues[key];
                if (cue) {
                    if (durationKnown && !(appendedDateRangeCues != null && appendedDateRangeCues.durationKnown)) cue.endTime = endTime;
                    else if (Math.abs(cue.startTime - startTime) > 0.01) {
                        cue.startTime = startTime;
                        cue.endTime = endTime;
                    }
                } else if (Cue) {
                    let data = dateRange.attr[key];
                    if ($b941786f4eb9cb76$var$isSCTE35Attribute(key)) data = $b941786f4eb9cb76$var$hexToArrayBuffer(data);
                    const payload = {
                        key: key,
                        data: data
                    };
                    const _cue = $b941786f4eb9cb76$var$createCueWithDataFields(Cue, startTime, endTime, payload, $b941786f4eb9cb76$export$3f0d1211c87abf7f.dateRange);
                    if (_cue) {
                        _cue.id = id;
                        this.id3Track.addCue(_cue);
                        cues[key] = _cue;
                        if (interstitialsController) {
                            if (key === 'X-ASSET-LIST' || key === 'X-ASSET-URL') _cue.addEventListener('enter', this.onEventCueEnter);
                        }
                    }
                }
            }
            // Keep track of processed DateRanges by ID for updating cues with new DateRange tag attributes
            dateRangeCuesAppended[id] = {
                cues: cues,
                dateRange: dateRange,
                durationKnown: durationKnown
            };
        }
    }
}
class $b941786f4eb9cb76$var$LatencyController {
    constructor(hls){
        this.hls = void 0;
        this.config = void 0;
        this.media = null;
        this.currentTime = 0;
        this.stallCount = 0;
        this._latency = null;
        this._targetLatencyUpdated = false;
        this.onTimeupdate = ()=>{
            const { media: media } = this;
            const levelDetails = this.levelDetails;
            if (!media || !levelDetails) return;
            this.currentTime = media.currentTime;
            const latency = this.computeLatency();
            if (latency === null) return;
            this._latency = latency;
            // Adapt playbackRate to meet target latency in low-latency mode
            const { lowLatencyMode: lowLatencyMode, maxLiveSyncPlaybackRate: maxLiveSyncPlaybackRate } = this.config;
            if (!lowLatencyMode || maxLiveSyncPlaybackRate === 1 || !levelDetails.live) return;
            const targetLatency = this.targetLatency;
            if (targetLatency === null) return;
            const distanceFromTarget = latency - targetLatency;
            // Only adjust playbackRate when within one target duration of targetLatency
            // and more than one second from under-buffering.
            // Playback further than one target duration from target can be considered DVR playback.
            const liveMinLatencyDuration = Math.min(this.maxLatency, targetLatency + levelDetails.targetduration);
            const inLiveRange = distanceFromTarget < liveMinLatencyDuration;
            if (inLiveRange && distanceFromTarget > 0.05 && this.forwardBufferLength > 1) {
                const max = Math.min(2, Math.max(1.0, maxLiveSyncPlaybackRate));
                const rate = Math.round(2 / (1 + Math.exp(-0.75 * distanceFromTarget - this.edgeStalled)) * 20) / 20;
                const playbackRate = Math.min(max, Math.max(1, rate));
                this.changeMediaPlaybackRate(media, playbackRate);
            } else if (media.playbackRate !== 1 && media.playbackRate !== 0) this.changeMediaPlaybackRate(media, 1);
        };
        this.hls = hls;
        this.config = hls.config;
        this.registerListeners();
    }
    get levelDetails() {
        var _this$hls;
        return ((_this$hls = this.hls) == null ? void 0 : _this$hls.latestLevelDetails) || null;
    }
    get latency() {
        return this._latency || 0;
    }
    get maxLatency() {
        const { config: config } = this;
        if (config.liveMaxLatencyDuration !== undefined) return config.liveMaxLatencyDuration;
        const levelDetails = this.levelDetails;
        return levelDetails ? config.liveMaxLatencyDurationCount * levelDetails.targetduration : 0;
    }
    get targetLatency() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null || this.hls === null) return null;
        const { holdBack: holdBack, partHoldBack: partHoldBack, targetduration: targetduration } = levelDetails;
        const { liveSyncDuration: liveSyncDuration, liveSyncDurationCount: liveSyncDurationCount, lowLatencyMode: lowLatencyMode } = this.config;
        const userConfig = this.hls.userConfig;
        let targetLatency = lowLatencyMode ? partHoldBack || holdBack : holdBack;
        if (this._targetLatencyUpdated || userConfig.liveSyncDuration || userConfig.liveSyncDurationCount || targetLatency === 0) targetLatency = liveSyncDuration !== undefined ? liveSyncDuration : liveSyncDurationCount * targetduration;
        const maxLiveSyncOnStallIncrease = targetduration;
        return targetLatency + Math.min(this.stallCount * this.config.liveSyncOnStallIncrease, maxLiveSyncOnStallIncrease);
    }
    set targetLatency(latency) {
        this.stallCount = 0;
        this.config.liveSyncDuration = latency;
        this._targetLatencyUpdated = true;
    }
    get liveSyncPosition() {
        const liveEdge = this.estimateLiveEdge();
        const targetLatency = this.targetLatency;
        if (liveEdge === null || targetLatency === null) return null;
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return null;
        const edge = levelDetails.edge;
        const syncPosition = liveEdge - targetLatency - this.edgeStalled;
        const min = edge - levelDetails.totalduration;
        const max = edge - (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration);
        return Math.min(Math.max(min, syncPosition), max);
    }
    get drift() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return 1;
        return levelDetails.drift;
    }
    get edgeStalled() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return 0;
        const maxLevelUpdateAge = (this.config.lowLatencyMode && levelDetails.partTarget || levelDetails.targetduration) * 3;
        return Math.max(levelDetails.age - maxLevelUpdateAge, 0);
    }
    get forwardBufferLength() {
        const { media: media } = this;
        const levelDetails = this.levelDetails;
        if (!media || !levelDetails) return 0;
        const bufferedRanges = media.buffered.length;
        return (bufferedRanges ? media.buffered.end(bufferedRanges - 1) : levelDetails.edge) - this.currentTime;
    }
    destroy() {
        this.unregisterListeners();
        this.onMediaDetaching();
        this.hls = null;
    }
    registerListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        if (!hls) return;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHED, this.onMediaAttached, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, this.onMediaDetaching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, this.onLevelUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    onMediaAttached(event, data) {
        this.media = data.media;
        this.media.addEventListener('timeupdate', this.onTimeupdate);
    }
    onMediaDetaching() {
        if (this.media) {
            this.media.removeEventListener('timeupdate', this.onTimeupdate);
            this.media = null;
        }
    }
    onManifestLoading() {
        this._latency = null;
        this.stallCount = 0;
    }
    onLevelUpdated(event, { details: details }) {
        if (details.advanced) this.onTimeupdate();
        if (!details.live && this.media) this.media.removeEventListener('timeupdate', this.onTimeupdate);
    }
    onError(event, data) {
        var _this$levelDetails;
        if (data.details !== $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_STALLED_ERROR) return;
        this.stallCount++;
        if (this.hls && (_this$levelDetails = this.levelDetails) != null && _this$levelDetails.live) this.hls.logger.warn('[latency-controller]: Stall detected, adjusting target latency');
    }
    changeMediaPlaybackRate(media, playbackRate) {
        var _this$hls2, _this$targetLatency;
        if (media.playbackRate === playbackRate) return;
        (_this$hls2 = this.hls) == null || _this$hls2.logger.debug(`[latency-controller]: latency=${this.latency.toFixed(3)}, targetLatency=${(_this$targetLatency = this.targetLatency) == null ? void 0 : _this$targetLatency.toFixed(3)}, forwardBufferLength=${this.forwardBufferLength.toFixed(3)}: adjusting playback rate from ${media.playbackRate} to ${playbackRate}`);
        media.playbackRate = playbackRate;
    }
    estimateLiveEdge() {
        const levelDetails = this.levelDetails;
        if (levelDetails === null) return null;
        return levelDetails.edge + levelDetails.age;
    }
    computeLatency() {
        const liveEdge = this.estimateLiveEdge();
        if (liveEdge === null) return null;
        return liveEdge - this.currentTime;
    }
}
class $b941786f4eb9cb76$var$LevelController extends $b941786f4eb9cb76$export$d94ec24774c8b986 {
    constructor(hls, contentSteeringController){
        super(hls, 'level-controller');
        this._levels = [];
        this._firstLevel = -1;
        this._maxAutoLevel = -1;
        this._startLevel = void 0;
        this.currentLevel = null;
        this.currentLevelIndex = -1;
        this.manualLevelIndex = -1;
        this.steering = void 0;
        this.onParsedComplete = void 0;
        this.steering = contentSteeringController;
        this._registerListeners();
    }
    _registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    _unregisterListeners() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, this.onManifestLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.ERROR, this.onError, this);
    }
    destroy() {
        this._unregisterListeners();
        this.steering = null;
        this.resetLevels();
        super.destroy();
    }
    stopLoad() {
        const levels = this._levels;
        // clean up live level details to force reload them, and reset load errors
        levels.forEach((level)=>{
            level.loadError = 0;
            level.fragmentError = 0;
        });
        super.stopLoad();
    }
    resetLevels() {
        this._startLevel = undefined;
        this.manualLevelIndex = -1;
        this.currentLevelIndex = -1;
        this.currentLevel = null;
        this._levels = [];
        this._maxAutoLevel = -1;
    }
    onManifestLoading(event, data) {
        this.resetLevels();
    }
    onManifestLoaded(event, data) {
        const preferManagedMediaSource = this.hls.config.preferManagedMediaSource;
        const levels = [];
        const redundantSet = {};
        const generatePathwaySet = {};
        let resolutionFound = false;
        let videoCodecFound = false;
        let audioCodecFound = false;
        data.levels.forEach((levelParsed)=>{
            const attributes = levelParsed.attrs;
            let { audioCodec: audioCodec, videoCodec: videoCodec } = levelParsed;
            if (audioCodec) // Returns empty and set to undefined for 'mp4a.40.34' with fallback to 'audio/mpeg' SourceBuffer
            levelParsed.audioCodec = audioCodec = $b941786f4eb9cb76$var$getCodecCompatibleName(audioCodec, preferManagedMediaSource) || undefined;
            if (videoCodec) videoCodec = levelParsed.videoCodec = $b941786f4eb9cb76$var$convertAVC1ToAVCOTI(videoCodec);
            // only keep levels with supported audio/video codecs
            const { width: width, height: height, unknownCodecs: unknownCodecs } = levelParsed;
            const unknownUnsupportedCodecCount = (unknownCodecs == null ? void 0 : unknownCodecs.length) || 0;
            resolutionFound || (resolutionFound = !!(width && height));
            videoCodecFound || (videoCodecFound = !!videoCodec);
            audioCodecFound || (audioCodecFound = !!audioCodec);
            if (unknownUnsupportedCodecCount || audioCodec && !this.isAudioSupported(audioCodec) || videoCodec && !this.isVideoSupported(videoCodec)) {
                this.log(`Some or all CODECS not supported "${attributes.CODECS}"`);
                return;
            }
            const { CODECS: CODECS, 'FRAME-RATE': FRAMERATE, 'HDCP-LEVEL': HDCP, 'PATHWAY-ID': PATHWAY, RESOLUTION: RESOLUTION, 'VIDEO-RANGE': VIDEO_RANGE } = attributes;
            const contentSteeringPrefix = `${PATHWAY || '.'}-`;
            const levelKey = `${contentSteeringPrefix}${levelParsed.bitrate}-${RESOLUTION}-${FRAMERATE}-${CODECS}-${VIDEO_RANGE}-${HDCP}`;
            if (!redundantSet[levelKey]) {
                const level = this.createLevel(levelParsed);
                redundantSet[levelKey] = level;
                generatePathwaySet[levelKey] = 1;
                levels.push(level);
            } else if (redundantSet[levelKey].uri !== levelParsed.url && !levelParsed.attrs['PATHWAY-ID']) {
                // Assign Pathway IDs to Redundant Streams (default Pathways is ".". Redundant Streams "..", "...", and so on.)
                // Content Steering controller to handles Pathway fallback on error
                const pathwayCount = generatePathwaySet[levelKey] += 1;
                levelParsed.attrs['PATHWAY-ID'] = new Array(pathwayCount + 1).join('.');
                const level = this.createLevel(levelParsed);
                redundantSet[levelKey] = level;
                levels.push(level);
            } else {
                redundantSet[levelKey].addGroupId('audio', attributes.AUDIO);
                redundantSet[levelKey].addGroupId('text', attributes.SUBTITLES);
            }
        });
        this.filterAndSortMediaOptions(levels, data, resolutionFound, videoCodecFound, audioCodecFound);
    }
    createLevel(levelParsed) {
        const level = new $b941786f4eb9cb76$export$ca664994d1d54bff(levelParsed);
        const supplemental = levelParsed.supplemental;
        if (supplemental != null && supplemental.videoCodec && !this.isVideoSupported(supplemental.videoCodec)) {
            const error = new Error(`SUPPLEMENTAL-CODECS not supported "${supplemental.videoCodec}"`);
            this.log(error.message);
            level.supportedResult = $b941786f4eb9cb76$var$getUnsupportedResult(error, []);
        }
        return level;
    }
    isAudioSupported(codec) {
        return $b941786f4eb9cb76$var$areCodecsMediaSourceSupported(codec, 'audio', this.hls.config.preferManagedMediaSource);
    }
    isVideoSupported(codec) {
        return $b941786f4eb9cb76$var$areCodecsMediaSourceSupported(codec, 'video', this.hls.config.preferManagedMediaSource);
    }
    filterAndSortMediaOptions(filteredLevels, data, resolutionFound, videoCodecFound, audioCodecFound) {
        var _data$stats;
        let audioTracks = [];
        let subtitleTracks = [];
        let levels = filteredLevels;
        const statsParsing = ((_data$stats = data.stats) == null ? void 0 : _data$stats.parsing) || {};
        // remove audio-only and invalid video-range levels if we also have levels with video codecs or RESOLUTION signalled
        if ((resolutionFound || videoCodecFound) && audioCodecFound) levels = levels.filter(({ videoCodec: videoCodec, videoRange: videoRange, width: width, height: height })=>(!!videoCodec || !!(width && height)) && $b941786f4eb9cb76$var$isVideoRange(videoRange));
        if (levels.length === 0) {
            // Dispatch error after MANIFEST_LOADED is done propagating
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            Promise.resolve().then(()=>{
                if (this.hls) {
                    let message = 'no level with compatible codecs found in manifest';
                    let reason = message;
                    if (data.levels.length) {
                        reason = `one or more CODECS in variant not supported: ${$b941786f4eb9cb76$var$stringify(data.levels.map((level)=>level.attrs.CODECS).filter((value, index, array)=>array.indexOf(value) === index))}`;
                        this.warn(reason);
                        message += ` (${reason})`;
                    }
                    const error = new Error(message);
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                        type: $b941786f4eb9cb76$export$43a750ddd9f2303e.MEDIA_ERROR,
                        details: $b941786f4eb9cb76$export$d053ec805ce391aa.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
                        fatal: true,
                        url: data.url,
                        error: error,
                        reason: reason
                    });
                }
            });
            statsParsing.end = performance.now();
            return;
        }
        if (data.audioTracks) {
            audioTracks = data.audioTracks.filter((track)=>!track.audioCodec || this.isAudioSupported(track.audioCodec));
            // Assign ids after filtering as array indices by group-id
            $b941786f4eb9cb76$var$assignTrackIdsByGroup(audioTracks);
        }
        if (data.subtitles) {
            subtitleTracks = data.subtitles;
            $b941786f4eb9cb76$var$assignTrackIdsByGroup(subtitleTracks);
        }
        // start bitrate is the first bitrate of the manifest
        const unsortedLevels = levels.slice(0);
        // sort levels from lowest to highest
        levels.sort((a, b)=>{
            if (a.attrs['HDCP-LEVEL'] !== b.attrs['HDCP-LEVEL']) return (a.attrs['HDCP-LEVEL'] || '') > (b.attrs['HDCP-LEVEL'] || '') ? 1 : -1;
            // sort on height before bitrate for cap-level-controller
            if (resolutionFound && a.height !== b.height) return a.height - b.height;
            if (a.frameRate !== b.frameRate) return a.frameRate - b.frameRate;
            if (a.videoRange !== b.videoRange) return $b941786f4eb9cb76$var$VideoRangeValues.indexOf(a.videoRange) - $b941786f4eb9cb76$var$VideoRangeValues.indexOf(b.videoRange);
            if (a.videoCodec !== b.videoCodec) {
                const valueA = $b941786f4eb9cb76$var$videoCodecPreferenceValue(a.videoCodec);
                const valueB = $b941786f4eb9cb76$var$videoCodecPreferenceValue(b.videoCodec);
                if (valueA !== valueB) return valueB - valueA;
            }
            if (a.uri === b.uri && a.codecSet !== b.codecSet) {
                const valueA = $b941786f4eb9cb76$var$codecsSetSelectionPreferenceValue(a.codecSet);
                const valueB = $b941786f4eb9cb76$var$codecsSetSelectionPreferenceValue(b.codecSet);
                if (valueA !== valueB) return valueB - valueA;
            }
            if (a.averageBitrate !== b.averageBitrate) return a.averageBitrate - b.averageBitrate;
            return 0;
        });
        let firstLevelInPlaylist = unsortedLevels[0];
        if (this.steering) {
            levels = this.steering.filterParsedLevels(levels);
            if (levels.length !== unsortedLevels.length) {
                for(let i = 0; i < unsortedLevels.length; i++)if (unsortedLevels[i].pathwayId === levels[0].pathwayId) {
                    firstLevelInPlaylist = unsortedLevels[i];
                    break;
                }
            }
        }
        this._levels = levels;
        // find index of first level in sorted levels
        for(let i = 0; i < levels.length; i++)if (levels[i] === firstLevelInPlaylist) {
            var _this$hls$userConfig;
            this._firstLevel = i;
            const firstLevelBitrate = firstLevelInPlaylist.bitrate;
            const bandwidthEstimate = this.hls.bandwidthEstimate;
            this.log(`manifest loaded, ${levels.length} level(s) found, first bitrate: ${firstLevelBitrate}`);
            // Update default bwe to first variant bitrate as long it has not been configured or set
            if (((_this$hls$userConfig = this.hls.userConfig) == null ? void 0 : _this$hls$userConfig.abrEwmaDefaultEstimate) === undefined) {
                const startingBwEstimate = Math.min(firstLevelBitrate, this.hls.config.abrEwmaDefaultEstimateMax);
                if (startingBwEstimate > bandwidthEstimate && bandwidthEstimate === this.hls.abrEwmaDefaultEstimate) this.hls.bandwidthEstimate = startingBwEstimate;
            }
            break;
        }
        // Audio is only alternate if manifest include a URI along with the audio group tag,
        // and this is not an audio-only stream where levels contain audio-only
        const audioOnly = audioCodecFound && !videoCodecFound;
        const config = this.hls.config;
        const altAudioEnabled = !!(config.audioStreamController && config.audioTrackController);
        const edata = {
            levels: levels,
            audioTracks: audioTracks,
            subtitleTracks: subtitleTracks,
            sessionData: data.sessionData,
            sessionKeys: data.sessionKeys,
            firstLevel: this._firstLevel,
            stats: data.stats,
            audio: audioCodecFound,
            video: videoCodecFound,
            altAudio: altAudioEnabled && !audioOnly && audioTracks.some((t)=>!!t.url)
        };
        statsParsing.end = performance.now();
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, edata);
    }
    get levels() {
        if (this._levels.length === 0) return null;
        return this._levels;
    }
    get loadLevelObj() {
        return this.currentLevel;
    }
    get level() {
        return this.currentLevelIndex;
    }
    set level(newLevel) {
        const levels = this._levels;
        if (levels.length === 0) return;
        // check if level idx is valid
        if (newLevel < 0 || newLevel >= levels.length) {
            // invalid level id given, trigger error
            const error = new Error('invalid level idx');
            const fatal = newLevel < 0;
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_SWITCH_ERROR,
                level: newLevel,
                fatal: fatal,
                error: error,
                reason: error.message
            });
            if (fatal) return;
            newLevel = Math.min(newLevel, levels.length - 1);
        }
        const lastLevelIndex = this.currentLevelIndex;
        const lastLevel = this.currentLevel;
        const lastPathwayId = lastLevel ? lastLevel.attrs['PATHWAY-ID'] : undefined;
        const level = levels[newLevel];
        const pathwayId = level.attrs['PATHWAY-ID'];
        this.currentLevelIndex = newLevel;
        this.currentLevel = level;
        if (lastLevelIndex === newLevel && lastLevel && lastPathwayId === pathwayId) return;
        this.log(`Switching to level ${newLevel} (${level.height ? level.height + 'p ' : ''}${level.videoRange ? level.videoRange + ' ' : ''}${level.codecSet ? level.codecSet + ' ' : ''}@${level.bitrate})${pathwayId ? ' with Pathway ' + pathwayId : ''} from level ${lastLevelIndex}${lastPathwayId ? ' with Pathway ' + lastPathwayId : ''}`);
        const levelSwitchingData = {
            level: newLevel,
            attrs: level.attrs,
            details: level.details,
            bitrate: level.bitrate,
            averageBitrate: level.averageBitrate,
            maxBitrate: level.maxBitrate,
            realBitrate: level.realBitrate,
            width: level.width,
            height: level.height,
            codecSet: level.codecSet,
            audioCodec: level.audioCodec,
            videoCodec: level.videoCodec,
            audioGroups: level.audioGroups,
            subtitleGroups: level.subtitleGroups,
            loaded: level.loaded,
            loadError: level.loadError,
            fragmentError: level.fragmentError,
            name: level.name,
            id: level.id,
            uri: level.uri,
            url: level.url,
            urlId: 0,
            audioGroupIds: level.audioGroupIds,
            textGroupIds: level.textGroupIds
        };
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHING, levelSwitchingData);
        // check if we need to load playlist for this level
        const levelDetails = level.details;
        if (!levelDetails || levelDetails.live) {
            // level not retrieved yet, or live playlist we need to (re)load it
            const hlsUrlParameters = this.switchParams(level.uri, lastLevel == null ? void 0 : lastLevel.details, levelDetails);
            this.loadPlaylist(hlsUrlParameters);
        }
    }
    get manualLevel() {
        return this.manualLevelIndex;
    }
    set manualLevel(newLevel) {
        this.manualLevelIndex = newLevel;
        if (this._startLevel === undefined) this._startLevel = newLevel;
        if (newLevel !== -1) this.level = newLevel;
    }
    get firstLevel() {
        return this._firstLevel;
    }
    set firstLevel(newLevel) {
        this._firstLevel = newLevel;
    }
    get startLevel() {
        // Setting hls.startLevel (this._startLevel) overrides config.startLevel
        if (this._startLevel === undefined) {
            const configStartLevel = this.hls.config.startLevel;
            if (configStartLevel !== undefined) return configStartLevel;
            return this.hls.firstAutoLevel;
        }
        return this._startLevel;
    }
    set startLevel(newLevel) {
        this._startLevel = newLevel;
    }
    get pathways() {
        if (this.steering) return this.steering.pathways();
        return [];
    }
    get pathwayPriority() {
        if (this.steering) return this.steering.pathwayPriority;
        return null;
    }
    set pathwayPriority(pathwayPriority) {
        if (this.steering) {
            const pathwaysList = this.steering.pathways();
            const filteredPathwayPriority = pathwayPriority.filter((pathwayId)=>{
                return pathwaysList.indexOf(pathwayId) !== -1;
            });
            if (pathwayPriority.length < 1) {
                this.warn(`pathwayPriority ${pathwayPriority} should contain at least one pathway from list: ${pathwaysList}`);
                return;
            }
            this.steering.pathwayPriority = filteredPathwayPriority;
        }
    }
    onError(event, data) {
        if (data.fatal || !data.context) return;
        if (data.context.type === $b941786f4eb9cb76$var$PlaylistContextType.LEVEL && data.context.level === this.level) this.checkRetry(data);
    }
    // reset errors on the successful load of a fragment
    onFragBuffered(event, { frag: frag }) {
        if (frag !== undefined && frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN) {
            const el = frag.elementaryStreams;
            if (!Object.keys(el).some((type)=>!!el[type])) return;
            const level = this._levels[frag.level];
            if (level != null && level.loadError) {
                this.log(`Resetting level error count of ${level.loadError} on frag buffered`);
                level.loadError = 0;
            }
        }
    }
    onLevelLoaded(event, data) {
        var _data$deliveryDirecti2;
        const { level: level, details: details } = data;
        const curLevel = data.levelInfo;
        if (!curLevel) {
            var _data$deliveryDirecti;
            this.warn(`Invalid level index ${level}`);
            if ((_data$deliveryDirecti = data.deliveryDirectives) != null && _data$deliveryDirecti.skip) details.deltaUpdateFailed = true;
            return;
        }
        // only process level loaded events matching with expected level or prior to switch when media playlist is loaded directly
        if (curLevel === this.currentLevel || data.withoutMultiVariant) {
            // reset level load error counter on successful level loaded only if there is no issues with fragments
            if (curLevel.fragmentError === 0) curLevel.loadError = 0;
            // Ignore matching details populated by loading a Media Playlist directly
            let previousDetails = curLevel.details;
            if (previousDetails === data.details && previousDetails.advanced) previousDetails = undefined;
            this.playlistLoaded(level, data, previousDetails);
        } else if ((_data$deliveryDirecti2 = data.deliveryDirectives) != null && _data$deliveryDirecti2.skip) // received a delta playlist update that cannot be merged
        details.deltaUpdateFailed = true;
    }
    loadPlaylist(hlsUrlParameters) {
        super.loadPlaylist();
        if (this.shouldLoadPlaylist(this.currentLevel)) this.scheduleLoading(this.currentLevel, hlsUrlParameters);
    }
    loadingPlaylist(currentLevel, hlsUrlParameters) {
        super.loadingPlaylist(currentLevel, hlsUrlParameters);
        const url = this.getUrlWithDirectives(currentLevel.uri, hlsUrlParameters);
        const currentLevelIndex = this.currentLevelIndex;
        const pathwayId = currentLevel.attrs['PATHWAY-ID'];
        const details = currentLevel.details;
        const age = details == null ? void 0 : details.age;
        this.log(`Loading level index ${currentLevelIndex}${(hlsUrlParameters == null ? void 0 : hlsUrlParameters.msn) !== undefined ? ' at sn ' + hlsUrlParameters.msn + ' part ' + hlsUrlParameters.part : ''}${pathwayId ? ' Pathway ' + pathwayId : ''}${age && details.live ? ' age ' + age.toFixed(1) + (details.type ? ' ' + details.type : '') : ''} ${url}`);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, {
            url: url,
            level: currentLevelIndex,
            levelInfo: currentLevel,
            pathwayId: currentLevel.attrs['PATHWAY-ID'],
            id: 0,
            // Deprecated Level urlId
            deliveryDirectives: hlsUrlParameters || null
        });
    }
    get nextLoadLevel() {
        if (this.manualLevelIndex !== -1) return this.manualLevelIndex;
        else return this.hls.nextAutoLevel;
    }
    set nextLoadLevel(nextLevel) {
        this.level = nextLevel;
        if (this.manualLevelIndex === -1) this.hls.nextAutoLevel = nextLevel;
    }
    removeLevel(levelIndex) {
        var _this$currentLevel;
        if (this._levels.length === 1) return;
        const levels = this._levels.filter((level, index)=>{
            if (index !== levelIndex) return true;
            if (this.steering) this.steering.removeLevel(level);
            if (level === this.currentLevel) {
                this.currentLevel = null;
                this.currentLevelIndex = -1;
                if (level.details) level.details.fragments.forEach((f)=>f.level = -1);
            }
            return false;
        });
        $b941786f4eb9cb76$var$reassignFragmentLevelIndexes(levels);
        this._levels = levels;
        if (this.currentLevelIndex > -1 && (_this$currentLevel = this.currentLevel) != null && _this$currentLevel.details) this.currentLevelIndex = this.currentLevel.details.fragments[0].level;
        if (this.manualLevelIndex > -1) this.manualLevelIndex = this.currentLevelIndex;
        const maxLevel = levels.length - 1;
        this._firstLevel = Math.min(this._firstLevel, maxLevel);
        if (this._startLevel) this._startLevel = Math.min(this._startLevel, maxLevel);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, {
            levels: levels
        });
    }
    onLevelsUpdated(event, { levels: levels }) {
        this._levels = levels;
    }
    checkMaxAutoUpdated() {
        const { autoLevelCapping: autoLevelCapping, maxAutoLevel: maxAutoLevel, maxHdcpLevel: maxHdcpLevel } = this.hls;
        if (this._maxAutoLevel !== maxAutoLevel) {
            this._maxAutoLevel = maxAutoLevel;
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MAX_AUTO_LEVEL_UPDATED, {
                autoLevelCapping: autoLevelCapping,
                levels: this.levels,
                maxAutoLevel: maxAutoLevel,
                minAutoLevel: this.hls.minAutoLevel,
                maxHdcpLevel: maxHdcpLevel
            });
        }
    }
}
function $b941786f4eb9cb76$var$assignTrackIdsByGroup(tracks) {
    const groups = {};
    tracks.forEach((track)=>{
        const groupId = track.groupId || '';
        track.id = groups[groupId] = groups[groupId] || 0;
        groups[groupId]++;
    });
}
function $b941786f4eb9cb76$var$getSourceBuffer() {
    return self.SourceBuffer || self.WebKitSourceBuffer;
}
function $b941786f4eb9cb76$export$e9e4a33dcf7638ad() {
    const mediaSource = $b941786f4eb9cb76$export$a92854129bc50f89();
    if (!mediaSource) return false;
    // if SourceBuffer is exposed ensure its API is valid
    // Older browsers do not expose SourceBuffer globally so checking SourceBuffer.prototype is impossible
    const sourceBuffer = $b941786f4eb9cb76$var$getSourceBuffer();
    return !sourceBuffer || sourceBuffer.prototype && typeof sourceBuffer.prototype.appendBuffer === 'function' && typeof sourceBuffer.prototype.remove === 'function';
}
function $b941786f4eb9cb76$export$48c17662a6902497() {
    if (!$b941786f4eb9cb76$export$e9e4a33dcf7638ad()) return false;
    const mediaSource = $b941786f4eb9cb76$export$a92854129bc50f89();
    return typeof (mediaSource == null ? void 0 : mediaSource.isTypeSupported) === 'function' && ([
        'avc1.42E01E,mp4a.40.2',
        'av01.0.01M.08',
        'vp09.00.50.08'
    ].some((codecsForVideoContainer)=>mediaSource.isTypeSupported($b941786f4eb9cb76$var$mimeTypeForCodec(codecsForVideoContainer, 'video'))) || [
        'mp4a.40.2',
        'fLaC'
    ].some((codecForAudioContainer)=>mediaSource.isTypeSupported($b941786f4eb9cb76$var$mimeTypeForCodec(codecForAudioContainer, 'audio'))));
}
function $b941786f4eb9cb76$var$changeTypeSupported() {
    var _sourceBuffer$prototy;
    const sourceBuffer = $b941786f4eb9cb76$var$getSourceBuffer();
    return typeof (sourceBuffer == null || (_sourceBuffer$prototy = sourceBuffer.prototype) == null ? void 0 : _sourceBuffer$prototy.changeType) === 'function';
}
const $b941786f4eb9cb76$var$TICK_INTERVAL = 100; // how often to tick in ms
class $b941786f4eb9cb76$var$StreamController extends $b941786f4eb9cb76$export$946cb951577581c9 {
    constructor(hls, fragmentTracker, keyLoader){
        super(hls, fragmentTracker, keyLoader, 'stream-controller', $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
        this.audioCodecSwap = false;
        this.level = -1;
        this._forceStartLoad = false;
        this._hasEnoughToStart = false;
        this.altAudio = 0;
        this.audioOnly = false;
        this.fragPlaying = null;
        this.fragLastKbps = 0;
        this.couldBacktrack = false;
        this.backtrackFragment = null;
        this.audioCodecSwitch = false;
        this.videoBuffer = null;
        this.onMediaPlaying = ()=>{
            // tick to speed up FRAG_CHANGED triggering
            this.tick();
        };
        this.onMediaSeeked = ()=>{
            const media = this.media;
            const currentTime = media ? media.currentTime : null;
            if (currentTime === null || !$b941786f4eb9cb76$var$isFiniteNumber(currentTime)) return;
            this.log(`Media seeked to ${currentTime.toFixed(3)}`);
            // If seeked was issued before buffer was appended do not tick immediately
            if (!this.getBufferedFrag(currentTime)) return;
            const bufferInfo = this.getFwdBufferInfoAtPos(media, currentTime, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN, 0);
            if (bufferInfo === null || bufferInfo.len === 0) {
                this.warn(`Main forward buffer length at ${currentTime} on "seeked" event ${bufferInfo ? bufferInfo.len : 'empty'})`);
                return;
            }
            // tick to speed up FRAG_CHANGED triggering
            this.tick();
        };
        this.registerListeners();
    }
    registerListeners() {
        super.registerListeners();
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    unregisterListeners() {
        super.unregisterListeners();
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_PARSED, this.onManifestParsed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, this.onLevelLoaded, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CREATED, this.onBufferCreated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, this.onBufferFlushed, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.FRAG_BUFFERED, this.onFragBuffered, this);
    }
    onHandlerDestroying() {
        // @ts-ignore
        this.onMediaPlaying = this.onMediaSeeked = null;
        this.unregisterListeners();
        super.onHandlerDestroying();
    }
    startLoad(startPosition, skipSeekToStartPosition) {
        if (this.levels) {
            const { lastCurrentTime: lastCurrentTime, hls: hls } = this;
            this.stopLoad();
            this.setInterval($b941786f4eb9cb76$var$TICK_INTERVAL);
            this.level = -1;
            if (!this.startFragRequested) {
                // determine load level
                let startLevel = hls.startLevel;
                if (startLevel === -1) {
                    if (hls.config.testBandwidth && this.levels.length > 1) {
                        // -1 : guess start Level by doing a bitrate test by loading first fragment of lowest quality level
                        startLevel = 0;
                        this.bitrateTest = true;
                    } else startLevel = hls.firstAutoLevel;
                }
                // set new level to playlist loader : this will trigger start level load
                // hls.nextLoadLevel remains until it is set to a new value or until a new frag is successfully loaded
                hls.nextLoadLevel = startLevel;
                this.level = hls.loadLevel;
                this._hasEnoughToStart = !!skipSeekToStartPosition;
            }
            // if startPosition undefined but lastCurrentTime set, set startPosition to last currentTime
            if (lastCurrentTime > 0 && startPosition === -1 && !skipSeekToStartPosition) {
                this.log(`Override startPosition with lastCurrentTime @${lastCurrentTime.toFixed(3)}`);
                startPosition = lastCurrentTime;
            }
            this.state = $b941786f4eb9cb76$var$State.IDLE;
            this.nextLoadPosition = this.lastCurrentTime = startPosition + this.timelineOffset;
            this.startPosition = skipSeekToStartPosition ? -1 : startPosition;
            this.tick();
        } else {
            this._forceStartLoad = true;
            this.state = $b941786f4eb9cb76$var$State.STOPPED;
        }
    }
    stopLoad() {
        this._forceStartLoad = false;
        super.stopLoad();
    }
    doTick() {
        switch(this.state){
            case $b941786f4eb9cb76$var$State.WAITING_LEVEL:
                {
                    const { levels: levels, level: level } = this;
                    const currentLevel = levels == null ? void 0 : levels[level];
                    const details = currentLevel == null ? void 0 : currentLevel.details;
                    if (details && (!details.live || this.levelLastLoaded === currentLevel && !this.waitForLive(currentLevel))) {
                        if (this.waitForCdnTuneIn(details)) break;
                        this.state = $b941786f4eb9cb76$var$State.IDLE;
                        break;
                    } else if (this.hls.nextLoadLevel !== this.level) {
                        this.state = $b941786f4eb9cb76$var$State.IDLE;
                        break;
                    }
                    break;
                }
            case $b941786f4eb9cb76$var$State.FRAG_LOADING_WAITING_RETRY:
                this.checkRetryDate();
                break;
        }
        if (this.state === $b941786f4eb9cb76$var$State.IDLE) this.doTickIdle();
        this.onTickEnd();
    }
    onTickEnd() {
        var _this$media;
        super.onTickEnd();
        if ((_this$media = this.media) != null && _this$media.readyState && this.media.seeking === false) this.lastCurrentTime = this.media.currentTime;
        this.checkFragmentChanged();
    }
    doTickIdle() {
        const { hls: hls, levelLastLoaded: levelLastLoaded, levels: levels, media: media } = this;
        // if start level not parsed yet OR
        // if video not attached AND start fragment already requested OR start frag prefetch not enabled
        // exit loop, as we either need more info (level not parsed) or we need media to be attached to load new fragment
        if (levelLastLoaded === null || !media && !this.primaryPrefetch && (this.startFragRequested || !hls.config.startFragPrefetch)) return;
        // If the "main" level is audio-only but we are loading an alternate track in the same group, do not load anything
        if (this.altAudio && this.audioOnly) return;
        const level = this.buffering ? hls.nextLoadLevel : hls.loadLevel;
        if (!(levels != null && levels[level])) return;
        const levelInfo = levels[level];
        // if buffer length is less than maxBufLen try to load a new fragment
        const bufferInfo = this.getMainFwdBufferInfo();
        if (bufferInfo === null) return;
        const lastDetails = this.getLevelDetails();
        if (lastDetails && this._streamEnded(bufferInfo, lastDetails)) {
            const data = {};
            if (this.altAudio === 2) data.type = 'video';
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_EOS, data);
            this.state = $b941786f4eb9cb76$var$State.ENDED;
            return;
        }
        if (!this.buffering) return;
        // set next load level : this will trigger a playlist load if needed
        if (hls.loadLevel !== level && hls.manualLevel === -1) this.log(`Adapting to level ${level} from level ${this.level}`);
        this.level = hls.nextLoadLevel = level;
        const levelDetails = levelInfo.details;
        // if level info not retrieved yet, switch state and wait for level retrieval
        // if live playlist, ensure that new playlist has been refreshed to avoid loading/try to load
        // a useless and outdated fragment (that might even introduce load error if it is already out of the live playlist)
        if (!levelDetails || this.state === $b941786f4eb9cb76$var$State.WAITING_LEVEL || this.waitForLive(levelInfo)) {
            this.level = level;
            this.state = $b941786f4eb9cb76$var$State.WAITING_LEVEL;
            this.startFragRequested = false;
            return;
        }
        const bufferLen = bufferInfo.len;
        // compute max Buffer Length that we could get from this load level, based on level bitrate. don't buffer more than 60 MB and more than 30s
        const maxBufLen = this.getMaxBufferLength(levelInfo.maxBitrate);
        // Stay idle if we are still with buffer margins
        if (bufferLen >= maxBufLen) return;
        if (this.backtrackFragment && this.backtrackFragment.start > bufferInfo.end) this.backtrackFragment = null;
        const targetBufferTime = this.backtrackFragment ? this.backtrackFragment.start : bufferInfo.end;
        let frag = this.getNextFragment(targetBufferTime, levelDetails);
        // Avoid backtracking by loading an earlier segment in streams with segments that do not start with a key frame (flagged by `couldBacktrack`)
        if (this.couldBacktrack && !this.fragPrevious && frag && $b941786f4eb9cb76$var$isMediaFragment(frag) && this.fragmentTracker.getState(frag) !== $b941786f4eb9cb76$var$FragmentState.OK) {
            var _this$backtrackFragme;
            const backtrackSn = ((_this$backtrackFragme = this.backtrackFragment) != null ? _this$backtrackFragme : frag).sn;
            const fragIdx = backtrackSn - levelDetails.startSN;
            const backtrackFrag = levelDetails.fragments[fragIdx - 1];
            if (backtrackFrag && frag.cc === backtrackFrag.cc) {
                frag = backtrackFrag;
                this.fragmentTracker.removeFragment(backtrackFrag);
            }
        } else if (this.backtrackFragment && bufferInfo.len) this.backtrackFragment = null;
        // Avoid loop loading by using nextLoadPosition set for backtracking and skipping consecutive GAP tags
        if (frag && this.isLoopLoading(frag, targetBufferTime)) {
            const gapStart = frag.gap;
            if (!gapStart) {
                // Cleanup the fragment tracker before trying to find the next unbuffered fragment
                const type = this.audioOnly && !this.altAudio ? $b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO : $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO;
                const mediaBuffer = (type === $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
                if (mediaBuffer) this.afterBufferFlushed(mediaBuffer, type, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
            }
            frag = this.getNextFragmentLoopLoading(frag, levelDetails, bufferInfo, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN, maxBufLen);
        }
        if (!frag) return;
        if (frag.initSegment && !frag.initSegment.data && !this.bitrateTest) frag = frag.initSegment;
        this.loadFragment(frag, levelInfo, targetBufferTime);
    }
    loadFragment(frag, level, targetBufferTime) {
        // Check if fragment is not loaded
        const fragState = this.fragmentTracker.getState(frag);
        if (fragState === $b941786f4eb9cb76$var$FragmentState.NOT_LOADED || fragState === $b941786f4eb9cb76$var$FragmentState.PARTIAL) {
            if (!$b941786f4eb9cb76$var$isMediaFragment(frag)) this._loadInitSegment(frag, level);
            else if (this.bitrateTest) {
                this.log(`Fragment ${frag.sn} of level ${frag.level} is being downloaded to test bitrate and will not be buffered`);
                this._loadBitrateTestFrag(frag, level);
            } else super.loadFragment(frag, level, targetBufferTime);
        } else this.clearTrackerIfNeeded(frag);
    }
    getBufferedFrag(position) {
        return this.fragmentTracker.getBufferedFrag(position, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
    }
    followingBufferedFrag(frag) {
        if (frag) // try to get range of next fragment (500ms after this range)
        return this.getBufferedFrag(frag.end + 0.5);
        return null;
    }
    /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */ immediateLevelSwitch() {
        this.abortCurrentFrag();
        this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
    }
    /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */ nextLevelSwitch() {
        const { levels: levels, media: media } = this;
        // ensure that media is defined and that metadata are available (to retrieve currentTime)
        if (media != null && media.readyState) {
            let fetchdelay;
            const fragPlayingCurrent = this.getAppendedFrag(media.currentTime);
            if (fragPlayingCurrent && fragPlayingCurrent.start > 1) // flush buffer preceding current fragment (flush until current fragment start offset)
            // minus 1s to avoid video freezing, that could happen if we flush keyframe of current video ...
            this.flushMainBuffer(0, fragPlayingCurrent.start - 1);
            const levelDetails = this.getLevelDetails();
            if (levelDetails != null && levelDetails.live) {
                const bufferInfo = this.getMainFwdBufferInfo();
                // Do not flush in live stream with low buffer
                if (!bufferInfo || bufferInfo.len < levelDetails.targetduration * 2) return;
            }
            if (!media.paused && levels) {
                // add a safety delay of 1s
                const nextLevelId = this.hls.nextLoadLevel;
                const nextLevel = levels[nextLevelId];
                const fragLastKbps = this.fragLastKbps;
                if (fragLastKbps && this.fragCurrent) fetchdelay = this.fragCurrent.duration * nextLevel.maxBitrate / (1000 * fragLastKbps) + 1;
                else fetchdelay = 0;
            } else fetchdelay = 0;
            // this.log('fetchdelay:'+fetchdelay);
            // find buffer range that will be reached once new fragment will be fetched
            const bufferedFrag = this.getBufferedFrag(media.currentTime + fetchdelay);
            if (bufferedFrag) {
                // we can flush buffer range following this one without stalling playback
                const nextBufferedFrag = this.followingBufferedFrag(bufferedFrag);
                if (nextBufferedFrag) {
                    // if we are here, we can also cancel any loading/demuxing in progress, as they are useless
                    this.abortCurrentFrag();
                    // start flush position is in next buffered frag. Leave some padding for non-independent segments and smoother playback.
                    const maxStart = nextBufferedFrag.maxStartPTS ? nextBufferedFrag.maxStartPTS : nextBufferedFrag.start;
                    const fragDuration = nextBufferedFrag.duration;
                    const startPts = Math.max(bufferedFrag.end, maxStart + Math.min(Math.max(fragDuration - this.config.maxFragLookUpTolerance, fragDuration * (this.couldBacktrack ? 0.5 : 0.125)), fragDuration * (this.couldBacktrack ? 0.75 : 0.25)));
                    this.flushMainBuffer(startPts, Number.POSITIVE_INFINITY);
                }
            }
        }
    }
    abortCurrentFrag() {
        const fragCurrent = this.fragCurrent;
        this.fragCurrent = null;
        this.backtrackFragment = null;
        if (fragCurrent) {
            fragCurrent.abortRequests();
            this.fragmentTracker.removeFragment(fragCurrent);
        }
        switch(this.state){
            case $b941786f4eb9cb76$var$State.KEY_LOADING:
            case $b941786f4eb9cb76$var$State.FRAG_LOADING:
            case $b941786f4eb9cb76$var$State.FRAG_LOADING_WAITING_RETRY:
            case $b941786f4eb9cb76$var$State.PARSING:
            case $b941786f4eb9cb76$var$State.PARSED:
                this.state = $b941786f4eb9cb76$var$State.IDLE;
                break;
        }
        this.nextLoadPosition = this.getLoadPosition();
    }
    flushMainBuffer(startOffset, endOffset) {
        super.flushMainBuffer(startOffset, endOffset, this.altAudio === 2 ? 'video' : null);
    }
    onMediaAttached(event, data) {
        super.onMediaAttached(event, data);
        const media = data.media;
        $b941786f4eb9cb76$var$addEventListener(media, 'playing', this.onMediaPlaying);
        $b941786f4eb9cb76$var$addEventListener(media, 'seeked', this.onMediaSeeked);
    }
    onMediaDetaching(event, data) {
        const { media: media } = this;
        if (media) {
            $b941786f4eb9cb76$var$removeEventListener(media, 'playing', this.onMediaPlaying);
            $b941786f4eb9cb76$var$removeEventListener(media, 'seeked', this.onMediaSeeked);
        }
        this.videoBuffer = null;
        this.fragPlaying = null;
        super.onMediaDetaching(event, data);
        const transferringMedia = !!data.transferMedia;
        if (transferringMedia) return;
        this._hasEnoughToStart = false;
    }
    onManifestLoading() {
        super.onManifestLoading();
        // reset buffer on manifest loading
        this.log('Trigger BUFFER_RESET');
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_RESET, undefined);
        this.couldBacktrack = false;
        this.fragLastKbps = 0;
        this.fragPlaying = this.backtrackFragment = null;
        this.altAudio = 0;
        this.audioOnly = false;
    }
    onManifestParsed(event, data) {
        // detect if we have different kind of audio codecs used amongst playlists
        let aac = false;
        let heaac = false;
        for(let i = 0; i < data.levels.length; i++){
            const codec = data.levels[i].audioCodec;
            if (codec) {
                aac = aac || codec.indexOf('mp4a.40.2') !== -1;
                heaac = heaac || codec.indexOf('mp4a.40.5') !== -1;
            }
        }
        this.audioCodecSwitch = aac && heaac && !$b941786f4eb9cb76$var$changeTypeSupported();
        if (this.audioCodecSwitch) this.log('Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC');
        this.levels = data.levels;
        this.startFragRequested = false;
    }
    onLevelLoading(event, data) {
        const { levels: levels } = this;
        if (!levels || this.state !== $b941786f4eb9cb76$var$State.IDLE) return;
        const level = data.levelInfo;
        if (!level.details || level.details.live && (this.levelLastLoaded !== level || level.details.expired) || this.waitForCdnTuneIn(level.details)) this.state = $b941786f4eb9cb76$var$State.WAITING_LEVEL;
    }
    onLevelLoaded(event, data) {
        var _curLevel$details;
        const { levels: levels, startFragRequested: startFragRequested } = this;
        const newLevelId = data.level;
        const newDetails = data.details;
        const duration = newDetails.totalduration;
        if (!levels) {
            this.warn(`Levels were reset while loading level ${newLevelId}`);
            return;
        }
        this.log(`Level ${newLevelId} loaded [${newDetails.startSN},${newDetails.endSN}]${newDetails.lastPartSn ? `[part-${newDetails.lastPartSn}-${newDetails.lastPartIndex}]` : ''}, cc [${newDetails.startCC}, ${newDetails.endCC}] duration:${duration}`);
        const curLevel = data.levelInfo;
        const fragCurrent = this.fragCurrent;
        if (fragCurrent && (this.state === $b941786f4eb9cb76$var$State.FRAG_LOADING || this.state === $b941786f4eb9cb76$var$State.FRAG_LOADING_WAITING_RETRY)) {
            if (fragCurrent.level !== data.level && fragCurrent.loader) this.abortCurrentFrag();
        }
        let sliding = 0;
        if (newDetails.live || (_curLevel$details = curLevel.details) != null && _curLevel$details.live) {
            var _this$levelLastLoaded;
            this.checkLiveUpdate(newDetails);
            if (newDetails.deltaUpdateFailed) return;
            sliding = this.alignPlaylists(newDetails, curLevel.details, (_this$levelLastLoaded = this.levelLastLoaded) == null ? void 0 : _this$levelLastLoaded.details);
        }
        // override level info
        curLevel.details = newDetails;
        this.levelLastLoaded = curLevel;
        if (!startFragRequested) this.setStartPosition(newDetails, sliding);
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_UPDATED, {
            details: newDetails,
            level: newLevelId
        });
        // only switch back to IDLE state if we were waiting for level to start downloading a new fragment
        if (this.state === $b941786f4eb9cb76$var$State.WAITING_LEVEL) {
            if (this.waitForCdnTuneIn(newDetails)) // Wait for Low-Latency CDN Tune-in
            return;
            this.state = $b941786f4eb9cb76$var$State.IDLE;
        }
        if (startFragRequested && newDetails.live) this.synchronizeToLiveEdge(newDetails);
        // trigger handler right now
        this.tick();
    }
    synchronizeToLiveEdge(levelDetails) {
        const { config: config, media: media } = this;
        if (!media) return;
        const liveSyncPosition = this.hls.liveSyncPosition;
        const currentTime = this.getLoadPosition();
        const start = levelDetails.fragmentStart;
        const end = levelDetails.edge;
        const withinSlidingWindow = currentTime >= start - config.maxFragLookUpTolerance && currentTime <= end;
        // Continue if we can seek forward to sync position or if current time is outside of sliding window
        if (liveSyncPosition !== null && media.duration > liveSyncPosition && (currentTime < liveSyncPosition || !withinSlidingWindow)) {
            // Continue if buffer is starving or if current time is behind max latency
            const maxLatency = config.liveMaxLatencyDuration !== undefined ? config.liveMaxLatencyDuration : config.liveMaxLatencyDurationCount * levelDetails.targetduration;
            if (!withinSlidingWindow && media.readyState < 4 || currentTime < end - maxLatency) {
                if (!this._hasEnoughToStart) this.nextLoadPosition = liveSyncPosition;
                // Only seek if ready and there is not a significant forward buffer available for playback
                if (media.readyState) {
                    this.warn(`Playback: ${currentTime.toFixed(3)} is located too far from the end of live sliding playlist: ${end}, reset currentTime to : ${liveSyncPosition.toFixed(3)}`);
                    if (this.config.liveSyncMode === 'buffered') {
                        var _bufferInfo$buffered;
                        const bufferInfo = $b941786f4eb9cb76$var$BufferHelper.bufferInfo(media, liveSyncPosition, 0);
                        if (!((_bufferInfo$buffered = bufferInfo.buffered) != null && _bufferInfo$buffered.length)) {
                            media.currentTime = liveSyncPosition;
                            return;
                        }
                        const isLiveSyncInBuffer = bufferInfo.start <= currentTime;
                        if (isLiveSyncInBuffer) {
                            media.currentTime = liveSyncPosition;
                            return;
                        }
                        const { nextStart: nextStart } = $b941786f4eb9cb76$var$BufferHelper.bufferedInfo(bufferInfo.buffered, currentTime, 0);
                        if (nextStart) media.currentTime = nextStart;
                    } else media.currentTime = liveSyncPosition;
                }
            }
        }
    }
    _handleFragmentLoadProgress(data) {
        var _frag$initSegment;
        const frag = data.frag;
        const { part: part, payload: payload } = data;
        const { levels: levels } = this;
        if (!levels) {
            this.warn(`Levels were reset while fragment load was in progress. Fragment ${frag.sn} of level ${frag.level} will not be buffered`);
            return;
        }
        const currentLevel = levels[frag.level];
        if (!currentLevel) {
            this.warn(`Level ${frag.level} not found on progress`);
            return;
        }
        const details = currentLevel.details;
        if (!details) {
            this.warn(`Dropping fragment ${frag.sn} of level ${frag.level} after level details were reset`);
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        const videoCodec = currentLevel.videoCodec;
        // time Offset is accurate if level PTS is known, or if playlist is not sliding (not live)
        const accurateTimeOffset = details.PTSKnown || !details.live;
        const initSegmentData = (_frag$initSegment = frag.initSegment) == null ? void 0 : _frag$initSegment.data;
        const audioCodec = this._getAudioCodec(currentLevel);
        // transmux the MPEG-TS data to ISO-BMFF segments
        // this.log(`Transmuxing ${frag.sn} of [${details.startSN} ,${details.endSN}],level ${frag.level}, cc ${frag.cc}`);
        const transmuxer = this.transmuxer = this.transmuxer || new $b941786f4eb9cb76$var$TransmuxerInterface(this.hls, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this));
        const partIndex = part ? part.index : -1;
        const partial = partIndex !== -1;
        const chunkMeta = new $b941786f4eb9cb76$export$ce0708ece532c9c(frag.level, frag.sn, frag.stats.chunkCount, payload.byteLength, partIndex, partial);
        const initPTS = this.initPTS[frag.cc];
        transmuxer.push(payload, initSegmentData, audioCodec, videoCodec, frag, part, details.totalduration, accurateTimeOffset, chunkMeta, initPTS);
    }
    onAudioTrackSwitching(event, data) {
        const hls = this.hls;
        // if any URL found on new audio track, it is an alternate audio track
        const fromAltAudio = this.altAudio !== 0;
        const altAudio = $b941786f4eb9cb76$var$useAlternateAudio(data.url, hls);
        // if we switch on main audio, ensure that main fragment scheduling is synced with media.buffered
        // don't do anything if we switch to alt audio: audio stream controller is handling it.
        // we will just have to change buffer scheduling on audioTrackSwitched
        if (!altAudio) {
            if (this.mediaBuffer !== this.media) {
                this.log('Switching on main audio, use media.buffered to schedule main fragment loading');
                this.mediaBuffer = this.media;
                const fragCurrent = this.fragCurrent;
                // we need to refill audio buffer from main: cancel any frag loading to speed up audio switch
                if (fragCurrent) {
                    this.log('Switching to main audio track, cancel main fragment load');
                    fragCurrent.abortRequests();
                    this.fragmentTracker.removeFragment(fragCurrent);
                }
                // destroy transmuxer to force init segment generation (following audio switch)
                this.resetTransmuxer();
                // switch to IDLE state to load new fragment
                this.resetLoadingState();
            } else if (this.audioOnly) // Reset audio transmuxer so when switching back to main audio we're not still appending where we left off
            this.resetTransmuxer();
            // If switching from alt to main audio, flush all audio and trigger track switched
            if (fromAltAudio) {
                this.altAudio = 0;
                this.fragmentTracker.removeAllFragments();
                hls.once($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHED, ()=>{
                    if (!this.hls) return;
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, data);
                });
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_FLUSHING, {
                    startOffset: 0,
                    endOffset: Number.POSITIVE_INFINITY,
                    type: null
                });
                return;
            }
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_SWITCHED, data);
        } else this.altAudio = 1;
    }
    onAudioTrackSwitched(event, data) {
        const altAudio = $b941786f4eb9cb76$var$useAlternateAudio(data.url, this.hls);
        if (altAudio) {
            const videoBuffer = this.videoBuffer;
            // if we switched on alternate audio, ensure that main fragment scheduling is synced with video sourcebuffer buffered
            if (videoBuffer && this.mediaBuffer !== videoBuffer) {
                this.log('Switching on alternate audio, use video.buffered to schedule main fragment loading');
                this.mediaBuffer = videoBuffer;
            }
        }
        this.altAudio = altAudio ? 2 : 0;
        this.tick();
    }
    onBufferCreated(event, data) {
        const tracks = data.tracks;
        let mediaTrack;
        let name;
        let alternate = false;
        for(const type in tracks){
            const track = tracks[type];
            if (track.id === 'main') {
                name = type;
                mediaTrack = track;
                // keep video source buffer reference
                if (type === 'video') {
                    const videoTrack = tracks[type];
                    if (videoTrack) this.videoBuffer = videoTrack.buffer;
                }
            } else alternate = true;
        }
        if (alternate && mediaTrack) {
            this.log(`Alternate track found, use ${name}.buffered to schedule main fragment loading`);
            this.mediaBuffer = mediaTrack.buffer;
        } else this.mediaBuffer = this.media;
    }
    onFragBuffered(event, data) {
        const { frag: frag, part: part } = data;
        const bufferedMainFragment = frag.type === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN;
        if (bufferedMainFragment) {
            if (this.fragContextChanged(frag)) {
                // If a level switch was requested while a fragment was buffering, it will emit the FRAG_BUFFERED event upon completion
                // Avoid setting state back to IDLE, since that will interfere with a level switch
                this.warn(`Fragment ${frag.sn}${part ? ' p: ' + part.index : ''} of level ${frag.level} finished buffering, but was aborted. state: ${this.state}`);
                if (this.state === $b941786f4eb9cb76$var$State.PARSED) this.state = $b941786f4eb9cb76$var$State.IDLE;
                return;
            }
            const stats = part ? part.stats : frag.stats;
            this.fragLastKbps = Math.round(8 * stats.total / (stats.buffering.end - stats.loading.first));
            if ($b941786f4eb9cb76$var$isMediaFragment(frag)) this.fragPrevious = frag;
            this.fragBufferedComplete(frag, part);
        }
        const media = this.media;
        if (!media) return;
        if (!this._hasEnoughToStart && $b941786f4eb9cb76$var$BufferHelper.getBuffered(media).length) {
            this._hasEnoughToStart = true;
            this.seekToStartPos();
        }
        if (bufferedMainFragment) this.tick();
    }
    get hasEnoughToStart() {
        return this._hasEnoughToStart;
    }
    onError(event, data) {
        var _data$context;
        if (data.fatal) {
            this.state = $b941786f4eb9cb76$var$State.ERROR;
            return;
        }
        switch(data.details){
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_GAP:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_PARSING_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_DECRYPT_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.FRAG_LOAD_TIMEOUT:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT:
                this.onFragmentOrKeyLoadError($b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN, data);
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_LOAD_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_PARSING_ERROR:
                // in case of non fatal error while loading level, if level controller is not retrying to load level, switch back to IDLE
                if (!data.levelRetry && this.state === $b941786f4eb9cb76$var$State.WAITING_LEVEL && ((_data$context = data.context) == null ? void 0 : _data$context.type) === $b941786f4eb9cb76$var$PlaylistContextType.LEVEL) this.state = $b941786f4eb9cb76$var$State.IDLE;
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_ADD_CODEC_ERROR:
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_APPEND_ERROR:
                if (data.parent !== 'main') return;
                if (this.reduceLengthAndFlushBuffer(data)) this.resetLoadingState();
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.BUFFER_FULL_ERROR:
                if (data.parent !== 'main') return;
                if (this.reduceLengthAndFlushBuffer(data)) {
                    const isAssetPlayer = !this.config.interstitialsController && this.config.assetPlayerId;
                    if (isAssetPlayer) // Use currentTime in buffer estimate to prevent loading more until playback advances
                    this._hasEnoughToStart = true;
                    else this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
                }
                break;
            case $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_EXCEPTION:
                this.recoverWorkerError(data);
                break;
        }
    }
    onFragLoadEmergencyAborted() {
        this.state = $b941786f4eb9cb76$var$State.IDLE;
        // if loadedmetadata is not set, it means that we are emergency switch down on first frag
        // in that case, reset startFragRequested flag
        if (!this._hasEnoughToStart) {
            this.startFragRequested = false;
            this.nextLoadPosition = this.lastCurrentTime;
        }
        this.tickImmediate();
    }
    onBufferFlushed(event, { type: type }) {
        if (type !== $b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO || !this.altAudio) {
            const mediaBuffer = (type === $b941786f4eb9cb76$var$ElementaryStreamTypes.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
            if (mediaBuffer) {
                this.afterBufferFlushed(mediaBuffer, type, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
                this.tick();
            }
        }
    }
    onLevelsUpdated(event, data) {
        if (this.level > -1 && this.fragCurrent) {
            this.level = this.fragCurrent.level;
            if (this.level === -1) this.resetWhenMissingContext(this.fragCurrent);
        }
        this.levels = data.levels;
    }
    swapAudioCodec() {
        this.audioCodecSwap = !this.audioCodecSwap;
    }
    /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */ seekToStartPos() {
        const { media: media } = this;
        if (!media) return;
        const currentTime = media.currentTime;
        let startPosition = this.startPosition;
        // only adjust currentTime if different from startPosition or if startPosition not buffered
        // at that stage, there should be only one buffered range, as we reach that code after first fragment has been buffered
        if (startPosition >= 0 && currentTime < startPosition) {
            if (media.seeking) {
                this.log(`could not seek to ${startPosition}, already seeking at ${currentTime}`);
                return;
            }
            // Offset start position by timeline offset
            const timelineOffset = this.timelineOffset;
            if (timelineOffset && startPosition) startPosition += timelineOffset;
            const details = this.getLevelDetails();
            const buffered = $b941786f4eb9cb76$var$BufferHelper.getBuffered(media);
            const bufferStart = buffered.length ? buffered.start(0) : 0;
            const delta = bufferStart - startPosition;
            const skipTolerance = Math.max(this.config.maxBufferHole, this.config.maxFragLookUpTolerance);
            if (this.config.startOnSegmentBoundary || delta > 0 && (delta < skipTolerance || this.loadingParts && delta < 2 * ((details == null ? void 0 : details.partTarget) || 0))) {
                this.log(`adjusting start position by ${delta} to match buffer start`);
                startPosition += delta;
                this.startPosition = startPosition;
            }
            if (currentTime < startPosition) {
                this.log(`seek to target start position ${startPosition} from current time ${currentTime} buffer start ${bufferStart}`);
                media.currentTime = startPosition;
            }
        }
    }
    _getAudioCodec(currentLevel) {
        let audioCodec = this.config.defaultAudioCodec || currentLevel.audioCodec;
        if (this.audioCodecSwap && audioCodec) {
            this.log('Swapping audio codec');
            if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
            else audioCodec = 'mp4a.40.5';
        }
        return audioCodec;
    }
    _loadBitrateTestFrag(fragment, level) {
        fragment.bitrateTest = true;
        this._doFragLoad(fragment, level).then((data)=>{
            const { hls: hls } = this;
            const frag = data == null ? void 0 : data.frag;
            if (!frag || this.fragContextChanged(frag)) return;
            level.fragmentError = 0;
            this.state = $b941786f4eb9cb76$var$State.IDLE;
            this.startFragRequested = false;
            this.bitrateTest = false;
            const stats = frag.stats;
            // Bitrate tests fragments are neither parsed nor buffered
            stats.parsing.start = stats.parsing.end = stats.buffering.start = stats.buffering.end = self.performance.now();
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_LOADED, data);
            frag.bitrateTest = false;
        }).catch((reason)=>{
            if (this.state === $b941786f4eb9cb76$var$State.STOPPED || this.state === $b941786f4eb9cb76$var$State.ERROR) return;
            this.warn(reason);
            this.resetFragmentLoading(fragment);
        });
    }
    _handleTransmuxComplete(transmuxResult) {
        const id = this.playlistType;
        const { hls: hls } = this;
        const { remuxResult: remuxResult, chunkMeta: chunkMeta } = transmuxResult;
        const context = this.getCurrentContext(chunkMeta);
        if (!context) {
            this.resetWhenMissingContext(chunkMeta);
            return;
        }
        const { frag: frag, part: part, level: level } = context;
        const { video: video, text: text, id3: id3, initSegment: initSegment } = remuxResult;
        const { details: details } = level;
        // The audio-stream-controller handles audio buffering if Hls.js is playing an alternate audio track
        const audio = this.altAudio ? undefined : remuxResult.audio;
        // Check if the current fragment has been aborted. We check this by first seeing if we're still playing the current level.
        // If we are, subsequently check if the currently loading fragment (fragCurrent) has changed.
        if (this.fragContextChanged(frag)) {
            this.fragmentTracker.removeFragment(frag);
            return;
        }
        this.state = $b941786f4eb9cb76$var$State.PARSING;
        if (initSegment) {
            const tracks = initSegment.tracks;
            if (tracks) {
                const mapFragment = frag.initSegment || frag;
                if (this.unhandledEncryptionError(initSegment, frag)) return;
                this._bufferInitSegment(level, tracks, mapFragment, chunkMeta);
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_INIT_SEGMENT, {
                    frag: mapFragment,
                    id: id,
                    tracks: tracks
                });
            }
            const baseTime = initSegment.initPTS;
            const timescale = initSegment.timescale;
            const initPTS = this.initPTS[frag.cc];
            if ($b941786f4eb9cb76$var$isFiniteNumber(baseTime) && (!initPTS || initPTS.baseTime !== baseTime || initPTS.timescale !== timescale)) {
                const trackId = initSegment.trackId;
                this.initPTS[frag.cc] = {
                    baseTime: baseTime,
                    timescale: timescale,
                    trackId: trackId
                };
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.INIT_PTS_FOUND, {
                    frag: frag,
                    id: id,
                    initPTS: baseTime,
                    timescale: timescale,
                    trackId: trackId
                });
            }
        }
        // Avoid buffering if backtracking this fragment
        if (video && details) {
            if (audio && video.type === 'audiovideo') this.logMuxedErr(frag);
            const prevFrag = details.fragments[frag.sn - 1 - details.startSN];
            const isFirstFragment = frag.sn === details.startSN;
            const isFirstInDiscontinuity = !prevFrag || frag.cc > prevFrag.cc;
            if (remuxResult.independent !== false) {
                const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = video;
                if (part) part.elementaryStreams[video.type] = {
                    startPTS: startPTS,
                    endPTS: endPTS,
                    startDTS: startDTS,
                    endDTS: endDTS
                };
                else {
                    if (video.firstKeyFrame && video.independent && chunkMeta.id === 1 && !isFirstInDiscontinuity) this.couldBacktrack = true;
                    if (video.dropped && video.independent) {
                        // Backtrack if dropped frames create a gap after currentTime
                        const bufferInfo = this.getMainFwdBufferInfo();
                        const targetBufferTime = (bufferInfo ? bufferInfo.end : this.getLoadPosition()) + this.config.maxBufferHole;
                        const startTime = video.firstKeyFramePTS ? video.firstKeyFramePTS : startPTS;
                        if (!isFirstFragment && targetBufferTime < startTime - this.config.maxBufferHole && !isFirstInDiscontinuity) {
                            this.backtrack(frag);
                            return;
                        } else if (isFirstInDiscontinuity) // Mark segment with a gap to avoid loop loading
                        frag.gap = true;
                        // Set video stream start to fragment start so that truncated samples do not distort the timeline, and mark it partial
                        frag.setElementaryStreamInfo(video.type, frag.start, endPTS, frag.start, endDTS, true);
                    } else if (isFirstFragment && startPTS - (details.appliedTimelineOffset || 0) > $b941786f4eb9cb76$var$MAX_START_GAP_JUMP) // Mark segment with a gap to skip large start gap
                    frag.gap = true;
                }
                frag.setElementaryStreamInfo(video.type, startPTS, endPTS, startDTS, endDTS);
                if (this.backtrackFragment) this.backtrackFragment = frag;
                this.bufferFragmentData(video, frag, part, chunkMeta, isFirstFragment || isFirstInDiscontinuity);
            } else if (isFirstFragment || isFirstInDiscontinuity) // Mark segment with a gap to avoid loop loading
            frag.gap = true;
            else {
                this.backtrack(frag);
                return;
            }
        }
        if (audio) {
            const { startPTS: startPTS, endPTS: endPTS, startDTS: startDTS, endDTS: endDTS } = audio;
            if (part) part.elementaryStreams[$b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO] = {
                startPTS: startPTS,
                endPTS: endPTS,
                startDTS: startDTS,
                endDTS: endDTS
            };
            frag.setElementaryStreamInfo($b941786f4eb9cb76$var$ElementaryStreamTypes.AUDIO, startPTS, endPTS, startDTS, endDTS);
            this.bufferFragmentData(audio, frag, part, chunkMeta);
        }
        if (details && id3 != null && id3.samples.length) {
            const emittedID3 = {
                id: id,
                frag: frag,
                details: details,
                samples: id3.samples
            };
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_METADATA, emittedID3);
        }
        if (details && text) {
            const emittedText = {
                id: id,
                frag: frag,
                details: details,
                samples: text.samples
            };
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_PARSING_USERDATA, emittedText);
        }
    }
    logMuxedErr(frag) {
        this.warn(`${$b941786f4eb9cb76$var$isMediaFragment(frag) ? 'Media' : 'Init'} segment with muxed audiovideo where only video expected: ${frag.url}`);
    }
    _bufferInitSegment(currentLevel, tracks, frag, chunkMeta) {
        if (this.state !== $b941786f4eb9cb76$var$State.PARSING) return;
        this.audioOnly = !!tracks.audio && !tracks.video;
        // if audio track is expected to come from audio stream controller, discard any coming from main
        if (this.altAudio && !this.audioOnly) {
            delete tracks.audio;
            if (tracks.audiovideo) this.logMuxedErr(frag);
        }
        // include levelCodec in audio and video tracks
        const { audio: audio, video: video, audiovideo: audiovideo } = tracks;
        if (audio) {
            const levelCodec = currentLevel.audioCodec;
            let audioCodec = $b941786f4eb9cb76$var$pickMostCompleteCodecName(audio.codec, levelCodec);
            // Add level and profile to make up for remuxer not being able to parse full codec
            // (logger warning "Unhandled audio codec...")
            if (audioCodec === 'mp4a') audioCodec = 'mp4a.40.5';
            // Handle `audioCodecSwitch`
            const ua = navigator.userAgent.toLowerCase();
            if (this.audioCodecSwitch) {
                if (audioCodec) {
                    if (audioCodec.indexOf('mp4a.40.5') !== -1) audioCodec = 'mp4a.40.2';
                    else audioCodec = 'mp4a.40.5';
                }
                // In the case that AAC and HE-AAC audio codecs are signalled in manifest,
                // force HE-AAC, as it seems that most browsers prefers it.
                // don't force HE-AAC if mono stream, or in Firefox
                const audioMetadata = audio.metadata;
                if (audioMetadata && 'channelCount' in audioMetadata && (audioMetadata.channelCount || 1) !== 1 && ua.indexOf('firefox') === -1) audioCodec = 'mp4a.40.5';
            }
            // HE-AAC is broken on Android, always signal audio codec as AAC even if variant manifest states otherwise
            if (audioCodec && audioCodec.indexOf('mp4a.40.5') !== -1 && ua.indexOf('android') !== -1 && audio.container !== 'audio/mpeg') {
                // Exclude mpeg audio
                audioCodec = 'mp4a.40.2';
                this.log(`Android: force audio codec to ${audioCodec}`);
            }
            if (levelCodec && levelCodec !== audioCodec) this.log(`Swapping manifest audio codec "${levelCodec}" for "${audioCodec}"`);
            audio.levelCodec = audioCodec;
            audio.id = $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN;
            this.log(`Init audio buffer, container:${audio.container}, codecs[selected/level/parsed]=[${audioCodec || ''}/${levelCodec || ''}/${audio.codec}]`);
            delete tracks.audiovideo;
        }
        if (video) {
            video.levelCodec = currentLevel.videoCodec;
            video.id = $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN;
            const parsedVideoCodec = video.codec;
            if ((parsedVideoCodec == null ? void 0 : parsedVideoCodec.length) === 4) // Make up for passthrough-remuxer not being able to parse full codec
            // (logger warning "Unhandled video codec...")
            switch(parsedVideoCodec){
                case 'hvc1':
                case 'hev1':
                    video.codec = 'hvc1.1.6.L120.90';
                    break;
                case 'av01':
                    video.codec = 'av01.0.04M.08';
                    break;
                case 'avc1':
                    video.codec = 'avc1.42e01e';
                    break;
            }
            this.log(`Init video buffer, container:${video.container}, codecs[level/parsed]=[${currentLevel.videoCodec || ''}/${parsedVideoCodec}]${video.codec !== parsedVideoCodec ? ' parsed-corrected=' + video.codec : ''}${video.supplemental ? ' supplemental=' + video.supplemental : ''}`);
            delete tracks.audiovideo;
        }
        if (audiovideo) {
            this.log(`Init audiovideo buffer, container:${audiovideo.container}, codecs[level/parsed]=[${currentLevel.codecs}/${audiovideo.codec}]`);
            delete tracks.video;
            delete tracks.audio;
        }
        const trackTypes = Object.keys(tracks);
        if (trackTypes.length) {
            this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_CODECS, tracks);
            if (!this.hls) // Exit after fatal tracks error
            return;
            // loop through tracks that are going to be provided to bufferController
            trackTypes.forEach((trackName)=>{
                const track = tracks[trackName];
                const initSegment = track.initSegment;
                if (initSegment != null && initSegment.byteLength) this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.BUFFER_APPENDING, {
                    type: trackName,
                    data: initSegment,
                    frag: frag,
                    part: null,
                    chunkMeta: chunkMeta,
                    parent: frag.type
                });
            });
        }
        // trigger handler right now
        this.tickImmediate();
    }
    getMainFwdBufferInfo() {
        // Observe video SourceBuffer (this.mediaBuffer) only when alt-audio is used, otherwise observe combined media buffer
        const bufferOutput = this.mediaBuffer && this.altAudio === 2 ? this.mediaBuffer : this.media;
        return this.getFwdBufferInfo(bufferOutput, $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN);
    }
    get maxBufferLength() {
        const { levels: levels, level: level } = this;
        const levelInfo = levels == null ? void 0 : levels[level];
        if (!levelInfo) return this.config.maxBufferLength;
        return this.getMaxBufferLength(levelInfo.maxBitrate);
    }
    backtrack(frag) {
        this.couldBacktrack = true;
        // Causes findFragments to backtrack through fragments to find the keyframe
        this.backtrackFragment = frag;
        this.resetTransmuxer();
        this.flushBufferGap(frag);
        this.fragmentTracker.removeFragment(frag);
        this.fragPrevious = null;
        this.nextLoadPosition = frag.start;
        this.state = $b941786f4eb9cb76$var$State.IDLE;
    }
    checkFragmentChanged() {
        const video = this.media;
        let fragPlayingCurrent = null;
        if (video && video.readyState > 1 && video.seeking === false) {
            const currentTime = video.currentTime;
            /* if video element is in seeked state, currentTime can only increase.
        (assuming that playback rate is positive ...)
        As sometimes currentTime jumps back to zero after a
        media decode error, check this, to avoid seeking back to
        wrong position after a media decode error
      */ if ($b941786f4eb9cb76$var$BufferHelper.isBuffered(video, currentTime)) fragPlayingCurrent = this.getAppendedFrag(currentTime);
            else if ($b941786f4eb9cb76$var$BufferHelper.isBuffered(video, currentTime + 0.1)) /* ensure that FRAG_CHANGED event is triggered at startup,
          when first video frame is displayed and playback is paused.
          add a tolerance of 100ms, in case current position is not buffered,
          check if current pos+100ms is buffered and use that buffer range
          for FRAG_CHANGED event reporting */ fragPlayingCurrent = this.getAppendedFrag(currentTime + 0.1);
            if (fragPlayingCurrent) {
                this.backtrackFragment = null;
                const fragPlaying = this.fragPlaying;
                const fragCurrentLevel = fragPlayingCurrent.level;
                if (!fragPlaying || fragPlayingCurrent.sn !== fragPlaying.sn || fragPlaying.level !== fragCurrentLevel) {
                    this.fragPlaying = fragPlayingCurrent;
                    this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.FRAG_CHANGED, {
                        frag: fragPlayingCurrent
                    });
                    if (!fragPlaying || fragPlaying.level !== fragCurrentLevel) this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_SWITCHED, {
                        level: fragCurrentLevel
                    });
                }
            }
        }
    }
    get nextLevel() {
        const frag = this.nextBufferedFrag;
        if (frag) return frag.level;
        return -1;
    }
    get currentFrag() {
        var _this$media2;
        if (this.fragPlaying) return this.fragPlaying;
        const currentTime = ((_this$media2 = this.media) == null ? void 0 : _this$media2.currentTime) || this.lastCurrentTime;
        if ($b941786f4eb9cb76$var$isFiniteNumber(currentTime)) return this.getAppendedFrag(currentTime);
        return null;
    }
    get currentProgramDateTime() {
        var _this$media3;
        const currentTime = ((_this$media3 = this.media) == null ? void 0 : _this$media3.currentTime) || this.lastCurrentTime;
        if ($b941786f4eb9cb76$var$isFiniteNumber(currentTime)) {
            const details = this.getLevelDetails();
            const frag = this.currentFrag || (details ? $b941786f4eb9cb76$var$findFragmentByPTS(null, details.fragments, currentTime) : null);
            if (frag) {
                const programDateTime = frag.programDateTime;
                if (programDateTime !== null) {
                    const epocMs = programDateTime + (currentTime - frag.start) * 1000;
                    return new Date(epocMs);
                }
            }
        }
        return null;
    }
    get currentLevel() {
        const frag = this.currentFrag;
        if (frag) return frag.level;
        return -1;
    }
    get nextBufferedFrag() {
        const frag = this.currentFrag;
        if (frag) return this.followingBufferedFrag(frag);
        return null;
    }
    get forceStartLoad() {
        return this._forceStartLoad;
    }
}
class $b941786f4eb9cb76$var$KeyLoader extends $b941786f4eb9cb76$var$Logger {
    constructor(config, logger){
        super('key-loader', logger);
        this.config = void 0;
        this.keyIdToKeyInfo = {};
        this.emeController = null;
        this.config = config;
    }
    abort(type) {
        for(const id in this.keyIdToKeyInfo){
            const loader = this.keyIdToKeyInfo[id].loader;
            if (loader) {
                var _loader$context;
                if (type && type !== ((_loader$context = loader.context) == null ? void 0 : _loader$context.frag.type)) return;
                loader.abort();
            }
        }
    }
    detach() {
        for(const id in this.keyIdToKeyInfo){
            const keyInfo = this.keyIdToKeyInfo[id];
            // Remove cached EME keys on detach
            if (keyInfo.mediaKeySessionContext || keyInfo.decryptdata.isCommonEncryption) delete this.keyIdToKeyInfo[id];
        }
    }
    destroy() {
        this.detach();
        for(const id in this.keyIdToKeyInfo){
            const loader = this.keyIdToKeyInfo[id].loader;
            if (loader) loader.destroy();
        }
        this.keyIdToKeyInfo = {};
    }
    createKeyLoadError(frag, details = $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR, error, networkDetails, response) {
        return new $b941786f4eb9cb76$var$LoadError({
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: details,
            fatal: false,
            frag: frag,
            response: response,
            error: error,
            networkDetails: networkDetails
        });
    }
    loadClear(loadingFrag, encryptedFragments, startFragRequested) {
        if (this.emeController && this.config.emeEnabled && !this.emeController.getSelectedKeySystemFormats().length) {
            // Access key-system with nearest key on start (loading frag is unencrypted)
            if (encryptedFragments.length) for(let i = 0, l = encryptedFragments.length; i < l; i++){
                const frag = encryptedFragments[i];
                // Loading at or before segment with EXT-X-KEY, or first frag loading and last EXT-X-KEY
                if (loadingFrag.cc <= frag.cc && (!$b941786f4eb9cb76$var$isMediaFragment(loadingFrag) || !$b941786f4eb9cb76$var$isMediaFragment(frag) || loadingFrag.sn < frag.sn) || !startFragRequested && i == l - 1) return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
                    if (!this.emeController) return;
                    frag.setKeyFormat(keySystemFormat);
                    const keySystem = $b941786f4eb9cb76$var$keySystemFormatToKeySystemDomain(keySystemFormat);
                    if (keySystem) return this.emeController.getKeySystemAccess([
                        keySystem
                    ]);
                });
            }
            if (this.config.requireKeySystemAccessOnStart) {
                const keySystemsInConfig = $b941786f4eb9cb76$var$getKeySystemsForConfig(this.config);
                if (keySystemsInConfig.length) return this.emeController.getKeySystemAccess(keySystemsInConfig);
            }
        }
        return null;
    }
    load(frag) {
        if (!frag.decryptdata && frag.encrypted && this.emeController && this.config.emeEnabled) // Multiple keys, but none selected, resolve in eme-controller
        return this.emeController.selectKeySystemFormat(frag).then((keySystemFormat)=>{
            return this.loadInternal(frag, keySystemFormat);
        });
        return this.loadInternal(frag);
    }
    loadInternal(frag, keySystemFormat) {
        var _keyInfo, _keyInfo2;
        if (keySystemFormat) frag.setKeyFormat(keySystemFormat);
        const decryptdata = frag.decryptdata;
        if (!decryptdata) {
            const error = new Error(keySystemFormat ? `Expected frag.decryptdata to be defined after setting format ${keySystemFormat}` : `Missing decryption data on fragment in onKeyLoading (emeEnabled with controller: ${this.emeController && this.config.emeEnabled})`);
            return Promise.reject(this.createKeyLoadError(frag, $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR, error));
        }
        const uri = decryptdata.uri;
        if (!uri) return Promise.reject(this.createKeyLoadError(frag, $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${uri}"`)));
        const id = $b941786f4eb9cb76$var$getKeyId(decryptdata);
        let keyInfo = this.keyIdToKeyInfo[id];
        if ((_keyInfo = keyInfo) != null && _keyInfo.decryptdata.key) {
            decryptdata.key = keyInfo.decryptdata.key;
            return Promise.resolve({
                frag: frag,
                keyInfo: keyInfo
            });
        }
        // Return key load promise once it has a mediakey session with an usable key status
        if (this.emeController && (_keyInfo2 = keyInfo) != null && _keyInfo2.keyLoadPromise) {
            const keyStatus = this.emeController.getKeyStatus(keyInfo.decryptdata);
            switch(keyStatus){
                case 'usable':
                case 'usable-in-future':
                    return keyInfo.keyLoadPromise.then((keyLoadedData)=>{
                        // Return the correct fragment with updated decryptdata key and loaded keyInfo
                        const { keyInfo: keyInfo } = keyLoadedData;
                        decryptdata.key = keyInfo.decryptdata.key;
                        return {
                            frag: frag,
                            keyInfo: keyInfo
                        };
                    });
            }
        // If we have a key session and status and it is not pending or usable, continue
        // This will go back to the eme-controller for expired keys to get a new keyLoadPromise
        }
        // Load the key or return the loading promise
        this.log(`${this.keyIdToKeyInfo[id] ? 'Rel' : 'L'}oading${decryptdata.keyId ? ' keyId: ' + $b941786f4eb9cb76$var$arrayToHex(decryptdata.keyId) : ''} URI: ${decryptdata.uri} from ${frag.type} ${frag.level}`);
        keyInfo = this.keyIdToKeyInfo[id] = {
            decryptdata: decryptdata,
            keyLoadPromise: null,
            loader: null,
            mediaKeySessionContext: null
        };
        switch(decryptdata.method){
            case 'SAMPLE-AES':
            case 'SAMPLE-AES-CENC':
            case 'SAMPLE-AES-CTR':
                if (decryptdata.keyFormat === 'identity') // loadKeyHTTP handles http(s) and data URLs
                return this.loadKeyHTTP(keyInfo, frag);
                return this.loadKeyEME(keyInfo, frag);
            case 'AES-128':
            case 'AES-256':
            case 'AES-256-CTR':
                return this.loadKeyHTTP(keyInfo, frag);
            default:
                return Promise.reject(this.createKeyLoadError(frag, $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${decryptdata.method}"`)));
        }
    }
    loadKeyEME(keyInfo, frag) {
        const keyLoadedData = {
            frag: frag,
            keyInfo: keyInfo
        };
        if (this.emeController && this.config.emeEnabled) {
            var _frag$initSegment;
            if (!keyInfo.decryptdata.keyId && (_frag$initSegment = frag.initSegment) != null && _frag$initSegment.data) {
                const keyIds = $b941786f4eb9cb76$var$parseKeyIdsFromTenc(frag.initSegment.data);
                if (keyIds.length) {
                    let keyId = keyIds[0];
                    if (keyId.some((b)=>b !== 0)) {
                        this.log(`Using keyId found in init segment ${$b941786f4eb9cb76$var$arrayToHex(keyId)}`);
                        $b941786f4eb9cb76$export$ca24892a09b21f29.setKeyIdForUri(keyInfo.decryptdata.uri, keyId);
                    } else {
                        keyId = $b941786f4eb9cb76$export$ca24892a09b21f29.addKeyIdForUri(keyInfo.decryptdata.uri);
                        this.log(`Generating keyId to patch media ${$b941786f4eb9cb76$var$arrayToHex(keyId)}`);
                    }
                    keyInfo.decryptdata.keyId = keyId;
                }
            }
            if (!keyInfo.decryptdata.keyId && !$b941786f4eb9cb76$var$isMediaFragment(frag)) // Resolve so that unencrypted init segment is loaded
            // key id is extracted from tenc box when processing key for next segment above
            return Promise.resolve(keyLoadedData);
            const keySessionContextPromise = this.emeController.loadKey(keyLoadedData);
            return (keyInfo.keyLoadPromise = keySessionContextPromise.then((keySessionContext)=>{
                keyInfo.mediaKeySessionContext = keySessionContext;
                return keyLoadedData;
            })).catch((error)=>{
                // Remove promise for license renewal or retry
                keyInfo.keyLoadPromise = null;
                if ('data' in error) error.data.frag = frag;
                throw error;
            });
        }
        return Promise.resolve(keyLoadedData);
    }
    loadKeyHTTP(keyInfo, frag) {
        const config = this.config;
        const Loader = config.loader;
        const keyLoader = new Loader(config);
        frag.keyLoader = keyInfo.loader = keyLoader;
        return keyInfo.keyLoadPromise = new Promise((resolve, reject)=>{
            const loaderContext = {
                keyInfo: keyInfo,
                frag: frag,
                responseType: 'arraybuffer',
                url: keyInfo.decryptdata.uri
            };
            // maxRetry is 0 so that instead of retrying the same key on the same variant multiple times,
            // key-loader will trigger an error and rely on stream-controller to handle retry logic.
            // this will also align retry logic with fragment-loader
            const loadPolicy = config.keyLoadPolicy.default;
            const loaderConfig = {
                loadPolicy: loadPolicy,
                timeout: loadPolicy.maxLoadTimeMs,
                maxRetry: 0,
                retryDelay: 0,
                maxRetryDelay: 0
            };
            const loaderCallbacks = {
                onSuccess: (response, stats, context, networkDetails)=>{
                    const { frag: frag, keyInfo: keyInfo } = context;
                    const id = $b941786f4eb9cb76$var$getKeyId(keyInfo.decryptdata);
                    if (!frag.decryptdata || keyInfo !== this.keyIdToKeyInfo[id]) return reject(this.createKeyLoadError(frag, $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error('after key load, decryptdata unset or changed'), networkDetails));
                    keyInfo.decryptdata.key = frag.decryptdata.key = new Uint8Array(response.data);
                    // detach fragment key loader on load success
                    frag.keyLoader = null;
                    keyInfo.loader = null;
                    resolve({
                        frag: frag,
                        keyInfo: keyInfo
                    });
                },
                onError: (response, context, networkDetails, stats)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_ERROR, new Error(`HTTP Error ${response.code} loading key ${response.text}`), networkDetails, $b941786f4eb9cb76$var$_objectSpread2({
                        url: loaderContext.url,
                        data: undefined
                    }, response)));
                },
                onTimeout: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $b941786f4eb9cb76$export$d053ec805ce391aa.KEY_LOAD_TIMEOUT, new Error('key loading timed out'), networkDetails));
                },
                onAbort: (stats, context, networkDetails)=>{
                    this.resetLoader(context);
                    reject(this.createKeyLoadError(frag, $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_ABORTED, new Error('key loading aborted'), networkDetails));
                }
            };
            keyLoader.load(loaderContext, loaderConfig, loaderCallbacks);
        });
    }
    resetLoader(context) {
        const { frag: frag, keyInfo: keyInfo, url: uri } = context;
        const loader = keyInfo.loader;
        if (frag.keyLoader === loader) {
            frag.keyLoader = null;
            keyInfo.loader = null;
        }
        const id = $b941786f4eb9cb76$var$getKeyId(keyInfo.decryptdata) || uri;
        delete this.keyIdToKeyInfo[id];
        if (loader) loader.destroy();
    }
}
function $b941786f4eb9cb76$var$getKeyId(decryptdata) {
    if (decryptdata.keyFormat !== $b941786f4eb9cb76$export$adbe91680a33e4e2.FAIRPLAY) {
        const keyId = decryptdata.keyId;
        if (keyId) return $b941786f4eb9cb76$var$arrayToHex(keyId);
    }
    return decryptdata.uri;
}
function $b941786f4eb9cb76$var$mapContextToLevelType(context) {
    const { type: type } = context;
    switch(type){
        case $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK:
            return $b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO;
        case $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK:
            return $b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE;
        default:
            return $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN;
    }
}
function $b941786f4eb9cb76$var$getResponseUrl(response, context) {
    let url = response.url;
    // responseURL not supported on some browsers (it is used to detect URL redirection)
    // data-uri mode also not supported (but no need to detect redirection)
    if (url === undefined || url.indexOf('data:') === 0) // fallback to initial URL
    url = context.url;
    return url;
}
class $b941786f4eb9cb76$var$PlaylistLoader {
    constructor(hls){
        this.hls = void 0;
        this.loaders = Object.create(null);
        this.variableList = null;
        this.onManifestLoaded = this.checkAutostartLoad;
        this.hls = hls;
        this.registerListeners();
    }
    startLoad(startPosition) {}
    stopLoad() {
        this.destroyInternalLoaders();
    }
    registerListeners() {
        const { hls: hls } = this;
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
        hls.on($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
    }
    unregisterListeners() {
        const { hls: hls } = this;
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, this.onManifestLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADING, this.onLevelLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this);
        hls.off($b941786f4eb9cb76$export$ada873a34909da65.LEVELS_UPDATED, this.onLevelsUpdated, this);
    }
    /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */ createInternalLoader(context) {
        const config = this.hls.config;
        const PLoader = config.pLoader;
        const Loader = config.loader;
        const InternalLoader = PLoader || Loader;
        const loader = new InternalLoader(config);
        this.loaders[context.type] = loader;
        return loader;
    }
    getInternalLoader(context) {
        return this.loaders[context.type];
    }
    resetInternalLoader(contextType) {
        if (this.loaders[contextType]) delete this.loaders[contextType];
    }
    /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */ destroyInternalLoaders() {
        for(const contextType in this.loaders){
            const loader = this.loaders[contextType];
            if (loader) loader.destroy();
            this.resetInternalLoader(contextType);
        }
    }
    destroy() {
        this.variableList = null;
        this.unregisterListeners();
        this.destroyInternalLoaders();
    }
    onManifestLoading(event, data) {
        const { url: url } = data;
        this.variableList = null;
        this.load({
            id: null,
            level: 0,
            responseType: 'text',
            type: $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST,
            url: url,
            deliveryDirectives: null,
            levelOrTrack: null
        });
    }
    onLevelLoading(event, data) {
        const { id: id, level: level, pathwayId: pathwayId, url: url, deliveryDirectives: deliveryDirectives, levelInfo: levelInfo } = data;
        this.load({
            id: id,
            level: level,
            pathwayId: pathwayId,
            responseType: 'text',
            type: $b941786f4eb9cb76$var$PlaylistContextType.LEVEL,
            url: url,
            deliveryDirectives: deliveryDirectives,
            levelOrTrack: levelInfo
        });
    }
    onAudioTrackLoading(event, data) {
        const { id: id, groupId: groupId, url: url, deliveryDirectives: deliveryDirectives, track: track } = data;
        this.load({
            id: id,
            groupId: groupId,
            level: null,
            responseType: 'text',
            type: $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK,
            url: url,
            deliveryDirectives: deliveryDirectives,
            levelOrTrack: track
        });
    }
    onSubtitleTrackLoading(event, data) {
        const { id: id, groupId: groupId, url: url, deliveryDirectives: deliveryDirectives, track: track } = data;
        this.load({
            id: id,
            groupId: groupId,
            level: null,
            responseType: 'text',
            type: $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK,
            url: url,
            deliveryDirectives: deliveryDirectives,
            levelOrTrack: track
        });
    }
    onLevelsUpdated(event, data) {
        // abort and delete loader of removed levels
        const loader = this.loaders[$b941786f4eb9cb76$var$PlaylistContextType.LEVEL];
        if (loader) {
            const context = loader.context;
            if (context && !data.levels.some((lvl)=>lvl === context.levelOrTrack)) {
                loader.abort();
                delete this.loaders[$b941786f4eb9cb76$var$PlaylistContextType.LEVEL];
            }
        }
    }
    load(context) {
        var _context$deliveryDire;
        const config = this.hls.config;
        // logger.debug(`[playlist-loader]: Loading playlist of type ${context.type}, level: ${context.level}, id: ${context.id}`);
        // Check if a loader for this context already exists
        let loader = this.getInternalLoader(context);
        if (loader) {
            const logger = this.hls.logger;
            const loaderContext = loader.context;
            if (loaderContext && loaderContext.levelOrTrack === context.levelOrTrack && (loaderContext.url === context.url || loaderContext.deliveryDirectives && !context.deliveryDirectives)) {
                // same URL can't overlap, or wait for blocking request
                if (loaderContext.url === context.url) logger.log(`[playlist-loader]: ignore ${context.url} ongoing request`);
                else logger.log(`[playlist-loader]: ignore ${context.url} in favor of ${loaderContext.url}`);
                return;
            }
            logger.log(`[playlist-loader]: aborting previous loader for type: ${context.type}`);
            loader.abort();
        }
        // apply different configs for retries depending on
        // context (manifest, level, audio/subs playlist)
        let loadPolicy;
        if (context.type === $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST) loadPolicy = config.manifestLoadPolicy.default;
        else loadPolicy = $b941786f4eb9cb76$var$_extends({}, config.playlistLoadPolicy.default, {
            timeoutRetry: null,
            errorRetry: null
        });
        loader = this.createInternalLoader(context);
        // Override level/track timeout for LL-HLS requests
        // (the default of 10000ms is counter productive to blocking playlist reload requests)
        if ($b941786f4eb9cb76$var$isFiniteNumber((_context$deliveryDire = context.deliveryDirectives) == null ? void 0 : _context$deliveryDire.part)) {
            let levelDetails;
            if (context.type === $b941786f4eb9cb76$var$PlaylistContextType.LEVEL && context.level !== null) levelDetails = this.hls.levels[context.level].details;
            else if (context.type === $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK && context.id !== null) levelDetails = this.hls.audioTracks[context.id].details;
            else if (context.type === $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK && context.id !== null) levelDetails = this.hls.subtitleTracks[context.id].details;
            if (levelDetails) {
                const partTarget = levelDetails.partTarget;
                const targetDuration = levelDetails.targetduration;
                if (partTarget && targetDuration) {
                    const maxLowLatencyPlaylistRefresh = Math.max(partTarget * 3, targetDuration * 0.8) * 1000;
                    loadPolicy = $b941786f4eb9cb76$var$_extends({}, loadPolicy, {
                        maxTimeToFirstByteMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs),
                        maxLoadTimeMs: Math.min(maxLowLatencyPlaylistRefresh, loadPolicy.maxTimeToFirstByteMs)
                    });
                }
            }
        }
        const legacyRetryCompatibility = loadPolicy.errorRetry || loadPolicy.timeoutRetry || {};
        const loaderConfig = {
            loadPolicy: loadPolicy,
            timeout: loadPolicy.maxLoadTimeMs,
            maxRetry: legacyRetryCompatibility.maxNumRetry || 0,
            retryDelay: legacyRetryCompatibility.retryDelayMs || 0,
            maxRetryDelay: legacyRetryCompatibility.maxRetryDelayMs || 0
        };
        const loaderCallbacks = {
            onSuccess: (response, stats, context, networkDetails)=>{
                const loader = this.getInternalLoader(context);
                this.resetInternalLoader(context.type);
                const string = response.data;
                stats.parsing.start = performance.now();
                if ($b941786f4eb9cb76$export$c1bd440a1b47590d.isMediaPlaylist(string) || context.type !== $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST) this.handleTrackOrLevelPlaylist(response, stats, context, networkDetails || null, loader);
                else this.handleMasterPlaylist(response, stats, context, networkDetails);
            },
            onError: (response, context, networkDetails, stats)=>{
                this.handleNetworkError(context, networkDetails, false, response, stats);
            },
            onTimeout: (stats, context, networkDetails)=>{
                this.handleNetworkError(context, networkDetails, true, undefined, stats);
            }
        };
        // logger.debug(`[playlist-loader]: Calling internal loader delegate for URL: ${context.url}`);
        loader.load(context, loaderConfig, loaderCallbacks);
    }
    checkAutostartLoad() {
        if (!this.hls) return;
        const { config: { autoStartLoad: autoStartLoad, startPosition: startPosition }, forceStartLoad: forceStartLoad } = this.hls;
        if (autoStartLoad || forceStartLoad) {
            this.hls.logger.log(`${autoStartLoad ? 'auto' : 'force'} startLoad with configured startPosition ${startPosition}`);
            this.hls.startLoad(startPosition);
        }
    }
    handleMasterPlaylist(response, stats, context, networkDetails) {
        const hls = this.hls;
        const string = response.data;
        const url = $b941786f4eb9cb76$var$getResponseUrl(response, context);
        const parsedResult = $b941786f4eb9cb76$export$c1bd440a1b47590d.parseMasterPlaylist(string, url);
        if (parsedResult.playlistParsingError) {
            stats.parsing.end = performance.now();
            this.handleManifestParsingError(response, context, parsedResult.playlistParsingError, networkDetails, stats);
            return;
        }
        const { contentSteering: contentSteering, levels: levels, sessionData: sessionData, sessionKeys: sessionKeys, startTimeOffset: startTimeOffset, variableList: variableList } = parsedResult;
        this.variableList = variableList;
        // Treat unknown codec as audio or video codec based on passing `isTypeSupported` check
        // (allows for playback of any supported codec even if not indexed in utils/codecs)
        levels.forEach((levelParsed)=>{
            const { unknownCodecs: unknownCodecs } = levelParsed;
            if (unknownCodecs) {
                const { preferManagedMediaSource: preferManagedMediaSource } = this.hls.config;
                let { audioCodec: audioCodec, videoCodec: videoCodec } = levelParsed;
                for(let i = unknownCodecs.length; i--;){
                    const unknownCodec = unknownCodecs[i];
                    if ($b941786f4eb9cb76$var$areCodecsMediaSourceSupported(unknownCodec, 'audio', preferManagedMediaSource)) {
                        levelParsed.audioCodec = audioCodec = audioCodec ? `${audioCodec},${unknownCodec}` : unknownCodec;
                        $b941786f4eb9cb76$var$sampleEntryCodesISO.audio[audioCodec.substring(0, 4)] = 2;
                        unknownCodecs.splice(i, 1);
                    } else if ($b941786f4eb9cb76$var$areCodecsMediaSourceSupported(unknownCodec, 'video', preferManagedMediaSource)) {
                        levelParsed.videoCodec = videoCodec = videoCodec ? `${videoCodec},${unknownCodec}` : unknownCodec;
                        $b941786f4eb9cb76$var$sampleEntryCodesISO.video[videoCodec.substring(0, 4)] = 2;
                        unknownCodecs.splice(i, 1);
                    }
                }
            }
        });
        const { AUDIO: audioTracks = [], SUBTITLES: subtitles, 'CLOSED-CAPTIONS': captions } = $b941786f4eb9cb76$export$c1bd440a1b47590d.parseMasterPlaylistMedia(string, url, parsedResult);
        if (audioTracks.length) {
            // check if we have found an audio track embedded in main playlist (audio track without URI attribute)
            const embeddedAudioFound = audioTracks.some((audioTrack)=>!audioTrack.url);
            // if no embedded audio track defined, but audio codec signaled in quality level,
            // we need to signal this main audio track this could happen with playlists with
            // alt audio rendition in which quality levels (main)
            // contains both audio+video. but with mixed audio track not signaled
            if (!embeddedAudioFound && levels[0].audioCodec && !levels[0].attrs.AUDIO) {
                this.hls.logger.log('[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one');
                audioTracks.unshift({
                    type: 'main',
                    name: 'main',
                    groupId: 'main',
                    default: false,
                    autoselect: false,
                    forced: false,
                    id: -1,
                    attrs: new $b941786f4eb9cb76$export$3b2a5864ee72b619({}),
                    bitrate: 0,
                    url: ''
                });
            }
        }
        hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, {
            levels: levels,
            audioTracks: audioTracks,
            subtitles: subtitles,
            captions: captions,
            contentSteering: contentSteering,
            url: url,
            stats: stats,
            networkDetails: networkDetails,
            sessionData: sessionData,
            sessionKeys: sessionKeys,
            startTimeOffset: startTimeOffset,
            variableList: variableList
        });
    }
    handleTrackOrLevelPlaylist(response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { id: id, level: level, type: type } = context;
        const url = $b941786f4eb9cb76$var$getResponseUrl(response, context);
        const levelId = $b941786f4eb9cb76$var$isFiniteNumber(level) ? level : $b941786f4eb9cb76$var$isFiniteNumber(id) ? id : 0;
        const levelType = $b941786f4eb9cb76$var$mapContextToLevelType(context);
        const levelDetails = $b941786f4eb9cb76$export$c1bd440a1b47590d.parseLevelPlaylist(response.data, url, levelId, levelType, 0, this.variableList);
        // We have done our first request (Manifest-type) and receive
        // not a master playlist but a chunk-list (track/level)
        // We fire the manifest-loaded event anyway with the parsed level-details
        // by creating a single-level structure for it.
        if (type === $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST) {
            const singleLevel = {
                attrs: new $b941786f4eb9cb76$export$3b2a5864ee72b619({}),
                bitrate: 0,
                details: levelDetails,
                name: '',
                url: url
            };
            levelDetails.requestScheduled = stats.loading.start + $b941786f4eb9cb76$var$computeReloadInterval(levelDetails, 0);
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, {
                levels: [
                    singleLevel
                ],
                audioTracks: [],
                url: url,
                stats: stats,
                networkDetails: networkDetails,
                sessionData: null,
                sessionKeys: null,
                contentSteering: null,
                startTimeOffset: null,
                variableList: null
            });
        }
        // save parsing time
        stats.parsing.end = performance.now();
        // extend the context with the new levelDetails property
        context.levelDetails = levelDetails;
        this.handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader);
    }
    handleManifestParsingError(response, context, error, networkDetails, stats) {
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: $b941786f4eb9cb76$export$d053ec805ce391aa.MANIFEST_PARSING_ERROR,
            fatal: context.type === $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST,
            url: response.url,
            err: error,
            error: error,
            reason: error.message,
            response: response,
            context: context,
            networkDetails: networkDetails,
            stats: stats
        });
    }
    handleNetworkError(context, networkDetails, timeout = false, response, stats) {
        let message = `A network ${timeout ? 'timeout' : 'error' + (response ? ' (status ' + response.code + ')' : '')} occurred while loading ${context.type}`;
        if (context.type === $b941786f4eb9cb76$var$PlaylistContextType.LEVEL) message += `: ${context.level} id: ${context.id}`;
        else if (context.type === $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK || context.type === $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK) message += ` id: ${context.id} group-id: "${context.groupId}"`;
        const error = new Error(message);
        this.hls.logger.warn(`[playlist-loader]: ${message}`);
        let details = $b941786f4eb9cb76$export$d053ec805ce391aa.UNKNOWN;
        let fatal = false;
        const loader = this.getInternalLoader(context);
        switch(context.type){
            case $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST:
                details = timeout ? $b941786f4eb9cb76$export$d053ec805ce391aa.MANIFEST_LOAD_TIMEOUT : $b941786f4eb9cb76$export$d053ec805ce391aa.MANIFEST_LOAD_ERROR;
                fatal = true;
                break;
            case $b941786f4eb9cb76$var$PlaylistContextType.LEVEL:
                details = timeout ? $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_LOAD_TIMEOUT : $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_LOAD_ERROR;
                fatal = false;
                break;
            case $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK:
                details = timeout ? $b941786f4eb9cb76$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_TIMEOUT : $b941786f4eb9cb76$export$d053ec805ce391aa.AUDIO_TRACK_LOAD_ERROR;
                fatal = false;
                break;
            case $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK:
                details = timeout ? $b941786f4eb9cb76$export$d053ec805ce391aa.SUBTITLE_TRACK_LOAD_TIMEOUT : $b941786f4eb9cb76$export$d053ec805ce391aa.SUBTITLE_LOAD_ERROR;
                fatal = false;
                break;
        }
        if (loader) this.resetInternalLoader(context.type);
        const errorData = {
            type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
            details: details,
            fatal: fatal,
            url: context.url,
            loader: loader,
            context: context,
            error: error,
            networkDetails: networkDetails,
            stats: stats
        };
        if (response) {
            const url = (networkDetails == null ? void 0 : networkDetails.url) || context.url;
            errorData.response = $b941786f4eb9cb76$var$_objectSpread2({
                url: url,
                data: undefined
            }, response);
        }
        this.hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, errorData);
    }
    handlePlaylistLoaded(levelDetails, response, stats, context, networkDetails, loader) {
        const hls = this.hls;
        const { type: type, level: level, levelOrTrack: levelOrTrack, id: id, groupId: groupId, deliveryDirectives: deliveryDirectives } = context;
        const url = $b941786f4eb9cb76$var$getResponseUrl(response, context);
        const parent = $b941786f4eb9cb76$var$mapContextToLevelType(context);
        let levelIndex = typeof context.level === 'number' && parent === $b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN ? level : undefined;
        const error = levelDetails.playlistParsingError;
        if (error) {
            this.hls.logger.warn(`${error} ${levelDetails.url}`);
            if (!hls.config.ignorePlaylistParsingErrors) {
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_PARSING_ERROR,
                    fatal: false,
                    url: url,
                    error: error,
                    reason: error.message,
                    response: response,
                    context: context,
                    level: levelIndex,
                    parent: parent,
                    networkDetails: networkDetails,
                    stats: stats
                });
                return;
            }
            levelDetails.playlistParsingError = null;
        }
        if (!levelDetails.fragments.length) {
            const _error = levelDetails.playlistParsingError = new Error('No Segments found in Playlist');
            hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.NETWORK_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.LEVEL_EMPTY_ERROR,
                fatal: false,
                url: url,
                error: _error,
                reason: _error.message,
                response: response,
                context: context,
                level: levelIndex,
                parent: parent,
                networkDetails: networkDetails,
                stats: stats
            });
            return;
        }
        if (levelDetails.live && loader) {
            if (loader.getCacheAge) levelDetails.ageHeader = loader.getCacheAge() || 0;
            if (!loader.getCacheAge || isNaN(levelDetails.ageHeader)) levelDetails.ageHeader = 0;
        }
        switch(type){
            case $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST:
            case $b941786f4eb9cb76$var$PlaylistContextType.LEVEL:
                if (levelIndex) {
                    if (!levelOrTrack) // fall-through to hls.levels[0]
                    levelIndex = 0;
                    else if (levelOrTrack !== hls.levels[levelIndex]) {
                        // correct levelIndex when lower levels were removed from hls.levels
                        const updatedIndex = hls.levels.indexOf(levelOrTrack);
                        if (updatedIndex > -1) levelIndex = updatedIndex;
                    }
                }
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.LEVEL_LOADED, {
                    details: levelDetails,
                    levelInfo: levelOrTrack || hls.levels[0],
                    level: levelIndex || 0,
                    id: id || 0,
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives,
                    withoutMultiVariant: type === $b941786f4eb9cb76$var$PlaylistContextType.MANIFEST
                });
                break;
            case $b941786f4eb9cb76$var$PlaylistContextType.AUDIO_TRACK:
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.AUDIO_TRACK_LOADED, {
                    details: levelDetails,
                    track: levelOrTrack,
                    id: id || 0,
                    groupId: groupId || '',
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives
                });
                break;
            case $b941786f4eb9cb76$var$PlaylistContextType.SUBTITLE_TRACK:
                hls.trigger($b941786f4eb9cb76$export$ada873a34909da65.SUBTITLE_TRACK_LOADED, {
                    details: levelDetails,
                    track: levelOrTrack,
                    id: id || 0,
                    groupId: groupId || '',
                    stats: stats,
                    networkDetails: networkDetails,
                    deliveryDirectives: deliveryDirectives
                });
                break;
        }
    }
}
/**
 * The `Hls` class is the core of the HLS.js library used to instantiate player instances.
 * @public
 */ class $b941786f4eb9cb76$export$1f323ed185d61c3 {
    /**
   * Get the video-dev/hls.js package version.
   */ static get version() {
        return $b941786f4eb9cb76$var$version;
    }
    /**
   * Check if the required MediaSource Extensions are available.
   */ static isMSESupported() {
        return $b941786f4eb9cb76$export$e9e4a33dcf7638ad();
    }
    /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */ static isSupported() {
        return $b941786f4eb9cb76$export$48c17662a6902497();
    }
    /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */ static getMediaSource() {
        return $b941786f4eb9cb76$export$a92854129bc50f89();
    }
    static get Events() {
        return $b941786f4eb9cb76$export$ada873a34909da65;
    }
    static get MetadataSchema() {
        return $b941786f4eb9cb76$export$3f0d1211c87abf7f;
    }
    static get ErrorTypes() {
        return $b941786f4eb9cb76$export$43a750ddd9f2303e;
    }
    static get ErrorDetails() {
        return $b941786f4eb9cb76$export$d053ec805ce391aa;
    }
    /**
   * Get the default configuration applied to new instances.
   */ static get DefaultConfig() {
        if (!$b941786f4eb9cb76$export$1f323ed185d61c3.defaultConfig) return $b941786f4eb9cb76$var$hlsDefaultConfig;
        return $b941786f4eb9cb76$export$1f323ed185d61c3.defaultConfig;
    }
    /**
   * Replace the default configuration applied to new instances.
   */ static set DefaultConfig(defaultConfig) {
        $b941786f4eb9cb76$export$1f323ed185d61c3.defaultConfig = defaultConfig;
    }
    /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */ constructor(userConfig = {}){
        /**
     * The runtime configuration used by the player. At instantiation this is combination of `hls.userConfig` merged over `Hls.DefaultConfig`.
     */ this.config = void 0;
        /**
     * The configuration object provided on player instantiation.
     */ this.userConfig = void 0;
        /**
     * The logger functions used by this player instance, configured on player instantiation.
     */ this.logger = void 0;
        this.coreComponents = void 0;
        this.networkControllers = void 0;
        this._emitter = new $b941786f4eb9cb76$var$EventEmitter();
        this._autoLevelCapping = -1;
        this._maxHdcpLevel = null;
        this.abrController = void 0;
        this.bufferController = void 0;
        this.capLevelController = void 0;
        this.latencyController = void 0;
        this.levelController = void 0;
        this.streamController = void 0;
        this.audioStreamController = void 0;
        this.subtititleStreamController = void 0;
        this.audioTrackController = void 0;
        this.subtitleTrackController = void 0;
        this.interstitialsController = void 0;
        this.gapController = void 0;
        this.emeController = void 0;
        this.cmcdController = void 0;
        this._media = null;
        this._url = null;
        this._sessionId = void 0;
        this.triggeringException = void 0;
        this.started = false;
        const logger = this.logger = $b941786f4eb9cb76$var$enableLogs(userConfig.debug || false, 'Hls instance', userConfig.assetPlayerId);
        const config = this.config = $b941786f4eb9cb76$var$mergeConfig($b941786f4eb9cb76$export$1f323ed185d61c3.DefaultConfig, userConfig, logger);
        this.userConfig = userConfig;
        if (config.progressive) $b941786f4eb9cb76$var$enableStreamingMode(config, logger);
        // core controllers and network loaders
        const { abrController: _AbrController, bufferController: _BufferController, capLevelController: _CapLevelController, errorController: _ErrorController, fpsController: _FpsController } = config;
        const errorController = new _ErrorController(this);
        const abrController = this.abrController = new _AbrController(this);
        // FragmentTracker must be defined before StreamController because the order of event handling is important
        const fragmentTracker = new $b941786f4eb9cb76$var$FragmentTracker(this);
        const _InterstitialsController = config.interstitialsController;
        const interstitialsController = _InterstitialsController ? this.interstitialsController = new _InterstitialsController(this, $b941786f4eb9cb76$export$1f323ed185d61c3) : null;
        const bufferController = this.bufferController = new _BufferController(this, fragmentTracker);
        const capLevelController = this.capLevelController = new _CapLevelController(this);
        const fpsController = new _FpsController(this);
        const playListLoader = new $b941786f4eb9cb76$var$PlaylistLoader(this);
        const _ContentSteeringController = config.contentSteeringController;
        // Instantiate ConentSteeringController before LevelController to receive Multivariant Playlist events first
        const contentSteering = _ContentSteeringController ? new _ContentSteeringController(this) : null;
        const levelController = this.levelController = new $b941786f4eb9cb76$var$LevelController(this, contentSteering);
        const id3TrackController = new $b941786f4eb9cb76$var$ID3TrackController(this);
        const keyLoader = new $b941786f4eb9cb76$var$KeyLoader(this.config, this.logger);
        const streamController = this.streamController = new $b941786f4eb9cb76$var$StreamController(this, fragmentTracker, keyLoader);
        const gapController = this.gapController = new $b941786f4eb9cb76$var$GapController(this, fragmentTracker);
        // Cap level controller uses streamController to flush the buffer
        capLevelController.setStreamController(streamController);
        // fpsController uses streamController to switch when frames are being dropped
        fpsController.setStreamController(streamController);
        const networkControllers = [
            playListLoader,
            levelController,
            streamController
        ];
        if (interstitialsController) networkControllers.splice(1, 0, interstitialsController);
        if (contentSteering) networkControllers.splice(1, 0, contentSteering);
        this.networkControllers = networkControllers;
        const coreComponents = [
            abrController,
            bufferController,
            gapController,
            capLevelController,
            fpsController,
            id3TrackController,
            fragmentTracker
        ];
        this.audioTrackController = this.createController(config.audioTrackController, networkControllers);
        const AudioStreamControllerClass = config.audioStreamController;
        if (AudioStreamControllerClass) networkControllers.push(this.audioStreamController = new AudioStreamControllerClass(this, fragmentTracker, keyLoader));
        // Instantiate subtitleTrackController before SubtitleStreamController to receive level events first
        this.subtitleTrackController = this.createController(config.subtitleTrackController, networkControllers);
        const SubtitleStreamControllerClass = config.subtitleStreamController;
        if (SubtitleStreamControllerClass) networkControllers.push(this.subtititleStreamController = new SubtitleStreamControllerClass(this, fragmentTracker, keyLoader));
        this.createController(config.timelineController, coreComponents);
        keyLoader.emeController = this.emeController = this.createController(config.emeController, coreComponents);
        this.cmcdController = this.createController(config.cmcdController, coreComponents);
        this.latencyController = this.createController($b941786f4eb9cb76$var$LatencyController, coreComponents);
        this.coreComponents = coreComponents;
        // Error controller handles errors before and after all other controllers
        // This listener will be invoked after all other controllers error listeners
        networkControllers.push(errorController);
        const onErrorOut = errorController.onErrorOut;
        if (typeof onErrorOut === 'function') this.on($b941786f4eb9cb76$export$ada873a34909da65.ERROR, onErrorOut, errorController);
        // Autostart load handler
        this.on($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADED, playListLoader.onManifestLoaded, playListLoader);
    }
    createController(ControllerClass, components) {
        if (ControllerClass) {
            const controllerInstance = new ControllerClass(this);
            if (components) components.push(controllerInstance);
            return controllerInstance;
        }
        return null;
    }
    // Delegate the EventEmitter through the public API of Hls.js
    on(event, listener, context = this) {
        this._emitter.on(event, listener, context);
    }
    once(event, listener, context = this) {
        this._emitter.once(event, listener, context);
    }
    removeAllListeners(event) {
        this._emitter.removeAllListeners(event);
    }
    off(event, listener, context = this, once) {
        this._emitter.off(event, listener, context, once);
    }
    listeners(event) {
        return this._emitter.listeners(event);
    }
    emit(event, name, eventObject) {
        return this._emitter.emit(event, name, eventObject);
    }
    trigger(event, eventObject) {
        if (this.config.debug) return this.emit(event, event, eventObject);
        else try {
            return this.emit(event, event, eventObject);
        } catch (error) {
            this.logger.error('An internal error happened while handling event ' + event + '. Error message: "' + error.message + '". Here is a stacktrace:', error);
            // Prevent recursion in error event handlers that throw #5497
            if (!this.triggeringException) {
                this.triggeringException = true;
                const fatal = event === $b941786f4eb9cb76$export$ada873a34909da65.ERROR;
                this.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                    type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                    details: $b941786f4eb9cb76$export$d053ec805ce391aa.INTERNAL_EXCEPTION,
                    fatal: fatal,
                    event: event,
                    error: error
                });
                this.triggeringException = false;
            }
        }
        return false;
    }
    listenerCount(event) {
        return this._emitter.listenerCount(event);
    }
    /**
   * Dispose of the instance
   */ destroy() {
        this.logger.log('destroy');
        this.trigger($b941786f4eb9cb76$export$ada873a34909da65.DESTROYING, undefined);
        this.detachMedia();
        this.removeAllListeners();
        this._autoLevelCapping = -1;
        this._url = null;
        this.networkControllers.forEach((component)=>component.destroy());
        this.networkControllers.length = 0;
        this.coreComponents.forEach((component)=>component.destroy());
        this.coreComponents.length = 0;
        // Remove any references that could be held in config options or callbacks
        const config = this.config;
        config.xhrSetup = config.fetchSetup = undefined;
        // @ts-ignore
        this.userConfig = null;
    }
    /**
   * Attaches Hls.js to a media element
   */ attachMedia(data) {
        if (!data || 'media' in data && !data.media) {
            const error = new Error(`attachMedia failed: invalid argument (${data})`);
            this.trigger($b941786f4eb9cb76$export$ada873a34909da65.ERROR, {
                type: $b941786f4eb9cb76$export$43a750ddd9f2303e.OTHER_ERROR,
                details: $b941786f4eb9cb76$export$d053ec805ce391aa.ATTACH_MEDIA_ERROR,
                fatal: true,
                error: error
            });
            return;
        }
        this.logger.log(`attachMedia`);
        if (this._media) {
            this.logger.warn(`media must be detached before attaching`);
            this.detachMedia();
        }
        const attachMediaSource = 'media' in data;
        const media = attachMediaSource ? data.media : data;
        const attachingData = attachMediaSource ? data : {
            media: media
        };
        this._media = media;
        this.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_ATTACHING, attachingData);
    }
    /**
   * Detach Hls.js from the media
   */ detachMedia() {
        this.logger.log('detachMedia');
        this.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, {});
        this._media = null;
    }
    /**
   * Detach HTMLMediaElement, MediaSource, and SourceBuffers without reset, for attaching to another instance
   */ transferMedia() {
        this._media = null;
        const transferMedia = this.bufferController.transferMedia();
        this.trigger($b941786f4eb9cb76$export$ada873a34909da65.MEDIA_DETACHING, {
            transferMedia: transferMedia
        });
        return transferMedia;
    }
    /**
   * Set the source URL. Can be relative or absolute.
   */ loadSource(url) {
        this.stopLoad();
        const media = this.media;
        const loadedSource = this._url;
        const loadingSource = this._url = $b941786f4eb9cb76$var$urlToolkitExports.buildAbsoluteURL(self.location.href, url, {
            alwaysNormalize: true
        });
        this._autoLevelCapping = -1;
        this._maxHdcpLevel = null;
        this.logger.log(`loadSource:${loadingSource}`);
        if (media && loadedSource && (loadedSource !== loadingSource || this.bufferController.hasSourceTypes())) {
            // Remove and re-create MediaSource
            this.detachMedia();
            this.attachMedia(media);
        }
        // when attaching to a source URL, trigger a playlist load
        this.trigger($b941786f4eb9cb76$export$ada873a34909da65.MANIFEST_LOADING, {
            url: url
        });
    }
    /**
   * Gets the currently loaded URL
   */ get url() {
        return this._url;
    }
    /**
   * Whether or not enough has been buffered to seek to start position or use `media.currentTime` to determine next load position
   */ get hasEnoughToStart() {
        return this.streamController.hasEnoughToStart;
    }
    /**
   * Get the startPosition set on startLoad(position) or on autostart with config.startPosition
   */ get startPosition() {
        return this.streamController.startPositionValue;
    }
    /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */ startLoad(startPosition = -1, skipSeekToStartPosition) {
        this.logger.log(`startLoad(${startPosition + (skipSeekToStartPosition ? ', <skip seek to start>' : '')})`);
        this.started = true;
        this.resumeBuffering();
        for(let i = 0; i < this.networkControllers.length; i++){
            this.networkControllers[i].startLoad(startPosition, skipSeekToStartPosition);
            if (!this.started || !this.networkControllers) break;
        }
    }
    /**
   * Stop loading of any stream data.
   */ stopLoad() {
        this.logger.log('stopLoad');
        this.started = false;
        for(let i = 0; i < this.networkControllers.length; i++){
            this.networkControllers[i].stopLoad();
            if (this.started || !this.networkControllers) break;
        }
    }
    /**
   * Returns whether loading, toggled with `startLoad()` and `stopLoad()`, is active or not`.
   */ get loadingEnabled() {
        return this.started;
    }
    /**
   * Returns state of fragment loading toggled by calling `pauseBuffering()` and `resumeBuffering()`.
   */ get bufferingEnabled() {
        return this.streamController.bufferingEnabled;
    }
    /**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */ resumeBuffering() {
        if (!this.bufferingEnabled) {
            this.logger.log(`resume buffering`);
            this.networkControllers.forEach((controller)=>{
                if (controller.resumeBuffering) controller.resumeBuffering();
            });
        }
    }
    /**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */ pauseBuffering() {
        if (this.bufferingEnabled) {
            this.logger.log(`pause buffering`);
            this.networkControllers.forEach((controller)=>{
                if (controller.pauseBuffering) controller.pauseBuffering();
            });
        }
    }
    get inFlightFragments() {
        const inFlightData = {
            [$b941786f4eb9cb76$export$e15fb1a9320a1882.MAIN]: this.streamController.inFlightFrag
        };
        if (this.audioStreamController) inFlightData[$b941786f4eb9cb76$export$e15fb1a9320a1882.AUDIO] = this.audioStreamController.inFlightFrag;
        if (this.subtititleStreamController) inFlightData[$b941786f4eb9cb76$export$e15fb1a9320a1882.SUBTITLE] = this.subtititleStreamController.inFlightFrag;
        return inFlightData;
    }
    /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */ swapAudioCodec() {
        this.logger.log('swapAudioCodec');
        this.streamController.swapAudioCodec();
    }
    /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */ recoverMediaError() {
        this.logger.log('recoverMediaError');
        const media = this._media;
        const time1 = media == null ? void 0 : media.currentTime;
        this.detachMedia();
        if (media) {
            this.attachMedia(media);
            if (time1) this.startLoad(time1);
        }
    }
    removeLevel(levelIndex) {
        this.levelController.removeLevel(levelIndex);
    }
    /**
   * @returns a UUID for this player instance
   */ get sessionId() {
        let _sessionId = this._sessionId;
        if (!_sessionId) _sessionId = this._sessionId = $b941786f4eb9cb76$var$uuid();
        return _sessionId;
    }
    /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */ get levels() {
        const levels = this.levelController.levels;
        return levels ? levels : [];
    }
    /**
   * @returns LevelDetails of last loaded level (variant) or `null` prior to loading a media playlist.
   */ get latestLevelDetails() {
        return this.streamController.getLevelDetails() || null;
    }
    /**
   * @returns Level object of selected level (variant) or `null` prior to selecting a level or once the level is removed.
   */ get loadLevelObj() {
        return this.levelController.loadLevelObj;
    }
    /**
   * Index of quality level (variant) currently played
   */ get currentLevel() {
        return this.streamController.currentLevel;
    }
    /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */ set currentLevel(newLevel) {
        this.logger.log(`set currentLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
        this.streamController.immediateLevelSwitch();
    }
    /**
   * Index of next quality level loaded as scheduled by stream controller.
   */ get nextLevel() {
        return this.streamController.nextLevel;
    }
    /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */ set nextLevel(newLevel) {
        this.logger.log(`set nextLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
        this.streamController.nextLevelSwitch();
    }
    /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */ get loadLevel() {
        return this.levelController.level;
    }
    /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */ set loadLevel(newLevel) {
        this.logger.log(`set loadLevel:${newLevel}`);
        this.levelController.manualLevel = newLevel;
    }
    /**
   * get next quality level loaded
   */ get nextLoadLevel() {
        return this.levelController.nextLoadLevel;
    }
    /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */ set nextLoadLevel(level) {
        this.levelController.nextLoadLevel = level;
    }
    /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */ get firstLevel() {
        return Math.max(this.levelController.firstLevel, this.minAutoLevel);
    }
    /**
   * Sets "first-level", see getter.
   */ set firstLevel(newLevel) {
        this.logger.log(`set firstLevel:${newLevel}`);
        this.levelController.firstLevel = newLevel;
    }
    /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */ get startLevel() {
        const startLevel = this.levelController.startLevel;
        if (startLevel === -1 && this.abrController.forcedAutoLevel > -1) return this.abrController.forcedAutoLevel;
        return startLevel;
    }
    /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */ set startLevel(newLevel) {
        this.logger.log(`set startLevel:${newLevel}`);
        // if not in automatic start level detection, ensure startLevel is greater than minAutoLevel
        if (newLevel !== -1) newLevel = Math.max(newLevel, this.minAutoLevel);
        this.levelController.startLevel = newLevel;
    }
    /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */ get capLevelToPlayerSize() {
        return this.config.capLevelToPlayerSize;
    }
    /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */ set capLevelToPlayerSize(shouldStartCapping) {
        const newCapLevelToPlayerSize = !!shouldStartCapping;
        if (newCapLevelToPlayerSize !== this.config.capLevelToPlayerSize) {
            if (newCapLevelToPlayerSize) this.capLevelController.startCapping(); // If capping occurs, nextLevelSwitch will happen based on size.
            else {
                this.capLevelController.stopCapping();
                this.autoLevelCapping = -1;
                this.streamController.nextLevelSwitch(); // Now we're uncapped, get the next level asap.
            }
            this.config.capLevelToPlayerSize = newCapLevelToPlayerSize;
        }
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ get autoLevelCapping() {
        return this._autoLevelCapping;
    }
    /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */ get bandwidthEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimate();
    }
    set bandwidthEstimate(abrEwmaDefaultEstimate) {
        this.abrController.resetEstimator(abrEwmaDefaultEstimate);
    }
    get abrEwmaDefaultEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.defaultEstimate;
    }
    /**
   * get time to first byte estimate
   * @type {number}
   */ get ttfbEstimate() {
        const { bwEstimator: bwEstimator } = this.abrController;
        if (!bwEstimator) return NaN;
        return bwEstimator.getEstimateTTFB();
    }
    /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */ set autoLevelCapping(newLevel) {
        if (this._autoLevelCapping !== newLevel) {
            this.logger.log(`set autoLevelCapping:${newLevel}`);
            this._autoLevelCapping = newLevel;
            this.levelController.checkMaxAutoUpdated();
        }
    }
    get maxHdcpLevel() {
        return this._maxHdcpLevel;
    }
    set maxHdcpLevel(value) {
        if ($b941786f4eb9cb76$var$isHdcpLevel(value) && this._maxHdcpLevel !== value) {
            this._maxHdcpLevel = value;
            this.levelController.checkMaxAutoUpdated();
        }
    }
    /**
   * True when automatic level selection enabled
   */ get autoLevelEnabled() {
        return this.levelController.manualLevel === -1;
    }
    /**
   * Level set manually (if any)
   */ get manualLevel() {
        return this.levelController.manualLevel;
    }
    /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */ get minAutoLevel() {
        const { levels: levels, config: { minAutoBitrate: minAutoBitrate } } = this;
        if (!levels) return 0;
        const len = levels.length;
        for(let i = 0; i < len; i++){
            if (levels[i].maxBitrate >= minAutoBitrate) return i;
        }
        return 0;
    }
    /**
   * max level selectable in auto mode according to autoLevelCapping
   */ get maxAutoLevel() {
        const { levels: levels, autoLevelCapping: autoLevelCapping, maxHdcpLevel: maxHdcpLevel } = this;
        let maxAutoLevel;
        if (autoLevelCapping === -1 && levels != null && levels.length) maxAutoLevel = levels.length - 1;
        else maxAutoLevel = autoLevelCapping;
        if (maxHdcpLevel) for(let i = maxAutoLevel; i--;){
            const hdcpLevel = levels[i].attrs['HDCP-LEVEL'];
            if (hdcpLevel && hdcpLevel <= maxHdcpLevel) return i;
        }
        return maxAutoLevel;
    }
    get firstAutoLevel() {
        return this.abrController.firstAutoLevel;
    }
    /**
   * next automatically selected quality level
   */ get nextAutoLevel() {
        return this.abrController.nextAutoLevel;
    }
    /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */ set nextAutoLevel(nextLevel) {
        this.abrController.nextAutoLevel = nextLevel;
    }
    /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */ get playingDate() {
        return this.streamController.currentProgramDateTime;
    }
    get mainForwardBufferInfo() {
        return this.streamController.getMainFwdBufferInfo();
    }
    get maxBufferLength() {
        return this.streamController.maxBufferLength;
    }
    /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */ setAudioOption(audioOption) {
        var _this$audioTrackContr;
        return ((_this$audioTrackContr = this.audioTrackController) == null ? void 0 : _this$audioTrackContr.setAudioOption(audioOption)) || null;
    }
    /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */ setSubtitleOption(subtitleOption) {
        var _this$subtitleTrackCo;
        return ((_this$subtitleTrackCo = this.subtitleTrackController) == null ? void 0 : _this$subtitleTrackCo.setSubtitleOption(subtitleOption)) || null;
    }
    /**
   * Get the complete list of audio tracks across all media groups
   */ get allAudioTracks() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.allAudioTracks : [];
    }
    /**
   * Get the list of selectable audio tracks
   */ get audioTracks() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTracks : [];
    }
    /**
   * index of the selected audio track (index in audio track lists)
   */ get audioTrack() {
        const audioTrackController = this.audioTrackController;
        return audioTrackController ? audioTrackController.audioTrack : -1;
    }
    /**
   * selects an audio track, based on its index in audio track lists
   */ set audioTrack(audioTrackId) {
        const audioTrackController = this.audioTrackController;
        if (audioTrackController) audioTrackController.audioTrack = audioTrackId;
    }
    /**
   * get the complete list of subtitle tracks across all media groups
   */ get allSubtitleTracks() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.allSubtitleTracks : [];
    }
    /**
   * get alternate subtitle tracks list from playlist
   */ get subtitleTracks() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTracks : [];
    }
    /**
   * index of the selected subtitle track (index in subtitle track lists)
   */ get subtitleTrack() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleTrack : -1;
    }
    get media() {
        return this._media;
    }
    /**
   * select an subtitle track, based on its index in subtitle track lists
   */ set subtitleTrack(subtitleTrackId) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleTrack = subtitleTrackId;
    }
    /**
   * Whether subtitle display is enabled or not
   */ get subtitleDisplay() {
        const subtitleTrackController = this.subtitleTrackController;
        return subtitleTrackController ? subtitleTrackController.subtitleDisplay : false;
    }
    /**
   * Enable/disable subtitle display rendering
   */ set subtitleDisplay(value) {
        const subtitleTrackController = this.subtitleTrackController;
        if (subtitleTrackController) subtitleTrackController.subtitleDisplay = value;
    }
    /**
   * get mode for Low-Latency HLS loading
   */ get lowLatencyMode() {
        return this.config.lowLatencyMode;
    }
    /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */ set lowLatencyMode(mode) {
        this.config.lowLatencyMode = mode;
    }
    /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */ get liveSyncPosition() {
        return this.latencyController.liveSyncPosition;
    }
    /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */ get latency() {
        return this.latencyController.latency;
    }
    /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */ get maxLatency() {
        return this.latencyController.maxLatency;
    }
    /**
   * target distance from the edge as calculated by the latency controller
   */ get targetLatency() {
        return this.latencyController.targetLatency;
    }
    set targetLatency(latency) {
        this.latencyController.targetLatency = latency;
    }
    /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */ get drift() {
        return this.latencyController.drift;
    }
    /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */ get forceStartLoad() {
        return this.streamController.forceStartLoad;
    }
    /**
   * ContentSteering pathways getter
   */ get pathways() {
        return this.levelController.pathways;
    }
    /**
   * ContentSteering pathwayPriority getter/setter
   */ get pathwayPriority() {
        return this.levelController.pathwayPriority;
    }
    set pathwayPriority(pathwayPriority) {
        this.levelController.pathwayPriority = pathwayPriority;
    }
    /**
   * returns true when all SourceBuffers are buffered to the end
   */ get bufferedToEnd() {
        var _this$bufferControlle;
        return !!((_this$bufferControlle = this.bufferController) != null && _this$bufferControlle.bufferedToEnd);
    }
    /**
   * returns Interstitials Program Manager
   */ get interstitialsManager() {
        var _this$interstitialsCo;
        return ((_this$interstitialsCo = this.interstitialsController) == null ? void 0 : _this$interstitialsCo.interstitialsManager) || null;
    }
    /**
   * returns mediaCapabilities.decodingInfo for a variant/rendition
   */ getMediaDecodingInfo(level, audioTracks = this.allAudioTracks) {
        const audioTracksByGroup = $b941786f4eb9cb76$var$getAudioTracksByGroup(audioTracks);
        return $b941786f4eb9cb76$var$getMediaDecodingInfoPromise(level, audioTracksByGroup, navigator.mediaCapabilities);
    }
}
$b941786f4eb9cb76$export$1f323ed185d61c3.defaultConfig = void 0;




const $69a381aecea465e9$var$STREAM_LIFETIME_MS = 180000;
const $69a381aecea465e9$var$RENEW_BEFORE_MS = 15000;
const $69a381aecea465e9$var$RENEW_AT_MS = $69a381aecea465e9$var$STREAM_LIFETIME_MS - $69a381aecea465e9$var$RENEW_BEFORE_MS;
const $69a381aecea465e9$var$VideoContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    position: relative;
    width: 100%;
    background: #000;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;

    video {
        width: 100%;
        max-height: 70vh;
    }

    &:fullscreen {
        min-height: 0;

        video {
            max-height: 100%;
            height: 100%;
            object-fit: contain;
        }
    }

    &:hover .video-controls {
        opacity: 1;
    }
`;
const $69a381aecea465e9$var$VideoControls = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
    opacity: 0;
    transition: opacity 0.25s ease;

    button {
        background: none;
        border: none;
        color: rgba(255, 255, 255, 0.85);
        cursor: pointer;
        padding: 6px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            color: #fff;
            background: rgba(255, 255, 255, 0.15);
        }
    }

    svg {
        fill: currentColor;
    }
`;
const $69a381aecea465e9$var$StatusBar = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #1c2127;
    border-top: 1px solid #394b59;
`;
const $69a381aecea465e9$var$Timer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).span`
    font-variant-numeric: tabular-nums;
    color: #a7b6c2;
    font-size: 12px;
`;
const $69a381aecea465e9$export$59b8796f430aa140 = ({ isOpen: isOpen, onClose: onClose, deviceName: deviceName, recid: recid, recName: recName })=>{
    const videoRef = (0, $kYL7Z.useRef)(null);
    const hlsRef = (0, $kYL7Z.useRef)(null);
    const renewTimerRef = (0, $kYL7Z.useRef)(null);
    const startTimeRef = (0, $kYL7Z.useRef)(null);
    const [status, setStatus] = (0, $kYL7Z.useState)('starting'); // starting | loading | playing | error | stopped
    const [countdown, setCountdown] = (0, $kYL7Z.useState)(null);
    const countdownRef = (0, $kYL7Z.useRef)(null);
    const containerRef = (0, $kYL7Z.useRef)(null);
    const toggleFullscreen = (0, $kYL7Z.useCallback)(()=>{
        if (document.fullscreenElement) document.exitFullscreen();
        else containerRef.current?.requestFullscreen();
    }, []);
    const startStream = (0, $kYL7Z.useCallback)((retryDelay = 2000, silent = false)=>{
        if (!silent) setStatus('starting');
        const attempt = (delay)=>(0, $0db64f2ac749186b$export$91cea577896d70d9).command('LiveStreamCommand', deviceName, {
                params: {
                    recid: recid,
                    streaming: true
                }
            }, 'update').then((resp)=>{
                const data = resp.payload?.resp;
                if (data?.error) throw new Error(data.error);
                if (!data?.hls_url) {
                    if (delay > 15000) throw new Error('Device did not start streaming');
                    return new Promise((resolve)=>setTimeout(resolve, delay)).then(()=>attempt(delay * 2));
                }
                return data.hls_url;
            });
        return attempt(retryDelay);
    }, [
        deviceName,
        recid
    ]);
    const attachHls = (0, $kYL7Z.useCallback)((url)=>{
        if (hlsRef.current) {
            hlsRef.current.destroy();
            hlsRef.current = null;
        }
        const video = videoRef.current;
        if (!video) return;
        if ((0, $b941786f4eb9cb76$export$1f323ed185d61c3).isSupported()) {
            const hls = new (0, $b941786f4eb9cb76$export$1f323ed185d61c3)({
                enableWorker: true,
                lowLatencyMode: true,
                liveSyncDurationCount: 2,
                liveMaxLatencyDurationCount: 5,
                maxLiveSyncPlaybackRate: 1.5
            });
            hlsRef.current = hls;
            hls.loadSource(url);
            hls.attachMedia(video);
            hls.on((0, $b941786f4eb9cb76$export$1f323ed185d61c3).Events.MANIFEST_PARSED, ()=>{
                setStatus('playing');
                video.play().catch(()=>{});
            });
            hls.on((0, $b941786f4eb9cb76$export$1f323ed185d61c3).Events.ERROR, (_event, data)=>{
                if (data.fatal) {
                    if (data.type === (0, $b941786f4eb9cb76$export$1f323ed185d61c3).ErrorTypes.NETWORK_ERROR) {
                        // Network errors during loading are expected while stream spins up
                        if (status === 'starting' || status === 'loading') {
                            setStatus('loading');
                            hls.startLoad();
                        } else setStatus('error');
                    } else setStatus('error');
                }
            });
            setStatus('loading');
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
            // Safari native HLS
            video.src = url;
            video.addEventListener('loadedmetadata', ()=>{
                setStatus('playing');
                video.play().catch(()=>{});
            });
            setStatus('loading');
        } else {
            setStatus('error');
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'HLS playback is not supported in this browser'
            });
        }
    }, []);
    const scheduleRenew = (0, $kYL7Z.useCallback)(()=>{
        if (renewTimerRef.current) clearTimeout(renewTimerRef.current);
        startTimeRef.current = Date.now();
        renewTimerRef.current = setTimeout(()=>{
            startStream(2000, true).then((url)=>{
                // Seamless renew — just swap the source on the existing HLS instance
                if (hlsRef.current) hlsRef.current.loadSource(url);
                else attachHls(url);
                scheduleRenew();
            }).catch((err)=>{
                console.warn('Failed to renew stream:', err);
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Failed to renew live stream'
                });
                setStatus('error');
            });
        }, $69a381aecea465e9$var$RENEW_AT_MS);
    }, [
        startStream,
        attachHls
    ]);
    // Countdown timer
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen || !startTimeRef.current) return;
        const tick = ()=>{
            if (!startTimeRef.current) return;
            const elapsed = Date.now() - startTimeRef.current;
            const remaining = Math.max(0, Math.ceil(($69a381aecea465e9$var$STREAM_LIFETIME_MS - elapsed) / 1000));
            const mins = Math.floor(remaining / 60);
            const secs = remaining % 60;
            setCountdown(`${mins}:${String(secs).padStart(2, '0')}`);
        };
        tick();
        countdownRef.current = setInterval(tick, 1000);
        return ()=>clearInterval(countdownRef.current);
    }, [
        isOpen,
        status
    ]);
    // Start/stop stream on open/close
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen) startStream().then((url)=>{
            attachHls(url);
            scheduleRenew();
        }).catch((err)=>{
            console.warn('Failed to start stream:', err);
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: `Failed to start live stream: ${err?.message ?? err}`
            });
            setStatus('error');
        });
        return ()=>{
            if (hlsRef.current) {
                hlsRef.current.destroy();
                hlsRef.current = null;
            }
            if (renewTimerRef.current) {
                clearTimeout(renewTimerRef.current);
                renewTimerRef.current = null;
            }
            if (countdownRef.current) {
                clearInterval(countdownRef.current);
                countdownRef.current = null;
            }
            startTimeRef.current = null;
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
        isOpen: isOpen,
        onClose: onClose,
        title: `Live Stream \u{2014} ${recName || recid}`,
        icon: "eye-open",
        style: {
            width: 'min(960px, 90vw)',
            paddingBottom: 0
        },
        canOutsideClickClose: false,
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($69a381aecea465e9$var$VideoContainer, {
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("video", {
                        ref: videoRef,
                        muted: true,
                        autoPlay: true,
                        playsInline: true
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($69a381aecea465e9$var$VideoControls, {
                        className: "video-controls",
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("button", {
                            onClick: toggleFullscreen,
                            title: "Fullscreen",
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("svg", {
                                width: "18",
                                height: "18",
                                viewBox: "0 0 24 24",
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("path", {
                                    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
                                })
                            })
                        })
                    }),
                    (status === 'starting' || status === 'loading') && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                        style: {
                            position: 'absolute',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
                                size: 40
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                minimal: true,
                                intent: "primary",
                                children: status === 'starting' ? 'Starting stream...' : 'Waiting for data...'
                            })
                        ]
                    }),
                    status === 'error' && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                        style: {
                            position: 'absolute',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            gap: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                icon: "error",
                                size: 40,
                                intent: "danger"
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                minimal: true,
                                intent: "danger",
                                children: "Stream unavailable"
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                small: true,
                                intent: "primary",
                                text: "Retry",
                                onClick: ()=>{
                                    startStream().then((url)=>{
                                        attachHls(url);
                                        scheduleRenew();
                                    }).catch((err)=>{
                                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                            message: `Failed to restart stream: ${err?.message ?? err}`
                                        });
                                        setStatus('error');
                                    });
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($69a381aecea465e9$var$StatusBar, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        intent: status === 'playing' ? 'success' : status === 'error' ? 'danger' : 'warning',
                        minimal: true,
                        round: true,
                        children: status === 'playing' ? 'LIVE' : status === 'error' ? 'ERROR' : 'CONNECTING'
                    }),
                    countdown && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($69a381aecea465e9$var$Timer, {
                        children: [
                            "Renews in ",
                            countdown
                        ]
                    })
                ]
            })
        ]
    });
};




const $8033b2c2dd0a5909$var$ContentWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin: 2em;
`;
const $8033b2c2dd0a5909$var$TopLayout = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-wrap: wrap;
    gap: 2em;
    align-items: flex-start;
    justify-content: center;
    margin-bottom: 2em;
`;
const $8033b2c2dd0a5909$var$LeftPanel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    flex-direction: column;
    gap: 1em;

    .row-cam-on {
        background-color: rgba(0, 128, 0, 0.08);
    }

    .row-cam-off {
        background-color: rgba(139, 0, 0, 0.08);
    }

    .row-cam-pending {
        background-color: rgba(200, 170, 0, 0.08);
    }
`;
const $8033b2c2dd0a5909$var$StatusRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 1em;
`;
const $8033b2c2dd0a5909$var$StatusButton = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    flex: 1 1 0;
    max-width: 25em;

    .bp6-intent-danger {
        background-color: #8B0000;
    }
`;
const $8033b2c2dd0a5909$var$RightPanel = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    flex: 1 1 300px;
    display: flex;
    flex-direction: column;
    gap: 1em;
`;
const $8033b2c2dd0a5909$var$_parseRtspIp = (url)=>{
    if (!url) return '';
    try {
        const match = url.match(/rtsp:\/\/(?:.*@)?([^:/]+)/);
        return match ? match[1] : '';
    } catch  {
        return '';
    }
};
const $8033b2c2dd0a5909$var$_buildRecordingColumns = (onStartStream, onRegenerateThumbnail)=>[
        {
            key: 'id',
            name: 'Preview',
            width: 200,
            sortable: false,
            filterable: true,
            formatter: ({ row: row })=>{
                const menu = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            icon: "eye-open",
                            text: "Live stream",
                            onClick: ()=>onStartStream(row)
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            icon: "share",
                            text: "Open in new tab",
                            href: '/recs/' + row.id,
                            target: "_blank"
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0b22b1cd0550bc0f$export$acb07b4664ac227c), {}),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            icon: "clipboard",
                            text: "Copy recording ID",
                            onClick: ()=>navigator.clipboard.writeText(row.id)
                        }),
                        row.processingConfig?.provider?.url && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            icon: "link",
                            text: "Copy RTSP URL",
                            onClick: ()=>navigator.clipboard.writeText(row.processingConfig.provider.url)
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0b22b1cd0550bc0f$export$acb07b4664ac227c), {}),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            icon: "refresh",
                            intent: "warning",
                            text: "Regenerate thumbnail",
                            disabled: !row.processingConfig?.provider?.url,
                            onClick: ()=>onRegenerateThumbnail(row)
                        })
                    ]
                });
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                    style: {
                        position: 'relative',
                        width: '100%',
                        height: '100%'
                    },
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $12102d7b56c6a393$export$8dc6765e8be191c7), {
                            content: menu,
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                                to: '/recs/' + row.id,
                                style: {
                                    display: 'block',
                                    width: '100%',
                                    height: '100%'
                                },
                                children: row?.thumbnails?.[0]?.url ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $73bb63be09f7db54$export$4b2d5a8d6a65444a), {
                                    recording: row,
                                    maxHeight: 150
                                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        width: '100%',
                                        height: '100%'
                                    },
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                        icon: "media",
                                        size: 40,
                                        color: "#8a9ba8"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                            style: {
                                position: 'absolute',
                                top: 4,
                                left: 4
                            },
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                intent: "success",
                                icon: "eye-open",
                                interactive: true,
                                round: true,
                                style: {
                                    cursor: 'pointer',
                                    minHeight: 18,
                                    minWidth: 18,
                                    fontSize: 10,
                                    padding: '2px 4px'
                                },
                                onClick: (e)=>{
                                    e.preventDefault();
                                    onStartStream(row);
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                            style: {
                                position: 'absolute',
                                top: 4,
                                right: 4
                            },
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                content: menu,
                                placement: "bottom-end",
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                    intent: "primary",
                                    icon: "more",
                                    interactive: true,
                                    round: true,
                                    style: {
                                        cursor: 'pointer',
                                        minHeight: 18,
                                        minWidth: 18,
                                        fontSize: 10,
                                        padding: '2px 4px'
                                    },
                                    onClick: (e)=>e.preventDefault()
                                })
                            })
                        })
                    ]
                });
            }
        },
        {
            key: 'ip',
            name: 'IP Address',
            width: 150,
            resizable: true,
            sortable: false
        },
        {
            key: 'status',
            name: 'Status',
            width: 120,
            sortable: false,
            formatter: ({ row: row })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    intent: row.status === 'Online' ? 'success' : row.status === 'Offline' ? 'danger' : 'warning',
                    minimal: true,
                    children: row.status
                })
        }
    ];
const $8033b2c2dd0a5909$var$StatusControl = ({ info: info, abortController: abortController, layout: layout })=>{
    const [isOnline, setIsOnline] = (0, $kYL7Z.useState)(null);
    const [snapVersion, setSnapVersion] = (0, $kYL7Z.useState)(null);
    const [recidStatus, setRecidStatus] = (0, $kYL7Z.useState)(null);
    const [recidInfo, setRecidInfo] = (0, $kYL7Z.useState)([]);
    const [gridRows, setGridRows] = (0, $kYL7Z.useState)([]);
    const [streamTarget, setStreamTarget] = (0, $kYL7Z.useState)(null);
    const [regenTarget, setRegenTarget] = (0, $kYL7Z.useState)(null);
    const [regenerating, setRegenerating] = (0, $kYL7Z.useState)(false);
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($kYL7Z))).useMemo(()=>$8033b2c2dd0a5909$var$_buildRecordingColumns((row)=>setStreamTarget(row), (row)=>setRegenTarget(row)), []);
    (0, $kYL7Z.useEffect)(()=>{
        if (info?.id) (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).list({
            withinCameraServers: info.id,
            include: "processingConfig,singleThumbnail,statElems"
        }).then((recs)=>{
            console.log(`Loaded ${recs.length} recs for device ${info.name}`);
            setRecidInfo(recs);
        });
        pingDevice();
    }, []);
    // Merge recidInfo + recidStatus into grid rows
    (0, $kYL7Z.useEffect)(()=>{
        if (!recidInfo.length) return;
        const rows = recidInfo.map((rec)=>{
            const cam_enabled = rec.processingConfig?.provider?.state === 'CAM_ON';
            let status;
            if (!cam_enabled) status = 'Disabled';
            else if (recidStatus === 'error') status = 'Unknown';
            else if (!Array.isArray(recidStatus)) status = 'Checking';
            else {
                const thisStatus = recidStatus.find(({ recid: id })=>id === rec.id);
                status = thisStatus?.cam_state === 'SUCCESS' ? 'Online' : 'Offline';
            }
            return {
                ...rec,
                ip: $8033b2c2dd0a5909$var$_parseRtspIp(rec.processingConfig?.provider?.url),
                status: status
            };
        });
        setGridRows(rows);
    }, [
        recidInfo,
        recidStatus
    ]);
    const handleRegenerate = (0, $kYL7Z.useCallback)((recording)=>{
        console.log(`Regenerating thumbnail for ${recording.id}`);
        setRegenerating(true);
        (0, $573a15d6227c5afa$export$4f262652c1b0494b)({
            deviceName: info.name,
            recording: recording
        }).then(({ width: width, height: height })=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `Regenerated thumbnail for ${recording.name} (${width}x${height})`
            });
            // pull the fresh thumbnail url back into the grid
            return (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).get(recording.id, {
                include: 'singleThumbnail'
            }).then((rec)=>{
                setRecidInfo((prev)=>prev.map((r)=>r.id === recording.id ? {
                            ...r,
                            thumbnails: rec.thumbnails
                        } : r));
            }).catch((err)=>console.log('Failed to reload the thumbnail', err));
        }).catch((err)=>{
            console.log(err);
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? 'Failed to regenerate the thumbnail'
            });
        }).finally(()=>{
            setRegenerating(false);
            setRegenTarget(null);
        });
    }, [
        info?.name
    ]);
    const pingDevice = (0, $kYL7Z.useCallback)(()=>{
        if (!!info) {
            console.log(`Pinging device ${info.name}`);
            setIsOnline(null);
            setSnapVersion(null);
            setRecidStatus(null);
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('HelloCommand', info.name, null, "command", {
                signal: abortController.signal
            }).then((resp)=>{
                setIsOnline(resp.payload?.resp === "hello!" ? "Online" : "Offline");
            }).catch((err)=>{
                console.log(err);
                setIsOnline("Offline");
            });
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetSoftwareVersionCommand', info.name, null, "command", {
                signal: abortController.signal
            }).then((resp)=>{
                setSnapVersion(resp.payload?.resp ?? 'error');
            }).catch((err)=>{
                console.log(err);
                setSnapVersion('error');
            });
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetRecidsStatusCommand', info.name, null, "command", {
                signal: abortController.signal
            }).then((resp)=>{
                setRecidStatus(resp.payload?.resp ?? []);
            }).catch((err)=>{
                console.log(err);
                setRecidStatus('error');
            });
        }
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($8033b2c2dd0a5909$var$StatusRow, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7882f7fbed3eeef1$export$173c2a107baffad4), {
                        deviceName: info.name,
                        abortController: abortController
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                        content: "Click to ping again",
                        fill: true,
                        disabled: !isOnline || !snapVersion,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($8033b2c2dd0a5909$var$StatusButton, {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                fill: true,
                                text: isOnline ?? 'Pinging...',
                                intent: !isOnline ? "warning" : isOnline === "Online" ? "success" : "danger",
                                onClick: pingDevice,
                                disabled: !isOnline || !snapVersion
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                        content: "Click to ping again",
                        fill: true,
                        disabled: !isOnline || !snapVersion,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($8033b2c2dd0a5909$var$StatusButton, {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                fill: true,
                                text: !snapVersion ? "Getting Version..." : snapVersion === 'error' ? "Unknown Version" : snapVersion,
                                intent: !snapVersion ? "warning" : snapVersion === "error" ? "danger" : "success",
                                onClick: pingDevice,
                                disabled: !isOnline || !snapVersion
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                columns: layout === 'Mobile' ? columns.filter((c)=>c.key !== 'ip') : columns,
                rowHeight: 150,
                data: gridRows,
                fitHeight: true,
                rowClass: (row)=>row.status === 'Online' ? 'row-cam-on' : row.status === 'Offline' ? 'row-cam-off' : 'row-cam-pending'
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $0557f9662be477d9$export$caec2af78bcc877f), {
                isOpen: !!regenTarget,
                icon: "refresh",
                intent: "warning",
                confirmButtonText: "Regenerate",
                cancelButtonText: "Cancel",
                loading: regenerating,
                canEscapeKeyCancel: !regenerating,
                canOutsideClickCancel: !regenerating,
                onCancel: ()=>setRegenTarget(null),
                onConfirm: ()=>handleRegenerate(regenTarget),
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                        children: [
                            "Request a new frame from ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                children: regenTarget?.name
                            }),
                            " and overwrite its current thumbnail?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("p", {
                        children: "The stat elems are not moved, so anything that changed in the camera view will need the elems to be adjusted afterwards."
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                        style: {
                            wordBreak: 'break-all',
                            color: '#8a9ba8'
                        },
                        children: [
                            regenTarget?.processingConfig?.provider?.url,
                            regenTarget?.processingConfig?.provider?.width ? ` (${regenTarget.processingConfig.provider.width}x${regenTarget.processingConfig.provider.height})` : null
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $69a381aecea465e9$export$59b8796f430aa140), {
                isOpen: !!streamTarget,
                onClose: ()=>setStreamTarget(null),
                deviceName: info.name,
                recid: streamTarget?.id,
                recName: streamTarget?.name
            })
        ]
    });
};
const $8033b2c2dd0a5909$export$f1a400555617dc08 = ({ info: info, onRefresh: onRefresh })=>{
    const [isRebooting, setIsRebooting] = (0, $kYL7Z.useState)(false);
    const [refreshKey, setRefreshKey] = (0, $kYL7Z.useState)(0);
    const [abortController] = (0, $kYL7Z.useState)(new AbortController());
    const { loading: loading, setLoading: setLoading } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const layout = (0, $8e425011355aeb30$export$f47430f7ffdcc134)();
    (0, $kYL7Z.useEffect)(()=>{
        return ()=>{
            abortController.abort("Aborting device commands because unmounting component");
        };
    }, []);
    const createRecid = (0, $kYL7Z.useCallback)(({ name: name, img: img, width: width, height: height, source: source })=>{
        if (!info?.organisation || !info?.location || !info?.id) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: "The device must have an organisation and a location to create a recording"
            });
            return;
        }
        const currentNavContext = loading.location;
        setLoading({
            status: true,
            location: `Creating recid for device ${info.name}`
        });
        (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).create({
            organisation: info.organisation,
            location: info.location,
            cameraServer: info.id,
            name: name,
            key: name.toLowerCase().replace(/\s+/g, '-'),
            type: 'auto-upload'
        }).then((rec)=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `Created recording ${rec.id}`
            });
            return Promise.allSettled([
                (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).thumbnail.patch(rec.id, {
                    base64EncodedJpeg: img
                }),
                (0, $5a9cade4af2d6a52$export$a78349cff2b2c2a0).create(rec.id, {
                    provider: {
                        state: 'CAM_ON',
                        url: source,
                        fps: 3,
                        width: width,
                        height: height
                    },
                    Stats: {
                        split_by: [
                            'age',
                            'gender',
                            'lines',
                            'engagement',
                            'occupancy'
                        ]
                    },
                    Drawer: {
                        enabled: false
                    },
                    Audit: {
                        enabled: false,
                        schedule: '0-14 */3 * * *'
                    },
                    Heatmaps: {
                        enabled: true
                    },
                    Spawner: {
                        enabled_timed: false,
                        enabled_line_crossing: false
                    }
                }),
                (0, $5a9cade4af2d6a52$export$557cacc73549007c).create(rec.id, {
                    lines: {},
                    areas: {
                        ignore: {},
                        trigger: {}
                    }
                })
            ]).then(([thumbResult, configResult, elemsResult])=>{
                if (thumbResult.status === 'rejected') (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Failed to set thumbnail'
                });
                if (configResult.status === 'rejected') (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Failed to create processing config'
                });
                if (elemsResult.status === 'rejected') (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Failed to create stat elems'
                });
                // Fire and forget — tell device to pick up the new recid
                (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', info.name, null, 'update').catch(()=>{});
                setRefreshKey((k)=>k + 1);
                onRefresh();
            });
        }).catch((err)=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? 'Failed to create recording'
            });
            setLoading({
                status: false,
                location: currentNavContext
            });
        });
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($8033b2c2dd0a5909$var$ContentWrapper, {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($8033b2c2dd0a5909$var$TopLayout, {
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($8033b2c2dd0a5909$var$LeftPanel, {
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($8033b2c2dd0a5909$var$StatusControl, {
                        info: info,
                        abortController: abortController,
                        layout: layout
                    }, refreshKey)
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($8033b2c2dd0a5909$var$RightPanel, {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $a52c0cc0b7d14ece$export$60332b2344f7fe41), {
                            title: "Thumbnails",
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $43f9c5d066688a60$export$d48a38fe1a7d8026), {
                                deviceName: info.name,
                                onCreate: createRecid
                            })
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $a52c0cc0b7d14ece$export$60332b2344f7fe41), {
                            title: "Network Control",
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7e2478d8cc8b2395$export$1e791ce0f94af3f), {
                                onGetInfo: ()=>(0, $0db64f2ac749186b$export$91cea577896d70d9).command('GetNetworkInfoCommand', info.name, null, "command", {
                                        signal: abortController.signal
                                    }).then((resp)=>resp.payload?.resp),
                                onSubmit: (config)=>{
                                    const payload = {
                                        ip: config.ip || "",
                                        netmask: config.netmask || "",
                                        gateway: config.gateway || "",
                                        dns: config.dns || ""
                                    };
                                    if (!window.confirm(`You are about to change network configuration for ${info.name}.\n` + `This might kick the device offline.\n\n` + `IP: ${payload.ip || '(empty)'}\nNetmask: ${payload.netmask || '(empty)'}` + (payload.gateway ? `\nGateway: ${payload.gateway}` : '') + (payload.dns ? `\nDNS: ${payload.dns}` : '') + `\n\nAre you sure?`)) return Promise.resolve();
                                    return (0, $0db64f2ac749186b$export$91cea577896d70d9).command('SetStaticONVIFCommand', info.name, payload, "command", {
                                        signal: abortController.signal
                                    }).then((resp)=>{
                                        const isNack = resp.topic?.split('/').pop() === 'nack';
                                        const result = resp.payload?.resp;
                                        if (isNack) throw new Error(result?.error || 'Device returned an error');
                                        // newer devices return {success, message}, older ones return true/false
                                        if (result === false) throw new Error('Configuration failed');
                                        if (typeof result === 'object' && result?.success === false) throw new Error(result.message || 'Configuration failed');
                                        (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                                            message: `Network configuration set on ${info.name}`
                                        });
                                    }).catch((err)=>{
                                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                            message: `Failed to set network configuration on ${info.name}: ${err?.message ?? err}`
                                        });
                                        throw err;
                                    });
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $a52c0cc0b7d14ece$export$60332b2344f7fe41), {
                            title: "Welcome to the Danger Zone",
                            intent: "danger",
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '0.5em'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                        fill: true,
                                        icon: "repeat",
                                        text: isRebooting ? "Rebooting..." : "Reboot device",
                                        intent: "danger",
                                        disabled: !info || isRebooting,
                                        onClick: ()=>{
                                            if (window.confirm(`Are you sure you want to reboot ${info.name}?`)) {
                                                setIsRebooting(true);
                                                (0, $0db64f2ac749186b$export$91cea577896d70d9).command('DeviceRebootCommand', info.name, null, "command", {
                                                    signal: abortController.signal
                                                }).then((resp)=>{
                                                    console.log("Reboot requested");
                                                }).catch((err)=>{
                                                    console.log(err);
                                                }).finally(()=>setIsRebooting(false));
                                            }
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $07257e639008340f$export$a849a34056f7c844), {
                                        deviceName: info.name,
                                        deviceId: info.id,
                                        organisationId: info.organisation,
                                        locationId: info.location,
                                        locationName: info.locationName
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $8033b2c2dd0a5909$export$e985d3b21c0ed539 = ({ devid: devid })=>{
    const [info, setInfo] = (0, $kYL7Z.useState)(null);
    const { setNav: setNav, setLoading: setLoading } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const loadDevice = (0, $kYL7Z.useCallback)(()=>{
        setLoading({
            status: true,
            location: `Loading device ${devid}`
        });
        (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).get(devid, {
            include: 'organisationDetails,locationDetails,recordings'
        }).then((apu)=>{
            setInfo({
                ...apu,
                organisation: apu.organisation?._id,
                location: apu.location?._id,
                locationName: apu.location?.name
            });
            setNav({
                left: [
                    ...apu.organisation?.name ? [
                        {
                            name: apu.organisation.name,
                            path: "/orgs/" + apu.organisation._id,
                            icon: "office",
                            subpaths: [
                                {
                                    name: "Locations",
                                    icon: "area-of-interest",
                                    path: '/locs?org=' + apu.organisation._id
                                },
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?org=' + apu.organisation._id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?org=' + apu.organisation._id
                                },
                                {
                                    name: "Users",
                                    icon: "people",
                                    path: '/orgs/' + apu.organisation._id + '/users'
                                }
                            ]
                        }
                    ] : [],
                    ...apu.location?.name ? [
                        {
                            name: apu.location.name,
                            path: "/locs/" + apu.location._id,
                            icon: "area-of-interest",
                            subpaths: [
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?loc=' + apu.location._id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?loc=' + apu.location._id
                                }
                            ]
                        }
                    ] : []
                ],
                right: [
                    {
                        name: "Cameras",
                        path: "/recs?dev=" + apu.id,
                        icon: "camera"
                    },
                    {
                        name: "Config",
                        path: `/devs/${apu.id}/config`,
                        icon: "cog"
                    }
                ]
            });
            setLoading({
                status: false,
                location: `${apu.name} (${devid})`
            });
        }).catch(()=>{
            setLoading({
                status: false,
                location: `Failed to load device ${devid}`
            });
        });
    }, []);
    (0, $kYL7Z.useEffect)(()=>{
        loadDevice();
    }, []);
    return !info ? null : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($8033b2c2dd0a5909$export$f1a400555617dc08, {
        info: info,
        onRefresh: loadDevice
    });
};


const $b32bb254fb5f975e$var$DevsListRedirect = ()=>{
    const location = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$444b3ab0cb9aec40), {
        to: `/devs/list${location.search}`,
        replace: true
    });
};
const $b32bb254fb5f975e$var$DevConfigRedirect = ()=>{
    const { resid: resid } = (0, $3c99a37f3fed1403$export$99eaa27ddbbb95ef)();
    const location = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$444b3ab0cb9aec40), {
        to: `/devs/${resid}/control${location.search}`,
        replace: true
    });
};
const $b32bb254fb5f975e$var$ManyDevsRoute = ()=>{
    const location = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f91b0515215ed5a9$export$28593712d0a69baa), {
        search: new URLSearchParams(location.search)
    });
};
const $b32bb254fb5f975e$var$OneDevRoute = ()=>{
    const { resid: resid } = (0, $3c99a37f3fed1403$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5de557269f9457a9$export$d611370310be2eb5), {
        devid: resid
    });
};
const $b32bb254fb5f975e$var$DevControlRoute = ()=>{
    const { resid: resid } = (0, $3c99a37f3fed1403$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $8033b2c2dd0a5909$export$e985d3b21c0ed539), {
        devid: resid
    });
};
const $b32bb254fb5f975e$export$ca557e36c5af9625 = ()=>{
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Devs page");
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $3c99a37f3fed1403$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b32bb254fb5f975e$var$DevsListRedirect, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/list",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b32bb254fb5f975e$var$ManyDevsRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/:resid",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b32bb254fb5f975e$var$DevConfigRedirect, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/:resid/config",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b32bb254fb5f975e$var$OneDevRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/:resid/control",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b32bb254fb5f975e$var$DevControlRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $92e6067166fae914$export$3cb69218ff952ef8), {})
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");







// --------------------------------------------------------- Columns
const $edb9b4ceb2689910$var$RecordingModelColumns = [
    {
        key: 'thumbnails',
        name: 'Preview',
        locked: true,
        width: 250,
        formatter: ({ row: row })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/recs/' + row.id,
                style: {
                    display: 'block',
                    width: '100%',
                    height: '100%'
                },
                children: row?.thumbnails?.[0]?.url ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $73bb63be09f7db54$export$4b2d5a8d6a65444a), {
                    recording: row,
                    maxHeight: 200
                }) : /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    style: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '100%',
                        height: '100%'
                    },
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                        icon: "media",
                        size: 40,
                        color: "#8a9ba8"
                    })
                })
            })
    },
    {
        key: 'contexts',
        name: 'Contexts',
        width: 200,
        resizable: true,
        filterable: true,
        formatter: ({ row: row })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $86ace0d9d7178e4f$export$71a1575a59ac5582), {
                recording: row
            })
    },
    {
        key: 'id',
        name: 'Recording ID',
        resizable: true,
        sortable: true,
        filterable: true,
        showDefaultFilter: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/recs/' + params.row.id,
                children: params.row.id
            })
    },
    {
        key: 'organisation.name',
        name: 'Organisation Name',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.organisation ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/orgs/' + params.row.organisation._id,
                children: params.row.organisation.name
            }) : ''
    },
    {
        key: 'location.name',
        name: 'Location Name',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.location ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/locs/' + params.row.location._id,
                children: params.row.location.name
            }) : ''
    },
    {
        key: 'location.status',
        name: 'Location Status',
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.location?.status || ''
    },
    {
        key: 'cameraServer.name',
        name: 'Device',
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.cameraServer ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$a6c7ac8248d6e38a), {
                to: '/devs/' + params.row.cameraServer._id,
                children: params.row.cameraServer.name
            }) : ''
    },
    {
        key: 'cameraServer.hardwareClass',
        name: 'Device Type',
        width: 100,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>params.row?.cameraServer?.hardwareClass || ''
    },
    {
        key: 'name',
        name: 'Camera Name',
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (j)=>j.row?.name || 'Not present'
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.createdAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
            })
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.updatedAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
            })
    }
];
const $edb9b4ceb2689910$export$1aeb4f122d3d1936 = ({ search: search })=>{
    const { setLoading: setLoading, setNav: setNav, setCount: setCount } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [data, setData] = (0, $kYL7Z.useState)(null);
    (0, $kYL7Z.useEffect)(()=>{
        let searchKeys = [
            'org',
            'loc',
            'dev'
        ].filter((s)=>search.has(s));
        if (searchKeys.length > 1) {
            setLoading({
                status: false,
                location: "Can only filter by one of organisation, location or device"
            });
            setData(Error("Can only filter by one of organisation, location or device"));
        } else {
            console.log("Loading recordings");
            setLoading({
                status: true,
                location: "Loading cameras..."
            });
            let fetch = {
                org: {
                    withinOrganisations: search.get('org')
                },
                loc: {
                    withinLocations: search.get('loc')
                },
                dev: {
                    withinCameraServers: search.get('dev')
                },
                null: {}
            }[searchKeys.length ? searchKeys[0] : null];
            (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).list({
                ...fetch,
                include: 'locationDetails,organisationDetails,cameraServerDetails,singleThumbnail,statElems,lineContexts,areaContexts'
            }).then((response)=>{
                console.log("Loaded " + response.length + " recs");
                const rec = response[0];
                const org = rec?.organisation;
                const loc = rec?.location;
                const dev = rec?.cameraServer;
                let description = {
                    org: org ? org.name + " Cameras" : "No cameras for organisation " + search.get('org'),
                    loc: loc ? "Cameras in " + loc.name : "No cameras for location " + search.get('loc'),
                    dev: dev ? "Cameras in " + dev.name : "No cameras for device " + search.get('dev'),
                    null: "All Cameras"
                }[searchKeys.length ? searchKeys[0] : null];
                const navLeft = [];
                if (rec && searchKeys.length) {
                    if (org && (search.has('org') || search.has('loc') || search.has('dev'))) navLeft.push({
                        name: org.name,
                        path: "/orgs/" + org._id,
                        icon: "office",
                        subpaths: [
                            {
                                name: "Locations",
                                icon: "area-of-interest",
                                path: '/locs?org=' + org._id
                            },
                            {
                                name: "Devices",
                                icon: "desktop",
                                path: '/devs?org=' + org._id
                            },
                            {
                                name: "Cameras",
                                icon: "camera",
                                path: '/recs?org=' + org._id
                            },
                            {
                                name: "Users",
                                icon: "people",
                                path: '/orgs/' + org._id + '/users'
                            }
                        ]
                    });
                    if (loc && (search.has('loc') || search.has('dev'))) navLeft.push({
                        name: loc.name,
                        path: "/locs/" + loc._id,
                        icon: "area-of-interest",
                        subpaths: [
                            {
                                name: "Devices",
                                icon: "desktop",
                                path: '/devs?loc=' + loc._id
                            },
                            {
                                name: "Cameras",
                                icon: "camera",
                                path: '/recs?loc=' + loc._id
                            }
                        ]
                    });
                    if (dev && search.has('dev')) navLeft.push({
                        name: dev.name,
                        path: "/devs/" + dev._id,
                        icon: "desktop",
                        subpaths: [
                            {
                                name: "Cameras",
                                icon: "camera",
                                path: '/recs?dev=' + dev._id
                            }
                        ]
                    });
                }
                if (navLeft.length) setNav({
                    left: navLeft
                });
                setLoading({
                    status: false,
                    location: description
                });
                response.forEach((row)=>{
                    const lc = (row.lineContexts || []).map((lc)=>{
                        const meta = lc.metadata?.length ? lc.metadata.map((m)=>`${m.key}: ${m.value}`).join(', ') : lc.withinLocationMovementKey || '';
                        return lc.type + (meta ? `: ${meta}` : '');
                    });
                    const ac = (row.areaContexts || []).map((ac)=>ac.taxonomy || ac.type);
                    row.contexts = [
                        ...lc,
                        ...ac
                    ].join(', ');
                });
                requestAnimationFrame(()=>setData(response));
            }).catch((error)=>{
                console.error(error);
                setLoading({
                    status: false,
                    location: "Failed to load cameras..."
                });
                setData(error);
            });
        }
    }, [
        search
    ]);
    const [selectedAreaContexts, setSelectedAreaContexts] = (0, $kYL7Z.useState)([]);
    const [selectedLineContexts, setSelectedLineContexts] = (0, $kYL7Z.useState)([]);
    const onTagHover = (0, $kYL7Z.useCallback)((tag)=>{
        setSelectedAreaContexts(tag?.elemType === 'area' ? [
            tag.key
        ] : []);
        setSelectedLineContexts(tag?.elemType === 'curve' ? [
            tag.type
        ] : []);
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3989e0deb8926acd$export$5e71ca194ae26770), {
        control: "both",
        selectedAreaContexts: selectedAreaContexts,
        selectedLineContexts: selectedLineContexts,
        onTagHover: onTagHover,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
            columns: $edb9b4ceb2689910$var$RecordingModelColumns,
            rowHeight: 200,
            data: data ?? [],
            defaultSort: "createdAt",
            defaultSortDirection: "DESC",
            onCount: (filtered, total)=>setCount({
                    filtered: filtered,
                    total: total
                })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");

var $i5w0I = parcelRequire("i5w0I");





var $kYL7Z = parcelRequire("kYL7Z");











var $kYL7Z = parcelRequire("kYL7Z");



const $38b737c6f60acefa$var$ButtonContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
  align-items: center;
  justify-content: flex-start;
  display: flex;
  gap: 1em;
`;
const $38b737c6f60acefa$var$saveAreaContext = async (context, recording, fetch)=>{
    const response = await (0, $5a9cade4af2d6a52$export$a8c677e3fb6cda8a).create(context, recording.id);
    if (response && response.id) fetch(recording.id);
};
const $38b737c6f60acefa$var$saveLineContext = async (context, recording, fetch)=>{
    const response = await (0, $5a9cade4af2d6a52$export$4ea2e4f1695ba788).create(context, recording.id);
    if (response && response.id) await fetch(recording.id);
};
const $38b737c6f60acefa$export$79b1f807a5e0f878 = ({ compact: compact, handleSaveChanges: handleSaveChanges })=>{
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const { recording: recording, elems: elems, setElems: setElems, fetch: fetch, setSelected: setSelected } = (0, $kYL7Z.useContext)((0, $a85201d171878a8f$export$7879fcf4b5cbbcfa));
    const is_loading = loading || !elems;
    let names = elems ? elems.elems.map((a)=>a.name) : [];
    let name_idx = 0;
    while(names.includes(`entry-${name_idx}`))name_idx += 1;
    const entryName = `entry-${name_idx}`;
    name_idx = 0;
    while(names.includes(`passer-by-${name_idx}`))name_idx += 1;
    const passerName = `passer-by-${name_idx}`;
    name_idx = 0;
    while(names.includes(`dwell-${name_idx}`))name_idx += 1;
    const dwellName = `dwell-${name_idx}`;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($38b737c6f60acefa$var$ButtonContainer, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                loading: is_loading,
                onClick: async ()=>{
                    setLoading(true);
                    elems.addDefault("lines", entryName);
                    setElems(new (0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3)(elems.scale, elems.elems));
                    await handleSaveChanges();
                    await $38b737c6f60acefa$var$saveLineContext({
                        type: 'location-entry',
                        actions: [
                            [
                                {
                                    lineId: entryName,
                                    direction: 'in',
                                    crossed: true
                                },
                                {
                                    lineId: entryName,
                                    direction: 'out',
                                    crossed: false
                                }
                            ]
                        ],
                        metadata: []
                    }, recording, fetch);
                    setLoading(false);
                },
                children: compact ? "+ Entry" : "+ Entry Line"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                loading: is_loading,
                onClick: async ()=>{
                    setLoading(true);
                    elems.addDefault("lines", passerName, {
                        vari: 0
                    });
                    setElems(new (0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3)(elems.scale, elems.elems));
                    await handleSaveChanges();
                    await $38b737c6f60acefa$var$saveLineContext({
                        type: 'location-pass-by',
                        actions: [
                            [
                                {
                                    lineId: passerName,
                                    direction: 'out',
                                    crossed: true
                                },
                                {
                                    lineId: passerName,
                                    direction: 'in',
                                    crossed: false
                                }
                            ],
                            [
                                {
                                    lineId: passerName,
                                    direction: 'out',
                                    crossed: false
                                },
                                {
                                    lineId: passerName,
                                    direction: 'in',
                                    crossed: true
                                }
                            ]
                        ],
                        metadata: []
                    }, recording, fetch);
                    setLoading(false);
                },
                children: compact ? "+ Passer By" : "+ Passer By Line"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                loading: is_loading,
                onClick: async ()=>{
                    setLoading(true);
                    elems.addDefault("areas", dwellName);
                    setElems(new (0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3)(elems.scale, elems.elems));
                    await handleSaveChanges();
                    await $38b737c6f60acefa$var$saveAreaContext({
                        areaId: dwellName,
                        type: 'location-dwell'
                    }, recording, fetch);
                    setLoading(false);
                },
                children: compact ? "+ Dwell" : "+ Dwell Area"
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");


var $i5w0I = parcelRequire("i5w0I");






var $kYL7Z = parcelRequire("kYL7Z");



const $b7ad189f1457490d$var$EditingItemForm = ({ item: initialItem, taxonomiesInUse: initialTaxonomiesInUse, elems: elems, cancelEditing: cancelEditing, editItem: editItem, saveItem: saveItem, setShapeHighlight: setShapeHighlight, loadingTaxonomies: loadingTaxonomies })=>{
    const [taxonomiesInUse, setTaxonomiesInUse] = (0, $kYL7Z.useState)(initialTaxonomiesInUse);
    const [item, setItem] = (0, $kYL7Z.useState)(initialItem);
    (0, $kYL7Z.useEffect)(()=>{
        setTaxonomiesInUse(initialTaxonomiesInUse);
    }, [
        initialTaxonomiesInUse
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        editItem(item);
    }, [
        item
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 2,
                halign: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                    popoverProps: {
                        minimal: true
                    },
                    items: [
                        "taxonomy",
                        "location-entry",
                        "location-dwell"
                    ],
                    filterable: false,
                    itemRenderer: (tType, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                minimal: true,
                                children: `${tType}`
                            }),
                            onClick: handleClick
                        }, tType),
                    noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                        disabled: true,
                        text: "No results."
                    }),
                    onItemSelect: (tType)=>setItem({
                            ...item,
                            type: tType
                        }),
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        rightIcon: "caret-down",
                        children: item.type || "Context Type"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 2,
                halign: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                    popoverProps: {
                        minimal: true
                    },
                    items: elems.areas,
                    filterable: false,
                    itemRenderer: (elem, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                minimal: true,
                                intent: "primary",
                                children: elem.name
                            }),
                            onMouseEnter: ()=>setShapeHighlight(elem, true),
                            onMouseLeave: ()=>setShapeHighlight(elem, false),
                            onClick: handleClick
                        }, elem.name),
                    noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                        disabled: true,
                        text: "No results."
                    }),
                    onItemSelect: (elem)=>setItem({
                            ...item,
                            areaId: elem.name
                        }),
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        rightIcon: "caret-down",
                        intent: item.areaId ? "primary" : "none",
                        children: item.areaId || "Select Area"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 3,
                halign: "center",
                valign: "center",
                children: item.type === 'taxonomy' && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d5a00f6d9a6cdc43$export$e0a397508a37e5a7), {
                            popoverProps: {
                                minimal: true
                            },
                            inputProps: {
                                small: true,
                                fill: false
                            },
                            query: item.taxonomy ? `${item.taxonomy}` : undefined,
                            items: !loadingTaxonomies && taxonomiesInUse ? taxonomiesInUse.sort((a, z)=>a - z) : [],
                            itemPredicate: (query, item)=>!!item && item.toLowerCase().indexOf(query.toLowerCase()) >= 0,
                            inputValueRenderer: ()=>null,
                            itemRenderer: (taxonomy, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                    text: `${taxonomy}`,
                                    onClick: handleClick
                                }, taxonomy),
                            noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                disabled: true,
                                text: "No results."
                            }),
                            onItemSelect: (taxonomy)=>setItem({
                                    ...item,
                                    taxonomy: taxonomy
                                }),
                            onQueryChange: (taxonomy)=>setItem({
                                    ...item,
                                    taxonomy: taxonomy
                                })
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                            content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("p", {
                                        children: "Taxonomies are colon (:) separated to denote A hierarchy,"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                                        children: [
                                            "so enter a taxonomy in the format",
                                            ' '
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("em", {
                                                children: "Category:Subcategory:Sub-sub-category"
                                            }),
                                            "."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                                        children: [
                                            "A real world example might be ",
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("em", {
                                                children: "Products:iPhones"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                icon: "help"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 1,
                halign: "center",
                valign: "center",
                gap: "10px",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "floppy-disk",
                            htmlTitle: "Save",
                            intent: "success",
                            onClick: ()=>saveItem(item)
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "delete",
                            htmlTitle: "Cancel",
                            intent: "danger",
                            onClick: cancelEditing
                        })
                    ]
                })
            })
        ]
    });
};
var $b7ad189f1457490d$export$2e2bcd8739ae039 = $b7ad189f1457490d$var$EditingItemForm;




var $kYL7Z = parcelRequire("kYL7Z");


const $3f5d140a942f0b69$var$ItemRow = ({ area: area, areaContext: areaContext, beginEditingItem: beginEditingItem, deleteContext: deleteContext, setShapeHighlight: setShapeHighlight })=>{
    const [showButtons, setShowButtons] = (0, $kYL7Z.useState)(false);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
        $hoverColor: "#d7e4f7",
        onMouseOver: ()=>{
            setShowButtons(true);
            if (!!area) setShapeHighlight(area, true);
        },
        onMouseLeave: ()=>{
            setShowButtons(false);
            if (!!area) setShapeHighlight(area, false);
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 2,
                halign: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    children: areaContext.type
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 2,
                halign: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    intent: "primary",
                    children: areaContext.areaId
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 3,
                halign: "center",
                valign: "center",
                children: areaContext.type === "taxonomy" && areaContext.taxonomy && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    children: areaContext.taxonomy
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 1,
                halign: "right",
                valign: "center",
                gap: "10px",
                children: showButtons && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "edit",
                            htmlTitle: "Edit",
                            intent: "success",
                            onClick: ()=>beginEditingItem(areaContext)
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "trash",
                            htmlTitle: "Delete",
                            intent: "danger",
                            onClick: ()=>deleteContext(areaContext)
                        })
                    ]
                })
            })
        ]
    }, areaContext.id);
};
var $3f5d140a942f0b69$export$2e2bcd8739ae039 = $3f5d140a942f0b69$var$ItemRow;


function $9e81588227b91752$export$2e2bcd8739ae039({ recording: recording, elems: elems, taxonomiesInUse: propTaxonomiesInUse, loadingTaxonomies: loadingTaxonomies, updateEditRecordingPageState: updateEditRecordingPageState, setShapeHighlight: setShapeHighlight }) {
    const { loading: loading, setLoading: setLoading } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [areaContexts, setAreaContexts] = (0, $kYL7Z.useState)(recording?.areaContexts);
    const [currentTaxonomies, setCurrentTaxonomies] = (0, $kYL7Z.useState)([]);
    const [editingItem, setEditingItem] = (0, $kYL7Z.useState)(null);
    const [newItem, setNewItem] = (0, $kYL7Z.useState)(null);
    const [taxonomiesInUse, setTaxonomiesInUse] = (0, $kYL7Z.useState)(propTaxonomiesInUse);
    const needsSyncRef = (0, $kYL7Z.useRef)(false);
    // Initialise from props if state is null/undefined
    (0, $kYL7Z.useEffect)(()=>{
        if (!areaContexts && recording?.areaContexts?.length) setAreaContexts(recording.areaContexts);
    }, [
        recording?.areaContexts
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!taxonomiesInUse && propTaxonomiesInUse?.length) setTaxonomiesInUse(propTaxonomiesInUse);
    }, [
        propTaxonomiesInUse
    ]);
    // Sync to recording + trigger save after state updates flagged by needsSyncRef
    (0, $kYL7Z.useEffect)(()=>{
        if (needsSyncRef.current) {
            needsSyncRef.current = false;
            recording.areaContexts = areaContexts;
            updateEditRecordingPageState();
        }
    }, [
        areaContexts
    ]);
    function beginEditingContext(contextBeingEdited) {
        if (editingItem) {
            const continueEdit = window.confirm('Cancel editing the other item?');
            if (continueEdit) setEditingItem(contextBeingEdited);
        } else setEditingItem(contextBeingEdited);
    }
    function stopEditingContext() {
        setEditingItem(null);
    }
    function beginAddingNewContext() {
        setNewItem({
            type: 'taxonomy'
        });
    }
    function editNewContext(contextBeingAdded) {
        setNewItem(contextBeingAdded);
    }
    function stopAddingNewContext() {
        setNewItem(null);
    }
    function validateContext(context) {
        let doThrow = false;
        context.taxonomy = context.type === "taxonomy" ? context.taxonomy : undefined;
        if (!context.type) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Missing a type'
            });
            doThrow = true;
        }
        if (!context.areaId) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Missing an areaId'
            });
            doThrow = true;
        }
        if (context.type === 'taxonomy' && !context.taxonomy) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Missing a taxonomy'
            });
            doThrow = true;
        }
        if (doThrow) throw new Error('Invalid form');
    }
    async function saveNewContext(context) {
        const prevLocation = loading.location;
        setLoading({
            status: true,
            location: "Saving area context..."
        });
        try {
            validateContext(context);
            const response = await (0, $5a9cade4af2d6a52$export$a8c677e3fb6cda8a).create(context, recording.id);
            if (response && response.id) {
                const newContext = {
                    ...context,
                    id: response.id
                };
                needsSyncRef.current = true;
                setNewItem(null);
                setAreaContexts([
                    ...areaContexts || [],
                    newContext
                ]);
                setTaxonomiesInUse((0, $i5w0I.uniq)([
                    ...taxonomiesInUse,
                    context.taxonomy
                ]));
            } else (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Your area context wasn\'t saved'
            });
        } catch (e) {
        // validation or API error
        } finally{
            setLoading({
                status: false,
                location: prevLocation
            });
        }
    }
    async function saveExistingContext(context) {
        const prevLocation = loading.location;
        setLoading({
            status: true,
            location: "Saving area context..."
        });
        try {
            validateContext(context);
            await (0, $5a9cade4af2d6a52$export$a8c677e3fb6cda8a).update(context, recording.id);
            needsSyncRef.current = true;
            setEditingItem(null);
            setAreaContexts([
                ...areaContexts.filter((ac)=>ac.id !== context.id),
                context
            ]);
            setTaxonomiesInUse((0, $i5w0I.uniq)([
                ...taxonomiesInUse,
                context.taxonomy
            ]));
        } catch (e) {
        // validation or API error
        } finally{
            setLoading({
                status: false,
                location: prevLocation
            });
        }
    }
    async function deleteContext(context) {
        const continueDelete = window.confirm('Are you sure you want to delete this areaContext?');
        if (continueDelete) {
            const prevLocation = loading.location;
            setLoading({
                status: true,
                location: "Deleting area context..."
            });
            try {
                await (0, $5a9cade4af2d6a52$export$a8c677e3fb6cda8a).delete(context.id);
                needsSyncRef.current = true;
                setAreaContexts([
                    ...areaContexts.filter((ac)=>ac.id !== context.id)
                ]);
            } catch (e) {
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Failed to delete area context'
                });
            } finally{
                setLoading({
                    status: false,
                    location: prevLocation
                });
            }
        }
    }
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        haligh: "left",
                        valign: "center",
                        span: 2,
                        children: [
                            areaContexts?.length ?? "No",
                            " area contexts"
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        span: 1,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            icon: "plus",
                            text: "Add New",
                            fill: true,
                            onClick: beginAddingNewContext
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                $separatorColor: "silver",
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 2,
                        halign: "center",
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 3,
                        halign: "center",
                        children: "Area"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 3,
                        halign: "center",
                        children: "Taxonomy"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 1,
                        halign: "center",
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "more"
                        })
                    })
                ]
            }),
            areaContexts && areaContexts.sort((a, b)=>a.createdAt < b.createdAt ? -1 : 1).map((ac)=>{
                if (editingItem && editingItem.id === ac.id) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b7ad189f1457490d$export$2e2bcd8739ae039), {
                    item: editingItem,
                    editItem: setEditingItem,
                    cancelEditing: stopEditingContext,
                    elems: elems,
                    taxonomiesInUse: taxonomiesInUse,
                    setShapeHighlight: setShapeHighlight,
                    saveItem: saveExistingContext,
                    loadingTaxonomies: loadingTaxonomies
                }, ac.id);
                else return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3f5d140a942f0b69$export$2e2bcd8739ae039), {
                    area: elems.areas.find((area)=>area.name === ac.areaId),
                    areaContext: ac,
                    beginEditingItem: beginEditingContext,
                    deleteContext: deleteContext,
                    setShapeHighlight: setShapeHighlight
                }, `${ac.areaId}${ac.taxonomy}_${ac.id}`);
            }),
            newItem && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                    halign: "center",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("h4", {
                        children: "Adding new item"
                    })
                })
            }),
            newItem && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b7ad189f1457490d$export$2e2bcd8739ae039), {
                item: newItem,
                editItem: editNewContext,
                cancelEditing: stopAddingNewContext,
                elems: elems,
                taxonomiesInUse: taxonomiesInUse,
                setShapeHighlight: setShapeHighlight,
                saveItem: saveNewContext
            })
        ]
    });
}




var $kYL7Z = parcelRequire("kYL7Z");


const $450a5f12f45aa946$var$NewShapePopoverContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
  display: block;
  width: 300px;
  height: auto;
`;
const $450a5f12f45aa946$var$ShapeTypeHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 23px;
  margin-bottom: 1em;
  padding-top: 1em;
  &:first-child {
    padding-top: 0.5em !important;
  }
`;
const $450a5f12f45aa946$var$createNewShapeMenu = (type, newShapeNameInput, setNewShapeNameInput, handleCreateNewShape)=>{
    const isButtonDisabled = newShapeNameInput.length < 1;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($450a5f12f45aa946$var$NewShapePopoverContainer, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                type: "text",
                leftIcon: "edit",
                value: newShapeNameInput,
                placeholder: type.replace('_', ' ').replace(/s$/, '') + ' name',
                name: "name",
                autoFocus: true,
                onChange: (e)=>setNewShapeNameInput(e.target.value),
                onKeyDown: (e)=>{
                    if (e.key === 'Enter') handleCreateNewShape(type);
                }
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                disabled: isButtonDisabled,
                intent: "primary",
                onClick: ()=>handleCreateNewShape(type),
                children: [
                    "Create ",
                    type.replace('_', ' ').replace(/s$/, '')
                ]
            })
        ]
    });
};
const $450a5f12f45aa946$export$a102f9a6b21a7345 = ({ type: type, title: title, createNewShape: createNewShape })=>{
    const [newShapeNameInput, setNewShapeNameInput] = (0, $kYL7Z.useState)('');
    const [popoverOpen, setPopoverOpen] = (0, $kYL7Z.useState)(false);
    const handleCreateNewShape = (type)=>{
        createNewShape(type, newShapeNameInput);
        setNewShapeNameInput('');
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($450a5f12f45aa946$var$ShapeTypeHeader, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                children: title
            }),
            type === "areas" || type === "lines" ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                position: "auto",
                onClose: ()=>setPopoverOpen(false),
                content: $450a5f12f45aa946$var$createNewShapeMenu(type, newShapeNameInput, setNewShapeNameInput, handleCreateNewShape),
                isOpen: popoverOpen,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    icon: "plus",
                    onClick: ()=>setPopoverOpen(!popoverOpen),
                    children: "Add"
                })
            }) : null
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");







var $kYL7Z = parcelRequire("kYL7Z");






/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Helper function for formatting ratios as CSS percentage values. */ function $876b8992fdb2605d$export$3e1eee59f5dc52be(ratio) {
    return `${(ratio * 100).toFixed(2)}%`;
}
function $876b8992fdb2605d$export$f0f90f0300c414d(values, startIndex, endIndex, fillValue) {
    const inc = startIndex < endIndex ? 1 : -1;
    for(let index = startIndex; index !== endIndex + inc; index += inc)values[index] = fillValue;
}
function $876b8992fdb2605d$export$ec99a91cddfb29a2(values, argFn) {
    if (values.length === 0) return undefined;
    let minValue = values[0];
    let minArg = argFn(minValue);
    for(let index = 1; index < values.length; index++){
        const value = values[index];
        const arg = argFn(value);
        if (arg < minArg) {
            minValue = value;
            minArg = arg;
        }
    }
    return minValue;
}


// props that require number values, for validation
const $d39e1859b9f182cb$var$NUMBER_PROPS = [
    "max",
    "min",
    "stepSize",
    "tickSize",
    "value"
];
class $d39e1859b9f182cb$export$94890c79f4cae6d6 extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.SliderHandle`;
    state = {
        isMoving: false
    };
    handleElement = null;
    refHandlers = {
        handle: (el)=>this.handleElement = el
    };
    componentDidMount() {
        // The first time this component renders, it has no ref to the handle and thus incorrectly centers the handle.
        // Therefore, on the first mount, force a re-render to center the handle with the ref'd component.
        this.forceUpdate();
    }
    render() {
        const { className: className, disabled: disabled, label: label, min: min, max: max, value: value, vertical: vertical, htmlProps: htmlProps } = this.props;
        const { isMoving: isMoving } = this.state;
        return (0, $fc31e5e9fc16a880$exports.jsx)("span", {
            role: "slider",
            tabIndex: 0,
            ...htmlProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).SLIDER_HANDLE, {
                [(0, $2cfd35af7ec11fdd$exports).ACTIVE]: isMoving
            }, className),
            onKeyDown: disabled ? undefined : this.handleKeyDown,
            onKeyUp: disabled ? undefined : this.handleKeyUp,
            onMouseDown: disabled ? undefined : this.beginHandleMovement,
            onTouchStart: disabled ? undefined : this.beginHandleTouchMovement,
            ref: this.refHandlers.handle,
            style: this.getStyleProperties(),
            "aria-valuemin": min,
            "aria-valuemax": max,
            "aria-valuenow": value,
            "aria-disabled": disabled,
            "aria-orientation": vertical ? "vertical" : "horizontal",
            children: label == null ? null : (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                className: (0, $2cfd35af7ec11fdd$exports).SLIDER_LABEL,
                children: label
            })
        });
    }
    componentWillUnmount() {
        this.removeDocumentEventListeners();
    }
    /** Convert client pixel to value between min and max. */ clientToValue(clientPixel) {
        const { stepSize: stepSize, tickSize: tickSize, value: value, vertical: vertical } = this.props;
        if (this.handleElement == null) return value;
        // #1769: this logic doesn't work perfectly when the tick size is
        // smaller than the handle size; it may be off by a tick or two.
        const clientPixelNormalized = vertical ? window.innerHeight - clientPixel : clientPixel;
        const handleCenterPixel = this.getHandleElementCenterPixel(this.handleElement);
        const pixelDelta = clientPixelNormalized - handleCenterPixel;
        if (isNaN(pixelDelta)) return value;
        // convert pixels to range value in increments of `stepSize`
        return value + Math.round(pixelDelta / (tickSize * stepSize)) * stepSize;
    }
    mouseEventClientOffset(event) {
        return this.props.vertical ? event.clientY : event.clientX;
    }
    touchEventClientOffset(event) {
        const touch = event.changedTouches[0];
        return this.props.vertical ? touch.clientY : touch.clientX;
    }
    beginHandleMovement = (event)=>{
        document.addEventListener("mousemove", this.handleHandleMovement);
        document.addEventListener("mouseup", this.endHandleMovement);
        this.setState({
            isMoving: true
        });
        this.changeValue(this.clientToValue(this.mouseEventClientOffset(event)));
    };
    beginHandleTouchMovement = (event)=>{
        document.addEventListener("touchmove", this.handleHandleTouchMovement);
        document.addEventListener("touchend", this.endHandleTouchMovement);
        document.addEventListener("touchcancel", this.endHandleTouchMovement);
        this.setState({
            isMoving: true
        });
        this.changeValue(this.clientToValue(this.touchEventClientOffset(event)));
    };
    validateProps(props) {
        for (const prop of $d39e1859b9f182cb$var$NUMBER_PROPS){
            if (typeof props[prop] !== "number") throw new Error(`[Blueprint] <Handle> requires number value for ${prop} prop`);
        }
    }
    getStyleProperties = ()=>{
        if (this.handleElement == null) return {};
        // The handle midpoint of RangeSlider is actually shifted by a margin to
        // be on the edge of the visible handle element. Because the midpoint
        // calculation does not take this margin into account, we instead
        // measure the long side (which is equal to the short side plus the
        // margin).
        const { min: min = 0, tickSizeRatio: tickSizeRatio, value: value, vertical: vertical } = this.props;
        const { handleMidpoint: handleMidpoint } = this.getHandleMidpointAndOffset(this.handleElement, true);
        const offsetRatio = (value - min) * tickSizeRatio;
        const offsetCalc = `calc(${(0, $876b8992fdb2605d$export$3e1eee59f5dc52be)(offsetRatio)} - ${handleMidpoint}px)`;
        return vertical ? {
            bottom: offsetCalc
        } : {
            left: offsetCalc
        };
    };
    endHandleMovement = (event)=>{
        this.handleMoveEndedAt(this.mouseEventClientOffset(event));
    };
    endHandleTouchMovement = (event)=>{
        this.handleMoveEndedAt(this.touchEventClientOffset(event));
    };
    handleMoveEndedAt = (clientPixel)=>{
        this.removeDocumentEventListeners();
        this.setState({
            isMoving: false
        });
        // always invoke onRelease; changeValue may call onChange if value is different
        const finalValue = this.changeValue(this.clientToValue(clientPixel));
        this.props.onRelease?.(finalValue);
    };
    handleHandleMovement = (event)=>{
        this.handleMovedTo(this.mouseEventClientOffset(event));
    };
    handleHandleTouchMovement = (event)=>{
        this.handleMovedTo(this.touchEventClientOffset(event));
    };
    handleMovedTo = (clientPixel)=>{
        if (this.state.isMoving && !this.props.disabled) this.changeValue(this.clientToValue(clientPixel));
    };
    handleKeyDown = (event)=>{
        const { stepSize: stepSize, value: value } = this.props;
        const direction = (0, $5f04c694ca05154e$exports).getArrowKeyDirection(event, [
            "ArrowLeft",
            "ArrowDown"
        ], [
            "ArrowRight",
            "ArrowUp"
        ]);
        if (direction !== undefined) {
            this.changeValue(value + stepSize * direction);
            // this key event has been handled! prevent browser scroll on up/down
            event.preventDefault();
        }
    };
    handleKeyUp = (event)=>{
        if ((0, $5f04c694ca05154e$exports).isArrowKey(event)) this.props.onRelease?.(this.props.value);
    };
    /** Clamp value and invoke callback if it differs from current value */ changeValue(newValue, callback = this.props.onChange) {
        newValue = this.clamp(newValue);
        if (!isNaN(newValue) && this.props.value !== newValue) callback?.(newValue);
        return newValue;
    }
    /** Clamp value between min and max props */ clamp(value) {
        return (0, $5f04c694ca05154e$exports).clamp(value, this.props.min, this.props.max);
    }
    getHandleElementCenterPixel(handleElement) {
        const { handleMidpoint: handleMidpoint, handleOffset: handleOffset } = this.getHandleMidpointAndOffset(handleElement);
        return handleOffset + handleMidpoint;
    }
    getHandleMidpointAndOffset(handleElement, useOppositeDimension = false) {
        if (handleElement == null) return {
            handleMidpoint: 0,
            handleOffset: 0
        };
        const { vertical: vertical } = this.props;
        // N.B. element.clientHeight does not include border size.
        // Also, element.getBoundingClientRect() is useful to get the top & left position on the page, but
        // it fails to accurately measure element width & height inside absolutely-positioned and CSS-transformed
        // containers like Popovers, so we use element.offsetWidth & offsetHeight instead (see https://github.com/palantir/blueprint/issues/4417).
        const handleRect = handleElement.getBoundingClientRect();
        handleRect.width = handleElement.offsetWidth;
        handleRect.height = handleElement.offsetHeight;
        const sizeKey = vertical ? useOppositeDimension ? "width" : "height" : useOppositeDimension ? "height" : "width";
        // "bottom" value seems to be consistently incorrect, so explicitly
        // calculate it using the window offset instead.
        const handleOffset = vertical ? window.innerHeight - (handleRect.top + handleRect[sizeKey]) : handleRect.left;
        return {
            handleMidpoint: handleRect[sizeKey] / 2,
            handleOffset: handleOffset
        };
    }
    removeDocumentEventListeners() {
        document.removeEventListener("mousemove", this.handleHandleMovement);
        document.removeEventListener("mouseup", this.endHandleMovement);
        document.removeEventListener("touchmove", this.handleHandleTouchMovement);
        document.removeEventListener("touchend", this.endHandleTouchMovement);
        document.removeEventListener("touchcancel", this.endHandleTouchMovement);
    }
}


/*
 * Copyright 2018 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4c2f2050311a797f$export$d7dc57c4fbf7bb60 = {
    /** A full handle appears as a small square. */ FULL: "full",
    /** A start handle appears as the left or top half of a square. */ START: "start",
    /** An end handle appears as the right or bottom half of a square. */ END: "end"
};
const $4c2f2050311a797f$export$eb391d59b59f9c4b = {
    /** Locked handles prevent other handles from being dragged past then. */ LOCK: "lock",
    /** Push handles move overlapping handles with them as they are dragged. */ PUSH: "push",
    /**
     * Handles marked "none" are not interactive and do not appear in the UI.
     * They serve only to break the track into subsections that can be colored separately.
     */ NONE: "none"
};



const $a7f051f96a87527d$export$2add953d5976e300 = ()=>null;
$a7f051f96a87527d$export$2add953d5976e300.displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.MultiSliderHandle`;
class $a7f051f96a87527d$export$fc4448d95c7b75ac extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static defaultSliderProps = {
        disabled: false,
        max: 10,
        min: 0,
        showTrackFill: true,
        stepSize: 1,
        vertical: false
    };
    static defaultProps = {
        ...$a7f051f96a87527d$export$fc4448d95c7b75ac.defaultSliderProps,
        defaultTrackIntent: (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).NONE
    };
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.MultiSlider`;
    /** @deprecated Use `MultiSliderHandle` instead */ static Handle = $a7f051f96a87527d$export$2add953d5976e300;
    static getDerivedStateFromProps(props) {
        return {
            labelPrecision: $a7f051f96a87527d$export$fc4448d95c7b75ac.getLabelPrecision(props)
        };
    }
    static getLabelPrecision({ labelPrecision: labelPrecision, stepSize: stepSize }) {
        // infer default label precision from stepSize because that's how much the handle moves.
        return labelPrecision == null ? (0, $5f04c694ca05154e$exports).countDecimalPlaces(stepSize) : labelPrecision;
    }
    state = {
        labelPrecision: $a7f051f96a87527d$var$getLabelPrecision(this.props),
        tickSize: 0,
        tickSizeRatio: 0
    };
    handleElements = [];
    trackElement = null;
    getSnapshotBeforeUpdate(prevProps) {
        const prevHandleProps = $a7f051f96a87527d$var$getSortedInteractiveHandleProps(prevProps);
        const newHandleProps = $a7f051f96a87527d$var$getSortedInteractiveHandleProps(this.props);
        if (newHandleProps.length !== prevHandleProps.length) // clear refs
        this.handleElements = [];
        return null;
    }
    render() {
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).SLIDER, {
            [(0, $2cfd35af7ec11fdd$exports).DISABLED]: this.props.disabled,
            [`${(0, $2cfd35af7ec11fdd$exports).SLIDER}-unlabeled`]: this.props.labelRenderer === false,
            [(0, $2cfd35af7ec11fdd$exports).VERTICAL]: this.props.vertical
        }, this.props.className);
        return(// track delegates keyboard interaction to slider
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions
        (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            className: classes,
            onMouseDown: this.maybeHandleTrackClick,
            onTouchStart: this.maybeHandleTrackTouch,
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    className: (0, $2cfd35af7ec11fdd$exports).SLIDER_TRACK,
                    ref: (ref)=>this.trackElement = ref,
                    children: this.renderTracks()
                }),
                (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                    className: (0, $2cfd35af7ec11fdd$exports).SLIDER_AXIS,
                    children: this.renderLabels()
                }),
                this.renderHandles()
            ]
        }));
    }
    componentDidMount() {
        this.updateTickSize();
    }
    componentDidUpdate(prevProps, prevState) {
        super.componentDidUpdate(prevProps, prevState);
        this.updateTickSize();
    }
    validateProps(props) {
        if (props.stepSize <= 0) throw new Error($5bed6f2a5e88b283$export$3f628d74aa22ee14);
        if (props.labelStepSize !== undefined && props.labelValues !== undefined) throw new Error($5bed6f2a5e88b283$export$be7e9beb3b581c37);
        if (props.labelStepSize !== undefined && props.labelStepSize <= 0) throw new Error($5bed6f2a5e88b283$export$e1e1f71b44b50957);
        if (props.min !== undefined && !isFinite(props.min)) throw new Error($5bed6f2a5e88b283$export$bd089811e8f6237d);
        if (props.max !== undefined && !isFinite(props.max)) throw new Error($5bed6f2a5e88b283$export$34f34bdfff94a103);
        let anyInvalidChildren = false;
        (0, $kYL7Z.Children).forEach(props.children, (child)=>{
            // allow boolean coercion to omit nulls and false values
            if (child && !(0, $5f04c694ca05154e$exports).isElementOfType(child, $a7f051f96a87527d$export$2add953d5976e300)) anyInvalidChildren = true;
        });
        if (anyInvalidChildren) throw new Error($5bed6f2a5e88b283$export$5c23f31d1ea14389);
    }
    formatLabel(value, isHandleTooltip = false) {
        const { labelRenderer: labelRenderer } = this.props;
        if (labelRenderer === false) return undefined;
        else if ((0, $5f04c694ca05154e$exports).isFunction(labelRenderer)) return labelRenderer(value, {
            isHandleTooltip: isHandleTooltip
        });
        else return value.toFixed(this.state.labelPrecision);
    }
    renderLabels() {
        if (this.props.labelRenderer === false) return null;
        const values = this.getLabelValues();
        const { max: max, min: min } = this.props;
        const labels = values.map((step, i)=>{
            const offsetPercentage = (0, $876b8992fdb2605d$export$3e1eee59f5dc52be)((step - min) / (max - min));
            const style = this.props.vertical ? {
                bottom: offsetPercentage
            } : {
                left: offsetPercentage
            };
            return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                className: (0, $2cfd35af7ec11fdd$exports).SLIDER_LABEL,
                style: style,
                children: this.formatLabel(step)
            }, i);
        });
        return labels;
    }
    renderTracks() {
        const trackStops = $a7f051f96a87527d$var$getSortedHandleProps(this.props);
        trackStops.push({
            value: this.props.max
        });
        // render from current to previous, then increment previous
        let previous = {
            value: this.props.min
        };
        const handles = [];
        for(let index = 0; index < trackStops.length; index++){
            const current = trackStops[index];
            handles.push(this.renderTrackFill(index, previous, current));
            previous = current;
        }
        return handles;
    }
    renderTrackFill(index, start, end) {
        // ensure startRatio <= endRatio
        const [startRatio, endRatio] = [
            this.getOffsetRatio(start.value),
            this.getOffsetRatio(end.value)
        ].sort((left, right)=>left - right);
        const startOffset = (0, $876b8992fdb2605d$export$3e1eee59f5dc52be)(startRatio);
        const endOffset = (0, $876b8992fdb2605d$export$3e1eee59f5dc52be)(1 - endRatio);
        const orientationStyle = this.props.vertical ? {
            bottom: startOffset,
            left: 0,
            top: endOffset
        } : {
            left: startOffset,
            right: endOffset,
            top: 0
        };
        const style = {
            ...orientationStyle,
            ...start.trackStyleAfter || end.trackStyleBefore || {}
        };
        const classes = (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))((0, $2cfd35af7ec11fdd$exports).SLIDER_PROGRESS, (0, $2cfd35af7ec11fdd$exports).intentClass(this.getTrackIntent(start, end)));
        return (0, $fc31e5e9fc16a880$exports.jsx)("div", {
            className: classes,
            style: style
        }, `track-${index}`);
    }
    renderHandles() {
        const { disabled: disabled, max: max, min: min, stepSize: stepSize, vertical: vertical } = this.props;
        const handleProps = $a7f051f96a87527d$var$getSortedInteractiveHandleProps(this.props);
        if (handleProps.length === 0) return null;
        return handleProps.map(({ value: value, type: type, className: className, htmlProps: htmlProps }, index)=>(0, $fc31e5e9fc16a880$exports.jsx)((0, $d39e1859b9f182cb$export$94890c79f4cae6d6), {
                htmlProps: htmlProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($ef515bba949c7615$exports)))({
                    [(0, $2cfd35af7ec11fdd$exports).START]: type === (0, $4c2f2050311a797f$export$d7dc57c4fbf7bb60).START,
                    [(0, $2cfd35af7ec11fdd$exports).END]: type === (0, $4c2f2050311a797f$export$d7dc57c4fbf7bb60).END
                }, className),
                disabled: disabled,
                label: this.formatLabel(value, true),
                max: max,
                min: min,
                onChange: this.getHandlerForIndex(index, this.handleChange),
                onRelease: this.getHandlerForIndex(index, this.handleRelease),
                ref: this.addHandleRef,
                stepSize: stepSize,
                tickSize: this.state.tickSize,
                tickSizeRatio: this.state.tickSizeRatio,
                value: value,
                vertical: vertical
            }, `${index}-${handleProps.length}`));
    }
    addHandleRef = (ref)=>{
        if (ref != null) this.handleElements.push(ref);
    };
    maybeHandleTrackClick = (event)=>{
        if (this.canHandleTrackEvent(event)) {
            const foundHandle = this.nearestHandleForValue(this.handleElements, (handle)=>handle.mouseEventClientOffset(event));
            if (foundHandle) foundHandle.beginHandleMovement(event);
        }
    };
    maybeHandleTrackTouch = (event)=>{
        if (this.canHandleTrackEvent(event)) {
            const foundHandle = this.nearestHandleForValue(this.handleElements, (handle)=>handle.touchEventClientOffset(event));
            if (foundHandle) foundHandle.beginHandleTouchMovement(event);
        }
    };
    canHandleTrackEvent = (event)=>{
        const target = event.target;
        // ensure event does not come from inside the handle
        return !this.props.disabled && target.closest(`.${(0, $2cfd35af7ec11fdd$exports).SLIDER_HANDLE}`) == null;
    };
    nearestHandleForValue(handles, getOffset) {
        return (0, $876b8992fdb2605d$export$ec99a91cddfb29a2)(handles, (handle)=>{
            const offset = getOffset(handle);
            const offsetValue = handle.clientToValue(offset);
            const handleValue = handle.props.value;
            return Math.abs(offsetValue - handleValue);
        });
    }
    getHandlerForIndex = (index, callback)=>{
        return (newValue)=>{
            callback?.(this.getNewHandleValues(newValue, index));
        };
    };
    getNewHandleValues(newValue, oldIndex) {
        const handleProps = $a7f051f96a87527d$var$getSortedInteractiveHandleProps(this.props);
        const oldValues = handleProps.map((handle)=>handle.value);
        const newValues = oldValues.slice();
        newValues[oldIndex] = newValue;
        newValues.sort((left, right)=>left - right);
        const newIndex = newValues.indexOf(newValue);
        const lockIndex = this.findFirstLockedHandleIndex(oldIndex, newIndex);
        if (lockIndex === -1) (0, $876b8992fdb2605d$export$f0f90f0300c414d)(newValues, oldIndex, newIndex, newValue);
        else {
            // If pushing past a locked handle, discard the new value and only make the updates to clamp values against the lock.
            const lockValue = oldValues[lockIndex];
            (0, $876b8992fdb2605d$export$f0f90f0300c414d)(oldValues, oldIndex, lockIndex, lockValue);
            return oldValues;
        }
        return newValues;
    }
    findFirstLockedHandleIndex(startIndex, endIndex) {
        const inc = startIndex < endIndex ? 1 : -1;
        const handleProps = $a7f051f96a87527d$var$getSortedInteractiveHandleProps(this.props);
        for(let index = startIndex + inc; index !== endIndex + inc; index += inc){
            if (handleProps[index].interactionKind !== (0, $4c2f2050311a797f$export$eb391d59b59f9c4b).PUSH) return index;
        }
        return -1;
    }
    handleChange = (newValues)=>{
        const handleProps = $a7f051f96a87527d$var$getSortedInteractiveHandleProps(this.props);
        const oldValues = handleProps.map((handle)=>handle.value);
        if (!(0, $5f04c694ca05154e$exports).arraysEqual(newValues, oldValues)) {
            this.props.onChange?.(newValues);
            handleProps.forEach((handle, index)=>{
                if (oldValues[index] !== newValues[index]) handle.onChange?.(newValues[index]);
            });
        }
    };
    handleRelease = (newValues)=>{
        const handleProps = $a7f051f96a87527d$var$getSortedInteractiveHandleProps(this.props);
        this.props.onRelease?.(newValues);
        handleProps.forEach((handle, index)=>{
            handle.onRelease?.(newValues[index]);
        });
    };
    getLabelValues() {
        const { labelStepSize: labelStepSize, labelValues: labelValues, min: min, max: max } = this.props;
        let values = [];
        if (labelValues !== undefined) values = labelValues.slice();
        else for(let i = min; i < max || (0, $5f04c694ca05154e$exports).approxEqual(i, max); i += labelStepSize ?? 1)values.push(i);
        return values;
    }
    getOffsetRatio(value) {
        return (0, $5f04c694ca05154e$exports).clamp((value - this.props.min) * this.state.tickSizeRatio, 0, 1);
    }
    getTrackIntent(start, end) {
        if (!this.props.showTrackFill) return (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).NONE;
        if (start.intentAfter !== undefined) return start.intentAfter;
        else if (end !== undefined && end.intentBefore !== undefined) return end.intentBefore;
        return this.props.defaultTrackIntent;
    }
    updateTickSize() {
        if (this.trackElement != null) {
            const trackSize = this.props.vertical ? this.trackElement.clientHeight : this.trackElement.clientWidth;
            const tickSizeRatio = 1 / (this.props.max - this.props.min);
            const tickSize = trackSize * tickSizeRatio;
            this.setState({
                tickSize: tickSize,
                tickSizeRatio: tickSizeRatio
            });
        }
    }
}
function $a7f051f96a87527d$var$getLabelPrecision({ labelPrecision: labelPrecision, stepSize: stepSize = $a7f051f96a87527d$export$fc4448d95c7b75ac.defaultSliderProps.stepSize }) {
    // infer default label precision from stepSize because that's how much the handle moves.
    return labelPrecision == null ? (0, $5f04c694ca05154e$exports).countDecimalPlaces(stepSize) : labelPrecision;
}
function $a7f051f96a87527d$var$getSortedInteractiveHandleProps(props) {
    return $a7f051f96a87527d$var$getSortedHandleProps(props, (childProps)=>childProps.interactionKind !== (0, $4c2f2050311a797f$export$eb391d59b59f9c4b).NONE);
}
function $a7f051f96a87527d$var$getSortedHandleProps({ children: children }, predicate = ()=>true) {
    const maybeHandles = (0, $kYL7Z.Children).map(children, (child)=>(0, $5f04c694ca05154e$exports).isElementOfType(child, $a7f051f96a87527d$export$2add953d5976e300) && predicate(child.props) ? child.props : null);
    let handles = maybeHandles != null ? maybeHandles : [];
    handles = handles.filter((handle)=>handle !== null);
    handles.sort((left, right)=>left.value - right.value);
    return handles;
}


class $896355c3a74c4ebf$export$472062a354075cee extends (0, $ceff0151c81d8a08$export$844dfdc3b38c9679) {
    static defaultProps = {
        ...(0, $a7f051f96a87527d$export$fc4448d95c7b75ac).defaultSliderProps,
        initialValue: 0,
        intent: (0, $9489302fa7beb346$export$dc3e8878c31a5f1c).PRIMARY,
        value: 0
    };
    static displayName = `${0, $b898cefa02f59fb9$export$64b684a1d3f6f6a6}.Slider`;
    render() {
        const { initialValue: initialValue, intent: intent, value: value, onChange: onChange, onRelease: onRelease, handleHtmlProps: handleHtmlProps, ...props } = this.props;
        return (0, $fc31e5e9fc16a880$exports.jsxs)((0, $a7f051f96a87527d$export$fc4448d95c7b75ac), {
            ...props,
            children: [
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $a7f051f96a87527d$export$2add953d5976e300), {
                    value: value,
                    intentAfter: value < initialValue ? intent : undefined,
                    intentBefore: value > initialValue ? intent : undefined,
                    onChange: onChange,
                    onRelease: onRelease,
                    htmlProps: handleHtmlProps
                }),
                (0, $fc31e5e9fc16a880$exports.jsx)((0, $a7f051f96a87527d$export$2add953d5976e300), {
                    value: initialValue,
                    interactionKind: "none"
                })
            ]
        });
    }
}




const $2b0773f5e64aca7f$export$215309ed41a7fa73 = (col, amt)=>{
    var usePound = false;
    if (col[0] === '#') {
        col = col.slice(1);
        usePound = true;
    }
    var num = parseInt(col, 16);
    var r = (num >> 16) + amt;
    if (r > 255) r = 255;
    else if (r < 0) r = 0;
    var b = (num >> 8 & 0x00ff) + amt;
    if (b > 255) b = 255;
    else if (b < 0) b = 0;
    var g = (num & 0x0000ff) + amt;
    if (g > 255) g = 255;
    else if (g < 0) g = 0;
    return (usePound ? '#' : '') + (g | b << 8 | r << 16).toString(16);
};
const $2b0773f5e64aca7f$export$f1fbbe1776f7d7f = '#eff3f6';
const $2b0773f5e64aca7f$export$6472a8108632870e = '#CFD5D9';
const $2b0773f5e64aca7f$export$87c69c0dc894f992 = '#C31919';
const $2b0773f5e64aca7f$export$7a91b0fde7ec420f = 'rgb(0,0,0)';
const $2b0773f5e64aca7f$export$29814851e0aa981f = 'rgb(255,255,255)';
const $2b0773f5e64aca7f$export$aa201224bb439d47 = 'rgb(255,0,0)';
const $2b0773f5e64aca7f$export$738c3b9a44c87ecc = 'rgb(0,0,255)';
const $2b0773f5e64aca7f$export$48d4b2cd5bc0e88b = 'rgb(0,255,0)';
const $2b0773f5e64aca7f$export$aab610c505c06a8f = 'rgb(255,255,0)';
const $2b0773f5e64aca7f$export$c7e0129e68c19529 = 'rgba(255,0,0,0.1)';
const $2b0773f5e64aca7f$export$13891f961d0b567c = 'rgba(0,0,255,0.1)';
const $2b0773f5e64aca7f$export$c6a5ece72fb4d6b3 = 'rgba(0,255,0,0.1)';
const $2b0773f5e64aca7f$export$620f6a9fc4bba701 = 'rgba(255,255,0,0.1)';


const $b26bc1a5c2efa28f$var$TitleShape = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;

    &:hover {
        cursor: pointer;
    }
`;
const $b26bc1a5c2efa28f$var$PopOverContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: block;
    padding: 1em;
`;
const $b26bc1a5c2efa28f$var$ShapeHeader = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 1rem;
`;
const $b26bc1a5c2efa28f$var$H6Custom = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $64289e527bcd600c$export$a559fb8039b06400))`
    margin: 0.5em 0 !important;
    margin-left: 1em !important;
`;
const $b26bc1a5c2efa28f$var$StyledIcon = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $b90a50544ad30fb8$export$f04a61298a47a40f))`
    margin-left: auto;
`;
const $b26bc1a5c2efa28f$var$VisibilityIcon = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $b90a50544ad30fb8$export$f04a61298a47a40f))`
    margin-left: 0.5rem;
`;
const $b26bc1a5c2efa28f$var$ChangeNameMenu = ({ onSave: onSave, onCancel: onCancel, name: name })=>{
    const [changeShapeNameInput, setChangeShapeNameInput] = (0, $kYL7Z.useState)(name);
    const isButtonDisabled = changeShapeNameInput.length < 1;
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($b26bc1a5c2efa28f$var$PopOverContainer, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$a559fb8039b06400), {
                children: "Change Name"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                type: "text",
                leftIcon: "edit",
                placeholder: "New name",
                value: changeShapeNameInput,
                onChange: (e)=>{
                    console.log(e.target.value);
                    setChangeShapeNameInput(e.target.value);
                },
                onKeyDown: (e)=>{
                    if (e.key === 'Enter') onSave(changeShapeNameInput);
                }
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                text: "Change Name",
                intent: "primary",
                disabled: isButtonDisabled,
                onClick: ()=>onSave(changeShapeNameInput)
            })
        ]
    });
};
const $b26bc1a5c2efa28f$export$efe2c4435b86f96e = ({ elem: elem, beforeChange: beforeChange, afterChange: afterChange, isOpen: isOpen, handleCurrentMenuOpen: handleCurrentMenuOpen })=>{
    const { elems: elems, selected: selected, setSelected: setSelected, setElems: setElems, setCanvasMode: setCanvasMode, setHovered: setHovered } = (0, $kYL7Z.useContext)((0, $a85201d171878a8f$export$7879fcf4b5cbbcfa));
    const [version, setVersion] = (0, $kYL7Z.useState)(0); // just to re-render on update
    const [changingName, setChangingName] = (0, $kYL7Z.useState)(false); // just to re-render on update
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $kYL7Z.Fragment), {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
            onMouseEnter: ()=>{
                if (!isOpen || elem === selected) setHovered(elem);
            },
            onMouseLeave: ()=>{
                setHovered(null);
            },
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($b26bc1a5c2efa28f$var$TitleShape, {
                    onClick: ()=>handleCurrentMenuOpen(elem),
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b26bc1a5c2efa28f$var$VisibilityIcon, {
                            icon: elem.visible ? 'eye-open' : 'eye-off',
                            color: elem.visible ? null : (0, $2b0773f5e64aca7f$export$6472a8108632870e),
                            onClick: (e)=>{
                                e.stopPropagation();
                                elem.visible = !elem.visible;
                                setVersion(version + 1);
                                setElems(new (0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3)(elems.scale, elems.elems));
                            }
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($b26bc1a5c2efa28f$var$ShapeHeader, {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                    icon: Object.getPrototypeOf(elem) === (0, $7b598b71dfcbcd89$export$b0e83c3ef8d2db1).prototype ? 'flow-linear' : 'polygon-filter',
                                    color: (0, $2b0773f5e64aca7f$export$6472a8108632870e)
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b26bc1a5c2efa28f$var$H6Custom, {
                                    children: elem.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b26bc1a5c2efa28f$var$StyledIcon, {
                            icon: "caret-down",
                            color: (0, $2b0773f5e64aca7f$export$6472a8108632870e)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $49b7c0a83e560886$export$2e0a83ec2e27ecbb), {}),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $e4a7ce8c396337d4$export$78768a9af065a7b), {
                    isOpen: isOpen,
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $1d0e64f739af1a0c$export$d9b273488cd8ce6f), {
                        large: true,
                        className: "menu-edit-line__SubMenu",
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                position: "auto",
                                isOpen: changingName,
                                onClose: ()=>setChangingName(false),
                                content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b26bc1a5c2efa28f$var$ChangeNameMenu, {
                                    name: elem.name,
                                    onCancel: ()=>setChangingName(false),
                                    onSave: (newName)=>{
                                        if (elems.elems.map((e)=>e.name).includes(newName)) (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                            message: `Name ${newName} already exists`
                                        });
                                        else {
                                            beforeChange(); // save history
                                            elem.name = newName;
                                            setVersion(version + 1);
                                            afterChange(); // release changing and update canvas
                                            setChangingName(false);
                                        }
                                    }
                                }),
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                    text: `Change name`,
                                    icon: "edit",
                                    onClick: ()=>setChangingName(!changingName)
                                })
                            }),
                            Object.getPrototypeOf(elem) === (0, $7b598b71dfcbcd89$export$ea1a111407f37557).prototype && [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                    text: elem.ignore ? 'Make area trigger' : 'Make area ignore',
                                    icon: "exchange",
                                    onClick: ()=>{
                                        beforeChange(); // save history
                                        elem.ignore = !elem.ignore;
                                        setVersion(version + 1);
                                        afterChange(); // release changing and update canvas
                                    }
                                }, `${elem.name}-area-toggle-ignore`),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                    text: "Add new point (press p)",
                                    icon: "new-link",
                                    onClick: ()=>setCanvasMode({
                                            type: 'add-point',
                                            area: elem
                                        })
                                }, `${elem.name}-area-add-point`),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                    text: "Delete a point (press d)",
                                    icon: "delete",
                                    disabled: elem.poly.length <= 3,
                                    onClick: ()=>setCanvasMode({
                                            type: 'remove-point',
                                            area: elem
                                        })
                                }, `${elem.name}-area-delete-point`)
                            ],
                            Object.getPrototypeOf(elem) === (0, $7b598b71dfcbcd89$export$b0e83c3ef8d2db1).prototype && [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                    position: "auto",
                                    fill: true,
                                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($b26bc1a5c2efa28f$var$PopOverContainer, {
                                        style: {
                                            minWidth: 300,
                                            padding: '1.5em'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b26bc1a5c2efa28f$var$H6Custom, {
                                                children: "Change curvature"
                                            }),
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $896355c3a74c4ebf$export$472062a354075cee), {
                                                min: -1,
                                                max: 1,
                                                showTrackFill: !!elem.cf,
                                                labelRenderer: (value)=>`${Math.round(value * 100)}%`,
                                                labelStepSize: 0.5,
                                                value: elem.cf,
                                                stepSize: 0.01,
                                                onChange: (value)=>{
                                                    beforeChange(); // save history
                                                    elem.cf = value;
                                                    setVersion(version + 1);
                                                    setElems(new (0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3)(elems.scale, elems.elems));
                                                },
                                                onRelease: ()=>{
                                                    afterChange(); // release changing and update canvas
                                                }
                                            })
                                        ]
                                    }),
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                        text: "Curvature",
                                        icon: !!elem.cf ? 'circle' : 'layout-linear'
                                    })
                                }, `${elem.name}-line-change-cf`),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $5ebb8a1948a3d723$export$5b6b19405a83ff9d), {
                                    position: "auto",
                                    fill: true,
                                    content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($b26bc1a5c2efa28f$var$PopOverContainer, {
                                        style: {
                                            minWidth: 300,
                                            padding: '1.5em'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b26bc1a5c2efa28f$var$H6Custom, {
                                                children: "Change var"
                                            }),
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $896355c3a74c4ebf$export$472062a354075cee), {
                                                min: 0,
                                                max: 30,
                                                showTrackFill: !!elem.vari,
                                                labelRenderer: (value)=>`${value}px`,
                                                labelStepSize: 5,
                                                value: elem.vari,
                                                stepSize: 1,
                                                onChange: (value)=>{
                                                    beforeChange(); // save history
                                                    elem.vari = value;
                                                    setVersion(version + 1);
                                                    setElems(new (0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3)(elems.scale, elems.elems));
                                                },
                                                onRelease: ()=>{
                                                    afterChange(); // release changing and update canvas
                                                }
                                            })
                                        ]
                                    }),
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                        text: "Variance",
                                        icon: "bring-data"
                                    })
                                }, `${elem.name}-line-change-vari`)
                            ],
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                text: `Duplicate ${elem.name}`,
                                icon: "duplicate",
                                intent: "success",
                                onClick: ()=>{
                                    beforeChange();
                                    const newElem = elems.copy(elem);
                                    setSelected(newElem);
                                    setVersion(version + 1);
                                    afterChange(); // release changing and update canvas
                                }
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                text: `Delete ${elem.name}`,
                                icon: "eraser",
                                intent: "danger",
                                onClick: ()=>{
                                    if (selected === elem) setSelected(null);
                                    beforeChange();
                                    elems.remove(elem);
                                    setVersion(version + 1);
                                    afterChange(); // release changing and update canvas
                                }
                            })
                        ]
                    })
                })
            ]
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");


var $i5w0I = parcelRequire("i5w0I");






var $kYL7Z = parcelRequire("kYL7Z");


const $fb91c79deafd52e0$export$215afc2e3ca9773d = ({ elems: elems, setShapeHighlight: setShapeHighlight, lineContext: lineContext, deleteContext: deleteContext, editItem: editItem, getActionType: getActionType })=>{
    const [showButtons, setShowButtons] = (0, $kYL7Z.useState)(false);
    const lines = lineContext.actions && !!elems?.curves ? elems.curves.filter((curve)=>{
        return !!lineContext.actions.find((action)=>{
            return action[0].lineId === curve.name;
        });
    }) : [];
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
        $hoverColor: "#d7e4f7",
        onMouseOver: ()=>{
            setShowButtons(true);
            lines.forEach((line)=>setShapeHighlight(line, true));
        },
        onMouseLeave: ()=>{
            setShowButtons(false);
            lines.forEach((line)=>setShapeHighlight(line, false));
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 2,
                halign: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    children: lineContext.type
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 3,
                haligh: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
                    children: lineContext.actions.map((action, actionIndex)=>{
                        if (!action[0] || !action[1]) return null;
                        const actionsTuple = [
                            action[0],
                            action[1]
                        ];
                        const actionType = getActionType(actionsTuple);
                        return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                    halign: "right",
                                    valign: "center",
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                        intent: "primary",
                                        children: `${action[0].lineId}`
                                    })
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                    halign: "left",
                                    valign: "center",
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                        children: actionType ? actionType : ''
                                    })
                                })
                            ]
                        }, actionIndex);
                    })
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 3,
                haligh: "center",
                valign: "center",
                children: (lineContext.type === 'within-location-entry' || lineContext.type === 'within-location-pass-by') && lineContext.metadata && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
                    children: lineContext.metadata.map((metadataItem, index)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                    halign: "right",
                                    valign: "center",
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                        intent: "primary",
                                        children: metadataItem.key
                                    })
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                    halign: "left",
                                    valign: "center",
                                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                        children: metadataItem.value
                                    })
                                })
                            ]
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 1,
                halign: "right",
                valign: "center",
                gap: "5px",
                children: showButtons && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "edit",
                            htmlTitle: "Edit",
                            intent: "success",
                            onClick: ()=>editItem(lineContext)
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "trash",
                            htmlTitle: "Delete",
                            intent: "danger",
                            onClick: ()=>deleteContext(lineContext)
                        })
                    ]
                })
            })
        ]
    }, lineContext.id);
};




var $kYL7Z = parcelRequire("kYL7Z");




const $18d435d731a269a7$var$IN_ACTION = [
    {
        direction: 'in',
        crossed: true
    },
    {
        direction: 'out',
        crossed: false
    }
];
const $18d435d731a269a7$var$OUT_ACTION = [
    {
        direction: 'out',
        crossed: true
    },
    {
        direction: 'in',
        crossed: false
    }
];
const $18d435d731a269a7$var$IN_AND_OUT_ACTION = [
    {
        direction: 'out',
        crossed: true
    },
    {
        direction: 'in',
        crossed: true
    }
];
const $18d435d731a269a7$var$requiresMeta = (type)=>type === 'within-location-entry' || type === 'within-location-pass-by';
const $18d435d731a269a7$export$a6e577d60ecacb81 = ({ item: initialItem, keysAndValuesInUse: initialKeysAndValuesInUse, elems: elems, cancelEditing: cancelEditing, editItem: editItem, saveItem: saveItem, setShapeHighlight: setShapeHighlight, getActionType: getActionType, loadingTaxonomies: loadingTaxonomies })=>{
    const [keysAndValuesInUse, setKeysAndValuesInUse] = (0, $kYL7Z.useState)(initialKeysAndValuesInUse);
    const [item, setItem] = (0, $kYL7Z.useState)(initialItem);
    (0, $kYL7Z.useEffect)(()=>{
        setKeysAndValuesInUse(initialKeysAndValuesInUse);
    }, [
        initialKeysAndValuesInUse
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        editItem(item);
    }, [
        item
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        const updates = {};
        if (!item.actions || item.actions.length === 0) updates.actions = [
            [
                {
                    lineId: null,
                    direction: 'in',
                    crossed: true
                },
                {
                    lineId: null,
                    direction: 'out',
                    crossed: false
                }
            ]
        ];
        if ($18d435d731a269a7$var$requiresMeta(item.type) && (!item.metadata || item.metadata.length === 0)) updates.metadata = [
            {
                key: '',
                value: ''
            }
        ];
        if (Object.keys(updates).length) setItem({
            ...item,
            ...updates
        });
    }, [
        item.type
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 2,
                halign: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                    popoverProps: {
                        minimal: true
                    },
                    items: [
                        "location-entry",
                        "location-pass-by",
                        "within-location-entry",
                        "within-location-pass-by"
                    ],
                    filterable: false,
                    itemRenderer: (tType, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                            text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                minimal: true,
                                children: `${tType}`
                            }),
                            onClick: handleClick
                        }, tType),
                    noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                        disabled: true,
                        text: "No results."
                    }),
                    onItemSelect: (tType)=>setItem({
                            ...item,
                            type: tType
                        }),
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                        minimal: true,
                        rightIcon: "caret-down",
                        children: item.type || "Context Type"
                    })
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 3,
                haligh: "center",
                valign: "center",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
                    children: [
                        item.actions?.map((action, actionIndex)=>{
                            if (!action[0] || !action[1]) return null;
                            const actionsTuple = [
                                action[0],
                                action[1]
                            ];
                            const actionType = getActionType(actionsTuple);
                            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        halign: "right",
                                        valign: "center",
                                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                                            popoverProps: {
                                                minimal: true
                                            },
                                            items: elems.curves,
                                            filterable: false,
                                            itemRenderer: (elem, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                    text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                        minimal: true,
                                                        intent: "primary",
                                                        children: elem.name
                                                    }),
                                                    onMouseEnter: ()=>setShapeHighlight(elem, true),
                                                    onMouseLeave: ()=>setShapeHighlight(elem, false),
                                                    onClick: handleClick
                                                }, elem.name),
                                            noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                disabled: true,
                                                text: "No results."
                                            }),
                                            onItemSelect: (elem)=>{
                                                const newActions = [
                                                    ...item.actions
                                                ];
                                                newActions[actionIndex] = [
                                                    {
                                                        ...newActions[actionIndex][0],
                                                        lineId: elem.name
                                                    },
                                                    {
                                                        ...newActions[actionIndex][1],
                                                        lineId: elem.name
                                                    }
                                                ];
                                                setItem({
                                                    ...item,
                                                    actions: newActions
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                minimal: true,
                                                rightIcon: "caret-down",
                                                intent: action[0].lineId ? "primary" : "none",
                                                children: action[0].lineId || "Select line"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        halign: "left",
                                        valign: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                                                popoverProps: {
                                                    minimal: true
                                                },
                                                items: [
                                                    "in",
                                                    "out",
                                                    "in-out"
                                                ],
                                                filterable: false,
                                                itemRenderer: (direction, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                        text: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                            minimal: true,
                                                            children: `${direction}`
                                                        }),
                                                        onClick: handleClick
                                                    }, direction),
                                                noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                    disabled: true,
                                                    text: "No results."
                                                }),
                                                onItemSelect: (direction)=>{
                                                    const lineId = action[0].lineId;
                                                    const base = direction === 'in' ? $18d435d731a269a7$var$IN_ACTION : direction === 'out' ? $18d435d731a269a7$var$OUT_ACTION : $18d435d731a269a7$var$IN_AND_OUT_ACTION;
                                                    const newActions = [
                                                        ...item.actions
                                                    ];
                                                    newActions[actionIndex] = [
                                                        {
                                                            ...base[0],
                                                            lineId: lineId
                                                        },
                                                        {
                                                            ...base[1],
                                                            lineId: lineId
                                                        }
                                                    ];
                                                    setItem({
                                                        ...item,
                                                        actions: newActions
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                                                    minimal: true,
                                                    rightIcon: "caret-down",
                                                    children: actionType || "Direction"
                                                })
                                            }),
                                            item.actions?.length > 1 && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                                style: {
                                                    paddingLeft: "2px"
                                                },
                                                icon: "cross",
                                                onClick: ()=>{
                                                    item.actions.splice(actionIndex, 1);
                                                    setItem({
                                                        ...item
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, actionIndex);
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                haligh: "center",
                                valign: "bottom",
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    small: true,
                                    text: "add line",
                                    icon: "plus",
                                    fill: true,
                                    onClick: ()=>{
                                        const actions = item.actions ? item.actions : [];
                                        actions.push([
                                            {
                                                lineId: null,
                                                direction: 'in',
                                                crossed: true
                                            },
                                            {
                                                lineId: null,
                                                direction: 'out',
                                                crossed: false
                                            }
                                        ]);
                                        item.actions = actions;
                                        setItem({
                                            ...item
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 3,
                haligh: "center",
                valign: "center",
                children: (item.type === 'within-location-entry' || item.type === 'within-location-pass-by') && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
                    children: [
                        item.metadata?.map((meta, index)=>{
                            return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        halign: "right",
                                        valign: "center",
                                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d5a00f6d9a6cdc43$export$e0a397508a37e5a7), {
                                            popoverProps: {
                                                minimal: true
                                            },
                                            inputProps: {
                                                small: true,
                                                fill: false
                                            },
                                            query: meta.key ?? '',
                                            items: !loadingTaxonomies && keysAndValuesInUse?.keys?.length ? keysAndValuesInUse.keys.sort() : [],
                                            itemPredicate: (query, item)=>!!item && item.toLowerCase().indexOf(query.toLowerCase()) >= 0,
                                            inputValueRenderer: (val)=>val,
                                            itemRenderer: (key, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                    text: `${key}`,
                                                    onClick: handleClick
                                                }, `${key}-${index}`),
                                            noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                disabled: true,
                                                text: "No results."
                                            }),
                                            onItemSelect: (key)=>{
                                                const newMetadata = item.metadata.map((m, i)=>i === index ? {
                                                        ...m,
                                                        key: key
                                                    } : m);
                                                setItem({
                                                    ...item,
                                                    metadata: newMetadata
                                                });
                                            },
                                            onQueryChange: (key)=>{
                                                const newMetadata = item.metadata.map((m, i)=>i === index ? {
                                                        ...m,
                                                        key: key
                                                    } : m);
                                                setItem({
                                                    ...item,
                                                    metadata: newMetadata
                                                });
                                            }
                                        })
                                    }, index),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                        halign: "left",
                                        valign: "center",
                                        children: [
                                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d5a00f6d9a6cdc43$export$e0a397508a37e5a7), {
                                                popoverProps: {
                                                    minimal: true
                                                },
                                                inputProps: {
                                                    small: true
                                                },
                                                query: meta.value ?? '',
                                                items: !loadingTaxonomies && keysAndValuesInUse?.values?.length ? keysAndValuesInUse.values.sort() : [],
                                                itemPredicate: (query, item)=>!!item && item.toLowerCase().indexOf(query.toLowerCase()) >= 0,
                                                inputValueRenderer: (val)=>val,
                                                itemRenderer: (value, { handleClick: handleClick })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                        text: `${value}`,
                                                        onClick: handleClick
                                                    }, `${value}-${index}`),
                                                noResults: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                                                    disabled: true,
                                                    text: "No results."
                                                }),
                                                onItemSelect: (value)=>{
                                                    const newMetadata = item.metadata.map((m, i)=>i === index ? {
                                                            ...m,
                                                            value: value
                                                        } : m);
                                                    setItem({
                                                        ...item,
                                                        metadata: newMetadata
                                                    });
                                                },
                                                onQueryChange: (value)=>{
                                                    const newMetadata = item.metadata.map((m, i)=>i === index ? {
                                                            ...m,
                                                            value: value
                                                        } : m);
                                                    setItem({
                                                        ...item,
                                                        metadata: newMetadata
                                                    });
                                                }
                                            }),
                                            !($18d435d731a269a7$var$requiresMeta(item.type) && item.metadata?.length <= 1) && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                                                style: {
                                                    paddingLeft: "2px"
                                                },
                                                icon: "cross",
                                                onClick: ()=>{
                                                    item.metadata.splice(index, 1);
                                                    setItem({
                                                        ...item
                                                    });
                                                }
                                            })
                                        ]
                                    })
                                ]
                            }, index);
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                                haligh: "center",
                                valign: "bottom",
                                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    small: true,
                                    text: "add meta",
                                    icon: "plus",
                                    fill: true,
                                    onClick: ()=>{
                                        const metas = item.metadata ? item.metadata : [];
                                        metas.push({
                                            key: '',
                                            value: ''
                                        });
                                        item.metadata = metas;
                                        setItem({
                                            ...item
                                        });
                                    }
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                span: 1,
                halign: "right",
                valign: "center",
                gap: "5px",
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "floppy-disk",
                            htmlTitle: "Save",
                            intent: "success",
                            onClick: ()=>{
                                if (!item.actions?.length || item.actions.some((a)=>!a[0]?.lineId)) {
                                    (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                        message: 'Every action must have a line selected'
                                    });
                                    return;
                                }
                                if ($18d435d731a269a7$var$requiresMeta(item.type)) {
                                    if (!item.metadata?.length) {
                                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                            message: 'At least one metadata entry is required'
                                        });
                                        return;
                                    }
                                    const hasEmptyMeta = item.metadata?.some((m)=>!m.key?.trim() || !m.value?.trim());
                                    if (hasEmptyMeta) {
                                        (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                                            message: 'Metadata key and value cannot be empty'
                                        });
                                        return;
                                    }
                                }
                                saveItem(item);
                            }
                        }),
                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "delete",
                            htmlTitle: "Cancel",
                            intent: "danger",
                            onClick: cancelEditing
                        })
                    ]
                })
            })
        ]
    });
};


const $26a3e7da384faf9d$var$IN_ACTION = [
    {
        direction: 'in',
        crossed: true
    },
    {
        direction: 'out',
        crossed: false
    }
];
const $26a3e7da384faf9d$var$OUT_ACTION = [
    {
        direction: 'out',
        crossed: true
    },
    {
        direction: 'in',
        crossed: false
    }
];
const $26a3e7da384faf9d$var$IN_AND_OUT_ACTION = [
    {
        direction: 'out',
        crossed: true
    },
    {
        direction: 'in',
        crossed: true
    }
];
// -------- helper functions
const $26a3e7da384faf9d$var$sortActions = (actions)=>{
    return actions.sort((a, b)=>a.direction > b.direction ? 1 : -1);
};
const $26a3e7da384faf9d$var$getActionType = (actions)=>{
    const actionsWithoutId = actions.map(({ direction: direction, crossed: crossed })=>{
        return {
            direction: direction,
            crossed: crossed
        };
    });
    if ((0, $i5w0I.isEqual)($26a3e7da384faf9d$var$sortActions(actionsWithoutId), $26a3e7da384faf9d$var$sortActions($26a3e7da384faf9d$var$IN_ACTION))) return 'in';
    else if ((0, $i5w0I.isEqual)($26a3e7da384faf9d$var$sortActions(actionsWithoutId), $26a3e7da384faf9d$var$sortActions($26a3e7da384faf9d$var$OUT_ACTION))) return 'out';
    else if ((0, $i5w0I.isEqual)($26a3e7da384faf9d$var$sortActions(actionsWithoutId), $26a3e7da384faf9d$var$sortActions($26a3e7da384faf9d$var$IN_AND_OUT_ACTION))) return 'in_out';
    return undefined;
};
function $26a3e7da384faf9d$export$6fbb920465926add({ recording: recording, elems: elems, taxonomiesInUse: taxonomiesInUse, keysAndValuesInUse: propKeysAndValuesInUse, loadingTaxonomies: loadingTaxonomies, updateEditRecordingPageState: updateEditRecordingPageState, setShapeHighlight: setShapeHighlight }) {
    const { loading: loading, setLoading: setLoading } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [lineContexts, setLineContexts] = (0, $kYL7Z.useState)(recording?.lineContexts || []);
    const [addingItem, setAddingItem] = (0, $kYL7Z.useState)(false);
    const [editingExistedItem, setEditingExistedItem] = (0, $kYL7Z.useState)(null);
    const [keysAndValuesInUse, setKeysAndValuesInUse] = (0, $kYL7Z.useState)(propKeysAndValuesInUse);
    const needsSyncRef = (0, $kYL7Z.useRef)(false);
    // Initialise from props if state is null/undefined
    (0, $kYL7Z.useEffect)(()=>{
        if (!lineContexts && recording?.lineContexts?.length) setLineContexts(recording.lineContexts);
    }, [
        recording?.lineContexts
    ]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!keysAndValuesInUse && propKeysAndValuesInUse) setKeysAndValuesInUse(propKeysAndValuesInUse);
    }, [
        propKeysAndValuesInUse
    ]);
    // Sync to recording + trigger save after state updates flagged by needsSyncRef
    (0, $kYL7Z.useEffect)(()=>{
        if (needsSyncRef.current) {
            needsSyncRef.current = false;
            recording.lineContexts = lineContexts;
            updateEditRecordingPageState();
        }
    }, [
        lineContexts
    ]);
    function beginAddingNewContext() {
        setAddingItem(!addingItem);
    }
    function stopAddingNewContext() {
        setAddingItem(false);
    }
    function validateContext(context) {
        let doThrow = false;
        if (!context.type) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Missing a type'
            });
            doThrow = true;
        }
        if (context.type === 'within-location-movement' && !context.withinLocationMovementKey) {
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Missing a withinLocationMovementKey'
            });
            doThrow = true;
        }
        if (doThrow) throw new Error('Invalid form');
    }
    async function saveNewContext(context) {
        const prevLocation = loading.location;
        // sanitize: strip _id and extra fields from actions and metadata before API call
        if (context.actions) context.actions = context.actions.map((pair)=>pair.map(({ lineId: lineId, direction: direction, crossed: crossed })=>({
                    lineId: lineId,
                    direction: direction,
                    crossed: crossed
                })));
        if (context.metadata && (context.type === 'within-location-entry' || context.type === 'within-location-pass-by')) context.metadata = context.metadata.map(({ key: key, value: value })=>({
                key: key,
                value: value
            }));
        else delete context.metadata;
        if (context.type !== 'within-location-movement') delete context.withinLocationMovementKey;
        setLoading({
            status: true,
            location: "Saving line context..."
        });
        // do api call — use context.id to distinguish update vs create
        if (context.id) try {
            validateContext(context);
            const response = await (0, $5a9cade4af2d6a52$export$4ea2e4f1695ba788).update(context, recording.id);
            if (response) {
                const filteredLineContexts = lineContexts.reduce((finalLineContexts, lContext)=>{
                    if (lContext.id !== context.id) finalLineContexts.push(lContext);
                    return finalLineContexts;
                }, []);
                needsSyncRef.current = true;
                setAddingItem(false);
                setEditingExistedItem(null);
                setLineContexts([
                    ...filteredLineContexts,
                    response
                ]);
            } else {
                setAddingItem(false);
                setEditingExistedItem(null);
            }
        } catch (e) {
        // validation or API error
        } finally{
            setLoading({
                status: false,
                location: prevLocation
            });
        }
        else try {
            validateContext(context);
            const response = await (0, $5a9cade4af2d6a52$export$4ea2e4f1695ba788).create(context, recording.id);
            if (response) {
                needsSyncRef.current = true;
                setAddingItem(false);
                setLineContexts([
                    ...lineContexts,
                    response
                ]);
            } else setAddingItem(false);
        } catch (e) {
        // validation or API error
        } finally{
            setLoading({
                status: false,
                location: prevLocation
            });
        }
    }
    function deleteContext(context) {
        if (window.confirm('Are you sure you want to delete this lineContext?')) {
            const prevLocation = loading.location;
            setLoading({
                status: true,
                location: "Deleting line context..."
            });
            if (context.id) (0, $5a9cade4af2d6a52$export$4ea2e4f1695ba788).delete(context.id).then(()=>{
                needsSyncRef.current = true;
                setLineContexts([
                    ...lineContexts.filter((lc)=>lc.id !== context.id)
                ]);
            }).catch((e)=>{
                (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                    message: 'Failed to delete line context'
                });
            }).finally(()=>{
                setLoading({
                    status: false,
                    location: prevLocation
                });
            });
            else setLoading({
                status: false,
                location: prevLocation
            });
        }
    }
    function handleBeingEditedLineContext(context) {
        setEditingExistedItem(context);
    }
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$54ec01a60f47d33d), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        haligh: "left",
                        valign: "center",
                        span: 2,
                        children: [
                            lineContexts?.length ?? "No",
                            " line contexts"
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        span: 1,
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                            icon: "plus",
                            text: "Add New",
                            fill: true,
                            onClick: beginAddingNewContext
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                $separatorColor: "silver",
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 2,
                        halign: "center",
                        children: "Type"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 3,
                        halign: "center",
                        children: "Actions"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 3,
                        halign: "center",
                        children: "Context"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                        header: true,
                        span: 1,
                        halign: "center",
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "more"
                        })
                    })
                ]
            }),
            lineContexts && lineContexts.sort((a, b)=>a.createdAt < b.createdAt ? -1 : 1).map((lc, index)=>{
                if (editingExistedItem && editingExistedItem.id === lc.id) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $18d435d731a269a7$export$a6e577d60ecacb81), {
                    item: editingExistedItem,
                    keysAndValuesInUse: keysAndValuesInUse,
                    elems: elems,
                    cancelEditing: ()=>handleBeingEditedLineContext(null),
                    editItem: handleBeingEditedLineContext,
                    saveItem: saveNewContext,
                    setShapeHighlight: setShapeHighlight,
                    getActionType: $26a3e7da384faf9d$var$getActionType,
                    loadingTaxonomies: loadingTaxonomies
                }, lc.id);
                else return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $fb91c79deafd52e0$export$215afc2e3ca9773d), {
                    elems: elems,
                    setShapeHighlight: setShapeHighlight,
                    lineContext: lc,
                    deleteContext: deleteContext,
                    editItem: handleBeingEditedLineContext,
                    getActionType: $26a3e7da384faf9d$var$getActionType
                }, lc.id);
            }),
            addingItem && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$b59bdbef9ce70de2), {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15ced77767d3eb63$export$f6f0c3fe4ec306ea), {
                    halign: "center",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("h4", {
                        children: "Adding new item"
                    })
                })
            }),
            addingItem && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $kYL7Z.Fragment), {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $18d435d731a269a7$export$a6e577d60ecacb81), {
                    item: {},
                    keysAndValuesInUse: keysAndValuesInUse,
                    elems: elems,
                    cancelEditing: ()=>{
                        handleBeingEditedLineContext(null);
                        setAddingItem(false);
                    },
                    editItem: handleBeingEditedLineContext,
                    saveItem: saveNewContext,
                    setShapeHighlight: setShapeHighlight,
                    getActionType: $26a3e7da384faf9d$var$getActionType,
                    loadingTaxonomies: loadingTaxonomies
                })
            })
        ]
    });
}


function $9e9b6d08ce7b7c61$export$b40aeba347da4106({ currentActiveMenuSection: initialSection, loadingTaxonomies: loadingTaxonomies, taxonomiesInUse: taxonomiesInUse, keysAndValuesInUse: keysAndValuesInUse, beforeChange: beforeChange, afterChange: afterChange, onElemsAction: onElemsAction }) {
    const { elems: elems, selected: selected, recording: recording, setSelected: setSelected, setHovered: setHovered, fetch: fetch } = (0, $kYL7Z.useContext)((0, $a85201d171878a8f$export$7879fcf4b5cbbcfa));
    const [currentActiveMenuSection, setCurrentActiveMenuSection] = (0, $kYL7Z.useState)(initialSection || 'areas');
    const prevSelectedRef = (0, $kYL7Z.useRef)(null);
    const prevElemsRef = (0, $kYL7Z.useRef)(null);
    // Auto-switch tab when selection changes
    (0, $kYL7Z.useEffect)(()=>{
        if (selected !== prevSelectedRef.current || elems !== prevElemsRef.current) {
            prevSelectedRef.current = selected;
            prevElemsRef.current = elems;
            if (selected && elems) {
                const nextSection = elems.areas.some((a)=>a.meOrMyChild(selected)) ? 'areas' : elems.curves.some((l)=>l.meOrMyChild(selected)) ? 'lines' : currentActiveMenuSection;
                handleSectionChange(nextSection);
            }
        }
    }, [
        elems,
        selected
    ]);
    function handleSectionChange(option) {
        if (currentActiveMenuSection !== option) {
            const url = new URL(window.location.href);
            url.searchParams.set("currentActiveMenuSection", option);
            window.history.pushState({}, '', url.toString());
            setCurrentActiveMenuSection(option);
        }
    }
    function handleCurrentMenuOpen(elem) {
        setSelected(selected === elem ? null : elem);
    }
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $kYL7Z.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $9aea662359a2cfdc$export$69b1032f2ecdf404), {
                fill: true,
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        onClick: ()=>handleSectionChange('areas'),
                        icon: "polygon-filter",
                        intent: currentActiveMenuSection === 'areas' ? 'primary' : 'none',
                        children: "Areas"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        onClick: ()=>handleSectionChange('lines'),
                        icon: "flow-linear",
                        intent: currentActiveMenuSection === 'lines' ? 'primary' : 'none',
                        children: "Lines"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        onClick: ()=>handleSectionChange('area_contexts'),
                        icon: "send-to-graph",
                        intent: currentActiveMenuSection === 'area_contexts' ? 'primary' : 'none',
                        children: "Area contexts"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                        onClick: ()=>handleSectionChange('line_contexts'),
                        icon: "new-link",
                        intent: currentActiveMenuSection === 'line_contexts' ? 'primary' : 'none',
                        children: "Line contexts"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $450a5f12f45aa946$export$a102f9a6b21a7345), {
                type: currentActiveMenuSection,
                title: {
                    'areas': 'Areas',
                    'lines': 'Lines',
                    'area_contexts': 'Area contexts',
                    'line_contexts': 'Line Contexts'
                }[currentActiveMenuSection],
                createNewShape: (type, name)=>{
                    if (type === 'lines' || type === 'areas') {
                        beforeChange();
                        elems.addDefault(type, name);
                        afterChange();
                    }
                }
            }),
            elems && currentActiveMenuSection === 'areas' && elems.areas.map((elem, index)=>{
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b26bc1a5c2efa28f$export$efe2c4435b86f96e), {
                    elem: elem,
                    isOpen: selected && elem.meOrMyChild(selected),
                    beforeChange: beforeChange,
                    afterChange: afterChange,
                    handleCurrentMenuOpen: handleCurrentMenuOpen
                }, `${elem.name}-${index}`);
            }),
            elems && currentActiveMenuSection === 'lines' && elems.curves.map((elem, index)=>{
                return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b26bc1a5c2efa28f$export$efe2c4435b86f96e), {
                    elem: elem,
                    isOpen: selected && elem.meOrMyChild(selected),
                    beforeChange: beforeChange,
                    afterChange: afterChange,
                    handleCurrentMenuOpen: handleCurrentMenuOpen
                }, `${elem.name}-${index}`);
            }),
            elems && currentActiveMenuSection === "area_contexts" && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9e81588227b91752$export$2e2bcd8739ae039), {
                recording: recording,
                elems: elems,
                taxonomiesInUse: taxonomiesInUse,
                loadingTaxonomies: loadingTaxonomies,
                updateEditRecordingPageState: ()=>{
                    onElemsAction({
                        action: 'save-changes'
                    });
                },
                setShapeHighlight: (elem, highlight)=>{
                    setHovered(highlight ? elem : null);
                }
            }),
            currentActiveMenuSection === "line_contexts" && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $26a3e7da384faf9d$export$6fbb920465926add), {
                recording: recording,
                elems: elems,
                taxonomiesInUse: taxonomiesInUse,
                keysAndValuesInUse: keysAndValuesInUse,
                loadingTaxonomies: loadingTaxonomies,
                updateEditRecordingPageState: ()=>{
                    onElemsAction({
                        action: 'save-changes'
                    });
                    fetch(recording.id);
                },
                setShapeHighlight: (elem, highlight)=>{
                    setHovered(highlight ? elem : null);
                }
            })
        ]
    });
}




var $kYL7Z = parcelRequire("kYL7Z");





const $c07e3ed9bfc135c4$var$STEP_CHOICE = 'choice';
const $c07e3ed9bfc135c4$var$STEP_MOVE = 'move';
const $c07e3ed9bfc135c4$var$STEP_DETACH = 'detach';
const $c07e3ed9bfc135c4$var$MOVE_SELECT = 'select';
const $c07e3ed9bfc135c4$var$MOVE_CONFIRM = 'confirm';
const $c07e3ed9bfc135c4$var$MOVE_DONE = 'done';
const $c07e3ed9bfc135c4$var$MoveStep = ({ recording: recording, onClose: onClose })=>{
    const [devices, setDevices] = (0, $kYL7Z.useState)(null);
    const [selected, setSelected] = (0, $kYL7Z.useState)(null);
    const [subStep, setSubStep] = (0, $kYL7Z.useState)($c07e3ed9bfc135c4$var$MOVE_SELECT);
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const organisationId = recording.organisation?._id;
    const organisationName = recording.organisation?.name;
    const locationId = recording.location?._id;
    const locationName = recording.location?.name;
    const currentDeviceName = recording.cameraServer?.name;
    (0, $kYL7Z.useEffect)(()=>{
        if (!organisationId || !locationId) {
            setDevices([]);
            return;
        }
        (0, $5a9cade4af2d6a52$export$e67dc8ea625cc8ef).list({
            withinOrganisations: organisationId,
            include: 'recordings'
        }).then((devs)=>{
            // Exclude the current device if any, and only show devices in the same location
            const currentDeviceId = recording.cameraServer?._id;
            setDevices(devs.filter((d)=>d.id !== currentDeviceId && d.location === locationId));
        }).catch(()=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Failed to load devices'
            });
        });
    }, []);
    const selectedRecs = selected?.recordings ?? [];
    const handleMove = (0, $kYL7Z.useCallback)(()=>{
        if (!selected) return;
        setLoading(true);
        (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).update(recording.id, {
            cameraServer: selected.id
        }).then(()=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `Moved ${recording.name} to ${selected.name}`
            });
            // Fire-and-forget: notify devices to update their config
            if (currentDeviceName) (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', currentDeviceName, null, 'update').catch(()=>{});
            (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', selected.name, null, 'update').catch(()=>{});
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: 'Sent device update commands'
            });
            setSubStep($c07e3ed9bfc135c4$var$MOVE_DONE);
        }).catch((err)=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? 'Failed to move recording'
            });
        }).finally(()=>setLoading(false));
    }, [
        selected,
        recording,
        currentDeviceName
    ]);
    if (devices == null) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $425946125bdc4b8f$export$7f7cbe89f1eacd2), {
        size: 24
    });
    if (!devices.length) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
        minimal: true,
        intent: "warning",
        icon: "warning-sign",
        children: "No devices available in this organisation and location"
    });
    if (subStep === $c07e3ed9bfc135c4$var$MOVE_SELECT) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                        position: "right",
                        content: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                            style: {
                                maxWidth: 220
                            },
                            children: [
                                "The target device must belong to ",
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                    children: organisationName
                                }),
                                " and be in ",
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                    children: locationName
                                }),
                                "."
                            ]
                        }),
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                            icon: "info-sign",
                            style: {
                                marginRight: 6,
                                cursor: 'help'
                            }
                        })
                    }),
                    "Select device for ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: recording.name
                    }),
                    ":"
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db379be4b874c425$export$ef9b1a59e592288f), {
                items: devices,
                itemPredicate: (query, dev)=>dev.name.toLowerCase().includes(query.toLowerCase()),
                itemRenderer: (dev, { handleClick: handleClick, modifiers: modifiers })=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d3dc9af3e7961651$export$2ce376c2cc3355c8), {
                        text: dev.name,
                        label: `${dev.recordings?.length ?? 0} recs`,
                        onClick: handleClick,
                        active: modifiers.active,
                        selected: selected?.id === dev.id
                    }, dev.id),
                onItemSelect: setSelected,
                popoverProps: {
                    minimal: true,
                    matchTargetWidth: true
                },
                fill: true,
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    fill: true,
                    text: selected ? selected.name : 'Select a device...',
                    endIcon: "caret-down",
                    icon: selected ? 'desktop' : undefined
                })
            }),
            selected && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                style: {
                    fontSize: 13,
                    color: '#5c7080'
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: selected.name
                    }),
                    " currently has ",
                    selectedRecs.length,
                    " recording",
                    selectedRecs.length !== 1 ? 's' : ''
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                intent: "primary",
                icon: currentDeviceName ? 'arrow-right' : 'add',
                text: selected ? `${currentDeviceName ? 'Move' : 'Attach'} to ${selected.name}` : currentDeviceName ? 'Move' : 'Attach',
                disabled: !selected,
                onClick: ()=>setSubStep($c07e3ed9bfc135c4$var$MOVE_CONFIRM)
            })
        ]
    });
    if (subStep === $c07e3ed9bfc135c4$var$MOVE_CONFIRM) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: "Step 1:"
                    }),
                    " ",
                    currentDeviceName ? 'Move' : 'Attach',
                    " ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: recording.name
                    }),
                    " to ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: selected.name
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0,
                    fontSize: 13,
                    color: '#5c7080'
                },
                children: [
                    "This will assign ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: recording.name
                    }),
                    " (",
                    recording.id,
                    ") to device ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: selected.name
                    }),
                    ".",
                    currentDeviceName && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
                        children: [
                            " It will be removed from ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                children: currentDeviceName
                            }),
                            "."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                intent: "primary",
                icon: currentDeviceName ? 'arrow-right' : 'add',
                text: loading ? currentDeviceName ? 'Moving...' : 'Attaching...' : `${currentDeviceName ? 'Move' : 'Attach'} to ${selected.name}`,
                disabled: loading,
                onClick: handleMove
            })
        ]
    });
    if (subStep === $c07e3ed9bfc135c4$var$MOVE_DONE) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em',
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: "tick-circle",
                size: 32,
                intent: "success"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: recording.name
                    }),
                    " has been ",
                    currentDeviceName ? 'moved' : 'attached',
                    " to ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: selected.name
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                text: "Done",
                onClick: ()=>window.location.reload()
            })
        ]
    });
    return null;
};
const $c07e3ed9bfc135c4$var$DETACH_CONFIRM = 'confirm';
const $c07e3ed9bfc135c4$var$DETACH_DONE = 'done';
const $c07e3ed9bfc135c4$var$DetachStep = ({ recording: recording })=>{
    const [subStep, setSubStep] = (0, $kYL7Z.useState)($c07e3ed9bfc135c4$var$DETACH_CONFIRM);
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const currentDeviceName = recording.cameraServer?.name;
    const handleDetach = (0, $kYL7Z.useCallback)(()=>{
        setLoading(true);
        (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).update(recording.id, {
            cameraServer: null
        }).then(()=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: `Detached ${recording.name} from ${currentDeviceName}`
            });
            // Fire-and-forget: notify device to update its config
            if (currentDeviceName) {
                (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', currentDeviceName, null, 'update').catch(()=>{});
                (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                    message: 'Sent device update commands'
                });
            }
            setSubStep($c07e3ed9bfc135c4$var$DETACH_DONE);
        }).catch((err)=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: err?.message ?? 'Failed to detach recording'
            });
        }).finally(()=>setLoading(false));
    }, [
        recording,
        currentDeviceName
    ]);
    if (subStep === $c07e3ed9bfc135c4$var$DETACH_CONFIRM) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: "Step 1:"
                    }),
                    " Detach ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: recording.name
                    }),
                    " from ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: currentDeviceName
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0,
                    fontSize: 13,
                    color: '#5c7080'
                },
                children: [
                    "This recording (",
                    recording.id,
                    ") will be set to have no device. You can reassign it later."
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                intent: "warning",
                icon: "remove",
                text: loading ? 'Detaching...' : `Detach from ${currentDeviceName}`,
                disabled: loading,
                onClick: handleDetach
            })
        ]
    });
    if (subStep === $c07e3ed9bfc135c4$var$DETACH_DONE) return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        style: {
            display: 'flex',
            flexDirection: 'column',
            gap: '0.75em',
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b90a50544ad30fb8$export$f04a61298a47a40f), {
                icon: "tick-circle",
                size: 32,
                intent: "success"
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                style: {
                    margin: 0
                },
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: recording.name
                    }),
                    " has been detached from ",
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                        children: currentDeviceName
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                fill: true,
                text: "Done",
                onClick: ()=>window.location.reload()
            })
        ]
    });
    return null;
};
const $c07e3ed9bfc135c4$export$6f49e1476ea8ef16 = ({ recording: recording })=>{
    const [isOpen, setIsOpen] = (0, $kYL7Z.useState)(false);
    const hasDevice = !!recording.cameraServer;
    const [step, setStep] = (0, $kYL7Z.useState)(hasDevice ? $c07e3ed9bfc135c4$var$STEP_CHOICE : $c07e3ed9bfc135c4$var$STEP_MOVE);
    const hasOrgAndLocation = !!recording.organisation?._id && !!recording.location?._id;
    const handleOpen = (0, $kYL7Z.useCallback)(()=>{
        setStep(hasDevice ? $c07e3ed9bfc135c4$var$STEP_CHOICE : $c07e3ed9bfc135c4$var$STEP_MOVE);
        setIsOpen(true);
    }, [
        hasDevice
    ]);
    const handleClose = (0, $kYL7Z.useCallback)(()=>{
        setIsOpen(false);
    }, []);
    const title = !hasDevice ? 'Attach to device' : step === $c07e3ed9bfc135c4$var$STEP_CHOICE ? 'Move or detach recording' : step === $c07e3ed9bfc135c4$var$STEP_MOVE ? 'Move recording' : 'Detach recording';
    const disabledReason = !hasOrgAndLocation ? `This recording must have an organisation and location before it can be ${hasDevice ? 'moved' : 'attached to a device'}.` : null;
    const button = /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
        fill: true,
        text: hasDevice ? `Move or detach from ${recording.cameraServer.name}` : 'Attach to a device',
        intent: "danger",
        icon: hasDevice ? 'remove' : 'add',
        onClick: handleOpen,
        disabled: !!disabledReason
    });
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            disabledReason ? /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                fill: true,
                content: disabledReason,
                position: "top",
                children: button
            }) : button,
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $1f28229800ba03f9$export$3ddf2d174ce01153), {
                isOpen: isOpen,
                onClose: handleClose,
                title: title,
                icon: !hasDevice ? 'add' : step === $c07e3ed9bfc135c4$var$STEP_MOVE ? 'arrow-right' : 'remove',
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $4c25c4a737f23a8e$export$5d20f2c38fcde41f), {
                    children: [
                        step === $c07e3ed9bfc135c4$var$STEP_CHOICE && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.75em'
                            },
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("p", {
                                    style: {
                                        margin: 0
                                    },
                                    children: [
                                        "Move this recording to another device, or detach from ",
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("strong", {
                                            children: recording.cameraServer.name
                                        }),
                                        "?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
                                    style: {
                                        display: 'flex',
                                        gap: '0.75em'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            fill: true,
                                            icon: "arrow-right",
                                            text: "Move",
                                            intent: "primary",
                                            onClick: ()=>setStep($c07e3ed9bfc135c4$var$STEP_MOVE)
                                        }),
                                        /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            fill: true,
                                            icon: "remove",
                                            text: "Detach",
                                            intent: "danger",
                                            onClick: ()=>setStep($c07e3ed9bfc135c4$var$STEP_DETACH)
                                        })
                                    ]
                                })
                            ]
                        }),
                        step === $c07e3ed9bfc135c4$var$STEP_MOVE && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c07e3ed9bfc135c4$var$MoveStep, {
                            recording: recording,
                            onClose: handleClose
                        }),
                        step === $c07e3ed9bfc135c4$var$STEP_DETACH && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($c07e3ed9bfc135c4$var$DetachStep, {
                            recording: recording
                        })
                    ]
                })
            })
        ]
    });
};


const $d9722d5f78fedffd$var$PageWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5em;
`;
// ----------------------------------------------------- canvas css
// --------- i.e. canvas, standard shapes, changes unsaved and undo
const $d9722d5f78fedffd$var$initialCanvasContainerSize = [
    (0, $c7a73239b47a74cf$export$d07517a676ce386f).PHONE_SIZE,
    (0, $c7a73239b47a74cf$export$d07517a676ce386f).TABLET_SIZE
].includes((0, $c7a73239b47a74cf$export$f72d8951b36b047e)()) ? "100%" : "50%";
const $d9722d5f78fedffd$var$CanvasContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: inline-block;
    width: ${$d9722d5f78fedffd$var$initialCanvasContainerSize};
    min-width: 360px;
    max-width: 1080px;
    border: solid 1px black;
    resize: horizontal;
    overflow: hidden;
`;
const $d9722d5f78fedffd$var$BelowCanvasRow = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 1em;
`;
const $d9722d5f78fedffd$var$SaveUndoBlock = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 1em;
    align-items: center;
`;
// ----------------------------------------------------- menu css
const $d9722d5f78fedffd$var$MenuContainer = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: inline-block;
    min-width: 360px;
    max-width: 1080px;
    flex-grow: 1;
`;
function $d9722d5f78fedffd$export$89f25e5029831c70({ currentActiveMenuSection: currentActiveMenuSection, loadingTaxonomies: loadingTaxonomies, keysAndValuesInUse: keysAndValuesInUse, taxonomiesInUse: taxonomiesInUse }) {
    const ctx = (0, $kYL7Z.useContext)((0, $a85201d171878a8f$export$7879fcf4b5cbbcfa));
    const hasThumbnail = !!ctx.recording?.thumbnails?.[0]?.url;
    const [history, setHistory] = (0, $kYL7Z.useState)([]);
    const [compact, setCompact] = (0, $kYL7Z.useState)(false);
    const canvasContainerRef = (0, $kYL7Z.useRef)(null);
    (0, $kYL7Z.useEffect)(()=>{
        const el = canvasContainerRef.current;
        if (!el) return;
        const observer = new ResizeObserver((entries)=>{
            const width = entries[0]?.contentRect?.width ?? 0;
            setCompact(width < 600);
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    // Refs so keyboard handler always sees current values
    const historyRef = (0, $kYL7Z.useRef)(history);
    const ctxRef = (0, $kYL7Z.useRef)(ctx);
    historyRef.current = history;
    ctxRef.current = ctx;
    const handleSaveChanges = (0, $kYL7Z.useCallback)(()=>{
        const { recording: recording, elems: elems } = ctxRef.current;
        return (0, $5a9cade4af2d6a52$export$557cacc73549007c).create(recording.id, elems.toApi()).then((response)=>{
            (0, $cc4fa4b6613dc4ad$export$73e19c0339806233)({
                message: 'All changes were successfully done!'
            });
            setHistory([]);
            const deviceName = recording.cameraServer?.name;
            if (deviceName) {
                (0, $cc4fa4b6613dc4ad$export$4cc0fb945c4ba96e)({
                    message: `Updating handled recids on ${deviceName}...`
                });
                (0, $0db64f2ac749186b$export$91cea577896d70d9).command('UpdateHandledRecids', deviceName, null, 'update').catch(()=>{});
            }
            return Promise.resolve(response);
        }).catch((error)=>{
            (0, $cc4fa4b6613dc4ad$export$6badb0ecde4e0bd0)({
                message: 'Failed to save changes'
            });
            return Promise.reject(error);
        });
    }, []);
    const beforeChange = (0, $kYL7Z.useCallback)(()=>{
        const { elems: elems } = ctxRef.current;
        if (!elems.changing) {
            elems.changing = true;
            setHistory((prev)=>[
                    ...prev,
                    JSON.stringify(elems.toApi())
                ]);
        }
    }, []);
    const afterChange = (0, $kYL7Z.useCallback)(()=>{
        const { elems: elems, setElems: setElems } = ctxRef.current;
        elems.changing = false;
        // New reference triggers React re-render → canvas auto-redraws
        setElems(new (0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3)(elems.scale, elems.elems));
    }, []);
    const undo = (0, $kYL7Z.useCallback)(()=>{
        const h = historyRef.current;
        if (h.length) {
            const newHistory = [
                ...h
            ];
            const last = newHistory.pop();
            const { elems: elems, setElems: setElems } = ctxRef.current;
            setElems((0, $7b598b71dfcbcd89$export$f7f7139cdc56cfb3).fromApi(elems.scale, JSON.parse(last)));
            setHistory(newHistory);
        }
    }, []);
    // Keyboard handler
    (0, $kYL7Z.useEffect)(()=>{
        const keyboard = (event)=>{
            const { elems: elems, selected: selected, setSelected: setSelected } = ctxRef.current;
            if (event.ctrlKey === true) switch(event.key){
                case 'z':
                    event.stopPropagation();
                    event.preventDefault();
                    undo();
                    break;
                case 'l':
                    event.stopPropagation();
                    event.preventDefault();
                    if (elems) {
                        let names = elems.curves.map((a)=>a.name);
                        let name_idx = 0;
                        while(names.includes(`line-${name_idx}`))name_idx += 1;
                        beforeChange();
                        elems.addDefault('lines', `line-${name_idx}`);
                        afterChange();
                    }
                    break;
                case 'a':
                    event.stopPropagation();
                    event.preventDefault();
                    if (elems) {
                        let names = elems.areas.map((a)=>a.name);
                        let name_idx = 0;
                        while(names.includes(`area-${name_idx}`))name_idx += 1;
                        beforeChange();
                        elems.addDefault('areas', `area-${name_idx}`);
                        afterChange();
                    }
                    break;
                case 's':
                    event.stopPropagation();
                    event.preventDefault();
                    handleSaveChanges().then();
                    break;
                default:
            }
            else if (event.key === 'Escape') {
                const { canvasMode: canvasMode, setCanvasMode: setCanvasMode } = ctxRef.current;
                if (canvasMode) {
                    event.stopPropagation();
                    event.preventDefault();
                    setCanvasMode(null);
                }
            } else if (event.key === 'p' && selected && Object.getPrototypeOf(selected) === (0, $7b598b71dfcbcd89$export$ea1a111407f37557).prototype) {
                event.stopPropagation();
                event.preventDefault();
                ctxRef.current.setCanvasMode({
                    type: 'add-point',
                    area: selected
                });
            } else if (event.key === 'd' && selected && Object.getPrototypeOf(selected) === (0, $7b598b71dfcbcd89$export$ea1a111407f37557).prototype && selected.poly.length > 3) {
                event.stopPropagation();
                event.preventDefault();
                ctxRef.current.setCanvasMode({
                    type: 'remove-point',
                    area: selected
                });
            } else if (event.key === 'Delete' && selected) {
                event.stopPropagation();
                event.preventDefault();
                beforeChange();
                elems.remove(selected);
                setSelected(null);
                afterChange();
            }
        };
        document.addEventListener('keydown', keyboard);
        return ()=>document.removeEventListener('keydown', keyboard);
    }, [
        undo,
        beforeChange,
        afterChange,
        handleSaveChanges
    ]);
    const handleElemsAction = (0, $kYL7Z.useCallback)((action)=>{
        if (action.action === "save-changes") handleSaveChanges().then(()=>{
            console.log("Saved changes");
        });
    }, [
        handleSaveChanges
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($d9722d5f78fedffd$var$PageWrapper, {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($d9722d5f78fedffd$var$CanvasContainer, {
                ref: canvasContainerRef,
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $a85201d171878a8f$export$9134750ec17e93b1), {
                        editable: hasThumbnail,
                        onBeforeChange: beforeChange,
                        onAfterChange: afterChange
                    }),
                    hasThumbnail && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($d9722d5f78fedffd$var$BelowCanvasRow, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $38b737c6f60acefa$export$79b1f807a5e0f878), {
                                compact: compact,
                                handleSaveChanges: handleSaveChanges
                            }),
                            !!history.length && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($d9722d5f78fedffd$var$SaveUndoBlock, {
                                children: [
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                        intent: "warning",
                                        onClick: handleSaveChanges,
                                        text: compact ? undefined : "Save Changes",
                                        icon: "floppy-disk"
                                    }),
                                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $19351b9bacb9d9ea$export$28c660c63b792dea), {
                                        position: (0, $066a1d9f6e8ad6f2$export$13807d9ee5a34a42).TOP_RIGHT,
                                        content: 'CTRL+Z',
                                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                            onClick: undo,
                                            icon: "undo",
                                            text: compact ? undefined : "Undo"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($d9722d5f78fedffd$var$MenuContainer, {
                children: [
                    hasThumbnail && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0199c8413a0068dd$export$60332b2344f7fe41), {
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9e9b6d08ce7b7c61$export$b40aeba347da4106), {
                            currentActiveMenuSection: currentActiveMenuSection,
                            loadingTaxonomies: loadingTaxonomies,
                            taxonomiesInUse: taxonomiesInUse,
                            keysAndValuesInUse: keysAndValuesInUse,
                            beforeChange: beforeChange,
                            afterChange: afterChange,
                            onElemsAction: handleElemsAction
                        })
                    }),
                    ctx.recording && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $a52c0cc0b7d14ece$export$60332b2344f7fe41), {
                        title: "Welcome to the Danger Zone",
                        intent: "danger",
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c07e3ed9bfc135c4$export$6f49e1476ea8ef16), {
                            recording: ctx.recording
                        })
                    })
                ]
            })
        ]
    });
}


const $97e3f09806ce1d80$export$8188809efe9a5f5d = ({ recid: recid, search: search })=>{
    const { setLoading: setLoading, setNav: setNav, setControls: setControls } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [editing, setEditing] = (0, $kYL7Z.useState)(false);
    const [taxonomiesInUse, setTaxonomiesInUse] = (0, $kYL7Z.useState)(null);
    const [keysAndValuesInUse, setKeysAndValuesInUse] = (0, $kYL7Z.useState)(null);
    const [loadingTaxonomies, setLoadingTaxonomies] = (0, $kYL7Z.useState)(false);
    // ElemsContext state — this component is the Provider
    const [recording, setRecording] = (0, $kYL7Z.useState)(null);
    const [elems, setElems] = (0, $kYL7Z.useState)(null);
    const [selected, _setSelected] = (0, $kYL7Z.useState)(null);
    const [canvasMode, setCanvasMode] = (0, $kYL7Z.useState)(null);
    const [hovered, setHovered] = (0, $kYL7Z.useState)(null);
    const fetchRecording = (0, $kYL7Z.useCallback)((id)=>{
        console.log(`Fetching recording: ${id}`);
        setRecording(null);
        setElems(null);
        _setSelected(null);
        return (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).get(id, {
            include: 'organisationDetails,locationDetails,cameraServerDetails,statElems,singleThumbnail,lineContexts,areaContexts'
        }).then((rec)=>{
            setRecording(rec);
            return rec;
        });
    }, []);
    const clearRecording = (0, $kYL7Z.useCallback)(()=>{
        setRecording(null);
        setElems(null);
        _setSelected(null);
    }, []);
    const setSelected = (0, $kYL7Z.useCallback)((selection)=>{
        _setSelected((prev)=>{
            if (prev) prev.highlight = (0, $7b598b71dfcbcd89$export$39dbc3f558091353).NONE;
            if (selection) [selection.highlight, selection.visible] = [
                (0, $7b598b71dfcbcd89$export$39dbc3f558091353).GREEN,
                true
            ];
            return selection;
        });
    }, []);
    // editing toggle — update controls
    const hasThumbnail = !!recording?.thumbnails?.[0]?.url;
    (0, $kYL7Z.useEffect)(()=>{
        if (!hasThumbnail) {
            setControls([]);
            return ()=>setControls([]);
        }
        setControls([
            {
                name: editing ? "Save" : "Edit",
                onClick: ()=>setEditing((prev)=>!prev),
                icon: editing ? "floppy-disk" : "edit",
                confirm: editing
            }
        ]);
        return ()=>setControls([]);
    }, [
        editing,
        hasThumbnail
    ]);
    // load recording data on mount
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Loading recid: " + recid);
        setLoading({
            status: true,
            location: "Loading camera: " + recid
        });
        fetchRecording(recid).then((rec)=>{
            if (!rec) throw "Recid not found!";
            setLoading({
                status: false,
                location: rec.name + " (" + rec.id + ")"
            });
            setNav({
                left: [
                    ...rec.organisation?.name ? [
                        {
                            name: rec.organisation.name,
                            path: "/orgs/" + rec.organisation._id,
                            icon: "office",
                            subpaths: [
                                {
                                    name: "Locations",
                                    icon: "area-of-interest",
                                    path: '/locs?org=' + rec.organisation._id
                                },
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?org=' + rec.organisation._id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?org=' + rec.organisation._id
                                },
                                {
                                    name: "Users",
                                    icon: "people",
                                    path: '/orgs/' + rec.organisation._id + '/users'
                                }
                            ]
                        }
                    ] : [],
                    ...rec.location?.name ? [
                        {
                            name: rec.location.name,
                            path: "/locs/" + rec.location._id,
                            icon: "area-of-interest",
                            subpaths: [
                                {
                                    name: "Devices",
                                    icon: "desktop",
                                    path: '/devs?loc=' + rec.location._id
                                },
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?loc=' + rec.location._id
                                }
                            ]
                        }
                    ] : [],
                    ...rec.cameraServer?.name ? [
                        {
                            name: rec.cameraServer.name,
                            path: "/devs/" + rec.cameraServer._id,
                            icon: "desktop",
                            subpaths: [
                                {
                                    name: "Cameras",
                                    icon: "camera",
                                    path: '/recs?dev=' + rec.cameraServer._id
                                }
                            ]
                        }
                    ] : []
                ]
            });
        }).catch((error)=>{
            console.log(error);
            setLoading({
                status: false,
                location: "Failed to load camera..."
            });
        });
        return ()=>clearRecording();
    }, []);
    // load extra resources (taxonomies, keys and values) when recording changes
    (0, $kYL7Z.useEffect)(()=>{
        if (recording?.organisation) {
            setLoading({
                status: false,
                location: recording.name + " (" + recording.id + ")" + " ... loading extra resources"
            });
            console.log("Loading extra resources...");
            setLoadingTaxonomies(true);
            (0, $5a9cade4af2d6a52$export$93b258f6fd606e97).list({
                include: 'areaContexts,lineContexts',
                withinOrganisations: recording.organisation._id
            }).then((siblings)=>{
                const allAreaContexts = (0, $i5w0I.flatten)(siblings.map((r)=>r.areaContexts)).filter((ac)=>!!ac);
                const allLineContexts = (0, $i5w0I.flatten)(siblings.map((r)=>r.lineContexts)).filter((ac)=>!!ac);
                setTaxonomiesInUse((0, $i5w0I.uniq)(allAreaContexts.map((ac)=>ac.taxonomy)));
                setKeysAndValuesInUse(allLineContexts.filter((lineContext)=>lineContext.type === 'within-location-entry' || lineContext.type === 'within-location-pass-by').reduce((finalKeysAndValues, lineContext)=>{
                    lineContext.metadata.forEach(({ key: key, value: value })=>{
                        finalKeysAndValues.keys = (0, $i5w0I.uniq)([
                            ...finalKeysAndValues.keys,
                            key
                        ]);
                        finalKeysAndValues.values = (0, $i5w0I.uniq)([
                            ...finalKeysAndValues.values,
                            value
                        ]);
                    });
                    return finalKeysAndValues;
                }, {
                    keys: [],
                    values: []
                }));
                setLoading({
                    status: false,
                    location: recording.name + " (" + recording.id + ")"
                });
                console.log("Loaded extra resources...");
            }).catch((error)=>{
                console.log(error);
                setLoading({
                    status: false,
                    location: recording.name + " (" + recording.id + ")" + " ... failed to load extra resources"
                });
            }).finally(()=>{
                setLoadingTaxonomies(false);
            });
        }
    }, [
        recording
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $a85201d171878a8f$export$7879fcf4b5cbbcfa).Provider, {
        value: {
            recording: recording,
            elems: elems,
            selected: selected,
            canvasMode: canvasMode,
            hovered: hovered,
            fetch: fetchRecording,
            clear: clearRecording,
            setElems: setElems,
            setSelected: setSelected,
            setCanvasMode: setCanvasMode,
            setHovered: setHovered
        },
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $d9722d5f78fedffd$export$89f25e5029831c70), {
            currentActiveMenuSection: search.get('currentActiveMenuSection'),
            taxonomiesInUse: taxonomiesInUse,
            keysAndValuesInUse: keysAndValuesInUse,
            loadingTaxonomies: loadingTaxonomies
        })
    });
};


const $b5ee80c3f7d9f5ea$var$ManyRecsRoute = ()=>{
    const location = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $edb9b4ceb2689910$export$1aeb4f122d3d1936), {
        search: new URLSearchParams(location.search)
    });
};
const $b5ee80c3f7d9f5ea$var$OneRecRoute = ()=>{
    const { resid: resid } = (0, $3c99a37f3fed1403$export$99eaa27ddbbb95ef)();
    const location = (0, $3c99a37f3fed1403$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $97e3f09806ce1d80$export$8188809efe9a5f5d), {
        recid: resid,
        search: new URLSearchParams(location.search)
    });
};
const $b5ee80c3f7d9f5ea$export$24eb32919a2c61dc = ()=>{
    (0, $kYL7Z.useEffect)(()=>{
        console.log("Recs page");
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $3c99a37f3fed1403$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b5ee80c3f7d9f5ea$var$ManyRecsRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/:resid",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($b5ee80c3f7d9f5ea$var$OneRecRoute, {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $92e6067166fae914$export$3cb69218ff952ef8), {})
            })
        ]
    });
};



parcelRequire("kYL7Z");




var $kYL7Z = parcelRequire("kYL7Z");







var $kYL7Z = parcelRequire("kYL7Z");


var $a2058b1c2cc8e90b$exports = {};
var $6186812f8d02739d$exports = {};

var $dFjst = parcelRequire("dFjst");
var $8263409ee52f7ea9$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $8263409ee52f7ea9$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to stand-in for `undefined` hash values. */ var $8263409ee52f7ea9$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used as references for various `Number` constants. */ var $8263409ee52f7ea9$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $8263409ee52f7ea9$var$funcTag = '[object Function]', $8263409ee52f7ea9$var$genTag = '[object GeneratorFunction]', $8263409ee52f7ea9$var$symbolTag = '[object Symbol]';
/** Used to match property names within property paths. */ var $8263409ee52f7ea9$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $8263409ee52f7ea9$var$reIsPlainProp = /^\w*$/, $8263409ee52f7ea9$var$reLeadingDot = /^\./, $8263409ee52f7ea9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8263409ee52f7ea9$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var $8263409ee52f7ea9$var$reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var $8263409ee52f7ea9$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var $8263409ee52f7ea9$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $8263409ee52f7ea9$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $8263409ee52f7ea9$var$root = $8263409ee52f7ea9$var$freeGlobal || $8263409ee52f7ea9$var$freeSelf || Function('return this')();
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8263409ee52f7ea9$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $8263409ee52f7ea9$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/** Used for built-in method references. */ var $8263409ee52f7ea9$var$arrayProto = Array.prototype, $8263409ee52f7ea9$var$funcProto = Function.prototype, $8263409ee52f7ea9$var$objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var $8263409ee52f7ea9$var$coreJsData = $8263409ee52f7ea9$var$root['__core-js_shared__'];
/** Used to detect methods masquerading as native. */ var $8263409ee52f7ea9$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($8263409ee52f7ea9$var$coreJsData && $8263409ee52f7ea9$var$coreJsData.keys && $8263409ee52f7ea9$var$coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/** Used to resolve the decompiled source of functions. */ var $8263409ee52f7ea9$var$funcToString = $8263409ee52f7ea9$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8263409ee52f7ea9$var$hasOwnProperty = $8263409ee52f7ea9$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $8263409ee52f7ea9$var$objectToString = $8263409ee52f7ea9$var$objectProto.toString;
/** Used to detect if a method is native. */ var $8263409ee52f7ea9$var$reIsNative = RegExp('^' + $8263409ee52f7ea9$var$funcToString.call($8263409ee52f7ea9$var$hasOwnProperty).replace($8263409ee52f7ea9$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/** Built-in value references. */ var $8263409ee52f7ea9$var$Symbol = $8263409ee52f7ea9$var$root.Symbol, $8263409ee52f7ea9$var$splice = $8263409ee52f7ea9$var$arrayProto.splice;
/* Built-in method references that are verified to be native. */ var $8263409ee52f7ea9$var$Map = $8263409ee52f7ea9$var$getNative($8263409ee52f7ea9$var$root, 'Map'), $8263409ee52f7ea9$var$nativeCreate = $8263409ee52f7ea9$var$getNative(Object, 'create');
/** Used to convert symbols to primitives and strings. */ var $8263409ee52f7ea9$var$symbolProto = $8263409ee52f7ea9$var$Symbol ? $8263409ee52f7ea9$var$Symbol.prototype : undefined, $8263409ee52f7ea9$var$symbolToString = $8263409ee52f7ea9$var$symbolProto ? $8263409ee52f7ea9$var$symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8263409ee52f7ea9$var$Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $8263409ee52f7ea9$var$hashClear() {
    this.__data__ = $8263409ee52f7ea9$var$nativeCreate ? $8263409ee52f7ea9$var$nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8263409ee52f7ea9$var$hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8263409ee52f7ea9$var$hashGet(key) {
    var data = this.__data__;
    if ($8263409ee52f7ea9$var$nativeCreate) {
        var result = data[key];
        return result === $8263409ee52f7ea9$var$HASH_UNDEFINED ? undefined : result;
    }
    return $8263409ee52f7ea9$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8263409ee52f7ea9$var$hashHas(key) {
    var data = this.__data__;
    return $8263409ee52f7ea9$var$nativeCreate ? data[key] !== undefined : $8263409ee52f7ea9$var$hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $8263409ee52f7ea9$var$hashSet(key, value) {
    var data = this.__data__;
    data[key] = $8263409ee52f7ea9$var$nativeCreate && value === undefined ? $8263409ee52f7ea9$var$HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
$8263409ee52f7ea9$var$Hash.prototype.clear = $8263409ee52f7ea9$var$hashClear;
$8263409ee52f7ea9$var$Hash.prototype['delete'] = $8263409ee52f7ea9$var$hashDelete;
$8263409ee52f7ea9$var$Hash.prototype.get = $8263409ee52f7ea9$var$hashGet;
$8263409ee52f7ea9$var$Hash.prototype.has = $8263409ee52f7ea9$var$hashHas;
$8263409ee52f7ea9$var$Hash.prototype.set = $8263409ee52f7ea9$var$hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8263409ee52f7ea9$var$ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $8263409ee52f7ea9$var$listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8263409ee52f7ea9$var$listCacheDelete(key) {
    var data = this.__data__, index = $8263409ee52f7ea9$var$assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8263409ee52f7ea9$var$splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8263409ee52f7ea9$var$listCacheGet(key) {
    var data = this.__data__, index = $8263409ee52f7ea9$var$assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8263409ee52f7ea9$var$listCacheHas(key) {
    return $8263409ee52f7ea9$var$assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $8263409ee52f7ea9$var$listCacheSet(key, value) {
    var data = this.__data__, index = $8263409ee52f7ea9$var$assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
$8263409ee52f7ea9$var$ListCache.prototype.clear = $8263409ee52f7ea9$var$listCacheClear;
$8263409ee52f7ea9$var$ListCache.prototype['delete'] = $8263409ee52f7ea9$var$listCacheDelete;
$8263409ee52f7ea9$var$ListCache.prototype.get = $8263409ee52f7ea9$var$listCacheGet;
$8263409ee52f7ea9$var$ListCache.prototype.has = $8263409ee52f7ea9$var$listCacheHas;
$8263409ee52f7ea9$var$ListCache.prototype.set = $8263409ee52f7ea9$var$listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8263409ee52f7ea9$var$MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8263409ee52f7ea9$var$mapCacheClear() {
    this.__data__ = {
        'hash': new $8263409ee52f7ea9$var$Hash,
        'map': new ($8263409ee52f7ea9$var$Map || $8263409ee52f7ea9$var$ListCache),
        'string': new $8263409ee52f7ea9$var$Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8263409ee52f7ea9$var$mapCacheDelete(key) {
    return $8263409ee52f7ea9$var$getMapData(this, key)['delete'](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $8263409ee52f7ea9$var$mapCacheGet(key) {
    return $8263409ee52f7ea9$var$getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8263409ee52f7ea9$var$mapCacheHas(key) {
    return $8263409ee52f7ea9$var$getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $8263409ee52f7ea9$var$mapCacheSet(key, value) {
    $8263409ee52f7ea9$var$getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
$8263409ee52f7ea9$var$MapCache.prototype.clear = $8263409ee52f7ea9$var$mapCacheClear;
$8263409ee52f7ea9$var$MapCache.prototype['delete'] = $8263409ee52f7ea9$var$mapCacheDelete;
$8263409ee52f7ea9$var$MapCache.prototype.get = $8263409ee52f7ea9$var$mapCacheGet;
$8263409ee52f7ea9$var$MapCache.prototype.has = $8263409ee52f7ea9$var$mapCacheHas;
$8263409ee52f7ea9$var$MapCache.prototype.set = $8263409ee52f7ea9$var$mapCacheSet;
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $8263409ee52f7ea9$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($8263409ee52f7ea9$var$eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $8263409ee52f7ea9$var$baseGet(object, path) {
    path = $8263409ee52f7ea9$var$isKey(path, object) ? [
        path
    ] : $8263409ee52f7ea9$var$castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$8263409ee52f7ea9$var$toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8263409ee52f7ea9$var$baseIsNative(value) {
    if (!$8263409ee52f7ea9$var$isObject(value) || $8263409ee52f7ea9$var$isMasked(value)) return false;
    var pattern = $8263409ee52f7ea9$var$isFunction(value) || $8263409ee52f7ea9$var$isHostObject(value) ? $8263409ee52f7ea9$var$reIsNative : $8263409ee52f7ea9$var$reIsHostCtor;
    return pattern.test($8263409ee52f7ea9$var$toSource(value));
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $8263409ee52f7ea9$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($8263409ee52f7ea9$var$isSymbol(value)) return $8263409ee52f7ea9$var$symbolToString ? $8263409ee52f7ea9$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$8263409ee52f7ea9$var$INFINITY ? '-0' : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function $8263409ee52f7ea9$var$castPath(value) {
    return $8263409ee52f7ea9$var$isArray(value) ? value : $8263409ee52f7ea9$var$stringToPath(value);
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $8263409ee52f7ea9$var$getMapData(map, key) {
    var data = map.__data__;
    return $8263409ee52f7ea9$var$isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $8263409ee52f7ea9$var$getNative(object, key) {
    var value = $8263409ee52f7ea9$var$getValue(object, key);
    return $8263409ee52f7ea9$var$baseIsNative(value) ? value : undefined;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $8263409ee52f7ea9$var$isKey(value, object) {
    if ($8263409ee52f7ea9$var$isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || $8263409ee52f7ea9$var$isSymbol(value)) return true;
    return $8263409ee52f7ea9$var$reIsPlainProp.test(value) || !$8263409ee52f7ea9$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $8263409ee52f7ea9$var$isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $8263409ee52f7ea9$var$isMasked(func) {
    return !!$8263409ee52f7ea9$var$maskSrcKey && $8263409ee52f7ea9$var$maskSrcKey in func;
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $8263409ee52f7ea9$var$stringToPath = $8263409ee52f7ea9$var$memoize(function(string) {
    string = $8263409ee52f7ea9$var$toString(string);
    var result = [];
    if ($8263409ee52f7ea9$var$reLeadingDot.test(string)) result.push('');
    string.replace($8263409ee52f7ea9$var$rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace($8263409ee52f7ea9$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $8263409ee52f7ea9$var$toKey(value) {
    if (typeof value == 'string' || $8263409ee52f7ea9$var$isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$8263409ee52f7ea9$var$INFINITY ? '-0' : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function $8263409ee52f7ea9$var$toSource(func) {
    if (func != null) {
        try {
            return $8263409ee52f7ea9$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $8263409ee52f7ea9$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver && typeof resolver != 'function') throw new TypeError($8263409ee52f7ea9$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new ($8263409ee52f7ea9$var$memoize.Cache || $8263409ee52f7ea9$var$MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
$8263409ee52f7ea9$var$memoize.Cache = $8263409ee52f7ea9$var$MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $8263409ee52f7ea9$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $8263409ee52f7ea9$var$isArray = Array.isArray;
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $8263409ee52f7ea9$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $8263409ee52f7ea9$var$isObject(value) ? $8263409ee52f7ea9$var$objectToString.call(value) : '';
    return tag == $8263409ee52f7ea9$var$funcTag || tag == $8263409ee52f7ea9$var$genTag;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $8263409ee52f7ea9$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $8263409ee52f7ea9$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $8263409ee52f7ea9$var$isSymbol(value) {
    return typeof value == 'symbol' || $8263409ee52f7ea9$var$isObjectLike(value) && $8263409ee52f7ea9$var$objectToString.call(value) == $8263409ee52f7ea9$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $8263409ee52f7ea9$var$toString(value) {
    return value == null ? '' : $8263409ee52f7ea9$var$baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $8263409ee52f7ea9$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $8263409ee52f7ea9$var$baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
$8263409ee52f7ea9$exports = $8263409ee52f7ea9$var$get;


var $d586a33e9a49e852$exports = {};






$d586a33e9a49e852$exports = {
    decode: (parcelRequire("4kgx4")),
    verify: (parcelRequire("HjT2s")),
    sign: (parcelRequire("bHGuR")),
    JsonWebTokenError: (parcelRequire("iegT3")),
    NotBeforeError: (parcelRequire("6Ogh4")),
    TokenExpiredError: (parcelRequire("j0d2F"))
};


var $eade7261f38fbf30$export$1592a73131c4467e;
$eade7261f38fbf30$export$1592a73131c4467e = class extends Error {
    constructor(message, childError){
        super(message);
        this.name = 'NotAuthorisedError';
        this.childError = childError;
    }
};


var $6186812f8d02739d$require$NotAuthorisedError = $eade7261f38fbf30$export$1592a73131c4467e;
var $27f317b75c2d0303$export$d1dd8b648639123d;
$27f317b75c2d0303$export$d1dd8b648639123d = class extends Error {
    constructor(message, childError){
        super(message);
        this.name = 'GenericAuthError';
        this.childError = childError;
    }
};


var $6186812f8d02739d$require$GenericAuthError = $27f317b75c2d0303$export$d1dd8b648639123d;
var $f0c9e003502750b6$exports = {};



var $f0c9e003502750b6$require$GenericAuthError = $27f317b75c2d0303$export$d1dd8b648639123d;

var $f0c9e003502750b6$require$NotAuthorisedError = $eade7261f38fbf30$export$1592a73131c4467e;
var $feda5fba568f1d4e$exports = {};
var $42dc19071556195f$exports = {};
var $95e1c88abef1e72f$exports = {};
var $f93fb987377bc1c3$exports = {};
var $bdefb8fe14c48320$export$48f79886221f037c;
$bdefb8fe14c48320$export$48f79886221f037c = class extends Error {
    constructor(message, childError){
        super(message);
        this.name = 'CoreApiException';
        this.childError = childError;
    }
};


var $f93fb987377bc1c3$require$CoreApiException = $bdefb8fe14c48320$export$48f79886221f037c;
var $d35594ab11ace490$exports = {};
var $5bebba5685c75139$exports = {};
var $ed149b675c0b0120$exports = {};

$ed149b675c0b0120$exports = (parcelRequire("gpBw0"));


var $348b778d9fe7dd50$exports = {};




(function() {
    var crypt = (parcelRequire("6yTTp")), utf8 = (parcelRequire("6qat2")).utf8, isBuffer = (parcelRequire("cPjZS")), bin = (parcelRequire("6qat2")).bin, // The core
    md5 = function(message, options) {
        // Convert to byte array
        if (message.constructor == String) {
            if (options && options.encoding === 'binary') message = bin.stringToBytes(message);
            else message = utf8.stringToBytes(message);
        } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);
        else if (!Array.isArray(message) && message.constructor !== Uint8Array) message = message.toString();
        // else, assume byte array already
        var m = crypt.bytesToWords(message), l = message.length * 8, a = 1732584193, b = -271733879, c = -1732584194, d = 271733878;
        // Swap endian
        for(var i = 0; i < m.length; i++)m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
        // Padding
        m[l >>> 5] |= 0x80 << l % 32;
        m[(l + 64 >>> 9 << 4) + 14] = l;
        // Method shortcuts
        var FF = md5._ff, GG = md5._gg, HH = md5._hh, II = md5._ii;
        for(var i = 0; i < m.length; i += 16){
            var aa = a, bb = b, cc = c, dd = d;
            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
            c = FF(c, d, a, b, m[i + 10], 17, -42063);
            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
            a = HH(a, b, c, d, m[i + 5], 4, -378558);
            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
            a = II(a, b, c, d, m[i + 0], 6, -198630844);
            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
            b = II(b, c, d, a, m[i + 5], 21, -57434055);
            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
            c = II(c, d, a, b, m[i + 10], 15, -1051523);
            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
            d = II(d, a, b, c, m[i + 15], 10, -30611744);
            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
            a = II(a, b, c, d, m[i + 4], 6, -145523070);
            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
            c = II(c, d, a, b, m[i + 2], 15, 718787259);
            b = II(b, c, d, a, m[i + 9], 21, -343485551);
            a = a + aa >>> 0;
            b = b + bb >>> 0;
            c = c + cc >>> 0;
            d = d + dd >>> 0;
        }
        return crypt.endian([
            a,
            b,
            c,
            d
        ]);
    };
    // Auxiliary functions
    md5._ff = function(a, b, c, d, x, s, t) {
        var n = a + (b & c | ~b & d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._gg = function(a, b, c, d, x, s, t) {
        var n = a + (b & d | c & ~d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._hh = function(a, b, c, d, x, s, t) {
        var n = a + (b ^ c ^ d) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    md5._ii = function(a, b, c, d, x, s, t) {
        var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
        return (n << s | n >>> 32 - s) + b;
    };
    // Package private blocksize
    md5._blocksize = 16;
    md5._digestsize = 16;
    $348b778d9fe7dd50$exports = function(message, options) {
        if (message === undefined || message === null) throw new Error('Illegal argument ' + message);
        var digestbytes = crypt.wordsToBytes(md5(message, options));
        return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
    };
})();


var $fe738c69634e2f33$export$2535487a8197cb2c;
$fe738c69634e2f33$export$2535487a8197cb2c = class extends Error {
    constructor(message, request, response, httpClientRequest, childError){
        super(message);
        this.name = 'HttpClientException';
        this.request = request;
        this.response = response;
        this.httpClientRequest = httpClientRequest;
        this.childError = childError;
    }
};


var $5bebba5685c75139$require$HttpClientException = $fe738c69634e2f33$export$2535487a8197cb2c;
class $5bebba5685c75139$var$AxiosHttpClient {
    /**
   * Perform http requests via Axios
   * Can use local caching (shouldCache = true)
   * Will return a simple object
   * {statusCode, payload, header}
   * on 2xx or HttpClientException
   * otherwise
   *
   * logger should be a function that
   * takes an object {message, contextObject}
   * and logs it as 'info' e.g. .info at
   * aura-emailer.git/src/services/logger/index.js
   *
   * @param logger
   * @param method
   * @param headers
   * @param url
   * @param cacheFacade
   * @param cacheTtl
   * @param payload
   * @param shouldCache
   * @param cacheErrorCodes
   * @param timeout
   * @throws {HttpClientException}
   * @returns {Promise<object>}
   */ static async makeRequest({ logger: logger, method: method, headers: headers, url: url, cacheFacade: cacheFacade = null, cacheTtl: cacheTtl = 900, payload: payload = null, shouldCache: shouldCache = false, cacheErrorCodes: cacheErrorCodes = [
        404
    ], timeout: timeout = 20000 }) {
        // We'll explicitly build a request object as we
        // will use it in the exception
        const request = {
            method: method,
            url: url,
            headers: headers,
            timeout: timeout
        };
        // We'll only add a data property if there is a payload
        if (payload) request.data = JSON.stringify(payload);
        logger({
            message: 'AxiosHttpClient.makeRequest',
            contextObject: request
        });
        // Make the call via axios
        return $5bebba5685c75139$var$AxiosHttpClient.callHttp({
            logger: logger,
            request: request,
            shouldCache: shouldCache,
            cacheFacade: cacheFacade,
            cacheTtl: cacheTtl,
            cacheErrorCodes: cacheErrorCodes
        });
    }
    /**
   * Hashes an object using md5
   *
   * @param obj
   * @returns {string}
   */ static getCacheKey(obj) {
        const stringToHash = JSON.stringify(obj);
        return $348b778d9fe7dd50$exports(stringToHash);
    }
    /**
   * Make a request via axios
   *
   * @param logger
   * @param request
   * @param shouldCache
   * @param cacheFacade
   * @param cacheTtl
   * @param cacheErrorCodes
   * @returns {Promise<{headers: *, payload: *, statusCode: *}>}
   */ static async callHttp({ logger: logger, request: request, shouldCache: shouldCache, cacheFacade: cacheFacade, cacheTtl: cacheTtl, cacheErrorCodes: cacheErrorCodes }) {
        let cacheKey = null;
        let httpResult = null;
        logger({
            message: 'AxiosHttpClient.callHttp'
        });
        try {
            // Generate a cache key for the request
            cacheKey = $5bebba5685c75139$var$AxiosHttpClient.getCacheKey(request);
            // Check the cache and return if found
            const cachedResult = await $5bebba5685c75139$var$AxiosHttpClient.checkCacheForPreviousRequestResult(logger, shouldCache, cacheFacade, cacheKey, request);
            if (cachedResult) return cachedResult;
            // Did not find in cache so let's make the call and log the duration
            const startDate = new Date();
            const start = startDate.getTime();
            const response = await $ed149b675c0b0120$exports(request);
            const endDate = new Date();
            const end = endDate.getTime();
            logger({
                message: `${end - start} milliseconds duration for HTTP call to ${request.url}`
            });
            httpResult = {
                statusCode: response.status,
                payload: response.data,
                headers: response.headers
            };
            // Cache the result if required to
            $5bebba5685c75139$var$AxiosHttpClient.cacheResultOfRequest(logger, shouldCache, cacheFacade, cacheTtl, cacheKey, httpResult);
            return httpResult;
        } catch (error) {
            if (error.response) {
                const httpErrorResult = {
                    statusCode: error.response.status,
                    payload: error.response.data,
                    headers: error.response.headers
                };
                // Should we cache the result of the error code?
                if (cacheErrorCodes.includes(error.response.status)) {
                    logger({
                        message: 'AxiosHttpClient.callHttp, result has error status code of ' + `${error.response.status}, which should be cached`
                    });
                    // Cache the result
                    await $5bebba5685c75139$var$AxiosHttpClient.cacheResultOfRequest(logger, shouldCache, cacheFacade, cacheKey, httpErrorResult);
                }
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                throw new $5bebba5685c75139$require$HttpClientException('AxiosHttpClient request response indicates error', request, httpErrorResult);
            } else if (error.request) throw new $5bebba5685c75139$require$HttpClientException('AxiosHttpClient failed to make request, no response received', request, null, error.request);
            else // Something happened in setting up the request that triggered an Error
            throw new $5bebba5685c75139$require$HttpClientException('AxiosHttpClient failed, unknown error', request, null, null, error);
        }
    }
    /**
   * Returns caches result if found. If cached
   * result is not a 2xx then the result is
   * thrown
   *
   * @param logger
   * @param shouldCache
   * @param cacheFacade
   * @param cacheKey
   * @param request
   * @returns {*}
   */ static async checkCacheForPreviousRequestResult(logger, shouldCache, cacheFacade, cacheKey, request) {
        if (shouldCache && cacheFacade) {
            logger({
                message: 'AxiosHttpClient.checkCacheForPreviousRequestResult, ' + `Checking cache for key ${cacheKey}`
            });
            const cachedResult = await cacheFacade.getKey(cacheKey);
            // if we've got a cache hit, then return the cached value
            // and do not make the http request
            if (cachedResult) {
                logger({
                    message: `AxiosHttpClient.callHttp, Cache hit for key ${cacheKey}`
                });
                if (cachedResult.statusCode < 200 || cachedResult.statusCode >= 300) {
                    logger({
                        message: 'AxiosHttpClient.checkCacheForPreviousRequestResult, cache' + ` entry for ${cacheKey} is non 2xx, so going to throw it ` + 'and allow stack to deal with it'
                    });
                    throw new $5bebba5685c75139$require$HttpClientException('AxiosHttpClient request response indicates error', request, {
                        status: cachedResult.statusCode,
                        data: cachedResult.payload,
                        headers: cachedResult.headers
                    });
                }
                // Otherwise it's a 2xx from the cache so return as normal
                return cachedResult;
            }
            logger({
                message: `AxiosHttpClient.callHttp, Cache miss for key ${cacheKey}`
            });
        }
        return false;
    }
    /**
   *
   * @param logger
   * @param shouldCache
   * @param cacheFacade
   * @param cacheTtl
   * @param cacheKey
   * @param httpResult
   */ static async cacheResultOfRequest(logger, shouldCache, cacheFacade, cacheTtl, cacheKey, httpResult) {
        if (shouldCache && cacheFacade) {
            logger({
                message: `AxiosHttpClient.cacheResultOfRequest, setting cache value for key ${cacheKey}`
            });
            await cacheFacade.setKey(cacheKey, httpResult, cacheTtl);
        }
    }
}
$5bebba5685c75139$exports = {
    AxiosHttpClient: $5bebba5685c75139$var$AxiosHttpClient
};


var $d35594ab11ace490$require$AxiosHttpClient = $5bebba5685c75139$exports.AxiosHttpClient;
var $96ab79cff0507cf1$export$d69c0d7f1b6c9ea1;
$96ab79cff0507cf1$export$d69c0d7f1b6c9ea1 = class extends Error {
    constructor(message, childError){
        super(message);
        this.name = 'BaseApiException';
        this.childError = childError;
    }
};


var $d35594ab11ace490$require$BaseApiException = $96ab79cff0507cf1$export$d69c0d7f1b6c9ea1;
/**
 * Base class api functionality
 * This must be constructed with
 * a httpAdapter that implements
 * makeRequest method as defined
 * in AxiosHttpClient.makeRequest
 *
 * logger - a function that
 * takes an object {message, contextObject}
 * and logs it as 'info' e.g. .info at
 * aura-emailer.git/src/services/logger/index.js
 *
 * envBasePath - the environment url for the
 * api in use
 *
 * jwtGenerator - function that when called
 * returns a valid JWT
 *
 * cacheFacade - found in
 * @auravisionlabs/aura-pkg-cache-facade
 */ // decorateUrlQuery cannot be static as it is called by CoreApi using {this}
// Late static binding not available in JS
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["decorateUrlQuery"] }] */ class $d35594ab11ace490$var$BaseApi {
    constructor(logger, envBasePath, jwtGenerator, cacheFacade = null){
        this.httpAdapter = $d35594ab11ace490$require$AxiosHttpClient;
        this.cacheFacade = cacheFacade;
        this.logger = logger;
        this.envBasePath = envBasePath;
        this.jwtGenerator = jwtGenerator;
    }
    /**
   * Allows updates to the client post construction
   * @param client
   */ setHttpClient(client) {
        this.httpAdapter = client;
    }
    /**
   * Gets the base headers and allows merge of
   * additional headers
   *
   * @param headersToMerge
   * @returns {object}
   */ async getHeaders(headersToMerge = {}) {
        return {
            ...headersToMerge,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${await this.getAuthToken()}`
        };
    }
    /**
   * Decorates a URL with a query passed
   * as on object of param / value pairs
   *
   * @param url
   * @param queryObject
   * @returns {string}
   */ decorateUrlQuery(url, queryObject) {
        const urlObj = new URL(url);
        const query = urlObj.search;
        const searchParams = new URLSearchParams(query);
        Object.entries(queryObject).map(([searchKey, searchValue])=>searchParams.append(searchKey, searchValue));
        urlObj.search = searchParams.toString();
        return urlObj.toString();
    }
    /**
   * Makes a request via http adapter
   * Return the full response payload
   *
   * @param method
   * @param url
   * @param headers
   * @param payload
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async makeRequest(method, url, headers, payload, shouldCache, cacheTtl, timeout) {
        const params = {
            logger: this.logger,
            method: method,
            headers: headers,
            url: url,
            payload: payload,
            shouldCache: shouldCache,
            cacheFacade: this.cacheFacade,
            cacheTtl: cacheTtl,
            timeout: timeout
        };
        try {
            const response = await this.httpAdapter.makeRequest(params);
            return {
                payload: response.payload
            };
        } catch (error) {
            throw new $d35594ab11ace490$require$BaseApiException(`BaseApi.makeRequest has failed for params: ${JSON.stringify({
                method: method,
                headers: headers,
                url: url,
                payload: payload
            })}`, error);
        }
    }
    /**
   * Return Auth token for endpoint
   *
   * @returns {*}
   */ async getAuthToken() {
        return this.jwtGenerator();
    }
}
$d35594ab11ace490$exports = {
    BaseApi: $d35594ab11ace490$var$BaseApi
};


var $f93fb987377bc1c3$require$BaseApi = $d35594ab11ace490$exports.BaseApi;
/**
 * Simple number range validator
 *
 * @param num
 * @param min
 * @param max
 * @param exception
 * @throws Error
 * @returns {boolean}
 */ var $4e998718a61ca71c$export$2c829148cb7f3c89;
$4e998718a61ca71c$export$2c829148cb7f3c89 = (num, min, max, exception)=>{
    if (!Number.isInteger(num) || num < min || num > max) throw exception;
    return true;
};


var $f93fb987377bc1c3$require$throwOnIntRangeOutOfBound = $4e998718a61ca71c$export$2c829148cb7f3c89;
const $f93fb987377bc1c3$var$scheduleResource = '/v1/scheduled-report-job/listWithinTimeParams';
const $f93fb987377bc1c3$var$cameraServerResource = '/v1/cameraServer/list';
const $f93fb987377bc1c3$var$RecordingResource = '/v1/recording';
const $f93fb987377bc1c3$var$DashboardReportResource = '/v1/dashboard-report';
const $f93fb987377bc1c3$var$SegmentResource = '/v1/segment';
const $f93fb987377bc1c3$var$ConfigurationResource = '/configuration';
const $f93fb987377bc1c3$var$ruleEvaluationResource = '/v1/rule-evaluation/';
const $f93fb987377bc1c3$var$locationResource = '/v1/location';
const $f93fb987377bc1c3$var$ruleEvaluationOrgResource = '/organisation/';
/**
 * Simple adapter for core api
 * This must be constructed with
 * a httpAdapter that implements
 * makeRequest method as defined
 * in AxiosHttpClient.makeRequest
 */ // getAuthToken cannot be static as it is called by BaseApi using {this}
// Late static binding not available in JS
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getAuthToken"] }] */ class $f93fb987377bc1c3$var$CoreApi extends $f93fb987377bc1c3$require$BaseApi {
    /**
   * Get camera servers
   *
   * params is an object that may include the following
   * property : value pairs -
   *    includes - list of relationships to include
   *    (locationDetailsWithoutTransactions, organisationDetails etc)
   *    separated by ',' - set to undefined to
   *
   *    status - list of api status values to constrain by
   *    separated by ','
   *
   *    name - list of cameraServer names to constrain by
   *    separated by ','
   *
   * shouldCache - bool indicating if result should be cached
   * NOTE - you need to construct with a cache facade to use this
   *
   * cachetTtl - how long to cache for (secs)
   *
   * Returns a payload object holding
   * the complete api call response
   *
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<[]>}
   */ async getCameraServers(params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: `CoreApi.getCameraServers called with params: ${params}`
        });
        return this.makeRequest('POST', `${this.envBasePath}${$f93fb987377bc1c3$var$cameraServerResource}`, await this.getHeaders(), {
            ...params
        }, shouldCache, cacheTtl, timeout);
    }
    /**
   * Gets all locations matching the users allowed locations
   * (via the location rule within their bootstrap)
   *
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<[]>}
   */ async getMyLocations(params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: `CoreApi.getMyLocations called with params: ${params}`
        });
        return this.makeRequest('POST', `${this.envBasePath}${$f93fb987377bc1c3$var$locationResource}/list`, await this.getHeaders(), {
            ...params
        }, shouldCache, cacheTtl, timeout);
    }
    /**
   * Get recording list
   *
   * params is an object that may include the following
   * property : value pairs -
   *    includes - list of relationships to include
   *    (locationDetailsWithoutTransactions, organisationDetails etc)
   *    separated by ',' - set to undefined to
   *
   *    filter - list of api filter values separated by ','
   *
   * shouldCache - bool indicating if result should be cached
   * NOTE - you need to construct with a cache facade to use this
   *
   * cachetTtl - how long to cache for (secs)
   *
   * Returns a payload object holding
   * the complete api call response
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getRecordingList(params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: `CoreApi.getRecordingList called with params: ${params}`
        });
        return this.makeRequest('POST', `${this.envBasePath}${$f93fb987377bc1c3$var$RecordingResource}/list`, await this.getHeaders(), {
            ...params
        }, shouldCache, cacheTtl, timeout);
    }
    /**
   * Get Segment Sum of Frames
   *
   * params is an object that may include the following
   * property : value pairs -
   *    recordings - list of recordings to search over
   *    start - period to start searching from
   *    end - period to stop searching from
   *    aggregation - the aggregationType to combine segments into
   *    timezone - the timezone of the recordings
   *    insideSchedule - whether to filter on insideSchedule or not
   *
   * shouldCache - bool indicating if result should be cached
   * NOTE - you need to construct with a cache facade to use this
   *
   * cachetTtl - how long to cache for (secs)
   *
   * Returns a payload object holding the complete api call response
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getSegmentSumFrames(params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: `CoreApi.getSegmentSumFrames called with params: ${params}`
        });
        return this.makeRequest('POST', `${this.envBasePath}${$f93fb987377bc1c3$var$SegmentResource}/sumFrames`, await this.getHeaders(), {
            ...params
        }, shouldCache, cacheTtl, timeout);
    }
    /**
   * Get Segment Avg of FPS
   *
   * params is an object that may include the following
   * property : value pairs -
   *    recordings - list of recordings to search over
   *    start - period to start searching from
   *    end - period to stop searching from
   *    aggregation - the aggregationType to combine segments into
   *    timezone - the timezone of the recordings
   *    insideSchedule - whether to filter on insideSchedule or not
   *
   * shouldCache - bool indicating if result should be cached
   * NOTE - you need to construct with a cache facade to use this
   *
   * cachetTtl - how long to cache for (secs)
   *
   * Returns a payload object holding the complete api call response
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getSegmentAvgFps(params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: `CoreApi.getSegmentAvgFps called with params: ${params}`
        });
        return this.makeRequest('POST', `${this.envBasePath}${$f93fb987377bc1c3$var$SegmentResource}/avgFps`, await this.getHeaders(), {
            ...params
        }, shouldCache, cacheTtl, timeout);
    }
    /**
   * Get recording by Id
   * @param recordingId
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getRecording(recordingId, params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: `CoreApi.getRecording called with recording id ${recordingId} and params: ${params}`
        });
        const url = this.decorateUrlQuery(`${this.envBasePath}${$f93fb987377bc1c3$var$RecordingResource}/${recordingId}`, {
            ...params
        });
        return this.makeRequest('GET', url, await this.getHeaders(), null, shouldCache, cacheTtl, timeout);
    }
    /**
   * Get recording configuration
   * @param recordingId
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getRecordingConfiguration(recordingId, params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: 'CoreApi.getRecordingConfiguration called with' + `recording id ${recordingId} and params: ${params}`
        });
        const url = this.decorateUrlQuery(`${this.envBasePath}${$f93fb987377bc1c3$var$RecordingResource}/${recordingId}${$f93fb987377bc1c3$var$ConfigurationResource}`, {
            ...params
        });
        return this.makeRequest('GET', url, await this.getHeaders(), null, shouldCache, cacheTtl, timeout);
    }
    /**
   * Gets the reports to be run for a given
   * day number and hour number
   *
   * @param day
   * @param hour
   * @param timeout
   * @returns {Promise<Object>}
   */ async getScheduledReports(dayOfMonth, dayOfWeek, hour, timeout = 180000) {
        this.logger({
            message: `CoreApi.getScheduledReports dayOfMonth: ${dayOfMonth}, dayOfWeek: ${dayOfWeek}, hour: ${hour}`
        });
        $f93fb987377bc1c3$require$throwOnIntRangeOutOfBound(dayOfMonth, 1, 31, new $f93fb987377bc1c3$require$CoreApiException(`CoreApi.getScheduledReports dayOfMonth must be int in range 1 - 31, ${dayOfMonth} provided`));
        $f93fb987377bc1c3$require$throwOnIntRangeOutOfBound(dayOfWeek, 0, 6, new $f93fb987377bc1c3$require$CoreApiException(`CoreApi.getScheduledReports dayOfWeek must be int in range 0 - 6, ${dayOfWeek} provided`));
        $f93fb987377bc1c3$require$throwOnIntRangeOutOfBound(hour, 0, 23, new $f93fb987377bc1c3$require$CoreApiException(`CoreApi.getScheduledReports hour must be int in range 0 - 23, ${hour} provided`));
        try {
            const response = await this.httpAdapter.makeRequest({
                logger: this.logger,
                method: 'GET',
                headers: await this.getHeaders(),
                url: this.decorateUrlQuery(`${this.envBasePath}${$f93fb987377bc1c3$var$scheduleResource}`, {
                    sendDayOfMonth: dayOfMonth,
                    sendDayOfWeek: dayOfWeek,
                    sendHour: hour
                }),
                payload: null,
                shouldCache: false,
                timeout: timeout
            });
            return response.payload;
        } catch (error) {
            throw new $f93fb987377bc1c3$require$CoreApiException(`CoreApi.getScheduledReports API request has failed for dayOfMonth: ${dayOfMonth}, dayOfWeek: ${dayOfWeek}, hour: ${hour}`, error);
        }
    }
    /**
   * Get recording uptime compatibility stub
   * TODO: remove this later
   * @param recordingId
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   * @deprecated
   */ async getRecordingUptime(recordingId, params, shouldCache, cacheTtl, timeout) {
        const result = await this.getRecordingUptimes([
            recordingId
        ], params, shouldCache, cacheTtl, timeout);
        return result.length ? result[0] : null;
    }
    /**
   * Get recording uptimes
   * @param recordingIds
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getRecordingUptimes(recordingIds, params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: 'CoreApi.getRecordingUptimes called with' + `recording ids ${recordingIds} and params: ${params}`
        });
        const url = this.decorateUrlQuery(`${this.envBasePath}${$f93fb987377bc1c3$var$RecordingResource}/uptimes`, {
            ...params
        });
        return this.makeRequest('POST', url, await this.getHeaders(), {
            recids: recordingIds,
            ...params
        }, shouldCache, cacheTtl, timeout);
    }
    /**
   * Get dashboard report
   * @param dashboardReportId
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getDashboardReport(dashboardReportId, params = null, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: 'CoreApi.getDashboardReport called with' + `dashboardReportId ${dashboardReportId} and params: ${params}`
        });
        const url = this.decorateUrlQuery(`${this.envBasePath}${$f93fb987377bc1c3$var$DashboardReportResource}/${dashboardReportId}`, {
            ...params
        });
        return this.makeRequest('GET', url, await this.getHeaders(), null, shouldCache, cacheTtl, timeout);
    }
    /**
   * Calls the rule-evaluation endpoint with
   * a rule type, org id and rule payload
   *
   * Returns the result of the evaluation
   * @param ruleType
   * @param organisation
   * @param rulePayload
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   */ async evaluateRule(ruleType, organisation, rulePayload = {}, shouldCache = false, cacheTtl = null, timeout = 180000) {
        this.logger({
            message: 'CoreApi.evaluateRule called with' + `rule type ${ruleType} and organisation: ${organisation}`
        });
        const url = `${this.envBasePath}${$f93fb987377bc1c3$var$ruleEvaluationResource}${ruleType}` + `${$f93fb987377bc1c3$var$ruleEvaluationOrgResource}${organisation}`;
        return this.makeRequest('POST', url, await this.getHeaders(), rulePayload, shouldCache, cacheTtl, timeout);
    }
}
$f93fb987377bc1c3$exports = {
    CoreApi: $f93fb987377bc1c3$var$CoreApi
};


var $95e1c88abef1e72f$require$CoreApi = $f93fb987377bc1c3$exports.CoreApi;

var $95e1c88abef1e72f$require$BaseApi = $d35594ab11ace490$exports.BaseApi;
var $dc0552bb2e29db2f$exports = {};

var $dc0552bb2e29db2f$require$BaseApi = $d35594ab11ace490$exports.BaseApi;
/**
 * Simple adapter for query api
 * This must be constructed with
 * a httpAdapter that implements
 * makeRequest method as defined
 * in AxiosHttpClient.makeRequest
 */ // getAuthToken cannot be static as it is called by BaseApi using {this}
// Late static binding not available in JS
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getAuthToken"] }] */ class $dc0552bb2e29db2f$var$QueryApi extends $dc0552bb2e29db2f$require$BaseApi {
    /**
   * Returns a payload object holding
   * the complete api call response
   *
   * @param url
   * @param queryPayload
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<Object>}
   */ async genericQuery({ queryResource: queryResource, queryPayload: queryPayload }, shouldCache = false, cacheTtl = null, timeout = 30000) {
        this.logger({
            message: 'QueryApi.getQueryData',
            contextObject: {
                queryResource: queryResource,
                queryPayload: queryPayload
            }
        });
        const url = `${this.envBasePath}/${queryResource}`;
        return this.makeRequest('POST', url, await this.getHeaders(), queryPayload, shouldCache, cacheTtl, timeout);
    }
}
$dc0552bb2e29db2f$exports = {
    QueryApi: $dc0552bb2e29db2f$var$QueryApi
};


var $95e1c88abef1e72f$require$QueryApi = $dc0552bb2e29db2f$exports.QueryApi;

var $95e1c88abef1e72f$require$AxiosHttpClient = $5bebba5685c75139$exports.AxiosHttpClient;
$95e1c88abef1e72f$exports = {
    AxiosHttpClient: $95e1c88abef1e72f$require$AxiosHttpClient,
    BaseApi: $95e1c88abef1e72f$require$BaseApi,
    CoreApi: $95e1c88abef1e72f$require$CoreApi,
    QueryApi: $95e1c88abef1e72f$require$QueryApi
};


var $42dc19071556195f$require$BaseApi = $95e1c88abef1e72f$exports.BaseApi;
var $fbac9574acccf85b$export$47e02012fd71e6b5;
$fbac9574acccf85b$export$47e02012fd71e6b5 = class extends Error {
    constructor(message, childError){
        super(message);
        this.name = 'AuthApiException';
        this.childError = childError;
    }
};


var $42dc19071556195f$require$AuthApiException = $fbac9574acccf85b$export$47e02012fd71e6b5;
const $42dc19071556195f$var$bootstrapOrgResource = '/api/v1/bootstrap/';
/**
 * Simple adapter for auth service api
 * This must be constructed with
 * a httpAdapter that implements
 * makeRequest method as defined
 * in AxiosHttpClient.makeRequest
 *
 * NOTE: We are using BaseAPI from
 * aura-pkg-node-core-api-adapter as
 * it gives us a great base for creating
 * this adapter. This can easily be
 * refactored into a new
 * aura-pkg-node-auth-api-adapter in
 * future
 */ /* eslint class-methods-use-this: ["error", { "exceptMethods": ["getHeaders"] }] */ class $42dc19071556195f$var$AuthAPI extends $42dc19071556195f$require$BaseApi {
    /**
   * Gets bootstrap for a given auth0Id
   * passes token
   *
   * @param auth0Id
   * @param token
   * @param skipTokenCache
   * @param params
   * @param shouldCache
   * @param cacheTtl
   * @param timeout
   * @returns {Promise<{payload: *}>}
   */ async getBootstrap(auth0Id, token, skipTokenCache = false, params = null, shouldCache = false, cacheTtl = null, timeout = 35000) {
        try {
            this.logger({
                message: 'AuthAPI.getBootstrap called with ' + `auth0Id ${auth0Id}, skipTokenCache: ${skipTokenCache} and params: ${params}`
            });
            if (typeof auth0Id !== 'string') throw new Error(`Auth0 ID is missing or incorrect type: ${auth0Id} (${typeof auth0Id})`);
            const sanitisedAuth0Id = auth0Id.replaceAll('|', '%7C');
            const url = this.decorateUrlQuery(`${this.envBasePath}${$42dc19071556195f$var$bootstrapOrgResource}${sanitisedAuth0Id}`, {
                ...params,
                skipCache: skipTokenCache.toString()
            });
            const response = await this.makeRequest('GET', url, await this.getHeaders({}, token), null, shouldCache, cacheTtl, timeout);
            return response;
        } catch (error) {
            throw new $42dc19071556195f$require$AuthApiException('AuthAPI.getBootstrap API request has failed', error);
        }
    }
    /**
   * Gets the base headers and allows merge of
   * additional headers and dynamic token
   *
   * @param headersToMerge
   * @param token
   * @returns {object}
   */ async getHeaders(headersToMerge = {}, token) {
        return {
            ...headersToMerge,
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        };
    }
}
$42dc19071556195f$exports = {
    AuthAPI: $42dc19071556195f$var$AuthAPI
};


var $feda5fba568f1d4e$require$AuthAPI = $42dc19071556195f$exports.AuthAPI;
/**
 * Abstracts api call over BootstrapBuilder.getBootstrap
 * if we have BootstrapBuilder, or the authServiceAdapter
 * if do not have BootstrapBuilder (we're not in the Auth
 * Service)
 * @param BootstrapBuilder
 * @param token
 * @param auth0Id
 * @param skipCache
 * @param authEnvBasePath
 * @param logger
 */ const $feda5fba568f1d4e$var$getBootstrapFromAuthService = async (BootstrapBuilder, token, auth0Id, skipCache, authEnvBasePath, logger)=>{
    logger.info({
        message: 'User.getBootstrapFromAuthService start',
        contextObject: {
            BootstrapBuilder: !!BootstrapBuilder,
            auth0Id: auth0Id,
            skipCache: skipCache,
            authEnvBasePath: authEnvBasePath
        }
    });
    if (BootstrapBuilder) {
        logger.info({
            message: "User.getBootstrapFromAuthService have BootstrapBuilder, so call getBootstrap directly with:",
            contextObject: {
                auth0Id: auth0Id,
                skipCache: skipCache
            }
        });
        return BootstrapBuilder.getBootstrap(auth0Id, skipCache);
    }
    logger.info({
        message: "User.getBootstrapFromAuthService do not have BootstrapBuilder , so call via authAPI with:",
        contextObject: {
            authEnvBasePath: authEnvBasePath,
            auth0Id: auth0Id,
            skipCache: skipCache
        }
    });
    const authAPI = new $feda5fba568f1d4e$require$AuthAPI(logger.info, authEnvBasePath, null);
    return (await authAPI.getBootstrap(auth0Id, token, skipCache)).payload;
};
$feda5fba568f1d4e$exports = {
    getBootstrapFromAuthService: $feda5fba568f1d4e$var$getBootstrapFromAuthService
};


var $f0c9e003502750b6$require$getBootstrapFromAuthService = $feda5fba568f1d4e$exports.getBootstrapFromAuthService;
const $f0c9e003502750b6$var$impersonateClaim = 'http://auravision.ai/impersonate';
const $f0c9e003502750b6$var$subClaim = 'sub';
/**
 * Manages which bootstrap data to retrieve and
 * whether to use cache or not
 *
 * Use skipImpersonation = true to get actual bootstrap for
 * sub of the token, rather than the impersonated user
 * This will be needed when calling authorisation on the
 * bootstrap endpoint
 *
 * NOTE: This method does not check the validity of the token,
 * but does use it to check for permission to impersonate
 *
 * @param token
 * @param cacheFacade
 * @param cacheKeyPrefix
 * @param authEnvBasePath
 * @param logger
 * @param BootstrapBuilder
 * @param skipImpersonation
 * @returns {Promise<{}>}
 */ const $f0c9e003502750b6$var$getUserBootstrap = async (token, cacheFacade, cacheKeyPrefix, authEnvBasePath, logger, BootstrapBuilder, skipImpersonation = false)=>{
    try {
        logger.info({
            message: 'User.getUserBootstrap start',
            contextObject: {}
        });
        let bootstrap = null;
        const decodedToken = $d586a33e9a49e852$exports.decode(token, {
            complete: true
        });
        // if we can't decode the token then throw NotAuthorisedError
        if (!decodedToken) throw new $f0c9e003502750b6$require$NotAuthorisedError('Token failed to decode');
        delete decodedToken.signature;
        const impersonate = $8263409ee52f7ea9$exports(decodedToken, `payload['${$f0c9e003502750b6$var$impersonateClaim}']`, false);
        const sub = $8263409ee52f7ea9$exports(decodedToken, `payload.${$f0c9e003502750b6$var$subClaim}`, false);
        logger.info({
            message: 'User.getUserBootstrap decoded token',
            contextObject: {
                decodedToken: decodedToken,
                impersonate: impersonate,
                sub: sub
            }
        });
        // if skipImpersonation == true then skip this section
        // in order to get the actual bootstrap, rather than
        // impersonated bootstrap
        if (skipImpersonation) logger.info({
            message: 'User.getUserBootstrap skipping impersonation',
            contextObject: {
                skipImpersonation: skipImpersonation
            }
        });
        else {
            logger.info({
                message: 'User.getUserBootstrap Not skipping impersonation',
                contextObject: {
                    skipImpersonation: skipImpersonation
                }
            });
            // If attempting to impersonate another user
            if (impersonate) {
                logger.info({
                    message: 'User.getUserBootstrap token attempting to impersonate a user. Check if we have the impersonated users bootstrap in the cache.',
                    contextObject: {
                        impersonatee: impersonate
                    }
                });
                const bootstrapFromCache = await $f0c9e003502750b6$var$checkCacheForBootstrap(cacheFacade, `${cacheKeyPrefix}${impersonate}`, logger);
                if (bootstrapFromCache) return bootstrapFromCache;
                // Otherwise go to auth service bootstrap api to ensure that requester has
                // impersonation authority (allow cache search)
                logger.info({
                    message: "User.getUserBootstrap token attempting to impersonate. Getting bootstrap from auth endpoint to authorise ability to " + `impersonate. Do we have local BootstrapBuilder: ${!!BootstrapBuilder}`,
                    contextObject: {
                        impersonate: impersonate
                    }
                });
                return $f0c9e003502750b6$require$getBootstrapFromAuthService(null, token, impersonate, false, authEnvBasePath, logger);
            }
        }
        // otherwise, request is for bootstrap of tokens sub, token
        // is authenticated and everybody can get their own bootstrap,
        // so no authorisation required
        bootstrap = await $f0c9e003502750b6$var$checkCacheForBootstrap(cacheFacade, `${cacheKeyPrefix}${sub}`, logger);
        if (bootstrap) return bootstrap;
        // Otherwise we'll get it from auth service bootstrap api.
        // Set skipCache as follows. If we have a cache then
        // skipCache = true else
        // skipCache = false
        return $f0c9e003502750b6$require$getBootstrapFromAuthService(BootstrapBuilder, token, sub, !!cacheFacade, authEnvBasePath, logger);
    } catch (err) {
        if (err instanceof $f0c9e003502750b6$require$NotAuthorisedError) throw err;
        throw new $f0c9e003502750b6$require$GenericAuthError('User.getUserBootstrap failed', err);
    }
};
/**
 *
 * @param cacheFacade
 * @param key
 * @param logger
 * @returns {Promise<{[p: string]: *}>}
 */ const $f0c9e003502750b6$var$checkCacheForBootstrap = async (cacheFacade, key, logger)=>{
    if (cacheFacade) {
        logger.info({
            message: `User.getUserBootstrap Check cache facade for ${key}`,
            contextObject: {
                cacheFacade: !!cacheFacade
            }
        });
        const bootstrap = await cacheFacade.getKey(`${key}`);
        if (bootstrap) {
            logger.info({
                message: `User.getUserBootstrap cache hit for ${key}`,
                contextObject: {
                    bootstrap: bootstrap
                }
            });
            return {
                ...bootstrap
            };
        }
        logger.info({
            message: `User.getUserBootstrap cache miss for ${key}`,
            contextObject: {}
        });
        return false;
    }
    logger.info({
        message: `User.getUserBootstrap Not checking cache facade for ${key}`,
        contextObject: {
            cacheFacade: !!cacheFacade
        }
    });
    return false;
};
$f0c9e003502750b6$exports = {
    getUserBootstrap: $f0c9e003502750b6$var$getUserBootstrap
};


var $6186812f8d02739d$require$getUserBootstrap = $f0c9e003502750b6$exports.getUserBootstrap;
var $c026efdc0b7a5c55$exports = {};
$c026efdc0b7a5c55$exports = {
    cptlze: (string)=>string.charAt(0).toUpperCase() + string.slice(1)
};


var $6186812f8d02739d$require$cptlze = $c026efdc0b7a5c55$exports.cptlze;
var $605de836e96c5ac3$exports = {};
/* eslint max-classes-per-file: ["error", 3] */ const $605de836e96c5ac3$var$allOrg = 'all org';
/**
 * Extends array functionality with async some
 */ class $605de836e96c5ac3$var$AsyncArray extends Array {
    async asyncSome(predicate) {
        for (const e of this){
            if (await predicate(e)) return true;
        }
        return false;
    }
}
/**
 * Extends asyncArray functionality with set helpers
 */ class $605de836e96c5ac3$var$SetArray extends $605de836e96c5ac3$var$AsyncArray {
    isSubSetOf(testAgainstArray) {
        if (!Array.isArray(testAgainstArray)) throw new Error('SetArray.isSubSetOf must be of type array');
        if (this.length === 0 || testAgainstArray.length === 0) return false;
        return this.every((val)=>testAgainstArray.includes(val));
    }
    intersectionWith(testAgainstArray) {
        if (!Array.isArray(testAgainstArray)) throw new Error('SetArray.intersectionWith must be of type array');
        return this.filter((x)=>testAgainstArray.includes(x));
    }
}
/**
 * Extends setArray functionality with capability helpers
 */ class $605de836e96c5ac3$var$CapArray extends $605de836e96c5ac3$var$SetArray {
    allOrgs() {
        return this.filter((elem)=>elem.visibility === $605de836e96c5ac3$var$allOrg);
    }
}
$605de836e96c5ac3$exports = {
    CapArray: $605de836e96c5ac3$var$CapArray,
    SetArray: $605de836e96c5ac3$var$SetArray
};


var $6186812f8d02739d$require$CapArray = $605de836e96c5ac3$exports.CapArray;
var $6186812f8d02739d$require$SetArray = $605de836e96c5ac3$exports.SetArray;
const $6186812f8d02739d$var$subClaim = 'sub';
const $6186812f8d02739d$var$ownOrg = 'own org';
const $6186812f8d02739d$var$personal = 'personal';
const $6186812f8d02739d$var$rule = 'rule';
const $6186812f8d02739d$var$notSet = 'NOT_SET';
const $6186812f8d02739d$var$inactive = 'inactive';
/* eslint class-methods-use-this: ["error", { "exceptMethods": ["cleanseEvaluators"] }] */ class $6186812f8d02739d$var$User {
    /**
   * Passed a token, will retrieve and populate
   * local instance property with bootstrap
   *
   * IMPORTANT - it is assumed that the token has been
   * authenticated prior to class construction. Passing
   * an unauthorised token will retrieve a users bootstrap
   * directly from the bootstrapCache, without authentication
   *
   * An unauthorised token will fail fallback to bootstrap api
   *
   * @param token
   * @param cacheFacade (compatible with @auravisionlabs/aura-pkg-cache-facade)
   * @param authEnvBasePath
   * @param logger (should expose info and async error methods)
   * @param BootstrapBuilder
   * @param cacheKeyPrefix
   */ constructor(token, cacheFacade, authEnvBasePath, logger, BootstrapBuilder, cacheKeyPrefix = 'bootstrap-'){
        this.token = token;
        this.cacheFacade = cacheFacade;
        this.authEnvBasePath = authEnvBasePath;
        this.logger = logger;
        this.cacheKeyPrefix = cacheKeyPrefix;
        this.BootstrapBuilder = BootstrapBuilder;
        this.logger.info({
            message: 'User.constructor start',
            contextObject: {
                authEnvBasePath: authEnvBasePath,
                cacheKeyPrefix: cacheKeyPrefix,
                cacheFacade: !!cacheFacade,
                BootstrapBuilder: !!BootstrapBuilder
            }
        });
    }
    /**
   * Refresh the bootstrap for the current token.
   * This must be called after user instantiation
   * to retrieve the bootstrap.
   *
   * Can be called to refresh the bootstrap after
   * primary org update
   *
   * @param skipImpersonation
   * @returns {*}
   */ async refresh(skipImpersonation = false) {
        this.logger.info({
            message: 'User.refresh start',
            contextObject: {
                skipImpersonation: skipImpersonation
            }
        });
        try {
            if (typeof this.token !== 'string') throw new $6186812f8d02739d$require$NotAuthorisedError(`Token missing or incorrect type: ${JSON.stringify(this.token)} (${typeof this.token})`);
            this.bootstrap = await $6186812f8d02739d$require$getUserBootstrap(this.token, this.cacheFacade, this.cacheKeyPrefix, this.authEnvBasePath, this.logger, this.BootstrapBuilder, skipImpersonation);
            return this.bootstrap;
        } catch (err) {
            if (err instanceof $6186812f8d02739d$require$NotAuthorisedError) throw err;
            throw new $6186812f8d02739d$require$GenericAuthError(`User.refresh failed to refresh bootstrap: ${err}`, err);
        }
    }
    /**
   * Return the sub of the token (this may not be the sub of the user
   * represented by the the bootstrap e.g. during impersonation)
   * @returns {*}
   */ getTokenSub() {
        const decodedToken = $d586a33e9a49e852$exports.decode(this.token, {
            complete: true
        });
        // if we can't decode the token then throw NotAuthorisedError
        if (!decodedToken) throw new $6186812f8d02739d$require$NotAuthorisedError('Token failed to decode');
        return $8263409ee52f7ea9$exports(decodedToken, `payload.${$6186812f8d02739d$var$subClaim}`, false);
    }
    /**
   * Return a copy of the raw bootstrap data
   *
   * @returns {Promise<{}>}
   */ async getRawBootstrap() {
        return $dFjst(await $8263409ee52f7ea9$exports(this, 'bootstrap', {}));
    }
    /**
   * Return a copy of bootstrap capabilities
   *
   * @returns {Promise<CapArray>}
   */ async getCapabilities() {
        return new $6186812f8d02739d$require$CapArray(...$8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'capabilities', []));
    }
    /**
   * Filters capabilities by eval function
   *
   * @returns {Promise<CapArray>}
   */ async filterCapabilities(evalFunction) {
        return (await this.getCapabilities()).filter(evalFunction);
    }
    /**
   * Returns a capability object by name, if found,
   * if not found returns undefined
   * @param name
   * @returns {Promise<{}|boolean>}
   */ async hasCapability(name) {
        return (await this.getCapabilities()).find((cpblty)=>cpblty.name === name);
    }
    /**
   * Gets capabilities from bootstrap that match resource and operation
   *
   * @returns {Promise<CapArray>}
   */ capabilitiesByResourceOp(resource, operation) {
        return this.filterCapabilities((cpblty)=>cpblty[`can${$6186812f8d02739d$require$cptlze(operation)}`] && cpblty.resource === resource);
    }
    /**
   * Get primary org id of user
   *
   * @returns {Promise<*>}
   */ async getPrimaryOrgId() {
        return $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'primaryOrgId', $6186812f8d02739d$var$notSet);
    }
    /**
   * Gets all user attributes, sets to 'NOT_SET' if attribute not in
   * Bootstrap
   *
   * @returns {Promise<*>}
   */ async getAllUserAttributes() {
        return {
            userId: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'userId', $6186812f8d02739d$var$notSet),
            fullName: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'fullName', $6186812f8d02739d$var$notSet),
            status: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'status', $6186812f8d02739d$var$notSet),
            email: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'email', $6186812f8d02739d$var$notSet),
            primaryOrgId: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'primaryOrgId', $6186812f8d02739d$var$notSet),
            ownerOrgId: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'ownerOrgId', $6186812f8d02739d$var$notSet),
            organisations: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'organisations', $6186812f8d02739d$var$notSet)
        };
    }
    /**
   * Gets an property by name from Bootstrap,
   * sets to 'NOT_SET' if attribute not in
   *
   * Accepts dot notation
   *
   * @returns {Promise<*>}
   */ async getAttribute(name) {
        return {
            [name]: $8263409ee52f7ea9$exports(await this.getRawBootstrap(), name, $6186812f8d02739d$var$notSet)
        };
    }
    /**
   * Get JSON of bootstrap
   * @returns {Promise<string>}
   */ async toJSON() {
        return JSON.stringify(await this.getRawBootstrap());
    }
    /**
   * Get owner org id of user
   *
   * @returns {Promise<*>}
   */ async getOwnerOrgId() {
        return $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'ownerOrgId', $6186812f8d02739d$var$notSet);
    }
    /**
   * Get users organisations
   *
   * @returns {Promise<*>}
   */ async getOrganisations() {
        return $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'organisations', []);
    }
    /**
   * Get id of user
   *
   * @returns {Promise<*>}
   */ async getUserId() {
        return $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'userId', $6186812f8d02739d$var$notSet);
    }
    /**
   * Get status of user
   *
   * @returns {Promise<*>}
   */ async getUserStatus() {
        return $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'status', $6186812f8d02739d$var$notSet);
    }
    /**
   * Gets all rules
   *
   * @returns {Promise<*>}
   */ async getRules() {
        return $8263409ee52f7ea9$exports(await this.getRawBootstrap(), 'rules', []);
    }
    /**
   * Get rules values (id's for location) of for rule type
   *
   * @returns {Promise<*>}
   */ async getRuleValues(ruleType) {
        const theRule = (await this.getRules()).find((eachRule)=>eachRule.type === ruleType);
        return new $6186812f8d02739d$require$SetArray(...$8263409ee52f7ea9$exports(theRule, 'values', []));
    }
    /**
   * For a given rule type, returns true if items are a subset
   * of the values of the given ruleType
   *
   * @param ruleType
   * @param items
   * @returns {{evaluate: boolean}}
   */ async ruleIsSubset(ruleType, items) {
        if (!Array.isArray(items)) throw new $6186812f8d02739d$require$GenericAuthError('user.ruleIsSubset items must be array');
        const castItems = $6186812f8d02739d$require$SetArray.from(items);
        return castItems.isSubSetOf(await this.getRuleValues(ruleType));
    }
    /**
   * For a given rule type, returns the intersection between
   * items and the values for the given rule type
   *
   * @param ruleType
   * @param items
   * @returns {{evaluate: boolean}}
   */ async ruleIntersection(ruleType, items) {
        if (!Array.isArray(items)) throw new $6186812f8d02739d$require$GenericAuthError('user.ruleIntersection items must be array');
        const castItems = $6186812f8d02739d$require$SetArray.from(items);
        return castItems.intersectionWith(await this.getRuleValues(ruleType));
    }
    /**
   * For a given resource name, CRUD operation (create, read, delete, update)
   * and evaluator object, evaluates whether a user is authorised (returns true)
   * or not (throws NotAuthorisedError)
   *
   * The evaluator object may have 1 or more of the following properties set:
   * {
   *   orgIds   // array of orgIds of the resource being CRUDed
   *            // - must match users primary org
   *   userIds   // array of userIds of the resource being CRUDed
   *            // - all must match users id
   *   ruleIds  // array of ids to match against rules[ruleNameFromCapability]
   *            // - all must be present in bootstrap.rules[ruleNameFromCapability]
   * }
   * @param resource
   * @param crudOp
   * @param evaluators
   * @returns {{evaluate: NotAuthorisedError|boolean}}
   */ can(resource, crudOp, evaluators) {
        return {
            evaluate: (async function evaluate() {
                try {
                    this.logger.info({
                        message: 'User.can start',
                        contextObject: {
                            resource: resource,
                            crudOp: crudOp,
                            evaluators: evaluators
                        }
                    });
                    // Check user status - inactive throws NotAuthorisedError
                    await this.notAuthorisedIfInactive();
                    const matchedOnResourceOp = await this.capabilitiesByResourceOp(resource, crudOp);
                    // Do we have a matching capability for resource and crudOp?
                    // Throw NotAuthorisedError if not
                    await this.checkHasCapabilities(matchedOnResourceOp);
                    // If any matchedOnResourceOp are 'all org' then authorise
                    if (await this.checkHasAllOrg(matchedOnResourceOp, 'can')) return true;
                    // Test each capability against Evaluators
                    const authorised = await matchedOnResourceOp.asyncSome(await this.testCapabilityEvaluators(evaluators));
                    if (authorised) return true;
                    throw new $6186812f8d02739d$require$NotAuthorisedError();
                } catch (err) {
                    if (err instanceof $6186812f8d02739d$require$NotAuthorisedError) throw err;
                    throw new $6186812f8d02739d$require$GenericAuthError('User.can failed', err);
                }
            }).bind(this)
        };
    }
    /**
   * For a given resource name and CRUD operation (create, read, delete, update)
   * evaluates whether a user is authorised (returns true) or not
   * (throws NotAuthorisedError)
   *
   * It does not consider visibility type against evaluator object
   *
   * @param resource
   * @param crudOp
   * @returns {{evaluate: NotAuthorisedError|boolean}}
   */ canCrud(resource, crudOp) {
        return {
            evaluate: (async function evaluate() {
                try {
                    this.logger.info({
                        message: 'User.canCrud start',
                        contextObject: {
                            resource: resource,
                            crudOp: crudOp
                        }
                    });
                    // Check user status - inactive throws NotAuthorisedError
                    await this.notAuthorisedIfInactive();
                    const matchedOnResourceOp = await this.capabilitiesByResourceOp(resource, crudOp);
                    // Do we have a matching capability for resource and crudOp?
                    // Throw NotAuthorisedError if not
                    await this.checkHasCapabilities(matchedOnResourceOp);
                    this.logger.info({
                        message: 'User.canCrud, Authorised',
                        contextObject: {}
                    });
                    return true;
                } catch (err) {
                    if (err instanceof $6186812f8d02739d$require$NotAuthorisedError) throw err;
                    throw new $6186812f8d02739d$require$GenericAuthError('User.canCrud failed', err);
                }
            }).bind(this)
        };
    }
    /**
   * For a given resource name and CRUD operation (create, read, delete, update)
   * and visibility 'all org' evaluates whether a user is authorised
   * (returns true) or not (throws NotAuthorisedError)
   *
   * This is useful for checking if the user is a Aura Admin for a given
   * resource name and CRUD operation
   *
   * @param resource
   * @param crudOp
   * @returns {{evaluate: NotAuthorisedError|boolean}}
   */ canCrudAllOrgs(resource, crudOp) {
        return {
            evaluate: (async function evaluate() {
                try {
                    this.logger.info({
                        message: 'User.canCrud start',
                        contextObject: {
                            resource: resource,
                            crudOp: crudOp
                        }
                    });
                    // Check user status - inactive throws NotAuthorisedError
                    await this.notAuthorisedIfInactive();
                    const matchedOnResourceOp = await this.capabilitiesByResourceOp(resource, crudOp);
                    // Do we have a matching capability for resource and crudOp?
                    // Throw NotAuthorisedError if not
                    await this.checkHasCapabilities(matchedOnResourceOp);
                    // If any matchedOnResourceOp are 'all org' then authorise
                    if (await this.checkHasAllOrg(matchedOnResourceOp, 'canCrudAllOrgs')) {
                        this.logger.info({
                            message: 'User.canCrudAllOrgs, Authorised',
                            contextObject: {
                                resource: resource,
                                crudOp: crudOp
                            }
                        });
                        return true;
                    }
                    // No match, throw NotAuthorisedError
                    throw new $6186812f8d02739d$require$NotAuthorisedError();
                } catch (err) {
                    if (err instanceof $6186812f8d02739d$require$NotAuthorisedError) {
                        this.logger.info({
                            message: 'User.canCrud Not Authorized',
                            contextObject: {
                                resource: resource,
                                crudOp: crudOp
                            }
                        });
                        throw err;
                    }
                    throw new $6186812f8d02739d$require$GenericAuthError('User.canCrud failed', err);
                }
            }).bind(this)
        };
    }
    /**
   * For a given sub, evaluates whether a user is authorised
   * (token has sub, returns true) or not (throws NotAuthorisedError)
   *
   * This is useful checking basic rights such as viewing their
   * own bootstrap record
   *
   * @param sub
   * @returns {{evaluate: NotAuthorisedError|boolean}}
   */ tokenHasSub(sub) {
        return {
            evaluate: (async function evaluate() {
                try {
                    this.logger.info({
                        message: 'User.hasSub start',
                        contextObject: {
                            sub: sub
                        }
                    });
                    // Check user status - inactive throws NotAuthorisedError
                    await this.notAuthorisedIfInactive();
                    const tokenSub = this.getTokenSub();
                    if (tokenSub === sub) {
                        this.logger.info({
                            message: 'User.hasSub, Authorised',
                            contextObject: {
                                sub: sub,
                                tokenSub: tokenSub
                            }
                        });
                        return true;
                    }
                    // No match, throw NotAuthorisedError
                    throw new $6186812f8d02739d$require$NotAuthorisedError();
                } catch (err) {
                    if (err instanceof $6186812f8d02739d$require$NotAuthorisedError) throw err;
                    throw new $6186812f8d02739d$require$GenericAuthError('User.canCrud failed', err);
                }
            }).bind(this)
        };
    }
    /**
   * Cast evaluator arrays to setArrays to leverage setArray.isSubSetOf()
   *
   * If a function is passed in, then it will be executed to derive
   * evaluator param value
   *
   * @param evaluators
   * @returns {{ruleIds: (SetArray), orgIds: (SetArray), userIds: (SetArray)}}
   */ async cleanseEvaluators(evaluators) {
        const castSetArray = (param)=>Array.isArray(param) ? $6186812f8d02739d$require$SetArray.from(param) : new $6186812f8d02739d$require$SetArray(param);
        return {
            orgIds: typeof evaluators.orgIds === 'function' ? castSetArray(await evaluators.orgIds()) : castSetArray(evaluators.orgIds),
            userIds: typeof evaluators.userIds === 'function' ? castSetArray(await evaluators.userIds()) : castSetArray(await evaluators.userIds),
            ruleIds: typeof evaluators.ruleIds === 'function' ? castSetArray(await evaluators.ruleIds()) : castSetArray(evaluators.ruleIds)
        };
    }
    /**
   * Test a capability visibility type against evaluators
   * Returns true for match
   * Returns falae for no match
   * @param evaluators
   * @returns {Promise<boolean>}
   */ async testCapabilityEvaluators(evaluators) {
        const castEvaluators = await this.cleanseEvaluators(evaluators);
        const userPrimaryOrg = await this.getPrimaryOrgId();
        const userId = await this.getUserId();
        return (async function testCapabilityEvaluators(cpblty) {
            this.logger.info({
                message: 'User.testCapabilityEvaluators start',
                contextObject: {
                    cpblty: cpblty,
                    castEvaluators: castEvaluators,
                    evaluators: evaluators,
                    userPrimaryOrg: userPrimaryOrg,
                    userId: userId
                }
            });
            switch(cpblty.visibility){
                case $6186812f8d02739d$var$ownOrg:
                    if (castEvaluators.orgIds.isSubSetOf([
                        userPrimaryOrg
                    ])) {
                        this.logger.info({
                            message: 'User.testCapabilityEvaluators ownOrg, Authorised',
                            contextObject: {
                                cpblty: cpblty,
                                castEvaluators: castEvaluators
                            }
                        });
                        return true;
                    }
                    break;
                case $6186812f8d02739d$var$personal:
                    if (castEvaluators.userIds.isSubSetOf([
                        userId
                    ])) {
                        this.logger.info({
                            message: 'User.testCapabilityEvaluators personal, Authorised',
                            contextObject: {
                                cpblty: cpblty,
                                castEvaluators: castEvaluators
                            }
                        });
                        return true;
                    }
                    break;
                case $6186812f8d02739d$var$rule:
                    {
                        const ruleValues = await this.getRuleValues(cpblty.ruleType);
                        if (castEvaluators.ruleIds.isSubSetOf(ruleValues)) {
                            this.logger.info({
                                message: 'User.testCapabilityEvaluators rule, Authorised',
                                contextObject: {
                                    cpblty: cpblty,
                                    castEvaluators: castEvaluators
                                }
                            });
                            return true;
                        }
                        break;
                    }
                default:
                    throw new $6186812f8d02739d$require$GenericAuthError('user.testCapabilityEvaluators Unsupported visibility ' + `type ${cpblty.visibility}`);
            }
            // Nothing has matched, so return false
            this.logger.info({
                message: 'User.testCapabilityEvaluators no rules / evaluators matched, next capability',
                contextObject: {}
            });
            return false;
        }).bind(this);
    }
    /**
   * Wrapper for matching capability all org capabilities
   * @param capabilities
   * @returns {boolean}
   */ checkHasAllOrg(capabilities, method) {
        return this.hasElements(capabilities.allOrgs(), `User.${method} matchedOnResourceOp has all org, Authorised`, `User.${method} matchedOnResourceOp does not have all orgs - next step`);
    }
    /**
   * Wrapper for matching capability for resource and crudOp test
   * @param capabilities
   * @returns {boolean}
   */ checkHasCapabilities(capabilities) {
        return this.notAuthorisedIfEmpty(capabilities, 'User.can matchedOnResourceOp capabilities found, next step', 'User.can matchedOnResourceOp length 0 - Not Authorised');
    }
    /**
   * Not authorised if inactive
   *
   * @returns {boolean}
   */ async notAuthorisedIfInactive() {
        this.logger.info({
            message: 'User.notAuthorisedIfInactive testing if inactive',
            contextObject: {}
        });
        const status = await this.getUserStatus();
        if (status === $6186812f8d02739d$var$inactive || status === $6186812f8d02739d$var$notSet) {
            this.logger.info({
                message: 'User.notAuthorisedIfInactive user is inactive or NOT_SET. Not Authorised',
                contextObject: {
                    status: status
                }
            });
            throw new $6186812f8d02739d$require$NotAuthorisedError();
        }
        return true;
    }
    /**
   * Array empty test - if empty throws not authorised
   * @param array
   * @param positiveMsg
   * @param negativeMsg
   * @returns {boolean}
   */ notAuthorisedIfEmpty(array, positiveMsg, negativeMsg) {
        if (array.length === 0) {
            this.logger.info({
                message: negativeMsg,
                contextObject: {
                    array: array
                }
            });
            throw new $6186812f8d02739d$require$NotAuthorisedError();
        }
        this.logger.info({
            message: positiveMsg,
            contextObject: {
                array: array
            }
        });
        return true;
    }
    /**
   * Array has elements test - returns true if has elements
   * returns false if empty
   *
   * @param array
   * @param positiveMsg
   * @param negativeMsg
   * @returns {boolean}
   */ hasElements(array, positiveMsg, negativeMsg) {
        // Do we have a matching capability for resource and crudOp?
        if (array.length === 0) {
            this.logger.info({
                message: negativeMsg,
                contextObject: {
                    array: array
                }
            });
            return false;
        }
        this.logger.info({
            message: positiveMsg,
            contextObject: {
                array: array
            }
        });
        return true;
    }
}
$6186812f8d02739d$exports = {
    User: $6186812f8d02739d$var$User
};


var $a2058b1c2cc8e90b$require$User = $6186812f8d02739d$exports.User;

var $a2058b1c2cc8e90b$require$AuthApiException = $fbac9574acccf85b$export$47e02012fd71e6b5;

var $a2058b1c2cc8e90b$require$GenericAuthError = $27f317b75c2d0303$export$d1dd8b648639123d;

var $a2058b1c2cc8e90b$require$NotAuthorisedError = $eade7261f38fbf30$export$1592a73131c4467e;
/**
 * Middleware to construct the user auth object
 * from token.
 *
 * Allows override of:
 * - assignToProp the property on req which the user instance is assigned
 * - authHeader which header the token can be found within
 * - BootstrapBuilder inject it here if available (i.e. in Auth Service)
 * - bootstrapCacheFacade inject it here is available (i.e. in a
 * server side service)
 * - OverrideNotAuthorisedError inject it here if pkg/NotAuthorisedError is not
 * caught in your implementation
 * - noImpersonateOnArray - array of strings of route resources that impersonation
 * should be skipped for e.g. ['/api/v1/bootstrap/']
 * - noUserOnArray - array of strings of route resources that user should
 * no be constructed or refreshed on
 * should be skipped for e.g. ['/api/v1/bootstrap/']
 *
 * @param authEnvBasePath
 * @param logger
 * @param BootstrapBuilder
 * @param assignToProp
 * @param overrideAuthHeader
 * @param bootstrapCacheFacade
 * @param noImpersonateOnArray
 * @param OverrideNotAuthorisedError
 * @param noUserOnArray
 * @returns {function(...[*]=)}
 */ var $2e1480ffaad1614f$export$49293b90670a2882;


var $2e1480ffaad1614f$require$User = $6186812f8d02739d$exports.User;

var $2e1480ffaad1614f$require$NotAuthorisedError = $eade7261f38fbf30$export$1592a73131c4467e;

var $2e1480ffaad1614f$require$GenericAuthError = $27f317b75c2d0303$export$d1dd8b648639123d;
const $2e1480ffaad1614f$var$bearerPrefix = 'Bearer ';
$2e1480ffaad1614f$export$49293b90670a2882 = (authEnvBasePath, logger, BootstrapBuilder = null, assignToProp = null, overrideAuthHeader = null, bootstrapCacheFacade = null, noImpersonateOnArray = [], OverrideNotAuthorisedError = $2e1480ffaad1614f$require$NotAuthorisedError, noUserOnArray = [])=>async (req, res, next)=>{
        try {
            logger.info({
                message: 'createUserFromToken.start'
            });
            // Should we skip user build on this resource?
            if ($2e1480ffaad1614f$var$isResourceInArray(req, noUserOnArray, logger)) {
                logger.info({
                    message: 'createUserFromToken - skipping user construction for this route'
                });
                return next();
            }
            // Default the authUser param to assign user to on req
            // Default which header we get the token from
            const authParam = assignToProp || 'authUser';
            const authHeader = overrideAuthHeader || 'authorization';
            // Strip out the token from 'Bearer xxxx'
            const [, token] = $8263409ee52f7ea9$exports(req, `headers.${authHeader}`, `${$2e1480ffaad1614f$var$bearerPrefix} null`).split($2e1480ffaad1614f$var$bearerPrefix);
            // Construct the user auth object
            const user = new $2e1480ffaad1614f$require$User(token, bootstrapCacheFacade, authEnvBasePath, logger, BootstrapBuilder);
            // Get the bootstrap for the user
            await user.refresh($2e1480ffaad1614f$var$isResourceInArray(req, noImpersonateOnArray, logger));
            // Assign it the the authUser (or custom) property of req
            req[authParam] = user;
        } catch (err) {
            // If the user object fails with NotAuthorisedError, return NotAuthorisedError OR
            // the overridden error
            if (err instanceof $2e1480ffaad1614f$require$NotAuthorisedError) return next(new OverrideNotAuthorisedError());
            // Otherwise log and return the error
            await logger.error({
                message: 'createUserFromToken - Failed',
                contextObject: err
            });
            return next(err);
        }
        // User auth object built, let's go to next middleware
        return next();
    };
/**
 * Returns true if the current resource path is present in an array
 * of resource paths
 * @param req
 * @param resourceArray
 * @param logger
 * @return boolean
 */ const $2e1480ffaad1614f$var$isResourceInArray = (req, resourceArray, logger)=>{
    logger.info({
        message: 'createUserFromToken.isResourceInArray start. ',
        contextObject: resourceArray
    });
    const requestedResourcePath = $2e1480ffaad1614f$var$getResourcePath(req);
    const isPresent = resourceArray.some((route)=>requestedResourcePath.startsWith(route));
    logger.info({
        message: `createUserFromToken.isResourceInArray isPresent: ${isPresent}`,
        contextObject: {
            requestedResourcePath: requestedResourcePath,
            isPresent: isPresent
        }
    });
    return isPresent;
};
/**
 * Get the current resource path
 * @param req
 */ const $2e1480ffaad1614f$var$getResourcePath = (req)=>{
    const requestedResourcePath = $8263409ee52f7ea9$exports(req, '_parsedUrl.path', false);
    if (!requestedResourcePath) throw new $2e1480ffaad1614f$require$GenericAuthError("createUserFromToken.getResourcePath Error. Unable to resolve requestContext.path from req", req);
    return requestedResourcePath;
};


var $a2058b1c2cc8e90b$require$createUserFromToken = $2e1480ffaad1614f$export$49293b90670a2882;
/**
 * Auth middleware - at least one of the injected tests must not throw
 * NotAuthorisedError
 *
 * All of the injected tests must not throw any other kind of error
 *
 * Allows override of:
 * - OverrideNotAuthorisedError inject it here if pkg/NotAuthorisedError is not
 * caught in your implementation
 *
 * @param rules
 * @param OverrideNotAuthorisedError
 * @returns {function(...[*]=)}
 */ var $ac75a52397bb8b82$export$e9d93b9160788733;
var $f7464e4ffb9e977e$exports = {};
'use strict';
Object.defineProperty($f7464e4ffb9e977e$exports, "__esModule", {
    value: true
});
var $3c71714de96ac378$exports = {};
"use strict";
Object.defineProperty($3c71714de96ac378$exports, "__esModule", {
    value: true
});
$3c71714de96ac378$exports.default = $3c71714de96ac378$var$all;
function $3c71714de96ac378$var$all(iterable) {
    return Promise.all(iterable);
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'all', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($3c71714de96ac378$exports).default;
    }
});
var $f9d11abd73183476$exports = {};
'use strict';
Object.defineProperty($f9d11abd73183476$exports, "__esModule", {
    value: true
});
$f9d11abd73183476$exports.default = $f9d11abd73183476$var$any;
var $05c166eb550ed64e$exports = {};
'use strict';
Object.defineProperty($05c166eb550ed64e$exports, "__esModule", {
    value: true
});
$05c166eb550ed64e$exports.default = $05c166eb550ed64e$var$concurrent;
var $1adb4084cd4ee3f7$exports = {};
'use strict';
Object.defineProperty($1adb4084cd4ee3f7$exports, "__esModule", {
    value: true
});
$1adb4084cd4ee3f7$exports.size = $1adb4084cd4ee3f7$var$size;
$1adb4084cd4ee3f7$exports.repeat = $1adb4084cd4ee3f7$var$repeat;
$1adb4084cd4ee3f7$exports.toArray = $1adb4084cd4ee3f7$var$toArray;
$1adb4084cd4ee3f7$exports.toBoolean = $1adb4084cd4ee3f7$var$toBoolean;
$1adb4084cd4ee3f7$exports.identity = $1adb4084cd4ee3f7$var$identity;
$1adb4084cd4ee3f7$exports.defaults = $1adb4084cd4ee3f7$var$defaults;
$1adb4084cd4ee3f7$exports.isIterable = $1adb4084cd4ee3f7$var$isIterable;
$1adb4084cd4ee3f7$exports.noop = $1adb4084cd4ee3f7$var$noop;
$1adb4084cd4ee3f7$exports.isDefined = $1adb4084cd4ee3f7$var$isDefined;
function $1adb4084cd4ee3f7$var$size(obj) {
    return Array.isArray(obj) ? obj.length : Object.keys(obj).length;
}
function $1adb4084cd4ee3f7$var$repeat(count, fn) {
    // eslint-disable-next-line no-plusplus
    for(var i = 0; i < count; i++)fn(i);
}
function $1adb4084cd4ee3f7$var$toArray(obj) {
    return Object.keys(obj).map(function(i) {
        return obj[i];
    });
}
function $1adb4084cd4ee3f7$var$toBoolean(val) {
    return !!val;
}
function $1adb4084cd4ee3f7$var$identity(value) {
    return value;
}
function $1adb4084cd4ee3f7$var$defaults(obj, defaultObj) {
    var initial = Object.assign({}, defaultObj);
    return Object.keys(obj).reduce(function(results, key) {
        results[key] = obj[key] === undefined ? defaultObj[key] : obj[key];
        return results;
    }, initial);
}
function $1adb4084cd4ee3f7$var$isIterable(iterable) {
    return iterable && typeof iterable.entries === 'function';
}
function $1adb4084cd4ee3f7$var$noop() {}
function $1adb4084cd4ee3f7$var$isDefined(val) {
    return val !== undefined;
}


function $05c166eb550ed64e$var$run() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var iterator = args[0], isFulfilled = args[1], transform = args[2], onItemResolved = args[3], onItemRejected = args[4], onItemCompleted = args[5];
    var iteration = iterator.next();
    if (iteration.done || isFulfilled()) return;
    var key = iteration.value[0];
    var value = iteration.value[1];
    transform(value, key).then(function(resolved) {
        return onItemResolved(resolved, key);
    }).catch(function(error) {
        return onItemRejected(error, key);
    }).then(function() {
        onItemCompleted();
        $05c166eb550ed64e$var$run.apply(undefined, args);
    });
}
function $05c166eb550ed64e$var$concurrent(_options) {
    return function(values) {
        return new Promise(function(resolve, reject) {
            var options = (0, $1adb4084cd4ee3f7$exports.defaults)(_options, {
                limit: values.length,
                breakOnError: true,
                transform: $1adb4084cd4ee3f7$exports.identity,
                onItemCompleted: function onItemCompleted() {
                    return $1adb4084cd4ee3f7$exports.noop;
                },
                onItemResolved: $1adb4084cd4ee3f7$exports.noop,
                onItemRejected: $1adb4084cd4ee3f7$exports.noop
            });
            var count = 0;
            var fulfilled = false;
            var errors = [];
            var iterator = values.entries();
            var isFulfilled = function isFulfilled() {
                return fulfilled;
            };
            function done(value) {
                resolve(value);
                fulfilled = true;
            }
            function throws(error) {
                reject(error);
                fulfilled = true;
            }
            function onItemCompleted() {
                count += 1;
                if (options.breakOnError && errors.length) {
                    throws(errors[0]);
                    return;
                }
                options.onItemCompleted(done, throws)(count, values, errors);
            }
            function onItemRejected(error) {
                if (fulfilled) return;
                errors = errors.concat(error);
                return options.onItemRejected(error);
            }
            function onItemResolved(value, key) {
                if (fulfilled) return;
                return options.onItemResolved(value, key, values);
            }
            var transform = function transform(value, key) {
                return Promise.resolve(options.transform(value, key, values));
            };
            (0, $1adb4084cd4ee3f7$exports.repeat)(options.limit, function() {
                return $05c166eb550ed64e$var$run(iterator, isFulfilled, transform, onItemResolved, onItemRejected, onItemCompleted);
            });
        });
    };
}


var $f9d11abd73183476$var$_concurrent2 = $f9d11abd73183476$var$_interopRequireDefault($05c166eb550ed64e$exports);
var $8e26be9bd1b74d21$exports = {};
'use strict';
Object.defineProperty($8e26be9bd1b74d21$exports, "__esModule", {
    value: true
});
var $8e26be9bd1b74d21$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $8e26be9bd1b74d21$var$customError(fn, BaseError) {
    BaseError = BaseError || Error;
    function CustomError() {
        // eslint-disable-next-line no-proto
        var _this = CustomError.__proto__.apply(this, arguments);
        Object.assign(_this, fn.apply(null, arguments));
        return _this;
    }
    Object.setPrototypeOf(CustomError, BaseError);
    return CustomError;
}
var $8e26be9bd1b74d21$var$SubError = $8e26be9bd1b74d21$exports.SubError = $8e26be9bd1b74d21$var$customError(function(errors) {
    var multiStack = errors.reduce(function(str, error) {
        str += '\n\n' + error.stack;
        return str;
    }, '');
    return {
        name: 'SubError',
        message: 'SubError ' + multiStack,
        errors: errors
    };
}, Error);
var $8e26be9bd1b74d21$var$IterableError = $8e26be9bd1b74d21$exports.IterableError = $8e26be9bd1b74d21$var$customError(function(value) {
    var type = value === null ? 'null' : typeof value === 'undefined' ? 'undefined' : $8e26be9bd1b74d21$var$_typeof(value);
    return {
        name: 'IterableError',
        message: 'expecting an array or an iterable object but got ' + type
    };
}, TypeError);



function $f9d11abd73183476$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f9d11abd73183476$var$any(iterable) {
    var winner = void 0;
    return Promise.resolve(iterable).then((0, $f9d11abd73183476$var$_concurrent2.default)({
        breakOnError: false,
        onItemResolved: function onItemResolved(value) {
            if (!(0, $1adb4084cd4ee3f7$exports.isDefined)(winner)) winner = value;
        },
        onItemCompleted: function onItemCompleted(done, throws) {
            return function(count, values, errors) {
                if ((0, $1adb4084cd4ee3f7$exports.isDefined)(winner)) done(winner);
                else if ((0, $1adb4084cd4ee3f7$exports.size)(errors) === (0, $1adb4084cd4ee3f7$exports.size)(values)) throws(new $8e26be9bd1b74d21$exports.SubError(errors));
            };
        }
    }));
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'any', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($f9d11abd73183476$exports).default;
    }
});
var $517324b7e5cab9b7$exports = {};
"use strict";
Object.defineProperty($517324b7e5cab9b7$exports, "__esModule", {
    value: true
});
$517324b7e5cab9b7$exports.default = $517324b7e5cab9b7$var$props;
function $517324b7e5cab9b7$var$props(obj) {
    var keys = Object.keys(obj);
    var values = Object.values(obj);
    return Promise.all(values).then(function(resolvedVals) {
        return resolvedVals.reduce(function(results, val, i) {
            results[keys[i]] = val;
            return results;
        }, {});
    });
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'props', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($517324b7e5cab9b7$exports).default;
    }
});
var $4097f34884d9983f$exports = {};
"use strict";
Object.defineProperty($4097f34884d9983f$exports, "__esModule", {
    value: true
});
$4097f34884d9983f$exports.default = $4097f34884d9983f$var$race;
function $4097f34884d9983f$var$race(iterable) {
    return Promise.race(iterable);
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'race', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($4097f34884d9983f$exports).default;
    }
});
var $ba5aea9434ec5aaf$exports = {};
'use strict';
Object.defineProperty($ba5aea9434ec5aaf$exports, "__esModule", {
    value: true
});
$ba5aea9434ec5aaf$exports.default = $ba5aea9434ec5aaf$var$each;
var $12a8eae49faa64aa$exports = {};
"use strict";
Object.defineProperty($12a8eae49faa64aa$exports, "__esModule", {
    value: true
});
$12a8eae49faa64aa$exports.default = $12a8eae49faa64aa$var$series;
function $12a8eae49faa64aa$var$series(reducer, initial) {
    return function(iterable) {
        return iterable.reduce(function(chain, value, key) {
            return chain.then(function(results) {
                return reducer(results, value, key, iterable);
            });
        }, Promise.resolve(initial));
    };
}


var $ba5aea9434ec5aaf$var$_series2 = $ba5aea9434ec5aaf$var$_interopRequireDefault($12a8eae49faa64aa$exports);
function $ba5aea9434ec5aaf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba5aea9434ec5aaf$var$each(iterable, iterator) {
    return Promise.all(iterable).then((0, $ba5aea9434ec5aaf$var$_series2.default)(function(results, value, key, values) {
        return iterator(value, key, values);
    })).then(function() {
        return undefined;
    });
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'each', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($ba5aea9434ec5aaf$exports).default;
    }
});
var $37787fd2f7fa0db1$exports = {};
'use strict';
Object.defineProperty($37787fd2f7fa0db1$exports, "__esModule", {
    value: true
});
$37787fd2f7fa0db1$exports.default = $37787fd2f7fa0db1$var$filter;
var $b56920965ade605b$exports = {};
'use strict';
Object.defineProperty($b56920965ade605b$exports, "__esModule", {
    value: true
});
$b56920965ade605b$exports.default = $b56920965ade605b$var$filterLimit;

var $b56920965ade605b$var$_concurrent2 = $b56920965ade605b$var$_interopRequireDefault($05c166eb550ed64e$exports);
var $4ba1eeac0ae111e4$exports = {};
'use strict';
Object.defineProperty($4ba1eeac0ae111e4$exports, "__esModule", {
    value: true
});
$4ba1eeac0ae111e4$exports.default = $4ba1eeac0ae111e4$var$resolveAll;


function $4ba1eeac0ae111e4$var$resolve(promises) {
    return Array.isArray(promises) ? Promise.all(promises) : Promise.resolve(promises);
}
function $4ba1eeac0ae111e4$var$resolveAll(promises) {
    var rejectNonIterable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return $4ba1eeac0ae111e4$var$resolve(promises).then(function(resolved) {
        if (rejectNonIterable && !(0, $1adb4084cd4ee3f7$exports.isIterable)(resolved)) return Promise.reject((0, $8e26be9bd1b74d21$exports.IterableError)(resolved));
        return resolved;
    });
}


var $b56920965ade605b$var$_resolveAll2 = $b56920965ade605b$var$_interopRequireDefault($4ba1eeac0ae111e4$exports);

function $b56920965ade605b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b56920965ade605b$var$filterLimit(iterable, filterer, limit) {
    var resolved = {};
    return (0, $b56920965ade605b$var$_resolveAll2.default)(iterable).then((0, $b56920965ade605b$var$_concurrent2.default)({
        limit: limit,
        onItemResolved: function onItemResolved(value, key, values) {
            var maybePromise = filterer(value, key, values);
            return Promise.resolve(maybePromise).then($1adb4084cd4ee3f7$exports.toBoolean).then(function(bool) {
                if (bool) resolved[key] = value;
            });
        },
        onItemCompleted: function onItemCompleted(done) {
            return function(count, values) {
                if (count === values.length) done((0, $1adb4084cd4ee3f7$exports.toArray)(resolved));
            };
        }
    }));
}


var $37787fd2f7fa0db1$var$_filterLimit2 = $37787fd2f7fa0db1$var$_interopRequireDefault($b56920965ade605b$exports);
function $37787fd2f7fa0db1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $37787fd2f7fa0db1$var$filter(iterable, filterer) {
    return (0, $37787fd2f7fa0db1$var$_filterLimit2.default)(iterable, filterer);
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'filter', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($37787fd2f7fa0db1$exports).default;
    }
});

Object.defineProperty($f7464e4ffb9e977e$exports, 'filterLimit', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($b56920965ade605b$exports).default;
    }
});
var $0fae343ad3361dda$exports = {};
'use strict';
Object.defineProperty($0fae343ad3361dda$exports, "__esModule", {
    value: true
});
$0fae343ad3361dda$exports.default = $0fae343ad3361dda$var$map;

var $0fae343ad3361dda$var$_resolveAll2 = $0fae343ad3361dda$var$_interopRequireDefault($4ba1eeac0ae111e4$exports);

function $0fae343ad3361dda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0fae343ad3361dda$var$map(iterable) {
    var mapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1adb4084cd4ee3f7$exports.identity;
    return (0, $0fae343ad3361dda$var$_resolveAll2.default)(iterable).then(function(values) {
        return Promise.all(values.map(mapper));
    });
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'map', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($0fae343ad3361dda$exports).default;
    }
});
var $81ddee40218cc250$exports = {};
'use strict';
Object.defineProperty($81ddee40218cc250$exports, "__esModule", {
    value: true
});
$81ddee40218cc250$exports.default = $81ddee40218cc250$var$mapLimit;

var $81ddee40218cc250$var$_concurrent2 = $81ddee40218cc250$var$_interopRequireDefault($05c166eb550ed64e$exports);

var $81ddee40218cc250$var$_resolveAll2 = $81ddee40218cc250$var$_interopRequireDefault($4ba1eeac0ae111e4$exports);


var $81ddee40218cc250$var$_map2 = $81ddee40218cc250$var$_interopRequireDefault($0fae343ad3361dda$exports);
function $81ddee40218cc250$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $81ddee40218cc250$var$mapLimit(iterable) {
    var mapper = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $1adb4084cd4ee3f7$exports.identity;
    var limit = arguments[2];
    var resolved = {};
    if (!limit || iterable.length <= limit) return (0, $81ddee40218cc250$var$_map2.default)(iterable, mapper);
    return (0, $81ddee40218cc250$var$_resolveAll2.default)(iterable).then((0, $81ddee40218cc250$var$_concurrent2.default)({
        limit: limit,
        breakOnError: true,
        transform: mapper,
        onItemResolved: function onItemResolved(value, key) {
            resolved[key] = value;
        },
        onItemCompleted: function onItemCompleted(done) {
            return function(count, values) {
                if (count === values.length) done((0, $1adb4084cd4ee3f7$exports.toArray)(resolved));
            };
        }
    }));
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'mapLimit', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($81ddee40218cc250$exports).default;
    }
});
var $e535eadab33f1429$exports = {};
'use strict';
Object.defineProperty($e535eadab33f1429$exports, "__esModule", {
    value: true
});
$e535eadab33f1429$exports.default = $e535eadab33f1429$var$mapSeries;

var $e535eadab33f1429$var$_series2 = $e535eadab33f1429$var$_interopRequireDefault($12a8eae49faa64aa$exports);
function $e535eadab33f1429$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e535eadab33f1429$var$mapSeries(iterable, mapper) {
    return Promise.all(iterable).then((0, $e535eadab33f1429$var$_series2.default)(function(results, value, key, values) {
        return Promise.resolve(value).then(function(resolved) {
            return mapper(resolved, key, values);
        }).then(function(resolved) {
            results.push(resolved);
            return results;
        });
    }, []));
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'mapSeries', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($e535eadab33f1429$exports).default;
    }
});
var $09f24b3f541aa0d9$exports = {};
'use strict';
Object.defineProperty($09f24b3f541aa0d9$exports, "__esModule", {
    value: true
});
$09f24b3f541aa0d9$exports.default = $09f24b3f541aa0d9$var$reduce;

var $09f24b3f541aa0d9$var$_series2 = $09f24b3f541aa0d9$var$_interopRequireDefault($12a8eae49faa64aa$exports);

var $09f24b3f541aa0d9$var$_resolveAll2 = $09f24b3f541aa0d9$var$_interopRequireDefault($4ba1eeac0ae111e4$exports);
function $09f24b3f541aa0d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $09f24b3f541aa0d9$var$reduce(iterable, reducer, initial) {
    return (0, $09f24b3f541aa0d9$var$_resolveAll2.default)(iterable).then((0, $09f24b3f541aa0d9$var$_series2.default)(reducer, initial));
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'reduce', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($09f24b3f541aa0d9$exports).default;
    }
});
var $4b2430e435cda03c$exports = {};
'use strict';
Object.defineProperty($4b2430e435cda03c$exports, "__esModule", {
    value: true
});
$4b2430e435cda03c$exports.default = $4b2430e435cda03c$var$some;

var $4b2430e435cda03c$var$_concurrent2 = $4b2430e435cda03c$var$_interopRequireDefault($05c166eb550ed64e$exports);


function $4b2430e435cda03c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b2430e435cda03c$var$some(iterable, total) {
    var resolved = {};
    return Promise.resolve(iterable).then((0, $4b2430e435cda03c$var$_concurrent2.default)({
        breakOnError: false,
        onItemResolved: function onItemResolved(value, key) {
            resolved[key] = value;
        },
        onItemCompleted: function onItemCompleted(done, throws) {
            return function(count, values, errors) {
                var tooManyFails = values.length - errors.length <= total;
                if ((0, $1adb4084cd4ee3f7$exports.size)(resolved) === total) done((0, $1adb4084cd4ee3f7$exports.toArray)(resolved));
                else if (tooManyFails) throws(new $8e26be9bd1b74d21$exports.SubError(errors));
            };
        }
    }));
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'some', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($4b2430e435cda03c$exports).default;
    }
});
var $568e8acdceeae2ce$exports = {};
'use strict';
Object.defineProperty($568e8acdceeae2ce$exports, "__esModule", {
    value: true
});
$568e8acdceeae2ce$exports.default = $568e8acdceeae2ce$var$flow;

var $568e8acdceeae2ce$var$_resolveAll2 = $568e8acdceeae2ce$var$_interopRequireDefault($4ba1eeac0ae111e4$exports);

var $568e8acdceeae2ce$var$_series2 = $568e8acdceeae2ce$var$_interopRequireDefault($12a8eae49faa64aa$exports);
function $568e8acdceeae2ce$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $568e8acdceeae2ce$var$flow(value, fns) {
    return (0, $568e8acdceeae2ce$var$_resolveAll2.default)(value, false).then(function(initial) {
        return (0, $568e8acdceeae2ce$var$_series2.default)(function(val, fn) {
            return fn(val);
        }, initial)(fns);
    });
}


Object.defineProperty($f7464e4ffb9e977e$exports, 'flow', {
    enumerable: true,
    get: function get() {
        return $f7464e4ffb9e977e$var$_interopRequireDefault($568e8acdceeae2ce$exports).default;
    }
});
function $f7464e4ffb9e977e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}


var $ac75a52397bb8b82$require$each = $f7464e4ffb9e977e$exports.each;

var $ac75a52397bb8b82$require$NotAuthorisedError = $eade7261f38fbf30$export$1592a73131c4467e;
$ac75a52397bb8b82$export$e9d93b9160788733 = (rules, OverrideNotAuthorisedError = $ac75a52397bb8b82$require$NotAuthorisedError)=>async (req, res, next)=>{
        try {
            // If it's not already one, make the injected rules an array
            const arrayOfRules = Array.isArray(rules) ? rules : [
                rules
            ];
            let onePassed = false;
            let inappropriateThrow = false;
            // Evaluate each of the rules and track if any pass
            // or if any throw with an error that is not
            // NotAuthorisedError
            await $ac75a52397bb8b82$require$each(arrayOfRules, async (rule)=>{
                try {
                    await rule.evaluate();
                    onePassed = true;
                } catch (err) {
                    if (!(err instanceof $ac75a52397bb8b82$require$NotAuthorisedError)) inappropriateThrow = err;
                }
            });
            // If something threw that was not NotAuthorisedError
            // then bubble it
            if (inappropriateThrow) return next(inappropriateThrow);
            // If at least one passed the open the gate!
            if (onePassed) return next();
            // Otherwise at least one has not passed, so throw
            // NotAuthorisedError (or overridden error class)
            return next(new OverrideNotAuthorisedError());
        } catch (err) {
            return next(err);
        }
    };


var $a2058b1c2cc8e90b$require$authAny = $ac75a52397bb8b82$export$e9d93b9160788733;
/**
 * Auth middleware - all of the injected tests must not throw
 * NotAuthorisedError
 *
 * All of the injected tests must not throw any other kind of error
 *
 * Allows override of:
 * - OverrideNotAuthorisedError inject it here if pkg/NotAuthorisedError is not
 * caught in your implementation
 *
 * @param rules
 * @param OverrideNotAuthorisedError
 * @returns {function(...[*]=)}
 */ var $a93fc42b7cc1868f$export$a81a63aa39c4fbbf;

var $a93fc42b7cc1868f$require$each = $f7464e4ffb9e977e$exports.each;

var $a93fc42b7cc1868f$require$NotAuthorisedError = $eade7261f38fbf30$export$1592a73131c4467e;
$a93fc42b7cc1868f$export$a81a63aa39c4fbbf = (rules, OverrideNotAuthorisedError = $a93fc42b7cc1868f$require$NotAuthorisedError)=>async (req, res, next)=>{
        try {
            // If it's not already one, make the injected rules an array
            const arrayOfRules = Array.isArray(rules) ? rules : [
                rules
            ];
            let oneNotAuth = false;
            let inappropriateThrow = false;
            // Evaluate each of the rules and track if any throw notAuthorised
            // or if any throw with an error that is not
            // NotAuthorisedError
            await $a93fc42b7cc1868f$require$each(arrayOfRules, async (rule)=>{
                try {
                    await rule.evaluate();
                } catch (err) {
                    if (!(err instanceof $a93fc42b7cc1868f$require$NotAuthorisedError)) inappropriateThrow = err;
                    else oneNotAuth = true;
                }
            });
            // If something threw that was not NotAuthorisedError
            // then bubble it
            if (inappropriateThrow) return next(inappropriateThrow);
            // If at least one threw notAuthorised the notAuthorised
            if (oneNotAuth) return next(new OverrideNotAuthorisedError());
            // Otherwise no notAuthorised or other kind of error, so open
            // the gate!
            return next();
        } catch (err) {
            return next(err);
        }
    };


var $a2058b1c2cc8e90b$require$authAll = $a93fc42b7cc1868f$export$a81a63aa39c4fbbf;
var $7dd79c738440a913$exports = {};
$7dd79c738440a913$exports = {
    resources: {
        user: 'user',
        rule: 'rule',
        role: 'role',
        capability: 'capability',
        capabilityRole: 'capability-role',
        roleUser: 'role-user',
        userOrg: 'user-org',
        userRole: 'user-role',
        userRule: 'user-rule',
        adoptedUser: 'adopted-user',
        adminRole: 'admin-role',
        adminRoleUser: 'admin-role-user',
        adminRoleCapability: 'admin-role-capability',
        orgUser: 'org-user',
        inviteUser: 'invite-user',
        bootstrapCache: 'bootstrap-cache',
        impersonate: 'impersonate',
        areaContext: 'areaContext',
        lineContext: 'lineContext',
        statElemsConfig: 'statElemsConfig',
        cameraServer: 'cameraServer',
        heatmap: 'heatmap',
        location: 'location',
        locationTransaction: 'location-transaction',
        recording: 'recording',
        recordingSegment: 'recording-segment',
        recordingHeatmap: 'recording-heatmap',
        recordingSources: 'recording-sources',
        recordingProcessingConfig: 'recording-processingConfig',
        recordingStatElems: 'recording-statElems',
        recordingConfiguration: 'recording-configuration',
        report: 'report',
        segment: 'segment',
        visitorEvent: 'visitor-event',
        organisation: 'organisation',
        processingConfig: 'processingConfig',
        ruleEvaluation: 'ruleEvaluation',
        dashboardReport: 'dashboardReport',
        deviceIOTAllCommands: 'device-iot-all-commands',
        deviceIOTSingleCommand: 'device-iot-single-command_',
        scheduledReportJob: 'scheduledReportJob',
        taxonomyMeta: 'taxonomyMeta',
        message: 'message'
    },
    authActions: {
        create: 'create',
        update: 'update',
        delete: 'delete',
        read: 'read'
    }
};


$a2058b1c2cc8e90b$exports = {
    User: $a2058b1c2cc8e90b$require$User,
    AuthApiException: $a2058b1c2cc8e90b$require$AuthApiException,
    GenericAuthError: $a2058b1c2cc8e90b$require$GenericAuthError,
    NotAuthorisedError: $a2058b1c2cc8e90b$require$NotAuthorisedError,
    createUserFromToken: $a2058b1c2cc8e90b$require$createUserFromToken,
    authAny: $a2058b1c2cc8e90b$require$authAny,
    authAll: $a2058b1c2cc8e90b$require$authAll,
    authPkgConfig: $7dd79c738440a913$exports
};



const $c1bff235c2818d53$var$FormWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).form`
    width: 90%;
    margin: 2em auto;
`;
const $c1bff235c2818d53$export$ec4834aea7c622be = ({ isOpen: isOpen, onClose: onClose })=>{
    const [loading, setLoading] = (0, $kYL7Z.useState)(false);
    const [response, setResponse] = (0, $kYL7Z.useState)({});
    const nameInput = (0, $kYL7Z.useRef)(null);
    const [resource, setResource] = (0, $kYL7Z.useState)('');
    const [iotCommandName, setIotCommandName] = (0, $kYL7Z.useState)('');
    const [canCreate, setCanCreate] = (0, $kYL7Z.useState)(false);
    const [canRead, setCanRead] = (0, $kYL7Z.useState)(false);
    const [canUpdate, setCanUpdate] = (0, $kYL7Z.useState)(false);
    const [canDelete, setCanDelete] = (0, $kYL7Z.useState)(false);
    const [visibility, setVisibility] = (0, $kYL7Z.useState)('own org');
    const [auraAdminOnly, setAuraAdminOnly] = (0, $kYL7Z.useState)(false);
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen) {
            if (nameInput.current) nameInput.current.focus();
            setResponse({});
        }
    }, [
        isOpen
    ]);
    const formSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        setResponse({});
        try {
            const newCapability = {
                name: nameInput.current.value,
                resource: resource,
                canCreate: canCreate,
                canRead: canRead,
                canUpdate: canUpdate,
                canDelete: canDelete,
                visibility: visibility,
                auraAdminOnly: auraAdminOnly
            };
            if (newCapability.resource === (0, $a2058b1c2cc8e90b$exports.authPkgConfig).resources.deviceIOTSingleCommand) newCapability.resource = `${newCapability.resource}${iotCommandName}`;
            await $aa27e6f0058e6325$export$8e76ac9f37578d1b.create(newCapability);
            setResponse({
                type: 'success',
                text: 'Capability added'
            });
        } catch (err) {
            setResponse({
                type: 'warning',
                text: 'There was an error'
            });
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        icon: "plus",
        title: "Add a new capability",
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($c1bff235c2818d53$var$FormWrapper, {
            onSubmit: formSubmit,
            children: [
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    label: "Capability Name",
                    labelFor: "cap-name",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                        id: "cap-name",
                        inputRef: nameInput,
                        required: true
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    label: "Resource",
                    labelFor: "cap-resource",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9e675beb9e64c244$export$49d2a72fcffd1efe), {
                        id: "cap-resource",
                        onChange: (e)=>setResource(e.target.value),
                        options: Object.values((0, $a2058b1c2cc8e90b$exports.authPkgConfig).resources),
                        value: resource
                    })
                }),
                resource === (0, $a2058b1c2cc8e90b$exports.authPkgConfig).resources.deviceIOTSingleCommand && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    label: "Name of IoT Command to give access to",
                    labelFor: "cap-iot",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $35acf471a14b7dad$export$6e5a9cd40e0c9b97), {
                        id: "cap-iot",
                        onChange: (e)=>setIotCommandName(e.target.value),
                        value: iotCommandName
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                    label: "Can Create",
                    checked: canCreate,
                    onChange: ()=>setCanCreate((v)=>!v)
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                    label: "Can Read",
                    checked: canRead,
                    onChange: ()=>setCanRead((v)=>!v)
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                    label: "Can Update",
                    checked: canUpdate,
                    onChange: ()=>setCanUpdate((v)=>!v)
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                    label: "Can Delete",
                    checked: canDelete,
                    onChange: ()=>setCanDelete((v)=>!v)
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                    label: "Visibility",
                    labelFor: "cap-visibility",
                    children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9e675beb9e64c244$export$49d2a72fcffd1efe), {
                        id: "cap-visibility",
                        onChange: (e)=>setVisibility(e.target.value),
                        options: [
                            'all org',
                            'own org',
                            'personal'
                        ],
                        value: visibility
                    })
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$b5d5cf8927ab7262), {
                    label: "Aura Admin Only",
                    checked: auraAdminOnly,
                    onChange: ()=>setAuraAdminOnly((v)=>!v)
                }),
                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                    type: "submit",
                    loading: loading,
                    intent: "primary",
                    children: "Create capability"
                }),
                response.type && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                    intent: response.type,
                    style: {
                        marginTop: 8
                    },
                    children: response.text
                })
            ]
        })
    });
};


const $638479c4687f6b91$var$capabilityColumns = [
    {
        key: 'id',
        name: 'Id',
        width: 50,
        sortable: true,
        filterable: true
    },
    {
        key: 'resource',
        name: 'Resource',
        width: 175,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                intent: "primary",
                children: params.row.resource
            })
    },
    {
        key: 'canCreate',
        name: 'Create',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canCreate,
                readOnly: true
            })
    },
    {
        key: 'canRead',
        name: 'Read',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canRead,
                readOnly: true
            })
    },
    {
        key: 'canUpdate',
        name: 'Update',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canUpdate,
                readOnly: true
            })
    },
    {
        key: 'canDelete',
        name: 'Delete',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canDelete,
                readOnly: true
            })
    },
    {
        key: 'visibility',
        name: 'Visibility',
        width: 120,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'name',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'auraAdminOnly',
        name: 'Internal only',
        width: 130,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.auraAdminOnly,
                readOnly: true
            })
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.createdAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
            })
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.updatedAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
            })
    }
];
const $638479c4687f6b91$export$dc236ab23ce9c661 = ()=>{
    const { setLoading: setLoading, setNav: setNav, setCount: setCount } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [data, setData] = (0, $kYL7Z.useState)(null);
    const [creating, setCreating] = (0, $kYL7Z.useState)(false);
    const [fetchTrigger, setFetchTrigger] = (0, $kYL7Z.useState)(0);
    const toggleCreating = (0, $kYL7Z.useCallback)(()=>setCreating((prev)=>!prev), []);
    (0, $kYL7Z.useEffect)(()=>{
        setNav({
            right: [
                {
                    name: "New Capability",
                    onClick: toggleCreating,
                    icon: "plus"
                }
            ]
        });
    }, []);
    (0, $kYL7Z.useEffect)(()=>{
        setLoading({
            status: true,
            location: "Loading capabilities..."
        });
        $aa27e6f0058e6325$export$8e76ac9f37578d1b.list(true).then(({ data: capabilities })=>{
            console.log("Loaded " + capabilities.length + " capabilities");
            setData(capabilities);
            setLoading({
                status: false,
                location: "Capabilities"
            });
        }).catch((error)=>{
            console.error(error);
            setLoading({
                status: false,
                location: "Failed to load capabilities..."
            });
            setData([]);
        });
    }, [
        fetchTrigger
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                columns: $638479c4687f6b91$var$capabilityColumns,
                data: data ?? [],
                defaultSort: "id",
                onCount: (filtered, total)=>setCount({
                        filtered: filtered,
                        total: total
                    })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c1bff235c2818d53$export$ec4834aea7c622be), {
                isOpen: creating,
                onClose: ()=>{
                    setCreating(false);
                    setFetchTrigger((prev)=>prev + 1);
                }
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");








var $kYL7Z = parcelRequire("kYL7Z");





const $0a1af0b61be6a6f7$var$DataWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    width: 95%;
    margin: 2em auto;
`;
const $0a1af0b61be6a6f7$var$userColumns = [
    {
        key: 'id',
        name: 'Id',
        width: 50,
        sortable: true,
        filterable: true
    },
    {
        key: 'fullName',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'email',
        name: 'Email',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'status',
        name: 'Status',
        width: 75,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'type',
        name: 'Type',
        width: 75,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'auth0Id',
        name: 'Auth0 Id',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'primaryOrgName',
        name: 'Active org',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'ownerOrgName',
        name: 'Owner org',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'adopted',
        name: 'Adopted',
        width: 75,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.adopted,
                readOnly: true
            })
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.createdAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
            })
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.updatedAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
            })
    }
];
const $0a1af0b61be6a6f7$export$547705f765c742d2 = ({ isOpen: isOpen, onClose: onClose, role: role, allOrgs: allOrgs })=>{
    const [data, setData] = (0, $kYL7Z.useState)([]);
    (0, $kYL7Z.useEffect)(()=>{
        if (!isOpen || !role) return;
        const apiGroup = role.auraAdminOnly ? 'adminRoles_users' : 'roles_users';
        $aa27e6f0058e6325$exports[apiGroup].list(role.id, allOrgs).then(({ data: users })=>{
            const getOrgName = (orgId)=>{
                const org = allOrgs.find((o)=>o.id === orgId);
                return org?.name ?? 'Unknown';
            };
            setData(users.map((u)=>({
                    ...u,
                    primaryOrgName: getOrgName(u.primaryOrgId),
                    ownerOrgName: getOrgName(u.ownerOrgId)
                })));
        }).catch((e)=>{
            console.error(e);
            setData([]);
        });
        return ()=>setData([]);
    }, [
        isOpen,
        role,
        allOrgs
    ]);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        size: (0, $6540feeb2a2776f0$export$4071300121a182f5).SIZE_LARGE,
        icon: "people",
        title: role ? `Role > ${role.name} > Users` : '',
        isOpen: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($0a1af0b61be6a6f7$var$DataWrapper, {
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                columns: $0a1af0b61be6a6f7$var$userColumns,
                data: data,
                defaultSort: "fullName"
            })
        })
    });
};




var $kYL7Z = parcelRequire("kYL7Z");





const $7aeebddf94671140$var$DataWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    width: 95%;
    margin: 2em auto;
`;
const $7aeebddf94671140$var$CalloutWrapper = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    width: 95%;
    margin: 0 auto 2em auto;
`;
const $7aeebddf94671140$var$capabilityColumns = [
    {
        key: 'id',
        name: 'Id',
        width: 50,
        sortable: true,
        filterable: true
    },
    {
        key: 'resource',
        name: 'Resource',
        width: 175,
        resizable: true,
        sortable: true,
        filterable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                intent: "primary",
                children: params.row.resource
            })
    },
    {
        key: 'canCreate',
        name: 'Create',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canCreate,
                readOnly: true
            })
    },
    {
        key: 'canRead',
        name: 'Read',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canRead,
                readOnly: true
            })
    },
    {
        key: 'canUpdate',
        name: 'Update',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canUpdate,
                readOnly: true
            })
    },
    {
        key: 'canDelete',
        name: 'Delete',
        width: 65,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.canDelete,
                readOnly: true
            })
    },
    {
        key: 'visibility',
        name: 'Visibility',
        width: 120,
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'name',
        name: 'Name',
        resizable: true,
        sortable: true,
        filterable: true
    },
    {
        key: 'auraAdminOnly',
        name: 'Internal only',
        width: 130,
        resizable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                checked: !!params.row.auraAdminOnly,
                readOnly: true
            })
    },
    {
        key: 'createdAt',
        name: 'Created',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.createdAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
            })
    },
    {
        key: 'updatedAt',
        name: 'Updated',
        width: 100,
        resizable: true,
        sortable: true,
        formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                title: params.row.updatedAt,
                children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
            })
    }
];
const $7aeebddf94671140$export$3b14234d1d9ed322 = ({ isOpen: isOpen, onClose: onClose, role: role })=>{
    const [data, setData] = (0, $kYL7Z.useState)([]);
    const [allCapabilities, setAllCapabilities] = (0, $kYL7Z.useState)([]);
    const [selectedCapId, setSelectedCapId] = (0, $kYL7Z.useState)(null);
    const [response, setResponse] = (0, $kYL7Z.useState)({});
    const fetchCapabilities = ()=>{
        if (!role) return;
        Promise.all([
            $aa27e6f0058e6325$export$5d38d8531ecf1ed4.list(role.id),
            $aa27e6f0058e6325$export$8e76ac9f37578d1b.list()
        ]).then(([capsRes, allCapsRes])=>{
            setData(capsRes.data);
            setAllCapabilities(allCapsRes.data);
        }).catch((e)=>{
            console.error(e);
        });
    };
    (0, $kYL7Z.useEffect)(()=>{
        if (isOpen) {
            fetchCapabilities();
            setResponse({});
        } else {
            setData([]);
            setAllCapabilities([]);
            setSelectedCapId(null);
        }
    }, [
        isOpen,
        role
    ]);
    const addCapability = ()=>{
        if (!selectedCapId) return;
        setResponse({
            type: 'primary',
            text: 'Loading...'
        });
        $aa27e6f0058e6325$export$5d38d8531ecf1ed4.create(role.id, selectedCapId).then(()=>{
            setResponse({
                type: 'success',
                text: 'Capability added to role'
            });
            fetchCapabilities();
        }).catch(()=>{
            setResponse({
                type: 'danger',
                text: 'Could not add capability to role'
            });
        });
    };
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $6540feeb2a2776f0$export$4071300121a182f5), {
        size: (0, $6540feeb2a2776f0$export$4071300121a182f5).SIZE_LARGE,
        icon: "shield",
        title: role ? `Role > ${role.name} > Capabilities` : '',
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($7aeebddf94671140$var$DataWrapper, {
                children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                    columns: $7aeebddf94671140$var$capabilityColumns,
                    data: data,
                    defaultSort: "id"
                })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($7aeebddf94671140$var$CalloutWrapper, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                        title: "Assign a new capability to this role",
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $15cb308855229ba4$export$2d00230e1e6f7fbc), {
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $9e675beb9e64c244$export$49d2a72fcffd1efe), {
                                    onChange: (e)=>setSelectedCapId(e.target.value),
                                    value: selectedCapId || '',
                                    options: allCapabilities.length === 0 ? [
                                        {
                                            label: 'Loading...',
                                            value: ''
                                        }
                                    ] : [
                                        {
                                            label: 'Select a capability...',
                                            value: ''
                                        },
                                        ...allCapabilities.map((cap)=>({
                                                label: `${cap.name} (id: ${cap.id})`,
                                                value: cap.id
                                            }))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $aa0ed25827418946$export$353f5b6fc5456de1), {
                                    text: "Add",
                                    intent: "primary",
                                    onClick: addCapability,
                                    style: {
                                        marginTop: 8
                                    }
                                })
                            ]
                        })
                    }),
                    response.type && /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $95ca98770ad4e8f2$export$97a5aca3dea8edc7), {
                        intent: response.type,
                        style: {
                            marginTop: 8
                        },
                        children: response.text
                    })
                ]
            })
        ]
    });
};


const $202aa7028d80c194$var$getRoleColumns = (onViewUsers, onViewCapabilities)=>[
        {
            key: 'id',
            name: 'Id',
            width: 75,
            sortable: true,
            filterable: true
        },
        {
            key: 'name',
            name: 'Name',
            resizable: true,
            sortable: true,
            filterable: true
        },
        {
            key: 'auraAdminOnly',
            name: 'Internal only',
            width: 150,
            resizable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $4e9bf29f7973618d$export$48513f6b9f8ce62d), {
                    checked: !!params.row.auraAdminOnly,
                    readOnly: true
                })
        },
        {
            key: 'createdAt',
            name: 'Created',
            width: 100,
            resizable: true,
            sortable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                    title: params.row.createdAt,
                    children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.createdAt)
                })
        },
        {
            key: 'updatedAt',
            name: 'Updated',
            width: 100,
            resizable: true,
            sortable: true,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("span", {
                    title: params.row.updatedAt,
                    children: (0, $ae042dd50ed2daac$export$9b9f695373d1284f)(params.row.updatedAt)
                })
        },
        {
            key: 'users',
            name: 'Users',
            width: 80,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    icon: "people",
                    interactive: true,
                    onClick: ()=>onViewUsers(params.row),
                    children: "Users"
                })
        },
        {
            key: 'capabilities',
            name: 'Capabilities',
            width: 120,
            formatter: (params)=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0975f43a8b42d010$export$3288d34c523a1192), {
                    icon: "shield",
                    interactive: true,
                    onClick: ()=>onViewCapabilities(params.row),
                    children: "Capabilities"
                })
        }
    ];
const $202aa7028d80c194$export$7bb10693b70928ea = ()=>{
    const { setLoading: setLoading, setCount: setCount } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [data, setData] = (0, $kYL7Z.useState)(null);
    const [orgs, setOrgs] = (0, $kYL7Z.useState)([]);
    const [usersRole, setUsersRole] = (0, $kYL7Z.useState)(null);
    const [capsRole, setCapsRole] = (0, $kYL7Z.useState)(null);
    const columns = (0, $kYL7Z.useMemo)(()=>$202aa7028d80c194$var$getRoleColumns(setUsersRole, setCapsRole), []);
    (0, $kYL7Z.useEffect)(()=>{
        setLoading({
            status: true,
            location: "Loading roles..."
        });
        Promise.all([
            $aa27e6f0058e6325$export$981db36c5c688393.list(true),
            (0, $5a9cade4af2d6a52$export$d030b7498dcede47).list()
        ]).then(([rolesRes, orgsRes])=>{
            console.log("Loaded " + rolesRes.data.length + " roles");
            setData(rolesRes.data);
            setOrgs(orgsRes);
            setLoading({
                status: false,
                location: "Roles"
            });
        }).catch((error)=>{
            console.error(error);
            setLoading({
                status: false,
                location: "Failed to load roles..."
            });
            setData([]);
        });
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $fc31e5e9fc16a880$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $f448bea4af9ba462$export$fea56d2ed3e1a888), {
                columns: columns,
                data: data ?? [],
                defaultSort: "id",
                onCount: (filtered, total)=>setCount({
                        filtered: filtered,
                        total: total
                    })
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $0a1af0b61be6a6f7$export$547705f765c742d2), {
                isOpen: !!usersRole,
                onClose: ()=>setUsersRole(null),
                role: usersRole,
                allOrgs: orgs
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $7aeebddf94671140$export$3b14234d1d9ed322), {
                isOpen: !!capsRole,
                onClose: ()=>setCapsRole(null),
                role: capsRole
            })
        ]
    });
};


const $97a7a4b127812727$export$b10e0f21eb59fd0b = ()=>{
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $3c99a37f3fed1403$export$3565eb3d00ca5a74), {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/capabilities",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $638479c4687f6b91$export$dc236ab23ce9c661), {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "/roles",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $202aa7028d80c194$export$7bb10693b70928ea), {})
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                path: "*",
                element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $92e6067166fae914$export$3cb69218ff952ef8), {})
            })
        ]
    });
};




var $kYL7Z = parcelRequire("kYL7Z");




const $58bc10482e55498e$var$Section = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    margin-bottom: 2.5em;
    padding-bottom: 2.5em;
    border-bottom: 3px solid rgba(17, 20, 24, 0.15);
`;
const $58bc10482e55498e$var$Description = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $51dde1f29cbe0fd9$export$5f1af8db9871e1d6))`
    margin-bottom: 1em;
    color: #5c7080;
    line-height: 1.5;
`;
const $58bc10482e55498e$var$SideBySide = (0, $564f85e69a9a6189$export$2e2bcd8739ae039).div`
    display: flex;
    gap: 1em;
    align-items: flex-start;
    & > * { flex: 1; }
`;
// ============================================================================
// 1. Text & Select Fields
// ============================================================================
const $58bc10482e55498e$var$textSelectSchema = {
    type: 'object',
    required: [
        'name',
        'email',
        'status'
    ],
    properties: {
        id: {
            type: 'string',
            pattern: '^[a-f\\d]{24}$',
            readOnly: true
        },
        name: {
            type: 'string'
        },
        email: {
            type: 'string',
            pattern: '^[^@]+@[^@]+\\.[^@]+$'
        },
        createdAt: {
            type: 'string',
            readOnly: true
        },
        status: {
            type: 'string',
            enum: [
                'active',
                'inactive',
                'suspended',
                'pending'
            ]
        },
        timezone: {
            type: 'string',
            enum: [
                'Europe/London',
                'America/New_York',
                'Asia/Tokyo',
                'Australia/Sydney'
            ]
        },
        theme: {
            type: [
                'string',
                'null'
            ]
        },
        organisation: {
            oneOf: [
                {
                    const: 'org_001',
                    title: 'Acme Corp'
                },
                {
                    const: 'org_002',
                    title: 'Globex Industries'
                },
                {
                    const: 'org_003',
                    title: 'Initech'
                },
                {
                    const: 'org_004',
                    title: 'Umbrella Corporation'
                }
            ]
        }
    }
};
const $58bc10482e55498e$var$textSelectUischema = {
    type: 'Group',
    label: 'Text & Select Fields',
    elements: [
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/id',
                    options: {
                        disabled: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/status',
                    options: {
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/createdAt',
                    options: {
                        disabled: true
                    }
                }
            ]
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/name'
                },
                {
                    type: 'Control',
                    scope: '#/properties/organisation',
                    options: {
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/email'
                }
            ]
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/theme',
                    label: 'Theme (optional)'
                },
                {
                    type: 'Control',
                    scope: '#/properties/timezone',
                    options: {
                        fill: true
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$textSelectData = {
    id: '65a1b2c3d4e5f6a7b8c9d0e1',
    name: 'Jane Doe',
    email: 'jane@example.com',
    createdAt: '2025-06-15T10:30:00Z',
    status: 'active',
    organisation: 'org_002',
    timezone: 'Europe/London',
    theme: null
};
// ============================================================================
// 2. Multi Select
// ============================================================================
const $58bc10482e55498e$var$multiSelectSchema = {
    type: 'object',
    properties: {
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'frontend',
                    'backend',
                    'devops',
                    'design',
                    'mobile',
                    'security',
                    'data',
                    'QA'
                ]
            }
        },
        permissions: {
            type: 'array',
            items: {
                oneOf: [
                    {
                        const: 'read',
                        title: 'Read Access'
                    },
                    {
                        const: 'write',
                        title: 'Write Access'
                    },
                    {
                        const: 'delete',
                        title: 'Delete Access'
                    },
                    {
                        const: 'admin',
                        title: 'Admin Access'
                    }
                ]
            }
        },
        labels: {
            type: 'array',
            items: {
                type: 'string',
                examples: [
                    'bug',
                    'feature',
                    'enhancement',
                    'documentation',
                    'urgent'
                ]
            }
        }
    }
};
const $58bc10482e55498e$var$multiSelectUischema = {
    type: 'Group',
    label: 'Multi Select',
    elements: [
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/tags',
                    options: {
                        icon: 'tag',
                        placeholder: 'Filter tags...'
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/permissions',
                    options: {
                        icon: 'lock'
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/labels',
                    options: {
                        icon: 'label',
                        placeholder: 'Search or create...'
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$multiSelectData = {
    tags: [
        'frontend',
        'design'
    ],
    permissions: [
        'read',
        'write'
    ],
    labels: [
        'bug',
        'custom-label'
    ]
};
// ============================================================================
// 3. Text Area
// ============================================================================
const $58bc10482e55498e$var$textareaSchema = {
    type: 'object',
    properties: {
        notes: {
            type: 'string'
        }
    }
};
const $58bc10482e55498e$var$textareaUischema = {
    type: 'Group',
    label: 'Text Area',
    elements: [
        {
            type: 'Control',
            scope: '#/properties/notes',
            label: 'Notes',
            options: {
                multi: true,
                rows: 4
            }
        }
    ]
};
const $58bc10482e55498e$var$textareaData = {
    notes: 'Some notes about this record.\nMultiple lines are supported.'
};
// ============================================================================
// 4. Date Picker
// ============================================================================
const $58bc10482e55498e$var$datePickerSchema = {
    type: 'object',
    properties: {
        goLiveDate: {
            type: 'string',
            format: 'date-time'
        },
        eventStart: {
            type: 'string',
            format: 'date-time'
        },
        preciseTimestamp: {
            type: 'string',
            format: 'date-time'
        }
    }
};
const $58bc10482e55498e$var$datePickerUischema = {
    type: 'Group',
    label: 'Date Picker',
    elements: [
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/goLiveDate',
                    label: 'Go Live Date (date only)'
                },
                {
                    type: 'Control',
                    scope: '#/properties/eventStart',
                    label: 'Event Start (with time)',
                    options: {
                        time: {
                            enabled: true
                        }
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/preciseTimestamp',
                    label: 'Precise (seconds)',
                    options: {
                        time: {
                            enabled: true,
                            precision: 'second'
                        }
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$datePickerData = {
    goLiveDate: '2025-03-15T00:00:00.000Z',
    eventStart: '2025-06-01T09:30:00.000Z',
    preciseTimestamp: null
};
// ============================================================================
// 5. Nested Objects
// ============================================================================
const $58bc10482e55498e$var$nestedSchema = {
    type: 'object',
    properties: {
        options: {
            type: 'object',
            properties: {
                enableNotifications: {
                    type: 'boolean',
                    default: true
                },
                darkMode: {
                    type: 'boolean',
                    default: false
                },
                betaFeatures: {
                    type: 'boolean',
                    default: false
                }
            }
        },
        metadata: {
            type: 'object',
            required: [
                'version',
                'author'
            ],
            properties: {
                version: {
                    type: 'string',
                    pattern: '^\\d+\\.\\d+\\.\\d+$'
                },
                author: {
                    type: 'string'
                },
                description: {
                    type: 'string'
                }
            }
        },
        config: {
            type: 'object',
            required: [
                'host'
            ],
            properties: {
                host: {
                    type: 'string',
                    pattern: '^https?://'
                },
                port: {
                    type: 'integer',
                    minimum: 1,
                    maximum: 65535
                },
                retries: {
                    type: 'integer',
                    minimum: 0,
                    maximum: 10
                }
            }
        }
    }
};
const $58bc10482e55498e$var$nestedAutoUischema = {
    type: 'HorizontalLayout',
    elements: [
        {
            type: 'Control',
            scope: '#',
            label: 'Auto-nested from root'
        }
    ]
};
const $58bc10482e55498e$var$nestedJsonUischema = {
    type: 'VerticalLayout',
    elements: [
        {
            type: 'Control',
            scope: '#',
            label: 'Same schema (nested: false)',
            options: {
                nested: false,
                rows: 10
            }
        }
    ]
};
const $58bc10482e55498e$var$nestedData = {
    options: {
        enableNotifications: true,
        darkMode: false,
        betaFeatures: true
    },
    metadata: {
        version: '1.2.0',
        author: 'Jane Doe',
        description: 'User profile configuration'
    },
    config: {
        host: 'https://api.example.com',
        port: 8080,
        retries: 3
    }
};
// ============================================================================
// 6. Array of Objects
// ============================================================================
const $58bc10482e55498e$var$arraySchema = {
    type: 'object',
    properties: {
        contacts: {
            type: 'array',
            items: {
                type: 'object',
                required: [
                    'name',
                    'email'
                ],
                properties: {
                    name: {
                        type: 'string'
                    },
                    email: {
                        type: 'string',
                        pattern: '^[^@]+@[^@]+\\.[^@]+$'
                    },
                    role: {
                        type: 'string',
                        enum: [
                            'admin',
                            'editor',
                            'viewer'
                        ]
                    },
                    notify: {
                        type: 'boolean',
                        default: false
                    }
                }
            }
        }
    }
};
const $58bc10482e55498e$var$arrayUischema = {
    type: 'Group',
    label: 'Array of Objects',
    elements: [
        {
            type: 'Control',
            scope: '#/properties/contacts',
            options: {
                horizontal: true,
                itemTitle: 'name'
            }
        }
    ]
};
const $58bc10482e55498e$var$arrayData = {
    contacts: [
        {
            name: 'Alice Smith',
            email: 'alice@example.com',
            role: 'admin',
            notify: true
        },
        {
            name: 'Bob Jones',
            email: 'bob@example.com',
            role: 'viewer',
            notify: false
        }
    ]
};
// ============================================================================
// 7. Dynamic Object
// ============================================================================
const $58bc10482e55498e$var$dynamicObjectSchema = {
    type: 'object',
    properties: {
        sections: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                required: [
                    'title'
                ],
                properties: {
                    title: {
                        type: 'string'
                    },
                    description: {
                        type: 'string'
                    },
                    enabled: {
                        type: 'boolean',
                        default: true
                    },
                    priority: {
                        type: 'string',
                        enum: [
                            'low',
                            'medium',
                            'high'
                        ]
                    }
                }
            }
        }
    }
};
const $58bc10482e55498e$var$dynamicObjectUischema = {
    type: 'Group',
    label: 'Dynamic Object',
    elements: [
        {
            type: 'Control',
            scope: '#/properties/sections',
            options: {
                allowPropertyRenaming: true,
                itemTitle: 'title',
                itemUISchema: {
                    type: 'HorizontalLayout',
                    options: {
                        wrap: false
                    },
                    elements: [
                        {
                            type: 'Control',
                            scope: '#/properties/enabled',
                            options: {
                                toggle: true,
                                maxWidth: '120px'
                            }
                        },
                        {
                            type: 'Control',
                            scope: '#/properties/title'
                        },
                        {
                            type: 'Control',
                            scope: '#/properties/priority',
                            options: {
                                fill: true,
                                maxWidth: '180px'
                            }
                        },
                        {
                            type: 'Control',
                            scope: '#/properties/description'
                        }
                    ]
                }
            }
        }
    ]
};
const $58bc10482e55498e$var$dynamicObjectData = {
    sections: {
        homepage: {
            title: 'Homepage',
            description: 'Main landing page section',
            enabled: true,
            priority: 'high'
        },
        analytics: {
            title: 'Analytics',
            description: 'Usage tracking and metrics',
            enabled: true,
            priority: 'medium'
        },
        experimental: {
            title: 'Experimental',
            description: 'Beta features in testing',
            enabled: false,
            priority: 'low'
        }
    }
};
// ============================================================================
// 8. Collapsible Cards
// ============================================================================
const $58bc10482e55498e$var$collapsibleSchema = {
    type: 'object',
    properties: {
        endpoints: {
            type: 'array',
            minItems: 1,
            items: {
                type: 'object',
                required: [
                    'url',
                    'method'
                ],
                properties: {
                    url: {
                        type: 'string',
                        minLength: 1
                    },
                    method: {
                        type: 'string',
                        enum: [
                            'GET',
                            'POST',
                            'PUT',
                            'DELETE'
                        ]
                    },
                    active: {
                        type: 'boolean',
                        default: true
                    }
                }
            }
        },
        headers: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                required: [
                    'value'
                ],
                properties: {
                    value: {
                        type: 'string',
                        minLength: 1
                    },
                    secret: {
                        type: 'boolean',
                        default: false
                    }
                }
            }
        }
    }
};
const $58bc10482e55498e$var$collapsibleUischema = {
    type: 'VerticalLayout',
    elements: [
        {
            type: 'Group',
            label: 'API Endpoints',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/endpoints',
                    options: {
                        editMode: 'collapsible',
                        collapsed: true,
                        itemTitle: 'url',
                        itemUISchema: {
                            type: 'HorizontalLayout',
                            options: {
                                wrap: false
                            },
                            elements: [
                                {
                                    type: 'Control',
                                    scope: '#/properties/active',
                                    options: {
                                        toggle: true,
                                        maxWidth: '120px'
                                    }
                                },
                                {
                                    type: 'Control',
                                    scope: '#/properties/method',
                                    options: {
                                        fill: true,
                                        maxWidth: '150px'
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        },
        {
            type: 'Group',
            label: 'Custom Headers',
            options: {
                editMode: 'collapsible',
                collapsed: true
            },
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/headers',
                    options: {
                        editMode: 'collapsible',
                        collapsed: true,
                        allowPropertyRenaming: true,
                        itemUISchema: {
                            type: 'HorizontalLayout',
                            options: {
                                wrap: false
                            },
                            elements: [
                                {
                                    type: 'Control',
                                    scope: '#/properties/value'
                                },
                                {
                                    type: 'Control',
                                    scope: '#/properties/secret',
                                    options: {
                                        toggle: true,
                                        maxWidth: '120px'
                                    }
                                }
                            ]
                        }
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$collapsibleData = {
    endpoints: [
        {
            url: 'https://api.example.com/users',
            method: 'GET',
            active: true
        },
        {
            url: '',
            method: 'POST',
            active: false
        },
        {
            url: 'https://api.example.com/health',
            method: 'GET',
            active: true
        }
    ],
    headers: {
        Authorization: {
            value: 'Bearer token123',
            secret: true
        },
        'Content-Type': {
            value: 'application/json',
            secret: false
        },
        'X-Custom': {
            value: '',
            secret: false
        }
    }
};
// --- Edit Mode comparison schemas ---
const $58bc10482e55498e$var$editModeSchema = {
    type: 'object',
    required: [
        'name'
    ],
    properties: {
        name: {
            type: 'string',
            minLength: 1
        },
        role: {
            type: 'string',
            enum: [
                'viewer',
                'editor',
                'admin'
            ]
        },
        active: {
            type: 'boolean'
        }
    }
};
const $58bc10482e55498e$var$editModeUischemaDefault = {
    type: 'Group',
    label: 'Default (always expanded)',
    elements: [
        {
            type: 'Control',
            scope: '#/properties/name'
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/role',
                    options: {
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/active',
                    options: {
                        maxWidth: 'fit-content'
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$editModeUischemaCollapsible = {
    type: 'Group',
    label: 'Collapsible',
    options: {
        editMode: 'collapsible',
        collapsed: true
    },
    elements: [
        {
            type: 'Control',
            scope: '#/properties/name'
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/role',
                    options: {
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/active',
                    options: {
                        maxWidth: 'fit-content'
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$editModeUischemaPopover = {
    type: 'Group',
    label: 'Popover (hover edit icon)',
    options: {
        editMode: 'popover'
    },
    elements: [
        {
            type: 'Control',
            scope: '#/properties/name'
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/role',
                    options: {
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/active',
                    options: {
                        maxWidth: 'fit-content'
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$editModeUischemaOverlay = {
    type: 'Group',
    label: 'Overlay (click edit icon)',
    options: {
        editMode: 'overlay'
    },
    elements: [
        {
            type: 'Control',
            scope: '#/properties/name'
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/role',
                    options: {
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/active',
                    options: {
                        maxWidth: 'fit-content'
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$editModeUischemaDrawer = {
    type: 'Group',
    label: 'Drawer (click edit icon)',
    options: {
        editMode: 'drawer'
    },
    elements: [
        {
            type: 'Control',
            scope: '#/properties/name'
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/role',
                    options: {
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/active',
                    options: {
                        maxWidth: 'fit-content'
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$editModeData = {
    name: '',
    role: 'editor',
    active: true
};
// ============================================================================
// 9. Drag-and-Drop Reordering
// ============================================================================
const $58bc10482e55498e$var$dragDropSchema = {
    type: 'object',
    properties: {
        metrics: {
            type: 'array',
            maxItems: 4,
            items: {
                type: 'object',
                required: [
                    'name'
                ],
                properties: {
                    name: {
                        type: 'string'
                    },
                    unit: {
                        type: 'string',
                        enum: [
                            'count',
                            'percent',
                            'seconds',
                            'meters'
                        ]
                    },
                    enabled: {
                        type: 'boolean',
                        default: true
                    },
                    priority: {
                        type: 'string',
                        enum: [
                            'low',
                            'medium',
                            'high'
                        ]
                    }
                }
            }
        },
        settings: {
            type: 'object',
            additionalProperties: {
                type: 'object',
                required: [
                    'label'
                ],
                properties: {
                    label: {
                        type: 'string'
                    },
                    visible: {
                        type: 'boolean',
                        default: true
                    }
                }
            }
        }
    }
};
const $58bc10482e55498e$var$dragDropVerticalUischema = {
    type: 'Group',
    label: "Array \u2014 Vertical (default)",
    elements: [
        {
            type: 'Control',
            scope: '#/properties/metrics',
            options: {
                itemTitle: 'name'
            }
        }
    ]
};
const $58bc10482e55498e$var$dragDropHorizontalUischema = {
    type: 'Group',
    label: "Array \u2014 Horizontal",
    elements: [
        {
            type: 'Control',
            scope: '#/properties/metrics',
            options: {
                itemTitle: 'name',
                editMode: 'collapsible',
                collapsed: true,
                horizontal: true
            }
        }
    ]
};
const $58bc10482e55498e$var$dragDropDynamicUischema = {
    type: 'Group',
    label: 'Dynamic Object',
    elements: [
        {
            type: 'Control',
            scope: '#/properties/settings',
            options: {
                allowPropertyRenaming: true,
                itemTitle: 'label',
                itemUISchema: {
                    type: 'HorizontalLayout',
                    options: {
                        wrap: false
                    },
                    elements: [
                        {
                            type: 'Control',
                            scope: '#/properties/visible',
                            options: {
                                toggle: true,
                                maxWidth: '120px'
                            }
                        }
                    ]
                }
            }
        }
    ]
};
const $58bc10482e55498e$var$dragDropData = {
    metrics: [
        {
            name: 'Impressions',
            unit: 'count',
            enabled: true,
            priority: 'high'
        },
        {
            name: 'Dwell Time',
            unit: 'seconds',
            enabled: true,
            priority: 'medium'
        },
        {
            name: 'Conversion',
            unit: 'percent',
            enabled: false,
            priority: 'low'
        },
        {
            name: 'Distance',
            unit: 'meters',
            enabled: true,
            priority: 'medium'
        }
    ],
    settings: {
        dashboard: {
            label: 'Dashboard',
            visible: true
        },
        analytics: {
            label: 'Analytics',
            visible: true
        },
        reports: {
            label: 'Reports',
            visible: false
        }
    }
};
// ============================================================================
// 10. Cascading Select
// ============================================================================
const $58bc10482e55498e$var$cascadingLevels = [
    {
        key: 'category',
        label: 'Category',
        items: [
            {
                value: 'store',
                label: 'Store'
            },
            {
                value: 'internal',
                label: 'Internal'
            },
            {
                value: 'attraction',
                label: 'Attraction'
            }
        ]
    },
    {
        key: 'path',
        label: 'Path',
        delimiter: ':',
        itemsFor: {
            store: [
                'entrance',
                'exit',
                'checkout'
            ],
            internal: [
                'queue',
                'staff:area',
                'staff:break-room'
            ],
            attraction: [
                'products',
                'products:mens',
                'products:womens',
                'products:womens:pants',
                'products:womens:dresses',
                'displays',
                'displays:window',
                'displays:endcap'
            ]
        }
    },
    {
        key: 'metric',
        label: 'Metric',
        itemsFor: {
            attraction: [
                'impressions',
                'engagement',
                'dwell',
                'conversion'
            ]
        }
    }
];
const $58bc10482e55498e$var$cascadingSingleSchema = {
    type: 'object',
    properties: {
        lineContext: {
            type: 'object',
            required: [
                'category',
                'path'
            ],
            properties: {
                category: {
                    type: 'string'
                },
                path: {
                    type: 'string'
                },
                metric: {
                    type: 'string'
                }
            }
        }
    }
};
const $58bc10482e55498e$var$cascadingSingleUischema = {
    type: 'Group',
    label: 'Single Select',
    elements: [
        {
            type: 'Control',
            scope: '#/properties/lineContext',
            label: 'Line Context',
            options: {
                levels: $58bc10482e55498e$var$cascadingLevels
            }
        }
    ]
};
const $58bc10482e55498e$var$cascadingSingleData = {
    lineContext: {
        category: 'attraction',
        path: 'products:womens:pants',
        metric: 'dwell'
    }
};
const $58bc10482e55498e$var$cascadingMultiLevels = [
    {
        key: 'category',
        label: 'Category',
        selectable: false,
        items: [
            {
                value: 'store',
                label: 'Store'
            },
            {
                value: 'internal',
                label: 'Internal'
            },
            {
                value: 'attraction',
                label: 'Attraction'
            }
        ]
    },
    {
        key: 'path',
        label: 'Path',
        delimiter: ':',
        itemsFor: {
            store: [
                'entrance',
                'exit',
                'checkout'
            ],
            internal: [
                'queue',
                'staff:area',
                'staff:break-room'
            ],
            attraction: [
                'products',
                'products:mens',
                'products:womens',
                'products:womens:pants',
                'products:womens:dresses',
                'displays',
                'displays:window',
                'displays:endcap'
            ]
        }
    },
    {
        key: 'metric',
        label: 'Metric',
        dependsOn: 'category',
        itemsFor: {
            attraction: [
                'impressions',
                'engagement',
                'dwell',
                'conversion'
            ]
        }
    }
];
const $58bc10482e55498e$var$cascadingMultiSchema = {
    type: 'object',
    properties: {
        lineContext: {
            type: 'object',
            properties: {
                category: {
                    type: 'string'
                },
                path: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                },
                metric: {
                    type: 'array',
                    items: {
                        type: 'string'
                    }
                }
            }
        }
    }
};
const $58bc10482e55498e$var$cascadingMultiUischema = {
    type: 'Group',
    label: 'Multi Select (selectable: false, dependsOn)',
    elements: [
        {
            type: 'Control',
            scope: '#/properties/lineContext',
            label: 'Line Context',
            options: {
                levels: $58bc10482e55498e$var$cascadingMultiLevels,
                multi: true
            }
        }
    ]
};
const $58bc10482e55498e$var$cascadingMultiData = {
    lineContext: {
        category: 'attraction',
        path: [
            'products:womens:pants',
            'products:mens'
        ],
        metric: [
            'dwell',
            'impressions'
        ]
    }
};
// ============================================================================
// 10. Validation Errors
// ============================================================================
const $58bc10482e55498e$var$errorSchema = {
    type: 'object',
    required: [
        'name',
        'email',
        'status',
        'tags'
    ],
    properties: {
        name: {
            type: 'string'
        },
        email: {
            type: 'string',
            pattern: '^[^@]+@[^@]+\\.[^@]+$'
        },
        status: {
            type: 'string',
            enum: [
                'active',
                'inactive',
                'suspended'
            ]
        },
        tags: {
            type: 'array',
            items: {
                type: 'string',
                enum: [
                    'frontend',
                    'backend',
                    'devops',
                    'design'
                ]
            }
        }
    }
};
const $58bc10482e55498e$var$errorUischema = {
    type: 'Group',
    label: 'Validation Errors',
    elements: [
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/status',
                    options: {
                        maxWidth: 'fit-content'
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/name'
                },
                {
                    type: 'Control',
                    scope: '#/properties/tags',
                    options: {
                        icon: 'tag',
                        maxWidth: 'fit-content'
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/email'
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$errorData = {
    name: '',
    email: 'not-an-email',
    status: undefined,
    tags: []
};
// ============================================================================
// 11. Read-Only Mode
// ============================================================================
const $58bc10482e55498e$var$readonlySchema = {
    type: 'object',
    properties: {
        name: {
            type: 'string'
        },
        status: {
            type: 'string',
            enum: [
                'active',
                'inactive'
            ]
        },
        enabled: {
            type: 'boolean'
        }
    }
};
const $58bc10482e55498e$var$readonlyUischema = {
    type: 'Group',
    label: 'Read-Only Mode',
    elements: [
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/enabled',
                    options: {
                        maxWidth: 'fit-content'
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/status',
                    options: {
                        maxWidth: 'fit-content'
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/name'
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$readonlyData = {
    name: 'Locked Record',
    status: 'active',
    enabled: true
};
// ============================================================================
// 12. Theming with styled-components
// ============================================================================
const $58bc10482e55498e$var$styledSchema = {
    type: 'object',
    required: [
        'name'
    ],
    properties: {
        name: {
            type: 'string'
        },
        role: {
            type: 'string',
            enum: [
                'viewer',
                'editor',
                'admin'
            ]
        },
        active: {
            type: 'boolean'
        },
        department: {
            oneOf: [
                {
                    const: 'eng',
                    title: 'Engineering'
                },
                {
                    const: 'design',
                    title: 'Design'
                },
                {
                    const: 'product',
                    title: 'Product'
                },
                {
                    const: 'marketing',
                    title: 'Marketing'
                }
            ]
        },
        bio: {
            type: 'string'
        }
    }
};
const $58bc10482e55498e$var$styledUischema = {
    type: 'Group',
    label: 'Styled Form',
    elements: [
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/name',
                    options: {
                        icon: 'person'
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/role',
                    options: {
                        icon: 'shield',
                        fill: true
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/department',
                    options: {
                        fill: true
                    }
                }
            ]
        },
        {
            type: 'HorizontalLayout',
            elements: [
                {
                    type: 'Control',
                    scope: '#/properties/bio',
                    options: {
                        multi: true,
                        rows: 3
                    }
                },
                {
                    type: 'Control',
                    scope: '#/properties/active',
                    options: {
                        toggle: true
                    }
                }
            ]
        }
    ]
};
const $58bc10482e55498e$var$styledData = {
    name: 'demo_user',
    role: 'editor',
    department: 'eng',
    active: true,
    bio: 'Full-stack developer.'
};
const $58bc10482e55498e$var$StyledSchemaForm = (0, $564f85e69a9a6189$export$2e2bcd8739ae039)((0, $efb7d3097a0a7ab7$export$becd7412971443d4))`
    --sf-vertical-gap: 0.75em;
    --sf-horizontal-gap: 1.5em;
    --sf-group-padding: 24px;
    --sf-group-margin: 0.5em;
    --sf-border-radius: 8px;
    --sf-label-color: #8a6d3b;
    --sf-label-size: 0.85em;
    --sf-label-weight: 500;
    --sf-group-label-color: #5642a6;
    --sf-group-label-size: 1.1em;
    --sf-group-background: #fafafa;
    --sf-group-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
    --sf-max-width: 700px;
    --sf-text-align: left;
`;
// ============================================================================
// Page component
// ============================================================================
const $58bc10482e55498e$export$7e1947839b9f42a4 = ()=>{
    const { setLoading: setLoading, setNav: setNav } = (0, $kYL7Z.useContext)((0, $fb92a67b3e898f78$export$3c1acde371c1f2a2));
    const [textSelectForm, setTextSelectForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$textSelectData);
    const [multiSelectForm, setMultiSelectForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$multiSelectData);
    const [textareaForm, setTextareaForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$textareaData);
    const [datePickerForm, setDatePickerForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$datePickerData);
    const [nestedForm, setNestedForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$nestedData);
    const [arrayForm, setArrayForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$arrayData);
    const [dynamicObjForm, setDynamicObjForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$dynamicObjectData);
    const [collapsibleForm, setCollapsibleForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$collapsibleData);
    const [editModeForm, setEditModeForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$editModeData);
    const [dragDropForm, setDragDropForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$dragDropData);
    const [cascadingSingle, setCascadingSingle] = (0, $kYL7Z.useState)($58bc10482e55498e$var$cascadingSingleData);
    const [cascadingMulti, setCascadingMulti] = (0, $kYL7Z.useState)($58bc10482e55498e$var$cascadingMultiData);
    const [errorForm, setErrorForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$errorData);
    const [styledForm, setStyledForm] = (0, $kYL7Z.useState)($58bc10482e55498e$var$styledData);
    (0, $kYL7Z.useEffect)(()=>{
        setLoading({
            status: false,
            location: 'Components'
        });
        setNav({
            right: []
        });
        return ()=>setNav({});
    }, []);
    return /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Text & Select Fields"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Text inputs render from ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'type: "string"'
                            }),
                            ". Disable with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "readOnly: true"
                            }),
                            " in the schema or ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'rule: {effect: "DISABLE"}'
                            }),
                            " on the control. Use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "pattern"
                            }),
                            " for regex validation (email, ID format). Nullable fields (",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'type: ["string", "null"]'
                            }),
                            ") convert empty strings to ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "null"
                            }),
                            ". Selects render from ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "enum"
                            }),
                            " (label = value) or ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "oneOf: [{const, title}]"
                            }),
                            " (display label differs from stored value). Required selects omit the empty option. Selects default to fit-content width so they pair well alongside text inputs. Set ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {fill: true}"
                            }),
                            " to make a select expand to full width. Use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {minWidth, maxWidth}"
                            }),
                            " to constrain any field's width."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$textSelectSchema,
                        uischema: $58bc10482e55498e$var$textSelectUischema,
                        data: textSelectForm,
                        onChange: ({ data: data })=>setTextSelectForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Multi Select"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Multiple-choice selection for array values. Schema ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'type: "array"'
                            }),
                            " with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "items: {enum}"
                            }),
                            " or ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "items: {oneOf}"
                            }),
                            " auto-resolves to a multi-select (or force it with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {multiselect: true}"
                            }),
                            '). The button text adapts: "No X" when empty, the item label for one selection, "N X" for multiple, "All X" when all selected. Use ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {icon}"
                            }),
                            " for a left icon and ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {placeholder}"
                            }),
                            " for filter text. For creatable multi-selects, use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "items: {examples}"
                            }),
                            " instead of ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "enum"
                            }),
                            ' \u2014 a "Create" option appears when the query doesn\'t match.'
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$multiSelectSchema,
                        uischema: $58bc10482e55498e$var$multiSelectUischema,
                        data: multiSelectForm,
                        onChange: ({ data: data })=>setMultiSelectForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Text Area"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Multi-line text input for longer content. Set ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {multi: true}"
                            }),
                            " on the control to render a monospace ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "TextArea"
                            }),
                            " instead of a single-line input. Optionally set ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {rows: N}"
                            }),
                            " to control height (default 10)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$textareaSchema,
                        uischema: $58bc10482e55498e$var$textareaUischema,
                        data: textareaForm,
                        onChange: ({ data: data })=>setTextareaForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Date Picker"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Fields with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'format: "date-time"'
                            }),
                            " in the schema automatically render as a Blueprint DatePicker in a popover. By default only the date is shown and the time part is zeroed out (",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "T00:00:00.000Z"
                            }),
                            "). Add ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {time: {enabled: true}}"
                            }),
                            " to show a time picker (default precision: minute). Set ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'time: {enabled: true, precision: "second"}'
                            }),
                            " for second-level precision. All values are stored as Zulu timestamps (",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "YYYY-MM-DDTHH:mm:ss.sssZ"
                            }),
                            ")."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$datePickerSchema,
                        uischema: $58bc10482e55498e$var$datePickerUischema,
                        data: datePickerForm,
                        onChange: ({ data: data })=>setDatePickerForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Nested Objects"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Objects with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'type: "object"'
                            }),
                            " and ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "properties"
                            }),
                            " auto-nest by default \u2014 each sub-property renders as its own control inside a Group card. Booleans become switches, strings become text inputs, etc. Use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'scope: "#"'
                            }),
                            " to render an entire schema from the root with a single Control. Opt out with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {nested: false}"
                            }),
                            " to render as a JSON textarea instead. Both modes validate sub-properties independently and share the same data \u2014 edits in either side are reflected in the other."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$SideBySide, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$nestedSchema,
                                uischema: $58bc10482e55498e$var$nestedAutoUischema,
                                data: nestedForm,
                                onChange: ({ data: data })=>setNestedForm(data)
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$nestedSchema,
                                uischema: $58bc10482e55498e$var$nestedJsonUischema,
                                data: nestedForm,
                                onChange: ({ data: data })=>setNestedForm(data)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Array of Objects"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Arrays where ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "items"
                            }),
                            " has ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'type: "object"'
                            }),
                            " with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "properties"
                            }),
                            " render as a list of cards \u2014 one per item. Each card contains a mini-form with the item's nested fields (text inputs, selects, switches, etc.). Items can be added (with defaults from schema) and removed via buttons. Each item validates independently. Use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'options: {itemTitle: "name"}'
                            }),
                            " to show an inner field as the card title (editable inline). The contacts array below has ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'required: ["name", "email"]'
                            }),
                            " and a pattern on email \u2014 try clearing a name or entering an invalid email."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$arraySchema,
                        uischema: $58bc10482e55498e$var$arrayUischema,
                        data: arrayForm,
                        onChange: ({ data: data })=>setArrayForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Dynamic Object"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Objects with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "additionalProperties"
                            }),
                            ' in the schema render as a list of editable cards \u2014 one per entry. New entries can be added via the "Add item" button, and each entry has a remove button. Set ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {allowPropertyRenaming: true}"
                            }),
                            " on the Control to make the object keys editable (click the card title to rename). Use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'options: {itemTitle: "title"}'
                            }),
                            " to show an inner field as the card title instead of the key. Use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {itemUISchema}"
                            }),
                            " to control the layout of each entry's fields, just like with arrays. Below: an object with dynamic sections \u2014 each entry shows the title field as the card header, keys are editable, and entries can be added/removed."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$dynamicObjectSchema,
                        uischema: $58bc10482e55498e$var$dynamicObjectUischema,
                        data: dynamicObjForm,
                        onChange: ({ data: data })=>setDynamicObjForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Edit Modes"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Cards (Groups, array items, dynamic object entries) support an ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "editMode"
                            }),
                            " option that controls how content is revealed. The default (no editMode) is always expanded with no toggle. Set ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "editMode: 'collapsible'"
                            }),
                            " for caret-toggle behavior (use ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "collapsed: true"
                            }),
                            " to start collapsed). Set ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "editMode: 'popover'"
                            }),
                            " for a hover popover,",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "'overlay'"
                            }),
                            " for a centered dialog, or ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "'drawer'"
                            }),
                            " for a side panel. When content is hidden, cards with validation errors show a red error count tag. The name field below is required but empty \u2014 notice the error tag on hidden modes."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$SideBySide, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$editModeSchema,
                                uischema: $58bc10482e55498e$var$editModeUischemaDefault,
                                data: editModeForm,
                                onChange: ({ data: data })=>setEditModeForm(data)
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$editModeSchema,
                                uischema: $58bc10482e55498e$var$editModeUischemaCollapsible,
                                data: editModeForm,
                                onChange: ({ data: data })=>setEditModeForm(data)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$SideBySide, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$editModeSchema,
                                uischema: $58bc10482e55498e$var$editModeUischemaPopover,
                                data: editModeForm,
                                onChange: ({ data: data })=>setEditModeForm(data)
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$editModeSchema,
                                uischema: $58bc10482e55498e$var$editModeUischemaOverlay,
                                data: editModeForm,
                                onChange: ({ data: data })=>setEditModeForm(data)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$SideBySide, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$editModeSchema,
                                uischema: $58bc10482e55498e$var$editModeUischemaDrawer,
                                data: editModeForm,
                                onChange: ({ data: data })=>setEditModeForm(data)
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($58bc10482e55498e$var$Description, {
                        style: {
                            marginTop: '1.5em',
                            marginBottom: 0
                        },
                        children: 'Below: collapsible mode on array items and groups. "API Endpoints" is expanded but its items start collapsed (the second endpoint has an empty URL \u2014 expand it to see the error). "Custom Headers" starts fully collapsed.'
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$collapsibleSchema,
                        uischema: $58bc10482e55498e$var$collapsibleUischema,
                        data: collapsibleForm,
                        onChange: ({ data: data })=>setCollapsibleForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Drag-and-Drop Reordering"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Arrays and dynamic objects support drag-and-drop reordering via drag handles. Grab the handle icon on the left of a card title to reorder items. Reordering is enabled by default \u2014 disable with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {reorderable: false}"
                            }),
                            ". Drag handles are hidden when the form is ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "readonly"
                            }),
                            " or the field is ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "disabled"
                            }),
                            ". Collapse state is preserved through reorder operations. Works with both vertical (default) and horizontal item layouts."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$SideBySide, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$dragDropSchema,
                                uischema: $58bc10482e55498e$var$dragDropVerticalUischema,
                                data: dragDropForm,
                                onChange: ({ data: data })=>setDragDropForm(data)
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$dragDropSchema,
                                uischema: $58bc10482e55498e$var$dragDropHorizontalUischema,
                                data: dragDropForm,
                                onChange: ({ data: data })=>setDragDropForm(data)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)("div", {
                        style: {
                            marginTop: '1em'
                        }
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$dragDropSchema,
                        uischema: $58bc10482e55498e$var$dragDropDynamicUischema,
                        data: dragDropForm,
                        onChange: ({ data: data })=>setDragDropForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Cascading Select"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Multi-level dependent selector for hierarchical data. Add ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {levels: [...]}"
                            }),
                            " to a Control whose schema is ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'type: "object"'
                            }),
                            ". Each level defines a ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "key"
                            }),
                            " (stored in the value object), a ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "label"
                            }),
                            " (panel header), and either fixed ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "items"
                            }),
                            " or dependent ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "itemsFor"
                            }),
                            " (keyed by ancestor level values). Levels with a ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "delimiter"
                            }),
                            " auto-group flat strings into an indented tree. Default mode is single-select (values are strings, changing a parent clears children). Add ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options: {multi: true}"
                            }),
                            " for multi-select (values are arrays, checkboxes, All/Clear buttons)."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$SideBySide, {
                        children: [
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$cascadingSingleSchema,
                                uischema: $58bc10482e55498e$var$cascadingSingleUischema,
                                data: cascadingSingle,
                                onChange: ({ data: data })=>setCascadingSingle(data)
                            }),
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                                schema: $58bc10482e55498e$var$cascadingMultiSchema,
                                uischema: $58bc10482e55498e$var$cascadingMultiUischema,
                                data: cascadingMulti,
                                onChange: ({ data: data })=>setCascadingMulti(data)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Validation Errors"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Errors are computed on every change and shown inline with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'intent="danger"'
                            }),
                            ". Add fields to ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "required"
                            }),
                            " for non-empty validation and ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "pattern"
                            }),
                            " for regex checks. Below: required text (empty), pattern mismatch (bad email), required select (no value), and required multi-select (empty array). Consumers receive errors as ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "[{instancePath, message, keyword}]"
                            }),
                            " in the ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "onChange"
                            }),
                            " callback."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$errorSchema,
                        uischema: $58bc10482e55498e$var$errorUischema,
                        data: errorForm,
                        onChange: ({ data: data })=>setErrorForm(data)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Read-Only Mode"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Pass ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "readonly={true}"
                            }),
                            " to disable the entire form. All fields become non-interactive. This is independent of per-field disabling via ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "readOnly"
                            }),
                            " in the schema or ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: 'rule.effect: "DISABLE"'
                            }),
                            " on individual controls."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $efb7d3097a0a7ab7$export$becd7412971443d4), {
                        schema: $58bc10482e55498e$var$readonlySchema,
                        uischema: $58bc10482e55498e$var$readonlyUischema,
                        data: $58bc10482e55498e$var$readonlyData,
                        readonly: true,
                        onChange: ()=>{}
                    })
                ]
            }),
            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Section, {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$746be9e3a3dfff1f), {
                        children: "Theming with styled-components"
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)($58bc10482e55498e$var$Description, {
                        children: [
                            "Wrap ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "SchemaForm"
                            }),
                            " with ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "styled(SchemaForm)"
                            }),
                            " and override CSS custom properties. Available: ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-vertical-gap"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-horizontal-gap"
                            }),
                            " (spacing),",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-group-padding"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-group-margin"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-group-background"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-group-shadow"
                            }),
                            " (group cards),",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-group-label-color"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-group-label-size"
                            }),
                            " (group headings),",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-label-color"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-label-size"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-label-weight"
                            }),
                            " (field labels),",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-border-radius"
                            }),
                            " (inputs + cards),",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-max-width"
                            }),
                            ", ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-width"
                            }),
                            " (form sizing),",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "--sf-text-align"
                            }),
                            " (input alignment). Per-control sizing is available via ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "options"
                            }),
                            ":",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "fill: true"
                            }),
                            " makes selects expand to full width (default: fit-content),",
                            ' ',
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "minWidth"
                            }),
                            " and ",
                            /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $64289e527bcd600c$export$52f0f02147b12c03), {
                                children: "maxWidth"
                            }),
                            " constrain any field's width."
                        ]
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($58bc10482e55498e$var$StyledSchemaForm, {
                        schema: $58bc10482e55498e$var$styledSchema,
                        uischema: $58bc10482e55498e$var$styledUischema,
                        data: styledForm,
                        onChange: ({ data: data })=>setStyledForm(data)
                    })
                ]
            })
        ]
    });
};


if (0, $a13d063d3fb3aa31$export$b6344303c18d5a5e) $c932a85603fa1501$export$2cd8252107eb640b({
    dsn: 'https://5337268db9fe477989daf78500f5707b@o135941.ingest.sentry.io/5338025'
});
console.log(`Running on ${(0, $a13d063d3fb3aa31$export$4625fcba3fc11d47)}`);
const $33364d247aaef018$var$App = ()=>/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $711b21ca0f0dd1b5$export$9b8f089fab3cf7ba), {
        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$9ba4e89fdfa1fc54), {
            children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $3c99a37f3fed1403$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$444b3ab0cb9aec40), {
                            to: "/orgs",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                        path: "/login",
                        element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db43518de4d3e4ff$export$f14c0e3f98d164c0), {})
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                        path: "/logout",
                        element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $db43518de4d3e4ff$export$ae5920452e7cb547), {})
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                        element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $711b21ca0f0dd1b5$export$f0f76eeab536c10d), {
                            login: "/login"
                        }),
                        children: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsxs)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                            element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $af6fbd639611b05f$export$19246bc72d40c4bc), {}),
                            children: [
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                                    path: "/orgs/*",
                                    element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $79684e8533829ba6$export$a410a7e73c6e2728), {})
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                                    path: "/locs/*",
                                    element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $c4ba356affd95277$export$945eb84e823d1310), {})
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                                    path: "/devs/*",
                                    element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b32bb254fb5f975e$export$ca557e36c5af9625), {})
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                                    path: "/recs/*",
                                    element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $b5ee80c3f7d9f5ea$export$24eb32919a2c61dc), {})
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                                    path: "/access/*",
                                    element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $97a7a4b127812727$export$b10e0f21eb59fd0b), {})
                                }),
                                /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                                    path: "/components",
                                    element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $58bc10482e55498e$export$7e1947839b9f42a4), {})
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $3c99a37f3fed1403$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)((0, $92e6067166fae914$export$3cb69218ff952ef8), {})
                    })
                ]
            })
        })
    });
(0, $2fc1460ebb889ad8$exports.createRoot)(document.getElementById('root')).render(/*#__PURE__*/ (0, $fc31e5e9fc16a880$exports.jsx)($33364d247aaef018$var$App, {}));


//# sourceMappingURL=repo.cf983bb7.js.map
